import type { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DayType: { input: any; output: any; }
  DocumentType: { input: any; output: any; }
  Time: { input: any; output: any; }
  bigint: { input: any; output: any; }
  date: { input: any; output: any; }
  geography: { input: any; output: any; }
  geometry: { input: any; output: any; }
  json: { input: any; output: any; }
  jsonb: { input: any; output: any; }
  name: { input: any; output: any; }
  numeric: { input: any; output: any; }
  point: { input: any; output: any; }
  time: { input: any; output: any; }
  timestamp: { input: any; output: any; }
  timestamptz: { input: any; output: any; }
  timetz: { input: any; output: any; }
  uuid: { input: any; output: any; }
  validation_workflow_status: { input: any; output: any; }
};

export type ActivePlanningPeriod = {
  __typename?: 'ActivePlanningPeriod';
  effective_from: Scalars['date']['output'];
  effective_until: Scalars['date']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
};

export type AddUserToOrganizationData = {
  __typename?: 'AddUserToOrganizationData';
  claims_updated: Scalars['Boolean']['output'];
  is_owner: Scalars['Boolean']['output'];
  organization_id: Scalars['String']['output'];
  organization_name?: Maybe<Scalars['String']['output']>;
  organization_user_id: Scalars['String']['output'];
  total_organizations: Scalars['Int']['output'];
  user_id: Scalars['String']['output'];
};

export type AddUserToOrganizationInput = {
  is_owner?: InputMaybe<Scalars['Boolean']['input']>;
  organization_id: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};

export type AddUserToOrganizationOutput = {
  __typename?: 'AddUserToOrganizationOutput';
  code: Scalars['String']['output'];
  data?: Maybe<AddUserToOrganizationData>;
  error?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type AddUserToPartnerData = {
  __typename?: 'AddUserToPartnerData';
  claims_updated: Scalars['Boolean']['output'];
  partner_id: Scalars['String']['output'];
  partner_name?: Maybe<Scalars['String']['output']>;
  partner_user_id: Scalars['String']['output'];
  role: Scalars['String']['output'];
  user_id: Scalars['String']['output'];
};

export type AddUserToPartnerInput = {
  partner_id: Scalars['String']['input'];
  role: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};

export type AddUserToPartnerOutput = {
  __typename?: 'AddUserToPartnerOutput';
  code: Scalars['String']['output'];
  data?: Maybe<AddUserToPartnerData>;
  error?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type ApproveDailyPlanInput = {
  slots: Array<SlotApprovalInput>;
  target_date: Scalars['date']['input'];
};

export type ApproveDailyPlanOutput = {
  __typename?: 'ApproveDailyPlanOutput';
  order_ids: Array<Scalars['uuid']['output']>;
  orders_created: Scalars['Int']['output'];
  shift_schedule_ids: Array<Scalars['uuid']['output']>;
  shifts_created: Scalars['Int']['output'];
  slots_skipped: Scalars['Int']['output'];
  slots_skipped_inactive_address: Scalars['Int']['output'];
  slots_skipped_inactive_org: Scalars['Int']['output'];
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type CancelCustomerOrderInput = {
  cancellation_reason_id?: InputMaybe<Scalars['uuid']['input']>;
  orderId?: InputMaybe<Scalars['uuid']['input']>;
};

export type CancelCustomerOrderOutput = {
  __typename?: 'CancelCustomerOrderOutput';
  orderId?: Maybe<Scalars['uuid']['output']>;
  orderStatus: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  updateStatus?: Maybe<Scalars['Boolean']['output']>;
};

export type CancelOrderInput = {
  order_id: Scalars['uuid']['input'];
  reason_id: Scalars['uuid']['input'];
  reason_text?: InputMaybe<Scalars['String']['input']>;
};

export type CancelOrderOutput = {
  __typename?: 'CancelOrderOutput';
  message?: Maybe<Scalars['String']['output']>;
  order_id?: Maybe<Scalars['uuid']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CheckDeliveryNotesInvoicedInput = {
  delivery_note_erp_codes: Array<Scalars['String']['input']>;
};

export type CheckDeliveryNotesInvoicedOutput = {
  __typename?: 'CheckDeliveryNotesInvoicedOutput';
  code?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Scalars['jsonb']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type ConflictingSlot = {
  __typename?: 'ConflictingSlot';
  address_name?: Maybe<Scalars['String']['output']>;
  days_of_week: Array<Scalars['Int']['output']>;
  id: Scalars['uuid']['output'];
  is_overnight: Scalars['Boolean']['output'];
  organization_name?: Maybe<Scalars['String']['output']>;
  slot_end_time: Scalars['time']['output'];
  slot_start_time: Scalars['time']['output'];
};

export type CreateInvoicedItemForAssetInput = {
  customer_asset_id: Scalars['uuid']['input'];
  session_id?: InputMaybe<Scalars['String']['input']>;
  task_id: Scalars['uuid']['input'];
};

export type CreateInvoicedItemForAssetOutput = {
  __typename?: 'CreateInvoicedItemForAssetOutput';
  code?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Scalars['jsonb']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CreateOrUpdateUserFirebaseData = {
  __typename?: 'CreateOrUpdateUserFirebaseData';
  database_user?: Maybe<DatabaseUser>;
  firebase_user?: Maybe<FirebaseUser>;
};

export type CreateOrUpdateUserFirebaseInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  first_name: Scalars['String']['input'];
  last_name?: InputMaybe<Scalars['String']['input']>;
  middle_name?: InputMaybe<Scalars['String']['input']>;
  phone_number: Scalars['String']['input'];
};

export type CreateOrUpdateUserFirebaseResponse = {
  __typename?: 'CreateOrUpdateUserFirebaseResponse';
  code: Scalars['String']['output'];
  data?: Maybe<CreateOrUpdateUserFirebaseData>;
  error?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type CreatePaymentLinkInput = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  orderId?: InputMaybe<Scalars['uuid']['input']>;
};

export type CreatePaymentLinkOutput = {
  __typename?: 'CreatePaymentLinkOutput';
  client_secret: Scalars['String']['output'];
  orderId?: Maybe<Scalars['uuid']['output']>;
  payment_id?: Maybe<Scalars['uuid']['output']>;
};

export type CreateTaskFromFranchiseOutput = {
  __typename?: 'CreateTaskFromFranchiseOutput';
  category: Scalars['String']['output'];
  customer_order_id: Scalars['uuid']['output'];
  driver_vehicle_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  partner_address_id: Scalars['uuid']['output'];
  shipping_address_id: Scalars['uuid']['output'];
  state: Scalars['String']['output'];
};

export type CreateTaskFromFranchiseTaskInsertInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
  driver_vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  job_id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_address_id?: InputMaybe<Scalars['uuid']['input']>;
  shipping_address_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserInput = {
  bd_name?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  middle_name?: InputMaybe<Scalars['String']['input']>;
  org_type?: InputMaybe<Scalars['String']['input']>;
  organization_name?: InputMaybe<Scalars['String']['input']>;
  partner_id?: InputMaybe<Scalars['String']['input']>;
  phone_number: Scalars['String']['input'];
  role: Scalars['String']['input'];
  trade_license?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<InputMaybe<UserInput>>>;
};

export type CreateUserOutput = {
  __typename?: 'CreateUserOutput';
  data?: Maybe<Scalars['jsonb']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CreateUserRefactoredInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  first_name: Scalars['String']['input'];
  last_name?: InputMaybe<Scalars['String']['input']>;
  middle_name?: InputMaybe<Scalars['String']['input']>;
  phone_number: Scalars['String']['input'];
};

export type CreateUserRefactoredOutput = {
  __typename?: 'CreateUserRefactoredOutput';
  code: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  user?: Maybe<CreatedUser>;
};

export type CreatedUser = {
  __typename?: 'CreatedUser';
  email?: Maybe<Scalars['String']['output']>;
  firebase_uid: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  id: Scalars['String']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  middle_name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['String']['output']>;
  phone_number: Scalars['String']['output'];
};

export type CustomerAssetDataInput = {
  endDate: Scalars['timestamp']['input'];
  startDate: Scalars['timestamp']['input'];
};

export type CustomerAssetDataOutput = {
  __typename?: 'CustomerAssetDataOutput';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type CustomerOrderDataInput = {
  endDate: Scalars['timestamp']['input'];
  startDate: Scalars['timestamp']['input'];
};

export type CustomerOrderDataOutput = {
  __typename?: 'CustomerOrderDataOutput';
  average_price?: Maybe<Scalars['numeric']['output']>;
  total_amount?: Maybe<Scalars['numeric']['output']>;
  total_asset_filled?: Maybe<Scalars['numeric']['output']>;
  total_asset_refilled?: Maybe<Scalars['numeric']['output']>;
  total_order?: Maybe<Scalars['numeric']['output']>;
  total_qty?: Maybe<Scalars['numeric']['output']>;
};

export type CustomerOrderInput = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  orderId?: InputMaybe<Scalars['uuid']['input']>;
};

export type CustomerOrderOutput = {
  __typename?: 'CustomerOrderOutput';
  client_secret: Scalars['String']['output'];
  orderId?: Maybe<Scalars['uuid']['output']>;
  payment_id?: Maybe<Scalars['uuid']['output']>;
};

export type DatabaseUser = {
  __typename?: 'DatabaseUser';
  created_at?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  google_firebase_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
  middle_name?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to compare columns of type "Date". All fields are combined with logical 'AND'. */
export type Date_BigQuery_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Date']['input']>;
  _gt?: InputMaybe<Scalars['Date']['input']>;
  _gte?: InputMaybe<Scalars['Date']['input']>;
  _in?: InputMaybe<Array<Scalars['Date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Date']['input']>;
  _lte?: InputMaybe<Scalars['Date']['input']>;
  _neq?: InputMaybe<Scalars['Date']['input']>;
  _nin?: InputMaybe<Array<Scalars['Date']['input']>>;
};

/** Boolean expression to compare columns of type "DayType". All fields are combined with logical 'AND'. */
export type DayType_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['DayType']['input']>;
  _gt?: InputMaybe<Scalars['DayType']['input']>;
  _gte?: InputMaybe<Scalars['DayType']['input']>;
  _in?: InputMaybe<Array<Scalars['DayType']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['DayType']['input']>;
  _lte?: InputMaybe<Scalars['DayType']['input']>;
  _neq?: InputMaybe<Scalars['DayType']['input']>;
  _nin?: InputMaybe<Array<Scalars['DayType']['input']>>;
};

export type DeriveSlotsForDateInput = {
  partner_id: Scalars['uuid']['input'];
  target_date: Scalars['date']['input'];
};

export type DeriveSlotsForDateOutput = {
  __typename?: 'DeriveSlotsForDateOutput';
  active_periods: Array<ActivePlanningPeriod>;
  day_of_week: Scalars['Int']['output'];
  slots: Array<DerivedSlot>;
  total_slots: Scalars['Int']['output'];
  unassigned_slots: Scalars['Int']['output'];
  vehicles_assigned: Scalars['Int']['output'];
};

export type DerivedSlot = {
  __typename?: 'DerivedSlot';
  address_line1?: Maybe<Scalars['String']['output']>;
  address_line2?: Maybe<Scalars['String']['output']>;
  driver_name?: Maybe<Scalars['String']['output']>;
  driver_vehicle_id?: Maybe<Scalars['uuid']['output']>;
  is_overnight: Scalars['Boolean']['output'];
  is_temporary: Scalars['Boolean']['output'];
  master_slot_id?: Maybe<Scalars['uuid']['output']>;
  organization_address_id: Scalars['uuid']['output'];
  organization_name?: Maybe<Scalars['String']['output']>;
  overrides_slot_id?: Maybe<Scalars['uuid']['output']>;
  partner_localities_id?: Maybe<Scalars['uuid']['output']>;
  planning_period_from?: Maybe<Scalars['date']['output']>;
  planning_period_name?: Maybe<Scalars['String']['output']>;
  planning_period_until?: Maybe<Scalars['date']['output']>;
  product_name?: Maybe<Scalars['String']['output']>;
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
  slot_end_time: Scalars['time']['output'];
  slot_start_time: Scalars['time']['output'];
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
  vehicle_name?: Maybe<Scalars['String']['output']>;
};

export type DeviceIotProcessorInput = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
  deviceId: Scalars['numeric']['input'];
  ignitionStatus?: InputMaybe<Scalars['numeric']['input']>;
  stampTime?: InputMaybe<Scalars['numeric']['input']>;
  traceId?: InputMaybe<Scalars['String']['input']>;
};

export type DeviceIotProcessorOutput = {
  __typename?: 'DeviceIotProcessorOutput';
  data?: Maybe<Scalars['jsonb']['output']>;
};

/** Boolean expression to compare columns of type "DocumentType". All fields are combined with logical 'AND'. */
export type DocumentType_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['DocumentType']['input']>;
  _gt?: InputMaybe<Scalars['DocumentType']['input']>;
  _gte?: InputMaybe<Scalars['DocumentType']['input']>;
  _in?: InputMaybe<Array<Scalars['DocumentType']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['DocumentType']['input']>;
  _lte?: InputMaybe<Scalars['DocumentType']['input']>;
  _neq?: InputMaybe<Scalars['DocumentType']['input']>;
  _nin?: InputMaybe<Array<Scalars['DocumentType']['input']>>;
};

export type FetchCustomerOrderItemSlotsByIdInput = {
  customer_order_item_id: Scalars['uuid']['input'];
};

export type FetchCustomerOrderItemSlotsByIdOutput = {
  __typename?: 'FetchCustomerOrderItemSlotsByIdOutput';
  day_date?: Maybe<Scalars['date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disclaimer?: Maybe<Scalars['String']['output']>;
  end_time?: Maybe<Scalars['timetz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  start_time?: Maybe<Scalars['timetz']['output']>;
};

export type FileInput = {
  fileUrl: Scalars['String']['input'];
};

export type FileOutput = {
  __typename?: 'FileOutput';
  url: Scalars['String']['output'];
};

export type FirebaseUser = {
  __typename?: 'FirebaseUser';
  disabled?: Maybe<Scalars['Boolean']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailVerified?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};

/** Boolean expression to compare columns of type "Float". All fields are combined with logical 'AND'. */
export type Float_BigQuery_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Float']['input']>;
  _gt?: InputMaybe<Scalars['Float']['input']>;
  _gte?: InputMaybe<Scalars['Float']['input']>;
  _in?: InputMaybe<Array<Scalars['Float']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Float']['input']>;
  _lte?: InputMaybe<Scalars['Float']['input']>;
  _neq?: InputMaybe<Scalars['Float']['input']>;
  _nin?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type GetInvoiceInfoInput = {
  end_date: Scalars['timestamptz']['input'];
  organization_id: Scalars['uuid']['input'];
  start_date: Scalars['timestamptz']['input'];
};

export type GetInvoiceInfoResponse = {
  __typename?: 'GetInvoiceInfoResponse';
  code: Scalars['String']['output'];
  data?: Maybe<Scalars['jsonb']['output']>;
  message: Scalars['String']['output'];
};

export type GetOrgLastSalesInvoiceDateInput = {
  organization_id: Scalars['uuid']['input'];
};

export type GetOrgLastSalesInvoiceDateOutput = {
  __typename?: 'GetOrgLastSalesInvoiceDateOutput';
  code?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Scalars['jsonb']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_BigQuery_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IsDeliveryNoteInvoicedInput = {
  invoiced_item_id: Scalars['uuid']['input'];
};

export type IsDeliveryNoteInvoicedOutput = {
  __typename?: 'IsDeliveryNoteInvoicedOutput';
  invoiced: Scalars['Boolean']['output'];
  per_billed?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type PayThroughWalletInput = {
  amount: Scalars['numeric']['input'];
  order_id: Scalars['uuid']['input'];
  wallet_id: Scalars['uuid']['input'];
};

export type PayThroughWalletOutput = {
  __typename?: 'PayThroughWalletOutput';
  order_id: Scalars['uuid']['output'];
  payment_id: Scalars['uuid']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type RectifyWalletDriftInput = {
  branch: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  target_id: Scalars['uuid']['input'];
};

export type RectifyWalletDriftOutput = {
  __typename?: 'RectifyWalletDriftOutput';
  batch_id: Scalars['uuid']['output'];
  new_wallet_balance: Scalars['numeric']['output'];
  rectified_ledger_id?: Maybe<Scalars['uuid']['output']>;
};

export type RescheduleTaskInput = {
  driver_vehicle_id: Scalars['uuid']['input'];
  task_id: Scalars['uuid']['input'];
};

export type RescheduleTaskOutput = {
  __typename?: 'RescheduleTaskOutput';
  status?: Maybe<Scalars['String']['output']>;
  task_id: Scalars['uuid']['output'];
};

export type RetagDeliveryNoteInput = {
  invoiced_item_id: Scalars['uuid']['input'];
};

export type RetagDeliveryNoteOutput = {
  __typename?: 'RetagDeliveryNoteOutput';
  code?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Scalars['jsonb']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type SendInvoiceToEtInput = {
  account: Scalars['String']['input'];
  end_date: Scalars['String']['input'];
  invoice_VAT_amount: Scalars['Float']['input'];
  invoice_amount_excl_VAT: Scalars['Float']['input'];
  invoice_date: Scalars['String']['input'];
  invoice_end_date: Scalars['timestamptz']['input'];
  invoice_number: Scalars['String']['input'];
  invoice_start_date: Scalars['timestamptz']['input'];
  invoice_total_due_amount: Scalars['Float']['input'];
  start_date: Scalars['String']['input'];
  supplier: Scalars['String']['input'];
  total_amount: Scalars['Float']['input'];
  total_quantity: Scalars['Float']['input'];
  total_transaction?: InputMaybe<Scalars['Int']['input']>;
  unit_price_inclusive_VAT?: InputMaybe<Scalars['Float']['input']>;
};

export type SendInvoiceToEtResponse = {
  __typename?: 'SendInvoiceToEtResponse';
  code: Scalars['Int']['output'];
  data?: Maybe<Scalars['jsonb']['output']>;
  message: Scalars['String']['output'];
};

export type SendTransactionLogsToEtResponse = {
  __typename?: 'SendTransactionLogsToEtResponse';
  code: Scalars['Int']['output'];
  data?: Maybe<Scalars['jsonb']['output']>;
  message: Scalars['String']['output'];
};

export type SendTransactionLogsToEtResponseV1 = {
  __typename?: 'SendTransactionLogsToEtResponseV1';
  code: Scalars['Int']['output'];
  data?: Maybe<Scalars['jsonb']['output']>;
  message: Scalars['String']['output'];
};

export type ShiftAddressDepartmentInput = {
  effective_from?: InputMaybe<Scalars['timestamptz']['input']>;
  organization_address_id: Scalars['uuid']['input'];
  subsidiary_id: Scalars['uuid']['input'];
};

export type ShiftAddressDepartmentOutput = {
  __typename?: 'ShiftAddressDepartmentOutput';
  code?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Scalars['jsonb']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type ShiftAssetDepartmentInput = {
  asset_id: Scalars['uuid']['input'];
  effective_from?: InputMaybe<Scalars['timestamptz']['input']>;
  subsidiary_id: Scalars['uuid']['input'];
};

export type ShiftAssetDepartmentOutput = {
  __typename?: 'ShiftAssetDepartmentOutput';
  code?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Scalars['jsonb']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type SlotApprovalInput = {
  is_overnight?: InputMaybe<Scalars['Boolean']['input']>;
  is_skipped: Scalars['Boolean']['input'];
  master_slot_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_address_id?: InputMaybe<Scalars['uuid']['input']>;
  override_reason?: InputMaybe<Scalars['String']['input']>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  qty?: InputMaybe<Scalars['numeric']['input']>;
  slot_end_time?: InputMaybe<Scalars['time']['input']>;
  slot_start_time?: InputMaybe<Scalars['time']['input']>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "SmartRefueler.dispencerLocation" */
export type SmartRefueler_DispencerLocation = {
  __typename?: 'SmartRefueler_dispencerLocation';
  course?: Maybe<Scalars['Float']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  hdop?: Maybe<Scalars['Int']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locationDate?: Maybe<Scalars['Date']['output']>;
  locationTime?: Maybe<Scalars['Time']['output']>;
  refId?: Maybe<Scalars['Int']['output']>;
  satellites?: Maybe<Scalars['String']['output']>;
  speed?: Maybe<Scalars['Float']['output']>;
};

/** aggregated selection of "SmartRefueler.dispencerLocation" */
export type SmartRefueler_DispencerLocation_Aggregate = {
  __typename?: 'SmartRefueler_dispencerLocation_aggregate';
  aggregate?: Maybe<SmartRefueler_DispencerLocation_Aggregate_Fields>;
  nodes: Array<SmartRefueler_DispencerLocation>;
};

/** aggregate fields of "SmartRefueler.dispencerLocation" */
export type SmartRefueler_DispencerLocation_Aggregate_Fields = {
  __typename?: 'SmartRefueler_dispencerLocation_aggregate_fields';
  avg?: Maybe<SmartRefueler_DispencerLocation_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<SmartRefueler_DispencerLocation_Max_Fields>;
  min?: Maybe<SmartRefueler_DispencerLocation_Min_Fields>;
  stddev?: Maybe<SmartRefueler_DispencerLocation_Stddev_Fields>;
  stddev_pop?: Maybe<SmartRefueler_DispencerLocation_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<SmartRefueler_DispencerLocation_Stddev_Samp_Fields>;
  sum?: Maybe<SmartRefueler_DispencerLocation_Sum_Fields>;
  var_pop?: Maybe<SmartRefueler_DispencerLocation_Var_Pop_Fields>;
  var_samp?: Maybe<SmartRefueler_DispencerLocation_Var_Samp_Fields>;
  variance?: Maybe<SmartRefueler_DispencerLocation_Variance_Fields>;
};


/** aggregate fields of "SmartRefueler.dispencerLocation" */
export type SmartRefueler_DispencerLocation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<SmartRefueler_DispencerLocation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type SmartRefueler_DispencerLocation_Avg_Fields = {
  __typename?: 'SmartRefueler_dispencerLocation_avg_fields';
  course?: Maybe<Scalars['Float']['output']>;
  hdop?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  refId?: Maybe<Scalars['Float']['output']>;
  speed?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "SmartRefueler.dispencerLocation". All fields are combined with a logical 'AND'. */
export type SmartRefueler_DispencerLocation_Bool_Exp = {
  _and?: InputMaybe<Array<SmartRefueler_DispencerLocation_Bool_Exp>>;
  _not?: InputMaybe<SmartRefueler_DispencerLocation_Bool_Exp>;
  _or?: InputMaybe<Array<SmartRefueler_DispencerLocation_Bool_Exp>>;
  course?: InputMaybe<Float_BigQuery_Comparison_Exp>;
  deviceId?: InputMaybe<String_BigQuery_Comparison_Exp>;
  hdop?: InputMaybe<Int_BigQuery_Comparison_Exp>;
  lat?: InputMaybe<Float_BigQuery_Comparison_Exp>;
  lng?: InputMaybe<Float_BigQuery_Comparison_Exp>;
  locationDate?: InputMaybe<Date_BigQuery_Comparison_Exp>;
  locationTime?: InputMaybe<Time_BigQuery_Comparison_Exp>;
  refId?: InputMaybe<Int_BigQuery_Comparison_Exp>;
  satellites?: InputMaybe<String_BigQuery_Comparison_Exp>;
  speed?: InputMaybe<Float_BigQuery_Comparison_Exp>;
};

/** aggregate max on columns */
export type SmartRefueler_DispencerLocation_Max_Fields = {
  __typename?: 'SmartRefueler_dispencerLocation_max_fields';
  course?: Maybe<Scalars['Float']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  hdop?: Maybe<Scalars['Int']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locationDate?: Maybe<Scalars['Date']['output']>;
  locationTime?: Maybe<Scalars['Time']['output']>;
  refId?: Maybe<Scalars['Int']['output']>;
  satellites?: Maybe<Scalars['String']['output']>;
  speed?: Maybe<Scalars['Float']['output']>;
};

/** aggregate min on columns */
export type SmartRefueler_DispencerLocation_Min_Fields = {
  __typename?: 'SmartRefueler_dispencerLocation_min_fields';
  course?: Maybe<Scalars['Float']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  hdop?: Maybe<Scalars['Int']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locationDate?: Maybe<Scalars['Date']['output']>;
  locationTime?: Maybe<Scalars['Time']['output']>;
  refId?: Maybe<Scalars['Int']['output']>;
  satellites?: Maybe<Scalars['String']['output']>;
  speed?: Maybe<Scalars['Float']['output']>;
};

/** Ordering options when selecting data from "SmartRefueler.dispencerLocation". */
export type SmartRefueler_DispencerLocation_Order_By = {
  course?: InputMaybe<Order_By>;
  deviceId?: InputMaybe<Order_By>;
  hdop?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locationDate?: InputMaybe<Order_By>;
  locationTime?: InputMaybe<Order_By>;
  refId?: InputMaybe<Order_By>;
  satellites?: InputMaybe<Order_By>;
  speed?: InputMaybe<Order_By>;
};

/** select columns of table "SmartRefueler.dispencerLocation" */
export enum SmartRefueler_DispencerLocation_Select_Column {
  /** column name */
  Course = 'course',
  /** column name */
  DeviceId = 'deviceId',
  /** column name */
  Hdop = 'hdop',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  LocationDate = 'locationDate',
  /** column name */
  LocationTime = 'locationTime',
  /** column name */
  RefId = 'refId',
  /** column name */
  Satellites = 'satellites',
  /** column name */
  Speed = 'speed'
}

/** aggregate stddev on columns */
export type SmartRefueler_DispencerLocation_Stddev_Fields = {
  __typename?: 'SmartRefueler_dispencerLocation_stddev_fields';
  course?: Maybe<Scalars['Float']['output']>;
  hdop?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  refId?: Maybe<Scalars['Float']['output']>;
  speed?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type SmartRefueler_DispencerLocation_Stddev_Pop_Fields = {
  __typename?: 'SmartRefueler_dispencerLocation_stddev_pop_fields';
  course?: Maybe<Scalars['Float']['output']>;
  hdop?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  refId?: Maybe<Scalars['Float']['output']>;
  speed?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type SmartRefueler_DispencerLocation_Stddev_Samp_Fields = {
  __typename?: 'SmartRefueler_dispencerLocation_stddev_samp_fields';
  course?: Maybe<Scalars['Float']['output']>;
  hdop?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  refId?: Maybe<Scalars['Float']['output']>;
  speed?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type SmartRefueler_DispencerLocation_Sum_Fields = {
  __typename?: 'SmartRefueler_dispencerLocation_sum_fields';
  course?: Maybe<Scalars['Float']['output']>;
  hdop?: Maybe<Scalars['Int']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  refId?: Maybe<Scalars['Int']['output']>;
  speed?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type SmartRefueler_DispencerLocation_Var_Pop_Fields = {
  __typename?: 'SmartRefueler_dispencerLocation_var_pop_fields';
  course?: Maybe<Scalars['Float']['output']>;
  hdop?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  refId?: Maybe<Scalars['Float']['output']>;
  speed?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type SmartRefueler_DispencerLocation_Var_Samp_Fields = {
  __typename?: 'SmartRefueler_dispencerLocation_var_samp_fields';
  course?: Maybe<Scalars['Float']['output']>;
  hdop?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  refId?: Maybe<Scalars['Float']['output']>;
  speed?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type SmartRefueler_DispencerLocation_Variance_Fields = {
  __typename?: 'SmartRefueler_dispencerLocation_variance_fields';
  course?: Maybe<Scalars['Float']['output']>;
  hdop?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  refId?: Maybe<Scalars['Float']['output']>;
  speed?: Maybe<Scalars['Float']['output']>;
};

export type StorageInput = {
  bucketName: Scalars['String']['input'];
  contentType?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
};

export type StorageOutput = {
  __typename?: 'StorageOutput';
  contentType?: Maybe<Scalars['String']['output']>;
  signedUrl?: Maybe<Scalars['String']['output']>;
  storeUrl?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_BigQuery_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['String']['input']>>;
  _eq?: InputMaybe<Array<Scalars['String']['input']>>;
  _gt?: InputMaybe<Array<Scalars['String']['input']>>;
  _gte?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['String']['input']>>;
  _lte?: InputMaybe<Array<Scalars['String']['input']>>;
  _neq?: InputMaybe<Array<Scalars['String']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to compare columns of type "Time". All fields are combined with logical 'AND'. */
export type Time_BigQuery_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Time']['input']>;
  _gt?: InputMaybe<Scalars['Time']['input']>;
  _gte?: InputMaybe<Scalars['Time']['input']>;
  _in?: InputMaybe<Array<Scalars['Time']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Time']['input']>;
  _lte?: InputMaybe<Scalars['Time']['input']>;
  _neq?: InputMaybe<Scalars['Time']['input']>;
  _nin?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type ToggleOrganizationActiveInput = {
  is_active: Scalars['Boolean']['input'];
  organization_id: Scalars['String']['input'];
  reason_id: Scalars['String']['input'];
};

export type ToggleOrganizationActiveOutput = {
  __typename?: 'ToggleOrganizationActiveOutput';
  code: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type ToggleUserStatusInput = {
  is_active: Scalars['Boolean']['input'];
  reason: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};

export type ToggleUserStatusOutput = {
  __typename?: 'ToggleUserStatusOutput';
  code: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type UpdateCustomerAssetBasedOnOrderCodeInput = {
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

export type UpdateCustomerAssetBasedOnOrderCodeOutput = {
  __typename?: 'UpdateCustomerAssetBasedOnOrderCodeOutput';
  response: Scalars['String']['output'];
};

export type UpdateDeliveryNoteDepartmentInput = {
  department: Scalars['String']['input'];
  invoiced_item_id: Scalars['uuid']['input'];
};

export type UpdateDeliveryNoteDepartmentOutput = {
  __typename?: 'UpdateDeliveryNoteDepartmentOutput';
  code?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Scalars['jsonb']['output']>;
  message: Scalars['String']['output'];
};

export type UpdateSubsidiaryInput = {
  organization_user_id: Scalars['uuid']['input'];
};

export type UpdateSubsidiaryOutput = {
  __typename?: 'UpdateSubsidiaryOutput';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['jsonb']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type UserDetailsOutput = {
  __typename?: 'UserDetailsOutput';
  delivery_otp?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  middle_name?: Maybe<Scalars['String']['output']>;
  pan_number?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  profile_pic?: Maybe<Scalars['String']['output']>;
  referral_code?: Maybe<Scalars['String']['output']>;
};

export type UserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  middle_name?: InputMaybe<Scalars['String']['input']>;
  phone_number: Scalars['String']['input'];
};

export type ValidateSlotOverlapInput = {
  days_of_week: Array<Scalars['Int']['input']>;
  exclude_slot_id?: InputMaybe<Scalars['uuid']['input']>;
  is_overnight?: InputMaybe<Scalars['Boolean']['input']>;
  partner_id: Scalars['uuid']['input'];
  /**
   * The planning card the proposed slot belongs to, when overriding. Without it
   * every slot on the vehicle is compared regardless of when it runs, so a Summer
   * override collides with a Winter one that never coexists with it. With it, only
   * slots whose own date range intersects the card window are considered, and
   * slots freed by being skipped or shadowed across the whole window are ignored.
   * Omit for a permanent slot, which runs indefinitely.
   */
  planning_period_id?: InputMaybe<Scalars['uuid']['input']>;
  slot_end_time: Scalars['time']['input'];
  slot_start_time: Scalars['time']['input'];
  vehicle_id: Scalars['uuid']['input'];
};

export type ValidateSlotOverlapOutput = {
  __typename?: 'ValidateSlotOverlapOutput';
  conflicting_slots: Array<ConflictingSlot>;
  has_overlap: Scalars['Boolean']['output'];
};

export type VerifyOrderOtpInput = {
  order_id: Scalars['uuid']['input'];
  otp: Scalars['numeric']['input'];
};

export type VerifyOrderOtpOutput = {
  __typename?: 'VerifyOrderOtpOutput';
  isVerified: Scalars['Boolean']['output'];
};

export type WalletStatementLineItem = {
  __typename?: 'WalletStatementLineItem';
  approved_by?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  credit_amount?: Maybe<Scalars['numeric']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  debit_amount?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['uuid']['output'];
  line_item_type?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  posting_date?: Maybe<Scalars['String']['output']>;
  reference_id?: Maybe<Scalars['uuid']['output']>;
  reference_type?: Maybe<Scalars['String']['output']>;
  running_balance?: Maybe<Scalars['numeric']['output']>;
};

export type WalletStatementPeriod = {
  __typename?: 'WalletStatementPeriod';
  end_date: Scalars['String']['output'];
  start_date: Scalars['String']['output'];
};

export type AcceptCustomerOrderInput = {
  order_id: Scalars['uuid']['input'];
};

export type AcceptCustomerOrderOutput = {
  __typename?: 'acceptCustomerOrderOutput';
  item_state?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  order_id?: Maybe<Scalars['uuid']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AddMissingCustomerOrderCustomerAssetInput = {
  customer_order_id: Scalars['uuid']['input'];
};

export type AddMissingCustomerOrderCustomerAssetOutput = {
  __typename?: 'addMissingCustomerOrderCustomerAssetOutput';
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

/** columns and relationships of "address_subsidiary" */
export type Address_Subsidiary = {
  __typename?: 'address_subsidiary';
  created_at: Scalars['timestamp']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  is_superseded: Scalars['Boolean']['output'];
  last_modified: Scalars['timestamp']['output'];
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  organization_address: Organization_Address;
  organization_address_id: Scalars['uuid']['output'];
  /** An object relationship */
  subsidiary: Subsidiary;
  subsidiary_id: Scalars['uuid']['output'];
  valid_from: Scalars['timestamptz']['output'];
  valid_to?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "address_subsidiary" */
export type Address_Subsidiary_Aggregate = {
  __typename?: 'address_subsidiary_aggregate';
  aggregate?: Maybe<Address_Subsidiary_Aggregate_Fields>;
  nodes: Array<Address_Subsidiary>;
};

export type Address_Subsidiary_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Address_Subsidiary_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Address_Subsidiary_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Address_Subsidiary_Aggregate_Bool_Exp_Count>;
};

export type Address_Subsidiary_Aggregate_Bool_Exp_Bool_And = {
  arguments: Address_Subsidiary_Select_Column_Address_Subsidiary_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Address_Subsidiary_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Address_Subsidiary_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Address_Subsidiary_Select_Column_Address_Subsidiary_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Address_Subsidiary_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Address_Subsidiary_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Address_Subsidiary_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Address_Subsidiary_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "address_subsidiary" */
export type Address_Subsidiary_Aggregate_Fields = {
  __typename?: 'address_subsidiary_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Address_Subsidiary_Max_Fields>;
  min?: Maybe<Address_Subsidiary_Min_Fields>;
};


/** aggregate fields of "address_subsidiary" */
export type Address_Subsidiary_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Address_Subsidiary_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "address_subsidiary" */
export type Address_Subsidiary_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Address_Subsidiary_Max_Order_By>;
  min?: InputMaybe<Address_Subsidiary_Min_Order_By>;
};

/** input type for inserting array relation for remote table "address_subsidiary" */
export type Address_Subsidiary_Arr_Rel_Insert_Input = {
  data: Array<Address_Subsidiary_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Address_Subsidiary_On_Conflict>;
};

/** columns and relationships of "address_subsidiary_audit_logs" */
export type Address_Subsidiary_Audit_Logs = {
  __typename?: 'address_subsidiary_audit_logs';
  action: Audit_Log_Action_Enum;
  /** An object relationship */
  audit_log_action: Audit_Log_Action;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  is_superseded: Scalars['Boolean']['output'];
  last_modified: Scalars['timestamptz']['output'];
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  organization_address: Organization_Address;
  organization_address_id: Scalars['uuid']['output'];
  /** An object relationship */
  subsidiary: Subsidiary;
  subsidiary_id: Scalars['uuid']['output'];
};

/** aggregated selection of "address_subsidiary_audit_logs" */
export type Address_Subsidiary_Audit_Logs_Aggregate = {
  __typename?: 'address_subsidiary_audit_logs_aggregate';
  aggregate?: Maybe<Address_Subsidiary_Audit_Logs_Aggregate_Fields>;
  nodes: Array<Address_Subsidiary_Audit_Logs>;
};

export type Address_Subsidiary_Audit_Logs_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Address_Subsidiary_Audit_Logs_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Address_Subsidiary_Audit_Logs_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Address_Subsidiary_Audit_Logs_Aggregate_Bool_Exp_Count>;
};

export type Address_Subsidiary_Audit_Logs_Aggregate_Bool_Exp_Bool_And = {
  arguments: Address_Subsidiary_Audit_Logs_Select_Column_Address_Subsidiary_Audit_Logs_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Address_Subsidiary_Audit_Logs_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Address_Subsidiary_Audit_Logs_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Address_Subsidiary_Audit_Logs_Select_Column_Address_Subsidiary_Audit_Logs_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Address_Subsidiary_Audit_Logs_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Address_Subsidiary_Audit_Logs_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Address_Subsidiary_Audit_Logs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Address_Subsidiary_Audit_Logs_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "address_subsidiary_audit_logs" */
export type Address_Subsidiary_Audit_Logs_Aggregate_Fields = {
  __typename?: 'address_subsidiary_audit_logs_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Address_Subsidiary_Audit_Logs_Max_Fields>;
  min?: Maybe<Address_Subsidiary_Audit_Logs_Min_Fields>;
};


/** aggregate fields of "address_subsidiary_audit_logs" */
export type Address_Subsidiary_Audit_Logs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Address_Subsidiary_Audit_Logs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "address_subsidiary_audit_logs" */
export type Address_Subsidiary_Audit_Logs_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Address_Subsidiary_Audit_Logs_Max_Order_By>;
  min?: InputMaybe<Address_Subsidiary_Audit_Logs_Min_Order_By>;
};

/** input type for inserting array relation for remote table "address_subsidiary_audit_logs" */
export type Address_Subsidiary_Audit_Logs_Arr_Rel_Insert_Input = {
  data: Array<Address_Subsidiary_Audit_Logs_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Address_Subsidiary_Audit_Logs_On_Conflict>;
};

/** Boolean expression to filter rows from the table "address_subsidiary_audit_logs". All fields are combined with a logical 'AND'. */
export type Address_Subsidiary_Audit_Logs_Bool_Exp = {
  _and?: InputMaybe<Array<Address_Subsidiary_Audit_Logs_Bool_Exp>>;
  _not?: InputMaybe<Address_Subsidiary_Audit_Logs_Bool_Exp>;
  _or?: InputMaybe<Array<Address_Subsidiary_Audit_Logs_Bool_Exp>>;
  action?: InputMaybe<Audit_Log_Action_Enum_Comparison_Exp>;
  audit_log_action?: InputMaybe<Audit_Log_Action_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_superseded?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  organization_address?: InputMaybe<Organization_Address_Bool_Exp>;
  organization_address_id?: InputMaybe<Uuid_Comparison_Exp>;
  subsidiary?: InputMaybe<Subsidiary_Bool_Exp>;
  subsidiary_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "address_subsidiary_audit_logs" */
export enum Address_Subsidiary_Audit_Logs_Constraint {
  /** unique or primary key constraint on columns "id" */
  AddressSubsidiaryAuditLogsPkey = 'address_subsidiary_audit_logs_pkey'
}

/** input type for inserting data into table "address_subsidiary_audit_logs" */
export type Address_Subsidiary_Audit_Logs_Insert_Input = {
  action?: InputMaybe<Audit_Log_Action_Enum>;
  audit_log_action?: InputMaybe<Audit_Log_Action_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_superseded?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_address?: InputMaybe<Organization_Address_Obj_Rel_Insert_Input>;
  organization_address_id?: InputMaybe<Scalars['uuid']['input']>;
  subsidiary?: InputMaybe<Subsidiary_Obj_Rel_Insert_Input>;
  subsidiary_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Address_Subsidiary_Audit_Logs_Max_Fields = {
  __typename?: 'address_subsidiary_audit_logs_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  organization_address_id?: Maybe<Scalars['uuid']['output']>;
  subsidiary_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "address_subsidiary_audit_logs" */
export type Address_Subsidiary_Audit_Logs_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_address_id?: InputMaybe<Order_By>;
  subsidiary_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Address_Subsidiary_Audit_Logs_Min_Fields = {
  __typename?: 'address_subsidiary_audit_logs_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  organization_address_id?: Maybe<Scalars['uuid']['output']>;
  subsidiary_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "address_subsidiary_audit_logs" */
export type Address_Subsidiary_Audit_Logs_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_address_id?: InputMaybe<Order_By>;
  subsidiary_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "address_subsidiary_audit_logs" */
export type Address_Subsidiary_Audit_Logs_Mutation_Response = {
  __typename?: 'address_subsidiary_audit_logs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Address_Subsidiary_Audit_Logs>;
};

/** on_conflict condition type for table "address_subsidiary_audit_logs" */
export type Address_Subsidiary_Audit_Logs_On_Conflict = {
  constraint: Address_Subsidiary_Audit_Logs_Constraint;
  update_columns?: Array<Address_Subsidiary_Audit_Logs_Update_Column>;
  where?: InputMaybe<Address_Subsidiary_Audit_Logs_Bool_Exp>;
};

/** Ordering options when selecting data from "address_subsidiary_audit_logs". */
export type Address_Subsidiary_Audit_Logs_Order_By = {
  action?: InputMaybe<Order_By>;
  audit_log_action?: InputMaybe<Audit_Log_Action_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_superseded?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_address?: InputMaybe<Organization_Address_Order_By>;
  organization_address_id?: InputMaybe<Order_By>;
  subsidiary?: InputMaybe<Subsidiary_Order_By>;
  subsidiary_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: address_subsidiary_audit_logs */
export type Address_Subsidiary_Audit_Logs_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "address_subsidiary_audit_logs" */
export enum Address_Subsidiary_Audit_Logs_Select_Column {
  /** column name */
  Action = 'action',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsSuperseded = 'is_superseded',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrganizationAddressId = 'organization_address_id',
  /** column name */
  SubsidiaryId = 'subsidiary_id'
}

/** select "address_subsidiary_audit_logs_aggregate_bool_exp_bool_and_arguments_columns" columns of table "address_subsidiary_audit_logs" */
export enum Address_Subsidiary_Audit_Logs_Select_Column_Address_Subsidiary_Audit_Logs_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsSuperseded = 'is_superseded'
}

/** select "address_subsidiary_audit_logs_aggregate_bool_exp_bool_or_arguments_columns" columns of table "address_subsidiary_audit_logs" */
export enum Address_Subsidiary_Audit_Logs_Select_Column_Address_Subsidiary_Audit_Logs_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsSuperseded = 'is_superseded'
}

/** input type for updating data in table "address_subsidiary_audit_logs" */
export type Address_Subsidiary_Audit_Logs_Set_Input = {
  action?: InputMaybe<Audit_Log_Action_Enum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_superseded?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_address_id?: InputMaybe<Scalars['uuid']['input']>;
  subsidiary_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "address_subsidiary_audit_logs" */
export type Address_Subsidiary_Audit_Logs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Address_Subsidiary_Audit_Logs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Address_Subsidiary_Audit_Logs_Stream_Cursor_Value_Input = {
  action?: InputMaybe<Audit_Log_Action_Enum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_superseded?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_address_id?: InputMaybe<Scalars['uuid']['input']>;
  subsidiary_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "address_subsidiary_audit_logs" */
export enum Address_Subsidiary_Audit_Logs_Update_Column {
  /** column name */
  Action = 'action',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsSuperseded = 'is_superseded',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrganizationAddressId = 'organization_address_id',
  /** column name */
  SubsidiaryId = 'subsidiary_id'
}

export type Address_Subsidiary_Audit_Logs_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Address_Subsidiary_Audit_Logs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Address_Subsidiary_Audit_Logs_Bool_Exp;
};

/** Boolean expression to filter rows from the table "address_subsidiary". All fields are combined with a logical 'AND'. */
export type Address_Subsidiary_Bool_Exp = {
  _and?: InputMaybe<Array<Address_Subsidiary_Bool_Exp>>;
  _not?: InputMaybe<Address_Subsidiary_Bool_Exp>;
  _or?: InputMaybe<Array<Address_Subsidiary_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_superseded?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  organization_address?: InputMaybe<Organization_Address_Bool_Exp>;
  organization_address_id?: InputMaybe<Uuid_Comparison_Exp>;
  subsidiary?: InputMaybe<Subsidiary_Bool_Exp>;
  subsidiary_id?: InputMaybe<Uuid_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  valid_to?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "address_subsidiary" */
export enum Address_Subsidiary_Constraint {
  /** unique or primary key constraint on columns "organization_address_id" */
  AddressSubsidiaryOneCurrentIdx = 'address_subsidiary_one_current_idx',
  /** unique or primary key constraint on columns "id" */
  AddressSubsidiaryPkey = 'address_subsidiary_pkey'
}

/** input type for inserting data into table "address_subsidiary" */
export type Address_Subsidiary_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_superseded?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_address?: InputMaybe<Organization_Address_Obj_Rel_Insert_Input>;
  organization_address_id?: InputMaybe<Scalars['uuid']['input']>;
  subsidiary?: InputMaybe<Subsidiary_Obj_Rel_Insert_Input>;
  subsidiary_id?: InputMaybe<Scalars['uuid']['input']>;
  valid_from?: InputMaybe<Scalars['timestamptz']['input']>;
  valid_to?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Address_Subsidiary_Max_Fields = {
  __typename?: 'address_subsidiary_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  organization_address_id?: Maybe<Scalars['uuid']['output']>;
  subsidiary_id?: Maybe<Scalars['uuid']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  valid_to?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "address_subsidiary" */
export type Address_Subsidiary_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_address_id?: InputMaybe<Order_By>;
  subsidiary_id?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_to?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Address_Subsidiary_Min_Fields = {
  __typename?: 'address_subsidiary_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  organization_address_id?: Maybe<Scalars['uuid']['output']>;
  subsidiary_id?: Maybe<Scalars['uuid']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  valid_to?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "address_subsidiary" */
export type Address_Subsidiary_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_address_id?: InputMaybe<Order_By>;
  subsidiary_id?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_to?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "address_subsidiary" */
export type Address_Subsidiary_Mutation_Response = {
  __typename?: 'address_subsidiary_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Address_Subsidiary>;
};

/** on_conflict condition type for table "address_subsidiary" */
export type Address_Subsidiary_On_Conflict = {
  constraint: Address_Subsidiary_Constraint;
  update_columns?: Array<Address_Subsidiary_Update_Column>;
  where?: InputMaybe<Address_Subsidiary_Bool_Exp>;
};

/** Ordering options when selecting data from "address_subsidiary". */
export type Address_Subsidiary_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_superseded?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_address?: InputMaybe<Organization_Address_Order_By>;
  organization_address_id?: InputMaybe<Order_By>;
  subsidiary?: InputMaybe<Subsidiary_Order_By>;
  subsidiary_id?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_to?: InputMaybe<Order_By>;
};

/** primary key columns input for table: address_subsidiary */
export type Address_Subsidiary_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "address_subsidiary" */
export enum Address_Subsidiary_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsSuperseded = 'is_superseded',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrganizationAddressId = 'organization_address_id',
  /** column name */
  SubsidiaryId = 'subsidiary_id',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTo = 'valid_to'
}

/** select "address_subsidiary_aggregate_bool_exp_bool_and_arguments_columns" columns of table "address_subsidiary" */
export enum Address_Subsidiary_Select_Column_Address_Subsidiary_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsSuperseded = 'is_superseded'
}

/** select "address_subsidiary_aggregate_bool_exp_bool_or_arguments_columns" columns of table "address_subsidiary" */
export enum Address_Subsidiary_Select_Column_Address_Subsidiary_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsSuperseded = 'is_superseded'
}

/** input type for updating data in table "address_subsidiary" */
export type Address_Subsidiary_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_superseded?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_address_id?: InputMaybe<Scalars['uuid']['input']>;
  subsidiary_id?: InputMaybe<Scalars['uuid']['input']>;
  valid_from?: InputMaybe<Scalars['timestamptz']['input']>;
  valid_to?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "address_subsidiary" */
export type Address_Subsidiary_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Address_Subsidiary_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Address_Subsidiary_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_superseded?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_address_id?: InputMaybe<Scalars['uuid']['input']>;
  subsidiary_id?: InputMaybe<Scalars['uuid']['input']>;
  valid_from?: InputMaybe<Scalars['timestamptz']['input']>;
  valid_to?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "address_subsidiary" */
export enum Address_Subsidiary_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsSuperseded = 'is_superseded',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrganizationAddressId = 'organization_address_id',
  /** column name */
  SubsidiaryId = 'subsidiary_id',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTo = 'valid_to'
}

export type Address_Subsidiary_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Address_Subsidiary_Set_Input>;
  /** filter the rows which have to be updated */
  where: Address_Subsidiary_Bool_Exp;
};

/** columns and relationships of "address_type" */
export type Address_Type = {
  __typename?: 'address_type';
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  organization_addresses: Array<Organization_Address>;
  /** An aggregate relationship */
  organization_addresses_aggregate: Organization_Address_Aggregate;
  /** An array relationship */
  partner_addresses: Array<Partner_Address>;
  /** An aggregate relationship */
  partner_addresses_aggregate: Partner_Address_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "address_type" */
export type Address_TypeOrganization_AddressesArgs = {
  distinct_on?: InputMaybe<Array<Organization_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Address_Order_By>>;
  where?: InputMaybe<Organization_Address_Bool_Exp>;
};


/** columns and relationships of "address_type" */
export type Address_TypeOrganization_Addresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Address_Order_By>>;
  where?: InputMaybe<Organization_Address_Bool_Exp>;
};


/** columns and relationships of "address_type" */
export type Address_TypePartner_AddressesArgs = {
  distinct_on?: InputMaybe<Array<Partner_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Address_Order_By>>;
  where?: InputMaybe<Partner_Address_Bool_Exp>;
};


/** columns and relationships of "address_type" */
export type Address_TypePartner_Addresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Address_Order_By>>;
  where?: InputMaybe<Partner_Address_Bool_Exp>;
};

/** aggregated selection of "address_type" */
export type Address_Type_Aggregate = {
  __typename?: 'address_type_aggregate';
  aggregate?: Maybe<Address_Type_Aggregate_Fields>;
  nodes: Array<Address_Type>;
};

/** aggregate fields of "address_type" */
export type Address_Type_Aggregate_Fields = {
  __typename?: 'address_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Address_Type_Max_Fields>;
  min?: Maybe<Address_Type_Min_Fields>;
};


/** aggregate fields of "address_type" */
export type Address_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Address_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "address_type". All fields are combined with a logical 'AND'. */
export type Address_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Address_Type_Bool_Exp>>;
  _not?: InputMaybe<Address_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Address_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  organization_addresses?: InputMaybe<Organization_Address_Bool_Exp>;
  organization_addresses_aggregate?: InputMaybe<Organization_Address_Aggregate_Bool_Exp>;
  partner_addresses?: InputMaybe<Partner_Address_Bool_Exp>;
  partner_addresses_aggregate?: InputMaybe<Partner_Address_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "address_type" */
export enum Address_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  AddressTypePkey = 'address_type_pkey'
}

export enum Address_Type_Enum {
  /** BILLING */
  Billing = 'BILLING',
  /** COOPERATE */
  Cooperate = 'COOPERATE',
  /** HEAD_OFFICE */
  HeadOffice = 'HEAD_OFFICE',
  /** HOME */
  Home = 'HOME',
  /** MAILING */
  Mailing = 'MAILING',
  /** PLACE_OF_BUSINESS */
  PlaceOfBusiness = 'PLACE_OF_BUSINESS',
  /** SHIPPING */
  Shipping = 'SHIPPING'
}

/** Boolean expression to compare columns of type "address_type_enum". All fields are combined with logical 'AND'. */
export type Address_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Address_Type_Enum>;
  _in?: InputMaybe<Array<Address_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Address_Type_Enum>;
  _nin?: InputMaybe<Array<Address_Type_Enum>>;
};

/** input type for inserting data into table "address_type" */
export type Address_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  organization_addresses?: InputMaybe<Organization_Address_Arr_Rel_Insert_Input>;
  partner_addresses?: InputMaybe<Partner_Address_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Address_Type_Max_Fields = {
  __typename?: 'address_type_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Address_Type_Min_Fields = {
  __typename?: 'address_type_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "address_type" */
export type Address_Type_Mutation_Response = {
  __typename?: 'address_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Address_Type>;
};

/** input type for inserting object relation for remote table "address_type" */
export type Address_Type_Obj_Rel_Insert_Input = {
  data: Address_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Address_Type_On_Conflict>;
};

/** on_conflict condition type for table "address_type" */
export type Address_Type_On_Conflict = {
  constraint: Address_Type_Constraint;
  update_columns?: Array<Address_Type_Update_Column>;
  where?: InputMaybe<Address_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "address_type". */
export type Address_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  organization_addresses_aggregate?: InputMaybe<Organization_Address_Aggregate_Order_By>;
  partner_addresses_aggregate?: InputMaybe<Partner_Address_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: address_type */
export type Address_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "address_type" */
export enum Address_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "address_type" */
export type Address_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "address_type" */
export type Address_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Address_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Address_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "address_type" */
export enum Address_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Address_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Address_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Address_Type_Bool_Exp;
};

/** columns and relationships of "asset_grouping" */
export type Asset_Grouping = {
  __typename?: 'asset_grouping';
  /** An array relationship */
  asset_grouping_customer_assets: Array<Asset_Grouping_Customer_Asset>;
  /** An aggregate relationship */
  asset_grouping_customer_assets_aggregate: Asset_Grouping_Customer_Asset_Aggregate;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  is_deleted: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "asset_grouping" */
export type Asset_GroupingAsset_Grouping_Customer_AssetsArgs = {
  distinct_on?: InputMaybe<Array<Asset_Grouping_Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Grouping_Customer_Asset_Order_By>>;
  where?: InputMaybe<Asset_Grouping_Customer_Asset_Bool_Exp>;
};


/** columns and relationships of "asset_grouping" */
export type Asset_GroupingAsset_Grouping_Customer_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Grouping_Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Grouping_Customer_Asset_Order_By>>;
  where?: InputMaybe<Asset_Grouping_Customer_Asset_Bool_Exp>;
};

/** aggregated selection of "asset_grouping" */
export type Asset_Grouping_Aggregate = {
  __typename?: 'asset_grouping_aggregate';
  aggregate?: Maybe<Asset_Grouping_Aggregate_Fields>;
  nodes: Array<Asset_Grouping>;
};

/** aggregate fields of "asset_grouping" */
export type Asset_Grouping_Aggregate_Fields = {
  __typename?: 'asset_grouping_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Asset_Grouping_Max_Fields>;
  min?: Maybe<Asset_Grouping_Min_Fields>;
};


/** aggregate fields of "asset_grouping" */
export type Asset_Grouping_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Asset_Grouping_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "asset_grouping". All fields are combined with a logical 'AND'. */
export type Asset_Grouping_Bool_Exp = {
  _and?: InputMaybe<Array<Asset_Grouping_Bool_Exp>>;
  _not?: InputMaybe<Asset_Grouping_Bool_Exp>;
  _or?: InputMaybe<Array<Asset_Grouping_Bool_Exp>>;
  asset_grouping_customer_assets?: InputMaybe<Asset_Grouping_Customer_Asset_Bool_Exp>;
  asset_grouping_customer_assets_aggregate?: InputMaybe<Asset_Grouping_Customer_Asset_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "asset_grouping" */
export enum Asset_Grouping_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssetGroupingPkey = 'asset_grouping_pkey'
}

/** columns and relationships of "asset_grouping_customer_asset" */
export type Asset_Grouping_Customer_Asset = {
  __typename?: 'asset_grouping_customer_asset';
  /** An object relationship */
  asset_grouping: Asset_Grouping;
  asset_grouping_id: Scalars['uuid']['output'];
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  customer_asset: Customer_Asset;
  customer_asset_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  is_deleted: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "asset_grouping_customer_asset" */
export type Asset_Grouping_Customer_Asset_Aggregate = {
  __typename?: 'asset_grouping_customer_asset_aggregate';
  aggregate?: Maybe<Asset_Grouping_Customer_Asset_Aggregate_Fields>;
  nodes: Array<Asset_Grouping_Customer_Asset>;
};

export type Asset_Grouping_Customer_Asset_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Asset_Grouping_Customer_Asset_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Asset_Grouping_Customer_Asset_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Asset_Grouping_Customer_Asset_Aggregate_Bool_Exp_Count>;
};

export type Asset_Grouping_Customer_Asset_Aggregate_Bool_Exp_Bool_And = {
  arguments: Asset_Grouping_Customer_Asset_Select_Column_Asset_Grouping_Customer_Asset_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Asset_Grouping_Customer_Asset_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Asset_Grouping_Customer_Asset_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Asset_Grouping_Customer_Asset_Select_Column_Asset_Grouping_Customer_Asset_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Asset_Grouping_Customer_Asset_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Asset_Grouping_Customer_Asset_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Asset_Grouping_Customer_Asset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Asset_Grouping_Customer_Asset_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "asset_grouping_customer_asset" */
export type Asset_Grouping_Customer_Asset_Aggregate_Fields = {
  __typename?: 'asset_grouping_customer_asset_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Asset_Grouping_Customer_Asset_Max_Fields>;
  min?: Maybe<Asset_Grouping_Customer_Asset_Min_Fields>;
};


/** aggregate fields of "asset_grouping_customer_asset" */
export type Asset_Grouping_Customer_Asset_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Asset_Grouping_Customer_Asset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "asset_grouping_customer_asset" */
export type Asset_Grouping_Customer_Asset_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Asset_Grouping_Customer_Asset_Max_Order_By>;
  min?: InputMaybe<Asset_Grouping_Customer_Asset_Min_Order_By>;
};

/** input type for inserting array relation for remote table "asset_grouping_customer_asset" */
export type Asset_Grouping_Customer_Asset_Arr_Rel_Insert_Input = {
  data: Array<Asset_Grouping_Customer_Asset_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Asset_Grouping_Customer_Asset_On_Conflict>;
};

/** Boolean expression to filter rows from the table "asset_grouping_customer_asset". All fields are combined with a logical 'AND'. */
export type Asset_Grouping_Customer_Asset_Bool_Exp = {
  _and?: InputMaybe<Array<Asset_Grouping_Customer_Asset_Bool_Exp>>;
  _not?: InputMaybe<Asset_Grouping_Customer_Asset_Bool_Exp>;
  _or?: InputMaybe<Array<Asset_Grouping_Customer_Asset_Bool_Exp>>;
  asset_grouping?: InputMaybe<Asset_Grouping_Bool_Exp>;
  asset_grouping_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_asset?: InputMaybe<Customer_Asset_Bool_Exp>;
  customer_asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "asset_grouping_customer_asset" */
export enum Asset_Grouping_Customer_Asset_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssetGroupingCustomerAssetPkey = 'asset_grouping_customer_asset_pkey'
}

/** input type for inserting data into table "asset_grouping_customer_asset" */
export type Asset_Grouping_Customer_Asset_Insert_Input = {
  asset_grouping?: InputMaybe<Asset_Grouping_Obj_Rel_Insert_Input>;
  asset_grouping_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_asset?: InputMaybe<Customer_Asset_Obj_Rel_Insert_Input>;
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Asset_Grouping_Customer_Asset_Max_Fields = {
  __typename?: 'asset_grouping_customer_asset_max_fields';
  asset_grouping_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "asset_grouping_customer_asset" */
export type Asset_Grouping_Customer_Asset_Max_Order_By = {
  asset_grouping_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Asset_Grouping_Customer_Asset_Min_Fields = {
  __typename?: 'asset_grouping_customer_asset_min_fields';
  asset_grouping_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "asset_grouping_customer_asset" */
export type Asset_Grouping_Customer_Asset_Min_Order_By = {
  asset_grouping_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "asset_grouping_customer_asset" */
export type Asset_Grouping_Customer_Asset_Mutation_Response = {
  __typename?: 'asset_grouping_customer_asset_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Asset_Grouping_Customer_Asset>;
};

/** on_conflict condition type for table "asset_grouping_customer_asset" */
export type Asset_Grouping_Customer_Asset_On_Conflict = {
  constraint: Asset_Grouping_Customer_Asset_Constraint;
  update_columns?: Array<Asset_Grouping_Customer_Asset_Update_Column>;
  where?: InputMaybe<Asset_Grouping_Customer_Asset_Bool_Exp>;
};

/** Ordering options when selecting data from "asset_grouping_customer_asset". */
export type Asset_Grouping_Customer_Asset_Order_By = {
  asset_grouping?: InputMaybe<Asset_Grouping_Order_By>;
  asset_grouping_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_asset?: InputMaybe<Customer_Asset_Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: asset_grouping_customer_asset */
export type Asset_Grouping_Customer_Asset_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "asset_grouping_customer_asset" */
export enum Asset_Grouping_Customer_Asset_Select_Column {
  /** column name */
  AssetGroupingId = 'asset_grouping_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerAssetId = 'customer_asset_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by'
}

/** select "asset_grouping_customer_asset_aggregate_bool_exp_bool_and_arguments_columns" columns of table "asset_grouping_customer_asset" */
export enum Asset_Grouping_Customer_Asset_Select_Column_Asset_Grouping_Customer_Asset_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsDeleted = 'is_deleted'
}

/** select "asset_grouping_customer_asset_aggregate_bool_exp_bool_or_arguments_columns" columns of table "asset_grouping_customer_asset" */
export enum Asset_Grouping_Customer_Asset_Select_Column_Asset_Grouping_Customer_Asset_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsDeleted = 'is_deleted'
}

/** input type for updating data in table "asset_grouping_customer_asset" */
export type Asset_Grouping_Customer_Asset_Set_Input = {
  asset_grouping_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "asset_grouping_customer_asset" */
export type Asset_Grouping_Customer_Asset_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Asset_Grouping_Customer_Asset_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Asset_Grouping_Customer_Asset_Stream_Cursor_Value_Input = {
  asset_grouping_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "asset_grouping_customer_asset" */
export enum Asset_Grouping_Customer_Asset_Update_Column {
  /** column name */
  AssetGroupingId = 'asset_grouping_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerAssetId = 'customer_asset_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by'
}

export type Asset_Grouping_Customer_Asset_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Asset_Grouping_Customer_Asset_Set_Input>;
  /** filter the rows which have to be updated */
  where: Asset_Grouping_Customer_Asset_Bool_Exp;
};

/** input type for inserting data into table "asset_grouping" */
export type Asset_Grouping_Insert_Input = {
  asset_grouping_customer_assets?: InputMaybe<Asset_Grouping_Customer_Asset_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Asset_Grouping_Max_Fields = {
  __typename?: 'asset_grouping_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Asset_Grouping_Min_Fields = {
  __typename?: 'asset_grouping_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "asset_grouping" */
export type Asset_Grouping_Mutation_Response = {
  __typename?: 'asset_grouping_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Asset_Grouping>;
};

/** input type for inserting object relation for remote table "asset_grouping" */
export type Asset_Grouping_Obj_Rel_Insert_Input = {
  data: Asset_Grouping_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Asset_Grouping_On_Conflict>;
};

/** on_conflict condition type for table "asset_grouping" */
export type Asset_Grouping_On_Conflict = {
  constraint: Asset_Grouping_Constraint;
  update_columns?: Array<Asset_Grouping_Update_Column>;
  where?: InputMaybe<Asset_Grouping_Bool_Exp>;
};

/** Ordering options when selecting data from "asset_grouping". */
export type Asset_Grouping_Order_By = {
  asset_grouping_customer_assets_aggregate?: InputMaybe<Asset_Grouping_Customer_Asset_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
};

/** primary key columns input for table: asset_grouping */
export type Asset_Grouping_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "asset_grouping" */
export enum Asset_Grouping_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  Slug = 'slug'
}

/** input type for updating data in table "asset_grouping" */
export type Asset_Grouping_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "asset_grouping" */
export type Asset_Grouping_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Asset_Grouping_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Asset_Grouping_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "asset_grouping" */
export enum Asset_Grouping_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  Slug = 'slug'
}

export type Asset_Grouping_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Asset_Grouping_Set_Input>;
  /** filter the rows which have to be updated */
  where: Asset_Grouping_Bool_Exp;
};

/** columns and relationships of "asset_subsidiary" */
export type Asset_Subsidiary = {
  __typename?: 'asset_subsidiary';
  asset_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamp']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  customer_asset: Customer_Asset;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  is_superseded: Scalars['Boolean']['output'];
  last_modified: Scalars['timestamp']['output'];
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  subsidiary: Subsidiary;
  subsidiary_id: Scalars['uuid']['output'];
  valid_from: Scalars['timestamptz']['output'];
  valid_to?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "asset_subsidiary" */
export type Asset_Subsidiary_Aggregate = {
  __typename?: 'asset_subsidiary_aggregate';
  aggregate?: Maybe<Asset_Subsidiary_Aggregate_Fields>;
  nodes: Array<Asset_Subsidiary>;
};

export type Asset_Subsidiary_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Asset_Subsidiary_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Asset_Subsidiary_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Asset_Subsidiary_Aggregate_Bool_Exp_Count>;
};

export type Asset_Subsidiary_Aggregate_Bool_Exp_Bool_And = {
  arguments: Asset_Subsidiary_Select_Column_Asset_Subsidiary_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Asset_Subsidiary_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Asset_Subsidiary_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Asset_Subsidiary_Select_Column_Asset_Subsidiary_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Asset_Subsidiary_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Asset_Subsidiary_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Asset_Subsidiary_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Asset_Subsidiary_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "asset_subsidiary" */
export type Asset_Subsidiary_Aggregate_Fields = {
  __typename?: 'asset_subsidiary_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Asset_Subsidiary_Max_Fields>;
  min?: Maybe<Asset_Subsidiary_Min_Fields>;
};


/** aggregate fields of "asset_subsidiary" */
export type Asset_Subsidiary_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Asset_Subsidiary_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "asset_subsidiary" */
export type Asset_Subsidiary_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Asset_Subsidiary_Max_Order_By>;
  min?: InputMaybe<Asset_Subsidiary_Min_Order_By>;
};

/** input type for inserting array relation for remote table "asset_subsidiary" */
export type Asset_Subsidiary_Arr_Rel_Insert_Input = {
  data: Array<Asset_Subsidiary_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Asset_Subsidiary_On_Conflict>;
};

/** columns and relationships of "asset_subsidiary_audit_logs" */
export type Asset_Subsidiary_Audit_Logs = {
  __typename?: 'asset_subsidiary_audit_logs';
  action: Audit_Log_Action_Enum;
  asset_id: Scalars['uuid']['output'];
  /** An object relationship */
  audit_log_action: Audit_Log_Action;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  customer_asset: Customer_Asset;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  is_superseded: Scalars['Boolean']['output'];
  last_modified: Scalars['timestamptz']['output'];
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  subsidiary: Subsidiary;
  subsidiary_id: Scalars['uuid']['output'];
};

/** aggregated selection of "asset_subsidiary_audit_logs" */
export type Asset_Subsidiary_Audit_Logs_Aggregate = {
  __typename?: 'asset_subsidiary_audit_logs_aggregate';
  aggregate?: Maybe<Asset_Subsidiary_Audit_Logs_Aggregate_Fields>;
  nodes: Array<Asset_Subsidiary_Audit_Logs>;
};

export type Asset_Subsidiary_Audit_Logs_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Asset_Subsidiary_Audit_Logs_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Asset_Subsidiary_Audit_Logs_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Asset_Subsidiary_Audit_Logs_Aggregate_Bool_Exp_Count>;
};

export type Asset_Subsidiary_Audit_Logs_Aggregate_Bool_Exp_Bool_And = {
  arguments: Asset_Subsidiary_Audit_Logs_Select_Column_Asset_Subsidiary_Audit_Logs_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Asset_Subsidiary_Audit_Logs_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Asset_Subsidiary_Audit_Logs_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Asset_Subsidiary_Audit_Logs_Select_Column_Asset_Subsidiary_Audit_Logs_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Asset_Subsidiary_Audit_Logs_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Asset_Subsidiary_Audit_Logs_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Asset_Subsidiary_Audit_Logs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Asset_Subsidiary_Audit_Logs_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "asset_subsidiary_audit_logs" */
export type Asset_Subsidiary_Audit_Logs_Aggregate_Fields = {
  __typename?: 'asset_subsidiary_audit_logs_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Asset_Subsidiary_Audit_Logs_Max_Fields>;
  min?: Maybe<Asset_Subsidiary_Audit_Logs_Min_Fields>;
};


/** aggregate fields of "asset_subsidiary_audit_logs" */
export type Asset_Subsidiary_Audit_Logs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Asset_Subsidiary_Audit_Logs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "asset_subsidiary_audit_logs" */
export type Asset_Subsidiary_Audit_Logs_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Asset_Subsidiary_Audit_Logs_Max_Order_By>;
  min?: InputMaybe<Asset_Subsidiary_Audit_Logs_Min_Order_By>;
};

/** input type for inserting array relation for remote table "asset_subsidiary_audit_logs" */
export type Asset_Subsidiary_Audit_Logs_Arr_Rel_Insert_Input = {
  data: Array<Asset_Subsidiary_Audit_Logs_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Asset_Subsidiary_Audit_Logs_On_Conflict>;
};

/** Boolean expression to filter rows from the table "asset_subsidiary_audit_logs". All fields are combined with a logical 'AND'. */
export type Asset_Subsidiary_Audit_Logs_Bool_Exp = {
  _and?: InputMaybe<Array<Asset_Subsidiary_Audit_Logs_Bool_Exp>>;
  _not?: InputMaybe<Asset_Subsidiary_Audit_Logs_Bool_Exp>;
  _or?: InputMaybe<Array<Asset_Subsidiary_Audit_Logs_Bool_Exp>>;
  action?: InputMaybe<Audit_Log_Action_Enum_Comparison_Exp>;
  asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  audit_log_action?: InputMaybe<Audit_Log_Action_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  customer_asset?: InputMaybe<Customer_Asset_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_superseded?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  subsidiary?: InputMaybe<Subsidiary_Bool_Exp>;
  subsidiary_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "asset_subsidiary_audit_logs" */
export enum Asset_Subsidiary_Audit_Logs_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssetSubsidiaryAuditLogsPkey = 'asset_subsidiary_audit_logs_pkey'
}

/** input type for inserting data into table "asset_subsidiary_audit_logs" */
export type Asset_Subsidiary_Audit_Logs_Insert_Input = {
  action?: InputMaybe<Audit_Log_Action_Enum>;
  asset_id?: InputMaybe<Scalars['uuid']['input']>;
  audit_log_action?: InputMaybe<Audit_Log_Action_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  customer_asset?: InputMaybe<Customer_Asset_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_superseded?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  subsidiary?: InputMaybe<Subsidiary_Obj_Rel_Insert_Input>;
  subsidiary_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Asset_Subsidiary_Audit_Logs_Max_Fields = {
  __typename?: 'asset_subsidiary_audit_logs_max_fields';
  asset_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  subsidiary_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "asset_subsidiary_audit_logs" */
export type Asset_Subsidiary_Audit_Logs_Max_Order_By = {
  asset_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  subsidiary_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Asset_Subsidiary_Audit_Logs_Min_Fields = {
  __typename?: 'asset_subsidiary_audit_logs_min_fields';
  asset_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  subsidiary_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "asset_subsidiary_audit_logs" */
export type Asset_Subsidiary_Audit_Logs_Min_Order_By = {
  asset_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  subsidiary_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "asset_subsidiary_audit_logs" */
export type Asset_Subsidiary_Audit_Logs_Mutation_Response = {
  __typename?: 'asset_subsidiary_audit_logs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Asset_Subsidiary_Audit_Logs>;
};

/** on_conflict condition type for table "asset_subsidiary_audit_logs" */
export type Asset_Subsidiary_Audit_Logs_On_Conflict = {
  constraint: Asset_Subsidiary_Audit_Logs_Constraint;
  update_columns?: Array<Asset_Subsidiary_Audit_Logs_Update_Column>;
  where?: InputMaybe<Asset_Subsidiary_Audit_Logs_Bool_Exp>;
};

/** Ordering options when selecting data from "asset_subsidiary_audit_logs". */
export type Asset_Subsidiary_Audit_Logs_Order_By = {
  action?: InputMaybe<Order_By>;
  asset_id?: InputMaybe<Order_By>;
  audit_log_action?: InputMaybe<Audit_Log_Action_Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_asset?: InputMaybe<Customer_Asset_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_superseded?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  subsidiary?: InputMaybe<Subsidiary_Order_By>;
  subsidiary_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: asset_subsidiary_audit_logs */
export type Asset_Subsidiary_Audit_Logs_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "asset_subsidiary_audit_logs" */
export enum Asset_Subsidiary_Audit_Logs_Select_Column {
  /** column name */
  Action = 'action',
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsSuperseded = 'is_superseded',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  SubsidiaryId = 'subsidiary_id'
}

/** select "asset_subsidiary_audit_logs_aggregate_bool_exp_bool_and_arguments_columns" columns of table "asset_subsidiary_audit_logs" */
export enum Asset_Subsidiary_Audit_Logs_Select_Column_Asset_Subsidiary_Audit_Logs_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsSuperseded = 'is_superseded'
}

/** select "asset_subsidiary_audit_logs_aggregate_bool_exp_bool_or_arguments_columns" columns of table "asset_subsidiary_audit_logs" */
export enum Asset_Subsidiary_Audit_Logs_Select_Column_Asset_Subsidiary_Audit_Logs_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsSuperseded = 'is_superseded'
}

/** input type for updating data in table "asset_subsidiary_audit_logs" */
export type Asset_Subsidiary_Audit_Logs_Set_Input = {
  action?: InputMaybe<Audit_Log_Action_Enum>;
  asset_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_superseded?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  subsidiary_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "asset_subsidiary_audit_logs" */
export type Asset_Subsidiary_Audit_Logs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Asset_Subsidiary_Audit_Logs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Asset_Subsidiary_Audit_Logs_Stream_Cursor_Value_Input = {
  action?: InputMaybe<Audit_Log_Action_Enum>;
  asset_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_superseded?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  subsidiary_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "asset_subsidiary_audit_logs" */
export enum Asset_Subsidiary_Audit_Logs_Update_Column {
  /** column name */
  Action = 'action',
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsSuperseded = 'is_superseded',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  SubsidiaryId = 'subsidiary_id'
}

export type Asset_Subsidiary_Audit_Logs_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Asset_Subsidiary_Audit_Logs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Asset_Subsidiary_Audit_Logs_Bool_Exp;
};

/** Boolean expression to filter rows from the table "asset_subsidiary". All fields are combined with a logical 'AND'. */
export type Asset_Subsidiary_Bool_Exp = {
  _and?: InputMaybe<Array<Asset_Subsidiary_Bool_Exp>>;
  _not?: InputMaybe<Asset_Subsidiary_Bool_Exp>;
  _or?: InputMaybe<Array<Asset_Subsidiary_Bool_Exp>>;
  asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  customer_asset?: InputMaybe<Customer_Asset_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_superseded?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  subsidiary?: InputMaybe<Subsidiary_Bool_Exp>;
  subsidiary_id?: InputMaybe<Uuid_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  valid_to?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "asset_subsidiary" */
export enum Asset_Subsidiary_Constraint {
  /** unique or primary key constraint on columns "asset_id" */
  AssetSubsidiaryOneCurrentIdx = 'asset_subsidiary_one_current_idx',
  /** unique or primary key constraint on columns "id" */
  AssetSubsidiaryPkey = 'asset_subsidiary_pkey'
}

/** input type for inserting data into table "asset_subsidiary" */
export type Asset_Subsidiary_Insert_Input = {
  asset_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  customer_asset?: InputMaybe<Customer_Asset_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_superseded?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  subsidiary?: InputMaybe<Subsidiary_Obj_Rel_Insert_Input>;
  subsidiary_id?: InputMaybe<Scalars['uuid']['input']>;
  valid_from?: InputMaybe<Scalars['timestamptz']['input']>;
  valid_to?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Asset_Subsidiary_Max_Fields = {
  __typename?: 'asset_subsidiary_max_fields';
  asset_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  subsidiary_id?: Maybe<Scalars['uuid']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  valid_to?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "asset_subsidiary" */
export type Asset_Subsidiary_Max_Order_By = {
  asset_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  subsidiary_id?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_to?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Asset_Subsidiary_Min_Fields = {
  __typename?: 'asset_subsidiary_min_fields';
  asset_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  subsidiary_id?: Maybe<Scalars['uuid']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  valid_to?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "asset_subsidiary" */
export type Asset_Subsidiary_Min_Order_By = {
  asset_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  subsidiary_id?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_to?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "asset_subsidiary" */
export type Asset_Subsidiary_Mutation_Response = {
  __typename?: 'asset_subsidiary_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Asset_Subsidiary>;
};

/** on_conflict condition type for table "asset_subsidiary" */
export type Asset_Subsidiary_On_Conflict = {
  constraint: Asset_Subsidiary_Constraint;
  update_columns?: Array<Asset_Subsidiary_Update_Column>;
  where?: InputMaybe<Asset_Subsidiary_Bool_Exp>;
};

/** Ordering options when selecting data from "asset_subsidiary". */
export type Asset_Subsidiary_Order_By = {
  asset_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  customer_asset?: InputMaybe<Customer_Asset_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_superseded?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  subsidiary?: InputMaybe<Subsidiary_Order_By>;
  subsidiary_id?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_to?: InputMaybe<Order_By>;
};

/** primary key columns input for table: asset_subsidiary */
export type Asset_Subsidiary_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "asset_subsidiary" */
export enum Asset_Subsidiary_Select_Column {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsSuperseded = 'is_superseded',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  SubsidiaryId = 'subsidiary_id',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTo = 'valid_to'
}

/** select "asset_subsidiary_aggregate_bool_exp_bool_and_arguments_columns" columns of table "asset_subsidiary" */
export enum Asset_Subsidiary_Select_Column_Asset_Subsidiary_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsSuperseded = 'is_superseded'
}

/** select "asset_subsidiary_aggregate_bool_exp_bool_or_arguments_columns" columns of table "asset_subsidiary" */
export enum Asset_Subsidiary_Select_Column_Asset_Subsidiary_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsSuperseded = 'is_superseded'
}

/** input type for updating data in table "asset_subsidiary" */
export type Asset_Subsidiary_Set_Input = {
  asset_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_superseded?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  subsidiary_id?: InputMaybe<Scalars['uuid']['input']>;
  valid_from?: InputMaybe<Scalars['timestamptz']['input']>;
  valid_to?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "asset_subsidiary" */
export type Asset_Subsidiary_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Asset_Subsidiary_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Asset_Subsidiary_Stream_Cursor_Value_Input = {
  asset_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_superseded?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  subsidiary_id?: InputMaybe<Scalars['uuid']['input']>;
  valid_from?: InputMaybe<Scalars['timestamptz']['input']>;
  valid_to?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "asset_subsidiary" */
export enum Asset_Subsidiary_Update_Column {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsSuperseded = 'is_superseded',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  SubsidiaryId = 'subsidiary_id',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTo = 'valid_to'
}

export type Asset_Subsidiary_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Asset_Subsidiary_Set_Input>;
  /** filter the rows which have to be updated */
  where: Asset_Subsidiary_Bool_Exp;
};

/** columns and relationships of "asset_type" */
export type Asset_Type = {
  __typename?: 'asset_type';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  customer_assets: Array<Customer_Asset>;
  /** An aggregate relationship */
  customer_assets_aggregate: Customer_Asset_Aggregate;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rank_id?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "asset_type" */
export type Asset_TypeCustomer_AssetsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Order_By>>;
  where?: InputMaybe<Customer_Asset_Bool_Exp>;
};


/** columns and relationships of "asset_type" */
export type Asset_TypeCustomer_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Order_By>>;
  where?: InputMaybe<Customer_Asset_Bool_Exp>;
};

/** aggregated selection of "asset_type" */
export type Asset_Type_Aggregate = {
  __typename?: 'asset_type_aggregate';
  aggregate?: Maybe<Asset_Type_Aggregate_Fields>;
  nodes: Array<Asset_Type>;
};

/** aggregate fields of "asset_type" */
export type Asset_Type_Aggregate_Fields = {
  __typename?: 'asset_type_aggregate_fields';
  avg?: Maybe<Asset_Type_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Asset_Type_Max_Fields>;
  min?: Maybe<Asset_Type_Min_Fields>;
  stddev?: Maybe<Asset_Type_Stddev_Fields>;
  stddev_pop?: Maybe<Asset_Type_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Asset_Type_Stddev_Samp_Fields>;
  sum?: Maybe<Asset_Type_Sum_Fields>;
  var_pop?: Maybe<Asset_Type_Var_Pop_Fields>;
  var_samp?: Maybe<Asset_Type_Var_Samp_Fields>;
  variance?: Maybe<Asset_Type_Variance_Fields>;
};


/** aggregate fields of "asset_type" */
export type Asset_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Asset_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Asset_Type_Avg_Fields = {
  __typename?: 'asset_type_avg_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "asset_type". All fields are combined with a logical 'AND'. */
export type Asset_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Asset_Type_Bool_Exp>>;
  _not?: InputMaybe<Asset_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Asset_Type_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_assets?: InputMaybe<Customer_Asset_Bool_Exp>;
  customer_assets_aggregate?: InputMaybe<Customer_Asset_Aggregate_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  rank_id?: InputMaybe<Int_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "asset_type_category" */
export type Asset_Type_Category = {
  __typename?: 'asset_type_category';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "asset_type_category" */
export type Asset_Type_Category_Aggregate = {
  __typename?: 'asset_type_category_aggregate';
  aggregate?: Maybe<Asset_Type_Category_Aggregate_Fields>;
  nodes: Array<Asset_Type_Category>;
};

/** aggregate fields of "asset_type_category" */
export type Asset_Type_Category_Aggregate_Fields = {
  __typename?: 'asset_type_category_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Asset_Type_Category_Max_Fields>;
  min?: Maybe<Asset_Type_Category_Min_Fields>;
};


/** aggregate fields of "asset_type_category" */
export type Asset_Type_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Asset_Type_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "asset_type_category". All fields are combined with a logical 'AND'. */
export type Asset_Type_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Asset_Type_Category_Bool_Exp>>;
  _not?: InputMaybe<Asset_Type_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Asset_Type_Category_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "asset_type_category" */
export enum Asset_Type_Category_Constraint {
  /** unique or primary key constraint on columns "value" */
  AssetTypeCategoryPkey = 'asset_type_category_pkey'
}

/** input type for inserting data into table "asset_type_category" */
export type Asset_Type_Category_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Asset_Type_Category_Max_Fields = {
  __typename?: 'asset_type_category_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Asset_Type_Category_Min_Fields = {
  __typename?: 'asset_type_category_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "asset_type_category" */
export type Asset_Type_Category_Mutation_Response = {
  __typename?: 'asset_type_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Asset_Type_Category>;
};

/** on_conflict condition type for table "asset_type_category" */
export type Asset_Type_Category_On_Conflict = {
  constraint: Asset_Type_Category_Constraint;
  update_columns?: Array<Asset_Type_Category_Update_Column>;
  where?: InputMaybe<Asset_Type_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "asset_type_category". */
export type Asset_Type_Category_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: asset_type_category */
export type Asset_Type_Category_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "asset_type_category" */
export enum Asset_Type_Category_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "asset_type_category" */
export type Asset_Type_Category_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "asset_type_category" */
export type Asset_Type_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Asset_Type_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Asset_Type_Category_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "asset_type_category" */
export enum Asset_Type_Category_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Asset_Type_Category_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Asset_Type_Category_Set_Input>;
  /** filter the rows which have to be updated */
  where: Asset_Type_Category_Bool_Exp;
};

/** unique or primary key constraints on table "asset_type" */
export enum Asset_Type_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssetTypePkey = 'asset_type_pkey'
}

/** input type for incrementing numeric columns in table "asset_type" */
export type Asset_Type_Inc_Input = {
  rank_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "asset_type" */
export type Asset_Type_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_assets?: InputMaybe<Customer_Asset_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rank_id?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Asset_Type_Max_Fields = {
  __typename?: 'asset_type_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rank_id?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Asset_Type_Min_Fields = {
  __typename?: 'asset_type_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rank_id?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "asset_type" */
export type Asset_Type_Mutation_Response = {
  __typename?: 'asset_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Asset_Type>;
};

/** input type for inserting object relation for remote table "asset_type" */
export type Asset_Type_Obj_Rel_Insert_Input = {
  data: Asset_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Asset_Type_On_Conflict>;
};

/** on_conflict condition type for table "asset_type" */
export type Asset_Type_On_Conflict = {
  constraint: Asset_Type_Constraint;
  update_columns?: Array<Asset_Type_Update_Column>;
  where?: InputMaybe<Asset_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "asset_type". */
export type Asset_Type_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_assets_aggregate?: InputMaybe<Customer_Asset_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  rank_id?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
};

/** primary key columns input for table: asset_type */
export type Asset_Type_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "asset_type" */
export enum Asset_Type_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  Name = 'name',
  /** column name */
  RankId = 'rank_id',
  /** column name */
  Slug = 'slug'
}

/** input type for updating data in table "asset_type" */
export type Asset_Type_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rank_id?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Asset_Type_Stddev_Fields = {
  __typename?: 'asset_type_stddev_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Asset_Type_Stddev_Pop_Fields = {
  __typename?: 'asset_type_stddev_pop_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Asset_Type_Stddev_Samp_Fields = {
  __typename?: 'asset_type_stddev_samp_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "asset_type" */
export type Asset_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Asset_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Asset_Type_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rank_id?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Asset_Type_Sum_Fields = {
  __typename?: 'asset_type_sum_fields';
  rank_id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "asset_type" */
export enum Asset_Type_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  Name = 'name',
  /** column name */
  RankId = 'rank_id',
  /** column name */
  Slug = 'slug'
}

export type Asset_Type_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Asset_Type_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Asset_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Asset_Type_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Asset_Type_Var_Pop_Fields = {
  __typename?: 'asset_type_var_pop_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Asset_Type_Var_Samp_Fields = {
  __typename?: 'asset_type_var_samp_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Asset_Type_Variance_Fields = {
  __typename?: 'asset_type_variance_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

export type AssignTaskInput = {
  category: Scalars['String']['input'];
  customer_order_id: Scalars['uuid']['input'];
  customer_order_item_id: Scalars['uuid']['input'];
  estimate_delivery_date?: InputMaybe<Scalars['timestamp']['input']>;
  is_done_locally: Scalars['Boolean']['input'];
  partner_address_id?: InputMaybe<Scalars['uuid']['input']>;
  shift_schedule_id: Scalars['uuid']['input'];
  shipping_address_id?: InputMaybe<Scalars['uuid']['input']>;
  state: Scalars['String']['input'];
};

export type AssignTaskOutput = {
  __typename?: 'assignTaskOutput';
  customer_order_id: Scalars['uuid']['output'];
  customer_order_item_id: Scalars['uuid']['output'];
  state: Scalars['String']['output'];
  taskId: Scalars['uuid']['output'];
};

/** columns and relationships of "associated_type" */
export type Associated_Type = {
  __typename?: 'associated_type';
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  partners: Array<Partner>;
  /** An aggregate relationship */
  partners_aggregate: Partner_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "associated_type" */
export type Associated_TypePartnersArgs = {
  distinct_on?: InputMaybe<Array<Partner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_By>>;
  where?: InputMaybe<Partner_Bool_Exp>;
};


/** columns and relationships of "associated_type" */
export type Associated_TypePartners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_By>>;
  where?: InputMaybe<Partner_Bool_Exp>;
};

/** aggregated selection of "associated_type" */
export type Associated_Type_Aggregate = {
  __typename?: 'associated_type_aggregate';
  aggregate?: Maybe<Associated_Type_Aggregate_Fields>;
  nodes: Array<Associated_Type>;
};

/** aggregate fields of "associated_type" */
export type Associated_Type_Aggregate_Fields = {
  __typename?: 'associated_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Associated_Type_Max_Fields>;
  min?: Maybe<Associated_Type_Min_Fields>;
};


/** aggregate fields of "associated_type" */
export type Associated_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Associated_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "associated_type". All fields are combined with a logical 'AND'. */
export type Associated_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Associated_Type_Bool_Exp>>;
  _not?: InputMaybe<Associated_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Associated_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  partners?: InputMaybe<Partner_Bool_Exp>;
  partners_aggregate?: InputMaybe<Partner_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "associated_type" */
export enum Associated_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  AssociatedTypePkey = 'associated_type_pkey'
}

export enum Associated_Type_Enum {
  /** ASSURED */
  Assured = 'ASSURED',
  /** NONE */
  None = 'NONE',
  /** TRANSACTIONAL */
  Transactional = 'TRANSACTIONAL'
}

/** Boolean expression to compare columns of type "associated_type_enum". All fields are combined with logical 'AND'. */
export type Associated_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Associated_Type_Enum>;
  _in?: InputMaybe<Array<Associated_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Associated_Type_Enum>;
  _nin?: InputMaybe<Array<Associated_Type_Enum>>;
};

/** input type for inserting data into table "associated_type" */
export type Associated_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  partners?: InputMaybe<Partner_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Associated_Type_Max_Fields = {
  __typename?: 'associated_type_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Associated_Type_Min_Fields = {
  __typename?: 'associated_type_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "associated_type" */
export type Associated_Type_Mutation_Response = {
  __typename?: 'associated_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Associated_Type>;
};

/** input type for inserting object relation for remote table "associated_type" */
export type Associated_Type_Obj_Rel_Insert_Input = {
  data: Associated_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Associated_Type_On_Conflict>;
};

/** on_conflict condition type for table "associated_type" */
export type Associated_Type_On_Conflict = {
  constraint: Associated_Type_Constraint;
  update_columns?: Array<Associated_Type_Update_Column>;
  where?: InputMaybe<Associated_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "associated_type". */
export type Associated_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  partners_aggregate?: InputMaybe<Partner_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: associated_type */
export type Associated_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "associated_type" */
export enum Associated_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "associated_type" */
export type Associated_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "associated_type" */
export type Associated_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Associated_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Associated_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "associated_type" */
export enum Associated_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Associated_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Associated_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Associated_Type_Bool_Exp;
};

export type AttachedRfidWithCustomerAssetInput = {
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  rfId: Scalars['String']['input'];
};

export type AttachedRfidWithCustomerAssetOutput = {
  __typename?: 'attachedRfidWithCustomerAssetOutput';
  response: Scalars['String']['output'];
};

/** columns and relationships of "audit_log_action" */
export type Audit_Log_Action = {
  __typename?: 'audit_log_action';
  /** An array relationship */
  address_subsidiary_audit_logs: Array<Address_Subsidiary_Audit_Logs>;
  /** An aggregate relationship */
  address_subsidiary_audit_logs_aggregate: Address_Subsidiary_Audit_Logs_Aggregate;
  /** An array relationship */
  asset_subsidiary_audit_logs: Array<Asset_Subsidiary_Audit_Logs>;
  /** An aggregate relationship */
  asset_subsidiary_audit_logs_aggregate: Asset_Subsidiary_Audit_Logs_Aggregate;
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};


/** columns and relationships of "audit_log_action" */
export type Audit_Log_ActionAddress_Subsidiary_Audit_LogsArgs = {
  distinct_on?: InputMaybe<Array<Address_Subsidiary_Audit_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Address_Subsidiary_Audit_Logs_Order_By>>;
  where?: InputMaybe<Address_Subsidiary_Audit_Logs_Bool_Exp>;
};


/** columns and relationships of "audit_log_action" */
export type Audit_Log_ActionAddress_Subsidiary_Audit_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Subsidiary_Audit_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Address_Subsidiary_Audit_Logs_Order_By>>;
  where?: InputMaybe<Address_Subsidiary_Audit_Logs_Bool_Exp>;
};


/** columns and relationships of "audit_log_action" */
export type Audit_Log_ActionAsset_Subsidiary_Audit_LogsArgs = {
  distinct_on?: InputMaybe<Array<Asset_Subsidiary_Audit_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Subsidiary_Audit_Logs_Order_By>>;
  where?: InputMaybe<Asset_Subsidiary_Audit_Logs_Bool_Exp>;
};


/** columns and relationships of "audit_log_action" */
export type Audit_Log_ActionAsset_Subsidiary_Audit_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Subsidiary_Audit_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Subsidiary_Audit_Logs_Order_By>>;
  where?: InputMaybe<Asset_Subsidiary_Audit_Logs_Bool_Exp>;
};

/** aggregated selection of "audit_log_action" */
export type Audit_Log_Action_Aggregate = {
  __typename?: 'audit_log_action_aggregate';
  aggregate?: Maybe<Audit_Log_Action_Aggregate_Fields>;
  nodes: Array<Audit_Log_Action>;
};

/** aggregate fields of "audit_log_action" */
export type Audit_Log_Action_Aggregate_Fields = {
  __typename?: 'audit_log_action_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Audit_Log_Action_Max_Fields>;
  min?: Maybe<Audit_Log_Action_Min_Fields>;
};


/** aggregate fields of "audit_log_action" */
export type Audit_Log_Action_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Audit_Log_Action_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "audit_log_action". All fields are combined with a logical 'AND'. */
export type Audit_Log_Action_Bool_Exp = {
  _and?: InputMaybe<Array<Audit_Log_Action_Bool_Exp>>;
  _not?: InputMaybe<Audit_Log_Action_Bool_Exp>;
  _or?: InputMaybe<Array<Audit_Log_Action_Bool_Exp>>;
  address_subsidiary_audit_logs?: InputMaybe<Address_Subsidiary_Audit_Logs_Bool_Exp>;
  address_subsidiary_audit_logs_aggregate?: InputMaybe<Address_Subsidiary_Audit_Logs_Aggregate_Bool_Exp>;
  asset_subsidiary_audit_logs?: InputMaybe<Asset_Subsidiary_Audit_Logs_Bool_Exp>;
  asset_subsidiary_audit_logs_aggregate?: InputMaybe<Asset_Subsidiary_Audit_Logs_Aggregate_Bool_Exp>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "audit_log_action" */
export enum Audit_Log_Action_Constraint {
  /** unique or primary key constraint on columns "value" */
  AuditLogActionPkey = 'audit_log_action_pkey'
}

export enum Audit_Log_Action_Enum {
  /** ACTIVATED */
  Activated = 'ACTIVATED',
  /** DEACTIVATED */
  Deactivated = 'DEACTIVATED',
  /** INSERT */
  Insert = 'INSERT',
  /** Department mapping closed/shifted to a new interval (SCD-2), not voided */
  Superseded = 'SUPERSEDED'
}

/** Boolean expression to compare columns of type "audit_log_action_enum". All fields are combined with logical 'AND'. */
export type Audit_Log_Action_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Audit_Log_Action_Enum>;
  _in?: InputMaybe<Array<Audit_Log_Action_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Audit_Log_Action_Enum>;
  _nin?: InputMaybe<Array<Audit_Log_Action_Enum>>;
};

/** input type for inserting data into table "audit_log_action" */
export type Audit_Log_Action_Insert_Input = {
  address_subsidiary_audit_logs?: InputMaybe<Address_Subsidiary_Audit_Logs_Arr_Rel_Insert_Input>;
  asset_subsidiary_audit_logs?: InputMaybe<Asset_Subsidiary_Audit_Logs_Arr_Rel_Insert_Input>;
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Audit_Log_Action_Max_Fields = {
  __typename?: 'audit_log_action_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Audit_Log_Action_Min_Fields = {
  __typename?: 'audit_log_action_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "audit_log_action" */
export type Audit_Log_Action_Mutation_Response = {
  __typename?: 'audit_log_action_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Audit_Log_Action>;
};

/** input type for inserting object relation for remote table "audit_log_action" */
export type Audit_Log_Action_Obj_Rel_Insert_Input = {
  data: Audit_Log_Action_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Audit_Log_Action_On_Conflict>;
};

/** on_conflict condition type for table "audit_log_action" */
export type Audit_Log_Action_On_Conflict = {
  constraint: Audit_Log_Action_Constraint;
  update_columns?: Array<Audit_Log_Action_Update_Column>;
  where?: InputMaybe<Audit_Log_Action_Bool_Exp>;
};

/** Ordering options when selecting data from "audit_log_action". */
export type Audit_Log_Action_Order_By = {
  address_subsidiary_audit_logs_aggregate?: InputMaybe<Address_Subsidiary_Audit_Logs_Aggregate_Order_By>;
  asset_subsidiary_audit_logs_aggregate?: InputMaybe<Asset_Subsidiary_Audit_Logs_Aggregate_Order_By>;
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: audit_log_action */
export type Audit_Log_Action_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "audit_log_action" */
export enum Audit_Log_Action_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "audit_log_action" */
export type Audit_Log_Action_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "audit_log_action" */
export type Audit_Log_Action_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Audit_Log_Action_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Audit_Log_Action_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "audit_log_action" */
export enum Audit_Log_Action_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Audit_Log_Action_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Audit_Log_Action_Set_Input>;
  /** filter the rows which have to be updated */
  where: Audit_Log_Action_Bool_Exp;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

export type Block_Wallet_Amount_Args = {
  p_amount?: InputMaybe<Scalars['numeric']['input']>;
  p_org_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "cancellation_reasons" */
export type Cancellation_Reasons = {
  __typename?: 'cancellation_reasons';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  customer_order_cancellation_reasons: Array<Customer_Order_Cancellation_Reasons>;
  /** An aggregate relationship */
  customer_order_cancellation_reasons_aggregate: Customer_Order_Cancellation_Reasons_Aggregate;
  /** An array relationship */
  customer_order_item_etd_transactional_logs: Array<Customer_Order_Item_Etd_Transactional_Logs>;
  /** An aggregate relationship */
  customer_order_item_etd_transactional_logs_aggregate: Customer_Order_Item_Etd_Transactional_Logs_Aggregate;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  rank_id?: Maybe<Scalars['Int']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  reasonTypeByReasonType: Reason_Type;
  reason_type: Reason_Type_Enum;
};


/** columns and relationships of "cancellation_reasons" */
export type Cancellation_ReasonsCustomer_Order_Cancellation_ReasonsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Cancellation_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Cancellation_Reasons_Order_By>>;
  where?: InputMaybe<Customer_Order_Cancellation_Reasons_Bool_Exp>;
};


/** columns and relationships of "cancellation_reasons" */
export type Cancellation_ReasonsCustomer_Order_Cancellation_Reasons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Cancellation_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Cancellation_Reasons_Order_By>>;
  where?: InputMaybe<Customer_Order_Cancellation_Reasons_Bool_Exp>;
};


/** columns and relationships of "cancellation_reasons" */
export type Cancellation_ReasonsCustomer_Order_Item_Etd_Transactional_LogsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Etd_Transactional_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Etd_Transactional_Logs_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Etd_Transactional_Logs_Bool_Exp>;
};


/** columns and relationships of "cancellation_reasons" */
export type Cancellation_ReasonsCustomer_Order_Item_Etd_Transactional_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Etd_Transactional_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Etd_Transactional_Logs_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Etd_Transactional_Logs_Bool_Exp>;
};

/** aggregated selection of "cancellation_reasons" */
export type Cancellation_Reasons_Aggregate = {
  __typename?: 'cancellation_reasons_aggregate';
  aggregate?: Maybe<Cancellation_Reasons_Aggregate_Fields>;
  nodes: Array<Cancellation_Reasons>;
};

export type Cancellation_Reasons_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Cancellation_Reasons_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Cancellation_Reasons_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Cancellation_Reasons_Aggregate_Bool_Exp_Count>;
};

export type Cancellation_Reasons_Aggregate_Bool_Exp_Bool_And = {
  arguments: Cancellation_Reasons_Select_Column_Cancellation_Reasons_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Cancellation_Reasons_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Cancellation_Reasons_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Cancellation_Reasons_Select_Column_Cancellation_Reasons_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Cancellation_Reasons_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Cancellation_Reasons_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Cancellation_Reasons_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Cancellation_Reasons_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "cancellation_reasons" */
export type Cancellation_Reasons_Aggregate_Fields = {
  __typename?: 'cancellation_reasons_aggregate_fields';
  avg?: Maybe<Cancellation_Reasons_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Cancellation_Reasons_Max_Fields>;
  min?: Maybe<Cancellation_Reasons_Min_Fields>;
  stddev?: Maybe<Cancellation_Reasons_Stddev_Fields>;
  stddev_pop?: Maybe<Cancellation_Reasons_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Cancellation_Reasons_Stddev_Samp_Fields>;
  sum?: Maybe<Cancellation_Reasons_Sum_Fields>;
  var_pop?: Maybe<Cancellation_Reasons_Var_Pop_Fields>;
  var_samp?: Maybe<Cancellation_Reasons_Var_Samp_Fields>;
  variance?: Maybe<Cancellation_Reasons_Variance_Fields>;
};


/** aggregate fields of "cancellation_reasons" */
export type Cancellation_Reasons_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cancellation_Reasons_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "cancellation_reasons" */
export type Cancellation_Reasons_Aggregate_Order_By = {
  avg?: InputMaybe<Cancellation_Reasons_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Cancellation_Reasons_Max_Order_By>;
  min?: InputMaybe<Cancellation_Reasons_Min_Order_By>;
  stddev?: InputMaybe<Cancellation_Reasons_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Cancellation_Reasons_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Cancellation_Reasons_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Cancellation_Reasons_Sum_Order_By>;
  var_pop?: InputMaybe<Cancellation_Reasons_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Cancellation_Reasons_Var_Samp_Order_By>;
  variance?: InputMaybe<Cancellation_Reasons_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "cancellation_reasons" */
export type Cancellation_Reasons_Arr_Rel_Insert_Input = {
  data: Array<Cancellation_Reasons_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Cancellation_Reasons_On_Conflict>;
};

/** aggregate avg on columns */
export type Cancellation_Reasons_Avg_Fields = {
  __typename?: 'cancellation_reasons_avg_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "cancellation_reasons" */
export type Cancellation_Reasons_Avg_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "cancellation_reasons". All fields are combined with a logical 'AND'. */
export type Cancellation_Reasons_Bool_Exp = {
  _and?: InputMaybe<Array<Cancellation_Reasons_Bool_Exp>>;
  _not?: InputMaybe<Cancellation_Reasons_Bool_Exp>;
  _or?: InputMaybe<Array<Cancellation_Reasons_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_order_cancellation_reasons?: InputMaybe<Customer_Order_Cancellation_Reasons_Bool_Exp>;
  customer_order_cancellation_reasons_aggregate?: InputMaybe<Customer_Order_Cancellation_Reasons_Aggregate_Bool_Exp>;
  customer_order_item_etd_transactional_logs?: InputMaybe<Customer_Order_Item_Etd_Transactional_Logs_Bool_Exp>;
  customer_order_item_etd_transactional_logs_aggregate?: InputMaybe<Customer_Order_Item_Etd_Transactional_Logs_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  rank_id?: InputMaybe<Int_Comparison_Exp>;
  reason?: InputMaybe<String_Comparison_Exp>;
  reasonTypeByReasonType?: InputMaybe<Reason_Type_Bool_Exp>;
  reason_type?: InputMaybe<Reason_Type_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "cancellation_reasons" */
export enum Cancellation_Reasons_Constraint {
  /** unique or primary key constraint on columns "id" */
  CancellationReasonsPkey = 'cancellation_reasons_pkey'
}

/** input type for incrementing numeric columns in table "cancellation_reasons" */
export type Cancellation_Reasons_Inc_Input = {
  rank_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "cancellation_reasons" */
export type Cancellation_Reasons_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_cancellation_reasons?: InputMaybe<Customer_Order_Cancellation_Reasons_Arr_Rel_Insert_Input>;
  customer_order_item_etd_transactional_logs?: InputMaybe<Customer_Order_Item_Etd_Transactional_Logs_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  rank_id?: InputMaybe<Scalars['Int']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  reasonTypeByReasonType?: InputMaybe<Reason_Type_Obj_Rel_Insert_Input>;
  reason_type?: InputMaybe<Reason_Type_Enum>;
};

/** aggregate max on columns */
export type Cancellation_Reasons_Max_Fields = {
  __typename?: 'cancellation_reasons_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  rank_id?: Maybe<Scalars['Int']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "cancellation_reasons" */
export type Cancellation_Reasons_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  rank_id?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Cancellation_Reasons_Min_Fields = {
  __typename?: 'cancellation_reasons_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  rank_id?: Maybe<Scalars['Int']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "cancellation_reasons" */
export type Cancellation_Reasons_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  rank_id?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "cancellation_reasons" */
export type Cancellation_Reasons_Mutation_Response = {
  __typename?: 'cancellation_reasons_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Cancellation_Reasons>;
};

/** input type for inserting object relation for remote table "cancellation_reasons" */
export type Cancellation_Reasons_Obj_Rel_Insert_Input = {
  data: Cancellation_Reasons_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Cancellation_Reasons_On_Conflict>;
};

/** on_conflict condition type for table "cancellation_reasons" */
export type Cancellation_Reasons_On_Conflict = {
  constraint: Cancellation_Reasons_Constraint;
  update_columns?: Array<Cancellation_Reasons_Update_Column>;
  where?: InputMaybe<Cancellation_Reasons_Bool_Exp>;
};

/** Ordering options when selecting data from "cancellation_reasons". */
export type Cancellation_Reasons_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_order_cancellation_reasons_aggregate?: InputMaybe<Customer_Order_Cancellation_Reasons_Aggregate_Order_By>;
  customer_order_item_etd_transactional_logs_aggregate?: InputMaybe<Customer_Order_Item_Etd_Transactional_Logs_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  rank_id?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  reasonTypeByReasonType?: InputMaybe<Reason_Type_Order_By>;
  reason_type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cancellation_reasons */
export type Cancellation_Reasons_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "cancellation_reasons" */
export enum Cancellation_Reasons_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  RankId = 'rank_id',
  /** column name */
  Reason = 'reason',
  /** column name */
  ReasonType = 'reason_type'
}

/** select "cancellation_reasons_aggregate_bool_exp_bool_and_arguments_columns" columns of table "cancellation_reasons" */
export enum Cancellation_Reasons_Select_Column_Cancellation_Reasons_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "cancellation_reasons_aggregate_bool_exp_bool_or_arguments_columns" columns of table "cancellation_reasons" */
export enum Cancellation_Reasons_Select_Column_Cancellation_Reasons_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "cancellation_reasons" */
export type Cancellation_Reasons_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  rank_id?: InputMaybe<Scalars['Int']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  reason_type?: InputMaybe<Reason_Type_Enum>;
};

/** aggregate stddev on columns */
export type Cancellation_Reasons_Stddev_Fields = {
  __typename?: 'cancellation_reasons_stddev_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "cancellation_reasons" */
export type Cancellation_Reasons_Stddev_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Cancellation_Reasons_Stddev_Pop_Fields = {
  __typename?: 'cancellation_reasons_stddev_pop_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "cancellation_reasons" */
export type Cancellation_Reasons_Stddev_Pop_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Cancellation_Reasons_Stddev_Samp_Fields = {
  __typename?: 'cancellation_reasons_stddev_samp_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "cancellation_reasons" */
export type Cancellation_Reasons_Stddev_Samp_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "cancellation_reasons" */
export type Cancellation_Reasons_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cancellation_Reasons_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cancellation_Reasons_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  rank_id?: InputMaybe<Scalars['Int']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  reason_type?: InputMaybe<Reason_Type_Enum>;
};

/** aggregate sum on columns */
export type Cancellation_Reasons_Sum_Fields = {
  __typename?: 'cancellation_reasons_sum_fields';
  rank_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "cancellation_reasons" */
export type Cancellation_Reasons_Sum_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** update columns of table "cancellation_reasons" */
export enum Cancellation_Reasons_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  RankId = 'rank_id',
  /** column name */
  Reason = 'reason',
  /** column name */
  ReasonType = 'reason_type'
}

export type Cancellation_Reasons_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Cancellation_Reasons_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cancellation_Reasons_Set_Input>;
  /** filter the rows which have to be updated */
  where: Cancellation_Reasons_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Cancellation_Reasons_Var_Pop_Fields = {
  __typename?: 'cancellation_reasons_var_pop_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "cancellation_reasons" */
export type Cancellation_Reasons_Var_Pop_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Cancellation_Reasons_Var_Samp_Fields = {
  __typename?: 'cancellation_reasons_var_samp_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "cancellation_reasons" */
export type Cancellation_Reasons_Var_Samp_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Cancellation_Reasons_Variance_Fields = {
  __typename?: 'cancellation_reasons_variance_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "cancellation_reasons" */
export type Cancellation_Reasons_Variance_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "category" */
export type Category = {
  __typename?: 'category';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description: Scalars['String']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  is_available_mobile: Scalars['Boolean']['output'];
  is_available_web: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name: Scalars['String']['output'];
  photo?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  products: Array<Product>;
  /** An aggregate relationship */
  products_aggregate: Product_Aggregate;
  /** An array relationship */
  services_categories: Array<Services_Category>;
  /** An aggregate relationship */
  services_categories_aggregate: Services_Category_Aggregate;
  slug: Scalars['String']['output'];
};


/** columns and relationships of "category" */
export type CategoryProductsArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


/** columns and relationships of "category" */
export type CategoryProducts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


/** columns and relationships of "category" */
export type CategoryServices_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Services_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Services_Category_Order_By>>;
  where?: InputMaybe<Services_Category_Bool_Exp>;
};


/** columns and relationships of "category" */
export type CategoryServices_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Services_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Services_Category_Order_By>>;
  where?: InputMaybe<Services_Category_Bool_Exp>;
};

/** aggregated selection of "category" */
export type Category_Aggregate = {
  __typename?: 'category_aggregate';
  aggregate?: Maybe<Category_Aggregate_Fields>;
  nodes: Array<Category>;
};

/** aggregate fields of "category" */
export type Category_Aggregate_Fields = {
  __typename?: 'category_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Category_Max_Fields>;
  min?: Maybe<Category_Min_Fields>;
};


/** aggregate fields of "category" */
export type Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "category". All fields are combined with a logical 'AND'. */
export type Category_Bool_Exp = {
  _and?: InputMaybe<Array<Category_Bool_Exp>>;
  _not?: InputMaybe<Category_Bool_Exp>;
  _or?: InputMaybe<Array<Category_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  icon?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_available_mobile?: InputMaybe<Boolean_Comparison_Exp>;
  is_available_web?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<String_Comparison_Exp>;
  products?: InputMaybe<Product_Bool_Exp>;
  products_aggregate?: InputMaybe<Product_Aggregate_Bool_Exp>;
  services_categories?: InputMaybe<Services_Category_Bool_Exp>;
  services_categories_aggregate?: InputMaybe<Services_Category_Aggregate_Bool_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "category" */
export enum Category_Constraint {
  /** unique or primary key constraint on columns "id" */
  CategoryPkey = 'category_pkey'
}

/** input type for inserting data into table "category" */
export type Category_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_available_mobile?: InputMaybe<Scalars['Boolean']['input']>;
  is_available_web?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Product_Arr_Rel_Insert_Input>;
  services_categories?: InputMaybe<Services_Category_Arr_Rel_Insert_Input>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Category_Max_Fields = {
  __typename?: 'category_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Category_Min_Fields = {
  __typename?: 'category_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "category" */
export type Category_Mutation_Response = {
  __typename?: 'category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Category>;
};

/** input type for inserting object relation for remote table "category" */
export type Category_Obj_Rel_Insert_Input = {
  data: Category_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Category_On_Conflict>;
};

/** on_conflict condition type for table "category" */
export type Category_On_Conflict = {
  constraint: Category_Constraint;
  update_columns?: Array<Category_Update_Column>;
  where?: InputMaybe<Category_Bool_Exp>;
};

/** Ordering options when selecting data from "category". */
export type Category_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  icon?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_available_mobile?: InputMaybe<Order_By>;
  is_available_web?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photo?: InputMaybe<Order_By>;
  products_aggregate?: InputMaybe<Product_Aggregate_Order_By>;
  services_categories_aggregate?: InputMaybe<Services_Category_Aggregate_Order_By>;
  slug?: InputMaybe<Order_By>;
};

/** primary key columns input for table: category */
export type Category_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "category" */
export enum Category_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsAvailableMobile = 'is_available_mobile',
  /** column name */
  IsAvailableWeb = 'is_available_web',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  Photo = 'photo',
  /** column name */
  Slug = 'slug'
}

/** input type for updating data in table "category" */
export type Category_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_available_mobile?: InputMaybe<Scalars['Boolean']['input']>;
  is_available_web?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "category" */
export type Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Category_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_available_mobile?: InputMaybe<Scalars['Boolean']['input']>;
  is_available_web?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "category" */
export enum Category_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsAvailableMobile = 'is_available_mobile',
  /** column name */
  IsAvailableWeb = 'is_available_web',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  Photo = 'photo',
  /** column name */
  Slug = 'slug'
}

export type Category_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Category_Set_Input>;
  /** filter the rows which have to be updated */
  where: Category_Bool_Exp;
};

export type CheckWalletAmountExitsInput = {
  amount: Scalars['numeric']['input'];
  organization_id: Scalars['uuid']['input'];
};

export type CheckWalletAmountExitsOutput = {
  __typename?: 'checkWalletAmountExitsOutput';
  amount?: Maybe<Scalars['numeric']['output']>;
  is_amount_available?: Maybe<Scalars['Boolean']['output']>;
  organization_id: Scalars['uuid']['output'];
  wallet_exists?: Maybe<Scalars['Boolean']['output']>;
  wallet_id?: Maybe<Scalars['uuid']['output']>;
};

/** columns and relationships of "city" */
export type City = {
  __typename?: 'city';
  code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  organization_addresses: Array<Organization_Address>;
  /** An aggregate relationship */
  organization_addresses_aggregate: Organization_Address_Aggregate;
  /** An object relationship */
  state: State;
  state_id: Scalars['uuid']['output'];
};


/** columns and relationships of "city" */
export type CityOrganization_AddressesArgs = {
  distinct_on?: InputMaybe<Array<Organization_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Address_Order_By>>;
  where?: InputMaybe<Organization_Address_Bool_Exp>;
};


/** columns and relationships of "city" */
export type CityOrganization_Addresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Address_Order_By>>;
  where?: InputMaybe<Organization_Address_Bool_Exp>;
};

/** aggregated selection of "city" */
export type City_Aggregate = {
  __typename?: 'city_aggregate';
  aggregate?: Maybe<City_Aggregate_Fields>;
  nodes: Array<City>;
};

export type City_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<City_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<City_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<City_Aggregate_Bool_Exp_Count>;
};

export type City_Aggregate_Bool_Exp_Bool_And = {
  arguments: City_Select_Column_City_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<City_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type City_Aggregate_Bool_Exp_Bool_Or = {
  arguments: City_Select_Column_City_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<City_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type City_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<City_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<City_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "city" */
export type City_Aggregate_Fields = {
  __typename?: 'city_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<City_Max_Fields>;
  min?: Maybe<City_Min_Fields>;
};


/** aggregate fields of "city" */
export type City_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<City_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "city" */
export type City_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<City_Max_Order_By>;
  min?: InputMaybe<City_Min_Order_By>;
};

/** input type for inserting array relation for remote table "city" */
export type City_Arr_Rel_Insert_Input = {
  data: Array<City_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<City_On_Conflict>;
};

/** Boolean expression to filter rows from the table "city". All fields are combined with a logical 'AND'. */
export type City_Bool_Exp = {
  _and?: InputMaybe<Array<City_Bool_Exp>>;
  _not?: InputMaybe<City_Bool_Exp>;
  _or?: InputMaybe<Array<City_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  district?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization_addresses?: InputMaybe<Organization_Address_Bool_Exp>;
  organization_addresses_aggregate?: InputMaybe<Organization_Address_Aggregate_Bool_Exp>;
  state?: InputMaybe<State_Bool_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "city" */
export enum City_Constraint {
  /** unique or primary key constraint on columns "id" */
  CityPkey = 'city_pkey'
}

/** input type for inserting data into table "city" */
export type City_Insert_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_addresses?: InputMaybe<Organization_Address_Arr_Rel_Insert_Input>;
  state?: InputMaybe<State_Obj_Rel_Insert_Input>;
  state_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type City_Max_Fields = {
  __typename?: 'city_max_fields';
  code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "city" */
export type City_Max_Order_By = {
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  district?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type City_Min_Fields = {
  __typename?: 'city_min_fields';
  code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "city" */
export type City_Min_Order_By = {
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  district?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "city" */
export type City_Mutation_Response = {
  __typename?: 'city_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<City>;
};

/** input type for inserting object relation for remote table "city" */
export type City_Obj_Rel_Insert_Input = {
  data: City_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<City_On_Conflict>;
};

/** on_conflict condition type for table "city" */
export type City_On_Conflict = {
  constraint: City_Constraint;
  update_columns?: Array<City_Update_Column>;
  where?: InputMaybe<City_Bool_Exp>;
};

/** Ordering options when selecting data from "city". */
export type City_Order_By = {
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  district?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_addresses_aggregate?: InputMaybe<Organization_Address_Aggregate_Order_By>;
  state?: InputMaybe<State_Order_By>;
  state_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: city */
export type City_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "city" */
export enum City_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  District = 'district',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  StateId = 'state_id'
}

/** select "city_aggregate_bool_exp_bool_and_arguments_columns" columns of table "city" */
export enum City_Select_Column_City_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "city_aggregate_bool_exp_bool_or_arguments_columns" columns of table "city" */
export enum City_Select_Column_City_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "city" */
export type City_Set_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  state_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "city" */
export type City_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: City_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type City_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  state_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "city" */
export enum City_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  District = 'district',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  StateId = 'state_id'
}

export type City_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<City_Set_Input>;
  /** filter the rows which have to be updated */
  where: City_Bool_Exp;
};

export type CorrectLedgerEntryInput = {
  ledger_entry_id: Scalars['uuid']['input'];
  new_amount: Scalars['numeric']['input'];
  notes: Scalars['String']['input'];
  posting_date?: InputMaybe<Scalars['String']['input']>;
};

export type CorrectLedgerEntryOutput = {
  __typename?: 'correctLedgerEntryOutput';
  new_entry_id?: Maybe<Scalars['uuid']['output']>;
  new_line_item_type?: Maybe<Scalars['String']['output']>;
  new_payment_type?: Maybe<Scalars['String']['output']>;
  new_wallet_balance: Scalars['numeric']['output'];
  old_entry_id: Scalars['uuid']['output'];
  type_changed: Scalars['Boolean']['output'];
};

/** columns and relationships of "country" */
export type Country = {
  __typename?: 'country';
  alpha_code2?: Maybe<Scalars['String']['output']>;
  alpha_code3?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numeric_code_id?: Maybe<Scalars['Int']['output']>;
  official_state?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  organization_addresses: Array<Organization_Address>;
  /** An aggregate relationship */
  organization_addresses_aggregate: Organization_Address_Aggregate;
  /** An array relationship */
  states: Array<State>;
  /** An aggregate relationship */
  states_aggregate: State_Aggregate;
};


/** columns and relationships of "country" */
export type CountryOrganization_AddressesArgs = {
  distinct_on?: InputMaybe<Array<Organization_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Address_Order_By>>;
  where?: InputMaybe<Organization_Address_Bool_Exp>;
};


/** columns and relationships of "country" */
export type CountryOrganization_Addresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Address_Order_By>>;
  where?: InputMaybe<Organization_Address_Bool_Exp>;
};


/** columns and relationships of "country" */
export type CountryStatesArgs = {
  distinct_on?: InputMaybe<Array<State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<State_Order_By>>;
  where?: InputMaybe<State_Bool_Exp>;
};


/** columns and relationships of "country" */
export type CountryStates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<State_Order_By>>;
  where?: InputMaybe<State_Bool_Exp>;
};

/** aggregated selection of "country" */
export type Country_Aggregate = {
  __typename?: 'country_aggregate';
  aggregate?: Maybe<Country_Aggregate_Fields>;
  nodes: Array<Country>;
};

/** aggregate fields of "country" */
export type Country_Aggregate_Fields = {
  __typename?: 'country_aggregate_fields';
  avg?: Maybe<Country_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Country_Max_Fields>;
  min?: Maybe<Country_Min_Fields>;
  stddev?: Maybe<Country_Stddev_Fields>;
  stddev_pop?: Maybe<Country_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Country_Stddev_Samp_Fields>;
  sum?: Maybe<Country_Sum_Fields>;
  var_pop?: Maybe<Country_Var_Pop_Fields>;
  var_samp?: Maybe<Country_Var_Samp_Fields>;
  variance?: Maybe<Country_Variance_Fields>;
};


/** aggregate fields of "country" */
export type Country_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Country_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Country_Avg_Fields = {
  __typename?: 'country_avg_fields';
  numeric_code_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "country". All fields are combined with a logical 'AND'. */
export type Country_Bool_Exp = {
  _and?: InputMaybe<Array<Country_Bool_Exp>>;
  _not?: InputMaybe<Country_Bool_Exp>;
  _or?: InputMaybe<Array<Country_Bool_Exp>>;
  alpha_code2?: InputMaybe<String_Comparison_Exp>;
  alpha_code3?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  numeric_code_id?: InputMaybe<Int_Comparison_Exp>;
  official_state?: InputMaybe<String_Comparison_Exp>;
  organization_addresses?: InputMaybe<Organization_Address_Bool_Exp>;
  organization_addresses_aggregate?: InputMaybe<Organization_Address_Aggregate_Bool_Exp>;
  states?: InputMaybe<State_Bool_Exp>;
  states_aggregate?: InputMaybe<State_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "country" */
export enum Country_Constraint {
  /** unique or primary key constraint on columns "id" */
  CountryPkey = 'country_pkey'
}

/** input type for incrementing numeric columns in table "country" */
export type Country_Inc_Input = {
  numeric_code_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "country" */
export type Country_Insert_Input = {
  alpha_code2?: InputMaybe<Scalars['String']['input']>;
  alpha_code3?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  numeric_code_id?: InputMaybe<Scalars['Int']['input']>;
  official_state?: InputMaybe<Scalars['String']['input']>;
  organization_addresses?: InputMaybe<Organization_Address_Arr_Rel_Insert_Input>;
  states?: InputMaybe<State_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Country_Max_Fields = {
  __typename?: 'country_max_fields';
  alpha_code2?: Maybe<Scalars['String']['output']>;
  alpha_code3?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numeric_code_id?: Maybe<Scalars['Int']['output']>;
  official_state?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Country_Min_Fields = {
  __typename?: 'country_min_fields';
  alpha_code2?: Maybe<Scalars['String']['output']>;
  alpha_code3?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numeric_code_id?: Maybe<Scalars['Int']['output']>;
  official_state?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "country" */
export type Country_Mutation_Response = {
  __typename?: 'country_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Country>;
};

/** input type for inserting object relation for remote table "country" */
export type Country_Obj_Rel_Insert_Input = {
  data: Country_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Country_On_Conflict>;
};

/** on_conflict condition type for table "country" */
export type Country_On_Conflict = {
  constraint: Country_Constraint;
  update_columns?: Array<Country_Update_Column>;
  where?: InputMaybe<Country_Bool_Exp>;
};

/** Ordering options when selecting data from "country". */
export type Country_Order_By = {
  alpha_code2?: InputMaybe<Order_By>;
  alpha_code3?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  numeric_code_id?: InputMaybe<Order_By>;
  official_state?: InputMaybe<Order_By>;
  organization_addresses_aggregate?: InputMaybe<Organization_Address_Aggregate_Order_By>;
  states_aggregate?: InputMaybe<State_Aggregate_Order_By>;
};

/** primary key columns input for table: country */
export type Country_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "country" */
export enum Country_Select_Column {
  /** column name */
  AlphaCode2 = 'alpha_code2',
  /** column name */
  AlphaCode3 = 'alpha_code3',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  NumericCodeId = 'numeric_code_id',
  /** column name */
  OfficialState = 'official_state'
}

/** input type for updating data in table "country" */
export type Country_Set_Input = {
  alpha_code2?: InputMaybe<Scalars['String']['input']>;
  alpha_code3?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  numeric_code_id?: InputMaybe<Scalars['Int']['input']>;
  official_state?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Country_Stddev_Fields = {
  __typename?: 'country_stddev_fields';
  numeric_code_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Country_Stddev_Pop_Fields = {
  __typename?: 'country_stddev_pop_fields';
  numeric_code_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Country_Stddev_Samp_Fields = {
  __typename?: 'country_stddev_samp_fields';
  numeric_code_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "country" */
export type Country_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Country_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Country_Stream_Cursor_Value_Input = {
  alpha_code2?: InputMaybe<Scalars['String']['input']>;
  alpha_code3?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  numeric_code_id?: InputMaybe<Scalars['Int']['input']>;
  official_state?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Country_Sum_Fields = {
  __typename?: 'country_sum_fields';
  numeric_code_id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "country" */
export enum Country_Update_Column {
  /** column name */
  AlphaCode2 = 'alpha_code2',
  /** column name */
  AlphaCode3 = 'alpha_code3',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  NumericCodeId = 'numeric_code_id',
  /** column name */
  OfficialState = 'official_state'
}

export type Country_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Country_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Country_Set_Input>;
  /** filter the rows which have to be updated */
  where: Country_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Country_Var_Pop_Fields = {
  __typename?: 'country_var_pop_fields';
  numeric_code_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Country_Var_Samp_Fields = {
  __typename?: 'country_var_samp_fields';
  numeric_code_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Country_Variance_Fields = {
  __typename?: 'country_variance_fields';
  numeric_code_id?: Maybe<Scalars['Float']['output']>;
};

export type CreateAdocCustomerOrderInput = {
  billing_address_id: Scalars['uuid']['input'];
  customer_assets?: InputMaybe<Array<CustomerAssetWithReqQty>>;
  end_time: Scalars['timestamptz']['input'];
  organization_user_id: Scalars['uuid']['input'];
  partner_id: Scalars['uuid']['input'];
  poc_details?: InputMaybe<Scalars['String']['input']>;
  poc_number?: InputMaybe<Scalars['String']['input']>;
  product_variation_id: Scalars['uuid']['input'];
  qty: Scalars['numeric']['input'];
  requirements?: InputMaybe<Scalars['String']['input']>;
  shipping_address_id: Scalars['uuid']['input'];
  start_time: Scalars['timestamptz']['input'];
};

export type CreateAdocCustomerOrderOutput = {
  __typename?: 'createAdocCustomerOrderOutput';
  data?: Maybe<Scalars['jsonb']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CreateBulkOrderInput = {
  billing_address_id: Scalars['uuid']['input'];
  organization_user_id: Scalars['uuid']['input'];
  partner_id: Scalars['uuid']['input'];
  partner_localities_id: Scalars['uuid']['input'];
  poc_details?: InputMaybe<Scalars['String']['input']>;
  poc_number?: InputMaybe<Scalars['String']['input']>;
  product_variation_id: Scalars['uuid']['input'];
  shipping_address_id: Scalars['uuid']['input'];
  slots: Array<InputMaybe<SlotsInput>>;
  total_monthly_qty: Scalars['numeric']['input'];
};

export type CreateBulkOrderOutput = {
  __typename?: 'createBulkOrderOutput';
  data?: Maybe<Scalars['jsonb']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CreateBulkShiftScheduleInput = {
  days?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dispenser_assignments?: InputMaybe<Array<InputMaybe<DispenserAssignmentInput>>>;
  end_date_time: Scalars['timestamp']['input'];
  start_date_time: Scalars['timestamp']['input'];
  vehicle_id: Scalars['uuid']['input'];
};

export type CreateBulkShiftScheduleOutput = {
  __typename?: 'createBulkShiftScheduleOutput';
  data?: Maybe<Scalars['jsonb']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CreateDeliveryInvoiceInput = {
  task_id: Scalars['uuid']['input'];
};

export type CreateDeliveryInvoiceOutput = {
  __typename?: 'createDeliveryInvoiceOutput';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['jsonb']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CreateGrnInput = {
  qty: Scalars['Float']['input'];
  supplier: Scalars['String']['input'];
  warehouse: Scalars['String']['input'];
};

export type CreateGrnOutput = {
  __typename?: 'createGrnOutput';
  code?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Scalars['jsonb']['output']>;
  message: Scalars['String']['output'];
};

export type CreateStockEntryInput = {
  qty: Scalars['Float']['input'];
  source_warehouse: Scalars['String']['input'];
  target_warehouse?: InputMaybe<Scalars['String']['input']>;
  transfer_type: Scalars['String']['input'];
};

export type CreateStockEntryOutput = {
  __typename?: 'createStockEntryOutput';
  code?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Scalars['jsonb']['output']>;
  message: Scalars['String']['output'];
};

export type CreateTaskValueInput = {
  customer_asset_id: Scalars['uuid']['input'];
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  location?: InputMaybe<Scalars['point']['input']>;
  quantity_dispensed?: InputMaybe<Scalars['numeric']['input']>;
  reason_id?: InputMaybe<Scalars['String']['input']>;
  session_id: Scalars['uuid']['input'];
  task_id: Scalars['uuid']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type CreateTaskValueOuput = {
  __typename?: 'createTaskValueOuput';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['jsonb']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

/** columns and relationships of "credit_breach" */
export type Credit_Breach = {
  __typename?: 'credit_breach';
  addition_credit_limit?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  limit_expire?: Maybe<Scalars['timestamp']['output']>;
  limit_start?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  organization: Organization;
  organization_id: Scalars['uuid']['output'];
};

/** aggregated selection of "credit_breach" */
export type Credit_Breach_Aggregate = {
  __typename?: 'credit_breach_aggregate';
  aggregate?: Maybe<Credit_Breach_Aggregate_Fields>;
  nodes: Array<Credit_Breach>;
};

export type Credit_Breach_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Credit_Breach_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Credit_Breach_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Credit_Breach_Aggregate_Bool_Exp_Count>;
};

export type Credit_Breach_Aggregate_Bool_Exp_Bool_And = {
  arguments: Credit_Breach_Select_Column_Credit_Breach_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Credit_Breach_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Credit_Breach_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Credit_Breach_Select_Column_Credit_Breach_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Credit_Breach_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Credit_Breach_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Credit_Breach_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Credit_Breach_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "credit_breach" */
export type Credit_Breach_Aggregate_Fields = {
  __typename?: 'credit_breach_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Credit_Breach_Max_Fields>;
  min?: Maybe<Credit_Breach_Min_Fields>;
};


/** aggregate fields of "credit_breach" */
export type Credit_Breach_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Credit_Breach_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "credit_breach" */
export type Credit_Breach_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Credit_Breach_Max_Order_By>;
  min?: InputMaybe<Credit_Breach_Min_Order_By>;
};

/** input type for inserting array relation for remote table "credit_breach" */
export type Credit_Breach_Arr_Rel_Insert_Input = {
  data: Array<Credit_Breach_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Credit_Breach_On_Conflict>;
};

/** Boolean expression to filter rows from the table "credit_breach". All fields are combined with a logical 'AND'. */
export type Credit_Breach_Bool_Exp = {
  _and?: InputMaybe<Array<Credit_Breach_Bool_Exp>>;
  _not?: InputMaybe<Credit_Breach_Bool_Exp>;
  _or?: InputMaybe<Array<Credit_Breach_Bool_Exp>>;
  addition_credit_limit?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  limit_expire?: InputMaybe<Timestamp_Comparison_Exp>;
  limit_start?: InputMaybe<Timestamp_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "credit_breach" */
export enum Credit_Breach_Constraint {
  /** unique or primary key constraint on columns "id" */
  CreditBreachPkey = 'credit_breach_pkey'
}

/** input type for inserting data into table "credit_breach" */
export type Credit_Breach_Insert_Input = {
  addition_credit_limit?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  limit_expire?: InputMaybe<Scalars['timestamp']['input']>;
  limit_start?: InputMaybe<Scalars['timestamp']['input']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Credit_Breach_Max_Fields = {
  __typename?: 'credit_breach_max_fields';
  addition_credit_limit?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  limit_expire?: Maybe<Scalars['timestamp']['output']>;
  limit_start?: Maybe<Scalars['timestamp']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "credit_breach" */
export type Credit_Breach_Max_Order_By = {
  addition_credit_limit?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  limit_expire?: InputMaybe<Order_By>;
  limit_start?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Credit_Breach_Min_Fields = {
  __typename?: 'credit_breach_min_fields';
  addition_credit_limit?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  limit_expire?: Maybe<Scalars['timestamp']['output']>;
  limit_start?: Maybe<Scalars['timestamp']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "credit_breach" */
export type Credit_Breach_Min_Order_By = {
  addition_credit_limit?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  limit_expire?: InputMaybe<Order_By>;
  limit_start?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "credit_breach" */
export type Credit_Breach_Mutation_Response = {
  __typename?: 'credit_breach_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Credit_Breach>;
};

/** on_conflict condition type for table "credit_breach" */
export type Credit_Breach_On_Conflict = {
  constraint: Credit_Breach_Constraint;
  update_columns?: Array<Credit_Breach_Update_Column>;
  where?: InputMaybe<Credit_Breach_Bool_Exp>;
};

/** Ordering options when selecting data from "credit_breach". */
export type Credit_Breach_Order_By = {
  addition_credit_limit?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  limit_expire?: InputMaybe<Order_By>;
  limit_start?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: credit_breach */
export type Credit_Breach_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "credit_breach" */
export enum Credit_Breach_Select_Column {
  /** column name */
  AdditionCreditLimit = 'addition_credit_limit',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  LimitExpire = 'limit_expire',
  /** column name */
  LimitStart = 'limit_start',
  /** column name */
  OrganizationId = 'organization_id'
}

/** select "credit_breach_aggregate_bool_exp_bool_and_arguments_columns" columns of table "credit_breach" */
export enum Credit_Breach_Select_Column_Credit_Breach_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "credit_breach_aggregate_bool_exp_bool_or_arguments_columns" columns of table "credit_breach" */
export enum Credit_Breach_Select_Column_Credit_Breach_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "credit_breach" */
export type Credit_Breach_Set_Input = {
  addition_credit_limit?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  limit_expire?: InputMaybe<Scalars['timestamp']['input']>;
  limit_start?: InputMaybe<Scalars['timestamp']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "credit_breach" */
export type Credit_Breach_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Credit_Breach_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Credit_Breach_Stream_Cursor_Value_Input = {
  addition_credit_limit?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  limit_expire?: InputMaybe<Scalars['timestamp']['input']>;
  limit_start?: InputMaybe<Scalars['timestamp']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "credit_breach" */
export enum Credit_Breach_Update_Column {
  /** column name */
  AdditionCreditLimit = 'addition_credit_limit',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  LimitExpire = 'limit_expire',
  /** column name */
  LimitStart = 'limit_start',
  /** column name */
  OrganizationId = 'organization_id'
}

export type Credit_Breach_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Credit_Breach_Set_Input>;
  /** filter the rows which have to be updated */
  where: Credit_Breach_Bool_Exp;
};

/** columns and relationships of "currency" */
export type Currency = {
  __typename?: 'currency';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  currencyConversionsByTargetCurrencyId: Array<Currency_Conversion>;
  /** An aggregate relationship */
  currencyConversionsByTargetCurrencyId_aggregate: Currency_Conversion_Aggregate;
  /** An array relationship */
  currency_conversions: Array<Currency_Conversion>;
  /** An aggregate relationship */
  currency_conversions_aggregate: Currency_Conversion_Aggregate;
  /** An array relationship */
  customer_payments: Array<Customer_Payment>;
  /** An aggregate relationship */
  customer_payments_aggregate: Customer_Payment_Aggregate;
  formatted_name: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name: Scalars['String']['output'];
  /** An array relationship */
  organizations: Array<Organization>;
  /** An aggregate relationship */
  organizations_aggregate: Organization_Aggregate;
  /** An array relationship */
  partners: Array<Partner>;
  /** An aggregate relationship */
  partners_aggregate: Partner_Aggregate;
  /** An array relationship */
  product_partner_localities_prices: Array<Product_Partner_Localities_Price>;
  /** An aggregate relationship */
  product_partner_localities_prices_aggregate: Product_Partner_Localities_Price_Aggregate;
  unit_value: Scalars['String']['output'];
  /** An array relationship */
  user_ledgers: Array<User_Ledger>;
  /** An aggregate relationship */
  user_ledgers_aggregate: User_Ledger_Aggregate;
  /** An array relationship */
  wallet_ledgers: Array<Wallet_Ledger>;
  /** An aggregate relationship */
  wallet_ledgers_aggregate: Wallet_Ledger_Aggregate;
  /** An array relationship */
  wallet_transactions: Array<Wallet_Transactions>;
  /** An aggregate relationship */
  wallet_transactions_aggregate: Wallet_Transactions_Aggregate;
  /** An array relationship */
  wallets: Array<Wallet>;
  /** An aggregate relationship */
  wallets_aggregate: Wallet_Aggregate;
};


/** columns and relationships of "currency" */
export type CurrencyCurrencyConversionsByTargetCurrencyIdArgs = {
  distinct_on?: InputMaybe<Array<Currency_Conversion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Currency_Conversion_Order_By>>;
  where?: InputMaybe<Currency_Conversion_Bool_Exp>;
};


/** columns and relationships of "currency" */
export type CurrencyCurrencyConversionsByTargetCurrencyId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Currency_Conversion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Currency_Conversion_Order_By>>;
  where?: InputMaybe<Currency_Conversion_Bool_Exp>;
};


/** columns and relationships of "currency" */
export type CurrencyCurrency_ConversionsArgs = {
  distinct_on?: InputMaybe<Array<Currency_Conversion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Currency_Conversion_Order_By>>;
  where?: InputMaybe<Currency_Conversion_Bool_Exp>;
};


/** columns and relationships of "currency" */
export type CurrencyCurrency_Conversions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Currency_Conversion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Currency_Conversion_Order_By>>;
  where?: InputMaybe<Currency_Conversion_Bool_Exp>;
};


/** columns and relationships of "currency" */
export type CurrencyCustomer_PaymentsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Payment_Order_By>>;
  where?: InputMaybe<Customer_Payment_Bool_Exp>;
};


/** columns and relationships of "currency" */
export type CurrencyCustomer_Payments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Payment_Order_By>>;
  where?: InputMaybe<Customer_Payment_Bool_Exp>;
};


/** columns and relationships of "currency" */
export type CurrencyOrganizationsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


/** columns and relationships of "currency" */
export type CurrencyOrganizations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


/** columns and relationships of "currency" */
export type CurrencyPartnersArgs = {
  distinct_on?: InputMaybe<Array<Partner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_By>>;
  where?: InputMaybe<Partner_Bool_Exp>;
};


/** columns and relationships of "currency" */
export type CurrencyPartners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_By>>;
  where?: InputMaybe<Partner_Bool_Exp>;
};


/** columns and relationships of "currency" */
export type CurrencyProduct_Partner_Localities_PricesArgs = {
  distinct_on?: InputMaybe<Array<Product_Partner_Localities_Price_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Partner_Localities_Price_Order_By>>;
  where?: InputMaybe<Product_Partner_Localities_Price_Bool_Exp>;
};


/** columns and relationships of "currency" */
export type CurrencyProduct_Partner_Localities_Prices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Partner_Localities_Price_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Partner_Localities_Price_Order_By>>;
  where?: InputMaybe<Product_Partner_Localities_Price_Bool_Exp>;
};


/** columns and relationships of "currency" */
export type CurrencyUser_LedgersArgs = {
  distinct_on?: InputMaybe<Array<User_Ledger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Ledger_Order_By>>;
  where?: InputMaybe<User_Ledger_Bool_Exp>;
};


/** columns and relationships of "currency" */
export type CurrencyUser_Ledgers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Ledger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Ledger_Order_By>>;
  where?: InputMaybe<User_Ledger_Bool_Exp>;
};


/** columns and relationships of "currency" */
export type CurrencyWallet_LedgersArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Ledger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Ledger_Order_By>>;
  where?: InputMaybe<Wallet_Ledger_Bool_Exp>;
};


/** columns and relationships of "currency" */
export type CurrencyWallet_Ledgers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Ledger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Ledger_Order_By>>;
  where?: InputMaybe<Wallet_Ledger_Bool_Exp>;
};


/** columns and relationships of "currency" */
export type CurrencyWallet_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Transactions_Order_By>>;
  where?: InputMaybe<Wallet_Transactions_Bool_Exp>;
};


/** columns and relationships of "currency" */
export type CurrencyWallet_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Transactions_Order_By>>;
  where?: InputMaybe<Wallet_Transactions_Bool_Exp>;
};


/** columns and relationships of "currency" */
export type CurrencyWalletsArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Order_By>>;
  where?: InputMaybe<Wallet_Bool_Exp>;
};


/** columns and relationships of "currency" */
export type CurrencyWallets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Order_By>>;
  where?: InputMaybe<Wallet_Bool_Exp>;
};

/** aggregated selection of "currency" */
export type Currency_Aggregate = {
  __typename?: 'currency_aggregate';
  aggregate?: Maybe<Currency_Aggregate_Fields>;
  nodes: Array<Currency>;
};

/** aggregate fields of "currency" */
export type Currency_Aggregate_Fields = {
  __typename?: 'currency_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Currency_Max_Fields>;
  min?: Maybe<Currency_Min_Fields>;
};


/** aggregate fields of "currency" */
export type Currency_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Currency_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "currency". All fields are combined with a logical 'AND'. */
export type Currency_Bool_Exp = {
  _and?: InputMaybe<Array<Currency_Bool_Exp>>;
  _not?: InputMaybe<Currency_Bool_Exp>;
  _or?: InputMaybe<Array<Currency_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  currencyConversionsByTargetCurrencyId?: InputMaybe<Currency_Conversion_Bool_Exp>;
  currencyConversionsByTargetCurrencyId_aggregate?: InputMaybe<Currency_Conversion_Aggregate_Bool_Exp>;
  currency_conversions?: InputMaybe<Currency_Conversion_Bool_Exp>;
  currency_conversions_aggregate?: InputMaybe<Currency_Conversion_Aggregate_Bool_Exp>;
  customer_payments?: InputMaybe<Customer_Payment_Bool_Exp>;
  customer_payments_aggregate?: InputMaybe<Customer_Payment_Aggregate_Bool_Exp>;
  formatted_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organizations?: InputMaybe<Organization_Bool_Exp>;
  organizations_aggregate?: InputMaybe<Organization_Aggregate_Bool_Exp>;
  partners?: InputMaybe<Partner_Bool_Exp>;
  partners_aggregate?: InputMaybe<Partner_Aggregate_Bool_Exp>;
  product_partner_localities_prices?: InputMaybe<Product_Partner_Localities_Price_Bool_Exp>;
  product_partner_localities_prices_aggregate?: InputMaybe<Product_Partner_Localities_Price_Aggregate_Bool_Exp>;
  unit_value?: InputMaybe<String_Comparison_Exp>;
  user_ledgers?: InputMaybe<User_Ledger_Bool_Exp>;
  user_ledgers_aggregate?: InputMaybe<User_Ledger_Aggregate_Bool_Exp>;
  wallet_ledgers?: InputMaybe<Wallet_Ledger_Bool_Exp>;
  wallet_ledgers_aggregate?: InputMaybe<Wallet_Ledger_Aggregate_Bool_Exp>;
  wallet_transactions?: InputMaybe<Wallet_Transactions_Bool_Exp>;
  wallet_transactions_aggregate?: InputMaybe<Wallet_Transactions_Aggregate_Bool_Exp>;
  wallets?: InputMaybe<Wallet_Bool_Exp>;
  wallets_aggregate?: InputMaybe<Wallet_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "currency" */
export enum Currency_Constraint {
  /** unique or primary key constraint on columns "id" */
  CurrencyPkey = 'currency_pkey'
}

/** columns and relationships of "currency_conversion" */
export type Currency_Conversion = {
  __typename?: 'currency_conversion';
  conversion_rate?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  currency: Currency;
  /** An object relationship */
  currencyByTargetCurrencyId: Currency;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  source_currency_id: Scalars['uuid']['output'];
  target_currency_id: Scalars['uuid']['output'];
};

/** aggregated selection of "currency_conversion" */
export type Currency_Conversion_Aggregate = {
  __typename?: 'currency_conversion_aggregate';
  aggregate?: Maybe<Currency_Conversion_Aggregate_Fields>;
  nodes: Array<Currency_Conversion>;
};

export type Currency_Conversion_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Currency_Conversion_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Currency_Conversion_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Currency_Conversion_Aggregate_Bool_Exp_Count>;
};

export type Currency_Conversion_Aggregate_Bool_Exp_Bool_And = {
  arguments: Currency_Conversion_Select_Column_Currency_Conversion_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Currency_Conversion_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Currency_Conversion_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Currency_Conversion_Select_Column_Currency_Conversion_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Currency_Conversion_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Currency_Conversion_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Currency_Conversion_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Currency_Conversion_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "currency_conversion" */
export type Currency_Conversion_Aggregate_Fields = {
  __typename?: 'currency_conversion_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Currency_Conversion_Max_Fields>;
  min?: Maybe<Currency_Conversion_Min_Fields>;
};


/** aggregate fields of "currency_conversion" */
export type Currency_Conversion_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Currency_Conversion_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "currency_conversion" */
export type Currency_Conversion_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Currency_Conversion_Max_Order_By>;
  min?: InputMaybe<Currency_Conversion_Min_Order_By>;
};

/** input type for inserting array relation for remote table "currency_conversion" */
export type Currency_Conversion_Arr_Rel_Insert_Input = {
  data: Array<Currency_Conversion_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Currency_Conversion_On_Conflict>;
};

/** Boolean expression to filter rows from the table "currency_conversion". All fields are combined with a logical 'AND'. */
export type Currency_Conversion_Bool_Exp = {
  _and?: InputMaybe<Array<Currency_Conversion_Bool_Exp>>;
  _not?: InputMaybe<Currency_Conversion_Bool_Exp>;
  _or?: InputMaybe<Array<Currency_Conversion_Bool_Exp>>;
  conversion_rate?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  currency?: InputMaybe<Currency_Bool_Exp>;
  currencyByTargetCurrencyId?: InputMaybe<Currency_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  source_currency_id?: InputMaybe<Uuid_Comparison_Exp>;
  target_currency_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "currency_conversion" */
export enum Currency_Conversion_Constraint {
  /** unique or primary key constraint on columns "id" */
  CurrencyConversionPkey = 'currency_conversion_pkey'
}

/** input type for inserting data into table "currency_conversion" */
export type Currency_Conversion_Insert_Input = {
  conversion_rate?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  currency?: InputMaybe<Currency_Obj_Rel_Insert_Input>;
  currencyByTargetCurrencyId?: InputMaybe<Currency_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  source_currency_id?: InputMaybe<Scalars['uuid']['input']>;
  target_currency_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Currency_Conversion_Max_Fields = {
  __typename?: 'currency_conversion_max_fields';
  conversion_rate?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  source_currency_id?: Maybe<Scalars['uuid']['output']>;
  target_currency_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "currency_conversion" */
export type Currency_Conversion_Max_Order_By = {
  conversion_rate?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  source_currency_id?: InputMaybe<Order_By>;
  target_currency_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Currency_Conversion_Min_Fields = {
  __typename?: 'currency_conversion_min_fields';
  conversion_rate?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  source_currency_id?: Maybe<Scalars['uuid']['output']>;
  target_currency_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "currency_conversion" */
export type Currency_Conversion_Min_Order_By = {
  conversion_rate?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  source_currency_id?: InputMaybe<Order_By>;
  target_currency_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "currency_conversion" */
export type Currency_Conversion_Mutation_Response = {
  __typename?: 'currency_conversion_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Currency_Conversion>;
};

/** on_conflict condition type for table "currency_conversion" */
export type Currency_Conversion_On_Conflict = {
  constraint: Currency_Conversion_Constraint;
  update_columns?: Array<Currency_Conversion_Update_Column>;
  where?: InputMaybe<Currency_Conversion_Bool_Exp>;
};

/** Ordering options when selecting data from "currency_conversion". */
export type Currency_Conversion_Order_By = {
  conversion_rate?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Currency_Order_By>;
  currencyByTargetCurrencyId?: InputMaybe<Currency_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  source_currency_id?: InputMaybe<Order_By>;
  target_currency_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: currency_conversion */
export type Currency_Conversion_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "currency_conversion" */
export enum Currency_Conversion_Select_Column {
  /** column name */
  ConversionRate = 'conversion_rate',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  SourceCurrencyId = 'source_currency_id',
  /** column name */
  TargetCurrencyId = 'target_currency_id'
}

/** select "currency_conversion_aggregate_bool_exp_bool_and_arguments_columns" columns of table "currency_conversion" */
export enum Currency_Conversion_Select_Column_Currency_Conversion_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "currency_conversion_aggregate_bool_exp_bool_or_arguments_columns" columns of table "currency_conversion" */
export enum Currency_Conversion_Select_Column_Currency_Conversion_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "currency_conversion" */
export type Currency_Conversion_Set_Input = {
  conversion_rate?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  source_currency_id?: InputMaybe<Scalars['uuid']['input']>;
  target_currency_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "currency_conversion" */
export type Currency_Conversion_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Currency_Conversion_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Currency_Conversion_Stream_Cursor_Value_Input = {
  conversion_rate?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  source_currency_id?: InputMaybe<Scalars['uuid']['input']>;
  target_currency_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "currency_conversion" */
export enum Currency_Conversion_Update_Column {
  /** column name */
  ConversionRate = 'conversion_rate',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  SourceCurrencyId = 'source_currency_id',
  /** column name */
  TargetCurrencyId = 'target_currency_id'
}

export type Currency_Conversion_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Currency_Conversion_Set_Input>;
  /** filter the rows which have to be updated */
  where: Currency_Conversion_Bool_Exp;
};

/** input type for inserting data into table "currency" */
export type Currency_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  currencyConversionsByTargetCurrencyId?: InputMaybe<Currency_Conversion_Arr_Rel_Insert_Input>;
  currency_conversions?: InputMaybe<Currency_Conversion_Arr_Rel_Insert_Input>;
  customer_payments?: InputMaybe<Customer_Payment_Arr_Rel_Insert_Input>;
  formatted_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizations?: InputMaybe<Organization_Arr_Rel_Insert_Input>;
  partners?: InputMaybe<Partner_Arr_Rel_Insert_Input>;
  product_partner_localities_prices?: InputMaybe<Product_Partner_Localities_Price_Arr_Rel_Insert_Input>;
  unit_value?: InputMaybe<Scalars['String']['input']>;
  user_ledgers?: InputMaybe<User_Ledger_Arr_Rel_Insert_Input>;
  wallet_ledgers?: InputMaybe<Wallet_Ledger_Arr_Rel_Insert_Input>;
  wallet_transactions?: InputMaybe<Wallet_Transactions_Arr_Rel_Insert_Input>;
  wallets?: InputMaybe<Wallet_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Currency_Max_Fields = {
  __typename?: 'currency_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  formatted_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  unit_value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Currency_Min_Fields = {
  __typename?: 'currency_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  formatted_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  unit_value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "currency" */
export type Currency_Mutation_Response = {
  __typename?: 'currency_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Currency>;
};

/** input type for inserting object relation for remote table "currency" */
export type Currency_Obj_Rel_Insert_Input = {
  data: Currency_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Currency_On_Conflict>;
};

/** on_conflict condition type for table "currency" */
export type Currency_On_Conflict = {
  constraint: Currency_Constraint;
  update_columns?: Array<Currency_Update_Column>;
  where?: InputMaybe<Currency_Bool_Exp>;
};

/** Ordering options when selecting data from "currency". */
export type Currency_Order_By = {
  created_at?: InputMaybe<Order_By>;
  currencyConversionsByTargetCurrencyId_aggregate?: InputMaybe<Currency_Conversion_Aggregate_Order_By>;
  currency_conversions_aggregate?: InputMaybe<Currency_Conversion_Aggregate_Order_By>;
  customer_payments_aggregate?: InputMaybe<Customer_Payment_Aggregate_Order_By>;
  formatted_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organizations_aggregate?: InputMaybe<Organization_Aggregate_Order_By>;
  partners_aggregate?: InputMaybe<Partner_Aggregate_Order_By>;
  product_partner_localities_prices_aggregate?: InputMaybe<Product_Partner_Localities_Price_Aggregate_Order_By>;
  unit_value?: InputMaybe<Order_By>;
  user_ledgers_aggregate?: InputMaybe<User_Ledger_Aggregate_Order_By>;
  wallet_ledgers_aggregate?: InputMaybe<Wallet_Ledger_Aggregate_Order_By>;
  wallet_transactions_aggregate?: InputMaybe<Wallet_Transactions_Aggregate_Order_By>;
  wallets_aggregate?: InputMaybe<Wallet_Aggregate_Order_By>;
};

/** primary key columns input for table: currency */
export type Currency_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "currency" */
export enum Currency_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FormattedName = 'formatted_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  UnitValue = 'unit_value'
}

/** input type for updating data in table "currency" */
export type Currency_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  formatted_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  unit_value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "currency" */
export type Currency_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Currency_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Currency_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  formatted_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  unit_value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "currency" */
export enum Currency_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FormattedName = 'formatted_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  UnitValue = 'unit_value'
}

export type Currency_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Currency_Set_Input>;
  /** filter the rows which have to be updated */
  where: Currency_Bool_Exp;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

export type CustomerAssetWithReqQty = {
  customer_asset_id: Scalars['uuid']['input'];
  quantity_requested: Scalars['numeric']['input'];
};

export type CustomerOrderSanityInput = {
  order_code: Scalars['numeric']['input'];
};

export type CustomerOrderSanityOutput = {
  __typename?: 'customerOrderSanityOutput';
  data?: Maybe<Scalars['jsonb']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

/** columns and relationships of "customer_asset" */
export type Customer_Asset = {
  __typename?: 'customer_asset';
  /** An array relationship */
  asset_grouping_customer_assets: Array<Asset_Grouping_Customer_Asset>;
  /** An aggregate relationship */
  asset_grouping_customer_assets_aggregate: Asset_Grouping_Customer_Asset_Aggregate;
  /** An array relationship */
  asset_subsidiaries: Array<Asset_Subsidiary>;
  /** An aggregate relationship */
  asset_subsidiaries_aggregate: Asset_Subsidiary_Aggregate;
  /** An array relationship */
  asset_subsidiary_audit_logs: Array<Asset_Subsidiary_Audit_Logs>;
  /** An aggregate relationship */
  asset_subsidiary_audit_logs_aggregate: Asset_Subsidiary_Audit_Logs_Aggregate;
  /** An object relationship */
  asset_type: Asset_Type;
  asset_type_id: Scalars['uuid']['output'];
  capacity?: Maybe<Scalars['String']['output']>;
  chassis_number?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  customer_asset_audits: Array<Customer_Asset_Audit_Log>;
  /** An aggregate relationship */
  customer_asset_audits_aggregate: Customer_Asset_Audit_Log_Aggregate;
  /** An array relationship */
  customer_asset_devices: Array<Customer_Asset_Device>;
  /** An aggregate relationship */
  customer_asset_devices_aggregate: Customer_Asset_Device_Aggregate;
  /** An array relationship */
  customer_asset_dispensing_rules: Array<Customer_Asset_Dispensing_Rules>;
  /** An aggregate relationship */
  customer_asset_dispensing_rules_aggregate: Customer_Asset_Dispensing_Rules_Aggregate;
  /** An array relationship */
  customer_asset_limits: Array<Customer_Asset_Limit>;
  /** An aggregate relationship */
  customer_asset_limits_aggregate: Customer_Asset_Limit_Aggregate;
  /** An array relationship */
  customer_asset_tags: Array<Customer_Asset_Tag>;
  /** An aggregate relationship */
  customer_asset_tags_aggregate: Customer_Asset_Tag_Aggregate;
  /** An array relationship */
  customer_order_customer_assets: Array<Customer_Order_Customer_Asset>;
  /** An aggregate relationship */
  customer_order_customer_assets_aggregate: Customer_Order_Customer_Asset_Aggregate;
  description?: Maybe<Scalars['String']['output']>;
  erp_code?: Maybe<Scalars['String']['output']>;
  fuel_card_number?: Maybe<Scalars['String']['output']>;
  fueltrans_asset_id?: Maybe<Scalars['String']['output']>;
  icon_prefix?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  ideal_utilisation?: Maybe<Scalars['numeric']['output']>;
  /** An array relationship */
  invoiced_items: Array<Invoiced_Item>;
  /** An aggregate relationship */
  invoiced_items_aggregate: Invoiced_Item_Aggregate;
  is_active: Scalars['Boolean']['output'];
  is_collect_odometer_reading: Scalars['Boolean']['output'];
  is_odometer_verified: Scalars['Boolean']['output'];
  is_test_enabled?: Maybe<Scalars['Boolean']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  make?: Maybe<Scalars['String']['output']>;
  modal?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** An array relationship */
  order_scheduler_customer_assets: Array<Order_Scheduler_Customer_Asset>;
  /** An aggregate relationship */
  order_scheduler_customer_assets_aggregate: Order_Scheduler_Customer_Asset_Aggregate;
  /** An object relationship */
  organization_user?: Maybe<Organization_User>;
  /** Optional reference to organization user. Can be NULL when asset belongs to organization as a whole rather than specific user. */
  organization_user_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  partner_order_customer_assets: Array<Partner_Order_Customer_Asset>;
  /** An aggregate relationship */
  partner_order_customer_assets_aggregate: Partner_Order_Customer_Asset_Aggregate;
  plate_code?: Maybe<Scalars['String']['output']>;
  plate_number?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  product?: Maybe<Product>;
  product_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  reason?: Maybe<Reasons>;
  reason_id?: Maybe<Scalars['uuid']['output']>;
  reason_note?: Maybe<Scalars['String']['output']>;
  registration_number?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  state?: Maybe<State>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  subsidiary_id?: Maybe<Scalars['uuid']['output']>;
  tag_id?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  task_values: Array<Task_Value>;
  /** An aggregate relationship */
  task_values_aggregate: Task_Value_Aggregate;
  /** An array relationship */
  tickets: Array<Tickets>;
  /** An aggregate relationship */
  tickets_aggregate: Tickets_Aggregate;
  /** An array relationship */
  trip_plans: Array<Trip_Plan>;
  /** An aggregate relationship */
  trip_plans_aggregate: Trip_Plan_Aggregate;
  /** An array relationship */
  view_daily_asset_limit: Array<View_Daily_Asset_Limit>;
  /** An aggregate relationship */
  view_daily_asset_limit_aggregate: View_Daily_Asset_Limit_Aggregate;
  /** An array relationship */
  view_monthly_asset_limit: Array<View_Monthly_Asset_Limit>;
  /** An aggregate relationship */
  view_monthly_asset_limit_aggregate: View_Monthly_Asset_Limit_Aggregate;
  /** An array relationship */
  view_weekly_asset_limit: Array<View_Weekly_Asset_Limit>;
  /** An aggregate relationship */
  view_weekly_asset_limit_aggregate: View_Weekly_Asset_Limit_Aggregate;
  /** An array relationship */
  wallet_ledgers: Array<Wallet_Ledger>;
  /** An aggregate relationship */
  wallet_ledgers_aggregate: Wallet_Ledger_Aggregate;
};


/** columns and relationships of "customer_asset" */
export type Customer_AssetAsset_Grouping_Customer_AssetsArgs = {
  distinct_on?: InputMaybe<Array<Asset_Grouping_Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Grouping_Customer_Asset_Order_By>>;
  where?: InputMaybe<Asset_Grouping_Customer_Asset_Bool_Exp>;
};


/** columns and relationships of "customer_asset" */
export type Customer_AssetAsset_Grouping_Customer_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Grouping_Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Grouping_Customer_Asset_Order_By>>;
  where?: InputMaybe<Asset_Grouping_Customer_Asset_Bool_Exp>;
};


/** columns and relationships of "customer_asset" */
export type Customer_AssetAsset_SubsidiariesArgs = {
  distinct_on?: InputMaybe<Array<Asset_Subsidiary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Subsidiary_Order_By>>;
  where?: InputMaybe<Asset_Subsidiary_Bool_Exp>;
};


/** columns and relationships of "customer_asset" */
export type Customer_AssetAsset_Subsidiaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Subsidiary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Subsidiary_Order_By>>;
  where?: InputMaybe<Asset_Subsidiary_Bool_Exp>;
};


/** columns and relationships of "customer_asset" */
export type Customer_AssetAsset_Subsidiary_Audit_LogsArgs = {
  distinct_on?: InputMaybe<Array<Asset_Subsidiary_Audit_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Subsidiary_Audit_Logs_Order_By>>;
  where?: InputMaybe<Asset_Subsidiary_Audit_Logs_Bool_Exp>;
};


/** columns and relationships of "customer_asset" */
export type Customer_AssetAsset_Subsidiary_Audit_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Subsidiary_Audit_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Subsidiary_Audit_Logs_Order_By>>;
  where?: InputMaybe<Asset_Subsidiary_Audit_Logs_Bool_Exp>;
};


/** columns and relationships of "customer_asset" */
export type Customer_AssetCustomer_Asset_AuditsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Audit_Log_Order_By>>;
  where?: InputMaybe<Customer_Asset_Audit_Log_Bool_Exp>;
};


/** columns and relationships of "customer_asset" */
export type Customer_AssetCustomer_Asset_Audits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Audit_Log_Order_By>>;
  where?: InputMaybe<Customer_Asset_Audit_Log_Bool_Exp>;
};


/** columns and relationships of "customer_asset" */
export type Customer_AssetCustomer_Asset_DevicesArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Device_Order_By>>;
  where?: InputMaybe<Customer_Asset_Device_Bool_Exp>;
};


/** columns and relationships of "customer_asset" */
export type Customer_AssetCustomer_Asset_Devices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Device_Order_By>>;
  where?: InputMaybe<Customer_Asset_Device_Bool_Exp>;
};


/** columns and relationships of "customer_asset" */
export type Customer_AssetCustomer_Asset_Dispensing_RulesArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Dispensing_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Dispensing_Rules_Order_By>>;
  where?: InputMaybe<Customer_Asset_Dispensing_Rules_Bool_Exp>;
};


/** columns and relationships of "customer_asset" */
export type Customer_AssetCustomer_Asset_Dispensing_Rules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Dispensing_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Dispensing_Rules_Order_By>>;
  where?: InputMaybe<Customer_Asset_Dispensing_Rules_Bool_Exp>;
};


/** columns and relationships of "customer_asset" */
export type Customer_AssetCustomer_Asset_LimitsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Limit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Limit_Order_By>>;
  where?: InputMaybe<Customer_Asset_Limit_Bool_Exp>;
};


/** columns and relationships of "customer_asset" */
export type Customer_AssetCustomer_Asset_Limits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Limit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Limit_Order_By>>;
  where?: InputMaybe<Customer_Asset_Limit_Bool_Exp>;
};


/** columns and relationships of "customer_asset" */
export type Customer_AssetCustomer_Asset_TagsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Tag_Order_By>>;
  where?: InputMaybe<Customer_Asset_Tag_Bool_Exp>;
};


/** columns and relationships of "customer_asset" */
export type Customer_AssetCustomer_Asset_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Tag_Order_By>>;
  where?: InputMaybe<Customer_Asset_Tag_Bool_Exp>;
};


/** columns and relationships of "customer_asset" */
export type Customer_AssetCustomer_Order_Customer_AssetsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Customer_Asset_Order_By>>;
  where?: InputMaybe<Customer_Order_Customer_Asset_Bool_Exp>;
};


/** columns and relationships of "customer_asset" */
export type Customer_AssetCustomer_Order_Customer_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Customer_Asset_Order_By>>;
  where?: InputMaybe<Customer_Order_Customer_Asset_Bool_Exp>;
};


/** columns and relationships of "customer_asset" */
export type Customer_AssetInvoiced_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Bool_Exp>;
};


/** columns and relationships of "customer_asset" */
export type Customer_AssetInvoiced_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Bool_Exp>;
};


/** columns and relationships of "customer_asset" */
export type Customer_AssetOrder_Scheduler_Customer_AssetsArgs = {
  distinct_on?: InputMaybe<Array<Order_Scheduler_Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Scheduler_Customer_Asset_Order_By>>;
  where?: InputMaybe<Order_Scheduler_Customer_Asset_Bool_Exp>;
};


/** columns and relationships of "customer_asset" */
export type Customer_AssetOrder_Scheduler_Customer_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Scheduler_Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Scheduler_Customer_Asset_Order_By>>;
  where?: InputMaybe<Order_Scheduler_Customer_Asset_Bool_Exp>;
};


/** columns and relationships of "customer_asset" */
export type Customer_AssetPartner_Order_Customer_AssetsArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Customer_Asset_Order_By>>;
  where?: InputMaybe<Partner_Order_Customer_Asset_Bool_Exp>;
};


/** columns and relationships of "customer_asset" */
export type Customer_AssetPartner_Order_Customer_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Customer_Asset_Order_By>>;
  where?: InputMaybe<Partner_Order_Customer_Asset_Bool_Exp>;
};


/** columns and relationships of "customer_asset" */
export type Customer_AssetTask_ValuesArgs = {
  distinct_on?: InputMaybe<Array<Task_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Value_Order_By>>;
  where?: InputMaybe<Task_Value_Bool_Exp>;
};


/** columns and relationships of "customer_asset" */
export type Customer_AssetTask_Values_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Value_Order_By>>;
  where?: InputMaybe<Task_Value_Bool_Exp>;
};


/** columns and relationships of "customer_asset" */
export type Customer_AssetTicketsArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tickets_Order_By>>;
  where?: InputMaybe<Tickets_Bool_Exp>;
};


/** columns and relationships of "customer_asset" */
export type Customer_AssetTickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tickets_Order_By>>;
  where?: InputMaybe<Tickets_Bool_Exp>;
};


/** columns and relationships of "customer_asset" */
export type Customer_AssetTrip_PlansArgs = {
  distinct_on?: InputMaybe<Array<Trip_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trip_Plan_Order_By>>;
  where?: InputMaybe<Trip_Plan_Bool_Exp>;
};


/** columns and relationships of "customer_asset" */
export type Customer_AssetTrip_Plans_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trip_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trip_Plan_Order_By>>;
  where?: InputMaybe<Trip_Plan_Bool_Exp>;
};


/** columns and relationships of "customer_asset" */
export type Customer_AssetView_Daily_Asset_LimitArgs = {
  distinct_on?: InputMaybe<Array<View_Daily_Asset_Limit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_Daily_Asset_Limit_Order_By>>;
  where?: InputMaybe<View_Daily_Asset_Limit_Bool_Exp>;
};


/** columns and relationships of "customer_asset" */
export type Customer_AssetView_Daily_Asset_Limit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<View_Daily_Asset_Limit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_Daily_Asset_Limit_Order_By>>;
  where?: InputMaybe<View_Daily_Asset_Limit_Bool_Exp>;
};


/** columns and relationships of "customer_asset" */
export type Customer_AssetView_Monthly_Asset_LimitArgs = {
  distinct_on?: InputMaybe<Array<View_Monthly_Asset_Limit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_Monthly_Asset_Limit_Order_By>>;
  where?: InputMaybe<View_Monthly_Asset_Limit_Bool_Exp>;
};


/** columns and relationships of "customer_asset" */
export type Customer_AssetView_Monthly_Asset_Limit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<View_Monthly_Asset_Limit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_Monthly_Asset_Limit_Order_By>>;
  where?: InputMaybe<View_Monthly_Asset_Limit_Bool_Exp>;
};


/** columns and relationships of "customer_asset" */
export type Customer_AssetView_Weekly_Asset_LimitArgs = {
  distinct_on?: InputMaybe<Array<View_Weekly_Asset_Limit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_Weekly_Asset_Limit_Order_By>>;
  where?: InputMaybe<View_Weekly_Asset_Limit_Bool_Exp>;
};


/** columns and relationships of "customer_asset" */
export type Customer_AssetView_Weekly_Asset_Limit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<View_Weekly_Asset_Limit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_Weekly_Asset_Limit_Order_By>>;
  where?: InputMaybe<View_Weekly_Asset_Limit_Bool_Exp>;
};


/** columns and relationships of "customer_asset" */
export type Customer_AssetWallet_LedgersArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Ledger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Ledger_Order_By>>;
  where?: InputMaybe<Wallet_Ledger_Bool_Exp>;
};


/** columns and relationships of "customer_asset" */
export type Customer_AssetWallet_Ledgers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Ledger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Ledger_Order_By>>;
  where?: InputMaybe<Wallet_Ledger_Bool_Exp>;
};

/** aggregated selection of "customer_asset" */
export type Customer_Asset_Aggregate = {
  __typename?: 'customer_asset_aggregate';
  aggregate?: Maybe<Customer_Asset_Aggregate_Fields>;
  nodes: Array<Customer_Asset>;
};

export type Customer_Asset_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Customer_Asset_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Customer_Asset_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Customer_Asset_Aggregate_Bool_Exp_Count>;
};

export type Customer_Asset_Aggregate_Bool_Exp_Bool_And = {
  arguments: Customer_Asset_Select_Column_Customer_Asset_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Asset_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customer_Asset_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Customer_Asset_Select_Column_Customer_Asset_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Asset_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customer_Asset_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Customer_Asset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Asset_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "customer_asset" */
export type Customer_Asset_Aggregate_Fields = {
  __typename?: 'customer_asset_aggregate_fields';
  avg?: Maybe<Customer_Asset_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Customer_Asset_Max_Fields>;
  min?: Maybe<Customer_Asset_Min_Fields>;
  stddev?: Maybe<Customer_Asset_Stddev_Fields>;
  stddev_pop?: Maybe<Customer_Asset_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Customer_Asset_Stddev_Samp_Fields>;
  sum?: Maybe<Customer_Asset_Sum_Fields>;
  var_pop?: Maybe<Customer_Asset_Var_Pop_Fields>;
  var_samp?: Maybe<Customer_Asset_Var_Samp_Fields>;
  variance?: Maybe<Customer_Asset_Variance_Fields>;
};


/** aggregate fields of "customer_asset" */
export type Customer_Asset_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Asset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "customer_asset" */
export type Customer_Asset_Aggregate_Order_By = {
  avg?: InputMaybe<Customer_Asset_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Customer_Asset_Max_Order_By>;
  min?: InputMaybe<Customer_Asset_Min_Order_By>;
  stddev?: InputMaybe<Customer_Asset_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Customer_Asset_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Customer_Asset_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Customer_Asset_Sum_Order_By>;
  var_pop?: InputMaybe<Customer_Asset_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Customer_Asset_Var_Samp_Order_By>;
  variance?: InputMaybe<Customer_Asset_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "customer_asset" */
export type Customer_Asset_Arr_Rel_Insert_Input = {
  data: Array<Customer_Asset_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Asset_On_Conflict>;
};

/** Audit trail for all changes to the customer asset table */
export type Customer_Asset_Audit_Log = {
  __typename?: 'customer_asset_audit_log';
  action: Scalars['String']['output'];
  after_state?: Maybe<Scalars['jsonb']['output']>;
  asset_id: Scalars['uuid']['output'];
  before_state?: Maybe<Scalars['jsonb']['output']>;
  /** Array of column names that changed during this audit event */
  changed_fields?: Maybe<Array<Scalars['String']['output']>>;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  customer_asset: Customer_Asset;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified: Scalars['timestamptz']['output'];
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  performer?: Maybe<User>;
  /** An object relationship */
  reason: Reasons;
  reason_id: Scalars['uuid']['output'];
  reason_note?: Maybe<Scalars['String']['output']>;
};


/** Audit trail for all changes to the customer asset table */
export type Customer_Asset_Audit_LogAfter_StateArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Audit trail for all changes to the customer asset table */
export type Customer_Asset_Audit_LogBefore_StateArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "customer_asset_audit_log" */
export type Customer_Asset_Audit_Log_Aggregate = {
  __typename?: 'customer_asset_audit_log_aggregate';
  aggregate?: Maybe<Customer_Asset_Audit_Log_Aggregate_Fields>;
  nodes: Array<Customer_Asset_Audit_Log>;
};

export type Customer_Asset_Audit_Log_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Customer_Asset_Audit_Log_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Customer_Asset_Audit_Log_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Customer_Asset_Audit_Log_Aggregate_Bool_Exp_Count>;
};

export type Customer_Asset_Audit_Log_Aggregate_Bool_Exp_Bool_And = {
  arguments: Customer_Asset_Audit_Log_Select_Column_Customer_Asset_Audit_Log_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Asset_Audit_Log_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customer_Asset_Audit_Log_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Customer_Asset_Audit_Log_Select_Column_Customer_Asset_Audit_Log_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Asset_Audit_Log_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customer_Asset_Audit_Log_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Customer_Asset_Audit_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Asset_Audit_Log_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "customer_asset_audit_log" */
export type Customer_Asset_Audit_Log_Aggregate_Fields = {
  __typename?: 'customer_asset_audit_log_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Customer_Asset_Audit_Log_Max_Fields>;
  min?: Maybe<Customer_Asset_Audit_Log_Min_Fields>;
};


/** aggregate fields of "customer_asset_audit_log" */
export type Customer_Asset_Audit_Log_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Asset_Audit_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "customer_asset_audit_log" */
export type Customer_Asset_Audit_Log_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Customer_Asset_Audit_Log_Max_Order_By>;
  min?: InputMaybe<Customer_Asset_Audit_Log_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Customer_Asset_Audit_Log_Append_Input = {
  after_state?: InputMaybe<Scalars['jsonb']['input']>;
  before_state?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "customer_asset_audit_log" */
export type Customer_Asset_Audit_Log_Arr_Rel_Insert_Input = {
  data: Array<Customer_Asset_Audit_Log_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Asset_Audit_Log_On_Conflict>;
};

/** Boolean expression to filter rows from the table "customer_asset_audit_log". All fields are combined with a logical 'AND'. */
export type Customer_Asset_Audit_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Asset_Audit_Log_Bool_Exp>>;
  _not?: InputMaybe<Customer_Asset_Audit_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Asset_Audit_Log_Bool_Exp>>;
  action?: InputMaybe<String_Comparison_Exp>;
  after_state?: InputMaybe<Jsonb_Comparison_Exp>;
  asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  before_state?: InputMaybe<Jsonb_Comparison_Exp>;
  changed_fields?: InputMaybe<String_Array_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  customer_asset?: InputMaybe<Customer_Asset_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  performer?: InputMaybe<User_Bool_Exp>;
  reason?: InputMaybe<Reasons_Bool_Exp>;
  reason_id?: InputMaybe<Uuid_Comparison_Exp>;
  reason_note?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "customer_asset_audit_log" */
export enum Customer_Asset_Audit_Log_Constraint {
  /** unique or primary key constraint on columns "id" */
  CustomerAssetAuditPkey = 'customer_asset_audit_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Customer_Asset_Audit_Log_Delete_At_Path_Input = {
  after_state?: InputMaybe<Array<Scalars['String']['input']>>;
  before_state?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Customer_Asset_Audit_Log_Delete_Elem_Input = {
  after_state?: InputMaybe<Scalars['Int']['input']>;
  before_state?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Customer_Asset_Audit_Log_Delete_Key_Input = {
  after_state?: InputMaybe<Scalars['String']['input']>;
  before_state?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "customer_asset_audit_log" */
export type Customer_Asset_Audit_Log_Insert_Input = {
  action?: InputMaybe<Scalars['String']['input']>;
  after_state?: InputMaybe<Scalars['jsonb']['input']>;
  asset_id?: InputMaybe<Scalars['uuid']['input']>;
  before_state?: InputMaybe<Scalars['jsonb']['input']>;
  /** Array of column names that changed during this audit event */
  changed_fields?: InputMaybe<Array<Scalars['String']['input']>>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  customer_asset?: InputMaybe<Customer_Asset_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  performer?: InputMaybe<User_Obj_Rel_Insert_Input>;
  reason?: InputMaybe<Reasons_Obj_Rel_Insert_Input>;
  reason_id?: InputMaybe<Scalars['uuid']['input']>;
  reason_note?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Customer_Asset_Audit_Log_Max_Fields = {
  __typename?: 'customer_asset_audit_log_max_fields';
  action?: Maybe<Scalars['String']['output']>;
  asset_id?: Maybe<Scalars['uuid']['output']>;
  /** Array of column names that changed during this audit event */
  changed_fields?: Maybe<Array<Scalars['String']['output']>>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  reason_id?: Maybe<Scalars['uuid']['output']>;
  reason_note?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "customer_asset_audit_log" */
export type Customer_Asset_Audit_Log_Max_Order_By = {
  action?: InputMaybe<Order_By>;
  asset_id?: InputMaybe<Order_By>;
  /** Array of column names that changed during this audit event */
  changed_fields?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  reason_id?: InputMaybe<Order_By>;
  reason_note?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Customer_Asset_Audit_Log_Min_Fields = {
  __typename?: 'customer_asset_audit_log_min_fields';
  action?: Maybe<Scalars['String']['output']>;
  asset_id?: Maybe<Scalars['uuid']['output']>;
  /** Array of column names that changed during this audit event */
  changed_fields?: Maybe<Array<Scalars['String']['output']>>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  reason_id?: Maybe<Scalars['uuid']['output']>;
  reason_note?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "customer_asset_audit_log" */
export type Customer_Asset_Audit_Log_Min_Order_By = {
  action?: InputMaybe<Order_By>;
  asset_id?: InputMaybe<Order_By>;
  /** Array of column names that changed during this audit event */
  changed_fields?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  reason_id?: InputMaybe<Order_By>;
  reason_note?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "customer_asset_audit_log" */
export type Customer_Asset_Audit_Log_Mutation_Response = {
  __typename?: 'customer_asset_audit_log_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Customer_Asset_Audit_Log>;
};

/** on_conflict condition type for table "customer_asset_audit_log" */
export type Customer_Asset_Audit_Log_On_Conflict = {
  constraint: Customer_Asset_Audit_Log_Constraint;
  update_columns?: Array<Customer_Asset_Audit_Log_Update_Column>;
  where?: InputMaybe<Customer_Asset_Audit_Log_Bool_Exp>;
};

/** Ordering options when selecting data from "customer_asset_audit_log". */
export type Customer_Asset_Audit_Log_Order_By = {
  action?: InputMaybe<Order_By>;
  after_state?: InputMaybe<Order_By>;
  asset_id?: InputMaybe<Order_By>;
  before_state?: InputMaybe<Order_By>;
  changed_fields?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_asset?: InputMaybe<Customer_Asset_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  performer?: InputMaybe<User_Order_By>;
  reason?: InputMaybe<Reasons_Order_By>;
  reason_id?: InputMaybe<Order_By>;
  reason_note?: InputMaybe<Order_By>;
};

/** primary key columns input for table: customer_asset_audit_log */
export type Customer_Asset_Audit_Log_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Customer_Asset_Audit_Log_Prepend_Input = {
  after_state?: InputMaybe<Scalars['jsonb']['input']>;
  before_state?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "customer_asset_audit_log" */
export enum Customer_Asset_Audit_Log_Select_Column {
  /** column name */
  Action = 'action',
  /** column name */
  AfterState = 'after_state',
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  BeforeState = 'before_state',
  /** column name */
  ChangedFields = 'changed_fields',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  ReasonId = 'reason_id',
  /** column name */
  ReasonNote = 'reason_note'
}

/** select "customer_asset_audit_log_aggregate_bool_exp_bool_and_arguments_columns" columns of table "customer_asset_audit_log" */
export enum Customer_Asset_Audit_Log_Select_Column_Customer_Asset_Audit_Log_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "customer_asset_audit_log_aggregate_bool_exp_bool_or_arguments_columns" columns of table "customer_asset_audit_log" */
export enum Customer_Asset_Audit_Log_Select_Column_Customer_Asset_Audit_Log_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "customer_asset_audit_log" */
export type Customer_Asset_Audit_Log_Set_Input = {
  action?: InputMaybe<Scalars['String']['input']>;
  after_state?: InputMaybe<Scalars['jsonb']['input']>;
  asset_id?: InputMaybe<Scalars['uuid']['input']>;
  before_state?: InputMaybe<Scalars['jsonb']['input']>;
  /** Array of column names that changed during this audit event */
  changed_fields?: InputMaybe<Array<Scalars['String']['input']>>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  reason_id?: InputMaybe<Scalars['uuid']['input']>;
  reason_note?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "customer_asset_audit_log" */
export type Customer_Asset_Audit_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Asset_Audit_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customer_Asset_Audit_Log_Stream_Cursor_Value_Input = {
  action?: InputMaybe<Scalars['String']['input']>;
  after_state?: InputMaybe<Scalars['jsonb']['input']>;
  asset_id?: InputMaybe<Scalars['uuid']['input']>;
  before_state?: InputMaybe<Scalars['jsonb']['input']>;
  /** Array of column names that changed during this audit event */
  changed_fields?: InputMaybe<Array<Scalars['String']['input']>>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  reason_id?: InputMaybe<Scalars['uuid']['input']>;
  reason_note?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "customer_asset_audit_log" */
export enum Customer_Asset_Audit_Log_Update_Column {
  /** column name */
  Action = 'action',
  /** column name */
  AfterState = 'after_state',
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  BeforeState = 'before_state',
  /** column name */
  ChangedFields = 'changed_fields',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  ReasonId = 'reason_id',
  /** column name */
  ReasonNote = 'reason_note'
}

export type Customer_Asset_Audit_Log_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Customer_Asset_Audit_Log_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Customer_Asset_Audit_Log_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Customer_Asset_Audit_Log_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Customer_Asset_Audit_Log_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Customer_Asset_Audit_Log_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Asset_Audit_Log_Set_Input>;
  /** filter the rows which have to be updated */
  where: Customer_Asset_Audit_Log_Bool_Exp;
};

/** aggregate avg on columns */
export type Customer_Asset_Avg_Fields = {
  __typename?: 'customer_asset_avg_fields';
  ideal_utilisation?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "customer_asset" */
export type Customer_Asset_Avg_Order_By = {
  ideal_utilisation?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "customer_asset". All fields are combined with a logical 'AND'. */
export type Customer_Asset_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Asset_Bool_Exp>>;
  _not?: InputMaybe<Customer_Asset_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Asset_Bool_Exp>>;
  asset_grouping_customer_assets?: InputMaybe<Asset_Grouping_Customer_Asset_Bool_Exp>;
  asset_grouping_customer_assets_aggregate?: InputMaybe<Asset_Grouping_Customer_Asset_Aggregate_Bool_Exp>;
  asset_subsidiaries?: InputMaybe<Asset_Subsidiary_Bool_Exp>;
  asset_subsidiaries_aggregate?: InputMaybe<Asset_Subsidiary_Aggregate_Bool_Exp>;
  asset_subsidiary_audit_logs?: InputMaybe<Asset_Subsidiary_Audit_Logs_Bool_Exp>;
  asset_subsidiary_audit_logs_aggregate?: InputMaybe<Asset_Subsidiary_Audit_Logs_Aggregate_Bool_Exp>;
  asset_type?: InputMaybe<Asset_Type_Bool_Exp>;
  asset_type_id?: InputMaybe<Uuid_Comparison_Exp>;
  capacity?: InputMaybe<String_Comparison_Exp>;
  chassis_number?: InputMaybe<String_Comparison_Exp>;
  color?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  customer_asset_audits?: InputMaybe<Customer_Asset_Audit_Log_Bool_Exp>;
  customer_asset_audits_aggregate?: InputMaybe<Customer_Asset_Audit_Log_Aggregate_Bool_Exp>;
  customer_asset_devices?: InputMaybe<Customer_Asset_Device_Bool_Exp>;
  customer_asset_devices_aggregate?: InputMaybe<Customer_Asset_Device_Aggregate_Bool_Exp>;
  customer_asset_dispensing_rules?: InputMaybe<Customer_Asset_Dispensing_Rules_Bool_Exp>;
  customer_asset_dispensing_rules_aggregate?: InputMaybe<Customer_Asset_Dispensing_Rules_Aggregate_Bool_Exp>;
  customer_asset_limits?: InputMaybe<Customer_Asset_Limit_Bool_Exp>;
  customer_asset_limits_aggregate?: InputMaybe<Customer_Asset_Limit_Aggregate_Bool_Exp>;
  customer_asset_tags?: InputMaybe<Customer_Asset_Tag_Bool_Exp>;
  customer_asset_tags_aggregate?: InputMaybe<Customer_Asset_Tag_Aggregate_Bool_Exp>;
  customer_order_customer_assets?: InputMaybe<Customer_Order_Customer_Asset_Bool_Exp>;
  customer_order_customer_assets_aggregate?: InputMaybe<Customer_Order_Customer_Asset_Aggregate_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  erp_code?: InputMaybe<String_Comparison_Exp>;
  fuel_card_number?: InputMaybe<String_Comparison_Exp>;
  fueltrans_asset_id?: InputMaybe<String_Comparison_Exp>;
  icon_prefix?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ideal_utilisation?: InputMaybe<Numeric_Comparison_Exp>;
  invoiced_items?: InputMaybe<Invoiced_Item_Bool_Exp>;
  invoiced_items_aggregate?: InputMaybe<Invoiced_Item_Aggregate_Bool_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_collect_odometer_reading?: InputMaybe<Boolean_Comparison_Exp>;
  is_odometer_verified?: InputMaybe<Boolean_Comparison_Exp>;
  is_test_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  make?: InputMaybe<String_Comparison_Exp>;
  modal?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order_scheduler_customer_assets?: InputMaybe<Order_Scheduler_Customer_Asset_Bool_Exp>;
  order_scheduler_customer_assets_aggregate?: InputMaybe<Order_Scheduler_Customer_Asset_Aggregate_Bool_Exp>;
  organization_user?: InputMaybe<Organization_User_Bool_Exp>;
  organization_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner_order_customer_assets?: InputMaybe<Partner_Order_Customer_Asset_Bool_Exp>;
  partner_order_customer_assets_aggregate?: InputMaybe<Partner_Order_Customer_Asset_Aggregate_Bool_Exp>;
  plate_code?: InputMaybe<String_Comparison_Exp>;
  plate_number?: InputMaybe<String_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  product_id?: InputMaybe<Uuid_Comparison_Exp>;
  reason?: InputMaybe<Reasons_Bool_Exp>;
  reason_id?: InputMaybe<Uuid_Comparison_Exp>;
  reason_note?: InputMaybe<String_Comparison_Exp>;
  registration_number?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<State_Bool_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  subsidiary_id?: InputMaybe<Uuid_Comparison_Exp>;
  tag_id?: InputMaybe<String_Comparison_Exp>;
  task_values?: InputMaybe<Task_Value_Bool_Exp>;
  task_values_aggregate?: InputMaybe<Task_Value_Aggregate_Bool_Exp>;
  tickets?: InputMaybe<Tickets_Bool_Exp>;
  tickets_aggregate?: InputMaybe<Tickets_Aggregate_Bool_Exp>;
  trip_plans?: InputMaybe<Trip_Plan_Bool_Exp>;
  trip_plans_aggregate?: InputMaybe<Trip_Plan_Aggregate_Bool_Exp>;
  view_daily_asset_limit?: InputMaybe<View_Daily_Asset_Limit_Bool_Exp>;
  view_daily_asset_limit_aggregate?: InputMaybe<View_Daily_Asset_Limit_Aggregate_Bool_Exp>;
  view_monthly_asset_limit?: InputMaybe<View_Monthly_Asset_Limit_Bool_Exp>;
  view_monthly_asset_limit_aggregate?: InputMaybe<View_Monthly_Asset_Limit_Aggregate_Bool_Exp>;
  view_weekly_asset_limit?: InputMaybe<View_Weekly_Asset_Limit_Bool_Exp>;
  view_weekly_asset_limit_aggregate?: InputMaybe<View_Weekly_Asset_Limit_Aggregate_Bool_Exp>;
  wallet_ledgers?: InputMaybe<Wallet_Ledger_Bool_Exp>;
  wallet_ledgers_aggregate?: InputMaybe<Wallet_Ledger_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "customer_asset" */
export enum Customer_Asset_Constraint {
  /** unique or primary key constraint on columns "id" */
  CustomerAssetPkey = 'customer_asset_pkey'
}

/** columns and relationships of "customer_asset_device" */
export type Customer_Asset_Device = {
  __typename?: 'customer_asset_device';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  customer_asset: Customer_Asset;
  /** An array relationship */
  customer_asset_device_calibrations: Array<Customer_Asset_Device_Calibration>;
  /** An aggregate relationship */
  customer_asset_device_calibrations_aggregate: Customer_Asset_Device_Calibration_Aggregate;
  customer_asset_id: Scalars['uuid']['output'];
  device_id: Scalars['numeric']['output'];
  device_type_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  devicetype?: Maybe<Devicetype>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "customer_asset_device" */
export type Customer_Asset_DeviceCustomer_Asset_Device_CalibrationsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Device_Calibration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Device_Calibration_Order_By>>;
  where?: InputMaybe<Customer_Asset_Device_Calibration_Bool_Exp>;
};


/** columns and relationships of "customer_asset_device" */
export type Customer_Asset_DeviceCustomer_Asset_Device_Calibrations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Device_Calibration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Device_Calibration_Order_By>>;
  where?: InputMaybe<Customer_Asset_Device_Calibration_Bool_Exp>;
};

/** aggregated selection of "customer_asset_device" */
export type Customer_Asset_Device_Aggregate = {
  __typename?: 'customer_asset_device_aggregate';
  aggregate?: Maybe<Customer_Asset_Device_Aggregate_Fields>;
  nodes: Array<Customer_Asset_Device>;
};

export type Customer_Asset_Device_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Customer_Asset_Device_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Customer_Asset_Device_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Customer_Asset_Device_Aggregate_Bool_Exp_Count>;
};

export type Customer_Asset_Device_Aggregate_Bool_Exp_Bool_And = {
  arguments: Customer_Asset_Device_Select_Column_Customer_Asset_Device_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Asset_Device_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customer_Asset_Device_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Customer_Asset_Device_Select_Column_Customer_Asset_Device_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Asset_Device_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customer_Asset_Device_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Customer_Asset_Device_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Asset_Device_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "customer_asset_device" */
export type Customer_Asset_Device_Aggregate_Fields = {
  __typename?: 'customer_asset_device_aggregate_fields';
  avg?: Maybe<Customer_Asset_Device_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Customer_Asset_Device_Max_Fields>;
  min?: Maybe<Customer_Asset_Device_Min_Fields>;
  stddev?: Maybe<Customer_Asset_Device_Stddev_Fields>;
  stddev_pop?: Maybe<Customer_Asset_Device_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Customer_Asset_Device_Stddev_Samp_Fields>;
  sum?: Maybe<Customer_Asset_Device_Sum_Fields>;
  var_pop?: Maybe<Customer_Asset_Device_Var_Pop_Fields>;
  var_samp?: Maybe<Customer_Asset_Device_Var_Samp_Fields>;
  variance?: Maybe<Customer_Asset_Device_Variance_Fields>;
};


/** aggregate fields of "customer_asset_device" */
export type Customer_Asset_Device_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Asset_Device_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "customer_asset_device" */
export type Customer_Asset_Device_Aggregate_Order_By = {
  avg?: InputMaybe<Customer_Asset_Device_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Customer_Asset_Device_Max_Order_By>;
  min?: InputMaybe<Customer_Asset_Device_Min_Order_By>;
  stddev?: InputMaybe<Customer_Asset_Device_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Customer_Asset_Device_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Customer_Asset_Device_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Customer_Asset_Device_Sum_Order_By>;
  var_pop?: InputMaybe<Customer_Asset_Device_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Customer_Asset_Device_Var_Samp_Order_By>;
  variance?: InputMaybe<Customer_Asset_Device_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "customer_asset_device" */
export type Customer_Asset_Device_Arr_Rel_Insert_Input = {
  data: Array<Customer_Asset_Device_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Asset_Device_On_Conflict>;
};

/** aggregate avg on columns */
export type Customer_Asset_Device_Avg_Fields = {
  __typename?: 'customer_asset_device_avg_fields';
  device_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "customer_asset_device" */
export type Customer_Asset_Device_Avg_Order_By = {
  device_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "customer_asset_device". All fields are combined with a logical 'AND'. */
export type Customer_Asset_Device_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Asset_Device_Bool_Exp>>;
  _not?: InputMaybe<Customer_Asset_Device_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Asset_Device_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_asset?: InputMaybe<Customer_Asset_Bool_Exp>;
  customer_asset_device_calibrations?: InputMaybe<Customer_Asset_Device_Calibration_Bool_Exp>;
  customer_asset_device_calibrations_aggregate?: InputMaybe<Customer_Asset_Device_Calibration_Aggregate_Bool_Exp>;
  customer_asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  device_id?: InputMaybe<Numeric_Comparison_Exp>;
  device_type_id?: InputMaybe<Uuid_Comparison_Exp>;
  devicetype?: InputMaybe<Devicetype_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
};

/** columns and relationships of "customer_asset_device_calibration" */
export type Customer_Asset_Device_Calibration = {
  __typename?: 'customer_asset_device_calibration';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  customer_asset_device: Customer_Asset_Device;
  customer_asset_device_id: Scalars['uuid']['output'];
  /** An object relationship */
  devicetypeParamerterDefinitionByTargetDevicetypeParamerterDefinitionId?: Maybe<Devicetype_Paramerter_Definition>;
  /** An object relationship */
  devicetype_paramerter_definition: Devicetype_Paramerter_Definition;
  devicetype_paramerter_definition_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  target_devicetype_paramerter_definition_id?: Maybe<Scalars['uuid']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "customer_asset_device_calibration" */
export type Customer_Asset_Device_Calibration_Aggregate = {
  __typename?: 'customer_asset_device_calibration_aggregate';
  aggregate?: Maybe<Customer_Asset_Device_Calibration_Aggregate_Fields>;
  nodes: Array<Customer_Asset_Device_Calibration>;
};

export type Customer_Asset_Device_Calibration_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Customer_Asset_Device_Calibration_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Customer_Asset_Device_Calibration_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Customer_Asset_Device_Calibration_Aggregate_Bool_Exp_Count>;
};

export type Customer_Asset_Device_Calibration_Aggregate_Bool_Exp_Bool_And = {
  arguments: Customer_Asset_Device_Calibration_Select_Column_Customer_Asset_Device_Calibration_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Asset_Device_Calibration_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customer_Asset_Device_Calibration_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Customer_Asset_Device_Calibration_Select_Column_Customer_Asset_Device_Calibration_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Asset_Device_Calibration_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customer_Asset_Device_Calibration_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Customer_Asset_Device_Calibration_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Asset_Device_Calibration_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "customer_asset_device_calibration" */
export type Customer_Asset_Device_Calibration_Aggregate_Fields = {
  __typename?: 'customer_asset_device_calibration_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Customer_Asset_Device_Calibration_Max_Fields>;
  min?: Maybe<Customer_Asset_Device_Calibration_Min_Fields>;
};


/** aggregate fields of "customer_asset_device_calibration" */
export type Customer_Asset_Device_Calibration_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Asset_Device_Calibration_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "customer_asset_device_calibration" */
export type Customer_Asset_Device_Calibration_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Customer_Asset_Device_Calibration_Max_Order_By>;
  min?: InputMaybe<Customer_Asset_Device_Calibration_Min_Order_By>;
};

/** input type for inserting array relation for remote table "customer_asset_device_calibration" */
export type Customer_Asset_Device_Calibration_Arr_Rel_Insert_Input = {
  data: Array<Customer_Asset_Device_Calibration_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Asset_Device_Calibration_On_Conflict>;
};

/** Boolean expression to filter rows from the table "customer_asset_device_calibration". All fields are combined with a logical 'AND'. */
export type Customer_Asset_Device_Calibration_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Asset_Device_Calibration_Bool_Exp>>;
  _not?: InputMaybe<Customer_Asset_Device_Calibration_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Asset_Device_Calibration_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_asset_device?: InputMaybe<Customer_Asset_Device_Bool_Exp>;
  customer_asset_device_id?: InputMaybe<Uuid_Comparison_Exp>;
  devicetypeParamerterDefinitionByTargetDevicetypeParamerterDefinitionId?: InputMaybe<Devicetype_Paramerter_Definition_Bool_Exp>;
  devicetype_paramerter_definition?: InputMaybe<Devicetype_Paramerter_Definition_Bool_Exp>;
  devicetype_paramerter_definition_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  target_devicetype_paramerter_definition_id?: InputMaybe<Uuid_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "customer_asset_device_calibration" */
export enum Customer_Asset_Device_Calibration_Constraint {
  /** unique or primary key constraint on columns "id" */
  CustomerAssetDeviceCalibrationPkey = 'customer_asset_device_calibration_pkey'
}

/** input type for inserting data into table "customer_asset_device_calibration" */
export type Customer_Asset_Device_Calibration_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_asset_device?: InputMaybe<Customer_Asset_Device_Obj_Rel_Insert_Input>;
  customer_asset_device_id?: InputMaybe<Scalars['uuid']['input']>;
  devicetypeParamerterDefinitionByTargetDevicetypeParamerterDefinitionId?: InputMaybe<Devicetype_Paramerter_Definition_Obj_Rel_Insert_Input>;
  devicetype_paramerter_definition?: InputMaybe<Devicetype_Paramerter_Definition_Obj_Rel_Insert_Input>;
  devicetype_paramerter_definition_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  target_devicetype_paramerter_definition_id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Customer_Asset_Device_Calibration_Max_Fields = {
  __typename?: 'customer_asset_device_calibration_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_asset_device_id?: Maybe<Scalars['uuid']['output']>;
  devicetype_paramerter_definition_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  target_devicetype_paramerter_definition_id?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "customer_asset_device_calibration" */
export type Customer_Asset_Device_Calibration_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_asset_device_id?: InputMaybe<Order_By>;
  devicetype_paramerter_definition_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  target_devicetype_paramerter_definition_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Customer_Asset_Device_Calibration_Min_Fields = {
  __typename?: 'customer_asset_device_calibration_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_asset_device_id?: Maybe<Scalars['uuid']['output']>;
  devicetype_paramerter_definition_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  target_devicetype_paramerter_definition_id?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "customer_asset_device_calibration" */
export type Customer_Asset_Device_Calibration_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_asset_device_id?: InputMaybe<Order_By>;
  devicetype_paramerter_definition_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  target_devicetype_paramerter_definition_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "customer_asset_device_calibration" */
export type Customer_Asset_Device_Calibration_Mutation_Response = {
  __typename?: 'customer_asset_device_calibration_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Customer_Asset_Device_Calibration>;
};

/** on_conflict condition type for table "customer_asset_device_calibration" */
export type Customer_Asset_Device_Calibration_On_Conflict = {
  constraint: Customer_Asset_Device_Calibration_Constraint;
  update_columns?: Array<Customer_Asset_Device_Calibration_Update_Column>;
  where?: InputMaybe<Customer_Asset_Device_Calibration_Bool_Exp>;
};

/** Ordering options when selecting data from "customer_asset_device_calibration". */
export type Customer_Asset_Device_Calibration_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_asset_device?: InputMaybe<Customer_Asset_Device_Order_By>;
  customer_asset_device_id?: InputMaybe<Order_By>;
  devicetypeParamerterDefinitionByTargetDevicetypeParamerterDefinitionId?: InputMaybe<Devicetype_Paramerter_Definition_Order_By>;
  devicetype_paramerter_definition?: InputMaybe<Devicetype_Paramerter_Definition_Order_By>;
  devicetype_paramerter_definition_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  target_devicetype_paramerter_definition_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: customer_asset_device_calibration */
export type Customer_Asset_Device_Calibration_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "customer_asset_device_calibration" */
export enum Customer_Asset_Device_Calibration_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerAssetDeviceId = 'customer_asset_device_id',
  /** column name */
  DevicetypeParamerterDefinitionId = 'devicetype_paramerter_definition_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Key = 'key',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  TargetDevicetypeParamerterDefinitionId = 'target_devicetype_paramerter_definition_id',
  /** column name */
  Value = 'value'
}

/** select "customer_asset_device_calibration_aggregate_bool_exp_bool_and_arguments_columns" columns of table "customer_asset_device_calibration" */
export enum Customer_Asset_Device_Calibration_Select_Column_Customer_Asset_Device_Calibration_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "customer_asset_device_calibration_aggregate_bool_exp_bool_or_arguments_columns" columns of table "customer_asset_device_calibration" */
export enum Customer_Asset_Device_Calibration_Select_Column_Customer_Asset_Device_Calibration_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "customer_asset_device_calibration" */
export type Customer_Asset_Device_Calibration_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_asset_device_id?: InputMaybe<Scalars['uuid']['input']>;
  devicetype_paramerter_definition_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  target_devicetype_paramerter_definition_id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "customer_asset_device_calibration" */
export type Customer_Asset_Device_Calibration_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Asset_Device_Calibration_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customer_Asset_Device_Calibration_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_asset_device_id?: InputMaybe<Scalars['uuid']['input']>;
  devicetype_paramerter_definition_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  target_devicetype_paramerter_definition_id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "customer_asset_device_calibration" */
export enum Customer_Asset_Device_Calibration_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerAssetDeviceId = 'customer_asset_device_id',
  /** column name */
  DevicetypeParamerterDefinitionId = 'devicetype_paramerter_definition_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Key = 'key',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  TargetDevicetypeParamerterDefinitionId = 'target_devicetype_paramerter_definition_id',
  /** column name */
  Value = 'value'
}

export type Customer_Asset_Device_Calibration_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Asset_Device_Calibration_Set_Input>;
  /** filter the rows which have to be updated */
  where: Customer_Asset_Device_Calibration_Bool_Exp;
};

/** unique or primary key constraints on table "customer_asset_device" */
export enum Customer_Asset_Device_Constraint {
  /** unique or primary key constraint on columns "id" */
  CustomerAssetDevicePkey = 'customer_asset_device_pkey'
}

/** input type for incrementing numeric columns in table "customer_asset_device" */
export type Customer_Asset_Device_Inc_Input = {
  device_id?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "customer_asset_device" */
export type Customer_Asset_Device_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_asset?: InputMaybe<Customer_Asset_Obj_Rel_Insert_Input>;
  customer_asset_device_calibrations?: InputMaybe<Customer_Asset_Device_Calibration_Arr_Rel_Insert_Input>;
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  device_id?: InputMaybe<Scalars['numeric']['input']>;
  device_type_id?: InputMaybe<Scalars['uuid']['input']>;
  devicetype?: InputMaybe<Devicetype_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Customer_Asset_Device_Max_Fields = {
  __typename?: 'customer_asset_device_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  device_id?: Maybe<Scalars['numeric']['output']>;
  device_type_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "customer_asset_device" */
export type Customer_Asset_Device_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  device_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Customer_Asset_Device_Min_Fields = {
  __typename?: 'customer_asset_device_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  device_id?: Maybe<Scalars['numeric']['output']>;
  device_type_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "customer_asset_device" */
export type Customer_Asset_Device_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  device_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "customer_asset_device" */
export type Customer_Asset_Device_Mutation_Response = {
  __typename?: 'customer_asset_device_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Customer_Asset_Device>;
};

/** input type for inserting object relation for remote table "customer_asset_device" */
export type Customer_Asset_Device_Obj_Rel_Insert_Input = {
  data: Customer_Asset_Device_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Asset_Device_On_Conflict>;
};

/** on_conflict condition type for table "customer_asset_device" */
export type Customer_Asset_Device_On_Conflict = {
  constraint: Customer_Asset_Device_Constraint;
  update_columns?: Array<Customer_Asset_Device_Update_Column>;
  where?: InputMaybe<Customer_Asset_Device_Bool_Exp>;
};

/** Ordering options when selecting data from "customer_asset_device". */
export type Customer_Asset_Device_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_asset?: InputMaybe<Customer_Asset_Order_By>;
  customer_asset_device_calibrations_aggregate?: InputMaybe<Customer_Asset_Device_Calibration_Aggregate_Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  device_type_id?: InputMaybe<Order_By>;
  devicetype?: InputMaybe<Devicetype_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: customer_asset_device */
export type Customer_Asset_Device_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "customer_asset_device" */
export enum Customer_Asset_Device_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerAssetId = 'customer_asset_id',
  /** column name */
  DeviceId = 'device_id',
  /** column name */
  DeviceTypeId = 'device_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by'
}

/** select "customer_asset_device_aggregate_bool_exp_bool_and_arguments_columns" columns of table "customer_asset_device" */
export enum Customer_Asset_Device_Select_Column_Customer_Asset_Device_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "customer_asset_device_aggregate_bool_exp_bool_or_arguments_columns" columns of table "customer_asset_device" */
export enum Customer_Asset_Device_Select_Column_Customer_Asset_Device_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "customer_asset_device" */
export type Customer_Asset_Device_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  device_id?: InputMaybe<Scalars['numeric']['input']>;
  device_type_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Customer_Asset_Device_Stddev_Fields = {
  __typename?: 'customer_asset_device_stddev_fields';
  device_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "customer_asset_device" */
export type Customer_Asset_Device_Stddev_Order_By = {
  device_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Customer_Asset_Device_Stddev_Pop_Fields = {
  __typename?: 'customer_asset_device_stddev_pop_fields';
  device_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "customer_asset_device" */
export type Customer_Asset_Device_Stddev_Pop_Order_By = {
  device_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Customer_Asset_Device_Stddev_Samp_Fields = {
  __typename?: 'customer_asset_device_stddev_samp_fields';
  device_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "customer_asset_device" */
export type Customer_Asset_Device_Stddev_Samp_Order_By = {
  device_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "customer_asset_device" */
export type Customer_Asset_Device_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Asset_Device_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customer_Asset_Device_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  device_id?: InputMaybe<Scalars['numeric']['input']>;
  device_type_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Customer_Asset_Device_Sum_Fields = {
  __typename?: 'customer_asset_device_sum_fields';
  device_id?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "customer_asset_device" */
export type Customer_Asset_Device_Sum_Order_By = {
  device_id?: InputMaybe<Order_By>;
};

/** update columns of table "customer_asset_device" */
export enum Customer_Asset_Device_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerAssetId = 'customer_asset_id',
  /** column name */
  DeviceId = 'device_id',
  /** column name */
  DeviceTypeId = 'device_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by'
}

export type Customer_Asset_Device_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Customer_Asset_Device_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Asset_Device_Set_Input>;
  /** filter the rows which have to be updated */
  where: Customer_Asset_Device_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Customer_Asset_Device_Var_Pop_Fields = {
  __typename?: 'customer_asset_device_var_pop_fields';
  device_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "customer_asset_device" */
export type Customer_Asset_Device_Var_Pop_Order_By = {
  device_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Customer_Asset_Device_Var_Samp_Fields = {
  __typename?: 'customer_asset_device_var_samp_fields';
  device_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "customer_asset_device" */
export type Customer_Asset_Device_Var_Samp_Order_By = {
  device_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Customer_Asset_Device_Variance_Fields = {
  __typename?: 'customer_asset_device_variance_fields';
  device_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "customer_asset_device" */
export type Customer_Asset_Device_Variance_Order_By = {
  device_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "customer_asset_dispensing_rules" */
export type Customer_Asset_Dispensing_Rules = {
  __typename?: 'customer_asset_dispensing_rules';
  created_at: Scalars['timestamp']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  customer_asset: Customer_Asset;
  customer_asset_id: Scalars['uuid']['output'];
  /** An object relationship */
  dispensing_rule: Dispensing_Rules;
  dispensing_rule_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified: Scalars['timestamp']['output'];
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "customer_asset_dispensing_rules" */
export type Customer_Asset_Dispensing_Rules_Aggregate = {
  __typename?: 'customer_asset_dispensing_rules_aggregate';
  aggregate?: Maybe<Customer_Asset_Dispensing_Rules_Aggregate_Fields>;
  nodes: Array<Customer_Asset_Dispensing_Rules>;
};

export type Customer_Asset_Dispensing_Rules_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Customer_Asset_Dispensing_Rules_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Customer_Asset_Dispensing_Rules_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Customer_Asset_Dispensing_Rules_Aggregate_Bool_Exp_Count>;
};

export type Customer_Asset_Dispensing_Rules_Aggregate_Bool_Exp_Bool_And = {
  arguments: Customer_Asset_Dispensing_Rules_Select_Column_Customer_Asset_Dispensing_Rules_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Asset_Dispensing_Rules_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customer_Asset_Dispensing_Rules_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Customer_Asset_Dispensing_Rules_Select_Column_Customer_Asset_Dispensing_Rules_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Asset_Dispensing_Rules_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customer_Asset_Dispensing_Rules_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Customer_Asset_Dispensing_Rules_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Asset_Dispensing_Rules_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "customer_asset_dispensing_rules" */
export type Customer_Asset_Dispensing_Rules_Aggregate_Fields = {
  __typename?: 'customer_asset_dispensing_rules_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Customer_Asset_Dispensing_Rules_Max_Fields>;
  min?: Maybe<Customer_Asset_Dispensing_Rules_Min_Fields>;
};


/** aggregate fields of "customer_asset_dispensing_rules" */
export type Customer_Asset_Dispensing_Rules_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Asset_Dispensing_Rules_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "customer_asset_dispensing_rules" */
export type Customer_Asset_Dispensing_Rules_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Customer_Asset_Dispensing_Rules_Max_Order_By>;
  min?: InputMaybe<Customer_Asset_Dispensing_Rules_Min_Order_By>;
};

/** input type for inserting array relation for remote table "customer_asset_dispensing_rules" */
export type Customer_Asset_Dispensing_Rules_Arr_Rel_Insert_Input = {
  data: Array<Customer_Asset_Dispensing_Rules_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Asset_Dispensing_Rules_On_Conflict>;
};

/** Boolean expression to filter rows from the table "customer_asset_dispensing_rules". All fields are combined with a logical 'AND'. */
export type Customer_Asset_Dispensing_Rules_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Asset_Dispensing_Rules_Bool_Exp>>;
  _not?: InputMaybe<Customer_Asset_Dispensing_Rules_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Asset_Dispensing_Rules_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  customer_asset?: InputMaybe<Customer_Asset_Bool_Exp>;
  customer_asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  dispensing_rule?: InputMaybe<Dispensing_Rules_Bool_Exp>;
  dispensing_rule_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "customer_asset_dispensing_rules" */
export enum Customer_Asset_Dispensing_Rules_Constraint {
  /** unique or primary key constraint on columns "customer_asset_id", "dispensing_rule_id" */
  CustomerAssetDispensingRulesDispensingRuleIdCustomerAss = 'customer_asset_dispensing_rules_dispensing_rule_id_customer_ass',
  /** unique or primary key constraint on columns "id" */
  CustomerAssetDispensingRulesPkey = 'customer_asset_dispensing_rules_pkey'
}

/** input type for inserting data into table "customer_asset_dispensing_rules" */
export type Customer_Asset_Dispensing_Rules_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  customer_asset?: InputMaybe<Customer_Asset_Obj_Rel_Insert_Input>;
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  dispensing_rule?: InputMaybe<Dispensing_Rules_Obj_Rel_Insert_Input>;
  dispensing_rule_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Customer_Asset_Dispensing_Rules_Max_Fields = {
  __typename?: 'customer_asset_dispensing_rules_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  dispensing_rule_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "customer_asset_dispensing_rules" */
export type Customer_Asset_Dispensing_Rules_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  dispensing_rule_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Customer_Asset_Dispensing_Rules_Min_Fields = {
  __typename?: 'customer_asset_dispensing_rules_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  dispensing_rule_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "customer_asset_dispensing_rules" */
export type Customer_Asset_Dispensing_Rules_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  dispensing_rule_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "customer_asset_dispensing_rules" */
export type Customer_Asset_Dispensing_Rules_Mutation_Response = {
  __typename?: 'customer_asset_dispensing_rules_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Customer_Asset_Dispensing_Rules>;
};

/** on_conflict condition type for table "customer_asset_dispensing_rules" */
export type Customer_Asset_Dispensing_Rules_On_Conflict = {
  constraint: Customer_Asset_Dispensing_Rules_Constraint;
  update_columns?: Array<Customer_Asset_Dispensing_Rules_Update_Column>;
  where?: InputMaybe<Customer_Asset_Dispensing_Rules_Bool_Exp>;
};

/** Ordering options when selecting data from "customer_asset_dispensing_rules". */
export type Customer_Asset_Dispensing_Rules_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  customer_asset?: InputMaybe<Customer_Asset_Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  dispensing_rule?: InputMaybe<Dispensing_Rules_Order_By>;
  dispensing_rule_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: customer_asset_dispensing_rules */
export type Customer_Asset_Dispensing_Rules_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "customer_asset_dispensing_rules" */
export enum Customer_Asset_Dispensing_Rules_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CustomerAssetId = 'customer_asset_id',
  /** column name */
  DispensingRuleId = 'dispensing_rule_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by'
}

/** select "customer_asset_dispensing_rules_aggregate_bool_exp_bool_and_arguments_columns" columns of table "customer_asset_dispensing_rules" */
export enum Customer_Asset_Dispensing_Rules_Select_Column_Customer_Asset_Dispensing_Rules_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "customer_asset_dispensing_rules_aggregate_bool_exp_bool_or_arguments_columns" columns of table "customer_asset_dispensing_rules" */
export enum Customer_Asset_Dispensing_Rules_Select_Column_Customer_Asset_Dispensing_Rules_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "customer_asset_dispensing_rules" */
export type Customer_Asset_Dispensing_Rules_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  dispensing_rule_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "customer_asset_dispensing_rules" */
export type Customer_Asset_Dispensing_Rules_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Asset_Dispensing_Rules_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customer_Asset_Dispensing_Rules_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  dispensing_rule_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "customer_asset_dispensing_rules" */
export enum Customer_Asset_Dispensing_Rules_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CustomerAssetId = 'customer_asset_id',
  /** column name */
  DispensingRuleId = 'dispensing_rule_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by'
}

export type Customer_Asset_Dispensing_Rules_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Asset_Dispensing_Rules_Set_Input>;
  /** filter the rows which have to be updated */
  where: Customer_Asset_Dispensing_Rules_Bool_Exp;
};

/** input type for incrementing numeric columns in table "customer_asset" */
export type Customer_Asset_Inc_Input = {
  ideal_utilisation?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "customer_asset" */
export type Customer_Asset_Insert_Input = {
  asset_grouping_customer_assets?: InputMaybe<Asset_Grouping_Customer_Asset_Arr_Rel_Insert_Input>;
  asset_subsidiaries?: InputMaybe<Asset_Subsidiary_Arr_Rel_Insert_Input>;
  asset_subsidiary_audit_logs?: InputMaybe<Asset_Subsidiary_Audit_Logs_Arr_Rel_Insert_Input>;
  asset_type?: InputMaybe<Asset_Type_Obj_Rel_Insert_Input>;
  asset_type_id?: InputMaybe<Scalars['uuid']['input']>;
  capacity?: InputMaybe<Scalars['String']['input']>;
  chassis_number?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  customer_asset_audits?: InputMaybe<Customer_Asset_Audit_Log_Arr_Rel_Insert_Input>;
  customer_asset_devices?: InputMaybe<Customer_Asset_Device_Arr_Rel_Insert_Input>;
  customer_asset_dispensing_rules?: InputMaybe<Customer_Asset_Dispensing_Rules_Arr_Rel_Insert_Input>;
  customer_asset_limits?: InputMaybe<Customer_Asset_Limit_Arr_Rel_Insert_Input>;
  customer_asset_tags?: InputMaybe<Customer_Asset_Tag_Arr_Rel_Insert_Input>;
  customer_order_customer_assets?: InputMaybe<Customer_Order_Customer_Asset_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']['input']>;
  erp_code?: InputMaybe<Scalars['String']['input']>;
  fuel_card_number?: InputMaybe<Scalars['String']['input']>;
  fueltrans_asset_id?: InputMaybe<Scalars['String']['input']>;
  icon_prefix?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ideal_utilisation?: InputMaybe<Scalars['numeric']['input']>;
  invoiced_items?: InputMaybe<Invoiced_Item_Arr_Rel_Insert_Input>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_collect_odometer_reading?: InputMaybe<Scalars['Boolean']['input']>;
  is_odometer_verified?: InputMaybe<Scalars['Boolean']['input']>;
  is_test_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  modal?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_scheduler_customer_assets?: InputMaybe<Order_Scheduler_Customer_Asset_Arr_Rel_Insert_Input>;
  organization_user?: InputMaybe<Organization_User_Obj_Rel_Insert_Input>;
  /** Optional reference to organization user. Can be NULL when asset belongs to organization as a whole rather than specific user. */
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_order_customer_assets?: InputMaybe<Partner_Order_Customer_Asset_Arr_Rel_Insert_Input>;
  plate_code?: InputMaybe<Scalars['String']['input']>;
  plate_number?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
  reason?: InputMaybe<Reasons_Obj_Rel_Insert_Input>;
  reason_id?: InputMaybe<Scalars['uuid']['input']>;
  reason_note?: InputMaybe<Scalars['String']['input']>;
  registration_number?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<State_Obj_Rel_Insert_Input>;
  state_id?: InputMaybe<Scalars['uuid']['input']>;
  subsidiary_id?: InputMaybe<Scalars['uuid']['input']>;
  tag_id?: InputMaybe<Scalars['String']['input']>;
  task_values?: InputMaybe<Task_Value_Arr_Rel_Insert_Input>;
  tickets?: InputMaybe<Tickets_Arr_Rel_Insert_Input>;
  trip_plans?: InputMaybe<Trip_Plan_Arr_Rel_Insert_Input>;
  view_daily_asset_limit?: InputMaybe<View_Daily_Asset_Limit_Arr_Rel_Insert_Input>;
  view_monthly_asset_limit?: InputMaybe<View_Monthly_Asset_Limit_Arr_Rel_Insert_Input>;
  view_weekly_asset_limit?: InputMaybe<View_Weekly_Asset_Limit_Arr_Rel_Insert_Input>;
  wallet_ledgers?: InputMaybe<Wallet_Ledger_Arr_Rel_Insert_Input>;
};

/** columns and relationships of "customer_asset_limit" */
export type Customer_Asset_Limit = {
  __typename?: 'customer_asset_limit';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  customer_asset: Customer_Asset;
  customer_asset_id: Scalars['uuid']['output'];
  end_date: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  pending_quantity: Scalars['numeric']['output'];
  quantity: Scalars['numeric']['output'];
  start_date: Scalars['timestamptz']['output'];
  used_quantity: Scalars['numeric']['output'];
};

/** aggregated selection of "customer_asset_limit" */
export type Customer_Asset_Limit_Aggregate = {
  __typename?: 'customer_asset_limit_aggregate';
  aggregate?: Maybe<Customer_Asset_Limit_Aggregate_Fields>;
  nodes: Array<Customer_Asset_Limit>;
};

export type Customer_Asset_Limit_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Customer_Asset_Limit_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Customer_Asset_Limit_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Customer_Asset_Limit_Aggregate_Bool_Exp_Count>;
};

export type Customer_Asset_Limit_Aggregate_Bool_Exp_Bool_And = {
  arguments: Customer_Asset_Limit_Select_Column_Customer_Asset_Limit_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Asset_Limit_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customer_Asset_Limit_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Customer_Asset_Limit_Select_Column_Customer_Asset_Limit_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Asset_Limit_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customer_Asset_Limit_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Customer_Asset_Limit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Asset_Limit_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "customer_asset_limit" */
export type Customer_Asset_Limit_Aggregate_Fields = {
  __typename?: 'customer_asset_limit_aggregate_fields';
  avg?: Maybe<Customer_Asset_Limit_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Customer_Asset_Limit_Max_Fields>;
  min?: Maybe<Customer_Asset_Limit_Min_Fields>;
  stddev?: Maybe<Customer_Asset_Limit_Stddev_Fields>;
  stddev_pop?: Maybe<Customer_Asset_Limit_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Customer_Asset_Limit_Stddev_Samp_Fields>;
  sum?: Maybe<Customer_Asset_Limit_Sum_Fields>;
  var_pop?: Maybe<Customer_Asset_Limit_Var_Pop_Fields>;
  var_samp?: Maybe<Customer_Asset_Limit_Var_Samp_Fields>;
  variance?: Maybe<Customer_Asset_Limit_Variance_Fields>;
};


/** aggregate fields of "customer_asset_limit" */
export type Customer_Asset_Limit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Asset_Limit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "customer_asset_limit" */
export type Customer_Asset_Limit_Aggregate_Order_By = {
  avg?: InputMaybe<Customer_Asset_Limit_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Customer_Asset_Limit_Max_Order_By>;
  min?: InputMaybe<Customer_Asset_Limit_Min_Order_By>;
  stddev?: InputMaybe<Customer_Asset_Limit_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Customer_Asset_Limit_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Customer_Asset_Limit_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Customer_Asset_Limit_Sum_Order_By>;
  var_pop?: InputMaybe<Customer_Asset_Limit_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Customer_Asset_Limit_Var_Samp_Order_By>;
  variance?: InputMaybe<Customer_Asset_Limit_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "customer_asset_limit" */
export type Customer_Asset_Limit_Arr_Rel_Insert_Input = {
  data: Array<Customer_Asset_Limit_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Asset_Limit_On_Conflict>;
};

/** aggregate avg on columns */
export type Customer_Asset_Limit_Avg_Fields = {
  __typename?: 'customer_asset_limit_avg_fields';
  pending_quantity?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  used_quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "customer_asset_limit" */
export type Customer_Asset_Limit_Avg_Order_By = {
  pending_quantity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  used_quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "customer_asset_limit". All fields are combined with a logical 'AND'. */
export type Customer_Asset_Limit_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Asset_Limit_Bool_Exp>>;
  _not?: InputMaybe<Customer_Asset_Limit_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Asset_Limit_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_asset?: InputMaybe<Customer_Asset_Bool_Exp>;
  customer_asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  end_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  pending_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  quantity?: InputMaybe<Numeric_Comparison_Exp>;
  start_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  used_quantity?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "customer_asset_limit" */
export enum Customer_Asset_Limit_Constraint {
  /** unique or primary key constraint on columns "id" */
  CustomerAssetLimitPkey = 'customer_asset_limit_pkey'
}

/** input type for incrementing numeric columns in table "customer_asset_limit" */
export type Customer_Asset_Limit_Inc_Input = {
  pending_quantity?: InputMaybe<Scalars['numeric']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  used_quantity?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "customer_asset_limit" */
export type Customer_Asset_Limit_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_asset?: InputMaybe<Customer_Asset_Obj_Rel_Insert_Input>;
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  end_date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  pending_quantity?: InputMaybe<Scalars['numeric']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  start_date?: InputMaybe<Scalars['timestamptz']['input']>;
  used_quantity?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Customer_Asset_Limit_Max_Fields = {
  __typename?: 'customer_asset_limit_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  end_date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  pending_quantity?: Maybe<Scalars['numeric']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
  start_date?: Maybe<Scalars['timestamptz']['output']>;
  used_quantity?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "customer_asset_limit" */
export type Customer_Asset_Limit_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  pending_quantity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  used_quantity?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Customer_Asset_Limit_Min_Fields = {
  __typename?: 'customer_asset_limit_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  end_date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  pending_quantity?: Maybe<Scalars['numeric']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
  start_date?: Maybe<Scalars['timestamptz']['output']>;
  used_quantity?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "customer_asset_limit" */
export type Customer_Asset_Limit_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  pending_quantity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  used_quantity?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "customer_asset_limit" */
export type Customer_Asset_Limit_Mutation_Response = {
  __typename?: 'customer_asset_limit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Customer_Asset_Limit>;
};

/** on_conflict condition type for table "customer_asset_limit" */
export type Customer_Asset_Limit_On_Conflict = {
  constraint: Customer_Asset_Limit_Constraint;
  update_columns?: Array<Customer_Asset_Limit_Update_Column>;
  where?: InputMaybe<Customer_Asset_Limit_Bool_Exp>;
};

/** Ordering options when selecting data from "customer_asset_limit". */
export type Customer_Asset_Limit_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_asset?: InputMaybe<Customer_Asset_Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  pending_quantity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  used_quantity?: InputMaybe<Order_By>;
};

/** primary key columns input for table: customer_asset_limit */
export type Customer_Asset_Limit_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "customer_asset_limit" */
export enum Customer_Asset_Limit_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerAssetId = 'customer_asset_id',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PendingQuantity = 'pending_quantity',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  UsedQuantity = 'used_quantity'
}

/** select "customer_asset_limit_aggregate_bool_exp_bool_and_arguments_columns" columns of table "customer_asset_limit" */
export enum Customer_Asset_Limit_Select_Column_Customer_Asset_Limit_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "customer_asset_limit_aggregate_bool_exp_bool_or_arguments_columns" columns of table "customer_asset_limit" */
export enum Customer_Asset_Limit_Select_Column_Customer_Asset_Limit_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "customer_asset_limit" */
export type Customer_Asset_Limit_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  end_date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  pending_quantity?: InputMaybe<Scalars['numeric']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  start_date?: InputMaybe<Scalars['timestamptz']['input']>;
  used_quantity?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Customer_Asset_Limit_Stddev_Fields = {
  __typename?: 'customer_asset_limit_stddev_fields';
  pending_quantity?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  used_quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "customer_asset_limit" */
export type Customer_Asset_Limit_Stddev_Order_By = {
  pending_quantity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  used_quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Customer_Asset_Limit_Stddev_Pop_Fields = {
  __typename?: 'customer_asset_limit_stddev_pop_fields';
  pending_quantity?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  used_quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "customer_asset_limit" */
export type Customer_Asset_Limit_Stddev_Pop_Order_By = {
  pending_quantity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  used_quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Customer_Asset_Limit_Stddev_Samp_Fields = {
  __typename?: 'customer_asset_limit_stddev_samp_fields';
  pending_quantity?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  used_quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "customer_asset_limit" */
export type Customer_Asset_Limit_Stddev_Samp_Order_By = {
  pending_quantity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  used_quantity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "customer_asset_limit" */
export type Customer_Asset_Limit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Asset_Limit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customer_Asset_Limit_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  end_date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  pending_quantity?: InputMaybe<Scalars['numeric']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  start_date?: InputMaybe<Scalars['timestamptz']['input']>;
  used_quantity?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Customer_Asset_Limit_Sum_Fields = {
  __typename?: 'customer_asset_limit_sum_fields';
  pending_quantity?: Maybe<Scalars['numeric']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
  used_quantity?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "customer_asset_limit" */
export type Customer_Asset_Limit_Sum_Order_By = {
  pending_quantity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  used_quantity?: InputMaybe<Order_By>;
};

/** update columns of table "customer_asset_limit" */
export enum Customer_Asset_Limit_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerAssetId = 'customer_asset_id',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PendingQuantity = 'pending_quantity',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  UsedQuantity = 'used_quantity'
}

export type Customer_Asset_Limit_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Customer_Asset_Limit_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Asset_Limit_Set_Input>;
  /** filter the rows which have to be updated */
  where: Customer_Asset_Limit_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Customer_Asset_Limit_Var_Pop_Fields = {
  __typename?: 'customer_asset_limit_var_pop_fields';
  pending_quantity?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  used_quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "customer_asset_limit" */
export type Customer_Asset_Limit_Var_Pop_Order_By = {
  pending_quantity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  used_quantity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Customer_Asset_Limit_Var_Samp_Fields = {
  __typename?: 'customer_asset_limit_var_samp_fields';
  pending_quantity?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  used_quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "customer_asset_limit" */
export type Customer_Asset_Limit_Var_Samp_Order_By = {
  pending_quantity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  used_quantity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Customer_Asset_Limit_Variance_Fields = {
  __typename?: 'customer_asset_limit_variance_fields';
  pending_quantity?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  used_quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "customer_asset_limit" */
export type Customer_Asset_Limit_Variance_Order_By = {
  pending_quantity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  used_quantity?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Customer_Asset_Max_Fields = {
  __typename?: 'customer_asset_max_fields';
  asset_type_id?: Maybe<Scalars['uuid']['output']>;
  capacity?: Maybe<Scalars['String']['output']>;
  chassis_number?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  erp_code?: Maybe<Scalars['String']['output']>;
  fuel_card_number?: Maybe<Scalars['String']['output']>;
  fueltrans_asset_id?: Maybe<Scalars['String']['output']>;
  icon_prefix?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ideal_utilisation?: Maybe<Scalars['numeric']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  make?: Maybe<Scalars['String']['output']>;
  modal?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Optional reference to organization user. Can be NULL when asset belongs to organization as a whole rather than specific user. */
  organization_user_id?: Maybe<Scalars['uuid']['output']>;
  plate_code?: Maybe<Scalars['String']['output']>;
  plate_number?: Maybe<Scalars['String']['output']>;
  product_id?: Maybe<Scalars['uuid']['output']>;
  reason_id?: Maybe<Scalars['uuid']['output']>;
  reason_note?: Maybe<Scalars['String']['output']>;
  registration_number?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  subsidiary_id?: Maybe<Scalars['uuid']['output']>;
  tag_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "customer_asset" */
export type Customer_Asset_Max_Order_By = {
  asset_type_id?: InputMaybe<Order_By>;
  capacity?: InputMaybe<Order_By>;
  chassis_number?: InputMaybe<Order_By>;
  color?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  erp_code?: InputMaybe<Order_By>;
  fuel_card_number?: InputMaybe<Order_By>;
  fueltrans_asset_id?: InputMaybe<Order_By>;
  icon_prefix?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ideal_utilisation?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  make?: InputMaybe<Order_By>;
  modal?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  /** Optional reference to organization user. Can be NULL when asset belongs to organization as a whole rather than specific user. */
  organization_user_id?: InputMaybe<Order_By>;
  plate_code?: InputMaybe<Order_By>;
  plate_number?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  reason_id?: InputMaybe<Order_By>;
  reason_note?: InputMaybe<Order_By>;
  registration_number?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  subsidiary_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Customer_Asset_Min_Fields = {
  __typename?: 'customer_asset_min_fields';
  asset_type_id?: Maybe<Scalars['uuid']['output']>;
  capacity?: Maybe<Scalars['String']['output']>;
  chassis_number?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  erp_code?: Maybe<Scalars['String']['output']>;
  fuel_card_number?: Maybe<Scalars['String']['output']>;
  fueltrans_asset_id?: Maybe<Scalars['String']['output']>;
  icon_prefix?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ideal_utilisation?: Maybe<Scalars['numeric']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  make?: Maybe<Scalars['String']['output']>;
  modal?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Optional reference to organization user. Can be NULL when asset belongs to organization as a whole rather than specific user. */
  organization_user_id?: Maybe<Scalars['uuid']['output']>;
  plate_code?: Maybe<Scalars['String']['output']>;
  plate_number?: Maybe<Scalars['String']['output']>;
  product_id?: Maybe<Scalars['uuid']['output']>;
  reason_id?: Maybe<Scalars['uuid']['output']>;
  reason_note?: Maybe<Scalars['String']['output']>;
  registration_number?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  subsidiary_id?: Maybe<Scalars['uuid']['output']>;
  tag_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "customer_asset" */
export type Customer_Asset_Min_Order_By = {
  asset_type_id?: InputMaybe<Order_By>;
  capacity?: InputMaybe<Order_By>;
  chassis_number?: InputMaybe<Order_By>;
  color?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  erp_code?: InputMaybe<Order_By>;
  fuel_card_number?: InputMaybe<Order_By>;
  fueltrans_asset_id?: InputMaybe<Order_By>;
  icon_prefix?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ideal_utilisation?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  make?: InputMaybe<Order_By>;
  modal?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  /** Optional reference to organization user. Can be NULL when asset belongs to organization as a whole rather than specific user. */
  organization_user_id?: InputMaybe<Order_By>;
  plate_code?: InputMaybe<Order_By>;
  plate_number?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  reason_id?: InputMaybe<Order_By>;
  reason_note?: InputMaybe<Order_By>;
  registration_number?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  subsidiary_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "customer_asset" */
export type Customer_Asset_Mutation_Response = {
  __typename?: 'customer_asset_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Customer_Asset>;
};

/** input type for inserting object relation for remote table "customer_asset" */
export type Customer_Asset_Obj_Rel_Insert_Input = {
  data: Customer_Asset_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Asset_On_Conflict>;
};

/** on_conflict condition type for table "customer_asset" */
export type Customer_Asset_On_Conflict = {
  constraint: Customer_Asset_Constraint;
  update_columns?: Array<Customer_Asset_Update_Column>;
  where?: InputMaybe<Customer_Asset_Bool_Exp>;
};

/** Ordering options when selecting data from "customer_asset". */
export type Customer_Asset_Order_By = {
  asset_grouping_customer_assets_aggregate?: InputMaybe<Asset_Grouping_Customer_Asset_Aggregate_Order_By>;
  asset_subsidiaries_aggregate?: InputMaybe<Asset_Subsidiary_Aggregate_Order_By>;
  asset_subsidiary_audit_logs_aggregate?: InputMaybe<Asset_Subsidiary_Audit_Logs_Aggregate_Order_By>;
  asset_type?: InputMaybe<Asset_Type_Order_By>;
  asset_type_id?: InputMaybe<Order_By>;
  capacity?: InputMaybe<Order_By>;
  chassis_number?: InputMaybe<Order_By>;
  color?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  customer_asset_audits_aggregate?: InputMaybe<Customer_Asset_Audit_Log_Aggregate_Order_By>;
  customer_asset_devices_aggregate?: InputMaybe<Customer_Asset_Device_Aggregate_Order_By>;
  customer_asset_dispensing_rules_aggregate?: InputMaybe<Customer_Asset_Dispensing_Rules_Aggregate_Order_By>;
  customer_asset_limits_aggregate?: InputMaybe<Customer_Asset_Limit_Aggregate_Order_By>;
  customer_asset_tags_aggregate?: InputMaybe<Customer_Asset_Tag_Aggregate_Order_By>;
  customer_order_customer_assets_aggregate?: InputMaybe<Customer_Order_Customer_Asset_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  erp_code?: InputMaybe<Order_By>;
  fuel_card_number?: InputMaybe<Order_By>;
  fueltrans_asset_id?: InputMaybe<Order_By>;
  icon_prefix?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ideal_utilisation?: InputMaybe<Order_By>;
  invoiced_items_aggregate?: InputMaybe<Invoiced_Item_Aggregate_Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_collect_odometer_reading?: InputMaybe<Order_By>;
  is_odometer_verified?: InputMaybe<Order_By>;
  is_test_enabled?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  make?: InputMaybe<Order_By>;
  modal?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order_scheduler_customer_assets_aggregate?: InputMaybe<Order_Scheduler_Customer_Asset_Aggregate_Order_By>;
  organization_user?: InputMaybe<Organization_User_Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
  partner_order_customer_assets_aggregate?: InputMaybe<Partner_Order_Customer_Asset_Aggregate_Order_By>;
  plate_code?: InputMaybe<Order_By>;
  plate_number?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  product_id?: InputMaybe<Order_By>;
  reason?: InputMaybe<Reasons_Order_By>;
  reason_id?: InputMaybe<Order_By>;
  reason_note?: InputMaybe<Order_By>;
  registration_number?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  state?: InputMaybe<State_Order_By>;
  state_id?: InputMaybe<Order_By>;
  subsidiary_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  task_values_aggregate?: InputMaybe<Task_Value_Aggregate_Order_By>;
  tickets_aggregate?: InputMaybe<Tickets_Aggregate_Order_By>;
  trip_plans_aggregate?: InputMaybe<Trip_Plan_Aggregate_Order_By>;
  view_daily_asset_limit_aggregate?: InputMaybe<View_Daily_Asset_Limit_Aggregate_Order_By>;
  view_monthly_asset_limit_aggregate?: InputMaybe<View_Monthly_Asset_Limit_Aggregate_Order_By>;
  view_weekly_asset_limit_aggregate?: InputMaybe<View_Weekly_Asset_Limit_Aggregate_Order_By>;
  wallet_ledgers_aggregate?: InputMaybe<Wallet_Ledger_Aggregate_Order_By>;
};

/** primary key columns input for table: customer_asset */
export type Customer_Asset_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "customer_asset" */
export enum Customer_Asset_Select_Column {
  /** column name */
  AssetTypeId = 'asset_type_id',
  /** column name */
  Capacity = 'capacity',
  /** column name */
  ChassisNumber = 'chassis_number',
  /** column name */
  Color = 'color',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  ErpCode = 'erp_code',
  /** column name */
  FuelCardNumber = 'fuel_card_number',
  /** column name */
  FueltransAssetId = 'fueltrans_asset_id',
  /** column name */
  IconPrefix = 'icon_prefix',
  /** column name */
  Id = 'id',
  /** column name */
  IdealUtilisation = 'ideal_utilisation',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsCollectOdometerReading = 'is_collect_odometer_reading',
  /** column name */
  IsOdometerVerified = 'is_odometer_verified',
  /** column name */
  IsTestEnabled = 'is_test_enabled',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Make = 'make',
  /** column name */
  Modal = 'modal',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationUserId = 'organization_user_id',
  /** column name */
  PlateCode = 'plate_code',
  /** column name */
  PlateNumber = 'plate_number',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  ReasonId = 'reason_id',
  /** column name */
  ReasonNote = 'reason_note',
  /** column name */
  RegistrationNumber = 'registration_number',
  /** column name */
  Slug = 'slug',
  /** column name */
  StateId = 'state_id',
  /** column name */
  SubsidiaryId = 'subsidiary_id',
  /** column name */
  TagId = 'tag_id'
}

/** select "customer_asset_aggregate_bool_exp_bool_and_arguments_columns" columns of table "customer_asset" */
export enum Customer_Asset_Select_Column_Customer_Asset_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsCollectOdometerReading = 'is_collect_odometer_reading',
  /** column name */
  IsOdometerVerified = 'is_odometer_verified',
  /** column name */
  IsTestEnabled = 'is_test_enabled'
}

/** select "customer_asset_aggregate_bool_exp_bool_or_arguments_columns" columns of table "customer_asset" */
export enum Customer_Asset_Select_Column_Customer_Asset_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsCollectOdometerReading = 'is_collect_odometer_reading',
  /** column name */
  IsOdometerVerified = 'is_odometer_verified',
  /** column name */
  IsTestEnabled = 'is_test_enabled'
}

/** input type for updating data in table "customer_asset" */
export type Customer_Asset_Set_Input = {
  asset_type_id?: InputMaybe<Scalars['uuid']['input']>;
  capacity?: InputMaybe<Scalars['String']['input']>;
  chassis_number?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  erp_code?: InputMaybe<Scalars['String']['input']>;
  fuel_card_number?: InputMaybe<Scalars['String']['input']>;
  fueltrans_asset_id?: InputMaybe<Scalars['String']['input']>;
  icon_prefix?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ideal_utilisation?: InputMaybe<Scalars['numeric']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_collect_odometer_reading?: InputMaybe<Scalars['Boolean']['input']>;
  is_odometer_verified?: InputMaybe<Scalars['Boolean']['input']>;
  is_test_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  modal?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Optional reference to organization user. Can be NULL when asset belongs to organization as a whole rather than specific user. */
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  plate_code?: InputMaybe<Scalars['String']['input']>;
  plate_number?: InputMaybe<Scalars['String']['input']>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
  reason_id?: InputMaybe<Scalars['uuid']['input']>;
  reason_note?: InputMaybe<Scalars['String']['input']>;
  registration_number?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  state_id?: InputMaybe<Scalars['uuid']['input']>;
  subsidiary_id?: InputMaybe<Scalars['uuid']['input']>;
  tag_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Customer_Asset_Stddev_Fields = {
  __typename?: 'customer_asset_stddev_fields';
  ideal_utilisation?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "customer_asset" */
export type Customer_Asset_Stddev_Order_By = {
  ideal_utilisation?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Customer_Asset_Stddev_Pop_Fields = {
  __typename?: 'customer_asset_stddev_pop_fields';
  ideal_utilisation?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "customer_asset" */
export type Customer_Asset_Stddev_Pop_Order_By = {
  ideal_utilisation?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Customer_Asset_Stddev_Samp_Fields = {
  __typename?: 'customer_asset_stddev_samp_fields';
  ideal_utilisation?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "customer_asset" */
export type Customer_Asset_Stddev_Samp_Order_By = {
  ideal_utilisation?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "customer_asset" */
export type Customer_Asset_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Asset_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customer_Asset_Stream_Cursor_Value_Input = {
  asset_type_id?: InputMaybe<Scalars['uuid']['input']>;
  capacity?: InputMaybe<Scalars['String']['input']>;
  chassis_number?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  erp_code?: InputMaybe<Scalars['String']['input']>;
  fuel_card_number?: InputMaybe<Scalars['String']['input']>;
  fueltrans_asset_id?: InputMaybe<Scalars['String']['input']>;
  icon_prefix?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ideal_utilisation?: InputMaybe<Scalars['numeric']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_collect_odometer_reading?: InputMaybe<Scalars['Boolean']['input']>;
  is_odometer_verified?: InputMaybe<Scalars['Boolean']['input']>;
  is_test_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  modal?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Optional reference to organization user. Can be NULL when asset belongs to organization as a whole rather than specific user. */
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  plate_code?: InputMaybe<Scalars['String']['input']>;
  plate_number?: InputMaybe<Scalars['String']['input']>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
  reason_id?: InputMaybe<Scalars['uuid']['input']>;
  reason_note?: InputMaybe<Scalars['String']['input']>;
  registration_number?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  state_id?: InputMaybe<Scalars['uuid']['input']>;
  subsidiary_id?: InputMaybe<Scalars['uuid']['input']>;
  tag_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Customer_Asset_Sum_Fields = {
  __typename?: 'customer_asset_sum_fields';
  ideal_utilisation?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "customer_asset" */
export type Customer_Asset_Sum_Order_By = {
  ideal_utilisation?: InputMaybe<Order_By>;
};

/** columns and relationships of "customer_asset_tag" */
export type Customer_Asset_Tag = {
  __typename?: 'customer_asset_tag';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  customer_asset: Customer_Asset;
  customer_asset_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified: Scalars['timestamptz']['output'];
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  tag: Tag;
  tag_id: Scalars['uuid']['output'];
};

/** aggregated selection of "customer_asset_tag" */
export type Customer_Asset_Tag_Aggregate = {
  __typename?: 'customer_asset_tag_aggregate';
  aggregate?: Maybe<Customer_Asset_Tag_Aggregate_Fields>;
  nodes: Array<Customer_Asset_Tag>;
};

export type Customer_Asset_Tag_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Customer_Asset_Tag_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Customer_Asset_Tag_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Customer_Asset_Tag_Aggregate_Bool_Exp_Count>;
};

export type Customer_Asset_Tag_Aggregate_Bool_Exp_Bool_And = {
  arguments: Customer_Asset_Tag_Select_Column_Customer_Asset_Tag_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Asset_Tag_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customer_Asset_Tag_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Customer_Asset_Tag_Select_Column_Customer_Asset_Tag_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Asset_Tag_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customer_Asset_Tag_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Customer_Asset_Tag_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Asset_Tag_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "customer_asset_tag" */
export type Customer_Asset_Tag_Aggregate_Fields = {
  __typename?: 'customer_asset_tag_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Customer_Asset_Tag_Max_Fields>;
  min?: Maybe<Customer_Asset_Tag_Min_Fields>;
};


/** aggregate fields of "customer_asset_tag" */
export type Customer_Asset_Tag_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Asset_Tag_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "customer_asset_tag" */
export type Customer_Asset_Tag_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Customer_Asset_Tag_Max_Order_By>;
  min?: InputMaybe<Customer_Asset_Tag_Min_Order_By>;
};

/** input type for inserting array relation for remote table "customer_asset_tag" */
export type Customer_Asset_Tag_Arr_Rel_Insert_Input = {
  data: Array<Customer_Asset_Tag_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Asset_Tag_On_Conflict>;
};

/** Boolean expression to filter rows from the table "customer_asset_tag". All fields are combined with a logical 'AND'. */
export type Customer_Asset_Tag_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Asset_Tag_Bool_Exp>>;
  _not?: InputMaybe<Customer_Asset_Tag_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Asset_Tag_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  customer_asset?: InputMaybe<Customer_Asset_Bool_Exp>;
  customer_asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  tag?: InputMaybe<Tag_Bool_Exp>;
  tag_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "customer_asset_tag" */
export enum Customer_Asset_Tag_Constraint {
  /** unique or primary key constraint on columns "tag_id", "customer_asset_id" */
  CustomerAssetTagCustomerAssetIdTagIdKey = 'customer_asset_tag_customer_asset_id_tag_id_key',
  /** unique or primary key constraint on columns "id" */
  CustomerAssetTagPkey = 'customer_asset_tag_pkey'
}

/** input type for inserting data into table "customer_asset_tag" */
export type Customer_Asset_Tag_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  customer_asset?: InputMaybe<Customer_Asset_Obj_Rel_Insert_Input>;
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  tag?: InputMaybe<Tag_Obj_Rel_Insert_Input>;
  tag_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Customer_Asset_Tag_Max_Fields = {
  __typename?: 'customer_asset_tag_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  tag_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "customer_asset_tag" */
export type Customer_Asset_Tag_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Customer_Asset_Tag_Min_Fields = {
  __typename?: 'customer_asset_tag_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  tag_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "customer_asset_tag" */
export type Customer_Asset_Tag_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "customer_asset_tag" */
export type Customer_Asset_Tag_Mutation_Response = {
  __typename?: 'customer_asset_tag_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Customer_Asset_Tag>;
};

/** on_conflict condition type for table "customer_asset_tag" */
export type Customer_Asset_Tag_On_Conflict = {
  constraint: Customer_Asset_Tag_Constraint;
  update_columns?: Array<Customer_Asset_Tag_Update_Column>;
  where?: InputMaybe<Customer_Asset_Tag_Bool_Exp>;
};

/** Ordering options when selecting data from "customer_asset_tag". */
export type Customer_Asset_Tag_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_asset?: InputMaybe<Customer_Asset_Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  tag?: InputMaybe<Tag_Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: customer_asset_tag */
export type Customer_Asset_Tag_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "customer_asset_tag" */
export enum Customer_Asset_Tag_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerAssetId = 'customer_asset_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  TagId = 'tag_id'
}

/** select "customer_asset_tag_aggregate_bool_exp_bool_and_arguments_columns" columns of table "customer_asset_tag" */
export enum Customer_Asset_Tag_Select_Column_Customer_Asset_Tag_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "customer_asset_tag_aggregate_bool_exp_bool_or_arguments_columns" columns of table "customer_asset_tag" */
export enum Customer_Asset_Tag_Select_Column_Customer_Asset_Tag_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "customer_asset_tag" */
export type Customer_Asset_Tag_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  tag_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "customer_asset_tag" */
export type Customer_Asset_Tag_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Asset_Tag_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customer_Asset_Tag_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  tag_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "customer_asset_tag" */
export enum Customer_Asset_Tag_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerAssetId = 'customer_asset_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  TagId = 'tag_id'
}

export type Customer_Asset_Tag_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Asset_Tag_Set_Input>;
  /** filter the rows which have to be updated */
  where: Customer_Asset_Tag_Bool_Exp;
};

/** update columns of table "customer_asset" */
export enum Customer_Asset_Update_Column {
  /** column name */
  AssetTypeId = 'asset_type_id',
  /** column name */
  Capacity = 'capacity',
  /** column name */
  ChassisNumber = 'chassis_number',
  /** column name */
  Color = 'color',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  ErpCode = 'erp_code',
  /** column name */
  FuelCardNumber = 'fuel_card_number',
  /** column name */
  FueltransAssetId = 'fueltrans_asset_id',
  /** column name */
  IconPrefix = 'icon_prefix',
  /** column name */
  Id = 'id',
  /** column name */
  IdealUtilisation = 'ideal_utilisation',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsCollectOdometerReading = 'is_collect_odometer_reading',
  /** column name */
  IsOdometerVerified = 'is_odometer_verified',
  /** column name */
  IsTestEnabled = 'is_test_enabled',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Make = 'make',
  /** column name */
  Modal = 'modal',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationUserId = 'organization_user_id',
  /** column name */
  PlateCode = 'plate_code',
  /** column name */
  PlateNumber = 'plate_number',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  ReasonId = 'reason_id',
  /** column name */
  ReasonNote = 'reason_note',
  /** column name */
  RegistrationNumber = 'registration_number',
  /** column name */
  Slug = 'slug',
  /** column name */
  StateId = 'state_id',
  /** column name */
  SubsidiaryId = 'subsidiary_id',
  /** column name */
  TagId = 'tag_id'
}

export type Customer_Asset_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Customer_Asset_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Asset_Set_Input>;
  /** filter the rows which have to be updated */
  where: Customer_Asset_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Customer_Asset_Var_Pop_Fields = {
  __typename?: 'customer_asset_var_pop_fields';
  ideal_utilisation?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "customer_asset" */
export type Customer_Asset_Var_Pop_Order_By = {
  ideal_utilisation?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Customer_Asset_Var_Samp_Fields = {
  __typename?: 'customer_asset_var_samp_fields';
  ideal_utilisation?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "customer_asset" */
export type Customer_Asset_Var_Samp_Order_By = {
  ideal_utilisation?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Customer_Asset_Variance_Fields = {
  __typename?: 'customer_asset_variance_fields';
  ideal_utilisation?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "customer_asset" */
export type Customer_Asset_Variance_Order_By = {
  ideal_utilisation?: InputMaybe<Order_By>;
};

/** columns and relationships of "customer_order" */
export type Customer_Order = {
  __typename?: 'customer_order';
  amount?: Maybe<Scalars['numeric']['output']>;
  amount_paid?: Maybe<Scalars['numeric']['output']>;
  amount_to_be_paid?: Maybe<Scalars['numeric']['output']>;
  billing_address_id?: Maybe<Scalars['uuid']['output']>;
  category: Order_Type_Enum;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  customer_order_cancellation_reasons: Array<Customer_Order_Cancellation_Reasons>;
  /** An aggregate relationship */
  customer_order_cancellation_reasons_aggregate: Customer_Order_Cancellation_Reasons_Aggregate;
  /** An array relationship */
  customer_order_customer_assets: Array<Customer_Order_Customer_Asset>;
  /** An aggregate relationship */
  customer_order_customer_assets_aggregate: Customer_Order_Customer_Asset_Aggregate;
  /** An array relationship */
  customer_order_items: Array<Customer_Order_Item>;
  /** An aggregate relationship */
  customer_order_items_aggregate: Customer_Order_Item_Aggregate;
  /** An array relationship */
  customer_order_organization_user_documents: Array<Customer_Order_Organization_User_Document>;
  /** An aggregate relationship */
  customer_order_organization_user_documents_aggregate: Customer_Order_Organization_User_Document_Aggregate;
  /** An array relationship */
  customer_order_partner_orders: Array<Customer_Order_Partner_Order>;
  /** An aggregate relationship */
  customer_order_partner_orders_aggregate: Customer_Order_Partner_Order_Aggregate;
  /** An object relationship */
  customer_order_slot?: Maybe<Customer_Order_Slots>;
  customer_order_slots_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  customer_order_state: Customer_Order_State;
  /** An array relationship */
  customer_order_stateflows: Array<Customer_Order_Stateflow>;
  /** An aggregate relationship */
  customer_order_stateflows_aggregate: Customer_Order_Stateflow_Aggregate;
  /** An array relationship */
  customer_payments: Array<Customer_Payment>;
  /** An aggregate relationship */
  customer_payments_aggregate: Customer_Payment_Aggregate;
  /** An object relationship */
  deliveryPreferenceByDeliveryPreference?: Maybe<Delivery_Preferences>;
  delivery_fee?: Maybe<Scalars['numeric']['output']>;
  delivery_preference?: Maybe<Delivery_Preferences_Enum>;
  description: Scalars['String']['output'];
  discount_amount?: Maybe<Scalars['numeric']['output']>;
  fueltrans_order_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  instruction?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  inventories: Array<Inventory>;
  /** An aggregate relationship */
  inventories_aggregate: Inventory_Aggregate;
  /** An object relationship */
  invoice?: Maybe<Invoice>;
  /** An array relationship */
  invoices: Array<Invoice>;
  /** An aggregate relationship */
  invoices_aggregate: Invoice_Aggregate;
  is_active: Scalars['Boolean']['output'];
  is_b2b?: Maybe<Scalars['Boolean']['output']>;
  is_otp_required: Scalars['Boolean']['output'];
  is_prepaid: Scalars['Boolean']['output'];
  is_receipt_required: Scalars['Boolean']['output'];
  is_test_enabled?: Maybe<Scalars['Boolean']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name: Scalars['String']['output'];
  order_code: Scalars['bigint']['output'];
  order_date?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  order_photos: Array<Order_Photos>;
  /** An aggregate relationship */
  order_photos_aggregate: Order_Photos_Aggregate;
  /** An object relationship */
  order_type: Order_Type;
  /** An object relationship */
  organizationAddressByShippingAddressId: Organization_Address;
  /** An object relationship */
  organization_address?: Maybe<Organization_Address>;
  /** An object relationship */
  organization_user?: Maybe<Organization_User>;
  organization_user_id?: Maybe<Scalars['uuid']['output']>;
  otp?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  partner_localities_slot?: Maybe<Partner_Localities_Slots>;
  partner_localities_slot_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  partner_payments: Array<Partner_Payment>;
  /** An aggregate relationship */
  partner_payments_aggregate: Partner_Payment_Aggregate;
  /** An object relationship */
  product_variation_partner_localities_slot?: Maybe<Product_Variation_Partner_Localities_Slots>;
  product_variation_partner_localities_slot_id?: Maybe<Scalars['uuid']['output']>;
  service_tax?: Maybe<Scalars['numeric']['output']>;
  shipping_address_id: Scalars['uuid']['output'];
  state: Customer_Order_State_Enum;
  /** An array relationship */
  tasks: Array<Task>;
  /** An aggregate relationship */
  tasks_aggregate: Task_Aggregate;
  tax?: Maybe<Scalars['numeric']['output']>;
  /** An array relationship */
  tickets: Array<Tickets>;
  /** An aggregate relationship */
  tickets_aggregate: Tickets_Aggregate;
  /** An array relationship */
  vehicle_inventory_transaction_logs: Array<Vehicle_Inventory_Transaction_Logs>;
  /** An aggregate relationship */
  vehicle_inventory_transaction_logs_aggregate: Vehicle_Inventory_Transaction_Logs_Aggregate;
  /** An object relationship */
  voucher?: Maybe<Voucher>;
  voucher_discount?: Maybe<Scalars['numeric']['output']>;
  voucher_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "customer_order" */
export type Customer_OrderCustomer_Order_Cancellation_ReasonsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Cancellation_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Cancellation_Reasons_Order_By>>;
  where?: InputMaybe<Customer_Order_Cancellation_Reasons_Bool_Exp>;
};


/** columns and relationships of "customer_order" */
export type Customer_OrderCustomer_Order_Cancellation_Reasons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Cancellation_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Cancellation_Reasons_Order_By>>;
  where?: InputMaybe<Customer_Order_Cancellation_Reasons_Bool_Exp>;
};


/** columns and relationships of "customer_order" */
export type Customer_OrderCustomer_Order_Customer_AssetsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Customer_Asset_Order_By>>;
  where?: InputMaybe<Customer_Order_Customer_Asset_Bool_Exp>;
};


/** columns and relationships of "customer_order" */
export type Customer_OrderCustomer_Order_Customer_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Customer_Asset_Order_By>>;
  where?: InputMaybe<Customer_Order_Customer_Asset_Bool_Exp>;
};


/** columns and relationships of "customer_order" */
export type Customer_OrderCustomer_Order_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Bool_Exp>;
};


/** columns and relationships of "customer_order" */
export type Customer_OrderCustomer_Order_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Bool_Exp>;
};


/** columns and relationships of "customer_order" */
export type Customer_OrderCustomer_Order_Organization_User_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Organization_User_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Organization_User_Document_Order_By>>;
  where?: InputMaybe<Customer_Order_Organization_User_Document_Bool_Exp>;
};


/** columns and relationships of "customer_order" */
export type Customer_OrderCustomer_Order_Organization_User_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Organization_User_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Organization_User_Document_Order_By>>;
  where?: InputMaybe<Customer_Order_Organization_User_Document_Bool_Exp>;
};


/** columns and relationships of "customer_order" */
export type Customer_OrderCustomer_Order_Partner_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Partner_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Partner_Order_Order_By>>;
  where?: InputMaybe<Customer_Order_Partner_Order_Bool_Exp>;
};


/** columns and relationships of "customer_order" */
export type Customer_OrderCustomer_Order_Partner_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Partner_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Partner_Order_Order_By>>;
  where?: InputMaybe<Customer_Order_Partner_Order_Bool_Exp>;
};


/** columns and relationships of "customer_order" */
export type Customer_OrderCustomer_Order_StateflowsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Stateflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Stateflow_Order_By>>;
  where?: InputMaybe<Customer_Order_Stateflow_Bool_Exp>;
};


/** columns and relationships of "customer_order" */
export type Customer_OrderCustomer_Order_Stateflows_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Stateflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Stateflow_Order_By>>;
  where?: InputMaybe<Customer_Order_Stateflow_Bool_Exp>;
};


/** columns and relationships of "customer_order" */
export type Customer_OrderCustomer_PaymentsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Payment_Order_By>>;
  where?: InputMaybe<Customer_Payment_Bool_Exp>;
};


/** columns and relationships of "customer_order" */
export type Customer_OrderCustomer_Payments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Payment_Order_By>>;
  where?: InputMaybe<Customer_Payment_Bool_Exp>;
};


/** columns and relationships of "customer_order" */
export type Customer_OrderInventoriesArgs = {
  distinct_on?: InputMaybe<Array<Inventory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Inventory_Order_By>>;
  where?: InputMaybe<Inventory_Bool_Exp>;
};


/** columns and relationships of "customer_order" */
export type Customer_OrderInventories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Inventory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Inventory_Order_By>>;
  where?: InputMaybe<Inventory_Bool_Exp>;
};


/** columns and relationships of "customer_order" */
export type Customer_OrderInvoicesArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


/** columns and relationships of "customer_order" */
export type Customer_OrderInvoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


/** columns and relationships of "customer_order" */
export type Customer_OrderOrder_PhotosArgs = {
  distinct_on?: InputMaybe<Array<Order_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Photos_Order_By>>;
  where?: InputMaybe<Order_Photos_Bool_Exp>;
};


/** columns and relationships of "customer_order" */
export type Customer_OrderOrder_Photos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Photos_Order_By>>;
  where?: InputMaybe<Order_Photos_Bool_Exp>;
};


/** columns and relationships of "customer_order" */
export type Customer_OrderPartner_PaymentsArgs = {
  distinct_on?: InputMaybe<Array<Partner_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Payment_Order_By>>;
  where?: InputMaybe<Partner_Payment_Bool_Exp>;
};


/** columns and relationships of "customer_order" */
export type Customer_OrderPartner_Payments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Payment_Order_By>>;
  where?: InputMaybe<Partner_Payment_Bool_Exp>;
};


/** columns and relationships of "customer_order" */
export type Customer_OrderTasksArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


/** columns and relationships of "customer_order" */
export type Customer_OrderTasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


/** columns and relationships of "customer_order" */
export type Customer_OrderTicketsArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tickets_Order_By>>;
  where?: InputMaybe<Tickets_Bool_Exp>;
};


/** columns and relationships of "customer_order" */
export type Customer_OrderTickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tickets_Order_By>>;
  where?: InputMaybe<Tickets_Bool_Exp>;
};


/** columns and relationships of "customer_order" */
export type Customer_OrderVehicle_Inventory_Transaction_LogsArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Inventory_Transaction_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Inventory_Transaction_Logs_Order_By>>;
  where?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Bool_Exp>;
};


/** columns and relationships of "customer_order" */
export type Customer_OrderVehicle_Inventory_Transaction_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Inventory_Transaction_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Inventory_Transaction_Logs_Order_By>>;
  where?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Bool_Exp>;
};

/** aggregated selection of "customer_order" */
export type Customer_Order_Aggregate = {
  __typename?: 'customer_order_aggregate';
  aggregate?: Maybe<Customer_Order_Aggregate_Fields>;
  nodes: Array<Customer_Order>;
};

export type Customer_Order_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Customer_Order_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Customer_Order_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Customer_Order_Aggregate_Bool_Exp_Count>;
};

export type Customer_Order_Aggregate_Bool_Exp_Bool_And = {
  arguments: Customer_Order_Select_Column_Customer_Order_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customer_Order_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Customer_Order_Select_Column_Customer_Order_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customer_Order_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Customer_Order_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "customer_order" */
export type Customer_Order_Aggregate_Fields = {
  __typename?: 'customer_order_aggregate_fields';
  avg?: Maybe<Customer_Order_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Customer_Order_Max_Fields>;
  min?: Maybe<Customer_Order_Min_Fields>;
  stddev?: Maybe<Customer_Order_Stddev_Fields>;
  stddev_pop?: Maybe<Customer_Order_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Customer_Order_Stddev_Samp_Fields>;
  sum?: Maybe<Customer_Order_Sum_Fields>;
  var_pop?: Maybe<Customer_Order_Var_Pop_Fields>;
  var_samp?: Maybe<Customer_Order_Var_Samp_Fields>;
  variance?: Maybe<Customer_Order_Variance_Fields>;
};


/** aggregate fields of "customer_order" */
export type Customer_Order_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Order_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "customer_order" */
export type Customer_Order_Aggregate_Order_By = {
  avg?: InputMaybe<Customer_Order_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Customer_Order_Max_Order_By>;
  min?: InputMaybe<Customer_Order_Min_Order_By>;
  stddev?: InputMaybe<Customer_Order_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Customer_Order_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Customer_Order_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Customer_Order_Sum_Order_By>;
  var_pop?: InputMaybe<Customer_Order_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Customer_Order_Var_Samp_Order_By>;
  variance?: InputMaybe<Customer_Order_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "customer_order" */
export type Customer_Order_Arr_Rel_Insert_Input = {
  data: Array<Customer_Order_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Order_On_Conflict>;
};

/** aggregate avg on columns */
export type Customer_Order_Avg_Fields = {
  __typename?: 'customer_order_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  amount_paid?: Maybe<Scalars['Float']['output']>;
  amount_to_be_paid?: Maybe<Scalars['Float']['output']>;
  delivery_fee?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  order_code?: Maybe<Scalars['Float']['output']>;
  otp?: Maybe<Scalars['Float']['output']>;
  service_tax?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  voucher_discount?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "customer_order" */
export type Customer_Order_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_to_be_paid?: InputMaybe<Order_By>;
  delivery_fee?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  order_code?: InputMaybe<Order_By>;
  otp?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "customer_order". All fields are combined with a logical 'AND'. */
export type Customer_Order_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Order_Bool_Exp>>;
  _not?: InputMaybe<Customer_Order_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Order_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  amount_paid?: InputMaybe<Numeric_Comparison_Exp>;
  amount_to_be_paid?: InputMaybe<Numeric_Comparison_Exp>;
  billing_address_id?: InputMaybe<Uuid_Comparison_Exp>;
  category?: InputMaybe<Order_Type_Enum_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  customer_order_cancellation_reasons?: InputMaybe<Customer_Order_Cancellation_Reasons_Bool_Exp>;
  customer_order_cancellation_reasons_aggregate?: InputMaybe<Customer_Order_Cancellation_Reasons_Aggregate_Bool_Exp>;
  customer_order_customer_assets?: InputMaybe<Customer_Order_Customer_Asset_Bool_Exp>;
  customer_order_customer_assets_aggregate?: InputMaybe<Customer_Order_Customer_Asset_Aggregate_Bool_Exp>;
  customer_order_items?: InputMaybe<Customer_Order_Item_Bool_Exp>;
  customer_order_items_aggregate?: InputMaybe<Customer_Order_Item_Aggregate_Bool_Exp>;
  customer_order_organization_user_documents?: InputMaybe<Customer_Order_Organization_User_Document_Bool_Exp>;
  customer_order_organization_user_documents_aggregate?: InputMaybe<Customer_Order_Organization_User_Document_Aggregate_Bool_Exp>;
  customer_order_partner_orders?: InputMaybe<Customer_Order_Partner_Order_Bool_Exp>;
  customer_order_partner_orders_aggregate?: InputMaybe<Customer_Order_Partner_Order_Aggregate_Bool_Exp>;
  customer_order_slot?: InputMaybe<Customer_Order_Slots_Bool_Exp>;
  customer_order_slots_id?: InputMaybe<Uuid_Comparison_Exp>;
  customer_order_state?: InputMaybe<Customer_Order_State_Bool_Exp>;
  customer_order_stateflows?: InputMaybe<Customer_Order_Stateflow_Bool_Exp>;
  customer_order_stateflows_aggregate?: InputMaybe<Customer_Order_Stateflow_Aggregate_Bool_Exp>;
  customer_payments?: InputMaybe<Customer_Payment_Bool_Exp>;
  customer_payments_aggregate?: InputMaybe<Customer_Payment_Aggregate_Bool_Exp>;
  deliveryPreferenceByDeliveryPreference?: InputMaybe<Delivery_Preferences_Bool_Exp>;
  delivery_fee?: InputMaybe<Numeric_Comparison_Exp>;
  delivery_preference?: InputMaybe<Delivery_Preferences_Enum_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  discount_amount?: InputMaybe<Numeric_Comparison_Exp>;
  fueltrans_order_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  instruction?: InputMaybe<String_Comparison_Exp>;
  inventories?: InputMaybe<Inventory_Bool_Exp>;
  inventories_aggregate?: InputMaybe<Inventory_Aggregate_Bool_Exp>;
  invoice?: InputMaybe<Invoice_Bool_Exp>;
  invoices?: InputMaybe<Invoice_Bool_Exp>;
  invoices_aggregate?: InputMaybe<Invoice_Aggregate_Bool_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_b2b?: InputMaybe<Boolean_Comparison_Exp>;
  is_otp_required?: InputMaybe<Boolean_Comparison_Exp>;
  is_prepaid?: InputMaybe<Boolean_Comparison_Exp>;
  is_receipt_required?: InputMaybe<Boolean_Comparison_Exp>;
  is_test_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order_code?: InputMaybe<Bigint_Comparison_Exp>;
  order_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  order_photos?: InputMaybe<Order_Photos_Bool_Exp>;
  order_photos_aggregate?: InputMaybe<Order_Photos_Aggregate_Bool_Exp>;
  order_type?: InputMaybe<Order_Type_Bool_Exp>;
  organizationAddressByShippingAddressId?: InputMaybe<Organization_Address_Bool_Exp>;
  organization_address?: InputMaybe<Organization_Address_Bool_Exp>;
  organization_user?: InputMaybe<Organization_User_Bool_Exp>;
  organization_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  otp?: InputMaybe<Int_Comparison_Exp>;
  partner_localities_slot?: InputMaybe<Partner_Localities_Slots_Bool_Exp>;
  partner_localities_slot_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner_payments?: InputMaybe<Partner_Payment_Bool_Exp>;
  partner_payments_aggregate?: InputMaybe<Partner_Payment_Aggregate_Bool_Exp>;
  product_variation_partner_localities_slot?: InputMaybe<Product_Variation_Partner_Localities_Slots_Bool_Exp>;
  product_variation_partner_localities_slot_id?: InputMaybe<Uuid_Comparison_Exp>;
  service_tax?: InputMaybe<Numeric_Comparison_Exp>;
  shipping_address_id?: InputMaybe<Uuid_Comparison_Exp>;
  state?: InputMaybe<Customer_Order_State_Enum_Comparison_Exp>;
  tasks?: InputMaybe<Task_Bool_Exp>;
  tasks_aggregate?: InputMaybe<Task_Aggregate_Bool_Exp>;
  tax?: InputMaybe<Numeric_Comparison_Exp>;
  tickets?: InputMaybe<Tickets_Bool_Exp>;
  tickets_aggregate?: InputMaybe<Tickets_Aggregate_Bool_Exp>;
  vehicle_inventory_transaction_logs?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Bool_Exp>;
  vehicle_inventory_transaction_logs_aggregate?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Aggregate_Bool_Exp>;
  voucher?: InputMaybe<Voucher_Bool_Exp>;
  voucher_discount?: InputMaybe<Numeric_Comparison_Exp>;
  voucher_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** columns and relationships of "customer_order_cancellation_reasons" */
export type Customer_Order_Cancellation_Reasons = {
  __typename?: 'customer_order_cancellation_reasons';
  /** An object relationship */
  cancellation_reason: Cancellation_Reasons;
  cancellation_reason_id: Scalars['uuid']['output'];
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  customer_order: Customer_Order;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  order_id: Scalars['uuid']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "customer_order_cancellation_reasons" */
export type Customer_Order_Cancellation_Reasons_Aggregate = {
  __typename?: 'customer_order_cancellation_reasons_aggregate';
  aggregate?: Maybe<Customer_Order_Cancellation_Reasons_Aggregate_Fields>;
  nodes: Array<Customer_Order_Cancellation_Reasons>;
};

export type Customer_Order_Cancellation_Reasons_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Customer_Order_Cancellation_Reasons_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Customer_Order_Cancellation_Reasons_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Customer_Order_Cancellation_Reasons_Aggregate_Bool_Exp_Count>;
};

export type Customer_Order_Cancellation_Reasons_Aggregate_Bool_Exp_Bool_And = {
  arguments: Customer_Order_Cancellation_Reasons_Select_Column_Customer_Order_Cancellation_Reasons_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Cancellation_Reasons_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customer_Order_Cancellation_Reasons_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Customer_Order_Cancellation_Reasons_Select_Column_Customer_Order_Cancellation_Reasons_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Cancellation_Reasons_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customer_Order_Cancellation_Reasons_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Customer_Order_Cancellation_Reasons_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Cancellation_Reasons_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "customer_order_cancellation_reasons" */
export type Customer_Order_Cancellation_Reasons_Aggregate_Fields = {
  __typename?: 'customer_order_cancellation_reasons_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Customer_Order_Cancellation_Reasons_Max_Fields>;
  min?: Maybe<Customer_Order_Cancellation_Reasons_Min_Fields>;
};


/** aggregate fields of "customer_order_cancellation_reasons" */
export type Customer_Order_Cancellation_Reasons_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Order_Cancellation_Reasons_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "customer_order_cancellation_reasons" */
export type Customer_Order_Cancellation_Reasons_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Customer_Order_Cancellation_Reasons_Max_Order_By>;
  min?: InputMaybe<Customer_Order_Cancellation_Reasons_Min_Order_By>;
};

/** input type for inserting array relation for remote table "customer_order_cancellation_reasons" */
export type Customer_Order_Cancellation_Reasons_Arr_Rel_Insert_Input = {
  data: Array<Customer_Order_Cancellation_Reasons_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Order_Cancellation_Reasons_On_Conflict>;
};

/** Boolean expression to filter rows from the table "customer_order_cancellation_reasons". All fields are combined with a logical 'AND'. */
export type Customer_Order_Cancellation_Reasons_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Order_Cancellation_Reasons_Bool_Exp>>;
  _not?: InputMaybe<Customer_Order_Cancellation_Reasons_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Order_Cancellation_Reasons_Bool_Exp>>;
  cancellation_reason?: InputMaybe<Cancellation_Reasons_Bool_Exp>;
  cancellation_reason_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_order?: InputMaybe<Customer_Order_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  order_id?: InputMaybe<Uuid_Comparison_Exp>;
  reason?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "customer_order_cancellation_reasons" */
export enum Customer_Order_Cancellation_Reasons_Constraint {
  /** unique or primary key constraint on columns "id" */
  CustomerOrderCancellationReasonsPkey = 'customer_order_cancellation_reasons_pkey'
}

/** input type for inserting data into table "customer_order_cancellation_reasons" */
export type Customer_Order_Cancellation_Reasons_Insert_Input = {
  cancellation_reason?: InputMaybe<Cancellation_Reasons_Obj_Rel_Insert_Input>;
  cancellation_reason_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order?: InputMaybe<Customer_Order_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  order_id?: InputMaybe<Scalars['uuid']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Customer_Order_Cancellation_Reasons_Max_Fields = {
  __typename?: 'customer_order_cancellation_reasons_max_fields';
  cancellation_reason_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  order_id?: Maybe<Scalars['uuid']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "customer_order_cancellation_reasons" */
export type Customer_Order_Cancellation_Reasons_Max_Order_By = {
  cancellation_reason_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Customer_Order_Cancellation_Reasons_Min_Fields = {
  __typename?: 'customer_order_cancellation_reasons_min_fields';
  cancellation_reason_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  order_id?: Maybe<Scalars['uuid']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "customer_order_cancellation_reasons" */
export type Customer_Order_Cancellation_Reasons_Min_Order_By = {
  cancellation_reason_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "customer_order_cancellation_reasons" */
export type Customer_Order_Cancellation_Reasons_Mutation_Response = {
  __typename?: 'customer_order_cancellation_reasons_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Customer_Order_Cancellation_Reasons>;
};

/** on_conflict condition type for table "customer_order_cancellation_reasons" */
export type Customer_Order_Cancellation_Reasons_On_Conflict = {
  constraint: Customer_Order_Cancellation_Reasons_Constraint;
  update_columns?: Array<Customer_Order_Cancellation_Reasons_Update_Column>;
  where?: InputMaybe<Customer_Order_Cancellation_Reasons_Bool_Exp>;
};

/** Ordering options when selecting data from "customer_order_cancellation_reasons". */
export type Customer_Order_Cancellation_Reasons_Order_By = {
  cancellation_reason?: InputMaybe<Cancellation_Reasons_Order_By>;
  cancellation_reason_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_order?: InputMaybe<Customer_Order_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
};

/** primary key columns input for table: customer_order_cancellation_reasons */
export type Customer_Order_Cancellation_Reasons_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "customer_order_cancellation_reasons" */
export enum Customer_Order_Cancellation_Reasons_Select_Column {
  /** column name */
  CancellationReasonId = 'cancellation_reason_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  Reason = 'reason'
}

/** select "customer_order_cancellation_reasons_aggregate_bool_exp_bool_and_arguments_columns" columns of table "customer_order_cancellation_reasons" */
export enum Customer_Order_Cancellation_Reasons_Select_Column_Customer_Order_Cancellation_Reasons_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "customer_order_cancellation_reasons_aggregate_bool_exp_bool_or_arguments_columns" columns of table "customer_order_cancellation_reasons" */
export enum Customer_Order_Cancellation_Reasons_Select_Column_Customer_Order_Cancellation_Reasons_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "customer_order_cancellation_reasons" */
export type Customer_Order_Cancellation_Reasons_Set_Input = {
  cancellation_reason_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  order_id?: InputMaybe<Scalars['uuid']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "customer_order_cancellation_reasons" */
export type Customer_Order_Cancellation_Reasons_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Order_Cancellation_Reasons_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customer_Order_Cancellation_Reasons_Stream_Cursor_Value_Input = {
  cancellation_reason_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  order_id?: InputMaybe<Scalars['uuid']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "customer_order_cancellation_reasons" */
export enum Customer_Order_Cancellation_Reasons_Update_Column {
  /** column name */
  CancellationReasonId = 'cancellation_reason_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  Reason = 'reason'
}

export type Customer_Order_Cancellation_Reasons_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Order_Cancellation_Reasons_Set_Input>;
  /** filter the rows which have to be updated */
  where: Customer_Order_Cancellation_Reasons_Bool_Exp;
};

/** unique or primary key constraints on table "customer_order" */
export enum Customer_Order_Constraint {
  /** unique or primary key constraint on columns "id" */
  CustomerOrderPkey = 'customer_order_pkey',
  /** unique or primary key constraint on columns "order_code" */
  OrderCodeIdx = 'order_code_idx'
}

/** columns and relationships of "customer_order_customer_asset" */
export type Customer_Order_Customer_Asset = {
  __typename?: 'customer_order_customer_asset';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  customer_asset: Customer_Asset;
  customer_asset_id: Scalars['uuid']['output'];
  /** An object relationship */
  customer_order: Customer_Order;
  customer_order_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  quantity_dispensed?: Maybe<Scalars['numeric']['output']>;
  quantity_requested?: Maybe<Scalars['numeric']['output']>;
  /** Unit for BOTH quantity_requested and quantity_dispensed. They are always expressed in the same unit by business rule - an order requested in litres is dispensed and recorded in litres. Product decision, 2026-08-06 (IDEV-3077). Mixed units on one line are deliberately unrepresentable; that would be a schema change, not a value. */
  unit?: Maybe<Unit_Of_Measure_Enum>;
  /** An object relationship */
  unit_of_measure?: Maybe<Unit_Of_Measure>;
};

/** aggregated selection of "customer_order_customer_asset" */
export type Customer_Order_Customer_Asset_Aggregate = {
  __typename?: 'customer_order_customer_asset_aggregate';
  aggregate?: Maybe<Customer_Order_Customer_Asset_Aggregate_Fields>;
  nodes: Array<Customer_Order_Customer_Asset>;
};

export type Customer_Order_Customer_Asset_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Customer_Order_Customer_Asset_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Customer_Order_Customer_Asset_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Customer_Order_Customer_Asset_Aggregate_Bool_Exp_Count>;
};

export type Customer_Order_Customer_Asset_Aggregate_Bool_Exp_Bool_And = {
  arguments: Customer_Order_Customer_Asset_Select_Column_Customer_Order_Customer_Asset_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Customer_Asset_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customer_Order_Customer_Asset_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Customer_Order_Customer_Asset_Select_Column_Customer_Order_Customer_Asset_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Customer_Asset_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customer_Order_Customer_Asset_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Customer_Order_Customer_Asset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Customer_Asset_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "customer_order_customer_asset" */
export type Customer_Order_Customer_Asset_Aggregate_Fields = {
  __typename?: 'customer_order_customer_asset_aggregate_fields';
  avg?: Maybe<Customer_Order_Customer_Asset_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Customer_Order_Customer_Asset_Max_Fields>;
  min?: Maybe<Customer_Order_Customer_Asset_Min_Fields>;
  stddev?: Maybe<Customer_Order_Customer_Asset_Stddev_Fields>;
  stddev_pop?: Maybe<Customer_Order_Customer_Asset_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Customer_Order_Customer_Asset_Stddev_Samp_Fields>;
  sum?: Maybe<Customer_Order_Customer_Asset_Sum_Fields>;
  var_pop?: Maybe<Customer_Order_Customer_Asset_Var_Pop_Fields>;
  var_samp?: Maybe<Customer_Order_Customer_Asset_Var_Samp_Fields>;
  variance?: Maybe<Customer_Order_Customer_Asset_Variance_Fields>;
};


/** aggregate fields of "customer_order_customer_asset" */
export type Customer_Order_Customer_Asset_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Order_Customer_Asset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "customer_order_customer_asset" */
export type Customer_Order_Customer_Asset_Aggregate_Order_By = {
  avg?: InputMaybe<Customer_Order_Customer_Asset_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Customer_Order_Customer_Asset_Max_Order_By>;
  min?: InputMaybe<Customer_Order_Customer_Asset_Min_Order_By>;
  stddev?: InputMaybe<Customer_Order_Customer_Asset_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Customer_Order_Customer_Asset_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Customer_Order_Customer_Asset_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Customer_Order_Customer_Asset_Sum_Order_By>;
  var_pop?: InputMaybe<Customer_Order_Customer_Asset_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Customer_Order_Customer_Asset_Var_Samp_Order_By>;
  variance?: InputMaybe<Customer_Order_Customer_Asset_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "customer_order_customer_asset" */
export type Customer_Order_Customer_Asset_Arr_Rel_Insert_Input = {
  data: Array<Customer_Order_Customer_Asset_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Order_Customer_Asset_On_Conflict>;
};

/** aggregate avg on columns */
export type Customer_Order_Customer_Asset_Avg_Fields = {
  __typename?: 'customer_order_customer_asset_avg_fields';
  quantity_dispensed?: Maybe<Scalars['Float']['output']>;
  quantity_requested?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "customer_order_customer_asset" */
export type Customer_Order_Customer_Asset_Avg_Order_By = {
  quantity_dispensed?: InputMaybe<Order_By>;
  quantity_requested?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "customer_order_customer_asset". All fields are combined with a logical 'AND'. */
export type Customer_Order_Customer_Asset_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Order_Customer_Asset_Bool_Exp>>;
  _not?: InputMaybe<Customer_Order_Customer_Asset_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Order_Customer_Asset_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_asset?: InputMaybe<Customer_Asset_Bool_Exp>;
  customer_asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  customer_order?: InputMaybe<Customer_Order_Bool_Exp>;
  customer_order_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  quantity_dispensed?: InputMaybe<Numeric_Comparison_Exp>;
  quantity_requested?: InputMaybe<Numeric_Comparison_Exp>;
  unit?: InputMaybe<Unit_Of_Measure_Enum_Comparison_Exp>;
  unit_of_measure?: InputMaybe<Unit_Of_Measure_Bool_Exp>;
};

/** unique or primary key constraints on table "customer_order_customer_asset" */
export enum Customer_Order_Customer_Asset_Constraint {
  /** unique or primary key constraint on columns "id" */
  CustomerOrderCustomerAssetPkey = 'customer_order_customer_asset_pkey'
}

/** input type for incrementing numeric columns in table "customer_order_customer_asset" */
export type Customer_Order_Customer_Asset_Inc_Input = {
  quantity_dispensed?: InputMaybe<Scalars['numeric']['input']>;
  quantity_requested?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "customer_order_customer_asset" */
export type Customer_Order_Customer_Asset_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_asset?: InputMaybe<Customer_Asset_Obj_Rel_Insert_Input>;
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  customer_order?: InputMaybe<Customer_Order_Obj_Rel_Insert_Input>;
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  quantity_dispensed?: InputMaybe<Scalars['numeric']['input']>;
  quantity_requested?: InputMaybe<Scalars['numeric']['input']>;
  /** Unit for BOTH quantity_requested and quantity_dispensed. They are always expressed in the same unit by business rule - an order requested in litres is dispensed and recorded in litres. Product decision, 2026-08-06 (IDEV-3077). Mixed units on one line are deliberately unrepresentable; that would be a schema change, not a value. */
  unit?: InputMaybe<Unit_Of_Measure_Enum>;
  unit_of_measure?: InputMaybe<Unit_Of_Measure_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Customer_Order_Customer_Asset_Max_Fields = {
  __typename?: 'customer_order_customer_asset_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  customer_order_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  quantity_dispensed?: Maybe<Scalars['numeric']['output']>;
  quantity_requested?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "customer_order_customer_asset" */
export type Customer_Order_Customer_Asset_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  customer_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  quantity_dispensed?: InputMaybe<Order_By>;
  quantity_requested?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Customer_Order_Customer_Asset_Min_Fields = {
  __typename?: 'customer_order_customer_asset_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  customer_order_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  quantity_dispensed?: Maybe<Scalars['numeric']['output']>;
  quantity_requested?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "customer_order_customer_asset" */
export type Customer_Order_Customer_Asset_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  customer_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  quantity_dispensed?: InputMaybe<Order_By>;
  quantity_requested?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "customer_order_customer_asset" */
export type Customer_Order_Customer_Asset_Mutation_Response = {
  __typename?: 'customer_order_customer_asset_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Customer_Order_Customer_Asset>;
};

/** on_conflict condition type for table "customer_order_customer_asset" */
export type Customer_Order_Customer_Asset_On_Conflict = {
  constraint: Customer_Order_Customer_Asset_Constraint;
  update_columns?: Array<Customer_Order_Customer_Asset_Update_Column>;
  where?: InputMaybe<Customer_Order_Customer_Asset_Bool_Exp>;
};

/** Ordering options when selecting data from "customer_order_customer_asset". */
export type Customer_Order_Customer_Asset_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_asset?: InputMaybe<Customer_Asset_Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  customer_order?: InputMaybe<Customer_Order_Order_By>;
  customer_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  quantity_dispensed?: InputMaybe<Order_By>;
  quantity_requested?: InputMaybe<Order_By>;
  unit?: InputMaybe<Order_By>;
  unit_of_measure?: InputMaybe<Unit_Of_Measure_Order_By>;
};

/** primary key columns input for table: customer_order_customer_asset */
export type Customer_Order_Customer_Asset_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "customer_order_customer_asset" */
export enum Customer_Order_Customer_Asset_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerAssetId = 'customer_asset_id',
  /** column name */
  CustomerOrderId = 'customer_order_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  QuantityDispensed = 'quantity_dispensed',
  /** column name */
  QuantityRequested = 'quantity_requested',
  /** column name */
  Unit = 'unit'
}

/** select "customer_order_customer_asset_aggregate_bool_exp_bool_and_arguments_columns" columns of table "customer_order_customer_asset" */
export enum Customer_Order_Customer_Asset_Select_Column_Customer_Order_Customer_Asset_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "customer_order_customer_asset_aggregate_bool_exp_bool_or_arguments_columns" columns of table "customer_order_customer_asset" */
export enum Customer_Order_Customer_Asset_Select_Column_Customer_Order_Customer_Asset_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "customer_order_customer_asset" */
export type Customer_Order_Customer_Asset_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  quantity_dispensed?: InputMaybe<Scalars['numeric']['input']>;
  quantity_requested?: InputMaybe<Scalars['numeric']['input']>;
  /** Unit for BOTH quantity_requested and quantity_dispensed. They are always expressed in the same unit by business rule - an order requested in litres is dispensed and recorded in litres. Product decision, 2026-08-06 (IDEV-3077). Mixed units on one line are deliberately unrepresentable; that would be a schema change, not a value. */
  unit?: InputMaybe<Unit_Of_Measure_Enum>;
};

/** aggregate stddev on columns */
export type Customer_Order_Customer_Asset_Stddev_Fields = {
  __typename?: 'customer_order_customer_asset_stddev_fields';
  quantity_dispensed?: Maybe<Scalars['Float']['output']>;
  quantity_requested?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "customer_order_customer_asset" */
export type Customer_Order_Customer_Asset_Stddev_Order_By = {
  quantity_dispensed?: InputMaybe<Order_By>;
  quantity_requested?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Customer_Order_Customer_Asset_Stddev_Pop_Fields = {
  __typename?: 'customer_order_customer_asset_stddev_pop_fields';
  quantity_dispensed?: Maybe<Scalars['Float']['output']>;
  quantity_requested?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "customer_order_customer_asset" */
export type Customer_Order_Customer_Asset_Stddev_Pop_Order_By = {
  quantity_dispensed?: InputMaybe<Order_By>;
  quantity_requested?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Customer_Order_Customer_Asset_Stddev_Samp_Fields = {
  __typename?: 'customer_order_customer_asset_stddev_samp_fields';
  quantity_dispensed?: Maybe<Scalars['Float']['output']>;
  quantity_requested?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "customer_order_customer_asset" */
export type Customer_Order_Customer_Asset_Stddev_Samp_Order_By = {
  quantity_dispensed?: InputMaybe<Order_By>;
  quantity_requested?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "customer_order_customer_asset" */
export type Customer_Order_Customer_Asset_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Order_Customer_Asset_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customer_Order_Customer_Asset_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  quantity_dispensed?: InputMaybe<Scalars['numeric']['input']>;
  quantity_requested?: InputMaybe<Scalars['numeric']['input']>;
  /** Unit for BOTH quantity_requested and quantity_dispensed. They are always expressed in the same unit by business rule - an order requested in litres is dispensed and recorded in litres. Product decision, 2026-08-06 (IDEV-3077). Mixed units on one line are deliberately unrepresentable; that would be a schema change, not a value. */
  unit?: InputMaybe<Unit_Of_Measure_Enum>;
};

/** aggregate sum on columns */
export type Customer_Order_Customer_Asset_Sum_Fields = {
  __typename?: 'customer_order_customer_asset_sum_fields';
  quantity_dispensed?: Maybe<Scalars['numeric']['output']>;
  quantity_requested?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "customer_order_customer_asset" */
export type Customer_Order_Customer_Asset_Sum_Order_By = {
  quantity_dispensed?: InputMaybe<Order_By>;
  quantity_requested?: InputMaybe<Order_By>;
};

/** update columns of table "customer_order_customer_asset" */
export enum Customer_Order_Customer_Asset_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerAssetId = 'customer_asset_id',
  /** column name */
  CustomerOrderId = 'customer_order_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  QuantityDispensed = 'quantity_dispensed',
  /** column name */
  QuantityRequested = 'quantity_requested',
  /** column name */
  Unit = 'unit'
}

export type Customer_Order_Customer_Asset_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Customer_Order_Customer_Asset_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Order_Customer_Asset_Set_Input>;
  /** filter the rows which have to be updated */
  where: Customer_Order_Customer_Asset_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Customer_Order_Customer_Asset_Var_Pop_Fields = {
  __typename?: 'customer_order_customer_asset_var_pop_fields';
  quantity_dispensed?: Maybe<Scalars['Float']['output']>;
  quantity_requested?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "customer_order_customer_asset" */
export type Customer_Order_Customer_Asset_Var_Pop_Order_By = {
  quantity_dispensed?: InputMaybe<Order_By>;
  quantity_requested?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Customer_Order_Customer_Asset_Var_Samp_Fields = {
  __typename?: 'customer_order_customer_asset_var_samp_fields';
  quantity_dispensed?: Maybe<Scalars['Float']['output']>;
  quantity_requested?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "customer_order_customer_asset" */
export type Customer_Order_Customer_Asset_Var_Samp_Order_By = {
  quantity_dispensed?: InputMaybe<Order_By>;
  quantity_requested?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Customer_Order_Customer_Asset_Variance_Fields = {
  __typename?: 'customer_order_customer_asset_variance_fields';
  quantity_dispensed?: Maybe<Scalars['Float']['output']>;
  quantity_requested?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "customer_order_customer_asset" */
export type Customer_Order_Customer_Asset_Variance_Order_By = {
  quantity_dispensed?: InputMaybe<Order_By>;
  quantity_requested?: InputMaybe<Order_By>;
};

/** columns and relationships of "customer_order_detail_view" */
export type Customer_Order_Detail_View = {
  __typename?: 'customer_order_detail_view';
  customer_asset_chassis_number?: Maybe<Scalars['String']['output']>;
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  customer_asset_make?: Maybe<Scalars['String']['output']>;
  customer_asset_name?: Maybe<Scalars['String']['output']>;
  customer_asset_plate_code?: Maybe<Scalars['String']['output']>;
  customer_asset_plate_number?: Maybe<Scalars['String']['output']>;
  customer_asset_state_id?: Maybe<Scalars['uuid']['output']>;
  customer_asset_state_name?: Maybe<Scalars['String']['output']>;
  customer_order_id?: Maybe<Scalars['uuid']['output']>;
  customer_order_item_id?: Maybe<Scalars['uuid']['output']>;
  customer_order_state?: Maybe<Scalars['String']['output']>;
  invoice_amount?: Maybe<Scalars['numeric']['output']>;
  invoice_date?: Maybe<Scalars['timestamptz']['output']>;
  invoice_id?: Maybe<Scalars['uuid']['output']>;
  invoice_is_active?: Maybe<Scalars['Boolean']['output']>;
  invoiced_item_actual_amount?: Maybe<Scalars['numeric']['output']>;
  invoiced_item_actual_qty?: Maybe<Scalars['numeric']['output']>;
  invoiced_item_amount?: Maybe<Scalars['numeric']['output']>;
  invoiced_item_customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  invoiced_item_dispensing_date?: Maybe<Scalars['timestamptz']['output']>;
  invoiced_item_id?: Maybe<Scalars['uuid']['output']>;
  invoiced_item_is_active?: Maybe<Scalars['Boolean']['output']>;
  invoiced_item_product_variation_id?: Maybe<Scalars['uuid']['output']>;
  invoiced_item_qty?: Maybe<Scalars['numeric']['output']>;
  invoiced_item_service_tax?: Maybe<Scalars['numeric']['output']>;
  invoiced_item_state?: Maybe<Scalars['String']['output']>;
  invoiced_item_unit?: Maybe<Scalars['String']['output']>;
  invoiced_item_unit_price?: Maybe<Scalars['numeric']['output']>;
  odometer_created_at?: Maybe<Scalars['timestamp']['output']>;
  odometer_key?: Maybe<Scalars['String']['output']>;
  odometer_task_value_id?: Maybe<Scalars['uuid']['output']>;
  odometer_value?: Maybe<Scalars['String']['output']>;
  order_code?: Maybe<Scalars['String']['output']>;
  order_created_at?: Maybe<Scalars['timestamp']['output']>;
  order_item_actual_delivery_date?: Maybe<Scalars['timestamptz']['output']>;
  order_item_actual_qty?: Maybe<Scalars['numeric']['output']>;
  order_item_amount?: Maybe<Scalars['numeric']['output']>;
  order_item_product_variation_id?: Maybe<Scalars['uuid']['output']>;
  order_item_task_id?: Maybe<Scalars['uuid']['output']>;
  order_item_unit_price?: Maybe<Scalars['numeric']['output']>;
  order_last_modified?: Maybe<Scalars['timestamp']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  organization_is_active?: Maybe<Scalars['Boolean']['output']>;
  organization_name?: Maybe<Scalars['String']['output']>;
  product_variation_partner_localities_slot_id?: Maybe<Scalars['uuid']['output']>;
  shipping_address_id?: Maybe<Scalars['uuid']['output']>;
  shipping_address_name?: Maybe<Scalars['String']['output']>;
  shipping_address_state_id?: Maybe<Scalars['uuid']['output']>;
  shipping_address_state_name?: Maybe<Scalars['String']['output']>;
  task_customer_order_item_id?: Maybe<Scalars['uuid']['output']>;
  task_id?: Maybe<Scalars['uuid']['output']>;
  task_is_active?: Maybe<Scalars['Boolean']['output']>;
  task_item_actual_amount?: Maybe<Scalars['numeric']['output']>;
  task_item_actual_qty?: Maybe<Scalars['numeric']['output']>;
  task_item_product_variation_id?: Maybe<Scalars['uuid']['output']>;
  task_item_unit?: Maybe<Scalars['String']['output']>;
  task_item_unit_price?: Maybe<Scalars['numeric']['output']>;
  task_state?: Maybe<Scalars['String']['output']>;
  totalizer_created_at?: Maybe<Scalars['timestamp']['output']>;
  totalizer_key?: Maybe<Scalars['String']['output']>;
  totalizer_task_value_id?: Maybe<Scalars['uuid']['output']>;
  totalizer_value?: Maybe<Scalars['String']['output']>;
  vendor_error?: Maybe<Scalars['String']['output']>;
  vendor_sync_attempts?: Maybe<Scalars['Int']['output']>;
  vendor_sync_status?: Maybe<Scalars['String']['output']>;
  vendor_synced_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "customer_order_detail_view" */
export type Customer_Order_Detail_View_Aggregate = {
  __typename?: 'customer_order_detail_view_aggregate';
  aggregate?: Maybe<Customer_Order_Detail_View_Aggregate_Fields>;
  nodes: Array<Customer_Order_Detail_View>;
};

/** aggregate fields of "customer_order_detail_view" */
export type Customer_Order_Detail_View_Aggregate_Fields = {
  __typename?: 'customer_order_detail_view_aggregate_fields';
  avg?: Maybe<Customer_Order_Detail_View_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Customer_Order_Detail_View_Max_Fields>;
  min?: Maybe<Customer_Order_Detail_View_Min_Fields>;
  stddev?: Maybe<Customer_Order_Detail_View_Stddev_Fields>;
  stddev_pop?: Maybe<Customer_Order_Detail_View_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Customer_Order_Detail_View_Stddev_Samp_Fields>;
  sum?: Maybe<Customer_Order_Detail_View_Sum_Fields>;
  var_pop?: Maybe<Customer_Order_Detail_View_Var_Pop_Fields>;
  var_samp?: Maybe<Customer_Order_Detail_View_Var_Samp_Fields>;
  variance?: Maybe<Customer_Order_Detail_View_Variance_Fields>;
};


/** aggregate fields of "customer_order_detail_view" */
export type Customer_Order_Detail_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Order_Detail_View_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Customer_Order_Detail_View_Avg_Fields = {
  __typename?: 'customer_order_detail_view_avg_fields';
  invoice_amount?: Maybe<Scalars['Float']['output']>;
  invoiced_item_actual_amount?: Maybe<Scalars['Float']['output']>;
  invoiced_item_actual_qty?: Maybe<Scalars['Float']['output']>;
  invoiced_item_amount?: Maybe<Scalars['Float']['output']>;
  invoiced_item_qty?: Maybe<Scalars['Float']['output']>;
  invoiced_item_service_tax?: Maybe<Scalars['Float']['output']>;
  invoiced_item_unit_price?: Maybe<Scalars['Float']['output']>;
  order_item_actual_qty?: Maybe<Scalars['Float']['output']>;
  order_item_amount?: Maybe<Scalars['Float']['output']>;
  order_item_unit_price?: Maybe<Scalars['Float']['output']>;
  task_item_actual_amount?: Maybe<Scalars['Float']['output']>;
  task_item_actual_qty?: Maybe<Scalars['Float']['output']>;
  task_item_unit_price?: Maybe<Scalars['Float']['output']>;
  vendor_sync_attempts?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "customer_order_detail_view". All fields are combined with a logical 'AND'. */
export type Customer_Order_Detail_View_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Order_Detail_View_Bool_Exp>>;
  _not?: InputMaybe<Customer_Order_Detail_View_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Order_Detail_View_Bool_Exp>>;
  customer_asset_chassis_number?: InputMaybe<String_Comparison_Exp>;
  customer_asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  customer_asset_make?: InputMaybe<String_Comparison_Exp>;
  customer_asset_name?: InputMaybe<String_Comparison_Exp>;
  customer_asset_plate_code?: InputMaybe<String_Comparison_Exp>;
  customer_asset_plate_number?: InputMaybe<String_Comparison_Exp>;
  customer_asset_state_id?: InputMaybe<Uuid_Comparison_Exp>;
  customer_asset_state_name?: InputMaybe<String_Comparison_Exp>;
  customer_order_id?: InputMaybe<Uuid_Comparison_Exp>;
  customer_order_item_id?: InputMaybe<Uuid_Comparison_Exp>;
  customer_order_state?: InputMaybe<String_Comparison_Exp>;
  invoice_amount?: InputMaybe<Numeric_Comparison_Exp>;
  invoice_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  invoice_id?: InputMaybe<Uuid_Comparison_Exp>;
  invoice_is_active?: InputMaybe<Boolean_Comparison_Exp>;
  invoiced_item_actual_amount?: InputMaybe<Numeric_Comparison_Exp>;
  invoiced_item_actual_qty?: InputMaybe<Numeric_Comparison_Exp>;
  invoiced_item_amount?: InputMaybe<Numeric_Comparison_Exp>;
  invoiced_item_customer_asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  invoiced_item_dispensing_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  invoiced_item_id?: InputMaybe<Uuid_Comparison_Exp>;
  invoiced_item_is_active?: InputMaybe<Boolean_Comparison_Exp>;
  invoiced_item_product_variation_id?: InputMaybe<Uuid_Comparison_Exp>;
  invoiced_item_qty?: InputMaybe<Numeric_Comparison_Exp>;
  invoiced_item_service_tax?: InputMaybe<Numeric_Comparison_Exp>;
  invoiced_item_state?: InputMaybe<String_Comparison_Exp>;
  invoiced_item_unit?: InputMaybe<String_Comparison_Exp>;
  invoiced_item_unit_price?: InputMaybe<Numeric_Comparison_Exp>;
  odometer_created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  odometer_key?: InputMaybe<String_Comparison_Exp>;
  odometer_task_value_id?: InputMaybe<Uuid_Comparison_Exp>;
  odometer_value?: InputMaybe<String_Comparison_Exp>;
  order_code?: InputMaybe<String_Comparison_Exp>;
  order_created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  order_item_actual_delivery_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  order_item_actual_qty?: InputMaybe<Numeric_Comparison_Exp>;
  order_item_amount?: InputMaybe<Numeric_Comparison_Exp>;
  order_item_product_variation_id?: InputMaybe<Uuid_Comparison_Exp>;
  order_item_task_id?: InputMaybe<Uuid_Comparison_Exp>;
  order_item_unit_price?: InputMaybe<Numeric_Comparison_Exp>;
  order_last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  organization_is_active?: InputMaybe<Boolean_Comparison_Exp>;
  organization_name?: InputMaybe<String_Comparison_Exp>;
  product_variation_partner_localities_slot_id?: InputMaybe<Uuid_Comparison_Exp>;
  shipping_address_id?: InputMaybe<Uuid_Comparison_Exp>;
  shipping_address_name?: InputMaybe<String_Comparison_Exp>;
  shipping_address_state_id?: InputMaybe<Uuid_Comparison_Exp>;
  shipping_address_state_name?: InputMaybe<String_Comparison_Exp>;
  task_customer_order_item_id?: InputMaybe<Uuid_Comparison_Exp>;
  task_id?: InputMaybe<Uuid_Comparison_Exp>;
  task_is_active?: InputMaybe<Boolean_Comparison_Exp>;
  task_item_actual_amount?: InputMaybe<Numeric_Comparison_Exp>;
  task_item_actual_qty?: InputMaybe<Numeric_Comparison_Exp>;
  task_item_product_variation_id?: InputMaybe<Uuid_Comparison_Exp>;
  task_item_unit?: InputMaybe<String_Comparison_Exp>;
  task_item_unit_price?: InputMaybe<Numeric_Comparison_Exp>;
  task_state?: InputMaybe<String_Comparison_Exp>;
  totalizer_created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  totalizer_key?: InputMaybe<String_Comparison_Exp>;
  totalizer_task_value_id?: InputMaybe<Uuid_Comparison_Exp>;
  totalizer_value?: InputMaybe<String_Comparison_Exp>;
  vendor_error?: InputMaybe<String_Comparison_Exp>;
  vendor_sync_attempts?: InputMaybe<Int_Comparison_Exp>;
  vendor_sync_status?: InputMaybe<String_Comparison_Exp>;
  vendor_synced_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Customer_Order_Detail_View_Max_Fields = {
  __typename?: 'customer_order_detail_view_max_fields';
  customer_asset_chassis_number?: Maybe<Scalars['String']['output']>;
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  customer_asset_make?: Maybe<Scalars['String']['output']>;
  customer_asset_name?: Maybe<Scalars['String']['output']>;
  customer_asset_plate_code?: Maybe<Scalars['String']['output']>;
  customer_asset_plate_number?: Maybe<Scalars['String']['output']>;
  customer_asset_state_id?: Maybe<Scalars['uuid']['output']>;
  customer_asset_state_name?: Maybe<Scalars['String']['output']>;
  customer_order_id?: Maybe<Scalars['uuid']['output']>;
  customer_order_item_id?: Maybe<Scalars['uuid']['output']>;
  customer_order_state?: Maybe<Scalars['String']['output']>;
  invoice_amount?: Maybe<Scalars['numeric']['output']>;
  invoice_date?: Maybe<Scalars['timestamptz']['output']>;
  invoice_id?: Maybe<Scalars['uuid']['output']>;
  invoiced_item_actual_amount?: Maybe<Scalars['numeric']['output']>;
  invoiced_item_actual_qty?: Maybe<Scalars['numeric']['output']>;
  invoiced_item_amount?: Maybe<Scalars['numeric']['output']>;
  invoiced_item_customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  invoiced_item_dispensing_date?: Maybe<Scalars['timestamptz']['output']>;
  invoiced_item_id?: Maybe<Scalars['uuid']['output']>;
  invoiced_item_product_variation_id?: Maybe<Scalars['uuid']['output']>;
  invoiced_item_qty?: Maybe<Scalars['numeric']['output']>;
  invoiced_item_service_tax?: Maybe<Scalars['numeric']['output']>;
  invoiced_item_state?: Maybe<Scalars['String']['output']>;
  invoiced_item_unit?: Maybe<Scalars['String']['output']>;
  invoiced_item_unit_price?: Maybe<Scalars['numeric']['output']>;
  odometer_created_at?: Maybe<Scalars['timestamp']['output']>;
  odometer_key?: Maybe<Scalars['String']['output']>;
  odometer_task_value_id?: Maybe<Scalars['uuid']['output']>;
  odometer_value?: Maybe<Scalars['String']['output']>;
  order_code?: Maybe<Scalars['String']['output']>;
  order_created_at?: Maybe<Scalars['timestamp']['output']>;
  order_item_actual_delivery_date?: Maybe<Scalars['timestamptz']['output']>;
  order_item_actual_qty?: Maybe<Scalars['numeric']['output']>;
  order_item_amount?: Maybe<Scalars['numeric']['output']>;
  order_item_product_variation_id?: Maybe<Scalars['uuid']['output']>;
  order_item_task_id?: Maybe<Scalars['uuid']['output']>;
  order_item_unit_price?: Maybe<Scalars['numeric']['output']>;
  order_last_modified?: Maybe<Scalars['timestamp']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  organization_name?: Maybe<Scalars['String']['output']>;
  product_variation_partner_localities_slot_id?: Maybe<Scalars['uuid']['output']>;
  shipping_address_id?: Maybe<Scalars['uuid']['output']>;
  shipping_address_name?: Maybe<Scalars['String']['output']>;
  shipping_address_state_id?: Maybe<Scalars['uuid']['output']>;
  shipping_address_state_name?: Maybe<Scalars['String']['output']>;
  task_customer_order_item_id?: Maybe<Scalars['uuid']['output']>;
  task_id?: Maybe<Scalars['uuid']['output']>;
  task_item_actual_amount?: Maybe<Scalars['numeric']['output']>;
  task_item_actual_qty?: Maybe<Scalars['numeric']['output']>;
  task_item_product_variation_id?: Maybe<Scalars['uuid']['output']>;
  task_item_unit?: Maybe<Scalars['String']['output']>;
  task_item_unit_price?: Maybe<Scalars['numeric']['output']>;
  task_state?: Maybe<Scalars['String']['output']>;
  totalizer_created_at?: Maybe<Scalars['timestamp']['output']>;
  totalizer_key?: Maybe<Scalars['String']['output']>;
  totalizer_task_value_id?: Maybe<Scalars['uuid']['output']>;
  totalizer_value?: Maybe<Scalars['String']['output']>;
  vendor_error?: Maybe<Scalars['String']['output']>;
  vendor_sync_attempts?: Maybe<Scalars['Int']['output']>;
  vendor_sync_status?: Maybe<Scalars['String']['output']>;
  vendor_synced_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Customer_Order_Detail_View_Min_Fields = {
  __typename?: 'customer_order_detail_view_min_fields';
  customer_asset_chassis_number?: Maybe<Scalars['String']['output']>;
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  customer_asset_make?: Maybe<Scalars['String']['output']>;
  customer_asset_name?: Maybe<Scalars['String']['output']>;
  customer_asset_plate_code?: Maybe<Scalars['String']['output']>;
  customer_asset_plate_number?: Maybe<Scalars['String']['output']>;
  customer_asset_state_id?: Maybe<Scalars['uuid']['output']>;
  customer_asset_state_name?: Maybe<Scalars['String']['output']>;
  customer_order_id?: Maybe<Scalars['uuid']['output']>;
  customer_order_item_id?: Maybe<Scalars['uuid']['output']>;
  customer_order_state?: Maybe<Scalars['String']['output']>;
  invoice_amount?: Maybe<Scalars['numeric']['output']>;
  invoice_date?: Maybe<Scalars['timestamptz']['output']>;
  invoice_id?: Maybe<Scalars['uuid']['output']>;
  invoiced_item_actual_amount?: Maybe<Scalars['numeric']['output']>;
  invoiced_item_actual_qty?: Maybe<Scalars['numeric']['output']>;
  invoiced_item_amount?: Maybe<Scalars['numeric']['output']>;
  invoiced_item_customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  invoiced_item_dispensing_date?: Maybe<Scalars['timestamptz']['output']>;
  invoiced_item_id?: Maybe<Scalars['uuid']['output']>;
  invoiced_item_product_variation_id?: Maybe<Scalars['uuid']['output']>;
  invoiced_item_qty?: Maybe<Scalars['numeric']['output']>;
  invoiced_item_service_tax?: Maybe<Scalars['numeric']['output']>;
  invoiced_item_state?: Maybe<Scalars['String']['output']>;
  invoiced_item_unit?: Maybe<Scalars['String']['output']>;
  invoiced_item_unit_price?: Maybe<Scalars['numeric']['output']>;
  odometer_created_at?: Maybe<Scalars['timestamp']['output']>;
  odometer_key?: Maybe<Scalars['String']['output']>;
  odometer_task_value_id?: Maybe<Scalars['uuid']['output']>;
  odometer_value?: Maybe<Scalars['String']['output']>;
  order_code?: Maybe<Scalars['String']['output']>;
  order_created_at?: Maybe<Scalars['timestamp']['output']>;
  order_item_actual_delivery_date?: Maybe<Scalars['timestamptz']['output']>;
  order_item_actual_qty?: Maybe<Scalars['numeric']['output']>;
  order_item_amount?: Maybe<Scalars['numeric']['output']>;
  order_item_product_variation_id?: Maybe<Scalars['uuid']['output']>;
  order_item_task_id?: Maybe<Scalars['uuid']['output']>;
  order_item_unit_price?: Maybe<Scalars['numeric']['output']>;
  order_last_modified?: Maybe<Scalars['timestamp']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  organization_name?: Maybe<Scalars['String']['output']>;
  product_variation_partner_localities_slot_id?: Maybe<Scalars['uuid']['output']>;
  shipping_address_id?: Maybe<Scalars['uuid']['output']>;
  shipping_address_name?: Maybe<Scalars['String']['output']>;
  shipping_address_state_id?: Maybe<Scalars['uuid']['output']>;
  shipping_address_state_name?: Maybe<Scalars['String']['output']>;
  task_customer_order_item_id?: Maybe<Scalars['uuid']['output']>;
  task_id?: Maybe<Scalars['uuid']['output']>;
  task_item_actual_amount?: Maybe<Scalars['numeric']['output']>;
  task_item_actual_qty?: Maybe<Scalars['numeric']['output']>;
  task_item_product_variation_id?: Maybe<Scalars['uuid']['output']>;
  task_item_unit?: Maybe<Scalars['String']['output']>;
  task_item_unit_price?: Maybe<Scalars['numeric']['output']>;
  task_state?: Maybe<Scalars['String']['output']>;
  totalizer_created_at?: Maybe<Scalars['timestamp']['output']>;
  totalizer_key?: Maybe<Scalars['String']['output']>;
  totalizer_task_value_id?: Maybe<Scalars['uuid']['output']>;
  totalizer_value?: Maybe<Scalars['String']['output']>;
  vendor_error?: Maybe<Scalars['String']['output']>;
  vendor_sync_attempts?: Maybe<Scalars['Int']['output']>;
  vendor_sync_status?: Maybe<Scalars['String']['output']>;
  vendor_synced_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** Ordering options when selecting data from "customer_order_detail_view". */
export type Customer_Order_Detail_View_Order_By = {
  customer_asset_chassis_number?: InputMaybe<Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  customer_asset_make?: InputMaybe<Order_By>;
  customer_asset_name?: InputMaybe<Order_By>;
  customer_asset_plate_code?: InputMaybe<Order_By>;
  customer_asset_plate_number?: InputMaybe<Order_By>;
  customer_asset_state_id?: InputMaybe<Order_By>;
  customer_asset_state_name?: InputMaybe<Order_By>;
  customer_order_id?: InputMaybe<Order_By>;
  customer_order_item_id?: InputMaybe<Order_By>;
  customer_order_state?: InputMaybe<Order_By>;
  invoice_amount?: InputMaybe<Order_By>;
  invoice_date?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  invoice_is_active?: InputMaybe<Order_By>;
  invoiced_item_actual_amount?: InputMaybe<Order_By>;
  invoiced_item_actual_qty?: InputMaybe<Order_By>;
  invoiced_item_amount?: InputMaybe<Order_By>;
  invoiced_item_customer_asset_id?: InputMaybe<Order_By>;
  invoiced_item_dispensing_date?: InputMaybe<Order_By>;
  invoiced_item_id?: InputMaybe<Order_By>;
  invoiced_item_is_active?: InputMaybe<Order_By>;
  invoiced_item_product_variation_id?: InputMaybe<Order_By>;
  invoiced_item_qty?: InputMaybe<Order_By>;
  invoiced_item_service_tax?: InputMaybe<Order_By>;
  invoiced_item_state?: InputMaybe<Order_By>;
  invoiced_item_unit?: InputMaybe<Order_By>;
  invoiced_item_unit_price?: InputMaybe<Order_By>;
  odometer_created_at?: InputMaybe<Order_By>;
  odometer_key?: InputMaybe<Order_By>;
  odometer_task_value_id?: InputMaybe<Order_By>;
  odometer_value?: InputMaybe<Order_By>;
  order_code?: InputMaybe<Order_By>;
  order_created_at?: InputMaybe<Order_By>;
  order_item_actual_delivery_date?: InputMaybe<Order_By>;
  order_item_actual_qty?: InputMaybe<Order_By>;
  order_item_amount?: InputMaybe<Order_By>;
  order_item_product_variation_id?: InputMaybe<Order_By>;
  order_item_task_id?: InputMaybe<Order_By>;
  order_item_unit_price?: InputMaybe<Order_By>;
  order_last_modified?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  organization_is_active?: InputMaybe<Order_By>;
  organization_name?: InputMaybe<Order_By>;
  product_variation_partner_localities_slot_id?: InputMaybe<Order_By>;
  shipping_address_id?: InputMaybe<Order_By>;
  shipping_address_name?: InputMaybe<Order_By>;
  shipping_address_state_id?: InputMaybe<Order_By>;
  shipping_address_state_name?: InputMaybe<Order_By>;
  task_customer_order_item_id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  task_is_active?: InputMaybe<Order_By>;
  task_item_actual_amount?: InputMaybe<Order_By>;
  task_item_actual_qty?: InputMaybe<Order_By>;
  task_item_product_variation_id?: InputMaybe<Order_By>;
  task_item_unit?: InputMaybe<Order_By>;
  task_item_unit_price?: InputMaybe<Order_By>;
  task_state?: InputMaybe<Order_By>;
  totalizer_created_at?: InputMaybe<Order_By>;
  totalizer_key?: InputMaybe<Order_By>;
  totalizer_task_value_id?: InputMaybe<Order_By>;
  totalizer_value?: InputMaybe<Order_By>;
  vendor_error?: InputMaybe<Order_By>;
  vendor_sync_attempts?: InputMaybe<Order_By>;
  vendor_sync_status?: InputMaybe<Order_By>;
  vendor_synced_at?: InputMaybe<Order_By>;
};

/** select columns of table "customer_order_detail_view" */
export enum Customer_Order_Detail_View_Select_Column {
  /** column name */
  CustomerAssetChassisNumber = 'customer_asset_chassis_number',
  /** column name */
  CustomerAssetId = 'customer_asset_id',
  /** column name */
  CustomerAssetMake = 'customer_asset_make',
  /** column name */
  CustomerAssetName = 'customer_asset_name',
  /** column name */
  CustomerAssetPlateCode = 'customer_asset_plate_code',
  /** column name */
  CustomerAssetPlateNumber = 'customer_asset_plate_number',
  /** column name */
  CustomerAssetStateId = 'customer_asset_state_id',
  /** column name */
  CustomerAssetStateName = 'customer_asset_state_name',
  /** column name */
  CustomerOrderId = 'customer_order_id',
  /** column name */
  CustomerOrderItemId = 'customer_order_item_id',
  /** column name */
  CustomerOrderState = 'customer_order_state',
  /** column name */
  InvoiceAmount = 'invoice_amount',
  /** column name */
  InvoiceDate = 'invoice_date',
  /** column name */
  InvoiceId = 'invoice_id',
  /** column name */
  InvoiceIsActive = 'invoice_is_active',
  /** column name */
  InvoicedItemActualAmount = 'invoiced_item_actual_amount',
  /** column name */
  InvoicedItemActualQty = 'invoiced_item_actual_qty',
  /** column name */
  InvoicedItemAmount = 'invoiced_item_amount',
  /** column name */
  InvoicedItemCustomerAssetId = 'invoiced_item_customer_asset_id',
  /** column name */
  InvoicedItemDispensingDate = 'invoiced_item_dispensing_date',
  /** column name */
  InvoicedItemId = 'invoiced_item_id',
  /** column name */
  InvoicedItemIsActive = 'invoiced_item_is_active',
  /** column name */
  InvoicedItemProductVariationId = 'invoiced_item_product_variation_id',
  /** column name */
  InvoicedItemQty = 'invoiced_item_qty',
  /** column name */
  InvoicedItemServiceTax = 'invoiced_item_service_tax',
  /** column name */
  InvoicedItemState = 'invoiced_item_state',
  /** column name */
  InvoicedItemUnit = 'invoiced_item_unit',
  /** column name */
  InvoicedItemUnitPrice = 'invoiced_item_unit_price',
  /** column name */
  OdometerCreatedAt = 'odometer_created_at',
  /** column name */
  OdometerKey = 'odometer_key',
  /** column name */
  OdometerTaskValueId = 'odometer_task_value_id',
  /** column name */
  OdometerValue = 'odometer_value',
  /** column name */
  OrderCode = 'order_code',
  /** column name */
  OrderCreatedAt = 'order_created_at',
  /** column name */
  OrderItemActualDeliveryDate = 'order_item_actual_delivery_date',
  /** column name */
  OrderItemActualQty = 'order_item_actual_qty',
  /** column name */
  OrderItemAmount = 'order_item_amount',
  /** column name */
  OrderItemProductVariationId = 'order_item_product_variation_id',
  /** column name */
  OrderItemTaskId = 'order_item_task_id',
  /** column name */
  OrderItemUnitPrice = 'order_item_unit_price',
  /** column name */
  OrderLastModified = 'order_last_modified',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  OrganizationIsActive = 'organization_is_active',
  /** column name */
  OrganizationName = 'organization_name',
  /** column name */
  ProductVariationPartnerLocalitiesSlotId = 'product_variation_partner_localities_slot_id',
  /** column name */
  ShippingAddressId = 'shipping_address_id',
  /** column name */
  ShippingAddressName = 'shipping_address_name',
  /** column name */
  ShippingAddressStateId = 'shipping_address_state_id',
  /** column name */
  ShippingAddressStateName = 'shipping_address_state_name',
  /** column name */
  TaskCustomerOrderItemId = 'task_customer_order_item_id',
  /** column name */
  TaskId = 'task_id',
  /** column name */
  TaskIsActive = 'task_is_active',
  /** column name */
  TaskItemActualAmount = 'task_item_actual_amount',
  /** column name */
  TaskItemActualQty = 'task_item_actual_qty',
  /** column name */
  TaskItemProductVariationId = 'task_item_product_variation_id',
  /** column name */
  TaskItemUnit = 'task_item_unit',
  /** column name */
  TaskItemUnitPrice = 'task_item_unit_price',
  /** column name */
  TaskState = 'task_state',
  /** column name */
  TotalizerCreatedAt = 'totalizer_created_at',
  /** column name */
  TotalizerKey = 'totalizer_key',
  /** column name */
  TotalizerTaskValueId = 'totalizer_task_value_id',
  /** column name */
  TotalizerValue = 'totalizer_value',
  /** column name */
  VendorError = 'vendor_error',
  /** column name */
  VendorSyncAttempts = 'vendor_sync_attempts',
  /** column name */
  VendorSyncStatus = 'vendor_sync_status',
  /** column name */
  VendorSyncedAt = 'vendor_synced_at'
}

/** aggregate stddev on columns */
export type Customer_Order_Detail_View_Stddev_Fields = {
  __typename?: 'customer_order_detail_view_stddev_fields';
  invoice_amount?: Maybe<Scalars['Float']['output']>;
  invoiced_item_actual_amount?: Maybe<Scalars['Float']['output']>;
  invoiced_item_actual_qty?: Maybe<Scalars['Float']['output']>;
  invoiced_item_amount?: Maybe<Scalars['Float']['output']>;
  invoiced_item_qty?: Maybe<Scalars['Float']['output']>;
  invoiced_item_service_tax?: Maybe<Scalars['Float']['output']>;
  invoiced_item_unit_price?: Maybe<Scalars['Float']['output']>;
  order_item_actual_qty?: Maybe<Scalars['Float']['output']>;
  order_item_amount?: Maybe<Scalars['Float']['output']>;
  order_item_unit_price?: Maybe<Scalars['Float']['output']>;
  task_item_actual_amount?: Maybe<Scalars['Float']['output']>;
  task_item_actual_qty?: Maybe<Scalars['Float']['output']>;
  task_item_unit_price?: Maybe<Scalars['Float']['output']>;
  vendor_sync_attempts?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Customer_Order_Detail_View_Stddev_Pop_Fields = {
  __typename?: 'customer_order_detail_view_stddev_pop_fields';
  invoice_amount?: Maybe<Scalars['Float']['output']>;
  invoiced_item_actual_amount?: Maybe<Scalars['Float']['output']>;
  invoiced_item_actual_qty?: Maybe<Scalars['Float']['output']>;
  invoiced_item_amount?: Maybe<Scalars['Float']['output']>;
  invoiced_item_qty?: Maybe<Scalars['Float']['output']>;
  invoiced_item_service_tax?: Maybe<Scalars['Float']['output']>;
  invoiced_item_unit_price?: Maybe<Scalars['Float']['output']>;
  order_item_actual_qty?: Maybe<Scalars['Float']['output']>;
  order_item_amount?: Maybe<Scalars['Float']['output']>;
  order_item_unit_price?: Maybe<Scalars['Float']['output']>;
  task_item_actual_amount?: Maybe<Scalars['Float']['output']>;
  task_item_actual_qty?: Maybe<Scalars['Float']['output']>;
  task_item_unit_price?: Maybe<Scalars['Float']['output']>;
  vendor_sync_attempts?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Customer_Order_Detail_View_Stddev_Samp_Fields = {
  __typename?: 'customer_order_detail_view_stddev_samp_fields';
  invoice_amount?: Maybe<Scalars['Float']['output']>;
  invoiced_item_actual_amount?: Maybe<Scalars['Float']['output']>;
  invoiced_item_actual_qty?: Maybe<Scalars['Float']['output']>;
  invoiced_item_amount?: Maybe<Scalars['Float']['output']>;
  invoiced_item_qty?: Maybe<Scalars['Float']['output']>;
  invoiced_item_service_tax?: Maybe<Scalars['Float']['output']>;
  invoiced_item_unit_price?: Maybe<Scalars['Float']['output']>;
  order_item_actual_qty?: Maybe<Scalars['Float']['output']>;
  order_item_amount?: Maybe<Scalars['Float']['output']>;
  order_item_unit_price?: Maybe<Scalars['Float']['output']>;
  task_item_actual_amount?: Maybe<Scalars['Float']['output']>;
  task_item_actual_qty?: Maybe<Scalars['Float']['output']>;
  task_item_unit_price?: Maybe<Scalars['Float']['output']>;
  vendor_sync_attempts?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "customer_order_detail_view" */
export type Customer_Order_Detail_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Order_Detail_View_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customer_Order_Detail_View_Stream_Cursor_Value_Input = {
  customer_asset_chassis_number?: InputMaybe<Scalars['String']['input']>;
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  customer_asset_make?: InputMaybe<Scalars['String']['input']>;
  customer_asset_name?: InputMaybe<Scalars['String']['input']>;
  customer_asset_plate_code?: InputMaybe<Scalars['String']['input']>;
  customer_asset_plate_number?: InputMaybe<Scalars['String']['input']>;
  customer_asset_state_id?: InputMaybe<Scalars['uuid']['input']>;
  customer_asset_state_name?: InputMaybe<Scalars['String']['input']>;
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
  customer_order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  customer_order_state?: InputMaybe<Scalars['String']['input']>;
  invoice_amount?: InputMaybe<Scalars['numeric']['input']>;
  invoice_date?: InputMaybe<Scalars['timestamptz']['input']>;
  invoice_id?: InputMaybe<Scalars['uuid']['input']>;
  invoice_is_active?: InputMaybe<Scalars['Boolean']['input']>;
  invoiced_item_actual_amount?: InputMaybe<Scalars['numeric']['input']>;
  invoiced_item_actual_qty?: InputMaybe<Scalars['numeric']['input']>;
  invoiced_item_amount?: InputMaybe<Scalars['numeric']['input']>;
  invoiced_item_customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  invoiced_item_dispensing_date?: InputMaybe<Scalars['timestamptz']['input']>;
  invoiced_item_id?: InputMaybe<Scalars['uuid']['input']>;
  invoiced_item_is_active?: InputMaybe<Scalars['Boolean']['input']>;
  invoiced_item_product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  invoiced_item_qty?: InputMaybe<Scalars['numeric']['input']>;
  invoiced_item_service_tax?: InputMaybe<Scalars['numeric']['input']>;
  invoiced_item_state?: InputMaybe<Scalars['String']['input']>;
  invoiced_item_unit?: InputMaybe<Scalars['String']['input']>;
  invoiced_item_unit_price?: InputMaybe<Scalars['numeric']['input']>;
  odometer_created_at?: InputMaybe<Scalars['timestamp']['input']>;
  odometer_key?: InputMaybe<Scalars['String']['input']>;
  odometer_task_value_id?: InputMaybe<Scalars['uuid']['input']>;
  odometer_value?: InputMaybe<Scalars['String']['input']>;
  order_code?: InputMaybe<Scalars['String']['input']>;
  order_created_at?: InputMaybe<Scalars['timestamp']['input']>;
  order_item_actual_delivery_date?: InputMaybe<Scalars['timestamptz']['input']>;
  order_item_actual_qty?: InputMaybe<Scalars['numeric']['input']>;
  order_item_amount?: InputMaybe<Scalars['numeric']['input']>;
  order_item_product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  order_item_task_id?: InputMaybe<Scalars['uuid']['input']>;
  order_item_unit_price?: InputMaybe<Scalars['numeric']['input']>;
  order_last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_is_active?: InputMaybe<Scalars['Boolean']['input']>;
  organization_name?: InputMaybe<Scalars['String']['input']>;
  product_variation_partner_localities_slot_id?: InputMaybe<Scalars['uuid']['input']>;
  shipping_address_id?: InputMaybe<Scalars['uuid']['input']>;
  shipping_address_name?: InputMaybe<Scalars['String']['input']>;
  shipping_address_state_id?: InputMaybe<Scalars['uuid']['input']>;
  shipping_address_state_name?: InputMaybe<Scalars['String']['input']>;
  task_customer_order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
  task_is_active?: InputMaybe<Scalars['Boolean']['input']>;
  task_item_actual_amount?: InputMaybe<Scalars['numeric']['input']>;
  task_item_actual_qty?: InputMaybe<Scalars['numeric']['input']>;
  task_item_product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  task_item_unit?: InputMaybe<Scalars['String']['input']>;
  task_item_unit_price?: InputMaybe<Scalars['numeric']['input']>;
  task_state?: InputMaybe<Scalars['String']['input']>;
  totalizer_created_at?: InputMaybe<Scalars['timestamp']['input']>;
  totalizer_key?: InputMaybe<Scalars['String']['input']>;
  totalizer_task_value_id?: InputMaybe<Scalars['uuid']['input']>;
  totalizer_value?: InputMaybe<Scalars['String']['input']>;
  vendor_error?: InputMaybe<Scalars['String']['input']>;
  vendor_sync_attempts?: InputMaybe<Scalars['Int']['input']>;
  vendor_sync_status?: InputMaybe<Scalars['String']['input']>;
  vendor_synced_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Customer_Order_Detail_View_Sum_Fields = {
  __typename?: 'customer_order_detail_view_sum_fields';
  invoice_amount?: Maybe<Scalars['numeric']['output']>;
  invoiced_item_actual_amount?: Maybe<Scalars['numeric']['output']>;
  invoiced_item_actual_qty?: Maybe<Scalars['numeric']['output']>;
  invoiced_item_amount?: Maybe<Scalars['numeric']['output']>;
  invoiced_item_qty?: Maybe<Scalars['numeric']['output']>;
  invoiced_item_service_tax?: Maybe<Scalars['numeric']['output']>;
  invoiced_item_unit_price?: Maybe<Scalars['numeric']['output']>;
  order_item_actual_qty?: Maybe<Scalars['numeric']['output']>;
  order_item_amount?: Maybe<Scalars['numeric']['output']>;
  order_item_unit_price?: Maybe<Scalars['numeric']['output']>;
  task_item_actual_amount?: Maybe<Scalars['numeric']['output']>;
  task_item_actual_qty?: Maybe<Scalars['numeric']['output']>;
  task_item_unit_price?: Maybe<Scalars['numeric']['output']>;
  vendor_sync_attempts?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Customer_Order_Detail_View_Var_Pop_Fields = {
  __typename?: 'customer_order_detail_view_var_pop_fields';
  invoice_amount?: Maybe<Scalars['Float']['output']>;
  invoiced_item_actual_amount?: Maybe<Scalars['Float']['output']>;
  invoiced_item_actual_qty?: Maybe<Scalars['Float']['output']>;
  invoiced_item_amount?: Maybe<Scalars['Float']['output']>;
  invoiced_item_qty?: Maybe<Scalars['Float']['output']>;
  invoiced_item_service_tax?: Maybe<Scalars['Float']['output']>;
  invoiced_item_unit_price?: Maybe<Scalars['Float']['output']>;
  order_item_actual_qty?: Maybe<Scalars['Float']['output']>;
  order_item_amount?: Maybe<Scalars['Float']['output']>;
  order_item_unit_price?: Maybe<Scalars['Float']['output']>;
  task_item_actual_amount?: Maybe<Scalars['Float']['output']>;
  task_item_actual_qty?: Maybe<Scalars['Float']['output']>;
  task_item_unit_price?: Maybe<Scalars['Float']['output']>;
  vendor_sync_attempts?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Customer_Order_Detail_View_Var_Samp_Fields = {
  __typename?: 'customer_order_detail_view_var_samp_fields';
  invoice_amount?: Maybe<Scalars['Float']['output']>;
  invoiced_item_actual_amount?: Maybe<Scalars['Float']['output']>;
  invoiced_item_actual_qty?: Maybe<Scalars['Float']['output']>;
  invoiced_item_amount?: Maybe<Scalars['Float']['output']>;
  invoiced_item_qty?: Maybe<Scalars['Float']['output']>;
  invoiced_item_service_tax?: Maybe<Scalars['Float']['output']>;
  invoiced_item_unit_price?: Maybe<Scalars['Float']['output']>;
  order_item_actual_qty?: Maybe<Scalars['Float']['output']>;
  order_item_amount?: Maybe<Scalars['Float']['output']>;
  order_item_unit_price?: Maybe<Scalars['Float']['output']>;
  task_item_actual_amount?: Maybe<Scalars['Float']['output']>;
  task_item_actual_qty?: Maybe<Scalars['Float']['output']>;
  task_item_unit_price?: Maybe<Scalars['Float']['output']>;
  vendor_sync_attempts?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Customer_Order_Detail_View_Variance_Fields = {
  __typename?: 'customer_order_detail_view_variance_fields';
  invoice_amount?: Maybe<Scalars['Float']['output']>;
  invoiced_item_actual_amount?: Maybe<Scalars['Float']['output']>;
  invoiced_item_actual_qty?: Maybe<Scalars['Float']['output']>;
  invoiced_item_amount?: Maybe<Scalars['Float']['output']>;
  invoiced_item_qty?: Maybe<Scalars['Float']['output']>;
  invoiced_item_service_tax?: Maybe<Scalars['Float']['output']>;
  invoiced_item_unit_price?: Maybe<Scalars['Float']['output']>;
  order_item_actual_qty?: Maybe<Scalars['Float']['output']>;
  order_item_amount?: Maybe<Scalars['Float']['output']>;
  order_item_unit_price?: Maybe<Scalars['Float']['output']>;
  task_item_actual_amount?: Maybe<Scalars['Float']['output']>;
  task_item_actual_qty?: Maybe<Scalars['Float']['output']>;
  task_item_unit_price?: Maybe<Scalars['Float']['output']>;
  vendor_sync_attempts?: Maybe<Scalars['Float']['output']>;
};

/** input type for incrementing numeric columns in table "customer_order" */
export type Customer_Order_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  amount_paid?: InputMaybe<Scalars['numeric']['input']>;
  amount_to_be_paid?: InputMaybe<Scalars['numeric']['input']>;
  delivery_fee?: InputMaybe<Scalars['numeric']['input']>;
  discount_amount?: InputMaybe<Scalars['numeric']['input']>;
  order_code?: InputMaybe<Scalars['bigint']['input']>;
  otp?: InputMaybe<Scalars['Int']['input']>;
  service_tax?: InputMaybe<Scalars['numeric']['input']>;
  tax?: InputMaybe<Scalars['numeric']['input']>;
  voucher_discount?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "customer_order" */
export type Customer_Order_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  amount_paid?: InputMaybe<Scalars['numeric']['input']>;
  amount_to_be_paid?: InputMaybe<Scalars['numeric']['input']>;
  billing_address_id?: InputMaybe<Scalars['uuid']['input']>;
  category?: InputMaybe<Order_Type_Enum>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  customer_order_cancellation_reasons?: InputMaybe<Customer_Order_Cancellation_Reasons_Arr_Rel_Insert_Input>;
  customer_order_customer_assets?: InputMaybe<Customer_Order_Customer_Asset_Arr_Rel_Insert_Input>;
  customer_order_items?: InputMaybe<Customer_Order_Item_Arr_Rel_Insert_Input>;
  customer_order_organization_user_documents?: InputMaybe<Customer_Order_Organization_User_Document_Arr_Rel_Insert_Input>;
  customer_order_partner_orders?: InputMaybe<Customer_Order_Partner_Order_Arr_Rel_Insert_Input>;
  customer_order_slot?: InputMaybe<Customer_Order_Slots_Obj_Rel_Insert_Input>;
  customer_order_slots_id?: InputMaybe<Scalars['uuid']['input']>;
  customer_order_state?: InputMaybe<Customer_Order_State_Obj_Rel_Insert_Input>;
  customer_order_stateflows?: InputMaybe<Customer_Order_Stateflow_Arr_Rel_Insert_Input>;
  customer_payments?: InputMaybe<Customer_Payment_Arr_Rel_Insert_Input>;
  deliveryPreferenceByDeliveryPreference?: InputMaybe<Delivery_Preferences_Obj_Rel_Insert_Input>;
  delivery_fee?: InputMaybe<Scalars['numeric']['input']>;
  delivery_preference?: InputMaybe<Delivery_Preferences_Enum>;
  description?: InputMaybe<Scalars['String']['input']>;
  discount_amount?: InputMaybe<Scalars['numeric']['input']>;
  fueltrans_order_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  instruction?: InputMaybe<Scalars['String']['input']>;
  inventories?: InputMaybe<Inventory_Arr_Rel_Insert_Input>;
  invoice?: InputMaybe<Invoice_Obj_Rel_Insert_Input>;
  invoices?: InputMaybe<Invoice_Arr_Rel_Insert_Input>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_b2b?: InputMaybe<Scalars['Boolean']['input']>;
  is_otp_required?: InputMaybe<Scalars['Boolean']['input']>;
  is_prepaid?: InputMaybe<Scalars['Boolean']['input']>;
  is_receipt_required?: InputMaybe<Scalars['Boolean']['input']>;
  is_test_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_code?: InputMaybe<Scalars['bigint']['input']>;
  order_date?: InputMaybe<Scalars['timestamptz']['input']>;
  order_photos?: InputMaybe<Order_Photos_Arr_Rel_Insert_Input>;
  order_type?: InputMaybe<Order_Type_Obj_Rel_Insert_Input>;
  organizationAddressByShippingAddressId?: InputMaybe<Organization_Address_Obj_Rel_Insert_Input>;
  organization_address?: InputMaybe<Organization_Address_Obj_Rel_Insert_Input>;
  organization_user?: InputMaybe<Organization_User_Obj_Rel_Insert_Input>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  otp?: InputMaybe<Scalars['Int']['input']>;
  partner_localities_slot?: InputMaybe<Partner_Localities_Slots_Obj_Rel_Insert_Input>;
  partner_localities_slot_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_payments?: InputMaybe<Partner_Payment_Arr_Rel_Insert_Input>;
  product_variation_partner_localities_slot?: InputMaybe<Product_Variation_Partner_Localities_Slots_Obj_Rel_Insert_Input>;
  product_variation_partner_localities_slot_id?: InputMaybe<Scalars['uuid']['input']>;
  service_tax?: InputMaybe<Scalars['numeric']['input']>;
  shipping_address_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Customer_Order_State_Enum>;
  tasks?: InputMaybe<Task_Arr_Rel_Insert_Input>;
  tax?: InputMaybe<Scalars['numeric']['input']>;
  tickets?: InputMaybe<Tickets_Arr_Rel_Insert_Input>;
  vehicle_inventory_transaction_logs?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Arr_Rel_Insert_Input>;
  voucher?: InputMaybe<Voucher_Obj_Rel_Insert_Input>;
  voucher_discount?: InputMaybe<Scalars['numeric']['input']>;
  voucher_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "customer_order_item" */
export type Customer_Order_Item = {
  __typename?: 'customer_order_item';
  actual_amount?: Maybe<Scalars['numeric']['output']>;
  actual_delivery_date?: Maybe<Scalars['timestamptz']['output']>;
  actual_qty: Scalars['numeric']['output'];
  amount?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  customer_order: Customer_Order;
  /** An array relationship */
  customer_order_item_cancellation_reasons: Array<Customer_Order_Item_Cancellation_Reasons>;
  /** An aggregate relationship */
  customer_order_item_cancellation_reasons_aggregate: Customer_Order_Item_Cancellation_Reasons_Aggregate;
  /** An array relationship */
  customer_order_item_comments: Array<Customer_Order_Item_Comments>;
  /** An aggregate relationship */
  customer_order_item_comments_aggregate: Customer_Order_Item_Comments_Aggregate;
  /** An array relationship */
  customer_order_item_commissions: Array<Customer_Order_Item_Commission>;
  /** An aggregate relationship */
  customer_order_item_commissions_aggregate: Customer_Order_Item_Commission_Aggregate;
  /** An array relationship */
  customer_order_item_etd_transactional_logs: Array<Customer_Order_Item_Etd_Transactional_Logs>;
  /** An aggregate relationship */
  customer_order_item_etd_transactional_logs_aggregate: Customer_Order_Item_Etd_Transactional_Logs_Aggregate;
  /** An array relationship */
  customer_order_item_partners: Array<Customer_Order_Item_Partner>;
  /** An aggregate relationship */
  customer_order_item_partners_aggregate: Customer_Order_Item_Partner_Aggregate;
  /** An array relationship */
  customer_order_item_safety_checklist_results: Array<Customer_Order_Item_Safety_Checklist_Results>;
  /** An aggregate relationship */
  customer_order_item_safety_checklist_results_aggregate: Customer_Order_Item_Safety_Checklist_Results_Aggregate;
  /** An object relationship */
  customer_order_item_state?: Maybe<Customer_Order_Item_State>;
  /** An array relationship */
  customer_order_item_stateflows: Array<Customer_Order_Item_Stateflow>;
  /** An aggregate relationship */
  customer_order_item_stateflows_aggregate: Customer_Order_Item_Stateflow_Aggregate;
  /** An array relationship */
  customer_order_item_test_categories: Array<Customer_Order_Item_Test_Category>;
  /** An aggregate relationship */
  customer_order_item_test_categories_aggregate: Customer_Order_Item_Test_Category_Aggregate;
  /** An object relationship */
  customer_order_slot?: Maybe<Customer_Order_Slots>;
  customer_order_slots_id?: Maybe<Scalars['uuid']['output']>;
  delivery_fee?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  discountTypeByDiscountType?: Maybe<Discount_Type>;
  discount_amount?: Maybe<Scalars['numeric']['output']>;
  discount_rate?: Maybe<Scalars['numeric']['output']>;
  discount_type?: Maybe<Discount_Type_Enum>;
  estimate_delivery_date?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  invoiced_items: Array<Invoiced_Item>;
  /** An aggregate relationship */
  invoiced_items_aggregate: Invoiced_Item_Aggregate;
  is_active: Scalars['Boolean']['output'];
  is_b2b?: Maybe<Scalars['Boolean']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  order_id: Scalars['uuid']['output'];
  /** An object relationship */
  partner?: Maybe<Partner>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  product_variation: Product_Variation;
  product_variation_id: Scalars['uuid']['output'];
  /** An object relationship */
  product_variation_partner_localities_slot?: Maybe<Product_Variation_Partner_Localities_Slots>;
  product_variation_partner_localities_slot_id?: Maybe<Scalars['uuid']['output']>;
  qty: Scalars['numeric']['output'];
  service_tax?: Maybe<Scalars['numeric']['output']>;
  state?: Maybe<Customer_Order_Item_State_Enum>;
  /** An object relationship */
  task?: Maybe<Task>;
  task_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  tasks: Array<Task>;
  /** An aggregate relationship */
  tasks_aggregate: Task_Aggregate;
  tax?: Maybe<Scalars['numeric']['output']>;
  unit: Unit_Of_Measure_Enum;
  /** An object relationship */
  unit_of_measure: Unit_Of_Measure;
  unit_price?: Maybe<Scalars['numeric']['output']>;
  voucher_discount?: Maybe<Scalars['numeric']['output']>;
};


/** columns and relationships of "customer_order_item" */
export type Customer_Order_ItemCustomer_Order_Item_Cancellation_ReasonsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Cancellation_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Cancellation_Reasons_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Cancellation_Reasons_Bool_Exp>;
};


/** columns and relationships of "customer_order_item" */
export type Customer_Order_ItemCustomer_Order_Item_Cancellation_Reasons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Cancellation_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Cancellation_Reasons_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Cancellation_Reasons_Bool_Exp>;
};


/** columns and relationships of "customer_order_item" */
export type Customer_Order_ItemCustomer_Order_Item_CommentsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Comments_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Comments_Bool_Exp>;
};


/** columns and relationships of "customer_order_item" */
export type Customer_Order_ItemCustomer_Order_Item_Comments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Comments_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Comments_Bool_Exp>;
};


/** columns and relationships of "customer_order_item" */
export type Customer_Order_ItemCustomer_Order_Item_CommissionsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Commission_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Commission_Bool_Exp>;
};


/** columns and relationships of "customer_order_item" */
export type Customer_Order_ItemCustomer_Order_Item_Commissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Commission_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Commission_Bool_Exp>;
};


/** columns and relationships of "customer_order_item" */
export type Customer_Order_ItemCustomer_Order_Item_Etd_Transactional_LogsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Etd_Transactional_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Etd_Transactional_Logs_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Etd_Transactional_Logs_Bool_Exp>;
};


/** columns and relationships of "customer_order_item" */
export type Customer_Order_ItemCustomer_Order_Item_Etd_Transactional_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Etd_Transactional_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Etd_Transactional_Logs_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Etd_Transactional_Logs_Bool_Exp>;
};


/** columns and relationships of "customer_order_item" */
export type Customer_Order_ItemCustomer_Order_Item_PartnersArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Partner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Partner_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Partner_Bool_Exp>;
};


/** columns and relationships of "customer_order_item" */
export type Customer_Order_ItemCustomer_Order_Item_Partners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Partner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Partner_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Partner_Bool_Exp>;
};


/** columns and relationships of "customer_order_item" */
export type Customer_Order_ItemCustomer_Order_Item_Safety_Checklist_ResultsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Safety_Checklist_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Safety_Checklist_Results_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Safety_Checklist_Results_Bool_Exp>;
};


/** columns and relationships of "customer_order_item" */
export type Customer_Order_ItemCustomer_Order_Item_Safety_Checklist_Results_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Safety_Checklist_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Safety_Checklist_Results_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Safety_Checklist_Results_Bool_Exp>;
};


/** columns and relationships of "customer_order_item" */
export type Customer_Order_ItemCustomer_Order_Item_StateflowsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Stateflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Stateflow_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Stateflow_Bool_Exp>;
};


/** columns and relationships of "customer_order_item" */
export type Customer_Order_ItemCustomer_Order_Item_Stateflows_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Stateflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Stateflow_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Stateflow_Bool_Exp>;
};


/** columns and relationships of "customer_order_item" */
export type Customer_Order_ItemCustomer_Order_Item_Test_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Test_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Test_Category_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Test_Category_Bool_Exp>;
};


/** columns and relationships of "customer_order_item" */
export type Customer_Order_ItemCustomer_Order_Item_Test_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Test_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Test_Category_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Test_Category_Bool_Exp>;
};


/** columns and relationships of "customer_order_item" */
export type Customer_Order_ItemInvoiced_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Bool_Exp>;
};


/** columns and relationships of "customer_order_item" */
export type Customer_Order_ItemInvoiced_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Bool_Exp>;
};


/** columns and relationships of "customer_order_item" */
export type Customer_Order_ItemTasksArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


/** columns and relationships of "customer_order_item" */
export type Customer_Order_ItemTasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};

/** aggregated selection of "customer_order_item" */
export type Customer_Order_Item_Aggregate = {
  __typename?: 'customer_order_item_aggregate';
  aggregate?: Maybe<Customer_Order_Item_Aggregate_Fields>;
  nodes: Array<Customer_Order_Item>;
};

export type Customer_Order_Item_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Customer_Order_Item_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Customer_Order_Item_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Customer_Order_Item_Aggregate_Bool_Exp_Count>;
};

export type Customer_Order_Item_Aggregate_Bool_Exp_Bool_And = {
  arguments: Customer_Order_Item_Select_Column_Customer_Order_Item_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Item_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customer_Order_Item_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Customer_Order_Item_Select_Column_Customer_Order_Item_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Item_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customer_Order_Item_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Customer_Order_Item_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Item_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "customer_order_item" */
export type Customer_Order_Item_Aggregate_Fields = {
  __typename?: 'customer_order_item_aggregate_fields';
  avg?: Maybe<Customer_Order_Item_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Customer_Order_Item_Max_Fields>;
  min?: Maybe<Customer_Order_Item_Min_Fields>;
  stddev?: Maybe<Customer_Order_Item_Stddev_Fields>;
  stddev_pop?: Maybe<Customer_Order_Item_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Customer_Order_Item_Stddev_Samp_Fields>;
  sum?: Maybe<Customer_Order_Item_Sum_Fields>;
  var_pop?: Maybe<Customer_Order_Item_Var_Pop_Fields>;
  var_samp?: Maybe<Customer_Order_Item_Var_Samp_Fields>;
  variance?: Maybe<Customer_Order_Item_Variance_Fields>;
};


/** aggregate fields of "customer_order_item" */
export type Customer_Order_Item_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Order_Item_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "customer_order_item" */
export type Customer_Order_Item_Aggregate_Order_By = {
  avg?: InputMaybe<Customer_Order_Item_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Customer_Order_Item_Max_Order_By>;
  min?: InputMaybe<Customer_Order_Item_Min_Order_By>;
  stddev?: InputMaybe<Customer_Order_Item_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Customer_Order_Item_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Customer_Order_Item_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Customer_Order_Item_Sum_Order_By>;
  var_pop?: InputMaybe<Customer_Order_Item_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Customer_Order_Item_Var_Samp_Order_By>;
  variance?: InputMaybe<Customer_Order_Item_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "customer_order_item" */
export type Customer_Order_Item_Arr_Rel_Insert_Input = {
  data: Array<Customer_Order_Item_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Order_Item_On_Conflict>;
};

/** aggregate avg on columns */
export type Customer_Order_Item_Avg_Fields = {
  __typename?: 'customer_order_item_avg_fields';
  actual_amount?: Maybe<Scalars['Float']['output']>;
  actual_qty?: Maybe<Scalars['Float']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  delivery_fee?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  discount_rate?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  service_tax?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  unit_price?: Maybe<Scalars['Float']['output']>;
  voucher_discount?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "customer_order_item" */
export type Customer_Order_Item_Avg_Order_By = {
  actual_amount?: InputMaybe<Order_By>;
  actual_qty?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  delivery_fee?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  discount_rate?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "customer_order_item". All fields are combined with a logical 'AND'. */
export type Customer_Order_Item_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Order_Item_Bool_Exp>>;
  _not?: InputMaybe<Customer_Order_Item_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Order_Item_Bool_Exp>>;
  actual_amount?: InputMaybe<Numeric_Comparison_Exp>;
  actual_delivery_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  actual_qty?: InputMaybe<Numeric_Comparison_Exp>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_order?: InputMaybe<Customer_Order_Bool_Exp>;
  customer_order_item_cancellation_reasons?: InputMaybe<Customer_Order_Item_Cancellation_Reasons_Bool_Exp>;
  customer_order_item_cancellation_reasons_aggregate?: InputMaybe<Customer_Order_Item_Cancellation_Reasons_Aggregate_Bool_Exp>;
  customer_order_item_comments?: InputMaybe<Customer_Order_Item_Comments_Bool_Exp>;
  customer_order_item_comments_aggregate?: InputMaybe<Customer_Order_Item_Comments_Aggregate_Bool_Exp>;
  customer_order_item_commissions?: InputMaybe<Customer_Order_Item_Commission_Bool_Exp>;
  customer_order_item_commissions_aggregate?: InputMaybe<Customer_Order_Item_Commission_Aggregate_Bool_Exp>;
  customer_order_item_etd_transactional_logs?: InputMaybe<Customer_Order_Item_Etd_Transactional_Logs_Bool_Exp>;
  customer_order_item_etd_transactional_logs_aggregate?: InputMaybe<Customer_Order_Item_Etd_Transactional_Logs_Aggregate_Bool_Exp>;
  customer_order_item_partners?: InputMaybe<Customer_Order_Item_Partner_Bool_Exp>;
  customer_order_item_partners_aggregate?: InputMaybe<Customer_Order_Item_Partner_Aggregate_Bool_Exp>;
  customer_order_item_safety_checklist_results?: InputMaybe<Customer_Order_Item_Safety_Checklist_Results_Bool_Exp>;
  customer_order_item_safety_checklist_results_aggregate?: InputMaybe<Customer_Order_Item_Safety_Checklist_Results_Aggregate_Bool_Exp>;
  customer_order_item_state?: InputMaybe<Customer_Order_Item_State_Bool_Exp>;
  customer_order_item_stateflows?: InputMaybe<Customer_Order_Item_Stateflow_Bool_Exp>;
  customer_order_item_stateflows_aggregate?: InputMaybe<Customer_Order_Item_Stateflow_Aggregate_Bool_Exp>;
  customer_order_item_test_categories?: InputMaybe<Customer_Order_Item_Test_Category_Bool_Exp>;
  customer_order_item_test_categories_aggregate?: InputMaybe<Customer_Order_Item_Test_Category_Aggregate_Bool_Exp>;
  customer_order_slot?: InputMaybe<Customer_Order_Slots_Bool_Exp>;
  customer_order_slots_id?: InputMaybe<Uuid_Comparison_Exp>;
  delivery_fee?: InputMaybe<Numeric_Comparison_Exp>;
  discountTypeByDiscountType?: InputMaybe<Discount_Type_Bool_Exp>;
  discount_amount?: InputMaybe<Numeric_Comparison_Exp>;
  discount_rate?: InputMaybe<Numeric_Comparison_Exp>;
  discount_type?: InputMaybe<Discount_Type_Enum_Comparison_Exp>;
  estimate_delivery_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invoiced_items?: InputMaybe<Invoiced_Item_Bool_Exp>;
  invoiced_items_aggregate?: InputMaybe<Invoiced_Item_Aggregate_Bool_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_b2b?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  order_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner?: InputMaybe<Partner_Bool_Exp>;
  partner_id?: InputMaybe<Uuid_Comparison_Exp>;
  product_variation?: InputMaybe<Product_Variation_Bool_Exp>;
  product_variation_id?: InputMaybe<Uuid_Comparison_Exp>;
  product_variation_partner_localities_slot?: InputMaybe<Product_Variation_Partner_Localities_Slots_Bool_Exp>;
  product_variation_partner_localities_slot_id?: InputMaybe<Uuid_Comparison_Exp>;
  qty?: InputMaybe<Numeric_Comparison_Exp>;
  service_tax?: InputMaybe<Numeric_Comparison_Exp>;
  state?: InputMaybe<Customer_Order_Item_State_Enum_Comparison_Exp>;
  task?: InputMaybe<Task_Bool_Exp>;
  task_id?: InputMaybe<Uuid_Comparison_Exp>;
  tasks?: InputMaybe<Task_Bool_Exp>;
  tasks_aggregate?: InputMaybe<Task_Aggregate_Bool_Exp>;
  tax?: InputMaybe<Numeric_Comparison_Exp>;
  unit?: InputMaybe<Unit_Of_Measure_Enum_Comparison_Exp>;
  unit_of_measure?: InputMaybe<Unit_Of_Measure_Bool_Exp>;
  unit_price?: InputMaybe<Numeric_Comparison_Exp>;
  voucher_discount?: InputMaybe<Numeric_Comparison_Exp>;
};

/** columns and relationships of "customer_order_item_cancellation_reasons" */
export type Customer_Order_Item_Cancellation_Reasons = {
  __typename?: 'customer_order_item_cancellation_reasons';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  customer_order_item: Customer_Order_Item;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  order_item_id: Scalars['uuid']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "customer_order_item_cancellation_reasons" */
export type Customer_Order_Item_Cancellation_Reasons_Aggregate = {
  __typename?: 'customer_order_item_cancellation_reasons_aggregate';
  aggregate?: Maybe<Customer_Order_Item_Cancellation_Reasons_Aggregate_Fields>;
  nodes: Array<Customer_Order_Item_Cancellation_Reasons>;
};

export type Customer_Order_Item_Cancellation_Reasons_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Customer_Order_Item_Cancellation_Reasons_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Customer_Order_Item_Cancellation_Reasons_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Customer_Order_Item_Cancellation_Reasons_Aggregate_Bool_Exp_Count>;
};

export type Customer_Order_Item_Cancellation_Reasons_Aggregate_Bool_Exp_Bool_And = {
  arguments: Customer_Order_Item_Cancellation_Reasons_Select_Column_Customer_Order_Item_Cancellation_Reasons_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Item_Cancellation_Reasons_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customer_Order_Item_Cancellation_Reasons_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Customer_Order_Item_Cancellation_Reasons_Select_Column_Customer_Order_Item_Cancellation_Reasons_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Item_Cancellation_Reasons_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customer_Order_Item_Cancellation_Reasons_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Customer_Order_Item_Cancellation_Reasons_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Item_Cancellation_Reasons_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "customer_order_item_cancellation_reasons" */
export type Customer_Order_Item_Cancellation_Reasons_Aggregate_Fields = {
  __typename?: 'customer_order_item_cancellation_reasons_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Customer_Order_Item_Cancellation_Reasons_Max_Fields>;
  min?: Maybe<Customer_Order_Item_Cancellation_Reasons_Min_Fields>;
};


/** aggregate fields of "customer_order_item_cancellation_reasons" */
export type Customer_Order_Item_Cancellation_Reasons_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Order_Item_Cancellation_Reasons_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "customer_order_item_cancellation_reasons" */
export type Customer_Order_Item_Cancellation_Reasons_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Customer_Order_Item_Cancellation_Reasons_Max_Order_By>;
  min?: InputMaybe<Customer_Order_Item_Cancellation_Reasons_Min_Order_By>;
};

/** input type for inserting array relation for remote table "customer_order_item_cancellation_reasons" */
export type Customer_Order_Item_Cancellation_Reasons_Arr_Rel_Insert_Input = {
  data: Array<Customer_Order_Item_Cancellation_Reasons_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Order_Item_Cancellation_Reasons_On_Conflict>;
};

/** Boolean expression to filter rows from the table "customer_order_item_cancellation_reasons". All fields are combined with a logical 'AND'. */
export type Customer_Order_Item_Cancellation_Reasons_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Order_Item_Cancellation_Reasons_Bool_Exp>>;
  _not?: InputMaybe<Customer_Order_Item_Cancellation_Reasons_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Order_Item_Cancellation_Reasons_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_order_item?: InputMaybe<Customer_Order_Item_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  order_item_id?: InputMaybe<Uuid_Comparison_Exp>;
  reason?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "customer_order_item_cancellation_reasons" */
export enum Customer_Order_Item_Cancellation_Reasons_Constraint {
  /** unique or primary key constraint on columns "id" */
  CustomerOrderItemCancellationReasonsPkey = 'customer_order_item_cancellation_reasons_pkey'
}

/** input type for inserting data into table "customer_order_item_cancellation_reasons" */
export type Customer_Order_Item_Cancellation_Reasons_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_item?: InputMaybe<Customer_Order_Item_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Customer_Order_Item_Cancellation_Reasons_Max_Fields = {
  __typename?: 'customer_order_item_cancellation_reasons_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  order_item_id?: Maybe<Scalars['uuid']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "customer_order_item_cancellation_reasons" */
export type Customer_Order_Item_Cancellation_Reasons_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  order_item_id?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Customer_Order_Item_Cancellation_Reasons_Min_Fields = {
  __typename?: 'customer_order_item_cancellation_reasons_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  order_item_id?: Maybe<Scalars['uuid']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "customer_order_item_cancellation_reasons" */
export type Customer_Order_Item_Cancellation_Reasons_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  order_item_id?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "customer_order_item_cancellation_reasons" */
export type Customer_Order_Item_Cancellation_Reasons_Mutation_Response = {
  __typename?: 'customer_order_item_cancellation_reasons_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Customer_Order_Item_Cancellation_Reasons>;
};

/** on_conflict condition type for table "customer_order_item_cancellation_reasons" */
export type Customer_Order_Item_Cancellation_Reasons_On_Conflict = {
  constraint: Customer_Order_Item_Cancellation_Reasons_Constraint;
  update_columns?: Array<Customer_Order_Item_Cancellation_Reasons_Update_Column>;
  where?: InputMaybe<Customer_Order_Item_Cancellation_Reasons_Bool_Exp>;
};

/** Ordering options when selecting data from "customer_order_item_cancellation_reasons". */
export type Customer_Order_Item_Cancellation_Reasons_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_order_item?: InputMaybe<Customer_Order_Item_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  order_item_id?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
};

/** primary key columns input for table: customer_order_item_cancellation_reasons */
export type Customer_Order_Item_Cancellation_Reasons_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "customer_order_item_cancellation_reasons" */
export enum Customer_Order_Item_Cancellation_Reasons_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrderItemId = 'order_item_id',
  /** column name */
  Reason = 'reason'
}

/** select "customer_order_item_cancellation_reasons_aggregate_bool_exp_bool_and_arguments_columns" columns of table "customer_order_item_cancellation_reasons" */
export enum Customer_Order_Item_Cancellation_Reasons_Select_Column_Customer_Order_Item_Cancellation_Reasons_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "customer_order_item_cancellation_reasons_aggregate_bool_exp_bool_or_arguments_columns" columns of table "customer_order_item_cancellation_reasons" */
export enum Customer_Order_Item_Cancellation_Reasons_Select_Column_Customer_Order_Item_Cancellation_Reasons_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "customer_order_item_cancellation_reasons" */
export type Customer_Order_Item_Cancellation_Reasons_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "customer_order_item_cancellation_reasons" */
export type Customer_Order_Item_Cancellation_Reasons_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Order_Item_Cancellation_Reasons_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customer_Order_Item_Cancellation_Reasons_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "customer_order_item_cancellation_reasons" */
export enum Customer_Order_Item_Cancellation_Reasons_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrderItemId = 'order_item_id',
  /** column name */
  Reason = 'reason'
}

export type Customer_Order_Item_Cancellation_Reasons_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Order_Item_Cancellation_Reasons_Set_Input>;
  /** filter the rows which have to be updated */
  where: Customer_Order_Item_Cancellation_Reasons_Bool_Exp;
};

/** columns and relationships of "customer_order_item_comments" */
export type Customer_Order_Item_Comments = {
  __typename?: 'customer_order_item_comments';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  customer_order_item: Customer_Order_Item;
  customer_order_item_id: Scalars['uuid']['output'];
  description: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  role?: Maybe<Role>;
  role_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "customer_order_item_comments" */
export type Customer_Order_Item_Comments_Aggregate = {
  __typename?: 'customer_order_item_comments_aggregate';
  aggregate?: Maybe<Customer_Order_Item_Comments_Aggregate_Fields>;
  nodes: Array<Customer_Order_Item_Comments>;
};

export type Customer_Order_Item_Comments_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Customer_Order_Item_Comments_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Customer_Order_Item_Comments_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Customer_Order_Item_Comments_Aggregate_Bool_Exp_Count>;
};

export type Customer_Order_Item_Comments_Aggregate_Bool_Exp_Bool_And = {
  arguments: Customer_Order_Item_Comments_Select_Column_Customer_Order_Item_Comments_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Item_Comments_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customer_Order_Item_Comments_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Customer_Order_Item_Comments_Select_Column_Customer_Order_Item_Comments_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Item_Comments_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customer_Order_Item_Comments_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Customer_Order_Item_Comments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Item_Comments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "customer_order_item_comments" */
export type Customer_Order_Item_Comments_Aggregate_Fields = {
  __typename?: 'customer_order_item_comments_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Customer_Order_Item_Comments_Max_Fields>;
  min?: Maybe<Customer_Order_Item_Comments_Min_Fields>;
};


/** aggregate fields of "customer_order_item_comments" */
export type Customer_Order_Item_Comments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Order_Item_Comments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "customer_order_item_comments" */
export type Customer_Order_Item_Comments_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Customer_Order_Item_Comments_Max_Order_By>;
  min?: InputMaybe<Customer_Order_Item_Comments_Min_Order_By>;
};

/** input type for inserting array relation for remote table "customer_order_item_comments" */
export type Customer_Order_Item_Comments_Arr_Rel_Insert_Input = {
  data: Array<Customer_Order_Item_Comments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Order_Item_Comments_On_Conflict>;
};

/** Boolean expression to filter rows from the table "customer_order_item_comments". All fields are combined with a logical 'AND'. */
export type Customer_Order_Item_Comments_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Order_Item_Comments_Bool_Exp>>;
  _not?: InputMaybe<Customer_Order_Item_Comments_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Order_Item_Comments_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_order_item?: InputMaybe<Customer_Order_Item_Bool_Exp>;
  customer_order_item_id?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  role?: InputMaybe<Role_Bool_Exp>;
  role_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "customer_order_item_comments" */
export enum Customer_Order_Item_Comments_Constraint {
  /** unique or primary key constraint on columns "id" */
  CustomerOrderItemCommentsPkey = 'customer_order_item_comments_pkey'
}

/** input type for inserting data into table "customer_order_item_comments" */
export type Customer_Order_Item_Comments_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_item?: InputMaybe<Customer_Order_Item_Obj_Rel_Insert_Input>;
  customer_order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Role_Obj_Rel_Insert_Input>;
  role_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Customer_Order_Item_Comments_Max_Fields = {
  __typename?: 'customer_order_item_comments_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_order_item_id?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  role_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "customer_order_item_comments" */
export type Customer_Order_Item_Comments_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_order_item_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Customer_Order_Item_Comments_Min_Fields = {
  __typename?: 'customer_order_item_comments_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_order_item_id?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  role_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "customer_order_item_comments" */
export type Customer_Order_Item_Comments_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_order_item_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "customer_order_item_comments" */
export type Customer_Order_Item_Comments_Mutation_Response = {
  __typename?: 'customer_order_item_comments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Customer_Order_Item_Comments>;
};

/** on_conflict condition type for table "customer_order_item_comments" */
export type Customer_Order_Item_Comments_On_Conflict = {
  constraint: Customer_Order_Item_Comments_Constraint;
  update_columns?: Array<Customer_Order_Item_Comments_Update_Column>;
  where?: InputMaybe<Customer_Order_Item_Comments_Bool_Exp>;
};

/** Ordering options when selecting data from "customer_order_item_comments". */
export type Customer_Order_Item_Comments_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_order_item?: InputMaybe<Customer_Order_Item_Order_By>;
  customer_order_item_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  role?: InputMaybe<Role_Order_By>;
  role_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: customer_order_item_comments */
export type Customer_Order_Item_Comments_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "customer_order_item_comments" */
export enum Customer_Order_Item_Comments_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerOrderItemId = 'customer_order_item_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  RoleId = 'role_id'
}

/** select "customer_order_item_comments_aggregate_bool_exp_bool_and_arguments_columns" columns of table "customer_order_item_comments" */
export enum Customer_Order_Item_Comments_Select_Column_Customer_Order_Item_Comments_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "customer_order_item_comments_aggregate_bool_exp_bool_or_arguments_columns" columns of table "customer_order_item_comments" */
export enum Customer_Order_Item_Comments_Select_Column_Customer_Order_Item_Comments_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "customer_order_item_comments" */
export type Customer_Order_Item_Comments_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  role_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "customer_order_item_comments" */
export type Customer_Order_Item_Comments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Order_Item_Comments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customer_Order_Item_Comments_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  role_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "customer_order_item_comments" */
export enum Customer_Order_Item_Comments_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerOrderItemId = 'customer_order_item_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  RoleId = 'role_id'
}

export type Customer_Order_Item_Comments_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Order_Item_Comments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Customer_Order_Item_Comments_Bool_Exp;
};

/** columns and relationships of "customer_order_item_commission" */
export type Customer_Order_Item_Commission = {
  __typename?: 'customer_order_item_commission';
  affiliation_id: Scalars['uuid']['output'];
  amount?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  customer_order_item: Customer_Order_Item;
  customer_order_item_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  organization_commission_product_variation_type: Organization_Commission_Product_Variation_Type;
  organization_commission_product_variation_type_id: Scalars['uuid']['output'];
  /** An object relationship */
  organization_user: Organization_User;
};

/** aggregated selection of "customer_order_item_commission" */
export type Customer_Order_Item_Commission_Aggregate = {
  __typename?: 'customer_order_item_commission_aggregate';
  aggregate?: Maybe<Customer_Order_Item_Commission_Aggregate_Fields>;
  nodes: Array<Customer_Order_Item_Commission>;
};

export type Customer_Order_Item_Commission_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Customer_Order_Item_Commission_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Customer_Order_Item_Commission_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Customer_Order_Item_Commission_Aggregate_Bool_Exp_Count>;
};

export type Customer_Order_Item_Commission_Aggregate_Bool_Exp_Bool_And = {
  arguments: Customer_Order_Item_Commission_Select_Column_Customer_Order_Item_Commission_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Item_Commission_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customer_Order_Item_Commission_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Customer_Order_Item_Commission_Select_Column_Customer_Order_Item_Commission_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Item_Commission_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customer_Order_Item_Commission_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Customer_Order_Item_Commission_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Item_Commission_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "customer_order_item_commission" */
export type Customer_Order_Item_Commission_Aggregate_Fields = {
  __typename?: 'customer_order_item_commission_aggregate_fields';
  avg?: Maybe<Customer_Order_Item_Commission_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Customer_Order_Item_Commission_Max_Fields>;
  min?: Maybe<Customer_Order_Item_Commission_Min_Fields>;
  stddev?: Maybe<Customer_Order_Item_Commission_Stddev_Fields>;
  stddev_pop?: Maybe<Customer_Order_Item_Commission_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Customer_Order_Item_Commission_Stddev_Samp_Fields>;
  sum?: Maybe<Customer_Order_Item_Commission_Sum_Fields>;
  var_pop?: Maybe<Customer_Order_Item_Commission_Var_Pop_Fields>;
  var_samp?: Maybe<Customer_Order_Item_Commission_Var_Samp_Fields>;
  variance?: Maybe<Customer_Order_Item_Commission_Variance_Fields>;
};


/** aggregate fields of "customer_order_item_commission" */
export type Customer_Order_Item_Commission_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Order_Item_Commission_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "customer_order_item_commission" */
export type Customer_Order_Item_Commission_Aggregate_Order_By = {
  avg?: InputMaybe<Customer_Order_Item_Commission_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Customer_Order_Item_Commission_Max_Order_By>;
  min?: InputMaybe<Customer_Order_Item_Commission_Min_Order_By>;
  stddev?: InputMaybe<Customer_Order_Item_Commission_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Customer_Order_Item_Commission_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Customer_Order_Item_Commission_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Customer_Order_Item_Commission_Sum_Order_By>;
  var_pop?: InputMaybe<Customer_Order_Item_Commission_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Customer_Order_Item_Commission_Var_Samp_Order_By>;
  variance?: InputMaybe<Customer_Order_Item_Commission_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "customer_order_item_commission" */
export type Customer_Order_Item_Commission_Arr_Rel_Insert_Input = {
  data: Array<Customer_Order_Item_Commission_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Order_Item_Commission_On_Conflict>;
};

/** aggregate avg on columns */
export type Customer_Order_Item_Commission_Avg_Fields = {
  __typename?: 'customer_order_item_commission_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "customer_order_item_commission" */
export type Customer_Order_Item_Commission_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "customer_order_item_commission". All fields are combined with a logical 'AND'. */
export type Customer_Order_Item_Commission_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Order_Item_Commission_Bool_Exp>>;
  _not?: InputMaybe<Customer_Order_Item_Commission_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Order_Item_Commission_Bool_Exp>>;
  affiliation_id?: InputMaybe<Uuid_Comparison_Exp>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_order_item?: InputMaybe<Customer_Order_Item_Bool_Exp>;
  customer_order_item_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  organization_commission_product_variation_type?: InputMaybe<Organization_Commission_Product_Variation_Type_Bool_Exp>;
  organization_commission_product_variation_type_id?: InputMaybe<Uuid_Comparison_Exp>;
  organization_user?: InputMaybe<Organization_User_Bool_Exp>;
};

/** unique or primary key constraints on table "customer_order_item_commission" */
export enum Customer_Order_Item_Commission_Constraint {
  /** unique or primary key constraint on columns "id" */
  CustomerOrderItemCommissionPkey = 'customer_order_item_commission_pkey'
}

/** input type for incrementing numeric columns in table "customer_order_item_commission" */
export type Customer_Order_Item_Commission_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "customer_order_item_commission" */
export type Customer_Order_Item_Commission_Insert_Input = {
  affiliation_id?: InputMaybe<Scalars['uuid']['input']>;
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_item?: InputMaybe<Customer_Order_Item_Obj_Rel_Insert_Input>;
  customer_order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_commission_product_variation_type?: InputMaybe<Organization_Commission_Product_Variation_Type_Obj_Rel_Insert_Input>;
  organization_commission_product_variation_type_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_user?: InputMaybe<Organization_User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Customer_Order_Item_Commission_Max_Fields = {
  __typename?: 'customer_order_item_commission_max_fields';
  affiliation_id?: Maybe<Scalars['uuid']['output']>;
  amount?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_order_item_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  organization_commission_product_variation_type_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "customer_order_item_commission" */
export type Customer_Order_Item_Commission_Max_Order_By = {
  affiliation_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_order_item_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_commission_product_variation_type_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Customer_Order_Item_Commission_Min_Fields = {
  __typename?: 'customer_order_item_commission_min_fields';
  affiliation_id?: Maybe<Scalars['uuid']['output']>;
  amount?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_order_item_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  organization_commission_product_variation_type_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "customer_order_item_commission" */
export type Customer_Order_Item_Commission_Min_Order_By = {
  affiliation_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_order_item_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_commission_product_variation_type_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "customer_order_item_commission" */
export type Customer_Order_Item_Commission_Mutation_Response = {
  __typename?: 'customer_order_item_commission_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Customer_Order_Item_Commission>;
};

/** on_conflict condition type for table "customer_order_item_commission" */
export type Customer_Order_Item_Commission_On_Conflict = {
  constraint: Customer_Order_Item_Commission_Constraint;
  update_columns?: Array<Customer_Order_Item_Commission_Update_Column>;
  where?: InputMaybe<Customer_Order_Item_Commission_Bool_Exp>;
};

/** Ordering options when selecting data from "customer_order_item_commission". */
export type Customer_Order_Item_Commission_Order_By = {
  affiliation_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_order_item?: InputMaybe<Customer_Order_Item_Order_By>;
  customer_order_item_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_commission_product_variation_type?: InputMaybe<Organization_Commission_Product_Variation_Type_Order_By>;
  organization_commission_product_variation_type_id?: InputMaybe<Order_By>;
  organization_user?: InputMaybe<Organization_User_Order_By>;
};

/** primary key columns input for table: customer_order_item_commission */
export type Customer_Order_Item_Commission_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "customer_order_item_commission" */
export enum Customer_Order_Item_Commission_Select_Column {
  /** column name */
  AffiliationId = 'affiliation_id',
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerOrderItemId = 'customer_order_item_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrganizationCommissionProductVariationTypeId = 'organization_commission_product_variation_type_id'
}

/** select "customer_order_item_commission_aggregate_bool_exp_bool_and_arguments_columns" columns of table "customer_order_item_commission" */
export enum Customer_Order_Item_Commission_Select_Column_Customer_Order_Item_Commission_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "customer_order_item_commission_aggregate_bool_exp_bool_or_arguments_columns" columns of table "customer_order_item_commission" */
export enum Customer_Order_Item_Commission_Select_Column_Customer_Order_Item_Commission_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "customer_order_item_commission" */
export type Customer_Order_Item_Commission_Set_Input = {
  affiliation_id?: InputMaybe<Scalars['uuid']['input']>;
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_commission_product_variation_type_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Customer_Order_Item_Commission_Stddev_Fields = {
  __typename?: 'customer_order_item_commission_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "customer_order_item_commission" */
export type Customer_Order_Item_Commission_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Customer_Order_Item_Commission_Stddev_Pop_Fields = {
  __typename?: 'customer_order_item_commission_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "customer_order_item_commission" */
export type Customer_Order_Item_Commission_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Customer_Order_Item_Commission_Stddev_Samp_Fields = {
  __typename?: 'customer_order_item_commission_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "customer_order_item_commission" */
export type Customer_Order_Item_Commission_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "customer_order_item_commission" */
export type Customer_Order_Item_Commission_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Order_Item_Commission_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customer_Order_Item_Commission_Stream_Cursor_Value_Input = {
  affiliation_id?: InputMaybe<Scalars['uuid']['input']>;
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_commission_product_variation_type_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Customer_Order_Item_Commission_Sum_Fields = {
  __typename?: 'customer_order_item_commission_sum_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "customer_order_item_commission" */
export type Customer_Order_Item_Commission_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** update columns of table "customer_order_item_commission" */
export enum Customer_Order_Item_Commission_Update_Column {
  /** column name */
  AffiliationId = 'affiliation_id',
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerOrderItemId = 'customer_order_item_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrganizationCommissionProductVariationTypeId = 'organization_commission_product_variation_type_id'
}

export type Customer_Order_Item_Commission_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Customer_Order_Item_Commission_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Order_Item_Commission_Set_Input>;
  /** filter the rows which have to be updated */
  where: Customer_Order_Item_Commission_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Customer_Order_Item_Commission_Var_Pop_Fields = {
  __typename?: 'customer_order_item_commission_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "customer_order_item_commission" */
export type Customer_Order_Item_Commission_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Customer_Order_Item_Commission_Var_Samp_Fields = {
  __typename?: 'customer_order_item_commission_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "customer_order_item_commission" */
export type Customer_Order_Item_Commission_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Customer_Order_Item_Commission_Variance_Fields = {
  __typename?: 'customer_order_item_commission_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "customer_order_item_commission" */
export type Customer_Order_Item_Commission_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "customer_order_item" */
export enum Customer_Order_Item_Constraint {
  /** unique or primary key constraint on columns "id" */
  CustomerOrderItemPkey = 'customer_order_item_pkey'
}

/** columns and relationships of "customer_order_item_etd_transactional_logs" */
export type Customer_Order_Item_Etd_Transactional_Logs = {
  __typename?: 'customer_order_item_etd_transactional_logs';
  /** An object relationship */
  cancellation_reason: Cancellation_Reasons;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  customer_order_item: Customer_Order_Item;
  customer_order_item_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  new_estimate_delivery_date?: Maybe<Scalars['timestamp']['output']>;
  previous_estimate_delivery_date?: Maybe<Scalars['timestamp']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  reason_id: Scalars['uuid']['output'];
};

/** aggregated selection of "customer_order_item_etd_transactional_logs" */
export type Customer_Order_Item_Etd_Transactional_Logs_Aggregate = {
  __typename?: 'customer_order_item_etd_transactional_logs_aggregate';
  aggregate?: Maybe<Customer_Order_Item_Etd_Transactional_Logs_Aggregate_Fields>;
  nodes: Array<Customer_Order_Item_Etd_Transactional_Logs>;
};

export type Customer_Order_Item_Etd_Transactional_Logs_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Customer_Order_Item_Etd_Transactional_Logs_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Customer_Order_Item_Etd_Transactional_Logs_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Customer_Order_Item_Etd_Transactional_Logs_Aggregate_Bool_Exp_Count>;
};

export type Customer_Order_Item_Etd_Transactional_Logs_Aggregate_Bool_Exp_Bool_And = {
  arguments: Customer_Order_Item_Etd_Transactional_Logs_Select_Column_Customer_Order_Item_Etd_Transactional_Logs_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Item_Etd_Transactional_Logs_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customer_Order_Item_Etd_Transactional_Logs_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Customer_Order_Item_Etd_Transactional_Logs_Select_Column_Customer_Order_Item_Etd_Transactional_Logs_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Item_Etd_Transactional_Logs_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customer_Order_Item_Etd_Transactional_Logs_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Customer_Order_Item_Etd_Transactional_Logs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Item_Etd_Transactional_Logs_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "customer_order_item_etd_transactional_logs" */
export type Customer_Order_Item_Etd_Transactional_Logs_Aggregate_Fields = {
  __typename?: 'customer_order_item_etd_transactional_logs_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Customer_Order_Item_Etd_Transactional_Logs_Max_Fields>;
  min?: Maybe<Customer_Order_Item_Etd_Transactional_Logs_Min_Fields>;
};


/** aggregate fields of "customer_order_item_etd_transactional_logs" */
export type Customer_Order_Item_Etd_Transactional_Logs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Order_Item_Etd_Transactional_Logs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "customer_order_item_etd_transactional_logs" */
export type Customer_Order_Item_Etd_Transactional_Logs_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Customer_Order_Item_Etd_Transactional_Logs_Max_Order_By>;
  min?: InputMaybe<Customer_Order_Item_Etd_Transactional_Logs_Min_Order_By>;
};

/** input type for inserting array relation for remote table "customer_order_item_etd_transactional_logs" */
export type Customer_Order_Item_Etd_Transactional_Logs_Arr_Rel_Insert_Input = {
  data: Array<Customer_Order_Item_Etd_Transactional_Logs_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Order_Item_Etd_Transactional_Logs_On_Conflict>;
};

/** Boolean expression to filter rows from the table "customer_order_item_etd_transactional_logs". All fields are combined with a logical 'AND'. */
export type Customer_Order_Item_Etd_Transactional_Logs_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Order_Item_Etd_Transactional_Logs_Bool_Exp>>;
  _not?: InputMaybe<Customer_Order_Item_Etd_Transactional_Logs_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Order_Item_Etd_Transactional_Logs_Bool_Exp>>;
  cancellation_reason?: InputMaybe<Cancellation_Reasons_Bool_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_order_item?: InputMaybe<Customer_Order_Item_Bool_Exp>;
  customer_order_item_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  new_estimate_delivery_date?: InputMaybe<Timestamp_Comparison_Exp>;
  previous_estimate_delivery_date?: InputMaybe<Timestamp_Comparison_Exp>;
  reason?: InputMaybe<String_Comparison_Exp>;
  reason_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "customer_order_item_etd_transactional_logs" */
export enum Customer_Order_Item_Etd_Transactional_Logs_Constraint {
  /** unique or primary key constraint on columns "id" */
  CustomerOrderItemEtdTransactionalLogsPkey = 'customer_order_item_etd_transactional_logs_pkey'
}

/** input type for inserting data into table "customer_order_item_etd_transactional_logs" */
export type Customer_Order_Item_Etd_Transactional_Logs_Insert_Input = {
  cancellation_reason?: InputMaybe<Cancellation_Reasons_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_item?: InputMaybe<Customer_Order_Item_Obj_Rel_Insert_Input>;
  customer_order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  new_estimate_delivery_date?: InputMaybe<Scalars['timestamp']['input']>;
  previous_estimate_delivery_date?: InputMaybe<Scalars['timestamp']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  reason_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Customer_Order_Item_Etd_Transactional_Logs_Max_Fields = {
  __typename?: 'customer_order_item_etd_transactional_logs_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_order_item_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  new_estimate_delivery_date?: Maybe<Scalars['timestamp']['output']>;
  previous_estimate_delivery_date?: Maybe<Scalars['timestamp']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  reason_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "customer_order_item_etd_transactional_logs" */
export type Customer_Order_Item_Etd_Transactional_Logs_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_order_item_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  new_estimate_delivery_date?: InputMaybe<Order_By>;
  previous_estimate_delivery_date?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  reason_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Customer_Order_Item_Etd_Transactional_Logs_Min_Fields = {
  __typename?: 'customer_order_item_etd_transactional_logs_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_order_item_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  new_estimate_delivery_date?: Maybe<Scalars['timestamp']['output']>;
  previous_estimate_delivery_date?: Maybe<Scalars['timestamp']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  reason_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "customer_order_item_etd_transactional_logs" */
export type Customer_Order_Item_Etd_Transactional_Logs_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_order_item_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  new_estimate_delivery_date?: InputMaybe<Order_By>;
  previous_estimate_delivery_date?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  reason_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "customer_order_item_etd_transactional_logs" */
export type Customer_Order_Item_Etd_Transactional_Logs_Mutation_Response = {
  __typename?: 'customer_order_item_etd_transactional_logs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Customer_Order_Item_Etd_Transactional_Logs>;
};

/** on_conflict condition type for table "customer_order_item_etd_transactional_logs" */
export type Customer_Order_Item_Etd_Transactional_Logs_On_Conflict = {
  constraint: Customer_Order_Item_Etd_Transactional_Logs_Constraint;
  update_columns?: Array<Customer_Order_Item_Etd_Transactional_Logs_Update_Column>;
  where?: InputMaybe<Customer_Order_Item_Etd_Transactional_Logs_Bool_Exp>;
};

/** Ordering options when selecting data from "customer_order_item_etd_transactional_logs". */
export type Customer_Order_Item_Etd_Transactional_Logs_Order_By = {
  cancellation_reason?: InputMaybe<Cancellation_Reasons_Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_order_item?: InputMaybe<Customer_Order_Item_Order_By>;
  customer_order_item_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  new_estimate_delivery_date?: InputMaybe<Order_By>;
  previous_estimate_delivery_date?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  reason_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: customer_order_item_etd_transactional_logs */
export type Customer_Order_Item_Etd_Transactional_Logs_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "customer_order_item_etd_transactional_logs" */
export enum Customer_Order_Item_Etd_Transactional_Logs_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerOrderItemId = 'customer_order_item_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  NewEstimateDeliveryDate = 'new_estimate_delivery_date',
  /** column name */
  PreviousEstimateDeliveryDate = 'previous_estimate_delivery_date',
  /** column name */
  Reason = 'reason',
  /** column name */
  ReasonId = 'reason_id'
}

/** select "customer_order_item_etd_transactional_logs_aggregate_bool_exp_bool_and_arguments_columns" columns of table "customer_order_item_etd_transactional_logs" */
export enum Customer_Order_Item_Etd_Transactional_Logs_Select_Column_Customer_Order_Item_Etd_Transactional_Logs_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "customer_order_item_etd_transactional_logs_aggregate_bool_exp_bool_or_arguments_columns" columns of table "customer_order_item_etd_transactional_logs" */
export enum Customer_Order_Item_Etd_Transactional_Logs_Select_Column_Customer_Order_Item_Etd_Transactional_Logs_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "customer_order_item_etd_transactional_logs" */
export type Customer_Order_Item_Etd_Transactional_Logs_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  new_estimate_delivery_date?: InputMaybe<Scalars['timestamp']['input']>;
  previous_estimate_delivery_date?: InputMaybe<Scalars['timestamp']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  reason_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "customer_order_item_etd_transactional_logs" */
export type Customer_Order_Item_Etd_Transactional_Logs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Order_Item_Etd_Transactional_Logs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customer_Order_Item_Etd_Transactional_Logs_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  new_estimate_delivery_date?: InputMaybe<Scalars['timestamp']['input']>;
  previous_estimate_delivery_date?: InputMaybe<Scalars['timestamp']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  reason_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "customer_order_item_etd_transactional_logs" */
export enum Customer_Order_Item_Etd_Transactional_Logs_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerOrderItemId = 'customer_order_item_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  NewEstimateDeliveryDate = 'new_estimate_delivery_date',
  /** column name */
  PreviousEstimateDeliveryDate = 'previous_estimate_delivery_date',
  /** column name */
  Reason = 'reason',
  /** column name */
  ReasonId = 'reason_id'
}

export type Customer_Order_Item_Etd_Transactional_Logs_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Order_Item_Etd_Transactional_Logs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Customer_Order_Item_Etd_Transactional_Logs_Bool_Exp;
};

/** input type for incrementing numeric columns in table "customer_order_item" */
export type Customer_Order_Item_Inc_Input = {
  actual_amount?: InputMaybe<Scalars['numeric']['input']>;
  actual_qty?: InputMaybe<Scalars['numeric']['input']>;
  amount?: InputMaybe<Scalars['numeric']['input']>;
  delivery_fee?: InputMaybe<Scalars['numeric']['input']>;
  discount_amount?: InputMaybe<Scalars['numeric']['input']>;
  discount_rate?: InputMaybe<Scalars['numeric']['input']>;
  qty?: InputMaybe<Scalars['numeric']['input']>;
  service_tax?: InputMaybe<Scalars['numeric']['input']>;
  tax?: InputMaybe<Scalars['numeric']['input']>;
  unit_price?: InputMaybe<Scalars['numeric']['input']>;
  voucher_discount?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "customer_order_item" */
export type Customer_Order_Item_Insert_Input = {
  actual_amount?: InputMaybe<Scalars['numeric']['input']>;
  actual_delivery_date?: InputMaybe<Scalars['timestamptz']['input']>;
  actual_qty?: InputMaybe<Scalars['numeric']['input']>;
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order?: InputMaybe<Customer_Order_Obj_Rel_Insert_Input>;
  customer_order_item_cancellation_reasons?: InputMaybe<Customer_Order_Item_Cancellation_Reasons_Arr_Rel_Insert_Input>;
  customer_order_item_comments?: InputMaybe<Customer_Order_Item_Comments_Arr_Rel_Insert_Input>;
  customer_order_item_commissions?: InputMaybe<Customer_Order_Item_Commission_Arr_Rel_Insert_Input>;
  customer_order_item_etd_transactional_logs?: InputMaybe<Customer_Order_Item_Etd_Transactional_Logs_Arr_Rel_Insert_Input>;
  customer_order_item_partners?: InputMaybe<Customer_Order_Item_Partner_Arr_Rel_Insert_Input>;
  customer_order_item_safety_checklist_results?: InputMaybe<Customer_Order_Item_Safety_Checklist_Results_Arr_Rel_Insert_Input>;
  customer_order_item_state?: InputMaybe<Customer_Order_Item_State_Obj_Rel_Insert_Input>;
  customer_order_item_stateflows?: InputMaybe<Customer_Order_Item_Stateflow_Arr_Rel_Insert_Input>;
  customer_order_item_test_categories?: InputMaybe<Customer_Order_Item_Test_Category_Arr_Rel_Insert_Input>;
  customer_order_slot?: InputMaybe<Customer_Order_Slots_Obj_Rel_Insert_Input>;
  customer_order_slots_id?: InputMaybe<Scalars['uuid']['input']>;
  delivery_fee?: InputMaybe<Scalars['numeric']['input']>;
  discountTypeByDiscountType?: InputMaybe<Discount_Type_Obj_Rel_Insert_Input>;
  discount_amount?: InputMaybe<Scalars['numeric']['input']>;
  discount_rate?: InputMaybe<Scalars['numeric']['input']>;
  discount_type?: InputMaybe<Discount_Type_Enum>;
  estimate_delivery_date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invoiced_items?: InputMaybe<Invoiced_Item_Arr_Rel_Insert_Input>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_b2b?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  order_id?: InputMaybe<Scalars['uuid']['input']>;
  partner?: InputMaybe<Partner_Obj_Rel_Insert_Input>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  product_variation?: InputMaybe<Product_Variation_Obj_Rel_Insert_Input>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  product_variation_partner_localities_slot?: InputMaybe<Product_Variation_Partner_Localities_Slots_Obj_Rel_Insert_Input>;
  product_variation_partner_localities_slot_id?: InputMaybe<Scalars['uuid']['input']>;
  qty?: InputMaybe<Scalars['numeric']['input']>;
  service_tax?: InputMaybe<Scalars['numeric']['input']>;
  state?: InputMaybe<Customer_Order_Item_State_Enum>;
  task?: InputMaybe<Task_Obj_Rel_Insert_Input>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
  tasks?: InputMaybe<Task_Arr_Rel_Insert_Input>;
  tax?: InputMaybe<Scalars['numeric']['input']>;
  unit?: InputMaybe<Unit_Of_Measure_Enum>;
  unit_of_measure?: InputMaybe<Unit_Of_Measure_Obj_Rel_Insert_Input>;
  unit_price?: InputMaybe<Scalars['numeric']['input']>;
  voucher_discount?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Customer_Order_Item_Max_Fields = {
  __typename?: 'customer_order_item_max_fields';
  actual_amount?: Maybe<Scalars['numeric']['output']>;
  actual_delivery_date?: Maybe<Scalars['timestamptz']['output']>;
  actual_qty?: Maybe<Scalars['numeric']['output']>;
  amount?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_order_slots_id?: Maybe<Scalars['uuid']['output']>;
  delivery_fee?: Maybe<Scalars['numeric']['output']>;
  discount_amount?: Maybe<Scalars['numeric']['output']>;
  discount_rate?: Maybe<Scalars['numeric']['output']>;
  estimate_delivery_date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  order_id?: Maybe<Scalars['uuid']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
  product_variation_partner_localities_slot_id?: Maybe<Scalars['uuid']['output']>;
  qty?: Maybe<Scalars['numeric']['output']>;
  service_tax?: Maybe<Scalars['numeric']['output']>;
  task_id?: Maybe<Scalars['uuid']['output']>;
  tax?: Maybe<Scalars['numeric']['output']>;
  unit_price?: Maybe<Scalars['numeric']['output']>;
  voucher_discount?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "customer_order_item" */
export type Customer_Order_Item_Max_Order_By = {
  actual_amount?: InputMaybe<Order_By>;
  actual_delivery_date?: InputMaybe<Order_By>;
  actual_qty?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_order_slots_id?: InputMaybe<Order_By>;
  delivery_fee?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  discount_rate?: InputMaybe<Order_By>;
  estimate_delivery_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  product_variation_partner_localities_slot_id?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Customer_Order_Item_Min_Fields = {
  __typename?: 'customer_order_item_min_fields';
  actual_amount?: Maybe<Scalars['numeric']['output']>;
  actual_delivery_date?: Maybe<Scalars['timestamptz']['output']>;
  actual_qty?: Maybe<Scalars['numeric']['output']>;
  amount?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_order_slots_id?: Maybe<Scalars['uuid']['output']>;
  delivery_fee?: Maybe<Scalars['numeric']['output']>;
  discount_amount?: Maybe<Scalars['numeric']['output']>;
  discount_rate?: Maybe<Scalars['numeric']['output']>;
  estimate_delivery_date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  order_id?: Maybe<Scalars['uuid']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
  product_variation_partner_localities_slot_id?: Maybe<Scalars['uuid']['output']>;
  qty?: Maybe<Scalars['numeric']['output']>;
  service_tax?: Maybe<Scalars['numeric']['output']>;
  task_id?: Maybe<Scalars['uuid']['output']>;
  tax?: Maybe<Scalars['numeric']['output']>;
  unit_price?: Maybe<Scalars['numeric']['output']>;
  voucher_discount?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "customer_order_item" */
export type Customer_Order_Item_Min_Order_By = {
  actual_amount?: InputMaybe<Order_By>;
  actual_delivery_date?: InputMaybe<Order_By>;
  actual_qty?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_order_slots_id?: InputMaybe<Order_By>;
  delivery_fee?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  discount_rate?: InputMaybe<Order_By>;
  estimate_delivery_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  product_variation_partner_localities_slot_id?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "customer_order_item" */
export type Customer_Order_Item_Mutation_Response = {
  __typename?: 'customer_order_item_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Customer_Order_Item>;
};

/** input type for inserting object relation for remote table "customer_order_item" */
export type Customer_Order_Item_Obj_Rel_Insert_Input = {
  data: Customer_Order_Item_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Order_Item_On_Conflict>;
};

/** on_conflict condition type for table "customer_order_item" */
export type Customer_Order_Item_On_Conflict = {
  constraint: Customer_Order_Item_Constraint;
  update_columns?: Array<Customer_Order_Item_Update_Column>;
  where?: InputMaybe<Customer_Order_Item_Bool_Exp>;
};

/** Ordering options when selecting data from "customer_order_item". */
export type Customer_Order_Item_Order_By = {
  actual_amount?: InputMaybe<Order_By>;
  actual_delivery_date?: InputMaybe<Order_By>;
  actual_qty?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_order?: InputMaybe<Customer_Order_Order_By>;
  customer_order_item_cancellation_reasons_aggregate?: InputMaybe<Customer_Order_Item_Cancellation_Reasons_Aggregate_Order_By>;
  customer_order_item_comments_aggregate?: InputMaybe<Customer_Order_Item_Comments_Aggregate_Order_By>;
  customer_order_item_commissions_aggregate?: InputMaybe<Customer_Order_Item_Commission_Aggregate_Order_By>;
  customer_order_item_etd_transactional_logs_aggregate?: InputMaybe<Customer_Order_Item_Etd_Transactional_Logs_Aggregate_Order_By>;
  customer_order_item_partners_aggregate?: InputMaybe<Customer_Order_Item_Partner_Aggregate_Order_By>;
  customer_order_item_safety_checklist_results_aggregate?: InputMaybe<Customer_Order_Item_Safety_Checklist_Results_Aggregate_Order_By>;
  customer_order_item_state?: InputMaybe<Customer_Order_Item_State_Order_By>;
  customer_order_item_stateflows_aggregate?: InputMaybe<Customer_Order_Item_Stateflow_Aggregate_Order_By>;
  customer_order_item_test_categories_aggregate?: InputMaybe<Customer_Order_Item_Test_Category_Aggregate_Order_By>;
  customer_order_slot?: InputMaybe<Customer_Order_Slots_Order_By>;
  customer_order_slots_id?: InputMaybe<Order_By>;
  delivery_fee?: InputMaybe<Order_By>;
  discountTypeByDiscountType?: InputMaybe<Discount_Type_Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  discount_rate?: InputMaybe<Order_By>;
  discount_type?: InputMaybe<Order_By>;
  estimate_delivery_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoiced_items_aggregate?: InputMaybe<Invoiced_Item_Aggregate_Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_b2b?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  partner?: InputMaybe<Partner_Order_By>;
  partner_id?: InputMaybe<Order_By>;
  product_variation?: InputMaybe<Product_Variation_Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  product_variation_partner_localities_slot?: InputMaybe<Product_Variation_Partner_Localities_Slots_Order_By>;
  product_variation_partner_localities_slot_id?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  task?: InputMaybe<Task_Order_By>;
  task_id?: InputMaybe<Order_By>;
  tasks_aggregate?: InputMaybe<Task_Aggregate_Order_By>;
  tax?: InputMaybe<Order_By>;
  unit?: InputMaybe<Order_By>;
  unit_of_measure?: InputMaybe<Unit_Of_Measure_Order_By>;
  unit_price?: InputMaybe<Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
};

/** columns and relationships of "customer_order_item_partner" */
export type Customer_Order_Item_Partner = {
  __typename?: 'customer_order_item_partner';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  customer_order_item: Customer_Order_Item;
  customer_order_item_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  partner: Partner;
  partner_id: Scalars['uuid']['output'];
  /** An object relationship */
  product_partner_localities_price?: Maybe<Product_Partner_Localities_Price>;
  product_partner_localities_price_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  product_variation_partner_localities_slot?: Maybe<Product_Variation_Partner_Localities_Slots>;
  product_variation_partner_localities_slot_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "customer_order_item_partner" */
export type Customer_Order_Item_Partner_Aggregate = {
  __typename?: 'customer_order_item_partner_aggregate';
  aggregate?: Maybe<Customer_Order_Item_Partner_Aggregate_Fields>;
  nodes: Array<Customer_Order_Item_Partner>;
};

export type Customer_Order_Item_Partner_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Customer_Order_Item_Partner_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Customer_Order_Item_Partner_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Customer_Order_Item_Partner_Aggregate_Bool_Exp_Count>;
};

export type Customer_Order_Item_Partner_Aggregate_Bool_Exp_Bool_And = {
  arguments: Customer_Order_Item_Partner_Select_Column_Customer_Order_Item_Partner_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Item_Partner_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customer_Order_Item_Partner_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Customer_Order_Item_Partner_Select_Column_Customer_Order_Item_Partner_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Item_Partner_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customer_Order_Item_Partner_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Customer_Order_Item_Partner_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Item_Partner_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "customer_order_item_partner" */
export type Customer_Order_Item_Partner_Aggregate_Fields = {
  __typename?: 'customer_order_item_partner_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Customer_Order_Item_Partner_Max_Fields>;
  min?: Maybe<Customer_Order_Item_Partner_Min_Fields>;
};


/** aggregate fields of "customer_order_item_partner" */
export type Customer_Order_Item_Partner_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Order_Item_Partner_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "customer_order_item_partner" */
export type Customer_Order_Item_Partner_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Customer_Order_Item_Partner_Max_Order_By>;
  min?: InputMaybe<Customer_Order_Item_Partner_Min_Order_By>;
};

/** input type for inserting array relation for remote table "customer_order_item_partner" */
export type Customer_Order_Item_Partner_Arr_Rel_Insert_Input = {
  data: Array<Customer_Order_Item_Partner_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Order_Item_Partner_On_Conflict>;
};

/** Boolean expression to filter rows from the table "customer_order_item_partner". All fields are combined with a logical 'AND'. */
export type Customer_Order_Item_Partner_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Order_Item_Partner_Bool_Exp>>;
  _not?: InputMaybe<Customer_Order_Item_Partner_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Order_Item_Partner_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_order_item?: InputMaybe<Customer_Order_Item_Bool_Exp>;
  customer_order_item_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  partner?: InputMaybe<Partner_Bool_Exp>;
  partner_id?: InputMaybe<Uuid_Comparison_Exp>;
  product_partner_localities_price?: InputMaybe<Product_Partner_Localities_Price_Bool_Exp>;
  product_partner_localities_price_id?: InputMaybe<Uuid_Comparison_Exp>;
  product_variation_partner_localities_slot?: InputMaybe<Product_Variation_Partner_Localities_Slots_Bool_Exp>;
  product_variation_partner_localities_slot_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "customer_order_item_partner" */
export enum Customer_Order_Item_Partner_Constraint {
  /** unique or primary key constraint on columns "id" */
  CustomerOrderItemPartnerPkey = 'customer_order_item_partner_pkey'
}

/** input type for inserting data into table "customer_order_item_partner" */
export type Customer_Order_Item_Partner_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_item?: InputMaybe<Customer_Order_Item_Obj_Rel_Insert_Input>;
  customer_order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner?: InputMaybe<Partner_Obj_Rel_Insert_Input>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  product_partner_localities_price?: InputMaybe<Product_Partner_Localities_Price_Obj_Rel_Insert_Input>;
  product_partner_localities_price_id?: InputMaybe<Scalars['uuid']['input']>;
  product_variation_partner_localities_slot?: InputMaybe<Product_Variation_Partner_Localities_Slots_Obj_Rel_Insert_Input>;
  product_variation_partner_localities_slot_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Customer_Order_Item_Partner_Max_Fields = {
  __typename?: 'customer_order_item_partner_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_order_item_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  product_partner_localities_price_id?: Maybe<Scalars['uuid']['output']>;
  product_variation_partner_localities_slot_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "customer_order_item_partner" */
export type Customer_Order_Item_Partner_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_order_item_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  product_partner_localities_price_id?: InputMaybe<Order_By>;
  product_variation_partner_localities_slot_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Customer_Order_Item_Partner_Min_Fields = {
  __typename?: 'customer_order_item_partner_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_order_item_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  product_partner_localities_price_id?: Maybe<Scalars['uuid']['output']>;
  product_variation_partner_localities_slot_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "customer_order_item_partner" */
export type Customer_Order_Item_Partner_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_order_item_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  product_partner_localities_price_id?: InputMaybe<Order_By>;
  product_variation_partner_localities_slot_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "customer_order_item_partner" */
export type Customer_Order_Item_Partner_Mutation_Response = {
  __typename?: 'customer_order_item_partner_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Customer_Order_Item_Partner>;
};

/** on_conflict condition type for table "customer_order_item_partner" */
export type Customer_Order_Item_Partner_On_Conflict = {
  constraint: Customer_Order_Item_Partner_Constraint;
  update_columns?: Array<Customer_Order_Item_Partner_Update_Column>;
  where?: InputMaybe<Customer_Order_Item_Partner_Bool_Exp>;
};

/** Ordering options when selecting data from "customer_order_item_partner". */
export type Customer_Order_Item_Partner_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_order_item?: InputMaybe<Customer_Order_Item_Order_By>;
  customer_order_item_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner?: InputMaybe<Partner_Order_By>;
  partner_id?: InputMaybe<Order_By>;
  product_partner_localities_price?: InputMaybe<Product_Partner_Localities_Price_Order_By>;
  product_partner_localities_price_id?: InputMaybe<Order_By>;
  product_variation_partner_localities_slot?: InputMaybe<Product_Variation_Partner_Localities_Slots_Order_By>;
  product_variation_partner_localities_slot_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: customer_order_item_partner */
export type Customer_Order_Item_Partner_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "customer_order_item_partner" */
export enum Customer_Order_Item_Partner_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerOrderItemId = 'customer_order_item_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  ProductPartnerLocalitiesPriceId = 'product_partner_localities_price_id',
  /** column name */
  ProductVariationPartnerLocalitiesSlotId = 'product_variation_partner_localities_slot_id'
}

/** select "customer_order_item_partner_aggregate_bool_exp_bool_and_arguments_columns" columns of table "customer_order_item_partner" */
export enum Customer_Order_Item_Partner_Select_Column_Customer_Order_Item_Partner_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "customer_order_item_partner_aggregate_bool_exp_bool_or_arguments_columns" columns of table "customer_order_item_partner" */
export enum Customer_Order_Item_Partner_Select_Column_Customer_Order_Item_Partner_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "customer_order_item_partner" */
export type Customer_Order_Item_Partner_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  product_partner_localities_price_id?: InputMaybe<Scalars['uuid']['input']>;
  product_variation_partner_localities_slot_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "customer_order_item_partner" */
export type Customer_Order_Item_Partner_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Order_Item_Partner_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customer_Order_Item_Partner_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  product_partner_localities_price_id?: InputMaybe<Scalars['uuid']['input']>;
  product_variation_partner_localities_slot_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "customer_order_item_partner" */
export enum Customer_Order_Item_Partner_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerOrderItemId = 'customer_order_item_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  ProductPartnerLocalitiesPriceId = 'product_partner_localities_price_id',
  /** column name */
  ProductVariationPartnerLocalitiesSlotId = 'product_variation_partner_localities_slot_id'
}

export type Customer_Order_Item_Partner_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Order_Item_Partner_Set_Input>;
  /** filter the rows which have to be updated */
  where: Customer_Order_Item_Partner_Bool_Exp;
};

/** primary key columns input for table: customer_order_item */
export type Customer_Order_Item_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "customer_order_item_safety_checklist_results" */
export type Customer_Order_Item_Safety_Checklist_Results = {
  __typename?: 'customer_order_item_safety_checklist_results';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  customer_order_item: Customer_Order_Item;
  customer_order_item_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  key?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  safety_checklist: Safety_Checklist;
  safety_checklist_id: Scalars['uuid']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "customer_order_item_safety_checklist_results" */
export type Customer_Order_Item_Safety_Checklist_Results_Aggregate = {
  __typename?: 'customer_order_item_safety_checklist_results_aggregate';
  aggregate?: Maybe<Customer_Order_Item_Safety_Checklist_Results_Aggregate_Fields>;
  nodes: Array<Customer_Order_Item_Safety_Checklist_Results>;
};

export type Customer_Order_Item_Safety_Checklist_Results_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Customer_Order_Item_Safety_Checklist_Results_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Customer_Order_Item_Safety_Checklist_Results_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Customer_Order_Item_Safety_Checklist_Results_Aggregate_Bool_Exp_Count>;
};

export type Customer_Order_Item_Safety_Checklist_Results_Aggregate_Bool_Exp_Bool_And = {
  arguments: Customer_Order_Item_Safety_Checklist_Results_Select_Column_Customer_Order_Item_Safety_Checklist_Results_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Item_Safety_Checklist_Results_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customer_Order_Item_Safety_Checklist_Results_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Customer_Order_Item_Safety_Checklist_Results_Select_Column_Customer_Order_Item_Safety_Checklist_Results_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Item_Safety_Checklist_Results_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customer_Order_Item_Safety_Checklist_Results_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Customer_Order_Item_Safety_Checklist_Results_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Item_Safety_Checklist_Results_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "customer_order_item_safety_checklist_results" */
export type Customer_Order_Item_Safety_Checklist_Results_Aggregate_Fields = {
  __typename?: 'customer_order_item_safety_checklist_results_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Customer_Order_Item_Safety_Checklist_Results_Max_Fields>;
  min?: Maybe<Customer_Order_Item_Safety_Checklist_Results_Min_Fields>;
};


/** aggregate fields of "customer_order_item_safety_checklist_results" */
export type Customer_Order_Item_Safety_Checklist_Results_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Order_Item_Safety_Checklist_Results_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "customer_order_item_safety_checklist_results" */
export type Customer_Order_Item_Safety_Checklist_Results_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Customer_Order_Item_Safety_Checklist_Results_Max_Order_By>;
  min?: InputMaybe<Customer_Order_Item_Safety_Checklist_Results_Min_Order_By>;
};

/** input type for inserting array relation for remote table "customer_order_item_safety_checklist_results" */
export type Customer_Order_Item_Safety_Checklist_Results_Arr_Rel_Insert_Input = {
  data: Array<Customer_Order_Item_Safety_Checklist_Results_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Order_Item_Safety_Checklist_Results_On_Conflict>;
};

/** Boolean expression to filter rows from the table "customer_order_item_safety_checklist_results". All fields are combined with a logical 'AND'. */
export type Customer_Order_Item_Safety_Checklist_Results_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Order_Item_Safety_Checklist_Results_Bool_Exp>>;
  _not?: InputMaybe<Customer_Order_Item_Safety_Checklist_Results_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Order_Item_Safety_Checklist_Results_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_order_item?: InputMaybe<Customer_Order_Item_Bool_Exp>;
  customer_order_item_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  safety_checklist?: InputMaybe<Safety_Checklist_Bool_Exp>;
  safety_checklist_id?: InputMaybe<Uuid_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "customer_order_item_safety_checklist_results" */
export enum Customer_Order_Item_Safety_Checklist_Results_Constraint {
  /** unique or primary key constraint on columns "id" */
  CustomerOrderItemSafetyChecklistResultsPkey = 'customer_order_item_safety_checklist_results_pkey'
}

/** input type for inserting data into table "customer_order_item_safety_checklist_results" */
export type Customer_Order_Item_Safety_Checklist_Results_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_item?: InputMaybe<Customer_Order_Item_Obj_Rel_Insert_Input>;
  customer_order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  safety_checklist?: InputMaybe<Safety_Checklist_Obj_Rel_Insert_Input>;
  safety_checklist_id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Customer_Order_Item_Safety_Checklist_Results_Max_Fields = {
  __typename?: 'customer_order_item_safety_checklist_results_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_order_item_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  safety_checklist_id?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "customer_order_item_safety_checklist_results" */
export type Customer_Order_Item_Safety_Checklist_Results_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_order_item_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  safety_checklist_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Customer_Order_Item_Safety_Checklist_Results_Min_Fields = {
  __typename?: 'customer_order_item_safety_checklist_results_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_order_item_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  safety_checklist_id?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "customer_order_item_safety_checklist_results" */
export type Customer_Order_Item_Safety_Checklist_Results_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_order_item_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  safety_checklist_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "customer_order_item_safety_checklist_results" */
export type Customer_Order_Item_Safety_Checklist_Results_Mutation_Response = {
  __typename?: 'customer_order_item_safety_checklist_results_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Customer_Order_Item_Safety_Checklist_Results>;
};

/** on_conflict condition type for table "customer_order_item_safety_checklist_results" */
export type Customer_Order_Item_Safety_Checklist_Results_On_Conflict = {
  constraint: Customer_Order_Item_Safety_Checklist_Results_Constraint;
  update_columns?: Array<Customer_Order_Item_Safety_Checklist_Results_Update_Column>;
  where?: InputMaybe<Customer_Order_Item_Safety_Checklist_Results_Bool_Exp>;
};

/** Ordering options when selecting data from "customer_order_item_safety_checklist_results". */
export type Customer_Order_Item_Safety_Checklist_Results_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_order_item?: InputMaybe<Customer_Order_Item_Order_By>;
  customer_order_item_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  safety_checklist?: InputMaybe<Safety_Checklist_Order_By>;
  safety_checklist_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: customer_order_item_safety_checklist_results */
export type Customer_Order_Item_Safety_Checklist_Results_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "customer_order_item_safety_checklist_results" */
export enum Customer_Order_Item_Safety_Checklist_Results_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerOrderItemId = 'customer_order_item_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Key = 'key',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  SafetyChecklistId = 'safety_checklist_id',
  /** column name */
  Value = 'value'
}

/** select "customer_order_item_safety_checklist_results_aggregate_bool_exp_bool_and_arguments_columns" columns of table "customer_order_item_safety_checklist_results" */
export enum Customer_Order_Item_Safety_Checklist_Results_Select_Column_Customer_Order_Item_Safety_Checklist_Results_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "customer_order_item_safety_checklist_results_aggregate_bool_exp_bool_or_arguments_columns" columns of table "customer_order_item_safety_checklist_results" */
export enum Customer_Order_Item_Safety_Checklist_Results_Select_Column_Customer_Order_Item_Safety_Checklist_Results_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "customer_order_item_safety_checklist_results" */
export type Customer_Order_Item_Safety_Checklist_Results_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  safety_checklist_id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "customer_order_item_safety_checklist_results" */
export type Customer_Order_Item_Safety_Checklist_Results_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Order_Item_Safety_Checklist_Results_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customer_Order_Item_Safety_Checklist_Results_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  safety_checklist_id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "customer_order_item_safety_checklist_results" */
export enum Customer_Order_Item_Safety_Checklist_Results_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerOrderItemId = 'customer_order_item_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Key = 'key',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  SafetyChecklistId = 'safety_checklist_id',
  /** column name */
  Value = 'value'
}

export type Customer_Order_Item_Safety_Checklist_Results_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Order_Item_Safety_Checklist_Results_Set_Input>;
  /** filter the rows which have to be updated */
  where: Customer_Order_Item_Safety_Checklist_Results_Bool_Exp;
};

/** select columns of table "customer_order_item" */
export enum Customer_Order_Item_Select_Column {
  /** column name */
  ActualAmount = 'actual_amount',
  /** column name */
  ActualDeliveryDate = 'actual_delivery_date',
  /** column name */
  ActualQty = 'actual_qty',
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerOrderSlotsId = 'customer_order_slots_id',
  /** column name */
  DeliveryFee = 'delivery_fee',
  /** column name */
  DiscountAmount = 'discount_amount',
  /** column name */
  DiscountRate = 'discount_rate',
  /** column name */
  DiscountType = 'discount_type',
  /** column name */
  EstimateDeliveryDate = 'estimate_delivery_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsB2b = 'is_b2b',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  ProductVariationId = 'product_variation_id',
  /** column name */
  ProductVariationPartnerLocalitiesSlotId = 'product_variation_partner_localities_slot_id',
  /** column name */
  Qty = 'qty',
  /** column name */
  ServiceTax = 'service_tax',
  /** column name */
  State = 'state',
  /** column name */
  TaskId = 'task_id',
  /** column name */
  Tax = 'tax',
  /** column name */
  Unit = 'unit',
  /** column name */
  UnitPrice = 'unit_price',
  /** column name */
  VoucherDiscount = 'voucher_discount'
}

/** select "customer_order_item_aggregate_bool_exp_bool_and_arguments_columns" columns of table "customer_order_item" */
export enum Customer_Order_Item_Select_Column_Customer_Order_Item_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsB2b = 'is_b2b'
}

/** select "customer_order_item_aggregate_bool_exp_bool_or_arguments_columns" columns of table "customer_order_item" */
export enum Customer_Order_Item_Select_Column_Customer_Order_Item_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsB2b = 'is_b2b'
}

/** input type for updating data in table "customer_order_item" */
export type Customer_Order_Item_Set_Input = {
  actual_amount?: InputMaybe<Scalars['numeric']['input']>;
  actual_delivery_date?: InputMaybe<Scalars['timestamptz']['input']>;
  actual_qty?: InputMaybe<Scalars['numeric']['input']>;
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_slots_id?: InputMaybe<Scalars['uuid']['input']>;
  delivery_fee?: InputMaybe<Scalars['numeric']['input']>;
  discount_amount?: InputMaybe<Scalars['numeric']['input']>;
  discount_rate?: InputMaybe<Scalars['numeric']['input']>;
  discount_type?: InputMaybe<Discount_Type_Enum>;
  estimate_delivery_date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_b2b?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  order_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  product_variation_partner_localities_slot_id?: InputMaybe<Scalars['uuid']['input']>;
  qty?: InputMaybe<Scalars['numeric']['input']>;
  service_tax?: InputMaybe<Scalars['numeric']['input']>;
  state?: InputMaybe<Customer_Order_Item_State_Enum>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
  tax?: InputMaybe<Scalars['numeric']['input']>;
  unit?: InputMaybe<Unit_Of_Measure_Enum>;
  unit_price?: InputMaybe<Scalars['numeric']['input']>;
  voucher_discount?: InputMaybe<Scalars['numeric']['input']>;
};

/** columns and relationships of "customer_order_item_state" */
export type Customer_Order_Item_State = {
  __typename?: 'customer_order_item_state';
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  customer_order_item_stateflows: Array<Customer_Order_Item_Stateflow>;
  /** An aggregate relationship */
  customer_order_item_stateflows_aggregate: Customer_Order_Item_Stateflow_Aggregate;
  /** An array relationship */
  customer_order_items: Array<Customer_Order_Item>;
  /** An aggregate relationship */
  customer_order_items_aggregate: Customer_Order_Item_Aggregate;
  /** An array relationship */
  invoiced_items: Array<Invoiced_Item>;
  /** An aggregate relationship */
  invoiced_items_aggregate: Invoiced_Item_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "customer_order_item_state" */
export type Customer_Order_Item_StateCustomer_Order_Item_StateflowsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Stateflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Stateflow_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Stateflow_Bool_Exp>;
};


/** columns and relationships of "customer_order_item_state" */
export type Customer_Order_Item_StateCustomer_Order_Item_Stateflows_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Stateflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Stateflow_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Stateflow_Bool_Exp>;
};


/** columns and relationships of "customer_order_item_state" */
export type Customer_Order_Item_StateCustomer_Order_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Bool_Exp>;
};


/** columns and relationships of "customer_order_item_state" */
export type Customer_Order_Item_StateCustomer_Order_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Bool_Exp>;
};


/** columns and relationships of "customer_order_item_state" */
export type Customer_Order_Item_StateInvoiced_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Bool_Exp>;
};


/** columns and relationships of "customer_order_item_state" */
export type Customer_Order_Item_StateInvoiced_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Bool_Exp>;
};

/** aggregated selection of "customer_order_item_state" */
export type Customer_Order_Item_State_Aggregate = {
  __typename?: 'customer_order_item_state_aggregate';
  aggregate?: Maybe<Customer_Order_Item_State_Aggregate_Fields>;
  nodes: Array<Customer_Order_Item_State>;
};

/** aggregate fields of "customer_order_item_state" */
export type Customer_Order_Item_State_Aggregate_Fields = {
  __typename?: 'customer_order_item_state_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Customer_Order_Item_State_Max_Fields>;
  min?: Maybe<Customer_Order_Item_State_Min_Fields>;
};


/** aggregate fields of "customer_order_item_state" */
export type Customer_Order_Item_State_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Order_Item_State_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "customer_order_item_state". All fields are combined with a logical 'AND'. */
export type Customer_Order_Item_State_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Order_Item_State_Bool_Exp>>;
  _not?: InputMaybe<Customer_Order_Item_State_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Order_Item_State_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  customer_order_item_stateflows?: InputMaybe<Customer_Order_Item_Stateflow_Bool_Exp>;
  customer_order_item_stateflows_aggregate?: InputMaybe<Customer_Order_Item_Stateflow_Aggregate_Bool_Exp>;
  customer_order_items?: InputMaybe<Customer_Order_Item_Bool_Exp>;
  customer_order_items_aggregate?: InputMaybe<Customer_Order_Item_Aggregate_Bool_Exp>;
  invoiced_items?: InputMaybe<Invoiced_Item_Bool_Exp>;
  invoiced_items_aggregate?: InputMaybe<Invoiced_Item_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "customer_order_item_state" */
export enum Customer_Order_Item_State_Constraint {
  /** unique or primary key constraint on columns "value" */
  CustomerOrderItemStatePkey = 'customer_order_item_state_pkey'
}

export enum Customer_Order_Item_State_Enum {
  /** when item accepted by franchise */
  Accepted = 'ACCEPTED',
  /** when task assigned to the driver vehicle */
  Assigned = 'ASSIGNED',
  /** when item is cancelled */
  Cancelled = 'CANCELLED',
  /** when order mark paid, order item status is confirmed */
  Confirmed = 'CONFIRMED',
  /** when item is delivered */
  Delivered = 'DELIVERED',
  /** When vehicle is moving  */
  InTransit = 'IN_TRANSIT',
  /** NO_SHOW */
  NoShow = 'NO_SHOW',
  /** when order create, order item status is pending */
  Pending = 'PENDING',
  /** when item is pickup */
  Pickup = 'PICKUP'
}

/** Boolean expression to compare columns of type "customer_order_item_state_enum". All fields are combined with logical 'AND'. */
export type Customer_Order_Item_State_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Customer_Order_Item_State_Enum>;
  _in?: InputMaybe<Array<Customer_Order_Item_State_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Customer_Order_Item_State_Enum>;
  _nin?: InputMaybe<Array<Customer_Order_Item_State_Enum>>;
};

/** input type for inserting data into table "customer_order_item_state" */
export type Customer_Order_Item_State_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  customer_order_item_stateflows?: InputMaybe<Customer_Order_Item_Stateflow_Arr_Rel_Insert_Input>;
  customer_order_items?: InputMaybe<Customer_Order_Item_Arr_Rel_Insert_Input>;
  invoiced_items?: InputMaybe<Invoiced_Item_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Customer_Order_Item_State_Max_Fields = {
  __typename?: 'customer_order_item_state_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Customer_Order_Item_State_Min_Fields = {
  __typename?: 'customer_order_item_state_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "customer_order_item_state" */
export type Customer_Order_Item_State_Mutation_Response = {
  __typename?: 'customer_order_item_state_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Customer_Order_Item_State>;
};

/** input type for inserting object relation for remote table "customer_order_item_state" */
export type Customer_Order_Item_State_Obj_Rel_Insert_Input = {
  data: Customer_Order_Item_State_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Order_Item_State_On_Conflict>;
};

/** on_conflict condition type for table "customer_order_item_state" */
export type Customer_Order_Item_State_On_Conflict = {
  constraint: Customer_Order_Item_State_Constraint;
  update_columns?: Array<Customer_Order_Item_State_Update_Column>;
  where?: InputMaybe<Customer_Order_Item_State_Bool_Exp>;
};

/** Ordering options when selecting data from "customer_order_item_state". */
export type Customer_Order_Item_State_Order_By = {
  comment?: InputMaybe<Order_By>;
  customer_order_item_stateflows_aggregate?: InputMaybe<Customer_Order_Item_Stateflow_Aggregate_Order_By>;
  customer_order_items_aggregate?: InputMaybe<Customer_Order_Item_Aggregate_Order_By>;
  invoiced_items_aggregate?: InputMaybe<Invoiced_Item_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: customer_order_item_state */
export type Customer_Order_Item_State_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "customer_order_item_state" */
export enum Customer_Order_Item_State_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "customer_order_item_state" */
export type Customer_Order_Item_State_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "customer_order_item_state" */
export type Customer_Order_Item_State_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Order_Item_State_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customer_Order_Item_State_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "customer_order_item_state" */
export enum Customer_Order_Item_State_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Customer_Order_Item_State_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Order_Item_State_Set_Input>;
  /** filter the rows which have to be updated */
  where: Customer_Order_Item_State_Bool_Exp;
};

/** columns and relationships of "customer_order_item_stateflow" */
export type Customer_Order_Item_Stateflow = {
  __typename?: 'customer_order_item_stateflow';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  customer_order_item: Customer_Order_Item;
  /** An object relationship */
  customer_order_item_state: Customer_Order_Item_State;
  id: Scalars['uuid']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  order_item_id: Scalars['uuid']['output'];
  /** An object relationship */
  organization_user?: Maybe<Organization_User>;
  organization_user_id?: Maybe<Scalars['uuid']['output']>;
  state: Customer_Order_Item_State_Enum;
};

/** aggregated selection of "customer_order_item_stateflow" */
export type Customer_Order_Item_Stateflow_Aggregate = {
  __typename?: 'customer_order_item_stateflow_aggregate';
  aggregate?: Maybe<Customer_Order_Item_Stateflow_Aggregate_Fields>;
  nodes: Array<Customer_Order_Item_Stateflow>;
};

export type Customer_Order_Item_Stateflow_Aggregate_Bool_Exp = {
  count?: InputMaybe<Customer_Order_Item_Stateflow_Aggregate_Bool_Exp_Count>;
};

export type Customer_Order_Item_Stateflow_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Customer_Order_Item_Stateflow_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Item_Stateflow_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "customer_order_item_stateflow" */
export type Customer_Order_Item_Stateflow_Aggregate_Fields = {
  __typename?: 'customer_order_item_stateflow_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Customer_Order_Item_Stateflow_Max_Fields>;
  min?: Maybe<Customer_Order_Item_Stateflow_Min_Fields>;
};


/** aggregate fields of "customer_order_item_stateflow" */
export type Customer_Order_Item_Stateflow_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Order_Item_Stateflow_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "customer_order_item_stateflow" */
export type Customer_Order_Item_Stateflow_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Customer_Order_Item_Stateflow_Max_Order_By>;
  min?: InputMaybe<Customer_Order_Item_Stateflow_Min_Order_By>;
};

/** input type for inserting array relation for remote table "customer_order_item_stateflow" */
export type Customer_Order_Item_Stateflow_Arr_Rel_Insert_Input = {
  data: Array<Customer_Order_Item_Stateflow_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Order_Item_Stateflow_On_Conflict>;
};

/** Boolean expression to filter rows from the table "customer_order_item_stateflow". All fields are combined with a logical 'AND'. */
export type Customer_Order_Item_Stateflow_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Order_Item_Stateflow_Bool_Exp>>;
  _not?: InputMaybe<Customer_Order_Item_Stateflow_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Order_Item_Stateflow_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_order_item?: InputMaybe<Customer_Order_Item_Bool_Exp>;
  customer_order_item_state?: InputMaybe<Customer_Order_Item_State_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  order_item_id?: InputMaybe<Uuid_Comparison_Exp>;
  organization_user?: InputMaybe<Organization_User_Bool_Exp>;
  organization_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  state?: InputMaybe<Customer_Order_Item_State_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "customer_order_item_stateflow" */
export enum Customer_Order_Item_Stateflow_Constraint {
  /** unique or primary key constraint on columns "id" */
  CustomerOrderItemStateflowPkey = 'customer_order_item_stateflow_pkey'
}

/** input type for inserting data into table "customer_order_item_stateflow" */
export type Customer_Order_Item_Stateflow_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_item?: InputMaybe<Customer_Order_Item_Obj_Rel_Insert_Input>;
  customer_order_item_state?: InputMaybe<Customer_Order_Item_State_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_user?: InputMaybe<Organization_User_Obj_Rel_Insert_Input>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Customer_Order_Item_State_Enum>;
};

/** aggregate max on columns */
export type Customer_Order_Item_Stateflow_Max_Fields = {
  __typename?: 'customer_order_item_stateflow_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  order_item_id?: Maybe<Scalars['uuid']['output']>;
  organization_user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "customer_order_item_stateflow" */
export type Customer_Order_Item_Stateflow_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  order_item_id?: InputMaybe<Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Customer_Order_Item_Stateflow_Min_Fields = {
  __typename?: 'customer_order_item_stateflow_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  order_item_id?: Maybe<Scalars['uuid']['output']>;
  organization_user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "customer_order_item_stateflow" */
export type Customer_Order_Item_Stateflow_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  order_item_id?: InputMaybe<Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "customer_order_item_stateflow" */
export type Customer_Order_Item_Stateflow_Mutation_Response = {
  __typename?: 'customer_order_item_stateflow_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Customer_Order_Item_Stateflow>;
};

/** on_conflict condition type for table "customer_order_item_stateflow" */
export type Customer_Order_Item_Stateflow_On_Conflict = {
  constraint: Customer_Order_Item_Stateflow_Constraint;
  update_columns?: Array<Customer_Order_Item_Stateflow_Update_Column>;
  where?: InputMaybe<Customer_Order_Item_Stateflow_Bool_Exp>;
};

/** Ordering options when selecting data from "customer_order_item_stateflow". */
export type Customer_Order_Item_Stateflow_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_order_item?: InputMaybe<Customer_Order_Item_Order_By>;
  customer_order_item_state?: InputMaybe<Customer_Order_Item_State_Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  order_item_id?: InputMaybe<Order_By>;
  organization_user?: InputMaybe<Organization_User_Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
};

/** primary key columns input for table: customer_order_item_stateflow */
export type Customer_Order_Item_Stateflow_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "customer_order_item_stateflow" */
export enum Customer_Order_Item_Stateflow_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrderItemId = 'order_item_id',
  /** column name */
  OrganizationUserId = 'organization_user_id',
  /** column name */
  State = 'state'
}

/** input type for updating data in table "customer_order_item_stateflow" */
export type Customer_Order_Item_Stateflow_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Customer_Order_Item_State_Enum>;
};

/** Streaming cursor of the table "customer_order_item_stateflow" */
export type Customer_Order_Item_Stateflow_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Order_Item_Stateflow_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customer_Order_Item_Stateflow_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Customer_Order_Item_State_Enum>;
};

/** update columns of table "customer_order_item_stateflow" */
export enum Customer_Order_Item_Stateflow_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrderItemId = 'order_item_id',
  /** column name */
  OrganizationUserId = 'organization_user_id',
  /** column name */
  State = 'state'
}

export type Customer_Order_Item_Stateflow_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Order_Item_Stateflow_Set_Input>;
  /** filter the rows which have to be updated */
  where: Customer_Order_Item_Stateflow_Bool_Exp;
};

/** aggregate stddev on columns */
export type Customer_Order_Item_Stddev_Fields = {
  __typename?: 'customer_order_item_stddev_fields';
  actual_amount?: Maybe<Scalars['Float']['output']>;
  actual_qty?: Maybe<Scalars['Float']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  delivery_fee?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  discount_rate?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  service_tax?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  unit_price?: Maybe<Scalars['Float']['output']>;
  voucher_discount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "customer_order_item" */
export type Customer_Order_Item_Stddev_Order_By = {
  actual_amount?: InputMaybe<Order_By>;
  actual_qty?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  delivery_fee?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  discount_rate?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Customer_Order_Item_Stddev_Pop_Fields = {
  __typename?: 'customer_order_item_stddev_pop_fields';
  actual_amount?: Maybe<Scalars['Float']['output']>;
  actual_qty?: Maybe<Scalars['Float']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  delivery_fee?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  discount_rate?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  service_tax?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  unit_price?: Maybe<Scalars['Float']['output']>;
  voucher_discount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "customer_order_item" */
export type Customer_Order_Item_Stddev_Pop_Order_By = {
  actual_amount?: InputMaybe<Order_By>;
  actual_qty?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  delivery_fee?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  discount_rate?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Customer_Order_Item_Stddev_Samp_Fields = {
  __typename?: 'customer_order_item_stddev_samp_fields';
  actual_amount?: Maybe<Scalars['Float']['output']>;
  actual_qty?: Maybe<Scalars['Float']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  delivery_fee?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  discount_rate?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  service_tax?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  unit_price?: Maybe<Scalars['Float']['output']>;
  voucher_discount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "customer_order_item" */
export type Customer_Order_Item_Stddev_Samp_Order_By = {
  actual_amount?: InputMaybe<Order_By>;
  actual_qty?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  delivery_fee?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  discount_rate?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "customer_order_item" */
export type Customer_Order_Item_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Order_Item_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customer_Order_Item_Stream_Cursor_Value_Input = {
  actual_amount?: InputMaybe<Scalars['numeric']['input']>;
  actual_delivery_date?: InputMaybe<Scalars['timestamptz']['input']>;
  actual_qty?: InputMaybe<Scalars['numeric']['input']>;
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_slots_id?: InputMaybe<Scalars['uuid']['input']>;
  delivery_fee?: InputMaybe<Scalars['numeric']['input']>;
  discount_amount?: InputMaybe<Scalars['numeric']['input']>;
  discount_rate?: InputMaybe<Scalars['numeric']['input']>;
  discount_type?: InputMaybe<Discount_Type_Enum>;
  estimate_delivery_date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_b2b?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  order_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  product_variation_partner_localities_slot_id?: InputMaybe<Scalars['uuid']['input']>;
  qty?: InputMaybe<Scalars['numeric']['input']>;
  service_tax?: InputMaybe<Scalars['numeric']['input']>;
  state?: InputMaybe<Customer_Order_Item_State_Enum>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
  tax?: InputMaybe<Scalars['numeric']['input']>;
  unit?: InputMaybe<Unit_Of_Measure_Enum>;
  unit_price?: InputMaybe<Scalars['numeric']['input']>;
  voucher_discount?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Customer_Order_Item_Sum_Fields = {
  __typename?: 'customer_order_item_sum_fields';
  actual_amount?: Maybe<Scalars['numeric']['output']>;
  actual_qty?: Maybe<Scalars['numeric']['output']>;
  amount?: Maybe<Scalars['numeric']['output']>;
  delivery_fee?: Maybe<Scalars['numeric']['output']>;
  discount_amount?: Maybe<Scalars['numeric']['output']>;
  discount_rate?: Maybe<Scalars['numeric']['output']>;
  qty?: Maybe<Scalars['numeric']['output']>;
  service_tax?: Maybe<Scalars['numeric']['output']>;
  tax?: Maybe<Scalars['numeric']['output']>;
  unit_price?: Maybe<Scalars['numeric']['output']>;
  voucher_discount?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "customer_order_item" */
export type Customer_Order_Item_Sum_Order_By = {
  actual_amount?: InputMaybe<Order_By>;
  actual_qty?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  delivery_fee?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  discount_rate?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
};

/** columns and relationships of "customer_order_item_test_category" */
export type Customer_Order_Item_Test_Category = {
  __typename?: 'customer_order_item_test_category';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  customer_order_item: Customer_Order_Item;
  customer_order_item_id: Scalars['uuid']['output'];
  /** An array relationship */
  customer_order_item_test_results: Array<Customer_Order_Item_Test_Results>;
  /** An aggregate relationship */
  customer_order_item_test_results_aggregate: Customer_Order_Item_Test_Results_Aggregate;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  is_customer_allowed_skipped: Scalars['Boolean']['output'];
  is_customer_approved: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  test_category: Test_Category;
  test_category_id: Scalars['uuid']['output'];
};


/** columns and relationships of "customer_order_item_test_category" */
export type Customer_Order_Item_Test_CategoryCustomer_Order_Item_Test_ResultsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Test_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Test_Results_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Test_Results_Bool_Exp>;
};


/** columns and relationships of "customer_order_item_test_category" */
export type Customer_Order_Item_Test_CategoryCustomer_Order_Item_Test_Results_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Test_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Test_Results_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Test_Results_Bool_Exp>;
};

/** aggregated selection of "customer_order_item_test_category" */
export type Customer_Order_Item_Test_Category_Aggregate = {
  __typename?: 'customer_order_item_test_category_aggregate';
  aggregate?: Maybe<Customer_Order_Item_Test_Category_Aggregate_Fields>;
  nodes: Array<Customer_Order_Item_Test_Category>;
};

export type Customer_Order_Item_Test_Category_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Customer_Order_Item_Test_Category_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Customer_Order_Item_Test_Category_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Customer_Order_Item_Test_Category_Aggregate_Bool_Exp_Count>;
};

export type Customer_Order_Item_Test_Category_Aggregate_Bool_Exp_Bool_And = {
  arguments: Customer_Order_Item_Test_Category_Select_Column_Customer_Order_Item_Test_Category_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Item_Test_Category_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customer_Order_Item_Test_Category_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Customer_Order_Item_Test_Category_Select_Column_Customer_Order_Item_Test_Category_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Item_Test_Category_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customer_Order_Item_Test_Category_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Customer_Order_Item_Test_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Item_Test_Category_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "customer_order_item_test_category" */
export type Customer_Order_Item_Test_Category_Aggregate_Fields = {
  __typename?: 'customer_order_item_test_category_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Customer_Order_Item_Test_Category_Max_Fields>;
  min?: Maybe<Customer_Order_Item_Test_Category_Min_Fields>;
};


/** aggregate fields of "customer_order_item_test_category" */
export type Customer_Order_Item_Test_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Order_Item_Test_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "customer_order_item_test_category" */
export type Customer_Order_Item_Test_Category_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Customer_Order_Item_Test_Category_Max_Order_By>;
  min?: InputMaybe<Customer_Order_Item_Test_Category_Min_Order_By>;
};

/** input type for inserting array relation for remote table "customer_order_item_test_category" */
export type Customer_Order_Item_Test_Category_Arr_Rel_Insert_Input = {
  data: Array<Customer_Order_Item_Test_Category_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Order_Item_Test_Category_On_Conflict>;
};

/** Boolean expression to filter rows from the table "customer_order_item_test_category". All fields are combined with a logical 'AND'. */
export type Customer_Order_Item_Test_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Order_Item_Test_Category_Bool_Exp>>;
  _not?: InputMaybe<Customer_Order_Item_Test_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Order_Item_Test_Category_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_order_item?: InputMaybe<Customer_Order_Item_Bool_Exp>;
  customer_order_item_id?: InputMaybe<Uuid_Comparison_Exp>;
  customer_order_item_test_results?: InputMaybe<Customer_Order_Item_Test_Results_Bool_Exp>;
  customer_order_item_test_results_aggregate?: InputMaybe<Customer_Order_Item_Test_Results_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_customer_allowed_skipped?: InputMaybe<Boolean_Comparison_Exp>;
  is_customer_approved?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  test_category?: InputMaybe<Test_Category_Bool_Exp>;
  test_category_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "customer_order_item_test_category" */
export enum Customer_Order_Item_Test_Category_Constraint {
  /** unique or primary key constraint on columns "id" */
  CustomerOrderItemTestCategoryPkey = 'customer_order_item_test_category_pkey'
}

/** input type for inserting data into table "customer_order_item_test_category" */
export type Customer_Order_Item_Test_Category_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_item?: InputMaybe<Customer_Order_Item_Obj_Rel_Insert_Input>;
  customer_order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  customer_order_item_test_results?: InputMaybe<Customer_Order_Item_Test_Results_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_customer_allowed_skipped?: InputMaybe<Scalars['Boolean']['input']>;
  is_customer_approved?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  test_category?: InputMaybe<Test_Category_Obj_Rel_Insert_Input>;
  test_category_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Customer_Order_Item_Test_Category_Max_Fields = {
  __typename?: 'customer_order_item_test_category_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_order_item_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  test_category_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "customer_order_item_test_category" */
export type Customer_Order_Item_Test_Category_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_order_item_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  test_category_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Customer_Order_Item_Test_Category_Min_Fields = {
  __typename?: 'customer_order_item_test_category_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_order_item_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  test_category_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "customer_order_item_test_category" */
export type Customer_Order_Item_Test_Category_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_order_item_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  test_category_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "customer_order_item_test_category" */
export type Customer_Order_Item_Test_Category_Mutation_Response = {
  __typename?: 'customer_order_item_test_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Customer_Order_Item_Test_Category>;
};

/** input type for inserting object relation for remote table "customer_order_item_test_category" */
export type Customer_Order_Item_Test_Category_Obj_Rel_Insert_Input = {
  data: Customer_Order_Item_Test_Category_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Order_Item_Test_Category_On_Conflict>;
};

/** on_conflict condition type for table "customer_order_item_test_category" */
export type Customer_Order_Item_Test_Category_On_Conflict = {
  constraint: Customer_Order_Item_Test_Category_Constraint;
  update_columns?: Array<Customer_Order_Item_Test_Category_Update_Column>;
  where?: InputMaybe<Customer_Order_Item_Test_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "customer_order_item_test_category". */
export type Customer_Order_Item_Test_Category_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_order_item?: InputMaybe<Customer_Order_Item_Order_By>;
  customer_order_item_id?: InputMaybe<Order_By>;
  customer_order_item_test_results_aggregate?: InputMaybe<Customer_Order_Item_Test_Results_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_customer_allowed_skipped?: InputMaybe<Order_By>;
  is_customer_approved?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  test_category?: InputMaybe<Test_Category_Order_By>;
  test_category_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: customer_order_item_test_category */
export type Customer_Order_Item_Test_Category_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "customer_order_item_test_category" */
export enum Customer_Order_Item_Test_Category_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerOrderItemId = 'customer_order_item_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsCustomerAllowedSkipped = 'is_customer_allowed_skipped',
  /** column name */
  IsCustomerApproved = 'is_customer_approved',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  TestCategoryId = 'test_category_id'
}

/** select "customer_order_item_test_category_aggregate_bool_exp_bool_and_arguments_columns" columns of table "customer_order_item_test_category" */
export enum Customer_Order_Item_Test_Category_Select_Column_Customer_Order_Item_Test_Category_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsCustomerAllowedSkipped = 'is_customer_allowed_skipped',
  /** column name */
  IsCustomerApproved = 'is_customer_approved'
}

/** select "customer_order_item_test_category_aggregate_bool_exp_bool_or_arguments_columns" columns of table "customer_order_item_test_category" */
export enum Customer_Order_Item_Test_Category_Select_Column_Customer_Order_Item_Test_Category_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsCustomerAllowedSkipped = 'is_customer_allowed_skipped',
  /** column name */
  IsCustomerApproved = 'is_customer_approved'
}

/** input type for updating data in table "customer_order_item_test_category" */
export type Customer_Order_Item_Test_Category_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_customer_allowed_skipped?: InputMaybe<Scalars['Boolean']['input']>;
  is_customer_approved?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  test_category_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "customer_order_item_test_category" */
export type Customer_Order_Item_Test_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Order_Item_Test_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customer_Order_Item_Test_Category_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_customer_allowed_skipped?: InputMaybe<Scalars['Boolean']['input']>;
  is_customer_approved?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  test_category_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "customer_order_item_test_category" */
export enum Customer_Order_Item_Test_Category_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerOrderItemId = 'customer_order_item_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsCustomerAllowedSkipped = 'is_customer_allowed_skipped',
  /** column name */
  IsCustomerApproved = 'is_customer_approved',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  TestCategoryId = 'test_category_id'
}

export type Customer_Order_Item_Test_Category_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Order_Item_Test_Category_Set_Input>;
  /** filter the rows which have to be updated */
  where: Customer_Order_Item_Test_Category_Bool_Exp;
};

/** columns and relationships of "customer_order_item_test_results" */
export type Customer_Order_Item_Test_Results = {
  __typename?: 'customer_order_item_test_results';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  customer_order_item_test_category?: Maybe<Customer_Order_Item_Test_Category>;
  customer_order_item_test_category_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  customer_order_item_test_results_photos: Array<Customer_Order_Item_Test_Results_Photos>;
  /** An aggregate relationship */
  customer_order_item_test_results_photos_aggregate: Customer_Order_Item_Test_Results_Photos_Aggregate;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  is_passed?: Maybe<Scalars['Boolean']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  test: Test;
  test_id: Scalars['uuid']['output'];
  value?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "customer_order_item_test_results" */
export type Customer_Order_Item_Test_ResultsCustomer_Order_Item_Test_Results_PhotosArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Test_Results_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Test_Results_Photos_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Test_Results_Photos_Bool_Exp>;
};


/** columns and relationships of "customer_order_item_test_results" */
export type Customer_Order_Item_Test_ResultsCustomer_Order_Item_Test_Results_Photos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Test_Results_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Test_Results_Photos_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Test_Results_Photos_Bool_Exp>;
};

/** aggregated selection of "customer_order_item_test_results" */
export type Customer_Order_Item_Test_Results_Aggregate = {
  __typename?: 'customer_order_item_test_results_aggregate';
  aggregate?: Maybe<Customer_Order_Item_Test_Results_Aggregate_Fields>;
  nodes: Array<Customer_Order_Item_Test_Results>;
};

export type Customer_Order_Item_Test_Results_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Customer_Order_Item_Test_Results_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Customer_Order_Item_Test_Results_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Customer_Order_Item_Test_Results_Aggregate_Bool_Exp_Count>;
};

export type Customer_Order_Item_Test_Results_Aggregate_Bool_Exp_Bool_And = {
  arguments: Customer_Order_Item_Test_Results_Select_Column_Customer_Order_Item_Test_Results_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Item_Test_Results_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customer_Order_Item_Test_Results_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Customer_Order_Item_Test_Results_Select_Column_Customer_Order_Item_Test_Results_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Item_Test_Results_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customer_Order_Item_Test_Results_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Customer_Order_Item_Test_Results_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Item_Test_Results_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "customer_order_item_test_results" */
export type Customer_Order_Item_Test_Results_Aggregate_Fields = {
  __typename?: 'customer_order_item_test_results_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Customer_Order_Item_Test_Results_Max_Fields>;
  min?: Maybe<Customer_Order_Item_Test_Results_Min_Fields>;
};


/** aggregate fields of "customer_order_item_test_results" */
export type Customer_Order_Item_Test_Results_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Order_Item_Test_Results_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "customer_order_item_test_results" */
export type Customer_Order_Item_Test_Results_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Customer_Order_Item_Test_Results_Max_Order_By>;
  min?: InputMaybe<Customer_Order_Item_Test_Results_Min_Order_By>;
};

/** input type for inserting array relation for remote table "customer_order_item_test_results" */
export type Customer_Order_Item_Test_Results_Arr_Rel_Insert_Input = {
  data: Array<Customer_Order_Item_Test_Results_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Order_Item_Test_Results_On_Conflict>;
};

/** Boolean expression to filter rows from the table "customer_order_item_test_results". All fields are combined with a logical 'AND'. */
export type Customer_Order_Item_Test_Results_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Order_Item_Test_Results_Bool_Exp>>;
  _not?: InputMaybe<Customer_Order_Item_Test_Results_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Order_Item_Test_Results_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_order_item_test_category?: InputMaybe<Customer_Order_Item_Test_Category_Bool_Exp>;
  customer_order_item_test_category_id?: InputMaybe<Uuid_Comparison_Exp>;
  customer_order_item_test_results_photos?: InputMaybe<Customer_Order_Item_Test_Results_Photos_Bool_Exp>;
  customer_order_item_test_results_photos_aggregate?: InputMaybe<Customer_Order_Item_Test_Results_Photos_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_passed?: InputMaybe<Boolean_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  test?: InputMaybe<Test_Bool_Exp>;
  test_id?: InputMaybe<Uuid_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "customer_order_item_test_results" */
export enum Customer_Order_Item_Test_Results_Constraint {
  /** unique or primary key constraint on columns "id" */
  CustomerOrderItemTestResultsPkey = 'customer_order_item_test_results_pkey'
}

/** input type for inserting data into table "customer_order_item_test_results" */
export type Customer_Order_Item_Test_Results_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_item_test_category?: InputMaybe<Customer_Order_Item_Test_Category_Obj_Rel_Insert_Input>;
  customer_order_item_test_category_id?: InputMaybe<Scalars['uuid']['input']>;
  customer_order_item_test_results_photos?: InputMaybe<Customer_Order_Item_Test_Results_Photos_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_passed?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  test?: InputMaybe<Test_Obj_Rel_Insert_Input>;
  test_id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Customer_Order_Item_Test_Results_Max_Fields = {
  __typename?: 'customer_order_item_test_results_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_order_item_test_category_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  test_id?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "customer_order_item_test_results" */
export type Customer_Order_Item_Test_Results_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_order_item_test_category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  test_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Customer_Order_Item_Test_Results_Min_Fields = {
  __typename?: 'customer_order_item_test_results_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_order_item_test_category_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  test_id?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "customer_order_item_test_results" */
export type Customer_Order_Item_Test_Results_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_order_item_test_category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  test_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "customer_order_item_test_results" */
export type Customer_Order_Item_Test_Results_Mutation_Response = {
  __typename?: 'customer_order_item_test_results_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Customer_Order_Item_Test_Results>;
};

/** input type for inserting object relation for remote table "customer_order_item_test_results" */
export type Customer_Order_Item_Test_Results_Obj_Rel_Insert_Input = {
  data: Customer_Order_Item_Test_Results_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Order_Item_Test_Results_On_Conflict>;
};

/** on_conflict condition type for table "customer_order_item_test_results" */
export type Customer_Order_Item_Test_Results_On_Conflict = {
  constraint: Customer_Order_Item_Test_Results_Constraint;
  update_columns?: Array<Customer_Order_Item_Test_Results_Update_Column>;
  where?: InputMaybe<Customer_Order_Item_Test_Results_Bool_Exp>;
};

/** Ordering options when selecting data from "customer_order_item_test_results". */
export type Customer_Order_Item_Test_Results_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_order_item_test_category?: InputMaybe<Customer_Order_Item_Test_Category_Order_By>;
  customer_order_item_test_category_id?: InputMaybe<Order_By>;
  customer_order_item_test_results_photos_aggregate?: InputMaybe<Customer_Order_Item_Test_Results_Photos_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_passed?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  test?: InputMaybe<Test_Order_By>;
  test_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** columns and relationships of "customer_order_item_test_results_photos" */
export type Customer_Order_Item_Test_Results_Photos = {
  __typename?: 'customer_order_item_test_results_photos';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  customer_order_item_test_result: Customer_Order_Item_Test_Results;
  customer_order_item_test_results_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "customer_order_item_test_results_photos" */
export type Customer_Order_Item_Test_Results_Photos_Aggregate = {
  __typename?: 'customer_order_item_test_results_photos_aggregate';
  aggregate?: Maybe<Customer_Order_Item_Test_Results_Photos_Aggregate_Fields>;
  nodes: Array<Customer_Order_Item_Test_Results_Photos>;
};

export type Customer_Order_Item_Test_Results_Photos_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Customer_Order_Item_Test_Results_Photos_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Customer_Order_Item_Test_Results_Photos_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Customer_Order_Item_Test_Results_Photos_Aggregate_Bool_Exp_Count>;
};

export type Customer_Order_Item_Test_Results_Photos_Aggregate_Bool_Exp_Bool_And = {
  arguments: Customer_Order_Item_Test_Results_Photos_Select_Column_Customer_Order_Item_Test_Results_Photos_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Item_Test_Results_Photos_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customer_Order_Item_Test_Results_Photos_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Customer_Order_Item_Test_Results_Photos_Select_Column_Customer_Order_Item_Test_Results_Photos_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Item_Test_Results_Photos_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customer_Order_Item_Test_Results_Photos_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Customer_Order_Item_Test_Results_Photos_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Item_Test_Results_Photos_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "customer_order_item_test_results_photos" */
export type Customer_Order_Item_Test_Results_Photos_Aggregate_Fields = {
  __typename?: 'customer_order_item_test_results_photos_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Customer_Order_Item_Test_Results_Photos_Max_Fields>;
  min?: Maybe<Customer_Order_Item_Test_Results_Photos_Min_Fields>;
};


/** aggregate fields of "customer_order_item_test_results_photos" */
export type Customer_Order_Item_Test_Results_Photos_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Order_Item_Test_Results_Photos_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "customer_order_item_test_results_photos" */
export type Customer_Order_Item_Test_Results_Photos_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Customer_Order_Item_Test_Results_Photos_Max_Order_By>;
  min?: InputMaybe<Customer_Order_Item_Test_Results_Photos_Min_Order_By>;
};

/** input type for inserting array relation for remote table "customer_order_item_test_results_photos" */
export type Customer_Order_Item_Test_Results_Photos_Arr_Rel_Insert_Input = {
  data: Array<Customer_Order_Item_Test_Results_Photos_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Order_Item_Test_Results_Photos_On_Conflict>;
};

/** Boolean expression to filter rows from the table "customer_order_item_test_results_photos". All fields are combined with a logical 'AND'. */
export type Customer_Order_Item_Test_Results_Photos_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Order_Item_Test_Results_Photos_Bool_Exp>>;
  _not?: InputMaybe<Customer_Order_Item_Test_Results_Photos_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Order_Item_Test_Results_Photos_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_order_item_test_result?: InputMaybe<Customer_Order_Item_Test_Results_Bool_Exp>;
  customer_order_item_test_results_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "customer_order_item_test_results_photos" */
export enum Customer_Order_Item_Test_Results_Photos_Constraint {
  /** unique or primary key constraint on columns "id" */
  CustomerOrderItemTestResultsPhotosPkey = 'customer_order_item_test_results_photos_pkey'
}

/** input type for inserting data into table "customer_order_item_test_results_photos" */
export type Customer_Order_Item_Test_Results_Photos_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_item_test_result?: InputMaybe<Customer_Order_Item_Test_Results_Obj_Rel_Insert_Input>;
  customer_order_item_test_results_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Customer_Order_Item_Test_Results_Photos_Max_Fields = {
  __typename?: 'customer_order_item_test_results_photos_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_order_item_test_results_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "customer_order_item_test_results_photos" */
export type Customer_Order_Item_Test_Results_Photos_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_order_item_test_results_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Customer_Order_Item_Test_Results_Photos_Min_Fields = {
  __typename?: 'customer_order_item_test_results_photos_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_order_item_test_results_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "customer_order_item_test_results_photos" */
export type Customer_Order_Item_Test_Results_Photos_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_order_item_test_results_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "customer_order_item_test_results_photos" */
export type Customer_Order_Item_Test_Results_Photos_Mutation_Response = {
  __typename?: 'customer_order_item_test_results_photos_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Customer_Order_Item_Test_Results_Photos>;
};

/** on_conflict condition type for table "customer_order_item_test_results_photos" */
export type Customer_Order_Item_Test_Results_Photos_On_Conflict = {
  constraint: Customer_Order_Item_Test_Results_Photos_Constraint;
  update_columns?: Array<Customer_Order_Item_Test_Results_Photos_Update_Column>;
  where?: InputMaybe<Customer_Order_Item_Test_Results_Photos_Bool_Exp>;
};

/** Ordering options when selecting data from "customer_order_item_test_results_photos". */
export type Customer_Order_Item_Test_Results_Photos_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_order_item_test_result?: InputMaybe<Customer_Order_Item_Test_Results_Order_By>;
  customer_order_item_test_results_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: customer_order_item_test_results_photos */
export type Customer_Order_Item_Test_Results_Photos_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "customer_order_item_test_results_photos" */
export enum Customer_Order_Item_Test_Results_Photos_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerOrderItemTestResultsId = 'customer_order_item_test_results_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Url = 'url'
}

/** select "customer_order_item_test_results_photos_aggregate_bool_exp_bool_and_arguments_columns" columns of table "customer_order_item_test_results_photos" */
export enum Customer_Order_Item_Test_Results_Photos_Select_Column_Customer_Order_Item_Test_Results_Photos_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "customer_order_item_test_results_photos_aggregate_bool_exp_bool_or_arguments_columns" columns of table "customer_order_item_test_results_photos" */
export enum Customer_Order_Item_Test_Results_Photos_Select_Column_Customer_Order_Item_Test_Results_Photos_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "customer_order_item_test_results_photos" */
export type Customer_Order_Item_Test_Results_Photos_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_item_test_results_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "customer_order_item_test_results_photos" */
export type Customer_Order_Item_Test_Results_Photos_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Order_Item_Test_Results_Photos_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customer_Order_Item_Test_Results_Photos_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_item_test_results_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "customer_order_item_test_results_photos" */
export enum Customer_Order_Item_Test_Results_Photos_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerOrderItemTestResultsId = 'customer_order_item_test_results_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Url = 'url'
}

export type Customer_Order_Item_Test_Results_Photos_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Order_Item_Test_Results_Photos_Set_Input>;
  /** filter the rows which have to be updated */
  where: Customer_Order_Item_Test_Results_Photos_Bool_Exp;
};

/** primary key columns input for table: customer_order_item_test_results */
export type Customer_Order_Item_Test_Results_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "customer_order_item_test_results" */
export enum Customer_Order_Item_Test_Results_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerOrderItemTestCategoryId = 'customer_order_item_test_category_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsPassed = 'is_passed',
  /** column name */
  Key = 'key',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  TestId = 'test_id',
  /** column name */
  Value = 'value'
}

/** select "customer_order_item_test_results_aggregate_bool_exp_bool_and_arguments_columns" columns of table "customer_order_item_test_results" */
export enum Customer_Order_Item_Test_Results_Select_Column_Customer_Order_Item_Test_Results_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsPassed = 'is_passed'
}

/** select "customer_order_item_test_results_aggregate_bool_exp_bool_or_arguments_columns" columns of table "customer_order_item_test_results" */
export enum Customer_Order_Item_Test_Results_Select_Column_Customer_Order_Item_Test_Results_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsPassed = 'is_passed'
}

/** input type for updating data in table "customer_order_item_test_results" */
export type Customer_Order_Item_Test_Results_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_item_test_category_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_passed?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  test_id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "customer_order_item_test_results" */
export type Customer_Order_Item_Test_Results_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Order_Item_Test_Results_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customer_Order_Item_Test_Results_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_item_test_category_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_passed?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  test_id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "customer_order_item_test_results" */
export enum Customer_Order_Item_Test_Results_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerOrderItemTestCategoryId = 'customer_order_item_test_category_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsPassed = 'is_passed',
  /** column name */
  Key = 'key',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  TestId = 'test_id',
  /** column name */
  Value = 'value'
}

export type Customer_Order_Item_Test_Results_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Order_Item_Test_Results_Set_Input>;
  /** filter the rows which have to be updated */
  where: Customer_Order_Item_Test_Results_Bool_Exp;
};

/** update columns of table "customer_order_item" */
export enum Customer_Order_Item_Update_Column {
  /** column name */
  ActualAmount = 'actual_amount',
  /** column name */
  ActualDeliveryDate = 'actual_delivery_date',
  /** column name */
  ActualQty = 'actual_qty',
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerOrderSlotsId = 'customer_order_slots_id',
  /** column name */
  DeliveryFee = 'delivery_fee',
  /** column name */
  DiscountAmount = 'discount_amount',
  /** column name */
  DiscountRate = 'discount_rate',
  /** column name */
  DiscountType = 'discount_type',
  /** column name */
  EstimateDeliveryDate = 'estimate_delivery_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsB2b = 'is_b2b',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  ProductVariationId = 'product_variation_id',
  /** column name */
  ProductVariationPartnerLocalitiesSlotId = 'product_variation_partner_localities_slot_id',
  /** column name */
  Qty = 'qty',
  /** column name */
  ServiceTax = 'service_tax',
  /** column name */
  State = 'state',
  /** column name */
  TaskId = 'task_id',
  /** column name */
  Tax = 'tax',
  /** column name */
  Unit = 'unit',
  /** column name */
  UnitPrice = 'unit_price',
  /** column name */
  VoucherDiscount = 'voucher_discount'
}

export type Customer_Order_Item_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Customer_Order_Item_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Order_Item_Set_Input>;
  /** filter the rows which have to be updated */
  where: Customer_Order_Item_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Customer_Order_Item_Var_Pop_Fields = {
  __typename?: 'customer_order_item_var_pop_fields';
  actual_amount?: Maybe<Scalars['Float']['output']>;
  actual_qty?: Maybe<Scalars['Float']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  delivery_fee?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  discount_rate?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  service_tax?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  unit_price?: Maybe<Scalars['Float']['output']>;
  voucher_discount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "customer_order_item" */
export type Customer_Order_Item_Var_Pop_Order_By = {
  actual_amount?: InputMaybe<Order_By>;
  actual_qty?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  delivery_fee?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  discount_rate?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Customer_Order_Item_Var_Samp_Fields = {
  __typename?: 'customer_order_item_var_samp_fields';
  actual_amount?: Maybe<Scalars['Float']['output']>;
  actual_qty?: Maybe<Scalars['Float']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  delivery_fee?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  discount_rate?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  service_tax?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  unit_price?: Maybe<Scalars['Float']['output']>;
  voucher_discount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "customer_order_item" */
export type Customer_Order_Item_Var_Samp_Order_By = {
  actual_amount?: InputMaybe<Order_By>;
  actual_qty?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  delivery_fee?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  discount_rate?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Customer_Order_Item_Variance_Fields = {
  __typename?: 'customer_order_item_variance_fields';
  actual_amount?: Maybe<Scalars['Float']['output']>;
  actual_qty?: Maybe<Scalars['Float']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  delivery_fee?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  discount_rate?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  service_tax?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  unit_price?: Maybe<Scalars['Float']['output']>;
  voucher_discount?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "customer_order_item" */
export type Customer_Order_Item_Variance_Order_By = {
  actual_amount?: InputMaybe<Order_By>;
  actual_qty?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  delivery_fee?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  discount_rate?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Customer_Order_Max_Fields = {
  __typename?: 'customer_order_max_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  amount_paid?: Maybe<Scalars['numeric']['output']>;
  amount_to_be_paid?: Maybe<Scalars['numeric']['output']>;
  billing_address_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  customer_order_slots_id?: Maybe<Scalars['uuid']['output']>;
  delivery_fee?: Maybe<Scalars['numeric']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount_amount?: Maybe<Scalars['numeric']['output']>;
  fueltrans_order_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  instruction?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order_code?: Maybe<Scalars['bigint']['output']>;
  order_date?: Maybe<Scalars['timestamptz']['output']>;
  organization_user_id?: Maybe<Scalars['uuid']['output']>;
  otp?: Maybe<Scalars['Int']['output']>;
  partner_localities_slot_id?: Maybe<Scalars['uuid']['output']>;
  product_variation_partner_localities_slot_id?: Maybe<Scalars['uuid']['output']>;
  service_tax?: Maybe<Scalars['numeric']['output']>;
  shipping_address_id?: Maybe<Scalars['uuid']['output']>;
  tax?: Maybe<Scalars['numeric']['output']>;
  voucher_discount?: Maybe<Scalars['numeric']['output']>;
  voucher_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "customer_order" */
export type Customer_Order_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_to_be_paid?: InputMaybe<Order_By>;
  billing_address_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  customer_order_slots_id?: InputMaybe<Order_By>;
  delivery_fee?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  fueltrans_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instruction?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order_code?: InputMaybe<Order_By>;
  order_date?: InputMaybe<Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
  otp?: InputMaybe<Order_By>;
  partner_localities_slot_id?: InputMaybe<Order_By>;
  product_variation_partner_localities_slot_id?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  shipping_address_id?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
  voucher_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Customer_Order_Min_Fields = {
  __typename?: 'customer_order_min_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  amount_paid?: Maybe<Scalars['numeric']['output']>;
  amount_to_be_paid?: Maybe<Scalars['numeric']['output']>;
  billing_address_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  customer_order_slots_id?: Maybe<Scalars['uuid']['output']>;
  delivery_fee?: Maybe<Scalars['numeric']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount_amount?: Maybe<Scalars['numeric']['output']>;
  fueltrans_order_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  instruction?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order_code?: Maybe<Scalars['bigint']['output']>;
  order_date?: Maybe<Scalars['timestamptz']['output']>;
  organization_user_id?: Maybe<Scalars['uuid']['output']>;
  otp?: Maybe<Scalars['Int']['output']>;
  partner_localities_slot_id?: Maybe<Scalars['uuid']['output']>;
  product_variation_partner_localities_slot_id?: Maybe<Scalars['uuid']['output']>;
  service_tax?: Maybe<Scalars['numeric']['output']>;
  shipping_address_id?: Maybe<Scalars['uuid']['output']>;
  tax?: Maybe<Scalars['numeric']['output']>;
  voucher_discount?: Maybe<Scalars['numeric']['output']>;
  voucher_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "customer_order" */
export type Customer_Order_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_to_be_paid?: InputMaybe<Order_By>;
  billing_address_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  customer_order_slots_id?: InputMaybe<Order_By>;
  delivery_fee?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  fueltrans_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instruction?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order_code?: InputMaybe<Order_By>;
  order_date?: InputMaybe<Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
  otp?: InputMaybe<Order_By>;
  partner_localities_slot_id?: InputMaybe<Order_By>;
  product_variation_partner_localities_slot_id?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  shipping_address_id?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
  voucher_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "customer_order" */
export type Customer_Order_Mutation_Response = {
  __typename?: 'customer_order_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Customer_Order>;
};

/** input type for inserting object relation for remote table "customer_order" */
export type Customer_Order_Obj_Rel_Insert_Input = {
  data: Customer_Order_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Order_On_Conflict>;
};

/** on_conflict condition type for table "customer_order" */
export type Customer_Order_On_Conflict = {
  constraint: Customer_Order_Constraint;
  update_columns?: Array<Customer_Order_Update_Column>;
  where?: InputMaybe<Customer_Order_Bool_Exp>;
};

/** Ordering options when selecting data from "customer_order". */
export type Customer_Order_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_to_be_paid?: InputMaybe<Order_By>;
  billing_address_id?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  customer_order_cancellation_reasons_aggregate?: InputMaybe<Customer_Order_Cancellation_Reasons_Aggregate_Order_By>;
  customer_order_customer_assets_aggregate?: InputMaybe<Customer_Order_Customer_Asset_Aggregate_Order_By>;
  customer_order_items_aggregate?: InputMaybe<Customer_Order_Item_Aggregate_Order_By>;
  customer_order_organization_user_documents_aggregate?: InputMaybe<Customer_Order_Organization_User_Document_Aggregate_Order_By>;
  customer_order_partner_orders_aggregate?: InputMaybe<Customer_Order_Partner_Order_Aggregate_Order_By>;
  customer_order_slot?: InputMaybe<Customer_Order_Slots_Order_By>;
  customer_order_slots_id?: InputMaybe<Order_By>;
  customer_order_state?: InputMaybe<Customer_Order_State_Order_By>;
  customer_order_stateflows_aggregate?: InputMaybe<Customer_Order_Stateflow_Aggregate_Order_By>;
  customer_payments_aggregate?: InputMaybe<Customer_Payment_Aggregate_Order_By>;
  deliveryPreferenceByDeliveryPreference?: InputMaybe<Delivery_Preferences_Order_By>;
  delivery_fee?: InputMaybe<Order_By>;
  delivery_preference?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  fueltrans_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instruction?: InputMaybe<Order_By>;
  inventories_aggregate?: InputMaybe<Inventory_Aggregate_Order_By>;
  invoice?: InputMaybe<Invoice_Order_By>;
  invoices_aggregate?: InputMaybe<Invoice_Aggregate_Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_b2b?: InputMaybe<Order_By>;
  is_otp_required?: InputMaybe<Order_By>;
  is_prepaid?: InputMaybe<Order_By>;
  is_receipt_required?: InputMaybe<Order_By>;
  is_test_enabled?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order_code?: InputMaybe<Order_By>;
  order_date?: InputMaybe<Order_By>;
  order_photos_aggregate?: InputMaybe<Order_Photos_Aggregate_Order_By>;
  order_type?: InputMaybe<Order_Type_Order_By>;
  organizationAddressByShippingAddressId?: InputMaybe<Organization_Address_Order_By>;
  organization_address?: InputMaybe<Organization_Address_Order_By>;
  organization_user?: InputMaybe<Organization_User_Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
  otp?: InputMaybe<Order_By>;
  partner_localities_slot?: InputMaybe<Partner_Localities_Slots_Order_By>;
  partner_localities_slot_id?: InputMaybe<Order_By>;
  partner_payments_aggregate?: InputMaybe<Partner_Payment_Aggregate_Order_By>;
  product_variation_partner_localities_slot?: InputMaybe<Product_Variation_Partner_Localities_Slots_Order_By>;
  product_variation_partner_localities_slot_id?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  shipping_address_id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  tasks_aggregate?: InputMaybe<Task_Aggregate_Order_By>;
  tax?: InputMaybe<Order_By>;
  tickets_aggregate?: InputMaybe<Tickets_Aggregate_Order_By>;
  vehicle_inventory_transaction_logs_aggregate?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Aggregate_Order_By>;
  voucher?: InputMaybe<Voucher_Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
  voucher_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "customer_order_organization_user_document" */
export type Customer_Order_Organization_User_Document = {
  __typename?: 'customer_order_organization_user_document';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  customer_order: Customer_Order;
  customer_order_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  organization_user_document: Organization_User_Document;
  organization_user_document_id: Scalars['uuid']['output'];
};

/** aggregated selection of "customer_order_organization_user_document" */
export type Customer_Order_Organization_User_Document_Aggregate = {
  __typename?: 'customer_order_organization_user_document_aggregate';
  aggregate?: Maybe<Customer_Order_Organization_User_Document_Aggregate_Fields>;
  nodes: Array<Customer_Order_Organization_User_Document>;
};

export type Customer_Order_Organization_User_Document_Aggregate_Bool_Exp = {
  count?: InputMaybe<Customer_Order_Organization_User_Document_Aggregate_Bool_Exp_Count>;
};

export type Customer_Order_Organization_User_Document_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Customer_Order_Organization_User_Document_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Organization_User_Document_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "customer_order_organization_user_document" */
export type Customer_Order_Organization_User_Document_Aggregate_Fields = {
  __typename?: 'customer_order_organization_user_document_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Customer_Order_Organization_User_Document_Max_Fields>;
  min?: Maybe<Customer_Order_Organization_User_Document_Min_Fields>;
};


/** aggregate fields of "customer_order_organization_user_document" */
export type Customer_Order_Organization_User_Document_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Order_Organization_User_Document_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "customer_order_organization_user_document" */
export type Customer_Order_Organization_User_Document_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Customer_Order_Organization_User_Document_Max_Order_By>;
  min?: InputMaybe<Customer_Order_Organization_User_Document_Min_Order_By>;
};

/** input type for inserting array relation for remote table "customer_order_organization_user_document" */
export type Customer_Order_Organization_User_Document_Arr_Rel_Insert_Input = {
  data: Array<Customer_Order_Organization_User_Document_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Order_Organization_User_Document_On_Conflict>;
};

/** Boolean expression to filter rows from the table "customer_order_organization_user_document". All fields are combined with a logical 'AND'. */
export type Customer_Order_Organization_User_Document_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Order_Organization_User_Document_Bool_Exp>>;
  _not?: InputMaybe<Customer_Order_Organization_User_Document_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Order_Organization_User_Document_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_order?: InputMaybe<Customer_Order_Bool_Exp>;
  customer_order_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  organization_user_document?: InputMaybe<Organization_User_Document_Bool_Exp>;
  organization_user_document_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "customer_order_organization_user_document" */
export enum Customer_Order_Organization_User_Document_Constraint {
  /** unique or primary key constraint on columns "id" */
  CustomerOrderOrganizationUserDocumentPkey = 'customer_order_organization_user_document_pkey'
}

/** input type for inserting data into table "customer_order_organization_user_document" */
export type Customer_Order_Organization_User_Document_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order?: InputMaybe<Customer_Order_Obj_Rel_Insert_Input>;
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_user_document?: InputMaybe<Organization_User_Document_Obj_Rel_Insert_Input>;
  organization_user_document_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Customer_Order_Organization_User_Document_Max_Fields = {
  __typename?: 'customer_order_organization_user_document_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_order_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  organization_user_document_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "customer_order_organization_user_document" */
export type Customer_Order_Organization_User_Document_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_user_document_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Customer_Order_Organization_User_Document_Min_Fields = {
  __typename?: 'customer_order_organization_user_document_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_order_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  organization_user_document_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "customer_order_organization_user_document" */
export type Customer_Order_Organization_User_Document_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_user_document_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "customer_order_organization_user_document" */
export type Customer_Order_Organization_User_Document_Mutation_Response = {
  __typename?: 'customer_order_organization_user_document_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Customer_Order_Organization_User_Document>;
};

/** on_conflict condition type for table "customer_order_organization_user_document" */
export type Customer_Order_Organization_User_Document_On_Conflict = {
  constraint: Customer_Order_Organization_User_Document_Constraint;
  update_columns?: Array<Customer_Order_Organization_User_Document_Update_Column>;
  where?: InputMaybe<Customer_Order_Organization_User_Document_Bool_Exp>;
};

/** Ordering options when selecting data from "customer_order_organization_user_document". */
export type Customer_Order_Organization_User_Document_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_order?: InputMaybe<Customer_Order_Order_By>;
  customer_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_user_document?: InputMaybe<Organization_User_Document_Order_By>;
  organization_user_document_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: customer_order_organization_user_document */
export type Customer_Order_Organization_User_Document_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "customer_order_organization_user_document" */
export enum Customer_Order_Organization_User_Document_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerOrderId = 'customer_order_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrganizationUserDocumentId = 'organization_user_document_id'
}

/** input type for updating data in table "customer_order_organization_user_document" */
export type Customer_Order_Organization_User_Document_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_user_document_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "customer_order_organization_user_document" */
export type Customer_Order_Organization_User_Document_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Order_Organization_User_Document_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customer_Order_Organization_User_Document_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_user_document_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "customer_order_organization_user_document" */
export enum Customer_Order_Organization_User_Document_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerOrderId = 'customer_order_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrganizationUserDocumentId = 'organization_user_document_id'
}

export type Customer_Order_Organization_User_Document_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Order_Organization_User_Document_Set_Input>;
  /** filter the rows which have to be updated */
  where: Customer_Order_Organization_User_Document_Bool_Exp;
};

/** columns and relationships of "customer_order_partner_order" */
export type Customer_Order_Partner_Order = {
  __typename?: 'customer_order_partner_order';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  customer_order: Customer_Order;
  customer_order_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  partner_order_item: Partner_Order_Item;
  partner_order_item_id: Scalars['uuid']['output'];
};

/** aggregated selection of "customer_order_partner_order" */
export type Customer_Order_Partner_Order_Aggregate = {
  __typename?: 'customer_order_partner_order_aggregate';
  aggregate?: Maybe<Customer_Order_Partner_Order_Aggregate_Fields>;
  nodes: Array<Customer_Order_Partner_Order>;
};

export type Customer_Order_Partner_Order_Aggregate_Bool_Exp = {
  count?: InputMaybe<Customer_Order_Partner_Order_Aggregate_Bool_Exp_Count>;
};

export type Customer_Order_Partner_Order_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Customer_Order_Partner_Order_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Partner_Order_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "customer_order_partner_order" */
export type Customer_Order_Partner_Order_Aggregate_Fields = {
  __typename?: 'customer_order_partner_order_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Customer_Order_Partner_Order_Max_Fields>;
  min?: Maybe<Customer_Order_Partner_Order_Min_Fields>;
};


/** aggregate fields of "customer_order_partner_order" */
export type Customer_Order_Partner_Order_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Order_Partner_Order_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "customer_order_partner_order" */
export type Customer_Order_Partner_Order_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Customer_Order_Partner_Order_Max_Order_By>;
  min?: InputMaybe<Customer_Order_Partner_Order_Min_Order_By>;
};

/** input type for inserting array relation for remote table "customer_order_partner_order" */
export type Customer_Order_Partner_Order_Arr_Rel_Insert_Input = {
  data: Array<Customer_Order_Partner_Order_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Order_Partner_Order_On_Conflict>;
};

/** Boolean expression to filter rows from the table "customer_order_partner_order". All fields are combined with a logical 'AND'. */
export type Customer_Order_Partner_Order_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Order_Partner_Order_Bool_Exp>>;
  _not?: InputMaybe<Customer_Order_Partner_Order_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Order_Partner_Order_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_order?: InputMaybe<Customer_Order_Bool_Exp>;
  customer_order_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  partner_order_item?: InputMaybe<Partner_Order_Item_Bool_Exp>;
  partner_order_item_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "customer_order_partner_order" */
export enum Customer_Order_Partner_Order_Constraint {
  /** unique or primary key constraint on columns "id" */
  CustomerOrderPartnerOrderPkey = 'customer_order_partner_order_pkey'
}

/** input type for inserting data into table "customer_order_partner_order" */
export type Customer_Order_Partner_Order_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order?: InputMaybe<Customer_Order_Obj_Rel_Insert_Input>;
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_order_item?: InputMaybe<Partner_Order_Item_Obj_Rel_Insert_Input>;
  partner_order_item_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Customer_Order_Partner_Order_Max_Fields = {
  __typename?: 'customer_order_partner_order_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_order_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_order_item_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "customer_order_partner_order" */
export type Customer_Order_Partner_Order_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_order_item_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Customer_Order_Partner_Order_Min_Fields = {
  __typename?: 'customer_order_partner_order_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_order_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_order_item_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "customer_order_partner_order" */
export type Customer_Order_Partner_Order_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_order_item_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "customer_order_partner_order" */
export type Customer_Order_Partner_Order_Mutation_Response = {
  __typename?: 'customer_order_partner_order_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Customer_Order_Partner_Order>;
};

/** on_conflict condition type for table "customer_order_partner_order" */
export type Customer_Order_Partner_Order_On_Conflict = {
  constraint: Customer_Order_Partner_Order_Constraint;
  update_columns?: Array<Customer_Order_Partner_Order_Update_Column>;
  where?: InputMaybe<Customer_Order_Partner_Order_Bool_Exp>;
};

/** Ordering options when selecting data from "customer_order_partner_order". */
export type Customer_Order_Partner_Order_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_order?: InputMaybe<Customer_Order_Order_By>;
  customer_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_order_item?: InputMaybe<Partner_Order_Item_Order_By>;
  partner_order_item_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: customer_order_partner_order */
export type Customer_Order_Partner_Order_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "customer_order_partner_order" */
export enum Customer_Order_Partner_Order_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerOrderId = 'customer_order_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerOrderItemId = 'partner_order_item_id'
}

/** input type for updating data in table "customer_order_partner_order" */
export type Customer_Order_Partner_Order_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_order_item_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "customer_order_partner_order" */
export type Customer_Order_Partner_Order_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Order_Partner_Order_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customer_Order_Partner_Order_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_order_item_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "customer_order_partner_order" */
export enum Customer_Order_Partner_Order_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerOrderId = 'customer_order_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerOrderItemId = 'partner_order_item_id'
}

export type Customer_Order_Partner_Order_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Order_Partner_Order_Set_Input>;
  /** filter the rows which have to be updated */
  where: Customer_Order_Partner_Order_Bool_Exp;
};

/** primary key columns input for table: customer_order */
export type Customer_Order_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "customer_order" */
export enum Customer_Order_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  AmountPaid = 'amount_paid',
  /** column name */
  AmountToBePaid = 'amount_to_be_paid',
  /** column name */
  BillingAddressId = 'billing_address_id',
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CustomerOrderSlotsId = 'customer_order_slots_id',
  /** column name */
  DeliveryFee = 'delivery_fee',
  /** column name */
  DeliveryPreference = 'delivery_preference',
  /** column name */
  Description = 'description',
  /** column name */
  DiscountAmount = 'discount_amount',
  /** column name */
  FueltransOrderId = 'fueltrans_order_id',
  /** column name */
  Id = 'id',
  /** column name */
  Instruction = 'instruction',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsB2b = 'is_b2b',
  /** column name */
  IsOtpRequired = 'is_otp_required',
  /** column name */
  IsPrepaid = 'is_prepaid',
  /** column name */
  IsReceiptRequired = 'is_receipt_required',
  /** column name */
  IsTestEnabled = 'is_test_enabled',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  OrderCode = 'order_code',
  /** column name */
  OrderDate = 'order_date',
  /** column name */
  OrganizationUserId = 'organization_user_id',
  /** column name */
  Otp = 'otp',
  /** column name */
  PartnerLocalitiesSlotId = 'partner_localities_slot_id',
  /** column name */
  ProductVariationPartnerLocalitiesSlotId = 'product_variation_partner_localities_slot_id',
  /** column name */
  ServiceTax = 'service_tax',
  /** column name */
  ShippingAddressId = 'shipping_address_id',
  /** column name */
  State = 'state',
  /** column name */
  Tax = 'tax',
  /** column name */
  VoucherDiscount = 'voucher_discount',
  /** column name */
  VoucherId = 'voucher_id'
}

/** select "customer_order_aggregate_bool_exp_bool_and_arguments_columns" columns of table "customer_order" */
export enum Customer_Order_Select_Column_Customer_Order_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsB2b = 'is_b2b',
  /** column name */
  IsOtpRequired = 'is_otp_required',
  /** column name */
  IsPrepaid = 'is_prepaid',
  /** column name */
  IsReceiptRequired = 'is_receipt_required',
  /** column name */
  IsTestEnabled = 'is_test_enabled'
}

/** select "customer_order_aggregate_bool_exp_bool_or_arguments_columns" columns of table "customer_order" */
export enum Customer_Order_Select_Column_Customer_Order_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsB2b = 'is_b2b',
  /** column name */
  IsOtpRequired = 'is_otp_required',
  /** column name */
  IsPrepaid = 'is_prepaid',
  /** column name */
  IsReceiptRequired = 'is_receipt_required',
  /** column name */
  IsTestEnabled = 'is_test_enabled'
}

/** input type for updating data in table "customer_order" */
export type Customer_Order_Set_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  amount_paid?: InputMaybe<Scalars['numeric']['input']>;
  amount_to_be_paid?: InputMaybe<Scalars['numeric']['input']>;
  billing_address_id?: InputMaybe<Scalars['uuid']['input']>;
  category?: InputMaybe<Order_Type_Enum>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  customer_order_slots_id?: InputMaybe<Scalars['uuid']['input']>;
  delivery_fee?: InputMaybe<Scalars['numeric']['input']>;
  delivery_preference?: InputMaybe<Delivery_Preferences_Enum>;
  description?: InputMaybe<Scalars['String']['input']>;
  discount_amount?: InputMaybe<Scalars['numeric']['input']>;
  fueltrans_order_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  instruction?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_b2b?: InputMaybe<Scalars['Boolean']['input']>;
  is_otp_required?: InputMaybe<Scalars['Boolean']['input']>;
  is_prepaid?: InputMaybe<Scalars['Boolean']['input']>;
  is_receipt_required?: InputMaybe<Scalars['Boolean']['input']>;
  is_test_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_code?: InputMaybe<Scalars['bigint']['input']>;
  order_date?: InputMaybe<Scalars['timestamptz']['input']>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  otp?: InputMaybe<Scalars['Int']['input']>;
  partner_localities_slot_id?: InputMaybe<Scalars['uuid']['input']>;
  product_variation_partner_localities_slot_id?: InputMaybe<Scalars['uuid']['input']>;
  service_tax?: InputMaybe<Scalars['numeric']['input']>;
  shipping_address_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Customer_Order_State_Enum>;
  tax?: InputMaybe<Scalars['numeric']['input']>;
  voucher_discount?: InputMaybe<Scalars['numeric']['input']>;
  voucher_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "customer_order_slots" */
export type Customer_Order_Slots = {
  __typename?: 'customer_order_slots';
  created_at: Scalars['time']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  customer_order_items: Array<Customer_Order_Item>;
  /** An aggregate relationship */
  customer_order_items_aggregate: Customer_Order_Item_Aggregate;
  /** An array relationship */
  customer_orders: Array<Customer_Order>;
  /** An aggregate relationship */
  customer_orders_aggregate: Customer_Order_Aggregate;
  end_time: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  modified_at: Scalars['timestamp']['output'];
  /** An object relationship */
  shift_schedule?: Maybe<Shift_Schedule>;
  shift_schedule_id?: Maybe<Scalars['uuid']['output']>;
  start_time: Scalars['timestamptz']['output'];
  /** An array relationship */
  tasks: Array<Task>;
  /** An aggregate relationship */
  tasks_aggregate: Task_Aggregate;
};


/** columns and relationships of "customer_order_slots" */
export type Customer_Order_SlotsCustomer_Order_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Bool_Exp>;
};


/** columns and relationships of "customer_order_slots" */
export type Customer_Order_SlotsCustomer_Order_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Bool_Exp>;
};


/** columns and relationships of "customer_order_slots" */
export type Customer_Order_SlotsCustomer_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Order_By>>;
  where?: InputMaybe<Customer_Order_Bool_Exp>;
};


/** columns and relationships of "customer_order_slots" */
export type Customer_Order_SlotsCustomer_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Order_By>>;
  where?: InputMaybe<Customer_Order_Bool_Exp>;
};


/** columns and relationships of "customer_order_slots" */
export type Customer_Order_SlotsTasksArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


/** columns and relationships of "customer_order_slots" */
export type Customer_Order_SlotsTasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};

/** aggregated selection of "customer_order_slots" */
export type Customer_Order_Slots_Aggregate = {
  __typename?: 'customer_order_slots_aggregate';
  aggregate?: Maybe<Customer_Order_Slots_Aggregate_Fields>;
  nodes: Array<Customer_Order_Slots>;
};

export type Customer_Order_Slots_Aggregate_Bool_Exp = {
  count?: InputMaybe<Customer_Order_Slots_Aggregate_Bool_Exp_Count>;
};

export type Customer_Order_Slots_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Customer_Order_Slots_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Slots_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "customer_order_slots" */
export type Customer_Order_Slots_Aggregate_Fields = {
  __typename?: 'customer_order_slots_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Customer_Order_Slots_Max_Fields>;
  min?: Maybe<Customer_Order_Slots_Min_Fields>;
};


/** aggregate fields of "customer_order_slots" */
export type Customer_Order_Slots_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Order_Slots_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "customer_order_slots" */
export type Customer_Order_Slots_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Customer_Order_Slots_Max_Order_By>;
  min?: InputMaybe<Customer_Order_Slots_Min_Order_By>;
};

/** input type for inserting array relation for remote table "customer_order_slots" */
export type Customer_Order_Slots_Arr_Rel_Insert_Input = {
  data: Array<Customer_Order_Slots_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Order_Slots_On_Conflict>;
};

/** Boolean expression to filter rows from the table "customer_order_slots". All fields are combined with a logical 'AND'. */
export type Customer_Order_Slots_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Order_Slots_Bool_Exp>>;
  _not?: InputMaybe<Customer_Order_Slots_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Order_Slots_Bool_Exp>>;
  created_at?: InputMaybe<Time_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  customer_order_items?: InputMaybe<Customer_Order_Item_Bool_Exp>;
  customer_order_items_aggregate?: InputMaybe<Customer_Order_Item_Aggregate_Bool_Exp>;
  customer_orders?: InputMaybe<Customer_Order_Bool_Exp>;
  customer_orders_aggregate?: InputMaybe<Customer_Order_Aggregate_Bool_Exp>;
  end_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  modified_at?: InputMaybe<Timestamp_Comparison_Exp>;
  shift_schedule?: InputMaybe<Shift_Schedule_Bool_Exp>;
  shift_schedule_id?: InputMaybe<Uuid_Comparison_Exp>;
  start_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  tasks?: InputMaybe<Task_Bool_Exp>;
  tasks_aggregate?: InputMaybe<Task_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "customer_order_slots" */
export enum Customer_Order_Slots_Constraint {
  /** unique or primary key constraint on columns "id" */
  CustomerOrderSlotsPkey = 'customer_order_slots_pkey'
}

/** input type for inserting data into table "customer_order_slots" */
export type Customer_Order_Slots_Insert_Input = {
  created_at?: InputMaybe<Scalars['time']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  customer_order_items?: InputMaybe<Customer_Order_Item_Arr_Rel_Insert_Input>;
  customer_orders?: InputMaybe<Customer_Order_Arr_Rel_Insert_Input>;
  end_time?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  modified_at?: InputMaybe<Scalars['timestamp']['input']>;
  shift_schedule?: InputMaybe<Shift_Schedule_Obj_Rel_Insert_Input>;
  shift_schedule_id?: InputMaybe<Scalars['uuid']['input']>;
  start_time?: InputMaybe<Scalars['timestamptz']['input']>;
  tasks?: InputMaybe<Task_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Customer_Order_Slots_Max_Fields = {
  __typename?: 'customer_order_slots_max_fields';
  created_by?: Maybe<Scalars['uuid']['output']>;
  end_time?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  modified_at?: Maybe<Scalars['timestamp']['output']>;
  shift_schedule_id?: Maybe<Scalars['uuid']['output']>;
  start_time?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "customer_order_slots" */
export type Customer_Order_Slots_Max_Order_By = {
  created_by?: InputMaybe<Order_By>;
  end_time?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
  shift_schedule_id?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Customer_Order_Slots_Min_Fields = {
  __typename?: 'customer_order_slots_min_fields';
  created_by?: Maybe<Scalars['uuid']['output']>;
  end_time?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  modified_at?: Maybe<Scalars['timestamp']['output']>;
  shift_schedule_id?: Maybe<Scalars['uuid']['output']>;
  start_time?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "customer_order_slots" */
export type Customer_Order_Slots_Min_Order_By = {
  created_by?: InputMaybe<Order_By>;
  end_time?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
  shift_schedule_id?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "customer_order_slots" */
export type Customer_Order_Slots_Mutation_Response = {
  __typename?: 'customer_order_slots_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Customer_Order_Slots>;
};

/** input type for inserting object relation for remote table "customer_order_slots" */
export type Customer_Order_Slots_Obj_Rel_Insert_Input = {
  data: Customer_Order_Slots_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Order_Slots_On_Conflict>;
};

/** on_conflict condition type for table "customer_order_slots" */
export type Customer_Order_Slots_On_Conflict = {
  constraint: Customer_Order_Slots_Constraint;
  update_columns?: Array<Customer_Order_Slots_Update_Column>;
  where?: InputMaybe<Customer_Order_Slots_Bool_Exp>;
};

/** Ordering options when selecting data from "customer_order_slots". */
export type Customer_Order_Slots_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  customer_order_items_aggregate?: InputMaybe<Customer_Order_Item_Aggregate_Order_By>;
  customer_orders_aggregate?: InputMaybe<Customer_Order_Aggregate_Order_By>;
  end_time?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
  shift_schedule?: InputMaybe<Shift_Schedule_Order_By>;
  shift_schedule_id?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  tasks_aggregate?: InputMaybe<Task_Aggregate_Order_By>;
};

/** primary key columns input for table: customer_order_slots */
export type Customer_Order_Slots_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "customer_order_slots" */
export enum Customer_Order_Slots_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  Id = 'id',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  ModifiedAt = 'modified_at',
  /** column name */
  ShiftScheduleId = 'shift_schedule_id',
  /** column name */
  StartTime = 'start_time'
}

/** input type for updating data in table "customer_order_slots" */
export type Customer_Order_Slots_Set_Input = {
  created_at?: InputMaybe<Scalars['time']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  end_time?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  modified_at?: InputMaybe<Scalars['timestamp']['input']>;
  shift_schedule_id?: InputMaybe<Scalars['uuid']['input']>;
  start_time?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "customer_order_slots" */
export type Customer_Order_Slots_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Order_Slots_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customer_Order_Slots_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['time']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  end_time?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  modified_at?: InputMaybe<Scalars['timestamp']['input']>;
  shift_schedule_id?: InputMaybe<Scalars['uuid']['input']>;
  start_time?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "customer_order_slots" */
export enum Customer_Order_Slots_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  Id = 'id',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  ModifiedAt = 'modified_at',
  /** column name */
  ShiftScheduleId = 'shift_schedule_id',
  /** column name */
  StartTime = 'start_time'
}

export type Customer_Order_Slots_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Order_Slots_Set_Input>;
  /** filter the rows which have to be updated */
  where: Customer_Order_Slots_Bool_Exp;
};

/** columns and relationships of "customer_order_state" */
export type Customer_Order_State = {
  __typename?: 'customer_order_state';
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  customer_order_stateflows: Array<Customer_Order_Stateflow>;
  /** An aggregate relationship */
  customer_order_stateflows_aggregate: Customer_Order_Stateflow_Aggregate;
  /** An array relationship */
  customer_orders: Array<Customer_Order>;
  /** An aggregate relationship */
  customer_orders_aggregate: Customer_Order_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "customer_order_state" */
export type Customer_Order_StateCustomer_Order_StateflowsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Stateflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Stateflow_Order_By>>;
  where?: InputMaybe<Customer_Order_Stateflow_Bool_Exp>;
};


/** columns and relationships of "customer_order_state" */
export type Customer_Order_StateCustomer_Order_Stateflows_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Stateflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Stateflow_Order_By>>;
  where?: InputMaybe<Customer_Order_Stateflow_Bool_Exp>;
};


/** columns and relationships of "customer_order_state" */
export type Customer_Order_StateCustomer_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Order_By>>;
  where?: InputMaybe<Customer_Order_Bool_Exp>;
};


/** columns and relationships of "customer_order_state" */
export type Customer_Order_StateCustomer_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Order_By>>;
  where?: InputMaybe<Customer_Order_Bool_Exp>;
};

/** aggregated selection of "customer_order_state" */
export type Customer_Order_State_Aggregate = {
  __typename?: 'customer_order_state_aggregate';
  aggregate?: Maybe<Customer_Order_State_Aggregate_Fields>;
  nodes: Array<Customer_Order_State>;
};

/** aggregate fields of "customer_order_state" */
export type Customer_Order_State_Aggregate_Fields = {
  __typename?: 'customer_order_state_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Customer_Order_State_Max_Fields>;
  min?: Maybe<Customer_Order_State_Min_Fields>;
};


/** aggregate fields of "customer_order_state" */
export type Customer_Order_State_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Order_State_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "customer_order_state". All fields are combined with a logical 'AND'. */
export type Customer_Order_State_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Order_State_Bool_Exp>>;
  _not?: InputMaybe<Customer_Order_State_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Order_State_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  customer_order_stateflows?: InputMaybe<Customer_Order_Stateflow_Bool_Exp>;
  customer_order_stateflows_aggregate?: InputMaybe<Customer_Order_Stateflow_Aggregate_Bool_Exp>;
  customer_orders?: InputMaybe<Customer_Order_Bool_Exp>;
  customer_orders_aggregate?: InputMaybe<Customer_Order_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "customer_order_state" */
export enum Customer_Order_State_Constraint {
  /** unique or primary key constraint on columns "value" */
  CustomerOrderStatePkey = 'customer_order_state_pkey'
}

export enum Customer_Order_State_Enum {
  /** Order cancelled by ops during pre-acceptance review */
  Cancelled = 'CANCELLED',
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** CONFIRMED */
  Confirmed = 'CONFIRMED',
  /** DELIVERED */
  Delivered = 'DELIVERED',
  /** NO_SHOW */
  NoShow = 'NO_SHOW',
  /** PAID */
  Paid = 'PAID',
  /** PARTIAL_DELIVERED */
  PartialDelivered = 'PARTIAL_DELIVERED',
  /** PAY_LATER */
  PayLater = 'PAY_LATER',
  /** PENDING */
  Pending = 'PENDING',
  /** SETTLEMENT_DONE */
  SettlementDone = 'SETTLEMENT_DONE'
}

/** Boolean expression to compare columns of type "customer_order_state_enum". All fields are combined with logical 'AND'. */
export type Customer_Order_State_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Customer_Order_State_Enum>;
  _in?: InputMaybe<Array<Customer_Order_State_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Customer_Order_State_Enum>;
  _nin?: InputMaybe<Array<Customer_Order_State_Enum>>;
};

/** input type for inserting data into table "customer_order_state" */
export type Customer_Order_State_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  customer_order_stateflows?: InputMaybe<Customer_Order_Stateflow_Arr_Rel_Insert_Input>;
  customer_orders?: InputMaybe<Customer_Order_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Customer_Order_State_Max_Fields = {
  __typename?: 'customer_order_state_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Customer_Order_State_Min_Fields = {
  __typename?: 'customer_order_state_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "customer_order_state" */
export type Customer_Order_State_Mutation_Response = {
  __typename?: 'customer_order_state_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Customer_Order_State>;
};

/** input type for inserting object relation for remote table "customer_order_state" */
export type Customer_Order_State_Obj_Rel_Insert_Input = {
  data: Customer_Order_State_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Order_State_On_Conflict>;
};

/** on_conflict condition type for table "customer_order_state" */
export type Customer_Order_State_On_Conflict = {
  constraint: Customer_Order_State_Constraint;
  update_columns?: Array<Customer_Order_State_Update_Column>;
  where?: InputMaybe<Customer_Order_State_Bool_Exp>;
};

/** Ordering options when selecting data from "customer_order_state". */
export type Customer_Order_State_Order_By = {
  comment?: InputMaybe<Order_By>;
  customer_order_stateflows_aggregate?: InputMaybe<Customer_Order_Stateflow_Aggregate_Order_By>;
  customer_orders_aggregate?: InputMaybe<Customer_Order_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: customer_order_state */
export type Customer_Order_State_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "customer_order_state" */
export enum Customer_Order_State_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "customer_order_state" */
export type Customer_Order_State_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "customer_order_state" */
export type Customer_Order_State_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Order_State_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customer_Order_State_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "customer_order_state" */
export enum Customer_Order_State_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Customer_Order_State_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Order_State_Set_Input>;
  /** filter the rows which have to be updated */
  where: Customer_Order_State_Bool_Exp;
};

/** columns and relationships of "customer_order_stateflow" */
export type Customer_Order_Stateflow = {
  __typename?: 'customer_order_stateflow';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  customer_order: Customer_Order;
  /** An object relationship */
  customer_order_state: Customer_Order_State;
  id: Scalars['uuid']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  order_id: Scalars['uuid']['output'];
  /** An object relationship */
  organization_user: Organization_User;
  organization_user_id: Scalars['uuid']['output'];
  state: Customer_Order_State_Enum;
};

/** aggregated selection of "customer_order_stateflow" */
export type Customer_Order_Stateflow_Aggregate = {
  __typename?: 'customer_order_stateflow_aggregate';
  aggregate?: Maybe<Customer_Order_Stateflow_Aggregate_Fields>;
  nodes: Array<Customer_Order_Stateflow>;
};

export type Customer_Order_Stateflow_Aggregate_Bool_Exp = {
  count?: InputMaybe<Customer_Order_Stateflow_Aggregate_Bool_Exp_Count>;
};

export type Customer_Order_Stateflow_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Customer_Order_Stateflow_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Order_Stateflow_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "customer_order_stateflow" */
export type Customer_Order_Stateflow_Aggregate_Fields = {
  __typename?: 'customer_order_stateflow_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Customer_Order_Stateflow_Max_Fields>;
  min?: Maybe<Customer_Order_Stateflow_Min_Fields>;
};


/** aggregate fields of "customer_order_stateflow" */
export type Customer_Order_Stateflow_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Order_Stateflow_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "customer_order_stateflow" */
export type Customer_Order_Stateflow_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Customer_Order_Stateflow_Max_Order_By>;
  min?: InputMaybe<Customer_Order_Stateflow_Min_Order_By>;
};

/** input type for inserting array relation for remote table "customer_order_stateflow" */
export type Customer_Order_Stateflow_Arr_Rel_Insert_Input = {
  data: Array<Customer_Order_Stateflow_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Order_Stateflow_On_Conflict>;
};

/** Boolean expression to filter rows from the table "customer_order_stateflow". All fields are combined with a logical 'AND'. */
export type Customer_Order_Stateflow_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Order_Stateflow_Bool_Exp>>;
  _not?: InputMaybe<Customer_Order_Stateflow_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Order_Stateflow_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_order?: InputMaybe<Customer_Order_Bool_Exp>;
  customer_order_state?: InputMaybe<Customer_Order_State_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  order_id?: InputMaybe<Uuid_Comparison_Exp>;
  organization_user?: InputMaybe<Organization_User_Bool_Exp>;
  organization_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  state?: InputMaybe<Customer_Order_State_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "customer_order_stateflow" */
export enum Customer_Order_Stateflow_Constraint {
  /** unique or primary key constraint on columns "id" */
  CustomerOrderStateflowPkey = 'customer_order_stateflow_pkey'
}

/** input type for inserting data into table "customer_order_stateflow" */
export type Customer_Order_Stateflow_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order?: InputMaybe<Customer_Order_Obj_Rel_Insert_Input>;
  customer_order_state?: InputMaybe<Customer_Order_State_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  order_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_user?: InputMaybe<Organization_User_Obj_Rel_Insert_Input>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Customer_Order_State_Enum>;
};

/** aggregate max on columns */
export type Customer_Order_Stateflow_Max_Fields = {
  __typename?: 'customer_order_stateflow_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  order_id?: Maybe<Scalars['uuid']['output']>;
  organization_user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "customer_order_stateflow" */
export type Customer_Order_Stateflow_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Customer_Order_Stateflow_Min_Fields = {
  __typename?: 'customer_order_stateflow_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  order_id?: Maybe<Scalars['uuid']['output']>;
  organization_user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "customer_order_stateflow" */
export type Customer_Order_Stateflow_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "customer_order_stateflow" */
export type Customer_Order_Stateflow_Mutation_Response = {
  __typename?: 'customer_order_stateflow_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Customer_Order_Stateflow>;
};

/** on_conflict condition type for table "customer_order_stateflow" */
export type Customer_Order_Stateflow_On_Conflict = {
  constraint: Customer_Order_Stateflow_Constraint;
  update_columns?: Array<Customer_Order_Stateflow_Update_Column>;
  where?: InputMaybe<Customer_Order_Stateflow_Bool_Exp>;
};

/** Ordering options when selecting data from "customer_order_stateflow". */
export type Customer_Order_Stateflow_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_order?: InputMaybe<Customer_Order_Order_By>;
  customer_order_state?: InputMaybe<Customer_Order_State_Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  organization_user?: InputMaybe<Organization_User_Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
};

/** primary key columns input for table: customer_order_stateflow */
export type Customer_Order_Stateflow_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "customer_order_stateflow" */
export enum Customer_Order_Stateflow_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  OrganizationUserId = 'organization_user_id',
  /** column name */
  State = 'state'
}

/** input type for updating data in table "customer_order_stateflow" */
export type Customer_Order_Stateflow_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  order_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Customer_Order_State_Enum>;
};

/** Streaming cursor of the table "customer_order_stateflow" */
export type Customer_Order_Stateflow_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Order_Stateflow_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customer_Order_Stateflow_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  order_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Customer_Order_State_Enum>;
};

/** update columns of table "customer_order_stateflow" */
export enum Customer_Order_Stateflow_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  OrganizationUserId = 'organization_user_id',
  /** column name */
  State = 'state'
}

export type Customer_Order_Stateflow_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Order_Stateflow_Set_Input>;
  /** filter the rows which have to be updated */
  where: Customer_Order_Stateflow_Bool_Exp;
};

/** aggregate stddev on columns */
export type Customer_Order_Stddev_Fields = {
  __typename?: 'customer_order_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  amount_paid?: Maybe<Scalars['Float']['output']>;
  amount_to_be_paid?: Maybe<Scalars['Float']['output']>;
  delivery_fee?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  order_code?: Maybe<Scalars['Float']['output']>;
  otp?: Maybe<Scalars['Float']['output']>;
  service_tax?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  voucher_discount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "customer_order" */
export type Customer_Order_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_to_be_paid?: InputMaybe<Order_By>;
  delivery_fee?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  order_code?: InputMaybe<Order_By>;
  otp?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Customer_Order_Stddev_Pop_Fields = {
  __typename?: 'customer_order_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  amount_paid?: Maybe<Scalars['Float']['output']>;
  amount_to_be_paid?: Maybe<Scalars['Float']['output']>;
  delivery_fee?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  order_code?: Maybe<Scalars['Float']['output']>;
  otp?: Maybe<Scalars['Float']['output']>;
  service_tax?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  voucher_discount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "customer_order" */
export type Customer_Order_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_to_be_paid?: InputMaybe<Order_By>;
  delivery_fee?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  order_code?: InputMaybe<Order_By>;
  otp?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Customer_Order_Stddev_Samp_Fields = {
  __typename?: 'customer_order_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  amount_paid?: Maybe<Scalars['Float']['output']>;
  amount_to_be_paid?: Maybe<Scalars['Float']['output']>;
  delivery_fee?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  order_code?: Maybe<Scalars['Float']['output']>;
  otp?: Maybe<Scalars['Float']['output']>;
  service_tax?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  voucher_discount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "customer_order" */
export type Customer_Order_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_to_be_paid?: InputMaybe<Order_By>;
  delivery_fee?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  order_code?: InputMaybe<Order_By>;
  otp?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "customer_order" */
export type Customer_Order_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Order_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customer_Order_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  amount_paid?: InputMaybe<Scalars['numeric']['input']>;
  amount_to_be_paid?: InputMaybe<Scalars['numeric']['input']>;
  billing_address_id?: InputMaybe<Scalars['uuid']['input']>;
  category?: InputMaybe<Order_Type_Enum>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  customer_order_slots_id?: InputMaybe<Scalars['uuid']['input']>;
  delivery_fee?: InputMaybe<Scalars['numeric']['input']>;
  delivery_preference?: InputMaybe<Delivery_Preferences_Enum>;
  description?: InputMaybe<Scalars['String']['input']>;
  discount_amount?: InputMaybe<Scalars['numeric']['input']>;
  fueltrans_order_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  instruction?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_b2b?: InputMaybe<Scalars['Boolean']['input']>;
  is_otp_required?: InputMaybe<Scalars['Boolean']['input']>;
  is_prepaid?: InputMaybe<Scalars['Boolean']['input']>;
  is_receipt_required?: InputMaybe<Scalars['Boolean']['input']>;
  is_test_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_code?: InputMaybe<Scalars['bigint']['input']>;
  order_date?: InputMaybe<Scalars['timestamptz']['input']>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  otp?: InputMaybe<Scalars['Int']['input']>;
  partner_localities_slot_id?: InputMaybe<Scalars['uuid']['input']>;
  product_variation_partner_localities_slot_id?: InputMaybe<Scalars['uuid']['input']>;
  service_tax?: InputMaybe<Scalars['numeric']['input']>;
  shipping_address_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Customer_Order_State_Enum>;
  tax?: InputMaybe<Scalars['numeric']['input']>;
  voucher_discount?: InputMaybe<Scalars['numeric']['input']>;
  voucher_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Customer_Order_Sum_Fields = {
  __typename?: 'customer_order_sum_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  amount_paid?: Maybe<Scalars['numeric']['output']>;
  amount_to_be_paid?: Maybe<Scalars['numeric']['output']>;
  delivery_fee?: Maybe<Scalars['numeric']['output']>;
  discount_amount?: Maybe<Scalars['numeric']['output']>;
  order_code?: Maybe<Scalars['bigint']['output']>;
  otp?: Maybe<Scalars['Int']['output']>;
  service_tax?: Maybe<Scalars['numeric']['output']>;
  tax?: Maybe<Scalars['numeric']['output']>;
  voucher_discount?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "customer_order" */
export type Customer_Order_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_to_be_paid?: InputMaybe<Order_By>;
  delivery_fee?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  order_code?: InputMaybe<Order_By>;
  otp?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
};

/** update columns of table "customer_order" */
export enum Customer_Order_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  AmountPaid = 'amount_paid',
  /** column name */
  AmountToBePaid = 'amount_to_be_paid',
  /** column name */
  BillingAddressId = 'billing_address_id',
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CustomerOrderSlotsId = 'customer_order_slots_id',
  /** column name */
  DeliveryFee = 'delivery_fee',
  /** column name */
  DeliveryPreference = 'delivery_preference',
  /** column name */
  Description = 'description',
  /** column name */
  DiscountAmount = 'discount_amount',
  /** column name */
  FueltransOrderId = 'fueltrans_order_id',
  /** column name */
  Id = 'id',
  /** column name */
  Instruction = 'instruction',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsB2b = 'is_b2b',
  /** column name */
  IsOtpRequired = 'is_otp_required',
  /** column name */
  IsPrepaid = 'is_prepaid',
  /** column name */
  IsReceiptRequired = 'is_receipt_required',
  /** column name */
  IsTestEnabled = 'is_test_enabled',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  OrderCode = 'order_code',
  /** column name */
  OrderDate = 'order_date',
  /** column name */
  OrganizationUserId = 'organization_user_id',
  /** column name */
  Otp = 'otp',
  /** column name */
  PartnerLocalitiesSlotId = 'partner_localities_slot_id',
  /** column name */
  ProductVariationPartnerLocalitiesSlotId = 'product_variation_partner_localities_slot_id',
  /** column name */
  ServiceTax = 'service_tax',
  /** column name */
  ShippingAddressId = 'shipping_address_id',
  /** column name */
  State = 'state',
  /** column name */
  Tax = 'tax',
  /** column name */
  VoucherDiscount = 'voucher_discount',
  /** column name */
  VoucherId = 'voucher_id'
}

export type Customer_Order_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Customer_Order_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Order_Set_Input>;
  /** filter the rows which have to be updated */
  where: Customer_Order_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Customer_Order_Var_Pop_Fields = {
  __typename?: 'customer_order_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  amount_paid?: Maybe<Scalars['Float']['output']>;
  amount_to_be_paid?: Maybe<Scalars['Float']['output']>;
  delivery_fee?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  order_code?: Maybe<Scalars['Float']['output']>;
  otp?: Maybe<Scalars['Float']['output']>;
  service_tax?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  voucher_discount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "customer_order" */
export type Customer_Order_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_to_be_paid?: InputMaybe<Order_By>;
  delivery_fee?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  order_code?: InputMaybe<Order_By>;
  otp?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Customer_Order_Var_Samp_Fields = {
  __typename?: 'customer_order_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  amount_paid?: Maybe<Scalars['Float']['output']>;
  amount_to_be_paid?: Maybe<Scalars['Float']['output']>;
  delivery_fee?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  order_code?: Maybe<Scalars['Float']['output']>;
  otp?: Maybe<Scalars['Float']['output']>;
  service_tax?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  voucher_discount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "customer_order" */
export type Customer_Order_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_to_be_paid?: InputMaybe<Order_By>;
  delivery_fee?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  order_code?: InputMaybe<Order_By>;
  otp?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Customer_Order_Variance_Fields = {
  __typename?: 'customer_order_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  amount_paid?: Maybe<Scalars['Float']['output']>;
  amount_to_be_paid?: Maybe<Scalars['Float']['output']>;
  delivery_fee?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  order_code?: Maybe<Scalars['Float']['output']>;
  otp?: Maybe<Scalars['Float']['output']>;
  service_tax?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  voucher_discount?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "customer_order" */
export type Customer_Order_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_to_be_paid?: InputMaybe<Order_By>;
  delivery_fee?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  order_code?: InputMaybe<Order_By>;
  otp?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
};

/** columns and relationships of "customer_payment" */
export type Customer_Payment = {
  __typename?: 'customer_payment';
  amount?: Maybe<Scalars['numeric']['output']>;
  client_secret?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  currency?: Maybe<Currency>;
  currency_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  customer_order: Customer_Order;
  customer_order_id: Scalars['uuid']['output'];
  /** An object relationship */
  customer_payment_status?: Maybe<Customer_Payment_Status>;
  id: Scalars['uuid']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  payment_url?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Customer_Payment_Status_Enum>;
  transaction_id?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  user_ledgers: Array<User_Ledger>;
  /** An aggregate relationship */
  user_ledgers_aggregate: User_Ledger_Aggregate;
};


/** columns and relationships of "customer_payment" */
export type Customer_PaymentUser_LedgersArgs = {
  distinct_on?: InputMaybe<Array<User_Ledger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Ledger_Order_By>>;
  where?: InputMaybe<User_Ledger_Bool_Exp>;
};


/** columns and relationships of "customer_payment" */
export type Customer_PaymentUser_Ledgers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Ledger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Ledger_Order_By>>;
  where?: InputMaybe<User_Ledger_Bool_Exp>;
};

/** aggregated selection of "customer_payment" */
export type Customer_Payment_Aggregate = {
  __typename?: 'customer_payment_aggregate';
  aggregate?: Maybe<Customer_Payment_Aggregate_Fields>;
  nodes: Array<Customer_Payment>;
};

export type Customer_Payment_Aggregate_Bool_Exp = {
  count?: InputMaybe<Customer_Payment_Aggregate_Bool_Exp_Count>;
};

export type Customer_Payment_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Customer_Payment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Payment_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "customer_payment" */
export type Customer_Payment_Aggregate_Fields = {
  __typename?: 'customer_payment_aggregate_fields';
  avg?: Maybe<Customer_Payment_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Customer_Payment_Max_Fields>;
  min?: Maybe<Customer_Payment_Min_Fields>;
  stddev?: Maybe<Customer_Payment_Stddev_Fields>;
  stddev_pop?: Maybe<Customer_Payment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Customer_Payment_Stddev_Samp_Fields>;
  sum?: Maybe<Customer_Payment_Sum_Fields>;
  var_pop?: Maybe<Customer_Payment_Var_Pop_Fields>;
  var_samp?: Maybe<Customer_Payment_Var_Samp_Fields>;
  variance?: Maybe<Customer_Payment_Variance_Fields>;
};


/** aggregate fields of "customer_payment" */
export type Customer_Payment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Payment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "customer_payment" */
export type Customer_Payment_Aggregate_Order_By = {
  avg?: InputMaybe<Customer_Payment_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Customer_Payment_Max_Order_By>;
  min?: InputMaybe<Customer_Payment_Min_Order_By>;
  stddev?: InputMaybe<Customer_Payment_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Customer_Payment_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Customer_Payment_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Customer_Payment_Sum_Order_By>;
  var_pop?: InputMaybe<Customer_Payment_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Customer_Payment_Var_Samp_Order_By>;
  variance?: InputMaybe<Customer_Payment_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "customer_payment" */
export type Customer_Payment_Arr_Rel_Insert_Input = {
  data: Array<Customer_Payment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Payment_On_Conflict>;
};

/** aggregate avg on columns */
export type Customer_Payment_Avg_Fields = {
  __typename?: 'customer_payment_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "customer_payment" */
export type Customer_Payment_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "customer_payment". All fields are combined with a logical 'AND'. */
export type Customer_Payment_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Payment_Bool_Exp>>;
  _not?: InputMaybe<Customer_Payment_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Payment_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  client_secret?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  currency?: InputMaybe<Currency_Bool_Exp>;
  currency_id?: InputMaybe<Uuid_Comparison_Exp>;
  customer_order?: InputMaybe<Customer_Order_Bool_Exp>;
  customer_order_id?: InputMaybe<Uuid_Comparison_Exp>;
  customer_payment_status?: InputMaybe<Customer_Payment_Status_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  payment_url?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Customer_Payment_Status_Enum_Comparison_Exp>;
  transaction_id?: InputMaybe<String_Comparison_Exp>;
  user_ledgers?: InputMaybe<User_Ledger_Bool_Exp>;
  user_ledgers_aggregate?: InputMaybe<User_Ledger_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "customer_payment" */
export enum Customer_Payment_Constraint {
  /** unique or primary key constraint on columns "id" */
  CustomerPaymentPkey = 'customer_payment_pkey'
}

/** input type for incrementing numeric columns in table "customer_payment" */
export type Customer_Payment_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "customer_payment" */
export type Customer_Payment_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  client_secret?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  currency?: InputMaybe<Currency_Obj_Rel_Insert_Input>;
  currency_id?: InputMaybe<Scalars['uuid']['input']>;
  customer_order?: InputMaybe<Customer_Order_Obj_Rel_Insert_Input>;
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
  customer_payment_status?: InputMaybe<Customer_Payment_Status_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  payment_url?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Customer_Payment_Status_Enum>;
  transaction_id?: InputMaybe<Scalars['String']['input']>;
  user_ledgers?: InputMaybe<User_Ledger_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Customer_Payment_Max_Fields = {
  __typename?: 'customer_payment_max_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  client_secret?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  currency_id?: Maybe<Scalars['uuid']['output']>;
  customer_order_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  payment_url?: Maybe<Scalars['String']['output']>;
  transaction_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "customer_payment" */
export type Customer_Payment_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  client_secret?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency_id?: InputMaybe<Order_By>;
  customer_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  payment_url?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Customer_Payment_Min_Fields = {
  __typename?: 'customer_payment_min_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  client_secret?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  currency_id?: Maybe<Scalars['uuid']['output']>;
  customer_order_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  payment_url?: Maybe<Scalars['String']['output']>;
  transaction_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "customer_payment" */
export type Customer_Payment_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  client_secret?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency_id?: InputMaybe<Order_By>;
  customer_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  payment_url?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "customer_payment" */
export type Customer_Payment_Mutation_Response = {
  __typename?: 'customer_payment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Customer_Payment>;
};

/** input type for inserting object relation for remote table "customer_payment" */
export type Customer_Payment_Obj_Rel_Insert_Input = {
  data: Customer_Payment_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Payment_On_Conflict>;
};

/** on_conflict condition type for table "customer_payment" */
export type Customer_Payment_On_Conflict = {
  constraint: Customer_Payment_Constraint;
  update_columns?: Array<Customer_Payment_Update_Column>;
  where?: InputMaybe<Customer_Payment_Bool_Exp>;
};

/** Ordering options when selecting data from "customer_payment". */
export type Customer_Payment_Order_By = {
  amount?: InputMaybe<Order_By>;
  client_secret?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Currency_Order_By>;
  currency_id?: InputMaybe<Order_By>;
  customer_order?: InputMaybe<Customer_Order_Order_By>;
  customer_order_id?: InputMaybe<Order_By>;
  customer_payment_status?: InputMaybe<Customer_Payment_Status_Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  payment_url?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  user_ledgers_aggregate?: InputMaybe<User_Ledger_Aggregate_Order_By>;
};

/** primary key columns input for table: customer_payment */
export type Customer_Payment_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "customer_payment" */
export enum Customer_Payment_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  ClientSecret = 'client_secret',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  CustomerOrderId = 'customer_order_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PaymentUrl = 'payment_url',
  /** column name */
  Status = 'status',
  /** column name */
  TransactionId = 'transaction_id'
}

/** input type for updating data in table "customer_payment" */
export type Customer_Payment_Set_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  client_secret?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  currency_id?: InputMaybe<Scalars['uuid']['input']>;
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  payment_url?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Customer_Payment_Status_Enum>;
  transaction_id?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "customer_payment_status" */
export type Customer_Payment_Status = {
  __typename?: 'customer_payment_status';
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  customer_payments: Array<Customer_Payment>;
  /** An aggregate relationship */
  customer_payments_aggregate: Customer_Payment_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "customer_payment_status" */
export type Customer_Payment_StatusCustomer_PaymentsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Payment_Order_By>>;
  where?: InputMaybe<Customer_Payment_Bool_Exp>;
};


/** columns and relationships of "customer_payment_status" */
export type Customer_Payment_StatusCustomer_Payments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Payment_Order_By>>;
  where?: InputMaybe<Customer_Payment_Bool_Exp>;
};

/** aggregated selection of "customer_payment_status" */
export type Customer_Payment_Status_Aggregate = {
  __typename?: 'customer_payment_status_aggregate';
  aggregate?: Maybe<Customer_Payment_Status_Aggregate_Fields>;
  nodes: Array<Customer_Payment_Status>;
};

/** aggregate fields of "customer_payment_status" */
export type Customer_Payment_Status_Aggregate_Fields = {
  __typename?: 'customer_payment_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Customer_Payment_Status_Max_Fields>;
  min?: Maybe<Customer_Payment_Status_Min_Fields>;
};


/** aggregate fields of "customer_payment_status" */
export type Customer_Payment_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Payment_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "customer_payment_status". All fields are combined with a logical 'AND'. */
export type Customer_Payment_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Payment_Status_Bool_Exp>>;
  _not?: InputMaybe<Customer_Payment_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Payment_Status_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  customer_payments?: InputMaybe<Customer_Payment_Bool_Exp>;
  customer_payments_aggregate?: InputMaybe<Customer_Payment_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "customer_payment_status" */
export enum Customer_Payment_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  CustomerPaymentStatusPkey = 'customer_payment_status_pkey'
}

export enum Customer_Payment_Status_Enum {
  /** CANCELLED */
  Cancelled = 'CANCELLED',
  /** FAILED */
  Failed = 'FAILED',
  /** ITEM_CANCELLATION_REFUND */
  ItemCancellationRefund = 'ITEM_CANCELLATION_REFUND',
  /** PAID */
  Paid = 'PAID',
  /** PENDING */
  Pending = 'PENDING',
  /** REFUNDED */
  Refunded = 'REFUNDED'
}

/** Boolean expression to compare columns of type "customer_payment_status_enum". All fields are combined with logical 'AND'. */
export type Customer_Payment_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Customer_Payment_Status_Enum>;
  _in?: InputMaybe<Array<Customer_Payment_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Customer_Payment_Status_Enum>;
  _nin?: InputMaybe<Array<Customer_Payment_Status_Enum>>;
};

/** input type for inserting data into table "customer_payment_status" */
export type Customer_Payment_Status_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  customer_payments?: InputMaybe<Customer_Payment_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Customer_Payment_Status_Max_Fields = {
  __typename?: 'customer_payment_status_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Customer_Payment_Status_Min_Fields = {
  __typename?: 'customer_payment_status_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "customer_payment_status" */
export type Customer_Payment_Status_Mutation_Response = {
  __typename?: 'customer_payment_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Customer_Payment_Status>;
};

/** input type for inserting object relation for remote table "customer_payment_status" */
export type Customer_Payment_Status_Obj_Rel_Insert_Input = {
  data: Customer_Payment_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Payment_Status_On_Conflict>;
};

/** on_conflict condition type for table "customer_payment_status" */
export type Customer_Payment_Status_On_Conflict = {
  constraint: Customer_Payment_Status_Constraint;
  update_columns?: Array<Customer_Payment_Status_Update_Column>;
  where?: InputMaybe<Customer_Payment_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "customer_payment_status". */
export type Customer_Payment_Status_Order_By = {
  comment?: InputMaybe<Order_By>;
  customer_payments_aggregate?: InputMaybe<Customer_Payment_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: customer_payment_status */
export type Customer_Payment_Status_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "customer_payment_status" */
export enum Customer_Payment_Status_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "customer_payment_status" */
export type Customer_Payment_Status_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "customer_payment_status" */
export type Customer_Payment_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Payment_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customer_Payment_Status_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "customer_payment_status" */
export enum Customer_Payment_Status_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Customer_Payment_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Payment_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Customer_Payment_Status_Bool_Exp;
};

/** aggregate stddev on columns */
export type Customer_Payment_Stddev_Fields = {
  __typename?: 'customer_payment_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "customer_payment" */
export type Customer_Payment_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Customer_Payment_Stddev_Pop_Fields = {
  __typename?: 'customer_payment_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "customer_payment" */
export type Customer_Payment_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Customer_Payment_Stddev_Samp_Fields = {
  __typename?: 'customer_payment_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "customer_payment" */
export type Customer_Payment_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "customer_payment" */
export type Customer_Payment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Payment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customer_Payment_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  client_secret?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  currency_id?: InputMaybe<Scalars['uuid']['input']>;
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  payment_url?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Customer_Payment_Status_Enum>;
  transaction_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Customer_Payment_Sum_Fields = {
  __typename?: 'customer_payment_sum_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "customer_payment" */
export type Customer_Payment_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** update columns of table "customer_payment" */
export enum Customer_Payment_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  ClientSecret = 'client_secret',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  CustomerOrderId = 'customer_order_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PaymentUrl = 'payment_url',
  /** column name */
  Status = 'status',
  /** column name */
  TransactionId = 'transaction_id'
}

export type Customer_Payment_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Customer_Payment_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Payment_Set_Input>;
  /** filter the rows which have to be updated */
  where: Customer_Payment_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Customer_Payment_Var_Pop_Fields = {
  __typename?: 'customer_payment_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "customer_payment" */
export type Customer_Payment_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Customer_Payment_Var_Samp_Fields = {
  __typename?: 'customer_payment_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "customer_payment" */
export type Customer_Payment_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Customer_Payment_Variance_Fields = {
  __typename?: 'customer_payment_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "customer_payment" */
export type Customer_Payment_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** columns and relationships of "customer_segmentation" */
export type Customer_Segmentation = {
  __typename?: 'customer_segmentation';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name: Scalars['String']['output'];
  rank_id?: Maybe<Scalars['Int']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  users: Array<User>;
  /** An aggregate relationship */
  users_aggregate: User_Aggregate;
};


/** columns and relationships of "customer_segmentation" */
export type Customer_SegmentationUsersArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


/** columns and relationships of "customer_segmentation" */
export type Customer_SegmentationUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};

/** aggregated selection of "customer_segmentation" */
export type Customer_Segmentation_Aggregate = {
  __typename?: 'customer_segmentation_aggregate';
  aggregate?: Maybe<Customer_Segmentation_Aggregate_Fields>;
  nodes: Array<Customer_Segmentation>;
};

/** aggregate fields of "customer_segmentation" */
export type Customer_Segmentation_Aggregate_Fields = {
  __typename?: 'customer_segmentation_aggregate_fields';
  avg?: Maybe<Customer_Segmentation_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Customer_Segmentation_Max_Fields>;
  min?: Maybe<Customer_Segmentation_Min_Fields>;
  stddev?: Maybe<Customer_Segmentation_Stddev_Fields>;
  stddev_pop?: Maybe<Customer_Segmentation_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Customer_Segmentation_Stddev_Samp_Fields>;
  sum?: Maybe<Customer_Segmentation_Sum_Fields>;
  var_pop?: Maybe<Customer_Segmentation_Var_Pop_Fields>;
  var_samp?: Maybe<Customer_Segmentation_Var_Samp_Fields>;
  variance?: Maybe<Customer_Segmentation_Variance_Fields>;
};


/** aggregate fields of "customer_segmentation" */
export type Customer_Segmentation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Segmentation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Customer_Segmentation_Avg_Fields = {
  __typename?: 'customer_segmentation_avg_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "customer_segmentation". All fields are combined with a logical 'AND'. */
export type Customer_Segmentation_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Segmentation_Bool_Exp>>;
  _not?: InputMaybe<Customer_Segmentation_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Segmentation_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  rank_id?: InputMaybe<Int_Comparison_Exp>;
  sku?: InputMaybe<String_Comparison_Exp>;
  users?: InputMaybe<User_Bool_Exp>;
  users_aggregate?: InputMaybe<User_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "customer_segmentation" */
export enum Customer_Segmentation_Constraint {
  /** unique or primary key constraint on columns "id" */
  CustomerSegmentationPkey = 'customer_segmentation_pkey'
}

/** input type for incrementing numeric columns in table "customer_segmentation" */
export type Customer_Segmentation_Inc_Input = {
  rank_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "customer_segmentation" */
export type Customer_Segmentation_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rank_id?: InputMaybe<Scalars['Int']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<User_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Customer_Segmentation_Max_Fields = {
  __typename?: 'customer_segmentation_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rank_id?: Maybe<Scalars['Int']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Customer_Segmentation_Min_Fields = {
  __typename?: 'customer_segmentation_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rank_id?: Maybe<Scalars['Int']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "customer_segmentation" */
export type Customer_Segmentation_Mutation_Response = {
  __typename?: 'customer_segmentation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Customer_Segmentation>;
};

/** input type for inserting object relation for remote table "customer_segmentation" */
export type Customer_Segmentation_Obj_Rel_Insert_Input = {
  data: Customer_Segmentation_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Segmentation_On_Conflict>;
};

/** on_conflict condition type for table "customer_segmentation" */
export type Customer_Segmentation_On_Conflict = {
  constraint: Customer_Segmentation_Constraint;
  update_columns?: Array<Customer_Segmentation_Update_Column>;
  where?: InputMaybe<Customer_Segmentation_Bool_Exp>;
};

/** Ordering options when selecting data from "customer_segmentation". */
export type Customer_Segmentation_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  rank_id?: InputMaybe<Order_By>;
  sku?: InputMaybe<Order_By>;
  users_aggregate?: InputMaybe<User_Aggregate_Order_By>;
};

/** primary key columns input for table: customer_segmentation */
export type Customer_Segmentation_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "customer_segmentation" */
export enum Customer_Segmentation_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  RankId = 'rank_id',
  /** column name */
  Sku = 'sku'
}

/** input type for updating data in table "customer_segmentation" */
export type Customer_Segmentation_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rank_id?: InputMaybe<Scalars['Int']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Customer_Segmentation_Stddev_Fields = {
  __typename?: 'customer_segmentation_stddev_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Customer_Segmentation_Stddev_Pop_Fields = {
  __typename?: 'customer_segmentation_stddev_pop_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Customer_Segmentation_Stddev_Samp_Fields = {
  __typename?: 'customer_segmentation_stddev_samp_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "customer_segmentation" */
export type Customer_Segmentation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Segmentation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customer_Segmentation_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rank_id?: InputMaybe<Scalars['Int']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Customer_Segmentation_Sum_Fields = {
  __typename?: 'customer_segmentation_sum_fields';
  rank_id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "customer_segmentation" */
export enum Customer_Segmentation_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  RankId = 'rank_id',
  /** column name */
  Sku = 'sku'
}

export type Customer_Segmentation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Customer_Segmentation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Segmentation_Set_Input>;
  /** filter the rows which have to be updated */
  where: Customer_Segmentation_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Customer_Segmentation_Var_Pop_Fields = {
  __typename?: 'customer_segmentation_var_pop_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Customer_Segmentation_Var_Samp_Fields = {
  __typename?: 'customer_segmentation_var_samp_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Customer_Segmentation_Variance_Fields = {
  __typename?: 'customer_segmentation_variance_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

export type DashboardDetailsInput = {
  dashboard_id: Scalars['uuid']['input'];
  dashboard_type: Scalars['String']['input'];
};

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

/** columns and relationships of "day_type" */
export type Day_Type = {
  __typename?: 'day_type';
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  order_scheduler_daily_frequencies: Array<Order_Scheduler_Daily_Frequency>;
  /** An aggregate relationship */
  order_scheduler_daily_frequencies_aggregate: Order_Scheduler_Daily_Frequency_Aggregate;
  /** An array relationship */
  organization_timings: Array<Organization_Timing>;
  /** An aggregate relationship */
  organization_timings_aggregate: Organization_Timing_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "day_type" */
export type Day_TypeOrder_Scheduler_Daily_FrequenciesArgs = {
  distinct_on?: InputMaybe<Array<Order_Scheduler_Daily_Frequency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Scheduler_Daily_Frequency_Order_By>>;
  where?: InputMaybe<Order_Scheduler_Daily_Frequency_Bool_Exp>;
};


/** columns and relationships of "day_type" */
export type Day_TypeOrder_Scheduler_Daily_Frequencies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Scheduler_Daily_Frequency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Scheduler_Daily_Frequency_Order_By>>;
  where?: InputMaybe<Order_Scheduler_Daily_Frequency_Bool_Exp>;
};


/** columns and relationships of "day_type" */
export type Day_TypeOrganization_TimingsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Timing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Timing_Order_By>>;
  where?: InputMaybe<Organization_Timing_Bool_Exp>;
};


/** columns and relationships of "day_type" */
export type Day_TypeOrganization_Timings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Timing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Timing_Order_By>>;
  where?: InputMaybe<Organization_Timing_Bool_Exp>;
};

/** aggregated selection of "day_type" */
export type Day_Type_Aggregate = {
  __typename?: 'day_type_aggregate';
  aggregate?: Maybe<Day_Type_Aggregate_Fields>;
  nodes: Array<Day_Type>;
};

/** aggregate fields of "day_type" */
export type Day_Type_Aggregate_Fields = {
  __typename?: 'day_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Day_Type_Max_Fields>;
  min?: Maybe<Day_Type_Min_Fields>;
};


/** aggregate fields of "day_type" */
export type Day_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Day_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "day_type". All fields are combined with a logical 'AND'. */
export type Day_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Day_Type_Bool_Exp>>;
  _not?: InputMaybe<Day_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Day_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  order_scheduler_daily_frequencies?: InputMaybe<Order_Scheduler_Daily_Frequency_Bool_Exp>;
  order_scheduler_daily_frequencies_aggregate?: InputMaybe<Order_Scheduler_Daily_Frequency_Aggregate_Bool_Exp>;
  organization_timings?: InputMaybe<Organization_Timing_Bool_Exp>;
  organization_timings_aggregate?: InputMaybe<Organization_Timing_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "day_type" */
export enum Day_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  DayTypePkey = 'day_type_pkey'
}

export enum Day_Type_Enum {
  /** FRIDAY */
  Friday = 'FRIDAY',
  /** MONDAY */
  Monday = 'MONDAY',
  /** SATURDAY */
  Saturday = 'SATURDAY',
  /** SUNDAY */
  Sunday = 'SUNDAY',
  /** THURSDAY */
  Thursday = 'THURSDAY',
  /** TUESDAY */
  Tuesday = 'TUESDAY',
  /** WEDNESDAY */
  Wednesday = 'WEDNESDAY'
}

/** Boolean expression to compare columns of type "day_type_enum". All fields are combined with logical 'AND'. */
export type Day_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Day_Type_Enum>;
  _in?: InputMaybe<Array<Day_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Day_Type_Enum>;
  _nin?: InputMaybe<Array<Day_Type_Enum>>;
};

/** input type for inserting data into table "day_type" */
export type Day_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  order_scheduler_daily_frequencies?: InputMaybe<Order_Scheduler_Daily_Frequency_Arr_Rel_Insert_Input>;
  organization_timings?: InputMaybe<Organization_Timing_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Day_Type_Max_Fields = {
  __typename?: 'day_type_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Day_Type_Min_Fields = {
  __typename?: 'day_type_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "day_type" */
export type Day_Type_Mutation_Response = {
  __typename?: 'day_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Day_Type>;
};

/** input type for inserting object relation for remote table "day_type" */
export type Day_Type_Obj_Rel_Insert_Input = {
  data: Day_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Day_Type_On_Conflict>;
};

/** on_conflict condition type for table "day_type" */
export type Day_Type_On_Conflict = {
  constraint: Day_Type_Constraint;
  update_columns?: Array<Day_Type_Update_Column>;
  where?: InputMaybe<Day_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "day_type". */
export type Day_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  order_scheduler_daily_frequencies_aggregate?: InputMaybe<Order_Scheduler_Daily_Frequency_Aggregate_Order_By>;
  organization_timings_aggregate?: InputMaybe<Organization_Timing_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: day_type */
export type Day_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "day_type" */
export enum Day_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "day_type" */
export type Day_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "day_type" */
export type Day_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Day_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Day_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "day_type" */
export enum Day_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Day_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Day_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Day_Type_Bool_Exp;
};

/** columns and relationships of "delayed_orders" */
export type Delayed_Orders = {
  __typename?: 'delayed_orders';
  actual_amount?: Maybe<Scalars['numeric']['output']>;
  actual_delivery_date?: Maybe<Scalars['timestamptz']['output']>;
  actual_qty?: Maybe<Scalars['numeric']['output']>;
  amount?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  customer_order?: Maybe<Customer_Order>;
  /** An array relationship */
  customer_order_item_cancellation_reasons: Array<Customer_Order_Item_Cancellation_Reasons>;
  /** An aggregate relationship */
  customer_order_item_cancellation_reasons_aggregate: Customer_Order_Item_Cancellation_Reasons_Aggregate;
  /** An array relationship */
  customer_order_item_comments: Array<Customer_Order_Item_Comments>;
  /** An aggregate relationship */
  customer_order_item_comments_aggregate: Customer_Order_Item_Comments_Aggregate;
  /** An array relationship */
  customer_order_item_commissions: Array<Customer_Order_Item_Commission>;
  /** An aggregate relationship */
  customer_order_item_commissions_aggregate: Customer_Order_Item_Commission_Aggregate;
  /** An array relationship */
  customer_order_item_etd_transactional_logs: Array<Customer_Order_Item_Etd_Transactional_Logs>;
  /** An aggregate relationship */
  customer_order_item_etd_transactional_logs_aggregate: Customer_Order_Item_Etd_Transactional_Logs_Aggregate;
  /** An array relationship */
  customer_order_item_partners: Array<Customer_Order_Item_Partner>;
  /** An aggregate relationship */
  customer_order_item_partners_aggregate: Customer_Order_Item_Partner_Aggregate;
  /** An array relationship */
  customer_order_item_safety_checklist_results: Array<Customer_Order_Item_Safety_Checklist_Results>;
  /** An aggregate relationship */
  customer_order_item_safety_checklist_results_aggregate: Customer_Order_Item_Safety_Checklist_Results_Aggregate;
  /** An object relationship */
  customer_order_item_state?: Maybe<Customer_Order_Item_State>;
  /** An array relationship */
  customer_order_item_stateflows: Array<Customer_Order_Item_Stateflow>;
  /** An aggregate relationship */
  customer_order_item_stateflows_aggregate: Customer_Order_Item_Stateflow_Aggregate;
  /** An array relationship */
  customer_order_item_test_categories: Array<Customer_Order_Item_Test_Category>;
  /** An aggregate relationship */
  customer_order_item_test_categories_aggregate: Customer_Order_Item_Test_Category_Aggregate;
  delivery_fee?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  discountTypeByDiscountType?: Maybe<Discount_Type>;
  discount_amount?: Maybe<Scalars['numeric']['output']>;
  discount_rate?: Maybe<Scalars['numeric']['output']>;
  discount_type?: Maybe<Scalars['String']['output']>;
  estimate_delivery_date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  invoiced_items: Array<Invoiced_Item>;
  /** An aggregate relationship */
  invoiced_items_aggregate: Invoiced_Item_Aggregate;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  is_b2b?: Maybe<Scalars['Boolean']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  order_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  partner?: Maybe<Partner>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  product_variation?: Maybe<Product_Variation>;
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  product_variation_partner_localities_slot?: Maybe<Product_Variation_Partner_Localities_Slots>;
  product_variation_partner_localities_slot_id?: Maybe<Scalars['uuid']['output']>;
  qty?: Maybe<Scalars['numeric']['output']>;
  service_tax?: Maybe<Scalars['numeric']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  task?: Maybe<Task>;
  task_id?: Maybe<Scalars['uuid']['output']>;
  tax?: Maybe<Scalars['numeric']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  unit_price?: Maybe<Scalars['numeric']['output']>;
  voucher_discount?: Maybe<Scalars['numeric']['output']>;
};


/** columns and relationships of "delayed_orders" */
export type Delayed_OrdersCustomer_Order_Item_Cancellation_ReasonsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Cancellation_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Cancellation_Reasons_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Cancellation_Reasons_Bool_Exp>;
};


/** columns and relationships of "delayed_orders" */
export type Delayed_OrdersCustomer_Order_Item_Cancellation_Reasons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Cancellation_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Cancellation_Reasons_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Cancellation_Reasons_Bool_Exp>;
};


/** columns and relationships of "delayed_orders" */
export type Delayed_OrdersCustomer_Order_Item_CommentsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Comments_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Comments_Bool_Exp>;
};


/** columns and relationships of "delayed_orders" */
export type Delayed_OrdersCustomer_Order_Item_Comments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Comments_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Comments_Bool_Exp>;
};


/** columns and relationships of "delayed_orders" */
export type Delayed_OrdersCustomer_Order_Item_CommissionsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Commission_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Commission_Bool_Exp>;
};


/** columns and relationships of "delayed_orders" */
export type Delayed_OrdersCustomer_Order_Item_Commissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Commission_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Commission_Bool_Exp>;
};


/** columns and relationships of "delayed_orders" */
export type Delayed_OrdersCustomer_Order_Item_Etd_Transactional_LogsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Etd_Transactional_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Etd_Transactional_Logs_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Etd_Transactional_Logs_Bool_Exp>;
};


/** columns and relationships of "delayed_orders" */
export type Delayed_OrdersCustomer_Order_Item_Etd_Transactional_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Etd_Transactional_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Etd_Transactional_Logs_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Etd_Transactional_Logs_Bool_Exp>;
};


/** columns and relationships of "delayed_orders" */
export type Delayed_OrdersCustomer_Order_Item_PartnersArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Partner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Partner_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Partner_Bool_Exp>;
};


/** columns and relationships of "delayed_orders" */
export type Delayed_OrdersCustomer_Order_Item_Partners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Partner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Partner_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Partner_Bool_Exp>;
};


/** columns and relationships of "delayed_orders" */
export type Delayed_OrdersCustomer_Order_Item_Safety_Checklist_ResultsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Safety_Checklist_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Safety_Checklist_Results_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Safety_Checklist_Results_Bool_Exp>;
};


/** columns and relationships of "delayed_orders" */
export type Delayed_OrdersCustomer_Order_Item_Safety_Checklist_Results_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Safety_Checklist_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Safety_Checklist_Results_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Safety_Checklist_Results_Bool_Exp>;
};


/** columns and relationships of "delayed_orders" */
export type Delayed_OrdersCustomer_Order_Item_StateflowsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Stateflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Stateflow_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Stateflow_Bool_Exp>;
};


/** columns and relationships of "delayed_orders" */
export type Delayed_OrdersCustomer_Order_Item_Stateflows_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Stateflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Stateflow_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Stateflow_Bool_Exp>;
};


/** columns and relationships of "delayed_orders" */
export type Delayed_OrdersCustomer_Order_Item_Test_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Test_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Test_Category_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Test_Category_Bool_Exp>;
};


/** columns and relationships of "delayed_orders" */
export type Delayed_OrdersCustomer_Order_Item_Test_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Test_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Test_Category_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Test_Category_Bool_Exp>;
};


/** columns and relationships of "delayed_orders" */
export type Delayed_OrdersInvoiced_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Bool_Exp>;
};


/** columns and relationships of "delayed_orders" */
export type Delayed_OrdersInvoiced_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Bool_Exp>;
};

/** aggregated selection of "delayed_orders" */
export type Delayed_Orders_Aggregate = {
  __typename?: 'delayed_orders_aggregate';
  aggregate?: Maybe<Delayed_Orders_Aggregate_Fields>;
  nodes: Array<Delayed_Orders>;
};

/** aggregate fields of "delayed_orders" */
export type Delayed_Orders_Aggregate_Fields = {
  __typename?: 'delayed_orders_aggregate_fields';
  avg?: Maybe<Delayed_Orders_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Delayed_Orders_Max_Fields>;
  min?: Maybe<Delayed_Orders_Min_Fields>;
  stddev?: Maybe<Delayed_Orders_Stddev_Fields>;
  stddev_pop?: Maybe<Delayed_Orders_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Delayed_Orders_Stddev_Samp_Fields>;
  sum?: Maybe<Delayed_Orders_Sum_Fields>;
  var_pop?: Maybe<Delayed_Orders_Var_Pop_Fields>;
  var_samp?: Maybe<Delayed_Orders_Var_Samp_Fields>;
  variance?: Maybe<Delayed_Orders_Variance_Fields>;
};


/** aggregate fields of "delayed_orders" */
export type Delayed_Orders_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Delayed_Orders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Delayed_Orders_Avg_Fields = {
  __typename?: 'delayed_orders_avg_fields';
  actual_amount?: Maybe<Scalars['Float']['output']>;
  actual_qty?: Maybe<Scalars['Float']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  delivery_fee?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  discount_rate?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  service_tax?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  unit_price?: Maybe<Scalars['Float']['output']>;
  voucher_discount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "delayed_orders". All fields are combined with a logical 'AND'. */
export type Delayed_Orders_Bool_Exp = {
  _and?: InputMaybe<Array<Delayed_Orders_Bool_Exp>>;
  _not?: InputMaybe<Delayed_Orders_Bool_Exp>;
  _or?: InputMaybe<Array<Delayed_Orders_Bool_Exp>>;
  actual_amount?: InputMaybe<Numeric_Comparison_Exp>;
  actual_delivery_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  actual_qty?: InputMaybe<Numeric_Comparison_Exp>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_order?: InputMaybe<Customer_Order_Bool_Exp>;
  customer_order_item_cancellation_reasons?: InputMaybe<Customer_Order_Item_Cancellation_Reasons_Bool_Exp>;
  customer_order_item_cancellation_reasons_aggregate?: InputMaybe<Customer_Order_Item_Cancellation_Reasons_Aggregate_Bool_Exp>;
  customer_order_item_comments?: InputMaybe<Customer_Order_Item_Comments_Bool_Exp>;
  customer_order_item_comments_aggregate?: InputMaybe<Customer_Order_Item_Comments_Aggregate_Bool_Exp>;
  customer_order_item_commissions?: InputMaybe<Customer_Order_Item_Commission_Bool_Exp>;
  customer_order_item_commissions_aggregate?: InputMaybe<Customer_Order_Item_Commission_Aggregate_Bool_Exp>;
  customer_order_item_etd_transactional_logs?: InputMaybe<Customer_Order_Item_Etd_Transactional_Logs_Bool_Exp>;
  customer_order_item_etd_transactional_logs_aggregate?: InputMaybe<Customer_Order_Item_Etd_Transactional_Logs_Aggregate_Bool_Exp>;
  customer_order_item_partners?: InputMaybe<Customer_Order_Item_Partner_Bool_Exp>;
  customer_order_item_partners_aggregate?: InputMaybe<Customer_Order_Item_Partner_Aggregate_Bool_Exp>;
  customer_order_item_safety_checklist_results?: InputMaybe<Customer_Order_Item_Safety_Checklist_Results_Bool_Exp>;
  customer_order_item_safety_checklist_results_aggregate?: InputMaybe<Customer_Order_Item_Safety_Checklist_Results_Aggregate_Bool_Exp>;
  customer_order_item_state?: InputMaybe<Customer_Order_Item_State_Bool_Exp>;
  customer_order_item_stateflows?: InputMaybe<Customer_Order_Item_Stateflow_Bool_Exp>;
  customer_order_item_stateflows_aggregate?: InputMaybe<Customer_Order_Item_Stateflow_Aggregate_Bool_Exp>;
  customer_order_item_test_categories?: InputMaybe<Customer_Order_Item_Test_Category_Bool_Exp>;
  customer_order_item_test_categories_aggregate?: InputMaybe<Customer_Order_Item_Test_Category_Aggregate_Bool_Exp>;
  delivery_fee?: InputMaybe<Numeric_Comparison_Exp>;
  discountTypeByDiscountType?: InputMaybe<Discount_Type_Bool_Exp>;
  discount_amount?: InputMaybe<Numeric_Comparison_Exp>;
  discount_rate?: InputMaybe<Numeric_Comparison_Exp>;
  discount_type?: InputMaybe<String_Comparison_Exp>;
  estimate_delivery_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invoiced_items?: InputMaybe<Invoiced_Item_Bool_Exp>;
  invoiced_items_aggregate?: InputMaybe<Invoiced_Item_Aggregate_Bool_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_b2b?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  order_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner?: InputMaybe<Partner_Bool_Exp>;
  partner_id?: InputMaybe<Uuid_Comparison_Exp>;
  product_variation?: InputMaybe<Product_Variation_Bool_Exp>;
  product_variation_id?: InputMaybe<Uuid_Comparison_Exp>;
  product_variation_partner_localities_slot?: InputMaybe<Product_Variation_Partner_Localities_Slots_Bool_Exp>;
  product_variation_partner_localities_slot_id?: InputMaybe<Uuid_Comparison_Exp>;
  qty?: InputMaybe<Numeric_Comparison_Exp>;
  service_tax?: InputMaybe<Numeric_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  task?: InputMaybe<Task_Bool_Exp>;
  task_id?: InputMaybe<Uuid_Comparison_Exp>;
  tax?: InputMaybe<Numeric_Comparison_Exp>;
  unit?: InputMaybe<String_Comparison_Exp>;
  unit_price?: InputMaybe<Numeric_Comparison_Exp>;
  voucher_discount?: InputMaybe<Numeric_Comparison_Exp>;
};

/** aggregate max on columns */
export type Delayed_Orders_Max_Fields = {
  __typename?: 'delayed_orders_max_fields';
  actual_amount?: Maybe<Scalars['numeric']['output']>;
  actual_delivery_date?: Maybe<Scalars['timestamptz']['output']>;
  actual_qty?: Maybe<Scalars['numeric']['output']>;
  amount?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  delivery_fee?: Maybe<Scalars['numeric']['output']>;
  discount_amount?: Maybe<Scalars['numeric']['output']>;
  discount_rate?: Maybe<Scalars['numeric']['output']>;
  discount_type?: Maybe<Scalars['String']['output']>;
  estimate_delivery_date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  order_id?: Maybe<Scalars['uuid']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
  product_variation_partner_localities_slot_id?: Maybe<Scalars['uuid']['output']>;
  qty?: Maybe<Scalars['numeric']['output']>;
  service_tax?: Maybe<Scalars['numeric']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  task_id?: Maybe<Scalars['uuid']['output']>;
  tax?: Maybe<Scalars['numeric']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  unit_price?: Maybe<Scalars['numeric']['output']>;
  voucher_discount?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type Delayed_Orders_Min_Fields = {
  __typename?: 'delayed_orders_min_fields';
  actual_amount?: Maybe<Scalars['numeric']['output']>;
  actual_delivery_date?: Maybe<Scalars['timestamptz']['output']>;
  actual_qty?: Maybe<Scalars['numeric']['output']>;
  amount?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  delivery_fee?: Maybe<Scalars['numeric']['output']>;
  discount_amount?: Maybe<Scalars['numeric']['output']>;
  discount_rate?: Maybe<Scalars['numeric']['output']>;
  discount_type?: Maybe<Scalars['String']['output']>;
  estimate_delivery_date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  order_id?: Maybe<Scalars['uuid']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
  product_variation_partner_localities_slot_id?: Maybe<Scalars['uuid']['output']>;
  qty?: Maybe<Scalars['numeric']['output']>;
  service_tax?: Maybe<Scalars['numeric']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  task_id?: Maybe<Scalars['uuid']['output']>;
  tax?: Maybe<Scalars['numeric']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  unit_price?: Maybe<Scalars['numeric']['output']>;
  voucher_discount?: Maybe<Scalars['numeric']['output']>;
};

/** Ordering options when selecting data from "delayed_orders". */
export type Delayed_Orders_Order_By = {
  actual_amount?: InputMaybe<Order_By>;
  actual_delivery_date?: InputMaybe<Order_By>;
  actual_qty?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_order?: InputMaybe<Customer_Order_Order_By>;
  customer_order_item_cancellation_reasons_aggregate?: InputMaybe<Customer_Order_Item_Cancellation_Reasons_Aggregate_Order_By>;
  customer_order_item_comments_aggregate?: InputMaybe<Customer_Order_Item_Comments_Aggregate_Order_By>;
  customer_order_item_commissions_aggregate?: InputMaybe<Customer_Order_Item_Commission_Aggregate_Order_By>;
  customer_order_item_etd_transactional_logs_aggregate?: InputMaybe<Customer_Order_Item_Etd_Transactional_Logs_Aggregate_Order_By>;
  customer_order_item_partners_aggregate?: InputMaybe<Customer_Order_Item_Partner_Aggregate_Order_By>;
  customer_order_item_safety_checklist_results_aggregate?: InputMaybe<Customer_Order_Item_Safety_Checklist_Results_Aggregate_Order_By>;
  customer_order_item_state?: InputMaybe<Customer_Order_Item_State_Order_By>;
  customer_order_item_stateflows_aggregate?: InputMaybe<Customer_Order_Item_Stateflow_Aggregate_Order_By>;
  customer_order_item_test_categories_aggregate?: InputMaybe<Customer_Order_Item_Test_Category_Aggregate_Order_By>;
  delivery_fee?: InputMaybe<Order_By>;
  discountTypeByDiscountType?: InputMaybe<Discount_Type_Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  discount_rate?: InputMaybe<Order_By>;
  discount_type?: InputMaybe<Order_By>;
  estimate_delivery_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoiced_items_aggregate?: InputMaybe<Invoiced_Item_Aggregate_Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_b2b?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  partner?: InputMaybe<Partner_Order_By>;
  partner_id?: InputMaybe<Order_By>;
  product_variation?: InputMaybe<Product_Variation_Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  product_variation_partner_localities_slot?: InputMaybe<Product_Variation_Partner_Localities_Slots_Order_By>;
  product_variation_partner_localities_slot_id?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  task?: InputMaybe<Task_Order_By>;
  task_id?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  unit?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
};

/** select columns of table "delayed_orders" */
export enum Delayed_Orders_Select_Column {
  /** column name */
  ActualAmount = 'actual_amount',
  /** column name */
  ActualDeliveryDate = 'actual_delivery_date',
  /** column name */
  ActualQty = 'actual_qty',
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeliveryFee = 'delivery_fee',
  /** column name */
  DiscountAmount = 'discount_amount',
  /** column name */
  DiscountRate = 'discount_rate',
  /** column name */
  DiscountType = 'discount_type',
  /** column name */
  EstimateDeliveryDate = 'estimate_delivery_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsB2b = 'is_b2b',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  ProductVariationId = 'product_variation_id',
  /** column name */
  ProductVariationPartnerLocalitiesSlotId = 'product_variation_partner_localities_slot_id',
  /** column name */
  Qty = 'qty',
  /** column name */
  ServiceTax = 'service_tax',
  /** column name */
  State = 'state',
  /** column name */
  TaskId = 'task_id',
  /** column name */
  Tax = 'tax',
  /** column name */
  Unit = 'unit',
  /** column name */
  UnitPrice = 'unit_price',
  /** column name */
  VoucherDiscount = 'voucher_discount'
}

/** aggregate stddev on columns */
export type Delayed_Orders_Stddev_Fields = {
  __typename?: 'delayed_orders_stddev_fields';
  actual_amount?: Maybe<Scalars['Float']['output']>;
  actual_qty?: Maybe<Scalars['Float']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  delivery_fee?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  discount_rate?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  service_tax?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  unit_price?: Maybe<Scalars['Float']['output']>;
  voucher_discount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Delayed_Orders_Stddev_Pop_Fields = {
  __typename?: 'delayed_orders_stddev_pop_fields';
  actual_amount?: Maybe<Scalars['Float']['output']>;
  actual_qty?: Maybe<Scalars['Float']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  delivery_fee?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  discount_rate?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  service_tax?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  unit_price?: Maybe<Scalars['Float']['output']>;
  voucher_discount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Delayed_Orders_Stddev_Samp_Fields = {
  __typename?: 'delayed_orders_stddev_samp_fields';
  actual_amount?: Maybe<Scalars['Float']['output']>;
  actual_qty?: Maybe<Scalars['Float']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  delivery_fee?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  discount_rate?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  service_tax?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  unit_price?: Maybe<Scalars['Float']['output']>;
  voucher_discount?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "delayed_orders" */
export type Delayed_Orders_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Delayed_Orders_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Delayed_Orders_Stream_Cursor_Value_Input = {
  actual_amount?: InputMaybe<Scalars['numeric']['input']>;
  actual_delivery_date?: InputMaybe<Scalars['timestamptz']['input']>;
  actual_qty?: InputMaybe<Scalars['numeric']['input']>;
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  delivery_fee?: InputMaybe<Scalars['numeric']['input']>;
  discount_amount?: InputMaybe<Scalars['numeric']['input']>;
  discount_rate?: InputMaybe<Scalars['numeric']['input']>;
  discount_type?: InputMaybe<Scalars['String']['input']>;
  estimate_delivery_date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_b2b?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  order_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  product_variation_partner_localities_slot_id?: InputMaybe<Scalars['uuid']['input']>;
  qty?: InputMaybe<Scalars['numeric']['input']>;
  service_tax?: InputMaybe<Scalars['numeric']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
  tax?: InputMaybe<Scalars['numeric']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  unit_price?: InputMaybe<Scalars['numeric']['input']>;
  voucher_discount?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Delayed_Orders_Sum_Fields = {
  __typename?: 'delayed_orders_sum_fields';
  actual_amount?: Maybe<Scalars['numeric']['output']>;
  actual_qty?: Maybe<Scalars['numeric']['output']>;
  amount?: Maybe<Scalars['numeric']['output']>;
  delivery_fee?: Maybe<Scalars['numeric']['output']>;
  discount_amount?: Maybe<Scalars['numeric']['output']>;
  discount_rate?: Maybe<Scalars['numeric']['output']>;
  qty?: Maybe<Scalars['numeric']['output']>;
  service_tax?: Maybe<Scalars['numeric']['output']>;
  tax?: Maybe<Scalars['numeric']['output']>;
  unit_price?: Maybe<Scalars['numeric']['output']>;
  voucher_discount?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate var_pop on columns */
export type Delayed_Orders_Var_Pop_Fields = {
  __typename?: 'delayed_orders_var_pop_fields';
  actual_amount?: Maybe<Scalars['Float']['output']>;
  actual_qty?: Maybe<Scalars['Float']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  delivery_fee?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  discount_rate?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  service_tax?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  unit_price?: Maybe<Scalars['Float']['output']>;
  voucher_discount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Delayed_Orders_Var_Samp_Fields = {
  __typename?: 'delayed_orders_var_samp_fields';
  actual_amount?: Maybe<Scalars['Float']['output']>;
  actual_qty?: Maybe<Scalars['Float']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  delivery_fee?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  discount_rate?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  service_tax?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  unit_price?: Maybe<Scalars['Float']['output']>;
  voucher_discount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Delayed_Orders_Variance_Fields = {
  __typename?: 'delayed_orders_variance_fields';
  actual_amount?: Maybe<Scalars['Float']['output']>;
  actual_qty?: Maybe<Scalars['Float']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  delivery_fee?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  discount_rate?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  service_tax?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  unit_price?: Maybe<Scalars['Float']['output']>;
  voucher_discount?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "delivery_preferences" */
export type Delivery_Preferences = {
  __typename?: 'delivery_preferences';
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  customer_orders: Array<Customer_Order>;
  /** An aggregate relationship */
  customer_orders_aggregate: Customer_Order_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "delivery_preferences" */
export type Delivery_PreferencesCustomer_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Order_By>>;
  where?: InputMaybe<Customer_Order_Bool_Exp>;
};


/** columns and relationships of "delivery_preferences" */
export type Delivery_PreferencesCustomer_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Order_By>>;
  where?: InputMaybe<Customer_Order_Bool_Exp>;
};

/** aggregated selection of "delivery_preferences" */
export type Delivery_Preferences_Aggregate = {
  __typename?: 'delivery_preferences_aggregate';
  aggregate?: Maybe<Delivery_Preferences_Aggregate_Fields>;
  nodes: Array<Delivery_Preferences>;
};

/** aggregate fields of "delivery_preferences" */
export type Delivery_Preferences_Aggregate_Fields = {
  __typename?: 'delivery_preferences_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Delivery_Preferences_Max_Fields>;
  min?: Maybe<Delivery_Preferences_Min_Fields>;
};


/** aggregate fields of "delivery_preferences" */
export type Delivery_Preferences_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Delivery_Preferences_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "delivery_preferences". All fields are combined with a logical 'AND'. */
export type Delivery_Preferences_Bool_Exp = {
  _and?: InputMaybe<Array<Delivery_Preferences_Bool_Exp>>;
  _not?: InputMaybe<Delivery_Preferences_Bool_Exp>;
  _or?: InputMaybe<Array<Delivery_Preferences_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  customer_orders?: InputMaybe<Customer_Order_Bool_Exp>;
  customer_orders_aggregate?: InputMaybe<Customer_Order_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "delivery_preferences" */
export enum Delivery_Preferences_Constraint {
  /** unique or primary key constraint on columns "value" */
  DeliveryPreferencesPkey = 'delivery_preferences_pkey'
}

export enum Delivery_Preferences_Enum {
  /** AFTERNOON */
  Afternoon = 'AFTERNOON',
  /** EVENING */
  Evening = 'EVENING',
  /** MORNING */
  Morning = 'MORNING',
  /** NIGHT */
  Night = 'NIGHT'
}

/** Boolean expression to compare columns of type "delivery_preferences_enum". All fields are combined with logical 'AND'. */
export type Delivery_Preferences_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Delivery_Preferences_Enum>;
  _in?: InputMaybe<Array<Delivery_Preferences_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Delivery_Preferences_Enum>;
  _nin?: InputMaybe<Array<Delivery_Preferences_Enum>>;
};

/** input type for inserting data into table "delivery_preferences" */
export type Delivery_Preferences_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  customer_orders?: InputMaybe<Customer_Order_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Delivery_Preferences_Max_Fields = {
  __typename?: 'delivery_preferences_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Delivery_Preferences_Min_Fields = {
  __typename?: 'delivery_preferences_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "delivery_preferences" */
export type Delivery_Preferences_Mutation_Response = {
  __typename?: 'delivery_preferences_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Delivery_Preferences>;
};

/** input type for inserting object relation for remote table "delivery_preferences" */
export type Delivery_Preferences_Obj_Rel_Insert_Input = {
  data: Delivery_Preferences_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Delivery_Preferences_On_Conflict>;
};

/** on_conflict condition type for table "delivery_preferences" */
export type Delivery_Preferences_On_Conflict = {
  constraint: Delivery_Preferences_Constraint;
  update_columns?: Array<Delivery_Preferences_Update_Column>;
  where?: InputMaybe<Delivery_Preferences_Bool_Exp>;
};

/** Ordering options when selecting data from "delivery_preferences". */
export type Delivery_Preferences_Order_By = {
  comment?: InputMaybe<Order_By>;
  customer_orders_aggregate?: InputMaybe<Customer_Order_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: delivery_preferences */
export type Delivery_Preferences_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "delivery_preferences" */
export enum Delivery_Preferences_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "delivery_preferences" */
export type Delivery_Preferences_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "delivery_preferences" */
export type Delivery_Preferences_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Delivery_Preferences_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Delivery_Preferences_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "delivery_preferences" */
export enum Delivery_Preferences_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Delivery_Preferences_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Delivery_Preferences_Set_Input>;
  /** filter the rows which have to be updated */
  where: Delivery_Preferences_Bool_Exp;
};

/** columns and relationships of "delivery_scheduler" */
export type Delivery_Scheduler = {
  __typename?: 'delivery_scheduler';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  delivery_scheduler_product_items: Array<Delivery_Scheduler_Product_Item>;
  /** An aggregate relationship */
  delivery_scheduler_product_items_aggregate: Delivery_Scheduler_Product_Item_Aggregate;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  organization_user: Organization_User;
  organization_user_id: Scalars['uuid']['output'];
  /** An object relationship */
  vehicle: Vehicle;
  vehicle_id: Scalars['uuid']['output'];
};


/** columns and relationships of "delivery_scheduler" */
export type Delivery_SchedulerDelivery_Scheduler_Product_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Delivery_Scheduler_Product_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delivery_Scheduler_Product_Item_Order_By>>;
  where?: InputMaybe<Delivery_Scheduler_Product_Item_Bool_Exp>;
};


/** columns and relationships of "delivery_scheduler" */
export type Delivery_SchedulerDelivery_Scheduler_Product_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Delivery_Scheduler_Product_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delivery_Scheduler_Product_Item_Order_By>>;
  where?: InputMaybe<Delivery_Scheduler_Product_Item_Bool_Exp>;
};

/** aggregated selection of "delivery_scheduler" */
export type Delivery_Scheduler_Aggregate = {
  __typename?: 'delivery_scheduler_aggregate';
  aggregate?: Maybe<Delivery_Scheduler_Aggregate_Fields>;
  nodes: Array<Delivery_Scheduler>;
};

export type Delivery_Scheduler_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Delivery_Scheduler_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Delivery_Scheduler_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Delivery_Scheduler_Aggregate_Bool_Exp_Count>;
};

export type Delivery_Scheduler_Aggregate_Bool_Exp_Bool_And = {
  arguments: Delivery_Scheduler_Select_Column_Delivery_Scheduler_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Delivery_Scheduler_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Delivery_Scheduler_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Delivery_Scheduler_Select_Column_Delivery_Scheduler_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Delivery_Scheduler_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Delivery_Scheduler_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Delivery_Scheduler_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Delivery_Scheduler_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "delivery_scheduler" */
export type Delivery_Scheduler_Aggregate_Fields = {
  __typename?: 'delivery_scheduler_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Delivery_Scheduler_Max_Fields>;
  min?: Maybe<Delivery_Scheduler_Min_Fields>;
};


/** aggregate fields of "delivery_scheduler" */
export type Delivery_Scheduler_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Delivery_Scheduler_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "delivery_scheduler" */
export type Delivery_Scheduler_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Delivery_Scheduler_Max_Order_By>;
  min?: InputMaybe<Delivery_Scheduler_Min_Order_By>;
};

/** input type for inserting array relation for remote table "delivery_scheduler" */
export type Delivery_Scheduler_Arr_Rel_Insert_Input = {
  data: Array<Delivery_Scheduler_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Delivery_Scheduler_On_Conflict>;
};

/** Boolean expression to filter rows from the table "delivery_scheduler". All fields are combined with a logical 'AND'. */
export type Delivery_Scheduler_Bool_Exp = {
  _and?: InputMaybe<Array<Delivery_Scheduler_Bool_Exp>>;
  _not?: InputMaybe<Delivery_Scheduler_Bool_Exp>;
  _or?: InputMaybe<Array<Delivery_Scheduler_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  delivery_scheduler_product_items?: InputMaybe<Delivery_Scheduler_Product_Item_Bool_Exp>;
  delivery_scheduler_product_items_aggregate?: InputMaybe<Delivery_Scheduler_Product_Item_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  organization_user?: InputMaybe<Organization_User_Bool_Exp>;
  organization_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  vehicle?: InputMaybe<Vehicle_Bool_Exp>;
  vehicle_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "delivery_scheduler" */
export enum Delivery_Scheduler_Constraint {
  /** unique or primary key constraint on columns "id" */
  DeliverySchedulerPkey = 'delivery_scheduler_pkey'
}

/** input type for inserting data into table "delivery_scheduler" */
export type Delivery_Scheduler_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  delivery_scheduler_product_items?: InputMaybe<Delivery_Scheduler_Product_Item_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_user?: InputMaybe<Organization_User_Obj_Rel_Insert_Input>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  vehicle?: InputMaybe<Vehicle_Obj_Rel_Insert_Input>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Delivery_Scheduler_Max_Fields = {
  __typename?: 'delivery_scheduler_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  organization_user_id?: Maybe<Scalars['uuid']['output']>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "delivery_scheduler" */
export type Delivery_Scheduler_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Delivery_Scheduler_Min_Fields = {
  __typename?: 'delivery_scheduler_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  organization_user_id?: Maybe<Scalars['uuid']['output']>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "delivery_scheduler" */
export type Delivery_Scheduler_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "delivery_scheduler" */
export type Delivery_Scheduler_Mutation_Response = {
  __typename?: 'delivery_scheduler_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Delivery_Scheduler>;
};

/** input type for inserting object relation for remote table "delivery_scheduler" */
export type Delivery_Scheduler_Obj_Rel_Insert_Input = {
  data: Delivery_Scheduler_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Delivery_Scheduler_On_Conflict>;
};

/** on_conflict condition type for table "delivery_scheduler" */
export type Delivery_Scheduler_On_Conflict = {
  constraint: Delivery_Scheduler_Constraint;
  update_columns?: Array<Delivery_Scheduler_Update_Column>;
  where?: InputMaybe<Delivery_Scheduler_Bool_Exp>;
};

/** Ordering options when selecting data from "delivery_scheduler". */
export type Delivery_Scheduler_Order_By = {
  created_at?: InputMaybe<Order_By>;
  delivery_scheduler_product_items_aggregate?: InputMaybe<Delivery_Scheduler_Product_Item_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_user?: InputMaybe<Organization_User_Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
  vehicle?: InputMaybe<Vehicle_Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: delivery_scheduler */
export type Delivery_Scheduler_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "delivery_scheduler_product_item" */
export type Delivery_Scheduler_Product_Item = {
  __typename?: 'delivery_scheduler_product_item';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  delivery_scheduler: Delivery_Scheduler;
  delivery_scheduler_id: Scalars['uuid']['output'];
  end_date?: Maybe<Scalars['timestamp']['output']>;
  frequency?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  start_date?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregated selection of "delivery_scheduler_product_item" */
export type Delivery_Scheduler_Product_Item_Aggregate = {
  __typename?: 'delivery_scheduler_product_item_aggregate';
  aggregate?: Maybe<Delivery_Scheduler_Product_Item_Aggregate_Fields>;
  nodes: Array<Delivery_Scheduler_Product_Item>;
};

export type Delivery_Scheduler_Product_Item_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Delivery_Scheduler_Product_Item_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Delivery_Scheduler_Product_Item_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Delivery_Scheduler_Product_Item_Aggregate_Bool_Exp_Count>;
};

export type Delivery_Scheduler_Product_Item_Aggregate_Bool_Exp_Bool_And = {
  arguments: Delivery_Scheduler_Product_Item_Select_Column_Delivery_Scheduler_Product_Item_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Delivery_Scheduler_Product_Item_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Delivery_Scheduler_Product_Item_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Delivery_Scheduler_Product_Item_Select_Column_Delivery_Scheduler_Product_Item_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Delivery_Scheduler_Product_Item_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Delivery_Scheduler_Product_Item_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Delivery_Scheduler_Product_Item_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Delivery_Scheduler_Product_Item_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "delivery_scheduler_product_item" */
export type Delivery_Scheduler_Product_Item_Aggregate_Fields = {
  __typename?: 'delivery_scheduler_product_item_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Delivery_Scheduler_Product_Item_Max_Fields>;
  min?: Maybe<Delivery_Scheduler_Product_Item_Min_Fields>;
};


/** aggregate fields of "delivery_scheduler_product_item" */
export type Delivery_Scheduler_Product_Item_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Delivery_Scheduler_Product_Item_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "delivery_scheduler_product_item" */
export type Delivery_Scheduler_Product_Item_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Delivery_Scheduler_Product_Item_Max_Order_By>;
  min?: InputMaybe<Delivery_Scheduler_Product_Item_Min_Order_By>;
};

/** input type for inserting array relation for remote table "delivery_scheduler_product_item" */
export type Delivery_Scheduler_Product_Item_Arr_Rel_Insert_Input = {
  data: Array<Delivery_Scheduler_Product_Item_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Delivery_Scheduler_Product_Item_On_Conflict>;
};

/** Boolean expression to filter rows from the table "delivery_scheduler_product_item". All fields are combined with a logical 'AND'. */
export type Delivery_Scheduler_Product_Item_Bool_Exp = {
  _and?: InputMaybe<Array<Delivery_Scheduler_Product_Item_Bool_Exp>>;
  _not?: InputMaybe<Delivery_Scheduler_Product_Item_Bool_Exp>;
  _or?: InputMaybe<Array<Delivery_Scheduler_Product_Item_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  delivery_scheduler?: InputMaybe<Delivery_Scheduler_Bool_Exp>;
  delivery_scheduler_id?: InputMaybe<Uuid_Comparison_Exp>;
  end_date?: InputMaybe<Timestamp_Comparison_Exp>;
  frequency?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  start_date?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "delivery_scheduler_product_item" */
export enum Delivery_Scheduler_Product_Item_Constraint {
  /** unique or primary key constraint on columns "id" */
  DeliverySchedulerProductItemPkey = 'delivery_scheduler_product_item_pkey'
}

/** input type for inserting data into table "delivery_scheduler_product_item" */
export type Delivery_Scheduler_Product_Item_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  delivery_scheduler?: InputMaybe<Delivery_Scheduler_Obj_Rel_Insert_Input>;
  delivery_scheduler_id?: InputMaybe<Scalars['uuid']['input']>;
  end_date?: InputMaybe<Scalars['timestamp']['input']>;
  frequency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  start_date?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Delivery_Scheduler_Product_Item_Max_Fields = {
  __typename?: 'delivery_scheduler_product_item_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  delivery_scheduler_id?: Maybe<Scalars['uuid']['output']>;
  end_date?: Maybe<Scalars['timestamp']['output']>;
  frequency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  start_date?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "delivery_scheduler_product_item" */
export type Delivery_Scheduler_Product_Item_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  delivery_scheduler_id?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Delivery_Scheduler_Product_Item_Min_Fields = {
  __typename?: 'delivery_scheduler_product_item_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  delivery_scheduler_id?: Maybe<Scalars['uuid']['output']>;
  end_date?: Maybe<Scalars['timestamp']['output']>;
  frequency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  start_date?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "delivery_scheduler_product_item" */
export type Delivery_Scheduler_Product_Item_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  delivery_scheduler_id?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "delivery_scheduler_product_item" */
export type Delivery_Scheduler_Product_Item_Mutation_Response = {
  __typename?: 'delivery_scheduler_product_item_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Delivery_Scheduler_Product_Item>;
};

/** on_conflict condition type for table "delivery_scheduler_product_item" */
export type Delivery_Scheduler_Product_Item_On_Conflict = {
  constraint: Delivery_Scheduler_Product_Item_Constraint;
  update_columns?: Array<Delivery_Scheduler_Product_Item_Update_Column>;
  where?: InputMaybe<Delivery_Scheduler_Product_Item_Bool_Exp>;
};

/** Ordering options when selecting data from "delivery_scheduler_product_item". */
export type Delivery_Scheduler_Product_Item_Order_By = {
  created_at?: InputMaybe<Order_By>;
  delivery_scheduler?: InputMaybe<Delivery_Scheduler_Order_By>;
  delivery_scheduler_id?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
};

/** primary key columns input for table: delivery_scheduler_product_item */
export type Delivery_Scheduler_Product_Item_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "delivery_scheduler_product_item" */
export enum Delivery_Scheduler_Product_Item_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeliverySchedulerId = 'delivery_scheduler_id',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  StartDate = 'start_date'
}

/** select "delivery_scheduler_product_item_aggregate_bool_exp_bool_and_arguments_columns" columns of table "delivery_scheduler_product_item" */
export enum Delivery_Scheduler_Product_Item_Select_Column_Delivery_Scheduler_Product_Item_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "delivery_scheduler_product_item_aggregate_bool_exp_bool_or_arguments_columns" columns of table "delivery_scheduler_product_item" */
export enum Delivery_Scheduler_Product_Item_Select_Column_Delivery_Scheduler_Product_Item_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "delivery_scheduler_product_item" */
export type Delivery_Scheduler_Product_Item_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  delivery_scheduler_id?: InputMaybe<Scalars['uuid']['input']>;
  end_date?: InputMaybe<Scalars['timestamp']['input']>;
  frequency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  start_date?: InputMaybe<Scalars['timestamp']['input']>;
};

/** Streaming cursor of the table "delivery_scheduler_product_item" */
export type Delivery_Scheduler_Product_Item_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Delivery_Scheduler_Product_Item_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Delivery_Scheduler_Product_Item_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  delivery_scheduler_id?: InputMaybe<Scalars['uuid']['input']>;
  end_date?: InputMaybe<Scalars['timestamp']['input']>;
  frequency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  start_date?: InputMaybe<Scalars['timestamp']['input']>;
};

/** update columns of table "delivery_scheduler_product_item" */
export enum Delivery_Scheduler_Product_Item_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeliverySchedulerId = 'delivery_scheduler_id',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  StartDate = 'start_date'
}

export type Delivery_Scheduler_Product_Item_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Delivery_Scheduler_Product_Item_Set_Input>;
  /** filter the rows which have to be updated */
  where: Delivery_Scheduler_Product_Item_Bool_Exp;
};

/** select columns of table "delivery_scheduler" */
export enum Delivery_Scheduler_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrganizationUserId = 'organization_user_id',
  /** column name */
  VehicleId = 'vehicle_id'
}

/** select "delivery_scheduler_aggregate_bool_exp_bool_and_arguments_columns" columns of table "delivery_scheduler" */
export enum Delivery_Scheduler_Select_Column_Delivery_Scheduler_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "delivery_scheduler_aggregate_bool_exp_bool_or_arguments_columns" columns of table "delivery_scheduler" */
export enum Delivery_Scheduler_Select_Column_Delivery_Scheduler_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "delivery_scheduler" */
export type Delivery_Scheduler_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "delivery_scheduler" */
export type Delivery_Scheduler_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Delivery_Scheduler_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Delivery_Scheduler_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "delivery_scheduler" */
export enum Delivery_Scheduler_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrganizationUserId = 'organization_user_id',
  /** column name */
  VehicleId = 'vehicle_id'
}

export type Delivery_Scheduler_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Delivery_Scheduler_Set_Input>;
  /** filter the rows which have to be updated */
  where: Delivery_Scheduler_Bool_Exp;
};

/** IDEV-2805: retrospective department-shift re-tag job queue. INSERT triggers a Hasura event routed (via hasura-workflows) to the Temporal RetagDeliveryNotesWorkflow, which re-tags affected delivery notes. entity_type asset|address selects the dimension; status PENDING|RUNNING|COMPLETED|FAILED tracks the workflow. */
export type Department_Retag_Request = {
  __typename?: 'department_retag_request';
  attempts: Scalars['Int']['output'];
  created_at: Scalars['timestamptz']['output'];
  effective_from: Scalars['timestamptz']['output'];
  entity_id: Scalars['uuid']['output'];
  entity_type: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  last_error?: Maybe<Scalars['String']['output']>;
  last_modified: Scalars['timestamptz']['output'];
  organization_id?: Maybe<Scalars['uuid']['output']>;
  requested_by?: Maybe<Scalars['uuid']['output']>;
  status: Scalars['String']['output'];
  /** An object relationship */
  subsidiary: Subsidiary;
  subsidiary_id: Scalars['uuid']['output'];
  workflow_id?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "department_retag_request" */
export type Department_Retag_Request_Aggregate = {
  __typename?: 'department_retag_request_aggregate';
  aggregate?: Maybe<Department_Retag_Request_Aggregate_Fields>;
  nodes: Array<Department_Retag_Request>;
};

export type Department_Retag_Request_Aggregate_Bool_Exp = {
  count?: InputMaybe<Department_Retag_Request_Aggregate_Bool_Exp_Count>;
};

export type Department_Retag_Request_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Department_Retag_Request_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Department_Retag_Request_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "department_retag_request" */
export type Department_Retag_Request_Aggregate_Fields = {
  __typename?: 'department_retag_request_aggregate_fields';
  avg?: Maybe<Department_Retag_Request_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Department_Retag_Request_Max_Fields>;
  min?: Maybe<Department_Retag_Request_Min_Fields>;
  stddev?: Maybe<Department_Retag_Request_Stddev_Fields>;
  stddev_pop?: Maybe<Department_Retag_Request_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Department_Retag_Request_Stddev_Samp_Fields>;
  sum?: Maybe<Department_Retag_Request_Sum_Fields>;
  var_pop?: Maybe<Department_Retag_Request_Var_Pop_Fields>;
  var_samp?: Maybe<Department_Retag_Request_Var_Samp_Fields>;
  variance?: Maybe<Department_Retag_Request_Variance_Fields>;
};


/** aggregate fields of "department_retag_request" */
export type Department_Retag_Request_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Department_Retag_Request_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "department_retag_request" */
export type Department_Retag_Request_Aggregate_Order_By = {
  avg?: InputMaybe<Department_Retag_Request_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Department_Retag_Request_Max_Order_By>;
  min?: InputMaybe<Department_Retag_Request_Min_Order_By>;
  stddev?: InputMaybe<Department_Retag_Request_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Department_Retag_Request_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Department_Retag_Request_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Department_Retag_Request_Sum_Order_By>;
  var_pop?: InputMaybe<Department_Retag_Request_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Department_Retag_Request_Var_Samp_Order_By>;
  variance?: InputMaybe<Department_Retag_Request_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "department_retag_request" */
export type Department_Retag_Request_Arr_Rel_Insert_Input = {
  data: Array<Department_Retag_Request_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Department_Retag_Request_On_Conflict>;
};

/** aggregate avg on columns */
export type Department_Retag_Request_Avg_Fields = {
  __typename?: 'department_retag_request_avg_fields';
  attempts?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "department_retag_request" */
export type Department_Retag_Request_Avg_Order_By = {
  attempts?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "department_retag_request". All fields are combined with a logical 'AND'. */
export type Department_Retag_Request_Bool_Exp = {
  _and?: InputMaybe<Array<Department_Retag_Request_Bool_Exp>>;
  _not?: InputMaybe<Department_Retag_Request_Bool_Exp>;
  _or?: InputMaybe<Array<Department_Retag_Request_Bool_Exp>>;
  attempts?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  effective_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  entity_id?: InputMaybe<Uuid_Comparison_Exp>;
  entity_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_error?: InputMaybe<String_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamptz_Comparison_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  requested_by?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  subsidiary?: InputMaybe<Subsidiary_Bool_Exp>;
  subsidiary_id?: InputMaybe<Uuid_Comparison_Exp>;
  workflow_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "department_retag_request" */
export enum Department_Retag_Request_Constraint {
  /** unique or primary key constraint on columns "id" */
  DepartmentRetagRequestPkey = 'department_retag_request_pkey'
}

/** input type for incrementing numeric columns in table "department_retag_request" */
export type Department_Retag_Request_Inc_Input = {
  attempts?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "department_retag_request" */
export type Department_Retag_Request_Insert_Input = {
  attempts?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  effective_from?: InputMaybe<Scalars['timestamptz']['input']>;
  entity_id?: InputMaybe<Scalars['uuid']['input']>;
  entity_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_error?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  requested_by?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subsidiary?: InputMaybe<Subsidiary_Obj_Rel_Insert_Input>;
  subsidiary_id?: InputMaybe<Scalars['uuid']['input']>;
  workflow_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Department_Retag_Request_Max_Fields = {
  __typename?: 'department_retag_request_max_fields';
  attempts?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  effective_from?: Maybe<Scalars['timestamptz']['output']>;
  entity_id?: Maybe<Scalars['uuid']['output']>;
  entity_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_error?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  requested_by?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subsidiary_id?: Maybe<Scalars['uuid']['output']>;
  workflow_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "department_retag_request" */
export type Department_Retag_Request_Max_Order_By = {
  attempts?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  effective_from?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  entity_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_error?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  requested_by?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  subsidiary_id?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Department_Retag_Request_Min_Fields = {
  __typename?: 'department_retag_request_min_fields';
  attempts?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  effective_from?: Maybe<Scalars['timestamptz']['output']>;
  entity_id?: Maybe<Scalars['uuid']['output']>;
  entity_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_error?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  requested_by?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subsidiary_id?: Maybe<Scalars['uuid']['output']>;
  workflow_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "department_retag_request" */
export type Department_Retag_Request_Min_Order_By = {
  attempts?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  effective_from?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  entity_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_error?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  requested_by?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  subsidiary_id?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "department_retag_request" */
export type Department_Retag_Request_Mutation_Response = {
  __typename?: 'department_retag_request_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Department_Retag_Request>;
};

/** on_conflict condition type for table "department_retag_request" */
export type Department_Retag_Request_On_Conflict = {
  constraint: Department_Retag_Request_Constraint;
  update_columns?: Array<Department_Retag_Request_Update_Column>;
  where?: InputMaybe<Department_Retag_Request_Bool_Exp>;
};

/** Ordering options when selecting data from "department_retag_request". */
export type Department_Retag_Request_Order_By = {
  attempts?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  effective_from?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  entity_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_error?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  requested_by?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  subsidiary?: InputMaybe<Subsidiary_Order_By>;
  subsidiary_id?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: department_retag_request */
export type Department_Retag_Request_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "department_retag_request" */
export enum Department_Retag_Request_Select_Column {
  /** column name */
  Attempts = 'attempts',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EffectiveFrom = 'effective_from',
  /** column name */
  EntityId = 'entity_id',
  /** column name */
  EntityType = 'entity_type',
  /** column name */
  Id = 'id',
  /** column name */
  LastError = 'last_error',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  RequestedBy = 'requested_by',
  /** column name */
  Status = 'status',
  /** column name */
  SubsidiaryId = 'subsidiary_id',
  /** column name */
  WorkflowId = 'workflow_id'
}

/** input type for updating data in table "department_retag_request" */
export type Department_Retag_Request_Set_Input = {
  attempts?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  effective_from?: InputMaybe<Scalars['timestamptz']['input']>;
  entity_id?: InputMaybe<Scalars['uuid']['input']>;
  entity_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_error?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  requested_by?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subsidiary_id?: InputMaybe<Scalars['uuid']['input']>;
  workflow_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Department_Retag_Request_Stddev_Fields = {
  __typename?: 'department_retag_request_stddev_fields';
  attempts?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "department_retag_request" */
export type Department_Retag_Request_Stddev_Order_By = {
  attempts?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Department_Retag_Request_Stddev_Pop_Fields = {
  __typename?: 'department_retag_request_stddev_pop_fields';
  attempts?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "department_retag_request" */
export type Department_Retag_Request_Stddev_Pop_Order_By = {
  attempts?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Department_Retag_Request_Stddev_Samp_Fields = {
  __typename?: 'department_retag_request_stddev_samp_fields';
  attempts?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "department_retag_request" */
export type Department_Retag_Request_Stddev_Samp_Order_By = {
  attempts?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "department_retag_request" */
export type Department_Retag_Request_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Department_Retag_Request_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Department_Retag_Request_Stream_Cursor_Value_Input = {
  attempts?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  effective_from?: InputMaybe<Scalars['timestamptz']['input']>;
  entity_id?: InputMaybe<Scalars['uuid']['input']>;
  entity_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_error?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  requested_by?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subsidiary_id?: InputMaybe<Scalars['uuid']['input']>;
  workflow_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Department_Retag_Request_Sum_Fields = {
  __typename?: 'department_retag_request_sum_fields';
  attempts?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "department_retag_request" */
export type Department_Retag_Request_Sum_Order_By = {
  attempts?: InputMaybe<Order_By>;
};

/** update columns of table "department_retag_request" */
export enum Department_Retag_Request_Update_Column {
  /** column name */
  Attempts = 'attempts',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EffectiveFrom = 'effective_from',
  /** column name */
  EntityId = 'entity_id',
  /** column name */
  EntityType = 'entity_type',
  /** column name */
  Id = 'id',
  /** column name */
  LastError = 'last_error',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  RequestedBy = 'requested_by',
  /** column name */
  Status = 'status',
  /** column name */
  SubsidiaryId = 'subsidiary_id',
  /** column name */
  WorkflowId = 'workflow_id'
}

export type Department_Retag_Request_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Department_Retag_Request_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Department_Retag_Request_Set_Input>;
  /** filter the rows which have to be updated */
  where: Department_Retag_Request_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Department_Retag_Request_Var_Pop_Fields = {
  __typename?: 'department_retag_request_var_pop_fields';
  attempts?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "department_retag_request" */
export type Department_Retag_Request_Var_Pop_Order_By = {
  attempts?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Department_Retag_Request_Var_Samp_Fields = {
  __typename?: 'department_retag_request_var_samp_fields';
  attempts?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "department_retag_request" */
export type Department_Retag_Request_Var_Samp_Order_By = {
  attempts?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Department_Retag_Request_Variance_Fields = {
  __typename?: 'department_retag_request_variance_fields';
  attempts?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "department_retag_request" */
export type Department_Retag_Request_Variance_Order_By = {
  attempts?: InputMaybe<Order_By>;
};

/** columns and relationships of "device_devicetype_paramerter_definition" */
export type Device_Devicetype_Paramerter_Definition = {
  __typename?: 'device_devicetype_paramerter_definition';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  devicetype: Devicetype;
  devicetype_id: Scalars['uuid']['output'];
  /** An object relationship */
  devicetype_paramerter_definition: Devicetype_Paramerter_Definition;
  devicetype_paramerter_definition_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "device_devicetype_paramerter_definition" */
export type Device_Devicetype_Paramerter_Definition_Aggregate = {
  __typename?: 'device_devicetype_paramerter_definition_aggregate';
  aggregate?: Maybe<Device_Devicetype_Paramerter_Definition_Aggregate_Fields>;
  nodes: Array<Device_Devicetype_Paramerter_Definition>;
};

export type Device_Devicetype_Paramerter_Definition_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Device_Devicetype_Paramerter_Definition_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Device_Devicetype_Paramerter_Definition_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Device_Devicetype_Paramerter_Definition_Aggregate_Bool_Exp_Count>;
};

export type Device_Devicetype_Paramerter_Definition_Aggregate_Bool_Exp_Bool_And = {
  arguments: Device_Devicetype_Paramerter_Definition_Select_Column_Device_Devicetype_Paramerter_Definition_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Device_Devicetype_Paramerter_Definition_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Device_Devicetype_Paramerter_Definition_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Device_Devicetype_Paramerter_Definition_Select_Column_Device_Devicetype_Paramerter_Definition_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Device_Devicetype_Paramerter_Definition_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Device_Devicetype_Paramerter_Definition_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Device_Devicetype_Paramerter_Definition_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Device_Devicetype_Paramerter_Definition_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "device_devicetype_paramerter_definition" */
export type Device_Devicetype_Paramerter_Definition_Aggregate_Fields = {
  __typename?: 'device_devicetype_paramerter_definition_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Device_Devicetype_Paramerter_Definition_Max_Fields>;
  min?: Maybe<Device_Devicetype_Paramerter_Definition_Min_Fields>;
};


/** aggregate fields of "device_devicetype_paramerter_definition" */
export type Device_Devicetype_Paramerter_Definition_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Device_Devicetype_Paramerter_Definition_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "device_devicetype_paramerter_definition" */
export type Device_Devicetype_Paramerter_Definition_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Device_Devicetype_Paramerter_Definition_Max_Order_By>;
  min?: InputMaybe<Device_Devicetype_Paramerter_Definition_Min_Order_By>;
};

/** input type for inserting array relation for remote table "device_devicetype_paramerter_definition" */
export type Device_Devicetype_Paramerter_Definition_Arr_Rel_Insert_Input = {
  data: Array<Device_Devicetype_Paramerter_Definition_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Device_Devicetype_Paramerter_Definition_On_Conflict>;
};

/** Boolean expression to filter rows from the table "device_devicetype_paramerter_definition". All fields are combined with a logical 'AND'. */
export type Device_Devicetype_Paramerter_Definition_Bool_Exp = {
  _and?: InputMaybe<Array<Device_Devicetype_Paramerter_Definition_Bool_Exp>>;
  _not?: InputMaybe<Device_Devicetype_Paramerter_Definition_Bool_Exp>;
  _or?: InputMaybe<Array<Device_Devicetype_Paramerter_Definition_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  devicetype?: InputMaybe<Devicetype_Bool_Exp>;
  devicetype_id?: InputMaybe<Uuid_Comparison_Exp>;
  devicetype_paramerter_definition?: InputMaybe<Devicetype_Paramerter_Definition_Bool_Exp>;
  devicetype_paramerter_definition_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "device_devicetype_paramerter_definition" */
export enum Device_Devicetype_Paramerter_Definition_Constraint {
  /** unique or primary key constraint on columns "id" */
  DeviceDevicetypeParamerterDefinitionPkey = 'device_devicetype_paramerter_definition_pkey'
}

/** input type for inserting data into table "device_devicetype_paramerter_definition" */
export type Device_Devicetype_Paramerter_Definition_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  devicetype?: InputMaybe<Devicetype_Obj_Rel_Insert_Input>;
  devicetype_id?: InputMaybe<Scalars['uuid']['input']>;
  devicetype_paramerter_definition?: InputMaybe<Devicetype_Paramerter_Definition_Obj_Rel_Insert_Input>;
  devicetype_paramerter_definition_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Device_Devicetype_Paramerter_Definition_Max_Fields = {
  __typename?: 'device_devicetype_paramerter_definition_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  devicetype_id?: Maybe<Scalars['uuid']['output']>;
  devicetype_paramerter_definition_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "device_devicetype_paramerter_definition" */
export type Device_Devicetype_Paramerter_Definition_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  devicetype_id?: InputMaybe<Order_By>;
  devicetype_paramerter_definition_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Device_Devicetype_Paramerter_Definition_Min_Fields = {
  __typename?: 'device_devicetype_paramerter_definition_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  devicetype_id?: Maybe<Scalars['uuid']['output']>;
  devicetype_paramerter_definition_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "device_devicetype_paramerter_definition" */
export type Device_Devicetype_Paramerter_Definition_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  devicetype_id?: InputMaybe<Order_By>;
  devicetype_paramerter_definition_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "device_devicetype_paramerter_definition" */
export type Device_Devicetype_Paramerter_Definition_Mutation_Response = {
  __typename?: 'device_devicetype_paramerter_definition_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Device_Devicetype_Paramerter_Definition>;
};

/** on_conflict condition type for table "device_devicetype_paramerter_definition" */
export type Device_Devicetype_Paramerter_Definition_On_Conflict = {
  constraint: Device_Devicetype_Paramerter_Definition_Constraint;
  update_columns?: Array<Device_Devicetype_Paramerter_Definition_Update_Column>;
  where?: InputMaybe<Device_Devicetype_Paramerter_Definition_Bool_Exp>;
};

/** Ordering options when selecting data from "device_devicetype_paramerter_definition". */
export type Device_Devicetype_Paramerter_Definition_Order_By = {
  created_at?: InputMaybe<Order_By>;
  devicetype?: InputMaybe<Devicetype_Order_By>;
  devicetype_id?: InputMaybe<Order_By>;
  devicetype_paramerter_definition?: InputMaybe<Devicetype_Paramerter_Definition_Order_By>;
  devicetype_paramerter_definition_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: device_devicetype_paramerter_definition */
export type Device_Devicetype_Paramerter_Definition_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "device_devicetype_paramerter_definition" */
export enum Device_Devicetype_Paramerter_Definition_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DevicetypeId = 'devicetype_id',
  /** column name */
  DevicetypeParamerterDefinitionId = 'devicetype_paramerter_definition_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by'
}

/** select "device_devicetype_paramerter_definition_aggregate_bool_exp_bool_and_arguments_columns" columns of table "device_devicetype_paramerter_definition" */
export enum Device_Devicetype_Paramerter_Definition_Select_Column_Device_Devicetype_Paramerter_Definition_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "device_devicetype_paramerter_definition_aggregate_bool_exp_bool_or_arguments_columns" columns of table "device_devicetype_paramerter_definition" */
export enum Device_Devicetype_Paramerter_Definition_Select_Column_Device_Devicetype_Paramerter_Definition_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "device_devicetype_paramerter_definition" */
export type Device_Devicetype_Paramerter_Definition_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  devicetype_id?: InputMaybe<Scalars['uuid']['input']>;
  devicetype_paramerter_definition_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "device_devicetype_paramerter_definition" */
export type Device_Devicetype_Paramerter_Definition_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Device_Devicetype_Paramerter_Definition_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Device_Devicetype_Paramerter_Definition_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  devicetype_id?: InputMaybe<Scalars['uuid']['input']>;
  devicetype_paramerter_definition_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "device_devicetype_paramerter_definition" */
export enum Device_Devicetype_Paramerter_Definition_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DevicetypeId = 'devicetype_id',
  /** column name */
  DevicetypeParamerterDefinitionId = 'devicetype_paramerter_definition_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by'
}

export type Device_Devicetype_Paramerter_Definition_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Device_Devicetype_Paramerter_Definition_Set_Input>;
  /** filter the rows which have to be updated */
  where: Device_Devicetype_Paramerter_Definition_Bool_Exp;
};

/** columns and relationships of "devicetype" */
export type Devicetype = {
  __typename?: 'devicetype';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  customer_asset_devices: Array<Customer_Asset_Device>;
  /** An aggregate relationship */
  customer_asset_devices_aggregate: Customer_Asset_Device_Aggregate;
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  device_devicetype_paramerter_definitions: Array<Device_Devicetype_Paramerter_Definition>;
  /** An aggregate relationship */
  device_devicetype_paramerter_definitions_aggregate: Device_Devicetype_Paramerter_Definition_Aggregate;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name: Scalars['String']['output'];
  sku: Scalars['String']['output'];
  /** An array relationship */
  vehicle_devices: Array<Vehicle_Device>;
  /** An aggregate relationship */
  vehicle_devices_aggregate: Vehicle_Device_Aggregate;
};


/** columns and relationships of "devicetype" */
export type DevicetypeCustomer_Asset_DevicesArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Device_Order_By>>;
  where?: InputMaybe<Customer_Asset_Device_Bool_Exp>;
};


/** columns and relationships of "devicetype" */
export type DevicetypeCustomer_Asset_Devices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Device_Order_By>>;
  where?: InputMaybe<Customer_Asset_Device_Bool_Exp>;
};


/** columns and relationships of "devicetype" */
export type DevicetypeDevice_Devicetype_Paramerter_DefinitionsArgs = {
  distinct_on?: InputMaybe<Array<Device_Devicetype_Paramerter_Definition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Device_Devicetype_Paramerter_Definition_Order_By>>;
  where?: InputMaybe<Device_Devicetype_Paramerter_Definition_Bool_Exp>;
};


/** columns and relationships of "devicetype" */
export type DevicetypeDevice_Devicetype_Paramerter_Definitions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Device_Devicetype_Paramerter_Definition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Device_Devicetype_Paramerter_Definition_Order_By>>;
  where?: InputMaybe<Device_Devicetype_Paramerter_Definition_Bool_Exp>;
};


/** columns and relationships of "devicetype" */
export type DevicetypeVehicle_DevicesArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Device_Order_By>>;
  where?: InputMaybe<Vehicle_Device_Bool_Exp>;
};


/** columns and relationships of "devicetype" */
export type DevicetypeVehicle_Devices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Device_Order_By>>;
  where?: InputMaybe<Vehicle_Device_Bool_Exp>;
};

/** aggregated selection of "devicetype" */
export type Devicetype_Aggregate = {
  __typename?: 'devicetype_aggregate';
  aggregate?: Maybe<Devicetype_Aggregate_Fields>;
  nodes: Array<Devicetype>;
};

/** aggregate fields of "devicetype" */
export type Devicetype_Aggregate_Fields = {
  __typename?: 'devicetype_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Devicetype_Max_Fields>;
  min?: Maybe<Devicetype_Min_Fields>;
};


/** aggregate fields of "devicetype" */
export type Devicetype_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Devicetype_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "devicetype". All fields are combined with a logical 'AND'. */
export type Devicetype_Bool_Exp = {
  _and?: InputMaybe<Array<Devicetype_Bool_Exp>>;
  _not?: InputMaybe<Devicetype_Bool_Exp>;
  _or?: InputMaybe<Array<Devicetype_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_asset_devices?: InputMaybe<Customer_Asset_Device_Bool_Exp>;
  customer_asset_devices_aggregate?: InputMaybe<Customer_Asset_Device_Aggregate_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  device_devicetype_paramerter_definitions?: InputMaybe<Device_Devicetype_Paramerter_Definition_Bool_Exp>;
  device_devicetype_paramerter_definitions_aggregate?: InputMaybe<Device_Devicetype_Paramerter_Definition_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  sku?: InputMaybe<String_Comparison_Exp>;
  vehicle_devices?: InputMaybe<Vehicle_Device_Bool_Exp>;
  vehicle_devices_aggregate?: InputMaybe<Vehicle_Device_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "devicetype" */
export enum Devicetype_Constraint {
  /** unique or primary key constraint on columns "id" */
  DevicetypePkey = 'devicetype_pkey'
}

/** input type for inserting data into table "devicetype" */
export type Devicetype_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_asset_devices?: InputMaybe<Customer_Asset_Device_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']['input']>;
  device_devicetype_paramerter_definitions?: InputMaybe<Device_Devicetype_Paramerter_Definition_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  vehicle_devices?: InputMaybe<Vehicle_Device_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Devicetype_Max_Fields = {
  __typename?: 'devicetype_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Devicetype_Min_Fields = {
  __typename?: 'devicetype_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "devicetype" */
export type Devicetype_Mutation_Response = {
  __typename?: 'devicetype_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Devicetype>;
};

/** input type for inserting object relation for remote table "devicetype" */
export type Devicetype_Obj_Rel_Insert_Input = {
  data: Devicetype_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Devicetype_On_Conflict>;
};

/** on_conflict condition type for table "devicetype" */
export type Devicetype_On_Conflict = {
  constraint: Devicetype_Constraint;
  update_columns?: Array<Devicetype_Update_Column>;
  where?: InputMaybe<Devicetype_Bool_Exp>;
};

/** Ordering options when selecting data from "devicetype". */
export type Devicetype_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_asset_devices_aggregate?: InputMaybe<Customer_Asset_Device_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  device_devicetype_paramerter_definitions_aggregate?: InputMaybe<Device_Devicetype_Paramerter_Definition_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  sku?: InputMaybe<Order_By>;
  vehicle_devices_aggregate?: InputMaybe<Vehicle_Device_Aggregate_Order_By>;
};

/** columns and relationships of "devicetype_paramerter_definition" */
export type Devicetype_Paramerter_Definition = {
  __typename?: 'devicetype_paramerter_definition';
  bytes_details?: Maybe<Scalars['String']['output']>;
  bytes_type?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  customerAssetDeviceCalibrationsByTargetDevicetypeParamerterDefinitionId: Array<Customer_Asset_Device_Calibration>;
  /** An aggregate relationship */
  customerAssetDeviceCalibrationsByTargetDevicetypeParamerterDefinitionId_aggregate: Customer_Asset_Device_Calibration_Aggregate;
  /** An array relationship */
  customer_asset_device_calibrations: Array<Customer_Asset_Device_Calibration>;
  /** An aggregate relationship */
  customer_asset_device_calibrations_aggregate: Customer_Asset_Device_Calibration_Aggregate;
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  device_devicetype_paramerter_definitions: Array<Device_Devicetype_Paramerter_Definition>;
  /** An aggregate relationship */
  device_devicetype_paramerter_definitions_aggregate: Device_Devicetype_Paramerter_Definition_Aggregate;
  /** An object relationship */
  devicetype_parameter_group: Devicetype_Parameter_Group;
  devicetype_parameter_group_id: Scalars['uuid']['output'];
  hardware_support?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  maximum?: Maybe<Scalars['String']['output']>;
  minimum?: Maybe<Scalars['String']['output']>;
  multiplier?: Maybe<Scalars['String']['output']>;
  property_id: Scalars['String']['output'];
  property_name?: Maybe<Scalars['String']['output']>;
  units?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  vehicleDeviceCalibrationsByTargetDevicetypeParamerterDefinitionId: Array<Vehicle_Device_Calibration>;
  /** An aggregate relationship */
  vehicleDeviceCalibrationsByTargetDevicetypeParamerterDefinitionId_aggregate: Vehicle_Device_Calibration_Aggregate;
  /** An array relationship */
  vehicle_device_calibrations: Array<Vehicle_Device_Calibration>;
  /** An aggregate relationship */
  vehicle_device_calibrations_aggregate: Vehicle_Device_Calibration_Aggregate;
};


/** columns and relationships of "devicetype_paramerter_definition" */
export type Devicetype_Paramerter_DefinitionCustomerAssetDeviceCalibrationsByTargetDevicetypeParamerterDefinitionIdArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Device_Calibration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Device_Calibration_Order_By>>;
  where?: InputMaybe<Customer_Asset_Device_Calibration_Bool_Exp>;
};


/** columns and relationships of "devicetype_paramerter_definition" */
export type Devicetype_Paramerter_DefinitionCustomerAssetDeviceCalibrationsByTargetDevicetypeParamerterDefinitionId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Device_Calibration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Device_Calibration_Order_By>>;
  where?: InputMaybe<Customer_Asset_Device_Calibration_Bool_Exp>;
};


/** columns and relationships of "devicetype_paramerter_definition" */
export type Devicetype_Paramerter_DefinitionCustomer_Asset_Device_CalibrationsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Device_Calibration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Device_Calibration_Order_By>>;
  where?: InputMaybe<Customer_Asset_Device_Calibration_Bool_Exp>;
};


/** columns and relationships of "devicetype_paramerter_definition" */
export type Devicetype_Paramerter_DefinitionCustomer_Asset_Device_Calibrations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Device_Calibration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Device_Calibration_Order_By>>;
  where?: InputMaybe<Customer_Asset_Device_Calibration_Bool_Exp>;
};


/** columns and relationships of "devicetype_paramerter_definition" */
export type Devicetype_Paramerter_DefinitionDevice_Devicetype_Paramerter_DefinitionsArgs = {
  distinct_on?: InputMaybe<Array<Device_Devicetype_Paramerter_Definition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Device_Devicetype_Paramerter_Definition_Order_By>>;
  where?: InputMaybe<Device_Devicetype_Paramerter_Definition_Bool_Exp>;
};


/** columns and relationships of "devicetype_paramerter_definition" */
export type Devicetype_Paramerter_DefinitionDevice_Devicetype_Paramerter_Definitions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Device_Devicetype_Paramerter_Definition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Device_Devicetype_Paramerter_Definition_Order_By>>;
  where?: InputMaybe<Device_Devicetype_Paramerter_Definition_Bool_Exp>;
};


/** columns and relationships of "devicetype_paramerter_definition" */
export type Devicetype_Paramerter_DefinitionVehicleDeviceCalibrationsByTargetDevicetypeParamerterDefinitionIdArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Device_Calibration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Device_Calibration_Order_By>>;
  where?: InputMaybe<Vehicle_Device_Calibration_Bool_Exp>;
};


/** columns and relationships of "devicetype_paramerter_definition" */
export type Devicetype_Paramerter_DefinitionVehicleDeviceCalibrationsByTargetDevicetypeParamerterDefinitionId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Device_Calibration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Device_Calibration_Order_By>>;
  where?: InputMaybe<Vehicle_Device_Calibration_Bool_Exp>;
};


/** columns and relationships of "devicetype_paramerter_definition" */
export type Devicetype_Paramerter_DefinitionVehicle_Device_CalibrationsArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Device_Calibration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Device_Calibration_Order_By>>;
  where?: InputMaybe<Vehicle_Device_Calibration_Bool_Exp>;
};


/** columns and relationships of "devicetype_paramerter_definition" */
export type Devicetype_Paramerter_DefinitionVehicle_Device_Calibrations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Device_Calibration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Device_Calibration_Order_By>>;
  where?: InputMaybe<Vehicle_Device_Calibration_Bool_Exp>;
};

/** aggregated selection of "devicetype_paramerter_definition" */
export type Devicetype_Paramerter_Definition_Aggregate = {
  __typename?: 'devicetype_paramerter_definition_aggregate';
  aggregate?: Maybe<Devicetype_Paramerter_Definition_Aggregate_Fields>;
  nodes: Array<Devicetype_Paramerter_Definition>;
};

export type Devicetype_Paramerter_Definition_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Devicetype_Paramerter_Definition_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Devicetype_Paramerter_Definition_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Devicetype_Paramerter_Definition_Aggregate_Bool_Exp_Count>;
};

export type Devicetype_Paramerter_Definition_Aggregate_Bool_Exp_Bool_And = {
  arguments: Devicetype_Paramerter_Definition_Select_Column_Devicetype_Paramerter_Definition_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Devicetype_Paramerter_Definition_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Devicetype_Paramerter_Definition_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Devicetype_Paramerter_Definition_Select_Column_Devicetype_Paramerter_Definition_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Devicetype_Paramerter_Definition_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Devicetype_Paramerter_Definition_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Devicetype_Paramerter_Definition_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Devicetype_Paramerter_Definition_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "devicetype_paramerter_definition" */
export type Devicetype_Paramerter_Definition_Aggregate_Fields = {
  __typename?: 'devicetype_paramerter_definition_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Devicetype_Paramerter_Definition_Max_Fields>;
  min?: Maybe<Devicetype_Paramerter_Definition_Min_Fields>;
};


/** aggregate fields of "devicetype_paramerter_definition" */
export type Devicetype_Paramerter_Definition_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Devicetype_Paramerter_Definition_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "devicetype_paramerter_definition" */
export type Devicetype_Paramerter_Definition_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Devicetype_Paramerter_Definition_Max_Order_By>;
  min?: InputMaybe<Devicetype_Paramerter_Definition_Min_Order_By>;
};

/** input type for inserting array relation for remote table "devicetype_paramerter_definition" */
export type Devicetype_Paramerter_Definition_Arr_Rel_Insert_Input = {
  data: Array<Devicetype_Paramerter_Definition_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Devicetype_Paramerter_Definition_On_Conflict>;
};

/** Boolean expression to filter rows from the table "devicetype_paramerter_definition". All fields are combined with a logical 'AND'. */
export type Devicetype_Paramerter_Definition_Bool_Exp = {
  _and?: InputMaybe<Array<Devicetype_Paramerter_Definition_Bool_Exp>>;
  _not?: InputMaybe<Devicetype_Paramerter_Definition_Bool_Exp>;
  _or?: InputMaybe<Array<Devicetype_Paramerter_Definition_Bool_Exp>>;
  bytes_details?: InputMaybe<String_Comparison_Exp>;
  bytes_type?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customerAssetDeviceCalibrationsByTargetDevicetypeParamerterDefinitionId?: InputMaybe<Customer_Asset_Device_Calibration_Bool_Exp>;
  customerAssetDeviceCalibrationsByTargetDevicetypeParamerterDefinitionId_aggregate?: InputMaybe<Customer_Asset_Device_Calibration_Aggregate_Bool_Exp>;
  customer_asset_device_calibrations?: InputMaybe<Customer_Asset_Device_Calibration_Bool_Exp>;
  customer_asset_device_calibrations_aggregate?: InputMaybe<Customer_Asset_Device_Calibration_Aggregate_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  device_devicetype_paramerter_definitions?: InputMaybe<Device_Devicetype_Paramerter_Definition_Bool_Exp>;
  device_devicetype_paramerter_definitions_aggregate?: InputMaybe<Device_Devicetype_Paramerter_Definition_Aggregate_Bool_Exp>;
  devicetype_parameter_group?: InputMaybe<Devicetype_Parameter_Group_Bool_Exp>;
  devicetype_parameter_group_id?: InputMaybe<Uuid_Comparison_Exp>;
  hardware_support?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  maximum?: InputMaybe<String_Comparison_Exp>;
  minimum?: InputMaybe<String_Comparison_Exp>;
  multiplier?: InputMaybe<String_Comparison_Exp>;
  property_id?: InputMaybe<String_Comparison_Exp>;
  property_name?: InputMaybe<String_Comparison_Exp>;
  units?: InputMaybe<String_Comparison_Exp>;
  vehicleDeviceCalibrationsByTargetDevicetypeParamerterDefinitionId?: InputMaybe<Vehicle_Device_Calibration_Bool_Exp>;
  vehicleDeviceCalibrationsByTargetDevicetypeParamerterDefinitionId_aggregate?: InputMaybe<Vehicle_Device_Calibration_Aggregate_Bool_Exp>;
  vehicle_device_calibrations?: InputMaybe<Vehicle_Device_Calibration_Bool_Exp>;
  vehicle_device_calibrations_aggregate?: InputMaybe<Vehicle_Device_Calibration_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "devicetype_paramerter_definition" */
export enum Devicetype_Paramerter_Definition_Constraint {
  /** unique or primary key constraint on columns "id" */
  DevicetypeParamerterDefinitionPkey = 'devicetype_paramerter_definition_pkey'
}

/** input type for inserting data into table "devicetype_paramerter_definition" */
export type Devicetype_Paramerter_Definition_Insert_Input = {
  bytes_details?: InputMaybe<Scalars['String']['input']>;
  bytes_type?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customerAssetDeviceCalibrationsByTargetDevicetypeParamerterDefinitionId?: InputMaybe<Customer_Asset_Device_Calibration_Arr_Rel_Insert_Input>;
  customer_asset_device_calibrations?: InputMaybe<Customer_Asset_Device_Calibration_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']['input']>;
  device_devicetype_paramerter_definitions?: InputMaybe<Device_Devicetype_Paramerter_Definition_Arr_Rel_Insert_Input>;
  devicetype_parameter_group?: InputMaybe<Devicetype_Parameter_Group_Obj_Rel_Insert_Input>;
  devicetype_parameter_group_id?: InputMaybe<Scalars['uuid']['input']>;
  hardware_support?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  maximum?: InputMaybe<Scalars['String']['input']>;
  minimum?: InputMaybe<Scalars['String']['input']>;
  multiplier?: InputMaybe<Scalars['String']['input']>;
  property_id?: InputMaybe<Scalars['String']['input']>;
  property_name?: InputMaybe<Scalars['String']['input']>;
  units?: InputMaybe<Scalars['String']['input']>;
  vehicleDeviceCalibrationsByTargetDevicetypeParamerterDefinitionId?: InputMaybe<Vehicle_Device_Calibration_Arr_Rel_Insert_Input>;
  vehicle_device_calibrations?: InputMaybe<Vehicle_Device_Calibration_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Devicetype_Paramerter_Definition_Max_Fields = {
  __typename?: 'devicetype_paramerter_definition_max_fields';
  bytes_details?: Maybe<Scalars['String']['output']>;
  bytes_type?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  devicetype_parameter_group_id?: Maybe<Scalars['uuid']['output']>;
  hardware_support?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  maximum?: Maybe<Scalars['String']['output']>;
  minimum?: Maybe<Scalars['String']['output']>;
  multiplier?: Maybe<Scalars['String']['output']>;
  property_id?: Maybe<Scalars['String']['output']>;
  property_name?: Maybe<Scalars['String']['output']>;
  units?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "devicetype_paramerter_definition" */
export type Devicetype_Paramerter_Definition_Max_Order_By = {
  bytes_details?: InputMaybe<Order_By>;
  bytes_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  devicetype_parameter_group_id?: InputMaybe<Order_By>;
  hardware_support?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  maximum?: InputMaybe<Order_By>;
  minimum?: InputMaybe<Order_By>;
  multiplier?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  property_name?: InputMaybe<Order_By>;
  units?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Devicetype_Paramerter_Definition_Min_Fields = {
  __typename?: 'devicetype_paramerter_definition_min_fields';
  bytes_details?: Maybe<Scalars['String']['output']>;
  bytes_type?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  devicetype_parameter_group_id?: Maybe<Scalars['uuid']['output']>;
  hardware_support?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  maximum?: Maybe<Scalars['String']['output']>;
  minimum?: Maybe<Scalars['String']['output']>;
  multiplier?: Maybe<Scalars['String']['output']>;
  property_id?: Maybe<Scalars['String']['output']>;
  property_name?: Maybe<Scalars['String']['output']>;
  units?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "devicetype_paramerter_definition" */
export type Devicetype_Paramerter_Definition_Min_Order_By = {
  bytes_details?: InputMaybe<Order_By>;
  bytes_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  devicetype_parameter_group_id?: InputMaybe<Order_By>;
  hardware_support?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  maximum?: InputMaybe<Order_By>;
  minimum?: InputMaybe<Order_By>;
  multiplier?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  property_name?: InputMaybe<Order_By>;
  units?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "devicetype_paramerter_definition" */
export type Devicetype_Paramerter_Definition_Mutation_Response = {
  __typename?: 'devicetype_paramerter_definition_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Devicetype_Paramerter_Definition>;
};

/** input type for inserting object relation for remote table "devicetype_paramerter_definition" */
export type Devicetype_Paramerter_Definition_Obj_Rel_Insert_Input = {
  data: Devicetype_Paramerter_Definition_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Devicetype_Paramerter_Definition_On_Conflict>;
};

/** on_conflict condition type for table "devicetype_paramerter_definition" */
export type Devicetype_Paramerter_Definition_On_Conflict = {
  constraint: Devicetype_Paramerter_Definition_Constraint;
  update_columns?: Array<Devicetype_Paramerter_Definition_Update_Column>;
  where?: InputMaybe<Devicetype_Paramerter_Definition_Bool_Exp>;
};

/** Ordering options when selecting data from "devicetype_paramerter_definition". */
export type Devicetype_Paramerter_Definition_Order_By = {
  bytes_details?: InputMaybe<Order_By>;
  bytes_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customerAssetDeviceCalibrationsByTargetDevicetypeParamerterDefinitionId_aggregate?: InputMaybe<Customer_Asset_Device_Calibration_Aggregate_Order_By>;
  customer_asset_device_calibrations_aggregate?: InputMaybe<Customer_Asset_Device_Calibration_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  device_devicetype_paramerter_definitions_aggregate?: InputMaybe<Device_Devicetype_Paramerter_Definition_Aggregate_Order_By>;
  devicetype_parameter_group?: InputMaybe<Devicetype_Parameter_Group_Order_By>;
  devicetype_parameter_group_id?: InputMaybe<Order_By>;
  hardware_support?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  maximum?: InputMaybe<Order_By>;
  minimum?: InputMaybe<Order_By>;
  multiplier?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  property_name?: InputMaybe<Order_By>;
  units?: InputMaybe<Order_By>;
  vehicleDeviceCalibrationsByTargetDevicetypeParamerterDefinitionId_aggregate?: InputMaybe<Vehicle_Device_Calibration_Aggregate_Order_By>;
  vehicle_device_calibrations_aggregate?: InputMaybe<Vehicle_Device_Calibration_Aggregate_Order_By>;
};

/** primary key columns input for table: devicetype_paramerter_definition */
export type Devicetype_Paramerter_Definition_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "devicetype_paramerter_definition" */
export enum Devicetype_Paramerter_Definition_Select_Column {
  /** column name */
  BytesDetails = 'bytes_details',
  /** column name */
  BytesType = 'bytes_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  DevicetypeParameterGroupId = 'devicetype_parameter_group_id',
  /** column name */
  HardwareSupport = 'hardware_support',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Maximum = 'maximum',
  /** column name */
  Minimum = 'minimum',
  /** column name */
  Multiplier = 'multiplier',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PropertyName = 'property_name',
  /** column name */
  Units = 'units'
}

/** select "devicetype_paramerter_definition_aggregate_bool_exp_bool_and_arguments_columns" columns of table "devicetype_paramerter_definition" */
export enum Devicetype_Paramerter_Definition_Select_Column_Devicetype_Paramerter_Definition_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "devicetype_paramerter_definition_aggregate_bool_exp_bool_or_arguments_columns" columns of table "devicetype_paramerter_definition" */
export enum Devicetype_Paramerter_Definition_Select_Column_Devicetype_Paramerter_Definition_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "devicetype_paramerter_definition" */
export type Devicetype_Paramerter_Definition_Set_Input = {
  bytes_details?: InputMaybe<Scalars['String']['input']>;
  bytes_type?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  devicetype_parameter_group_id?: InputMaybe<Scalars['uuid']['input']>;
  hardware_support?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  maximum?: InputMaybe<Scalars['String']['input']>;
  minimum?: InputMaybe<Scalars['String']['input']>;
  multiplier?: InputMaybe<Scalars['String']['input']>;
  property_id?: InputMaybe<Scalars['String']['input']>;
  property_name?: InputMaybe<Scalars['String']['input']>;
  units?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "devicetype_paramerter_definition" */
export type Devicetype_Paramerter_Definition_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Devicetype_Paramerter_Definition_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Devicetype_Paramerter_Definition_Stream_Cursor_Value_Input = {
  bytes_details?: InputMaybe<Scalars['String']['input']>;
  bytes_type?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  devicetype_parameter_group_id?: InputMaybe<Scalars['uuid']['input']>;
  hardware_support?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  maximum?: InputMaybe<Scalars['String']['input']>;
  minimum?: InputMaybe<Scalars['String']['input']>;
  multiplier?: InputMaybe<Scalars['String']['input']>;
  property_id?: InputMaybe<Scalars['String']['input']>;
  property_name?: InputMaybe<Scalars['String']['input']>;
  units?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "devicetype_paramerter_definition" */
export enum Devicetype_Paramerter_Definition_Update_Column {
  /** column name */
  BytesDetails = 'bytes_details',
  /** column name */
  BytesType = 'bytes_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  DevicetypeParameterGroupId = 'devicetype_parameter_group_id',
  /** column name */
  HardwareSupport = 'hardware_support',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Maximum = 'maximum',
  /** column name */
  Minimum = 'minimum',
  /** column name */
  Multiplier = 'multiplier',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PropertyName = 'property_name',
  /** column name */
  Units = 'units'
}

export type Devicetype_Paramerter_Definition_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Devicetype_Paramerter_Definition_Set_Input>;
  /** filter the rows which have to be updated */
  where: Devicetype_Paramerter_Definition_Bool_Exp;
};

/** columns and relationships of "devicetype_parameter_group" */
export type Devicetype_Parameter_Group = {
  __typename?: 'devicetype_parameter_group';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  devicetype_paramerter_definitions: Array<Devicetype_Paramerter_Definition>;
  /** An aggregate relationship */
  devicetype_paramerter_definitions_aggregate: Devicetype_Paramerter_Definition_Aggregate;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name: Scalars['String']['output'];
};


/** columns and relationships of "devicetype_parameter_group" */
export type Devicetype_Parameter_GroupDevicetype_Paramerter_DefinitionsArgs = {
  distinct_on?: InputMaybe<Array<Devicetype_Paramerter_Definition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Devicetype_Paramerter_Definition_Order_By>>;
  where?: InputMaybe<Devicetype_Paramerter_Definition_Bool_Exp>;
};


/** columns and relationships of "devicetype_parameter_group" */
export type Devicetype_Parameter_GroupDevicetype_Paramerter_Definitions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Devicetype_Paramerter_Definition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Devicetype_Paramerter_Definition_Order_By>>;
  where?: InputMaybe<Devicetype_Paramerter_Definition_Bool_Exp>;
};

/** aggregated selection of "devicetype_parameter_group" */
export type Devicetype_Parameter_Group_Aggregate = {
  __typename?: 'devicetype_parameter_group_aggregate';
  aggregate?: Maybe<Devicetype_Parameter_Group_Aggregate_Fields>;
  nodes: Array<Devicetype_Parameter_Group>;
};

/** aggregate fields of "devicetype_parameter_group" */
export type Devicetype_Parameter_Group_Aggregate_Fields = {
  __typename?: 'devicetype_parameter_group_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Devicetype_Parameter_Group_Max_Fields>;
  min?: Maybe<Devicetype_Parameter_Group_Min_Fields>;
};


/** aggregate fields of "devicetype_parameter_group" */
export type Devicetype_Parameter_Group_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Devicetype_Parameter_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "devicetype_parameter_group". All fields are combined with a logical 'AND'. */
export type Devicetype_Parameter_Group_Bool_Exp = {
  _and?: InputMaybe<Array<Devicetype_Parameter_Group_Bool_Exp>>;
  _not?: InputMaybe<Devicetype_Parameter_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Devicetype_Parameter_Group_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  devicetype_paramerter_definitions?: InputMaybe<Devicetype_Paramerter_Definition_Bool_Exp>;
  devicetype_paramerter_definitions_aggregate?: InputMaybe<Devicetype_Paramerter_Definition_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "devicetype_parameter_group" */
export enum Devicetype_Parameter_Group_Constraint {
  /** unique or primary key constraint on columns "id" */
  DevicetypeParameterGroupPkey = 'devicetype_parameter_group_pkey'
}

/** input type for inserting data into table "devicetype_parameter_group" */
export type Devicetype_Parameter_Group_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  devicetype_paramerter_definitions?: InputMaybe<Devicetype_Paramerter_Definition_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Devicetype_Parameter_Group_Max_Fields = {
  __typename?: 'devicetype_parameter_group_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Devicetype_Parameter_Group_Min_Fields = {
  __typename?: 'devicetype_parameter_group_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "devicetype_parameter_group" */
export type Devicetype_Parameter_Group_Mutation_Response = {
  __typename?: 'devicetype_parameter_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Devicetype_Parameter_Group>;
};

/** input type for inserting object relation for remote table "devicetype_parameter_group" */
export type Devicetype_Parameter_Group_Obj_Rel_Insert_Input = {
  data: Devicetype_Parameter_Group_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Devicetype_Parameter_Group_On_Conflict>;
};

/** on_conflict condition type for table "devicetype_parameter_group" */
export type Devicetype_Parameter_Group_On_Conflict = {
  constraint: Devicetype_Parameter_Group_Constraint;
  update_columns?: Array<Devicetype_Parameter_Group_Update_Column>;
  where?: InputMaybe<Devicetype_Parameter_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "devicetype_parameter_group". */
export type Devicetype_Parameter_Group_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  devicetype_paramerter_definitions_aggregate?: InputMaybe<Devicetype_Paramerter_Definition_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: devicetype_parameter_group */
export type Devicetype_Parameter_Group_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "devicetype_parameter_group" */
export enum Devicetype_Parameter_Group_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "devicetype_parameter_group" */
export type Devicetype_Parameter_Group_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "devicetype_parameter_group" */
export type Devicetype_Parameter_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Devicetype_Parameter_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Devicetype_Parameter_Group_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "devicetype_parameter_group" */
export enum Devicetype_Parameter_Group_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name'
}

export type Devicetype_Parameter_Group_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Devicetype_Parameter_Group_Set_Input>;
  /** filter the rows which have to be updated */
  where: Devicetype_Parameter_Group_Bool_Exp;
};

/** primary key columns input for table: devicetype */
export type Devicetype_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "devicetype" */
export enum Devicetype_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  Sku = 'sku'
}

/** input type for updating data in table "devicetype" */
export type Devicetype_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "devicetype" */
export type Devicetype_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Devicetype_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Devicetype_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "devicetype" */
export enum Devicetype_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  Sku = 'sku'
}

export type Devicetype_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Devicetype_Set_Input>;
  /** filter the rows which have to be updated */
  where: Devicetype_Bool_Exp;
};

/** columns and relationships of "discount_type" */
export type Discount_Type = {
  __typename?: 'discount_type';
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  customer_order_items: Array<Customer_Order_Item>;
  /** An aggregate relationship */
  customer_order_items_aggregate: Customer_Order_Item_Aggregate;
  /** An array relationship */
  invoiced_items: Array<Invoiced_Item>;
  /** An aggregate relationship */
  invoiced_items_aggregate: Invoiced_Item_Aggregate;
  /** An array relationship */
  organizationProductVariationDiscountHistoriesByOldDiscountType: Array<Organization_Product_Variation_Discount_History>;
  /** An aggregate relationship */
  organizationProductVariationDiscountHistoriesByOldDiscountType_aggregate: Organization_Product_Variation_Discount_History_Aggregate;
  /** An array relationship */
  organization_product_variation_discount_histories: Array<Organization_Product_Variation_Discount_History>;
  /** An aggregate relationship */
  organization_product_variation_discount_histories_aggregate: Organization_Product_Variation_Discount_History_Aggregate;
  /** An array relationship */
  organization_product_variation_discounts: Array<Organization_Product_Variation_Discount>;
  /** An aggregate relationship */
  organization_product_variation_discounts_aggregate: Organization_Product_Variation_Discount_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "discount_type" */
export type Discount_TypeCustomer_Order_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Bool_Exp>;
};


/** columns and relationships of "discount_type" */
export type Discount_TypeCustomer_Order_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Bool_Exp>;
};


/** columns and relationships of "discount_type" */
export type Discount_TypeInvoiced_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Bool_Exp>;
};


/** columns and relationships of "discount_type" */
export type Discount_TypeInvoiced_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Bool_Exp>;
};


/** columns and relationships of "discount_type" */
export type Discount_TypeOrganizationProductVariationDiscountHistoriesByOldDiscountTypeArgs = {
  distinct_on?: InputMaybe<Array<Organization_Product_Variation_Discount_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Product_Variation_Discount_History_Order_By>>;
  where?: InputMaybe<Organization_Product_Variation_Discount_History_Bool_Exp>;
};


/** columns and relationships of "discount_type" */
export type Discount_TypeOrganizationProductVariationDiscountHistoriesByOldDiscountType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Product_Variation_Discount_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Product_Variation_Discount_History_Order_By>>;
  where?: InputMaybe<Organization_Product_Variation_Discount_History_Bool_Exp>;
};


/** columns and relationships of "discount_type" */
export type Discount_TypeOrganization_Product_Variation_Discount_HistoriesArgs = {
  distinct_on?: InputMaybe<Array<Organization_Product_Variation_Discount_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Product_Variation_Discount_History_Order_By>>;
  where?: InputMaybe<Organization_Product_Variation_Discount_History_Bool_Exp>;
};


/** columns and relationships of "discount_type" */
export type Discount_TypeOrganization_Product_Variation_Discount_Histories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Product_Variation_Discount_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Product_Variation_Discount_History_Order_By>>;
  where?: InputMaybe<Organization_Product_Variation_Discount_History_Bool_Exp>;
};


/** columns and relationships of "discount_type" */
export type Discount_TypeOrganization_Product_Variation_DiscountsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Product_Variation_Discount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Product_Variation_Discount_Order_By>>;
  where?: InputMaybe<Organization_Product_Variation_Discount_Bool_Exp>;
};


/** columns and relationships of "discount_type" */
export type Discount_TypeOrganization_Product_Variation_Discounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Product_Variation_Discount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Product_Variation_Discount_Order_By>>;
  where?: InputMaybe<Organization_Product_Variation_Discount_Bool_Exp>;
};

/** aggregated selection of "discount_type" */
export type Discount_Type_Aggregate = {
  __typename?: 'discount_type_aggregate';
  aggregate?: Maybe<Discount_Type_Aggregate_Fields>;
  nodes: Array<Discount_Type>;
};

/** aggregate fields of "discount_type" */
export type Discount_Type_Aggregate_Fields = {
  __typename?: 'discount_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Discount_Type_Max_Fields>;
  min?: Maybe<Discount_Type_Min_Fields>;
};


/** aggregate fields of "discount_type" */
export type Discount_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Discount_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "discount_type". All fields are combined with a logical 'AND'. */
export type Discount_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Discount_Type_Bool_Exp>>;
  _not?: InputMaybe<Discount_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Discount_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  customer_order_items?: InputMaybe<Customer_Order_Item_Bool_Exp>;
  customer_order_items_aggregate?: InputMaybe<Customer_Order_Item_Aggregate_Bool_Exp>;
  invoiced_items?: InputMaybe<Invoiced_Item_Bool_Exp>;
  invoiced_items_aggregate?: InputMaybe<Invoiced_Item_Aggregate_Bool_Exp>;
  organizationProductVariationDiscountHistoriesByOldDiscountType?: InputMaybe<Organization_Product_Variation_Discount_History_Bool_Exp>;
  organizationProductVariationDiscountHistoriesByOldDiscountType_aggregate?: InputMaybe<Organization_Product_Variation_Discount_History_Aggregate_Bool_Exp>;
  organization_product_variation_discount_histories?: InputMaybe<Organization_Product_Variation_Discount_History_Bool_Exp>;
  organization_product_variation_discount_histories_aggregate?: InputMaybe<Organization_Product_Variation_Discount_History_Aggregate_Bool_Exp>;
  organization_product_variation_discounts?: InputMaybe<Organization_Product_Variation_Discount_Bool_Exp>;
  organization_product_variation_discounts_aggregate?: InputMaybe<Organization_Product_Variation_Discount_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "discount_type" */
export enum Discount_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  DiscountTypePkey = 'discount_type_pkey'
}

export enum Discount_Type_Enum {
  /** PERCENTAGE */
  Percentage = 'PERCENTAGE',
  /** PER_LITER */
  PerLiter = 'PER_LITER'
}

/** Boolean expression to compare columns of type "discount_type_enum". All fields are combined with logical 'AND'. */
export type Discount_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Discount_Type_Enum>;
  _in?: InputMaybe<Array<Discount_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Discount_Type_Enum>;
  _nin?: InputMaybe<Array<Discount_Type_Enum>>;
};

/** input type for inserting data into table "discount_type" */
export type Discount_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  customer_order_items?: InputMaybe<Customer_Order_Item_Arr_Rel_Insert_Input>;
  invoiced_items?: InputMaybe<Invoiced_Item_Arr_Rel_Insert_Input>;
  organizationProductVariationDiscountHistoriesByOldDiscountType?: InputMaybe<Organization_Product_Variation_Discount_History_Arr_Rel_Insert_Input>;
  organization_product_variation_discount_histories?: InputMaybe<Organization_Product_Variation_Discount_History_Arr_Rel_Insert_Input>;
  organization_product_variation_discounts?: InputMaybe<Organization_Product_Variation_Discount_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Discount_Type_Max_Fields = {
  __typename?: 'discount_type_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Discount_Type_Min_Fields = {
  __typename?: 'discount_type_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "discount_type" */
export type Discount_Type_Mutation_Response = {
  __typename?: 'discount_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Discount_Type>;
};

/** input type for inserting object relation for remote table "discount_type" */
export type Discount_Type_Obj_Rel_Insert_Input = {
  data: Discount_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Discount_Type_On_Conflict>;
};

/** on_conflict condition type for table "discount_type" */
export type Discount_Type_On_Conflict = {
  constraint: Discount_Type_Constraint;
  update_columns?: Array<Discount_Type_Update_Column>;
  where?: InputMaybe<Discount_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "discount_type". */
export type Discount_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  customer_order_items_aggregate?: InputMaybe<Customer_Order_Item_Aggregate_Order_By>;
  invoiced_items_aggregate?: InputMaybe<Invoiced_Item_Aggregate_Order_By>;
  organizationProductVariationDiscountHistoriesByOldDiscountType_aggregate?: InputMaybe<Organization_Product_Variation_Discount_History_Aggregate_Order_By>;
  organization_product_variation_discount_histories_aggregate?: InputMaybe<Organization_Product_Variation_Discount_History_Aggregate_Order_By>;
  organization_product_variation_discounts_aggregate?: InputMaybe<Organization_Product_Variation_Discount_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: discount_type */
export type Discount_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "discount_type" */
export enum Discount_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "discount_type" */
export type Discount_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "discount_type" */
export type Discount_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Discount_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Discount_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "discount_type" */
export enum Discount_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Discount_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Discount_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Discount_Type_Bool_Exp;
};

/** columns and relationships of "dispenser" */
export type Dispenser = {
  __typename?: 'dispenser';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  dispenser_configurations: Array<Dispenser_Configuration>;
  /** An aggregate relationship */
  dispenser_configurations_aggregate: Dispenser_Configuration_Aggregate;
  /** An object relationship */
  dispenser_type: Dispenser_Type;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name: Scalars['String']['output'];
  /** An array relationship */
  shift_schedule_dispensers: Array<Shift_Schedule_Dispenser>;
  /** An aggregate relationship */
  shift_schedule_dispensers_aggregate: Shift_Schedule_Dispenser_Aggregate;
  type: Scalars['String']['output'];
  /** An object relationship */
  vehicle: Vehicle;
  vehicle_id: Scalars['uuid']['output'];
};


/** columns and relationships of "dispenser" */
export type DispenserDispenser_ConfigurationsArgs = {
  distinct_on?: InputMaybe<Array<Dispenser_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dispenser_Configuration_Order_By>>;
  where?: InputMaybe<Dispenser_Configuration_Bool_Exp>;
};


/** columns and relationships of "dispenser" */
export type DispenserDispenser_Configurations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dispenser_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dispenser_Configuration_Order_By>>;
  where?: InputMaybe<Dispenser_Configuration_Bool_Exp>;
};


/** columns and relationships of "dispenser" */
export type DispenserShift_Schedule_DispensersArgs = {
  distinct_on?: InputMaybe<Array<Shift_Schedule_Dispenser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shift_Schedule_Dispenser_Order_By>>;
  where?: InputMaybe<Shift_Schedule_Dispenser_Bool_Exp>;
};


/** columns and relationships of "dispenser" */
export type DispenserShift_Schedule_Dispensers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shift_Schedule_Dispenser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shift_Schedule_Dispenser_Order_By>>;
  where?: InputMaybe<Shift_Schedule_Dispenser_Bool_Exp>;
};

export type DispenserAssignmentInput = {
  dispenser_id: Scalars['uuid']['input'];
  driver_id: Scalars['uuid']['input'];
};

/** aggregated selection of "dispenser" */
export type Dispenser_Aggregate = {
  __typename?: 'dispenser_aggregate';
  aggregate?: Maybe<Dispenser_Aggregate_Fields>;
  nodes: Array<Dispenser>;
};

export type Dispenser_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Dispenser_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Dispenser_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Dispenser_Aggregate_Bool_Exp_Count>;
};

export type Dispenser_Aggregate_Bool_Exp_Bool_And = {
  arguments: Dispenser_Select_Column_Dispenser_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Dispenser_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Dispenser_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Dispenser_Select_Column_Dispenser_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Dispenser_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Dispenser_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Dispenser_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Dispenser_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "dispenser" */
export type Dispenser_Aggregate_Fields = {
  __typename?: 'dispenser_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Dispenser_Max_Fields>;
  min?: Maybe<Dispenser_Min_Fields>;
};


/** aggregate fields of "dispenser" */
export type Dispenser_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Dispenser_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "dispenser" */
export type Dispenser_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Dispenser_Max_Order_By>;
  min?: InputMaybe<Dispenser_Min_Order_By>;
};

/** input type for inserting array relation for remote table "dispenser" */
export type Dispenser_Arr_Rel_Insert_Input = {
  data: Array<Dispenser_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Dispenser_On_Conflict>;
};

/** Boolean expression to filter rows from the table "dispenser". All fields are combined with a logical 'AND'. */
export type Dispenser_Bool_Exp = {
  _and?: InputMaybe<Array<Dispenser_Bool_Exp>>;
  _not?: InputMaybe<Dispenser_Bool_Exp>;
  _or?: InputMaybe<Array<Dispenser_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  dispenser_configurations?: InputMaybe<Dispenser_Configuration_Bool_Exp>;
  dispenser_configurations_aggregate?: InputMaybe<Dispenser_Configuration_Aggregate_Bool_Exp>;
  dispenser_type?: InputMaybe<Dispenser_Type_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  shift_schedule_dispensers?: InputMaybe<Shift_Schedule_Dispenser_Bool_Exp>;
  shift_schedule_dispensers_aggregate?: InputMaybe<Shift_Schedule_Dispenser_Aggregate_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  vehicle?: InputMaybe<Vehicle_Bool_Exp>;
  vehicle_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** columns and relationships of "dispenser_configuration" */
export type Dispenser_Configuration = {
  __typename?: 'dispenser_configuration';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  dispenser: Dispenser;
  dispenser_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  key: Scalars['String']['output'];
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "dispenser_configuration" */
export type Dispenser_Configuration_Aggregate = {
  __typename?: 'dispenser_configuration_aggregate';
  aggregate?: Maybe<Dispenser_Configuration_Aggregate_Fields>;
  nodes: Array<Dispenser_Configuration>;
};

export type Dispenser_Configuration_Aggregate_Bool_Exp = {
  count?: InputMaybe<Dispenser_Configuration_Aggregate_Bool_Exp_Count>;
};

export type Dispenser_Configuration_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Dispenser_Configuration_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Dispenser_Configuration_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "dispenser_configuration" */
export type Dispenser_Configuration_Aggregate_Fields = {
  __typename?: 'dispenser_configuration_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Dispenser_Configuration_Max_Fields>;
  min?: Maybe<Dispenser_Configuration_Min_Fields>;
};


/** aggregate fields of "dispenser_configuration" */
export type Dispenser_Configuration_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Dispenser_Configuration_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "dispenser_configuration" */
export type Dispenser_Configuration_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Dispenser_Configuration_Max_Order_By>;
  min?: InputMaybe<Dispenser_Configuration_Min_Order_By>;
};

/** input type for inserting array relation for remote table "dispenser_configuration" */
export type Dispenser_Configuration_Arr_Rel_Insert_Input = {
  data: Array<Dispenser_Configuration_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Dispenser_Configuration_On_Conflict>;
};

/** Boolean expression to filter rows from the table "dispenser_configuration". All fields are combined with a logical 'AND'. */
export type Dispenser_Configuration_Bool_Exp = {
  _and?: InputMaybe<Array<Dispenser_Configuration_Bool_Exp>>;
  _not?: InputMaybe<Dispenser_Configuration_Bool_Exp>;
  _or?: InputMaybe<Array<Dispenser_Configuration_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  dispenser?: InputMaybe<Dispenser_Bool_Exp>;
  dispenser_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "dispenser_configuration" */
export enum Dispenser_Configuration_Constraint {
  /** unique or primary key constraint on columns "key", "dispenser_id" */
  DispenserConfigurationDispenserIdKeyKey = 'dispenser_configuration_dispenser_id_key_key',
  /** unique or primary key constraint on columns "id" */
  DispenserConfigurationPkey = 'dispenser_configuration_pkey'
}

/** input type for inserting data into table "dispenser_configuration" */
export type Dispenser_Configuration_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dispenser?: InputMaybe<Dispenser_Obj_Rel_Insert_Input>;
  dispenser_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Dispenser_Configuration_Max_Fields = {
  __typename?: 'dispenser_configuration_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  dispenser_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "dispenser_configuration" */
export type Dispenser_Configuration_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  dispenser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Dispenser_Configuration_Min_Fields = {
  __typename?: 'dispenser_configuration_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  dispenser_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "dispenser_configuration" */
export type Dispenser_Configuration_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  dispenser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "dispenser_configuration" */
export type Dispenser_Configuration_Mutation_Response = {
  __typename?: 'dispenser_configuration_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Dispenser_Configuration>;
};

/** on_conflict condition type for table "dispenser_configuration" */
export type Dispenser_Configuration_On_Conflict = {
  constraint: Dispenser_Configuration_Constraint;
  update_columns?: Array<Dispenser_Configuration_Update_Column>;
  where?: InputMaybe<Dispenser_Configuration_Bool_Exp>;
};

/** Ordering options when selecting data from "dispenser_configuration". */
export type Dispenser_Configuration_Order_By = {
  created_at?: InputMaybe<Order_By>;
  dispenser?: InputMaybe<Dispenser_Order_By>;
  dispenser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: dispenser_configuration */
export type Dispenser_Configuration_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "dispenser_configuration" */
export enum Dispenser_Configuration_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DispenserId = 'dispenser_id',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "dispenser_configuration" */
export type Dispenser_Configuration_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dispenser_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "dispenser_configuration" */
export type Dispenser_Configuration_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dispenser_Configuration_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dispenser_Configuration_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dispenser_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "dispenser_configuration" */
export enum Dispenser_Configuration_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DispenserId = 'dispenser_id',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Value = 'value'
}

export type Dispenser_Configuration_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Dispenser_Configuration_Set_Input>;
  /** filter the rows which have to be updated */
  where: Dispenser_Configuration_Bool_Exp;
};

/** unique or primary key constraints on table "dispenser" */
export enum Dispenser_Constraint {
  /** unique or primary key constraint on columns "id" */
  DispenserPkey = 'dispenser_pkey'
}

/** input type for inserting data into table "dispenser" */
export type Dispenser_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dispenser_configurations?: InputMaybe<Dispenser_Configuration_Arr_Rel_Insert_Input>;
  dispenser_type?: InputMaybe<Dispenser_Type_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  shift_schedule_dispensers?: InputMaybe<Shift_Schedule_Dispenser_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['String']['input']>;
  vehicle?: InputMaybe<Vehicle_Obj_Rel_Insert_Input>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Dispenser_Max_Fields = {
  __typename?: 'dispenser_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "dispenser" */
export type Dispenser_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Dispenser_Min_Fields = {
  __typename?: 'dispenser_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "dispenser" */
export type Dispenser_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "dispenser" */
export type Dispenser_Mutation_Response = {
  __typename?: 'dispenser_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Dispenser>;
};

/** input type for inserting object relation for remote table "dispenser" */
export type Dispenser_Obj_Rel_Insert_Input = {
  data: Dispenser_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Dispenser_On_Conflict>;
};

/** on_conflict condition type for table "dispenser" */
export type Dispenser_On_Conflict = {
  constraint: Dispenser_Constraint;
  update_columns?: Array<Dispenser_Update_Column>;
  where?: InputMaybe<Dispenser_Bool_Exp>;
};

/** Ordering options when selecting data from "dispenser". */
export type Dispenser_Order_By = {
  created_at?: InputMaybe<Order_By>;
  dispenser_configurations_aggregate?: InputMaybe<Dispenser_Configuration_Aggregate_Order_By>;
  dispenser_type?: InputMaybe<Dispenser_Type_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  shift_schedule_dispensers_aggregate?: InputMaybe<Shift_Schedule_Dispenser_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
  vehicle?: InputMaybe<Vehicle_Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: dispenser */
export type Dispenser_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "dispenser" */
export enum Dispenser_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  Type = 'type',
  /** column name */
  VehicleId = 'vehicle_id'
}

/** select "dispenser_aggregate_bool_exp_bool_and_arguments_columns" columns of table "dispenser" */
export enum Dispenser_Select_Column_Dispenser_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "dispenser_aggregate_bool_exp_bool_or_arguments_columns" columns of table "dispenser" */
export enum Dispenser_Select_Column_Dispenser_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "dispenser" */
export type Dispenser_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "dispenser" */
export type Dispenser_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dispenser_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dispenser_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "dispenser_type" */
export type Dispenser_Type = {
  __typename?: 'dispenser_type';
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  dispensers: Array<Dispenser>;
  /** An aggregate relationship */
  dispensers_aggregate: Dispenser_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "dispenser_type" */
export type Dispenser_TypeDispensersArgs = {
  distinct_on?: InputMaybe<Array<Dispenser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dispenser_Order_By>>;
  where?: InputMaybe<Dispenser_Bool_Exp>;
};


/** columns and relationships of "dispenser_type" */
export type Dispenser_TypeDispensers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dispenser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dispenser_Order_By>>;
  where?: InputMaybe<Dispenser_Bool_Exp>;
};

/** aggregated selection of "dispenser_type" */
export type Dispenser_Type_Aggregate = {
  __typename?: 'dispenser_type_aggregate';
  aggregate?: Maybe<Dispenser_Type_Aggregate_Fields>;
  nodes: Array<Dispenser_Type>;
};

/** aggregate fields of "dispenser_type" */
export type Dispenser_Type_Aggregate_Fields = {
  __typename?: 'dispenser_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Dispenser_Type_Max_Fields>;
  min?: Maybe<Dispenser_Type_Min_Fields>;
};


/** aggregate fields of "dispenser_type" */
export type Dispenser_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Dispenser_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "dispenser_type". All fields are combined with a logical 'AND'. */
export type Dispenser_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Dispenser_Type_Bool_Exp>>;
  _not?: InputMaybe<Dispenser_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Dispenser_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  dispensers?: InputMaybe<Dispenser_Bool_Exp>;
  dispensers_aggregate?: InputMaybe<Dispenser_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "dispenser_type" */
export enum Dispenser_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  DispenserTypePkey = 'dispenser_type_pkey'
}

/** input type for inserting data into table "dispenser_type" */
export type Dispenser_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  dispensers?: InputMaybe<Dispenser_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Dispenser_Type_Max_Fields = {
  __typename?: 'dispenser_type_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Dispenser_Type_Min_Fields = {
  __typename?: 'dispenser_type_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "dispenser_type" */
export type Dispenser_Type_Mutation_Response = {
  __typename?: 'dispenser_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Dispenser_Type>;
};

/** input type for inserting object relation for remote table "dispenser_type" */
export type Dispenser_Type_Obj_Rel_Insert_Input = {
  data: Dispenser_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Dispenser_Type_On_Conflict>;
};

/** on_conflict condition type for table "dispenser_type" */
export type Dispenser_Type_On_Conflict = {
  constraint: Dispenser_Type_Constraint;
  update_columns?: Array<Dispenser_Type_Update_Column>;
  where?: InputMaybe<Dispenser_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "dispenser_type". */
export type Dispenser_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  dispensers_aggregate?: InputMaybe<Dispenser_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: dispenser_type */
export type Dispenser_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "dispenser_type" */
export enum Dispenser_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "dispenser_type" */
export type Dispenser_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "dispenser_type" */
export type Dispenser_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dispenser_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dispenser_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "dispenser_type" */
export enum Dispenser_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Dispenser_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Dispenser_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Dispenser_Type_Bool_Exp;
};

/** update columns of table "dispenser" */
export enum Dispenser_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  Type = 'type',
  /** column name */
  VehicleId = 'vehicle_id'
}

export type Dispenser_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Dispenser_Set_Input>;
  /** filter the rows which have to be updated */
  where: Dispenser_Bool_Exp;
};

/** columns and relationships of "dispensing_rules" */
export type Dispensing_Rules = {
  __typename?: 'dispensing_rules';
  count?: Maybe<Scalars['numeric']['output']>;
  created_at: Scalars['timestamp']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  customer_asset_dispensing_rules: Array<Customer_Asset_Dispensing_Rules>;
  /** An aggregate relationship */
  customer_asset_dispensing_rules_aggregate: Customer_Asset_Dispensing_Rules_Aggregate;
  end_date: Scalars['date']['output'];
  frequency: Period_Frequency_Enum;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified: Scalars['timestamp']['output'];
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  organization: Organization;
  organization_id: Scalars['uuid']['output'];
  /** An object relationship */
  period_frequency: Period_Frequency;
  qty?: Maybe<Scalars['numeric']['output']>;
  start_date: Scalars['date']['output'];
  value?: Maybe<Scalars['numeric']['output']>;
};


/** columns and relationships of "dispensing_rules" */
export type Dispensing_RulesCustomer_Asset_Dispensing_RulesArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Dispensing_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Dispensing_Rules_Order_By>>;
  where?: InputMaybe<Customer_Asset_Dispensing_Rules_Bool_Exp>;
};


/** columns and relationships of "dispensing_rules" */
export type Dispensing_RulesCustomer_Asset_Dispensing_Rules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Dispensing_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Dispensing_Rules_Order_By>>;
  where?: InputMaybe<Customer_Asset_Dispensing_Rules_Bool_Exp>;
};

/** aggregated selection of "dispensing_rules" */
export type Dispensing_Rules_Aggregate = {
  __typename?: 'dispensing_rules_aggregate';
  aggregate?: Maybe<Dispensing_Rules_Aggregate_Fields>;
  nodes: Array<Dispensing_Rules>;
};

export type Dispensing_Rules_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Dispensing_Rules_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Dispensing_Rules_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Dispensing_Rules_Aggregate_Bool_Exp_Count>;
};

export type Dispensing_Rules_Aggregate_Bool_Exp_Bool_And = {
  arguments: Dispensing_Rules_Select_Column_Dispensing_Rules_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Dispensing_Rules_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Dispensing_Rules_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Dispensing_Rules_Select_Column_Dispensing_Rules_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Dispensing_Rules_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Dispensing_Rules_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Dispensing_Rules_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Dispensing_Rules_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "dispensing_rules" */
export type Dispensing_Rules_Aggregate_Fields = {
  __typename?: 'dispensing_rules_aggregate_fields';
  avg?: Maybe<Dispensing_Rules_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Dispensing_Rules_Max_Fields>;
  min?: Maybe<Dispensing_Rules_Min_Fields>;
  stddev?: Maybe<Dispensing_Rules_Stddev_Fields>;
  stddev_pop?: Maybe<Dispensing_Rules_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Dispensing_Rules_Stddev_Samp_Fields>;
  sum?: Maybe<Dispensing_Rules_Sum_Fields>;
  var_pop?: Maybe<Dispensing_Rules_Var_Pop_Fields>;
  var_samp?: Maybe<Dispensing_Rules_Var_Samp_Fields>;
  variance?: Maybe<Dispensing_Rules_Variance_Fields>;
};


/** aggregate fields of "dispensing_rules" */
export type Dispensing_Rules_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Dispensing_Rules_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "dispensing_rules" */
export type Dispensing_Rules_Aggregate_Order_By = {
  avg?: InputMaybe<Dispensing_Rules_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Dispensing_Rules_Max_Order_By>;
  min?: InputMaybe<Dispensing_Rules_Min_Order_By>;
  stddev?: InputMaybe<Dispensing_Rules_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Dispensing_Rules_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Dispensing_Rules_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Dispensing_Rules_Sum_Order_By>;
  var_pop?: InputMaybe<Dispensing_Rules_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Dispensing_Rules_Var_Samp_Order_By>;
  variance?: InputMaybe<Dispensing_Rules_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "dispensing_rules" */
export type Dispensing_Rules_Arr_Rel_Insert_Input = {
  data: Array<Dispensing_Rules_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Dispensing_Rules_On_Conflict>;
};

/** aggregate avg on columns */
export type Dispensing_Rules_Avg_Fields = {
  __typename?: 'dispensing_rules_avg_fields';
  count?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "dispensing_rules" */
export type Dispensing_Rules_Avg_Order_By = {
  count?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "dispensing_rules". All fields are combined with a logical 'AND'. */
export type Dispensing_Rules_Bool_Exp = {
  _and?: InputMaybe<Array<Dispensing_Rules_Bool_Exp>>;
  _not?: InputMaybe<Dispensing_Rules_Bool_Exp>;
  _or?: InputMaybe<Array<Dispensing_Rules_Bool_Exp>>;
  count?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  customer_asset_dispensing_rules?: InputMaybe<Customer_Asset_Dispensing_Rules_Bool_Exp>;
  customer_asset_dispensing_rules_aggregate?: InputMaybe<Customer_Asset_Dispensing_Rules_Aggregate_Bool_Exp>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  frequency?: InputMaybe<Period_Frequency_Enum_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  period_frequency?: InputMaybe<Period_Frequency_Bool_Exp>;
  qty?: InputMaybe<Numeric_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  value?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "dispensing_rules" */
export enum Dispensing_Rules_Constraint {
  /** unique or primary key constraint on columns "id" */
  DispensingRulesPkey = 'dispensing_rules_pkey'
}

/** input type for incrementing numeric columns in table "dispensing_rules" */
export type Dispensing_Rules_Inc_Input = {
  count?: InputMaybe<Scalars['numeric']['input']>;
  qty?: InputMaybe<Scalars['numeric']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "dispensing_rules" */
export type Dispensing_Rules_Insert_Input = {
  count?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  customer_asset_dispensing_rules?: InputMaybe<Customer_Asset_Dispensing_Rules_Arr_Rel_Insert_Input>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  frequency?: InputMaybe<Period_Frequency_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  period_frequency?: InputMaybe<Period_Frequency_Obj_Rel_Insert_Input>;
  qty?: InputMaybe<Scalars['numeric']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Dispensing_Rules_Max_Fields = {
  __typename?: 'dispensing_rules_max_fields';
  count?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  end_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  qty?: Maybe<Scalars['numeric']['output']>;
  start_date?: Maybe<Scalars['date']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "dispensing_rules" */
export type Dispensing_Rules_Max_Order_By = {
  count?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Dispensing_Rules_Min_Fields = {
  __typename?: 'dispensing_rules_min_fields';
  count?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  end_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  qty?: Maybe<Scalars['numeric']['output']>;
  start_date?: Maybe<Scalars['date']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "dispensing_rules" */
export type Dispensing_Rules_Min_Order_By = {
  count?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "dispensing_rules" */
export type Dispensing_Rules_Mutation_Response = {
  __typename?: 'dispensing_rules_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Dispensing_Rules>;
};

/** input type for inserting object relation for remote table "dispensing_rules" */
export type Dispensing_Rules_Obj_Rel_Insert_Input = {
  data: Dispensing_Rules_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Dispensing_Rules_On_Conflict>;
};

/** on_conflict condition type for table "dispensing_rules" */
export type Dispensing_Rules_On_Conflict = {
  constraint: Dispensing_Rules_Constraint;
  update_columns?: Array<Dispensing_Rules_Update_Column>;
  where?: InputMaybe<Dispensing_Rules_Bool_Exp>;
};

/** Ordering options when selecting data from "dispensing_rules". */
export type Dispensing_Rules_Order_By = {
  count?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  customer_asset_dispensing_rules_aggregate?: InputMaybe<Customer_Asset_Dispensing_Rules_Aggregate_Order_By>;
  end_date?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  period_frequency?: InputMaybe<Period_Frequency_Order_By>;
  qty?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: dispensing_rules */
export type Dispensing_Rules_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "dispensing_rules" */
export enum Dispensing_Rules_Select_Column {
  /** column name */
  Count = 'count',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Qty = 'qty',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Value = 'value'
}

/** select "dispensing_rules_aggregate_bool_exp_bool_and_arguments_columns" columns of table "dispensing_rules" */
export enum Dispensing_Rules_Select_Column_Dispensing_Rules_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "dispensing_rules_aggregate_bool_exp_bool_or_arguments_columns" columns of table "dispensing_rules" */
export enum Dispensing_Rules_Select_Column_Dispensing_Rules_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "dispensing_rules" */
export type Dispensing_Rules_Set_Input = {
  count?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  frequency?: InputMaybe<Period_Frequency_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  qty?: InputMaybe<Scalars['numeric']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Dispensing_Rules_Stddev_Fields = {
  __typename?: 'dispensing_rules_stddev_fields';
  count?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "dispensing_rules" */
export type Dispensing_Rules_Stddev_Order_By = {
  count?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Dispensing_Rules_Stddev_Pop_Fields = {
  __typename?: 'dispensing_rules_stddev_pop_fields';
  count?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "dispensing_rules" */
export type Dispensing_Rules_Stddev_Pop_Order_By = {
  count?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Dispensing_Rules_Stddev_Samp_Fields = {
  __typename?: 'dispensing_rules_stddev_samp_fields';
  count?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "dispensing_rules" */
export type Dispensing_Rules_Stddev_Samp_Order_By = {
  count?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "dispensing_rules" */
export type Dispensing_Rules_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dispensing_Rules_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dispensing_Rules_Stream_Cursor_Value_Input = {
  count?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  frequency?: InputMaybe<Period_Frequency_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  qty?: InputMaybe<Scalars['numeric']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Dispensing_Rules_Sum_Fields = {
  __typename?: 'dispensing_rules_sum_fields';
  count?: Maybe<Scalars['numeric']['output']>;
  qty?: Maybe<Scalars['numeric']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "dispensing_rules" */
export type Dispensing_Rules_Sum_Order_By = {
  count?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** update columns of table "dispensing_rules" */
export enum Dispensing_Rules_Update_Column {
  /** column name */
  Count = 'count',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Qty = 'qty',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Value = 'value'
}

export type Dispensing_Rules_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Dispensing_Rules_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Dispensing_Rules_Set_Input>;
  /** filter the rows which have to be updated */
  where: Dispensing_Rules_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Dispensing_Rules_Var_Pop_Fields = {
  __typename?: 'dispensing_rules_var_pop_fields';
  count?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "dispensing_rules" */
export type Dispensing_Rules_Var_Pop_Order_By = {
  count?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Dispensing_Rules_Var_Samp_Fields = {
  __typename?: 'dispensing_rules_var_samp_fields';
  count?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "dispensing_rules" */
export type Dispensing_Rules_Var_Samp_Order_By = {
  count?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Dispensing_Rules_Variance_Fields = {
  __typename?: 'dispensing_rules_variance_fields';
  count?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "dispensing_rules" */
export type Dispensing_Rules_Variance_Order_By = {
  count?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** columns and relationships of "document_type" */
export type Document_Type = {
  __typename?: 'document_type';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "document_type" */
export type Document_Type_Aggregate = {
  __typename?: 'document_type_aggregate';
  aggregate?: Maybe<Document_Type_Aggregate_Fields>;
  nodes: Array<Document_Type>;
};

/** aggregate fields of "document_type" */
export type Document_Type_Aggregate_Fields = {
  __typename?: 'document_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Document_Type_Max_Fields>;
  min?: Maybe<Document_Type_Min_Fields>;
};


/** aggregate fields of "document_type" */
export type Document_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Document_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "document_type". All fields are combined with a logical 'AND'. */
export type Document_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Document_Type_Bool_Exp>>;
  _not?: InputMaybe<Document_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Type_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  sku?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "document_type_category" */
export type Document_Type_Category = {
  __typename?: 'document_type_category';
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  organization_user_documents: Array<Organization_User_Document>;
  /** An aggregate relationship */
  organization_user_documents_aggregate: Organization_User_Document_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "document_type_category" */
export type Document_Type_CategoryOrganization_User_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Document_Order_By>>;
  where?: InputMaybe<Organization_User_Document_Bool_Exp>;
};


/** columns and relationships of "document_type_category" */
export type Document_Type_CategoryOrganization_User_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Document_Order_By>>;
  where?: InputMaybe<Organization_User_Document_Bool_Exp>;
};

/** aggregated selection of "document_type_category" */
export type Document_Type_Category_Aggregate = {
  __typename?: 'document_type_category_aggregate';
  aggregate?: Maybe<Document_Type_Category_Aggregate_Fields>;
  nodes: Array<Document_Type_Category>;
};

/** aggregate fields of "document_type_category" */
export type Document_Type_Category_Aggregate_Fields = {
  __typename?: 'document_type_category_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Document_Type_Category_Max_Fields>;
  min?: Maybe<Document_Type_Category_Min_Fields>;
};


/** aggregate fields of "document_type_category" */
export type Document_Type_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Document_Type_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "document_type_category". All fields are combined with a logical 'AND'. */
export type Document_Type_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Document_Type_Category_Bool_Exp>>;
  _not?: InputMaybe<Document_Type_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Type_Category_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  organization_user_documents?: InputMaybe<Organization_User_Document_Bool_Exp>;
  organization_user_documents_aggregate?: InputMaybe<Organization_User_Document_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "document_type_category" */
export enum Document_Type_Category_Constraint {
  /** unique or primary key constraint on columns "value" */
  DocumentTypeCategoryPkey = 'document_type_category_pkey'
}

export enum Document_Type_Category_Enum {
  /** DRIVER_LICENSE */
  DriverLicense = 'DRIVER_LICENSE',
  /** OTHER */
  Other = 'OTHER',
  /** PO */
  Po = 'PO'
}

/** Boolean expression to compare columns of type "document_type_category_enum". All fields are combined with logical 'AND'. */
export type Document_Type_Category_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Document_Type_Category_Enum>;
  _in?: InputMaybe<Array<Document_Type_Category_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Document_Type_Category_Enum>;
  _nin?: InputMaybe<Array<Document_Type_Category_Enum>>;
};

/** input type for inserting data into table "document_type_category" */
export type Document_Type_Category_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  organization_user_documents?: InputMaybe<Organization_User_Document_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Document_Type_Category_Max_Fields = {
  __typename?: 'document_type_category_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Document_Type_Category_Min_Fields = {
  __typename?: 'document_type_category_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "document_type_category" */
export type Document_Type_Category_Mutation_Response = {
  __typename?: 'document_type_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Document_Type_Category>;
};

/** input type for inserting object relation for remote table "document_type_category" */
export type Document_Type_Category_Obj_Rel_Insert_Input = {
  data: Document_Type_Category_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Document_Type_Category_On_Conflict>;
};

/** on_conflict condition type for table "document_type_category" */
export type Document_Type_Category_On_Conflict = {
  constraint: Document_Type_Category_Constraint;
  update_columns?: Array<Document_Type_Category_Update_Column>;
  where?: InputMaybe<Document_Type_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "document_type_category". */
export type Document_Type_Category_Order_By = {
  comment?: InputMaybe<Order_By>;
  organization_user_documents_aggregate?: InputMaybe<Organization_User_Document_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: document_type_category */
export type Document_Type_Category_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "document_type_category" */
export enum Document_Type_Category_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "document_type_category" */
export type Document_Type_Category_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "document_type_category" */
export type Document_Type_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Type_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Type_Category_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "document_type_category" */
export enum Document_Type_Category_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Document_Type_Category_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Document_Type_Category_Set_Input>;
  /** filter the rows which have to be updated */
  where: Document_Type_Category_Bool_Exp;
};

/** unique or primary key constraints on table "document_type" */
export enum Document_Type_Constraint {
  /** unique or primary key constraint on columns "id" */
  DocumentTypePkey = 'document_type_pkey'
}

/** input type for inserting data into table "document_type" */
export type Document_Type_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Document_Type_Max_Fields = {
  __typename?: 'document_type_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Document_Type_Min_Fields = {
  __typename?: 'document_type_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "document_type" */
export type Document_Type_Mutation_Response = {
  __typename?: 'document_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Document_Type>;
};

/** on_conflict condition type for table "document_type" */
export type Document_Type_On_Conflict = {
  constraint: Document_Type_Constraint;
  update_columns?: Array<Document_Type_Update_Column>;
  where?: InputMaybe<Document_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "document_type". */
export type Document_Type_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  sku?: InputMaybe<Order_By>;
};

/** primary key columns input for table: document_type */
export type Document_Type_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "document_type" */
export enum Document_Type_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  Sku = 'sku'
}

/** input type for updating data in table "document_type" */
export type Document_Type_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "document_type" */
export type Document_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Type_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "document_type" */
export enum Document_Type_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  Sku = 'sku'
}

export type Document_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Document_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Document_Type_Bool_Exp;
};

/** columns and relationships of "documents" */
export type Documents = {
  __typename?: 'documents';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  document_type_id: Scalars['uuid']['output'];
  expiry_date?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  is_approved: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  organization_user_documents: Array<Organization_User_Document>;
  /** An aggregate relationship */
  organization_user_documents_aggregate: Organization_User_Document_Aggregate;
  /** An array relationship */
  partner_user_documents: Array<Partner_User_Document>;
  /** An aggregate relationship */
  partner_user_documents_aggregate: Partner_User_Document_Aggregate;
  /** An array relationship */
  product_documents: Array<Product_Document>;
  /** An aggregate relationship */
  product_documents_aggregate: Product_Document_Aggregate;
  /** An array relationship */
  role_documents: Array<Role_Document>;
  /** An aggregate relationship */
  role_documents_aggregate: Role_Document_Aggregate;
  url?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "documents" */
export type DocumentsOrganization_User_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Document_Order_By>>;
  where?: InputMaybe<Organization_User_Document_Bool_Exp>;
};


/** columns and relationships of "documents" */
export type DocumentsOrganization_User_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Document_Order_By>>;
  where?: InputMaybe<Organization_User_Document_Bool_Exp>;
};


/** columns and relationships of "documents" */
export type DocumentsPartner_User_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Partner_User_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_User_Document_Order_By>>;
  where?: InputMaybe<Partner_User_Document_Bool_Exp>;
};


/** columns and relationships of "documents" */
export type DocumentsPartner_User_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_User_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_User_Document_Order_By>>;
  where?: InputMaybe<Partner_User_Document_Bool_Exp>;
};


/** columns and relationships of "documents" */
export type DocumentsProduct_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Product_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Document_Order_By>>;
  where?: InputMaybe<Product_Document_Bool_Exp>;
};


/** columns and relationships of "documents" */
export type DocumentsProduct_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Document_Order_By>>;
  where?: InputMaybe<Product_Document_Bool_Exp>;
};


/** columns and relationships of "documents" */
export type DocumentsRole_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Role_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Role_Document_Order_By>>;
  where?: InputMaybe<Role_Document_Bool_Exp>;
};


/** columns and relationships of "documents" */
export type DocumentsRole_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Role_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Role_Document_Order_By>>;
  where?: InputMaybe<Role_Document_Bool_Exp>;
};

/** aggregated selection of "documents" */
export type Documents_Aggregate = {
  __typename?: 'documents_aggregate';
  aggregate?: Maybe<Documents_Aggregate_Fields>;
  nodes: Array<Documents>;
};

/** aggregate fields of "documents" */
export type Documents_Aggregate_Fields = {
  __typename?: 'documents_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Documents_Max_Fields>;
  min?: Maybe<Documents_Min_Fields>;
};


/** aggregate fields of "documents" */
export type Documents_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Documents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "documents". All fields are combined with a logical 'AND'. */
export type Documents_Bool_Exp = {
  _and?: InputMaybe<Array<Documents_Bool_Exp>>;
  _not?: InputMaybe<Documents_Bool_Exp>;
  _or?: InputMaybe<Array<Documents_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  document_type_id?: InputMaybe<Uuid_Comparison_Exp>;
  expiry_date?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_approved?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  organization_user_documents?: InputMaybe<Organization_User_Document_Bool_Exp>;
  organization_user_documents_aggregate?: InputMaybe<Organization_User_Document_Aggregate_Bool_Exp>;
  partner_user_documents?: InputMaybe<Partner_User_Document_Bool_Exp>;
  partner_user_documents_aggregate?: InputMaybe<Partner_User_Document_Aggregate_Bool_Exp>;
  product_documents?: InputMaybe<Product_Document_Bool_Exp>;
  product_documents_aggregate?: InputMaybe<Product_Document_Aggregate_Bool_Exp>;
  role_documents?: InputMaybe<Role_Document_Bool_Exp>;
  role_documents_aggregate?: InputMaybe<Role_Document_Aggregate_Bool_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "documents" */
export enum Documents_Constraint {
  /** unique or primary key constraint on columns "id" */
  DocumentsPkey = 'documents_pkey'
}

/** input type for inserting data into table "documents" */
export type Documents_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  document_type_id?: InputMaybe<Scalars['uuid']['input']>;
  expiry_date?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_approved?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_user_documents?: InputMaybe<Organization_User_Document_Arr_Rel_Insert_Input>;
  partner_user_documents?: InputMaybe<Partner_User_Document_Arr_Rel_Insert_Input>;
  product_documents?: InputMaybe<Product_Document_Arr_Rel_Insert_Input>;
  role_documents?: InputMaybe<Role_Document_Arr_Rel_Insert_Input>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Documents_Max_Fields = {
  __typename?: 'documents_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  document_type_id?: Maybe<Scalars['uuid']['output']>;
  expiry_date?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Documents_Min_Fields = {
  __typename?: 'documents_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  document_type_id?: Maybe<Scalars['uuid']['output']>;
  expiry_date?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "documents" */
export type Documents_Mutation_Response = {
  __typename?: 'documents_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Documents>;
};

/** input type for inserting object relation for remote table "documents" */
export type Documents_Obj_Rel_Insert_Input = {
  data: Documents_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Documents_On_Conflict>;
};

/** on_conflict condition type for table "documents" */
export type Documents_On_Conflict = {
  constraint: Documents_Constraint;
  update_columns?: Array<Documents_Update_Column>;
  where?: InputMaybe<Documents_Bool_Exp>;
};

/** Ordering options when selecting data from "documents". */
export type Documents_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document_type_id?: InputMaybe<Order_By>;
  expiry_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_approved?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_user_documents_aggregate?: InputMaybe<Organization_User_Document_Aggregate_Order_By>;
  partner_user_documents_aggregate?: InputMaybe<Partner_User_Document_Aggregate_Order_By>;
  product_documents_aggregate?: InputMaybe<Product_Document_Aggregate_Order_By>;
  role_documents_aggregate?: InputMaybe<Role_Document_Aggregate_Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: documents */
export type Documents_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "documents" */
export enum Documents_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentTypeId = 'document_type_id',
  /** column name */
  ExpiryDate = 'expiry_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsApproved = 'is_approved',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "documents" */
export type Documents_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  document_type_id?: InputMaybe<Scalars['uuid']['input']>;
  expiry_date?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_approved?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "documents" */
export type Documents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Documents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Documents_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  document_type_id?: InputMaybe<Scalars['uuid']['input']>;
  expiry_date?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_approved?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "documents" */
export enum Documents_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentTypeId = 'document_type_id',
  /** column name */
  ExpiryDate = 'expiry_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsApproved = 'is_approved',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Url = 'url'
}

export type Documents_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Documents_Set_Input>;
  /** filter the rows which have to be updated */
  where: Documents_Bool_Exp;
};

/** columns and relationships of "driver_duty_log" */
export type Driver_Duty_Log = {
  __typename?: 'driver_duty_log';
  category: Login_Type_Enum;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  driver_duty_log?: Maybe<Driver_Duty_Log>;
  /** An array relationship */
  driver_duty_logs: Array<Driver_Duty_Log>;
  /** An aggregate relationship */
  driver_duty_logs_aggregate: Driver_Duty_Log_Aggregate;
  /** An array relationship */
  driver_duty_photos: Array<Driver_Duty_Photos>;
  /** An aggregate relationship */
  driver_duty_photos_aggregate: Driver_Duty_Photos_Aggregate;
  /** An object relationship */
  driver_vehicle?: Maybe<Driver_Vehicle>;
  driver_vehicle_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  location?: Maybe<Scalars['point']['output']>;
  loginTime?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  login_type: Login_Type;
  name: Scalars['String']['output'];
  odometer: Scalars['String']['output'];
  parent_id?: Maybe<Scalars['uuid']['output']>;
  refueller?: Maybe<Scalars['String']['output']>;
  totallizer: Scalars['String']['output'];
};


/** columns and relationships of "driver_duty_log" */
export type Driver_Duty_LogDriver_Duty_LogsArgs = {
  distinct_on?: InputMaybe<Array<Driver_Duty_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Duty_Log_Order_By>>;
  where?: InputMaybe<Driver_Duty_Log_Bool_Exp>;
};


/** columns and relationships of "driver_duty_log" */
export type Driver_Duty_LogDriver_Duty_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Driver_Duty_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Duty_Log_Order_By>>;
  where?: InputMaybe<Driver_Duty_Log_Bool_Exp>;
};


/** columns and relationships of "driver_duty_log" */
export type Driver_Duty_LogDriver_Duty_PhotosArgs = {
  distinct_on?: InputMaybe<Array<Driver_Duty_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Duty_Photos_Order_By>>;
  where?: InputMaybe<Driver_Duty_Photos_Bool_Exp>;
};


/** columns and relationships of "driver_duty_log" */
export type Driver_Duty_LogDriver_Duty_Photos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Driver_Duty_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Duty_Photos_Order_By>>;
  where?: InputMaybe<Driver_Duty_Photos_Bool_Exp>;
};

/** aggregated selection of "driver_duty_log" */
export type Driver_Duty_Log_Aggregate = {
  __typename?: 'driver_duty_log_aggregate';
  aggregate?: Maybe<Driver_Duty_Log_Aggregate_Fields>;
  nodes: Array<Driver_Duty_Log>;
};

export type Driver_Duty_Log_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Driver_Duty_Log_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Driver_Duty_Log_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Driver_Duty_Log_Aggregate_Bool_Exp_Count>;
};

export type Driver_Duty_Log_Aggregate_Bool_Exp_Bool_And = {
  arguments: Driver_Duty_Log_Select_Column_Driver_Duty_Log_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Driver_Duty_Log_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Driver_Duty_Log_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Driver_Duty_Log_Select_Column_Driver_Duty_Log_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Driver_Duty_Log_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Driver_Duty_Log_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Driver_Duty_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Driver_Duty_Log_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "driver_duty_log" */
export type Driver_Duty_Log_Aggregate_Fields = {
  __typename?: 'driver_duty_log_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Driver_Duty_Log_Max_Fields>;
  min?: Maybe<Driver_Duty_Log_Min_Fields>;
};


/** aggregate fields of "driver_duty_log" */
export type Driver_Duty_Log_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Driver_Duty_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "driver_duty_log" */
export type Driver_Duty_Log_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Driver_Duty_Log_Max_Order_By>;
  min?: InputMaybe<Driver_Duty_Log_Min_Order_By>;
};

/** input type for inserting array relation for remote table "driver_duty_log" */
export type Driver_Duty_Log_Arr_Rel_Insert_Input = {
  data: Array<Driver_Duty_Log_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Driver_Duty_Log_On_Conflict>;
};

/** Boolean expression to filter rows from the table "driver_duty_log". All fields are combined with a logical 'AND'. */
export type Driver_Duty_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Driver_Duty_Log_Bool_Exp>>;
  _not?: InputMaybe<Driver_Duty_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Driver_Duty_Log_Bool_Exp>>;
  category?: InputMaybe<Login_Type_Enum_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  driver_duty_log?: InputMaybe<Driver_Duty_Log_Bool_Exp>;
  driver_duty_logs?: InputMaybe<Driver_Duty_Log_Bool_Exp>;
  driver_duty_logs_aggregate?: InputMaybe<Driver_Duty_Log_Aggregate_Bool_Exp>;
  driver_duty_photos?: InputMaybe<Driver_Duty_Photos_Bool_Exp>;
  driver_duty_photos_aggregate?: InputMaybe<Driver_Duty_Photos_Aggregate_Bool_Exp>;
  driver_vehicle?: InputMaybe<Driver_Vehicle_Bool_Exp>;
  driver_vehicle_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<Point_Comparison_Exp>;
  loginTime?: InputMaybe<Timestamp_Comparison_Exp>;
  login_type?: InputMaybe<Login_Type_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  odometer?: InputMaybe<String_Comparison_Exp>;
  parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  refueller?: InputMaybe<String_Comparison_Exp>;
  totallizer?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "driver_duty_log" */
export enum Driver_Duty_Log_Constraint {
  /** unique or primary key constraint on columns "id" */
  DriverDutyLogPkey = 'driver_duty_log_pkey'
}

/** input type for inserting data into table "driver_duty_log" */
export type Driver_Duty_Log_Insert_Input = {
  category?: InputMaybe<Login_Type_Enum>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  driver_duty_log?: InputMaybe<Driver_Duty_Log_Obj_Rel_Insert_Input>;
  driver_duty_logs?: InputMaybe<Driver_Duty_Log_Arr_Rel_Insert_Input>;
  driver_duty_photos?: InputMaybe<Driver_Duty_Photos_Arr_Rel_Insert_Input>;
  driver_vehicle?: InputMaybe<Driver_Vehicle_Obj_Rel_Insert_Input>;
  driver_vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['point']['input']>;
  loginTime?: InputMaybe<Scalars['timestamp']['input']>;
  login_type?: InputMaybe<Login_Type_Obj_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  odometer?: InputMaybe<Scalars['String']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  refueller?: InputMaybe<Scalars['String']['input']>;
  totallizer?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Driver_Duty_Log_Max_Fields = {
  __typename?: 'driver_duty_log_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  driver_vehicle_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  loginTime?: Maybe<Scalars['timestamp']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  odometer?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  refueller?: Maybe<Scalars['String']['output']>;
  totallizer?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "driver_duty_log" */
export type Driver_Duty_Log_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  driver_vehicle_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  loginTime?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  odometer?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  refueller?: InputMaybe<Order_By>;
  totallizer?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Driver_Duty_Log_Min_Fields = {
  __typename?: 'driver_duty_log_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  driver_vehicle_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  loginTime?: Maybe<Scalars['timestamp']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  odometer?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  refueller?: Maybe<Scalars['String']['output']>;
  totallizer?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "driver_duty_log" */
export type Driver_Duty_Log_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  driver_vehicle_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  loginTime?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  odometer?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  refueller?: InputMaybe<Order_By>;
  totallizer?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "driver_duty_log" */
export type Driver_Duty_Log_Mutation_Response = {
  __typename?: 'driver_duty_log_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Driver_Duty_Log>;
};

/** input type for inserting object relation for remote table "driver_duty_log" */
export type Driver_Duty_Log_Obj_Rel_Insert_Input = {
  data: Driver_Duty_Log_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Driver_Duty_Log_On_Conflict>;
};

/** on_conflict condition type for table "driver_duty_log" */
export type Driver_Duty_Log_On_Conflict = {
  constraint: Driver_Duty_Log_Constraint;
  update_columns?: Array<Driver_Duty_Log_Update_Column>;
  where?: InputMaybe<Driver_Duty_Log_Bool_Exp>;
};

/** Ordering options when selecting data from "driver_duty_log". */
export type Driver_Duty_Log_Order_By = {
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  driver_duty_log?: InputMaybe<Driver_Duty_Log_Order_By>;
  driver_duty_logs_aggregate?: InputMaybe<Driver_Duty_Log_Aggregate_Order_By>;
  driver_duty_photos_aggregate?: InputMaybe<Driver_Duty_Photos_Aggregate_Order_By>;
  driver_vehicle?: InputMaybe<Driver_Vehicle_Order_By>;
  driver_vehicle_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  loginTime?: InputMaybe<Order_By>;
  login_type?: InputMaybe<Login_Type_Order_By>;
  name?: InputMaybe<Order_By>;
  odometer?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  refueller?: InputMaybe<Order_By>;
  totallizer?: InputMaybe<Order_By>;
};

/** primary key columns input for table: driver_duty_log */
export type Driver_Duty_Log_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "driver_duty_log" */
export enum Driver_Duty_Log_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DriverVehicleId = 'driver_vehicle_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Location = 'location',
  /** column name */
  LoginTime = 'loginTime',
  /** column name */
  Name = 'name',
  /** column name */
  Odometer = 'odometer',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  Refueller = 'refueller',
  /** column name */
  Totallizer = 'totallizer'
}

/** select "driver_duty_log_aggregate_bool_exp_bool_and_arguments_columns" columns of table "driver_duty_log" */
export enum Driver_Duty_Log_Select_Column_Driver_Duty_Log_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "driver_duty_log_aggregate_bool_exp_bool_or_arguments_columns" columns of table "driver_duty_log" */
export enum Driver_Duty_Log_Select_Column_Driver_Duty_Log_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "driver_duty_log" */
export type Driver_Duty_Log_Set_Input = {
  category?: InputMaybe<Login_Type_Enum>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  driver_vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['point']['input']>;
  loginTime?: InputMaybe<Scalars['timestamp']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  odometer?: InputMaybe<Scalars['String']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  refueller?: InputMaybe<Scalars['String']['input']>;
  totallizer?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "driver_duty_log" */
export type Driver_Duty_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Driver_Duty_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Driver_Duty_Log_Stream_Cursor_Value_Input = {
  category?: InputMaybe<Login_Type_Enum>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  driver_vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['point']['input']>;
  loginTime?: InputMaybe<Scalars['timestamp']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  odometer?: InputMaybe<Scalars['String']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  refueller?: InputMaybe<Scalars['String']['input']>;
  totallizer?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "driver_duty_log" */
export enum Driver_Duty_Log_Update_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DriverVehicleId = 'driver_vehicle_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Location = 'location',
  /** column name */
  LoginTime = 'loginTime',
  /** column name */
  Name = 'name',
  /** column name */
  Odometer = 'odometer',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  Refueller = 'refueller',
  /** column name */
  Totallizer = 'totallizer'
}

export type Driver_Duty_Log_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Driver_Duty_Log_Set_Input>;
  /** filter the rows which have to be updated */
  where: Driver_Duty_Log_Bool_Exp;
};

/** columns and relationships of "driver_duty_photos" */
export type Driver_Duty_Photos = {
  __typename?: 'driver_duty_photos';
  category: Photo_Type_Enum;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  driver_duty_log: Driver_Duty_Log;
  driver_duty_log_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  photo_type: Photo_Type;
  url: Scalars['String']['output'];
};

/** aggregated selection of "driver_duty_photos" */
export type Driver_Duty_Photos_Aggregate = {
  __typename?: 'driver_duty_photos_aggregate';
  aggregate?: Maybe<Driver_Duty_Photos_Aggregate_Fields>;
  nodes: Array<Driver_Duty_Photos>;
};

export type Driver_Duty_Photos_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Driver_Duty_Photos_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Driver_Duty_Photos_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Driver_Duty_Photos_Aggregate_Bool_Exp_Count>;
};

export type Driver_Duty_Photos_Aggregate_Bool_Exp_Bool_And = {
  arguments: Driver_Duty_Photos_Select_Column_Driver_Duty_Photos_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Driver_Duty_Photos_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Driver_Duty_Photos_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Driver_Duty_Photos_Select_Column_Driver_Duty_Photos_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Driver_Duty_Photos_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Driver_Duty_Photos_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Driver_Duty_Photos_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Driver_Duty_Photos_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "driver_duty_photos" */
export type Driver_Duty_Photos_Aggregate_Fields = {
  __typename?: 'driver_duty_photos_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Driver_Duty_Photos_Max_Fields>;
  min?: Maybe<Driver_Duty_Photos_Min_Fields>;
};


/** aggregate fields of "driver_duty_photos" */
export type Driver_Duty_Photos_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Driver_Duty_Photos_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "driver_duty_photos" */
export type Driver_Duty_Photos_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Driver_Duty_Photos_Max_Order_By>;
  min?: InputMaybe<Driver_Duty_Photos_Min_Order_By>;
};

/** input type for inserting array relation for remote table "driver_duty_photos" */
export type Driver_Duty_Photos_Arr_Rel_Insert_Input = {
  data: Array<Driver_Duty_Photos_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Driver_Duty_Photos_On_Conflict>;
};

/** Boolean expression to filter rows from the table "driver_duty_photos". All fields are combined with a logical 'AND'. */
export type Driver_Duty_Photos_Bool_Exp = {
  _and?: InputMaybe<Array<Driver_Duty_Photos_Bool_Exp>>;
  _not?: InputMaybe<Driver_Duty_Photos_Bool_Exp>;
  _or?: InputMaybe<Array<Driver_Duty_Photos_Bool_Exp>>;
  category?: InputMaybe<Photo_Type_Enum_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  driver_duty_log?: InputMaybe<Driver_Duty_Log_Bool_Exp>;
  driver_duty_log_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  photo_type?: InputMaybe<Photo_Type_Bool_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "driver_duty_photos" */
export enum Driver_Duty_Photos_Constraint {
  /** unique or primary key constraint on columns "id" */
  DriverDutyPhotosPkey = 'driver_duty_photos_pkey'
}

/** input type for inserting data into table "driver_duty_photos" */
export type Driver_Duty_Photos_Insert_Input = {
  category?: InputMaybe<Photo_Type_Enum>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  driver_duty_log?: InputMaybe<Driver_Duty_Log_Obj_Rel_Insert_Input>;
  driver_duty_log_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  photo_type?: InputMaybe<Photo_Type_Obj_Rel_Insert_Input>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Driver_Duty_Photos_Max_Fields = {
  __typename?: 'driver_duty_photos_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  driver_duty_log_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "driver_duty_photos" */
export type Driver_Duty_Photos_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  driver_duty_log_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Driver_Duty_Photos_Min_Fields = {
  __typename?: 'driver_duty_photos_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  driver_duty_log_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "driver_duty_photos" */
export type Driver_Duty_Photos_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  driver_duty_log_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "driver_duty_photos" */
export type Driver_Duty_Photos_Mutation_Response = {
  __typename?: 'driver_duty_photos_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Driver_Duty_Photos>;
};

/** on_conflict condition type for table "driver_duty_photos" */
export type Driver_Duty_Photos_On_Conflict = {
  constraint: Driver_Duty_Photos_Constraint;
  update_columns?: Array<Driver_Duty_Photos_Update_Column>;
  where?: InputMaybe<Driver_Duty_Photos_Bool_Exp>;
};

/** Ordering options when selecting data from "driver_duty_photos". */
export type Driver_Duty_Photos_Order_By = {
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  driver_duty_log?: InputMaybe<Driver_Duty_Log_Order_By>;
  driver_duty_log_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  photo_type?: InputMaybe<Photo_Type_Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: driver_duty_photos */
export type Driver_Duty_Photos_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "driver_duty_photos" */
export enum Driver_Duty_Photos_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DriverDutyLogId = 'driver_duty_log_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Url = 'url'
}

/** select "driver_duty_photos_aggregate_bool_exp_bool_and_arguments_columns" columns of table "driver_duty_photos" */
export enum Driver_Duty_Photos_Select_Column_Driver_Duty_Photos_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "driver_duty_photos_aggregate_bool_exp_bool_or_arguments_columns" columns of table "driver_duty_photos" */
export enum Driver_Duty_Photos_Select_Column_Driver_Duty_Photos_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "driver_duty_photos" */
export type Driver_Duty_Photos_Set_Input = {
  category?: InputMaybe<Photo_Type_Enum>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  driver_duty_log_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "driver_duty_photos" */
export type Driver_Duty_Photos_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Driver_Duty_Photos_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Driver_Duty_Photos_Stream_Cursor_Value_Input = {
  category?: InputMaybe<Photo_Type_Enum>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  driver_duty_log_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "driver_duty_photos" */
export enum Driver_Duty_Photos_Update_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DriverDutyLogId = 'driver_duty_log_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Url = 'url'
}

export type Driver_Duty_Photos_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Driver_Duty_Photos_Set_Input>;
  /** filter the rows which have to be updated */
  where: Driver_Duty_Photos_Bool_Exp;
};

/** columns and relationships of "driver_permit" */
export type Driver_Permit = {
  __typename?: 'driver_permit';
  created_at: Scalars['timestamptz']['output'];
  driver_id: Scalars['uuid']['output'];
  expiry_date?: Maybe<Scalars['date']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified: Scalars['timestamptz']['output'];
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  permit: Permit;
  permit_id: Scalars['uuid']['output'];
  /** An object relationship */
  user: User;
};

/** aggregated selection of "driver_permit" */
export type Driver_Permit_Aggregate = {
  __typename?: 'driver_permit_aggregate';
  aggregate?: Maybe<Driver_Permit_Aggregate_Fields>;
  nodes: Array<Driver_Permit>;
};

export type Driver_Permit_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Driver_Permit_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Driver_Permit_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Driver_Permit_Aggregate_Bool_Exp_Count>;
};

export type Driver_Permit_Aggregate_Bool_Exp_Bool_And = {
  arguments: Driver_Permit_Select_Column_Driver_Permit_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Driver_Permit_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Driver_Permit_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Driver_Permit_Select_Column_Driver_Permit_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Driver_Permit_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Driver_Permit_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Driver_Permit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Driver_Permit_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "driver_permit" */
export type Driver_Permit_Aggregate_Fields = {
  __typename?: 'driver_permit_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Driver_Permit_Max_Fields>;
  min?: Maybe<Driver_Permit_Min_Fields>;
};


/** aggregate fields of "driver_permit" */
export type Driver_Permit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Driver_Permit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "driver_permit" */
export type Driver_Permit_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Driver_Permit_Max_Order_By>;
  min?: InputMaybe<Driver_Permit_Min_Order_By>;
};

/** input type for inserting array relation for remote table "driver_permit" */
export type Driver_Permit_Arr_Rel_Insert_Input = {
  data: Array<Driver_Permit_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Driver_Permit_On_Conflict>;
};

/** Boolean expression to filter rows from the table "driver_permit". All fields are combined with a logical 'AND'. */
export type Driver_Permit_Bool_Exp = {
  _and?: InputMaybe<Array<Driver_Permit_Bool_Exp>>;
  _not?: InputMaybe<Driver_Permit_Bool_Exp>;
  _or?: InputMaybe<Array<Driver_Permit_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  driver_id?: InputMaybe<Uuid_Comparison_Exp>;
  expiry_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  permit?: InputMaybe<Permit_Bool_Exp>;
  permit_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "driver_permit" */
export enum Driver_Permit_Constraint {
  /** unique or primary key constraint on columns "permit_id", "driver_id" */
  DriverPermitDriverIdPermitIdKey = 'driver_permit_driver_id_permit_id_key',
  /** unique or primary key constraint on columns "id" */
  DriverPermitPkey = 'driver_permit_pkey'
}

/** input type for inserting data into table "driver_permit" */
export type Driver_Permit_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  driver_id?: InputMaybe<Scalars['uuid']['input']>;
  expiry_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  permit?: InputMaybe<Permit_Obj_Rel_Insert_Input>;
  permit_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Driver_Permit_Max_Fields = {
  __typename?: 'driver_permit_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  driver_id?: Maybe<Scalars['uuid']['output']>;
  expiry_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  permit_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "driver_permit" */
export type Driver_Permit_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  driver_id?: InputMaybe<Order_By>;
  expiry_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  permit_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Driver_Permit_Min_Fields = {
  __typename?: 'driver_permit_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  driver_id?: Maybe<Scalars['uuid']['output']>;
  expiry_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  permit_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "driver_permit" */
export type Driver_Permit_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  driver_id?: InputMaybe<Order_By>;
  expiry_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  permit_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "driver_permit" */
export type Driver_Permit_Mutation_Response = {
  __typename?: 'driver_permit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Driver_Permit>;
};

/** on_conflict condition type for table "driver_permit" */
export type Driver_Permit_On_Conflict = {
  constraint: Driver_Permit_Constraint;
  update_columns?: Array<Driver_Permit_Update_Column>;
  where?: InputMaybe<Driver_Permit_Bool_Exp>;
};

/** Ordering options when selecting data from "driver_permit". */
export type Driver_Permit_Order_By = {
  created_at?: InputMaybe<Order_By>;
  driver_id?: InputMaybe<Order_By>;
  expiry_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  permit?: InputMaybe<Permit_Order_By>;
  permit_id?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: driver_permit */
export type Driver_Permit_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "driver_permit" */
export enum Driver_Permit_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DriverId = 'driver_id',
  /** column name */
  ExpiryDate = 'expiry_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PermitId = 'permit_id'
}

/** select "driver_permit_aggregate_bool_exp_bool_and_arguments_columns" columns of table "driver_permit" */
export enum Driver_Permit_Select_Column_Driver_Permit_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "driver_permit_aggregate_bool_exp_bool_or_arguments_columns" columns of table "driver_permit" */
export enum Driver_Permit_Select_Column_Driver_Permit_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "driver_permit" */
export type Driver_Permit_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  driver_id?: InputMaybe<Scalars['uuid']['input']>;
  expiry_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  permit_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "driver_permit" */
export type Driver_Permit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Driver_Permit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Driver_Permit_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  driver_id?: InputMaybe<Scalars['uuid']['input']>;
  expiry_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  permit_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "driver_permit" */
export enum Driver_Permit_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DriverId = 'driver_id',
  /** column name */
  ExpiryDate = 'expiry_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PermitId = 'permit_id'
}

export type Driver_Permit_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Driver_Permit_Set_Input>;
  /** filter the rows which have to be updated */
  where: Driver_Permit_Bool_Exp;
};

/** columns and relationships of "driver_vehicle" */
export type Driver_Vehicle = {
  __typename?: 'driver_vehicle';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  driver_duty_logs: Array<Driver_Duty_Log>;
  /** An aggregate relationship */
  driver_duty_logs_aggregate: Driver_Duty_Log_Aggregate;
  driver_id: Scalars['uuid']['output'];
  /** An array relationship */
  driver_vehicle_issues: Array<Driver_Vehicle_Issue>;
  /** An aggregate relationship */
  driver_vehicle_issues_aggregate: Driver_Vehicle_Issue_Aggregate;
  /** An array relationship */
  driver_vehicle_locations: Array<Driver_Vehicle_Location>;
  /** An aggregate relationship */
  driver_vehicle_locations_aggregate: Driver_Vehicle_Location_Aggregate;
  /** An array relationship */
  fillup_requests: Array<Fillup_Request>;
  /** An aggregate relationship */
  fillup_requests_aggregate: Fillup_Request_Aggregate;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  login_type?: Maybe<Login_Type>;
  /** An array relationship */
  order_schedulers: Array<Order_Scheduler>;
  /** An aggregate relationship */
  order_schedulers_aggregate: Order_Scheduler_Aggregate;
  /** An object relationship */
  partner_vehicle_state?: Maybe<Partner_Vehicle_State>;
  /** An array relationship */
  shift_schedules: Array<Shift_Schedule>;
  /** An aggregate relationship */
  shift_schedules_aggregate: Shift_Schedule_Aggregate;
  state?: Maybe<Login_Type_Enum>;
  status?: Maybe<Partner_Vehicle_State_Enum>;
  /** An array relationship */
  tasks: Array<Task>;
  /** An aggregate relationship */
  tasks_aggregate: Task_Aggregate;
  /** An object relationship */
  user: User;
  /** An object relationship */
  vehicle: Vehicle;
  vehicle_id: Scalars['uuid']['output'];
  /** An array relationship */
  vendor_order_logs: Array<Vendor_Order_Logs>;
  /** An aggregate relationship */
  vendor_order_logs_aggregate: Vendor_Order_Logs_Aggregate;
};


/** columns and relationships of "driver_vehicle" */
export type Driver_VehicleDriver_Duty_LogsArgs = {
  distinct_on?: InputMaybe<Array<Driver_Duty_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Duty_Log_Order_By>>;
  where?: InputMaybe<Driver_Duty_Log_Bool_Exp>;
};


/** columns and relationships of "driver_vehicle" */
export type Driver_VehicleDriver_Duty_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Driver_Duty_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Duty_Log_Order_By>>;
  where?: InputMaybe<Driver_Duty_Log_Bool_Exp>;
};


/** columns and relationships of "driver_vehicle" */
export type Driver_VehicleDriver_Vehicle_IssuesArgs = {
  distinct_on?: InputMaybe<Array<Driver_Vehicle_Issue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Vehicle_Issue_Order_By>>;
  where?: InputMaybe<Driver_Vehicle_Issue_Bool_Exp>;
};


/** columns and relationships of "driver_vehicle" */
export type Driver_VehicleDriver_Vehicle_Issues_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Driver_Vehicle_Issue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Vehicle_Issue_Order_By>>;
  where?: InputMaybe<Driver_Vehicle_Issue_Bool_Exp>;
};


/** columns and relationships of "driver_vehicle" */
export type Driver_VehicleDriver_Vehicle_LocationsArgs = {
  distinct_on?: InputMaybe<Array<Driver_Vehicle_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Vehicle_Location_Order_By>>;
  where?: InputMaybe<Driver_Vehicle_Location_Bool_Exp>;
};


/** columns and relationships of "driver_vehicle" */
export type Driver_VehicleDriver_Vehicle_Locations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Driver_Vehicle_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Vehicle_Location_Order_By>>;
  where?: InputMaybe<Driver_Vehicle_Location_Bool_Exp>;
};


/** columns and relationships of "driver_vehicle" */
export type Driver_VehicleFillup_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Fillup_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fillup_Request_Order_By>>;
  where?: InputMaybe<Fillup_Request_Bool_Exp>;
};


/** columns and relationships of "driver_vehicle" */
export type Driver_VehicleFillup_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fillup_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fillup_Request_Order_By>>;
  where?: InputMaybe<Fillup_Request_Bool_Exp>;
};


/** columns and relationships of "driver_vehicle" */
export type Driver_VehicleOrder_SchedulersArgs = {
  distinct_on?: InputMaybe<Array<Order_Scheduler_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Scheduler_Order_By>>;
  where?: InputMaybe<Order_Scheduler_Bool_Exp>;
};


/** columns and relationships of "driver_vehicle" */
export type Driver_VehicleOrder_Schedulers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Scheduler_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Scheduler_Order_By>>;
  where?: InputMaybe<Order_Scheduler_Bool_Exp>;
};


/** columns and relationships of "driver_vehicle" */
export type Driver_VehicleShift_SchedulesArgs = {
  distinct_on?: InputMaybe<Array<Shift_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shift_Schedule_Order_By>>;
  where?: InputMaybe<Shift_Schedule_Bool_Exp>;
};


/** columns and relationships of "driver_vehicle" */
export type Driver_VehicleShift_Schedules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shift_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shift_Schedule_Order_By>>;
  where?: InputMaybe<Shift_Schedule_Bool_Exp>;
};


/** columns and relationships of "driver_vehicle" */
export type Driver_VehicleTasksArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


/** columns and relationships of "driver_vehicle" */
export type Driver_VehicleTasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


/** columns and relationships of "driver_vehicle" */
export type Driver_VehicleVendor_Order_LogsArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Order_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Order_Logs_Order_By>>;
  where?: InputMaybe<Vendor_Order_Logs_Bool_Exp>;
};


/** columns and relationships of "driver_vehicle" */
export type Driver_VehicleVendor_Order_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Order_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Order_Logs_Order_By>>;
  where?: InputMaybe<Vendor_Order_Logs_Bool_Exp>;
};

/** aggregated selection of "driver_vehicle" */
export type Driver_Vehicle_Aggregate = {
  __typename?: 'driver_vehicle_aggregate';
  aggregate?: Maybe<Driver_Vehicle_Aggregate_Fields>;
  nodes: Array<Driver_Vehicle>;
};

export type Driver_Vehicle_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Driver_Vehicle_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Driver_Vehicle_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Driver_Vehicle_Aggregate_Bool_Exp_Count>;
};

export type Driver_Vehicle_Aggregate_Bool_Exp_Bool_And = {
  arguments: Driver_Vehicle_Select_Column_Driver_Vehicle_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Driver_Vehicle_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Driver_Vehicle_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Driver_Vehicle_Select_Column_Driver_Vehicle_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Driver_Vehicle_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Driver_Vehicle_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Driver_Vehicle_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Driver_Vehicle_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "driver_vehicle" */
export type Driver_Vehicle_Aggregate_Fields = {
  __typename?: 'driver_vehicle_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Driver_Vehicle_Max_Fields>;
  min?: Maybe<Driver_Vehicle_Min_Fields>;
};


/** aggregate fields of "driver_vehicle" */
export type Driver_Vehicle_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Driver_Vehicle_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "driver_vehicle" */
export type Driver_Vehicle_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Driver_Vehicle_Max_Order_By>;
  min?: InputMaybe<Driver_Vehicle_Min_Order_By>;
};

/** input type for inserting array relation for remote table "driver_vehicle" */
export type Driver_Vehicle_Arr_Rel_Insert_Input = {
  data: Array<Driver_Vehicle_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Driver_Vehicle_On_Conflict>;
};

/** Boolean expression to filter rows from the table "driver_vehicle". All fields are combined with a logical 'AND'. */
export type Driver_Vehicle_Bool_Exp = {
  _and?: InputMaybe<Array<Driver_Vehicle_Bool_Exp>>;
  _not?: InputMaybe<Driver_Vehicle_Bool_Exp>;
  _or?: InputMaybe<Array<Driver_Vehicle_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  driver_duty_logs?: InputMaybe<Driver_Duty_Log_Bool_Exp>;
  driver_duty_logs_aggregate?: InputMaybe<Driver_Duty_Log_Aggregate_Bool_Exp>;
  driver_id?: InputMaybe<Uuid_Comparison_Exp>;
  driver_vehicle_issues?: InputMaybe<Driver_Vehicle_Issue_Bool_Exp>;
  driver_vehicle_issues_aggregate?: InputMaybe<Driver_Vehicle_Issue_Aggregate_Bool_Exp>;
  driver_vehicle_locations?: InputMaybe<Driver_Vehicle_Location_Bool_Exp>;
  driver_vehicle_locations_aggregate?: InputMaybe<Driver_Vehicle_Location_Aggregate_Bool_Exp>;
  fillup_requests?: InputMaybe<Fillup_Request_Bool_Exp>;
  fillup_requests_aggregate?: InputMaybe<Fillup_Request_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  login_type?: InputMaybe<Login_Type_Bool_Exp>;
  order_schedulers?: InputMaybe<Order_Scheduler_Bool_Exp>;
  order_schedulers_aggregate?: InputMaybe<Order_Scheduler_Aggregate_Bool_Exp>;
  partner_vehicle_state?: InputMaybe<Partner_Vehicle_State_Bool_Exp>;
  shift_schedules?: InputMaybe<Shift_Schedule_Bool_Exp>;
  shift_schedules_aggregate?: InputMaybe<Shift_Schedule_Aggregate_Bool_Exp>;
  state?: InputMaybe<Login_Type_Enum_Comparison_Exp>;
  status?: InputMaybe<Partner_Vehicle_State_Enum_Comparison_Exp>;
  tasks?: InputMaybe<Task_Bool_Exp>;
  tasks_aggregate?: InputMaybe<Task_Aggregate_Bool_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  vehicle?: InputMaybe<Vehicle_Bool_Exp>;
  vehicle_id?: InputMaybe<Uuid_Comparison_Exp>;
  vendor_order_logs?: InputMaybe<Vendor_Order_Logs_Bool_Exp>;
  vendor_order_logs_aggregate?: InputMaybe<Vendor_Order_Logs_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "driver_vehicle" */
export enum Driver_Vehicle_Constraint {
  /** unique or primary key constraint on columns "id" */
  DriverVehiclePkey = 'driver_vehicle_pkey'
}

/** input type for inserting data into table "driver_vehicle" */
export type Driver_Vehicle_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  driver_duty_logs?: InputMaybe<Driver_Duty_Log_Arr_Rel_Insert_Input>;
  driver_id?: InputMaybe<Scalars['uuid']['input']>;
  driver_vehicle_issues?: InputMaybe<Driver_Vehicle_Issue_Arr_Rel_Insert_Input>;
  driver_vehicle_locations?: InputMaybe<Driver_Vehicle_Location_Arr_Rel_Insert_Input>;
  fillup_requests?: InputMaybe<Fillup_Request_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  login_type?: InputMaybe<Login_Type_Obj_Rel_Insert_Input>;
  order_schedulers?: InputMaybe<Order_Scheduler_Arr_Rel_Insert_Input>;
  partner_vehicle_state?: InputMaybe<Partner_Vehicle_State_Obj_Rel_Insert_Input>;
  shift_schedules?: InputMaybe<Shift_Schedule_Arr_Rel_Insert_Input>;
  state?: InputMaybe<Login_Type_Enum>;
  status?: InputMaybe<Partner_Vehicle_State_Enum>;
  tasks?: InputMaybe<Task_Arr_Rel_Insert_Input>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  vehicle?: InputMaybe<Vehicle_Obj_Rel_Insert_Input>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  vendor_order_logs?: InputMaybe<Vendor_Order_Logs_Arr_Rel_Insert_Input>;
};

/** columns and relationships of "driver_vehicle_issue" */
export type Driver_Vehicle_Issue = {
  __typename?: 'driver_vehicle_issue';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  driver_vehicle: Driver_Vehicle;
  driver_vehicle_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  /** An object relationship */
  issue: Issue;
  issue_id: Scalars['uuid']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "driver_vehicle_issue" */
export type Driver_Vehicle_Issue_Aggregate = {
  __typename?: 'driver_vehicle_issue_aggregate';
  aggregate?: Maybe<Driver_Vehicle_Issue_Aggregate_Fields>;
  nodes: Array<Driver_Vehicle_Issue>;
};

export type Driver_Vehicle_Issue_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Driver_Vehicle_Issue_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Driver_Vehicle_Issue_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Driver_Vehicle_Issue_Aggregate_Bool_Exp_Count>;
};

export type Driver_Vehicle_Issue_Aggregate_Bool_Exp_Bool_And = {
  arguments: Driver_Vehicle_Issue_Select_Column_Driver_Vehicle_Issue_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Driver_Vehicle_Issue_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Driver_Vehicle_Issue_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Driver_Vehicle_Issue_Select_Column_Driver_Vehicle_Issue_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Driver_Vehicle_Issue_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Driver_Vehicle_Issue_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Driver_Vehicle_Issue_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Driver_Vehicle_Issue_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "driver_vehicle_issue" */
export type Driver_Vehicle_Issue_Aggregate_Fields = {
  __typename?: 'driver_vehicle_issue_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Driver_Vehicle_Issue_Max_Fields>;
  min?: Maybe<Driver_Vehicle_Issue_Min_Fields>;
};


/** aggregate fields of "driver_vehicle_issue" */
export type Driver_Vehicle_Issue_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Driver_Vehicle_Issue_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "driver_vehicle_issue" */
export type Driver_Vehicle_Issue_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Driver_Vehicle_Issue_Max_Order_By>;
  min?: InputMaybe<Driver_Vehicle_Issue_Min_Order_By>;
};

/** input type for inserting array relation for remote table "driver_vehicle_issue" */
export type Driver_Vehicle_Issue_Arr_Rel_Insert_Input = {
  data: Array<Driver_Vehicle_Issue_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Driver_Vehicle_Issue_On_Conflict>;
};

/** Boolean expression to filter rows from the table "driver_vehicle_issue". All fields are combined with a logical 'AND'. */
export type Driver_Vehicle_Issue_Bool_Exp = {
  _and?: InputMaybe<Array<Driver_Vehicle_Issue_Bool_Exp>>;
  _not?: InputMaybe<Driver_Vehicle_Issue_Bool_Exp>;
  _or?: InputMaybe<Array<Driver_Vehicle_Issue_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  driver_vehicle?: InputMaybe<Driver_Vehicle_Bool_Exp>;
  driver_vehicle_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  issue?: InputMaybe<Issue_Bool_Exp>;
  issue_id?: InputMaybe<Uuid_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "driver_vehicle_issue" */
export enum Driver_Vehicle_Issue_Constraint {
  /** unique or primary key constraint on columns "id" */
  DriverVehicleIssuePkey = 'driver_vehicle_issue_pkey'
}

/** input type for inserting data into table "driver_vehicle_issue" */
export type Driver_Vehicle_Issue_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  driver_vehicle?: InputMaybe<Driver_Vehicle_Obj_Rel_Insert_Input>;
  driver_vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  issue?: InputMaybe<Issue_Obj_Rel_Insert_Input>;
  issue_id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Driver_Vehicle_Issue_Max_Fields = {
  __typename?: 'driver_vehicle_issue_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  driver_vehicle_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  issue_id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "driver_vehicle_issue" */
export type Driver_Vehicle_Issue_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  driver_vehicle_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issue_id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Driver_Vehicle_Issue_Min_Fields = {
  __typename?: 'driver_vehicle_issue_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  driver_vehicle_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  issue_id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "driver_vehicle_issue" */
export type Driver_Vehicle_Issue_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  driver_vehicle_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issue_id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "driver_vehicle_issue" */
export type Driver_Vehicle_Issue_Mutation_Response = {
  __typename?: 'driver_vehicle_issue_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Driver_Vehicle_Issue>;
};

/** on_conflict condition type for table "driver_vehicle_issue" */
export type Driver_Vehicle_Issue_On_Conflict = {
  constraint: Driver_Vehicle_Issue_Constraint;
  update_columns?: Array<Driver_Vehicle_Issue_Update_Column>;
  where?: InputMaybe<Driver_Vehicle_Issue_Bool_Exp>;
};

/** Ordering options when selecting data from "driver_vehicle_issue". */
export type Driver_Vehicle_Issue_Order_By = {
  created_at?: InputMaybe<Order_By>;
  driver_vehicle?: InputMaybe<Driver_Vehicle_Order_By>;
  driver_vehicle_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  issue?: InputMaybe<Issue_Order_By>;
  issue_id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: driver_vehicle_issue */
export type Driver_Vehicle_Issue_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "driver_vehicle_issue" */
export enum Driver_Vehicle_Issue_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DriverVehicleId = 'driver_vehicle_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IssueId = 'issue_id',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by'
}

/** select "driver_vehicle_issue_aggregate_bool_exp_bool_and_arguments_columns" columns of table "driver_vehicle_issue" */
export enum Driver_Vehicle_Issue_Select_Column_Driver_Vehicle_Issue_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "driver_vehicle_issue_aggregate_bool_exp_bool_or_arguments_columns" columns of table "driver_vehicle_issue" */
export enum Driver_Vehicle_Issue_Select_Column_Driver_Vehicle_Issue_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "driver_vehicle_issue" */
export type Driver_Vehicle_Issue_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  driver_vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  issue_id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "driver_vehicle_issue" */
export type Driver_Vehicle_Issue_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Driver_Vehicle_Issue_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Driver_Vehicle_Issue_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  driver_vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  issue_id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "driver_vehicle_issue" */
export enum Driver_Vehicle_Issue_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DriverVehicleId = 'driver_vehicle_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IssueId = 'issue_id',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by'
}

export type Driver_Vehicle_Issue_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Driver_Vehicle_Issue_Set_Input>;
  /** filter the rows which have to be updated */
  where: Driver_Vehicle_Issue_Bool_Exp;
};

/** columns and relationships of "driver_vehicle_location" */
export type Driver_Vehicle_Location = {
  __typename?: 'driver_vehicle_location';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  driver_vehicle: Driver_Vehicle;
  driver_vehicle_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "driver_vehicle_location" */
export type Driver_Vehicle_Location_Aggregate = {
  __typename?: 'driver_vehicle_location_aggregate';
  aggregate?: Maybe<Driver_Vehicle_Location_Aggregate_Fields>;
  nodes: Array<Driver_Vehicle_Location>;
};

export type Driver_Vehicle_Location_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Driver_Vehicle_Location_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Driver_Vehicle_Location_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Driver_Vehicle_Location_Aggregate_Bool_Exp_Count>;
};

export type Driver_Vehicle_Location_Aggregate_Bool_Exp_Bool_And = {
  arguments: Driver_Vehicle_Location_Select_Column_Driver_Vehicle_Location_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Driver_Vehicle_Location_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Driver_Vehicle_Location_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Driver_Vehicle_Location_Select_Column_Driver_Vehicle_Location_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Driver_Vehicle_Location_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Driver_Vehicle_Location_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Driver_Vehicle_Location_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Driver_Vehicle_Location_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "driver_vehicle_location" */
export type Driver_Vehicle_Location_Aggregate_Fields = {
  __typename?: 'driver_vehicle_location_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Driver_Vehicle_Location_Max_Fields>;
  min?: Maybe<Driver_Vehicle_Location_Min_Fields>;
};


/** aggregate fields of "driver_vehicle_location" */
export type Driver_Vehicle_Location_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Driver_Vehicle_Location_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "driver_vehicle_location" */
export type Driver_Vehicle_Location_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Driver_Vehicle_Location_Max_Order_By>;
  min?: InputMaybe<Driver_Vehicle_Location_Min_Order_By>;
};

/** input type for inserting array relation for remote table "driver_vehicle_location" */
export type Driver_Vehicle_Location_Arr_Rel_Insert_Input = {
  data: Array<Driver_Vehicle_Location_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Driver_Vehicle_Location_On_Conflict>;
};

/** Boolean expression to filter rows from the table "driver_vehicle_location". All fields are combined with a logical 'AND'. */
export type Driver_Vehicle_Location_Bool_Exp = {
  _and?: InputMaybe<Array<Driver_Vehicle_Location_Bool_Exp>>;
  _not?: InputMaybe<Driver_Vehicle_Location_Bool_Exp>;
  _or?: InputMaybe<Array<Driver_Vehicle_Location_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  driver_vehicle?: InputMaybe<Driver_Vehicle_Bool_Exp>;
  driver_vehicle_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "driver_vehicle_location" */
export enum Driver_Vehicle_Location_Constraint {
  /** unique or primary key constraint on columns "id" */
  DriverVehicleLocationPkey = 'driver_vehicle_location_pkey'
}

/** input type for inserting data into table "driver_vehicle_location" */
export type Driver_Vehicle_Location_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  driver_vehicle?: InputMaybe<Driver_Vehicle_Obj_Rel_Insert_Input>;
  driver_vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Driver_Vehicle_Location_Max_Fields = {
  __typename?: 'driver_vehicle_location_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  driver_vehicle_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "driver_vehicle_location" */
export type Driver_Vehicle_Location_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  driver_vehicle_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Driver_Vehicle_Location_Min_Fields = {
  __typename?: 'driver_vehicle_location_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  driver_vehicle_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "driver_vehicle_location" */
export type Driver_Vehicle_Location_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  driver_vehicle_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "driver_vehicle_location" */
export type Driver_Vehicle_Location_Mutation_Response = {
  __typename?: 'driver_vehicle_location_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Driver_Vehicle_Location>;
};

/** on_conflict condition type for table "driver_vehicle_location" */
export type Driver_Vehicle_Location_On_Conflict = {
  constraint: Driver_Vehicle_Location_Constraint;
  update_columns?: Array<Driver_Vehicle_Location_Update_Column>;
  where?: InputMaybe<Driver_Vehicle_Location_Bool_Exp>;
};

/** Ordering options when selecting data from "driver_vehicle_location". */
export type Driver_Vehicle_Location_Order_By = {
  created_at?: InputMaybe<Order_By>;
  driver_vehicle?: InputMaybe<Driver_Vehicle_Order_By>;
  driver_vehicle_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: driver_vehicle_location */
export type Driver_Vehicle_Location_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "driver_vehicle_location" */
export enum Driver_Vehicle_Location_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DriverVehicleId = 'driver_vehicle_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by'
}

/** select "driver_vehicle_location_aggregate_bool_exp_bool_and_arguments_columns" columns of table "driver_vehicle_location" */
export enum Driver_Vehicle_Location_Select_Column_Driver_Vehicle_Location_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "driver_vehicle_location_aggregate_bool_exp_bool_or_arguments_columns" columns of table "driver_vehicle_location" */
export enum Driver_Vehicle_Location_Select_Column_Driver_Vehicle_Location_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "driver_vehicle_location" */
export type Driver_Vehicle_Location_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  driver_vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "driver_vehicle_location" */
export type Driver_Vehicle_Location_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Driver_Vehicle_Location_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Driver_Vehicle_Location_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  driver_vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "driver_vehicle_location" */
export enum Driver_Vehicle_Location_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DriverVehicleId = 'driver_vehicle_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by'
}

export type Driver_Vehicle_Location_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Driver_Vehicle_Location_Set_Input>;
  /** filter the rows which have to be updated */
  where: Driver_Vehicle_Location_Bool_Exp;
};

/** aggregate max on columns */
export type Driver_Vehicle_Max_Fields = {
  __typename?: 'driver_vehicle_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  driver_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "driver_vehicle" */
export type Driver_Vehicle_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  driver_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Driver_Vehicle_Min_Fields = {
  __typename?: 'driver_vehicle_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  driver_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "driver_vehicle" */
export type Driver_Vehicle_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  driver_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "driver_vehicle" */
export type Driver_Vehicle_Mutation_Response = {
  __typename?: 'driver_vehicle_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Driver_Vehicle>;
};

/** input type for inserting object relation for remote table "driver_vehicle" */
export type Driver_Vehicle_Obj_Rel_Insert_Input = {
  data: Driver_Vehicle_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Driver_Vehicle_On_Conflict>;
};

/** on_conflict condition type for table "driver_vehicle" */
export type Driver_Vehicle_On_Conflict = {
  constraint: Driver_Vehicle_Constraint;
  update_columns?: Array<Driver_Vehicle_Update_Column>;
  where?: InputMaybe<Driver_Vehicle_Bool_Exp>;
};

/** Ordering options when selecting data from "driver_vehicle". */
export type Driver_Vehicle_Order_By = {
  created_at?: InputMaybe<Order_By>;
  driver_duty_logs_aggregate?: InputMaybe<Driver_Duty_Log_Aggregate_Order_By>;
  driver_id?: InputMaybe<Order_By>;
  driver_vehicle_issues_aggregate?: InputMaybe<Driver_Vehicle_Issue_Aggregate_Order_By>;
  driver_vehicle_locations_aggregate?: InputMaybe<Driver_Vehicle_Location_Aggregate_Order_By>;
  fillup_requests_aggregate?: InputMaybe<Fillup_Request_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  login_type?: InputMaybe<Login_Type_Order_By>;
  order_schedulers_aggregate?: InputMaybe<Order_Scheduler_Aggregate_Order_By>;
  partner_vehicle_state?: InputMaybe<Partner_Vehicle_State_Order_By>;
  shift_schedules_aggregate?: InputMaybe<Shift_Schedule_Aggregate_Order_By>;
  state?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tasks_aggregate?: InputMaybe<Task_Aggregate_Order_By>;
  user?: InputMaybe<User_Order_By>;
  vehicle?: InputMaybe<Vehicle_Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
  vendor_order_logs_aggregate?: InputMaybe<Vendor_Order_Logs_Aggregate_Order_By>;
};

/** primary key columns input for table: driver_vehicle */
export type Driver_Vehicle_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "driver_vehicle" */
export enum Driver_Vehicle_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DriverId = 'driver_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  State = 'state',
  /** column name */
  Status = 'status',
  /** column name */
  VehicleId = 'vehicle_id'
}

/** select "driver_vehicle_aggregate_bool_exp_bool_and_arguments_columns" columns of table "driver_vehicle" */
export enum Driver_Vehicle_Select_Column_Driver_Vehicle_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "driver_vehicle_aggregate_bool_exp_bool_or_arguments_columns" columns of table "driver_vehicle" */
export enum Driver_Vehicle_Select_Column_Driver_Vehicle_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "driver_vehicle" */
export type Driver_Vehicle_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  driver_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Login_Type_Enum>;
  status?: InputMaybe<Partner_Vehicle_State_Enum>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "driver_vehicle" */
export type Driver_Vehicle_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Driver_Vehicle_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Driver_Vehicle_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  driver_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Login_Type_Enum>;
  status?: InputMaybe<Partner_Vehicle_State_Enum>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "driver_vehicle" */
export enum Driver_Vehicle_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DriverId = 'driver_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  State = 'state',
  /** column name */
  Status = 'status',
  /** column name */
  VehicleId = 'vehicle_id'
}

export type Driver_Vehicle_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Driver_Vehicle_Set_Input>;
  /** filter the rows which have to be updated */
  where: Driver_Vehicle_Bool_Exp;
};

/** columns and relationships of "erp_sync_status" */
export type Erp_Sync_Status = {
  __typename?: 'erp_sync_status';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
  /** An array relationship */
  vehicle_inventory_transaction_logs: Array<Vehicle_Inventory_Transaction_Logs>;
  /** An aggregate relationship */
  vehicle_inventory_transaction_logs_aggregate: Vehicle_Inventory_Transaction_Logs_Aggregate;
};


/** columns and relationships of "erp_sync_status" */
export type Erp_Sync_StatusVehicle_Inventory_Transaction_LogsArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Inventory_Transaction_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Inventory_Transaction_Logs_Order_By>>;
  where?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Bool_Exp>;
};


/** columns and relationships of "erp_sync_status" */
export type Erp_Sync_StatusVehicle_Inventory_Transaction_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Inventory_Transaction_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Inventory_Transaction_Logs_Order_By>>;
  where?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Bool_Exp>;
};

/** aggregated selection of "erp_sync_status" */
export type Erp_Sync_Status_Aggregate = {
  __typename?: 'erp_sync_status_aggregate';
  aggregate?: Maybe<Erp_Sync_Status_Aggregate_Fields>;
  nodes: Array<Erp_Sync_Status>;
};

/** aggregate fields of "erp_sync_status" */
export type Erp_Sync_Status_Aggregate_Fields = {
  __typename?: 'erp_sync_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Erp_Sync_Status_Max_Fields>;
  min?: Maybe<Erp_Sync_Status_Min_Fields>;
};


/** aggregate fields of "erp_sync_status" */
export type Erp_Sync_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Erp_Sync_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "erp_sync_status". All fields are combined with a logical 'AND'. */
export type Erp_Sync_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Erp_Sync_Status_Bool_Exp>>;
  _not?: InputMaybe<Erp_Sync_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Erp_Sync_Status_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
  vehicle_inventory_transaction_logs?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Bool_Exp>;
  vehicle_inventory_transaction_logs_aggregate?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "erp_sync_status" */
export enum Erp_Sync_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  ErpSyncStatusPkey = 'erp_sync_status_pkey'
}

export enum Erp_Sync_Status_Enum {
  /** Successfully synced to ERP */
  Completed = 'COMPLETED',
  /** ERP sync failed */
  Failed = 'FAILED',
  /** Awaiting ERP sync */
  Pending = 'PENDING'
}

/** Boolean expression to compare columns of type "erp_sync_status_enum". All fields are combined with logical 'AND'. */
export type Erp_Sync_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Erp_Sync_Status_Enum>;
  _in?: InputMaybe<Array<Erp_Sync_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Erp_Sync_Status_Enum>;
  _nin?: InputMaybe<Array<Erp_Sync_Status_Enum>>;
};

/** input type for inserting data into table "erp_sync_status" */
export type Erp_Sync_Status_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  vehicle_inventory_transaction_logs?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Erp_Sync_Status_Max_Fields = {
  __typename?: 'erp_sync_status_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Erp_Sync_Status_Min_Fields = {
  __typename?: 'erp_sync_status_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "erp_sync_status" */
export type Erp_Sync_Status_Mutation_Response = {
  __typename?: 'erp_sync_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Erp_Sync_Status>;
};

/** input type for inserting object relation for remote table "erp_sync_status" */
export type Erp_Sync_Status_Obj_Rel_Insert_Input = {
  data: Erp_Sync_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Erp_Sync_Status_On_Conflict>;
};

/** on_conflict condition type for table "erp_sync_status" */
export type Erp_Sync_Status_On_Conflict = {
  constraint: Erp_Sync_Status_Constraint;
  update_columns?: Array<Erp_Sync_Status_Update_Column>;
  where?: InputMaybe<Erp_Sync_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "erp_sync_status". */
export type Erp_Sync_Status_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  vehicle_inventory_transaction_logs_aggregate?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Aggregate_Order_By>;
};

/** primary key columns input for table: erp_sync_status */
export type Erp_Sync_Status_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "erp_sync_status" */
export enum Erp_Sync_Status_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "erp_sync_status" */
export type Erp_Sync_Status_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "erp_sync_status" */
export type Erp_Sync_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Erp_Sync_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Erp_Sync_Status_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "erp_sync_status" */
export enum Erp_Sync_Status_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Erp_Sync_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Erp_Sync_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Erp_Sync_Status_Bool_Exp;
};

export type FetchAdvanceReceiptControlsInput = {
  supplier?: InputMaybe<Scalars['String']['input']>;
};

export type FetchAdvanceReceiptControlsOutput = {
  __typename?: 'fetchAdvanceReceiptControlsOutput';
  code?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<Scalars['jsonb']['output']>>>;
  message: Scalars['String']['output'];
};

export type FetchBatchOrgConsumptionInput = {
  end_date: Scalars['String']['input'];
  organization_ids: Array<Scalars['String']['input']>;
  start_date: Scalars['String']['input'];
};

export type FetchBatchOrgConsumptionOutput = {
  __typename?: 'fetchBatchOrgConsumptionOutput';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchCurrAndPrevOdometerReadingV2Input = {
  customer_asset_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  end_date: Scalars['date']['input'];
  limit?: InputMaybe<Scalars['numeric']['input']>;
  offset?: InputMaybe<Scalars['numeric']['input']>;
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  start_date: Scalars['date']['input'];
};

export type FetchCurrAndPrevOdometerReadingV2Output = {
  __typename?: 'fetchCurrAndPrevOdometerReadingV2Output';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['jsonb']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type FetchCurrentAndPreviousMonthQtyV1Input = {
  customer_asset_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  customer_shipping_address_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  end_date: Scalars['date']['input'];
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  start_date: Scalars['date']['input'];
  tag_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type FetchCurrentAndPreviousMonthQtyV1Output = {
  __typename?: 'fetchCurrentAndPreviousMonthQtyV1Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchCurrentAndPreviousMonthQtyV2Input = {
  customer_asset_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  customer_shipping_address_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  end_date: Scalars['date']['input'];
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  start_date: Scalars['date']['input'];
  tag_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  time_offset: Scalars['String']['input'];
};

export type FetchCurrentAndPreviousMonthQtyV2Output = {
  __typename?: 'fetchCurrentAndPreviousMonthQtyV2Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchCurrentAndPreviousMonthQtyV3Input = {
  customer_asset_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  customer_shipping_address_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  end_date: Scalars['date']['input'];
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  start_date: Scalars['date']['input'];
  tag_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  time_offset: Scalars['String']['input'];
};

export type FetchCurrentAndPreviousMonthQtyV3Output = {
  __typename?: 'fetchCurrentAndPreviousMonthQtyV3Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchCurrentAndPreviousMonthQtyV4Input = {
  customer_asset_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  customer_shipping_address_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  end_date: Scalars['date']['input'];
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  start_date: Scalars['date']['input'];
  tag_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  time_offset: Scalars['String']['input'];
};

export type FetchCurrentAndPreviousMonthQtyV4Output = {
  __typename?: 'fetchCurrentAndPreviousMonthQtyV4Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchCurrentAndPreviousMonthQtyV7Input = {
  customer_asset_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  customer_shipping_address_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  end_date: Scalars['date']['input'];
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  start_date: Scalars['date']['input'];
  tag_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type FetchCurrentAndPreviousMonthQtyV7Output = {
  __typename?: 'fetchCurrentAndPreviousMonthQtyV7Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchCurrentMonthDashboardSummaryV7Input = {
  end_date: Scalars['date']['input'];
  organization_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  start_date: Scalars['date']['input'];
};

export type FetchCurrentMonthDashboardSummaryV7Output = {
  __typename?: 'fetchCurrentMonthDashboardSummaryV7Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchCurrentMonthOrderSummaryV1Input = {
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type FetchCurrentMonthOrderSummaryV1Output = {
  __typename?: 'fetchCurrentMonthOrderSummaryV1Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchCurrentMonthOrderSummaryV2Input = {
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  time_offset: Scalars['String']['input'];
};

export type FetchCurrentMonthOrderSummaryV2Output = {
  __typename?: 'fetchCurrentMonthOrderSummaryV2Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchCurrentMonthOrderSummaryV3Input = {
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  time_offset: Scalars['String']['input'];
};

export type FetchCurrentMonthOrderSummaryV3Output = {
  __typename?: 'fetchCurrentMonthOrderSummaryV3Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchCurrentMonthOrderSummaryV7Input = {
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type FetchCurrentMonthOrderSummaryV7Output = {
  __typename?: 'fetchCurrentMonthOrderSummaryV7Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchCustomerAssetMileageV1Input = {
  customer_asset_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  customer_shipping_address_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  data_type: Scalars['String']['input'];
  end_date: Scalars['date']['input'];
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  start_date: Scalars['date']['input'];
  tag_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type FetchCustomerAssetMileageV1Output = {
  __typename?: 'fetchCustomerAssetMileageV1Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchCustomerAssetReportV1Input = {
  customer_asset_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  customer_shipping_address_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  end_date: Scalars['date']['input'];
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  start_date: Scalars['date']['input'];
  tag_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type FetchCustomerAssetReportV1Output = {
  __typename?: 'fetchCustomerAssetReportV1Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchCustomerAssetTagsFilterV1Input = {
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type FetchCustomerAssetTagsFilterV1Output = {
  __typename?: 'fetchCustomerAssetTagsFilterV1Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchCustomerAssetUtilizationV1Input = {
  customer_asset_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  customer_shipping_address_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  data_type: Scalars['String']['input'];
  end_date: Scalars['date']['input'];
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  start_date: Scalars['date']['input'];
  tag_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type FetchCustomerAssetUtilizationV1Output = {
  __typename?: 'fetchCustomerAssetUtilizationV1Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchCustomerAssetsFilterV1Input = {
  order_code: Array<Scalars['bigint']['input']>;
};

export type FetchCustomerAssetsFilterV1Output = {
  __typename?: 'fetchCustomerAssetsFilterV1Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchCustomerOrderDetailsV1Input = {
  customer_asset_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  customer_shipping_address_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  end_date: Scalars['date']['input'];
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  start_date: Scalars['date']['input'];
  tag_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type FetchCustomerOrderDetailsV1Output = {
  __typename?: 'fetchCustomerOrderDetailsV1Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchCustomerOrderDetailsV2Input = {
  customer_asset_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  customer_shipping_address_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  end_date: Scalars['date']['input'];
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  start_date: Scalars['date']['input'];
  tag_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  time_offset: Scalars['String']['input'];
};

export type FetchCustomerOrderDetailsV2Output = {
  __typename?: 'fetchCustomerOrderDetailsV2Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchCustomerOrderDetailsV3Input = {
  customer_asset_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  customer_shipping_address_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  end_date: Scalars['date']['input'];
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  start_date: Scalars['date']['input'];
  tag_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  time_offset: Scalars['String']['input'];
};

export type FetchCustomerOrderDetailsV3Output = {
  __typename?: 'fetchCustomerOrderDetailsV3Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchCustomerOrderDetailsV4Input = {
  customer_asset_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  customer_shipping_address_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  end_date: Scalars['date']['input'];
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  start_date: Scalars['date']['input'];
  tag_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  time_offset: Scalars['String']['input'];
};

export type FetchCustomerOrderDetailsV4Output = {
  __typename?: 'fetchCustomerOrderDetailsV4Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchCustomerOrderDetailsV5Input = {
  customer_asset_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  customer_shipping_address_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  department_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  end_date: Scalars['date']['input'];
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  start_date: Scalars['date']['input'];
  state_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  tag_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  time_offset: Scalars['String']['input'];
};

export type FetchCustomerOrderDetailsV5Output = {
  __typename?: 'fetchCustomerOrderDetailsV5Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchCustomerOrderDetailsV6Input = {
  customer_asset_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  customer_shipping_address_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  department_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  end_date: Scalars['date']['input'];
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  start_date: Scalars['date']['input'];
  state_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  tag_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  time_offset: Scalars['String']['input'];
};

export type FetchCustomerOrderDetailsV6Output = {
  __typename?: 'fetchCustomerOrderDetailsV6Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchCustomerOrderDetailsV7Input = {
  customer_asset_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  department_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  end_date: Scalars['date']['input'];
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  page: Scalars['numeric']['input'];
  shipping_address_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  size: Scalars['numeric']['input'];
  start_date: Scalars['date']['input'];
  state_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type FetchCustomerOrderDetailsV7Output = {
  __typename?: 'fetchCustomerOrderDetailsV7Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchCustomerOrderItemCommentsInput = {
  customer_order_item_id: Scalars['uuid']['input'];
};

export type FetchCustomerOrderItemCommentsOutput = {
  __typename?: 'fetchCustomerOrderItemCommentsOutput';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchDownloadReportDetailsV7Input = {
  customer_asset_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  department_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  end_date: Scalars['date']['input'];
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  shipping_address_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  start_date: Scalars['date']['input'];
  state_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type FetchDownloadReportDetailsV7Output = {
  __typename?: 'fetchDownloadReportDetailsV7Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchMonthBillingV7Input = {
  customer_asset_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  department_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  end_date: Scalars['date']['input'];
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  shipping_address_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  start_date: Scalars['date']['input'];
  state_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type FetchMonthBillingV7Output = {
  __typename?: 'fetchMonthBillingV7Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchOrderCodesFilterV1Input = {
  end_date: Scalars['date']['input'];
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  start_date: Scalars['date']['input'];
};

export type FetchOrderCodesFilterV1Output = {
  __typename?: 'fetchOrderCodesFilterV1Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchOrderDetailsInput = {
  task_id: Scalars['uuid']['input'];
};

export type FetchOrderDetailsOutput = {
  __typename?: 'fetchOrderDetailsOutput';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['jsonb']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type FetchOrderSummaryCountV1Input = {
  customer_asset_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  customer_shipping_address_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  end_date: Scalars['date']['input'];
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  start_date: Scalars['date']['input'];
  tag_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type FetchOrderSummaryCountV1Output = {
  __typename?: 'fetchOrderSummaryCountV1Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchOrderSummaryCountV2Input = {
  customer_asset_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  customer_shipping_address_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  end_date: Scalars['date']['input'];
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  start_date: Scalars['date']['input'];
  tag_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  time_offset: Scalars['String']['input'];
};

export type FetchOrderSummaryCountV2Output = {
  __typename?: 'fetchOrderSummaryCountV2Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchOrderSummaryCountV3Input = {
  customer_asset_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  customer_shipping_address_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  end_date: Scalars['date']['input'];
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  start_date: Scalars['date']['input'];
  tag_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  time_offset: Scalars['String']['input'];
};

export type FetchOrderSummaryCountV3Output = {
  __typename?: 'fetchOrderSummaryCountV3Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchOrderSummaryCountV7Input = {
  customer_asset_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  customer_shipping_address_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  end_date: Scalars['date']['input'];
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  start_date: Scalars['date']['input'];
  tag_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type FetchOrderSummaryCountV7Output = {
  __typename?: 'fetchOrderSummaryCountV7Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchOrderSummaryQuantityV1Input = {
  customer_asset_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  customer_shipping_address_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  end_date: Scalars['date']['input'];
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  start_date: Scalars['date']['input'];
  tag_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type FetchOrderSummaryQuantityV1Output = {
  __typename?: 'fetchOrderSummaryQuantityV1Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchOrderSummaryQuantityV2Input = {
  customer_asset_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  customer_shipping_address_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  end_date: Scalars['date']['input'];
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  start_date: Scalars['date']['input'];
  tag_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  time_offset: Scalars['String']['input'];
};

export type FetchOrderSummaryQuantityV2Output = {
  __typename?: 'fetchOrderSummaryQuantityV2Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchOrderSummaryQuantityV3Input = {
  customer_asset_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  customer_shipping_address_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  end_date: Scalars['date']['input'];
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  start_date: Scalars['date']['input'];
  tag_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  time_offset: Scalars['String']['input'];
};

export type FetchOrderSummaryQuantityV3Output = {
  __typename?: 'fetchOrderSummaryQuantityV3Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchOrderSummaryQuantityV7Input = {
  customer_asset_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  customer_shipping_address_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  end_date: Scalars['date']['input'];
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  start_date: Scalars['date']['input'];
  tag_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type FetchOrderSummaryQuantityV7Output = {
  __typename?: 'fetchOrderSummaryQuantityV7Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchOrderSummaryRefillV1Input = {
  customer_asset_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  customer_shipping_address_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  end_date: Scalars['date']['input'];
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  start_date: Scalars['date']['input'];
  tag_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type FetchOrderSummaryRefillV1Output = {
  __typename?: 'fetchOrderSummaryRefillV1Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchOrderSummaryRefillV2Input = {
  customer_asset_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  customer_shipping_address_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  end_date: Scalars['date']['input'];
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  start_date: Scalars['date']['input'];
  tag_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  time_offset: Scalars['String']['input'];
};

export type FetchOrderSummaryRefillV2Output = {
  __typename?: 'fetchOrderSummaryRefillV2Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchOrderSummaryRefillV3Input = {
  customer_asset_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  customer_shipping_address_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  end_date: Scalars['date']['input'];
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  start_date: Scalars['date']['input'];
  tag_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  time_offset: Scalars['String']['input'];
};

export type FetchOrderSummaryRefillV3Output = {
  __typename?: 'fetchOrderSummaryRefillV3Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchOrderSummaryRefillV7Input = {
  customer_asset_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  customer_shipping_address_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  end_date: Scalars['date']['input'];
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  start_date: Scalars['date']['input'];
  tag_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type FetchOrderSummaryRefillV7Output = {
  __typename?: 'fetchOrderSummaryRefillV7Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchOrderedAndDeliveredQtyV1Input = {
  customer_asset_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  customer_shipping_address_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  end_date: Scalars['date']['input'];
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  show_only_delivered_qty?: InputMaybe<Scalars['Boolean']['input']>;
  start_date: Scalars['date']['input'];
  tag_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type FetchOrderedAndDeliveredQtyV1Output = {
  __typename?: 'fetchOrderedAndDeliveredQtyV1Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchOrderedAndDeliveredQtyV2Input = {
  customer_asset_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  customer_shipping_address_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  end_date: Scalars['date']['input'];
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  show_only_delivered_qty?: InputMaybe<Scalars['Boolean']['input']>;
  start_date: Scalars['date']['input'];
  tag_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  time_offset: Scalars['String']['input'];
};

export type FetchOrderedAndDeliveredQtyV2Output = {
  __typename?: 'fetchOrderedAndDeliveredQtyV2Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchOrderedAndDeliveredQtyV3Input = {
  customer_asset_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  customer_shipping_address_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  end_date: Scalars['date']['input'];
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  show_only_delivered_qty?: InputMaybe<Scalars['Boolean']['input']>;
  start_date: Scalars['date']['input'];
  tag_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  time_offset: Scalars['String']['input'];
};

export type FetchOrderedAndDeliveredQtyV3Output = {
  __typename?: 'fetchOrderedAndDeliveredQtyV3Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchOrderedAndDeliveredQtyV4Input = {
  customer_asset_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  customer_shipping_address_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  end_date: Scalars['date']['input'];
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  show_only_delivered_qty?: InputMaybe<Scalars['Boolean']['input']>;
  start_date: Scalars['date']['input'];
  tag_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  time_offset: Scalars['String']['input'];
};

export type FetchOrderedAndDeliveredQtyV4Output = {
  __typename?: 'fetchOrderedAndDeliveredQtyV4Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchOrderedAndDeliveredQtyV7Input = {
  customer_asset_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  customer_shipping_address_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  department_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  end_date: Scalars['date']['input'];
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  show_only_delivered_qty?: InputMaybe<Scalars['Boolean']['input']>;
  start_date: Scalars['date']['input'];
  state_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  tag_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type FetchOrderedAndDeliveredQtyV7Output = {
  __typename?: 'fetchOrderedAndDeliveredQtyV7Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchOrganizationAddressFilterV1Input = {
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type FetchOrganizationAddressFilterV1Output = {
  __typename?: 'fetchOrganizationAddressFilterV1Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchPartnerUsersFilterV1Input = {
  partner_id: Scalars['uuid']['input'];
};

export type FetchPartnerUsersFilterV1Output = {
  __typename?: 'fetchPartnerUsersFilterV1Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchPrevMonthDashboardSummaryV7Input = {
  end_date: Scalars['date']['input'];
  organization_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  start_date: Scalars['date']['input'];
};

export type FetchPrevMonthDashboardSummaryV7Output = {
  __typename?: 'fetchPrevMonthDashboardSummaryV7Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchPreviousMonthOrderSummaryV1Input = {
  end_date?: InputMaybe<Scalars['date']['input']>;
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  start_date?: InputMaybe<Scalars['date']['input']>;
};

export type FetchPreviousMonthOrderSummaryV1Output = {
  __typename?: 'fetchPreviousMonthOrderSummaryV1Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchPreviousMonthOrderSummaryV2Input = {
  end_date?: InputMaybe<Scalars['date']['input']>;
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  time_offset: Scalars['String']['input'];
};

export type FetchPreviousMonthOrderSummaryV2Output = {
  __typename?: 'fetchPreviousMonthOrderSummaryV2Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchPreviousMonthOrderSummaryV3Input = {
  end_date?: InputMaybe<Scalars['date']['input']>;
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  time_offset: Scalars['String']['input'];
};

export type FetchPreviousMonthOrderSummaryV3Output = {
  __typename?: 'fetchPreviousMonthOrderSummaryV3Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchPreviousMonthOrderSummaryV7Input = {
  end_date?: InputMaybe<Scalars['date']['input']>;
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  start_date?: InputMaybe<Scalars['date']['input']>;
};

export type FetchPreviousMonthOrderSummaryV7Output = {
  __typename?: 'fetchPreviousMonthOrderSummaryV7Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchSlaTrackingV2Input = {
  customer_shipping_address_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  limit?: InputMaybe<Scalars['numeric']['input']>;
  offset?: InputMaybe<Scalars['numeric']['input']>;
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  order_description?: InputMaybe<Array<Scalars['String']['input']>>;
  order_status?: InputMaybe<Array<Scalars['String']['input']>>;
  start_date?: InputMaybe<Scalars['date']['input']>;
};

export type FetchSlaTrackingV2Output = {
  __typename?: 'fetchSLATrackingV2Output';
  data: Scalars['jsonb']['output'];
};

export type FetchTaskValueForCustomerAssetInput = {
  customerAssetId: Scalars['uuid']['input'];
  taskId: Scalars['uuid']['input'];
};

export type FetchTaskValueForCustomerAssetOutput = {
  __typename?: 'fetchTaskValueForCustomerAssetOutput';
  customerCode?: Maybe<Scalars['String']['output']>;
  driverCode?: Maybe<Scalars['String']['output']>;
  endBatchCode?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  endTotalizer?: Maybe<Scalars['String']['output']>;
  invoiceDate?: Maybe<Scalars['String']['output']>;
  isReceiptRequired?: Maybe<Scalars['Boolean']['output']>;
  odometerReading?: Maybe<Scalars['String']['output']>;
  orderCode?: Maybe<Scalars['String']['output']>;
  orderDate?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
  startBatchCode?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  startTotalizer?: Maybe<Scalars['String']['output']>;
  unitOfMeasure?: Maybe<Scalars['String']['output']>;
  vehicleRegistrationNumber?: Maybe<Scalars['String']['output']>;
};

export type FetchTotalOrdersAmountGroupedByDayV1Input = {
  customer_asset_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  customer_shipping_address_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  end_date: Scalars['date']['input'];
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  start_date: Scalars['date']['input'];
  tag_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type FetchTotalOrdersAmountGroupedByDayV1Output = {
  __typename?: 'fetchTotalOrdersAmountGroupedByDayV1Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchTotalOrdersAmountGroupedByDayV2Input = {
  customer_asset_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  customer_shipping_address_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  end_date: Scalars['date']['input'];
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  start_date: Scalars['date']['input'];
  tag_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  time_offset: Scalars['String']['input'];
};

export type FetchTotalOrdersAmountGroupedByDayV2Output = {
  __typename?: 'fetchTotalOrdersAmountGroupedByDayV2Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchTotalOrdersAmountGroupedByDayV3Input = {
  customer_asset_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  customer_shipping_address_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  end_date: Scalars['date']['input'];
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  start_date: Scalars['date']['input'];
  tag_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  time_offset: Scalars['String']['input'];
};

export type FetchTotalOrdersAmountGroupedByDayV3Output = {
  __typename?: 'fetchTotalOrdersAmountGroupedByDayV3Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchTotalOrdersAmountGroupedByDayV4Input = {
  customer_asset_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  customer_shipping_address_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  end_date: Scalars['date']['input'];
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  start_date: Scalars['date']['input'];
  tag_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  time_offset: Scalars['String']['input'];
};

export type FetchTotalOrdersAmountGroupedByDayV4Output = {
  __typename?: 'fetchTotalOrdersAmountGroupedByDayV4Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchTotalOrdersAmountGroupedByDayV7Input = {
  customer_asset_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  customer_shipping_address_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  end_date: Scalars['date']['input'];
  order_code?: InputMaybe<Array<Scalars['bigint']['input']>>;
  organization_user_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
  start_date: Scalars['date']['input'];
  tag_id?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type FetchTotalOrdersAmountGroupedByDayV7Output = {
  __typename?: 'fetchTotalOrdersAmountGroupedByDayV7Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchWalletDriftDuplicateInput = {
  from_date: Scalars['String']['input'];
  mode: Scalars['String']['input'];
  organization_id?: InputMaybe<Array<Scalars['String']['input']>>;
  to_date: Scalars['String']['input'];
};

export type FetchWalletDriftDuplicateOutput = {
  __typename?: 'fetchWalletDriftDuplicateOutput';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchWalletDriftInvariantInput = {
  from_date: Scalars['String']['input'];
  mode: Scalars['String']['input'];
  organization_id?: InputMaybe<Array<Scalars['String']['input']>>;
  to_date: Scalars['String']['input'];
};

export type FetchWalletDriftInvariantOutput = {
  __typename?: 'fetchWalletDriftInvariantOutput';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchWalletDriftMismatchInput = {
  from_date: Scalars['String']['input'];
  mode: Scalars['String']['input'];
  organization_id?: InputMaybe<Array<Scalars['String']['input']>>;
  to_date: Scalars['String']['input'];
};

export type FetchWalletDriftMismatchOutput = {
  __typename?: 'fetchWalletDriftMismatchOutput';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchWalletDriftMissingInput = {
  from_date: Scalars['String']['input'];
  mode: Scalars['String']['input'];
  organization_id?: InputMaybe<Array<Scalars['String']['input']>>;
  to_date: Scalars['String']['input'];
};

export type FetchWalletDriftMissingOutput = {
  __typename?: 'fetchWalletDriftMissingOutput';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type FetchWalletDriftOrphanInput = {
  from_date: Scalars['String']['input'];
  mode: Scalars['String']['input'];
  organization_id?: InputMaybe<Array<Scalars['String']['input']>>;
  to_date: Scalars['String']['input'];
};

export type FetchWalletDriftOrphanOutput = {
  __typename?: 'fetchWalletDriftOrphanOutput';
  data?: Maybe<Scalars['jsonb']['output']>;
};

/** columns and relationships of "fillup_request" */
export type Fillup_Request = {
  __typename?: 'fillup_request';
  /** When approved/rejected */
  approved_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Checker who approved/rejected */
  approved_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  approver?: Maybe<User>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  driver?: Maybe<User>;
  /** Depot operator identity (IDEV-2059 pattern) */
  driver_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  driver_vehicle?: Maybe<Driver_Vehicle>;
  driver_vehicle_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  fillup_request_status: Fillup_Request_Status;
  /** An object relationship */
  fuelRequestTypeByFuelRequestType?: Maybe<Fuel_Request_Type>;
  fuel_request_type?: Maybe<Fuel_Request_Type_Enum>;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  inventory_workflow_logs: Array<Inventory_Workflow_Logs>;
  /** An aggregate relationship */
  inventory_workflow_logs_aggregate: Inventory_Workflow_Logs_Aggregate;
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** Images, GPS, supplier, warehouse, PARC ref */
  metadata?: Maybe<Scalars['jsonb']['output']>;
  /** Quantity expressed in the base unit OF ITS OWN DIMENSION - see normalized_unit. This is NOT always litres: a gas quantity normalises to SCM, not to a liquid volume. */
  normalized_quantity?: Maybe<Scalars['numeric']['output']>;
  /** The unit normalized_quantity is expressed in: the is_base unit of the dimension that fillup_request.unit belongs to. */
  normalized_unit?: Maybe<Unit_Of_Measure_Enum>;
  otp?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  partnerVehicleBySourcePartnerVehicleId?: Maybe<Partner_Vehicle>;
  /** An object relationship */
  partnerVehicleByTargetPartnerVehicleId?: Maybe<Partner_Vehicle>;
  /** An object relationship */
  partner_order?: Maybe<Partner_Order>;
  partner_order_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  product_variation?: Maybe<Product_Variation>;
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
  quantity: Scalars['numeric']['output'];
  quantity_approved?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  reason?: Maybe<Reasons>;
  /** Why rejected - edge case only */
  reason_id?: Maybe<Scalars['uuid']['output']>;
  /** Free-text remarks alongside structured reason */
  reason_remarks?: Maybe<Scalars['String']['output']>;
  /** The source vehicle which will deliver fuel */
  source_partner_vehicle_id?: Maybe<Scalars['uuid']['output']>;
  state: Fillup_Request_Status_Enum;
  /** The target vehicle in which fuel is delivered */
  target_partner_vehicle_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  task?: Maybe<Task>;
  task_id?: Maybe<Scalars['uuid']['output']>;
  unit?: Maybe<Unit_Of_Measure_Enum>;
  /** An object relationship */
  unitOfMeasureByNormalizedUnit?: Maybe<Unit_Of_Measure>;
  /** An object relationship */
  unit_of_measure?: Maybe<Unit_Of_Measure>;
  /** An array relationship */
  vehicle_inventory_transaction_logs: Array<Vehicle_Inventory_Transaction_Logs>;
  /** An aggregate relationship */
  vehicle_inventory_transaction_logs_aggregate: Vehicle_Inventory_Transaction_Logs_Aggregate;
  /** An object relationship */
  vehicle_tank_type_product_variation?: Maybe<Vehicle_Tank_Type_Product_Variation>;
  vehicle_tank_type_product_variation_id?: Maybe<Scalars['uuid']['output']>;
  /** Temporal workflow run ID */
  workflow_run_id?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "fillup_request" */
export type Fillup_RequestInventory_Workflow_LogsArgs = {
  distinct_on?: InputMaybe<Array<Inventory_Workflow_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Inventory_Workflow_Logs_Order_By>>;
  where?: InputMaybe<Inventory_Workflow_Logs_Bool_Exp>;
};


/** columns and relationships of "fillup_request" */
export type Fillup_RequestInventory_Workflow_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Inventory_Workflow_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Inventory_Workflow_Logs_Order_By>>;
  where?: InputMaybe<Inventory_Workflow_Logs_Bool_Exp>;
};


/** columns and relationships of "fillup_request" */
export type Fillup_RequestMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "fillup_request" */
export type Fillup_RequestVehicle_Inventory_Transaction_LogsArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Inventory_Transaction_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Inventory_Transaction_Logs_Order_By>>;
  where?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Bool_Exp>;
};


/** columns and relationships of "fillup_request" */
export type Fillup_RequestVehicle_Inventory_Transaction_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Inventory_Transaction_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Inventory_Transaction_Logs_Order_By>>;
  where?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Bool_Exp>;
};

/** aggregated selection of "fillup_request" */
export type Fillup_Request_Aggregate = {
  __typename?: 'fillup_request_aggregate';
  aggregate?: Maybe<Fillup_Request_Aggregate_Fields>;
  nodes: Array<Fillup_Request>;
};

export type Fillup_Request_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Fillup_Request_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Fillup_Request_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Fillup_Request_Aggregate_Bool_Exp_Count>;
};

export type Fillup_Request_Aggregate_Bool_Exp_Bool_And = {
  arguments: Fillup_Request_Select_Column_Fillup_Request_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Fillup_Request_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Fillup_Request_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Fillup_Request_Select_Column_Fillup_Request_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Fillup_Request_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Fillup_Request_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Fillup_Request_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Fillup_Request_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "fillup_request" */
export type Fillup_Request_Aggregate_Fields = {
  __typename?: 'fillup_request_aggregate_fields';
  avg?: Maybe<Fillup_Request_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Fillup_Request_Max_Fields>;
  min?: Maybe<Fillup_Request_Min_Fields>;
  stddev?: Maybe<Fillup_Request_Stddev_Fields>;
  stddev_pop?: Maybe<Fillup_Request_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fillup_Request_Stddev_Samp_Fields>;
  sum?: Maybe<Fillup_Request_Sum_Fields>;
  var_pop?: Maybe<Fillup_Request_Var_Pop_Fields>;
  var_samp?: Maybe<Fillup_Request_Var_Samp_Fields>;
  variance?: Maybe<Fillup_Request_Variance_Fields>;
};


/** aggregate fields of "fillup_request" */
export type Fillup_Request_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fillup_Request_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "fillup_request" */
export type Fillup_Request_Aggregate_Order_By = {
  avg?: InputMaybe<Fillup_Request_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Fillup_Request_Max_Order_By>;
  min?: InputMaybe<Fillup_Request_Min_Order_By>;
  stddev?: InputMaybe<Fillup_Request_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Fillup_Request_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Fillup_Request_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Fillup_Request_Sum_Order_By>;
  var_pop?: InputMaybe<Fillup_Request_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Fillup_Request_Var_Samp_Order_By>;
  variance?: InputMaybe<Fillup_Request_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Fillup_Request_Append_Input = {
  /** Images, GPS, supplier, warehouse, PARC ref */
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "fillup_request" */
export type Fillup_Request_Arr_Rel_Insert_Input = {
  data: Array<Fillup_Request_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Fillup_Request_On_Conflict>;
};

/** aggregate avg on columns */
export type Fillup_Request_Avg_Fields = {
  __typename?: 'fillup_request_avg_fields';
  /** Quantity expressed in the base unit OF ITS OWN DIMENSION - see normalized_unit. This is NOT always litres: a gas quantity normalises to SCM, not to a liquid volume. */
  normalized_quantity?: Maybe<Scalars['Float']['output']>;
  otp?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  quantity_approved?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "fillup_request" */
export type Fillup_Request_Avg_Order_By = {
  /** Quantity expressed in the base unit OF ITS OWN DIMENSION - see normalized_unit. This is NOT always litres: a gas quantity normalises to SCM, not to a liquid volume. */
  normalized_quantity?: InputMaybe<Order_By>;
  otp?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_approved?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "fillup_request". All fields are combined with a logical 'AND'. */
export type Fillup_Request_Bool_Exp = {
  _and?: InputMaybe<Array<Fillup_Request_Bool_Exp>>;
  _not?: InputMaybe<Fillup_Request_Bool_Exp>;
  _or?: InputMaybe<Array<Fillup_Request_Bool_Exp>>;
  approved_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  approved_by?: InputMaybe<Uuid_Comparison_Exp>;
  approver?: InputMaybe<User_Bool_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  driver?: InputMaybe<User_Bool_Exp>;
  driver_id?: InputMaybe<Uuid_Comparison_Exp>;
  driver_vehicle?: InputMaybe<Driver_Vehicle_Bool_Exp>;
  driver_vehicle_id?: InputMaybe<Uuid_Comparison_Exp>;
  fillup_request_status?: InputMaybe<Fillup_Request_Status_Bool_Exp>;
  fuelRequestTypeByFuelRequestType?: InputMaybe<Fuel_Request_Type_Bool_Exp>;
  fuel_request_type?: InputMaybe<Fuel_Request_Type_Enum_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  inventory_workflow_logs?: InputMaybe<Inventory_Workflow_Logs_Bool_Exp>;
  inventory_workflow_logs_aggregate?: InputMaybe<Inventory_Workflow_Logs_Aggregate_Bool_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  normalized_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  normalized_unit?: InputMaybe<Unit_Of_Measure_Enum_Comparison_Exp>;
  otp?: InputMaybe<Int_Comparison_Exp>;
  partnerVehicleBySourcePartnerVehicleId?: InputMaybe<Partner_Vehicle_Bool_Exp>;
  partnerVehicleByTargetPartnerVehicleId?: InputMaybe<Partner_Vehicle_Bool_Exp>;
  partner_order?: InputMaybe<Partner_Order_Bool_Exp>;
  partner_order_id?: InputMaybe<Uuid_Comparison_Exp>;
  product_variation?: InputMaybe<Product_Variation_Bool_Exp>;
  product_variation_id?: InputMaybe<Uuid_Comparison_Exp>;
  quantity?: InputMaybe<Numeric_Comparison_Exp>;
  quantity_approved?: InputMaybe<Numeric_Comparison_Exp>;
  reason?: InputMaybe<Reasons_Bool_Exp>;
  reason_id?: InputMaybe<Uuid_Comparison_Exp>;
  reason_remarks?: InputMaybe<String_Comparison_Exp>;
  source_partner_vehicle_id?: InputMaybe<Uuid_Comparison_Exp>;
  state?: InputMaybe<Fillup_Request_Status_Enum_Comparison_Exp>;
  target_partner_vehicle_id?: InputMaybe<Uuid_Comparison_Exp>;
  task?: InputMaybe<Task_Bool_Exp>;
  task_id?: InputMaybe<Uuid_Comparison_Exp>;
  unit?: InputMaybe<Unit_Of_Measure_Enum_Comparison_Exp>;
  unitOfMeasureByNormalizedUnit?: InputMaybe<Unit_Of_Measure_Bool_Exp>;
  unit_of_measure?: InputMaybe<Unit_Of_Measure_Bool_Exp>;
  vehicle_inventory_transaction_logs?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Bool_Exp>;
  vehicle_inventory_transaction_logs_aggregate?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Aggregate_Bool_Exp>;
  vehicle_tank_type_product_variation?: InputMaybe<Vehicle_Tank_Type_Product_Variation_Bool_Exp>;
  vehicle_tank_type_product_variation_id?: InputMaybe<Uuid_Comparison_Exp>;
  workflow_run_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "fillup_request" */
export enum Fillup_Request_Constraint {
  /** unique or primary key constraint on columns "id" */
  FillupRequestPkey = 'fillup_request_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Fillup_Request_Delete_At_Path_Input = {
  /** Images, GPS, supplier, warehouse, PARC ref */
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Fillup_Request_Delete_Elem_Input = {
  /** Images, GPS, supplier, warehouse, PARC ref */
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Fillup_Request_Delete_Key_Input = {
  /** Images, GPS, supplier, warehouse, PARC ref */
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "fillup_request" */
export type Fillup_Request_Inc_Input = {
  /** Quantity expressed in the base unit OF ITS OWN DIMENSION - see normalized_unit. This is NOT always litres: a gas quantity normalises to SCM, not to a liquid volume. */
  normalized_quantity?: InputMaybe<Scalars['numeric']['input']>;
  otp?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  quantity_approved?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "fillup_request" */
export type Fillup_Request_Insert_Input = {
  /** When approved/rejected */
  approved_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Checker who approved/rejected */
  approved_by?: InputMaybe<Scalars['uuid']['input']>;
  approver?: InputMaybe<User_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  driver?: InputMaybe<User_Obj_Rel_Insert_Input>;
  /** Depot operator identity (IDEV-2059 pattern) */
  driver_id?: InputMaybe<Scalars['uuid']['input']>;
  driver_vehicle?: InputMaybe<Driver_Vehicle_Obj_Rel_Insert_Input>;
  driver_vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  fillup_request_status?: InputMaybe<Fillup_Request_Status_Obj_Rel_Insert_Input>;
  fuelRequestTypeByFuelRequestType?: InputMaybe<Fuel_Request_Type_Obj_Rel_Insert_Input>;
  fuel_request_type?: InputMaybe<Fuel_Request_Type_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  inventory_workflow_logs?: InputMaybe<Inventory_Workflow_Logs_Arr_Rel_Insert_Input>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  /** Images, GPS, supplier, warehouse, PARC ref */
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  /** Quantity expressed in the base unit OF ITS OWN DIMENSION - see normalized_unit. This is NOT always litres: a gas quantity normalises to SCM, not to a liquid volume. */
  normalized_quantity?: InputMaybe<Scalars['numeric']['input']>;
  /** The unit normalized_quantity is expressed in: the is_base unit of the dimension that fillup_request.unit belongs to. */
  normalized_unit?: InputMaybe<Unit_Of_Measure_Enum>;
  otp?: InputMaybe<Scalars['Int']['input']>;
  partnerVehicleBySourcePartnerVehicleId?: InputMaybe<Partner_Vehicle_Obj_Rel_Insert_Input>;
  partnerVehicleByTargetPartnerVehicleId?: InputMaybe<Partner_Vehicle_Obj_Rel_Insert_Input>;
  partner_order?: InputMaybe<Partner_Order_Obj_Rel_Insert_Input>;
  partner_order_id?: InputMaybe<Scalars['uuid']['input']>;
  product_variation?: InputMaybe<Product_Variation_Obj_Rel_Insert_Input>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  quantity_approved?: InputMaybe<Scalars['numeric']['input']>;
  reason?: InputMaybe<Reasons_Obj_Rel_Insert_Input>;
  /** Why rejected - edge case only */
  reason_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Free-text remarks alongside structured reason */
  reason_remarks?: InputMaybe<Scalars['String']['input']>;
  /** The source vehicle which will deliver fuel */
  source_partner_vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Fillup_Request_Status_Enum>;
  /** The target vehicle in which fuel is delivered */
  target_partner_vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  task?: InputMaybe<Task_Obj_Rel_Insert_Input>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
  unit?: InputMaybe<Unit_Of_Measure_Enum>;
  unitOfMeasureByNormalizedUnit?: InputMaybe<Unit_Of_Measure_Obj_Rel_Insert_Input>;
  unit_of_measure?: InputMaybe<Unit_Of_Measure_Obj_Rel_Insert_Input>;
  vehicle_inventory_transaction_logs?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Arr_Rel_Insert_Input>;
  vehicle_tank_type_product_variation?: InputMaybe<Vehicle_Tank_Type_Product_Variation_Obj_Rel_Insert_Input>;
  vehicle_tank_type_product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Temporal workflow run ID */
  workflow_run_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Fillup_Request_Max_Fields = {
  __typename?: 'fillup_request_max_fields';
  /** When approved/rejected */
  approved_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Checker who approved/rejected */
  approved_by?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** Depot operator identity (IDEV-2059 pattern) */
  driver_id?: Maybe<Scalars['uuid']['output']>;
  driver_vehicle_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** Quantity expressed in the base unit OF ITS OWN DIMENSION - see normalized_unit. This is NOT always litres: a gas quantity normalises to SCM, not to a liquid volume. */
  normalized_quantity?: Maybe<Scalars['numeric']['output']>;
  otp?: Maybe<Scalars['Int']['output']>;
  partner_order_id?: Maybe<Scalars['uuid']['output']>;
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
  quantity_approved?: Maybe<Scalars['numeric']['output']>;
  /** Why rejected - edge case only */
  reason_id?: Maybe<Scalars['uuid']['output']>;
  /** Free-text remarks alongside structured reason */
  reason_remarks?: Maybe<Scalars['String']['output']>;
  /** The source vehicle which will deliver fuel */
  source_partner_vehicle_id?: Maybe<Scalars['uuid']['output']>;
  /** The target vehicle in which fuel is delivered */
  target_partner_vehicle_id?: Maybe<Scalars['uuid']['output']>;
  task_id?: Maybe<Scalars['uuid']['output']>;
  vehicle_tank_type_product_variation_id?: Maybe<Scalars['uuid']['output']>;
  /** Temporal workflow run ID */
  workflow_run_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "fillup_request" */
export type Fillup_Request_Max_Order_By = {
  /** When approved/rejected */
  approved_at?: InputMaybe<Order_By>;
  /** Checker who approved/rejected */
  approved_by?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  /** Depot operator identity (IDEV-2059 pattern) */
  driver_id?: InputMaybe<Order_By>;
  driver_vehicle_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  /** Quantity expressed in the base unit OF ITS OWN DIMENSION - see normalized_unit. This is NOT always litres: a gas quantity normalises to SCM, not to a liquid volume. */
  normalized_quantity?: InputMaybe<Order_By>;
  otp?: InputMaybe<Order_By>;
  partner_order_id?: InputMaybe<Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_approved?: InputMaybe<Order_By>;
  /** Why rejected - edge case only */
  reason_id?: InputMaybe<Order_By>;
  /** Free-text remarks alongside structured reason */
  reason_remarks?: InputMaybe<Order_By>;
  /** The source vehicle which will deliver fuel */
  source_partner_vehicle_id?: InputMaybe<Order_By>;
  /** The target vehicle in which fuel is delivered */
  target_partner_vehicle_id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  vehicle_tank_type_product_variation_id?: InputMaybe<Order_By>;
  /** Temporal workflow run ID */
  workflow_run_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Fillup_Request_Min_Fields = {
  __typename?: 'fillup_request_min_fields';
  /** When approved/rejected */
  approved_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Checker who approved/rejected */
  approved_by?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** Depot operator identity (IDEV-2059 pattern) */
  driver_id?: Maybe<Scalars['uuid']['output']>;
  driver_vehicle_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** Quantity expressed in the base unit OF ITS OWN DIMENSION - see normalized_unit. This is NOT always litres: a gas quantity normalises to SCM, not to a liquid volume. */
  normalized_quantity?: Maybe<Scalars['numeric']['output']>;
  otp?: Maybe<Scalars['Int']['output']>;
  partner_order_id?: Maybe<Scalars['uuid']['output']>;
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
  quantity_approved?: Maybe<Scalars['numeric']['output']>;
  /** Why rejected - edge case only */
  reason_id?: Maybe<Scalars['uuid']['output']>;
  /** Free-text remarks alongside structured reason */
  reason_remarks?: Maybe<Scalars['String']['output']>;
  /** The source vehicle which will deliver fuel */
  source_partner_vehicle_id?: Maybe<Scalars['uuid']['output']>;
  /** The target vehicle in which fuel is delivered */
  target_partner_vehicle_id?: Maybe<Scalars['uuid']['output']>;
  task_id?: Maybe<Scalars['uuid']['output']>;
  vehicle_tank_type_product_variation_id?: Maybe<Scalars['uuid']['output']>;
  /** Temporal workflow run ID */
  workflow_run_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "fillup_request" */
export type Fillup_Request_Min_Order_By = {
  /** When approved/rejected */
  approved_at?: InputMaybe<Order_By>;
  /** Checker who approved/rejected */
  approved_by?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  /** Depot operator identity (IDEV-2059 pattern) */
  driver_id?: InputMaybe<Order_By>;
  driver_vehicle_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  /** Quantity expressed in the base unit OF ITS OWN DIMENSION - see normalized_unit. This is NOT always litres: a gas quantity normalises to SCM, not to a liquid volume. */
  normalized_quantity?: InputMaybe<Order_By>;
  otp?: InputMaybe<Order_By>;
  partner_order_id?: InputMaybe<Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_approved?: InputMaybe<Order_By>;
  /** Why rejected - edge case only */
  reason_id?: InputMaybe<Order_By>;
  /** Free-text remarks alongside structured reason */
  reason_remarks?: InputMaybe<Order_By>;
  /** The source vehicle which will deliver fuel */
  source_partner_vehicle_id?: InputMaybe<Order_By>;
  /** The target vehicle in which fuel is delivered */
  target_partner_vehicle_id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  vehicle_tank_type_product_variation_id?: InputMaybe<Order_By>;
  /** Temporal workflow run ID */
  workflow_run_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "fillup_request" */
export type Fillup_Request_Mutation_Response = {
  __typename?: 'fillup_request_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Fillup_Request>;
};

/** input type for inserting object relation for remote table "fillup_request" */
export type Fillup_Request_Obj_Rel_Insert_Input = {
  data: Fillup_Request_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Fillup_Request_On_Conflict>;
};

/** on_conflict condition type for table "fillup_request" */
export type Fillup_Request_On_Conflict = {
  constraint: Fillup_Request_Constraint;
  update_columns?: Array<Fillup_Request_Update_Column>;
  where?: InputMaybe<Fillup_Request_Bool_Exp>;
};

/** Ordering options when selecting data from "fillup_request". */
export type Fillup_Request_Order_By = {
  approved_at?: InputMaybe<Order_By>;
  approved_by?: InputMaybe<Order_By>;
  approver?: InputMaybe<User_Order_By>;
  created_at?: InputMaybe<Order_By>;
  driver?: InputMaybe<User_Order_By>;
  driver_id?: InputMaybe<Order_By>;
  driver_vehicle?: InputMaybe<Driver_Vehicle_Order_By>;
  driver_vehicle_id?: InputMaybe<Order_By>;
  fillup_request_status?: InputMaybe<Fillup_Request_Status_Order_By>;
  fuelRequestTypeByFuelRequestType?: InputMaybe<Fuel_Request_Type_Order_By>;
  fuel_request_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inventory_workflow_logs_aggregate?: InputMaybe<Inventory_Workflow_Logs_Aggregate_Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  normalized_quantity?: InputMaybe<Order_By>;
  normalized_unit?: InputMaybe<Order_By>;
  otp?: InputMaybe<Order_By>;
  partnerVehicleBySourcePartnerVehicleId?: InputMaybe<Partner_Vehicle_Order_By>;
  partnerVehicleByTargetPartnerVehicleId?: InputMaybe<Partner_Vehicle_Order_By>;
  partner_order?: InputMaybe<Partner_Order_Order_By>;
  partner_order_id?: InputMaybe<Order_By>;
  product_variation?: InputMaybe<Product_Variation_Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_approved?: InputMaybe<Order_By>;
  reason?: InputMaybe<Reasons_Order_By>;
  reason_id?: InputMaybe<Order_By>;
  reason_remarks?: InputMaybe<Order_By>;
  source_partner_vehicle_id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  target_partner_vehicle_id?: InputMaybe<Order_By>;
  task?: InputMaybe<Task_Order_By>;
  task_id?: InputMaybe<Order_By>;
  unit?: InputMaybe<Order_By>;
  unitOfMeasureByNormalizedUnit?: InputMaybe<Unit_Of_Measure_Order_By>;
  unit_of_measure?: InputMaybe<Unit_Of_Measure_Order_By>;
  vehicle_inventory_transaction_logs_aggregate?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Aggregate_Order_By>;
  vehicle_tank_type_product_variation?: InputMaybe<Vehicle_Tank_Type_Product_Variation_Order_By>;
  vehicle_tank_type_product_variation_id?: InputMaybe<Order_By>;
  workflow_run_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: fillup_request */
export type Fillup_Request_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Fillup_Request_Prepend_Input = {
  /** Images, GPS, supplier, warehouse, PARC ref */
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "fillup_request" */
export enum Fillup_Request_Select_Column {
  /** column name */
  ApprovedAt = 'approved_at',
  /** column name */
  ApprovedBy = 'approved_by',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DriverId = 'driver_id',
  /** column name */
  DriverVehicleId = 'driver_vehicle_id',
  /** column name */
  FuelRequestType = 'fuel_request_type',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NormalizedQuantity = 'normalized_quantity',
  /** column name */
  NormalizedUnit = 'normalized_unit',
  /** column name */
  Otp = 'otp',
  /** column name */
  PartnerOrderId = 'partner_order_id',
  /** column name */
  ProductVariationId = 'product_variation_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  QuantityApproved = 'quantity_approved',
  /** column name */
  ReasonId = 'reason_id',
  /** column name */
  ReasonRemarks = 'reason_remarks',
  /** column name */
  SourcePartnerVehicleId = 'source_partner_vehicle_id',
  /** column name */
  State = 'state',
  /** column name */
  TargetPartnerVehicleId = 'target_partner_vehicle_id',
  /** column name */
  TaskId = 'task_id',
  /** column name */
  Unit = 'unit',
  /** column name */
  VehicleTankTypeProductVariationId = 'vehicle_tank_type_product_variation_id',
  /** column name */
  WorkflowRunId = 'workflow_run_id'
}

/** select "fillup_request_aggregate_bool_exp_bool_and_arguments_columns" columns of table "fillup_request" */
export enum Fillup_Request_Select_Column_Fillup_Request_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "fillup_request_aggregate_bool_exp_bool_or_arguments_columns" columns of table "fillup_request" */
export enum Fillup_Request_Select_Column_Fillup_Request_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "fillup_request" */
export type Fillup_Request_Set_Input = {
  /** When approved/rejected */
  approved_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Checker who approved/rejected */
  approved_by?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  /** Depot operator identity (IDEV-2059 pattern) */
  driver_id?: InputMaybe<Scalars['uuid']['input']>;
  driver_vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  fuel_request_type?: InputMaybe<Fuel_Request_Type_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  /** Images, GPS, supplier, warehouse, PARC ref */
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  /** Quantity expressed in the base unit OF ITS OWN DIMENSION - see normalized_unit. This is NOT always litres: a gas quantity normalises to SCM, not to a liquid volume. */
  normalized_quantity?: InputMaybe<Scalars['numeric']['input']>;
  /** The unit normalized_quantity is expressed in: the is_base unit of the dimension that fillup_request.unit belongs to. */
  normalized_unit?: InputMaybe<Unit_Of_Measure_Enum>;
  otp?: InputMaybe<Scalars['Int']['input']>;
  partner_order_id?: InputMaybe<Scalars['uuid']['input']>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  quantity_approved?: InputMaybe<Scalars['numeric']['input']>;
  /** Why rejected - edge case only */
  reason_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Free-text remarks alongside structured reason */
  reason_remarks?: InputMaybe<Scalars['String']['input']>;
  /** The source vehicle which will deliver fuel */
  source_partner_vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Fillup_Request_Status_Enum>;
  /** The target vehicle in which fuel is delivered */
  target_partner_vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
  unit?: InputMaybe<Unit_Of_Measure_Enum>;
  vehicle_tank_type_product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Temporal workflow run ID */
  workflow_run_id?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "fillup_request_status" */
export type Fillup_Request_Status = {
  __typename?: 'fillup_request_status';
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  fillup_requests: Array<Fillup_Request>;
  /** An aggregate relationship */
  fillup_requests_aggregate: Fillup_Request_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "fillup_request_status" */
export type Fillup_Request_StatusFillup_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Fillup_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fillup_Request_Order_By>>;
  where?: InputMaybe<Fillup_Request_Bool_Exp>;
};


/** columns and relationships of "fillup_request_status" */
export type Fillup_Request_StatusFillup_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fillup_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fillup_Request_Order_By>>;
  where?: InputMaybe<Fillup_Request_Bool_Exp>;
};

/** aggregated selection of "fillup_request_status" */
export type Fillup_Request_Status_Aggregate = {
  __typename?: 'fillup_request_status_aggregate';
  aggregate?: Maybe<Fillup_Request_Status_Aggregate_Fields>;
  nodes: Array<Fillup_Request_Status>;
};

/** aggregate fields of "fillup_request_status" */
export type Fillup_Request_Status_Aggregate_Fields = {
  __typename?: 'fillup_request_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Fillup_Request_Status_Max_Fields>;
  min?: Maybe<Fillup_Request_Status_Min_Fields>;
};


/** aggregate fields of "fillup_request_status" */
export type Fillup_Request_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fillup_Request_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "fillup_request_status". All fields are combined with a logical 'AND'. */
export type Fillup_Request_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Fillup_Request_Status_Bool_Exp>>;
  _not?: InputMaybe<Fillup_Request_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Fillup_Request_Status_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  fillup_requests?: InputMaybe<Fillup_Request_Bool_Exp>;
  fillup_requests_aggregate?: InputMaybe<Fillup_Request_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "fillup_request_status" */
export enum Fillup_Request_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  FillupRequestStatusPkey = 'fillup_request_status_pkey'
}

export enum Fillup_Request_Status_Enum {
  /** APPROVED */
  Approved = 'APPROVED',
  /** authorized */
  Authorized = 'AUTHORIZED',
  /** PENDING */
  Pending = 'PENDING',
  /** REJECTED */
  Rejected = 'REJECTED',
  /** Pre-created by procurement, awaiting depot operator action */
  Scheduled = 'SCHEDULED'
}

/** Boolean expression to compare columns of type "fillup_request_status_enum". All fields are combined with logical 'AND'. */
export type Fillup_Request_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Fillup_Request_Status_Enum>;
  _in?: InputMaybe<Array<Fillup_Request_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Fillup_Request_Status_Enum>;
  _nin?: InputMaybe<Array<Fillup_Request_Status_Enum>>;
};

/** input type for inserting data into table "fillup_request_status" */
export type Fillup_Request_Status_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  fillup_requests?: InputMaybe<Fillup_Request_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Fillup_Request_Status_Max_Fields = {
  __typename?: 'fillup_request_status_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Fillup_Request_Status_Min_Fields = {
  __typename?: 'fillup_request_status_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "fillup_request_status" */
export type Fillup_Request_Status_Mutation_Response = {
  __typename?: 'fillup_request_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Fillup_Request_Status>;
};

/** input type for inserting object relation for remote table "fillup_request_status" */
export type Fillup_Request_Status_Obj_Rel_Insert_Input = {
  data: Fillup_Request_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Fillup_Request_Status_On_Conflict>;
};

/** on_conflict condition type for table "fillup_request_status" */
export type Fillup_Request_Status_On_Conflict = {
  constraint: Fillup_Request_Status_Constraint;
  update_columns?: Array<Fillup_Request_Status_Update_Column>;
  where?: InputMaybe<Fillup_Request_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "fillup_request_status". */
export type Fillup_Request_Status_Order_By = {
  comment?: InputMaybe<Order_By>;
  fillup_requests_aggregate?: InputMaybe<Fillup_Request_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: fillup_request_status */
export type Fillup_Request_Status_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "fillup_request_status" */
export enum Fillup_Request_Status_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "fillup_request_status" */
export type Fillup_Request_Status_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "fillup_request_status" */
export type Fillup_Request_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fillup_Request_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fillup_Request_Status_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "fillup_request_status" */
export enum Fillup_Request_Status_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Fillup_Request_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Fillup_Request_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Fillup_Request_Status_Bool_Exp;
};

/** aggregate stddev on columns */
export type Fillup_Request_Stddev_Fields = {
  __typename?: 'fillup_request_stddev_fields';
  /** Quantity expressed in the base unit OF ITS OWN DIMENSION - see normalized_unit. This is NOT always litres: a gas quantity normalises to SCM, not to a liquid volume. */
  normalized_quantity?: Maybe<Scalars['Float']['output']>;
  otp?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  quantity_approved?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "fillup_request" */
export type Fillup_Request_Stddev_Order_By = {
  /** Quantity expressed in the base unit OF ITS OWN DIMENSION - see normalized_unit. This is NOT always litres: a gas quantity normalises to SCM, not to a liquid volume. */
  normalized_quantity?: InputMaybe<Order_By>;
  otp?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_approved?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Fillup_Request_Stddev_Pop_Fields = {
  __typename?: 'fillup_request_stddev_pop_fields';
  /** Quantity expressed in the base unit OF ITS OWN DIMENSION - see normalized_unit. This is NOT always litres: a gas quantity normalises to SCM, not to a liquid volume. */
  normalized_quantity?: Maybe<Scalars['Float']['output']>;
  otp?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  quantity_approved?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "fillup_request" */
export type Fillup_Request_Stddev_Pop_Order_By = {
  /** Quantity expressed in the base unit OF ITS OWN DIMENSION - see normalized_unit. This is NOT always litres: a gas quantity normalises to SCM, not to a liquid volume. */
  normalized_quantity?: InputMaybe<Order_By>;
  otp?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_approved?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Fillup_Request_Stddev_Samp_Fields = {
  __typename?: 'fillup_request_stddev_samp_fields';
  /** Quantity expressed in the base unit OF ITS OWN DIMENSION - see normalized_unit. This is NOT always litres: a gas quantity normalises to SCM, not to a liquid volume. */
  normalized_quantity?: Maybe<Scalars['Float']['output']>;
  otp?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  quantity_approved?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "fillup_request" */
export type Fillup_Request_Stddev_Samp_Order_By = {
  /** Quantity expressed in the base unit OF ITS OWN DIMENSION - see normalized_unit. This is NOT always litres: a gas quantity normalises to SCM, not to a liquid volume. */
  normalized_quantity?: InputMaybe<Order_By>;
  otp?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_approved?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "fillup_request" */
export type Fillup_Request_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fillup_Request_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fillup_Request_Stream_Cursor_Value_Input = {
  /** When approved/rejected */
  approved_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Checker who approved/rejected */
  approved_by?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  /** Depot operator identity (IDEV-2059 pattern) */
  driver_id?: InputMaybe<Scalars['uuid']['input']>;
  driver_vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  fuel_request_type?: InputMaybe<Fuel_Request_Type_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  /** Images, GPS, supplier, warehouse, PARC ref */
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  /** Quantity expressed in the base unit OF ITS OWN DIMENSION - see normalized_unit. This is NOT always litres: a gas quantity normalises to SCM, not to a liquid volume. */
  normalized_quantity?: InputMaybe<Scalars['numeric']['input']>;
  /** The unit normalized_quantity is expressed in: the is_base unit of the dimension that fillup_request.unit belongs to. */
  normalized_unit?: InputMaybe<Unit_Of_Measure_Enum>;
  otp?: InputMaybe<Scalars['Int']['input']>;
  partner_order_id?: InputMaybe<Scalars['uuid']['input']>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  quantity_approved?: InputMaybe<Scalars['numeric']['input']>;
  /** Why rejected - edge case only */
  reason_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Free-text remarks alongside structured reason */
  reason_remarks?: InputMaybe<Scalars['String']['input']>;
  /** The source vehicle which will deliver fuel */
  source_partner_vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Fillup_Request_Status_Enum>;
  /** The target vehicle in which fuel is delivered */
  target_partner_vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
  unit?: InputMaybe<Unit_Of_Measure_Enum>;
  vehicle_tank_type_product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Temporal workflow run ID */
  workflow_run_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Fillup_Request_Sum_Fields = {
  __typename?: 'fillup_request_sum_fields';
  /** Quantity expressed in the base unit OF ITS OWN DIMENSION - see normalized_unit. This is NOT always litres: a gas quantity normalises to SCM, not to a liquid volume. */
  normalized_quantity?: Maybe<Scalars['numeric']['output']>;
  otp?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
  quantity_approved?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "fillup_request" */
export type Fillup_Request_Sum_Order_By = {
  /** Quantity expressed in the base unit OF ITS OWN DIMENSION - see normalized_unit. This is NOT always litres: a gas quantity normalises to SCM, not to a liquid volume. */
  normalized_quantity?: InputMaybe<Order_By>;
  otp?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_approved?: InputMaybe<Order_By>;
};

/** update columns of table "fillup_request" */
export enum Fillup_Request_Update_Column {
  /** column name */
  ApprovedAt = 'approved_at',
  /** column name */
  ApprovedBy = 'approved_by',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DriverId = 'driver_id',
  /** column name */
  DriverVehicleId = 'driver_vehicle_id',
  /** column name */
  FuelRequestType = 'fuel_request_type',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NormalizedQuantity = 'normalized_quantity',
  /** column name */
  NormalizedUnit = 'normalized_unit',
  /** column name */
  Otp = 'otp',
  /** column name */
  PartnerOrderId = 'partner_order_id',
  /** column name */
  ProductVariationId = 'product_variation_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  QuantityApproved = 'quantity_approved',
  /** column name */
  ReasonId = 'reason_id',
  /** column name */
  ReasonRemarks = 'reason_remarks',
  /** column name */
  SourcePartnerVehicleId = 'source_partner_vehicle_id',
  /** column name */
  State = 'state',
  /** column name */
  TargetPartnerVehicleId = 'target_partner_vehicle_id',
  /** column name */
  TaskId = 'task_id',
  /** column name */
  Unit = 'unit',
  /** column name */
  VehicleTankTypeProductVariationId = 'vehicle_tank_type_product_variation_id',
  /** column name */
  WorkflowRunId = 'workflow_run_id'
}

export type Fillup_Request_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Fillup_Request_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Fillup_Request_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Fillup_Request_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Fillup_Request_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Fillup_Request_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Fillup_Request_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Fillup_Request_Set_Input>;
  /** filter the rows which have to be updated */
  where: Fillup_Request_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Fillup_Request_Var_Pop_Fields = {
  __typename?: 'fillup_request_var_pop_fields';
  /** Quantity expressed in the base unit OF ITS OWN DIMENSION - see normalized_unit. This is NOT always litres: a gas quantity normalises to SCM, not to a liquid volume. */
  normalized_quantity?: Maybe<Scalars['Float']['output']>;
  otp?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  quantity_approved?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "fillup_request" */
export type Fillup_Request_Var_Pop_Order_By = {
  /** Quantity expressed in the base unit OF ITS OWN DIMENSION - see normalized_unit. This is NOT always litres: a gas quantity normalises to SCM, not to a liquid volume. */
  normalized_quantity?: InputMaybe<Order_By>;
  otp?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_approved?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Fillup_Request_Var_Samp_Fields = {
  __typename?: 'fillup_request_var_samp_fields';
  /** Quantity expressed in the base unit OF ITS OWN DIMENSION - see normalized_unit. This is NOT always litres: a gas quantity normalises to SCM, not to a liquid volume. */
  normalized_quantity?: Maybe<Scalars['Float']['output']>;
  otp?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  quantity_approved?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "fillup_request" */
export type Fillup_Request_Var_Samp_Order_By = {
  /** Quantity expressed in the base unit OF ITS OWN DIMENSION - see normalized_unit. This is NOT always litres: a gas quantity normalises to SCM, not to a liquid volume. */
  normalized_quantity?: InputMaybe<Order_By>;
  otp?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_approved?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Fillup_Request_Variance_Fields = {
  __typename?: 'fillup_request_variance_fields';
  /** Quantity expressed in the base unit OF ITS OWN DIMENSION - see normalized_unit. This is NOT always litres: a gas quantity normalises to SCM, not to a liquid volume. */
  normalized_quantity?: Maybe<Scalars['Float']['output']>;
  otp?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  quantity_approved?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "fillup_request" */
export type Fillup_Request_Variance_Order_By = {
  /** Quantity expressed in the base unit OF ITS OWN DIMENSION - see normalized_unit. This is NOT always litres: a gas quantity normalises to SCM, not to a liquid volume. */
  normalized_quantity?: InputMaybe<Order_By>;
  otp?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_approved?: InputMaybe<Order_By>;
};

export type FuelTransLog = {
  account_number?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['numeric']['input']>;
  asset_registration_number: Scalars['String']['input'];
  card_number?: InputMaybe<Scalars['String']['input']>;
  card_type?: InputMaybe<Scalars['String']['input']>;
  company_name?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['String']['input'];
  department_code?: InputMaybe<Scalars['String']['input']>;
  odometer?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['numeric']['input']>;
  product_name?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['numeric']['input'];
  totalizer_end?: InputMaybe<Scalars['String']['input']>;
  totalizer_start?: InputMaybe<Scalars['String']['input']>;
  transaction_date: Scalars['date']['input'];
  transaction_end_time?: InputMaybe<Scalars['timestamp']['input']>;
  transaction_mode?: InputMaybe<Scalars['String']['input']>;
  transaction_number?: InputMaybe<Scalars['String']['input']>;
  transaction_start_time?: InputMaybe<Scalars['timestamp']['input']>;
  transaction_time: Scalars['timetz']['input'];
  truck_name?: InputMaybe<Scalars['String']['input']>;
  truck_registration_number: Scalars['String']['input'];
};

/** columns and relationships of "fuel_request_type" */
export type Fuel_Request_Type = {
  __typename?: 'fuel_request_type';
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  fillup_requests: Array<Fillup_Request>;
  /** An aggregate relationship */
  fillup_requests_aggregate: Fillup_Request_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "fuel_request_type" */
export type Fuel_Request_TypeFillup_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Fillup_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fillup_Request_Order_By>>;
  where?: InputMaybe<Fillup_Request_Bool_Exp>;
};


/** columns and relationships of "fuel_request_type" */
export type Fuel_Request_TypeFillup_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fillup_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fillup_Request_Order_By>>;
  where?: InputMaybe<Fillup_Request_Bool_Exp>;
};

/** aggregated selection of "fuel_request_type" */
export type Fuel_Request_Type_Aggregate = {
  __typename?: 'fuel_request_type_aggregate';
  aggregate?: Maybe<Fuel_Request_Type_Aggregate_Fields>;
  nodes: Array<Fuel_Request_Type>;
};

/** aggregate fields of "fuel_request_type" */
export type Fuel_Request_Type_Aggregate_Fields = {
  __typename?: 'fuel_request_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Fuel_Request_Type_Max_Fields>;
  min?: Maybe<Fuel_Request_Type_Min_Fields>;
};


/** aggregate fields of "fuel_request_type" */
export type Fuel_Request_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fuel_Request_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "fuel_request_type". All fields are combined with a logical 'AND'. */
export type Fuel_Request_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Fuel_Request_Type_Bool_Exp>>;
  _not?: InputMaybe<Fuel_Request_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Fuel_Request_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  fillup_requests?: InputMaybe<Fillup_Request_Bool_Exp>;
  fillup_requests_aggregate?: InputMaybe<Fillup_Request_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "fuel_request_type" */
export enum Fuel_Request_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  FuelRequestTypePkey = 'fuel_request_type_pkey'
}

export enum Fuel_Request_Type_Enum {
  /** BOWSERS_TANK */
  BowsersTank = 'BOWSERS_TANK',
  /** FUEL_TANK */
  FuelTank = 'FUEL_TANK',
  /** Goods receipt from vendor - creates Purchase Receipt in ERP */
  Grn = 'GRN',
  /** SERVICE_STATION */
  ServiceStation = 'SERVICE_STATION',
  /** Tank-to-tank fuel transfer - creates Stock Entry in ERP */
  Transfer = 'TRANSFER'
}

/** Boolean expression to compare columns of type "fuel_request_type_enum". All fields are combined with logical 'AND'. */
export type Fuel_Request_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Fuel_Request_Type_Enum>;
  _in?: InputMaybe<Array<Fuel_Request_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Fuel_Request_Type_Enum>;
  _nin?: InputMaybe<Array<Fuel_Request_Type_Enum>>;
};

/** input type for inserting data into table "fuel_request_type" */
export type Fuel_Request_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  fillup_requests?: InputMaybe<Fillup_Request_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Fuel_Request_Type_Max_Fields = {
  __typename?: 'fuel_request_type_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Fuel_Request_Type_Min_Fields = {
  __typename?: 'fuel_request_type_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "fuel_request_type" */
export type Fuel_Request_Type_Mutation_Response = {
  __typename?: 'fuel_request_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Fuel_Request_Type>;
};

/** input type for inserting object relation for remote table "fuel_request_type" */
export type Fuel_Request_Type_Obj_Rel_Insert_Input = {
  data: Fuel_Request_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Fuel_Request_Type_On_Conflict>;
};

/** on_conflict condition type for table "fuel_request_type" */
export type Fuel_Request_Type_On_Conflict = {
  constraint: Fuel_Request_Type_Constraint;
  update_columns?: Array<Fuel_Request_Type_Update_Column>;
  where?: InputMaybe<Fuel_Request_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "fuel_request_type". */
export type Fuel_Request_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  fillup_requests_aggregate?: InputMaybe<Fillup_Request_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: fuel_request_type */
export type Fuel_Request_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "fuel_request_type" */
export enum Fuel_Request_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "fuel_request_type" */
export type Fuel_Request_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "fuel_request_type" */
export type Fuel_Request_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fuel_Request_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fuel_Request_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "fuel_request_type" */
export enum Fuel_Request_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Fuel_Request_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Fuel_Request_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Fuel_Request_Type_Bool_Exp;
};

/** columns and relationships of "fueltrans_transaction_logs" */
export type Fueltrans_Transaction_Logs = {
  __typename?: 'fueltrans_transaction_logs';
  account_number?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['numeric']['output']>;
  asset_registration_number: Scalars['String']['output'];
  card_number?: Maybe<Scalars['String']['output']>;
  card_type?: Maybe<Scalars['String']['output']>;
  company_name?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamp']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  customer_id: Scalars['String']['output'];
  department_code?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  is_used: Scalars['Boolean']['output'];
  last_modified: Scalars['timestamp']['output'];
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  odometer?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['numeric']['output']>;
  product_name?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['numeric']['output'];
  totalizer_end?: Maybe<Scalars['String']['output']>;
  totalizer_start?: Maybe<Scalars['String']['output']>;
  transaction_date: Scalars['timestamp']['output'];
  transaction_end_time?: Maybe<Scalars['timestamp']['output']>;
  transaction_mode?: Maybe<Scalars['String']['output']>;
  transaction_number?: Maybe<Scalars['String']['output']>;
  transaction_start_time?: Maybe<Scalars['timestamp']['output']>;
  transaction_time?: Maybe<Scalars['time']['output']>;
  truck_name?: Maybe<Scalars['String']['output']>;
  truck_registration_number: Scalars['String']['output'];
};

/** aggregated selection of "fueltrans_transaction_logs" */
export type Fueltrans_Transaction_Logs_Aggregate = {
  __typename?: 'fueltrans_transaction_logs_aggregate';
  aggregate?: Maybe<Fueltrans_Transaction_Logs_Aggregate_Fields>;
  nodes: Array<Fueltrans_Transaction_Logs>;
};

/** aggregate fields of "fueltrans_transaction_logs" */
export type Fueltrans_Transaction_Logs_Aggregate_Fields = {
  __typename?: 'fueltrans_transaction_logs_aggregate_fields';
  avg?: Maybe<Fueltrans_Transaction_Logs_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Fueltrans_Transaction_Logs_Max_Fields>;
  min?: Maybe<Fueltrans_Transaction_Logs_Min_Fields>;
  stddev?: Maybe<Fueltrans_Transaction_Logs_Stddev_Fields>;
  stddev_pop?: Maybe<Fueltrans_Transaction_Logs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fueltrans_Transaction_Logs_Stddev_Samp_Fields>;
  sum?: Maybe<Fueltrans_Transaction_Logs_Sum_Fields>;
  var_pop?: Maybe<Fueltrans_Transaction_Logs_Var_Pop_Fields>;
  var_samp?: Maybe<Fueltrans_Transaction_Logs_Var_Samp_Fields>;
  variance?: Maybe<Fueltrans_Transaction_Logs_Variance_Fields>;
};


/** aggregate fields of "fueltrans_transaction_logs" */
export type Fueltrans_Transaction_Logs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fueltrans_Transaction_Logs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Fueltrans_Transaction_Logs_Avg_Fields = {
  __typename?: 'fueltrans_transaction_logs_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "fueltrans_transaction_logs". All fields are combined with a logical 'AND'. */
export type Fueltrans_Transaction_Logs_Bool_Exp = {
  _and?: InputMaybe<Array<Fueltrans_Transaction_Logs_Bool_Exp>>;
  _not?: InputMaybe<Fueltrans_Transaction_Logs_Bool_Exp>;
  _or?: InputMaybe<Array<Fueltrans_Transaction_Logs_Bool_Exp>>;
  account_number?: InputMaybe<String_Comparison_Exp>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  asset_registration_number?: InputMaybe<String_Comparison_Exp>;
  card_number?: InputMaybe<String_Comparison_Exp>;
  card_type?: InputMaybe<String_Comparison_Exp>;
  company_name?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  customer_id?: InputMaybe<String_Comparison_Exp>;
  department_code?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_used?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  odometer?: InputMaybe<String_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  product_name?: InputMaybe<String_Comparison_Exp>;
  quantity?: InputMaybe<Numeric_Comparison_Exp>;
  totalizer_end?: InputMaybe<String_Comparison_Exp>;
  totalizer_start?: InputMaybe<String_Comparison_Exp>;
  transaction_date?: InputMaybe<Timestamp_Comparison_Exp>;
  transaction_end_time?: InputMaybe<Timestamp_Comparison_Exp>;
  transaction_mode?: InputMaybe<String_Comparison_Exp>;
  transaction_number?: InputMaybe<String_Comparison_Exp>;
  transaction_start_time?: InputMaybe<Timestamp_Comparison_Exp>;
  transaction_time?: InputMaybe<Time_Comparison_Exp>;
  truck_name?: InputMaybe<String_Comparison_Exp>;
  truck_registration_number?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "fueltrans_transaction_logs" */
export enum Fueltrans_Transaction_Logs_Constraint {
  /** unique or primary key constraint on columns "id" */
  FueltransTransactionLogsPkey = 'fueltrans_transaction_logs_pkey',
  /** unique or primary key constraint on columns "transaction_number" */
  FueltransTransactionLogsTransactionNumberKey = 'fueltrans_transaction_logs_transaction_number_key'
}

/** input type for incrementing numeric columns in table "fueltrans_transaction_logs" */
export type Fueltrans_Transaction_Logs_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  price?: InputMaybe<Scalars['numeric']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "fueltrans_transaction_logs" */
export type Fueltrans_Transaction_Logs_Insert_Input = {
  account_number?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['numeric']['input']>;
  asset_registration_number?: InputMaybe<Scalars['String']['input']>;
  card_number?: InputMaybe<Scalars['String']['input']>;
  card_type?: InputMaybe<Scalars['String']['input']>;
  company_name?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customer_id?: InputMaybe<Scalars['String']['input']>;
  department_code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_used?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  odometer?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['numeric']['input']>;
  product_name?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  totalizer_end?: InputMaybe<Scalars['String']['input']>;
  totalizer_start?: InputMaybe<Scalars['String']['input']>;
  transaction_date?: InputMaybe<Scalars['timestamp']['input']>;
  transaction_end_time?: InputMaybe<Scalars['timestamp']['input']>;
  transaction_mode?: InputMaybe<Scalars['String']['input']>;
  transaction_number?: InputMaybe<Scalars['String']['input']>;
  transaction_start_time?: InputMaybe<Scalars['timestamp']['input']>;
  transaction_time?: InputMaybe<Scalars['time']['input']>;
  truck_name?: InputMaybe<Scalars['String']['input']>;
  truck_registration_number?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Fueltrans_Transaction_Logs_Max_Fields = {
  __typename?: 'fueltrans_transaction_logs_max_fields';
  account_number?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['numeric']['output']>;
  asset_registration_number?: Maybe<Scalars['String']['output']>;
  card_number?: Maybe<Scalars['String']['output']>;
  card_type?: Maybe<Scalars['String']['output']>;
  company_name?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customer_id?: Maybe<Scalars['String']['output']>;
  department_code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  odometer?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['numeric']['output']>;
  product_name?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
  totalizer_end?: Maybe<Scalars['String']['output']>;
  totalizer_start?: Maybe<Scalars['String']['output']>;
  transaction_date?: Maybe<Scalars['timestamp']['output']>;
  transaction_end_time?: Maybe<Scalars['timestamp']['output']>;
  transaction_mode?: Maybe<Scalars['String']['output']>;
  transaction_number?: Maybe<Scalars['String']['output']>;
  transaction_start_time?: Maybe<Scalars['timestamp']['output']>;
  truck_name?: Maybe<Scalars['String']['output']>;
  truck_registration_number?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Fueltrans_Transaction_Logs_Min_Fields = {
  __typename?: 'fueltrans_transaction_logs_min_fields';
  account_number?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['numeric']['output']>;
  asset_registration_number?: Maybe<Scalars['String']['output']>;
  card_number?: Maybe<Scalars['String']['output']>;
  card_type?: Maybe<Scalars['String']['output']>;
  company_name?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customer_id?: Maybe<Scalars['String']['output']>;
  department_code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  odometer?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['numeric']['output']>;
  product_name?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
  totalizer_end?: Maybe<Scalars['String']['output']>;
  totalizer_start?: Maybe<Scalars['String']['output']>;
  transaction_date?: Maybe<Scalars['timestamp']['output']>;
  transaction_end_time?: Maybe<Scalars['timestamp']['output']>;
  transaction_mode?: Maybe<Scalars['String']['output']>;
  transaction_number?: Maybe<Scalars['String']['output']>;
  transaction_start_time?: Maybe<Scalars['timestamp']['output']>;
  truck_name?: Maybe<Scalars['String']['output']>;
  truck_registration_number?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "fueltrans_transaction_logs" */
export type Fueltrans_Transaction_Logs_Mutation_Response = {
  __typename?: 'fueltrans_transaction_logs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Fueltrans_Transaction_Logs>;
};

/** on_conflict condition type for table "fueltrans_transaction_logs" */
export type Fueltrans_Transaction_Logs_On_Conflict = {
  constraint: Fueltrans_Transaction_Logs_Constraint;
  update_columns?: Array<Fueltrans_Transaction_Logs_Update_Column>;
  where?: InputMaybe<Fueltrans_Transaction_Logs_Bool_Exp>;
};

/** Ordering options when selecting data from "fueltrans_transaction_logs". */
export type Fueltrans_Transaction_Logs_Order_By = {
  account_number?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  asset_registration_number?: InputMaybe<Order_By>;
  card_number?: InputMaybe<Order_By>;
  card_type?: InputMaybe<Order_By>;
  company_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  department_code?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_used?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  odometer?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  product_name?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  totalizer_end?: InputMaybe<Order_By>;
  totalizer_start?: InputMaybe<Order_By>;
  transaction_date?: InputMaybe<Order_By>;
  transaction_end_time?: InputMaybe<Order_By>;
  transaction_mode?: InputMaybe<Order_By>;
  transaction_number?: InputMaybe<Order_By>;
  transaction_start_time?: InputMaybe<Order_By>;
  transaction_time?: InputMaybe<Order_By>;
  truck_name?: InputMaybe<Order_By>;
  truck_registration_number?: InputMaybe<Order_By>;
};

/** primary key columns input for table: fueltrans_transaction_logs */
export type Fueltrans_Transaction_Logs_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "fueltrans_transaction_logs" */
export enum Fueltrans_Transaction_Logs_Select_Column {
  /** column name */
  AccountNumber = 'account_number',
  /** column name */
  Amount = 'amount',
  /** column name */
  AssetRegistrationNumber = 'asset_registration_number',
  /** column name */
  CardNumber = 'card_number',
  /** column name */
  CardType = 'card_type',
  /** column name */
  CompanyName = 'company_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  CustomerId = 'customer_id',
  /** column name */
  DepartmentCode = 'department_code',
  /** column name */
  Id = 'id',
  /** column name */
  IsUsed = 'is_used',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Odometer = 'odometer',
  /** column name */
  Price = 'price',
  /** column name */
  ProductName = 'product_name',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  TotalizerEnd = 'totalizer_end',
  /** column name */
  TotalizerStart = 'totalizer_start',
  /** column name */
  TransactionDate = 'transaction_date',
  /** column name */
  TransactionEndTime = 'transaction_end_time',
  /** column name */
  TransactionMode = 'transaction_mode',
  /** column name */
  TransactionNumber = 'transaction_number',
  /** column name */
  TransactionStartTime = 'transaction_start_time',
  /** column name */
  TransactionTime = 'transaction_time',
  /** column name */
  TruckName = 'truck_name',
  /** column name */
  TruckRegistrationNumber = 'truck_registration_number'
}

/** input type for updating data in table "fueltrans_transaction_logs" */
export type Fueltrans_Transaction_Logs_Set_Input = {
  account_number?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['numeric']['input']>;
  asset_registration_number?: InputMaybe<Scalars['String']['input']>;
  card_number?: InputMaybe<Scalars['String']['input']>;
  card_type?: InputMaybe<Scalars['String']['input']>;
  company_name?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customer_id?: InputMaybe<Scalars['String']['input']>;
  department_code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_used?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  odometer?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['numeric']['input']>;
  product_name?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  totalizer_end?: InputMaybe<Scalars['String']['input']>;
  totalizer_start?: InputMaybe<Scalars['String']['input']>;
  transaction_date?: InputMaybe<Scalars['timestamp']['input']>;
  transaction_end_time?: InputMaybe<Scalars['timestamp']['input']>;
  transaction_mode?: InputMaybe<Scalars['String']['input']>;
  transaction_number?: InputMaybe<Scalars['String']['input']>;
  transaction_start_time?: InputMaybe<Scalars['timestamp']['input']>;
  transaction_time?: InputMaybe<Scalars['time']['input']>;
  truck_name?: InputMaybe<Scalars['String']['input']>;
  truck_registration_number?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Fueltrans_Transaction_Logs_Stddev_Fields = {
  __typename?: 'fueltrans_transaction_logs_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Fueltrans_Transaction_Logs_Stddev_Pop_Fields = {
  __typename?: 'fueltrans_transaction_logs_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Fueltrans_Transaction_Logs_Stddev_Samp_Fields = {
  __typename?: 'fueltrans_transaction_logs_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "fueltrans_transaction_logs" */
export type Fueltrans_Transaction_Logs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fueltrans_Transaction_Logs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fueltrans_Transaction_Logs_Stream_Cursor_Value_Input = {
  account_number?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['numeric']['input']>;
  asset_registration_number?: InputMaybe<Scalars['String']['input']>;
  card_number?: InputMaybe<Scalars['String']['input']>;
  card_type?: InputMaybe<Scalars['String']['input']>;
  company_name?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customer_id?: InputMaybe<Scalars['String']['input']>;
  department_code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_used?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  odometer?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['numeric']['input']>;
  product_name?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  totalizer_end?: InputMaybe<Scalars['String']['input']>;
  totalizer_start?: InputMaybe<Scalars['String']['input']>;
  transaction_date?: InputMaybe<Scalars['timestamp']['input']>;
  transaction_end_time?: InputMaybe<Scalars['timestamp']['input']>;
  transaction_mode?: InputMaybe<Scalars['String']['input']>;
  transaction_number?: InputMaybe<Scalars['String']['input']>;
  transaction_start_time?: InputMaybe<Scalars['timestamp']['input']>;
  transaction_time?: InputMaybe<Scalars['time']['input']>;
  truck_name?: InputMaybe<Scalars['String']['input']>;
  truck_registration_number?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Fueltrans_Transaction_Logs_Sum_Fields = {
  __typename?: 'fueltrans_transaction_logs_sum_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  price?: Maybe<Scalars['numeric']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "fueltrans_transaction_logs" */
export enum Fueltrans_Transaction_Logs_Update_Column {
  /** column name */
  AccountNumber = 'account_number',
  /** column name */
  Amount = 'amount',
  /** column name */
  AssetRegistrationNumber = 'asset_registration_number',
  /** column name */
  CardNumber = 'card_number',
  /** column name */
  CardType = 'card_type',
  /** column name */
  CompanyName = 'company_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  CustomerId = 'customer_id',
  /** column name */
  DepartmentCode = 'department_code',
  /** column name */
  Id = 'id',
  /** column name */
  IsUsed = 'is_used',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Odometer = 'odometer',
  /** column name */
  Price = 'price',
  /** column name */
  ProductName = 'product_name',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  TotalizerEnd = 'totalizer_end',
  /** column name */
  TotalizerStart = 'totalizer_start',
  /** column name */
  TransactionDate = 'transaction_date',
  /** column name */
  TransactionEndTime = 'transaction_end_time',
  /** column name */
  TransactionMode = 'transaction_mode',
  /** column name */
  TransactionNumber = 'transaction_number',
  /** column name */
  TransactionStartTime = 'transaction_start_time',
  /** column name */
  TransactionTime = 'transaction_time',
  /** column name */
  TruckName = 'truck_name',
  /** column name */
  TruckRegistrationNumber = 'truck_registration_number'
}

export type Fueltrans_Transaction_Logs_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Fueltrans_Transaction_Logs_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Fueltrans_Transaction_Logs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Fueltrans_Transaction_Logs_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Fueltrans_Transaction_Logs_Var_Pop_Fields = {
  __typename?: 'fueltrans_transaction_logs_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Fueltrans_Transaction_Logs_Var_Samp_Fields = {
  __typename?: 'fueltrans_transaction_logs_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Fueltrans_Transaction_Logs_Variance_Fields = {
  __typename?: 'fueltrans_transaction_logs_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

export type Geography_Cast_Exp = {
  geometry?: InputMaybe<Geometry_Comparison_Exp>;
};

/** columns and relationships of "geography_columns" */
export type Geography_Columns = {
  __typename?: 'geography_columns';
  coord_dimension?: Maybe<Scalars['Int']['output']>;
  f_geography_column?: Maybe<Scalars['name']['output']>;
  f_table_catalog?: Maybe<Scalars['name']['output']>;
  f_table_name?: Maybe<Scalars['name']['output']>;
  f_table_schema?: Maybe<Scalars['name']['output']>;
  srid?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "geography_columns" */
export type Geography_Columns_Aggregate = {
  __typename?: 'geography_columns_aggregate';
  aggregate?: Maybe<Geography_Columns_Aggregate_Fields>;
  nodes: Array<Geography_Columns>;
};

/** aggregate fields of "geography_columns" */
export type Geography_Columns_Aggregate_Fields = {
  __typename?: 'geography_columns_aggregate_fields';
  avg?: Maybe<Geography_Columns_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Geography_Columns_Max_Fields>;
  min?: Maybe<Geography_Columns_Min_Fields>;
  stddev?: Maybe<Geography_Columns_Stddev_Fields>;
  stddev_pop?: Maybe<Geography_Columns_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Geography_Columns_Stddev_Samp_Fields>;
  sum?: Maybe<Geography_Columns_Sum_Fields>;
  var_pop?: Maybe<Geography_Columns_Var_Pop_Fields>;
  var_samp?: Maybe<Geography_Columns_Var_Samp_Fields>;
  variance?: Maybe<Geography_Columns_Variance_Fields>;
};


/** aggregate fields of "geography_columns" */
export type Geography_Columns_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Geography_Columns_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Geography_Columns_Avg_Fields = {
  __typename?: 'geography_columns_avg_fields';
  coord_dimension?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "geography_columns". All fields are combined with a logical 'AND'. */
export type Geography_Columns_Bool_Exp = {
  _and?: InputMaybe<Array<Geography_Columns_Bool_Exp>>;
  _not?: InputMaybe<Geography_Columns_Bool_Exp>;
  _or?: InputMaybe<Array<Geography_Columns_Bool_Exp>>;
  coord_dimension?: InputMaybe<Int_Comparison_Exp>;
  f_geography_column?: InputMaybe<Name_Comparison_Exp>;
  f_table_catalog?: InputMaybe<Name_Comparison_Exp>;
  f_table_name?: InputMaybe<Name_Comparison_Exp>;
  f_table_schema?: InputMaybe<Name_Comparison_Exp>;
  srid?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Geography_Columns_Max_Fields = {
  __typename?: 'geography_columns_max_fields';
  coord_dimension?: Maybe<Scalars['Int']['output']>;
  srid?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Geography_Columns_Min_Fields = {
  __typename?: 'geography_columns_min_fields';
  coord_dimension?: Maybe<Scalars['Int']['output']>;
  srid?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "geography_columns". */
export type Geography_Columns_Order_By = {
  coord_dimension?: InputMaybe<Order_By>;
  f_geography_column?: InputMaybe<Order_By>;
  f_table_catalog?: InputMaybe<Order_By>;
  f_table_name?: InputMaybe<Order_By>;
  f_table_schema?: InputMaybe<Order_By>;
  srid?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** select columns of table "geography_columns" */
export enum Geography_Columns_Select_Column {
  /** column name */
  CoordDimension = 'coord_dimension',
  /** column name */
  FGeographyColumn = 'f_geography_column',
  /** column name */
  FTableCatalog = 'f_table_catalog',
  /** column name */
  FTableName = 'f_table_name',
  /** column name */
  FTableSchema = 'f_table_schema',
  /** column name */
  Srid = 'srid',
  /** column name */
  Type = 'type'
}

/** aggregate stddev on columns */
export type Geography_Columns_Stddev_Fields = {
  __typename?: 'geography_columns_stddev_fields';
  coord_dimension?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Geography_Columns_Stddev_Pop_Fields = {
  __typename?: 'geography_columns_stddev_pop_fields';
  coord_dimension?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Geography_Columns_Stddev_Samp_Fields = {
  __typename?: 'geography_columns_stddev_samp_fields';
  coord_dimension?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "geography_columns" */
export type Geography_Columns_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Geography_Columns_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Geography_Columns_Stream_Cursor_Value_Input = {
  coord_dimension?: InputMaybe<Scalars['Int']['input']>;
  f_geography_column?: InputMaybe<Scalars['name']['input']>;
  f_table_catalog?: InputMaybe<Scalars['name']['input']>;
  f_table_name?: InputMaybe<Scalars['name']['input']>;
  f_table_schema?: InputMaybe<Scalars['name']['input']>;
  srid?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Geography_Columns_Sum_Fields = {
  __typename?: 'geography_columns_sum_fields';
  coord_dimension?: Maybe<Scalars['Int']['output']>;
  srid?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Geography_Columns_Var_Pop_Fields = {
  __typename?: 'geography_columns_var_pop_fields';
  coord_dimension?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Geography_Columns_Var_Samp_Fields = {
  __typename?: 'geography_columns_var_samp_fields';
  coord_dimension?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Geography_Columns_Variance_Fields = {
  __typename?: 'geography_columns_variance_fields';
  coord_dimension?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "geography". All fields are combined with logical 'AND'. */
export type Geography_Comparison_Exp = {
  _cast?: InputMaybe<Geography_Cast_Exp>;
  _eq?: InputMaybe<Scalars['geography']['input']>;
  _gt?: InputMaybe<Scalars['geography']['input']>;
  _gte?: InputMaybe<Scalars['geography']['input']>;
  _in?: InputMaybe<Array<Scalars['geography']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['geography']['input']>;
  _lte?: InputMaybe<Scalars['geography']['input']>;
  _neq?: InputMaybe<Scalars['geography']['input']>;
  _nin?: InputMaybe<Array<Scalars['geography']['input']>>;
  /** is the column within a given distance from the given geography value */
  _st_d_within?: InputMaybe<St_D_Within_Geography_Input>;
  /** does the column spatially intersect the given geography value */
  _st_intersects?: InputMaybe<Scalars['geography']['input']>;
};

export type Geometry_Cast_Exp = {
  geography?: InputMaybe<Geography_Comparison_Exp>;
};

/** columns and relationships of "geometry_columns" */
export type Geometry_Columns = {
  __typename?: 'geometry_columns';
  coord_dimension?: Maybe<Scalars['Int']['output']>;
  f_geometry_column?: Maybe<Scalars['name']['output']>;
  f_table_catalog?: Maybe<Scalars['String']['output']>;
  f_table_name?: Maybe<Scalars['name']['output']>;
  f_table_schema?: Maybe<Scalars['name']['output']>;
  srid?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "geometry_columns" */
export type Geometry_Columns_Aggregate = {
  __typename?: 'geometry_columns_aggregate';
  aggregate?: Maybe<Geometry_Columns_Aggregate_Fields>;
  nodes: Array<Geometry_Columns>;
};

/** aggregate fields of "geometry_columns" */
export type Geometry_Columns_Aggregate_Fields = {
  __typename?: 'geometry_columns_aggregate_fields';
  avg?: Maybe<Geometry_Columns_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Geometry_Columns_Max_Fields>;
  min?: Maybe<Geometry_Columns_Min_Fields>;
  stddev?: Maybe<Geometry_Columns_Stddev_Fields>;
  stddev_pop?: Maybe<Geometry_Columns_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Geometry_Columns_Stddev_Samp_Fields>;
  sum?: Maybe<Geometry_Columns_Sum_Fields>;
  var_pop?: Maybe<Geometry_Columns_Var_Pop_Fields>;
  var_samp?: Maybe<Geometry_Columns_Var_Samp_Fields>;
  variance?: Maybe<Geometry_Columns_Variance_Fields>;
};


/** aggregate fields of "geometry_columns" */
export type Geometry_Columns_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Geometry_Columns_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Geometry_Columns_Avg_Fields = {
  __typename?: 'geometry_columns_avg_fields';
  coord_dimension?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "geometry_columns". All fields are combined with a logical 'AND'. */
export type Geometry_Columns_Bool_Exp = {
  _and?: InputMaybe<Array<Geometry_Columns_Bool_Exp>>;
  _not?: InputMaybe<Geometry_Columns_Bool_Exp>;
  _or?: InputMaybe<Array<Geometry_Columns_Bool_Exp>>;
  coord_dimension?: InputMaybe<Int_Comparison_Exp>;
  f_geometry_column?: InputMaybe<Name_Comparison_Exp>;
  f_table_catalog?: InputMaybe<String_Comparison_Exp>;
  f_table_name?: InputMaybe<Name_Comparison_Exp>;
  f_table_schema?: InputMaybe<Name_Comparison_Exp>;
  srid?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "geometry_columns" */
export type Geometry_Columns_Inc_Input = {
  coord_dimension?: InputMaybe<Scalars['Int']['input']>;
  srid?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "geometry_columns" */
export type Geometry_Columns_Insert_Input = {
  coord_dimension?: InputMaybe<Scalars['Int']['input']>;
  f_geometry_column?: InputMaybe<Scalars['name']['input']>;
  f_table_catalog?: InputMaybe<Scalars['String']['input']>;
  f_table_name?: InputMaybe<Scalars['name']['input']>;
  f_table_schema?: InputMaybe<Scalars['name']['input']>;
  srid?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Geometry_Columns_Max_Fields = {
  __typename?: 'geometry_columns_max_fields';
  coord_dimension?: Maybe<Scalars['Int']['output']>;
  f_table_catalog?: Maybe<Scalars['String']['output']>;
  srid?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Geometry_Columns_Min_Fields = {
  __typename?: 'geometry_columns_min_fields';
  coord_dimension?: Maybe<Scalars['Int']['output']>;
  f_table_catalog?: Maybe<Scalars['String']['output']>;
  srid?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "geometry_columns" */
export type Geometry_Columns_Mutation_Response = {
  __typename?: 'geometry_columns_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Geometry_Columns>;
};

/** Ordering options when selecting data from "geometry_columns". */
export type Geometry_Columns_Order_By = {
  coord_dimension?: InputMaybe<Order_By>;
  f_geometry_column?: InputMaybe<Order_By>;
  f_table_catalog?: InputMaybe<Order_By>;
  f_table_name?: InputMaybe<Order_By>;
  f_table_schema?: InputMaybe<Order_By>;
  srid?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** select columns of table "geometry_columns" */
export enum Geometry_Columns_Select_Column {
  /** column name */
  CoordDimension = 'coord_dimension',
  /** column name */
  FGeometryColumn = 'f_geometry_column',
  /** column name */
  FTableCatalog = 'f_table_catalog',
  /** column name */
  FTableName = 'f_table_name',
  /** column name */
  FTableSchema = 'f_table_schema',
  /** column name */
  Srid = 'srid',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "geometry_columns" */
export type Geometry_Columns_Set_Input = {
  coord_dimension?: InputMaybe<Scalars['Int']['input']>;
  f_geometry_column?: InputMaybe<Scalars['name']['input']>;
  f_table_catalog?: InputMaybe<Scalars['String']['input']>;
  f_table_name?: InputMaybe<Scalars['name']['input']>;
  f_table_schema?: InputMaybe<Scalars['name']['input']>;
  srid?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Geometry_Columns_Stddev_Fields = {
  __typename?: 'geometry_columns_stddev_fields';
  coord_dimension?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Geometry_Columns_Stddev_Pop_Fields = {
  __typename?: 'geometry_columns_stddev_pop_fields';
  coord_dimension?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Geometry_Columns_Stddev_Samp_Fields = {
  __typename?: 'geometry_columns_stddev_samp_fields';
  coord_dimension?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "geometry_columns" */
export type Geometry_Columns_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Geometry_Columns_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Geometry_Columns_Stream_Cursor_Value_Input = {
  coord_dimension?: InputMaybe<Scalars['Int']['input']>;
  f_geometry_column?: InputMaybe<Scalars['name']['input']>;
  f_table_catalog?: InputMaybe<Scalars['String']['input']>;
  f_table_name?: InputMaybe<Scalars['name']['input']>;
  f_table_schema?: InputMaybe<Scalars['name']['input']>;
  srid?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Geometry_Columns_Sum_Fields = {
  __typename?: 'geometry_columns_sum_fields';
  coord_dimension?: Maybe<Scalars['Int']['output']>;
  srid?: Maybe<Scalars['Int']['output']>;
};

export type Geometry_Columns_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Geometry_Columns_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Geometry_Columns_Set_Input>;
  /** filter the rows which have to be updated */
  where: Geometry_Columns_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Geometry_Columns_Var_Pop_Fields = {
  __typename?: 'geometry_columns_var_pop_fields';
  coord_dimension?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Geometry_Columns_Var_Samp_Fields = {
  __typename?: 'geometry_columns_var_samp_fields';
  coord_dimension?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Geometry_Columns_Variance_Fields = {
  __typename?: 'geometry_columns_variance_fields';
  coord_dimension?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "geometry". All fields are combined with logical 'AND'. */
export type Geometry_Comparison_Exp = {
  _cast?: InputMaybe<Geometry_Cast_Exp>;
  _eq?: InputMaybe<Scalars['geometry']['input']>;
  _gt?: InputMaybe<Scalars['geometry']['input']>;
  _gte?: InputMaybe<Scalars['geometry']['input']>;
  _in?: InputMaybe<Array<Scalars['geometry']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['geometry']['input']>;
  _lte?: InputMaybe<Scalars['geometry']['input']>;
  _neq?: InputMaybe<Scalars['geometry']['input']>;
  _nin?: InputMaybe<Array<Scalars['geometry']['input']>>;
  /** is the column within a given 3D distance from the given geometry value */
  _st_3d_d_within?: InputMaybe<St_D_Within_Input>;
  /** does the column spatially intersect the given geometry value in 3D */
  _st_3d_intersects?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column contain the given geometry value */
  _st_contains?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column cross the given geometry value */
  _st_crosses?: InputMaybe<Scalars['geometry']['input']>;
  /** is the column within a given distance from the given geometry value */
  _st_d_within?: InputMaybe<St_D_Within_Input>;
  /** is the column equal to given geometry value (directionality is ignored) */
  _st_equals?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column spatially intersect the given geometry value */
  _st_intersects?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column 'spatially overlap' (intersect but not completely contain) the given geometry value */
  _st_overlaps?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column have atleast one point in common with the given geometry value */
  _st_touches?: InputMaybe<Scalars['geometry']['input']>;
  /** is the column contained in the given geometry value */
  _st_within?: InputMaybe<Scalars['geometry']['input']>;
};

export type GetCustomerAssetDispensingLimitInput = {
  customer_asset_id: Scalars['uuid']['input'];
  dispensing_date?: InputMaybe<Scalars['timestamp']['input']>;
  product_variation_partner_localities_slot_id?: InputMaybe<Scalars['uuid']['input']>;
  taskId?: InputMaybe<Scalars['uuid']['input']>;
};

export type GetCustomerAssetDispensingLimitOutput = {
  __typename?: 'getCustomerAssetDispensingLimitOutput';
  data?: Maybe<Scalars['jsonb']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type GetDeviceHistoryInput = {
  deviceId: Scalars['String']['input'];
  endTime: Scalars['timestamp']['input'];
  orderKey: Scalars['String']['input'];
  orderType: Scalars['String']['input'];
  startTime: Scalars['timestamp']['input'];
};

export type GetDeviceHistoryOutput = {
  __typename?: 'getDeviceHistoryOutput';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type GetDeviceHistoryV1Input = {
  deviceId: Scalars['String']['input'];
  endTime: Scalars['timestamp']['input'];
  orderKey: Scalars['String']['input'];
  orderType: Scalars['String']['input'];
  startTime: Scalars['timestamp']['input'];
};

export type GetDeviceHistoryV1Output = {
  __typename?: 'getDeviceHistoryV1Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type GetDeviceHistoryV2Input = {
  deviceId: Scalars['String']['input'];
  endTime: Scalars['timestamp']['input'];
  orderKey: Scalars['String']['input'];
  orderType: Scalars['String']['input'];
  startTime: Scalars['timestamp']['input'];
};

export type GetDeviceHistoryV2Output = {
  __typename?: 'getDeviceHistoryV2Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type GetDeviceUpdateInput = {
  deviceIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetDeviceUpdateOutput = {
  __typename?: 'getDeviceUpdateOutput';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type GetDeviceUpdateV1Input = {
  deviceIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetDeviceUpdateV1Output = {
  __typename?: 'getDeviceUpdateV1Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type GetDeviceUpdateV4Input = {
  deviceIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetDeviceUpdateV4Output = {
  __typename?: 'getDeviceUpdateV4Output';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type GetLatestTaskValueInput = {
  asset_id: Scalars['uuid']['input'];
  task_id: Scalars['uuid']['input'];
};

export type GetLatestTaskValueOutput = {
  __typename?: 'getLatestTaskValueOutput';
  data?: Maybe<Scalars['jsonb']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type GetWalletStatementInput = {
  end_date: Scalars['String']['input'];
  organization_id: Scalars['uuid']['input'];
  start_date: Scalars['String']['input'];
};

export type GetWalletStatementOutput = {
  __typename?: 'getWalletStatementOutput';
  closing_balance?: Maybe<Scalars['numeric']['output']>;
  line_items?: Maybe<Array<Maybe<WalletStatementLineItem>>>;
  opening_balance?: Maybe<Scalars['numeric']['output']>;
  organization_id: Scalars['uuid']['output'];
  period?: Maybe<WalletStatementPeriod>;
  total_credits?: Maybe<Scalars['numeric']['output']>;
  total_debits?: Maybe<Scalars['numeric']['output']>;
  wallet_id: Scalars['uuid']['output'];
};

export type GuestToken = {
  __typename?: 'guestToken';
  guest_token: Scalars['String']['output'];
};

export type InitializeBackdatedWalletInput = {
  credit_during_period?: InputMaybe<Scalars['numeric']['input']>;
  date_of_record: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  opening_balance: Scalars['numeric']['input'];
  organization_id: Scalars['uuid']['input'];
};

export type InitializeBackdatedWalletOutput = {
  __typename?: 'initializeBackdatedWalletOutput';
  batch_id: Scalars['uuid']['output'];
  invoice_debits_inserted: Scalars['Int']['output'];
  invoice_debits_skipped: Scalars['Int']['output'];
  manual_credit_id?: Maybe<Scalars['uuid']['output']>;
  new_wallet_balance: Scalars['numeric']['output'];
  opening_adjustment_id?: Maybe<Scalars['uuid']['output']>;
  wallet_id: Scalars['uuid']['output'];
};

/** columns and relationships of "inventory" */
export type Inventory = {
  __typename?: 'inventory';
  access_password?: Maybe<Scalars['String']['output']>;
  capacity?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  customer_order: Customer_Order;
  customer_order_id: Scalars['uuid']['output'];
  delivery_date?: Maybe<Scalars['timestamp']['output']>;
  frequency?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  installation_date?: Maybe<Scalars['timestamp']['output']>;
  is_active: Scalars['Boolean']['output'];
  is_lockable: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  menufacture_date?: Maybe<Scalars['timestamp']['output']>;
  remotely_controlled: Scalars['Boolean']['output'];
  sim_company?: Maybe<Scalars['String']['output']>;
  sim_mobile?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "inventory" */
export type Inventory_Aggregate = {
  __typename?: 'inventory_aggregate';
  aggregate?: Maybe<Inventory_Aggregate_Fields>;
  nodes: Array<Inventory>;
};

export type Inventory_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Inventory_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Inventory_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Inventory_Aggregate_Bool_Exp_Count>;
};

export type Inventory_Aggregate_Bool_Exp_Bool_And = {
  arguments: Inventory_Select_Column_Inventory_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Inventory_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Inventory_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Inventory_Select_Column_Inventory_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Inventory_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Inventory_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Inventory_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Inventory_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "inventory" */
export type Inventory_Aggregate_Fields = {
  __typename?: 'inventory_aggregate_fields';
  avg?: Maybe<Inventory_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Inventory_Max_Fields>;
  min?: Maybe<Inventory_Min_Fields>;
  stddev?: Maybe<Inventory_Stddev_Fields>;
  stddev_pop?: Maybe<Inventory_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Inventory_Stddev_Samp_Fields>;
  sum?: Maybe<Inventory_Sum_Fields>;
  var_pop?: Maybe<Inventory_Var_Pop_Fields>;
  var_samp?: Maybe<Inventory_Var_Samp_Fields>;
  variance?: Maybe<Inventory_Variance_Fields>;
};


/** aggregate fields of "inventory" */
export type Inventory_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Inventory_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "inventory" */
export type Inventory_Aggregate_Order_By = {
  avg?: InputMaybe<Inventory_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Inventory_Max_Order_By>;
  min?: InputMaybe<Inventory_Min_Order_By>;
  stddev?: InputMaybe<Inventory_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Inventory_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Inventory_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Inventory_Sum_Order_By>;
  var_pop?: InputMaybe<Inventory_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Inventory_Var_Samp_Order_By>;
  variance?: InputMaybe<Inventory_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "inventory" */
export type Inventory_Arr_Rel_Insert_Input = {
  data: Array<Inventory_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Inventory_On_Conflict>;
};

/** aggregate avg on columns */
export type Inventory_Avg_Fields = {
  __typename?: 'inventory_avg_fields';
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "inventory" */
export type Inventory_Avg_Order_By = {
  version?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "inventory". All fields are combined with a logical 'AND'. */
export type Inventory_Bool_Exp = {
  _and?: InputMaybe<Array<Inventory_Bool_Exp>>;
  _not?: InputMaybe<Inventory_Bool_Exp>;
  _or?: InputMaybe<Array<Inventory_Bool_Exp>>;
  access_password?: InputMaybe<String_Comparison_Exp>;
  capacity?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_order?: InputMaybe<Customer_Order_Bool_Exp>;
  customer_order_id?: InputMaybe<Uuid_Comparison_Exp>;
  delivery_date?: InputMaybe<Timestamp_Comparison_Exp>;
  frequency?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  installation_date?: InputMaybe<Timestamp_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_lockable?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  menufacture_date?: InputMaybe<Timestamp_Comparison_Exp>;
  remotely_controlled?: InputMaybe<Boolean_Comparison_Exp>;
  sim_company?: InputMaybe<String_Comparison_Exp>;
  sim_mobile?: InputMaybe<String_Comparison_Exp>;
  version?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "inventory" */
export enum Inventory_Constraint {
  /** unique or primary key constraint on columns "id" */
  InventoryPkey = 'inventory_pkey'
}

/** input type for incrementing numeric columns in table "inventory" */
export type Inventory_Inc_Input = {
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "inventory" */
export type Inventory_Insert_Input = {
  access_password?: InputMaybe<Scalars['String']['input']>;
  capacity?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order?: InputMaybe<Customer_Order_Obj_Rel_Insert_Input>;
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
  delivery_date?: InputMaybe<Scalars['timestamp']['input']>;
  frequency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  installation_date?: InputMaybe<Scalars['timestamp']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_lockable?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  menufacture_date?: InputMaybe<Scalars['timestamp']['input']>;
  remotely_controlled?: InputMaybe<Scalars['Boolean']['input']>;
  sim_company?: InputMaybe<Scalars['String']['input']>;
  sim_mobile?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Inventory_Max_Fields = {
  __typename?: 'inventory_max_fields';
  access_password?: Maybe<Scalars['String']['output']>;
  capacity?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_order_id?: Maybe<Scalars['uuid']['output']>;
  delivery_date?: Maybe<Scalars['timestamp']['output']>;
  frequency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  installation_date?: Maybe<Scalars['timestamp']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  menufacture_date?: Maybe<Scalars['timestamp']['output']>;
  sim_company?: Maybe<Scalars['String']['output']>;
  sim_mobile?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "inventory" */
export type Inventory_Max_Order_By = {
  access_password?: InputMaybe<Order_By>;
  capacity?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_order_id?: InputMaybe<Order_By>;
  delivery_date?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  installation_date?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  menufacture_date?: InputMaybe<Order_By>;
  sim_company?: InputMaybe<Order_By>;
  sim_mobile?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Inventory_Min_Fields = {
  __typename?: 'inventory_min_fields';
  access_password?: Maybe<Scalars['String']['output']>;
  capacity?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_order_id?: Maybe<Scalars['uuid']['output']>;
  delivery_date?: Maybe<Scalars['timestamp']['output']>;
  frequency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  installation_date?: Maybe<Scalars['timestamp']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  menufacture_date?: Maybe<Scalars['timestamp']['output']>;
  sim_company?: Maybe<Scalars['String']['output']>;
  sim_mobile?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "inventory" */
export type Inventory_Min_Order_By = {
  access_password?: InputMaybe<Order_By>;
  capacity?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_order_id?: InputMaybe<Order_By>;
  delivery_date?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  installation_date?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  menufacture_date?: InputMaybe<Order_By>;
  sim_company?: InputMaybe<Order_By>;
  sim_mobile?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "inventory" */
export type Inventory_Mutation_Response = {
  __typename?: 'inventory_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Inventory>;
};

/** on_conflict condition type for table "inventory" */
export type Inventory_On_Conflict = {
  constraint: Inventory_Constraint;
  update_columns?: Array<Inventory_Update_Column>;
  where?: InputMaybe<Inventory_Bool_Exp>;
};

/** Ordering options when selecting data from "inventory". */
export type Inventory_Order_By = {
  access_password?: InputMaybe<Order_By>;
  capacity?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_order?: InputMaybe<Customer_Order_Order_By>;
  customer_order_id?: InputMaybe<Order_By>;
  delivery_date?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  installation_date?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_lockable?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  menufacture_date?: InputMaybe<Order_By>;
  remotely_controlled?: InputMaybe<Order_By>;
  sim_company?: InputMaybe<Order_By>;
  sim_mobile?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** primary key columns input for table: inventory */
export type Inventory_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "inventory" */
export enum Inventory_Select_Column {
  /** column name */
  AccessPassword = 'access_password',
  /** column name */
  Capacity = 'capacity',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerOrderId = 'customer_order_id',
  /** column name */
  DeliveryDate = 'delivery_date',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  Id = 'id',
  /** column name */
  InstallationDate = 'installation_date',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsLockable = 'is_lockable',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  MenufactureDate = 'menufacture_date',
  /** column name */
  RemotelyControlled = 'remotely_controlled',
  /** column name */
  SimCompany = 'sim_company',
  /** column name */
  SimMobile = 'sim_mobile',
  /** column name */
  Version = 'version'
}

/** select "inventory_aggregate_bool_exp_bool_and_arguments_columns" columns of table "inventory" */
export enum Inventory_Select_Column_Inventory_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsLockable = 'is_lockable',
  /** column name */
  RemotelyControlled = 'remotely_controlled'
}

/** select "inventory_aggregate_bool_exp_bool_or_arguments_columns" columns of table "inventory" */
export enum Inventory_Select_Column_Inventory_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsLockable = 'is_lockable',
  /** column name */
  RemotelyControlled = 'remotely_controlled'
}

/** input type for updating data in table "inventory" */
export type Inventory_Set_Input = {
  access_password?: InputMaybe<Scalars['String']['input']>;
  capacity?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
  delivery_date?: InputMaybe<Scalars['timestamp']['input']>;
  frequency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  installation_date?: InputMaybe<Scalars['timestamp']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_lockable?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  menufacture_date?: InputMaybe<Scalars['timestamp']['input']>;
  remotely_controlled?: InputMaybe<Scalars['Boolean']['input']>;
  sim_company?: InputMaybe<Scalars['String']['input']>;
  sim_mobile?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Inventory_Stddev_Fields = {
  __typename?: 'inventory_stddev_fields';
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "inventory" */
export type Inventory_Stddev_Order_By = {
  version?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Inventory_Stddev_Pop_Fields = {
  __typename?: 'inventory_stddev_pop_fields';
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "inventory" */
export type Inventory_Stddev_Pop_Order_By = {
  version?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Inventory_Stddev_Samp_Fields = {
  __typename?: 'inventory_stddev_samp_fields';
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "inventory" */
export type Inventory_Stddev_Samp_Order_By = {
  version?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "inventory" */
export type Inventory_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Inventory_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Inventory_Stream_Cursor_Value_Input = {
  access_password?: InputMaybe<Scalars['String']['input']>;
  capacity?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
  delivery_date?: InputMaybe<Scalars['timestamp']['input']>;
  frequency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  installation_date?: InputMaybe<Scalars['timestamp']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_lockable?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  menufacture_date?: InputMaybe<Scalars['timestamp']['input']>;
  remotely_controlled?: InputMaybe<Scalars['Boolean']['input']>;
  sim_company?: InputMaybe<Scalars['String']['input']>;
  sim_mobile?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Inventory_Sum_Fields = {
  __typename?: 'inventory_sum_fields';
  version?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "inventory" */
export type Inventory_Sum_Order_By = {
  version?: InputMaybe<Order_By>;
};

/** update columns of table "inventory" */
export enum Inventory_Update_Column {
  /** column name */
  AccessPassword = 'access_password',
  /** column name */
  Capacity = 'capacity',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerOrderId = 'customer_order_id',
  /** column name */
  DeliveryDate = 'delivery_date',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  Id = 'id',
  /** column name */
  InstallationDate = 'installation_date',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsLockable = 'is_lockable',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  MenufactureDate = 'menufacture_date',
  /** column name */
  RemotelyControlled = 'remotely_controlled',
  /** column name */
  SimCompany = 'sim_company',
  /** column name */
  SimMobile = 'sim_mobile',
  /** column name */
  Version = 'version'
}

export type Inventory_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Inventory_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Inventory_Set_Input>;
  /** filter the rows which have to be updated */
  where: Inventory_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Inventory_Var_Pop_Fields = {
  __typename?: 'inventory_var_pop_fields';
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "inventory" */
export type Inventory_Var_Pop_Order_By = {
  version?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Inventory_Var_Samp_Fields = {
  __typename?: 'inventory_var_samp_fields';
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "inventory" */
export type Inventory_Var_Samp_Order_By = {
  version?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Inventory_Variance_Fields = {
  __typename?: 'inventory_variance_fields';
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "inventory" */
export type Inventory_Variance_Order_By = {
  version?: InputMaybe<Order_By>;
};

/** Stores execution results for InventoryApprovalWorkflow (maker-checker flow). One row per workflow run. */
export type Inventory_Workflow_Logs = {
  __typename?: 'inventory_workflow_logs';
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  fillup_request: Fillup_Request;
  fillup_request_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  outcome?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['jsonb']['output']>;
  status: Scalars['String']['output'];
  workflow_id: Scalars['String']['output'];
  workflow_run_id: Scalars['String']['output'];
  workflow_version: Scalars['String']['output'];
};


/** Stores execution results for InventoryApprovalWorkflow (maker-checker flow). One row per workflow run. */
export type Inventory_Workflow_LogsResultArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "inventory_workflow_logs" */
export type Inventory_Workflow_Logs_Aggregate = {
  __typename?: 'inventory_workflow_logs_aggregate';
  aggregate?: Maybe<Inventory_Workflow_Logs_Aggregate_Fields>;
  nodes: Array<Inventory_Workflow_Logs>;
};

export type Inventory_Workflow_Logs_Aggregate_Bool_Exp = {
  count?: InputMaybe<Inventory_Workflow_Logs_Aggregate_Bool_Exp_Count>;
};

export type Inventory_Workflow_Logs_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Inventory_Workflow_Logs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Inventory_Workflow_Logs_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "inventory_workflow_logs" */
export type Inventory_Workflow_Logs_Aggregate_Fields = {
  __typename?: 'inventory_workflow_logs_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Inventory_Workflow_Logs_Max_Fields>;
  min?: Maybe<Inventory_Workflow_Logs_Min_Fields>;
};


/** aggregate fields of "inventory_workflow_logs" */
export type Inventory_Workflow_Logs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Inventory_Workflow_Logs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "inventory_workflow_logs" */
export type Inventory_Workflow_Logs_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Inventory_Workflow_Logs_Max_Order_By>;
  min?: InputMaybe<Inventory_Workflow_Logs_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Inventory_Workflow_Logs_Append_Input = {
  result?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "inventory_workflow_logs" */
export type Inventory_Workflow_Logs_Arr_Rel_Insert_Input = {
  data: Array<Inventory_Workflow_Logs_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Inventory_Workflow_Logs_On_Conflict>;
};

/** Boolean expression to filter rows from the table "inventory_workflow_logs". All fields are combined with a logical 'AND'. */
export type Inventory_Workflow_Logs_Bool_Exp = {
  _and?: InputMaybe<Array<Inventory_Workflow_Logs_Bool_Exp>>;
  _not?: InputMaybe<Inventory_Workflow_Logs_Bool_Exp>;
  _or?: InputMaybe<Array<Inventory_Workflow_Logs_Bool_Exp>>;
  completed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  fillup_request?: InputMaybe<Fillup_Request_Bool_Exp>;
  fillup_request_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  outcome?: InputMaybe<String_Comparison_Exp>;
  result?: InputMaybe<Jsonb_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  workflow_id?: InputMaybe<String_Comparison_Exp>;
  workflow_run_id?: InputMaybe<String_Comparison_Exp>;
  workflow_version?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "inventory_workflow_logs" */
export enum Inventory_Workflow_Logs_Constraint {
  /** unique or primary key constraint on columns "fillup_request_id", "workflow_run_id" */
  IdxInventoryWorkflowLogsWorkflowRun = 'idx_inventory_workflow_logs_workflow_run',
  /** unique or primary key constraint on columns "id" */
  InventoryWorkflowLogsPkey = 'inventory_workflow_logs_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Inventory_Workflow_Logs_Delete_At_Path_Input = {
  result?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Inventory_Workflow_Logs_Delete_Elem_Input = {
  result?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Inventory_Workflow_Logs_Delete_Key_Input = {
  result?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "inventory_workflow_logs" */
export type Inventory_Workflow_Logs_Insert_Input = {
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fillup_request?: InputMaybe<Fillup_Request_Obj_Rel_Insert_Input>;
  fillup_request_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<Scalars['jsonb']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  workflow_id?: InputMaybe<Scalars['String']['input']>;
  workflow_run_id?: InputMaybe<Scalars['String']['input']>;
  workflow_version?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Inventory_Workflow_Logs_Max_Fields = {
  __typename?: 'inventory_workflow_logs_max_fields';
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  fillup_request_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  workflow_id?: Maybe<Scalars['String']['output']>;
  workflow_run_id?: Maybe<Scalars['String']['output']>;
  workflow_version?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "inventory_workflow_logs" */
export type Inventory_Workflow_Logs_Max_Order_By = {
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  fillup_request_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  outcome?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
  workflow_run_id?: InputMaybe<Order_By>;
  workflow_version?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Inventory_Workflow_Logs_Min_Fields = {
  __typename?: 'inventory_workflow_logs_min_fields';
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  fillup_request_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  workflow_id?: Maybe<Scalars['String']['output']>;
  workflow_run_id?: Maybe<Scalars['String']['output']>;
  workflow_version?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "inventory_workflow_logs" */
export type Inventory_Workflow_Logs_Min_Order_By = {
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  fillup_request_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  outcome?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
  workflow_run_id?: InputMaybe<Order_By>;
  workflow_version?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "inventory_workflow_logs" */
export type Inventory_Workflow_Logs_Mutation_Response = {
  __typename?: 'inventory_workflow_logs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Inventory_Workflow_Logs>;
};

/** on_conflict condition type for table "inventory_workflow_logs" */
export type Inventory_Workflow_Logs_On_Conflict = {
  constraint: Inventory_Workflow_Logs_Constraint;
  update_columns?: Array<Inventory_Workflow_Logs_Update_Column>;
  where?: InputMaybe<Inventory_Workflow_Logs_Bool_Exp>;
};

/** Ordering options when selecting data from "inventory_workflow_logs". */
export type Inventory_Workflow_Logs_Order_By = {
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  fillup_request?: InputMaybe<Fillup_Request_Order_By>;
  fillup_request_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  outcome?: InputMaybe<Order_By>;
  result?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
  workflow_run_id?: InputMaybe<Order_By>;
  workflow_version?: InputMaybe<Order_By>;
};

/** primary key columns input for table: inventory_workflow_logs */
export type Inventory_Workflow_Logs_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Inventory_Workflow_Logs_Prepend_Input = {
  result?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "inventory_workflow_logs" */
export enum Inventory_Workflow_Logs_Select_Column {
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FillupRequestId = 'fillup_request_id',
  /** column name */
  Id = 'id',
  /** column name */
  Outcome = 'outcome',
  /** column name */
  Result = 'result',
  /** column name */
  Status = 'status',
  /** column name */
  WorkflowId = 'workflow_id',
  /** column name */
  WorkflowRunId = 'workflow_run_id',
  /** column name */
  WorkflowVersion = 'workflow_version'
}

/** input type for updating data in table "inventory_workflow_logs" */
export type Inventory_Workflow_Logs_Set_Input = {
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fillup_request_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<Scalars['jsonb']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  workflow_id?: InputMaybe<Scalars['String']['input']>;
  workflow_run_id?: InputMaybe<Scalars['String']['input']>;
  workflow_version?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "inventory_workflow_logs" */
export type Inventory_Workflow_Logs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Inventory_Workflow_Logs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Inventory_Workflow_Logs_Stream_Cursor_Value_Input = {
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fillup_request_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<Scalars['jsonb']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  workflow_id?: InputMaybe<Scalars['String']['input']>;
  workflow_run_id?: InputMaybe<Scalars['String']['input']>;
  workflow_version?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "inventory_workflow_logs" */
export enum Inventory_Workflow_Logs_Update_Column {
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FillupRequestId = 'fillup_request_id',
  /** column name */
  Id = 'id',
  /** column name */
  Outcome = 'outcome',
  /** column name */
  Result = 'result',
  /** column name */
  Status = 'status',
  /** column name */
  WorkflowId = 'workflow_id',
  /** column name */
  WorkflowRunId = 'workflow_run_id',
  /** column name */
  WorkflowVersion = 'workflow_version'
}

export type Inventory_Workflow_Logs_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Inventory_Workflow_Logs_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Inventory_Workflow_Logs_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Inventory_Workflow_Logs_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Inventory_Workflow_Logs_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Inventory_Workflow_Logs_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Inventory_Workflow_Logs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Inventory_Workflow_Logs_Bool_Exp;
};

/** columns and relationships of "invitation" */
export type Invitation = {
  __typename?: 'invitation';
  created_at: Scalars['timestamptz']['output'];
  erp_onboarded: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  invitation_status: Invitation_Status;
  is_active: Scalars['Boolean']['output'];
  last_modified: Scalars['timestamptz']['output'];
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  organization: Organization;
  /** An object relationship */
  organizationUserTypeByOrganizationUserType: Organization_User_Type;
  organization_id: Scalars['uuid']['output'];
  organization_user_type: Scalars['String']['output'];
  phone_number: Scalars['String']['output'];
  /** An object relationship */
  role: Role;
  role_id: Scalars['uuid']['output'];
  status: Invitation_Status_Enum;
};

/** aggregated selection of "invitation" */
export type Invitation_Aggregate = {
  __typename?: 'invitation_aggregate';
  aggregate?: Maybe<Invitation_Aggregate_Fields>;
  nodes: Array<Invitation>;
};

export type Invitation_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Invitation_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Invitation_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Invitation_Aggregate_Bool_Exp_Count>;
};

export type Invitation_Aggregate_Bool_Exp_Bool_And = {
  arguments: Invitation_Select_Column_Invitation_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Invitation_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Invitation_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Invitation_Select_Column_Invitation_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Invitation_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Invitation_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Invitation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Invitation_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "invitation" */
export type Invitation_Aggregate_Fields = {
  __typename?: 'invitation_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Invitation_Max_Fields>;
  min?: Maybe<Invitation_Min_Fields>;
};


/** aggregate fields of "invitation" */
export type Invitation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Invitation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "invitation" */
export type Invitation_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Invitation_Max_Order_By>;
  min?: InputMaybe<Invitation_Min_Order_By>;
};

/** input type for inserting array relation for remote table "invitation" */
export type Invitation_Arr_Rel_Insert_Input = {
  data: Array<Invitation_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Invitation_On_Conflict>;
};

/** Boolean expression to filter rows from the table "invitation". All fields are combined with a logical 'AND'. */
export type Invitation_Bool_Exp = {
  _and?: InputMaybe<Array<Invitation_Bool_Exp>>;
  _not?: InputMaybe<Invitation_Bool_Exp>;
  _or?: InputMaybe<Array<Invitation_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  erp_onboarded?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invitation_status?: InputMaybe<Invitation_Status_Bool_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationUserTypeByOrganizationUserType?: InputMaybe<Organization_User_Type_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  organization_user_type?: InputMaybe<String_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  role?: InputMaybe<Role_Bool_Exp>;
  role_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Invitation_Status_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "invitation" */
export enum Invitation_Constraint {
  /** unique or primary key constraint on columns "id" */
  InvitationPkey = 'invitation_pkey'
}

/** input type for inserting data into table "invitation" */
export type Invitation_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  erp_onboarded?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invitation_status?: InputMaybe<Invitation_Status_Obj_Rel_Insert_Input>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationUserTypeByOrganizationUserType?: InputMaybe<Organization_User_Type_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_user_type?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role_Obj_Rel_Insert_Input>;
  role_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Invitation_Status_Enum>;
};

/** aggregate max on columns */
export type Invitation_Max_Fields = {
  __typename?: 'invitation_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  organization_user_type?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  role_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "invitation" */
export type Invitation_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  organization_user_type?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Invitation_Min_Fields = {
  __typename?: 'invitation_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  organization_user_type?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  role_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "invitation" */
export type Invitation_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  organization_user_type?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "invitation" */
export type Invitation_Mutation_Response = {
  __typename?: 'invitation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Invitation>;
};

/** on_conflict condition type for table "invitation" */
export type Invitation_On_Conflict = {
  constraint: Invitation_Constraint;
  update_columns?: Array<Invitation_Update_Column>;
  where?: InputMaybe<Invitation_Bool_Exp>;
};

/** Ordering options when selecting data from "invitation". */
export type Invitation_Order_By = {
  created_at?: InputMaybe<Order_By>;
  erp_onboarded?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invitation_status?: InputMaybe<Invitation_Status_Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationUserTypeByOrganizationUserType?: InputMaybe<Organization_User_Type_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  organization_user_type?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  role?: InputMaybe<Role_Order_By>;
  role_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: invitation */
export type Invitation_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "invitation" */
export enum Invitation_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ErpOnboarded = 'erp_onboarded',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  OrganizationUserType = 'organization_user_type',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  Status = 'status'
}

/** select "invitation_aggregate_bool_exp_bool_and_arguments_columns" columns of table "invitation" */
export enum Invitation_Select_Column_Invitation_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  ErpOnboarded = 'erp_onboarded',
  /** column name */
  IsActive = 'is_active'
}

/** select "invitation_aggregate_bool_exp_bool_or_arguments_columns" columns of table "invitation" */
export enum Invitation_Select_Column_Invitation_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  ErpOnboarded = 'erp_onboarded',
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "invitation" */
export type Invitation_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  erp_onboarded?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_user_type?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  role_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Invitation_Status_Enum>;
};

/** columns and relationships of "invitation_status" */
export type Invitation_Status = {
  __typename?: 'invitation_status';
  comment: Scalars['String']['output'];
  /** An array relationship */
  invitations: Array<Invitation>;
  /** An aggregate relationship */
  invitations_aggregate: Invitation_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "invitation_status" */
export type Invitation_StatusInvitationsArgs = {
  distinct_on?: InputMaybe<Array<Invitation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invitation_Order_By>>;
  where?: InputMaybe<Invitation_Bool_Exp>;
};


/** columns and relationships of "invitation_status" */
export type Invitation_StatusInvitations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invitation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invitation_Order_By>>;
  where?: InputMaybe<Invitation_Bool_Exp>;
};

/** aggregated selection of "invitation_status" */
export type Invitation_Status_Aggregate = {
  __typename?: 'invitation_status_aggregate';
  aggregate?: Maybe<Invitation_Status_Aggregate_Fields>;
  nodes: Array<Invitation_Status>;
};

/** aggregate fields of "invitation_status" */
export type Invitation_Status_Aggregate_Fields = {
  __typename?: 'invitation_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Invitation_Status_Max_Fields>;
  min?: Maybe<Invitation_Status_Min_Fields>;
};


/** aggregate fields of "invitation_status" */
export type Invitation_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Invitation_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "invitation_status". All fields are combined with a logical 'AND'. */
export type Invitation_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Invitation_Status_Bool_Exp>>;
  _not?: InputMaybe<Invitation_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Invitation_Status_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  invitations?: InputMaybe<Invitation_Bool_Exp>;
  invitations_aggregate?: InputMaybe<Invitation_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "invitation_status" */
export enum Invitation_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  InvitationStatusPkey = 'invitation_status_pkey'
}

export enum Invitation_Status_Enum {
  /** UNUSED */
  Unused = 'UNUSED',
  /** USED */
  Used = 'USED'
}

/** Boolean expression to compare columns of type "invitation_status_enum". All fields are combined with logical 'AND'. */
export type Invitation_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Invitation_Status_Enum>;
  _in?: InputMaybe<Array<Invitation_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Invitation_Status_Enum>;
  _nin?: InputMaybe<Array<Invitation_Status_Enum>>;
};

/** input type for inserting data into table "invitation_status" */
export type Invitation_Status_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  invitations?: InputMaybe<Invitation_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Invitation_Status_Max_Fields = {
  __typename?: 'invitation_status_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Invitation_Status_Min_Fields = {
  __typename?: 'invitation_status_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "invitation_status" */
export type Invitation_Status_Mutation_Response = {
  __typename?: 'invitation_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Invitation_Status>;
};

/** input type for inserting object relation for remote table "invitation_status" */
export type Invitation_Status_Obj_Rel_Insert_Input = {
  data: Invitation_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Invitation_Status_On_Conflict>;
};

/** on_conflict condition type for table "invitation_status" */
export type Invitation_Status_On_Conflict = {
  constraint: Invitation_Status_Constraint;
  update_columns?: Array<Invitation_Status_Update_Column>;
  where?: InputMaybe<Invitation_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "invitation_status". */
export type Invitation_Status_Order_By = {
  comment?: InputMaybe<Order_By>;
  invitations_aggregate?: InputMaybe<Invitation_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: invitation_status */
export type Invitation_Status_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "invitation_status" */
export enum Invitation_Status_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "invitation_status" */
export type Invitation_Status_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "invitation_status" */
export type Invitation_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Invitation_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Invitation_Status_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "invitation_status" */
export enum Invitation_Status_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Invitation_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Invitation_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Invitation_Status_Bool_Exp;
};

/** Streaming cursor of the table "invitation" */
export type Invitation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Invitation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Invitation_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  erp_onboarded?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_user_type?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  role_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Invitation_Status_Enum>;
};

/** update columns of table "invitation" */
export enum Invitation_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ErpOnboarded = 'erp_onboarded',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  OrganizationUserType = 'organization_user_type',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  Status = 'status'
}

export type Invitation_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Invitation_Set_Input>;
  /** filter the rows which have to be updated */
  where: Invitation_Bool_Exp;
};

/** columns and relationships of "invoice" */
export type Invoice = {
  __typename?: 'invoice';
  amount?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  customer_order: Customer_Order;
  customer_order_id: Scalars['uuid']['output'];
  delivery_fee?: Maybe<Scalars['String']['output']>;
  discount_amount?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['uuid']['output'];
  invoice_date?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  invoiced_items: Array<Invoiced_Item>;
  /** An aggregate relationship */
  invoiced_items_aggregate: Invoiced_Item_Aggregate;
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  service_charges?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "invoice" */
export type InvoiceInvoiced_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Bool_Exp>;
};


/** columns and relationships of "invoice" */
export type InvoiceInvoiced_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Bool_Exp>;
};

/** aggregated selection of "invoice" */
export type Invoice_Aggregate = {
  __typename?: 'invoice_aggregate';
  aggregate?: Maybe<Invoice_Aggregate_Fields>;
  nodes: Array<Invoice>;
};

export type Invoice_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Invoice_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Invoice_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Invoice_Aggregate_Bool_Exp_Count>;
};

export type Invoice_Aggregate_Bool_Exp_Bool_And = {
  arguments: Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Invoice_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Invoice_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Invoice_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Invoice_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Invoice_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Invoice_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "invoice" */
export type Invoice_Aggregate_Fields = {
  __typename?: 'invoice_aggregate_fields';
  avg?: Maybe<Invoice_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Invoice_Max_Fields>;
  min?: Maybe<Invoice_Min_Fields>;
  stddev?: Maybe<Invoice_Stddev_Fields>;
  stddev_pop?: Maybe<Invoice_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Invoice_Stddev_Samp_Fields>;
  sum?: Maybe<Invoice_Sum_Fields>;
  var_pop?: Maybe<Invoice_Var_Pop_Fields>;
  var_samp?: Maybe<Invoice_Var_Samp_Fields>;
  variance?: Maybe<Invoice_Variance_Fields>;
};


/** aggregate fields of "invoice" */
export type Invoice_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Invoice_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "invoice" */
export type Invoice_Aggregate_Order_By = {
  avg?: InputMaybe<Invoice_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Invoice_Max_Order_By>;
  min?: InputMaybe<Invoice_Min_Order_By>;
  stddev?: InputMaybe<Invoice_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Invoice_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Invoice_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Invoice_Sum_Order_By>;
  var_pop?: InputMaybe<Invoice_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Invoice_Var_Samp_Order_By>;
  variance?: InputMaybe<Invoice_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "invoice" */
export type Invoice_Arr_Rel_Insert_Input = {
  data: Array<Invoice_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Invoice_On_Conflict>;
};

/** aggregate avg on columns */
export type Invoice_Avg_Fields = {
  __typename?: 'invoice_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "invoice" */
export type Invoice_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "invoice". All fields are combined with a logical 'AND'. */
export type Invoice_Bool_Exp = {
  _and?: InputMaybe<Array<Invoice_Bool_Exp>>;
  _not?: InputMaybe<Invoice_Bool_Exp>;
  _or?: InputMaybe<Array<Invoice_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_order?: InputMaybe<Customer_Order_Bool_Exp>;
  customer_order_id?: InputMaybe<Uuid_Comparison_Exp>;
  delivery_fee?: InputMaybe<String_Comparison_Exp>;
  discount_amount?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invoice_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  invoiced_items?: InputMaybe<Invoiced_Item_Bool_Exp>;
  invoiced_items_aggregate?: InputMaybe<Invoiced_Item_Aggregate_Bool_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  service_charges?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "invoice" */
export enum Invoice_Constraint {
  /** unique or primary key constraint on columns "customer_order_id" */
  InvoiceCustomerOrderIdKey = 'invoice_customer_order_id_key',
  /** unique or primary key constraint on columns "id" */
  InvoicePkey = 'invoice_pkey'
}

/** input type for incrementing numeric columns in table "invoice" */
export type Invoice_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  discount_amount?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "invoice" */
export type Invoice_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order?: InputMaybe<Customer_Order_Obj_Rel_Insert_Input>;
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
  delivery_fee?: InputMaybe<Scalars['String']['input']>;
  discount_amount?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invoice_date?: InputMaybe<Scalars['timestamptz']['input']>;
  invoiced_items?: InputMaybe<Invoiced_Item_Arr_Rel_Insert_Input>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  service_charges?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Invoice_Max_Fields = {
  __typename?: 'invoice_max_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_order_id?: Maybe<Scalars['uuid']['output']>;
  delivery_fee?: Maybe<Scalars['String']['output']>;
  discount_amount?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  invoice_date?: Maybe<Scalars['timestamptz']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  service_charges?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "invoice" */
export type Invoice_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_order_id?: InputMaybe<Order_By>;
  delivery_fee?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_date?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  service_charges?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Invoice_Min_Fields = {
  __typename?: 'invoice_min_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_order_id?: Maybe<Scalars['uuid']['output']>;
  delivery_fee?: Maybe<Scalars['String']['output']>;
  discount_amount?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  invoice_date?: Maybe<Scalars['timestamptz']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  service_charges?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "invoice" */
export type Invoice_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_order_id?: InputMaybe<Order_By>;
  delivery_fee?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_date?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  service_charges?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "invoice" */
export type Invoice_Mutation_Response = {
  __typename?: 'invoice_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Invoice>;
};

/** input type for inserting object relation for remote table "invoice" */
export type Invoice_Obj_Rel_Insert_Input = {
  data: Invoice_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Invoice_On_Conflict>;
};

/** on_conflict condition type for table "invoice" */
export type Invoice_On_Conflict = {
  constraint: Invoice_Constraint;
  update_columns?: Array<Invoice_Update_Column>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};

/** Ordering options when selecting data from "invoice". */
export type Invoice_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_order?: InputMaybe<Customer_Order_Order_By>;
  customer_order_id?: InputMaybe<Order_By>;
  delivery_fee?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_date?: InputMaybe<Order_By>;
  invoiced_items_aggregate?: InputMaybe<Invoiced_Item_Aggregate_Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  service_charges?: InputMaybe<Order_By>;
};

/** primary key columns input for table: invoice */
export type Invoice_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "invoice" */
export enum Invoice_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerOrderId = 'customer_order_id',
  /** column name */
  DeliveryFee = 'delivery_fee',
  /** column name */
  DiscountAmount = 'discount_amount',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceDate = 'invoice_date',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  ServiceCharges = 'service_charges'
}

/** select "invoice_aggregate_bool_exp_bool_and_arguments_columns" columns of table "invoice" */
export enum Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "invoice_aggregate_bool_exp_bool_or_arguments_columns" columns of table "invoice" */
export enum Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "invoice" */
export type Invoice_Set_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
  delivery_fee?: InputMaybe<Scalars['String']['input']>;
  discount_amount?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invoice_date?: InputMaybe<Scalars['timestamptz']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  service_charges?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Invoice_Stddev_Fields = {
  __typename?: 'invoice_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "invoice" */
export type Invoice_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Invoice_Stddev_Pop_Fields = {
  __typename?: 'invoice_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "invoice" */
export type Invoice_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Invoice_Stddev_Samp_Fields = {
  __typename?: 'invoice_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "invoice" */
export type Invoice_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "invoice" */
export type Invoice_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Invoice_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Invoice_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
  delivery_fee?: InputMaybe<Scalars['String']['input']>;
  discount_amount?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invoice_date?: InputMaybe<Scalars['timestamptz']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  service_charges?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Invoice_Sum_Fields = {
  __typename?: 'invoice_sum_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  discount_amount?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "invoice" */
export type Invoice_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
};

/** update columns of table "invoice" */
export enum Invoice_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerOrderId = 'customer_order_id',
  /** column name */
  DeliveryFee = 'delivery_fee',
  /** column name */
  DiscountAmount = 'discount_amount',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceDate = 'invoice_date',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  ServiceCharges = 'service_charges'
}

export type Invoice_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Invoice_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Invoice_Set_Input>;
  /** filter the rows which have to be updated */
  where: Invoice_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Invoice_Var_Pop_Fields = {
  __typename?: 'invoice_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "invoice" */
export type Invoice_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Invoice_Var_Samp_Fields = {
  __typename?: 'invoice_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "invoice" */
export type Invoice_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Invoice_Variance_Fields = {
  __typename?: 'invoice_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "invoice" */
export type Invoice_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
};

/** columns and relationships of "invoiced_item" */
export type Invoiced_Item = {
  __typename?: 'invoiced_item';
  actual_amount?: Maybe<Scalars['numeric']['output']>;
  actual_qty: Scalars['numeric']['output'];
  amount?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  customer_asset?: Maybe<Customer_Asset>;
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  customer_order_item: Customer_Order_Item;
  /** An object relationship */
  customer_order_item_state: Customer_Order_Item_State;
  delivery_note_erp_code?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  discountTypeByDiscountType?: Maybe<Discount_Type>;
  discount_amount?: Maybe<Scalars['numeric']['output']>;
  discount_rate?: Maybe<Scalars['numeric']['output']>;
  discount_type?: Maybe<Discount_Type_Enum>;
  dispensing_date?: Maybe<Scalars['timestamptz']['output']>;
  erp_sync_status?: Maybe<Vendor_Sync_Status_Enum>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  invoice: Invoice;
  invoice_id: Scalars['uuid']['output'];
  /** An array relationship */
  invoiced_item_cancellation_tickets: Array<Invoiced_Item_Cancellation_Tickets>;
  /** An aggregate relationship */
  invoiced_item_cancellation_tickets_aggregate: Invoiced_Item_Cancellation_Tickets_Aggregate;
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  limit_purchase_order_logs: Array<Limit_Purchase_Order_Logs>;
  /** An aggregate relationship */
  limit_purchase_order_logs_aggregate: Limit_Purchase_Order_Logs_Aggregate;
  /** IDEV-3146: true when the LPO this delivery would draw down (resolveTargetLpo rule) already existed on the delivery day. The reconcileLpoLogs sweep filters on it so pre-LPO deliveries are never repaired against a later LPO. */
  lpo_existed_at_delivery?: Maybe<Scalars['Boolean']['output']>;
  order_item_id: Scalars['uuid']['output'];
  /** An object relationship */
  product_partner_localities_price_history?: Maybe<Product_Partner_Localities_Price_History>;
  product_partner_localities_price_history_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  product_variation: Product_Variation;
  product_variation_id: Scalars['uuid']['output'];
  qty: Scalars['numeric']['output'];
  service_tax?: Maybe<Scalars['numeric']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  state: Customer_Order_Item_State_Enum;
  tax?: Maybe<Scalars['numeric']['output']>;
  taxable_amount: Scalars['numeric']['output'];
  unit: Unit_Of_Measure_Enum;
  /** An object relationship */
  unit_of_measure: Unit_Of_Measure;
  unit_price?: Maybe<Scalars['numeric']['output']>;
  unit_price_excl_vat: Scalars['numeric']['output'];
  vat_rate: Scalars['numeric']['output'];
  /** An object relationship */
  vendorSyncStatusByErpSyncStatus?: Maybe<Vendor_Sync_Status>;
  /** An object relationship */
  vendorSyncStatusByVendorSyncStatus: Vendor_Sync_Status;
  vendor_error?: Maybe<Scalars['String']['output']>;
  vendor_sync_attempts: Scalars['Int']['output'];
  vendor_sync_status: Vendor_Sync_Status_Enum;
  vendor_synced_at?: Maybe<Scalars['timestamptz']['output']>;
  version: Scalars['Int']['output'];
};


/** columns and relationships of "invoiced_item" */
export type Invoiced_ItemInvoiced_Item_Cancellation_TicketsArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Cancellation_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Cancellation_Tickets_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Bool_Exp>;
};


/** columns and relationships of "invoiced_item" */
export type Invoiced_ItemInvoiced_Item_Cancellation_Tickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Cancellation_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Cancellation_Tickets_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Bool_Exp>;
};


/** columns and relationships of "invoiced_item" */
export type Invoiced_ItemLimit_Purchase_Order_LogsArgs = {
  distinct_on?: InputMaybe<Array<Limit_Purchase_Order_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Limit_Purchase_Order_Logs_Order_By>>;
  where?: InputMaybe<Limit_Purchase_Order_Logs_Bool_Exp>;
};


/** columns and relationships of "invoiced_item" */
export type Invoiced_ItemLimit_Purchase_Order_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Limit_Purchase_Order_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Limit_Purchase_Order_Logs_Order_By>>;
  where?: InputMaybe<Limit_Purchase_Order_Logs_Bool_Exp>;
};

/** aggregated selection of "invoiced_item" */
export type Invoiced_Item_Aggregate = {
  __typename?: 'invoiced_item_aggregate';
  aggregate?: Maybe<Invoiced_Item_Aggregate_Fields>;
  nodes: Array<Invoiced_Item>;
};

export type Invoiced_Item_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Invoiced_Item_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Invoiced_Item_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Invoiced_Item_Aggregate_Bool_Exp_Count>;
};

export type Invoiced_Item_Aggregate_Bool_Exp_Bool_And = {
  arguments: Invoiced_Item_Select_Column_Invoiced_Item_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Invoiced_Item_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Invoiced_Item_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Invoiced_Item_Select_Column_Invoiced_Item_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Invoiced_Item_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Invoiced_Item_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Invoiced_Item_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Invoiced_Item_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "invoiced_item" */
export type Invoiced_Item_Aggregate_Fields = {
  __typename?: 'invoiced_item_aggregate_fields';
  avg?: Maybe<Invoiced_Item_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Invoiced_Item_Max_Fields>;
  min?: Maybe<Invoiced_Item_Min_Fields>;
  stddev?: Maybe<Invoiced_Item_Stddev_Fields>;
  stddev_pop?: Maybe<Invoiced_Item_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Invoiced_Item_Stddev_Samp_Fields>;
  sum?: Maybe<Invoiced_Item_Sum_Fields>;
  var_pop?: Maybe<Invoiced_Item_Var_Pop_Fields>;
  var_samp?: Maybe<Invoiced_Item_Var_Samp_Fields>;
  variance?: Maybe<Invoiced_Item_Variance_Fields>;
};


/** aggregate fields of "invoiced_item" */
export type Invoiced_Item_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Invoiced_Item_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "invoiced_item" */
export type Invoiced_Item_Aggregate_Order_By = {
  avg?: InputMaybe<Invoiced_Item_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Invoiced_Item_Max_Order_By>;
  min?: InputMaybe<Invoiced_Item_Min_Order_By>;
  stddev?: InputMaybe<Invoiced_Item_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Invoiced_Item_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Invoiced_Item_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Invoiced_Item_Sum_Order_By>;
  var_pop?: InputMaybe<Invoiced_Item_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Invoiced_Item_Var_Samp_Order_By>;
  variance?: InputMaybe<Invoiced_Item_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "invoiced_item" */
export type Invoiced_Item_Arr_Rel_Insert_Input = {
  data: Array<Invoiced_Item_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Invoiced_Item_On_Conflict>;
};

/** aggregate avg on columns */
export type Invoiced_Item_Avg_Fields = {
  __typename?: 'invoiced_item_avg_fields';
  actual_amount?: Maybe<Scalars['Float']['output']>;
  actual_qty?: Maybe<Scalars['Float']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  discount_rate?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  service_tax?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  taxable_amount?: Maybe<Scalars['Float']['output']>;
  unit_price?: Maybe<Scalars['Float']['output']>;
  unit_price_excl_vat?: Maybe<Scalars['Float']['output']>;
  vat_rate?: Maybe<Scalars['Float']['output']>;
  vendor_sync_attempts?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "invoiced_item" */
export type Invoiced_Item_Avg_Order_By = {
  actual_amount?: InputMaybe<Order_By>;
  actual_qty?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  discount_rate?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  taxable_amount?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  unit_price_excl_vat?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
  vendor_sync_attempts?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "invoiced_item". All fields are combined with a logical 'AND'. */
export type Invoiced_Item_Bool_Exp = {
  _and?: InputMaybe<Array<Invoiced_Item_Bool_Exp>>;
  _not?: InputMaybe<Invoiced_Item_Bool_Exp>;
  _or?: InputMaybe<Array<Invoiced_Item_Bool_Exp>>;
  actual_amount?: InputMaybe<Numeric_Comparison_Exp>;
  actual_qty?: InputMaybe<Numeric_Comparison_Exp>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_asset?: InputMaybe<Customer_Asset_Bool_Exp>;
  customer_asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  customer_order_item?: InputMaybe<Customer_Order_Item_Bool_Exp>;
  customer_order_item_state?: InputMaybe<Customer_Order_Item_State_Bool_Exp>;
  delivery_note_erp_code?: InputMaybe<String_Comparison_Exp>;
  discount?: InputMaybe<Numeric_Comparison_Exp>;
  discountTypeByDiscountType?: InputMaybe<Discount_Type_Bool_Exp>;
  discount_amount?: InputMaybe<Numeric_Comparison_Exp>;
  discount_rate?: InputMaybe<Numeric_Comparison_Exp>;
  discount_type?: InputMaybe<Discount_Type_Enum_Comparison_Exp>;
  dispensing_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  erp_sync_status?: InputMaybe<Vendor_Sync_Status_Enum_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invoice?: InputMaybe<Invoice_Bool_Exp>;
  invoice_id?: InputMaybe<Uuid_Comparison_Exp>;
  invoiced_item_cancellation_tickets?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Bool_Exp>;
  invoiced_item_cancellation_tickets_aggregate?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Aggregate_Bool_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  limit_purchase_order_logs?: InputMaybe<Limit_Purchase_Order_Logs_Bool_Exp>;
  limit_purchase_order_logs_aggregate?: InputMaybe<Limit_Purchase_Order_Logs_Aggregate_Bool_Exp>;
  lpo_existed_at_delivery?: InputMaybe<Boolean_Comparison_Exp>;
  order_item_id?: InputMaybe<Uuid_Comparison_Exp>;
  product_partner_localities_price_history?: InputMaybe<Product_Partner_Localities_Price_History_Bool_Exp>;
  product_partner_localities_price_history_id?: InputMaybe<Uuid_Comparison_Exp>;
  product_variation?: InputMaybe<Product_Variation_Bool_Exp>;
  product_variation_id?: InputMaybe<Uuid_Comparison_Exp>;
  qty?: InputMaybe<Numeric_Comparison_Exp>;
  service_tax?: InputMaybe<Numeric_Comparison_Exp>;
  session_id?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<Customer_Order_Item_State_Enum_Comparison_Exp>;
  tax?: InputMaybe<Numeric_Comparison_Exp>;
  taxable_amount?: InputMaybe<Numeric_Comparison_Exp>;
  unit?: InputMaybe<Unit_Of_Measure_Enum_Comparison_Exp>;
  unit_of_measure?: InputMaybe<Unit_Of_Measure_Bool_Exp>;
  unit_price?: InputMaybe<Numeric_Comparison_Exp>;
  unit_price_excl_vat?: InputMaybe<Numeric_Comparison_Exp>;
  vat_rate?: InputMaybe<Numeric_Comparison_Exp>;
  vendorSyncStatusByErpSyncStatus?: InputMaybe<Vendor_Sync_Status_Bool_Exp>;
  vendorSyncStatusByVendorSyncStatus?: InputMaybe<Vendor_Sync_Status_Bool_Exp>;
  vendor_error?: InputMaybe<String_Comparison_Exp>;
  vendor_sync_attempts?: InputMaybe<Int_Comparison_Exp>;
  vendor_sync_status?: InputMaybe<Vendor_Sync_Status_Enum_Comparison_Exp>;
  vendor_synced_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  version?: InputMaybe<Int_Comparison_Exp>;
};

/** Enum table for invoiced item cancellation ticket states */
export type Invoiced_Item_Cancellation_Ticket_States = {
  __typename?: 'invoiced_item_cancellation_ticket_states';
  comment: Scalars['String']['output'];
  /** An array relationship */
  invoiced_item_cancellation_tickets: Array<Invoiced_Item_Cancellation_Tickets>;
  /** An aggregate relationship */
  invoiced_item_cancellation_tickets_aggregate: Invoiced_Item_Cancellation_Tickets_Aggregate;
  value: Scalars['String']['output'];
};


/** Enum table for invoiced item cancellation ticket states */
export type Invoiced_Item_Cancellation_Ticket_StatesInvoiced_Item_Cancellation_TicketsArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Cancellation_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Cancellation_Tickets_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Bool_Exp>;
};


/** Enum table for invoiced item cancellation ticket states */
export type Invoiced_Item_Cancellation_Ticket_StatesInvoiced_Item_Cancellation_Tickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Cancellation_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Cancellation_Tickets_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Bool_Exp>;
};

/** aggregated selection of "invoiced_item_cancellation_ticket_states" */
export type Invoiced_Item_Cancellation_Ticket_States_Aggregate = {
  __typename?: 'invoiced_item_cancellation_ticket_states_aggregate';
  aggregate?: Maybe<Invoiced_Item_Cancellation_Ticket_States_Aggregate_Fields>;
  nodes: Array<Invoiced_Item_Cancellation_Ticket_States>;
};

/** aggregate fields of "invoiced_item_cancellation_ticket_states" */
export type Invoiced_Item_Cancellation_Ticket_States_Aggregate_Fields = {
  __typename?: 'invoiced_item_cancellation_ticket_states_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Invoiced_Item_Cancellation_Ticket_States_Max_Fields>;
  min?: Maybe<Invoiced_Item_Cancellation_Ticket_States_Min_Fields>;
};


/** aggregate fields of "invoiced_item_cancellation_ticket_states" */
export type Invoiced_Item_Cancellation_Ticket_States_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Invoiced_Item_Cancellation_Ticket_States_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "invoiced_item_cancellation_ticket_states". All fields are combined with a logical 'AND'. */
export type Invoiced_Item_Cancellation_Ticket_States_Bool_Exp = {
  _and?: InputMaybe<Array<Invoiced_Item_Cancellation_Ticket_States_Bool_Exp>>;
  _not?: InputMaybe<Invoiced_Item_Cancellation_Ticket_States_Bool_Exp>;
  _or?: InputMaybe<Array<Invoiced_Item_Cancellation_Ticket_States_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  invoiced_item_cancellation_tickets?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Bool_Exp>;
  invoiced_item_cancellation_tickets_aggregate?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "invoiced_item_cancellation_ticket_states" */
export enum Invoiced_Item_Cancellation_Ticket_States_Constraint {
  /** unique or primary key constraint on columns "value" */
  InvoicedItemCancellationTicketStatesPkey = 'invoiced_item_cancellation_ticket_states_pkey'
}

export enum Invoiced_Item_Cancellation_Ticket_States_Enum {
  /** Cancellation approved */
  Approved = 'APPROVED',
  /** Ticket awaiting review */
  Pending = 'PENDING',
  /** Cancellation rejected */
  Rejected = 'REJECTED'
}

/** Boolean expression to compare columns of type "invoiced_item_cancellation_ticket_states_enum". All fields are combined with logical 'AND'. */
export type Invoiced_Item_Cancellation_Ticket_States_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Invoiced_Item_Cancellation_Ticket_States_Enum>;
  _in?: InputMaybe<Array<Invoiced_Item_Cancellation_Ticket_States_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Invoiced_Item_Cancellation_Ticket_States_Enum>;
  _nin?: InputMaybe<Array<Invoiced_Item_Cancellation_Ticket_States_Enum>>;
};

/** input type for inserting data into table "invoiced_item_cancellation_ticket_states" */
export type Invoiced_Item_Cancellation_Ticket_States_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  invoiced_item_cancellation_tickets?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Invoiced_Item_Cancellation_Ticket_States_Max_Fields = {
  __typename?: 'invoiced_item_cancellation_ticket_states_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Invoiced_Item_Cancellation_Ticket_States_Min_Fields = {
  __typename?: 'invoiced_item_cancellation_ticket_states_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "invoiced_item_cancellation_ticket_states" */
export type Invoiced_Item_Cancellation_Ticket_States_Mutation_Response = {
  __typename?: 'invoiced_item_cancellation_ticket_states_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Invoiced_Item_Cancellation_Ticket_States>;
};

/** input type for inserting object relation for remote table "invoiced_item_cancellation_ticket_states" */
export type Invoiced_Item_Cancellation_Ticket_States_Obj_Rel_Insert_Input = {
  data: Invoiced_Item_Cancellation_Ticket_States_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Invoiced_Item_Cancellation_Ticket_States_On_Conflict>;
};

/** on_conflict condition type for table "invoiced_item_cancellation_ticket_states" */
export type Invoiced_Item_Cancellation_Ticket_States_On_Conflict = {
  constraint: Invoiced_Item_Cancellation_Ticket_States_Constraint;
  update_columns?: Array<Invoiced_Item_Cancellation_Ticket_States_Update_Column>;
  where?: InputMaybe<Invoiced_Item_Cancellation_Ticket_States_Bool_Exp>;
};

/** Ordering options when selecting data from "invoiced_item_cancellation_ticket_states". */
export type Invoiced_Item_Cancellation_Ticket_States_Order_By = {
  comment?: InputMaybe<Order_By>;
  invoiced_item_cancellation_tickets_aggregate?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: invoiced_item_cancellation_ticket_states */
export type Invoiced_Item_Cancellation_Ticket_States_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "invoiced_item_cancellation_ticket_states" */
export enum Invoiced_Item_Cancellation_Ticket_States_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "invoiced_item_cancellation_ticket_states" */
export type Invoiced_Item_Cancellation_Ticket_States_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "invoiced_item_cancellation_ticket_states" */
export type Invoiced_Item_Cancellation_Ticket_States_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Invoiced_Item_Cancellation_Ticket_States_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Invoiced_Item_Cancellation_Ticket_States_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "invoiced_item_cancellation_ticket_states" */
export enum Invoiced_Item_Cancellation_Ticket_States_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Invoiced_Item_Cancellation_Ticket_States_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Invoiced_Item_Cancellation_Ticket_States_Set_Input>;
  /** filter the rows which have to be updated */
  where: Invoiced_Item_Cancellation_Ticket_States_Bool_Exp;
};

/** Cancellation requests for invoiced items. Tech Support creates, workflow processes. */
export type Invoiced_Item_Cancellation_Tickets = {
  __typename?: 'invoiced_item_cancellation_tickets';
  approved_by?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  image_url?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  invoiced_item: Invoiced_Item;
  /** An object relationship */
  invoiced_item_cancellation_ticket_state: Invoiced_Item_Cancellation_Ticket_States;
  invoiced_item_id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified: Scalars['timestamptz']['output'];
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  reason: Reasons;
  reason_id: Scalars['uuid']['output'];
  state: Invoiced_Item_Cancellation_Ticket_States_Enum;
  /** An object relationship */
  user?: Maybe<User>;
  /** An object relationship */
  userByCreatedBy?: Maybe<User>;
  /** An object relationship */
  userByLastModifiedBy?: Maybe<User>;
};

/** aggregated selection of "invoiced_item_cancellation_tickets" */
export type Invoiced_Item_Cancellation_Tickets_Aggregate = {
  __typename?: 'invoiced_item_cancellation_tickets_aggregate';
  aggregate?: Maybe<Invoiced_Item_Cancellation_Tickets_Aggregate_Fields>;
  nodes: Array<Invoiced_Item_Cancellation_Tickets>;
};

export type Invoiced_Item_Cancellation_Tickets_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Aggregate_Bool_Exp_Count>;
};

export type Invoiced_Item_Cancellation_Tickets_Aggregate_Bool_Exp_Bool_And = {
  arguments: Invoiced_Item_Cancellation_Tickets_Select_Column_Invoiced_Item_Cancellation_Tickets_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Invoiced_Item_Cancellation_Tickets_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Invoiced_Item_Cancellation_Tickets_Select_Column_Invoiced_Item_Cancellation_Tickets_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Invoiced_Item_Cancellation_Tickets_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Invoiced_Item_Cancellation_Tickets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "invoiced_item_cancellation_tickets" */
export type Invoiced_Item_Cancellation_Tickets_Aggregate_Fields = {
  __typename?: 'invoiced_item_cancellation_tickets_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Invoiced_Item_Cancellation_Tickets_Max_Fields>;
  min?: Maybe<Invoiced_Item_Cancellation_Tickets_Min_Fields>;
};


/** aggregate fields of "invoiced_item_cancellation_tickets" */
export type Invoiced_Item_Cancellation_Tickets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Invoiced_Item_Cancellation_Tickets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "invoiced_item_cancellation_tickets" */
export type Invoiced_Item_Cancellation_Tickets_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Max_Order_By>;
  min?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Min_Order_By>;
};

/** input type for inserting array relation for remote table "invoiced_item_cancellation_tickets" */
export type Invoiced_Item_Cancellation_Tickets_Arr_Rel_Insert_Input = {
  data: Array<Invoiced_Item_Cancellation_Tickets_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Invoiced_Item_Cancellation_Tickets_On_Conflict>;
};

/** Boolean expression to filter rows from the table "invoiced_item_cancellation_tickets". All fields are combined with a logical 'AND'. */
export type Invoiced_Item_Cancellation_Tickets_Bool_Exp = {
  _and?: InputMaybe<Array<Invoiced_Item_Cancellation_Tickets_Bool_Exp>>;
  _not?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Bool_Exp>;
  _or?: InputMaybe<Array<Invoiced_Item_Cancellation_Tickets_Bool_Exp>>;
  approved_by?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  invoiced_item?: InputMaybe<Invoiced_Item_Bool_Exp>;
  invoiced_item_cancellation_ticket_state?: InputMaybe<Invoiced_Item_Cancellation_Ticket_States_Bool_Exp>;
  invoiced_item_id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  reason?: InputMaybe<Reasons_Bool_Exp>;
  reason_id?: InputMaybe<Uuid_Comparison_Exp>;
  state?: InputMaybe<Invoiced_Item_Cancellation_Ticket_States_Enum_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userByCreatedBy?: InputMaybe<User_Bool_Exp>;
  userByLastModifiedBy?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "invoiced_item_cancellation_tickets" */
export enum Invoiced_Item_Cancellation_Tickets_Constraint {
  /** unique or primary key constraint on columns "id" */
  InvoicedItemCancellationTicketsPkey = 'invoiced_item_cancellation_tickets_pkey'
}

/** input type for inserting data into table "invoiced_item_cancellation_tickets" */
export type Invoiced_Item_Cancellation_Tickets_Insert_Input = {
  approved_by?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image_url?: InputMaybe<Scalars['String']['input']>;
  invoiced_item?: InputMaybe<Invoiced_Item_Obj_Rel_Insert_Input>;
  invoiced_item_cancellation_ticket_state?: InputMaybe<Invoiced_Item_Cancellation_Ticket_States_Obj_Rel_Insert_Input>;
  invoiced_item_id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Reasons_Obj_Rel_Insert_Input>;
  reason_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Invoiced_Item_Cancellation_Ticket_States_Enum>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userByCreatedBy?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userByLastModifiedBy?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Invoiced_Item_Cancellation_Tickets_Max_Fields = {
  __typename?: 'invoiced_item_cancellation_tickets_max_fields';
  approved_by?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_url?: Maybe<Scalars['String']['output']>;
  invoiced_item_id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  reason_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "invoiced_item_cancellation_tickets" */
export type Invoiced_Item_Cancellation_Tickets_Max_Order_By = {
  approved_by?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  invoiced_item_id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  reason_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Invoiced_Item_Cancellation_Tickets_Min_Fields = {
  __typename?: 'invoiced_item_cancellation_tickets_min_fields';
  approved_by?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_url?: Maybe<Scalars['String']['output']>;
  invoiced_item_id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  reason_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "invoiced_item_cancellation_tickets" */
export type Invoiced_Item_Cancellation_Tickets_Min_Order_By = {
  approved_by?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  invoiced_item_id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  reason_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "invoiced_item_cancellation_tickets" */
export type Invoiced_Item_Cancellation_Tickets_Mutation_Response = {
  __typename?: 'invoiced_item_cancellation_tickets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Invoiced_Item_Cancellation_Tickets>;
};

/** on_conflict condition type for table "invoiced_item_cancellation_tickets" */
export type Invoiced_Item_Cancellation_Tickets_On_Conflict = {
  constraint: Invoiced_Item_Cancellation_Tickets_Constraint;
  update_columns?: Array<Invoiced_Item_Cancellation_Tickets_Update_Column>;
  where?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Bool_Exp>;
};

/** Ordering options when selecting data from "invoiced_item_cancellation_tickets". */
export type Invoiced_Item_Cancellation_Tickets_Order_By = {
  approved_by?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  invoiced_item?: InputMaybe<Invoiced_Item_Order_By>;
  invoiced_item_cancellation_ticket_state?: InputMaybe<Invoiced_Item_Cancellation_Ticket_States_Order_By>;
  invoiced_item_id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  reason?: InputMaybe<Reasons_Order_By>;
  reason_id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userByCreatedBy?: InputMaybe<User_Order_By>;
  userByLastModifiedBy?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: invoiced_item_cancellation_tickets */
export type Invoiced_Item_Cancellation_Tickets_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "invoiced_item_cancellation_tickets" */
export enum Invoiced_Item_Cancellation_Tickets_Select_Column {
  /** column name */
  ApprovedBy = 'approved_by',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  InvoicedItemId = 'invoiced_item_id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Message = 'message',
  /** column name */
  ReasonId = 'reason_id',
  /** column name */
  State = 'state'
}

/** select "invoiced_item_cancellation_tickets_aggregate_bool_exp_bool_and_arguments_columns" columns of table "invoiced_item_cancellation_tickets" */
export enum Invoiced_Item_Cancellation_Tickets_Select_Column_Invoiced_Item_Cancellation_Tickets_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "invoiced_item_cancellation_tickets_aggregate_bool_exp_bool_or_arguments_columns" columns of table "invoiced_item_cancellation_tickets" */
export enum Invoiced_Item_Cancellation_Tickets_Select_Column_Invoiced_Item_Cancellation_Tickets_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "invoiced_item_cancellation_tickets" */
export type Invoiced_Item_Cancellation_Tickets_Set_Input = {
  approved_by?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image_url?: InputMaybe<Scalars['String']['input']>;
  invoiced_item_id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  reason_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Invoiced_Item_Cancellation_Ticket_States_Enum>;
};

/** Streaming cursor of the table "invoiced_item_cancellation_tickets" */
export type Invoiced_Item_Cancellation_Tickets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Invoiced_Item_Cancellation_Tickets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Invoiced_Item_Cancellation_Tickets_Stream_Cursor_Value_Input = {
  approved_by?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image_url?: InputMaybe<Scalars['String']['input']>;
  invoiced_item_id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  reason_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Invoiced_Item_Cancellation_Ticket_States_Enum>;
};

/** update columns of table "invoiced_item_cancellation_tickets" */
export enum Invoiced_Item_Cancellation_Tickets_Update_Column {
  /** column name */
  ApprovedBy = 'approved_by',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  InvoicedItemId = 'invoiced_item_id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Message = 'message',
  /** column name */
  ReasonId = 'reason_id',
  /** column name */
  State = 'state'
}

export type Invoiced_Item_Cancellation_Tickets_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Set_Input>;
  /** filter the rows which have to be updated */
  where: Invoiced_Item_Cancellation_Tickets_Bool_Exp;
};

/** unique or primary key constraints on table "invoiced_item" */
export enum Invoiced_Item_Constraint {
  /** unique or primary key constraint on columns "customer_asset_id", "invoice_id" */
  InvoicedItemInvoiceCustomerAssetActiveUnique = 'invoiced_item_invoice_customer_asset_active_unique',
  /** unique or primary key constraint on columns "id" */
  InvoicedItemPkey = 'invoiced_item_pkey'
}

/** input type for incrementing numeric columns in table "invoiced_item" */
export type Invoiced_Item_Inc_Input = {
  actual_amount?: InputMaybe<Scalars['numeric']['input']>;
  actual_qty?: InputMaybe<Scalars['numeric']['input']>;
  amount?: InputMaybe<Scalars['numeric']['input']>;
  discount?: InputMaybe<Scalars['numeric']['input']>;
  discount_amount?: InputMaybe<Scalars['numeric']['input']>;
  discount_rate?: InputMaybe<Scalars['numeric']['input']>;
  qty?: InputMaybe<Scalars['numeric']['input']>;
  service_tax?: InputMaybe<Scalars['numeric']['input']>;
  tax?: InputMaybe<Scalars['numeric']['input']>;
  taxable_amount?: InputMaybe<Scalars['numeric']['input']>;
  unit_price?: InputMaybe<Scalars['numeric']['input']>;
  unit_price_excl_vat?: InputMaybe<Scalars['numeric']['input']>;
  vat_rate?: InputMaybe<Scalars['numeric']['input']>;
  vendor_sync_attempts?: InputMaybe<Scalars['Int']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "invoiced_item" */
export type Invoiced_Item_Insert_Input = {
  actual_amount?: InputMaybe<Scalars['numeric']['input']>;
  actual_qty?: InputMaybe<Scalars['numeric']['input']>;
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_asset?: InputMaybe<Customer_Asset_Obj_Rel_Insert_Input>;
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  customer_order_item?: InputMaybe<Customer_Order_Item_Obj_Rel_Insert_Input>;
  customer_order_item_state?: InputMaybe<Customer_Order_Item_State_Obj_Rel_Insert_Input>;
  delivery_note_erp_code?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['numeric']['input']>;
  discountTypeByDiscountType?: InputMaybe<Discount_Type_Obj_Rel_Insert_Input>;
  discount_amount?: InputMaybe<Scalars['numeric']['input']>;
  discount_rate?: InputMaybe<Scalars['numeric']['input']>;
  discount_type?: InputMaybe<Discount_Type_Enum>;
  dispensing_date?: InputMaybe<Scalars['timestamptz']['input']>;
  erp_sync_status?: InputMaybe<Vendor_Sync_Status_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invoice?: InputMaybe<Invoice_Obj_Rel_Insert_Input>;
  invoice_id?: InputMaybe<Scalars['uuid']['input']>;
  invoiced_item_cancellation_tickets?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Arr_Rel_Insert_Input>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  limit_purchase_order_logs?: InputMaybe<Limit_Purchase_Order_Logs_Arr_Rel_Insert_Input>;
  order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  product_partner_localities_price_history?: InputMaybe<Product_Partner_Localities_Price_History_Obj_Rel_Insert_Input>;
  product_partner_localities_price_history_id?: InputMaybe<Scalars['uuid']['input']>;
  product_variation?: InputMaybe<Product_Variation_Obj_Rel_Insert_Input>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  qty?: InputMaybe<Scalars['numeric']['input']>;
  service_tax?: InputMaybe<Scalars['numeric']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Customer_Order_Item_State_Enum>;
  tax?: InputMaybe<Scalars['numeric']['input']>;
  taxable_amount?: InputMaybe<Scalars['numeric']['input']>;
  unit?: InputMaybe<Unit_Of_Measure_Enum>;
  unit_of_measure?: InputMaybe<Unit_Of_Measure_Obj_Rel_Insert_Input>;
  unit_price?: InputMaybe<Scalars['numeric']['input']>;
  unit_price_excl_vat?: InputMaybe<Scalars['numeric']['input']>;
  vat_rate?: InputMaybe<Scalars['numeric']['input']>;
  vendorSyncStatusByErpSyncStatus?: InputMaybe<Vendor_Sync_Status_Obj_Rel_Insert_Input>;
  vendorSyncStatusByVendorSyncStatus?: InputMaybe<Vendor_Sync_Status_Obj_Rel_Insert_Input>;
  vendor_error?: InputMaybe<Scalars['String']['input']>;
  vendor_sync_attempts?: InputMaybe<Scalars['Int']['input']>;
  vendor_sync_status?: InputMaybe<Vendor_Sync_Status_Enum>;
  vendor_synced_at?: InputMaybe<Scalars['timestamptz']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Invoiced_Item_Max_Fields = {
  __typename?: 'invoiced_item_max_fields';
  actual_amount?: Maybe<Scalars['numeric']['output']>;
  actual_qty?: Maybe<Scalars['numeric']['output']>;
  amount?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  delivery_note_erp_code?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['numeric']['output']>;
  discount_amount?: Maybe<Scalars['numeric']['output']>;
  discount_rate?: Maybe<Scalars['numeric']['output']>;
  dispensing_date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  invoice_id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  order_item_id?: Maybe<Scalars['uuid']['output']>;
  product_partner_localities_price_history_id?: Maybe<Scalars['uuid']['output']>;
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
  qty?: Maybe<Scalars['numeric']['output']>;
  service_tax?: Maybe<Scalars['numeric']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  tax?: Maybe<Scalars['numeric']['output']>;
  taxable_amount?: Maybe<Scalars['numeric']['output']>;
  unit_price?: Maybe<Scalars['numeric']['output']>;
  unit_price_excl_vat?: Maybe<Scalars['numeric']['output']>;
  vat_rate?: Maybe<Scalars['numeric']['output']>;
  vendor_error?: Maybe<Scalars['String']['output']>;
  vendor_sync_attempts?: Maybe<Scalars['Int']['output']>;
  vendor_synced_at?: Maybe<Scalars['timestamptz']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "invoiced_item" */
export type Invoiced_Item_Max_Order_By = {
  actual_amount?: InputMaybe<Order_By>;
  actual_qty?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  delivery_note_erp_code?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  discount_rate?: InputMaybe<Order_By>;
  dispensing_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  order_item_id?: InputMaybe<Order_By>;
  product_partner_localities_price_history_id?: InputMaybe<Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  taxable_amount?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  unit_price_excl_vat?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
  vendor_error?: InputMaybe<Order_By>;
  vendor_sync_attempts?: InputMaybe<Order_By>;
  vendor_synced_at?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Invoiced_Item_Min_Fields = {
  __typename?: 'invoiced_item_min_fields';
  actual_amount?: Maybe<Scalars['numeric']['output']>;
  actual_qty?: Maybe<Scalars['numeric']['output']>;
  amount?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  delivery_note_erp_code?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['numeric']['output']>;
  discount_amount?: Maybe<Scalars['numeric']['output']>;
  discount_rate?: Maybe<Scalars['numeric']['output']>;
  dispensing_date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  invoice_id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  order_item_id?: Maybe<Scalars['uuid']['output']>;
  product_partner_localities_price_history_id?: Maybe<Scalars['uuid']['output']>;
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
  qty?: Maybe<Scalars['numeric']['output']>;
  service_tax?: Maybe<Scalars['numeric']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  tax?: Maybe<Scalars['numeric']['output']>;
  taxable_amount?: Maybe<Scalars['numeric']['output']>;
  unit_price?: Maybe<Scalars['numeric']['output']>;
  unit_price_excl_vat?: Maybe<Scalars['numeric']['output']>;
  vat_rate?: Maybe<Scalars['numeric']['output']>;
  vendor_error?: Maybe<Scalars['String']['output']>;
  vendor_sync_attempts?: Maybe<Scalars['Int']['output']>;
  vendor_synced_at?: Maybe<Scalars['timestamptz']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "invoiced_item" */
export type Invoiced_Item_Min_Order_By = {
  actual_amount?: InputMaybe<Order_By>;
  actual_qty?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  delivery_note_erp_code?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  discount_rate?: InputMaybe<Order_By>;
  dispensing_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  order_item_id?: InputMaybe<Order_By>;
  product_partner_localities_price_history_id?: InputMaybe<Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  taxable_amount?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  unit_price_excl_vat?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
  vendor_error?: InputMaybe<Order_By>;
  vendor_sync_attempts?: InputMaybe<Order_By>;
  vendor_synced_at?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "invoiced_item" */
export type Invoiced_Item_Mutation_Response = {
  __typename?: 'invoiced_item_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Invoiced_Item>;
};

/** input type for inserting object relation for remote table "invoiced_item" */
export type Invoiced_Item_Obj_Rel_Insert_Input = {
  data: Invoiced_Item_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Invoiced_Item_On_Conflict>;
};

/** on_conflict condition type for table "invoiced_item" */
export type Invoiced_Item_On_Conflict = {
  constraint: Invoiced_Item_Constraint;
  update_columns?: Array<Invoiced_Item_Update_Column>;
  where?: InputMaybe<Invoiced_Item_Bool_Exp>;
};

/** Ordering options when selecting data from "invoiced_item". */
export type Invoiced_Item_Order_By = {
  actual_amount?: InputMaybe<Order_By>;
  actual_qty?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_asset?: InputMaybe<Customer_Asset_Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  customer_order_item?: InputMaybe<Customer_Order_Item_Order_By>;
  customer_order_item_state?: InputMaybe<Customer_Order_Item_State_Order_By>;
  delivery_note_erp_code?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  discountTypeByDiscountType?: InputMaybe<Discount_Type_Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  discount_rate?: InputMaybe<Order_By>;
  discount_type?: InputMaybe<Order_By>;
  dispensing_date?: InputMaybe<Order_By>;
  erp_sync_status?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice?: InputMaybe<Invoice_Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  invoiced_item_cancellation_tickets_aggregate?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Aggregate_Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  limit_purchase_order_logs_aggregate?: InputMaybe<Limit_Purchase_Order_Logs_Aggregate_Order_By>;
  lpo_existed_at_delivery?: InputMaybe<Order_By>;
  order_item_id?: InputMaybe<Order_By>;
  product_partner_localities_price_history?: InputMaybe<Product_Partner_Localities_Price_History_Order_By>;
  product_partner_localities_price_history_id?: InputMaybe<Order_By>;
  product_variation?: InputMaybe<Product_Variation_Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  taxable_amount?: InputMaybe<Order_By>;
  unit?: InputMaybe<Order_By>;
  unit_of_measure?: InputMaybe<Unit_Of_Measure_Order_By>;
  unit_price?: InputMaybe<Order_By>;
  unit_price_excl_vat?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
  vendorSyncStatusByErpSyncStatus?: InputMaybe<Vendor_Sync_Status_Order_By>;
  vendorSyncStatusByVendorSyncStatus?: InputMaybe<Vendor_Sync_Status_Order_By>;
  vendor_error?: InputMaybe<Order_By>;
  vendor_sync_attempts?: InputMaybe<Order_By>;
  vendor_sync_status?: InputMaybe<Order_By>;
  vendor_synced_at?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** primary key columns input for table: invoiced_item */
export type Invoiced_Item_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "invoiced_item" */
export enum Invoiced_Item_Select_Column {
  /** column name */
  ActualAmount = 'actual_amount',
  /** column name */
  ActualQty = 'actual_qty',
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerAssetId = 'customer_asset_id',
  /** column name */
  DeliveryNoteErpCode = 'delivery_note_erp_code',
  /** column name */
  Discount = 'discount',
  /** column name */
  DiscountAmount = 'discount_amount',
  /** column name */
  DiscountRate = 'discount_rate',
  /** column name */
  DiscountType = 'discount_type',
  /** column name */
  DispensingDate = 'dispensing_date',
  /** column name */
  ErpSyncStatus = 'erp_sync_status',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceId = 'invoice_id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrderItemId = 'order_item_id',
  /** column name */
  ProductPartnerLocalitiesPriceHistoryId = 'product_partner_localities_price_history_id',
  /** column name */
  ProductVariationId = 'product_variation_id',
  /** column name */
  Qty = 'qty',
  /** column name */
  ServiceTax = 'service_tax',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  State = 'state',
  /** column name */
  Tax = 'tax',
  /** column name */
  TaxableAmount = 'taxable_amount',
  /** column name */
  Unit = 'unit',
  /** column name */
  UnitPrice = 'unit_price',
  /** column name */
  UnitPriceExclVat = 'unit_price_excl_vat',
  /** column name */
  VatRate = 'vat_rate',
  /** column name */
  VendorError = 'vendor_error',
  /** column name */
  VendorSyncAttempts = 'vendor_sync_attempts',
  /** column name */
  VendorSyncStatus = 'vendor_sync_status',
  /** column name */
  VendorSyncedAt = 'vendor_synced_at',
  /** column name */
  Version = 'version'
}

/** select "invoiced_item_aggregate_bool_exp_bool_and_arguments_columns" columns of table "invoiced_item" */
export enum Invoiced_Item_Select_Column_Invoiced_Item_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "invoiced_item_aggregate_bool_exp_bool_or_arguments_columns" columns of table "invoiced_item" */
export enum Invoiced_Item_Select_Column_Invoiced_Item_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "invoiced_item" */
export type Invoiced_Item_Set_Input = {
  actual_amount?: InputMaybe<Scalars['numeric']['input']>;
  actual_qty?: InputMaybe<Scalars['numeric']['input']>;
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  delivery_note_erp_code?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['numeric']['input']>;
  discount_amount?: InputMaybe<Scalars['numeric']['input']>;
  discount_rate?: InputMaybe<Scalars['numeric']['input']>;
  discount_type?: InputMaybe<Discount_Type_Enum>;
  dispensing_date?: InputMaybe<Scalars['timestamptz']['input']>;
  erp_sync_status?: InputMaybe<Vendor_Sync_Status_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invoice_id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  product_partner_localities_price_history_id?: InputMaybe<Scalars['uuid']['input']>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  qty?: InputMaybe<Scalars['numeric']['input']>;
  service_tax?: InputMaybe<Scalars['numeric']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Customer_Order_Item_State_Enum>;
  tax?: InputMaybe<Scalars['numeric']['input']>;
  taxable_amount?: InputMaybe<Scalars['numeric']['input']>;
  unit?: InputMaybe<Unit_Of_Measure_Enum>;
  unit_price?: InputMaybe<Scalars['numeric']['input']>;
  unit_price_excl_vat?: InputMaybe<Scalars['numeric']['input']>;
  vat_rate?: InputMaybe<Scalars['numeric']['input']>;
  vendor_error?: InputMaybe<Scalars['String']['input']>;
  vendor_sync_attempts?: InputMaybe<Scalars['Int']['input']>;
  vendor_sync_status?: InputMaybe<Vendor_Sync_Status_Enum>;
  vendor_synced_at?: InputMaybe<Scalars['timestamptz']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Invoiced_Item_Stddev_Fields = {
  __typename?: 'invoiced_item_stddev_fields';
  actual_amount?: Maybe<Scalars['Float']['output']>;
  actual_qty?: Maybe<Scalars['Float']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  discount_rate?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  service_tax?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  taxable_amount?: Maybe<Scalars['Float']['output']>;
  unit_price?: Maybe<Scalars['Float']['output']>;
  unit_price_excl_vat?: Maybe<Scalars['Float']['output']>;
  vat_rate?: Maybe<Scalars['Float']['output']>;
  vendor_sync_attempts?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "invoiced_item" */
export type Invoiced_Item_Stddev_Order_By = {
  actual_amount?: InputMaybe<Order_By>;
  actual_qty?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  discount_rate?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  taxable_amount?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  unit_price_excl_vat?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
  vendor_sync_attempts?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Invoiced_Item_Stddev_Pop_Fields = {
  __typename?: 'invoiced_item_stddev_pop_fields';
  actual_amount?: Maybe<Scalars['Float']['output']>;
  actual_qty?: Maybe<Scalars['Float']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  discount_rate?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  service_tax?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  taxable_amount?: Maybe<Scalars['Float']['output']>;
  unit_price?: Maybe<Scalars['Float']['output']>;
  unit_price_excl_vat?: Maybe<Scalars['Float']['output']>;
  vat_rate?: Maybe<Scalars['Float']['output']>;
  vendor_sync_attempts?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "invoiced_item" */
export type Invoiced_Item_Stddev_Pop_Order_By = {
  actual_amount?: InputMaybe<Order_By>;
  actual_qty?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  discount_rate?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  taxable_amount?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  unit_price_excl_vat?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
  vendor_sync_attempts?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Invoiced_Item_Stddev_Samp_Fields = {
  __typename?: 'invoiced_item_stddev_samp_fields';
  actual_amount?: Maybe<Scalars['Float']['output']>;
  actual_qty?: Maybe<Scalars['Float']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  discount_rate?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  service_tax?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  taxable_amount?: Maybe<Scalars['Float']['output']>;
  unit_price?: Maybe<Scalars['Float']['output']>;
  unit_price_excl_vat?: Maybe<Scalars['Float']['output']>;
  vat_rate?: Maybe<Scalars['Float']['output']>;
  vendor_sync_attempts?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "invoiced_item" */
export type Invoiced_Item_Stddev_Samp_Order_By = {
  actual_amount?: InputMaybe<Order_By>;
  actual_qty?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  discount_rate?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  taxable_amount?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  unit_price_excl_vat?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
  vendor_sync_attempts?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "invoiced_item" */
export type Invoiced_Item_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Invoiced_Item_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Invoiced_Item_Stream_Cursor_Value_Input = {
  actual_amount?: InputMaybe<Scalars['numeric']['input']>;
  actual_qty?: InputMaybe<Scalars['numeric']['input']>;
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  delivery_note_erp_code?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['numeric']['input']>;
  discount_amount?: InputMaybe<Scalars['numeric']['input']>;
  discount_rate?: InputMaybe<Scalars['numeric']['input']>;
  discount_type?: InputMaybe<Discount_Type_Enum>;
  dispensing_date?: InputMaybe<Scalars['timestamptz']['input']>;
  erp_sync_status?: InputMaybe<Vendor_Sync_Status_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invoice_id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  product_partner_localities_price_history_id?: InputMaybe<Scalars['uuid']['input']>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  qty?: InputMaybe<Scalars['numeric']['input']>;
  service_tax?: InputMaybe<Scalars['numeric']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Customer_Order_Item_State_Enum>;
  tax?: InputMaybe<Scalars['numeric']['input']>;
  taxable_amount?: InputMaybe<Scalars['numeric']['input']>;
  unit?: InputMaybe<Unit_Of_Measure_Enum>;
  unit_price?: InputMaybe<Scalars['numeric']['input']>;
  unit_price_excl_vat?: InputMaybe<Scalars['numeric']['input']>;
  vat_rate?: InputMaybe<Scalars['numeric']['input']>;
  vendor_error?: InputMaybe<Scalars['String']['input']>;
  vendor_sync_attempts?: InputMaybe<Scalars['Int']['input']>;
  vendor_sync_status?: InputMaybe<Vendor_Sync_Status_Enum>;
  vendor_synced_at?: InputMaybe<Scalars['timestamptz']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Invoiced_Item_Sum_Fields = {
  __typename?: 'invoiced_item_sum_fields';
  actual_amount?: Maybe<Scalars['numeric']['output']>;
  actual_qty?: Maybe<Scalars['numeric']['output']>;
  amount?: Maybe<Scalars['numeric']['output']>;
  discount?: Maybe<Scalars['numeric']['output']>;
  discount_amount?: Maybe<Scalars['numeric']['output']>;
  discount_rate?: Maybe<Scalars['numeric']['output']>;
  qty?: Maybe<Scalars['numeric']['output']>;
  service_tax?: Maybe<Scalars['numeric']['output']>;
  tax?: Maybe<Scalars['numeric']['output']>;
  taxable_amount?: Maybe<Scalars['numeric']['output']>;
  unit_price?: Maybe<Scalars['numeric']['output']>;
  unit_price_excl_vat?: Maybe<Scalars['numeric']['output']>;
  vat_rate?: Maybe<Scalars['numeric']['output']>;
  vendor_sync_attempts?: Maybe<Scalars['Int']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "invoiced_item" */
export type Invoiced_Item_Sum_Order_By = {
  actual_amount?: InputMaybe<Order_By>;
  actual_qty?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  discount_rate?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  taxable_amount?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  unit_price_excl_vat?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
  vendor_sync_attempts?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** update columns of table "invoiced_item" */
export enum Invoiced_Item_Update_Column {
  /** column name */
  ActualAmount = 'actual_amount',
  /** column name */
  ActualQty = 'actual_qty',
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerAssetId = 'customer_asset_id',
  /** column name */
  DeliveryNoteErpCode = 'delivery_note_erp_code',
  /** column name */
  Discount = 'discount',
  /** column name */
  DiscountAmount = 'discount_amount',
  /** column name */
  DiscountRate = 'discount_rate',
  /** column name */
  DiscountType = 'discount_type',
  /** column name */
  DispensingDate = 'dispensing_date',
  /** column name */
  ErpSyncStatus = 'erp_sync_status',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceId = 'invoice_id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrderItemId = 'order_item_id',
  /** column name */
  ProductPartnerLocalitiesPriceHistoryId = 'product_partner_localities_price_history_id',
  /** column name */
  ProductVariationId = 'product_variation_id',
  /** column name */
  Qty = 'qty',
  /** column name */
  ServiceTax = 'service_tax',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  State = 'state',
  /** column name */
  Tax = 'tax',
  /** column name */
  TaxableAmount = 'taxable_amount',
  /** column name */
  Unit = 'unit',
  /** column name */
  UnitPrice = 'unit_price',
  /** column name */
  UnitPriceExclVat = 'unit_price_excl_vat',
  /** column name */
  VatRate = 'vat_rate',
  /** column name */
  VendorError = 'vendor_error',
  /** column name */
  VendorSyncAttempts = 'vendor_sync_attempts',
  /** column name */
  VendorSyncStatus = 'vendor_sync_status',
  /** column name */
  VendorSyncedAt = 'vendor_synced_at',
  /** column name */
  Version = 'version'
}

export type Invoiced_Item_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Invoiced_Item_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Invoiced_Item_Set_Input>;
  /** filter the rows which have to be updated */
  where: Invoiced_Item_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Invoiced_Item_Var_Pop_Fields = {
  __typename?: 'invoiced_item_var_pop_fields';
  actual_amount?: Maybe<Scalars['Float']['output']>;
  actual_qty?: Maybe<Scalars['Float']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  discount_rate?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  service_tax?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  taxable_amount?: Maybe<Scalars['Float']['output']>;
  unit_price?: Maybe<Scalars['Float']['output']>;
  unit_price_excl_vat?: Maybe<Scalars['Float']['output']>;
  vat_rate?: Maybe<Scalars['Float']['output']>;
  vendor_sync_attempts?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "invoiced_item" */
export type Invoiced_Item_Var_Pop_Order_By = {
  actual_amount?: InputMaybe<Order_By>;
  actual_qty?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  discount_rate?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  taxable_amount?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  unit_price_excl_vat?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
  vendor_sync_attempts?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Invoiced_Item_Var_Samp_Fields = {
  __typename?: 'invoiced_item_var_samp_fields';
  actual_amount?: Maybe<Scalars['Float']['output']>;
  actual_qty?: Maybe<Scalars['Float']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  discount_rate?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  service_tax?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  taxable_amount?: Maybe<Scalars['Float']['output']>;
  unit_price?: Maybe<Scalars['Float']['output']>;
  unit_price_excl_vat?: Maybe<Scalars['Float']['output']>;
  vat_rate?: Maybe<Scalars['Float']['output']>;
  vendor_sync_attempts?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "invoiced_item" */
export type Invoiced_Item_Var_Samp_Order_By = {
  actual_amount?: InputMaybe<Order_By>;
  actual_qty?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  discount_rate?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  taxable_amount?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  unit_price_excl_vat?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
  vendor_sync_attempts?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Invoiced_Item_Variance_Fields = {
  __typename?: 'invoiced_item_variance_fields';
  actual_amount?: Maybe<Scalars['Float']['output']>;
  actual_qty?: Maybe<Scalars['Float']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  discount_rate?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  service_tax?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  taxable_amount?: Maybe<Scalars['Float']['output']>;
  unit_price?: Maybe<Scalars['Float']['output']>;
  unit_price_excl_vat?: Maybe<Scalars['Float']['output']>;
  vat_rate?: Maybe<Scalars['Float']['output']>;
  vendor_sync_attempts?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "invoiced_item" */
export type Invoiced_Item_Variance_Order_By = {
  actual_amount?: InputMaybe<Order_By>;
  actual_qty?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  discount_rate?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  taxable_amount?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  unit_price_excl_vat?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
  vendor_sync_attempts?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

export type IsShiftScheduleExistInput = {
  end_time?: InputMaybe<Scalars['timestamp']['input']>;
  start_time?: InputMaybe<Scalars['timestamp']['input']>;
  vehicle_id: Scalars['uuid']['input'];
};

export type IsShiftScheduleExistOutput = {
  __typename?: 'isShiftScheduleExistOutput';
  driver_id?: Maybe<Scalars['uuid']['output']>;
  end_time?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  is_exit?: Maybe<Scalars['Boolean']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  middle_name?: Maybe<Scalars['String']['output']>;
  registration_number?: Maybe<Scalars['String']['output']>;
  shift_schedule_id?: Maybe<Scalars['uuid']['output']>;
  start_time?: Maybe<Scalars['String']['output']>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};

/** columns and relationships of "issue" */
export type Issue = {
  __typename?: 'issue';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description: Scalars['String']['output'];
  /** An array relationship */
  driver_vehicle_issues: Array<Driver_Vehicle_Issue>;
  /** An aggregate relationship */
  driver_vehicle_issues_aggregate: Driver_Vehicle_Issue_Aggregate;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name: Scalars['String']['output'];
  sequence?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "issue" */
export type IssueDriver_Vehicle_IssuesArgs = {
  distinct_on?: InputMaybe<Array<Driver_Vehicle_Issue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Vehicle_Issue_Order_By>>;
  where?: InputMaybe<Driver_Vehicle_Issue_Bool_Exp>;
};


/** columns and relationships of "issue" */
export type IssueDriver_Vehicle_Issues_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Driver_Vehicle_Issue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Vehicle_Issue_Order_By>>;
  where?: InputMaybe<Driver_Vehicle_Issue_Bool_Exp>;
};

/** aggregated selection of "issue" */
export type Issue_Aggregate = {
  __typename?: 'issue_aggregate';
  aggregate?: Maybe<Issue_Aggregate_Fields>;
  nodes: Array<Issue>;
};

/** aggregate fields of "issue" */
export type Issue_Aggregate_Fields = {
  __typename?: 'issue_aggregate_fields';
  avg?: Maybe<Issue_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Issue_Max_Fields>;
  min?: Maybe<Issue_Min_Fields>;
  stddev?: Maybe<Issue_Stddev_Fields>;
  stddev_pop?: Maybe<Issue_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Issue_Stddev_Samp_Fields>;
  sum?: Maybe<Issue_Sum_Fields>;
  var_pop?: Maybe<Issue_Var_Pop_Fields>;
  var_samp?: Maybe<Issue_Var_Samp_Fields>;
  variance?: Maybe<Issue_Variance_Fields>;
};


/** aggregate fields of "issue" */
export type Issue_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Issue_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Issue_Avg_Fields = {
  __typename?: 'issue_avg_fields';
  sequence?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "issue". All fields are combined with a logical 'AND'. */
export type Issue_Bool_Exp = {
  _and?: InputMaybe<Array<Issue_Bool_Exp>>;
  _not?: InputMaybe<Issue_Bool_Exp>;
  _or?: InputMaybe<Array<Issue_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  driver_vehicle_issues?: InputMaybe<Driver_Vehicle_Issue_Bool_Exp>;
  driver_vehicle_issues_aggregate?: InputMaybe<Driver_Vehicle_Issue_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  sequence?: InputMaybe<Int_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "issue" */
export enum Issue_Constraint {
  /** unique or primary key constraint on columns "id" */
  IssuePkey = 'issue_pkey'
}

/** input type for incrementing numeric columns in table "issue" */
export type Issue_Inc_Input = {
  sequence?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "issue" */
export type Issue_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  driver_vehicle_issues?: InputMaybe<Driver_Vehicle_Issue_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Issue_Max_Fields = {
  __typename?: 'issue_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sequence?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Issue_Min_Fields = {
  __typename?: 'issue_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sequence?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "issue" */
export type Issue_Mutation_Response = {
  __typename?: 'issue_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Issue>;
};

/** input type for inserting object relation for remote table "issue" */
export type Issue_Obj_Rel_Insert_Input = {
  data: Issue_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Issue_On_Conflict>;
};

/** on_conflict condition type for table "issue" */
export type Issue_On_Conflict = {
  constraint: Issue_Constraint;
  update_columns?: Array<Issue_Update_Column>;
  where?: InputMaybe<Issue_Bool_Exp>;
};

/** Ordering options when selecting data from "issue". */
export type Issue_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  driver_vehicle_issues_aggregate?: InputMaybe<Driver_Vehicle_Issue_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
};

/** primary key columns input for table: issue */
export type Issue_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "issue" */
export enum Issue_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  Sequence = 'sequence',
  /** column name */
  Slug = 'slug'
}

/** input type for updating data in table "issue" */
export type Issue_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Issue_Stddev_Fields = {
  __typename?: 'issue_stddev_fields';
  sequence?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Issue_Stddev_Pop_Fields = {
  __typename?: 'issue_stddev_pop_fields';
  sequence?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Issue_Stddev_Samp_Fields = {
  __typename?: 'issue_stddev_samp_fields';
  sequence?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "issue" */
export type Issue_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Issue_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Issue_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Issue_Sum_Fields = {
  __typename?: 'issue_sum_fields';
  sequence?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "issue" */
export enum Issue_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  Sequence = 'sequence',
  /** column name */
  Slug = 'slug'
}

export type Issue_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Issue_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Issue_Set_Input>;
  /** filter the rows which have to be updated */
  where: Issue_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Issue_Var_Pop_Fields = {
  __typename?: 'issue_var_pop_fields';
  sequence?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Issue_Var_Samp_Fields = {
  __typename?: 'issue_var_samp_fields';
  sequence?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Issue_Variance_Fields = {
  __typename?: 'issue_variance_fields';
  sequence?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "job_state" */
export type Job_State = {
  __typename?: 'job_state';
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  jobs: Array<Jobs>;
  /** An aggregate relationship */
  jobs_aggregate: Jobs_Aggregate;
  /** An array relationship */
  jobs_state_flows: Array<Jobs_State_Flow>;
  /** An aggregate relationship */
  jobs_state_flows_aggregate: Jobs_State_Flow_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "job_state" */
export type Job_StateJobsArgs = {
  distinct_on?: InputMaybe<Array<Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Jobs_Order_By>>;
  where?: InputMaybe<Jobs_Bool_Exp>;
};


/** columns and relationships of "job_state" */
export type Job_StateJobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Jobs_Order_By>>;
  where?: InputMaybe<Jobs_Bool_Exp>;
};


/** columns and relationships of "job_state" */
export type Job_StateJobs_State_FlowsArgs = {
  distinct_on?: InputMaybe<Array<Jobs_State_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Jobs_State_Flow_Order_By>>;
  where?: InputMaybe<Jobs_State_Flow_Bool_Exp>;
};


/** columns and relationships of "job_state" */
export type Job_StateJobs_State_Flows_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Jobs_State_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Jobs_State_Flow_Order_By>>;
  where?: InputMaybe<Jobs_State_Flow_Bool_Exp>;
};

/** aggregated selection of "job_state" */
export type Job_State_Aggregate = {
  __typename?: 'job_state_aggregate';
  aggregate?: Maybe<Job_State_Aggregate_Fields>;
  nodes: Array<Job_State>;
};

/** aggregate fields of "job_state" */
export type Job_State_Aggregate_Fields = {
  __typename?: 'job_state_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Job_State_Max_Fields>;
  min?: Maybe<Job_State_Min_Fields>;
};


/** aggregate fields of "job_state" */
export type Job_State_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Job_State_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "job_state". All fields are combined with a logical 'AND'. */
export type Job_State_Bool_Exp = {
  _and?: InputMaybe<Array<Job_State_Bool_Exp>>;
  _not?: InputMaybe<Job_State_Bool_Exp>;
  _or?: InputMaybe<Array<Job_State_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  jobs?: InputMaybe<Jobs_Bool_Exp>;
  jobs_aggregate?: InputMaybe<Jobs_Aggregate_Bool_Exp>;
  jobs_state_flows?: InputMaybe<Jobs_State_Flow_Bool_Exp>;
  jobs_state_flows_aggregate?: InputMaybe<Jobs_State_Flow_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "job_state" */
export enum Job_State_Constraint {
  /** unique or primary key constraint on columns "value" */
  JobStatePkey = 'job_state_pkey'
}

export enum Job_State_Enum {
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** PENDING */
  Pending = 'PENDING',
  /** PROCESSING */
  Processing = 'PROCESSING',
  /** START */
  Start = 'START'
}

/** Boolean expression to compare columns of type "job_state_enum". All fields are combined with logical 'AND'. */
export type Job_State_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Job_State_Enum>;
  _in?: InputMaybe<Array<Job_State_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Job_State_Enum>;
  _nin?: InputMaybe<Array<Job_State_Enum>>;
};

/** input type for inserting data into table "job_state" */
export type Job_State_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  jobs?: InputMaybe<Jobs_Arr_Rel_Insert_Input>;
  jobs_state_flows?: InputMaybe<Jobs_State_Flow_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Job_State_Max_Fields = {
  __typename?: 'job_state_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Job_State_Min_Fields = {
  __typename?: 'job_state_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "job_state" */
export type Job_State_Mutation_Response = {
  __typename?: 'job_state_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Job_State>;
};

/** input type for inserting object relation for remote table "job_state" */
export type Job_State_Obj_Rel_Insert_Input = {
  data: Job_State_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Job_State_On_Conflict>;
};

/** on_conflict condition type for table "job_state" */
export type Job_State_On_Conflict = {
  constraint: Job_State_Constraint;
  update_columns?: Array<Job_State_Update_Column>;
  where?: InputMaybe<Job_State_Bool_Exp>;
};

/** Ordering options when selecting data from "job_state". */
export type Job_State_Order_By = {
  comment?: InputMaybe<Order_By>;
  jobs_aggregate?: InputMaybe<Jobs_Aggregate_Order_By>;
  jobs_state_flows_aggregate?: InputMaybe<Jobs_State_Flow_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: job_state */
export type Job_State_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "job_state" */
export enum Job_State_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "job_state" */
export type Job_State_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "job_state" */
export type Job_State_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Job_State_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Job_State_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "job_state" */
export enum Job_State_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Job_State_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Job_State_Set_Input>;
  /** filter the rows which have to be updated */
  where: Job_State_Bool_Exp;
};

/** columns and relationships of "job_type" */
export type Job_Type = {
  __typename?: 'job_type';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  /** An array relationship */
  jobs: Array<Jobs>;
  /** An aggregate relationship */
  jobs_aggregate: Jobs_Aggregate;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "job_type" */
export type Job_TypeJobsArgs = {
  distinct_on?: InputMaybe<Array<Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Jobs_Order_By>>;
  where?: InputMaybe<Jobs_Bool_Exp>;
};


/** columns and relationships of "job_type" */
export type Job_TypeJobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Jobs_Order_By>>;
  where?: InputMaybe<Jobs_Bool_Exp>;
};

/** aggregated selection of "job_type" */
export type Job_Type_Aggregate = {
  __typename?: 'job_type_aggregate';
  aggregate?: Maybe<Job_Type_Aggregate_Fields>;
  nodes: Array<Job_Type>;
};

/** aggregate fields of "job_type" */
export type Job_Type_Aggregate_Fields = {
  __typename?: 'job_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Job_Type_Max_Fields>;
  min?: Maybe<Job_Type_Min_Fields>;
};


/** aggregate fields of "job_type" */
export type Job_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Job_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "job_type". All fields are combined with a logical 'AND'. */
export type Job_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Job_Type_Bool_Exp>>;
  _not?: InputMaybe<Job_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Job_Type_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  jobs?: InputMaybe<Jobs_Bool_Exp>;
  jobs_aggregate?: InputMaybe<Jobs_Aggregate_Bool_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  sku?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "job_type" */
export enum Job_Type_Constraint {
  /** unique or primary key constraint on columns "id" */
  JobTypePkey = 'job_type_pkey'
}

/** input type for inserting data into table "job_type" */
export type Job_Type_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  jobs?: InputMaybe<Jobs_Arr_Rel_Insert_Input>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Job_Type_Max_Fields = {
  __typename?: 'job_type_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Job_Type_Min_Fields = {
  __typename?: 'job_type_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "job_type" */
export type Job_Type_Mutation_Response = {
  __typename?: 'job_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Job_Type>;
};

/** input type for inserting object relation for remote table "job_type" */
export type Job_Type_Obj_Rel_Insert_Input = {
  data: Job_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Job_Type_On_Conflict>;
};

/** on_conflict condition type for table "job_type" */
export type Job_Type_On_Conflict = {
  constraint: Job_Type_Constraint;
  update_columns?: Array<Job_Type_Update_Column>;
  where?: InputMaybe<Job_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "job_type". */
export type Job_Type_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  jobs_aggregate?: InputMaybe<Jobs_Aggregate_Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  sku?: InputMaybe<Order_By>;
};

/** primary key columns input for table: job_type */
export type Job_Type_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "job_type" */
export enum Job_Type_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  Sku = 'sku'
}

/** input type for updating data in table "job_type" */
export type Job_Type_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "job_type" */
export type Job_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Job_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Job_Type_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "job_type_template" */
export type Job_Type_Template = {
  __typename?: 'job_type_template';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  tasks: Array<Task>;
  /** An aggregate relationship */
  tasks_aggregate: Task_Aggregate;
  template?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "job_type_template" */
export type Job_Type_TemplateTasksArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


/** columns and relationships of "job_type_template" */
export type Job_Type_TemplateTasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};

/** aggregated selection of "job_type_template" */
export type Job_Type_Template_Aggregate = {
  __typename?: 'job_type_template_aggregate';
  aggregate?: Maybe<Job_Type_Template_Aggregate_Fields>;
  nodes: Array<Job_Type_Template>;
};

/** aggregate fields of "job_type_template" */
export type Job_Type_Template_Aggregate_Fields = {
  __typename?: 'job_type_template_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Job_Type_Template_Max_Fields>;
  min?: Maybe<Job_Type_Template_Min_Fields>;
};


/** aggregate fields of "job_type_template" */
export type Job_Type_Template_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Job_Type_Template_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "job_type_template". All fields are combined with a logical 'AND'. */
export type Job_Type_Template_Bool_Exp = {
  _and?: InputMaybe<Array<Job_Type_Template_Bool_Exp>>;
  _not?: InputMaybe<Job_Type_Template_Bool_Exp>;
  _or?: InputMaybe<Array<Job_Type_Template_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  tasks?: InputMaybe<Task_Bool_Exp>;
  tasks_aggregate?: InputMaybe<Task_Aggregate_Bool_Exp>;
  template?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "job_type_template" */
export enum Job_Type_Template_Constraint {
  /** unique or primary key constraint on columns "id" */
  JobTypeTemplatePkey = 'job_type_template_pkey'
}

/** input type for inserting data into table "job_type_template" */
export type Job_Type_Template_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tasks?: InputMaybe<Task_Arr_Rel_Insert_Input>;
  template?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Job_Type_Template_Max_Fields = {
  __typename?: 'job_type_template_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  template?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Job_Type_Template_Min_Fields = {
  __typename?: 'job_type_template_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  template?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "job_type_template" */
export type Job_Type_Template_Mutation_Response = {
  __typename?: 'job_type_template_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Job_Type_Template>;
};

/** input type for inserting object relation for remote table "job_type_template" */
export type Job_Type_Template_Obj_Rel_Insert_Input = {
  data: Job_Type_Template_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Job_Type_Template_On_Conflict>;
};

/** on_conflict condition type for table "job_type_template" */
export type Job_Type_Template_On_Conflict = {
  constraint: Job_Type_Template_Constraint;
  update_columns?: Array<Job_Type_Template_Update_Column>;
  where?: InputMaybe<Job_Type_Template_Bool_Exp>;
};

/** Ordering options when selecting data from "job_type_template". */
export type Job_Type_Template_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  tasks_aggregate?: InputMaybe<Task_Aggregate_Order_By>;
  template?: InputMaybe<Order_By>;
};

/** primary key columns input for table: job_type_template */
export type Job_Type_Template_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "job_type_template" */
export enum Job_Type_Template_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  Template = 'template'
}

/** input type for updating data in table "job_type_template" */
export type Job_Type_Template_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  template?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "job_type_template" */
export type Job_Type_Template_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Job_Type_Template_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Job_Type_Template_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  template?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "job_type_template" */
export enum Job_Type_Template_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  Template = 'template'
}

export type Job_Type_Template_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Job_Type_Template_Set_Input>;
  /** filter the rows which have to be updated */
  where: Job_Type_Template_Bool_Exp;
};

/** update columns of table "job_type" */
export enum Job_Type_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  Sku = 'sku'
}

export type Job_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Job_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Job_Type_Bool_Exp;
};

/** columns and relationships of "jobs" */
export type Jobs = {
  __typename?: 'jobs';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  /** An object relationship */
  jobTypeByJobType?: Maybe<Job_Type>;
  /** An object relationship */
  job_state?: Maybe<Job_State>;
  job_type?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  jobs_state_flows: Array<Jobs_State_Flow>;
  /** An aggregate relationship */
  jobs_state_flows_aggregate: Jobs_State_Flow_Aggregate;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  state?: Maybe<Job_State_Enum>;
  /** An array relationship */
  tasks: Array<Task>;
  /** An aggregate relationship */
  tasks_aggregate: Task_Aggregate;
};


/** columns and relationships of "jobs" */
export type JobsJobs_State_FlowsArgs = {
  distinct_on?: InputMaybe<Array<Jobs_State_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Jobs_State_Flow_Order_By>>;
  where?: InputMaybe<Jobs_State_Flow_Bool_Exp>;
};


/** columns and relationships of "jobs" */
export type JobsJobs_State_Flows_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Jobs_State_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Jobs_State_Flow_Order_By>>;
  where?: InputMaybe<Jobs_State_Flow_Bool_Exp>;
};


/** columns and relationships of "jobs" */
export type JobsTasksArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


/** columns and relationships of "jobs" */
export type JobsTasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};

/** aggregated selection of "jobs" */
export type Jobs_Aggregate = {
  __typename?: 'jobs_aggregate';
  aggregate?: Maybe<Jobs_Aggregate_Fields>;
  nodes: Array<Jobs>;
};

export type Jobs_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Jobs_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Jobs_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Jobs_Aggregate_Bool_Exp_Count>;
};

export type Jobs_Aggregate_Bool_Exp_Bool_And = {
  arguments: Jobs_Select_Column_Jobs_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Jobs_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Jobs_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Jobs_Select_Column_Jobs_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Jobs_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Jobs_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Jobs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Jobs_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "jobs" */
export type Jobs_Aggregate_Fields = {
  __typename?: 'jobs_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Jobs_Max_Fields>;
  min?: Maybe<Jobs_Min_Fields>;
};


/** aggregate fields of "jobs" */
export type Jobs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Jobs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "jobs" */
export type Jobs_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Jobs_Max_Order_By>;
  min?: InputMaybe<Jobs_Min_Order_By>;
};

/** input type for inserting array relation for remote table "jobs" */
export type Jobs_Arr_Rel_Insert_Input = {
  data: Array<Jobs_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Jobs_On_Conflict>;
};

/** Boolean expression to filter rows from the table "jobs". All fields are combined with a logical 'AND'. */
export type Jobs_Bool_Exp = {
  _and?: InputMaybe<Array<Jobs_Bool_Exp>>;
  _not?: InputMaybe<Jobs_Bool_Exp>;
  _or?: InputMaybe<Array<Jobs_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  jobTypeByJobType?: InputMaybe<Job_Type_Bool_Exp>;
  job_state?: InputMaybe<Job_State_Bool_Exp>;
  job_type?: InputMaybe<Uuid_Comparison_Exp>;
  jobs_state_flows?: InputMaybe<Jobs_State_Flow_Bool_Exp>;
  jobs_state_flows_aggregate?: InputMaybe<Jobs_State_Flow_Aggregate_Bool_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  state?: InputMaybe<Job_State_Enum_Comparison_Exp>;
  tasks?: InputMaybe<Task_Bool_Exp>;
  tasks_aggregate?: InputMaybe<Task_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "jobs" */
export enum Jobs_Constraint {
  /** unique or primary key constraint on columns "id" */
  JobsPkey = 'jobs_pkey'
}

/** input type for inserting data into table "jobs" */
export type Jobs_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  jobTypeByJobType?: InputMaybe<Job_Type_Obj_Rel_Insert_Input>;
  job_state?: InputMaybe<Job_State_Obj_Rel_Insert_Input>;
  job_type?: InputMaybe<Scalars['uuid']['input']>;
  jobs_state_flows?: InputMaybe<Jobs_State_Flow_Arr_Rel_Insert_Input>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Job_State_Enum>;
  tasks?: InputMaybe<Task_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Jobs_Max_Fields = {
  __typename?: 'jobs_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  job_type?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "jobs" */
export type Jobs_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  job_type?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Jobs_Min_Fields = {
  __typename?: 'jobs_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  job_type?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "jobs" */
export type Jobs_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  job_type?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "jobs" */
export type Jobs_Mutation_Response = {
  __typename?: 'jobs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Jobs>;
};

/** input type for inserting object relation for remote table "jobs" */
export type Jobs_Obj_Rel_Insert_Input = {
  data: Jobs_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Jobs_On_Conflict>;
};

/** on_conflict condition type for table "jobs" */
export type Jobs_On_Conflict = {
  constraint: Jobs_Constraint;
  update_columns?: Array<Jobs_Update_Column>;
  where?: InputMaybe<Jobs_Bool_Exp>;
};

/** Ordering options when selecting data from "jobs". */
export type Jobs_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  jobTypeByJobType?: InputMaybe<Job_Type_Order_By>;
  job_state?: InputMaybe<Job_State_Order_By>;
  job_type?: InputMaybe<Order_By>;
  jobs_state_flows_aggregate?: InputMaybe<Jobs_State_Flow_Aggregate_Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  tasks_aggregate?: InputMaybe<Task_Aggregate_Order_By>;
};

/** primary key columns input for table: jobs */
export type Jobs_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "jobs" */
export enum Jobs_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  JobType = 'job_type',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  State = 'state'
}

/** select "jobs_aggregate_bool_exp_bool_and_arguments_columns" columns of table "jobs" */
export enum Jobs_Select_Column_Jobs_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "jobs_aggregate_bool_exp_bool_or_arguments_columns" columns of table "jobs" */
export enum Jobs_Select_Column_Jobs_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "jobs" */
export type Jobs_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  job_type?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Job_State_Enum>;
};

/** columns and relationships of "jobs_state_flow" */
export type Jobs_State_Flow = {
  __typename?: 'jobs_state_flow';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  /** An object relationship */
  job: Jobs;
  job_id: Scalars['uuid']['output'];
  /** An object relationship */
  job_state: Job_State;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  state: Job_State_Enum;
};

/** aggregated selection of "jobs_state_flow" */
export type Jobs_State_Flow_Aggregate = {
  __typename?: 'jobs_state_flow_aggregate';
  aggregate?: Maybe<Jobs_State_Flow_Aggregate_Fields>;
  nodes: Array<Jobs_State_Flow>;
};

export type Jobs_State_Flow_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Jobs_State_Flow_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Jobs_State_Flow_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Jobs_State_Flow_Aggregate_Bool_Exp_Count>;
};

export type Jobs_State_Flow_Aggregate_Bool_Exp_Bool_And = {
  arguments: Jobs_State_Flow_Select_Column_Jobs_State_Flow_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Jobs_State_Flow_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Jobs_State_Flow_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Jobs_State_Flow_Select_Column_Jobs_State_Flow_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Jobs_State_Flow_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Jobs_State_Flow_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Jobs_State_Flow_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Jobs_State_Flow_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "jobs_state_flow" */
export type Jobs_State_Flow_Aggregate_Fields = {
  __typename?: 'jobs_state_flow_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Jobs_State_Flow_Max_Fields>;
  min?: Maybe<Jobs_State_Flow_Min_Fields>;
};


/** aggregate fields of "jobs_state_flow" */
export type Jobs_State_Flow_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Jobs_State_Flow_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "jobs_state_flow" */
export type Jobs_State_Flow_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Jobs_State_Flow_Max_Order_By>;
  min?: InputMaybe<Jobs_State_Flow_Min_Order_By>;
};

/** input type for inserting array relation for remote table "jobs_state_flow" */
export type Jobs_State_Flow_Arr_Rel_Insert_Input = {
  data: Array<Jobs_State_Flow_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Jobs_State_Flow_On_Conflict>;
};

/** Boolean expression to filter rows from the table "jobs_state_flow". All fields are combined with a logical 'AND'. */
export type Jobs_State_Flow_Bool_Exp = {
  _and?: InputMaybe<Array<Jobs_State_Flow_Bool_Exp>>;
  _not?: InputMaybe<Jobs_State_Flow_Bool_Exp>;
  _or?: InputMaybe<Array<Jobs_State_Flow_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  job?: InputMaybe<Jobs_Bool_Exp>;
  job_id?: InputMaybe<Uuid_Comparison_Exp>;
  job_state?: InputMaybe<Job_State_Bool_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  state?: InputMaybe<Job_State_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "jobs_state_flow" */
export enum Jobs_State_Flow_Constraint {
  /** unique or primary key constraint on columns "id" */
  JobsStateFlowPkey = 'jobs_state_flow_pkey'
}

/** input type for inserting data into table "jobs_state_flow" */
export type Jobs_State_Flow_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  job?: InputMaybe<Jobs_Obj_Rel_Insert_Input>;
  job_id?: InputMaybe<Scalars['uuid']['input']>;
  job_state?: InputMaybe<Job_State_Obj_Rel_Insert_Input>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Job_State_Enum>;
};

/** aggregate max on columns */
export type Jobs_State_Flow_Max_Fields = {
  __typename?: 'jobs_state_flow_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  job_id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "jobs_state_flow" */
export type Jobs_State_Flow_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  job_id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Jobs_State_Flow_Min_Fields = {
  __typename?: 'jobs_state_flow_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  job_id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "jobs_state_flow" */
export type Jobs_State_Flow_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  job_id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "jobs_state_flow" */
export type Jobs_State_Flow_Mutation_Response = {
  __typename?: 'jobs_state_flow_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Jobs_State_Flow>;
};

/** on_conflict condition type for table "jobs_state_flow" */
export type Jobs_State_Flow_On_Conflict = {
  constraint: Jobs_State_Flow_Constraint;
  update_columns?: Array<Jobs_State_Flow_Update_Column>;
  where?: InputMaybe<Jobs_State_Flow_Bool_Exp>;
};

/** Ordering options when selecting data from "jobs_state_flow". */
export type Jobs_State_Flow_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  job?: InputMaybe<Jobs_Order_By>;
  job_id?: InputMaybe<Order_By>;
  job_state?: InputMaybe<Job_State_Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
};

/** primary key columns input for table: jobs_state_flow */
export type Jobs_State_Flow_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "jobs_state_flow" */
export enum Jobs_State_Flow_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  JobId = 'job_id',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  State = 'state'
}

/** select "jobs_state_flow_aggregate_bool_exp_bool_and_arguments_columns" columns of table "jobs_state_flow" */
export enum Jobs_State_Flow_Select_Column_Jobs_State_Flow_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "jobs_state_flow_aggregate_bool_exp_bool_or_arguments_columns" columns of table "jobs_state_flow" */
export enum Jobs_State_Flow_Select_Column_Jobs_State_Flow_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "jobs_state_flow" */
export type Jobs_State_Flow_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  job_id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Job_State_Enum>;
};

/** Streaming cursor of the table "jobs_state_flow" */
export type Jobs_State_Flow_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Jobs_State_Flow_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Jobs_State_Flow_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  job_id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Job_State_Enum>;
};

/** update columns of table "jobs_state_flow" */
export enum Jobs_State_Flow_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  JobId = 'job_id',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  State = 'state'
}

export type Jobs_State_Flow_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Jobs_State_Flow_Set_Input>;
  /** filter the rows which have to be updated */
  where: Jobs_State_Flow_Bool_Exp;
};

/** Streaming cursor of the table "jobs" */
export type Jobs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Jobs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Jobs_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  job_type?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Job_State_Enum>;
};

/** update columns of table "jobs" */
export enum Jobs_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  JobType = 'job_type',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  State = 'state'
}

export type Jobs_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Jobs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Jobs_Bool_Exp;
};

/** Boolean expression to compare columns of type "json". All fields are combined with logical 'AND'. */
export type Json_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['json']['input']>;
  _gt?: InputMaybe<Scalars['json']['input']>;
  _gte?: InputMaybe<Scalars['json']['input']>;
  _in?: InputMaybe<Array<Scalars['json']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['json']['input']>;
  _lte?: InputMaybe<Scalars['json']['input']>;
  _neq?: InputMaybe<Scalars['json']['input']>;
  _nin?: InputMaybe<Array<Scalars['json']['input']>>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** columns and relationships of "limit_purchase_order" */
export type Limit_Purchase_Order = {
  __typename?: 'limit_purchase_order';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  limit_purchase_order_logs: Array<Limit_Purchase_Order_Logs>;
  /** An aggregate relationship */
  limit_purchase_order_logs_aggregate: Limit_Purchase_Order_Logs_Aggregate;
  /** An array relationship */
  lpo_exceptions: Array<Lpo_Exception>;
  /** An aggregate relationship */
  lpo_exceptions_aggregate: Lpo_Exception_Aggregate;
  notes?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organization: Organization;
  /** An object relationship */
  organization_address?: Maybe<Organization_Address>;
  organization_address_id?: Maybe<Scalars['uuid']['output']>;
  organization_id: Scalars['uuid']['output'];
  quantity: Scalars['numeric']['output'];
};


/** columns and relationships of "limit_purchase_order" */
export type Limit_Purchase_OrderLimit_Purchase_Order_LogsArgs = {
  distinct_on?: InputMaybe<Array<Limit_Purchase_Order_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Limit_Purchase_Order_Logs_Order_By>>;
  where?: InputMaybe<Limit_Purchase_Order_Logs_Bool_Exp>;
};


/** columns and relationships of "limit_purchase_order" */
export type Limit_Purchase_OrderLimit_Purchase_Order_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Limit_Purchase_Order_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Limit_Purchase_Order_Logs_Order_By>>;
  where?: InputMaybe<Limit_Purchase_Order_Logs_Bool_Exp>;
};


/** columns and relationships of "limit_purchase_order" */
export type Limit_Purchase_OrderLpo_ExceptionsArgs = {
  distinct_on?: InputMaybe<Array<Lpo_Exception_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lpo_Exception_Order_By>>;
  where?: InputMaybe<Lpo_Exception_Bool_Exp>;
};


/** columns and relationships of "limit_purchase_order" */
export type Limit_Purchase_OrderLpo_Exceptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lpo_Exception_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lpo_Exception_Order_By>>;
  where?: InputMaybe<Lpo_Exception_Bool_Exp>;
};

/** aggregated selection of "limit_purchase_order" */
export type Limit_Purchase_Order_Aggregate = {
  __typename?: 'limit_purchase_order_aggregate';
  aggregate?: Maybe<Limit_Purchase_Order_Aggregate_Fields>;
  nodes: Array<Limit_Purchase_Order>;
};

export type Limit_Purchase_Order_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Limit_Purchase_Order_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Limit_Purchase_Order_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Limit_Purchase_Order_Aggregate_Bool_Exp_Count>;
};

export type Limit_Purchase_Order_Aggregate_Bool_Exp_Bool_And = {
  arguments: Limit_Purchase_Order_Select_Column_Limit_Purchase_Order_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Limit_Purchase_Order_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Limit_Purchase_Order_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Limit_Purchase_Order_Select_Column_Limit_Purchase_Order_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Limit_Purchase_Order_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Limit_Purchase_Order_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Limit_Purchase_Order_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Limit_Purchase_Order_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "limit_purchase_order" */
export type Limit_Purchase_Order_Aggregate_Fields = {
  __typename?: 'limit_purchase_order_aggregate_fields';
  avg?: Maybe<Limit_Purchase_Order_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Limit_Purchase_Order_Max_Fields>;
  min?: Maybe<Limit_Purchase_Order_Min_Fields>;
  stddev?: Maybe<Limit_Purchase_Order_Stddev_Fields>;
  stddev_pop?: Maybe<Limit_Purchase_Order_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Limit_Purchase_Order_Stddev_Samp_Fields>;
  sum?: Maybe<Limit_Purchase_Order_Sum_Fields>;
  var_pop?: Maybe<Limit_Purchase_Order_Var_Pop_Fields>;
  var_samp?: Maybe<Limit_Purchase_Order_Var_Samp_Fields>;
  variance?: Maybe<Limit_Purchase_Order_Variance_Fields>;
};


/** aggregate fields of "limit_purchase_order" */
export type Limit_Purchase_Order_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Limit_Purchase_Order_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "limit_purchase_order" */
export type Limit_Purchase_Order_Aggregate_Order_By = {
  avg?: InputMaybe<Limit_Purchase_Order_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Limit_Purchase_Order_Max_Order_By>;
  min?: InputMaybe<Limit_Purchase_Order_Min_Order_By>;
  stddev?: InputMaybe<Limit_Purchase_Order_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Limit_Purchase_Order_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Limit_Purchase_Order_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Limit_Purchase_Order_Sum_Order_By>;
  var_pop?: InputMaybe<Limit_Purchase_Order_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Limit_Purchase_Order_Var_Samp_Order_By>;
  variance?: InputMaybe<Limit_Purchase_Order_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "limit_purchase_order" */
export type Limit_Purchase_Order_Arr_Rel_Insert_Input = {
  data: Array<Limit_Purchase_Order_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Limit_Purchase_Order_On_Conflict>;
};

/** aggregate avg on columns */
export type Limit_Purchase_Order_Avg_Fields = {
  __typename?: 'limit_purchase_order_avg_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "limit_purchase_order" */
export type Limit_Purchase_Order_Avg_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "limit_purchase_order". All fields are combined with a logical 'AND'. */
export type Limit_Purchase_Order_Bool_Exp = {
  _and?: InputMaybe<Array<Limit_Purchase_Order_Bool_Exp>>;
  _not?: InputMaybe<Limit_Purchase_Order_Bool_Exp>;
  _or?: InputMaybe<Array<Limit_Purchase_Order_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  limit_purchase_order_logs?: InputMaybe<Limit_Purchase_Order_Logs_Bool_Exp>;
  limit_purchase_order_logs_aggregate?: InputMaybe<Limit_Purchase_Order_Logs_Aggregate_Bool_Exp>;
  lpo_exceptions?: InputMaybe<Lpo_Exception_Bool_Exp>;
  lpo_exceptions_aggregate?: InputMaybe<Lpo_Exception_Aggregate_Bool_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organization_address?: InputMaybe<Organization_Address_Bool_Exp>;
  organization_address_id?: InputMaybe<Uuid_Comparison_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  quantity?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "limit_purchase_order" */
export enum Limit_Purchase_Order_Constraint {
  /** unique or primary key constraint on columns "organization_id" */
  LimitPurchaseOrderOrgAddressActiveUnique = 'limit_purchase_order_org_address_active_unique',
  /** unique or primary key constraint on columns "id" */
  LimitPurchaseOrderPkey = 'limit_purchase_order_pkey'
}

/** input type for incrementing numeric columns in table "limit_purchase_order" */
export type Limit_Purchase_Order_Inc_Input = {
  quantity?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "limit_purchase_order" */
export type Limit_Purchase_Order_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  limit_purchase_order_logs?: InputMaybe<Limit_Purchase_Order_Logs_Arr_Rel_Insert_Input>;
  lpo_exceptions?: InputMaybe<Lpo_Exception_Arr_Rel_Insert_Input>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organization_address?: InputMaybe<Organization_Address_Obj_Rel_Insert_Input>;
  organization_address_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
};

/** columns and relationships of "limit_purchase_order_logs" */
export type Limit_Purchase_Order_Logs = {
  __typename?: 'limit_purchase_order_logs';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  current_quantity?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  invoiced_item?: Maybe<Invoiced_Item>;
  invoiced_item_id?: Maybe<Scalars['uuid']['output']>;
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  limit_purchase_order?: Maybe<Limit_Purchase_Order>;
  limit_purchase_order_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  lpo_exception?: Maybe<Lpo_Exception>;
  lpo_exception_id?: Maybe<Scalars['uuid']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['numeric']['output'];
  /** An object relationship */
  transactionTypeByTransactionType?: Maybe<Transaction_Type>;
  transaction_reference?: Maybe<Scalars['uuid']['output']>;
  transaction_type?: Maybe<Scalars['String']['output']>;
  unit_price?: Maybe<Scalars['numeric']['output']>;
};

/** aggregated selection of "limit_purchase_order_logs" */
export type Limit_Purchase_Order_Logs_Aggregate = {
  __typename?: 'limit_purchase_order_logs_aggregate';
  aggregate?: Maybe<Limit_Purchase_Order_Logs_Aggregate_Fields>;
  nodes: Array<Limit_Purchase_Order_Logs>;
};

export type Limit_Purchase_Order_Logs_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Limit_Purchase_Order_Logs_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Limit_Purchase_Order_Logs_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Limit_Purchase_Order_Logs_Aggregate_Bool_Exp_Count>;
};

export type Limit_Purchase_Order_Logs_Aggregate_Bool_Exp_Bool_And = {
  arguments: Limit_Purchase_Order_Logs_Select_Column_Limit_Purchase_Order_Logs_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Limit_Purchase_Order_Logs_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Limit_Purchase_Order_Logs_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Limit_Purchase_Order_Logs_Select_Column_Limit_Purchase_Order_Logs_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Limit_Purchase_Order_Logs_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Limit_Purchase_Order_Logs_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Limit_Purchase_Order_Logs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Limit_Purchase_Order_Logs_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "limit_purchase_order_logs" */
export type Limit_Purchase_Order_Logs_Aggregate_Fields = {
  __typename?: 'limit_purchase_order_logs_aggregate_fields';
  avg?: Maybe<Limit_Purchase_Order_Logs_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Limit_Purchase_Order_Logs_Max_Fields>;
  min?: Maybe<Limit_Purchase_Order_Logs_Min_Fields>;
  stddev?: Maybe<Limit_Purchase_Order_Logs_Stddev_Fields>;
  stddev_pop?: Maybe<Limit_Purchase_Order_Logs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Limit_Purchase_Order_Logs_Stddev_Samp_Fields>;
  sum?: Maybe<Limit_Purchase_Order_Logs_Sum_Fields>;
  var_pop?: Maybe<Limit_Purchase_Order_Logs_Var_Pop_Fields>;
  var_samp?: Maybe<Limit_Purchase_Order_Logs_Var_Samp_Fields>;
  variance?: Maybe<Limit_Purchase_Order_Logs_Variance_Fields>;
};


/** aggregate fields of "limit_purchase_order_logs" */
export type Limit_Purchase_Order_Logs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Limit_Purchase_Order_Logs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "limit_purchase_order_logs" */
export type Limit_Purchase_Order_Logs_Aggregate_Order_By = {
  avg?: InputMaybe<Limit_Purchase_Order_Logs_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Limit_Purchase_Order_Logs_Max_Order_By>;
  min?: InputMaybe<Limit_Purchase_Order_Logs_Min_Order_By>;
  stddev?: InputMaybe<Limit_Purchase_Order_Logs_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Limit_Purchase_Order_Logs_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Limit_Purchase_Order_Logs_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Limit_Purchase_Order_Logs_Sum_Order_By>;
  var_pop?: InputMaybe<Limit_Purchase_Order_Logs_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Limit_Purchase_Order_Logs_Var_Samp_Order_By>;
  variance?: InputMaybe<Limit_Purchase_Order_Logs_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "limit_purchase_order_logs" */
export type Limit_Purchase_Order_Logs_Arr_Rel_Insert_Input = {
  data: Array<Limit_Purchase_Order_Logs_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Limit_Purchase_Order_Logs_On_Conflict>;
};

/** aggregate avg on columns */
export type Limit_Purchase_Order_Logs_Avg_Fields = {
  __typename?: 'limit_purchase_order_logs_avg_fields';
  current_quantity?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  unit_price?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "limit_purchase_order_logs" */
export type Limit_Purchase_Order_Logs_Avg_Order_By = {
  current_quantity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "limit_purchase_order_logs". All fields are combined with a logical 'AND'. */
export type Limit_Purchase_Order_Logs_Bool_Exp = {
  _and?: InputMaybe<Array<Limit_Purchase_Order_Logs_Bool_Exp>>;
  _not?: InputMaybe<Limit_Purchase_Order_Logs_Bool_Exp>;
  _or?: InputMaybe<Array<Limit_Purchase_Order_Logs_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  current_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invoiced_item?: InputMaybe<Invoiced_Item_Bool_Exp>;
  invoiced_item_id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  limit_purchase_order?: InputMaybe<Limit_Purchase_Order_Bool_Exp>;
  limit_purchase_order_id?: InputMaybe<Uuid_Comparison_Exp>;
  lpo_exception?: InputMaybe<Lpo_Exception_Bool_Exp>;
  lpo_exception_id?: InputMaybe<Uuid_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  quantity?: InputMaybe<Numeric_Comparison_Exp>;
  transactionTypeByTransactionType?: InputMaybe<Transaction_Type_Bool_Exp>;
  transaction_reference?: InputMaybe<Uuid_Comparison_Exp>;
  transaction_type?: InputMaybe<String_Comparison_Exp>;
  unit_price?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "limit_purchase_order_logs" */
export enum Limit_Purchase_Order_Logs_Constraint {
  /** unique or primary key constraint on columns "invoiced_item_id" */
  LimitPurchaseOrderLogsInvoicedItemDebitUnique = 'limit_purchase_order_logs_invoiced_item_debit_unique',
  /** unique or primary key constraint on columns "lpo_exception_id" */
  LimitPurchaseOrderLogsLpoExceptionCreditUnique = 'limit_purchase_order_logs_lpo_exception_credit_unique',
  /** unique or primary key constraint on columns "id" */
  LimitPurchaseOrderLogsPkey = 'limit_purchase_order_logs_pkey',
  /** unique or primary key constraint on columns "invoiced_item_id", "transaction_type" */
  LpoLogsInvoicedItemTxnUnique = 'lpo_logs_invoiced_item_txn_unique',
  /** unique or primary key constraint on columns "transaction_reference" */
  LpoLogsTransactionReferenceUnique = 'lpo_logs_transaction_reference_unique'
}

/** input type for incrementing numeric columns in table "limit_purchase_order_logs" */
export type Limit_Purchase_Order_Logs_Inc_Input = {
  current_quantity?: InputMaybe<Scalars['numeric']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  unit_price?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "limit_purchase_order_logs" */
export type Limit_Purchase_Order_Logs_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  current_quantity?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invoiced_item?: InputMaybe<Invoiced_Item_Obj_Rel_Insert_Input>;
  invoiced_item_id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  limit_purchase_order?: InputMaybe<Limit_Purchase_Order_Obj_Rel_Insert_Input>;
  limit_purchase_order_id?: InputMaybe<Scalars['uuid']['input']>;
  lpo_exception?: InputMaybe<Lpo_Exception_Obj_Rel_Insert_Input>;
  lpo_exception_id?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  transactionTypeByTransactionType?: InputMaybe<Transaction_Type_Obj_Rel_Insert_Input>;
  transaction_reference?: InputMaybe<Scalars['uuid']['input']>;
  transaction_type?: InputMaybe<Scalars['String']['input']>;
  unit_price?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Limit_Purchase_Order_Logs_Max_Fields = {
  __typename?: 'limit_purchase_order_logs_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  current_quantity?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  invoiced_item_id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  limit_purchase_order_id?: Maybe<Scalars['uuid']['output']>;
  lpo_exception_id?: Maybe<Scalars['uuid']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
  transaction_reference?: Maybe<Scalars['uuid']['output']>;
  transaction_type?: Maybe<Scalars['String']['output']>;
  unit_price?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "limit_purchase_order_logs" */
export type Limit_Purchase_Order_Logs_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  current_quantity?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoiced_item_id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  limit_purchase_order_id?: InputMaybe<Order_By>;
  lpo_exception_id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  transaction_reference?: InputMaybe<Order_By>;
  transaction_type?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Limit_Purchase_Order_Logs_Min_Fields = {
  __typename?: 'limit_purchase_order_logs_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  current_quantity?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  invoiced_item_id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  limit_purchase_order_id?: Maybe<Scalars['uuid']['output']>;
  lpo_exception_id?: Maybe<Scalars['uuid']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
  transaction_reference?: Maybe<Scalars['uuid']['output']>;
  transaction_type?: Maybe<Scalars['String']['output']>;
  unit_price?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "limit_purchase_order_logs" */
export type Limit_Purchase_Order_Logs_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  current_quantity?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoiced_item_id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  limit_purchase_order_id?: InputMaybe<Order_By>;
  lpo_exception_id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  transaction_reference?: InputMaybe<Order_By>;
  transaction_type?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "limit_purchase_order_logs" */
export type Limit_Purchase_Order_Logs_Mutation_Response = {
  __typename?: 'limit_purchase_order_logs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Limit_Purchase_Order_Logs>;
};

/** on_conflict condition type for table "limit_purchase_order_logs" */
export type Limit_Purchase_Order_Logs_On_Conflict = {
  constraint: Limit_Purchase_Order_Logs_Constraint;
  update_columns?: Array<Limit_Purchase_Order_Logs_Update_Column>;
  where?: InputMaybe<Limit_Purchase_Order_Logs_Bool_Exp>;
};

/** Ordering options when selecting data from "limit_purchase_order_logs". */
export type Limit_Purchase_Order_Logs_Order_By = {
  created_at?: InputMaybe<Order_By>;
  current_quantity?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoiced_item?: InputMaybe<Invoiced_Item_Order_By>;
  invoiced_item_id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  limit_purchase_order?: InputMaybe<Limit_Purchase_Order_Order_By>;
  limit_purchase_order_id?: InputMaybe<Order_By>;
  lpo_exception?: InputMaybe<Lpo_Exception_Order_By>;
  lpo_exception_id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  transactionTypeByTransactionType?: InputMaybe<Transaction_Type_Order_By>;
  transaction_reference?: InputMaybe<Order_By>;
  transaction_type?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** primary key columns input for table: limit_purchase_order_logs */
export type Limit_Purchase_Order_Logs_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "limit_purchase_order_logs" */
export enum Limit_Purchase_Order_Logs_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentQuantity = 'current_quantity',
  /** column name */
  Id = 'id',
  /** column name */
  InvoicedItemId = 'invoiced_item_id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  LimitPurchaseOrderId = 'limit_purchase_order_id',
  /** column name */
  LpoExceptionId = 'lpo_exception_id',
  /** column name */
  Notes = 'notes',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  TransactionReference = 'transaction_reference',
  /** column name */
  TransactionType = 'transaction_type',
  /** column name */
  UnitPrice = 'unit_price'
}

/** select "limit_purchase_order_logs_aggregate_bool_exp_bool_and_arguments_columns" columns of table "limit_purchase_order_logs" */
export enum Limit_Purchase_Order_Logs_Select_Column_Limit_Purchase_Order_Logs_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "limit_purchase_order_logs_aggregate_bool_exp_bool_or_arguments_columns" columns of table "limit_purchase_order_logs" */
export enum Limit_Purchase_Order_Logs_Select_Column_Limit_Purchase_Order_Logs_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "limit_purchase_order_logs" */
export type Limit_Purchase_Order_Logs_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  current_quantity?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invoiced_item_id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  limit_purchase_order_id?: InputMaybe<Scalars['uuid']['input']>;
  lpo_exception_id?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  transaction_reference?: InputMaybe<Scalars['uuid']['input']>;
  transaction_type?: InputMaybe<Scalars['String']['input']>;
  unit_price?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Limit_Purchase_Order_Logs_Stddev_Fields = {
  __typename?: 'limit_purchase_order_logs_stddev_fields';
  current_quantity?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  unit_price?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "limit_purchase_order_logs" */
export type Limit_Purchase_Order_Logs_Stddev_Order_By = {
  current_quantity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Limit_Purchase_Order_Logs_Stddev_Pop_Fields = {
  __typename?: 'limit_purchase_order_logs_stddev_pop_fields';
  current_quantity?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  unit_price?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "limit_purchase_order_logs" */
export type Limit_Purchase_Order_Logs_Stddev_Pop_Order_By = {
  current_quantity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Limit_Purchase_Order_Logs_Stddev_Samp_Fields = {
  __typename?: 'limit_purchase_order_logs_stddev_samp_fields';
  current_quantity?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  unit_price?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "limit_purchase_order_logs" */
export type Limit_Purchase_Order_Logs_Stddev_Samp_Order_By = {
  current_quantity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "limit_purchase_order_logs" */
export type Limit_Purchase_Order_Logs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Limit_Purchase_Order_Logs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Limit_Purchase_Order_Logs_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  current_quantity?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invoiced_item_id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  limit_purchase_order_id?: InputMaybe<Scalars['uuid']['input']>;
  lpo_exception_id?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  transaction_reference?: InputMaybe<Scalars['uuid']['input']>;
  transaction_type?: InputMaybe<Scalars['String']['input']>;
  unit_price?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Limit_Purchase_Order_Logs_Sum_Fields = {
  __typename?: 'limit_purchase_order_logs_sum_fields';
  current_quantity?: Maybe<Scalars['numeric']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
  unit_price?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "limit_purchase_order_logs" */
export type Limit_Purchase_Order_Logs_Sum_Order_By = {
  current_quantity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** update columns of table "limit_purchase_order_logs" */
export enum Limit_Purchase_Order_Logs_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentQuantity = 'current_quantity',
  /** column name */
  Id = 'id',
  /** column name */
  InvoicedItemId = 'invoiced_item_id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  LimitPurchaseOrderId = 'limit_purchase_order_id',
  /** column name */
  LpoExceptionId = 'lpo_exception_id',
  /** column name */
  Notes = 'notes',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  TransactionReference = 'transaction_reference',
  /** column name */
  TransactionType = 'transaction_type',
  /** column name */
  UnitPrice = 'unit_price'
}

export type Limit_Purchase_Order_Logs_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Limit_Purchase_Order_Logs_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Limit_Purchase_Order_Logs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Limit_Purchase_Order_Logs_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Limit_Purchase_Order_Logs_Var_Pop_Fields = {
  __typename?: 'limit_purchase_order_logs_var_pop_fields';
  current_quantity?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  unit_price?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "limit_purchase_order_logs" */
export type Limit_Purchase_Order_Logs_Var_Pop_Order_By = {
  current_quantity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Limit_Purchase_Order_Logs_Var_Samp_Fields = {
  __typename?: 'limit_purchase_order_logs_var_samp_fields';
  current_quantity?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  unit_price?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "limit_purchase_order_logs" */
export type Limit_Purchase_Order_Logs_Var_Samp_Order_By = {
  current_quantity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Limit_Purchase_Order_Logs_Variance_Fields = {
  __typename?: 'limit_purchase_order_logs_variance_fields';
  current_quantity?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  unit_price?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "limit_purchase_order_logs" */
export type Limit_Purchase_Order_Logs_Variance_Order_By = {
  current_quantity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Limit_Purchase_Order_Max_Fields = {
  __typename?: 'limit_purchase_order_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  organization_address_id?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "limit_purchase_order" */
export type Limit_Purchase_Order_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  organization_address_id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Limit_Purchase_Order_Min_Fields = {
  __typename?: 'limit_purchase_order_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  organization_address_id?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "limit_purchase_order" */
export type Limit_Purchase_Order_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  organization_address_id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "limit_purchase_order" */
export type Limit_Purchase_Order_Mutation_Response = {
  __typename?: 'limit_purchase_order_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Limit_Purchase_Order>;
};

/** input type for inserting object relation for remote table "limit_purchase_order" */
export type Limit_Purchase_Order_Obj_Rel_Insert_Input = {
  data: Limit_Purchase_Order_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Limit_Purchase_Order_On_Conflict>;
};

/** on_conflict condition type for table "limit_purchase_order" */
export type Limit_Purchase_Order_On_Conflict = {
  constraint: Limit_Purchase_Order_Constraint;
  update_columns?: Array<Limit_Purchase_Order_Update_Column>;
  where?: InputMaybe<Limit_Purchase_Order_Bool_Exp>;
};

/** Ordering options when selecting data from "limit_purchase_order". */
export type Limit_Purchase_Order_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  limit_purchase_order_logs_aggregate?: InputMaybe<Limit_Purchase_Order_Logs_Aggregate_Order_By>;
  lpo_exceptions_aggregate?: InputMaybe<Lpo_Exception_Aggregate_Order_By>;
  notes?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organization_address?: InputMaybe<Organization_Address_Order_By>;
  organization_address_id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** primary key columns input for table: limit_purchase_order */
export type Limit_Purchase_Order_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "limit_purchase_order" */
export enum Limit_Purchase_Order_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Notes = 'notes',
  /** column name */
  OrganizationAddressId = 'organization_address_id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Quantity = 'quantity'
}

/** select "limit_purchase_order_aggregate_bool_exp_bool_and_arguments_columns" columns of table "limit_purchase_order" */
export enum Limit_Purchase_Order_Select_Column_Limit_Purchase_Order_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "limit_purchase_order_aggregate_bool_exp_bool_or_arguments_columns" columns of table "limit_purchase_order" */
export enum Limit_Purchase_Order_Select_Column_Limit_Purchase_Order_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "limit_purchase_order" */
export type Limit_Purchase_Order_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organization_address_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Limit_Purchase_Order_Stddev_Fields = {
  __typename?: 'limit_purchase_order_stddev_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "limit_purchase_order" */
export type Limit_Purchase_Order_Stddev_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Limit_Purchase_Order_Stddev_Pop_Fields = {
  __typename?: 'limit_purchase_order_stddev_pop_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "limit_purchase_order" */
export type Limit_Purchase_Order_Stddev_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Limit_Purchase_Order_Stddev_Samp_Fields = {
  __typename?: 'limit_purchase_order_stddev_samp_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "limit_purchase_order" */
export type Limit_Purchase_Order_Stddev_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "limit_purchase_order" */
export type Limit_Purchase_Order_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Limit_Purchase_Order_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Limit_Purchase_Order_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organization_address_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Limit_Purchase_Order_Sum_Fields = {
  __typename?: 'limit_purchase_order_sum_fields';
  quantity?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "limit_purchase_order" */
export type Limit_Purchase_Order_Sum_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** update columns of table "limit_purchase_order" */
export enum Limit_Purchase_Order_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Notes = 'notes',
  /** column name */
  OrganizationAddressId = 'organization_address_id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Quantity = 'quantity'
}

export type Limit_Purchase_Order_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Limit_Purchase_Order_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Limit_Purchase_Order_Set_Input>;
  /** filter the rows which have to be updated */
  where: Limit_Purchase_Order_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Limit_Purchase_Order_Var_Pop_Fields = {
  __typename?: 'limit_purchase_order_var_pop_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "limit_purchase_order" */
export type Limit_Purchase_Order_Var_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Limit_Purchase_Order_Var_Samp_Fields = {
  __typename?: 'limit_purchase_order_var_samp_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "limit_purchase_order" */
export type Limit_Purchase_Order_Var_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Limit_Purchase_Order_Variance_Fields = {
  __typename?: 'limit_purchase_order_variance_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "limit_purchase_order" */
export type Limit_Purchase_Order_Variance_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** columns and relationships of "localities" */
export type Localities = {
  __typename?: 'localities';
  area: Scalars['geometry']['output'];
  country_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  country_localities?: Maybe<Country>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  is_buddycan_delivery?: Maybe<Scalars['Boolean']['output']>;
  is_minimum_order_quantity_enabled?: Maybe<Scalars['Boolean']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  minimum_order_quantity?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  organization_addresses: Array<Organization_Address>;
  /** An aggregate relationship */
  organization_addresses_aggregate: Organization_Address_Aggregate;
  /** An array relationship */
  partner_addresses: Array<Partner_Address>;
  /** An aggregate relationship */
  partner_addresses_aggregate: Partner_Address_Aggregate;
  /** An array relationship */
  partner_localities: Array<Partner_Localities>;
  /** An aggregate relationship */
  partner_localities_aggregate: Partner_Localities_Aggregate;
  state_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  state_localities?: Maybe<State>;
  /** An array relationship */
  vehicle_localities: Array<Vehicle_Localities>;
  /** An aggregate relationship */
  vehicle_localities_aggregate: Vehicle_Localities_Aggregate;
};


/** columns and relationships of "localities" */
export type LocalitiesOrganization_AddressesArgs = {
  distinct_on?: InputMaybe<Array<Organization_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Address_Order_By>>;
  where?: InputMaybe<Organization_Address_Bool_Exp>;
};


/** columns and relationships of "localities" */
export type LocalitiesOrganization_Addresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Address_Order_By>>;
  where?: InputMaybe<Organization_Address_Bool_Exp>;
};


/** columns and relationships of "localities" */
export type LocalitiesPartner_AddressesArgs = {
  distinct_on?: InputMaybe<Array<Partner_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Address_Order_By>>;
  where?: InputMaybe<Partner_Address_Bool_Exp>;
};


/** columns and relationships of "localities" */
export type LocalitiesPartner_Addresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Address_Order_By>>;
  where?: InputMaybe<Partner_Address_Bool_Exp>;
};


/** columns and relationships of "localities" */
export type LocalitiesPartner_LocalitiesArgs = {
  distinct_on?: InputMaybe<Array<Partner_Localities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Localities_Order_By>>;
  where?: InputMaybe<Partner_Localities_Bool_Exp>;
};


/** columns and relationships of "localities" */
export type LocalitiesPartner_Localities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Localities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Localities_Order_By>>;
  where?: InputMaybe<Partner_Localities_Bool_Exp>;
};


/** columns and relationships of "localities" */
export type LocalitiesVehicle_LocalitiesArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Localities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Localities_Order_By>>;
  where?: InputMaybe<Vehicle_Localities_Bool_Exp>;
};


/** columns and relationships of "localities" */
export type LocalitiesVehicle_Localities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Localities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Localities_Order_By>>;
  where?: InputMaybe<Vehicle_Localities_Bool_Exp>;
};

/** aggregated selection of "localities" */
export type Localities_Aggregate = {
  __typename?: 'localities_aggregate';
  aggregate?: Maybe<Localities_Aggregate_Fields>;
  nodes: Array<Localities>;
};

/** aggregate fields of "localities" */
export type Localities_Aggregate_Fields = {
  __typename?: 'localities_aggregate_fields';
  avg?: Maybe<Localities_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Localities_Max_Fields>;
  min?: Maybe<Localities_Min_Fields>;
  stddev?: Maybe<Localities_Stddev_Fields>;
  stddev_pop?: Maybe<Localities_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Localities_Stddev_Samp_Fields>;
  sum?: Maybe<Localities_Sum_Fields>;
  var_pop?: Maybe<Localities_Var_Pop_Fields>;
  var_samp?: Maybe<Localities_Var_Samp_Fields>;
  variance?: Maybe<Localities_Variance_Fields>;
};


/** aggregate fields of "localities" */
export type Localities_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Localities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Localities_Avg_Fields = {
  __typename?: 'localities_avg_fields';
  minimum_order_quantity?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "localities". All fields are combined with a logical 'AND'. */
export type Localities_Bool_Exp = {
  _and?: InputMaybe<Array<Localities_Bool_Exp>>;
  _not?: InputMaybe<Localities_Bool_Exp>;
  _or?: InputMaybe<Array<Localities_Bool_Exp>>;
  area?: InputMaybe<Geometry_Comparison_Exp>;
  country_id?: InputMaybe<Uuid_Comparison_Exp>;
  country_localities?: InputMaybe<Country_Bool_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_buddycan_delivery?: InputMaybe<Boolean_Comparison_Exp>;
  is_minimum_order_quantity_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  minimum_order_quantity?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization_addresses?: InputMaybe<Organization_Address_Bool_Exp>;
  organization_addresses_aggregate?: InputMaybe<Organization_Address_Aggregate_Bool_Exp>;
  partner_addresses?: InputMaybe<Partner_Address_Bool_Exp>;
  partner_addresses_aggregate?: InputMaybe<Partner_Address_Aggregate_Bool_Exp>;
  partner_localities?: InputMaybe<Partner_Localities_Bool_Exp>;
  partner_localities_aggregate?: InputMaybe<Partner_Localities_Aggregate_Bool_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  state_localities?: InputMaybe<State_Bool_Exp>;
  vehicle_localities?: InputMaybe<Vehicle_Localities_Bool_Exp>;
  vehicle_localities_aggregate?: InputMaybe<Vehicle_Localities_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "localities" */
export enum Localities_Constraint {
  /** unique or primary key constraint on columns "id" */
  LocalitiesPkey = 'localities_pkey'
}

/** input type for incrementing numeric columns in table "localities" */
export type Localities_Inc_Input = {
  minimum_order_quantity?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "localities" */
export type Localities_Insert_Input = {
  area?: InputMaybe<Scalars['geometry']['input']>;
  country_id?: InputMaybe<Scalars['uuid']['input']>;
  country_localities?: InputMaybe<Country_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_buddycan_delivery?: InputMaybe<Scalars['Boolean']['input']>;
  is_minimum_order_quantity_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  minimum_order_quantity?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_addresses?: InputMaybe<Organization_Address_Arr_Rel_Insert_Input>;
  partner_addresses?: InputMaybe<Partner_Address_Arr_Rel_Insert_Input>;
  partner_localities?: InputMaybe<Partner_Localities_Arr_Rel_Insert_Input>;
  state_id?: InputMaybe<Scalars['uuid']['input']>;
  state_localities?: InputMaybe<State_Obj_Rel_Insert_Input>;
  vehicle_localities?: InputMaybe<Vehicle_Localities_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Localities_Max_Fields = {
  __typename?: 'localities_max_fields';
  country_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  minimum_order_quantity?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Localities_Min_Fields = {
  __typename?: 'localities_min_fields';
  country_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  minimum_order_quantity?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "localities" */
export type Localities_Mutation_Response = {
  __typename?: 'localities_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Localities>;
};

/** input type for inserting object relation for remote table "localities" */
export type Localities_Obj_Rel_Insert_Input = {
  data: Localities_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Localities_On_Conflict>;
};

/** on_conflict condition type for table "localities" */
export type Localities_On_Conflict = {
  constraint: Localities_Constraint;
  update_columns?: Array<Localities_Update_Column>;
  where?: InputMaybe<Localities_Bool_Exp>;
};

/** Ordering options when selecting data from "localities". */
export type Localities_Order_By = {
  area?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  country_localities?: InputMaybe<Country_Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_buddycan_delivery?: InputMaybe<Order_By>;
  is_minimum_order_quantity_enabled?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  minimum_order_quantity?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_addresses_aggregate?: InputMaybe<Organization_Address_Aggregate_Order_By>;
  partner_addresses_aggregate?: InputMaybe<Partner_Address_Aggregate_Order_By>;
  partner_localities_aggregate?: InputMaybe<Partner_Localities_Aggregate_Order_By>;
  state_id?: InputMaybe<Order_By>;
  state_localities?: InputMaybe<State_Order_By>;
  vehicle_localities_aggregate?: InputMaybe<Vehicle_Localities_Aggregate_Order_By>;
};

/** primary key columns input for table: localities */
export type Localities_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "localities" */
export enum Localities_Select_Column {
  /** column name */
  Area = 'area',
  /** column name */
  CountryId = 'country_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsBuddycanDelivery = 'is_buddycan_delivery',
  /** column name */
  IsMinimumOrderQuantityEnabled = 'is_minimum_order_quantity_enabled',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  MinimumOrderQuantity = 'minimum_order_quantity',
  /** column name */
  Name = 'name',
  /** column name */
  StateId = 'state_id'
}

/** input type for updating data in table "localities" */
export type Localities_Set_Input = {
  area?: InputMaybe<Scalars['geometry']['input']>;
  country_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_buddycan_delivery?: InputMaybe<Scalars['Boolean']['input']>;
  is_minimum_order_quantity_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  minimum_order_quantity?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  state_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Localities_Stddev_Fields = {
  __typename?: 'localities_stddev_fields';
  minimum_order_quantity?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Localities_Stddev_Pop_Fields = {
  __typename?: 'localities_stddev_pop_fields';
  minimum_order_quantity?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Localities_Stddev_Samp_Fields = {
  __typename?: 'localities_stddev_samp_fields';
  minimum_order_quantity?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "localities" */
export type Localities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Localities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Localities_Stream_Cursor_Value_Input = {
  area?: InputMaybe<Scalars['geometry']['input']>;
  country_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_buddycan_delivery?: InputMaybe<Scalars['Boolean']['input']>;
  is_minimum_order_quantity_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  minimum_order_quantity?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  state_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Localities_Sum_Fields = {
  __typename?: 'localities_sum_fields';
  minimum_order_quantity?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "localities" */
export enum Localities_Update_Column {
  /** column name */
  Area = 'area',
  /** column name */
  CountryId = 'country_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsBuddycanDelivery = 'is_buddycan_delivery',
  /** column name */
  IsMinimumOrderQuantityEnabled = 'is_minimum_order_quantity_enabled',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  MinimumOrderQuantity = 'minimum_order_quantity',
  /** column name */
  Name = 'name',
  /** column name */
  StateId = 'state_id'
}

export type Localities_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Localities_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Localities_Set_Input>;
  /** filter the rows which have to be updated */
  where: Localities_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Localities_Var_Pop_Fields = {
  __typename?: 'localities_var_pop_fields';
  minimum_order_quantity?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Localities_Var_Samp_Fields = {
  __typename?: 'localities_var_samp_fields';
  minimum_order_quantity?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Localities_Variance_Fields = {
  __typename?: 'localities_variance_fields';
  minimum_order_quantity?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "login_type" */
export type Login_Type = {
  __typename?: 'login_type';
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  driver_duty_logs: Array<Driver_Duty_Log>;
  /** An aggregate relationship */
  driver_duty_logs_aggregate: Driver_Duty_Log_Aggregate;
  /** An array relationship */
  driver_vehicles: Array<Driver_Vehicle>;
  /** An aggregate relationship */
  driver_vehicles_aggregate: Driver_Vehicle_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "login_type" */
export type Login_TypeDriver_Duty_LogsArgs = {
  distinct_on?: InputMaybe<Array<Driver_Duty_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Duty_Log_Order_By>>;
  where?: InputMaybe<Driver_Duty_Log_Bool_Exp>;
};


/** columns and relationships of "login_type" */
export type Login_TypeDriver_Duty_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Driver_Duty_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Duty_Log_Order_By>>;
  where?: InputMaybe<Driver_Duty_Log_Bool_Exp>;
};


/** columns and relationships of "login_type" */
export type Login_TypeDriver_VehiclesArgs = {
  distinct_on?: InputMaybe<Array<Driver_Vehicle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Vehicle_Order_By>>;
  where?: InputMaybe<Driver_Vehicle_Bool_Exp>;
};


/** columns and relationships of "login_type" */
export type Login_TypeDriver_Vehicles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Driver_Vehicle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Vehicle_Order_By>>;
  where?: InputMaybe<Driver_Vehicle_Bool_Exp>;
};

/** aggregated selection of "login_type" */
export type Login_Type_Aggregate = {
  __typename?: 'login_type_aggregate';
  aggregate?: Maybe<Login_Type_Aggregate_Fields>;
  nodes: Array<Login_Type>;
};

/** aggregate fields of "login_type" */
export type Login_Type_Aggregate_Fields = {
  __typename?: 'login_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Login_Type_Max_Fields>;
  min?: Maybe<Login_Type_Min_Fields>;
};


/** aggregate fields of "login_type" */
export type Login_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Login_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "login_type". All fields are combined with a logical 'AND'. */
export type Login_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Login_Type_Bool_Exp>>;
  _not?: InputMaybe<Login_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Login_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  driver_duty_logs?: InputMaybe<Driver_Duty_Log_Bool_Exp>;
  driver_duty_logs_aggregate?: InputMaybe<Driver_Duty_Log_Aggregate_Bool_Exp>;
  driver_vehicles?: InputMaybe<Driver_Vehicle_Bool_Exp>;
  driver_vehicles_aggregate?: InputMaybe<Driver_Vehicle_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "login_type" */
export enum Login_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  LoginTypePkey = 'login_type_pkey'
}

export enum Login_Type_Enum {
  /** CHECK_IN */
  CheckIn = 'CHECK_IN',
  /** CHECK_OUT */
  CheckOut = 'CHECK_OUT',
  /** LOGED_IN */
  LogedIn = 'LOGED_IN',
  /** LOGOUT */
  Logout = 'LOGOUT',
  /** OCCUPIED */
  Occupied = 'OCCUPIED'
}

/** Boolean expression to compare columns of type "login_type_enum". All fields are combined with logical 'AND'. */
export type Login_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Login_Type_Enum>;
  _in?: InputMaybe<Array<Login_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Login_Type_Enum>;
  _nin?: InputMaybe<Array<Login_Type_Enum>>;
};

/** input type for inserting data into table "login_type" */
export type Login_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  driver_duty_logs?: InputMaybe<Driver_Duty_Log_Arr_Rel_Insert_Input>;
  driver_vehicles?: InputMaybe<Driver_Vehicle_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Login_Type_Max_Fields = {
  __typename?: 'login_type_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Login_Type_Min_Fields = {
  __typename?: 'login_type_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "login_type" */
export type Login_Type_Mutation_Response = {
  __typename?: 'login_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Login_Type>;
};

/** input type for inserting object relation for remote table "login_type" */
export type Login_Type_Obj_Rel_Insert_Input = {
  data: Login_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Login_Type_On_Conflict>;
};

/** on_conflict condition type for table "login_type" */
export type Login_Type_On_Conflict = {
  constraint: Login_Type_Constraint;
  update_columns?: Array<Login_Type_Update_Column>;
  where?: InputMaybe<Login_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "login_type". */
export type Login_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  driver_duty_logs_aggregate?: InputMaybe<Driver_Duty_Log_Aggregate_Order_By>;
  driver_vehicles_aggregate?: InputMaybe<Driver_Vehicle_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: login_type */
export type Login_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "login_type" */
export enum Login_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "login_type" */
export type Login_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "login_type" */
export type Login_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Login_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Login_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "login_type" */
export enum Login_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Login_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Login_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Login_Type_Bool_Exp;
};

/** Tracks temporary LPO exception approvals that allow deliveries beyond LPO limits. Each exception is a fixed 12-hour window with an optional volume cap. */
export type Lpo_Exception = {
  __typename?: 'lpo_exception';
  approval_reference?: Maybe<Scalars['String']['output']>;
  approved_by: Scalars['uuid']['output'];
  /** An object relationship */
  approved_by_user: User;
  created_at: Scalars['timestamptz']['output'];
  exception_quantity?: Maybe<Scalars['numeric']['output']>;
  expires_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified: Scalars['timestamptz']['output'];
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  last_modified_by_user?: Maybe<User>;
  /** An object relationship */
  limit_purchase_order: Limit_Purchase_Order;
  limit_purchase_order_id: Scalars['uuid']['output'];
  /** An array relationship */
  limit_purchase_order_logs: Array<Limit_Purchase_Order_Logs>;
  /** An aggregate relationship */
  limit_purchase_order_logs_aggregate: Limit_Purchase_Order_Logs_Aggregate;
  notes?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organization: Organization;
  /** An object relationship */
  organization_address?: Maybe<Organization_Address>;
  organization_address_id?: Maybe<Scalars['uuid']['output']>;
  organization_id: Scalars['uuid']['output'];
  state: Scalars['String']['output'];
  workflow_id?: Maybe<Scalars['String']['output']>;
  workflow_run_id?: Maybe<Scalars['String']['output']>;
};


/** Tracks temporary LPO exception approvals that allow deliveries beyond LPO limits. Each exception is a fixed 12-hour window with an optional volume cap. */
export type Lpo_ExceptionLimit_Purchase_Order_LogsArgs = {
  distinct_on?: InputMaybe<Array<Limit_Purchase_Order_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Limit_Purchase_Order_Logs_Order_By>>;
  where?: InputMaybe<Limit_Purchase_Order_Logs_Bool_Exp>;
};


/** Tracks temporary LPO exception approvals that allow deliveries beyond LPO limits. Each exception is a fixed 12-hour window with an optional volume cap. */
export type Lpo_ExceptionLimit_Purchase_Order_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Limit_Purchase_Order_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Limit_Purchase_Order_Logs_Order_By>>;
  where?: InputMaybe<Limit_Purchase_Order_Logs_Bool_Exp>;
};

/** aggregated selection of "lpo_exception" */
export type Lpo_Exception_Aggregate = {
  __typename?: 'lpo_exception_aggregate';
  aggregate?: Maybe<Lpo_Exception_Aggregate_Fields>;
  nodes: Array<Lpo_Exception>;
};

export type Lpo_Exception_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Lpo_Exception_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Lpo_Exception_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Lpo_Exception_Aggregate_Bool_Exp_Count>;
};

export type Lpo_Exception_Aggregate_Bool_Exp_Bool_And = {
  arguments: Lpo_Exception_Select_Column_Lpo_Exception_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lpo_Exception_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Lpo_Exception_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Lpo_Exception_Select_Column_Lpo_Exception_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lpo_Exception_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Lpo_Exception_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Lpo_Exception_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lpo_Exception_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "lpo_exception" */
export type Lpo_Exception_Aggregate_Fields = {
  __typename?: 'lpo_exception_aggregate_fields';
  avg?: Maybe<Lpo_Exception_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Lpo_Exception_Max_Fields>;
  min?: Maybe<Lpo_Exception_Min_Fields>;
  stddev?: Maybe<Lpo_Exception_Stddev_Fields>;
  stddev_pop?: Maybe<Lpo_Exception_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Lpo_Exception_Stddev_Samp_Fields>;
  sum?: Maybe<Lpo_Exception_Sum_Fields>;
  var_pop?: Maybe<Lpo_Exception_Var_Pop_Fields>;
  var_samp?: Maybe<Lpo_Exception_Var_Samp_Fields>;
  variance?: Maybe<Lpo_Exception_Variance_Fields>;
};


/** aggregate fields of "lpo_exception" */
export type Lpo_Exception_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Lpo_Exception_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "lpo_exception" */
export type Lpo_Exception_Aggregate_Order_By = {
  avg?: InputMaybe<Lpo_Exception_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Lpo_Exception_Max_Order_By>;
  min?: InputMaybe<Lpo_Exception_Min_Order_By>;
  stddev?: InputMaybe<Lpo_Exception_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Lpo_Exception_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Lpo_Exception_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Lpo_Exception_Sum_Order_By>;
  var_pop?: InputMaybe<Lpo_Exception_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Lpo_Exception_Var_Samp_Order_By>;
  variance?: InputMaybe<Lpo_Exception_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "lpo_exception" */
export type Lpo_Exception_Arr_Rel_Insert_Input = {
  data: Array<Lpo_Exception_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Lpo_Exception_On_Conflict>;
};

/** aggregate avg on columns */
export type Lpo_Exception_Avg_Fields = {
  __typename?: 'lpo_exception_avg_fields';
  exception_quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "lpo_exception" */
export type Lpo_Exception_Avg_Order_By = {
  exception_quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "lpo_exception". All fields are combined with a logical 'AND'. */
export type Lpo_Exception_Bool_Exp = {
  _and?: InputMaybe<Array<Lpo_Exception_Bool_Exp>>;
  _not?: InputMaybe<Lpo_Exception_Bool_Exp>;
  _or?: InputMaybe<Array<Lpo_Exception_Bool_Exp>>;
  approval_reference?: InputMaybe<String_Comparison_Exp>;
  approved_by?: InputMaybe<Uuid_Comparison_Exp>;
  approved_by_user?: InputMaybe<User_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  exception_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  expires_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  last_modified_by_user?: InputMaybe<User_Bool_Exp>;
  limit_purchase_order?: InputMaybe<Limit_Purchase_Order_Bool_Exp>;
  limit_purchase_order_id?: InputMaybe<Uuid_Comparison_Exp>;
  limit_purchase_order_logs?: InputMaybe<Limit_Purchase_Order_Logs_Bool_Exp>;
  limit_purchase_order_logs_aggregate?: InputMaybe<Limit_Purchase_Order_Logs_Aggregate_Bool_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organization_address?: InputMaybe<Organization_Address_Bool_Exp>;
  organization_address_id?: InputMaybe<Uuid_Comparison_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  workflow_id?: InputMaybe<String_Comparison_Exp>;
  workflow_run_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "lpo_exception" */
export enum Lpo_Exception_Constraint {
  /** unique or primary key constraint on columns "limit_purchase_order_id" */
  LpoExceptionActiveUnique = 'lpo_exception_active_unique',
  /** unique or primary key constraint on columns "id" */
  LpoExceptionPkey = 'lpo_exception_pkey'
}

/** input type for incrementing numeric columns in table "lpo_exception" */
export type Lpo_Exception_Inc_Input = {
  exception_quantity?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "lpo_exception" */
export type Lpo_Exception_Insert_Input = {
  approval_reference?: InputMaybe<Scalars['String']['input']>;
  approved_by?: InputMaybe<Scalars['uuid']['input']>;
  approved_by_user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  exception_quantity?: InputMaybe<Scalars['numeric']['input']>;
  expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  last_modified_by_user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  limit_purchase_order?: InputMaybe<Limit_Purchase_Order_Obj_Rel_Insert_Input>;
  limit_purchase_order_id?: InputMaybe<Scalars['uuid']['input']>;
  limit_purchase_order_logs?: InputMaybe<Limit_Purchase_Order_Logs_Arr_Rel_Insert_Input>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organization_address?: InputMaybe<Organization_Address_Obj_Rel_Insert_Input>;
  organization_address_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  workflow_id?: InputMaybe<Scalars['String']['input']>;
  workflow_run_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Lpo_Exception_Max_Fields = {
  __typename?: 'lpo_exception_max_fields';
  approval_reference?: Maybe<Scalars['String']['output']>;
  approved_by?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  exception_quantity?: Maybe<Scalars['numeric']['output']>;
  expires_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  limit_purchase_order_id?: Maybe<Scalars['uuid']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  organization_address_id?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  workflow_id?: Maybe<Scalars['String']['output']>;
  workflow_run_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "lpo_exception" */
export type Lpo_Exception_Max_Order_By = {
  approval_reference?: InputMaybe<Order_By>;
  approved_by?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  exception_quantity?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  limit_purchase_order_id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  organization_address_id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
  workflow_run_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Lpo_Exception_Min_Fields = {
  __typename?: 'lpo_exception_min_fields';
  approval_reference?: Maybe<Scalars['String']['output']>;
  approved_by?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  exception_quantity?: Maybe<Scalars['numeric']['output']>;
  expires_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  limit_purchase_order_id?: Maybe<Scalars['uuid']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  organization_address_id?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  workflow_id?: Maybe<Scalars['String']['output']>;
  workflow_run_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "lpo_exception" */
export type Lpo_Exception_Min_Order_By = {
  approval_reference?: InputMaybe<Order_By>;
  approved_by?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  exception_quantity?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  limit_purchase_order_id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  organization_address_id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
  workflow_run_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "lpo_exception" */
export type Lpo_Exception_Mutation_Response = {
  __typename?: 'lpo_exception_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Lpo_Exception>;
};

/** input type for inserting object relation for remote table "lpo_exception" */
export type Lpo_Exception_Obj_Rel_Insert_Input = {
  data: Lpo_Exception_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Lpo_Exception_On_Conflict>;
};

/** on_conflict condition type for table "lpo_exception" */
export type Lpo_Exception_On_Conflict = {
  constraint: Lpo_Exception_Constraint;
  update_columns?: Array<Lpo_Exception_Update_Column>;
  where?: InputMaybe<Lpo_Exception_Bool_Exp>;
};

/** Ordering options when selecting data from "lpo_exception". */
export type Lpo_Exception_Order_By = {
  approval_reference?: InputMaybe<Order_By>;
  approved_by?: InputMaybe<Order_By>;
  approved_by_user?: InputMaybe<User_Order_By>;
  created_at?: InputMaybe<Order_By>;
  exception_quantity?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  last_modified_by_user?: InputMaybe<User_Order_By>;
  limit_purchase_order?: InputMaybe<Limit_Purchase_Order_Order_By>;
  limit_purchase_order_id?: InputMaybe<Order_By>;
  limit_purchase_order_logs_aggregate?: InputMaybe<Limit_Purchase_Order_Logs_Aggregate_Order_By>;
  notes?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organization_address?: InputMaybe<Organization_Address_Order_By>;
  organization_address_id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
  workflow_run_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: lpo_exception */
export type Lpo_Exception_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "lpo_exception" */
export enum Lpo_Exception_Select_Column {
  /** column name */
  ApprovalReference = 'approval_reference',
  /** column name */
  ApprovedBy = 'approved_by',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExceptionQuantity = 'exception_quantity',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  LimitPurchaseOrderId = 'limit_purchase_order_id',
  /** column name */
  Notes = 'notes',
  /** column name */
  OrganizationAddressId = 'organization_address_id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  State = 'state',
  /** column name */
  WorkflowId = 'workflow_id',
  /** column name */
  WorkflowRunId = 'workflow_run_id'
}

/** select "lpo_exception_aggregate_bool_exp_bool_and_arguments_columns" columns of table "lpo_exception" */
export enum Lpo_Exception_Select_Column_Lpo_Exception_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "lpo_exception_aggregate_bool_exp_bool_or_arguments_columns" columns of table "lpo_exception" */
export enum Lpo_Exception_Select_Column_Lpo_Exception_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "lpo_exception" */
export type Lpo_Exception_Set_Input = {
  approval_reference?: InputMaybe<Scalars['String']['input']>;
  approved_by?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  exception_quantity?: InputMaybe<Scalars['numeric']['input']>;
  expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  limit_purchase_order_id?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organization_address_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  workflow_id?: InputMaybe<Scalars['String']['input']>;
  workflow_run_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Lpo_Exception_Stddev_Fields = {
  __typename?: 'lpo_exception_stddev_fields';
  exception_quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "lpo_exception" */
export type Lpo_Exception_Stddev_Order_By = {
  exception_quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Lpo_Exception_Stddev_Pop_Fields = {
  __typename?: 'lpo_exception_stddev_pop_fields';
  exception_quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "lpo_exception" */
export type Lpo_Exception_Stddev_Pop_Order_By = {
  exception_quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Lpo_Exception_Stddev_Samp_Fields = {
  __typename?: 'lpo_exception_stddev_samp_fields';
  exception_quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "lpo_exception" */
export type Lpo_Exception_Stddev_Samp_Order_By = {
  exception_quantity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "lpo_exception" */
export type Lpo_Exception_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lpo_Exception_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lpo_Exception_Stream_Cursor_Value_Input = {
  approval_reference?: InputMaybe<Scalars['String']['input']>;
  approved_by?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  exception_quantity?: InputMaybe<Scalars['numeric']['input']>;
  expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  limit_purchase_order_id?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organization_address_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  workflow_id?: InputMaybe<Scalars['String']['input']>;
  workflow_run_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Lpo_Exception_Sum_Fields = {
  __typename?: 'lpo_exception_sum_fields';
  exception_quantity?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "lpo_exception" */
export type Lpo_Exception_Sum_Order_By = {
  exception_quantity?: InputMaybe<Order_By>;
};

/** update columns of table "lpo_exception" */
export enum Lpo_Exception_Update_Column {
  /** column name */
  ApprovalReference = 'approval_reference',
  /** column name */
  ApprovedBy = 'approved_by',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExceptionQuantity = 'exception_quantity',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  LimitPurchaseOrderId = 'limit_purchase_order_id',
  /** column name */
  Notes = 'notes',
  /** column name */
  OrganizationAddressId = 'organization_address_id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  State = 'state',
  /** column name */
  WorkflowId = 'workflow_id',
  /** column name */
  WorkflowRunId = 'workflow_run_id'
}

export type Lpo_Exception_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Lpo_Exception_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Lpo_Exception_Set_Input>;
  /** filter the rows which have to be updated */
  where: Lpo_Exception_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Lpo_Exception_Var_Pop_Fields = {
  __typename?: 'lpo_exception_var_pop_fields';
  exception_quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "lpo_exception" */
export type Lpo_Exception_Var_Pop_Order_By = {
  exception_quantity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Lpo_Exception_Var_Samp_Fields = {
  __typename?: 'lpo_exception_var_samp_fields';
  exception_quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "lpo_exception" */
export type Lpo_Exception_Var_Samp_Order_By = {
  exception_quantity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Lpo_Exception_Variance_Fields = {
  __typename?: 'lpo_exception_variance_fields';
  exception_quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "lpo_exception" */
export type Lpo_Exception_Variance_Order_By = {
  exception_quantity?: InputMaybe<Order_By>;
};

/** Recurring weekly slot templates for customer delivery scheduling */
export type Master_Slot = {
  __typename?: 'master_slot';
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  created_by_user?: Maybe<User>;
  /** JSONB integer array where 0=Sunday, 1=Monday, ..., 6=Saturday. Example: [1,2,3,4,5] for Mon-Fri */
  days_of_week: Scalars['jsonb']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  /** True if slot crosses midnight */
  is_overnight: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  master_slot_pauses: Array<Master_Slot_Pause>;
  /** An aggregate relationship */
  master_slot_pauses_aggregate: Master_Slot_Pause_Aggregate;
  /** An object relationship */
  modified_by_user?: Maybe<User>;
  /** An object relationship */
  organization_address: Organization_Address;
  organization_address_id: Scalars['uuid']['output'];
  /** An object relationship */
  original?: Maybe<Master_Slot>;
  /** An object relationship */
  overrides_slot?: Maybe<Master_Slot>;
  /** The slot this row acts on. For OVERRIDE, the slot being replaced; for SKIP, the slot being stopped. NULL on ordinary permanent slots. */
  overrides_slot_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  overriding_slots: Array<Master_Slot>;
  /** An aggregate relationship */
  overriding_slots_aggregate: Master_Slot_Aggregate;
  /** An object relationship */
  partner: Partner;
  partner_id: Scalars['uuid']['output'];
  /** An array relationship */
  pauses: Array<Master_Slot_Pause>;
  /** An aggregate relationship */
  pauses_aggregate: Master_Slot_Pause_Aggregate;
  /** An array relationship */
  pending_revisions: Array<Master_Slot>;
  /** An aggregate relationship */
  pending_revisions_aggregate: Master_Slot_Aggregate;
  /** NULL = a permanent recurring slot. SKIP = a non-delivery that stops overrides_slot_id for the card window. OVERRIDE = a replacement that runs instead of overrides_slot_id for the card window. Action rows always belong to a planning_period. */
  planning_action?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  planning_period?: Maybe<Planning_Period>;
  /** Links to planning_period for temporary slots. NULL = permanent/perpetual slot */
  planning_period_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  product_variation?: Maybe<Product_Variation>;
  /** FK to product_variation - the product to be delivered in this slot */
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
  /** Delivery quantity for this slot (in litres or unit) */
  quantity?: Maybe<Scalars['numeric']['output']>;
  review_comment?: Maybe<Scalars['String']['output']>;
  reviewed_at?: Maybe<Scalars['timestamptz']['output']>;
  reviewed_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  reviewer?: Maybe<User>;
  /** Self-referential FK to original slot when this is a revision */
  revision_for?: Maybe<Scalars['uuid']['output']>;
  slot_end_time: Scalars['time']['output'];
  slot_start_time: Scalars['time']['output'];
  /** Approval status: DRAFT, PENDING_APPROVAL, APPROVED, REJECTED, SUPERSEDED */
  status: Scalars['String']['output'];
  /** An object relationship */
  vehicle?: Maybe<Vehicle>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};


/** Recurring weekly slot templates for customer delivery scheduling */
export type Master_SlotDays_Of_WeekArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Recurring weekly slot templates for customer delivery scheduling */
export type Master_SlotMaster_Slot_PausesArgs = {
  distinct_on?: InputMaybe<Array<Master_Slot_Pause_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Slot_Pause_Order_By>>;
  where?: InputMaybe<Master_Slot_Pause_Bool_Exp>;
};


/** Recurring weekly slot templates for customer delivery scheduling */
export type Master_SlotMaster_Slot_Pauses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Master_Slot_Pause_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Slot_Pause_Order_By>>;
  where?: InputMaybe<Master_Slot_Pause_Bool_Exp>;
};


/** Recurring weekly slot templates for customer delivery scheduling */
export type Master_SlotOverriding_SlotsArgs = {
  distinct_on?: InputMaybe<Array<Master_Slot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Slot_Order_By>>;
  where?: InputMaybe<Master_Slot_Bool_Exp>;
};


/** Recurring weekly slot templates for customer delivery scheduling */
export type Master_SlotOverriding_Slots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Master_Slot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Slot_Order_By>>;
  where?: InputMaybe<Master_Slot_Bool_Exp>;
};


/** Recurring weekly slot templates for customer delivery scheduling */
export type Master_SlotPausesArgs = {
  distinct_on?: InputMaybe<Array<Master_Slot_Pause_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Slot_Pause_Order_By>>;
  where?: InputMaybe<Master_Slot_Pause_Bool_Exp>;
};


/** Recurring weekly slot templates for customer delivery scheduling */
export type Master_SlotPauses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Master_Slot_Pause_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Slot_Pause_Order_By>>;
  where?: InputMaybe<Master_Slot_Pause_Bool_Exp>;
};


/** Recurring weekly slot templates for customer delivery scheduling */
export type Master_SlotPending_RevisionsArgs = {
  distinct_on?: InputMaybe<Array<Master_Slot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Slot_Order_By>>;
  where?: InputMaybe<Master_Slot_Bool_Exp>;
};


/** Recurring weekly slot templates for customer delivery scheduling */
export type Master_SlotPending_Revisions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Master_Slot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Slot_Order_By>>;
  where?: InputMaybe<Master_Slot_Bool_Exp>;
};

/** aggregated selection of "master_slot" */
export type Master_Slot_Aggregate = {
  __typename?: 'master_slot_aggregate';
  aggregate?: Maybe<Master_Slot_Aggregate_Fields>;
  nodes: Array<Master_Slot>;
};

export type Master_Slot_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Master_Slot_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Master_Slot_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Master_Slot_Aggregate_Bool_Exp_Count>;
};

export type Master_Slot_Aggregate_Bool_Exp_Bool_And = {
  arguments: Master_Slot_Select_Column_Master_Slot_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Master_Slot_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Master_Slot_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Master_Slot_Select_Column_Master_Slot_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Master_Slot_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Master_Slot_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Master_Slot_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Master_Slot_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "master_slot" */
export type Master_Slot_Aggregate_Fields = {
  __typename?: 'master_slot_aggregate_fields';
  avg?: Maybe<Master_Slot_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Master_Slot_Max_Fields>;
  min?: Maybe<Master_Slot_Min_Fields>;
  stddev?: Maybe<Master_Slot_Stddev_Fields>;
  stddev_pop?: Maybe<Master_Slot_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Master_Slot_Stddev_Samp_Fields>;
  sum?: Maybe<Master_Slot_Sum_Fields>;
  var_pop?: Maybe<Master_Slot_Var_Pop_Fields>;
  var_samp?: Maybe<Master_Slot_Var_Samp_Fields>;
  variance?: Maybe<Master_Slot_Variance_Fields>;
};


/** aggregate fields of "master_slot" */
export type Master_Slot_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Master_Slot_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "master_slot" */
export type Master_Slot_Aggregate_Order_By = {
  avg?: InputMaybe<Master_Slot_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Master_Slot_Max_Order_By>;
  min?: InputMaybe<Master_Slot_Min_Order_By>;
  stddev?: InputMaybe<Master_Slot_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Master_Slot_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Master_Slot_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Master_Slot_Sum_Order_By>;
  var_pop?: InputMaybe<Master_Slot_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Master_Slot_Var_Samp_Order_By>;
  variance?: InputMaybe<Master_Slot_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Master_Slot_Append_Input = {
  /** JSONB integer array where 0=Sunday, 1=Monday, ..., 6=Saturday. Example: [1,2,3,4,5] for Mon-Fri */
  days_of_week?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "master_slot" */
export type Master_Slot_Arr_Rel_Insert_Input = {
  data: Array<Master_Slot_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Master_Slot_On_Conflict>;
};

/** aggregate avg on columns */
export type Master_Slot_Avg_Fields = {
  __typename?: 'master_slot_avg_fields';
  /** Delivery quantity for this slot (in litres or unit) */
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "master_slot" */
export type Master_Slot_Avg_Order_By = {
  /** Delivery quantity for this slot (in litres or unit) */
  quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "master_slot". All fields are combined with a logical 'AND'. */
export type Master_Slot_Bool_Exp = {
  _and?: InputMaybe<Array<Master_Slot_Bool_Exp>>;
  _not?: InputMaybe<Master_Slot_Bool_Exp>;
  _or?: InputMaybe<Array<Master_Slot_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  created_by_user?: InputMaybe<User_Bool_Exp>;
  days_of_week?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_overnight?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  master_slot_pauses?: InputMaybe<Master_Slot_Pause_Bool_Exp>;
  master_slot_pauses_aggregate?: InputMaybe<Master_Slot_Pause_Aggregate_Bool_Exp>;
  modified_by_user?: InputMaybe<User_Bool_Exp>;
  organization_address?: InputMaybe<Organization_Address_Bool_Exp>;
  organization_address_id?: InputMaybe<Uuid_Comparison_Exp>;
  original?: InputMaybe<Master_Slot_Bool_Exp>;
  overrides_slot?: InputMaybe<Master_Slot_Bool_Exp>;
  overrides_slot_id?: InputMaybe<Uuid_Comparison_Exp>;
  overriding_slots?: InputMaybe<Master_Slot_Bool_Exp>;
  overriding_slots_aggregate?: InputMaybe<Master_Slot_Aggregate_Bool_Exp>;
  partner?: InputMaybe<Partner_Bool_Exp>;
  partner_id?: InputMaybe<Uuid_Comparison_Exp>;
  pauses?: InputMaybe<Master_Slot_Pause_Bool_Exp>;
  pauses_aggregate?: InputMaybe<Master_Slot_Pause_Aggregate_Bool_Exp>;
  pending_revisions?: InputMaybe<Master_Slot_Bool_Exp>;
  pending_revisions_aggregate?: InputMaybe<Master_Slot_Aggregate_Bool_Exp>;
  planning_action?: InputMaybe<String_Comparison_Exp>;
  planning_period?: InputMaybe<Planning_Period_Bool_Exp>;
  planning_period_id?: InputMaybe<Uuid_Comparison_Exp>;
  product_variation?: InputMaybe<Product_Variation_Bool_Exp>;
  product_variation_id?: InputMaybe<Uuid_Comparison_Exp>;
  quantity?: InputMaybe<Numeric_Comparison_Exp>;
  review_comment?: InputMaybe<String_Comparison_Exp>;
  reviewed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  reviewed_by?: InputMaybe<Uuid_Comparison_Exp>;
  reviewer?: InputMaybe<User_Bool_Exp>;
  revision_for?: InputMaybe<Uuid_Comparison_Exp>;
  slot_end_time?: InputMaybe<Time_Comparison_Exp>;
  slot_start_time?: InputMaybe<Time_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  vehicle?: InputMaybe<Vehicle_Bool_Exp>;
  vehicle_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "master_slot" */
export enum Master_Slot_Constraint {
  /** unique or primary key constraint on columns "id", "partner_id" */
  MasterSlotIdPartnerIdKey = 'master_slot_id_partner_id_key',
  /** unique or primary key constraint on columns "id" */
  MasterSlotPkey = 'master_slot_pkey',
  /** unique or primary key constraint on columns "planning_action", "overrides_slot_id", "planning_period_id" */
  UqMasterSlotCardTargetAction = 'uq_master_slot_card_target_action'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Master_Slot_Delete_At_Path_Input = {
  /** JSONB integer array where 0=Sunday, 1=Monday, ..., 6=Saturday. Example: [1,2,3,4,5] for Mon-Fri */
  days_of_week?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Master_Slot_Delete_Elem_Input = {
  /** JSONB integer array where 0=Sunday, 1=Monday, ..., 6=Saturday. Example: [1,2,3,4,5] for Mon-Fri */
  days_of_week?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Master_Slot_Delete_Key_Input = {
  /** JSONB integer array where 0=Sunday, 1=Monday, ..., 6=Saturday. Example: [1,2,3,4,5] for Mon-Fri */
  days_of_week?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "master_slot" */
export type Master_Slot_Inc_Input = {
  /** Delivery quantity for this slot (in litres or unit) */
  quantity?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "master_slot" */
export type Master_Slot_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  created_by_user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  /** JSONB integer array where 0=Sunday, 1=Monday, ..., 6=Saturday. Example: [1,2,3,4,5] for Mon-Fri */
  days_of_week?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  /** True if slot crosses midnight */
  is_overnight?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  master_slot_pauses?: InputMaybe<Master_Slot_Pause_Arr_Rel_Insert_Input>;
  modified_by_user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  organization_address?: InputMaybe<Organization_Address_Obj_Rel_Insert_Input>;
  organization_address_id?: InputMaybe<Scalars['uuid']['input']>;
  original?: InputMaybe<Master_Slot_Obj_Rel_Insert_Input>;
  overrides_slot?: InputMaybe<Master_Slot_Obj_Rel_Insert_Input>;
  /** The slot this row acts on. For OVERRIDE, the slot being replaced; for SKIP, the slot being stopped. NULL on ordinary permanent slots. */
  overrides_slot_id?: InputMaybe<Scalars['uuid']['input']>;
  overriding_slots?: InputMaybe<Master_Slot_Arr_Rel_Insert_Input>;
  partner?: InputMaybe<Partner_Obj_Rel_Insert_Input>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  pauses?: InputMaybe<Master_Slot_Pause_Arr_Rel_Insert_Input>;
  pending_revisions?: InputMaybe<Master_Slot_Arr_Rel_Insert_Input>;
  /** NULL = a permanent recurring slot. SKIP = a non-delivery that stops overrides_slot_id for the card window. OVERRIDE = a replacement that runs instead of overrides_slot_id for the card window. Action rows always belong to a planning_period. */
  planning_action?: InputMaybe<Scalars['String']['input']>;
  planning_period?: InputMaybe<Planning_Period_Obj_Rel_Insert_Input>;
  /** Links to planning_period for temporary slots. NULL = permanent/perpetual slot */
  planning_period_id?: InputMaybe<Scalars['uuid']['input']>;
  product_variation?: InputMaybe<Product_Variation_Obj_Rel_Insert_Input>;
  /** FK to product_variation - the product to be delivered in this slot */
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Delivery quantity for this slot (in litres or unit) */
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  review_comment?: InputMaybe<Scalars['String']['input']>;
  reviewed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  reviewed_by?: InputMaybe<Scalars['uuid']['input']>;
  reviewer?: InputMaybe<User_Obj_Rel_Insert_Input>;
  /** Self-referential FK to original slot when this is a revision */
  revision_for?: InputMaybe<Scalars['uuid']['input']>;
  slot_end_time?: InputMaybe<Scalars['time']['input']>;
  slot_start_time?: InputMaybe<Scalars['time']['input']>;
  /** Approval status: DRAFT, PENDING_APPROVAL, APPROVED, REJECTED, SUPERSEDED */
  status?: InputMaybe<Scalars['String']['input']>;
  vehicle?: InputMaybe<Vehicle_Obj_Rel_Insert_Input>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Master_Slot_Max_Fields = {
  __typename?: 'master_slot_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  organization_address_id?: Maybe<Scalars['uuid']['output']>;
  /** The slot this row acts on. For OVERRIDE, the slot being replaced; for SKIP, the slot being stopped. NULL on ordinary permanent slots. */
  overrides_slot_id?: Maybe<Scalars['uuid']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  /** NULL = a permanent recurring slot. SKIP = a non-delivery that stops overrides_slot_id for the card window. OVERRIDE = a replacement that runs instead of overrides_slot_id for the card window. Action rows always belong to a planning_period. */
  planning_action?: Maybe<Scalars['String']['output']>;
  /** Links to planning_period for temporary slots. NULL = permanent/perpetual slot */
  planning_period_id?: Maybe<Scalars['uuid']['output']>;
  /** FK to product_variation - the product to be delivered in this slot */
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
  /** Delivery quantity for this slot (in litres or unit) */
  quantity?: Maybe<Scalars['numeric']['output']>;
  review_comment?: Maybe<Scalars['String']['output']>;
  reviewed_at?: Maybe<Scalars['timestamptz']['output']>;
  reviewed_by?: Maybe<Scalars['uuid']['output']>;
  /** Self-referential FK to original slot when this is a revision */
  revision_for?: Maybe<Scalars['uuid']['output']>;
  /** Approval status: DRAFT, PENDING_APPROVAL, APPROVED, REJECTED, SUPERSEDED */
  status?: Maybe<Scalars['String']['output']>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "master_slot" */
export type Master_Slot_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_address_id?: InputMaybe<Order_By>;
  /** The slot this row acts on. For OVERRIDE, the slot being replaced; for SKIP, the slot being stopped. NULL on ordinary permanent slots. */
  overrides_slot_id?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  /** NULL = a permanent recurring slot. SKIP = a non-delivery that stops overrides_slot_id for the card window. OVERRIDE = a replacement that runs instead of overrides_slot_id for the card window. Action rows always belong to a planning_period. */
  planning_action?: InputMaybe<Order_By>;
  /** Links to planning_period for temporary slots. NULL = permanent/perpetual slot */
  planning_period_id?: InputMaybe<Order_By>;
  /** FK to product_variation - the product to be delivered in this slot */
  product_variation_id?: InputMaybe<Order_By>;
  /** Delivery quantity for this slot (in litres or unit) */
  quantity?: InputMaybe<Order_By>;
  review_comment?: InputMaybe<Order_By>;
  reviewed_at?: InputMaybe<Order_By>;
  reviewed_by?: InputMaybe<Order_By>;
  /** Self-referential FK to original slot when this is a revision */
  revision_for?: InputMaybe<Order_By>;
  /** Approval status: DRAFT, PENDING_APPROVAL, APPROVED, REJECTED, SUPERSEDED */
  status?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Master_Slot_Min_Fields = {
  __typename?: 'master_slot_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  organization_address_id?: Maybe<Scalars['uuid']['output']>;
  /** The slot this row acts on. For OVERRIDE, the slot being replaced; for SKIP, the slot being stopped. NULL on ordinary permanent slots. */
  overrides_slot_id?: Maybe<Scalars['uuid']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  /** NULL = a permanent recurring slot. SKIP = a non-delivery that stops overrides_slot_id for the card window. OVERRIDE = a replacement that runs instead of overrides_slot_id for the card window. Action rows always belong to a planning_period. */
  planning_action?: Maybe<Scalars['String']['output']>;
  /** Links to planning_period for temporary slots. NULL = permanent/perpetual slot */
  planning_period_id?: Maybe<Scalars['uuid']['output']>;
  /** FK to product_variation - the product to be delivered in this slot */
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
  /** Delivery quantity for this slot (in litres or unit) */
  quantity?: Maybe<Scalars['numeric']['output']>;
  review_comment?: Maybe<Scalars['String']['output']>;
  reviewed_at?: Maybe<Scalars['timestamptz']['output']>;
  reviewed_by?: Maybe<Scalars['uuid']['output']>;
  /** Self-referential FK to original slot when this is a revision */
  revision_for?: Maybe<Scalars['uuid']['output']>;
  /** Approval status: DRAFT, PENDING_APPROVAL, APPROVED, REJECTED, SUPERSEDED */
  status?: Maybe<Scalars['String']['output']>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "master_slot" */
export type Master_Slot_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_address_id?: InputMaybe<Order_By>;
  /** The slot this row acts on. For OVERRIDE, the slot being replaced; for SKIP, the slot being stopped. NULL on ordinary permanent slots. */
  overrides_slot_id?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  /** NULL = a permanent recurring slot. SKIP = a non-delivery that stops overrides_slot_id for the card window. OVERRIDE = a replacement that runs instead of overrides_slot_id for the card window. Action rows always belong to a planning_period. */
  planning_action?: InputMaybe<Order_By>;
  /** Links to planning_period for temporary slots. NULL = permanent/perpetual slot */
  planning_period_id?: InputMaybe<Order_By>;
  /** FK to product_variation - the product to be delivered in this slot */
  product_variation_id?: InputMaybe<Order_By>;
  /** Delivery quantity for this slot (in litres or unit) */
  quantity?: InputMaybe<Order_By>;
  review_comment?: InputMaybe<Order_By>;
  reviewed_at?: InputMaybe<Order_By>;
  reviewed_by?: InputMaybe<Order_By>;
  /** Self-referential FK to original slot when this is a revision */
  revision_for?: InputMaybe<Order_By>;
  /** Approval status: DRAFT, PENDING_APPROVAL, APPROVED, REJECTED, SUPERSEDED */
  status?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "master_slot" */
export type Master_Slot_Mutation_Response = {
  __typename?: 'master_slot_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Master_Slot>;
};

/** input type for inserting object relation for remote table "master_slot" */
export type Master_Slot_Obj_Rel_Insert_Input = {
  data: Master_Slot_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Master_Slot_On_Conflict>;
};

/** on_conflict condition type for table "master_slot" */
export type Master_Slot_On_Conflict = {
  constraint: Master_Slot_Constraint;
  update_columns?: Array<Master_Slot_Update_Column>;
  where?: InputMaybe<Master_Slot_Bool_Exp>;
};

/** Ordering options when selecting data from "master_slot". */
export type Master_Slot_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<User_Order_By>;
  days_of_week?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_overnight?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  master_slot_pauses_aggregate?: InputMaybe<Master_Slot_Pause_Aggregate_Order_By>;
  modified_by_user?: InputMaybe<User_Order_By>;
  organization_address?: InputMaybe<Organization_Address_Order_By>;
  organization_address_id?: InputMaybe<Order_By>;
  original?: InputMaybe<Master_Slot_Order_By>;
  overrides_slot?: InputMaybe<Master_Slot_Order_By>;
  overrides_slot_id?: InputMaybe<Order_By>;
  overriding_slots_aggregate?: InputMaybe<Master_Slot_Aggregate_Order_By>;
  partner?: InputMaybe<Partner_Order_By>;
  partner_id?: InputMaybe<Order_By>;
  pauses_aggregate?: InputMaybe<Master_Slot_Pause_Aggregate_Order_By>;
  pending_revisions_aggregate?: InputMaybe<Master_Slot_Aggregate_Order_By>;
  planning_action?: InputMaybe<Order_By>;
  planning_period?: InputMaybe<Planning_Period_Order_By>;
  planning_period_id?: InputMaybe<Order_By>;
  product_variation?: InputMaybe<Product_Variation_Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  review_comment?: InputMaybe<Order_By>;
  reviewed_at?: InputMaybe<Order_By>;
  reviewed_by?: InputMaybe<Order_By>;
  reviewer?: InputMaybe<User_Order_By>;
  revision_for?: InputMaybe<Order_By>;
  slot_end_time?: InputMaybe<Order_By>;
  slot_start_time?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  vehicle?: InputMaybe<Vehicle_Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** Date-bounded suspension of a recurring delivery slot. Slot does not run on date D when an active row has pause_from <= D <= pause_until. Resumes implicitly — no scheduled job. */
export type Master_Slot_Pause = {
  __typename?: 'master_slot_pause';
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  created_by_user?: Maybe<User>;
  id: Scalars['uuid']['output'];
  /** False = pause withdrawn / planner resumed early. Rows are never hard-deleted. */
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  masterSlotByMasterSlotIdPartnerId?: Maybe<Master_Slot>;
  /** An object relationship */
  master_slot: Master_Slot;
  master_slot_id: Scalars['uuid']['output'];
  /** An object relationship */
  modified_by_user?: Maybe<User>;
  /** An object relationship */
  partner: Partner;
  partner_id: Scalars['uuid']['output'];
  /** First date the slot is suspended (inclusive) */
  pause_from: Scalars['date']['output'];
  /** Last date the slot is suspended (inclusive). The slot runs again from the next day. */
  pause_until: Scalars['date']['output'];
  /** Free-text note from the planner, e.g. "site shutdown for maintenance" */
  reason?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "master_slot_pause" */
export type Master_Slot_Pause_Aggregate = {
  __typename?: 'master_slot_pause_aggregate';
  aggregate?: Maybe<Master_Slot_Pause_Aggregate_Fields>;
  nodes: Array<Master_Slot_Pause>;
};

export type Master_Slot_Pause_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Master_Slot_Pause_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Master_Slot_Pause_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Master_Slot_Pause_Aggregate_Bool_Exp_Count>;
};

export type Master_Slot_Pause_Aggregate_Bool_Exp_Bool_And = {
  arguments: Master_Slot_Pause_Select_Column_Master_Slot_Pause_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Master_Slot_Pause_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Master_Slot_Pause_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Master_Slot_Pause_Select_Column_Master_Slot_Pause_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Master_Slot_Pause_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Master_Slot_Pause_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Master_Slot_Pause_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Master_Slot_Pause_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "master_slot_pause" */
export type Master_Slot_Pause_Aggregate_Fields = {
  __typename?: 'master_slot_pause_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Master_Slot_Pause_Max_Fields>;
  min?: Maybe<Master_Slot_Pause_Min_Fields>;
};


/** aggregate fields of "master_slot_pause" */
export type Master_Slot_Pause_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Master_Slot_Pause_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "master_slot_pause" */
export type Master_Slot_Pause_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Master_Slot_Pause_Max_Order_By>;
  min?: InputMaybe<Master_Slot_Pause_Min_Order_By>;
};

/** input type for inserting array relation for remote table "master_slot_pause" */
export type Master_Slot_Pause_Arr_Rel_Insert_Input = {
  data: Array<Master_Slot_Pause_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Master_Slot_Pause_On_Conflict>;
};

/** Boolean expression to filter rows from the table "master_slot_pause". All fields are combined with a logical 'AND'. */
export type Master_Slot_Pause_Bool_Exp = {
  _and?: InputMaybe<Array<Master_Slot_Pause_Bool_Exp>>;
  _not?: InputMaybe<Master_Slot_Pause_Bool_Exp>;
  _or?: InputMaybe<Array<Master_Slot_Pause_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  created_by_user?: InputMaybe<User_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  masterSlotByMasterSlotIdPartnerId?: InputMaybe<Master_Slot_Bool_Exp>;
  master_slot?: InputMaybe<Master_Slot_Bool_Exp>;
  master_slot_id?: InputMaybe<Uuid_Comparison_Exp>;
  modified_by_user?: InputMaybe<User_Bool_Exp>;
  partner?: InputMaybe<Partner_Bool_Exp>;
  partner_id?: InputMaybe<Uuid_Comparison_Exp>;
  pause_from?: InputMaybe<Date_Comparison_Exp>;
  pause_until?: InputMaybe<Date_Comparison_Exp>;
  reason?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "master_slot_pause" */
export enum Master_Slot_Pause_Constraint {
  /** unique or primary key constraint on columns "id" */
  MasterSlotPausePkey = 'master_slot_pause_pkey'
}

/** input type for inserting data into table "master_slot_pause" */
export type Master_Slot_Pause_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  created_by_user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** False = pause withdrawn / planner resumed early. Rows are never hard-deleted. */
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  masterSlotByMasterSlotIdPartnerId?: InputMaybe<Master_Slot_Obj_Rel_Insert_Input>;
  master_slot?: InputMaybe<Master_Slot_Obj_Rel_Insert_Input>;
  master_slot_id?: InputMaybe<Scalars['uuid']['input']>;
  modified_by_user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  partner?: InputMaybe<Partner_Obj_Rel_Insert_Input>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  /** First date the slot is suspended (inclusive) */
  pause_from?: InputMaybe<Scalars['date']['input']>;
  /** Last date the slot is suspended (inclusive). The slot runs again from the next day. */
  pause_until?: InputMaybe<Scalars['date']['input']>;
  /** Free-text note from the planner, e.g. "site shutdown for maintenance" */
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Master_Slot_Pause_Max_Fields = {
  __typename?: 'master_slot_pause_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  master_slot_id?: Maybe<Scalars['uuid']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  /** First date the slot is suspended (inclusive) */
  pause_from?: Maybe<Scalars['date']['output']>;
  /** Last date the slot is suspended (inclusive). The slot runs again from the next day. */
  pause_until?: Maybe<Scalars['date']['output']>;
  /** Free-text note from the planner, e.g. "site shutdown for maintenance" */
  reason?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "master_slot_pause" */
export type Master_Slot_Pause_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  master_slot_id?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  /** First date the slot is suspended (inclusive) */
  pause_from?: InputMaybe<Order_By>;
  /** Last date the slot is suspended (inclusive). The slot runs again from the next day. */
  pause_until?: InputMaybe<Order_By>;
  /** Free-text note from the planner, e.g. "site shutdown for maintenance" */
  reason?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Master_Slot_Pause_Min_Fields = {
  __typename?: 'master_slot_pause_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  master_slot_id?: Maybe<Scalars['uuid']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  /** First date the slot is suspended (inclusive) */
  pause_from?: Maybe<Scalars['date']['output']>;
  /** Last date the slot is suspended (inclusive). The slot runs again from the next day. */
  pause_until?: Maybe<Scalars['date']['output']>;
  /** Free-text note from the planner, e.g. "site shutdown for maintenance" */
  reason?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "master_slot_pause" */
export type Master_Slot_Pause_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  master_slot_id?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  /** First date the slot is suspended (inclusive) */
  pause_from?: InputMaybe<Order_By>;
  /** Last date the slot is suspended (inclusive). The slot runs again from the next day. */
  pause_until?: InputMaybe<Order_By>;
  /** Free-text note from the planner, e.g. "site shutdown for maintenance" */
  reason?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "master_slot_pause" */
export type Master_Slot_Pause_Mutation_Response = {
  __typename?: 'master_slot_pause_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Master_Slot_Pause>;
};

/** on_conflict condition type for table "master_slot_pause" */
export type Master_Slot_Pause_On_Conflict = {
  constraint: Master_Slot_Pause_Constraint;
  update_columns?: Array<Master_Slot_Pause_Update_Column>;
  where?: InputMaybe<Master_Slot_Pause_Bool_Exp>;
};

/** Ordering options when selecting data from "master_slot_pause". */
export type Master_Slot_Pause_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<User_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  masterSlotByMasterSlotIdPartnerId?: InputMaybe<Master_Slot_Order_By>;
  master_slot?: InputMaybe<Master_Slot_Order_By>;
  master_slot_id?: InputMaybe<Order_By>;
  modified_by_user?: InputMaybe<User_Order_By>;
  partner?: InputMaybe<Partner_Order_By>;
  partner_id?: InputMaybe<Order_By>;
  pause_from?: InputMaybe<Order_By>;
  pause_until?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
};

/** primary key columns input for table: master_slot_pause */
export type Master_Slot_Pause_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "master_slot_pause" */
export enum Master_Slot_Pause_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  MasterSlotId = 'master_slot_id',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  PauseFrom = 'pause_from',
  /** column name */
  PauseUntil = 'pause_until',
  /** column name */
  Reason = 'reason'
}

/** select "master_slot_pause_aggregate_bool_exp_bool_and_arguments_columns" columns of table "master_slot_pause" */
export enum Master_Slot_Pause_Select_Column_Master_Slot_Pause_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "master_slot_pause_aggregate_bool_exp_bool_or_arguments_columns" columns of table "master_slot_pause" */
export enum Master_Slot_Pause_Select_Column_Master_Slot_Pause_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "master_slot_pause" */
export type Master_Slot_Pause_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** False = pause withdrawn / planner resumed early. Rows are never hard-deleted. */
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  master_slot_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  /** First date the slot is suspended (inclusive) */
  pause_from?: InputMaybe<Scalars['date']['input']>;
  /** Last date the slot is suspended (inclusive). The slot runs again from the next day. */
  pause_until?: InputMaybe<Scalars['date']['input']>;
  /** Free-text note from the planner, e.g. "site shutdown for maintenance" */
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "master_slot_pause" */
export type Master_Slot_Pause_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Master_Slot_Pause_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Master_Slot_Pause_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** False = pause withdrawn / planner resumed early. Rows are never hard-deleted. */
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  master_slot_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  /** First date the slot is suspended (inclusive) */
  pause_from?: InputMaybe<Scalars['date']['input']>;
  /** Last date the slot is suspended (inclusive). The slot runs again from the next day. */
  pause_until?: InputMaybe<Scalars['date']['input']>;
  /** Free-text note from the planner, e.g. "site shutdown for maintenance" */
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "master_slot_pause" */
export enum Master_Slot_Pause_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  MasterSlotId = 'master_slot_id',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  PauseFrom = 'pause_from',
  /** column name */
  PauseUntil = 'pause_until',
  /** column name */
  Reason = 'reason'
}

export type Master_Slot_Pause_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Master_Slot_Pause_Set_Input>;
  /** filter the rows which have to be updated */
  where: Master_Slot_Pause_Bool_Exp;
};

/** primary key columns input for table: master_slot */
export type Master_Slot_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Master_Slot_Prepend_Input = {
  /** JSONB integer array where 0=Sunday, 1=Monday, ..., 6=Saturday. Example: [1,2,3,4,5] for Mon-Fri */
  days_of_week?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "master_slot" */
export enum Master_Slot_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DaysOfWeek = 'days_of_week',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsOvernight = 'is_overnight',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrganizationAddressId = 'organization_address_id',
  /** column name */
  OverridesSlotId = 'overrides_slot_id',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  PlanningAction = 'planning_action',
  /** column name */
  PlanningPeriodId = 'planning_period_id',
  /** column name */
  ProductVariationId = 'product_variation_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  ReviewComment = 'review_comment',
  /** column name */
  ReviewedAt = 'reviewed_at',
  /** column name */
  ReviewedBy = 'reviewed_by',
  /** column name */
  RevisionFor = 'revision_for',
  /** column name */
  SlotEndTime = 'slot_end_time',
  /** column name */
  SlotStartTime = 'slot_start_time',
  /** column name */
  Status = 'status',
  /** column name */
  VehicleId = 'vehicle_id'
}

/** select "master_slot_aggregate_bool_exp_bool_and_arguments_columns" columns of table "master_slot" */
export enum Master_Slot_Select_Column_Master_Slot_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsOvernight = 'is_overnight'
}

/** select "master_slot_aggregate_bool_exp_bool_or_arguments_columns" columns of table "master_slot" */
export enum Master_Slot_Select_Column_Master_Slot_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsOvernight = 'is_overnight'
}

/** input type for updating data in table "master_slot" */
export type Master_Slot_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  /** JSONB integer array where 0=Sunday, 1=Monday, ..., 6=Saturday. Example: [1,2,3,4,5] for Mon-Fri */
  days_of_week?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  /** True if slot crosses midnight */
  is_overnight?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_address_id?: InputMaybe<Scalars['uuid']['input']>;
  /** The slot this row acts on. For OVERRIDE, the slot being replaced; for SKIP, the slot being stopped. NULL on ordinary permanent slots. */
  overrides_slot_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  /** NULL = a permanent recurring slot. SKIP = a non-delivery that stops overrides_slot_id for the card window. OVERRIDE = a replacement that runs instead of overrides_slot_id for the card window. Action rows always belong to a planning_period. */
  planning_action?: InputMaybe<Scalars['String']['input']>;
  /** Links to planning_period for temporary slots. NULL = permanent/perpetual slot */
  planning_period_id?: InputMaybe<Scalars['uuid']['input']>;
  /** FK to product_variation - the product to be delivered in this slot */
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Delivery quantity for this slot (in litres or unit) */
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  review_comment?: InputMaybe<Scalars['String']['input']>;
  reviewed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  reviewed_by?: InputMaybe<Scalars['uuid']['input']>;
  /** Self-referential FK to original slot when this is a revision */
  revision_for?: InputMaybe<Scalars['uuid']['input']>;
  slot_end_time?: InputMaybe<Scalars['time']['input']>;
  slot_start_time?: InputMaybe<Scalars['time']['input']>;
  /** Approval status: DRAFT, PENDING_APPROVAL, APPROVED, REJECTED, SUPERSEDED */
  status?: InputMaybe<Scalars['String']['input']>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Master_Slot_Stddev_Fields = {
  __typename?: 'master_slot_stddev_fields';
  /** Delivery quantity for this slot (in litres or unit) */
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "master_slot" */
export type Master_Slot_Stddev_Order_By = {
  /** Delivery quantity for this slot (in litres or unit) */
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Master_Slot_Stddev_Pop_Fields = {
  __typename?: 'master_slot_stddev_pop_fields';
  /** Delivery quantity for this slot (in litres or unit) */
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "master_slot" */
export type Master_Slot_Stddev_Pop_Order_By = {
  /** Delivery quantity for this slot (in litres or unit) */
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Master_Slot_Stddev_Samp_Fields = {
  __typename?: 'master_slot_stddev_samp_fields';
  /** Delivery quantity for this slot (in litres or unit) */
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "master_slot" */
export type Master_Slot_Stddev_Samp_Order_By = {
  /** Delivery quantity for this slot (in litres or unit) */
  quantity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "master_slot" */
export type Master_Slot_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Master_Slot_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Master_Slot_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  /** JSONB integer array where 0=Sunday, 1=Monday, ..., 6=Saturday. Example: [1,2,3,4,5] for Mon-Fri */
  days_of_week?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  /** True if slot crosses midnight */
  is_overnight?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_address_id?: InputMaybe<Scalars['uuid']['input']>;
  /** The slot this row acts on. For OVERRIDE, the slot being replaced; for SKIP, the slot being stopped. NULL on ordinary permanent slots. */
  overrides_slot_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  /** NULL = a permanent recurring slot. SKIP = a non-delivery that stops overrides_slot_id for the card window. OVERRIDE = a replacement that runs instead of overrides_slot_id for the card window. Action rows always belong to a planning_period. */
  planning_action?: InputMaybe<Scalars['String']['input']>;
  /** Links to planning_period for temporary slots. NULL = permanent/perpetual slot */
  planning_period_id?: InputMaybe<Scalars['uuid']['input']>;
  /** FK to product_variation - the product to be delivered in this slot */
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Delivery quantity for this slot (in litres or unit) */
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  review_comment?: InputMaybe<Scalars['String']['input']>;
  reviewed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  reviewed_by?: InputMaybe<Scalars['uuid']['input']>;
  /** Self-referential FK to original slot when this is a revision */
  revision_for?: InputMaybe<Scalars['uuid']['input']>;
  slot_end_time?: InputMaybe<Scalars['time']['input']>;
  slot_start_time?: InputMaybe<Scalars['time']['input']>;
  /** Approval status: DRAFT, PENDING_APPROVAL, APPROVED, REJECTED, SUPERSEDED */
  status?: InputMaybe<Scalars['String']['input']>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Master_Slot_Sum_Fields = {
  __typename?: 'master_slot_sum_fields';
  /** Delivery quantity for this slot (in litres or unit) */
  quantity?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "master_slot" */
export type Master_Slot_Sum_Order_By = {
  /** Delivery quantity for this slot (in litres or unit) */
  quantity?: InputMaybe<Order_By>;
};

/** update columns of table "master_slot" */
export enum Master_Slot_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DaysOfWeek = 'days_of_week',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsOvernight = 'is_overnight',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrganizationAddressId = 'organization_address_id',
  /** column name */
  OverridesSlotId = 'overrides_slot_id',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  PlanningAction = 'planning_action',
  /** column name */
  PlanningPeriodId = 'planning_period_id',
  /** column name */
  ProductVariationId = 'product_variation_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  ReviewComment = 'review_comment',
  /** column name */
  ReviewedAt = 'reviewed_at',
  /** column name */
  ReviewedBy = 'reviewed_by',
  /** column name */
  RevisionFor = 'revision_for',
  /** column name */
  SlotEndTime = 'slot_end_time',
  /** column name */
  SlotStartTime = 'slot_start_time',
  /** column name */
  Status = 'status',
  /** column name */
  VehicleId = 'vehicle_id'
}

export type Master_Slot_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Master_Slot_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Master_Slot_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Master_Slot_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Master_Slot_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Master_Slot_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Master_Slot_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Master_Slot_Set_Input>;
  /** filter the rows which have to be updated */
  where: Master_Slot_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Master_Slot_Var_Pop_Fields = {
  __typename?: 'master_slot_var_pop_fields';
  /** Delivery quantity for this slot (in litres or unit) */
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "master_slot" */
export type Master_Slot_Var_Pop_Order_By = {
  /** Delivery quantity for this slot (in litres or unit) */
  quantity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Master_Slot_Var_Samp_Fields = {
  __typename?: 'master_slot_var_samp_fields';
  /** Delivery quantity for this slot (in litres or unit) */
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "master_slot" */
export type Master_Slot_Var_Samp_Order_By = {
  /** Delivery quantity for this slot (in litres or unit) */
  quantity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Master_Slot_Variance_Fields = {
  __typename?: 'master_slot_variance_fields';
  /** Delivery quantity for this slot (in litres or unit) */
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "master_slot" */
export type Master_Slot_Variance_Order_By = {
  /** Delivery quantity for this slot (in litres or unit) */
  quantity?: InputMaybe<Order_By>;
};

export type MigrateCustomerToErpInput = {
  organization_id: Scalars['uuid']['input'];
};

export type MigrateCustomerToErpOutput = {
  __typename?: 'migrateCustomerToErpOutput';
  addresses_migrated: Scalars['Int']['output'];
  assets_migrated: Scalars['Int']['output'];
  customer_code?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['jsonb']['output']>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  message: Scalars['String']['output'];
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** Ops review — accept a customer adhoc order, moving items from CONFIRMED to ACCEPTED so they appear in the unassigned queue. */
  acceptCustomerOrder: AcceptCustomerOrderOutput;
  addMissingCustomerOrderCustomerAsset?: Maybe<AddMissingCustomerOrderCustomerAssetOutput>;
  /** Link a user to a business organization and update customer_orgs claims */
  addUserToOrganization?: Maybe<AddUserToOrganizationOutput>;
  /** Link a user to a partner and assign driver/franchise role claims */
  addUserToPartner?: Maybe<AddUserToPartnerOutput>;
  /** Approve daily plan by creating orders and shifts from master_slot templates */
  approveDailyPlan?: Maybe<ApproveDailyPlanOutput>;
  assignTask?: Maybe<AssignTaskOutput>;
  attachedRfidWithCustomerAsset?: Maybe<AttachedRfidWithCustomerAssetOutput>;
  /** execute VOLATILE function "block_wallet_amount" which returns "wallet" */
  block_wallet_amount: Array<Wallet>;
  /** Ops review — cancel a customer adhoc order. reason_id refers to a cancellation_reasons row with reason_type='CUSTOMER_ORDER_OPS_CANCELLATION'. Optional reason_text is stored as free-text notes on the customer_order_cancellation_reasons junction row. Moves order + items to CANCELLED. */
  cancelCustomerOrder: CancelOrderOutput;
  /** Cancel the order before it gets accepted by ops team. */
  cancelOrderByUser?: Maybe<CancelCustomerOrderOutput>;
  /** IDEV-2805: batched invoiced-state check for delivery notes (retrospective department-shift gate) */
  checkDeliveryNotesInvoiced?: Maybe<CheckDeliveryNotesInvoicedOutput>;
  /** Check wallet balance availability for an organization */
  checkWalletAmountExits?: Maybe<CheckWalletAmountExitsOutput>;
  /** Atomic correction of an ADJUSTMENT / MANUAL_CREDIT / REFUND ledger row. Soft-deletes the original, inserts a replacement with the corrected amount (sign-derived type), recomputes wallet.amount. */
  correctLedgerEntry?: Maybe<CorrectLedgerEntryOutput>;
  createAdocCustomerOrder: CreateAdocCustomerOrderOutput;
  createBulkOrder?: Maybe<CreateBulkOrderOutput>;
  createBulkShiftSchedule?: Maybe<CreateBulkShiftScheduleOutput>;
  /** Create Stripe payment link against */
  createCustomerOrder?: Maybe<CustomerOrderOutput>;
  createDeliveryInvoice?: Maybe<CreateDeliveryInvoiceOutput>;
  /** Create Easebuzz payment link against */
  createEasebuzzPaymentLink?: Maybe<CreatePaymentLinkOutput>;
  /** Create GRN (Goods Receipt Note) in ERP from supplier, warehouse and quantity */
  createGrn?: Maybe<CreateGrnOutput>;
  /** Create invoiced item for a customer asset based on task */
  createInvoicedItemForAsset?: Maybe<CreateInvoicedItemForAssetOutput>;
  /** Create or update user in Firebase and database with UAE phone validation */
  createOrUpdateUserFirebase?: Maybe<CreateOrUpdateUserFirebaseResponse>;
  /** Create Stock Entry in ERP for bowser to bowser or upper to lower tank transfers */
  createStockEntry?: Maybe<CreateStockEntryOutput>;
  createTaskFromFranchise?: Maybe<CreateTaskFromFranchiseOutput>;
  createTaskValue?: Maybe<CreateTaskValueOuput>;
  createUser?: Maybe<CreateUserOutput>;
  /** Create base user in Firebase + DB via processSignUp trigger (replaces createUser) */
  createUserRefactored?: Maybe<CreateUserRefactoredOutput>;
  customerOrderSanity?: Maybe<CustomerOrderSanityOutput>;
  /** delete data from the table: "address_subsidiary" */
  delete_address_subsidiary?: Maybe<Address_Subsidiary_Mutation_Response>;
  /** delete data from the table: "address_subsidiary_audit_logs" */
  delete_address_subsidiary_audit_logs?: Maybe<Address_Subsidiary_Audit_Logs_Mutation_Response>;
  /** delete single row from the table: "address_subsidiary_audit_logs" */
  delete_address_subsidiary_audit_logs_by_pk?: Maybe<Address_Subsidiary_Audit_Logs>;
  /** delete single row from the table: "address_subsidiary" */
  delete_address_subsidiary_by_pk?: Maybe<Address_Subsidiary>;
  /** delete data from the table: "address_type" */
  delete_address_type?: Maybe<Address_Type_Mutation_Response>;
  /** delete single row from the table: "address_type" */
  delete_address_type_by_pk?: Maybe<Address_Type>;
  /** delete data from the table: "asset_grouping" */
  delete_asset_grouping?: Maybe<Asset_Grouping_Mutation_Response>;
  /** delete single row from the table: "asset_grouping" */
  delete_asset_grouping_by_pk?: Maybe<Asset_Grouping>;
  /** delete data from the table: "asset_grouping_customer_asset" */
  delete_asset_grouping_customer_asset?: Maybe<Asset_Grouping_Customer_Asset_Mutation_Response>;
  /** delete single row from the table: "asset_grouping_customer_asset" */
  delete_asset_grouping_customer_asset_by_pk?: Maybe<Asset_Grouping_Customer_Asset>;
  /** delete data from the table: "asset_subsidiary" */
  delete_asset_subsidiary?: Maybe<Asset_Subsidiary_Mutation_Response>;
  /** delete data from the table: "asset_subsidiary_audit_logs" */
  delete_asset_subsidiary_audit_logs?: Maybe<Asset_Subsidiary_Audit_Logs_Mutation_Response>;
  /** delete single row from the table: "asset_subsidiary_audit_logs" */
  delete_asset_subsidiary_audit_logs_by_pk?: Maybe<Asset_Subsidiary_Audit_Logs>;
  /** delete single row from the table: "asset_subsidiary" */
  delete_asset_subsidiary_by_pk?: Maybe<Asset_Subsidiary>;
  /** delete data from the table: "asset_type" */
  delete_asset_type?: Maybe<Asset_Type_Mutation_Response>;
  /** delete single row from the table: "asset_type" */
  delete_asset_type_by_pk?: Maybe<Asset_Type>;
  /** delete data from the table: "asset_type_category" */
  delete_asset_type_category?: Maybe<Asset_Type_Category_Mutation_Response>;
  /** delete single row from the table: "asset_type_category" */
  delete_asset_type_category_by_pk?: Maybe<Asset_Type_Category>;
  /** delete data from the table: "associated_type" */
  delete_associated_type?: Maybe<Associated_Type_Mutation_Response>;
  /** delete single row from the table: "associated_type" */
  delete_associated_type_by_pk?: Maybe<Associated_Type>;
  /** delete data from the table: "audit_log_action" */
  delete_audit_log_action?: Maybe<Audit_Log_Action_Mutation_Response>;
  /** delete single row from the table: "audit_log_action" */
  delete_audit_log_action_by_pk?: Maybe<Audit_Log_Action>;
  /** delete data from the table: "cancellation_reasons" */
  delete_cancellation_reasons?: Maybe<Cancellation_Reasons_Mutation_Response>;
  /** delete single row from the table: "cancellation_reasons" */
  delete_cancellation_reasons_by_pk?: Maybe<Cancellation_Reasons>;
  /** delete data from the table: "category" */
  delete_category?: Maybe<Category_Mutation_Response>;
  /** delete single row from the table: "category" */
  delete_category_by_pk?: Maybe<Category>;
  /** delete data from the table: "city" */
  delete_city?: Maybe<City_Mutation_Response>;
  /** delete single row from the table: "city" */
  delete_city_by_pk?: Maybe<City>;
  /** delete data from the table: "country" */
  delete_country?: Maybe<Country_Mutation_Response>;
  /** delete single row from the table: "country" */
  delete_country_by_pk?: Maybe<Country>;
  /** delete data from the table: "credit_breach" */
  delete_credit_breach?: Maybe<Credit_Breach_Mutation_Response>;
  /** delete single row from the table: "credit_breach" */
  delete_credit_breach_by_pk?: Maybe<Credit_Breach>;
  /** delete data from the table: "currency" */
  delete_currency?: Maybe<Currency_Mutation_Response>;
  /** delete single row from the table: "currency" */
  delete_currency_by_pk?: Maybe<Currency>;
  /** delete data from the table: "currency_conversion" */
  delete_currency_conversion?: Maybe<Currency_Conversion_Mutation_Response>;
  /** delete single row from the table: "currency_conversion" */
  delete_currency_conversion_by_pk?: Maybe<Currency_Conversion>;
  /** delete data from the table: "customer_asset" */
  delete_customer_asset?: Maybe<Customer_Asset_Mutation_Response>;
  /** delete data from the table: "customer_asset_audit_log" */
  delete_customer_asset_audit_log?: Maybe<Customer_Asset_Audit_Log_Mutation_Response>;
  /** delete single row from the table: "customer_asset_audit_log" */
  delete_customer_asset_audit_log_by_pk?: Maybe<Customer_Asset_Audit_Log>;
  /** delete single row from the table: "customer_asset" */
  delete_customer_asset_by_pk?: Maybe<Customer_Asset>;
  /** delete data from the table: "customer_asset_device" */
  delete_customer_asset_device?: Maybe<Customer_Asset_Device_Mutation_Response>;
  /** delete single row from the table: "customer_asset_device" */
  delete_customer_asset_device_by_pk?: Maybe<Customer_Asset_Device>;
  /** delete data from the table: "customer_asset_device_calibration" */
  delete_customer_asset_device_calibration?: Maybe<Customer_Asset_Device_Calibration_Mutation_Response>;
  /** delete single row from the table: "customer_asset_device_calibration" */
  delete_customer_asset_device_calibration_by_pk?: Maybe<Customer_Asset_Device_Calibration>;
  /** delete data from the table: "customer_asset_dispensing_rules" */
  delete_customer_asset_dispensing_rules?: Maybe<Customer_Asset_Dispensing_Rules_Mutation_Response>;
  /** delete single row from the table: "customer_asset_dispensing_rules" */
  delete_customer_asset_dispensing_rules_by_pk?: Maybe<Customer_Asset_Dispensing_Rules>;
  /** delete data from the table: "customer_asset_limit" */
  delete_customer_asset_limit?: Maybe<Customer_Asset_Limit_Mutation_Response>;
  /** delete single row from the table: "customer_asset_limit" */
  delete_customer_asset_limit_by_pk?: Maybe<Customer_Asset_Limit>;
  /** delete data from the table: "customer_asset_tag" */
  delete_customer_asset_tag?: Maybe<Customer_Asset_Tag_Mutation_Response>;
  /** delete single row from the table: "customer_asset_tag" */
  delete_customer_asset_tag_by_pk?: Maybe<Customer_Asset_Tag>;
  /** delete data from the table: "customer_order" */
  delete_customer_order?: Maybe<Customer_Order_Mutation_Response>;
  /** delete single row from the table: "customer_order" */
  delete_customer_order_by_pk?: Maybe<Customer_Order>;
  /** delete data from the table: "customer_order_cancellation_reasons" */
  delete_customer_order_cancellation_reasons?: Maybe<Customer_Order_Cancellation_Reasons_Mutation_Response>;
  /** delete single row from the table: "customer_order_cancellation_reasons" */
  delete_customer_order_cancellation_reasons_by_pk?: Maybe<Customer_Order_Cancellation_Reasons>;
  /** delete data from the table: "customer_order_customer_asset" */
  delete_customer_order_customer_asset?: Maybe<Customer_Order_Customer_Asset_Mutation_Response>;
  /** delete single row from the table: "customer_order_customer_asset" */
  delete_customer_order_customer_asset_by_pk?: Maybe<Customer_Order_Customer_Asset>;
  /** delete data from the table: "customer_order_item" */
  delete_customer_order_item?: Maybe<Customer_Order_Item_Mutation_Response>;
  /** delete single row from the table: "customer_order_item" */
  delete_customer_order_item_by_pk?: Maybe<Customer_Order_Item>;
  /** delete data from the table: "customer_order_item_cancellation_reasons" */
  delete_customer_order_item_cancellation_reasons?: Maybe<Customer_Order_Item_Cancellation_Reasons_Mutation_Response>;
  /** delete single row from the table: "customer_order_item_cancellation_reasons" */
  delete_customer_order_item_cancellation_reasons_by_pk?: Maybe<Customer_Order_Item_Cancellation_Reasons>;
  /** delete data from the table: "customer_order_item_comments" */
  delete_customer_order_item_comments?: Maybe<Customer_Order_Item_Comments_Mutation_Response>;
  /** delete single row from the table: "customer_order_item_comments" */
  delete_customer_order_item_comments_by_pk?: Maybe<Customer_Order_Item_Comments>;
  /** delete data from the table: "customer_order_item_commission" */
  delete_customer_order_item_commission?: Maybe<Customer_Order_Item_Commission_Mutation_Response>;
  /** delete single row from the table: "customer_order_item_commission" */
  delete_customer_order_item_commission_by_pk?: Maybe<Customer_Order_Item_Commission>;
  /** delete data from the table: "customer_order_item_etd_transactional_logs" */
  delete_customer_order_item_etd_transactional_logs?: Maybe<Customer_Order_Item_Etd_Transactional_Logs_Mutation_Response>;
  /** delete single row from the table: "customer_order_item_etd_transactional_logs" */
  delete_customer_order_item_etd_transactional_logs_by_pk?: Maybe<Customer_Order_Item_Etd_Transactional_Logs>;
  /** delete data from the table: "customer_order_item_partner" */
  delete_customer_order_item_partner?: Maybe<Customer_Order_Item_Partner_Mutation_Response>;
  /** delete single row from the table: "customer_order_item_partner" */
  delete_customer_order_item_partner_by_pk?: Maybe<Customer_Order_Item_Partner>;
  /** delete data from the table: "customer_order_item_safety_checklist_results" */
  delete_customer_order_item_safety_checklist_results?: Maybe<Customer_Order_Item_Safety_Checklist_Results_Mutation_Response>;
  /** delete single row from the table: "customer_order_item_safety_checklist_results" */
  delete_customer_order_item_safety_checklist_results_by_pk?: Maybe<Customer_Order_Item_Safety_Checklist_Results>;
  /** delete data from the table: "customer_order_item_state" */
  delete_customer_order_item_state?: Maybe<Customer_Order_Item_State_Mutation_Response>;
  /** delete single row from the table: "customer_order_item_state" */
  delete_customer_order_item_state_by_pk?: Maybe<Customer_Order_Item_State>;
  /** delete data from the table: "customer_order_item_stateflow" */
  delete_customer_order_item_stateflow?: Maybe<Customer_Order_Item_Stateflow_Mutation_Response>;
  /** delete single row from the table: "customer_order_item_stateflow" */
  delete_customer_order_item_stateflow_by_pk?: Maybe<Customer_Order_Item_Stateflow>;
  /** delete data from the table: "customer_order_item_test_category" */
  delete_customer_order_item_test_category?: Maybe<Customer_Order_Item_Test_Category_Mutation_Response>;
  /** delete single row from the table: "customer_order_item_test_category" */
  delete_customer_order_item_test_category_by_pk?: Maybe<Customer_Order_Item_Test_Category>;
  /** delete data from the table: "customer_order_item_test_results" */
  delete_customer_order_item_test_results?: Maybe<Customer_Order_Item_Test_Results_Mutation_Response>;
  /** delete single row from the table: "customer_order_item_test_results" */
  delete_customer_order_item_test_results_by_pk?: Maybe<Customer_Order_Item_Test_Results>;
  /** delete data from the table: "customer_order_item_test_results_photos" */
  delete_customer_order_item_test_results_photos?: Maybe<Customer_Order_Item_Test_Results_Photos_Mutation_Response>;
  /** delete single row from the table: "customer_order_item_test_results_photos" */
  delete_customer_order_item_test_results_photos_by_pk?: Maybe<Customer_Order_Item_Test_Results_Photos>;
  /** delete data from the table: "customer_order_organization_user_document" */
  delete_customer_order_organization_user_document?: Maybe<Customer_Order_Organization_User_Document_Mutation_Response>;
  /** delete single row from the table: "customer_order_organization_user_document" */
  delete_customer_order_organization_user_document_by_pk?: Maybe<Customer_Order_Organization_User_Document>;
  /** delete data from the table: "customer_order_partner_order" */
  delete_customer_order_partner_order?: Maybe<Customer_Order_Partner_Order_Mutation_Response>;
  /** delete single row from the table: "customer_order_partner_order" */
  delete_customer_order_partner_order_by_pk?: Maybe<Customer_Order_Partner_Order>;
  /** delete data from the table: "customer_order_slots" */
  delete_customer_order_slots?: Maybe<Customer_Order_Slots_Mutation_Response>;
  /** delete single row from the table: "customer_order_slots" */
  delete_customer_order_slots_by_pk?: Maybe<Customer_Order_Slots>;
  /** delete data from the table: "customer_order_state" */
  delete_customer_order_state?: Maybe<Customer_Order_State_Mutation_Response>;
  /** delete single row from the table: "customer_order_state" */
  delete_customer_order_state_by_pk?: Maybe<Customer_Order_State>;
  /** delete data from the table: "customer_order_stateflow" */
  delete_customer_order_stateflow?: Maybe<Customer_Order_Stateflow_Mutation_Response>;
  /** delete single row from the table: "customer_order_stateflow" */
  delete_customer_order_stateflow_by_pk?: Maybe<Customer_Order_Stateflow>;
  /** delete data from the table: "customer_payment" */
  delete_customer_payment?: Maybe<Customer_Payment_Mutation_Response>;
  /** delete single row from the table: "customer_payment" */
  delete_customer_payment_by_pk?: Maybe<Customer_Payment>;
  /** delete data from the table: "customer_payment_status" */
  delete_customer_payment_status?: Maybe<Customer_Payment_Status_Mutation_Response>;
  /** delete single row from the table: "customer_payment_status" */
  delete_customer_payment_status_by_pk?: Maybe<Customer_Payment_Status>;
  /** delete data from the table: "customer_segmentation" */
  delete_customer_segmentation?: Maybe<Customer_Segmentation_Mutation_Response>;
  /** delete single row from the table: "customer_segmentation" */
  delete_customer_segmentation_by_pk?: Maybe<Customer_Segmentation>;
  /** delete data from the table: "day_type" */
  delete_day_type?: Maybe<Day_Type_Mutation_Response>;
  /** delete single row from the table: "day_type" */
  delete_day_type_by_pk?: Maybe<Day_Type>;
  /** delete data from the table: "delivery_preferences" */
  delete_delivery_preferences?: Maybe<Delivery_Preferences_Mutation_Response>;
  /** delete single row from the table: "delivery_preferences" */
  delete_delivery_preferences_by_pk?: Maybe<Delivery_Preferences>;
  /** delete data from the table: "delivery_scheduler" */
  delete_delivery_scheduler?: Maybe<Delivery_Scheduler_Mutation_Response>;
  /** delete single row from the table: "delivery_scheduler" */
  delete_delivery_scheduler_by_pk?: Maybe<Delivery_Scheduler>;
  /** delete data from the table: "delivery_scheduler_product_item" */
  delete_delivery_scheduler_product_item?: Maybe<Delivery_Scheduler_Product_Item_Mutation_Response>;
  /** delete single row from the table: "delivery_scheduler_product_item" */
  delete_delivery_scheduler_product_item_by_pk?: Maybe<Delivery_Scheduler_Product_Item>;
  /** delete data from the table: "department_retag_request" */
  delete_department_retag_request?: Maybe<Department_Retag_Request_Mutation_Response>;
  /** delete single row from the table: "department_retag_request" */
  delete_department_retag_request_by_pk?: Maybe<Department_Retag_Request>;
  /** delete data from the table: "device_devicetype_paramerter_definition" */
  delete_device_devicetype_paramerter_definition?: Maybe<Device_Devicetype_Paramerter_Definition_Mutation_Response>;
  /** delete single row from the table: "device_devicetype_paramerter_definition" */
  delete_device_devicetype_paramerter_definition_by_pk?: Maybe<Device_Devicetype_Paramerter_Definition>;
  /** delete data from the table: "devicetype" */
  delete_devicetype?: Maybe<Devicetype_Mutation_Response>;
  /** delete single row from the table: "devicetype" */
  delete_devicetype_by_pk?: Maybe<Devicetype>;
  /** delete data from the table: "devicetype_paramerter_definition" */
  delete_devicetype_paramerter_definition?: Maybe<Devicetype_Paramerter_Definition_Mutation_Response>;
  /** delete single row from the table: "devicetype_paramerter_definition" */
  delete_devicetype_paramerter_definition_by_pk?: Maybe<Devicetype_Paramerter_Definition>;
  /** delete data from the table: "devicetype_parameter_group" */
  delete_devicetype_parameter_group?: Maybe<Devicetype_Parameter_Group_Mutation_Response>;
  /** delete single row from the table: "devicetype_parameter_group" */
  delete_devicetype_parameter_group_by_pk?: Maybe<Devicetype_Parameter_Group>;
  /** delete data from the table: "discount_type" */
  delete_discount_type?: Maybe<Discount_Type_Mutation_Response>;
  /** delete single row from the table: "discount_type" */
  delete_discount_type_by_pk?: Maybe<Discount_Type>;
  /** delete data from the table: "dispenser" */
  delete_dispenser?: Maybe<Dispenser_Mutation_Response>;
  /** delete single row from the table: "dispenser" */
  delete_dispenser_by_pk?: Maybe<Dispenser>;
  /** delete data from the table: "dispenser_configuration" */
  delete_dispenser_configuration?: Maybe<Dispenser_Configuration_Mutation_Response>;
  /** delete single row from the table: "dispenser_configuration" */
  delete_dispenser_configuration_by_pk?: Maybe<Dispenser_Configuration>;
  /** delete data from the table: "dispenser_type" */
  delete_dispenser_type?: Maybe<Dispenser_Type_Mutation_Response>;
  /** delete single row from the table: "dispenser_type" */
  delete_dispenser_type_by_pk?: Maybe<Dispenser_Type>;
  /** delete data from the table: "dispensing_rules" */
  delete_dispensing_rules?: Maybe<Dispensing_Rules_Mutation_Response>;
  /** delete single row from the table: "dispensing_rules" */
  delete_dispensing_rules_by_pk?: Maybe<Dispensing_Rules>;
  /** delete data from the table: "document_type" */
  delete_document_type?: Maybe<Document_Type_Mutation_Response>;
  /** delete single row from the table: "document_type" */
  delete_document_type_by_pk?: Maybe<Document_Type>;
  /** delete data from the table: "document_type_category" */
  delete_document_type_category?: Maybe<Document_Type_Category_Mutation_Response>;
  /** delete single row from the table: "document_type_category" */
  delete_document_type_category_by_pk?: Maybe<Document_Type_Category>;
  /** delete data from the table: "documents" */
  delete_documents?: Maybe<Documents_Mutation_Response>;
  /** delete single row from the table: "documents" */
  delete_documents_by_pk?: Maybe<Documents>;
  /** delete data from the table: "driver_duty_log" */
  delete_driver_duty_log?: Maybe<Driver_Duty_Log_Mutation_Response>;
  /** delete single row from the table: "driver_duty_log" */
  delete_driver_duty_log_by_pk?: Maybe<Driver_Duty_Log>;
  /** delete data from the table: "driver_duty_photos" */
  delete_driver_duty_photos?: Maybe<Driver_Duty_Photos_Mutation_Response>;
  /** delete single row from the table: "driver_duty_photos" */
  delete_driver_duty_photos_by_pk?: Maybe<Driver_Duty_Photos>;
  /** delete data from the table: "driver_permit" */
  delete_driver_permit?: Maybe<Driver_Permit_Mutation_Response>;
  /** delete single row from the table: "driver_permit" */
  delete_driver_permit_by_pk?: Maybe<Driver_Permit>;
  /** delete data from the table: "driver_vehicle" */
  delete_driver_vehicle?: Maybe<Driver_Vehicle_Mutation_Response>;
  /** delete single row from the table: "driver_vehicle" */
  delete_driver_vehicle_by_pk?: Maybe<Driver_Vehicle>;
  /** delete data from the table: "driver_vehicle_issue" */
  delete_driver_vehicle_issue?: Maybe<Driver_Vehicle_Issue_Mutation_Response>;
  /** delete single row from the table: "driver_vehicle_issue" */
  delete_driver_vehicle_issue_by_pk?: Maybe<Driver_Vehicle_Issue>;
  /** delete data from the table: "driver_vehicle_location" */
  delete_driver_vehicle_location?: Maybe<Driver_Vehicle_Location_Mutation_Response>;
  /** delete single row from the table: "driver_vehicle_location" */
  delete_driver_vehicle_location_by_pk?: Maybe<Driver_Vehicle_Location>;
  /** delete data from the table: "erp_sync_status" */
  delete_erp_sync_status?: Maybe<Erp_Sync_Status_Mutation_Response>;
  /** delete single row from the table: "erp_sync_status" */
  delete_erp_sync_status_by_pk?: Maybe<Erp_Sync_Status>;
  /** delete data from the table: "fillup_request" */
  delete_fillup_request?: Maybe<Fillup_Request_Mutation_Response>;
  /** delete single row from the table: "fillup_request" */
  delete_fillup_request_by_pk?: Maybe<Fillup_Request>;
  /** delete data from the table: "fillup_request_status" */
  delete_fillup_request_status?: Maybe<Fillup_Request_Status_Mutation_Response>;
  /** delete single row from the table: "fillup_request_status" */
  delete_fillup_request_status_by_pk?: Maybe<Fillup_Request_Status>;
  /** delete data from the table: "fuel_request_type" */
  delete_fuel_request_type?: Maybe<Fuel_Request_Type_Mutation_Response>;
  /** delete single row from the table: "fuel_request_type" */
  delete_fuel_request_type_by_pk?: Maybe<Fuel_Request_Type>;
  /** delete data from the table: "fueltrans_transaction_logs" */
  delete_fueltrans_transaction_logs?: Maybe<Fueltrans_Transaction_Logs_Mutation_Response>;
  /** delete single row from the table: "fueltrans_transaction_logs" */
  delete_fueltrans_transaction_logs_by_pk?: Maybe<Fueltrans_Transaction_Logs>;
  /** delete data from the table: "geometry_columns" */
  delete_geometry_columns?: Maybe<Geometry_Columns_Mutation_Response>;
  /** delete data from the table: "inventory" */
  delete_inventory?: Maybe<Inventory_Mutation_Response>;
  /** delete single row from the table: "inventory" */
  delete_inventory_by_pk?: Maybe<Inventory>;
  /** delete data from the table: "inventory_workflow_logs" */
  delete_inventory_workflow_logs?: Maybe<Inventory_Workflow_Logs_Mutation_Response>;
  /** delete single row from the table: "inventory_workflow_logs" */
  delete_inventory_workflow_logs_by_pk?: Maybe<Inventory_Workflow_Logs>;
  /** delete data from the table: "invitation" */
  delete_invitation?: Maybe<Invitation_Mutation_Response>;
  /** delete single row from the table: "invitation" */
  delete_invitation_by_pk?: Maybe<Invitation>;
  /** delete data from the table: "invitation_status" */
  delete_invitation_status?: Maybe<Invitation_Status_Mutation_Response>;
  /** delete single row from the table: "invitation_status" */
  delete_invitation_status_by_pk?: Maybe<Invitation_Status>;
  /** delete data from the table: "invoice" */
  delete_invoice?: Maybe<Invoice_Mutation_Response>;
  /** delete single row from the table: "invoice" */
  delete_invoice_by_pk?: Maybe<Invoice>;
  /** delete data from the table: "invoiced_item" */
  delete_invoiced_item?: Maybe<Invoiced_Item_Mutation_Response>;
  /** delete single row from the table: "invoiced_item" */
  delete_invoiced_item_by_pk?: Maybe<Invoiced_Item>;
  /** delete data from the table: "invoiced_item_cancellation_ticket_states" */
  delete_invoiced_item_cancellation_ticket_states?: Maybe<Invoiced_Item_Cancellation_Ticket_States_Mutation_Response>;
  /** delete single row from the table: "invoiced_item_cancellation_ticket_states" */
  delete_invoiced_item_cancellation_ticket_states_by_pk?: Maybe<Invoiced_Item_Cancellation_Ticket_States>;
  /** delete data from the table: "invoiced_item_cancellation_tickets" */
  delete_invoiced_item_cancellation_tickets?: Maybe<Invoiced_Item_Cancellation_Tickets_Mutation_Response>;
  /** delete single row from the table: "invoiced_item_cancellation_tickets" */
  delete_invoiced_item_cancellation_tickets_by_pk?: Maybe<Invoiced_Item_Cancellation_Tickets>;
  /** delete data from the table: "issue" */
  delete_issue?: Maybe<Issue_Mutation_Response>;
  /** delete single row from the table: "issue" */
  delete_issue_by_pk?: Maybe<Issue>;
  /** delete data from the table: "job_state" */
  delete_job_state?: Maybe<Job_State_Mutation_Response>;
  /** delete single row from the table: "job_state" */
  delete_job_state_by_pk?: Maybe<Job_State>;
  /** delete data from the table: "job_type" */
  delete_job_type?: Maybe<Job_Type_Mutation_Response>;
  /** delete single row from the table: "job_type" */
  delete_job_type_by_pk?: Maybe<Job_Type>;
  /** delete data from the table: "job_type_template" */
  delete_job_type_template?: Maybe<Job_Type_Template_Mutation_Response>;
  /** delete single row from the table: "job_type_template" */
  delete_job_type_template_by_pk?: Maybe<Job_Type_Template>;
  /** delete data from the table: "jobs" */
  delete_jobs?: Maybe<Jobs_Mutation_Response>;
  /** delete single row from the table: "jobs" */
  delete_jobs_by_pk?: Maybe<Jobs>;
  /** delete data from the table: "jobs_state_flow" */
  delete_jobs_state_flow?: Maybe<Jobs_State_Flow_Mutation_Response>;
  /** delete single row from the table: "jobs_state_flow" */
  delete_jobs_state_flow_by_pk?: Maybe<Jobs_State_Flow>;
  /** delete data from the table: "limit_purchase_order" */
  delete_limit_purchase_order?: Maybe<Limit_Purchase_Order_Mutation_Response>;
  /** delete single row from the table: "limit_purchase_order" */
  delete_limit_purchase_order_by_pk?: Maybe<Limit_Purchase_Order>;
  /** delete data from the table: "limit_purchase_order_logs" */
  delete_limit_purchase_order_logs?: Maybe<Limit_Purchase_Order_Logs_Mutation_Response>;
  /** delete single row from the table: "limit_purchase_order_logs" */
  delete_limit_purchase_order_logs_by_pk?: Maybe<Limit_Purchase_Order_Logs>;
  /** delete data from the table: "localities" */
  delete_localities?: Maybe<Localities_Mutation_Response>;
  /** delete single row from the table: "localities" */
  delete_localities_by_pk?: Maybe<Localities>;
  /** delete data from the table: "login_type" */
  delete_login_type?: Maybe<Login_Type_Mutation_Response>;
  /** delete single row from the table: "login_type" */
  delete_login_type_by_pk?: Maybe<Login_Type>;
  /** delete data from the table: "lpo_exception" */
  delete_lpo_exception?: Maybe<Lpo_Exception_Mutation_Response>;
  /** delete single row from the table: "lpo_exception" */
  delete_lpo_exception_by_pk?: Maybe<Lpo_Exception>;
  /** delete data from the table: "master_slot" */
  delete_master_slot?: Maybe<Master_Slot_Mutation_Response>;
  /** delete single row from the table: "master_slot" */
  delete_master_slot_by_pk?: Maybe<Master_Slot>;
  /** delete data from the table: "master_slot_pause" */
  delete_master_slot_pause?: Maybe<Master_Slot_Pause_Mutation_Response>;
  /** delete single row from the table: "master_slot_pause" */
  delete_master_slot_pause_by_pk?: Maybe<Master_Slot_Pause>;
  /** delete data from the table: "omc_type" */
  delete_omc_type?: Maybe<Omc_Type_Mutation_Response>;
  /** delete single row from the table: "omc_type" */
  delete_omc_type_by_pk?: Maybe<Omc_Type>;
  /** delete data from the table: "order_photos" */
  delete_order_photos?: Maybe<Order_Photos_Mutation_Response>;
  /** delete single row from the table: "order_photos" */
  delete_order_photos_by_pk?: Maybe<Order_Photos>;
  /** delete data from the table: "order_scheduler" */
  delete_order_scheduler?: Maybe<Order_Scheduler_Mutation_Response>;
  /** delete single row from the table: "order_scheduler" */
  delete_order_scheduler_by_pk?: Maybe<Order_Scheduler>;
  /** delete data from the table: "order_scheduler_customer_asset" */
  delete_order_scheduler_customer_asset?: Maybe<Order_Scheduler_Customer_Asset_Mutation_Response>;
  /** delete single row from the table: "order_scheduler_customer_asset" */
  delete_order_scheduler_customer_asset_by_pk?: Maybe<Order_Scheduler_Customer_Asset>;
  /** delete data from the table: "order_scheduler_daily_frequency" */
  delete_order_scheduler_daily_frequency?: Maybe<Order_Scheduler_Daily_Frequency_Mutation_Response>;
  /** delete single row from the table: "order_scheduler_daily_frequency" */
  delete_order_scheduler_daily_frequency_by_pk?: Maybe<Order_Scheduler_Daily_Frequency>;
  /** delete data from the table: "order_type" */
  delete_order_type?: Maybe<Order_Type_Mutation_Response>;
  /** delete single row from the table: "order_type" */
  delete_order_type_by_pk?: Maybe<Order_Type>;
  /** delete data from the table: "organization" */
  delete_organization?: Maybe<Organization_Mutation_Response>;
  /** delete data from the table: "organization_address" */
  delete_organization_address?: Maybe<Organization_Address_Mutation_Response>;
  /** delete single row from the table: "organization_address" */
  delete_organization_address_by_pk?: Maybe<Organization_Address>;
  /** delete data from the table: "organization_audit_log" */
  delete_organization_audit_log?: Maybe<Organization_Audit_Log_Mutation_Response>;
  /** delete single row from the table: "organization_audit_log" */
  delete_organization_audit_log_by_pk?: Maybe<Organization_Audit_Log>;
  /** delete single row from the table: "organization" */
  delete_organization_by_pk?: Maybe<Organization>;
  /** delete data from the table: "organization_commission_product_variation_type" */
  delete_organization_commission_product_variation_type?: Maybe<Organization_Commission_Product_Variation_Type_Mutation_Response>;
  /** delete single row from the table: "organization_commission_product_variation_type" */
  delete_organization_commission_product_variation_type_by_pk?: Maybe<Organization_Commission_Product_Variation_Type>;
  /** delete data from the table: "organization_configuration" */
  delete_organization_configuration?: Maybe<Organization_Configuration_Mutation_Response>;
  /** delete single row from the table: "organization_configuration" */
  delete_organization_configuration_by_pk?: Maybe<Organization_Configuration>;
  /** delete data from the table: "organization_product_variation_discount" */
  delete_organization_product_variation_discount?: Maybe<Organization_Product_Variation_Discount_Mutation_Response>;
  /** delete single row from the table: "organization_product_variation_discount" */
  delete_organization_product_variation_discount_by_pk?: Maybe<Organization_Product_Variation_Discount>;
  /** delete data from the table: "organization_product_variation_discount_history" */
  delete_organization_product_variation_discount_history?: Maybe<Organization_Product_Variation_Discount_History_Mutation_Response>;
  /** delete single row from the table: "organization_product_variation_discount_history" */
  delete_organization_product_variation_discount_history_by_pk?: Maybe<Organization_Product_Variation_Discount_History>;
  /** delete data from the table: "organization_sales_projection" */
  delete_organization_sales_projection?: Maybe<Organization_Sales_Projection_Mutation_Response>;
  /** delete single row from the table: "organization_sales_projection" */
  delete_organization_sales_projection_by_pk?: Maybe<Organization_Sales_Projection>;
  /** delete data from the table: "organization_timing" */
  delete_organization_timing?: Maybe<Organization_Timing_Mutation_Response>;
  /** delete single row from the table: "organization_timing" */
  delete_organization_timing_by_pk?: Maybe<Organization_Timing>;
  /** delete data from the table: "organization_type" */
  delete_organization_type?: Maybe<Organization_Type_Mutation_Response>;
  /** delete single row from the table: "organization_type" */
  delete_organization_type_by_pk?: Maybe<Organization_Type>;
  /** delete data from the table: "organization_user" */
  delete_organization_user?: Maybe<Organization_User_Mutation_Response>;
  /** delete single row from the table: "organization_user" */
  delete_organization_user_by_pk?: Maybe<Organization_User>;
  /** delete data from the table: "organization_user_commission" */
  delete_organization_user_commission?: Maybe<Organization_User_Commission_Mutation_Response>;
  /** delete single row from the table: "organization_user_commission" */
  delete_organization_user_commission_by_pk?: Maybe<Organization_User_Commission>;
  /** delete data from the table: "organization_user_document" */
  delete_organization_user_document?: Maybe<Organization_User_Document_Mutation_Response>;
  /** delete single row from the table: "organization_user_document" */
  delete_organization_user_document_by_pk?: Maybe<Organization_User_Document>;
  /** delete data from the table: "organization_user_permission" */
  delete_organization_user_permission?: Maybe<Organization_User_Permission_Mutation_Response>;
  /** delete single row from the table: "organization_user_permission" */
  delete_organization_user_permission_by_pk?: Maybe<Organization_User_Permission>;
  /** delete data from the table: "organization_user_subsidiary" */
  delete_organization_user_subsidiary?: Maybe<Organization_User_Subsidiary_Mutation_Response>;
  /** delete single row from the table: "organization_user_subsidiary" */
  delete_organization_user_subsidiary_by_pk?: Maybe<Organization_User_Subsidiary>;
  /** delete data from the table: "organization_user_type" */
  delete_organization_user_type?: Maybe<Organization_User_Type_Mutation_Response>;
  /** delete single row from the table: "organization_user_type" */
  delete_organization_user_type_by_pk?: Maybe<Organization_User_Type>;
  /** delete data from the table: "ownership_type" */
  delete_ownership_type?: Maybe<Ownership_Type_Mutation_Response>;
  /** delete single row from the table: "ownership_type" */
  delete_ownership_type_by_pk?: Maybe<Ownership_Type>;
  /** delete data from the table: "partner" */
  delete_partner?: Maybe<Partner_Mutation_Response>;
  /** delete data from the table: "partner_address" */
  delete_partner_address?: Maybe<Partner_Address_Mutation_Response>;
  /** delete single row from the table: "partner_address" */
  delete_partner_address_by_pk?: Maybe<Partner_Address>;
  /** delete data from the table: "partner_bank_details" */
  delete_partner_bank_details?: Maybe<Partner_Bank_Details_Mutation_Response>;
  /** delete single row from the table: "partner_bank_details" */
  delete_partner_bank_details_by_pk?: Maybe<Partner_Bank_Details>;
  /** delete single row from the table: "partner" */
  delete_partner_by_pk?: Maybe<Partner>;
  /** delete data from the table: "partner_commission" */
  delete_partner_commission?: Maybe<Partner_Commission_Mutation_Response>;
  /** delete single row from the table: "partner_commission" */
  delete_partner_commission_by_pk?: Maybe<Partner_Commission>;
  /** delete data from the table: "partner_commission_product_variation_type" */
  delete_partner_commission_product_variation_type?: Maybe<Partner_Commission_Product_Variation_Type_Mutation_Response>;
  /** delete single row from the table: "partner_commission_product_variation_type" */
  delete_partner_commission_product_variation_type_by_pk?: Maybe<Partner_Commission_Product_Variation_Type>;
  /** delete data from the table: "partner_contact_type" */
  delete_partner_contact_type?: Maybe<Partner_Contact_Type_Mutation_Response>;
  /** delete single row from the table: "partner_contact_type" */
  delete_partner_contact_type_by_pk?: Maybe<Partner_Contact_Type>;
  /** delete data from the table: "partner_localities" */
  delete_partner_localities?: Maybe<Partner_Localities_Mutation_Response>;
  /** delete single row from the table: "partner_localities" */
  delete_partner_localities_by_pk?: Maybe<Partner_Localities>;
  /** delete data from the table: "partner_localities_slots" */
  delete_partner_localities_slots?: Maybe<Partner_Localities_Slots_Mutation_Response>;
  /** delete single row from the table: "partner_localities_slots" */
  delete_partner_localities_slots_by_pk?: Maybe<Partner_Localities_Slots>;
  /** delete data from the table: "partner_order" */
  delete_partner_order?: Maybe<Partner_Order_Mutation_Response>;
  /** delete single row from the table: "partner_order" */
  delete_partner_order_by_pk?: Maybe<Partner_Order>;
  /** delete data from the table: "partner_order_customer_asset" */
  delete_partner_order_customer_asset?: Maybe<Partner_Order_Customer_Asset_Mutation_Response>;
  /** delete single row from the table: "partner_order_customer_asset" */
  delete_partner_order_customer_asset_by_pk?: Maybe<Partner_Order_Customer_Asset>;
  /** delete data from the table: "partner_order_item" */
  delete_partner_order_item?: Maybe<Partner_Order_Item_Mutation_Response>;
  /** delete single row from the table: "partner_order_item" */
  delete_partner_order_item_by_pk?: Maybe<Partner_Order_Item>;
  /** delete data from the table: "partner_order_item_commission" */
  delete_partner_order_item_commission?: Maybe<Partner_Order_Item_Commission_Mutation_Response>;
  /** delete single row from the table: "partner_order_item_commission" */
  delete_partner_order_item_commission_by_pk?: Maybe<Partner_Order_Item_Commission>;
  /** delete data from the table: "partner_order_item_state" */
  delete_partner_order_item_state?: Maybe<Partner_Order_Item_State_Mutation_Response>;
  /** delete single row from the table: "partner_order_item_state" */
  delete_partner_order_item_state_by_pk?: Maybe<Partner_Order_Item_State>;
  /** delete data from the table: "partner_order_item_stateflow" */
  delete_partner_order_item_stateflow?: Maybe<Partner_Order_Item_Stateflow_Mutation_Response>;
  /** delete single row from the table: "partner_order_item_stateflow" */
  delete_partner_order_item_stateflow_by_pk?: Maybe<Partner_Order_Item_Stateflow>;
  /** delete data from the table: "partner_order_item_test_category" */
  delete_partner_order_item_test_category?: Maybe<Partner_Order_Item_Test_Category_Mutation_Response>;
  /** delete single row from the table: "partner_order_item_test_category" */
  delete_partner_order_item_test_category_by_pk?: Maybe<Partner_Order_Item_Test_Category>;
  /** delete data from the table: "partner_order_item_test_results" */
  delete_partner_order_item_test_results?: Maybe<Partner_Order_Item_Test_Results_Mutation_Response>;
  /** delete single row from the table: "partner_order_item_test_results" */
  delete_partner_order_item_test_results_by_pk?: Maybe<Partner_Order_Item_Test_Results>;
  /** delete data from the table: "partner_order_item_test_results_photos" */
  delete_partner_order_item_test_results_photos?: Maybe<Partner_Order_Item_Test_Results_Photos_Mutation_Response>;
  /** delete single row from the table: "partner_order_item_test_results_photos" */
  delete_partner_order_item_test_results_photos_by_pk?: Maybe<Partner_Order_Item_Test_Results_Photos>;
  /** delete data from the table: "partner_order_item_value" */
  delete_partner_order_item_value?: Maybe<Partner_Order_Item_Value_Mutation_Response>;
  /** delete single row from the table: "partner_order_item_value" */
  delete_partner_order_item_value_by_pk?: Maybe<Partner_Order_Item_Value>;
  /** delete data from the table: "partner_order_partner_user_document" */
  delete_partner_order_partner_user_document?: Maybe<Partner_Order_Partner_User_Document_Mutation_Response>;
  /** delete single row from the table: "partner_order_partner_user_document" */
  delete_partner_order_partner_user_document_by_pk?: Maybe<Partner_Order_Partner_User_Document>;
  /** delete data from the table: "partner_order_state" */
  delete_partner_order_state?: Maybe<Partner_Order_State_Mutation_Response>;
  /** delete single row from the table: "partner_order_state" */
  delete_partner_order_state_by_pk?: Maybe<Partner_Order_State>;
  /** delete data from the table: "partner_order_stateflow" */
  delete_partner_order_stateflow?: Maybe<Partner_Order_Stateflow_Mutation_Response>;
  /** delete single row from the table: "partner_order_stateflow" */
  delete_partner_order_stateflow_by_pk?: Maybe<Partner_Order_Stateflow>;
  /** delete data from the table: "partner_payment" */
  delete_partner_payment?: Maybe<Partner_Payment_Mutation_Response>;
  /** delete single row from the table: "partner_payment" */
  delete_partner_payment_by_pk?: Maybe<Partner_Payment>;
  /** delete data from the table: "partner_product" */
  delete_partner_product?: Maybe<Partner_Product_Mutation_Response>;
  /** delete single row from the table: "partner_product" */
  delete_partner_product_by_pk?: Maybe<Partner_Product>;
  /** delete data from the table: "partner_relationship" */
  delete_partner_relationship?: Maybe<Partner_Relationship_Mutation_Response>;
  /** delete single row from the table: "partner_relationship" */
  delete_partner_relationship_by_pk?: Maybe<Partner_Relationship>;
  /** delete data from the table: "partner_seller" */
  delete_partner_seller?: Maybe<Partner_Seller_Mutation_Response>;
  /** delete single row from the table: "partner_seller" */
  delete_partner_seller_by_pk?: Maybe<Partner_Seller>;
  /** delete data from the table: "partner_seller_type" */
  delete_partner_seller_type?: Maybe<Partner_Seller_Type_Mutation_Response>;
  /** delete single row from the table: "partner_seller_type" */
  delete_partner_seller_type_by_pk?: Maybe<Partner_Seller_Type>;
  /** delete data from the table: "partner_signing_authority" */
  delete_partner_signing_authority?: Maybe<Partner_Signing_Authority_Mutation_Response>;
  /** delete single row from the table: "partner_signing_authority" */
  delete_partner_signing_authority_by_pk?: Maybe<Partner_Signing_Authority>;
  /** delete data from the table: "partner_timing" */
  delete_partner_timing?: Maybe<Partner_Timing_Mutation_Response>;
  /** delete single row from the table: "partner_timing" */
  delete_partner_timing_by_pk?: Maybe<Partner_Timing>;
  /** delete data from the table: "partner_type" */
  delete_partner_type?: Maybe<Partner_Type_Mutation_Response>;
  /** delete single row from the table: "partner_type" */
  delete_partner_type_by_pk?: Maybe<Partner_Type>;
  /** delete data from the table: "partner_user" */
  delete_partner_user?: Maybe<Partner_User_Mutation_Response>;
  /** delete single row from the table: "partner_user" */
  delete_partner_user_by_pk?: Maybe<Partner_User>;
  /** delete data from the table: "partner_user_document" */
  delete_partner_user_document?: Maybe<Partner_User_Document_Mutation_Response>;
  /** delete single row from the table: "partner_user_document" */
  delete_partner_user_document_by_pk?: Maybe<Partner_User_Document>;
  /** delete data from the table: "partner_user_permission" */
  delete_partner_user_permission?: Maybe<Partner_User_Permission_Mutation_Response>;
  /** delete single row from the table: "partner_user_permission" */
  delete_partner_user_permission_by_pk?: Maybe<Partner_User_Permission>;
  /** delete data from the table: "partner_vehicle" */
  delete_partner_vehicle?: Maybe<Partner_Vehicle_Mutation_Response>;
  /** delete single row from the table: "partner_vehicle" */
  delete_partner_vehicle_by_pk?: Maybe<Partner_Vehicle>;
  /** delete data from the table: "partner_vehicle_state" */
  delete_partner_vehicle_state?: Maybe<Partner_Vehicle_State_Mutation_Response>;
  /** delete single row from the table: "partner_vehicle_state" */
  delete_partner_vehicle_state_by_pk?: Maybe<Partner_Vehicle_State>;
  /** delete data from the table: "payment_type" */
  delete_payment_type?: Maybe<Payment_Type_Mutation_Response>;
  /** delete single row from the table: "payment_type" */
  delete_payment_type_by_pk?: Maybe<Payment_Type>;
  /** delete data from the table: "period_frequency" */
  delete_period_frequency?: Maybe<Period_Frequency_Mutation_Response>;
  /** delete single row from the table: "period_frequency" */
  delete_period_frequency_by_pk?: Maybe<Period_Frequency>;
  /** delete data from the table: "permission" */
  delete_permission?: Maybe<Permission_Mutation_Response>;
  /** delete single row from the table: "permission" */
  delete_permission_by_pk?: Maybe<Permission>;
  /** delete data from the table: "permit" */
  delete_permit?: Maybe<Permit_Mutation_Response>;
  /** delete single row from the table: "permit" */
  delete_permit_by_pk?: Maybe<Permit>;
  /** delete data from the table: "photo_type" */
  delete_photo_type?: Maybe<Photo_Type_Mutation_Response>;
  /** delete single row from the table: "photo_type" */
  delete_photo_type_by_pk?: Maybe<Photo_Type>;
  /** delete data from the table: "planning_audit_log" */
  delete_planning_audit_log?: Maybe<Planning_Audit_Log_Mutation_Response>;
  /** delete single row from the table: "planning_audit_log" */
  delete_planning_audit_log_by_pk?: Maybe<Planning_Audit_Log>;
  /** delete data from the table: "planning_period" */
  delete_planning_period?: Maybe<Planning_Period_Mutation_Response>;
  /** delete single row from the table: "planning_period" */
  delete_planning_period_by_pk?: Maybe<Planning_Period>;
  /** delete data from the table: "product" */
  delete_product?: Maybe<Product_Mutation_Response>;
  /** delete single row from the table: "product" */
  delete_product_by_pk?: Maybe<Product>;
  /** delete data from the table: "product_commission" */
  delete_product_commission?: Maybe<Product_Commission_Mutation_Response>;
  /** delete single row from the table: "product_commission" */
  delete_product_commission_by_pk?: Maybe<Product_Commission>;
  /** delete data from the table: "product_document" */
  delete_product_document?: Maybe<Product_Document_Mutation_Response>;
  /** delete single row from the table: "product_document" */
  delete_product_document_by_pk?: Maybe<Product_Document>;
  /** delete data from the table: "product_partner_localities_price" */
  delete_product_partner_localities_price?: Maybe<Product_Partner_Localities_Price_Mutation_Response>;
  /** delete single row from the table: "product_partner_localities_price" */
  delete_product_partner_localities_price_by_pk?: Maybe<Product_Partner_Localities_Price>;
  /** delete data from the table: "product_partner_localities_price_history" */
  delete_product_partner_localities_price_history?: Maybe<Product_Partner_Localities_Price_History_Mutation_Response>;
  /** delete single row from the table: "product_partner_localities_price_history" */
  delete_product_partner_localities_price_history_by_pk?: Maybe<Product_Partner_Localities_Price_History>;
  /** delete data from the table: "product_photos" */
  delete_product_photos?: Maybe<Product_Photos_Mutation_Response>;
  /** delete single row from the table: "product_photos" */
  delete_product_photos_by_pk?: Maybe<Product_Photos>;
  /** delete data from the table: "product_type" */
  delete_product_type?: Maybe<Product_Type_Mutation_Response>;
  /** delete single row from the table: "product_type" */
  delete_product_type_by_pk?: Maybe<Product_Type>;
  /** delete data from the table: "product_variation" */
  delete_product_variation?: Maybe<Product_Variation_Mutation_Response>;
  /** delete single row from the table: "product_variation" */
  delete_product_variation_by_pk?: Maybe<Product_Variation>;
  /** delete data from the table: "product_variation_partner_localities_slots" */
  delete_product_variation_partner_localities_slots?: Maybe<Product_Variation_Partner_Localities_Slots_Mutation_Response>;
  /** delete single row from the table: "product_variation_partner_localities_slots" */
  delete_product_variation_partner_localities_slots_by_pk?: Maybe<Product_Variation_Partner_Localities_Slots>;
  /** delete data from the table: "product_variation_photos" */
  delete_product_variation_photos?: Maybe<Product_Variation_Photos_Mutation_Response>;
  /** delete single row from the table: "product_variation_photos" */
  delete_product_variation_photos_by_pk?: Maybe<Product_Variation_Photos>;
  /** delete data from the table: "product_variation_safety_checklist_category" */
  delete_product_variation_safety_checklist_category?: Maybe<Product_Variation_Safety_Checklist_Category_Mutation_Response>;
  /** delete single row from the table: "product_variation_safety_checklist_category" */
  delete_product_variation_safety_checklist_category_by_pk?: Maybe<Product_Variation_Safety_Checklist_Category>;
  /** delete data from the table: "product_variation_test_category" */
  delete_product_variation_test_category?: Maybe<Product_Variation_Test_Category_Mutation_Response>;
  /** delete single row from the table: "product_variation_test_category" */
  delete_product_variation_test_category_by_pk?: Maybe<Product_Variation_Test_Category>;
  /** delete data from the table: "purchase_order" */
  delete_purchase_order?: Maybe<Purchase_Order_Mutation_Response>;
  /** delete single row from the table: "purchase_order" */
  delete_purchase_order_by_pk?: Maybe<Purchase_Order>;
  /** delete data from the table: "purchase_order_items" */
  delete_purchase_order_items?: Maybe<Purchase_Order_Items_Mutation_Response>;
  /** delete single row from the table: "purchase_order_items" */
  delete_purchase_order_items_by_pk?: Maybe<Purchase_Order_Items>;
  /** delete data from the table: "quantity_correction_ticket_states" */
  delete_quantity_correction_ticket_states?: Maybe<Quantity_Correction_Ticket_States_Mutation_Response>;
  /** delete single row from the table: "quantity_correction_ticket_states" */
  delete_quantity_correction_ticket_states_by_pk?: Maybe<Quantity_Correction_Ticket_States>;
  /** delete data from the table: "quantity_correction_tickets" */
  delete_quantity_correction_tickets?: Maybe<Quantity_Correction_Tickets_Mutation_Response>;
  /** delete single row from the table: "quantity_correction_tickets" */
  delete_quantity_correction_tickets_by_pk?: Maybe<Quantity_Correction_Tickets>;
  /** delete data from the table: "reason_type" */
  delete_reason_type?: Maybe<Reason_Type_Mutation_Response>;
  /** delete single row from the table: "reason_type" */
  delete_reason_type_by_pk?: Maybe<Reason_Type>;
  /** delete data from the table: "reasons" */
  delete_reasons?: Maybe<Reasons_Mutation_Response>;
  /** delete single row from the table: "reasons" */
  delete_reasons_by_pk?: Maybe<Reasons>;
  /** delete data from the table: "role" */
  delete_role?: Maybe<Role_Mutation_Response>;
  /** delete single row from the table: "role" */
  delete_role_by_pk?: Maybe<Role>;
  /** delete data from the table: "role_document" */
  delete_role_document?: Maybe<Role_Document_Mutation_Response>;
  /** delete single row from the table: "role_document" */
  delete_role_document_by_pk?: Maybe<Role_Document>;
  /** delete data from the table: "safety_checklist" */
  delete_safety_checklist?: Maybe<Safety_Checklist_Mutation_Response>;
  /** delete single row from the table: "safety_checklist" */
  delete_safety_checklist_by_pk?: Maybe<Safety_Checklist>;
  /** delete data from the table: "safety_checklist_category" */
  delete_safety_checklist_category?: Maybe<Safety_Checklist_Category_Mutation_Response>;
  /** delete single row from the table: "safety_checklist_category" */
  delete_safety_checklist_category_by_pk?: Maybe<Safety_Checklist_Category>;
  /** delete data from the table: "script_type" */
  delete_script_type?: Maybe<Script_Type_Mutation_Response>;
  /** delete single row from the table: "script_type" */
  delete_script_type_by_pk?: Maybe<Script_Type>;
  /** delete data from the table: "scripts" */
  delete_scripts?: Maybe<Scripts_Mutation_Response>;
  /** delete single row from the table: "scripts" */
  delete_scripts_by_pk?: Maybe<Scripts>;
  /** delete data from the table: "services" */
  delete_services?: Maybe<Services_Mutation_Response>;
  /** delete single row from the table: "services" */
  delete_services_by_pk?: Maybe<Services>;
  /** delete data from the table: "services_category" */
  delete_services_category?: Maybe<Services_Category_Mutation_Response>;
  /** delete single row from the table: "services_category" */
  delete_services_category_by_pk?: Maybe<Services_Category>;
  /** delete data from the table: "shift_schedule" */
  delete_shift_schedule?: Maybe<Shift_Schedule_Mutation_Response>;
  /** delete single row from the table: "shift_schedule" */
  delete_shift_schedule_by_pk?: Maybe<Shift_Schedule>;
  /** delete data from the table: "shift_schedule_dispenser" */
  delete_shift_schedule_dispenser?: Maybe<Shift_Schedule_Dispenser_Mutation_Response>;
  /** delete single row from the table: "shift_schedule_dispenser" */
  delete_shift_schedule_dispenser_by_pk?: Maybe<Shift_Schedule_Dispenser>;
  /** delete data from the table: "shift_template" */
  delete_shift_template?: Maybe<Shift_Template_Mutation_Response>;
  /** delete single row from the table: "shift_template" */
  delete_shift_template_by_pk?: Maybe<Shift_Template>;
  /** delete data from the table: "slab_type" */
  delete_slab_type?: Maybe<Slab_Type_Mutation_Response>;
  /** delete single row from the table: "slab_type" */
  delete_slab_type_by_pk?: Maybe<Slab_Type>;
  /** delete data from the table: "source_type" */
  delete_source_type?: Maybe<Source_Type_Mutation_Response>;
  /** delete single row from the table: "source_type" */
  delete_source_type_by_pk?: Maybe<Source_Type>;
  /** delete data from the table: "spatial_ref_sys" */
  delete_spatial_ref_sys?: Maybe<Spatial_Ref_Sys_Mutation_Response>;
  /** delete single row from the table: "spatial_ref_sys" */
  delete_spatial_ref_sys_by_pk?: Maybe<Spatial_Ref_Sys>;
  /** delete data from the table: "state" */
  delete_state?: Maybe<State_Mutation_Response>;
  /** delete single row from the table: "state" */
  delete_state_by_pk?: Maybe<State>;
  /** delete data from the table: "subsidiary" */
  delete_subsidiary?: Maybe<Subsidiary_Mutation_Response>;
  /** delete single row from the table: "subsidiary" */
  delete_subsidiary_by_pk?: Maybe<Subsidiary>;
  /** delete data from the table: "support_tickets" */
  delete_support_tickets?: Maybe<Support_Tickets_Mutation_Response>;
  /** delete single row from the table: "support_tickets" */
  delete_support_tickets_by_pk?: Maybe<Support_Tickets>;
  /** delete data from the table: "support_tickets_category" */
  delete_support_tickets_category?: Maybe<Support_Tickets_Category_Mutation_Response>;
  /** delete single row from the table: "support_tickets_category" */
  delete_support_tickets_category_by_pk?: Maybe<Support_Tickets_Category>;
  /** delete data from the table: "support_tickets_photos" */
  delete_support_tickets_photos?: Maybe<Support_Tickets_Photos_Mutation_Response>;
  /** delete single row from the table: "support_tickets_photos" */
  delete_support_tickets_photos_by_pk?: Maybe<Support_Tickets_Photos>;
  /** delete data from the table: "tag" */
  delete_tag?: Maybe<Tag_Mutation_Response>;
  /** delete single row from the table: "tag" */
  delete_tag_by_pk?: Maybe<Tag>;
  /** delete data from the table: "tank_type" */
  delete_tank_type?: Maybe<Tank_Type_Mutation_Response>;
  /** delete single row from the table: "tank_type" */
  delete_tank_type_by_pk?: Maybe<Tank_Type>;
  /** delete data from the table: "task" */
  delete_task?: Maybe<Task_Mutation_Response>;
  /** delete data from the table: "task_action_instruction" */
  delete_task_action_instruction?: Maybe<Task_Action_Instruction_Mutation_Response>;
  /** delete single row from the table: "task_action_instruction" */
  delete_task_action_instruction_by_pk?: Maybe<Task_Action_Instruction>;
  /** delete data from the table: "task_action_type" */
  delete_task_action_type?: Maybe<Task_Action_Type_Mutation_Response>;
  /** delete single row from the table: "task_action_type" */
  delete_task_action_type_by_pk?: Maybe<Task_Action_Type>;
  /** delete single row from the table: "task" */
  delete_task_by_pk?: Maybe<Task>;
  /** delete data from the table: "task_cancellation_reasons" */
  delete_task_cancellation_reasons?: Maybe<Task_Cancellation_Reasons_Mutation_Response>;
  /** delete single row from the table: "task_cancellation_reasons" */
  delete_task_cancellation_reasons_by_pk?: Maybe<Task_Cancellation_Reasons>;
  /** delete data from the table: "task_state" */
  delete_task_state?: Maybe<Task_State_Mutation_Response>;
  /** delete single row from the table: "task_state" */
  delete_task_state_by_pk?: Maybe<Task_State>;
  /** delete data from the table: "task_states_flow" */
  delete_task_states_flow?: Maybe<Task_States_Flow_Mutation_Response>;
  /** delete single row from the table: "task_states_flow" */
  delete_task_states_flow_by_pk?: Maybe<Task_States_Flow>;
  /** delete data from the table: "task_type" */
  delete_task_type?: Maybe<Task_Type_Mutation_Response>;
  /** delete single row from the table: "task_type" */
  delete_task_type_by_pk?: Maybe<Task_Type>;
  /** delete data from the table: "task_value" */
  delete_task_value?: Maybe<Task_Value_Mutation_Response>;
  /** delete single row from the table: "task_value" */
  delete_task_value_by_pk?: Maybe<Task_Value>;
  /** delete data from the table: "test" */
  delete_test?: Maybe<Test_Mutation_Response>;
  /** delete single row from the table: "test" */
  delete_test_by_pk?: Maybe<Test>;
  /** delete data from the table: "test_category" */
  delete_test_category?: Maybe<Test_Category_Mutation_Response>;
  /** delete single row from the table: "test_category" */
  delete_test_category_by_pk?: Maybe<Test_Category>;
  /** delete data from the table: "ticket_state" */
  delete_ticket_state?: Maybe<Ticket_State_Mutation_Response>;
  /** delete single row from the table: "ticket_state" */
  delete_ticket_state_by_pk?: Maybe<Ticket_State>;
  /** delete data from the table: "ticket_type" */
  delete_ticket_type?: Maybe<Ticket_Type_Mutation_Response>;
  /** delete single row from the table: "ticket_type" */
  delete_ticket_type_by_pk?: Maybe<Ticket_Type>;
  /** delete data from the table: "tickets" */
  delete_tickets?: Maybe<Tickets_Mutation_Response>;
  /** delete single row from the table: "tickets" */
  delete_tickets_by_pk?: Maybe<Tickets>;
  /** delete data from the table: "totalizer_correction_ticket_states" */
  delete_totalizer_correction_ticket_states?: Maybe<Totalizer_Correction_Ticket_States_Mutation_Response>;
  /** delete single row from the table: "totalizer_correction_ticket_states" */
  delete_totalizer_correction_ticket_states_by_pk?: Maybe<Totalizer_Correction_Ticket_States>;
  /** delete data from the table: "totalizer_correction_tickets" */
  delete_totalizer_correction_tickets?: Maybe<Totalizer_Correction_Tickets_Mutation_Response>;
  /** delete single row from the table: "totalizer_correction_tickets" */
  delete_totalizer_correction_tickets_by_pk?: Maybe<Totalizer_Correction_Tickets>;
  /** delete data from the table: "transaction_type" */
  delete_transaction_type?: Maybe<Transaction_Type_Mutation_Response>;
  /** delete single row from the table: "transaction_type" */
  delete_transaction_type_by_pk?: Maybe<Transaction_Type>;
  /** delete data from the table: "trip" */
  delete_trip?: Maybe<Trip_Mutation_Response>;
  /** delete single row from the table: "trip" */
  delete_trip_by_pk?: Maybe<Trip>;
  /** delete data from the table: "trip_location" */
  delete_trip_location?: Maybe<Trip_Location_Mutation_Response>;
  /** delete single row from the table: "trip_location" */
  delete_trip_location_by_pk?: Maybe<Trip_Location>;
  /** delete data from the table: "trip_plan" */
  delete_trip_plan?: Maybe<Trip_Plan_Mutation_Response>;
  /** delete single row from the table: "trip_plan" */
  delete_trip_plan_by_pk?: Maybe<Trip_Plan>;
  /** delete data from the table: "unit_of_measure" */
  delete_unit_of_measure?: Maybe<Unit_Of_Measure_Mutation_Response>;
  /** delete single row from the table: "unit_of_measure" */
  delete_unit_of_measure_by_pk?: Maybe<Unit_Of_Measure>;
  /** delete data from the table: "unit_of_measure_meta" */
  delete_unit_of_measure_meta?: Maybe<Unit_Of_Measure_Meta_Mutation_Response>;
  /** delete single row from the table: "unit_of_measure_meta" */
  delete_unit_of_measure_meta_by_pk?: Maybe<Unit_Of_Measure_Meta>;
  /** delete data from the table: "uom_conversion" */
  delete_uom_conversion?: Maybe<Uom_Conversion_Mutation_Response>;
  /** delete single row from the table: "uom_conversion" */
  delete_uom_conversion_by_pk?: Maybe<Uom_Conversion>;
  /** delete data from the table: "user" */
  delete_user?: Maybe<User_Mutation_Response>;
  /** delete data from the table: "user_access_audit_log" */
  delete_user_access_audit_log?: Maybe<User_Access_Audit_Log_Mutation_Response>;
  /** delete single row from the table: "user_access_audit_log" */
  delete_user_access_audit_log_by_pk?: Maybe<User_Access_Audit_Log>;
  /** delete single row from the table: "user" */
  delete_user_by_pk?: Maybe<User>;
  /** delete data from the table: "user_ledger" */
  delete_user_ledger?: Maybe<User_Ledger_Mutation_Response>;
  /** delete single row from the table: "user_ledger" */
  delete_user_ledger_by_pk?: Maybe<User_Ledger>;
  /** delete data from the table: "user_partner_type" */
  delete_user_partner_type?: Maybe<User_Partner_Type_Mutation_Response>;
  /** delete single row from the table: "user_partner_type" */
  delete_user_partner_type_by_pk?: Maybe<User_Partner_Type>;
  /** delete data from the table: "user_referral" */
  delete_user_referral?: Maybe<User_Referral_Mutation_Response>;
  /** delete single row from the table: "user_referral" */
  delete_user_referral_by_pk?: Maybe<User_Referral>;
  /** delete data from the table: "user_role" */
  delete_user_role?: Maybe<User_Role_Mutation_Response>;
  /** delete single row from the table: "user_role" */
  delete_user_role_by_pk?: Maybe<User_Role>;
  /** delete data from the table: "validation_workflows" */
  delete_validation_workflows?: Maybe<Validation_Workflows_Mutation_Response>;
  /** delete single row from the table: "validation_workflows" */
  delete_validation_workflows_by_pk?: Maybe<Validation_Workflows>;
  /** delete data from the table: "variation" */
  delete_variation?: Maybe<Variation_Mutation_Response>;
  /** delete single row from the table: "variation" */
  delete_variation_by_pk?: Maybe<Variation>;
  /** delete data from the table: "variation_type" */
  delete_variation_type?: Maybe<Variation_Type_Mutation_Response>;
  /** delete single row from the table: "variation_type" */
  delete_variation_type_by_pk?: Maybe<Variation_Type>;
  /** delete data from the table: "vehicle" */
  delete_vehicle?: Maybe<Vehicle_Mutation_Response>;
  /** delete single row from the table: "vehicle" */
  delete_vehicle_by_pk?: Maybe<Vehicle>;
  /** delete data from the table: "vehicle_configuration" */
  delete_vehicle_configuration?: Maybe<Vehicle_Configuration_Mutation_Response>;
  /** delete single row from the table: "vehicle_configuration" */
  delete_vehicle_configuration_by_pk?: Maybe<Vehicle_Configuration>;
  /** delete data from the table: "vehicle_device" */
  delete_vehicle_device?: Maybe<Vehicle_Device_Mutation_Response>;
  /** delete single row from the table: "vehicle_device" */
  delete_vehicle_device_by_pk?: Maybe<Vehicle_Device>;
  /** delete data from the table: "vehicle_device_calibration" */
  delete_vehicle_device_calibration?: Maybe<Vehicle_Device_Calibration_Mutation_Response>;
  /** delete single row from the table: "vehicle_device_calibration" */
  delete_vehicle_device_calibration_by_pk?: Maybe<Vehicle_Device_Calibration>;
  /** delete data from the table: "vehicle_inventory_transaction_logs" */
  delete_vehicle_inventory_transaction_logs?: Maybe<Vehicle_Inventory_Transaction_Logs_Mutation_Response>;
  /** delete single row from the table: "vehicle_inventory_transaction_logs" */
  delete_vehicle_inventory_transaction_logs_by_pk?: Maybe<Vehicle_Inventory_Transaction_Logs>;
  /** delete data from the table: "vehicle_localities" */
  delete_vehicle_localities?: Maybe<Vehicle_Localities_Mutation_Response>;
  /** delete single row from the table: "vehicle_localities" */
  delete_vehicle_localities_by_pk?: Maybe<Vehicle_Localities>;
  /** delete data from the table: "vehicle_permit" */
  delete_vehicle_permit?: Maybe<Vehicle_Permit_Mutation_Response>;
  /** delete single row from the table: "vehicle_permit" */
  delete_vehicle_permit_by_pk?: Maybe<Vehicle_Permit>;
  /** delete data from the table: "vehicle_shift_template" */
  delete_vehicle_shift_template?: Maybe<Vehicle_Shift_Template_Mutation_Response>;
  /** delete single row from the table: "vehicle_shift_template" */
  delete_vehicle_shift_template_by_pk?: Maybe<Vehicle_Shift_Template>;
  /** delete data from the table: "vehicle_status" */
  delete_vehicle_status?: Maybe<Vehicle_Status_Mutation_Response>;
  /** delete single row from the table: "vehicle_status" */
  delete_vehicle_status_by_pk?: Maybe<Vehicle_Status>;
  /** delete data from the table: "vehicle_status_logs" */
  delete_vehicle_status_logs?: Maybe<Vehicle_Status_Logs_Mutation_Response>;
  /** delete single row from the table: "vehicle_status_logs" */
  delete_vehicle_status_logs_by_pk?: Maybe<Vehicle_Status_Logs>;
  /** delete data from the table: "vehicle_tank_type" */
  delete_vehicle_tank_type?: Maybe<Vehicle_Tank_Type_Mutation_Response>;
  /** delete single row from the table: "vehicle_tank_type" */
  delete_vehicle_tank_type_by_pk?: Maybe<Vehicle_Tank_Type>;
  /** delete data from the table: "vehicle_tank_type_product_variation" */
  delete_vehicle_tank_type_product_variation?: Maybe<Vehicle_Tank_Type_Product_Variation_Mutation_Response>;
  /** delete single row from the table: "vehicle_tank_type_product_variation" */
  delete_vehicle_tank_type_product_variation_by_pk?: Maybe<Vehicle_Tank_Type_Product_Variation>;
  /** delete data from the table: "vehicle_type" */
  delete_vehicle_type?: Maybe<Vehicle_Type_Mutation_Response>;
  /** delete single row from the table: "vehicle_type" */
  delete_vehicle_type_by_pk?: Maybe<Vehicle_Type>;
  /** delete data from the table: "vendor_order_logs" */
  delete_vendor_order_logs?: Maybe<Vendor_Order_Logs_Mutation_Response>;
  /** delete single row from the table: "vendor_order_logs" */
  delete_vendor_order_logs_by_pk?: Maybe<Vendor_Order_Logs>;
  /** delete data from the table: "vendor_sync_status" */
  delete_vendor_sync_status?: Maybe<Vendor_Sync_Status_Mutation_Response>;
  /** delete single row from the table: "vendor_sync_status" */
  delete_vendor_sync_status_by_pk?: Maybe<Vendor_Sync_Status>;
  /** delete data from the table: "voucher" */
  delete_voucher?: Maybe<Voucher_Mutation_Response>;
  /** delete single row from the table: "voucher" */
  delete_voucher_by_pk?: Maybe<Voucher>;
  /** delete data from the table: "wallet" */
  delete_wallet?: Maybe<Wallet_Mutation_Response>;
  /** delete single row from the table: "wallet" */
  delete_wallet_by_pk?: Maybe<Wallet>;
  /** delete data from the table: "wallet_exception" */
  delete_wallet_exception?: Maybe<Wallet_Exception_Mutation_Response>;
  /** delete single row from the table: "wallet_exception" */
  delete_wallet_exception_by_pk?: Maybe<Wallet_Exception>;
  /** delete data from the table: "wallet_ledger" */
  delete_wallet_ledger?: Maybe<Wallet_Ledger_Mutation_Response>;
  /** delete single row from the table: "wallet_ledger" */
  delete_wallet_ledger_by_pk?: Maybe<Wallet_Ledger>;
  /** delete data from the table: "wallet_state" */
  delete_wallet_state?: Maybe<Wallet_State_Mutation_Response>;
  /** delete single row from the table: "wallet_state" */
  delete_wallet_state_by_pk?: Maybe<Wallet_State>;
  /** delete data from the table: "wallet_transactions" */
  delete_wallet_transactions?: Maybe<Wallet_Transactions_Mutation_Response>;
  /** delete single row from the table: "wallet_transactions" */
  delete_wallet_transactions_by_pk?: Maybe<Wallet_Transactions>;
  deviceIotProcessor?: Maybe<DeviceIotProcessorOutput>;
  /** Fetch all draft Purchase Advance Receipt Control entries from ERP */
  fetchAdvanceReceiptControls?: Maybe<FetchAdvanceReceiptControlsOutput>;
  /** Batch consumption query - total qty dispensed per org for a date range */
  fetchBatchOrgConsumption?: Maybe<FetchBatchOrgConsumptionOutput>;
  fetchCurrAndPrevOdometerReadingV2?: Maybe<FetchCurrAndPrevOdometerReadingV2Output>;
  /** fetchCustomerAssetDashboradData */
  fetchCustomerAssetDashboradData?: Maybe<CustomerAssetDataOutput>;
  fetchCustomerOrderDashboradData?: Maybe<CustomerOrderDataOutput>;
  /** fetchCustomerOrderItemSlotsById */
  fetchCustomerOrderItemSlotsById?: Maybe<FetchCustomerOrderItemSlotsByIdOutput>;
  fetchSLATrackingV2: FetchSlaTrackingV2Output;
  /** Fetch wallet ledger entries that appear duplicated within the drift window */
  fetchWalletDriftDuplicate?: Maybe<FetchWalletDriftDuplicateOutput>;
  /** Fetch wallet entries that violate balance invariants (wallet.amount != ledger sum) */
  fetchWalletDriftInvariant?: Maybe<FetchWalletDriftInvariantOutput>;
  /** Fetch wallet entries where ledger amount mismatches the recorded wallet balance */
  fetchWalletDriftMismatch?: Maybe<FetchWalletDriftMismatchOutput>;
  /** Fetch wallet transactions that are missing a corresponding ledger entry */
  fetchWalletDriftMissing?: Maybe<FetchWalletDriftMissingOutput>;
  /** Fetch orphaned ledger debits with no matching wallet transaction */
  fetchWalletDriftOrphan?: Maybe<FetchWalletDriftOrphanOutput>;
  getCustomerAssetDispensingLimit?: Maybe<GetCustomerAssetDispensingLimitOutput>;
  /** Fetch and process aggregated invoice data using date range and organization ID with dual calculation methods (amount_based and rate_based) */
  getInvoiceInfo?: Maybe<GetInvoiceInfoResponse>;
  getLatestTaskValue?: Maybe<GetLatestTaskValueOutput>;
  /** IDEV-2979: last submitted ERP Sales Invoice posting time for the org (retag backdate floor) */
  getOrgLastSalesInvoiceDate?: Maybe<GetOrgLastSalesInvoiceDateOutput>;
  /** Get wallet statement of account with opening/closing balance and running balance */
  getWalletStatement?: Maybe<GetWalletStatementOutput>;
  /** Bring up a wallet with backdated history — opening ADJUSTMENT + optional MANUAL_CREDIT + retroactive INVOICE_DEBIT sweep (30-day cap). Idempotent. Refuses if org has active DISPENSING orders. */
  initializeBackdatedWallet?: Maybe<InitializeBackdatedWalletOutput>;
  /** insert data into the table: "address_subsidiary" */
  insert_address_subsidiary?: Maybe<Address_Subsidiary_Mutation_Response>;
  /** insert data into the table: "address_subsidiary_audit_logs" */
  insert_address_subsidiary_audit_logs?: Maybe<Address_Subsidiary_Audit_Logs_Mutation_Response>;
  /** insert a single row into the table: "address_subsidiary_audit_logs" */
  insert_address_subsidiary_audit_logs_one?: Maybe<Address_Subsidiary_Audit_Logs>;
  /** insert a single row into the table: "address_subsidiary" */
  insert_address_subsidiary_one?: Maybe<Address_Subsidiary>;
  /** insert data into the table: "address_type" */
  insert_address_type?: Maybe<Address_Type_Mutation_Response>;
  /** insert a single row into the table: "address_type" */
  insert_address_type_one?: Maybe<Address_Type>;
  /** insert data into the table: "asset_grouping" */
  insert_asset_grouping?: Maybe<Asset_Grouping_Mutation_Response>;
  /** insert data into the table: "asset_grouping_customer_asset" */
  insert_asset_grouping_customer_asset?: Maybe<Asset_Grouping_Customer_Asset_Mutation_Response>;
  /** insert a single row into the table: "asset_grouping_customer_asset" */
  insert_asset_grouping_customer_asset_one?: Maybe<Asset_Grouping_Customer_Asset>;
  /** insert a single row into the table: "asset_grouping" */
  insert_asset_grouping_one?: Maybe<Asset_Grouping>;
  /** insert data into the table: "asset_subsidiary" */
  insert_asset_subsidiary?: Maybe<Asset_Subsidiary_Mutation_Response>;
  /** insert data into the table: "asset_subsidiary_audit_logs" */
  insert_asset_subsidiary_audit_logs?: Maybe<Asset_Subsidiary_Audit_Logs_Mutation_Response>;
  /** insert a single row into the table: "asset_subsidiary_audit_logs" */
  insert_asset_subsidiary_audit_logs_one?: Maybe<Asset_Subsidiary_Audit_Logs>;
  /** insert a single row into the table: "asset_subsidiary" */
  insert_asset_subsidiary_one?: Maybe<Asset_Subsidiary>;
  /** insert data into the table: "asset_type" */
  insert_asset_type?: Maybe<Asset_Type_Mutation_Response>;
  /** insert data into the table: "asset_type_category" */
  insert_asset_type_category?: Maybe<Asset_Type_Category_Mutation_Response>;
  /** insert a single row into the table: "asset_type_category" */
  insert_asset_type_category_one?: Maybe<Asset_Type_Category>;
  /** insert a single row into the table: "asset_type" */
  insert_asset_type_one?: Maybe<Asset_Type>;
  /** insert data into the table: "associated_type" */
  insert_associated_type?: Maybe<Associated_Type_Mutation_Response>;
  /** insert a single row into the table: "associated_type" */
  insert_associated_type_one?: Maybe<Associated_Type>;
  /** insert data into the table: "audit_log_action" */
  insert_audit_log_action?: Maybe<Audit_Log_Action_Mutation_Response>;
  /** insert a single row into the table: "audit_log_action" */
  insert_audit_log_action_one?: Maybe<Audit_Log_Action>;
  /** insert data into the table: "cancellation_reasons" */
  insert_cancellation_reasons?: Maybe<Cancellation_Reasons_Mutation_Response>;
  /** insert a single row into the table: "cancellation_reasons" */
  insert_cancellation_reasons_one?: Maybe<Cancellation_Reasons>;
  /** insert data into the table: "category" */
  insert_category?: Maybe<Category_Mutation_Response>;
  /** insert a single row into the table: "category" */
  insert_category_one?: Maybe<Category>;
  /** insert data into the table: "city" */
  insert_city?: Maybe<City_Mutation_Response>;
  /** insert a single row into the table: "city" */
  insert_city_one?: Maybe<City>;
  /** insert data into the table: "country" */
  insert_country?: Maybe<Country_Mutation_Response>;
  /** insert a single row into the table: "country" */
  insert_country_one?: Maybe<Country>;
  /** insert data into the table: "credit_breach" */
  insert_credit_breach?: Maybe<Credit_Breach_Mutation_Response>;
  /** insert a single row into the table: "credit_breach" */
  insert_credit_breach_one?: Maybe<Credit_Breach>;
  /** insert data into the table: "currency" */
  insert_currency?: Maybe<Currency_Mutation_Response>;
  /** insert data into the table: "currency_conversion" */
  insert_currency_conversion?: Maybe<Currency_Conversion_Mutation_Response>;
  /** insert a single row into the table: "currency_conversion" */
  insert_currency_conversion_one?: Maybe<Currency_Conversion>;
  /** insert a single row into the table: "currency" */
  insert_currency_one?: Maybe<Currency>;
  /** insert data into the table: "customer_asset" */
  insert_customer_asset?: Maybe<Customer_Asset_Mutation_Response>;
  /** insert data into the table: "customer_asset_audit_log" */
  insert_customer_asset_audit_log?: Maybe<Customer_Asset_Audit_Log_Mutation_Response>;
  /** insert a single row into the table: "customer_asset_audit_log" */
  insert_customer_asset_audit_log_one?: Maybe<Customer_Asset_Audit_Log>;
  /** insert data into the table: "customer_asset_device" */
  insert_customer_asset_device?: Maybe<Customer_Asset_Device_Mutation_Response>;
  /** insert data into the table: "customer_asset_device_calibration" */
  insert_customer_asset_device_calibration?: Maybe<Customer_Asset_Device_Calibration_Mutation_Response>;
  /** insert a single row into the table: "customer_asset_device_calibration" */
  insert_customer_asset_device_calibration_one?: Maybe<Customer_Asset_Device_Calibration>;
  /** insert a single row into the table: "customer_asset_device" */
  insert_customer_asset_device_one?: Maybe<Customer_Asset_Device>;
  /** insert data into the table: "customer_asset_dispensing_rules" */
  insert_customer_asset_dispensing_rules?: Maybe<Customer_Asset_Dispensing_Rules_Mutation_Response>;
  /** insert a single row into the table: "customer_asset_dispensing_rules" */
  insert_customer_asset_dispensing_rules_one?: Maybe<Customer_Asset_Dispensing_Rules>;
  /** insert data into the table: "customer_asset_limit" */
  insert_customer_asset_limit?: Maybe<Customer_Asset_Limit_Mutation_Response>;
  /** insert a single row into the table: "customer_asset_limit" */
  insert_customer_asset_limit_one?: Maybe<Customer_Asset_Limit>;
  /** insert a single row into the table: "customer_asset" */
  insert_customer_asset_one?: Maybe<Customer_Asset>;
  /** insert data into the table: "customer_asset_tag" */
  insert_customer_asset_tag?: Maybe<Customer_Asset_Tag_Mutation_Response>;
  /** insert a single row into the table: "customer_asset_tag" */
  insert_customer_asset_tag_one?: Maybe<Customer_Asset_Tag>;
  /** insert data into the table: "customer_order" */
  insert_customer_order?: Maybe<Customer_Order_Mutation_Response>;
  /** insert data into the table: "customer_order_cancellation_reasons" */
  insert_customer_order_cancellation_reasons?: Maybe<Customer_Order_Cancellation_Reasons_Mutation_Response>;
  /** insert a single row into the table: "customer_order_cancellation_reasons" */
  insert_customer_order_cancellation_reasons_one?: Maybe<Customer_Order_Cancellation_Reasons>;
  /** insert data into the table: "customer_order_customer_asset" */
  insert_customer_order_customer_asset?: Maybe<Customer_Order_Customer_Asset_Mutation_Response>;
  /** insert a single row into the table: "customer_order_customer_asset" */
  insert_customer_order_customer_asset_one?: Maybe<Customer_Order_Customer_Asset>;
  /** insert data into the table: "customer_order_item" */
  insert_customer_order_item?: Maybe<Customer_Order_Item_Mutation_Response>;
  /** insert data into the table: "customer_order_item_cancellation_reasons" */
  insert_customer_order_item_cancellation_reasons?: Maybe<Customer_Order_Item_Cancellation_Reasons_Mutation_Response>;
  /** insert a single row into the table: "customer_order_item_cancellation_reasons" */
  insert_customer_order_item_cancellation_reasons_one?: Maybe<Customer_Order_Item_Cancellation_Reasons>;
  /** insert data into the table: "customer_order_item_comments" */
  insert_customer_order_item_comments?: Maybe<Customer_Order_Item_Comments_Mutation_Response>;
  /** insert a single row into the table: "customer_order_item_comments" */
  insert_customer_order_item_comments_one?: Maybe<Customer_Order_Item_Comments>;
  /** insert data into the table: "customer_order_item_commission" */
  insert_customer_order_item_commission?: Maybe<Customer_Order_Item_Commission_Mutation_Response>;
  /** insert a single row into the table: "customer_order_item_commission" */
  insert_customer_order_item_commission_one?: Maybe<Customer_Order_Item_Commission>;
  /** insert data into the table: "customer_order_item_etd_transactional_logs" */
  insert_customer_order_item_etd_transactional_logs?: Maybe<Customer_Order_Item_Etd_Transactional_Logs_Mutation_Response>;
  /** insert a single row into the table: "customer_order_item_etd_transactional_logs" */
  insert_customer_order_item_etd_transactional_logs_one?: Maybe<Customer_Order_Item_Etd_Transactional_Logs>;
  /** insert a single row into the table: "customer_order_item" */
  insert_customer_order_item_one?: Maybe<Customer_Order_Item>;
  /** insert data into the table: "customer_order_item_partner" */
  insert_customer_order_item_partner?: Maybe<Customer_Order_Item_Partner_Mutation_Response>;
  /** insert a single row into the table: "customer_order_item_partner" */
  insert_customer_order_item_partner_one?: Maybe<Customer_Order_Item_Partner>;
  /** insert data into the table: "customer_order_item_safety_checklist_results" */
  insert_customer_order_item_safety_checklist_results?: Maybe<Customer_Order_Item_Safety_Checklist_Results_Mutation_Response>;
  /** insert a single row into the table: "customer_order_item_safety_checklist_results" */
  insert_customer_order_item_safety_checklist_results_one?: Maybe<Customer_Order_Item_Safety_Checklist_Results>;
  /** insert data into the table: "customer_order_item_state" */
  insert_customer_order_item_state?: Maybe<Customer_Order_Item_State_Mutation_Response>;
  /** insert a single row into the table: "customer_order_item_state" */
  insert_customer_order_item_state_one?: Maybe<Customer_Order_Item_State>;
  /** insert data into the table: "customer_order_item_stateflow" */
  insert_customer_order_item_stateflow?: Maybe<Customer_Order_Item_Stateflow_Mutation_Response>;
  /** insert a single row into the table: "customer_order_item_stateflow" */
  insert_customer_order_item_stateflow_one?: Maybe<Customer_Order_Item_Stateflow>;
  /** insert data into the table: "customer_order_item_test_category" */
  insert_customer_order_item_test_category?: Maybe<Customer_Order_Item_Test_Category_Mutation_Response>;
  /** insert a single row into the table: "customer_order_item_test_category" */
  insert_customer_order_item_test_category_one?: Maybe<Customer_Order_Item_Test_Category>;
  /** insert data into the table: "customer_order_item_test_results" */
  insert_customer_order_item_test_results?: Maybe<Customer_Order_Item_Test_Results_Mutation_Response>;
  /** insert a single row into the table: "customer_order_item_test_results" */
  insert_customer_order_item_test_results_one?: Maybe<Customer_Order_Item_Test_Results>;
  /** insert data into the table: "customer_order_item_test_results_photos" */
  insert_customer_order_item_test_results_photos?: Maybe<Customer_Order_Item_Test_Results_Photos_Mutation_Response>;
  /** insert a single row into the table: "customer_order_item_test_results_photos" */
  insert_customer_order_item_test_results_photos_one?: Maybe<Customer_Order_Item_Test_Results_Photos>;
  /** insert a single row into the table: "customer_order" */
  insert_customer_order_one?: Maybe<Customer_Order>;
  /** insert data into the table: "customer_order_organization_user_document" */
  insert_customer_order_organization_user_document?: Maybe<Customer_Order_Organization_User_Document_Mutation_Response>;
  /** insert a single row into the table: "customer_order_organization_user_document" */
  insert_customer_order_organization_user_document_one?: Maybe<Customer_Order_Organization_User_Document>;
  /** insert data into the table: "customer_order_partner_order" */
  insert_customer_order_partner_order?: Maybe<Customer_Order_Partner_Order_Mutation_Response>;
  /** insert a single row into the table: "customer_order_partner_order" */
  insert_customer_order_partner_order_one?: Maybe<Customer_Order_Partner_Order>;
  /** insert data into the table: "customer_order_slots" */
  insert_customer_order_slots?: Maybe<Customer_Order_Slots_Mutation_Response>;
  /** insert a single row into the table: "customer_order_slots" */
  insert_customer_order_slots_one?: Maybe<Customer_Order_Slots>;
  /** insert data into the table: "customer_order_state" */
  insert_customer_order_state?: Maybe<Customer_Order_State_Mutation_Response>;
  /** insert a single row into the table: "customer_order_state" */
  insert_customer_order_state_one?: Maybe<Customer_Order_State>;
  /** insert data into the table: "customer_order_stateflow" */
  insert_customer_order_stateflow?: Maybe<Customer_Order_Stateflow_Mutation_Response>;
  /** insert a single row into the table: "customer_order_stateflow" */
  insert_customer_order_stateflow_one?: Maybe<Customer_Order_Stateflow>;
  /** insert data into the table: "customer_payment" */
  insert_customer_payment?: Maybe<Customer_Payment_Mutation_Response>;
  /** insert a single row into the table: "customer_payment" */
  insert_customer_payment_one?: Maybe<Customer_Payment>;
  /** insert data into the table: "customer_payment_status" */
  insert_customer_payment_status?: Maybe<Customer_Payment_Status_Mutation_Response>;
  /** insert a single row into the table: "customer_payment_status" */
  insert_customer_payment_status_one?: Maybe<Customer_Payment_Status>;
  /** insert data into the table: "customer_segmentation" */
  insert_customer_segmentation?: Maybe<Customer_Segmentation_Mutation_Response>;
  /** insert a single row into the table: "customer_segmentation" */
  insert_customer_segmentation_one?: Maybe<Customer_Segmentation>;
  /** insert data into the table: "day_type" */
  insert_day_type?: Maybe<Day_Type_Mutation_Response>;
  /** insert a single row into the table: "day_type" */
  insert_day_type_one?: Maybe<Day_Type>;
  /** insert data into the table: "delivery_preferences" */
  insert_delivery_preferences?: Maybe<Delivery_Preferences_Mutation_Response>;
  /** insert a single row into the table: "delivery_preferences" */
  insert_delivery_preferences_one?: Maybe<Delivery_Preferences>;
  /** insert data into the table: "delivery_scheduler" */
  insert_delivery_scheduler?: Maybe<Delivery_Scheduler_Mutation_Response>;
  /** insert a single row into the table: "delivery_scheduler" */
  insert_delivery_scheduler_one?: Maybe<Delivery_Scheduler>;
  /** insert data into the table: "delivery_scheduler_product_item" */
  insert_delivery_scheduler_product_item?: Maybe<Delivery_Scheduler_Product_Item_Mutation_Response>;
  /** insert a single row into the table: "delivery_scheduler_product_item" */
  insert_delivery_scheduler_product_item_one?: Maybe<Delivery_Scheduler_Product_Item>;
  /** insert data into the table: "department_retag_request" */
  insert_department_retag_request?: Maybe<Department_Retag_Request_Mutation_Response>;
  /** insert a single row into the table: "department_retag_request" */
  insert_department_retag_request_one?: Maybe<Department_Retag_Request>;
  /** insert data into the table: "device_devicetype_paramerter_definition" */
  insert_device_devicetype_paramerter_definition?: Maybe<Device_Devicetype_Paramerter_Definition_Mutation_Response>;
  /** insert a single row into the table: "device_devicetype_paramerter_definition" */
  insert_device_devicetype_paramerter_definition_one?: Maybe<Device_Devicetype_Paramerter_Definition>;
  /** insert data into the table: "devicetype" */
  insert_devicetype?: Maybe<Devicetype_Mutation_Response>;
  /** insert a single row into the table: "devicetype" */
  insert_devicetype_one?: Maybe<Devicetype>;
  /** insert data into the table: "devicetype_paramerter_definition" */
  insert_devicetype_paramerter_definition?: Maybe<Devicetype_Paramerter_Definition_Mutation_Response>;
  /** insert a single row into the table: "devicetype_paramerter_definition" */
  insert_devicetype_paramerter_definition_one?: Maybe<Devicetype_Paramerter_Definition>;
  /** insert data into the table: "devicetype_parameter_group" */
  insert_devicetype_parameter_group?: Maybe<Devicetype_Parameter_Group_Mutation_Response>;
  /** insert a single row into the table: "devicetype_parameter_group" */
  insert_devicetype_parameter_group_one?: Maybe<Devicetype_Parameter_Group>;
  /** insert data into the table: "discount_type" */
  insert_discount_type?: Maybe<Discount_Type_Mutation_Response>;
  /** insert a single row into the table: "discount_type" */
  insert_discount_type_one?: Maybe<Discount_Type>;
  /** insert data into the table: "dispenser" */
  insert_dispenser?: Maybe<Dispenser_Mutation_Response>;
  /** insert data into the table: "dispenser_configuration" */
  insert_dispenser_configuration?: Maybe<Dispenser_Configuration_Mutation_Response>;
  /** insert a single row into the table: "dispenser_configuration" */
  insert_dispenser_configuration_one?: Maybe<Dispenser_Configuration>;
  /** insert a single row into the table: "dispenser" */
  insert_dispenser_one?: Maybe<Dispenser>;
  /** insert data into the table: "dispenser_type" */
  insert_dispenser_type?: Maybe<Dispenser_Type_Mutation_Response>;
  /** insert a single row into the table: "dispenser_type" */
  insert_dispenser_type_one?: Maybe<Dispenser_Type>;
  /** insert data into the table: "dispensing_rules" */
  insert_dispensing_rules?: Maybe<Dispensing_Rules_Mutation_Response>;
  /** insert a single row into the table: "dispensing_rules" */
  insert_dispensing_rules_one?: Maybe<Dispensing_Rules>;
  /** insert data into the table: "document_type" */
  insert_document_type?: Maybe<Document_Type_Mutation_Response>;
  /** insert data into the table: "document_type_category" */
  insert_document_type_category?: Maybe<Document_Type_Category_Mutation_Response>;
  /** insert a single row into the table: "document_type_category" */
  insert_document_type_category_one?: Maybe<Document_Type_Category>;
  /** insert a single row into the table: "document_type" */
  insert_document_type_one?: Maybe<Document_Type>;
  /** insert data into the table: "documents" */
  insert_documents?: Maybe<Documents_Mutation_Response>;
  /** insert a single row into the table: "documents" */
  insert_documents_one?: Maybe<Documents>;
  /** insert data into the table: "driver_duty_log" */
  insert_driver_duty_log?: Maybe<Driver_Duty_Log_Mutation_Response>;
  /** insert a single row into the table: "driver_duty_log" */
  insert_driver_duty_log_one?: Maybe<Driver_Duty_Log>;
  /** insert data into the table: "driver_duty_photos" */
  insert_driver_duty_photos?: Maybe<Driver_Duty_Photos_Mutation_Response>;
  /** insert a single row into the table: "driver_duty_photos" */
  insert_driver_duty_photos_one?: Maybe<Driver_Duty_Photos>;
  /** insert data into the table: "driver_permit" */
  insert_driver_permit?: Maybe<Driver_Permit_Mutation_Response>;
  /** insert a single row into the table: "driver_permit" */
  insert_driver_permit_one?: Maybe<Driver_Permit>;
  /** insert data into the table: "driver_vehicle" */
  insert_driver_vehicle?: Maybe<Driver_Vehicle_Mutation_Response>;
  /** insert data into the table: "driver_vehicle_issue" */
  insert_driver_vehicle_issue?: Maybe<Driver_Vehicle_Issue_Mutation_Response>;
  /** insert a single row into the table: "driver_vehicle_issue" */
  insert_driver_vehicle_issue_one?: Maybe<Driver_Vehicle_Issue>;
  /** insert data into the table: "driver_vehicle_location" */
  insert_driver_vehicle_location?: Maybe<Driver_Vehicle_Location_Mutation_Response>;
  /** insert a single row into the table: "driver_vehicle_location" */
  insert_driver_vehicle_location_one?: Maybe<Driver_Vehicle_Location>;
  /** insert a single row into the table: "driver_vehicle" */
  insert_driver_vehicle_one?: Maybe<Driver_Vehicle>;
  /** insert data into the table: "erp_sync_status" */
  insert_erp_sync_status?: Maybe<Erp_Sync_Status_Mutation_Response>;
  /** insert a single row into the table: "erp_sync_status" */
  insert_erp_sync_status_one?: Maybe<Erp_Sync_Status>;
  /** insert data into the table: "fillup_request" */
  insert_fillup_request?: Maybe<Fillup_Request_Mutation_Response>;
  /** insert a single row into the table: "fillup_request" */
  insert_fillup_request_one?: Maybe<Fillup_Request>;
  /** insert data into the table: "fillup_request_status" */
  insert_fillup_request_status?: Maybe<Fillup_Request_Status_Mutation_Response>;
  /** insert a single row into the table: "fillup_request_status" */
  insert_fillup_request_status_one?: Maybe<Fillup_Request_Status>;
  /** insert data into the table: "fuel_request_type" */
  insert_fuel_request_type?: Maybe<Fuel_Request_Type_Mutation_Response>;
  /** insert a single row into the table: "fuel_request_type" */
  insert_fuel_request_type_one?: Maybe<Fuel_Request_Type>;
  /** insert data into the table: "fueltrans_transaction_logs" */
  insert_fueltrans_transaction_logs?: Maybe<Fueltrans_Transaction_Logs_Mutation_Response>;
  /** insert a single row into the table: "fueltrans_transaction_logs" */
  insert_fueltrans_transaction_logs_one?: Maybe<Fueltrans_Transaction_Logs>;
  /** insert data into the table: "geometry_columns" */
  insert_geometry_columns?: Maybe<Geometry_Columns_Mutation_Response>;
  /** insert a single row into the table: "geometry_columns" */
  insert_geometry_columns_one?: Maybe<Geometry_Columns>;
  /** insert data into the table: "inventory" */
  insert_inventory?: Maybe<Inventory_Mutation_Response>;
  /** insert a single row into the table: "inventory" */
  insert_inventory_one?: Maybe<Inventory>;
  /** insert data into the table: "inventory_workflow_logs" */
  insert_inventory_workflow_logs?: Maybe<Inventory_Workflow_Logs_Mutation_Response>;
  /** insert a single row into the table: "inventory_workflow_logs" */
  insert_inventory_workflow_logs_one?: Maybe<Inventory_Workflow_Logs>;
  /** insert data into the table: "invitation" */
  insert_invitation?: Maybe<Invitation_Mutation_Response>;
  /** insert a single row into the table: "invitation" */
  insert_invitation_one?: Maybe<Invitation>;
  /** insert data into the table: "invitation_status" */
  insert_invitation_status?: Maybe<Invitation_Status_Mutation_Response>;
  /** insert a single row into the table: "invitation_status" */
  insert_invitation_status_one?: Maybe<Invitation_Status>;
  /** insert data into the table: "invoice" */
  insert_invoice?: Maybe<Invoice_Mutation_Response>;
  /** insert a single row into the table: "invoice" */
  insert_invoice_one?: Maybe<Invoice>;
  /** insert data into the table: "invoiced_item" */
  insert_invoiced_item?: Maybe<Invoiced_Item_Mutation_Response>;
  /** insert data into the table: "invoiced_item_cancellation_ticket_states" */
  insert_invoiced_item_cancellation_ticket_states?: Maybe<Invoiced_Item_Cancellation_Ticket_States_Mutation_Response>;
  /** insert a single row into the table: "invoiced_item_cancellation_ticket_states" */
  insert_invoiced_item_cancellation_ticket_states_one?: Maybe<Invoiced_Item_Cancellation_Ticket_States>;
  /** insert data into the table: "invoiced_item_cancellation_tickets" */
  insert_invoiced_item_cancellation_tickets?: Maybe<Invoiced_Item_Cancellation_Tickets_Mutation_Response>;
  /** insert a single row into the table: "invoiced_item_cancellation_tickets" */
  insert_invoiced_item_cancellation_tickets_one?: Maybe<Invoiced_Item_Cancellation_Tickets>;
  /** insert a single row into the table: "invoiced_item" */
  insert_invoiced_item_one?: Maybe<Invoiced_Item>;
  /** insert data into the table: "issue" */
  insert_issue?: Maybe<Issue_Mutation_Response>;
  /** insert a single row into the table: "issue" */
  insert_issue_one?: Maybe<Issue>;
  /** insert data into the table: "job_state" */
  insert_job_state?: Maybe<Job_State_Mutation_Response>;
  /** insert a single row into the table: "job_state" */
  insert_job_state_one?: Maybe<Job_State>;
  /** insert data into the table: "job_type" */
  insert_job_type?: Maybe<Job_Type_Mutation_Response>;
  /** insert a single row into the table: "job_type" */
  insert_job_type_one?: Maybe<Job_Type>;
  /** insert data into the table: "job_type_template" */
  insert_job_type_template?: Maybe<Job_Type_Template_Mutation_Response>;
  /** insert a single row into the table: "job_type_template" */
  insert_job_type_template_one?: Maybe<Job_Type_Template>;
  /** insert data into the table: "jobs" */
  insert_jobs?: Maybe<Jobs_Mutation_Response>;
  /** insert a single row into the table: "jobs" */
  insert_jobs_one?: Maybe<Jobs>;
  /** insert data into the table: "jobs_state_flow" */
  insert_jobs_state_flow?: Maybe<Jobs_State_Flow_Mutation_Response>;
  /** insert a single row into the table: "jobs_state_flow" */
  insert_jobs_state_flow_one?: Maybe<Jobs_State_Flow>;
  /** insert data into the table: "limit_purchase_order" */
  insert_limit_purchase_order?: Maybe<Limit_Purchase_Order_Mutation_Response>;
  /** insert data into the table: "limit_purchase_order_logs" */
  insert_limit_purchase_order_logs?: Maybe<Limit_Purchase_Order_Logs_Mutation_Response>;
  /** insert a single row into the table: "limit_purchase_order_logs" */
  insert_limit_purchase_order_logs_one?: Maybe<Limit_Purchase_Order_Logs>;
  /** insert a single row into the table: "limit_purchase_order" */
  insert_limit_purchase_order_one?: Maybe<Limit_Purchase_Order>;
  /** insert data into the table: "localities" */
  insert_localities?: Maybe<Localities_Mutation_Response>;
  /** insert a single row into the table: "localities" */
  insert_localities_one?: Maybe<Localities>;
  /** insert data into the table: "login_type" */
  insert_login_type?: Maybe<Login_Type_Mutation_Response>;
  /** insert a single row into the table: "login_type" */
  insert_login_type_one?: Maybe<Login_Type>;
  /** insert data into the table: "lpo_exception" */
  insert_lpo_exception?: Maybe<Lpo_Exception_Mutation_Response>;
  /** insert a single row into the table: "lpo_exception" */
  insert_lpo_exception_one?: Maybe<Lpo_Exception>;
  /** insert data into the table: "master_slot" */
  insert_master_slot?: Maybe<Master_Slot_Mutation_Response>;
  /** insert a single row into the table: "master_slot" */
  insert_master_slot_one?: Maybe<Master_Slot>;
  /** insert data into the table: "master_slot_pause" */
  insert_master_slot_pause?: Maybe<Master_Slot_Pause_Mutation_Response>;
  /** insert a single row into the table: "master_slot_pause" */
  insert_master_slot_pause_one?: Maybe<Master_Slot_Pause>;
  /** insert data into the table: "omc_type" */
  insert_omc_type?: Maybe<Omc_Type_Mutation_Response>;
  /** insert a single row into the table: "omc_type" */
  insert_omc_type_one?: Maybe<Omc_Type>;
  /** insert data into the table: "order_photos" */
  insert_order_photos?: Maybe<Order_Photos_Mutation_Response>;
  /** insert a single row into the table: "order_photos" */
  insert_order_photos_one?: Maybe<Order_Photos>;
  /** insert data into the table: "order_scheduler" */
  insert_order_scheduler?: Maybe<Order_Scheduler_Mutation_Response>;
  /** insert data into the table: "order_scheduler_customer_asset" */
  insert_order_scheduler_customer_asset?: Maybe<Order_Scheduler_Customer_Asset_Mutation_Response>;
  /** insert a single row into the table: "order_scheduler_customer_asset" */
  insert_order_scheduler_customer_asset_one?: Maybe<Order_Scheduler_Customer_Asset>;
  /** insert data into the table: "order_scheduler_daily_frequency" */
  insert_order_scheduler_daily_frequency?: Maybe<Order_Scheduler_Daily_Frequency_Mutation_Response>;
  /** insert a single row into the table: "order_scheduler_daily_frequency" */
  insert_order_scheduler_daily_frequency_one?: Maybe<Order_Scheduler_Daily_Frequency>;
  /** insert a single row into the table: "order_scheduler" */
  insert_order_scheduler_one?: Maybe<Order_Scheduler>;
  /** insert data into the table: "order_type" */
  insert_order_type?: Maybe<Order_Type_Mutation_Response>;
  /** insert a single row into the table: "order_type" */
  insert_order_type_one?: Maybe<Order_Type>;
  /** insert data into the table: "organization" */
  insert_organization?: Maybe<Organization_Mutation_Response>;
  /** insert data into the table: "organization_address" */
  insert_organization_address?: Maybe<Organization_Address_Mutation_Response>;
  /** insert a single row into the table: "organization_address" */
  insert_organization_address_one?: Maybe<Organization_Address>;
  /** insert data into the table: "organization_audit_log" */
  insert_organization_audit_log?: Maybe<Organization_Audit_Log_Mutation_Response>;
  /** insert a single row into the table: "organization_audit_log" */
  insert_organization_audit_log_one?: Maybe<Organization_Audit_Log>;
  /** insert data into the table: "organization_commission_product_variation_type" */
  insert_organization_commission_product_variation_type?: Maybe<Organization_Commission_Product_Variation_Type_Mutation_Response>;
  /** insert a single row into the table: "organization_commission_product_variation_type" */
  insert_organization_commission_product_variation_type_one?: Maybe<Organization_Commission_Product_Variation_Type>;
  /** insert data into the table: "organization_configuration" */
  insert_organization_configuration?: Maybe<Organization_Configuration_Mutation_Response>;
  /** insert a single row into the table: "organization_configuration" */
  insert_organization_configuration_one?: Maybe<Organization_Configuration>;
  /** insert a single row into the table: "organization" */
  insert_organization_one?: Maybe<Organization>;
  /** insert data into the table: "organization_product_variation_discount" */
  insert_organization_product_variation_discount?: Maybe<Organization_Product_Variation_Discount_Mutation_Response>;
  /** insert data into the table: "organization_product_variation_discount_history" */
  insert_organization_product_variation_discount_history?: Maybe<Organization_Product_Variation_Discount_History_Mutation_Response>;
  /** insert a single row into the table: "organization_product_variation_discount_history" */
  insert_organization_product_variation_discount_history_one?: Maybe<Organization_Product_Variation_Discount_History>;
  /** insert a single row into the table: "organization_product_variation_discount" */
  insert_organization_product_variation_discount_one?: Maybe<Organization_Product_Variation_Discount>;
  /** insert data into the table: "organization_sales_projection" */
  insert_organization_sales_projection?: Maybe<Organization_Sales_Projection_Mutation_Response>;
  /** insert a single row into the table: "organization_sales_projection" */
  insert_organization_sales_projection_one?: Maybe<Organization_Sales_Projection>;
  /** insert data into the table: "organization_timing" */
  insert_organization_timing?: Maybe<Organization_Timing_Mutation_Response>;
  /** insert a single row into the table: "organization_timing" */
  insert_organization_timing_one?: Maybe<Organization_Timing>;
  /** insert data into the table: "organization_type" */
  insert_organization_type?: Maybe<Organization_Type_Mutation_Response>;
  /** insert a single row into the table: "organization_type" */
  insert_organization_type_one?: Maybe<Organization_Type>;
  /** insert data into the table: "organization_user" */
  insert_organization_user?: Maybe<Organization_User_Mutation_Response>;
  /** insert data into the table: "organization_user_commission" */
  insert_organization_user_commission?: Maybe<Organization_User_Commission_Mutation_Response>;
  /** insert a single row into the table: "organization_user_commission" */
  insert_organization_user_commission_one?: Maybe<Organization_User_Commission>;
  /** insert data into the table: "organization_user_document" */
  insert_organization_user_document?: Maybe<Organization_User_Document_Mutation_Response>;
  /** insert a single row into the table: "organization_user_document" */
  insert_organization_user_document_one?: Maybe<Organization_User_Document>;
  /** insert a single row into the table: "organization_user" */
  insert_organization_user_one?: Maybe<Organization_User>;
  /** insert data into the table: "organization_user_permission" */
  insert_organization_user_permission?: Maybe<Organization_User_Permission_Mutation_Response>;
  /** insert a single row into the table: "organization_user_permission" */
  insert_organization_user_permission_one?: Maybe<Organization_User_Permission>;
  /** insert data into the table: "organization_user_subsidiary" */
  insert_organization_user_subsidiary?: Maybe<Organization_User_Subsidiary_Mutation_Response>;
  /** insert a single row into the table: "organization_user_subsidiary" */
  insert_organization_user_subsidiary_one?: Maybe<Organization_User_Subsidiary>;
  /** insert data into the table: "organization_user_type" */
  insert_organization_user_type?: Maybe<Organization_User_Type_Mutation_Response>;
  /** insert a single row into the table: "organization_user_type" */
  insert_organization_user_type_one?: Maybe<Organization_User_Type>;
  /** insert data into the table: "ownership_type" */
  insert_ownership_type?: Maybe<Ownership_Type_Mutation_Response>;
  /** insert a single row into the table: "ownership_type" */
  insert_ownership_type_one?: Maybe<Ownership_Type>;
  /** insert data into the table: "partner" */
  insert_partner?: Maybe<Partner_Mutation_Response>;
  /** insert data into the table: "partner_address" */
  insert_partner_address?: Maybe<Partner_Address_Mutation_Response>;
  /** insert a single row into the table: "partner_address" */
  insert_partner_address_one?: Maybe<Partner_Address>;
  /** insert data into the table: "partner_bank_details" */
  insert_partner_bank_details?: Maybe<Partner_Bank_Details_Mutation_Response>;
  /** insert a single row into the table: "partner_bank_details" */
  insert_partner_bank_details_one?: Maybe<Partner_Bank_Details>;
  /** insert data into the table: "partner_commission" */
  insert_partner_commission?: Maybe<Partner_Commission_Mutation_Response>;
  /** insert a single row into the table: "partner_commission" */
  insert_partner_commission_one?: Maybe<Partner_Commission>;
  /** insert data into the table: "partner_commission_product_variation_type" */
  insert_partner_commission_product_variation_type?: Maybe<Partner_Commission_Product_Variation_Type_Mutation_Response>;
  /** insert a single row into the table: "partner_commission_product_variation_type" */
  insert_partner_commission_product_variation_type_one?: Maybe<Partner_Commission_Product_Variation_Type>;
  /** insert data into the table: "partner_contact_type" */
  insert_partner_contact_type?: Maybe<Partner_Contact_Type_Mutation_Response>;
  /** insert a single row into the table: "partner_contact_type" */
  insert_partner_contact_type_one?: Maybe<Partner_Contact_Type>;
  /** insert data into the table: "partner_localities" */
  insert_partner_localities?: Maybe<Partner_Localities_Mutation_Response>;
  /** insert a single row into the table: "partner_localities" */
  insert_partner_localities_one?: Maybe<Partner_Localities>;
  /** insert data into the table: "partner_localities_slots" */
  insert_partner_localities_slots?: Maybe<Partner_Localities_Slots_Mutation_Response>;
  /** insert a single row into the table: "partner_localities_slots" */
  insert_partner_localities_slots_one?: Maybe<Partner_Localities_Slots>;
  /** insert a single row into the table: "partner" */
  insert_partner_one?: Maybe<Partner>;
  /** insert data into the table: "partner_order" */
  insert_partner_order?: Maybe<Partner_Order_Mutation_Response>;
  /** insert data into the table: "partner_order_customer_asset" */
  insert_partner_order_customer_asset?: Maybe<Partner_Order_Customer_Asset_Mutation_Response>;
  /** insert a single row into the table: "partner_order_customer_asset" */
  insert_partner_order_customer_asset_one?: Maybe<Partner_Order_Customer_Asset>;
  /** insert data into the table: "partner_order_item" */
  insert_partner_order_item?: Maybe<Partner_Order_Item_Mutation_Response>;
  /** insert data into the table: "partner_order_item_commission" */
  insert_partner_order_item_commission?: Maybe<Partner_Order_Item_Commission_Mutation_Response>;
  /** insert a single row into the table: "partner_order_item_commission" */
  insert_partner_order_item_commission_one?: Maybe<Partner_Order_Item_Commission>;
  /** insert a single row into the table: "partner_order_item" */
  insert_partner_order_item_one?: Maybe<Partner_Order_Item>;
  /** insert data into the table: "partner_order_item_state" */
  insert_partner_order_item_state?: Maybe<Partner_Order_Item_State_Mutation_Response>;
  /** insert a single row into the table: "partner_order_item_state" */
  insert_partner_order_item_state_one?: Maybe<Partner_Order_Item_State>;
  /** insert data into the table: "partner_order_item_stateflow" */
  insert_partner_order_item_stateflow?: Maybe<Partner_Order_Item_Stateflow_Mutation_Response>;
  /** insert a single row into the table: "partner_order_item_stateflow" */
  insert_partner_order_item_stateflow_one?: Maybe<Partner_Order_Item_Stateflow>;
  /** insert data into the table: "partner_order_item_test_category" */
  insert_partner_order_item_test_category?: Maybe<Partner_Order_Item_Test_Category_Mutation_Response>;
  /** insert a single row into the table: "partner_order_item_test_category" */
  insert_partner_order_item_test_category_one?: Maybe<Partner_Order_Item_Test_Category>;
  /** insert data into the table: "partner_order_item_test_results" */
  insert_partner_order_item_test_results?: Maybe<Partner_Order_Item_Test_Results_Mutation_Response>;
  /** insert a single row into the table: "partner_order_item_test_results" */
  insert_partner_order_item_test_results_one?: Maybe<Partner_Order_Item_Test_Results>;
  /** insert data into the table: "partner_order_item_test_results_photos" */
  insert_partner_order_item_test_results_photos?: Maybe<Partner_Order_Item_Test_Results_Photos_Mutation_Response>;
  /** insert a single row into the table: "partner_order_item_test_results_photos" */
  insert_partner_order_item_test_results_photos_one?: Maybe<Partner_Order_Item_Test_Results_Photos>;
  /** insert data into the table: "partner_order_item_value" */
  insert_partner_order_item_value?: Maybe<Partner_Order_Item_Value_Mutation_Response>;
  /** insert a single row into the table: "partner_order_item_value" */
  insert_partner_order_item_value_one?: Maybe<Partner_Order_Item_Value>;
  /** insert a single row into the table: "partner_order" */
  insert_partner_order_one?: Maybe<Partner_Order>;
  /** insert data into the table: "partner_order_partner_user_document" */
  insert_partner_order_partner_user_document?: Maybe<Partner_Order_Partner_User_Document_Mutation_Response>;
  /** insert a single row into the table: "partner_order_partner_user_document" */
  insert_partner_order_partner_user_document_one?: Maybe<Partner_Order_Partner_User_Document>;
  /** insert data into the table: "partner_order_state" */
  insert_partner_order_state?: Maybe<Partner_Order_State_Mutation_Response>;
  /** insert a single row into the table: "partner_order_state" */
  insert_partner_order_state_one?: Maybe<Partner_Order_State>;
  /** insert data into the table: "partner_order_stateflow" */
  insert_partner_order_stateflow?: Maybe<Partner_Order_Stateflow_Mutation_Response>;
  /** insert a single row into the table: "partner_order_stateflow" */
  insert_partner_order_stateflow_one?: Maybe<Partner_Order_Stateflow>;
  /** insert data into the table: "partner_payment" */
  insert_partner_payment?: Maybe<Partner_Payment_Mutation_Response>;
  /** insert a single row into the table: "partner_payment" */
  insert_partner_payment_one?: Maybe<Partner_Payment>;
  /** insert data into the table: "partner_product" */
  insert_partner_product?: Maybe<Partner_Product_Mutation_Response>;
  /** insert a single row into the table: "partner_product" */
  insert_partner_product_one?: Maybe<Partner_Product>;
  /** insert data into the table: "partner_relationship" */
  insert_partner_relationship?: Maybe<Partner_Relationship_Mutation_Response>;
  /** insert a single row into the table: "partner_relationship" */
  insert_partner_relationship_one?: Maybe<Partner_Relationship>;
  /** insert data into the table: "partner_seller" */
  insert_partner_seller?: Maybe<Partner_Seller_Mutation_Response>;
  /** insert a single row into the table: "partner_seller" */
  insert_partner_seller_one?: Maybe<Partner_Seller>;
  /** insert data into the table: "partner_seller_type" */
  insert_partner_seller_type?: Maybe<Partner_Seller_Type_Mutation_Response>;
  /** insert a single row into the table: "partner_seller_type" */
  insert_partner_seller_type_one?: Maybe<Partner_Seller_Type>;
  /** insert data into the table: "partner_signing_authority" */
  insert_partner_signing_authority?: Maybe<Partner_Signing_Authority_Mutation_Response>;
  /** insert a single row into the table: "partner_signing_authority" */
  insert_partner_signing_authority_one?: Maybe<Partner_Signing_Authority>;
  /** insert data into the table: "partner_timing" */
  insert_partner_timing?: Maybe<Partner_Timing_Mutation_Response>;
  /** insert a single row into the table: "partner_timing" */
  insert_partner_timing_one?: Maybe<Partner_Timing>;
  /** insert data into the table: "partner_type" */
  insert_partner_type?: Maybe<Partner_Type_Mutation_Response>;
  /** insert a single row into the table: "partner_type" */
  insert_partner_type_one?: Maybe<Partner_Type>;
  /** insert data into the table: "partner_user" */
  insert_partner_user?: Maybe<Partner_User_Mutation_Response>;
  /** insert data into the table: "partner_user_document" */
  insert_partner_user_document?: Maybe<Partner_User_Document_Mutation_Response>;
  /** insert a single row into the table: "partner_user_document" */
  insert_partner_user_document_one?: Maybe<Partner_User_Document>;
  /** insert a single row into the table: "partner_user" */
  insert_partner_user_one?: Maybe<Partner_User>;
  /** insert data into the table: "partner_user_permission" */
  insert_partner_user_permission?: Maybe<Partner_User_Permission_Mutation_Response>;
  /** insert a single row into the table: "partner_user_permission" */
  insert_partner_user_permission_one?: Maybe<Partner_User_Permission>;
  /** insert data into the table: "partner_vehicle" */
  insert_partner_vehicle?: Maybe<Partner_Vehicle_Mutation_Response>;
  /** insert a single row into the table: "partner_vehicle" */
  insert_partner_vehicle_one?: Maybe<Partner_Vehicle>;
  /** insert data into the table: "partner_vehicle_state" */
  insert_partner_vehicle_state?: Maybe<Partner_Vehicle_State_Mutation_Response>;
  /** insert a single row into the table: "partner_vehicle_state" */
  insert_partner_vehicle_state_one?: Maybe<Partner_Vehicle_State>;
  /** insert data into the table: "payment_type" */
  insert_payment_type?: Maybe<Payment_Type_Mutation_Response>;
  /** insert a single row into the table: "payment_type" */
  insert_payment_type_one?: Maybe<Payment_Type>;
  /** insert data into the table: "period_frequency" */
  insert_period_frequency?: Maybe<Period_Frequency_Mutation_Response>;
  /** insert a single row into the table: "period_frequency" */
  insert_period_frequency_one?: Maybe<Period_Frequency>;
  /** insert data into the table: "permission" */
  insert_permission?: Maybe<Permission_Mutation_Response>;
  /** insert a single row into the table: "permission" */
  insert_permission_one?: Maybe<Permission>;
  /** insert data into the table: "permit" */
  insert_permit?: Maybe<Permit_Mutation_Response>;
  /** insert a single row into the table: "permit" */
  insert_permit_one?: Maybe<Permit>;
  /** insert data into the table: "photo_type" */
  insert_photo_type?: Maybe<Photo_Type_Mutation_Response>;
  /** insert a single row into the table: "photo_type" */
  insert_photo_type_one?: Maybe<Photo_Type>;
  /** insert data into the table: "planning_audit_log" */
  insert_planning_audit_log?: Maybe<Planning_Audit_Log_Mutation_Response>;
  /** insert a single row into the table: "planning_audit_log" */
  insert_planning_audit_log_one?: Maybe<Planning_Audit_Log>;
  /** insert data into the table: "planning_period" */
  insert_planning_period?: Maybe<Planning_Period_Mutation_Response>;
  /** insert a single row into the table: "planning_period" */
  insert_planning_period_one?: Maybe<Planning_Period>;
  /** insert data into the table: "product" */
  insert_product?: Maybe<Product_Mutation_Response>;
  /** insert data into the table: "product_commission" */
  insert_product_commission?: Maybe<Product_Commission_Mutation_Response>;
  /** insert a single row into the table: "product_commission" */
  insert_product_commission_one?: Maybe<Product_Commission>;
  /** insert data into the table: "product_document" */
  insert_product_document?: Maybe<Product_Document_Mutation_Response>;
  /** insert a single row into the table: "product_document" */
  insert_product_document_one?: Maybe<Product_Document>;
  /** insert a single row into the table: "product" */
  insert_product_one?: Maybe<Product>;
  /** insert data into the table: "product_partner_localities_price" */
  insert_product_partner_localities_price?: Maybe<Product_Partner_Localities_Price_Mutation_Response>;
  /** insert data into the table: "product_partner_localities_price_history" */
  insert_product_partner_localities_price_history?: Maybe<Product_Partner_Localities_Price_History_Mutation_Response>;
  /** insert a single row into the table: "product_partner_localities_price_history" */
  insert_product_partner_localities_price_history_one?: Maybe<Product_Partner_Localities_Price_History>;
  /** insert a single row into the table: "product_partner_localities_price" */
  insert_product_partner_localities_price_one?: Maybe<Product_Partner_Localities_Price>;
  /** insert data into the table: "product_photos" */
  insert_product_photos?: Maybe<Product_Photos_Mutation_Response>;
  /** insert a single row into the table: "product_photos" */
  insert_product_photos_one?: Maybe<Product_Photos>;
  /** insert data into the table: "product_type" */
  insert_product_type?: Maybe<Product_Type_Mutation_Response>;
  /** insert a single row into the table: "product_type" */
  insert_product_type_one?: Maybe<Product_Type>;
  /** insert data into the table: "product_variation" */
  insert_product_variation?: Maybe<Product_Variation_Mutation_Response>;
  /** insert a single row into the table: "product_variation" */
  insert_product_variation_one?: Maybe<Product_Variation>;
  /** insert data into the table: "product_variation_partner_localities_slots" */
  insert_product_variation_partner_localities_slots?: Maybe<Product_Variation_Partner_Localities_Slots_Mutation_Response>;
  /** insert a single row into the table: "product_variation_partner_localities_slots" */
  insert_product_variation_partner_localities_slots_one?: Maybe<Product_Variation_Partner_Localities_Slots>;
  /** insert data into the table: "product_variation_photos" */
  insert_product_variation_photos?: Maybe<Product_Variation_Photos_Mutation_Response>;
  /** insert a single row into the table: "product_variation_photos" */
  insert_product_variation_photos_one?: Maybe<Product_Variation_Photos>;
  /** insert data into the table: "product_variation_safety_checklist_category" */
  insert_product_variation_safety_checklist_category?: Maybe<Product_Variation_Safety_Checklist_Category_Mutation_Response>;
  /** insert a single row into the table: "product_variation_safety_checklist_category" */
  insert_product_variation_safety_checklist_category_one?: Maybe<Product_Variation_Safety_Checklist_Category>;
  /** insert data into the table: "product_variation_test_category" */
  insert_product_variation_test_category?: Maybe<Product_Variation_Test_Category_Mutation_Response>;
  /** insert a single row into the table: "product_variation_test_category" */
  insert_product_variation_test_category_one?: Maybe<Product_Variation_Test_Category>;
  /** insert data into the table: "purchase_order" */
  insert_purchase_order?: Maybe<Purchase_Order_Mutation_Response>;
  /** insert data into the table: "purchase_order_items" */
  insert_purchase_order_items?: Maybe<Purchase_Order_Items_Mutation_Response>;
  /** insert a single row into the table: "purchase_order_items" */
  insert_purchase_order_items_one?: Maybe<Purchase_Order_Items>;
  /** insert a single row into the table: "purchase_order" */
  insert_purchase_order_one?: Maybe<Purchase_Order>;
  /** insert data into the table: "quantity_correction_ticket_states" */
  insert_quantity_correction_ticket_states?: Maybe<Quantity_Correction_Ticket_States_Mutation_Response>;
  /** insert a single row into the table: "quantity_correction_ticket_states" */
  insert_quantity_correction_ticket_states_one?: Maybe<Quantity_Correction_Ticket_States>;
  /** insert data into the table: "quantity_correction_tickets" */
  insert_quantity_correction_tickets?: Maybe<Quantity_Correction_Tickets_Mutation_Response>;
  /** insert a single row into the table: "quantity_correction_tickets" */
  insert_quantity_correction_tickets_one?: Maybe<Quantity_Correction_Tickets>;
  /** insert data into the table: "reason_type" */
  insert_reason_type?: Maybe<Reason_Type_Mutation_Response>;
  /** insert a single row into the table: "reason_type" */
  insert_reason_type_one?: Maybe<Reason_Type>;
  /** insert data into the table: "reasons" */
  insert_reasons?: Maybe<Reasons_Mutation_Response>;
  /** insert a single row into the table: "reasons" */
  insert_reasons_one?: Maybe<Reasons>;
  /** insert data into the table: "role" */
  insert_role?: Maybe<Role_Mutation_Response>;
  /** insert data into the table: "role_document" */
  insert_role_document?: Maybe<Role_Document_Mutation_Response>;
  /** insert a single row into the table: "role_document" */
  insert_role_document_one?: Maybe<Role_Document>;
  /** insert a single row into the table: "role" */
  insert_role_one?: Maybe<Role>;
  /** insert data into the table: "safety_checklist" */
  insert_safety_checklist?: Maybe<Safety_Checklist_Mutation_Response>;
  /** insert data into the table: "safety_checklist_category" */
  insert_safety_checklist_category?: Maybe<Safety_Checklist_Category_Mutation_Response>;
  /** insert a single row into the table: "safety_checklist_category" */
  insert_safety_checklist_category_one?: Maybe<Safety_Checklist_Category>;
  /** insert a single row into the table: "safety_checklist" */
  insert_safety_checklist_one?: Maybe<Safety_Checklist>;
  /** insert data into the table: "script_type" */
  insert_script_type?: Maybe<Script_Type_Mutation_Response>;
  /** insert a single row into the table: "script_type" */
  insert_script_type_one?: Maybe<Script_Type>;
  /** insert data into the table: "scripts" */
  insert_scripts?: Maybe<Scripts_Mutation_Response>;
  /** insert a single row into the table: "scripts" */
  insert_scripts_one?: Maybe<Scripts>;
  /** insert data into the table: "services" */
  insert_services?: Maybe<Services_Mutation_Response>;
  /** insert data into the table: "services_category" */
  insert_services_category?: Maybe<Services_Category_Mutation_Response>;
  /** insert a single row into the table: "services_category" */
  insert_services_category_one?: Maybe<Services_Category>;
  /** insert a single row into the table: "services" */
  insert_services_one?: Maybe<Services>;
  /** insert data into the table: "shift_schedule" */
  insert_shift_schedule?: Maybe<Shift_Schedule_Mutation_Response>;
  /** insert data into the table: "shift_schedule_dispenser" */
  insert_shift_schedule_dispenser?: Maybe<Shift_Schedule_Dispenser_Mutation_Response>;
  /** insert a single row into the table: "shift_schedule_dispenser" */
  insert_shift_schedule_dispenser_one?: Maybe<Shift_Schedule_Dispenser>;
  /** insert a single row into the table: "shift_schedule" */
  insert_shift_schedule_one?: Maybe<Shift_Schedule>;
  /** insert data into the table: "shift_template" */
  insert_shift_template?: Maybe<Shift_Template_Mutation_Response>;
  /** insert a single row into the table: "shift_template" */
  insert_shift_template_one?: Maybe<Shift_Template>;
  /** insert data into the table: "slab_type" */
  insert_slab_type?: Maybe<Slab_Type_Mutation_Response>;
  /** insert a single row into the table: "slab_type" */
  insert_slab_type_one?: Maybe<Slab_Type>;
  /** insert data into the table: "source_type" */
  insert_source_type?: Maybe<Source_Type_Mutation_Response>;
  /** insert a single row into the table: "source_type" */
  insert_source_type_one?: Maybe<Source_Type>;
  /** insert data into the table: "spatial_ref_sys" */
  insert_spatial_ref_sys?: Maybe<Spatial_Ref_Sys_Mutation_Response>;
  /** insert a single row into the table: "spatial_ref_sys" */
  insert_spatial_ref_sys_one?: Maybe<Spatial_Ref_Sys>;
  /** insert data into the table: "state" */
  insert_state?: Maybe<State_Mutation_Response>;
  /** insert a single row into the table: "state" */
  insert_state_one?: Maybe<State>;
  /** insert data into the table: "subsidiary" */
  insert_subsidiary?: Maybe<Subsidiary_Mutation_Response>;
  /** insert a single row into the table: "subsidiary" */
  insert_subsidiary_one?: Maybe<Subsidiary>;
  /** insert data into the table: "support_tickets" */
  insert_support_tickets?: Maybe<Support_Tickets_Mutation_Response>;
  /** insert data into the table: "support_tickets_category" */
  insert_support_tickets_category?: Maybe<Support_Tickets_Category_Mutation_Response>;
  /** insert a single row into the table: "support_tickets_category" */
  insert_support_tickets_category_one?: Maybe<Support_Tickets_Category>;
  /** insert a single row into the table: "support_tickets" */
  insert_support_tickets_one?: Maybe<Support_Tickets>;
  /** insert data into the table: "support_tickets_photos" */
  insert_support_tickets_photos?: Maybe<Support_Tickets_Photos_Mutation_Response>;
  /** insert a single row into the table: "support_tickets_photos" */
  insert_support_tickets_photos_one?: Maybe<Support_Tickets_Photos>;
  /** insert data into the table: "tag" */
  insert_tag?: Maybe<Tag_Mutation_Response>;
  /** insert a single row into the table: "tag" */
  insert_tag_one?: Maybe<Tag>;
  /** insert data into the table: "tank_type" */
  insert_tank_type?: Maybe<Tank_Type_Mutation_Response>;
  /** insert a single row into the table: "tank_type" */
  insert_tank_type_one?: Maybe<Tank_Type>;
  /** insert data into the table: "task" */
  insert_task?: Maybe<Task_Mutation_Response>;
  /** insert data into the table: "task_action_instruction" */
  insert_task_action_instruction?: Maybe<Task_Action_Instruction_Mutation_Response>;
  /** insert a single row into the table: "task_action_instruction" */
  insert_task_action_instruction_one?: Maybe<Task_Action_Instruction>;
  /** insert data into the table: "task_action_type" */
  insert_task_action_type?: Maybe<Task_Action_Type_Mutation_Response>;
  /** insert a single row into the table: "task_action_type" */
  insert_task_action_type_one?: Maybe<Task_Action_Type>;
  /** insert data into the table: "task_cancellation_reasons" */
  insert_task_cancellation_reasons?: Maybe<Task_Cancellation_Reasons_Mutation_Response>;
  /** insert a single row into the table: "task_cancellation_reasons" */
  insert_task_cancellation_reasons_one?: Maybe<Task_Cancellation_Reasons>;
  /** insert a single row into the table: "task" */
  insert_task_one?: Maybe<Task>;
  /** insert data into the table: "task_state" */
  insert_task_state?: Maybe<Task_State_Mutation_Response>;
  /** insert a single row into the table: "task_state" */
  insert_task_state_one?: Maybe<Task_State>;
  /** insert data into the table: "task_states_flow" */
  insert_task_states_flow?: Maybe<Task_States_Flow_Mutation_Response>;
  /** insert a single row into the table: "task_states_flow" */
  insert_task_states_flow_one?: Maybe<Task_States_Flow>;
  /** insert data into the table: "task_type" */
  insert_task_type?: Maybe<Task_Type_Mutation_Response>;
  /** insert a single row into the table: "task_type" */
  insert_task_type_one?: Maybe<Task_Type>;
  /** insert data into the table: "task_value" */
  insert_task_value?: Maybe<Task_Value_Mutation_Response>;
  /** insert a single row into the table: "task_value" */
  insert_task_value_one?: Maybe<Task_Value>;
  /** insert data into the table: "test" */
  insert_test?: Maybe<Test_Mutation_Response>;
  /** insert data into the table: "test_category" */
  insert_test_category?: Maybe<Test_Category_Mutation_Response>;
  /** insert a single row into the table: "test_category" */
  insert_test_category_one?: Maybe<Test_Category>;
  /** insert a single row into the table: "test" */
  insert_test_one?: Maybe<Test>;
  /** insert data into the table: "ticket_state" */
  insert_ticket_state?: Maybe<Ticket_State_Mutation_Response>;
  /** insert a single row into the table: "ticket_state" */
  insert_ticket_state_one?: Maybe<Ticket_State>;
  /** insert data into the table: "ticket_type" */
  insert_ticket_type?: Maybe<Ticket_Type_Mutation_Response>;
  /** insert a single row into the table: "ticket_type" */
  insert_ticket_type_one?: Maybe<Ticket_Type>;
  /** insert data into the table: "tickets" */
  insert_tickets?: Maybe<Tickets_Mutation_Response>;
  /** insert a single row into the table: "tickets" */
  insert_tickets_one?: Maybe<Tickets>;
  /** insert data into the table: "totalizer_correction_ticket_states" */
  insert_totalizer_correction_ticket_states?: Maybe<Totalizer_Correction_Ticket_States_Mutation_Response>;
  /** insert a single row into the table: "totalizer_correction_ticket_states" */
  insert_totalizer_correction_ticket_states_one?: Maybe<Totalizer_Correction_Ticket_States>;
  /** insert data into the table: "totalizer_correction_tickets" */
  insert_totalizer_correction_tickets?: Maybe<Totalizer_Correction_Tickets_Mutation_Response>;
  /** insert a single row into the table: "totalizer_correction_tickets" */
  insert_totalizer_correction_tickets_one?: Maybe<Totalizer_Correction_Tickets>;
  /** insert data into the table: "transaction_type" */
  insert_transaction_type?: Maybe<Transaction_Type_Mutation_Response>;
  /** insert a single row into the table: "transaction_type" */
  insert_transaction_type_one?: Maybe<Transaction_Type>;
  /** insert data into the table: "trip" */
  insert_trip?: Maybe<Trip_Mutation_Response>;
  /** insert data into the table: "trip_location" */
  insert_trip_location?: Maybe<Trip_Location_Mutation_Response>;
  /** insert a single row into the table: "trip_location" */
  insert_trip_location_one?: Maybe<Trip_Location>;
  /** insert a single row into the table: "trip" */
  insert_trip_one?: Maybe<Trip>;
  /** insert data into the table: "trip_plan" */
  insert_trip_plan?: Maybe<Trip_Plan_Mutation_Response>;
  /** insert a single row into the table: "trip_plan" */
  insert_trip_plan_one?: Maybe<Trip_Plan>;
  /** insert data into the table: "unit_of_measure" */
  insert_unit_of_measure?: Maybe<Unit_Of_Measure_Mutation_Response>;
  /** insert data into the table: "unit_of_measure_meta" */
  insert_unit_of_measure_meta?: Maybe<Unit_Of_Measure_Meta_Mutation_Response>;
  /** insert a single row into the table: "unit_of_measure_meta" */
  insert_unit_of_measure_meta_one?: Maybe<Unit_Of_Measure_Meta>;
  /** insert a single row into the table: "unit_of_measure" */
  insert_unit_of_measure_one?: Maybe<Unit_Of_Measure>;
  /** insert data into the table: "uom_conversion" */
  insert_uom_conversion?: Maybe<Uom_Conversion_Mutation_Response>;
  /** insert a single row into the table: "uom_conversion" */
  insert_uom_conversion_one?: Maybe<Uom_Conversion>;
  /** insert data into the table: "user" */
  insert_user?: Maybe<User_Mutation_Response>;
  /** insert data into the table: "user_access_audit_log" */
  insert_user_access_audit_log?: Maybe<User_Access_Audit_Log_Mutation_Response>;
  /** insert a single row into the table: "user_access_audit_log" */
  insert_user_access_audit_log_one?: Maybe<User_Access_Audit_Log>;
  /** insert data into the table: "user_ledger" */
  insert_user_ledger?: Maybe<User_Ledger_Mutation_Response>;
  /** insert a single row into the table: "user_ledger" */
  insert_user_ledger_one?: Maybe<User_Ledger>;
  /** insert a single row into the table: "user" */
  insert_user_one?: Maybe<User>;
  /** insert data into the table: "user_partner_type" */
  insert_user_partner_type?: Maybe<User_Partner_Type_Mutation_Response>;
  /** insert a single row into the table: "user_partner_type" */
  insert_user_partner_type_one?: Maybe<User_Partner_Type>;
  /** insert data into the table: "user_referral" */
  insert_user_referral?: Maybe<User_Referral_Mutation_Response>;
  /** insert a single row into the table: "user_referral" */
  insert_user_referral_one?: Maybe<User_Referral>;
  /** insert data into the table: "user_role" */
  insert_user_role?: Maybe<User_Role_Mutation_Response>;
  /** insert a single row into the table: "user_role" */
  insert_user_role_one?: Maybe<User_Role>;
  /** insert data into the table: "validation_workflows" */
  insert_validation_workflows?: Maybe<Validation_Workflows_Mutation_Response>;
  /** insert a single row into the table: "validation_workflows" */
  insert_validation_workflows_one?: Maybe<Validation_Workflows>;
  /** insert data into the table: "variation" */
  insert_variation?: Maybe<Variation_Mutation_Response>;
  /** insert a single row into the table: "variation" */
  insert_variation_one?: Maybe<Variation>;
  /** insert data into the table: "variation_type" */
  insert_variation_type?: Maybe<Variation_Type_Mutation_Response>;
  /** insert a single row into the table: "variation_type" */
  insert_variation_type_one?: Maybe<Variation_Type>;
  /** insert data into the table: "vehicle" */
  insert_vehicle?: Maybe<Vehicle_Mutation_Response>;
  /** insert data into the table: "vehicle_configuration" */
  insert_vehicle_configuration?: Maybe<Vehicle_Configuration_Mutation_Response>;
  /** insert a single row into the table: "vehicle_configuration" */
  insert_vehicle_configuration_one?: Maybe<Vehicle_Configuration>;
  /** insert data into the table: "vehicle_device" */
  insert_vehicle_device?: Maybe<Vehicle_Device_Mutation_Response>;
  /** insert data into the table: "vehicle_device_calibration" */
  insert_vehicle_device_calibration?: Maybe<Vehicle_Device_Calibration_Mutation_Response>;
  /** insert a single row into the table: "vehicle_device_calibration" */
  insert_vehicle_device_calibration_one?: Maybe<Vehicle_Device_Calibration>;
  /** insert a single row into the table: "vehicle_device" */
  insert_vehicle_device_one?: Maybe<Vehicle_Device>;
  /** insert data into the table: "vehicle_inventory_transaction_logs" */
  insert_vehicle_inventory_transaction_logs?: Maybe<Vehicle_Inventory_Transaction_Logs_Mutation_Response>;
  /** insert a single row into the table: "vehicle_inventory_transaction_logs" */
  insert_vehicle_inventory_transaction_logs_one?: Maybe<Vehicle_Inventory_Transaction_Logs>;
  /** insert data into the table: "vehicle_localities" */
  insert_vehicle_localities?: Maybe<Vehicle_Localities_Mutation_Response>;
  /** insert a single row into the table: "vehicle_localities" */
  insert_vehicle_localities_one?: Maybe<Vehicle_Localities>;
  /** insert a single row into the table: "vehicle" */
  insert_vehicle_one?: Maybe<Vehicle>;
  /** insert data into the table: "vehicle_permit" */
  insert_vehicle_permit?: Maybe<Vehicle_Permit_Mutation_Response>;
  /** insert a single row into the table: "vehicle_permit" */
  insert_vehicle_permit_one?: Maybe<Vehicle_Permit>;
  /** insert data into the table: "vehicle_shift_template" */
  insert_vehicle_shift_template?: Maybe<Vehicle_Shift_Template_Mutation_Response>;
  /** insert a single row into the table: "vehicle_shift_template" */
  insert_vehicle_shift_template_one?: Maybe<Vehicle_Shift_Template>;
  /** insert data into the table: "vehicle_status" */
  insert_vehicle_status?: Maybe<Vehicle_Status_Mutation_Response>;
  /** insert data into the table: "vehicle_status_logs" */
  insert_vehicle_status_logs?: Maybe<Vehicle_Status_Logs_Mutation_Response>;
  /** insert a single row into the table: "vehicle_status_logs" */
  insert_vehicle_status_logs_one?: Maybe<Vehicle_Status_Logs>;
  /** insert a single row into the table: "vehicle_status" */
  insert_vehicle_status_one?: Maybe<Vehicle_Status>;
  /** insert data into the table: "vehicle_tank_type" */
  insert_vehicle_tank_type?: Maybe<Vehicle_Tank_Type_Mutation_Response>;
  /** insert a single row into the table: "vehicle_tank_type" */
  insert_vehicle_tank_type_one?: Maybe<Vehicle_Tank_Type>;
  /** insert data into the table: "vehicle_tank_type_product_variation" */
  insert_vehicle_tank_type_product_variation?: Maybe<Vehicle_Tank_Type_Product_Variation_Mutation_Response>;
  /** insert a single row into the table: "vehicle_tank_type_product_variation" */
  insert_vehicle_tank_type_product_variation_one?: Maybe<Vehicle_Tank_Type_Product_Variation>;
  /** insert data into the table: "vehicle_type" */
  insert_vehicle_type?: Maybe<Vehicle_Type_Mutation_Response>;
  /** insert a single row into the table: "vehicle_type" */
  insert_vehicle_type_one?: Maybe<Vehicle_Type>;
  /** insert data into the table: "vendor_order_logs" */
  insert_vendor_order_logs?: Maybe<Vendor_Order_Logs_Mutation_Response>;
  /** insert a single row into the table: "vendor_order_logs" */
  insert_vendor_order_logs_one?: Maybe<Vendor_Order_Logs>;
  /** insert data into the table: "vendor_sync_status" */
  insert_vendor_sync_status?: Maybe<Vendor_Sync_Status_Mutation_Response>;
  /** insert a single row into the table: "vendor_sync_status" */
  insert_vendor_sync_status_one?: Maybe<Vendor_Sync_Status>;
  /** insert data into the table: "voucher" */
  insert_voucher?: Maybe<Voucher_Mutation_Response>;
  /** insert a single row into the table: "voucher" */
  insert_voucher_one?: Maybe<Voucher>;
  /** insert data into the table: "wallet" */
  insert_wallet?: Maybe<Wallet_Mutation_Response>;
  /** insert data into the table: "wallet_exception" */
  insert_wallet_exception?: Maybe<Wallet_Exception_Mutation_Response>;
  /** insert a single row into the table: "wallet_exception" */
  insert_wallet_exception_one?: Maybe<Wallet_Exception>;
  /** insert data into the table: "wallet_ledger" */
  insert_wallet_ledger?: Maybe<Wallet_Ledger_Mutation_Response>;
  /** insert a single row into the table: "wallet_ledger" */
  insert_wallet_ledger_one?: Maybe<Wallet_Ledger>;
  /** insert a single row into the table: "wallet" */
  insert_wallet_one?: Maybe<Wallet>;
  /** insert data into the table: "wallet_state" */
  insert_wallet_state?: Maybe<Wallet_State_Mutation_Response>;
  /** insert a single row into the table: "wallet_state" */
  insert_wallet_state_one?: Maybe<Wallet_State>;
  /** insert data into the table: "wallet_transactions" */
  insert_wallet_transactions?: Maybe<Wallet_Transactions_Mutation_Response>;
  /** insert a single row into the table: "wallet_transactions" */
  insert_wallet_transactions_one?: Maybe<Wallet_Transactions>;
  /** IDEV-2620: check whether a Delivery Note is invoiced by a submitted Sales Invoice (department re-tag gate) */
  isDeliveryNoteInvoiced?: Maybe<IsDeliveryNoteInvoicedOutput>;
  /** isShiftScheduleExist */
  isShiftScheduleExist?: Maybe<IsShiftScheduleExistOutput>;
  /** Migrate organization data (customer, addresses, assets) to ERP system */
  migrateCustomerToErp?: Maybe<MigrateCustomerToErpOutput>;
  orderDeliveryAutomation?: Maybe<OrderDeliveryAutomationOutput>;
  /** This is pay through wallet */
  payThroughWallet?: Maybe<PayThroughWalletOutput>;
  /** Push current department (active subsidiary) from Hasura onto custom_department of linked Delivery Notes in ERPNext */
  pushDepartmentToErp?: Maybe<PushDepartmentToErpOutput>;
  reassignShiftSchedule?: Maybe<ReassignShiftScheduleOutput>;
  reassignTask?: Maybe<ReassignTaskOutput>;
  /** Rectify a wallet drift finding. Branch selects the corrective action — MISSING_INSERT, MISMATCH_REPLACE, ORPHAN_DELETE, or DUPLICATE_DEDUPE. Soft-delete-and-replace; recomputes wallet.amount. Single finding per call. */
  rectifyWalletDrift?: Maybe<RectifyWalletDriftOutput>;
  /** Release a wallet block on dispensing cancellation */
  releaseWalletBlock?: Maybe<ReleaseWalletBlockOutput>;
  rescheduleTask?: Maybe<RescheduleTaskOutput>;
  /** IDEV-2805: re-tag a single delivery note (cancel+amend / recreate) for the Temporal retag workflow */
  retagDeliveryNote?: Maybe<RetagDeliveryNoteOutput>;
  /** Send aggregated invoice data to ET webhook using date range and organization ID with dual calculation methods (amount_based and rate_based) */
  sendInvoiceToEt?: Maybe<SendInvoiceToEtResponse>;
  /** Send transaction logs to ET webhook for invoiced items */
  sendTransactionLogsToEt?: Maybe<SendTransactionLogsToEtResponse>;
  /** Send transaction logs to ET webhook for invoiced items (v1) */
  sendTransactionLogsToEtV1?: Maybe<SendTransactionLogsToEtResponseV1>;
  /** IDEV-2809: SCD-2 reconcile — shift an address to a department (close-old + insert-new interval) */
  shiftAddressDepartment?: Maybe<ShiftAddressDepartmentOutput>;
  /** IDEV-2809: SCD-2 reconcile — shift an asset to a department (close-old + insert-new interval) */
  shiftAssetDepartment?: Maybe<ShiftAssetDepartmentOutput>;
  /** Activate or deactivate an organization with audit logging. Requires reason_id from the reasons table (reason_type ORGANIZATION_STATUS_CHANGE). Only path to flip is_active — direct update permissions exclude that column. */
  toggleOrganizationActive?: Maybe<ToggleOrganizationActiveOutput>;
  /** Enable or disable a user account with Firebase cascading and audit logging */
  toggleUserStatus?: Maybe<ToggleUserStatusOutput>;
  /** Trigger delivery note creation by incrementing version on invoiced items */
  triggerDeliveryNote?: Maybe<TriggerDeliveryNoteOutput>;
  /** execute VOLATILE function "unblock_wallet_amount" which returns "wallet" */
  unblock_wallet_amount: Array<Wallet>;
  updateCustomerAssetBasedOnOrderCode?: Maybe<UpdateCustomerAssetBasedOnOrderCodeOutput>;
  updateCustomerOrderItemUnitPrice?: Maybe<UpdateCustomerOrderItemOutput>;
  /** IDEV-2620: retro re-tag a Delivery Note department (gated — locked once invoiced) */
  updateDeliveryNoteDepartment?: Maybe<UpdateDeliveryNoteDepartmentOutput>;
  updateDispensedQty?: Maybe<UpdateDispensedQtyOutput>;
  updateDispensingDate?: Maybe<UpdateDispensingDateOutput>;
  updateInvoice?: Maybe<UpdateInvoiceOutput>;
  updateOdometerReading?: Maybe<UpdateOdometerReadingOutput>;
  updateOrderDateByOrderCode?: Maybe<UpdateOrderDateByOrderCodeOutput>;
  /** Franchise Accepted Order */
  updateOrderItemToAccepted?: Maybe<UpdateOrderItemToAcceptedOutput>;
  updateOrderStateByOrderCode?: Maybe<UpdateOrderStateByOrderCodeOutput>;
  /** updateProductPartnerLocalitiesPrice */
  updateProductPartnerLocalitiesPrice?: Maybe<UpdateProductPartnerLocalitiesPriceOutput>;
  /** Update subsidiary claims for user */
  updateSubsidiary?: Maybe<UpdateSubsidiaryOutput>;
  updateTask?: Maybe<UpdateTaskOutput>;
  updateWalletAmount?: Maybe<UpdateWalletAmountOutput>;
  /** update data of the table: "address_subsidiary" */
  update_address_subsidiary?: Maybe<Address_Subsidiary_Mutation_Response>;
  /** update data of the table: "address_subsidiary_audit_logs" */
  update_address_subsidiary_audit_logs?: Maybe<Address_Subsidiary_Audit_Logs_Mutation_Response>;
  /** update single row of the table: "address_subsidiary_audit_logs" */
  update_address_subsidiary_audit_logs_by_pk?: Maybe<Address_Subsidiary_Audit_Logs>;
  /** update multiples rows of table: "address_subsidiary_audit_logs" */
  update_address_subsidiary_audit_logs_many?: Maybe<Array<Maybe<Address_Subsidiary_Audit_Logs_Mutation_Response>>>;
  /** update single row of the table: "address_subsidiary" */
  update_address_subsidiary_by_pk?: Maybe<Address_Subsidiary>;
  /** update multiples rows of table: "address_subsidiary" */
  update_address_subsidiary_many?: Maybe<Array<Maybe<Address_Subsidiary_Mutation_Response>>>;
  /** update data of the table: "address_type" */
  update_address_type?: Maybe<Address_Type_Mutation_Response>;
  /** update single row of the table: "address_type" */
  update_address_type_by_pk?: Maybe<Address_Type>;
  /** update multiples rows of table: "address_type" */
  update_address_type_many?: Maybe<Array<Maybe<Address_Type_Mutation_Response>>>;
  /** update data of the table: "asset_grouping" */
  update_asset_grouping?: Maybe<Asset_Grouping_Mutation_Response>;
  /** update single row of the table: "asset_grouping" */
  update_asset_grouping_by_pk?: Maybe<Asset_Grouping>;
  /** update data of the table: "asset_grouping_customer_asset" */
  update_asset_grouping_customer_asset?: Maybe<Asset_Grouping_Customer_Asset_Mutation_Response>;
  /** update single row of the table: "asset_grouping_customer_asset" */
  update_asset_grouping_customer_asset_by_pk?: Maybe<Asset_Grouping_Customer_Asset>;
  /** update multiples rows of table: "asset_grouping_customer_asset" */
  update_asset_grouping_customer_asset_many?: Maybe<Array<Maybe<Asset_Grouping_Customer_Asset_Mutation_Response>>>;
  /** update multiples rows of table: "asset_grouping" */
  update_asset_grouping_many?: Maybe<Array<Maybe<Asset_Grouping_Mutation_Response>>>;
  /** update data of the table: "asset_subsidiary" */
  update_asset_subsidiary?: Maybe<Asset_Subsidiary_Mutation_Response>;
  /** update data of the table: "asset_subsidiary_audit_logs" */
  update_asset_subsidiary_audit_logs?: Maybe<Asset_Subsidiary_Audit_Logs_Mutation_Response>;
  /** update single row of the table: "asset_subsidiary_audit_logs" */
  update_asset_subsidiary_audit_logs_by_pk?: Maybe<Asset_Subsidiary_Audit_Logs>;
  /** update multiples rows of table: "asset_subsidiary_audit_logs" */
  update_asset_subsidiary_audit_logs_many?: Maybe<Array<Maybe<Asset_Subsidiary_Audit_Logs_Mutation_Response>>>;
  /** update single row of the table: "asset_subsidiary" */
  update_asset_subsidiary_by_pk?: Maybe<Asset_Subsidiary>;
  /** update multiples rows of table: "asset_subsidiary" */
  update_asset_subsidiary_many?: Maybe<Array<Maybe<Asset_Subsidiary_Mutation_Response>>>;
  /** update data of the table: "asset_type" */
  update_asset_type?: Maybe<Asset_Type_Mutation_Response>;
  /** update single row of the table: "asset_type" */
  update_asset_type_by_pk?: Maybe<Asset_Type>;
  /** update data of the table: "asset_type_category" */
  update_asset_type_category?: Maybe<Asset_Type_Category_Mutation_Response>;
  /** update single row of the table: "asset_type_category" */
  update_asset_type_category_by_pk?: Maybe<Asset_Type_Category>;
  /** update multiples rows of table: "asset_type_category" */
  update_asset_type_category_many?: Maybe<Array<Maybe<Asset_Type_Category_Mutation_Response>>>;
  /** update multiples rows of table: "asset_type" */
  update_asset_type_many?: Maybe<Array<Maybe<Asset_Type_Mutation_Response>>>;
  /** update data of the table: "associated_type" */
  update_associated_type?: Maybe<Associated_Type_Mutation_Response>;
  /** update single row of the table: "associated_type" */
  update_associated_type_by_pk?: Maybe<Associated_Type>;
  /** update multiples rows of table: "associated_type" */
  update_associated_type_many?: Maybe<Array<Maybe<Associated_Type_Mutation_Response>>>;
  /** update data of the table: "audit_log_action" */
  update_audit_log_action?: Maybe<Audit_Log_Action_Mutation_Response>;
  /** update single row of the table: "audit_log_action" */
  update_audit_log_action_by_pk?: Maybe<Audit_Log_Action>;
  /** update multiples rows of table: "audit_log_action" */
  update_audit_log_action_many?: Maybe<Array<Maybe<Audit_Log_Action_Mutation_Response>>>;
  /** update data of the table: "cancellation_reasons" */
  update_cancellation_reasons?: Maybe<Cancellation_Reasons_Mutation_Response>;
  /** update single row of the table: "cancellation_reasons" */
  update_cancellation_reasons_by_pk?: Maybe<Cancellation_Reasons>;
  /** update multiples rows of table: "cancellation_reasons" */
  update_cancellation_reasons_many?: Maybe<Array<Maybe<Cancellation_Reasons_Mutation_Response>>>;
  /** update data of the table: "category" */
  update_category?: Maybe<Category_Mutation_Response>;
  /** update single row of the table: "category" */
  update_category_by_pk?: Maybe<Category>;
  /** update multiples rows of table: "category" */
  update_category_many?: Maybe<Array<Maybe<Category_Mutation_Response>>>;
  /** update data of the table: "city" */
  update_city?: Maybe<City_Mutation_Response>;
  /** update single row of the table: "city" */
  update_city_by_pk?: Maybe<City>;
  /** update multiples rows of table: "city" */
  update_city_many?: Maybe<Array<Maybe<City_Mutation_Response>>>;
  /** update data of the table: "country" */
  update_country?: Maybe<Country_Mutation_Response>;
  /** update single row of the table: "country" */
  update_country_by_pk?: Maybe<Country>;
  /** update multiples rows of table: "country" */
  update_country_many?: Maybe<Array<Maybe<Country_Mutation_Response>>>;
  /** update data of the table: "credit_breach" */
  update_credit_breach?: Maybe<Credit_Breach_Mutation_Response>;
  /** update single row of the table: "credit_breach" */
  update_credit_breach_by_pk?: Maybe<Credit_Breach>;
  /** update multiples rows of table: "credit_breach" */
  update_credit_breach_many?: Maybe<Array<Maybe<Credit_Breach_Mutation_Response>>>;
  /** update data of the table: "currency" */
  update_currency?: Maybe<Currency_Mutation_Response>;
  /** update single row of the table: "currency" */
  update_currency_by_pk?: Maybe<Currency>;
  /** update data of the table: "currency_conversion" */
  update_currency_conversion?: Maybe<Currency_Conversion_Mutation_Response>;
  /** update single row of the table: "currency_conversion" */
  update_currency_conversion_by_pk?: Maybe<Currency_Conversion>;
  /** update multiples rows of table: "currency_conversion" */
  update_currency_conversion_many?: Maybe<Array<Maybe<Currency_Conversion_Mutation_Response>>>;
  /** update multiples rows of table: "currency" */
  update_currency_many?: Maybe<Array<Maybe<Currency_Mutation_Response>>>;
  /** update data of the table: "customer_asset" */
  update_customer_asset?: Maybe<Customer_Asset_Mutation_Response>;
  /** update data of the table: "customer_asset_audit_log" */
  update_customer_asset_audit_log?: Maybe<Customer_Asset_Audit_Log_Mutation_Response>;
  /** update single row of the table: "customer_asset_audit_log" */
  update_customer_asset_audit_log_by_pk?: Maybe<Customer_Asset_Audit_Log>;
  /** update multiples rows of table: "customer_asset_audit_log" */
  update_customer_asset_audit_log_many?: Maybe<Array<Maybe<Customer_Asset_Audit_Log_Mutation_Response>>>;
  /** update single row of the table: "customer_asset" */
  update_customer_asset_by_pk?: Maybe<Customer_Asset>;
  /** update data of the table: "customer_asset_device" */
  update_customer_asset_device?: Maybe<Customer_Asset_Device_Mutation_Response>;
  /** update single row of the table: "customer_asset_device" */
  update_customer_asset_device_by_pk?: Maybe<Customer_Asset_Device>;
  /** update data of the table: "customer_asset_device_calibration" */
  update_customer_asset_device_calibration?: Maybe<Customer_Asset_Device_Calibration_Mutation_Response>;
  /** update single row of the table: "customer_asset_device_calibration" */
  update_customer_asset_device_calibration_by_pk?: Maybe<Customer_Asset_Device_Calibration>;
  /** update multiples rows of table: "customer_asset_device_calibration" */
  update_customer_asset_device_calibration_many?: Maybe<Array<Maybe<Customer_Asset_Device_Calibration_Mutation_Response>>>;
  /** update multiples rows of table: "customer_asset_device" */
  update_customer_asset_device_many?: Maybe<Array<Maybe<Customer_Asset_Device_Mutation_Response>>>;
  /** update data of the table: "customer_asset_dispensing_rules" */
  update_customer_asset_dispensing_rules?: Maybe<Customer_Asset_Dispensing_Rules_Mutation_Response>;
  /** update single row of the table: "customer_asset_dispensing_rules" */
  update_customer_asset_dispensing_rules_by_pk?: Maybe<Customer_Asset_Dispensing_Rules>;
  /** update multiples rows of table: "customer_asset_dispensing_rules" */
  update_customer_asset_dispensing_rules_many?: Maybe<Array<Maybe<Customer_Asset_Dispensing_Rules_Mutation_Response>>>;
  /** update data of the table: "customer_asset_limit" */
  update_customer_asset_limit?: Maybe<Customer_Asset_Limit_Mutation_Response>;
  /** update single row of the table: "customer_asset_limit" */
  update_customer_asset_limit_by_pk?: Maybe<Customer_Asset_Limit>;
  /** update multiples rows of table: "customer_asset_limit" */
  update_customer_asset_limit_many?: Maybe<Array<Maybe<Customer_Asset_Limit_Mutation_Response>>>;
  /** update multiples rows of table: "customer_asset" */
  update_customer_asset_many?: Maybe<Array<Maybe<Customer_Asset_Mutation_Response>>>;
  /** update data of the table: "customer_asset_tag" */
  update_customer_asset_tag?: Maybe<Customer_Asset_Tag_Mutation_Response>;
  /** update single row of the table: "customer_asset_tag" */
  update_customer_asset_tag_by_pk?: Maybe<Customer_Asset_Tag>;
  /** update multiples rows of table: "customer_asset_tag" */
  update_customer_asset_tag_many?: Maybe<Array<Maybe<Customer_Asset_Tag_Mutation_Response>>>;
  /** update data of the table: "customer_order" */
  update_customer_order?: Maybe<Customer_Order_Mutation_Response>;
  /** update single row of the table: "customer_order" */
  update_customer_order_by_pk?: Maybe<Customer_Order>;
  /** update data of the table: "customer_order_cancellation_reasons" */
  update_customer_order_cancellation_reasons?: Maybe<Customer_Order_Cancellation_Reasons_Mutation_Response>;
  /** update single row of the table: "customer_order_cancellation_reasons" */
  update_customer_order_cancellation_reasons_by_pk?: Maybe<Customer_Order_Cancellation_Reasons>;
  /** update multiples rows of table: "customer_order_cancellation_reasons" */
  update_customer_order_cancellation_reasons_many?: Maybe<Array<Maybe<Customer_Order_Cancellation_Reasons_Mutation_Response>>>;
  /** update data of the table: "customer_order_customer_asset" */
  update_customer_order_customer_asset?: Maybe<Customer_Order_Customer_Asset_Mutation_Response>;
  /** update single row of the table: "customer_order_customer_asset" */
  update_customer_order_customer_asset_by_pk?: Maybe<Customer_Order_Customer_Asset>;
  /** update multiples rows of table: "customer_order_customer_asset" */
  update_customer_order_customer_asset_many?: Maybe<Array<Maybe<Customer_Order_Customer_Asset_Mutation_Response>>>;
  /** update data of the table: "customer_order_item" */
  update_customer_order_item?: Maybe<Customer_Order_Item_Mutation_Response>;
  /** update single row of the table: "customer_order_item" */
  update_customer_order_item_by_pk?: Maybe<Customer_Order_Item>;
  /** update data of the table: "customer_order_item_cancellation_reasons" */
  update_customer_order_item_cancellation_reasons?: Maybe<Customer_Order_Item_Cancellation_Reasons_Mutation_Response>;
  /** update single row of the table: "customer_order_item_cancellation_reasons" */
  update_customer_order_item_cancellation_reasons_by_pk?: Maybe<Customer_Order_Item_Cancellation_Reasons>;
  /** update multiples rows of table: "customer_order_item_cancellation_reasons" */
  update_customer_order_item_cancellation_reasons_many?: Maybe<Array<Maybe<Customer_Order_Item_Cancellation_Reasons_Mutation_Response>>>;
  /** update data of the table: "customer_order_item_comments" */
  update_customer_order_item_comments?: Maybe<Customer_Order_Item_Comments_Mutation_Response>;
  /** update single row of the table: "customer_order_item_comments" */
  update_customer_order_item_comments_by_pk?: Maybe<Customer_Order_Item_Comments>;
  /** update multiples rows of table: "customer_order_item_comments" */
  update_customer_order_item_comments_many?: Maybe<Array<Maybe<Customer_Order_Item_Comments_Mutation_Response>>>;
  /** update data of the table: "customer_order_item_commission" */
  update_customer_order_item_commission?: Maybe<Customer_Order_Item_Commission_Mutation_Response>;
  /** update single row of the table: "customer_order_item_commission" */
  update_customer_order_item_commission_by_pk?: Maybe<Customer_Order_Item_Commission>;
  /** update multiples rows of table: "customer_order_item_commission" */
  update_customer_order_item_commission_many?: Maybe<Array<Maybe<Customer_Order_Item_Commission_Mutation_Response>>>;
  /** update data of the table: "customer_order_item_etd_transactional_logs" */
  update_customer_order_item_etd_transactional_logs?: Maybe<Customer_Order_Item_Etd_Transactional_Logs_Mutation_Response>;
  /** update single row of the table: "customer_order_item_etd_transactional_logs" */
  update_customer_order_item_etd_transactional_logs_by_pk?: Maybe<Customer_Order_Item_Etd_Transactional_Logs>;
  /** update multiples rows of table: "customer_order_item_etd_transactional_logs" */
  update_customer_order_item_etd_transactional_logs_many?: Maybe<Array<Maybe<Customer_Order_Item_Etd_Transactional_Logs_Mutation_Response>>>;
  /** update multiples rows of table: "customer_order_item" */
  update_customer_order_item_many?: Maybe<Array<Maybe<Customer_Order_Item_Mutation_Response>>>;
  /** update data of the table: "customer_order_item_partner" */
  update_customer_order_item_partner?: Maybe<Customer_Order_Item_Partner_Mutation_Response>;
  /** update single row of the table: "customer_order_item_partner" */
  update_customer_order_item_partner_by_pk?: Maybe<Customer_Order_Item_Partner>;
  /** update multiples rows of table: "customer_order_item_partner" */
  update_customer_order_item_partner_many?: Maybe<Array<Maybe<Customer_Order_Item_Partner_Mutation_Response>>>;
  /** update data of the table: "customer_order_item_safety_checklist_results" */
  update_customer_order_item_safety_checklist_results?: Maybe<Customer_Order_Item_Safety_Checklist_Results_Mutation_Response>;
  /** update single row of the table: "customer_order_item_safety_checklist_results" */
  update_customer_order_item_safety_checklist_results_by_pk?: Maybe<Customer_Order_Item_Safety_Checklist_Results>;
  /** update multiples rows of table: "customer_order_item_safety_checklist_results" */
  update_customer_order_item_safety_checklist_results_many?: Maybe<Array<Maybe<Customer_Order_Item_Safety_Checklist_Results_Mutation_Response>>>;
  /** update data of the table: "customer_order_item_state" */
  update_customer_order_item_state?: Maybe<Customer_Order_Item_State_Mutation_Response>;
  /** update single row of the table: "customer_order_item_state" */
  update_customer_order_item_state_by_pk?: Maybe<Customer_Order_Item_State>;
  /** update multiples rows of table: "customer_order_item_state" */
  update_customer_order_item_state_many?: Maybe<Array<Maybe<Customer_Order_Item_State_Mutation_Response>>>;
  /** update data of the table: "customer_order_item_stateflow" */
  update_customer_order_item_stateflow?: Maybe<Customer_Order_Item_Stateflow_Mutation_Response>;
  /** update single row of the table: "customer_order_item_stateflow" */
  update_customer_order_item_stateflow_by_pk?: Maybe<Customer_Order_Item_Stateflow>;
  /** update multiples rows of table: "customer_order_item_stateflow" */
  update_customer_order_item_stateflow_many?: Maybe<Array<Maybe<Customer_Order_Item_Stateflow_Mutation_Response>>>;
  /** update data of the table: "customer_order_item_test_category" */
  update_customer_order_item_test_category?: Maybe<Customer_Order_Item_Test_Category_Mutation_Response>;
  /** update single row of the table: "customer_order_item_test_category" */
  update_customer_order_item_test_category_by_pk?: Maybe<Customer_Order_Item_Test_Category>;
  /** update multiples rows of table: "customer_order_item_test_category" */
  update_customer_order_item_test_category_many?: Maybe<Array<Maybe<Customer_Order_Item_Test_Category_Mutation_Response>>>;
  /** update data of the table: "customer_order_item_test_results" */
  update_customer_order_item_test_results?: Maybe<Customer_Order_Item_Test_Results_Mutation_Response>;
  /** update single row of the table: "customer_order_item_test_results" */
  update_customer_order_item_test_results_by_pk?: Maybe<Customer_Order_Item_Test_Results>;
  /** update multiples rows of table: "customer_order_item_test_results" */
  update_customer_order_item_test_results_many?: Maybe<Array<Maybe<Customer_Order_Item_Test_Results_Mutation_Response>>>;
  /** update data of the table: "customer_order_item_test_results_photos" */
  update_customer_order_item_test_results_photos?: Maybe<Customer_Order_Item_Test_Results_Photos_Mutation_Response>;
  /** update single row of the table: "customer_order_item_test_results_photos" */
  update_customer_order_item_test_results_photos_by_pk?: Maybe<Customer_Order_Item_Test_Results_Photos>;
  /** update multiples rows of table: "customer_order_item_test_results_photos" */
  update_customer_order_item_test_results_photos_many?: Maybe<Array<Maybe<Customer_Order_Item_Test_Results_Photos_Mutation_Response>>>;
  /** update multiples rows of table: "customer_order" */
  update_customer_order_many?: Maybe<Array<Maybe<Customer_Order_Mutation_Response>>>;
  /** update data of the table: "customer_order_organization_user_document" */
  update_customer_order_organization_user_document?: Maybe<Customer_Order_Organization_User_Document_Mutation_Response>;
  /** update single row of the table: "customer_order_organization_user_document" */
  update_customer_order_organization_user_document_by_pk?: Maybe<Customer_Order_Organization_User_Document>;
  /** update multiples rows of table: "customer_order_organization_user_document" */
  update_customer_order_organization_user_document_many?: Maybe<Array<Maybe<Customer_Order_Organization_User_Document_Mutation_Response>>>;
  /** update data of the table: "customer_order_partner_order" */
  update_customer_order_partner_order?: Maybe<Customer_Order_Partner_Order_Mutation_Response>;
  /** update single row of the table: "customer_order_partner_order" */
  update_customer_order_partner_order_by_pk?: Maybe<Customer_Order_Partner_Order>;
  /** update multiples rows of table: "customer_order_partner_order" */
  update_customer_order_partner_order_many?: Maybe<Array<Maybe<Customer_Order_Partner_Order_Mutation_Response>>>;
  /** update data of the table: "customer_order_slots" */
  update_customer_order_slots?: Maybe<Customer_Order_Slots_Mutation_Response>;
  /** update single row of the table: "customer_order_slots" */
  update_customer_order_slots_by_pk?: Maybe<Customer_Order_Slots>;
  /** update multiples rows of table: "customer_order_slots" */
  update_customer_order_slots_many?: Maybe<Array<Maybe<Customer_Order_Slots_Mutation_Response>>>;
  /** update data of the table: "customer_order_state" */
  update_customer_order_state?: Maybe<Customer_Order_State_Mutation_Response>;
  /** update single row of the table: "customer_order_state" */
  update_customer_order_state_by_pk?: Maybe<Customer_Order_State>;
  /** update multiples rows of table: "customer_order_state" */
  update_customer_order_state_many?: Maybe<Array<Maybe<Customer_Order_State_Mutation_Response>>>;
  /** update data of the table: "customer_order_stateflow" */
  update_customer_order_stateflow?: Maybe<Customer_Order_Stateflow_Mutation_Response>;
  /** update single row of the table: "customer_order_stateflow" */
  update_customer_order_stateflow_by_pk?: Maybe<Customer_Order_Stateflow>;
  /** update multiples rows of table: "customer_order_stateflow" */
  update_customer_order_stateflow_many?: Maybe<Array<Maybe<Customer_Order_Stateflow_Mutation_Response>>>;
  /** update data of the table: "customer_payment" */
  update_customer_payment?: Maybe<Customer_Payment_Mutation_Response>;
  /** update single row of the table: "customer_payment" */
  update_customer_payment_by_pk?: Maybe<Customer_Payment>;
  /** update multiples rows of table: "customer_payment" */
  update_customer_payment_many?: Maybe<Array<Maybe<Customer_Payment_Mutation_Response>>>;
  /** update data of the table: "customer_payment_status" */
  update_customer_payment_status?: Maybe<Customer_Payment_Status_Mutation_Response>;
  /** update single row of the table: "customer_payment_status" */
  update_customer_payment_status_by_pk?: Maybe<Customer_Payment_Status>;
  /** update multiples rows of table: "customer_payment_status" */
  update_customer_payment_status_many?: Maybe<Array<Maybe<Customer_Payment_Status_Mutation_Response>>>;
  /** update data of the table: "customer_segmentation" */
  update_customer_segmentation?: Maybe<Customer_Segmentation_Mutation_Response>;
  /** update single row of the table: "customer_segmentation" */
  update_customer_segmentation_by_pk?: Maybe<Customer_Segmentation>;
  /** update multiples rows of table: "customer_segmentation" */
  update_customer_segmentation_many?: Maybe<Array<Maybe<Customer_Segmentation_Mutation_Response>>>;
  /** update data of the table: "day_type" */
  update_day_type?: Maybe<Day_Type_Mutation_Response>;
  /** update single row of the table: "day_type" */
  update_day_type_by_pk?: Maybe<Day_Type>;
  /** update multiples rows of table: "day_type" */
  update_day_type_many?: Maybe<Array<Maybe<Day_Type_Mutation_Response>>>;
  /** update data of the table: "delivery_preferences" */
  update_delivery_preferences?: Maybe<Delivery_Preferences_Mutation_Response>;
  /** update single row of the table: "delivery_preferences" */
  update_delivery_preferences_by_pk?: Maybe<Delivery_Preferences>;
  /** update multiples rows of table: "delivery_preferences" */
  update_delivery_preferences_many?: Maybe<Array<Maybe<Delivery_Preferences_Mutation_Response>>>;
  /** update data of the table: "delivery_scheduler" */
  update_delivery_scheduler?: Maybe<Delivery_Scheduler_Mutation_Response>;
  /** update single row of the table: "delivery_scheduler" */
  update_delivery_scheduler_by_pk?: Maybe<Delivery_Scheduler>;
  /** update multiples rows of table: "delivery_scheduler" */
  update_delivery_scheduler_many?: Maybe<Array<Maybe<Delivery_Scheduler_Mutation_Response>>>;
  /** update data of the table: "delivery_scheduler_product_item" */
  update_delivery_scheduler_product_item?: Maybe<Delivery_Scheduler_Product_Item_Mutation_Response>;
  /** update single row of the table: "delivery_scheduler_product_item" */
  update_delivery_scheduler_product_item_by_pk?: Maybe<Delivery_Scheduler_Product_Item>;
  /** update multiples rows of table: "delivery_scheduler_product_item" */
  update_delivery_scheduler_product_item_many?: Maybe<Array<Maybe<Delivery_Scheduler_Product_Item_Mutation_Response>>>;
  /** update data of the table: "department_retag_request" */
  update_department_retag_request?: Maybe<Department_Retag_Request_Mutation_Response>;
  /** update single row of the table: "department_retag_request" */
  update_department_retag_request_by_pk?: Maybe<Department_Retag_Request>;
  /** update multiples rows of table: "department_retag_request" */
  update_department_retag_request_many?: Maybe<Array<Maybe<Department_Retag_Request_Mutation_Response>>>;
  /** update data of the table: "device_devicetype_paramerter_definition" */
  update_device_devicetype_paramerter_definition?: Maybe<Device_Devicetype_Paramerter_Definition_Mutation_Response>;
  /** update single row of the table: "device_devicetype_paramerter_definition" */
  update_device_devicetype_paramerter_definition_by_pk?: Maybe<Device_Devicetype_Paramerter_Definition>;
  /** update multiples rows of table: "device_devicetype_paramerter_definition" */
  update_device_devicetype_paramerter_definition_many?: Maybe<Array<Maybe<Device_Devicetype_Paramerter_Definition_Mutation_Response>>>;
  /** update data of the table: "devicetype" */
  update_devicetype?: Maybe<Devicetype_Mutation_Response>;
  /** update single row of the table: "devicetype" */
  update_devicetype_by_pk?: Maybe<Devicetype>;
  /** update multiples rows of table: "devicetype" */
  update_devicetype_many?: Maybe<Array<Maybe<Devicetype_Mutation_Response>>>;
  /** update data of the table: "devicetype_paramerter_definition" */
  update_devicetype_paramerter_definition?: Maybe<Devicetype_Paramerter_Definition_Mutation_Response>;
  /** update single row of the table: "devicetype_paramerter_definition" */
  update_devicetype_paramerter_definition_by_pk?: Maybe<Devicetype_Paramerter_Definition>;
  /** update multiples rows of table: "devicetype_paramerter_definition" */
  update_devicetype_paramerter_definition_many?: Maybe<Array<Maybe<Devicetype_Paramerter_Definition_Mutation_Response>>>;
  /** update data of the table: "devicetype_parameter_group" */
  update_devicetype_parameter_group?: Maybe<Devicetype_Parameter_Group_Mutation_Response>;
  /** update single row of the table: "devicetype_parameter_group" */
  update_devicetype_parameter_group_by_pk?: Maybe<Devicetype_Parameter_Group>;
  /** update multiples rows of table: "devicetype_parameter_group" */
  update_devicetype_parameter_group_many?: Maybe<Array<Maybe<Devicetype_Parameter_Group_Mutation_Response>>>;
  /** update data of the table: "discount_type" */
  update_discount_type?: Maybe<Discount_Type_Mutation_Response>;
  /** update single row of the table: "discount_type" */
  update_discount_type_by_pk?: Maybe<Discount_Type>;
  /** update multiples rows of table: "discount_type" */
  update_discount_type_many?: Maybe<Array<Maybe<Discount_Type_Mutation_Response>>>;
  /** update data of the table: "dispenser" */
  update_dispenser?: Maybe<Dispenser_Mutation_Response>;
  /** update single row of the table: "dispenser" */
  update_dispenser_by_pk?: Maybe<Dispenser>;
  /** update data of the table: "dispenser_configuration" */
  update_dispenser_configuration?: Maybe<Dispenser_Configuration_Mutation_Response>;
  /** update single row of the table: "dispenser_configuration" */
  update_dispenser_configuration_by_pk?: Maybe<Dispenser_Configuration>;
  /** update multiples rows of table: "dispenser_configuration" */
  update_dispenser_configuration_many?: Maybe<Array<Maybe<Dispenser_Configuration_Mutation_Response>>>;
  /** update multiples rows of table: "dispenser" */
  update_dispenser_many?: Maybe<Array<Maybe<Dispenser_Mutation_Response>>>;
  /** update data of the table: "dispenser_type" */
  update_dispenser_type?: Maybe<Dispenser_Type_Mutation_Response>;
  /** update single row of the table: "dispenser_type" */
  update_dispenser_type_by_pk?: Maybe<Dispenser_Type>;
  /** update multiples rows of table: "dispenser_type" */
  update_dispenser_type_many?: Maybe<Array<Maybe<Dispenser_Type_Mutation_Response>>>;
  /** update data of the table: "dispensing_rules" */
  update_dispensing_rules?: Maybe<Dispensing_Rules_Mutation_Response>;
  /** update single row of the table: "dispensing_rules" */
  update_dispensing_rules_by_pk?: Maybe<Dispensing_Rules>;
  /** update multiples rows of table: "dispensing_rules" */
  update_dispensing_rules_many?: Maybe<Array<Maybe<Dispensing_Rules_Mutation_Response>>>;
  /** update data of the table: "document_type" */
  update_document_type?: Maybe<Document_Type_Mutation_Response>;
  /** update single row of the table: "document_type" */
  update_document_type_by_pk?: Maybe<Document_Type>;
  /** update data of the table: "document_type_category" */
  update_document_type_category?: Maybe<Document_Type_Category_Mutation_Response>;
  /** update single row of the table: "document_type_category" */
  update_document_type_category_by_pk?: Maybe<Document_Type_Category>;
  /** update multiples rows of table: "document_type_category" */
  update_document_type_category_many?: Maybe<Array<Maybe<Document_Type_Category_Mutation_Response>>>;
  /** update multiples rows of table: "document_type" */
  update_document_type_many?: Maybe<Array<Maybe<Document_Type_Mutation_Response>>>;
  /** update data of the table: "documents" */
  update_documents?: Maybe<Documents_Mutation_Response>;
  /** update single row of the table: "documents" */
  update_documents_by_pk?: Maybe<Documents>;
  /** update multiples rows of table: "documents" */
  update_documents_many?: Maybe<Array<Maybe<Documents_Mutation_Response>>>;
  /** update data of the table: "driver_duty_log" */
  update_driver_duty_log?: Maybe<Driver_Duty_Log_Mutation_Response>;
  /** update single row of the table: "driver_duty_log" */
  update_driver_duty_log_by_pk?: Maybe<Driver_Duty_Log>;
  /** update multiples rows of table: "driver_duty_log" */
  update_driver_duty_log_many?: Maybe<Array<Maybe<Driver_Duty_Log_Mutation_Response>>>;
  /** update data of the table: "driver_duty_photos" */
  update_driver_duty_photos?: Maybe<Driver_Duty_Photos_Mutation_Response>;
  /** update single row of the table: "driver_duty_photos" */
  update_driver_duty_photos_by_pk?: Maybe<Driver_Duty_Photos>;
  /** update multiples rows of table: "driver_duty_photos" */
  update_driver_duty_photos_many?: Maybe<Array<Maybe<Driver_Duty_Photos_Mutation_Response>>>;
  /** update data of the table: "driver_permit" */
  update_driver_permit?: Maybe<Driver_Permit_Mutation_Response>;
  /** update single row of the table: "driver_permit" */
  update_driver_permit_by_pk?: Maybe<Driver_Permit>;
  /** update multiples rows of table: "driver_permit" */
  update_driver_permit_many?: Maybe<Array<Maybe<Driver_Permit_Mutation_Response>>>;
  /** update data of the table: "driver_vehicle" */
  update_driver_vehicle?: Maybe<Driver_Vehicle_Mutation_Response>;
  /** update single row of the table: "driver_vehicle" */
  update_driver_vehicle_by_pk?: Maybe<Driver_Vehicle>;
  /** update data of the table: "driver_vehicle_issue" */
  update_driver_vehicle_issue?: Maybe<Driver_Vehicle_Issue_Mutation_Response>;
  /** update single row of the table: "driver_vehicle_issue" */
  update_driver_vehicle_issue_by_pk?: Maybe<Driver_Vehicle_Issue>;
  /** update multiples rows of table: "driver_vehicle_issue" */
  update_driver_vehicle_issue_many?: Maybe<Array<Maybe<Driver_Vehicle_Issue_Mutation_Response>>>;
  /** update data of the table: "driver_vehicle_location" */
  update_driver_vehicle_location?: Maybe<Driver_Vehicle_Location_Mutation_Response>;
  /** update single row of the table: "driver_vehicle_location" */
  update_driver_vehicle_location_by_pk?: Maybe<Driver_Vehicle_Location>;
  /** update multiples rows of table: "driver_vehicle_location" */
  update_driver_vehicle_location_many?: Maybe<Array<Maybe<Driver_Vehicle_Location_Mutation_Response>>>;
  /** update multiples rows of table: "driver_vehicle" */
  update_driver_vehicle_many?: Maybe<Array<Maybe<Driver_Vehicle_Mutation_Response>>>;
  /** update data of the table: "erp_sync_status" */
  update_erp_sync_status?: Maybe<Erp_Sync_Status_Mutation_Response>;
  /** update single row of the table: "erp_sync_status" */
  update_erp_sync_status_by_pk?: Maybe<Erp_Sync_Status>;
  /** update multiples rows of table: "erp_sync_status" */
  update_erp_sync_status_many?: Maybe<Array<Maybe<Erp_Sync_Status_Mutation_Response>>>;
  /** update data of the table: "fillup_request" */
  update_fillup_request?: Maybe<Fillup_Request_Mutation_Response>;
  /** update single row of the table: "fillup_request" */
  update_fillup_request_by_pk?: Maybe<Fillup_Request>;
  /** update multiples rows of table: "fillup_request" */
  update_fillup_request_many?: Maybe<Array<Maybe<Fillup_Request_Mutation_Response>>>;
  /** update data of the table: "fillup_request_status" */
  update_fillup_request_status?: Maybe<Fillup_Request_Status_Mutation_Response>;
  /** update single row of the table: "fillup_request_status" */
  update_fillup_request_status_by_pk?: Maybe<Fillup_Request_Status>;
  /** update multiples rows of table: "fillup_request_status" */
  update_fillup_request_status_many?: Maybe<Array<Maybe<Fillup_Request_Status_Mutation_Response>>>;
  /** update data of the table: "fuel_request_type" */
  update_fuel_request_type?: Maybe<Fuel_Request_Type_Mutation_Response>;
  /** update single row of the table: "fuel_request_type" */
  update_fuel_request_type_by_pk?: Maybe<Fuel_Request_Type>;
  /** update multiples rows of table: "fuel_request_type" */
  update_fuel_request_type_many?: Maybe<Array<Maybe<Fuel_Request_Type_Mutation_Response>>>;
  /** update data of the table: "fueltrans_transaction_logs" */
  update_fueltrans_transaction_logs?: Maybe<Fueltrans_Transaction_Logs_Mutation_Response>;
  /** update single row of the table: "fueltrans_transaction_logs" */
  update_fueltrans_transaction_logs_by_pk?: Maybe<Fueltrans_Transaction_Logs>;
  /** update multiples rows of table: "fueltrans_transaction_logs" */
  update_fueltrans_transaction_logs_many?: Maybe<Array<Maybe<Fueltrans_Transaction_Logs_Mutation_Response>>>;
  /** update data of the table: "geometry_columns" */
  update_geometry_columns?: Maybe<Geometry_Columns_Mutation_Response>;
  /** update multiples rows of table: "geometry_columns" */
  update_geometry_columns_many?: Maybe<Array<Maybe<Geometry_Columns_Mutation_Response>>>;
  /** update data of the table: "inventory" */
  update_inventory?: Maybe<Inventory_Mutation_Response>;
  /** update single row of the table: "inventory" */
  update_inventory_by_pk?: Maybe<Inventory>;
  /** update multiples rows of table: "inventory" */
  update_inventory_many?: Maybe<Array<Maybe<Inventory_Mutation_Response>>>;
  /** update data of the table: "inventory_workflow_logs" */
  update_inventory_workflow_logs?: Maybe<Inventory_Workflow_Logs_Mutation_Response>;
  /** update single row of the table: "inventory_workflow_logs" */
  update_inventory_workflow_logs_by_pk?: Maybe<Inventory_Workflow_Logs>;
  /** update multiples rows of table: "inventory_workflow_logs" */
  update_inventory_workflow_logs_many?: Maybe<Array<Maybe<Inventory_Workflow_Logs_Mutation_Response>>>;
  /** update data of the table: "invitation" */
  update_invitation?: Maybe<Invitation_Mutation_Response>;
  /** update single row of the table: "invitation" */
  update_invitation_by_pk?: Maybe<Invitation>;
  /** update multiples rows of table: "invitation" */
  update_invitation_many?: Maybe<Array<Maybe<Invitation_Mutation_Response>>>;
  /** update data of the table: "invitation_status" */
  update_invitation_status?: Maybe<Invitation_Status_Mutation_Response>;
  /** update single row of the table: "invitation_status" */
  update_invitation_status_by_pk?: Maybe<Invitation_Status>;
  /** update multiples rows of table: "invitation_status" */
  update_invitation_status_many?: Maybe<Array<Maybe<Invitation_Status_Mutation_Response>>>;
  /** update data of the table: "invoice" */
  update_invoice?: Maybe<Invoice_Mutation_Response>;
  /** update single row of the table: "invoice" */
  update_invoice_by_pk?: Maybe<Invoice>;
  /** update multiples rows of table: "invoice" */
  update_invoice_many?: Maybe<Array<Maybe<Invoice_Mutation_Response>>>;
  /** update data of the table: "invoiced_item" */
  update_invoiced_item?: Maybe<Invoiced_Item_Mutation_Response>;
  /** update single row of the table: "invoiced_item" */
  update_invoiced_item_by_pk?: Maybe<Invoiced_Item>;
  /** update data of the table: "invoiced_item_cancellation_ticket_states" */
  update_invoiced_item_cancellation_ticket_states?: Maybe<Invoiced_Item_Cancellation_Ticket_States_Mutation_Response>;
  /** update single row of the table: "invoiced_item_cancellation_ticket_states" */
  update_invoiced_item_cancellation_ticket_states_by_pk?: Maybe<Invoiced_Item_Cancellation_Ticket_States>;
  /** update multiples rows of table: "invoiced_item_cancellation_ticket_states" */
  update_invoiced_item_cancellation_ticket_states_many?: Maybe<Array<Maybe<Invoiced_Item_Cancellation_Ticket_States_Mutation_Response>>>;
  /** update data of the table: "invoiced_item_cancellation_tickets" */
  update_invoiced_item_cancellation_tickets?: Maybe<Invoiced_Item_Cancellation_Tickets_Mutation_Response>;
  /** update single row of the table: "invoiced_item_cancellation_tickets" */
  update_invoiced_item_cancellation_tickets_by_pk?: Maybe<Invoiced_Item_Cancellation_Tickets>;
  /** update multiples rows of table: "invoiced_item_cancellation_tickets" */
  update_invoiced_item_cancellation_tickets_many?: Maybe<Array<Maybe<Invoiced_Item_Cancellation_Tickets_Mutation_Response>>>;
  /** update multiples rows of table: "invoiced_item" */
  update_invoiced_item_many?: Maybe<Array<Maybe<Invoiced_Item_Mutation_Response>>>;
  /** update data of the table: "issue" */
  update_issue?: Maybe<Issue_Mutation_Response>;
  /** update single row of the table: "issue" */
  update_issue_by_pk?: Maybe<Issue>;
  /** update multiples rows of table: "issue" */
  update_issue_many?: Maybe<Array<Maybe<Issue_Mutation_Response>>>;
  /** update data of the table: "job_state" */
  update_job_state?: Maybe<Job_State_Mutation_Response>;
  /** update single row of the table: "job_state" */
  update_job_state_by_pk?: Maybe<Job_State>;
  /** update multiples rows of table: "job_state" */
  update_job_state_many?: Maybe<Array<Maybe<Job_State_Mutation_Response>>>;
  /** update data of the table: "job_type" */
  update_job_type?: Maybe<Job_Type_Mutation_Response>;
  /** update single row of the table: "job_type" */
  update_job_type_by_pk?: Maybe<Job_Type>;
  /** update multiples rows of table: "job_type" */
  update_job_type_many?: Maybe<Array<Maybe<Job_Type_Mutation_Response>>>;
  /** update data of the table: "job_type_template" */
  update_job_type_template?: Maybe<Job_Type_Template_Mutation_Response>;
  /** update single row of the table: "job_type_template" */
  update_job_type_template_by_pk?: Maybe<Job_Type_Template>;
  /** update multiples rows of table: "job_type_template" */
  update_job_type_template_many?: Maybe<Array<Maybe<Job_Type_Template_Mutation_Response>>>;
  /** update data of the table: "jobs" */
  update_jobs?: Maybe<Jobs_Mutation_Response>;
  /** update single row of the table: "jobs" */
  update_jobs_by_pk?: Maybe<Jobs>;
  /** update multiples rows of table: "jobs" */
  update_jobs_many?: Maybe<Array<Maybe<Jobs_Mutation_Response>>>;
  /** update data of the table: "jobs_state_flow" */
  update_jobs_state_flow?: Maybe<Jobs_State_Flow_Mutation_Response>;
  /** update single row of the table: "jobs_state_flow" */
  update_jobs_state_flow_by_pk?: Maybe<Jobs_State_Flow>;
  /** update multiples rows of table: "jobs_state_flow" */
  update_jobs_state_flow_many?: Maybe<Array<Maybe<Jobs_State_Flow_Mutation_Response>>>;
  /** update data of the table: "limit_purchase_order" */
  update_limit_purchase_order?: Maybe<Limit_Purchase_Order_Mutation_Response>;
  /** update single row of the table: "limit_purchase_order" */
  update_limit_purchase_order_by_pk?: Maybe<Limit_Purchase_Order>;
  /** update data of the table: "limit_purchase_order_logs" */
  update_limit_purchase_order_logs?: Maybe<Limit_Purchase_Order_Logs_Mutation_Response>;
  /** update single row of the table: "limit_purchase_order_logs" */
  update_limit_purchase_order_logs_by_pk?: Maybe<Limit_Purchase_Order_Logs>;
  /** update multiples rows of table: "limit_purchase_order_logs" */
  update_limit_purchase_order_logs_many?: Maybe<Array<Maybe<Limit_Purchase_Order_Logs_Mutation_Response>>>;
  /** update multiples rows of table: "limit_purchase_order" */
  update_limit_purchase_order_many?: Maybe<Array<Maybe<Limit_Purchase_Order_Mutation_Response>>>;
  /** update data of the table: "localities" */
  update_localities?: Maybe<Localities_Mutation_Response>;
  /** update single row of the table: "localities" */
  update_localities_by_pk?: Maybe<Localities>;
  /** update multiples rows of table: "localities" */
  update_localities_many?: Maybe<Array<Maybe<Localities_Mutation_Response>>>;
  /** update data of the table: "login_type" */
  update_login_type?: Maybe<Login_Type_Mutation_Response>;
  /** update single row of the table: "login_type" */
  update_login_type_by_pk?: Maybe<Login_Type>;
  /** update multiples rows of table: "login_type" */
  update_login_type_many?: Maybe<Array<Maybe<Login_Type_Mutation_Response>>>;
  /** update data of the table: "lpo_exception" */
  update_lpo_exception?: Maybe<Lpo_Exception_Mutation_Response>;
  /** update single row of the table: "lpo_exception" */
  update_lpo_exception_by_pk?: Maybe<Lpo_Exception>;
  /** update multiples rows of table: "lpo_exception" */
  update_lpo_exception_many?: Maybe<Array<Maybe<Lpo_Exception_Mutation_Response>>>;
  /** update data of the table: "master_slot" */
  update_master_slot?: Maybe<Master_Slot_Mutation_Response>;
  /** update single row of the table: "master_slot" */
  update_master_slot_by_pk?: Maybe<Master_Slot>;
  /** update multiples rows of table: "master_slot" */
  update_master_slot_many?: Maybe<Array<Maybe<Master_Slot_Mutation_Response>>>;
  /** update data of the table: "master_slot_pause" */
  update_master_slot_pause?: Maybe<Master_Slot_Pause_Mutation_Response>;
  /** update single row of the table: "master_slot_pause" */
  update_master_slot_pause_by_pk?: Maybe<Master_Slot_Pause>;
  /** update multiples rows of table: "master_slot_pause" */
  update_master_slot_pause_many?: Maybe<Array<Maybe<Master_Slot_Pause_Mutation_Response>>>;
  /** update data of the table: "omc_type" */
  update_omc_type?: Maybe<Omc_Type_Mutation_Response>;
  /** update single row of the table: "omc_type" */
  update_omc_type_by_pk?: Maybe<Omc_Type>;
  /** update multiples rows of table: "omc_type" */
  update_omc_type_many?: Maybe<Array<Maybe<Omc_Type_Mutation_Response>>>;
  /** update data of the table: "order_photos" */
  update_order_photos?: Maybe<Order_Photos_Mutation_Response>;
  /** update single row of the table: "order_photos" */
  update_order_photos_by_pk?: Maybe<Order_Photos>;
  /** update multiples rows of table: "order_photos" */
  update_order_photos_many?: Maybe<Array<Maybe<Order_Photos_Mutation_Response>>>;
  /** update data of the table: "order_scheduler" */
  update_order_scheduler?: Maybe<Order_Scheduler_Mutation_Response>;
  /** update single row of the table: "order_scheduler" */
  update_order_scheduler_by_pk?: Maybe<Order_Scheduler>;
  /** update data of the table: "order_scheduler_customer_asset" */
  update_order_scheduler_customer_asset?: Maybe<Order_Scheduler_Customer_Asset_Mutation_Response>;
  /** update single row of the table: "order_scheduler_customer_asset" */
  update_order_scheduler_customer_asset_by_pk?: Maybe<Order_Scheduler_Customer_Asset>;
  /** update multiples rows of table: "order_scheduler_customer_asset" */
  update_order_scheduler_customer_asset_many?: Maybe<Array<Maybe<Order_Scheduler_Customer_Asset_Mutation_Response>>>;
  /** update data of the table: "order_scheduler_daily_frequency" */
  update_order_scheduler_daily_frequency?: Maybe<Order_Scheduler_Daily_Frequency_Mutation_Response>;
  /** update single row of the table: "order_scheduler_daily_frequency" */
  update_order_scheduler_daily_frequency_by_pk?: Maybe<Order_Scheduler_Daily_Frequency>;
  /** update multiples rows of table: "order_scheduler_daily_frequency" */
  update_order_scheduler_daily_frequency_many?: Maybe<Array<Maybe<Order_Scheduler_Daily_Frequency_Mutation_Response>>>;
  /** update multiples rows of table: "order_scheduler" */
  update_order_scheduler_many?: Maybe<Array<Maybe<Order_Scheduler_Mutation_Response>>>;
  /** update data of the table: "order_type" */
  update_order_type?: Maybe<Order_Type_Mutation_Response>;
  /** update single row of the table: "order_type" */
  update_order_type_by_pk?: Maybe<Order_Type>;
  /** update multiples rows of table: "order_type" */
  update_order_type_many?: Maybe<Array<Maybe<Order_Type_Mutation_Response>>>;
  /** update data of the table: "organization" */
  update_organization?: Maybe<Organization_Mutation_Response>;
  /** update data of the table: "organization_address" */
  update_organization_address?: Maybe<Organization_Address_Mutation_Response>;
  /** update single row of the table: "organization_address" */
  update_organization_address_by_pk?: Maybe<Organization_Address>;
  /** update multiples rows of table: "organization_address" */
  update_organization_address_many?: Maybe<Array<Maybe<Organization_Address_Mutation_Response>>>;
  /** update data of the table: "organization_audit_log" */
  update_organization_audit_log?: Maybe<Organization_Audit_Log_Mutation_Response>;
  /** update single row of the table: "organization_audit_log" */
  update_organization_audit_log_by_pk?: Maybe<Organization_Audit_Log>;
  /** update multiples rows of table: "organization_audit_log" */
  update_organization_audit_log_many?: Maybe<Array<Maybe<Organization_Audit_Log_Mutation_Response>>>;
  /** update single row of the table: "organization" */
  update_organization_by_pk?: Maybe<Organization>;
  /** update data of the table: "organization_commission_product_variation_type" */
  update_organization_commission_product_variation_type?: Maybe<Organization_Commission_Product_Variation_Type_Mutation_Response>;
  /** update single row of the table: "organization_commission_product_variation_type" */
  update_organization_commission_product_variation_type_by_pk?: Maybe<Organization_Commission_Product_Variation_Type>;
  /** update multiples rows of table: "organization_commission_product_variation_type" */
  update_organization_commission_product_variation_type_many?: Maybe<Array<Maybe<Organization_Commission_Product_Variation_Type_Mutation_Response>>>;
  /** update data of the table: "organization_configuration" */
  update_organization_configuration?: Maybe<Organization_Configuration_Mutation_Response>;
  /** update single row of the table: "organization_configuration" */
  update_organization_configuration_by_pk?: Maybe<Organization_Configuration>;
  /** update multiples rows of table: "organization_configuration" */
  update_organization_configuration_many?: Maybe<Array<Maybe<Organization_Configuration_Mutation_Response>>>;
  /** update multiples rows of table: "organization" */
  update_organization_many?: Maybe<Array<Maybe<Organization_Mutation_Response>>>;
  /** update data of the table: "organization_product_variation_discount" */
  update_organization_product_variation_discount?: Maybe<Organization_Product_Variation_Discount_Mutation_Response>;
  /** update single row of the table: "organization_product_variation_discount" */
  update_organization_product_variation_discount_by_pk?: Maybe<Organization_Product_Variation_Discount>;
  /** update data of the table: "organization_product_variation_discount_history" */
  update_organization_product_variation_discount_history?: Maybe<Organization_Product_Variation_Discount_History_Mutation_Response>;
  /** update single row of the table: "organization_product_variation_discount_history" */
  update_organization_product_variation_discount_history_by_pk?: Maybe<Organization_Product_Variation_Discount_History>;
  /** update multiples rows of table: "organization_product_variation_discount_history" */
  update_organization_product_variation_discount_history_many?: Maybe<Array<Maybe<Organization_Product_Variation_Discount_History_Mutation_Response>>>;
  /** update multiples rows of table: "organization_product_variation_discount" */
  update_organization_product_variation_discount_many?: Maybe<Array<Maybe<Organization_Product_Variation_Discount_Mutation_Response>>>;
  /** update data of the table: "organization_sales_projection" */
  update_organization_sales_projection?: Maybe<Organization_Sales_Projection_Mutation_Response>;
  /** update single row of the table: "organization_sales_projection" */
  update_organization_sales_projection_by_pk?: Maybe<Organization_Sales_Projection>;
  /** update multiples rows of table: "organization_sales_projection" */
  update_organization_sales_projection_many?: Maybe<Array<Maybe<Organization_Sales_Projection_Mutation_Response>>>;
  /** update data of the table: "organization_timing" */
  update_organization_timing?: Maybe<Organization_Timing_Mutation_Response>;
  /** update single row of the table: "organization_timing" */
  update_organization_timing_by_pk?: Maybe<Organization_Timing>;
  /** update multiples rows of table: "organization_timing" */
  update_organization_timing_many?: Maybe<Array<Maybe<Organization_Timing_Mutation_Response>>>;
  /** update data of the table: "organization_type" */
  update_organization_type?: Maybe<Organization_Type_Mutation_Response>;
  /** update single row of the table: "organization_type" */
  update_organization_type_by_pk?: Maybe<Organization_Type>;
  /** update multiples rows of table: "organization_type" */
  update_organization_type_many?: Maybe<Array<Maybe<Organization_Type_Mutation_Response>>>;
  /** update data of the table: "organization_user" */
  update_organization_user?: Maybe<Organization_User_Mutation_Response>;
  /** update single row of the table: "organization_user" */
  update_organization_user_by_pk?: Maybe<Organization_User>;
  /** update data of the table: "organization_user_commission" */
  update_organization_user_commission?: Maybe<Organization_User_Commission_Mutation_Response>;
  /** update single row of the table: "organization_user_commission" */
  update_organization_user_commission_by_pk?: Maybe<Organization_User_Commission>;
  /** update multiples rows of table: "organization_user_commission" */
  update_organization_user_commission_many?: Maybe<Array<Maybe<Organization_User_Commission_Mutation_Response>>>;
  /** update data of the table: "organization_user_document" */
  update_organization_user_document?: Maybe<Organization_User_Document_Mutation_Response>;
  /** update single row of the table: "organization_user_document" */
  update_organization_user_document_by_pk?: Maybe<Organization_User_Document>;
  /** update multiples rows of table: "organization_user_document" */
  update_organization_user_document_many?: Maybe<Array<Maybe<Organization_User_Document_Mutation_Response>>>;
  /** update multiples rows of table: "organization_user" */
  update_organization_user_many?: Maybe<Array<Maybe<Organization_User_Mutation_Response>>>;
  /** update data of the table: "organization_user_permission" */
  update_organization_user_permission?: Maybe<Organization_User_Permission_Mutation_Response>;
  /** update single row of the table: "organization_user_permission" */
  update_organization_user_permission_by_pk?: Maybe<Organization_User_Permission>;
  /** update multiples rows of table: "organization_user_permission" */
  update_organization_user_permission_many?: Maybe<Array<Maybe<Organization_User_Permission_Mutation_Response>>>;
  /** update data of the table: "organization_user_subsidiary" */
  update_organization_user_subsidiary?: Maybe<Organization_User_Subsidiary_Mutation_Response>;
  /** update single row of the table: "organization_user_subsidiary" */
  update_organization_user_subsidiary_by_pk?: Maybe<Organization_User_Subsidiary>;
  /** update multiples rows of table: "organization_user_subsidiary" */
  update_organization_user_subsidiary_many?: Maybe<Array<Maybe<Organization_User_Subsidiary_Mutation_Response>>>;
  /** update data of the table: "organization_user_type" */
  update_organization_user_type?: Maybe<Organization_User_Type_Mutation_Response>;
  /** update single row of the table: "organization_user_type" */
  update_organization_user_type_by_pk?: Maybe<Organization_User_Type>;
  /** update multiples rows of table: "organization_user_type" */
  update_organization_user_type_many?: Maybe<Array<Maybe<Organization_User_Type_Mutation_Response>>>;
  /** update data of the table: "ownership_type" */
  update_ownership_type?: Maybe<Ownership_Type_Mutation_Response>;
  /** update single row of the table: "ownership_type" */
  update_ownership_type_by_pk?: Maybe<Ownership_Type>;
  /** update multiples rows of table: "ownership_type" */
  update_ownership_type_many?: Maybe<Array<Maybe<Ownership_Type_Mutation_Response>>>;
  /** update data of the table: "partner" */
  update_partner?: Maybe<Partner_Mutation_Response>;
  /** update data of the table: "partner_address" */
  update_partner_address?: Maybe<Partner_Address_Mutation_Response>;
  /** update single row of the table: "partner_address" */
  update_partner_address_by_pk?: Maybe<Partner_Address>;
  /** update multiples rows of table: "partner_address" */
  update_partner_address_many?: Maybe<Array<Maybe<Partner_Address_Mutation_Response>>>;
  /** update data of the table: "partner_bank_details" */
  update_partner_bank_details?: Maybe<Partner_Bank_Details_Mutation_Response>;
  /** update single row of the table: "partner_bank_details" */
  update_partner_bank_details_by_pk?: Maybe<Partner_Bank_Details>;
  /** update multiples rows of table: "partner_bank_details" */
  update_partner_bank_details_many?: Maybe<Array<Maybe<Partner_Bank_Details_Mutation_Response>>>;
  /** update single row of the table: "partner" */
  update_partner_by_pk?: Maybe<Partner>;
  /** update data of the table: "partner_commission" */
  update_partner_commission?: Maybe<Partner_Commission_Mutation_Response>;
  /** update single row of the table: "partner_commission" */
  update_partner_commission_by_pk?: Maybe<Partner_Commission>;
  /** update multiples rows of table: "partner_commission" */
  update_partner_commission_many?: Maybe<Array<Maybe<Partner_Commission_Mutation_Response>>>;
  /** update data of the table: "partner_commission_product_variation_type" */
  update_partner_commission_product_variation_type?: Maybe<Partner_Commission_Product_Variation_Type_Mutation_Response>;
  /** update single row of the table: "partner_commission_product_variation_type" */
  update_partner_commission_product_variation_type_by_pk?: Maybe<Partner_Commission_Product_Variation_Type>;
  /** update multiples rows of table: "partner_commission_product_variation_type" */
  update_partner_commission_product_variation_type_many?: Maybe<Array<Maybe<Partner_Commission_Product_Variation_Type_Mutation_Response>>>;
  /** update data of the table: "partner_contact_type" */
  update_partner_contact_type?: Maybe<Partner_Contact_Type_Mutation_Response>;
  /** update single row of the table: "partner_contact_type" */
  update_partner_contact_type_by_pk?: Maybe<Partner_Contact_Type>;
  /** update multiples rows of table: "partner_contact_type" */
  update_partner_contact_type_many?: Maybe<Array<Maybe<Partner_Contact_Type_Mutation_Response>>>;
  /** update data of the table: "partner_localities" */
  update_partner_localities?: Maybe<Partner_Localities_Mutation_Response>;
  /** update single row of the table: "partner_localities" */
  update_partner_localities_by_pk?: Maybe<Partner_Localities>;
  /** update multiples rows of table: "partner_localities" */
  update_partner_localities_many?: Maybe<Array<Maybe<Partner_Localities_Mutation_Response>>>;
  /** update data of the table: "partner_localities_slots" */
  update_partner_localities_slots?: Maybe<Partner_Localities_Slots_Mutation_Response>;
  /** update single row of the table: "partner_localities_slots" */
  update_partner_localities_slots_by_pk?: Maybe<Partner_Localities_Slots>;
  /** update multiples rows of table: "partner_localities_slots" */
  update_partner_localities_slots_many?: Maybe<Array<Maybe<Partner_Localities_Slots_Mutation_Response>>>;
  /** update multiples rows of table: "partner" */
  update_partner_many?: Maybe<Array<Maybe<Partner_Mutation_Response>>>;
  /** update data of the table: "partner_order" */
  update_partner_order?: Maybe<Partner_Order_Mutation_Response>;
  /** update single row of the table: "partner_order" */
  update_partner_order_by_pk?: Maybe<Partner_Order>;
  /** update data of the table: "partner_order_customer_asset" */
  update_partner_order_customer_asset?: Maybe<Partner_Order_Customer_Asset_Mutation_Response>;
  /** update single row of the table: "partner_order_customer_asset" */
  update_partner_order_customer_asset_by_pk?: Maybe<Partner_Order_Customer_Asset>;
  /** update multiples rows of table: "partner_order_customer_asset" */
  update_partner_order_customer_asset_many?: Maybe<Array<Maybe<Partner_Order_Customer_Asset_Mutation_Response>>>;
  /** update data of the table: "partner_order_item" */
  update_partner_order_item?: Maybe<Partner_Order_Item_Mutation_Response>;
  /** update single row of the table: "partner_order_item" */
  update_partner_order_item_by_pk?: Maybe<Partner_Order_Item>;
  /** update data of the table: "partner_order_item_commission" */
  update_partner_order_item_commission?: Maybe<Partner_Order_Item_Commission_Mutation_Response>;
  /** update single row of the table: "partner_order_item_commission" */
  update_partner_order_item_commission_by_pk?: Maybe<Partner_Order_Item_Commission>;
  /** update multiples rows of table: "partner_order_item_commission" */
  update_partner_order_item_commission_many?: Maybe<Array<Maybe<Partner_Order_Item_Commission_Mutation_Response>>>;
  /** update multiples rows of table: "partner_order_item" */
  update_partner_order_item_many?: Maybe<Array<Maybe<Partner_Order_Item_Mutation_Response>>>;
  /** update data of the table: "partner_order_item_state" */
  update_partner_order_item_state?: Maybe<Partner_Order_Item_State_Mutation_Response>;
  /** update single row of the table: "partner_order_item_state" */
  update_partner_order_item_state_by_pk?: Maybe<Partner_Order_Item_State>;
  /** update multiples rows of table: "partner_order_item_state" */
  update_partner_order_item_state_many?: Maybe<Array<Maybe<Partner_Order_Item_State_Mutation_Response>>>;
  /** update data of the table: "partner_order_item_stateflow" */
  update_partner_order_item_stateflow?: Maybe<Partner_Order_Item_Stateflow_Mutation_Response>;
  /** update single row of the table: "partner_order_item_stateflow" */
  update_partner_order_item_stateflow_by_pk?: Maybe<Partner_Order_Item_Stateflow>;
  /** update multiples rows of table: "partner_order_item_stateflow" */
  update_partner_order_item_stateflow_many?: Maybe<Array<Maybe<Partner_Order_Item_Stateflow_Mutation_Response>>>;
  /** update data of the table: "partner_order_item_test_category" */
  update_partner_order_item_test_category?: Maybe<Partner_Order_Item_Test_Category_Mutation_Response>;
  /** update single row of the table: "partner_order_item_test_category" */
  update_partner_order_item_test_category_by_pk?: Maybe<Partner_Order_Item_Test_Category>;
  /** update multiples rows of table: "partner_order_item_test_category" */
  update_partner_order_item_test_category_many?: Maybe<Array<Maybe<Partner_Order_Item_Test_Category_Mutation_Response>>>;
  /** update data of the table: "partner_order_item_test_results" */
  update_partner_order_item_test_results?: Maybe<Partner_Order_Item_Test_Results_Mutation_Response>;
  /** update single row of the table: "partner_order_item_test_results" */
  update_partner_order_item_test_results_by_pk?: Maybe<Partner_Order_Item_Test_Results>;
  /** update multiples rows of table: "partner_order_item_test_results" */
  update_partner_order_item_test_results_many?: Maybe<Array<Maybe<Partner_Order_Item_Test_Results_Mutation_Response>>>;
  /** update data of the table: "partner_order_item_test_results_photos" */
  update_partner_order_item_test_results_photos?: Maybe<Partner_Order_Item_Test_Results_Photos_Mutation_Response>;
  /** update single row of the table: "partner_order_item_test_results_photos" */
  update_partner_order_item_test_results_photos_by_pk?: Maybe<Partner_Order_Item_Test_Results_Photos>;
  /** update multiples rows of table: "partner_order_item_test_results_photos" */
  update_partner_order_item_test_results_photos_many?: Maybe<Array<Maybe<Partner_Order_Item_Test_Results_Photos_Mutation_Response>>>;
  /** update data of the table: "partner_order_item_value" */
  update_partner_order_item_value?: Maybe<Partner_Order_Item_Value_Mutation_Response>;
  /** update single row of the table: "partner_order_item_value" */
  update_partner_order_item_value_by_pk?: Maybe<Partner_Order_Item_Value>;
  /** update multiples rows of table: "partner_order_item_value" */
  update_partner_order_item_value_many?: Maybe<Array<Maybe<Partner_Order_Item_Value_Mutation_Response>>>;
  /** update multiples rows of table: "partner_order" */
  update_partner_order_many?: Maybe<Array<Maybe<Partner_Order_Mutation_Response>>>;
  /** update data of the table: "partner_order_partner_user_document" */
  update_partner_order_partner_user_document?: Maybe<Partner_Order_Partner_User_Document_Mutation_Response>;
  /** update single row of the table: "partner_order_partner_user_document" */
  update_partner_order_partner_user_document_by_pk?: Maybe<Partner_Order_Partner_User_Document>;
  /** update multiples rows of table: "partner_order_partner_user_document" */
  update_partner_order_partner_user_document_many?: Maybe<Array<Maybe<Partner_Order_Partner_User_Document_Mutation_Response>>>;
  /** update data of the table: "partner_order_state" */
  update_partner_order_state?: Maybe<Partner_Order_State_Mutation_Response>;
  /** update single row of the table: "partner_order_state" */
  update_partner_order_state_by_pk?: Maybe<Partner_Order_State>;
  /** update multiples rows of table: "partner_order_state" */
  update_partner_order_state_many?: Maybe<Array<Maybe<Partner_Order_State_Mutation_Response>>>;
  /** update data of the table: "partner_order_stateflow" */
  update_partner_order_stateflow?: Maybe<Partner_Order_Stateflow_Mutation_Response>;
  /** update single row of the table: "partner_order_stateflow" */
  update_partner_order_stateflow_by_pk?: Maybe<Partner_Order_Stateflow>;
  /** update multiples rows of table: "partner_order_stateflow" */
  update_partner_order_stateflow_many?: Maybe<Array<Maybe<Partner_Order_Stateflow_Mutation_Response>>>;
  /** update data of the table: "partner_payment" */
  update_partner_payment?: Maybe<Partner_Payment_Mutation_Response>;
  /** update single row of the table: "partner_payment" */
  update_partner_payment_by_pk?: Maybe<Partner_Payment>;
  /** update multiples rows of table: "partner_payment" */
  update_partner_payment_many?: Maybe<Array<Maybe<Partner_Payment_Mutation_Response>>>;
  /** update data of the table: "partner_product" */
  update_partner_product?: Maybe<Partner_Product_Mutation_Response>;
  /** update single row of the table: "partner_product" */
  update_partner_product_by_pk?: Maybe<Partner_Product>;
  /** update multiples rows of table: "partner_product" */
  update_partner_product_many?: Maybe<Array<Maybe<Partner_Product_Mutation_Response>>>;
  /** update data of the table: "partner_relationship" */
  update_partner_relationship?: Maybe<Partner_Relationship_Mutation_Response>;
  /** update single row of the table: "partner_relationship" */
  update_partner_relationship_by_pk?: Maybe<Partner_Relationship>;
  /** update multiples rows of table: "partner_relationship" */
  update_partner_relationship_many?: Maybe<Array<Maybe<Partner_Relationship_Mutation_Response>>>;
  /** update data of the table: "partner_seller" */
  update_partner_seller?: Maybe<Partner_Seller_Mutation_Response>;
  /** update single row of the table: "partner_seller" */
  update_partner_seller_by_pk?: Maybe<Partner_Seller>;
  /** update multiples rows of table: "partner_seller" */
  update_partner_seller_many?: Maybe<Array<Maybe<Partner_Seller_Mutation_Response>>>;
  /** update data of the table: "partner_seller_type" */
  update_partner_seller_type?: Maybe<Partner_Seller_Type_Mutation_Response>;
  /** update single row of the table: "partner_seller_type" */
  update_partner_seller_type_by_pk?: Maybe<Partner_Seller_Type>;
  /** update multiples rows of table: "partner_seller_type" */
  update_partner_seller_type_many?: Maybe<Array<Maybe<Partner_Seller_Type_Mutation_Response>>>;
  /** update data of the table: "partner_signing_authority" */
  update_partner_signing_authority?: Maybe<Partner_Signing_Authority_Mutation_Response>;
  /** update single row of the table: "partner_signing_authority" */
  update_partner_signing_authority_by_pk?: Maybe<Partner_Signing_Authority>;
  /** update multiples rows of table: "partner_signing_authority" */
  update_partner_signing_authority_many?: Maybe<Array<Maybe<Partner_Signing_Authority_Mutation_Response>>>;
  /** update data of the table: "partner_timing" */
  update_partner_timing?: Maybe<Partner_Timing_Mutation_Response>;
  /** update single row of the table: "partner_timing" */
  update_partner_timing_by_pk?: Maybe<Partner_Timing>;
  /** update multiples rows of table: "partner_timing" */
  update_partner_timing_many?: Maybe<Array<Maybe<Partner_Timing_Mutation_Response>>>;
  /** update data of the table: "partner_type" */
  update_partner_type?: Maybe<Partner_Type_Mutation_Response>;
  /** update single row of the table: "partner_type" */
  update_partner_type_by_pk?: Maybe<Partner_Type>;
  /** update multiples rows of table: "partner_type" */
  update_partner_type_many?: Maybe<Array<Maybe<Partner_Type_Mutation_Response>>>;
  /** update data of the table: "partner_user" */
  update_partner_user?: Maybe<Partner_User_Mutation_Response>;
  /** update single row of the table: "partner_user" */
  update_partner_user_by_pk?: Maybe<Partner_User>;
  /** update data of the table: "partner_user_document" */
  update_partner_user_document?: Maybe<Partner_User_Document_Mutation_Response>;
  /** update single row of the table: "partner_user_document" */
  update_partner_user_document_by_pk?: Maybe<Partner_User_Document>;
  /** update multiples rows of table: "partner_user_document" */
  update_partner_user_document_many?: Maybe<Array<Maybe<Partner_User_Document_Mutation_Response>>>;
  /** update multiples rows of table: "partner_user" */
  update_partner_user_many?: Maybe<Array<Maybe<Partner_User_Mutation_Response>>>;
  /** update data of the table: "partner_user_permission" */
  update_partner_user_permission?: Maybe<Partner_User_Permission_Mutation_Response>;
  /** update single row of the table: "partner_user_permission" */
  update_partner_user_permission_by_pk?: Maybe<Partner_User_Permission>;
  /** update multiples rows of table: "partner_user_permission" */
  update_partner_user_permission_many?: Maybe<Array<Maybe<Partner_User_Permission_Mutation_Response>>>;
  /** update data of the table: "partner_vehicle" */
  update_partner_vehicle?: Maybe<Partner_Vehicle_Mutation_Response>;
  /** update single row of the table: "partner_vehicle" */
  update_partner_vehicle_by_pk?: Maybe<Partner_Vehicle>;
  /** update multiples rows of table: "partner_vehicle" */
  update_partner_vehicle_many?: Maybe<Array<Maybe<Partner_Vehicle_Mutation_Response>>>;
  /** update data of the table: "partner_vehicle_state" */
  update_partner_vehicle_state?: Maybe<Partner_Vehicle_State_Mutation_Response>;
  /** update single row of the table: "partner_vehicle_state" */
  update_partner_vehicle_state_by_pk?: Maybe<Partner_Vehicle_State>;
  /** update multiples rows of table: "partner_vehicle_state" */
  update_partner_vehicle_state_many?: Maybe<Array<Maybe<Partner_Vehicle_State_Mutation_Response>>>;
  /** update data of the table: "payment_type" */
  update_payment_type?: Maybe<Payment_Type_Mutation_Response>;
  /** update single row of the table: "payment_type" */
  update_payment_type_by_pk?: Maybe<Payment_Type>;
  /** update multiples rows of table: "payment_type" */
  update_payment_type_many?: Maybe<Array<Maybe<Payment_Type_Mutation_Response>>>;
  /** update data of the table: "period_frequency" */
  update_period_frequency?: Maybe<Period_Frequency_Mutation_Response>;
  /** update single row of the table: "period_frequency" */
  update_period_frequency_by_pk?: Maybe<Period_Frequency>;
  /** update multiples rows of table: "period_frequency" */
  update_period_frequency_many?: Maybe<Array<Maybe<Period_Frequency_Mutation_Response>>>;
  /** update data of the table: "permission" */
  update_permission?: Maybe<Permission_Mutation_Response>;
  /** update single row of the table: "permission" */
  update_permission_by_pk?: Maybe<Permission>;
  /** update multiples rows of table: "permission" */
  update_permission_many?: Maybe<Array<Maybe<Permission_Mutation_Response>>>;
  /** update data of the table: "permit" */
  update_permit?: Maybe<Permit_Mutation_Response>;
  /** update single row of the table: "permit" */
  update_permit_by_pk?: Maybe<Permit>;
  /** update multiples rows of table: "permit" */
  update_permit_many?: Maybe<Array<Maybe<Permit_Mutation_Response>>>;
  /** update data of the table: "photo_type" */
  update_photo_type?: Maybe<Photo_Type_Mutation_Response>;
  /** update single row of the table: "photo_type" */
  update_photo_type_by_pk?: Maybe<Photo_Type>;
  /** update multiples rows of table: "photo_type" */
  update_photo_type_many?: Maybe<Array<Maybe<Photo_Type_Mutation_Response>>>;
  /** update data of the table: "planning_audit_log" */
  update_planning_audit_log?: Maybe<Planning_Audit_Log_Mutation_Response>;
  /** update single row of the table: "planning_audit_log" */
  update_planning_audit_log_by_pk?: Maybe<Planning_Audit_Log>;
  /** update multiples rows of table: "planning_audit_log" */
  update_planning_audit_log_many?: Maybe<Array<Maybe<Planning_Audit_Log_Mutation_Response>>>;
  /** update data of the table: "planning_period" */
  update_planning_period?: Maybe<Planning_Period_Mutation_Response>;
  /** update single row of the table: "planning_period" */
  update_planning_period_by_pk?: Maybe<Planning_Period>;
  /** update multiples rows of table: "planning_period" */
  update_planning_period_many?: Maybe<Array<Maybe<Planning_Period_Mutation_Response>>>;
  /** update data of the table: "product" */
  update_product?: Maybe<Product_Mutation_Response>;
  /** update single row of the table: "product" */
  update_product_by_pk?: Maybe<Product>;
  /** update data of the table: "product_commission" */
  update_product_commission?: Maybe<Product_Commission_Mutation_Response>;
  /** update single row of the table: "product_commission" */
  update_product_commission_by_pk?: Maybe<Product_Commission>;
  /** update multiples rows of table: "product_commission" */
  update_product_commission_many?: Maybe<Array<Maybe<Product_Commission_Mutation_Response>>>;
  /** update data of the table: "product_document" */
  update_product_document?: Maybe<Product_Document_Mutation_Response>;
  /** update single row of the table: "product_document" */
  update_product_document_by_pk?: Maybe<Product_Document>;
  /** update multiples rows of table: "product_document" */
  update_product_document_many?: Maybe<Array<Maybe<Product_Document_Mutation_Response>>>;
  /** update multiples rows of table: "product" */
  update_product_many?: Maybe<Array<Maybe<Product_Mutation_Response>>>;
  /** update data of the table: "product_partner_localities_price" */
  update_product_partner_localities_price?: Maybe<Product_Partner_Localities_Price_Mutation_Response>;
  /** update single row of the table: "product_partner_localities_price" */
  update_product_partner_localities_price_by_pk?: Maybe<Product_Partner_Localities_Price>;
  /** update data of the table: "product_partner_localities_price_history" */
  update_product_partner_localities_price_history?: Maybe<Product_Partner_Localities_Price_History_Mutation_Response>;
  /** update single row of the table: "product_partner_localities_price_history" */
  update_product_partner_localities_price_history_by_pk?: Maybe<Product_Partner_Localities_Price_History>;
  /** update multiples rows of table: "product_partner_localities_price_history" */
  update_product_partner_localities_price_history_many?: Maybe<Array<Maybe<Product_Partner_Localities_Price_History_Mutation_Response>>>;
  /** update multiples rows of table: "product_partner_localities_price" */
  update_product_partner_localities_price_many?: Maybe<Array<Maybe<Product_Partner_Localities_Price_Mutation_Response>>>;
  /** update data of the table: "product_photos" */
  update_product_photos?: Maybe<Product_Photos_Mutation_Response>;
  /** update single row of the table: "product_photos" */
  update_product_photos_by_pk?: Maybe<Product_Photos>;
  /** update multiples rows of table: "product_photos" */
  update_product_photos_many?: Maybe<Array<Maybe<Product_Photos_Mutation_Response>>>;
  /** update data of the table: "product_type" */
  update_product_type?: Maybe<Product_Type_Mutation_Response>;
  /** update single row of the table: "product_type" */
  update_product_type_by_pk?: Maybe<Product_Type>;
  /** update multiples rows of table: "product_type" */
  update_product_type_many?: Maybe<Array<Maybe<Product_Type_Mutation_Response>>>;
  /** update data of the table: "product_variation" */
  update_product_variation?: Maybe<Product_Variation_Mutation_Response>;
  /** update single row of the table: "product_variation" */
  update_product_variation_by_pk?: Maybe<Product_Variation>;
  /** update multiples rows of table: "product_variation" */
  update_product_variation_many?: Maybe<Array<Maybe<Product_Variation_Mutation_Response>>>;
  /** update data of the table: "product_variation_partner_localities_slots" */
  update_product_variation_partner_localities_slots?: Maybe<Product_Variation_Partner_Localities_Slots_Mutation_Response>;
  /** update single row of the table: "product_variation_partner_localities_slots" */
  update_product_variation_partner_localities_slots_by_pk?: Maybe<Product_Variation_Partner_Localities_Slots>;
  /** update multiples rows of table: "product_variation_partner_localities_slots" */
  update_product_variation_partner_localities_slots_many?: Maybe<Array<Maybe<Product_Variation_Partner_Localities_Slots_Mutation_Response>>>;
  /** update data of the table: "product_variation_photos" */
  update_product_variation_photos?: Maybe<Product_Variation_Photos_Mutation_Response>;
  /** update single row of the table: "product_variation_photos" */
  update_product_variation_photos_by_pk?: Maybe<Product_Variation_Photos>;
  /** update multiples rows of table: "product_variation_photos" */
  update_product_variation_photos_many?: Maybe<Array<Maybe<Product_Variation_Photos_Mutation_Response>>>;
  /** update data of the table: "product_variation_safety_checklist_category" */
  update_product_variation_safety_checklist_category?: Maybe<Product_Variation_Safety_Checklist_Category_Mutation_Response>;
  /** update single row of the table: "product_variation_safety_checklist_category" */
  update_product_variation_safety_checklist_category_by_pk?: Maybe<Product_Variation_Safety_Checklist_Category>;
  /** update multiples rows of table: "product_variation_safety_checklist_category" */
  update_product_variation_safety_checklist_category_many?: Maybe<Array<Maybe<Product_Variation_Safety_Checklist_Category_Mutation_Response>>>;
  /** update data of the table: "product_variation_test_category" */
  update_product_variation_test_category?: Maybe<Product_Variation_Test_Category_Mutation_Response>;
  /** update single row of the table: "product_variation_test_category" */
  update_product_variation_test_category_by_pk?: Maybe<Product_Variation_Test_Category>;
  /** update multiples rows of table: "product_variation_test_category" */
  update_product_variation_test_category_many?: Maybe<Array<Maybe<Product_Variation_Test_Category_Mutation_Response>>>;
  /** update data of the table: "purchase_order" */
  update_purchase_order?: Maybe<Purchase_Order_Mutation_Response>;
  /** update single row of the table: "purchase_order" */
  update_purchase_order_by_pk?: Maybe<Purchase_Order>;
  /** update data of the table: "purchase_order_items" */
  update_purchase_order_items?: Maybe<Purchase_Order_Items_Mutation_Response>;
  /** update single row of the table: "purchase_order_items" */
  update_purchase_order_items_by_pk?: Maybe<Purchase_Order_Items>;
  /** update multiples rows of table: "purchase_order_items" */
  update_purchase_order_items_many?: Maybe<Array<Maybe<Purchase_Order_Items_Mutation_Response>>>;
  /** update multiples rows of table: "purchase_order" */
  update_purchase_order_many?: Maybe<Array<Maybe<Purchase_Order_Mutation_Response>>>;
  /** update data of the table: "quantity_correction_ticket_states" */
  update_quantity_correction_ticket_states?: Maybe<Quantity_Correction_Ticket_States_Mutation_Response>;
  /** update single row of the table: "quantity_correction_ticket_states" */
  update_quantity_correction_ticket_states_by_pk?: Maybe<Quantity_Correction_Ticket_States>;
  /** update multiples rows of table: "quantity_correction_ticket_states" */
  update_quantity_correction_ticket_states_many?: Maybe<Array<Maybe<Quantity_Correction_Ticket_States_Mutation_Response>>>;
  /** update data of the table: "quantity_correction_tickets" */
  update_quantity_correction_tickets?: Maybe<Quantity_Correction_Tickets_Mutation_Response>;
  /** update single row of the table: "quantity_correction_tickets" */
  update_quantity_correction_tickets_by_pk?: Maybe<Quantity_Correction_Tickets>;
  /** update multiples rows of table: "quantity_correction_tickets" */
  update_quantity_correction_tickets_many?: Maybe<Array<Maybe<Quantity_Correction_Tickets_Mutation_Response>>>;
  /** update data of the table: "reason_type" */
  update_reason_type?: Maybe<Reason_Type_Mutation_Response>;
  /** update single row of the table: "reason_type" */
  update_reason_type_by_pk?: Maybe<Reason_Type>;
  /** update multiples rows of table: "reason_type" */
  update_reason_type_many?: Maybe<Array<Maybe<Reason_Type_Mutation_Response>>>;
  /** update data of the table: "reasons" */
  update_reasons?: Maybe<Reasons_Mutation_Response>;
  /** update single row of the table: "reasons" */
  update_reasons_by_pk?: Maybe<Reasons>;
  /** update multiples rows of table: "reasons" */
  update_reasons_many?: Maybe<Array<Maybe<Reasons_Mutation_Response>>>;
  /** update data of the table: "role" */
  update_role?: Maybe<Role_Mutation_Response>;
  /** update single row of the table: "role" */
  update_role_by_pk?: Maybe<Role>;
  /** update data of the table: "role_document" */
  update_role_document?: Maybe<Role_Document_Mutation_Response>;
  /** update single row of the table: "role_document" */
  update_role_document_by_pk?: Maybe<Role_Document>;
  /** update multiples rows of table: "role_document" */
  update_role_document_many?: Maybe<Array<Maybe<Role_Document_Mutation_Response>>>;
  /** update multiples rows of table: "role" */
  update_role_many?: Maybe<Array<Maybe<Role_Mutation_Response>>>;
  /** update data of the table: "safety_checklist" */
  update_safety_checklist?: Maybe<Safety_Checklist_Mutation_Response>;
  /** update single row of the table: "safety_checklist" */
  update_safety_checklist_by_pk?: Maybe<Safety_Checklist>;
  /** update data of the table: "safety_checklist_category" */
  update_safety_checklist_category?: Maybe<Safety_Checklist_Category_Mutation_Response>;
  /** update single row of the table: "safety_checklist_category" */
  update_safety_checklist_category_by_pk?: Maybe<Safety_Checklist_Category>;
  /** update multiples rows of table: "safety_checklist_category" */
  update_safety_checklist_category_many?: Maybe<Array<Maybe<Safety_Checklist_Category_Mutation_Response>>>;
  /** update multiples rows of table: "safety_checklist" */
  update_safety_checklist_many?: Maybe<Array<Maybe<Safety_Checklist_Mutation_Response>>>;
  /** update data of the table: "script_type" */
  update_script_type?: Maybe<Script_Type_Mutation_Response>;
  /** update single row of the table: "script_type" */
  update_script_type_by_pk?: Maybe<Script_Type>;
  /** update multiples rows of table: "script_type" */
  update_script_type_many?: Maybe<Array<Maybe<Script_Type_Mutation_Response>>>;
  /** update data of the table: "scripts" */
  update_scripts?: Maybe<Scripts_Mutation_Response>;
  /** update single row of the table: "scripts" */
  update_scripts_by_pk?: Maybe<Scripts>;
  /** update multiples rows of table: "scripts" */
  update_scripts_many?: Maybe<Array<Maybe<Scripts_Mutation_Response>>>;
  /** update data of the table: "services" */
  update_services?: Maybe<Services_Mutation_Response>;
  /** update single row of the table: "services" */
  update_services_by_pk?: Maybe<Services>;
  /** update data of the table: "services_category" */
  update_services_category?: Maybe<Services_Category_Mutation_Response>;
  /** update single row of the table: "services_category" */
  update_services_category_by_pk?: Maybe<Services_Category>;
  /** update multiples rows of table: "services_category" */
  update_services_category_many?: Maybe<Array<Maybe<Services_Category_Mutation_Response>>>;
  /** update multiples rows of table: "services" */
  update_services_many?: Maybe<Array<Maybe<Services_Mutation_Response>>>;
  /** update data of the table: "shift_schedule" */
  update_shift_schedule?: Maybe<Shift_Schedule_Mutation_Response>;
  /** update single row of the table: "shift_schedule" */
  update_shift_schedule_by_pk?: Maybe<Shift_Schedule>;
  /** update data of the table: "shift_schedule_dispenser" */
  update_shift_schedule_dispenser?: Maybe<Shift_Schedule_Dispenser_Mutation_Response>;
  /** update single row of the table: "shift_schedule_dispenser" */
  update_shift_schedule_dispenser_by_pk?: Maybe<Shift_Schedule_Dispenser>;
  /** update multiples rows of table: "shift_schedule_dispenser" */
  update_shift_schedule_dispenser_many?: Maybe<Array<Maybe<Shift_Schedule_Dispenser_Mutation_Response>>>;
  /** update multiples rows of table: "shift_schedule" */
  update_shift_schedule_many?: Maybe<Array<Maybe<Shift_Schedule_Mutation_Response>>>;
  /** update data of the table: "shift_template" */
  update_shift_template?: Maybe<Shift_Template_Mutation_Response>;
  /** update single row of the table: "shift_template" */
  update_shift_template_by_pk?: Maybe<Shift_Template>;
  /** update multiples rows of table: "shift_template" */
  update_shift_template_many?: Maybe<Array<Maybe<Shift_Template_Mutation_Response>>>;
  /** update data of the table: "slab_type" */
  update_slab_type?: Maybe<Slab_Type_Mutation_Response>;
  /** update single row of the table: "slab_type" */
  update_slab_type_by_pk?: Maybe<Slab_Type>;
  /** update multiples rows of table: "slab_type" */
  update_slab_type_many?: Maybe<Array<Maybe<Slab_Type_Mutation_Response>>>;
  /** update data of the table: "source_type" */
  update_source_type?: Maybe<Source_Type_Mutation_Response>;
  /** update single row of the table: "source_type" */
  update_source_type_by_pk?: Maybe<Source_Type>;
  /** update multiples rows of table: "source_type" */
  update_source_type_many?: Maybe<Array<Maybe<Source_Type_Mutation_Response>>>;
  /** update data of the table: "spatial_ref_sys" */
  update_spatial_ref_sys?: Maybe<Spatial_Ref_Sys_Mutation_Response>;
  /** update single row of the table: "spatial_ref_sys" */
  update_spatial_ref_sys_by_pk?: Maybe<Spatial_Ref_Sys>;
  /** update multiples rows of table: "spatial_ref_sys" */
  update_spatial_ref_sys_many?: Maybe<Array<Maybe<Spatial_Ref_Sys_Mutation_Response>>>;
  /** update data of the table: "state" */
  update_state?: Maybe<State_Mutation_Response>;
  /** update single row of the table: "state" */
  update_state_by_pk?: Maybe<State>;
  /** update multiples rows of table: "state" */
  update_state_many?: Maybe<Array<Maybe<State_Mutation_Response>>>;
  /** update data of the table: "subsidiary" */
  update_subsidiary?: Maybe<Subsidiary_Mutation_Response>;
  /** update single row of the table: "subsidiary" */
  update_subsidiary_by_pk?: Maybe<Subsidiary>;
  /** update multiples rows of table: "subsidiary" */
  update_subsidiary_many?: Maybe<Array<Maybe<Subsidiary_Mutation_Response>>>;
  /** update data of the table: "support_tickets" */
  update_support_tickets?: Maybe<Support_Tickets_Mutation_Response>;
  /** update single row of the table: "support_tickets" */
  update_support_tickets_by_pk?: Maybe<Support_Tickets>;
  /** update data of the table: "support_tickets_category" */
  update_support_tickets_category?: Maybe<Support_Tickets_Category_Mutation_Response>;
  /** update single row of the table: "support_tickets_category" */
  update_support_tickets_category_by_pk?: Maybe<Support_Tickets_Category>;
  /** update multiples rows of table: "support_tickets_category" */
  update_support_tickets_category_many?: Maybe<Array<Maybe<Support_Tickets_Category_Mutation_Response>>>;
  /** update multiples rows of table: "support_tickets" */
  update_support_tickets_many?: Maybe<Array<Maybe<Support_Tickets_Mutation_Response>>>;
  /** update data of the table: "support_tickets_photos" */
  update_support_tickets_photos?: Maybe<Support_Tickets_Photos_Mutation_Response>;
  /** update single row of the table: "support_tickets_photos" */
  update_support_tickets_photos_by_pk?: Maybe<Support_Tickets_Photos>;
  /** update multiples rows of table: "support_tickets_photos" */
  update_support_tickets_photos_many?: Maybe<Array<Maybe<Support_Tickets_Photos_Mutation_Response>>>;
  /** update data of the table: "tag" */
  update_tag?: Maybe<Tag_Mutation_Response>;
  /** update single row of the table: "tag" */
  update_tag_by_pk?: Maybe<Tag>;
  /** update multiples rows of table: "tag" */
  update_tag_many?: Maybe<Array<Maybe<Tag_Mutation_Response>>>;
  /** update data of the table: "tank_type" */
  update_tank_type?: Maybe<Tank_Type_Mutation_Response>;
  /** update single row of the table: "tank_type" */
  update_tank_type_by_pk?: Maybe<Tank_Type>;
  /** update multiples rows of table: "tank_type" */
  update_tank_type_many?: Maybe<Array<Maybe<Tank_Type_Mutation_Response>>>;
  /** update data of the table: "task" */
  update_task?: Maybe<Task_Mutation_Response>;
  /** update data of the table: "task_action_instruction" */
  update_task_action_instruction?: Maybe<Task_Action_Instruction_Mutation_Response>;
  /** update single row of the table: "task_action_instruction" */
  update_task_action_instruction_by_pk?: Maybe<Task_Action_Instruction>;
  /** update multiples rows of table: "task_action_instruction" */
  update_task_action_instruction_many?: Maybe<Array<Maybe<Task_Action_Instruction_Mutation_Response>>>;
  /** update data of the table: "task_action_type" */
  update_task_action_type?: Maybe<Task_Action_Type_Mutation_Response>;
  /** update single row of the table: "task_action_type" */
  update_task_action_type_by_pk?: Maybe<Task_Action_Type>;
  /** update multiples rows of table: "task_action_type" */
  update_task_action_type_many?: Maybe<Array<Maybe<Task_Action_Type_Mutation_Response>>>;
  /** update single row of the table: "task" */
  update_task_by_pk?: Maybe<Task>;
  /** update data of the table: "task_cancellation_reasons" */
  update_task_cancellation_reasons?: Maybe<Task_Cancellation_Reasons_Mutation_Response>;
  /** update single row of the table: "task_cancellation_reasons" */
  update_task_cancellation_reasons_by_pk?: Maybe<Task_Cancellation_Reasons>;
  /** update multiples rows of table: "task_cancellation_reasons" */
  update_task_cancellation_reasons_many?: Maybe<Array<Maybe<Task_Cancellation_Reasons_Mutation_Response>>>;
  /** update multiples rows of table: "task" */
  update_task_many?: Maybe<Array<Maybe<Task_Mutation_Response>>>;
  /** update data of the table: "task_state" */
  update_task_state?: Maybe<Task_State_Mutation_Response>;
  /** update single row of the table: "task_state" */
  update_task_state_by_pk?: Maybe<Task_State>;
  /** update multiples rows of table: "task_state" */
  update_task_state_many?: Maybe<Array<Maybe<Task_State_Mutation_Response>>>;
  /** update data of the table: "task_states_flow" */
  update_task_states_flow?: Maybe<Task_States_Flow_Mutation_Response>;
  /** update single row of the table: "task_states_flow" */
  update_task_states_flow_by_pk?: Maybe<Task_States_Flow>;
  /** update multiples rows of table: "task_states_flow" */
  update_task_states_flow_many?: Maybe<Array<Maybe<Task_States_Flow_Mutation_Response>>>;
  /** update data of the table: "task_type" */
  update_task_type?: Maybe<Task_Type_Mutation_Response>;
  /** update single row of the table: "task_type" */
  update_task_type_by_pk?: Maybe<Task_Type>;
  /** update multiples rows of table: "task_type" */
  update_task_type_many?: Maybe<Array<Maybe<Task_Type_Mutation_Response>>>;
  /** update data of the table: "task_value" */
  update_task_value?: Maybe<Task_Value_Mutation_Response>;
  /** update single row of the table: "task_value" */
  update_task_value_by_pk?: Maybe<Task_Value>;
  /** update multiples rows of table: "task_value" */
  update_task_value_many?: Maybe<Array<Maybe<Task_Value_Mutation_Response>>>;
  /** update data of the table: "test" */
  update_test?: Maybe<Test_Mutation_Response>;
  /** update single row of the table: "test" */
  update_test_by_pk?: Maybe<Test>;
  /** update data of the table: "test_category" */
  update_test_category?: Maybe<Test_Category_Mutation_Response>;
  /** update single row of the table: "test_category" */
  update_test_category_by_pk?: Maybe<Test_Category>;
  /** update multiples rows of table: "test_category" */
  update_test_category_many?: Maybe<Array<Maybe<Test_Category_Mutation_Response>>>;
  /** update multiples rows of table: "test" */
  update_test_many?: Maybe<Array<Maybe<Test_Mutation_Response>>>;
  /** update data of the table: "ticket_state" */
  update_ticket_state?: Maybe<Ticket_State_Mutation_Response>;
  /** update single row of the table: "ticket_state" */
  update_ticket_state_by_pk?: Maybe<Ticket_State>;
  /** update multiples rows of table: "ticket_state" */
  update_ticket_state_many?: Maybe<Array<Maybe<Ticket_State_Mutation_Response>>>;
  /** update data of the table: "ticket_type" */
  update_ticket_type?: Maybe<Ticket_Type_Mutation_Response>;
  /** update single row of the table: "ticket_type" */
  update_ticket_type_by_pk?: Maybe<Ticket_Type>;
  /** update multiples rows of table: "ticket_type" */
  update_ticket_type_many?: Maybe<Array<Maybe<Ticket_Type_Mutation_Response>>>;
  /** update data of the table: "tickets" */
  update_tickets?: Maybe<Tickets_Mutation_Response>;
  /** update single row of the table: "tickets" */
  update_tickets_by_pk?: Maybe<Tickets>;
  /** update multiples rows of table: "tickets" */
  update_tickets_many?: Maybe<Array<Maybe<Tickets_Mutation_Response>>>;
  /** update data of the table: "totalizer_correction_ticket_states" */
  update_totalizer_correction_ticket_states?: Maybe<Totalizer_Correction_Ticket_States_Mutation_Response>;
  /** update single row of the table: "totalizer_correction_ticket_states" */
  update_totalizer_correction_ticket_states_by_pk?: Maybe<Totalizer_Correction_Ticket_States>;
  /** update multiples rows of table: "totalizer_correction_ticket_states" */
  update_totalizer_correction_ticket_states_many?: Maybe<Array<Maybe<Totalizer_Correction_Ticket_States_Mutation_Response>>>;
  /** update data of the table: "totalizer_correction_tickets" */
  update_totalizer_correction_tickets?: Maybe<Totalizer_Correction_Tickets_Mutation_Response>;
  /** update single row of the table: "totalizer_correction_tickets" */
  update_totalizer_correction_tickets_by_pk?: Maybe<Totalizer_Correction_Tickets>;
  /** update multiples rows of table: "totalizer_correction_tickets" */
  update_totalizer_correction_tickets_many?: Maybe<Array<Maybe<Totalizer_Correction_Tickets_Mutation_Response>>>;
  /** update data of the table: "transaction_type" */
  update_transaction_type?: Maybe<Transaction_Type_Mutation_Response>;
  /** update single row of the table: "transaction_type" */
  update_transaction_type_by_pk?: Maybe<Transaction_Type>;
  /** update multiples rows of table: "transaction_type" */
  update_transaction_type_many?: Maybe<Array<Maybe<Transaction_Type_Mutation_Response>>>;
  /** update data of the table: "trip" */
  update_trip?: Maybe<Trip_Mutation_Response>;
  /** update single row of the table: "trip" */
  update_trip_by_pk?: Maybe<Trip>;
  /** update data of the table: "trip_location" */
  update_trip_location?: Maybe<Trip_Location_Mutation_Response>;
  /** update single row of the table: "trip_location" */
  update_trip_location_by_pk?: Maybe<Trip_Location>;
  /** update multiples rows of table: "trip_location" */
  update_trip_location_many?: Maybe<Array<Maybe<Trip_Location_Mutation_Response>>>;
  /** update multiples rows of table: "trip" */
  update_trip_many?: Maybe<Array<Maybe<Trip_Mutation_Response>>>;
  /** update data of the table: "trip_plan" */
  update_trip_plan?: Maybe<Trip_Plan_Mutation_Response>;
  /** update single row of the table: "trip_plan" */
  update_trip_plan_by_pk?: Maybe<Trip_Plan>;
  /** update multiples rows of table: "trip_plan" */
  update_trip_plan_many?: Maybe<Array<Maybe<Trip_Plan_Mutation_Response>>>;
  /** update data of the table: "unit_of_measure" */
  update_unit_of_measure?: Maybe<Unit_Of_Measure_Mutation_Response>;
  /** update single row of the table: "unit_of_measure" */
  update_unit_of_measure_by_pk?: Maybe<Unit_Of_Measure>;
  /** update multiples rows of table: "unit_of_measure" */
  update_unit_of_measure_many?: Maybe<Array<Maybe<Unit_Of_Measure_Mutation_Response>>>;
  /** update data of the table: "unit_of_measure_meta" */
  update_unit_of_measure_meta?: Maybe<Unit_Of_Measure_Meta_Mutation_Response>;
  /** update single row of the table: "unit_of_measure_meta" */
  update_unit_of_measure_meta_by_pk?: Maybe<Unit_Of_Measure_Meta>;
  /** update multiples rows of table: "unit_of_measure_meta" */
  update_unit_of_measure_meta_many?: Maybe<Array<Maybe<Unit_Of_Measure_Meta_Mutation_Response>>>;
  /** update data of the table: "uom_conversion" */
  update_uom_conversion?: Maybe<Uom_Conversion_Mutation_Response>;
  /** update single row of the table: "uom_conversion" */
  update_uom_conversion_by_pk?: Maybe<Uom_Conversion>;
  /** update multiples rows of table: "uom_conversion" */
  update_uom_conversion_many?: Maybe<Array<Maybe<Uom_Conversion_Mutation_Response>>>;
  /** update data of the table: "user" */
  update_user?: Maybe<User_Mutation_Response>;
  /** update data of the table: "user_access_audit_log" */
  update_user_access_audit_log?: Maybe<User_Access_Audit_Log_Mutation_Response>;
  /** update single row of the table: "user_access_audit_log" */
  update_user_access_audit_log_by_pk?: Maybe<User_Access_Audit_Log>;
  /** update multiples rows of table: "user_access_audit_log" */
  update_user_access_audit_log_many?: Maybe<Array<Maybe<User_Access_Audit_Log_Mutation_Response>>>;
  /** update single row of the table: "user" */
  update_user_by_pk?: Maybe<User>;
  /** update data of the table: "user_ledger" */
  update_user_ledger?: Maybe<User_Ledger_Mutation_Response>;
  /** update single row of the table: "user_ledger" */
  update_user_ledger_by_pk?: Maybe<User_Ledger>;
  /** update multiples rows of table: "user_ledger" */
  update_user_ledger_many?: Maybe<Array<Maybe<User_Ledger_Mutation_Response>>>;
  /** update multiples rows of table: "user" */
  update_user_many?: Maybe<Array<Maybe<User_Mutation_Response>>>;
  /** update data of the table: "user_partner_type" */
  update_user_partner_type?: Maybe<User_Partner_Type_Mutation_Response>;
  /** update single row of the table: "user_partner_type" */
  update_user_partner_type_by_pk?: Maybe<User_Partner_Type>;
  /** update multiples rows of table: "user_partner_type" */
  update_user_partner_type_many?: Maybe<Array<Maybe<User_Partner_Type_Mutation_Response>>>;
  /** update data of the table: "user_referral" */
  update_user_referral?: Maybe<User_Referral_Mutation_Response>;
  /** update single row of the table: "user_referral" */
  update_user_referral_by_pk?: Maybe<User_Referral>;
  /** update multiples rows of table: "user_referral" */
  update_user_referral_many?: Maybe<Array<Maybe<User_Referral_Mutation_Response>>>;
  /** update data of the table: "user_role" */
  update_user_role?: Maybe<User_Role_Mutation_Response>;
  /** update single row of the table: "user_role" */
  update_user_role_by_pk?: Maybe<User_Role>;
  /** update multiples rows of table: "user_role" */
  update_user_role_many?: Maybe<Array<Maybe<User_Role_Mutation_Response>>>;
  /** update data of the table: "validation_workflows" */
  update_validation_workflows?: Maybe<Validation_Workflows_Mutation_Response>;
  /** update single row of the table: "validation_workflows" */
  update_validation_workflows_by_pk?: Maybe<Validation_Workflows>;
  /** update multiples rows of table: "validation_workflows" */
  update_validation_workflows_many?: Maybe<Array<Maybe<Validation_Workflows_Mutation_Response>>>;
  /** update data of the table: "variation" */
  update_variation?: Maybe<Variation_Mutation_Response>;
  /** update single row of the table: "variation" */
  update_variation_by_pk?: Maybe<Variation>;
  /** update multiples rows of table: "variation" */
  update_variation_many?: Maybe<Array<Maybe<Variation_Mutation_Response>>>;
  /** update data of the table: "variation_type" */
  update_variation_type?: Maybe<Variation_Type_Mutation_Response>;
  /** update single row of the table: "variation_type" */
  update_variation_type_by_pk?: Maybe<Variation_Type>;
  /** update multiples rows of table: "variation_type" */
  update_variation_type_many?: Maybe<Array<Maybe<Variation_Type_Mutation_Response>>>;
  /** update data of the table: "vehicle" */
  update_vehicle?: Maybe<Vehicle_Mutation_Response>;
  /** update single row of the table: "vehicle" */
  update_vehicle_by_pk?: Maybe<Vehicle>;
  /** update data of the table: "vehicle_configuration" */
  update_vehicle_configuration?: Maybe<Vehicle_Configuration_Mutation_Response>;
  /** update single row of the table: "vehicle_configuration" */
  update_vehicle_configuration_by_pk?: Maybe<Vehicle_Configuration>;
  /** update multiples rows of table: "vehicle_configuration" */
  update_vehicle_configuration_many?: Maybe<Array<Maybe<Vehicle_Configuration_Mutation_Response>>>;
  /** update data of the table: "vehicle_device" */
  update_vehicle_device?: Maybe<Vehicle_Device_Mutation_Response>;
  /** update single row of the table: "vehicle_device" */
  update_vehicle_device_by_pk?: Maybe<Vehicle_Device>;
  /** update data of the table: "vehicle_device_calibration" */
  update_vehicle_device_calibration?: Maybe<Vehicle_Device_Calibration_Mutation_Response>;
  /** update single row of the table: "vehicle_device_calibration" */
  update_vehicle_device_calibration_by_pk?: Maybe<Vehicle_Device_Calibration>;
  /** update multiples rows of table: "vehicle_device_calibration" */
  update_vehicle_device_calibration_many?: Maybe<Array<Maybe<Vehicle_Device_Calibration_Mutation_Response>>>;
  /** update multiples rows of table: "vehicle_device" */
  update_vehicle_device_many?: Maybe<Array<Maybe<Vehicle_Device_Mutation_Response>>>;
  /** update data of the table: "vehicle_inventory_transaction_logs" */
  update_vehicle_inventory_transaction_logs?: Maybe<Vehicle_Inventory_Transaction_Logs_Mutation_Response>;
  /** update single row of the table: "vehicle_inventory_transaction_logs" */
  update_vehicle_inventory_transaction_logs_by_pk?: Maybe<Vehicle_Inventory_Transaction_Logs>;
  /** update multiples rows of table: "vehicle_inventory_transaction_logs" */
  update_vehicle_inventory_transaction_logs_many?: Maybe<Array<Maybe<Vehicle_Inventory_Transaction_Logs_Mutation_Response>>>;
  /** update data of the table: "vehicle_localities" */
  update_vehicle_localities?: Maybe<Vehicle_Localities_Mutation_Response>;
  /** update single row of the table: "vehicle_localities" */
  update_vehicle_localities_by_pk?: Maybe<Vehicle_Localities>;
  /** update multiples rows of table: "vehicle_localities" */
  update_vehicle_localities_many?: Maybe<Array<Maybe<Vehicle_Localities_Mutation_Response>>>;
  /** update multiples rows of table: "vehicle" */
  update_vehicle_many?: Maybe<Array<Maybe<Vehicle_Mutation_Response>>>;
  /** update data of the table: "vehicle_permit" */
  update_vehicle_permit?: Maybe<Vehicle_Permit_Mutation_Response>;
  /** update single row of the table: "vehicle_permit" */
  update_vehicle_permit_by_pk?: Maybe<Vehicle_Permit>;
  /** update multiples rows of table: "vehicle_permit" */
  update_vehicle_permit_many?: Maybe<Array<Maybe<Vehicle_Permit_Mutation_Response>>>;
  /** update data of the table: "vehicle_shift_template" */
  update_vehicle_shift_template?: Maybe<Vehicle_Shift_Template_Mutation_Response>;
  /** update single row of the table: "vehicle_shift_template" */
  update_vehicle_shift_template_by_pk?: Maybe<Vehicle_Shift_Template>;
  /** update multiples rows of table: "vehicle_shift_template" */
  update_vehicle_shift_template_many?: Maybe<Array<Maybe<Vehicle_Shift_Template_Mutation_Response>>>;
  /** update data of the table: "vehicle_status" */
  update_vehicle_status?: Maybe<Vehicle_Status_Mutation_Response>;
  /** update single row of the table: "vehicle_status" */
  update_vehicle_status_by_pk?: Maybe<Vehicle_Status>;
  /** update data of the table: "vehicle_status_logs" */
  update_vehicle_status_logs?: Maybe<Vehicle_Status_Logs_Mutation_Response>;
  /** update single row of the table: "vehicle_status_logs" */
  update_vehicle_status_logs_by_pk?: Maybe<Vehicle_Status_Logs>;
  /** update multiples rows of table: "vehicle_status_logs" */
  update_vehicle_status_logs_many?: Maybe<Array<Maybe<Vehicle_Status_Logs_Mutation_Response>>>;
  /** update multiples rows of table: "vehicle_status" */
  update_vehicle_status_many?: Maybe<Array<Maybe<Vehicle_Status_Mutation_Response>>>;
  /** update data of the table: "vehicle_tank_type" */
  update_vehicle_tank_type?: Maybe<Vehicle_Tank_Type_Mutation_Response>;
  /** update single row of the table: "vehicle_tank_type" */
  update_vehicle_tank_type_by_pk?: Maybe<Vehicle_Tank_Type>;
  /** update multiples rows of table: "vehicle_tank_type" */
  update_vehicle_tank_type_many?: Maybe<Array<Maybe<Vehicle_Tank_Type_Mutation_Response>>>;
  /** update data of the table: "vehicle_tank_type_product_variation" */
  update_vehicle_tank_type_product_variation?: Maybe<Vehicle_Tank_Type_Product_Variation_Mutation_Response>;
  /** update single row of the table: "vehicle_tank_type_product_variation" */
  update_vehicle_tank_type_product_variation_by_pk?: Maybe<Vehicle_Tank_Type_Product_Variation>;
  /** update multiples rows of table: "vehicle_tank_type_product_variation" */
  update_vehicle_tank_type_product_variation_many?: Maybe<Array<Maybe<Vehicle_Tank_Type_Product_Variation_Mutation_Response>>>;
  /** update data of the table: "vehicle_type" */
  update_vehicle_type?: Maybe<Vehicle_Type_Mutation_Response>;
  /** update single row of the table: "vehicle_type" */
  update_vehicle_type_by_pk?: Maybe<Vehicle_Type>;
  /** update multiples rows of table: "vehicle_type" */
  update_vehicle_type_many?: Maybe<Array<Maybe<Vehicle_Type_Mutation_Response>>>;
  /** update data of the table: "vendor_order_logs" */
  update_vendor_order_logs?: Maybe<Vendor_Order_Logs_Mutation_Response>;
  /** update single row of the table: "vendor_order_logs" */
  update_vendor_order_logs_by_pk?: Maybe<Vendor_Order_Logs>;
  /** update multiples rows of table: "vendor_order_logs" */
  update_vendor_order_logs_many?: Maybe<Array<Maybe<Vendor_Order_Logs_Mutation_Response>>>;
  /** update data of the table: "vendor_sync_status" */
  update_vendor_sync_status?: Maybe<Vendor_Sync_Status_Mutation_Response>;
  /** update single row of the table: "vendor_sync_status" */
  update_vendor_sync_status_by_pk?: Maybe<Vendor_Sync_Status>;
  /** update multiples rows of table: "vendor_sync_status" */
  update_vendor_sync_status_many?: Maybe<Array<Maybe<Vendor_Sync_Status_Mutation_Response>>>;
  /** update data of the table: "voucher" */
  update_voucher?: Maybe<Voucher_Mutation_Response>;
  /** update single row of the table: "voucher" */
  update_voucher_by_pk?: Maybe<Voucher>;
  /** update multiples rows of table: "voucher" */
  update_voucher_many?: Maybe<Array<Maybe<Voucher_Mutation_Response>>>;
  /** update data of the table: "wallet" */
  update_wallet?: Maybe<Wallet_Mutation_Response>;
  /** update single row of the table: "wallet" */
  update_wallet_by_pk?: Maybe<Wallet>;
  /** update data of the table: "wallet_exception" */
  update_wallet_exception?: Maybe<Wallet_Exception_Mutation_Response>;
  /** update single row of the table: "wallet_exception" */
  update_wallet_exception_by_pk?: Maybe<Wallet_Exception>;
  /** update multiples rows of table: "wallet_exception" */
  update_wallet_exception_many?: Maybe<Array<Maybe<Wallet_Exception_Mutation_Response>>>;
  /** update data of the table: "wallet_ledger" */
  update_wallet_ledger?: Maybe<Wallet_Ledger_Mutation_Response>;
  /** update single row of the table: "wallet_ledger" */
  update_wallet_ledger_by_pk?: Maybe<Wallet_Ledger>;
  /** update multiples rows of table: "wallet_ledger" */
  update_wallet_ledger_many?: Maybe<Array<Maybe<Wallet_Ledger_Mutation_Response>>>;
  /** update multiples rows of table: "wallet" */
  update_wallet_many?: Maybe<Array<Maybe<Wallet_Mutation_Response>>>;
  /** update data of the table: "wallet_state" */
  update_wallet_state?: Maybe<Wallet_State_Mutation_Response>;
  /** update single row of the table: "wallet_state" */
  update_wallet_state_by_pk?: Maybe<Wallet_State>;
  /** update multiples rows of table: "wallet_state" */
  update_wallet_state_many?: Maybe<Array<Maybe<Wallet_State_Mutation_Response>>>;
  /** update data of the table: "wallet_transactions" */
  update_wallet_transactions?: Maybe<Wallet_Transactions_Mutation_Response>;
  /** update single row of the table: "wallet_transactions" */
  update_wallet_transactions_by_pk?: Maybe<Wallet_Transactions>;
  /** update multiples rows of table: "wallet_transactions" */
  update_wallet_transactions_many?: Maybe<Array<Maybe<Wallet_Transactions_Mutation_Response>>>;
  /** This is cloud storage upload mutation. */
  uploadFile?: Maybe<StorageOutput>;
  uploadFuelTransTxnLogsExcel?: Maybe<UploadFuelTransTxnLogsExcelOutput>;
  upsertCustomerAssetET?: Maybe<UpsertCustomerAssetEtOutput>;
  /** verifyEasebuzzPaymentStatus */
  verifyEasebuzzPaymentStatus?: Maybe<VerifyEasebuzzPaymentStatusOutPut>;
  /** This is verify order OTP for order */
  verifyOrderOtp?: Maybe<VerifyOrderOtpOutput>;
  verifyPaymentStatus?: Maybe<VerifyPaymentStatusOutPut>;
};


/** mutation root */
export type Mutation_RootAcceptCustomerOrderArgs = {
  object: AcceptCustomerOrderInput;
};


/** mutation root */
export type Mutation_RootAddMissingCustomerOrderCustomerAssetArgs = {
  object: AddMissingCustomerOrderCustomerAssetInput;
};


/** mutation root */
export type Mutation_RootAddUserToOrganizationArgs = {
  object: AddUserToOrganizationInput;
};


/** mutation root */
export type Mutation_RootAddUserToPartnerArgs = {
  object: AddUserToPartnerInput;
};


/** mutation root */
export type Mutation_RootApproveDailyPlanArgs = {
  object: ApproveDailyPlanInput;
};


/** mutation root */
export type Mutation_RootAssignTaskArgs = {
  object: AssignTaskInput;
};


/** mutation root */
export type Mutation_RootAttachedRfidWithCustomerAssetArgs = {
  object: AttachedRfidWithCustomerAssetInput;
};


/** mutation root */
export type Mutation_RootBlock_Wallet_AmountArgs = {
  args: Block_Wallet_Amount_Args;
  distinct_on?: InputMaybe<Array<Wallet_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Order_By>>;
  where?: InputMaybe<Wallet_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootCancelCustomerOrderArgs = {
  object: CancelOrderInput;
};


/** mutation root */
export type Mutation_RootCancelOrderByUserArgs = {
  object: CancelCustomerOrderInput;
};


/** mutation root */
export type Mutation_RootCheckDeliveryNotesInvoicedArgs = {
  object: CheckDeliveryNotesInvoicedInput;
};


/** mutation root */
export type Mutation_RootCheckWalletAmountExitsArgs = {
  object: CheckWalletAmountExitsInput;
};


/** mutation root */
export type Mutation_RootCorrectLedgerEntryArgs = {
  object: CorrectLedgerEntryInput;
};


/** mutation root */
export type Mutation_RootCreateAdocCustomerOrderArgs = {
  object: CreateAdocCustomerOrderInput;
};


/** mutation root */
export type Mutation_RootCreateBulkOrderArgs = {
  object: CreateBulkOrderInput;
};


/** mutation root */
export type Mutation_RootCreateBulkShiftScheduleArgs = {
  object: CreateBulkShiftScheduleInput;
};


/** mutation root */
export type Mutation_RootCreateCustomerOrderArgs = {
  object: CustomerOrderInput;
};


/** mutation root */
export type Mutation_RootCreateDeliveryInvoiceArgs = {
  object: CreateDeliveryInvoiceInput;
};


/** mutation root */
export type Mutation_RootCreateEasebuzzPaymentLinkArgs = {
  object: CreatePaymentLinkInput;
};


/** mutation root */
export type Mutation_RootCreateGrnArgs = {
  object: CreateGrnInput;
};


/** mutation root */
export type Mutation_RootCreateInvoicedItemForAssetArgs = {
  object: CreateInvoicedItemForAssetInput;
};


/** mutation root */
export type Mutation_RootCreateOrUpdateUserFirebaseArgs = {
  object: CreateOrUpdateUserFirebaseInput;
};


/** mutation root */
export type Mutation_RootCreateStockEntryArgs = {
  object: CreateStockEntryInput;
};


/** mutation root */
export type Mutation_RootCreateTaskFromFranchiseArgs = {
  object: CreateTaskFromFranchiseTaskInsertInput;
};


/** mutation root */
export type Mutation_RootCreateTaskValueArgs = {
  object: CreateTaskValueInput;
};


/** mutation root */
export type Mutation_RootCreateUserArgs = {
  object: CreateUserInput;
};


/** mutation root */
export type Mutation_RootCreateUserRefactoredArgs = {
  object: CreateUserRefactoredInput;
};


/** mutation root */
export type Mutation_RootCustomerOrderSanityArgs = {
  object: CustomerOrderSanityInput;
};


/** mutation root */
export type Mutation_RootDelete_Address_SubsidiaryArgs = {
  where: Address_Subsidiary_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Address_Subsidiary_Audit_LogsArgs = {
  where: Address_Subsidiary_Audit_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Address_Subsidiary_Audit_Logs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Address_Subsidiary_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Address_TypeArgs = {
  where: Address_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Address_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Asset_GroupingArgs = {
  where: Asset_Grouping_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Asset_Grouping_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Asset_Grouping_Customer_AssetArgs = {
  where: Asset_Grouping_Customer_Asset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Asset_Grouping_Customer_Asset_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Asset_SubsidiaryArgs = {
  where: Asset_Subsidiary_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Asset_Subsidiary_Audit_LogsArgs = {
  where: Asset_Subsidiary_Audit_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Asset_Subsidiary_Audit_Logs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Asset_Subsidiary_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Asset_TypeArgs = {
  where: Asset_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Asset_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Asset_Type_CategoryArgs = {
  where: Asset_Type_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Asset_Type_Category_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Associated_TypeArgs = {
  where: Associated_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Associated_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Audit_Log_ActionArgs = {
  where: Audit_Log_Action_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Audit_Log_Action_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Cancellation_ReasonsArgs = {
  where: Cancellation_Reasons_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cancellation_Reasons_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CategoryArgs = {
  where: Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CityArgs = {
  where: City_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_City_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CountryArgs = {
  where: Country_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Country_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Credit_BreachArgs = {
  where: Credit_Breach_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Credit_Breach_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CurrencyArgs = {
  where: Currency_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Currency_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Currency_ConversionArgs = {
  where: Currency_Conversion_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Currency_Conversion_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Customer_AssetArgs = {
  where: Customer_Asset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Customer_Asset_Audit_LogArgs = {
  where: Customer_Asset_Audit_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Customer_Asset_Audit_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Customer_Asset_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Customer_Asset_DeviceArgs = {
  where: Customer_Asset_Device_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Customer_Asset_Device_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Customer_Asset_Device_CalibrationArgs = {
  where: Customer_Asset_Device_Calibration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Customer_Asset_Device_Calibration_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Customer_Asset_Dispensing_RulesArgs = {
  where: Customer_Asset_Dispensing_Rules_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Customer_Asset_Dispensing_Rules_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Customer_Asset_LimitArgs = {
  where: Customer_Asset_Limit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Customer_Asset_Limit_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Customer_Asset_TagArgs = {
  where: Customer_Asset_Tag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Customer_Asset_Tag_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Customer_OrderArgs = {
  where: Customer_Order_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Customer_Order_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Customer_Order_Cancellation_ReasonsArgs = {
  where: Customer_Order_Cancellation_Reasons_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Customer_Order_Cancellation_Reasons_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Customer_Order_Customer_AssetArgs = {
  where: Customer_Order_Customer_Asset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Customer_Order_Customer_Asset_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Customer_Order_ItemArgs = {
  where: Customer_Order_Item_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Customer_Order_Item_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Customer_Order_Item_Cancellation_ReasonsArgs = {
  where: Customer_Order_Item_Cancellation_Reasons_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Customer_Order_Item_Cancellation_Reasons_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Customer_Order_Item_CommentsArgs = {
  where: Customer_Order_Item_Comments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Customer_Order_Item_Comments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Customer_Order_Item_CommissionArgs = {
  where: Customer_Order_Item_Commission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Customer_Order_Item_Commission_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Customer_Order_Item_Etd_Transactional_LogsArgs = {
  where: Customer_Order_Item_Etd_Transactional_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Customer_Order_Item_Etd_Transactional_Logs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Customer_Order_Item_PartnerArgs = {
  where: Customer_Order_Item_Partner_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Customer_Order_Item_Partner_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Customer_Order_Item_Safety_Checklist_ResultsArgs = {
  where: Customer_Order_Item_Safety_Checklist_Results_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Customer_Order_Item_Safety_Checklist_Results_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Customer_Order_Item_StateArgs = {
  where: Customer_Order_Item_State_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Customer_Order_Item_State_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Customer_Order_Item_StateflowArgs = {
  where: Customer_Order_Item_Stateflow_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Customer_Order_Item_Stateflow_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Customer_Order_Item_Test_CategoryArgs = {
  where: Customer_Order_Item_Test_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Customer_Order_Item_Test_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Customer_Order_Item_Test_ResultsArgs = {
  where: Customer_Order_Item_Test_Results_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Customer_Order_Item_Test_Results_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Customer_Order_Item_Test_Results_PhotosArgs = {
  where: Customer_Order_Item_Test_Results_Photos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Customer_Order_Item_Test_Results_Photos_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Customer_Order_Organization_User_DocumentArgs = {
  where: Customer_Order_Organization_User_Document_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Customer_Order_Organization_User_Document_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Customer_Order_Partner_OrderArgs = {
  where: Customer_Order_Partner_Order_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Customer_Order_Partner_Order_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Customer_Order_SlotsArgs = {
  where: Customer_Order_Slots_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Customer_Order_Slots_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Customer_Order_StateArgs = {
  where: Customer_Order_State_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Customer_Order_State_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Customer_Order_StateflowArgs = {
  where: Customer_Order_Stateflow_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Customer_Order_Stateflow_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Customer_PaymentArgs = {
  where: Customer_Payment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Customer_Payment_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Customer_Payment_StatusArgs = {
  where: Customer_Payment_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Customer_Payment_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Customer_SegmentationArgs = {
  where: Customer_Segmentation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Customer_Segmentation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Day_TypeArgs = {
  where: Day_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Day_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Delivery_PreferencesArgs = {
  where: Delivery_Preferences_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Delivery_Preferences_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Delivery_SchedulerArgs = {
  where: Delivery_Scheduler_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Delivery_Scheduler_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Delivery_Scheduler_Product_ItemArgs = {
  where: Delivery_Scheduler_Product_Item_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Delivery_Scheduler_Product_Item_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Department_Retag_RequestArgs = {
  where: Department_Retag_Request_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Department_Retag_Request_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Device_Devicetype_Paramerter_DefinitionArgs = {
  where: Device_Devicetype_Paramerter_Definition_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Device_Devicetype_Paramerter_Definition_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_DevicetypeArgs = {
  where: Devicetype_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Devicetype_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Devicetype_Paramerter_DefinitionArgs = {
  where: Devicetype_Paramerter_Definition_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Devicetype_Paramerter_Definition_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Devicetype_Parameter_GroupArgs = {
  where: Devicetype_Parameter_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Devicetype_Parameter_Group_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Discount_TypeArgs = {
  where: Discount_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Discount_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_DispenserArgs = {
  where: Dispenser_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Dispenser_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Dispenser_ConfigurationArgs = {
  where: Dispenser_Configuration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Dispenser_Configuration_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Dispenser_TypeArgs = {
  where: Dispenser_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Dispenser_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Dispensing_RulesArgs = {
  where: Dispensing_Rules_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Dispensing_Rules_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Document_TypeArgs = {
  where: Document_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Document_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Document_Type_CategoryArgs = {
  where: Document_Type_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Document_Type_Category_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_DocumentsArgs = {
  where: Documents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Documents_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Driver_Duty_LogArgs = {
  where: Driver_Duty_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Driver_Duty_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Driver_Duty_PhotosArgs = {
  where: Driver_Duty_Photos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Driver_Duty_Photos_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Driver_PermitArgs = {
  where: Driver_Permit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Driver_Permit_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Driver_VehicleArgs = {
  where: Driver_Vehicle_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Driver_Vehicle_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Driver_Vehicle_IssueArgs = {
  where: Driver_Vehicle_Issue_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Driver_Vehicle_Issue_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Driver_Vehicle_LocationArgs = {
  where: Driver_Vehicle_Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Driver_Vehicle_Location_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Erp_Sync_StatusArgs = {
  where: Erp_Sync_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Erp_Sync_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Fillup_RequestArgs = {
  where: Fillup_Request_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Fillup_Request_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Fillup_Request_StatusArgs = {
  where: Fillup_Request_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Fillup_Request_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Fuel_Request_TypeArgs = {
  where: Fuel_Request_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Fuel_Request_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Fueltrans_Transaction_LogsArgs = {
  where: Fueltrans_Transaction_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Fueltrans_Transaction_Logs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Geometry_ColumnsArgs = {
  where: Geometry_Columns_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_InventoryArgs = {
  where: Inventory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Inventory_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Inventory_Workflow_LogsArgs = {
  where: Inventory_Workflow_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Inventory_Workflow_Logs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_InvitationArgs = {
  where: Invitation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Invitation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Invitation_StatusArgs = {
  where: Invitation_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Invitation_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_InvoiceArgs = {
  where: Invoice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Invoice_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Invoiced_ItemArgs = {
  where: Invoiced_Item_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Invoiced_Item_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Invoiced_Item_Cancellation_Ticket_StatesArgs = {
  where: Invoiced_Item_Cancellation_Ticket_States_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Invoiced_Item_Cancellation_Ticket_States_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Invoiced_Item_Cancellation_TicketsArgs = {
  where: Invoiced_Item_Cancellation_Tickets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Invoiced_Item_Cancellation_Tickets_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_IssueArgs = {
  where: Issue_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Issue_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Job_StateArgs = {
  where: Job_State_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Job_State_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Job_TypeArgs = {
  where: Job_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Job_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Job_Type_TemplateArgs = {
  where: Job_Type_Template_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Job_Type_Template_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_JobsArgs = {
  where: Jobs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Jobs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Jobs_State_FlowArgs = {
  where: Jobs_State_Flow_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Jobs_State_Flow_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Limit_Purchase_OrderArgs = {
  where: Limit_Purchase_Order_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Limit_Purchase_Order_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Limit_Purchase_Order_LogsArgs = {
  where: Limit_Purchase_Order_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Limit_Purchase_Order_Logs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_LocalitiesArgs = {
  where: Localities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Localities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Login_TypeArgs = {
  where: Login_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Login_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Lpo_ExceptionArgs = {
  where: Lpo_Exception_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Lpo_Exception_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Master_SlotArgs = {
  where: Master_Slot_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Master_Slot_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Master_Slot_PauseArgs = {
  where: Master_Slot_Pause_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Master_Slot_Pause_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Omc_TypeArgs = {
  where: Omc_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Omc_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Order_PhotosArgs = {
  where: Order_Photos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Order_Photos_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Order_SchedulerArgs = {
  where: Order_Scheduler_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Order_Scheduler_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Order_Scheduler_Customer_AssetArgs = {
  where: Order_Scheduler_Customer_Asset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Order_Scheduler_Customer_Asset_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Order_Scheduler_Daily_FrequencyArgs = {
  where: Order_Scheduler_Daily_Frequency_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Order_Scheduler_Daily_Frequency_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Order_TypeArgs = {
  where: Order_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Order_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_OrganizationArgs = {
  where: Organization_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_AddressArgs = {
  where: Organization_Address_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Address_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_Audit_LogArgs = {
  where: Organization_Audit_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Audit_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_Commission_Product_Variation_TypeArgs = {
  where: Organization_Commission_Product_Variation_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Commission_Product_Variation_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_ConfigurationArgs = {
  where: Organization_Configuration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Configuration_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_Product_Variation_DiscountArgs = {
  where: Organization_Product_Variation_Discount_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Product_Variation_Discount_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_Product_Variation_Discount_HistoryArgs = {
  where: Organization_Product_Variation_Discount_History_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Product_Variation_Discount_History_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_Sales_ProjectionArgs = {
  where: Organization_Sales_Projection_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Sales_Projection_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_TimingArgs = {
  where: Organization_Timing_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Timing_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_TypeArgs = {
  where: Organization_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_UserArgs = {
  where: Organization_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_User_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_User_CommissionArgs = {
  where: Organization_User_Commission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_User_Commission_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_User_DocumentArgs = {
  where: Organization_User_Document_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_User_Document_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_User_PermissionArgs = {
  where: Organization_User_Permission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_User_Permission_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_User_SubsidiaryArgs = {
  where: Organization_User_Subsidiary_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_User_Subsidiary_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_User_TypeArgs = {
  where: Organization_User_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_User_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Ownership_TypeArgs = {
  where: Ownership_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ownership_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PartnerArgs = {
  where: Partner_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Partner_AddressArgs = {
  where: Partner_Address_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Partner_Address_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Partner_Bank_DetailsArgs = {
  where: Partner_Bank_Details_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Partner_Bank_Details_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Partner_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Partner_CommissionArgs = {
  where: Partner_Commission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Partner_Commission_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Partner_Commission_Product_Variation_TypeArgs = {
  where: Partner_Commission_Product_Variation_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Partner_Commission_Product_Variation_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Partner_Contact_TypeArgs = {
  where: Partner_Contact_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Partner_Contact_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Partner_LocalitiesArgs = {
  where: Partner_Localities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Partner_Localities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Partner_Localities_SlotsArgs = {
  where: Partner_Localities_Slots_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Partner_Localities_Slots_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Partner_OrderArgs = {
  where: Partner_Order_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Partner_Order_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Partner_Order_Customer_AssetArgs = {
  where: Partner_Order_Customer_Asset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Partner_Order_Customer_Asset_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Partner_Order_ItemArgs = {
  where: Partner_Order_Item_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Partner_Order_Item_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Partner_Order_Item_CommissionArgs = {
  where: Partner_Order_Item_Commission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Partner_Order_Item_Commission_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Partner_Order_Item_StateArgs = {
  where: Partner_Order_Item_State_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Partner_Order_Item_State_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Partner_Order_Item_StateflowArgs = {
  where: Partner_Order_Item_Stateflow_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Partner_Order_Item_Stateflow_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Partner_Order_Item_Test_CategoryArgs = {
  where: Partner_Order_Item_Test_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Partner_Order_Item_Test_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Partner_Order_Item_Test_ResultsArgs = {
  where: Partner_Order_Item_Test_Results_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Partner_Order_Item_Test_Results_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Partner_Order_Item_Test_Results_PhotosArgs = {
  where: Partner_Order_Item_Test_Results_Photos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Partner_Order_Item_Test_Results_Photos_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Partner_Order_Item_ValueArgs = {
  where: Partner_Order_Item_Value_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Partner_Order_Item_Value_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Partner_Order_Partner_User_DocumentArgs = {
  where: Partner_Order_Partner_User_Document_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Partner_Order_Partner_User_Document_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Partner_Order_StateArgs = {
  where: Partner_Order_State_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Partner_Order_State_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Partner_Order_StateflowArgs = {
  where: Partner_Order_Stateflow_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Partner_Order_Stateflow_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Partner_PaymentArgs = {
  where: Partner_Payment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Partner_Payment_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Partner_ProductArgs = {
  where: Partner_Product_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Partner_Product_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Partner_RelationshipArgs = {
  where: Partner_Relationship_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Partner_Relationship_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Partner_SellerArgs = {
  where: Partner_Seller_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Partner_Seller_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Partner_Seller_TypeArgs = {
  where: Partner_Seller_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Partner_Seller_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Partner_Signing_AuthorityArgs = {
  where: Partner_Signing_Authority_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Partner_Signing_Authority_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Partner_TimingArgs = {
  where: Partner_Timing_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Partner_Timing_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Partner_TypeArgs = {
  where: Partner_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Partner_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Partner_UserArgs = {
  where: Partner_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Partner_User_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Partner_User_DocumentArgs = {
  where: Partner_User_Document_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Partner_User_Document_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Partner_User_PermissionArgs = {
  where: Partner_User_Permission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Partner_User_Permission_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Partner_VehicleArgs = {
  where: Partner_Vehicle_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Partner_Vehicle_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Partner_Vehicle_StateArgs = {
  where: Partner_Vehicle_State_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Partner_Vehicle_State_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Payment_TypeArgs = {
  where: Payment_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Payment_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Period_FrequencyArgs = {
  where: Period_Frequency_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Period_Frequency_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PermissionArgs = {
  where: Permission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Permission_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PermitArgs = {
  where: Permit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Permit_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Photo_TypeArgs = {
  where: Photo_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Photo_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Planning_Audit_LogArgs = {
  where: Planning_Audit_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Planning_Audit_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Planning_PeriodArgs = {
  where: Planning_Period_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Planning_Period_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProductArgs = {
  where: Product_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Product_CommissionArgs = {
  where: Product_Commission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Commission_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Product_DocumentArgs = {
  where: Product_Document_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Document_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Product_Partner_Localities_PriceArgs = {
  where: Product_Partner_Localities_Price_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Partner_Localities_Price_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Product_Partner_Localities_Price_HistoryArgs = {
  where: Product_Partner_Localities_Price_History_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Partner_Localities_Price_History_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Product_PhotosArgs = {
  where: Product_Photos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Photos_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Product_TypeArgs = {
  where: Product_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Product_VariationArgs = {
  where: Product_Variation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Variation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Product_Variation_Partner_Localities_SlotsArgs = {
  where: Product_Variation_Partner_Localities_Slots_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Variation_Partner_Localities_Slots_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Product_Variation_PhotosArgs = {
  where: Product_Variation_Photos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Variation_Photos_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Product_Variation_Safety_Checklist_CategoryArgs = {
  where: Product_Variation_Safety_Checklist_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Variation_Safety_Checklist_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Product_Variation_Test_CategoryArgs = {
  where: Product_Variation_Test_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Variation_Test_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Purchase_OrderArgs = {
  where: Purchase_Order_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Purchase_Order_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Purchase_Order_ItemsArgs = {
  where: Purchase_Order_Items_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Purchase_Order_Items_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quantity_Correction_Ticket_StatesArgs = {
  where: Quantity_Correction_Ticket_States_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quantity_Correction_Ticket_States_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quantity_Correction_TicketsArgs = {
  where: Quantity_Correction_Tickets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quantity_Correction_Tickets_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Reason_TypeArgs = {
  where: Reason_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Reason_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ReasonsArgs = {
  where: Reasons_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Reasons_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_RoleArgs = {
  where: Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Role_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Role_DocumentArgs = {
  where: Role_Document_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Role_Document_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Safety_ChecklistArgs = {
  where: Safety_Checklist_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Safety_Checklist_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Safety_Checklist_CategoryArgs = {
  where: Safety_Checklist_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Safety_Checklist_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Script_TypeArgs = {
  where: Script_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Script_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ScriptsArgs = {
  where: Scripts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Scripts_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ServicesArgs = {
  where: Services_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Services_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Services_CategoryArgs = {
  where: Services_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Services_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Shift_ScheduleArgs = {
  where: Shift_Schedule_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Shift_Schedule_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Shift_Schedule_DispenserArgs = {
  where: Shift_Schedule_Dispenser_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Shift_Schedule_Dispenser_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Shift_TemplateArgs = {
  where: Shift_Template_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Shift_Template_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Slab_TypeArgs = {
  where: Slab_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Slab_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Source_TypeArgs = {
  where: Source_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Source_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Spatial_Ref_SysArgs = {
  where: Spatial_Ref_Sys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Spatial_Ref_Sys_By_PkArgs = {
  srid: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_StateArgs = {
  where: State_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_State_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_SubsidiaryArgs = {
  where: Subsidiary_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Subsidiary_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Support_TicketsArgs = {
  where: Support_Tickets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Support_Tickets_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Support_Tickets_CategoryArgs = {
  where: Support_Tickets_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Support_Tickets_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Support_Tickets_PhotosArgs = {
  where: Support_Tickets_Photos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Support_Tickets_Photos_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TagArgs = {
  where: Tag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tag_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tank_TypeArgs = {
  where: Tank_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tank_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TaskArgs = {
  where: Task_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Task_Action_InstructionArgs = {
  where: Task_Action_Instruction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Task_Action_Instruction_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Task_Action_TypeArgs = {
  where: Task_Action_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Task_Action_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Task_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Task_Cancellation_ReasonsArgs = {
  where: Task_Cancellation_Reasons_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Task_Cancellation_Reasons_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Task_StateArgs = {
  where: Task_State_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Task_State_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Task_States_FlowArgs = {
  where: Task_States_Flow_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Task_States_Flow_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Task_TypeArgs = {
  where: Task_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Task_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Task_ValueArgs = {
  where: Task_Value_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Task_Value_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TestArgs = {
  where: Test_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Test_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Test_CategoryArgs = {
  where: Test_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Test_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Ticket_StateArgs = {
  where: Ticket_State_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ticket_State_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Ticket_TypeArgs = {
  where: Ticket_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ticket_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TicketsArgs = {
  where: Tickets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tickets_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Totalizer_Correction_Ticket_StatesArgs = {
  where: Totalizer_Correction_Ticket_States_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Totalizer_Correction_Ticket_States_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Totalizer_Correction_TicketsArgs = {
  where: Totalizer_Correction_Tickets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Totalizer_Correction_Tickets_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Transaction_TypeArgs = {
  where: Transaction_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Transaction_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TripArgs = {
  where: Trip_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Trip_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Trip_LocationArgs = {
  where: Trip_Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Trip_Location_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Trip_PlanArgs = {
  where: Trip_Plan_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Trip_Plan_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Unit_Of_MeasureArgs = {
  where: Unit_Of_Measure_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Unit_Of_Measure_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Unit_Of_Measure_MetaArgs = {
  where: Unit_Of_Measure_Meta_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Unit_Of_Measure_Meta_By_PkArgs = {
  value: Unit_Of_Measure_Enum;
};


/** mutation root */
export type Mutation_RootDelete_Uom_ConversionArgs = {
  where: Uom_Conversion_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uom_Conversion_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_UserArgs = {
  where: User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Access_Audit_LogArgs = {
  where: User_Access_Audit_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Access_Audit_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_LedgerArgs = {
  where: User_Ledger_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Ledger_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_Partner_TypeArgs = {
  where: User_Partner_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Partner_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_ReferralArgs = {
  where: User_Referral_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Referral_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_RoleArgs = {
  where: User_Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Role_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Validation_WorkflowsArgs = {
  where: Validation_Workflows_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Validation_Workflows_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_VariationArgs = {
  where: Variation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Variation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Variation_TypeArgs = {
  where: Variation_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Variation_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_VehicleArgs = {
  where: Vehicle_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_ConfigurationArgs = {
  where: Vehicle_Configuration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_Configuration_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_DeviceArgs = {
  where: Vehicle_Device_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_Device_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_Device_CalibrationArgs = {
  where: Vehicle_Device_Calibration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_Device_Calibration_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_Inventory_Transaction_LogsArgs = {
  where: Vehicle_Inventory_Transaction_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_Inventory_Transaction_Logs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_LocalitiesArgs = {
  where: Vehicle_Localities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_Localities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_PermitArgs = {
  where: Vehicle_Permit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_Permit_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_Shift_TemplateArgs = {
  where: Vehicle_Shift_Template_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_Shift_Template_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_StatusArgs = {
  where: Vehicle_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_Status_LogsArgs = {
  where: Vehicle_Status_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_Status_Logs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_Tank_TypeArgs = {
  where: Vehicle_Tank_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_Tank_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_Tank_Type_Product_VariationArgs = {
  where: Vehicle_Tank_Type_Product_Variation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_Tank_Type_Product_Variation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_TypeArgs = {
  where: Vehicle_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Vendor_Order_LogsArgs = {
  where: Vendor_Order_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Vendor_Order_Logs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Vendor_Sync_StatusArgs = {
  where: Vendor_Sync_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Vendor_Sync_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_VoucherArgs = {
  where: Voucher_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Voucher_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_WalletArgs = {
  where: Wallet_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Wallet_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Wallet_ExceptionArgs = {
  where: Wallet_Exception_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Wallet_Exception_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Wallet_LedgerArgs = {
  where: Wallet_Ledger_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Wallet_Ledger_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Wallet_StateArgs = {
  where: Wallet_State_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Wallet_State_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Wallet_TransactionsArgs = {
  where: Wallet_Transactions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Wallet_Transactions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeviceIotProcessorArgs = {
  object: DeviceIotProcessorInput;
};


/** mutation root */
export type Mutation_RootFetchAdvanceReceiptControlsArgs = {
  object: FetchAdvanceReceiptControlsInput;
};


/** mutation root */
export type Mutation_RootFetchBatchOrgConsumptionArgs = {
  object: FetchBatchOrgConsumptionInput;
};


/** mutation root */
export type Mutation_RootFetchCurrAndPrevOdometerReadingV2Args = {
  object: FetchCurrAndPrevOdometerReadingV2Input;
};


/** mutation root */
export type Mutation_RootFetchCustomerAssetDashboradDataArgs = {
  object: CustomerAssetDataInput;
};


/** mutation root */
export type Mutation_RootFetchCustomerOrderDashboradDataArgs = {
  object: CustomerOrderDataInput;
};


/** mutation root */
export type Mutation_RootFetchCustomerOrderItemSlotsByIdArgs = {
  object: FetchCustomerOrderItemSlotsByIdInput;
};


/** mutation root */
export type Mutation_RootFetchSlaTrackingV2Args = {
  object: FetchSlaTrackingV2Input;
};


/** mutation root */
export type Mutation_RootFetchWalletDriftDuplicateArgs = {
  object: FetchWalletDriftDuplicateInput;
};


/** mutation root */
export type Mutation_RootFetchWalletDriftInvariantArgs = {
  object: FetchWalletDriftInvariantInput;
};


/** mutation root */
export type Mutation_RootFetchWalletDriftMismatchArgs = {
  object: FetchWalletDriftMismatchInput;
};


/** mutation root */
export type Mutation_RootFetchWalletDriftMissingArgs = {
  object: FetchWalletDriftMissingInput;
};


/** mutation root */
export type Mutation_RootFetchWalletDriftOrphanArgs = {
  object: FetchWalletDriftOrphanInput;
};


/** mutation root */
export type Mutation_RootGetCustomerAssetDispensingLimitArgs = {
  object: GetCustomerAssetDispensingLimitInput;
};


/** mutation root */
export type Mutation_RootGetInvoiceInfoArgs = {
  object: GetInvoiceInfoInput;
};


/** mutation root */
export type Mutation_RootGetLatestTaskValueArgs = {
  object: GetLatestTaskValueInput;
};


/** mutation root */
export type Mutation_RootGetOrgLastSalesInvoiceDateArgs = {
  object: GetOrgLastSalesInvoiceDateInput;
};


/** mutation root */
export type Mutation_RootGetWalletStatementArgs = {
  object: GetWalletStatementInput;
};


/** mutation root */
export type Mutation_RootInitializeBackdatedWalletArgs = {
  object: InitializeBackdatedWalletInput;
};


/** mutation root */
export type Mutation_RootInsert_Address_SubsidiaryArgs = {
  objects: Array<Address_Subsidiary_Insert_Input>;
  on_conflict?: InputMaybe<Address_Subsidiary_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Address_Subsidiary_Audit_LogsArgs = {
  objects: Array<Address_Subsidiary_Audit_Logs_Insert_Input>;
  on_conflict?: InputMaybe<Address_Subsidiary_Audit_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Address_Subsidiary_Audit_Logs_OneArgs = {
  object: Address_Subsidiary_Audit_Logs_Insert_Input;
  on_conflict?: InputMaybe<Address_Subsidiary_Audit_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Address_Subsidiary_OneArgs = {
  object: Address_Subsidiary_Insert_Input;
  on_conflict?: InputMaybe<Address_Subsidiary_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Address_TypeArgs = {
  objects: Array<Address_Type_Insert_Input>;
  on_conflict?: InputMaybe<Address_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Address_Type_OneArgs = {
  object: Address_Type_Insert_Input;
  on_conflict?: InputMaybe<Address_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Asset_GroupingArgs = {
  objects: Array<Asset_Grouping_Insert_Input>;
  on_conflict?: InputMaybe<Asset_Grouping_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Asset_Grouping_Customer_AssetArgs = {
  objects: Array<Asset_Grouping_Customer_Asset_Insert_Input>;
  on_conflict?: InputMaybe<Asset_Grouping_Customer_Asset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Asset_Grouping_Customer_Asset_OneArgs = {
  object: Asset_Grouping_Customer_Asset_Insert_Input;
  on_conflict?: InputMaybe<Asset_Grouping_Customer_Asset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Asset_Grouping_OneArgs = {
  object: Asset_Grouping_Insert_Input;
  on_conflict?: InputMaybe<Asset_Grouping_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Asset_SubsidiaryArgs = {
  objects: Array<Asset_Subsidiary_Insert_Input>;
  on_conflict?: InputMaybe<Asset_Subsidiary_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Asset_Subsidiary_Audit_LogsArgs = {
  objects: Array<Asset_Subsidiary_Audit_Logs_Insert_Input>;
  on_conflict?: InputMaybe<Asset_Subsidiary_Audit_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Asset_Subsidiary_Audit_Logs_OneArgs = {
  object: Asset_Subsidiary_Audit_Logs_Insert_Input;
  on_conflict?: InputMaybe<Asset_Subsidiary_Audit_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Asset_Subsidiary_OneArgs = {
  object: Asset_Subsidiary_Insert_Input;
  on_conflict?: InputMaybe<Asset_Subsidiary_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Asset_TypeArgs = {
  objects: Array<Asset_Type_Insert_Input>;
  on_conflict?: InputMaybe<Asset_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Asset_Type_CategoryArgs = {
  objects: Array<Asset_Type_Category_Insert_Input>;
  on_conflict?: InputMaybe<Asset_Type_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Asset_Type_Category_OneArgs = {
  object: Asset_Type_Category_Insert_Input;
  on_conflict?: InputMaybe<Asset_Type_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Asset_Type_OneArgs = {
  object: Asset_Type_Insert_Input;
  on_conflict?: InputMaybe<Asset_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Associated_TypeArgs = {
  objects: Array<Associated_Type_Insert_Input>;
  on_conflict?: InputMaybe<Associated_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Associated_Type_OneArgs = {
  object: Associated_Type_Insert_Input;
  on_conflict?: InputMaybe<Associated_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Audit_Log_ActionArgs = {
  objects: Array<Audit_Log_Action_Insert_Input>;
  on_conflict?: InputMaybe<Audit_Log_Action_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Audit_Log_Action_OneArgs = {
  object: Audit_Log_Action_Insert_Input;
  on_conflict?: InputMaybe<Audit_Log_Action_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cancellation_ReasonsArgs = {
  objects: Array<Cancellation_Reasons_Insert_Input>;
  on_conflict?: InputMaybe<Cancellation_Reasons_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cancellation_Reasons_OneArgs = {
  object: Cancellation_Reasons_Insert_Input;
  on_conflict?: InputMaybe<Cancellation_Reasons_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CategoryArgs = {
  objects: Array<Category_Insert_Input>;
  on_conflict?: InputMaybe<Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Category_OneArgs = {
  object: Category_Insert_Input;
  on_conflict?: InputMaybe<Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CityArgs = {
  objects: Array<City_Insert_Input>;
  on_conflict?: InputMaybe<City_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_City_OneArgs = {
  object: City_Insert_Input;
  on_conflict?: InputMaybe<City_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CountryArgs = {
  objects: Array<Country_Insert_Input>;
  on_conflict?: InputMaybe<Country_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Country_OneArgs = {
  object: Country_Insert_Input;
  on_conflict?: InputMaybe<Country_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Credit_BreachArgs = {
  objects: Array<Credit_Breach_Insert_Input>;
  on_conflict?: InputMaybe<Credit_Breach_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Credit_Breach_OneArgs = {
  object: Credit_Breach_Insert_Input;
  on_conflict?: InputMaybe<Credit_Breach_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CurrencyArgs = {
  objects: Array<Currency_Insert_Input>;
  on_conflict?: InputMaybe<Currency_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Currency_ConversionArgs = {
  objects: Array<Currency_Conversion_Insert_Input>;
  on_conflict?: InputMaybe<Currency_Conversion_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Currency_Conversion_OneArgs = {
  object: Currency_Conversion_Insert_Input;
  on_conflict?: InputMaybe<Currency_Conversion_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Currency_OneArgs = {
  object: Currency_Insert_Input;
  on_conflict?: InputMaybe<Currency_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_AssetArgs = {
  objects: Array<Customer_Asset_Insert_Input>;
  on_conflict?: InputMaybe<Customer_Asset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Asset_Audit_LogArgs = {
  objects: Array<Customer_Asset_Audit_Log_Insert_Input>;
  on_conflict?: InputMaybe<Customer_Asset_Audit_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Asset_Audit_Log_OneArgs = {
  object: Customer_Asset_Audit_Log_Insert_Input;
  on_conflict?: InputMaybe<Customer_Asset_Audit_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Asset_DeviceArgs = {
  objects: Array<Customer_Asset_Device_Insert_Input>;
  on_conflict?: InputMaybe<Customer_Asset_Device_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Asset_Device_CalibrationArgs = {
  objects: Array<Customer_Asset_Device_Calibration_Insert_Input>;
  on_conflict?: InputMaybe<Customer_Asset_Device_Calibration_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Asset_Device_Calibration_OneArgs = {
  object: Customer_Asset_Device_Calibration_Insert_Input;
  on_conflict?: InputMaybe<Customer_Asset_Device_Calibration_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Asset_Device_OneArgs = {
  object: Customer_Asset_Device_Insert_Input;
  on_conflict?: InputMaybe<Customer_Asset_Device_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Asset_Dispensing_RulesArgs = {
  objects: Array<Customer_Asset_Dispensing_Rules_Insert_Input>;
  on_conflict?: InputMaybe<Customer_Asset_Dispensing_Rules_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Asset_Dispensing_Rules_OneArgs = {
  object: Customer_Asset_Dispensing_Rules_Insert_Input;
  on_conflict?: InputMaybe<Customer_Asset_Dispensing_Rules_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Asset_LimitArgs = {
  objects: Array<Customer_Asset_Limit_Insert_Input>;
  on_conflict?: InputMaybe<Customer_Asset_Limit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Asset_Limit_OneArgs = {
  object: Customer_Asset_Limit_Insert_Input;
  on_conflict?: InputMaybe<Customer_Asset_Limit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Asset_OneArgs = {
  object: Customer_Asset_Insert_Input;
  on_conflict?: InputMaybe<Customer_Asset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Asset_TagArgs = {
  objects: Array<Customer_Asset_Tag_Insert_Input>;
  on_conflict?: InputMaybe<Customer_Asset_Tag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Asset_Tag_OneArgs = {
  object: Customer_Asset_Tag_Insert_Input;
  on_conflict?: InputMaybe<Customer_Asset_Tag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_OrderArgs = {
  objects: Array<Customer_Order_Insert_Input>;
  on_conflict?: InputMaybe<Customer_Order_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Order_Cancellation_ReasonsArgs = {
  objects: Array<Customer_Order_Cancellation_Reasons_Insert_Input>;
  on_conflict?: InputMaybe<Customer_Order_Cancellation_Reasons_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Order_Cancellation_Reasons_OneArgs = {
  object: Customer_Order_Cancellation_Reasons_Insert_Input;
  on_conflict?: InputMaybe<Customer_Order_Cancellation_Reasons_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Order_Customer_AssetArgs = {
  objects: Array<Customer_Order_Customer_Asset_Insert_Input>;
  on_conflict?: InputMaybe<Customer_Order_Customer_Asset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Order_Customer_Asset_OneArgs = {
  object: Customer_Order_Customer_Asset_Insert_Input;
  on_conflict?: InputMaybe<Customer_Order_Customer_Asset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Order_ItemArgs = {
  objects: Array<Customer_Order_Item_Insert_Input>;
  on_conflict?: InputMaybe<Customer_Order_Item_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Order_Item_Cancellation_ReasonsArgs = {
  objects: Array<Customer_Order_Item_Cancellation_Reasons_Insert_Input>;
  on_conflict?: InputMaybe<Customer_Order_Item_Cancellation_Reasons_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Order_Item_Cancellation_Reasons_OneArgs = {
  object: Customer_Order_Item_Cancellation_Reasons_Insert_Input;
  on_conflict?: InputMaybe<Customer_Order_Item_Cancellation_Reasons_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Order_Item_CommentsArgs = {
  objects: Array<Customer_Order_Item_Comments_Insert_Input>;
  on_conflict?: InputMaybe<Customer_Order_Item_Comments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Order_Item_Comments_OneArgs = {
  object: Customer_Order_Item_Comments_Insert_Input;
  on_conflict?: InputMaybe<Customer_Order_Item_Comments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Order_Item_CommissionArgs = {
  objects: Array<Customer_Order_Item_Commission_Insert_Input>;
  on_conflict?: InputMaybe<Customer_Order_Item_Commission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Order_Item_Commission_OneArgs = {
  object: Customer_Order_Item_Commission_Insert_Input;
  on_conflict?: InputMaybe<Customer_Order_Item_Commission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Order_Item_Etd_Transactional_LogsArgs = {
  objects: Array<Customer_Order_Item_Etd_Transactional_Logs_Insert_Input>;
  on_conflict?: InputMaybe<Customer_Order_Item_Etd_Transactional_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Order_Item_Etd_Transactional_Logs_OneArgs = {
  object: Customer_Order_Item_Etd_Transactional_Logs_Insert_Input;
  on_conflict?: InputMaybe<Customer_Order_Item_Etd_Transactional_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Order_Item_OneArgs = {
  object: Customer_Order_Item_Insert_Input;
  on_conflict?: InputMaybe<Customer_Order_Item_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Order_Item_PartnerArgs = {
  objects: Array<Customer_Order_Item_Partner_Insert_Input>;
  on_conflict?: InputMaybe<Customer_Order_Item_Partner_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Order_Item_Partner_OneArgs = {
  object: Customer_Order_Item_Partner_Insert_Input;
  on_conflict?: InputMaybe<Customer_Order_Item_Partner_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Order_Item_Safety_Checklist_ResultsArgs = {
  objects: Array<Customer_Order_Item_Safety_Checklist_Results_Insert_Input>;
  on_conflict?: InputMaybe<Customer_Order_Item_Safety_Checklist_Results_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Order_Item_Safety_Checklist_Results_OneArgs = {
  object: Customer_Order_Item_Safety_Checklist_Results_Insert_Input;
  on_conflict?: InputMaybe<Customer_Order_Item_Safety_Checklist_Results_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Order_Item_StateArgs = {
  objects: Array<Customer_Order_Item_State_Insert_Input>;
  on_conflict?: InputMaybe<Customer_Order_Item_State_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Order_Item_State_OneArgs = {
  object: Customer_Order_Item_State_Insert_Input;
  on_conflict?: InputMaybe<Customer_Order_Item_State_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Order_Item_StateflowArgs = {
  objects: Array<Customer_Order_Item_Stateflow_Insert_Input>;
  on_conflict?: InputMaybe<Customer_Order_Item_Stateflow_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Order_Item_Stateflow_OneArgs = {
  object: Customer_Order_Item_Stateflow_Insert_Input;
  on_conflict?: InputMaybe<Customer_Order_Item_Stateflow_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Order_Item_Test_CategoryArgs = {
  objects: Array<Customer_Order_Item_Test_Category_Insert_Input>;
  on_conflict?: InputMaybe<Customer_Order_Item_Test_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Order_Item_Test_Category_OneArgs = {
  object: Customer_Order_Item_Test_Category_Insert_Input;
  on_conflict?: InputMaybe<Customer_Order_Item_Test_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Order_Item_Test_ResultsArgs = {
  objects: Array<Customer_Order_Item_Test_Results_Insert_Input>;
  on_conflict?: InputMaybe<Customer_Order_Item_Test_Results_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Order_Item_Test_Results_OneArgs = {
  object: Customer_Order_Item_Test_Results_Insert_Input;
  on_conflict?: InputMaybe<Customer_Order_Item_Test_Results_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Order_Item_Test_Results_PhotosArgs = {
  objects: Array<Customer_Order_Item_Test_Results_Photos_Insert_Input>;
  on_conflict?: InputMaybe<Customer_Order_Item_Test_Results_Photos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Order_Item_Test_Results_Photos_OneArgs = {
  object: Customer_Order_Item_Test_Results_Photos_Insert_Input;
  on_conflict?: InputMaybe<Customer_Order_Item_Test_Results_Photos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Order_OneArgs = {
  object: Customer_Order_Insert_Input;
  on_conflict?: InputMaybe<Customer_Order_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Order_Organization_User_DocumentArgs = {
  objects: Array<Customer_Order_Organization_User_Document_Insert_Input>;
  on_conflict?: InputMaybe<Customer_Order_Organization_User_Document_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Order_Organization_User_Document_OneArgs = {
  object: Customer_Order_Organization_User_Document_Insert_Input;
  on_conflict?: InputMaybe<Customer_Order_Organization_User_Document_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Order_Partner_OrderArgs = {
  objects: Array<Customer_Order_Partner_Order_Insert_Input>;
  on_conflict?: InputMaybe<Customer_Order_Partner_Order_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Order_Partner_Order_OneArgs = {
  object: Customer_Order_Partner_Order_Insert_Input;
  on_conflict?: InputMaybe<Customer_Order_Partner_Order_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Order_SlotsArgs = {
  objects: Array<Customer_Order_Slots_Insert_Input>;
  on_conflict?: InputMaybe<Customer_Order_Slots_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Order_Slots_OneArgs = {
  object: Customer_Order_Slots_Insert_Input;
  on_conflict?: InputMaybe<Customer_Order_Slots_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Order_StateArgs = {
  objects: Array<Customer_Order_State_Insert_Input>;
  on_conflict?: InputMaybe<Customer_Order_State_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Order_State_OneArgs = {
  object: Customer_Order_State_Insert_Input;
  on_conflict?: InputMaybe<Customer_Order_State_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Order_StateflowArgs = {
  objects: Array<Customer_Order_Stateflow_Insert_Input>;
  on_conflict?: InputMaybe<Customer_Order_Stateflow_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Order_Stateflow_OneArgs = {
  object: Customer_Order_Stateflow_Insert_Input;
  on_conflict?: InputMaybe<Customer_Order_Stateflow_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_PaymentArgs = {
  objects: Array<Customer_Payment_Insert_Input>;
  on_conflict?: InputMaybe<Customer_Payment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Payment_OneArgs = {
  object: Customer_Payment_Insert_Input;
  on_conflict?: InputMaybe<Customer_Payment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Payment_StatusArgs = {
  objects: Array<Customer_Payment_Status_Insert_Input>;
  on_conflict?: InputMaybe<Customer_Payment_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Payment_Status_OneArgs = {
  object: Customer_Payment_Status_Insert_Input;
  on_conflict?: InputMaybe<Customer_Payment_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_SegmentationArgs = {
  objects: Array<Customer_Segmentation_Insert_Input>;
  on_conflict?: InputMaybe<Customer_Segmentation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Segmentation_OneArgs = {
  object: Customer_Segmentation_Insert_Input;
  on_conflict?: InputMaybe<Customer_Segmentation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Day_TypeArgs = {
  objects: Array<Day_Type_Insert_Input>;
  on_conflict?: InputMaybe<Day_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Day_Type_OneArgs = {
  object: Day_Type_Insert_Input;
  on_conflict?: InputMaybe<Day_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Delivery_PreferencesArgs = {
  objects: Array<Delivery_Preferences_Insert_Input>;
  on_conflict?: InputMaybe<Delivery_Preferences_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Delivery_Preferences_OneArgs = {
  object: Delivery_Preferences_Insert_Input;
  on_conflict?: InputMaybe<Delivery_Preferences_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Delivery_SchedulerArgs = {
  objects: Array<Delivery_Scheduler_Insert_Input>;
  on_conflict?: InputMaybe<Delivery_Scheduler_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Delivery_Scheduler_OneArgs = {
  object: Delivery_Scheduler_Insert_Input;
  on_conflict?: InputMaybe<Delivery_Scheduler_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Delivery_Scheduler_Product_ItemArgs = {
  objects: Array<Delivery_Scheduler_Product_Item_Insert_Input>;
  on_conflict?: InputMaybe<Delivery_Scheduler_Product_Item_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Delivery_Scheduler_Product_Item_OneArgs = {
  object: Delivery_Scheduler_Product_Item_Insert_Input;
  on_conflict?: InputMaybe<Delivery_Scheduler_Product_Item_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Department_Retag_RequestArgs = {
  objects: Array<Department_Retag_Request_Insert_Input>;
  on_conflict?: InputMaybe<Department_Retag_Request_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Department_Retag_Request_OneArgs = {
  object: Department_Retag_Request_Insert_Input;
  on_conflict?: InputMaybe<Department_Retag_Request_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Device_Devicetype_Paramerter_DefinitionArgs = {
  objects: Array<Device_Devicetype_Paramerter_Definition_Insert_Input>;
  on_conflict?: InputMaybe<Device_Devicetype_Paramerter_Definition_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Device_Devicetype_Paramerter_Definition_OneArgs = {
  object: Device_Devicetype_Paramerter_Definition_Insert_Input;
  on_conflict?: InputMaybe<Device_Devicetype_Paramerter_Definition_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DevicetypeArgs = {
  objects: Array<Devicetype_Insert_Input>;
  on_conflict?: InputMaybe<Devicetype_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Devicetype_OneArgs = {
  object: Devicetype_Insert_Input;
  on_conflict?: InputMaybe<Devicetype_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Devicetype_Paramerter_DefinitionArgs = {
  objects: Array<Devicetype_Paramerter_Definition_Insert_Input>;
  on_conflict?: InputMaybe<Devicetype_Paramerter_Definition_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Devicetype_Paramerter_Definition_OneArgs = {
  object: Devicetype_Paramerter_Definition_Insert_Input;
  on_conflict?: InputMaybe<Devicetype_Paramerter_Definition_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Devicetype_Parameter_GroupArgs = {
  objects: Array<Devicetype_Parameter_Group_Insert_Input>;
  on_conflict?: InputMaybe<Devicetype_Parameter_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Devicetype_Parameter_Group_OneArgs = {
  object: Devicetype_Parameter_Group_Insert_Input;
  on_conflict?: InputMaybe<Devicetype_Parameter_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Discount_TypeArgs = {
  objects: Array<Discount_Type_Insert_Input>;
  on_conflict?: InputMaybe<Discount_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Discount_Type_OneArgs = {
  object: Discount_Type_Insert_Input;
  on_conflict?: InputMaybe<Discount_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DispenserArgs = {
  objects: Array<Dispenser_Insert_Input>;
  on_conflict?: InputMaybe<Dispenser_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Dispenser_ConfigurationArgs = {
  objects: Array<Dispenser_Configuration_Insert_Input>;
  on_conflict?: InputMaybe<Dispenser_Configuration_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Dispenser_Configuration_OneArgs = {
  object: Dispenser_Configuration_Insert_Input;
  on_conflict?: InputMaybe<Dispenser_Configuration_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Dispenser_OneArgs = {
  object: Dispenser_Insert_Input;
  on_conflict?: InputMaybe<Dispenser_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Dispenser_TypeArgs = {
  objects: Array<Dispenser_Type_Insert_Input>;
  on_conflict?: InputMaybe<Dispenser_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Dispenser_Type_OneArgs = {
  object: Dispenser_Type_Insert_Input;
  on_conflict?: InputMaybe<Dispenser_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Dispensing_RulesArgs = {
  objects: Array<Dispensing_Rules_Insert_Input>;
  on_conflict?: InputMaybe<Dispensing_Rules_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Dispensing_Rules_OneArgs = {
  object: Dispensing_Rules_Insert_Input;
  on_conflict?: InputMaybe<Dispensing_Rules_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_TypeArgs = {
  objects: Array<Document_Type_Insert_Input>;
  on_conflict?: InputMaybe<Document_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Type_CategoryArgs = {
  objects: Array<Document_Type_Category_Insert_Input>;
  on_conflict?: InputMaybe<Document_Type_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Type_Category_OneArgs = {
  object: Document_Type_Category_Insert_Input;
  on_conflict?: InputMaybe<Document_Type_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Type_OneArgs = {
  object: Document_Type_Insert_Input;
  on_conflict?: InputMaybe<Document_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DocumentsArgs = {
  objects: Array<Documents_Insert_Input>;
  on_conflict?: InputMaybe<Documents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Documents_OneArgs = {
  object: Documents_Insert_Input;
  on_conflict?: InputMaybe<Documents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Driver_Duty_LogArgs = {
  objects: Array<Driver_Duty_Log_Insert_Input>;
  on_conflict?: InputMaybe<Driver_Duty_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Driver_Duty_Log_OneArgs = {
  object: Driver_Duty_Log_Insert_Input;
  on_conflict?: InputMaybe<Driver_Duty_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Driver_Duty_PhotosArgs = {
  objects: Array<Driver_Duty_Photos_Insert_Input>;
  on_conflict?: InputMaybe<Driver_Duty_Photos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Driver_Duty_Photos_OneArgs = {
  object: Driver_Duty_Photos_Insert_Input;
  on_conflict?: InputMaybe<Driver_Duty_Photos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Driver_PermitArgs = {
  objects: Array<Driver_Permit_Insert_Input>;
  on_conflict?: InputMaybe<Driver_Permit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Driver_Permit_OneArgs = {
  object: Driver_Permit_Insert_Input;
  on_conflict?: InputMaybe<Driver_Permit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Driver_VehicleArgs = {
  objects: Array<Driver_Vehicle_Insert_Input>;
  on_conflict?: InputMaybe<Driver_Vehicle_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Driver_Vehicle_IssueArgs = {
  objects: Array<Driver_Vehicle_Issue_Insert_Input>;
  on_conflict?: InputMaybe<Driver_Vehicle_Issue_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Driver_Vehicle_Issue_OneArgs = {
  object: Driver_Vehicle_Issue_Insert_Input;
  on_conflict?: InputMaybe<Driver_Vehicle_Issue_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Driver_Vehicle_LocationArgs = {
  objects: Array<Driver_Vehicle_Location_Insert_Input>;
  on_conflict?: InputMaybe<Driver_Vehicle_Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Driver_Vehicle_Location_OneArgs = {
  object: Driver_Vehicle_Location_Insert_Input;
  on_conflict?: InputMaybe<Driver_Vehicle_Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Driver_Vehicle_OneArgs = {
  object: Driver_Vehicle_Insert_Input;
  on_conflict?: InputMaybe<Driver_Vehicle_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Erp_Sync_StatusArgs = {
  objects: Array<Erp_Sync_Status_Insert_Input>;
  on_conflict?: InputMaybe<Erp_Sync_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Erp_Sync_Status_OneArgs = {
  object: Erp_Sync_Status_Insert_Input;
  on_conflict?: InputMaybe<Erp_Sync_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fillup_RequestArgs = {
  objects: Array<Fillup_Request_Insert_Input>;
  on_conflict?: InputMaybe<Fillup_Request_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fillup_Request_OneArgs = {
  object: Fillup_Request_Insert_Input;
  on_conflict?: InputMaybe<Fillup_Request_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fillup_Request_StatusArgs = {
  objects: Array<Fillup_Request_Status_Insert_Input>;
  on_conflict?: InputMaybe<Fillup_Request_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fillup_Request_Status_OneArgs = {
  object: Fillup_Request_Status_Insert_Input;
  on_conflict?: InputMaybe<Fillup_Request_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fuel_Request_TypeArgs = {
  objects: Array<Fuel_Request_Type_Insert_Input>;
  on_conflict?: InputMaybe<Fuel_Request_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fuel_Request_Type_OneArgs = {
  object: Fuel_Request_Type_Insert_Input;
  on_conflict?: InputMaybe<Fuel_Request_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fueltrans_Transaction_LogsArgs = {
  objects: Array<Fueltrans_Transaction_Logs_Insert_Input>;
  on_conflict?: InputMaybe<Fueltrans_Transaction_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fueltrans_Transaction_Logs_OneArgs = {
  object: Fueltrans_Transaction_Logs_Insert_Input;
  on_conflict?: InputMaybe<Fueltrans_Transaction_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Geometry_ColumnsArgs = {
  objects: Array<Geometry_Columns_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Geometry_Columns_OneArgs = {
  object: Geometry_Columns_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_InventoryArgs = {
  objects: Array<Inventory_Insert_Input>;
  on_conflict?: InputMaybe<Inventory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Inventory_OneArgs = {
  object: Inventory_Insert_Input;
  on_conflict?: InputMaybe<Inventory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Inventory_Workflow_LogsArgs = {
  objects: Array<Inventory_Workflow_Logs_Insert_Input>;
  on_conflict?: InputMaybe<Inventory_Workflow_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Inventory_Workflow_Logs_OneArgs = {
  object: Inventory_Workflow_Logs_Insert_Input;
  on_conflict?: InputMaybe<Inventory_Workflow_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_InvitationArgs = {
  objects: Array<Invitation_Insert_Input>;
  on_conflict?: InputMaybe<Invitation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invitation_OneArgs = {
  object: Invitation_Insert_Input;
  on_conflict?: InputMaybe<Invitation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invitation_StatusArgs = {
  objects: Array<Invitation_Status_Insert_Input>;
  on_conflict?: InputMaybe<Invitation_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invitation_Status_OneArgs = {
  object: Invitation_Status_Insert_Input;
  on_conflict?: InputMaybe<Invitation_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_InvoiceArgs = {
  objects: Array<Invoice_Insert_Input>;
  on_conflict?: InputMaybe<Invoice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invoice_OneArgs = {
  object: Invoice_Insert_Input;
  on_conflict?: InputMaybe<Invoice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invoiced_ItemArgs = {
  objects: Array<Invoiced_Item_Insert_Input>;
  on_conflict?: InputMaybe<Invoiced_Item_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invoiced_Item_Cancellation_Ticket_StatesArgs = {
  objects: Array<Invoiced_Item_Cancellation_Ticket_States_Insert_Input>;
  on_conflict?: InputMaybe<Invoiced_Item_Cancellation_Ticket_States_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invoiced_Item_Cancellation_Ticket_States_OneArgs = {
  object: Invoiced_Item_Cancellation_Ticket_States_Insert_Input;
  on_conflict?: InputMaybe<Invoiced_Item_Cancellation_Ticket_States_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invoiced_Item_Cancellation_TicketsArgs = {
  objects: Array<Invoiced_Item_Cancellation_Tickets_Insert_Input>;
  on_conflict?: InputMaybe<Invoiced_Item_Cancellation_Tickets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invoiced_Item_Cancellation_Tickets_OneArgs = {
  object: Invoiced_Item_Cancellation_Tickets_Insert_Input;
  on_conflict?: InputMaybe<Invoiced_Item_Cancellation_Tickets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invoiced_Item_OneArgs = {
  object: Invoiced_Item_Insert_Input;
  on_conflict?: InputMaybe<Invoiced_Item_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_IssueArgs = {
  objects: Array<Issue_Insert_Input>;
  on_conflict?: InputMaybe<Issue_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Issue_OneArgs = {
  object: Issue_Insert_Input;
  on_conflict?: InputMaybe<Issue_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Job_StateArgs = {
  objects: Array<Job_State_Insert_Input>;
  on_conflict?: InputMaybe<Job_State_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Job_State_OneArgs = {
  object: Job_State_Insert_Input;
  on_conflict?: InputMaybe<Job_State_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Job_TypeArgs = {
  objects: Array<Job_Type_Insert_Input>;
  on_conflict?: InputMaybe<Job_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Job_Type_OneArgs = {
  object: Job_Type_Insert_Input;
  on_conflict?: InputMaybe<Job_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Job_Type_TemplateArgs = {
  objects: Array<Job_Type_Template_Insert_Input>;
  on_conflict?: InputMaybe<Job_Type_Template_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Job_Type_Template_OneArgs = {
  object: Job_Type_Template_Insert_Input;
  on_conflict?: InputMaybe<Job_Type_Template_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_JobsArgs = {
  objects: Array<Jobs_Insert_Input>;
  on_conflict?: InputMaybe<Jobs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Jobs_OneArgs = {
  object: Jobs_Insert_Input;
  on_conflict?: InputMaybe<Jobs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Jobs_State_FlowArgs = {
  objects: Array<Jobs_State_Flow_Insert_Input>;
  on_conflict?: InputMaybe<Jobs_State_Flow_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Jobs_State_Flow_OneArgs = {
  object: Jobs_State_Flow_Insert_Input;
  on_conflict?: InputMaybe<Jobs_State_Flow_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Limit_Purchase_OrderArgs = {
  objects: Array<Limit_Purchase_Order_Insert_Input>;
  on_conflict?: InputMaybe<Limit_Purchase_Order_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Limit_Purchase_Order_LogsArgs = {
  objects: Array<Limit_Purchase_Order_Logs_Insert_Input>;
  on_conflict?: InputMaybe<Limit_Purchase_Order_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Limit_Purchase_Order_Logs_OneArgs = {
  object: Limit_Purchase_Order_Logs_Insert_Input;
  on_conflict?: InputMaybe<Limit_Purchase_Order_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Limit_Purchase_Order_OneArgs = {
  object: Limit_Purchase_Order_Insert_Input;
  on_conflict?: InputMaybe<Limit_Purchase_Order_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LocalitiesArgs = {
  objects: Array<Localities_Insert_Input>;
  on_conflict?: InputMaybe<Localities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Localities_OneArgs = {
  object: Localities_Insert_Input;
  on_conflict?: InputMaybe<Localities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Login_TypeArgs = {
  objects: Array<Login_Type_Insert_Input>;
  on_conflict?: InputMaybe<Login_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Login_Type_OneArgs = {
  object: Login_Type_Insert_Input;
  on_conflict?: InputMaybe<Login_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lpo_ExceptionArgs = {
  objects: Array<Lpo_Exception_Insert_Input>;
  on_conflict?: InputMaybe<Lpo_Exception_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lpo_Exception_OneArgs = {
  object: Lpo_Exception_Insert_Input;
  on_conflict?: InputMaybe<Lpo_Exception_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Master_SlotArgs = {
  objects: Array<Master_Slot_Insert_Input>;
  on_conflict?: InputMaybe<Master_Slot_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Master_Slot_OneArgs = {
  object: Master_Slot_Insert_Input;
  on_conflict?: InputMaybe<Master_Slot_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Master_Slot_PauseArgs = {
  objects: Array<Master_Slot_Pause_Insert_Input>;
  on_conflict?: InputMaybe<Master_Slot_Pause_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Master_Slot_Pause_OneArgs = {
  object: Master_Slot_Pause_Insert_Input;
  on_conflict?: InputMaybe<Master_Slot_Pause_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Omc_TypeArgs = {
  objects: Array<Omc_Type_Insert_Input>;
  on_conflict?: InputMaybe<Omc_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Omc_Type_OneArgs = {
  object: Omc_Type_Insert_Input;
  on_conflict?: InputMaybe<Omc_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_PhotosArgs = {
  objects: Array<Order_Photos_Insert_Input>;
  on_conflict?: InputMaybe<Order_Photos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_Photos_OneArgs = {
  object: Order_Photos_Insert_Input;
  on_conflict?: InputMaybe<Order_Photos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_SchedulerArgs = {
  objects: Array<Order_Scheduler_Insert_Input>;
  on_conflict?: InputMaybe<Order_Scheduler_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_Scheduler_Customer_AssetArgs = {
  objects: Array<Order_Scheduler_Customer_Asset_Insert_Input>;
  on_conflict?: InputMaybe<Order_Scheduler_Customer_Asset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_Scheduler_Customer_Asset_OneArgs = {
  object: Order_Scheduler_Customer_Asset_Insert_Input;
  on_conflict?: InputMaybe<Order_Scheduler_Customer_Asset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_Scheduler_Daily_FrequencyArgs = {
  objects: Array<Order_Scheduler_Daily_Frequency_Insert_Input>;
  on_conflict?: InputMaybe<Order_Scheduler_Daily_Frequency_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_Scheduler_Daily_Frequency_OneArgs = {
  object: Order_Scheduler_Daily_Frequency_Insert_Input;
  on_conflict?: InputMaybe<Order_Scheduler_Daily_Frequency_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_Scheduler_OneArgs = {
  object: Order_Scheduler_Insert_Input;
  on_conflict?: InputMaybe<Order_Scheduler_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_TypeArgs = {
  objects: Array<Order_Type_Insert_Input>;
  on_conflict?: InputMaybe<Order_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_Type_OneArgs = {
  object: Order_Type_Insert_Input;
  on_conflict?: InputMaybe<Order_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OrganizationArgs = {
  objects: Array<Organization_Insert_Input>;
  on_conflict?: InputMaybe<Organization_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_AddressArgs = {
  objects: Array<Organization_Address_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Address_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Address_OneArgs = {
  object: Organization_Address_Insert_Input;
  on_conflict?: InputMaybe<Organization_Address_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Audit_LogArgs = {
  objects: Array<Organization_Audit_Log_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Audit_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Audit_Log_OneArgs = {
  object: Organization_Audit_Log_Insert_Input;
  on_conflict?: InputMaybe<Organization_Audit_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Commission_Product_Variation_TypeArgs = {
  objects: Array<Organization_Commission_Product_Variation_Type_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Commission_Product_Variation_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Commission_Product_Variation_Type_OneArgs = {
  object: Organization_Commission_Product_Variation_Type_Insert_Input;
  on_conflict?: InputMaybe<Organization_Commission_Product_Variation_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_ConfigurationArgs = {
  objects: Array<Organization_Configuration_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Configuration_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Configuration_OneArgs = {
  object: Organization_Configuration_Insert_Input;
  on_conflict?: InputMaybe<Organization_Configuration_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_OneArgs = {
  object: Organization_Insert_Input;
  on_conflict?: InputMaybe<Organization_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Product_Variation_DiscountArgs = {
  objects: Array<Organization_Product_Variation_Discount_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Product_Variation_Discount_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Product_Variation_Discount_HistoryArgs = {
  objects: Array<Organization_Product_Variation_Discount_History_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Product_Variation_Discount_History_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Product_Variation_Discount_History_OneArgs = {
  object: Organization_Product_Variation_Discount_History_Insert_Input;
  on_conflict?: InputMaybe<Organization_Product_Variation_Discount_History_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Product_Variation_Discount_OneArgs = {
  object: Organization_Product_Variation_Discount_Insert_Input;
  on_conflict?: InputMaybe<Organization_Product_Variation_Discount_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Sales_ProjectionArgs = {
  objects: Array<Organization_Sales_Projection_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Sales_Projection_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Sales_Projection_OneArgs = {
  object: Organization_Sales_Projection_Insert_Input;
  on_conflict?: InputMaybe<Organization_Sales_Projection_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_TimingArgs = {
  objects: Array<Organization_Timing_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Timing_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Timing_OneArgs = {
  object: Organization_Timing_Insert_Input;
  on_conflict?: InputMaybe<Organization_Timing_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_TypeArgs = {
  objects: Array<Organization_Type_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Type_OneArgs = {
  object: Organization_Type_Insert_Input;
  on_conflict?: InputMaybe<Organization_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_UserArgs = {
  objects: Array<Organization_User_Insert_Input>;
  on_conflict?: InputMaybe<Organization_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_User_CommissionArgs = {
  objects: Array<Organization_User_Commission_Insert_Input>;
  on_conflict?: InputMaybe<Organization_User_Commission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_User_Commission_OneArgs = {
  object: Organization_User_Commission_Insert_Input;
  on_conflict?: InputMaybe<Organization_User_Commission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_User_DocumentArgs = {
  objects: Array<Organization_User_Document_Insert_Input>;
  on_conflict?: InputMaybe<Organization_User_Document_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_User_Document_OneArgs = {
  object: Organization_User_Document_Insert_Input;
  on_conflict?: InputMaybe<Organization_User_Document_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_User_OneArgs = {
  object: Organization_User_Insert_Input;
  on_conflict?: InputMaybe<Organization_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_User_PermissionArgs = {
  objects: Array<Organization_User_Permission_Insert_Input>;
  on_conflict?: InputMaybe<Organization_User_Permission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_User_Permission_OneArgs = {
  object: Organization_User_Permission_Insert_Input;
  on_conflict?: InputMaybe<Organization_User_Permission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_User_SubsidiaryArgs = {
  objects: Array<Organization_User_Subsidiary_Insert_Input>;
  on_conflict?: InputMaybe<Organization_User_Subsidiary_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_User_Subsidiary_OneArgs = {
  object: Organization_User_Subsidiary_Insert_Input;
  on_conflict?: InputMaybe<Organization_User_Subsidiary_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_User_TypeArgs = {
  objects: Array<Organization_User_Type_Insert_Input>;
  on_conflict?: InputMaybe<Organization_User_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_User_Type_OneArgs = {
  object: Organization_User_Type_Insert_Input;
  on_conflict?: InputMaybe<Organization_User_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ownership_TypeArgs = {
  objects: Array<Ownership_Type_Insert_Input>;
  on_conflict?: InputMaybe<Ownership_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ownership_Type_OneArgs = {
  object: Ownership_Type_Insert_Input;
  on_conflict?: InputMaybe<Ownership_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PartnerArgs = {
  objects: Array<Partner_Insert_Input>;
  on_conflict?: InputMaybe<Partner_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_AddressArgs = {
  objects: Array<Partner_Address_Insert_Input>;
  on_conflict?: InputMaybe<Partner_Address_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Address_OneArgs = {
  object: Partner_Address_Insert_Input;
  on_conflict?: InputMaybe<Partner_Address_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Bank_DetailsArgs = {
  objects: Array<Partner_Bank_Details_Insert_Input>;
  on_conflict?: InputMaybe<Partner_Bank_Details_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Bank_Details_OneArgs = {
  object: Partner_Bank_Details_Insert_Input;
  on_conflict?: InputMaybe<Partner_Bank_Details_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_CommissionArgs = {
  objects: Array<Partner_Commission_Insert_Input>;
  on_conflict?: InputMaybe<Partner_Commission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Commission_OneArgs = {
  object: Partner_Commission_Insert_Input;
  on_conflict?: InputMaybe<Partner_Commission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Commission_Product_Variation_TypeArgs = {
  objects: Array<Partner_Commission_Product_Variation_Type_Insert_Input>;
  on_conflict?: InputMaybe<Partner_Commission_Product_Variation_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Commission_Product_Variation_Type_OneArgs = {
  object: Partner_Commission_Product_Variation_Type_Insert_Input;
  on_conflict?: InputMaybe<Partner_Commission_Product_Variation_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Contact_TypeArgs = {
  objects: Array<Partner_Contact_Type_Insert_Input>;
  on_conflict?: InputMaybe<Partner_Contact_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Contact_Type_OneArgs = {
  object: Partner_Contact_Type_Insert_Input;
  on_conflict?: InputMaybe<Partner_Contact_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_LocalitiesArgs = {
  objects: Array<Partner_Localities_Insert_Input>;
  on_conflict?: InputMaybe<Partner_Localities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Localities_OneArgs = {
  object: Partner_Localities_Insert_Input;
  on_conflict?: InputMaybe<Partner_Localities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Localities_SlotsArgs = {
  objects: Array<Partner_Localities_Slots_Insert_Input>;
  on_conflict?: InputMaybe<Partner_Localities_Slots_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Localities_Slots_OneArgs = {
  object: Partner_Localities_Slots_Insert_Input;
  on_conflict?: InputMaybe<Partner_Localities_Slots_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_OneArgs = {
  object: Partner_Insert_Input;
  on_conflict?: InputMaybe<Partner_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_OrderArgs = {
  objects: Array<Partner_Order_Insert_Input>;
  on_conflict?: InputMaybe<Partner_Order_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Order_Customer_AssetArgs = {
  objects: Array<Partner_Order_Customer_Asset_Insert_Input>;
  on_conflict?: InputMaybe<Partner_Order_Customer_Asset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Order_Customer_Asset_OneArgs = {
  object: Partner_Order_Customer_Asset_Insert_Input;
  on_conflict?: InputMaybe<Partner_Order_Customer_Asset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Order_ItemArgs = {
  objects: Array<Partner_Order_Item_Insert_Input>;
  on_conflict?: InputMaybe<Partner_Order_Item_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Order_Item_CommissionArgs = {
  objects: Array<Partner_Order_Item_Commission_Insert_Input>;
  on_conflict?: InputMaybe<Partner_Order_Item_Commission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Order_Item_Commission_OneArgs = {
  object: Partner_Order_Item_Commission_Insert_Input;
  on_conflict?: InputMaybe<Partner_Order_Item_Commission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Order_Item_OneArgs = {
  object: Partner_Order_Item_Insert_Input;
  on_conflict?: InputMaybe<Partner_Order_Item_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Order_Item_StateArgs = {
  objects: Array<Partner_Order_Item_State_Insert_Input>;
  on_conflict?: InputMaybe<Partner_Order_Item_State_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Order_Item_State_OneArgs = {
  object: Partner_Order_Item_State_Insert_Input;
  on_conflict?: InputMaybe<Partner_Order_Item_State_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Order_Item_StateflowArgs = {
  objects: Array<Partner_Order_Item_Stateflow_Insert_Input>;
  on_conflict?: InputMaybe<Partner_Order_Item_Stateflow_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Order_Item_Stateflow_OneArgs = {
  object: Partner_Order_Item_Stateflow_Insert_Input;
  on_conflict?: InputMaybe<Partner_Order_Item_Stateflow_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Order_Item_Test_CategoryArgs = {
  objects: Array<Partner_Order_Item_Test_Category_Insert_Input>;
  on_conflict?: InputMaybe<Partner_Order_Item_Test_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Order_Item_Test_Category_OneArgs = {
  object: Partner_Order_Item_Test_Category_Insert_Input;
  on_conflict?: InputMaybe<Partner_Order_Item_Test_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Order_Item_Test_ResultsArgs = {
  objects: Array<Partner_Order_Item_Test_Results_Insert_Input>;
  on_conflict?: InputMaybe<Partner_Order_Item_Test_Results_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Order_Item_Test_Results_OneArgs = {
  object: Partner_Order_Item_Test_Results_Insert_Input;
  on_conflict?: InputMaybe<Partner_Order_Item_Test_Results_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Order_Item_Test_Results_PhotosArgs = {
  objects: Array<Partner_Order_Item_Test_Results_Photos_Insert_Input>;
  on_conflict?: InputMaybe<Partner_Order_Item_Test_Results_Photos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Order_Item_Test_Results_Photos_OneArgs = {
  object: Partner_Order_Item_Test_Results_Photos_Insert_Input;
  on_conflict?: InputMaybe<Partner_Order_Item_Test_Results_Photos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Order_Item_ValueArgs = {
  objects: Array<Partner_Order_Item_Value_Insert_Input>;
  on_conflict?: InputMaybe<Partner_Order_Item_Value_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Order_Item_Value_OneArgs = {
  object: Partner_Order_Item_Value_Insert_Input;
  on_conflict?: InputMaybe<Partner_Order_Item_Value_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Order_OneArgs = {
  object: Partner_Order_Insert_Input;
  on_conflict?: InputMaybe<Partner_Order_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Order_Partner_User_DocumentArgs = {
  objects: Array<Partner_Order_Partner_User_Document_Insert_Input>;
  on_conflict?: InputMaybe<Partner_Order_Partner_User_Document_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Order_Partner_User_Document_OneArgs = {
  object: Partner_Order_Partner_User_Document_Insert_Input;
  on_conflict?: InputMaybe<Partner_Order_Partner_User_Document_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Order_StateArgs = {
  objects: Array<Partner_Order_State_Insert_Input>;
  on_conflict?: InputMaybe<Partner_Order_State_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Order_State_OneArgs = {
  object: Partner_Order_State_Insert_Input;
  on_conflict?: InputMaybe<Partner_Order_State_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Order_StateflowArgs = {
  objects: Array<Partner_Order_Stateflow_Insert_Input>;
  on_conflict?: InputMaybe<Partner_Order_Stateflow_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Order_Stateflow_OneArgs = {
  object: Partner_Order_Stateflow_Insert_Input;
  on_conflict?: InputMaybe<Partner_Order_Stateflow_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_PaymentArgs = {
  objects: Array<Partner_Payment_Insert_Input>;
  on_conflict?: InputMaybe<Partner_Payment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Payment_OneArgs = {
  object: Partner_Payment_Insert_Input;
  on_conflict?: InputMaybe<Partner_Payment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_ProductArgs = {
  objects: Array<Partner_Product_Insert_Input>;
  on_conflict?: InputMaybe<Partner_Product_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Product_OneArgs = {
  object: Partner_Product_Insert_Input;
  on_conflict?: InputMaybe<Partner_Product_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_RelationshipArgs = {
  objects: Array<Partner_Relationship_Insert_Input>;
  on_conflict?: InputMaybe<Partner_Relationship_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Relationship_OneArgs = {
  object: Partner_Relationship_Insert_Input;
  on_conflict?: InputMaybe<Partner_Relationship_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_SellerArgs = {
  objects: Array<Partner_Seller_Insert_Input>;
  on_conflict?: InputMaybe<Partner_Seller_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Seller_OneArgs = {
  object: Partner_Seller_Insert_Input;
  on_conflict?: InputMaybe<Partner_Seller_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Seller_TypeArgs = {
  objects: Array<Partner_Seller_Type_Insert_Input>;
  on_conflict?: InputMaybe<Partner_Seller_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Seller_Type_OneArgs = {
  object: Partner_Seller_Type_Insert_Input;
  on_conflict?: InputMaybe<Partner_Seller_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Signing_AuthorityArgs = {
  objects: Array<Partner_Signing_Authority_Insert_Input>;
  on_conflict?: InputMaybe<Partner_Signing_Authority_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Signing_Authority_OneArgs = {
  object: Partner_Signing_Authority_Insert_Input;
  on_conflict?: InputMaybe<Partner_Signing_Authority_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_TimingArgs = {
  objects: Array<Partner_Timing_Insert_Input>;
  on_conflict?: InputMaybe<Partner_Timing_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Timing_OneArgs = {
  object: Partner_Timing_Insert_Input;
  on_conflict?: InputMaybe<Partner_Timing_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_TypeArgs = {
  objects: Array<Partner_Type_Insert_Input>;
  on_conflict?: InputMaybe<Partner_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Type_OneArgs = {
  object: Partner_Type_Insert_Input;
  on_conflict?: InputMaybe<Partner_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_UserArgs = {
  objects: Array<Partner_User_Insert_Input>;
  on_conflict?: InputMaybe<Partner_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_User_DocumentArgs = {
  objects: Array<Partner_User_Document_Insert_Input>;
  on_conflict?: InputMaybe<Partner_User_Document_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_User_Document_OneArgs = {
  object: Partner_User_Document_Insert_Input;
  on_conflict?: InputMaybe<Partner_User_Document_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_User_OneArgs = {
  object: Partner_User_Insert_Input;
  on_conflict?: InputMaybe<Partner_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_User_PermissionArgs = {
  objects: Array<Partner_User_Permission_Insert_Input>;
  on_conflict?: InputMaybe<Partner_User_Permission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_User_Permission_OneArgs = {
  object: Partner_User_Permission_Insert_Input;
  on_conflict?: InputMaybe<Partner_User_Permission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_VehicleArgs = {
  objects: Array<Partner_Vehicle_Insert_Input>;
  on_conflict?: InputMaybe<Partner_Vehicle_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Vehicle_OneArgs = {
  object: Partner_Vehicle_Insert_Input;
  on_conflict?: InputMaybe<Partner_Vehicle_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Vehicle_StateArgs = {
  objects: Array<Partner_Vehicle_State_Insert_Input>;
  on_conflict?: InputMaybe<Partner_Vehicle_State_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Vehicle_State_OneArgs = {
  object: Partner_Vehicle_State_Insert_Input;
  on_conflict?: InputMaybe<Partner_Vehicle_State_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_TypeArgs = {
  objects: Array<Payment_Type_Insert_Input>;
  on_conflict?: InputMaybe<Payment_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_Type_OneArgs = {
  object: Payment_Type_Insert_Input;
  on_conflict?: InputMaybe<Payment_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Period_FrequencyArgs = {
  objects: Array<Period_Frequency_Insert_Input>;
  on_conflict?: InputMaybe<Period_Frequency_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Period_Frequency_OneArgs = {
  object: Period_Frequency_Insert_Input;
  on_conflict?: InputMaybe<Period_Frequency_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PermissionArgs = {
  objects: Array<Permission_Insert_Input>;
  on_conflict?: InputMaybe<Permission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Permission_OneArgs = {
  object: Permission_Insert_Input;
  on_conflict?: InputMaybe<Permission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PermitArgs = {
  objects: Array<Permit_Insert_Input>;
  on_conflict?: InputMaybe<Permit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Permit_OneArgs = {
  object: Permit_Insert_Input;
  on_conflict?: InputMaybe<Permit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Photo_TypeArgs = {
  objects: Array<Photo_Type_Insert_Input>;
  on_conflict?: InputMaybe<Photo_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Photo_Type_OneArgs = {
  object: Photo_Type_Insert_Input;
  on_conflict?: InputMaybe<Photo_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Planning_Audit_LogArgs = {
  objects: Array<Planning_Audit_Log_Insert_Input>;
  on_conflict?: InputMaybe<Planning_Audit_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Planning_Audit_Log_OneArgs = {
  object: Planning_Audit_Log_Insert_Input;
  on_conflict?: InputMaybe<Planning_Audit_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Planning_PeriodArgs = {
  objects: Array<Planning_Period_Insert_Input>;
  on_conflict?: InputMaybe<Planning_Period_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Planning_Period_OneArgs = {
  object: Planning_Period_Insert_Input;
  on_conflict?: InputMaybe<Planning_Period_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProductArgs = {
  objects: Array<Product_Insert_Input>;
  on_conflict?: InputMaybe<Product_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_CommissionArgs = {
  objects: Array<Product_Commission_Insert_Input>;
  on_conflict?: InputMaybe<Product_Commission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Commission_OneArgs = {
  object: Product_Commission_Insert_Input;
  on_conflict?: InputMaybe<Product_Commission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_DocumentArgs = {
  objects: Array<Product_Document_Insert_Input>;
  on_conflict?: InputMaybe<Product_Document_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Document_OneArgs = {
  object: Product_Document_Insert_Input;
  on_conflict?: InputMaybe<Product_Document_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_OneArgs = {
  object: Product_Insert_Input;
  on_conflict?: InputMaybe<Product_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Partner_Localities_PriceArgs = {
  objects: Array<Product_Partner_Localities_Price_Insert_Input>;
  on_conflict?: InputMaybe<Product_Partner_Localities_Price_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Partner_Localities_Price_HistoryArgs = {
  objects: Array<Product_Partner_Localities_Price_History_Insert_Input>;
  on_conflict?: InputMaybe<Product_Partner_Localities_Price_History_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Partner_Localities_Price_History_OneArgs = {
  object: Product_Partner_Localities_Price_History_Insert_Input;
  on_conflict?: InputMaybe<Product_Partner_Localities_Price_History_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Partner_Localities_Price_OneArgs = {
  object: Product_Partner_Localities_Price_Insert_Input;
  on_conflict?: InputMaybe<Product_Partner_Localities_Price_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_PhotosArgs = {
  objects: Array<Product_Photos_Insert_Input>;
  on_conflict?: InputMaybe<Product_Photos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Photos_OneArgs = {
  object: Product_Photos_Insert_Input;
  on_conflict?: InputMaybe<Product_Photos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_TypeArgs = {
  objects: Array<Product_Type_Insert_Input>;
  on_conflict?: InputMaybe<Product_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Type_OneArgs = {
  object: Product_Type_Insert_Input;
  on_conflict?: InputMaybe<Product_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_VariationArgs = {
  objects: Array<Product_Variation_Insert_Input>;
  on_conflict?: InputMaybe<Product_Variation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Variation_OneArgs = {
  object: Product_Variation_Insert_Input;
  on_conflict?: InputMaybe<Product_Variation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Variation_Partner_Localities_SlotsArgs = {
  objects: Array<Product_Variation_Partner_Localities_Slots_Insert_Input>;
  on_conflict?: InputMaybe<Product_Variation_Partner_Localities_Slots_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Variation_Partner_Localities_Slots_OneArgs = {
  object: Product_Variation_Partner_Localities_Slots_Insert_Input;
  on_conflict?: InputMaybe<Product_Variation_Partner_Localities_Slots_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Variation_PhotosArgs = {
  objects: Array<Product_Variation_Photos_Insert_Input>;
  on_conflict?: InputMaybe<Product_Variation_Photos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Variation_Photos_OneArgs = {
  object: Product_Variation_Photos_Insert_Input;
  on_conflict?: InputMaybe<Product_Variation_Photos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Variation_Safety_Checklist_CategoryArgs = {
  objects: Array<Product_Variation_Safety_Checklist_Category_Insert_Input>;
  on_conflict?: InputMaybe<Product_Variation_Safety_Checklist_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Variation_Safety_Checklist_Category_OneArgs = {
  object: Product_Variation_Safety_Checklist_Category_Insert_Input;
  on_conflict?: InputMaybe<Product_Variation_Safety_Checklist_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Variation_Test_CategoryArgs = {
  objects: Array<Product_Variation_Test_Category_Insert_Input>;
  on_conflict?: InputMaybe<Product_Variation_Test_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Variation_Test_Category_OneArgs = {
  object: Product_Variation_Test_Category_Insert_Input;
  on_conflict?: InputMaybe<Product_Variation_Test_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Purchase_OrderArgs = {
  objects: Array<Purchase_Order_Insert_Input>;
  on_conflict?: InputMaybe<Purchase_Order_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Purchase_Order_ItemsArgs = {
  objects: Array<Purchase_Order_Items_Insert_Input>;
  on_conflict?: InputMaybe<Purchase_Order_Items_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Purchase_Order_Items_OneArgs = {
  object: Purchase_Order_Items_Insert_Input;
  on_conflict?: InputMaybe<Purchase_Order_Items_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Purchase_Order_OneArgs = {
  object: Purchase_Order_Insert_Input;
  on_conflict?: InputMaybe<Purchase_Order_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quantity_Correction_Ticket_StatesArgs = {
  objects: Array<Quantity_Correction_Ticket_States_Insert_Input>;
  on_conflict?: InputMaybe<Quantity_Correction_Ticket_States_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quantity_Correction_Ticket_States_OneArgs = {
  object: Quantity_Correction_Ticket_States_Insert_Input;
  on_conflict?: InputMaybe<Quantity_Correction_Ticket_States_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quantity_Correction_TicketsArgs = {
  objects: Array<Quantity_Correction_Tickets_Insert_Input>;
  on_conflict?: InputMaybe<Quantity_Correction_Tickets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quantity_Correction_Tickets_OneArgs = {
  object: Quantity_Correction_Tickets_Insert_Input;
  on_conflict?: InputMaybe<Quantity_Correction_Tickets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Reason_TypeArgs = {
  objects: Array<Reason_Type_Insert_Input>;
  on_conflict?: InputMaybe<Reason_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Reason_Type_OneArgs = {
  object: Reason_Type_Insert_Input;
  on_conflict?: InputMaybe<Reason_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ReasonsArgs = {
  objects: Array<Reasons_Insert_Input>;
  on_conflict?: InputMaybe<Reasons_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Reasons_OneArgs = {
  object: Reasons_Insert_Input;
  on_conflict?: InputMaybe<Reasons_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RoleArgs = {
  objects: Array<Role_Insert_Input>;
  on_conflict?: InputMaybe<Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Role_DocumentArgs = {
  objects: Array<Role_Document_Insert_Input>;
  on_conflict?: InputMaybe<Role_Document_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Role_Document_OneArgs = {
  object: Role_Document_Insert_Input;
  on_conflict?: InputMaybe<Role_Document_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Role_OneArgs = {
  object: Role_Insert_Input;
  on_conflict?: InputMaybe<Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Safety_ChecklistArgs = {
  objects: Array<Safety_Checklist_Insert_Input>;
  on_conflict?: InputMaybe<Safety_Checklist_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Safety_Checklist_CategoryArgs = {
  objects: Array<Safety_Checklist_Category_Insert_Input>;
  on_conflict?: InputMaybe<Safety_Checklist_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Safety_Checklist_Category_OneArgs = {
  object: Safety_Checklist_Category_Insert_Input;
  on_conflict?: InputMaybe<Safety_Checklist_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Safety_Checklist_OneArgs = {
  object: Safety_Checklist_Insert_Input;
  on_conflict?: InputMaybe<Safety_Checklist_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Script_TypeArgs = {
  objects: Array<Script_Type_Insert_Input>;
  on_conflict?: InputMaybe<Script_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Script_Type_OneArgs = {
  object: Script_Type_Insert_Input;
  on_conflict?: InputMaybe<Script_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ScriptsArgs = {
  objects: Array<Scripts_Insert_Input>;
  on_conflict?: InputMaybe<Scripts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Scripts_OneArgs = {
  object: Scripts_Insert_Input;
  on_conflict?: InputMaybe<Scripts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServicesArgs = {
  objects: Array<Services_Insert_Input>;
  on_conflict?: InputMaybe<Services_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Services_CategoryArgs = {
  objects: Array<Services_Category_Insert_Input>;
  on_conflict?: InputMaybe<Services_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Services_Category_OneArgs = {
  object: Services_Category_Insert_Input;
  on_conflict?: InputMaybe<Services_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Services_OneArgs = {
  object: Services_Insert_Input;
  on_conflict?: InputMaybe<Services_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shift_ScheduleArgs = {
  objects: Array<Shift_Schedule_Insert_Input>;
  on_conflict?: InputMaybe<Shift_Schedule_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shift_Schedule_DispenserArgs = {
  objects: Array<Shift_Schedule_Dispenser_Insert_Input>;
  on_conflict?: InputMaybe<Shift_Schedule_Dispenser_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shift_Schedule_Dispenser_OneArgs = {
  object: Shift_Schedule_Dispenser_Insert_Input;
  on_conflict?: InputMaybe<Shift_Schedule_Dispenser_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shift_Schedule_OneArgs = {
  object: Shift_Schedule_Insert_Input;
  on_conflict?: InputMaybe<Shift_Schedule_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shift_TemplateArgs = {
  objects: Array<Shift_Template_Insert_Input>;
  on_conflict?: InputMaybe<Shift_Template_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shift_Template_OneArgs = {
  object: Shift_Template_Insert_Input;
  on_conflict?: InputMaybe<Shift_Template_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Slab_TypeArgs = {
  objects: Array<Slab_Type_Insert_Input>;
  on_conflict?: InputMaybe<Slab_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Slab_Type_OneArgs = {
  object: Slab_Type_Insert_Input;
  on_conflict?: InputMaybe<Slab_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Source_TypeArgs = {
  objects: Array<Source_Type_Insert_Input>;
  on_conflict?: InputMaybe<Source_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Source_Type_OneArgs = {
  object: Source_Type_Insert_Input;
  on_conflict?: InputMaybe<Source_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Spatial_Ref_SysArgs = {
  objects: Array<Spatial_Ref_Sys_Insert_Input>;
  on_conflict?: InputMaybe<Spatial_Ref_Sys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Spatial_Ref_Sys_OneArgs = {
  object: Spatial_Ref_Sys_Insert_Input;
  on_conflict?: InputMaybe<Spatial_Ref_Sys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StateArgs = {
  objects: Array<State_Insert_Input>;
  on_conflict?: InputMaybe<State_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_State_OneArgs = {
  object: State_Insert_Input;
  on_conflict?: InputMaybe<State_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SubsidiaryArgs = {
  objects: Array<Subsidiary_Insert_Input>;
  on_conflict?: InputMaybe<Subsidiary_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subsidiary_OneArgs = {
  object: Subsidiary_Insert_Input;
  on_conflict?: InputMaybe<Subsidiary_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Support_TicketsArgs = {
  objects: Array<Support_Tickets_Insert_Input>;
  on_conflict?: InputMaybe<Support_Tickets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Support_Tickets_CategoryArgs = {
  objects: Array<Support_Tickets_Category_Insert_Input>;
  on_conflict?: InputMaybe<Support_Tickets_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Support_Tickets_Category_OneArgs = {
  object: Support_Tickets_Category_Insert_Input;
  on_conflict?: InputMaybe<Support_Tickets_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Support_Tickets_OneArgs = {
  object: Support_Tickets_Insert_Input;
  on_conflict?: InputMaybe<Support_Tickets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Support_Tickets_PhotosArgs = {
  objects: Array<Support_Tickets_Photos_Insert_Input>;
  on_conflict?: InputMaybe<Support_Tickets_Photos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Support_Tickets_Photos_OneArgs = {
  object: Support_Tickets_Photos_Insert_Input;
  on_conflict?: InputMaybe<Support_Tickets_Photos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TagArgs = {
  objects: Array<Tag_Insert_Input>;
  on_conflict?: InputMaybe<Tag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tag_OneArgs = {
  object: Tag_Insert_Input;
  on_conflict?: InputMaybe<Tag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tank_TypeArgs = {
  objects: Array<Tank_Type_Insert_Input>;
  on_conflict?: InputMaybe<Tank_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tank_Type_OneArgs = {
  object: Tank_Type_Insert_Input;
  on_conflict?: InputMaybe<Tank_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TaskArgs = {
  objects: Array<Task_Insert_Input>;
  on_conflict?: InputMaybe<Task_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Task_Action_InstructionArgs = {
  objects: Array<Task_Action_Instruction_Insert_Input>;
  on_conflict?: InputMaybe<Task_Action_Instruction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Task_Action_Instruction_OneArgs = {
  object: Task_Action_Instruction_Insert_Input;
  on_conflict?: InputMaybe<Task_Action_Instruction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Task_Action_TypeArgs = {
  objects: Array<Task_Action_Type_Insert_Input>;
  on_conflict?: InputMaybe<Task_Action_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Task_Action_Type_OneArgs = {
  object: Task_Action_Type_Insert_Input;
  on_conflict?: InputMaybe<Task_Action_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Task_Cancellation_ReasonsArgs = {
  objects: Array<Task_Cancellation_Reasons_Insert_Input>;
  on_conflict?: InputMaybe<Task_Cancellation_Reasons_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Task_Cancellation_Reasons_OneArgs = {
  object: Task_Cancellation_Reasons_Insert_Input;
  on_conflict?: InputMaybe<Task_Cancellation_Reasons_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Task_OneArgs = {
  object: Task_Insert_Input;
  on_conflict?: InputMaybe<Task_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Task_StateArgs = {
  objects: Array<Task_State_Insert_Input>;
  on_conflict?: InputMaybe<Task_State_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Task_State_OneArgs = {
  object: Task_State_Insert_Input;
  on_conflict?: InputMaybe<Task_State_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Task_States_FlowArgs = {
  objects: Array<Task_States_Flow_Insert_Input>;
  on_conflict?: InputMaybe<Task_States_Flow_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Task_States_Flow_OneArgs = {
  object: Task_States_Flow_Insert_Input;
  on_conflict?: InputMaybe<Task_States_Flow_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Task_TypeArgs = {
  objects: Array<Task_Type_Insert_Input>;
  on_conflict?: InputMaybe<Task_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Task_Type_OneArgs = {
  object: Task_Type_Insert_Input;
  on_conflict?: InputMaybe<Task_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Task_ValueArgs = {
  objects: Array<Task_Value_Insert_Input>;
  on_conflict?: InputMaybe<Task_Value_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Task_Value_OneArgs = {
  object: Task_Value_Insert_Input;
  on_conflict?: InputMaybe<Task_Value_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TestArgs = {
  objects: Array<Test_Insert_Input>;
  on_conflict?: InputMaybe<Test_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Test_CategoryArgs = {
  objects: Array<Test_Category_Insert_Input>;
  on_conflict?: InputMaybe<Test_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Test_Category_OneArgs = {
  object: Test_Category_Insert_Input;
  on_conflict?: InputMaybe<Test_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Test_OneArgs = {
  object: Test_Insert_Input;
  on_conflict?: InputMaybe<Test_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ticket_StateArgs = {
  objects: Array<Ticket_State_Insert_Input>;
  on_conflict?: InputMaybe<Ticket_State_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ticket_State_OneArgs = {
  object: Ticket_State_Insert_Input;
  on_conflict?: InputMaybe<Ticket_State_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ticket_TypeArgs = {
  objects: Array<Ticket_Type_Insert_Input>;
  on_conflict?: InputMaybe<Ticket_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ticket_Type_OneArgs = {
  object: Ticket_Type_Insert_Input;
  on_conflict?: InputMaybe<Ticket_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TicketsArgs = {
  objects: Array<Tickets_Insert_Input>;
  on_conflict?: InputMaybe<Tickets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tickets_OneArgs = {
  object: Tickets_Insert_Input;
  on_conflict?: InputMaybe<Tickets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Totalizer_Correction_Ticket_StatesArgs = {
  objects: Array<Totalizer_Correction_Ticket_States_Insert_Input>;
  on_conflict?: InputMaybe<Totalizer_Correction_Ticket_States_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Totalizer_Correction_Ticket_States_OneArgs = {
  object: Totalizer_Correction_Ticket_States_Insert_Input;
  on_conflict?: InputMaybe<Totalizer_Correction_Ticket_States_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Totalizer_Correction_TicketsArgs = {
  objects: Array<Totalizer_Correction_Tickets_Insert_Input>;
  on_conflict?: InputMaybe<Totalizer_Correction_Tickets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Totalizer_Correction_Tickets_OneArgs = {
  object: Totalizer_Correction_Tickets_Insert_Input;
  on_conflict?: InputMaybe<Totalizer_Correction_Tickets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Transaction_TypeArgs = {
  objects: Array<Transaction_Type_Insert_Input>;
  on_conflict?: InputMaybe<Transaction_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Transaction_Type_OneArgs = {
  object: Transaction_Type_Insert_Input;
  on_conflict?: InputMaybe<Transaction_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TripArgs = {
  objects: Array<Trip_Insert_Input>;
  on_conflict?: InputMaybe<Trip_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trip_LocationArgs = {
  objects: Array<Trip_Location_Insert_Input>;
  on_conflict?: InputMaybe<Trip_Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trip_Location_OneArgs = {
  object: Trip_Location_Insert_Input;
  on_conflict?: InputMaybe<Trip_Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trip_OneArgs = {
  object: Trip_Insert_Input;
  on_conflict?: InputMaybe<Trip_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trip_PlanArgs = {
  objects: Array<Trip_Plan_Insert_Input>;
  on_conflict?: InputMaybe<Trip_Plan_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trip_Plan_OneArgs = {
  object: Trip_Plan_Insert_Input;
  on_conflict?: InputMaybe<Trip_Plan_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Unit_Of_MeasureArgs = {
  objects: Array<Unit_Of_Measure_Insert_Input>;
  on_conflict?: InputMaybe<Unit_Of_Measure_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Unit_Of_Measure_MetaArgs = {
  objects: Array<Unit_Of_Measure_Meta_Insert_Input>;
  on_conflict?: InputMaybe<Unit_Of_Measure_Meta_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Unit_Of_Measure_Meta_OneArgs = {
  object: Unit_Of_Measure_Meta_Insert_Input;
  on_conflict?: InputMaybe<Unit_Of_Measure_Meta_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Unit_Of_Measure_OneArgs = {
  object: Unit_Of_Measure_Insert_Input;
  on_conflict?: InputMaybe<Unit_Of_Measure_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uom_ConversionArgs = {
  objects: Array<Uom_Conversion_Insert_Input>;
  on_conflict?: InputMaybe<Uom_Conversion_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uom_Conversion_OneArgs = {
  object: Uom_Conversion_Insert_Input;
  on_conflict?: InputMaybe<Uom_Conversion_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserArgs = {
  objects: Array<User_Insert_Input>;
  on_conflict?: InputMaybe<User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Access_Audit_LogArgs = {
  objects: Array<User_Access_Audit_Log_Insert_Input>;
  on_conflict?: InputMaybe<User_Access_Audit_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Access_Audit_Log_OneArgs = {
  object: User_Access_Audit_Log_Insert_Input;
  on_conflict?: InputMaybe<User_Access_Audit_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_LedgerArgs = {
  objects: Array<User_Ledger_Insert_Input>;
  on_conflict?: InputMaybe<User_Ledger_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Ledger_OneArgs = {
  object: User_Ledger_Insert_Input;
  on_conflict?: InputMaybe<User_Ledger_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_OneArgs = {
  object: User_Insert_Input;
  on_conflict?: InputMaybe<User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Partner_TypeArgs = {
  objects: Array<User_Partner_Type_Insert_Input>;
  on_conflict?: InputMaybe<User_Partner_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Partner_Type_OneArgs = {
  object: User_Partner_Type_Insert_Input;
  on_conflict?: InputMaybe<User_Partner_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_ReferralArgs = {
  objects: Array<User_Referral_Insert_Input>;
  on_conflict?: InputMaybe<User_Referral_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Referral_OneArgs = {
  object: User_Referral_Insert_Input;
  on_conflict?: InputMaybe<User_Referral_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_RoleArgs = {
  objects: Array<User_Role_Insert_Input>;
  on_conflict?: InputMaybe<User_Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Role_OneArgs = {
  object: User_Role_Insert_Input;
  on_conflict?: InputMaybe<User_Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Validation_WorkflowsArgs = {
  objects: Array<Validation_Workflows_Insert_Input>;
  on_conflict?: InputMaybe<Validation_Workflows_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Validation_Workflows_OneArgs = {
  object: Validation_Workflows_Insert_Input;
  on_conflict?: InputMaybe<Validation_Workflows_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_VariationArgs = {
  objects: Array<Variation_Insert_Input>;
  on_conflict?: InputMaybe<Variation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variation_OneArgs = {
  object: Variation_Insert_Input;
  on_conflict?: InputMaybe<Variation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variation_TypeArgs = {
  objects: Array<Variation_Type_Insert_Input>;
  on_conflict?: InputMaybe<Variation_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variation_Type_OneArgs = {
  object: Variation_Type_Insert_Input;
  on_conflict?: InputMaybe<Variation_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_VehicleArgs = {
  objects: Array<Vehicle_Insert_Input>;
  on_conflict?: InputMaybe<Vehicle_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_ConfigurationArgs = {
  objects: Array<Vehicle_Configuration_Insert_Input>;
  on_conflict?: InputMaybe<Vehicle_Configuration_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_Configuration_OneArgs = {
  object: Vehicle_Configuration_Insert_Input;
  on_conflict?: InputMaybe<Vehicle_Configuration_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_DeviceArgs = {
  objects: Array<Vehicle_Device_Insert_Input>;
  on_conflict?: InputMaybe<Vehicle_Device_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_Device_CalibrationArgs = {
  objects: Array<Vehicle_Device_Calibration_Insert_Input>;
  on_conflict?: InputMaybe<Vehicle_Device_Calibration_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_Device_Calibration_OneArgs = {
  object: Vehicle_Device_Calibration_Insert_Input;
  on_conflict?: InputMaybe<Vehicle_Device_Calibration_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_Device_OneArgs = {
  object: Vehicle_Device_Insert_Input;
  on_conflict?: InputMaybe<Vehicle_Device_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_Inventory_Transaction_LogsArgs = {
  objects: Array<Vehicle_Inventory_Transaction_Logs_Insert_Input>;
  on_conflict?: InputMaybe<Vehicle_Inventory_Transaction_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_Inventory_Transaction_Logs_OneArgs = {
  object: Vehicle_Inventory_Transaction_Logs_Insert_Input;
  on_conflict?: InputMaybe<Vehicle_Inventory_Transaction_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_LocalitiesArgs = {
  objects: Array<Vehicle_Localities_Insert_Input>;
  on_conflict?: InputMaybe<Vehicle_Localities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_Localities_OneArgs = {
  object: Vehicle_Localities_Insert_Input;
  on_conflict?: InputMaybe<Vehicle_Localities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_OneArgs = {
  object: Vehicle_Insert_Input;
  on_conflict?: InputMaybe<Vehicle_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_PermitArgs = {
  objects: Array<Vehicle_Permit_Insert_Input>;
  on_conflict?: InputMaybe<Vehicle_Permit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_Permit_OneArgs = {
  object: Vehicle_Permit_Insert_Input;
  on_conflict?: InputMaybe<Vehicle_Permit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_Shift_TemplateArgs = {
  objects: Array<Vehicle_Shift_Template_Insert_Input>;
  on_conflict?: InputMaybe<Vehicle_Shift_Template_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_Shift_Template_OneArgs = {
  object: Vehicle_Shift_Template_Insert_Input;
  on_conflict?: InputMaybe<Vehicle_Shift_Template_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_StatusArgs = {
  objects: Array<Vehicle_Status_Insert_Input>;
  on_conflict?: InputMaybe<Vehicle_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_Status_LogsArgs = {
  objects: Array<Vehicle_Status_Logs_Insert_Input>;
  on_conflict?: InputMaybe<Vehicle_Status_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_Status_Logs_OneArgs = {
  object: Vehicle_Status_Logs_Insert_Input;
  on_conflict?: InputMaybe<Vehicle_Status_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_Status_OneArgs = {
  object: Vehicle_Status_Insert_Input;
  on_conflict?: InputMaybe<Vehicle_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_Tank_TypeArgs = {
  objects: Array<Vehicle_Tank_Type_Insert_Input>;
  on_conflict?: InputMaybe<Vehicle_Tank_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_Tank_Type_OneArgs = {
  object: Vehicle_Tank_Type_Insert_Input;
  on_conflict?: InputMaybe<Vehicle_Tank_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_Tank_Type_Product_VariationArgs = {
  objects: Array<Vehicle_Tank_Type_Product_Variation_Insert_Input>;
  on_conflict?: InputMaybe<Vehicle_Tank_Type_Product_Variation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_Tank_Type_Product_Variation_OneArgs = {
  object: Vehicle_Tank_Type_Product_Variation_Insert_Input;
  on_conflict?: InputMaybe<Vehicle_Tank_Type_Product_Variation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_TypeArgs = {
  objects: Array<Vehicle_Type_Insert_Input>;
  on_conflict?: InputMaybe<Vehicle_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_Type_OneArgs = {
  object: Vehicle_Type_Insert_Input;
  on_conflict?: InputMaybe<Vehicle_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vendor_Order_LogsArgs = {
  objects: Array<Vendor_Order_Logs_Insert_Input>;
  on_conflict?: InputMaybe<Vendor_Order_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vendor_Order_Logs_OneArgs = {
  object: Vendor_Order_Logs_Insert_Input;
  on_conflict?: InputMaybe<Vendor_Order_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vendor_Sync_StatusArgs = {
  objects: Array<Vendor_Sync_Status_Insert_Input>;
  on_conflict?: InputMaybe<Vendor_Sync_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vendor_Sync_Status_OneArgs = {
  object: Vendor_Sync_Status_Insert_Input;
  on_conflict?: InputMaybe<Vendor_Sync_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_VoucherArgs = {
  objects: Array<Voucher_Insert_Input>;
  on_conflict?: InputMaybe<Voucher_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Voucher_OneArgs = {
  object: Voucher_Insert_Input;
  on_conflict?: InputMaybe<Voucher_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_WalletArgs = {
  objects: Array<Wallet_Insert_Input>;
  on_conflict?: InputMaybe<Wallet_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Wallet_ExceptionArgs = {
  objects: Array<Wallet_Exception_Insert_Input>;
  on_conflict?: InputMaybe<Wallet_Exception_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Wallet_Exception_OneArgs = {
  object: Wallet_Exception_Insert_Input;
  on_conflict?: InputMaybe<Wallet_Exception_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Wallet_LedgerArgs = {
  objects: Array<Wallet_Ledger_Insert_Input>;
  on_conflict?: InputMaybe<Wallet_Ledger_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Wallet_Ledger_OneArgs = {
  object: Wallet_Ledger_Insert_Input;
  on_conflict?: InputMaybe<Wallet_Ledger_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Wallet_OneArgs = {
  object: Wallet_Insert_Input;
  on_conflict?: InputMaybe<Wallet_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Wallet_StateArgs = {
  objects: Array<Wallet_State_Insert_Input>;
  on_conflict?: InputMaybe<Wallet_State_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Wallet_State_OneArgs = {
  object: Wallet_State_Insert_Input;
  on_conflict?: InputMaybe<Wallet_State_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Wallet_TransactionsArgs = {
  objects: Array<Wallet_Transactions_Insert_Input>;
  on_conflict?: InputMaybe<Wallet_Transactions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Wallet_Transactions_OneArgs = {
  object: Wallet_Transactions_Insert_Input;
  on_conflict?: InputMaybe<Wallet_Transactions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootIsDeliveryNoteInvoicedArgs = {
  object: IsDeliveryNoteInvoicedInput;
};


/** mutation root */
export type Mutation_RootIsShiftScheduleExistArgs = {
  object: IsShiftScheduleExistInput;
};


/** mutation root */
export type Mutation_RootMigrateCustomerToErpArgs = {
  object: MigrateCustomerToErpInput;
};


/** mutation root */
export type Mutation_RootOrderDeliveryAutomationArgs = {
  object: OrderDeliveryAutomationInput;
};


/** mutation root */
export type Mutation_RootPayThroughWalletArgs = {
  object: PayThroughWalletInput;
};


/** mutation root */
export type Mutation_RootPushDepartmentToErpArgs = {
  object: PushDepartmentToErpInput;
};


/** mutation root */
export type Mutation_RootReassignShiftScheduleArgs = {
  object: ReassignShiftScheduleInput;
};


/** mutation root */
export type Mutation_RootReassignTaskArgs = {
  object: ReassignTaskInput;
};


/** mutation root */
export type Mutation_RootRectifyWalletDriftArgs = {
  object: RectifyWalletDriftInput;
};


/** mutation root */
export type Mutation_RootReleaseWalletBlockArgs = {
  object: ReleaseWalletBlockInput;
};


/** mutation root */
export type Mutation_RootRescheduleTaskArgs = {
  object: RescheduleTaskInput;
};


/** mutation root */
export type Mutation_RootRetagDeliveryNoteArgs = {
  object: RetagDeliveryNoteInput;
};


/** mutation root */
export type Mutation_RootSendInvoiceToEtArgs = {
  object: SendInvoiceToEtInput;
};


/** mutation root */
export type Mutation_RootSendTransactionLogsToEtArgs = {
  order_codes: Array<Scalars['bigint']['input']>;
};


/** mutation root */
export type Mutation_RootSendTransactionLogsToEtV1Args = {
  order_codes: Array<Scalars['bigint']['input']>;
};


/** mutation root */
export type Mutation_RootShiftAddressDepartmentArgs = {
  object: ShiftAddressDepartmentInput;
};


/** mutation root */
export type Mutation_RootShiftAssetDepartmentArgs = {
  object: ShiftAssetDepartmentInput;
};


/** mutation root */
export type Mutation_RootToggleOrganizationActiveArgs = {
  object: ToggleOrganizationActiveInput;
};


/** mutation root */
export type Mutation_RootToggleUserStatusArgs = {
  object: ToggleUserStatusInput;
};


/** mutation root */
export type Mutation_RootTriggerDeliveryNoteArgs = {
  object: TriggerDeliveryNoteInput;
};


/** mutation root */
export type Mutation_RootUnblock_Wallet_AmountArgs = {
  args: Unblock_Wallet_Amount_Args;
  distinct_on?: InputMaybe<Array<Wallet_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Order_By>>;
  where?: InputMaybe<Wallet_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootUpdateCustomerAssetBasedOnOrderCodeArgs = {
  object: UpdateCustomerAssetBasedOnOrderCodeInput;
};


/** mutation root */
export type Mutation_RootUpdateCustomerOrderItemUnitPriceArgs = {
  object: UpdateCustomerOrderItemInput;
};


/** mutation root */
export type Mutation_RootUpdateDeliveryNoteDepartmentArgs = {
  object: UpdateDeliveryNoteDepartmentInput;
};


/** mutation root */
export type Mutation_RootUpdateDispensedQtyArgs = {
  object: UpdateDispensedQtyInput;
};


/** mutation root */
export type Mutation_RootUpdateDispensingDateArgs = {
  object: UpdateDispensingDateInput;
};


/** mutation root */
export type Mutation_RootUpdateInvoiceArgs = {
  object: UpdateInvoiceInput;
};


/** mutation root */
export type Mutation_RootUpdateOdometerReadingArgs = {
  object: UpdateOdometerReadingInput;
};


/** mutation root */
export type Mutation_RootUpdateOrderDateByOrderCodeArgs = {
  object?: InputMaybe<UpdateOrderDateByOrderCodeInput>;
};


/** mutation root */
export type Mutation_RootUpdateOrderItemToAcceptedArgs = {
  object: UpdateOrderItemToAcceptedInput;
};


/** mutation root */
export type Mutation_RootUpdateOrderStateByOrderCodeArgs = {
  object?: InputMaybe<UpdateOrderStateByOrderCodeInput>;
};


/** mutation root */
export type Mutation_RootUpdateProductPartnerLocalitiesPriceArgs = {
  object: UpdateProductPartnerLocalitiesPriceInput;
};


/** mutation root */
export type Mutation_RootUpdateSubsidiaryArgs = {
  object: UpdateSubsidiaryInput;
};


/** mutation root */
export type Mutation_RootUpdateTaskArgs = {
  object: UpdateTaskInput;
};


/** mutation root */
export type Mutation_RootUpdateWalletAmountArgs = {
  object: UpdateWalletAmountInput;
};


/** mutation root */
export type Mutation_RootUpdate_Address_SubsidiaryArgs = {
  _set?: InputMaybe<Address_Subsidiary_Set_Input>;
  where: Address_Subsidiary_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Address_Subsidiary_Audit_LogsArgs = {
  _set?: InputMaybe<Address_Subsidiary_Audit_Logs_Set_Input>;
  where: Address_Subsidiary_Audit_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Address_Subsidiary_Audit_Logs_By_PkArgs = {
  _set?: InputMaybe<Address_Subsidiary_Audit_Logs_Set_Input>;
  pk_columns: Address_Subsidiary_Audit_Logs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Address_Subsidiary_Audit_Logs_ManyArgs = {
  updates: Array<Address_Subsidiary_Audit_Logs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Address_Subsidiary_By_PkArgs = {
  _set?: InputMaybe<Address_Subsidiary_Set_Input>;
  pk_columns: Address_Subsidiary_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Address_Subsidiary_ManyArgs = {
  updates: Array<Address_Subsidiary_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Address_TypeArgs = {
  _set?: InputMaybe<Address_Type_Set_Input>;
  where: Address_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Address_Type_By_PkArgs = {
  _set?: InputMaybe<Address_Type_Set_Input>;
  pk_columns: Address_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Address_Type_ManyArgs = {
  updates: Array<Address_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_GroupingArgs = {
  _set?: InputMaybe<Asset_Grouping_Set_Input>;
  where: Asset_Grouping_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Grouping_By_PkArgs = {
  _set?: InputMaybe<Asset_Grouping_Set_Input>;
  pk_columns: Asset_Grouping_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Grouping_Customer_AssetArgs = {
  _set?: InputMaybe<Asset_Grouping_Customer_Asset_Set_Input>;
  where: Asset_Grouping_Customer_Asset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Grouping_Customer_Asset_By_PkArgs = {
  _set?: InputMaybe<Asset_Grouping_Customer_Asset_Set_Input>;
  pk_columns: Asset_Grouping_Customer_Asset_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Grouping_Customer_Asset_ManyArgs = {
  updates: Array<Asset_Grouping_Customer_Asset_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Grouping_ManyArgs = {
  updates: Array<Asset_Grouping_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_SubsidiaryArgs = {
  _set?: InputMaybe<Asset_Subsidiary_Set_Input>;
  where: Asset_Subsidiary_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Subsidiary_Audit_LogsArgs = {
  _set?: InputMaybe<Asset_Subsidiary_Audit_Logs_Set_Input>;
  where: Asset_Subsidiary_Audit_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Subsidiary_Audit_Logs_By_PkArgs = {
  _set?: InputMaybe<Asset_Subsidiary_Audit_Logs_Set_Input>;
  pk_columns: Asset_Subsidiary_Audit_Logs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Subsidiary_Audit_Logs_ManyArgs = {
  updates: Array<Asset_Subsidiary_Audit_Logs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Subsidiary_By_PkArgs = {
  _set?: InputMaybe<Asset_Subsidiary_Set_Input>;
  pk_columns: Asset_Subsidiary_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Subsidiary_ManyArgs = {
  updates: Array<Asset_Subsidiary_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_TypeArgs = {
  _inc?: InputMaybe<Asset_Type_Inc_Input>;
  _set?: InputMaybe<Asset_Type_Set_Input>;
  where: Asset_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Type_By_PkArgs = {
  _inc?: InputMaybe<Asset_Type_Inc_Input>;
  _set?: InputMaybe<Asset_Type_Set_Input>;
  pk_columns: Asset_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Type_CategoryArgs = {
  _set?: InputMaybe<Asset_Type_Category_Set_Input>;
  where: Asset_Type_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Type_Category_By_PkArgs = {
  _set?: InputMaybe<Asset_Type_Category_Set_Input>;
  pk_columns: Asset_Type_Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Type_Category_ManyArgs = {
  updates: Array<Asset_Type_Category_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Type_ManyArgs = {
  updates: Array<Asset_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Associated_TypeArgs = {
  _set?: InputMaybe<Associated_Type_Set_Input>;
  where: Associated_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Associated_Type_By_PkArgs = {
  _set?: InputMaybe<Associated_Type_Set_Input>;
  pk_columns: Associated_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Associated_Type_ManyArgs = {
  updates: Array<Associated_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Audit_Log_ActionArgs = {
  _set?: InputMaybe<Audit_Log_Action_Set_Input>;
  where: Audit_Log_Action_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Audit_Log_Action_By_PkArgs = {
  _set?: InputMaybe<Audit_Log_Action_Set_Input>;
  pk_columns: Audit_Log_Action_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Audit_Log_Action_ManyArgs = {
  updates: Array<Audit_Log_Action_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Cancellation_ReasonsArgs = {
  _inc?: InputMaybe<Cancellation_Reasons_Inc_Input>;
  _set?: InputMaybe<Cancellation_Reasons_Set_Input>;
  where: Cancellation_Reasons_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Cancellation_Reasons_By_PkArgs = {
  _inc?: InputMaybe<Cancellation_Reasons_Inc_Input>;
  _set?: InputMaybe<Cancellation_Reasons_Set_Input>;
  pk_columns: Cancellation_Reasons_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Cancellation_Reasons_ManyArgs = {
  updates: Array<Cancellation_Reasons_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CategoryArgs = {
  _set?: InputMaybe<Category_Set_Input>;
  where: Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Category_By_PkArgs = {
  _set?: InputMaybe<Category_Set_Input>;
  pk_columns: Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Category_ManyArgs = {
  updates: Array<Category_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CityArgs = {
  _set?: InputMaybe<City_Set_Input>;
  where: City_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_City_By_PkArgs = {
  _set?: InputMaybe<City_Set_Input>;
  pk_columns: City_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_City_ManyArgs = {
  updates: Array<City_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CountryArgs = {
  _inc?: InputMaybe<Country_Inc_Input>;
  _set?: InputMaybe<Country_Set_Input>;
  where: Country_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Country_By_PkArgs = {
  _inc?: InputMaybe<Country_Inc_Input>;
  _set?: InputMaybe<Country_Set_Input>;
  pk_columns: Country_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Country_ManyArgs = {
  updates: Array<Country_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Credit_BreachArgs = {
  _set?: InputMaybe<Credit_Breach_Set_Input>;
  where: Credit_Breach_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Credit_Breach_By_PkArgs = {
  _set?: InputMaybe<Credit_Breach_Set_Input>;
  pk_columns: Credit_Breach_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Credit_Breach_ManyArgs = {
  updates: Array<Credit_Breach_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CurrencyArgs = {
  _set?: InputMaybe<Currency_Set_Input>;
  where: Currency_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Currency_By_PkArgs = {
  _set?: InputMaybe<Currency_Set_Input>;
  pk_columns: Currency_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Currency_ConversionArgs = {
  _set?: InputMaybe<Currency_Conversion_Set_Input>;
  where: Currency_Conversion_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Currency_Conversion_By_PkArgs = {
  _set?: InputMaybe<Currency_Conversion_Set_Input>;
  pk_columns: Currency_Conversion_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Currency_Conversion_ManyArgs = {
  updates: Array<Currency_Conversion_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Currency_ManyArgs = {
  updates: Array<Currency_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_AssetArgs = {
  _inc?: InputMaybe<Customer_Asset_Inc_Input>;
  _set?: InputMaybe<Customer_Asset_Set_Input>;
  where: Customer_Asset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Asset_Audit_LogArgs = {
  _append?: InputMaybe<Customer_Asset_Audit_Log_Append_Input>;
  _delete_at_path?: InputMaybe<Customer_Asset_Audit_Log_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Customer_Asset_Audit_Log_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Customer_Asset_Audit_Log_Delete_Key_Input>;
  _prepend?: InputMaybe<Customer_Asset_Audit_Log_Prepend_Input>;
  _set?: InputMaybe<Customer_Asset_Audit_Log_Set_Input>;
  where: Customer_Asset_Audit_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Asset_Audit_Log_By_PkArgs = {
  _append?: InputMaybe<Customer_Asset_Audit_Log_Append_Input>;
  _delete_at_path?: InputMaybe<Customer_Asset_Audit_Log_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Customer_Asset_Audit_Log_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Customer_Asset_Audit_Log_Delete_Key_Input>;
  _prepend?: InputMaybe<Customer_Asset_Audit_Log_Prepend_Input>;
  _set?: InputMaybe<Customer_Asset_Audit_Log_Set_Input>;
  pk_columns: Customer_Asset_Audit_Log_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Asset_Audit_Log_ManyArgs = {
  updates: Array<Customer_Asset_Audit_Log_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Asset_By_PkArgs = {
  _inc?: InputMaybe<Customer_Asset_Inc_Input>;
  _set?: InputMaybe<Customer_Asset_Set_Input>;
  pk_columns: Customer_Asset_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Asset_DeviceArgs = {
  _inc?: InputMaybe<Customer_Asset_Device_Inc_Input>;
  _set?: InputMaybe<Customer_Asset_Device_Set_Input>;
  where: Customer_Asset_Device_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Asset_Device_By_PkArgs = {
  _inc?: InputMaybe<Customer_Asset_Device_Inc_Input>;
  _set?: InputMaybe<Customer_Asset_Device_Set_Input>;
  pk_columns: Customer_Asset_Device_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Asset_Device_CalibrationArgs = {
  _set?: InputMaybe<Customer_Asset_Device_Calibration_Set_Input>;
  where: Customer_Asset_Device_Calibration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Asset_Device_Calibration_By_PkArgs = {
  _set?: InputMaybe<Customer_Asset_Device_Calibration_Set_Input>;
  pk_columns: Customer_Asset_Device_Calibration_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Asset_Device_Calibration_ManyArgs = {
  updates: Array<Customer_Asset_Device_Calibration_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Asset_Device_ManyArgs = {
  updates: Array<Customer_Asset_Device_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Asset_Dispensing_RulesArgs = {
  _set?: InputMaybe<Customer_Asset_Dispensing_Rules_Set_Input>;
  where: Customer_Asset_Dispensing_Rules_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Asset_Dispensing_Rules_By_PkArgs = {
  _set?: InputMaybe<Customer_Asset_Dispensing_Rules_Set_Input>;
  pk_columns: Customer_Asset_Dispensing_Rules_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Asset_Dispensing_Rules_ManyArgs = {
  updates: Array<Customer_Asset_Dispensing_Rules_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Asset_LimitArgs = {
  _inc?: InputMaybe<Customer_Asset_Limit_Inc_Input>;
  _set?: InputMaybe<Customer_Asset_Limit_Set_Input>;
  where: Customer_Asset_Limit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Asset_Limit_By_PkArgs = {
  _inc?: InputMaybe<Customer_Asset_Limit_Inc_Input>;
  _set?: InputMaybe<Customer_Asset_Limit_Set_Input>;
  pk_columns: Customer_Asset_Limit_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Asset_Limit_ManyArgs = {
  updates: Array<Customer_Asset_Limit_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Asset_ManyArgs = {
  updates: Array<Customer_Asset_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Asset_TagArgs = {
  _set?: InputMaybe<Customer_Asset_Tag_Set_Input>;
  where: Customer_Asset_Tag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Asset_Tag_By_PkArgs = {
  _set?: InputMaybe<Customer_Asset_Tag_Set_Input>;
  pk_columns: Customer_Asset_Tag_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Asset_Tag_ManyArgs = {
  updates: Array<Customer_Asset_Tag_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_OrderArgs = {
  _inc?: InputMaybe<Customer_Order_Inc_Input>;
  _set?: InputMaybe<Customer_Order_Set_Input>;
  where: Customer_Order_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_By_PkArgs = {
  _inc?: InputMaybe<Customer_Order_Inc_Input>;
  _set?: InputMaybe<Customer_Order_Set_Input>;
  pk_columns: Customer_Order_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Cancellation_ReasonsArgs = {
  _set?: InputMaybe<Customer_Order_Cancellation_Reasons_Set_Input>;
  where: Customer_Order_Cancellation_Reasons_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Cancellation_Reasons_By_PkArgs = {
  _set?: InputMaybe<Customer_Order_Cancellation_Reasons_Set_Input>;
  pk_columns: Customer_Order_Cancellation_Reasons_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Cancellation_Reasons_ManyArgs = {
  updates: Array<Customer_Order_Cancellation_Reasons_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Customer_AssetArgs = {
  _inc?: InputMaybe<Customer_Order_Customer_Asset_Inc_Input>;
  _set?: InputMaybe<Customer_Order_Customer_Asset_Set_Input>;
  where: Customer_Order_Customer_Asset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Customer_Asset_By_PkArgs = {
  _inc?: InputMaybe<Customer_Order_Customer_Asset_Inc_Input>;
  _set?: InputMaybe<Customer_Order_Customer_Asset_Set_Input>;
  pk_columns: Customer_Order_Customer_Asset_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Customer_Asset_ManyArgs = {
  updates: Array<Customer_Order_Customer_Asset_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_ItemArgs = {
  _inc?: InputMaybe<Customer_Order_Item_Inc_Input>;
  _set?: InputMaybe<Customer_Order_Item_Set_Input>;
  where: Customer_Order_Item_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Item_By_PkArgs = {
  _inc?: InputMaybe<Customer_Order_Item_Inc_Input>;
  _set?: InputMaybe<Customer_Order_Item_Set_Input>;
  pk_columns: Customer_Order_Item_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Item_Cancellation_ReasonsArgs = {
  _set?: InputMaybe<Customer_Order_Item_Cancellation_Reasons_Set_Input>;
  where: Customer_Order_Item_Cancellation_Reasons_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Item_Cancellation_Reasons_By_PkArgs = {
  _set?: InputMaybe<Customer_Order_Item_Cancellation_Reasons_Set_Input>;
  pk_columns: Customer_Order_Item_Cancellation_Reasons_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Item_Cancellation_Reasons_ManyArgs = {
  updates: Array<Customer_Order_Item_Cancellation_Reasons_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Item_CommentsArgs = {
  _set?: InputMaybe<Customer_Order_Item_Comments_Set_Input>;
  where: Customer_Order_Item_Comments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Item_Comments_By_PkArgs = {
  _set?: InputMaybe<Customer_Order_Item_Comments_Set_Input>;
  pk_columns: Customer_Order_Item_Comments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Item_Comments_ManyArgs = {
  updates: Array<Customer_Order_Item_Comments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Item_CommissionArgs = {
  _inc?: InputMaybe<Customer_Order_Item_Commission_Inc_Input>;
  _set?: InputMaybe<Customer_Order_Item_Commission_Set_Input>;
  where: Customer_Order_Item_Commission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Item_Commission_By_PkArgs = {
  _inc?: InputMaybe<Customer_Order_Item_Commission_Inc_Input>;
  _set?: InputMaybe<Customer_Order_Item_Commission_Set_Input>;
  pk_columns: Customer_Order_Item_Commission_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Item_Commission_ManyArgs = {
  updates: Array<Customer_Order_Item_Commission_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Item_Etd_Transactional_LogsArgs = {
  _set?: InputMaybe<Customer_Order_Item_Etd_Transactional_Logs_Set_Input>;
  where: Customer_Order_Item_Etd_Transactional_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Item_Etd_Transactional_Logs_By_PkArgs = {
  _set?: InputMaybe<Customer_Order_Item_Etd_Transactional_Logs_Set_Input>;
  pk_columns: Customer_Order_Item_Etd_Transactional_Logs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Item_Etd_Transactional_Logs_ManyArgs = {
  updates: Array<Customer_Order_Item_Etd_Transactional_Logs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Item_ManyArgs = {
  updates: Array<Customer_Order_Item_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Item_PartnerArgs = {
  _set?: InputMaybe<Customer_Order_Item_Partner_Set_Input>;
  where: Customer_Order_Item_Partner_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Item_Partner_By_PkArgs = {
  _set?: InputMaybe<Customer_Order_Item_Partner_Set_Input>;
  pk_columns: Customer_Order_Item_Partner_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Item_Partner_ManyArgs = {
  updates: Array<Customer_Order_Item_Partner_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Item_Safety_Checklist_ResultsArgs = {
  _set?: InputMaybe<Customer_Order_Item_Safety_Checklist_Results_Set_Input>;
  where: Customer_Order_Item_Safety_Checklist_Results_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Item_Safety_Checklist_Results_By_PkArgs = {
  _set?: InputMaybe<Customer_Order_Item_Safety_Checklist_Results_Set_Input>;
  pk_columns: Customer_Order_Item_Safety_Checklist_Results_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Item_Safety_Checklist_Results_ManyArgs = {
  updates: Array<Customer_Order_Item_Safety_Checklist_Results_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Item_StateArgs = {
  _set?: InputMaybe<Customer_Order_Item_State_Set_Input>;
  where: Customer_Order_Item_State_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Item_State_By_PkArgs = {
  _set?: InputMaybe<Customer_Order_Item_State_Set_Input>;
  pk_columns: Customer_Order_Item_State_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Item_State_ManyArgs = {
  updates: Array<Customer_Order_Item_State_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Item_StateflowArgs = {
  _set?: InputMaybe<Customer_Order_Item_Stateflow_Set_Input>;
  where: Customer_Order_Item_Stateflow_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Item_Stateflow_By_PkArgs = {
  _set?: InputMaybe<Customer_Order_Item_Stateflow_Set_Input>;
  pk_columns: Customer_Order_Item_Stateflow_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Item_Stateflow_ManyArgs = {
  updates: Array<Customer_Order_Item_Stateflow_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Item_Test_CategoryArgs = {
  _set?: InputMaybe<Customer_Order_Item_Test_Category_Set_Input>;
  where: Customer_Order_Item_Test_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Item_Test_Category_By_PkArgs = {
  _set?: InputMaybe<Customer_Order_Item_Test_Category_Set_Input>;
  pk_columns: Customer_Order_Item_Test_Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Item_Test_Category_ManyArgs = {
  updates: Array<Customer_Order_Item_Test_Category_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Item_Test_ResultsArgs = {
  _set?: InputMaybe<Customer_Order_Item_Test_Results_Set_Input>;
  where: Customer_Order_Item_Test_Results_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Item_Test_Results_By_PkArgs = {
  _set?: InputMaybe<Customer_Order_Item_Test_Results_Set_Input>;
  pk_columns: Customer_Order_Item_Test_Results_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Item_Test_Results_ManyArgs = {
  updates: Array<Customer_Order_Item_Test_Results_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Item_Test_Results_PhotosArgs = {
  _set?: InputMaybe<Customer_Order_Item_Test_Results_Photos_Set_Input>;
  where: Customer_Order_Item_Test_Results_Photos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Item_Test_Results_Photos_By_PkArgs = {
  _set?: InputMaybe<Customer_Order_Item_Test_Results_Photos_Set_Input>;
  pk_columns: Customer_Order_Item_Test_Results_Photos_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Item_Test_Results_Photos_ManyArgs = {
  updates: Array<Customer_Order_Item_Test_Results_Photos_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_ManyArgs = {
  updates: Array<Customer_Order_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Organization_User_DocumentArgs = {
  _set?: InputMaybe<Customer_Order_Organization_User_Document_Set_Input>;
  where: Customer_Order_Organization_User_Document_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Organization_User_Document_By_PkArgs = {
  _set?: InputMaybe<Customer_Order_Organization_User_Document_Set_Input>;
  pk_columns: Customer_Order_Organization_User_Document_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Organization_User_Document_ManyArgs = {
  updates: Array<Customer_Order_Organization_User_Document_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Partner_OrderArgs = {
  _set?: InputMaybe<Customer_Order_Partner_Order_Set_Input>;
  where: Customer_Order_Partner_Order_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Partner_Order_By_PkArgs = {
  _set?: InputMaybe<Customer_Order_Partner_Order_Set_Input>;
  pk_columns: Customer_Order_Partner_Order_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Partner_Order_ManyArgs = {
  updates: Array<Customer_Order_Partner_Order_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_SlotsArgs = {
  _set?: InputMaybe<Customer_Order_Slots_Set_Input>;
  where: Customer_Order_Slots_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Slots_By_PkArgs = {
  _set?: InputMaybe<Customer_Order_Slots_Set_Input>;
  pk_columns: Customer_Order_Slots_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Slots_ManyArgs = {
  updates: Array<Customer_Order_Slots_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_StateArgs = {
  _set?: InputMaybe<Customer_Order_State_Set_Input>;
  where: Customer_Order_State_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_State_By_PkArgs = {
  _set?: InputMaybe<Customer_Order_State_Set_Input>;
  pk_columns: Customer_Order_State_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_State_ManyArgs = {
  updates: Array<Customer_Order_State_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_StateflowArgs = {
  _set?: InputMaybe<Customer_Order_Stateflow_Set_Input>;
  where: Customer_Order_Stateflow_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Stateflow_By_PkArgs = {
  _set?: InputMaybe<Customer_Order_Stateflow_Set_Input>;
  pk_columns: Customer_Order_Stateflow_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Order_Stateflow_ManyArgs = {
  updates: Array<Customer_Order_Stateflow_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_PaymentArgs = {
  _inc?: InputMaybe<Customer_Payment_Inc_Input>;
  _set?: InputMaybe<Customer_Payment_Set_Input>;
  where: Customer_Payment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Payment_By_PkArgs = {
  _inc?: InputMaybe<Customer_Payment_Inc_Input>;
  _set?: InputMaybe<Customer_Payment_Set_Input>;
  pk_columns: Customer_Payment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Payment_ManyArgs = {
  updates: Array<Customer_Payment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Payment_StatusArgs = {
  _set?: InputMaybe<Customer_Payment_Status_Set_Input>;
  where: Customer_Payment_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Payment_Status_By_PkArgs = {
  _set?: InputMaybe<Customer_Payment_Status_Set_Input>;
  pk_columns: Customer_Payment_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Payment_Status_ManyArgs = {
  updates: Array<Customer_Payment_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_SegmentationArgs = {
  _inc?: InputMaybe<Customer_Segmentation_Inc_Input>;
  _set?: InputMaybe<Customer_Segmentation_Set_Input>;
  where: Customer_Segmentation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Segmentation_By_PkArgs = {
  _inc?: InputMaybe<Customer_Segmentation_Inc_Input>;
  _set?: InputMaybe<Customer_Segmentation_Set_Input>;
  pk_columns: Customer_Segmentation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Segmentation_ManyArgs = {
  updates: Array<Customer_Segmentation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Day_TypeArgs = {
  _set?: InputMaybe<Day_Type_Set_Input>;
  where: Day_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Day_Type_By_PkArgs = {
  _set?: InputMaybe<Day_Type_Set_Input>;
  pk_columns: Day_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Day_Type_ManyArgs = {
  updates: Array<Day_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Delivery_PreferencesArgs = {
  _set?: InputMaybe<Delivery_Preferences_Set_Input>;
  where: Delivery_Preferences_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Delivery_Preferences_By_PkArgs = {
  _set?: InputMaybe<Delivery_Preferences_Set_Input>;
  pk_columns: Delivery_Preferences_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Delivery_Preferences_ManyArgs = {
  updates: Array<Delivery_Preferences_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Delivery_SchedulerArgs = {
  _set?: InputMaybe<Delivery_Scheduler_Set_Input>;
  where: Delivery_Scheduler_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Delivery_Scheduler_By_PkArgs = {
  _set?: InputMaybe<Delivery_Scheduler_Set_Input>;
  pk_columns: Delivery_Scheduler_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Delivery_Scheduler_ManyArgs = {
  updates: Array<Delivery_Scheduler_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Delivery_Scheduler_Product_ItemArgs = {
  _set?: InputMaybe<Delivery_Scheduler_Product_Item_Set_Input>;
  where: Delivery_Scheduler_Product_Item_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Delivery_Scheduler_Product_Item_By_PkArgs = {
  _set?: InputMaybe<Delivery_Scheduler_Product_Item_Set_Input>;
  pk_columns: Delivery_Scheduler_Product_Item_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Delivery_Scheduler_Product_Item_ManyArgs = {
  updates: Array<Delivery_Scheduler_Product_Item_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Department_Retag_RequestArgs = {
  _inc?: InputMaybe<Department_Retag_Request_Inc_Input>;
  _set?: InputMaybe<Department_Retag_Request_Set_Input>;
  where: Department_Retag_Request_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Department_Retag_Request_By_PkArgs = {
  _inc?: InputMaybe<Department_Retag_Request_Inc_Input>;
  _set?: InputMaybe<Department_Retag_Request_Set_Input>;
  pk_columns: Department_Retag_Request_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Department_Retag_Request_ManyArgs = {
  updates: Array<Department_Retag_Request_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Device_Devicetype_Paramerter_DefinitionArgs = {
  _set?: InputMaybe<Device_Devicetype_Paramerter_Definition_Set_Input>;
  where: Device_Devicetype_Paramerter_Definition_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Device_Devicetype_Paramerter_Definition_By_PkArgs = {
  _set?: InputMaybe<Device_Devicetype_Paramerter_Definition_Set_Input>;
  pk_columns: Device_Devicetype_Paramerter_Definition_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Device_Devicetype_Paramerter_Definition_ManyArgs = {
  updates: Array<Device_Devicetype_Paramerter_Definition_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DevicetypeArgs = {
  _set?: InputMaybe<Devicetype_Set_Input>;
  where: Devicetype_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Devicetype_By_PkArgs = {
  _set?: InputMaybe<Devicetype_Set_Input>;
  pk_columns: Devicetype_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Devicetype_ManyArgs = {
  updates: Array<Devicetype_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Devicetype_Paramerter_DefinitionArgs = {
  _set?: InputMaybe<Devicetype_Paramerter_Definition_Set_Input>;
  where: Devicetype_Paramerter_Definition_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Devicetype_Paramerter_Definition_By_PkArgs = {
  _set?: InputMaybe<Devicetype_Paramerter_Definition_Set_Input>;
  pk_columns: Devicetype_Paramerter_Definition_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Devicetype_Paramerter_Definition_ManyArgs = {
  updates: Array<Devicetype_Paramerter_Definition_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Devicetype_Parameter_GroupArgs = {
  _set?: InputMaybe<Devicetype_Parameter_Group_Set_Input>;
  where: Devicetype_Parameter_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Devicetype_Parameter_Group_By_PkArgs = {
  _set?: InputMaybe<Devicetype_Parameter_Group_Set_Input>;
  pk_columns: Devicetype_Parameter_Group_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Devicetype_Parameter_Group_ManyArgs = {
  updates: Array<Devicetype_Parameter_Group_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Discount_TypeArgs = {
  _set?: InputMaybe<Discount_Type_Set_Input>;
  where: Discount_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Discount_Type_By_PkArgs = {
  _set?: InputMaybe<Discount_Type_Set_Input>;
  pk_columns: Discount_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Discount_Type_ManyArgs = {
  updates: Array<Discount_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DispenserArgs = {
  _set?: InputMaybe<Dispenser_Set_Input>;
  where: Dispenser_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Dispenser_By_PkArgs = {
  _set?: InputMaybe<Dispenser_Set_Input>;
  pk_columns: Dispenser_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Dispenser_ConfigurationArgs = {
  _set?: InputMaybe<Dispenser_Configuration_Set_Input>;
  where: Dispenser_Configuration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Dispenser_Configuration_By_PkArgs = {
  _set?: InputMaybe<Dispenser_Configuration_Set_Input>;
  pk_columns: Dispenser_Configuration_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Dispenser_Configuration_ManyArgs = {
  updates: Array<Dispenser_Configuration_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Dispenser_ManyArgs = {
  updates: Array<Dispenser_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Dispenser_TypeArgs = {
  _set?: InputMaybe<Dispenser_Type_Set_Input>;
  where: Dispenser_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Dispenser_Type_By_PkArgs = {
  _set?: InputMaybe<Dispenser_Type_Set_Input>;
  pk_columns: Dispenser_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Dispenser_Type_ManyArgs = {
  updates: Array<Dispenser_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Dispensing_RulesArgs = {
  _inc?: InputMaybe<Dispensing_Rules_Inc_Input>;
  _set?: InputMaybe<Dispensing_Rules_Set_Input>;
  where: Dispensing_Rules_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Dispensing_Rules_By_PkArgs = {
  _inc?: InputMaybe<Dispensing_Rules_Inc_Input>;
  _set?: InputMaybe<Dispensing_Rules_Set_Input>;
  pk_columns: Dispensing_Rules_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Dispensing_Rules_ManyArgs = {
  updates: Array<Dispensing_Rules_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Document_TypeArgs = {
  _set?: InputMaybe<Document_Type_Set_Input>;
  where: Document_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Type_By_PkArgs = {
  _set?: InputMaybe<Document_Type_Set_Input>;
  pk_columns: Document_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Type_CategoryArgs = {
  _set?: InputMaybe<Document_Type_Category_Set_Input>;
  where: Document_Type_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Type_Category_By_PkArgs = {
  _set?: InputMaybe<Document_Type_Category_Set_Input>;
  pk_columns: Document_Type_Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Type_Category_ManyArgs = {
  updates: Array<Document_Type_Category_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Type_ManyArgs = {
  updates: Array<Document_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DocumentsArgs = {
  _set?: InputMaybe<Documents_Set_Input>;
  where: Documents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Documents_By_PkArgs = {
  _set?: InputMaybe<Documents_Set_Input>;
  pk_columns: Documents_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Documents_ManyArgs = {
  updates: Array<Documents_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Driver_Duty_LogArgs = {
  _set?: InputMaybe<Driver_Duty_Log_Set_Input>;
  where: Driver_Duty_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Driver_Duty_Log_By_PkArgs = {
  _set?: InputMaybe<Driver_Duty_Log_Set_Input>;
  pk_columns: Driver_Duty_Log_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Driver_Duty_Log_ManyArgs = {
  updates: Array<Driver_Duty_Log_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Driver_Duty_PhotosArgs = {
  _set?: InputMaybe<Driver_Duty_Photos_Set_Input>;
  where: Driver_Duty_Photos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Driver_Duty_Photos_By_PkArgs = {
  _set?: InputMaybe<Driver_Duty_Photos_Set_Input>;
  pk_columns: Driver_Duty_Photos_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Driver_Duty_Photos_ManyArgs = {
  updates: Array<Driver_Duty_Photos_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Driver_PermitArgs = {
  _set?: InputMaybe<Driver_Permit_Set_Input>;
  where: Driver_Permit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Driver_Permit_By_PkArgs = {
  _set?: InputMaybe<Driver_Permit_Set_Input>;
  pk_columns: Driver_Permit_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Driver_Permit_ManyArgs = {
  updates: Array<Driver_Permit_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Driver_VehicleArgs = {
  _set?: InputMaybe<Driver_Vehicle_Set_Input>;
  where: Driver_Vehicle_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Driver_Vehicle_By_PkArgs = {
  _set?: InputMaybe<Driver_Vehicle_Set_Input>;
  pk_columns: Driver_Vehicle_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Driver_Vehicle_IssueArgs = {
  _set?: InputMaybe<Driver_Vehicle_Issue_Set_Input>;
  where: Driver_Vehicle_Issue_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Driver_Vehicle_Issue_By_PkArgs = {
  _set?: InputMaybe<Driver_Vehicle_Issue_Set_Input>;
  pk_columns: Driver_Vehicle_Issue_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Driver_Vehicle_Issue_ManyArgs = {
  updates: Array<Driver_Vehicle_Issue_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Driver_Vehicle_LocationArgs = {
  _set?: InputMaybe<Driver_Vehicle_Location_Set_Input>;
  where: Driver_Vehicle_Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Driver_Vehicle_Location_By_PkArgs = {
  _set?: InputMaybe<Driver_Vehicle_Location_Set_Input>;
  pk_columns: Driver_Vehicle_Location_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Driver_Vehicle_Location_ManyArgs = {
  updates: Array<Driver_Vehicle_Location_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Driver_Vehicle_ManyArgs = {
  updates: Array<Driver_Vehicle_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Erp_Sync_StatusArgs = {
  _set?: InputMaybe<Erp_Sync_Status_Set_Input>;
  where: Erp_Sync_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Erp_Sync_Status_By_PkArgs = {
  _set?: InputMaybe<Erp_Sync_Status_Set_Input>;
  pk_columns: Erp_Sync_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Erp_Sync_Status_ManyArgs = {
  updates: Array<Erp_Sync_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Fillup_RequestArgs = {
  _append?: InputMaybe<Fillup_Request_Append_Input>;
  _delete_at_path?: InputMaybe<Fillup_Request_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Fillup_Request_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Fillup_Request_Delete_Key_Input>;
  _inc?: InputMaybe<Fillup_Request_Inc_Input>;
  _prepend?: InputMaybe<Fillup_Request_Prepend_Input>;
  _set?: InputMaybe<Fillup_Request_Set_Input>;
  where: Fillup_Request_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Fillup_Request_By_PkArgs = {
  _append?: InputMaybe<Fillup_Request_Append_Input>;
  _delete_at_path?: InputMaybe<Fillup_Request_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Fillup_Request_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Fillup_Request_Delete_Key_Input>;
  _inc?: InputMaybe<Fillup_Request_Inc_Input>;
  _prepend?: InputMaybe<Fillup_Request_Prepend_Input>;
  _set?: InputMaybe<Fillup_Request_Set_Input>;
  pk_columns: Fillup_Request_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Fillup_Request_ManyArgs = {
  updates: Array<Fillup_Request_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Fillup_Request_StatusArgs = {
  _set?: InputMaybe<Fillup_Request_Status_Set_Input>;
  where: Fillup_Request_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Fillup_Request_Status_By_PkArgs = {
  _set?: InputMaybe<Fillup_Request_Status_Set_Input>;
  pk_columns: Fillup_Request_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Fillup_Request_Status_ManyArgs = {
  updates: Array<Fillup_Request_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Fuel_Request_TypeArgs = {
  _set?: InputMaybe<Fuel_Request_Type_Set_Input>;
  where: Fuel_Request_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Fuel_Request_Type_By_PkArgs = {
  _set?: InputMaybe<Fuel_Request_Type_Set_Input>;
  pk_columns: Fuel_Request_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Fuel_Request_Type_ManyArgs = {
  updates: Array<Fuel_Request_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Fueltrans_Transaction_LogsArgs = {
  _inc?: InputMaybe<Fueltrans_Transaction_Logs_Inc_Input>;
  _set?: InputMaybe<Fueltrans_Transaction_Logs_Set_Input>;
  where: Fueltrans_Transaction_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Fueltrans_Transaction_Logs_By_PkArgs = {
  _inc?: InputMaybe<Fueltrans_Transaction_Logs_Inc_Input>;
  _set?: InputMaybe<Fueltrans_Transaction_Logs_Set_Input>;
  pk_columns: Fueltrans_Transaction_Logs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Fueltrans_Transaction_Logs_ManyArgs = {
  updates: Array<Fueltrans_Transaction_Logs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Geometry_ColumnsArgs = {
  _inc?: InputMaybe<Geometry_Columns_Inc_Input>;
  _set?: InputMaybe<Geometry_Columns_Set_Input>;
  where: Geometry_Columns_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Geometry_Columns_ManyArgs = {
  updates: Array<Geometry_Columns_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_InventoryArgs = {
  _inc?: InputMaybe<Inventory_Inc_Input>;
  _set?: InputMaybe<Inventory_Set_Input>;
  where: Inventory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Inventory_By_PkArgs = {
  _inc?: InputMaybe<Inventory_Inc_Input>;
  _set?: InputMaybe<Inventory_Set_Input>;
  pk_columns: Inventory_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Inventory_ManyArgs = {
  updates: Array<Inventory_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Inventory_Workflow_LogsArgs = {
  _append?: InputMaybe<Inventory_Workflow_Logs_Append_Input>;
  _delete_at_path?: InputMaybe<Inventory_Workflow_Logs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Inventory_Workflow_Logs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Inventory_Workflow_Logs_Delete_Key_Input>;
  _prepend?: InputMaybe<Inventory_Workflow_Logs_Prepend_Input>;
  _set?: InputMaybe<Inventory_Workflow_Logs_Set_Input>;
  where: Inventory_Workflow_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Inventory_Workflow_Logs_By_PkArgs = {
  _append?: InputMaybe<Inventory_Workflow_Logs_Append_Input>;
  _delete_at_path?: InputMaybe<Inventory_Workflow_Logs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Inventory_Workflow_Logs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Inventory_Workflow_Logs_Delete_Key_Input>;
  _prepend?: InputMaybe<Inventory_Workflow_Logs_Prepend_Input>;
  _set?: InputMaybe<Inventory_Workflow_Logs_Set_Input>;
  pk_columns: Inventory_Workflow_Logs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Inventory_Workflow_Logs_ManyArgs = {
  updates: Array<Inventory_Workflow_Logs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_InvitationArgs = {
  _set?: InputMaybe<Invitation_Set_Input>;
  where: Invitation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Invitation_By_PkArgs = {
  _set?: InputMaybe<Invitation_Set_Input>;
  pk_columns: Invitation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Invitation_ManyArgs = {
  updates: Array<Invitation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Invitation_StatusArgs = {
  _set?: InputMaybe<Invitation_Status_Set_Input>;
  where: Invitation_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Invitation_Status_By_PkArgs = {
  _set?: InputMaybe<Invitation_Status_Set_Input>;
  pk_columns: Invitation_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Invitation_Status_ManyArgs = {
  updates: Array<Invitation_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_InvoiceArgs = {
  _inc?: InputMaybe<Invoice_Inc_Input>;
  _set?: InputMaybe<Invoice_Set_Input>;
  where: Invoice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Invoice_By_PkArgs = {
  _inc?: InputMaybe<Invoice_Inc_Input>;
  _set?: InputMaybe<Invoice_Set_Input>;
  pk_columns: Invoice_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Invoice_ManyArgs = {
  updates: Array<Invoice_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Invoiced_ItemArgs = {
  _inc?: InputMaybe<Invoiced_Item_Inc_Input>;
  _set?: InputMaybe<Invoiced_Item_Set_Input>;
  where: Invoiced_Item_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Invoiced_Item_By_PkArgs = {
  _inc?: InputMaybe<Invoiced_Item_Inc_Input>;
  _set?: InputMaybe<Invoiced_Item_Set_Input>;
  pk_columns: Invoiced_Item_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Invoiced_Item_Cancellation_Ticket_StatesArgs = {
  _set?: InputMaybe<Invoiced_Item_Cancellation_Ticket_States_Set_Input>;
  where: Invoiced_Item_Cancellation_Ticket_States_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Invoiced_Item_Cancellation_Ticket_States_By_PkArgs = {
  _set?: InputMaybe<Invoiced_Item_Cancellation_Ticket_States_Set_Input>;
  pk_columns: Invoiced_Item_Cancellation_Ticket_States_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Invoiced_Item_Cancellation_Ticket_States_ManyArgs = {
  updates: Array<Invoiced_Item_Cancellation_Ticket_States_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Invoiced_Item_Cancellation_TicketsArgs = {
  _set?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Set_Input>;
  where: Invoiced_Item_Cancellation_Tickets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Invoiced_Item_Cancellation_Tickets_By_PkArgs = {
  _set?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Set_Input>;
  pk_columns: Invoiced_Item_Cancellation_Tickets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Invoiced_Item_Cancellation_Tickets_ManyArgs = {
  updates: Array<Invoiced_Item_Cancellation_Tickets_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Invoiced_Item_ManyArgs = {
  updates: Array<Invoiced_Item_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_IssueArgs = {
  _inc?: InputMaybe<Issue_Inc_Input>;
  _set?: InputMaybe<Issue_Set_Input>;
  where: Issue_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Issue_By_PkArgs = {
  _inc?: InputMaybe<Issue_Inc_Input>;
  _set?: InputMaybe<Issue_Set_Input>;
  pk_columns: Issue_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Issue_ManyArgs = {
  updates: Array<Issue_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Job_StateArgs = {
  _set?: InputMaybe<Job_State_Set_Input>;
  where: Job_State_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Job_State_By_PkArgs = {
  _set?: InputMaybe<Job_State_Set_Input>;
  pk_columns: Job_State_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Job_State_ManyArgs = {
  updates: Array<Job_State_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Job_TypeArgs = {
  _set?: InputMaybe<Job_Type_Set_Input>;
  where: Job_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Type_By_PkArgs = {
  _set?: InputMaybe<Job_Type_Set_Input>;
  pk_columns: Job_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Type_ManyArgs = {
  updates: Array<Job_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Type_TemplateArgs = {
  _set?: InputMaybe<Job_Type_Template_Set_Input>;
  where: Job_Type_Template_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Type_Template_By_PkArgs = {
  _set?: InputMaybe<Job_Type_Template_Set_Input>;
  pk_columns: Job_Type_Template_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Type_Template_ManyArgs = {
  updates: Array<Job_Type_Template_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_JobsArgs = {
  _set?: InputMaybe<Jobs_Set_Input>;
  where: Jobs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Jobs_By_PkArgs = {
  _set?: InputMaybe<Jobs_Set_Input>;
  pk_columns: Jobs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Jobs_ManyArgs = {
  updates: Array<Jobs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Jobs_State_FlowArgs = {
  _set?: InputMaybe<Jobs_State_Flow_Set_Input>;
  where: Jobs_State_Flow_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Jobs_State_Flow_By_PkArgs = {
  _set?: InputMaybe<Jobs_State_Flow_Set_Input>;
  pk_columns: Jobs_State_Flow_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Jobs_State_Flow_ManyArgs = {
  updates: Array<Jobs_State_Flow_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Limit_Purchase_OrderArgs = {
  _inc?: InputMaybe<Limit_Purchase_Order_Inc_Input>;
  _set?: InputMaybe<Limit_Purchase_Order_Set_Input>;
  where: Limit_Purchase_Order_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Limit_Purchase_Order_By_PkArgs = {
  _inc?: InputMaybe<Limit_Purchase_Order_Inc_Input>;
  _set?: InputMaybe<Limit_Purchase_Order_Set_Input>;
  pk_columns: Limit_Purchase_Order_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Limit_Purchase_Order_LogsArgs = {
  _inc?: InputMaybe<Limit_Purchase_Order_Logs_Inc_Input>;
  _set?: InputMaybe<Limit_Purchase_Order_Logs_Set_Input>;
  where: Limit_Purchase_Order_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Limit_Purchase_Order_Logs_By_PkArgs = {
  _inc?: InputMaybe<Limit_Purchase_Order_Logs_Inc_Input>;
  _set?: InputMaybe<Limit_Purchase_Order_Logs_Set_Input>;
  pk_columns: Limit_Purchase_Order_Logs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Limit_Purchase_Order_Logs_ManyArgs = {
  updates: Array<Limit_Purchase_Order_Logs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Limit_Purchase_Order_ManyArgs = {
  updates: Array<Limit_Purchase_Order_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_LocalitiesArgs = {
  _inc?: InputMaybe<Localities_Inc_Input>;
  _set?: InputMaybe<Localities_Set_Input>;
  where: Localities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Localities_By_PkArgs = {
  _inc?: InputMaybe<Localities_Inc_Input>;
  _set?: InputMaybe<Localities_Set_Input>;
  pk_columns: Localities_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Localities_ManyArgs = {
  updates: Array<Localities_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Login_TypeArgs = {
  _set?: InputMaybe<Login_Type_Set_Input>;
  where: Login_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Login_Type_By_PkArgs = {
  _set?: InputMaybe<Login_Type_Set_Input>;
  pk_columns: Login_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Login_Type_ManyArgs = {
  updates: Array<Login_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Lpo_ExceptionArgs = {
  _inc?: InputMaybe<Lpo_Exception_Inc_Input>;
  _set?: InputMaybe<Lpo_Exception_Set_Input>;
  where: Lpo_Exception_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Lpo_Exception_By_PkArgs = {
  _inc?: InputMaybe<Lpo_Exception_Inc_Input>;
  _set?: InputMaybe<Lpo_Exception_Set_Input>;
  pk_columns: Lpo_Exception_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Lpo_Exception_ManyArgs = {
  updates: Array<Lpo_Exception_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Master_SlotArgs = {
  _append?: InputMaybe<Master_Slot_Append_Input>;
  _delete_at_path?: InputMaybe<Master_Slot_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Master_Slot_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Master_Slot_Delete_Key_Input>;
  _inc?: InputMaybe<Master_Slot_Inc_Input>;
  _prepend?: InputMaybe<Master_Slot_Prepend_Input>;
  _set?: InputMaybe<Master_Slot_Set_Input>;
  where: Master_Slot_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Master_Slot_By_PkArgs = {
  _append?: InputMaybe<Master_Slot_Append_Input>;
  _delete_at_path?: InputMaybe<Master_Slot_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Master_Slot_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Master_Slot_Delete_Key_Input>;
  _inc?: InputMaybe<Master_Slot_Inc_Input>;
  _prepend?: InputMaybe<Master_Slot_Prepend_Input>;
  _set?: InputMaybe<Master_Slot_Set_Input>;
  pk_columns: Master_Slot_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Master_Slot_ManyArgs = {
  updates: Array<Master_Slot_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Master_Slot_PauseArgs = {
  _set?: InputMaybe<Master_Slot_Pause_Set_Input>;
  where: Master_Slot_Pause_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Master_Slot_Pause_By_PkArgs = {
  _set?: InputMaybe<Master_Slot_Pause_Set_Input>;
  pk_columns: Master_Slot_Pause_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Master_Slot_Pause_ManyArgs = {
  updates: Array<Master_Slot_Pause_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Omc_TypeArgs = {
  _set?: InputMaybe<Omc_Type_Set_Input>;
  where: Omc_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Omc_Type_By_PkArgs = {
  _set?: InputMaybe<Omc_Type_Set_Input>;
  pk_columns: Omc_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Omc_Type_ManyArgs = {
  updates: Array<Omc_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Order_PhotosArgs = {
  _set?: InputMaybe<Order_Photos_Set_Input>;
  where: Order_Photos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Photos_By_PkArgs = {
  _set?: InputMaybe<Order_Photos_Set_Input>;
  pk_columns: Order_Photos_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Photos_ManyArgs = {
  updates: Array<Order_Photos_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Order_SchedulerArgs = {
  _inc?: InputMaybe<Order_Scheduler_Inc_Input>;
  _set?: InputMaybe<Order_Scheduler_Set_Input>;
  where: Order_Scheduler_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Scheduler_By_PkArgs = {
  _inc?: InputMaybe<Order_Scheduler_Inc_Input>;
  _set?: InputMaybe<Order_Scheduler_Set_Input>;
  pk_columns: Order_Scheduler_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Scheduler_Customer_AssetArgs = {
  _set?: InputMaybe<Order_Scheduler_Customer_Asset_Set_Input>;
  where: Order_Scheduler_Customer_Asset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Scheduler_Customer_Asset_By_PkArgs = {
  _set?: InputMaybe<Order_Scheduler_Customer_Asset_Set_Input>;
  pk_columns: Order_Scheduler_Customer_Asset_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Scheduler_Customer_Asset_ManyArgs = {
  updates: Array<Order_Scheduler_Customer_Asset_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Scheduler_Daily_FrequencyArgs = {
  _inc?: InputMaybe<Order_Scheduler_Daily_Frequency_Inc_Input>;
  _set?: InputMaybe<Order_Scheduler_Daily_Frequency_Set_Input>;
  where: Order_Scheduler_Daily_Frequency_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Scheduler_Daily_Frequency_By_PkArgs = {
  _inc?: InputMaybe<Order_Scheduler_Daily_Frequency_Inc_Input>;
  _set?: InputMaybe<Order_Scheduler_Daily_Frequency_Set_Input>;
  pk_columns: Order_Scheduler_Daily_Frequency_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Scheduler_Daily_Frequency_ManyArgs = {
  updates: Array<Order_Scheduler_Daily_Frequency_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Scheduler_ManyArgs = {
  updates: Array<Order_Scheduler_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Order_TypeArgs = {
  _set?: InputMaybe<Order_Type_Set_Input>;
  where: Order_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Type_By_PkArgs = {
  _set?: InputMaybe<Order_Type_Set_Input>;
  pk_columns: Order_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Type_ManyArgs = {
  updates: Array<Order_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_OrganizationArgs = {
  _inc?: InputMaybe<Organization_Inc_Input>;
  _set?: InputMaybe<Organization_Set_Input>;
  where: Organization_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_AddressArgs = {
  _set?: InputMaybe<Organization_Address_Set_Input>;
  where: Organization_Address_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Address_By_PkArgs = {
  _set?: InputMaybe<Organization_Address_Set_Input>;
  pk_columns: Organization_Address_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Address_ManyArgs = {
  updates: Array<Organization_Address_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Audit_LogArgs = {
  _append?: InputMaybe<Organization_Audit_Log_Append_Input>;
  _delete_at_path?: InputMaybe<Organization_Audit_Log_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Organization_Audit_Log_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Organization_Audit_Log_Delete_Key_Input>;
  _prepend?: InputMaybe<Organization_Audit_Log_Prepend_Input>;
  _set?: InputMaybe<Organization_Audit_Log_Set_Input>;
  where: Organization_Audit_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Audit_Log_By_PkArgs = {
  _append?: InputMaybe<Organization_Audit_Log_Append_Input>;
  _delete_at_path?: InputMaybe<Organization_Audit_Log_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Organization_Audit_Log_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Organization_Audit_Log_Delete_Key_Input>;
  _prepend?: InputMaybe<Organization_Audit_Log_Prepend_Input>;
  _set?: InputMaybe<Organization_Audit_Log_Set_Input>;
  pk_columns: Organization_Audit_Log_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Audit_Log_ManyArgs = {
  updates: Array<Organization_Audit_Log_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_By_PkArgs = {
  _inc?: InputMaybe<Organization_Inc_Input>;
  _set?: InputMaybe<Organization_Set_Input>;
  pk_columns: Organization_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Commission_Product_Variation_TypeArgs = {
  _set?: InputMaybe<Organization_Commission_Product_Variation_Type_Set_Input>;
  where: Organization_Commission_Product_Variation_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Commission_Product_Variation_Type_By_PkArgs = {
  _set?: InputMaybe<Organization_Commission_Product_Variation_Type_Set_Input>;
  pk_columns: Organization_Commission_Product_Variation_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Commission_Product_Variation_Type_ManyArgs = {
  updates: Array<Organization_Commission_Product_Variation_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_ConfigurationArgs = {
  _set?: InputMaybe<Organization_Configuration_Set_Input>;
  where: Organization_Configuration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Configuration_By_PkArgs = {
  _set?: InputMaybe<Organization_Configuration_Set_Input>;
  pk_columns: Organization_Configuration_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Configuration_ManyArgs = {
  updates: Array<Organization_Configuration_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_ManyArgs = {
  updates: Array<Organization_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Product_Variation_DiscountArgs = {
  _inc?: InputMaybe<Organization_Product_Variation_Discount_Inc_Input>;
  _set?: InputMaybe<Organization_Product_Variation_Discount_Set_Input>;
  where: Organization_Product_Variation_Discount_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Product_Variation_Discount_By_PkArgs = {
  _inc?: InputMaybe<Organization_Product_Variation_Discount_Inc_Input>;
  _set?: InputMaybe<Organization_Product_Variation_Discount_Set_Input>;
  pk_columns: Organization_Product_Variation_Discount_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Product_Variation_Discount_HistoryArgs = {
  _inc?: InputMaybe<Organization_Product_Variation_Discount_History_Inc_Input>;
  _set?: InputMaybe<Organization_Product_Variation_Discount_History_Set_Input>;
  where: Organization_Product_Variation_Discount_History_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Product_Variation_Discount_History_By_PkArgs = {
  _inc?: InputMaybe<Organization_Product_Variation_Discount_History_Inc_Input>;
  _set?: InputMaybe<Organization_Product_Variation_Discount_History_Set_Input>;
  pk_columns: Organization_Product_Variation_Discount_History_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Product_Variation_Discount_History_ManyArgs = {
  updates: Array<Organization_Product_Variation_Discount_History_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Product_Variation_Discount_ManyArgs = {
  updates: Array<Organization_Product_Variation_Discount_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Sales_ProjectionArgs = {
  _inc?: InputMaybe<Organization_Sales_Projection_Inc_Input>;
  _set?: InputMaybe<Organization_Sales_Projection_Set_Input>;
  where: Organization_Sales_Projection_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Sales_Projection_By_PkArgs = {
  _inc?: InputMaybe<Organization_Sales_Projection_Inc_Input>;
  _set?: InputMaybe<Organization_Sales_Projection_Set_Input>;
  pk_columns: Organization_Sales_Projection_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Sales_Projection_ManyArgs = {
  updates: Array<Organization_Sales_Projection_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_TimingArgs = {
  _set?: InputMaybe<Organization_Timing_Set_Input>;
  where: Organization_Timing_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Timing_By_PkArgs = {
  _set?: InputMaybe<Organization_Timing_Set_Input>;
  pk_columns: Organization_Timing_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Timing_ManyArgs = {
  updates: Array<Organization_Timing_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_TypeArgs = {
  _set?: InputMaybe<Organization_Type_Set_Input>;
  where: Organization_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Type_By_PkArgs = {
  _set?: InputMaybe<Organization_Type_Set_Input>;
  pk_columns: Organization_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Type_ManyArgs = {
  updates: Array<Organization_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_UserArgs = {
  _inc?: InputMaybe<Organization_User_Inc_Input>;
  _set?: InputMaybe<Organization_User_Set_Input>;
  where: Organization_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_User_By_PkArgs = {
  _inc?: InputMaybe<Organization_User_Inc_Input>;
  _set?: InputMaybe<Organization_User_Set_Input>;
  pk_columns: Organization_User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_User_CommissionArgs = {
  _set?: InputMaybe<Organization_User_Commission_Set_Input>;
  where: Organization_User_Commission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_User_Commission_By_PkArgs = {
  _set?: InputMaybe<Organization_User_Commission_Set_Input>;
  pk_columns: Organization_User_Commission_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_User_Commission_ManyArgs = {
  updates: Array<Organization_User_Commission_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_User_DocumentArgs = {
  _set?: InputMaybe<Organization_User_Document_Set_Input>;
  where: Organization_User_Document_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_User_Document_By_PkArgs = {
  _set?: InputMaybe<Organization_User_Document_Set_Input>;
  pk_columns: Organization_User_Document_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_User_Document_ManyArgs = {
  updates: Array<Organization_User_Document_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_User_ManyArgs = {
  updates: Array<Organization_User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_User_PermissionArgs = {
  _set?: InputMaybe<Organization_User_Permission_Set_Input>;
  where: Organization_User_Permission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_User_Permission_By_PkArgs = {
  _set?: InputMaybe<Organization_User_Permission_Set_Input>;
  pk_columns: Organization_User_Permission_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_User_Permission_ManyArgs = {
  updates: Array<Organization_User_Permission_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_User_SubsidiaryArgs = {
  _set?: InputMaybe<Organization_User_Subsidiary_Set_Input>;
  where: Organization_User_Subsidiary_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_User_Subsidiary_By_PkArgs = {
  _set?: InputMaybe<Organization_User_Subsidiary_Set_Input>;
  pk_columns: Organization_User_Subsidiary_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_User_Subsidiary_ManyArgs = {
  updates: Array<Organization_User_Subsidiary_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_User_TypeArgs = {
  _set?: InputMaybe<Organization_User_Type_Set_Input>;
  where: Organization_User_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_User_Type_By_PkArgs = {
  _set?: InputMaybe<Organization_User_Type_Set_Input>;
  pk_columns: Organization_User_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_User_Type_ManyArgs = {
  updates: Array<Organization_User_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ownership_TypeArgs = {
  _set?: InputMaybe<Ownership_Type_Set_Input>;
  where: Ownership_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ownership_Type_By_PkArgs = {
  _set?: InputMaybe<Ownership_Type_Set_Input>;
  pk_columns: Ownership_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ownership_Type_ManyArgs = {
  updates: Array<Ownership_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PartnerArgs = {
  _inc?: InputMaybe<Partner_Inc_Input>;
  _set?: InputMaybe<Partner_Set_Input>;
  where: Partner_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_AddressArgs = {
  _inc?: InputMaybe<Partner_Address_Inc_Input>;
  _set?: InputMaybe<Partner_Address_Set_Input>;
  where: Partner_Address_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Address_By_PkArgs = {
  _inc?: InputMaybe<Partner_Address_Inc_Input>;
  _set?: InputMaybe<Partner_Address_Set_Input>;
  pk_columns: Partner_Address_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Address_ManyArgs = {
  updates: Array<Partner_Address_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Bank_DetailsArgs = {
  _set?: InputMaybe<Partner_Bank_Details_Set_Input>;
  where: Partner_Bank_Details_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Bank_Details_By_PkArgs = {
  _set?: InputMaybe<Partner_Bank_Details_Set_Input>;
  pk_columns: Partner_Bank_Details_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Bank_Details_ManyArgs = {
  updates: Array<Partner_Bank_Details_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_By_PkArgs = {
  _inc?: InputMaybe<Partner_Inc_Input>;
  _set?: InputMaybe<Partner_Set_Input>;
  pk_columns: Partner_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_CommissionArgs = {
  _set?: InputMaybe<Partner_Commission_Set_Input>;
  where: Partner_Commission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Commission_By_PkArgs = {
  _set?: InputMaybe<Partner_Commission_Set_Input>;
  pk_columns: Partner_Commission_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Commission_ManyArgs = {
  updates: Array<Partner_Commission_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Commission_Product_Variation_TypeArgs = {
  _set?: InputMaybe<Partner_Commission_Product_Variation_Type_Set_Input>;
  where: Partner_Commission_Product_Variation_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Commission_Product_Variation_Type_By_PkArgs = {
  _set?: InputMaybe<Partner_Commission_Product_Variation_Type_Set_Input>;
  pk_columns: Partner_Commission_Product_Variation_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Commission_Product_Variation_Type_ManyArgs = {
  updates: Array<Partner_Commission_Product_Variation_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Contact_TypeArgs = {
  _set?: InputMaybe<Partner_Contact_Type_Set_Input>;
  where: Partner_Contact_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Contact_Type_By_PkArgs = {
  _set?: InputMaybe<Partner_Contact_Type_Set_Input>;
  pk_columns: Partner_Contact_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Contact_Type_ManyArgs = {
  updates: Array<Partner_Contact_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_LocalitiesArgs = {
  _set?: InputMaybe<Partner_Localities_Set_Input>;
  where: Partner_Localities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Localities_By_PkArgs = {
  _set?: InputMaybe<Partner_Localities_Set_Input>;
  pk_columns: Partner_Localities_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Localities_ManyArgs = {
  updates: Array<Partner_Localities_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Localities_SlotsArgs = {
  _inc?: InputMaybe<Partner_Localities_Slots_Inc_Input>;
  _set?: InputMaybe<Partner_Localities_Slots_Set_Input>;
  where: Partner_Localities_Slots_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Localities_Slots_By_PkArgs = {
  _inc?: InputMaybe<Partner_Localities_Slots_Inc_Input>;
  _set?: InputMaybe<Partner_Localities_Slots_Set_Input>;
  pk_columns: Partner_Localities_Slots_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Localities_Slots_ManyArgs = {
  updates: Array<Partner_Localities_Slots_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_ManyArgs = {
  updates: Array<Partner_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_OrderArgs = {
  _inc?: InputMaybe<Partner_Order_Inc_Input>;
  _set?: InputMaybe<Partner_Order_Set_Input>;
  where: Partner_Order_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Order_By_PkArgs = {
  _inc?: InputMaybe<Partner_Order_Inc_Input>;
  _set?: InputMaybe<Partner_Order_Set_Input>;
  pk_columns: Partner_Order_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Order_Customer_AssetArgs = {
  _inc?: InputMaybe<Partner_Order_Customer_Asset_Inc_Input>;
  _set?: InputMaybe<Partner_Order_Customer_Asset_Set_Input>;
  where: Partner_Order_Customer_Asset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Order_Customer_Asset_By_PkArgs = {
  _inc?: InputMaybe<Partner_Order_Customer_Asset_Inc_Input>;
  _set?: InputMaybe<Partner_Order_Customer_Asset_Set_Input>;
  pk_columns: Partner_Order_Customer_Asset_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Order_Customer_Asset_ManyArgs = {
  updates: Array<Partner_Order_Customer_Asset_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Order_ItemArgs = {
  _inc?: InputMaybe<Partner_Order_Item_Inc_Input>;
  _set?: InputMaybe<Partner_Order_Item_Set_Input>;
  where: Partner_Order_Item_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Order_Item_By_PkArgs = {
  _inc?: InputMaybe<Partner_Order_Item_Inc_Input>;
  _set?: InputMaybe<Partner_Order_Item_Set_Input>;
  pk_columns: Partner_Order_Item_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Order_Item_CommissionArgs = {
  _inc?: InputMaybe<Partner_Order_Item_Commission_Inc_Input>;
  _set?: InputMaybe<Partner_Order_Item_Commission_Set_Input>;
  where: Partner_Order_Item_Commission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Order_Item_Commission_By_PkArgs = {
  _inc?: InputMaybe<Partner_Order_Item_Commission_Inc_Input>;
  _set?: InputMaybe<Partner_Order_Item_Commission_Set_Input>;
  pk_columns: Partner_Order_Item_Commission_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Order_Item_Commission_ManyArgs = {
  updates: Array<Partner_Order_Item_Commission_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Order_Item_ManyArgs = {
  updates: Array<Partner_Order_Item_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Order_Item_StateArgs = {
  _set?: InputMaybe<Partner_Order_Item_State_Set_Input>;
  where: Partner_Order_Item_State_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Order_Item_State_By_PkArgs = {
  _set?: InputMaybe<Partner_Order_Item_State_Set_Input>;
  pk_columns: Partner_Order_Item_State_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Order_Item_State_ManyArgs = {
  updates: Array<Partner_Order_Item_State_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Order_Item_StateflowArgs = {
  _set?: InputMaybe<Partner_Order_Item_Stateflow_Set_Input>;
  where: Partner_Order_Item_Stateflow_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Order_Item_Stateflow_By_PkArgs = {
  _set?: InputMaybe<Partner_Order_Item_Stateflow_Set_Input>;
  pk_columns: Partner_Order_Item_Stateflow_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Order_Item_Stateflow_ManyArgs = {
  updates: Array<Partner_Order_Item_Stateflow_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Order_Item_Test_CategoryArgs = {
  _set?: InputMaybe<Partner_Order_Item_Test_Category_Set_Input>;
  where: Partner_Order_Item_Test_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Order_Item_Test_Category_By_PkArgs = {
  _set?: InputMaybe<Partner_Order_Item_Test_Category_Set_Input>;
  pk_columns: Partner_Order_Item_Test_Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Order_Item_Test_Category_ManyArgs = {
  updates: Array<Partner_Order_Item_Test_Category_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Order_Item_Test_ResultsArgs = {
  _set?: InputMaybe<Partner_Order_Item_Test_Results_Set_Input>;
  where: Partner_Order_Item_Test_Results_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Order_Item_Test_Results_By_PkArgs = {
  _set?: InputMaybe<Partner_Order_Item_Test_Results_Set_Input>;
  pk_columns: Partner_Order_Item_Test_Results_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Order_Item_Test_Results_ManyArgs = {
  updates: Array<Partner_Order_Item_Test_Results_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Order_Item_Test_Results_PhotosArgs = {
  _set?: InputMaybe<Partner_Order_Item_Test_Results_Photos_Set_Input>;
  where: Partner_Order_Item_Test_Results_Photos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Order_Item_Test_Results_Photos_By_PkArgs = {
  _set?: InputMaybe<Partner_Order_Item_Test_Results_Photos_Set_Input>;
  pk_columns: Partner_Order_Item_Test_Results_Photos_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Order_Item_Test_Results_Photos_ManyArgs = {
  updates: Array<Partner_Order_Item_Test_Results_Photos_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Order_Item_ValueArgs = {
  _set?: InputMaybe<Partner_Order_Item_Value_Set_Input>;
  where: Partner_Order_Item_Value_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Order_Item_Value_By_PkArgs = {
  _set?: InputMaybe<Partner_Order_Item_Value_Set_Input>;
  pk_columns: Partner_Order_Item_Value_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Order_Item_Value_ManyArgs = {
  updates: Array<Partner_Order_Item_Value_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Order_ManyArgs = {
  updates: Array<Partner_Order_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Order_Partner_User_DocumentArgs = {
  _set?: InputMaybe<Partner_Order_Partner_User_Document_Set_Input>;
  where: Partner_Order_Partner_User_Document_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Order_Partner_User_Document_By_PkArgs = {
  _set?: InputMaybe<Partner_Order_Partner_User_Document_Set_Input>;
  pk_columns: Partner_Order_Partner_User_Document_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Order_Partner_User_Document_ManyArgs = {
  updates: Array<Partner_Order_Partner_User_Document_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Order_StateArgs = {
  _set?: InputMaybe<Partner_Order_State_Set_Input>;
  where: Partner_Order_State_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Order_State_By_PkArgs = {
  _set?: InputMaybe<Partner_Order_State_Set_Input>;
  pk_columns: Partner_Order_State_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Order_State_ManyArgs = {
  updates: Array<Partner_Order_State_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Order_StateflowArgs = {
  _set?: InputMaybe<Partner_Order_Stateflow_Set_Input>;
  where: Partner_Order_Stateflow_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Order_Stateflow_By_PkArgs = {
  _set?: InputMaybe<Partner_Order_Stateflow_Set_Input>;
  pk_columns: Partner_Order_Stateflow_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Order_Stateflow_ManyArgs = {
  updates: Array<Partner_Order_Stateflow_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_PaymentArgs = {
  _inc?: InputMaybe<Partner_Payment_Inc_Input>;
  _set?: InputMaybe<Partner_Payment_Set_Input>;
  where: Partner_Payment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Payment_By_PkArgs = {
  _inc?: InputMaybe<Partner_Payment_Inc_Input>;
  _set?: InputMaybe<Partner_Payment_Set_Input>;
  pk_columns: Partner_Payment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Payment_ManyArgs = {
  updates: Array<Partner_Payment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_ProductArgs = {
  _set?: InputMaybe<Partner_Product_Set_Input>;
  where: Partner_Product_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Product_By_PkArgs = {
  _set?: InputMaybe<Partner_Product_Set_Input>;
  pk_columns: Partner_Product_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Product_ManyArgs = {
  updates: Array<Partner_Product_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_RelationshipArgs = {
  _set?: InputMaybe<Partner_Relationship_Set_Input>;
  where: Partner_Relationship_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Relationship_By_PkArgs = {
  _set?: InputMaybe<Partner_Relationship_Set_Input>;
  pk_columns: Partner_Relationship_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Relationship_ManyArgs = {
  updates: Array<Partner_Relationship_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_SellerArgs = {
  _set?: InputMaybe<Partner_Seller_Set_Input>;
  where: Partner_Seller_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Seller_By_PkArgs = {
  _set?: InputMaybe<Partner_Seller_Set_Input>;
  pk_columns: Partner_Seller_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Seller_ManyArgs = {
  updates: Array<Partner_Seller_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Seller_TypeArgs = {
  _set?: InputMaybe<Partner_Seller_Type_Set_Input>;
  where: Partner_Seller_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Seller_Type_By_PkArgs = {
  _set?: InputMaybe<Partner_Seller_Type_Set_Input>;
  pk_columns: Partner_Seller_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Seller_Type_ManyArgs = {
  updates: Array<Partner_Seller_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Signing_AuthorityArgs = {
  _set?: InputMaybe<Partner_Signing_Authority_Set_Input>;
  where: Partner_Signing_Authority_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Signing_Authority_By_PkArgs = {
  _set?: InputMaybe<Partner_Signing_Authority_Set_Input>;
  pk_columns: Partner_Signing_Authority_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Signing_Authority_ManyArgs = {
  updates: Array<Partner_Signing_Authority_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_TimingArgs = {
  _set?: InputMaybe<Partner_Timing_Set_Input>;
  where: Partner_Timing_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Timing_By_PkArgs = {
  _set?: InputMaybe<Partner_Timing_Set_Input>;
  pk_columns: Partner_Timing_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Timing_ManyArgs = {
  updates: Array<Partner_Timing_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_TypeArgs = {
  _set?: InputMaybe<Partner_Type_Set_Input>;
  where: Partner_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Type_By_PkArgs = {
  _set?: InputMaybe<Partner_Type_Set_Input>;
  pk_columns: Partner_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Type_ManyArgs = {
  updates: Array<Partner_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_UserArgs = {
  _set?: InputMaybe<Partner_User_Set_Input>;
  where: Partner_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_User_By_PkArgs = {
  _set?: InputMaybe<Partner_User_Set_Input>;
  pk_columns: Partner_User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_User_DocumentArgs = {
  _set?: InputMaybe<Partner_User_Document_Set_Input>;
  where: Partner_User_Document_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_User_Document_By_PkArgs = {
  _set?: InputMaybe<Partner_User_Document_Set_Input>;
  pk_columns: Partner_User_Document_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_User_Document_ManyArgs = {
  updates: Array<Partner_User_Document_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_User_ManyArgs = {
  updates: Array<Partner_User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_User_PermissionArgs = {
  _set?: InputMaybe<Partner_User_Permission_Set_Input>;
  where: Partner_User_Permission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_User_Permission_By_PkArgs = {
  _set?: InputMaybe<Partner_User_Permission_Set_Input>;
  pk_columns: Partner_User_Permission_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_User_Permission_ManyArgs = {
  updates: Array<Partner_User_Permission_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_VehicleArgs = {
  _set?: InputMaybe<Partner_Vehicle_Set_Input>;
  where: Partner_Vehicle_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Vehicle_By_PkArgs = {
  _set?: InputMaybe<Partner_Vehicle_Set_Input>;
  pk_columns: Partner_Vehicle_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Vehicle_ManyArgs = {
  updates: Array<Partner_Vehicle_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Vehicle_StateArgs = {
  _set?: InputMaybe<Partner_Vehicle_State_Set_Input>;
  where: Partner_Vehicle_State_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Vehicle_State_By_PkArgs = {
  _set?: InputMaybe<Partner_Vehicle_State_Set_Input>;
  pk_columns: Partner_Vehicle_State_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Vehicle_State_ManyArgs = {
  updates: Array<Partner_Vehicle_State_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_TypeArgs = {
  _set?: InputMaybe<Payment_Type_Set_Input>;
  where: Payment_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Type_By_PkArgs = {
  _set?: InputMaybe<Payment_Type_Set_Input>;
  pk_columns: Payment_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Type_ManyArgs = {
  updates: Array<Payment_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Period_FrequencyArgs = {
  _set?: InputMaybe<Period_Frequency_Set_Input>;
  where: Period_Frequency_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Period_Frequency_By_PkArgs = {
  _set?: InputMaybe<Period_Frequency_Set_Input>;
  pk_columns: Period_Frequency_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Period_Frequency_ManyArgs = {
  updates: Array<Period_Frequency_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PermissionArgs = {
  _set?: InputMaybe<Permission_Set_Input>;
  where: Permission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Permission_By_PkArgs = {
  _set?: InputMaybe<Permission_Set_Input>;
  pk_columns: Permission_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Permission_ManyArgs = {
  updates: Array<Permission_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PermitArgs = {
  _set?: InputMaybe<Permit_Set_Input>;
  where: Permit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Permit_By_PkArgs = {
  _set?: InputMaybe<Permit_Set_Input>;
  pk_columns: Permit_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Permit_ManyArgs = {
  updates: Array<Permit_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Photo_TypeArgs = {
  _set?: InputMaybe<Photo_Type_Set_Input>;
  where: Photo_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Photo_Type_By_PkArgs = {
  _set?: InputMaybe<Photo_Type_Set_Input>;
  pk_columns: Photo_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Photo_Type_ManyArgs = {
  updates: Array<Photo_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Planning_Audit_LogArgs = {
  _append?: InputMaybe<Planning_Audit_Log_Append_Input>;
  _delete_at_path?: InputMaybe<Planning_Audit_Log_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Planning_Audit_Log_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Planning_Audit_Log_Delete_Key_Input>;
  _prepend?: InputMaybe<Planning_Audit_Log_Prepend_Input>;
  _set?: InputMaybe<Planning_Audit_Log_Set_Input>;
  where: Planning_Audit_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Planning_Audit_Log_By_PkArgs = {
  _append?: InputMaybe<Planning_Audit_Log_Append_Input>;
  _delete_at_path?: InputMaybe<Planning_Audit_Log_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Planning_Audit_Log_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Planning_Audit_Log_Delete_Key_Input>;
  _prepend?: InputMaybe<Planning_Audit_Log_Prepend_Input>;
  _set?: InputMaybe<Planning_Audit_Log_Set_Input>;
  pk_columns: Planning_Audit_Log_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Planning_Audit_Log_ManyArgs = {
  updates: Array<Planning_Audit_Log_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Planning_PeriodArgs = {
  _set?: InputMaybe<Planning_Period_Set_Input>;
  where: Planning_Period_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Planning_Period_By_PkArgs = {
  _set?: InputMaybe<Planning_Period_Set_Input>;
  pk_columns: Planning_Period_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Planning_Period_ManyArgs = {
  updates: Array<Planning_Period_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProductArgs = {
  _set?: InputMaybe<Product_Set_Input>;
  where: Product_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_By_PkArgs = {
  _set?: InputMaybe<Product_Set_Input>;
  pk_columns: Product_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_CommissionArgs = {
  _set?: InputMaybe<Product_Commission_Set_Input>;
  where: Product_Commission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Commission_By_PkArgs = {
  _set?: InputMaybe<Product_Commission_Set_Input>;
  pk_columns: Product_Commission_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Commission_ManyArgs = {
  updates: Array<Product_Commission_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_DocumentArgs = {
  _set?: InputMaybe<Product_Document_Set_Input>;
  where: Product_Document_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Document_By_PkArgs = {
  _set?: InputMaybe<Product_Document_Set_Input>;
  pk_columns: Product_Document_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Document_ManyArgs = {
  updates: Array<Product_Document_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_ManyArgs = {
  updates: Array<Product_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Partner_Localities_PriceArgs = {
  _inc?: InputMaybe<Product_Partner_Localities_Price_Inc_Input>;
  _set?: InputMaybe<Product_Partner_Localities_Price_Set_Input>;
  where: Product_Partner_Localities_Price_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Partner_Localities_Price_By_PkArgs = {
  _inc?: InputMaybe<Product_Partner_Localities_Price_Inc_Input>;
  _set?: InputMaybe<Product_Partner_Localities_Price_Set_Input>;
  pk_columns: Product_Partner_Localities_Price_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Partner_Localities_Price_HistoryArgs = {
  _inc?: InputMaybe<Product_Partner_Localities_Price_History_Inc_Input>;
  _set?: InputMaybe<Product_Partner_Localities_Price_History_Set_Input>;
  where: Product_Partner_Localities_Price_History_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Partner_Localities_Price_History_By_PkArgs = {
  _inc?: InputMaybe<Product_Partner_Localities_Price_History_Inc_Input>;
  _set?: InputMaybe<Product_Partner_Localities_Price_History_Set_Input>;
  pk_columns: Product_Partner_Localities_Price_History_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Partner_Localities_Price_History_ManyArgs = {
  updates: Array<Product_Partner_Localities_Price_History_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Partner_Localities_Price_ManyArgs = {
  updates: Array<Product_Partner_Localities_Price_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_PhotosArgs = {
  _inc?: InputMaybe<Product_Photos_Inc_Input>;
  _set?: InputMaybe<Product_Photos_Set_Input>;
  where: Product_Photos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Photos_By_PkArgs = {
  _inc?: InputMaybe<Product_Photos_Inc_Input>;
  _set?: InputMaybe<Product_Photos_Set_Input>;
  pk_columns: Product_Photos_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Photos_ManyArgs = {
  updates: Array<Product_Photos_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_TypeArgs = {
  _set?: InputMaybe<Product_Type_Set_Input>;
  where: Product_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Type_By_PkArgs = {
  _set?: InputMaybe<Product_Type_Set_Input>;
  pk_columns: Product_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Type_ManyArgs = {
  updates: Array<Product_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_VariationArgs = {
  _set?: InputMaybe<Product_Variation_Set_Input>;
  where: Product_Variation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Variation_By_PkArgs = {
  _set?: InputMaybe<Product_Variation_Set_Input>;
  pk_columns: Product_Variation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Variation_ManyArgs = {
  updates: Array<Product_Variation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Variation_Partner_Localities_SlotsArgs = {
  _inc?: InputMaybe<Product_Variation_Partner_Localities_Slots_Inc_Input>;
  _set?: InputMaybe<Product_Variation_Partner_Localities_Slots_Set_Input>;
  where: Product_Variation_Partner_Localities_Slots_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Variation_Partner_Localities_Slots_By_PkArgs = {
  _inc?: InputMaybe<Product_Variation_Partner_Localities_Slots_Inc_Input>;
  _set?: InputMaybe<Product_Variation_Partner_Localities_Slots_Set_Input>;
  pk_columns: Product_Variation_Partner_Localities_Slots_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Variation_Partner_Localities_Slots_ManyArgs = {
  updates: Array<Product_Variation_Partner_Localities_Slots_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Variation_PhotosArgs = {
  _inc?: InputMaybe<Product_Variation_Photos_Inc_Input>;
  _set?: InputMaybe<Product_Variation_Photos_Set_Input>;
  where: Product_Variation_Photos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Variation_Photos_By_PkArgs = {
  _inc?: InputMaybe<Product_Variation_Photos_Inc_Input>;
  _set?: InputMaybe<Product_Variation_Photos_Set_Input>;
  pk_columns: Product_Variation_Photos_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Variation_Photos_ManyArgs = {
  updates: Array<Product_Variation_Photos_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Variation_Safety_Checklist_CategoryArgs = {
  _set?: InputMaybe<Product_Variation_Safety_Checklist_Category_Set_Input>;
  where: Product_Variation_Safety_Checklist_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Variation_Safety_Checklist_Category_By_PkArgs = {
  _set?: InputMaybe<Product_Variation_Safety_Checklist_Category_Set_Input>;
  pk_columns: Product_Variation_Safety_Checklist_Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Variation_Safety_Checklist_Category_ManyArgs = {
  updates: Array<Product_Variation_Safety_Checklist_Category_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Variation_Test_CategoryArgs = {
  _set?: InputMaybe<Product_Variation_Test_Category_Set_Input>;
  where: Product_Variation_Test_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Variation_Test_Category_By_PkArgs = {
  _set?: InputMaybe<Product_Variation_Test_Category_Set_Input>;
  pk_columns: Product_Variation_Test_Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Variation_Test_Category_ManyArgs = {
  updates: Array<Product_Variation_Test_Category_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Purchase_OrderArgs = {
  _set?: InputMaybe<Purchase_Order_Set_Input>;
  where: Purchase_Order_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Purchase_Order_By_PkArgs = {
  _set?: InputMaybe<Purchase_Order_Set_Input>;
  pk_columns: Purchase_Order_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Purchase_Order_ItemsArgs = {
  _set?: InputMaybe<Purchase_Order_Items_Set_Input>;
  where: Purchase_Order_Items_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Purchase_Order_Items_By_PkArgs = {
  _set?: InputMaybe<Purchase_Order_Items_Set_Input>;
  pk_columns: Purchase_Order_Items_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Purchase_Order_Items_ManyArgs = {
  updates: Array<Purchase_Order_Items_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Purchase_Order_ManyArgs = {
  updates: Array<Purchase_Order_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quantity_Correction_Ticket_StatesArgs = {
  _set?: InputMaybe<Quantity_Correction_Ticket_States_Set_Input>;
  where: Quantity_Correction_Ticket_States_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quantity_Correction_Ticket_States_By_PkArgs = {
  _set?: InputMaybe<Quantity_Correction_Ticket_States_Set_Input>;
  pk_columns: Quantity_Correction_Ticket_States_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quantity_Correction_Ticket_States_ManyArgs = {
  updates: Array<Quantity_Correction_Ticket_States_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quantity_Correction_TicketsArgs = {
  _inc?: InputMaybe<Quantity_Correction_Tickets_Inc_Input>;
  _set?: InputMaybe<Quantity_Correction_Tickets_Set_Input>;
  where: Quantity_Correction_Tickets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quantity_Correction_Tickets_By_PkArgs = {
  _inc?: InputMaybe<Quantity_Correction_Tickets_Inc_Input>;
  _set?: InputMaybe<Quantity_Correction_Tickets_Set_Input>;
  pk_columns: Quantity_Correction_Tickets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quantity_Correction_Tickets_ManyArgs = {
  updates: Array<Quantity_Correction_Tickets_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Reason_TypeArgs = {
  _set?: InputMaybe<Reason_Type_Set_Input>;
  where: Reason_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Reason_Type_By_PkArgs = {
  _set?: InputMaybe<Reason_Type_Set_Input>;
  pk_columns: Reason_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Reason_Type_ManyArgs = {
  updates: Array<Reason_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ReasonsArgs = {
  _inc?: InputMaybe<Reasons_Inc_Input>;
  _set?: InputMaybe<Reasons_Set_Input>;
  where: Reasons_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Reasons_By_PkArgs = {
  _inc?: InputMaybe<Reasons_Inc_Input>;
  _set?: InputMaybe<Reasons_Set_Input>;
  pk_columns: Reasons_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Reasons_ManyArgs = {
  updates: Array<Reasons_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RoleArgs = {
  _set?: InputMaybe<Role_Set_Input>;
  where: Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Role_By_PkArgs = {
  _set?: InputMaybe<Role_Set_Input>;
  pk_columns: Role_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Role_DocumentArgs = {
  _set?: InputMaybe<Role_Document_Set_Input>;
  where: Role_Document_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Role_Document_By_PkArgs = {
  _set?: InputMaybe<Role_Document_Set_Input>;
  pk_columns: Role_Document_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Role_Document_ManyArgs = {
  updates: Array<Role_Document_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Role_ManyArgs = {
  updates: Array<Role_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Safety_ChecklistArgs = {
  _set?: InputMaybe<Safety_Checklist_Set_Input>;
  where: Safety_Checklist_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Safety_Checklist_By_PkArgs = {
  _set?: InputMaybe<Safety_Checklist_Set_Input>;
  pk_columns: Safety_Checklist_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Safety_Checklist_CategoryArgs = {
  _set?: InputMaybe<Safety_Checklist_Category_Set_Input>;
  where: Safety_Checklist_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Safety_Checklist_Category_By_PkArgs = {
  _set?: InputMaybe<Safety_Checklist_Category_Set_Input>;
  pk_columns: Safety_Checklist_Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Safety_Checklist_Category_ManyArgs = {
  updates: Array<Safety_Checklist_Category_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Safety_Checklist_ManyArgs = {
  updates: Array<Safety_Checklist_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Script_TypeArgs = {
  _set?: InputMaybe<Script_Type_Set_Input>;
  where: Script_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Script_Type_By_PkArgs = {
  _set?: InputMaybe<Script_Type_Set_Input>;
  pk_columns: Script_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Script_Type_ManyArgs = {
  updates: Array<Script_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ScriptsArgs = {
  _set?: InputMaybe<Scripts_Set_Input>;
  where: Scripts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Scripts_By_PkArgs = {
  _set?: InputMaybe<Scripts_Set_Input>;
  pk_columns: Scripts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Scripts_ManyArgs = {
  updates: Array<Scripts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ServicesArgs = {
  _inc?: InputMaybe<Services_Inc_Input>;
  _set?: InputMaybe<Services_Set_Input>;
  where: Services_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Services_By_PkArgs = {
  _inc?: InputMaybe<Services_Inc_Input>;
  _set?: InputMaybe<Services_Set_Input>;
  pk_columns: Services_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Services_CategoryArgs = {
  _set?: InputMaybe<Services_Category_Set_Input>;
  where: Services_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Services_Category_By_PkArgs = {
  _set?: InputMaybe<Services_Category_Set_Input>;
  pk_columns: Services_Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Services_Category_ManyArgs = {
  updates: Array<Services_Category_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Services_ManyArgs = {
  updates: Array<Services_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Shift_ScheduleArgs = {
  _set?: InputMaybe<Shift_Schedule_Set_Input>;
  where: Shift_Schedule_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Shift_Schedule_By_PkArgs = {
  _set?: InputMaybe<Shift_Schedule_Set_Input>;
  pk_columns: Shift_Schedule_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Shift_Schedule_DispenserArgs = {
  _set?: InputMaybe<Shift_Schedule_Dispenser_Set_Input>;
  where: Shift_Schedule_Dispenser_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Shift_Schedule_Dispenser_By_PkArgs = {
  _set?: InputMaybe<Shift_Schedule_Dispenser_Set_Input>;
  pk_columns: Shift_Schedule_Dispenser_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Shift_Schedule_Dispenser_ManyArgs = {
  updates: Array<Shift_Schedule_Dispenser_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Shift_Schedule_ManyArgs = {
  updates: Array<Shift_Schedule_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Shift_TemplateArgs = {
  _append?: InputMaybe<Shift_Template_Append_Input>;
  _delete_at_path?: InputMaybe<Shift_Template_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Shift_Template_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Shift_Template_Delete_Key_Input>;
  _inc?: InputMaybe<Shift_Template_Inc_Input>;
  _prepend?: InputMaybe<Shift_Template_Prepend_Input>;
  _set?: InputMaybe<Shift_Template_Set_Input>;
  where: Shift_Template_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Shift_Template_By_PkArgs = {
  _append?: InputMaybe<Shift_Template_Append_Input>;
  _delete_at_path?: InputMaybe<Shift_Template_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Shift_Template_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Shift_Template_Delete_Key_Input>;
  _inc?: InputMaybe<Shift_Template_Inc_Input>;
  _prepend?: InputMaybe<Shift_Template_Prepend_Input>;
  _set?: InputMaybe<Shift_Template_Set_Input>;
  pk_columns: Shift_Template_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Shift_Template_ManyArgs = {
  updates: Array<Shift_Template_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Slab_TypeArgs = {
  _set?: InputMaybe<Slab_Type_Set_Input>;
  where: Slab_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Slab_Type_By_PkArgs = {
  _set?: InputMaybe<Slab_Type_Set_Input>;
  pk_columns: Slab_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Slab_Type_ManyArgs = {
  updates: Array<Slab_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Source_TypeArgs = {
  _set?: InputMaybe<Source_Type_Set_Input>;
  where: Source_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Source_Type_By_PkArgs = {
  _set?: InputMaybe<Source_Type_Set_Input>;
  pk_columns: Source_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Source_Type_ManyArgs = {
  updates: Array<Source_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Spatial_Ref_SysArgs = {
  _inc?: InputMaybe<Spatial_Ref_Sys_Inc_Input>;
  _set?: InputMaybe<Spatial_Ref_Sys_Set_Input>;
  where: Spatial_Ref_Sys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Spatial_Ref_Sys_By_PkArgs = {
  _inc?: InputMaybe<Spatial_Ref_Sys_Inc_Input>;
  _set?: InputMaybe<Spatial_Ref_Sys_Set_Input>;
  pk_columns: Spatial_Ref_Sys_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Spatial_Ref_Sys_ManyArgs = {
  updates: Array<Spatial_Ref_Sys_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_StateArgs = {
  _set?: InputMaybe<State_Set_Input>;
  where: State_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_State_By_PkArgs = {
  _set?: InputMaybe<State_Set_Input>;
  pk_columns: State_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_State_ManyArgs = {
  updates: Array<State_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SubsidiaryArgs = {
  _set?: InputMaybe<Subsidiary_Set_Input>;
  where: Subsidiary_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Subsidiary_By_PkArgs = {
  _set?: InputMaybe<Subsidiary_Set_Input>;
  pk_columns: Subsidiary_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Subsidiary_ManyArgs = {
  updates: Array<Subsidiary_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Support_TicketsArgs = {
  _set?: InputMaybe<Support_Tickets_Set_Input>;
  where: Support_Tickets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Support_Tickets_By_PkArgs = {
  _set?: InputMaybe<Support_Tickets_Set_Input>;
  pk_columns: Support_Tickets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Support_Tickets_CategoryArgs = {
  _set?: InputMaybe<Support_Tickets_Category_Set_Input>;
  where: Support_Tickets_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Support_Tickets_Category_By_PkArgs = {
  _set?: InputMaybe<Support_Tickets_Category_Set_Input>;
  pk_columns: Support_Tickets_Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Support_Tickets_Category_ManyArgs = {
  updates: Array<Support_Tickets_Category_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Support_Tickets_ManyArgs = {
  updates: Array<Support_Tickets_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Support_Tickets_PhotosArgs = {
  _set?: InputMaybe<Support_Tickets_Photos_Set_Input>;
  where: Support_Tickets_Photos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Support_Tickets_Photos_By_PkArgs = {
  _set?: InputMaybe<Support_Tickets_Photos_Set_Input>;
  pk_columns: Support_Tickets_Photos_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Support_Tickets_Photos_ManyArgs = {
  updates: Array<Support_Tickets_Photos_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TagArgs = {
  _set?: InputMaybe<Tag_Set_Input>;
  where: Tag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tag_By_PkArgs = {
  _set?: InputMaybe<Tag_Set_Input>;
  pk_columns: Tag_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tag_ManyArgs = {
  updates: Array<Tag_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tank_TypeArgs = {
  _set?: InputMaybe<Tank_Type_Set_Input>;
  where: Tank_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tank_Type_By_PkArgs = {
  _set?: InputMaybe<Tank_Type_Set_Input>;
  pk_columns: Tank_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tank_Type_ManyArgs = {
  updates: Array<Tank_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TaskArgs = {
  _inc?: InputMaybe<Task_Inc_Input>;
  _set?: InputMaybe<Task_Set_Input>;
  where: Task_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Task_Action_InstructionArgs = {
  _inc?: InputMaybe<Task_Action_Instruction_Inc_Input>;
  _set?: InputMaybe<Task_Action_Instruction_Set_Input>;
  where: Task_Action_Instruction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Task_Action_Instruction_By_PkArgs = {
  _inc?: InputMaybe<Task_Action_Instruction_Inc_Input>;
  _set?: InputMaybe<Task_Action_Instruction_Set_Input>;
  pk_columns: Task_Action_Instruction_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Task_Action_Instruction_ManyArgs = {
  updates: Array<Task_Action_Instruction_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Task_Action_TypeArgs = {
  _set?: InputMaybe<Task_Action_Type_Set_Input>;
  where: Task_Action_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Task_Action_Type_By_PkArgs = {
  _set?: InputMaybe<Task_Action_Type_Set_Input>;
  pk_columns: Task_Action_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Task_Action_Type_ManyArgs = {
  updates: Array<Task_Action_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Task_By_PkArgs = {
  _inc?: InputMaybe<Task_Inc_Input>;
  _set?: InputMaybe<Task_Set_Input>;
  pk_columns: Task_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Task_Cancellation_ReasonsArgs = {
  _set?: InputMaybe<Task_Cancellation_Reasons_Set_Input>;
  where: Task_Cancellation_Reasons_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Task_Cancellation_Reasons_By_PkArgs = {
  _set?: InputMaybe<Task_Cancellation_Reasons_Set_Input>;
  pk_columns: Task_Cancellation_Reasons_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Task_Cancellation_Reasons_ManyArgs = {
  updates: Array<Task_Cancellation_Reasons_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Task_ManyArgs = {
  updates: Array<Task_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Task_StateArgs = {
  _set?: InputMaybe<Task_State_Set_Input>;
  where: Task_State_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Task_State_By_PkArgs = {
  _set?: InputMaybe<Task_State_Set_Input>;
  pk_columns: Task_State_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Task_State_ManyArgs = {
  updates: Array<Task_State_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Task_States_FlowArgs = {
  _set?: InputMaybe<Task_States_Flow_Set_Input>;
  where: Task_States_Flow_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Task_States_Flow_By_PkArgs = {
  _set?: InputMaybe<Task_States_Flow_Set_Input>;
  pk_columns: Task_States_Flow_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Task_States_Flow_ManyArgs = {
  updates: Array<Task_States_Flow_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Task_TypeArgs = {
  _set?: InputMaybe<Task_Type_Set_Input>;
  where: Task_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Task_Type_By_PkArgs = {
  _set?: InputMaybe<Task_Type_Set_Input>;
  pk_columns: Task_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Task_Type_ManyArgs = {
  updates: Array<Task_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Task_ValueArgs = {
  _inc?: InputMaybe<Task_Value_Inc_Input>;
  _set?: InputMaybe<Task_Value_Set_Input>;
  where: Task_Value_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Task_Value_By_PkArgs = {
  _inc?: InputMaybe<Task_Value_Inc_Input>;
  _set?: InputMaybe<Task_Value_Set_Input>;
  pk_columns: Task_Value_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Task_Value_ManyArgs = {
  updates: Array<Task_Value_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TestArgs = {
  _inc?: InputMaybe<Test_Inc_Input>;
  _set?: InputMaybe<Test_Set_Input>;
  where: Test_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Test_By_PkArgs = {
  _inc?: InputMaybe<Test_Inc_Input>;
  _set?: InputMaybe<Test_Set_Input>;
  pk_columns: Test_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Test_CategoryArgs = {
  _set?: InputMaybe<Test_Category_Set_Input>;
  where: Test_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Test_Category_By_PkArgs = {
  _set?: InputMaybe<Test_Category_Set_Input>;
  pk_columns: Test_Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Test_Category_ManyArgs = {
  updates: Array<Test_Category_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Test_ManyArgs = {
  updates: Array<Test_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ticket_StateArgs = {
  _set?: InputMaybe<Ticket_State_Set_Input>;
  where: Ticket_State_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ticket_State_By_PkArgs = {
  _set?: InputMaybe<Ticket_State_Set_Input>;
  pk_columns: Ticket_State_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ticket_State_ManyArgs = {
  updates: Array<Ticket_State_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ticket_TypeArgs = {
  _set?: InputMaybe<Ticket_Type_Set_Input>;
  where: Ticket_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ticket_Type_By_PkArgs = {
  _set?: InputMaybe<Ticket_Type_Set_Input>;
  pk_columns: Ticket_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ticket_Type_ManyArgs = {
  updates: Array<Ticket_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TicketsArgs = {
  _set?: InputMaybe<Tickets_Set_Input>;
  where: Tickets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tickets_By_PkArgs = {
  _set?: InputMaybe<Tickets_Set_Input>;
  pk_columns: Tickets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tickets_ManyArgs = {
  updates: Array<Tickets_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Totalizer_Correction_Ticket_StatesArgs = {
  _set?: InputMaybe<Totalizer_Correction_Ticket_States_Set_Input>;
  where: Totalizer_Correction_Ticket_States_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Totalizer_Correction_Ticket_States_By_PkArgs = {
  _set?: InputMaybe<Totalizer_Correction_Ticket_States_Set_Input>;
  pk_columns: Totalizer_Correction_Ticket_States_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Totalizer_Correction_Ticket_States_ManyArgs = {
  updates: Array<Totalizer_Correction_Ticket_States_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Totalizer_Correction_TicketsArgs = {
  _inc?: InputMaybe<Totalizer_Correction_Tickets_Inc_Input>;
  _set?: InputMaybe<Totalizer_Correction_Tickets_Set_Input>;
  where: Totalizer_Correction_Tickets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Totalizer_Correction_Tickets_By_PkArgs = {
  _inc?: InputMaybe<Totalizer_Correction_Tickets_Inc_Input>;
  _set?: InputMaybe<Totalizer_Correction_Tickets_Set_Input>;
  pk_columns: Totalizer_Correction_Tickets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Totalizer_Correction_Tickets_ManyArgs = {
  updates: Array<Totalizer_Correction_Tickets_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Transaction_TypeArgs = {
  _set?: InputMaybe<Transaction_Type_Set_Input>;
  where: Transaction_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Transaction_Type_By_PkArgs = {
  _set?: InputMaybe<Transaction_Type_Set_Input>;
  pk_columns: Transaction_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Transaction_Type_ManyArgs = {
  updates: Array<Transaction_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TripArgs = {
  _set?: InputMaybe<Trip_Set_Input>;
  where: Trip_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trip_By_PkArgs = {
  _set?: InputMaybe<Trip_Set_Input>;
  pk_columns: Trip_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trip_LocationArgs = {
  _set?: InputMaybe<Trip_Location_Set_Input>;
  where: Trip_Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trip_Location_By_PkArgs = {
  _set?: InputMaybe<Trip_Location_Set_Input>;
  pk_columns: Trip_Location_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trip_Location_ManyArgs = {
  updates: Array<Trip_Location_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Trip_ManyArgs = {
  updates: Array<Trip_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Trip_PlanArgs = {
  _inc?: InputMaybe<Trip_Plan_Inc_Input>;
  _set?: InputMaybe<Trip_Plan_Set_Input>;
  where: Trip_Plan_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trip_Plan_By_PkArgs = {
  _inc?: InputMaybe<Trip_Plan_Inc_Input>;
  _set?: InputMaybe<Trip_Plan_Set_Input>;
  pk_columns: Trip_Plan_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trip_Plan_ManyArgs = {
  updates: Array<Trip_Plan_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Unit_Of_MeasureArgs = {
  _set?: InputMaybe<Unit_Of_Measure_Set_Input>;
  where: Unit_Of_Measure_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Unit_Of_Measure_By_PkArgs = {
  _set?: InputMaybe<Unit_Of_Measure_Set_Input>;
  pk_columns: Unit_Of_Measure_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Unit_Of_Measure_ManyArgs = {
  updates: Array<Unit_Of_Measure_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Unit_Of_Measure_MetaArgs = {
  _set?: InputMaybe<Unit_Of_Measure_Meta_Set_Input>;
  where: Unit_Of_Measure_Meta_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Unit_Of_Measure_Meta_By_PkArgs = {
  _set?: InputMaybe<Unit_Of_Measure_Meta_Set_Input>;
  pk_columns: Unit_Of_Measure_Meta_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Unit_Of_Measure_Meta_ManyArgs = {
  updates: Array<Unit_Of_Measure_Meta_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uom_ConversionArgs = {
  _inc?: InputMaybe<Uom_Conversion_Inc_Input>;
  _set?: InputMaybe<Uom_Conversion_Set_Input>;
  where: Uom_Conversion_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uom_Conversion_By_PkArgs = {
  _inc?: InputMaybe<Uom_Conversion_Inc_Input>;
  _set?: InputMaybe<Uom_Conversion_Set_Input>;
  pk_columns: Uom_Conversion_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uom_Conversion_ManyArgs = {
  updates: Array<Uom_Conversion_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UserArgs = {
  _inc?: InputMaybe<User_Inc_Input>;
  _set?: InputMaybe<User_Set_Input>;
  where: User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Access_Audit_LogArgs = {
  _set?: InputMaybe<User_Access_Audit_Log_Set_Input>;
  where: User_Access_Audit_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Access_Audit_Log_By_PkArgs = {
  _set?: InputMaybe<User_Access_Audit_Log_Set_Input>;
  pk_columns: User_Access_Audit_Log_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Access_Audit_Log_ManyArgs = {
  updates: Array<User_Access_Audit_Log_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_By_PkArgs = {
  _inc?: InputMaybe<User_Inc_Input>;
  _set?: InputMaybe<User_Set_Input>;
  pk_columns: User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_LedgerArgs = {
  _inc?: InputMaybe<User_Ledger_Inc_Input>;
  _set?: InputMaybe<User_Ledger_Set_Input>;
  where: User_Ledger_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Ledger_By_PkArgs = {
  _inc?: InputMaybe<User_Ledger_Inc_Input>;
  _set?: InputMaybe<User_Ledger_Set_Input>;
  pk_columns: User_Ledger_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Ledger_ManyArgs = {
  updates: Array<User_Ledger_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_ManyArgs = {
  updates: Array<User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Partner_TypeArgs = {
  _set?: InputMaybe<User_Partner_Type_Set_Input>;
  where: User_Partner_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Partner_Type_By_PkArgs = {
  _set?: InputMaybe<User_Partner_Type_Set_Input>;
  pk_columns: User_Partner_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Partner_Type_ManyArgs = {
  updates: Array<User_Partner_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_ReferralArgs = {
  _set?: InputMaybe<User_Referral_Set_Input>;
  where: User_Referral_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Referral_By_PkArgs = {
  _set?: InputMaybe<User_Referral_Set_Input>;
  pk_columns: User_Referral_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Referral_ManyArgs = {
  updates: Array<User_Referral_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_RoleArgs = {
  _set?: InputMaybe<User_Role_Set_Input>;
  where: User_Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Role_By_PkArgs = {
  _set?: InputMaybe<User_Role_Set_Input>;
  pk_columns: User_Role_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Role_ManyArgs = {
  updates: Array<User_Role_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Validation_WorkflowsArgs = {
  _append?: InputMaybe<Validation_Workflows_Append_Input>;
  _delete_at_path?: InputMaybe<Validation_Workflows_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Validation_Workflows_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Validation_Workflows_Delete_Key_Input>;
  _prepend?: InputMaybe<Validation_Workflows_Prepend_Input>;
  _set?: InputMaybe<Validation_Workflows_Set_Input>;
  where: Validation_Workflows_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Validation_Workflows_By_PkArgs = {
  _append?: InputMaybe<Validation_Workflows_Append_Input>;
  _delete_at_path?: InputMaybe<Validation_Workflows_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Validation_Workflows_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Validation_Workflows_Delete_Key_Input>;
  _prepend?: InputMaybe<Validation_Workflows_Prepend_Input>;
  _set?: InputMaybe<Validation_Workflows_Set_Input>;
  pk_columns: Validation_Workflows_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Validation_Workflows_ManyArgs = {
  updates: Array<Validation_Workflows_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_VariationArgs = {
  _set?: InputMaybe<Variation_Set_Input>;
  where: Variation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Variation_By_PkArgs = {
  _set?: InputMaybe<Variation_Set_Input>;
  pk_columns: Variation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Variation_ManyArgs = {
  updates: Array<Variation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Variation_TypeArgs = {
  _set?: InputMaybe<Variation_Type_Set_Input>;
  where: Variation_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Variation_Type_By_PkArgs = {
  _set?: InputMaybe<Variation_Type_Set_Input>;
  pk_columns: Variation_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Variation_Type_ManyArgs = {
  updates: Array<Variation_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_VehicleArgs = {
  _inc?: InputMaybe<Vehicle_Inc_Input>;
  _set?: InputMaybe<Vehicle_Set_Input>;
  where: Vehicle_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_By_PkArgs = {
  _inc?: InputMaybe<Vehicle_Inc_Input>;
  _set?: InputMaybe<Vehicle_Set_Input>;
  pk_columns: Vehicle_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_ConfigurationArgs = {
  _set?: InputMaybe<Vehicle_Configuration_Set_Input>;
  where: Vehicle_Configuration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Configuration_By_PkArgs = {
  _set?: InputMaybe<Vehicle_Configuration_Set_Input>;
  pk_columns: Vehicle_Configuration_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Configuration_ManyArgs = {
  updates: Array<Vehicle_Configuration_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_DeviceArgs = {
  _inc?: InputMaybe<Vehicle_Device_Inc_Input>;
  _set?: InputMaybe<Vehicle_Device_Set_Input>;
  where: Vehicle_Device_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Device_By_PkArgs = {
  _inc?: InputMaybe<Vehicle_Device_Inc_Input>;
  _set?: InputMaybe<Vehicle_Device_Set_Input>;
  pk_columns: Vehicle_Device_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Device_CalibrationArgs = {
  _set?: InputMaybe<Vehicle_Device_Calibration_Set_Input>;
  where: Vehicle_Device_Calibration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Device_Calibration_By_PkArgs = {
  _set?: InputMaybe<Vehicle_Device_Calibration_Set_Input>;
  pk_columns: Vehicle_Device_Calibration_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Device_Calibration_ManyArgs = {
  updates: Array<Vehicle_Device_Calibration_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Device_ManyArgs = {
  updates: Array<Vehicle_Device_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Inventory_Transaction_LogsArgs = {
  _append?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Append_Input>;
  _delete_at_path?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Delete_Key_Input>;
  _inc?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Inc_Input>;
  _prepend?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Prepend_Input>;
  _set?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Set_Input>;
  where: Vehicle_Inventory_Transaction_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Inventory_Transaction_Logs_By_PkArgs = {
  _append?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Append_Input>;
  _delete_at_path?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Delete_Key_Input>;
  _inc?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Inc_Input>;
  _prepend?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Prepend_Input>;
  _set?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Set_Input>;
  pk_columns: Vehicle_Inventory_Transaction_Logs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Inventory_Transaction_Logs_ManyArgs = {
  updates: Array<Vehicle_Inventory_Transaction_Logs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_LocalitiesArgs = {
  _set?: InputMaybe<Vehicle_Localities_Set_Input>;
  where: Vehicle_Localities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Localities_By_PkArgs = {
  _set?: InputMaybe<Vehicle_Localities_Set_Input>;
  pk_columns: Vehicle_Localities_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Localities_ManyArgs = {
  updates: Array<Vehicle_Localities_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_ManyArgs = {
  updates: Array<Vehicle_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_PermitArgs = {
  _set?: InputMaybe<Vehicle_Permit_Set_Input>;
  where: Vehicle_Permit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Permit_By_PkArgs = {
  _set?: InputMaybe<Vehicle_Permit_Set_Input>;
  pk_columns: Vehicle_Permit_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Permit_ManyArgs = {
  updates: Array<Vehicle_Permit_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Shift_TemplateArgs = {
  _set?: InputMaybe<Vehicle_Shift_Template_Set_Input>;
  where: Vehicle_Shift_Template_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Shift_Template_By_PkArgs = {
  _set?: InputMaybe<Vehicle_Shift_Template_Set_Input>;
  pk_columns: Vehicle_Shift_Template_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Shift_Template_ManyArgs = {
  updates: Array<Vehicle_Shift_Template_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_StatusArgs = {
  _set?: InputMaybe<Vehicle_Status_Set_Input>;
  where: Vehicle_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Status_By_PkArgs = {
  _set?: InputMaybe<Vehicle_Status_Set_Input>;
  pk_columns: Vehicle_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Status_LogsArgs = {
  _set?: InputMaybe<Vehicle_Status_Logs_Set_Input>;
  where: Vehicle_Status_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Status_Logs_By_PkArgs = {
  _set?: InputMaybe<Vehicle_Status_Logs_Set_Input>;
  pk_columns: Vehicle_Status_Logs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Status_Logs_ManyArgs = {
  updates: Array<Vehicle_Status_Logs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Status_ManyArgs = {
  updates: Array<Vehicle_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Tank_TypeArgs = {
  _inc?: InputMaybe<Vehicle_Tank_Type_Inc_Input>;
  _set?: InputMaybe<Vehicle_Tank_Type_Set_Input>;
  where: Vehicle_Tank_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Tank_Type_By_PkArgs = {
  _inc?: InputMaybe<Vehicle_Tank_Type_Inc_Input>;
  _set?: InputMaybe<Vehicle_Tank_Type_Set_Input>;
  pk_columns: Vehicle_Tank_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Tank_Type_ManyArgs = {
  updates: Array<Vehicle_Tank_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Tank_Type_Product_VariationArgs = {
  _set?: InputMaybe<Vehicle_Tank_Type_Product_Variation_Set_Input>;
  where: Vehicle_Tank_Type_Product_Variation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Tank_Type_Product_Variation_By_PkArgs = {
  _set?: InputMaybe<Vehicle_Tank_Type_Product_Variation_Set_Input>;
  pk_columns: Vehicle_Tank_Type_Product_Variation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Tank_Type_Product_Variation_ManyArgs = {
  updates: Array<Vehicle_Tank_Type_Product_Variation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_TypeArgs = {
  _set?: InputMaybe<Vehicle_Type_Set_Input>;
  where: Vehicle_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Type_By_PkArgs = {
  _set?: InputMaybe<Vehicle_Type_Set_Input>;
  pk_columns: Vehicle_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Type_ManyArgs = {
  updates: Array<Vehicle_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Vendor_Order_LogsArgs = {
  _set?: InputMaybe<Vendor_Order_Logs_Set_Input>;
  where: Vendor_Order_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vendor_Order_Logs_By_PkArgs = {
  _set?: InputMaybe<Vendor_Order_Logs_Set_Input>;
  pk_columns: Vendor_Order_Logs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Vendor_Order_Logs_ManyArgs = {
  updates: Array<Vendor_Order_Logs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Vendor_Sync_StatusArgs = {
  _set?: InputMaybe<Vendor_Sync_Status_Set_Input>;
  where: Vendor_Sync_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vendor_Sync_Status_By_PkArgs = {
  _set?: InputMaybe<Vendor_Sync_Status_Set_Input>;
  pk_columns: Vendor_Sync_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Vendor_Sync_Status_ManyArgs = {
  updates: Array<Vendor_Sync_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_VoucherArgs = {
  _inc?: InputMaybe<Voucher_Inc_Input>;
  _set?: InputMaybe<Voucher_Set_Input>;
  where: Voucher_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Voucher_By_PkArgs = {
  _inc?: InputMaybe<Voucher_Inc_Input>;
  _set?: InputMaybe<Voucher_Set_Input>;
  pk_columns: Voucher_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Voucher_ManyArgs = {
  updates: Array<Voucher_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_WalletArgs = {
  _inc?: InputMaybe<Wallet_Inc_Input>;
  _set?: InputMaybe<Wallet_Set_Input>;
  where: Wallet_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Wallet_By_PkArgs = {
  _inc?: InputMaybe<Wallet_Inc_Input>;
  _set?: InputMaybe<Wallet_Set_Input>;
  pk_columns: Wallet_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Wallet_ExceptionArgs = {
  _inc?: InputMaybe<Wallet_Exception_Inc_Input>;
  _set?: InputMaybe<Wallet_Exception_Set_Input>;
  where: Wallet_Exception_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Wallet_Exception_By_PkArgs = {
  _inc?: InputMaybe<Wallet_Exception_Inc_Input>;
  _set?: InputMaybe<Wallet_Exception_Set_Input>;
  pk_columns: Wallet_Exception_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Wallet_Exception_ManyArgs = {
  updates: Array<Wallet_Exception_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Wallet_LedgerArgs = {
  _inc?: InputMaybe<Wallet_Ledger_Inc_Input>;
  _set?: InputMaybe<Wallet_Ledger_Set_Input>;
  where: Wallet_Ledger_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Wallet_Ledger_By_PkArgs = {
  _inc?: InputMaybe<Wallet_Ledger_Inc_Input>;
  _set?: InputMaybe<Wallet_Ledger_Set_Input>;
  pk_columns: Wallet_Ledger_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Wallet_Ledger_ManyArgs = {
  updates: Array<Wallet_Ledger_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Wallet_ManyArgs = {
  updates: Array<Wallet_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Wallet_StateArgs = {
  _set?: InputMaybe<Wallet_State_Set_Input>;
  where: Wallet_State_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Wallet_State_By_PkArgs = {
  _set?: InputMaybe<Wallet_State_Set_Input>;
  pk_columns: Wallet_State_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Wallet_State_ManyArgs = {
  updates: Array<Wallet_State_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Wallet_TransactionsArgs = {
  _inc?: InputMaybe<Wallet_Transactions_Inc_Input>;
  _set?: InputMaybe<Wallet_Transactions_Set_Input>;
  where: Wallet_Transactions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Wallet_Transactions_By_PkArgs = {
  _inc?: InputMaybe<Wallet_Transactions_Inc_Input>;
  _set?: InputMaybe<Wallet_Transactions_Set_Input>;
  pk_columns: Wallet_Transactions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Wallet_Transactions_ManyArgs = {
  updates: Array<Wallet_Transactions_Updates>;
};


/** mutation root */
export type Mutation_RootUploadFileArgs = {
  object: StorageInput;
};


/** mutation root */
export type Mutation_RootUploadFuelTransTxnLogsExcelArgs = {
  object: UploadFuelTransTxnLogsExcelInput;
};


/** mutation root */
export type Mutation_RootUpsertCustomerAssetEtArgs = {
  object: UpsertCustomerAssetEtInput;
};


/** mutation root */
export type Mutation_RootVerifyEasebuzzPaymentStatusArgs = {
  object: VerifyEasebuzzPaymentStatusInput;
};


/** mutation root */
export type Mutation_RootVerifyOrderOtpArgs = {
  object: VerifyOrderOtpInput;
};


/** mutation root */
export type Mutation_RootVerifyPaymentStatusArgs = {
  object: VerifyPaymentStatusInput;
};

/** Boolean expression to compare columns of type "name". All fields are combined with logical 'AND'. */
export type Name_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['name']['input']>;
  _gt?: InputMaybe<Scalars['name']['input']>;
  _gte?: InputMaybe<Scalars['name']['input']>;
  _in?: InputMaybe<Array<Scalars['name']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['name']['input']>;
  _lte?: InputMaybe<Scalars['name']['input']>;
  _neq?: InputMaybe<Scalars['name']['input']>;
  _nin?: InputMaybe<Array<Scalars['name']['input']>>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** columns and relationships of "omc_type" */
export type Omc_Type = {
  __typename?: 'omc_type';
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  partners: Array<Partner>;
  /** An aggregate relationship */
  partners_aggregate: Partner_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "omc_type" */
export type Omc_TypePartnersArgs = {
  distinct_on?: InputMaybe<Array<Partner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_By>>;
  where?: InputMaybe<Partner_Bool_Exp>;
};


/** columns and relationships of "omc_type" */
export type Omc_TypePartners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_By>>;
  where?: InputMaybe<Partner_Bool_Exp>;
};

/** aggregated selection of "omc_type" */
export type Omc_Type_Aggregate = {
  __typename?: 'omc_type_aggregate';
  aggregate?: Maybe<Omc_Type_Aggregate_Fields>;
  nodes: Array<Omc_Type>;
};

/** aggregate fields of "omc_type" */
export type Omc_Type_Aggregate_Fields = {
  __typename?: 'omc_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Omc_Type_Max_Fields>;
  min?: Maybe<Omc_Type_Min_Fields>;
};


/** aggregate fields of "omc_type" */
export type Omc_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Omc_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "omc_type". All fields are combined with a logical 'AND'. */
export type Omc_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Omc_Type_Bool_Exp>>;
  _not?: InputMaybe<Omc_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Omc_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  partners?: InputMaybe<Partner_Bool_Exp>;
  partners_aggregate?: InputMaybe<Partner_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "omc_type" */
export enum Omc_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  OmcTypePkey = 'omc_type_pkey'
}

export enum Omc_Type_Enum {
  /** BPCL */
  Bpcl = 'BPCL',
  /** HPCL */
  Hpcl = 'HPCL',
  /** IOCL */
  Iocl = 'IOCL',
  /** JIOBP */
  Jiobp = 'JIOBP',
  /** NAYARA */
  Nayara = 'NAYARA',
  /** SHELL */
  Shell = 'SHELL'
}

/** Boolean expression to compare columns of type "omc_type_enum". All fields are combined with logical 'AND'. */
export type Omc_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Omc_Type_Enum>;
  _in?: InputMaybe<Array<Omc_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Omc_Type_Enum>;
  _nin?: InputMaybe<Array<Omc_Type_Enum>>;
};

/** input type for inserting data into table "omc_type" */
export type Omc_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  partners?: InputMaybe<Partner_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Omc_Type_Max_Fields = {
  __typename?: 'omc_type_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Omc_Type_Min_Fields = {
  __typename?: 'omc_type_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "omc_type" */
export type Omc_Type_Mutation_Response = {
  __typename?: 'omc_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Omc_Type>;
};

/** input type for inserting object relation for remote table "omc_type" */
export type Omc_Type_Obj_Rel_Insert_Input = {
  data: Omc_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Omc_Type_On_Conflict>;
};

/** on_conflict condition type for table "omc_type" */
export type Omc_Type_On_Conflict = {
  constraint: Omc_Type_Constraint;
  update_columns?: Array<Omc_Type_Update_Column>;
  where?: InputMaybe<Omc_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "omc_type". */
export type Omc_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  partners_aggregate?: InputMaybe<Partner_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: omc_type */
export type Omc_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "omc_type" */
export enum Omc_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "omc_type" */
export type Omc_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "omc_type" */
export type Omc_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Omc_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Omc_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "omc_type" */
export enum Omc_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Omc_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Omc_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Omc_Type_Bool_Exp;
};

export type OrderDeliveryAutomationInput = {
  order_logs?: InputMaybe<Array<OrderDeliveryAutomationLogs>>;
};

export type OrderDeliveryAutomationLogs = {
  address_id: Scalars['uuid']['input'];
  asset_registration_number: Scalars['String']['input'];
  customer_code: Scalars['numeric']['input'];
  dispensing_date?: InputMaybe<Scalars['timestamp']['input']>;
  driver_id?: InputMaybe<Scalars['uuid']['input']>;
  driver_vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  odometer?: InputMaybe<Scalars['String']['input']>;
  order_date: Scalars['timestamp']['input'];
  partner_id: Scalars['uuid']['input'];
  partner_localities_id: Scalars['uuid']['input'];
  product_variation_id: Scalars['uuid']['input'];
  quantity: Scalars['numeric']['input'];
  totalizer_after_reading?: InputMaybe<Scalars['String']['input']>;
  totalizer_before_reading?: InputMaybe<Scalars['String']['input']>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type OrderDeliveryAutomationOutput = {
  __typename?: 'orderDeliveryAutomationOutput';
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type OrderStatsInput = {
  customer_id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  end_date: Scalars['timestamp']['input'];
  start_date: Scalars['timestamp']['input'];
};

export type OrderStatsOutput = {
  __typename?: 'orderStatsOutput';
  total_active_deliveries?: Maybe<Scalars['Int']['output']>;
  total_assigned_deliveries?: Maybe<Scalars['Int']['output']>;
  total_orders?: Maybe<Scalars['Int']['output']>;
  total_orders_cancelled?: Maybe<Scalars['Int']['output']>;
  total_orders_delivered?: Maybe<Scalars['Int']['output']>;
  total_orders_unassigned?: Maybe<Scalars['Int']['output']>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls first */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls last */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "order_photos" */
export type Order_Photos = {
  __typename?: 'order_photos';
  category: Photo_Type_Enum;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  customer_order: Customer_Order;
  customer_order_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  photo_type: Photo_Type;
  url: Scalars['String']['output'];
};

/** aggregated selection of "order_photos" */
export type Order_Photos_Aggregate = {
  __typename?: 'order_photos_aggregate';
  aggregate?: Maybe<Order_Photos_Aggregate_Fields>;
  nodes: Array<Order_Photos>;
};

export type Order_Photos_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Order_Photos_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Order_Photos_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Order_Photos_Aggregate_Bool_Exp_Count>;
};

export type Order_Photos_Aggregate_Bool_Exp_Bool_And = {
  arguments: Order_Photos_Select_Column_Order_Photos_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Order_Photos_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Order_Photos_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Order_Photos_Select_Column_Order_Photos_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Order_Photos_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Order_Photos_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Order_Photos_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Order_Photos_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "order_photos" */
export type Order_Photos_Aggregate_Fields = {
  __typename?: 'order_photos_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Order_Photos_Max_Fields>;
  min?: Maybe<Order_Photos_Min_Fields>;
};


/** aggregate fields of "order_photos" */
export type Order_Photos_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Order_Photos_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "order_photos" */
export type Order_Photos_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Photos_Max_Order_By>;
  min?: InputMaybe<Order_Photos_Min_Order_By>;
};

/** input type for inserting array relation for remote table "order_photos" */
export type Order_Photos_Arr_Rel_Insert_Input = {
  data: Array<Order_Photos_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Order_Photos_On_Conflict>;
};

/** Boolean expression to filter rows from the table "order_photos". All fields are combined with a logical 'AND'. */
export type Order_Photos_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Photos_Bool_Exp>>;
  _not?: InputMaybe<Order_Photos_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Photos_Bool_Exp>>;
  category?: InputMaybe<Photo_Type_Enum_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_order?: InputMaybe<Customer_Order_Bool_Exp>;
  customer_order_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  photo_type?: InputMaybe<Photo_Type_Bool_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "order_photos" */
export enum Order_Photos_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrderPhotosPkey = 'order_photos_pkey'
}

/** input type for inserting data into table "order_photos" */
export type Order_Photos_Insert_Input = {
  category?: InputMaybe<Photo_Type_Enum>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order?: InputMaybe<Customer_Order_Obj_Rel_Insert_Input>;
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  photo_type?: InputMaybe<Photo_Type_Obj_Rel_Insert_Input>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Order_Photos_Max_Fields = {
  __typename?: 'order_photos_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_order_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "order_photos" */
export type Order_Photos_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Order_Photos_Min_Fields = {
  __typename?: 'order_photos_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_order_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "order_photos" */
export type Order_Photos_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "order_photos" */
export type Order_Photos_Mutation_Response = {
  __typename?: 'order_photos_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Order_Photos>;
};

/** on_conflict condition type for table "order_photos" */
export type Order_Photos_On_Conflict = {
  constraint: Order_Photos_Constraint;
  update_columns?: Array<Order_Photos_Update_Column>;
  where?: InputMaybe<Order_Photos_Bool_Exp>;
};

/** Ordering options when selecting data from "order_photos". */
export type Order_Photos_Order_By = {
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_order?: InputMaybe<Customer_Order_Order_By>;
  customer_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  photo_type?: InputMaybe<Photo_Type_Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: order_photos */
export type Order_Photos_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "order_photos" */
export enum Order_Photos_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerOrderId = 'customer_order_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Url = 'url'
}

/** select "order_photos_aggregate_bool_exp_bool_and_arguments_columns" columns of table "order_photos" */
export enum Order_Photos_Select_Column_Order_Photos_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "order_photos_aggregate_bool_exp_bool_or_arguments_columns" columns of table "order_photos" */
export enum Order_Photos_Select_Column_Order_Photos_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "order_photos" */
export type Order_Photos_Set_Input = {
  category?: InputMaybe<Photo_Type_Enum>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "order_photos" */
export type Order_Photos_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_Photos_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_Photos_Stream_Cursor_Value_Input = {
  category?: InputMaybe<Photo_Type_Enum>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "order_photos" */
export enum Order_Photos_Update_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerOrderId = 'customer_order_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Url = 'url'
}

export type Order_Photos_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Order_Photos_Set_Input>;
  /** filter the rows which have to be updated */
  where: Order_Photos_Bool_Exp;
};

/** columns and relationships of "order_scheduler" */
export type Order_Scheduler = {
  __typename?: 'order_scheduler';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  driver_vehicle?: Maybe<Driver_Vehicle>;
  driver_vehicle_id?: Maybe<Scalars['uuid']['output']>;
  end_date: Scalars['timestamp']['output'];
  end_time?: Maybe<Scalars['timetz']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  order_scheduler_customer_assets: Array<Order_Scheduler_Customer_Asset>;
  /** An aggregate relationship */
  order_scheduler_customer_assets_aggregate: Order_Scheduler_Customer_Asset_Aggregate;
  /** An array relationship */
  order_scheduler_daily_frequencies: Array<Order_Scheduler_Daily_Frequency>;
  /** An aggregate relationship */
  order_scheduler_daily_frequencies_aggregate: Order_Scheduler_Daily_Frequency_Aggregate;
  /** An object relationship */
  organization_address?: Maybe<Organization_Address>;
  organization_address_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  organization_user: Organization_User;
  organization_user_id: Scalars['uuid']['output'];
  /** An object relationship */
  partner: Partner;
  partner_id: Scalars['uuid']['output'];
  partner_localities_id: Scalars['uuid']['output'];
  /** An object relationship */
  partner_locality: Partner_Localities;
  poc_details?: Maybe<Scalars['String']['output']>;
  poc_details_other?: Maybe<Scalars['String']['output']>;
  poc_number?: Maybe<Scalars['String']['output']>;
  poc_number_other?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  product_variation: Product_Variation;
  product_variation_id: Scalars['uuid']['output'];
  remark?: Maybe<Scalars['String']['output']>;
  start_date: Scalars['timestamp']['output'];
  start_time: Scalars['timetz']['output'];
  total_quantity_limit: Scalars['numeric']['output'];
  total_quantity_limit_left?: Maybe<Scalars['numeric']['output']>;
};


/** columns and relationships of "order_scheduler" */
export type Order_SchedulerOrder_Scheduler_Customer_AssetsArgs = {
  distinct_on?: InputMaybe<Array<Order_Scheduler_Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Scheduler_Customer_Asset_Order_By>>;
  where?: InputMaybe<Order_Scheduler_Customer_Asset_Bool_Exp>;
};


/** columns and relationships of "order_scheduler" */
export type Order_SchedulerOrder_Scheduler_Customer_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Scheduler_Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Scheduler_Customer_Asset_Order_By>>;
  where?: InputMaybe<Order_Scheduler_Customer_Asset_Bool_Exp>;
};


/** columns and relationships of "order_scheduler" */
export type Order_SchedulerOrder_Scheduler_Daily_FrequenciesArgs = {
  distinct_on?: InputMaybe<Array<Order_Scheduler_Daily_Frequency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Scheduler_Daily_Frequency_Order_By>>;
  where?: InputMaybe<Order_Scheduler_Daily_Frequency_Bool_Exp>;
};


/** columns and relationships of "order_scheduler" */
export type Order_SchedulerOrder_Scheduler_Daily_Frequencies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Scheduler_Daily_Frequency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Scheduler_Daily_Frequency_Order_By>>;
  where?: InputMaybe<Order_Scheduler_Daily_Frequency_Bool_Exp>;
};

/** aggregated selection of "order_scheduler" */
export type Order_Scheduler_Aggregate = {
  __typename?: 'order_scheduler_aggregate';
  aggregate?: Maybe<Order_Scheduler_Aggregate_Fields>;
  nodes: Array<Order_Scheduler>;
};

export type Order_Scheduler_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Order_Scheduler_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Order_Scheduler_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Order_Scheduler_Aggregate_Bool_Exp_Count>;
};

export type Order_Scheduler_Aggregate_Bool_Exp_Bool_And = {
  arguments: Order_Scheduler_Select_Column_Order_Scheduler_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Order_Scheduler_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Order_Scheduler_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Order_Scheduler_Select_Column_Order_Scheduler_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Order_Scheduler_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Order_Scheduler_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Order_Scheduler_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Order_Scheduler_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "order_scheduler" */
export type Order_Scheduler_Aggregate_Fields = {
  __typename?: 'order_scheduler_aggregate_fields';
  avg?: Maybe<Order_Scheduler_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Order_Scheduler_Max_Fields>;
  min?: Maybe<Order_Scheduler_Min_Fields>;
  stddev?: Maybe<Order_Scheduler_Stddev_Fields>;
  stddev_pop?: Maybe<Order_Scheduler_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Order_Scheduler_Stddev_Samp_Fields>;
  sum?: Maybe<Order_Scheduler_Sum_Fields>;
  var_pop?: Maybe<Order_Scheduler_Var_Pop_Fields>;
  var_samp?: Maybe<Order_Scheduler_Var_Samp_Fields>;
  variance?: Maybe<Order_Scheduler_Variance_Fields>;
};


/** aggregate fields of "order_scheduler" */
export type Order_Scheduler_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Order_Scheduler_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "order_scheduler" */
export type Order_Scheduler_Aggregate_Order_By = {
  avg?: InputMaybe<Order_Scheduler_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Scheduler_Max_Order_By>;
  min?: InputMaybe<Order_Scheduler_Min_Order_By>;
  stddev?: InputMaybe<Order_Scheduler_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_Scheduler_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_Scheduler_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_Scheduler_Sum_Order_By>;
  var_pop?: InputMaybe<Order_Scheduler_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_Scheduler_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_Scheduler_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "order_scheduler" */
export type Order_Scheduler_Arr_Rel_Insert_Input = {
  data: Array<Order_Scheduler_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Order_Scheduler_On_Conflict>;
};

/** aggregate avg on columns */
export type Order_Scheduler_Avg_Fields = {
  __typename?: 'order_scheduler_avg_fields';
  total_quantity_limit?: Maybe<Scalars['Float']['output']>;
  total_quantity_limit_left?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "order_scheduler" */
export type Order_Scheduler_Avg_Order_By = {
  total_quantity_limit?: InputMaybe<Order_By>;
  total_quantity_limit_left?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order_scheduler". All fields are combined with a logical 'AND'. */
export type Order_Scheduler_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Scheduler_Bool_Exp>>;
  _not?: InputMaybe<Order_Scheduler_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Scheduler_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  driver_vehicle?: InputMaybe<Driver_Vehicle_Bool_Exp>;
  driver_vehicle_id?: InputMaybe<Uuid_Comparison_Exp>;
  end_date?: InputMaybe<Timestamp_Comparison_Exp>;
  end_time?: InputMaybe<Timetz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  order_scheduler_customer_assets?: InputMaybe<Order_Scheduler_Customer_Asset_Bool_Exp>;
  order_scheduler_customer_assets_aggregate?: InputMaybe<Order_Scheduler_Customer_Asset_Aggregate_Bool_Exp>;
  order_scheduler_daily_frequencies?: InputMaybe<Order_Scheduler_Daily_Frequency_Bool_Exp>;
  order_scheduler_daily_frequencies_aggregate?: InputMaybe<Order_Scheduler_Daily_Frequency_Aggregate_Bool_Exp>;
  organization_address?: InputMaybe<Organization_Address_Bool_Exp>;
  organization_address_id?: InputMaybe<Uuid_Comparison_Exp>;
  organization_user?: InputMaybe<Organization_User_Bool_Exp>;
  organization_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner?: InputMaybe<Partner_Bool_Exp>;
  partner_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner_localities_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner_locality?: InputMaybe<Partner_Localities_Bool_Exp>;
  poc_details?: InputMaybe<String_Comparison_Exp>;
  poc_details_other?: InputMaybe<String_Comparison_Exp>;
  poc_number?: InputMaybe<String_Comparison_Exp>;
  poc_number_other?: InputMaybe<String_Comparison_Exp>;
  product_variation?: InputMaybe<Product_Variation_Bool_Exp>;
  product_variation_id?: InputMaybe<Uuid_Comparison_Exp>;
  remark?: InputMaybe<String_Comparison_Exp>;
  start_date?: InputMaybe<Timestamp_Comparison_Exp>;
  start_time?: InputMaybe<Timetz_Comparison_Exp>;
  total_quantity_limit?: InputMaybe<Numeric_Comparison_Exp>;
  total_quantity_limit_left?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "order_scheduler" */
export enum Order_Scheduler_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrderSchedulerPkey = 'order_scheduler_pkey'
}

/** columns and relationships of "order_scheduler_customer_asset" */
export type Order_Scheduler_Customer_Asset = {
  __typename?: 'order_scheduler_customer_asset';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  customer_asset?: Maybe<Customer_Asset>;
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  order_scheduler: Order_Scheduler;
  order_scheduler_id: Scalars['uuid']['output'];
};

/** aggregated selection of "order_scheduler_customer_asset" */
export type Order_Scheduler_Customer_Asset_Aggregate = {
  __typename?: 'order_scheduler_customer_asset_aggregate';
  aggregate?: Maybe<Order_Scheduler_Customer_Asset_Aggregate_Fields>;
  nodes: Array<Order_Scheduler_Customer_Asset>;
};

export type Order_Scheduler_Customer_Asset_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Order_Scheduler_Customer_Asset_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Order_Scheduler_Customer_Asset_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Order_Scheduler_Customer_Asset_Aggregate_Bool_Exp_Count>;
};

export type Order_Scheduler_Customer_Asset_Aggregate_Bool_Exp_Bool_And = {
  arguments: Order_Scheduler_Customer_Asset_Select_Column_Order_Scheduler_Customer_Asset_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Order_Scheduler_Customer_Asset_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Order_Scheduler_Customer_Asset_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Order_Scheduler_Customer_Asset_Select_Column_Order_Scheduler_Customer_Asset_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Order_Scheduler_Customer_Asset_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Order_Scheduler_Customer_Asset_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Order_Scheduler_Customer_Asset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Order_Scheduler_Customer_Asset_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "order_scheduler_customer_asset" */
export type Order_Scheduler_Customer_Asset_Aggregate_Fields = {
  __typename?: 'order_scheduler_customer_asset_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Order_Scheduler_Customer_Asset_Max_Fields>;
  min?: Maybe<Order_Scheduler_Customer_Asset_Min_Fields>;
};


/** aggregate fields of "order_scheduler_customer_asset" */
export type Order_Scheduler_Customer_Asset_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Order_Scheduler_Customer_Asset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "order_scheduler_customer_asset" */
export type Order_Scheduler_Customer_Asset_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Scheduler_Customer_Asset_Max_Order_By>;
  min?: InputMaybe<Order_Scheduler_Customer_Asset_Min_Order_By>;
};

/** input type for inserting array relation for remote table "order_scheduler_customer_asset" */
export type Order_Scheduler_Customer_Asset_Arr_Rel_Insert_Input = {
  data: Array<Order_Scheduler_Customer_Asset_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Order_Scheduler_Customer_Asset_On_Conflict>;
};

/** Boolean expression to filter rows from the table "order_scheduler_customer_asset". All fields are combined with a logical 'AND'. */
export type Order_Scheduler_Customer_Asset_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Scheduler_Customer_Asset_Bool_Exp>>;
  _not?: InputMaybe<Order_Scheduler_Customer_Asset_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Scheduler_Customer_Asset_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_asset?: InputMaybe<Customer_Asset_Bool_Exp>;
  customer_asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  order_scheduler?: InputMaybe<Order_Scheduler_Bool_Exp>;
  order_scheduler_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "order_scheduler_customer_asset" */
export enum Order_Scheduler_Customer_Asset_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrderSchedulerCustomerAssetPkey = 'order_scheduler_customer_asset_pkey'
}

/** input type for inserting data into table "order_scheduler_customer_asset" */
export type Order_Scheduler_Customer_Asset_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_asset?: InputMaybe<Customer_Asset_Obj_Rel_Insert_Input>;
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  order_scheduler?: InputMaybe<Order_Scheduler_Obj_Rel_Insert_Input>;
  order_scheduler_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Order_Scheduler_Customer_Asset_Max_Fields = {
  __typename?: 'order_scheduler_customer_asset_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  order_scheduler_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "order_scheduler_customer_asset" */
export type Order_Scheduler_Customer_Asset_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  order_scheduler_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Order_Scheduler_Customer_Asset_Min_Fields = {
  __typename?: 'order_scheduler_customer_asset_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  order_scheduler_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "order_scheduler_customer_asset" */
export type Order_Scheduler_Customer_Asset_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  order_scheduler_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "order_scheduler_customer_asset" */
export type Order_Scheduler_Customer_Asset_Mutation_Response = {
  __typename?: 'order_scheduler_customer_asset_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Order_Scheduler_Customer_Asset>;
};

/** on_conflict condition type for table "order_scheduler_customer_asset" */
export type Order_Scheduler_Customer_Asset_On_Conflict = {
  constraint: Order_Scheduler_Customer_Asset_Constraint;
  update_columns?: Array<Order_Scheduler_Customer_Asset_Update_Column>;
  where?: InputMaybe<Order_Scheduler_Customer_Asset_Bool_Exp>;
};

/** Ordering options when selecting data from "order_scheduler_customer_asset". */
export type Order_Scheduler_Customer_Asset_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_asset?: InputMaybe<Customer_Asset_Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  order_scheduler?: InputMaybe<Order_Scheduler_Order_By>;
  order_scheduler_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: order_scheduler_customer_asset */
export type Order_Scheduler_Customer_Asset_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "order_scheduler_customer_asset" */
export enum Order_Scheduler_Customer_Asset_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerAssetId = 'customer_asset_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrderSchedulerId = 'order_scheduler_id'
}

/** select "order_scheduler_customer_asset_aggregate_bool_exp_bool_and_arguments_columns" columns of table "order_scheduler_customer_asset" */
export enum Order_Scheduler_Customer_Asset_Select_Column_Order_Scheduler_Customer_Asset_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "order_scheduler_customer_asset_aggregate_bool_exp_bool_or_arguments_columns" columns of table "order_scheduler_customer_asset" */
export enum Order_Scheduler_Customer_Asset_Select_Column_Order_Scheduler_Customer_Asset_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "order_scheduler_customer_asset" */
export type Order_Scheduler_Customer_Asset_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  order_scheduler_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "order_scheduler_customer_asset" */
export type Order_Scheduler_Customer_Asset_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_Scheduler_Customer_Asset_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_Scheduler_Customer_Asset_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  order_scheduler_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "order_scheduler_customer_asset" */
export enum Order_Scheduler_Customer_Asset_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerAssetId = 'customer_asset_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrderSchedulerId = 'order_scheduler_id'
}

export type Order_Scheduler_Customer_Asset_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Order_Scheduler_Customer_Asset_Set_Input>;
  /** filter the rows which have to be updated */
  where: Order_Scheduler_Customer_Asset_Bool_Exp;
};

/** columns and relationships of "order_scheduler_daily_frequency" */
export type Order_Scheduler_Daily_Frequency = {
  __typename?: 'order_scheduler_daily_frequency';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  day?: Maybe<Day_Type_Enum>;
  /** An object relationship */
  day_type?: Maybe<Day_Type>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  order_scheduler: Order_Scheduler;
  order_scheduler_id: Scalars['uuid']['output'];
  quantity: Scalars['numeric']['output'];
};

/** aggregated selection of "order_scheduler_daily_frequency" */
export type Order_Scheduler_Daily_Frequency_Aggregate = {
  __typename?: 'order_scheduler_daily_frequency_aggregate';
  aggregate?: Maybe<Order_Scheduler_Daily_Frequency_Aggregate_Fields>;
  nodes: Array<Order_Scheduler_Daily_Frequency>;
};

export type Order_Scheduler_Daily_Frequency_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Order_Scheduler_Daily_Frequency_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Order_Scheduler_Daily_Frequency_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Order_Scheduler_Daily_Frequency_Aggregate_Bool_Exp_Count>;
};

export type Order_Scheduler_Daily_Frequency_Aggregate_Bool_Exp_Bool_And = {
  arguments: Order_Scheduler_Daily_Frequency_Select_Column_Order_Scheduler_Daily_Frequency_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Order_Scheduler_Daily_Frequency_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Order_Scheduler_Daily_Frequency_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Order_Scheduler_Daily_Frequency_Select_Column_Order_Scheduler_Daily_Frequency_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Order_Scheduler_Daily_Frequency_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Order_Scheduler_Daily_Frequency_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Order_Scheduler_Daily_Frequency_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Order_Scheduler_Daily_Frequency_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "order_scheduler_daily_frequency" */
export type Order_Scheduler_Daily_Frequency_Aggregate_Fields = {
  __typename?: 'order_scheduler_daily_frequency_aggregate_fields';
  avg?: Maybe<Order_Scheduler_Daily_Frequency_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Order_Scheduler_Daily_Frequency_Max_Fields>;
  min?: Maybe<Order_Scheduler_Daily_Frequency_Min_Fields>;
  stddev?: Maybe<Order_Scheduler_Daily_Frequency_Stddev_Fields>;
  stddev_pop?: Maybe<Order_Scheduler_Daily_Frequency_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Order_Scheduler_Daily_Frequency_Stddev_Samp_Fields>;
  sum?: Maybe<Order_Scheduler_Daily_Frequency_Sum_Fields>;
  var_pop?: Maybe<Order_Scheduler_Daily_Frequency_Var_Pop_Fields>;
  var_samp?: Maybe<Order_Scheduler_Daily_Frequency_Var_Samp_Fields>;
  variance?: Maybe<Order_Scheduler_Daily_Frequency_Variance_Fields>;
};


/** aggregate fields of "order_scheduler_daily_frequency" */
export type Order_Scheduler_Daily_Frequency_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Order_Scheduler_Daily_Frequency_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "order_scheduler_daily_frequency" */
export type Order_Scheduler_Daily_Frequency_Aggregate_Order_By = {
  avg?: InputMaybe<Order_Scheduler_Daily_Frequency_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Scheduler_Daily_Frequency_Max_Order_By>;
  min?: InputMaybe<Order_Scheduler_Daily_Frequency_Min_Order_By>;
  stddev?: InputMaybe<Order_Scheduler_Daily_Frequency_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_Scheduler_Daily_Frequency_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_Scheduler_Daily_Frequency_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_Scheduler_Daily_Frequency_Sum_Order_By>;
  var_pop?: InputMaybe<Order_Scheduler_Daily_Frequency_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_Scheduler_Daily_Frequency_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_Scheduler_Daily_Frequency_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "order_scheduler_daily_frequency" */
export type Order_Scheduler_Daily_Frequency_Arr_Rel_Insert_Input = {
  data: Array<Order_Scheduler_Daily_Frequency_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Order_Scheduler_Daily_Frequency_On_Conflict>;
};

/** aggregate avg on columns */
export type Order_Scheduler_Daily_Frequency_Avg_Fields = {
  __typename?: 'order_scheduler_daily_frequency_avg_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "order_scheduler_daily_frequency" */
export type Order_Scheduler_Daily_Frequency_Avg_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order_scheduler_daily_frequency". All fields are combined with a logical 'AND'. */
export type Order_Scheduler_Daily_Frequency_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Scheduler_Daily_Frequency_Bool_Exp>>;
  _not?: InputMaybe<Order_Scheduler_Daily_Frequency_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Scheduler_Daily_Frequency_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  day?: InputMaybe<Day_Type_Enum_Comparison_Exp>;
  day_type?: InputMaybe<Day_Type_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  order_scheduler?: InputMaybe<Order_Scheduler_Bool_Exp>;
  order_scheduler_id?: InputMaybe<Uuid_Comparison_Exp>;
  quantity?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "order_scheduler_daily_frequency" */
export enum Order_Scheduler_Daily_Frequency_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrderSchedulerDailyFrequencyPkey = 'order_scheduler_daily_frequency_pkey'
}

/** input type for incrementing numeric columns in table "order_scheduler_daily_frequency" */
export type Order_Scheduler_Daily_Frequency_Inc_Input = {
  quantity?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "order_scheduler_daily_frequency" */
export type Order_Scheduler_Daily_Frequency_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  day?: InputMaybe<Day_Type_Enum>;
  day_type?: InputMaybe<Day_Type_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  order_scheduler?: InputMaybe<Order_Scheduler_Obj_Rel_Insert_Input>;
  order_scheduler_id?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Order_Scheduler_Daily_Frequency_Max_Fields = {
  __typename?: 'order_scheduler_daily_frequency_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  order_scheduler_id?: Maybe<Scalars['uuid']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "order_scheduler_daily_frequency" */
export type Order_Scheduler_Daily_Frequency_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  order_scheduler_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Order_Scheduler_Daily_Frequency_Min_Fields = {
  __typename?: 'order_scheduler_daily_frequency_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  order_scheduler_id?: Maybe<Scalars['uuid']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "order_scheduler_daily_frequency" */
export type Order_Scheduler_Daily_Frequency_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  order_scheduler_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "order_scheduler_daily_frequency" */
export type Order_Scheduler_Daily_Frequency_Mutation_Response = {
  __typename?: 'order_scheduler_daily_frequency_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Order_Scheduler_Daily_Frequency>;
};

/** on_conflict condition type for table "order_scheduler_daily_frequency" */
export type Order_Scheduler_Daily_Frequency_On_Conflict = {
  constraint: Order_Scheduler_Daily_Frequency_Constraint;
  update_columns?: Array<Order_Scheduler_Daily_Frequency_Update_Column>;
  where?: InputMaybe<Order_Scheduler_Daily_Frequency_Bool_Exp>;
};

/** Ordering options when selecting data from "order_scheduler_daily_frequency". */
export type Order_Scheduler_Daily_Frequency_Order_By = {
  created_at?: InputMaybe<Order_By>;
  day?: InputMaybe<Order_By>;
  day_type?: InputMaybe<Day_Type_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  order_scheduler?: InputMaybe<Order_Scheduler_Order_By>;
  order_scheduler_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** primary key columns input for table: order_scheduler_daily_frequency */
export type Order_Scheduler_Daily_Frequency_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "order_scheduler_daily_frequency" */
export enum Order_Scheduler_Daily_Frequency_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Day = 'day',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrderSchedulerId = 'order_scheduler_id',
  /** column name */
  Quantity = 'quantity'
}

/** select "order_scheduler_daily_frequency_aggregate_bool_exp_bool_and_arguments_columns" columns of table "order_scheduler_daily_frequency" */
export enum Order_Scheduler_Daily_Frequency_Select_Column_Order_Scheduler_Daily_Frequency_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "order_scheduler_daily_frequency_aggregate_bool_exp_bool_or_arguments_columns" columns of table "order_scheduler_daily_frequency" */
export enum Order_Scheduler_Daily_Frequency_Select_Column_Order_Scheduler_Daily_Frequency_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "order_scheduler_daily_frequency" */
export type Order_Scheduler_Daily_Frequency_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  day?: InputMaybe<Day_Type_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  order_scheduler_id?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Order_Scheduler_Daily_Frequency_Stddev_Fields = {
  __typename?: 'order_scheduler_daily_frequency_stddev_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "order_scheduler_daily_frequency" */
export type Order_Scheduler_Daily_Frequency_Stddev_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Order_Scheduler_Daily_Frequency_Stddev_Pop_Fields = {
  __typename?: 'order_scheduler_daily_frequency_stddev_pop_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "order_scheduler_daily_frequency" */
export type Order_Scheduler_Daily_Frequency_Stddev_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Order_Scheduler_Daily_Frequency_Stddev_Samp_Fields = {
  __typename?: 'order_scheduler_daily_frequency_stddev_samp_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "order_scheduler_daily_frequency" */
export type Order_Scheduler_Daily_Frequency_Stddev_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "order_scheduler_daily_frequency" */
export type Order_Scheduler_Daily_Frequency_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_Scheduler_Daily_Frequency_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_Scheduler_Daily_Frequency_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  day?: InputMaybe<Day_Type_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  order_scheduler_id?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Order_Scheduler_Daily_Frequency_Sum_Fields = {
  __typename?: 'order_scheduler_daily_frequency_sum_fields';
  quantity?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "order_scheduler_daily_frequency" */
export type Order_Scheduler_Daily_Frequency_Sum_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** update columns of table "order_scheduler_daily_frequency" */
export enum Order_Scheduler_Daily_Frequency_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Day = 'day',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrderSchedulerId = 'order_scheduler_id',
  /** column name */
  Quantity = 'quantity'
}

export type Order_Scheduler_Daily_Frequency_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Order_Scheduler_Daily_Frequency_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Order_Scheduler_Daily_Frequency_Set_Input>;
  /** filter the rows which have to be updated */
  where: Order_Scheduler_Daily_Frequency_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Order_Scheduler_Daily_Frequency_Var_Pop_Fields = {
  __typename?: 'order_scheduler_daily_frequency_var_pop_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "order_scheduler_daily_frequency" */
export type Order_Scheduler_Daily_Frequency_Var_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Order_Scheduler_Daily_Frequency_Var_Samp_Fields = {
  __typename?: 'order_scheduler_daily_frequency_var_samp_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "order_scheduler_daily_frequency" */
export type Order_Scheduler_Daily_Frequency_Var_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Order_Scheduler_Daily_Frequency_Variance_Fields = {
  __typename?: 'order_scheduler_daily_frequency_variance_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "order_scheduler_daily_frequency" */
export type Order_Scheduler_Daily_Frequency_Variance_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "order_scheduler" */
export type Order_Scheduler_Inc_Input = {
  total_quantity_limit?: InputMaybe<Scalars['numeric']['input']>;
  total_quantity_limit_left?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "order_scheduler" */
export type Order_Scheduler_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  driver_vehicle?: InputMaybe<Driver_Vehicle_Obj_Rel_Insert_Input>;
  driver_vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  end_date?: InputMaybe<Scalars['timestamp']['input']>;
  end_time?: InputMaybe<Scalars['timetz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  order_scheduler_customer_assets?: InputMaybe<Order_Scheduler_Customer_Asset_Arr_Rel_Insert_Input>;
  order_scheduler_daily_frequencies?: InputMaybe<Order_Scheduler_Daily_Frequency_Arr_Rel_Insert_Input>;
  organization_address?: InputMaybe<Organization_Address_Obj_Rel_Insert_Input>;
  organization_address_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_user?: InputMaybe<Organization_User_Obj_Rel_Insert_Input>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  partner?: InputMaybe<Partner_Obj_Rel_Insert_Input>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_localities_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_locality?: InputMaybe<Partner_Localities_Obj_Rel_Insert_Input>;
  poc_details?: InputMaybe<Scalars['String']['input']>;
  poc_details_other?: InputMaybe<Scalars['String']['input']>;
  poc_number?: InputMaybe<Scalars['String']['input']>;
  poc_number_other?: InputMaybe<Scalars['String']['input']>;
  product_variation?: InputMaybe<Product_Variation_Obj_Rel_Insert_Input>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['timestamp']['input']>;
  start_time?: InputMaybe<Scalars['timetz']['input']>;
  total_quantity_limit?: InputMaybe<Scalars['numeric']['input']>;
  total_quantity_limit_left?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Order_Scheduler_Max_Fields = {
  __typename?: 'order_scheduler_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  driver_vehicle_id?: Maybe<Scalars['uuid']['output']>;
  end_date?: Maybe<Scalars['timestamp']['output']>;
  end_time?: Maybe<Scalars['timetz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  organization_address_id?: Maybe<Scalars['uuid']['output']>;
  organization_user_id?: Maybe<Scalars['uuid']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  partner_localities_id?: Maybe<Scalars['uuid']['output']>;
  poc_details?: Maybe<Scalars['String']['output']>;
  poc_details_other?: Maybe<Scalars['String']['output']>;
  poc_number?: Maybe<Scalars['String']['output']>;
  poc_number_other?: Maybe<Scalars['String']['output']>;
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['timestamp']['output']>;
  start_time?: Maybe<Scalars['timetz']['output']>;
  total_quantity_limit?: Maybe<Scalars['numeric']['output']>;
  total_quantity_limit_left?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "order_scheduler" */
export type Order_Scheduler_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  driver_vehicle_id?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  end_time?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_address_id?: InputMaybe<Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  partner_localities_id?: InputMaybe<Order_By>;
  poc_details?: InputMaybe<Order_By>;
  poc_details_other?: InputMaybe<Order_By>;
  poc_number?: InputMaybe<Order_By>;
  poc_number_other?: InputMaybe<Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  total_quantity_limit?: InputMaybe<Order_By>;
  total_quantity_limit_left?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Order_Scheduler_Min_Fields = {
  __typename?: 'order_scheduler_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  driver_vehicle_id?: Maybe<Scalars['uuid']['output']>;
  end_date?: Maybe<Scalars['timestamp']['output']>;
  end_time?: Maybe<Scalars['timetz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  organization_address_id?: Maybe<Scalars['uuid']['output']>;
  organization_user_id?: Maybe<Scalars['uuid']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  partner_localities_id?: Maybe<Scalars['uuid']['output']>;
  poc_details?: Maybe<Scalars['String']['output']>;
  poc_details_other?: Maybe<Scalars['String']['output']>;
  poc_number?: Maybe<Scalars['String']['output']>;
  poc_number_other?: Maybe<Scalars['String']['output']>;
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['timestamp']['output']>;
  start_time?: Maybe<Scalars['timetz']['output']>;
  total_quantity_limit?: Maybe<Scalars['numeric']['output']>;
  total_quantity_limit_left?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "order_scheduler" */
export type Order_Scheduler_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  driver_vehicle_id?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  end_time?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_address_id?: InputMaybe<Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  partner_localities_id?: InputMaybe<Order_By>;
  poc_details?: InputMaybe<Order_By>;
  poc_details_other?: InputMaybe<Order_By>;
  poc_number?: InputMaybe<Order_By>;
  poc_number_other?: InputMaybe<Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  total_quantity_limit?: InputMaybe<Order_By>;
  total_quantity_limit_left?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "order_scheduler" */
export type Order_Scheduler_Mutation_Response = {
  __typename?: 'order_scheduler_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Order_Scheduler>;
};

/** input type for inserting object relation for remote table "order_scheduler" */
export type Order_Scheduler_Obj_Rel_Insert_Input = {
  data: Order_Scheduler_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Order_Scheduler_On_Conflict>;
};

/** on_conflict condition type for table "order_scheduler" */
export type Order_Scheduler_On_Conflict = {
  constraint: Order_Scheduler_Constraint;
  update_columns?: Array<Order_Scheduler_Update_Column>;
  where?: InputMaybe<Order_Scheduler_Bool_Exp>;
};

/** Ordering options when selecting data from "order_scheduler". */
export type Order_Scheduler_Order_By = {
  created_at?: InputMaybe<Order_By>;
  driver_vehicle?: InputMaybe<Driver_Vehicle_Order_By>;
  driver_vehicle_id?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  end_time?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  order_scheduler_customer_assets_aggregate?: InputMaybe<Order_Scheduler_Customer_Asset_Aggregate_Order_By>;
  order_scheduler_daily_frequencies_aggregate?: InputMaybe<Order_Scheduler_Daily_Frequency_Aggregate_Order_By>;
  organization_address?: InputMaybe<Organization_Address_Order_By>;
  organization_address_id?: InputMaybe<Order_By>;
  organization_user?: InputMaybe<Organization_User_Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
  partner?: InputMaybe<Partner_Order_By>;
  partner_id?: InputMaybe<Order_By>;
  partner_localities_id?: InputMaybe<Order_By>;
  partner_locality?: InputMaybe<Partner_Localities_Order_By>;
  poc_details?: InputMaybe<Order_By>;
  poc_details_other?: InputMaybe<Order_By>;
  poc_number?: InputMaybe<Order_By>;
  poc_number_other?: InputMaybe<Order_By>;
  product_variation?: InputMaybe<Product_Variation_Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  total_quantity_limit?: InputMaybe<Order_By>;
  total_quantity_limit_left?: InputMaybe<Order_By>;
};

/** primary key columns input for table: order_scheduler */
export type Order_Scheduler_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "order_scheduler" */
export enum Order_Scheduler_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DriverVehicleId = 'driver_vehicle_id',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrganizationAddressId = 'organization_address_id',
  /** column name */
  OrganizationUserId = 'organization_user_id',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  PartnerLocalitiesId = 'partner_localities_id',
  /** column name */
  PocDetails = 'poc_details',
  /** column name */
  PocDetailsOther = 'poc_details_other',
  /** column name */
  PocNumber = 'poc_number',
  /** column name */
  PocNumberOther = 'poc_number_other',
  /** column name */
  ProductVariationId = 'product_variation_id',
  /** column name */
  Remark = 'remark',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  TotalQuantityLimit = 'total_quantity_limit',
  /** column name */
  TotalQuantityLimitLeft = 'total_quantity_limit_left'
}

/** select "order_scheduler_aggregate_bool_exp_bool_and_arguments_columns" columns of table "order_scheduler" */
export enum Order_Scheduler_Select_Column_Order_Scheduler_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "order_scheduler_aggregate_bool_exp_bool_or_arguments_columns" columns of table "order_scheduler" */
export enum Order_Scheduler_Select_Column_Order_Scheduler_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "order_scheduler" */
export type Order_Scheduler_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  driver_vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  end_date?: InputMaybe<Scalars['timestamp']['input']>;
  end_time?: InputMaybe<Scalars['timetz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_address_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_localities_id?: InputMaybe<Scalars['uuid']['input']>;
  poc_details?: InputMaybe<Scalars['String']['input']>;
  poc_details_other?: InputMaybe<Scalars['String']['input']>;
  poc_number?: InputMaybe<Scalars['String']['input']>;
  poc_number_other?: InputMaybe<Scalars['String']['input']>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['timestamp']['input']>;
  start_time?: InputMaybe<Scalars['timetz']['input']>;
  total_quantity_limit?: InputMaybe<Scalars['numeric']['input']>;
  total_quantity_limit_left?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Order_Scheduler_Stddev_Fields = {
  __typename?: 'order_scheduler_stddev_fields';
  total_quantity_limit?: Maybe<Scalars['Float']['output']>;
  total_quantity_limit_left?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "order_scheduler" */
export type Order_Scheduler_Stddev_Order_By = {
  total_quantity_limit?: InputMaybe<Order_By>;
  total_quantity_limit_left?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Order_Scheduler_Stddev_Pop_Fields = {
  __typename?: 'order_scheduler_stddev_pop_fields';
  total_quantity_limit?: Maybe<Scalars['Float']['output']>;
  total_quantity_limit_left?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "order_scheduler" */
export type Order_Scheduler_Stddev_Pop_Order_By = {
  total_quantity_limit?: InputMaybe<Order_By>;
  total_quantity_limit_left?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Order_Scheduler_Stddev_Samp_Fields = {
  __typename?: 'order_scheduler_stddev_samp_fields';
  total_quantity_limit?: Maybe<Scalars['Float']['output']>;
  total_quantity_limit_left?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "order_scheduler" */
export type Order_Scheduler_Stddev_Samp_Order_By = {
  total_quantity_limit?: InputMaybe<Order_By>;
  total_quantity_limit_left?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "order_scheduler" */
export type Order_Scheduler_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_Scheduler_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_Scheduler_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  driver_vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  end_date?: InputMaybe<Scalars['timestamp']['input']>;
  end_time?: InputMaybe<Scalars['timetz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_address_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_localities_id?: InputMaybe<Scalars['uuid']['input']>;
  poc_details?: InputMaybe<Scalars['String']['input']>;
  poc_details_other?: InputMaybe<Scalars['String']['input']>;
  poc_number?: InputMaybe<Scalars['String']['input']>;
  poc_number_other?: InputMaybe<Scalars['String']['input']>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['timestamp']['input']>;
  start_time?: InputMaybe<Scalars['timetz']['input']>;
  total_quantity_limit?: InputMaybe<Scalars['numeric']['input']>;
  total_quantity_limit_left?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Order_Scheduler_Sum_Fields = {
  __typename?: 'order_scheduler_sum_fields';
  total_quantity_limit?: Maybe<Scalars['numeric']['output']>;
  total_quantity_limit_left?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "order_scheduler" */
export type Order_Scheduler_Sum_Order_By = {
  total_quantity_limit?: InputMaybe<Order_By>;
  total_quantity_limit_left?: InputMaybe<Order_By>;
};

/** update columns of table "order_scheduler" */
export enum Order_Scheduler_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DriverVehicleId = 'driver_vehicle_id',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrganizationAddressId = 'organization_address_id',
  /** column name */
  OrganizationUserId = 'organization_user_id',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  PartnerLocalitiesId = 'partner_localities_id',
  /** column name */
  PocDetails = 'poc_details',
  /** column name */
  PocDetailsOther = 'poc_details_other',
  /** column name */
  PocNumber = 'poc_number',
  /** column name */
  PocNumberOther = 'poc_number_other',
  /** column name */
  ProductVariationId = 'product_variation_id',
  /** column name */
  Remark = 'remark',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  TotalQuantityLimit = 'total_quantity_limit',
  /** column name */
  TotalQuantityLimitLeft = 'total_quantity_limit_left'
}

export type Order_Scheduler_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Order_Scheduler_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Order_Scheduler_Set_Input>;
  /** filter the rows which have to be updated */
  where: Order_Scheduler_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Order_Scheduler_Var_Pop_Fields = {
  __typename?: 'order_scheduler_var_pop_fields';
  total_quantity_limit?: Maybe<Scalars['Float']['output']>;
  total_quantity_limit_left?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "order_scheduler" */
export type Order_Scheduler_Var_Pop_Order_By = {
  total_quantity_limit?: InputMaybe<Order_By>;
  total_quantity_limit_left?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Order_Scheduler_Var_Samp_Fields = {
  __typename?: 'order_scheduler_var_samp_fields';
  total_quantity_limit?: Maybe<Scalars['Float']['output']>;
  total_quantity_limit_left?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "order_scheduler" */
export type Order_Scheduler_Var_Samp_Order_By = {
  total_quantity_limit?: InputMaybe<Order_By>;
  total_quantity_limit_left?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Order_Scheduler_Variance_Fields = {
  __typename?: 'order_scheduler_variance_fields';
  total_quantity_limit?: Maybe<Scalars['Float']['output']>;
  total_quantity_limit_left?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "order_scheduler" */
export type Order_Scheduler_Variance_Order_By = {
  total_quantity_limit?: InputMaybe<Order_By>;
  total_quantity_limit_left?: InputMaybe<Order_By>;
};

/** columns and relationships of "order_type" */
export type Order_Type = {
  __typename?: 'order_type';
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  customer_orders: Array<Customer_Order>;
  /** An aggregate relationship */
  customer_orders_aggregate: Customer_Order_Aggregate;
  /** An array relationship */
  partner_orders: Array<Partner_Order>;
  /** An aggregate relationship */
  partner_orders_aggregate: Partner_Order_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "order_type" */
export type Order_TypeCustomer_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Order_By>>;
  where?: InputMaybe<Customer_Order_Bool_Exp>;
};


/** columns and relationships of "order_type" */
export type Order_TypeCustomer_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Order_By>>;
  where?: InputMaybe<Customer_Order_Bool_Exp>;
};


/** columns and relationships of "order_type" */
export type Order_TypePartner_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Order_By>>;
  where?: InputMaybe<Partner_Order_Bool_Exp>;
};


/** columns and relationships of "order_type" */
export type Order_TypePartner_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Order_By>>;
  where?: InputMaybe<Partner_Order_Bool_Exp>;
};

/** aggregated selection of "order_type" */
export type Order_Type_Aggregate = {
  __typename?: 'order_type_aggregate';
  aggregate?: Maybe<Order_Type_Aggregate_Fields>;
  nodes: Array<Order_Type>;
};

/** aggregate fields of "order_type" */
export type Order_Type_Aggregate_Fields = {
  __typename?: 'order_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Order_Type_Max_Fields>;
  min?: Maybe<Order_Type_Min_Fields>;
};


/** aggregate fields of "order_type" */
export type Order_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Order_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "order_type". All fields are combined with a logical 'AND'. */
export type Order_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Type_Bool_Exp>>;
  _not?: InputMaybe<Order_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  customer_orders?: InputMaybe<Customer_Order_Bool_Exp>;
  customer_orders_aggregate?: InputMaybe<Customer_Order_Aggregate_Bool_Exp>;
  partner_orders?: InputMaybe<Partner_Order_Bool_Exp>;
  partner_orders_aggregate?: InputMaybe<Partner_Order_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "order_type" */
export enum Order_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  OrderTypePkey = 'order_type_pkey'
}

export enum Order_Type_Enum {
  /** DELIVERY */
  Delivery = 'DELIVERY',
  /** PICK_UP */
  PickUp = 'PICK_UP',
  /** SERVICE */
  Service = 'SERVICE',
  /** TRIP */
  Trip = 'TRIP'
}

/** Boolean expression to compare columns of type "order_type_enum". All fields are combined with logical 'AND'. */
export type Order_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Order_Type_Enum>;
  _in?: InputMaybe<Array<Order_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Order_Type_Enum>;
  _nin?: InputMaybe<Array<Order_Type_Enum>>;
};

/** input type for inserting data into table "order_type" */
export type Order_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  customer_orders?: InputMaybe<Customer_Order_Arr_Rel_Insert_Input>;
  partner_orders?: InputMaybe<Partner_Order_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Order_Type_Max_Fields = {
  __typename?: 'order_type_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Order_Type_Min_Fields = {
  __typename?: 'order_type_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "order_type" */
export type Order_Type_Mutation_Response = {
  __typename?: 'order_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Order_Type>;
};

/** input type for inserting object relation for remote table "order_type" */
export type Order_Type_Obj_Rel_Insert_Input = {
  data: Order_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Order_Type_On_Conflict>;
};

/** on_conflict condition type for table "order_type" */
export type Order_Type_On_Conflict = {
  constraint: Order_Type_Constraint;
  update_columns?: Array<Order_Type_Update_Column>;
  where?: InputMaybe<Order_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "order_type". */
export type Order_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  customer_orders_aggregate?: InputMaybe<Customer_Order_Aggregate_Order_By>;
  partner_orders_aggregate?: InputMaybe<Partner_Order_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: order_type */
export type Order_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "order_type" */
export enum Order_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "order_type" */
export type Order_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "order_type" */
export type Order_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "order_type" */
export enum Order_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Order_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Order_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Order_Type_Bool_Exp;
};

export type OrdersInput = {
  customer_id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  limit?: InputMaybe<Scalars['numeric']['input']>;
  offset?: InputMaybe<Scalars['numeric']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  state?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  taskidflag?: InputMaybe<Scalars['Boolean']['input']>;
  taskstate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OrdersOutput = {
  __typename?: 'ordersOutput';
  data?: Maybe<Scalars['jsonb']['output']>;
};

/** columns and relationships of "organization" */
export type Organization = {
  __typename?: 'organization';
  alias_name?: Maybe<Scalars['String']['output']>;
  allowed_credit_limit?: Maybe<Scalars['numeric']['output']>;
  /** An array relationship */
  audit_logs: Array<Organization_Audit_Log>;
  /** An aggregate relationship */
  audit_logs_aggregate: Organization_Audit_Log_Aggregate;
  bd_name?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  brand_logo?: Maybe<Scalars['String']['output']>;
  cin_number?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  credit_breaches: Array<Credit_Breach>;
  /** An aggregate relationship */
  credit_breaches_aggregate: Credit_Breach_Aggregate;
  /** An object relationship */
  currency: Currency;
  customer_code?: Maybe<Scalars['Int']['output']>;
  customer_erp_code?: Maybe<Scalars['String']['output']>;
  default_currency: Scalars['uuid']['output'];
  delivery_charge_id?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  dispensing_rules: Array<Dispensing_Rules>;
  /** An aggregate relationship */
  dispensing_rules_aggregate: Dispensing_Rules_Aggregate;
  fueltrans_customer_id?: Maybe<Scalars['String']['output']>;
  gst_number?: Maybe<Scalars['String']['output']>;
  head_office_general_email?: Maybe<Scalars['String']['output']>;
  head_office_general_phone_number?: Maybe<Scalars['String']['output']>;
  holding_company: Scalars['Boolean']['output'];
  holding_company_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  invitations: Array<Invitation>;
  /** An aggregate relationship */
  invitations_aggregate: Invitation_Aggregate;
  invoice_email?: Maybe<Scalars['String']['output']>;
  invoices_uploaded: Scalars['Boolean']['output'];
  is_active: Scalars['Boolean']['output'];
  is_business: Scalars['Boolean']['output'];
  is_post_paid?: Maybe<Scalars['Boolean']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  limit_purchase_orders: Array<Limit_Purchase_Order>;
  /** An aggregate relationship */
  limit_purchase_orders_aggregate: Limit_Purchase_Order_Aggregate;
  /** An array relationship */
  lpo_exceptions: Array<Lpo_Exception>;
  /** An aggregate relationship */
  lpo_exceptions_aggregate: Lpo_Exception_Aggregate;
  name?: Maybe<Scalars['String']['output']>;
  org_type?: Maybe<Organization_Type_Enum>;
  /** An array relationship */
  organization_addresses: Array<Organization_Address>;
  /** An aggregate relationship */
  organization_addresses_aggregate: Organization_Address_Aggregate;
  /** An array relationship */
  organization_configurations: Array<Organization_Configuration>;
  /** An aggregate relationship */
  organization_configurations_aggregate: Organization_Configuration_Aggregate;
  /** An array relationship */
  organization_product_variation_discount_histories: Array<Organization_Product_Variation_Discount_History>;
  /** An aggregate relationship */
  organization_product_variation_discount_histories_aggregate: Organization_Product_Variation_Discount_History_Aggregate;
  /** An array relationship */
  organization_product_variation_discounts: Array<Organization_Product_Variation_Discount>;
  /** An aggregate relationship */
  organization_product_variation_discounts_aggregate: Organization_Product_Variation_Discount_Aggregate;
  /** An array relationship */
  organization_sales_projections: Array<Organization_Sales_Projection>;
  /** An aggregate relationship */
  organization_sales_projections_aggregate: Organization_Sales_Projection_Aggregate;
  /** An array relationship */
  organization_timings: Array<Organization_Timing>;
  /** An aggregate relationship */
  organization_timings_aggregate: Organization_Timing_Aggregate;
  /** An object relationship */
  organization_type?: Maybe<Organization_Type>;
  /** An array relationship */
  organization_users: Array<Organization_User>;
  /** An aggregate relationship */
  organization_users_aggregate: Organization_User_Aggregate;
  pan_number?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  script?: Maybe<Scripts>;
  signed_invoice_on_email: Scalars['Boolean']['output'];
  /** An array relationship */
  subsidiaries: Array<Subsidiary>;
  /** An aggregate relationship */
  subsidiaries_aggregate: Subsidiary_Aggregate;
  technical_contact_email?: Maybe<Scalars['String']['output']>;
  technical_contact_full_name?: Maybe<Scalars['String']['output']>;
  technical_contact_phone_number?: Maybe<Scalars['String']['output']>;
  trade_license?: Maybe<Scalars['String']['output']>;
  verified_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  wallet?: Maybe<Wallet>;
  /** An array relationship */
  wallet_exceptions: Array<Wallet_Exception>;
  /** An aggregate relationship */
  wallet_exceptions_aggregate: Wallet_Exception_Aggregate;
  /** An array relationship */
  wallets: Array<Wallet>;
  /** An aggregate relationship */
  wallets_aggregate: Wallet_Aggregate;
  website_url?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "organization" */
export type OrganizationAudit_LogsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Audit_Log_Order_By>>;
  where?: InputMaybe<Organization_Audit_Log_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationAudit_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Audit_Log_Order_By>>;
  where?: InputMaybe<Organization_Audit_Log_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationCredit_BreachesArgs = {
  distinct_on?: InputMaybe<Array<Credit_Breach_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Breach_Order_By>>;
  where?: InputMaybe<Credit_Breach_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationCredit_Breaches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Breach_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Breach_Order_By>>;
  where?: InputMaybe<Credit_Breach_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationDispensing_RulesArgs = {
  distinct_on?: InputMaybe<Array<Dispensing_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dispensing_Rules_Order_By>>;
  where?: InputMaybe<Dispensing_Rules_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationDispensing_Rules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dispensing_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dispensing_Rules_Order_By>>;
  where?: InputMaybe<Dispensing_Rules_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationInvitationsArgs = {
  distinct_on?: InputMaybe<Array<Invitation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invitation_Order_By>>;
  where?: InputMaybe<Invitation_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationInvitations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invitation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invitation_Order_By>>;
  where?: InputMaybe<Invitation_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationLimit_Purchase_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Limit_Purchase_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Limit_Purchase_Order_Order_By>>;
  where?: InputMaybe<Limit_Purchase_Order_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationLimit_Purchase_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Limit_Purchase_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Limit_Purchase_Order_Order_By>>;
  where?: InputMaybe<Limit_Purchase_Order_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationLpo_ExceptionsArgs = {
  distinct_on?: InputMaybe<Array<Lpo_Exception_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lpo_Exception_Order_By>>;
  where?: InputMaybe<Lpo_Exception_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationLpo_Exceptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lpo_Exception_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lpo_Exception_Order_By>>;
  where?: InputMaybe<Lpo_Exception_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationOrganization_AddressesArgs = {
  distinct_on?: InputMaybe<Array<Organization_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Address_Order_By>>;
  where?: InputMaybe<Organization_Address_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationOrganization_Addresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Address_Order_By>>;
  where?: InputMaybe<Organization_Address_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationOrganization_ConfigurationsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Configuration_Order_By>>;
  where?: InputMaybe<Organization_Configuration_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationOrganization_Configurations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Configuration_Order_By>>;
  where?: InputMaybe<Organization_Configuration_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationOrganization_Product_Variation_Discount_HistoriesArgs = {
  distinct_on?: InputMaybe<Array<Organization_Product_Variation_Discount_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Product_Variation_Discount_History_Order_By>>;
  where?: InputMaybe<Organization_Product_Variation_Discount_History_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationOrganization_Product_Variation_Discount_Histories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Product_Variation_Discount_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Product_Variation_Discount_History_Order_By>>;
  where?: InputMaybe<Organization_Product_Variation_Discount_History_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationOrganization_Product_Variation_DiscountsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Product_Variation_Discount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Product_Variation_Discount_Order_By>>;
  where?: InputMaybe<Organization_Product_Variation_Discount_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationOrganization_Product_Variation_Discounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Product_Variation_Discount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Product_Variation_Discount_Order_By>>;
  where?: InputMaybe<Organization_Product_Variation_Discount_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationOrganization_Sales_ProjectionsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Sales_Projection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Sales_Projection_Order_By>>;
  where?: InputMaybe<Organization_Sales_Projection_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationOrganization_Sales_Projections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Sales_Projection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Sales_Projection_Order_By>>;
  where?: InputMaybe<Organization_Sales_Projection_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationOrganization_TimingsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Timing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Timing_Order_By>>;
  where?: InputMaybe<Organization_Timing_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationOrganization_Timings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Timing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Timing_Order_By>>;
  where?: InputMaybe<Organization_Timing_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationOrganization_UsersArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Order_By>>;
  where?: InputMaybe<Organization_User_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationOrganization_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Order_By>>;
  where?: InputMaybe<Organization_User_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationSubsidiariesArgs = {
  distinct_on?: InputMaybe<Array<Subsidiary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subsidiary_Order_By>>;
  where?: InputMaybe<Subsidiary_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationSubsidiaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subsidiary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subsidiary_Order_By>>;
  where?: InputMaybe<Subsidiary_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationWallet_ExceptionsArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Exception_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Exception_Order_By>>;
  where?: InputMaybe<Wallet_Exception_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationWallet_Exceptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Exception_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Exception_Order_By>>;
  where?: InputMaybe<Wallet_Exception_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationWalletsArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Order_By>>;
  where?: InputMaybe<Wallet_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationWallets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Order_By>>;
  where?: InputMaybe<Wallet_Bool_Exp>;
};

/** columns and relationships of "organization_address" */
export type Organization_Address = {
  __typename?: 'organization_address';
  /** An object relationship */
  addressTypeByAddressType?: Maybe<Address_Type>;
  address_alias?: Maybe<Scalars['String']['output']>;
  address_line1?: Maybe<Scalars['String']['output']>;
  address_line2?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  address_subsidiaries: Array<Address_Subsidiary>;
  /** An aggregate relationship */
  address_subsidiaries_aggregate: Address_Subsidiary_Aggregate;
  /** An array relationship */
  address_subsidiary_audit_logs: Array<Address_Subsidiary_Audit_Logs>;
  /** An aggregate relationship */
  address_subsidiary_audit_logs_aggregate: Address_Subsidiary_Audit_Logs_Aggregate;
  address_type?: Maybe<Address_Type_Enum>;
  area?: Maybe<Scalars['geometry']['output']>;
  /** An object relationship */
  city?: Maybe<City>;
  city_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  country?: Maybe<Country>;
  country_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  customerOrdersByShippingAddressId: Array<Customer_Order>;
  /** An aggregate relationship */
  customerOrdersByShippingAddressId_aggregate: Customer_Order_Aggregate;
  /** An array relationship */
  customer_orders: Array<Customer_Order>;
  /** An aggregate relationship */
  customer_orders_aggregate: Customer_Order_Aggregate;
  erp_code?: Maybe<Scalars['String']['output']>;
  gst_number?: Maybe<Scalars['String']['output']>;
  house_number?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  instruction?: Maybe<Scalars['String']['output']>;
  is_active: Scalars['Boolean']['output'];
  landMark?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  limit_purchase_orders: Array<Limit_Purchase_Order>;
  /** An aggregate relationship */
  limit_purchase_orders_aggregate: Limit_Purchase_Order_Aggregate;
  localities_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  locality?: Maybe<Localities>;
  location?: Maybe<Scalars['point']['output']>;
  /** An array relationship */
  lpo_exceptions: Array<Lpo_Exception>;
  /** An aggregate relationship */
  lpo_exceptions_aggregate: Lpo_Exception_Aggregate;
  map_link?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  master_slots: Array<Master_Slot>;
  /** An aggregate relationship */
  master_slots_aggregate: Master_Slot_Aggregate;
  name: Scalars['String']['output'];
  /** An array relationship */
  order_schedulers: Array<Order_Scheduler>;
  /** An aggregate relationship */
  order_schedulers_aggregate: Order_Scheduler_Aggregate;
  /** An object relationship */
  organization?: Maybe<Organization>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  organization_user?: Maybe<Organization_User>;
  organization_user_id?: Maybe<Scalars['uuid']['output']>;
  ownership?: Maybe<Scalars['String']['output']>;
  partner_localities_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  partner_locality?: Maybe<Partner_Localities>;
  pincode?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  state?: Maybe<State>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_address?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  tasks: Array<Task>;
  /** An aggregate relationship */
  tasks_aggregate: Task_Aggregate;
  /** An array relationship */
  vendor_order_logs: Array<Vendor_Order_Logs>;
  /** An aggregate relationship */
  vendor_order_logs_aggregate: Vendor_Order_Logs_Aggregate;
};


/** columns and relationships of "organization_address" */
export type Organization_AddressAddress_SubsidiariesArgs = {
  distinct_on?: InputMaybe<Array<Address_Subsidiary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Address_Subsidiary_Order_By>>;
  where?: InputMaybe<Address_Subsidiary_Bool_Exp>;
};


/** columns and relationships of "organization_address" */
export type Organization_AddressAddress_Subsidiaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Subsidiary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Address_Subsidiary_Order_By>>;
  where?: InputMaybe<Address_Subsidiary_Bool_Exp>;
};


/** columns and relationships of "organization_address" */
export type Organization_AddressAddress_Subsidiary_Audit_LogsArgs = {
  distinct_on?: InputMaybe<Array<Address_Subsidiary_Audit_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Address_Subsidiary_Audit_Logs_Order_By>>;
  where?: InputMaybe<Address_Subsidiary_Audit_Logs_Bool_Exp>;
};


/** columns and relationships of "organization_address" */
export type Organization_AddressAddress_Subsidiary_Audit_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Subsidiary_Audit_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Address_Subsidiary_Audit_Logs_Order_By>>;
  where?: InputMaybe<Address_Subsidiary_Audit_Logs_Bool_Exp>;
};


/** columns and relationships of "organization_address" */
export type Organization_AddressCustomerOrdersByShippingAddressIdArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Order_By>>;
  where?: InputMaybe<Customer_Order_Bool_Exp>;
};


/** columns and relationships of "organization_address" */
export type Organization_AddressCustomerOrdersByShippingAddressId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Order_By>>;
  where?: InputMaybe<Customer_Order_Bool_Exp>;
};


/** columns and relationships of "organization_address" */
export type Organization_AddressCustomer_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Order_By>>;
  where?: InputMaybe<Customer_Order_Bool_Exp>;
};


/** columns and relationships of "organization_address" */
export type Organization_AddressCustomer_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Order_By>>;
  where?: InputMaybe<Customer_Order_Bool_Exp>;
};


/** columns and relationships of "organization_address" */
export type Organization_AddressLimit_Purchase_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Limit_Purchase_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Limit_Purchase_Order_Order_By>>;
  where?: InputMaybe<Limit_Purchase_Order_Bool_Exp>;
};


/** columns and relationships of "organization_address" */
export type Organization_AddressLimit_Purchase_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Limit_Purchase_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Limit_Purchase_Order_Order_By>>;
  where?: InputMaybe<Limit_Purchase_Order_Bool_Exp>;
};


/** columns and relationships of "organization_address" */
export type Organization_AddressLpo_ExceptionsArgs = {
  distinct_on?: InputMaybe<Array<Lpo_Exception_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lpo_Exception_Order_By>>;
  where?: InputMaybe<Lpo_Exception_Bool_Exp>;
};


/** columns and relationships of "organization_address" */
export type Organization_AddressLpo_Exceptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lpo_Exception_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lpo_Exception_Order_By>>;
  where?: InputMaybe<Lpo_Exception_Bool_Exp>;
};


/** columns and relationships of "organization_address" */
export type Organization_AddressMaster_SlotsArgs = {
  distinct_on?: InputMaybe<Array<Master_Slot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Slot_Order_By>>;
  where?: InputMaybe<Master_Slot_Bool_Exp>;
};


/** columns and relationships of "organization_address" */
export type Organization_AddressMaster_Slots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Master_Slot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Slot_Order_By>>;
  where?: InputMaybe<Master_Slot_Bool_Exp>;
};


/** columns and relationships of "organization_address" */
export type Organization_AddressOrder_SchedulersArgs = {
  distinct_on?: InputMaybe<Array<Order_Scheduler_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Scheduler_Order_By>>;
  where?: InputMaybe<Order_Scheduler_Bool_Exp>;
};


/** columns and relationships of "organization_address" */
export type Organization_AddressOrder_Schedulers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Scheduler_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Scheduler_Order_By>>;
  where?: InputMaybe<Order_Scheduler_Bool_Exp>;
};


/** columns and relationships of "organization_address" */
export type Organization_AddressTasksArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


/** columns and relationships of "organization_address" */
export type Organization_AddressTasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


/** columns and relationships of "organization_address" */
export type Organization_AddressVendor_Order_LogsArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Order_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Order_Logs_Order_By>>;
  where?: InputMaybe<Vendor_Order_Logs_Bool_Exp>;
};


/** columns and relationships of "organization_address" */
export type Organization_AddressVendor_Order_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Order_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Order_Logs_Order_By>>;
  where?: InputMaybe<Vendor_Order_Logs_Bool_Exp>;
};

/** aggregated selection of "organization_address" */
export type Organization_Address_Aggregate = {
  __typename?: 'organization_address_aggregate';
  aggregate?: Maybe<Organization_Address_Aggregate_Fields>;
  nodes: Array<Organization_Address>;
};

export type Organization_Address_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Organization_Address_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Organization_Address_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Organization_Address_Aggregate_Bool_Exp_Count>;
};

export type Organization_Address_Aggregate_Bool_Exp_Bool_And = {
  arguments: Organization_Address_Select_Column_Organization_Address_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Address_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organization_Address_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Organization_Address_Select_Column_Organization_Address_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Address_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organization_Address_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organization_Address_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Address_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organization_address" */
export type Organization_Address_Aggregate_Fields = {
  __typename?: 'organization_address_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_Address_Max_Fields>;
  min?: Maybe<Organization_Address_Min_Fields>;
};


/** aggregate fields of "organization_address" */
export type Organization_Address_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Address_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organization_address" */
export type Organization_Address_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Address_Max_Order_By>;
  min?: InputMaybe<Organization_Address_Min_Order_By>;
};

/** input type for inserting array relation for remote table "organization_address" */
export type Organization_Address_Arr_Rel_Insert_Input = {
  data: Array<Organization_Address_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Address_On_Conflict>;
};

/** Boolean expression to filter rows from the table "organization_address". All fields are combined with a logical 'AND'. */
export type Organization_Address_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Address_Bool_Exp>>;
  _not?: InputMaybe<Organization_Address_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Address_Bool_Exp>>;
  addressTypeByAddressType?: InputMaybe<Address_Type_Bool_Exp>;
  address_alias?: InputMaybe<String_Comparison_Exp>;
  address_line1?: InputMaybe<String_Comparison_Exp>;
  address_line2?: InputMaybe<String_Comparison_Exp>;
  address_subsidiaries?: InputMaybe<Address_Subsidiary_Bool_Exp>;
  address_subsidiaries_aggregate?: InputMaybe<Address_Subsidiary_Aggregate_Bool_Exp>;
  address_subsidiary_audit_logs?: InputMaybe<Address_Subsidiary_Audit_Logs_Bool_Exp>;
  address_subsidiary_audit_logs_aggregate?: InputMaybe<Address_Subsidiary_Audit_Logs_Aggregate_Bool_Exp>;
  address_type?: InputMaybe<Address_Type_Enum_Comparison_Exp>;
  area?: InputMaybe<Geometry_Comparison_Exp>;
  city?: InputMaybe<City_Bool_Exp>;
  city_id?: InputMaybe<Uuid_Comparison_Exp>;
  country?: InputMaybe<Country_Bool_Exp>;
  country_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customerOrdersByShippingAddressId?: InputMaybe<Customer_Order_Bool_Exp>;
  customerOrdersByShippingAddressId_aggregate?: InputMaybe<Customer_Order_Aggregate_Bool_Exp>;
  customer_orders?: InputMaybe<Customer_Order_Bool_Exp>;
  customer_orders_aggregate?: InputMaybe<Customer_Order_Aggregate_Bool_Exp>;
  erp_code?: InputMaybe<String_Comparison_Exp>;
  gst_number?: InputMaybe<String_Comparison_Exp>;
  house_number?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  instruction?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  landMark?: InputMaybe<String_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  limit_purchase_orders?: InputMaybe<Limit_Purchase_Order_Bool_Exp>;
  limit_purchase_orders_aggregate?: InputMaybe<Limit_Purchase_Order_Aggregate_Bool_Exp>;
  localities_id?: InputMaybe<Uuid_Comparison_Exp>;
  locality?: InputMaybe<Localities_Bool_Exp>;
  location?: InputMaybe<Point_Comparison_Exp>;
  lpo_exceptions?: InputMaybe<Lpo_Exception_Bool_Exp>;
  lpo_exceptions_aggregate?: InputMaybe<Lpo_Exception_Aggregate_Bool_Exp>;
  map_link?: InputMaybe<String_Comparison_Exp>;
  master_slots?: InputMaybe<Master_Slot_Bool_Exp>;
  master_slots_aggregate?: InputMaybe<Master_Slot_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order_schedulers?: InputMaybe<Order_Scheduler_Bool_Exp>;
  order_schedulers_aggregate?: InputMaybe<Order_Scheduler_Aggregate_Bool_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  organization_user?: InputMaybe<Organization_User_Bool_Exp>;
  organization_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  ownership?: InputMaybe<String_Comparison_Exp>;
  partner_localities_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner_locality?: InputMaybe<Partner_Localities_Bool_Exp>;
  pincode?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<State_Bool_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  street_address?: InputMaybe<String_Comparison_Exp>;
  tasks?: InputMaybe<Task_Bool_Exp>;
  tasks_aggregate?: InputMaybe<Task_Aggregate_Bool_Exp>;
  vendor_order_logs?: InputMaybe<Vendor_Order_Logs_Bool_Exp>;
  vendor_order_logs_aggregate?: InputMaybe<Vendor_Order_Logs_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "organization_address" */
export enum Organization_Address_Constraint {
  /** unique or primary key constraint on columns "erp_code" */
  OrganizationAddressErpCodeKey = 'organization_address_erp_code_key',
  /** unique or primary key constraint on columns "id" */
  OrganizationAddressPkey = 'organization_address_pkey'
}

/** input type for inserting data into table "organization_address" */
export type Organization_Address_Insert_Input = {
  addressTypeByAddressType?: InputMaybe<Address_Type_Obj_Rel_Insert_Input>;
  address_alias?: InputMaybe<Scalars['String']['input']>;
  address_line1?: InputMaybe<Scalars['String']['input']>;
  address_line2?: InputMaybe<Scalars['String']['input']>;
  address_subsidiaries?: InputMaybe<Address_Subsidiary_Arr_Rel_Insert_Input>;
  address_subsidiary_audit_logs?: InputMaybe<Address_Subsidiary_Audit_Logs_Arr_Rel_Insert_Input>;
  address_type?: InputMaybe<Address_Type_Enum>;
  area?: InputMaybe<Scalars['geometry']['input']>;
  city?: InputMaybe<City_Obj_Rel_Insert_Input>;
  city_id?: InputMaybe<Scalars['uuid']['input']>;
  country?: InputMaybe<Country_Obj_Rel_Insert_Input>;
  country_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customerOrdersByShippingAddressId?: InputMaybe<Customer_Order_Arr_Rel_Insert_Input>;
  customer_orders?: InputMaybe<Customer_Order_Arr_Rel_Insert_Input>;
  erp_code?: InputMaybe<Scalars['String']['input']>;
  gst_number?: InputMaybe<Scalars['String']['input']>;
  house_number?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  instruction?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  landMark?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  limit_purchase_orders?: InputMaybe<Limit_Purchase_Order_Arr_Rel_Insert_Input>;
  localities_id?: InputMaybe<Scalars['uuid']['input']>;
  locality?: InputMaybe<Localities_Obj_Rel_Insert_Input>;
  location?: InputMaybe<Scalars['point']['input']>;
  lpo_exceptions?: InputMaybe<Lpo_Exception_Arr_Rel_Insert_Input>;
  map_link?: InputMaybe<Scalars['String']['input']>;
  master_slots?: InputMaybe<Master_Slot_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_schedulers?: InputMaybe<Order_Scheduler_Arr_Rel_Insert_Input>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_user?: InputMaybe<Organization_User_Obj_Rel_Insert_Input>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  ownership?: InputMaybe<Scalars['String']['input']>;
  partner_localities_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_locality?: InputMaybe<Partner_Localities_Obj_Rel_Insert_Input>;
  pincode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<State_Obj_Rel_Insert_Input>;
  state_id?: InputMaybe<Scalars['uuid']['input']>;
  street_address?: InputMaybe<Scalars['String']['input']>;
  tasks?: InputMaybe<Task_Arr_Rel_Insert_Input>;
  vendor_order_logs?: InputMaybe<Vendor_Order_Logs_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Organization_Address_Max_Fields = {
  __typename?: 'organization_address_max_fields';
  address_alias?: Maybe<Scalars['String']['output']>;
  address_line1?: Maybe<Scalars['String']['output']>;
  address_line2?: Maybe<Scalars['String']['output']>;
  city_id?: Maybe<Scalars['uuid']['output']>;
  country_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  erp_code?: Maybe<Scalars['String']['output']>;
  gst_number?: Maybe<Scalars['String']['output']>;
  house_number?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  instruction?: Maybe<Scalars['String']['output']>;
  landMark?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  localities_id?: Maybe<Scalars['uuid']['output']>;
  map_link?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  organization_user_id?: Maybe<Scalars['uuid']['output']>;
  ownership?: Maybe<Scalars['String']['output']>;
  partner_localities_id?: Maybe<Scalars['uuid']['output']>;
  pincode?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_address?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "organization_address" */
export type Organization_Address_Max_Order_By = {
  address_alias?: InputMaybe<Order_By>;
  address_line1?: InputMaybe<Order_By>;
  address_line2?: InputMaybe<Order_By>;
  city_id?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  erp_code?: InputMaybe<Order_By>;
  gst_number?: InputMaybe<Order_By>;
  house_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instruction?: InputMaybe<Order_By>;
  landMark?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  localities_id?: InputMaybe<Order_By>;
  map_link?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
  ownership?: InputMaybe<Order_By>;
  partner_localities_id?: InputMaybe<Order_By>;
  pincode?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_address?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organization_Address_Min_Fields = {
  __typename?: 'organization_address_min_fields';
  address_alias?: Maybe<Scalars['String']['output']>;
  address_line1?: Maybe<Scalars['String']['output']>;
  address_line2?: Maybe<Scalars['String']['output']>;
  city_id?: Maybe<Scalars['uuid']['output']>;
  country_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  erp_code?: Maybe<Scalars['String']['output']>;
  gst_number?: Maybe<Scalars['String']['output']>;
  house_number?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  instruction?: Maybe<Scalars['String']['output']>;
  landMark?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  localities_id?: Maybe<Scalars['uuid']['output']>;
  map_link?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  organization_user_id?: Maybe<Scalars['uuid']['output']>;
  ownership?: Maybe<Scalars['String']['output']>;
  partner_localities_id?: Maybe<Scalars['uuid']['output']>;
  pincode?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_address?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "organization_address" */
export type Organization_Address_Min_Order_By = {
  address_alias?: InputMaybe<Order_By>;
  address_line1?: InputMaybe<Order_By>;
  address_line2?: InputMaybe<Order_By>;
  city_id?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  erp_code?: InputMaybe<Order_By>;
  gst_number?: InputMaybe<Order_By>;
  house_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instruction?: InputMaybe<Order_By>;
  landMark?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  localities_id?: InputMaybe<Order_By>;
  map_link?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
  ownership?: InputMaybe<Order_By>;
  partner_localities_id?: InputMaybe<Order_By>;
  pincode?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_address?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization_address" */
export type Organization_Address_Mutation_Response = {
  __typename?: 'organization_address_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Address>;
};

/** input type for inserting object relation for remote table "organization_address" */
export type Organization_Address_Obj_Rel_Insert_Input = {
  data: Organization_Address_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Address_On_Conflict>;
};

/** on_conflict condition type for table "organization_address" */
export type Organization_Address_On_Conflict = {
  constraint: Organization_Address_Constraint;
  update_columns?: Array<Organization_Address_Update_Column>;
  where?: InputMaybe<Organization_Address_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_address". */
export type Organization_Address_Order_By = {
  addressTypeByAddressType?: InputMaybe<Address_Type_Order_By>;
  address_alias?: InputMaybe<Order_By>;
  address_line1?: InputMaybe<Order_By>;
  address_line2?: InputMaybe<Order_By>;
  address_subsidiaries_aggregate?: InputMaybe<Address_Subsidiary_Aggregate_Order_By>;
  address_subsidiary_audit_logs_aggregate?: InputMaybe<Address_Subsidiary_Audit_Logs_Aggregate_Order_By>;
  address_type?: InputMaybe<Order_By>;
  area?: InputMaybe<Order_By>;
  city?: InputMaybe<City_Order_By>;
  city_id?: InputMaybe<Order_By>;
  country?: InputMaybe<Country_Order_By>;
  country_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customerOrdersByShippingAddressId_aggregate?: InputMaybe<Customer_Order_Aggregate_Order_By>;
  customer_orders_aggregate?: InputMaybe<Customer_Order_Aggregate_Order_By>;
  erp_code?: InputMaybe<Order_By>;
  gst_number?: InputMaybe<Order_By>;
  house_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instruction?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  landMark?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  limit_purchase_orders_aggregate?: InputMaybe<Limit_Purchase_Order_Aggregate_Order_By>;
  localities_id?: InputMaybe<Order_By>;
  locality?: InputMaybe<Localities_Order_By>;
  location?: InputMaybe<Order_By>;
  lpo_exceptions_aggregate?: InputMaybe<Lpo_Exception_Aggregate_Order_By>;
  map_link?: InputMaybe<Order_By>;
  master_slots_aggregate?: InputMaybe<Master_Slot_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  order_schedulers_aggregate?: InputMaybe<Order_Scheduler_Aggregate_Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  organization_user?: InputMaybe<Organization_User_Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
  ownership?: InputMaybe<Order_By>;
  partner_localities_id?: InputMaybe<Order_By>;
  partner_locality?: InputMaybe<Partner_Localities_Order_By>;
  pincode?: InputMaybe<Order_By>;
  state?: InputMaybe<State_Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_address?: InputMaybe<Order_By>;
  tasks_aggregate?: InputMaybe<Task_Aggregate_Order_By>;
  vendor_order_logs_aggregate?: InputMaybe<Vendor_Order_Logs_Aggregate_Order_By>;
};

/** primary key columns input for table: organization_address */
export type Organization_Address_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organization_address" */
export enum Organization_Address_Select_Column {
  /** column name */
  AddressAlias = 'address_alias',
  /** column name */
  AddressLine1 = 'address_line1',
  /** column name */
  AddressLine2 = 'address_line2',
  /** column name */
  AddressType = 'address_type',
  /** column name */
  Area = 'area',
  /** column name */
  CityId = 'city_id',
  /** column name */
  CountryId = 'country_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ErpCode = 'erp_code',
  /** column name */
  GstNumber = 'gst_number',
  /** column name */
  HouseNumber = 'house_number',
  /** column name */
  Id = 'id',
  /** column name */
  Instruction = 'instruction',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LandMark = 'landMark',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  LocalitiesId = 'localities_id',
  /** column name */
  Location = 'location',
  /** column name */
  MapLink = 'map_link',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  OrganizationUserId = 'organization_user_id',
  /** column name */
  Ownership = 'ownership',
  /** column name */
  PartnerLocalitiesId = 'partner_localities_id',
  /** column name */
  Pincode = 'pincode',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetAddress = 'street_address'
}

/** select "organization_address_aggregate_bool_exp_bool_and_arguments_columns" columns of table "organization_address" */
export enum Organization_Address_Select_Column_Organization_Address_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "organization_address_aggregate_bool_exp_bool_or_arguments_columns" columns of table "organization_address" */
export enum Organization_Address_Select_Column_Organization_Address_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "organization_address" */
export type Organization_Address_Set_Input = {
  address_alias?: InputMaybe<Scalars['String']['input']>;
  address_line1?: InputMaybe<Scalars['String']['input']>;
  address_line2?: InputMaybe<Scalars['String']['input']>;
  address_type?: InputMaybe<Address_Type_Enum>;
  area?: InputMaybe<Scalars['geometry']['input']>;
  city_id?: InputMaybe<Scalars['uuid']['input']>;
  country_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  erp_code?: InputMaybe<Scalars['String']['input']>;
  gst_number?: InputMaybe<Scalars['String']['input']>;
  house_number?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  instruction?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  landMark?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  localities_id?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['point']['input']>;
  map_link?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  ownership?: InputMaybe<Scalars['String']['input']>;
  partner_localities_id?: InputMaybe<Scalars['uuid']['input']>;
  pincode?: InputMaybe<Scalars['String']['input']>;
  state_id?: InputMaybe<Scalars['uuid']['input']>;
  street_address?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "organization_address" */
export type Organization_Address_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Address_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Address_Stream_Cursor_Value_Input = {
  address_alias?: InputMaybe<Scalars['String']['input']>;
  address_line1?: InputMaybe<Scalars['String']['input']>;
  address_line2?: InputMaybe<Scalars['String']['input']>;
  address_type?: InputMaybe<Address_Type_Enum>;
  area?: InputMaybe<Scalars['geometry']['input']>;
  city_id?: InputMaybe<Scalars['uuid']['input']>;
  country_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  erp_code?: InputMaybe<Scalars['String']['input']>;
  gst_number?: InputMaybe<Scalars['String']['input']>;
  house_number?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  instruction?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  landMark?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  localities_id?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['point']['input']>;
  map_link?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  ownership?: InputMaybe<Scalars['String']['input']>;
  partner_localities_id?: InputMaybe<Scalars['uuid']['input']>;
  pincode?: InputMaybe<Scalars['String']['input']>;
  state_id?: InputMaybe<Scalars['uuid']['input']>;
  street_address?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "organization_address" */
export enum Organization_Address_Update_Column {
  /** column name */
  AddressAlias = 'address_alias',
  /** column name */
  AddressLine1 = 'address_line1',
  /** column name */
  AddressLine2 = 'address_line2',
  /** column name */
  AddressType = 'address_type',
  /** column name */
  Area = 'area',
  /** column name */
  CityId = 'city_id',
  /** column name */
  CountryId = 'country_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ErpCode = 'erp_code',
  /** column name */
  GstNumber = 'gst_number',
  /** column name */
  HouseNumber = 'house_number',
  /** column name */
  Id = 'id',
  /** column name */
  Instruction = 'instruction',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LandMark = 'landMark',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  LocalitiesId = 'localities_id',
  /** column name */
  Location = 'location',
  /** column name */
  MapLink = 'map_link',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  OrganizationUserId = 'organization_user_id',
  /** column name */
  Ownership = 'ownership',
  /** column name */
  PartnerLocalitiesId = 'partner_localities_id',
  /** column name */
  Pincode = 'pincode',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetAddress = 'street_address'
}

export type Organization_Address_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Address_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Address_Bool_Exp;
};

/** aggregated selection of "organization" */
export type Organization_Aggregate = {
  __typename?: 'organization_aggregate';
  aggregate?: Maybe<Organization_Aggregate_Fields>;
  nodes: Array<Organization>;
};

export type Organization_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Organization_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Organization_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Organization_Aggregate_Bool_Exp_Count>;
};

export type Organization_Aggregate_Bool_Exp_Bool_And = {
  arguments: Organization_Select_Column_Organization_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organization_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Organization_Select_Column_Organization_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organization_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organization_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organization" */
export type Organization_Aggregate_Fields = {
  __typename?: 'organization_aggregate_fields';
  avg?: Maybe<Organization_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_Max_Fields>;
  min?: Maybe<Organization_Min_Fields>;
  stddev?: Maybe<Organization_Stddev_Fields>;
  stddev_pop?: Maybe<Organization_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organization_Stddev_Samp_Fields>;
  sum?: Maybe<Organization_Sum_Fields>;
  var_pop?: Maybe<Organization_Var_Pop_Fields>;
  var_samp?: Maybe<Organization_Var_Samp_Fields>;
  variance?: Maybe<Organization_Variance_Fields>;
};


/** aggregate fields of "organization" */
export type Organization_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organization" */
export type Organization_Aggregate_Order_By = {
  avg?: InputMaybe<Organization_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Max_Order_By>;
  min?: InputMaybe<Organization_Min_Order_By>;
  stddev?: InputMaybe<Organization_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Organization_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Organization_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Organization_Sum_Order_By>;
  var_pop?: InputMaybe<Organization_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Organization_Var_Samp_Order_By>;
  variance?: InputMaybe<Organization_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "organization" */
export type Organization_Arr_Rel_Insert_Input = {
  data: Array<Organization_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_On_Conflict>;
};

/** Audit trail for all changes to the organization table */
export type Organization_Audit_Log = {
  __typename?: 'organization_audit_log';
  action: Scalars['String']['output'];
  changed_fields?: Maybe<Array<Scalars['String']['output']>>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  new_data?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  organization: Organization;
  organization_id: Scalars['uuid']['output'];
  performed_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  performer?: Maybe<User>;
  previous_data?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  reason?: Maybe<Reasons>;
  /** Reference to reasons.id — required when is_active changes via toggleOrganizationActive, null otherwise */
  reason_id?: Maybe<Scalars['uuid']['output']>;
};


/** Audit trail for all changes to the organization table */
export type Organization_Audit_LogNew_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Audit trail for all changes to the organization table */
export type Organization_Audit_LogPrevious_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "organization_audit_log" */
export type Organization_Audit_Log_Aggregate = {
  __typename?: 'organization_audit_log_aggregate';
  aggregate?: Maybe<Organization_Audit_Log_Aggregate_Fields>;
  nodes: Array<Organization_Audit_Log>;
};

export type Organization_Audit_Log_Aggregate_Bool_Exp = {
  count?: InputMaybe<Organization_Audit_Log_Aggregate_Bool_Exp_Count>;
};

export type Organization_Audit_Log_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organization_Audit_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Audit_Log_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organization_audit_log" */
export type Organization_Audit_Log_Aggregate_Fields = {
  __typename?: 'organization_audit_log_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_Audit_Log_Max_Fields>;
  min?: Maybe<Organization_Audit_Log_Min_Fields>;
};


/** aggregate fields of "organization_audit_log" */
export type Organization_Audit_Log_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Audit_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organization_audit_log" */
export type Organization_Audit_Log_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Audit_Log_Max_Order_By>;
  min?: InputMaybe<Organization_Audit_Log_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Organization_Audit_Log_Append_Input = {
  new_data?: InputMaybe<Scalars['jsonb']['input']>;
  previous_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "organization_audit_log" */
export type Organization_Audit_Log_Arr_Rel_Insert_Input = {
  data: Array<Organization_Audit_Log_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Audit_Log_On_Conflict>;
};

/** Boolean expression to filter rows from the table "organization_audit_log". All fields are combined with a logical 'AND'. */
export type Organization_Audit_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Audit_Log_Bool_Exp>>;
  _not?: InputMaybe<Organization_Audit_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Audit_Log_Bool_Exp>>;
  action?: InputMaybe<String_Comparison_Exp>;
  changed_fields?: InputMaybe<String_Array_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  new_data?: InputMaybe<Jsonb_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  performed_by?: InputMaybe<Uuid_Comparison_Exp>;
  performer?: InputMaybe<User_Bool_Exp>;
  previous_data?: InputMaybe<Jsonb_Comparison_Exp>;
  reason?: InputMaybe<Reasons_Bool_Exp>;
  reason_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_audit_log" */
export enum Organization_Audit_Log_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrganizationAuditLogPkey = 'organization_audit_log_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Organization_Audit_Log_Delete_At_Path_Input = {
  new_data?: InputMaybe<Array<Scalars['String']['input']>>;
  previous_data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Organization_Audit_Log_Delete_Elem_Input = {
  new_data?: InputMaybe<Scalars['Int']['input']>;
  previous_data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Organization_Audit_Log_Delete_Key_Input = {
  new_data?: InputMaybe<Scalars['String']['input']>;
  previous_data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "organization_audit_log" */
export type Organization_Audit_Log_Insert_Input = {
  action?: InputMaybe<Scalars['String']['input']>;
  changed_fields?: InputMaybe<Array<Scalars['String']['input']>>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  new_data?: InputMaybe<Scalars['jsonb']['input']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  performed_by?: InputMaybe<Scalars['uuid']['input']>;
  performer?: InputMaybe<User_Obj_Rel_Insert_Input>;
  previous_data?: InputMaybe<Scalars['jsonb']['input']>;
  reason?: InputMaybe<Reasons_Obj_Rel_Insert_Input>;
  /** Reference to reasons.id — required when is_active changes via toggleOrganizationActive, null otherwise */
  reason_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Organization_Audit_Log_Max_Fields = {
  __typename?: 'organization_audit_log_max_fields';
  action?: Maybe<Scalars['String']['output']>;
  changed_fields?: Maybe<Array<Scalars['String']['output']>>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  performed_by?: Maybe<Scalars['uuid']['output']>;
  /** Reference to reasons.id — required when is_active changes via toggleOrganizationActive, null otherwise */
  reason_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "organization_audit_log" */
export type Organization_Audit_Log_Max_Order_By = {
  action?: InputMaybe<Order_By>;
  changed_fields?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  performed_by?: InputMaybe<Order_By>;
  /** Reference to reasons.id — required when is_active changes via toggleOrganizationActive, null otherwise */
  reason_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organization_Audit_Log_Min_Fields = {
  __typename?: 'organization_audit_log_min_fields';
  action?: Maybe<Scalars['String']['output']>;
  changed_fields?: Maybe<Array<Scalars['String']['output']>>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  performed_by?: Maybe<Scalars['uuid']['output']>;
  /** Reference to reasons.id — required when is_active changes via toggleOrganizationActive, null otherwise */
  reason_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "organization_audit_log" */
export type Organization_Audit_Log_Min_Order_By = {
  action?: InputMaybe<Order_By>;
  changed_fields?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  performed_by?: InputMaybe<Order_By>;
  /** Reference to reasons.id — required when is_active changes via toggleOrganizationActive, null otherwise */
  reason_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization_audit_log" */
export type Organization_Audit_Log_Mutation_Response = {
  __typename?: 'organization_audit_log_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Audit_Log>;
};

/** on_conflict condition type for table "organization_audit_log" */
export type Organization_Audit_Log_On_Conflict = {
  constraint: Organization_Audit_Log_Constraint;
  update_columns?: Array<Organization_Audit_Log_Update_Column>;
  where?: InputMaybe<Organization_Audit_Log_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_audit_log". */
export type Organization_Audit_Log_Order_By = {
  action?: InputMaybe<Order_By>;
  changed_fields?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  new_data?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  performed_by?: InputMaybe<Order_By>;
  performer?: InputMaybe<User_Order_By>;
  previous_data?: InputMaybe<Order_By>;
  reason?: InputMaybe<Reasons_Order_By>;
  reason_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_audit_log */
export type Organization_Audit_Log_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Organization_Audit_Log_Prepend_Input = {
  new_data?: InputMaybe<Scalars['jsonb']['input']>;
  previous_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "organization_audit_log" */
export enum Organization_Audit_Log_Select_Column {
  /** column name */
  Action = 'action',
  /** column name */
  ChangedFields = 'changed_fields',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  NewData = 'new_data',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  PerformedBy = 'performed_by',
  /** column name */
  PreviousData = 'previous_data',
  /** column name */
  ReasonId = 'reason_id'
}

/** input type for updating data in table "organization_audit_log" */
export type Organization_Audit_Log_Set_Input = {
  action?: InputMaybe<Scalars['String']['input']>;
  changed_fields?: InputMaybe<Array<Scalars['String']['input']>>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  new_data?: InputMaybe<Scalars['jsonb']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  performed_by?: InputMaybe<Scalars['uuid']['input']>;
  previous_data?: InputMaybe<Scalars['jsonb']['input']>;
  /** Reference to reasons.id — required when is_active changes via toggleOrganizationActive, null otherwise */
  reason_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "organization_audit_log" */
export type Organization_Audit_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Audit_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Audit_Log_Stream_Cursor_Value_Input = {
  action?: InputMaybe<Scalars['String']['input']>;
  changed_fields?: InputMaybe<Array<Scalars['String']['input']>>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  new_data?: InputMaybe<Scalars['jsonb']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  performed_by?: InputMaybe<Scalars['uuid']['input']>;
  previous_data?: InputMaybe<Scalars['jsonb']['input']>;
  /** Reference to reasons.id — required when is_active changes via toggleOrganizationActive, null otherwise */
  reason_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "organization_audit_log" */
export enum Organization_Audit_Log_Update_Column {
  /** column name */
  Action = 'action',
  /** column name */
  ChangedFields = 'changed_fields',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  NewData = 'new_data',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  PerformedBy = 'performed_by',
  /** column name */
  PreviousData = 'previous_data',
  /** column name */
  ReasonId = 'reason_id'
}

export type Organization_Audit_Log_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Organization_Audit_Log_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Organization_Audit_Log_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Organization_Audit_Log_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Organization_Audit_Log_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Organization_Audit_Log_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Audit_Log_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Audit_Log_Bool_Exp;
};

/** aggregate avg on columns */
export type Organization_Avg_Fields = {
  __typename?: 'organization_avg_fields';
  allowed_credit_limit?: Maybe<Scalars['Float']['output']>;
  customer_code?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "organization" */
export type Organization_Avg_Order_By = {
  allowed_credit_limit?: InputMaybe<Order_By>;
  customer_code?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "organization". All fields are combined with a logical 'AND'. */
export type Organization_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Bool_Exp>>;
  _not?: InputMaybe<Organization_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Bool_Exp>>;
  alias_name?: InputMaybe<String_Comparison_Exp>;
  allowed_credit_limit?: InputMaybe<Numeric_Comparison_Exp>;
  audit_logs?: InputMaybe<Organization_Audit_Log_Bool_Exp>;
  audit_logs_aggregate?: InputMaybe<Organization_Audit_Log_Aggregate_Bool_Exp>;
  bd_name?: InputMaybe<String_Comparison_Exp>;
  brand?: InputMaybe<String_Comparison_Exp>;
  brand_logo?: InputMaybe<String_Comparison_Exp>;
  cin_number?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  credit_breaches?: InputMaybe<Credit_Breach_Bool_Exp>;
  credit_breaches_aggregate?: InputMaybe<Credit_Breach_Aggregate_Bool_Exp>;
  currency?: InputMaybe<Currency_Bool_Exp>;
  customer_code?: InputMaybe<Int_Comparison_Exp>;
  customer_erp_code?: InputMaybe<String_Comparison_Exp>;
  default_currency?: InputMaybe<Uuid_Comparison_Exp>;
  delivery_charge_id?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dispensing_rules?: InputMaybe<Dispensing_Rules_Bool_Exp>;
  dispensing_rules_aggregate?: InputMaybe<Dispensing_Rules_Aggregate_Bool_Exp>;
  fueltrans_customer_id?: InputMaybe<String_Comparison_Exp>;
  gst_number?: InputMaybe<String_Comparison_Exp>;
  head_office_general_email?: InputMaybe<String_Comparison_Exp>;
  head_office_general_phone_number?: InputMaybe<String_Comparison_Exp>;
  holding_company?: InputMaybe<Boolean_Comparison_Exp>;
  holding_company_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invitations?: InputMaybe<Invitation_Bool_Exp>;
  invitations_aggregate?: InputMaybe<Invitation_Aggregate_Bool_Exp>;
  invoice_email?: InputMaybe<String_Comparison_Exp>;
  invoices_uploaded?: InputMaybe<Boolean_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_business?: InputMaybe<Boolean_Comparison_Exp>;
  is_post_paid?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  limit_purchase_orders?: InputMaybe<Limit_Purchase_Order_Bool_Exp>;
  limit_purchase_orders_aggregate?: InputMaybe<Limit_Purchase_Order_Aggregate_Bool_Exp>;
  lpo_exceptions?: InputMaybe<Lpo_Exception_Bool_Exp>;
  lpo_exceptions_aggregate?: InputMaybe<Lpo_Exception_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  org_type?: InputMaybe<Organization_Type_Enum_Comparison_Exp>;
  organization_addresses?: InputMaybe<Organization_Address_Bool_Exp>;
  organization_addresses_aggregate?: InputMaybe<Organization_Address_Aggregate_Bool_Exp>;
  organization_configurations?: InputMaybe<Organization_Configuration_Bool_Exp>;
  organization_configurations_aggregate?: InputMaybe<Organization_Configuration_Aggregate_Bool_Exp>;
  organization_product_variation_discount_histories?: InputMaybe<Organization_Product_Variation_Discount_History_Bool_Exp>;
  organization_product_variation_discount_histories_aggregate?: InputMaybe<Organization_Product_Variation_Discount_History_Aggregate_Bool_Exp>;
  organization_product_variation_discounts?: InputMaybe<Organization_Product_Variation_Discount_Bool_Exp>;
  organization_product_variation_discounts_aggregate?: InputMaybe<Organization_Product_Variation_Discount_Aggregate_Bool_Exp>;
  organization_sales_projections?: InputMaybe<Organization_Sales_Projection_Bool_Exp>;
  organization_sales_projections_aggregate?: InputMaybe<Organization_Sales_Projection_Aggregate_Bool_Exp>;
  organization_timings?: InputMaybe<Organization_Timing_Bool_Exp>;
  organization_timings_aggregate?: InputMaybe<Organization_Timing_Aggregate_Bool_Exp>;
  organization_type?: InputMaybe<Organization_Type_Bool_Exp>;
  organization_users?: InputMaybe<Organization_User_Bool_Exp>;
  organization_users_aggregate?: InputMaybe<Organization_User_Aggregate_Bool_Exp>;
  pan_number?: InputMaybe<String_Comparison_Exp>;
  script?: InputMaybe<Scripts_Bool_Exp>;
  signed_invoice_on_email?: InputMaybe<Boolean_Comparison_Exp>;
  subsidiaries?: InputMaybe<Subsidiary_Bool_Exp>;
  subsidiaries_aggregate?: InputMaybe<Subsidiary_Aggregate_Bool_Exp>;
  technical_contact_email?: InputMaybe<String_Comparison_Exp>;
  technical_contact_full_name?: InputMaybe<String_Comparison_Exp>;
  technical_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  trade_license?: InputMaybe<String_Comparison_Exp>;
  verified_at?: InputMaybe<Timestamp_Comparison_Exp>;
  wallet?: InputMaybe<Wallet_Bool_Exp>;
  wallet_exceptions?: InputMaybe<Wallet_Exception_Bool_Exp>;
  wallet_exceptions_aggregate?: InputMaybe<Wallet_Exception_Aggregate_Bool_Exp>;
  wallets?: InputMaybe<Wallet_Bool_Exp>;
  wallets_aggregate?: InputMaybe<Wallet_Aggregate_Bool_Exp>;
  website_url?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "organization_commission_product_variation_type" */
export type Organization_Commission_Product_Variation_Type = {
  __typename?: 'organization_commission_product_variation_type';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  customer_order_item_commissions: Array<Customer_Order_Item_Commission>;
  /** An aggregate relationship */
  customer_order_item_commissions_aggregate: Customer_Order_Item_Commission_Aggregate;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  organization_user: Organization_User;
  /** An array relationship */
  organization_user_commissions: Array<Organization_User_Commission>;
  /** An aggregate relationship */
  organization_user_commissions_aggregate: Organization_User_Commission_Aggregate;
  organization_user_id: Scalars['uuid']['output'];
  /** An object relationship */
  product: Product;
  product_id: Scalars['uuid']['output'];
  /** An object relationship */
  product_variation: Product_Variation;
  product_variation_id: Scalars['uuid']['output'];
  /** An object relationship */
  script: Scripts;
  scripts_id: Scalars['uuid']['output'];
};


/** columns and relationships of "organization_commission_product_variation_type" */
export type Organization_Commission_Product_Variation_TypeCustomer_Order_Item_CommissionsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Commission_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Commission_Bool_Exp>;
};


/** columns and relationships of "organization_commission_product_variation_type" */
export type Organization_Commission_Product_Variation_TypeCustomer_Order_Item_Commissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Commission_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Commission_Bool_Exp>;
};


/** columns and relationships of "organization_commission_product_variation_type" */
export type Organization_Commission_Product_Variation_TypeOrganization_User_CommissionsArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Commission_Order_By>>;
  where?: InputMaybe<Organization_User_Commission_Bool_Exp>;
};


/** columns and relationships of "organization_commission_product_variation_type" */
export type Organization_Commission_Product_Variation_TypeOrganization_User_Commissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Commission_Order_By>>;
  where?: InputMaybe<Organization_User_Commission_Bool_Exp>;
};

/** aggregated selection of "organization_commission_product_variation_type" */
export type Organization_Commission_Product_Variation_Type_Aggregate = {
  __typename?: 'organization_commission_product_variation_type_aggregate';
  aggregate?: Maybe<Organization_Commission_Product_Variation_Type_Aggregate_Fields>;
  nodes: Array<Organization_Commission_Product_Variation_Type>;
};

export type Organization_Commission_Product_Variation_Type_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Organization_Commission_Product_Variation_Type_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Organization_Commission_Product_Variation_Type_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Organization_Commission_Product_Variation_Type_Aggregate_Bool_Exp_Count>;
};

export type Organization_Commission_Product_Variation_Type_Aggregate_Bool_Exp_Bool_And = {
  arguments: Organization_Commission_Product_Variation_Type_Select_Column_Organization_Commission_Product_Variation_Type_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Commission_Product_Variation_Type_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organization_Commission_Product_Variation_Type_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Organization_Commission_Product_Variation_Type_Select_Column_Organization_Commission_Product_Variation_Type_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Commission_Product_Variation_Type_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organization_Commission_Product_Variation_Type_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organization_Commission_Product_Variation_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Commission_Product_Variation_Type_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organization_commission_product_variation_type" */
export type Organization_Commission_Product_Variation_Type_Aggregate_Fields = {
  __typename?: 'organization_commission_product_variation_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_Commission_Product_Variation_Type_Max_Fields>;
  min?: Maybe<Organization_Commission_Product_Variation_Type_Min_Fields>;
};


/** aggregate fields of "organization_commission_product_variation_type" */
export type Organization_Commission_Product_Variation_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Commission_Product_Variation_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organization_commission_product_variation_type" */
export type Organization_Commission_Product_Variation_Type_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Commission_Product_Variation_Type_Max_Order_By>;
  min?: InputMaybe<Organization_Commission_Product_Variation_Type_Min_Order_By>;
};

/** input type for inserting array relation for remote table "organization_commission_product_variation_type" */
export type Organization_Commission_Product_Variation_Type_Arr_Rel_Insert_Input = {
  data: Array<Organization_Commission_Product_Variation_Type_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Commission_Product_Variation_Type_On_Conflict>;
};

/** Boolean expression to filter rows from the table "organization_commission_product_variation_type". All fields are combined with a logical 'AND'. */
export type Organization_Commission_Product_Variation_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Commission_Product_Variation_Type_Bool_Exp>>;
  _not?: InputMaybe<Organization_Commission_Product_Variation_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Commission_Product_Variation_Type_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_order_item_commissions?: InputMaybe<Customer_Order_Item_Commission_Bool_Exp>;
  customer_order_item_commissions_aggregate?: InputMaybe<Customer_Order_Item_Commission_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  organization_user?: InputMaybe<Organization_User_Bool_Exp>;
  organization_user_commissions?: InputMaybe<Organization_User_Commission_Bool_Exp>;
  organization_user_commissions_aggregate?: InputMaybe<Organization_User_Commission_Aggregate_Bool_Exp>;
  organization_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  product_id?: InputMaybe<Uuid_Comparison_Exp>;
  product_variation?: InputMaybe<Product_Variation_Bool_Exp>;
  product_variation_id?: InputMaybe<Uuid_Comparison_Exp>;
  script?: InputMaybe<Scripts_Bool_Exp>;
  scripts_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_commission_product_variation_type" */
export enum Organization_Commission_Product_Variation_Type_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrganizationCommissionProductVariationTypePkey = 'organization_commission_product_variation_type_pkey'
}

/** input type for inserting data into table "organization_commission_product_variation_type" */
export type Organization_Commission_Product_Variation_Type_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_item_commissions?: InputMaybe<Customer_Order_Item_Commission_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_user?: InputMaybe<Organization_User_Obj_Rel_Insert_Input>;
  organization_user_commissions?: InputMaybe<Organization_User_Commission_Arr_Rel_Insert_Input>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
  product_variation?: InputMaybe<Product_Variation_Obj_Rel_Insert_Input>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  script?: InputMaybe<Scripts_Obj_Rel_Insert_Input>;
  scripts_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Organization_Commission_Product_Variation_Type_Max_Fields = {
  __typename?: 'organization_commission_product_variation_type_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  organization_user_id?: Maybe<Scalars['uuid']['output']>;
  product_id?: Maybe<Scalars['uuid']['output']>;
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
  scripts_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "organization_commission_product_variation_type" */
export type Organization_Commission_Product_Variation_Type_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  scripts_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organization_Commission_Product_Variation_Type_Min_Fields = {
  __typename?: 'organization_commission_product_variation_type_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  organization_user_id?: Maybe<Scalars['uuid']['output']>;
  product_id?: Maybe<Scalars['uuid']['output']>;
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
  scripts_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "organization_commission_product_variation_type" */
export type Organization_Commission_Product_Variation_Type_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  scripts_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization_commission_product_variation_type" */
export type Organization_Commission_Product_Variation_Type_Mutation_Response = {
  __typename?: 'organization_commission_product_variation_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Commission_Product_Variation_Type>;
};

/** input type for inserting object relation for remote table "organization_commission_product_variation_type" */
export type Organization_Commission_Product_Variation_Type_Obj_Rel_Insert_Input = {
  data: Organization_Commission_Product_Variation_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Commission_Product_Variation_Type_On_Conflict>;
};

/** on_conflict condition type for table "organization_commission_product_variation_type" */
export type Organization_Commission_Product_Variation_Type_On_Conflict = {
  constraint: Organization_Commission_Product_Variation_Type_Constraint;
  update_columns?: Array<Organization_Commission_Product_Variation_Type_Update_Column>;
  where?: InputMaybe<Organization_Commission_Product_Variation_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_commission_product_variation_type". */
export type Organization_Commission_Product_Variation_Type_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_order_item_commissions_aggregate?: InputMaybe<Customer_Order_Item_Commission_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_user?: InputMaybe<Organization_User_Order_By>;
  organization_user_commissions_aggregate?: InputMaybe<Organization_User_Commission_Aggregate_Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  product_id?: InputMaybe<Order_By>;
  product_variation?: InputMaybe<Product_Variation_Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  script?: InputMaybe<Scripts_Order_By>;
  scripts_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_commission_product_variation_type */
export type Organization_Commission_Product_Variation_Type_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organization_commission_product_variation_type" */
export enum Organization_Commission_Product_Variation_Type_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrganizationUserId = 'organization_user_id',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  ProductVariationId = 'product_variation_id',
  /** column name */
  ScriptsId = 'scripts_id'
}

/** select "organization_commission_product_variation_type_aggregate_bool_exp_bool_and_arguments_columns" columns of table "organization_commission_product_variation_type" */
export enum Organization_Commission_Product_Variation_Type_Select_Column_Organization_Commission_Product_Variation_Type_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "organization_commission_product_variation_type_aggregate_bool_exp_bool_or_arguments_columns" columns of table "organization_commission_product_variation_type" */
export enum Organization_Commission_Product_Variation_Type_Select_Column_Organization_Commission_Product_Variation_Type_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "organization_commission_product_variation_type" */
export type Organization_Commission_Product_Variation_Type_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  scripts_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "organization_commission_product_variation_type" */
export type Organization_Commission_Product_Variation_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Commission_Product_Variation_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Commission_Product_Variation_Type_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  scripts_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "organization_commission_product_variation_type" */
export enum Organization_Commission_Product_Variation_Type_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrganizationUserId = 'organization_user_id',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  ProductVariationId = 'product_variation_id',
  /** column name */
  ScriptsId = 'scripts_id'
}

export type Organization_Commission_Product_Variation_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Commission_Product_Variation_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Commission_Product_Variation_Type_Bool_Exp;
};

/** columns and relationships of "organization_configuration" */
export type Organization_Configuration = {
  __typename?: 'organization_configuration';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  key: Scalars['String']['output'];
  /** An object relationship */
  organization: Organization;
  organization_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "organization_configuration" */
export type Organization_Configuration_Aggregate = {
  __typename?: 'organization_configuration_aggregate';
  aggregate?: Maybe<Organization_Configuration_Aggregate_Fields>;
  nodes: Array<Organization_Configuration>;
};

export type Organization_Configuration_Aggregate_Bool_Exp = {
  count?: InputMaybe<Organization_Configuration_Aggregate_Bool_Exp_Count>;
};

export type Organization_Configuration_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organization_Configuration_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Configuration_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organization_configuration" */
export type Organization_Configuration_Aggregate_Fields = {
  __typename?: 'organization_configuration_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_Configuration_Max_Fields>;
  min?: Maybe<Organization_Configuration_Min_Fields>;
};


/** aggregate fields of "organization_configuration" */
export type Organization_Configuration_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Configuration_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organization_configuration" */
export type Organization_Configuration_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Configuration_Max_Order_By>;
  min?: InputMaybe<Organization_Configuration_Min_Order_By>;
};

/** input type for inserting array relation for remote table "organization_configuration" */
export type Organization_Configuration_Arr_Rel_Insert_Input = {
  data: Array<Organization_Configuration_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Configuration_On_Conflict>;
};

/** Boolean expression to filter rows from the table "organization_configuration". All fields are combined with a logical 'AND'. */
export type Organization_Configuration_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Configuration_Bool_Exp>>;
  _not?: InputMaybe<Organization_Configuration_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Configuration_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_configuration" */
export enum Organization_Configuration_Constraint {
  /** unique or primary key constraint on columns "key", "organization_id" */
  OrganizationConfigurationOrganizationIdKeyKey = 'organization_configuration_organization_id_key_key',
  /** unique or primary key constraint on columns "id" */
  OrganizationConfigurationPkey = 'organization_configuration_pkey'
}

/** input type for inserting data into table "organization_configuration" */
export type Organization_Configuration_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Organization_Configuration_Max_Fields = {
  __typename?: 'organization_configuration_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "organization_configuration" */
export type Organization_Configuration_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organization_Configuration_Min_Fields = {
  __typename?: 'organization_configuration_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "organization_configuration" */
export type Organization_Configuration_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization_configuration" */
export type Organization_Configuration_Mutation_Response = {
  __typename?: 'organization_configuration_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Configuration>;
};

/** on_conflict condition type for table "organization_configuration" */
export type Organization_Configuration_On_Conflict = {
  constraint: Organization_Configuration_Constraint;
  update_columns?: Array<Organization_Configuration_Update_Column>;
  where?: InputMaybe<Organization_Configuration_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_configuration". */
export type Organization_Configuration_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_configuration */
export type Organization_Configuration_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organization_configuration" */
export enum Organization_Configuration_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "organization_configuration" */
export type Organization_Configuration_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "organization_configuration" */
export type Organization_Configuration_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Configuration_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Configuration_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "organization_configuration" */
export enum Organization_Configuration_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

export type Organization_Configuration_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Configuration_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Configuration_Bool_Exp;
};

/** unique or primary key constraints on table "organization" */
export enum Organization_Constraint {
  /** unique or primary key constraint on columns "customer_erp_code" */
  OrganizationCustomerErpCodeUniqueIdx = 'organization_customer_erp_code_unique_idx',
  /** unique or primary key constraint on columns "id" */
  OrganizationPkey = 'organization_pkey'
}

/** input type for incrementing numeric columns in table "organization" */
export type Organization_Inc_Input = {
  allowed_credit_limit?: InputMaybe<Scalars['numeric']['input']>;
  customer_code?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "organization" */
export type Organization_Insert_Input = {
  alias_name?: InputMaybe<Scalars['String']['input']>;
  allowed_credit_limit?: InputMaybe<Scalars['numeric']['input']>;
  audit_logs?: InputMaybe<Organization_Audit_Log_Arr_Rel_Insert_Input>;
  bd_name?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  brand_logo?: InputMaybe<Scalars['String']['input']>;
  cin_number?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  credit_breaches?: InputMaybe<Credit_Breach_Arr_Rel_Insert_Input>;
  currency?: InputMaybe<Currency_Obj_Rel_Insert_Input>;
  customer_code?: InputMaybe<Scalars['Int']['input']>;
  customer_erp_code?: InputMaybe<Scalars['String']['input']>;
  default_currency?: InputMaybe<Scalars['uuid']['input']>;
  delivery_charge_id?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dispensing_rules?: InputMaybe<Dispensing_Rules_Arr_Rel_Insert_Input>;
  fueltrans_customer_id?: InputMaybe<Scalars['String']['input']>;
  gst_number?: InputMaybe<Scalars['String']['input']>;
  head_office_general_email?: InputMaybe<Scalars['String']['input']>;
  head_office_general_phone_number?: InputMaybe<Scalars['String']['input']>;
  holding_company?: InputMaybe<Scalars['Boolean']['input']>;
  holding_company_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invitations?: InputMaybe<Invitation_Arr_Rel_Insert_Input>;
  invoice_email?: InputMaybe<Scalars['String']['input']>;
  invoices_uploaded?: InputMaybe<Scalars['Boolean']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_business?: InputMaybe<Scalars['Boolean']['input']>;
  is_post_paid?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  limit_purchase_orders?: InputMaybe<Limit_Purchase_Order_Arr_Rel_Insert_Input>;
  lpo_exceptions?: InputMaybe<Lpo_Exception_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  org_type?: InputMaybe<Organization_Type_Enum>;
  organization_addresses?: InputMaybe<Organization_Address_Arr_Rel_Insert_Input>;
  organization_configurations?: InputMaybe<Organization_Configuration_Arr_Rel_Insert_Input>;
  organization_product_variation_discount_histories?: InputMaybe<Organization_Product_Variation_Discount_History_Arr_Rel_Insert_Input>;
  organization_product_variation_discounts?: InputMaybe<Organization_Product_Variation_Discount_Arr_Rel_Insert_Input>;
  organization_sales_projections?: InputMaybe<Organization_Sales_Projection_Arr_Rel_Insert_Input>;
  organization_timings?: InputMaybe<Organization_Timing_Arr_Rel_Insert_Input>;
  organization_type?: InputMaybe<Organization_Type_Obj_Rel_Insert_Input>;
  organization_users?: InputMaybe<Organization_User_Arr_Rel_Insert_Input>;
  pan_number?: InputMaybe<Scalars['String']['input']>;
  script?: InputMaybe<Scripts_Obj_Rel_Insert_Input>;
  signed_invoice_on_email?: InputMaybe<Scalars['Boolean']['input']>;
  subsidiaries?: InputMaybe<Subsidiary_Arr_Rel_Insert_Input>;
  technical_contact_email?: InputMaybe<Scalars['String']['input']>;
  technical_contact_full_name?: InputMaybe<Scalars['String']['input']>;
  technical_contact_phone_number?: InputMaybe<Scalars['String']['input']>;
  trade_license?: InputMaybe<Scalars['String']['input']>;
  verified_at?: InputMaybe<Scalars['timestamp']['input']>;
  wallet?: InputMaybe<Wallet_Obj_Rel_Insert_Input>;
  wallet_exceptions?: InputMaybe<Wallet_Exception_Arr_Rel_Insert_Input>;
  wallets?: InputMaybe<Wallet_Arr_Rel_Insert_Input>;
  website_url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Organization_Max_Fields = {
  __typename?: 'organization_max_fields';
  alias_name?: Maybe<Scalars['String']['output']>;
  allowed_credit_limit?: Maybe<Scalars['numeric']['output']>;
  bd_name?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  brand_logo?: Maybe<Scalars['String']['output']>;
  cin_number?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_code?: Maybe<Scalars['Int']['output']>;
  customer_erp_code?: Maybe<Scalars['String']['output']>;
  default_currency?: Maybe<Scalars['uuid']['output']>;
  delivery_charge_id?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fueltrans_customer_id?: Maybe<Scalars['String']['output']>;
  gst_number?: Maybe<Scalars['String']['output']>;
  head_office_general_email?: Maybe<Scalars['String']['output']>;
  head_office_general_phone_number?: Maybe<Scalars['String']['output']>;
  holding_company_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  invoice_email?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pan_number?: Maybe<Scalars['String']['output']>;
  technical_contact_email?: Maybe<Scalars['String']['output']>;
  technical_contact_full_name?: Maybe<Scalars['String']['output']>;
  technical_contact_phone_number?: Maybe<Scalars['String']['output']>;
  trade_license?: Maybe<Scalars['String']['output']>;
  verified_at?: Maybe<Scalars['timestamp']['output']>;
  website_url?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "organization" */
export type Organization_Max_Order_By = {
  alias_name?: InputMaybe<Order_By>;
  allowed_credit_limit?: InputMaybe<Order_By>;
  bd_name?: InputMaybe<Order_By>;
  brand?: InputMaybe<Order_By>;
  brand_logo?: InputMaybe<Order_By>;
  cin_number?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_code?: InputMaybe<Order_By>;
  customer_erp_code?: InputMaybe<Order_By>;
  default_currency?: InputMaybe<Order_By>;
  delivery_charge_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  fueltrans_customer_id?: InputMaybe<Order_By>;
  gst_number?: InputMaybe<Order_By>;
  head_office_general_email?: InputMaybe<Order_By>;
  head_office_general_phone_number?: InputMaybe<Order_By>;
  holding_company_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_email?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  pan_number?: InputMaybe<Order_By>;
  technical_contact_email?: InputMaybe<Order_By>;
  technical_contact_full_name?: InputMaybe<Order_By>;
  technical_contact_phone_number?: InputMaybe<Order_By>;
  trade_license?: InputMaybe<Order_By>;
  verified_at?: InputMaybe<Order_By>;
  website_url?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organization_Min_Fields = {
  __typename?: 'organization_min_fields';
  alias_name?: Maybe<Scalars['String']['output']>;
  allowed_credit_limit?: Maybe<Scalars['numeric']['output']>;
  bd_name?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  brand_logo?: Maybe<Scalars['String']['output']>;
  cin_number?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_code?: Maybe<Scalars['Int']['output']>;
  customer_erp_code?: Maybe<Scalars['String']['output']>;
  default_currency?: Maybe<Scalars['uuid']['output']>;
  delivery_charge_id?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fueltrans_customer_id?: Maybe<Scalars['String']['output']>;
  gst_number?: Maybe<Scalars['String']['output']>;
  head_office_general_email?: Maybe<Scalars['String']['output']>;
  head_office_general_phone_number?: Maybe<Scalars['String']['output']>;
  holding_company_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  invoice_email?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pan_number?: Maybe<Scalars['String']['output']>;
  technical_contact_email?: Maybe<Scalars['String']['output']>;
  technical_contact_full_name?: Maybe<Scalars['String']['output']>;
  technical_contact_phone_number?: Maybe<Scalars['String']['output']>;
  trade_license?: Maybe<Scalars['String']['output']>;
  verified_at?: Maybe<Scalars['timestamp']['output']>;
  website_url?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "organization" */
export type Organization_Min_Order_By = {
  alias_name?: InputMaybe<Order_By>;
  allowed_credit_limit?: InputMaybe<Order_By>;
  bd_name?: InputMaybe<Order_By>;
  brand?: InputMaybe<Order_By>;
  brand_logo?: InputMaybe<Order_By>;
  cin_number?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_code?: InputMaybe<Order_By>;
  customer_erp_code?: InputMaybe<Order_By>;
  default_currency?: InputMaybe<Order_By>;
  delivery_charge_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  fueltrans_customer_id?: InputMaybe<Order_By>;
  gst_number?: InputMaybe<Order_By>;
  head_office_general_email?: InputMaybe<Order_By>;
  head_office_general_phone_number?: InputMaybe<Order_By>;
  holding_company_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_email?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  pan_number?: InputMaybe<Order_By>;
  technical_contact_email?: InputMaybe<Order_By>;
  technical_contact_full_name?: InputMaybe<Order_By>;
  technical_contact_phone_number?: InputMaybe<Order_By>;
  trade_license?: InputMaybe<Order_By>;
  verified_at?: InputMaybe<Order_By>;
  website_url?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization" */
export type Organization_Mutation_Response = {
  __typename?: 'organization_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization>;
};

/** input type for inserting object relation for remote table "organization" */
export type Organization_Obj_Rel_Insert_Input = {
  data: Organization_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_On_Conflict>;
};

/** on_conflict condition type for table "organization" */
export type Organization_On_Conflict = {
  constraint: Organization_Constraint;
  update_columns?: Array<Organization_Update_Column>;
  where?: InputMaybe<Organization_Bool_Exp>;
};

/** Ordering options when selecting data from "organization". */
export type Organization_Order_By = {
  alias_name?: InputMaybe<Order_By>;
  allowed_credit_limit?: InputMaybe<Order_By>;
  audit_logs_aggregate?: InputMaybe<Organization_Audit_Log_Aggregate_Order_By>;
  bd_name?: InputMaybe<Order_By>;
  brand?: InputMaybe<Order_By>;
  brand_logo?: InputMaybe<Order_By>;
  cin_number?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  credit_breaches_aggregate?: InputMaybe<Credit_Breach_Aggregate_Order_By>;
  currency?: InputMaybe<Currency_Order_By>;
  customer_code?: InputMaybe<Order_By>;
  customer_erp_code?: InputMaybe<Order_By>;
  default_currency?: InputMaybe<Order_By>;
  delivery_charge_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dispensing_rules_aggregate?: InputMaybe<Dispensing_Rules_Aggregate_Order_By>;
  fueltrans_customer_id?: InputMaybe<Order_By>;
  gst_number?: InputMaybe<Order_By>;
  head_office_general_email?: InputMaybe<Order_By>;
  head_office_general_phone_number?: InputMaybe<Order_By>;
  holding_company?: InputMaybe<Order_By>;
  holding_company_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invitations_aggregate?: InputMaybe<Invitation_Aggregate_Order_By>;
  invoice_email?: InputMaybe<Order_By>;
  invoices_uploaded?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_business?: InputMaybe<Order_By>;
  is_post_paid?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  limit_purchase_orders_aggregate?: InputMaybe<Limit_Purchase_Order_Aggregate_Order_By>;
  lpo_exceptions_aggregate?: InputMaybe<Lpo_Exception_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  org_type?: InputMaybe<Order_By>;
  organization_addresses_aggregate?: InputMaybe<Organization_Address_Aggregate_Order_By>;
  organization_configurations_aggregate?: InputMaybe<Organization_Configuration_Aggregate_Order_By>;
  organization_product_variation_discount_histories_aggregate?: InputMaybe<Organization_Product_Variation_Discount_History_Aggregate_Order_By>;
  organization_product_variation_discounts_aggregate?: InputMaybe<Organization_Product_Variation_Discount_Aggregate_Order_By>;
  organization_sales_projections_aggregate?: InputMaybe<Organization_Sales_Projection_Aggregate_Order_By>;
  organization_timings_aggregate?: InputMaybe<Organization_Timing_Aggregate_Order_By>;
  organization_type?: InputMaybe<Organization_Type_Order_By>;
  organization_users_aggregate?: InputMaybe<Organization_User_Aggregate_Order_By>;
  pan_number?: InputMaybe<Order_By>;
  script?: InputMaybe<Scripts_Order_By>;
  signed_invoice_on_email?: InputMaybe<Order_By>;
  subsidiaries_aggregate?: InputMaybe<Subsidiary_Aggregate_Order_By>;
  technical_contact_email?: InputMaybe<Order_By>;
  technical_contact_full_name?: InputMaybe<Order_By>;
  technical_contact_phone_number?: InputMaybe<Order_By>;
  trade_license?: InputMaybe<Order_By>;
  verified_at?: InputMaybe<Order_By>;
  wallet?: InputMaybe<Wallet_Order_By>;
  wallet_exceptions_aggregate?: InputMaybe<Wallet_Exception_Aggregate_Order_By>;
  wallets_aggregate?: InputMaybe<Wallet_Aggregate_Order_By>;
  website_url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization */
export type Organization_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "organization_product_variation_discount" */
export type Organization_Product_Variation_Discount = {
  __typename?: 'organization_product_variation_discount';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  discountTypeByDiscountType: Discount_Type;
  discount_rate?: Maybe<Scalars['numeric']['output']>;
  discount_type: Discount_Type_Enum;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  organization: Organization;
  organization_id: Scalars['uuid']['output'];
  /** An array relationship */
  organization_product_variation_discount_histories: Array<Organization_Product_Variation_Discount_History>;
  /** An aggregate relationship */
  organization_product_variation_discount_histories_aggregate: Organization_Product_Variation_Discount_History_Aggregate;
  /** An object relationship */
  product_variation: Product_Variation;
  product_variation_id: Scalars['uuid']['output'];
};


/** columns and relationships of "organization_product_variation_discount" */
export type Organization_Product_Variation_DiscountOrganization_Product_Variation_Discount_HistoriesArgs = {
  distinct_on?: InputMaybe<Array<Organization_Product_Variation_Discount_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Product_Variation_Discount_History_Order_By>>;
  where?: InputMaybe<Organization_Product_Variation_Discount_History_Bool_Exp>;
};


/** columns and relationships of "organization_product_variation_discount" */
export type Organization_Product_Variation_DiscountOrganization_Product_Variation_Discount_Histories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Product_Variation_Discount_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Product_Variation_Discount_History_Order_By>>;
  where?: InputMaybe<Organization_Product_Variation_Discount_History_Bool_Exp>;
};

/** aggregated selection of "organization_product_variation_discount" */
export type Organization_Product_Variation_Discount_Aggregate = {
  __typename?: 'organization_product_variation_discount_aggregate';
  aggregate?: Maybe<Organization_Product_Variation_Discount_Aggregate_Fields>;
  nodes: Array<Organization_Product_Variation_Discount>;
};

export type Organization_Product_Variation_Discount_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Organization_Product_Variation_Discount_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Organization_Product_Variation_Discount_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Organization_Product_Variation_Discount_Aggregate_Bool_Exp_Count>;
};

export type Organization_Product_Variation_Discount_Aggregate_Bool_Exp_Bool_And = {
  arguments: Organization_Product_Variation_Discount_Select_Column_Organization_Product_Variation_Discount_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Product_Variation_Discount_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organization_Product_Variation_Discount_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Organization_Product_Variation_Discount_Select_Column_Organization_Product_Variation_Discount_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Product_Variation_Discount_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organization_Product_Variation_Discount_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organization_Product_Variation_Discount_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Product_Variation_Discount_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organization_product_variation_discount" */
export type Organization_Product_Variation_Discount_Aggregate_Fields = {
  __typename?: 'organization_product_variation_discount_aggregate_fields';
  avg?: Maybe<Organization_Product_Variation_Discount_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_Product_Variation_Discount_Max_Fields>;
  min?: Maybe<Organization_Product_Variation_Discount_Min_Fields>;
  stddev?: Maybe<Organization_Product_Variation_Discount_Stddev_Fields>;
  stddev_pop?: Maybe<Organization_Product_Variation_Discount_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organization_Product_Variation_Discount_Stddev_Samp_Fields>;
  sum?: Maybe<Organization_Product_Variation_Discount_Sum_Fields>;
  var_pop?: Maybe<Organization_Product_Variation_Discount_Var_Pop_Fields>;
  var_samp?: Maybe<Organization_Product_Variation_Discount_Var_Samp_Fields>;
  variance?: Maybe<Organization_Product_Variation_Discount_Variance_Fields>;
};


/** aggregate fields of "organization_product_variation_discount" */
export type Organization_Product_Variation_Discount_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Product_Variation_Discount_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organization_product_variation_discount" */
export type Organization_Product_Variation_Discount_Aggregate_Order_By = {
  avg?: InputMaybe<Organization_Product_Variation_Discount_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Product_Variation_Discount_Max_Order_By>;
  min?: InputMaybe<Organization_Product_Variation_Discount_Min_Order_By>;
  stddev?: InputMaybe<Organization_Product_Variation_Discount_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Organization_Product_Variation_Discount_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Organization_Product_Variation_Discount_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Organization_Product_Variation_Discount_Sum_Order_By>;
  var_pop?: InputMaybe<Organization_Product_Variation_Discount_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Organization_Product_Variation_Discount_Var_Samp_Order_By>;
  variance?: InputMaybe<Organization_Product_Variation_Discount_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "organization_product_variation_discount" */
export type Organization_Product_Variation_Discount_Arr_Rel_Insert_Input = {
  data: Array<Organization_Product_Variation_Discount_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Product_Variation_Discount_On_Conflict>;
};

/** aggregate avg on columns */
export type Organization_Product_Variation_Discount_Avg_Fields = {
  __typename?: 'organization_product_variation_discount_avg_fields';
  discount_rate?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "organization_product_variation_discount" */
export type Organization_Product_Variation_Discount_Avg_Order_By = {
  discount_rate?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "organization_product_variation_discount". All fields are combined with a logical 'AND'. */
export type Organization_Product_Variation_Discount_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Product_Variation_Discount_Bool_Exp>>;
  _not?: InputMaybe<Organization_Product_Variation_Discount_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Product_Variation_Discount_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  discountTypeByDiscountType?: InputMaybe<Discount_Type_Bool_Exp>;
  discount_rate?: InputMaybe<Numeric_Comparison_Exp>;
  discount_type?: InputMaybe<Discount_Type_Enum_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  organization_product_variation_discount_histories?: InputMaybe<Organization_Product_Variation_Discount_History_Bool_Exp>;
  organization_product_variation_discount_histories_aggregate?: InputMaybe<Organization_Product_Variation_Discount_History_Aggregate_Bool_Exp>;
  product_variation?: InputMaybe<Product_Variation_Bool_Exp>;
  product_variation_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_product_variation_discount" */
export enum Organization_Product_Variation_Discount_Constraint {
  /** unique or primary key constraint on columns "product_variation_id", "discount_type", "organization_id" */
  OrganizationProductVariationDiscountOrganizationIdProduct = 'organization_product_variation_discount_organization_id_product',
  /** unique or primary key constraint on columns "id" */
  OrganizationProductVariationDiscountPkey = 'organization_product_variation_discount_pkey'
}

/** columns and relationships of "organization_product_variation_discount_history" */
export type Organization_Product_Variation_Discount_History = {
  __typename?: 'organization_product_variation_discount_history';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  discountTypeByOldDiscountType: Discount_Type;
  /** An object relationship */
  discount_type: Discount_Type;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  new_discount_rate?: Maybe<Scalars['numeric']['output']>;
  new_discount_type: Discount_Type_Enum;
  old_discount_rate?: Maybe<Scalars['numeric']['output']>;
  old_discount_type: Discount_Type_Enum;
  /** An object relationship */
  organization: Organization;
  organization_id: Scalars['uuid']['output'];
  /** An object relationship */
  organization_product_variation_discount: Organization_Product_Variation_Discount;
  organization_product_variation_discount_id: Scalars['uuid']['output'];
  previous_date?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  product_variation: Product_Variation;
  product_variation_id: Scalars['uuid']['output'];
};

/** aggregated selection of "organization_product_variation_discount_history" */
export type Organization_Product_Variation_Discount_History_Aggregate = {
  __typename?: 'organization_product_variation_discount_history_aggregate';
  aggregate?: Maybe<Organization_Product_Variation_Discount_History_Aggregate_Fields>;
  nodes: Array<Organization_Product_Variation_Discount_History>;
};

export type Organization_Product_Variation_Discount_History_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Organization_Product_Variation_Discount_History_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Organization_Product_Variation_Discount_History_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Organization_Product_Variation_Discount_History_Aggregate_Bool_Exp_Count>;
};

export type Organization_Product_Variation_Discount_History_Aggregate_Bool_Exp_Bool_And = {
  arguments: Organization_Product_Variation_Discount_History_Select_Column_Organization_Product_Variation_Discount_History_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Product_Variation_Discount_History_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organization_Product_Variation_Discount_History_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Organization_Product_Variation_Discount_History_Select_Column_Organization_Product_Variation_Discount_History_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Product_Variation_Discount_History_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organization_Product_Variation_Discount_History_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organization_Product_Variation_Discount_History_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Product_Variation_Discount_History_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organization_product_variation_discount_history" */
export type Organization_Product_Variation_Discount_History_Aggregate_Fields = {
  __typename?: 'organization_product_variation_discount_history_aggregate_fields';
  avg?: Maybe<Organization_Product_Variation_Discount_History_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_Product_Variation_Discount_History_Max_Fields>;
  min?: Maybe<Organization_Product_Variation_Discount_History_Min_Fields>;
  stddev?: Maybe<Organization_Product_Variation_Discount_History_Stddev_Fields>;
  stddev_pop?: Maybe<Organization_Product_Variation_Discount_History_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organization_Product_Variation_Discount_History_Stddev_Samp_Fields>;
  sum?: Maybe<Organization_Product_Variation_Discount_History_Sum_Fields>;
  var_pop?: Maybe<Organization_Product_Variation_Discount_History_Var_Pop_Fields>;
  var_samp?: Maybe<Organization_Product_Variation_Discount_History_Var_Samp_Fields>;
  variance?: Maybe<Organization_Product_Variation_Discount_History_Variance_Fields>;
};


/** aggregate fields of "organization_product_variation_discount_history" */
export type Organization_Product_Variation_Discount_History_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Product_Variation_Discount_History_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organization_product_variation_discount_history" */
export type Organization_Product_Variation_Discount_History_Aggregate_Order_By = {
  avg?: InputMaybe<Organization_Product_Variation_Discount_History_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Product_Variation_Discount_History_Max_Order_By>;
  min?: InputMaybe<Organization_Product_Variation_Discount_History_Min_Order_By>;
  stddev?: InputMaybe<Organization_Product_Variation_Discount_History_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Organization_Product_Variation_Discount_History_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Organization_Product_Variation_Discount_History_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Organization_Product_Variation_Discount_History_Sum_Order_By>;
  var_pop?: InputMaybe<Organization_Product_Variation_Discount_History_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Organization_Product_Variation_Discount_History_Var_Samp_Order_By>;
  variance?: InputMaybe<Organization_Product_Variation_Discount_History_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "organization_product_variation_discount_history" */
export type Organization_Product_Variation_Discount_History_Arr_Rel_Insert_Input = {
  data: Array<Organization_Product_Variation_Discount_History_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Product_Variation_Discount_History_On_Conflict>;
};

/** aggregate avg on columns */
export type Organization_Product_Variation_Discount_History_Avg_Fields = {
  __typename?: 'organization_product_variation_discount_history_avg_fields';
  new_discount_rate?: Maybe<Scalars['Float']['output']>;
  old_discount_rate?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "organization_product_variation_discount_history" */
export type Organization_Product_Variation_Discount_History_Avg_Order_By = {
  new_discount_rate?: InputMaybe<Order_By>;
  old_discount_rate?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "organization_product_variation_discount_history". All fields are combined with a logical 'AND'. */
export type Organization_Product_Variation_Discount_History_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Product_Variation_Discount_History_Bool_Exp>>;
  _not?: InputMaybe<Organization_Product_Variation_Discount_History_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Product_Variation_Discount_History_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  discountTypeByOldDiscountType?: InputMaybe<Discount_Type_Bool_Exp>;
  discount_type?: InputMaybe<Discount_Type_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  new_discount_rate?: InputMaybe<Numeric_Comparison_Exp>;
  new_discount_type?: InputMaybe<Discount_Type_Enum_Comparison_Exp>;
  old_discount_rate?: InputMaybe<Numeric_Comparison_Exp>;
  old_discount_type?: InputMaybe<Discount_Type_Enum_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  organization_product_variation_discount?: InputMaybe<Organization_Product_Variation_Discount_Bool_Exp>;
  organization_product_variation_discount_id?: InputMaybe<Uuid_Comparison_Exp>;
  previous_date?: InputMaybe<Timestamp_Comparison_Exp>;
  product_variation?: InputMaybe<Product_Variation_Bool_Exp>;
  product_variation_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_product_variation_discount_history" */
export enum Organization_Product_Variation_Discount_History_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrganizationProductVariationDiscountHistoryPkey = 'organization_product_variation_discount_history_pkey'
}

/** input type for incrementing numeric columns in table "organization_product_variation_discount_history" */
export type Organization_Product_Variation_Discount_History_Inc_Input = {
  new_discount_rate?: InputMaybe<Scalars['numeric']['input']>;
  old_discount_rate?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "organization_product_variation_discount_history" */
export type Organization_Product_Variation_Discount_History_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  discountTypeByOldDiscountType?: InputMaybe<Discount_Type_Obj_Rel_Insert_Input>;
  discount_type?: InputMaybe<Discount_Type_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  new_discount_rate?: InputMaybe<Scalars['numeric']['input']>;
  new_discount_type?: InputMaybe<Discount_Type_Enum>;
  old_discount_rate?: InputMaybe<Scalars['numeric']['input']>;
  old_discount_type?: InputMaybe<Discount_Type_Enum>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_product_variation_discount?: InputMaybe<Organization_Product_Variation_Discount_Obj_Rel_Insert_Input>;
  organization_product_variation_discount_id?: InputMaybe<Scalars['uuid']['input']>;
  previous_date?: InputMaybe<Scalars['timestamp']['input']>;
  product_variation?: InputMaybe<Product_Variation_Obj_Rel_Insert_Input>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Organization_Product_Variation_Discount_History_Max_Fields = {
  __typename?: 'organization_product_variation_discount_history_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  new_discount_rate?: Maybe<Scalars['numeric']['output']>;
  old_discount_rate?: Maybe<Scalars['numeric']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  organization_product_variation_discount_id?: Maybe<Scalars['uuid']['output']>;
  previous_date?: Maybe<Scalars['timestamp']['output']>;
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "organization_product_variation_discount_history" */
export type Organization_Product_Variation_Discount_History_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  new_discount_rate?: InputMaybe<Order_By>;
  old_discount_rate?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  organization_product_variation_discount_id?: InputMaybe<Order_By>;
  previous_date?: InputMaybe<Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organization_Product_Variation_Discount_History_Min_Fields = {
  __typename?: 'organization_product_variation_discount_history_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  new_discount_rate?: Maybe<Scalars['numeric']['output']>;
  old_discount_rate?: Maybe<Scalars['numeric']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  organization_product_variation_discount_id?: Maybe<Scalars['uuid']['output']>;
  previous_date?: Maybe<Scalars['timestamp']['output']>;
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "organization_product_variation_discount_history" */
export type Organization_Product_Variation_Discount_History_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  new_discount_rate?: InputMaybe<Order_By>;
  old_discount_rate?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  organization_product_variation_discount_id?: InputMaybe<Order_By>;
  previous_date?: InputMaybe<Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization_product_variation_discount_history" */
export type Organization_Product_Variation_Discount_History_Mutation_Response = {
  __typename?: 'organization_product_variation_discount_history_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Product_Variation_Discount_History>;
};

/** on_conflict condition type for table "organization_product_variation_discount_history" */
export type Organization_Product_Variation_Discount_History_On_Conflict = {
  constraint: Organization_Product_Variation_Discount_History_Constraint;
  update_columns?: Array<Organization_Product_Variation_Discount_History_Update_Column>;
  where?: InputMaybe<Organization_Product_Variation_Discount_History_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_product_variation_discount_history". */
export type Organization_Product_Variation_Discount_History_Order_By = {
  created_at?: InputMaybe<Order_By>;
  discountTypeByOldDiscountType?: InputMaybe<Discount_Type_Order_By>;
  discount_type?: InputMaybe<Discount_Type_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  new_discount_rate?: InputMaybe<Order_By>;
  new_discount_type?: InputMaybe<Order_By>;
  old_discount_rate?: InputMaybe<Order_By>;
  old_discount_type?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  organization_product_variation_discount?: InputMaybe<Organization_Product_Variation_Discount_Order_By>;
  organization_product_variation_discount_id?: InputMaybe<Order_By>;
  previous_date?: InputMaybe<Order_By>;
  product_variation?: InputMaybe<Product_Variation_Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_product_variation_discount_history */
export type Organization_Product_Variation_Discount_History_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organization_product_variation_discount_history" */
export enum Organization_Product_Variation_Discount_History_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  NewDiscountRate = 'new_discount_rate',
  /** column name */
  NewDiscountType = 'new_discount_type',
  /** column name */
  OldDiscountRate = 'old_discount_rate',
  /** column name */
  OldDiscountType = 'old_discount_type',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  OrganizationProductVariationDiscountId = 'organization_product_variation_discount_id',
  /** column name */
  PreviousDate = 'previous_date',
  /** column name */
  ProductVariationId = 'product_variation_id'
}

/** select "organization_product_variation_discount_history_aggregate_bool_exp_bool_and_arguments_columns" columns of table "organization_product_variation_discount_history" */
export enum Organization_Product_Variation_Discount_History_Select_Column_Organization_Product_Variation_Discount_History_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "organization_product_variation_discount_history_aggregate_bool_exp_bool_or_arguments_columns" columns of table "organization_product_variation_discount_history" */
export enum Organization_Product_Variation_Discount_History_Select_Column_Organization_Product_Variation_Discount_History_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "organization_product_variation_discount_history" */
export type Organization_Product_Variation_Discount_History_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  new_discount_rate?: InputMaybe<Scalars['numeric']['input']>;
  new_discount_type?: InputMaybe<Discount_Type_Enum>;
  old_discount_rate?: InputMaybe<Scalars['numeric']['input']>;
  old_discount_type?: InputMaybe<Discount_Type_Enum>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_product_variation_discount_id?: InputMaybe<Scalars['uuid']['input']>;
  previous_date?: InputMaybe<Scalars['timestamp']['input']>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Organization_Product_Variation_Discount_History_Stddev_Fields = {
  __typename?: 'organization_product_variation_discount_history_stddev_fields';
  new_discount_rate?: Maybe<Scalars['Float']['output']>;
  old_discount_rate?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "organization_product_variation_discount_history" */
export type Organization_Product_Variation_Discount_History_Stddev_Order_By = {
  new_discount_rate?: InputMaybe<Order_By>;
  old_discount_rate?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Organization_Product_Variation_Discount_History_Stddev_Pop_Fields = {
  __typename?: 'organization_product_variation_discount_history_stddev_pop_fields';
  new_discount_rate?: Maybe<Scalars['Float']['output']>;
  old_discount_rate?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "organization_product_variation_discount_history" */
export type Organization_Product_Variation_Discount_History_Stddev_Pop_Order_By = {
  new_discount_rate?: InputMaybe<Order_By>;
  old_discount_rate?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Organization_Product_Variation_Discount_History_Stddev_Samp_Fields = {
  __typename?: 'organization_product_variation_discount_history_stddev_samp_fields';
  new_discount_rate?: Maybe<Scalars['Float']['output']>;
  old_discount_rate?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "organization_product_variation_discount_history" */
export type Organization_Product_Variation_Discount_History_Stddev_Samp_Order_By = {
  new_discount_rate?: InputMaybe<Order_By>;
  old_discount_rate?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "organization_product_variation_discount_history" */
export type Organization_Product_Variation_Discount_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Product_Variation_Discount_History_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Product_Variation_Discount_History_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  new_discount_rate?: InputMaybe<Scalars['numeric']['input']>;
  new_discount_type?: InputMaybe<Discount_Type_Enum>;
  old_discount_rate?: InputMaybe<Scalars['numeric']['input']>;
  old_discount_type?: InputMaybe<Discount_Type_Enum>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_product_variation_discount_id?: InputMaybe<Scalars['uuid']['input']>;
  previous_date?: InputMaybe<Scalars['timestamp']['input']>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Organization_Product_Variation_Discount_History_Sum_Fields = {
  __typename?: 'organization_product_variation_discount_history_sum_fields';
  new_discount_rate?: Maybe<Scalars['numeric']['output']>;
  old_discount_rate?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "organization_product_variation_discount_history" */
export type Organization_Product_Variation_Discount_History_Sum_Order_By = {
  new_discount_rate?: InputMaybe<Order_By>;
  old_discount_rate?: InputMaybe<Order_By>;
};

/** update columns of table "organization_product_variation_discount_history" */
export enum Organization_Product_Variation_Discount_History_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  NewDiscountRate = 'new_discount_rate',
  /** column name */
  NewDiscountType = 'new_discount_type',
  /** column name */
  OldDiscountRate = 'old_discount_rate',
  /** column name */
  OldDiscountType = 'old_discount_type',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  OrganizationProductVariationDiscountId = 'organization_product_variation_discount_id',
  /** column name */
  PreviousDate = 'previous_date',
  /** column name */
  ProductVariationId = 'product_variation_id'
}

export type Organization_Product_Variation_Discount_History_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Organization_Product_Variation_Discount_History_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Product_Variation_Discount_History_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Product_Variation_Discount_History_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Organization_Product_Variation_Discount_History_Var_Pop_Fields = {
  __typename?: 'organization_product_variation_discount_history_var_pop_fields';
  new_discount_rate?: Maybe<Scalars['Float']['output']>;
  old_discount_rate?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "organization_product_variation_discount_history" */
export type Organization_Product_Variation_Discount_History_Var_Pop_Order_By = {
  new_discount_rate?: InputMaybe<Order_By>;
  old_discount_rate?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Organization_Product_Variation_Discount_History_Var_Samp_Fields = {
  __typename?: 'organization_product_variation_discount_history_var_samp_fields';
  new_discount_rate?: Maybe<Scalars['Float']['output']>;
  old_discount_rate?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "organization_product_variation_discount_history" */
export type Organization_Product_Variation_Discount_History_Var_Samp_Order_By = {
  new_discount_rate?: InputMaybe<Order_By>;
  old_discount_rate?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Organization_Product_Variation_Discount_History_Variance_Fields = {
  __typename?: 'organization_product_variation_discount_history_variance_fields';
  new_discount_rate?: Maybe<Scalars['Float']['output']>;
  old_discount_rate?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "organization_product_variation_discount_history" */
export type Organization_Product_Variation_Discount_History_Variance_Order_By = {
  new_discount_rate?: InputMaybe<Order_By>;
  old_discount_rate?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "organization_product_variation_discount" */
export type Organization_Product_Variation_Discount_Inc_Input = {
  discount_rate?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "organization_product_variation_discount" */
export type Organization_Product_Variation_Discount_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  discountTypeByDiscountType?: InputMaybe<Discount_Type_Obj_Rel_Insert_Input>;
  discount_rate?: InputMaybe<Scalars['numeric']['input']>;
  discount_type?: InputMaybe<Discount_Type_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_product_variation_discount_histories?: InputMaybe<Organization_Product_Variation_Discount_History_Arr_Rel_Insert_Input>;
  product_variation?: InputMaybe<Product_Variation_Obj_Rel_Insert_Input>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Organization_Product_Variation_Discount_Max_Fields = {
  __typename?: 'organization_product_variation_discount_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  discount_rate?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "organization_product_variation_discount" */
export type Organization_Product_Variation_Discount_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  discount_rate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organization_Product_Variation_Discount_Min_Fields = {
  __typename?: 'organization_product_variation_discount_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  discount_rate?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "organization_product_variation_discount" */
export type Organization_Product_Variation_Discount_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  discount_rate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization_product_variation_discount" */
export type Organization_Product_Variation_Discount_Mutation_Response = {
  __typename?: 'organization_product_variation_discount_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Product_Variation_Discount>;
};

/** input type for inserting object relation for remote table "organization_product_variation_discount" */
export type Organization_Product_Variation_Discount_Obj_Rel_Insert_Input = {
  data: Organization_Product_Variation_Discount_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Product_Variation_Discount_On_Conflict>;
};

/** on_conflict condition type for table "organization_product_variation_discount" */
export type Organization_Product_Variation_Discount_On_Conflict = {
  constraint: Organization_Product_Variation_Discount_Constraint;
  update_columns?: Array<Organization_Product_Variation_Discount_Update_Column>;
  where?: InputMaybe<Organization_Product_Variation_Discount_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_product_variation_discount". */
export type Organization_Product_Variation_Discount_Order_By = {
  created_at?: InputMaybe<Order_By>;
  discountTypeByDiscountType?: InputMaybe<Discount_Type_Order_By>;
  discount_rate?: InputMaybe<Order_By>;
  discount_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  organization_product_variation_discount_histories_aggregate?: InputMaybe<Organization_Product_Variation_Discount_History_Aggregate_Order_By>;
  product_variation?: InputMaybe<Product_Variation_Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_product_variation_discount */
export type Organization_Product_Variation_Discount_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organization_product_variation_discount" */
export enum Organization_Product_Variation_Discount_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DiscountRate = 'discount_rate',
  /** column name */
  DiscountType = 'discount_type',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  ProductVariationId = 'product_variation_id'
}

/** select "organization_product_variation_discount_aggregate_bool_exp_bool_and_arguments_columns" columns of table "organization_product_variation_discount" */
export enum Organization_Product_Variation_Discount_Select_Column_Organization_Product_Variation_Discount_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "organization_product_variation_discount_aggregate_bool_exp_bool_or_arguments_columns" columns of table "organization_product_variation_discount" */
export enum Organization_Product_Variation_Discount_Select_Column_Organization_Product_Variation_Discount_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "organization_product_variation_discount" */
export type Organization_Product_Variation_Discount_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  discount_rate?: InputMaybe<Scalars['numeric']['input']>;
  discount_type?: InputMaybe<Discount_Type_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Organization_Product_Variation_Discount_Stddev_Fields = {
  __typename?: 'organization_product_variation_discount_stddev_fields';
  discount_rate?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "organization_product_variation_discount" */
export type Organization_Product_Variation_Discount_Stddev_Order_By = {
  discount_rate?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Organization_Product_Variation_Discount_Stddev_Pop_Fields = {
  __typename?: 'organization_product_variation_discount_stddev_pop_fields';
  discount_rate?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "organization_product_variation_discount" */
export type Organization_Product_Variation_Discount_Stddev_Pop_Order_By = {
  discount_rate?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Organization_Product_Variation_Discount_Stddev_Samp_Fields = {
  __typename?: 'organization_product_variation_discount_stddev_samp_fields';
  discount_rate?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "organization_product_variation_discount" */
export type Organization_Product_Variation_Discount_Stddev_Samp_Order_By = {
  discount_rate?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "organization_product_variation_discount" */
export type Organization_Product_Variation_Discount_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Product_Variation_Discount_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Product_Variation_Discount_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  discount_rate?: InputMaybe<Scalars['numeric']['input']>;
  discount_type?: InputMaybe<Discount_Type_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Organization_Product_Variation_Discount_Sum_Fields = {
  __typename?: 'organization_product_variation_discount_sum_fields';
  discount_rate?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "organization_product_variation_discount" */
export type Organization_Product_Variation_Discount_Sum_Order_By = {
  discount_rate?: InputMaybe<Order_By>;
};

/** update columns of table "organization_product_variation_discount" */
export enum Organization_Product_Variation_Discount_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DiscountRate = 'discount_rate',
  /** column name */
  DiscountType = 'discount_type',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  ProductVariationId = 'product_variation_id'
}

export type Organization_Product_Variation_Discount_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Organization_Product_Variation_Discount_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Product_Variation_Discount_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Product_Variation_Discount_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Organization_Product_Variation_Discount_Var_Pop_Fields = {
  __typename?: 'organization_product_variation_discount_var_pop_fields';
  discount_rate?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "organization_product_variation_discount" */
export type Organization_Product_Variation_Discount_Var_Pop_Order_By = {
  discount_rate?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Organization_Product_Variation_Discount_Var_Samp_Fields = {
  __typename?: 'organization_product_variation_discount_var_samp_fields';
  discount_rate?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "organization_product_variation_discount" */
export type Organization_Product_Variation_Discount_Var_Samp_Order_By = {
  discount_rate?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Organization_Product_Variation_Discount_Variance_Fields = {
  __typename?: 'organization_product_variation_discount_variance_fields';
  discount_rate?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "organization_product_variation_discount" */
export type Organization_Product_Variation_Discount_Variance_Order_By = {
  discount_rate?: InputMaybe<Order_By>;
};

/** columns and relationships of "organization_sales_projection" */
export type Organization_Sales_Projection = {
  __typename?: 'organization_sales_projection';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  end_date?: Maybe<Scalars['date']['output']>;
  id: Scalars['uuid']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  organization: Organization;
  organization_id: Scalars['uuid']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
  start_date?: Maybe<Scalars['date']['output']>;
};

/** aggregated selection of "organization_sales_projection" */
export type Organization_Sales_Projection_Aggregate = {
  __typename?: 'organization_sales_projection_aggregate';
  aggregate?: Maybe<Organization_Sales_Projection_Aggregate_Fields>;
  nodes: Array<Organization_Sales_Projection>;
};

export type Organization_Sales_Projection_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Organization_Sales_Projection_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Organization_Sales_Projection_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Organization_Sales_Projection_Aggregate_Bool_Exp_Count>;
};

export type Organization_Sales_Projection_Aggregate_Bool_Exp_Bool_And = {
  arguments: Organization_Sales_Projection_Select_Column_Organization_Sales_Projection_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Sales_Projection_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organization_Sales_Projection_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Organization_Sales_Projection_Select_Column_Organization_Sales_Projection_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Sales_Projection_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organization_Sales_Projection_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organization_Sales_Projection_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Sales_Projection_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organization_sales_projection" */
export type Organization_Sales_Projection_Aggregate_Fields = {
  __typename?: 'organization_sales_projection_aggregate_fields';
  avg?: Maybe<Organization_Sales_Projection_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_Sales_Projection_Max_Fields>;
  min?: Maybe<Organization_Sales_Projection_Min_Fields>;
  stddev?: Maybe<Organization_Sales_Projection_Stddev_Fields>;
  stddev_pop?: Maybe<Organization_Sales_Projection_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organization_Sales_Projection_Stddev_Samp_Fields>;
  sum?: Maybe<Organization_Sales_Projection_Sum_Fields>;
  var_pop?: Maybe<Organization_Sales_Projection_Var_Pop_Fields>;
  var_samp?: Maybe<Organization_Sales_Projection_Var_Samp_Fields>;
  variance?: Maybe<Organization_Sales_Projection_Variance_Fields>;
};


/** aggregate fields of "organization_sales_projection" */
export type Organization_Sales_Projection_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Sales_Projection_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organization_sales_projection" */
export type Organization_Sales_Projection_Aggregate_Order_By = {
  avg?: InputMaybe<Organization_Sales_Projection_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Sales_Projection_Max_Order_By>;
  min?: InputMaybe<Organization_Sales_Projection_Min_Order_By>;
  stddev?: InputMaybe<Organization_Sales_Projection_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Organization_Sales_Projection_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Organization_Sales_Projection_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Organization_Sales_Projection_Sum_Order_By>;
  var_pop?: InputMaybe<Organization_Sales_Projection_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Organization_Sales_Projection_Var_Samp_Order_By>;
  variance?: InputMaybe<Organization_Sales_Projection_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "organization_sales_projection" */
export type Organization_Sales_Projection_Arr_Rel_Insert_Input = {
  data: Array<Organization_Sales_Projection_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Sales_Projection_On_Conflict>;
};

/** aggregate avg on columns */
export type Organization_Sales_Projection_Avg_Fields = {
  __typename?: 'organization_sales_projection_avg_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "organization_sales_projection" */
export type Organization_Sales_Projection_Avg_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "organization_sales_projection". All fields are combined with a logical 'AND'. */
export type Organization_Sales_Projection_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Sales_Projection_Bool_Exp>>;
  _not?: InputMaybe<Organization_Sales_Projection_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Sales_Projection_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  quantity?: InputMaybe<Int_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_sales_projection" */
export enum Organization_Sales_Projection_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrganizationSalesProjectionPkey = 'organization_sales_projection_pkey'
}

/** input type for incrementing numeric columns in table "organization_sales_projection" */
export type Organization_Sales_Projection_Inc_Input = {
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "organization_sales_projection" */
export type Organization_Sales_Projection_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
};

/** aggregate max on columns */
export type Organization_Sales_Projection_Max_Fields = {
  __typename?: 'organization_sales_projection_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  end_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  start_date?: Maybe<Scalars['date']['output']>;
};

/** order by max() on columns of table "organization_sales_projection" */
export type Organization_Sales_Projection_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organization_Sales_Projection_Min_Fields = {
  __typename?: 'organization_sales_projection_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  end_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  start_date?: Maybe<Scalars['date']['output']>;
};

/** order by min() on columns of table "organization_sales_projection" */
export type Organization_Sales_Projection_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization_sales_projection" */
export type Organization_Sales_Projection_Mutation_Response = {
  __typename?: 'organization_sales_projection_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Sales_Projection>;
};

/** on_conflict condition type for table "organization_sales_projection" */
export type Organization_Sales_Projection_On_Conflict = {
  constraint: Organization_Sales_Projection_Constraint;
  update_columns?: Array<Organization_Sales_Projection_Update_Column>;
  where?: InputMaybe<Organization_Sales_Projection_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_sales_projection". */
export type Organization_Sales_Projection_Order_By = {
  created_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_sales_projection */
export type Organization_Sales_Projection_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organization_sales_projection" */
export enum Organization_Sales_Projection_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  StartDate = 'start_date'
}

/** select "organization_sales_projection_aggregate_bool_exp_bool_and_arguments_columns" columns of table "organization_sales_projection" */
export enum Organization_Sales_Projection_Select_Column_Organization_Sales_Projection_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "organization_sales_projection_aggregate_bool_exp_bool_or_arguments_columns" columns of table "organization_sales_projection" */
export enum Organization_Sales_Projection_Select_Column_Organization_Sales_Projection_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "organization_sales_projection" */
export type Organization_Sales_Projection_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
};

/** aggregate stddev on columns */
export type Organization_Sales_Projection_Stddev_Fields = {
  __typename?: 'organization_sales_projection_stddev_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "organization_sales_projection" */
export type Organization_Sales_Projection_Stddev_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Organization_Sales_Projection_Stddev_Pop_Fields = {
  __typename?: 'organization_sales_projection_stddev_pop_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "organization_sales_projection" */
export type Organization_Sales_Projection_Stddev_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Organization_Sales_Projection_Stddev_Samp_Fields = {
  __typename?: 'organization_sales_projection_stddev_samp_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "organization_sales_projection" */
export type Organization_Sales_Projection_Stddev_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "organization_sales_projection" */
export type Organization_Sales_Projection_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Sales_Projection_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Sales_Projection_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
};

/** aggregate sum on columns */
export type Organization_Sales_Projection_Sum_Fields = {
  __typename?: 'organization_sales_projection_sum_fields';
  quantity?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "organization_sales_projection" */
export type Organization_Sales_Projection_Sum_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** update columns of table "organization_sales_projection" */
export enum Organization_Sales_Projection_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  StartDate = 'start_date'
}

export type Organization_Sales_Projection_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Organization_Sales_Projection_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Sales_Projection_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Sales_Projection_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Organization_Sales_Projection_Var_Pop_Fields = {
  __typename?: 'organization_sales_projection_var_pop_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "organization_sales_projection" */
export type Organization_Sales_Projection_Var_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Organization_Sales_Projection_Var_Samp_Fields = {
  __typename?: 'organization_sales_projection_var_samp_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "organization_sales_projection" */
export type Organization_Sales_Projection_Var_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Organization_Sales_Projection_Variance_Fields = {
  __typename?: 'organization_sales_projection_variance_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "organization_sales_projection" */
export type Organization_Sales_Projection_Variance_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** select columns of table "organization" */
export enum Organization_Select_Column {
  /** column name */
  AliasName = 'alias_name',
  /** column name */
  AllowedCreditLimit = 'allowed_credit_limit',
  /** column name */
  BdName = 'bd_name',
  /** column name */
  Brand = 'brand',
  /** column name */
  BrandLogo = 'brand_logo',
  /** column name */
  CinNumber = 'cin_number',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerCode = 'customer_code',
  /** column name */
  CustomerErpCode = 'customer_erp_code',
  /** column name */
  DefaultCurrency = 'default_currency',
  /** column name */
  DeliveryChargeId = 'delivery_charge_id',
  /** column name */
  Description = 'description',
  /** column name */
  FueltransCustomerId = 'fueltrans_customer_id',
  /** column name */
  GstNumber = 'gst_number',
  /** column name */
  HeadOfficeGeneralEmail = 'head_office_general_email',
  /** column name */
  HeadOfficeGeneralPhoneNumber = 'head_office_general_phone_number',
  /** column name */
  HoldingCompany = 'holding_company',
  /** column name */
  HoldingCompanyName = 'holding_company_name',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceEmail = 'invoice_email',
  /** column name */
  InvoicesUploaded = 'invoices_uploaded',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsBusiness = 'is_business',
  /** column name */
  IsPostPaid = 'is_post_paid',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  OrgType = 'org_type',
  /** column name */
  PanNumber = 'pan_number',
  /** column name */
  SignedInvoiceOnEmail = 'signed_invoice_on_email',
  /** column name */
  TechnicalContactEmail = 'technical_contact_email',
  /** column name */
  TechnicalContactFullName = 'technical_contact_full_name',
  /** column name */
  TechnicalContactPhoneNumber = 'technical_contact_phone_number',
  /** column name */
  TradeLicense = 'trade_license',
  /** column name */
  VerifiedAt = 'verified_at',
  /** column name */
  WebsiteUrl = 'website_url'
}

/** select "organization_aggregate_bool_exp_bool_and_arguments_columns" columns of table "organization" */
export enum Organization_Select_Column_Organization_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  HoldingCompany = 'holding_company',
  /** column name */
  InvoicesUploaded = 'invoices_uploaded',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsBusiness = 'is_business',
  /** column name */
  IsPostPaid = 'is_post_paid',
  /** column name */
  SignedInvoiceOnEmail = 'signed_invoice_on_email'
}

/** select "organization_aggregate_bool_exp_bool_or_arguments_columns" columns of table "organization" */
export enum Organization_Select_Column_Organization_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  HoldingCompany = 'holding_company',
  /** column name */
  InvoicesUploaded = 'invoices_uploaded',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsBusiness = 'is_business',
  /** column name */
  IsPostPaid = 'is_post_paid',
  /** column name */
  SignedInvoiceOnEmail = 'signed_invoice_on_email'
}

/** input type for updating data in table "organization" */
export type Organization_Set_Input = {
  alias_name?: InputMaybe<Scalars['String']['input']>;
  allowed_credit_limit?: InputMaybe<Scalars['numeric']['input']>;
  bd_name?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  brand_logo?: InputMaybe<Scalars['String']['input']>;
  cin_number?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_code?: InputMaybe<Scalars['Int']['input']>;
  customer_erp_code?: InputMaybe<Scalars['String']['input']>;
  default_currency?: InputMaybe<Scalars['uuid']['input']>;
  delivery_charge_id?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fueltrans_customer_id?: InputMaybe<Scalars['String']['input']>;
  gst_number?: InputMaybe<Scalars['String']['input']>;
  head_office_general_email?: InputMaybe<Scalars['String']['input']>;
  head_office_general_phone_number?: InputMaybe<Scalars['String']['input']>;
  holding_company?: InputMaybe<Scalars['Boolean']['input']>;
  holding_company_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invoice_email?: InputMaybe<Scalars['String']['input']>;
  invoices_uploaded?: InputMaybe<Scalars['Boolean']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_business?: InputMaybe<Scalars['Boolean']['input']>;
  is_post_paid?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  org_type?: InputMaybe<Organization_Type_Enum>;
  pan_number?: InputMaybe<Scalars['String']['input']>;
  signed_invoice_on_email?: InputMaybe<Scalars['Boolean']['input']>;
  technical_contact_email?: InputMaybe<Scalars['String']['input']>;
  technical_contact_full_name?: InputMaybe<Scalars['String']['input']>;
  technical_contact_phone_number?: InputMaybe<Scalars['String']['input']>;
  trade_license?: InputMaybe<Scalars['String']['input']>;
  verified_at?: InputMaybe<Scalars['timestamp']['input']>;
  website_url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Organization_Stddev_Fields = {
  __typename?: 'organization_stddev_fields';
  allowed_credit_limit?: Maybe<Scalars['Float']['output']>;
  customer_code?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "organization" */
export type Organization_Stddev_Order_By = {
  allowed_credit_limit?: InputMaybe<Order_By>;
  customer_code?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Organization_Stddev_Pop_Fields = {
  __typename?: 'organization_stddev_pop_fields';
  allowed_credit_limit?: Maybe<Scalars['Float']['output']>;
  customer_code?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "organization" */
export type Organization_Stddev_Pop_Order_By = {
  allowed_credit_limit?: InputMaybe<Order_By>;
  customer_code?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Organization_Stddev_Samp_Fields = {
  __typename?: 'organization_stddev_samp_fields';
  allowed_credit_limit?: Maybe<Scalars['Float']['output']>;
  customer_code?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "organization" */
export type Organization_Stddev_Samp_Order_By = {
  allowed_credit_limit?: InputMaybe<Order_By>;
  customer_code?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "organization" */
export type Organization_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Stream_Cursor_Value_Input = {
  alias_name?: InputMaybe<Scalars['String']['input']>;
  allowed_credit_limit?: InputMaybe<Scalars['numeric']['input']>;
  bd_name?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  brand_logo?: InputMaybe<Scalars['String']['input']>;
  cin_number?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_code?: InputMaybe<Scalars['Int']['input']>;
  customer_erp_code?: InputMaybe<Scalars['String']['input']>;
  default_currency?: InputMaybe<Scalars['uuid']['input']>;
  delivery_charge_id?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fueltrans_customer_id?: InputMaybe<Scalars['String']['input']>;
  gst_number?: InputMaybe<Scalars['String']['input']>;
  head_office_general_email?: InputMaybe<Scalars['String']['input']>;
  head_office_general_phone_number?: InputMaybe<Scalars['String']['input']>;
  holding_company?: InputMaybe<Scalars['Boolean']['input']>;
  holding_company_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invoice_email?: InputMaybe<Scalars['String']['input']>;
  invoices_uploaded?: InputMaybe<Scalars['Boolean']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_business?: InputMaybe<Scalars['Boolean']['input']>;
  is_post_paid?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  org_type?: InputMaybe<Organization_Type_Enum>;
  pan_number?: InputMaybe<Scalars['String']['input']>;
  signed_invoice_on_email?: InputMaybe<Scalars['Boolean']['input']>;
  technical_contact_email?: InputMaybe<Scalars['String']['input']>;
  technical_contact_full_name?: InputMaybe<Scalars['String']['input']>;
  technical_contact_phone_number?: InputMaybe<Scalars['String']['input']>;
  trade_license?: InputMaybe<Scalars['String']['input']>;
  verified_at?: InputMaybe<Scalars['timestamp']['input']>;
  website_url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Organization_Sum_Fields = {
  __typename?: 'organization_sum_fields';
  allowed_credit_limit?: Maybe<Scalars['numeric']['output']>;
  customer_code?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "organization" */
export type Organization_Sum_Order_By = {
  allowed_credit_limit?: InputMaybe<Order_By>;
  customer_code?: InputMaybe<Order_By>;
};

/** columns and relationships of "organization_timing" */
export type Organization_Timing = {
  __typename?: 'organization_timing';
  close_time?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  day?: Maybe<Day_Type_Enum>;
  /** An object relationship */
  day_type?: Maybe<Day_Type>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  is_closed: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  open_time?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  organization: Organization;
  organization_id: Scalars['uuid']['output'];
};

/** aggregated selection of "organization_timing" */
export type Organization_Timing_Aggregate = {
  __typename?: 'organization_timing_aggregate';
  aggregate?: Maybe<Organization_Timing_Aggregate_Fields>;
  nodes: Array<Organization_Timing>;
};

export type Organization_Timing_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Organization_Timing_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Organization_Timing_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Organization_Timing_Aggregate_Bool_Exp_Count>;
};

export type Organization_Timing_Aggregate_Bool_Exp_Bool_And = {
  arguments: Organization_Timing_Select_Column_Organization_Timing_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Timing_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organization_Timing_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Organization_Timing_Select_Column_Organization_Timing_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Timing_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organization_Timing_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organization_Timing_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Timing_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organization_timing" */
export type Organization_Timing_Aggregate_Fields = {
  __typename?: 'organization_timing_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_Timing_Max_Fields>;
  min?: Maybe<Organization_Timing_Min_Fields>;
};


/** aggregate fields of "organization_timing" */
export type Organization_Timing_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Timing_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organization_timing" */
export type Organization_Timing_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Timing_Max_Order_By>;
  min?: InputMaybe<Organization_Timing_Min_Order_By>;
};

/** input type for inserting array relation for remote table "organization_timing" */
export type Organization_Timing_Arr_Rel_Insert_Input = {
  data: Array<Organization_Timing_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Timing_On_Conflict>;
};

/** Boolean expression to filter rows from the table "organization_timing". All fields are combined with a logical 'AND'. */
export type Organization_Timing_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Timing_Bool_Exp>>;
  _not?: InputMaybe<Organization_Timing_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Timing_Bool_Exp>>;
  close_time?: InputMaybe<Timestamp_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  day?: InputMaybe<Day_Type_Enum_Comparison_Exp>;
  day_type?: InputMaybe<Day_Type_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_closed?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  open_time?: InputMaybe<Timestamp_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_timing" */
export enum Organization_Timing_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrganizationTimingPkey = 'organization_timing_pkey'
}

/** input type for inserting data into table "organization_timing" */
export type Organization_Timing_Insert_Input = {
  close_time?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  day?: InputMaybe<Day_Type_Enum>;
  day_type?: InputMaybe<Day_Type_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_closed?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  open_time?: InputMaybe<Scalars['timestamp']['input']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Organization_Timing_Max_Fields = {
  __typename?: 'organization_timing_max_fields';
  close_time?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  open_time?: Maybe<Scalars['timestamp']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "organization_timing" */
export type Organization_Timing_Max_Order_By = {
  close_time?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  open_time?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organization_Timing_Min_Fields = {
  __typename?: 'organization_timing_min_fields';
  close_time?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  open_time?: Maybe<Scalars['timestamp']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "organization_timing" */
export type Organization_Timing_Min_Order_By = {
  close_time?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  open_time?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization_timing" */
export type Organization_Timing_Mutation_Response = {
  __typename?: 'organization_timing_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Timing>;
};

/** on_conflict condition type for table "organization_timing" */
export type Organization_Timing_On_Conflict = {
  constraint: Organization_Timing_Constraint;
  update_columns?: Array<Organization_Timing_Update_Column>;
  where?: InputMaybe<Organization_Timing_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_timing". */
export type Organization_Timing_Order_By = {
  close_time?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  day?: InputMaybe<Order_By>;
  day_type?: InputMaybe<Day_Type_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_closed?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  open_time?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_timing */
export type Organization_Timing_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organization_timing" */
export enum Organization_Timing_Select_Column {
  /** column name */
  CloseTime = 'close_time',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Day = 'day',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsClosed = 'is_closed',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OpenTime = 'open_time',
  /** column name */
  OrganizationId = 'organization_id'
}

/** select "organization_timing_aggregate_bool_exp_bool_and_arguments_columns" columns of table "organization_timing" */
export enum Organization_Timing_Select_Column_Organization_Timing_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsClosed = 'is_closed'
}

/** select "organization_timing_aggregate_bool_exp_bool_or_arguments_columns" columns of table "organization_timing" */
export enum Organization_Timing_Select_Column_Organization_Timing_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsClosed = 'is_closed'
}

/** input type for updating data in table "organization_timing" */
export type Organization_Timing_Set_Input = {
  close_time?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  day?: InputMaybe<Day_Type_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_closed?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  open_time?: InputMaybe<Scalars['timestamp']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "organization_timing" */
export type Organization_Timing_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Timing_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Timing_Stream_Cursor_Value_Input = {
  close_time?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  day?: InputMaybe<Day_Type_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_closed?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  open_time?: InputMaybe<Scalars['timestamp']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "organization_timing" */
export enum Organization_Timing_Update_Column {
  /** column name */
  CloseTime = 'close_time',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Day = 'day',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsClosed = 'is_closed',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OpenTime = 'open_time',
  /** column name */
  OrganizationId = 'organization_id'
}

export type Organization_Timing_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Timing_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Timing_Bool_Exp;
};

/** columns and relationships of "organization_type" */
export type Organization_Type = {
  __typename?: 'organization_type';
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  organizations: Array<Organization>;
  /** An aggregate relationship */
  organizations_aggregate: Organization_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "organization_type" */
export type Organization_TypeOrganizationsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


/** columns and relationships of "organization_type" */
export type Organization_TypeOrganizations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};

/** aggregated selection of "organization_type" */
export type Organization_Type_Aggregate = {
  __typename?: 'organization_type_aggregate';
  aggregate?: Maybe<Organization_Type_Aggregate_Fields>;
  nodes: Array<Organization_Type>;
};

/** aggregate fields of "organization_type" */
export type Organization_Type_Aggregate_Fields = {
  __typename?: 'organization_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_Type_Max_Fields>;
  min?: Maybe<Organization_Type_Min_Fields>;
};


/** aggregate fields of "organization_type" */
export type Organization_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "organization_type". All fields are combined with a logical 'AND'. */
export type Organization_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Type_Bool_Exp>>;
  _not?: InputMaybe<Organization_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  organizations?: InputMaybe<Organization_Bool_Exp>;
  organizations_aggregate?: InputMaybe<Organization_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_type" */
export enum Organization_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  OrganizationTypePkey = 'organization_type_pkey'
}

export enum Organization_Type_Enum {
  /** BULK */
  Bulk = 'BULK',
  /** FLEET */
  Fleet = 'FLEET',
  /** INTERNAL */
  Internal = 'INTERNAL',
  /** TEST */
  Test = 'TEST'
}

/** Boolean expression to compare columns of type "organization_type_enum". All fields are combined with logical 'AND'. */
export type Organization_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Organization_Type_Enum>;
  _in?: InputMaybe<Array<Organization_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Organization_Type_Enum>;
  _nin?: InputMaybe<Array<Organization_Type_Enum>>;
};

/** input type for inserting data into table "organization_type" */
export type Organization_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  organizations?: InputMaybe<Organization_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Organization_Type_Max_Fields = {
  __typename?: 'organization_type_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Organization_Type_Min_Fields = {
  __typename?: 'organization_type_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "organization_type" */
export type Organization_Type_Mutation_Response = {
  __typename?: 'organization_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Type>;
};

/** input type for inserting object relation for remote table "organization_type" */
export type Organization_Type_Obj_Rel_Insert_Input = {
  data: Organization_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Type_On_Conflict>;
};

/** on_conflict condition type for table "organization_type" */
export type Organization_Type_On_Conflict = {
  constraint: Organization_Type_Constraint;
  update_columns?: Array<Organization_Type_Update_Column>;
  where?: InputMaybe<Organization_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_type". */
export type Organization_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  organizations_aggregate?: InputMaybe<Organization_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_type */
export type Organization_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "organization_type" */
export enum Organization_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "organization_type" */
export type Organization_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "organization_type" */
export type Organization_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "organization_type" */
export enum Organization_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Organization_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Type_Bool_Exp;
};

/** update columns of table "organization" */
export enum Organization_Update_Column {
  /** column name */
  AliasName = 'alias_name',
  /** column name */
  AllowedCreditLimit = 'allowed_credit_limit',
  /** column name */
  BdName = 'bd_name',
  /** column name */
  Brand = 'brand',
  /** column name */
  BrandLogo = 'brand_logo',
  /** column name */
  CinNumber = 'cin_number',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerCode = 'customer_code',
  /** column name */
  CustomerErpCode = 'customer_erp_code',
  /** column name */
  DefaultCurrency = 'default_currency',
  /** column name */
  DeliveryChargeId = 'delivery_charge_id',
  /** column name */
  Description = 'description',
  /** column name */
  FueltransCustomerId = 'fueltrans_customer_id',
  /** column name */
  GstNumber = 'gst_number',
  /** column name */
  HeadOfficeGeneralEmail = 'head_office_general_email',
  /** column name */
  HeadOfficeGeneralPhoneNumber = 'head_office_general_phone_number',
  /** column name */
  HoldingCompany = 'holding_company',
  /** column name */
  HoldingCompanyName = 'holding_company_name',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceEmail = 'invoice_email',
  /** column name */
  InvoicesUploaded = 'invoices_uploaded',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsBusiness = 'is_business',
  /** column name */
  IsPostPaid = 'is_post_paid',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  OrgType = 'org_type',
  /** column name */
  PanNumber = 'pan_number',
  /** column name */
  SignedInvoiceOnEmail = 'signed_invoice_on_email',
  /** column name */
  TechnicalContactEmail = 'technical_contact_email',
  /** column name */
  TechnicalContactFullName = 'technical_contact_full_name',
  /** column name */
  TechnicalContactPhoneNumber = 'technical_contact_phone_number',
  /** column name */
  TradeLicense = 'trade_license',
  /** column name */
  VerifiedAt = 'verified_at',
  /** column name */
  WebsiteUrl = 'website_url'
}

export type Organization_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Organization_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Bool_Exp;
};

/** columns and relationships of "organization_user" */
export type Organization_User = {
  __typename?: 'organization_user';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  customer_assets: Array<Customer_Asset>;
  /** An aggregate relationship */
  customer_assets_aggregate: Customer_Asset_Aggregate;
  customer_erp_code?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  customer_order_item_commissions: Array<Customer_Order_Item_Commission>;
  /** An aggregate relationship */
  customer_order_item_commissions_aggregate: Customer_Order_Item_Commission_Aggregate;
  /** An array relationship */
  customer_order_item_stateflows: Array<Customer_Order_Item_Stateflow>;
  /** An aggregate relationship */
  customer_order_item_stateflows_aggregate: Customer_Order_Item_Stateflow_Aggregate;
  /** An array relationship */
  customer_order_stateflows: Array<Customer_Order_Stateflow>;
  /** An aggregate relationship */
  customer_order_stateflows_aggregate: Customer_Order_Stateflow_Aggregate;
  /** An array relationship */
  customer_orders: Array<Customer_Order>;
  /** An aggregate relationship */
  customer_orders_aggregate: Customer_Order_Aggregate;
  /** An array relationship */
  delivery_schedulers: Array<Delivery_Scheduler>;
  /** An aggregate relationship */
  delivery_schedulers_aggregate: Delivery_Scheduler_Aggregate;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  is_owner: Scalars['Boolean']['output'];
  is_receipt_required: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  limit_used: Scalars['numeric']['output'];
  /** An array relationship */
  order_schedulers: Array<Order_Scheduler>;
  /** An aggregate relationship */
  order_schedulers_aggregate: Order_Scheduler_Aggregate;
  /** An object relationship */
  organization: Organization;
  /** An object relationship */
  organizationUserTypeByOrganizationUserType?: Maybe<Organization_User_Type>;
  /** An array relationship */
  organization_addresses: Array<Organization_Address>;
  /** An aggregate relationship */
  organization_addresses_aggregate: Organization_Address_Aggregate;
  /** An array relationship */
  organization_commission_product_variation_types: Array<Organization_Commission_Product_Variation_Type>;
  /** An aggregate relationship */
  organization_commission_product_variation_types_aggregate: Organization_Commission_Product_Variation_Type_Aggregate;
  organization_id: Scalars['uuid']['output'];
  /** An array relationship */
  organization_user_documents: Array<Organization_User_Document>;
  /** An aggregate relationship */
  organization_user_documents_aggregate: Organization_User_Document_Aggregate;
  /** An array relationship */
  organization_user_permissions: Array<Organization_User_Permission>;
  /** An aggregate relationship */
  organization_user_permissions_aggregate: Organization_User_Permission_Aggregate;
  /** An array relationship */
  organization_user_subsidiaries: Array<Organization_User_Subsidiary>;
  /** An aggregate relationship */
  organization_user_subsidiaries_aggregate: Organization_User_Subsidiary_Aggregate;
  organization_user_type?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  partner_orders: Array<Partner_Order>;
  /** An aggregate relationship */
  partner_orders_aggregate: Partner_Order_Aggregate;
  /** An array relationship */
  purchase_orders: Array<Purchase_Order>;
  /** An aggregate relationship */
  purchase_orders_aggregate: Purchase_Order_Aggregate;
  total_limit: Scalars['numeric']['output'];
  /** An object relationship */
  user: User;
  user_id: Scalars['uuid']['output'];
  /** An array relationship */
  user_ledgers: Array<User_Ledger>;
  /** An aggregate relationship */
  user_ledgers_aggregate: User_Ledger_Aggregate;
  /** An array relationship */
  vouchers: Array<Voucher>;
  /** An aggregate relationship */
  vouchers_aggregate: Voucher_Aggregate;
  /** An array relationship */
  wallet_transactions: Array<Wallet_Transactions>;
  /** An aggregate relationship */
  wallet_transactions_aggregate: Wallet_Transactions_Aggregate;
};


/** columns and relationships of "organization_user" */
export type Organization_UserCustomer_AssetsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Order_By>>;
  where?: InputMaybe<Customer_Asset_Bool_Exp>;
};


/** columns and relationships of "organization_user" */
export type Organization_UserCustomer_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Order_By>>;
  where?: InputMaybe<Customer_Asset_Bool_Exp>;
};


/** columns and relationships of "organization_user" */
export type Organization_UserCustomer_Order_Item_CommissionsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Commission_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Commission_Bool_Exp>;
};


/** columns and relationships of "organization_user" */
export type Organization_UserCustomer_Order_Item_Commissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Commission_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Commission_Bool_Exp>;
};


/** columns and relationships of "organization_user" */
export type Organization_UserCustomer_Order_Item_StateflowsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Stateflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Stateflow_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Stateflow_Bool_Exp>;
};


/** columns and relationships of "organization_user" */
export type Organization_UserCustomer_Order_Item_Stateflows_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Stateflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Stateflow_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Stateflow_Bool_Exp>;
};


/** columns and relationships of "organization_user" */
export type Organization_UserCustomer_Order_StateflowsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Stateflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Stateflow_Order_By>>;
  where?: InputMaybe<Customer_Order_Stateflow_Bool_Exp>;
};


/** columns and relationships of "organization_user" */
export type Organization_UserCustomer_Order_Stateflows_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Stateflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Stateflow_Order_By>>;
  where?: InputMaybe<Customer_Order_Stateflow_Bool_Exp>;
};


/** columns and relationships of "organization_user" */
export type Organization_UserCustomer_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Order_By>>;
  where?: InputMaybe<Customer_Order_Bool_Exp>;
};


/** columns and relationships of "organization_user" */
export type Organization_UserCustomer_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Order_By>>;
  where?: InputMaybe<Customer_Order_Bool_Exp>;
};


/** columns and relationships of "organization_user" */
export type Organization_UserDelivery_SchedulersArgs = {
  distinct_on?: InputMaybe<Array<Delivery_Scheduler_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delivery_Scheduler_Order_By>>;
  where?: InputMaybe<Delivery_Scheduler_Bool_Exp>;
};


/** columns and relationships of "organization_user" */
export type Organization_UserDelivery_Schedulers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Delivery_Scheduler_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delivery_Scheduler_Order_By>>;
  where?: InputMaybe<Delivery_Scheduler_Bool_Exp>;
};


/** columns and relationships of "organization_user" */
export type Organization_UserOrder_SchedulersArgs = {
  distinct_on?: InputMaybe<Array<Order_Scheduler_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Scheduler_Order_By>>;
  where?: InputMaybe<Order_Scheduler_Bool_Exp>;
};


/** columns and relationships of "organization_user" */
export type Organization_UserOrder_Schedulers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Scheduler_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Scheduler_Order_By>>;
  where?: InputMaybe<Order_Scheduler_Bool_Exp>;
};


/** columns and relationships of "organization_user" */
export type Organization_UserOrganization_AddressesArgs = {
  distinct_on?: InputMaybe<Array<Organization_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Address_Order_By>>;
  where?: InputMaybe<Organization_Address_Bool_Exp>;
};


/** columns and relationships of "organization_user" */
export type Organization_UserOrganization_Addresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Address_Order_By>>;
  where?: InputMaybe<Organization_Address_Bool_Exp>;
};


/** columns and relationships of "organization_user" */
export type Organization_UserOrganization_Commission_Product_Variation_TypesArgs = {
  distinct_on?: InputMaybe<Array<Organization_Commission_Product_Variation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Commission_Product_Variation_Type_Order_By>>;
  where?: InputMaybe<Organization_Commission_Product_Variation_Type_Bool_Exp>;
};


/** columns and relationships of "organization_user" */
export type Organization_UserOrganization_Commission_Product_Variation_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Commission_Product_Variation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Commission_Product_Variation_Type_Order_By>>;
  where?: InputMaybe<Organization_Commission_Product_Variation_Type_Bool_Exp>;
};


/** columns and relationships of "organization_user" */
export type Organization_UserOrganization_User_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Document_Order_By>>;
  where?: InputMaybe<Organization_User_Document_Bool_Exp>;
};


/** columns and relationships of "organization_user" */
export type Organization_UserOrganization_User_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Document_Order_By>>;
  where?: InputMaybe<Organization_User_Document_Bool_Exp>;
};


/** columns and relationships of "organization_user" */
export type Organization_UserOrganization_User_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Permission_Order_By>>;
  where?: InputMaybe<Organization_User_Permission_Bool_Exp>;
};


/** columns and relationships of "organization_user" */
export type Organization_UserOrganization_User_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Permission_Order_By>>;
  where?: InputMaybe<Organization_User_Permission_Bool_Exp>;
};


/** columns and relationships of "organization_user" */
export type Organization_UserOrganization_User_SubsidiariesArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Subsidiary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Subsidiary_Order_By>>;
  where?: InputMaybe<Organization_User_Subsidiary_Bool_Exp>;
};


/** columns and relationships of "organization_user" */
export type Organization_UserOrganization_User_Subsidiaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Subsidiary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Subsidiary_Order_By>>;
  where?: InputMaybe<Organization_User_Subsidiary_Bool_Exp>;
};


/** columns and relationships of "organization_user" */
export type Organization_UserPartner_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Order_By>>;
  where?: InputMaybe<Partner_Order_Bool_Exp>;
};


/** columns and relationships of "organization_user" */
export type Organization_UserPartner_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Order_By>>;
  where?: InputMaybe<Partner_Order_Bool_Exp>;
};


/** columns and relationships of "organization_user" */
export type Organization_UserPurchase_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Purchase_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Purchase_Order_Order_By>>;
  where?: InputMaybe<Purchase_Order_Bool_Exp>;
};


/** columns and relationships of "organization_user" */
export type Organization_UserPurchase_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Purchase_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Purchase_Order_Order_By>>;
  where?: InputMaybe<Purchase_Order_Bool_Exp>;
};


/** columns and relationships of "organization_user" */
export type Organization_UserUser_LedgersArgs = {
  distinct_on?: InputMaybe<Array<User_Ledger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Ledger_Order_By>>;
  where?: InputMaybe<User_Ledger_Bool_Exp>;
};


/** columns and relationships of "organization_user" */
export type Organization_UserUser_Ledgers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Ledger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Ledger_Order_By>>;
  where?: InputMaybe<User_Ledger_Bool_Exp>;
};


/** columns and relationships of "organization_user" */
export type Organization_UserVouchersArgs = {
  distinct_on?: InputMaybe<Array<Voucher_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Voucher_Order_By>>;
  where?: InputMaybe<Voucher_Bool_Exp>;
};


/** columns and relationships of "organization_user" */
export type Organization_UserVouchers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Voucher_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Voucher_Order_By>>;
  where?: InputMaybe<Voucher_Bool_Exp>;
};


/** columns and relationships of "organization_user" */
export type Organization_UserWallet_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Transactions_Order_By>>;
  where?: InputMaybe<Wallet_Transactions_Bool_Exp>;
};


/** columns and relationships of "organization_user" */
export type Organization_UserWallet_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Transactions_Order_By>>;
  where?: InputMaybe<Wallet_Transactions_Bool_Exp>;
};

/** aggregated selection of "organization_user" */
export type Organization_User_Aggregate = {
  __typename?: 'organization_user_aggregate';
  aggregate?: Maybe<Organization_User_Aggregate_Fields>;
  nodes: Array<Organization_User>;
};

export type Organization_User_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Organization_User_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Organization_User_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Organization_User_Aggregate_Bool_Exp_Count>;
};

export type Organization_User_Aggregate_Bool_Exp_Bool_And = {
  arguments: Organization_User_Select_Column_Organization_User_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_User_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organization_User_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Organization_User_Select_Column_Organization_User_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_User_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organization_User_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organization_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_User_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organization_user" */
export type Organization_User_Aggregate_Fields = {
  __typename?: 'organization_user_aggregate_fields';
  avg?: Maybe<Organization_User_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_User_Max_Fields>;
  min?: Maybe<Organization_User_Min_Fields>;
  stddev?: Maybe<Organization_User_Stddev_Fields>;
  stddev_pop?: Maybe<Organization_User_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organization_User_Stddev_Samp_Fields>;
  sum?: Maybe<Organization_User_Sum_Fields>;
  var_pop?: Maybe<Organization_User_Var_Pop_Fields>;
  var_samp?: Maybe<Organization_User_Var_Samp_Fields>;
  variance?: Maybe<Organization_User_Variance_Fields>;
};


/** aggregate fields of "organization_user" */
export type Organization_User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organization_user" */
export type Organization_User_Aggregate_Order_By = {
  avg?: InputMaybe<Organization_User_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_User_Max_Order_By>;
  min?: InputMaybe<Organization_User_Min_Order_By>;
  stddev?: InputMaybe<Organization_User_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Organization_User_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Organization_User_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Organization_User_Sum_Order_By>;
  var_pop?: InputMaybe<Organization_User_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Organization_User_Var_Samp_Order_By>;
  variance?: InputMaybe<Organization_User_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "organization_user" */
export type Organization_User_Arr_Rel_Insert_Input = {
  data: Array<Organization_User_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_User_On_Conflict>;
};

/** aggregate avg on columns */
export type Organization_User_Avg_Fields = {
  __typename?: 'organization_user_avg_fields';
  limit_used?: Maybe<Scalars['Float']['output']>;
  total_limit?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "organization_user" */
export type Organization_User_Avg_Order_By = {
  limit_used?: InputMaybe<Order_By>;
  total_limit?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "organization_user". All fields are combined with a logical 'AND'. */
export type Organization_User_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_User_Bool_Exp>>;
  _not?: InputMaybe<Organization_User_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_User_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_assets?: InputMaybe<Customer_Asset_Bool_Exp>;
  customer_assets_aggregate?: InputMaybe<Customer_Asset_Aggregate_Bool_Exp>;
  customer_erp_code?: InputMaybe<String_Comparison_Exp>;
  customer_order_item_commissions?: InputMaybe<Customer_Order_Item_Commission_Bool_Exp>;
  customer_order_item_commissions_aggregate?: InputMaybe<Customer_Order_Item_Commission_Aggregate_Bool_Exp>;
  customer_order_item_stateflows?: InputMaybe<Customer_Order_Item_Stateflow_Bool_Exp>;
  customer_order_item_stateflows_aggregate?: InputMaybe<Customer_Order_Item_Stateflow_Aggregate_Bool_Exp>;
  customer_order_stateflows?: InputMaybe<Customer_Order_Stateflow_Bool_Exp>;
  customer_order_stateflows_aggregate?: InputMaybe<Customer_Order_Stateflow_Aggregate_Bool_Exp>;
  customer_orders?: InputMaybe<Customer_Order_Bool_Exp>;
  customer_orders_aggregate?: InputMaybe<Customer_Order_Aggregate_Bool_Exp>;
  delivery_schedulers?: InputMaybe<Delivery_Scheduler_Bool_Exp>;
  delivery_schedulers_aggregate?: InputMaybe<Delivery_Scheduler_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_owner?: InputMaybe<Boolean_Comparison_Exp>;
  is_receipt_required?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  limit_used?: InputMaybe<Numeric_Comparison_Exp>;
  order_schedulers?: InputMaybe<Order_Scheduler_Bool_Exp>;
  order_schedulers_aggregate?: InputMaybe<Order_Scheduler_Aggregate_Bool_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationUserTypeByOrganizationUserType?: InputMaybe<Organization_User_Type_Bool_Exp>;
  organization_addresses?: InputMaybe<Organization_Address_Bool_Exp>;
  organization_addresses_aggregate?: InputMaybe<Organization_Address_Aggregate_Bool_Exp>;
  organization_commission_product_variation_types?: InputMaybe<Organization_Commission_Product_Variation_Type_Bool_Exp>;
  organization_commission_product_variation_types_aggregate?: InputMaybe<Organization_Commission_Product_Variation_Type_Aggregate_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  organization_user_documents?: InputMaybe<Organization_User_Document_Bool_Exp>;
  organization_user_documents_aggregate?: InputMaybe<Organization_User_Document_Aggregate_Bool_Exp>;
  organization_user_permissions?: InputMaybe<Organization_User_Permission_Bool_Exp>;
  organization_user_permissions_aggregate?: InputMaybe<Organization_User_Permission_Aggregate_Bool_Exp>;
  organization_user_subsidiaries?: InputMaybe<Organization_User_Subsidiary_Bool_Exp>;
  organization_user_subsidiaries_aggregate?: InputMaybe<Organization_User_Subsidiary_Aggregate_Bool_Exp>;
  organization_user_type?: InputMaybe<String_Comparison_Exp>;
  partner_orders?: InputMaybe<Partner_Order_Bool_Exp>;
  partner_orders_aggregate?: InputMaybe<Partner_Order_Aggregate_Bool_Exp>;
  purchase_orders?: InputMaybe<Purchase_Order_Bool_Exp>;
  purchase_orders_aggregate?: InputMaybe<Purchase_Order_Aggregate_Bool_Exp>;
  total_limit?: InputMaybe<Numeric_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  user_ledgers?: InputMaybe<User_Ledger_Bool_Exp>;
  user_ledgers_aggregate?: InputMaybe<User_Ledger_Aggregate_Bool_Exp>;
  vouchers?: InputMaybe<Voucher_Bool_Exp>;
  vouchers_aggregate?: InputMaybe<Voucher_Aggregate_Bool_Exp>;
  wallet_transactions?: InputMaybe<Wallet_Transactions_Bool_Exp>;
  wallet_transactions_aggregate?: InputMaybe<Wallet_Transactions_Aggregate_Bool_Exp>;
};

/** columns and relationships of "organization_user_commission" */
export type Organization_User_Commission = {
  __typename?: 'organization_user_commission';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  organization_commission_product_variation_type: Organization_Commission_Product_Variation_Type;
  organization_commission_product_variation_type_id: Scalars['uuid']['output'];
  /** An object relationship */
  user: User;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "organization_user_commission" */
export type Organization_User_Commission_Aggregate = {
  __typename?: 'organization_user_commission_aggregate';
  aggregate?: Maybe<Organization_User_Commission_Aggregate_Fields>;
  nodes: Array<Organization_User_Commission>;
};

export type Organization_User_Commission_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Organization_User_Commission_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Organization_User_Commission_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Organization_User_Commission_Aggregate_Bool_Exp_Count>;
};

export type Organization_User_Commission_Aggregate_Bool_Exp_Bool_And = {
  arguments: Organization_User_Commission_Select_Column_Organization_User_Commission_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_User_Commission_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organization_User_Commission_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Organization_User_Commission_Select_Column_Organization_User_Commission_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_User_Commission_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organization_User_Commission_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organization_User_Commission_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_User_Commission_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organization_user_commission" */
export type Organization_User_Commission_Aggregate_Fields = {
  __typename?: 'organization_user_commission_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_User_Commission_Max_Fields>;
  min?: Maybe<Organization_User_Commission_Min_Fields>;
};


/** aggregate fields of "organization_user_commission" */
export type Organization_User_Commission_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_User_Commission_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organization_user_commission" */
export type Organization_User_Commission_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_User_Commission_Max_Order_By>;
  min?: InputMaybe<Organization_User_Commission_Min_Order_By>;
};

/** input type for inserting array relation for remote table "organization_user_commission" */
export type Organization_User_Commission_Arr_Rel_Insert_Input = {
  data: Array<Organization_User_Commission_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_User_Commission_On_Conflict>;
};

/** Boolean expression to filter rows from the table "organization_user_commission". All fields are combined with a logical 'AND'. */
export type Organization_User_Commission_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_User_Commission_Bool_Exp>>;
  _not?: InputMaybe<Organization_User_Commission_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_User_Commission_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  organization_commission_product_variation_type?: InputMaybe<Organization_Commission_Product_Variation_Type_Bool_Exp>;
  organization_commission_product_variation_type_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_user_commission" */
export enum Organization_User_Commission_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrganizationUserCommissionPkey = 'organization_user_commission_pkey'
}

/** input type for inserting data into table "organization_user_commission" */
export type Organization_User_Commission_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_commission_product_variation_type?: InputMaybe<Organization_Commission_Product_Variation_Type_Obj_Rel_Insert_Input>;
  organization_commission_product_variation_type_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Organization_User_Commission_Max_Fields = {
  __typename?: 'organization_user_commission_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  organization_commission_product_variation_type_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "organization_user_commission" */
export type Organization_User_Commission_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_commission_product_variation_type_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organization_User_Commission_Min_Fields = {
  __typename?: 'organization_user_commission_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  organization_commission_product_variation_type_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "organization_user_commission" */
export type Organization_User_Commission_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_commission_product_variation_type_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization_user_commission" */
export type Organization_User_Commission_Mutation_Response = {
  __typename?: 'organization_user_commission_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_User_Commission>;
};

/** on_conflict condition type for table "organization_user_commission" */
export type Organization_User_Commission_On_Conflict = {
  constraint: Organization_User_Commission_Constraint;
  update_columns?: Array<Organization_User_Commission_Update_Column>;
  where?: InputMaybe<Organization_User_Commission_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_user_commission". */
export type Organization_User_Commission_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_commission_product_variation_type?: InputMaybe<Organization_Commission_Product_Variation_Type_Order_By>;
  organization_commission_product_variation_type_id?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_user_commission */
export type Organization_User_Commission_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organization_user_commission" */
export enum Organization_User_Commission_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrganizationCommissionProductVariationTypeId = 'organization_commission_product_variation_type_id',
  /** column name */
  UserId = 'user_id'
}

/** select "organization_user_commission_aggregate_bool_exp_bool_and_arguments_columns" columns of table "organization_user_commission" */
export enum Organization_User_Commission_Select_Column_Organization_User_Commission_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "organization_user_commission_aggregate_bool_exp_bool_or_arguments_columns" columns of table "organization_user_commission" */
export enum Organization_User_Commission_Select_Column_Organization_User_Commission_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "organization_user_commission" */
export type Organization_User_Commission_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_commission_product_variation_type_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "organization_user_commission" */
export type Organization_User_Commission_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_User_Commission_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_User_Commission_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_commission_product_variation_type_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "organization_user_commission" */
export enum Organization_User_Commission_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrganizationCommissionProductVariationTypeId = 'organization_commission_product_variation_type_id',
  /** column name */
  UserId = 'user_id'
}

export type Organization_User_Commission_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_User_Commission_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_User_Commission_Bool_Exp;
};

/** unique or primary key constraints on table "organization_user" */
export enum Organization_User_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrganizationUserPkey = 'organization_user_pkey'
}

/** columns and relationships of "organization_user_document" */
export type Organization_User_Document = {
  __typename?: 'organization_user_document';
  category?: Maybe<Document_Type_Category_Enum>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  customer_order_organization_user_documents: Array<Customer_Order_Organization_User_Document>;
  /** An aggregate relationship */
  customer_order_organization_user_documents_aggregate: Customer_Order_Organization_User_Document_Aggregate;
  /** An object relationship */
  document: Documents;
  document_id: Scalars['uuid']['output'];
  /** An object relationship */
  document_type_category?: Maybe<Document_Type_Category>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  organization_user: Organization_User;
  organization_user_id: Scalars['uuid']['output'];
  url?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "organization_user_document" */
export type Organization_User_DocumentCustomer_Order_Organization_User_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Organization_User_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Organization_User_Document_Order_By>>;
  where?: InputMaybe<Customer_Order_Organization_User_Document_Bool_Exp>;
};


/** columns and relationships of "organization_user_document" */
export type Organization_User_DocumentCustomer_Order_Organization_User_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Organization_User_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Organization_User_Document_Order_By>>;
  where?: InputMaybe<Customer_Order_Organization_User_Document_Bool_Exp>;
};

/** aggregated selection of "organization_user_document" */
export type Organization_User_Document_Aggregate = {
  __typename?: 'organization_user_document_aggregate';
  aggregate?: Maybe<Organization_User_Document_Aggregate_Fields>;
  nodes: Array<Organization_User_Document>;
};

export type Organization_User_Document_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Organization_User_Document_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Organization_User_Document_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Organization_User_Document_Aggregate_Bool_Exp_Count>;
};

export type Organization_User_Document_Aggregate_Bool_Exp_Bool_And = {
  arguments: Organization_User_Document_Select_Column_Organization_User_Document_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_User_Document_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organization_User_Document_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Organization_User_Document_Select_Column_Organization_User_Document_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_User_Document_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organization_User_Document_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organization_User_Document_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_User_Document_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organization_user_document" */
export type Organization_User_Document_Aggregate_Fields = {
  __typename?: 'organization_user_document_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_User_Document_Max_Fields>;
  min?: Maybe<Organization_User_Document_Min_Fields>;
};


/** aggregate fields of "organization_user_document" */
export type Organization_User_Document_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_User_Document_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organization_user_document" */
export type Organization_User_Document_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_User_Document_Max_Order_By>;
  min?: InputMaybe<Organization_User_Document_Min_Order_By>;
};

/** input type for inserting array relation for remote table "organization_user_document" */
export type Organization_User_Document_Arr_Rel_Insert_Input = {
  data: Array<Organization_User_Document_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_User_Document_On_Conflict>;
};

/** Boolean expression to filter rows from the table "organization_user_document". All fields are combined with a logical 'AND'. */
export type Organization_User_Document_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_User_Document_Bool_Exp>>;
  _not?: InputMaybe<Organization_User_Document_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_User_Document_Bool_Exp>>;
  category?: InputMaybe<Document_Type_Category_Enum_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_order_organization_user_documents?: InputMaybe<Customer_Order_Organization_User_Document_Bool_Exp>;
  customer_order_organization_user_documents_aggregate?: InputMaybe<Customer_Order_Organization_User_Document_Aggregate_Bool_Exp>;
  document?: InputMaybe<Documents_Bool_Exp>;
  document_id?: InputMaybe<Uuid_Comparison_Exp>;
  document_type_category?: InputMaybe<Document_Type_Category_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  organization_user?: InputMaybe<Organization_User_Bool_Exp>;
  organization_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_user_document" */
export enum Organization_User_Document_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrganizationUserDocumentPkey = 'organization_user_document_pkey'
}

/** input type for inserting data into table "organization_user_document" */
export type Organization_User_Document_Insert_Input = {
  category?: InputMaybe<Document_Type_Category_Enum>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_organization_user_documents?: InputMaybe<Customer_Order_Organization_User_Document_Arr_Rel_Insert_Input>;
  document?: InputMaybe<Documents_Obj_Rel_Insert_Input>;
  document_id?: InputMaybe<Scalars['uuid']['input']>;
  document_type_category?: InputMaybe<Document_Type_Category_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_user?: InputMaybe<Organization_User_Obj_Rel_Insert_Input>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Organization_User_Document_Max_Fields = {
  __typename?: 'organization_user_document_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  document_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  organization_user_id?: Maybe<Scalars['uuid']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "organization_user_document" */
export type Organization_User_Document_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organization_User_Document_Min_Fields = {
  __typename?: 'organization_user_document_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  document_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  organization_user_id?: Maybe<Scalars['uuid']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "organization_user_document" */
export type Organization_User_Document_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization_user_document" */
export type Organization_User_Document_Mutation_Response = {
  __typename?: 'organization_user_document_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_User_Document>;
};

/** input type for inserting object relation for remote table "organization_user_document" */
export type Organization_User_Document_Obj_Rel_Insert_Input = {
  data: Organization_User_Document_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_User_Document_On_Conflict>;
};

/** on_conflict condition type for table "organization_user_document" */
export type Organization_User_Document_On_Conflict = {
  constraint: Organization_User_Document_Constraint;
  update_columns?: Array<Organization_User_Document_Update_Column>;
  where?: InputMaybe<Organization_User_Document_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_user_document". */
export type Organization_User_Document_Order_By = {
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_order_organization_user_documents_aggregate?: InputMaybe<Customer_Order_Organization_User_Document_Aggregate_Order_By>;
  document?: InputMaybe<Documents_Order_By>;
  document_id?: InputMaybe<Order_By>;
  document_type_category?: InputMaybe<Document_Type_Category_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_user?: InputMaybe<Organization_User_Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_user_document */
export type Organization_User_Document_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organization_user_document" */
export enum Organization_User_Document_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrganizationUserId = 'organization_user_id',
  /** column name */
  Url = 'url'
}

/** select "organization_user_document_aggregate_bool_exp_bool_and_arguments_columns" columns of table "organization_user_document" */
export enum Organization_User_Document_Select_Column_Organization_User_Document_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "organization_user_document_aggregate_bool_exp_bool_or_arguments_columns" columns of table "organization_user_document" */
export enum Organization_User_Document_Select_Column_Organization_User_Document_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "organization_user_document" */
export type Organization_User_Document_Set_Input = {
  category?: InputMaybe<Document_Type_Category_Enum>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  document_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "organization_user_document" */
export type Organization_User_Document_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_User_Document_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_User_Document_Stream_Cursor_Value_Input = {
  category?: InputMaybe<Document_Type_Category_Enum>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  document_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "organization_user_document" */
export enum Organization_User_Document_Update_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrganizationUserId = 'organization_user_id',
  /** column name */
  Url = 'url'
}

export type Organization_User_Document_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_User_Document_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_User_Document_Bool_Exp;
};

/** input type for incrementing numeric columns in table "organization_user" */
export type Organization_User_Inc_Input = {
  limit_used?: InputMaybe<Scalars['numeric']['input']>;
  total_limit?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "organization_user" */
export type Organization_User_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_assets?: InputMaybe<Customer_Asset_Arr_Rel_Insert_Input>;
  customer_erp_code?: InputMaybe<Scalars['String']['input']>;
  customer_order_item_commissions?: InputMaybe<Customer_Order_Item_Commission_Arr_Rel_Insert_Input>;
  customer_order_item_stateflows?: InputMaybe<Customer_Order_Item_Stateflow_Arr_Rel_Insert_Input>;
  customer_order_stateflows?: InputMaybe<Customer_Order_Stateflow_Arr_Rel_Insert_Input>;
  customer_orders?: InputMaybe<Customer_Order_Arr_Rel_Insert_Input>;
  delivery_schedulers?: InputMaybe<Delivery_Scheduler_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_owner?: InputMaybe<Scalars['Boolean']['input']>;
  is_receipt_required?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  limit_used?: InputMaybe<Scalars['numeric']['input']>;
  order_schedulers?: InputMaybe<Order_Scheduler_Arr_Rel_Insert_Input>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationUserTypeByOrganizationUserType?: InputMaybe<Organization_User_Type_Obj_Rel_Insert_Input>;
  organization_addresses?: InputMaybe<Organization_Address_Arr_Rel_Insert_Input>;
  organization_commission_product_variation_types?: InputMaybe<Organization_Commission_Product_Variation_Type_Arr_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_user_documents?: InputMaybe<Organization_User_Document_Arr_Rel_Insert_Input>;
  organization_user_permissions?: InputMaybe<Organization_User_Permission_Arr_Rel_Insert_Input>;
  organization_user_subsidiaries?: InputMaybe<Organization_User_Subsidiary_Arr_Rel_Insert_Input>;
  organization_user_type?: InputMaybe<Scalars['String']['input']>;
  partner_orders?: InputMaybe<Partner_Order_Arr_Rel_Insert_Input>;
  purchase_orders?: InputMaybe<Purchase_Order_Arr_Rel_Insert_Input>;
  total_limit?: InputMaybe<Scalars['numeric']['input']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_ledgers?: InputMaybe<User_Ledger_Arr_Rel_Insert_Input>;
  vouchers?: InputMaybe<Voucher_Arr_Rel_Insert_Input>;
  wallet_transactions?: InputMaybe<Wallet_Transactions_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Organization_User_Max_Fields = {
  __typename?: 'organization_user_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_erp_code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  limit_used?: Maybe<Scalars['numeric']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  organization_user_type?: Maybe<Scalars['String']['output']>;
  total_limit?: Maybe<Scalars['numeric']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "organization_user" */
export type Organization_User_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_erp_code?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  limit_used?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  organization_user_type?: InputMaybe<Order_By>;
  total_limit?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organization_User_Min_Fields = {
  __typename?: 'organization_user_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_erp_code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  limit_used?: Maybe<Scalars['numeric']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  organization_user_type?: Maybe<Scalars['String']['output']>;
  total_limit?: Maybe<Scalars['numeric']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "organization_user" */
export type Organization_User_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_erp_code?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  limit_used?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  organization_user_type?: InputMaybe<Order_By>;
  total_limit?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization_user" */
export type Organization_User_Mutation_Response = {
  __typename?: 'organization_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_User>;
};

/** input type for inserting object relation for remote table "organization_user" */
export type Organization_User_Obj_Rel_Insert_Input = {
  data: Organization_User_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_User_On_Conflict>;
};

/** on_conflict condition type for table "organization_user" */
export type Organization_User_On_Conflict = {
  constraint: Organization_User_Constraint;
  update_columns?: Array<Organization_User_Update_Column>;
  where?: InputMaybe<Organization_User_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_user". */
export type Organization_User_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_assets_aggregate?: InputMaybe<Customer_Asset_Aggregate_Order_By>;
  customer_erp_code?: InputMaybe<Order_By>;
  customer_order_item_commissions_aggregate?: InputMaybe<Customer_Order_Item_Commission_Aggregate_Order_By>;
  customer_order_item_stateflows_aggregate?: InputMaybe<Customer_Order_Item_Stateflow_Aggregate_Order_By>;
  customer_order_stateflows_aggregate?: InputMaybe<Customer_Order_Stateflow_Aggregate_Order_By>;
  customer_orders_aggregate?: InputMaybe<Customer_Order_Aggregate_Order_By>;
  delivery_schedulers_aggregate?: InputMaybe<Delivery_Scheduler_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_owner?: InputMaybe<Order_By>;
  is_receipt_required?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  limit_used?: InputMaybe<Order_By>;
  order_schedulers_aggregate?: InputMaybe<Order_Scheduler_Aggregate_Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationUserTypeByOrganizationUserType?: InputMaybe<Organization_User_Type_Order_By>;
  organization_addresses_aggregate?: InputMaybe<Organization_Address_Aggregate_Order_By>;
  organization_commission_product_variation_types_aggregate?: InputMaybe<Organization_Commission_Product_Variation_Type_Aggregate_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  organization_user_documents_aggregate?: InputMaybe<Organization_User_Document_Aggregate_Order_By>;
  organization_user_permissions_aggregate?: InputMaybe<Organization_User_Permission_Aggregate_Order_By>;
  organization_user_subsidiaries_aggregate?: InputMaybe<Organization_User_Subsidiary_Aggregate_Order_By>;
  organization_user_type?: InputMaybe<Order_By>;
  partner_orders_aggregate?: InputMaybe<Partner_Order_Aggregate_Order_By>;
  purchase_orders_aggregate?: InputMaybe<Purchase_Order_Aggregate_Order_By>;
  total_limit?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_ledgers_aggregate?: InputMaybe<User_Ledger_Aggregate_Order_By>;
  vouchers_aggregate?: InputMaybe<Voucher_Aggregate_Order_By>;
  wallet_transactions_aggregate?: InputMaybe<Wallet_Transactions_Aggregate_Order_By>;
};

/** columns and relationships of "organization_user_permission" */
export type Organization_User_Permission = {
  __typename?: 'organization_user_permission';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  organization_user: Organization_User;
  organization_user_id: Scalars['uuid']['output'];
  /** An object relationship */
  permission: Permission;
  permission_id: Scalars['uuid']['output'];
};

/** aggregated selection of "organization_user_permission" */
export type Organization_User_Permission_Aggregate = {
  __typename?: 'organization_user_permission_aggregate';
  aggregate?: Maybe<Organization_User_Permission_Aggregate_Fields>;
  nodes: Array<Organization_User_Permission>;
};

export type Organization_User_Permission_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Organization_User_Permission_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Organization_User_Permission_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Organization_User_Permission_Aggregate_Bool_Exp_Count>;
};

export type Organization_User_Permission_Aggregate_Bool_Exp_Bool_And = {
  arguments: Organization_User_Permission_Select_Column_Organization_User_Permission_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_User_Permission_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organization_User_Permission_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Organization_User_Permission_Select_Column_Organization_User_Permission_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_User_Permission_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organization_User_Permission_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organization_User_Permission_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_User_Permission_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organization_user_permission" */
export type Organization_User_Permission_Aggregate_Fields = {
  __typename?: 'organization_user_permission_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_User_Permission_Max_Fields>;
  min?: Maybe<Organization_User_Permission_Min_Fields>;
};


/** aggregate fields of "organization_user_permission" */
export type Organization_User_Permission_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_User_Permission_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organization_user_permission" */
export type Organization_User_Permission_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_User_Permission_Max_Order_By>;
  min?: InputMaybe<Organization_User_Permission_Min_Order_By>;
};

/** input type for inserting array relation for remote table "organization_user_permission" */
export type Organization_User_Permission_Arr_Rel_Insert_Input = {
  data: Array<Organization_User_Permission_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_User_Permission_On_Conflict>;
};

/** Boolean expression to filter rows from the table "organization_user_permission". All fields are combined with a logical 'AND'. */
export type Organization_User_Permission_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_User_Permission_Bool_Exp>>;
  _not?: InputMaybe<Organization_User_Permission_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_User_Permission_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  disabled?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  organization_user?: InputMaybe<Organization_User_Bool_Exp>;
  organization_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  permission?: InputMaybe<Permission_Bool_Exp>;
  permission_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_user_permission" */
export enum Organization_User_Permission_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrganizationUserPermissionPkey = 'organization_user_permission_pkey'
}

/** input type for inserting data into table "organization_user_permission" */
export type Organization_User_Permission_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_user?: InputMaybe<Organization_User_Obj_Rel_Insert_Input>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  permission?: InputMaybe<Permission_Obj_Rel_Insert_Input>;
  permission_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Organization_User_Permission_Max_Fields = {
  __typename?: 'organization_user_permission_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  organization_user_id?: Maybe<Scalars['uuid']['output']>;
  permission_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "organization_user_permission" */
export type Organization_User_Permission_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organization_User_Permission_Min_Fields = {
  __typename?: 'organization_user_permission_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  organization_user_id?: Maybe<Scalars['uuid']['output']>;
  permission_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "organization_user_permission" */
export type Organization_User_Permission_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization_user_permission" */
export type Organization_User_Permission_Mutation_Response = {
  __typename?: 'organization_user_permission_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_User_Permission>;
};

/** on_conflict condition type for table "organization_user_permission" */
export type Organization_User_Permission_On_Conflict = {
  constraint: Organization_User_Permission_Constraint;
  update_columns?: Array<Organization_User_Permission_Update_Column>;
  where?: InputMaybe<Organization_User_Permission_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_user_permission". */
export type Organization_User_Permission_Order_By = {
  created_at?: InputMaybe<Order_By>;
  disabled?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_user?: InputMaybe<Organization_User_Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
  permission?: InputMaybe<Permission_Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_user_permission */
export type Organization_User_Permission_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organization_user_permission" */
export enum Organization_User_Permission_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrganizationUserId = 'organization_user_id',
  /** column name */
  PermissionId = 'permission_id'
}

/** select "organization_user_permission_aggregate_bool_exp_bool_and_arguments_columns" columns of table "organization_user_permission" */
export enum Organization_User_Permission_Select_Column_Organization_User_Permission_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Disabled = 'disabled',
  /** column name */
  IsActive = 'is_active'
}

/** select "organization_user_permission_aggregate_bool_exp_bool_or_arguments_columns" columns of table "organization_user_permission" */
export enum Organization_User_Permission_Select_Column_Organization_User_Permission_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Disabled = 'disabled',
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "organization_user_permission" */
export type Organization_User_Permission_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  permission_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "organization_user_permission" */
export type Organization_User_Permission_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_User_Permission_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_User_Permission_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  permission_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "organization_user_permission" */
export enum Organization_User_Permission_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrganizationUserId = 'organization_user_id',
  /** column name */
  PermissionId = 'permission_id'
}

export type Organization_User_Permission_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_User_Permission_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_User_Permission_Bool_Exp;
};

/** primary key columns input for table: organization_user */
export type Organization_User_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organization_user" */
export enum Organization_User_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerErpCode = 'customer_erp_code',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsOwner = 'is_owner',
  /** column name */
  IsReceiptRequired = 'is_receipt_required',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  LimitUsed = 'limit_used',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  OrganizationUserType = 'organization_user_type',
  /** column name */
  TotalLimit = 'total_limit',
  /** column name */
  UserId = 'user_id'
}

/** select "organization_user_aggregate_bool_exp_bool_and_arguments_columns" columns of table "organization_user" */
export enum Organization_User_Select_Column_Organization_User_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsOwner = 'is_owner',
  /** column name */
  IsReceiptRequired = 'is_receipt_required'
}

/** select "organization_user_aggregate_bool_exp_bool_or_arguments_columns" columns of table "organization_user" */
export enum Organization_User_Select_Column_Organization_User_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsOwner = 'is_owner',
  /** column name */
  IsReceiptRequired = 'is_receipt_required'
}

/** input type for updating data in table "organization_user" */
export type Organization_User_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_erp_code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_owner?: InputMaybe<Scalars['Boolean']['input']>;
  is_receipt_required?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  limit_used?: InputMaybe<Scalars['numeric']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_user_type?: InputMaybe<Scalars['String']['input']>;
  total_limit?: InputMaybe<Scalars['numeric']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Organization_User_Stddev_Fields = {
  __typename?: 'organization_user_stddev_fields';
  limit_used?: Maybe<Scalars['Float']['output']>;
  total_limit?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "organization_user" */
export type Organization_User_Stddev_Order_By = {
  limit_used?: InputMaybe<Order_By>;
  total_limit?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Organization_User_Stddev_Pop_Fields = {
  __typename?: 'organization_user_stddev_pop_fields';
  limit_used?: Maybe<Scalars['Float']['output']>;
  total_limit?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "organization_user" */
export type Organization_User_Stddev_Pop_Order_By = {
  limit_used?: InputMaybe<Order_By>;
  total_limit?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Organization_User_Stddev_Samp_Fields = {
  __typename?: 'organization_user_stddev_samp_fields';
  limit_used?: Maybe<Scalars['Float']['output']>;
  total_limit?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "organization_user" */
export type Organization_User_Stddev_Samp_Order_By = {
  limit_used?: InputMaybe<Order_By>;
  total_limit?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "organization_user" */
export type Organization_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_User_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_erp_code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_owner?: InputMaybe<Scalars['Boolean']['input']>;
  is_receipt_required?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  limit_used?: InputMaybe<Scalars['numeric']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_user_type?: InputMaybe<Scalars['String']['input']>;
  total_limit?: InputMaybe<Scalars['numeric']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "organization_user_subsidiary" */
export type Organization_User_Subsidiary = {
  __typename?: 'organization_user_subsidiary';
  created_at: Scalars['timestamp']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  last_modified: Scalars['timestamp']['output'];
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  organization_user: Organization_User;
  organization_user_id: Scalars['uuid']['output'];
  /** An object relationship */
  subsidiary: Subsidiary;
  subsidiary_id: Scalars['uuid']['output'];
};

/** aggregated selection of "organization_user_subsidiary" */
export type Organization_User_Subsidiary_Aggregate = {
  __typename?: 'organization_user_subsidiary_aggregate';
  aggregate?: Maybe<Organization_User_Subsidiary_Aggregate_Fields>;
  nodes: Array<Organization_User_Subsidiary>;
};

export type Organization_User_Subsidiary_Aggregate_Bool_Exp = {
  count?: InputMaybe<Organization_User_Subsidiary_Aggregate_Bool_Exp_Count>;
};

export type Organization_User_Subsidiary_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organization_User_Subsidiary_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_User_Subsidiary_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organization_user_subsidiary" */
export type Organization_User_Subsidiary_Aggregate_Fields = {
  __typename?: 'organization_user_subsidiary_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_User_Subsidiary_Max_Fields>;
  min?: Maybe<Organization_User_Subsidiary_Min_Fields>;
};


/** aggregate fields of "organization_user_subsidiary" */
export type Organization_User_Subsidiary_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_User_Subsidiary_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organization_user_subsidiary" */
export type Organization_User_Subsidiary_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_User_Subsidiary_Max_Order_By>;
  min?: InputMaybe<Organization_User_Subsidiary_Min_Order_By>;
};

/** input type for inserting array relation for remote table "organization_user_subsidiary" */
export type Organization_User_Subsidiary_Arr_Rel_Insert_Input = {
  data: Array<Organization_User_Subsidiary_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_User_Subsidiary_On_Conflict>;
};

/** Boolean expression to filter rows from the table "organization_user_subsidiary". All fields are combined with a logical 'AND'. */
export type Organization_User_Subsidiary_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_User_Subsidiary_Bool_Exp>>;
  _not?: InputMaybe<Organization_User_Subsidiary_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_User_Subsidiary_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  organization_user?: InputMaybe<Organization_User_Bool_Exp>;
  organization_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  subsidiary?: InputMaybe<Subsidiary_Bool_Exp>;
  subsidiary_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_user_subsidiary" */
export enum Organization_User_Subsidiary_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrganizationUserSubsidiaryPkey = 'organization_user_subsidiary_pkey'
}

/** input type for inserting data into table "organization_user_subsidiary" */
export type Organization_User_Subsidiary_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_user?: InputMaybe<Organization_User_Obj_Rel_Insert_Input>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  subsidiary?: InputMaybe<Subsidiary_Obj_Rel_Insert_Input>;
  subsidiary_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Organization_User_Subsidiary_Max_Fields = {
  __typename?: 'organization_user_subsidiary_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  organization_user_id?: Maybe<Scalars['uuid']['output']>;
  subsidiary_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "organization_user_subsidiary" */
export type Organization_User_Subsidiary_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
  subsidiary_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organization_User_Subsidiary_Min_Fields = {
  __typename?: 'organization_user_subsidiary_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  organization_user_id?: Maybe<Scalars['uuid']['output']>;
  subsidiary_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "organization_user_subsidiary" */
export type Organization_User_Subsidiary_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
  subsidiary_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization_user_subsidiary" */
export type Organization_User_Subsidiary_Mutation_Response = {
  __typename?: 'organization_user_subsidiary_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_User_Subsidiary>;
};

/** on_conflict condition type for table "organization_user_subsidiary" */
export type Organization_User_Subsidiary_On_Conflict = {
  constraint: Organization_User_Subsidiary_Constraint;
  update_columns?: Array<Organization_User_Subsidiary_Update_Column>;
  where?: InputMaybe<Organization_User_Subsidiary_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_user_subsidiary". */
export type Organization_User_Subsidiary_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_user?: InputMaybe<Organization_User_Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
  subsidiary?: InputMaybe<Subsidiary_Order_By>;
  subsidiary_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_user_subsidiary */
export type Organization_User_Subsidiary_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organization_user_subsidiary" */
export enum Organization_User_Subsidiary_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrganizationUserId = 'organization_user_id',
  /** column name */
  SubsidiaryId = 'subsidiary_id'
}

/** input type for updating data in table "organization_user_subsidiary" */
export type Organization_User_Subsidiary_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  subsidiary_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "organization_user_subsidiary" */
export type Organization_User_Subsidiary_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_User_Subsidiary_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_User_Subsidiary_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  subsidiary_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "organization_user_subsidiary" */
export enum Organization_User_Subsidiary_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrganizationUserId = 'organization_user_id',
  /** column name */
  SubsidiaryId = 'subsidiary_id'
}

export type Organization_User_Subsidiary_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_User_Subsidiary_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_User_Subsidiary_Bool_Exp;
};

/** aggregate sum on columns */
export type Organization_User_Sum_Fields = {
  __typename?: 'organization_user_sum_fields';
  limit_used?: Maybe<Scalars['numeric']['output']>;
  total_limit?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "organization_user" */
export type Organization_User_Sum_Order_By = {
  limit_used?: InputMaybe<Order_By>;
  total_limit?: InputMaybe<Order_By>;
};

/** columns and relationships of "organization_user_type" */
export type Organization_User_Type = {
  __typename?: 'organization_user_type';
  comment: Scalars['String']['output'];
  /** An array relationship */
  invitations: Array<Invitation>;
  /** An aggregate relationship */
  invitations_aggregate: Invitation_Aggregate;
  /** An array relationship */
  organization_users: Array<Organization_User>;
  /** An aggregate relationship */
  organization_users_aggregate: Organization_User_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "organization_user_type" */
export type Organization_User_TypeInvitationsArgs = {
  distinct_on?: InputMaybe<Array<Invitation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invitation_Order_By>>;
  where?: InputMaybe<Invitation_Bool_Exp>;
};


/** columns and relationships of "organization_user_type" */
export type Organization_User_TypeInvitations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invitation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invitation_Order_By>>;
  where?: InputMaybe<Invitation_Bool_Exp>;
};


/** columns and relationships of "organization_user_type" */
export type Organization_User_TypeOrganization_UsersArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Order_By>>;
  where?: InputMaybe<Organization_User_Bool_Exp>;
};


/** columns and relationships of "organization_user_type" */
export type Organization_User_TypeOrganization_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Order_By>>;
  where?: InputMaybe<Organization_User_Bool_Exp>;
};

/** aggregated selection of "organization_user_type" */
export type Organization_User_Type_Aggregate = {
  __typename?: 'organization_user_type_aggregate';
  aggregate?: Maybe<Organization_User_Type_Aggregate_Fields>;
  nodes: Array<Organization_User_Type>;
};

/** aggregate fields of "organization_user_type" */
export type Organization_User_Type_Aggregate_Fields = {
  __typename?: 'organization_user_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_User_Type_Max_Fields>;
  min?: Maybe<Organization_User_Type_Min_Fields>;
};


/** aggregate fields of "organization_user_type" */
export type Organization_User_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_User_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "organization_user_type". All fields are combined with a logical 'AND'. */
export type Organization_User_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_User_Type_Bool_Exp>>;
  _not?: InputMaybe<Organization_User_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_User_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  invitations?: InputMaybe<Invitation_Bool_Exp>;
  invitations_aggregate?: InputMaybe<Invitation_Aggregate_Bool_Exp>;
  organization_users?: InputMaybe<Organization_User_Bool_Exp>;
  organization_users_aggregate?: InputMaybe<Organization_User_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_user_type" */
export enum Organization_User_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  OrganizationUserTypePkey = 'organization_user_type_pkey'
}

/** input type for inserting data into table "organization_user_type" */
export type Organization_User_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  invitations?: InputMaybe<Invitation_Arr_Rel_Insert_Input>;
  organization_users?: InputMaybe<Organization_User_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Organization_User_Type_Max_Fields = {
  __typename?: 'organization_user_type_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Organization_User_Type_Min_Fields = {
  __typename?: 'organization_user_type_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "organization_user_type" */
export type Organization_User_Type_Mutation_Response = {
  __typename?: 'organization_user_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_User_Type>;
};

/** input type for inserting object relation for remote table "organization_user_type" */
export type Organization_User_Type_Obj_Rel_Insert_Input = {
  data: Organization_User_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_User_Type_On_Conflict>;
};

/** on_conflict condition type for table "organization_user_type" */
export type Organization_User_Type_On_Conflict = {
  constraint: Organization_User_Type_Constraint;
  update_columns?: Array<Organization_User_Type_Update_Column>;
  where?: InputMaybe<Organization_User_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_user_type". */
export type Organization_User_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  invitations_aggregate?: InputMaybe<Invitation_Aggregate_Order_By>;
  organization_users_aggregate?: InputMaybe<Organization_User_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_user_type */
export type Organization_User_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "organization_user_type" */
export enum Organization_User_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "organization_user_type" */
export type Organization_User_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "organization_user_type" */
export type Organization_User_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_User_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_User_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "organization_user_type" */
export enum Organization_User_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Organization_User_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_User_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_User_Type_Bool_Exp;
};

/** update columns of table "organization_user" */
export enum Organization_User_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerErpCode = 'customer_erp_code',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsOwner = 'is_owner',
  /** column name */
  IsReceiptRequired = 'is_receipt_required',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  LimitUsed = 'limit_used',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  OrganizationUserType = 'organization_user_type',
  /** column name */
  TotalLimit = 'total_limit',
  /** column name */
  UserId = 'user_id'
}

export type Organization_User_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Organization_User_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_User_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_User_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Organization_User_Var_Pop_Fields = {
  __typename?: 'organization_user_var_pop_fields';
  limit_used?: Maybe<Scalars['Float']['output']>;
  total_limit?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "organization_user" */
export type Organization_User_Var_Pop_Order_By = {
  limit_used?: InputMaybe<Order_By>;
  total_limit?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Organization_User_Var_Samp_Fields = {
  __typename?: 'organization_user_var_samp_fields';
  limit_used?: Maybe<Scalars['Float']['output']>;
  total_limit?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "organization_user" */
export type Organization_User_Var_Samp_Order_By = {
  limit_used?: InputMaybe<Order_By>;
  total_limit?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Organization_User_Variance_Fields = {
  __typename?: 'organization_user_variance_fields';
  limit_used?: Maybe<Scalars['Float']['output']>;
  total_limit?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "organization_user" */
export type Organization_User_Variance_Order_By = {
  limit_used?: InputMaybe<Order_By>;
  total_limit?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Organization_Var_Pop_Fields = {
  __typename?: 'organization_var_pop_fields';
  allowed_credit_limit?: Maybe<Scalars['Float']['output']>;
  customer_code?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "organization" */
export type Organization_Var_Pop_Order_By = {
  allowed_credit_limit?: InputMaybe<Order_By>;
  customer_code?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Organization_Var_Samp_Fields = {
  __typename?: 'organization_var_samp_fields';
  allowed_credit_limit?: Maybe<Scalars['Float']['output']>;
  customer_code?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "organization" */
export type Organization_Var_Samp_Order_By = {
  allowed_credit_limit?: InputMaybe<Order_By>;
  customer_code?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Organization_Variance_Fields = {
  __typename?: 'organization_variance_fields';
  allowed_credit_limit?: Maybe<Scalars['Float']['output']>;
  customer_code?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "organization" */
export type Organization_Variance_Order_By = {
  allowed_credit_limit?: InputMaybe<Order_By>;
  customer_code?: InputMaybe<Order_By>;
};

/** columns and relationships of "ownership_type" */
export type Ownership_Type = {
  __typename?: 'ownership_type';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "ownership_type" */
export type Ownership_Type_Aggregate = {
  __typename?: 'ownership_type_aggregate';
  aggregate?: Maybe<Ownership_Type_Aggregate_Fields>;
  nodes: Array<Ownership_Type>;
};

/** aggregate fields of "ownership_type" */
export type Ownership_Type_Aggregate_Fields = {
  __typename?: 'ownership_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Ownership_Type_Max_Fields>;
  min?: Maybe<Ownership_Type_Min_Fields>;
};


/** aggregate fields of "ownership_type" */
export type Ownership_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ownership_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "ownership_type". All fields are combined with a logical 'AND'. */
export type Ownership_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Ownership_Type_Bool_Exp>>;
  _not?: InputMaybe<Ownership_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Ownership_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ownership_type" */
export enum Ownership_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  OwnershipTypePkey = 'ownership_type_pkey'
}

/** input type for inserting data into table "ownership_type" */
export type Ownership_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Ownership_Type_Max_Fields = {
  __typename?: 'ownership_type_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Ownership_Type_Min_Fields = {
  __typename?: 'ownership_type_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "ownership_type" */
export type Ownership_Type_Mutation_Response = {
  __typename?: 'ownership_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ownership_Type>;
};

/** on_conflict condition type for table "ownership_type" */
export type Ownership_Type_On_Conflict = {
  constraint: Ownership_Type_Constraint;
  update_columns?: Array<Ownership_Type_Update_Column>;
  where?: InputMaybe<Ownership_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "ownership_type". */
export type Ownership_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ownership_type */
export type Ownership_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "ownership_type" */
export enum Ownership_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "ownership_type" */
export type Ownership_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "ownership_type" */
export type Ownership_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ownership_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ownership_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "ownership_type" */
export enum Ownership_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Ownership_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ownership_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ownership_Type_Bool_Exp;
};

/** columns and relationships of "partner" */
export type Partner = {
  __typename?: 'partner';
  about?: Maybe<Scalars['String']['output']>;
  accounts_payable_located?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  associatedTypeByAssociatedType?: Maybe<Associated_Type>;
  associated_type?: Maybe<Associated_Type_Enum>;
  brand?: Maybe<Scalars['String']['output']>;
  brand_logo?: Maybe<Scalars['String']['output']>;
  category: Partner_Type_Enum;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  currency: Currency;
  /** An array relationship */
  customer_order_item_partners: Array<Customer_Order_Item_Partner>;
  /** An aggregate relationship */
  customer_order_item_partners_aggregate: Customer_Order_Item_Partner_Aggregate;
  /** An array relationship */
  customer_order_items: Array<Customer_Order_Item>;
  /** An aggregate relationship */
  customer_order_items_aggregate: Customer_Order_Item_Aggregate;
  dealer_code?: Maybe<Scalars['String']['output']>;
  default_currency: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  invoice_followup_email_address?: Maybe<Scalars['String']['output']>;
  invoice_sending_email_address?: Maybe<Scalars['String']['output']>;
  is_active: Scalars['Boolean']['output'];
  is_fuelbuddy: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  location?: Maybe<Scalars['geography']['output']>;
  /** An array relationship */
  master_slot_pauses: Array<Master_Slot_Pause>;
  /** An aggregate relationship */
  master_slot_pauses_aggregate: Master_Slot_Pause_Aggregate;
  /** An array relationship */
  master_slots: Array<Master_Slot>;
  /** An aggregate relationship */
  master_slots_aggregate: Master_Slot_Aggregate;
  name?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  omcTypeByOmcType?: Maybe<Omc_Type>;
  omc_type?: Maybe<Omc_Type_Enum>;
  /** An array relationship */
  order_schedulers: Array<Order_Scheduler>;
  /** An aggregate relationship */
  order_schedulers_aggregate: Order_Scheduler_Aggregate;
  /** An array relationship */
  partnerRelationshipsByVendorId: Array<Partner_Relationship>;
  /** An aggregate relationship */
  partnerRelationshipsByVendorId_aggregate: Partner_Relationship_Aggregate;
  /** An array relationship */
  partnerSellersBySellerId: Array<Partner_Seller>;
  /** An aggregate relationship */
  partnerSellersBySellerId_aggregate: Partner_Seller_Aggregate;
  /** An object relationship */
  partner_address?: Maybe<Partner_Address>;
  partner_address_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  partner_addresses: Array<Partner_Address>;
  /** An aggregate relationship */
  partner_addresses_aggregate: Partner_Address_Aggregate;
  /** An array relationship */
  partner_bank_details: Array<Partner_Bank_Details>;
  /** An aggregate relationship */
  partner_bank_details_aggregate: Partner_Bank_Details_Aggregate;
  /** An array relationship */
  partner_localities: Array<Partner_Localities>;
  /** An aggregate relationship */
  partner_localities_aggregate: Partner_Localities_Aggregate;
  /** An array relationship */
  partner_order_items: Array<Partner_Order_Item>;
  /** An aggregate relationship */
  partner_order_items_aggregate: Partner_Order_Item_Aggregate;
  /** An array relationship */
  partner_products: Array<Partner_Product>;
  /** An aggregate relationship */
  partner_products_aggregate: Partner_Product_Aggregate;
  /** An array relationship */
  partner_relationships: Array<Partner_Relationship>;
  /** An aggregate relationship */
  partner_relationships_aggregate: Partner_Relationship_Aggregate;
  /** An array relationship */
  partner_sellers: Array<Partner_Seller>;
  /** An aggregate relationship */
  partner_sellers_aggregate: Partner_Seller_Aggregate;
  /** An array relationship */
  partner_signing_authorities: Array<Partner_Signing_Authority>;
  /** An aggregate relationship */
  partner_signing_authorities_aggregate: Partner_Signing_Authority_Aggregate;
  /** An array relationship */
  partner_timings: Array<Partner_Timing>;
  /** An aggregate relationship */
  partner_timings_aggregate: Partner_Timing_Aggregate;
  /** An object relationship */
  partner_type: Partner_Type;
  /** An array relationship */
  partner_users: Array<Partner_User>;
  /** An aggregate relationship */
  partner_users_aggregate: Partner_User_Aggregate;
  /** An array relationship */
  partner_vehicles: Array<Partner_Vehicle>;
  /** An aggregate relationship */
  partner_vehicles_aggregate: Partner_Vehicle_Aggregate;
  /** An array relationship */
  planning_audit_logs: Array<Planning_Audit_Log>;
  /** An aggregate relationship */
  planning_audit_logs_aggregate: Planning_Audit_Log_Aggregate;
  /** An array relationship */
  planning_periods: Array<Planning_Period>;
  /** An aggregate relationship */
  planning_periods_aggregate: Planning_Period_Aggregate;
  popularity?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  shift_schedules: Array<Shift_Schedule>;
  /** An aggregate relationship */
  shift_schedules_aggregate: Shift_Schedule_Aggregate;
  support_contact_number?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  trips: Array<Trip>;
  /** An aggregate relationship */
  trips_aggregate: Trip_Aggregate;
  /** An array relationship */
  vendor_order_logs: Array<Vendor_Order_Logs>;
  /** An aggregate relationship */
  vendor_order_logs_aggregate: Vendor_Order_Logs_Aggregate;
};


/** columns and relationships of "partner" */
export type PartnerCustomer_Order_Item_PartnersArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Partner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Partner_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Partner_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerCustomer_Order_Item_Partners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Partner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Partner_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Partner_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerCustomer_Order_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerCustomer_Order_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerMaster_Slot_PausesArgs = {
  distinct_on?: InputMaybe<Array<Master_Slot_Pause_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Slot_Pause_Order_By>>;
  where?: InputMaybe<Master_Slot_Pause_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerMaster_Slot_Pauses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Master_Slot_Pause_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Slot_Pause_Order_By>>;
  where?: InputMaybe<Master_Slot_Pause_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerMaster_SlotsArgs = {
  distinct_on?: InputMaybe<Array<Master_Slot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Slot_Order_By>>;
  where?: InputMaybe<Master_Slot_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerMaster_Slots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Master_Slot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Slot_Order_By>>;
  where?: InputMaybe<Master_Slot_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerOrder_SchedulersArgs = {
  distinct_on?: InputMaybe<Array<Order_Scheduler_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Scheduler_Order_By>>;
  where?: InputMaybe<Order_Scheduler_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerOrder_Schedulers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Scheduler_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Scheduler_Order_By>>;
  where?: InputMaybe<Order_Scheduler_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerPartnerRelationshipsByVendorIdArgs = {
  distinct_on?: InputMaybe<Array<Partner_Relationship_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Relationship_Order_By>>;
  where?: InputMaybe<Partner_Relationship_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerPartnerRelationshipsByVendorId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Relationship_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Relationship_Order_By>>;
  where?: InputMaybe<Partner_Relationship_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerPartnerSellersBySellerIdArgs = {
  distinct_on?: InputMaybe<Array<Partner_Seller_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Seller_Order_By>>;
  where?: InputMaybe<Partner_Seller_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerPartnerSellersBySellerId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Seller_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Seller_Order_By>>;
  where?: InputMaybe<Partner_Seller_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerPartner_AddressesArgs = {
  distinct_on?: InputMaybe<Array<Partner_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Address_Order_By>>;
  where?: InputMaybe<Partner_Address_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerPartner_Addresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Address_Order_By>>;
  where?: InputMaybe<Partner_Address_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerPartner_Bank_DetailsArgs = {
  distinct_on?: InputMaybe<Array<Partner_Bank_Details_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Bank_Details_Order_By>>;
  where?: InputMaybe<Partner_Bank_Details_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerPartner_Bank_Details_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Bank_Details_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Bank_Details_Order_By>>;
  where?: InputMaybe<Partner_Bank_Details_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerPartner_LocalitiesArgs = {
  distinct_on?: InputMaybe<Array<Partner_Localities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Localities_Order_By>>;
  where?: InputMaybe<Partner_Localities_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerPartner_Localities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Localities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Localities_Order_By>>;
  where?: InputMaybe<Partner_Localities_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerPartner_Order_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerPartner_Order_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerPartner_ProductsArgs = {
  distinct_on?: InputMaybe<Array<Partner_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Product_Order_By>>;
  where?: InputMaybe<Partner_Product_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerPartner_Products_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Product_Order_By>>;
  where?: InputMaybe<Partner_Product_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerPartner_RelationshipsArgs = {
  distinct_on?: InputMaybe<Array<Partner_Relationship_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Relationship_Order_By>>;
  where?: InputMaybe<Partner_Relationship_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerPartner_Relationships_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Relationship_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Relationship_Order_By>>;
  where?: InputMaybe<Partner_Relationship_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerPartner_SellersArgs = {
  distinct_on?: InputMaybe<Array<Partner_Seller_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Seller_Order_By>>;
  where?: InputMaybe<Partner_Seller_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerPartner_Sellers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Seller_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Seller_Order_By>>;
  where?: InputMaybe<Partner_Seller_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerPartner_Signing_AuthoritiesArgs = {
  distinct_on?: InputMaybe<Array<Partner_Signing_Authority_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Signing_Authority_Order_By>>;
  where?: InputMaybe<Partner_Signing_Authority_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerPartner_Signing_Authorities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Signing_Authority_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Signing_Authority_Order_By>>;
  where?: InputMaybe<Partner_Signing_Authority_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerPartner_TimingsArgs = {
  distinct_on?: InputMaybe<Array<Partner_Timing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Timing_Order_By>>;
  where?: InputMaybe<Partner_Timing_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerPartner_Timings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Timing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Timing_Order_By>>;
  where?: InputMaybe<Partner_Timing_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerPartner_UsersArgs = {
  distinct_on?: InputMaybe<Array<Partner_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_User_Order_By>>;
  where?: InputMaybe<Partner_User_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerPartner_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_User_Order_By>>;
  where?: InputMaybe<Partner_User_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerPartner_VehiclesArgs = {
  distinct_on?: InputMaybe<Array<Partner_Vehicle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Vehicle_Order_By>>;
  where?: InputMaybe<Partner_Vehicle_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerPartner_Vehicles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Vehicle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Vehicle_Order_By>>;
  where?: InputMaybe<Partner_Vehicle_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerPlanning_Audit_LogsArgs = {
  distinct_on?: InputMaybe<Array<Planning_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Planning_Audit_Log_Order_By>>;
  where?: InputMaybe<Planning_Audit_Log_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerPlanning_Audit_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Planning_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Planning_Audit_Log_Order_By>>;
  where?: InputMaybe<Planning_Audit_Log_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerPlanning_PeriodsArgs = {
  distinct_on?: InputMaybe<Array<Planning_Period_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Planning_Period_Order_By>>;
  where?: InputMaybe<Planning_Period_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerPlanning_Periods_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Planning_Period_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Planning_Period_Order_By>>;
  where?: InputMaybe<Planning_Period_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerShift_SchedulesArgs = {
  distinct_on?: InputMaybe<Array<Shift_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shift_Schedule_Order_By>>;
  where?: InputMaybe<Shift_Schedule_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerShift_Schedules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shift_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shift_Schedule_Order_By>>;
  where?: InputMaybe<Shift_Schedule_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerTripsArgs = {
  distinct_on?: InputMaybe<Array<Trip_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trip_Order_By>>;
  where?: InputMaybe<Trip_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerTrips_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trip_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trip_Order_By>>;
  where?: InputMaybe<Trip_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerVendor_Order_LogsArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Order_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Order_Logs_Order_By>>;
  where?: InputMaybe<Vendor_Order_Logs_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerVendor_Order_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Order_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Order_Logs_Order_By>>;
  where?: InputMaybe<Vendor_Order_Logs_Bool_Exp>;
};

/** columns and relationships of "partner_address" */
export type Partner_Address = {
  __typename?: 'partner_address';
  /** An object relationship */
  addressTypeByAddressType?: Maybe<Address_Type>;
  address_alias?: Maybe<Scalars['String']['output']>;
  address_line1: Scalars['String']['output'];
  address_line2: Scalars['String']['output'];
  address_type?: Maybe<Address_Type_Enum>;
  city_id?: Maybe<Scalars['String']['output']>;
  code: Scalars['Int']['output'];
  country_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  gst_number?: Maybe<Scalars['String']['output']>;
  house_number: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  instruction?: Maybe<Scalars['String']['output']>;
  is_active: Scalars['Boolean']['output'];
  landMark?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  localities_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  locality?: Maybe<Localities>;
  location?: Maybe<Scalars['point']['output']>;
  name: Scalars['String']['output'];
  ownership?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  partner?: Maybe<Partner>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  partner_orders: Array<Partner_Order>;
  /** An aggregate relationship */
  partner_orders_aggregate: Partner_Order_Aggregate;
  /** An array relationship */
  partners: Array<Partner>;
  /** An aggregate relationship */
  partners_aggregate: Partner_Aggregate;
  pincode?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['String']['output']>;
  street_address: Scalars['String']['output'];
  /** An array relationship */
  tasks: Array<Task>;
  /** An aggregate relationship */
  tasks_aggregate: Task_Aggregate;
  /** An object relationship */
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  vehicles: Array<Vehicle>;
  /** An aggregate relationship */
  vehicles_aggregate: Vehicle_Aggregate;
};


/** columns and relationships of "partner_address" */
export type Partner_AddressPartner_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Order_By>>;
  where?: InputMaybe<Partner_Order_Bool_Exp>;
};


/** columns and relationships of "partner_address" */
export type Partner_AddressPartner_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Order_By>>;
  where?: InputMaybe<Partner_Order_Bool_Exp>;
};


/** columns and relationships of "partner_address" */
export type Partner_AddressPartnersArgs = {
  distinct_on?: InputMaybe<Array<Partner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_By>>;
  where?: InputMaybe<Partner_Bool_Exp>;
};


/** columns and relationships of "partner_address" */
export type Partner_AddressPartners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_By>>;
  where?: InputMaybe<Partner_Bool_Exp>;
};


/** columns and relationships of "partner_address" */
export type Partner_AddressTasksArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


/** columns and relationships of "partner_address" */
export type Partner_AddressTasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


/** columns and relationships of "partner_address" */
export type Partner_AddressVehiclesArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Order_By>>;
  where?: InputMaybe<Vehicle_Bool_Exp>;
};


/** columns and relationships of "partner_address" */
export type Partner_AddressVehicles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Order_By>>;
  where?: InputMaybe<Vehicle_Bool_Exp>;
};

/** aggregated selection of "partner_address" */
export type Partner_Address_Aggregate = {
  __typename?: 'partner_address_aggregate';
  aggregate?: Maybe<Partner_Address_Aggregate_Fields>;
  nodes: Array<Partner_Address>;
};

export type Partner_Address_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Partner_Address_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Partner_Address_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Partner_Address_Aggregate_Bool_Exp_Count>;
};

export type Partner_Address_Aggregate_Bool_Exp_Bool_And = {
  arguments: Partner_Address_Select_Column_Partner_Address_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Address_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_Address_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Partner_Address_Select_Column_Partner_Address_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Address_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_Address_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Partner_Address_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Address_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "partner_address" */
export type Partner_Address_Aggregate_Fields = {
  __typename?: 'partner_address_aggregate_fields';
  avg?: Maybe<Partner_Address_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Partner_Address_Max_Fields>;
  min?: Maybe<Partner_Address_Min_Fields>;
  stddev?: Maybe<Partner_Address_Stddev_Fields>;
  stddev_pop?: Maybe<Partner_Address_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Partner_Address_Stddev_Samp_Fields>;
  sum?: Maybe<Partner_Address_Sum_Fields>;
  var_pop?: Maybe<Partner_Address_Var_Pop_Fields>;
  var_samp?: Maybe<Partner_Address_Var_Samp_Fields>;
  variance?: Maybe<Partner_Address_Variance_Fields>;
};


/** aggregate fields of "partner_address" */
export type Partner_Address_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Partner_Address_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "partner_address" */
export type Partner_Address_Aggregate_Order_By = {
  avg?: InputMaybe<Partner_Address_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Partner_Address_Max_Order_By>;
  min?: InputMaybe<Partner_Address_Min_Order_By>;
  stddev?: InputMaybe<Partner_Address_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Partner_Address_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Partner_Address_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Partner_Address_Sum_Order_By>;
  var_pop?: InputMaybe<Partner_Address_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Partner_Address_Var_Samp_Order_By>;
  variance?: InputMaybe<Partner_Address_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "partner_address" */
export type Partner_Address_Arr_Rel_Insert_Input = {
  data: Array<Partner_Address_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_Address_On_Conflict>;
};

/** aggregate avg on columns */
export type Partner_Address_Avg_Fields = {
  __typename?: 'partner_address_avg_fields';
  code?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "partner_address" */
export type Partner_Address_Avg_Order_By = {
  code?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "partner_address". All fields are combined with a logical 'AND'. */
export type Partner_Address_Bool_Exp = {
  _and?: InputMaybe<Array<Partner_Address_Bool_Exp>>;
  _not?: InputMaybe<Partner_Address_Bool_Exp>;
  _or?: InputMaybe<Array<Partner_Address_Bool_Exp>>;
  addressTypeByAddressType?: InputMaybe<Address_Type_Bool_Exp>;
  address_alias?: InputMaybe<String_Comparison_Exp>;
  address_line1?: InputMaybe<String_Comparison_Exp>;
  address_line2?: InputMaybe<String_Comparison_Exp>;
  address_type?: InputMaybe<Address_Type_Enum_Comparison_Exp>;
  city_id?: InputMaybe<String_Comparison_Exp>;
  code?: InputMaybe<Int_Comparison_Exp>;
  country_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  gst_number?: InputMaybe<String_Comparison_Exp>;
  house_number?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  instruction?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  landMark?: InputMaybe<String_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  localities_id?: InputMaybe<Uuid_Comparison_Exp>;
  locality?: InputMaybe<Localities_Bool_Exp>;
  location?: InputMaybe<Point_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  ownership?: InputMaybe<String_Comparison_Exp>;
  partner?: InputMaybe<Partner_Bool_Exp>;
  partner_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner_orders?: InputMaybe<Partner_Order_Bool_Exp>;
  partner_orders_aggregate?: InputMaybe<Partner_Order_Aggregate_Bool_Exp>;
  partners?: InputMaybe<Partner_Bool_Exp>;
  partners_aggregate?: InputMaybe<Partner_Aggregate_Bool_Exp>;
  pincode?: InputMaybe<String_Comparison_Exp>;
  state_id?: InputMaybe<String_Comparison_Exp>;
  street_address?: InputMaybe<String_Comparison_Exp>;
  tasks?: InputMaybe<Task_Bool_Exp>;
  tasks_aggregate?: InputMaybe<Task_Aggregate_Bool_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  vehicles?: InputMaybe<Vehicle_Bool_Exp>;
  vehicles_aggregate?: InputMaybe<Vehicle_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "partner_address" */
export enum Partner_Address_Constraint {
  /** unique or primary key constraint on columns "code" */
  PartnerAddressCodeKey = 'partner_address_code_key',
  /** unique or primary key constraint on columns "id" */
  PartnerAddressPkey = 'partner_address_pkey'
}

/** input type for incrementing numeric columns in table "partner_address" */
export type Partner_Address_Inc_Input = {
  code?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "partner_address" */
export type Partner_Address_Insert_Input = {
  addressTypeByAddressType?: InputMaybe<Address_Type_Obj_Rel_Insert_Input>;
  address_alias?: InputMaybe<Scalars['String']['input']>;
  address_line1?: InputMaybe<Scalars['String']['input']>;
  address_line2?: InputMaybe<Scalars['String']['input']>;
  address_type?: InputMaybe<Address_Type_Enum>;
  city_id?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['Int']['input']>;
  country_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  gst_number?: InputMaybe<Scalars['String']['input']>;
  house_number?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  instruction?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  landMark?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  localities_id?: InputMaybe<Scalars['uuid']['input']>;
  locality?: InputMaybe<Localities_Obj_Rel_Insert_Input>;
  location?: InputMaybe<Scalars['point']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownership?: InputMaybe<Scalars['String']['input']>;
  partner?: InputMaybe<Partner_Obj_Rel_Insert_Input>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_orders?: InputMaybe<Partner_Order_Arr_Rel_Insert_Input>;
  partners?: InputMaybe<Partner_Arr_Rel_Insert_Input>;
  pincode?: InputMaybe<Scalars['String']['input']>;
  state_id?: InputMaybe<Scalars['String']['input']>;
  street_address?: InputMaybe<Scalars['String']['input']>;
  tasks?: InputMaybe<Task_Arr_Rel_Insert_Input>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  vehicles?: InputMaybe<Vehicle_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Partner_Address_Max_Fields = {
  __typename?: 'partner_address_max_fields';
  address_alias?: Maybe<Scalars['String']['output']>;
  address_line1?: Maybe<Scalars['String']['output']>;
  address_line2?: Maybe<Scalars['String']['output']>;
  city_id?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['Int']['output']>;
  country_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  gst_number?: Maybe<Scalars['String']['output']>;
  house_number?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  instruction?: Maybe<Scalars['String']['output']>;
  landMark?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  localities_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ownership?: Maybe<Scalars['String']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  pincode?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['String']['output']>;
  street_address?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "partner_address" */
export type Partner_Address_Max_Order_By = {
  address_alias?: InputMaybe<Order_By>;
  address_line1?: InputMaybe<Order_By>;
  address_line2?: InputMaybe<Order_By>;
  city_id?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  gst_number?: InputMaybe<Order_By>;
  house_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instruction?: InputMaybe<Order_By>;
  landMark?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  localities_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  ownership?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  pincode?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_address?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Partner_Address_Min_Fields = {
  __typename?: 'partner_address_min_fields';
  address_alias?: Maybe<Scalars['String']['output']>;
  address_line1?: Maybe<Scalars['String']['output']>;
  address_line2?: Maybe<Scalars['String']['output']>;
  city_id?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['Int']['output']>;
  country_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  gst_number?: Maybe<Scalars['String']['output']>;
  house_number?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  instruction?: Maybe<Scalars['String']['output']>;
  landMark?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  localities_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ownership?: Maybe<Scalars['String']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  pincode?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['String']['output']>;
  street_address?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "partner_address" */
export type Partner_Address_Min_Order_By = {
  address_alias?: InputMaybe<Order_By>;
  address_line1?: InputMaybe<Order_By>;
  address_line2?: InputMaybe<Order_By>;
  city_id?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  gst_number?: InputMaybe<Order_By>;
  house_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instruction?: InputMaybe<Order_By>;
  landMark?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  localities_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  ownership?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  pincode?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_address?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "partner_address" */
export type Partner_Address_Mutation_Response = {
  __typename?: 'partner_address_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Partner_Address>;
};

/** input type for inserting object relation for remote table "partner_address" */
export type Partner_Address_Obj_Rel_Insert_Input = {
  data: Partner_Address_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_Address_On_Conflict>;
};

/** on_conflict condition type for table "partner_address" */
export type Partner_Address_On_Conflict = {
  constraint: Partner_Address_Constraint;
  update_columns?: Array<Partner_Address_Update_Column>;
  where?: InputMaybe<Partner_Address_Bool_Exp>;
};

/** Ordering options when selecting data from "partner_address". */
export type Partner_Address_Order_By = {
  addressTypeByAddressType?: InputMaybe<Address_Type_Order_By>;
  address_alias?: InputMaybe<Order_By>;
  address_line1?: InputMaybe<Order_By>;
  address_line2?: InputMaybe<Order_By>;
  address_type?: InputMaybe<Order_By>;
  city_id?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  gst_number?: InputMaybe<Order_By>;
  house_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instruction?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  landMark?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  localities_id?: InputMaybe<Order_By>;
  locality?: InputMaybe<Localities_Order_By>;
  location?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  ownership?: InputMaybe<Order_By>;
  partner?: InputMaybe<Partner_Order_By>;
  partner_id?: InputMaybe<Order_By>;
  partner_orders_aggregate?: InputMaybe<Partner_Order_Aggregate_Order_By>;
  partners_aggregate?: InputMaybe<Partner_Aggregate_Order_By>;
  pincode?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_address?: InputMaybe<Order_By>;
  tasks_aggregate?: InputMaybe<Task_Aggregate_Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
  vehicles_aggregate?: InputMaybe<Vehicle_Aggregate_Order_By>;
};

/** primary key columns input for table: partner_address */
export type Partner_Address_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "partner_address" */
export enum Partner_Address_Select_Column {
  /** column name */
  AddressAlias = 'address_alias',
  /** column name */
  AddressLine1 = 'address_line1',
  /** column name */
  AddressLine2 = 'address_line2',
  /** column name */
  AddressType = 'address_type',
  /** column name */
  CityId = 'city_id',
  /** column name */
  Code = 'code',
  /** column name */
  CountryId = 'country_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GstNumber = 'gst_number',
  /** column name */
  HouseNumber = 'house_number',
  /** column name */
  Id = 'id',
  /** column name */
  Instruction = 'instruction',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LandMark = 'landMark',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  LocalitiesId = 'localities_id',
  /** column name */
  Location = 'location',
  /** column name */
  Name = 'name',
  /** column name */
  Ownership = 'ownership',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  Pincode = 'pincode',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetAddress = 'street_address',
  /** column name */
  UserId = 'user_id'
}

/** select "partner_address_aggregate_bool_exp_bool_and_arguments_columns" columns of table "partner_address" */
export enum Partner_Address_Select_Column_Partner_Address_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "partner_address_aggregate_bool_exp_bool_or_arguments_columns" columns of table "partner_address" */
export enum Partner_Address_Select_Column_Partner_Address_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "partner_address" */
export type Partner_Address_Set_Input = {
  address_alias?: InputMaybe<Scalars['String']['input']>;
  address_line1?: InputMaybe<Scalars['String']['input']>;
  address_line2?: InputMaybe<Scalars['String']['input']>;
  address_type?: InputMaybe<Address_Type_Enum>;
  city_id?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['Int']['input']>;
  country_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  gst_number?: InputMaybe<Scalars['String']['input']>;
  house_number?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  instruction?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  landMark?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  localities_id?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['point']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownership?: InputMaybe<Scalars['String']['input']>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  pincode?: InputMaybe<Scalars['String']['input']>;
  state_id?: InputMaybe<Scalars['String']['input']>;
  street_address?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Partner_Address_Stddev_Fields = {
  __typename?: 'partner_address_stddev_fields';
  code?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "partner_address" */
export type Partner_Address_Stddev_Order_By = {
  code?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Partner_Address_Stddev_Pop_Fields = {
  __typename?: 'partner_address_stddev_pop_fields';
  code?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "partner_address" */
export type Partner_Address_Stddev_Pop_Order_By = {
  code?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Partner_Address_Stddev_Samp_Fields = {
  __typename?: 'partner_address_stddev_samp_fields';
  code?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "partner_address" */
export type Partner_Address_Stddev_Samp_Order_By = {
  code?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "partner_address" */
export type Partner_Address_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Partner_Address_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Partner_Address_Stream_Cursor_Value_Input = {
  address_alias?: InputMaybe<Scalars['String']['input']>;
  address_line1?: InputMaybe<Scalars['String']['input']>;
  address_line2?: InputMaybe<Scalars['String']['input']>;
  address_type?: InputMaybe<Address_Type_Enum>;
  city_id?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['Int']['input']>;
  country_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  gst_number?: InputMaybe<Scalars['String']['input']>;
  house_number?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  instruction?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  landMark?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  localities_id?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['point']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownership?: InputMaybe<Scalars['String']['input']>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  pincode?: InputMaybe<Scalars['String']['input']>;
  state_id?: InputMaybe<Scalars['String']['input']>;
  street_address?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Partner_Address_Sum_Fields = {
  __typename?: 'partner_address_sum_fields';
  code?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "partner_address" */
export type Partner_Address_Sum_Order_By = {
  code?: InputMaybe<Order_By>;
};

/** update columns of table "partner_address" */
export enum Partner_Address_Update_Column {
  /** column name */
  AddressAlias = 'address_alias',
  /** column name */
  AddressLine1 = 'address_line1',
  /** column name */
  AddressLine2 = 'address_line2',
  /** column name */
  AddressType = 'address_type',
  /** column name */
  CityId = 'city_id',
  /** column name */
  Code = 'code',
  /** column name */
  CountryId = 'country_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GstNumber = 'gst_number',
  /** column name */
  HouseNumber = 'house_number',
  /** column name */
  Id = 'id',
  /** column name */
  Instruction = 'instruction',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LandMark = 'landMark',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  LocalitiesId = 'localities_id',
  /** column name */
  Location = 'location',
  /** column name */
  Name = 'name',
  /** column name */
  Ownership = 'ownership',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  Pincode = 'pincode',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetAddress = 'street_address',
  /** column name */
  UserId = 'user_id'
}

export type Partner_Address_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Partner_Address_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Partner_Address_Set_Input>;
  /** filter the rows which have to be updated */
  where: Partner_Address_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Partner_Address_Var_Pop_Fields = {
  __typename?: 'partner_address_var_pop_fields';
  code?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "partner_address" */
export type Partner_Address_Var_Pop_Order_By = {
  code?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Partner_Address_Var_Samp_Fields = {
  __typename?: 'partner_address_var_samp_fields';
  code?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "partner_address" */
export type Partner_Address_Var_Samp_Order_By = {
  code?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Partner_Address_Variance_Fields = {
  __typename?: 'partner_address_variance_fields';
  code?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "partner_address" */
export type Partner_Address_Variance_Order_By = {
  code?: InputMaybe<Order_By>;
};

/** aggregated selection of "partner" */
export type Partner_Aggregate = {
  __typename?: 'partner_aggregate';
  aggregate?: Maybe<Partner_Aggregate_Fields>;
  nodes: Array<Partner>;
};

export type Partner_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Partner_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Partner_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Partner_Aggregate_Bool_Exp_Count>;
};

export type Partner_Aggregate_Bool_Exp_Bool_And = {
  arguments: Partner_Select_Column_Partner_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Partner_Select_Column_Partner_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Partner_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "partner" */
export type Partner_Aggregate_Fields = {
  __typename?: 'partner_aggregate_fields';
  avg?: Maybe<Partner_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Partner_Max_Fields>;
  min?: Maybe<Partner_Min_Fields>;
  stddev?: Maybe<Partner_Stddev_Fields>;
  stddev_pop?: Maybe<Partner_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Partner_Stddev_Samp_Fields>;
  sum?: Maybe<Partner_Sum_Fields>;
  var_pop?: Maybe<Partner_Var_Pop_Fields>;
  var_samp?: Maybe<Partner_Var_Samp_Fields>;
  variance?: Maybe<Partner_Variance_Fields>;
};


/** aggregate fields of "partner" */
export type Partner_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Partner_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "partner" */
export type Partner_Aggregate_Order_By = {
  avg?: InputMaybe<Partner_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Partner_Max_Order_By>;
  min?: InputMaybe<Partner_Min_Order_By>;
  stddev?: InputMaybe<Partner_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Partner_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Partner_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Partner_Sum_Order_By>;
  var_pop?: InputMaybe<Partner_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Partner_Var_Samp_Order_By>;
  variance?: InputMaybe<Partner_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "partner" */
export type Partner_Arr_Rel_Insert_Input = {
  data: Array<Partner_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_On_Conflict>;
};

/** aggregate avg on columns */
export type Partner_Avg_Fields = {
  __typename?: 'partner_avg_fields';
  popularity?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "partner" */
export type Partner_Avg_Order_By = {
  popularity?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
};

/** columns and relationships of "partner_bank_details" */
export type Partner_Bank_Details = {
  __typename?: 'partner_bank_details';
  bank_account_name?: Maybe<Scalars['String']['output']>;
  bank_account_number?: Maybe<Scalars['String']['output']>;
  bank_address?: Maybe<Scalars['String']['output']>;
  bank_code?: Maybe<Scalars['String']['output']>;
  bank_name?: Maybe<Scalars['String']['output']>;
  bic_swift?: Maybe<Scalars['String']['output']>;
  cancelled_cheque_scan_copy_url?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  ifsc_code?: Maybe<Scalars['String']['output']>;
  is_active: Scalars['Boolean']['output'];
  is_default: Scalars['Boolean']['output'];
  key?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  partner: Partner;
  partner_id: Scalars['uuid']['output'];
  sort_code?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "partner_bank_details" */
export type Partner_Bank_Details_Aggregate = {
  __typename?: 'partner_bank_details_aggregate';
  aggregate?: Maybe<Partner_Bank_Details_Aggregate_Fields>;
  nodes: Array<Partner_Bank_Details>;
};

export type Partner_Bank_Details_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Partner_Bank_Details_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Partner_Bank_Details_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Partner_Bank_Details_Aggregate_Bool_Exp_Count>;
};

export type Partner_Bank_Details_Aggregate_Bool_Exp_Bool_And = {
  arguments: Partner_Bank_Details_Select_Column_Partner_Bank_Details_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Bank_Details_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_Bank_Details_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Partner_Bank_Details_Select_Column_Partner_Bank_Details_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Bank_Details_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_Bank_Details_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Partner_Bank_Details_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Bank_Details_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "partner_bank_details" */
export type Partner_Bank_Details_Aggregate_Fields = {
  __typename?: 'partner_bank_details_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Partner_Bank_Details_Max_Fields>;
  min?: Maybe<Partner_Bank_Details_Min_Fields>;
};


/** aggregate fields of "partner_bank_details" */
export type Partner_Bank_Details_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Partner_Bank_Details_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "partner_bank_details" */
export type Partner_Bank_Details_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Partner_Bank_Details_Max_Order_By>;
  min?: InputMaybe<Partner_Bank_Details_Min_Order_By>;
};

/** input type for inserting array relation for remote table "partner_bank_details" */
export type Partner_Bank_Details_Arr_Rel_Insert_Input = {
  data: Array<Partner_Bank_Details_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_Bank_Details_On_Conflict>;
};

/** Boolean expression to filter rows from the table "partner_bank_details". All fields are combined with a logical 'AND'. */
export type Partner_Bank_Details_Bool_Exp = {
  _and?: InputMaybe<Array<Partner_Bank_Details_Bool_Exp>>;
  _not?: InputMaybe<Partner_Bank_Details_Bool_Exp>;
  _or?: InputMaybe<Array<Partner_Bank_Details_Bool_Exp>>;
  bank_account_name?: InputMaybe<String_Comparison_Exp>;
  bank_account_number?: InputMaybe<String_Comparison_Exp>;
  bank_address?: InputMaybe<String_Comparison_Exp>;
  bank_code?: InputMaybe<String_Comparison_Exp>;
  bank_name?: InputMaybe<String_Comparison_Exp>;
  bic_swift?: InputMaybe<String_Comparison_Exp>;
  cancelled_cheque_scan_copy_url?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  iban?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ifsc_code?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_default?: InputMaybe<Boolean_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  partner?: InputMaybe<Partner_Bool_Exp>;
  partner_id?: InputMaybe<Uuid_Comparison_Exp>;
  sort_code?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "partner_bank_details" */
export enum Partner_Bank_Details_Constraint {
  /** unique or primary key constraint on columns "id" */
  PartnerBankDetailsPkey = 'partner_bank_details_pkey'
}

/** input type for inserting data into table "partner_bank_details" */
export type Partner_Bank_Details_Insert_Input = {
  bank_account_name?: InputMaybe<Scalars['String']['input']>;
  bank_account_number?: InputMaybe<Scalars['String']['input']>;
  bank_address?: InputMaybe<Scalars['String']['input']>;
  bank_code?: InputMaybe<Scalars['String']['input']>;
  bank_name?: InputMaybe<Scalars['String']['input']>;
  bic_swift?: InputMaybe<Scalars['String']['input']>;
  cancelled_cheque_scan_copy_url?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ifsc_code?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner?: InputMaybe<Partner_Obj_Rel_Insert_Input>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  sort_code?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Partner_Bank_Details_Max_Fields = {
  __typename?: 'partner_bank_details_max_fields';
  bank_account_name?: Maybe<Scalars['String']['output']>;
  bank_account_number?: Maybe<Scalars['String']['output']>;
  bank_address?: Maybe<Scalars['String']['output']>;
  bank_code?: Maybe<Scalars['String']['output']>;
  bank_name?: Maybe<Scalars['String']['output']>;
  bic_swift?: Maybe<Scalars['String']['output']>;
  cancelled_cheque_scan_copy_url?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ifsc_code?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  sort_code?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "partner_bank_details" */
export type Partner_Bank_Details_Max_Order_By = {
  bank_account_name?: InputMaybe<Order_By>;
  bank_account_number?: InputMaybe<Order_By>;
  bank_address?: InputMaybe<Order_By>;
  bank_code?: InputMaybe<Order_By>;
  bank_name?: InputMaybe<Order_By>;
  bic_swift?: InputMaybe<Order_By>;
  cancelled_cheque_scan_copy_url?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  iban?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ifsc_code?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  sort_code?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Partner_Bank_Details_Min_Fields = {
  __typename?: 'partner_bank_details_min_fields';
  bank_account_name?: Maybe<Scalars['String']['output']>;
  bank_account_number?: Maybe<Scalars['String']['output']>;
  bank_address?: Maybe<Scalars['String']['output']>;
  bank_code?: Maybe<Scalars['String']['output']>;
  bank_name?: Maybe<Scalars['String']['output']>;
  bic_swift?: Maybe<Scalars['String']['output']>;
  cancelled_cheque_scan_copy_url?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ifsc_code?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  sort_code?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "partner_bank_details" */
export type Partner_Bank_Details_Min_Order_By = {
  bank_account_name?: InputMaybe<Order_By>;
  bank_account_number?: InputMaybe<Order_By>;
  bank_address?: InputMaybe<Order_By>;
  bank_code?: InputMaybe<Order_By>;
  bank_name?: InputMaybe<Order_By>;
  bic_swift?: InputMaybe<Order_By>;
  cancelled_cheque_scan_copy_url?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  iban?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ifsc_code?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  sort_code?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "partner_bank_details" */
export type Partner_Bank_Details_Mutation_Response = {
  __typename?: 'partner_bank_details_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Partner_Bank_Details>;
};

/** on_conflict condition type for table "partner_bank_details" */
export type Partner_Bank_Details_On_Conflict = {
  constraint: Partner_Bank_Details_Constraint;
  update_columns?: Array<Partner_Bank_Details_Update_Column>;
  where?: InputMaybe<Partner_Bank_Details_Bool_Exp>;
};

/** Ordering options when selecting data from "partner_bank_details". */
export type Partner_Bank_Details_Order_By = {
  bank_account_name?: InputMaybe<Order_By>;
  bank_account_number?: InputMaybe<Order_By>;
  bank_address?: InputMaybe<Order_By>;
  bank_code?: InputMaybe<Order_By>;
  bank_name?: InputMaybe<Order_By>;
  bic_swift?: InputMaybe<Order_By>;
  cancelled_cheque_scan_copy_url?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  iban?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ifsc_code?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_default?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner?: InputMaybe<Partner_Order_By>;
  partner_id?: InputMaybe<Order_By>;
  sort_code?: InputMaybe<Order_By>;
};

/** primary key columns input for table: partner_bank_details */
export type Partner_Bank_Details_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "partner_bank_details" */
export enum Partner_Bank_Details_Select_Column {
  /** column name */
  BankAccountName = 'bank_account_name',
  /** column name */
  BankAccountNumber = 'bank_account_number',
  /** column name */
  BankAddress = 'bank_address',
  /** column name */
  BankCode = 'bank_code',
  /** column name */
  BankName = 'bank_name',
  /** column name */
  BicSwift = 'bic_swift',
  /** column name */
  CancelledChequeScanCopyUrl = 'cancelled_cheque_scan_copy_url',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Iban = 'iban',
  /** column name */
  Id = 'id',
  /** column name */
  IfscCode = 'ifsc_code',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  Key = 'key',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  SortCode = 'sort_code'
}

/** select "partner_bank_details_aggregate_bool_exp_bool_and_arguments_columns" columns of table "partner_bank_details" */
export enum Partner_Bank_Details_Select_Column_Partner_Bank_Details_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsDefault = 'is_default'
}

/** select "partner_bank_details_aggregate_bool_exp_bool_or_arguments_columns" columns of table "partner_bank_details" */
export enum Partner_Bank_Details_Select_Column_Partner_Bank_Details_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsDefault = 'is_default'
}

/** input type for updating data in table "partner_bank_details" */
export type Partner_Bank_Details_Set_Input = {
  bank_account_name?: InputMaybe<Scalars['String']['input']>;
  bank_account_number?: InputMaybe<Scalars['String']['input']>;
  bank_address?: InputMaybe<Scalars['String']['input']>;
  bank_code?: InputMaybe<Scalars['String']['input']>;
  bank_name?: InputMaybe<Scalars['String']['input']>;
  bic_swift?: InputMaybe<Scalars['String']['input']>;
  cancelled_cheque_scan_copy_url?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ifsc_code?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  sort_code?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "partner_bank_details" */
export type Partner_Bank_Details_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Partner_Bank_Details_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Partner_Bank_Details_Stream_Cursor_Value_Input = {
  bank_account_name?: InputMaybe<Scalars['String']['input']>;
  bank_account_number?: InputMaybe<Scalars['String']['input']>;
  bank_address?: InputMaybe<Scalars['String']['input']>;
  bank_code?: InputMaybe<Scalars['String']['input']>;
  bank_name?: InputMaybe<Scalars['String']['input']>;
  bic_swift?: InputMaybe<Scalars['String']['input']>;
  cancelled_cheque_scan_copy_url?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ifsc_code?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  sort_code?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "partner_bank_details" */
export enum Partner_Bank_Details_Update_Column {
  /** column name */
  BankAccountName = 'bank_account_name',
  /** column name */
  BankAccountNumber = 'bank_account_number',
  /** column name */
  BankAddress = 'bank_address',
  /** column name */
  BankCode = 'bank_code',
  /** column name */
  BankName = 'bank_name',
  /** column name */
  BicSwift = 'bic_swift',
  /** column name */
  CancelledChequeScanCopyUrl = 'cancelled_cheque_scan_copy_url',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Iban = 'iban',
  /** column name */
  Id = 'id',
  /** column name */
  IfscCode = 'ifsc_code',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  Key = 'key',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  SortCode = 'sort_code'
}

export type Partner_Bank_Details_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Partner_Bank_Details_Set_Input>;
  /** filter the rows which have to be updated */
  where: Partner_Bank_Details_Bool_Exp;
};

/** Boolean expression to filter rows from the table "partner". All fields are combined with a logical 'AND'. */
export type Partner_Bool_Exp = {
  _and?: InputMaybe<Array<Partner_Bool_Exp>>;
  _not?: InputMaybe<Partner_Bool_Exp>;
  _or?: InputMaybe<Array<Partner_Bool_Exp>>;
  about?: InputMaybe<String_Comparison_Exp>;
  accounts_payable_located?: InputMaybe<String_Comparison_Exp>;
  associatedTypeByAssociatedType?: InputMaybe<Associated_Type_Bool_Exp>;
  associated_type?: InputMaybe<Associated_Type_Enum_Comparison_Exp>;
  brand?: InputMaybe<String_Comparison_Exp>;
  brand_logo?: InputMaybe<String_Comparison_Exp>;
  category?: InputMaybe<Partner_Type_Enum_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  currency?: InputMaybe<Currency_Bool_Exp>;
  customer_order_item_partners?: InputMaybe<Customer_Order_Item_Partner_Bool_Exp>;
  customer_order_item_partners_aggregate?: InputMaybe<Customer_Order_Item_Partner_Aggregate_Bool_Exp>;
  customer_order_items?: InputMaybe<Customer_Order_Item_Bool_Exp>;
  customer_order_items_aggregate?: InputMaybe<Customer_Order_Item_Aggregate_Bool_Exp>;
  dealer_code?: InputMaybe<String_Comparison_Exp>;
  default_currency?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invoice_followup_email_address?: InputMaybe<String_Comparison_Exp>;
  invoice_sending_email_address?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_fuelbuddy?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<Geography_Comparison_Exp>;
  master_slot_pauses?: InputMaybe<Master_Slot_Pause_Bool_Exp>;
  master_slot_pauses_aggregate?: InputMaybe<Master_Slot_Pause_Aggregate_Bool_Exp>;
  master_slots?: InputMaybe<Master_Slot_Bool_Exp>;
  master_slots_aggregate?: InputMaybe<Master_Slot_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  omcTypeByOmcType?: InputMaybe<Omc_Type_Bool_Exp>;
  omc_type?: InputMaybe<Omc_Type_Enum_Comparison_Exp>;
  order_schedulers?: InputMaybe<Order_Scheduler_Bool_Exp>;
  order_schedulers_aggregate?: InputMaybe<Order_Scheduler_Aggregate_Bool_Exp>;
  partnerRelationshipsByVendorId?: InputMaybe<Partner_Relationship_Bool_Exp>;
  partnerRelationshipsByVendorId_aggregate?: InputMaybe<Partner_Relationship_Aggregate_Bool_Exp>;
  partnerSellersBySellerId?: InputMaybe<Partner_Seller_Bool_Exp>;
  partnerSellersBySellerId_aggregate?: InputMaybe<Partner_Seller_Aggregate_Bool_Exp>;
  partner_address?: InputMaybe<Partner_Address_Bool_Exp>;
  partner_address_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner_addresses?: InputMaybe<Partner_Address_Bool_Exp>;
  partner_addresses_aggregate?: InputMaybe<Partner_Address_Aggregate_Bool_Exp>;
  partner_bank_details?: InputMaybe<Partner_Bank_Details_Bool_Exp>;
  partner_bank_details_aggregate?: InputMaybe<Partner_Bank_Details_Aggregate_Bool_Exp>;
  partner_localities?: InputMaybe<Partner_Localities_Bool_Exp>;
  partner_localities_aggregate?: InputMaybe<Partner_Localities_Aggregate_Bool_Exp>;
  partner_order_items?: InputMaybe<Partner_Order_Item_Bool_Exp>;
  partner_order_items_aggregate?: InputMaybe<Partner_Order_Item_Aggregate_Bool_Exp>;
  partner_products?: InputMaybe<Partner_Product_Bool_Exp>;
  partner_products_aggregate?: InputMaybe<Partner_Product_Aggregate_Bool_Exp>;
  partner_relationships?: InputMaybe<Partner_Relationship_Bool_Exp>;
  partner_relationships_aggregate?: InputMaybe<Partner_Relationship_Aggregate_Bool_Exp>;
  partner_sellers?: InputMaybe<Partner_Seller_Bool_Exp>;
  partner_sellers_aggregate?: InputMaybe<Partner_Seller_Aggregate_Bool_Exp>;
  partner_signing_authorities?: InputMaybe<Partner_Signing_Authority_Bool_Exp>;
  partner_signing_authorities_aggregate?: InputMaybe<Partner_Signing_Authority_Aggregate_Bool_Exp>;
  partner_timings?: InputMaybe<Partner_Timing_Bool_Exp>;
  partner_timings_aggregate?: InputMaybe<Partner_Timing_Aggregate_Bool_Exp>;
  partner_type?: InputMaybe<Partner_Type_Bool_Exp>;
  partner_users?: InputMaybe<Partner_User_Bool_Exp>;
  partner_users_aggregate?: InputMaybe<Partner_User_Aggregate_Bool_Exp>;
  partner_vehicles?: InputMaybe<Partner_Vehicle_Bool_Exp>;
  partner_vehicles_aggregate?: InputMaybe<Partner_Vehicle_Aggregate_Bool_Exp>;
  planning_audit_logs?: InputMaybe<Planning_Audit_Log_Bool_Exp>;
  planning_audit_logs_aggregate?: InputMaybe<Planning_Audit_Log_Aggregate_Bool_Exp>;
  planning_periods?: InputMaybe<Planning_Period_Bool_Exp>;
  planning_periods_aggregate?: InputMaybe<Planning_Period_Aggregate_Bool_Exp>;
  popularity?: InputMaybe<Int_Comparison_Exp>;
  rating?: InputMaybe<Int_Comparison_Exp>;
  shift_schedules?: InputMaybe<Shift_Schedule_Bool_Exp>;
  shift_schedules_aggregate?: InputMaybe<Shift_Schedule_Aggregate_Bool_Exp>;
  support_contact_number?: InputMaybe<String_Comparison_Exp>;
  trips?: InputMaybe<Trip_Bool_Exp>;
  trips_aggregate?: InputMaybe<Trip_Aggregate_Bool_Exp>;
  vendor_order_logs?: InputMaybe<Vendor_Order_Logs_Bool_Exp>;
  vendor_order_logs_aggregate?: InputMaybe<Vendor_Order_Logs_Aggregate_Bool_Exp>;
};

/** columns and relationships of "partner_commission" */
export type Partner_Commission = {
  __typename?: 'partner_commission';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  partner_commission_product_variation_type: Partner_Commission_Product_Variation_Type;
  partner_commission_product_variation_type_id: Scalars['uuid']['output'];
  /** An object relationship */
  user: User;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "partner_commission" */
export type Partner_Commission_Aggregate = {
  __typename?: 'partner_commission_aggregate';
  aggregate?: Maybe<Partner_Commission_Aggregate_Fields>;
  nodes: Array<Partner_Commission>;
};

export type Partner_Commission_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Partner_Commission_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Partner_Commission_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Partner_Commission_Aggregate_Bool_Exp_Count>;
};

export type Partner_Commission_Aggregate_Bool_Exp_Bool_And = {
  arguments: Partner_Commission_Select_Column_Partner_Commission_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Commission_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_Commission_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Partner_Commission_Select_Column_Partner_Commission_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Commission_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_Commission_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Partner_Commission_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Commission_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "partner_commission" */
export type Partner_Commission_Aggregate_Fields = {
  __typename?: 'partner_commission_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Partner_Commission_Max_Fields>;
  min?: Maybe<Partner_Commission_Min_Fields>;
};


/** aggregate fields of "partner_commission" */
export type Partner_Commission_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Partner_Commission_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "partner_commission" */
export type Partner_Commission_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Partner_Commission_Max_Order_By>;
  min?: InputMaybe<Partner_Commission_Min_Order_By>;
};

/** input type for inserting array relation for remote table "partner_commission" */
export type Partner_Commission_Arr_Rel_Insert_Input = {
  data: Array<Partner_Commission_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_Commission_On_Conflict>;
};

/** Boolean expression to filter rows from the table "partner_commission". All fields are combined with a logical 'AND'. */
export type Partner_Commission_Bool_Exp = {
  _and?: InputMaybe<Array<Partner_Commission_Bool_Exp>>;
  _not?: InputMaybe<Partner_Commission_Bool_Exp>;
  _or?: InputMaybe<Array<Partner_Commission_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  partner_commission_product_variation_type?: InputMaybe<Partner_Commission_Product_Variation_Type_Bool_Exp>;
  partner_commission_product_variation_type_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "partner_commission" */
export enum Partner_Commission_Constraint {
  /** unique or primary key constraint on columns "id" */
  PartnerCommissionPkey = 'partner_commission_pkey'
}

/** input type for inserting data into table "partner_commission" */
export type Partner_Commission_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_commission_product_variation_type?: InputMaybe<Partner_Commission_Product_Variation_Type_Obj_Rel_Insert_Input>;
  partner_commission_product_variation_type_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Partner_Commission_Max_Fields = {
  __typename?: 'partner_commission_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_commission_product_variation_type_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "partner_commission" */
export type Partner_Commission_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_commission_product_variation_type_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Partner_Commission_Min_Fields = {
  __typename?: 'partner_commission_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_commission_product_variation_type_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "partner_commission" */
export type Partner_Commission_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_commission_product_variation_type_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "partner_commission" */
export type Partner_Commission_Mutation_Response = {
  __typename?: 'partner_commission_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Partner_Commission>;
};

/** on_conflict condition type for table "partner_commission" */
export type Partner_Commission_On_Conflict = {
  constraint: Partner_Commission_Constraint;
  update_columns?: Array<Partner_Commission_Update_Column>;
  where?: InputMaybe<Partner_Commission_Bool_Exp>;
};

/** Ordering options when selecting data from "partner_commission". */
export type Partner_Commission_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_commission_product_variation_type?: InputMaybe<Partner_Commission_Product_Variation_Type_Order_By>;
  partner_commission_product_variation_type_id?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: partner_commission */
export type Partner_Commission_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "partner_commission_product_variation_type" */
export type Partner_Commission_Product_Variation_Type = {
  __typename?: 'partner_commission_product_variation_type';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  partner_commissions: Array<Partner_Commission>;
  /** An aggregate relationship */
  partner_commissions_aggregate: Partner_Commission_Aggregate;
  /** An array relationship */
  partner_order_item_commissions: Array<Partner_Order_Item_Commission>;
  /** An aggregate relationship */
  partner_order_item_commissions_aggregate: Partner_Order_Item_Commission_Aggregate;
  /** An object relationship */
  partner_user: Partner_User;
  partner_user_id: Scalars['uuid']['output'];
  /** An object relationship */
  product: Product;
  product_id: Scalars['uuid']['output'];
  /** An object relationship */
  product_variation: Product_Variation;
  product_variation_id: Scalars['uuid']['output'];
  /** An object relationship */
  script: Scripts;
  scripts_id: Scalars['uuid']['output'];
};


/** columns and relationships of "partner_commission_product_variation_type" */
export type Partner_Commission_Product_Variation_TypePartner_CommissionsArgs = {
  distinct_on?: InputMaybe<Array<Partner_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Commission_Order_By>>;
  where?: InputMaybe<Partner_Commission_Bool_Exp>;
};


/** columns and relationships of "partner_commission_product_variation_type" */
export type Partner_Commission_Product_Variation_TypePartner_Commissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Commission_Order_By>>;
  where?: InputMaybe<Partner_Commission_Bool_Exp>;
};


/** columns and relationships of "partner_commission_product_variation_type" */
export type Partner_Commission_Product_Variation_TypePartner_Order_Item_CommissionsArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Commission_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Commission_Bool_Exp>;
};


/** columns and relationships of "partner_commission_product_variation_type" */
export type Partner_Commission_Product_Variation_TypePartner_Order_Item_Commissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Commission_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Commission_Bool_Exp>;
};

/** aggregated selection of "partner_commission_product_variation_type" */
export type Partner_Commission_Product_Variation_Type_Aggregate = {
  __typename?: 'partner_commission_product_variation_type_aggregate';
  aggregate?: Maybe<Partner_Commission_Product_Variation_Type_Aggregate_Fields>;
  nodes: Array<Partner_Commission_Product_Variation_Type>;
};

export type Partner_Commission_Product_Variation_Type_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Partner_Commission_Product_Variation_Type_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Partner_Commission_Product_Variation_Type_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Partner_Commission_Product_Variation_Type_Aggregate_Bool_Exp_Count>;
};

export type Partner_Commission_Product_Variation_Type_Aggregate_Bool_Exp_Bool_And = {
  arguments: Partner_Commission_Product_Variation_Type_Select_Column_Partner_Commission_Product_Variation_Type_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Commission_Product_Variation_Type_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_Commission_Product_Variation_Type_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Partner_Commission_Product_Variation_Type_Select_Column_Partner_Commission_Product_Variation_Type_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Commission_Product_Variation_Type_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_Commission_Product_Variation_Type_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Partner_Commission_Product_Variation_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Commission_Product_Variation_Type_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "partner_commission_product_variation_type" */
export type Partner_Commission_Product_Variation_Type_Aggregate_Fields = {
  __typename?: 'partner_commission_product_variation_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Partner_Commission_Product_Variation_Type_Max_Fields>;
  min?: Maybe<Partner_Commission_Product_Variation_Type_Min_Fields>;
};


/** aggregate fields of "partner_commission_product_variation_type" */
export type Partner_Commission_Product_Variation_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Partner_Commission_Product_Variation_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "partner_commission_product_variation_type" */
export type Partner_Commission_Product_Variation_Type_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Partner_Commission_Product_Variation_Type_Max_Order_By>;
  min?: InputMaybe<Partner_Commission_Product_Variation_Type_Min_Order_By>;
};

/** input type for inserting array relation for remote table "partner_commission_product_variation_type" */
export type Partner_Commission_Product_Variation_Type_Arr_Rel_Insert_Input = {
  data: Array<Partner_Commission_Product_Variation_Type_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_Commission_Product_Variation_Type_On_Conflict>;
};

/** Boolean expression to filter rows from the table "partner_commission_product_variation_type". All fields are combined with a logical 'AND'. */
export type Partner_Commission_Product_Variation_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Partner_Commission_Product_Variation_Type_Bool_Exp>>;
  _not?: InputMaybe<Partner_Commission_Product_Variation_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Partner_Commission_Product_Variation_Type_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  partner_commissions?: InputMaybe<Partner_Commission_Bool_Exp>;
  partner_commissions_aggregate?: InputMaybe<Partner_Commission_Aggregate_Bool_Exp>;
  partner_order_item_commissions?: InputMaybe<Partner_Order_Item_Commission_Bool_Exp>;
  partner_order_item_commissions_aggregate?: InputMaybe<Partner_Order_Item_Commission_Aggregate_Bool_Exp>;
  partner_user?: InputMaybe<Partner_User_Bool_Exp>;
  partner_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  product_id?: InputMaybe<Uuid_Comparison_Exp>;
  product_variation?: InputMaybe<Product_Variation_Bool_Exp>;
  product_variation_id?: InputMaybe<Uuid_Comparison_Exp>;
  script?: InputMaybe<Scripts_Bool_Exp>;
  scripts_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "partner_commission_product_variation_type" */
export enum Partner_Commission_Product_Variation_Type_Constraint {
  /** unique or primary key constraint on columns "id" */
  PartnerCommissionProductVariationTypePkey = 'partner_commission_product_variation_type_pkey'
}

/** input type for inserting data into table "partner_commission_product_variation_type" */
export type Partner_Commission_Product_Variation_Type_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_commissions?: InputMaybe<Partner_Commission_Arr_Rel_Insert_Input>;
  partner_order_item_commissions?: InputMaybe<Partner_Order_Item_Commission_Arr_Rel_Insert_Input>;
  partner_user?: InputMaybe<Partner_User_Obj_Rel_Insert_Input>;
  partner_user_id?: InputMaybe<Scalars['uuid']['input']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
  product_variation?: InputMaybe<Product_Variation_Obj_Rel_Insert_Input>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  script?: InputMaybe<Scripts_Obj_Rel_Insert_Input>;
  scripts_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Partner_Commission_Product_Variation_Type_Max_Fields = {
  __typename?: 'partner_commission_product_variation_type_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_user_id?: Maybe<Scalars['uuid']['output']>;
  product_id?: Maybe<Scalars['uuid']['output']>;
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
  scripts_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "partner_commission_product_variation_type" */
export type Partner_Commission_Product_Variation_Type_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_user_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  scripts_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Partner_Commission_Product_Variation_Type_Min_Fields = {
  __typename?: 'partner_commission_product_variation_type_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_user_id?: Maybe<Scalars['uuid']['output']>;
  product_id?: Maybe<Scalars['uuid']['output']>;
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
  scripts_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "partner_commission_product_variation_type" */
export type Partner_Commission_Product_Variation_Type_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_user_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  scripts_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "partner_commission_product_variation_type" */
export type Partner_Commission_Product_Variation_Type_Mutation_Response = {
  __typename?: 'partner_commission_product_variation_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Partner_Commission_Product_Variation_Type>;
};

/** input type for inserting object relation for remote table "partner_commission_product_variation_type" */
export type Partner_Commission_Product_Variation_Type_Obj_Rel_Insert_Input = {
  data: Partner_Commission_Product_Variation_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_Commission_Product_Variation_Type_On_Conflict>;
};

/** on_conflict condition type for table "partner_commission_product_variation_type" */
export type Partner_Commission_Product_Variation_Type_On_Conflict = {
  constraint: Partner_Commission_Product_Variation_Type_Constraint;
  update_columns?: Array<Partner_Commission_Product_Variation_Type_Update_Column>;
  where?: InputMaybe<Partner_Commission_Product_Variation_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "partner_commission_product_variation_type". */
export type Partner_Commission_Product_Variation_Type_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_commissions_aggregate?: InputMaybe<Partner_Commission_Aggregate_Order_By>;
  partner_order_item_commissions_aggregate?: InputMaybe<Partner_Order_Item_Commission_Aggregate_Order_By>;
  partner_user?: InputMaybe<Partner_User_Order_By>;
  partner_user_id?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  product_id?: InputMaybe<Order_By>;
  product_variation?: InputMaybe<Product_Variation_Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  script?: InputMaybe<Scripts_Order_By>;
  scripts_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: partner_commission_product_variation_type */
export type Partner_Commission_Product_Variation_Type_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "partner_commission_product_variation_type" */
export enum Partner_Commission_Product_Variation_Type_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerUserId = 'partner_user_id',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  ProductVariationId = 'product_variation_id',
  /** column name */
  ScriptsId = 'scripts_id'
}

/** select "partner_commission_product_variation_type_aggregate_bool_exp_bool_and_arguments_columns" columns of table "partner_commission_product_variation_type" */
export enum Partner_Commission_Product_Variation_Type_Select_Column_Partner_Commission_Product_Variation_Type_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "partner_commission_product_variation_type_aggregate_bool_exp_bool_or_arguments_columns" columns of table "partner_commission_product_variation_type" */
export enum Partner_Commission_Product_Variation_Type_Select_Column_Partner_Commission_Product_Variation_Type_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "partner_commission_product_variation_type" */
export type Partner_Commission_Product_Variation_Type_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_user_id?: InputMaybe<Scalars['uuid']['input']>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  scripts_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "partner_commission_product_variation_type" */
export type Partner_Commission_Product_Variation_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Partner_Commission_Product_Variation_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Partner_Commission_Product_Variation_Type_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_user_id?: InputMaybe<Scalars['uuid']['input']>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  scripts_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "partner_commission_product_variation_type" */
export enum Partner_Commission_Product_Variation_Type_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerUserId = 'partner_user_id',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  ProductVariationId = 'product_variation_id',
  /** column name */
  ScriptsId = 'scripts_id'
}

export type Partner_Commission_Product_Variation_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Partner_Commission_Product_Variation_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Partner_Commission_Product_Variation_Type_Bool_Exp;
};

/** select columns of table "partner_commission" */
export enum Partner_Commission_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerCommissionProductVariationTypeId = 'partner_commission_product_variation_type_id',
  /** column name */
  UserId = 'user_id'
}

/** select "partner_commission_aggregate_bool_exp_bool_and_arguments_columns" columns of table "partner_commission" */
export enum Partner_Commission_Select_Column_Partner_Commission_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "partner_commission_aggregate_bool_exp_bool_or_arguments_columns" columns of table "partner_commission" */
export enum Partner_Commission_Select_Column_Partner_Commission_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "partner_commission" */
export type Partner_Commission_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_commission_product_variation_type_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "partner_commission" */
export type Partner_Commission_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Partner_Commission_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Partner_Commission_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_commission_product_variation_type_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "partner_commission" */
export enum Partner_Commission_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerCommissionProductVariationTypeId = 'partner_commission_product_variation_type_id',
  /** column name */
  UserId = 'user_id'
}

export type Partner_Commission_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Partner_Commission_Set_Input>;
  /** filter the rows which have to be updated */
  where: Partner_Commission_Bool_Exp;
};

/** unique or primary key constraints on table "partner" */
export enum Partner_Constraint {
  /** unique or primary key constraint on columns "dealer_code" */
  PartnerDealerCodeKey = 'partner_dealer_code_key',
  /** unique or primary key constraint on columns "id" */
  PartnerPkey = 'partner_pkey'
}

/** columns and relationships of "partner_contact_type" */
export type Partner_Contact_Type = {
  __typename?: 'partner_contact_type';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "partner_contact_type" */
export type Partner_Contact_Type_Aggregate = {
  __typename?: 'partner_contact_type_aggregate';
  aggregate?: Maybe<Partner_Contact_Type_Aggregate_Fields>;
  nodes: Array<Partner_Contact_Type>;
};

/** aggregate fields of "partner_contact_type" */
export type Partner_Contact_Type_Aggregate_Fields = {
  __typename?: 'partner_contact_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Partner_Contact_Type_Max_Fields>;
  min?: Maybe<Partner_Contact_Type_Min_Fields>;
};


/** aggregate fields of "partner_contact_type" */
export type Partner_Contact_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Partner_Contact_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "partner_contact_type". All fields are combined with a logical 'AND'. */
export type Partner_Contact_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Partner_Contact_Type_Bool_Exp>>;
  _not?: InputMaybe<Partner_Contact_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Partner_Contact_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "partner_contact_type" */
export enum Partner_Contact_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  PartnerContactTypePkey = 'partner_contact_type_pkey'
}

/** input type for inserting data into table "partner_contact_type" */
export type Partner_Contact_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Partner_Contact_Type_Max_Fields = {
  __typename?: 'partner_contact_type_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Partner_Contact_Type_Min_Fields = {
  __typename?: 'partner_contact_type_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "partner_contact_type" */
export type Partner_Contact_Type_Mutation_Response = {
  __typename?: 'partner_contact_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Partner_Contact_Type>;
};

/** on_conflict condition type for table "partner_contact_type" */
export type Partner_Contact_Type_On_Conflict = {
  constraint: Partner_Contact_Type_Constraint;
  update_columns?: Array<Partner_Contact_Type_Update_Column>;
  where?: InputMaybe<Partner_Contact_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "partner_contact_type". */
export type Partner_Contact_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: partner_contact_type */
export type Partner_Contact_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "partner_contact_type" */
export enum Partner_Contact_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "partner_contact_type" */
export type Partner_Contact_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "partner_contact_type" */
export type Partner_Contact_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Partner_Contact_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Partner_Contact_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "partner_contact_type" */
export enum Partner_Contact_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Partner_Contact_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Partner_Contact_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Partner_Contact_Type_Bool_Exp;
};

/** input type for incrementing numeric columns in table "partner" */
export type Partner_Inc_Input = {
  popularity?: InputMaybe<Scalars['Int']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "partner" */
export type Partner_Insert_Input = {
  about?: InputMaybe<Scalars['String']['input']>;
  accounts_payable_located?: InputMaybe<Scalars['String']['input']>;
  associatedTypeByAssociatedType?: InputMaybe<Associated_Type_Obj_Rel_Insert_Input>;
  associated_type?: InputMaybe<Associated_Type_Enum>;
  brand?: InputMaybe<Scalars['String']['input']>;
  brand_logo?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Partner_Type_Enum>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  currency?: InputMaybe<Currency_Obj_Rel_Insert_Input>;
  customer_order_item_partners?: InputMaybe<Customer_Order_Item_Partner_Arr_Rel_Insert_Input>;
  customer_order_items?: InputMaybe<Customer_Order_Item_Arr_Rel_Insert_Input>;
  dealer_code?: InputMaybe<Scalars['String']['input']>;
  default_currency?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invoice_followup_email_address?: InputMaybe<Scalars['String']['input']>;
  invoice_sending_email_address?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_fuelbuddy?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['geography']['input']>;
  master_slot_pauses?: InputMaybe<Master_Slot_Pause_Arr_Rel_Insert_Input>;
  master_slots?: InputMaybe<Master_Slot_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  omcTypeByOmcType?: InputMaybe<Omc_Type_Obj_Rel_Insert_Input>;
  omc_type?: InputMaybe<Omc_Type_Enum>;
  order_schedulers?: InputMaybe<Order_Scheduler_Arr_Rel_Insert_Input>;
  partnerRelationshipsByVendorId?: InputMaybe<Partner_Relationship_Arr_Rel_Insert_Input>;
  partnerSellersBySellerId?: InputMaybe<Partner_Seller_Arr_Rel_Insert_Input>;
  partner_address?: InputMaybe<Partner_Address_Obj_Rel_Insert_Input>;
  partner_address_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_addresses?: InputMaybe<Partner_Address_Arr_Rel_Insert_Input>;
  partner_bank_details?: InputMaybe<Partner_Bank_Details_Arr_Rel_Insert_Input>;
  partner_localities?: InputMaybe<Partner_Localities_Arr_Rel_Insert_Input>;
  partner_order_items?: InputMaybe<Partner_Order_Item_Arr_Rel_Insert_Input>;
  partner_products?: InputMaybe<Partner_Product_Arr_Rel_Insert_Input>;
  partner_relationships?: InputMaybe<Partner_Relationship_Arr_Rel_Insert_Input>;
  partner_sellers?: InputMaybe<Partner_Seller_Arr_Rel_Insert_Input>;
  partner_signing_authorities?: InputMaybe<Partner_Signing_Authority_Arr_Rel_Insert_Input>;
  partner_timings?: InputMaybe<Partner_Timing_Arr_Rel_Insert_Input>;
  partner_type?: InputMaybe<Partner_Type_Obj_Rel_Insert_Input>;
  partner_users?: InputMaybe<Partner_User_Arr_Rel_Insert_Input>;
  partner_vehicles?: InputMaybe<Partner_Vehicle_Arr_Rel_Insert_Input>;
  planning_audit_logs?: InputMaybe<Planning_Audit_Log_Arr_Rel_Insert_Input>;
  planning_periods?: InputMaybe<Planning_Period_Arr_Rel_Insert_Input>;
  popularity?: InputMaybe<Scalars['Int']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  shift_schedules?: InputMaybe<Shift_Schedule_Arr_Rel_Insert_Input>;
  support_contact_number?: InputMaybe<Scalars['String']['input']>;
  trips?: InputMaybe<Trip_Arr_Rel_Insert_Input>;
  vendor_order_logs?: InputMaybe<Vendor_Order_Logs_Arr_Rel_Insert_Input>;
};

/** columns and relationships of "partner_localities" */
export type Partner_Localities = {
  __typename?: 'partner_localities';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  localities_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  locality?: Maybe<Localities>;
  /** An array relationship */
  order_schedulers: Array<Order_Scheduler>;
  /** An aggregate relationship */
  order_schedulers_aggregate: Order_Scheduler_Aggregate;
  /** An array relationship */
  organization_addresses: Array<Organization_Address>;
  /** An aggregate relationship */
  organization_addresses_aggregate: Organization_Address_Aggregate;
  /** An object relationship */
  partner: Partner;
  partner_id: Scalars['uuid']['output'];
  /** An array relationship */
  partner_localities_slots: Array<Partner_Localities_Slots>;
  /** An aggregate relationship */
  partner_localities_slots_aggregate: Partner_Localities_Slots_Aggregate;
  /** An array relationship */
  product_partner_localities_price_histories: Array<Product_Partner_Localities_Price_History>;
  /** An aggregate relationship */
  product_partner_localities_price_histories_aggregate: Product_Partner_Localities_Price_History_Aggregate;
  /** An array relationship */
  product_partner_localities_prices: Array<Product_Partner_Localities_Price>;
  /** An aggregate relationship */
  product_partner_localities_prices_aggregate: Product_Partner_Localities_Price_Aggregate;
  /** An array relationship */
  product_variation_partner_localities_slots: Array<Product_Variation_Partner_Localities_Slots>;
  /** An aggregate relationship */
  product_variation_partner_localities_slots_aggregate: Product_Variation_Partner_Localities_Slots_Aggregate;
  slug?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  vendor_order_logs: Array<Vendor_Order_Logs>;
  /** An aggregate relationship */
  vendor_order_logs_aggregate: Vendor_Order_Logs_Aggregate;
  zone_name?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "partner_localities" */
export type Partner_LocalitiesOrder_SchedulersArgs = {
  distinct_on?: InputMaybe<Array<Order_Scheduler_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Scheduler_Order_By>>;
  where?: InputMaybe<Order_Scheduler_Bool_Exp>;
};


/** columns and relationships of "partner_localities" */
export type Partner_LocalitiesOrder_Schedulers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Scheduler_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Scheduler_Order_By>>;
  where?: InputMaybe<Order_Scheduler_Bool_Exp>;
};


/** columns and relationships of "partner_localities" */
export type Partner_LocalitiesOrganization_AddressesArgs = {
  distinct_on?: InputMaybe<Array<Organization_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Address_Order_By>>;
  where?: InputMaybe<Organization_Address_Bool_Exp>;
};


/** columns and relationships of "partner_localities" */
export type Partner_LocalitiesOrganization_Addresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Address_Order_By>>;
  where?: InputMaybe<Organization_Address_Bool_Exp>;
};


/** columns and relationships of "partner_localities" */
export type Partner_LocalitiesPartner_Localities_SlotsArgs = {
  distinct_on?: InputMaybe<Array<Partner_Localities_Slots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Localities_Slots_Order_By>>;
  where?: InputMaybe<Partner_Localities_Slots_Bool_Exp>;
};


/** columns and relationships of "partner_localities" */
export type Partner_LocalitiesPartner_Localities_Slots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Localities_Slots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Localities_Slots_Order_By>>;
  where?: InputMaybe<Partner_Localities_Slots_Bool_Exp>;
};


/** columns and relationships of "partner_localities" */
export type Partner_LocalitiesProduct_Partner_Localities_Price_HistoriesArgs = {
  distinct_on?: InputMaybe<Array<Product_Partner_Localities_Price_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Partner_Localities_Price_History_Order_By>>;
  where?: InputMaybe<Product_Partner_Localities_Price_History_Bool_Exp>;
};


/** columns and relationships of "partner_localities" */
export type Partner_LocalitiesProduct_Partner_Localities_Price_Histories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Partner_Localities_Price_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Partner_Localities_Price_History_Order_By>>;
  where?: InputMaybe<Product_Partner_Localities_Price_History_Bool_Exp>;
};


/** columns and relationships of "partner_localities" */
export type Partner_LocalitiesProduct_Partner_Localities_PricesArgs = {
  distinct_on?: InputMaybe<Array<Product_Partner_Localities_Price_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Partner_Localities_Price_Order_By>>;
  where?: InputMaybe<Product_Partner_Localities_Price_Bool_Exp>;
};


/** columns and relationships of "partner_localities" */
export type Partner_LocalitiesProduct_Partner_Localities_Prices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Partner_Localities_Price_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Partner_Localities_Price_Order_By>>;
  where?: InputMaybe<Product_Partner_Localities_Price_Bool_Exp>;
};


/** columns and relationships of "partner_localities" */
export type Partner_LocalitiesProduct_Variation_Partner_Localities_SlotsArgs = {
  distinct_on?: InputMaybe<Array<Product_Variation_Partner_Localities_Slots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Variation_Partner_Localities_Slots_Order_By>>;
  where?: InputMaybe<Product_Variation_Partner_Localities_Slots_Bool_Exp>;
};


/** columns and relationships of "partner_localities" */
export type Partner_LocalitiesProduct_Variation_Partner_Localities_Slots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Variation_Partner_Localities_Slots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Variation_Partner_Localities_Slots_Order_By>>;
  where?: InputMaybe<Product_Variation_Partner_Localities_Slots_Bool_Exp>;
};


/** columns and relationships of "partner_localities" */
export type Partner_LocalitiesVendor_Order_LogsArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Order_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Order_Logs_Order_By>>;
  where?: InputMaybe<Vendor_Order_Logs_Bool_Exp>;
};


/** columns and relationships of "partner_localities" */
export type Partner_LocalitiesVendor_Order_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Order_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Order_Logs_Order_By>>;
  where?: InputMaybe<Vendor_Order_Logs_Bool_Exp>;
};

/** aggregated selection of "partner_localities" */
export type Partner_Localities_Aggregate = {
  __typename?: 'partner_localities_aggregate';
  aggregate?: Maybe<Partner_Localities_Aggregate_Fields>;
  nodes: Array<Partner_Localities>;
};

export type Partner_Localities_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Partner_Localities_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Partner_Localities_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Partner_Localities_Aggregate_Bool_Exp_Count>;
};

export type Partner_Localities_Aggregate_Bool_Exp_Bool_And = {
  arguments: Partner_Localities_Select_Column_Partner_Localities_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Localities_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_Localities_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Partner_Localities_Select_Column_Partner_Localities_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Localities_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_Localities_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Partner_Localities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Localities_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "partner_localities" */
export type Partner_Localities_Aggregate_Fields = {
  __typename?: 'partner_localities_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Partner_Localities_Max_Fields>;
  min?: Maybe<Partner_Localities_Min_Fields>;
};


/** aggregate fields of "partner_localities" */
export type Partner_Localities_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Partner_Localities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "partner_localities" */
export type Partner_Localities_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Partner_Localities_Max_Order_By>;
  min?: InputMaybe<Partner_Localities_Min_Order_By>;
};

/** input type for inserting array relation for remote table "partner_localities" */
export type Partner_Localities_Arr_Rel_Insert_Input = {
  data: Array<Partner_Localities_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_Localities_On_Conflict>;
};

/** Boolean expression to filter rows from the table "partner_localities". All fields are combined with a logical 'AND'. */
export type Partner_Localities_Bool_Exp = {
  _and?: InputMaybe<Array<Partner_Localities_Bool_Exp>>;
  _not?: InputMaybe<Partner_Localities_Bool_Exp>;
  _or?: InputMaybe<Array<Partner_Localities_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  localities_id?: InputMaybe<Uuid_Comparison_Exp>;
  locality?: InputMaybe<Localities_Bool_Exp>;
  order_schedulers?: InputMaybe<Order_Scheduler_Bool_Exp>;
  order_schedulers_aggregate?: InputMaybe<Order_Scheduler_Aggregate_Bool_Exp>;
  organization_addresses?: InputMaybe<Organization_Address_Bool_Exp>;
  organization_addresses_aggregate?: InputMaybe<Organization_Address_Aggregate_Bool_Exp>;
  partner?: InputMaybe<Partner_Bool_Exp>;
  partner_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner_localities_slots?: InputMaybe<Partner_Localities_Slots_Bool_Exp>;
  partner_localities_slots_aggregate?: InputMaybe<Partner_Localities_Slots_Aggregate_Bool_Exp>;
  product_partner_localities_price_histories?: InputMaybe<Product_Partner_Localities_Price_History_Bool_Exp>;
  product_partner_localities_price_histories_aggregate?: InputMaybe<Product_Partner_Localities_Price_History_Aggregate_Bool_Exp>;
  product_partner_localities_prices?: InputMaybe<Product_Partner_Localities_Price_Bool_Exp>;
  product_partner_localities_prices_aggregate?: InputMaybe<Product_Partner_Localities_Price_Aggregate_Bool_Exp>;
  product_variation_partner_localities_slots?: InputMaybe<Product_Variation_Partner_Localities_Slots_Bool_Exp>;
  product_variation_partner_localities_slots_aggregate?: InputMaybe<Product_Variation_Partner_Localities_Slots_Aggregate_Bool_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  vendor_order_logs?: InputMaybe<Vendor_Order_Logs_Bool_Exp>;
  vendor_order_logs_aggregate?: InputMaybe<Vendor_Order_Logs_Aggregate_Bool_Exp>;
  zone_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "partner_localities" */
export enum Partner_Localities_Constraint {
  /** unique or primary key constraint on columns "id" */
  PartnerLocalitiesPkey = 'partner_localities_pkey'
}

/** input type for inserting data into table "partner_localities" */
export type Partner_Localities_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  localities_id?: InputMaybe<Scalars['uuid']['input']>;
  locality?: InputMaybe<Localities_Obj_Rel_Insert_Input>;
  order_schedulers?: InputMaybe<Order_Scheduler_Arr_Rel_Insert_Input>;
  organization_addresses?: InputMaybe<Organization_Address_Arr_Rel_Insert_Input>;
  partner?: InputMaybe<Partner_Obj_Rel_Insert_Input>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_localities_slots?: InputMaybe<Partner_Localities_Slots_Arr_Rel_Insert_Input>;
  product_partner_localities_price_histories?: InputMaybe<Product_Partner_Localities_Price_History_Arr_Rel_Insert_Input>;
  product_partner_localities_prices?: InputMaybe<Product_Partner_Localities_Price_Arr_Rel_Insert_Input>;
  product_variation_partner_localities_slots?: InputMaybe<Product_Variation_Partner_Localities_Slots_Arr_Rel_Insert_Input>;
  slug?: InputMaybe<Scalars['String']['input']>;
  vendor_order_logs?: InputMaybe<Vendor_Order_Logs_Arr_Rel_Insert_Input>;
  zone_name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Partner_Localities_Max_Fields = {
  __typename?: 'partner_localities_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  localities_id?: Maybe<Scalars['uuid']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  zone_name?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "partner_localities" */
export type Partner_Localities_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  localities_id?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  zone_name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Partner_Localities_Min_Fields = {
  __typename?: 'partner_localities_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  localities_id?: Maybe<Scalars['uuid']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  zone_name?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "partner_localities" */
export type Partner_Localities_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  localities_id?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  zone_name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "partner_localities" */
export type Partner_Localities_Mutation_Response = {
  __typename?: 'partner_localities_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Partner_Localities>;
};

/** input type for inserting object relation for remote table "partner_localities" */
export type Partner_Localities_Obj_Rel_Insert_Input = {
  data: Partner_Localities_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_Localities_On_Conflict>;
};

/** on_conflict condition type for table "partner_localities" */
export type Partner_Localities_On_Conflict = {
  constraint: Partner_Localities_Constraint;
  update_columns?: Array<Partner_Localities_Update_Column>;
  where?: InputMaybe<Partner_Localities_Bool_Exp>;
};

/** Ordering options when selecting data from "partner_localities". */
export type Partner_Localities_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  localities_id?: InputMaybe<Order_By>;
  locality?: InputMaybe<Localities_Order_By>;
  order_schedulers_aggregate?: InputMaybe<Order_Scheduler_Aggregate_Order_By>;
  organization_addresses_aggregate?: InputMaybe<Organization_Address_Aggregate_Order_By>;
  partner?: InputMaybe<Partner_Order_By>;
  partner_id?: InputMaybe<Order_By>;
  partner_localities_slots_aggregate?: InputMaybe<Partner_Localities_Slots_Aggregate_Order_By>;
  product_partner_localities_price_histories_aggregate?: InputMaybe<Product_Partner_Localities_Price_History_Aggregate_Order_By>;
  product_partner_localities_prices_aggregate?: InputMaybe<Product_Partner_Localities_Price_Aggregate_Order_By>;
  product_variation_partner_localities_slots_aggregate?: InputMaybe<Product_Variation_Partner_Localities_Slots_Aggregate_Order_By>;
  slug?: InputMaybe<Order_By>;
  vendor_order_logs_aggregate?: InputMaybe<Vendor_Order_Logs_Aggregate_Order_By>;
  zone_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: partner_localities */
export type Partner_Localities_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "partner_localities" */
export enum Partner_Localities_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  LocalitiesId = 'localities_id',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  Slug = 'slug',
  /** column name */
  ZoneName = 'zone_name'
}

/** select "partner_localities_aggregate_bool_exp_bool_and_arguments_columns" columns of table "partner_localities" */
export enum Partner_Localities_Select_Column_Partner_Localities_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsDeleted = 'is_deleted'
}

/** select "partner_localities_aggregate_bool_exp_bool_or_arguments_columns" columns of table "partner_localities" */
export enum Partner_Localities_Select_Column_Partner_Localities_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsDeleted = 'is_deleted'
}

/** input type for updating data in table "partner_localities" */
export type Partner_Localities_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  localities_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  zone_name?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "partner_localities_slots" */
export type Partner_Localities_Slots = {
  __typename?: 'partner_localities_slots';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  customer_orders: Array<Customer_Order>;
  /** An aggregate relationship */
  customer_orders_aggregate: Customer_Order_Aggregate;
  day_date: Scalars['date']['output'];
  end_time: Scalars['timetz']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  is_visible: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  order_limit?: Maybe<Scalars['Int']['output']>;
  partner_localities: Scalars['uuid']['output'];
  /** An object relationship */
  partner_locality: Partner_Localities;
  start_time: Scalars['timetz']['output'];
};


/** columns and relationships of "partner_localities_slots" */
export type Partner_Localities_SlotsCustomer_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Order_By>>;
  where?: InputMaybe<Customer_Order_Bool_Exp>;
};


/** columns and relationships of "partner_localities_slots" */
export type Partner_Localities_SlotsCustomer_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Order_By>>;
  where?: InputMaybe<Customer_Order_Bool_Exp>;
};

/** aggregated selection of "partner_localities_slots" */
export type Partner_Localities_Slots_Aggregate = {
  __typename?: 'partner_localities_slots_aggregate';
  aggregate?: Maybe<Partner_Localities_Slots_Aggregate_Fields>;
  nodes: Array<Partner_Localities_Slots>;
};

export type Partner_Localities_Slots_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Partner_Localities_Slots_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Partner_Localities_Slots_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Partner_Localities_Slots_Aggregate_Bool_Exp_Count>;
};

export type Partner_Localities_Slots_Aggregate_Bool_Exp_Bool_And = {
  arguments: Partner_Localities_Slots_Select_Column_Partner_Localities_Slots_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Localities_Slots_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_Localities_Slots_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Partner_Localities_Slots_Select_Column_Partner_Localities_Slots_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Localities_Slots_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_Localities_Slots_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Partner_Localities_Slots_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Localities_Slots_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "partner_localities_slots" */
export type Partner_Localities_Slots_Aggregate_Fields = {
  __typename?: 'partner_localities_slots_aggregate_fields';
  avg?: Maybe<Partner_Localities_Slots_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Partner_Localities_Slots_Max_Fields>;
  min?: Maybe<Partner_Localities_Slots_Min_Fields>;
  stddev?: Maybe<Partner_Localities_Slots_Stddev_Fields>;
  stddev_pop?: Maybe<Partner_Localities_Slots_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Partner_Localities_Slots_Stddev_Samp_Fields>;
  sum?: Maybe<Partner_Localities_Slots_Sum_Fields>;
  var_pop?: Maybe<Partner_Localities_Slots_Var_Pop_Fields>;
  var_samp?: Maybe<Partner_Localities_Slots_Var_Samp_Fields>;
  variance?: Maybe<Partner_Localities_Slots_Variance_Fields>;
};


/** aggregate fields of "partner_localities_slots" */
export type Partner_Localities_Slots_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Partner_Localities_Slots_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "partner_localities_slots" */
export type Partner_Localities_Slots_Aggregate_Order_By = {
  avg?: InputMaybe<Partner_Localities_Slots_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Partner_Localities_Slots_Max_Order_By>;
  min?: InputMaybe<Partner_Localities_Slots_Min_Order_By>;
  stddev?: InputMaybe<Partner_Localities_Slots_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Partner_Localities_Slots_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Partner_Localities_Slots_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Partner_Localities_Slots_Sum_Order_By>;
  var_pop?: InputMaybe<Partner_Localities_Slots_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Partner_Localities_Slots_Var_Samp_Order_By>;
  variance?: InputMaybe<Partner_Localities_Slots_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "partner_localities_slots" */
export type Partner_Localities_Slots_Arr_Rel_Insert_Input = {
  data: Array<Partner_Localities_Slots_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_Localities_Slots_On_Conflict>;
};

/** aggregate avg on columns */
export type Partner_Localities_Slots_Avg_Fields = {
  __typename?: 'partner_localities_slots_avg_fields';
  order_limit?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "partner_localities_slots" */
export type Partner_Localities_Slots_Avg_Order_By = {
  order_limit?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "partner_localities_slots". All fields are combined with a logical 'AND'. */
export type Partner_Localities_Slots_Bool_Exp = {
  _and?: InputMaybe<Array<Partner_Localities_Slots_Bool_Exp>>;
  _not?: InputMaybe<Partner_Localities_Slots_Bool_Exp>;
  _or?: InputMaybe<Array<Partner_Localities_Slots_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_orders?: InputMaybe<Customer_Order_Bool_Exp>;
  customer_orders_aggregate?: InputMaybe<Customer_Order_Aggregate_Bool_Exp>;
  day_date?: InputMaybe<Date_Comparison_Exp>;
  end_time?: InputMaybe<Timetz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_visible?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  order_limit?: InputMaybe<Int_Comparison_Exp>;
  partner_localities?: InputMaybe<Uuid_Comparison_Exp>;
  partner_locality?: InputMaybe<Partner_Localities_Bool_Exp>;
  start_time?: InputMaybe<Timetz_Comparison_Exp>;
};

/** unique or primary key constraints on table "partner_localities_slots" */
export enum Partner_Localities_Slots_Constraint {
  /** unique or primary key constraint on columns "id" */
  PartnerLocalitiesSlotsPkey = 'partner_localities_slots_pkey'
}

/** input type for incrementing numeric columns in table "partner_localities_slots" */
export type Partner_Localities_Slots_Inc_Input = {
  order_limit?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "partner_localities_slots" */
export type Partner_Localities_Slots_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_orders?: InputMaybe<Customer_Order_Arr_Rel_Insert_Input>;
  day_date?: InputMaybe<Scalars['date']['input']>;
  end_time?: InputMaybe<Scalars['timetz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_visible?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  order_limit?: InputMaybe<Scalars['Int']['input']>;
  partner_localities?: InputMaybe<Scalars['uuid']['input']>;
  partner_locality?: InputMaybe<Partner_Localities_Obj_Rel_Insert_Input>;
  start_time?: InputMaybe<Scalars['timetz']['input']>;
};

/** aggregate max on columns */
export type Partner_Localities_Slots_Max_Fields = {
  __typename?: 'partner_localities_slots_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  day_date?: Maybe<Scalars['date']['output']>;
  end_time?: Maybe<Scalars['timetz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  order_limit?: Maybe<Scalars['Int']['output']>;
  partner_localities?: Maybe<Scalars['uuid']['output']>;
  start_time?: Maybe<Scalars['timetz']['output']>;
};

/** order by max() on columns of table "partner_localities_slots" */
export type Partner_Localities_Slots_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  day_date?: InputMaybe<Order_By>;
  end_time?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  order_limit?: InputMaybe<Order_By>;
  partner_localities?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Partner_Localities_Slots_Min_Fields = {
  __typename?: 'partner_localities_slots_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  day_date?: Maybe<Scalars['date']['output']>;
  end_time?: Maybe<Scalars['timetz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  order_limit?: Maybe<Scalars['Int']['output']>;
  partner_localities?: Maybe<Scalars['uuid']['output']>;
  start_time?: Maybe<Scalars['timetz']['output']>;
};

/** order by min() on columns of table "partner_localities_slots" */
export type Partner_Localities_Slots_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  day_date?: InputMaybe<Order_By>;
  end_time?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  order_limit?: InputMaybe<Order_By>;
  partner_localities?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "partner_localities_slots" */
export type Partner_Localities_Slots_Mutation_Response = {
  __typename?: 'partner_localities_slots_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Partner_Localities_Slots>;
};

/** input type for inserting object relation for remote table "partner_localities_slots" */
export type Partner_Localities_Slots_Obj_Rel_Insert_Input = {
  data: Partner_Localities_Slots_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_Localities_Slots_On_Conflict>;
};

/** on_conflict condition type for table "partner_localities_slots" */
export type Partner_Localities_Slots_On_Conflict = {
  constraint: Partner_Localities_Slots_Constraint;
  update_columns?: Array<Partner_Localities_Slots_Update_Column>;
  where?: InputMaybe<Partner_Localities_Slots_Bool_Exp>;
};

/** Ordering options when selecting data from "partner_localities_slots". */
export type Partner_Localities_Slots_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_orders_aggregate?: InputMaybe<Customer_Order_Aggregate_Order_By>;
  day_date?: InputMaybe<Order_By>;
  end_time?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_visible?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  order_limit?: InputMaybe<Order_By>;
  partner_localities?: InputMaybe<Order_By>;
  partner_locality?: InputMaybe<Partner_Localities_Order_By>;
  start_time?: InputMaybe<Order_By>;
};

/** primary key columns input for table: partner_localities_slots */
export type Partner_Localities_Slots_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "partner_localities_slots" */
export enum Partner_Localities_Slots_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DayDate = 'day_date',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsVisible = 'is_visible',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrderLimit = 'order_limit',
  /** column name */
  PartnerLocalities = 'partner_localities',
  /** column name */
  StartTime = 'start_time'
}

/** select "partner_localities_slots_aggregate_bool_exp_bool_and_arguments_columns" columns of table "partner_localities_slots" */
export enum Partner_Localities_Slots_Select_Column_Partner_Localities_Slots_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsVisible = 'is_visible'
}

/** select "partner_localities_slots_aggregate_bool_exp_bool_or_arguments_columns" columns of table "partner_localities_slots" */
export enum Partner_Localities_Slots_Select_Column_Partner_Localities_Slots_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsVisible = 'is_visible'
}

/** input type for updating data in table "partner_localities_slots" */
export type Partner_Localities_Slots_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  day_date?: InputMaybe<Scalars['date']['input']>;
  end_time?: InputMaybe<Scalars['timetz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_visible?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  order_limit?: InputMaybe<Scalars['Int']['input']>;
  partner_localities?: InputMaybe<Scalars['uuid']['input']>;
  start_time?: InputMaybe<Scalars['timetz']['input']>;
};

/** aggregate stddev on columns */
export type Partner_Localities_Slots_Stddev_Fields = {
  __typename?: 'partner_localities_slots_stddev_fields';
  order_limit?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "partner_localities_slots" */
export type Partner_Localities_Slots_Stddev_Order_By = {
  order_limit?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Partner_Localities_Slots_Stddev_Pop_Fields = {
  __typename?: 'partner_localities_slots_stddev_pop_fields';
  order_limit?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "partner_localities_slots" */
export type Partner_Localities_Slots_Stddev_Pop_Order_By = {
  order_limit?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Partner_Localities_Slots_Stddev_Samp_Fields = {
  __typename?: 'partner_localities_slots_stddev_samp_fields';
  order_limit?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "partner_localities_slots" */
export type Partner_Localities_Slots_Stddev_Samp_Order_By = {
  order_limit?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "partner_localities_slots" */
export type Partner_Localities_Slots_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Partner_Localities_Slots_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Partner_Localities_Slots_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  day_date?: InputMaybe<Scalars['date']['input']>;
  end_time?: InputMaybe<Scalars['timetz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_visible?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  order_limit?: InputMaybe<Scalars['Int']['input']>;
  partner_localities?: InputMaybe<Scalars['uuid']['input']>;
  start_time?: InputMaybe<Scalars['timetz']['input']>;
};

/** aggregate sum on columns */
export type Partner_Localities_Slots_Sum_Fields = {
  __typename?: 'partner_localities_slots_sum_fields';
  order_limit?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "partner_localities_slots" */
export type Partner_Localities_Slots_Sum_Order_By = {
  order_limit?: InputMaybe<Order_By>;
};

/** update columns of table "partner_localities_slots" */
export enum Partner_Localities_Slots_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DayDate = 'day_date',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsVisible = 'is_visible',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrderLimit = 'order_limit',
  /** column name */
  PartnerLocalities = 'partner_localities',
  /** column name */
  StartTime = 'start_time'
}

export type Partner_Localities_Slots_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Partner_Localities_Slots_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Partner_Localities_Slots_Set_Input>;
  /** filter the rows which have to be updated */
  where: Partner_Localities_Slots_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Partner_Localities_Slots_Var_Pop_Fields = {
  __typename?: 'partner_localities_slots_var_pop_fields';
  order_limit?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "partner_localities_slots" */
export type Partner_Localities_Slots_Var_Pop_Order_By = {
  order_limit?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Partner_Localities_Slots_Var_Samp_Fields = {
  __typename?: 'partner_localities_slots_var_samp_fields';
  order_limit?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "partner_localities_slots" */
export type Partner_Localities_Slots_Var_Samp_Order_By = {
  order_limit?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Partner_Localities_Slots_Variance_Fields = {
  __typename?: 'partner_localities_slots_variance_fields';
  order_limit?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "partner_localities_slots" */
export type Partner_Localities_Slots_Variance_Order_By = {
  order_limit?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "partner_localities" */
export type Partner_Localities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Partner_Localities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Partner_Localities_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  localities_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  zone_name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "partner_localities" */
export enum Partner_Localities_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  LocalitiesId = 'localities_id',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  Slug = 'slug',
  /** column name */
  ZoneName = 'zone_name'
}

export type Partner_Localities_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Partner_Localities_Set_Input>;
  /** filter the rows which have to be updated */
  where: Partner_Localities_Bool_Exp;
};

/** aggregate max on columns */
export type Partner_Max_Fields = {
  __typename?: 'partner_max_fields';
  about?: Maybe<Scalars['String']['output']>;
  accounts_payable_located?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  brand_logo?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  dealer_code?: Maybe<Scalars['String']['output']>;
  default_currency?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  invoice_followup_email_address?: Maybe<Scalars['String']['output']>;
  invoice_sending_email_address?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  partner_address_id?: Maybe<Scalars['uuid']['output']>;
  popularity?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  support_contact_number?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "partner" */
export type Partner_Max_Order_By = {
  about?: InputMaybe<Order_By>;
  accounts_payable_located?: InputMaybe<Order_By>;
  brand?: InputMaybe<Order_By>;
  brand_logo?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dealer_code?: InputMaybe<Order_By>;
  default_currency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_followup_email_address?: InputMaybe<Order_By>;
  invoice_sending_email_address?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  partner_address_id?: InputMaybe<Order_By>;
  popularity?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  support_contact_number?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Partner_Min_Fields = {
  __typename?: 'partner_min_fields';
  about?: Maybe<Scalars['String']['output']>;
  accounts_payable_located?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  brand_logo?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  dealer_code?: Maybe<Scalars['String']['output']>;
  default_currency?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  invoice_followup_email_address?: Maybe<Scalars['String']['output']>;
  invoice_sending_email_address?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  partner_address_id?: Maybe<Scalars['uuid']['output']>;
  popularity?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  support_contact_number?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "partner" */
export type Partner_Min_Order_By = {
  about?: InputMaybe<Order_By>;
  accounts_payable_located?: InputMaybe<Order_By>;
  brand?: InputMaybe<Order_By>;
  brand_logo?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dealer_code?: InputMaybe<Order_By>;
  default_currency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_followup_email_address?: InputMaybe<Order_By>;
  invoice_sending_email_address?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  partner_address_id?: InputMaybe<Order_By>;
  popularity?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  support_contact_number?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "partner" */
export type Partner_Mutation_Response = {
  __typename?: 'partner_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Partner>;
};

/** input type for inserting object relation for remote table "partner" */
export type Partner_Obj_Rel_Insert_Input = {
  data: Partner_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_On_Conflict>;
};

/** on_conflict condition type for table "partner" */
export type Partner_On_Conflict = {
  constraint: Partner_Constraint;
  update_columns?: Array<Partner_Update_Column>;
  where?: InputMaybe<Partner_Bool_Exp>;
};

/** columns and relationships of "partner_order" */
export type Partner_Order = {
  __typename?: 'partner_order';
  affiliation_amount?: Maybe<Scalars['numeric']['output']>;
  affiliation_user_id?: Maybe<Scalars['uuid']['output']>;
  amount?: Maybe<Scalars['numeric']['output']>;
  amount_paid?: Maybe<Scalars['numeric']['output']>;
  amount_to_be_paid?: Maybe<Scalars['numeric']['output']>;
  category: Order_Type_Enum;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  delivery_fee?: Maybe<Scalars['numeric']['output']>;
  /** An array relationship */
  fillup_requests: Array<Fillup_Request>;
  /** An aggregate relationship */
  fillup_requests_aggregate: Fillup_Request_Aggregate;
  id: Scalars['uuid']['output'];
  instruction?: Maybe<Scalars['String']['output']>;
  is_active: Scalars['Boolean']['output'];
  is_prepaid: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  order_code: Scalars['bigint']['output'];
  /** An object relationship */
  order_type: Order_Type;
  /** An object relationship */
  organization_user?: Maybe<Organization_User>;
  organization_user_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  partner_address: Partner_Address;
  partner_address_id: Scalars['uuid']['output'];
  /** An array relationship */
  partner_order_customer_assets: Array<Partner_Order_Customer_Asset>;
  /** An aggregate relationship */
  partner_order_customer_assets_aggregate: Partner_Order_Customer_Asset_Aggregate;
  /** An array relationship */
  partner_order_items: Array<Partner_Order_Item>;
  /** An aggregate relationship */
  partner_order_items_aggregate: Partner_Order_Item_Aggregate;
  /** An array relationship */
  partner_order_partner_user_documents: Array<Partner_Order_Partner_User_Document>;
  /** An aggregate relationship */
  partner_order_partner_user_documents_aggregate: Partner_Order_Partner_User_Document_Aggregate;
  /** An object relationship */
  partner_order_state: Partner_Order_State;
  /** An array relationship */
  partner_order_stateflows: Array<Partner_Order_Stateflow>;
  /** An aggregate relationship */
  partner_order_stateflows_aggregate: Partner_Order_Stateflow_Aggregate;
  /** An object relationship */
  partner_user: Partner_User;
  partner_user_id: Scalars['uuid']['output'];
  po_id?: Maybe<Scalars['String']['output']>;
  service_tax?: Maybe<Scalars['numeric']['output']>;
  state: Partner_Order_State_Enum;
  tax?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  user?: Maybe<User>;
  /** An object relationship */
  userByCreatedBy?: Maybe<User>;
  /** An object relationship */
  voucher?: Maybe<Voucher>;
  voucher_discount?: Maybe<Scalars['numeric']['output']>;
  voucher_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "partner_order" */
export type Partner_OrderFillup_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Fillup_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fillup_Request_Order_By>>;
  where?: InputMaybe<Fillup_Request_Bool_Exp>;
};


/** columns and relationships of "partner_order" */
export type Partner_OrderFillup_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fillup_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fillup_Request_Order_By>>;
  where?: InputMaybe<Fillup_Request_Bool_Exp>;
};


/** columns and relationships of "partner_order" */
export type Partner_OrderPartner_Order_Customer_AssetsArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Customer_Asset_Order_By>>;
  where?: InputMaybe<Partner_Order_Customer_Asset_Bool_Exp>;
};


/** columns and relationships of "partner_order" */
export type Partner_OrderPartner_Order_Customer_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Customer_Asset_Order_By>>;
  where?: InputMaybe<Partner_Order_Customer_Asset_Bool_Exp>;
};


/** columns and relationships of "partner_order" */
export type Partner_OrderPartner_Order_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Bool_Exp>;
};


/** columns and relationships of "partner_order" */
export type Partner_OrderPartner_Order_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Bool_Exp>;
};


/** columns and relationships of "partner_order" */
export type Partner_OrderPartner_Order_Partner_User_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Partner_User_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Partner_User_Document_Order_By>>;
  where?: InputMaybe<Partner_Order_Partner_User_Document_Bool_Exp>;
};


/** columns and relationships of "partner_order" */
export type Partner_OrderPartner_Order_Partner_User_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Partner_User_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Partner_User_Document_Order_By>>;
  where?: InputMaybe<Partner_Order_Partner_User_Document_Bool_Exp>;
};


/** columns and relationships of "partner_order" */
export type Partner_OrderPartner_Order_StateflowsArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Stateflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Stateflow_Order_By>>;
  where?: InputMaybe<Partner_Order_Stateflow_Bool_Exp>;
};


/** columns and relationships of "partner_order" */
export type Partner_OrderPartner_Order_Stateflows_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Stateflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Stateflow_Order_By>>;
  where?: InputMaybe<Partner_Order_Stateflow_Bool_Exp>;
};

/** aggregated selection of "partner_order" */
export type Partner_Order_Aggregate = {
  __typename?: 'partner_order_aggregate';
  aggregate?: Maybe<Partner_Order_Aggregate_Fields>;
  nodes: Array<Partner_Order>;
};

export type Partner_Order_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Partner_Order_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Partner_Order_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Partner_Order_Aggregate_Bool_Exp_Count>;
};

export type Partner_Order_Aggregate_Bool_Exp_Bool_And = {
  arguments: Partner_Order_Select_Column_Partner_Order_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Order_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_Order_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Partner_Order_Select_Column_Partner_Order_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Order_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_Order_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Partner_Order_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Order_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "partner_order" */
export type Partner_Order_Aggregate_Fields = {
  __typename?: 'partner_order_aggregate_fields';
  avg?: Maybe<Partner_Order_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Partner_Order_Max_Fields>;
  min?: Maybe<Partner_Order_Min_Fields>;
  stddev?: Maybe<Partner_Order_Stddev_Fields>;
  stddev_pop?: Maybe<Partner_Order_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Partner_Order_Stddev_Samp_Fields>;
  sum?: Maybe<Partner_Order_Sum_Fields>;
  var_pop?: Maybe<Partner_Order_Var_Pop_Fields>;
  var_samp?: Maybe<Partner_Order_Var_Samp_Fields>;
  variance?: Maybe<Partner_Order_Variance_Fields>;
};


/** aggregate fields of "partner_order" */
export type Partner_Order_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Partner_Order_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "partner_order" */
export type Partner_Order_Aggregate_Order_By = {
  avg?: InputMaybe<Partner_Order_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Partner_Order_Max_Order_By>;
  min?: InputMaybe<Partner_Order_Min_Order_By>;
  stddev?: InputMaybe<Partner_Order_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Partner_Order_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Partner_Order_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Partner_Order_Sum_Order_By>;
  var_pop?: InputMaybe<Partner_Order_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Partner_Order_Var_Samp_Order_By>;
  variance?: InputMaybe<Partner_Order_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "partner_order" */
export type Partner_Order_Arr_Rel_Insert_Input = {
  data: Array<Partner_Order_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_Order_On_Conflict>;
};

/** aggregate avg on columns */
export type Partner_Order_Avg_Fields = {
  __typename?: 'partner_order_avg_fields';
  affiliation_amount?: Maybe<Scalars['Float']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  amount_paid?: Maybe<Scalars['Float']['output']>;
  amount_to_be_paid?: Maybe<Scalars['Float']['output']>;
  delivery_fee?: Maybe<Scalars['Float']['output']>;
  order_code?: Maybe<Scalars['Float']['output']>;
  service_tax?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  voucher_discount?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "partner_order" */
export type Partner_Order_Avg_Order_By = {
  affiliation_amount?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_to_be_paid?: InputMaybe<Order_By>;
  delivery_fee?: InputMaybe<Order_By>;
  order_code?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "partner_order". All fields are combined with a logical 'AND'. */
export type Partner_Order_Bool_Exp = {
  _and?: InputMaybe<Array<Partner_Order_Bool_Exp>>;
  _not?: InputMaybe<Partner_Order_Bool_Exp>;
  _or?: InputMaybe<Array<Partner_Order_Bool_Exp>>;
  affiliation_amount?: InputMaybe<Numeric_Comparison_Exp>;
  affiliation_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  amount_paid?: InputMaybe<Numeric_Comparison_Exp>;
  amount_to_be_paid?: InputMaybe<Numeric_Comparison_Exp>;
  category?: InputMaybe<Order_Type_Enum_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  delivery_fee?: InputMaybe<Numeric_Comparison_Exp>;
  fillup_requests?: InputMaybe<Fillup_Request_Bool_Exp>;
  fillup_requests_aggregate?: InputMaybe<Fillup_Request_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  instruction?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_prepaid?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  order_code?: InputMaybe<Bigint_Comparison_Exp>;
  order_type?: InputMaybe<Order_Type_Bool_Exp>;
  organization_user?: InputMaybe<Organization_User_Bool_Exp>;
  organization_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner_address?: InputMaybe<Partner_Address_Bool_Exp>;
  partner_address_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner_order_customer_assets?: InputMaybe<Partner_Order_Customer_Asset_Bool_Exp>;
  partner_order_customer_assets_aggregate?: InputMaybe<Partner_Order_Customer_Asset_Aggregate_Bool_Exp>;
  partner_order_items?: InputMaybe<Partner_Order_Item_Bool_Exp>;
  partner_order_items_aggregate?: InputMaybe<Partner_Order_Item_Aggregate_Bool_Exp>;
  partner_order_partner_user_documents?: InputMaybe<Partner_Order_Partner_User_Document_Bool_Exp>;
  partner_order_partner_user_documents_aggregate?: InputMaybe<Partner_Order_Partner_User_Document_Aggregate_Bool_Exp>;
  partner_order_state?: InputMaybe<Partner_Order_State_Bool_Exp>;
  partner_order_stateflows?: InputMaybe<Partner_Order_Stateflow_Bool_Exp>;
  partner_order_stateflows_aggregate?: InputMaybe<Partner_Order_Stateflow_Aggregate_Bool_Exp>;
  partner_user?: InputMaybe<Partner_User_Bool_Exp>;
  partner_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  po_id?: InputMaybe<String_Comparison_Exp>;
  service_tax?: InputMaybe<Numeric_Comparison_Exp>;
  state?: InputMaybe<Partner_Order_State_Enum_Comparison_Exp>;
  tax?: InputMaybe<Numeric_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userByCreatedBy?: InputMaybe<User_Bool_Exp>;
  voucher?: InputMaybe<Voucher_Bool_Exp>;
  voucher_discount?: InputMaybe<Numeric_Comparison_Exp>;
  voucher_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "partner". */
export type Partner_Order_By = {
  about?: InputMaybe<Order_By>;
  accounts_payable_located?: InputMaybe<Order_By>;
  associatedTypeByAssociatedType?: InputMaybe<Associated_Type_Order_By>;
  associated_type?: InputMaybe<Order_By>;
  brand?: InputMaybe<Order_By>;
  brand_logo?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Currency_Order_By>;
  customer_order_item_partners_aggregate?: InputMaybe<Customer_Order_Item_Partner_Aggregate_Order_By>;
  customer_order_items_aggregate?: InputMaybe<Customer_Order_Item_Aggregate_Order_By>;
  dealer_code?: InputMaybe<Order_By>;
  default_currency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_followup_email_address?: InputMaybe<Order_By>;
  invoice_sending_email_address?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_fuelbuddy?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  master_slot_pauses_aggregate?: InputMaybe<Master_Slot_Pause_Aggregate_Order_By>;
  master_slots_aggregate?: InputMaybe<Master_Slot_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  omcTypeByOmcType?: InputMaybe<Omc_Type_Order_By>;
  omc_type?: InputMaybe<Order_By>;
  order_schedulers_aggregate?: InputMaybe<Order_Scheduler_Aggregate_Order_By>;
  partnerRelationshipsByVendorId_aggregate?: InputMaybe<Partner_Relationship_Aggregate_Order_By>;
  partnerSellersBySellerId_aggregate?: InputMaybe<Partner_Seller_Aggregate_Order_By>;
  partner_address?: InputMaybe<Partner_Address_Order_By>;
  partner_address_id?: InputMaybe<Order_By>;
  partner_addresses_aggregate?: InputMaybe<Partner_Address_Aggregate_Order_By>;
  partner_bank_details_aggregate?: InputMaybe<Partner_Bank_Details_Aggregate_Order_By>;
  partner_localities_aggregate?: InputMaybe<Partner_Localities_Aggregate_Order_By>;
  partner_order_items_aggregate?: InputMaybe<Partner_Order_Item_Aggregate_Order_By>;
  partner_products_aggregate?: InputMaybe<Partner_Product_Aggregate_Order_By>;
  partner_relationships_aggregate?: InputMaybe<Partner_Relationship_Aggregate_Order_By>;
  partner_sellers_aggregate?: InputMaybe<Partner_Seller_Aggregate_Order_By>;
  partner_signing_authorities_aggregate?: InputMaybe<Partner_Signing_Authority_Aggregate_Order_By>;
  partner_timings_aggregate?: InputMaybe<Partner_Timing_Aggregate_Order_By>;
  partner_type?: InputMaybe<Partner_Type_Order_By>;
  partner_users_aggregate?: InputMaybe<Partner_User_Aggregate_Order_By>;
  partner_vehicles_aggregate?: InputMaybe<Partner_Vehicle_Aggregate_Order_By>;
  planning_audit_logs_aggregate?: InputMaybe<Planning_Audit_Log_Aggregate_Order_By>;
  planning_periods_aggregate?: InputMaybe<Planning_Period_Aggregate_Order_By>;
  popularity?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  shift_schedules_aggregate?: InputMaybe<Shift_Schedule_Aggregate_Order_By>;
  support_contact_number?: InputMaybe<Order_By>;
  trips_aggregate?: InputMaybe<Trip_Aggregate_Order_By>;
  vendor_order_logs_aggregate?: InputMaybe<Vendor_Order_Logs_Aggregate_Order_By>;
};

/** unique or primary key constraints on table "partner_order" */
export enum Partner_Order_Constraint {
  /** unique or primary key constraint on columns "id" */
  PartnerOrderPkey = 'partner_order_pkey'
}

/** columns and relationships of "partner_order_customer_asset" */
export type Partner_Order_Customer_Asset = {
  __typename?: 'partner_order_customer_asset';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  customer_asset: Customer_Asset;
  customer_asset_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  partner_order: Partner_Order;
  partner_order_id: Scalars['uuid']['output'];
  quantity_dispensed?: Maybe<Scalars['numeric']['output']>;
  quantity_requested?: Maybe<Scalars['numeric']['output']>;
};

/** aggregated selection of "partner_order_customer_asset" */
export type Partner_Order_Customer_Asset_Aggregate = {
  __typename?: 'partner_order_customer_asset_aggregate';
  aggregate?: Maybe<Partner_Order_Customer_Asset_Aggregate_Fields>;
  nodes: Array<Partner_Order_Customer_Asset>;
};

export type Partner_Order_Customer_Asset_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Partner_Order_Customer_Asset_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Partner_Order_Customer_Asset_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Partner_Order_Customer_Asset_Aggregate_Bool_Exp_Count>;
};

export type Partner_Order_Customer_Asset_Aggregate_Bool_Exp_Bool_And = {
  arguments: Partner_Order_Customer_Asset_Select_Column_Partner_Order_Customer_Asset_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Order_Customer_Asset_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_Order_Customer_Asset_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Partner_Order_Customer_Asset_Select_Column_Partner_Order_Customer_Asset_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Order_Customer_Asset_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_Order_Customer_Asset_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Partner_Order_Customer_Asset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Order_Customer_Asset_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "partner_order_customer_asset" */
export type Partner_Order_Customer_Asset_Aggregate_Fields = {
  __typename?: 'partner_order_customer_asset_aggregate_fields';
  avg?: Maybe<Partner_Order_Customer_Asset_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Partner_Order_Customer_Asset_Max_Fields>;
  min?: Maybe<Partner_Order_Customer_Asset_Min_Fields>;
  stddev?: Maybe<Partner_Order_Customer_Asset_Stddev_Fields>;
  stddev_pop?: Maybe<Partner_Order_Customer_Asset_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Partner_Order_Customer_Asset_Stddev_Samp_Fields>;
  sum?: Maybe<Partner_Order_Customer_Asset_Sum_Fields>;
  var_pop?: Maybe<Partner_Order_Customer_Asset_Var_Pop_Fields>;
  var_samp?: Maybe<Partner_Order_Customer_Asset_Var_Samp_Fields>;
  variance?: Maybe<Partner_Order_Customer_Asset_Variance_Fields>;
};


/** aggregate fields of "partner_order_customer_asset" */
export type Partner_Order_Customer_Asset_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Partner_Order_Customer_Asset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "partner_order_customer_asset" */
export type Partner_Order_Customer_Asset_Aggregate_Order_By = {
  avg?: InputMaybe<Partner_Order_Customer_Asset_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Partner_Order_Customer_Asset_Max_Order_By>;
  min?: InputMaybe<Partner_Order_Customer_Asset_Min_Order_By>;
  stddev?: InputMaybe<Partner_Order_Customer_Asset_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Partner_Order_Customer_Asset_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Partner_Order_Customer_Asset_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Partner_Order_Customer_Asset_Sum_Order_By>;
  var_pop?: InputMaybe<Partner_Order_Customer_Asset_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Partner_Order_Customer_Asset_Var_Samp_Order_By>;
  variance?: InputMaybe<Partner_Order_Customer_Asset_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "partner_order_customer_asset" */
export type Partner_Order_Customer_Asset_Arr_Rel_Insert_Input = {
  data: Array<Partner_Order_Customer_Asset_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_Order_Customer_Asset_On_Conflict>;
};

/** aggregate avg on columns */
export type Partner_Order_Customer_Asset_Avg_Fields = {
  __typename?: 'partner_order_customer_asset_avg_fields';
  quantity_dispensed?: Maybe<Scalars['Float']['output']>;
  quantity_requested?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "partner_order_customer_asset" */
export type Partner_Order_Customer_Asset_Avg_Order_By = {
  quantity_dispensed?: InputMaybe<Order_By>;
  quantity_requested?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "partner_order_customer_asset". All fields are combined with a logical 'AND'. */
export type Partner_Order_Customer_Asset_Bool_Exp = {
  _and?: InputMaybe<Array<Partner_Order_Customer_Asset_Bool_Exp>>;
  _not?: InputMaybe<Partner_Order_Customer_Asset_Bool_Exp>;
  _or?: InputMaybe<Array<Partner_Order_Customer_Asset_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_asset?: InputMaybe<Customer_Asset_Bool_Exp>;
  customer_asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  partner_order?: InputMaybe<Partner_Order_Bool_Exp>;
  partner_order_id?: InputMaybe<Uuid_Comparison_Exp>;
  quantity_dispensed?: InputMaybe<Numeric_Comparison_Exp>;
  quantity_requested?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "partner_order_customer_asset" */
export enum Partner_Order_Customer_Asset_Constraint {
  /** unique or primary key constraint on columns "id" */
  PartnerOrderCustomerAssetPkey = 'partner_order_customer_asset_pkey'
}

/** input type for incrementing numeric columns in table "partner_order_customer_asset" */
export type Partner_Order_Customer_Asset_Inc_Input = {
  quantity_dispensed?: InputMaybe<Scalars['numeric']['input']>;
  quantity_requested?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "partner_order_customer_asset" */
export type Partner_Order_Customer_Asset_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_asset?: InputMaybe<Customer_Asset_Obj_Rel_Insert_Input>;
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_order?: InputMaybe<Partner_Order_Obj_Rel_Insert_Input>;
  partner_order_id?: InputMaybe<Scalars['uuid']['input']>;
  quantity_dispensed?: InputMaybe<Scalars['numeric']['input']>;
  quantity_requested?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Partner_Order_Customer_Asset_Max_Fields = {
  __typename?: 'partner_order_customer_asset_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_order_id?: Maybe<Scalars['uuid']['output']>;
  quantity_dispensed?: Maybe<Scalars['numeric']['output']>;
  quantity_requested?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "partner_order_customer_asset" */
export type Partner_Order_Customer_Asset_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_order_id?: InputMaybe<Order_By>;
  quantity_dispensed?: InputMaybe<Order_By>;
  quantity_requested?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Partner_Order_Customer_Asset_Min_Fields = {
  __typename?: 'partner_order_customer_asset_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_order_id?: Maybe<Scalars['uuid']['output']>;
  quantity_dispensed?: Maybe<Scalars['numeric']['output']>;
  quantity_requested?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "partner_order_customer_asset" */
export type Partner_Order_Customer_Asset_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_order_id?: InputMaybe<Order_By>;
  quantity_dispensed?: InputMaybe<Order_By>;
  quantity_requested?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "partner_order_customer_asset" */
export type Partner_Order_Customer_Asset_Mutation_Response = {
  __typename?: 'partner_order_customer_asset_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Partner_Order_Customer_Asset>;
};

/** on_conflict condition type for table "partner_order_customer_asset" */
export type Partner_Order_Customer_Asset_On_Conflict = {
  constraint: Partner_Order_Customer_Asset_Constraint;
  update_columns?: Array<Partner_Order_Customer_Asset_Update_Column>;
  where?: InputMaybe<Partner_Order_Customer_Asset_Bool_Exp>;
};

/** Ordering options when selecting data from "partner_order_customer_asset". */
export type Partner_Order_Customer_Asset_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_asset?: InputMaybe<Customer_Asset_Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_order?: InputMaybe<Partner_Order_Order_By>;
  partner_order_id?: InputMaybe<Order_By>;
  quantity_dispensed?: InputMaybe<Order_By>;
  quantity_requested?: InputMaybe<Order_By>;
};

/** primary key columns input for table: partner_order_customer_asset */
export type Partner_Order_Customer_Asset_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "partner_order_customer_asset" */
export enum Partner_Order_Customer_Asset_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerAssetId = 'customer_asset_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerOrderId = 'partner_order_id',
  /** column name */
  QuantityDispensed = 'quantity_dispensed',
  /** column name */
  QuantityRequested = 'quantity_requested'
}

/** select "partner_order_customer_asset_aggregate_bool_exp_bool_and_arguments_columns" columns of table "partner_order_customer_asset" */
export enum Partner_Order_Customer_Asset_Select_Column_Partner_Order_Customer_Asset_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "partner_order_customer_asset_aggregate_bool_exp_bool_or_arguments_columns" columns of table "partner_order_customer_asset" */
export enum Partner_Order_Customer_Asset_Select_Column_Partner_Order_Customer_Asset_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "partner_order_customer_asset" */
export type Partner_Order_Customer_Asset_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_order_id?: InputMaybe<Scalars['uuid']['input']>;
  quantity_dispensed?: InputMaybe<Scalars['numeric']['input']>;
  quantity_requested?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Partner_Order_Customer_Asset_Stddev_Fields = {
  __typename?: 'partner_order_customer_asset_stddev_fields';
  quantity_dispensed?: Maybe<Scalars['Float']['output']>;
  quantity_requested?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "partner_order_customer_asset" */
export type Partner_Order_Customer_Asset_Stddev_Order_By = {
  quantity_dispensed?: InputMaybe<Order_By>;
  quantity_requested?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Partner_Order_Customer_Asset_Stddev_Pop_Fields = {
  __typename?: 'partner_order_customer_asset_stddev_pop_fields';
  quantity_dispensed?: Maybe<Scalars['Float']['output']>;
  quantity_requested?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "partner_order_customer_asset" */
export type Partner_Order_Customer_Asset_Stddev_Pop_Order_By = {
  quantity_dispensed?: InputMaybe<Order_By>;
  quantity_requested?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Partner_Order_Customer_Asset_Stddev_Samp_Fields = {
  __typename?: 'partner_order_customer_asset_stddev_samp_fields';
  quantity_dispensed?: Maybe<Scalars['Float']['output']>;
  quantity_requested?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "partner_order_customer_asset" */
export type Partner_Order_Customer_Asset_Stddev_Samp_Order_By = {
  quantity_dispensed?: InputMaybe<Order_By>;
  quantity_requested?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "partner_order_customer_asset" */
export type Partner_Order_Customer_Asset_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Partner_Order_Customer_Asset_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Partner_Order_Customer_Asset_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_order_id?: InputMaybe<Scalars['uuid']['input']>;
  quantity_dispensed?: InputMaybe<Scalars['numeric']['input']>;
  quantity_requested?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Partner_Order_Customer_Asset_Sum_Fields = {
  __typename?: 'partner_order_customer_asset_sum_fields';
  quantity_dispensed?: Maybe<Scalars['numeric']['output']>;
  quantity_requested?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "partner_order_customer_asset" */
export type Partner_Order_Customer_Asset_Sum_Order_By = {
  quantity_dispensed?: InputMaybe<Order_By>;
  quantity_requested?: InputMaybe<Order_By>;
};

/** update columns of table "partner_order_customer_asset" */
export enum Partner_Order_Customer_Asset_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerAssetId = 'customer_asset_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerOrderId = 'partner_order_id',
  /** column name */
  QuantityDispensed = 'quantity_dispensed',
  /** column name */
  QuantityRequested = 'quantity_requested'
}

export type Partner_Order_Customer_Asset_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Partner_Order_Customer_Asset_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Partner_Order_Customer_Asset_Set_Input>;
  /** filter the rows which have to be updated */
  where: Partner_Order_Customer_Asset_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Partner_Order_Customer_Asset_Var_Pop_Fields = {
  __typename?: 'partner_order_customer_asset_var_pop_fields';
  quantity_dispensed?: Maybe<Scalars['Float']['output']>;
  quantity_requested?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "partner_order_customer_asset" */
export type Partner_Order_Customer_Asset_Var_Pop_Order_By = {
  quantity_dispensed?: InputMaybe<Order_By>;
  quantity_requested?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Partner_Order_Customer_Asset_Var_Samp_Fields = {
  __typename?: 'partner_order_customer_asset_var_samp_fields';
  quantity_dispensed?: Maybe<Scalars['Float']['output']>;
  quantity_requested?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "partner_order_customer_asset" */
export type Partner_Order_Customer_Asset_Var_Samp_Order_By = {
  quantity_dispensed?: InputMaybe<Order_By>;
  quantity_requested?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Partner_Order_Customer_Asset_Variance_Fields = {
  __typename?: 'partner_order_customer_asset_variance_fields';
  quantity_dispensed?: Maybe<Scalars['Float']['output']>;
  quantity_requested?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "partner_order_customer_asset" */
export type Partner_Order_Customer_Asset_Variance_Order_By = {
  quantity_dispensed?: InputMaybe<Order_By>;
  quantity_requested?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "partner_order" */
export type Partner_Order_Inc_Input = {
  affiliation_amount?: InputMaybe<Scalars['numeric']['input']>;
  amount?: InputMaybe<Scalars['numeric']['input']>;
  amount_paid?: InputMaybe<Scalars['numeric']['input']>;
  amount_to_be_paid?: InputMaybe<Scalars['numeric']['input']>;
  delivery_fee?: InputMaybe<Scalars['numeric']['input']>;
  order_code?: InputMaybe<Scalars['bigint']['input']>;
  service_tax?: InputMaybe<Scalars['numeric']['input']>;
  tax?: InputMaybe<Scalars['numeric']['input']>;
  voucher_discount?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "partner_order" */
export type Partner_Order_Insert_Input = {
  affiliation_amount?: InputMaybe<Scalars['numeric']['input']>;
  affiliation_user_id?: InputMaybe<Scalars['uuid']['input']>;
  amount?: InputMaybe<Scalars['numeric']['input']>;
  amount_paid?: InputMaybe<Scalars['numeric']['input']>;
  amount_to_be_paid?: InputMaybe<Scalars['numeric']['input']>;
  category?: InputMaybe<Order_Type_Enum>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  delivery_fee?: InputMaybe<Scalars['numeric']['input']>;
  fillup_requests?: InputMaybe<Fillup_Request_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  instruction?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_prepaid?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  order_code?: InputMaybe<Scalars['bigint']['input']>;
  order_type?: InputMaybe<Order_Type_Obj_Rel_Insert_Input>;
  organization_user?: InputMaybe<Organization_User_Obj_Rel_Insert_Input>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_address?: InputMaybe<Partner_Address_Obj_Rel_Insert_Input>;
  partner_address_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_order_customer_assets?: InputMaybe<Partner_Order_Customer_Asset_Arr_Rel_Insert_Input>;
  partner_order_items?: InputMaybe<Partner_Order_Item_Arr_Rel_Insert_Input>;
  partner_order_partner_user_documents?: InputMaybe<Partner_Order_Partner_User_Document_Arr_Rel_Insert_Input>;
  partner_order_state?: InputMaybe<Partner_Order_State_Obj_Rel_Insert_Input>;
  partner_order_stateflows?: InputMaybe<Partner_Order_Stateflow_Arr_Rel_Insert_Input>;
  partner_user?: InputMaybe<Partner_User_Obj_Rel_Insert_Input>;
  partner_user_id?: InputMaybe<Scalars['uuid']['input']>;
  po_id?: InputMaybe<Scalars['String']['input']>;
  service_tax?: InputMaybe<Scalars['numeric']['input']>;
  state?: InputMaybe<Partner_Order_State_Enum>;
  tax?: InputMaybe<Scalars['numeric']['input']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userByCreatedBy?: InputMaybe<User_Obj_Rel_Insert_Input>;
  voucher?: InputMaybe<Voucher_Obj_Rel_Insert_Input>;
  voucher_discount?: InputMaybe<Scalars['numeric']['input']>;
  voucher_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "partner_order_item" */
export type Partner_Order_Item = {
  __typename?: 'partner_order_item';
  actual_amount?: Maybe<Scalars['numeric']['output']>;
  actual_qty: Scalars['numeric']['output'];
  amount?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  customer_order_partner_orders: Array<Customer_Order_Partner_Order>;
  /** An aggregate relationship */
  customer_order_partner_orders_aggregate: Customer_Order_Partner_Order_Aggregate;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  partner?: Maybe<Partner>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  partner_order: Partner_Order;
  partner_order_id: Scalars['uuid']['output'];
  /** An array relationship */
  partner_order_item_commissions: Array<Partner_Order_Item_Commission>;
  /** An aggregate relationship */
  partner_order_item_commissions_aggregate: Partner_Order_Item_Commission_Aggregate;
  /** An object relationship */
  partner_order_item_state: Partner_Order_Item_State;
  /** An array relationship */
  partner_order_item_stateflows: Array<Partner_Order_Item_Stateflow>;
  /** An aggregate relationship */
  partner_order_item_stateflows_aggregate: Partner_Order_Item_Stateflow_Aggregate;
  /** An array relationship */
  partner_order_item_test_categories: Array<Partner_Order_Item_Test_Category>;
  /** An aggregate relationship */
  partner_order_item_test_categories_aggregate: Partner_Order_Item_Test_Category_Aggregate;
  /** An array relationship */
  partner_order_item_test_results: Array<Partner_Order_Item_Test_Results>;
  /** An aggregate relationship */
  partner_order_item_test_results_aggregate: Partner_Order_Item_Test_Results_Aggregate;
  /** An array relationship */
  partner_order_item_values: Array<Partner_Order_Item_Value>;
  /** An aggregate relationship */
  partner_order_item_values_aggregate: Partner_Order_Item_Value_Aggregate;
  /** An object relationship */
  partner_user?: Maybe<Partner_User>;
  partner_user_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  product_variation: Product_Variation;
  product_variation_id: Scalars['uuid']['output'];
  qty: Scalars['numeric']['output'];
  state: Partner_Order_Item_State_Enum;
  unit: Scalars['String']['output'];
  unit_price?: Maybe<Scalars['numeric']['output']>;
  voucher_discount?: Maybe<Scalars['numeric']['output']>;
};


/** columns and relationships of "partner_order_item" */
export type Partner_Order_ItemCustomer_Order_Partner_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Partner_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Partner_Order_Order_By>>;
  where?: InputMaybe<Customer_Order_Partner_Order_Bool_Exp>;
};


/** columns and relationships of "partner_order_item" */
export type Partner_Order_ItemCustomer_Order_Partner_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Partner_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Partner_Order_Order_By>>;
  where?: InputMaybe<Customer_Order_Partner_Order_Bool_Exp>;
};


/** columns and relationships of "partner_order_item" */
export type Partner_Order_ItemPartner_Order_Item_CommissionsArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Commission_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Commission_Bool_Exp>;
};


/** columns and relationships of "partner_order_item" */
export type Partner_Order_ItemPartner_Order_Item_Commissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Commission_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Commission_Bool_Exp>;
};


/** columns and relationships of "partner_order_item" */
export type Partner_Order_ItemPartner_Order_Item_StateflowsArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Stateflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Stateflow_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Stateflow_Bool_Exp>;
};


/** columns and relationships of "partner_order_item" */
export type Partner_Order_ItemPartner_Order_Item_Stateflows_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Stateflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Stateflow_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Stateflow_Bool_Exp>;
};


/** columns and relationships of "partner_order_item" */
export type Partner_Order_ItemPartner_Order_Item_Test_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Test_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Test_Category_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Test_Category_Bool_Exp>;
};


/** columns and relationships of "partner_order_item" */
export type Partner_Order_ItemPartner_Order_Item_Test_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Test_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Test_Category_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Test_Category_Bool_Exp>;
};


/** columns and relationships of "partner_order_item" */
export type Partner_Order_ItemPartner_Order_Item_Test_ResultsArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Test_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Test_Results_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Test_Results_Bool_Exp>;
};


/** columns and relationships of "partner_order_item" */
export type Partner_Order_ItemPartner_Order_Item_Test_Results_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Test_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Test_Results_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Test_Results_Bool_Exp>;
};


/** columns and relationships of "partner_order_item" */
export type Partner_Order_ItemPartner_Order_Item_ValuesArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Value_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Value_Bool_Exp>;
};


/** columns and relationships of "partner_order_item" */
export type Partner_Order_ItemPartner_Order_Item_Values_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Value_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Value_Bool_Exp>;
};

/** aggregated selection of "partner_order_item" */
export type Partner_Order_Item_Aggregate = {
  __typename?: 'partner_order_item_aggregate';
  aggregate?: Maybe<Partner_Order_Item_Aggregate_Fields>;
  nodes: Array<Partner_Order_Item>;
};

export type Partner_Order_Item_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Partner_Order_Item_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Partner_Order_Item_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Partner_Order_Item_Aggregate_Bool_Exp_Count>;
};

export type Partner_Order_Item_Aggregate_Bool_Exp_Bool_And = {
  arguments: Partner_Order_Item_Select_Column_Partner_Order_Item_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Order_Item_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_Order_Item_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Partner_Order_Item_Select_Column_Partner_Order_Item_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Order_Item_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_Order_Item_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Partner_Order_Item_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Order_Item_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "partner_order_item" */
export type Partner_Order_Item_Aggregate_Fields = {
  __typename?: 'partner_order_item_aggregate_fields';
  avg?: Maybe<Partner_Order_Item_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Partner_Order_Item_Max_Fields>;
  min?: Maybe<Partner_Order_Item_Min_Fields>;
  stddev?: Maybe<Partner_Order_Item_Stddev_Fields>;
  stddev_pop?: Maybe<Partner_Order_Item_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Partner_Order_Item_Stddev_Samp_Fields>;
  sum?: Maybe<Partner_Order_Item_Sum_Fields>;
  var_pop?: Maybe<Partner_Order_Item_Var_Pop_Fields>;
  var_samp?: Maybe<Partner_Order_Item_Var_Samp_Fields>;
  variance?: Maybe<Partner_Order_Item_Variance_Fields>;
};


/** aggregate fields of "partner_order_item" */
export type Partner_Order_Item_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Partner_Order_Item_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "partner_order_item" */
export type Partner_Order_Item_Aggregate_Order_By = {
  avg?: InputMaybe<Partner_Order_Item_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Partner_Order_Item_Max_Order_By>;
  min?: InputMaybe<Partner_Order_Item_Min_Order_By>;
  stddev?: InputMaybe<Partner_Order_Item_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Partner_Order_Item_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Partner_Order_Item_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Partner_Order_Item_Sum_Order_By>;
  var_pop?: InputMaybe<Partner_Order_Item_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Partner_Order_Item_Var_Samp_Order_By>;
  variance?: InputMaybe<Partner_Order_Item_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "partner_order_item" */
export type Partner_Order_Item_Arr_Rel_Insert_Input = {
  data: Array<Partner_Order_Item_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_Order_Item_On_Conflict>;
};

/** aggregate avg on columns */
export type Partner_Order_Item_Avg_Fields = {
  __typename?: 'partner_order_item_avg_fields';
  actual_amount?: Maybe<Scalars['Float']['output']>;
  actual_qty?: Maybe<Scalars['Float']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  unit_price?: Maybe<Scalars['Float']['output']>;
  voucher_discount?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "partner_order_item" */
export type Partner_Order_Item_Avg_Order_By = {
  actual_amount?: InputMaybe<Order_By>;
  actual_qty?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "partner_order_item". All fields are combined with a logical 'AND'. */
export type Partner_Order_Item_Bool_Exp = {
  _and?: InputMaybe<Array<Partner_Order_Item_Bool_Exp>>;
  _not?: InputMaybe<Partner_Order_Item_Bool_Exp>;
  _or?: InputMaybe<Array<Partner_Order_Item_Bool_Exp>>;
  actual_amount?: InputMaybe<Numeric_Comparison_Exp>;
  actual_qty?: InputMaybe<Numeric_Comparison_Exp>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_order_partner_orders?: InputMaybe<Customer_Order_Partner_Order_Bool_Exp>;
  customer_order_partner_orders_aggregate?: InputMaybe<Customer_Order_Partner_Order_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  partner?: InputMaybe<Partner_Bool_Exp>;
  partner_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner_order?: InputMaybe<Partner_Order_Bool_Exp>;
  partner_order_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner_order_item_commissions?: InputMaybe<Partner_Order_Item_Commission_Bool_Exp>;
  partner_order_item_commissions_aggregate?: InputMaybe<Partner_Order_Item_Commission_Aggregate_Bool_Exp>;
  partner_order_item_state?: InputMaybe<Partner_Order_Item_State_Bool_Exp>;
  partner_order_item_stateflows?: InputMaybe<Partner_Order_Item_Stateflow_Bool_Exp>;
  partner_order_item_stateflows_aggregate?: InputMaybe<Partner_Order_Item_Stateflow_Aggregate_Bool_Exp>;
  partner_order_item_test_categories?: InputMaybe<Partner_Order_Item_Test_Category_Bool_Exp>;
  partner_order_item_test_categories_aggregate?: InputMaybe<Partner_Order_Item_Test_Category_Aggregate_Bool_Exp>;
  partner_order_item_test_results?: InputMaybe<Partner_Order_Item_Test_Results_Bool_Exp>;
  partner_order_item_test_results_aggregate?: InputMaybe<Partner_Order_Item_Test_Results_Aggregate_Bool_Exp>;
  partner_order_item_values?: InputMaybe<Partner_Order_Item_Value_Bool_Exp>;
  partner_order_item_values_aggregate?: InputMaybe<Partner_Order_Item_Value_Aggregate_Bool_Exp>;
  partner_user?: InputMaybe<Partner_User_Bool_Exp>;
  partner_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  product_variation?: InputMaybe<Product_Variation_Bool_Exp>;
  product_variation_id?: InputMaybe<Uuid_Comparison_Exp>;
  qty?: InputMaybe<Numeric_Comparison_Exp>;
  state?: InputMaybe<Partner_Order_Item_State_Enum_Comparison_Exp>;
  unit?: InputMaybe<String_Comparison_Exp>;
  unit_price?: InputMaybe<Numeric_Comparison_Exp>;
  voucher_discount?: InputMaybe<Numeric_Comparison_Exp>;
};

/** columns and relationships of "partner_order_item_commission" */
export type Partner_Order_Item_Commission = {
  __typename?: 'partner_order_item_commission';
  affiliation_id: Scalars['uuid']['output'];
  amount?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  partner_commission_product_variation_type: Partner_Commission_Product_Variation_Type;
  partner_commission_product_variation_type_id: Scalars['uuid']['output'];
  /** An object relationship */
  partner_order_item: Partner_Order_Item;
  partner_order_item_id: Scalars['uuid']['output'];
  /** An object relationship */
  partner_user: Partner_User;
};

/** aggregated selection of "partner_order_item_commission" */
export type Partner_Order_Item_Commission_Aggregate = {
  __typename?: 'partner_order_item_commission_aggregate';
  aggregate?: Maybe<Partner_Order_Item_Commission_Aggregate_Fields>;
  nodes: Array<Partner_Order_Item_Commission>;
};

export type Partner_Order_Item_Commission_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Partner_Order_Item_Commission_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Partner_Order_Item_Commission_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Partner_Order_Item_Commission_Aggregate_Bool_Exp_Count>;
};

export type Partner_Order_Item_Commission_Aggregate_Bool_Exp_Bool_And = {
  arguments: Partner_Order_Item_Commission_Select_Column_Partner_Order_Item_Commission_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Order_Item_Commission_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_Order_Item_Commission_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Partner_Order_Item_Commission_Select_Column_Partner_Order_Item_Commission_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Order_Item_Commission_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_Order_Item_Commission_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Partner_Order_Item_Commission_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Order_Item_Commission_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "partner_order_item_commission" */
export type Partner_Order_Item_Commission_Aggregate_Fields = {
  __typename?: 'partner_order_item_commission_aggregate_fields';
  avg?: Maybe<Partner_Order_Item_Commission_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Partner_Order_Item_Commission_Max_Fields>;
  min?: Maybe<Partner_Order_Item_Commission_Min_Fields>;
  stddev?: Maybe<Partner_Order_Item_Commission_Stddev_Fields>;
  stddev_pop?: Maybe<Partner_Order_Item_Commission_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Partner_Order_Item_Commission_Stddev_Samp_Fields>;
  sum?: Maybe<Partner_Order_Item_Commission_Sum_Fields>;
  var_pop?: Maybe<Partner_Order_Item_Commission_Var_Pop_Fields>;
  var_samp?: Maybe<Partner_Order_Item_Commission_Var_Samp_Fields>;
  variance?: Maybe<Partner_Order_Item_Commission_Variance_Fields>;
};


/** aggregate fields of "partner_order_item_commission" */
export type Partner_Order_Item_Commission_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Partner_Order_Item_Commission_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "partner_order_item_commission" */
export type Partner_Order_Item_Commission_Aggregate_Order_By = {
  avg?: InputMaybe<Partner_Order_Item_Commission_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Partner_Order_Item_Commission_Max_Order_By>;
  min?: InputMaybe<Partner_Order_Item_Commission_Min_Order_By>;
  stddev?: InputMaybe<Partner_Order_Item_Commission_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Partner_Order_Item_Commission_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Partner_Order_Item_Commission_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Partner_Order_Item_Commission_Sum_Order_By>;
  var_pop?: InputMaybe<Partner_Order_Item_Commission_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Partner_Order_Item_Commission_Var_Samp_Order_By>;
  variance?: InputMaybe<Partner_Order_Item_Commission_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "partner_order_item_commission" */
export type Partner_Order_Item_Commission_Arr_Rel_Insert_Input = {
  data: Array<Partner_Order_Item_Commission_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_Order_Item_Commission_On_Conflict>;
};

/** aggregate avg on columns */
export type Partner_Order_Item_Commission_Avg_Fields = {
  __typename?: 'partner_order_item_commission_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "partner_order_item_commission" */
export type Partner_Order_Item_Commission_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "partner_order_item_commission". All fields are combined with a logical 'AND'. */
export type Partner_Order_Item_Commission_Bool_Exp = {
  _and?: InputMaybe<Array<Partner_Order_Item_Commission_Bool_Exp>>;
  _not?: InputMaybe<Partner_Order_Item_Commission_Bool_Exp>;
  _or?: InputMaybe<Array<Partner_Order_Item_Commission_Bool_Exp>>;
  affiliation_id?: InputMaybe<Uuid_Comparison_Exp>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  partner_commission_product_variation_type?: InputMaybe<Partner_Commission_Product_Variation_Type_Bool_Exp>;
  partner_commission_product_variation_type_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner_order_item?: InputMaybe<Partner_Order_Item_Bool_Exp>;
  partner_order_item_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner_user?: InputMaybe<Partner_User_Bool_Exp>;
};

/** unique or primary key constraints on table "partner_order_item_commission" */
export enum Partner_Order_Item_Commission_Constraint {
  /** unique or primary key constraint on columns "id" */
  PartnerOrderItemCommissionPkey = 'partner_order_item_commission_pkey'
}

/** input type for incrementing numeric columns in table "partner_order_item_commission" */
export type Partner_Order_Item_Commission_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "partner_order_item_commission" */
export type Partner_Order_Item_Commission_Insert_Input = {
  affiliation_id?: InputMaybe<Scalars['uuid']['input']>;
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_commission_product_variation_type?: InputMaybe<Partner_Commission_Product_Variation_Type_Obj_Rel_Insert_Input>;
  partner_commission_product_variation_type_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_order_item?: InputMaybe<Partner_Order_Item_Obj_Rel_Insert_Input>;
  partner_order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_user?: InputMaybe<Partner_User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Partner_Order_Item_Commission_Max_Fields = {
  __typename?: 'partner_order_item_commission_max_fields';
  affiliation_id?: Maybe<Scalars['uuid']['output']>;
  amount?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_commission_product_variation_type_id?: Maybe<Scalars['uuid']['output']>;
  partner_order_item_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "partner_order_item_commission" */
export type Partner_Order_Item_Commission_Max_Order_By = {
  affiliation_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_commission_product_variation_type_id?: InputMaybe<Order_By>;
  partner_order_item_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Partner_Order_Item_Commission_Min_Fields = {
  __typename?: 'partner_order_item_commission_min_fields';
  affiliation_id?: Maybe<Scalars['uuid']['output']>;
  amount?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_commission_product_variation_type_id?: Maybe<Scalars['uuid']['output']>;
  partner_order_item_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "partner_order_item_commission" */
export type Partner_Order_Item_Commission_Min_Order_By = {
  affiliation_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_commission_product_variation_type_id?: InputMaybe<Order_By>;
  partner_order_item_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "partner_order_item_commission" */
export type Partner_Order_Item_Commission_Mutation_Response = {
  __typename?: 'partner_order_item_commission_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Partner_Order_Item_Commission>;
};

/** on_conflict condition type for table "partner_order_item_commission" */
export type Partner_Order_Item_Commission_On_Conflict = {
  constraint: Partner_Order_Item_Commission_Constraint;
  update_columns?: Array<Partner_Order_Item_Commission_Update_Column>;
  where?: InputMaybe<Partner_Order_Item_Commission_Bool_Exp>;
};

/** Ordering options when selecting data from "partner_order_item_commission". */
export type Partner_Order_Item_Commission_Order_By = {
  affiliation_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_commission_product_variation_type?: InputMaybe<Partner_Commission_Product_Variation_Type_Order_By>;
  partner_commission_product_variation_type_id?: InputMaybe<Order_By>;
  partner_order_item?: InputMaybe<Partner_Order_Item_Order_By>;
  partner_order_item_id?: InputMaybe<Order_By>;
  partner_user?: InputMaybe<Partner_User_Order_By>;
};

/** primary key columns input for table: partner_order_item_commission */
export type Partner_Order_Item_Commission_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "partner_order_item_commission" */
export enum Partner_Order_Item_Commission_Select_Column {
  /** column name */
  AffiliationId = 'affiliation_id',
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerCommissionProductVariationTypeId = 'partner_commission_product_variation_type_id',
  /** column name */
  PartnerOrderItemId = 'partner_order_item_id'
}

/** select "partner_order_item_commission_aggregate_bool_exp_bool_and_arguments_columns" columns of table "partner_order_item_commission" */
export enum Partner_Order_Item_Commission_Select_Column_Partner_Order_Item_Commission_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "partner_order_item_commission_aggregate_bool_exp_bool_or_arguments_columns" columns of table "partner_order_item_commission" */
export enum Partner_Order_Item_Commission_Select_Column_Partner_Order_Item_Commission_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "partner_order_item_commission" */
export type Partner_Order_Item_Commission_Set_Input = {
  affiliation_id?: InputMaybe<Scalars['uuid']['input']>;
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_commission_product_variation_type_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_order_item_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Partner_Order_Item_Commission_Stddev_Fields = {
  __typename?: 'partner_order_item_commission_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "partner_order_item_commission" */
export type Partner_Order_Item_Commission_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Partner_Order_Item_Commission_Stddev_Pop_Fields = {
  __typename?: 'partner_order_item_commission_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "partner_order_item_commission" */
export type Partner_Order_Item_Commission_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Partner_Order_Item_Commission_Stddev_Samp_Fields = {
  __typename?: 'partner_order_item_commission_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "partner_order_item_commission" */
export type Partner_Order_Item_Commission_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "partner_order_item_commission" */
export type Partner_Order_Item_Commission_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Partner_Order_Item_Commission_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Partner_Order_Item_Commission_Stream_Cursor_Value_Input = {
  affiliation_id?: InputMaybe<Scalars['uuid']['input']>;
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_commission_product_variation_type_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_order_item_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Partner_Order_Item_Commission_Sum_Fields = {
  __typename?: 'partner_order_item_commission_sum_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "partner_order_item_commission" */
export type Partner_Order_Item_Commission_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** update columns of table "partner_order_item_commission" */
export enum Partner_Order_Item_Commission_Update_Column {
  /** column name */
  AffiliationId = 'affiliation_id',
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerCommissionProductVariationTypeId = 'partner_commission_product_variation_type_id',
  /** column name */
  PartnerOrderItemId = 'partner_order_item_id'
}

export type Partner_Order_Item_Commission_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Partner_Order_Item_Commission_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Partner_Order_Item_Commission_Set_Input>;
  /** filter the rows which have to be updated */
  where: Partner_Order_Item_Commission_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Partner_Order_Item_Commission_Var_Pop_Fields = {
  __typename?: 'partner_order_item_commission_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "partner_order_item_commission" */
export type Partner_Order_Item_Commission_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Partner_Order_Item_Commission_Var_Samp_Fields = {
  __typename?: 'partner_order_item_commission_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "partner_order_item_commission" */
export type Partner_Order_Item_Commission_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Partner_Order_Item_Commission_Variance_Fields = {
  __typename?: 'partner_order_item_commission_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "partner_order_item_commission" */
export type Partner_Order_Item_Commission_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "partner_order_item" */
export enum Partner_Order_Item_Constraint {
  /** unique or primary key constraint on columns "id" */
  PartnerOrderItemPkey = 'partner_order_item_pkey'
}

/** input type for incrementing numeric columns in table "partner_order_item" */
export type Partner_Order_Item_Inc_Input = {
  actual_amount?: InputMaybe<Scalars['numeric']['input']>;
  actual_qty?: InputMaybe<Scalars['numeric']['input']>;
  amount?: InputMaybe<Scalars['numeric']['input']>;
  qty?: InputMaybe<Scalars['numeric']['input']>;
  unit_price?: InputMaybe<Scalars['numeric']['input']>;
  voucher_discount?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "partner_order_item" */
export type Partner_Order_Item_Insert_Input = {
  actual_amount?: InputMaybe<Scalars['numeric']['input']>;
  actual_qty?: InputMaybe<Scalars['numeric']['input']>;
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_partner_orders?: InputMaybe<Customer_Order_Partner_Order_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner?: InputMaybe<Partner_Obj_Rel_Insert_Input>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_order?: InputMaybe<Partner_Order_Obj_Rel_Insert_Input>;
  partner_order_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_order_item_commissions?: InputMaybe<Partner_Order_Item_Commission_Arr_Rel_Insert_Input>;
  partner_order_item_state?: InputMaybe<Partner_Order_Item_State_Obj_Rel_Insert_Input>;
  partner_order_item_stateflows?: InputMaybe<Partner_Order_Item_Stateflow_Arr_Rel_Insert_Input>;
  partner_order_item_test_categories?: InputMaybe<Partner_Order_Item_Test_Category_Arr_Rel_Insert_Input>;
  partner_order_item_test_results?: InputMaybe<Partner_Order_Item_Test_Results_Arr_Rel_Insert_Input>;
  partner_order_item_values?: InputMaybe<Partner_Order_Item_Value_Arr_Rel_Insert_Input>;
  partner_user?: InputMaybe<Partner_User_Obj_Rel_Insert_Input>;
  partner_user_id?: InputMaybe<Scalars['uuid']['input']>;
  product_variation?: InputMaybe<Product_Variation_Obj_Rel_Insert_Input>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  qty?: InputMaybe<Scalars['numeric']['input']>;
  state?: InputMaybe<Partner_Order_Item_State_Enum>;
  unit?: InputMaybe<Scalars['String']['input']>;
  unit_price?: InputMaybe<Scalars['numeric']['input']>;
  voucher_discount?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Partner_Order_Item_Max_Fields = {
  __typename?: 'partner_order_item_max_fields';
  actual_amount?: Maybe<Scalars['numeric']['output']>;
  actual_qty?: Maybe<Scalars['numeric']['output']>;
  amount?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  partner_order_id?: Maybe<Scalars['uuid']['output']>;
  partner_user_id?: Maybe<Scalars['uuid']['output']>;
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
  qty?: Maybe<Scalars['numeric']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  unit_price?: Maybe<Scalars['numeric']['output']>;
  voucher_discount?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "partner_order_item" */
export type Partner_Order_Item_Max_Order_By = {
  actual_amount?: InputMaybe<Order_By>;
  actual_qty?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  partner_order_id?: InputMaybe<Order_By>;
  partner_user_id?: InputMaybe<Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  unit?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Partner_Order_Item_Min_Fields = {
  __typename?: 'partner_order_item_min_fields';
  actual_amount?: Maybe<Scalars['numeric']['output']>;
  actual_qty?: Maybe<Scalars['numeric']['output']>;
  amount?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  partner_order_id?: Maybe<Scalars['uuid']['output']>;
  partner_user_id?: Maybe<Scalars['uuid']['output']>;
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
  qty?: Maybe<Scalars['numeric']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  unit_price?: Maybe<Scalars['numeric']['output']>;
  voucher_discount?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "partner_order_item" */
export type Partner_Order_Item_Min_Order_By = {
  actual_amount?: InputMaybe<Order_By>;
  actual_qty?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  partner_order_id?: InputMaybe<Order_By>;
  partner_user_id?: InputMaybe<Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  unit?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "partner_order_item" */
export type Partner_Order_Item_Mutation_Response = {
  __typename?: 'partner_order_item_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Partner_Order_Item>;
};

/** input type for inserting object relation for remote table "partner_order_item" */
export type Partner_Order_Item_Obj_Rel_Insert_Input = {
  data: Partner_Order_Item_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_Order_Item_On_Conflict>;
};

/** on_conflict condition type for table "partner_order_item" */
export type Partner_Order_Item_On_Conflict = {
  constraint: Partner_Order_Item_Constraint;
  update_columns?: Array<Partner_Order_Item_Update_Column>;
  where?: InputMaybe<Partner_Order_Item_Bool_Exp>;
};

/** Ordering options when selecting data from "partner_order_item". */
export type Partner_Order_Item_Order_By = {
  actual_amount?: InputMaybe<Order_By>;
  actual_qty?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_order_partner_orders_aggregate?: InputMaybe<Customer_Order_Partner_Order_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner?: InputMaybe<Partner_Order_By>;
  partner_id?: InputMaybe<Order_By>;
  partner_order?: InputMaybe<Partner_Order_Order_By>;
  partner_order_id?: InputMaybe<Order_By>;
  partner_order_item_commissions_aggregate?: InputMaybe<Partner_Order_Item_Commission_Aggregate_Order_By>;
  partner_order_item_state?: InputMaybe<Partner_Order_Item_State_Order_By>;
  partner_order_item_stateflows_aggregate?: InputMaybe<Partner_Order_Item_Stateflow_Aggregate_Order_By>;
  partner_order_item_test_categories_aggregate?: InputMaybe<Partner_Order_Item_Test_Category_Aggregate_Order_By>;
  partner_order_item_test_results_aggregate?: InputMaybe<Partner_Order_Item_Test_Results_Aggregate_Order_By>;
  partner_order_item_values_aggregate?: InputMaybe<Partner_Order_Item_Value_Aggregate_Order_By>;
  partner_user?: InputMaybe<Partner_User_Order_By>;
  partner_user_id?: InputMaybe<Order_By>;
  product_variation?: InputMaybe<Product_Variation_Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  unit?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
};

/** primary key columns input for table: partner_order_item */
export type Partner_Order_Item_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "partner_order_item" */
export enum Partner_Order_Item_Select_Column {
  /** column name */
  ActualAmount = 'actual_amount',
  /** column name */
  ActualQty = 'actual_qty',
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  PartnerOrderId = 'partner_order_id',
  /** column name */
  PartnerUserId = 'partner_user_id',
  /** column name */
  ProductVariationId = 'product_variation_id',
  /** column name */
  Qty = 'qty',
  /** column name */
  State = 'state',
  /** column name */
  Unit = 'unit',
  /** column name */
  UnitPrice = 'unit_price',
  /** column name */
  VoucherDiscount = 'voucher_discount'
}

/** select "partner_order_item_aggregate_bool_exp_bool_and_arguments_columns" columns of table "partner_order_item" */
export enum Partner_Order_Item_Select_Column_Partner_Order_Item_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "partner_order_item_aggregate_bool_exp_bool_or_arguments_columns" columns of table "partner_order_item" */
export enum Partner_Order_Item_Select_Column_Partner_Order_Item_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "partner_order_item" */
export type Partner_Order_Item_Set_Input = {
  actual_amount?: InputMaybe<Scalars['numeric']['input']>;
  actual_qty?: InputMaybe<Scalars['numeric']['input']>;
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_order_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_user_id?: InputMaybe<Scalars['uuid']['input']>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  qty?: InputMaybe<Scalars['numeric']['input']>;
  state?: InputMaybe<Partner_Order_Item_State_Enum>;
  unit?: InputMaybe<Scalars['String']['input']>;
  unit_price?: InputMaybe<Scalars['numeric']['input']>;
  voucher_discount?: InputMaybe<Scalars['numeric']['input']>;
};

/** columns and relationships of "partner_order_item_state" */
export type Partner_Order_Item_State = {
  __typename?: 'partner_order_item_state';
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  partner_order_item_stateflows: Array<Partner_Order_Item_Stateflow>;
  /** An aggregate relationship */
  partner_order_item_stateflows_aggregate: Partner_Order_Item_Stateflow_Aggregate;
  /** An array relationship */
  partner_order_items: Array<Partner_Order_Item>;
  /** An aggregate relationship */
  partner_order_items_aggregate: Partner_Order_Item_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "partner_order_item_state" */
export type Partner_Order_Item_StatePartner_Order_Item_StateflowsArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Stateflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Stateflow_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Stateflow_Bool_Exp>;
};


/** columns and relationships of "partner_order_item_state" */
export type Partner_Order_Item_StatePartner_Order_Item_Stateflows_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Stateflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Stateflow_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Stateflow_Bool_Exp>;
};


/** columns and relationships of "partner_order_item_state" */
export type Partner_Order_Item_StatePartner_Order_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Bool_Exp>;
};


/** columns and relationships of "partner_order_item_state" */
export type Partner_Order_Item_StatePartner_Order_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Bool_Exp>;
};

/** aggregated selection of "partner_order_item_state" */
export type Partner_Order_Item_State_Aggregate = {
  __typename?: 'partner_order_item_state_aggregate';
  aggregate?: Maybe<Partner_Order_Item_State_Aggregate_Fields>;
  nodes: Array<Partner_Order_Item_State>;
};

/** aggregate fields of "partner_order_item_state" */
export type Partner_Order_Item_State_Aggregate_Fields = {
  __typename?: 'partner_order_item_state_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Partner_Order_Item_State_Max_Fields>;
  min?: Maybe<Partner_Order_Item_State_Min_Fields>;
};


/** aggregate fields of "partner_order_item_state" */
export type Partner_Order_Item_State_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Partner_Order_Item_State_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "partner_order_item_state". All fields are combined with a logical 'AND'. */
export type Partner_Order_Item_State_Bool_Exp = {
  _and?: InputMaybe<Array<Partner_Order_Item_State_Bool_Exp>>;
  _not?: InputMaybe<Partner_Order_Item_State_Bool_Exp>;
  _or?: InputMaybe<Array<Partner_Order_Item_State_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  partner_order_item_stateflows?: InputMaybe<Partner_Order_Item_Stateflow_Bool_Exp>;
  partner_order_item_stateflows_aggregate?: InputMaybe<Partner_Order_Item_Stateflow_Aggregate_Bool_Exp>;
  partner_order_items?: InputMaybe<Partner_Order_Item_Bool_Exp>;
  partner_order_items_aggregate?: InputMaybe<Partner_Order_Item_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "partner_order_item_state" */
export enum Partner_Order_Item_State_Constraint {
  /** unique or primary key constraint on columns "value" */
  PartnerOrderItemStatePkey = 'partner_order_item_state_pkey'
}

export enum Partner_Order_Item_State_Enum {
  /** when item accepted by franchise */
  Accepted = 'ACCEPTED',
  /** when task assigned to the driver vehicle */
  Assigned = 'ASSIGNED',
  /** when item is cancelled */
  Cancelled = 'CANCELLED',
  /** when order mark paid, order item status is confirmed */
  Confirmed = 'CONFIRMED',
  /** when item is delivered */
  Delivered = 'DELIVERED',
  /** when vehicle  is moving */
  InTransit = 'IN_TRANSIT',
  /** NO_SHOW */
  NoShow = 'NO_SHOW',
  /** when order create, order item status is pending */
  Pending = 'PENDING',
  /** when item is pickup */
  Pickup = 'PICKUP'
}

/** Boolean expression to compare columns of type "partner_order_item_state_enum". All fields are combined with logical 'AND'. */
export type Partner_Order_Item_State_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Partner_Order_Item_State_Enum>;
  _in?: InputMaybe<Array<Partner_Order_Item_State_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Partner_Order_Item_State_Enum>;
  _nin?: InputMaybe<Array<Partner_Order_Item_State_Enum>>;
};

/** input type for inserting data into table "partner_order_item_state" */
export type Partner_Order_Item_State_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  partner_order_item_stateflows?: InputMaybe<Partner_Order_Item_Stateflow_Arr_Rel_Insert_Input>;
  partner_order_items?: InputMaybe<Partner_Order_Item_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Partner_Order_Item_State_Max_Fields = {
  __typename?: 'partner_order_item_state_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Partner_Order_Item_State_Min_Fields = {
  __typename?: 'partner_order_item_state_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "partner_order_item_state" */
export type Partner_Order_Item_State_Mutation_Response = {
  __typename?: 'partner_order_item_state_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Partner_Order_Item_State>;
};

/** input type for inserting object relation for remote table "partner_order_item_state" */
export type Partner_Order_Item_State_Obj_Rel_Insert_Input = {
  data: Partner_Order_Item_State_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_Order_Item_State_On_Conflict>;
};

/** on_conflict condition type for table "partner_order_item_state" */
export type Partner_Order_Item_State_On_Conflict = {
  constraint: Partner_Order_Item_State_Constraint;
  update_columns?: Array<Partner_Order_Item_State_Update_Column>;
  where?: InputMaybe<Partner_Order_Item_State_Bool_Exp>;
};

/** Ordering options when selecting data from "partner_order_item_state". */
export type Partner_Order_Item_State_Order_By = {
  comment?: InputMaybe<Order_By>;
  partner_order_item_stateflows_aggregate?: InputMaybe<Partner_Order_Item_Stateflow_Aggregate_Order_By>;
  partner_order_items_aggregate?: InputMaybe<Partner_Order_Item_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: partner_order_item_state */
export type Partner_Order_Item_State_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "partner_order_item_state" */
export enum Partner_Order_Item_State_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "partner_order_item_state" */
export type Partner_Order_Item_State_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "partner_order_item_state" */
export type Partner_Order_Item_State_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Partner_Order_Item_State_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Partner_Order_Item_State_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "partner_order_item_state" */
export enum Partner_Order_Item_State_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Partner_Order_Item_State_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Partner_Order_Item_State_Set_Input>;
  /** filter the rows which have to be updated */
  where: Partner_Order_Item_State_Bool_Exp;
};

/** columns and relationships of "partner_order_item_stateflow" */
export type Partner_Order_Item_Stateflow = {
  __typename?: 'partner_order_item_stateflow';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  order_item_id: Scalars['uuid']['output'];
  /** An object relationship */
  partner_order_item: Partner_Order_Item;
  /** An object relationship */
  partner_order_item_state: Partner_Order_Item_State;
  /** An object relationship */
  partner_user: Partner_User;
  partner_user_id: Scalars['uuid']['output'];
  state: Partner_Order_Item_State_Enum;
};

/** aggregated selection of "partner_order_item_stateflow" */
export type Partner_Order_Item_Stateflow_Aggregate = {
  __typename?: 'partner_order_item_stateflow_aggregate';
  aggregate?: Maybe<Partner_Order_Item_Stateflow_Aggregate_Fields>;
  nodes: Array<Partner_Order_Item_Stateflow>;
};

export type Partner_Order_Item_Stateflow_Aggregate_Bool_Exp = {
  count?: InputMaybe<Partner_Order_Item_Stateflow_Aggregate_Bool_Exp_Count>;
};

export type Partner_Order_Item_Stateflow_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Partner_Order_Item_Stateflow_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Order_Item_Stateflow_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "partner_order_item_stateflow" */
export type Partner_Order_Item_Stateflow_Aggregate_Fields = {
  __typename?: 'partner_order_item_stateflow_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Partner_Order_Item_Stateflow_Max_Fields>;
  min?: Maybe<Partner_Order_Item_Stateflow_Min_Fields>;
};


/** aggregate fields of "partner_order_item_stateflow" */
export type Partner_Order_Item_Stateflow_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Partner_Order_Item_Stateflow_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "partner_order_item_stateflow" */
export type Partner_Order_Item_Stateflow_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Partner_Order_Item_Stateflow_Max_Order_By>;
  min?: InputMaybe<Partner_Order_Item_Stateflow_Min_Order_By>;
};

/** input type for inserting array relation for remote table "partner_order_item_stateflow" */
export type Partner_Order_Item_Stateflow_Arr_Rel_Insert_Input = {
  data: Array<Partner_Order_Item_Stateflow_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_Order_Item_Stateflow_On_Conflict>;
};

/** Boolean expression to filter rows from the table "partner_order_item_stateflow". All fields are combined with a logical 'AND'. */
export type Partner_Order_Item_Stateflow_Bool_Exp = {
  _and?: InputMaybe<Array<Partner_Order_Item_Stateflow_Bool_Exp>>;
  _not?: InputMaybe<Partner_Order_Item_Stateflow_Bool_Exp>;
  _or?: InputMaybe<Array<Partner_Order_Item_Stateflow_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  order_item_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner_order_item?: InputMaybe<Partner_Order_Item_Bool_Exp>;
  partner_order_item_state?: InputMaybe<Partner_Order_Item_State_Bool_Exp>;
  partner_user?: InputMaybe<Partner_User_Bool_Exp>;
  partner_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  state?: InputMaybe<Partner_Order_Item_State_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "partner_order_item_stateflow" */
export enum Partner_Order_Item_Stateflow_Constraint {
  /** unique or primary key constraint on columns "id" */
  PartnerOrderItemStateflowPkey = 'partner_order_item_stateflow_pkey'
}

/** input type for inserting data into table "partner_order_item_stateflow" */
export type Partner_Order_Item_Stateflow_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_order_item?: InputMaybe<Partner_Order_Item_Obj_Rel_Insert_Input>;
  partner_order_item_state?: InputMaybe<Partner_Order_Item_State_Obj_Rel_Insert_Input>;
  partner_user?: InputMaybe<Partner_User_Obj_Rel_Insert_Input>;
  partner_user_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Partner_Order_Item_State_Enum>;
};

/** aggregate max on columns */
export type Partner_Order_Item_Stateflow_Max_Fields = {
  __typename?: 'partner_order_item_stateflow_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  order_item_id?: Maybe<Scalars['uuid']['output']>;
  partner_user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "partner_order_item_stateflow" */
export type Partner_Order_Item_Stateflow_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  order_item_id?: InputMaybe<Order_By>;
  partner_user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Partner_Order_Item_Stateflow_Min_Fields = {
  __typename?: 'partner_order_item_stateflow_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  order_item_id?: Maybe<Scalars['uuid']['output']>;
  partner_user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "partner_order_item_stateflow" */
export type Partner_Order_Item_Stateflow_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  order_item_id?: InputMaybe<Order_By>;
  partner_user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "partner_order_item_stateflow" */
export type Partner_Order_Item_Stateflow_Mutation_Response = {
  __typename?: 'partner_order_item_stateflow_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Partner_Order_Item_Stateflow>;
};

/** on_conflict condition type for table "partner_order_item_stateflow" */
export type Partner_Order_Item_Stateflow_On_Conflict = {
  constraint: Partner_Order_Item_Stateflow_Constraint;
  update_columns?: Array<Partner_Order_Item_Stateflow_Update_Column>;
  where?: InputMaybe<Partner_Order_Item_Stateflow_Bool_Exp>;
};

/** Ordering options when selecting data from "partner_order_item_stateflow". */
export type Partner_Order_Item_Stateflow_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  order_item_id?: InputMaybe<Order_By>;
  partner_order_item?: InputMaybe<Partner_Order_Item_Order_By>;
  partner_order_item_state?: InputMaybe<Partner_Order_Item_State_Order_By>;
  partner_user?: InputMaybe<Partner_User_Order_By>;
  partner_user_id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
};

/** primary key columns input for table: partner_order_item_stateflow */
export type Partner_Order_Item_Stateflow_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "partner_order_item_stateflow" */
export enum Partner_Order_Item_Stateflow_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrderItemId = 'order_item_id',
  /** column name */
  PartnerUserId = 'partner_user_id',
  /** column name */
  State = 'state'
}

/** input type for updating data in table "partner_order_item_stateflow" */
export type Partner_Order_Item_Stateflow_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_user_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Partner_Order_Item_State_Enum>;
};

/** Streaming cursor of the table "partner_order_item_stateflow" */
export type Partner_Order_Item_Stateflow_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Partner_Order_Item_Stateflow_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Partner_Order_Item_Stateflow_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_user_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Partner_Order_Item_State_Enum>;
};

/** update columns of table "partner_order_item_stateflow" */
export enum Partner_Order_Item_Stateflow_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrderItemId = 'order_item_id',
  /** column name */
  PartnerUserId = 'partner_user_id',
  /** column name */
  State = 'state'
}

export type Partner_Order_Item_Stateflow_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Partner_Order_Item_Stateflow_Set_Input>;
  /** filter the rows which have to be updated */
  where: Partner_Order_Item_Stateflow_Bool_Exp;
};

/** aggregate stddev on columns */
export type Partner_Order_Item_Stddev_Fields = {
  __typename?: 'partner_order_item_stddev_fields';
  actual_amount?: Maybe<Scalars['Float']['output']>;
  actual_qty?: Maybe<Scalars['Float']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  unit_price?: Maybe<Scalars['Float']['output']>;
  voucher_discount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "partner_order_item" */
export type Partner_Order_Item_Stddev_Order_By = {
  actual_amount?: InputMaybe<Order_By>;
  actual_qty?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Partner_Order_Item_Stddev_Pop_Fields = {
  __typename?: 'partner_order_item_stddev_pop_fields';
  actual_amount?: Maybe<Scalars['Float']['output']>;
  actual_qty?: Maybe<Scalars['Float']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  unit_price?: Maybe<Scalars['Float']['output']>;
  voucher_discount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "partner_order_item" */
export type Partner_Order_Item_Stddev_Pop_Order_By = {
  actual_amount?: InputMaybe<Order_By>;
  actual_qty?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Partner_Order_Item_Stddev_Samp_Fields = {
  __typename?: 'partner_order_item_stddev_samp_fields';
  actual_amount?: Maybe<Scalars['Float']['output']>;
  actual_qty?: Maybe<Scalars['Float']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  unit_price?: Maybe<Scalars['Float']['output']>;
  voucher_discount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "partner_order_item" */
export type Partner_Order_Item_Stddev_Samp_Order_By = {
  actual_amount?: InputMaybe<Order_By>;
  actual_qty?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "partner_order_item" */
export type Partner_Order_Item_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Partner_Order_Item_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Partner_Order_Item_Stream_Cursor_Value_Input = {
  actual_amount?: InputMaybe<Scalars['numeric']['input']>;
  actual_qty?: InputMaybe<Scalars['numeric']['input']>;
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_order_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_user_id?: InputMaybe<Scalars['uuid']['input']>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  qty?: InputMaybe<Scalars['numeric']['input']>;
  state?: InputMaybe<Partner_Order_Item_State_Enum>;
  unit?: InputMaybe<Scalars['String']['input']>;
  unit_price?: InputMaybe<Scalars['numeric']['input']>;
  voucher_discount?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Partner_Order_Item_Sum_Fields = {
  __typename?: 'partner_order_item_sum_fields';
  actual_amount?: Maybe<Scalars['numeric']['output']>;
  actual_qty?: Maybe<Scalars['numeric']['output']>;
  amount?: Maybe<Scalars['numeric']['output']>;
  qty?: Maybe<Scalars['numeric']['output']>;
  unit_price?: Maybe<Scalars['numeric']['output']>;
  voucher_discount?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "partner_order_item" */
export type Partner_Order_Item_Sum_Order_By = {
  actual_amount?: InputMaybe<Order_By>;
  actual_qty?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
};

/** columns and relationships of "partner_order_item_test_category" */
export type Partner_Order_Item_Test_Category = {
  __typename?: 'partner_order_item_test_category';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  is_customer_allowed_skipped: Scalars['Boolean']['output'];
  is_customer_approved: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  partner_order_item: Partner_Order_Item;
  partner_order_item_id: Scalars['uuid']['output'];
  /** An object relationship */
  test_category: Test_Category;
  test_category_id: Scalars['uuid']['output'];
};

/** aggregated selection of "partner_order_item_test_category" */
export type Partner_Order_Item_Test_Category_Aggregate = {
  __typename?: 'partner_order_item_test_category_aggregate';
  aggregate?: Maybe<Partner_Order_Item_Test_Category_Aggregate_Fields>;
  nodes: Array<Partner_Order_Item_Test_Category>;
};

export type Partner_Order_Item_Test_Category_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Partner_Order_Item_Test_Category_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Partner_Order_Item_Test_Category_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Partner_Order_Item_Test_Category_Aggregate_Bool_Exp_Count>;
};

export type Partner_Order_Item_Test_Category_Aggregate_Bool_Exp_Bool_And = {
  arguments: Partner_Order_Item_Test_Category_Select_Column_Partner_Order_Item_Test_Category_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Order_Item_Test_Category_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_Order_Item_Test_Category_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Partner_Order_Item_Test_Category_Select_Column_Partner_Order_Item_Test_Category_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Order_Item_Test_Category_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_Order_Item_Test_Category_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Partner_Order_Item_Test_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Order_Item_Test_Category_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "partner_order_item_test_category" */
export type Partner_Order_Item_Test_Category_Aggregate_Fields = {
  __typename?: 'partner_order_item_test_category_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Partner_Order_Item_Test_Category_Max_Fields>;
  min?: Maybe<Partner_Order_Item_Test_Category_Min_Fields>;
};


/** aggregate fields of "partner_order_item_test_category" */
export type Partner_Order_Item_Test_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Partner_Order_Item_Test_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "partner_order_item_test_category" */
export type Partner_Order_Item_Test_Category_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Partner_Order_Item_Test_Category_Max_Order_By>;
  min?: InputMaybe<Partner_Order_Item_Test_Category_Min_Order_By>;
};

/** input type for inserting array relation for remote table "partner_order_item_test_category" */
export type Partner_Order_Item_Test_Category_Arr_Rel_Insert_Input = {
  data: Array<Partner_Order_Item_Test_Category_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_Order_Item_Test_Category_On_Conflict>;
};

/** Boolean expression to filter rows from the table "partner_order_item_test_category". All fields are combined with a logical 'AND'. */
export type Partner_Order_Item_Test_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Partner_Order_Item_Test_Category_Bool_Exp>>;
  _not?: InputMaybe<Partner_Order_Item_Test_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Partner_Order_Item_Test_Category_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_customer_allowed_skipped?: InputMaybe<Boolean_Comparison_Exp>;
  is_customer_approved?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  partner_order_item?: InputMaybe<Partner_Order_Item_Bool_Exp>;
  partner_order_item_id?: InputMaybe<Uuid_Comparison_Exp>;
  test_category?: InputMaybe<Test_Category_Bool_Exp>;
  test_category_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "partner_order_item_test_category" */
export enum Partner_Order_Item_Test_Category_Constraint {
  /** unique or primary key constraint on columns "id" */
  PartnerOrderItemTestCategoryPkey = 'partner_order_item_test_category_pkey'
}

/** input type for inserting data into table "partner_order_item_test_category" */
export type Partner_Order_Item_Test_Category_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_customer_allowed_skipped?: InputMaybe<Scalars['Boolean']['input']>;
  is_customer_approved?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_order_item?: InputMaybe<Partner_Order_Item_Obj_Rel_Insert_Input>;
  partner_order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  test_category?: InputMaybe<Test_Category_Obj_Rel_Insert_Input>;
  test_category_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Partner_Order_Item_Test_Category_Max_Fields = {
  __typename?: 'partner_order_item_test_category_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_order_item_id?: Maybe<Scalars['uuid']['output']>;
  test_category_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "partner_order_item_test_category" */
export type Partner_Order_Item_Test_Category_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_order_item_id?: InputMaybe<Order_By>;
  test_category_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Partner_Order_Item_Test_Category_Min_Fields = {
  __typename?: 'partner_order_item_test_category_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_order_item_id?: Maybe<Scalars['uuid']['output']>;
  test_category_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "partner_order_item_test_category" */
export type Partner_Order_Item_Test_Category_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_order_item_id?: InputMaybe<Order_By>;
  test_category_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "partner_order_item_test_category" */
export type Partner_Order_Item_Test_Category_Mutation_Response = {
  __typename?: 'partner_order_item_test_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Partner_Order_Item_Test_Category>;
};

/** on_conflict condition type for table "partner_order_item_test_category" */
export type Partner_Order_Item_Test_Category_On_Conflict = {
  constraint: Partner_Order_Item_Test_Category_Constraint;
  update_columns?: Array<Partner_Order_Item_Test_Category_Update_Column>;
  where?: InputMaybe<Partner_Order_Item_Test_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "partner_order_item_test_category". */
export type Partner_Order_Item_Test_Category_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_customer_allowed_skipped?: InputMaybe<Order_By>;
  is_customer_approved?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_order_item?: InputMaybe<Partner_Order_Item_Order_By>;
  partner_order_item_id?: InputMaybe<Order_By>;
  test_category?: InputMaybe<Test_Category_Order_By>;
  test_category_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: partner_order_item_test_category */
export type Partner_Order_Item_Test_Category_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "partner_order_item_test_category" */
export enum Partner_Order_Item_Test_Category_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsCustomerAllowedSkipped = 'is_customer_allowed_skipped',
  /** column name */
  IsCustomerApproved = 'is_customer_approved',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerOrderItemId = 'partner_order_item_id',
  /** column name */
  TestCategoryId = 'test_category_id'
}

/** select "partner_order_item_test_category_aggregate_bool_exp_bool_and_arguments_columns" columns of table "partner_order_item_test_category" */
export enum Partner_Order_Item_Test_Category_Select_Column_Partner_Order_Item_Test_Category_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsCustomerAllowedSkipped = 'is_customer_allowed_skipped',
  /** column name */
  IsCustomerApproved = 'is_customer_approved'
}

/** select "partner_order_item_test_category_aggregate_bool_exp_bool_or_arguments_columns" columns of table "partner_order_item_test_category" */
export enum Partner_Order_Item_Test_Category_Select_Column_Partner_Order_Item_Test_Category_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsCustomerAllowedSkipped = 'is_customer_allowed_skipped',
  /** column name */
  IsCustomerApproved = 'is_customer_approved'
}

/** input type for updating data in table "partner_order_item_test_category" */
export type Partner_Order_Item_Test_Category_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_customer_allowed_skipped?: InputMaybe<Scalars['Boolean']['input']>;
  is_customer_approved?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  test_category_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "partner_order_item_test_category" */
export type Partner_Order_Item_Test_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Partner_Order_Item_Test_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Partner_Order_Item_Test_Category_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_customer_allowed_skipped?: InputMaybe<Scalars['Boolean']['input']>;
  is_customer_approved?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  test_category_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "partner_order_item_test_category" */
export enum Partner_Order_Item_Test_Category_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsCustomerAllowedSkipped = 'is_customer_allowed_skipped',
  /** column name */
  IsCustomerApproved = 'is_customer_approved',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerOrderItemId = 'partner_order_item_id',
  /** column name */
  TestCategoryId = 'test_category_id'
}

export type Partner_Order_Item_Test_Category_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Partner_Order_Item_Test_Category_Set_Input>;
  /** filter the rows which have to be updated */
  where: Partner_Order_Item_Test_Category_Bool_Exp;
};

/** columns and relationships of "partner_order_item_test_results" */
export type Partner_Order_Item_Test_Results = {
  __typename?: 'partner_order_item_test_results';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  is_passed?: Maybe<Scalars['Boolean']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  partner_order_item: Partner_Order_Item;
  partner_order_item_id: Scalars['uuid']['output'];
  /** An array relationship */
  partner_order_item_test_results_photos: Array<Partner_Order_Item_Test_Results_Photos>;
  /** An aggregate relationship */
  partner_order_item_test_results_photos_aggregate: Partner_Order_Item_Test_Results_Photos_Aggregate;
  /** An object relationship */
  test: Test;
  test_id: Scalars['uuid']['output'];
  value?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "partner_order_item_test_results" */
export type Partner_Order_Item_Test_ResultsPartner_Order_Item_Test_Results_PhotosArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Test_Results_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Test_Results_Photos_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Test_Results_Photos_Bool_Exp>;
};


/** columns and relationships of "partner_order_item_test_results" */
export type Partner_Order_Item_Test_ResultsPartner_Order_Item_Test_Results_Photos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Test_Results_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Test_Results_Photos_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Test_Results_Photos_Bool_Exp>;
};

/** aggregated selection of "partner_order_item_test_results" */
export type Partner_Order_Item_Test_Results_Aggregate = {
  __typename?: 'partner_order_item_test_results_aggregate';
  aggregate?: Maybe<Partner_Order_Item_Test_Results_Aggregate_Fields>;
  nodes: Array<Partner_Order_Item_Test_Results>;
};

export type Partner_Order_Item_Test_Results_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Partner_Order_Item_Test_Results_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Partner_Order_Item_Test_Results_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Partner_Order_Item_Test_Results_Aggregate_Bool_Exp_Count>;
};

export type Partner_Order_Item_Test_Results_Aggregate_Bool_Exp_Bool_And = {
  arguments: Partner_Order_Item_Test_Results_Select_Column_Partner_Order_Item_Test_Results_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Order_Item_Test_Results_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_Order_Item_Test_Results_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Partner_Order_Item_Test_Results_Select_Column_Partner_Order_Item_Test_Results_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Order_Item_Test_Results_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_Order_Item_Test_Results_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Partner_Order_Item_Test_Results_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Order_Item_Test_Results_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "partner_order_item_test_results" */
export type Partner_Order_Item_Test_Results_Aggregate_Fields = {
  __typename?: 'partner_order_item_test_results_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Partner_Order_Item_Test_Results_Max_Fields>;
  min?: Maybe<Partner_Order_Item_Test_Results_Min_Fields>;
};


/** aggregate fields of "partner_order_item_test_results" */
export type Partner_Order_Item_Test_Results_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Partner_Order_Item_Test_Results_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "partner_order_item_test_results" */
export type Partner_Order_Item_Test_Results_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Partner_Order_Item_Test_Results_Max_Order_By>;
  min?: InputMaybe<Partner_Order_Item_Test_Results_Min_Order_By>;
};

/** input type for inserting array relation for remote table "partner_order_item_test_results" */
export type Partner_Order_Item_Test_Results_Arr_Rel_Insert_Input = {
  data: Array<Partner_Order_Item_Test_Results_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_Order_Item_Test_Results_On_Conflict>;
};

/** Boolean expression to filter rows from the table "partner_order_item_test_results". All fields are combined with a logical 'AND'. */
export type Partner_Order_Item_Test_Results_Bool_Exp = {
  _and?: InputMaybe<Array<Partner_Order_Item_Test_Results_Bool_Exp>>;
  _not?: InputMaybe<Partner_Order_Item_Test_Results_Bool_Exp>;
  _or?: InputMaybe<Array<Partner_Order_Item_Test_Results_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_passed?: InputMaybe<Boolean_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  partner_order_item?: InputMaybe<Partner_Order_Item_Bool_Exp>;
  partner_order_item_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner_order_item_test_results_photos?: InputMaybe<Partner_Order_Item_Test_Results_Photos_Bool_Exp>;
  partner_order_item_test_results_photos_aggregate?: InputMaybe<Partner_Order_Item_Test_Results_Photos_Aggregate_Bool_Exp>;
  test?: InputMaybe<Test_Bool_Exp>;
  test_id?: InputMaybe<Uuid_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "partner_order_item_test_results" */
export enum Partner_Order_Item_Test_Results_Constraint {
  /** unique or primary key constraint on columns "id" */
  PartnerOrderItemTestResultsPkey = 'partner_order_item_test_results_pkey'
}

/** input type for inserting data into table "partner_order_item_test_results" */
export type Partner_Order_Item_Test_Results_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_passed?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_order_item?: InputMaybe<Partner_Order_Item_Obj_Rel_Insert_Input>;
  partner_order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_order_item_test_results_photos?: InputMaybe<Partner_Order_Item_Test_Results_Photos_Arr_Rel_Insert_Input>;
  test?: InputMaybe<Test_Obj_Rel_Insert_Input>;
  test_id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Partner_Order_Item_Test_Results_Max_Fields = {
  __typename?: 'partner_order_item_test_results_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_order_item_id?: Maybe<Scalars['uuid']['output']>;
  test_id?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "partner_order_item_test_results" */
export type Partner_Order_Item_Test_Results_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_order_item_id?: InputMaybe<Order_By>;
  test_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Partner_Order_Item_Test_Results_Min_Fields = {
  __typename?: 'partner_order_item_test_results_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_order_item_id?: Maybe<Scalars['uuid']['output']>;
  test_id?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "partner_order_item_test_results" */
export type Partner_Order_Item_Test_Results_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_order_item_id?: InputMaybe<Order_By>;
  test_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "partner_order_item_test_results" */
export type Partner_Order_Item_Test_Results_Mutation_Response = {
  __typename?: 'partner_order_item_test_results_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Partner_Order_Item_Test_Results>;
};

/** input type for inserting object relation for remote table "partner_order_item_test_results" */
export type Partner_Order_Item_Test_Results_Obj_Rel_Insert_Input = {
  data: Partner_Order_Item_Test_Results_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_Order_Item_Test_Results_On_Conflict>;
};

/** on_conflict condition type for table "partner_order_item_test_results" */
export type Partner_Order_Item_Test_Results_On_Conflict = {
  constraint: Partner_Order_Item_Test_Results_Constraint;
  update_columns?: Array<Partner_Order_Item_Test_Results_Update_Column>;
  where?: InputMaybe<Partner_Order_Item_Test_Results_Bool_Exp>;
};

/** Ordering options when selecting data from "partner_order_item_test_results". */
export type Partner_Order_Item_Test_Results_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_passed?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_order_item?: InputMaybe<Partner_Order_Item_Order_By>;
  partner_order_item_id?: InputMaybe<Order_By>;
  partner_order_item_test_results_photos_aggregate?: InputMaybe<Partner_Order_Item_Test_Results_Photos_Aggregate_Order_By>;
  test?: InputMaybe<Test_Order_By>;
  test_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** columns and relationships of "partner_order_item_test_results_photos" */
export type Partner_Order_Item_Test_Results_Photos = {
  __typename?: 'partner_order_item_test_results_photos';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  partner_order_item_test_result: Partner_Order_Item_Test_Results;
  partner_order_item_test_results_id: Scalars['uuid']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "partner_order_item_test_results_photos" */
export type Partner_Order_Item_Test_Results_Photos_Aggregate = {
  __typename?: 'partner_order_item_test_results_photos_aggregate';
  aggregate?: Maybe<Partner_Order_Item_Test_Results_Photos_Aggregate_Fields>;
  nodes: Array<Partner_Order_Item_Test_Results_Photos>;
};

export type Partner_Order_Item_Test_Results_Photos_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Partner_Order_Item_Test_Results_Photos_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Partner_Order_Item_Test_Results_Photos_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Partner_Order_Item_Test_Results_Photos_Aggregate_Bool_Exp_Count>;
};

export type Partner_Order_Item_Test_Results_Photos_Aggregate_Bool_Exp_Bool_And = {
  arguments: Partner_Order_Item_Test_Results_Photos_Select_Column_Partner_Order_Item_Test_Results_Photos_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Order_Item_Test_Results_Photos_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_Order_Item_Test_Results_Photos_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Partner_Order_Item_Test_Results_Photos_Select_Column_Partner_Order_Item_Test_Results_Photos_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Order_Item_Test_Results_Photos_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_Order_Item_Test_Results_Photos_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Partner_Order_Item_Test_Results_Photos_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Order_Item_Test_Results_Photos_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "partner_order_item_test_results_photos" */
export type Partner_Order_Item_Test_Results_Photos_Aggregate_Fields = {
  __typename?: 'partner_order_item_test_results_photos_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Partner_Order_Item_Test_Results_Photos_Max_Fields>;
  min?: Maybe<Partner_Order_Item_Test_Results_Photos_Min_Fields>;
};


/** aggregate fields of "partner_order_item_test_results_photos" */
export type Partner_Order_Item_Test_Results_Photos_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Partner_Order_Item_Test_Results_Photos_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "partner_order_item_test_results_photos" */
export type Partner_Order_Item_Test_Results_Photos_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Partner_Order_Item_Test_Results_Photos_Max_Order_By>;
  min?: InputMaybe<Partner_Order_Item_Test_Results_Photos_Min_Order_By>;
};

/** input type for inserting array relation for remote table "partner_order_item_test_results_photos" */
export type Partner_Order_Item_Test_Results_Photos_Arr_Rel_Insert_Input = {
  data: Array<Partner_Order_Item_Test_Results_Photos_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_Order_Item_Test_Results_Photos_On_Conflict>;
};

/** Boolean expression to filter rows from the table "partner_order_item_test_results_photos". All fields are combined with a logical 'AND'. */
export type Partner_Order_Item_Test_Results_Photos_Bool_Exp = {
  _and?: InputMaybe<Array<Partner_Order_Item_Test_Results_Photos_Bool_Exp>>;
  _not?: InputMaybe<Partner_Order_Item_Test_Results_Photos_Bool_Exp>;
  _or?: InputMaybe<Array<Partner_Order_Item_Test_Results_Photos_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  partner_order_item_test_result?: InputMaybe<Partner_Order_Item_Test_Results_Bool_Exp>;
  partner_order_item_test_results_id?: InputMaybe<Uuid_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "partner_order_item_test_results_photos" */
export enum Partner_Order_Item_Test_Results_Photos_Constraint {
  /** unique or primary key constraint on columns "id" */
  PartnerOrderItemTestResultsPhotosPkey = 'partner_order_item_test_results_photos_pkey'
}

/** input type for inserting data into table "partner_order_item_test_results_photos" */
export type Partner_Order_Item_Test_Results_Photos_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_order_item_test_result?: InputMaybe<Partner_Order_Item_Test_Results_Obj_Rel_Insert_Input>;
  partner_order_item_test_results_id?: InputMaybe<Scalars['uuid']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Partner_Order_Item_Test_Results_Photos_Max_Fields = {
  __typename?: 'partner_order_item_test_results_photos_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_order_item_test_results_id?: Maybe<Scalars['uuid']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "partner_order_item_test_results_photos" */
export type Partner_Order_Item_Test_Results_Photos_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_order_item_test_results_id?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Partner_Order_Item_Test_Results_Photos_Min_Fields = {
  __typename?: 'partner_order_item_test_results_photos_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_order_item_test_results_id?: Maybe<Scalars['uuid']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "partner_order_item_test_results_photos" */
export type Partner_Order_Item_Test_Results_Photos_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_order_item_test_results_id?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "partner_order_item_test_results_photos" */
export type Partner_Order_Item_Test_Results_Photos_Mutation_Response = {
  __typename?: 'partner_order_item_test_results_photos_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Partner_Order_Item_Test_Results_Photos>;
};

/** on_conflict condition type for table "partner_order_item_test_results_photos" */
export type Partner_Order_Item_Test_Results_Photos_On_Conflict = {
  constraint: Partner_Order_Item_Test_Results_Photos_Constraint;
  update_columns?: Array<Partner_Order_Item_Test_Results_Photos_Update_Column>;
  where?: InputMaybe<Partner_Order_Item_Test_Results_Photos_Bool_Exp>;
};

/** Ordering options when selecting data from "partner_order_item_test_results_photos". */
export type Partner_Order_Item_Test_Results_Photos_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_order_item_test_result?: InputMaybe<Partner_Order_Item_Test_Results_Order_By>;
  partner_order_item_test_results_id?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: partner_order_item_test_results_photos */
export type Partner_Order_Item_Test_Results_Photos_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "partner_order_item_test_results_photos" */
export enum Partner_Order_Item_Test_Results_Photos_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerOrderItemTestResultsId = 'partner_order_item_test_results_id',
  /** column name */
  Url = 'url'
}

/** select "partner_order_item_test_results_photos_aggregate_bool_exp_bool_and_arguments_columns" columns of table "partner_order_item_test_results_photos" */
export enum Partner_Order_Item_Test_Results_Photos_Select_Column_Partner_Order_Item_Test_Results_Photos_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "partner_order_item_test_results_photos_aggregate_bool_exp_bool_or_arguments_columns" columns of table "partner_order_item_test_results_photos" */
export enum Partner_Order_Item_Test_Results_Photos_Select_Column_Partner_Order_Item_Test_Results_Photos_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "partner_order_item_test_results_photos" */
export type Partner_Order_Item_Test_Results_Photos_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_order_item_test_results_id?: InputMaybe<Scalars['uuid']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "partner_order_item_test_results_photos" */
export type Partner_Order_Item_Test_Results_Photos_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Partner_Order_Item_Test_Results_Photos_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Partner_Order_Item_Test_Results_Photos_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_order_item_test_results_id?: InputMaybe<Scalars['uuid']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "partner_order_item_test_results_photos" */
export enum Partner_Order_Item_Test_Results_Photos_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerOrderItemTestResultsId = 'partner_order_item_test_results_id',
  /** column name */
  Url = 'url'
}

export type Partner_Order_Item_Test_Results_Photos_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Partner_Order_Item_Test_Results_Photos_Set_Input>;
  /** filter the rows which have to be updated */
  where: Partner_Order_Item_Test_Results_Photos_Bool_Exp;
};

/** primary key columns input for table: partner_order_item_test_results */
export type Partner_Order_Item_Test_Results_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "partner_order_item_test_results" */
export enum Partner_Order_Item_Test_Results_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsPassed = 'is_passed',
  /** column name */
  Key = 'key',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerOrderItemId = 'partner_order_item_id',
  /** column name */
  TestId = 'test_id',
  /** column name */
  Value = 'value'
}

/** select "partner_order_item_test_results_aggregate_bool_exp_bool_and_arguments_columns" columns of table "partner_order_item_test_results" */
export enum Partner_Order_Item_Test_Results_Select_Column_Partner_Order_Item_Test_Results_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsPassed = 'is_passed'
}

/** select "partner_order_item_test_results_aggregate_bool_exp_bool_or_arguments_columns" columns of table "partner_order_item_test_results" */
export enum Partner_Order_Item_Test_Results_Select_Column_Partner_Order_Item_Test_Results_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsPassed = 'is_passed'
}

/** input type for updating data in table "partner_order_item_test_results" */
export type Partner_Order_Item_Test_Results_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_passed?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  test_id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "partner_order_item_test_results" */
export type Partner_Order_Item_Test_Results_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Partner_Order_Item_Test_Results_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Partner_Order_Item_Test_Results_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_passed?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  test_id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "partner_order_item_test_results" */
export enum Partner_Order_Item_Test_Results_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsPassed = 'is_passed',
  /** column name */
  Key = 'key',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerOrderItemId = 'partner_order_item_id',
  /** column name */
  TestId = 'test_id',
  /** column name */
  Value = 'value'
}

export type Partner_Order_Item_Test_Results_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Partner_Order_Item_Test_Results_Set_Input>;
  /** filter the rows which have to be updated */
  where: Partner_Order_Item_Test_Results_Bool_Exp;
};

/** update columns of table "partner_order_item" */
export enum Partner_Order_Item_Update_Column {
  /** column name */
  ActualAmount = 'actual_amount',
  /** column name */
  ActualQty = 'actual_qty',
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  PartnerOrderId = 'partner_order_id',
  /** column name */
  PartnerUserId = 'partner_user_id',
  /** column name */
  ProductVariationId = 'product_variation_id',
  /** column name */
  Qty = 'qty',
  /** column name */
  State = 'state',
  /** column name */
  Unit = 'unit',
  /** column name */
  UnitPrice = 'unit_price',
  /** column name */
  VoucherDiscount = 'voucher_discount'
}

export type Partner_Order_Item_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Partner_Order_Item_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Partner_Order_Item_Set_Input>;
  /** filter the rows which have to be updated */
  where: Partner_Order_Item_Bool_Exp;
};

/** columns and relationships of "partner_order_item_value" */
export type Partner_Order_Item_Value = {
  __typename?: 'partner_order_item_value';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  partner_order_item: Partner_Order_Item;
  partner_order_item_id: Scalars['uuid']['output'];
  url?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "partner_order_item_value" */
export type Partner_Order_Item_Value_Aggregate = {
  __typename?: 'partner_order_item_value_aggregate';
  aggregate?: Maybe<Partner_Order_Item_Value_Aggregate_Fields>;
  nodes: Array<Partner_Order_Item_Value>;
};

export type Partner_Order_Item_Value_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Partner_Order_Item_Value_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Partner_Order_Item_Value_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Partner_Order_Item_Value_Aggregate_Bool_Exp_Count>;
};

export type Partner_Order_Item_Value_Aggregate_Bool_Exp_Bool_And = {
  arguments: Partner_Order_Item_Value_Select_Column_Partner_Order_Item_Value_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Order_Item_Value_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_Order_Item_Value_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Partner_Order_Item_Value_Select_Column_Partner_Order_Item_Value_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Order_Item_Value_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_Order_Item_Value_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Partner_Order_Item_Value_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Order_Item_Value_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "partner_order_item_value" */
export type Partner_Order_Item_Value_Aggregate_Fields = {
  __typename?: 'partner_order_item_value_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Partner_Order_Item_Value_Max_Fields>;
  min?: Maybe<Partner_Order_Item_Value_Min_Fields>;
};


/** aggregate fields of "partner_order_item_value" */
export type Partner_Order_Item_Value_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Partner_Order_Item_Value_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "partner_order_item_value" */
export type Partner_Order_Item_Value_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Partner_Order_Item_Value_Max_Order_By>;
  min?: InputMaybe<Partner_Order_Item_Value_Min_Order_By>;
};

/** input type for inserting array relation for remote table "partner_order_item_value" */
export type Partner_Order_Item_Value_Arr_Rel_Insert_Input = {
  data: Array<Partner_Order_Item_Value_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_Order_Item_Value_On_Conflict>;
};

/** Boolean expression to filter rows from the table "partner_order_item_value". All fields are combined with a logical 'AND'. */
export type Partner_Order_Item_Value_Bool_Exp = {
  _and?: InputMaybe<Array<Partner_Order_Item_Value_Bool_Exp>>;
  _not?: InputMaybe<Partner_Order_Item_Value_Bool_Exp>;
  _or?: InputMaybe<Array<Partner_Order_Item_Value_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  partner_order_item?: InputMaybe<Partner_Order_Item_Bool_Exp>;
  partner_order_item_id?: InputMaybe<Uuid_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "partner_order_item_value" */
export enum Partner_Order_Item_Value_Constraint {
  /** unique or primary key constraint on columns "id" */
  PartnerOrderItemValuePkey = 'partner_order_item_value_pkey'
}

/** input type for inserting data into table "partner_order_item_value" */
export type Partner_Order_Item_Value_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_order_item?: InputMaybe<Partner_Order_Item_Obj_Rel_Insert_Input>;
  partner_order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Partner_Order_Item_Value_Max_Fields = {
  __typename?: 'partner_order_item_value_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_order_item_id?: Maybe<Scalars['uuid']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "partner_order_item_value" */
export type Partner_Order_Item_Value_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_order_item_id?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Partner_Order_Item_Value_Min_Fields = {
  __typename?: 'partner_order_item_value_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_order_item_id?: Maybe<Scalars['uuid']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "partner_order_item_value" */
export type Partner_Order_Item_Value_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_order_item_id?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "partner_order_item_value" */
export type Partner_Order_Item_Value_Mutation_Response = {
  __typename?: 'partner_order_item_value_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Partner_Order_Item_Value>;
};

/** on_conflict condition type for table "partner_order_item_value" */
export type Partner_Order_Item_Value_On_Conflict = {
  constraint: Partner_Order_Item_Value_Constraint;
  update_columns?: Array<Partner_Order_Item_Value_Update_Column>;
  where?: InputMaybe<Partner_Order_Item_Value_Bool_Exp>;
};

/** Ordering options when selecting data from "partner_order_item_value". */
export type Partner_Order_Item_Value_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_order_item?: InputMaybe<Partner_Order_Item_Order_By>;
  partner_order_item_id?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: partner_order_item_value */
export type Partner_Order_Item_Value_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "partner_order_item_value" */
export enum Partner_Order_Item_Value_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Key = 'key',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerOrderItemId = 'partner_order_item_id',
  /** column name */
  Url = 'url',
  /** column name */
  Value = 'value'
}

/** select "partner_order_item_value_aggregate_bool_exp_bool_and_arguments_columns" columns of table "partner_order_item_value" */
export enum Partner_Order_Item_Value_Select_Column_Partner_Order_Item_Value_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "partner_order_item_value_aggregate_bool_exp_bool_or_arguments_columns" columns of table "partner_order_item_value" */
export enum Partner_Order_Item_Value_Select_Column_Partner_Order_Item_Value_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "partner_order_item_value" */
export type Partner_Order_Item_Value_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "partner_order_item_value" */
export type Partner_Order_Item_Value_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Partner_Order_Item_Value_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Partner_Order_Item_Value_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "partner_order_item_value" */
export enum Partner_Order_Item_Value_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Key = 'key',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerOrderItemId = 'partner_order_item_id',
  /** column name */
  Url = 'url',
  /** column name */
  Value = 'value'
}

export type Partner_Order_Item_Value_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Partner_Order_Item_Value_Set_Input>;
  /** filter the rows which have to be updated */
  where: Partner_Order_Item_Value_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Partner_Order_Item_Var_Pop_Fields = {
  __typename?: 'partner_order_item_var_pop_fields';
  actual_amount?: Maybe<Scalars['Float']['output']>;
  actual_qty?: Maybe<Scalars['Float']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  unit_price?: Maybe<Scalars['Float']['output']>;
  voucher_discount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "partner_order_item" */
export type Partner_Order_Item_Var_Pop_Order_By = {
  actual_amount?: InputMaybe<Order_By>;
  actual_qty?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Partner_Order_Item_Var_Samp_Fields = {
  __typename?: 'partner_order_item_var_samp_fields';
  actual_amount?: Maybe<Scalars['Float']['output']>;
  actual_qty?: Maybe<Scalars['Float']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  unit_price?: Maybe<Scalars['Float']['output']>;
  voucher_discount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "partner_order_item" */
export type Partner_Order_Item_Var_Samp_Order_By = {
  actual_amount?: InputMaybe<Order_By>;
  actual_qty?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Partner_Order_Item_Variance_Fields = {
  __typename?: 'partner_order_item_variance_fields';
  actual_amount?: Maybe<Scalars['Float']['output']>;
  actual_qty?: Maybe<Scalars['Float']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  unit_price?: Maybe<Scalars['Float']['output']>;
  voucher_discount?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "partner_order_item" */
export type Partner_Order_Item_Variance_Order_By = {
  actual_amount?: InputMaybe<Order_By>;
  actual_qty?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Partner_Order_Max_Fields = {
  __typename?: 'partner_order_max_fields';
  affiliation_amount?: Maybe<Scalars['numeric']['output']>;
  affiliation_user_id?: Maybe<Scalars['uuid']['output']>;
  amount?: Maybe<Scalars['numeric']['output']>;
  amount_paid?: Maybe<Scalars['numeric']['output']>;
  amount_to_be_paid?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  delivery_fee?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  instruction?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  order_code?: Maybe<Scalars['bigint']['output']>;
  organization_user_id?: Maybe<Scalars['uuid']['output']>;
  partner_address_id?: Maybe<Scalars['uuid']['output']>;
  partner_user_id?: Maybe<Scalars['uuid']['output']>;
  po_id?: Maybe<Scalars['String']['output']>;
  service_tax?: Maybe<Scalars['numeric']['output']>;
  tax?: Maybe<Scalars['numeric']['output']>;
  voucher_discount?: Maybe<Scalars['numeric']['output']>;
  voucher_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "partner_order" */
export type Partner_Order_Max_Order_By = {
  affiliation_amount?: InputMaybe<Order_By>;
  affiliation_user_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_to_be_paid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  delivery_fee?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instruction?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  order_code?: InputMaybe<Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
  partner_address_id?: InputMaybe<Order_By>;
  partner_user_id?: InputMaybe<Order_By>;
  po_id?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
  voucher_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Partner_Order_Min_Fields = {
  __typename?: 'partner_order_min_fields';
  affiliation_amount?: Maybe<Scalars['numeric']['output']>;
  affiliation_user_id?: Maybe<Scalars['uuid']['output']>;
  amount?: Maybe<Scalars['numeric']['output']>;
  amount_paid?: Maybe<Scalars['numeric']['output']>;
  amount_to_be_paid?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  delivery_fee?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  instruction?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  order_code?: Maybe<Scalars['bigint']['output']>;
  organization_user_id?: Maybe<Scalars['uuid']['output']>;
  partner_address_id?: Maybe<Scalars['uuid']['output']>;
  partner_user_id?: Maybe<Scalars['uuid']['output']>;
  po_id?: Maybe<Scalars['String']['output']>;
  service_tax?: Maybe<Scalars['numeric']['output']>;
  tax?: Maybe<Scalars['numeric']['output']>;
  voucher_discount?: Maybe<Scalars['numeric']['output']>;
  voucher_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "partner_order" */
export type Partner_Order_Min_Order_By = {
  affiliation_amount?: InputMaybe<Order_By>;
  affiliation_user_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_to_be_paid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  delivery_fee?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instruction?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  order_code?: InputMaybe<Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
  partner_address_id?: InputMaybe<Order_By>;
  partner_user_id?: InputMaybe<Order_By>;
  po_id?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
  voucher_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "partner_order" */
export type Partner_Order_Mutation_Response = {
  __typename?: 'partner_order_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Partner_Order>;
};

/** input type for inserting object relation for remote table "partner_order" */
export type Partner_Order_Obj_Rel_Insert_Input = {
  data: Partner_Order_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_Order_On_Conflict>;
};

/** on_conflict condition type for table "partner_order" */
export type Partner_Order_On_Conflict = {
  constraint: Partner_Order_Constraint;
  update_columns?: Array<Partner_Order_Update_Column>;
  where?: InputMaybe<Partner_Order_Bool_Exp>;
};

/** Ordering options when selecting data from "partner_order". */
export type Partner_Order_Order_By = {
  affiliation_amount?: InputMaybe<Order_By>;
  affiliation_user_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_to_be_paid?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  delivery_fee?: InputMaybe<Order_By>;
  fillup_requests_aggregate?: InputMaybe<Fillup_Request_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  instruction?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_prepaid?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  order_code?: InputMaybe<Order_By>;
  order_type?: InputMaybe<Order_Type_Order_By>;
  organization_user?: InputMaybe<Organization_User_Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
  partner_address?: InputMaybe<Partner_Address_Order_By>;
  partner_address_id?: InputMaybe<Order_By>;
  partner_order_customer_assets_aggregate?: InputMaybe<Partner_Order_Customer_Asset_Aggregate_Order_By>;
  partner_order_items_aggregate?: InputMaybe<Partner_Order_Item_Aggregate_Order_By>;
  partner_order_partner_user_documents_aggregate?: InputMaybe<Partner_Order_Partner_User_Document_Aggregate_Order_By>;
  partner_order_state?: InputMaybe<Partner_Order_State_Order_By>;
  partner_order_stateflows_aggregate?: InputMaybe<Partner_Order_Stateflow_Aggregate_Order_By>;
  partner_user?: InputMaybe<Partner_User_Order_By>;
  partner_user_id?: InputMaybe<Order_By>;
  po_id?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userByCreatedBy?: InputMaybe<User_Order_By>;
  voucher?: InputMaybe<Voucher_Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
  voucher_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "partner_order_partner_user_document" */
export type Partner_Order_Partner_User_Document = {
  __typename?: 'partner_order_partner_user_document';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  partner_order: Partner_Order;
  partner_order_id: Scalars['uuid']['output'];
  /** An object relationship */
  partner_user_document: Partner_User_Document;
  partner_user_document_id: Scalars['uuid']['output'];
};

/** aggregated selection of "partner_order_partner_user_document" */
export type Partner_Order_Partner_User_Document_Aggregate = {
  __typename?: 'partner_order_partner_user_document_aggregate';
  aggregate?: Maybe<Partner_Order_Partner_User_Document_Aggregate_Fields>;
  nodes: Array<Partner_Order_Partner_User_Document>;
};

export type Partner_Order_Partner_User_Document_Aggregate_Bool_Exp = {
  count?: InputMaybe<Partner_Order_Partner_User_Document_Aggregate_Bool_Exp_Count>;
};

export type Partner_Order_Partner_User_Document_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Partner_Order_Partner_User_Document_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Order_Partner_User_Document_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "partner_order_partner_user_document" */
export type Partner_Order_Partner_User_Document_Aggregate_Fields = {
  __typename?: 'partner_order_partner_user_document_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Partner_Order_Partner_User_Document_Max_Fields>;
  min?: Maybe<Partner_Order_Partner_User_Document_Min_Fields>;
};


/** aggregate fields of "partner_order_partner_user_document" */
export type Partner_Order_Partner_User_Document_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Partner_Order_Partner_User_Document_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "partner_order_partner_user_document" */
export type Partner_Order_Partner_User_Document_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Partner_Order_Partner_User_Document_Max_Order_By>;
  min?: InputMaybe<Partner_Order_Partner_User_Document_Min_Order_By>;
};

/** input type for inserting array relation for remote table "partner_order_partner_user_document" */
export type Partner_Order_Partner_User_Document_Arr_Rel_Insert_Input = {
  data: Array<Partner_Order_Partner_User_Document_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_Order_Partner_User_Document_On_Conflict>;
};

/** Boolean expression to filter rows from the table "partner_order_partner_user_document". All fields are combined with a logical 'AND'. */
export type Partner_Order_Partner_User_Document_Bool_Exp = {
  _and?: InputMaybe<Array<Partner_Order_Partner_User_Document_Bool_Exp>>;
  _not?: InputMaybe<Partner_Order_Partner_User_Document_Bool_Exp>;
  _or?: InputMaybe<Array<Partner_Order_Partner_User_Document_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  partner_order?: InputMaybe<Partner_Order_Bool_Exp>;
  partner_order_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner_user_document?: InputMaybe<Partner_User_Document_Bool_Exp>;
  partner_user_document_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "partner_order_partner_user_document" */
export enum Partner_Order_Partner_User_Document_Constraint {
  /** unique or primary key constraint on columns "id" */
  PartnerOrderPartnerUserDocumentPkey = 'partner_order_partner_user_document_pkey'
}

/** input type for inserting data into table "partner_order_partner_user_document" */
export type Partner_Order_Partner_User_Document_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_order?: InputMaybe<Partner_Order_Obj_Rel_Insert_Input>;
  partner_order_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_user_document?: InputMaybe<Partner_User_Document_Obj_Rel_Insert_Input>;
  partner_user_document_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Partner_Order_Partner_User_Document_Max_Fields = {
  __typename?: 'partner_order_partner_user_document_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_order_id?: Maybe<Scalars['uuid']['output']>;
  partner_user_document_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "partner_order_partner_user_document" */
export type Partner_Order_Partner_User_Document_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_order_id?: InputMaybe<Order_By>;
  partner_user_document_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Partner_Order_Partner_User_Document_Min_Fields = {
  __typename?: 'partner_order_partner_user_document_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_order_id?: Maybe<Scalars['uuid']['output']>;
  partner_user_document_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "partner_order_partner_user_document" */
export type Partner_Order_Partner_User_Document_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_order_id?: InputMaybe<Order_By>;
  partner_user_document_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "partner_order_partner_user_document" */
export type Partner_Order_Partner_User_Document_Mutation_Response = {
  __typename?: 'partner_order_partner_user_document_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Partner_Order_Partner_User_Document>;
};

/** on_conflict condition type for table "partner_order_partner_user_document" */
export type Partner_Order_Partner_User_Document_On_Conflict = {
  constraint: Partner_Order_Partner_User_Document_Constraint;
  update_columns?: Array<Partner_Order_Partner_User_Document_Update_Column>;
  where?: InputMaybe<Partner_Order_Partner_User_Document_Bool_Exp>;
};

/** Ordering options when selecting data from "partner_order_partner_user_document". */
export type Partner_Order_Partner_User_Document_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_order?: InputMaybe<Partner_Order_Order_By>;
  partner_order_id?: InputMaybe<Order_By>;
  partner_user_document?: InputMaybe<Partner_User_Document_Order_By>;
  partner_user_document_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: partner_order_partner_user_document */
export type Partner_Order_Partner_User_Document_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "partner_order_partner_user_document" */
export enum Partner_Order_Partner_User_Document_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerOrderId = 'partner_order_id',
  /** column name */
  PartnerUserDocumentId = 'partner_user_document_id'
}

/** input type for updating data in table "partner_order_partner_user_document" */
export type Partner_Order_Partner_User_Document_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_order_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_user_document_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "partner_order_partner_user_document" */
export type Partner_Order_Partner_User_Document_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Partner_Order_Partner_User_Document_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Partner_Order_Partner_User_Document_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_order_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_user_document_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "partner_order_partner_user_document" */
export enum Partner_Order_Partner_User_Document_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerOrderId = 'partner_order_id',
  /** column name */
  PartnerUserDocumentId = 'partner_user_document_id'
}

export type Partner_Order_Partner_User_Document_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Partner_Order_Partner_User_Document_Set_Input>;
  /** filter the rows which have to be updated */
  where: Partner_Order_Partner_User_Document_Bool_Exp;
};

/** primary key columns input for table: partner_order */
export type Partner_Order_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "partner_order" */
export enum Partner_Order_Select_Column {
  /** column name */
  AffiliationAmount = 'affiliation_amount',
  /** column name */
  AffiliationUserId = 'affiliation_user_id',
  /** column name */
  Amount = 'amount',
  /** column name */
  AmountPaid = 'amount_paid',
  /** column name */
  AmountToBePaid = 'amount_to_be_paid',
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DeliveryFee = 'delivery_fee',
  /** column name */
  Id = 'id',
  /** column name */
  Instruction = 'instruction',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsPrepaid = 'is_prepaid',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrderCode = 'order_code',
  /** column name */
  OrganizationUserId = 'organization_user_id',
  /** column name */
  PartnerAddressId = 'partner_address_id',
  /** column name */
  PartnerUserId = 'partner_user_id',
  /** column name */
  PoId = 'po_id',
  /** column name */
  ServiceTax = 'service_tax',
  /** column name */
  State = 'state',
  /** column name */
  Tax = 'tax',
  /** column name */
  VoucherDiscount = 'voucher_discount',
  /** column name */
  VoucherId = 'voucher_id'
}

/** select "partner_order_aggregate_bool_exp_bool_and_arguments_columns" columns of table "partner_order" */
export enum Partner_Order_Select_Column_Partner_Order_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsPrepaid = 'is_prepaid'
}

/** select "partner_order_aggregate_bool_exp_bool_or_arguments_columns" columns of table "partner_order" */
export enum Partner_Order_Select_Column_Partner_Order_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsPrepaid = 'is_prepaid'
}

/** input type for updating data in table "partner_order" */
export type Partner_Order_Set_Input = {
  affiliation_amount?: InputMaybe<Scalars['numeric']['input']>;
  affiliation_user_id?: InputMaybe<Scalars['uuid']['input']>;
  amount?: InputMaybe<Scalars['numeric']['input']>;
  amount_paid?: InputMaybe<Scalars['numeric']['input']>;
  amount_to_be_paid?: InputMaybe<Scalars['numeric']['input']>;
  category?: InputMaybe<Order_Type_Enum>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  delivery_fee?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  instruction?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_prepaid?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  order_code?: InputMaybe<Scalars['bigint']['input']>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_address_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_user_id?: InputMaybe<Scalars['uuid']['input']>;
  po_id?: InputMaybe<Scalars['String']['input']>;
  service_tax?: InputMaybe<Scalars['numeric']['input']>;
  state?: InputMaybe<Partner_Order_State_Enum>;
  tax?: InputMaybe<Scalars['numeric']['input']>;
  voucher_discount?: InputMaybe<Scalars['numeric']['input']>;
  voucher_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "partner_order_state" */
export type Partner_Order_State = {
  __typename?: 'partner_order_state';
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  partner_order_stateflows: Array<Partner_Order_Stateflow>;
  /** An aggregate relationship */
  partner_order_stateflows_aggregate: Partner_Order_Stateflow_Aggregate;
  /** An array relationship */
  partner_orders: Array<Partner_Order>;
  /** An aggregate relationship */
  partner_orders_aggregate: Partner_Order_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "partner_order_state" */
export type Partner_Order_StatePartner_Order_StateflowsArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Stateflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Stateflow_Order_By>>;
  where?: InputMaybe<Partner_Order_Stateflow_Bool_Exp>;
};


/** columns and relationships of "partner_order_state" */
export type Partner_Order_StatePartner_Order_Stateflows_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Stateflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Stateflow_Order_By>>;
  where?: InputMaybe<Partner_Order_Stateflow_Bool_Exp>;
};


/** columns and relationships of "partner_order_state" */
export type Partner_Order_StatePartner_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Order_By>>;
  where?: InputMaybe<Partner_Order_Bool_Exp>;
};


/** columns and relationships of "partner_order_state" */
export type Partner_Order_StatePartner_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Order_By>>;
  where?: InputMaybe<Partner_Order_Bool_Exp>;
};

/** aggregated selection of "partner_order_state" */
export type Partner_Order_State_Aggregate = {
  __typename?: 'partner_order_state_aggregate';
  aggregate?: Maybe<Partner_Order_State_Aggregate_Fields>;
  nodes: Array<Partner_Order_State>;
};

/** aggregate fields of "partner_order_state" */
export type Partner_Order_State_Aggregate_Fields = {
  __typename?: 'partner_order_state_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Partner_Order_State_Max_Fields>;
  min?: Maybe<Partner_Order_State_Min_Fields>;
};


/** aggregate fields of "partner_order_state" */
export type Partner_Order_State_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Partner_Order_State_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "partner_order_state". All fields are combined with a logical 'AND'. */
export type Partner_Order_State_Bool_Exp = {
  _and?: InputMaybe<Array<Partner_Order_State_Bool_Exp>>;
  _not?: InputMaybe<Partner_Order_State_Bool_Exp>;
  _or?: InputMaybe<Array<Partner_Order_State_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  partner_order_stateflows?: InputMaybe<Partner_Order_Stateflow_Bool_Exp>;
  partner_order_stateflows_aggregate?: InputMaybe<Partner_Order_Stateflow_Aggregate_Bool_Exp>;
  partner_orders?: InputMaybe<Partner_Order_Bool_Exp>;
  partner_orders_aggregate?: InputMaybe<Partner_Order_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "partner_order_state" */
export enum Partner_Order_State_Constraint {
  /** unique or primary key constraint on columns "value" */
  PartnerOrderStatePkey = 'partner_order_state_pkey'
}

export enum Partner_Order_State_Enum {
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** CONFIRMED */
  Confirmed = 'CONFIRMED',
  /** DELIVERED */
  Delivered = 'DELIVERED',
  /** NO_SHOW */
  NoShow = 'NO_SHOW',
  /** PAID */
  Paid = 'PAID',
  /** PAY_LATER */
  PayLater = 'PAY_LATER',
  /** PENDING */
  Pending = 'PENDING'
}

/** Boolean expression to compare columns of type "partner_order_state_enum". All fields are combined with logical 'AND'. */
export type Partner_Order_State_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Partner_Order_State_Enum>;
  _in?: InputMaybe<Array<Partner_Order_State_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Partner_Order_State_Enum>;
  _nin?: InputMaybe<Array<Partner_Order_State_Enum>>;
};

/** input type for inserting data into table "partner_order_state" */
export type Partner_Order_State_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  partner_order_stateflows?: InputMaybe<Partner_Order_Stateflow_Arr_Rel_Insert_Input>;
  partner_orders?: InputMaybe<Partner_Order_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Partner_Order_State_Max_Fields = {
  __typename?: 'partner_order_state_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Partner_Order_State_Min_Fields = {
  __typename?: 'partner_order_state_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "partner_order_state" */
export type Partner_Order_State_Mutation_Response = {
  __typename?: 'partner_order_state_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Partner_Order_State>;
};

/** input type for inserting object relation for remote table "partner_order_state" */
export type Partner_Order_State_Obj_Rel_Insert_Input = {
  data: Partner_Order_State_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_Order_State_On_Conflict>;
};

/** on_conflict condition type for table "partner_order_state" */
export type Partner_Order_State_On_Conflict = {
  constraint: Partner_Order_State_Constraint;
  update_columns?: Array<Partner_Order_State_Update_Column>;
  where?: InputMaybe<Partner_Order_State_Bool_Exp>;
};

/** Ordering options when selecting data from "partner_order_state". */
export type Partner_Order_State_Order_By = {
  comment?: InputMaybe<Order_By>;
  partner_order_stateflows_aggregate?: InputMaybe<Partner_Order_Stateflow_Aggregate_Order_By>;
  partner_orders_aggregate?: InputMaybe<Partner_Order_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: partner_order_state */
export type Partner_Order_State_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "partner_order_state" */
export enum Partner_Order_State_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "partner_order_state" */
export type Partner_Order_State_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "partner_order_state" */
export type Partner_Order_State_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Partner_Order_State_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Partner_Order_State_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "partner_order_state" */
export enum Partner_Order_State_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Partner_Order_State_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Partner_Order_State_Set_Input>;
  /** filter the rows which have to be updated */
  where: Partner_Order_State_Bool_Exp;
};

/** columns and relationships of "partner_order_stateflow" */
export type Partner_Order_Stateflow = {
  __typename?: 'partner_order_stateflow';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  partner_order: Partner_Order;
  partner_order_id: Scalars['uuid']['output'];
  /** An object relationship */
  partner_order_state: Partner_Order_State;
  /** An object relationship */
  partner_user: Partner_User;
  partner_user_id: Scalars['uuid']['output'];
  state: Partner_Order_State_Enum;
};

/** aggregated selection of "partner_order_stateflow" */
export type Partner_Order_Stateflow_Aggregate = {
  __typename?: 'partner_order_stateflow_aggregate';
  aggregate?: Maybe<Partner_Order_Stateflow_Aggregate_Fields>;
  nodes: Array<Partner_Order_Stateflow>;
};

export type Partner_Order_Stateflow_Aggregate_Bool_Exp = {
  count?: InputMaybe<Partner_Order_Stateflow_Aggregate_Bool_Exp_Count>;
};

export type Partner_Order_Stateflow_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Partner_Order_Stateflow_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Order_Stateflow_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "partner_order_stateflow" */
export type Partner_Order_Stateflow_Aggregate_Fields = {
  __typename?: 'partner_order_stateflow_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Partner_Order_Stateflow_Max_Fields>;
  min?: Maybe<Partner_Order_Stateflow_Min_Fields>;
};


/** aggregate fields of "partner_order_stateflow" */
export type Partner_Order_Stateflow_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Partner_Order_Stateflow_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "partner_order_stateflow" */
export type Partner_Order_Stateflow_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Partner_Order_Stateflow_Max_Order_By>;
  min?: InputMaybe<Partner_Order_Stateflow_Min_Order_By>;
};

/** input type for inserting array relation for remote table "partner_order_stateflow" */
export type Partner_Order_Stateflow_Arr_Rel_Insert_Input = {
  data: Array<Partner_Order_Stateflow_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_Order_Stateflow_On_Conflict>;
};

/** Boolean expression to filter rows from the table "partner_order_stateflow". All fields are combined with a logical 'AND'. */
export type Partner_Order_Stateflow_Bool_Exp = {
  _and?: InputMaybe<Array<Partner_Order_Stateflow_Bool_Exp>>;
  _not?: InputMaybe<Partner_Order_Stateflow_Bool_Exp>;
  _or?: InputMaybe<Array<Partner_Order_Stateflow_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  partner_order?: InputMaybe<Partner_Order_Bool_Exp>;
  partner_order_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner_order_state?: InputMaybe<Partner_Order_State_Bool_Exp>;
  partner_user?: InputMaybe<Partner_User_Bool_Exp>;
  partner_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  state?: InputMaybe<Partner_Order_State_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "partner_order_stateflow" */
export enum Partner_Order_Stateflow_Constraint {
  /** unique or primary key constraint on columns "id" */
  PartnerOrderStateflowPkey = 'partner_order_stateflow_pkey'
}

/** input type for inserting data into table "partner_order_stateflow" */
export type Partner_Order_Stateflow_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_order?: InputMaybe<Partner_Order_Obj_Rel_Insert_Input>;
  partner_order_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_order_state?: InputMaybe<Partner_Order_State_Obj_Rel_Insert_Input>;
  partner_user?: InputMaybe<Partner_User_Obj_Rel_Insert_Input>;
  partner_user_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Partner_Order_State_Enum>;
};

/** aggregate max on columns */
export type Partner_Order_Stateflow_Max_Fields = {
  __typename?: 'partner_order_stateflow_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_order_id?: Maybe<Scalars['uuid']['output']>;
  partner_user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "partner_order_stateflow" */
export type Partner_Order_Stateflow_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_order_id?: InputMaybe<Order_By>;
  partner_user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Partner_Order_Stateflow_Min_Fields = {
  __typename?: 'partner_order_stateflow_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_order_id?: Maybe<Scalars['uuid']['output']>;
  partner_user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "partner_order_stateflow" */
export type Partner_Order_Stateflow_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_order_id?: InputMaybe<Order_By>;
  partner_user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "partner_order_stateflow" */
export type Partner_Order_Stateflow_Mutation_Response = {
  __typename?: 'partner_order_stateflow_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Partner_Order_Stateflow>;
};

/** on_conflict condition type for table "partner_order_stateflow" */
export type Partner_Order_Stateflow_On_Conflict = {
  constraint: Partner_Order_Stateflow_Constraint;
  update_columns?: Array<Partner_Order_Stateflow_Update_Column>;
  where?: InputMaybe<Partner_Order_Stateflow_Bool_Exp>;
};

/** Ordering options when selecting data from "partner_order_stateflow". */
export type Partner_Order_Stateflow_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_order?: InputMaybe<Partner_Order_Order_By>;
  partner_order_id?: InputMaybe<Order_By>;
  partner_order_state?: InputMaybe<Partner_Order_State_Order_By>;
  partner_user?: InputMaybe<Partner_User_Order_By>;
  partner_user_id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
};

/** primary key columns input for table: partner_order_stateflow */
export type Partner_Order_Stateflow_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "partner_order_stateflow" */
export enum Partner_Order_Stateflow_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerOrderId = 'partner_order_id',
  /** column name */
  PartnerUserId = 'partner_user_id',
  /** column name */
  State = 'state'
}

/** input type for updating data in table "partner_order_stateflow" */
export type Partner_Order_Stateflow_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_order_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_user_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Partner_Order_State_Enum>;
};

/** Streaming cursor of the table "partner_order_stateflow" */
export type Partner_Order_Stateflow_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Partner_Order_Stateflow_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Partner_Order_Stateflow_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_order_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_user_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Partner_Order_State_Enum>;
};

/** update columns of table "partner_order_stateflow" */
export enum Partner_Order_Stateflow_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerOrderId = 'partner_order_id',
  /** column name */
  PartnerUserId = 'partner_user_id',
  /** column name */
  State = 'state'
}

export type Partner_Order_Stateflow_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Partner_Order_Stateflow_Set_Input>;
  /** filter the rows which have to be updated */
  where: Partner_Order_Stateflow_Bool_Exp;
};

/** aggregate stddev on columns */
export type Partner_Order_Stddev_Fields = {
  __typename?: 'partner_order_stddev_fields';
  affiliation_amount?: Maybe<Scalars['Float']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  amount_paid?: Maybe<Scalars['Float']['output']>;
  amount_to_be_paid?: Maybe<Scalars['Float']['output']>;
  delivery_fee?: Maybe<Scalars['Float']['output']>;
  order_code?: Maybe<Scalars['Float']['output']>;
  service_tax?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  voucher_discount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "partner_order" */
export type Partner_Order_Stddev_Order_By = {
  affiliation_amount?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_to_be_paid?: InputMaybe<Order_By>;
  delivery_fee?: InputMaybe<Order_By>;
  order_code?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Partner_Order_Stddev_Pop_Fields = {
  __typename?: 'partner_order_stddev_pop_fields';
  affiliation_amount?: Maybe<Scalars['Float']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  amount_paid?: Maybe<Scalars['Float']['output']>;
  amount_to_be_paid?: Maybe<Scalars['Float']['output']>;
  delivery_fee?: Maybe<Scalars['Float']['output']>;
  order_code?: Maybe<Scalars['Float']['output']>;
  service_tax?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  voucher_discount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "partner_order" */
export type Partner_Order_Stddev_Pop_Order_By = {
  affiliation_amount?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_to_be_paid?: InputMaybe<Order_By>;
  delivery_fee?: InputMaybe<Order_By>;
  order_code?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Partner_Order_Stddev_Samp_Fields = {
  __typename?: 'partner_order_stddev_samp_fields';
  affiliation_amount?: Maybe<Scalars['Float']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  amount_paid?: Maybe<Scalars['Float']['output']>;
  amount_to_be_paid?: Maybe<Scalars['Float']['output']>;
  delivery_fee?: Maybe<Scalars['Float']['output']>;
  order_code?: Maybe<Scalars['Float']['output']>;
  service_tax?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  voucher_discount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "partner_order" */
export type Partner_Order_Stddev_Samp_Order_By = {
  affiliation_amount?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_to_be_paid?: InputMaybe<Order_By>;
  delivery_fee?: InputMaybe<Order_By>;
  order_code?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "partner_order" */
export type Partner_Order_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Partner_Order_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Partner_Order_Stream_Cursor_Value_Input = {
  affiliation_amount?: InputMaybe<Scalars['numeric']['input']>;
  affiliation_user_id?: InputMaybe<Scalars['uuid']['input']>;
  amount?: InputMaybe<Scalars['numeric']['input']>;
  amount_paid?: InputMaybe<Scalars['numeric']['input']>;
  amount_to_be_paid?: InputMaybe<Scalars['numeric']['input']>;
  category?: InputMaybe<Order_Type_Enum>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  delivery_fee?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  instruction?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_prepaid?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  order_code?: InputMaybe<Scalars['bigint']['input']>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_address_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_user_id?: InputMaybe<Scalars['uuid']['input']>;
  po_id?: InputMaybe<Scalars['String']['input']>;
  service_tax?: InputMaybe<Scalars['numeric']['input']>;
  state?: InputMaybe<Partner_Order_State_Enum>;
  tax?: InputMaybe<Scalars['numeric']['input']>;
  voucher_discount?: InputMaybe<Scalars['numeric']['input']>;
  voucher_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Partner_Order_Sum_Fields = {
  __typename?: 'partner_order_sum_fields';
  affiliation_amount?: Maybe<Scalars['numeric']['output']>;
  amount?: Maybe<Scalars['numeric']['output']>;
  amount_paid?: Maybe<Scalars['numeric']['output']>;
  amount_to_be_paid?: Maybe<Scalars['numeric']['output']>;
  delivery_fee?: Maybe<Scalars['numeric']['output']>;
  order_code?: Maybe<Scalars['bigint']['output']>;
  service_tax?: Maybe<Scalars['numeric']['output']>;
  tax?: Maybe<Scalars['numeric']['output']>;
  voucher_discount?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "partner_order" */
export type Partner_Order_Sum_Order_By = {
  affiliation_amount?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_to_be_paid?: InputMaybe<Order_By>;
  delivery_fee?: InputMaybe<Order_By>;
  order_code?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
};

/** update columns of table "partner_order" */
export enum Partner_Order_Update_Column {
  /** column name */
  AffiliationAmount = 'affiliation_amount',
  /** column name */
  AffiliationUserId = 'affiliation_user_id',
  /** column name */
  Amount = 'amount',
  /** column name */
  AmountPaid = 'amount_paid',
  /** column name */
  AmountToBePaid = 'amount_to_be_paid',
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DeliveryFee = 'delivery_fee',
  /** column name */
  Id = 'id',
  /** column name */
  Instruction = 'instruction',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsPrepaid = 'is_prepaid',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrderCode = 'order_code',
  /** column name */
  OrganizationUserId = 'organization_user_id',
  /** column name */
  PartnerAddressId = 'partner_address_id',
  /** column name */
  PartnerUserId = 'partner_user_id',
  /** column name */
  PoId = 'po_id',
  /** column name */
  ServiceTax = 'service_tax',
  /** column name */
  State = 'state',
  /** column name */
  Tax = 'tax',
  /** column name */
  VoucherDiscount = 'voucher_discount',
  /** column name */
  VoucherId = 'voucher_id'
}

export type Partner_Order_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Partner_Order_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Partner_Order_Set_Input>;
  /** filter the rows which have to be updated */
  where: Partner_Order_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Partner_Order_Var_Pop_Fields = {
  __typename?: 'partner_order_var_pop_fields';
  affiliation_amount?: Maybe<Scalars['Float']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  amount_paid?: Maybe<Scalars['Float']['output']>;
  amount_to_be_paid?: Maybe<Scalars['Float']['output']>;
  delivery_fee?: Maybe<Scalars['Float']['output']>;
  order_code?: Maybe<Scalars['Float']['output']>;
  service_tax?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  voucher_discount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "partner_order" */
export type Partner_Order_Var_Pop_Order_By = {
  affiliation_amount?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_to_be_paid?: InputMaybe<Order_By>;
  delivery_fee?: InputMaybe<Order_By>;
  order_code?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Partner_Order_Var_Samp_Fields = {
  __typename?: 'partner_order_var_samp_fields';
  affiliation_amount?: Maybe<Scalars['Float']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  amount_paid?: Maybe<Scalars['Float']['output']>;
  amount_to_be_paid?: Maybe<Scalars['Float']['output']>;
  delivery_fee?: Maybe<Scalars['Float']['output']>;
  order_code?: Maybe<Scalars['Float']['output']>;
  service_tax?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  voucher_discount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "partner_order" */
export type Partner_Order_Var_Samp_Order_By = {
  affiliation_amount?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_to_be_paid?: InputMaybe<Order_By>;
  delivery_fee?: InputMaybe<Order_By>;
  order_code?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Partner_Order_Variance_Fields = {
  __typename?: 'partner_order_variance_fields';
  affiliation_amount?: Maybe<Scalars['Float']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  amount_paid?: Maybe<Scalars['Float']['output']>;
  amount_to_be_paid?: Maybe<Scalars['Float']['output']>;
  delivery_fee?: Maybe<Scalars['Float']['output']>;
  order_code?: Maybe<Scalars['Float']['output']>;
  service_tax?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  voucher_discount?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "partner_order" */
export type Partner_Order_Variance_Order_By = {
  affiliation_amount?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_to_be_paid?: InputMaybe<Order_By>;
  delivery_fee?: InputMaybe<Order_By>;
  order_code?: InputMaybe<Order_By>;
  service_tax?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  voucher_discount?: InputMaybe<Order_By>;
};

/** columns and relationships of "partner_payment" */
export type Partner_Payment = {
  __typename?: 'partner_payment';
  amount?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  customer_order: Customer_Order;
  customer_order_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  transaction_id: Scalars['String']['output'];
  /** An array relationship */
  user_ledgers: Array<User_Ledger>;
  /** An aggregate relationship */
  user_ledgers_aggregate: User_Ledger_Aggregate;
};


/** columns and relationships of "partner_payment" */
export type Partner_PaymentUser_LedgersArgs = {
  distinct_on?: InputMaybe<Array<User_Ledger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Ledger_Order_By>>;
  where?: InputMaybe<User_Ledger_Bool_Exp>;
};


/** columns and relationships of "partner_payment" */
export type Partner_PaymentUser_Ledgers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Ledger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Ledger_Order_By>>;
  where?: InputMaybe<User_Ledger_Bool_Exp>;
};

/** aggregated selection of "partner_payment" */
export type Partner_Payment_Aggregate = {
  __typename?: 'partner_payment_aggregate';
  aggregate?: Maybe<Partner_Payment_Aggregate_Fields>;
  nodes: Array<Partner_Payment>;
};

export type Partner_Payment_Aggregate_Bool_Exp = {
  count?: InputMaybe<Partner_Payment_Aggregate_Bool_Exp_Count>;
};

export type Partner_Payment_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Partner_Payment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Payment_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "partner_payment" */
export type Partner_Payment_Aggregate_Fields = {
  __typename?: 'partner_payment_aggregate_fields';
  avg?: Maybe<Partner_Payment_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Partner_Payment_Max_Fields>;
  min?: Maybe<Partner_Payment_Min_Fields>;
  stddev?: Maybe<Partner_Payment_Stddev_Fields>;
  stddev_pop?: Maybe<Partner_Payment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Partner_Payment_Stddev_Samp_Fields>;
  sum?: Maybe<Partner_Payment_Sum_Fields>;
  var_pop?: Maybe<Partner_Payment_Var_Pop_Fields>;
  var_samp?: Maybe<Partner_Payment_Var_Samp_Fields>;
  variance?: Maybe<Partner_Payment_Variance_Fields>;
};


/** aggregate fields of "partner_payment" */
export type Partner_Payment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Partner_Payment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "partner_payment" */
export type Partner_Payment_Aggregate_Order_By = {
  avg?: InputMaybe<Partner_Payment_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Partner_Payment_Max_Order_By>;
  min?: InputMaybe<Partner_Payment_Min_Order_By>;
  stddev?: InputMaybe<Partner_Payment_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Partner_Payment_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Partner_Payment_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Partner_Payment_Sum_Order_By>;
  var_pop?: InputMaybe<Partner_Payment_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Partner_Payment_Var_Samp_Order_By>;
  variance?: InputMaybe<Partner_Payment_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "partner_payment" */
export type Partner_Payment_Arr_Rel_Insert_Input = {
  data: Array<Partner_Payment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_Payment_On_Conflict>;
};

/** aggregate avg on columns */
export type Partner_Payment_Avg_Fields = {
  __typename?: 'partner_payment_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "partner_payment" */
export type Partner_Payment_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "partner_payment". All fields are combined with a logical 'AND'. */
export type Partner_Payment_Bool_Exp = {
  _and?: InputMaybe<Array<Partner_Payment_Bool_Exp>>;
  _not?: InputMaybe<Partner_Payment_Bool_Exp>;
  _or?: InputMaybe<Array<Partner_Payment_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_order?: InputMaybe<Customer_Order_Bool_Exp>;
  customer_order_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  price?: InputMaybe<String_Comparison_Exp>;
  transaction_id?: InputMaybe<String_Comparison_Exp>;
  user_ledgers?: InputMaybe<User_Ledger_Bool_Exp>;
  user_ledgers_aggregate?: InputMaybe<User_Ledger_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "partner_payment" */
export enum Partner_Payment_Constraint {
  /** unique or primary key constraint on columns "id" */
  PartnerPaymentPkey = 'partner_payment_pkey'
}

/** input type for incrementing numeric columns in table "partner_payment" */
export type Partner_Payment_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "partner_payment" */
export type Partner_Payment_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order?: InputMaybe<Customer_Order_Obj_Rel_Insert_Input>;
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  transaction_id?: InputMaybe<Scalars['String']['input']>;
  user_ledgers?: InputMaybe<User_Ledger_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Partner_Payment_Max_Fields = {
  __typename?: 'partner_payment_max_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_order_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  transaction_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "partner_payment" */
export type Partner_Payment_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Partner_Payment_Min_Fields = {
  __typename?: 'partner_payment_min_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_order_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  transaction_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "partner_payment" */
export type Partner_Payment_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "partner_payment" */
export type Partner_Payment_Mutation_Response = {
  __typename?: 'partner_payment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Partner_Payment>;
};

/** input type for inserting object relation for remote table "partner_payment" */
export type Partner_Payment_Obj_Rel_Insert_Input = {
  data: Partner_Payment_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_Payment_On_Conflict>;
};

/** on_conflict condition type for table "partner_payment" */
export type Partner_Payment_On_Conflict = {
  constraint: Partner_Payment_Constraint;
  update_columns?: Array<Partner_Payment_Update_Column>;
  where?: InputMaybe<Partner_Payment_Bool_Exp>;
};

/** Ordering options when selecting data from "partner_payment". */
export type Partner_Payment_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_order?: InputMaybe<Customer_Order_Order_By>;
  customer_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  user_ledgers_aggregate?: InputMaybe<User_Ledger_Aggregate_Order_By>;
};

/** primary key columns input for table: partner_payment */
export type Partner_Payment_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "partner_payment" */
export enum Partner_Payment_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerOrderId = 'customer_order_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Price = 'price',
  /** column name */
  TransactionId = 'transaction_id'
}

/** input type for updating data in table "partner_payment" */
export type Partner_Payment_Set_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  transaction_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Partner_Payment_Stddev_Fields = {
  __typename?: 'partner_payment_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "partner_payment" */
export type Partner_Payment_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Partner_Payment_Stddev_Pop_Fields = {
  __typename?: 'partner_payment_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "partner_payment" */
export type Partner_Payment_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Partner_Payment_Stddev_Samp_Fields = {
  __typename?: 'partner_payment_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "partner_payment" */
export type Partner_Payment_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "partner_payment" */
export type Partner_Payment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Partner_Payment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Partner_Payment_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  transaction_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Partner_Payment_Sum_Fields = {
  __typename?: 'partner_payment_sum_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "partner_payment" */
export type Partner_Payment_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** update columns of table "partner_payment" */
export enum Partner_Payment_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerOrderId = 'customer_order_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Price = 'price',
  /** column name */
  TransactionId = 'transaction_id'
}

export type Partner_Payment_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Partner_Payment_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Partner_Payment_Set_Input>;
  /** filter the rows which have to be updated */
  where: Partner_Payment_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Partner_Payment_Var_Pop_Fields = {
  __typename?: 'partner_payment_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "partner_payment" */
export type Partner_Payment_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Partner_Payment_Var_Samp_Fields = {
  __typename?: 'partner_payment_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "partner_payment" */
export type Partner_Payment_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Partner_Payment_Variance_Fields = {
  __typename?: 'partner_payment_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "partner_payment" */
export type Partner_Payment_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** primary key columns input for table: partner */
export type Partner_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "partner_product" */
export type Partner_Product = {
  __typename?: 'partner_product';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  partner: Partner;
  partner_id: Scalars['uuid']['output'];
  /** An object relationship */
  product: Product;
  product_id: Scalars['uuid']['output'];
};

/** aggregated selection of "partner_product" */
export type Partner_Product_Aggregate = {
  __typename?: 'partner_product_aggregate';
  aggregate?: Maybe<Partner_Product_Aggregate_Fields>;
  nodes: Array<Partner_Product>;
};

export type Partner_Product_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Partner_Product_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Partner_Product_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Partner_Product_Aggregate_Bool_Exp_Count>;
};

export type Partner_Product_Aggregate_Bool_Exp_Bool_And = {
  arguments: Partner_Product_Select_Column_Partner_Product_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Product_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_Product_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Partner_Product_Select_Column_Partner_Product_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Product_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_Product_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Partner_Product_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Product_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "partner_product" */
export type Partner_Product_Aggregate_Fields = {
  __typename?: 'partner_product_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Partner_Product_Max_Fields>;
  min?: Maybe<Partner_Product_Min_Fields>;
};


/** aggregate fields of "partner_product" */
export type Partner_Product_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Partner_Product_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "partner_product" */
export type Partner_Product_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Partner_Product_Max_Order_By>;
  min?: InputMaybe<Partner_Product_Min_Order_By>;
};

/** input type for inserting array relation for remote table "partner_product" */
export type Partner_Product_Arr_Rel_Insert_Input = {
  data: Array<Partner_Product_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_Product_On_Conflict>;
};

/** Boolean expression to filter rows from the table "partner_product". All fields are combined with a logical 'AND'. */
export type Partner_Product_Bool_Exp = {
  _and?: InputMaybe<Array<Partner_Product_Bool_Exp>>;
  _not?: InputMaybe<Partner_Product_Bool_Exp>;
  _or?: InputMaybe<Array<Partner_Product_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  partner?: InputMaybe<Partner_Bool_Exp>;
  partner_id?: InputMaybe<Uuid_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  product_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "partner_product" */
export enum Partner_Product_Constraint {
  /** unique or primary key constraint on columns "id" */
  PartnerProductPkey = 'partner_product_pkey'
}

/** input type for inserting data into table "partner_product" */
export type Partner_Product_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner?: InputMaybe<Partner_Obj_Rel_Insert_Input>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Partner_Product_Max_Fields = {
  __typename?: 'partner_product_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  product_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "partner_product" */
export type Partner_Product_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Partner_Product_Min_Fields = {
  __typename?: 'partner_product_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  product_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "partner_product" */
export type Partner_Product_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "partner_product" */
export type Partner_Product_Mutation_Response = {
  __typename?: 'partner_product_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Partner_Product>;
};

/** on_conflict condition type for table "partner_product" */
export type Partner_Product_On_Conflict = {
  constraint: Partner_Product_Constraint;
  update_columns?: Array<Partner_Product_Update_Column>;
  where?: InputMaybe<Partner_Product_Bool_Exp>;
};

/** Ordering options when selecting data from "partner_product". */
export type Partner_Product_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner?: InputMaybe<Partner_Order_By>;
  partner_id?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: partner_product */
export type Partner_Product_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "partner_product" */
export enum Partner_Product_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  ProductId = 'product_id'
}

/** select "partner_product_aggregate_bool_exp_bool_and_arguments_columns" columns of table "partner_product" */
export enum Partner_Product_Select_Column_Partner_Product_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "partner_product_aggregate_bool_exp_bool_or_arguments_columns" columns of table "partner_product" */
export enum Partner_Product_Select_Column_Partner_Product_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "partner_product" */
export type Partner_Product_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "partner_product" */
export type Partner_Product_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Partner_Product_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Partner_Product_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "partner_product" */
export enum Partner_Product_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  ProductId = 'product_id'
}

export type Partner_Product_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Partner_Product_Set_Input>;
  /** filter the rows which have to be updated */
  where: Partner_Product_Bool_Exp;
};

/** columns and relationships of "partner_relationship" */
export type Partner_Relationship = {
  __typename?: 'partner_relationship';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  partner: Partner;
  /** An object relationship */
  partnerByVendorId: Partner;
  partner_id: Scalars['uuid']['output'];
  vendor_id: Scalars['uuid']['output'];
};

/** aggregated selection of "partner_relationship" */
export type Partner_Relationship_Aggregate = {
  __typename?: 'partner_relationship_aggregate';
  aggregate?: Maybe<Partner_Relationship_Aggregate_Fields>;
  nodes: Array<Partner_Relationship>;
};

export type Partner_Relationship_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Partner_Relationship_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Partner_Relationship_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Partner_Relationship_Aggregate_Bool_Exp_Count>;
};

export type Partner_Relationship_Aggregate_Bool_Exp_Bool_And = {
  arguments: Partner_Relationship_Select_Column_Partner_Relationship_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Relationship_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_Relationship_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Partner_Relationship_Select_Column_Partner_Relationship_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Relationship_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_Relationship_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Partner_Relationship_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Relationship_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "partner_relationship" */
export type Partner_Relationship_Aggregate_Fields = {
  __typename?: 'partner_relationship_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Partner_Relationship_Max_Fields>;
  min?: Maybe<Partner_Relationship_Min_Fields>;
};


/** aggregate fields of "partner_relationship" */
export type Partner_Relationship_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Partner_Relationship_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "partner_relationship" */
export type Partner_Relationship_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Partner_Relationship_Max_Order_By>;
  min?: InputMaybe<Partner_Relationship_Min_Order_By>;
};

/** input type for inserting array relation for remote table "partner_relationship" */
export type Partner_Relationship_Arr_Rel_Insert_Input = {
  data: Array<Partner_Relationship_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_Relationship_On_Conflict>;
};

/** Boolean expression to filter rows from the table "partner_relationship". All fields are combined with a logical 'AND'. */
export type Partner_Relationship_Bool_Exp = {
  _and?: InputMaybe<Array<Partner_Relationship_Bool_Exp>>;
  _not?: InputMaybe<Partner_Relationship_Bool_Exp>;
  _or?: InputMaybe<Array<Partner_Relationship_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  partner?: InputMaybe<Partner_Bool_Exp>;
  partnerByVendorId?: InputMaybe<Partner_Bool_Exp>;
  partner_id?: InputMaybe<Uuid_Comparison_Exp>;
  vendor_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "partner_relationship" */
export enum Partner_Relationship_Constraint {
  /** unique or primary key constraint on columns "id" */
  PartnerRelationshipPkey = 'partner_relationship_pkey'
}

/** input type for inserting data into table "partner_relationship" */
export type Partner_Relationship_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner?: InputMaybe<Partner_Obj_Rel_Insert_Input>;
  partnerByVendorId?: InputMaybe<Partner_Obj_Rel_Insert_Input>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  vendor_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Partner_Relationship_Max_Fields = {
  __typename?: 'partner_relationship_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  vendor_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "partner_relationship" */
export type Partner_Relationship_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  vendor_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Partner_Relationship_Min_Fields = {
  __typename?: 'partner_relationship_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  vendor_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "partner_relationship" */
export type Partner_Relationship_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  vendor_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "partner_relationship" */
export type Partner_Relationship_Mutation_Response = {
  __typename?: 'partner_relationship_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Partner_Relationship>;
};

/** on_conflict condition type for table "partner_relationship" */
export type Partner_Relationship_On_Conflict = {
  constraint: Partner_Relationship_Constraint;
  update_columns?: Array<Partner_Relationship_Update_Column>;
  where?: InputMaybe<Partner_Relationship_Bool_Exp>;
};

/** Ordering options when selecting data from "partner_relationship". */
export type Partner_Relationship_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner?: InputMaybe<Partner_Order_By>;
  partnerByVendorId?: InputMaybe<Partner_Order_By>;
  partner_id?: InputMaybe<Order_By>;
  vendor_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: partner_relationship */
export type Partner_Relationship_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "partner_relationship" */
export enum Partner_Relationship_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  VendorId = 'vendor_id'
}

/** select "partner_relationship_aggregate_bool_exp_bool_and_arguments_columns" columns of table "partner_relationship" */
export enum Partner_Relationship_Select_Column_Partner_Relationship_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "partner_relationship_aggregate_bool_exp_bool_or_arguments_columns" columns of table "partner_relationship" */
export enum Partner_Relationship_Select_Column_Partner_Relationship_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "partner_relationship" */
export type Partner_Relationship_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  vendor_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "partner_relationship" */
export type Partner_Relationship_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Partner_Relationship_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Partner_Relationship_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  vendor_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "partner_relationship" */
export enum Partner_Relationship_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  VendorId = 'vendor_id'
}

export type Partner_Relationship_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Partner_Relationship_Set_Input>;
  /** filter the rows which have to be updated */
  where: Partner_Relationship_Bool_Exp;
};

/** select columns of table "partner" */
export enum Partner_Select_Column {
  /** column name */
  About = 'about',
  /** column name */
  AccountsPayableLocated = 'accounts_payable_located',
  /** column name */
  AssociatedType = 'associated_type',
  /** column name */
  Brand = 'brand',
  /** column name */
  BrandLogo = 'brand_logo',
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DealerCode = 'dealer_code',
  /** column name */
  DefaultCurrency = 'default_currency',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceFollowupEmailAddress = 'invoice_followup_email_address',
  /** column name */
  InvoiceSendingEmailAddress = 'invoice_sending_email_address',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsFuelbuddy = 'is_fuelbuddy',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Location = 'location',
  /** column name */
  Name = 'name',
  /** column name */
  OmcType = 'omc_type',
  /** column name */
  PartnerAddressId = 'partner_address_id',
  /** column name */
  Popularity = 'popularity',
  /** column name */
  Rating = 'rating',
  /** column name */
  SupportContactNumber = 'support_contact_number'
}

/** select "partner_aggregate_bool_exp_bool_and_arguments_columns" columns of table "partner" */
export enum Partner_Select_Column_Partner_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsFuelbuddy = 'is_fuelbuddy'
}

/** select "partner_aggregate_bool_exp_bool_or_arguments_columns" columns of table "partner" */
export enum Partner_Select_Column_Partner_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsFuelbuddy = 'is_fuelbuddy'
}

/** columns and relationships of "partner_seller" */
export type Partner_Seller = {
  __typename?: 'partner_seller';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  partner: Partner;
  /** An object relationship */
  partnerBySellerId: Partner;
  /** An object relationship */
  partnerSellerTypeByPartnerSellerType: Partner_Seller_Type;
  partner_id: Scalars['uuid']['output'];
  partner_seller_type: Scalars['uuid']['output'];
  seller_id: Scalars['uuid']['output'];
};

/** aggregated selection of "partner_seller" */
export type Partner_Seller_Aggregate = {
  __typename?: 'partner_seller_aggregate';
  aggregate?: Maybe<Partner_Seller_Aggregate_Fields>;
  nodes: Array<Partner_Seller>;
};

export type Partner_Seller_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Partner_Seller_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Partner_Seller_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Partner_Seller_Aggregate_Bool_Exp_Count>;
};

export type Partner_Seller_Aggregate_Bool_Exp_Bool_And = {
  arguments: Partner_Seller_Select_Column_Partner_Seller_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Seller_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_Seller_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Partner_Seller_Select_Column_Partner_Seller_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Seller_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_Seller_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Partner_Seller_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Seller_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "partner_seller" */
export type Partner_Seller_Aggregate_Fields = {
  __typename?: 'partner_seller_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Partner_Seller_Max_Fields>;
  min?: Maybe<Partner_Seller_Min_Fields>;
};


/** aggregate fields of "partner_seller" */
export type Partner_Seller_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Partner_Seller_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "partner_seller" */
export type Partner_Seller_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Partner_Seller_Max_Order_By>;
  min?: InputMaybe<Partner_Seller_Min_Order_By>;
};

/** input type for inserting array relation for remote table "partner_seller" */
export type Partner_Seller_Arr_Rel_Insert_Input = {
  data: Array<Partner_Seller_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_Seller_On_Conflict>;
};

/** Boolean expression to filter rows from the table "partner_seller". All fields are combined with a logical 'AND'. */
export type Partner_Seller_Bool_Exp = {
  _and?: InputMaybe<Array<Partner_Seller_Bool_Exp>>;
  _not?: InputMaybe<Partner_Seller_Bool_Exp>;
  _or?: InputMaybe<Array<Partner_Seller_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  partner?: InputMaybe<Partner_Bool_Exp>;
  partnerBySellerId?: InputMaybe<Partner_Bool_Exp>;
  partnerSellerTypeByPartnerSellerType?: InputMaybe<Partner_Seller_Type_Bool_Exp>;
  partner_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner_seller_type?: InputMaybe<Uuid_Comparison_Exp>;
  seller_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "partner_seller" */
export enum Partner_Seller_Constraint {
  /** unique or primary key constraint on columns "id" */
  PartnerSellerPkey = 'partner_seller_pkey'
}

/** input type for inserting data into table "partner_seller" */
export type Partner_Seller_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner?: InputMaybe<Partner_Obj_Rel_Insert_Input>;
  partnerBySellerId?: InputMaybe<Partner_Obj_Rel_Insert_Input>;
  partnerSellerTypeByPartnerSellerType?: InputMaybe<Partner_Seller_Type_Obj_Rel_Insert_Input>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_seller_type?: InputMaybe<Scalars['uuid']['input']>;
  seller_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Partner_Seller_Max_Fields = {
  __typename?: 'partner_seller_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  partner_seller_type?: Maybe<Scalars['uuid']['output']>;
  seller_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "partner_seller" */
export type Partner_Seller_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  partner_seller_type?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Partner_Seller_Min_Fields = {
  __typename?: 'partner_seller_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  partner_seller_type?: Maybe<Scalars['uuid']['output']>;
  seller_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "partner_seller" */
export type Partner_Seller_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  partner_seller_type?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "partner_seller" */
export type Partner_Seller_Mutation_Response = {
  __typename?: 'partner_seller_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Partner_Seller>;
};

/** on_conflict condition type for table "partner_seller" */
export type Partner_Seller_On_Conflict = {
  constraint: Partner_Seller_Constraint;
  update_columns?: Array<Partner_Seller_Update_Column>;
  where?: InputMaybe<Partner_Seller_Bool_Exp>;
};

/** Ordering options when selecting data from "partner_seller". */
export type Partner_Seller_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner?: InputMaybe<Partner_Order_By>;
  partnerBySellerId?: InputMaybe<Partner_Order_By>;
  partnerSellerTypeByPartnerSellerType?: InputMaybe<Partner_Seller_Type_Order_By>;
  partner_id?: InputMaybe<Order_By>;
  partner_seller_type?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: partner_seller */
export type Partner_Seller_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "partner_seller" */
export enum Partner_Seller_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  PartnerSellerType = 'partner_seller_type',
  /** column name */
  SellerId = 'seller_id'
}

/** select "partner_seller_aggregate_bool_exp_bool_and_arguments_columns" columns of table "partner_seller" */
export enum Partner_Seller_Select_Column_Partner_Seller_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "partner_seller_aggregate_bool_exp_bool_or_arguments_columns" columns of table "partner_seller" */
export enum Partner_Seller_Select_Column_Partner_Seller_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "partner_seller" */
export type Partner_Seller_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_seller_type?: InputMaybe<Scalars['uuid']['input']>;
  seller_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "partner_seller" */
export type Partner_Seller_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Partner_Seller_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Partner_Seller_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_seller_type?: InputMaybe<Scalars['uuid']['input']>;
  seller_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "partner_seller_type" */
export type Partner_Seller_Type = {
  __typename?: 'partner_seller_type';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name: Scalars['String']['output'];
  /** An array relationship */
  partner_sellers: Array<Partner_Seller>;
  /** An aggregate relationship */
  partner_sellers_aggregate: Partner_Seller_Aggregate;
  sku: Scalars['String']['output'];
};


/** columns and relationships of "partner_seller_type" */
export type Partner_Seller_TypePartner_SellersArgs = {
  distinct_on?: InputMaybe<Array<Partner_Seller_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Seller_Order_By>>;
  where?: InputMaybe<Partner_Seller_Bool_Exp>;
};


/** columns and relationships of "partner_seller_type" */
export type Partner_Seller_TypePartner_Sellers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Seller_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Seller_Order_By>>;
  where?: InputMaybe<Partner_Seller_Bool_Exp>;
};

/** aggregated selection of "partner_seller_type" */
export type Partner_Seller_Type_Aggregate = {
  __typename?: 'partner_seller_type_aggregate';
  aggregate?: Maybe<Partner_Seller_Type_Aggregate_Fields>;
  nodes: Array<Partner_Seller_Type>;
};

/** aggregate fields of "partner_seller_type" */
export type Partner_Seller_Type_Aggregate_Fields = {
  __typename?: 'partner_seller_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Partner_Seller_Type_Max_Fields>;
  min?: Maybe<Partner_Seller_Type_Min_Fields>;
};


/** aggregate fields of "partner_seller_type" */
export type Partner_Seller_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Partner_Seller_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "partner_seller_type". All fields are combined with a logical 'AND'. */
export type Partner_Seller_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Partner_Seller_Type_Bool_Exp>>;
  _not?: InputMaybe<Partner_Seller_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Partner_Seller_Type_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  partner_sellers?: InputMaybe<Partner_Seller_Bool_Exp>;
  partner_sellers_aggregate?: InputMaybe<Partner_Seller_Aggregate_Bool_Exp>;
  sku?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "partner_seller_type" */
export enum Partner_Seller_Type_Constraint {
  /** unique or primary key constraint on columns "id" */
  PartnerSellerTypePkey = 'partner_seller_type_pkey'
}

/** input type for inserting data into table "partner_seller_type" */
export type Partner_Seller_Type_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partner_sellers?: InputMaybe<Partner_Seller_Arr_Rel_Insert_Input>;
  sku?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Partner_Seller_Type_Max_Fields = {
  __typename?: 'partner_seller_type_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Partner_Seller_Type_Min_Fields = {
  __typename?: 'partner_seller_type_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "partner_seller_type" */
export type Partner_Seller_Type_Mutation_Response = {
  __typename?: 'partner_seller_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Partner_Seller_Type>;
};

/** input type for inserting object relation for remote table "partner_seller_type" */
export type Partner_Seller_Type_Obj_Rel_Insert_Input = {
  data: Partner_Seller_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_Seller_Type_On_Conflict>;
};

/** on_conflict condition type for table "partner_seller_type" */
export type Partner_Seller_Type_On_Conflict = {
  constraint: Partner_Seller_Type_Constraint;
  update_columns?: Array<Partner_Seller_Type_Update_Column>;
  where?: InputMaybe<Partner_Seller_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "partner_seller_type". */
export type Partner_Seller_Type_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  partner_sellers_aggregate?: InputMaybe<Partner_Seller_Aggregate_Order_By>;
  sku?: InputMaybe<Order_By>;
};

/** primary key columns input for table: partner_seller_type */
export type Partner_Seller_Type_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "partner_seller_type" */
export enum Partner_Seller_Type_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  Sku = 'sku'
}

/** input type for updating data in table "partner_seller_type" */
export type Partner_Seller_Type_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "partner_seller_type" */
export type Partner_Seller_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Partner_Seller_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Partner_Seller_Type_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "partner_seller_type" */
export enum Partner_Seller_Type_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  Sku = 'sku'
}

export type Partner_Seller_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Partner_Seller_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Partner_Seller_Type_Bool_Exp;
};

/** update columns of table "partner_seller" */
export enum Partner_Seller_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  PartnerSellerType = 'partner_seller_type',
  /** column name */
  SellerId = 'seller_id'
}

export type Partner_Seller_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Partner_Seller_Set_Input>;
  /** filter the rows which have to be updated */
  where: Partner_Seller_Bool_Exp;
};

/** input type for updating data in table "partner" */
export type Partner_Set_Input = {
  about?: InputMaybe<Scalars['String']['input']>;
  accounts_payable_located?: InputMaybe<Scalars['String']['input']>;
  associated_type?: InputMaybe<Associated_Type_Enum>;
  brand?: InputMaybe<Scalars['String']['input']>;
  brand_logo?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Partner_Type_Enum>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  dealer_code?: InputMaybe<Scalars['String']['input']>;
  default_currency?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invoice_followup_email_address?: InputMaybe<Scalars['String']['input']>;
  invoice_sending_email_address?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_fuelbuddy?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['geography']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  omc_type?: InputMaybe<Omc_Type_Enum>;
  partner_address_id?: InputMaybe<Scalars['uuid']['input']>;
  popularity?: InputMaybe<Scalars['Int']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  support_contact_number?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "partner_signing_authority" */
export type Partner_Signing_Authority = {
  __typename?: 'partner_signing_authority';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  partner: Partner;
  partner_id: Scalars['uuid']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "partner_signing_authority" */
export type Partner_Signing_Authority_Aggregate = {
  __typename?: 'partner_signing_authority_aggregate';
  aggregate?: Maybe<Partner_Signing_Authority_Aggregate_Fields>;
  nodes: Array<Partner_Signing_Authority>;
};

export type Partner_Signing_Authority_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Partner_Signing_Authority_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Partner_Signing_Authority_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Partner_Signing_Authority_Aggregate_Bool_Exp_Count>;
};

export type Partner_Signing_Authority_Aggregate_Bool_Exp_Bool_And = {
  arguments: Partner_Signing_Authority_Select_Column_Partner_Signing_Authority_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Signing_Authority_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_Signing_Authority_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Partner_Signing_Authority_Select_Column_Partner_Signing_Authority_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Signing_Authority_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_Signing_Authority_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Partner_Signing_Authority_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Signing_Authority_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "partner_signing_authority" */
export type Partner_Signing_Authority_Aggregate_Fields = {
  __typename?: 'partner_signing_authority_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Partner_Signing_Authority_Max_Fields>;
  min?: Maybe<Partner_Signing_Authority_Min_Fields>;
};


/** aggregate fields of "partner_signing_authority" */
export type Partner_Signing_Authority_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Partner_Signing_Authority_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "partner_signing_authority" */
export type Partner_Signing_Authority_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Partner_Signing_Authority_Max_Order_By>;
  min?: InputMaybe<Partner_Signing_Authority_Min_Order_By>;
};

/** input type for inserting array relation for remote table "partner_signing_authority" */
export type Partner_Signing_Authority_Arr_Rel_Insert_Input = {
  data: Array<Partner_Signing_Authority_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_Signing_Authority_On_Conflict>;
};

/** Boolean expression to filter rows from the table "partner_signing_authority". All fields are combined with a logical 'AND'. */
export type Partner_Signing_Authority_Bool_Exp = {
  _and?: InputMaybe<Array<Partner_Signing_Authority_Bool_Exp>>;
  _not?: InputMaybe<Partner_Signing_Authority_Bool_Exp>;
  _or?: InputMaybe<Array<Partner_Signing_Authority_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  partner?: InputMaybe<Partner_Bool_Exp>;
  partner_id?: InputMaybe<Uuid_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "partner_signing_authority" */
export enum Partner_Signing_Authority_Constraint {
  /** unique or primary key constraint on columns "id" */
  PartnerSigningAuthorityPkey = 'partner_signing_authority_pkey'
}

/** input type for inserting data into table "partner_signing_authority" */
export type Partner_Signing_Authority_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner?: InputMaybe<Partner_Obj_Rel_Insert_Input>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Partner_Signing_Authority_Max_Fields = {
  __typename?: 'partner_signing_authority_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "partner_signing_authority" */
export type Partner_Signing_Authority_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Partner_Signing_Authority_Min_Fields = {
  __typename?: 'partner_signing_authority_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "partner_signing_authority" */
export type Partner_Signing_Authority_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "partner_signing_authority" */
export type Partner_Signing_Authority_Mutation_Response = {
  __typename?: 'partner_signing_authority_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Partner_Signing_Authority>;
};

/** on_conflict condition type for table "partner_signing_authority" */
export type Partner_Signing_Authority_On_Conflict = {
  constraint: Partner_Signing_Authority_Constraint;
  update_columns?: Array<Partner_Signing_Authority_Update_Column>;
  where?: InputMaybe<Partner_Signing_Authority_Bool_Exp>;
};

/** Ordering options when selecting data from "partner_signing_authority". */
export type Partner_Signing_Authority_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner?: InputMaybe<Partner_Order_By>;
  partner_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** primary key columns input for table: partner_signing_authority */
export type Partner_Signing_Authority_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "partner_signing_authority" */
export enum Partner_Signing_Authority_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  FullName = 'full_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  Title = 'title'
}

/** select "partner_signing_authority_aggregate_bool_exp_bool_and_arguments_columns" columns of table "partner_signing_authority" */
export enum Partner_Signing_Authority_Select_Column_Partner_Signing_Authority_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "partner_signing_authority_aggregate_bool_exp_bool_or_arguments_columns" columns of table "partner_signing_authority" */
export enum Partner_Signing_Authority_Select_Column_Partner_Signing_Authority_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "partner_signing_authority" */
export type Partner_Signing_Authority_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "partner_signing_authority" */
export type Partner_Signing_Authority_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Partner_Signing_Authority_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Partner_Signing_Authority_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "partner_signing_authority" */
export enum Partner_Signing_Authority_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  FullName = 'full_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  Title = 'title'
}

export type Partner_Signing_Authority_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Partner_Signing_Authority_Set_Input>;
  /** filter the rows which have to be updated */
  where: Partner_Signing_Authority_Bool_Exp;
};

/** aggregate stddev on columns */
export type Partner_Stddev_Fields = {
  __typename?: 'partner_stddev_fields';
  popularity?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "partner" */
export type Partner_Stddev_Order_By = {
  popularity?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Partner_Stddev_Pop_Fields = {
  __typename?: 'partner_stddev_pop_fields';
  popularity?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "partner" */
export type Partner_Stddev_Pop_Order_By = {
  popularity?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Partner_Stddev_Samp_Fields = {
  __typename?: 'partner_stddev_samp_fields';
  popularity?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "partner" */
export type Partner_Stddev_Samp_Order_By = {
  popularity?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "partner" */
export type Partner_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Partner_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Partner_Stream_Cursor_Value_Input = {
  about?: InputMaybe<Scalars['String']['input']>;
  accounts_payable_located?: InputMaybe<Scalars['String']['input']>;
  associated_type?: InputMaybe<Associated_Type_Enum>;
  brand?: InputMaybe<Scalars['String']['input']>;
  brand_logo?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Partner_Type_Enum>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  dealer_code?: InputMaybe<Scalars['String']['input']>;
  default_currency?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invoice_followup_email_address?: InputMaybe<Scalars['String']['input']>;
  invoice_sending_email_address?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_fuelbuddy?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['geography']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  omc_type?: InputMaybe<Omc_Type_Enum>;
  partner_address_id?: InputMaybe<Scalars['uuid']['input']>;
  popularity?: InputMaybe<Scalars['Int']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  support_contact_number?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Partner_Sum_Fields = {
  __typename?: 'partner_sum_fields';
  popularity?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "partner" */
export type Partner_Sum_Order_By = {
  popularity?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
};

/** columns and relationships of "partner_timing" */
export type Partner_Timing = {
  __typename?: 'partner_timing';
  close_time?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  day?: Maybe<Scalars['DayType']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  is_closed: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  open_time?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  partner: Partner;
  partner_id: Scalars['uuid']['output'];
};

/** aggregated selection of "partner_timing" */
export type Partner_Timing_Aggregate = {
  __typename?: 'partner_timing_aggregate';
  aggregate?: Maybe<Partner_Timing_Aggregate_Fields>;
  nodes: Array<Partner_Timing>;
};

export type Partner_Timing_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Partner_Timing_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Partner_Timing_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Partner_Timing_Aggregate_Bool_Exp_Count>;
};

export type Partner_Timing_Aggregate_Bool_Exp_Bool_And = {
  arguments: Partner_Timing_Select_Column_Partner_Timing_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Timing_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_Timing_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Partner_Timing_Select_Column_Partner_Timing_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Timing_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_Timing_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Partner_Timing_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Timing_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "partner_timing" */
export type Partner_Timing_Aggregate_Fields = {
  __typename?: 'partner_timing_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Partner_Timing_Max_Fields>;
  min?: Maybe<Partner_Timing_Min_Fields>;
};


/** aggregate fields of "partner_timing" */
export type Partner_Timing_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Partner_Timing_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "partner_timing" */
export type Partner_Timing_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Partner_Timing_Max_Order_By>;
  min?: InputMaybe<Partner_Timing_Min_Order_By>;
};

/** input type for inserting array relation for remote table "partner_timing" */
export type Partner_Timing_Arr_Rel_Insert_Input = {
  data: Array<Partner_Timing_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_Timing_On_Conflict>;
};

/** Boolean expression to filter rows from the table "partner_timing". All fields are combined with a logical 'AND'. */
export type Partner_Timing_Bool_Exp = {
  _and?: InputMaybe<Array<Partner_Timing_Bool_Exp>>;
  _not?: InputMaybe<Partner_Timing_Bool_Exp>;
  _or?: InputMaybe<Array<Partner_Timing_Bool_Exp>>;
  close_time?: InputMaybe<Timestamp_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  day?: InputMaybe<DayType_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_closed?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  open_time?: InputMaybe<Timestamp_Comparison_Exp>;
  partner?: InputMaybe<Partner_Bool_Exp>;
  partner_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "partner_timing" */
export enum Partner_Timing_Constraint {
  /** unique or primary key constraint on columns "id" */
  PartnerTimingPkey = 'partner_timing_pkey'
}

/** input type for inserting data into table "partner_timing" */
export type Partner_Timing_Insert_Input = {
  close_time?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  day?: InputMaybe<Scalars['DayType']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_closed?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  open_time?: InputMaybe<Scalars['timestamp']['input']>;
  partner?: InputMaybe<Partner_Obj_Rel_Insert_Input>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Partner_Timing_Max_Fields = {
  __typename?: 'partner_timing_max_fields';
  close_time?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  day?: Maybe<Scalars['DayType']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  open_time?: Maybe<Scalars['timestamp']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "partner_timing" */
export type Partner_Timing_Max_Order_By = {
  close_time?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  day?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  open_time?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Partner_Timing_Min_Fields = {
  __typename?: 'partner_timing_min_fields';
  close_time?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  day?: Maybe<Scalars['DayType']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  open_time?: Maybe<Scalars['timestamp']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "partner_timing" */
export type Partner_Timing_Min_Order_By = {
  close_time?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  day?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  open_time?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "partner_timing" */
export type Partner_Timing_Mutation_Response = {
  __typename?: 'partner_timing_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Partner_Timing>;
};

/** on_conflict condition type for table "partner_timing" */
export type Partner_Timing_On_Conflict = {
  constraint: Partner_Timing_Constraint;
  update_columns?: Array<Partner_Timing_Update_Column>;
  where?: InputMaybe<Partner_Timing_Bool_Exp>;
};

/** Ordering options when selecting data from "partner_timing". */
export type Partner_Timing_Order_By = {
  close_time?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  day?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_closed?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  open_time?: InputMaybe<Order_By>;
  partner?: InputMaybe<Partner_Order_By>;
  partner_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: partner_timing */
export type Partner_Timing_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "partner_timing" */
export enum Partner_Timing_Select_Column {
  /** column name */
  CloseTime = 'close_time',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Day = 'day',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsClosed = 'is_closed',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OpenTime = 'open_time',
  /** column name */
  PartnerId = 'partner_id'
}

/** select "partner_timing_aggregate_bool_exp_bool_and_arguments_columns" columns of table "partner_timing" */
export enum Partner_Timing_Select_Column_Partner_Timing_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsClosed = 'is_closed'
}

/** select "partner_timing_aggregate_bool_exp_bool_or_arguments_columns" columns of table "partner_timing" */
export enum Partner_Timing_Select_Column_Partner_Timing_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsClosed = 'is_closed'
}

/** input type for updating data in table "partner_timing" */
export type Partner_Timing_Set_Input = {
  close_time?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  day?: InputMaybe<Scalars['DayType']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_closed?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  open_time?: InputMaybe<Scalars['timestamp']['input']>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "partner_timing" */
export type Partner_Timing_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Partner_Timing_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Partner_Timing_Stream_Cursor_Value_Input = {
  close_time?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  day?: InputMaybe<Scalars['DayType']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_closed?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  open_time?: InputMaybe<Scalars['timestamp']['input']>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "partner_timing" */
export enum Partner_Timing_Update_Column {
  /** column name */
  CloseTime = 'close_time',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Day = 'day',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsClosed = 'is_closed',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OpenTime = 'open_time',
  /** column name */
  PartnerId = 'partner_id'
}

export type Partner_Timing_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Partner_Timing_Set_Input>;
  /** filter the rows which have to be updated */
  where: Partner_Timing_Bool_Exp;
};

/** columns and relationships of "partner_type" */
export type Partner_Type = {
  __typename?: 'partner_type';
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  partners: Array<Partner>;
  /** An aggregate relationship */
  partners_aggregate: Partner_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "partner_type" */
export type Partner_TypePartnersArgs = {
  distinct_on?: InputMaybe<Array<Partner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_By>>;
  where?: InputMaybe<Partner_Bool_Exp>;
};


/** columns and relationships of "partner_type" */
export type Partner_TypePartners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_By>>;
  where?: InputMaybe<Partner_Bool_Exp>;
};

/** aggregated selection of "partner_type" */
export type Partner_Type_Aggregate = {
  __typename?: 'partner_type_aggregate';
  aggregate?: Maybe<Partner_Type_Aggregate_Fields>;
  nodes: Array<Partner_Type>;
};

/** aggregate fields of "partner_type" */
export type Partner_Type_Aggregate_Fields = {
  __typename?: 'partner_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Partner_Type_Max_Fields>;
  min?: Maybe<Partner_Type_Min_Fields>;
};


/** aggregate fields of "partner_type" */
export type Partner_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Partner_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "partner_type". All fields are combined with a logical 'AND'. */
export type Partner_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Partner_Type_Bool_Exp>>;
  _not?: InputMaybe<Partner_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Partner_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  partners?: InputMaybe<Partner_Bool_Exp>;
  partners_aggregate?: InputMaybe<Partner_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "partner_type" */
export enum Partner_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  PartnerTypePkey = 'partner_type_pkey'
}

export enum Partner_Type_Enum {
  /** AFFILIATE */
  Affiliate = 'AFFILIATE',
  /** FRANCHISE */
  Franchise = 'FRANCHISE',
  /** OMC */
  Omc = 'OMC',
  /** OPERATION */
  Operation = 'OPERATION',
  /** OTHER */
  Other = 'OTHER',
  /** Ro */
  Ro = 'RO'
}

/** Boolean expression to compare columns of type "partner_type_enum". All fields are combined with logical 'AND'. */
export type Partner_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Partner_Type_Enum>;
  _in?: InputMaybe<Array<Partner_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Partner_Type_Enum>;
  _nin?: InputMaybe<Array<Partner_Type_Enum>>;
};

/** input type for inserting data into table "partner_type" */
export type Partner_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  partners?: InputMaybe<Partner_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Partner_Type_Max_Fields = {
  __typename?: 'partner_type_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Partner_Type_Min_Fields = {
  __typename?: 'partner_type_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "partner_type" */
export type Partner_Type_Mutation_Response = {
  __typename?: 'partner_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Partner_Type>;
};

/** input type for inserting object relation for remote table "partner_type" */
export type Partner_Type_Obj_Rel_Insert_Input = {
  data: Partner_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_Type_On_Conflict>;
};

/** on_conflict condition type for table "partner_type" */
export type Partner_Type_On_Conflict = {
  constraint: Partner_Type_Constraint;
  update_columns?: Array<Partner_Type_Update_Column>;
  where?: InputMaybe<Partner_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "partner_type". */
export type Partner_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  partners_aggregate?: InputMaybe<Partner_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: partner_type */
export type Partner_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "partner_type" */
export enum Partner_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "partner_type" */
export type Partner_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "partner_type" */
export type Partner_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Partner_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Partner_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "partner_type" */
export enum Partner_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Partner_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Partner_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Partner_Type_Bool_Exp;
};

/** update columns of table "partner" */
export enum Partner_Update_Column {
  /** column name */
  About = 'about',
  /** column name */
  AccountsPayableLocated = 'accounts_payable_located',
  /** column name */
  AssociatedType = 'associated_type',
  /** column name */
  Brand = 'brand',
  /** column name */
  BrandLogo = 'brand_logo',
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DealerCode = 'dealer_code',
  /** column name */
  DefaultCurrency = 'default_currency',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceFollowupEmailAddress = 'invoice_followup_email_address',
  /** column name */
  InvoiceSendingEmailAddress = 'invoice_sending_email_address',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsFuelbuddy = 'is_fuelbuddy',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Location = 'location',
  /** column name */
  Name = 'name',
  /** column name */
  OmcType = 'omc_type',
  /** column name */
  PartnerAddressId = 'partner_address_id',
  /** column name */
  Popularity = 'popularity',
  /** column name */
  Rating = 'rating',
  /** column name */
  SupportContactNumber = 'support_contact_number'
}

export type Partner_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Partner_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Partner_Set_Input>;
  /** filter the rows which have to be updated */
  where: Partner_Bool_Exp;
};

/** columns and relationships of "partner_user" */
export type Partner_User = {
  __typename?: 'partner_user';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  is_owner: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  partner: Partner;
  /** An array relationship */
  partner_commission_product_variation_types: Array<Partner_Commission_Product_Variation_Type>;
  /** An aggregate relationship */
  partner_commission_product_variation_types_aggregate: Partner_Commission_Product_Variation_Type_Aggregate;
  partner_id: Scalars['uuid']['output'];
  /** An array relationship */
  partner_order_item_commissions: Array<Partner_Order_Item_Commission>;
  /** An aggregate relationship */
  partner_order_item_commissions_aggregate: Partner_Order_Item_Commission_Aggregate;
  /** An array relationship */
  partner_order_item_stateflows: Array<Partner_Order_Item_Stateflow>;
  /** An aggregate relationship */
  partner_order_item_stateflows_aggregate: Partner_Order_Item_Stateflow_Aggregate;
  /** An array relationship */
  partner_order_items: Array<Partner_Order_Item>;
  /** An aggregate relationship */
  partner_order_items_aggregate: Partner_Order_Item_Aggregate;
  /** An array relationship */
  partner_order_stateflows: Array<Partner_Order_Stateflow>;
  /** An aggregate relationship */
  partner_order_stateflows_aggregate: Partner_Order_Stateflow_Aggregate;
  /** An array relationship */
  partner_orders: Array<Partner_Order>;
  /** An aggregate relationship */
  partner_orders_aggregate: Partner_Order_Aggregate;
  /** An array relationship */
  partner_user_permissions: Array<Partner_User_Permission>;
  /** An aggregate relationship */
  partner_user_permissions_aggregate: Partner_User_Permission_Aggregate;
  /** An object relationship */
  user: User;
  user_id: Scalars['uuid']['output'];
};


/** columns and relationships of "partner_user" */
export type Partner_UserPartner_Commission_Product_Variation_TypesArgs = {
  distinct_on?: InputMaybe<Array<Partner_Commission_Product_Variation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Commission_Product_Variation_Type_Order_By>>;
  where?: InputMaybe<Partner_Commission_Product_Variation_Type_Bool_Exp>;
};


/** columns and relationships of "partner_user" */
export type Partner_UserPartner_Commission_Product_Variation_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Commission_Product_Variation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Commission_Product_Variation_Type_Order_By>>;
  where?: InputMaybe<Partner_Commission_Product_Variation_Type_Bool_Exp>;
};


/** columns and relationships of "partner_user" */
export type Partner_UserPartner_Order_Item_CommissionsArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Commission_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Commission_Bool_Exp>;
};


/** columns and relationships of "partner_user" */
export type Partner_UserPartner_Order_Item_Commissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Commission_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Commission_Bool_Exp>;
};


/** columns and relationships of "partner_user" */
export type Partner_UserPartner_Order_Item_StateflowsArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Stateflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Stateflow_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Stateflow_Bool_Exp>;
};


/** columns and relationships of "partner_user" */
export type Partner_UserPartner_Order_Item_Stateflows_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Stateflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Stateflow_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Stateflow_Bool_Exp>;
};


/** columns and relationships of "partner_user" */
export type Partner_UserPartner_Order_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Bool_Exp>;
};


/** columns and relationships of "partner_user" */
export type Partner_UserPartner_Order_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Bool_Exp>;
};


/** columns and relationships of "partner_user" */
export type Partner_UserPartner_Order_StateflowsArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Stateflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Stateflow_Order_By>>;
  where?: InputMaybe<Partner_Order_Stateflow_Bool_Exp>;
};


/** columns and relationships of "partner_user" */
export type Partner_UserPartner_Order_Stateflows_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Stateflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Stateflow_Order_By>>;
  where?: InputMaybe<Partner_Order_Stateflow_Bool_Exp>;
};


/** columns and relationships of "partner_user" */
export type Partner_UserPartner_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Order_By>>;
  where?: InputMaybe<Partner_Order_Bool_Exp>;
};


/** columns and relationships of "partner_user" */
export type Partner_UserPartner_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Order_By>>;
  where?: InputMaybe<Partner_Order_Bool_Exp>;
};


/** columns and relationships of "partner_user" */
export type Partner_UserPartner_User_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Partner_User_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_User_Permission_Order_By>>;
  where?: InputMaybe<Partner_User_Permission_Bool_Exp>;
};


/** columns and relationships of "partner_user" */
export type Partner_UserPartner_User_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_User_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_User_Permission_Order_By>>;
  where?: InputMaybe<Partner_User_Permission_Bool_Exp>;
};

/** aggregated selection of "partner_user" */
export type Partner_User_Aggregate = {
  __typename?: 'partner_user_aggregate';
  aggregate?: Maybe<Partner_User_Aggregate_Fields>;
  nodes: Array<Partner_User>;
};

export type Partner_User_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Partner_User_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Partner_User_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Partner_User_Aggregate_Bool_Exp_Count>;
};

export type Partner_User_Aggregate_Bool_Exp_Bool_And = {
  arguments: Partner_User_Select_Column_Partner_User_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_User_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_User_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Partner_User_Select_Column_Partner_User_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_User_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_User_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Partner_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_User_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "partner_user" */
export type Partner_User_Aggregate_Fields = {
  __typename?: 'partner_user_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Partner_User_Max_Fields>;
  min?: Maybe<Partner_User_Min_Fields>;
};


/** aggregate fields of "partner_user" */
export type Partner_User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Partner_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "partner_user" */
export type Partner_User_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Partner_User_Max_Order_By>;
  min?: InputMaybe<Partner_User_Min_Order_By>;
};

/** input type for inserting array relation for remote table "partner_user" */
export type Partner_User_Arr_Rel_Insert_Input = {
  data: Array<Partner_User_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_User_On_Conflict>;
};

/** Boolean expression to filter rows from the table "partner_user". All fields are combined with a logical 'AND'. */
export type Partner_User_Bool_Exp = {
  _and?: InputMaybe<Array<Partner_User_Bool_Exp>>;
  _not?: InputMaybe<Partner_User_Bool_Exp>;
  _or?: InputMaybe<Array<Partner_User_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_owner?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  partner?: InputMaybe<Partner_Bool_Exp>;
  partner_commission_product_variation_types?: InputMaybe<Partner_Commission_Product_Variation_Type_Bool_Exp>;
  partner_commission_product_variation_types_aggregate?: InputMaybe<Partner_Commission_Product_Variation_Type_Aggregate_Bool_Exp>;
  partner_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner_order_item_commissions?: InputMaybe<Partner_Order_Item_Commission_Bool_Exp>;
  partner_order_item_commissions_aggregate?: InputMaybe<Partner_Order_Item_Commission_Aggregate_Bool_Exp>;
  partner_order_item_stateflows?: InputMaybe<Partner_Order_Item_Stateflow_Bool_Exp>;
  partner_order_item_stateflows_aggregate?: InputMaybe<Partner_Order_Item_Stateflow_Aggregate_Bool_Exp>;
  partner_order_items?: InputMaybe<Partner_Order_Item_Bool_Exp>;
  partner_order_items_aggregate?: InputMaybe<Partner_Order_Item_Aggregate_Bool_Exp>;
  partner_order_stateflows?: InputMaybe<Partner_Order_Stateflow_Bool_Exp>;
  partner_order_stateflows_aggregate?: InputMaybe<Partner_Order_Stateflow_Aggregate_Bool_Exp>;
  partner_orders?: InputMaybe<Partner_Order_Bool_Exp>;
  partner_orders_aggregate?: InputMaybe<Partner_Order_Aggregate_Bool_Exp>;
  partner_user_permissions?: InputMaybe<Partner_User_Permission_Bool_Exp>;
  partner_user_permissions_aggregate?: InputMaybe<Partner_User_Permission_Aggregate_Bool_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "partner_user" */
export enum Partner_User_Constraint {
  /** unique or primary key constraint on columns "id" */
  PartnerUserPkey = 'partner_user_pkey'
}

/** columns and relationships of "partner_user_document" */
export type Partner_User_Document = {
  __typename?: 'partner_user_document';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  document: Documents;
  document_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  partner_order_partner_user_documents: Array<Partner_Order_Partner_User_Document>;
  /** An aggregate relationship */
  partner_order_partner_user_documents_aggregate: Partner_Order_Partner_User_Document_Aggregate;
  /** An object relationship */
  partner_user_document: Partner_User_Document;
  partner_user_document_id: Scalars['uuid']['output'];
  /** An array relationship */
  partner_user_documents: Array<Partner_User_Document>;
  /** An aggregate relationship */
  partner_user_documents_aggregate: Partner_User_Document_Aggregate;
  type?: Maybe<Scalars['DocumentType']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "partner_user_document" */
export type Partner_User_DocumentPartner_Order_Partner_User_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Partner_User_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Partner_User_Document_Order_By>>;
  where?: InputMaybe<Partner_Order_Partner_User_Document_Bool_Exp>;
};


/** columns and relationships of "partner_user_document" */
export type Partner_User_DocumentPartner_Order_Partner_User_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Partner_User_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Partner_User_Document_Order_By>>;
  where?: InputMaybe<Partner_Order_Partner_User_Document_Bool_Exp>;
};


/** columns and relationships of "partner_user_document" */
export type Partner_User_DocumentPartner_User_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Partner_User_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_User_Document_Order_By>>;
  where?: InputMaybe<Partner_User_Document_Bool_Exp>;
};


/** columns and relationships of "partner_user_document" */
export type Partner_User_DocumentPartner_User_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_User_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_User_Document_Order_By>>;
  where?: InputMaybe<Partner_User_Document_Bool_Exp>;
};

/** aggregated selection of "partner_user_document" */
export type Partner_User_Document_Aggregate = {
  __typename?: 'partner_user_document_aggregate';
  aggregate?: Maybe<Partner_User_Document_Aggregate_Fields>;
  nodes: Array<Partner_User_Document>;
};

export type Partner_User_Document_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Partner_User_Document_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Partner_User_Document_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Partner_User_Document_Aggregate_Bool_Exp_Count>;
};

export type Partner_User_Document_Aggregate_Bool_Exp_Bool_And = {
  arguments: Partner_User_Document_Select_Column_Partner_User_Document_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_User_Document_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_User_Document_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Partner_User_Document_Select_Column_Partner_User_Document_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_User_Document_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_User_Document_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Partner_User_Document_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_User_Document_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "partner_user_document" */
export type Partner_User_Document_Aggregate_Fields = {
  __typename?: 'partner_user_document_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Partner_User_Document_Max_Fields>;
  min?: Maybe<Partner_User_Document_Min_Fields>;
};


/** aggregate fields of "partner_user_document" */
export type Partner_User_Document_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Partner_User_Document_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "partner_user_document" */
export type Partner_User_Document_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Partner_User_Document_Max_Order_By>;
  min?: InputMaybe<Partner_User_Document_Min_Order_By>;
};

/** input type for inserting array relation for remote table "partner_user_document" */
export type Partner_User_Document_Arr_Rel_Insert_Input = {
  data: Array<Partner_User_Document_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_User_Document_On_Conflict>;
};

/** Boolean expression to filter rows from the table "partner_user_document". All fields are combined with a logical 'AND'. */
export type Partner_User_Document_Bool_Exp = {
  _and?: InputMaybe<Array<Partner_User_Document_Bool_Exp>>;
  _not?: InputMaybe<Partner_User_Document_Bool_Exp>;
  _or?: InputMaybe<Array<Partner_User_Document_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  document?: InputMaybe<Documents_Bool_Exp>;
  document_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  partner_order_partner_user_documents?: InputMaybe<Partner_Order_Partner_User_Document_Bool_Exp>;
  partner_order_partner_user_documents_aggregate?: InputMaybe<Partner_Order_Partner_User_Document_Aggregate_Bool_Exp>;
  partner_user_document?: InputMaybe<Partner_User_Document_Bool_Exp>;
  partner_user_document_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner_user_documents?: InputMaybe<Partner_User_Document_Bool_Exp>;
  partner_user_documents_aggregate?: InputMaybe<Partner_User_Document_Aggregate_Bool_Exp>;
  type?: InputMaybe<DocumentType_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "partner_user_document" */
export enum Partner_User_Document_Constraint {
  /** unique or primary key constraint on columns "id" */
  PartnerUserDocumentPkey = 'partner_user_document_pkey'
}

/** input type for inserting data into table "partner_user_document" */
export type Partner_User_Document_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  document?: InputMaybe<Documents_Obj_Rel_Insert_Input>;
  document_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_order_partner_user_documents?: InputMaybe<Partner_Order_Partner_User_Document_Arr_Rel_Insert_Input>;
  partner_user_document?: InputMaybe<Partner_User_Document_Obj_Rel_Insert_Input>;
  partner_user_document_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_user_documents?: InputMaybe<Partner_User_Document_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['DocumentType']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Partner_User_Document_Max_Fields = {
  __typename?: 'partner_user_document_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  document_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_user_document_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['DocumentType']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "partner_user_document" */
export type Partner_User_Document_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_user_document_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Partner_User_Document_Min_Fields = {
  __typename?: 'partner_user_document_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  document_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_user_document_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['DocumentType']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "partner_user_document" */
export type Partner_User_Document_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_user_document_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "partner_user_document" */
export type Partner_User_Document_Mutation_Response = {
  __typename?: 'partner_user_document_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Partner_User_Document>;
};

/** input type for inserting object relation for remote table "partner_user_document" */
export type Partner_User_Document_Obj_Rel_Insert_Input = {
  data: Partner_User_Document_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_User_Document_On_Conflict>;
};

/** on_conflict condition type for table "partner_user_document" */
export type Partner_User_Document_On_Conflict = {
  constraint: Partner_User_Document_Constraint;
  update_columns?: Array<Partner_User_Document_Update_Column>;
  where?: InputMaybe<Partner_User_Document_Bool_Exp>;
};

/** Ordering options when selecting data from "partner_user_document". */
export type Partner_User_Document_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document?: InputMaybe<Documents_Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_order_partner_user_documents_aggregate?: InputMaybe<Partner_Order_Partner_User_Document_Aggregate_Order_By>;
  partner_user_document?: InputMaybe<Partner_User_Document_Order_By>;
  partner_user_document_id?: InputMaybe<Order_By>;
  partner_user_documents_aggregate?: InputMaybe<Partner_User_Document_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: partner_user_document */
export type Partner_User_Document_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "partner_user_document" */
export enum Partner_User_Document_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerUserDocumentId = 'partner_user_document_id',
  /** column name */
  Type = 'type',
  /** column name */
  Url = 'url'
}

/** select "partner_user_document_aggregate_bool_exp_bool_and_arguments_columns" columns of table "partner_user_document" */
export enum Partner_User_Document_Select_Column_Partner_User_Document_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "partner_user_document_aggregate_bool_exp_bool_or_arguments_columns" columns of table "partner_user_document" */
export enum Partner_User_Document_Select_Column_Partner_User_Document_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "partner_user_document" */
export type Partner_User_Document_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  document_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_user_document_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['DocumentType']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "partner_user_document" */
export type Partner_User_Document_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Partner_User_Document_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Partner_User_Document_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  document_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_user_document_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['DocumentType']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "partner_user_document" */
export enum Partner_User_Document_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerUserDocumentId = 'partner_user_document_id',
  /** column name */
  Type = 'type',
  /** column name */
  Url = 'url'
}

export type Partner_User_Document_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Partner_User_Document_Set_Input>;
  /** filter the rows which have to be updated */
  where: Partner_User_Document_Bool_Exp;
};

/** input type for inserting data into table "partner_user" */
export type Partner_User_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_owner?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner?: InputMaybe<Partner_Obj_Rel_Insert_Input>;
  partner_commission_product_variation_types?: InputMaybe<Partner_Commission_Product_Variation_Type_Arr_Rel_Insert_Input>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_order_item_commissions?: InputMaybe<Partner_Order_Item_Commission_Arr_Rel_Insert_Input>;
  partner_order_item_stateflows?: InputMaybe<Partner_Order_Item_Stateflow_Arr_Rel_Insert_Input>;
  partner_order_items?: InputMaybe<Partner_Order_Item_Arr_Rel_Insert_Input>;
  partner_order_stateflows?: InputMaybe<Partner_Order_Stateflow_Arr_Rel_Insert_Input>;
  partner_orders?: InputMaybe<Partner_Order_Arr_Rel_Insert_Input>;
  partner_user_permissions?: InputMaybe<Partner_User_Permission_Arr_Rel_Insert_Input>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Partner_User_Max_Fields = {
  __typename?: 'partner_user_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "partner_user" */
export type Partner_User_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Partner_User_Min_Fields = {
  __typename?: 'partner_user_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "partner_user" */
export type Partner_User_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "partner_user" */
export type Partner_User_Mutation_Response = {
  __typename?: 'partner_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Partner_User>;
};

/** input type for inserting object relation for remote table "partner_user" */
export type Partner_User_Obj_Rel_Insert_Input = {
  data: Partner_User_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_User_On_Conflict>;
};

/** on_conflict condition type for table "partner_user" */
export type Partner_User_On_Conflict = {
  constraint: Partner_User_Constraint;
  update_columns?: Array<Partner_User_Update_Column>;
  where?: InputMaybe<Partner_User_Bool_Exp>;
};

/** Ordering options when selecting data from "partner_user". */
export type Partner_User_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_owner?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner?: InputMaybe<Partner_Order_By>;
  partner_commission_product_variation_types_aggregate?: InputMaybe<Partner_Commission_Product_Variation_Type_Aggregate_Order_By>;
  partner_id?: InputMaybe<Order_By>;
  partner_order_item_commissions_aggregate?: InputMaybe<Partner_Order_Item_Commission_Aggregate_Order_By>;
  partner_order_item_stateflows_aggregate?: InputMaybe<Partner_Order_Item_Stateflow_Aggregate_Order_By>;
  partner_order_items_aggregate?: InputMaybe<Partner_Order_Item_Aggregate_Order_By>;
  partner_order_stateflows_aggregate?: InputMaybe<Partner_Order_Stateflow_Aggregate_Order_By>;
  partner_orders_aggregate?: InputMaybe<Partner_Order_Aggregate_Order_By>;
  partner_user_permissions_aggregate?: InputMaybe<Partner_User_Permission_Aggregate_Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "partner_user_permission" */
export type Partner_User_Permission = {
  __typename?: 'partner_user_permission';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  partner_user: Partner_User;
  partner_user_id: Scalars['uuid']['output'];
  /** An object relationship */
  permission: Permission;
  permission_id: Scalars['uuid']['output'];
};

/** aggregated selection of "partner_user_permission" */
export type Partner_User_Permission_Aggregate = {
  __typename?: 'partner_user_permission_aggregate';
  aggregate?: Maybe<Partner_User_Permission_Aggregate_Fields>;
  nodes: Array<Partner_User_Permission>;
};

export type Partner_User_Permission_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Partner_User_Permission_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Partner_User_Permission_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Partner_User_Permission_Aggregate_Bool_Exp_Count>;
};

export type Partner_User_Permission_Aggregate_Bool_Exp_Bool_And = {
  arguments: Partner_User_Permission_Select_Column_Partner_User_Permission_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_User_Permission_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_User_Permission_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Partner_User_Permission_Select_Column_Partner_User_Permission_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_User_Permission_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_User_Permission_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Partner_User_Permission_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_User_Permission_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "partner_user_permission" */
export type Partner_User_Permission_Aggregate_Fields = {
  __typename?: 'partner_user_permission_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Partner_User_Permission_Max_Fields>;
  min?: Maybe<Partner_User_Permission_Min_Fields>;
};


/** aggregate fields of "partner_user_permission" */
export type Partner_User_Permission_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Partner_User_Permission_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "partner_user_permission" */
export type Partner_User_Permission_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Partner_User_Permission_Max_Order_By>;
  min?: InputMaybe<Partner_User_Permission_Min_Order_By>;
};

/** input type for inserting array relation for remote table "partner_user_permission" */
export type Partner_User_Permission_Arr_Rel_Insert_Input = {
  data: Array<Partner_User_Permission_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_User_Permission_On_Conflict>;
};

/** Boolean expression to filter rows from the table "partner_user_permission". All fields are combined with a logical 'AND'. */
export type Partner_User_Permission_Bool_Exp = {
  _and?: InputMaybe<Array<Partner_User_Permission_Bool_Exp>>;
  _not?: InputMaybe<Partner_User_Permission_Bool_Exp>;
  _or?: InputMaybe<Array<Partner_User_Permission_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  disabled?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  partner_user?: InputMaybe<Partner_User_Bool_Exp>;
  partner_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  permission?: InputMaybe<Permission_Bool_Exp>;
  permission_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "partner_user_permission" */
export enum Partner_User_Permission_Constraint {
  /** unique or primary key constraint on columns "id" */
  PartnerUserPermissionPkey = 'partner_user_permission_pkey'
}

/** input type for inserting data into table "partner_user_permission" */
export type Partner_User_Permission_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_user?: InputMaybe<Partner_User_Obj_Rel_Insert_Input>;
  partner_user_id?: InputMaybe<Scalars['uuid']['input']>;
  permission?: InputMaybe<Permission_Obj_Rel_Insert_Input>;
  permission_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Partner_User_Permission_Max_Fields = {
  __typename?: 'partner_user_permission_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_user_id?: Maybe<Scalars['uuid']['output']>;
  permission_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "partner_user_permission" */
export type Partner_User_Permission_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_user_id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Partner_User_Permission_Min_Fields = {
  __typename?: 'partner_user_permission_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_user_id?: Maybe<Scalars['uuid']['output']>;
  permission_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "partner_user_permission" */
export type Partner_User_Permission_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_user_id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "partner_user_permission" */
export type Partner_User_Permission_Mutation_Response = {
  __typename?: 'partner_user_permission_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Partner_User_Permission>;
};

/** on_conflict condition type for table "partner_user_permission" */
export type Partner_User_Permission_On_Conflict = {
  constraint: Partner_User_Permission_Constraint;
  update_columns?: Array<Partner_User_Permission_Update_Column>;
  where?: InputMaybe<Partner_User_Permission_Bool_Exp>;
};

/** Ordering options when selecting data from "partner_user_permission". */
export type Partner_User_Permission_Order_By = {
  created_at?: InputMaybe<Order_By>;
  disabled?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_user?: InputMaybe<Partner_User_Order_By>;
  partner_user_id?: InputMaybe<Order_By>;
  permission?: InputMaybe<Permission_Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: partner_user_permission */
export type Partner_User_Permission_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "partner_user_permission" */
export enum Partner_User_Permission_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerUserId = 'partner_user_id',
  /** column name */
  PermissionId = 'permission_id'
}

/** select "partner_user_permission_aggregate_bool_exp_bool_and_arguments_columns" columns of table "partner_user_permission" */
export enum Partner_User_Permission_Select_Column_Partner_User_Permission_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Disabled = 'disabled',
  /** column name */
  IsActive = 'is_active'
}

/** select "partner_user_permission_aggregate_bool_exp_bool_or_arguments_columns" columns of table "partner_user_permission" */
export enum Partner_User_Permission_Select_Column_Partner_User_Permission_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Disabled = 'disabled',
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "partner_user_permission" */
export type Partner_User_Permission_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_user_id?: InputMaybe<Scalars['uuid']['input']>;
  permission_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "partner_user_permission" */
export type Partner_User_Permission_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Partner_User_Permission_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Partner_User_Permission_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_user_id?: InputMaybe<Scalars['uuid']['input']>;
  permission_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "partner_user_permission" */
export enum Partner_User_Permission_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerUserId = 'partner_user_id',
  /** column name */
  PermissionId = 'permission_id'
}

export type Partner_User_Permission_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Partner_User_Permission_Set_Input>;
  /** filter the rows which have to be updated */
  where: Partner_User_Permission_Bool_Exp;
};

/** primary key columns input for table: partner_user */
export type Partner_User_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "partner_user" */
export enum Partner_User_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsOwner = 'is_owner',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  UserId = 'user_id'
}

/** select "partner_user_aggregate_bool_exp_bool_and_arguments_columns" columns of table "partner_user" */
export enum Partner_User_Select_Column_Partner_User_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsOwner = 'is_owner'
}

/** select "partner_user_aggregate_bool_exp_bool_or_arguments_columns" columns of table "partner_user" */
export enum Partner_User_Select_Column_Partner_User_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsOwner = 'is_owner'
}

/** input type for updating data in table "partner_user" */
export type Partner_User_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_owner?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "partner_user" */
export type Partner_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Partner_User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Partner_User_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_owner?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "partner_user" */
export enum Partner_User_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsOwner = 'is_owner',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  UserId = 'user_id'
}

export type Partner_User_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Partner_User_Set_Input>;
  /** filter the rows which have to be updated */
  where: Partner_User_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Partner_Var_Pop_Fields = {
  __typename?: 'partner_var_pop_fields';
  popularity?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "partner" */
export type Partner_Var_Pop_Order_By = {
  popularity?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Partner_Var_Samp_Fields = {
  __typename?: 'partner_var_samp_fields';
  popularity?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "partner" */
export type Partner_Var_Samp_Order_By = {
  popularity?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Partner_Variance_Fields = {
  __typename?: 'partner_variance_fields';
  popularity?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "partner" */
export type Partner_Variance_Order_By = {
  popularity?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
};

/** columns and relationships of "partner_vehicle" */
export type Partner_Vehicle = {
  __typename?: 'partner_vehicle';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  fillupRequestsByTargetPartnerVehicleId: Array<Fillup_Request>;
  /** An aggregate relationship */
  fillupRequestsByTargetPartnerVehicleId_aggregate: Fillup_Request_Aggregate;
  /** An array relationship */
  fillup_requests: Array<Fillup_Request>;
  /** An aggregate relationship */
  fillup_requests_aggregate: Fillup_Request_Aggregate;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  partner: Partner;
  partner_id: Scalars['uuid']['output'];
  /** An object relationship */
  partner_vehicle_state?: Maybe<Partner_Vehicle_State>;
  status?: Maybe<Partner_Vehicle_State_Enum>;
  /** An object relationship */
  vehicle: Vehicle;
  vehicle_id: Scalars['uuid']['output'];
};


/** columns and relationships of "partner_vehicle" */
export type Partner_VehicleFillupRequestsByTargetPartnerVehicleIdArgs = {
  distinct_on?: InputMaybe<Array<Fillup_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fillup_Request_Order_By>>;
  where?: InputMaybe<Fillup_Request_Bool_Exp>;
};


/** columns and relationships of "partner_vehicle" */
export type Partner_VehicleFillupRequestsByTargetPartnerVehicleId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fillup_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fillup_Request_Order_By>>;
  where?: InputMaybe<Fillup_Request_Bool_Exp>;
};


/** columns and relationships of "partner_vehicle" */
export type Partner_VehicleFillup_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Fillup_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fillup_Request_Order_By>>;
  where?: InputMaybe<Fillup_Request_Bool_Exp>;
};


/** columns and relationships of "partner_vehicle" */
export type Partner_VehicleFillup_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fillup_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fillup_Request_Order_By>>;
  where?: InputMaybe<Fillup_Request_Bool_Exp>;
};

/** aggregated selection of "partner_vehicle" */
export type Partner_Vehicle_Aggregate = {
  __typename?: 'partner_vehicle_aggregate';
  aggregate?: Maybe<Partner_Vehicle_Aggregate_Fields>;
  nodes: Array<Partner_Vehicle>;
};

export type Partner_Vehicle_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Partner_Vehicle_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Partner_Vehicle_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Partner_Vehicle_Aggregate_Bool_Exp_Count>;
};

export type Partner_Vehicle_Aggregate_Bool_Exp_Bool_And = {
  arguments: Partner_Vehicle_Select_Column_Partner_Vehicle_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Vehicle_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_Vehicle_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Partner_Vehicle_Select_Column_Partner_Vehicle_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Vehicle_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Partner_Vehicle_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Partner_Vehicle_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Partner_Vehicle_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "partner_vehicle" */
export type Partner_Vehicle_Aggregate_Fields = {
  __typename?: 'partner_vehicle_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Partner_Vehicle_Max_Fields>;
  min?: Maybe<Partner_Vehicle_Min_Fields>;
};


/** aggregate fields of "partner_vehicle" */
export type Partner_Vehicle_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Partner_Vehicle_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "partner_vehicle" */
export type Partner_Vehicle_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Partner_Vehicle_Max_Order_By>;
  min?: InputMaybe<Partner_Vehicle_Min_Order_By>;
};

/** input type for inserting array relation for remote table "partner_vehicle" */
export type Partner_Vehicle_Arr_Rel_Insert_Input = {
  data: Array<Partner_Vehicle_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_Vehicle_On_Conflict>;
};

/** Boolean expression to filter rows from the table "partner_vehicle". All fields are combined with a logical 'AND'. */
export type Partner_Vehicle_Bool_Exp = {
  _and?: InputMaybe<Array<Partner_Vehicle_Bool_Exp>>;
  _not?: InputMaybe<Partner_Vehicle_Bool_Exp>;
  _or?: InputMaybe<Array<Partner_Vehicle_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  fillupRequestsByTargetPartnerVehicleId?: InputMaybe<Fillup_Request_Bool_Exp>;
  fillupRequestsByTargetPartnerVehicleId_aggregate?: InputMaybe<Fillup_Request_Aggregate_Bool_Exp>;
  fillup_requests?: InputMaybe<Fillup_Request_Bool_Exp>;
  fillup_requests_aggregate?: InputMaybe<Fillup_Request_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  partner?: InputMaybe<Partner_Bool_Exp>;
  partner_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner_vehicle_state?: InputMaybe<Partner_Vehicle_State_Bool_Exp>;
  status?: InputMaybe<Partner_Vehicle_State_Enum_Comparison_Exp>;
  vehicle?: InputMaybe<Vehicle_Bool_Exp>;
  vehicle_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "partner_vehicle" */
export enum Partner_Vehicle_Constraint {
  /** unique or primary key constraint on columns "id" */
  PartnerVehiclePkey = 'partner_vehicle_pkey'
}

/** input type for inserting data into table "partner_vehicle" */
export type Partner_Vehicle_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  fillupRequestsByTargetPartnerVehicleId?: InputMaybe<Fillup_Request_Arr_Rel_Insert_Input>;
  fillup_requests?: InputMaybe<Fillup_Request_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner?: InputMaybe<Partner_Obj_Rel_Insert_Input>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_vehicle_state?: InputMaybe<Partner_Vehicle_State_Obj_Rel_Insert_Input>;
  status?: InputMaybe<Partner_Vehicle_State_Enum>;
  vehicle?: InputMaybe<Vehicle_Obj_Rel_Insert_Input>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Partner_Vehicle_Max_Fields = {
  __typename?: 'partner_vehicle_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "partner_vehicle" */
export type Partner_Vehicle_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Partner_Vehicle_Min_Fields = {
  __typename?: 'partner_vehicle_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "partner_vehicle" */
export type Partner_Vehicle_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "partner_vehicle" */
export type Partner_Vehicle_Mutation_Response = {
  __typename?: 'partner_vehicle_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Partner_Vehicle>;
};

/** input type for inserting object relation for remote table "partner_vehicle" */
export type Partner_Vehicle_Obj_Rel_Insert_Input = {
  data: Partner_Vehicle_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_Vehicle_On_Conflict>;
};

/** on_conflict condition type for table "partner_vehicle" */
export type Partner_Vehicle_On_Conflict = {
  constraint: Partner_Vehicle_Constraint;
  update_columns?: Array<Partner_Vehicle_Update_Column>;
  where?: InputMaybe<Partner_Vehicle_Bool_Exp>;
};

/** Ordering options when selecting data from "partner_vehicle". */
export type Partner_Vehicle_Order_By = {
  created_at?: InputMaybe<Order_By>;
  fillupRequestsByTargetPartnerVehicleId_aggregate?: InputMaybe<Fillup_Request_Aggregate_Order_By>;
  fillup_requests_aggregate?: InputMaybe<Fillup_Request_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner?: InputMaybe<Partner_Order_By>;
  partner_id?: InputMaybe<Order_By>;
  partner_vehicle_state?: InputMaybe<Partner_Vehicle_State_Order_By>;
  status?: InputMaybe<Order_By>;
  vehicle?: InputMaybe<Vehicle_Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: partner_vehicle */
export type Partner_Vehicle_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "partner_vehicle" */
export enum Partner_Vehicle_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  Status = 'status',
  /** column name */
  VehicleId = 'vehicle_id'
}

/** select "partner_vehicle_aggregate_bool_exp_bool_and_arguments_columns" columns of table "partner_vehicle" */
export enum Partner_Vehicle_Select_Column_Partner_Vehicle_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "partner_vehicle_aggregate_bool_exp_bool_or_arguments_columns" columns of table "partner_vehicle" */
export enum Partner_Vehicle_Select_Column_Partner_Vehicle_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "partner_vehicle" */
export type Partner_Vehicle_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Partner_Vehicle_State_Enum>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "partner_vehicle_state" */
export type Partner_Vehicle_State = {
  __typename?: 'partner_vehicle_state';
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  driver_vehicles: Array<Driver_Vehicle>;
  /** An aggregate relationship */
  driver_vehicles_aggregate: Driver_Vehicle_Aggregate;
  /** An array relationship */
  partner_vehicles: Array<Partner_Vehicle>;
  /** An aggregate relationship */
  partner_vehicles_aggregate: Partner_Vehicle_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "partner_vehicle_state" */
export type Partner_Vehicle_StateDriver_VehiclesArgs = {
  distinct_on?: InputMaybe<Array<Driver_Vehicle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Vehicle_Order_By>>;
  where?: InputMaybe<Driver_Vehicle_Bool_Exp>;
};


/** columns and relationships of "partner_vehicle_state" */
export type Partner_Vehicle_StateDriver_Vehicles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Driver_Vehicle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Vehicle_Order_By>>;
  where?: InputMaybe<Driver_Vehicle_Bool_Exp>;
};


/** columns and relationships of "partner_vehicle_state" */
export type Partner_Vehicle_StatePartner_VehiclesArgs = {
  distinct_on?: InputMaybe<Array<Partner_Vehicle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Vehicle_Order_By>>;
  where?: InputMaybe<Partner_Vehicle_Bool_Exp>;
};


/** columns and relationships of "partner_vehicle_state" */
export type Partner_Vehicle_StatePartner_Vehicles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Vehicle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Vehicle_Order_By>>;
  where?: InputMaybe<Partner_Vehicle_Bool_Exp>;
};

/** aggregated selection of "partner_vehicle_state" */
export type Partner_Vehicle_State_Aggregate = {
  __typename?: 'partner_vehicle_state_aggregate';
  aggregate?: Maybe<Partner_Vehicle_State_Aggregate_Fields>;
  nodes: Array<Partner_Vehicle_State>;
};

/** aggregate fields of "partner_vehicle_state" */
export type Partner_Vehicle_State_Aggregate_Fields = {
  __typename?: 'partner_vehicle_state_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Partner_Vehicle_State_Max_Fields>;
  min?: Maybe<Partner_Vehicle_State_Min_Fields>;
};


/** aggregate fields of "partner_vehicle_state" */
export type Partner_Vehicle_State_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Partner_Vehicle_State_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "partner_vehicle_state". All fields are combined with a logical 'AND'. */
export type Partner_Vehicle_State_Bool_Exp = {
  _and?: InputMaybe<Array<Partner_Vehicle_State_Bool_Exp>>;
  _not?: InputMaybe<Partner_Vehicle_State_Bool_Exp>;
  _or?: InputMaybe<Array<Partner_Vehicle_State_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  driver_vehicles?: InputMaybe<Driver_Vehicle_Bool_Exp>;
  driver_vehicles_aggregate?: InputMaybe<Driver_Vehicle_Aggregate_Bool_Exp>;
  partner_vehicles?: InputMaybe<Partner_Vehicle_Bool_Exp>;
  partner_vehicles_aggregate?: InputMaybe<Partner_Vehicle_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "partner_vehicle_state" */
export enum Partner_Vehicle_State_Constraint {
  /** unique or primary key constraint on columns "value" */
  PartnerVehicleStatePkey = 'partner_vehicle_state_pkey'
}

export enum Partner_Vehicle_State_Enum {
  /** DELAYED */
  Delayed = 'DELAYED',
  /** ENGINE_OFF */
  EngineOff = 'ENGINE_OFF',
  /** IDLE */
  Idle = 'IDLE',
  /** LOW_INVENTORY */
  LowInventory = 'LOW_INVENTORY',
  /** MOVING_NO_ORDER */
  MovingNoOrder = 'MOVING_NO_ORDER',
  /** MOVING_ORDER_STARTED */
  MovingOrderStarted = 'MOVING_ORDER_STARTED',
  /** OFF_DUTY */
  OffDuty = 'OFF_DUTY'
}

/** Boolean expression to compare columns of type "partner_vehicle_state_enum". All fields are combined with logical 'AND'. */
export type Partner_Vehicle_State_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Partner_Vehicle_State_Enum>;
  _in?: InputMaybe<Array<Partner_Vehicle_State_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Partner_Vehicle_State_Enum>;
  _nin?: InputMaybe<Array<Partner_Vehicle_State_Enum>>;
};

/** input type for inserting data into table "partner_vehicle_state" */
export type Partner_Vehicle_State_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  driver_vehicles?: InputMaybe<Driver_Vehicle_Arr_Rel_Insert_Input>;
  partner_vehicles?: InputMaybe<Partner_Vehicle_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Partner_Vehicle_State_Max_Fields = {
  __typename?: 'partner_vehicle_state_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Partner_Vehicle_State_Min_Fields = {
  __typename?: 'partner_vehicle_state_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "partner_vehicle_state" */
export type Partner_Vehicle_State_Mutation_Response = {
  __typename?: 'partner_vehicle_state_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Partner_Vehicle_State>;
};

/** input type for inserting object relation for remote table "partner_vehicle_state" */
export type Partner_Vehicle_State_Obj_Rel_Insert_Input = {
  data: Partner_Vehicle_State_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_Vehicle_State_On_Conflict>;
};

/** on_conflict condition type for table "partner_vehicle_state" */
export type Partner_Vehicle_State_On_Conflict = {
  constraint: Partner_Vehicle_State_Constraint;
  update_columns?: Array<Partner_Vehicle_State_Update_Column>;
  where?: InputMaybe<Partner_Vehicle_State_Bool_Exp>;
};

/** Ordering options when selecting data from "partner_vehicle_state". */
export type Partner_Vehicle_State_Order_By = {
  comment?: InputMaybe<Order_By>;
  driver_vehicles_aggregate?: InputMaybe<Driver_Vehicle_Aggregate_Order_By>;
  partner_vehicles_aggregate?: InputMaybe<Partner_Vehicle_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: partner_vehicle_state */
export type Partner_Vehicle_State_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "partner_vehicle_state" */
export enum Partner_Vehicle_State_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "partner_vehicle_state" */
export type Partner_Vehicle_State_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "partner_vehicle_state" */
export type Partner_Vehicle_State_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Partner_Vehicle_State_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Partner_Vehicle_State_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "partner_vehicle_state" */
export enum Partner_Vehicle_State_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Partner_Vehicle_State_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Partner_Vehicle_State_Set_Input>;
  /** filter the rows which have to be updated */
  where: Partner_Vehicle_State_Bool_Exp;
};

/** Streaming cursor of the table "partner_vehicle" */
export type Partner_Vehicle_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Partner_Vehicle_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Partner_Vehicle_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Partner_Vehicle_State_Enum>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "partner_vehicle" */
export enum Partner_Vehicle_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  Status = 'status',
  /** column name */
  VehicleId = 'vehicle_id'
}

export type Partner_Vehicle_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Partner_Vehicle_Set_Input>;
  /** filter the rows which have to be updated */
  where: Partner_Vehicle_Bool_Exp;
};

/** columns and relationships of "payment_type" */
export type Payment_Type = {
  __typename?: 'payment_type';
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  user_ledgers: Array<User_Ledger>;
  /** An aggregate relationship */
  user_ledgers_aggregate: User_Ledger_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "payment_type" */
export type Payment_TypeUser_LedgersArgs = {
  distinct_on?: InputMaybe<Array<User_Ledger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Ledger_Order_By>>;
  where?: InputMaybe<User_Ledger_Bool_Exp>;
};


/** columns and relationships of "payment_type" */
export type Payment_TypeUser_Ledgers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Ledger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Ledger_Order_By>>;
  where?: InputMaybe<User_Ledger_Bool_Exp>;
};

/** aggregated selection of "payment_type" */
export type Payment_Type_Aggregate = {
  __typename?: 'payment_type_aggregate';
  aggregate?: Maybe<Payment_Type_Aggregate_Fields>;
  nodes: Array<Payment_Type>;
};

/** aggregate fields of "payment_type" */
export type Payment_Type_Aggregate_Fields = {
  __typename?: 'payment_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Payment_Type_Max_Fields>;
  min?: Maybe<Payment_Type_Min_Fields>;
};


/** aggregate fields of "payment_type" */
export type Payment_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Payment_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "payment_type". All fields are combined with a logical 'AND'. */
export type Payment_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Payment_Type_Bool_Exp>>;
  _not?: InputMaybe<Payment_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Payment_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  user_ledgers?: InputMaybe<User_Ledger_Bool_Exp>;
  user_ledgers_aggregate?: InputMaybe<User_Ledger_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "payment_type" */
export enum Payment_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  PaymentTypePkey = 'payment_type_pkey'
}

export enum Payment_Type_Enum {
  /** CREDIT */
  Credit = 'CREDIT',
  /** DEBIT */
  Debit = 'DEBIT'
}

/** Boolean expression to compare columns of type "payment_type_enum". All fields are combined with logical 'AND'. */
export type Payment_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Payment_Type_Enum>;
  _in?: InputMaybe<Array<Payment_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Payment_Type_Enum>;
  _nin?: InputMaybe<Array<Payment_Type_Enum>>;
};

/** input type for inserting data into table "payment_type" */
export type Payment_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  user_ledgers?: InputMaybe<User_Ledger_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Payment_Type_Max_Fields = {
  __typename?: 'payment_type_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Payment_Type_Min_Fields = {
  __typename?: 'payment_type_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "payment_type" */
export type Payment_Type_Mutation_Response = {
  __typename?: 'payment_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Payment_Type>;
};

/** input type for inserting object relation for remote table "payment_type" */
export type Payment_Type_Obj_Rel_Insert_Input = {
  data: Payment_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Payment_Type_On_Conflict>;
};

/** on_conflict condition type for table "payment_type" */
export type Payment_Type_On_Conflict = {
  constraint: Payment_Type_Constraint;
  update_columns?: Array<Payment_Type_Update_Column>;
  where?: InputMaybe<Payment_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "payment_type". */
export type Payment_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  user_ledgers_aggregate?: InputMaybe<User_Ledger_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: payment_type */
export type Payment_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "payment_type" */
export enum Payment_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "payment_type" */
export type Payment_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "payment_type" */
export type Payment_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payment_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Payment_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "payment_type" */
export enum Payment_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Payment_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Payment_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Payment_Type_Bool_Exp;
};

/** columns and relationships of "period_frequency" */
export type Period_Frequency = {
  __typename?: 'period_frequency';
  comment: Scalars['String']['output'];
  /** An array relationship */
  dispensing_rules: Array<Dispensing_Rules>;
  /** An aggregate relationship */
  dispensing_rules_aggregate: Dispensing_Rules_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "period_frequency" */
export type Period_FrequencyDispensing_RulesArgs = {
  distinct_on?: InputMaybe<Array<Dispensing_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dispensing_Rules_Order_By>>;
  where?: InputMaybe<Dispensing_Rules_Bool_Exp>;
};


/** columns and relationships of "period_frequency" */
export type Period_FrequencyDispensing_Rules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dispensing_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dispensing_Rules_Order_By>>;
  where?: InputMaybe<Dispensing_Rules_Bool_Exp>;
};

/** aggregated selection of "period_frequency" */
export type Period_Frequency_Aggregate = {
  __typename?: 'period_frequency_aggregate';
  aggregate?: Maybe<Period_Frequency_Aggregate_Fields>;
  nodes: Array<Period_Frequency>;
};

/** aggregate fields of "period_frequency" */
export type Period_Frequency_Aggregate_Fields = {
  __typename?: 'period_frequency_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Period_Frequency_Max_Fields>;
  min?: Maybe<Period_Frequency_Min_Fields>;
};


/** aggregate fields of "period_frequency" */
export type Period_Frequency_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Period_Frequency_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "period_frequency". All fields are combined with a logical 'AND'. */
export type Period_Frequency_Bool_Exp = {
  _and?: InputMaybe<Array<Period_Frequency_Bool_Exp>>;
  _not?: InputMaybe<Period_Frequency_Bool_Exp>;
  _or?: InputMaybe<Array<Period_Frequency_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  dispensing_rules?: InputMaybe<Dispensing_Rules_Bool_Exp>;
  dispensing_rules_aggregate?: InputMaybe<Dispensing_Rules_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "period_frequency" */
export enum Period_Frequency_Constraint {
  /** unique or primary key constraint on columns "value" */
  PeriodFrequencyPkey = 'period_frequency_pkey'
}

export enum Period_Frequency_Enum {
  /** DAILY */
  Daily = 'DAILY',
  /** MONTHLY */
  Monthly = 'MONTHLY',
  /** WEEKLY */
  Weekly = 'WEEKLY'
}

/** Boolean expression to compare columns of type "period_frequency_enum". All fields are combined with logical 'AND'. */
export type Period_Frequency_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Period_Frequency_Enum>;
  _in?: InputMaybe<Array<Period_Frequency_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Period_Frequency_Enum>;
  _nin?: InputMaybe<Array<Period_Frequency_Enum>>;
};

/** input type for inserting data into table "period_frequency" */
export type Period_Frequency_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  dispensing_rules?: InputMaybe<Dispensing_Rules_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Period_Frequency_Max_Fields = {
  __typename?: 'period_frequency_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Period_Frequency_Min_Fields = {
  __typename?: 'period_frequency_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "period_frequency" */
export type Period_Frequency_Mutation_Response = {
  __typename?: 'period_frequency_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Period_Frequency>;
};

/** input type for inserting object relation for remote table "period_frequency" */
export type Period_Frequency_Obj_Rel_Insert_Input = {
  data: Period_Frequency_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Period_Frequency_On_Conflict>;
};

/** on_conflict condition type for table "period_frequency" */
export type Period_Frequency_On_Conflict = {
  constraint: Period_Frequency_Constraint;
  update_columns?: Array<Period_Frequency_Update_Column>;
  where?: InputMaybe<Period_Frequency_Bool_Exp>;
};

/** Ordering options when selecting data from "period_frequency". */
export type Period_Frequency_Order_By = {
  comment?: InputMaybe<Order_By>;
  dispensing_rules_aggregate?: InputMaybe<Dispensing_Rules_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: period_frequency */
export type Period_Frequency_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "period_frequency" */
export enum Period_Frequency_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "period_frequency" */
export type Period_Frequency_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "period_frequency" */
export type Period_Frequency_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Period_Frequency_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Period_Frequency_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "period_frequency" */
export enum Period_Frequency_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Period_Frequency_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Period_Frequency_Set_Input>;
  /** filter the rows which have to be updated */
  where: Period_Frequency_Bool_Exp;
};

/** columns and relationships of "permission" */
export type Permission = {
  __typename?: 'permission';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  key?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  organization_user_permissions: Array<Organization_User_Permission>;
  /** An aggregate relationship */
  organization_user_permissions_aggregate: Organization_User_Permission_Aggregate;
  /** An array relationship */
  partner_user_permissions: Array<Partner_User_Permission>;
  /** An aggregate relationship */
  partner_user_permissions_aggregate: Partner_User_Permission_Aggregate;
};


/** columns and relationships of "permission" */
export type PermissionOrganization_User_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Permission_Order_By>>;
  where?: InputMaybe<Organization_User_Permission_Bool_Exp>;
};


/** columns and relationships of "permission" */
export type PermissionOrganization_User_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Permission_Order_By>>;
  where?: InputMaybe<Organization_User_Permission_Bool_Exp>;
};


/** columns and relationships of "permission" */
export type PermissionPartner_User_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Partner_User_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_User_Permission_Order_By>>;
  where?: InputMaybe<Partner_User_Permission_Bool_Exp>;
};


/** columns and relationships of "permission" */
export type PermissionPartner_User_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_User_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_User_Permission_Order_By>>;
  where?: InputMaybe<Partner_User_Permission_Bool_Exp>;
};

/** aggregated selection of "permission" */
export type Permission_Aggregate = {
  __typename?: 'permission_aggregate';
  aggregate?: Maybe<Permission_Aggregate_Fields>;
  nodes: Array<Permission>;
};

/** aggregate fields of "permission" */
export type Permission_Aggregate_Fields = {
  __typename?: 'permission_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Permission_Max_Fields>;
  min?: Maybe<Permission_Min_Fields>;
};


/** aggregate fields of "permission" */
export type Permission_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Permission_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "permission". All fields are combined with a logical 'AND'. */
export type Permission_Bool_Exp = {
  _and?: InputMaybe<Array<Permission_Bool_Exp>>;
  _not?: InputMaybe<Permission_Bool_Exp>;
  _or?: InputMaybe<Array<Permission_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization_user_permissions?: InputMaybe<Organization_User_Permission_Bool_Exp>;
  organization_user_permissions_aggregate?: InputMaybe<Organization_User_Permission_Aggregate_Bool_Exp>;
  partner_user_permissions?: InputMaybe<Partner_User_Permission_Bool_Exp>;
  partner_user_permissions_aggregate?: InputMaybe<Partner_User_Permission_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "permission" */
export enum Permission_Constraint {
  /** unique or primary key constraint on columns "id" */
  PermissionPkey = 'permission_pkey'
}

/** input type for inserting data into table "permission" */
export type Permission_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_user_permissions?: InputMaybe<Organization_User_Permission_Arr_Rel_Insert_Input>;
  partner_user_permissions?: InputMaybe<Partner_User_Permission_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Permission_Max_Fields = {
  __typename?: 'permission_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Permission_Min_Fields = {
  __typename?: 'permission_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "permission" */
export type Permission_Mutation_Response = {
  __typename?: 'permission_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Permission>;
};

/** input type for inserting object relation for remote table "permission" */
export type Permission_Obj_Rel_Insert_Input = {
  data: Permission_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Permission_On_Conflict>;
};

/** on_conflict condition type for table "permission" */
export type Permission_On_Conflict = {
  constraint: Permission_Constraint;
  update_columns?: Array<Permission_Update_Column>;
  where?: InputMaybe<Permission_Bool_Exp>;
};

/** Ordering options when selecting data from "permission". */
export type Permission_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_user_permissions_aggregate?: InputMaybe<Organization_User_Permission_Aggregate_Order_By>;
  partner_user_permissions_aggregate?: InputMaybe<Partner_User_Permission_Aggregate_Order_By>;
};

/** primary key columns input for table: permission */
export type Permission_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "permission" */
export enum Permission_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Key = 'key',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "permission" */
export type Permission_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "permission" */
export type Permission_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Permission_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Permission_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "permission" */
export enum Permission_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Key = 'key',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name'
}

export type Permission_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Permission_Set_Input>;
  /** filter the rows which have to be updated */
  where: Permission_Bool_Exp;
};

/** columns and relationships of "permit" */
export type Permit = {
  __typename?: 'permit';
  created_at: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  driver_permits: Array<Driver_Permit>;
  /** An aggregate relationship */
  driver_permits_aggregate: Driver_Permit_Aggregate;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified: Scalars['timestamptz']['output'];
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name: Scalars['String']['output'];
  /** An array relationship */
  vehicle_permits: Array<Vehicle_Permit>;
  /** An aggregate relationship */
  vehicle_permits_aggregate: Vehicle_Permit_Aggregate;
};


/** columns and relationships of "permit" */
export type PermitDriver_PermitsArgs = {
  distinct_on?: InputMaybe<Array<Driver_Permit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Permit_Order_By>>;
  where?: InputMaybe<Driver_Permit_Bool_Exp>;
};


/** columns and relationships of "permit" */
export type PermitDriver_Permits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Driver_Permit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Permit_Order_By>>;
  where?: InputMaybe<Driver_Permit_Bool_Exp>;
};


/** columns and relationships of "permit" */
export type PermitVehicle_PermitsArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Permit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Permit_Order_By>>;
  where?: InputMaybe<Vehicle_Permit_Bool_Exp>;
};


/** columns and relationships of "permit" */
export type PermitVehicle_Permits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Permit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Permit_Order_By>>;
  where?: InputMaybe<Vehicle_Permit_Bool_Exp>;
};

/** aggregated selection of "permit" */
export type Permit_Aggregate = {
  __typename?: 'permit_aggregate';
  aggregate?: Maybe<Permit_Aggregate_Fields>;
  nodes: Array<Permit>;
};

/** aggregate fields of "permit" */
export type Permit_Aggregate_Fields = {
  __typename?: 'permit_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Permit_Max_Fields>;
  min?: Maybe<Permit_Min_Fields>;
};


/** aggregate fields of "permit" */
export type Permit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Permit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "permit". All fields are combined with a logical 'AND'. */
export type Permit_Bool_Exp = {
  _and?: InputMaybe<Array<Permit_Bool_Exp>>;
  _not?: InputMaybe<Permit_Bool_Exp>;
  _or?: InputMaybe<Array<Permit_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  driver_permits?: InputMaybe<Driver_Permit_Bool_Exp>;
  driver_permits_aggregate?: InputMaybe<Driver_Permit_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  vehicle_permits?: InputMaybe<Vehicle_Permit_Bool_Exp>;
  vehicle_permits_aggregate?: InputMaybe<Vehicle_Permit_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "permit" */
export enum Permit_Constraint {
  /** unique or primary key constraint on columns "name" */
  PermitNameKey = 'permit_name_key',
  /** unique or primary key constraint on columns "id" */
  PermitPkey = 'permit_pkey'
}

/** input type for inserting data into table "permit" */
export type Permit_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  driver_permits?: InputMaybe<Driver_Permit_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  vehicle_permits?: InputMaybe<Vehicle_Permit_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Permit_Max_Fields = {
  __typename?: 'permit_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Permit_Min_Fields = {
  __typename?: 'permit_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "permit" */
export type Permit_Mutation_Response = {
  __typename?: 'permit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Permit>;
};

/** input type for inserting object relation for remote table "permit" */
export type Permit_Obj_Rel_Insert_Input = {
  data: Permit_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Permit_On_Conflict>;
};

/** on_conflict condition type for table "permit" */
export type Permit_On_Conflict = {
  constraint: Permit_Constraint;
  update_columns?: Array<Permit_Update_Column>;
  where?: InputMaybe<Permit_Bool_Exp>;
};

/** Ordering options when selecting data from "permit". */
export type Permit_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  driver_permits_aggregate?: InputMaybe<Driver_Permit_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  vehicle_permits_aggregate?: InputMaybe<Vehicle_Permit_Aggregate_Order_By>;
};

/** primary key columns input for table: permit */
export type Permit_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "permit" */
export enum Permit_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "permit" */
export type Permit_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "permit" */
export type Permit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Permit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Permit_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "permit" */
export enum Permit_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name'
}

export type Permit_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Permit_Set_Input>;
  /** filter the rows which have to be updated */
  where: Permit_Bool_Exp;
};

/** columns and relationships of "photo_type" */
export type Photo_Type = {
  __typename?: 'photo_type';
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  driver_duty_photos: Array<Driver_Duty_Photos>;
  /** An aggregate relationship */
  driver_duty_photos_aggregate: Driver_Duty_Photos_Aggregate;
  /** An array relationship */
  order_photos: Array<Order_Photos>;
  /** An aggregate relationship */
  order_photos_aggregate: Order_Photos_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "photo_type" */
export type Photo_TypeDriver_Duty_PhotosArgs = {
  distinct_on?: InputMaybe<Array<Driver_Duty_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Duty_Photos_Order_By>>;
  where?: InputMaybe<Driver_Duty_Photos_Bool_Exp>;
};


/** columns and relationships of "photo_type" */
export type Photo_TypeDriver_Duty_Photos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Driver_Duty_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Duty_Photos_Order_By>>;
  where?: InputMaybe<Driver_Duty_Photos_Bool_Exp>;
};


/** columns and relationships of "photo_type" */
export type Photo_TypeOrder_PhotosArgs = {
  distinct_on?: InputMaybe<Array<Order_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Photos_Order_By>>;
  where?: InputMaybe<Order_Photos_Bool_Exp>;
};


/** columns and relationships of "photo_type" */
export type Photo_TypeOrder_Photos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Photos_Order_By>>;
  where?: InputMaybe<Order_Photos_Bool_Exp>;
};

/** aggregated selection of "photo_type" */
export type Photo_Type_Aggregate = {
  __typename?: 'photo_type_aggregate';
  aggregate?: Maybe<Photo_Type_Aggregate_Fields>;
  nodes: Array<Photo_Type>;
};

/** aggregate fields of "photo_type" */
export type Photo_Type_Aggregate_Fields = {
  __typename?: 'photo_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Photo_Type_Max_Fields>;
  min?: Maybe<Photo_Type_Min_Fields>;
};


/** aggregate fields of "photo_type" */
export type Photo_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Photo_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "photo_type". All fields are combined with a logical 'AND'. */
export type Photo_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Photo_Type_Bool_Exp>>;
  _not?: InputMaybe<Photo_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Photo_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  driver_duty_photos?: InputMaybe<Driver_Duty_Photos_Bool_Exp>;
  driver_duty_photos_aggregate?: InputMaybe<Driver_Duty_Photos_Aggregate_Bool_Exp>;
  order_photos?: InputMaybe<Order_Photos_Bool_Exp>;
  order_photos_aggregate?: InputMaybe<Order_Photos_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "photo_type" */
export enum Photo_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  PhotoTypePkey = 'photo_type_pkey'
}

export enum Photo_Type_Enum {
  /** ODOMETER */
  Odometer = 'ODOMETER',
  /** ODOMETER_END */
  OdometerEnd = 'ODOMETER_END',
  /** ODOMETER_START */
  OdometerStart = 'ODOMETER_START',
  /** REFUELLER */
  Refueller = 'REFUELLER',
  /** SELFIE */
  Selfie = 'SELFIE',
  /** TOTALIZER */
  Totalizer = 'TOTALIZER',
  /** TOTALIZER_END */
  TotalizerEnd = 'TOTALIZER_END',
  /** TOTALIZER_START */
  TotalizerStart = 'TOTALIZER_START'
}

/** Boolean expression to compare columns of type "photo_type_enum". All fields are combined with logical 'AND'. */
export type Photo_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Photo_Type_Enum>;
  _in?: InputMaybe<Array<Photo_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Photo_Type_Enum>;
  _nin?: InputMaybe<Array<Photo_Type_Enum>>;
};

/** input type for inserting data into table "photo_type" */
export type Photo_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  driver_duty_photos?: InputMaybe<Driver_Duty_Photos_Arr_Rel_Insert_Input>;
  order_photos?: InputMaybe<Order_Photos_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Photo_Type_Max_Fields = {
  __typename?: 'photo_type_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Photo_Type_Min_Fields = {
  __typename?: 'photo_type_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "photo_type" */
export type Photo_Type_Mutation_Response = {
  __typename?: 'photo_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Photo_Type>;
};

/** input type for inserting object relation for remote table "photo_type" */
export type Photo_Type_Obj_Rel_Insert_Input = {
  data: Photo_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Photo_Type_On_Conflict>;
};

/** on_conflict condition type for table "photo_type" */
export type Photo_Type_On_Conflict = {
  constraint: Photo_Type_Constraint;
  update_columns?: Array<Photo_Type_Update_Column>;
  where?: InputMaybe<Photo_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "photo_type". */
export type Photo_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  driver_duty_photos_aggregate?: InputMaybe<Driver_Duty_Photos_Aggregate_Order_By>;
  order_photos_aggregate?: InputMaybe<Order_Photos_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: photo_type */
export type Photo_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "photo_type" */
export enum Photo_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "photo_type" */
export type Photo_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "photo_type" */
export type Photo_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Photo_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Photo_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "photo_type" */
export enum Photo_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Photo_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Photo_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Photo_Type_Bool_Exp;
};

/** Comprehensive audit trail for all planning module actions */
export type Planning_Audit_Log = {
  __typename?: 'planning_audit_log';
  /** Action performed: CREATE, UPDATE, DELETE, APPROVE, REJECT, SKIP, OVERRIDE */
  action: Scalars['String']['output'];
  entity_id: Scalars['uuid']['output'];
  /** Type of entity: MASTER_SLOT, SHIFT_SCHEDULE, SHIFT_TEMPLATE */
  entity_type: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  ip_address?: Maybe<Scalars['String']['output']>;
  /** JSONB snapshot of entity after change */
  new_data?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  partner: Partner;
  partner_id: Scalars['uuid']['output'];
  performed_at: Scalars['timestamptz']['output'];
  performed_by: Scalars['uuid']['output'];
  /** An object relationship */
  performer?: Maybe<User>;
  /** JSONB snapshot of entity before change */
  previous_data?: Maybe<Scalars['jsonb']['output']>;
  user_agent?: Maybe<Scalars['String']['output']>;
};


/** Comprehensive audit trail for all planning module actions */
export type Planning_Audit_LogNew_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Comprehensive audit trail for all planning module actions */
export type Planning_Audit_LogPrevious_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "planning_audit_log" */
export type Planning_Audit_Log_Aggregate = {
  __typename?: 'planning_audit_log_aggregate';
  aggregate?: Maybe<Planning_Audit_Log_Aggregate_Fields>;
  nodes: Array<Planning_Audit_Log>;
};

export type Planning_Audit_Log_Aggregate_Bool_Exp = {
  count?: InputMaybe<Planning_Audit_Log_Aggregate_Bool_Exp_Count>;
};

export type Planning_Audit_Log_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Planning_Audit_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Planning_Audit_Log_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "planning_audit_log" */
export type Planning_Audit_Log_Aggregate_Fields = {
  __typename?: 'planning_audit_log_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Planning_Audit_Log_Max_Fields>;
  min?: Maybe<Planning_Audit_Log_Min_Fields>;
};


/** aggregate fields of "planning_audit_log" */
export type Planning_Audit_Log_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Planning_Audit_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "planning_audit_log" */
export type Planning_Audit_Log_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Planning_Audit_Log_Max_Order_By>;
  min?: InputMaybe<Planning_Audit_Log_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Planning_Audit_Log_Append_Input = {
  /** JSONB snapshot of entity after change */
  new_data?: InputMaybe<Scalars['jsonb']['input']>;
  /** JSONB snapshot of entity before change */
  previous_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "planning_audit_log" */
export type Planning_Audit_Log_Arr_Rel_Insert_Input = {
  data: Array<Planning_Audit_Log_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Planning_Audit_Log_On_Conflict>;
};

/** Boolean expression to filter rows from the table "planning_audit_log". All fields are combined with a logical 'AND'. */
export type Planning_Audit_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Planning_Audit_Log_Bool_Exp>>;
  _not?: InputMaybe<Planning_Audit_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Planning_Audit_Log_Bool_Exp>>;
  action?: InputMaybe<String_Comparison_Exp>;
  entity_id?: InputMaybe<Uuid_Comparison_Exp>;
  entity_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ip_address?: InputMaybe<String_Comparison_Exp>;
  new_data?: InputMaybe<Jsonb_Comparison_Exp>;
  partner?: InputMaybe<Partner_Bool_Exp>;
  partner_id?: InputMaybe<Uuid_Comparison_Exp>;
  performed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  performed_by?: InputMaybe<Uuid_Comparison_Exp>;
  performer?: InputMaybe<User_Bool_Exp>;
  previous_data?: InputMaybe<Jsonb_Comparison_Exp>;
  user_agent?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "planning_audit_log" */
export enum Planning_Audit_Log_Constraint {
  /** unique or primary key constraint on columns "id" */
  PlanningAuditLogPkey = 'planning_audit_log_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Planning_Audit_Log_Delete_At_Path_Input = {
  /** JSONB snapshot of entity after change */
  new_data?: InputMaybe<Array<Scalars['String']['input']>>;
  /** JSONB snapshot of entity before change */
  previous_data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Planning_Audit_Log_Delete_Elem_Input = {
  /** JSONB snapshot of entity after change */
  new_data?: InputMaybe<Scalars['Int']['input']>;
  /** JSONB snapshot of entity before change */
  previous_data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Planning_Audit_Log_Delete_Key_Input = {
  /** JSONB snapshot of entity after change */
  new_data?: InputMaybe<Scalars['String']['input']>;
  /** JSONB snapshot of entity before change */
  previous_data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "planning_audit_log" */
export type Planning_Audit_Log_Insert_Input = {
  /** Action performed: CREATE, UPDATE, DELETE, APPROVE, REJECT, SKIP, OVERRIDE */
  action?: InputMaybe<Scalars['String']['input']>;
  entity_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Type of entity: MASTER_SLOT, SHIFT_SCHEDULE, SHIFT_TEMPLATE */
  entity_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ip_address?: InputMaybe<Scalars['String']['input']>;
  /** JSONB snapshot of entity after change */
  new_data?: InputMaybe<Scalars['jsonb']['input']>;
  partner?: InputMaybe<Partner_Obj_Rel_Insert_Input>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  performed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  performed_by?: InputMaybe<Scalars['uuid']['input']>;
  performer?: InputMaybe<User_Obj_Rel_Insert_Input>;
  /** JSONB snapshot of entity before change */
  previous_data?: InputMaybe<Scalars['jsonb']['input']>;
  user_agent?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Planning_Audit_Log_Max_Fields = {
  __typename?: 'planning_audit_log_max_fields';
  /** Action performed: CREATE, UPDATE, DELETE, APPROVE, REJECT, SKIP, OVERRIDE */
  action?: Maybe<Scalars['String']['output']>;
  entity_id?: Maybe<Scalars['uuid']['output']>;
  /** Type of entity: MASTER_SLOT, SHIFT_SCHEDULE, SHIFT_TEMPLATE */
  entity_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ip_address?: Maybe<Scalars['String']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  performed_at?: Maybe<Scalars['timestamptz']['output']>;
  performed_by?: Maybe<Scalars['uuid']['output']>;
  user_agent?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "planning_audit_log" */
export type Planning_Audit_Log_Max_Order_By = {
  /** Action performed: CREATE, UPDATE, DELETE, APPROVE, REJECT, SKIP, OVERRIDE */
  action?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  /** Type of entity: MASTER_SLOT, SHIFT_SCHEDULE, SHIFT_TEMPLATE */
  entity_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ip_address?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  performed_at?: InputMaybe<Order_By>;
  performed_by?: InputMaybe<Order_By>;
  user_agent?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Planning_Audit_Log_Min_Fields = {
  __typename?: 'planning_audit_log_min_fields';
  /** Action performed: CREATE, UPDATE, DELETE, APPROVE, REJECT, SKIP, OVERRIDE */
  action?: Maybe<Scalars['String']['output']>;
  entity_id?: Maybe<Scalars['uuid']['output']>;
  /** Type of entity: MASTER_SLOT, SHIFT_SCHEDULE, SHIFT_TEMPLATE */
  entity_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ip_address?: Maybe<Scalars['String']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  performed_at?: Maybe<Scalars['timestamptz']['output']>;
  performed_by?: Maybe<Scalars['uuid']['output']>;
  user_agent?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "planning_audit_log" */
export type Planning_Audit_Log_Min_Order_By = {
  /** Action performed: CREATE, UPDATE, DELETE, APPROVE, REJECT, SKIP, OVERRIDE */
  action?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  /** Type of entity: MASTER_SLOT, SHIFT_SCHEDULE, SHIFT_TEMPLATE */
  entity_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ip_address?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  performed_at?: InputMaybe<Order_By>;
  performed_by?: InputMaybe<Order_By>;
  user_agent?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "planning_audit_log" */
export type Planning_Audit_Log_Mutation_Response = {
  __typename?: 'planning_audit_log_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Planning_Audit_Log>;
};

/** on_conflict condition type for table "planning_audit_log" */
export type Planning_Audit_Log_On_Conflict = {
  constraint: Planning_Audit_Log_Constraint;
  update_columns?: Array<Planning_Audit_Log_Update_Column>;
  where?: InputMaybe<Planning_Audit_Log_Bool_Exp>;
};

/** Ordering options when selecting data from "planning_audit_log". */
export type Planning_Audit_Log_Order_By = {
  action?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  entity_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ip_address?: InputMaybe<Order_By>;
  new_data?: InputMaybe<Order_By>;
  partner?: InputMaybe<Partner_Order_By>;
  partner_id?: InputMaybe<Order_By>;
  performed_at?: InputMaybe<Order_By>;
  performed_by?: InputMaybe<Order_By>;
  performer?: InputMaybe<User_Order_By>;
  previous_data?: InputMaybe<Order_By>;
  user_agent?: InputMaybe<Order_By>;
};

/** primary key columns input for table: planning_audit_log */
export type Planning_Audit_Log_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Planning_Audit_Log_Prepend_Input = {
  /** JSONB snapshot of entity after change */
  new_data?: InputMaybe<Scalars['jsonb']['input']>;
  /** JSONB snapshot of entity before change */
  previous_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "planning_audit_log" */
export enum Planning_Audit_Log_Select_Column {
  /** column name */
  Action = 'action',
  /** column name */
  EntityId = 'entity_id',
  /** column name */
  EntityType = 'entity_type',
  /** column name */
  Id = 'id',
  /** column name */
  IpAddress = 'ip_address',
  /** column name */
  NewData = 'new_data',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  PerformedAt = 'performed_at',
  /** column name */
  PerformedBy = 'performed_by',
  /** column name */
  PreviousData = 'previous_data',
  /** column name */
  UserAgent = 'user_agent'
}

/** input type for updating data in table "planning_audit_log" */
export type Planning_Audit_Log_Set_Input = {
  /** Action performed: CREATE, UPDATE, DELETE, APPROVE, REJECT, SKIP, OVERRIDE */
  action?: InputMaybe<Scalars['String']['input']>;
  entity_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Type of entity: MASTER_SLOT, SHIFT_SCHEDULE, SHIFT_TEMPLATE */
  entity_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ip_address?: InputMaybe<Scalars['String']['input']>;
  /** JSONB snapshot of entity after change */
  new_data?: InputMaybe<Scalars['jsonb']['input']>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  performed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  performed_by?: InputMaybe<Scalars['uuid']['input']>;
  /** JSONB snapshot of entity before change */
  previous_data?: InputMaybe<Scalars['jsonb']['input']>;
  user_agent?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "planning_audit_log" */
export type Planning_Audit_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Planning_Audit_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Planning_Audit_Log_Stream_Cursor_Value_Input = {
  /** Action performed: CREATE, UPDATE, DELETE, APPROVE, REJECT, SKIP, OVERRIDE */
  action?: InputMaybe<Scalars['String']['input']>;
  entity_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Type of entity: MASTER_SLOT, SHIFT_SCHEDULE, SHIFT_TEMPLATE */
  entity_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ip_address?: InputMaybe<Scalars['String']['input']>;
  /** JSONB snapshot of entity after change */
  new_data?: InputMaybe<Scalars['jsonb']['input']>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  performed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  performed_by?: InputMaybe<Scalars['uuid']['input']>;
  /** JSONB snapshot of entity before change */
  previous_data?: InputMaybe<Scalars['jsonb']['input']>;
  user_agent?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "planning_audit_log" */
export enum Planning_Audit_Log_Update_Column {
  /** column name */
  Action = 'action',
  /** column name */
  EntityId = 'entity_id',
  /** column name */
  EntityType = 'entity_type',
  /** column name */
  Id = 'id',
  /** column name */
  IpAddress = 'ip_address',
  /** column name */
  NewData = 'new_data',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  PerformedAt = 'performed_at',
  /** column name */
  PerformedBy = 'performed_by',
  /** column name */
  PreviousData = 'previous_data',
  /** column name */
  UserAgent = 'user_agent'
}

export type Planning_Audit_Log_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Planning_Audit_Log_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Planning_Audit_Log_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Planning_Audit_Log_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Planning_Audit_Log_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Planning_Audit_Log_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Planning_Audit_Log_Set_Input>;
  /** filter the rows which have to be updated */
  where: Planning_Audit_Log_Bool_Exp;
};

/** Named date-bounded periods for temporary slot overrides (e.g., Ramadan 2026, Summer 2026) */
export type Planning_Period = {
  __typename?: 'planning_period';
  /** SKIP or OVERRIDE: which action this card attaches to slots. NULL on cards predating skip/override cards. Attached rows must match; enforced in the service layer. */
  card_type?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  created_by_user?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  /** Start date of the period (inclusive) */
  effective_from: Scalars['date']['output'];
  /** End date of the period (inclusive) */
  effective_until: Scalars['date']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  master_slots: Array<Master_Slot>;
  /** An aggregate relationship */
  master_slots_aggregate: Master_Slot_Aggregate;
  /** An object relationship */
  modified_by_user?: Maybe<User>;
  name: Scalars['String']['output'];
  /** An object relationship */
  partner: Partner;
  partner_id: Scalars['uuid']['output'];
};


/** Named date-bounded periods for temporary slot overrides (e.g., Ramadan 2026, Summer 2026) */
export type Planning_PeriodMaster_SlotsArgs = {
  distinct_on?: InputMaybe<Array<Master_Slot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Slot_Order_By>>;
  where?: InputMaybe<Master_Slot_Bool_Exp>;
};


/** Named date-bounded periods for temporary slot overrides (e.g., Ramadan 2026, Summer 2026) */
export type Planning_PeriodMaster_Slots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Master_Slot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Slot_Order_By>>;
  where?: InputMaybe<Master_Slot_Bool_Exp>;
};

/** aggregated selection of "planning_period" */
export type Planning_Period_Aggregate = {
  __typename?: 'planning_period_aggregate';
  aggregate?: Maybe<Planning_Period_Aggregate_Fields>;
  nodes: Array<Planning_Period>;
};

export type Planning_Period_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Planning_Period_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Planning_Period_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Planning_Period_Aggregate_Bool_Exp_Count>;
};

export type Planning_Period_Aggregate_Bool_Exp_Bool_And = {
  arguments: Planning_Period_Select_Column_Planning_Period_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Planning_Period_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Planning_Period_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Planning_Period_Select_Column_Planning_Period_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Planning_Period_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Planning_Period_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Planning_Period_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Planning_Period_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "planning_period" */
export type Planning_Period_Aggregate_Fields = {
  __typename?: 'planning_period_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Planning_Period_Max_Fields>;
  min?: Maybe<Planning_Period_Min_Fields>;
};


/** aggregate fields of "planning_period" */
export type Planning_Period_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Planning_Period_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "planning_period" */
export type Planning_Period_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Planning_Period_Max_Order_By>;
  min?: InputMaybe<Planning_Period_Min_Order_By>;
};

/** input type for inserting array relation for remote table "planning_period" */
export type Planning_Period_Arr_Rel_Insert_Input = {
  data: Array<Planning_Period_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Planning_Period_On_Conflict>;
};

/** Boolean expression to filter rows from the table "planning_period". All fields are combined with a logical 'AND'. */
export type Planning_Period_Bool_Exp = {
  _and?: InputMaybe<Array<Planning_Period_Bool_Exp>>;
  _not?: InputMaybe<Planning_Period_Bool_Exp>;
  _or?: InputMaybe<Array<Planning_Period_Bool_Exp>>;
  card_type?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  created_by_user?: InputMaybe<User_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  effective_from?: InputMaybe<Date_Comparison_Exp>;
  effective_until?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  master_slots?: InputMaybe<Master_Slot_Bool_Exp>;
  master_slots_aggregate?: InputMaybe<Master_Slot_Aggregate_Bool_Exp>;
  modified_by_user?: InputMaybe<User_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  partner?: InputMaybe<Partner_Bool_Exp>;
  partner_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "planning_period" */
export enum Planning_Period_Constraint {
  /** unique or primary key constraint on columns "id" */
  PlanningPeriodPkey = 'planning_period_pkey',
  /** unique or primary key constraint on columns "partner_id", "name" */
  UniquePeriodNamePerPartner = 'unique_period_name_per_partner'
}

/** input type for inserting data into table "planning_period" */
export type Planning_Period_Insert_Input = {
  /** SKIP or OVERRIDE: which action this card attaches to slots. NULL on cards predating skip/override cards. Attached rows must match; enforced in the service layer. */
  card_type?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  created_by_user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Start date of the period (inclusive) */
  effective_from?: InputMaybe<Scalars['date']['input']>;
  /** End date of the period (inclusive) */
  effective_until?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  master_slots?: InputMaybe<Master_Slot_Arr_Rel_Insert_Input>;
  modified_by_user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  partner?: InputMaybe<Partner_Obj_Rel_Insert_Input>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Planning_Period_Max_Fields = {
  __typename?: 'planning_period_max_fields';
  /** SKIP or OVERRIDE: which action this card attaches to slots. NULL on cards predating skip/override cards. Attached rows must match; enforced in the service layer. */
  card_type?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Start date of the period (inclusive) */
  effective_from?: Maybe<Scalars['date']['output']>;
  /** End date of the period (inclusive) */
  effective_until?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "planning_period" */
export type Planning_Period_Max_Order_By = {
  /** SKIP or OVERRIDE: which action this card attaches to slots. NULL on cards predating skip/override cards. Attached rows must match; enforced in the service layer. */
  card_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  /** Start date of the period (inclusive) */
  effective_from?: InputMaybe<Order_By>;
  /** End date of the period (inclusive) */
  effective_until?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Planning_Period_Min_Fields = {
  __typename?: 'planning_period_min_fields';
  /** SKIP or OVERRIDE: which action this card attaches to slots. NULL on cards predating skip/override cards. Attached rows must match; enforced in the service layer. */
  card_type?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Start date of the period (inclusive) */
  effective_from?: Maybe<Scalars['date']['output']>;
  /** End date of the period (inclusive) */
  effective_until?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "planning_period" */
export type Planning_Period_Min_Order_By = {
  /** SKIP or OVERRIDE: which action this card attaches to slots. NULL on cards predating skip/override cards. Attached rows must match; enforced in the service layer. */
  card_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  /** Start date of the period (inclusive) */
  effective_from?: InputMaybe<Order_By>;
  /** End date of the period (inclusive) */
  effective_until?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "planning_period" */
export type Planning_Period_Mutation_Response = {
  __typename?: 'planning_period_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Planning_Period>;
};

/** input type for inserting object relation for remote table "planning_period" */
export type Planning_Period_Obj_Rel_Insert_Input = {
  data: Planning_Period_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Planning_Period_On_Conflict>;
};

/** on_conflict condition type for table "planning_period" */
export type Planning_Period_On_Conflict = {
  constraint: Planning_Period_Constraint;
  update_columns?: Array<Planning_Period_Update_Column>;
  where?: InputMaybe<Planning_Period_Bool_Exp>;
};

/** Ordering options when selecting data from "planning_period". */
export type Planning_Period_Order_By = {
  card_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<User_Order_By>;
  description?: InputMaybe<Order_By>;
  effective_from?: InputMaybe<Order_By>;
  effective_until?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  master_slots_aggregate?: InputMaybe<Master_Slot_Aggregate_Order_By>;
  modified_by_user?: InputMaybe<User_Order_By>;
  name?: InputMaybe<Order_By>;
  partner?: InputMaybe<Partner_Order_By>;
  partner_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: planning_period */
export type Planning_Period_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "planning_period" */
export enum Planning_Period_Select_Column {
  /** column name */
  CardType = 'card_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  EffectiveFrom = 'effective_from',
  /** column name */
  EffectiveUntil = 'effective_until',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  PartnerId = 'partner_id'
}

/** select "planning_period_aggregate_bool_exp_bool_and_arguments_columns" columns of table "planning_period" */
export enum Planning_Period_Select_Column_Planning_Period_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "planning_period_aggregate_bool_exp_bool_or_arguments_columns" columns of table "planning_period" */
export enum Planning_Period_Select_Column_Planning_Period_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "planning_period" */
export type Planning_Period_Set_Input = {
  /** SKIP or OVERRIDE: which action this card attaches to slots. NULL on cards predating skip/override cards. Attached rows must match; enforced in the service layer. */
  card_type?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Start date of the period (inclusive) */
  effective_from?: InputMaybe<Scalars['date']['input']>;
  /** End date of the period (inclusive) */
  effective_until?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "planning_period" */
export type Planning_Period_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Planning_Period_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Planning_Period_Stream_Cursor_Value_Input = {
  /** SKIP or OVERRIDE: which action this card attaches to slots. NULL on cards predating skip/override cards. Attached rows must match; enforced in the service layer. */
  card_type?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Start date of the period (inclusive) */
  effective_from?: InputMaybe<Scalars['date']['input']>;
  /** End date of the period (inclusive) */
  effective_until?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "planning_period" */
export enum Planning_Period_Update_Column {
  /** column name */
  CardType = 'card_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  EffectiveFrom = 'effective_from',
  /** column name */
  EffectiveUntil = 'effective_until',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  PartnerId = 'partner_id'
}

export type Planning_Period_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Planning_Period_Set_Input>;
  /** filter the rows which have to be updated */
  where: Planning_Period_Bool_Exp;
};

/** Boolean expression to compare columns of type "point". All fields are combined with logical 'AND'. */
export type Point_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['point']['input']>;
  _gt?: InputMaybe<Scalars['point']['input']>;
  _gte?: InputMaybe<Scalars['point']['input']>;
  _in?: InputMaybe<Array<Scalars['point']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['point']['input']>;
  _lte?: InputMaybe<Scalars['point']['input']>;
  _neq?: InputMaybe<Scalars['point']['input']>;
  _nin?: InputMaybe<Array<Scalars['point']['input']>>;
};

/** columns and relationships of "product" */
export type Product = {
  __typename?: 'product';
  /** The unit that defines this product's DIMENSION, and the default unit for its order lines. An order line may transact in a different unit of the SAME dimension but never across dimensions - enforced by the customer_order_item dimension guard. NULL means no unit is defined and consumers fall back to the deployment default. Set once, then immutable - see the write-once trigger. */
  base_uom?: Maybe<Unit_Of_Measure_Enum>;
  /** An object relationship */
  category?: Maybe<Category>;
  category_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  customer_assets: Array<Customer_Asset>;
  /** An aggregate relationship */
  customer_assets_aggregate: Customer_Asset_Aggregate;
  description: Scalars['String']['output'];
  hsn_code: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name: Scalars['String']['output'];
  /** An array relationship */
  organization_commission_product_variation_types: Array<Organization_Commission_Product_Variation_Type>;
  /** An aggregate relationship */
  organization_commission_product_variation_types_aggregate: Organization_Commission_Product_Variation_Type_Aggregate;
  /** An array relationship */
  partner_commission_product_variation_types: Array<Partner_Commission_Product_Variation_Type>;
  /** An aggregate relationship */
  partner_commission_product_variation_types_aggregate: Partner_Commission_Product_Variation_Type_Aggregate;
  /** An array relationship */
  partner_products: Array<Partner_Product>;
  /** An aggregate relationship */
  partner_products_aggregate: Partner_Product_Aggregate;
  /** An object relationship */
  productTypeByProductType: Product_Type;
  /** An array relationship */
  product_commissions: Array<Product_Commission>;
  /** An aggregate relationship */
  product_commissions_aggregate: Product_Commission_Aggregate;
  /** An array relationship */
  product_documents: Array<Product_Document>;
  /** An aggregate relationship */
  product_documents_aggregate: Product_Document_Aggregate;
  /** An array relationship */
  product_photos: Array<Product_Photos>;
  /** An aggregate relationship */
  product_photos_aggregate: Product_Photos_Aggregate;
  product_type: Product_Type_Enum;
  /** An array relationship */
  product_variations: Array<Product_Variation>;
  /** An aggregate relationship */
  product_variations_aggregate: Product_Variation_Aggregate;
  sku: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  /** An object relationship */
  unit_of_measure?: Maybe<Unit_Of_Measure>;
};


/** columns and relationships of "product" */
export type ProductCustomer_AssetsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Order_By>>;
  where?: InputMaybe<Customer_Asset_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductCustomer_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Order_By>>;
  where?: InputMaybe<Customer_Asset_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductOrganization_Commission_Product_Variation_TypesArgs = {
  distinct_on?: InputMaybe<Array<Organization_Commission_Product_Variation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Commission_Product_Variation_Type_Order_By>>;
  where?: InputMaybe<Organization_Commission_Product_Variation_Type_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductOrganization_Commission_Product_Variation_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Commission_Product_Variation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Commission_Product_Variation_Type_Order_By>>;
  where?: InputMaybe<Organization_Commission_Product_Variation_Type_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductPartner_Commission_Product_Variation_TypesArgs = {
  distinct_on?: InputMaybe<Array<Partner_Commission_Product_Variation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Commission_Product_Variation_Type_Order_By>>;
  where?: InputMaybe<Partner_Commission_Product_Variation_Type_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductPartner_Commission_Product_Variation_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Commission_Product_Variation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Commission_Product_Variation_Type_Order_By>>;
  where?: InputMaybe<Partner_Commission_Product_Variation_Type_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductPartner_ProductsArgs = {
  distinct_on?: InputMaybe<Array<Partner_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Product_Order_By>>;
  where?: InputMaybe<Partner_Product_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductPartner_Products_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Product_Order_By>>;
  where?: InputMaybe<Partner_Product_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProduct_CommissionsArgs = {
  distinct_on?: InputMaybe<Array<Product_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Commission_Order_By>>;
  where?: InputMaybe<Product_Commission_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProduct_Commissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Commission_Order_By>>;
  where?: InputMaybe<Product_Commission_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProduct_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Product_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Document_Order_By>>;
  where?: InputMaybe<Product_Document_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProduct_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Document_Order_By>>;
  where?: InputMaybe<Product_Document_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProduct_PhotosArgs = {
  distinct_on?: InputMaybe<Array<Product_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Photos_Order_By>>;
  where?: InputMaybe<Product_Photos_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProduct_Photos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Photos_Order_By>>;
  where?: InputMaybe<Product_Photos_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProduct_VariationsArgs = {
  distinct_on?: InputMaybe<Array<Product_Variation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Variation_Order_By>>;
  where?: InputMaybe<Product_Variation_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductProduct_Variations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Variation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Variation_Order_By>>;
  where?: InputMaybe<Product_Variation_Bool_Exp>;
};

/** aggregated selection of "product" */
export type Product_Aggregate = {
  __typename?: 'product_aggregate';
  aggregate?: Maybe<Product_Aggregate_Fields>;
  nodes: Array<Product>;
};

export type Product_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Product_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Product_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Product_Aggregate_Bool_Exp_Count>;
};

export type Product_Aggregate_Bool_Exp_Bool_And = {
  arguments: Product_Select_Column_Product_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Product_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Product_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Product_Select_Column_Product_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Product_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Product_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Product_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Product_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "product" */
export type Product_Aggregate_Fields = {
  __typename?: 'product_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Product_Max_Fields>;
  min?: Maybe<Product_Min_Fields>;
};


/** aggregate fields of "product" */
export type Product_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "product" */
export type Product_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Product_Max_Order_By>;
  min?: InputMaybe<Product_Min_Order_By>;
};

/** input type for inserting array relation for remote table "product" */
export type Product_Arr_Rel_Insert_Input = {
  data: Array<Product_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_On_Conflict>;
};

/** Boolean expression to filter rows from the table "product". All fields are combined with a logical 'AND'. */
export type Product_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Bool_Exp>>;
  _not?: InputMaybe<Product_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Bool_Exp>>;
  base_uom?: InputMaybe<Unit_Of_Measure_Enum_Comparison_Exp>;
  category?: InputMaybe<Category_Bool_Exp>;
  category_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_assets?: InputMaybe<Customer_Asset_Bool_Exp>;
  customer_assets_aggregate?: InputMaybe<Customer_Asset_Aggregate_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  hsn_code?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization_commission_product_variation_types?: InputMaybe<Organization_Commission_Product_Variation_Type_Bool_Exp>;
  organization_commission_product_variation_types_aggregate?: InputMaybe<Organization_Commission_Product_Variation_Type_Aggregate_Bool_Exp>;
  partner_commission_product_variation_types?: InputMaybe<Partner_Commission_Product_Variation_Type_Bool_Exp>;
  partner_commission_product_variation_types_aggregate?: InputMaybe<Partner_Commission_Product_Variation_Type_Aggregate_Bool_Exp>;
  partner_products?: InputMaybe<Partner_Product_Bool_Exp>;
  partner_products_aggregate?: InputMaybe<Partner_Product_Aggregate_Bool_Exp>;
  productTypeByProductType?: InputMaybe<Product_Type_Bool_Exp>;
  product_commissions?: InputMaybe<Product_Commission_Bool_Exp>;
  product_commissions_aggregate?: InputMaybe<Product_Commission_Aggregate_Bool_Exp>;
  product_documents?: InputMaybe<Product_Document_Bool_Exp>;
  product_documents_aggregate?: InputMaybe<Product_Document_Aggregate_Bool_Exp>;
  product_photos?: InputMaybe<Product_Photos_Bool_Exp>;
  product_photos_aggregate?: InputMaybe<Product_Photos_Aggregate_Bool_Exp>;
  product_type?: InputMaybe<Product_Type_Enum_Comparison_Exp>;
  product_variations?: InputMaybe<Product_Variation_Bool_Exp>;
  product_variations_aggregate?: InputMaybe<Product_Variation_Aggregate_Bool_Exp>;
  sku?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  unit_of_measure?: InputMaybe<Unit_Of_Measure_Bool_Exp>;
};

/** columns and relationships of "product_commission" */
export type Product_Commission = {
  __typename?: 'product_commission';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  product?: Maybe<Product>;
  product_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  script?: Maybe<Scripts>;
  scripts_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "product_commission" */
export type Product_Commission_Aggregate = {
  __typename?: 'product_commission_aggregate';
  aggregate?: Maybe<Product_Commission_Aggregate_Fields>;
  nodes: Array<Product_Commission>;
};

export type Product_Commission_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Product_Commission_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Product_Commission_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Product_Commission_Aggregate_Bool_Exp_Count>;
};

export type Product_Commission_Aggregate_Bool_Exp_Bool_And = {
  arguments: Product_Commission_Select_Column_Product_Commission_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Product_Commission_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Product_Commission_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Product_Commission_Select_Column_Product_Commission_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Product_Commission_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Product_Commission_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Product_Commission_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Product_Commission_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "product_commission" */
export type Product_Commission_Aggregate_Fields = {
  __typename?: 'product_commission_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Product_Commission_Max_Fields>;
  min?: Maybe<Product_Commission_Min_Fields>;
};


/** aggregate fields of "product_commission" */
export type Product_Commission_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Commission_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "product_commission" */
export type Product_Commission_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Product_Commission_Max_Order_By>;
  min?: InputMaybe<Product_Commission_Min_Order_By>;
};

/** input type for inserting array relation for remote table "product_commission" */
export type Product_Commission_Arr_Rel_Insert_Input = {
  data: Array<Product_Commission_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Commission_On_Conflict>;
};

/** Boolean expression to filter rows from the table "product_commission". All fields are combined with a logical 'AND'. */
export type Product_Commission_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Commission_Bool_Exp>>;
  _not?: InputMaybe<Product_Commission_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Commission_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  product_id?: InputMaybe<Uuid_Comparison_Exp>;
  script?: InputMaybe<Scripts_Bool_Exp>;
  scripts_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_commission" */
export enum Product_Commission_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductCommissionPkey = 'product_commission_pkey'
}

/** input type for inserting data into table "product_commission" */
export type Product_Commission_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
  script?: InputMaybe<Scripts_Obj_Rel_Insert_Input>;
  scripts_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Product_Commission_Max_Fields = {
  __typename?: 'product_commission_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  product_id?: Maybe<Scalars['uuid']['output']>;
  scripts_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "product_commission" */
export type Product_Commission_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  scripts_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Product_Commission_Min_Fields = {
  __typename?: 'product_commission_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  product_id?: Maybe<Scalars['uuid']['output']>;
  scripts_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "product_commission" */
export type Product_Commission_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  scripts_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_commission" */
export type Product_Commission_Mutation_Response = {
  __typename?: 'product_commission_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_Commission>;
};

/** on_conflict condition type for table "product_commission" */
export type Product_Commission_On_Conflict = {
  constraint: Product_Commission_Constraint;
  update_columns?: Array<Product_Commission_Update_Column>;
  where?: InputMaybe<Product_Commission_Bool_Exp>;
};

/** Ordering options when selecting data from "product_commission". */
export type Product_Commission_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  product_id?: InputMaybe<Order_By>;
  script?: InputMaybe<Scripts_Order_By>;
  scripts_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_commission */
export type Product_Commission_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "product_commission" */
export enum Product_Commission_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  ScriptsId = 'scripts_id'
}

/** select "product_commission_aggregate_bool_exp_bool_and_arguments_columns" columns of table "product_commission" */
export enum Product_Commission_Select_Column_Product_Commission_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "product_commission_aggregate_bool_exp_bool_or_arguments_columns" columns of table "product_commission" */
export enum Product_Commission_Select_Column_Product_Commission_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "product_commission" */
export type Product_Commission_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
  scripts_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "product_commission" */
export type Product_Commission_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Commission_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Commission_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
  scripts_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "product_commission" */
export enum Product_Commission_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  ScriptsId = 'scripts_id'
}

export type Product_Commission_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Commission_Set_Input>;
  /** filter the rows which have to be updated */
  where: Product_Commission_Bool_Exp;
};

/** unique or primary key constraints on table "product" */
export enum Product_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductPkey = 'product_pkey'
}

/** columns and relationships of "product_document" */
export type Product_Document = {
  __typename?: 'product_document';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  document: Documents;
  document_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  is_approved: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  product: Product;
  product_id: Scalars['uuid']['output'];
};

/** aggregated selection of "product_document" */
export type Product_Document_Aggregate = {
  __typename?: 'product_document_aggregate';
  aggregate?: Maybe<Product_Document_Aggregate_Fields>;
  nodes: Array<Product_Document>;
};

export type Product_Document_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Product_Document_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Product_Document_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Product_Document_Aggregate_Bool_Exp_Count>;
};

export type Product_Document_Aggregate_Bool_Exp_Bool_And = {
  arguments: Product_Document_Select_Column_Product_Document_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Product_Document_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Product_Document_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Product_Document_Select_Column_Product_Document_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Product_Document_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Product_Document_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Product_Document_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Product_Document_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "product_document" */
export type Product_Document_Aggregate_Fields = {
  __typename?: 'product_document_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Product_Document_Max_Fields>;
  min?: Maybe<Product_Document_Min_Fields>;
};


/** aggregate fields of "product_document" */
export type Product_Document_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Document_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "product_document" */
export type Product_Document_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Product_Document_Max_Order_By>;
  min?: InputMaybe<Product_Document_Min_Order_By>;
};

/** input type for inserting array relation for remote table "product_document" */
export type Product_Document_Arr_Rel_Insert_Input = {
  data: Array<Product_Document_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Document_On_Conflict>;
};

/** Boolean expression to filter rows from the table "product_document". All fields are combined with a logical 'AND'. */
export type Product_Document_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Document_Bool_Exp>>;
  _not?: InputMaybe<Product_Document_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Document_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  document?: InputMaybe<Documents_Bool_Exp>;
  document_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_approved?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  product_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_document" */
export enum Product_Document_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductDocumentPkey = 'product_document_pkey'
}

/** input type for inserting data into table "product_document" */
export type Product_Document_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  document?: InputMaybe<Documents_Obj_Rel_Insert_Input>;
  document_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_approved?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Product_Document_Max_Fields = {
  __typename?: 'product_document_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  document_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  product_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "product_document" */
export type Product_Document_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Product_Document_Min_Fields = {
  __typename?: 'product_document_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  document_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  product_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "product_document" */
export type Product_Document_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_document" */
export type Product_Document_Mutation_Response = {
  __typename?: 'product_document_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_Document>;
};

/** on_conflict condition type for table "product_document" */
export type Product_Document_On_Conflict = {
  constraint: Product_Document_Constraint;
  update_columns?: Array<Product_Document_Update_Column>;
  where?: InputMaybe<Product_Document_Bool_Exp>;
};

/** Ordering options when selecting data from "product_document". */
export type Product_Document_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document?: InputMaybe<Documents_Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_approved?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_document */
export type Product_Document_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "product_document" */
export enum Product_Document_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsApproved = 'is_approved',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  ProductId = 'product_id'
}

/** select "product_document_aggregate_bool_exp_bool_and_arguments_columns" columns of table "product_document" */
export enum Product_Document_Select_Column_Product_Document_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsApproved = 'is_approved'
}

/** select "product_document_aggregate_bool_exp_bool_or_arguments_columns" columns of table "product_document" */
export enum Product_Document_Select_Column_Product_Document_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsApproved = 'is_approved'
}

/** input type for updating data in table "product_document" */
export type Product_Document_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  document_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_approved?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "product_document" */
export type Product_Document_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Document_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Document_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  document_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_approved?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "product_document" */
export enum Product_Document_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsApproved = 'is_approved',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  ProductId = 'product_id'
}

export type Product_Document_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Document_Set_Input>;
  /** filter the rows which have to be updated */
  where: Product_Document_Bool_Exp;
};

/** input type for inserting data into table "product" */
export type Product_Insert_Input = {
  /** The unit that defines this product's DIMENSION, and the default unit for its order lines. An order line may transact in a different unit of the SAME dimension but never across dimensions - enforced by the customer_order_item dimension guard. NULL means no unit is defined and consumers fall back to the deployment default. Set once, then immutable - see the write-once trigger. */
  base_uom?: InputMaybe<Unit_Of_Measure_Enum>;
  category?: InputMaybe<Category_Obj_Rel_Insert_Input>;
  category_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_assets?: InputMaybe<Customer_Asset_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']['input']>;
  hsn_code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_commission_product_variation_types?: InputMaybe<Organization_Commission_Product_Variation_Type_Arr_Rel_Insert_Input>;
  partner_commission_product_variation_types?: InputMaybe<Partner_Commission_Product_Variation_Type_Arr_Rel_Insert_Input>;
  partner_products?: InputMaybe<Partner_Product_Arr_Rel_Insert_Input>;
  productTypeByProductType?: InputMaybe<Product_Type_Obj_Rel_Insert_Input>;
  product_commissions?: InputMaybe<Product_Commission_Arr_Rel_Insert_Input>;
  product_documents?: InputMaybe<Product_Document_Arr_Rel_Insert_Input>;
  product_photos?: InputMaybe<Product_Photos_Arr_Rel_Insert_Input>;
  product_type?: InputMaybe<Product_Type_Enum>;
  product_variations?: InputMaybe<Product_Variation_Arr_Rel_Insert_Input>;
  sku?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  unit_of_measure?: InputMaybe<Unit_Of_Measure_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Product_Max_Fields = {
  __typename?: 'product_max_fields';
  category_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hsn_code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "product" */
export type Product_Max_Order_By = {
  category_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  hsn_code?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  sku?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Product_Min_Fields = {
  __typename?: 'product_min_fields';
  category_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hsn_code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "product" */
export type Product_Min_Order_By = {
  category_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  hsn_code?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  sku?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product" */
export type Product_Mutation_Response = {
  __typename?: 'product_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Product>;
};

/** input type for inserting object relation for remote table "product" */
export type Product_Obj_Rel_Insert_Input = {
  data: Product_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_On_Conflict>;
};

/** on_conflict condition type for table "product" */
export type Product_On_Conflict = {
  constraint: Product_Constraint;
  update_columns?: Array<Product_Update_Column>;
  where?: InputMaybe<Product_Bool_Exp>;
};

/** Ordering options when selecting data from "product". */
export type Product_Order_By = {
  base_uom?: InputMaybe<Order_By>;
  category?: InputMaybe<Category_Order_By>;
  category_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_assets_aggregate?: InputMaybe<Customer_Asset_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  hsn_code?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_commission_product_variation_types_aggregate?: InputMaybe<Organization_Commission_Product_Variation_Type_Aggregate_Order_By>;
  partner_commission_product_variation_types_aggregate?: InputMaybe<Partner_Commission_Product_Variation_Type_Aggregate_Order_By>;
  partner_products_aggregate?: InputMaybe<Partner_Product_Aggregate_Order_By>;
  productTypeByProductType?: InputMaybe<Product_Type_Order_By>;
  product_commissions_aggregate?: InputMaybe<Product_Commission_Aggregate_Order_By>;
  product_documents_aggregate?: InputMaybe<Product_Document_Aggregate_Order_By>;
  product_photos_aggregate?: InputMaybe<Product_Photos_Aggregate_Order_By>;
  product_type?: InputMaybe<Order_By>;
  product_variations_aggregate?: InputMaybe<Product_Variation_Aggregate_Order_By>;
  sku?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  unit_of_measure?: InputMaybe<Unit_Of_Measure_Order_By>;
};

/** columns and relationships of "product_partner_localities_price" */
export type Product_Partner_Localities_Price = {
  __typename?: 'product_partner_localities_price';
  buy_price?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  currency: Currency;
  currency_id: Scalars['uuid']['output'];
  /** An array relationship */
  customer_order_item_partners: Array<Customer_Order_Item_Partner>;
  /** An aggregate relationship */
  customer_order_item_partners_aggregate: Customer_Order_Item_Partner_Aggregate;
  discount: Scalars['numeric']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  partner_localities_id: Scalars['uuid']['output'];
  /** An object relationship */
  partner_locality: Partner_Localities;
  /** An object relationship */
  product_partner_localities_price?: Maybe<Product_Partner_Localities_Price>;
  /** An array relationship */
  product_partner_localities_price_histories: Array<Product_Partner_Localities_Price_History>;
  /** An aggregate relationship */
  product_partner_localities_price_histories_aggregate: Product_Partner_Localities_Price_History_Aggregate;
  /** An array relationship */
  product_partner_localities_prices: Array<Product_Partner_Localities_Price>;
  /** An aggregate relationship */
  product_partner_localities_prices_aggregate: Product_Partner_Localities_Price_Aggregate;
  /** An object relationship */
  product_variation: Product_Variation;
  product_variation_id: Scalars['uuid']['output'];
  sale_price?: Maybe<Scalars['numeric']['output']>;
};


/** columns and relationships of "product_partner_localities_price" */
export type Product_Partner_Localities_PriceCustomer_Order_Item_PartnersArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Partner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Partner_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Partner_Bool_Exp>;
};


/** columns and relationships of "product_partner_localities_price" */
export type Product_Partner_Localities_PriceCustomer_Order_Item_Partners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Partner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Partner_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Partner_Bool_Exp>;
};


/** columns and relationships of "product_partner_localities_price" */
export type Product_Partner_Localities_PriceProduct_Partner_Localities_Price_HistoriesArgs = {
  distinct_on?: InputMaybe<Array<Product_Partner_Localities_Price_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Partner_Localities_Price_History_Order_By>>;
  where?: InputMaybe<Product_Partner_Localities_Price_History_Bool_Exp>;
};


/** columns and relationships of "product_partner_localities_price" */
export type Product_Partner_Localities_PriceProduct_Partner_Localities_Price_Histories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Partner_Localities_Price_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Partner_Localities_Price_History_Order_By>>;
  where?: InputMaybe<Product_Partner_Localities_Price_History_Bool_Exp>;
};


/** columns and relationships of "product_partner_localities_price" */
export type Product_Partner_Localities_PriceProduct_Partner_Localities_PricesArgs = {
  distinct_on?: InputMaybe<Array<Product_Partner_Localities_Price_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Partner_Localities_Price_Order_By>>;
  where?: InputMaybe<Product_Partner_Localities_Price_Bool_Exp>;
};


/** columns and relationships of "product_partner_localities_price" */
export type Product_Partner_Localities_PriceProduct_Partner_Localities_Prices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Partner_Localities_Price_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Partner_Localities_Price_Order_By>>;
  where?: InputMaybe<Product_Partner_Localities_Price_Bool_Exp>;
};

/** aggregated selection of "product_partner_localities_price" */
export type Product_Partner_Localities_Price_Aggregate = {
  __typename?: 'product_partner_localities_price_aggregate';
  aggregate?: Maybe<Product_Partner_Localities_Price_Aggregate_Fields>;
  nodes: Array<Product_Partner_Localities_Price>;
};

export type Product_Partner_Localities_Price_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Product_Partner_Localities_Price_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Product_Partner_Localities_Price_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Product_Partner_Localities_Price_Aggregate_Bool_Exp_Count>;
};

export type Product_Partner_Localities_Price_Aggregate_Bool_Exp_Bool_And = {
  arguments: Product_Partner_Localities_Price_Select_Column_Product_Partner_Localities_Price_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Product_Partner_Localities_Price_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Product_Partner_Localities_Price_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Product_Partner_Localities_Price_Select_Column_Product_Partner_Localities_Price_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Product_Partner_Localities_Price_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Product_Partner_Localities_Price_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Product_Partner_Localities_Price_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Product_Partner_Localities_Price_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "product_partner_localities_price" */
export type Product_Partner_Localities_Price_Aggregate_Fields = {
  __typename?: 'product_partner_localities_price_aggregate_fields';
  avg?: Maybe<Product_Partner_Localities_Price_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Product_Partner_Localities_Price_Max_Fields>;
  min?: Maybe<Product_Partner_Localities_Price_Min_Fields>;
  stddev?: Maybe<Product_Partner_Localities_Price_Stddev_Fields>;
  stddev_pop?: Maybe<Product_Partner_Localities_Price_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Product_Partner_Localities_Price_Stddev_Samp_Fields>;
  sum?: Maybe<Product_Partner_Localities_Price_Sum_Fields>;
  var_pop?: Maybe<Product_Partner_Localities_Price_Var_Pop_Fields>;
  var_samp?: Maybe<Product_Partner_Localities_Price_Var_Samp_Fields>;
  variance?: Maybe<Product_Partner_Localities_Price_Variance_Fields>;
};


/** aggregate fields of "product_partner_localities_price" */
export type Product_Partner_Localities_Price_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Partner_Localities_Price_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "product_partner_localities_price" */
export type Product_Partner_Localities_Price_Aggregate_Order_By = {
  avg?: InputMaybe<Product_Partner_Localities_Price_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Product_Partner_Localities_Price_Max_Order_By>;
  min?: InputMaybe<Product_Partner_Localities_Price_Min_Order_By>;
  stddev?: InputMaybe<Product_Partner_Localities_Price_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Product_Partner_Localities_Price_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Product_Partner_Localities_Price_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Product_Partner_Localities_Price_Sum_Order_By>;
  var_pop?: InputMaybe<Product_Partner_Localities_Price_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Product_Partner_Localities_Price_Var_Samp_Order_By>;
  variance?: InputMaybe<Product_Partner_Localities_Price_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "product_partner_localities_price" */
export type Product_Partner_Localities_Price_Arr_Rel_Insert_Input = {
  data: Array<Product_Partner_Localities_Price_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Partner_Localities_Price_On_Conflict>;
};

/** aggregate avg on columns */
export type Product_Partner_Localities_Price_Avg_Fields = {
  __typename?: 'product_partner_localities_price_avg_fields';
  buy_price?: Maybe<Scalars['Float']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "product_partner_localities_price" */
export type Product_Partner_Localities_Price_Avg_Order_By = {
  buy_price?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "product_partner_localities_price". All fields are combined with a logical 'AND'. */
export type Product_Partner_Localities_Price_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Partner_Localities_Price_Bool_Exp>>;
  _not?: InputMaybe<Product_Partner_Localities_Price_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Partner_Localities_Price_Bool_Exp>>;
  buy_price?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  currency?: InputMaybe<Currency_Bool_Exp>;
  currency_id?: InputMaybe<Uuid_Comparison_Exp>;
  customer_order_item_partners?: InputMaybe<Customer_Order_Item_Partner_Bool_Exp>;
  customer_order_item_partners_aggregate?: InputMaybe<Customer_Order_Item_Partner_Aggregate_Bool_Exp>;
  discount?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner_localities_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner_locality?: InputMaybe<Partner_Localities_Bool_Exp>;
  product_partner_localities_price?: InputMaybe<Product_Partner_Localities_Price_Bool_Exp>;
  product_partner_localities_price_histories?: InputMaybe<Product_Partner_Localities_Price_History_Bool_Exp>;
  product_partner_localities_price_histories_aggregate?: InputMaybe<Product_Partner_Localities_Price_History_Aggregate_Bool_Exp>;
  product_partner_localities_prices?: InputMaybe<Product_Partner_Localities_Price_Bool_Exp>;
  product_partner_localities_prices_aggregate?: InputMaybe<Product_Partner_Localities_Price_Aggregate_Bool_Exp>;
  product_variation?: InputMaybe<Product_Variation_Bool_Exp>;
  product_variation_id?: InputMaybe<Uuid_Comparison_Exp>;
  sale_price?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_partner_localities_price" */
export enum Product_Partner_Localities_Price_Constraint {
  /** unique or primary key constraint on columns  */
  CompositeKeyIndex = 'composite_key_index',
  /** unique or primary key constraint on columns "id" */
  ProductPartnerLocalitiesPricePkey = 'product_partner_localities_price_pkey'
}

/** columns and relationships of "product_partner_localities_price_history" */
export type Product_Partner_Localities_Price_History = {
  __typename?: 'product_partner_localities_price_history';
  buy_price?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An array relationship */
  invoiced_items: Array<Invoiced_Item>;
  /** An aggregate relationship */
  invoiced_items_aggregate: Invoiced_Item_Aggregate;
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  new_discount?: Maybe<Scalars['numeric']['output']>;
  old_buy_price?: Maybe<Scalars['numeric']['output']>;
  old_discount?: Maybe<Scalars['numeric']['output']>;
  old_sale_price?: Maybe<Scalars['numeric']['output']>;
  partner_localities_id: Scalars['uuid']['output'];
  /** An object relationship */
  partner_locality: Partner_Localities;
  previous_date?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  product_partner_localities_price: Product_Partner_Localities_Price;
  product_partner_localities_price_id: Scalars['uuid']['output'];
  /** An object relationship */
  product_variation: Product_Variation;
  product_variation_id: Scalars['uuid']['output'];
  sale_price?: Maybe<Scalars['numeric']['output']>;
  sale_price_excl_vat: Scalars['numeric']['output'];
  valid_from: Scalars['timestamp']['output'];
  valid_to: Scalars['timestamp']['output'];
  vat_rate: Scalars['numeric']['output'];
};


/** columns and relationships of "product_partner_localities_price_history" */
export type Product_Partner_Localities_Price_HistoryInvoiced_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Bool_Exp>;
};


/** columns and relationships of "product_partner_localities_price_history" */
export type Product_Partner_Localities_Price_HistoryInvoiced_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Bool_Exp>;
};

/** aggregated selection of "product_partner_localities_price_history" */
export type Product_Partner_Localities_Price_History_Aggregate = {
  __typename?: 'product_partner_localities_price_history_aggregate';
  aggregate?: Maybe<Product_Partner_Localities_Price_History_Aggregate_Fields>;
  nodes: Array<Product_Partner_Localities_Price_History>;
};

export type Product_Partner_Localities_Price_History_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Product_Partner_Localities_Price_History_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Product_Partner_Localities_Price_History_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Product_Partner_Localities_Price_History_Aggregate_Bool_Exp_Count>;
};

export type Product_Partner_Localities_Price_History_Aggregate_Bool_Exp_Bool_And = {
  arguments: Product_Partner_Localities_Price_History_Select_Column_Product_Partner_Localities_Price_History_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Product_Partner_Localities_Price_History_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Product_Partner_Localities_Price_History_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Product_Partner_Localities_Price_History_Select_Column_Product_Partner_Localities_Price_History_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Product_Partner_Localities_Price_History_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Product_Partner_Localities_Price_History_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Product_Partner_Localities_Price_History_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Product_Partner_Localities_Price_History_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "product_partner_localities_price_history" */
export type Product_Partner_Localities_Price_History_Aggregate_Fields = {
  __typename?: 'product_partner_localities_price_history_aggregate_fields';
  avg?: Maybe<Product_Partner_Localities_Price_History_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Product_Partner_Localities_Price_History_Max_Fields>;
  min?: Maybe<Product_Partner_Localities_Price_History_Min_Fields>;
  stddev?: Maybe<Product_Partner_Localities_Price_History_Stddev_Fields>;
  stddev_pop?: Maybe<Product_Partner_Localities_Price_History_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Product_Partner_Localities_Price_History_Stddev_Samp_Fields>;
  sum?: Maybe<Product_Partner_Localities_Price_History_Sum_Fields>;
  var_pop?: Maybe<Product_Partner_Localities_Price_History_Var_Pop_Fields>;
  var_samp?: Maybe<Product_Partner_Localities_Price_History_Var_Samp_Fields>;
  variance?: Maybe<Product_Partner_Localities_Price_History_Variance_Fields>;
};


/** aggregate fields of "product_partner_localities_price_history" */
export type Product_Partner_Localities_Price_History_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Partner_Localities_Price_History_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "product_partner_localities_price_history" */
export type Product_Partner_Localities_Price_History_Aggregate_Order_By = {
  avg?: InputMaybe<Product_Partner_Localities_Price_History_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Product_Partner_Localities_Price_History_Max_Order_By>;
  min?: InputMaybe<Product_Partner_Localities_Price_History_Min_Order_By>;
  stddev?: InputMaybe<Product_Partner_Localities_Price_History_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Product_Partner_Localities_Price_History_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Product_Partner_Localities_Price_History_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Product_Partner_Localities_Price_History_Sum_Order_By>;
  var_pop?: InputMaybe<Product_Partner_Localities_Price_History_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Product_Partner_Localities_Price_History_Var_Samp_Order_By>;
  variance?: InputMaybe<Product_Partner_Localities_Price_History_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "product_partner_localities_price_history" */
export type Product_Partner_Localities_Price_History_Arr_Rel_Insert_Input = {
  data: Array<Product_Partner_Localities_Price_History_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Partner_Localities_Price_History_On_Conflict>;
};

/** aggregate avg on columns */
export type Product_Partner_Localities_Price_History_Avg_Fields = {
  __typename?: 'product_partner_localities_price_history_avg_fields';
  buy_price?: Maybe<Scalars['Float']['output']>;
  new_discount?: Maybe<Scalars['Float']['output']>;
  old_buy_price?: Maybe<Scalars['Float']['output']>;
  old_discount?: Maybe<Scalars['Float']['output']>;
  old_sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_excl_vat?: Maybe<Scalars['Float']['output']>;
  vat_rate?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "product_partner_localities_price_history" */
export type Product_Partner_Localities_Price_History_Avg_Order_By = {
  buy_price?: InputMaybe<Order_By>;
  new_discount?: InputMaybe<Order_By>;
  old_buy_price?: InputMaybe<Order_By>;
  old_discount?: InputMaybe<Order_By>;
  old_sale_price?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_excl_vat?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "product_partner_localities_price_history". All fields are combined with a logical 'AND'. */
export type Product_Partner_Localities_Price_History_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Partner_Localities_Price_History_Bool_Exp>>;
  _not?: InputMaybe<Product_Partner_Localities_Price_History_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Partner_Localities_Price_History_Bool_Exp>>;
  buy_price?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invoiced_items?: InputMaybe<Invoiced_Item_Bool_Exp>;
  invoiced_items_aggregate?: InputMaybe<Invoiced_Item_Aggregate_Bool_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  new_discount?: InputMaybe<Numeric_Comparison_Exp>;
  old_buy_price?: InputMaybe<Numeric_Comparison_Exp>;
  old_discount?: InputMaybe<Numeric_Comparison_Exp>;
  old_sale_price?: InputMaybe<Numeric_Comparison_Exp>;
  partner_localities_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner_locality?: InputMaybe<Partner_Localities_Bool_Exp>;
  previous_date?: InputMaybe<Timestamp_Comparison_Exp>;
  product_partner_localities_price?: InputMaybe<Product_Partner_Localities_Price_Bool_Exp>;
  product_partner_localities_price_id?: InputMaybe<Uuid_Comparison_Exp>;
  product_variation?: InputMaybe<Product_Variation_Bool_Exp>;
  product_variation_id?: InputMaybe<Uuid_Comparison_Exp>;
  sale_price?: InputMaybe<Numeric_Comparison_Exp>;
  sale_price_excl_vat?: InputMaybe<Numeric_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamp_Comparison_Exp>;
  valid_to?: InputMaybe<Timestamp_Comparison_Exp>;
  vat_rate?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_partner_localities_price_history" */
export enum Product_Partner_Localities_Price_History_Constraint {
  /** unique or primary key constraint on columns "product_partner_localities_price_id", "valid_from" */
  PplphUniqueFrom = 'pplph_unique_from',
  /** unique or primary key constraint on columns "id" */
  ProductPartnerLocalitiesPriceHistoryPkey = 'product_partner_localities_price_history_pkey'
}

/** input type for incrementing numeric columns in table "product_partner_localities_price_history" */
export type Product_Partner_Localities_Price_History_Inc_Input = {
  buy_price?: InputMaybe<Scalars['numeric']['input']>;
  new_discount?: InputMaybe<Scalars['numeric']['input']>;
  old_buy_price?: InputMaybe<Scalars['numeric']['input']>;
  old_discount?: InputMaybe<Scalars['numeric']['input']>;
  old_sale_price?: InputMaybe<Scalars['numeric']['input']>;
  sale_price?: InputMaybe<Scalars['numeric']['input']>;
  sale_price_excl_vat?: InputMaybe<Scalars['numeric']['input']>;
  vat_rate?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "product_partner_localities_price_history" */
export type Product_Partner_Localities_Price_History_Insert_Input = {
  buy_price?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invoiced_items?: InputMaybe<Invoiced_Item_Arr_Rel_Insert_Input>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  new_discount?: InputMaybe<Scalars['numeric']['input']>;
  old_buy_price?: InputMaybe<Scalars['numeric']['input']>;
  old_discount?: InputMaybe<Scalars['numeric']['input']>;
  old_sale_price?: InputMaybe<Scalars['numeric']['input']>;
  partner_localities_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_locality?: InputMaybe<Partner_Localities_Obj_Rel_Insert_Input>;
  previous_date?: InputMaybe<Scalars['timestamp']['input']>;
  product_partner_localities_price?: InputMaybe<Product_Partner_Localities_Price_Obj_Rel_Insert_Input>;
  product_partner_localities_price_id?: InputMaybe<Scalars['uuid']['input']>;
  product_variation?: InputMaybe<Product_Variation_Obj_Rel_Insert_Input>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  sale_price?: InputMaybe<Scalars['numeric']['input']>;
  sale_price_excl_vat?: InputMaybe<Scalars['numeric']['input']>;
  valid_from?: InputMaybe<Scalars['timestamp']['input']>;
  valid_to?: InputMaybe<Scalars['timestamp']['input']>;
  vat_rate?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Product_Partner_Localities_Price_History_Max_Fields = {
  __typename?: 'product_partner_localities_price_history_max_fields';
  buy_price?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  new_discount?: Maybe<Scalars['numeric']['output']>;
  old_buy_price?: Maybe<Scalars['numeric']['output']>;
  old_discount?: Maybe<Scalars['numeric']['output']>;
  old_sale_price?: Maybe<Scalars['numeric']['output']>;
  partner_localities_id?: Maybe<Scalars['uuid']['output']>;
  previous_date?: Maybe<Scalars['timestamp']['output']>;
  product_partner_localities_price_id?: Maybe<Scalars['uuid']['output']>;
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
  sale_price?: Maybe<Scalars['numeric']['output']>;
  sale_price_excl_vat?: Maybe<Scalars['numeric']['output']>;
  valid_from?: Maybe<Scalars['timestamp']['output']>;
  valid_to?: Maybe<Scalars['timestamp']['output']>;
  vat_rate?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "product_partner_localities_price_history" */
export type Product_Partner_Localities_Price_History_Max_Order_By = {
  buy_price?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  new_discount?: InputMaybe<Order_By>;
  old_buy_price?: InputMaybe<Order_By>;
  old_discount?: InputMaybe<Order_By>;
  old_sale_price?: InputMaybe<Order_By>;
  partner_localities_id?: InputMaybe<Order_By>;
  previous_date?: InputMaybe<Order_By>;
  product_partner_localities_price_id?: InputMaybe<Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_excl_vat?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_to?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Product_Partner_Localities_Price_History_Min_Fields = {
  __typename?: 'product_partner_localities_price_history_min_fields';
  buy_price?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  new_discount?: Maybe<Scalars['numeric']['output']>;
  old_buy_price?: Maybe<Scalars['numeric']['output']>;
  old_discount?: Maybe<Scalars['numeric']['output']>;
  old_sale_price?: Maybe<Scalars['numeric']['output']>;
  partner_localities_id?: Maybe<Scalars['uuid']['output']>;
  previous_date?: Maybe<Scalars['timestamp']['output']>;
  product_partner_localities_price_id?: Maybe<Scalars['uuid']['output']>;
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
  sale_price?: Maybe<Scalars['numeric']['output']>;
  sale_price_excl_vat?: Maybe<Scalars['numeric']['output']>;
  valid_from?: Maybe<Scalars['timestamp']['output']>;
  valid_to?: Maybe<Scalars['timestamp']['output']>;
  vat_rate?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "product_partner_localities_price_history" */
export type Product_Partner_Localities_Price_History_Min_Order_By = {
  buy_price?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  new_discount?: InputMaybe<Order_By>;
  old_buy_price?: InputMaybe<Order_By>;
  old_discount?: InputMaybe<Order_By>;
  old_sale_price?: InputMaybe<Order_By>;
  partner_localities_id?: InputMaybe<Order_By>;
  previous_date?: InputMaybe<Order_By>;
  product_partner_localities_price_id?: InputMaybe<Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_excl_vat?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_to?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_partner_localities_price_history" */
export type Product_Partner_Localities_Price_History_Mutation_Response = {
  __typename?: 'product_partner_localities_price_history_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_Partner_Localities_Price_History>;
};

/** input type for inserting object relation for remote table "product_partner_localities_price_history" */
export type Product_Partner_Localities_Price_History_Obj_Rel_Insert_Input = {
  data: Product_Partner_Localities_Price_History_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Partner_Localities_Price_History_On_Conflict>;
};

/** on_conflict condition type for table "product_partner_localities_price_history" */
export type Product_Partner_Localities_Price_History_On_Conflict = {
  constraint: Product_Partner_Localities_Price_History_Constraint;
  update_columns?: Array<Product_Partner_Localities_Price_History_Update_Column>;
  where?: InputMaybe<Product_Partner_Localities_Price_History_Bool_Exp>;
};

/** Ordering options when selecting data from "product_partner_localities_price_history". */
export type Product_Partner_Localities_Price_History_Order_By = {
  buy_price?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoiced_items_aggregate?: InputMaybe<Invoiced_Item_Aggregate_Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  new_discount?: InputMaybe<Order_By>;
  old_buy_price?: InputMaybe<Order_By>;
  old_discount?: InputMaybe<Order_By>;
  old_sale_price?: InputMaybe<Order_By>;
  partner_localities_id?: InputMaybe<Order_By>;
  partner_locality?: InputMaybe<Partner_Localities_Order_By>;
  previous_date?: InputMaybe<Order_By>;
  product_partner_localities_price?: InputMaybe<Product_Partner_Localities_Price_Order_By>;
  product_partner_localities_price_id?: InputMaybe<Order_By>;
  product_variation?: InputMaybe<Product_Variation_Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_excl_vat?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_to?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_partner_localities_price_history */
export type Product_Partner_Localities_Price_History_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "product_partner_localities_price_history" */
export enum Product_Partner_Localities_Price_History_Select_Column {
  /** column name */
  BuyPrice = 'buy_price',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  NewDiscount = 'new_discount',
  /** column name */
  OldBuyPrice = 'old_buy_price',
  /** column name */
  OldDiscount = 'old_discount',
  /** column name */
  OldSalePrice = 'old_sale_price',
  /** column name */
  PartnerLocalitiesId = 'partner_localities_id',
  /** column name */
  PreviousDate = 'previous_date',
  /** column name */
  ProductPartnerLocalitiesPriceId = 'product_partner_localities_price_id',
  /** column name */
  ProductVariationId = 'product_variation_id',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceExclVat = 'sale_price_excl_vat',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTo = 'valid_to',
  /** column name */
  VatRate = 'vat_rate'
}

/** select "product_partner_localities_price_history_aggregate_bool_exp_bool_and_arguments_columns" columns of table "product_partner_localities_price_history" */
export enum Product_Partner_Localities_Price_History_Select_Column_Product_Partner_Localities_Price_History_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "product_partner_localities_price_history_aggregate_bool_exp_bool_or_arguments_columns" columns of table "product_partner_localities_price_history" */
export enum Product_Partner_Localities_Price_History_Select_Column_Product_Partner_Localities_Price_History_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "product_partner_localities_price_history" */
export type Product_Partner_Localities_Price_History_Set_Input = {
  buy_price?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  new_discount?: InputMaybe<Scalars['numeric']['input']>;
  old_buy_price?: InputMaybe<Scalars['numeric']['input']>;
  old_discount?: InputMaybe<Scalars['numeric']['input']>;
  old_sale_price?: InputMaybe<Scalars['numeric']['input']>;
  partner_localities_id?: InputMaybe<Scalars['uuid']['input']>;
  previous_date?: InputMaybe<Scalars['timestamp']['input']>;
  product_partner_localities_price_id?: InputMaybe<Scalars['uuid']['input']>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  sale_price?: InputMaybe<Scalars['numeric']['input']>;
  sale_price_excl_vat?: InputMaybe<Scalars['numeric']['input']>;
  valid_from?: InputMaybe<Scalars['timestamp']['input']>;
  valid_to?: InputMaybe<Scalars['timestamp']['input']>;
  vat_rate?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Product_Partner_Localities_Price_History_Stddev_Fields = {
  __typename?: 'product_partner_localities_price_history_stddev_fields';
  buy_price?: Maybe<Scalars['Float']['output']>;
  new_discount?: Maybe<Scalars['Float']['output']>;
  old_buy_price?: Maybe<Scalars['Float']['output']>;
  old_discount?: Maybe<Scalars['Float']['output']>;
  old_sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_excl_vat?: Maybe<Scalars['Float']['output']>;
  vat_rate?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "product_partner_localities_price_history" */
export type Product_Partner_Localities_Price_History_Stddev_Order_By = {
  buy_price?: InputMaybe<Order_By>;
  new_discount?: InputMaybe<Order_By>;
  old_buy_price?: InputMaybe<Order_By>;
  old_discount?: InputMaybe<Order_By>;
  old_sale_price?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_excl_vat?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Product_Partner_Localities_Price_History_Stddev_Pop_Fields = {
  __typename?: 'product_partner_localities_price_history_stddev_pop_fields';
  buy_price?: Maybe<Scalars['Float']['output']>;
  new_discount?: Maybe<Scalars['Float']['output']>;
  old_buy_price?: Maybe<Scalars['Float']['output']>;
  old_discount?: Maybe<Scalars['Float']['output']>;
  old_sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_excl_vat?: Maybe<Scalars['Float']['output']>;
  vat_rate?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "product_partner_localities_price_history" */
export type Product_Partner_Localities_Price_History_Stddev_Pop_Order_By = {
  buy_price?: InputMaybe<Order_By>;
  new_discount?: InputMaybe<Order_By>;
  old_buy_price?: InputMaybe<Order_By>;
  old_discount?: InputMaybe<Order_By>;
  old_sale_price?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_excl_vat?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Product_Partner_Localities_Price_History_Stddev_Samp_Fields = {
  __typename?: 'product_partner_localities_price_history_stddev_samp_fields';
  buy_price?: Maybe<Scalars['Float']['output']>;
  new_discount?: Maybe<Scalars['Float']['output']>;
  old_buy_price?: Maybe<Scalars['Float']['output']>;
  old_discount?: Maybe<Scalars['Float']['output']>;
  old_sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_excl_vat?: Maybe<Scalars['Float']['output']>;
  vat_rate?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "product_partner_localities_price_history" */
export type Product_Partner_Localities_Price_History_Stddev_Samp_Order_By = {
  buy_price?: InputMaybe<Order_By>;
  new_discount?: InputMaybe<Order_By>;
  old_buy_price?: InputMaybe<Order_By>;
  old_discount?: InputMaybe<Order_By>;
  old_sale_price?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_excl_vat?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "product_partner_localities_price_history" */
export type Product_Partner_Localities_Price_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Partner_Localities_Price_History_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Partner_Localities_Price_History_Stream_Cursor_Value_Input = {
  buy_price?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  new_discount?: InputMaybe<Scalars['numeric']['input']>;
  old_buy_price?: InputMaybe<Scalars['numeric']['input']>;
  old_discount?: InputMaybe<Scalars['numeric']['input']>;
  old_sale_price?: InputMaybe<Scalars['numeric']['input']>;
  partner_localities_id?: InputMaybe<Scalars['uuid']['input']>;
  previous_date?: InputMaybe<Scalars['timestamp']['input']>;
  product_partner_localities_price_id?: InputMaybe<Scalars['uuid']['input']>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  sale_price?: InputMaybe<Scalars['numeric']['input']>;
  sale_price_excl_vat?: InputMaybe<Scalars['numeric']['input']>;
  valid_from?: InputMaybe<Scalars['timestamp']['input']>;
  valid_to?: InputMaybe<Scalars['timestamp']['input']>;
  vat_rate?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Product_Partner_Localities_Price_History_Sum_Fields = {
  __typename?: 'product_partner_localities_price_history_sum_fields';
  buy_price?: Maybe<Scalars['numeric']['output']>;
  new_discount?: Maybe<Scalars['numeric']['output']>;
  old_buy_price?: Maybe<Scalars['numeric']['output']>;
  old_discount?: Maybe<Scalars['numeric']['output']>;
  old_sale_price?: Maybe<Scalars['numeric']['output']>;
  sale_price?: Maybe<Scalars['numeric']['output']>;
  sale_price_excl_vat?: Maybe<Scalars['numeric']['output']>;
  vat_rate?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "product_partner_localities_price_history" */
export type Product_Partner_Localities_Price_History_Sum_Order_By = {
  buy_price?: InputMaybe<Order_By>;
  new_discount?: InputMaybe<Order_By>;
  old_buy_price?: InputMaybe<Order_By>;
  old_discount?: InputMaybe<Order_By>;
  old_sale_price?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_excl_vat?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
};

/** update columns of table "product_partner_localities_price_history" */
export enum Product_Partner_Localities_Price_History_Update_Column {
  /** column name */
  BuyPrice = 'buy_price',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  NewDiscount = 'new_discount',
  /** column name */
  OldBuyPrice = 'old_buy_price',
  /** column name */
  OldDiscount = 'old_discount',
  /** column name */
  OldSalePrice = 'old_sale_price',
  /** column name */
  PartnerLocalitiesId = 'partner_localities_id',
  /** column name */
  PreviousDate = 'previous_date',
  /** column name */
  ProductPartnerLocalitiesPriceId = 'product_partner_localities_price_id',
  /** column name */
  ProductVariationId = 'product_variation_id',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceExclVat = 'sale_price_excl_vat',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTo = 'valid_to',
  /** column name */
  VatRate = 'vat_rate'
}

export type Product_Partner_Localities_Price_History_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Product_Partner_Localities_Price_History_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Partner_Localities_Price_History_Set_Input>;
  /** filter the rows which have to be updated */
  where: Product_Partner_Localities_Price_History_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Product_Partner_Localities_Price_History_Var_Pop_Fields = {
  __typename?: 'product_partner_localities_price_history_var_pop_fields';
  buy_price?: Maybe<Scalars['Float']['output']>;
  new_discount?: Maybe<Scalars['Float']['output']>;
  old_buy_price?: Maybe<Scalars['Float']['output']>;
  old_discount?: Maybe<Scalars['Float']['output']>;
  old_sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_excl_vat?: Maybe<Scalars['Float']['output']>;
  vat_rate?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "product_partner_localities_price_history" */
export type Product_Partner_Localities_Price_History_Var_Pop_Order_By = {
  buy_price?: InputMaybe<Order_By>;
  new_discount?: InputMaybe<Order_By>;
  old_buy_price?: InputMaybe<Order_By>;
  old_discount?: InputMaybe<Order_By>;
  old_sale_price?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_excl_vat?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Product_Partner_Localities_Price_History_Var_Samp_Fields = {
  __typename?: 'product_partner_localities_price_history_var_samp_fields';
  buy_price?: Maybe<Scalars['Float']['output']>;
  new_discount?: Maybe<Scalars['Float']['output']>;
  old_buy_price?: Maybe<Scalars['Float']['output']>;
  old_discount?: Maybe<Scalars['Float']['output']>;
  old_sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_excl_vat?: Maybe<Scalars['Float']['output']>;
  vat_rate?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "product_partner_localities_price_history" */
export type Product_Partner_Localities_Price_History_Var_Samp_Order_By = {
  buy_price?: InputMaybe<Order_By>;
  new_discount?: InputMaybe<Order_By>;
  old_buy_price?: InputMaybe<Order_By>;
  old_discount?: InputMaybe<Order_By>;
  old_sale_price?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_excl_vat?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Product_Partner_Localities_Price_History_Variance_Fields = {
  __typename?: 'product_partner_localities_price_history_variance_fields';
  buy_price?: Maybe<Scalars['Float']['output']>;
  new_discount?: Maybe<Scalars['Float']['output']>;
  old_buy_price?: Maybe<Scalars['Float']['output']>;
  old_discount?: Maybe<Scalars['Float']['output']>;
  old_sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_excl_vat?: Maybe<Scalars['Float']['output']>;
  vat_rate?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "product_partner_localities_price_history" */
export type Product_Partner_Localities_Price_History_Variance_Order_By = {
  buy_price?: InputMaybe<Order_By>;
  new_discount?: InputMaybe<Order_By>;
  old_buy_price?: InputMaybe<Order_By>;
  old_discount?: InputMaybe<Order_By>;
  old_sale_price?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_excl_vat?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "product_partner_localities_price" */
export type Product_Partner_Localities_Price_Inc_Input = {
  buy_price?: InputMaybe<Scalars['numeric']['input']>;
  discount?: InputMaybe<Scalars['numeric']['input']>;
  sale_price?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "product_partner_localities_price" */
export type Product_Partner_Localities_Price_Insert_Input = {
  buy_price?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  currency?: InputMaybe<Currency_Obj_Rel_Insert_Input>;
  currency_id?: InputMaybe<Scalars['uuid']['input']>;
  customer_order_item_partners?: InputMaybe<Customer_Order_Item_Partner_Arr_Rel_Insert_Input>;
  discount?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_localities_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_locality?: InputMaybe<Partner_Localities_Obj_Rel_Insert_Input>;
  product_partner_localities_price?: InputMaybe<Product_Partner_Localities_Price_Obj_Rel_Insert_Input>;
  product_partner_localities_price_histories?: InputMaybe<Product_Partner_Localities_Price_History_Arr_Rel_Insert_Input>;
  product_partner_localities_prices?: InputMaybe<Product_Partner_Localities_Price_Arr_Rel_Insert_Input>;
  product_variation?: InputMaybe<Product_Variation_Obj_Rel_Insert_Input>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  sale_price?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Product_Partner_Localities_Price_Max_Fields = {
  __typename?: 'product_partner_localities_price_max_fields';
  buy_price?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  currency_id?: Maybe<Scalars['uuid']['output']>;
  discount?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  partner_localities_id?: Maybe<Scalars['uuid']['output']>;
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
  sale_price?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "product_partner_localities_price" */
export type Product_Partner_Localities_Price_Max_Order_By = {
  buy_price?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency_id?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  partner_localities_id?: InputMaybe<Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Product_Partner_Localities_Price_Min_Fields = {
  __typename?: 'product_partner_localities_price_min_fields';
  buy_price?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  currency_id?: Maybe<Scalars['uuid']['output']>;
  discount?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  partner_localities_id?: Maybe<Scalars['uuid']['output']>;
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
  sale_price?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "product_partner_localities_price" */
export type Product_Partner_Localities_Price_Min_Order_By = {
  buy_price?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency_id?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  partner_localities_id?: InputMaybe<Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_partner_localities_price" */
export type Product_Partner_Localities_Price_Mutation_Response = {
  __typename?: 'product_partner_localities_price_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_Partner_Localities_Price>;
};

/** input type for inserting object relation for remote table "product_partner_localities_price" */
export type Product_Partner_Localities_Price_Obj_Rel_Insert_Input = {
  data: Product_Partner_Localities_Price_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Partner_Localities_Price_On_Conflict>;
};

/** on_conflict condition type for table "product_partner_localities_price" */
export type Product_Partner_Localities_Price_On_Conflict = {
  constraint: Product_Partner_Localities_Price_Constraint;
  update_columns?: Array<Product_Partner_Localities_Price_Update_Column>;
  where?: InputMaybe<Product_Partner_Localities_Price_Bool_Exp>;
};

/** Ordering options when selecting data from "product_partner_localities_price". */
export type Product_Partner_Localities_Price_Order_By = {
  buy_price?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Currency_Order_By>;
  currency_id?: InputMaybe<Order_By>;
  customer_order_item_partners_aggregate?: InputMaybe<Customer_Order_Item_Partner_Aggregate_Order_By>;
  discount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  partner_localities_id?: InputMaybe<Order_By>;
  partner_locality?: InputMaybe<Partner_Localities_Order_By>;
  product_partner_localities_price?: InputMaybe<Product_Partner_Localities_Price_Order_By>;
  product_partner_localities_price_histories_aggregate?: InputMaybe<Product_Partner_Localities_Price_History_Aggregate_Order_By>;
  product_partner_localities_prices_aggregate?: InputMaybe<Product_Partner_Localities_Price_Aggregate_Order_By>;
  product_variation?: InputMaybe<Product_Variation_Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_partner_localities_price */
export type Product_Partner_Localities_Price_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "product_partner_localities_price" */
export enum Product_Partner_Localities_Price_Select_Column {
  /** column name */
  BuyPrice = 'buy_price',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  Discount = 'discount',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  PartnerLocalitiesId = 'partner_localities_id',
  /** column name */
  ProductVariationId = 'product_variation_id',
  /** column name */
  SalePrice = 'sale_price'
}

/** select "product_partner_localities_price_aggregate_bool_exp_bool_and_arguments_columns" columns of table "product_partner_localities_price" */
export enum Product_Partner_Localities_Price_Select_Column_Product_Partner_Localities_Price_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "product_partner_localities_price_aggregate_bool_exp_bool_or_arguments_columns" columns of table "product_partner_localities_price" */
export enum Product_Partner_Localities_Price_Select_Column_Product_Partner_Localities_Price_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "product_partner_localities_price" */
export type Product_Partner_Localities_Price_Set_Input = {
  buy_price?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  currency_id?: InputMaybe<Scalars['uuid']['input']>;
  discount?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_localities_id?: InputMaybe<Scalars['uuid']['input']>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  sale_price?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Product_Partner_Localities_Price_Stddev_Fields = {
  __typename?: 'product_partner_localities_price_stddev_fields';
  buy_price?: Maybe<Scalars['Float']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "product_partner_localities_price" */
export type Product_Partner_Localities_Price_Stddev_Order_By = {
  buy_price?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Product_Partner_Localities_Price_Stddev_Pop_Fields = {
  __typename?: 'product_partner_localities_price_stddev_pop_fields';
  buy_price?: Maybe<Scalars['Float']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "product_partner_localities_price" */
export type Product_Partner_Localities_Price_Stddev_Pop_Order_By = {
  buy_price?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Product_Partner_Localities_Price_Stddev_Samp_Fields = {
  __typename?: 'product_partner_localities_price_stddev_samp_fields';
  buy_price?: Maybe<Scalars['Float']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "product_partner_localities_price" */
export type Product_Partner_Localities_Price_Stddev_Samp_Order_By = {
  buy_price?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "product_partner_localities_price" */
export type Product_Partner_Localities_Price_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Partner_Localities_Price_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Partner_Localities_Price_Stream_Cursor_Value_Input = {
  buy_price?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  currency_id?: InputMaybe<Scalars['uuid']['input']>;
  discount?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_localities_id?: InputMaybe<Scalars['uuid']['input']>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  sale_price?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Product_Partner_Localities_Price_Sum_Fields = {
  __typename?: 'product_partner_localities_price_sum_fields';
  buy_price?: Maybe<Scalars['numeric']['output']>;
  discount?: Maybe<Scalars['numeric']['output']>;
  sale_price?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "product_partner_localities_price" */
export type Product_Partner_Localities_Price_Sum_Order_By = {
  buy_price?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
};

/** update columns of table "product_partner_localities_price" */
export enum Product_Partner_Localities_Price_Update_Column {
  /** column name */
  BuyPrice = 'buy_price',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  Discount = 'discount',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  PartnerLocalitiesId = 'partner_localities_id',
  /** column name */
  ProductVariationId = 'product_variation_id',
  /** column name */
  SalePrice = 'sale_price'
}

export type Product_Partner_Localities_Price_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Product_Partner_Localities_Price_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Partner_Localities_Price_Set_Input>;
  /** filter the rows which have to be updated */
  where: Product_Partner_Localities_Price_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Product_Partner_Localities_Price_Var_Pop_Fields = {
  __typename?: 'product_partner_localities_price_var_pop_fields';
  buy_price?: Maybe<Scalars['Float']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "product_partner_localities_price" */
export type Product_Partner_Localities_Price_Var_Pop_Order_By = {
  buy_price?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Product_Partner_Localities_Price_Var_Samp_Fields = {
  __typename?: 'product_partner_localities_price_var_samp_fields';
  buy_price?: Maybe<Scalars['Float']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "product_partner_localities_price" */
export type Product_Partner_Localities_Price_Var_Samp_Order_By = {
  buy_price?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Product_Partner_Localities_Price_Variance_Fields = {
  __typename?: 'product_partner_localities_price_variance_fields';
  buy_price?: Maybe<Scalars['Float']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "product_partner_localities_price" */
export type Product_Partner_Localities_Price_Variance_Order_By = {
  buy_price?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
};

/** columns and relationships of "product_photos" */
export type Product_Photos = {
  __typename?: 'product_photos';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  product: Product;
  product_id: Scalars['uuid']['output'];
  rank_id?: Maybe<Scalars['Int']['output']>;
  url: Scalars['String']['output'];
};

/** aggregated selection of "product_photos" */
export type Product_Photos_Aggregate = {
  __typename?: 'product_photos_aggregate';
  aggregate?: Maybe<Product_Photos_Aggregate_Fields>;
  nodes: Array<Product_Photos>;
};

export type Product_Photos_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Product_Photos_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Product_Photos_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Product_Photos_Aggregate_Bool_Exp_Count>;
};

export type Product_Photos_Aggregate_Bool_Exp_Bool_And = {
  arguments: Product_Photos_Select_Column_Product_Photos_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Product_Photos_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Product_Photos_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Product_Photos_Select_Column_Product_Photos_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Product_Photos_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Product_Photos_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Product_Photos_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Product_Photos_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "product_photos" */
export type Product_Photos_Aggregate_Fields = {
  __typename?: 'product_photos_aggregate_fields';
  avg?: Maybe<Product_Photos_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Product_Photos_Max_Fields>;
  min?: Maybe<Product_Photos_Min_Fields>;
  stddev?: Maybe<Product_Photos_Stddev_Fields>;
  stddev_pop?: Maybe<Product_Photos_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Product_Photos_Stddev_Samp_Fields>;
  sum?: Maybe<Product_Photos_Sum_Fields>;
  var_pop?: Maybe<Product_Photos_Var_Pop_Fields>;
  var_samp?: Maybe<Product_Photos_Var_Samp_Fields>;
  variance?: Maybe<Product_Photos_Variance_Fields>;
};


/** aggregate fields of "product_photos" */
export type Product_Photos_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Photos_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "product_photos" */
export type Product_Photos_Aggregate_Order_By = {
  avg?: InputMaybe<Product_Photos_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Product_Photos_Max_Order_By>;
  min?: InputMaybe<Product_Photos_Min_Order_By>;
  stddev?: InputMaybe<Product_Photos_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Product_Photos_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Product_Photos_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Product_Photos_Sum_Order_By>;
  var_pop?: InputMaybe<Product_Photos_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Product_Photos_Var_Samp_Order_By>;
  variance?: InputMaybe<Product_Photos_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "product_photos" */
export type Product_Photos_Arr_Rel_Insert_Input = {
  data: Array<Product_Photos_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Photos_On_Conflict>;
};

/** aggregate avg on columns */
export type Product_Photos_Avg_Fields = {
  __typename?: 'product_photos_avg_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "product_photos" */
export type Product_Photos_Avg_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "product_photos". All fields are combined with a logical 'AND'. */
export type Product_Photos_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Photos_Bool_Exp>>;
  _not?: InputMaybe<Product_Photos_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Photos_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  product_id?: InputMaybe<Uuid_Comparison_Exp>;
  rank_id?: InputMaybe<Int_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_photos" */
export enum Product_Photos_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductPhotosPkey = 'product_photos_pkey'
}

/** input type for incrementing numeric columns in table "product_photos" */
export type Product_Photos_Inc_Input = {
  rank_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "product_photos" */
export type Product_Photos_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
  rank_id?: InputMaybe<Scalars['Int']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Product_Photos_Max_Fields = {
  __typename?: 'product_photos_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  product_id?: Maybe<Scalars['uuid']['output']>;
  rank_id?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "product_photos" */
export type Product_Photos_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  rank_id?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Product_Photos_Min_Fields = {
  __typename?: 'product_photos_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  product_id?: Maybe<Scalars['uuid']['output']>;
  rank_id?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "product_photos" */
export type Product_Photos_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  rank_id?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_photos" */
export type Product_Photos_Mutation_Response = {
  __typename?: 'product_photos_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_Photos>;
};

/** on_conflict condition type for table "product_photos" */
export type Product_Photos_On_Conflict = {
  constraint: Product_Photos_Constraint;
  update_columns?: Array<Product_Photos_Update_Column>;
  where?: InputMaybe<Product_Photos_Bool_Exp>;
};

/** Ordering options when selecting data from "product_photos". */
export type Product_Photos_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  product_id?: InputMaybe<Order_By>;
  rank_id?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_photos */
export type Product_Photos_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "product_photos" */
export enum Product_Photos_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  RankId = 'rank_id',
  /** column name */
  Url = 'url'
}

/** select "product_photos_aggregate_bool_exp_bool_and_arguments_columns" columns of table "product_photos" */
export enum Product_Photos_Select_Column_Product_Photos_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "product_photos_aggregate_bool_exp_bool_or_arguments_columns" columns of table "product_photos" */
export enum Product_Photos_Select_Column_Product_Photos_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "product_photos" */
export type Product_Photos_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
  rank_id?: InputMaybe<Scalars['Int']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Product_Photos_Stddev_Fields = {
  __typename?: 'product_photos_stddev_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "product_photos" */
export type Product_Photos_Stddev_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Product_Photos_Stddev_Pop_Fields = {
  __typename?: 'product_photos_stddev_pop_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "product_photos" */
export type Product_Photos_Stddev_Pop_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Product_Photos_Stddev_Samp_Fields = {
  __typename?: 'product_photos_stddev_samp_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "product_photos" */
export type Product_Photos_Stddev_Samp_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "product_photos" */
export type Product_Photos_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Photos_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Photos_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
  rank_id?: InputMaybe<Scalars['Int']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Product_Photos_Sum_Fields = {
  __typename?: 'product_photos_sum_fields';
  rank_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "product_photos" */
export type Product_Photos_Sum_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** update columns of table "product_photos" */
export enum Product_Photos_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  RankId = 'rank_id',
  /** column name */
  Url = 'url'
}

export type Product_Photos_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Product_Photos_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Photos_Set_Input>;
  /** filter the rows which have to be updated */
  where: Product_Photos_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Product_Photos_Var_Pop_Fields = {
  __typename?: 'product_photos_var_pop_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "product_photos" */
export type Product_Photos_Var_Pop_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Product_Photos_Var_Samp_Fields = {
  __typename?: 'product_photos_var_samp_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "product_photos" */
export type Product_Photos_Var_Samp_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Product_Photos_Variance_Fields = {
  __typename?: 'product_photos_variance_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "product_photos" */
export type Product_Photos_Variance_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product */
export type Product_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "product" */
export enum Product_Select_Column {
  /** column name */
  BaseUom = 'base_uom',
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  HsnCode = 'hsn_code',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  ProductType = 'product_type',
  /** column name */
  Sku = 'sku',
  /** column name */
  Slug = 'slug'
}

/** select "product_aggregate_bool_exp_bool_and_arguments_columns" columns of table "product" */
export enum Product_Select_Column_Product_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "product_aggregate_bool_exp_bool_or_arguments_columns" columns of table "product" */
export enum Product_Select_Column_Product_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "product" */
export type Product_Set_Input = {
  /** The unit that defines this product's DIMENSION, and the default unit for its order lines. An order line may transact in a different unit of the SAME dimension but never across dimensions - enforced by the customer_order_item dimension guard. NULL means no unit is defined and consumers fall back to the deployment default. Set once, then immutable - see the write-once trigger. */
  base_uom?: InputMaybe<Unit_Of_Measure_Enum>;
  category_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hsn_code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  product_type?: InputMaybe<Product_Type_Enum>;
  sku?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "product" */
export type Product_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Stream_Cursor_Value_Input = {
  /** The unit that defines this product's DIMENSION, and the default unit for its order lines. An order line may transact in a different unit of the SAME dimension but never across dimensions - enforced by the customer_order_item dimension guard. NULL means no unit is defined and consumers fall back to the deployment default. Set once, then immutable - see the write-once trigger. */
  base_uom?: InputMaybe<Unit_Of_Measure_Enum>;
  category_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hsn_code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  product_type?: InputMaybe<Product_Type_Enum>;
  sku?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "product_type" */
export type Product_Type = {
  __typename?: 'product_type';
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  products: Array<Product>;
  /** An aggregate relationship */
  products_aggregate: Product_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "product_type" */
export type Product_TypeProductsArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


/** columns and relationships of "product_type" */
export type Product_TypeProducts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};

/** aggregated selection of "product_type" */
export type Product_Type_Aggregate = {
  __typename?: 'product_type_aggregate';
  aggregate?: Maybe<Product_Type_Aggregate_Fields>;
  nodes: Array<Product_Type>;
};

/** aggregate fields of "product_type" */
export type Product_Type_Aggregate_Fields = {
  __typename?: 'product_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Product_Type_Max_Fields>;
  min?: Maybe<Product_Type_Min_Fields>;
};


/** aggregate fields of "product_type" */
export type Product_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "product_type". All fields are combined with a logical 'AND'. */
export type Product_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Type_Bool_Exp>>;
  _not?: InputMaybe<Product_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  products?: InputMaybe<Product_Bool_Exp>;
  products_aggregate?: InputMaybe<Product_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_type" */
export enum Product_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  ProductTypePkey = 'product_type_pkey'
}

export enum Product_Type_Enum {
  /** CONSUMABLE */
  Consumable = 'CONSUMABLE',
  /** FB */
  Fb = 'FB',
  /** SERVICES */
  Services = 'SERVICES'
}

/** Boolean expression to compare columns of type "product_type_enum". All fields are combined with logical 'AND'. */
export type Product_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Product_Type_Enum>;
  _in?: InputMaybe<Array<Product_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Product_Type_Enum>;
  _nin?: InputMaybe<Array<Product_Type_Enum>>;
};

/** input type for inserting data into table "product_type" */
export type Product_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Product_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Product_Type_Max_Fields = {
  __typename?: 'product_type_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Product_Type_Min_Fields = {
  __typename?: 'product_type_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "product_type" */
export type Product_Type_Mutation_Response = {
  __typename?: 'product_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_Type>;
};

/** input type for inserting object relation for remote table "product_type" */
export type Product_Type_Obj_Rel_Insert_Input = {
  data: Product_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Type_On_Conflict>;
};

/** on_conflict condition type for table "product_type" */
export type Product_Type_On_Conflict = {
  constraint: Product_Type_Constraint;
  update_columns?: Array<Product_Type_Update_Column>;
  where?: InputMaybe<Product_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "product_type". */
export type Product_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  products_aggregate?: InputMaybe<Product_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_type */
export type Product_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "product_type" */
export enum Product_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "product_type" */
export type Product_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "product_type" */
export type Product_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "product_type" */
export enum Product_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Product_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Product_Type_Bool_Exp;
};

/** update columns of table "product" */
export enum Product_Update_Column {
  /** column name */
  BaseUom = 'base_uom',
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  HsnCode = 'hsn_code',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  ProductType = 'product_type',
  /** column name */
  Sku = 'sku',
  /** column name */
  Slug = 'slug'
}

export type Product_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Set_Input>;
  /** filter the rows which have to be updated */
  where: Product_Bool_Exp;
};

/** columns and relationships of "product_variation" */
export type Product_Variation = {
  __typename?: 'product_variation';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  customer_order_items: Array<Customer_Order_Item>;
  /** An aggregate relationship */
  customer_order_items_aggregate: Customer_Order_Item_Aggregate;
  erp_code?: Maybe<Scalars['String']['output']>;
  expiry_date?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  fillup_requests: Array<Fillup_Request>;
  /** An aggregate relationship */
  fillup_requests_aggregate: Fillup_Request_Aggregate;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  invoiced_items: Array<Invoiced_Item>;
  /** An aggregate relationship */
  invoiced_items_aggregate: Invoiced_Item_Aggregate;
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  master_slots: Array<Master_Slot>;
  /** An aggregate relationship */
  master_slots_aggregate: Master_Slot_Aggregate;
  /** An array relationship */
  order_schedulers: Array<Order_Scheduler>;
  /** An aggregate relationship */
  order_schedulers_aggregate: Order_Scheduler_Aggregate;
  /** An array relationship */
  organization_commission_product_variation_types: Array<Organization_Commission_Product_Variation_Type>;
  /** An aggregate relationship */
  organization_commission_product_variation_types_aggregate: Organization_Commission_Product_Variation_Type_Aggregate;
  /** An array relationship */
  organization_product_variation_discount_histories: Array<Organization_Product_Variation_Discount_History>;
  /** An aggregate relationship */
  organization_product_variation_discount_histories_aggregate: Organization_Product_Variation_Discount_History_Aggregate;
  /** An array relationship */
  organization_product_variation_discounts: Array<Organization_Product_Variation_Discount>;
  /** An aggregate relationship */
  organization_product_variation_discounts_aggregate: Organization_Product_Variation_Discount_Aggregate;
  /** An array relationship */
  partner_commission_product_variation_types: Array<Partner_Commission_Product_Variation_Type>;
  /** An aggregate relationship */
  partner_commission_product_variation_types_aggregate: Partner_Commission_Product_Variation_Type_Aggregate;
  /** An array relationship */
  partner_order_items: Array<Partner_Order_Item>;
  /** An aggregate relationship */
  partner_order_items_aggregate: Partner_Order_Item_Aggregate;
  price?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  product: Product;
  product_id: Scalars['uuid']['output'];
  /** An array relationship */
  product_partner_localities_price_histories: Array<Product_Partner_Localities_Price_History>;
  /** An aggregate relationship */
  product_partner_localities_price_histories_aggregate: Product_Partner_Localities_Price_History_Aggregate;
  /** An array relationship */
  product_partner_localities_prices: Array<Product_Partner_Localities_Price>;
  /** An aggregate relationship */
  product_partner_localities_prices_aggregate: Product_Partner_Localities_Price_Aggregate;
  /** An array relationship */
  product_variation_partner_localities_slots: Array<Product_Variation_Partner_Localities_Slots>;
  /** An aggregate relationship */
  product_variation_partner_localities_slots_aggregate: Product_Variation_Partner_Localities_Slots_Aggregate;
  /** An array relationship */
  product_variation_photos: Array<Product_Variation_Photos>;
  /** An aggregate relationship */
  product_variation_photos_aggregate: Product_Variation_Photos_Aggregate;
  /** An array relationship */
  product_variation_safety_checklist_categories: Array<Product_Variation_Safety_Checklist_Category>;
  /** An aggregate relationship */
  product_variation_safety_checklist_categories_aggregate: Product_Variation_Safety_Checklist_Category_Aggregate;
  /** An array relationship */
  product_variation_test_categories: Array<Product_Variation_Test_Category>;
  /** An aggregate relationship */
  product_variation_test_categories_aggregate: Product_Variation_Test_Category_Aggregate;
  /** An array relationship */
  purchase_order_items: Array<Purchase_Order_Items>;
  /** An aggregate relationship */
  purchase_order_items_aggregate: Purchase_Order_Items_Aggregate;
  /** An object relationship */
  variation: Variation;
  variation_id: Scalars['uuid']['output'];
  /** An array relationship */
  vehicle_inventory_transaction_logs: Array<Vehicle_Inventory_Transaction_Logs>;
  /** An aggregate relationship */
  vehicle_inventory_transaction_logs_aggregate: Vehicle_Inventory_Transaction_Logs_Aggregate;
  /** An array relationship */
  vehicle_tank_type_product_variations: Array<Vehicle_Tank_Type_Product_Variation>;
  /** An aggregate relationship */
  vehicle_tank_type_product_variations_aggregate: Vehicle_Tank_Type_Product_Variation_Aggregate;
  /** An array relationship */
  vendor_order_logs: Array<Vendor_Order_Logs>;
  /** An aggregate relationship */
  vendor_order_logs_aggregate: Vendor_Order_Logs_Aggregate;
};


/** columns and relationships of "product_variation" */
export type Product_VariationCustomer_Order_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Bool_Exp>;
};


/** columns and relationships of "product_variation" */
export type Product_VariationCustomer_Order_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Bool_Exp>;
};


/** columns and relationships of "product_variation" */
export type Product_VariationFillup_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Fillup_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fillup_Request_Order_By>>;
  where?: InputMaybe<Fillup_Request_Bool_Exp>;
};


/** columns and relationships of "product_variation" */
export type Product_VariationFillup_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fillup_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fillup_Request_Order_By>>;
  where?: InputMaybe<Fillup_Request_Bool_Exp>;
};


/** columns and relationships of "product_variation" */
export type Product_VariationInvoiced_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Bool_Exp>;
};


/** columns and relationships of "product_variation" */
export type Product_VariationInvoiced_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Bool_Exp>;
};


/** columns and relationships of "product_variation" */
export type Product_VariationMaster_SlotsArgs = {
  distinct_on?: InputMaybe<Array<Master_Slot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Slot_Order_By>>;
  where?: InputMaybe<Master_Slot_Bool_Exp>;
};


/** columns and relationships of "product_variation" */
export type Product_VariationMaster_Slots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Master_Slot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Slot_Order_By>>;
  where?: InputMaybe<Master_Slot_Bool_Exp>;
};


/** columns and relationships of "product_variation" */
export type Product_VariationOrder_SchedulersArgs = {
  distinct_on?: InputMaybe<Array<Order_Scheduler_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Scheduler_Order_By>>;
  where?: InputMaybe<Order_Scheduler_Bool_Exp>;
};


/** columns and relationships of "product_variation" */
export type Product_VariationOrder_Schedulers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Scheduler_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Scheduler_Order_By>>;
  where?: InputMaybe<Order_Scheduler_Bool_Exp>;
};


/** columns and relationships of "product_variation" */
export type Product_VariationOrganization_Commission_Product_Variation_TypesArgs = {
  distinct_on?: InputMaybe<Array<Organization_Commission_Product_Variation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Commission_Product_Variation_Type_Order_By>>;
  where?: InputMaybe<Organization_Commission_Product_Variation_Type_Bool_Exp>;
};


/** columns and relationships of "product_variation" */
export type Product_VariationOrganization_Commission_Product_Variation_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Commission_Product_Variation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Commission_Product_Variation_Type_Order_By>>;
  where?: InputMaybe<Organization_Commission_Product_Variation_Type_Bool_Exp>;
};


/** columns and relationships of "product_variation" */
export type Product_VariationOrganization_Product_Variation_Discount_HistoriesArgs = {
  distinct_on?: InputMaybe<Array<Organization_Product_Variation_Discount_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Product_Variation_Discount_History_Order_By>>;
  where?: InputMaybe<Organization_Product_Variation_Discount_History_Bool_Exp>;
};


/** columns and relationships of "product_variation" */
export type Product_VariationOrganization_Product_Variation_Discount_Histories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Product_Variation_Discount_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Product_Variation_Discount_History_Order_By>>;
  where?: InputMaybe<Organization_Product_Variation_Discount_History_Bool_Exp>;
};


/** columns and relationships of "product_variation" */
export type Product_VariationOrganization_Product_Variation_DiscountsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Product_Variation_Discount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Product_Variation_Discount_Order_By>>;
  where?: InputMaybe<Organization_Product_Variation_Discount_Bool_Exp>;
};


/** columns and relationships of "product_variation" */
export type Product_VariationOrganization_Product_Variation_Discounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Product_Variation_Discount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Product_Variation_Discount_Order_By>>;
  where?: InputMaybe<Organization_Product_Variation_Discount_Bool_Exp>;
};


/** columns and relationships of "product_variation" */
export type Product_VariationPartner_Commission_Product_Variation_TypesArgs = {
  distinct_on?: InputMaybe<Array<Partner_Commission_Product_Variation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Commission_Product_Variation_Type_Order_By>>;
  where?: InputMaybe<Partner_Commission_Product_Variation_Type_Bool_Exp>;
};


/** columns and relationships of "product_variation" */
export type Product_VariationPartner_Commission_Product_Variation_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Commission_Product_Variation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Commission_Product_Variation_Type_Order_By>>;
  where?: InputMaybe<Partner_Commission_Product_Variation_Type_Bool_Exp>;
};


/** columns and relationships of "product_variation" */
export type Product_VariationPartner_Order_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Bool_Exp>;
};


/** columns and relationships of "product_variation" */
export type Product_VariationPartner_Order_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Bool_Exp>;
};


/** columns and relationships of "product_variation" */
export type Product_VariationProduct_Partner_Localities_Price_HistoriesArgs = {
  distinct_on?: InputMaybe<Array<Product_Partner_Localities_Price_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Partner_Localities_Price_History_Order_By>>;
  where?: InputMaybe<Product_Partner_Localities_Price_History_Bool_Exp>;
};


/** columns and relationships of "product_variation" */
export type Product_VariationProduct_Partner_Localities_Price_Histories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Partner_Localities_Price_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Partner_Localities_Price_History_Order_By>>;
  where?: InputMaybe<Product_Partner_Localities_Price_History_Bool_Exp>;
};


/** columns and relationships of "product_variation" */
export type Product_VariationProduct_Partner_Localities_PricesArgs = {
  distinct_on?: InputMaybe<Array<Product_Partner_Localities_Price_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Partner_Localities_Price_Order_By>>;
  where?: InputMaybe<Product_Partner_Localities_Price_Bool_Exp>;
};


/** columns and relationships of "product_variation" */
export type Product_VariationProduct_Partner_Localities_Prices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Partner_Localities_Price_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Partner_Localities_Price_Order_By>>;
  where?: InputMaybe<Product_Partner_Localities_Price_Bool_Exp>;
};


/** columns and relationships of "product_variation" */
export type Product_VariationProduct_Variation_Partner_Localities_SlotsArgs = {
  distinct_on?: InputMaybe<Array<Product_Variation_Partner_Localities_Slots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Variation_Partner_Localities_Slots_Order_By>>;
  where?: InputMaybe<Product_Variation_Partner_Localities_Slots_Bool_Exp>;
};


/** columns and relationships of "product_variation" */
export type Product_VariationProduct_Variation_Partner_Localities_Slots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Variation_Partner_Localities_Slots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Variation_Partner_Localities_Slots_Order_By>>;
  where?: InputMaybe<Product_Variation_Partner_Localities_Slots_Bool_Exp>;
};


/** columns and relationships of "product_variation" */
export type Product_VariationProduct_Variation_PhotosArgs = {
  distinct_on?: InputMaybe<Array<Product_Variation_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Variation_Photos_Order_By>>;
  where?: InputMaybe<Product_Variation_Photos_Bool_Exp>;
};


/** columns and relationships of "product_variation" */
export type Product_VariationProduct_Variation_Photos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Variation_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Variation_Photos_Order_By>>;
  where?: InputMaybe<Product_Variation_Photos_Bool_Exp>;
};


/** columns and relationships of "product_variation" */
export type Product_VariationProduct_Variation_Safety_Checklist_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Product_Variation_Safety_Checklist_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Variation_Safety_Checklist_Category_Order_By>>;
  where?: InputMaybe<Product_Variation_Safety_Checklist_Category_Bool_Exp>;
};


/** columns and relationships of "product_variation" */
export type Product_VariationProduct_Variation_Safety_Checklist_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Variation_Safety_Checklist_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Variation_Safety_Checklist_Category_Order_By>>;
  where?: InputMaybe<Product_Variation_Safety_Checklist_Category_Bool_Exp>;
};


/** columns and relationships of "product_variation" */
export type Product_VariationProduct_Variation_Test_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Product_Variation_Test_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Variation_Test_Category_Order_By>>;
  where?: InputMaybe<Product_Variation_Test_Category_Bool_Exp>;
};


/** columns and relationships of "product_variation" */
export type Product_VariationProduct_Variation_Test_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Variation_Test_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Variation_Test_Category_Order_By>>;
  where?: InputMaybe<Product_Variation_Test_Category_Bool_Exp>;
};


/** columns and relationships of "product_variation" */
export type Product_VariationPurchase_Order_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Purchase_Order_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Purchase_Order_Items_Order_By>>;
  where?: InputMaybe<Purchase_Order_Items_Bool_Exp>;
};


/** columns and relationships of "product_variation" */
export type Product_VariationPurchase_Order_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Purchase_Order_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Purchase_Order_Items_Order_By>>;
  where?: InputMaybe<Purchase_Order_Items_Bool_Exp>;
};


/** columns and relationships of "product_variation" */
export type Product_VariationVehicle_Inventory_Transaction_LogsArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Inventory_Transaction_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Inventory_Transaction_Logs_Order_By>>;
  where?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Bool_Exp>;
};


/** columns and relationships of "product_variation" */
export type Product_VariationVehicle_Inventory_Transaction_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Inventory_Transaction_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Inventory_Transaction_Logs_Order_By>>;
  where?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Bool_Exp>;
};


/** columns and relationships of "product_variation" */
export type Product_VariationVehicle_Tank_Type_Product_VariationsArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Tank_Type_Product_Variation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Tank_Type_Product_Variation_Order_By>>;
  where?: InputMaybe<Vehicle_Tank_Type_Product_Variation_Bool_Exp>;
};


/** columns and relationships of "product_variation" */
export type Product_VariationVehicle_Tank_Type_Product_Variations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Tank_Type_Product_Variation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Tank_Type_Product_Variation_Order_By>>;
  where?: InputMaybe<Vehicle_Tank_Type_Product_Variation_Bool_Exp>;
};


/** columns and relationships of "product_variation" */
export type Product_VariationVendor_Order_LogsArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Order_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Order_Logs_Order_By>>;
  where?: InputMaybe<Vendor_Order_Logs_Bool_Exp>;
};


/** columns and relationships of "product_variation" */
export type Product_VariationVendor_Order_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Order_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Order_Logs_Order_By>>;
  where?: InputMaybe<Vendor_Order_Logs_Bool_Exp>;
};

/** aggregated selection of "product_variation" */
export type Product_Variation_Aggregate = {
  __typename?: 'product_variation_aggregate';
  aggregate?: Maybe<Product_Variation_Aggregate_Fields>;
  nodes: Array<Product_Variation>;
};

export type Product_Variation_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Product_Variation_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Product_Variation_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Product_Variation_Aggregate_Bool_Exp_Count>;
};

export type Product_Variation_Aggregate_Bool_Exp_Bool_And = {
  arguments: Product_Variation_Select_Column_Product_Variation_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Product_Variation_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Product_Variation_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Product_Variation_Select_Column_Product_Variation_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Product_Variation_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Product_Variation_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Product_Variation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Product_Variation_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "product_variation" */
export type Product_Variation_Aggregate_Fields = {
  __typename?: 'product_variation_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Product_Variation_Max_Fields>;
  min?: Maybe<Product_Variation_Min_Fields>;
};


/** aggregate fields of "product_variation" */
export type Product_Variation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Variation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "product_variation" */
export type Product_Variation_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Product_Variation_Max_Order_By>;
  min?: InputMaybe<Product_Variation_Min_Order_By>;
};

/** input type for inserting array relation for remote table "product_variation" */
export type Product_Variation_Arr_Rel_Insert_Input = {
  data: Array<Product_Variation_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Variation_On_Conflict>;
};

/** Boolean expression to filter rows from the table "product_variation". All fields are combined with a logical 'AND'. */
export type Product_Variation_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Variation_Bool_Exp>>;
  _not?: InputMaybe<Product_Variation_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Variation_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_order_items?: InputMaybe<Customer_Order_Item_Bool_Exp>;
  customer_order_items_aggregate?: InputMaybe<Customer_Order_Item_Aggregate_Bool_Exp>;
  erp_code?: InputMaybe<String_Comparison_Exp>;
  expiry_date?: InputMaybe<Timestamp_Comparison_Exp>;
  fillup_requests?: InputMaybe<Fillup_Request_Bool_Exp>;
  fillup_requests_aggregate?: InputMaybe<Fillup_Request_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invoiced_items?: InputMaybe<Invoiced_Item_Bool_Exp>;
  invoiced_items_aggregate?: InputMaybe<Invoiced_Item_Aggregate_Bool_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  master_slots?: InputMaybe<Master_Slot_Bool_Exp>;
  master_slots_aggregate?: InputMaybe<Master_Slot_Aggregate_Bool_Exp>;
  order_schedulers?: InputMaybe<Order_Scheduler_Bool_Exp>;
  order_schedulers_aggregate?: InputMaybe<Order_Scheduler_Aggregate_Bool_Exp>;
  organization_commission_product_variation_types?: InputMaybe<Organization_Commission_Product_Variation_Type_Bool_Exp>;
  organization_commission_product_variation_types_aggregate?: InputMaybe<Organization_Commission_Product_Variation_Type_Aggregate_Bool_Exp>;
  organization_product_variation_discount_histories?: InputMaybe<Organization_Product_Variation_Discount_History_Bool_Exp>;
  organization_product_variation_discount_histories_aggregate?: InputMaybe<Organization_Product_Variation_Discount_History_Aggregate_Bool_Exp>;
  organization_product_variation_discounts?: InputMaybe<Organization_Product_Variation_Discount_Bool_Exp>;
  organization_product_variation_discounts_aggregate?: InputMaybe<Organization_Product_Variation_Discount_Aggregate_Bool_Exp>;
  partner_commission_product_variation_types?: InputMaybe<Partner_Commission_Product_Variation_Type_Bool_Exp>;
  partner_commission_product_variation_types_aggregate?: InputMaybe<Partner_Commission_Product_Variation_Type_Aggregate_Bool_Exp>;
  partner_order_items?: InputMaybe<Partner_Order_Item_Bool_Exp>;
  partner_order_items_aggregate?: InputMaybe<Partner_Order_Item_Aggregate_Bool_Exp>;
  price?: InputMaybe<String_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  product_id?: InputMaybe<Uuid_Comparison_Exp>;
  product_partner_localities_price_histories?: InputMaybe<Product_Partner_Localities_Price_History_Bool_Exp>;
  product_partner_localities_price_histories_aggregate?: InputMaybe<Product_Partner_Localities_Price_History_Aggregate_Bool_Exp>;
  product_partner_localities_prices?: InputMaybe<Product_Partner_Localities_Price_Bool_Exp>;
  product_partner_localities_prices_aggregate?: InputMaybe<Product_Partner_Localities_Price_Aggregate_Bool_Exp>;
  product_variation_partner_localities_slots?: InputMaybe<Product_Variation_Partner_Localities_Slots_Bool_Exp>;
  product_variation_partner_localities_slots_aggregate?: InputMaybe<Product_Variation_Partner_Localities_Slots_Aggregate_Bool_Exp>;
  product_variation_photos?: InputMaybe<Product_Variation_Photos_Bool_Exp>;
  product_variation_photos_aggregate?: InputMaybe<Product_Variation_Photos_Aggregate_Bool_Exp>;
  product_variation_safety_checklist_categories?: InputMaybe<Product_Variation_Safety_Checklist_Category_Bool_Exp>;
  product_variation_safety_checklist_categories_aggregate?: InputMaybe<Product_Variation_Safety_Checklist_Category_Aggregate_Bool_Exp>;
  product_variation_test_categories?: InputMaybe<Product_Variation_Test_Category_Bool_Exp>;
  product_variation_test_categories_aggregate?: InputMaybe<Product_Variation_Test_Category_Aggregate_Bool_Exp>;
  purchase_order_items?: InputMaybe<Purchase_Order_Items_Bool_Exp>;
  purchase_order_items_aggregate?: InputMaybe<Purchase_Order_Items_Aggregate_Bool_Exp>;
  variation?: InputMaybe<Variation_Bool_Exp>;
  variation_id?: InputMaybe<Uuid_Comparison_Exp>;
  vehicle_inventory_transaction_logs?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Bool_Exp>;
  vehicle_inventory_transaction_logs_aggregate?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Aggregate_Bool_Exp>;
  vehicle_tank_type_product_variations?: InputMaybe<Vehicle_Tank_Type_Product_Variation_Bool_Exp>;
  vehicle_tank_type_product_variations_aggregate?: InputMaybe<Vehicle_Tank_Type_Product_Variation_Aggregate_Bool_Exp>;
  vendor_order_logs?: InputMaybe<Vendor_Order_Logs_Bool_Exp>;
  vendor_order_logs_aggregate?: InputMaybe<Vendor_Order_Logs_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "product_variation" */
export enum Product_Variation_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductVariationPkey = 'product_variation_pkey'
}

/** input type for inserting data into table "product_variation" */
export type Product_Variation_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_items?: InputMaybe<Customer_Order_Item_Arr_Rel_Insert_Input>;
  erp_code?: InputMaybe<Scalars['String']['input']>;
  expiry_date?: InputMaybe<Scalars['timestamp']['input']>;
  fillup_requests?: InputMaybe<Fillup_Request_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invoiced_items?: InputMaybe<Invoiced_Item_Arr_Rel_Insert_Input>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  master_slots?: InputMaybe<Master_Slot_Arr_Rel_Insert_Input>;
  order_schedulers?: InputMaybe<Order_Scheduler_Arr_Rel_Insert_Input>;
  organization_commission_product_variation_types?: InputMaybe<Organization_Commission_Product_Variation_Type_Arr_Rel_Insert_Input>;
  organization_product_variation_discount_histories?: InputMaybe<Organization_Product_Variation_Discount_History_Arr_Rel_Insert_Input>;
  organization_product_variation_discounts?: InputMaybe<Organization_Product_Variation_Discount_Arr_Rel_Insert_Input>;
  partner_commission_product_variation_types?: InputMaybe<Partner_Commission_Product_Variation_Type_Arr_Rel_Insert_Input>;
  partner_order_items?: InputMaybe<Partner_Order_Item_Arr_Rel_Insert_Input>;
  price?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
  product_partner_localities_price_histories?: InputMaybe<Product_Partner_Localities_Price_History_Arr_Rel_Insert_Input>;
  product_partner_localities_prices?: InputMaybe<Product_Partner_Localities_Price_Arr_Rel_Insert_Input>;
  product_variation_partner_localities_slots?: InputMaybe<Product_Variation_Partner_Localities_Slots_Arr_Rel_Insert_Input>;
  product_variation_photos?: InputMaybe<Product_Variation_Photos_Arr_Rel_Insert_Input>;
  product_variation_safety_checklist_categories?: InputMaybe<Product_Variation_Safety_Checklist_Category_Arr_Rel_Insert_Input>;
  product_variation_test_categories?: InputMaybe<Product_Variation_Test_Category_Arr_Rel_Insert_Input>;
  purchase_order_items?: InputMaybe<Purchase_Order_Items_Arr_Rel_Insert_Input>;
  variation?: InputMaybe<Variation_Obj_Rel_Insert_Input>;
  variation_id?: InputMaybe<Scalars['uuid']['input']>;
  vehicle_inventory_transaction_logs?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Arr_Rel_Insert_Input>;
  vehicle_tank_type_product_variations?: InputMaybe<Vehicle_Tank_Type_Product_Variation_Arr_Rel_Insert_Input>;
  vendor_order_logs?: InputMaybe<Vendor_Order_Logs_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Product_Variation_Max_Fields = {
  __typename?: 'product_variation_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  erp_code?: Maybe<Scalars['String']['output']>;
  expiry_date?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  product_id?: Maybe<Scalars['uuid']['output']>;
  variation_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "product_variation" */
export type Product_Variation_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  erp_code?: InputMaybe<Order_By>;
  expiry_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  variation_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Product_Variation_Min_Fields = {
  __typename?: 'product_variation_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  erp_code?: Maybe<Scalars['String']['output']>;
  expiry_date?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  product_id?: Maybe<Scalars['uuid']['output']>;
  variation_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "product_variation" */
export type Product_Variation_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  erp_code?: InputMaybe<Order_By>;
  expiry_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  variation_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_variation" */
export type Product_Variation_Mutation_Response = {
  __typename?: 'product_variation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_Variation>;
};

/** input type for inserting object relation for remote table "product_variation" */
export type Product_Variation_Obj_Rel_Insert_Input = {
  data: Product_Variation_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Variation_On_Conflict>;
};

/** on_conflict condition type for table "product_variation" */
export type Product_Variation_On_Conflict = {
  constraint: Product_Variation_Constraint;
  update_columns?: Array<Product_Variation_Update_Column>;
  where?: InputMaybe<Product_Variation_Bool_Exp>;
};

/** Ordering options when selecting data from "product_variation". */
export type Product_Variation_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_order_items_aggregate?: InputMaybe<Customer_Order_Item_Aggregate_Order_By>;
  erp_code?: InputMaybe<Order_By>;
  expiry_date?: InputMaybe<Order_By>;
  fillup_requests_aggregate?: InputMaybe<Fillup_Request_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  invoiced_items_aggregate?: InputMaybe<Invoiced_Item_Aggregate_Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  master_slots_aggregate?: InputMaybe<Master_Slot_Aggregate_Order_By>;
  order_schedulers_aggregate?: InputMaybe<Order_Scheduler_Aggregate_Order_By>;
  organization_commission_product_variation_types_aggregate?: InputMaybe<Organization_Commission_Product_Variation_Type_Aggregate_Order_By>;
  organization_product_variation_discount_histories_aggregate?: InputMaybe<Organization_Product_Variation_Discount_History_Aggregate_Order_By>;
  organization_product_variation_discounts_aggregate?: InputMaybe<Organization_Product_Variation_Discount_Aggregate_Order_By>;
  partner_commission_product_variation_types_aggregate?: InputMaybe<Partner_Commission_Product_Variation_Type_Aggregate_Order_By>;
  partner_order_items_aggregate?: InputMaybe<Partner_Order_Item_Aggregate_Order_By>;
  price?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  product_id?: InputMaybe<Order_By>;
  product_partner_localities_price_histories_aggregate?: InputMaybe<Product_Partner_Localities_Price_History_Aggregate_Order_By>;
  product_partner_localities_prices_aggregate?: InputMaybe<Product_Partner_Localities_Price_Aggregate_Order_By>;
  product_variation_partner_localities_slots_aggregate?: InputMaybe<Product_Variation_Partner_Localities_Slots_Aggregate_Order_By>;
  product_variation_photos_aggregate?: InputMaybe<Product_Variation_Photos_Aggregate_Order_By>;
  product_variation_safety_checklist_categories_aggregate?: InputMaybe<Product_Variation_Safety_Checklist_Category_Aggregate_Order_By>;
  product_variation_test_categories_aggregate?: InputMaybe<Product_Variation_Test_Category_Aggregate_Order_By>;
  purchase_order_items_aggregate?: InputMaybe<Purchase_Order_Items_Aggregate_Order_By>;
  variation?: InputMaybe<Variation_Order_By>;
  variation_id?: InputMaybe<Order_By>;
  vehicle_inventory_transaction_logs_aggregate?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Aggregate_Order_By>;
  vehicle_tank_type_product_variations_aggregate?: InputMaybe<Vehicle_Tank_Type_Product_Variation_Aggregate_Order_By>;
  vendor_order_logs_aggregate?: InputMaybe<Vendor_Order_Logs_Aggregate_Order_By>;
};

/** columns and relationships of "product_variation_partner_localities_slots" */
export type Product_Variation_Partner_Localities_Slots = {
  __typename?: 'product_variation_partner_localities_slots';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  customer_order_item_partners: Array<Customer_Order_Item_Partner>;
  /** An aggregate relationship */
  customer_order_item_partners_aggregate: Customer_Order_Item_Partner_Aggregate;
  /** An array relationship */
  customer_order_items: Array<Customer_Order_Item>;
  /** An aggregate relationship */
  customer_order_items_aggregate: Customer_Order_Item_Aggregate;
  /** An array relationship */
  customer_orders: Array<Customer_Order>;
  /** An aggregate relationship */
  customer_orders_aggregate: Customer_Order_Aggregate;
  day_date: Scalars['date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  disclaimer?: Maybe<Scalars['String']['output']>;
  end_time: Scalars['timetz']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  is_visible: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order_limit?: Maybe<Scalars['numeric']['output']>;
  partner_localities_id: Scalars['uuid']['output'];
  /** An object relationship */
  partner_locality: Partner_Localities;
  /** An object relationship */
  product_variation: Product_Variation;
  product_variation_id: Scalars['uuid']['output'];
  start_time: Scalars['timetz']['output'];
};


/** columns and relationships of "product_variation_partner_localities_slots" */
export type Product_Variation_Partner_Localities_SlotsCustomer_Order_Item_PartnersArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Partner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Partner_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Partner_Bool_Exp>;
};


/** columns and relationships of "product_variation_partner_localities_slots" */
export type Product_Variation_Partner_Localities_SlotsCustomer_Order_Item_Partners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Partner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Partner_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Partner_Bool_Exp>;
};


/** columns and relationships of "product_variation_partner_localities_slots" */
export type Product_Variation_Partner_Localities_SlotsCustomer_Order_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Bool_Exp>;
};


/** columns and relationships of "product_variation_partner_localities_slots" */
export type Product_Variation_Partner_Localities_SlotsCustomer_Order_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Bool_Exp>;
};


/** columns and relationships of "product_variation_partner_localities_slots" */
export type Product_Variation_Partner_Localities_SlotsCustomer_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Order_By>>;
  where?: InputMaybe<Customer_Order_Bool_Exp>;
};


/** columns and relationships of "product_variation_partner_localities_slots" */
export type Product_Variation_Partner_Localities_SlotsCustomer_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Order_By>>;
  where?: InputMaybe<Customer_Order_Bool_Exp>;
};

/** aggregated selection of "product_variation_partner_localities_slots" */
export type Product_Variation_Partner_Localities_Slots_Aggregate = {
  __typename?: 'product_variation_partner_localities_slots_aggregate';
  aggregate?: Maybe<Product_Variation_Partner_Localities_Slots_Aggregate_Fields>;
  nodes: Array<Product_Variation_Partner_Localities_Slots>;
};

export type Product_Variation_Partner_Localities_Slots_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Product_Variation_Partner_Localities_Slots_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Product_Variation_Partner_Localities_Slots_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Product_Variation_Partner_Localities_Slots_Aggregate_Bool_Exp_Count>;
};

export type Product_Variation_Partner_Localities_Slots_Aggregate_Bool_Exp_Bool_And = {
  arguments: Product_Variation_Partner_Localities_Slots_Select_Column_Product_Variation_Partner_Localities_Slots_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Product_Variation_Partner_Localities_Slots_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Product_Variation_Partner_Localities_Slots_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Product_Variation_Partner_Localities_Slots_Select_Column_Product_Variation_Partner_Localities_Slots_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Product_Variation_Partner_Localities_Slots_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Product_Variation_Partner_Localities_Slots_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Product_Variation_Partner_Localities_Slots_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Product_Variation_Partner_Localities_Slots_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "product_variation_partner_localities_slots" */
export type Product_Variation_Partner_Localities_Slots_Aggregate_Fields = {
  __typename?: 'product_variation_partner_localities_slots_aggregate_fields';
  avg?: Maybe<Product_Variation_Partner_Localities_Slots_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Product_Variation_Partner_Localities_Slots_Max_Fields>;
  min?: Maybe<Product_Variation_Partner_Localities_Slots_Min_Fields>;
  stddev?: Maybe<Product_Variation_Partner_Localities_Slots_Stddev_Fields>;
  stddev_pop?: Maybe<Product_Variation_Partner_Localities_Slots_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Product_Variation_Partner_Localities_Slots_Stddev_Samp_Fields>;
  sum?: Maybe<Product_Variation_Partner_Localities_Slots_Sum_Fields>;
  var_pop?: Maybe<Product_Variation_Partner_Localities_Slots_Var_Pop_Fields>;
  var_samp?: Maybe<Product_Variation_Partner_Localities_Slots_Var_Samp_Fields>;
  variance?: Maybe<Product_Variation_Partner_Localities_Slots_Variance_Fields>;
};


/** aggregate fields of "product_variation_partner_localities_slots" */
export type Product_Variation_Partner_Localities_Slots_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Variation_Partner_Localities_Slots_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "product_variation_partner_localities_slots" */
export type Product_Variation_Partner_Localities_Slots_Aggregate_Order_By = {
  avg?: InputMaybe<Product_Variation_Partner_Localities_Slots_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Product_Variation_Partner_Localities_Slots_Max_Order_By>;
  min?: InputMaybe<Product_Variation_Partner_Localities_Slots_Min_Order_By>;
  stddev?: InputMaybe<Product_Variation_Partner_Localities_Slots_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Product_Variation_Partner_Localities_Slots_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Product_Variation_Partner_Localities_Slots_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Product_Variation_Partner_Localities_Slots_Sum_Order_By>;
  var_pop?: InputMaybe<Product_Variation_Partner_Localities_Slots_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Product_Variation_Partner_Localities_Slots_Var_Samp_Order_By>;
  variance?: InputMaybe<Product_Variation_Partner_Localities_Slots_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "product_variation_partner_localities_slots" */
export type Product_Variation_Partner_Localities_Slots_Arr_Rel_Insert_Input = {
  data: Array<Product_Variation_Partner_Localities_Slots_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Variation_Partner_Localities_Slots_On_Conflict>;
};

/** aggregate avg on columns */
export type Product_Variation_Partner_Localities_Slots_Avg_Fields = {
  __typename?: 'product_variation_partner_localities_slots_avg_fields';
  order_limit?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "product_variation_partner_localities_slots" */
export type Product_Variation_Partner_Localities_Slots_Avg_Order_By = {
  order_limit?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "product_variation_partner_localities_slots". All fields are combined with a logical 'AND'. */
export type Product_Variation_Partner_Localities_Slots_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Variation_Partner_Localities_Slots_Bool_Exp>>;
  _not?: InputMaybe<Product_Variation_Partner_Localities_Slots_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Variation_Partner_Localities_Slots_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_order_item_partners?: InputMaybe<Customer_Order_Item_Partner_Bool_Exp>;
  customer_order_item_partners_aggregate?: InputMaybe<Customer_Order_Item_Partner_Aggregate_Bool_Exp>;
  customer_order_items?: InputMaybe<Customer_Order_Item_Bool_Exp>;
  customer_order_items_aggregate?: InputMaybe<Customer_Order_Item_Aggregate_Bool_Exp>;
  customer_orders?: InputMaybe<Customer_Order_Bool_Exp>;
  customer_orders_aggregate?: InputMaybe<Customer_Order_Aggregate_Bool_Exp>;
  day_date?: InputMaybe<Date_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  disclaimer?: InputMaybe<String_Comparison_Exp>;
  end_time?: InputMaybe<Timetz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_visible?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order_limit?: InputMaybe<Numeric_Comparison_Exp>;
  partner_localities_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner_locality?: InputMaybe<Partner_Localities_Bool_Exp>;
  product_variation?: InputMaybe<Product_Variation_Bool_Exp>;
  product_variation_id?: InputMaybe<Uuid_Comparison_Exp>;
  start_time?: InputMaybe<Timetz_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_variation_partner_localities_slots" */
export enum Product_Variation_Partner_Localities_Slots_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductVariationPartnerLocalitiesSlotsPkey = 'product_variation_partner_localities_slots_pkey'
}

/** input type for incrementing numeric columns in table "product_variation_partner_localities_slots" */
export type Product_Variation_Partner_Localities_Slots_Inc_Input = {
  order_limit?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "product_variation_partner_localities_slots" */
export type Product_Variation_Partner_Localities_Slots_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_item_partners?: InputMaybe<Customer_Order_Item_Partner_Arr_Rel_Insert_Input>;
  customer_order_items?: InputMaybe<Customer_Order_Item_Arr_Rel_Insert_Input>;
  customer_orders?: InputMaybe<Customer_Order_Arr_Rel_Insert_Input>;
  day_date?: InputMaybe<Scalars['date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  end_time?: InputMaybe<Scalars['timetz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_visible?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_limit?: InputMaybe<Scalars['numeric']['input']>;
  partner_localities_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_locality?: InputMaybe<Partner_Localities_Obj_Rel_Insert_Input>;
  product_variation?: InputMaybe<Product_Variation_Obj_Rel_Insert_Input>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  start_time?: InputMaybe<Scalars['timetz']['input']>;
};

/** aggregate max on columns */
export type Product_Variation_Partner_Localities_Slots_Max_Fields = {
  __typename?: 'product_variation_partner_localities_slots_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  day_date?: Maybe<Scalars['date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disclaimer?: Maybe<Scalars['String']['output']>;
  end_time?: Maybe<Scalars['timetz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order_limit?: Maybe<Scalars['numeric']['output']>;
  partner_localities_id?: Maybe<Scalars['uuid']['output']>;
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
  start_time?: Maybe<Scalars['timetz']['output']>;
};

/** order by max() on columns of table "product_variation_partner_localities_slots" */
export type Product_Variation_Partner_Localities_Slots_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  day_date?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  disclaimer?: InputMaybe<Order_By>;
  end_time?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order_limit?: InputMaybe<Order_By>;
  partner_localities_id?: InputMaybe<Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Product_Variation_Partner_Localities_Slots_Min_Fields = {
  __typename?: 'product_variation_partner_localities_slots_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  day_date?: Maybe<Scalars['date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disclaimer?: Maybe<Scalars['String']['output']>;
  end_time?: Maybe<Scalars['timetz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order_limit?: Maybe<Scalars['numeric']['output']>;
  partner_localities_id?: Maybe<Scalars['uuid']['output']>;
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
  start_time?: Maybe<Scalars['timetz']['output']>;
};

/** order by min() on columns of table "product_variation_partner_localities_slots" */
export type Product_Variation_Partner_Localities_Slots_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  day_date?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  disclaimer?: InputMaybe<Order_By>;
  end_time?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order_limit?: InputMaybe<Order_By>;
  partner_localities_id?: InputMaybe<Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_variation_partner_localities_slots" */
export type Product_Variation_Partner_Localities_Slots_Mutation_Response = {
  __typename?: 'product_variation_partner_localities_slots_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_Variation_Partner_Localities_Slots>;
};

/** input type for inserting object relation for remote table "product_variation_partner_localities_slots" */
export type Product_Variation_Partner_Localities_Slots_Obj_Rel_Insert_Input = {
  data: Product_Variation_Partner_Localities_Slots_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Variation_Partner_Localities_Slots_On_Conflict>;
};

/** on_conflict condition type for table "product_variation_partner_localities_slots" */
export type Product_Variation_Partner_Localities_Slots_On_Conflict = {
  constraint: Product_Variation_Partner_Localities_Slots_Constraint;
  update_columns?: Array<Product_Variation_Partner_Localities_Slots_Update_Column>;
  where?: InputMaybe<Product_Variation_Partner_Localities_Slots_Bool_Exp>;
};

/** Ordering options when selecting data from "product_variation_partner_localities_slots". */
export type Product_Variation_Partner_Localities_Slots_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_order_item_partners_aggregate?: InputMaybe<Customer_Order_Item_Partner_Aggregate_Order_By>;
  customer_order_items_aggregate?: InputMaybe<Customer_Order_Item_Aggregate_Order_By>;
  customer_orders_aggregate?: InputMaybe<Customer_Order_Aggregate_Order_By>;
  day_date?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  disclaimer?: InputMaybe<Order_By>;
  end_time?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_visible?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order_limit?: InputMaybe<Order_By>;
  partner_localities_id?: InputMaybe<Order_By>;
  partner_locality?: InputMaybe<Partner_Localities_Order_By>;
  product_variation?: InputMaybe<Product_Variation_Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_variation_partner_localities_slots */
export type Product_Variation_Partner_Localities_Slots_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "product_variation_partner_localities_slots" */
export enum Product_Variation_Partner_Localities_Slots_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DayDate = 'day_date',
  /** column name */
  Description = 'description',
  /** column name */
  Disclaimer = 'disclaimer',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsVisible = 'is_visible',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  OrderLimit = 'order_limit',
  /** column name */
  PartnerLocalitiesId = 'partner_localities_id',
  /** column name */
  ProductVariationId = 'product_variation_id',
  /** column name */
  StartTime = 'start_time'
}

/** select "product_variation_partner_localities_slots_aggregate_bool_exp_bool_and_arguments_columns" columns of table "product_variation_partner_localities_slots" */
export enum Product_Variation_Partner_Localities_Slots_Select_Column_Product_Variation_Partner_Localities_Slots_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsVisible = 'is_visible'
}

/** select "product_variation_partner_localities_slots_aggregate_bool_exp_bool_or_arguments_columns" columns of table "product_variation_partner_localities_slots" */
export enum Product_Variation_Partner_Localities_Slots_Select_Column_Product_Variation_Partner_Localities_Slots_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsVisible = 'is_visible'
}

/** input type for updating data in table "product_variation_partner_localities_slots" */
export type Product_Variation_Partner_Localities_Slots_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  day_date?: InputMaybe<Scalars['date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  end_time?: InputMaybe<Scalars['timetz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_visible?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_limit?: InputMaybe<Scalars['numeric']['input']>;
  partner_localities_id?: InputMaybe<Scalars['uuid']['input']>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  start_time?: InputMaybe<Scalars['timetz']['input']>;
};

/** aggregate stddev on columns */
export type Product_Variation_Partner_Localities_Slots_Stddev_Fields = {
  __typename?: 'product_variation_partner_localities_slots_stddev_fields';
  order_limit?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "product_variation_partner_localities_slots" */
export type Product_Variation_Partner_Localities_Slots_Stddev_Order_By = {
  order_limit?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Product_Variation_Partner_Localities_Slots_Stddev_Pop_Fields = {
  __typename?: 'product_variation_partner_localities_slots_stddev_pop_fields';
  order_limit?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "product_variation_partner_localities_slots" */
export type Product_Variation_Partner_Localities_Slots_Stddev_Pop_Order_By = {
  order_limit?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Product_Variation_Partner_Localities_Slots_Stddev_Samp_Fields = {
  __typename?: 'product_variation_partner_localities_slots_stddev_samp_fields';
  order_limit?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "product_variation_partner_localities_slots" */
export type Product_Variation_Partner_Localities_Slots_Stddev_Samp_Order_By = {
  order_limit?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "product_variation_partner_localities_slots" */
export type Product_Variation_Partner_Localities_Slots_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Variation_Partner_Localities_Slots_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Variation_Partner_Localities_Slots_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  day_date?: InputMaybe<Scalars['date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  end_time?: InputMaybe<Scalars['timetz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_visible?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_limit?: InputMaybe<Scalars['numeric']['input']>;
  partner_localities_id?: InputMaybe<Scalars['uuid']['input']>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  start_time?: InputMaybe<Scalars['timetz']['input']>;
};

/** aggregate sum on columns */
export type Product_Variation_Partner_Localities_Slots_Sum_Fields = {
  __typename?: 'product_variation_partner_localities_slots_sum_fields';
  order_limit?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "product_variation_partner_localities_slots" */
export type Product_Variation_Partner_Localities_Slots_Sum_Order_By = {
  order_limit?: InputMaybe<Order_By>;
};

/** update columns of table "product_variation_partner_localities_slots" */
export enum Product_Variation_Partner_Localities_Slots_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DayDate = 'day_date',
  /** column name */
  Description = 'description',
  /** column name */
  Disclaimer = 'disclaimer',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsVisible = 'is_visible',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  OrderLimit = 'order_limit',
  /** column name */
  PartnerLocalitiesId = 'partner_localities_id',
  /** column name */
  ProductVariationId = 'product_variation_id',
  /** column name */
  StartTime = 'start_time'
}

export type Product_Variation_Partner_Localities_Slots_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Product_Variation_Partner_Localities_Slots_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Variation_Partner_Localities_Slots_Set_Input>;
  /** filter the rows which have to be updated */
  where: Product_Variation_Partner_Localities_Slots_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Product_Variation_Partner_Localities_Slots_Var_Pop_Fields = {
  __typename?: 'product_variation_partner_localities_slots_var_pop_fields';
  order_limit?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "product_variation_partner_localities_slots" */
export type Product_Variation_Partner_Localities_Slots_Var_Pop_Order_By = {
  order_limit?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Product_Variation_Partner_Localities_Slots_Var_Samp_Fields = {
  __typename?: 'product_variation_partner_localities_slots_var_samp_fields';
  order_limit?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "product_variation_partner_localities_slots" */
export type Product_Variation_Partner_Localities_Slots_Var_Samp_Order_By = {
  order_limit?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Product_Variation_Partner_Localities_Slots_Variance_Fields = {
  __typename?: 'product_variation_partner_localities_slots_variance_fields';
  order_limit?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "product_variation_partner_localities_slots" */
export type Product_Variation_Partner_Localities_Slots_Variance_Order_By = {
  order_limit?: InputMaybe<Order_By>;
};

/** columns and relationships of "product_variation_photos" */
export type Product_Variation_Photos = {
  __typename?: 'product_variation_photos';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  product_variation: Product_Variation;
  product_variation_id: Scalars['uuid']['output'];
  rank_id?: Maybe<Scalars['Int']['output']>;
  url: Scalars['String']['output'];
};

/** aggregated selection of "product_variation_photos" */
export type Product_Variation_Photos_Aggregate = {
  __typename?: 'product_variation_photos_aggregate';
  aggregate?: Maybe<Product_Variation_Photos_Aggregate_Fields>;
  nodes: Array<Product_Variation_Photos>;
};

export type Product_Variation_Photos_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Product_Variation_Photos_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Product_Variation_Photos_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Product_Variation_Photos_Aggregate_Bool_Exp_Count>;
};

export type Product_Variation_Photos_Aggregate_Bool_Exp_Bool_And = {
  arguments: Product_Variation_Photos_Select_Column_Product_Variation_Photos_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Product_Variation_Photos_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Product_Variation_Photos_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Product_Variation_Photos_Select_Column_Product_Variation_Photos_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Product_Variation_Photos_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Product_Variation_Photos_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Product_Variation_Photos_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Product_Variation_Photos_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "product_variation_photos" */
export type Product_Variation_Photos_Aggregate_Fields = {
  __typename?: 'product_variation_photos_aggregate_fields';
  avg?: Maybe<Product_Variation_Photos_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Product_Variation_Photos_Max_Fields>;
  min?: Maybe<Product_Variation_Photos_Min_Fields>;
  stddev?: Maybe<Product_Variation_Photos_Stddev_Fields>;
  stddev_pop?: Maybe<Product_Variation_Photos_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Product_Variation_Photos_Stddev_Samp_Fields>;
  sum?: Maybe<Product_Variation_Photos_Sum_Fields>;
  var_pop?: Maybe<Product_Variation_Photos_Var_Pop_Fields>;
  var_samp?: Maybe<Product_Variation_Photos_Var_Samp_Fields>;
  variance?: Maybe<Product_Variation_Photos_Variance_Fields>;
};


/** aggregate fields of "product_variation_photos" */
export type Product_Variation_Photos_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Variation_Photos_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "product_variation_photos" */
export type Product_Variation_Photos_Aggregate_Order_By = {
  avg?: InputMaybe<Product_Variation_Photos_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Product_Variation_Photos_Max_Order_By>;
  min?: InputMaybe<Product_Variation_Photos_Min_Order_By>;
  stddev?: InputMaybe<Product_Variation_Photos_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Product_Variation_Photos_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Product_Variation_Photos_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Product_Variation_Photos_Sum_Order_By>;
  var_pop?: InputMaybe<Product_Variation_Photos_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Product_Variation_Photos_Var_Samp_Order_By>;
  variance?: InputMaybe<Product_Variation_Photos_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "product_variation_photos" */
export type Product_Variation_Photos_Arr_Rel_Insert_Input = {
  data: Array<Product_Variation_Photos_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Variation_Photos_On_Conflict>;
};

/** aggregate avg on columns */
export type Product_Variation_Photos_Avg_Fields = {
  __typename?: 'product_variation_photos_avg_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "product_variation_photos" */
export type Product_Variation_Photos_Avg_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "product_variation_photos". All fields are combined with a logical 'AND'. */
export type Product_Variation_Photos_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Variation_Photos_Bool_Exp>>;
  _not?: InputMaybe<Product_Variation_Photos_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Variation_Photos_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  product_variation?: InputMaybe<Product_Variation_Bool_Exp>;
  product_variation_id?: InputMaybe<Uuid_Comparison_Exp>;
  rank_id?: InputMaybe<Int_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_variation_photos" */
export enum Product_Variation_Photos_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductVariationPhotosPkey = 'product_variation_photos_pkey'
}

/** input type for incrementing numeric columns in table "product_variation_photos" */
export type Product_Variation_Photos_Inc_Input = {
  rank_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "product_variation_photos" */
export type Product_Variation_Photos_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  product_variation?: InputMaybe<Product_Variation_Obj_Rel_Insert_Input>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  rank_id?: InputMaybe<Scalars['Int']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Product_Variation_Photos_Max_Fields = {
  __typename?: 'product_variation_photos_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
  rank_id?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "product_variation_photos" */
export type Product_Variation_Photos_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  rank_id?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Product_Variation_Photos_Min_Fields = {
  __typename?: 'product_variation_photos_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
  rank_id?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "product_variation_photos" */
export type Product_Variation_Photos_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  rank_id?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_variation_photos" */
export type Product_Variation_Photos_Mutation_Response = {
  __typename?: 'product_variation_photos_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_Variation_Photos>;
};

/** on_conflict condition type for table "product_variation_photos" */
export type Product_Variation_Photos_On_Conflict = {
  constraint: Product_Variation_Photos_Constraint;
  update_columns?: Array<Product_Variation_Photos_Update_Column>;
  where?: InputMaybe<Product_Variation_Photos_Bool_Exp>;
};

/** Ordering options when selecting data from "product_variation_photos". */
export type Product_Variation_Photos_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  product_variation?: InputMaybe<Product_Variation_Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  rank_id?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_variation_photos */
export type Product_Variation_Photos_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "product_variation_photos" */
export enum Product_Variation_Photos_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  ProductVariationId = 'product_variation_id',
  /** column name */
  RankId = 'rank_id',
  /** column name */
  Url = 'url'
}

/** select "product_variation_photos_aggregate_bool_exp_bool_and_arguments_columns" columns of table "product_variation_photos" */
export enum Product_Variation_Photos_Select_Column_Product_Variation_Photos_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "product_variation_photos_aggregate_bool_exp_bool_or_arguments_columns" columns of table "product_variation_photos" */
export enum Product_Variation_Photos_Select_Column_Product_Variation_Photos_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "product_variation_photos" */
export type Product_Variation_Photos_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  rank_id?: InputMaybe<Scalars['Int']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Product_Variation_Photos_Stddev_Fields = {
  __typename?: 'product_variation_photos_stddev_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "product_variation_photos" */
export type Product_Variation_Photos_Stddev_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Product_Variation_Photos_Stddev_Pop_Fields = {
  __typename?: 'product_variation_photos_stddev_pop_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "product_variation_photos" */
export type Product_Variation_Photos_Stddev_Pop_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Product_Variation_Photos_Stddev_Samp_Fields = {
  __typename?: 'product_variation_photos_stddev_samp_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "product_variation_photos" */
export type Product_Variation_Photos_Stddev_Samp_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "product_variation_photos" */
export type Product_Variation_Photos_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Variation_Photos_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Variation_Photos_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  rank_id?: InputMaybe<Scalars['Int']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Product_Variation_Photos_Sum_Fields = {
  __typename?: 'product_variation_photos_sum_fields';
  rank_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "product_variation_photos" */
export type Product_Variation_Photos_Sum_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** update columns of table "product_variation_photos" */
export enum Product_Variation_Photos_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  ProductVariationId = 'product_variation_id',
  /** column name */
  RankId = 'rank_id',
  /** column name */
  Url = 'url'
}

export type Product_Variation_Photos_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Product_Variation_Photos_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Variation_Photos_Set_Input>;
  /** filter the rows which have to be updated */
  where: Product_Variation_Photos_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Product_Variation_Photos_Var_Pop_Fields = {
  __typename?: 'product_variation_photos_var_pop_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "product_variation_photos" */
export type Product_Variation_Photos_Var_Pop_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Product_Variation_Photos_Var_Samp_Fields = {
  __typename?: 'product_variation_photos_var_samp_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "product_variation_photos" */
export type Product_Variation_Photos_Var_Samp_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Product_Variation_Photos_Variance_Fields = {
  __typename?: 'product_variation_photos_variance_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "product_variation_photos" */
export type Product_Variation_Photos_Variance_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_variation */
export type Product_Variation_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "product_variation_safety_checklist_category" */
export type Product_Variation_Safety_Checklist_Category = {
  __typename?: 'product_variation_safety_checklist_category';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  product_variation: Product_Variation;
  product_variation_id: Scalars['uuid']['output'];
  /** An object relationship */
  safety_checklist_category: Safety_Checklist_Category;
  safety_checklist_category_id: Scalars['uuid']['output'];
};

/** aggregated selection of "product_variation_safety_checklist_category" */
export type Product_Variation_Safety_Checklist_Category_Aggregate = {
  __typename?: 'product_variation_safety_checklist_category_aggregate';
  aggregate?: Maybe<Product_Variation_Safety_Checklist_Category_Aggregate_Fields>;
  nodes: Array<Product_Variation_Safety_Checklist_Category>;
};

export type Product_Variation_Safety_Checklist_Category_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Product_Variation_Safety_Checklist_Category_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Product_Variation_Safety_Checklist_Category_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Product_Variation_Safety_Checklist_Category_Aggregate_Bool_Exp_Count>;
};

export type Product_Variation_Safety_Checklist_Category_Aggregate_Bool_Exp_Bool_And = {
  arguments: Product_Variation_Safety_Checklist_Category_Select_Column_Product_Variation_Safety_Checklist_Category_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Product_Variation_Safety_Checklist_Category_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Product_Variation_Safety_Checklist_Category_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Product_Variation_Safety_Checklist_Category_Select_Column_Product_Variation_Safety_Checklist_Category_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Product_Variation_Safety_Checklist_Category_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Product_Variation_Safety_Checklist_Category_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Product_Variation_Safety_Checklist_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Product_Variation_Safety_Checklist_Category_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "product_variation_safety_checklist_category" */
export type Product_Variation_Safety_Checklist_Category_Aggregate_Fields = {
  __typename?: 'product_variation_safety_checklist_category_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Product_Variation_Safety_Checklist_Category_Max_Fields>;
  min?: Maybe<Product_Variation_Safety_Checklist_Category_Min_Fields>;
};


/** aggregate fields of "product_variation_safety_checklist_category" */
export type Product_Variation_Safety_Checklist_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Variation_Safety_Checklist_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "product_variation_safety_checklist_category" */
export type Product_Variation_Safety_Checklist_Category_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Product_Variation_Safety_Checklist_Category_Max_Order_By>;
  min?: InputMaybe<Product_Variation_Safety_Checklist_Category_Min_Order_By>;
};

/** input type for inserting array relation for remote table "product_variation_safety_checklist_category" */
export type Product_Variation_Safety_Checklist_Category_Arr_Rel_Insert_Input = {
  data: Array<Product_Variation_Safety_Checklist_Category_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Variation_Safety_Checklist_Category_On_Conflict>;
};

/** Boolean expression to filter rows from the table "product_variation_safety_checklist_category". All fields are combined with a logical 'AND'. */
export type Product_Variation_Safety_Checklist_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Variation_Safety_Checklist_Category_Bool_Exp>>;
  _not?: InputMaybe<Product_Variation_Safety_Checklist_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Variation_Safety_Checklist_Category_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  product_variation?: InputMaybe<Product_Variation_Bool_Exp>;
  product_variation_id?: InputMaybe<Uuid_Comparison_Exp>;
  safety_checklist_category?: InputMaybe<Safety_Checklist_Category_Bool_Exp>;
  safety_checklist_category_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_variation_safety_checklist_category" */
export enum Product_Variation_Safety_Checklist_Category_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductVariationSafetyChecklistCategoryPkey = 'product_variation_safety_checklist_category_pkey'
}

/** input type for inserting data into table "product_variation_safety_checklist_category" */
export type Product_Variation_Safety_Checklist_Category_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  product_variation?: InputMaybe<Product_Variation_Obj_Rel_Insert_Input>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  safety_checklist_category?: InputMaybe<Safety_Checklist_Category_Obj_Rel_Insert_Input>;
  safety_checklist_category_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Product_Variation_Safety_Checklist_Category_Max_Fields = {
  __typename?: 'product_variation_safety_checklist_category_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
  safety_checklist_category_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "product_variation_safety_checklist_category" */
export type Product_Variation_Safety_Checklist_Category_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  safety_checklist_category_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Product_Variation_Safety_Checklist_Category_Min_Fields = {
  __typename?: 'product_variation_safety_checklist_category_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
  safety_checklist_category_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "product_variation_safety_checklist_category" */
export type Product_Variation_Safety_Checklist_Category_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  safety_checklist_category_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_variation_safety_checklist_category" */
export type Product_Variation_Safety_Checklist_Category_Mutation_Response = {
  __typename?: 'product_variation_safety_checklist_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_Variation_Safety_Checklist_Category>;
};

/** on_conflict condition type for table "product_variation_safety_checklist_category" */
export type Product_Variation_Safety_Checklist_Category_On_Conflict = {
  constraint: Product_Variation_Safety_Checklist_Category_Constraint;
  update_columns?: Array<Product_Variation_Safety_Checklist_Category_Update_Column>;
  where?: InputMaybe<Product_Variation_Safety_Checklist_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "product_variation_safety_checklist_category". */
export type Product_Variation_Safety_Checklist_Category_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  product_variation?: InputMaybe<Product_Variation_Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  safety_checklist_category?: InputMaybe<Safety_Checklist_Category_Order_By>;
  safety_checklist_category_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_variation_safety_checklist_category */
export type Product_Variation_Safety_Checklist_Category_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "product_variation_safety_checklist_category" */
export enum Product_Variation_Safety_Checklist_Category_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  ProductVariationId = 'product_variation_id',
  /** column name */
  SafetyChecklistCategoryId = 'safety_checklist_category_id'
}

/** select "product_variation_safety_checklist_category_aggregate_bool_exp_bool_and_arguments_columns" columns of table "product_variation_safety_checklist_category" */
export enum Product_Variation_Safety_Checklist_Category_Select_Column_Product_Variation_Safety_Checklist_Category_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "product_variation_safety_checklist_category_aggregate_bool_exp_bool_or_arguments_columns" columns of table "product_variation_safety_checklist_category" */
export enum Product_Variation_Safety_Checklist_Category_Select_Column_Product_Variation_Safety_Checklist_Category_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "product_variation_safety_checklist_category" */
export type Product_Variation_Safety_Checklist_Category_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  safety_checklist_category_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "product_variation_safety_checklist_category" */
export type Product_Variation_Safety_Checklist_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Variation_Safety_Checklist_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Variation_Safety_Checklist_Category_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  safety_checklist_category_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "product_variation_safety_checklist_category" */
export enum Product_Variation_Safety_Checklist_Category_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  ProductVariationId = 'product_variation_id',
  /** column name */
  SafetyChecklistCategoryId = 'safety_checklist_category_id'
}

export type Product_Variation_Safety_Checklist_Category_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Variation_Safety_Checklist_Category_Set_Input>;
  /** filter the rows which have to be updated */
  where: Product_Variation_Safety_Checklist_Category_Bool_Exp;
};

/** select columns of table "product_variation" */
export enum Product_Variation_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ErpCode = 'erp_code',
  /** column name */
  ExpiryDate = 'expiry_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Price = 'price',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  VariationId = 'variation_id'
}

/** select "product_variation_aggregate_bool_exp_bool_and_arguments_columns" columns of table "product_variation" */
export enum Product_Variation_Select_Column_Product_Variation_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "product_variation_aggregate_bool_exp_bool_or_arguments_columns" columns of table "product_variation" */
export enum Product_Variation_Select_Column_Product_Variation_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "product_variation" */
export type Product_Variation_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  erp_code?: InputMaybe<Scalars['String']['input']>;
  expiry_date?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
  variation_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "product_variation" */
export type Product_Variation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Variation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Variation_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  erp_code?: InputMaybe<Scalars['String']['input']>;
  expiry_date?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
  variation_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "product_variation_test_category" */
export type Product_Variation_Test_Category = {
  __typename?: 'product_variation_test_category';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  product_variation: Product_Variation;
  product_variation_id: Scalars['uuid']['output'];
  /** An object relationship */
  test_category: Test_Category;
  test_category_id: Scalars['uuid']['output'];
};

/** aggregated selection of "product_variation_test_category" */
export type Product_Variation_Test_Category_Aggregate = {
  __typename?: 'product_variation_test_category_aggregate';
  aggregate?: Maybe<Product_Variation_Test_Category_Aggregate_Fields>;
  nodes: Array<Product_Variation_Test_Category>;
};

export type Product_Variation_Test_Category_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Product_Variation_Test_Category_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Product_Variation_Test_Category_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Product_Variation_Test_Category_Aggregate_Bool_Exp_Count>;
};

export type Product_Variation_Test_Category_Aggregate_Bool_Exp_Bool_And = {
  arguments: Product_Variation_Test_Category_Select_Column_Product_Variation_Test_Category_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Product_Variation_Test_Category_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Product_Variation_Test_Category_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Product_Variation_Test_Category_Select_Column_Product_Variation_Test_Category_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Product_Variation_Test_Category_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Product_Variation_Test_Category_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Product_Variation_Test_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Product_Variation_Test_Category_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "product_variation_test_category" */
export type Product_Variation_Test_Category_Aggregate_Fields = {
  __typename?: 'product_variation_test_category_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Product_Variation_Test_Category_Max_Fields>;
  min?: Maybe<Product_Variation_Test_Category_Min_Fields>;
};


/** aggregate fields of "product_variation_test_category" */
export type Product_Variation_Test_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Variation_Test_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "product_variation_test_category" */
export type Product_Variation_Test_Category_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Product_Variation_Test_Category_Max_Order_By>;
  min?: InputMaybe<Product_Variation_Test_Category_Min_Order_By>;
};

/** input type for inserting array relation for remote table "product_variation_test_category" */
export type Product_Variation_Test_Category_Arr_Rel_Insert_Input = {
  data: Array<Product_Variation_Test_Category_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Variation_Test_Category_On_Conflict>;
};

/** Boolean expression to filter rows from the table "product_variation_test_category". All fields are combined with a logical 'AND'. */
export type Product_Variation_Test_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Variation_Test_Category_Bool_Exp>>;
  _not?: InputMaybe<Product_Variation_Test_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Variation_Test_Category_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  product_variation?: InputMaybe<Product_Variation_Bool_Exp>;
  product_variation_id?: InputMaybe<Uuid_Comparison_Exp>;
  test_category?: InputMaybe<Test_Category_Bool_Exp>;
  test_category_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_variation_test_category" */
export enum Product_Variation_Test_Category_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductVariationTestCategoryPkey = 'product_variation_test_category_pkey'
}

/** input type for inserting data into table "product_variation_test_category" */
export type Product_Variation_Test_Category_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  product_variation?: InputMaybe<Product_Variation_Obj_Rel_Insert_Input>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  test_category?: InputMaybe<Test_Category_Obj_Rel_Insert_Input>;
  test_category_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Product_Variation_Test_Category_Max_Fields = {
  __typename?: 'product_variation_test_category_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
  test_category_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "product_variation_test_category" */
export type Product_Variation_Test_Category_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  test_category_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Product_Variation_Test_Category_Min_Fields = {
  __typename?: 'product_variation_test_category_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
  test_category_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "product_variation_test_category" */
export type Product_Variation_Test_Category_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  test_category_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_variation_test_category" */
export type Product_Variation_Test_Category_Mutation_Response = {
  __typename?: 'product_variation_test_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_Variation_Test_Category>;
};

/** on_conflict condition type for table "product_variation_test_category" */
export type Product_Variation_Test_Category_On_Conflict = {
  constraint: Product_Variation_Test_Category_Constraint;
  update_columns?: Array<Product_Variation_Test_Category_Update_Column>;
  where?: InputMaybe<Product_Variation_Test_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "product_variation_test_category". */
export type Product_Variation_Test_Category_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  product_variation?: InputMaybe<Product_Variation_Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  test_category?: InputMaybe<Test_Category_Order_By>;
  test_category_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_variation_test_category */
export type Product_Variation_Test_Category_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "product_variation_test_category" */
export enum Product_Variation_Test_Category_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  ProductVariationId = 'product_variation_id',
  /** column name */
  TestCategoryId = 'test_category_id'
}

/** select "product_variation_test_category_aggregate_bool_exp_bool_and_arguments_columns" columns of table "product_variation_test_category" */
export enum Product_Variation_Test_Category_Select_Column_Product_Variation_Test_Category_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "product_variation_test_category_aggregate_bool_exp_bool_or_arguments_columns" columns of table "product_variation_test_category" */
export enum Product_Variation_Test_Category_Select_Column_Product_Variation_Test_Category_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "product_variation_test_category" */
export type Product_Variation_Test_Category_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  test_category_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "product_variation_test_category" */
export type Product_Variation_Test_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Variation_Test_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Variation_Test_Category_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  test_category_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "product_variation_test_category" */
export enum Product_Variation_Test_Category_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  ProductVariationId = 'product_variation_id',
  /** column name */
  TestCategoryId = 'test_category_id'
}

export type Product_Variation_Test_Category_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Variation_Test_Category_Set_Input>;
  /** filter the rows which have to be updated */
  where: Product_Variation_Test_Category_Bool_Exp;
};

/** update columns of table "product_variation" */
export enum Product_Variation_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ErpCode = 'erp_code',
  /** column name */
  ExpiryDate = 'expiry_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Price = 'price',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  VariationId = 'variation_id'
}

export type Product_Variation_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Variation_Set_Input>;
  /** filter the rows which have to be updated */
  where: Product_Variation_Bool_Exp;
};

/** columns and relationships of "purchase_order" */
export type Purchase_Order = {
  __typename?: 'purchase_order';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  organization_user: Organization_User;
  organization_user_id: Scalars['uuid']['output'];
  po_create_date?: Maybe<Scalars['timestamp']['output']>;
  po_date?: Maybe<Scalars['timestamp']['output']>;
  po_expire?: Maybe<Scalars['timestamp']['output']>;
  po_number?: Maybe<Scalars['String']['output']>;
  po_received?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  purchase_order_items: Array<Purchase_Order_Items>;
  /** An aggregate relationship */
  purchase_order_items_aggregate: Purchase_Order_Items_Aggregate;
};


/** columns and relationships of "purchase_order" */
export type Purchase_OrderPurchase_Order_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Purchase_Order_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Purchase_Order_Items_Order_By>>;
  where?: InputMaybe<Purchase_Order_Items_Bool_Exp>;
};


/** columns and relationships of "purchase_order" */
export type Purchase_OrderPurchase_Order_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Purchase_Order_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Purchase_Order_Items_Order_By>>;
  where?: InputMaybe<Purchase_Order_Items_Bool_Exp>;
};

/** aggregated selection of "purchase_order" */
export type Purchase_Order_Aggregate = {
  __typename?: 'purchase_order_aggregate';
  aggregate?: Maybe<Purchase_Order_Aggregate_Fields>;
  nodes: Array<Purchase_Order>;
};

export type Purchase_Order_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Purchase_Order_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Purchase_Order_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Purchase_Order_Aggregate_Bool_Exp_Count>;
};

export type Purchase_Order_Aggregate_Bool_Exp_Bool_And = {
  arguments: Purchase_Order_Select_Column_Purchase_Order_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Purchase_Order_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Purchase_Order_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Purchase_Order_Select_Column_Purchase_Order_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Purchase_Order_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Purchase_Order_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Purchase_Order_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Purchase_Order_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "purchase_order" */
export type Purchase_Order_Aggregate_Fields = {
  __typename?: 'purchase_order_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Purchase_Order_Max_Fields>;
  min?: Maybe<Purchase_Order_Min_Fields>;
};


/** aggregate fields of "purchase_order" */
export type Purchase_Order_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Purchase_Order_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "purchase_order" */
export type Purchase_Order_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Purchase_Order_Max_Order_By>;
  min?: InputMaybe<Purchase_Order_Min_Order_By>;
};

/** input type for inserting array relation for remote table "purchase_order" */
export type Purchase_Order_Arr_Rel_Insert_Input = {
  data: Array<Purchase_Order_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Purchase_Order_On_Conflict>;
};

/** Boolean expression to filter rows from the table "purchase_order". All fields are combined with a logical 'AND'. */
export type Purchase_Order_Bool_Exp = {
  _and?: InputMaybe<Array<Purchase_Order_Bool_Exp>>;
  _not?: InputMaybe<Purchase_Order_Bool_Exp>;
  _or?: InputMaybe<Array<Purchase_Order_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  organization_user?: InputMaybe<Organization_User_Bool_Exp>;
  organization_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  po_create_date?: InputMaybe<Timestamp_Comparison_Exp>;
  po_date?: InputMaybe<Timestamp_Comparison_Exp>;
  po_expire?: InputMaybe<Timestamp_Comparison_Exp>;
  po_number?: InputMaybe<String_Comparison_Exp>;
  po_received?: InputMaybe<Timestamp_Comparison_Exp>;
  purchase_order_items?: InputMaybe<Purchase_Order_Items_Bool_Exp>;
  purchase_order_items_aggregate?: InputMaybe<Purchase_Order_Items_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "purchase_order" */
export enum Purchase_Order_Constraint {
  /** unique or primary key constraint on columns "id" */
  PurchaseOrderPkey = 'purchase_order_pkey'
}

/** input type for inserting data into table "purchase_order" */
export type Purchase_Order_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_user?: InputMaybe<Organization_User_Obj_Rel_Insert_Input>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  po_create_date?: InputMaybe<Scalars['timestamp']['input']>;
  po_date?: InputMaybe<Scalars['timestamp']['input']>;
  po_expire?: InputMaybe<Scalars['timestamp']['input']>;
  po_number?: InputMaybe<Scalars['String']['input']>;
  po_received?: InputMaybe<Scalars['timestamp']['input']>;
  purchase_order_items?: InputMaybe<Purchase_Order_Items_Arr_Rel_Insert_Input>;
};

/** columns and relationships of "purchase_order_items" */
export type Purchase_Order_Items = {
  __typename?: 'purchase_order_items';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  product_variation: Product_Variation;
  product_variation_id: Scalars['uuid']['output'];
  /** An object relationship */
  purchase_order: Purchase_Order;
  purchase_order_id: Scalars['uuid']['output'];
  qty?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "purchase_order_items" */
export type Purchase_Order_Items_Aggregate = {
  __typename?: 'purchase_order_items_aggregate';
  aggregate?: Maybe<Purchase_Order_Items_Aggregate_Fields>;
  nodes: Array<Purchase_Order_Items>;
};

export type Purchase_Order_Items_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Purchase_Order_Items_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Purchase_Order_Items_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Purchase_Order_Items_Aggregate_Bool_Exp_Count>;
};

export type Purchase_Order_Items_Aggregate_Bool_Exp_Bool_And = {
  arguments: Purchase_Order_Items_Select_Column_Purchase_Order_Items_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Purchase_Order_Items_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Purchase_Order_Items_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Purchase_Order_Items_Select_Column_Purchase_Order_Items_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Purchase_Order_Items_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Purchase_Order_Items_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Purchase_Order_Items_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Purchase_Order_Items_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "purchase_order_items" */
export type Purchase_Order_Items_Aggregate_Fields = {
  __typename?: 'purchase_order_items_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Purchase_Order_Items_Max_Fields>;
  min?: Maybe<Purchase_Order_Items_Min_Fields>;
};


/** aggregate fields of "purchase_order_items" */
export type Purchase_Order_Items_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Purchase_Order_Items_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "purchase_order_items" */
export type Purchase_Order_Items_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Purchase_Order_Items_Max_Order_By>;
  min?: InputMaybe<Purchase_Order_Items_Min_Order_By>;
};

/** input type for inserting array relation for remote table "purchase_order_items" */
export type Purchase_Order_Items_Arr_Rel_Insert_Input = {
  data: Array<Purchase_Order_Items_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Purchase_Order_Items_On_Conflict>;
};

/** Boolean expression to filter rows from the table "purchase_order_items". All fields are combined with a logical 'AND'. */
export type Purchase_Order_Items_Bool_Exp = {
  _and?: InputMaybe<Array<Purchase_Order_Items_Bool_Exp>>;
  _not?: InputMaybe<Purchase_Order_Items_Bool_Exp>;
  _or?: InputMaybe<Array<Purchase_Order_Items_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  product_variation?: InputMaybe<Product_Variation_Bool_Exp>;
  product_variation_id?: InputMaybe<Uuid_Comparison_Exp>;
  purchase_order?: InputMaybe<Purchase_Order_Bool_Exp>;
  purchase_order_id?: InputMaybe<Uuid_Comparison_Exp>;
  qty?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "purchase_order_items" */
export enum Purchase_Order_Items_Constraint {
  /** unique or primary key constraint on columns "id" */
  PurchaseOrderItemsPkey = 'purchase_order_items_pkey'
}

/** input type for inserting data into table "purchase_order_items" */
export type Purchase_Order_Items_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  product_variation?: InputMaybe<Product_Variation_Obj_Rel_Insert_Input>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  purchase_order?: InputMaybe<Purchase_Order_Obj_Rel_Insert_Input>;
  purchase_order_id?: InputMaybe<Scalars['uuid']['input']>;
  qty?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Purchase_Order_Items_Max_Fields = {
  __typename?: 'purchase_order_items_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
  purchase_order_id?: Maybe<Scalars['uuid']['output']>;
  qty?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "purchase_order_items" */
export type Purchase_Order_Items_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  purchase_order_id?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Purchase_Order_Items_Min_Fields = {
  __typename?: 'purchase_order_items_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
  purchase_order_id?: Maybe<Scalars['uuid']['output']>;
  qty?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "purchase_order_items" */
export type Purchase_Order_Items_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  purchase_order_id?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "purchase_order_items" */
export type Purchase_Order_Items_Mutation_Response = {
  __typename?: 'purchase_order_items_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Purchase_Order_Items>;
};

/** on_conflict condition type for table "purchase_order_items" */
export type Purchase_Order_Items_On_Conflict = {
  constraint: Purchase_Order_Items_Constraint;
  update_columns?: Array<Purchase_Order_Items_Update_Column>;
  where?: InputMaybe<Purchase_Order_Items_Bool_Exp>;
};

/** Ordering options when selecting data from "purchase_order_items". */
export type Purchase_Order_Items_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  product_variation?: InputMaybe<Product_Variation_Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  purchase_order?: InputMaybe<Purchase_Order_Order_By>;
  purchase_order_id?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
};

/** primary key columns input for table: purchase_order_items */
export type Purchase_Order_Items_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "purchase_order_items" */
export enum Purchase_Order_Items_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  ProductVariationId = 'product_variation_id',
  /** column name */
  PurchaseOrderId = 'purchase_order_id',
  /** column name */
  Qty = 'qty'
}

/** select "purchase_order_items_aggregate_bool_exp_bool_and_arguments_columns" columns of table "purchase_order_items" */
export enum Purchase_Order_Items_Select_Column_Purchase_Order_Items_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "purchase_order_items_aggregate_bool_exp_bool_or_arguments_columns" columns of table "purchase_order_items" */
export enum Purchase_Order_Items_Select_Column_Purchase_Order_Items_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "purchase_order_items" */
export type Purchase_Order_Items_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  purchase_order_id?: InputMaybe<Scalars['uuid']['input']>;
  qty?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "purchase_order_items" */
export type Purchase_Order_Items_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Purchase_Order_Items_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Purchase_Order_Items_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  purchase_order_id?: InputMaybe<Scalars['uuid']['input']>;
  qty?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "purchase_order_items" */
export enum Purchase_Order_Items_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  ProductVariationId = 'product_variation_id',
  /** column name */
  PurchaseOrderId = 'purchase_order_id',
  /** column name */
  Qty = 'qty'
}

export type Purchase_Order_Items_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Purchase_Order_Items_Set_Input>;
  /** filter the rows which have to be updated */
  where: Purchase_Order_Items_Bool_Exp;
};

/** aggregate max on columns */
export type Purchase_Order_Max_Fields = {
  __typename?: 'purchase_order_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  organization_user_id?: Maybe<Scalars['uuid']['output']>;
  po_create_date?: Maybe<Scalars['timestamp']['output']>;
  po_date?: Maybe<Scalars['timestamp']['output']>;
  po_expire?: Maybe<Scalars['timestamp']['output']>;
  po_number?: Maybe<Scalars['String']['output']>;
  po_received?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "purchase_order" */
export type Purchase_Order_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
  po_create_date?: InputMaybe<Order_By>;
  po_date?: InputMaybe<Order_By>;
  po_expire?: InputMaybe<Order_By>;
  po_number?: InputMaybe<Order_By>;
  po_received?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Purchase_Order_Min_Fields = {
  __typename?: 'purchase_order_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  organization_user_id?: Maybe<Scalars['uuid']['output']>;
  po_create_date?: Maybe<Scalars['timestamp']['output']>;
  po_date?: Maybe<Scalars['timestamp']['output']>;
  po_expire?: Maybe<Scalars['timestamp']['output']>;
  po_number?: Maybe<Scalars['String']['output']>;
  po_received?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "purchase_order" */
export type Purchase_Order_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
  po_create_date?: InputMaybe<Order_By>;
  po_date?: InputMaybe<Order_By>;
  po_expire?: InputMaybe<Order_By>;
  po_number?: InputMaybe<Order_By>;
  po_received?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "purchase_order" */
export type Purchase_Order_Mutation_Response = {
  __typename?: 'purchase_order_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Purchase_Order>;
};

/** input type for inserting object relation for remote table "purchase_order" */
export type Purchase_Order_Obj_Rel_Insert_Input = {
  data: Purchase_Order_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Purchase_Order_On_Conflict>;
};

/** on_conflict condition type for table "purchase_order" */
export type Purchase_Order_On_Conflict = {
  constraint: Purchase_Order_Constraint;
  update_columns?: Array<Purchase_Order_Update_Column>;
  where?: InputMaybe<Purchase_Order_Bool_Exp>;
};

/** Ordering options when selecting data from "purchase_order". */
export type Purchase_Order_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_user?: InputMaybe<Organization_User_Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
  po_create_date?: InputMaybe<Order_By>;
  po_date?: InputMaybe<Order_By>;
  po_expire?: InputMaybe<Order_By>;
  po_number?: InputMaybe<Order_By>;
  po_received?: InputMaybe<Order_By>;
  purchase_order_items_aggregate?: InputMaybe<Purchase_Order_Items_Aggregate_Order_By>;
};

/** primary key columns input for table: purchase_order */
export type Purchase_Order_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "purchase_order" */
export enum Purchase_Order_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrganizationUserId = 'organization_user_id',
  /** column name */
  PoCreateDate = 'po_create_date',
  /** column name */
  PoDate = 'po_date',
  /** column name */
  PoExpire = 'po_expire',
  /** column name */
  PoNumber = 'po_number',
  /** column name */
  PoReceived = 'po_received'
}

/** select "purchase_order_aggregate_bool_exp_bool_and_arguments_columns" columns of table "purchase_order" */
export enum Purchase_Order_Select_Column_Purchase_Order_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "purchase_order_aggregate_bool_exp_bool_or_arguments_columns" columns of table "purchase_order" */
export enum Purchase_Order_Select_Column_Purchase_Order_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "purchase_order" */
export type Purchase_Order_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  po_create_date?: InputMaybe<Scalars['timestamp']['input']>;
  po_date?: InputMaybe<Scalars['timestamp']['input']>;
  po_expire?: InputMaybe<Scalars['timestamp']['input']>;
  po_number?: InputMaybe<Scalars['String']['input']>;
  po_received?: InputMaybe<Scalars['timestamp']['input']>;
};

/** Streaming cursor of the table "purchase_order" */
export type Purchase_Order_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Purchase_Order_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Purchase_Order_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  po_create_date?: InputMaybe<Scalars['timestamp']['input']>;
  po_date?: InputMaybe<Scalars['timestamp']['input']>;
  po_expire?: InputMaybe<Scalars['timestamp']['input']>;
  po_number?: InputMaybe<Scalars['String']['input']>;
  po_received?: InputMaybe<Scalars['timestamp']['input']>;
};

/** update columns of table "purchase_order" */
export enum Purchase_Order_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrganizationUserId = 'organization_user_id',
  /** column name */
  PoCreateDate = 'po_create_date',
  /** column name */
  PoDate = 'po_date',
  /** column name */
  PoExpire = 'po_expire',
  /** column name */
  PoNumber = 'po_number',
  /** column name */
  PoReceived = 'po_received'
}

export type Purchase_Order_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Purchase_Order_Set_Input>;
  /** filter the rows which have to be updated */
  where: Purchase_Order_Bool_Exp;
};

export type PushDepartmentToErpInput = {
  customer_asset_ids?: InputMaybe<Array<Scalars['uuid']['input']>>;
  dispensing_date_from?: InputMaybe<Scalars['date']['input']>;
  subsidiary_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type PushDepartmentToErpOutput = {
  __typename?: 'pushDepartmentToErpOutput';
  cancelled?: Maybe<Scalars['Int']['output']>;
  conflicts?: Maybe<Array<Scalars['String']['output']>>;
  failed?: Maybe<Array<Scalars['String']['output']>>;
  locked?: Maybe<Array<Scalars['String']['output']>>;
  matched?: Maybe<Scalars['Int']['output']>;
  message: Scalars['String']['output'];
  missing?: Maybe<Array<Scalars['String']['output']>>;
  unchanged?: Maybe<Scalars['Int']['output']>;
  updated?: Maybe<Scalars['Int']['output']>;
};

/** columns and relationships of "quantity_correction_ticket_states" */
export type Quantity_Correction_Ticket_States = {
  __typename?: 'quantity_correction_ticket_states';
  comment: Scalars['String']['output'];
  /** An array relationship */
  quantity_correction_tickets: Array<Quantity_Correction_Tickets>;
  /** An aggregate relationship */
  quantity_correction_tickets_aggregate: Quantity_Correction_Tickets_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "quantity_correction_ticket_states" */
export type Quantity_Correction_Ticket_StatesQuantity_Correction_TicketsArgs = {
  distinct_on?: InputMaybe<Array<Quantity_Correction_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quantity_Correction_Tickets_Order_By>>;
  where?: InputMaybe<Quantity_Correction_Tickets_Bool_Exp>;
};


/** columns and relationships of "quantity_correction_ticket_states" */
export type Quantity_Correction_Ticket_StatesQuantity_Correction_Tickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quantity_Correction_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quantity_Correction_Tickets_Order_By>>;
  where?: InputMaybe<Quantity_Correction_Tickets_Bool_Exp>;
};

/** aggregated selection of "quantity_correction_ticket_states" */
export type Quantity_Correction_Ticket_States_Aggregate = {
  __typename?: 'quantity_correction_ticket_states_aggregate';
  aggregate?: Maybe<Quantity_Correction_Ticket_States_Aggregate_Fields>;
  nodes: Array<Quantity_Correction_Ticket_States>;
};

/** aggregate fields of "quantity_correction_ticket_states" */
export type Quantity_Correction_Ticket_States_Aggregate_Fields = {
  __typename?: 'quantity_correction_ticket_states_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Quantity_Correction_Ticket_States_Max_Fields>;
  min?: Maybe<Quantity_Correction_Ticket_States_Min_Fields>;
};


/** aggregate fields of "quantity_correction_ticket_states" */
export type Quantity_Correction_Ticket_States_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quantity_Correction_Ticket_States_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "quantity_correction_ticket_states". All fields are combined with a logical 'AND'. */
export type Quantity_Correction_Ticket_States_Bool_Exp = {
  _and?: InputMaybe<Array<Quantity_Correction_Ticket_States_Bool_Exp>>;
  _not?: InputMaybe<Quantity_Correction_Ticket_States_Bool_Exp>;
  _or?: InputMaybe<Array<Quantity_Correction_Ticket_States_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  quantity_correction_tickets?: InputMaybe<Quantity_Correction_Tickets_Bool_Exp>;
  quantity_correction_tickets_aggregate?: InputMaybe<Quantity_Correction_Tickets_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "quantity_correction_ticket_states" */
export enum Quantity_Correction_Ticket_States_Constraint {
  /** unique or primary key constraint on columns "value" */
  QuantityCorrectionTicketStatesPkey = 'quantity_correction_ticket_states_pkey'
}

export enum Quantity_Correction_Ticket_States_Enum {
  /** APPROVED */
  Approved = 'APPROVED',
  /** PENDING */
  Pending = 'PENDING',
  /** REJECTED */
  Rejected = 'REJECTED'
}

/** Boolean expression to compare columns of type "quantity_correction_ticket_states_enum". All fields are combined with logical 'AND'. */
export type Quantity_Correction_Ticket_States_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Quantity_Correction_Ticket_States_Enum>;
  _in?: InputMaybe<Array<Quantity_Correction_Ticket_States_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Quantity_Correction_Ticket_States_Enum>;
  _nin?: InputMaybe<Array<Quantity_Correction_Ticket_States_Enum>>;
};

/** input type for inserting data into table "quantity_correction_ticket_states" */
export type Quantity_Correction_Ticket_States_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  quantity_correction_tickets?: InputMaybe<Quantity_Correction_Tickets_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Quantity_Correction_Ticket_States_Max_Fields = {
  __typename?: 'quantity_correction_ticket_states_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Quantity_Correction_Ticket_States_Min_Fields = {
  __typename?: 'quantity_correction_ticket_states_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "quantity_correction_ticket_states" */
export type Quantity_Correction_Ticket_States_Mutation_Response = {
  __typename?: 'quantity_correction_ticket_states_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quantity_Correction_Ticket_States>;
};

/** input type for inserting object relation for remote table "quantity_correction_ticket_states" */
export type Quantity_Correction_Ticket_States_Obj_Rel_Insert_Input = {
  data: Quantity_Correction_Ticket_States_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Quantity_Correction_Ticket_States_On_Conflict>;
};

/** on_conflict condition type for table "quantity_correction_ticket_states" */
export type Quantity_Correction_Ticket_States_On_Conflict = {
  constraint: Quantity_Correction_Ticket_States_Constraint;
  update_columns?: Array<Quantity_Correction_Ticket_States_Update_Column>;
  where?: InputMaybe<Quantity_Correction_Ticket_States_Bool_Exp>;
};

/** Ordering options when selecting data from "quantity_correction_ticket_states". */
export type Quantity_Correction_Ticket_States_Order_By = {
  comment?: InputMaybe<Order_By>;
  quantity_correction_tickets_aggregate?: InputMaybe<Quantity_Correction_Tickets_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quantity_correction_ticket_states */
export type Quantity_Correction_Ticket_States_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "quantity_correction_ticket_states" */
export enum Quantity_Correction_Ticket_States_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "quantity_correction_ticket_states" */
export type Quantity_Correction_Ticket_States_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "quantity_correction_ticket_states" */
export type Quantity_Correction_Ticket_States_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quantity_Correction_Ticket_States_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quantity_Correction_Ticket_States_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "quantity_correction_ticket_states" */
export enum Quantity_Correction_Ticket_States_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Quantity_Correction_Ticket_States_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quantity_Correction_Ticket_States_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quantity_Correction_Ticket_States_Bool_Exp;
};

/** columns and relationships of "quantity_correction_tickets" */
export type Quantity_Correction_Tickets = {
  __typename?: 'quantity_correction_tickets';
  approved_by?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified: Scalars['timestamptz']['output'];
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  quantity_correction_ticket_state: Quantity_Correction_Ticket_States;
  quantity_dispensed: Scalars['numeric']['output'];
  /** An object relationship */
  reason: Reasons;
  reason_id: Scalars['uuid']['output'];
  state: Quantity_Correction_Ticket_States_Enum;
  /** An object relationship */
  task_value: Task_Value;
  task_value_id: Scalars['uuid']['output'];
  /** An object relationship */
  user?: Maybe<User>;
};

/** aggregated selection of "quantity_correction_tickets" */
export type Quantity_Correction_Tickets_Aggregate = {
  __typename?: 'quantity_correction_tickets_aggregate';
  aggregate?: Maybe<Quantity_Correction_Tickets_Aggregate_Fields>;
  nodes: Array<Quantity_Correction_Tickets>;
};

export type Quantity_Correction_Tickets_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Quantity_Correction_Tickets_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Quantity_Correction_Tickets_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Quantity_Correction_Tickets_Aggregate_Bool_Exp_Count>;
};

export type Quantity_Correction_Tickets_Aggregate_Bool_Exp_Bool_And = {
  arguments: Quantity_Correction_Tickets_Select_Column_Quantity_Correction_Tickets_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quantity_Correction_Tickets_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Quantity_Correction_Tickets_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Quantity_Correction_Tickets_Select_Column_Quantity_Correction_Tickets_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quantity_Correction_Tickets_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Quantity_Correction_Tickets_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Quantity_Correction_Tickets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quantity_Correction_Tickets_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "quantity_correction_tickets" */
export type Quantity_Correction_Tickets_Aggregate_Fields = {
  __typename?: 'quantity_correction_tickets_aggregate_fields';
  avg?: Maybe<Quantity_Correction_Tickets_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Quantity_Correction_Tickets_Max_Fields>;
  min?: Maybe<Quantity_Correction_Tickets_Min_Fields>;
  stddev?: Maybe<Quantity_Correction_Tickets_Stddev_Fields>;
  stddev_pop?: Maybe<Quantity_Correction_Tickets_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Quantity_Correction_Tickets_Stddev_Samp_Fields>;
  sum?: Maybe<Quantity_Correction_Tickets_Sum_Fields>;
  var_pop?: Maybe<Quantity_Correction_Tickets_Var_Pop_Fields>;
  var_samp?: Maybe<Quantity_Correction_Tickets_Var_Samp_Fields>;
  variance?: Maybe<Quantity_Correction_Tickets_Variance_Fields>;
};


/** aggregate fields of "quantity_correction_tickets" */
export type Quantity_Correction_Tickets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quantity_Correction_Tickets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "quantity_correction_tickets" */
export type Quantity_Correction_Tickets_Aggregate_Order_By = {
  avg?: InputMaybe<Quantity_Correction_Tickets_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Quantity_Correction_Tickets_Max_Order_By>;
  min?: InputMaybe<Quantity_Correction_Tickets_Min_Order_By>;
  stddev?: InputMaybe<Quantity_Correction_Tickets_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Quantity_Correction_Tickets_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Quantity_Correction_Tickets_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Quantity_Correction_Tickets_Sum_Order_By>;
  var_pop?: InputMaybe<Quantity_Correction_Tickets_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Quantity_Correction_Tickets_Var_Samp_Order_By>;
  variance?: InputMaybe<Quantity_Correction_Tickets_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "quantity_correction_tickets" */
export type Quantity_Correction_Tickets_Arr_Rel_Insert_Input = {
  data: Array<Quantity_Correction_Tickets_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Quantity_Correction_Tickets_On_Conflict>;
};

/** aggregate avg on columns */
export type Quantity_Correction_Tickets_Avg_Fields = {
  __typename?: 'quantity_correction_tickets_avg_fields';
  quantity_dispensed?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "quantity_correction_tickets" */
export type Quantity_Correction_Tickets_Avg_Order_By = {
  quantity_dispensed?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "quantity_correction_tickets". All fields are combined with a logical 'AND'. */
export type Quantity_Correction_Tickets_Bool_Exp = {
  _and?: InputMaybe<Array<Quantity_Correction_Tickets_Bool_Exp>>;
  _not?: InputMaybe<Quantity_Correction_Tickets_Bool_Exp>;
  _or?: InputMaybe<Array<Quantity_Correction_Tickets_Bool_Exp>>;
  approved_by?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  quantity_correction_ticket_state?: InputMaybe<Quantity_Correction_Ticket_States_Bool_Exp>;
  quantity_dispensed?: InputMaybe<Numeric_Comparison_Exp>;
  reason?: InputMaybe<Reasons_Bool_Exp>;
  reason_id?: InputMaybe<Uuid_Comparison_Exp>;
  state?: InputMaybe<Quantity_Correction_Ticket_States_Enum_Comparison_Exp>;
  task_value?: InputMaybe<Task_Value_Bool_Exp>;
  task_value_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "quantity_correction_tickets" */
export enum Quantity_Correction_Tickets_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuantityCorrectionTicketsPkey = 'quantity_correction_tickets_pkey',
  /** unique or primary key constraint on columns "task_value_id" */
  QuantityCorrectionTicketsTaskValueIdKey = 'quantity_correction_tickets_task_value_id_key'
}

/** input type for incrementing numeric columns in table "quantity_correction_tickets" */
export type Quantity_Correction_Tickets_Inc_Input = {
  quantity_dispensed?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "quantity_correction_tickets" */
export type Quantity_Correction_Tickets_Insert_Input = {
  approved_by?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  quantity_correction_ticket_state?: InputMaybe<Quantity_Correction_Ticket_States_Obj_Rel_Insert_Input>;
  quantity_dispensed?: InputMaybe<Scalars['numeric']['input']>;
  reason?: InputMaybe<Reasons_Obj_Rel_Insert_Input>;
  reason_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Quantity_Correction_Ticket_States_Enum>;
  task_value?: InputMaybe<Task_Value_Obj_Rel_Insert_Input>;
  task_value_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Quantity_Correction_Tickets_Max_Fields = {
  __typename?: 'quantity_correction_tickets_max_fields';
  approved_by?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  quantity_dispensed?: Maybe<Scalars['numeric']['output']>;
  reason_id?: Maybe<Scalars['uuid']['output']>;
  task_value_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "quantity_correction_tickets" */
export type Quantity_Correction_Tickets_Max_Order_By = {
  approved_by?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  quantity_dispensed?: InputMaybe<Order_By>;
  reason_id?: InputMaybe<Order_By>;
  task_value_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Quantity_Correction_Tickets_Min_Fields = {
  __typename?: 'quantity_correction_tickets_min_fields';
  approved_by?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  quantity_dispensed?: Maybe<Scalars['numeric']['output']>;
  reason_id?: Maybe<Scalars['uuid']['output']>;
  task_value_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "quantity_correction_tickets" */
export type Quantity_Correction_Tickets_Min_Order_By = {
  approved_by?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  quantity_dispensed?: InputMaybe<Order_By>;
  reason_id?: InputMaybe<Order_By>;
  task_value_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "quantity_correction_tickets" */
export type Quantity_Correction_Tickets_Mutation_Response = {
  __typename?: 'quantity_correction_tickets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quantity_Correction_Tickets>;
};

/** input type for inserting object relation for remote table "quantity_correction_tickets" */
export type Quantity_Correction_Tickets_Obj_Rel_Insert_Input = {
  data: Quantity_Correction_Tickets_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Quantity_Correction_Tickets_On_Conflict>;
};

/** on_conflict condition type for table "quantity_correction_tickets" */
export type Quantity_Correction_Tickets_On_Conflict = {
  constraint: Quantity_Correction_Tickets_Constraint;
  update_columns?: Array<Quantity_Correction_Tickets_Update_Column>;
  where?: InputMaybe<Quantity_Correction_Tickets_Bool_Exp>;
};

/** Ordering options when selecting data from "quantity_correction_tickets". */
export type Quantity_Correction_Tickets_Order_By = {
  approved_by?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  quantity_correction_ticket_state?: InputMaybe<Quantity_Correction_Ticket_States_Order_By>;
  quantity_dispensed?: InputMaybe<Order_By>;
  reason?: InputMaybe<Reasons_Order_By>;
  reason_id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  task_value?: InputMaybe<Task_Value_Order_By>;
  task_value_id?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: quantity_correction_tickets */
export type Quantity_Correction_Tickets_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "quantity_correction_tickets" */
export enum Quantity_Correction_Tickets_Select_Column {
  /** column name */
  ApprovedBy = 'approved_by',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Message = 'message',
  /** column name */
  QuantityDispensed = 'quantity_dispensed',
  /** column name */
  ReasonId = 'reason_id',
  /** column name */
  State = 'state',
  /** column name */
  TaskValueId = 'task_value_id'
}

/** select "quantity_correction_tickets_aggregate_bool_exp_bool_and_arguments_columns" columns of table "quantity_correction_tickets" */
export enum Quantity_Correction_Tickets_Select_Column_Quantity_Correction_Tickets_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "quantity_correction_tickets_aggregate_bool_exp_bool_or_arguments_columns" columns of table "quantity_correction_tickets" */
export enum Quantity_Correction_Tickets_Select_Column_Quantity_Correction_Tickets_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "quantity_correction_tickets" */
export type Quantity_Correction_Tickets_Set_Input = {
  approved_by?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  quantity_dispensed?: InputMaybe<Scalars['numeric']['input']>;
  reason_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Quantity_Correction_Ticket_States_Enum>;
  task_value_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Quantity_Correction_Tickets_Stddev_Fields = {
  __typename?: 'quantity_correction_tickets_stddev_fields';
  quantity_dispensed?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "quantity_correction_tickets" */
export type Quantity_Correction_Tickets_Stddev_Order_By = {
  quantity_dispensed?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Quantity_Correction_Tickets_Stddev_Pop_Fields = {
  __typename?: 'quantity_correction_tickets_stddev_pop_fields';
  quantity_dispensed?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "quantity_correction_tickets" */
export type Quantity_Correction_Tickets_Stddev_Pop_Order_By = {
  quantity_dispensed?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Quantity_Correction_Tickets_Stddev_Samp_Fields = {
  __typename?: 'quantity_correction_tickets_stddev_samp_fields';
  quantity_dispensed?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "quantity_correction_tickets" */
export type Quantity_Correction_Tickets_Stddev_Samp_Order_By = {
  quantity_dispensed?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "quantity_correction_tickets" */
export type Quantity_Correction_Tickets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quantity_Correction_Tickets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quantity_Correction_Tickets_Stream_Cursor_Value_Input = {
  approved_by?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  quantity_dispensed?: InputMaybe<Scalars['numeric']['input']>;
  reason_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Quantity_Correction_Ticket_States_Enum>;
  task_value_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Quantity_Correction_Tickets_Sum_Fields = {
  __typename?: 'quantity_correction_tickets_sum_fields';
  quantity_dispensed?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "quantity_correction_tickets" */
export type Quantity_Correction_Tickets_Sum_Order_By = {
  quantity_dispensed?: InputMaybe<Order_By>;
};

/** update columns of table "quantity_correction_tickets" */
export enum Quantity_Correction_Tickets_Update_Column {
  /** column name */
  ApprovedBy = 'approved_by',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Message = 'message',
  /** column name */
  QuantityDispensed = 'quantity_dispensed',
  /** column name */
  ReasonId = 'reason_id',
  /** column name */
  State = 'state',
  /** column name */
  TaskValueId = 'task_value_id'
}

export type Quantity_Correction_Tickets_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Quantity_Correction_Tickets_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quantity_Correction_Tickets_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quantity_Correction_Tickets_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Quantity_Correction_Tickets_Var_Pop_Fields = {
  __typename?: 'quantity_correction_tickets_var_pop_fields';
  quantity_dispensed?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "quantity_correction_tickets" */
export type Quantity_Correction_Tickets_Var_Pop_Order_By = {
  quantity_dispensed?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Quantity_Correction_Tickets_Var_Samp_Fields = {
  __typename?: 'quantity_correction_tickets_var_samp_fields';
  quantity_dispensed?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "quantity_correction_tickets" */
export type Quantity_Correction_Tickets_Var_Samp_Order_By = {
  quantity_dispensed?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Quantity_Correction_Tickets_Variance_Fields = {
  __typename?: 'quantity_correction_tickets_variance_fields';
  quantity_dispensed?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "quantity_correction_tickets" */
export type Quantity_Correction_Tickets_Variance_Order_By = {
  quantity_dispensed?: InputMaybe<Order_By>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "SmartRefueler.dispencerLocation" */
  SmartRefueler_dispencerLocation: Array<SmartRefueler_DispencerLocation>;
  /** fetch aggregated fields from the table: "SmartRefueler.dispencerLocation" */
  SmartRefueler_dispencerLocation_aggregate: SmartRefueler_DispencerLocation_Aggregate;
  /** fetch data from the table: "address_subsidiary" */
  address_subsidiary: Array<Address_Subsidiary>;
  /** fetch aggregated fields from the table: "address_subsidiary" */
  address_subsidiary_aggregate: Address_Subsidiary_Aggregate;
  /** An array relationship */
  address_subsidiary_audit_logs: Array<Address_Subsidiary_Audit_Logs>;
  /** An aggregate relationship */
  address_subsidiary_audit_logs_aggregate: Address_Subsidiary_Audit_Logs_Aggregate;
  /** fetch data from the table: "address_subsidiary_audit_logs" using primary key columns */
  address_subsidiary_audit_logs_by_pk?: Maybe<Address_Subsidiary_Audit_Logs>;
  /** fetch data from the table: "address_subsidiary" using primary key columns */
  address_subsidiary_by_pk?: Maybe<Address_Subsidiary>;
  /** fetch data from the table: "address_type" */
  address_type: Array<Address_Type>;
  /** fetch aggregated fields from the table: "address_type" */
  address_type_aggregate: Address_Type_Aggregate;
  /** fetch data from the table: "address_type" using primary key columns */
  address_type_by_pk?: Maybe<Address_Type>;
  /** fetch data from the table: "asset_grouping" */
  asset_grouping: Array<Asset_Grouping>;
  /** fetch aggregated fields from the table: "asset_grouping" */
  asset_grouping_aggregate: Asset_Grouping_Aggregate;
  /** fetch data from the table: "asset_grouping" using primary key columns */
  asset_grouping_by_pk?: Maybe<Asset_Grouping>;
  /** fetch data from the table: "asset_grouping_customer_asset" */
  asset_grouping_customer_asset: Array<Asset_Grouping_Customer_Asset>;
  /** fetch aggregated fields from the table: "asset_grouping_customer_asset" */
  asset_grouping_customer_asset_aggregate: Asset_Grouping_Customer_Asset_Aggregate;
  /** fetch data from the table: "asset_grouping_customer_asset" using primary key columns */
  asset_grouping_customer_asset_by_pk?: Maybe<Asset_Grouping_Customer_Asset>;
  /** fetch data from the table: "asset_subsidiary" */
  asset_subsidiary: Array<Asset_Subsidiary>;
  /** fetch aggregated fields from the table: "asset_subsidiary" */
  asset_subsidiary_aggregate: Asset_Subsidiary_Aggregate;
  /** An array relationship */
  asset_subsidiary_audit_logs: Array<Asset_Subsidiary_Audit_Logs>;
  /** An aggregate relationship */
  asset_subsidiary_audit_logs_aggregate: Asset_Subsidiary_Audit_Logs_Aggregate;
  /** fetch data from the table: "asset_subsidiary_audit_logs" using primary key columns */
  asset_subsidiary_audit_logs_by_pk?: Maybe<Asset_Subsidiary_Audit_Logs>;
  /** fetch data from the table: "asset_subsidiary" using primary key columns */
  asset_subsidiary_by_pk?: Maybe<Asset_Subsidiary>;
  /** fetch data from the table: "asset_type" */
  asset_type: Array<Asset_Type>;
  /** fetch aggregated fields from the table: "asset_type" */
  asset_type_aggregate: Asset_Type_Aggregate;
  /** fetch data from the table: "asset_type" using primary key columns */
  asset_type_by_pk?: Maybe<Asset_Type>;
  /** fetch data from the table: "asset_type_category" */
  asset_type_category: Array<Asset_Type_Category>;
  /** fetch aggregated fields from the table: "asset_type_category" */
  asset_type_category_aggregate: Asset_Type_Category_Aggregate;
  /** fetch data from the table: "asset_type_category" using primary key columns */
  asset_type_category_by_pk?: Maybe<Asset_Type_Category>;
  /** fetch data from the table: "associated_type" */
  associated_type: Array<Associated_Type>;
  /** fetch aggregated fields from the table: "associated_type" */
  associated_type_aggregate: Associated_Type_Aggregate;
  /** fetch data from the table: "associated_type" using primary key columns */
  associated_type_by_pk?: Maybe<Associated_Type>;
  /** fetch data from the table: "audit_log_action" */
  audit_log_action: Array<Audit_Log_Action>;
  /** fetch aggregated fields from the table: "audit_log_action" */
  audit_log_action_aggregate: Audit_Log_Action_Aggregate;
  /** fetch data from the table: "audit_log_action" using primary key columns */
  audit_log_action_by_pk?: Maybe<Audit_Log_Action>;
  /** An array relationship */
  cancellation_reasons: Array<Cancellation_Reasons>;
  /** An aggregate relationship */
  cancellation_reasons_aggregate: Cancellation_Reasons_Aggregate;
  /** fetch data from the table: "cancellation_reasons" using primary key columns */
  cancellation_reasons_by_pk?: Maybe<Cancellation_Reasons>;
  /** fetch data from the table: "category" */
  category: Array<Category>;
  /** fetch aggregated fields from the table: "category" */
  category_aggregate: Category_Aggregate;
  /** fetch data from the table: "category" using primary key columns */
  category_by_pk?: Maybe<Category>;
  /** fetch data from the table: "city" */
  city: Array<City>;
  /** fetch aggregated fields from the table: "city" */
  city_aggregate: City_Aggregate;
  /** fetch data from the table: "city" using primary key columns */
  city_by_pk?: Maybe<City>;
  /** fetch data from the table: "country" */
  country: Array<Country>;
  /** fetch aggregated fields from the table: "country" */
  country_aggregate: Country_Aggregate;
  /** fetch data from the table: "country" using primary key columns */
  country_by_pk?: Maybe<Country>;
  /** fetch data from the table: "credit_breach" */
  credit_breach: Array<Credit_Breach>;
  /** fetch aggregated fields from the table: "credit_breach" */
  credit_breach_aggregate: Credit_Breach_Aggregate;
  /** fetch data from the table: "credit_breach" using primary key columns */
  credit_breach_by_pk?: Maybe<Credit_Breach>;
  /** fetch data from the table: "currency" */
  currency: Array<Currency>;
  /** fetch aggregated fields from the table: "currency" */
  currency_aggregate: Currency_Aggregate;
  /** fetch data from the table: "currency" using primary key columns */
  currency_by_pk?: Maybe<Currency>;
  /** fetch data from the table: "currency_conversion" */
  currency_conversion: Array<Currency_Conversion>;
  /** fetch aggregated fields from the table: "currency_conversion" */
  currency_conversion_aggregate: Currency_Conversion_Aggregate;
  /** fetch data from the table: "currency_conversion" using primary key columns */
  currency_conversion_by_pk?: Maybe<Currency_Conversion>;
  /** fetch data from the table: "customer_asset" */
  customer_asset: Array<Customer_Asset>;
  /** fetch aggregated fields from the table: "customer_asset" */
  customer_asset_aggregate: Customer_Asset_Aggregate;
  /** fetch data from the table: "customer_asset_audit_log" */
  customer_asset_audit_log: Array<Customer_Asset_Audit_Log>;
  /** fetch aggregated fields from the table: "customer_asset_audit_log" */
  customer_asset_audit_log_aggregate: Customer_Asset_Audit_Log_Aggregate;
  /** fetch data from the table: "customer_asset_audit_log" using primary key columns */
  customer_asset_audit_log_by_pk?: Maybe<Customer_Asset_Audit_Log>;
  /** fetch data from the table: "customer_asset" using primary key columns */
  customer_asset_by_pk?: Maybe<Customer_Asset>;
  /** fetch data from the table: "customer_asset_device" */
  customer_asset_device: Array<Customer_Asset_Device>;
  /** fetch aggregated fields from the table: "customer_asset_device" */
  customer_asset_device_aggregate: Customer_Asset_Device_Aggregate;
  /** fetch data from the table: "customer_asset_device" using primary key columns */
  customer_asset_device_by_pk?: Maybe<Customer_Asset_Device>;
  /** fetch data from the table: "customer_asset_device_calibration" */
  customer_asset_device_calibration: Array<Customer_Asset_Device_Calibration>;
  /** fetch aggregated fields from the table: "customer_asset_device_calibration" */
  customer_asset_device_calibration_aggregate: Customer_Asset_Device_Calibration_Aggregate;
  /** fetch data from the table: "customer_asset_device_calibration" using primary key columns */
  customer_asset_device_calibration_by_pk?: Maybe<Customer_Asset_Device_Calibration>;
  /** An array relationship */
  customer_asset_dispensing_rules: Array<Customer_Asset_Dispensing_Rules>;
  /** An aggregate relationship */
  customer_asset_dispensing_rules_aggregate: Customer_Asset_Dispensing_Rules_Aggregate;
  /** fetch data from the table: "customer_asset_dispensing_rules" using primary key columns */
  customer_asset_dispensing_rules_by_pk?: Maybe<Customer_Asset_Dispensing_Rules>;
  /** fetch data from the table: "customer_asset_limit" */
  customer_asset_limit: Array<Customer_Asset_Limit>;
  /** fetch aggregated fields from the table: "customer_asset_limit" */
  customer_asset_limit_aggregate: Customer_Asset_Limit_Aggregate;
  /** fetch data from the table: "customer_asset_limit" using primary key columns */
  customer_asset_limit_by_pk?: Maybe<Customer_Asset_Limit>;
  /** fetch data from the table: "customer_asset_tag" */
  customer_asset_tag: Array<Customer_Asset_Tag>;
  /** fetch aggregated fields from the table: "customer_asset_tag" */
  customer_asset_tag_aggregate: Customer_Asset_Tag_Aggregate;
  /** fetch data from the table: "customer_asset_tag" using primary key columns */
  customer_asset_tag_by_pk?: Maybe<Customer_Asset_Tag>;
  /** fetch data from the table: "customer_order" */
  customer_order: Array<Customer_Order>;
  /** fetch aggregated fields from the table: "customer_order" */
  customer_order_aggregate: Customer_Order_Aggregate;
  /** fetch data from the table: "customer_order" using primary key columns */
  customer_order_by_pk?: Maybe<Customer_Order>;
  /** An array relationship */
  customer_order_cancellation_reasons: Array<Customer_Order_Cancellation_Reasons>;
  /** An aggregate relationship */
  customer_order_cancellation_reasons_aggregate: Customer_Order_Cancellation_Reasons_Aggregate;
  /** fetch data from the table: "customer_order_cancellation_reasons" using primary key columns */
  customer_order_cancellation_reasons_by_pk?: Maybe<Customer_Order_Cancellation_Reasons>;
  /** fetch data from the table: "customer_order_customer_asset" */
  customer_order_customer_asset: Array<Customer_Order_Customer_Asset>;
  /** fetch aggregated fields from the table: "customer_order_customer_asset" */
  customer_order_customer_asset_aggregate: Customer_Order_Customer_Asset_Aggregate;
  /** fetch data from the table: "customer_order_customer_asset" using primary key columns */
  customer_order_customer_asset_by_pk?: Maybe<Customer_Order_Customer_Asset>;
  /** fetch data from the table: "customer_order_detail_view" */
  customer_order_detail_view: Array<Customer_Order_Detail_View>;
  /** fetch aggregated fields from the table: "customer_order_detail_view" */
  customer_order_detail_view_aggregate: Customer_Order_Detail_View_Aggregate;
  /** fetch data from the table: "customer_order_item" */
  customer_order_item: Array<Customer_Order_Item>;
  /** fetch aggregated fields from the table: "customer_order_item" */
  customer_order_item_aggregate: Customer_Order_Item_Aggregate;
  /** fetch data from the table: "customer_order_item" using primary key columns */
  customer_order_item_by_pk?: Maybe<Customer_Order_Item>;
  /** An array relationship */
  customer_order_item_cancellation_reasons: Array<Customer_Order_Item_Cancellation_Reasons>;
  /** An aggregate relationship */
  customer_order_item_cancellation_reasons_aggregate: Customer_Order_Item_Cancellation_Reasons_Aggregate;
  /** fetch data from the table: "customer_order_item_cancellation_reasons" using primary key columns */
  customer_order_item_cancellation_reasons_by_pk?: Maybe<Customer_Order_Item_Cancellation_Reasons>;
  /** An array relationship */
  customer_order_item_comments: Array<Customer_Order_Item_Comments>;
  /** An aggregate relationship */
  customer_order_item_comments_aggregate: Customer_Order_Item_Comments_Aggregate;
  /** fetch data from the table: "customer_order_item_comments" using primary key columns */
  customer_order_item_comments_by_pk?: Maybe<Customer_Order_Item_Comments>;
  /** fetch data from the table: "customer_order_item_commission" */
  customer_order_item_commission: Array<Customer_Order_Item_Commission>;
  /** fetch aggregated fields from the table: "customer_order_item_commission" */
  customer_order_item_commission_aggregate: Customer_Order_Item_Commission_Aggregate;
  /** fetch data from the table: "customer_order_item_commission" using primary key columns */
  customer_order_item_commission_by_pk?: Maybe<Customer_Order_Item_Commission>;
  /** An array relationship */
  customer_order_item_etd_transactional_logs: Array<Customer_Order_Item_Etd_Transactional_Logs>;
  /** An aggregate relationship */
  customer_order_item_etd_transactional_logs_aggregate: Customer_Order_Item_Etd_Transactional_Logs_Aggregate;
  /** fetch data from the table: "customer_order_item_etd_transactional_logs" using primary key columns */
  customer_order_item_etd_transactional_logs_by_pk?: Maybe<Customer_Order_Item_Etd_Transactional_Logs>;
  /** fetch data from the table: "customer_order_item_partner" */
  customer_order_item_partner: Array<Customer_Order_Item_Partner>;
  /** fetch aggregated fields from the table: "customer_order_item_partner" */
  customer_order_item_partner_aggregate: Customer_Order_Item_Partner_Aggregate;
  /** fetch data from the table: "customer_order_item_partner" using primary key columns */
  customer_order_item_partner_by_pk?: Maybe<Customer_Order_Item_Partner>;
  /** An array relationship */
  customer_order_item_safety_checklist_results: Array<Customer_Order_Item_Safety_Checklist_Results>;
  /** An aggregate relationship */
  customer_order_item_safety_checklist_results_aggregate: Customer_Order_Item_Safety_Checklist_Results_Aggregate;
  /** fetch data from the table: "customer_order_item_safety_checklist_results" using primary key columns */
  customer_order_item_safety_checklist_results_by_pk?: Maybe<Customer_Order_Item_Safety_Checklist_Results>;
  /** fetch data from the table: "customer_order_item_state" */
  customer_order_item_state: Array<Customer_Order_Item_State>;
  /** fetch aggregated fields from the table: "customer_order_item_state" */
  customer_order_item_state_aggregate: Customer_Order_Item_State_Aggregate;
  /** fetch data from the table: "customer_order_item_state" using primary key columns */
  customer_order_item_state_by_pk?: Maybe<Customer_Order_Item_State>;
  /** fetch data from the table: "customer_order_item_stateflow" */
  customer_order_item_stateflow: Array<Customer_Order_Item_Stateflow>;
  /** fetch aggregated fields from the table: "customer_order_item_stateflow" */
  customer_order_item_stateflow_aggregate: Customer_Order_Item_Stateflow_Aggregate;
  /** fetch data from the table: "customer_order_item_stateflow" using primary key columns */
  customer_order_item_stateflow_by_pk?: Maybe<Customer_Order_Item_Stateflow>;
  /** fetch data from the table: "customer_order_item_test_category" */
  customer_order_item_test_category: Array<Customer_Order_Item_Test_Category>;
  /** fetch aggregated fields from the table: "customer_order_item_test_category" */
  customer_order_item_test_category_aggregate: Customer_Order_Item_Test_Category_Aggregate;
  /** fetch data from the table: "customer_order_item_test_category" using primary key columns */
  customer_order_item_test_category_by_pk?: Maybe<Customer_Order_Item_Test_Category>;
  /** An array relationship */
  customer_order_item_test_results: Array<Customer_Order_Item_Test_Results>;
  /** An aggregate relationship */
  customer_order_item_test_results_aggregate: Customer_Order_Item_Test_Results_Aggregate;
  /** fetch data from the table: "customer_order_item_test_results" using primary key columns */
  customer_order_item_test_results_by_pk?: Maybe<Customer_Order_Item_Test_Results>;
  /** An array relationship */
  customer_order_item_test_results_photos: Array<Customer_Order_Item_Test_Results_Photos>;
  /** An aggregate relationship */
  customer_order_item_test_results_photos_aggregate: Customer_Order_Item_Test_Results_Photos_Aggregate;
  /** fetch data from the table: "customer_order_item_test_results_photos" using primary key columns */
  customer_order_item_test_results_photos_by_pk?: Maybe<Customer_Order_Item_Test_Results_Photos>;
  /** fetch data from the table: "customer_order_organization_user_document" */
  customer_order_organization_user_document: Array<Customer_Order_Organization_User_Document>;
  /** fetch aggregated fields from the table: "customer_order_organization_user_document" */
  customer_order_organization_user_document_aggregate: Customer_Order_Organization_User_Document_Aggregate;
  /** fetch data from the table: "customer_order_organization_user_document" using primary key columns */
  customer_order_organization_user_document_by_pk?: Maybe<Customer_Order_Organization_User_Document>;
  /** fetch data from the table: "customer_order_partner_order" */
  customer_order_partner_order: Array<Customer_Order_Partner_Order>;
  /** fetch aggregated fields from the table: "customer_order_partner_order" */
  customer_order_partner_order_aggregate: Customer_Order_Partner_Order_Aggregate;
  /** fetch data from the table: "customer_order_partner_order" using primary key columns */
  customer_order_partner_order_by_pk?: Maybe<Customer_Order_Partner_Order>;
  /** An array relationship */
  customer_order_slots: Array<Customer_Order_Slots>;
  /** An aggregate relationship */
  customer_order_slots_aggregate: Customer_Order_Slots_Aggregate;
  /** fetch data from the table: "customer_order_slots" using primary key columns */
  customer_order_slots_by_pk?: Maybe<Customer_Order_Slots>;
  /** fetch data from the table: "customer_order_state" */
  customer_order_state: Array<Customer_Order_State>;
  /** fetch aggregated fields from the table: "customer_order_state" */
  customer_order_state_aggregate: Customer_Order_State_Aggregate;
  /** fetch data from the table: "customer_order_state" using primary key columns */
  customer_order_state_by_pk?: Maybe<Customer_Order_State>;
  /** fetch data from the table: "customer_order_stateflow" */
  customer_order_stateflow: Array<Customer_Order_Stateflow>;
  /** fetch aggregated fields from the table: "customer_order_stateflow" */
  customer_order_stateflow_aggregate: Customer_Order_Stateflow_Aggregate;
  /** fetch data from the table: "customer_order_stateflow" using primary key columns */
  customer_order_stateflow_by_pk?: Maybe<Customer_Order_Stateflow>;
  /** fetch data from the table: "customer_payment" */
  customer_payment: Array<Customer_Payment>;
  /** fetch aggregated fields from the table: "customer_payment" */
  customer_payment_aggregate: Customer_Payment_Aggregate;
  /** fetch data from the table: "customer_payment" using primary key columns */
  customer_payment_by_pk?: Maybe<Customer_Payment>;
  /** fetch data from the table: "customer_payment_status" */
  customer_payment_status: Array<Customer_Payment_Status>;
  /** fetch aggregated fields from the table: "customer_payment_status" */
  customer_payment_status_aggregate: Customer_Payment_Status_Aggregate;
  /** fetch data from the table: "customer_payment_status" using primary key columns */
  customer_payment_status_by_pk?: Maybe<Customer_Payment_Status>;
  /** fetch data from the table: "customer_segmentation" */
  customer_segmentation: Array<Customer_Segmentation>;
  /** fetch aggregated fields from the table: "customer_segmentation" */
  customer_segmentation_aggregate: Customer_Segmentation_Aggregate;
  /** fetch data from the table: "customer_segmentation" using primary key columns */
  customer_segmentation_by_pk?: Maybe<Customer_Segmentation>;
  /** fetch data from the table: "day_type" */
  day_type: Array<Day_Type>;
  /** fetch aggregated fields from the table: "day_type" */
  day_type_aggregate: Day_Type_Aggregate;
  /** fetch data from the table: "day_type" using primary key columns */
  day_type_by_pk?: Maybe<Day_Type>;
  /** fetch data from the table: "delayed_orders" */
  delayed_orders: Array<Delayed_Orders>;
  /** fetch aggregated fields from the table: "delayed_orders" */
  delayed_orders_aggregate: Delayed_Orders_Aggregate;
  /** fetch data from the table: "delivery_preferences" */
  delivery_preferences: Array<Delivery_Preferences>;
  /** fetch aggregated fields from the table: "delivery_preferences" */
  delivery_preferences_aggregate: Delivery_Preferences_Aggregate;
  /** fetch data from the table: "delivery_preferences" using primary key columns */
  delivery_preferences_by_pk?: Maybe<Delivery_Preferences>;
  /** fetch data from the table: "delivery_scheduler" */
  delivery_scheduler: Array<Delivery_Scheduler>;
  /** fetch aggregated fields from the table: "delivery_scheduler" */
  delivery_scheduler_aggregate: Delivery_Scheduler_Aggregate;
  /** fetch data from the table: "delivery_scheduler" using primary key columns */
  delivery_scheduler_by_pk?: Maybe<Delivery_Scheduler>;
  /** fetch data from the table: "delivery_scheduler_product_item" */
  delivery_scheduler_product_item: Array<Delivery_Scheduler_Product_Item>;
  /** fetch aggregated fields from the table: "delivery_scheduler_product_item" */
  delivery_scheduler_product_item_aggregate: Delivery_Scheduler_Product_Item_Aggregate;
  /** fetch data from the table: "delivery_scheduler_product_item" using primary key columns */
  delivery_scheduler_product_item_by_pk?: Maybe<Delivery_Scheduler_Product_Item>;
  /** fetch data from the table: "department_retag_request" */
  department_retag_request: Array<Department_Retag_Request>;
  /** fetch aggregated fields from the table: "department_retag_request" */
  department_retag_request_aggregate: Department_Retag_Request_Aggregate;
  /** fetch data from the table: "department_retag_request" using primary key columns */
  department_retag_request_by_pk?: Maybe<Department_Retag_Request>;
  /** Derive slots for a specific date from master_slot templates for daily planning approval */
  deriveSlotsForDate?: Maybe<DeriveSlotsForDateOutput>;
  /** fetch data from the table: "device_devicetype_paramerter_definition" */
  device_devicetype_paramerter_definition: Array<Device_Devicetype_Paramerter_Definition>;
  /** fetch aggregated fields from the table: "device_devicetype_paramerter_definition" */
  device_devicetype_paramerter_definition_aggregate: Device_Devicetype_Paramerter_Definition_Aggregate;
  /** fetch data from the table: "device_devicetype_paramerter_definition" using primary key columns */
  device_devicetype_paramerter_definition_by_pk?: Maybe<Device_Devicetype_Paramerter_Definition>;
  /** fetch data from the table: "devicetype" */
  devicetype: Array<Devicetype>;
  /** fetch aggregated fields from the table: "devicetype" */
  devicetype_aggregate: Devicetype_Aggregate;
  /** fetch data from the table: "devicetype" using primary key columns */
  devicetype_by_pk?: Maybe<Devicetype>;
  /** fetch data from the table: "devicetype_paramerter_definition" */
  devicetype_paramerter_definition: Array<Devicetype_Paramerter_Definition>;
  /** fetch aggregated fields from the table: "devicetype_paramerter_definition" */
  devicetype_paramerter_definition_aggregate: Devicetype_Paramerter_Definition_Aggregate;
  /** fetch data from the table: "devicetype_paramerter_definition" using primary key columns */
  devicetype_paramerter_definition_by_pk?: Maybe<Devicetype_Paramerter_Definition>;
  /** fetch data from the table: "devicetype_parameter_group" */
  devicetype_parameter_group: Array<Devicetype_Parameter_Group>;
  /** fetch aggregated fields from the table: "devicetype_parameter_group" */
  devicetype_parameter_group_aggregate: Devicetype_Parameter_Group_Aggregate;
  /** fetch data from the table: "devicetype_parameter_group" using primary key columns */
  devicetype_parameter_group_by_pk?: Maybe<Devicetype_Parameter_Group>;
  /** fetch data from the table: "discount_type" */
  discount_type: Array<Discount_Type>;
  /** fetch aggregated fields from the table: "discount_type" */
  discount_type_aggregate: Discount_Type_Aggregate;
  /** fetch data from the table: "discount_type" using primary key columns */
  discount_type_by_pk?: Maybe<Discount_Type>;
  /** fetch data from the table: "dispenser" */
  dispenser: Array<Dispenser>;
  /** fetch aggregated fields from the table: "dispenser" */
  dispenser_aggregate: Dispenser_Aggregate;
  /** fetch data from the table: "dispenser" using primary key columns */
  dispenser_by_pk?: Maybe<Dispenser>;
  /** fetch data from the table: "dispenser_configuration" */
  dispenser_configuration: Array<Dispenser_Configuration>;
  /** fetch aggregated fields from the table: "dispenser_configuration" */
  dispenser_configuration_aggregate: Dispenser_Configuration_Aggregate;
  /** fetch data from the table: "dispenser_configuration" using primary key columns */
  dispenser_configuration_by_pk?: Maybe<Dispenser_Configuration>;
  /** fetch data from the table: "dispenser_type" */
  dispenser_type: Array<Dispenser_Type>;
  /** fetch aggregated fields from the table: "dispenser_type" */
  dispenser_type_aggregate: Dispenser_Type_Aggregate;
  /** fetch data from the table: "dispenser_type" using primary key columns */
  dispenser_type_by_pk?: Maybe<Dispenser_Type>;
  /** An array relationship */
  dispensing_rules: Array<Dispensing_Rules>;
  /** An aggregate relationship */
  dispensing_rules_aggregate: Dispensing_Rules_Aggregate;
  /** fetch data from the table: "dispensing_rules" using primary key columns */
  dispensing_rules_by_pk?: Maybe<Dispensing_Rules>;
  /** fetch data from the table: "document_type" */
  document_type: Array<Document_Type>;
  /** fetch aggregated fields from the table: "document_type" */
  document_type_aggregate: Document_Type_Aggregate;
  /** fetch data from the table: "document_type" using primary key columns */
  document_type_by_pk?: Maybe<Document_Type>;
  /** fetch data from the table: "document_type_category" */
  document_type_category: Array<Document_Type_Category>;
  /** fetch aggregated fields from the table: "document_type_category" */
  document_type_category_aggregate: Document_Type_Category_Aggregate;
  /** fetch data from the table: "document_type_category" using primary key columns */
  document_type_category_by_pk?: Maybe<Document_Type_Category>;
  /** fetch data from the table: "documents" */
  documents: Array<Documents>;
  /** fetch aggregated fields from the table: "documents" */
  documents_aggregate: Documents_Aggregate;
  /** fetch data from the table: "documents" using primary key columns */
  documents_by_pk?: Maybe<Documents>;
  /** fetch data from the table: "driver_duty_log" */
  driver_duty_log: Array<Driver_Duty_Log>;
  /** fetch aggregated fields from the table: "driver_duty_log" */
  driver_duty_log_aggregate: Driver_Duty_Log_Aggregate;
  /** fetch data from the table: "driver_duty_log" using primary key columns */
  driver_duty_log_by_pk?: Maybe<Driver_Duty_Log>;
  /** An array relationship */
  driver_duty_photos: Array<Driver_Duty_Photos>;
  /** An aggregate relationship */
  driver_duty_photos_aggregate: Driver_Duty_Photos_Aggregate;
  /** fetch data from the table: "driver_duty_photos" using primary key columns */
  driver_duty_photos_by_pk?: Maybe<Driver_Duty_Photos>;
  /** fetch data from the table: "driver_permit" */
  driver_permit: Array<Driver_Permit>;
  /** fetch aggregated fields from the table: "driver_permit" */
  driver_permit_aggregate: Driver_Permit_Aggregate;
  /** fetch data from the table: "driver_permit" using primary key columns */
  driver_permit_by_pk?: Maybe<Driver_Permit>;
  /** fetch data from the table: "driver_vehicle" */
  driver_vehicle: Array<Driver_Vehicle>;
  /** fetch aggregated fields from the table: "driver_vehicle" */
  driver_vehicle_aggregate: Driver_Vehicle_Aggregate;
  /** fetch data from the table: "driver_vehicle" using primary key columns */
  driver_vehicle_by_pk?: Maybe<Driver_Vehicle>;
  /** fetch data from the table: "driver_vehicle_issue" */
  driver_vehicle_issue: Array<Driver_Vehicle_Issue>;
  /** fetch aggregated fields from the table: "driver_vehicle_issue" */
  driver_vehicle_issue_aggregate: Driver_Vehicle_Issue_Aggregate;
  /** fetch data from the table: "driver_vehicle_issue" using primary key columns */
  driver_vehicle_issue_by_pk?: Maybe<Driver_Vehicle_Issue>;
  /** fetch data from the table: "driver_vehicle_location" */
  driver_vehicle_location: Array<Driver_Vehicle_Location>;
  /** fetch aggregated fields from the table: "driver_vehicle_location" */
  driver_vehicle_location_aggregate: Driver_Vehicle_Location_Aggregate;
  /** fetch data from the table: "driver_vehicle_location" using primary key columns */
  driver_vehicle_location_by_pk?: Maybe<Driver_Vehicle_Location>;
  /** fetch data from the table: "erp_sync_status" */
  erp_sync_status: Array<Erp_Sync_Status>;
  /** fetch aggregated fields from the table: "erp_sync_status" */
  erp_sync_status_aggregate: Erp_Sync_Status_Aggregate;
  /** fetch data from the table: "erp_sync_status" using primary key columns */
  erp_sync_status_by_pk?: Maybe<Erp_Sync_Status>;
  fetchCurrentAndPreviousMonthQtyV1?: Maybe<FetchCurrentAndPreviousMonthQtyV1Output>;
  fetchCurrentAndPreviousMonthQtyV2?: Maybe<FetchCurrentAndPreviousMonthQtyV2Output>;
  fetchCurrentAndPreviousMonthQtyV3?: Maybe<FetchCurrentAndPreviousMonthQtyV3Output>;
  fetchCurrentAndPreviousMonthQtyV4?: Maybe<FetchCurrentAndPreviousMonthQtyV4Output>;
  fetchCurrentAndPreviousMonthQtyV7?: Maybe<FetchCurrentAndPreviousMonthQtyV7Output>;
  fetchCurrentMonthDashboardSummaryV7?: Maybe<FetchCurrentMonthDashboardSummaryV7Output>;
  fetchCurrentMonthOrderSummaryV1?: Maybe<FetchCurrentMonthOrderSummaryV1Output>;
  fetchCurrentMonthOrderSummaryV2?: Maybe<FetchCurrentMonthOrderSummaryV2Output>;
  fetchCurrentMonthOrderSummaryV3?: Maybe<FetchCurrentMonthOrderSummaryV3Output>;
  fetchCurrentMonthOrderSummaryV7?: Maybe<FetchCurrentMonthOrderSummaryV7Output>;
  fetchCustomerAssetMileageV1?: Maybe<FetchCustomerAssetMileageV1Output>;
  fetchCustomerAssetReportV1?: Maybe<FetchCustomerAssetReportV1Output>;
  fetchCustomerAssetTagsFilterV1?: Maybe<FetchCustomerAssetTagsFilterV1Output>;
  fetchCustomerAssetUtilizationV1?: Maybe<FetchCustomerAssetUtilizationV1Output>;
  fetchCustomerAssetsFilterV1?: Maybe<FetchCustomerAssetsFilterV1Output>;
  fetchCustomerOrderDetailsV1?: Maybe<FetchCustomerOrderDetailsV1Output>;
  fetchCustomerOrderDetailsV2?: Maybe<FetchCustomerOrderDetailsV2Output>;
  fetchCustomerOrderDetailsV3?: Maybe<FetchCustomerOrderDetailsV3Output>;
  fetchCustomerOrderDetailsV4?: Maybe<FetchCustomerOrderDetailsV4Output>;
  fetchCustomerOrderDetailsV5?: Maybe<FetchCustomerOrderDetailsV5Output>;
  fetchCustomerOrderDetailsV6?: Maybe<FetchCustomerOrderDetailsV6Output>;
  fetchCustomerOrderDetailsV7?: Maybe<FetchCustomerOrderDetailsV7Output>;
  fetchCustomerOrderItemComments?: Maybe<FetchCustomerOrderItemCommentsOutput>;
  fetchDownloadReportDetailsV7?: Maybe<FetchDownloadReportDetailsV7Output>;
  /** fetch Url for a file in cloud storage */
  fetchFile?: Maybe<FileOutput>;
  fetchMonthBillingV7?: Maybe<FetchMonthBillingV7Output>;
  fetchOrderCodesFilterV1?: Maybe<FetchOrderCodesFilterV1Output>;
  fetchOrderDetails?: Maybe<FetchOrderDetailsOutput>;
  fetchOrderStats?: Maybe<OrderStatsOutput>;
  fetchOrderSummaryCountV1?: Maybe<FetchOrderSummaryCountV1Output>;
  fetchOrderSummaryCountV2?: Maybe<FetchOrderSummaryCountV2Output>;
  fetchOrderSummaryCountV3?: Maybe<FetchOrderSummaryCountV3Output>;
  fetchOrderSummaryCountV7?: Maybe<FetchOrderSummaryCountV7Output>;
  fetchOrderSummaryQuantityV1?: Maybe<FetchOrderSummaryQuantityV1Output>;
  fetchOrderSummaryQuantityV2?: Maybe<FetchOrderSummaryQuantityV2Output>;
  fetchOrderSummaryQuantityV3?: Maybe<FetchOrderSummaryQuantityV3Output>;
  fetchOrderSummaryQuantityV7?: Maybe<FetchOrderSummaryQuantityV7Output>;
  fetchOrderSummaryRefillV1?: Maybe<FetchOrderSummaryRefillV1Output>;
  fetchOrderSummaryRefillV2?: Maybe<FetchOrderSummaryRefillV2Output>;
  fetchOrderSummaryRefillV3?: Maybe<FetchOrderSummaryRefillV3Output>;
  fetchOrderSummaryRefillV7?: Maybe<FetchOrderSummaryRefillV7Output>;
  fetchOrderedAndDeliveredQtyV1?: Maybe<FetchOrderedAndDeliveredQtyV1Output>;
  fetchOrderedAndDeliveredQtyV2?: Maybe<FetchOrderedAndDeliveredQtyV2Output>;
  fetchOrderedAndDeliveredQtyV3?: Maybe<FetchOrderedAndDeliveredQtyV3Output>;
  fetchOrderedAndDeliveredQtyV4?: Maybe<FetchOrderedAndDeliveredQtyV4Output>;
  fetchOrderedAndDeliveredQtyV7?: Maybe<FetchOrderedAndDeliveredQtyV7Output>;
  fetchOrders?: Maybe<OrdersOutput>;
  fetchOrganizationAddressFilterV1?: Maybe<FetchOrganizationAddressFilterV1Output>;
  fetchPartnerUsersFilterV1?: Maybe<FetchPartnerUsersFilterV1Output>;
  fetchPrevMonthDashboardSummaryV7?: Maybe<FetchPrevMonthDashboardSummaryV7Output>;
  fetchPreviousMonthOrderSummaryV1?: Maybe<FetchPreviousMonthOrderSummaryV1Output>;
  fetchPreviousMonthOrderSummaryV2?: Maybe<FetchPreviousMonthOrderSummaryV2Output>;
  fetchPreviousMonthOrderSummaryV3?: Maybe<FetchPreviousMonthOrderSummaryV3Output>;
  fetchPreviousMonthOrderSummaryV7?: Maybe<FetchPreviousMonthOrderSummaryV7Output>;
  /** This will fetch SuperSet guest token */
  fetchSuperSetGuestToken?: Maybe<GuestToken>;
  fetchTaskValueForCustomerAsset?: Maybe<FetchTaskValueForCustomerAssetOutput>;
  fetchTotalOrdersAmountGroupedByDayV1?: Maybe<FetchTotalOrdersAmountGroupedByDayV1Output>;
  fetchTotalOrdersAmountGroupedByDayV2?: Maybe<FetchTotalOrdersAmountGroupedByDayV2Output>;
  fetchTotalOrdersAmountGroupedByDayV3?: Maybe<FetchTotalOrdersAmountGroupedByDayV3Output>;
  fetchTotalOrdersAmountGroupedByDayV4?: Maybe<FetchTotalOrdersAmountGroupedByDayV4Output>;
  fetchTotalOrdersAmountGroupedByDayV7?: Maybe<FetchTotalOrdersAmountGroupedByDayV7Output>;
  /** fetchUserDetails from token */
  fetchUserDetails?: Maybe<UserDetailsOutput>;
  fetchVehicleInventoryTransactionLogs?: Maybe<VehicleInventoryTransactionLogsOutput>;
  fetchVehicleLiveData?: Maybe<VehicleLiveDataOutput>;
  /** fetch data from the table: "fillup_request" */
  fillup_request: Array<Fillup_Request>;
  /** fetch aggregated fields from the table: "fillup_request" */
  fillup_request_aggregate: Fillup_Request_Aggregate;
  /** fetch data from the table: "fillup_request" using primary key columns */
  fillup_request_by_pk?: Maybe<Fillup_Request>;
  /** fetch data from the table: "fillup_request_status" */
  fillup_request_status: Array<Fillup_Request_Status>;
  /** fetch aggregated fields from the table: "fillup_request_status" */
  fillup_request_status_aggregate: Fillup_Request_Status_Aggregate;
  /** fetch data from the table: "fillup_request_status" using primary key columns */
  fillup_request_status_by_pk?: Maybe<Fillup_Request_Status>;
  /** fetch data from the table: "fuel_request_type" */
  fuel_request_type: Array<Fuel_Request_Type>;
  /** fetch aggregated fields from the table: "fuel_request_type" */
  fuel_request_type_aggregate: Fuel_Request_Type_Aggregate;
  /** fetch data from the table: "fuel_request_type" using primary key columns */
  fuel_request_type_by_pk?: Maybe<Fuel_Request_Type>;
  /** fetch data from the table: "fueltrans_transaction_logs" */
  fueltrans_transaction_logs: Array<Fueltrans_Transaction_Logs>;
  /** fetch aggregated fields from the table: "fueltrans_transaction_logs" */
  fueltrans_transaction_logs_aggregate: Fueltrans_Transaction_Logs_Aggregate;
  /** fetch data from the table: "fueltrans_transaction_logs" using primary key columns */
  fueltrans_transaction_logs_by_pk?: Maybe<Fueltrans_Transaction_Logs>;
  /** fetch data from the table: "geography_columns" */
  geography_columns: Array<Geography_Columns>;
  /** fetch aggregated fields from the table: "geography_columns" */
  geography_columns_aggregate: Geography_Columns_Aggregate;
  /** fetch data from the table: "geometry_columns" */
  geometry_columns: Array<Geometry_Columns>;
  /** fetch aggregated fields from the table: "geometry_columns" */
  geometry_columns_aggregate: Geometry_Columns_Aggregate;
  getDeviceHistory?: Maybe<GetDeviceHistoryOutput>;
  getDeviceHistoryV1?: Maybe<GetDeviceHistoryV1Output>;
  getDeviceHistoryV2?: Maybe<GetDeviceHistoryV2Output>;
  getDeviceUpdate?: Maybe<GetDeviceUpdateOutput>;
  getDeviceUpdateV1?: Maybe<GetDeviceUpdateV1Output>;
  getDeviceUpdateV4?: Maybe<GetDeviceUpdateV4Output>;
  /** fetch data from the table: "inventory" */
  inventory: Array<Inventory>;
  /** fetch aggregated fields from the table: "inventory" */
  inventory_aggregate: Inventory_Aggregate;
  /** fetch data from the table: "inventory" using primary key columns */
  inventory_by_pk?: Maybe<Inventory>;
  /** An array relationship */
  inventory_workflow_logs: Array<Inventory_Workflow_Logs>;
  /** An aggregate relationship */
  inventory_workflow_logs_aggregate: Inventory_Workflow_Logs_Aggregate;
  /** fetch data from the table: "inventory_workflow_logs" using primary key columns */
  inventory_workflow_logs_by_pk?: Maybe<Inventory_Workflow_Logs>;
  /** fetch data from the table: "invitation" */
  invitation: Array<Invitation>;
  /** fetch aggregated fields from the table: "invitation" */
  invitation_aggregate: Invitation_Aggregate;
  /** fetch data from the table: "invitation" using primary key columns */
  invitation_by_pk?: Maybe<Invitation>;
  /** fetch data from the table: "invitation_status" */
  invitation_status: Array<Invitation_Status>;
  /** fetch aggregated fields from the table: "invitation_status" */
  invitation_status_aggregate: Invitation_Status_Aggregate;
  /** fetch data from the table: "invitation_status" using primary key columns */
  invitation_status_by_pk?: Maybe<Invitation_Status>;
  /** fetch data from the table: "invoice" */
  invoice: Array<Invoice>;
  /** fetch aggregated fields from the table: "invoice" */
  invoice_aggregate: Invoice_Aggregate;
  /** fetch data from the table: "invoice" using primary key columns */
  invoice_by_pk?: Maybe<Invoice>;
  /** fetch data from the table: "invoiced_item" */
  invoiced_item: Array<Invoiced_Item>;
  /** fetch aggregated fields from the table: "invoiced_item" */
  invoiced_item_aggregate: Invoiced_Item_Aggregate;
  /** fetch data from the table: "invoiced_item" using primary key columns */
  invoiced_item_by_pk?: Maybe<Invoiced_Item>;
  /** fetch data from the table: "invoiced_item_cancellation_ticket_states" */
  invoiced_item_cancellation_ticket_states: Array<Invoiced_Item_Cancellation_Ticket_States>;
  /** fetch aggregated fields from the table: "invoiced_item_cancellation_ticket_states" */
  invoiced_item_cancellation_ticket_states_aggregate: Invoiced_Item_Cancellation_Ticket_States_Aggregate;
  /** fetch data from the table: "invoiced_item_cancellation_ticket_states" using primary key columns */
  invoiced_item_cancellation_ticket_states_by_pk?: Maybe<Invoiced_Item_Cancellation_Ticket_States>;
  /** An array relationship */
  invoiced_item_cancellation_tickets: Array<Invoiced_Item_Cancellation_Tickets>;
  /** An aggregate relationship */
  invoiced_item_cancellation_tickets_aggregate: Invoiced_Item_Cancellation_Tickets_Aggregate;
  /** fetch data from the table: "invoiced_item_cancellation_tickets" using primary key columns */
  invoiced_item_cancellation_tickets_by_pk?: Maybe<Invoiced_Item_Cancellation_Tickets>;
  /** fetch data from the table: "issue" */
  issue: Array<Issue>;
  /** fetch aggregated fields from the table: "issue" */
  issue_aggregate: Issue_Aggregate;
  /** fetch data from the table: "issue" using primary key columns */
  issue_by_pk?: Maybe<Issue>;
  /** fetch data from the table: "job_state" */
  job_state: Array<Job_State>;
  /** fetch aggregated fields from the table: "job_state" */
  job_state_aggregate: Job_State_Aggregate;
  /** fetch data from the table: "job_state" using primary key columns */
  job_state_by_pk?: Maybe<Job_State>;
  /** fetch data from the table: "job_type" */
  job_type: Array<Job_Type>;
  /** fetch aggregated fields from the table: "job_type" */
  job_type_aggregate: Job_Type_Aggregate;
  /** fetch data from the table: "job_type" using primary key columns */
  job_type_by_pk?: Maybe<Job_Type>;
  /** fetch data from the table: "job_type_template" */
  job_type_template: Array<Job_Type_Template>;
  /** fetch aggregated fields from the table: "job_type_template" */
  job_type_template_aggregate: Job_Type_Template_Aggregate;
  /** fetch data from the table: "job_type_template" using primary key columns */
  job_type_template_by_pk?: Maybe<Job_Type_Template>;
  /** An array relationship */
  jobs: Array<Jobs>;
  /** An aggregate relationship */
  jobs_aggregate: Jobs_Aggregate;
  /** fetch data from the table: "jobs" using primary key columns */
  jobs_by_pk?: Maybe<Jobs>;
  /** fetch data from the table: "jobs_state_flow" */
  jobs_state_flow: Array<Jobs_State_Flow>;
  /** fetch aggregated fields from the table: "jobs_state_flow" */
  jobs_state_flow_aggregate: Jobs_State_Flow_Aggregate;
  /** fetch data from the table: "jobs_state_flow" using primary key columns */
  jobs_state_flow_by_pk?: Maybe<Jobs_State_Flow>;
  /** fetch data from the table: "limit_purchase_order" */
  limit_purchase_order: Array<Limit_Purchase_Order>;
  /** fetch aggregated fields from the table: "limit_purchase_order" */
  limit_purchase_order_aggregate: Limit_Purchase_Order_Aggregate;
  /** fetch data from the table: "limit_purchase_order" using primary key columns */
  limit_purchase_order_by_pk?: Maybe<Limit_Purchase_Order>;
  /** An array relationship */
  limit_purchase_order_logs: Array<Limit_Purchase_Order_Logs>;
  /** An aggregate relationship */
  limit_purchase_order_logs_aggregate: Limit_Purchase_Order_Logs_Aggregate;
  /** fetch data from the table: "limit_purchase_order_logs" using primary key columns */
  limit_purchase_order_logs_by_pk?: Maybe<Limit_Purchase_Order_Logs>;
  /** fetch data from the table: "localities" */
  localities: Array<Localities>;
  /** fetch aggregated fields from the table: "localities" */
  localities_aggregate: Localities_Aggregate;
  /** fetch data from the table: "localities" using primary key columns */
  localities_by_pk?: Maybe<Localities>;
  /** fetch data from the table: "login_type" */
  login_type: Array<Login_Type>;
  /** fetch aggregated fields from the table: "login_type" */
  login_type_aggregate: Login_Type_Aggregate;
  /** fetch data from the table: "login_type" using primary key columns */
  login_type_by_pk?: Maybe<Login_Type>;
  /** fetch data from the table: "lpo_exception" */
  lpo_exception: Array<Lpo_Exception>;
  /** fetch aggregated fields from the table: "lpo_exception" */
  lpo_exception_aggregate: Lpo_Exception_Aggregate;
  /** fetch data from the table: "lpo_exception" using primary key columns */
  lpo_exception_by_pk?: Maybe<Lpo_Exception>;
  /** fetch data from the table: "master_slot" */
  master_slot: Array<Master_Slot>;
  /** fetch aggregated fields from the table: "master_slot" */
  master_slot_aggregate: Master_Slot_Aggregate;
  /** fetch data from the table: "master_slot" using primary key columns */
  master_slot_by_pk?: Maybe<Master_Slot>;
  /** fetch data from the table: "master_slot_pause" */
  master_slot_pause: Array<Master_Slot_Pause>;
  /** fetch aggregated fields from the table: "master_slot_pause" */
  master_slot_pause_aggregate: Master_Slot_Pause_Aggregate;
  /** fetch data from the table: "master_slot_pause" using primary key columns */
  master_slot_pause_by_pk?: Maybe<Master_Slot_Pause>;
  /** fetch data from the table: "omc_type" */
  omc_type: Array<Omc_Type>;
  /** fetch aggregated fields from the table: "omc_type" */
  omc_type_aggregate: Omc_Type_Aggregate;
  /** fetch data from the table: "omc_type" using primary key columns */
  omc_type_by_pk?: Maybe<Omc_Type>;
  /** An array relationship */
  order_photos: Array<Order_Photos>;
  /** An aggregate relationship */
  order_photos_aggregate: Order_Photos_Aggregate;
  /** fetch data from the table: "order_photos" using primary key columns */
  order_photos_by_pk?: Maybe<Order_Photos>;
  /** fetch data from the table: "order_scheduler" */
  order_scheduler: Array<Order_Scheduler>;
  /** fetch aggregated fields from the table: "order_scheduler" */
  order_scheduler_aggregate: Order_Scheduler_Aggregate;
  /** fetch data from the table: "order_scheduler" using primary key columns */
  order_scheduler_by_pk?: Maybe<Order_Scheduler>;
  /** fetch data from the table: "order_scheduler_customer_asset" */
  order_scheduler_customer_asset: Array<Order_Scheduler_Customer_Asset>;
  /** fetch aggregated fields from the table: "order_scheduler_customer_asset" */
  order_scheduler_customer_asset_aggregate: Order_Scheduler_Customer_Asset_Aggregate;
  /** fetch data from the table: "order_scheduler_customer_asset" using primary key columns */
  order_scheduler_customer_asset_by_pk?: Maybe<Order_Scheduler_Customer_Asset>;
  /** fetch data from the table: "order_scheduler_daily_frequency" */
  order_scheduler_daily_frequency: Array<Order_Scheduler_Daily_Frequency>;
  /** fetch aggregated fields from the table: "order_scheduler_daily_frequency" */
  order_scheduler_daily_frequency_aggregate: Order_Scheduler_Daily_Frequency_Aggregate;
  /** fetch data from the table: "order_scheduler_daily_frequency" using primary key columns */
  order_scheduler_daily_frequency_by_pk?: Maybe<Order_Scheduler_Daily_Frequency>;
  /** fetch data from the table: "order_type" */
  order_type: Array<Order_Type>;
  /** fetch aggregated fields from the table: "order_type" */
  order_type_aggregate: Order_Type_Aggregate;
  /** fetch data from the table: "order_type" using primary key columns */
  order_type_by_pk?: Maybe<Order_Type>;
  /** fetch data from the table: "organization" */
  organization: Array<Organization>;
  /** fetch data from the table: "organization_address" */
  organization_address: Array<Organization_Address>;
  /** fetch aggregated fields from the table: "organization_address" */
  organization_address_aggregate: Organization_Address_Aggregate;
  /** fetch data from the table: "organization_address" using primary key columns */
  organization_address_by_pk?: Maybe<Organization_Address>;
  /** fetch aggregated fields from the table: "organization" */
  organization_aggregate: Organization_Aggregate;
  /** fetch data from the table: "organization_audit_log" */
  organization_audit_log: Array<Organization_Audit_Log>;
  /** fetch aggregated fields from the table: "organization_audit_log" */
  organization_audit_log_aggregate: Organization_Audit_Log_Aggregate;
  /** fetch data from the table: "organization_audit_log" using primary key columns */
  organization_audit_log_by_pk?: Maybe<Organization_Audit_Log>;
  /** fetch data from the table: "organization" using primary key columns */
  organization_by_pk?: Maybe<Organization>;
  /** fetch data from the table: "organization_commission_product_variation_type" */
  organization_commission_product_variation_type: Array<Organization_Commission_Product_Variation_Type>;
  /** fetch aggregated fields from the table: "organization_commission_product_variation_type" */
  organization_commission_product_variation_type_aggregate: Organization_Commission_Product_Variation_Type_Aggregate;
  /** fetch data from the table: "organization_commission_product_variation_type" using primary key columns */
  organization_commission_product_variation_type_by_pk?: Maybe<Organization_Commission_Product_Variation_Type>;
  /** fetch data from the table: "organization_configuration" */
  organization_configuration: Array<Organization_Configuration>;
  /** fetch aggregated fields from the table: "organization_configuration" */
  organization_configuration_aggregate: Organization_Configuration_Aggregate;
  /** fetch data from the table: "organization_configuration" using primary key columns */
  organization_configuration_by_pk?: Maybe<Organization_Configuration>;
  /** fetch data from the table: "organization_product_variation_discount" */
  organization_product_variation_discount: Array<Organization_Product_Variation_Discount>;
  /** fetch aggregated fields from the table: "organization_product_variation_discount" */
  organization_product_variation_discount_aggregate: Organization_Product_Variation_Discount_Aggregate;
  /** fetch data from the table: "organization_product_variation_discount" using primary key columns */
  organization_product_variation_discount_by_pk?: Maybe<Organization_Product_Variation_Discount>;
  /** fetch data from the table: "organization_product_variation_discount_history" */
  organization_product_variation_discount_history: Array<Organization_Product_Variation_Discount_History>;
  /** fetch aggregated fields from the table: "organization_product_variation_discount_history" */
  organization_product_variation_discount_history_aggregate: Organization_Product_Variation_Discount_History_Aggregate;
  /** fetch data from the table: "organization_product_variation_discount_history" using primary key columns */
  organization_product_variation_discount_history_by_pk?: Maybe<Organization_Product_Variation_Discount_History>;
  /** fetch data from the table: "organization_sales_projection" */
  organization_sales_projection: Array<Organization_Sales_Projection>;
  /** fetch aggregated fields from the table: "organization_sales_projection" */
  organization_sales_projection_aggregate: Organization_Sales_Projection_Aggregate;
  /** fetch data from the table: "organization_sales_projection" using primary key columns */
  organization_sales_projection_by_pk?: Maybe<Organization_Sales_Projection>;
  /** fetch data from the table: "organization_timing" */
  organization_timing: Array<Organization_Timing>;
  /** fetch aggregated fields from the table: "organization_timing" */
  organization_timing_aggregate: Organization_Timing_Aggregate;
  /** fetch data from the table: "organization_timing" using primary key columns */
  organization_timing_by_pk?: Maybe<Organization_Timing>;
  /** fetch data from the table: "organization_type" */
  organization_type: Array<Organization_Type>;
  /** fetch aggregated fields from the table: "organization_type" */
  organization_type_aggregate: Organization_Type_Aggregate;
  /** fetch data from the table: "organization_type" using primary key columns */
  organization_type_by_pk?: Maybe<Organization_Type>;
  /** fetch data from the table: "organization_user" */
  organization_user: Array<Organization_User>;
  /** fetch aggregated fields from the table: "organization_user" */
  organization_user_aggregate: Organization_User_Aggregate;
  /** fetch data from the table: "organization_user" using primary key columns */
  organization_user_by_pk?: Maybe<Organization_User>;
  /** fetch data from the table: "organization_user_commission" */
  organization_user_commission: Array<Organization_User_Commission>;
  /** fetch aggregated fields from the table: "organization_user_commission" */
  organization_user_commission_aggregate: Organization_User_Commission_Aggregate;
  /** fetch data from the table: "organization_user_commission" using primary key columns */
  organization_user_commission_by_pk?: Maybe<Organization_User_Commission>;
  /** fetch data from the table: "organization_user_document" */
  organization_user_document: Array<Organization_User_Document>;
  /** fetch aggregated fields from the table: "organization_user_document" */
  organization_user_document_aggregate: Organization_User_Document_Aggregate;
  /** fetch data from the table: "organization_user_document" using primary key columns */
  organization_user_document_by_pk?: Maybe<Organization_User_Document>;
  /** fetch data from the table: "organization_user_permission" */
  organization_user_permission: Array<Organization_User_Permission>;
  /** fetch aggregated fields from the table: "organization_user_permission" */
  organization_user_permission_aggregate: Organization_User_Permission_Aggregate;
  /** fetch data from the table: "organization_user_permission" using primary key columns */
  organization_user_permission_by_pk?: Maybe<Organization_User_Permission>;
  /** fetch data from the table: "organization_user_subsidiary" */
  organization_user_subsidiary: Array<Organization_User_Subsidiary>;
  /** fetch aggregated fields from the table: "organization_user_subsidiary" */
  organization_user_subsidiary_aggregate: Organization_User_Subsidiary_Aggregate;
  /** fetch data from the table: "organization_user_subsidiary" using primary key columns */
  organization_user_subsidiary_by_pk?: Maybe<Organization_User_Subsidiary>;
  /** fetch data from the table: "organization_user_type" */
  organization_user_type: Array<Organization_User_Type>;
  /** fetch aggregated fields from the table: "organization_user_type" */
  organization_user_type_aggregate: Organization_User_Type_Aggregate;
  /** fetch data from the table: "organization_user_type" using primary key columns */
  organization_user_type_by_pk?: Maybe<Organization_User_Type>;
  /** fetch data from the table: "ownership_type" */
  ownership_type: Array<Ownership_Type>;
  /** fetch aggregated fields from the table: "ownership_type" */
  ownership_type_aggregate: Ownership_Type_Aggregate;
  /** fetch data from the table: "ownership_type" using primary key columns */
  ownership_type_by_pk?: Maybe<Ownership_Type>;
  /** fetch data from the table: "partner" */
  partner: Array<Partner>;
  /** fetch data from the table: "partner_address" */
  partner_address: Array<Partner_Address>;
  /** fetch aggregated fields from the table: "partner_address" */
  partner_address_aggregate: Partner_Address_Aggregate;
  /** fetch data from the table: "partner_address" using primary key columns */
  partner_address_by_pk?: Maybe<Partner_Address>;
  /** fetch aggregated fields from the table: "partner" */
  partner_aggregate: Partner_Aggregate;
  /** An array relationship */
  partner_bank_details: Array<Partner_Bank_Details>;
  /** An aggregate relationship */
  partner_bank_details_aggregate: Partner_Bank_Details_Aggregate;
  /** fetch data from the table: "partner_bank_details" using primary key columns */
  partner_bank_details_by_pk?: Maybe<Partner_Bank_Details>;
  /** fetch data from the table: "partner" using primary key columns */
  partner_by_pk?: Maybe<Partner>;
  /** fetch data from the table: "partner_commission" */
  partner_commission: Array<Partner_Commission>;
  /** fetch aggregated fields from the table: "partner_commission" */
  partner_commission_aggregate: Partner_Commission_Aggregate;
  /** fetch data from the table: "partner_commission" using primary key columns */
  partner_commission_by_pk?: Maybe<Partner_Commission>;
  /** fetch data from the table: "partner_commission_product_variation_type" */
  partner_commission_product_variation_type: Array<Partner_Commission_Product_Variation_Type>;
  /** fetch aggregated fields from the table: "partner_commission_product_variation_type" */
  partner_commission_product_variation_type_aggregate: Partner_Commission_Product_Variation_Type_Aggregate;
  /** fetch data from the table: "partner_commission_product_variation_type" using primary key columns */
  partner_commission_product_variation_type_by_pk?: Maybe<Partner_Commission_Product_Variation_Type>;
  /** fetch data from the table: "partner_contact_type" */
  partner_contact_type: Array<Partner_Contact_Type>;
  /** fetch aggregated fields from the table: "partner_contact_type" */
  partner_contact_type_aggregate: Partner_Contact_Type_Aggregate;
  /** fetch data from the table: "partner_contact_type" using primary key columns */
  partner_contact_type_by_pk?: Maybe<Partner_Contact_Type>;
  /** An array relationship */
  partner_localities: Array<Partner_Localities>;
  /** An aggregate relationship */
  partner_localities_aggregate: Partner_Localities_Aggregate;
  /** fetch data from the table: "partner_localities" using primary key columns */
  partner_localities_by_pk?: Maybe<Partner_Localities>;
  /** An array relationship */
  partner_localities_slots: Array<Partner_Localities_Slots>;
  /** An aggregate relationship */
  partner_localities_slots_aggregate: Partner_Localities_Slots_Aggregate;
  /** fetch data from the table: "partner_localities_slots" using primary key columns */
  partner_localities_slots_by_pk?: Maybe<Partner_Localities_Slots>;
  /** fetch data from the table: "partner_order" */
  partner_order: Array<Partner_Order>;
  /** fetch aggregated fields from the table: "partner_order" */
  partner_order_aggregate: Partner_Order_Aggregate;
  /** fetch data from the table: "partner_order" using primary key columns */
  partner_order_by_pk?: Maybe<Partner_Order>;
  /** fetch data from the table: "partner_order_customer_asset" */
  partner_order_customer_asset: Array<Partner_Order_Customer_Asset>;
  /** fetch aggregated fields from the table: "partner_order_customer_asset" */
  partner_order_customer_asset_aggregate: Partner_Order_Customer_Asset_Aggregate;
  /** fetch data from the table: "partner_order_customer_asset" using primary key columns */
  partner_order_customer_asset_by_pk?: Maybe<Partner_Order_Customer_Asset>;
  /** fetch data from the table: "partner_order_item" */
  partner_order_item: Array<Partner_Order_Item>;
  /** fetch aggregated fields from the table: "partner_order_item" */
  partner_order_item_aggregate: Partner_Order_Item_Aggregate;
  /** fetch data from the table: "partner_order_item" using primary key columns */
  partner_order_item_by_pk?: Maybe<Partner_Order_Item>;
  /** fetch data from the table: "partner_order_item_commission" */
  partner_order_item_commission: Array<Partner_Order_Item_Commission>;
  /** fetch aggregated fields from the table: "partner_order_item_commission" */
  partner_order_item_commission_aggregate: Partner_Order_Item_Commission_Aggregate;
  /** fetch data from the table: "partner_order_item_commission" using primary key columns */
  partner_order_item_commission_by_pk?: Maybe<Partner_Order_Item_Commission>;
  /** fetch data from the table: "partner_order_item_state" */
  partner_order_item_state: Array<Partner_Order_Item_State>;
  /** fetch aggregated fields from the table: "partner_order_item_state" */
  partner_order_item_state_aggregate: Partner_Order_Item_State_Aggregate;
  /** fetch data from the table: "partner_order_item_state" using primary key columns */
  partner_order_item_state_by_pk?: Maybe<Partner_Order_Item_State>;
  /** fetch data from the table: "partner_order_item_stateflow" */
  partner_order_item_stateflow: Array<Partner_Order_Item_Stateflow>;
  /** fetch aggregated fields from the table: "partner_order_item_stateflow" */
  partner_order_item_stateflow_aggregate: Partner_Order_Item_Stateflow_Aggregate;
  /** fetch data from the table: "partner_order_item_stateflow" using primary key columns */
  partner_order_item_stateflow_by_pk?: Maybe<Partner_Order_Item_Stateflow>;
  /** fetch data from the table: "partner_order_item_test_category" */
  partner_order_item_test_category: Array<Partner_Order_Item_Test_Category>;
  /** fetch aggregated fields from the table: "partner_order_item_test_category" */
  partner_order_item_test_category_aggregate: Partner_Order_Item_Test_Category_Aggregate;
  /** fetch data from the table: "partner_order_item_test_category" using primary key columns */
  partner_order_item_test_category_by_pk?: Maybe<Partner_Order_Item_Test_Category>;
  /** An array relationship */
  partner_order_item_test_results: Array<Partner_Order_Item_Test_Results>;
  /** An aggregate relationship */
  partner_order_item_test_results_aggregate: Partner_Order_Item_Test_Results_Aggregate;
  /** fetch data from the table: "partner_order_item_test_results" using primary key columns */
  partner_order_item_test_results_by_pk?: Maybe<Partner_Order_Item_Test_Results>;
  /** An array relationship */
  partner_order_item_test_results_photos: Array<Partner_Order_Item_Test_Results_Photos>;
  /** An aggregate relationship */
  partner_order_item_test_results_photos_aggregate: Partner_Order_Item_Test_Results_Photos_Aggregate;
  /** fetch data from the table: "partner_order_item_test_results_photos" using primary key columns */
  partner_order_item_test_results_photos_by_pk?: Maybe<Partner_Order_Item_Test_Results_Photos>;
  /** fetch data from the table: "partner_order_item_value" */
  partner_order_item_value: Array<Partner_Order_Item_Value>;
  /** fetch aggregated fields from the table: "partner_order_item_value" */
  partner_order_item_value_aggregate: Partner_Order_Item_Value_Aggregate;
  /** fetch data from the table: "partner_order_item_value" using primary key columns */
  partner_order_item_value_by_pk?: Maybe<Partner_Order_Item_Value>;
  /** fetch data from the table: "partner_order_partner_user_document" */
  partner_order_partner_user_document: Array<Partner_Order_Partner_User_Document>;
  /** fetch aggregated fields from the table: "partner_order_partner_user_document" */
  partner_order_partner_user_document_aggregate: Partner_Order_Partner_User_Document_Aggregate;
  /** fetch data from the table: "partner_order_partner_user_document" using primary key columns */
  partner_order_partner_user_document_by_pk?: Maybe<Partner_Order_Partner_User_Document>;
  /** fetch data from the table: "partner_order_state" */
  partner_order_state: Array<Partner_Order_State>;
  /** fetch aggregated fields from the table: "partner_order_state" */
  partner_order_state_aggregate: Partner_Order_State_Aggregate;
  /** fetch data from the table: "partner_order_state" using primary key columns */
  partner_order_state_by_pk?: Maybe<Partner_Order_State>;
  /** fetch data from the table: "partner_order_stateflow" */
  partner_order_stateflow: Array<Partner_Order_Stateflow>;
  /** fetch aggregated fields from the table: "partner_order_stateflow" */
  partner_order_stateflow_aggregate: Partner_Order_Stateflow_Aggregate;
  /** fetch data from the table: "partner_order_stateflow" using primary key columns */
  partner_order_stateflow_by_pk?: Maybe<Partner_Order_Stateflow>;
  /** fetch data from the table: "partner_payment" */
  partner_payment: Array<Partner_Payment>;
  /** fetch aggregated fields from the table: "partner_payment" */
  partner_payment_aggregate: Partner_Payment_Aggregate;
  /** fetch data from the table: "partner_payment" using primary key columns */
  partner_payment_by_pk?: Maybe<Partner_Payment>;
  /** fetch data from the table: "partner_product" */
  partner_product: Array<Partner_Product>;
  /** fetch aggregated fields from the table: "partner_product" */
  partner_product_aggregate: Partner_Product_Aggregate;
  /** fetch data from the table: "partner_product" using primary key columns */
  partner_product_by_pk?: Maybe<Partner_Product>;
  /** fetch data from the table: "partner_relationship" */
  partner_relationship: Array<Partner_Relationship>;
  /** fetch aggregated fields from the table: "partner_relationship" */
  partner_relationship_aggregate: Partner_Relationship_Aggregate;
  /** fetch data from the table: "partner_relationship" using primary key columns */
  partner_relationship_by_pk?: Maybe<Partner_Relationship>;
  /** fetch data from the table: "partner_seller" */
  partner_seller: Array<Partner_Seller>;
  /** fetch aggregated fields from the table: "partner_seller" */
  partner_seller_aggregate: Partner_Seller_Aggregate;
  /** fetch data from the table: "partner_seller" using primary key columns */
  partner_seller_by_pk?: Maybe<Partner_Seller>;
  /** fetch data from the table: "partner_seller_type" */
  partner_seller_type: Array<Partner_Seller_Type>;
  /** fetch aggregated fields from the table: "partner_seller_type" */
  partner_seller_type_aggregate: Partner_Seller_Type_Aggregate;
  /** fetch data from the table: "partner_seller_type" using primary key columns */
  partner_seller_type_by_pk?: Maybe<Partner_Seller_Type>;
  /** fetch data from the table: "partner_signing_authority" */
  partner_signing_authority: Array<Partner_Signing_Authority>;
  /** fetch aggregated fields from the table: "partner_signing_authority" */
  partner_signing_authority_aggregate: Partner_Signing_Authority_Aggregate;
  /** fetch data from the table: "partner_signing_authority" using primary key columns */
  partner_signing_authority_by_pk?: Maybe<Partner_Signing_Authority>;
  /** fetch data from the table: "partner_timing" */
  partner_timing: Array<Partner_Timing>;
  /** fetch aggregated fields from the table: "partner_timing" */
  partner_timing_aggregate: Partner_Timing_Aggregate;
  /** fetch data from the table: "partner_timing" using primary key columns */
  partner_timing_by_pk?: Maybe<Partner_Timing>;
  /** fetch data from the table: "partner_type" */
  partner_type: Array<Partner_Type>;
  /** fetch aggregated fields from the table: "partner_type" */
  partner_type_aggregate: Partner_Type_Aggregate;
  /** fetch data from the table: "partner_type" using primary key columns */
  partner_type_by_pk?: Maybe<Partner_Type>;
  /** fetch data from the table: "partner_user" */
  partner_user: Array<Partner_User>;
  /** fetch aggregated fields from the table: "partner_user" */
  partner_user_aggregate: Partner_User_Aggregate;
  /** fetch data from the table: "partner_user" using primary key columns */
  partner_user_by_pk?: Maybe<Partner_User>;
  /** fetch data from the table: "partner_user_document" */
  partner_user_document: Array<Partner_User_Document>;
  /** fetch aggregated fields from the table: "partner_user_document" */
  partner_user_document_aggregate: Partner_User_Document_Aggregate;
  /** fetch data from the table: "partner_user_document" using primary key columns */
  partner_user_document_by_pk?: Maybe<Partner_User_Document>;
  /** fetch data from the table: "partner_user_permission" */
  partner_user_permission: Array<Partner_User_Permission>;
  /** fetch aggregated fields from the table: "partner_user_permission" */
  partner_user_permission_aggregate: Partner_User_Permission_Aggregate;
  /** fetch data from the table: "partner_user_permission" using primary key columns */
  partner_user_permission_by_pk?: Maybe<Partner_User_Permission>;
  /** fetch data from the table: "partner_vehicle" */
  partner_vehicle: Array<Partner_Vehicle>;
  /** fetch aggregated fields from the table: "partner_vehicle" */
  partner_vehicle_aggregate: Partner_Vehicle_Aggregate;
  /** fetch data from the table: "partner_vehicle" using primary key columns */
  partner_vehicle_by_pk?: Maybe<Partner_Vehicle>;
  /** fetch data from the table: "partner_vehicle_state" */
  partner_vehicle_state: Array<Partner_Vehicle_State>;
  /** fetch aggregated fields from the table: "partner_vehicle_state" */
  partner_vehicle_state_aggregate: Partner_Vehicle_State_Aggregate;
  /** fetch data from the table: "partner_vehicle_state" using primary key columns */
  partner_vehicle_state_by_pk?: Maybe<Partner_Vehicle_State>;
  /** fetch data from the table: "payment_type" */
  payment_type: Array<Payment_Type>;
  /** fetch aggregated fields from the table: "payment_type" */
  payment_type_aggregate: Payment_Type_Aggregate;
  /** fetch data from the table: "payment_type" using primary key columns */
  payment_type_by_pk?: Maybe<Payment_Type>;
  /** fetch data from the table: "period_frequency" */
  period_frequency: Array<Period_Frequency>;
  /** fetch aggregated fields from the table: "period_frequency" */
  period_frequency_aggregate: Period_Frequency_Aggregate;
  /** fetch data from the table: "period_frequency" using primary key columns */
  period_frequency_by_pk?: Maybe<Period_Frequency>;
  /** fetch data from the table: "permission" */
  permission: Array<Permission>;
  /** fetch aggregated fields from the table: "permission" */
  permission_aggregate: Permission_Aggregate;
  /** fetch data from the table: "permission" using primary key columns */
  permission_by_pk?: Maybe<Permission>;
  /** fetch data from the table: "permit" */
  permit: Array<Permit>;
  /** fetch aggregated fields from the table: "permit" */
  permit_aggregate: Permit_Aggregate;
  /** fetch data from the table: "permit" using primary key columns */
  permit_by_pk?: Maybe<Permit>;
  /** fetch data from the table: "photo_type" */
  photo_type: Array<Photo_Type>;
  /** fetch aggregated fields from the table: "photo_type" */
  photo_type_aggregate: Photo_Type_Aggregate;
  /** fetch data from the table: "photo_type" using primary key columns */
  photo_type_by_pk?: Maybe<Photo_Type>;
  /** fetch data from the table: "planning_audit_log" */
  planning_audit_log: Array<Planning_Audit_Log>;
  /** fetch aggregated fields from the table: "planning_audit_log" */
  planning_audit_log_aggregate: Planning_Audit_Log_Aggregate;
  /** fetch data from the table: "planning_audit_log" using primary key columns */
  planning_audit_log_by_pk?: Maybe<Planning_Audit_Log>;
  /** fetch data from the table: "planning_period" */
  planning_period: Array<Planning_Period>;
  /** fetch aggregated fields from the table: "planning_period" */
  planning_period_aggregate: Planning_Period_Aggregate;
  /** fetch data from the table: "planning_period" using primary key columns */
  planning_period_by_pk?: Maybe<Planning_Period>;
  /** fetch data from the table: "product" */
  product: Array<Product>;
  /** fetch aggregated fields from the table: "product" */
  product_aggregate: Product_Aggregate;
  /** fetch data from the table: "product" using primary key columns */
  product_by_pk?: Maybe<Product>;
  /** fetch data from the table: "product_commission" */
  product_commission: Array<Product_Commission>;
  /** fetch aggregated fields from the table: "product_commission" */
  product_commission_aggregate: Product_Commission_Aggregate;
  /** fetch data from the table: "product_commission" using primary key columns */
  product_commission_by_pk?: Maybe<Product_Commission>;
  /** fetch data from the table: "product_document" */
  product_document: Array<Product_Document>;
  /** fetch aggregated fields from the table: "product_document" */
  product_document_aggregate: Product_Document_Aggregate;
  /** fetch data from the table: "product_document" using primary key columns */
  product_document_by_pk?: Maybe<Product_Document>;
  /** fetch data from the table: "product_partner_localities_price" */
  product_partner_localities_price: Array<Product_Partner_Localities_Price>;
  /** fetch aggregated fields from the table: "product_partner_localities_price" */
  product_partner_localities_price_aggregate: Product_Partner_Localities_Price_Aggregate;
  /** fetch data from the table: "product_partner_localities_price" using primary key columns */
  product_partner_localities_price_by_pk?: Maybe<Product_Partner_Localities_Price>;
  /** fetch data from the table: "product_partner_localities_price_history" */
  product_partner_localities_price_history: Array<Product_Partner_Localities_Price_History>;
  /** fetch aggregated fields from the table: "product_partner_localities_price_history" */
  product_partner_localities_price_history_aggregate: Product_Partner_Localities_Price_History_Aggregate;
  /** fetch data from the table: "product_partner_localities_price_history" using primary key columns */
  product_partner_localities_price_history_by_pk?: Maybe<Product_Partner_Localities_Price_History>;
  /** An array relationship */
  product_photos: Array<Product_Photos>;
  /** An aggregate relationship */
  product_photos_aggregate: Product_Photos_Aggregate;
  /** fetch data from the table: "product_photos" using primary key columns */
  product_photos_by_pk?: Maybe<Product_Photos>;
  /** fetch data from the table: "product_type" */
  product_type: Array<Product_Type>;
  /** fetch aggregated fields from the table: "product_type" */
  product_type_aggregate: Product_Type_Aggregate;
  /** fetch data from the table: "product_type" using primary key columns */
  product_type_by_pk?: Maybe<Product_Type>;
  /** fetch data from the table: "product_variation" */
  product_variation: Array<Product_Variation>;
  /** fetch aggregated fields from the table: "product_variation" */
  product_variation_aggregate: Product_Variation_Aggregate;
  /** fetch data from the table: "product_variation" using primary key columns */
  product_variation_by_pk?: Maybe<Product_Variation>;
  /** An array relationship */
  product_variation_partner_localities_slots: Array<Product_Variation_Partner_Localities_Slots>;
  /** An aggregate relationship */
  product_variation_partner_localities_slots_aggregate: Product_Variation_Partner_Localities_Slots_Aggregate;
  /** fetch data from the table: "product_variation_partner_localities_slots" using primary key columns */
  product_variation_partner_localities_slots_by_pk?: Maybe<Product_Variation_Partner_Localities_Slots>;
  /** An array relationship */
  product_variation_photos: Array<Product_Variation_Photos>;
  /** An aggregate relationship */
  product_variation_photos_aggregate: Product_Variation_Photos_Aggregate;
  /** fetch data from the table: "product_variation_photos" using primary key columns */
  product_variation_photos_by_pk?: Maybe<Product_Variation_Photos>;
  /** fetch data from the table: "product_variation_safety_checklist_category" */
  product_variation_safety_checklist_category: Array<Product_Variation_Safety_Checklist_Category>;
  /** fetch aggregated fields from the table: "product_variation_safety_checklist_category" */
  product_variation_safety_checklist_category_aggregate: Product_Variation_Safety_Checklist_Category_Aggregate;
  /** fetch data from the table: "product_variation_safety_checklist_category" using primary key columns */
  product_variation_safety_checklist_category_by_pk?: Maybe<Product_Variation_Safety_Checklist_Category>;
  /** fetch data from the table: "product_variation_test_category" */
  product_variation_test_category: Array<Product_Variation_Test_Category>;
  /** fetch aggregated fields from the table: "product_variation_test_category" */
  product_variation_test_category_aggregate: Product_Variation_Test_Category_Aggregate;
  /** fetch data from the table: "product_variation_test_category" using primary key columns */
  product_variation_test_category_by_pk?: Maybe<Product_Variation_Test_Category>;
  /** fetch data from the table: "purchase_order" */
  purchase_order: Array<Purchase_Order>;
  /** fetch aggregated fields from the table: "purchase_order" */
  purchase_order_aggregate: Purchase_Order_Aggregate;
  /** fetch data from the table: "purchase_order" using primary key columns */
  purchase_order_by_pk?: Maybe<Purchase_Order>;
  /** An array relationship */
  purchase_order_items: Array<Purchase_Order_Items>;
  /** An aggregate relationship */
  purchase_order_items_aggregate: Purchase_Order_Items_Aggregate;
  /** fetch data from the table: "purchase_order_items" using primary key columns */
  purchase_order_items_by_pk?: Maybe<Purchase_Order_Items>;
  /** fetch data from the table: "quantity_correction_ticket_states" */
  quantity_correction_ticket_states: Array<Quantity_Correction_Ticket_States>;
  /** fetch aggregated fields from the table: "quantity_correction_ticket_states" */
  quantity_correction_ticket_states_aggregate: Quantity_Correction_Ticket_States_Aggregate;
  /** fetch data from the table: "quantity_correction_ticket_states" using primary key columns */
  quantity_correction_ticket_states_by_pk?: Maybe<Quantity_Correction_Ticket_States>;
  /** An array relationship */
  quantity_correction_tickets: Array<Quantity_Correction_Tickets>;
  /** An aggregate relationship */
  quantity_correction_tickets_aggregate: Quantity_Correction_Tickets_Aggregate;
  /** fetch data from the table: "quantity_correction_tickets" using primary key columns */
  quantity_correction_tickets_by_pk?: Maybe<Quantity_Correction_Tickets>;
  /** fetch data from the table: "reason_type" */
  reason_type: Array<Reason_Type>;
  /** fetch aggregated fields from the table: "reason_type" */
  reason_type_aggregate: Reason_Type_Aggregate;
  /** fetch data from the table: "reason_type" using primary key columns */
  reason_type_by_pk?: Maybe<Reason_Type>;
  /** An array relationship */
  reasons: Array<Reasons>;
  /** An aggregate relationship */
  reasons_aggregate: Reasons_Aggregate;
  /** fetch data from the table: "reasons" using primary key columns */
  reasons_by_pk?: Maybe<Reasons>;
  /** fetch data from the table: "role" */
  role: Array<Role>;
  /** fetch aggregated fields from the table: "role" */
  role_aggregate: Role_Aggregate;
  /** fetch data from the table: "role" using primary key columns */
  role_by_pk?: Maybe<Role>;
  /** fetch data from the table: "role_document" */
  role_document: Array<Role_Document>;
  /** fetch aggregated fields from the table: "role_document" */
  role_document_aggregate: Role_Document_Aggregate;
  /** fetch data from the table: "role_document" using primary key columns */
  role_document_by_pk?: Maybe<Role_Document>;
  /** fetch data from the table: "safety_checklist" */
  safety_checklist: Array<Safety_Checklist>;
  /** fetch aggregated fields from the table: "safety_checklist" */
  safety_checklist_aggregate: Safety_Checklist_Aggregate;
  /** fetch data from the table: "safety_checklist" using primary key columns */
  safety_checklist_by_pk?: Maybe<Safety_Checklist>;
  /** fetch data from the table: "safety_checklist_category" */
  safety_checklist_category: Array<Safety_Checklist_Category>;
  /** fetch aggregated fields from the table: "safety_checklist_category" */
  safety_checklist_category_aggregate: Safety_Checklist_Category_Aggregate;
  /** fetch data from the table: "safety_checklist_category" using primary key columns */
  safety_checklist_category_by_pk?: Maybe<Safety_Checklist_Category>;
  /** fetch data from the table: "script_type" */
  script_type: Array<Script_Type>;
  /** fetch aggregated fields from the table: "script_type" */
  script_type_aggregate: Script_Type_Aggregate;
  /** fetch data from the table: "script_type" using primary key columns */
  script_type_by_pk?: Maybe<Script_Type>;
  /** An array relationship */
  scripts: Array<Scripts>;
  /** An aggregate relationship */
  scripts_aggregate: Scripts_Aggregate;
  /** fetch data from the table: "scripts" using primary key columns */
  scripts_by_pk?: Maybe<Scripts>;
  /** fetch data from the table: "services" */
  services: Array<Services>;
  /** fetch aggregated fields from the table: "services" */
  services_aggregate: Services_Aggregate;
  /** fetch data from the table: "services" using primary key columns */
  services_by_pk?: Maybe<Services>;
  /** fetch data from the table: "services_category" */
  services_category: Array<Services_Category>;
  /** fetch aggregated fields from the table: "services_category" */
  services_category_aggregate: Services_Category_Aggregate;
  /** fetch data from the table: "services_category" using primary key columns */
  services_category_by_pk?: Maybe<Services_Category>;
  /** fetch data from the table: "shift_schedule" */
  shift_schedule: Array<Shift_Schedule>;
  /** fetch aggregated fields from the table: "shift_schedule" */
  shift_schedule_aggregate: Shift_Schedule_Aggregate;
  /** fetch data from the table: "shift_schedule" using primary key columns */
  shift_schedule_by_pk?: Maybe<Shift_Schedule>;
  /** fetch data from the table: "shift_schedule_dispenser" */
  shift_schedule_dispenser: Array<Shift_Schedule_Dispenser>;
  /** fetch aggregated fields from the table: "shift_schedule_dispenser" */
  shift_schedule_dispenser_aggregate: Shift_Schedule_Dispenser_Aggregate;
  /** fetch data from the table: "shift_schedule_dispenser" using primary key columns */
  shift_schedule_dispenser_by_pk?: Maybe<Shift_Schedule_Dispenser>;
  /** fetch data from the table: "shift_template" */
  shift_template: Array<Shift_Template>;
  /** fetch aggregated fields from the table: "shift_template" */
  shift_template_aggregate: Shift_Template_Aggregate;
  /** fetch data from the table: "shift_template" using primary key columns */
  shift_template_by_pk?: Maybe<Shift_Template>;
  /** fetch data from the table: "slab_type" */
  slab_type: Array<Slab_Type>;
  /** fetch aggregated fields from the table: "slab_type" */
  slab_type_aggregate: Slab_Type_Aggregate;
  /** fetch data from the table: "slab_type" using primary key columns */
  slab_type_by_pk?: Maybe<Slab_Type>;
  /** fetch data from the table: "source_type" */
  source_type: Array<Source_Type>;
  /** fetch aggregated fields from the table: "source_type" */
  source_type_aggregate: Source_Type_Aggregate;
  /** fetch data from the table: "source_type" using primary key columns */
  source_type_by_pk?: Maybe<Source_Type>;
  /** fetch data from the table: "spatial_ref_sys" */
  spatial_ref_sys: Array<Spatial_Ref_Sys>;
  /** fetch aggregated fields from the table: "spatial_ref_sys" */
  spatial_ref_sys_aggregate: Spatial_Ref_Sys_Aggregate;
  /** fetch data from the table: "spatial_ref_sys" using primary key columns */
  spatial_ref_sys_by_pk?: Maybe<Spatial_Ref_Sys>;
  /** fetch data from the table: "state" */
  state: Array<State>;
  /** fetch aggregated fields from the table: "state" */
  state_aggregate: State_Aggregate;
  /** fetch data from the table: "state" using primary key columns */
  state_by_pk?: Maybe<State>;
  /** fetch data from the table: "subsidiary" */
  subsidiary: Array<Subsidiary>;
  /** fetch aggregated fields from the table: "subsidiary" */
  subsidiary_aggregate: Subsidiary_Aggregate;
  /** fetch data from the table: "subsidiary" using primary key columns */
  subsidiary_by_pk?: Maybe<Subsidiary>;
  /** An array relationship */
  support_tickets: Array<Support_Tickets>;
  /** An aggregate relationship */
  support_tickets_aggregate: Support_Tickets_Aggregate;
  /** fetch data from the table: "support_tickets" using primary key columns */
  support_tickets_by_pk?: Maybe<Support_Tickets>;
  /** fetch data from the table: "support_tickets_category" */
  support_tickets_category: Array<Support_Tickets_Category>;
  /** fetch aggregated fields from the table: "support_tickets_category" */
  support_tickets_category_aggregate: Support_Tickets_Category_Aggregate;
  /** fetch data from the table: "support_tickets_category" using primary key columns */
  support_tickets_category_by_pk?: Maybe<Support_Tickets_Category>;
  /** An array relationship */
  support_tickets_photos: Array<Support_Tickets_Photos>;
  /** An aggregate relationship */
  support_tickets_photos_aggregate: Support_Tickets_Photos_Aggregate;
  /** fetch data from the table: "support_tickets_photos" using primary key columns */
  support_tickets_photos_by_pk?: Maybe<Support_Tickets_Photos>;
  /** fetch data from the table: "tag" */
  tag: Array<Tag>;
  /** fetch aggregated fields from the table: "tag" */
  tag_aggregate: Tag_Aggregate;
  /** fetch data from the table: "tag" using primary key columns */
  tag_by_pk?: Maybe<Tag>;
  /** fetch data from the table: "tank_type" */
  tank_type: Array<Tank_Type>;
  /** fetch aggregated fields from the table: "tank_type" */
  tank_type_aggregate: Tank_Type_Aggregate;
  /** fetch data from the table: "tank_type" using primary key columns */
  tank_type_by_pk?: Maybe<Tank_Type>;
  /** fetch data from the table: "task" */
  task: Array<Task>;
  /** fetch data from the table: "task_action_instruction" */
  task_action_instruction: Array<Task_Action_Instruction>;
  /** fetch aggregated fields from the table: "task_action_instruction" */
  task_action_instruction_aggregate: Task_Action_Instruction_Aggregate;
  /** fetch data from the table: "task_action_instruction" using primary key columns */
  task_action_instruction_by_pk?: Maybe<Task_Action_Instruction>;
  /** fetch data from the table: "task_action_type" */
  task_action_type: Array<Task_Action_Type>;
  /** fetch aggregated fields from the table: "task_action_type" */
  task_action_type_aggregate: Task_Action_Type_Aggregate;
  /** fetch data from the table: "task_action_type" using primary key columns */
  task_action_type_by_pk?: Maybe<Task_Action_Type>;
  /** fetch aggregated fields from the table: "task" */
  task_aggregate: Task_Aggregate;
  /** fetch data from the table: "task" using primary key columns */
  task_by_pk?: Maybe<Task>;
  /** An array relationship */
  task_cancellation_reasons: Array<Task_Cancellation_Reasons>;
  /** An aggregate relationship */
  task_cancellation_reasons_aggregate: Task_Cancellation_Reasons_Aggregate;
  /** fetch data from the table: "task_cancellation_reasons" using primary key columns */
  task_cancellation_reasons_by_pk?: Maybe<Task_Cancellation_Reasons>;
  /** fetch data from the table: "task_state" */
  task_state: Array<Task_State>;
  /** fetch aggregated fields from the table: "task_state" */
  task_state_aggregate: Task_State_Aggregate;
  /** fetch data from the table: "task_state" using primary key columns */
  task_state_by_pk?: Maybe<Task_State>;
  /** fetch data from the table: "task_states_flow" */
  task_states_flow: Array<Task_States_Flow>;
  /** fetch aggregated fields from the table: "task_states_flow" */
  task_states_flow_aggregate: Task_States_Flow_Aggregate;
  /** fetch data from the table: "task_states_flow" using primary key columns */
  task_states_flow_by_pk?: Maybe<Task_States_Flow>;
  /** fetch data from the table: "task_type" */
  task_type: Array<Task_Type>;
  /** fetch aggregated fields from the table: "task_type" */
  task_type_aggregate: Task_Type_Aggregate;
  /** fetch data from the table: "task_type" using primary key columns */
  task_type_by_pk?: Maybe<Task_Type>;
  /** fetch data from the table: "task_value" */
  task_value: Array<Task_Value>;
  /** fetch aggregated fields from the table: "task_value" */
  task_value_aggregate: Task_Value_Aggregate;
  /** fetch data from the table: "task_value" using primary key columns */
  task_value_by_pk?: Maybe<Task_Value>;
  /** fetch data from the table: "test" */
  test: Array<Test>;
  /** fetch aggregated fields from the table: "test" */
  test_aggregate: Test_Aggregate;
  /** fetch data from the table: "test" using primary key columns */
  test_by_pk?: Maybe<Test>;
  /** fetch data from the table: "test_category" */
  test_category: Array<Test_Category>;
  /** fetch aggregated fields from the table: "test_category" */
  test_category_aggregate: Test_Category_Aggregate;
  /** fetch data from the table: "test_category" using primary key columns */
  test_category_by_pk?: Maybe<Test_Category>;
  /** fetch data from the table: "ticket_state" */
  ticket_state: Array<Ticket_State>;
  /** fetch aggregated fields from the table: "ticket_state" */
  ticket_state_aggregate: Ticket_State_Aggregate;
  /** fetch data from the table: "ticket_state" using primary key columns */
  ticket_state_by_pk?: Maybe<Ticket_State>;
  /** fetch data from the table: "ticket_type" */
  ticket_type: Array<Ticket_Type>;
  /** fetch aggregated fields from the table: "ticket_type" */
  ticket_type_aggregate: Ticket_Type_Aggregate;
  /** fetch data from the table: "ticket_type" using primary key columns */
  ticket_type_by_pk?: Maybe<Ticket_Type>;
  /** An array relationship */
  tickets: Array<Tickets>;
  /** An aggregate relationship */
  tickets_aggregate: Tickets_Aggregate;
  /** fetch data from the table: "tickets" using primary key columns */
  tickets_by_pk?: Maybe<Tickets>;
  /** fetch data from the table: "totalizer_correction_ticket_states" */
  totalizer_correction_ticket_states: Array<Totalizer_Correction_Ticket_States>;
  /** fetch aggregated fields from the table: "totalizer_correction_ticket_states" */
  totalizer_correction_ticket_states_aggregate: Totalizer_Correction_Ticket_States_Aggregate;
  /** fetch data from the table: "totalizer_correction_ticket_states" using primary key columns */
  totalizer_correction_ticket_states_by_pk?: Maybe<Totalizer_Correction_Ticket_States>;
  /** An array relationship */
  totalizer_correction_tickets: Array<Totalizer_Correction_Tickets>;
  /** An aggregate relationship */
  totalizer_correction_tickets_aggregate: Totalizer_Correction_Tickets_Aggregate;
  /** fetch data from the table: "totalizer_correction_tickets" using primary key columns */
  totalizer_correction_tickets_by_pk?: Maybe<Totalizer_Correction_Tickets>;
  /** fetch data from the table: "transaction_type" */
  transaction_type: Array<Transaction_Type>;
  /** fetch aggregated fields from the table: "transaction_type" */
  transaction_type_aggregate: Transaction_Type_Aggregate;
  /** fetch data from the table: "transaction_type" using primary key columns */
  transaction_type_by_pk?: Maybe<Transaction_Type>;
  /** fetch data from the table: "trip" */
  trip: Array<Trip>;
  /** fetch aggregated fields from the table: "trip" */
  trip_aggregate: Trip_Aggregate;
  /** fetch data from the table: "trip" using primary key columns */
  trip_by_pk?: Maybe<Trip>;
  /** fetch data from the table: "trip_location" */
  trip_location: Array<Trip_Location>;
  /** fetch aggregated fields from the table: "trip_location" */
  trip_location_aggregate: Trip_Location_Aggregate;
  /** fetch data from the table: "trip_location" using primary key columns */
  trip_location_by_pk?: Maybe<Trip_Location>;
  /** fetch data from the table: "trip_plan" */
  trip_plan: Array<Trip_Plan>;
  /** fetch aggregated fields from the table: "trip_plan" */
  trip_plan_aggregate: Trip_Plan_Aggregate;
  /** fetch data from the table: "trip_plan" using primary key columns */
  trip_plan_by_pk?: Maybe<Trip_Plan>;
  /** fetch data from the table: "unit_of_measure" */
  unit_of_measure: Array<Unit_Of_Measure>;
  /** fetch aggregated fields from the table: "unit_of_measure" */
  unit_of_measure_aggregate: Unit_Of_Measure_Aggregate;
  /** fetch data from the table: "unit_of_measure" using primary key columns */
  unit_of_measure_by_pk?: Maybe<Unit_Of_Measure>;
  /** fetch data from the table: "unit_of_measure_meta" */
  unit_of_measure_meta: Array<Unit_Of_Measure_Meta>;
  /** fetch aggregated fields from the table: "unit_of_measure_meta" */
  unit_of_measure_meta_aggregate: Unit_Of_Measure_Meta_Aggregate;
  /** fetch data from the table: "unit_of_measure_meta" using primary key columns */
  unit_of_measure_meta_by_pk?: Maybe<Unit_Of_Measure_Meta>;
  /** fetch data from the table: "uom_conversion" */
  uom_conversion: Array<Uom_Conversion>;
  /** fetch aggregated fields from the table: "uom_conversion" */
  uom_conversion_aggregate: Uom_Conversion_Aggregate;
  /** fetch data from the table: "uom_conversion" using primary key columns */
  uom_conversion_by_pk?: Maybe<Uom_Conversion>;
  /** fetch data from the table: "user" */
  user: Array<User>;
  /** fetch data from the table: "user_access_audit_log" */
  user_access_audit_log: Array<User_Access_Audit_Log>;
  /** fetch aggregated fields from the table: "user_access_audit_log" */
  user_access_audit_log_aggregate: User_Access_Audit_Log_Aggregate;
  /** fetch data from the table: "user_access_audit_log" using primary key columns */
  user_access_audit_log_by_pk?: Maybe<User_Access_Audit_Log>;
  /** fetch aggregated fields from the table: "user" */
  user_aggregate: User_Aggregate;
  /** fetch data from the table: "user" using primary key columns */
  user_by_pk?: Maybe<User>;
  /** fetch data from the table: "user_ledger" */
  user_ledger: Array<User_Ledger>;
  /** fetch aggregated fields from the table: "user_ledger" */
  user_ledger_aggregate: User_Ledger_Aggregate;
  /** fetch data from the table: "user_ledger" using primary key columns */
  user_ledger_by_pk?: Maybe<User_Ledger>;
  /** fetch data from the table: "user_partner_type" */
  user_partner_type: Array<User_Partner_Type>;
  /** fetch aggregated fields from the table: "user_partner_type" */
  user_partner_type_aggregate: User_Partner_Type_Aggregate;
  /** fetch data from the table: "user_partner_type" using primary key columns */
  user_partner_type_by_pk?: Maybe<User_Partner_Type>;
  /** fetch data from the table: "user_referral" */
  user_referral: Array<User_Referral>;
  /** fetch aggregated fields from the table: "user_referral" */
  user_referral_aggregate: User_Referral_Aggregate;
  /** fetch data from the table: "user_referral" using primary key columns */
  user_referral_by_pk?: Maybe<User_Referral>;
  /** fetch data from the table: "user_role" */
  user_role: Array<User_Role>;
  /** fetch aggregated fields from the table: "user_role" */
  user_role_aggregate: User_Role_Aggregate;
  /** fetch data from the table: "user_role" using primary key columns */
  user_role_by_pk?: Maybe<User_Role>;
  /** Check if proposed slot times conflict with existing slots for the same vehicle */
  validateSlotOverlap?: Maybe<ValidateSlotOverlapOutput>;
  /** An array relationship */
  validation_workflows: Array<Validation_Workflows>;
  /** An aggregate relationship */
  validation_workflows_aggregate: Validation_Workflows_Aggregate;
  /** fetch data from the table: "validation_workflows" using primary key columns */
  validation_workflows_by_pk?: Maybe<Validation_Workflows>;
  /** fetch data from the table: "variation" */
  variation: Array<Variation>;
  /** fetch aggregated fields from the table: "variation" */
  variation_aggregate: Variation_Aggregate;
  /** fetch data from the table: "variation" using primary key columns */
  variation_by_pk?: Maybe<Variation>;
  /** fetch data from the table: "variation_type" */
  variation_type: Array<Variation_Type>;
  /** fetch aggregated fields from the table: "variation_type" */
  variation_type_aggregate: Variation_Type_Aggregate;
  /** fetch data from the table: "variation_type" using primary key columns */
  variation_type_by_pk?: Maybe<Variation_Type>;
  /** fetch data from the table: "vehicle" */
  vehicle: Array<Vehicle>;
  /** fetch aggregated fields from the table: "vehicle" */
  vehicle_aggregate: Vehicle_Aggregate;
  /** fetch data from the table: "vehicle" using primary key columns */
  vehicle_by_pk?: Maybe<Vehicle>;
  /** fetch data from the table: "vehicle_configuration" */
  vehicle_configuration: Array<Vehicle_Configuration>;
  /** fetch aggregated fields from the table: "vehicle_configuration" */
  vehicle_configuration_aggregate: Vehicle_Configuration_Aggregate;
  /** fetch data from the table: "vehicle_configuration" using primary key columns */
  vehicle_configuration_by_pk?: Maybe<Vehicle_Configuration>;
  /** fetch data from the table: "vehicle_device" */
  vehicle_device: Array<Vehicle_Device>;
  /** fetch aggregated fields from the table: "vehicle_device" */
  vehicle_device_aggregate: Vehicle_Device_Aggregate;
  /** fetch data from the table: "vehicle_device" using primary key columns */
  vehicle_device_by_pk?: Maybe<Vehicle_Device>;
  /** fetch data from the table: "vehicle_device_calibration" */
  vehicle_device_calibration: Array<Vehicle_Device_Calibration>;
  /** fetch aggregated fields from the table: "vehicle_device_calibration" */
  vehicle_device_calibration_aggregate: Vehicle_Device_Calibration_Aggregate;
  /** fetch data from the table: "vehicle_device_calibration" using primary key columns */
  vehicle_device_calibration_by_pk?: Maybe<Vehicle_Device_Calibration>;
  /** An array relationship */
  vehicle_inventory_transaction_logs: Array<Vehicle_Inventory_Transaction_Logs>;
  /** An aggregate relationship */
  vehicle_inventory_transaction_logs_aggregate: Vehicle_Inventory_Transaction_Logs_Aggregate;
  /** fetch data from the table: "vehicle_inventory_transaction_logs" using primary key columns */
  vehicle_inventory_transaction_logs_by_pk?: Maybe<Vehicle_Inventory_Transaction_Logs>;
  /** An array relationship */
  vehicle_localities: Array<Vehicle_Localities>;
  /** An aggregate relationship */
  vehicle_localities_aggregate: Vehicle_Localities_Aggregate;
  /** fetch data from the table: "vehicle_localities" using primary key columns */
  vehicle_localities_by_pk?: Maybe<Vehicle_Localities>;
  /** fetch data from the table: "vehicle_permit" */
  vehicle_permit: Array<Vehicle_Permit>;
  /** fetch aggregated fields from the table: "vehicle_permit" */
  vehicle_permit_aggregate: Vehicle_Permit_Aggregate;
  /** fetch data from the table: "vehicle_permit" using primary key columns */
  vehicle_permit_by_pk?: Maybe<Vehicle_Permit>;
  /** fetch data from the table: "vehicle_shift_template" */
  vehicle_shift_template: Array<Vehicle_Shift_Template>;
  /** fetch aggregated fields from the table: "vehicle_shift_template" */
  vehicle_shift_template_aggregate: Vehicle_Shift_Template_Aggregate;
  /** fetch data from the table: "vehicle_shift_template" using primary key columns */
  vehicle_shift_template_by_pk?: Maybe<Vehicle_Shift_Template>;
  /** fetch data from the table: "vehicle_status" */
  vehicle_status: Array<Vehicle_Status>;
  /** fetch aggregated fields from the table: "vehicle_status" */
  vehicle_status_aggregate: Vehicle_Status_Aggregate;
  /** fetch data from the table: "vehicle_status" using primary key columns */
  vehicle_status_by_pk?: Maybe<Vehicle_Status>;
  /** An array relationship */
  vehicle_status_logs: Array<Vehicle_Status_Logs>;
  /** An aggregate relationship */
  vehicle_status_logs_aggregate: Vehicle_Status_Logs_Aggregate;
  /** fetch data from the table: "vehicle_status_logs" using primary key columns */
  vehicle_status_logs_by_pk?: Maybe<Vehicle_Status_Logs>;
  /** fetch data from the table: "vehicle_tank_type" */
  vehicle_tank_type: Array<Vehicle_Tank_Type>;
  /** fetch aggregated fields from the table: "vehicle_tank_type" */
  vehicle_tank_type_aggregate: Vehicle_Tank_Type_Aggregate;
  /** fetch data from the table: "vehicle_tank_type" using primary key columns */
  vehicle_tank_type_by_pk?: Maybe<Vehicle_Tank_Type>;
  /** fetch data from the table: "vehicle_tank_type_product_variation" */
  vehicle_tank_type_product_variation: Array<Vehicle_Tank_Type_Product_Variation>;
  /** fetch aggregated fields from the table: "vehicle_tank_type_product_variation" */
  vehicle_tank_type_product_variation_aggregate: Vehicle_Tank_Type_Product_Variation_Aggregate;
  /** fetch data from the table: "vehicle_tank_type_product_variation" using primary key columns */
  vehicle_tank_type_product_variation_by_pk?: Maybe<Vehicle_Tank_Type_Product_Variation>;
  /** fetch data from the table: "vehicle_type" */
  vehicle_type: Array<Vehicle_Type>;
  /** fetch aggregated fields from the table: "vehicle_type" */
  vehicle_type_aggregate: Vehicle_Type_Aggregate;
  /** fetch data from the table: "vehicle_type" using primary key columns */
  vehicle_type_by_pk?: Maybe<Vehicle_Type>;
  /** An array relationship */
  vendor_order_logs: Array<Vendor_Order_Logs>;
  /** An aggregate relationship */
  vendor_order_logs_aggregate: Vendor_Order_Logs_Aggregate;
  /** fetch data from the table: "vendor_order_logs" using primary key columns */
  vendor_order_logs_by_pk?: Maybe<Vendor_Order_Logs>;
  /** fetch data from the table: "vendor_sync_status" */
  vendor_sync_status: Array<Vendor_Sync_Status>;
  /** fetch aggregated fields from the table: "vendor_sync_status" */
  vendor_sync_status_aggregate: Vendor_Sync_Status_Aggregate;
  /** fetch data from the table: "vendor_sync_status" using primary key columns */
  vendor_sync_status_by_pk?: Maybe<Vendor_Sync_Status>;
  /** An array relationship */
  view_daily_asset_limit: Array<View_Daily_Asset_Limit>;
  /** An aggregate relationship */
  view_daily_asset_limit_aggregate: View_Daily_Asset_Limit_Aggregate;
  /** An array relationship */
  view_monthly_asset_limit: Array<View_Monthly_Asset_Limit>;
  /** An aggregate relationship */
  view_monthly_asset_limit_aggregate: View_Monthly_Asset_Limit_Aggregate;
  /** fetch data from the table: "view_unlinked_customer_assets" */
  view_unlinked_customer_assets: Array<View_Unlinked_Customer_Assets>;
  /** fetch aggregated fields from the table: "view_unlinked_customer_assets" */
  view_unlinked_customer_assets_aggregate: View_Unlinked_Customer_Assets_Aggregate;
  /** An array relationship */
  view_weekly_asset_limit: Array<View_Weekly_Asset_Limit>;
  /** An aggregate relationship */
  view_weekly_asset_limit_aggregate: View_Weekly_Asset_Limit_Aggregate;
  /** fetch data from the table: "voucher" */
  voucher: Array<Voucher>;
  /** fetch aggregated fields from the table: "voucher" */
  voucher_aggregate: Voucher_Aggregate;
  /** fetch data from the table: "voucher" using primary key columns */
  voucher_by_pk?: Maybe<Voucher>;
  /** fetch data from the table: "wallet" */
  wallet: Array<Wallet>;
  /** fetch aggregated fields from the table: "wallet" */
  wallet_aggregate: Wallet_Aggregate;
  /** fetch data from the table: "wallet" using primary key columns */
  wallet_by_pk?: Maybe<Wallet>;
  /** fetch data from the table: "wallet_exception" */
  wallet_exception: Array<Wallet_Exception>;
  /** fetch aggregated fields from the table: "wallet_exception" */
  wallet_exception_aggregate: Wallet_Exception_Aggregate;
  /** fetch data from the table: "wallet_exception" using primary key columns */
  wallet_exception_by_pk?: Maybe<Wallet_Exception>;
  /** fetch data from the table: "wallet_ledger" */
  wallet_ledger: Array<Wallet_Ledger>;
  /** fetch aggregated fields from the table: "wallet_ledger" */
  wallet_ledger_aggregate: Wallet_Ledger_Aggregate;
  /** fetch data from the table: "wallet_ledger" using primary key columns */
  wallet_ledger_by_pk?: Maybe<Wallet_Ledger>;
  /** fetch data from the table: "wallet_state" */
  wallet_state: Array<Wallet_State>;
  /** fetch aggregated fields from the table: "wallet_state" */
  wallet_state_aggregate: Wallet_State_Aggregate;
  /** fetch data from the table: "wallet_state" using primary key columns */
  wallet_state_by_pk?: Maybe<Wallet_State>;
  /** An array relationship */
  wallet_transactions: Array<Wallet_Transactions>;
  /** An aggregate relationship */
  wallet_transactions_aggregate: Wallet_Transactions_Aggregate;
  /** fetch data from the table: "wallet_transactions" using primary key columns */
  wallet_transactions_by_pk?: Maybe<Wallet_Transactions>;
};


export type Query_RootSmartRefueler_DispencerLocationArgs = {
  distinct_on?: InputMaybe<Array<SmartRefueler_DispencerLocation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SmartRefueler_DispencerLocation_Order_By>>;
  where?: InputMaybe<SmartRefueler_DispencerLocation_Bool_Exp>;
};


export type Query_RootSmartRefueler_DispencerLocation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SmartRefueler_DispencerLocation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SmartRefueler_DispencerLocation_Order_By>>;
  where?: InputMaybe<SmartRefueler_DispencerLocation_Bool_Exp>;
};


export type Query_RootAddress_SubsidiaryArgs = {
  distinct_on?: InputMaybe<Array<Address_Subsidiary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Address_Subsidiary_Order_By>>;
  where?: InputMaybe<Address_Subsidiary_Bool_Exp>;
};


export type Query_RootAddress_Subsidiary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Subsidiary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Address_Subsidiary_Order_By>>;
  where?: InputMaybe<Address_Subsidiary_Bool_Exp>;
};


export type Query_RootAddress_Subsidiary_Audit_LogsArgs = {
  distinct_on?: InputMaybe<Array<Address_Subsidiary_Audit_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Address_Subsidiary_Audit_Logs_Order_By>>;
  where?: InputMaybe<Address_Subsidiary_Audit_Logs_Bool_Exp>;
};


export type Query_RootAddress_Subsidiary_Audit_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Subsidiary_Audit_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Address_Subsidiary_Audit_Logs_Order_By>>;
  where?: InputMaybe<Address_Subsidiary_Audit_Logs_Bool_Exp>;
};


export type Query_RootAddress_Subsidiary_Audit_Logs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAddress_Subsidiary_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAddress_TypeArgs = {
  distinct_on?: InputMaybe<Array<Address_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Address_Type_Order_By>>;
  where?: InputMaybe<Address_Type_Bool_Exp>;
};


export type Query_RootAddress_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Address_Type_Order_By>>;
  where?: InputMaybe<Address_Type_Bool_Exp>;
};


export type Query_RootAddress_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootAsset_GroupingArgs = {
  distinct_on?: InputMaybe<Array<Asset_Grouping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Grouping_Order_By>>;
  where?: InputMaybe<Asset_Grouping_Bool_Exp>;
};


export type Query_RootAsset_Grouping_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Grouping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Grouping_Order_By>>;
  where?: InputMaybe<Asset_Grouping_Bool_Exp>;
};


export type Query_RootAsset_Grouping_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAsset_Grouping_Customer_AssetArgs = {
  distinct_on?: InputMaybe<Array<Asset_Grouping_Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Grouping_Customer_Asset_Order_By>>;
  where?: InputMaybe<Asset_Grouping_Customer_Asset_Bool_Exp>;
};


export type Query_RootAsset_Grouping_Customer_Asset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Grouping_Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Grouping_Customer_Asset_Order_By>>;
  where?: InputMaybe<Asset_Grouping_Customer_Asset_Bool_Exp>;
};


export type Query_RootAsset_Grouping_Customer_Asset_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAsset_SubsidiaryArgs = {
  distinct_on?: InputMaybe<Array<Asset_Subsidiary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Subsidiary_Order_By>>;
  where?: InputMaybe<Asset_Subsidiary_Bool_Exp>;
};


export type Query_RootAsset_Subsidiary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Subsidiary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Subsidiary_Order_By>>;
  where?: InputMaybe<Asset_Subsidiary_Bool_Exp>;
};


export type Query_RootAsset_Subsidiary_Audit_LogsArgs = {
  distinct_on?: InputMaybe<Array<Asset_Subsidiary_Audit_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Subsidiary_Audit_Logs_Order_By>>;
  where?: InputMaybe<Asset_Subsidiary_Audit_Logs_Bool_Exp>;
};


export type Query_RootAsset_Subsidiary_Audit_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Subsidiary_Audit_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Subsidiary_Audit_Logs_Order_By>>;
  where?: InputMaybe<Asset_Subsidiary_Audit_Logs_Bool_Exp>;
};


export type Query_RootAsset_Subsidiary_Audit_Logs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAsset_Subsidiary_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAsset_TypeArgs = {
  distinct_on?: InputMaybe<Array<Asset_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Type_Order_By>>;
  where?: InputMaybe<Asset_Type_Bool_Exp>;
};


export type Query_RootAsset_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Type_Order_By>>;
  where?: InputMaybe<Asset_Type_Bool_Exp>;
};


export type Query_RootAsset_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAsset_Type_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Asset_Type_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Type_Category_Order_By>>;
  where?: InputMaybe<Asset_Type_Category_Bool_Exp>;
};


export type Query_RootAsset_Type_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Type_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Type_Category_Order_By>>;
  where?: InputMaybe<Asset_Type_Category_Bool_Exp>;
};


export type Query_RootAsset_Type_Category_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootAssociated_TypeArgs = {
  distinct_on?: InputMaybe<Array<Associated_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Associated_Type_Order_By>>;
  where?: InputMaybe<Associated_Type_Bool_Exp>;
};


export type Query_RootAssociated_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Associated_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Associated_Type_Order_By>>;
  where?: InputMaybe<Associated_Type_Bool_Exp>;
};


export type Query_RootAssociated_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootAudit_Log_ActionArgs = {
  distinct_on?: InputMaybe<Array<Audit_Log_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audit_Log_Action_Order_By>>;
  where?: InputMaybe<Audit_Log_Action_Bool_Exp>;
};


export type Query_RootAudit_Log_Action_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Audit_Log_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audit_Log_Action_Order_By>>;
  where?: InputMaybe<Audit_Log_Action_Bool_Exp>;
};


export type Query_RootAudit_Log_Action_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootCancellation_ReasonsArgs = {
  distinct_on?: InputMaybe<Array<Cancellation_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cancellation_Reasons_Order_By>>;
  where?: InputMaybe<Cancellation_Reasons_Bool_Exp>;
};


export type Query_RootCancellation_Reasons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cancellation_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cancellation_Reasons_Order_By>>;
  where?: InputMaybe<Cancellation_Reasons_Bool_Exp>;
};


export type Query_RootCancellation_Reasons_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCategoryArgs = {
  distinct_on?: InputMaybe<Array<Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Category_Order_By>>;
  where?: InputMaybe<Category_Bool_Exp>;
};


export type Query_RootCategory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Category_Order_By>>;
  where?: InputMaybe<Category_Bool_Exp>;
};


export type Query_RootCategory_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCityArgs = {
  distinct_on?: InputMaybe<Array<City_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<City_Order_By>>;
  where?: InputMaybe<City_Bool_Exp>;
};


export type Query_RootCity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<City_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<City_Order_By>>;
  where?: InputMaybe<City_Bool_Exp>;
};


export type Query_RootCity_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCountryArgs = {
  distinct_on?: InputMaybe<Array<Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Country_Order_By>>;
  where?: InputMaybe<Country_Bool_Exp>;
};


export type Query_RootCountry_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Country_Order_By>>;
  where?: InputMaybe<Country_Bool_Exp>;
};


export type Query_RootCountry_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCredit_BreachArgs = {
  distinct_on?: InputMaybe<Array<Credit_Breach_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Breach_Order_By>>;
  where?: InputMaybe<Credit_Breach_Bool_Exp>;
};


export type Query_RootCredit_Breach_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Breach_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Breach_Order_By>>;
  where?: InputMaybe<Credit_Breach_Bool_Exp>;
};


export type Query_RootCredit_Breach_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCurrencyArgs = {
  distinct_on?: InputMaybe<Array<Currency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Currency_Order_By>>;
  where?: InputMaybe<Currency_Bool_Exp>;
};


export type Query_RootCurrency_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Currency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Currency_Order_By>>;
  where?: InputMaybe<Currency_Bool_Exp>;
};


export type Query_RootCurrency_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCurrency_ConversionArgs = {
  distinct_on?: InputMaybe<Array<Currency_Conversion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Currency_Conversion_Order_By>>;
  where?: InputMaybe<Currency_Conversion_Bool_Exp>;
};


export type Query_RootCurrency_Conversion_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Currency_Conversion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Currency_Conversion_Order_By>>;
  where?: InputMaybe<Currency_Conversion_Bool_Exp>;
};


export type Query_RootCurrency_Conversion_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCustomer_AssetArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Order_By>>;
  where?: InputMaybe<Customer_Asset_Bool_Exp>;
};


export type Query_RootCustomer_Asset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Order_By>>;
  where?: InputMaybe<Customer_Asset_Bool_Exp>;
};


export type Query_RootCustomer_Asset_Audit_LogArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Audit_Log_Order_By>>;
  where?: InputMaybe<Customer_Asset_Audit_Log_Bool_Exp>;
};


export type Query_RootCustomer_Asset_Audit_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Audit_Log_Order_By>>;
  where?: InputMaybe<Customer_Asset_Audit_Log_Bool_Exp>;
};


export type Query_RootCustomer_Asset_Audit_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCustomer_Asset_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCustomer_Asset_DeviceArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Device_Order_By>>;
  where?: InputMaybe<Customer_Asset_Device_Bool_Exp>;
};


export type Query_RootCustomer_Asset_Device_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Device_Order_By>>;
  where?: InputMaybe<Customer_Asset_Device_Bool_Exp>;
};


export type Query_RootCustomer_Asset_Device_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCustomer_Asset_Device_CalibrationArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Device_Calibration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Device_Calibration_Order_By>>;
  where?: InputMaybe<Customer_Asset_Device_Calibration_Bool_Exp>;
};


export type Query_RootCustomer_Asset_Device_Calibration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Device_Calibration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Device_Calibration_Order_By>>;
  where?: InputMaybe<Customer_Asset_Device_Calibration_Bool_Exp>;
};


export type Query_RootCustomer_Asset_Device_Calibration_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCustomer_Asset_Dispensing_RulesArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Dispensing_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Dispensing_Rules_Order_By>>;
  where?: InputMaybe<Customer_Asset_Dispensing_Rules_Bool_Exp>;
};


export type Query_RootCustomer_Asset_Dispensing_Rules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Dispensing_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Dispensing_Rules_Order_By>>;
  where?: InputMaybe<Customer_Asset_Dispensing_Rules_Bool_Exp>;
};


export type Query_RootCustomer_Asset_Dispensing_Rules_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCustomer_Asset_LimitArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Limit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Limit_Order_By>>;
  where?: InputMaybe<Customer_Asset_Limit_Bool_Exp>;
};


export type Query_RootCustomer_Asset_Limit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Limit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Limit_Order_By>>;
  where?: InputMaybe<Customer_Asset_Limit_Bool_Exp>;
};


export type Query_RootCustomer_Asset_Limit_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCustomer_Asset_TagArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Tag_Order_By>>;
  where?: InputMaybe<Customer_Asset_Tag_Bool_Exp>;
};


export type Query_RootCustomer_Asset_Tag_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Tag_Order_By>>;
  where?: InputMaybe<Customer_Asset_Tag_Bool_Exp>;
};


export type Query_RootCustomer_Asset_Tag_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCustomer_OrderArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Order_By>>;
  where?: InputMaybe<Customer_Order_Bool_Exp>;
};


export type Query_RootCustomer_Order_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Order_By>>;
  where?: InputMaybe<Customer_Order_Bool_Exp>;
};


export type Query_RootCustomer_Order_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCustomer_Order_Cancellation_ReasonsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Cancellation_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Cancellation_Reasons_Order_By>>;
  where?: InputMaybe<Customer_Order_Cancellation_Reasons_Bool_Exp>;
};


export type Query_RootCustomer_Order_Cancellation_Reasons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Cancellation_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Cancellation_Reasons_Order_By>>;
  where?: InputMaybe<Customer_Order_Cancellation_Reasons_Bool_Exp>;
};


export type Query_RootCustomer_Order_Cancellation_Reasons_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCustomer_Order_Customer_AssetArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Customer_Asset_Order_By>>;
  where?: InputMaybe<Customer_Order_Customer_Asset_Bool_Exp>;
};


export type Query_RootCustomer_Order_Customer_Asset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Customer_Asset_Order_By>>;
  where?: InputMaybe<Customer_Order_Customer_Asset_Bool_Exp>;
};


export type Query_RootCustomer_Order_Customer_Asset_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCustomer_Order_Detail_ViewArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Detail_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Detail_View_Order_By>>;
  where?: InputMaybe<Customer_Order_Detail_View_Bool_Exp>;
};


export type Query_RootCustomer_Order_Detail_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Detail_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Detail_View_Order_By>>;
  where?: InputMaybe<Customer_Order_Detail_View_Bool_Exp>;
};


export type Query_RootCustomer_Order_ItemArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Bool_Exp>;
};


export type Query_RootCustomer_Order_Item_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Bool_Exp>;
};


export type Query_RootCustomer_Order_Item_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCustomer_Order_Item_Cancellation_ReasonsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Cancellation_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Cancellation_Reasons_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Cancellation_Reasons_Bool_Exp>;
};


export type Query_RootCustomer_Order_Item_Cancellation_Reasons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Cancellation_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Cancellation_Reasons_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Cancellation_Reasons_Bool_Exp>;
};


export type Query_RootCustomer_Order_Item_Cancellation_Reasons_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCustomer_Order_Item_CommentsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Comments_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Comments_Bool_Exp>;
};


export type Query_RootCustomer_Order_Item_Comments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Comments_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Comments_Bool_Exp>;
};


export type Query_RootCustomer_Order_Item_Comments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCustomer_Order_Item_CommissionArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Commission_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Commission_Bool_Exp>;
};


export type Query_RootCustomer_Order_Item_Commission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Commission_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Commission_Bool_Exp>;
};


export type Query_RootCustomer_Order_Item_Commission_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCustomer_Order_Item_Etd_Transactional_LogsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Etd_Transactional_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Etd_Transactional_Logs_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Etd_Transactional_Logs_Bool_Exp>;
};


export type Query_RootCustomer_Order_Item_Etd_Transactional_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Etd_Transactional_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Etd_Transactional_Logs_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Etd_Transactional_Logs_Bool_Exp>;
};


export type Query_RootCustomer_Order_Item_Etd_Transactional_Logs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCustomer_Order_Item_PartnerArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Partner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Partner_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Partner_Bool_Exp>;
};


export type Query_RootCustomer_Order_Item_Partner_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Partner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Partner_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Partner_Bool_Exp>;
};


export type Query_RootCustomer_Order_Item_Partner_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCustomer_Order_Item_Safety_Checklist_ResultsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Safety_Checklist_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Safety_Checklist_Results_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Safety_Checklist_Results_Bool_Exp>;
};


export type Query_RootCustomer_Order_Item_Safety_Checklist_Results_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Safety_Checklist_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Safety_Checklist_Results_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Safety_Checklist_Results_Bool_Exp>;
};


export type Query_RootCustomer_Order_Item_Safety_Checklist_Results_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCustomer_Order_Item_StateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_State_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_State_Bool_Exp>;
};


export type Query_RootCustomer_Order_Item_State_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_State_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_State_Bool_Exp>;
};


export type Query_RootCustomer_Order_Item_State_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootCustomer_Order_Item_StateflowArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Stateflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Stateflow_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Stateflow_Bool_Exp>;
};


export type Query_RootCustomer_Order_Item_Stateflow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Stateflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Stateflow_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Stateflow_Bool_Exp>;
};


export type Query_RootCustomer_Order_Item_Stateflow_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCustomer_Order_Item_Test_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Test_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Test_Category_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Test_Category_Bool_Exp>;
};


export type Query_RootCustomer_Order_Item_Test_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Test_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Test_Category_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Test_Category_Bool_Exp>;
};


export type Query_RootCustomer_Order_Item_Test_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCustomer_Order_Item_Test_ResultsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Test_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Test_Results_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Test_Results_Bool_Exp>;
};


export type Query_RootCustomer_Order_Item_Test_Results_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Test_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Test_Results_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Test_Results_Bool_Exp>;
};


export type Query_RootCustomer_Order_Item_Test_Results_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCustomer_Order_Item_Test_Results_PhotosArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Test_Results_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Test_Results_Photos_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Test_Results_Photos_Bool_Exp>;
};


export type Query_RootCustomer_Order_Item_Test_Results_Photos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Test_Results_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Test_Results_Photos_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Test_Results_Photos_Bool_Exp>;
};


export type Query_RootCustomer_Order_Item_Test_Results_Photos_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCustomer_Order_Organization_User_DocumentArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Organization_User_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Organization_User_Document_Order_By>>;
  where?: InputMaybe<Customer_Order_Organization_User_Document_Bool_Exp>;
};


export type Query_RootCustomer_Order_Organization_User_Document_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Organization_User_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Organization_User_Document_Order_By>>;
  where?: InputMaybe<Customer_Order_Organization_User_Document_Bool_Exp>;
};


export type Query_RootCustomer_Order_Organization_User_Document_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCustomer_Order_Partner_OrderArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Partner_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Partner_Order_Order_By>>;
  where?: InputMaybe<Customer_Order_Partner_Order_Bool_Exp>;
};


export type Query_RootCustomer_Order_Partner_Order_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Partner_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Partner_Order_Order_By>>;
  where?: InputMaybe<Customer_Order_Partner_Order_Bool_Exp>;
};


export type Query_RootCustomer_Order_Partner_Order_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCustomer_Order_SlotsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Slots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Slots_Order_By>>;
  where?: InputMaybe<Customer_Order_Slots_Bool_Exp>;
};


export type Query_RootCustomer_Order_Slots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Slots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Slots_Order_By>>;
  where?: InputMaybe<Customer_Order_Slots_Bool_Exp>;
};


export type Query_RootCustomer_Order_Slots_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCustomer_Order_StateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_State_Order_By>>;
  where?: InputMaybe<Customer_Order_State_Bool_Exp>;
};


export type Query_RootCustomer_Order_State_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_State_Order_By>>;
  where?: InputMaybe<Customer_Order_State_Bool_Exp>;
};


export type Query_RootCustomer_Order_State_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootCustomer_Order_StateflowArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Stateflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Stateflow_Order_By>>;
  where?: InputMaybe<Customer_Order_Stateflow_Bool_Exp>;
};


export type Query_RootCustomer_Order_Stateflow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Stateflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Stateflow_Order_By>>;
  where?: InputMaybe<Customer_Order_Stateflow_Bool_Exp>;
};


export type Query_RootCustomer_Order_Stateflow_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCustomer_PaymentArgs = {
  distinct_on?: InputMaybe<Array<Customer_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Payment_Order_By>>;
  where?: InputMaybe<Customer_Payment_Bool_Exp>;
};


export type Query_RootCustomer_Payment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Payment_Order_By>>;
  where?: InputMaybe<Customer_Payment_Bool_Exp>;
};


export type Query_RootCustomer_Payment_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCustomer_Payment_StatusArgs = {
  distinct_on?: InputMaybe<Array<Customer_Payment_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Payment_Status_Order_By>>;
  where?: InputMaybe<Customer_Payment_Status_Bool_Exp>;
};


export type Query_RootCustomer_Payment_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Payment_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Payment_Status_Order_By>>;
  where?: InputMaybe<Customer_Payment_Status_Bool_Exp>;
};


export type Query_RootCustomer_Payment_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootCustomer_SegmentationArgs = {
  distinct_on?: InputMaybe<Array<Customer_Segmentation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Segmentation_Order_By>>;
  where?: InputMaybe<Customer_Segmentation_Bool_Exp>;
};


export type Query_RootCustomer_Segmentation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Segmentation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Segmentation_Order_By>>;
  where?: InputMaybe<Customer_Segmentation_Bool_Exp>;
};


export type Query_RootCustomer_Segmentation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDay_TypeArgs = {
  distinct_on?: InputMaybe<Array<Day_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Day_Type_Order_By>>;
  where?: InputMaybe<Day_Type_Bool_Exp>;
};


export type Query_RootDay_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Day_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Day_Type_Order_By>>;
  where?: InputMaybe<Day_Type_Bool_Exp>;
};


export type Query_RootDay_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootDelayed_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Delayed_Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delayed_Orders_Order_By>>;
  where?: InputMaybe<Delayed_Orders_Bool_Exp>;
};


export type Query_RootDelayed_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Delayed_Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delayed_Orders_Order_By>>;
  where?: InputMaybe<Delayed_Orders_Bool_Exp>;
};


export type Query_RootDelivery_PreferencesArgs = {
  distinct_on?: InputMaybe<Array<Delivery_Preferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delivery_Preferences_Order_By>>;
  where?: InputMaybe<Delivery_Preferences_Bool_Exp>;
};


export type Query_RootDelivery_Preferences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Delivery_Preferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delivery_Preferences_Order_By>>;
  where?: InputMaybe<Delivery_Preferences_Bool_Exp>;
};


export type Query_RootDelivery_Preferences_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootDelivery_SchedulerArgs = {
  distinct_on?: InputMaybe<Array<Delivery_Scheduler_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delivery_Scheduler_Order_By>>;
  where?: InputMaybe<Delivery_Scheduler_Bool_Exp>;
};


export type Query_RootDelivery_Scheduler_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Delivery_Scheduler_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delivery_Scheduler_Order_By>>;
  where?: InputMaybe<Delivery_Scheduler_Bool_Exp>;
};


export type Query_RootDelivery_Scheduler_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDelivery_Scheduler_Product_ItemArgs = {
  distinct_on?: InputMaybe<Array<Delivery_Scheduler_Product_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delivery_Scheduler_Product_Item_Order_By>>;
  where?: InputMaybe<Delivery_Scheduler_Product_Item_Bool_Exp>;
};


export type Query_RootDelivery_Scheduler_Product_Item_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Delivery_Scheduler_Product_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delivery_Scheduler_Product_Item_Order_By>>;
  where?: InputMaybe<Delivery_Scheduler_Product_Item_Bool_Exp>;
};


export type Query_RootDelivery_Scheduler_Product_Item_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDepartment_Retag_RequestArgs = {
  distinct_on?: InputMaybe<Array<Department_Retag_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Department_Retag_Request_Order_By>>;
  where?: InputMaybe<Department_Retag_Request_Bool_Exp>;
};


export type Query_RootDepartment_Retag_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Department_Retag_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Department_Retag_Request_Order_By>>;
  where?: InputMaybe<Department_Retag_Request_Bool_Exp>;
};


export type Query_RootDepartment_Retag_Request_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDeriveSlotsForDateArgs = {
  object: DeriveSlotsForDateInput;
};


export type Query_RootDevice_Devicetype_Paramerter_DefinitionArgs = {
  distinct_on?: InputMaybe<Array<Device_Devicetype_Paramerter_Definition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Device_Devicetype_Paramerter_Definition_Order_By>>;
  where?: InputMaybe<Device_Devicetype_Paramerter_Definition_Bool_Exp>;
};


export type Query_RootDevice_Devicetype_Paramerter_Definition_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Device_Devicetype_Paramerter_Definition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Device_Devicetype_Paramerter_Definition_Order_By>>;
  where?: InputMaybe<Device_Devicetype_Paramerter_Definition_Bool_Exp>;
};


export type Query_RootDevice_Devicetype_Paramerter_Definition_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDevicetypeArgs = {
  distinct_on?: InputMaybe<Array<Devicetype_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Devicetype_Order_By>>;
  where?: InputMaybe<Devicetype_Bool_Exp>;
};


export type Query_RootDevicetype_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Devicetype_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Devicetype_Order_By>>;
  where?: InputMaybe<Devicetype_Bool_Exp>;
};


export type Query_RootDevicetype_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDevicetype_Paramerter_DefinitionArgs = {
  distinct_on?: InputMaybe<Array<Devicetype_Paramerter_Definition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Devicetype_Paramerter_Definition_Order_By>>;
  where?: InputMaybe<Devicetype_Paramerter_Definition_Bool_Exp>;
};


export type Query_RootDevicetype_Paramerter_Definition_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Devicetype_Paramerter_Definition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Devicetype_Paramerter_Definition_Order_By>>;
  where?: InputMaybe<Devicetype_Paramerter_Definition_Bool_Exp>;
};


export type Query_RootDevicetype_Paramerter_Definition_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDevicetype_Parameter_GroupArgs = {
  distinct_on?: InputMaybe<Array<Devicetype_Parameter_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Devicetype_Parameter_Group_Order_By>>;
  where?: InputMaybe<Devicetype_Parameter_Group_Bool_Exp>;
};


export type Query_RootDevicetype_Parameter_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Devicetype_Parameter_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Devicetype_Parameter_Group_Order_By>>;
  where?: InputMaybe<Devicetype_Parameter_Group_Bool_Exp>;
};


export type Query_RootDevicetype_Parameter_Group_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDiscount_TypeArgs = {
  distinct_on?: InputMaybe<Array<Discount_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Discount_Type_Order_By>>;
  where?: InputMaybe<Discount_Type_Bool_Exp>;
};


export type Query_RootDiscount_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Discount_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Discount_Type_Order_By>>;
  where?: InputMaybe<Discount_Type_Bool_Exp>;
};


export type Query_RootDiscount_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootDispenserArgs = {
  distinct_on?: InputMaybe<Array<Dispenser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dispenser_Order_By>>;
  where?: InputMaybe<Dispenser_Bool_Exp>;
};


export type Query_RootDispenser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dispenser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dispenser_Order_By>>;
  where?: InputMaybe<Dispenser_Bool_Exp>;
};


export type Query_RootDispenser_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDispenser_ConfigurationArgs = {
  distinct_on?: InputMaybe<Array<Dispenser_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dispenser_Configuration_Order_By>>;
  where?: InputMaybe<Dispenser_Configuration_Bool_Exp>;
};


export type Query_RootDispenser_Configuration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dispenser_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dispenser_Configuration_Order_By>>;
  where?: InputMaybe<Dispenser_Configuration_Bool_Exp>;
};


export type Query_RootDispenser_Configuration_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDispenser_TypeArgs = {
  distinct_on?: InputMaybe<Array<Dispenser_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dispenser_Type_Order_By>>;
  where?: InputMaybe<Dispenser_Type_Bool_Exp>;
};


export type Query_RootDispenser_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dispenser_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dispenser_Type_Order_By>>;
  where?: InputMaybe<Dispenser_Type_Bool_Exp>;
};


export type Query_RootDispenser_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootDispensing_RulesArgs = {
  distinct_on?: InputMaybe<Array<Dispensing_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dispensing_Rules_Order_By>>;
  where?: InputMaybe<Dispensing_Rules_Bool_Exp>;
};


export type Query_RootDispensing_Rules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dispensing_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dispensing_Rules_Order_By>>;
  where?: InputMaybe<Dispensing_Rules_Bool_Exp>;
};


export type Query_RootDispensing_Rules_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDocument_TypeArgs = {
  distinct_on?: InputMaybe<Array<Document_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Type_Order_By>>;
  where?: InputMaybe<Document_Type_Bool_Exp>;
};


export type Query_RootDocument_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Type_Order_By>>;
  where?: InputMaybe<Document_Type_Bool_Exp>;
};


export type Query_RootDocument_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDocument_Type_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Document_Type_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Type_Category_Order_By>>;
  where?: InputMaybe<Document_Type_Category_Bool_Exp>;
};


export type Query_RootDocument_Type_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Type_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Type_Category_Order_By>>;
  where?: InputMaybe<Document_Type_Category_Bool_Exp>;
};


export type Query_RootDocument_Type_Category_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Documents_Order_By>>;
  where?: InputMaybe<Documents_Bool_Exp>;
};


export type Query_RootDocuments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Documents_Order_By>>;
  where?: InputMaybe<Documents_Bool_Exp>;
};


export type Query_RootDocuments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDriver_Duty_LogArgs = {
  distinct_on?: InputMaybe<Array<Driver_Duty_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Duty_Log_Order_By>>;
  where?: InputMaybe<Driver_Duty_Log_Bool_Exp>;
};


export type Query_RootDriver_Duty_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Driver_Duty_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Duty_Log_Order_By>>;
  where?: InputMaybe<Driver_Duty_Log_Bool_Exp>;
};


export type Query_RootDriver_Duty_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDriver_Duty_PhotosArgs = {
  distinct_on?: InputMaybe<Array<Driver_Duty_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Duty_Photos_Order_By>>;
  where?: InputMaybe<Driver_Duty_Photos_Bool_Exp>;
};


export type Query_RootDriver_Duty_Photos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Driver_Duty_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Duty_Photos_Order_By>>;
  where?: InputMaybe<Driver_Duty_Photos_Bool_Exp>;
};


export type Query_RootDriver_Duty_Photos_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDriver_PermitArgs = {
  distinct_on?: InputMaybe<Array<Driver_Permit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Permit_Order_By>>;
  where?: InputMaybe<Driver_Permit_Bool_Exp>;
};


export type Query_RootDriver_Permit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Driver_Permit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Permit_Order_By>>;
  where?: InputMaybe<Driver_Permit_Bool_Exp>;
};


export type Query_RootDriver_Permit_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDriver_VehicleArgs = {
  distinct_on?: InputMaybe<Array<Driver_Vehicle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Vehicle_Order_By>>;
  where?: InputMaybe<Driver_Vehicle_Bool_Exp>;
};


export type Query_RootDriver_Vehicle_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Driver_Vehicle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Vehicle_Order_By>>;
  where?: InputMaybe<Driver_Vehicle_Bool_Exp>;
};


export type Query_RootDriver_Vehicle_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDriver_Vehicle_IssueArgs = {
  distinct_on?: InputMaybe<Array<Driver_Vehicle_Issue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Vehicle_Issue_Order_By>>;
  where?: InputMaybe<Driver_Vehicle_Issue_Bool_Exp>;
};


export type Query_RootDriver_Vehicle_Issue_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Driver_Vehicle_Issue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Vehicle_Issue_Order_By>>;
  where?: InputMaybe<Driver_Vehicle_Issue_Bool_Exp>;
};


export type Query_RootDriver_Vehicle_Issue_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDriver_Vehicle_LocationArgs = {
  distinct_on?: InputMaybe<Array<Driver_Vehicle_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Vehicle_Location_Order_By>>;
  where?: InputMaybe<Driver_Vehicle_Location_Bool_Exp>;
};


export type Query_RootDriver_Vehicle_Location_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Driver_Vehicle_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Vehicle_Location_Order_By>>;
  where?: InputMaybe<Driver_Vehicle_Location_Bool_Exp>;
};


export type Query_RootDriver_Vehicle_Location_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootErp_Sync_StatusArgs = {
  distinct_on?: InputMaybe<Array<Erp_Sync_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Erp_Sync_Status_Order_By>>;
  where?: InputMaybe<Erp_Sync_Status_Bool_Exp>;
};


export type Query_RootErp_Sync_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Erp_Sync_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Erp_Sync_Status_Order_By>>;
  where?: InputMaybe<Erp_Sync_Status_Bool_Exp>;
};


export type Query_RootErp_Sync_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootFetchCurrentAndPreviousMonthQtyV1Args = {
  object: FetchCurrentAndPreviousMonthQtyV1Input;
};


export type Query_RootFetchCurrentAndPreviousMonthQtyV2Args = {
  object: FetchCurrentAndPreviousMonthQtyV2Input;
};


export type Query_RootFetchCurrentAndPreviousMonthQtyV3Args = {
  object: FetchCurrentAndPreviousMonthQtyV3Input;
};


export type Query_RootFetchCurrentAndPreviousMonthQtyV4Args = {
  object: FetchCurrentAndPreviousMonthQtyV4Input;
};


export type Query_RootFetchCurrentAndPreviousMonthQtyV7Args = {
  object: FetchCurrentAndPreviousMonthQtyV7Input;
};


export type Query_RootFetchCurrentMonthDashboardSummaryV7Args = {
  object: FetchCurrentMonthDashboardSummaryV7Input;
};


export type Query_RootFetchCurrentMonthOrderSummaryV1Args = {
  object: FetchCurrentMonthOrderSummaryV1Input;
};


export type Query_RootFetchCurrentMonthOrderSummaryV2Args = {
  object: FetchCurrentMonthOrderSummaryV2Input;
};


export type Query_RootFetchCurrentMonthOrderSummaryV3Args = {
  object: FetchCurrentMonthOrderSummaryV3Input;
};


export type Query_RootFetchCurrentMonthOrderSummaryV7Args = {
  object: FetchCurrentMonthOrderSummaryV7Input;
};


export type Query_RootFetchCustomerAssetMileageV1Args = {
  object: FetchCustomerAssetMileageV1Input;
};


export type Query_RootFetchCustomerAssetReportV1Args = {
  object: FetchCustomerAssetReportV1Input;
};


export type Query_RootFetchCustomerAssetTagsFilterV1Args = {
  object: FetchCustomerAssetTagsFilterV1Input;
};


export type Query_RootFetchCustomerAssetUtilizationV1Args = {
  object: FetchCustomerAssetUtilizationV1Input;
};


export type Query_RootFetchCustomerAssetsFilterV1Args = {
  object: FetchCustomerAssetsFilterV1Input;
};


export type Query_RootFetchCustomerOrderDetailsV1Args = {
  object: FetchCustomerOrderDetailsV1Input;
};


export type Query_RootFetchCustomerOrderDetailsV2Args = {
  object: FetchCustomerOrderDetailsV2Input;
};


export type Query_RootFetchCustomerOrderDetailsV3Args = {
  object: FetchCustomerOrderDetailsV3Input;
};


export type Query_RootFetchCustomerOrderDetailsV4Args = {
  object: FetchCustomerOrderDetailsV4Input;
};


export type Query_RootFetchCustomerOrderDetailsV5Args = {
  object: FetchCustomerOrderDetailsV5Input;
};


export type Query_RootFetchCustomerOrderDetailsV6Args = {
  object: FetchCustomerOrderDetailsV6Input;
};


export type Query_RootFetchCustomerOrderDetailsV7Args = {
  object: FetchCustomerOrderDetailsV7Input;
};


export type Query_RootFetchCustomerOrderItemCommentsArgs = {
  object: FetchCustomerOrderItemCommentsInput;
};


export type Query_RootFetchDownloadReportDetailsV7Args = {
  object: FetchDownloadReportDetailsV7Input;
};


export type Query_RootFetchFileArgs = {
  file: FileInput;
};


export type Query_RootFetchMonthBillingV7Args = {
  object: FetchMonthBillingV7Input;
};


export type Query_RootFetchOrderCodesFilterV1Args = {
  object: FetchOrderCodesFilterV1Input;
};


export type Query_RootFetchOrderDetailsArgs = {
  object: FetchOrderDetailsInput;
};


export type Query_RootFetchOrderStatsArgs = {
  object: OrderStatsInput;
};


export type Query_RootFetchOrderSummaryCountV1Args = {
  object: FetchOrderSummaryCountV1Input;
};


export type Query_RootFetchOrderSummaryCountV2Args = {
  object: FetchOrderSummaryCountV2Input;
};


export type Query_RootFetchOrderSummaryCountV3Args = {
  object: FetchOrderSummaryCountV3Input;
};


export type Query_RootFetchOrderSummaryCountV7Args = {
  object: FetchOrderSummaryCountV7Input;
};


export type Query_RootFetchOrderSummaryQuantityV1Args = {
  object: FetchOrderSummaryQuantityV1Input;
};


export type Query_RootFetchOrderSummaryQuantityV2Args = {
  object: FetchOrderSummaryQuantityV2Input;
};


export type Query_RootFetchOrderSummaryQuantityV3Args = {
  object: FetchOrderSummaryQuantityV3Input;
};


export type Query_RootFetchOrderSummaryQuantityV7Args = {
  object: FetchOrderSummaryQuantityV7Input;
};


export type Query_RootFetchOrderSummaryRefillV1Args = {
  object: FetchOrderSummaryRefillV1Input;
};


export type Query_RootFetchOrderSummaryRefillV2Args = {
  object: FetchOrderSummaryRefillV2Input;
};


export type Query_RootFetchOrderSummaryRefillV3Args = {
  object: FetchOrderSummaryRefillV3Input;
};


export type Query_RootFetchOrderSummaryRefillV7Args = {
  object: FetchOrderSummaryRefillV7Input;
};


export type Query_RootFetchOrderedAndDeliveredQtyV1Args = {
  object: FetchOrderedAndDeliveredQtyV1Input;
};


export type Query_RootFetchOrderedAndDeliveredQtyV2Args = {
  object: FetchOrderedAndDeliveredQtyV2Input;
};


export type Query_RootFetchOrderedAndDeliveredQtyV3Args = {
  object: FetchOrderedAndDeliveredQtyV3Input;
};


export type Query_RootFetchOrderedAndDeliveredQtyV4Args = {
  object: FetchOrderedAndDeliveredQtyV4Input;
};


export type Query_RootFetchOrderedAndDeliveredQtyV7Args = {
  object: FetchOrderedAndDeliveredQtyV7Input;
};


export type Query_RootFetchOrdersArgs = {
  object: OrdersInput;
};


export type Query_RootFetchOrganizationAddressFilterV1Args = {
  object: FetchOrganizationAddressFilterV1Input;
};


export type Query_RootFetchPartnerUsersFilterV1Args = {
  object: FetchPartnerUsersFilterV1Input;
};


export type Query_RootFetchPrevMonthDashboardSummaryV7Args = {
  object: FetchPrevMonthDashboardSummaryV7Input;
};


export type Query_RootFetchPreviousMonthOrderSummaryV1Args = {
  object: FetchPreviousMonthOrderSummaryV1Input;
};


export type Query_RootFetchPreviousMonthOrderSummaryV2Args = {
  object: FetchPreviousMonthOrderSummaryV2Input;
};


export type Query_RootFetchPreviousMonthOrderSummaryV3Args = {
  object: FetchPreviousMonthOrderSummaryV3Input;
};


export type Query_RootFetchPreviousMonthOrderSummaryV7Args = {
  object: FetchPreviousMonthOrderSummaryV7Input;
};


export type Query_RootFetchSuperSetGuestTokenArgs = {
  object: DashboardDetailsInput;
};


export type Query_RootFetchTaskValueForCustomerAssetArgs = {
  object: FetchTaskValueForCustomerAssetInput;
};


export type Query_RootFetchTotalOrdersAmountGroupedByDayV1Args = {
  object: FetchTotalOrdersAmountGroupedByDayV1Input;
};


export type Query_RootFetchTotalOrdersAmountGroupedByDayV2Args = {
  object: FetchTotalOrdersAmountGroupedByDayV2Input;
};


export type Query_RootFetchTotalOrdersAmountGroupedByDayV3Args = {
  object: FetchTotalOrdersAmountGroupedByDayV3Input;
};


export type Query_RootFetchTotalOrdersAmountGroupedByDayV4Args = {
  object: FetchTotalOrdersAmountGroupedByDayV4Input;
};


export type Query_RootFetchTotalOrdersAmountGroupedByDayV7Args = {
  object: FetchTotalOrdersAmountGroupedByDayV7Input;
};


export type Query_RootFetchVehicleInventoryTransactionLogsArgs = {
  object: VehicleInventoryTransactionLogsInput;
};


export type Query_RootFetchVehicleLiveDataArgs = {
  object: VehicleLiveDataInput;
};


export type Query_RootFillup_RequestArgs = {
  distinct_on?: InputMaybe<Array<Fillup_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fillup_Request_Order_By>>;
  where?: InputMaybe<Fillup_Request_Bool_Exp>;
};


export type Query_RootFillup_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fillup_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fillup_Request_Order_By>>;
  where?: InputMaybe<Fillup_Request_Bool_Exp>;
};


export type Query_RootFillup_Request_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFillup_Request_StatusArgs = {
  distinct_on?: InputMaybe<Array<Fillup_Request_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fillup_Request_Status_Order_By>>;
  where?: InputMaybe<Fillup_Request_Status_Bool_Exp>;
};


export type Query_RootFillup_Request_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fillup_Request_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fillup_Request_Status_Order_By>>;
  where?: InputMaybe<Fillup_Request_Status_Bool_Exp>;
};


export type Query_RootFillup_Request_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootFuel_Request_TypeArgs = {
  distinct_on?: InputMaybe<Array<Fuel_Request_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fuel_Request_Type_Order_By>>;
  where?: InputMaybe<Fuel_Request_Type_Bool_Exp>;
};


export type Query_RootFuel_Request_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fuel_Request_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fuel_Request_Type_Order_By>>;
  where?: InputMaybe<Fuel_Request_Type_Bool_Exp>;
};


export type Query_RootFuel_Request_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootFueltrans_Transaction_LogsArgs = {
  distinct_on?: InputMaybe<Array<Fueltrans_Transaction_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fueltrans_Transaction_Logs_Order_By>>;
  where?: InputMaybe<Fueltrans_Transaction_Logs_Bool_Exp>;
};


export type Query_RootFueltrans_Transaction_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fueltrans_Transaction_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fueltrans_Transaction_Logs_Order_By>>;
  where?: InputMaybe<Fueltrans_Transaction_Logs_Bool_Exp>;
};


export type Query_RootFueltrans_Transaction_Logs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootGeography_ColumnsArgs = {
  distinct_on?: InputMaybe<Array<Geography_Columns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Geography_Columns_Order_By>>;
  where?: InputMaybe<Geography_Columns_Bool_Exp>;
};


export type Query_RootGeography_Columns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Geography_Columns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Geography_Columns_Order_By>>;
  where?: InputMaybe<Geography_Columns_Bool_Exp>;
};


export type Query_RootGeometry_ColumnsArgs = {
  distinct_on?: InputMaybe<Array<Geometry_Columns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Geometry_Columns_Order_By>>;
  where?: InputMaybe<Geometry_Columns_Bool_Exp>;
};


export type Query_RootGeometry_Columns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Geometry_Columns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Geometry_Columns_Order_By>>;
  where?: InputMaybe<Geometry_Columns_Bool_Exp>;
};


export type Query_RootGetDeviceHistoryArgs = {
  object: GetDeviceHistoryInput;
};


export type Query_RootGetDeviceHistoryV1Args = {
  object: GetDeviceHistoryV1Input;
};


export type Query_RootGetDeviceHistoryV2Args = {
  object: GetDeviceHistoryV2Input;
};


export type Query_RootGetDeviceUpdateArgs = {
  object: GetDeviceUpdateInput;
};


export type Query_RootGetDeviceUpdateV1Args = {
  object: GetDeviceUpdateV1Input;
};


export type Query_RootGetDeviceUpdateV4Args = {
  object: GetDeviceUpdateV4Input;
};


export type Query_RootInventoryArgs = {
  distinct_on?: InputMaybe<Array<Inventory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Inventory_Order_By>>;
  where?: InputMaybe<Inventory_Bool_Exp>;
};


export type Query_RootInventory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Inventory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Inventory_Order_By>>;
  where?: InputMaybe<Inventory_Bool_Exp>;
};


export type Query_RootInventory_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootInventory_Workflow_LogsArgs = {
  distinct_on?: InputMaybe<Array<Inventory_Workflow_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Inventory_Workflow_Logs_Order_By>>;
  where?: InputMaybe<Inventory_Workflow_Logs_Bool_Exp>;
};


export type Query_RootInventory_Workflow_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Inventory_Workflow_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Inventory_Workflow_Logs_Order_By>>;
  where?: InputMaybe<Inventory_Workflow_Logs_Bool_Exp>;
};


export type Query_RootInventory_Workflow_Logs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootInvitationArgs = {
  distinct_on?: InputMaybe<Array<Invitation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invitation_Order_By>>;
  where?: InputMaybe<Invitation_Bool_Exp>;
};


export type Query_RootInvitation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invitation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invitation_Order_By>>;
  where?: InputMaybe<Invitation_Bool_Exp>;
};


export type Query_RootInvitation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootInvitation_StatusArgs = {
  distinct_on?: InputMaybe<Array<Invitation_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invitation_Status_Order_By>>;
  where?: InputMaybe<Invitation_Status_Bool_Exp>;
};


export type Query_RootInvitation_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invitation_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invitation_Status_Order_By>>;
  where?: InputMaybe<Invitation_Status_Bool_Exp>;
};


export type Query_RootInvitation_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootInvoiceArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


export type Query_RootInvoice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


export type Query_RootInvoice_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootInvoiced_ItemArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Bool_Exp>;
};


export type Query_RootInvoiced_Item_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Bool_Exp>;
};


export type Query_RootInvoiced_Item_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootInvoiced_Item_Cancellation_Ticket_StatesArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Cancellation_Ticket_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Cancellation_Ticket_States_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Cancellation_Ticket_States_Bool_Exp>;
};


export type Query_RootInvoiced_Item_Cancellation_Ticket_States_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Cancellation_Ticket_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Cancellation_Ticket_States_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Cancellation_Ticket_States_Bool_Exp>;
};


export type Query_RootInvoiced_Item_Cancellation_Ticket_States_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootInvoiced_Item_Cancellation_TicketsArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Cancellation_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Cancellation_Tickets_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Bool_Exp>;
};


export type Query_RootInvoiced_Item_Cancellation_Tickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Cancellation_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Cancellation_Tickets_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Bool_Exp>;
};


export type Query_RootInvoiced_Item_Cancellation_Tickets_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootIssueArgs = {
  distinct_on?: InputMaybe<Array<Issue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Order_By>>;
  where?: InputMaybe<Issue_Bool_Exp>;
};


export type Query_RootIssue_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Issue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Order_By>>;
  where?: InputMaybe<Issue_Bool_Exp>;
};


export type Query_RootIssue_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootJob_StateArgs = {
  distinct_on?: InputMaybe<Array<Job_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Job_State_Order_By>>;
  where?: InputMaybe<Job_State_Bool_Exp>;
};


export type Query_RootJob_State_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Job_State_Order_By>>;
  where?: InputMaybe<Job_State_Bool_Exp>;
};


export type Query_RootJob_State_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootJob_TypeArgs = {
  distinct_on?: InputMaybe<Array<Job_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Job_Type_Order_By>>;
  where?: InputMaybe<Job_Type_Bool_Exp>;
};


export type Query_RootJob_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Job_Type_Order_By>>;
  where?: InputMaybe<Job_Type_Bool_Exp>;
};


export type Query_RootJob_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootJob_Type_TemplateArgs = {
  distinct_on?: InputMaybe<Array<Job_Type_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Job_Type_Template_Order_By>>;
  where?: InputMaybe<Job_Type_Template_Bool_Exp>;
};


export type Query_RootJob_Type_Template_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Type_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Job_Type_Template_Order_By>>;
  where?: InputMaybe<Job_Type_Template_Bool_Exp>;
};


export type Query_RootJob_Type_Template_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootJobsArgs = {
  distinct_on?: InputMaybe<Array<Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Jobs_Order_By>>;
  where?: InputMaybe<Jobs_Bool_Exp>;
};


export type Query_RootJobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Jobs_Order_By>>;
  where?: InputMaybe<Jobs_Bool_Exp>;
};


export type Query_RootJobs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootJobs_State_FlowArgs = {
  distinct_on?: InputMaybe<Array<Jobs_State_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Jobs_State_Flow_Order_By>>;
  where?: InputMaybe<Jobs_State_Flow_Bool_Exp>;
};


export type Query_RootJobs_State_Flow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Jobs_State_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Jobs_State_Flow_Order_By>>;
  where?: InputMaybe<Jobs_State_Flow_Bool_Exp>;
};


export type Query_RootJobs_State_Flow_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootLimit_Purchase_OrderArgs = {
  distinct_on?: InputMaybe<Array<Limit_Purchase_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Limit_Purchase_Order_Order_By>>;
  where?: InputMaybe<Limit_Purchase_Order_Bool_Exp>;
};


export type Query_RootLimit_Purchase_Order_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Limit_Purchase_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Limit_Purchase_Order_Order_By>>;
  where?: InputMaybe<Limit_Purchase_Order_Bool_Exp>;
};


export type Query_RootLimit_Purchase_Order_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootLimit_Purchase_Order_LogsArgs = {
  distinct_on?: InputMaybe<Array<Limit_Purchase_Order_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Limit_Purchase_Order_Logs_Order_By>>;
  where?: InputMaybe<Limit_Purchase_Order_Logs_Bool_Exp>;
};


export type Query_RootLimit_Purchase_Order_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Limit_Purchase_Order_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Limit_Purchase_Order_Logs_Order_By>>;
  where?: InputMaybe<Limit_Purchase_Order_Logs_Bool_Exp>;
};


export type Query_RootLimit_Purchase_Order_Logs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootLocalitiesArgs = {
  distinct_on?: InputMaybe<Array<Localities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Localities_Order_By>>;
  where?: InputMaybe<Localities_Bool_Exp>;
};


export type Query_RootLocalities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Localities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Localities_Order_By>>;
  where?: InputMaybe<Localities_Bool_Exp>;
};


export type Query_RootLocalities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootLogin_TypeArgs = {
  distinct_on?: InputMaybe<Array<Login_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Login_Type_Order_By>>;
  where?: InputMaybe<Login_Type_Bool_Exp>;
};


export type Query_RootLogin_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Login_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Login_Type_Order_By>>;
  where?: InputMaybe<Login_Type_Bool_Exp>;
};


export type Query_RootLogin_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootLpo_ExceptionArgs = {
  distinct_on?: InputMaybe<Array<Lpo_Exception_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lpo_Exception_Order_By>>;
  where?: InputMaybe<Lpo_Exception_Bool_Exp>;
};


export type Query_RootLpo_Exception_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lpo_Exception_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lpo_Exception_Order_By>>;
  where?: InputMaybe<Lpo_Exception_Bool_Exp>;
};


export type Query_RootLpo_Exception_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMaster_SlotArgs = {
  distinct_on?: InputMaybe<Array<Master_Slot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Slot_Order_By>>;
  where?: InputMaybe<Master_Slot_Bool_Exp>;
};


export type Query_RootMaster_Slot_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Master_Slot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Slot_Order_By>>;
  where?: InputMaybe<Master_Slot_Bool_Exp>;
};


export type Query_RootMaster_Slot_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMaster_Slot_PauseArgs = {
  distinct_on?: InputMaybe<Array<Master_Slot_Pause_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Slot_Pause_Order_By>>;
  where?: InputMaybe<Master_Slot_Pause_Bool_Exp>;
};


export type Query_RootMaster_Slot_Pause_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Master_Slot_Pause_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Slot_Pause_Order_By>>;
  where?: InputMaybe<Master_Slot_Pause_Bool_Exp>;
};


export type Query_RootMaster_Slot_Pause_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOmc_TypeArgs = {
  distinct_on?: InputMaybe<Array<Omc_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Omc_Type_Order_By>>;
  where?: InputMaybe<Omc_Type_Bool_Exp>;
};


export type Query_RootOmc_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Omc_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Omc_Type_Order_By>>;
  where?: InputMaybe<Omc_Type_Bool_Exp>;
};


export type Query_RootOmc_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootOrder_PhotosArgs = {
  distinct_on?: InputMaybe<Array<Order_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Photos_Order_By>>;
  where?: InputMaybe<Order_Photos_Bool_Exp>;
};


export type Query_RootOrder_Photos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Photos_Order_By>>;
  where?: InputMaybe<Order_Photos_Bool_Exp>;
};


export type Query_RootOrder_Photos_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrder_SchedulerArgs = {
  distinct_on?: InputMaybe<Array<Order_Scheduler_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Scheduler_Order_By>>;
  where?: InputMaybe<Order_Scheduler_Bool_Exp>;
};


export type Query_RootOrder_Scheduler_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Scheduler_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Scheduler_Order_By>>;
  where?: InputMaybe<Order_Scheduler_Bool_Exp>;
};


export type Query_RootOrder_Scheduler_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrder_Scheduler_Customer_AssetArgs = {
  distinct_on?: InputMaybe<Array<Order_Scheduler_Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Scheduler_Customer_Asset_Order_By>>;
  where?: InputMaybe<Order_Scheduler_Customer_Asset_Bool_Exp>;
};


export type Query_RootOrder_Scheduler_Customer_Asset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Scheduler_Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Scheduler_Customer_Asset_Order_By>>;
  where?: InputMaybe<Order_Scheduler_Customer_Asset_Bool_Exp>;
};


export type Query_RootOrder_Scheduler_Customer_Asset_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrder_Scheduler_Daily_FrequencyArgs = {
  distinct_on?: InputMaybe<Array<Order_Scheduler_Daily_Frequency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Scheduler_Daily_Frequency_Order_By>>;
  where?: InputMaybe<Order_Scheduler_Daily_Frequency_Bool_Exp>;
};


export type Query_RootOrder_Scheduler_Daily_Frequency_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Scheduler_Daily_Frequency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Scheduler_Daily_Frequency_Order_By>>;
  where?: InputMaybe<Order_Scheduler_Daily_Frequency_Bool_Exp>;
};


export type Query_RootOrder_Scheduler_Daily_Frequency_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrder_TypeArgs = {
  distinct_on?: InputMaybe<Array<Order_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Type_Order_By>>;
  where?: InputMaybe<Order_Type_Bool_Exp>;
};


export type Query_RootOrder_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Type_Order_By>>;
  where?: InputMaybe<Order_Type_Bool_Exp>;
};


export type Query_RootOrder_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootOrganizationArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Query_RootOrganization_AddressArgs = {
  distinct_on?: InputMaybe<Array<Organization_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Address_Order_By>>;
  where?: InputMaybe<Organization_Address_Bool_Exp>;
};


export type Query_RootOrganization_Address_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Address_Order_By>>;
  where?: InputMaybe<Organization_Address_Bool_Exp>;
};


export type Query_RootOrganization_Address_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrganization_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Query_RootOrganization_Audit_LogArgs = {
  distinct_on?: InputMaybe<Array<Organization_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Audit_Log_Order_By>>;
  where?: InputMaybe<Organization_Audit_Log_Bool_Exp>;
};


export type Query_RootOrganization_Audit_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Audit_Log_Order_By>>;
  where?: InputMaybe<Organization_Audit_Log_Bool_Exp>;
};


export type Query_RootOrganization_Audit_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrganization_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrganization_Commission_Product_Variation_TypeArgs = {
  distinct_on?: InputMaybe<Array<Organization_Commission_Product_Variation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Commission_Product_Variation_Type_Order_By>>;
  where?: InputMaybe<Organization_Commission_Product_Variation_Type_Bool_Exp>;
};


export type Query_RootOrganization_Commission_Product_Variation_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Commission_Product_Variation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Commission_Product_Variation_Type_Order_By>>;
  where?: InputMaybe<Organization_Commission_Product_Variation_Type_Bool_Exp>;
};


export type Query_RootOrganization_Commission_Product_Variation_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrganization_ConfigurationArgs = {
  distinct_on?: InputMaybe<Array<Organization_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Configuration_Order_By>>;
  where?: InputMaybe<Organization_Configuration_Bool_Exp>;
};


export type Query_RootOrganization_Configuration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Configuration_Order_By>>;
  where?: InputMaybe<Organization_Configuration_Bool_Exp>;
};


export type Query_RootOrganization_Configuration_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrganization_Product_Variation_DiscountArgs = {
  distinct_on?: InputMaybe<Array<Organization_Product_Variation_Discount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Product_Variation_Discount_Order_By>>;
  where?: InputMaybe<Organization_Product_Variation_Discount_Bool_Exp>;
};


export type Query_RootOrganization_Product_Variation_Discount_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Product_Variation_Discount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Product_Variation_Discount_Order_By>>;
  where?: InputMaybe<Organization_Product_Variation_Discount_Bool_Exp>;
};


export type Query_RootOrganization_Product_Variation_Discount_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrganization_Product_Variation_Discount_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Organization_Product_Variation_Discount_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Product_Variation_Discount_History_Order_By>>;
  where?: InputMaybe<Organization_Product_Variation_Discount_History_Bool_Exp>;
};


export type Query_RootOrganization_Product_Variation_Discount_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Product_Variation_Discount_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Product_Variation_Discount_History_Order_By>>;
  where?: InputMaybe<Organization_Product_Variation_Discount_History_Bool_Exp>;
};


export type Query_RootOrganization_Product_Variation_Discount_History_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrganization_Sales_ProjectionArgs = {
  distinct_on?: InputMaybe<Array<Organization_Sales_Projection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Sales_Projection_Order_By>>;
  where?: InputMaybe<Organization_Sales_Projection_Bool_Exp>;
};


export type Query_RootOrganization_Sales_Projection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Sales_Projection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Sales_Projection_Order_By>>;
  where?: InputMaybe<Organization_Sales_Projection_Bool_Exp>;
};


export type Query_RootOrganization_Sales_Projection_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrganization_TimingArgs = {
  distinct_on?: InputMaybe<Array<Organization_Timing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Timing_Order_By>>;
  where?: InputMaybe<Organization_Timing_Bool_Exp>;
};


export type Query_RootOrganization_Timing_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Timing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Timing_Order_By>>;
  where?: InputMaybe<Organization_Timing_Bool_Exp>;
};


export type Query_RootOrganization_Timing_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrganization_TypeArgs = {
  distinct_on?: InputMaybe<Array<Organization_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Type_Order_By>>;
  where?: InputMaybe<Organization_Type_Bool_Exp>;
};


export type Query_RootOrganization_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Type_Order_By>>;
  where?: InputMaybe<Organization_Type_Bool_Exp>;
};


export type Query_RootOrganization_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootOrganization_UserArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Order_By>>;
  where?: InputMaybe<Organization_User_Bool_Exp>;
};


export type Query_RootOrganization_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Order_By>>;
  where?: InputMaybe<Organization_User_Bool_Exp>;
};


export type Query_RootOrganization_User_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrganization_User_CommissionArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Commission_Order_By>>;
  where?: InputMaybe<Organization_User_Commission_Bool_Exp>;
};


export type Query_RootOrganization_User_Commission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Commission_Order_By>>;
  where?: InputMaybe<Organization_User_Commission_Bool_Exp>;
};


export type Query_RootOrganization_User_Commission_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrganization_User_DocumentArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Document_Order_By>>;
  where?: InputMaybe<Organization_User_Document_Bool_Exp>;
};


export type Query_RootOrganization_User_Document_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Document_Order_By>>;
  where?: InputMaybe<Organization_User_Document_Bool_Exp>;
};


export type Query_RootOrganization_User_Document_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrganization_User_PermissionArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Permission_Order_By>>;
  where?: InputMaybe<Organization_User_Permission_Bool_Exp>;
};


export type Query_RootOrganization_User_Permission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Permission_Order_By>>;
  where?: InputMaybe<Organization_User_Permission_Bool_Exp>;
};


export type Query_RootOrganization_User_Permission_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrganization_User_SubsidiaryArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Subsidiary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Subsidiary_Order_By>>;
  where?: InputMaybe<Organization_User_Subsidiary_Bool_Exp>;
};


export type Query_RootOrganization_User_Subsidiary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Subsidiary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Subsidiary_Order_By>>;
  where?: InputMaybe<Organization_User_Subsidiary_Bool_Exp>;
};


export type Query_RootOrganization_User_Subsidiary_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrganization_User_TypeArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Type_Order_By>>;
  where?: InputMaybe<Organization_User_Type_Bool_Exp>;
};


export type Query_RootOrganization_User_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Type_Order_By>>;
  where?: InputMaybe<Organization_User_Type_Bool_Exp>;
};


export type Query_RootOrganization_User_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootOwnership_TypeArgs = {
  distinct_on?: InputMaybe<Array<Ownership_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ownership_Type_Order_By>>;
  where?: InputMaybe<Ownership_Type_Bool_Exp>;
};


export type Query_RootOwnership_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ownership_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ownership_Type_Order_By>>;
  where?: InputMaybe<Ownership_Type_Bool_Exp>;
};


export type Query_RootOwnership_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootPartnerArgs = {
  distinct_on?: InputMaybe<Array<Partner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_By>>;
  where?: InputMaybe<Partner_Bool_Exp>;
};


export type Query_RootPartner_AddressArgs = {
  distinct_on?: InputMaybe<Array<Partner_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Address_Order_By>>;
  where?: InputMaybe<Partner_Address_Bool_Exp>;
};


export type Query_RootPartner_Address_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Address_Order_By>>;
  where?: InputMaybe<Partner_Address_Bool_Exp>;
};


export type Query_RootPartner_Address_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPartner_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_By>>;
  where?: InputMaybe<Partner_Bool_Exp>;
};


export type Query_RootPartner_Bank_DetailsArgs = {
  distinct_on?: InputMaybe<Array<Partner_Bank_Details_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Bank_Details_Order_By>>;
  where?: InputMaybe<Partner_Bank_Details_Bool_Exp>;
};


export type Query_RootPartner_Bank_Details_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Bank_Details_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Bank_Details_Order_By>>;
  where?: InputMaybe<Partner_Bank_Details_Bool_Exp>;
};


export type Query_RootPartner_Bank_Details_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPartner_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPartner_CommissionArgs = {
  distinct_on?: InputMaybe<Array<Partner_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Commission_Order_By>>;
  where?: InputMaybe<Partner_Commission_Bool_Exp>;
};


export type Query_RootPartner_Commission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Commission_Order_By>>;
  where?: InputMaybe<Partner_Commission_Bool_Exp>;
};


export type Query_RootPartner_Commission_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPartner_Commission_Product_Variation_TypeArgs = {
  distinct_on?: InputMaybe<Array<Partner_Commission_Product_Variation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Commission_Product_Variation_Type_Order_By>>;
  where?: InputMaybe<Partner_Commission_Product_Variation_Type_Bool_Exp>;
};


export type Query_RootPartner_Commission_Product_Variation_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Commission_Product_Variation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Commission_Product_Variation_Type_Order_By>>;
  where?: InputMaybe<Partner_Commission_Product_Variation_Type_Bool_Exp>;
};


export type Query_RootPartner_Commission_Product_Variation_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPartner_Contact_TypeArgs = {
  distinct_on?: InputMaybe<Array<Partner_Contact_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Contact_Type_Order_By>>;
  where?: InputMaybe<Partner_Contact_Type_Bool_Exp>;
};


export type Query_RootPartner_Contact_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Contact_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Contact_Type_Order_By>>;
  where?: InputMaybe<Partner_Contact_Type_Bool_Exp>;
};


export type Query_RootPartner_Contact_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootPartner_LocalitiesArgs = {
  distinct_on?: InputMaybe<Array<Partner_Localities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Localities_Order_By>>;
  where?: InputMaybe<Partner_Localities_Bool_Exp>;
};


export type Query_RootPartner_Localities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Localities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Localities_Order_By>>;
  where?: InputMaybe<Partner_Localities_Bool_Exp>;
};


export type Query_RootPartner_Localities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPartner_Localities_SlotsArgs = {
  distinct_on?: InputMaybe<Array<Partner_Localities_Slots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Localities_Slots_Order_By>>;
  where?: InputMaybe<Partner_Localities_Slots_Bool_Exp>;
};


export type Query_RootPartner_Localities_Slots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Localities_Slots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Localities_Slots_Order_By>>;
  where?: InputMaybe<Partner_Localities_Slots_Bool_Exp>;
};


export type Query_RootPartner_Localities_Slots_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPartner_OrderArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Order_By>>;
  where?: InputMaybe<Partner_Order_Bool_Exp>;
};


export type Query_RootPartner_Order_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Order_By>>;
  where?: InputMaybe<Partner_Order_Bool_Exp>;
};


export type Query_RootPartner_Order_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPartner_Order_Customer_AssetArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Customer_Asset_Order_By>>;
  where?: InputMaybe<Partner_Order_Customer_Asset_Bool_Exp>;
};


export type Query_RootPartner_Order_Customer_Asset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Customer_Asset_Order_By>>;
  where?: InputMaybe<Partner_Order_Customer_Asset_Bool_Exp>;
};


export type Query_RootPartner_Order_Customer_Asset_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPartner_Order_ItemArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Bool_Exp>;
};


export type Query_RootPartner_Order_Item_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Bool_Exp>;
};


export type Query_RootPartner_Order_Item_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPartner_Order_Item_CommissionArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Commission_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Commission_Bool_Exp>;
};


export type Query_RootPartner_Order_Item_Commission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Commission_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Commission_Bool_Exp>;
};


export type Query_RootPartner_Order_Item_Commission_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPartner_Order_Item_StateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_State_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_State_Bool_Exp>;
};


export type Query_RootPartner_Order_Item_State_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_State_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_State_Bool_Exp>;
};


export type Query_RootPartner_Order_Item_State_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootPartner_Order_Item_StateflowArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Stateflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Stateflow_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Stateflow_Bool_Exp>;
};


export type Query_RootPartner_Order_Item_Stateflow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Stateflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Stateflow_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Stateflow_Bool_Exp>;
};


export type Query_RootPartner_Order_Item_Stateflow_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPartner_Order_Item_Test_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Test_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Test_Category_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Test_Category_Bool_Exp>;
};


export type Query_RootPartner_Order_Item_Test_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Test_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Test_Category_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Test_Category_Bool_Exp>;
};


export type Query_RootPartner_Order_Item_Test_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPartner_Order_Item_Test_ResultsArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Test_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Test_Results_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Test_Results_Bool_Exp>;
};


export type Query_RootPartner_Order_Item_Test_Results_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Test_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Test_Results_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Test_Results_Bool_Exp>;
};


export type Query_RootPartner_Order_Item_Test_Results_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPartner_Order_Item_Test_Results_PhotosArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Test_Results_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Test_Results_Photos_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Test_Results_Photos_Bool_Exp>;
};


export type Query_RootPartner_Order_Item_Test_Results_Photos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Test_Results_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Test_Results_Photos_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Test_Results_Photos_Bool_Exp>;
};


export type Query_RootPartner_Order_Item_Test_Results_Photos_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPartner_Order_Item_ValueArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Value_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Value_Bool_Exp>;
};


export type Query_RootPartner_Order_Item_Value_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Value_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Value_Bool_Exp>;
};


export type Query_RootPartner_Order_Item_Value_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPartner_Order_Partner_User_DocumentArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Partner_User_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Partner_User_Document_Order_By>>;
  where?: InputMaybe<Partner_Order_Partner_User_Document_Bool_Exp>;
};


export type Query_RootPartner_Order_Partner_User_Document_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Partner_User_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Partner_User_Document_Order_By>>;
  where?: InputMaybe<Partner_Order_Partner_User_Document_Bool_Exp>;
};


export type Query_RootPartner_Order_Partner_User_Document_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPartner_Order_StateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_State_Order_By>>;
  where?: InputMaybe<Partner_Order_State_Bool_Exp>;
};


export type Query_RootPartner_Order_State_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_State_Order_By>>;
  where?: InputMaybe<Partner_Order_State_Bool_Exp>;
};


export type Query_RootPartner_Order_State_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootPartner_Order_StateflowArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Stateflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Stateflow_Order_By>>;
  where?: InputMaybe<Partner_Order_Stateflow_Bool_Exp>;
};


export type Query_RootPartner_Order_Stateflow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Stateflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Stateflow_Order_By>>;
  where?: InputMaybe<Partner_Order_Stateflow_Bool_Exp>;
};


export type Query_RootPartner_Order_Stateflow_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPartner_PaymentArgs = {
  distinct_on?: InputMaybe<Array<Partner_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Payment_Order_By>>;
  where?: InputMaybe<Partner_Payment_Bool_Exp>;
};


export type Query_RootPartner_Payment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Payment_Order_By>>;
  where?: InputMaybe<Partner_Payment_Bool_Exp>;
};


export type Query_RootPartner_Payment_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPartner_ProductArgs = {
  distinct_on?: InputMaybe<Array<Partner_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Product_Order_By>>;
  where?: InputMaybe<Partner_Product_Bool_Exp>;
};


export type Query_RootPartner_Product_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Product_Order_By>>;
  where?: InputMaybe<Partner_Product_Bool_Exp>;
};


export type Query_RootPartner_Product_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPartner_RelationshipArgs = {
  distinct_on?: InputMaybe<Array<Partner_Relationship_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Relationship_Order_By>>;
  where?: InputMaybe<Partner_Relationship_Bool_Exp>;
};


export type Query_RootPartner_Relationship_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Relationship_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Relationship_Order_By>>;
  where?: InputMaybe<Partner_Relationship_Bool_Exp>;
};


export type Query_RootPartner_Relationship_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPartner_SellerArgs = {
  distinct_on?: InputMaybe<Array<Partner_Seller_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Seller_Order_By>>;
  where?: InputMaybe<Partner_Seller_Bool_Exp>;
};


export type Query_RootPartner_Seller_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Seller_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Seller_Order_By>>;
  where?: InputMaybe<Partner_Seller_Bool_Exp>;
};


export type Query_RootPartner_Seller_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPartner_Seller_TypeArgs = {
  distinct_on?: InputMaybe<Array<Partner_Seller_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Seller_Type_Order_By>>;
  where?: InputMaybe<Partner_Seller_Type_Bool_Exp>;
};


export type Query_RootPartner_Seller_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Seller_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Seller_Type_Order_By>>;
  where?: InputMaybe<Partner_Seller_Type_Bool_Exp>;
};


export type Query_RootPartner_Seller_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPartner_Signing_AuthorityArgs = {
  distinct_on?: InputMaybe<Array<Partner_Signing_Authority_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Signing_Authority_Order_By>>;
  where?: InputMaybe<Partner_Signing_Authority_Bool_Exp>;
};


export type Query_RootPartner_Signing_Authority_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Signing_Authority_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Signing_Authority_Order_By>>;
  where?: InputMaybe<Partner_Signing_Authority_Bool_Exp>;
};


export type Query_RootPartner_Signing_Authority_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPartner_TimingArgs = {
  distinct_on?: InputMaybe<Array<Partner_Timing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Timing_Order_By>>;
  where?: InputMaybe<Partner_Timing_Bool_Exp>;
};


export type Query_RootPartner_Timing_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Timing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Timing_Order_By>>;
  where?: InputMaybe<Partner_Timing_Bool_Exp>;
};


export type Query_RootPartner_Timing_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPartner_TypeArgs = {
  distinct_on?: InputMaybe<Array<Partner_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Type_Order_By>>;
  where?: InputMaybe<Partner_Type_Bool_Exp>;
};


export type Query_RootPartner_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Type_Order_By>>;
  where?: InputMaybe<Partner_Type_Bool_Exp>;
};


export type Query_RootPartner_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootPartner_UserArgs = {
  distinct_on?: InputMaybe<Array<Partner_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_User_Order_By>>;
  where?: InputMaybe<Partner_User_Bool_Exp>;
};


export type Query_RootPartner_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_User_Order_By>>;
  where?: InputMaybe<Partner_User_Bool_Exp>;
};


export type Query_RootPartner_User_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPartner_User_DocumentArgs = {
  distinct_on?: InputMaybe<Array<Partner_User_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_User_Document_Order_By>>;
  where?: InputMaybe<Partner_User_Document_Bool_Exp>;
};


export type Query_RootPartner_User_Document_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_User_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_User_Document_Order_By>>;
  where?: InputMaybe<Partner_User_Document_Bool_Exp>;
};


export type Query_RootPartner_User_Document_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPartner_User_PermissionArgs = {
  distinct_on?: InputMaybe<Array<Partner_User_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_User_Permission_Order_By>>;
  where?: InputMaybe<Partner_User_Permission_Bool_Exp>;
};


export type Query_RootPartner_User_Permission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_User_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_User_Permission_Order_By>>;
  where?: InputMaybe<Partner_User_Permission_Bool_Exp>;
};


export type Query_RootPartner_User_Permission_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPartner_VehicleArgs = {
  distinct_on?: InputMaybe<Array<Partner_Vehicle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Vehicle_Order_By>>;
  where?: InputMaybe<Partner_Vehicle_Bool_Exp>;
};


export type Query_RootPartner_Vehicle_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Vehicle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Vehicle_Order_By>>;
  where?: InputMaybe<Partner_Vehicle_Bool_Exp>;
};


export type Query_RootPartner_Vehicle_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPartner_Vehicle_StateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Vehicle_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Vehicle_State_Order_By>>;
  where?: InputMaybe<Partner_Vehicle_State_Bool_Exp>;
};


export type Query_RootPartner_Vehicle_State_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Vehicle_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Vehicle_State_Order_By>>;
  where?: InputMaybe<Partner_Vehicle_State_Bool_Exp>;
};


export type Query_RootPartner_Vehicle_State_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootPayment_TypeArgs = {
  distinct_on?: InputMaybe<Array<Payment_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Type_Order_By>>;
  where?: InputMaybe<Payment_Type_Bool_Exp>;
};


export type Query_RootPayment_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Type_Order_By>>;
  where?: InputMaybe<Payment_Type_Bool_Exp>;
};


export type Query_RootPayment_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootPeriod_FrequencyArgs = {
  distinct_on?: InputMaybe<Array<Period_Frequency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Period_Frequency_Order_By>>;
  where?: InputMaybe<Period_Frequency_Bool_Exp>;
};


export type Query_RootPeriod_Frequency_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Period_Frequency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Period_Frequency_Order_By>>;
  where?: InputMaybe<Period_Frequency_Bool_Exp>;
};


export type Query_RootPeriod_Frequency_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootPermissionArgs = {
  distinct_on?: InputMaybe<Array<Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permission_Order_By>>;
  where?: InputMaybe<Permission_Bool_Exp>;
};


export type Query_RootPermission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permission_Order_By>>;
  where?: InputMaybe<Permission_Bool_Exp>;
};


export type Query_RootPermission_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPermitArgs = {
  distinct_on?: InputMaybe<Array<Permit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permit_Order_By>>;
  where?: InputMaybe<Permit_Bool_Exp>;
};


export type Query_RootPermit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Permit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permit_Order_By>>;
  where?: InputMaybe<Permit_Bool_Exp>;
};


export type Query_RootPermit_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPhoto_TypeArgs = {
  distinct_on?: InputMaybe<Array<Photo_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Photo_Type_Order_By>>;
  where?: InputMaybe<Photo_Type_Bool_Exp>;
};


export type Query_RootPhoto_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Photo_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Photo_Type_Order_By>>;
  where?: InputMaybe<Photo_Type_Bool_Exp>;
};


export type Query_RootPhoto_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootPlanning_Audit_LogArgs = {
  distinct_on?: InputMaybe<Array<Planning_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Planning_Audit_Log_Order_By>>;
  where?: InputMaybe<Planning_Audit_Log_Bool_Exp>;
};


export type Query_RootPlanning_Audit_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Planning_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Planning_Audit_Log_Order_By>>;
  where?: InputMaybe<Planning_Audit_Log_Bool_Exp>;
};


export type Query_RootPlanning_Audit_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPlanning_PeriodArgs = {
  distinct_on?: InputMaybe<Array<Planning_Period_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Planning_Period_Order_By>>;
  where?: InputMaybe<Planning_Period_Bool_Exp>;
};


export type Query_RootPlanning_Period_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Planning_Period_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Planning_Period_Order_By>>;
  where?: InputMaybe<Planning_Period_Bool_Exp>;
};


export type Query_RootPlanning_Period_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProductArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Query_RootProduct_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Query_RootProduct_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProduct_CommissionArgs = {
  distinct_on?: InputMaybe<Array<Product_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Commission_Order_By>>;
  where?: InputMaybe<Product_Commission_Bool_Exp>;
};


export type Query_RootProduct_Commission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Commission_Order_By>>;
  where?: InputMaybe<Product_Commission_Bool_Exp>;
};


export type Query_RootProduct_Commission_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProduct_DocumentArgs = {
  distinct_on?: InputMaybe<Array<Product_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Document_Order_By>>;
  where?: InputMaybe<Product_Document_Bool_Exp>;
};


export type Query_RootProduct_Document_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Document_Order_By>>;
  where?: InputMaybe<Product_Document_Bool_Exp>;
};


export type Query_RootProduct_Document_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProduct_Partner_Localities_PriceArgs = {
  distinct_on?: InputMaybe<Array<Product_Partner_Localities_Price_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Partner_Localities_Price_Order_By>>;
  where?: InputMaybe<Product_Partner_Localities_Price_Bool_Exp>;
};


export type Query_RootProduct_Partner_Localities_Price_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Partner_Localities_Price_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Partner_Localities_Price_Order_By>>;
  where?: InputMaybe<Product_Partner_Localities_Price_Bool_Exp>;
};


export type Query_RootProduct_Partner_Localities_Price_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProduct_Partner_Localities_Price_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Product_Partner_Localities_Price_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Partner_Localities_Price_History_Order_By>>;
  where?: InputMaybe<Product_Partner_Localities_Price_History_Bool_Exp>;
};


export type Query_RootProduct_Partner_Localities_Price_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Partner_Localities_Price_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Partner_Localities_Price_History_Order_By>>;
  where?: InputMaybe<Product_Partner_Localities_Price_History_Bool_Exp>;
};


export type Query_RootProduct_Partner_Localities_Price_History_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProduct_PhotosArgs = {
  distinct_on?: InputMaybe<Array<Product_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Photos_Order_By>>;
  where?: InputMaybe<Product_Photos_Bool_Exp>;
};


export type Query_RootProduct_Photos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Photos_Order_By>>;
  where?: InputMaybe<Product_Photos_Bool_Exp>;
};


export type Query_RootProduct_Photos_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProduct_TypeArgs = {
  distinct_on?: InputMaybe<Array<Product_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Type_Order_By>>;
  where?: InputMaybe<Product_Type_Bool_Exp>;
};


export type Query_RootProduct_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Type_Order_By>>;
  where?: InputMaybe<Product_Type_Bool_Exp>;
};


export type Query_RootProduct_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootProduct_VariationArgs = {
  distinct_on?: InputMaybe<Array<Product_Variation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Variation_Order_By>>;
  where?: InputMaybe<Product_Variation_Bool_Exp>;
};


export type Query_RootProduct_Variation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Variation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Variation_Order_By>>;
  where?: InputMaybe<Product_Variation_Bool_Exp>;
};


export type Query_RootProduct_Variation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProduct_Variation_Partner_Localities_SlotsArgs = {
  distinct_on?: InputMaybe<Array<Product_Variation_Partner_Localities_Slots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Variation_Partner_Localities_Slots_Order_By>>;
  where?: InputMaybe<Product_Variation_Partner_Localities_Slots_Bool_Exp>;
};


export type Query_RootProduct_Variation_Partner_Localities_Slots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Variation_Partner_Localities_Slots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Variation_Partner_Localities_Slots_Order_By>>;
  where?: InputMaybe<Product_Variation_Partner_Localities_Slots_Bool_Exp>;
};


export type Query_RootProduct_Variation_Partner_Localities_Slots_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProduct_Variation_PhotosArgs = {
  distinct_on?: InputMaybe<Array<Product_Variation_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Variation_Photos_Order_By>>;
  where?: InputMaybe<Product_Variation_Photos_Bool_Exp>;
};


export type Query_RootProduct_Variation_Photos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Variation_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Variation_Photos_Order_By>>;
  where?: InputMaybe<Product_Variation_Photos_Bool_Exp>;
};


export type Query_RootProduct_Variation_Photos_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProduct_Variation_Safety_Checklist_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Product_Variation_Safety_Checklist_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Variation_Safety_Checklist_Category_Order_By>>;
  where?: InputMaybe<Product_Variation_Safety_Checklist_Category_Bool_Exp>;
};


export type Query_RootProduct_Variation_Safety_Checklist_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Variation_Safety_Checklist_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Variation_Safety_Checklist_Category_Order_By>>;
  where?: InputMaybe<Product_Variation_Safety_Checklist_Category_Bool_Exp>;
};


export type Query_RootProduct_Variation_Safety_Checklist_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProduct_Variation_Test_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Product_Variation_Test_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Variation_Test_Category_Order_By>>;
  where?: InputMaybe<Product_Variation_Test_Category_Bool_Exp>;
};


export type Query_RootProduct_Variation_Test_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Variation_Test_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Variation_Test_Category_Order_By>>;
  where?: InputMaybe<Product_Variation_Test_Category_Bool_Exp>;
};


export type Query_RootProduct_Variation_Test_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPurchase_OrderArgs = {
  distinct_on?: InputMaybe<Array<Purchase_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Purchase_Order_Order_By>>;
  where?: InputMaybe<Purchase_Order_Bool_Exp>;
};


export type Query_RootPurchase_Order_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Purchase_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Purchase_Order_Order_By>>;
  where?: InputMaybe<Purchase_Order_Bool_Exp>;
};


export type Query_RootPurchase_Order_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPurchase_Order_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Purchase_Order_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Purchase_Order_Items_Order_By>>;
  where?: InputMaybe<Purchase_Order_Items_Bool_Exp>;
};


export type Query_RootPurchase_Order_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Purchase_Order_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Purchase_Order_Items_Order_By>>;
  where?: InputMaybe<Purchase_Order_Items_Bool_Exp>;
};


export type Query_RootPurchase_Order_Items_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQuantity_Correction_Ticket_StatesArgs = {
  distinct_on?: InputMaybe<Array<Quantity_Correction_Ticket_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quantity_Correction_Ticket_States_Order_By>>;
  where?: InputMaybe<Quantity_Correction_Ticket_States_Bool_Exp>;
};


export type Query_RootQuantity_Correction_Ticket_States_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quantity_Correction_Ticket_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quantity_Correction_Ticket_States_Order_By>>;
  where?: InputMaybe<Quantity_Correction_Ticket_States_Bool_Exp>;
};


export type Query_RootQuantity_Correction_Ticket_States_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootQuantity_Correction_TicketsArgs = {
  distinct_on?: InputMaybe<Array<Quantity_Correction_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quantity_Correction_Tickets_Order_By>>;
  where?: InputMaybe<Quantity_Correction_Tickets_Bool_Exp>;
};


export type Query_RootQuantity_Correction_Tickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quantity_Correction_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quantity_Correction_Tickets_Order_By>>;
  where?: InputMaybe<Quantity_Correction_Tickets_Bool_Exp>;
};


export type Query_RootQuantity_Correction_Tickets_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootReason_TypeArgs = {
  distinct_on?: InputMaybe<Array<Reason_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reason_Type_Order_By>>;
  where?: InputMaybe<Reason_Type_Bool_Exp>;
};


export type Query_RootReason_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reason_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reason_Type_Order_By>>;
  where?: InputMaybe<Reason_Type_Bool_Exp>;
};


export type Query_RootReason_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootReasonsArgs = {
  distinct_on?: InputMaybe<Array<Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reasons_Order_By>>;
  where?: InputMaybe<Reasons_Bool_Exp>;
};


export type Query_RootReasons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reasons_Order_By>>;
  where?: InputMaybe<Reasons_Bool_Exp>;
};


export type Query_RootReasons_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRoleArgs = {
  distinct_on?: InputMaybe<Array<Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Role_Order_By>>;
  where?: InputMaybe<Role_Bool_Exp>;
};


export type Query_RootRole_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Role_Order_By>>;
  where?: InputMaybe<Role_Bool_Exp>;
};


export type Query_RootRole_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRole_DocumentArgs = {
  distinct_on?: InputMaybe<Array<Role_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Role_Document_Order_By>>;
  where?: InputMaybe<Role_Document_Bool_Exp>;
};


export type Query_RootRole_Document_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Role_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Role_Document_Order_By>>;
  where?: InputMaybe<Role_Document_Bool_Exp>;
};


export type Query_RootRole_Document_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSafety_ChecklistArgs = {
  distinct_on?: InputMaybe<Array<Safety_Checklist_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Checklist_Order_By>>;
  where?: InputMaybe<Safety_Checklist_Bool_Exp>;
};


export type Query_RootSafety_Checklist_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Safety_Checklist_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Checklist_Order_By>>;
  where?: InputMaybe<Safety_Checklist_Bool_Exp>;
};


export type Query_RootSafety_Checklist_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSafety_Checklist_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Safety_Checklist_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Checklist_Category_Order_By>>;
  where?: InputMaybe<Safety_Checklist_Category_Bool_Exp>;
};


export type Query_RootSafety_Checklist_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Safety_Checklist_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Checklist_Category_Order_By>>;
  where?: InputMaybe<Safety_Checklist_Category_Bool_Exp>;
};


export type Query_RootSafety_Checklist_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootScript_TypeArgs = {
  distinct_on?: InputMaybe<Array<Script_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Script_Type_Order_By>>;
  where?: InputMaybe<Script_Type_Bool_Exp>;
};


export type Query_RootScript_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Script_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Script_Type_Order_By>>;
  where?: InputMaybe<Script_Type_Bool_Exp>;
};


export type Query_RootScript_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootScriptsArgs = {
  distinct_on?: InputMaybe<Array<Scripts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scripts_Order_By>>;
  where?: InputMaybe<Scripts_Bool_Exp>;
};


export type Query_RootScripts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scripts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scripts_Order_By>>;
  where?: InputMaybe<Scripts_Bool_Exp>;
};


export type Query_RootScripts_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootServicesArgs = {
  distinct_on?: InputMaybe<Array<Services_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Services_Order_By>>;
  where?: InputMaybe<Services_Bool_Exp>;
};


export type Query_RootServices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Services_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Services_Order_By>>;
  where?: InputMaybe<Services_Bool_Exp>;
};


export type Query_RootServices_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootServices_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Services_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Services_Category_Order_By>>;
  where?: InputMaybe<Services_Category_Bool_Exp>;
};


export type Query_RootServices_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Services_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Services_Category_Order_By>>;
  where?: InputMaybe<Services_Category_Bool_Exp>;
};


export type Query_RootServices_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootShift_ScheduleArgs = {
  distinct_on?: InputMaybe<Array<Shift_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shift_Schedule_Order_By>>;
  where?: InputMaybe<Shift_Schedule_Bool_Exp>;
};


export type Query_RootShift_Schedule_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shift_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shift_Schedule_Order_By>>;
  where?: InputMaybe<Shift_Schedule_Bool_Exp>;
};


export type Query_RootShift_Schedule_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootShift_Schedule_DispenserArgs = {
  distinct_on?: InputMaybe<Array<Shift_Schedule_Dispenser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shift_Schedule_Dispenser_Order_By>>;
  where?: InputMaybe<Shift_Schedule_Dispenser_Bool_Exp>;
};


export type Query_RootShift_Schedule_Dispenser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shift_Schedule_Dispenser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shift_Schedule_Dispenser_Order_By>>;
  where?: InputMaybe<Shift_Schedule_Dispenser_Bool_Exp>;
};


export type Query_RootShift_Schedule_Dispenser_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootShift_TemplateArgs = {
  distinct_on?: InputMaybe<Array<Shift_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shift_Template_Order_By>>;
  where?: InputMaybe<Shift_Template_Bool_Exp>;
};


export type Query_RootShift_Template_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shift_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shift_Template_Order_By>>;
  where?: InputMaybe<Shift_Template_Bool_Exp>;
};


export type Query_RootShift_Template_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSlab_TypeArgs = {
  distinct_on?: InputMaybe<Array<Slab_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Slab_Type_Order_By>>;
  where?: InputMaybe<Slab_Type_Bool_Exp>;
};


export type Query_RootSlab_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Slab_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Slab_Type_Order_By>>;
  where?: InputMaybe<Slab_Type_Bool_Exp>;
};


export type Query_RootSlab_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootSource_TypeArgs = {
  distinct_on?: InputMaybe<Array<Source_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Source_Type_Order_By>>;
  where?: InputMaybe<Source_Type_Bool_Exp>;
};


export type Query_RootSource_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Source_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Source_Type_Order_By>>;
  where?: InputMaybe<Source_Type_Bool_Exp>;
};


export type Query_RootSource_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootSpatial_Ref_SysArgs = {
  distinct_on?: InputMaybe<Array<Spatial_Ref_Sys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spatial_Ref_Sys_Order_By>>;
  where?: InputMaybe<Spatial_Ref_Sys_Bool_Exp>;
};


export type Query_RootSpatial_Ref_Sys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spatial_Ref_Sys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spatial_Ref_Sys_Order_By>>;
  where?: InputMaybe<Spatial_Ref_Sys_Bool_Exp>;
};


export type Query_RootSpatial_Ref_Sys_By_PkArgs = {
  srid: Scalars['Int']['input'];
};


export type Query_RootStateArgs = {
  distinct_on?: InputMaybe<Array<State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<State_Order_By>>;
  where?: InputMaybe<State_Bool_Exp>;
};


export type Query_RootState_AggregateArgs = {
  distinct_on?: InputMaybe<Array<State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<State_Order_By>>;
  where?: InputMaybe<State_Bool_Exp>;
};


export type Query_RootState_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSubsidiaryArgs = {
  distinct_on?: InputMaybe<Array<Subsidiary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subsidiary_Order_By>>;
  where?: InputMaybe<Subsidiary_Bool_Exp>;
};


export type Query_RootSubsidiary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subsidiary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subsidiary_Order_By>>;
  where?: InputMaybe<Subsidiary_Bool_Exp>;
};


export type Query_RootSubsidiary_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSupport_TicketsArgs = {
  distinct_on?: InputMaybe<Array<Support_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Support_Tickets_Order_By>>;
  where?: InputMaybe<Support_Tickets_Bool_Exp>;
};


export type Query_RootSupport_Tickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Support_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Support_Tickets_Order_By>>;
  where?: InputMaybe<Support_Tickets_Bool_Exp>;
};


export type Query_RootSupport_Tickets_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSupport_Tickets_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Support_Tickets_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Support_Tickets_Category_Order_By>>;
  where?: InputMaybe<Support_Tickets_Category_Bool_Exp>;
};


export type Query_RootSupport_Tickets_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Support_Tickets_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Support_Tickets_Category_Order_By>>;
  where?: InputMaybe<Support_Tickets_Category_Bool_Exp>;
};


export type Query_RootSupport_Tickets_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSupport_Tickets_PhotosArgs = {
  distinct_on?: InputMaybe<Array<Support_Tickets_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Support_Tickets_Photos_Order_By>>;
  where?: InputMaybe<Support_Tickets_Photos_Bool_Exp>;
};


export type Query_RootSupport_Tickets_Photos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Support_Tickets_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Support_Tickets_Photos_Order_By>>;
  where?: InputMaybe<Support_Tickets_Photos_Bool_Exp>;
};


export type Query_RootSupport_Tickets_Photos_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTagArgs = {
  distinct_on?: InputMaybe<Array<Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Order_By>>;
  where?: InputMaybe<Tag_Bool_Exp>;
};


export type Query_RootTag_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Order_By>>;
  where?: InputMaybe<Tag_Bool_Exp>;
};


export type Query_RootTag_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTank_TypeArgs = {
  distinct_on?: InputMaybe<Array<Tank_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tank_Type_Order_By>>;
  where?: InputMaybe<Tank_Type_Bool_Exp>;
};


export type Query_RootTank_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tank_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tank_Type_Order_By>>;
  where?: InputMaybe<Tank_Type_Bool_Exp>;
};


export type Query_RootTank_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTaskArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


export type Query_RootTask_Action_InstructionArgs = {
  distinct_on?: InputMaybe<Array<Task_Action_Instruction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Action_Instruction_Order_By>>;
  where?: InputMaybe<Task_Action_Instruction_Bool_Exp>;
};


export type Query_RootTask_Action_Instruction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Action_Instruction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Action_Instruction_Order_By>>;
  where?: InputMaybe<Task_Action_Instruction_Bool_Exp>;
};


export type Query_RootTask_Action_Instruction_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTask_Action_TypeArgs = {
  distinct_on?: InputMaybe<Array<Task_Action_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Action_Type_Order_By>>;
  where?: InputMaybe<Task_Action_Type_Bool_Exp>;
};


export type Query_RootTask_Action_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Action_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Action_Type_Order_By>>;
  where?: InputMaybe<Task_Action_Type_Bool_Exp>;
};


export type Query_RootTask_Action_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTask_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


export type Query_RootTask_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTask_Cancellation_ReasonsArgs = {
  distinct_on?: InputMaybe<Array<Task_Cancellation_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Cancellation_Reasons_Order_By>>;
  where?: InputMaybe<Task_Cancellation_Reasons_Bool_Exp>;
};


export type Query_RootTask_Cancellation_Reasons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Cancellation_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Cancellation_Reasons_Order_By>>;
  where?: InputMaybe<Task_Cancellation_Reasons_Bool_Exp>;
};


export type Query_RootTask_Cancellation_Reasons_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTask_StateArgs = {
  distinct_on?: InputMaybe<Array<Task_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_State_Order_By>>;
  where?: InputMaybe<Task_State_Bool_Exp>;
};


export type Query_RootTask_State_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_State_Order_By>>;
  where?: InputMaybe<Task_State_Bool_Exp>;
};


export type Query_RootTask_State_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootTask_States_FlowArgs = {
  distinct_on?: InputMaybe<Array<Task_States_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_States_Flow_Order_By>>;
  where?: InputMaybe<Task_States_Flow_Bool_Exp>;
};


export type Query_RootTask_States_Flow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_States_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_States_Flow_Order_By>>;
  where?: InputMaybe<Task_States_Flow_Bool_Exp>;
};


export type Query_RootTask_States_Flow_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTask_TypeArgs = {
  distinct_on?: InputMaybe<Array<Task_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Type_Order_By>>;
  where?: InputMaybe<Task_Type_Bool_Exp>;
};


export type Query_RootTask_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Type_Order_By>>;
  where?: InputMaybe<Task_Type_Bool_Exp>;
};


export type Query_RootTask_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootTask_ValueArgs = {
  distinct_on?: InputMaybe<Array<Task_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Value_Order_By>>;
  where?: InputMaybe<Task_Value_Bool_Exp>;
};


export type Query_RootTask_Value_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Value_Order_By>>;
  where?: InputMaybe<Task_Value_Bool_Exp>;
};


export type Query_RootTask_Value_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTestArgs = {
  distinct_on?: InputMaybe<Array<Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Test_Order_By>>;
  where?: InputMaybe<Test_Bool_Exp>;
};


export type Query_RootTest_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Test_Order_By>>;
  where?: InputMaybe<Test_Bool_Exp>;
};


export type Query_RootTest_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTest_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Test_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Test_Category_Order_By>>;
  where?: InputMaybe<Test_Category_Bool_Exp>;
};


export type Query_RootTest_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Test_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Test_Category_Order_By>>;
  where?: InputMaybe<Test_Category_Bool_Exp>;
};


export type Query_RootTest_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTicket_StateArgs = {
  distinct_on?: InputMaybe<Array<Ticket_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ticket_State_Order_By>>;
  where?: InputMaybe<Ticket_State_Bool_Exp>;
};


export type Query_RootTicket_State_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ticket_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ticket_State_Order_By>>;
  where?: InputMaybe<Ticket_State_Bool_Exp>;
};


export type Query_RootTicket_State_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootTicket_TypeArgs = {
  distinct_on?: InputMaybe<Array<Ticket_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ticket_Type_Order_By>>;
  where?: InputMaybe<Ticket_Type_Bool_Exp>;
};


export type Query_RootTicket_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ticket_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ticket_Type_Order_By>>;
  where?: InputMaybe<Ticket_Type_Bool_Exp>;
};


export type Query_RootTicket_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootTicketsArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tickets_Order_By>>;
  where?: InputMaybe<Tickets_Bool_Exp>;
};


export type Query_RootTickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tickets_Order_By>>;
  where?: InputMaybe<Tickets_Bool_Exp>;
};


export type Query_RootTickets_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTotalizer_Correction_Ticket_StatesArgs = {
  distinct_on?: InputMaybe<Array<Totalizer_Correction_Ticket_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Totalizer_Correction_Ticket_States_Order_By>>;
  where?: InputMaybe<Totalizer_Correction_Ticket_States_Bool_Exp>;
};


export type Query_RootTotalizer_Correction_Ticket_States_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Totalizer_Correction_Ticket_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Totalizer_Correction_Ticket_States_Order_By>>;
  where?: InputMaybe<Totalizer_Correction_Ticket_States_Bool_Exp>;
};


export type Query_RootTotalizer_Correction_Ticket_States_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootTotalizer_Correction_TicketsArgs = {
  distinct_on?: InputMaybe<Array<Totalizer_Correction_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Totalizer_Correction_Tickets_Order_By>>;
  where?: InputMaybe<Totalizer_Correction_Tickets_Bool_Exp>;
};


export type Query_RootTotalizer_Correction_Tickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Totalizer_Correction_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Totalizer_Correction_Tickets_Order_By>>;
  where?: InputMaybe<Totalizer_Correction_Tickets_Bool_Exp>;
};


export type Query_RootTotalizer_Correction_Tickets_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTransaction_TypeArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transaction_Type_Order_By>>;
  where?: InputMaybe<Transaction_Type_Bool_Exp>;
};


export type Query_RootTransaction_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transaction_Type_Order_By>>;
  where?: InputMaybe<Transaction_Type_Bool_Exp>;
};


export type Query_RootTransaction_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootTripArgs = {
  distinct_on?: InputMaybe<Array<Trip_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trip_Order_By>>;
  where?: InputMaybe<Trip_Bool_Exp>;
};


export type Query_RootTrip_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trip_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trip_Order_By>>;
  where?: InputMaybe<Trip_Bool_Exp>;
};


export type Query_RootTrip_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTrip_LocationArgs = {
  distinct_on?: InputMaybe<Array<Trip_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trip_Location_Order_By>>;
  where?: InputMaybe<Trip_Location_Bool_Exp>;
};


export type Query_RootTrip_Location_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trip_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trip_Location_Order_By>>;
  where?: InputMaybe<Trip_Location_Bool_Exp>;
};


export type Query_RootTrip_Location_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTrip_PlanArgs = {
  distinct_on?: InputMaybe<Array<Trip_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trip_Plan_Order_By>>;
  where?: InputMaybe<Trip_Plan_Bool_Exp>;
};


export type Query_RootTrip_Plan_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trip_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trip_Plan_Order_By>>;
  where?: InputMaybe<Trip_Plan_Bool_Exp>;
};


export type Query_RootTrip_Plan_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUnit_Of_MeasureArgs = {
  distinct_on?: InputMaybe<Array<Unit_Of_Measure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unit_Of_Measure_Order_By>>;
  where?: InputMaybe<Unit_Of_Measure_Bool_Exp>;
};


export type Query_RootUnit_Of_Measure_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unit_Of_Measure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unit_Of_Measure_Order_By>>;
  where?: InputMaybe<Unit_Of_Measure_Bool_Exp>;
};


export type Query_RootUnit_Of_Measure_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootUnit_Of_Measure_MetaArgs = {
  distinct_on?: InputMaybe<Array<Unit_Of_Measure_Meta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unit_Of_Measure_Meta_Order_By>>;
  where?: InputMaybe<Unit_Of_Measure_Meta_Bool_Exp>;
};


export type Query_RootUnit_Of_Measure_Meta_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unit_Of_Measure_Meta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unit_Of_Measure_Meta_Order_By>>;
  where?: InputMaybe<Unit_Of_Measure_Meta_Bool_Exp>;
};


export type Query_RootUnit_Of_Measure_Meta_By_PkArgs = {
  value: Unit_Of_Measure_Enum;
};


export type Query_RootUom_ConversionArgs = {
  distinct_on?: InputMaybe<Array<Uom_Conversion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uom_Conversion_Order_By>>;
  where?: InputMaybe<Uom_Conversion_Bool_Exp>;
};


export type Query_RootUom_Conversion_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uom_Conversion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uom_Conversion_Order_By>>;
  where?: InputMaybe<Uom_Conversion_Bool_Exp>;
};


export type Query_RootUom_Conversion_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUserArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Query_RootUser_Access_Audit_LogArgs = {
  distinct_on?: InputMaybe<Array<User_Access_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Access_Audit_Log_Order_By>>;
  where?: InputMaybe<User_Access_Audit_Log_Bool_Exp>;
};


export type Query_RootUser_Access_Audit_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Access_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Access_Audit_Log_Order_By>>;
  where?: InputMaybe<User_Access_Audit_Log_Bool_Exp>;
};


export type Query_RootUser_Access_Audit_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Query_RootUser_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUser_LedgerArgs = {
  distinct_on?: InputMaybe<Array<User_Ledger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Ledger_Order_By>>;
  where?: InputMaybe<User_Ledger_Bool_Exp>;
};


export type Query_RootUser_Ledger_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Ledger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Ledger_Order_By>>;
  where?: InputMaybe<User_Ledger_Bool_Exp>;
};


export type Query_RootUser_Ledger_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUser_Partner_TypeArgs = {
  distinct_on?: InputMaybe<Array<User_Partner_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Partner_Type_Order_By>>;
  where?: InputMaybe<User_Partner_Type_Bool_Exp>;
};


export type Query_RootUser_Partner_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Partner_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Partner_Type_Order_By>>;
  where?: InputMaybe<User_Partner_Type_Bool_Exp>;
};


export type Query_RootUser_Partner_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootUser_ReferralArgs = {
  distinct_on?: InputMaybe<Array<User_Referral_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Referral_Order_By>>;
  where?: InputMaybe<User_Referral_Bool_Exp>;
};


export type Query_RootUser_Referral_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Referral_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Referral_Order_By>>;
  where?: InputMaybe<User_Referral_Bool_Exp>;
};


export type Query_RootUser_Referral_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUser_RoleArgs = {
  distinct_on?: InputMaybe<Array<User_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Role_Order_By>>;
  where?: InputMaybe<User_Role_Bool_Exp>;
};


export type Query_RootUser_Role_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Role_Order_By>>;
  where?: InputMaybe<User_Role_Bool_Exp>;
};


export type Query_RootUser_Role_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootValidateSlotOverlapArgs = {
  object: ValidateSlotOverlapInput;
};


export type Query_RootValidation_WorkflowsArgs = {
  distinct_on?: InputMaybe<Array<Validation_Workflows_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Validation_Workflows_Order_By>>;
  where?: InputMaybe<Validation_Workflows_Bool_Exp>;
};


export type Query_RootValidation_Workflows_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Validation_Workflows_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Validation_Workflows_Order_By>>;
  where?: InputMaybe<Validation_Workflows_Bool_Exp>;
};


export type Query_RootValidation_Workflows_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootVariationArgs = {
  distinct_on?: InputMaybe<Array<Variation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variation_Order_By>>;
  where?: InputMaybe<Variation_Bool_Exp>;
};


export type Query_RootVariation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variation_Order_By>>;
  where?: InputMaybe<Variation_Bool_Exp>;
};


export type Query_RootVariation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootVariation_TypeArgs = {
  distinct_on?: InputMaybe<Array<Variation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variation_Type_Order_By>>;
  where?: InputMaybe<Variation_Type_Bool_Exp>;
};


export type Query_RootVariation_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variation_Type_Order_By>>;
  where?: InputMaybe<Variation_Type_Bool_Exp>;
};


export type Query_RootVariation_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootVehicleArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Order_By>>;
  where?: InputMaybe<Vehicle_Bool_Exp>;
};


export type Query_RootVehicle_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Order_By>>;
  where?: InputMaybe<Vehicle_Bool_Exp>;
};


export type Query_RootVehicle_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootVehicle_ConfigurationArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Configuration_Order_By>>;
  where?: InputMaybe<Vehicle_Configuration_Bool_Exp>;
};


export type Query_RootVehicle_Configuration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Configuration_Order_By>>;
  where?: InputMaybe<Vehicle_Configuration_Bool_Exp>;
};


export type Query_RootVehicle_Configuration_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootVehicle_DeviceArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Device_Order_By>>;
  where?: InputMaybe<Vehicle_Device_Bool_Exp>;
};


export type Query_RootVehicle_Device_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Device_Order_By>>;
  where?: InputMaybe<Vehicle_Device_Bool_Exp>;
};


export type Query_RootVehicle_Device_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootVehicle_Device_CalibrationArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Device_Calibration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Device_Calibration_Order_By>>;
  where?: InputMaybe<Vehicle_Device_Calibration_Bool_Exp>;
};


export type Query_RootVehicle_Device_Calibration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Device_Calibration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Device_Calibration_Order_By>>;
  where?: InputMaybe<Vehicle_Device_Calibration_Bool_Exp>;
};


export type Query_RootVehicle_Device_Calibration_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootVehicle_Inventory_Transaction_LogsArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Inventory_Transaction_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Inventory_Transaction_Logs_Order_By>>;
  where?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Bool_Exp>;
};


export type Query_RootVehicle_Inventory_Transaction_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Inventory_Transaction_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Inventory_Transaction_Logs_Order_By>>;
  where?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Bool_Exp>;
};


export type Query_RootVehicle_Inventory_Transaction_Logs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootVehicle_LocalitiesArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Localities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Localities_Order_By>>;
  where?: InputMaybe<Vehicle_Localities_Bool_Exp>;
};


export type Query_RootVehicle_Localities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Localities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Localities_Order_By>>;
  where?: InputMaybe<Vehicle_Localities_Bool_Exp>;
};


export type Query_RootVehicle_Localities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootVehicle_PermitArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Permit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Permit_Order_By>>;
  where?: InputMaybe<Vehicle_Permit_Bool_Exp>;
};


export type Query_RootVehicle_Permit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Permit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Permit_Order_By>>;
  where?: InputMaybe<Vehicle_Permit_Bool_Exp>;
};


export type Query_RootVehicle_Permit_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootVehicle_Shift_TemplateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Shift_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Shift_Template_Order_By>>;
  where?: InputMaybe<Vehicle_Shift_Template_Bool_Exp>;
};


export type Query_RootVehicle_Shift_Template_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Shift_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Shift_Template_Order_By>>;
  where?: InputMaybe<Vehicle_Shift_Template_Bool_Exp>;
};


export type Query_RootVehicle_Shift_Template_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootVehicle_StatusArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Status_Order_By>>;
  where?: InputMaybe<Vehicle_Status_Bool_Exp>;
};


export type Query_RootVehicle_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Status_Order_By>>;
  where?: InputMaybe<Vehicle_Status_Bool_Exp>;
};


export type Query_RootVehicle_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootVehicle_Status_LogsArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Status_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Status_Logs_Order_By>>;
  where?: InputMaybe<Vehicle_Status_Logs_Bool_Exp>;
};


export type Query_RootVehicle_Status_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Status_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Status_Logs_Order_By>>;
  where?: InputMaybe<Vehicle_Status_Logs_Bool_Exp>;
};


export type Query_RootVehicle_Status_Logs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootVehicle_Tank_TypeArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Tank_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Tank_Type_Order_By>>;
  where?: InputMaybe<Vehicle_Tank_Type_Bool_Exp>;
};


export type Query_RootVehicle_Tank_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Tank_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Tank_Type_Order_By>>;
  where?: InputMaybe<Vehicle_Tank_Type_Bool_Exp>;
};


export type Query_RootVehicle_Tank_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootVehicle_Tank_Type_Product_VariationArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Tank_Type_Product_Variation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Tank_Type_Product_Variation_Order_By>>;
  where?: InputMaybe<Vehicle_Tank_Type_Product_Variation_Bool_Exp>;
};


export type Query_RootVehicle_Tank_Type_Product_Variation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Tank_Type_Product_Variation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Tank_Type_Product_Variation_Order_By>>;
  where?: InputMaybe<Vehicle_Tank_Type_Product_Variation_Bool_Exp>;
};


export type Query_RootVehicle_Tank_Type_Product_Variation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootVehicle_TypeArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Type_Order_By>>;
  where?: InputMaybe<Vehicle_Type_Bool_Exp>;
};


export type Query_RootVehicle_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Type_Order_By>>;
  where?: InputMaybe<Vehicle_Type_Bool_Exp>;
};


export type Query_RootVehicle_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootVendor_Order_LogsArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Order_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Order_Logs_Order_By>>;
  where?: InputMaybe<Vendor_Order_Logs_Bool_Exp>;
};


export type Query_RootVendor_Order_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Order_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Order_Logs_Order_By>>;
  where?: InputMaybe<Vendor_Order_Logs_Bool_Exp>;
};


export type Query_RootVendor_Order_Logs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootVendor_Sync_StatusArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Sync_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Sync_Status_Order_By>>;
  where?: InputMaybe<Vendor_Sync_Status_Bool_Exp>;
};


export type Query_RootVendor_Sync_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Sync_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Sync_Status_Order_By>>;
  where?: InputMaybe<Vendor_Sync_Status_Bool_Exp>;
};


export type Query_RootVendor_Sync_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootView_Daily_Asset_LimitArgs = {
  distinct_on?: InputMaybe<Array<View_Daily_Asset_Limit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_Daily_Asset_Limit_Order_By>>;
  where?: InputMaybe<View_Daily_Asset_Limit_Bool_Exp>;
};


export type Query_RootView_Daily_Asset_Limit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<View_Daily_Asset_Limit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_Daily_Asset_Limit_Order_By>>;
  where?: InputMaybe<View_Daily_Asset_Limit_Bool_Exp>;
};


export type Query_RootView_Monthly_Asset_LimitArgs = {
  distinct_on?: InputMaybe<Array<View_Monthly_Asset_Limit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_Monthly_Asset_Limit_Order_By>>;
  where?: InputMaybe<View_Monthly_Asset_Limit_Bool_Exp>;
};


export type Query_RootView_Monthly_Asset_Limit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<View_Monthly_Asset_Limit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_Monthly_Asset_Limit_Order_By>>;
  where?: InputMaybe<View_Monthly_Asset_Limit_Bool_Exp>;
};


export type Query_RootView_Unlinked_Customer_AssetsArgs = {
  distinct_on?: InputMaybe<Array<View_Unlinked_Customer_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_Unlinked_Customer_Assets_Order_By>>;
  where?: InputMaybe<View_Unlinked_Customer_Assets_Bool_Exp>;
};


export type Query_RootView_Unlinked_Customer_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<View_Unlinked_Customer_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_Unlinked_Customer_Assets_Order_By>>;
  where?: InputMaybe<View_Unlinked_Customer_Assets_Bool_Exp>;
};


export type Query_RootView_Weekly_Asset_LimitArgs = {
  distinct_on?: InputMaybe<Array<View_Weekly_Asset_Limit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_Weekly_Asset_Limit_Order_By>>;
  where?: InputMaybe<View_Weekly_Asset_Limit_Bool_Exp>;
};


export type Query_RootView_Weekly_Asset_Limit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<View_Weekly_Asset_Limit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_Weekly_Asset_Limit_Order_By>>;
  where?: InputMaybe<View_Weekly_Asset_Limit_Bool_Exp>;
};


export type Query_RootVoucherArgs = {
  distinct_on?: InputMaybe<Array<Voucher_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Voucher_Order_By>>;
  where?: InputMaybe<Voucher_Bool_Exp>;
};


export type Query_RootVoucher_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Voucher_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Voucher_Order_By>>;
  where?: InputMaybe<Voucher_Bool_Exp>;
};


export type Query_RootVoucher_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootWalletArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Order_By>>;
  where?: InputMaybe<Wallet_Bool_Exp>;
};


export type Query_RootWallet_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Order_By>>;
  where?: InputMaybe<Wallet_Bool_Exp>;
};


export type Query_RootWallet_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootWallet_ExceptionArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Exception_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Exception_Order_By>>;
  where?: InputMaybe<Wallet_Exception_Bool_Exp>;
};


export type Query_RootWallet_Exception_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Exception_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Exception_Order_By>>;
  where?: InputMaybe<Wallet_Exception_Bool_Exp>;
};


export type Query_RootWallet_Exception_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootWallet_LedgerArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Ledger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Ledger_Order_By>>;
  where?: InputMaybe<Wallet_Ledger_Bool_Exp>;
};


export type Query_RootWallet_Ledger_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Ledger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Ledger_Order_By>>;
  where?: InputMaybe<Wallet_Ledger_Bool_Exp>;
};


export type Query_RootWallet_Ledger_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootWallet_StateArgs = {
  distinct_on?: InputMaybe<Array<Wallet_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_State_Order_By>>;
  where?: InputMaybe<Wallet_State_Bool_Exp>;
};


export type Query_RootWallet_State_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wallet_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_State_Order_By>>;
  where?: InputMaybe<Wallet_State_Bool_Exp>;
};


export type Query_RootWallet_State_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootWallet_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Transactions_Order_By>>;
  where?: InputMaybe<Wallet_Transactions_Bool_Exp>;
};


export type Query_RootWallet_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Transactions_Order_By>>;
  where?: InputMaybe<Wallet_Transactions_Bool_Exp>;
};


export type Query_RootWallet_Transactions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "reason_type" */
export type Reason_Type = {
  __typename?: 'reason_type';
  /** An array relationship */
  cancellation_reasons: Array<Cancellation_Reasons>;
  /** An aggregate relationship */
  cancellation_reasons_aggregate: Cancellation_Reasons_Aggregate;
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  reasons: Array<Reasons>;
  /** An aggregate relationship */
  reasons_aggregate: Reasons_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "reason_type" */
export type Reason_TypeCancellation_ReasonsArgs = {
  distinct_on?: InputMaybe<Array<Cancellation_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cancellation_Reasons_Order_By>>;
  where?: InputMaybe<Cancellation_Reasons_Bool_Exp>;
};


/** columns and relationships of "reason_type" */
export type Reason_TypeCancellation_Reasons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cancellation_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cancellation_Reasons_Order_By>>;
  where?: InputMaybe<Cancellation_Reasons_Bool_Exp>;
};


/** columns and relationships of "reason_type" */
export type Reason_TypeReasonsArgs = {
  distinct_on?: InputMaybe<Array<Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reasons_Order_By>>;
  where?: InputMaybe<Reasons_Bool_Exp>;
};


/** columns and relationships of "reason_type" */
export type Reason_TypeReasons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reasons_Order_By>>;
  where?: InputMaybe<Reasons_Bool_Exp>;
};

/** aggregated selection of "reason_type" */
export type Reason_Type_Aggregate = {
  __typename?: 'reason_type_aggregate';
  aggregate?: Maybe<Reason_Type_Aggregate_Fields>;
  nodes: Array<Reason_Type>;
};

/** aggregate fields of "reason_type" */
export type Reason_Type_Aggregate_Fields = {
  __typename?: 'reason_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Reason_Type_Max_Fields>;
  min?: Maybe<Reason_Type_Min_Fields>;
};


/** aggregate fields of "reason_type" */
export type Reason_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Reason_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "reason_type". All fields are combined with a logical 'AND'. */
export type Reason_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Reason_Type_Bool_Exp>>;
  _not?: InputMaybe<Reason_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Reason_Type_Bool_Exp>>;
  cancellation_reasons?: InputMaybe<Cancellation_Reasons_Bool_Exp>;
  cancellation_reasons_aggregate?: InputMaybe<Cancellation_Reasons_Aggregate_Bool_Exp>;
  comment?: InputMaybe<String_Comparison_Exp>;
  reasons?: InputMaybe<Reasons_Bool_Exp>;
  reasons_aggregate?: InputMaybe<Reasons_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "reason_type" */
export enum Reason_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  ReasonTypePkey = 'reason_type_pkey'
}

export enum Reason_Type_Enum {
  /** ADDRESS_CORRECTION */
  AddressCorrection = 'ADDRESS_CORRECTION',
  /** ASSET_CORRECTION */
  AssetCorrection = 'ASSET_CORRECTION',
  /** CUSTOMER_ORDER */
  CustomerOrder = 'CUSTOMER_ORDER',
  /** CUSTOMER_ORDER_ITEM */
  CustomerOrderItem = 'CUSTOMER_ORDER_ITEM',
  /** CUSTOMER_ORDER_ITEM_ETD_CHANGED */
  CustomerOrderItemEtdChanged = 'CUSTOMER_ORDER_ITEM_ETD_CHANGED',
  /** Reasons ops selects when cancelling a customer adhoc order from the Order Review page (pre-acceptance). */
  CustomerOrderOpsCancellation = 'CUSTOMER_ORDER_OPS_CANCELLATION',
  /** Reasons for rejecting an inventory fillup request */
  InventoryRejection = 'INVENTORY_REJECTION',
  /** ODOMETER_CORRECTION */
  OdometerCorrection = 'ODOMETER_CORRECTION',
  /** ODOMETER_MISS_REASON */
  OdometerMissReason = 'ODOMETER_MISS_REASON',
  /** ORDER_CANCELLATION */
  OrderCancellation = 'ORDER_CANCELLATION',
  /** ORDER_CLOSE */
  OrderClose = 'ORDER_CLOSE',
  /** ORGANIZATION_STATUS_CHANGE */
  OrganizationStatusChange = 'ORGANIZATION_STATUS_CHANGE',
  /** QUANTITY_CORRECTION */
  QuantityCorrection = 'QUANTITY_CORRECTION'
}

/** Boolean expression to compare columns of type "reason_type_enum". All fields are combined with logical 'AND'. */
export type Reason_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Reason_Type_Enum>;
  _in?: InputMaybe<Array<Reason_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Reason_Type_Enum>;
  _nin?: InputMaybe<Array<Reason_Type_Enum>>;
};

/** input type for inserting data into table "reason_type" */
export type Reason_Type_Insert_Input = {
  cancellation_reasons?: InputMaybe<Cancellation_Reasons_Arr_Rel_Insert_Input>;
  comment?: InputMaybe<Scalars['String']['input']>;
  reasons?: InputMaybe<Reasons_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Reason_Type_Max_Fields = {
  __typename?: 'reason_type_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Reason_Type_Min_Fields = {
  __typename?: 'reason_type_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "reason_type" */
export type Reason_Type_Mutation_Response = {
  __typename?: 'reason_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Reason_Type>;
};

/** input type for inserting object relation for remote table "reason_type" */
export type Reason_Type_Obj_Rel_Insert_Input = {
  data: Reason_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Reason_Type_On_Conflict>;
};

/** on_conflict condition type for table "reason_type" */
export type Reason_Type_On_Conflict = {
  constraint: Reason_Type_Constraint;
  update_columns?: Array<Reason_Type_Update_Column>;
  where?: InputMaybe<Reason_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "reason_type". */
export type Reason_Type_Order_By = {
  cancellation_reasons_aggregate?: InputMaybe<Cancellation_Reasons_Aggregate_Order_By>;
  comment?: InputMaybe<Order_By>;
  reasons_aggregate?: InputMaybe<Reasons_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: reason_type */
export type Reason_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "reason_type" */
export enum Reason_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "reason_type" */
export type Reason_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "reason_type" */
export type Reason_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Reason_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Reason_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "reason_type" */
export enum Reason_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Reason_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Reason_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Reason_Type_Bool_Exp;
};

/** columns and relationships of "reasons" */
export type Reasons = {
  __typename?: 'reasons';
  accountability?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  customer_asset_audit_logs: Array<Customer_Asset_Audit_Log>;
  /** An aggregate relationship */
  customer_asset_audit_logs_aggregate: Customer_Asset_Audit_Log_Aggregate;
  /** An array relationship */
  customer_assets: Array<Customer_Asset>;
  /** An aggregate relationship */
  customer_assets_aggregate: Customer_Asset_Aggregate;
  /** An array relationship */
  fillup_requests: Array<Fillup_Request>;
  /** An aggregate relationship */
  fillup_requests_aggregate: Fillup_Request_Aggregate;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  invoiced_item_cancellation_tickets: Array<Invoiced_Item_Cancellation_Tickets>;
  /** An aggregate relationship */
  invoiced_item_cancellation_tickets_aggregate: Invoiced_Item_Cancellation_Tickets_Aggregate;
  is_active: Scalars['Boolean']['output'];
  last_modified: Scalars['timestamptz']['output'];
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  organization_audit_logs: Array<Organization_Audit_Log>;
  /** An aggregate relationship */
  organization_audit_logs_aggregate: Organization_Audit_Log_Aggregate;
  /** An array relationship */
  quantity_correction_tickets: Array<Quantity_Correction_Tickets>;
  /** An aggregate relationship */
  quantity_correction_tickets_aggregate: Quantity_Correction_Tickets_Aggregate;
  rank_id?: Maybe<Scalars['Int']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  reasonTypeByReasonType: Reason_Type;
  reason_type: Reason_Type_Enum;
  /** An array relationship */
  task_values: Array<Task_Value>;
  /** An aggregate relationship */
  task_values_aggregate: Task_Value_Aggregate;
  /** An array relationship */
  tickets: Array<Tickets>;
  /** An aggregate relationship */
  tickets_aggregate: Tickets_Aggregate;
  /** An array relationship */
  totalizer_correction_tickets: Array<Totalizer_Correction_Tickets>;
  /** An aggregate relationship */
  totalizer_correction_tickets_aggregate: Totalizer_Correction_Tickets_Aggregate;
};


/** columns and relationships of "reasons" */
export type ReasonsCustomer_Asset_Audit_LogsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Audit_Log_Order_By>>;
  where?: InputMaybe<Customer_Asset_Audit_Log_Bool_Exp>;
};


/** columns and relationships of "reasons" */
export type ReasonsCustomer_Asset_Audit_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Audit_Log_Order_By>>;
  where?: InputMaybe<Customer_Asset_Audit_Log_Bool_Exp>;
};


/** columns and relationships of "reasons" */
export type ReasonsCustomer_AssetsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Order_By>>;
  where?: InputMaybe<Customer_Asset_Bool_Exp>;
};


/** columns and relationships of "reasons" */
export type ReasonsCustomer_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Order_By>>;
  where?: InputMaybe<Customer_Asset_Bool_Exp>;
};


/** columns and relationships of "reasons" */
export type ReasonsFillup_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Fillup_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fillup_Request_Order_By>>;
  where?: InputMaybe<Fillup_Request_Bool_Exp>;
};


/** columns and relationships of "reasons" */
export type ReasonsFillup_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fillup_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fillup_Request_Order_By>>;
  where?: InputMaybe<Fillup_Request_Bool_Exp>;
};


/** columns and relationships of "reasons" */
export type ReasonsInvoiced_Item_Cancellation_TicketsArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Cancellation_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Cancellation_Tickets_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Bool_Exp>;
};


/** columns and relationships of "reasons" */
export type ReasonsInvoiced_Item_Cancellation_Tickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Cancellation_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Cancellation_Tickets_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Bool_Exp>;
};


/** columns and relationships of "reasons" */
export type ReasonsOrganization_Audit_LogsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Audit_Log_Order_By>>;
  where?: InputMaybe<Organization_Audit_Log_Bool_Exp>;
};


/** columns and relationships of "reasons" */
export type ReasonsOrganization_Audit_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Audit_Log_Order_By>>;
  where?: InputMaybe<Organization_Audit_Log_Bool_Exp>;
};


/** columns and relationships of "reasons" */
export type ReasonsQuantity_Correction_TicketsArgs = {
  distinct_on?: InputMaybe<Array<Quantity_Correction_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quantity_Correction_Tickets_Order_By>>;
  where?: InputMaybe<Quantity_Correction_Tickets_Bool_Exp>;
};


/** columns and relationships of "reasons" */
export type ReasonsQuantity_Correction_Tickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quantity_Correction_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quantity_Correction_Tickets_Order_By>>;
  where?: InputMaybe<Quantity_Correction_Tickets_Bool_Exp>;
};


/** columns and relationships of "reasons" */
export type ReasonsTask_ValuesArgs = {
  distinct_on?: InputMaybe<Array<Task_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Value_Order_By>>;
  where?: InputMaybe<Task_Value_Bool_Exp>;
};


/** columns and relationships of "reasons" */
export type ReasonsTask_Values_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Value_Order_By>>;
  where?: InputMaybe<Task_Value_Bool_Exp>;
};


/** columns and relationships of "reasons" */
export type ReasonsTicketsArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tickets_Order_By>>;
  where?: InputMaybe<Tickets_Bool_Exp>;
};


/** columns and relationships of "reasons" */
export type ReasonsTickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tickets_Order_By>>;
  where?: InputMaybe<Tickets_Bool_Exp>;
};


/** columns and relationships of "reasons" */
export type ReasonsTotalizer_Correction_TicketsArgs = {
  distinct_on?: InputMaybe<Array<Totalizer_Correction_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Totalizer_Correction_Tickets_Order_By>>;
  where?: InputMaybe<Totalizer_Correction_Tickets_Bool_Exp>;
};


/** columns and relationships of "reasons" */
export type ReasonsTotalizer_Correction_Tickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Totalizer_Correction_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Totalizer_Correction_Tickets_Order_By>>;
  where?: InputMaybe<Totalizer_Correction_Tickets_Bool_Exp>;
};

/** aggregated selection of "reasons" */
export type Reasons_Aggregate = {
  __typename?: 'reasons_aggregate';
  aggregate?: Maybe<Reasons_Aggregate_Fields>;
  nodes: Array<Reasons>;
};

export type Reasons_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Reasons_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Reasons_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Reasons_Aggregate_Bool_Exp_Count>;
};

export type Reasons_Aggregate_Bool_Exp_Bool_And = {
  arguments: Reasons_Select_Column_Reasons_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reasons_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Reasons_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Reasons_Select_Column_Reasons_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reasons_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Reasons_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Reasons_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reasons_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "reasons" */
export type Reasons_Aggregate_Fields = {
  __typename?: 'reasons_aggregate_fields';
  avg?: Maybe<Reasons_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Reasons_Max_Fields>;
  min?: Maybe<Reasons_Min_Fields>;
  stddev?: Maybe<Reasons_Stddev_Fields>;
  stddev_pop?: Maybe<Reasons_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Reasons_Stddev_Samp_Fields>;
  sum?: Maybe<Reasons_Sum_Fields>;
  var_pop?: Maybe<Reasons_Var_Pop_Fields>;
  var_samp?: Maybe<Reasons_Var_Samp_Fields>;
  variance?: Maybe<Reasons_Variance_Fields>;
};


/** aggregate fields of "reasons" */
export type Reasons_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Reasons_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "reasons" */
export type Reasons_Aggregate_Order_By = {
  avg?: InputMaybe<Reasons_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Reasons_Max_Order_By>;
  min?: InputMaybe<Reasons_Min_Order_By>;
  stddev?: InputMaybe<Reasons_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Reasons_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Reasons_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Reasons_Sum_Order_By>;
  var_pop?: InputMaybe<Reasons_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Reasons_Var_Samp_Order_By>;
  variance?: InputMaybe<Reasons_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "reasons" */
export type Reasons_Arr_Rel_Insert_Input = {
  data: Array<Reasons_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Reasons_On_Conflict>;
};

/** aggregate avg on columns */
export type Reasons_Avg_Fields = {
  __typename?: 'reasons_avg_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "reasons" */
export type Reasons_Avg_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "reasons". All fields are combined with a logical 'AND'. */
export type Reasons_Bool_Exp = {
  _and?: InputMaybe<Array<Reasons_Bool_Exp>>;
  _not?: InputMaybe<Reasons_Bool_Exp>;
  _or?: InputMaybe<Array<Reasons_Bool_Exp>>;
  accountability?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  customer_asset_audit_logs?: InputMaybe<Customer_Asset_Audit_Log_Bool_Exp>;
  customer_asset_audit_logs_aggregate?: InputMaybe<Customer_Asset_Audit_Log_Aggregate_Bool_Exp>;
  customer_assets?: InputMaybe<Customer_Asset_Bool_Exp>;
  customer_assets_aggregate?: InputMaybe<Customer_Asset_Aggregate_Bool_Exp>;
  fillup_requests?: InputMaybe<Fillup_Request_Bool_Exp>;
  fillup_requests_aggregate?: InputMaybe<Fillup_Request_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invoiced_item_cancellation_tickets?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Bool_Exp>;
  invoiced_item_cancellation_tickets_aggregate?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Aggregate_Bool_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  organization_audit_logs?: InputMaybe<Organization_Audit_Log_Bool_Exp>;
  organization_audit_logs_aggregate?: InputMaybe<Organization_Audit_Log_Aggregate_Bool_Exp>;
  quantity_correction_tickets?: InputMaybe<Quantity_Correction_Tickets_Bool_Exp>;
  quantity_correction_tickets_aggregate?: InputMaybe<Quantity_Correction_Tickets_Aggregate_Bool_Exp>;
  rank_id?: InputMaybe<Int_Comparison_Exp>;
  reason?: InputMaybe<String_Comparison_Exp>;
  reasonTypeByReasonType?: InputMaybe<Reason_Type_Bool_Exp>;
  reason_type?: InputMaybe<Reason_Type_Enum_Comparison_Exp>;
  task_values?: InputMaybe<Task_Value_Bool_Exp>;
  task_values_aggregate?: InputMaybe<Task_Value_Aggregate_Bool_Exp>;
  tickets?: InputMaybe<Tickets_Bool_Exp>;
  tickets_aggregate?: InputMaybe<Tickets_Aggregate_Bool_Exp>;
  totalizer_correction_tickets?: InputMaybe<Totalizer_Correction_Tickets_Bool_Exp>;
  totalizer_correction_tickets_aggregate?: InputMaybe<Totalizer_Correction_Tickets_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "reasons" */
export enum Reasons_Constraint {
  /** unique or primary key constraint on columns "id" */
  ReasonsPkey = 'reasons_pkey'
}

/** input type for incrementing numeric columns in table "reasons" */
export type Reasons_Inc_Input = {
  rank_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "reasons" */
export type Reasons_Insert_Input = {
  accountability?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  customer_asset_audit_logs?: InputMaybe<Customer_Asset_Audit_Log_Arr_Rel_Insert_Input>;
  customer_assets?: InputMaybe<Customer_Asset_Arr_Rel_Insert_Input>;
  fillup_requests?: InputMaybe<Fillup_Request_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invoiced_item_cancellation_tickets?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Arr_Rel_Insert_Input>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_audit_logs?: InputMaybe<Organization_Audit_Log_Arr_Rel_Insert_Input>;
  quantity_correction_tickets?: InputMaybe<Quantity_Correction_Tickets_Arr_Rel_Insert_Input>;
  rank_id?: InputMaybe<Scalars['Int']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  reasonTypeByReasonType?: InputMaybe<Reason_Type_Obj_Rel_Insert_Input>;
  reason_type?: InputMaybe<Reason_Type_Enum>;
  task_values?: InputMaybe<Task_Value_Arr_Rel_Insert_Input>;
  tickets?: InputMaybe<Tickets_Arr_Rel_Insert_Input>;
  totalizer_correction_tickets?: InputMaybe<Totalizer_Correction_Tickets_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Reasons_Max_Fields = {
  __typename?: 'reasons_max_fields';
  accountability?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  rank_id?: Maybe<Scalars['Int']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "reasons" */
export type Reasons_Max_Order_By = {
  accountability?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  rank_id?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Reasons_Min_Fields = {
  __typename?: 'reasons_min_fields';
  accountability?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  rank_id?: Maybe<Scalars['Int']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "reasons" */
export type Reasons_Min_Order_By = {
  accountability?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  rank_id?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "reasons" */
export type Reasons_Mutation_Response = {
  __typename?: 'reasons_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Reasons>;
};

/** input type for inserting object relation for remote table "reasons" */
export type Reasons_Obj_Rel_Insert_Input = {
  data: Reasons_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Reasons_On_Conflict>;
};

/** on_conflict condition type for table "reasons" */
export type Reasons_On_Conflict = {
  constraint: Reasons_Constraint;
  update_columns?: Array<Reasons_Update_Column>;
  where?: InputMaybe<Reasons_Bool_Exp>;
};

/** Ordering options when selecting data from "reasons". */
export type Reasons_Order_By = {
  accountability?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_asset_audit_logs_aggregate?: InputMaybe<Customer_Asset_Audit_Log_Aggregate_Order_By>;
  customer_assets_aggregate?: InputMaybe<Customer_Asset_Aggregate_Order_By>;
  fillup_requests_aggregate?: InputMaybe<Fillup_Request_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  invoiced_item_cancellation_tickets_aggregate?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Aggregate_Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_audit_logs_aggregate?: InputMaybe<Organization_Audit_Log_Aggregate_Order_By>;
  quantity_correction_tickets_aggregate?: InputMaybe<Quantity_Correction_Tickets_Aggregate_Order_By>;
  rank_id?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  reasonTypeByReasonType?: InputMaybe<Reason_Type_Order_By>;
  reason_type?: InputMaybe<Order_By>;
  task_values_aggregate?: InputMaybe<Task_Value_Aggregate_Order_By>;
  tickets_aggregate?: InputMaybe<Tickets_Aggregate_Order_By>;
  totalizer_correction_tickets_aggregate?: InputMaybe<Totalizer_Correction_Tickets_Aggregate_Order_By>;
};

/** primary key columns input for table: reasons */
export type Reasons_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "reasons" */
export enum Reasons_Select_Column {
  /** column name */
  Accountability = 'accountability',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  RankId = 'rank_id',
  /** column name */
  Reason = 'reason',
  /** column name */
  ReasonType = 'reason_type'
}

/** select "reasons_aggregate_bool_exp_bool_and_arguments_columns" columns of table "reasons" */
export enum Reasons_Select_Column_Reasons_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "reasons_aggregate_bool_exp_bool_or_arguments_columns" columns of table "reasons" */
export enum Reasons_Select_Column_Reasons_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "reasons" */
export type Reasons_Set_Input = {
  accountability?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  rank_id?: InputMaybe<Scalars['Int']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  reason_type?: InputMaybe<Reason_Type_Enum>;
};

/** aggregate stddev on columns */
export type Reasons_Stddev_Fields = {
  __typename?: 'reasons_stddev_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "reasons" */
export type Reasons_Stddev_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Reasons_Stddev_Pop_Fields = {
  __typename?: 'reasons_stddev_pop_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "reasons" */
export type Reasons_Stddev_Pop_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Reasons_Stddev_Samp_Fields = {
  __typename?: 'reasons_stddev_samp_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "reasons" */
export type Reasons_Stddev_Samp_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "reasons" */
export type Reasons_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Reasons_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Reasons_Stream_Cursor_Value_Input = {
  accountability?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  rank_id?: InputMaybe<Scalars['Int']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  reason_type?: InputMaybe<Reason_Type_Enum>;
};

/** aggregate sum on columns */
export type Reasons_Sum_Fields = {
  __typename?: 'reasons_sum_fields';
  rank_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "reasons" */
export type Reasons_Sum_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** update columns of table "reasons" */
export enum Reasons_Update_Column {
  /** column name */
  Accountability = 'accountability',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  RankId = 'rank_id',
  /** column name */
  Reason = 'reason',
  /** column name */
  ReasonType = 'reason_type'
}

export type Reasons_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Reasons_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Reasons_Set_Input>;
  /** filter the rows which have to be updated */
  where: Reasons_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Reasons_Var_Pop_Fields = {
  __typename?: 'reasons_var_pop_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "reasons" */
export type Reasons_Var_Pop_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Reasons_Var_Samp_Fields = {
  __typename?: 'reasons_var_samp_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "reasons" */
export type Reasons_Var_Samp_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Reasons_Variance_Fields = {
  __typename?: 'reasons_variance_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "reasons" */
export type Reasons_Variance_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

export type ReassignShiftScheduleInput = {
  new_vehicle_id: Scalars['uuid']['input'];
  old_vehicle_id: Scalars['uuid']['input'];
};

export type ReassignShiftScheduleOutput = {
  __typename?: 'reassignShiftScheduleOutput';
  data?: Maybe<Scalars['jsonb']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ReassignTaskInput = {
  is_done_locally?: InputMaybe<Scalars['Boolean']['input']>;
  is_enable_rfid_flow?: InputMaybe<Scalars['Boolean']['input']>;
  new_shift_schedule_id: Scalars['uuid']['input'];
  task_id: Scalars['uuid']['input'];
};

export type ReassignTaskOutput = {
  __typename?: 'reassignTaskOutput';
  status?: Maybe<Scalars['String']['output']>;
  task_id: Scalars['uuid']['output'];
};

export type ReleaseWalletBlockInput = {
  task_id: Scalars['uuid']['input'];
};

export type ReleaseWalletBlockOutput = {
  __typename?: 'releaseWalletBlockOutput';
  released_amount?: Maybe<Scalars['numeric']['output']>;
  success: Scalars['Boolean']['output'];
  task_id?: Maybe<Scalars['uuid']['output']>;
  wallet_id?: Maybe<Scalars['uuid']['output']>;
};

/** columns and relationships of "role" */
export type Role = {
  __typename?: 'role';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  customer_order_item_comments: Array<Customer_Order_Item_Comments>;
  /** An aggregate relationship */
  customer_order_item_comments_aggregate: Customer_Order_Item_Comments_Aggregate;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  invitations: Array<Invitation>;
  /** An aggregate relationship */
  invitations_aggregate: Invitation_Aggregate;
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  role_documents: Array<Role_Document>;
  /** An aggregate relationship */
  role_documents_aggregate: Role_Document_Aggregate;
  /** An array relationship */
  user_roles: Array<User_Role>;
  /** An aggregate relationship */
  user_roles_aggregate: User_Role_Aggregate;
};


/** columns and relationships of "role" */
export type RoleCustomer_Order_Item_CommentsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Comments_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Comments_Bool_Exp>;
};


/** columns and relationships of "role" */
export type RoleCustomer_Order_Item_Comments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Comments_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Comments_Bool_Exp>;
};


/** columns and relationships of "role" */
export type RoleInvitationsArgs = {
  distinct_on?: InputMaybe<Array<Invitation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invitation_Order_By>>;
  where?: InputMaybe<Invitation_Bool_Exp>;
};


/** columns and relationships of "role" */
export type RoleInvitations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invitation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invitation_Order_By>>;
  where?: InputMaybe<Invitation_Bool_Exp>;
};


/** columns and relationships of "role" */
export type RoleRole_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Role_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Role_Document_Order_By>>;
  where?: InputMaybe<Role_Document_Bool_Exp>;
};


/** columns and relationships of "role" */
export type RoleRole_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Role_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Role_Document_Order_By>>;
  where?: InputMaybe<Role_Document_Bool_Exp>;
};


/** columns and relationships of "role" */
export type RoleUser_RolesArgs = {
  distinct_on?: InputMaybe<Array<User_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Role_Order_By>>;
  where?: InputMaybe<User_Role_Bool_Exp>;
};


/** columns and relationships of "role" */
export type RoleUser_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Role_Order_By>>;
  where?: InputMaybe<User_Role_Bool_Exp>;
};

/** aggregated selection of "role" */
export type Role_Aggregate = {
  __typename?: 'role_aggregate';
  aggregate?: Maybe<Role_Aggregate_Fields>;
  nodes: Array<Role>;
};

/** aggregate fields of "role" */
export type Role_Aggregate_Fields = {
  __typename?: 'role_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Role_Max_Fields>;
  min?: Maybe<Role_Min_Fields>;
};


/** aggregate fields of "role" */
export type Role_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Role_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "role". All fields are combined with a logical 'AND'. */
export type Role_Bool_Exp = {
  _and?: InputMaybe<Array<Role_Bool_Exp>>;
  _not?: InputMaybe<Role_Bool_Exp>;
  _or?: InputMaybe<Array<Role_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_order_item_comments?: InputMaybe<Customer_Order_Item_Comments_Bool_Exp>;
  customer_order_item_comments_aggregate?: InputMaybe<Customer_Order_Item_Comments_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invitations?: InputMaybe<Invitation_Bool_Exp>;
  invitations_aggregate?: InputMaybe<Invitation_Aggregate_Bool_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
  role_documents?: InputMaybe<Role_Document_Bool_Exp>;
  role_documents_aggregate?: InputMaybe<Role_Document_Aggregate_Bool_Exp>;
  user_roles?: InputMaybe<User_Role_Bool_Exp>;
  user_roles_aggregate?: InputMaybe<User_Role_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "role" */
export enum Role_Constraint {
  /** unique or primary key constraint on columns "id" */
  RolePkey = 'role_pkey'
}

/** columns and relationships of "role_document" */
export type Role_Document = {
  __typename?: 'role_document';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  document: Documents;
  document_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  is_approved: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  role: Role;
  role_id: Scalars['uuid']['output'];
};

/** aggregated selection of "role_document" */
export type Role_Document_Aggregate = {
  __typename?: 'role_document_aggregate';
  aggregate?: Maybe<Role_Document_Aggregate_Fields>;
  nodes: Array<Role_Document>;
};

export type Role_Document_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Role_Document_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Role_Document_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Role_Document_Aggregate_Bool_Exp_Count>;
};

export type Role_Document_Aggregate_Bool_Exp_Bool_And = {
  arguments: Role_Document_Select_Column_Role_Document_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Role_Document_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Role_Document_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Role_Document_Select_Column_Role_Document_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Role_Document_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Role_Document_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Role_Document_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Role_Document_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "role_document" */
export type Role_Document_Aggregate_Fields = {
  __typename?: 'role_document_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Role_Document_Max_Fields>;
  min?: Maybe<Role_Document_Min_Fields>;
};


/** aggregate fields of "role_document" */
export type Role_Document_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Role_Document_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "role_document" */
export type Role_Document_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Role_Document_Max_Order_By>;
  min?: InputMaybe<Role_Document_Min_Order_By>;
};

/** input type for inserting array relation for remote table "role_document" */
export type Role_Document_Arr_Rel_Insert_Input = {
  data: Array<Role_Document_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Role_Document_On_Conflict>;
};

/** Boolean expression to filter rows from the table "role_document". All fields are combined with a logical 'AND'. */
export type Role_Document_Bool_Exp = {
  _and?: InputMaybe<Array<Role_Document_Bool_Exp>>;
  _not?: InputMaybe<Role_Document_Bool_Exp>;
  _or?: InputMaybe<Array<Role_Document_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  document?: InputMaybe<Documents_Bool_Exp>;
  document_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_approved?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  role?: InputMaybe<Role_Bool_Exp>;
  role_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "role_document" */
export enum Role_Document_Constraint {
  /** unique or primary key constraint on columns "id" */
  RoleDocumentPkey = 'role_document_pkey'
}

/** input type for inserting data into table "role_document" */
export type Role_Document_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  document?: InputMaybe<Documents_Obj_Rel_Insert_Input>;
  document_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_approved?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Role_Obj_Rel_Insert_Input>;
  role_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Role_Document_Max_Fields = {
  __typename?: 'role_document_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  document_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  role_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "role_document" */
export type Role_Document_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Role_Document_Min_Fields = {
  __typename?: 'role_document_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  document_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  role_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "role_document" */
export type Role_Document_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "role_document" */
export type Role_Document_Mutation_Response = {
  __typename?: 'role_document_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Role_Document>;
};

/** on_conflict condition type for table "role_document" */
export type Role_Document_On_Conflict = {
  constraint: Role_Document_Constraint;
  update_columns?: Array<Role_Document_Update_Column>;
  where?: InputMaybe<Role_Document_Bool_Exp>;
};

/** Ordering options when selecting data from "role_document". */
export type Role_Document_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document?: InputMaybe<Documents_Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_approved?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  role?: InputMaybe<Role_Order_By>;
  role_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: role_document */
export type Role_Document_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "role_document" */
export enum Role_Document_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsApproved = 'is_approved',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  RoleId = 'role_id'
}

/** select "role_document_aggregate_bool_exp_bool_and_arguments_columns" columns of table "role_document" */
export enum Role_Document_Select_Column_Role_Document_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsApproved = 'is_approved'
}

/** select "role_document_aggregate_bool_exp_bool_or_arguments_columns" columns of table "role_document" */
export enum Role_Document_Select_Column_Role_Document_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsApproved = 'is_approved'
}

/** input type for updating data in table "role_document" */
export type Role_Document_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  document_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_approved?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  role_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "role_document" */
export type Role_Document_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Role_Document_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Role_Document_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  document_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_approved?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  role_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "role_document" */
export enum Role_Document_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsApproved = 'is_approved',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  RoleId = 'role_id'
}

export type Role_Document_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Role_Document_Set_Input>;
  /** filter the rows which have to be updated */
  where: Role_Document_Bool_Exp;
};

/** input type for inserting data into table "role" */
export type Role_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_item_comments?: InputMaybe<Customer_Order_Item_Comments_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invitations?: InputMaybe<Invitation_Arr_Rel_Insert_Input>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  role_documents?: InputMaybe<Role_Document_Arr_Rel_Insert_Input>;
  user_roles?: InputMaybe<User_Role_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Role_Max_Fields = {
  __typename?: 'role_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Role_Min_Fields = {
  __typename?: 'role_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "role" */
export type Role_Mutation_Response = {
  __typename?: 'role_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Role>;
};

/** input type for inserting object relation for remote table "role" */
export type Role_Obj_Rel_Insert_Input = {
  data: Role_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Role_On_Conflict>;
};

/** on_conflict condition type for table "role" */
export type Role_On_Conflict = {
  constraint: Role_Constraint;
  update_columns?: Array<Role_Update_Column>;
  where?: InputMaybe<Role_Bool_Exp>;
};

/** Ordering options when selecting data from "role". */
export type Role_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_order_item_comments_aggregate?: InputMaybe<Customer_Order_Item_Comments_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  invitations_aggregate?: InputMaybe<Invitation_Aggregate_Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  role_documents_aggregate?: InputMaybe<Role_Document_Aggregate_Order_By>;
  user_roles_aggregate?: InputMaybe<User_Role_Aggregate_Order_By>;
};

/** primary key columns input for table: role */
export type Role_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "role" */
export enum Role_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Role = 'role'
}

/** input type for updating data in table "role" */
export type Role_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "role" */
export type Role_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Role_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Role_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "role" */
export enum Role_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Role = 'role'
}

export type Role_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Role_Set_Input>;
  /** filter the rows which have to be updated */
  where: Role_Bool_Exp;
};

/** columns and relationships of "safety_checklist" */
export type Safety_Checklist = {
  __typename?: 'safety_checklist';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  customer_order_item_safety_checklist_results: Array<Customer_Order_Item_Safety_Checklist_Results>;
  /** An aggregate relationship */
  customer_order_item_safety_checklist_results_aggregate: Customer_Order_Item_Safety_Checklist_Results_Aggregate;
  description: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name: Scalars['String']['output'];
  /** An object relationship */
  safety_checklist_category: Safety_Checklist_Category;
  safety_checklist_category_id: Scalars['uuid']['output'];
  slug?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "safety_checklist" */
export type Safety_ChecklistCustomer_Order_Item_Safety_Checklist_ResultsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Safety_Checklist_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Safety_Checklist_Results_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Safety_Checklist_Results_Bool_Exp>;
};


/** columns and relationships of "safety_checklist" */
export type Safety_ChecklistCustomer_Order_Item_Safety_Checklist_Results_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Safety_Checklist_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Safety_Checklist_Results_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Safety_Checklist_Results_Bool_Exp>;
};

/** aggregated selection of "safety_checklist" */
export type Safety_Checklist_Aggregate = {
  __typename?: 'safety_checklist_aggregate';
  aggregate?: Maybe<Safety_Checklist_Aggregate_Fields>;
  nodes: Array<Safety_Checklist>;
};

export type Safety_Checklist_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Safety_Checklist_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Safety_Checklist_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Safety_Checklist_Aggregate_Bool_Exp_Count>;
};

export type Safety_Checklist_Aggregate_Bool_Exp_Bool_And = {
  arguments: Safety_Checklist_Select_Column_Safety_Checklist_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Safety_Checklist_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Safety_Checklist_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Safety_Checklist_Select_Column_Safety_Checklist_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Safety_Checklist_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Safety_Checklist_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Safety_Checklist_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Safety_Checklist_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "safety_checklist" */
export type Safety_Checklist_Aggregate_Fields = {
  __typename?: 'safety_checklist_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Safety_Checklist_Max_Fields>;
  min?: Maybe<Safety_Checklist_Min_Fields>;
};


/** aggregate fields of "safety_checklist" */
export type Safety_Checklist_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Safety_Checklist_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "safety_checklist" */
export type Safety_Checklist_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Safety_Checklist_Max_Order_By>;
  min?: InputMaybe<Safety_Checklist_Min_Order_By>;
};

/** input type for inserting array relation for remote table "safety_checklist" */
export type Safety_Checklist_Arr_Rel_Insert_Input = {
  data: Array<Safety_Checklist_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Safety_Checklist_On_Conflict>;
};

/** Boolean expression to filter rows from the table "safety_checklist". All fields are combined with a logical 'AND'. */
export type Safety_Checklist_Bool_Exp = {
  _and?: InputMaybe<Array<Safety_Checklist_Bool_Exp>>;
  _not?: InputMaybe<Safety_Checklist_Bool_Exp>;
  _or?: InputMaybe<Array<Safety_Checklist_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_order_item_safety_checklist_results?: InputMaybe<Customer_Order_Item_Safety_Checklist_Results_Bool_Exp>;
  customer_order_item_safety_checklist_results_aggregate?: InputMaybe<Customer_Order_Item_Safety_Checklist_Results_Aggregate_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  safety_checklist_category?: InputMaybe<Safety_Checklist_Category_Bool_Exp>;
  safety_checklist_category_id?: InputMaybe<Uuid_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "safety_checklist_category" */
export type Safety_Checklist_Category = {
  __typename?: 'safety_checklist_category';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name: Scalars['String']['output'];
  /** An array relationship */
  product_variation_safety_checklist_categories: Array<Product_Variation_Safety_Checklist_Category>;
  /** An aggregate relationship */
  product_variation_safety_checklist_categories_aggregate: Product_Variation_Safety_Checklist_Category_Aggregate;
  /** An array relationship */
  safety_checklists: Array<Safety_Checklist>;
  /** An aggregate relationship */
  safety_checklists_aggregate: Safety_Checklist_Aggregate;
  slug?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "safety_checklist_category" */
export type Safety_Checklist_CategoryProduct_Variation_Safety_Checklist_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Product_Variation_Safety_Checklist_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Variation_Safety_Checklist_Category_Order_By>>;
  where?: InputMaybe<Product_Variation_Safety_Checklist_Category_Bool_Exp>;
};


/** columns and relationships of "safety_checklist_category" */
export type Safety_Checklist_CategoryProduct_Variation_Safety_Checklist_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Variation_Safety_Checklist_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Variation_Safety_Checklist_Category_Order_By>>;
  where?: InputMaybe<Product_Variation_Safety_Checklist_Category_Bool_Exp>;
};


/** columns and relationships of "safety_checklist_category" */
export type Safety_Checklist_CategorySafety_ChecklistsArgs = {
  distinct_on?: InputMaybe<Array<Safety_Checklist_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Checklist_Order_By>>;
  where?: InputMaybe<Safety_Checklist_Bool_Exp>;
};


/** columns and relationships of "safety_checklist_category" */
export type Safety_Checklist_CategorySafety_Checklists_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Safety_Checklist_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Checklist_Order_By>>;
  where?: InputMaybe<Safety_Checklist_Bool_Exp>;
};

/** aggregated selection of "safety_checklist_category" */
export type Safety_Checklist_Category_Aggregate = {
  __typename?: 'safety_checklist_category_aggregate';
  aggregate?: Maybe<Safety_Checklist_Category_Aggregate_Fields>;
  nodes: Array<Safety_Checklist_Category>;
};

/** aggregate fields of "safety_checklist_category" */
export type Safety_Checklist_Category_Aggregate_Fields = {
  __typename?: 'safety_checklist_category_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Safety_Checklist_Category_Max_Fields>;
  min?: Maybe<Safety_Checklist_Category_Min_Fields>;
};


/** aggregate fields of "safety_checklist_category" */
export type Safety_Checklist_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Safety_Checklist_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "safety_checklist_category". All fields are combined with a logical 'AND'. */
export type Safety_Checklist_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Safety_Checklist_Category_Bool_Exp>>;
  _not?: InputMaybe<Safety_Checklist_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Safety_Checklist_Category_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  product_variation_safety_checklist_categories?: InputMaybe<Product_Variation_Safety_Checklist_Category_Bool_Exp>;
  product_variation_safety_checklist_categories_aggregate?: InputMaybe<Product_Variation_Safety_Checklist_Category_Aggregate_Bool_Exp>;
  safety_checklists?: InputMaybe<Safety_Checklist_Bool_Exp>;
  safety_checklists_aggregate?: InputMaybe<Safety_Checklist_Aggregate_Bool_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "safety_checklist_category" */
export enum Safety_Checklist_Category_Constraint {
  /** unique or primary key constraint on columns "id" */
  SafetyChecklistCategoryPkey = 'safety_checklist_category_pkey'
}

/** input type for inserting data into table "safety_checklist_category" */
export type Safety_Checklist_Category_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  product_variation_safety_checklist_categories?: InputMaybe<Product_Variation_Safety_Checklist_Category_Arr_Rel_Insert_Input>;
  safety_checklists?: InputMaybe<Safety_Checklist_Arr_Rel_Insert_Input>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Safety_Checklist_Category_Max_Fields = {
  __typename?: 'safety_checklist_category_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Safety_Checklist_Category_Min_Fields = {
  __typename?: 'safety_checklist_category_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "safety_checklist_category" */
export type Safety_Checklist_Category_Mutation_Response = {
  __typename?: 'safety_checklist_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Safety_Checklist_Category>;
};

/** input type for inserting object relation for remote table "safety_checklist_category" */
export type Safety_Checklist_Category_Obj_Rel_Insert_Input = {
  data: Safety_Checklist_Category_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Safety_Checklist_Category_On_Conflict>;
};

/** on_conflict condition type for table "safety_checklist_category" */
export type Safety_Checklist_Category_On_Conflict = {
  constraint: Safety_Checklist_Category_Constraint;
  update_columns?: Array<Safety_Checklist_Category_Update_Column>;
  where?: InputMaybe<Safety_Checklist_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "safety_checklist_category". */
export type Safety_Checklist_Category_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  product_variation_safety_checklist_categories_aggregate?: InputMaybe<Product_Variation_Safety_Checklist_Category_Aggregate_Order_By>;
  safety_checklists_aggregate?: InputMaybe<Safety_Checklist_Aggregate_Order_By>;
  slug?: InputMaybe<Order_By>;
};

/** primary key columns input for table: safety_checklist_category */
export type Safety_Checklist_Category_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "safety_checklist_category" */
export enum Safety_Checklist_Category_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  Slug = 'slug'
}

/** input type for updating data in table "safety_checklist_category" */
export type Safety_Checklist_Category_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "safety_checklist_category" */
export type Safety_Checklist_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Safety_Checklist_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Safety_Checklist_Category_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "safety_checklist_category" */
export enum Safety_Checklist_Category_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  Slug = 'slug'
}

export type Safety_Checklist_Category_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Safety_Checklist_Category_Set_Input>;
  /** filter the rows which have to be updated */
  where: Safety_Checklist_Category_Bool_Exp;
};

/** unique or primary key constraints on table "safety_checklist" */
export enum Safety_Checklist_Constraint {
  /** unique or primary key constraint on columns "id" */
  SafetyChecklistPkey = 'safety_checklist_pkey'
}

/** input type for inserting data into table "safety_checklist" */
export type Safety_Checklist_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_item_safety_checklist_results?: InputMaybe<Customer_Order_Item_Safety_Checklist_Results_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  safety_checklist_category?: InputMaybe<Safety_Checklist_Category_Obj_Rel_Insert_Input>;
  safety_checklist_category_id?: InputMaybe<Scalars['uuid']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Safety_Checklist_Max_Fields = {
  __typename?: 'safety_checklist_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  safety_checklist_category_id?: Maybe<Scalars['uuid']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "safety_checklist" */
export type Safety_Checklist_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  safety_checklist_category_id?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Safety_Checklist_Min_Fields = {
  __typename?: 'safety_checklist_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  safety_checklist_category_id?: Maybe<Scalars['uuid']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "safety_checklist" */
export type Safety_Checklist_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  safety_checklist_category_id?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "safety_checklist" */
export type Safety_Checklist_Mutation_Response = {
  __typename?: 'safety_checklist_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Safety_Checklist>;
};

/** input type for inserting object relation for remote table "safety_checklist" */
export type Safety_Checklist_Obj_Rel_Insert_Input = {
  data: Safety_Checklist_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Safety_Checklist_On_Conflict>;
};

/** on_conflict condition type for table "safety_checklist" */
export type Safety_Checklist_On_Conflict = {
  constraint: Safety_Checklist_Constraint;
  update_columns?: Array<Safety_Checklist_Update_Column>;
  where?: InputMaybe<Safety_Checklist_Bool_Exp>;
};

/** Ordering options when selecting data from "safety_checklist". */
export type Safety_Checklist_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_order_item_safety_checklist_results_aggregate?: InputMaybe<Customer_Order_Item_Safety_Checklist_Results_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  safety_checklist_category?: InputMaybe<Safety_Checklist_Category_Order_By>;
  safety_checklist_category_id?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
};

/** primary key columns input for table: safety_checklist */
export type Safety_Checklist_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "safety_checklist" */
export enum Safety_Checklist_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  SafetyChecklistCategoryId = 'safety_checklist_category_id',
  /** column name */
  Slug = 'slug'
}

/** select "safety_checklist_aggregate_bool_exp_bool_and_arguments_columns" columns of table "safety_checklist" */
export enum Safety_Checklist_Select_Column_Safety_Checklist_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "safety_checklist_aggregate_bool_exp_bool_or_arguments_columns" columns of table "safety_checklist" */
export enum Safety_Checklist_Select_Column_Safety_Checklist_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "safety_checklist" */
export type Safety_Checklist_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  safety_checklist_category_id?: InputMaybe<Scalars['uuid']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "safety_checklist" */
export type Safety_Checklist_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Safety_Checklist_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Safety_Checklist_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  safety_checklist_category_id?: InputMaybe<Scalars['uuid']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "safety_checklist" */
export enum Safety_Checklist_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  SafetyChecklistCategoryId = 'safety_checklist_category_id',
  /** column name */
  Slug = 'slug'
}

export type Safety_Checklist_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Safety_Checklist_Set_Input>;
  /** filter the rows which have to be updated */
  where: Safety_Checklist_Bool_Exp;
};

/** columns and relationships of "script_type" */
export type Script_Type = {
  __typename?: 'script_type';
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  scripts: Array<Scripts>;
  /** An aggregate relationship */
  scripts_aggregate: Scripts_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "script_type" */
export type Script_TypeScriptsArgs = {
  distinct_on?: InputMaybe<Array<Scripts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scripts_Order_By>>;
  where?: InputMaybe<Scripts_Bool_Exp>;
};


/** columns and relationships of "script_type" */
export type Script_TypeScripts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scripts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scripts_Order_By>>;
  where?: InputMaybe<Scripts_Bool_Exp>;
};

/** aggregated selection of "script_type" */
export type Script_Type_Aggregate = {
  __typename?: 'script_type_aggregate';
  aggregate?: Maybe<Script_Type_Aggregate_Fields>;
  nodes: Array<Script_Type>;
};

/** aggregate fields of "script_type" */
export type Script_Type_Aggregate_Fields = {
  __typename?: 'script_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Script_Type_Max_Fields>;
  min?: Maybe<Script_Type_Min_Fields>;
};


/** aggregate fields of "script_type" */
export type Script_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Script_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "script_type". All fields are combined with a logical 'AND'. */
export type Script_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Script_Type_Bool_Exp>>;
  _not?: InputMaybe<Script_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Script_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  scripts?: InputMaybe<Scripts_Bool_Exp>;
  scripts_aggregate?: InputMaybe<Scripts_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "script_type" */
export enum Script_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  ScriptTypePkey = 'script_type_pkey'
}

export enum Script_Type_Enum {
  /** COMMISSION */
  Commission = 'COMMISSION',
  /** DELIVERY_FEE */
  DeliveryFee = 'DELIVERY_FEE',
  /** DISCOUNT */
  Discount = 'DISCOUNT',
  /** INBOUND */
  Inbound = 'INBOUND',
  /** OUTBOND */
  Outbond = 'OUTBOND'
}

/** Boolean expression to compare columns of type "script_type_enum". All fields are combined with logical 'AND'. */
export type Script_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Script_Type_Enum>;
  _in?: InputMaybe<Array<Script_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Script_Type_Enum>;
  _nin?: InputMaybe<Array<Script_Type_Enum>>;
};

/** input type for inserting data into table "script_type" */
export type Script_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  scripts?: InputMaybe<Scripts_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Script_Type_Max_Fields = {
  __typename?: 'script_type_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Script_Type_Min_Fields = {
  __typename?: 'script_type_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "script_type" */
export type Script_Type_Mutation_Response = {
  __typename?: 'script_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Script_Type>;
};

/** input type for inserting object relation for remote table "script_type" */
export type Script_Type_Obj_Rel_Insert_Input = {
  data: Script_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Script_Type_On_Conflict>;
};

/** on_conflict condition type for table "script_type" */
export type Script_Type_On_Conflict = {
  constraint: Script_Type_Constraint;
  update_columns?: Array<Script_Type_Update_Column>;
  where?: InputMaybe<Script_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "script_type". */
export type Script_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  scripts_aggregate?: InputMaybe<Scripts_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: script_type */
export type Script_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "script_type" */
export enum Script_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "script_type" */
export type Script_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "script_type" */
export type Script_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Script_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Script_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "script_type" */
export enum Script_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Script_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Script_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Script_Type_Bool_Exp;
};

/** columns and relationships of "scripts" */
export type Scripts = {
  __typename?: 'scripts';
  code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  organization_commission_product_variation_types: Array<Organization_Commission_Product_Variation_Type>;
  /** An aggregate relationship */
  organization_commission_product_variation_types_aggregate: Organization_Commission_Product_Variation_Type_Aggregate;
  /** An array relationship */
  organizations: Array<Organization>;
  /** An aggregate relationship */
  organizations_aggregate: Organization_Aggregate;
  outbound: Scalars['Boolean']['output'];
  /** An array relationship */
  partner_commission_product_variation_types: Array<Partner_Commission_Product_Variation_Type>;
  /** An aggregate relationship */
  partner_commission_product_variation_types_aggregate: Partner_Commission_Product_Variation_Type_Aggregate;
  /** An array relationship */
  product_commissions: Array<Product_Commission>;
  /** An aggregate relationship */
  product_commissions_aggregate: Product_Commission_Aggregate;
  script?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  scriptTypeByScriptType?: Maybe<Script_Type>;
  script_type?: Maybe<Script_Type_Enum>;
  /** An array relationship */
  vouchers: Array<Voucher>;
  /** An aggregate relationship */
  vouchers_aggregate: Voucher_Aggregate;
};


/** columns and relationships of "scripts" */
export type ScriptsOrganization_Commission_Product_Variation_TypesArgs = {
  distinct_on?: InputMaybe<Array<Organization_Commission_Product_Variation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Commission_Product_Variation_Type_Order_By>>;
  where?: InputMaybe<Organization_Commission_Product_Variation_Type_Bool_Exp>;
};


/** columns and relationships of "scripts" */
export type ScriptsOrganization_Commission_Product_Variation_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Commission_Product_Variation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Commission_Product_Variation_Type_Order_By>>;
  where?: InputMaybe<Organization_Commission_Product_Variation_Type_Bool_Exp>;
};


/** columns and relationships of "scripts" */
export type ScriptsOrganizationsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


/** columns and relationships of "scripts" */
export type ScriptsOrganizations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


/** columns and relationships of "scripts" */
export type ScriptsPartner_Commission_Product_Variation_TypesArgs = {
  distinct_on?: InputMaybe<Array<Partner_Commission_Product_Variation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Commission_Product_Variation_Type_Order_By>>;
  where?: InputMaybe<Partner_Commission_Product_Variation_Type_Bool_Exp>;
};


/** columns and relationships of "scripts" */
export type ScriptsPartner_Commission_Product_Variation_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Commission_Product_Variation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Commission_Product_Variation_Type_Order_By>>;
  where?: InputMaybe<Partner_Commission_Product_Variation_Type_Bool_Exp>;
};


/** columns and relationships of "scripts" */
export type ScriptsProduct_CommissionsArgs = {
  distinct_on?: InputMaybe<Array<Product_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Commission_Order_By>>;
  where?: InputMaybe<Product_Commission_Bool_Exp>;
};


/** columns and relationships of "scripts" */
export type ScriptsProduct_Commissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Commission_Order_By>>;
  where?: InputMaybe<Product_Commission_Bool_Exp>;
};


/** columns and relationships of "scripts" */
export type ScriptsVouchersArgs = {
  distinct_on?: InputMaybe<Array<Voucher_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Voucher_Order_By>>;
  where?: InputMaybe<Voucher_Bool_Exp>;
};


/** columns and relationships of "scripts" */
export type ScriptsVouchers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Voucher_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Voucher_Order_By>>;
  where?: InputMaybe<Voucher_Bool_Exp>;
};

/** aggregated selection of "scripts" */
export type Scripts_Aggregate = {
  __typename?: 'scripts_aggregate';
  aggregate?: Maybe<Scripts_Aggregate_Fields>;
  nodes: Array<Scripts>;
};

export type Scripts_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Scripts_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Scripts_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Scripts_Aggregate_Bool_Exp_Count>;
};

export type Scripts_Aggregate_Bool_Exp_Bool_And = {
  arguments: Scripts_Select_Column_Scripts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scripts_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Scripts_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Scripts_Select_Column_Scripts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scripts_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Scripts_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Scripts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scripts_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "scripts" */
export type Scripts_Aggregate_Fields = {
  __typename?: 'scripts_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Scripts_Max_Fields>;
  min?: Maybe<Scripts_Min_Fields>;
};


/** aggregate fields of "scripts" */
export type Scripts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scripts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "scripts" */
export type Scripts_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Scripts_Max_Order_By>;
  min?: InputMaybe<Scripts_Min_Order_By>;
};

/** input type for inserting array relation for remote table "scripts" */
export type Scripts_Arr_Rel_Insert_Input = {
  data: Array<Scripts_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Scripts_On_Conflict>;
};

/** Boolean expression to filter rows from the table "scripts". All fields are combined with a logical 'AND'. */
export type Scripts_Bool_Exp = {
  _and?: InputMaybe<Array<Scripts_Bool_Exp>>;
  _not?: InputMaybe<Scripts_Bool_Exp>;
  _or?: InputMaybe<Array<Scripts_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization_commission_product_variation_types?: InputMaybe<Organization_Commission_Product_Variation_Type_Bool_Exp>;
  organization_commission_product_variation_types_aggregate?: InputMaybe<Organization_Commission_Product_Variation_Type_Aggregate_Bool_Exp>;
  organizations?: InputMaybe<Organization_Bool_Exp>;
  organizations_aggregate?: InputMaybe<Organization_Aggregate_Bool_Exp>;
  outbound?: InputMaybe<Boolean_Comparison_Exp>;
  partner_commission_product_variation_types?: InputMaybe<Partner_Commission_Product_Variation_Type_Bool_Exp>;
  partner_commission_product_variation_types_aggregate?: InputMaybe<Partner_Commission_Product_Variation_Type_Aggregate_Bool_Exp>;
  product_commissions?: InputMaybe<Product_Commission_Bool_Exp>;
  product_commissions_aggregate?: InputMaybe<Product_Commission_Aggregate_Bool_Exp>;
  script?: InputMaybe<String_Comparison_Exp>;
  scriptTypeByScriptType?: InputMaybe<Script_Type_Bool_Exp>;
  script_type?: InputMaybe<Script_Type_Enum_Comparison_Exp>;
  vouchers?: InputMaybe<Voucher_Bool_Exp>;
  vouchers_aggregate?: InputMaybe<Voucher_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "scripts" */
export enum Scripts_Constraint {
  /** unique or primary key constraint on columns "id" */
  ScriptsPkey = 'scripts_pkey'
}

/** input type for inserting data into table "scripts" */
export type Scripts_Insert_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_commission_product_variation_types?: InputMaybe<Organization_Commission_Product_Variation_Type_Arr_Rel_Insert_Input>;
  organizations?: InputMaybe<Organization_Arr_Rel_Insert_Input>;
  outbound?: InputMaybe<Scalars['Boolean']['input']>;
  partner_commission_product_variation_types?: InputMaybe<Partner_Commission_Product_Variation_Type_Arr_Rel_Insert_Input>;
  product_commissions?: InputMaybe<Product_Commission_Arr_Rel_Insert_Input>;
  script?: InputMaybe<Scalars['String']['input']>;
  scriptTypeByScriptType?: InputMaybe<Script_Type_Obj_Rel_Insert_Input>;
  script_type?: InputMaybe<Script_Type_Enum>;
  vouchers?: InputMaybe<Voucher_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Scripts_Max_Fields = {
  __typename?: 'scripts_max_fields';
  code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  script?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "scripts" */
export type Scripts_Max_Order_By = {
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  script?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Scripts_Min_Fields = {
  __typename?: 'scripts_min_fields';
  code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  script?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "scripts" */
export type Scripts_Min_Order_By = {
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  script?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "scripts" */
export type Scripts_Mutation_Response = {
  __typename?: 'scripts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Scripts>;
};

/** input type for inserting object relation for remote table "scripts" */
export type Scripts_Obj_Rel_Insert_Input = {
  data: Scripts_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Scripts_On_Conflict>;
};

/** on_conflict condition type for table "scripts" */
export type Scripts_On_Conflict = {
  constraint: Scripts_Constraint;
  update_columns?: Array<Scripts_Update_Column>;
  where?: InputMaybe<Scripts_Bool_Exp>;
};

/** Ordering options when selecting data from "scripts". */
export type Scripts_Order_By = {
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_commission_product_variation_types_aggregate?: InputMaybe<Organization_Commission_Product_Variation_Type_Aggregate_Order_By>;
  organizations_aggregate?: InputMaybe<Organization_Aggregate_Order_By>;
  outbound?: InputMaybe<Order_By>;
  partner_commission_product_variation_types_aggregate?: InputMaybe<Partner_Commission_Product_Variation_Type_Aggregate_Order_By>;
  product_commissions_aggregate?: InputMaybe<Product_Commission_Aggregate_Order_By>;
  script?: InputMaybe<Order_By>;
  scriptTypeByScriptType?: InputMaybe<Script_Type_Order_By>;
  script_type?: InputMaybe<Order_By>;
  vouchers_aggregate?: InputMaybe<Voucher_Aggregate_Order_By>;
};

/** primary key columns input for table: scripts */
export type Scripts_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "scripts" */
export enum Scripts_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  Outbound = 'outbound',
  /** column name */
  Script = 'script',
  /** column name */
  ScriptType = 'script_type'
}

/** select "scripts_aggregate_bool_exp_bool_and_arguments_columns" columns of table "scripts" */
export enum Scripts_Select_Column_Scripts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Outbound = 'outbound'
}

/** select "scripts_aggregate_bool_exp_bool_or_arguments_columns" columns of table "scripts" */
export enum Scripts_Select_Column_Scripts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Outbound = 'outbound'
}

/** input type for updating data in table "scripts" */
export type Scripts_Set_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  outbound?: InputMaybe<Scalars['Boolean']['input']>;
  script?: InputMaybe<Scalars['String']['input']>;
  script_type?: InputMaybe<Script_Type_Enum>;
};

/** Streaming cursor of the table "scripts" */
export type Scripts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Scripts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Scripts_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  outbound?: InputMaybe<Scalars['Boolean']['input']>;
  script?: InputMaybe<Scalars['String']['input']>;
  script_type?: InputMaybe<Script_Type_Enum>;
};

/** update columns of table "scripts" */
export enum Scripts_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  Outbound = 'outbound',
  /** column name */
  Script = 'script',
  /** column name */
  ScriptType = 'script_type'
}

export type Scripts_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Scripts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Scripts_Bool_Exp;
};

/** columns and relationships of "services" */
export type Services = {
  __typename?: 'services';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name: Scalars['String']['output'];
  rank_id?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  services_categories: Array<Services_Category>;
  /** An aggregate relationship */
  services_categories_aggregate: Services_Category_Aggregate;
  slug?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "services" */
export type ServicesServices_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Services_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Services_Category_Order_By>>;
  where?: InputMaybe<Services_Category_Bool_Exp>;
};


/** columns and relationships of "services" */
export type ServicesServices_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Services_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Services_Category_Order_By>>;
  where?: InputMaybe<Services_Category_Bool_Exp>;
};

/** aggregated selection of "services" */
export type Services_Aggregate = {
  __typename?: 'services_aggregate';
  aggregate?: Maybe<Services_Aggregate_Fields>;
  nodes: Array<Services>;
};

/** aggregate fields of "services" */
export type Services_Aggregate_Fields = {
  __typename?: 'services_aggregate_fields';
  avg?: Maybe<Services_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Services_Max_Fields>;
  min?: Maybe<Services_Min_Fields>;
  stddev?: Maybe<Services_Stddev_Fields>;
  stddev_pop?: Maybe<Services_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Services_Stddev_Samp_Fields>;
  sum?: Maybe<Services_Sum_Fields>;
  var_pop?: Maybe<Services_Var_Pop_Fields>;
  var_samp?: Maybe<Services_Var_Samp_Fields>;
  variance?: Maybe<Services_Variance_Fields>;
};


/** aggregate fields of "services" */
export type Services_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Services_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Services_Avg_Fields = {
  __typename?: 'services_avg_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "services". All fields are combined with a logical 'AND'. */
export type Services_Bool_Exp = {
  _and?: InputMaybe<Array<Services_Bool_Exp>>;
  _not?: InputMaybe<Services_Bool_Exp>;
  _or?: InputMaybe<Array<Services_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  rank_id?: InputMaybe<Int_Comparison_Exp>;
  services_categories?: InputMaybe<Services_Category_Bool_Exp>;
  services_categories_aggregate?: InputMaybe<Services_Category_Aggregate_Bool_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "services_category" */
export type Services_Category = {
  __typename?: 'services_category';
  /** An object relationship */
  category: Category;
  category_id: Scalars['uuid']['output'];
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  service: Services;
  services_id: Scalars['uuid']['output'];
};

/** aggregated selection of "services_category" */
export type Services_Category_Aggregate = {
  __typename?: 'services_category_aggregate';
  aggregate?: Maybe<Services_Category_Aggregate_Fields>;
  nodes: Array<Services_Category>;
};

export type Services_Category_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Services_Category_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Services_Category_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Services_Category_Aggregate_Bool_Exp_Count>;
};

export type Services_Category_Aggregate_Bool_Exp_Bool_And = {
  arguments: Services_Category_Select_Column_Services_Category_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Services_Category_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Services_Category_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Services_Category_Select_Column_Services_Category_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Services_Category_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Services_Category_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Services_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Services_Category_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "services_category" */
export type Services_Category_Aggregate_Fields = {
  __typename?: 'services_category_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Services_Category_Max_Fields>;
  min?: Maybe<Services_Category_Min_Fields>;
};


/** aggregate fields of "services_category" */
export type Services_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Services_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "services_category" */
export type Services_Category_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Services_Category_Max_Order_By>;
  min?: InputMaybe<Services_Category_Min_Order_By>;
};

/** input type for inserting array relation for remote table "services_category" */
export type Services_Category_Arr_Rel_Insert_Input = {
  data: Array<Services_Category_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Services_Category_On_Conflict>;
};

/** Boolean expression to filter rows from the table "services_category". All fields are combined with a logical 'AND'. */
export type Services_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Services_Category_Bool_Exp>>;
  _not?: InputMaybe<Services_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Services_Category_Bool_Exp>>;
  category?: InputMaybe<Category_Bool_Exp>;
  category_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  service?: InputMaybe<Services_Bool_Exp>;
  services_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "services_category" */
export enum Services_Category_Constraint {
  /** unique or primary key constraint on columns "id" */
  ServicesCategoryPkey = 'services_category_pkey'
}

/** input type for inserting data into table "services_category" */
export type Services_Category_Insert_Input = {
  category?: InputMaybe<Category_Obj_Rel_Insert_Input>;
  category_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  service?: InputMaybe<Services_Obj_Rel_Insert_Input>;
  services_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Services_Category_Max_Fields = {
  __typename?: 'services_category_max_fields';
  category_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  services_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "services_category" */
export type Services_Category_Max_Order_By = {
  category_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  services_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Services_Category_Min_Fields = {
  __typename?: 'services_category_min_fields';
  category_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  services_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "services_category" */
export type Services_Category_Min_Order_By = {
  category_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  services_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "services_category" */
export type Services_Category_Mutation_Response = {
  __typename?: 'services_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Services_Category>;
};

/** on_conflict condition type for table "services_category" */
export type Services_Category_On_Conflict = {
  constraint: Services_Category_Constraint;
  update_columns?: Array<Services_Category_Update_Column>;
  where?: InputMaybe<Services_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "services_category". */
export type Services_Category_Order_By = {
  category?: InputMaybe<Category_Order_By>;
  category_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  service?: InputMaybe<Services_Order_By>;
  services_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: services_category */
export type Services_Category_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "services_category" */
export enum Services_Category_Select_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  ServicesId = 'services_id'
}

/** select "services_category_aggregate_bool_exp_bool_and_arguments_columns" columns of table "services_category" */
export enum Services_Category_Select_Column_Services_Category_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "services_category_aggregate_bool_exp_bool_or_arguments_columns" columns of table "services_category" */
export enum Services_Category_Select_Column_Services_Category_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "services_category" */
export type Services_Category_Set_Input = {
  category_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  services_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "services_category" */
export type Services_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Services_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Services_Category_Stream_Cursor_Value_Input = {
  category_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  services_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "services_category" */
export enum Services_Category_Update_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  ServicesId = 'services_id'
}

export type Services_Category_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Services_Category_Set_Input>;
  /** filter the rows which have to be updated */
  where: Services_Category_Bool_Exp;
};

/** unique or primary key constraints on table "services" */
export enum Services_Constraint {
  /** unique or primary key constraint on columns "id" */
  ServicesPkey = 'services_pkey'
}

/** input type for incrementing numeric columns in table "services" */
export type Services_Inc_Input = {
  rank_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "services" */
export type Services_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rank_id?: InputMaybe<Scalars['Int']['input']>;
  services_categories?: InputMaybe<Services_Category_Arr_Rel_Insert_Input>;
  slug?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Services_Max_Fields = {
  __typename?: 'services_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rank_id?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Services_Min_Fields = {
  __typename?: 'services_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rank_id?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "services" */
export type Services_Mutation_Response = {
  __typename?: 'services_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Services>;
};

/** input type for inserting object relation for remote table "services" */
export type Services_Obj_Rel_Insert_Input = {
  data: Services_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Services_On_Conflict>;
};

/** on_conflict condition type for table "services" */
export type Services_On_Conflict = {
  constraint: Services_Constraint;
  update_columns?: Array<Services_Update_Column>;
  where?: InputMaybe<Services_Bool_Exp>;
};

/** Ordering options when selecting data from "services". */
export type Services_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  rank_id?: InputMaybe<Order_By>;
  services_categories_aggregate?: InputMaybe<Services_Category_Aggregate_Order_By>;
  slug?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: services */
export type Services_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "services" */
export enum Services_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  RankId = 'rank_id',
  /** column name */
  Slug = 'slug',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "services" */
export type Services_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rank_id?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Services_Stddev_Fields = {
  __typename?: 'services_stddev_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Services_Stddev_Pop_Fields = {
  __typename?: 'services_stddev_pop_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Services_Stddev_Samp_Fields = {
  __typename?: 'services_stddev_samp_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "services" */
export type Services_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Services_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Services_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rank_id?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Services_Sum_Fields = {
  __typename?: 'services_sum_fields';
  rank_id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "services" */
export enum Services_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  RankId = 'rank_id',
  /** column name */
  Slug = 'slug',
  /** column name */
  Url = 'url'
}

export type Services_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Services_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Services_Set_Input>;
  /** filter the rows which have to be updated */
  where: Services_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Services_Var_Pop_Fields = {
  __typename?: 'services_var_pop_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Services_Var_Samp_Fields = {
  __typename?: 'services_var_samp_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Services_Variance_Fields = {
  __typename?: 'services_variance_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "shift_schedule" */
export type Shift_Schedule = {
  __typename?: 'shift_schedule';
  /** Timestamp when shift schedule was approved */
  approved_at?: Maybe<Scalars['timestamptz']['output']>;
  /** User who approved this shift schedule */
  approved_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  approver?: Maybe<User>;
  /** Actual break end time */
  break_end_time?: Maybe<Scalars['timestamptz']['output']>;
  /** Actual break start time */
  break_start_time?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  customer_order_slots: Array<Customer_Order_Slots>;
  /** An aggregate relationship */
  customer_order_slots_aggregate: Customer_Order_Slots_Aggregate;
  /** An object relationship */
  driver_vehicle?: Maybe<Driver_Vehicle>;
  driver_vehicle_id?: Maybe<Scalars['uuid']['output']>;
  end_time: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  partner?: Maybe<Partner>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  /** Actual refuel end time */
  refuel_end_time?: Maybe<Scalars['timestamptz']['output']>;
  /** Actual refuel start time */
  refuel_start_time?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  shift_schedule_dispensers: Array<Shift_Schedule_Dispenser>;
  /** An aggregate relationship */
  shift_schedule_dispensers_aggregate: Shift_Schedule_Dispenser_Aggregate;
  /** An object relationship */
  shift_template?: Maybe<Shift_Template>;
  /** Reference to shift template used for this schedule */
  shift_template_id?: Maybe<Scalars['uuid']['output']>;
  start_time: Scalars['timestamptz']['output'];
  /** Status: SCHEDULED, IN_PROGRESS, COMPLETED, CANCELLED */
  status?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  user?: Maybe<User>;
  /** An object relationship */
  vehicle?: Maybe<Vehicle>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  vehicle_shift_templates: Array<Vehicle_Shift_Template>;
  /** An aggregate relationship */
  vehicle_shift_templates_aggregate: Vehicle_Shift_Template_Aggregate;
};


/** columns and relationships of "shift_schedule" */
export type Shift_ScheduleCustomer_Order_SlotsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Slots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Slots_Order_By>>;
  where?: InputMaybe<Customer_Order_Slots_Bool_Exp>;
};


/** columns and relationships of "shift_schedule" */
export type Shift_ScheduleCustomer_Order_Slots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Slots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Slots_Order_By>>;
  where?: InputMaybe<Customer_Order_Slots_Bool_Exp>;
};


/** columns and relationships of "shift_schedule" */
export type Shift_ScheduleShift_Schedule_DispensersArgs = {
  distinct_on?: InputMaybe<Array<Shift_Schedule_Dispenser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shift_Schedule_Dispenser_Order_By>>;
  where?: InputMaybe<Shift_Schedule_Dispenser_Bool_Exp>;
};


/** columns and relationships of "shift_schedule" */
export type Shift_ScheduleShift_Schedule_Dispensers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shift_Schedule_Dispenser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shift_Schedule_Dispenser_Order_By>>;
  where?: InputMaybe<Shift_Schedule_Dispenser_Bool_Exp>;
};


/** columns and relationships of "shift_schedule" */
export type Shift_ScheduleVehicle_Shift_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Shift_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Shift_Template_Order_By>>;
  where?: InputMaybe<Vehicle_Shift_Template_Bool_Exp>;
};


/** columns and relationships of "shift_schedule" */
export type Shift_ScheduleVehicle_Shift_Templates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Shift_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Shift_Template_Order_By>>;
  where?: InputMaybe<Vehicle_Shift_Template_Bool_Exp>;
};

/** aggregated selection of "shift_schedule" */
export type Shift_Schedule_Aggregate = {
  __typename?: 'shift_schedule_aggregate';
  aggregate?: Maybe<Shift_Schedule_Aggregate_Fields>;
  nodes: Array<Shift_Schedule>;
};

export type Shift_Schedule_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Shift_Schedule_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Shift_Schedule_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Shift_Schedule_Aggregate_Bool_Exp_Count>;
};

export type Shift_Schedule_Aggregate_Bool_Exp_Bool_And = {
  arguments: Shift_Schedule_Select_Column_Shift_Schedule_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Shift_Schedule_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Shift_Schedule_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Shift_Schedule_Select_Column_Shift_Schedule_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Shift_Schedule_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Shift_Schedule_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Shift_Schedule_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Shift_Schedule_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "shift_schedule" */
export type Shift_Schedule_Aggregate_Fields = {
  __typename?: 'shift_schedule_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Shift_Schedule_Max_Fields>;
  min?: Maybe<Shift_Schedule_Min_Fields>;
};


/** aggregate fields of "shift_schedule" */
export type Shift_Schedule_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Shift_Schedule_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "shift_schedule" */
export type Shift_Schedule_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Shift_Schedule_Max_Order_By>;
  min?: InputMaybe<Shift_Schedule_Min_Order_By>;
};

/** input type for inserting array relation for remote table "shift_schedule" */
export type Shift_Schedule_Arr_Rel_Insert_Input = {
  data: Array<Shift_Schedule_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Shift_Schedule_On_Conflict>;
};

/** Boolean expression to filter rows from the table "shift_schedule". All fields are combined with a logical 'AND'. */
export type Shift_Schedule_Bool_Exp = {
  _and?: InputMaybe<Array<Shift_Schedule_Bool_Exp>>;
  _not?: InputMaybe<Shift_Schedule_Bool_Exp>;
  _or?: InputMaybe<Array<Shift_Schedule_Bool_Exp>>;
  approved_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  approved_by?: InputMaybe<Uuid_Comparison_Exp>;
  approver?: InputMaybe<User_Bool_Exp>;
  break_end_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  break_start_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  customer_order_slots?: InputMaybe<Customer_Order_Slots_Bool_Exp>;
  customer_order_slots_aggregate?: InputMaybe<Customer_Order_Slots_Aggregate_Bool_Exp>;
  driver_vehicle?: InputMaybe<Driver_Vehicle_Bool_Exp>;
  driver_vehicle_id?: InputMaybe<Uuid_Comparison_Exp>;
  end_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  partner?: InputMaybe<Partner_Bool_Exp>;
  partner_id?: InputMaybe<Uuid_Comparison_Exp>;
  refuel_end_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  refuel_start_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  shift_schedule_dispensers?: InputMaybe<Shift_Schedule_Dispenser_Bool_Exp>;
  shift_schedule_dispensers_aggregate?: InputMaybe<Shift_Schedule_Dispenser_Aggregate_Bool_Exp>;
  shift_template?: InputMaybe<Shift_Template_Bool_Exp>;
  shift_template_id?: InputMaybe<Uuid_Comparison_Exp>;
  start_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  vehicle?: InputMaybe<Vehicle_Bool_Exp>;
  vehicle_id?: InputMaybe<Uuid_Comparison_Exp>;
  vehicle_shift_templates?: InputMaybe<Vehicle_Shift_Template_Bool_Exp>;
  vehicle_shift_templates_aggregate?: InputMaybe<Vehicle_Shift_Template_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "shift_schedule" */
export enum Shift_Schedule_Constraint {
  /** unique or primary key constraint on columns "id" */
  ShiftSchedulePkey = 'shift_schedule_pkey'
}

/** columns and relationships of "shift_schedule_dispenser" */
export type Shift_Schedule_Dispenser = {
  __typename?: 'shift_schedule_dispenser';
  /** An object relationship */
  createdByUser?: Maybe<User>;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  dispenser: Dispenser;
  dispenser_id: Scalars['uuid']['output'];
  /** An object relationship */
  driver?: Maybe<User>;
  driver_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified: Scalars['timestamptz']['output'];
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  shift_schedule: Shift_Schedule;
  shift_schedule_id: Scalars['uuid']['output'];
  /** An array relationship */
  tasks: Array<Task>;
  /** An aggregate relationship */
  tasks_aggregate: Task_Aggregate;
};


/** columns and relationships of "shift_schedule_dispenser" */
export type Shift_Schedule_DispenserTasksArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


/** columns and relationships of "shift_schedule_dispenser" */
export type Shift_Schedule_DispenserTasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};

/** aggregated selection of "shift_schedule_dispenser" */
export type Shift_Schedule_Dispenser_Aggregate = {
  __typename?: 'shift_schedule_dispenser_aggregate';
  aggregate?: Maybe<Shift_Schedule_Dispenser_Aggregate_Fields>;
  nodes: Array<Shift_Schedule_Dispenser>;
};

export type Shift_Schedule_Dispenser_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Shift_Schedule_Dispenser_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Shift_Schedule_Dispenser_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Shift_Schedule_Dispenser_Aggregate_Bool_Exp_Count>;
};

export type Shift_Schedule_Dispenser_Aggregate_Bool_Exp_Bool_And = {
  arguments: Shift_Schedule_Dispenser_Select_Column_Shift_Schedule_Dispenser_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Shift_Schedule_Dispenser_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Shift_Schedule_Dispenser_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Shift_Schedule_Dispenser_Select_Column_Shift_Schedule_Dispenser_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Shift_Schedule_Dispenser_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Shift_Schedule_Dispenser_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Shift_Schedule_Dispenser_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Shift_Schedule_Dispenser_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "shift_schedule_dispenser" */
export type Shift_Schedule_Dispenser_Aggregate_Fields = {
  __typename?: 'shift_schedule_dispenser_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Shift_Schedule_Dispenser_Max_Fields>;
  min?: Maybe<Shift_Schedule_Dispenser_Min_Fields>;
};


/** aggregate fields of "shift_schedule_dispenser" */
export type Shift_Schedule_Dispenser_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Shift_Schedule_Dispenser_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "shift_schedule_dispenser" */
export type Shift_Schedule_Dispenser_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Shift_Schedule_Dispenser_Max_Order_By>;
  min?: InputMaybe<Shift_Schedule_Dispenser_Min_Order_By>;
};

/** input type for inserting array relation for remote table "shift_schedule_dispenser" */
export type Shift_Schedule_Dispenser_Arr_Rel_Insert_Input = {
  data: Array<Shift_Schedule_Dispenser_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Shift_Schedule_Dispenser_On_Conflict>;
};

/** Boolean expression to filter rows from the table "shift_schedule_dispenser". All fields are combined with a logical 'AND'. */
export type Shift_Schedule_Dispenser_Bool_Exp = {
  _and?: InputMaybe<Array<Shift_Schedule_Dispenser_Bool_Exp>>;
  _not?: InputMaybe<Shift_Schedule_Dispenser_Bool_Exp>;
  _or?: InputMaybe<Array<Shift_Schedule_Dispenser_Bool_Exp>>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  dispenser?: InputMaybe<Dispenser_Bool_Exp>;
  dispenser_id?: InputMaybe<Uuid_Comparison_Exp>;
  driver?: InputMaybe<User_Bool_Exp>;
  driver_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  shift_schedule?: InputMaybe<Shift_Schedule_Bool_Exp>;
  shift_schedule_id?: InputMaybe<Uuid_Comparison_Exp>;
  tasks?: InputMaybe<Task_Bool_Exp>;
  tasks_aggregate?: InputMaybe<Task_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "shift_schedule_dispenser" */
export enum Shift_Schedule_Dispenser_Constraint {
  /** unique or primary key constraint on columns "id" */
  ShiftScheduleDispenserPkey = 'shift_schedule_dispenser_pkey',
  /** unique or primary key constraint on columns "shift_schedule_id", "dispenser_id" */
  ShiftScheduleDispenserShiftScheduleIdDispenserIdKey = 'shift_schedule_dispenser_shift_schedule_id_dispenser_id_key'
}

/** input type for inserting data into table "shift_schedule_dispenser" */
export type Shift_Schedule_Dispenser_Insert_Input = {
  createdByUser?: InputMaybe<User_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  dispenser?: InputMaybe<Dispenser_Obj_Rel_Insert_Input>;
  dispenser_id?: InputMaybe<Scalars['uuid']['input']>;
  driver?: InputMaybe<User_Obj_Rel_Insert_Input>;
  driver_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  shift_schedule?: InputMaybe<Shift_Schedule_Obj_Rel_Insert_Input>;
  shift_schedule_id?: InputMaybe<Scalars['uuid']['input']>;
  tasks?: InputMaybe<Task_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Shift_Schedule_Dispenser_Max_Fields = {
  __typename?: 'shift_schedule_dispenser_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  dispenser_id?: Maybe<Scalars['uuid']['output']>;
  driver_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  shift_schedule_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "shift_schedule_dispenser" */
export type Shift_Schedule_Dispenser_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  dispenser_id?: InputMaybe<Order_By>;
  driver_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  shift_schedule_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Shift_Schedule_Dispenser_Min_Fields = {
  __typename?: 'shift_schedule_dispenser_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  dispenser_id?: Maybe<Scalars['uuid']['output']>;
  driver_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  shift_schedule_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "shift_schedule_dispenser" */
export type Shift_Schedule_Dispenser_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  dispenser_id?: InputMaybe<Order_By>;
  driver_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  shift_schedule_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "shift_schedule_dispenser" */
export type Shift_Schedule_Dispenser_Mutation_Response = {
  __typename?: 'shift_schedule_dispenser_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Shift_Schedule_Dispenser>;
};

/** input type for inserting object relation for remote table "shift_schedule_dispenser" */
export type Shift_Schedule_Dispenser_Obj_Rel_Insert_Input = {
  data: Shift_Schedule_Dispenser_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Shift_Schedule_Dispenser_On_Conflict>;
};

/** on_conflict condition type for table "shift_schedule_dispenser" */
export type Shift_Schedule_Dispenser_On_Conflict = {
  constraint: Shift_Schedule_Dispenser_Constraint;
  update_columns?: Array<Shift_Schedule_Dispenser_Update_Column>;
  where?: InputMaybe<Shift_Schedule_Dispenser_Bool_Exp>;
};

/** Ordering options when selecting data from "shift_schedule_dispenser". */
export type Shift_Schedule_Dispenser_Order_By = {
  createdByUser?: InputMaybe<User_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  dispenser?: InputMaybe<Dispenser_Order_By>;
  dispenser_id?: InputMaybe<Order_By>;
  driver?: InputMaybe<User_Order_By>;
  driver_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  shift_schedule?: InputMaybe<Shift_Schedule_Order_By>;
  shift_schedule_id?: InputMaybe<Order_By>;
  tasks_aggregate?: InputMaybe<Task_Aggregate_Order_By>;
};

/** primary key columns input for table: shift_schedule_dispenser */
export type Shift_Schedule_Dispenser_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "shift_schedule_dispenser" */
export enum Shift_Schedule_Dispenser_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DispenserId = 'dispenser_id',
  /** column name */
  DriverId = 'driver_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  ShiftScheduleId = 'shift_schedule_id'
}

/** select "shift_schedule_dispenser_aggregate_bool_exp_bool_and_arguments_columns" columns of table "shift_schedule_dispenser" */
export enum Shift_Schedule_Dispenser_Select_Column_Shift_Schedule_Dispenser_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "shift_schedule_dispenser_aggregate_bool_exp_bool_or_arguments_columns" columns of table "shift_schedule_dispenser" */
export enum Shift_Schedule_Dispenser_Select_Column_Shift_Schedule_Dispenser_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "shift_schedule_dispenser" */
export type Shift_Schedule_Dispenser_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  dispenser_id?: InputMaybe<Scalars['uuid']['input']>;
  driver_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  shift_schedule_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "shift_schedule_dispenser" */
export type Shift_Schedule_Dispenser_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Shift_Schedule_Dispenser_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Shift_Schedule_Dispenser_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  dispenser_id?: InputMaybe<Scalars['uuid']['input']>;
  driver_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  shift_schedule_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "shift_schedule_dispenser" */
export enum Shift_Schedule_Dispenser_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DispenserId = 'dispenser_id',
  /** column name */
  DriverId = 'driver_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  ShiftScheduleId = 'shift_schedule_id'
}

export type Shift_Schedule_Dispenser_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Shift_Schedule_Dispenser_Set_Input>;
  /** filter the rows which have to be updated */
  where: Shift_Schedule_Dispenser_Bool_Exp;
};

/** input type for inserting data into table "shift_schedule" */
export type Shift_Schedule_Insert_Input = {
  /** Timestamp when shift schedule was approved */
  approved_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** User who approved this shift schedule */
  approved_by?: InputMaybe<Scalars['uuid']['input']>;
  approver?: InputMaybe<User_Obj_Rel_Insert_Input>;
  /** Actual break end time */
  break_end_time?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Actual break start time */
  break_start_time?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  customer_order_slots?: InputMaybe<Customer_Order_Slots_Arr_Rel_Insert_Input>;
  driver_vehicle?: InputMaybe<Driver_Vehicle_Obj_Rel_Insert_Input>;
  driver_vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  end_time?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  partner?: InputMaybe<Partner_Obj_Rel_Insert_Input>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Actual refuel end time */
  refuel_end_time?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Actual refuel start time */
  refuel_start_time?: InputMaybe<Scalars['timestamptz']['input']>;
  shift_schedule_dispensers?: InputMaybe<Shift_Schedule_Dispenser_Arr_Rel_Insert_Input>;
  shift_template?: InputMaybe<Shift_Template_Obj_Rel_Insert_Input>;
  /** Reference to shift template used for this schedule */
  shift_template_id?: InputMaybe<Scalars['uuid']['input']>;
  start_time?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Status: SCHEDULED, IN_PROGRESS, COMPLETED, CANCELLED */
  status?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  vehicle?: InputMaybe<Vehicle_Obj_Rel_Insert_Input>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  vehicle_shift_templates?: InputMaybe<Vehicle_Shift_Template_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Shift_Schedule_Max_Fields = {
  __typename?: 'shift_schedule_max_fields';
  /** Timestamp when shift schedule was approved */
  approved_at?: Maybe<Scalars['timestamptz']['output']>;
  /** User who approved this shift schedule */
  approved_by?: Maybe<Scalars['uuid']['output']>;
  /** Actual break end time */
  break_end_time?: Maybe<Scalars['timestamptz']['output']>;
  /** Actual break start time */
  break_start_time?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  driver_vehicle_id?: Maybe<Scalars['uuid']['output']>;
  end_time?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  /** Actual refuel end time */
  refuel_end_time?: Maybe<Scalars['timestamptz']['output']>;
  /** Actual refuel start time */
  refuel_start_time?: Maybe<Scalars['timestamptz']['output']>;
  /** Reference to shift template used for this schedule */
  shift_template_id?: Maybe<Scalars['uuid']['output']>;
  start_time?: Maybe<Scalars['timestamptz']['output']>;
  /** Status: SCHEDULED, IN_PROGRESS, COMPLETED, CANCELLED */
  status?: Maybe<Scalars['String']['output']>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "shift_schedule" */
export type Shift_Schedule_Max_Order_By = {
  /** Timestamp when shift schedule was approved */
  approved_at?: InputMaybe<Order_By>;
  /** User who approved this shift schedule */
  approved_by?: InputMaybe<Order_By>;
  /** Actual break end time */
  break_end_time?: InputMaybe<Order_By>;
  /** Actual break start time */
  break_start_time?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  driver_vehicle_id?: InputMaybe<Order_By>;
  end_time?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  /** Actual refuel end time */
  refuel_end_time?: InputMaybe<Order_By>;
  /** Actual refuel start time */
  refuel_start_time?: InputMaybe<Order_By>;
  /** Reference to shift template used for this schedule */
  shift_template_id?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  /** Status: SCHEDULED, IN_PROGRESS, COMPLETED, CANCELLED */
  status?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Shift_Schedule_Min_Fields = {
  __typename?: 'shift_schedule_min_fields';
  /** Timestamp when shift schedule was approved */
  approved_at?: Maybe<Scalars['timestamptz']['output']>;
  /** User who approved this shift schedule */
  approved_by?: Maybe<Scalars['uuid']['output']>;
  /** Actual break end time */
  break_end_time?: Maybe<Scalars['timestamptz']['output']>;
  /** Actual break start time */
  break_start_time?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  driver_vehicle_id?: Maybe<Scalars['uuid']['output']>;
  end_time?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  /** Actual refuel end time */
  refuel_end_time?: Maybe<Scalars['timestamptz']['output']>;
  /** Actual refuel start time */
  refuel_start_time?: Maybe<Scalars['timestamptz']['output']>;
  /** Reference to shift template used for this schedule */
  shift_template_id?: Maybe<Scalars['uuid']['output']>;
  start_time?: Maybe<Scalars['timestamptz']['output']>;
  /** Status: SCHEDULED, IN_PROGRESS, COMPLETED, CANCELLED */
  status?: Maybe<Scalars['String']['output']>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "shift_schedule" */
export type Shift_Schedule_Min_Order_By = {
  /** Timestamp when shift schedule was approved */
  approved_at?: InputMaybe<Order_By>;
  /** User who approved this shift schedule */
  approved_by?: InputMaybe<Order_By>;
  /** Actual break end time */
  break_end_time?: InputMaybe<Order_By>;
  /** Actual break start time */
  break_start_time?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  driver_vehicle_id?: InputMaybe<Order_By>;
  end_time?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  /** Actual refuel end time */
  refuel_end_time?: InputMaybe<Order_By>;
  /** Actual refuel start time */
  refuel_start_time?: InputMaybe<Order_By>;
  /** Reference to shift template used for this schedule */
  shift_template_id?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  /** Status: SCHEDULED, IN_PROGRESS, COMPLETED, CANCELLED */
  status?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "shift_schedule" */
export type Shift_Schedule_Mutation_Response = {
  __typename?: 'shift_schedule_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Shift_Schedule>;
};

/** input type for inserting object relation for remote table "shift_schedule" */
export type Shift_Schedule_Obj_Rel_Insert_Input = {
  data: Shift_Schedule_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Shift_Schedule_On_Conflict>;
};

/** on_conflict condition type for table "shift_schedule" */
export type Shift_Schedule_On_Conflict = {
  constraint: Shift_Schedule_Constraint;
  update_columns?: Array<Shift_Schedule_Update_Column>;
  where?: InputMaybe<Shift_Schedule_Bool_Exp>;
};

/** Ordering options when selecting data from "shift_schedule". */
export type Shift_Schedule_Order_By = {
  approved_at?: InputMaybe<Order_By>;
  approved_by?: InputMaybe<Order_By>;
  approver?: InputMaybe<User_Order_By>;
  break_end_time?: InputMaybe<Order_By>;
  break_start_time?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  customer_order_slots_aggregate?: InputMaybe<Customer_Order_Slots_Aggregate_Order_By>;
  driver_vehicle?: InputMaybe<Driver_Vehicle_Order_By>;
  driver_vehicle_id?: InputMaybe<Order_By>;
  end_time?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  partner?: InputMaybe<Partner_Order_By>;
  partner_id?: InputMaybe<Order_By>;
  refuel_end_time?: InputMaybe<Order_By>;
  refuel_start_time?: InputMaybe<Order_By>;
  shift_schedule_dispensers_aggregate?: InputMaybe<Shift_Schedule_Dispenser_Aggregate_Order_By>;
  shift_template?: InputMaybe<Shift_Template_Order_By>;
  shift_template_id?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  vehicle?: InputMaybe<Vehicle_Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
  vehicle_shift_templates_aggregate?: InputMaybe<Vehicle_Shift_Template_Aggregate_Order_By>;
};

/** primary key columns input for table: shift_schedule */
export type Shift_Schedule_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "shift_schedule" */
export enum Shift_Schedule_Select_Column {
  /** column name */
  ApprovedAt = 'approved_at',
  /** column name */
  ApprovedBy = 'approved_by',
  /** column name */
  BreakEndTime = 'break_end_time',
  /** column name */
  BreakStartTime = 'break_start_time',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DriverVehicleId = 'driver_vehicle_id',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Notes = 'notes',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  RefuelEndTime = 'refuel_end_time',
  /** column name */
  RefuelStartTime = 'refuel_start_time',
  /** column name */
  ShiftTemplateId = 'shift_template_id',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  Status = 'status',
  /** column name */
  VehicleId = 'vehicle_id'
}

/** select "shift_schedule_aggregate_bool_exp_bool_and_arguments_columns" columns of table "shift_schedule" */
export enum Shift_Schedule_Select_Column_Shift_Schedule_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "shift_schedule_aggregate_bool_exp_bool_or_arguments_columns" columns of table "shift_schedule" */
export enum Shift_Schedule_Select_Column_Shift_Schedule_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "shift_schedule" */
export type Shift_Schedule_Set_Input = {
  /** Timestamp when shift schedule was approved */
  approved_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** User who approved this shift schedule */
  approved_by?: InputMaybe<Scalars['uuid']['input']>;
  /** Actual break end time */
  break_end_time?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Actual break start time */
  break_start_time?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  driver_vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  end_time?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Actual refuel end time */
  refuel_end_time?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Actual refuel start time */
  refuel_start_time?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Reference to shift template used for this schedule */
  shift_template_id?: InputMaybe<Scalars['uuid']['input']>;
  start_time?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Status: SCHEDULED, IN_PROGRESS, COMPLETED, CANCELLED */
  status?: InputMaybe<Scalars['String']['input']>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "shift_schedule" */
export type Shift_Schedule_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Shift_Schedule_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Shift_Schedule_Stream_Cursor_Value_Input = {
  /** Timestamp when shift schedule was approved */
  approved_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** User who approved this shift schedule */
  approved_by?: InputMaybe<Scalars['uuid']['input']>;
  /** Actual break end time */
  break_end_time?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Actual break start time */
  break_start_time?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  driver_vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  end_time?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Actual refuel end time */
  refuel_end_time?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Actual refuel start time */
  refuel_start_time?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Reference to shift template used for this schedule */
  shift_template_id?: InputMaybe<Scalars['uuid']['input']>;
  start_time?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Status: SCHEDULED, IN_PROGRESS, COMPLETED, CANCELLED */
  status?: InputMaybe<Scalars['String']['input']>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "shift_schedule" */
export enum Shift_Schedule_Update_Column {
  /** column name */
  ApprovedAt = 'approved_at',
  /** column name */
  ApprovedBy = 'approved_by',
  /** column name */
  BreakEndTime = 'break_end_time',
  /** column name */
  BreakStartTime = 'break_start_time',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DriverVehicleId = 'driver_vehicle_id',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Notes = 'notes',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  RefuelEndTime = 'refuel_end_time',
  /** column name */
  RefuelStartTime = 'refuel_start_time',
  /** column name */
  ShiftTemplateId = 'shift_template_id',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  Status = 'status',
  /** column name */
  VehicleId = 'vehicle_id'
}

export type Shift_Schedule_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Shift_Schedule_Set_Input>;
  /** filter the rows which have to be updated */
  where: Shift_Schedule_Bool_Exp;
};

/** Global reusable shift patterns for driver scheduling */
export type Shift_Template = {
  __typename?: 'shift_template';
  /** Default break duration in minutes */
  break_duration_minutes: Scalars['Int']['output'];
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  created_by_user?: Maybe<User>;
  /** Days of the week this template applies to. Array of integers: 0=Sun, 1=Mon, ..., 6=Sat. Matches master_slot convention. */
  days_of_week: Scalars['jsonb']['output'];
  description?: Maybe<Scalars['String']['output']>;
  end_time: Scalars['time']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  /** True if shift crosses midnight (e.g., 14:00-02:00) */
  is_overnight: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  modified_by_user?: Maybe<User>;
  name: Scalars['String']['output'];
  /** Default refuel duration in minutes */
  refuel_duration_minutes: Scalars['Int']['output'];
  /** An array relationship */
  shift_schedules: Array<Shift_Schedule>;
  /** An aggregate relationship */
  shift_schedules_aggregate: Shift_Schedule_Aggregate;
  start_time: Scalars['time']['output'];
  /** An array relationship */
  vehicle_shift_templates: Array<Vehicle_Shift_Template>;
  /** An aggregate relationship */
  vehicle_shift_templates_aggregate: Vehicle_Shift_Template_Aggregate;
};


/** Global reusable shift patterns for driver scheduling */
export type Shift_TemplateDays_Of_WeekArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Global reusable shift patterns for driver scheduling */
export type Shift_TemplateShift_SchedulesArgs = {
  distinct_on?: InputMaybe<Array<Shift_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shift_Schedule_Order_By>>;
  where?: InputMaybe<Shift_Schedule_Bool_Exp>;
};


/** Global reusable shift patterns for driver scheduling */
export type Shift_TemplateShift_Schedules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shift_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shift_Schedule_Order_By>>;
  where?: InputMaybe<Shift_Schedule_Bool_Exp>;
};


/** Global reusable shift patterns for driver scheduling */
export type Shift_TemplateVehicle_Shift_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Shift_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Shift_Template_Order_By>>;
  where?: InputMaybe<Vehicle_Shift_Template_Bool_Exp>;
};


/** Global reusable shift patterns for driver scheduling */
export type Shift_TemplateVehicle_Shift_Templates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Shift_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Shift_Template_Order_By>>;
  where?: InputMaybe<Vehicle_Shift_Template_Bool_Exp>;
};

/** aggregated selection of "shift_template" */
export type Shift_Template_Aggregate = {
  __typename?: 'shift_template_aggregate';
  aggregate?: Maybe<Shift_Template_Aggregate_Fields>;
  nodes: Array<Shift_Template>;
};

export type Shift_Template_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Shift_Template_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Shift_Template_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Shift_Template_Aggregate_Bool_Exp_Count>;
};

export type Shift_Template_Aggregate_Bool_Exp_Bool_And = {
  arguments: Shift_Template_Select_Column_Shift_Template_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Shift_Template_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Shift_Template_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Shift_Template_Select_Column_Shift_Template_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Shift_Template_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Shift_Template_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Shift_Template_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Shift_Template_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "shift_template" */
export type Shift_Template_Aggregate_Fields = {
  __typename?: 'shift_template_aggregate_fields';
  avg?: Maybe<Shift_Template_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Shift_Template_Max_Fields>;
  min?: Maybe<Shift_Template_Min_Fields>;
  stddev?: Maybe<Shift_Template_Stddev_Fields>;
  stddev_pop?: Maybe<Shift_Template_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Shift_Template_Stddev_Samp_Fields>;
  sum?: Maybe<Shift_Template_Sum_Fields>;
  var_pop?: Maybe<Shift_Template_Var_Pop_Fields>;
  var_samp?: Maybe<Shift_Template_Var_Samp_Fields>;
  variance?: Maybe<Shift_Template_Variance_Fields>;
};


/** aggregate fields of "shift_template" */
export type Shift_Template_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Shift_Template_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "shift_template" */
export type Shift_Template_Aggregate_Order_By = {
  avg?: InputMaybe<Shift_Template_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Shift_Template_Max_Order_By>;
  min?: InputMaybe<Shift_Template_Min_Order_By>;
  stddev?: InputMaybe<Shift_Template_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Shift_Template_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Shift_Template_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Shift_Template_Sum_Order_By>;
  var_pop?: InputMaybe<Shift_Template_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Shift_Template_Var_Samp_Order_By>;
  variance?: InputMaybe<Shift_Template_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Shift_Template_Append_Input = {
  /** Days of the week this template applies to. Array of integers: 0=Sun, 1=Mon, ..., 6=Sat. Matches master_slot convention. */
  days_of_week?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "shift_template" */
export type Shift_Template_Arr_Rel_Insert_Input = {
  data: Array<Shift_Template_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Shift_Template_On_Conflict>;
};

/** aggregate avg on columns */
export type Shift_Template_Avg_Fields = {
  __typename?: 'shift_template_avg_fields';
  /** Default break duration in minutes */
  break_duration_minutes?: Maybe<Scalars['Float']['output']>;
  /** Default refuel duration in minutes */
  refuel_duration_minutes?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "shift_template" */
export type Shift_Template_Avg_Order_By = {
  /** Default break duration in minutes */
  break_duration_minutes?: InputMaybe<Order_By>;
  /** Default refuel duration in minutes */
  refuel_duration_minutes?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "shift_template". All fields are combined with a logical 'AND'. */
export type Shift_Template_Bool_Exp = {
  _and?: InputMaybe<Array<Shift_Template_Bool_Exp>>;
  _not?: InputMaybe<Shift_Template_Bool_Exp>;
  _or?: InputMaybe<Array<Shift_Template_Bool_Exp>>;
  break_duration_minutes?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  created_by_user?: InputMaybe<User_Bool_Exp>;
  days_of_week?: InputMaybe<Jsonb_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  end_time?: InputMaybe<Time_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_overnight?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  modified_by_user?: InputMaybe<User_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  refuel_duration_minutes?: InputMaybe<Int_Comparison_Exp>;
  shift_schedules?: InputMaybe<Shift_Schedule_Bool_Exp>;
  shift_schedules_aggregate?: InputMaybe<Shift_Schedule_Aggregate_Bool_Exp>;
  start_time?: InputMaybe<Time_Comparison_Exp>;
  vehicle_shift_templates?: InputMaybe<Vehicle_Shift_Template_Bool_Exp>;
  vehicle_shift_templates_aggregate?: InputMaybe<Vehicle_Shift_Template_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "shift_template" */
export enum Shift_Template_Constraint {
  /** unique or primary key constraint on columns "name" */
  ShiftTemplateNameKey = 'shift_template_name_key',
  /** unique or primary key constraint on columns "id" */
  ShiftTemplatePkey = 'shift_template_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Shift_Template_Delete_At_Path_Input = {
  /** Days of the week this template applies to. Array of integers: 0=Sun, 1=Mon, ..., 6=Sat. Matches master_slot convention. */
  days_of_week?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Shift_Template_Delete_Elem_Input = {
  /** Days of the week this template applies to. Array of integers: 0=Sun, 1=Mon, ..., 6=Sat. Matches master_slot convention. */
  days_of_week?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Shift_Template_Delete_Key_Input = {
  /** Days of the week this template applies to. Array of integers: 0=Sun, 1=Mon, ..., 6=Sat. Matches master_slot convention. */
  days_of_week?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "shift_template" */
export type Shift_Template_Inc_Input = {
  /** Default break duration in minutes */
  break_duration_minutes?: InputMaybe<Scalars['Int']['input']>;
  /** Default refuel duration in minutes */
  refuel_duration_minutes?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "shift_template" */
export type Shift_Template_Insert_Input = {
  /** Default break duration in minutes */
  break_duration_minutes?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  created_by_user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  /** Days of the week this template applies to. Array of integers: 0=Sun, 1=Mon, ..., 6=Sat. Matches master_slot convention. */
  days_of_week?: InputMaybe<Scalars['jsonb']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  end_time?: InputMaybe<Scalars['time']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  /** True if shift crosses midnight (e.g., 14:00-02:00) */
  is_overnight?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  modified_by_user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Default refuel duration in minutes */
  refuel_duration_minutes?: InputMaybe<Scalars['Int']['input']>;
  shift_schedules?: InputMaybe<Shift_Schedule_Arr_Rel_Insert_Input>;
  start_time?: InputMaybe<Scalars['time']['input']>;
  vehicle_shift_templates?: InputMaybe<Vehicle_Shift_Template_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Shift_Template_Max_Fields = {
  __typename?: 'shift_template_max_fields';
  /** Default break duration in minutes */
  break_duration_minutes?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Default refuel duration in minutes */
  refuel_duration_minutes?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "shift_template" */
export type Shift_Template_Max_Order_By = {
  /** Default break duration in minutes */
  break_duration_minutes?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  /** Default refuel duration in minutes */
  refuel_duration_minutes?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Shift_Template_Min_Fields = {
  __typename?: 'shift_template_min_fields';
  /** Default break duration in minutes */
  break_duration_minutes?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Default refuel duration in minutes */
  refuel_duration_minutes?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "shift_template" */
export type Shift_Template_Min_Order_By = {
  /** Default break duration in minutes */
  break_duration_minutes?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  /** Default refuel duration in minutes */
  refuel_duration_minutes?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "shift_template" */
export type Shift_Template_Mutation_Response = {
  __typename?: 'shift_template_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Shift_Template>;
};

/** input type for inserting object relation for remote table "shift_template" */
export type Shift_Template_Obj_Rel_Insert_Input = {
  data: Shift_Template_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Shift_Template_On_Conflict>;
};

/** on_conflict condition type for table "shift_template" */
export type Shift_Template_On_Conflict = {
  constraint: Shift_Template_Constraint;
  update_columns?: Array<Shift_Template_Update_Column>;
  where?: InputMaybe<Shift_Template_Bool_Exp>;
};

/** Ordering options when selecting data from "shift_template". */
export type Shift_Template_Order_By = {
  break_duration_minutes?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<User_Order_By>;
  days_of_week?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  end_time?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_overnight?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  modified_by_user?: InputMaybe<User_Order_By>;
  name?: InputMaybe<Order_By>;
  refuel_duration_minutes?: InputMaybe<Order_By>;
  shift_schedules_aggregate?: InputMaybe<Shift_Schedule_Aggregate_Order_By>;
  start_time?: InputMaybe<Order_By>;
  vehicle_shift_templates_aggregate?: InputMaybe<Vehicle_Shift_Template_Aggregate_Order_By>;
};

/** primary key columns input for table: shift_template */
export type Shift_Template_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Shift_Template_Prepend_Input = {
  /** Days of the week this template applies to. Array of integers: 0=Sun, 1=Mon, ..., 6=Sat. Matches master_slot convention. */
  days_of_week?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "shift_template" */
export enum Shift_Template_Select_Column {
  /** column name */
  BreakDurationMinutes = 'break_duration_minutes',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DaysOfWeek = 'days_of_week',
  /** column name */
  Description = 'description',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsOvernight = 'is_overnight',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  RefuelDurationMinutes = 'refuel_duration_minutes',
  /** column name */
  StartTime = 'start_time'
}

/** select "shift_template_aggregate_bool_exp_bool_and_arguments_columns" columns of table "shift_template" */
export enum Shift_Template_Select_Column_Shift_Template_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsOvernight = 'is_overnight'
}

/** select "shift_template_aggregate_bool_exp_bool_or_arguments_columns" columns of table "shift_template" */
export enum Shift_Template_Select_Column_Shift_Template_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsOvernight = 'is_overnight'
}

/** input type for updating data in table "shift_template" */
export type Shift_Template_Set_Input = {
  /** Default break duration in minutes */
  break_duration_minutes?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  /** Days of the week this template applies to. Array of integers: 0=Sun, 1=Mon, ..., 6=Sat. Matches master_slot convention. */
  days_of_week?: InputMaybe<Scalars['jsonb']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  end_time?: InputMaybe<Scalars['time']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  /** True if shift crosses midnight (e.g., 14:00-02:00) */
  is_overnight?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Default refuel duration in minutes */
  refuel_duration_minutes?: InputMaybe<Scalars['Int']['input']>;
  start_time?: InputMaybe<Scalars['time']['input']>;
};

/** aggregate stddev on columns */
export type Shift_Template_Stddev_Fields = {
  __typename?: 'shift_template_stddev_fields';
  /** Default break duration in minutes */
  break_duration_minutes?: Maybe<Scalars['Float']['output']>;
  /** Default refuel duration in minutes */
  refuel_duration_minutes?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "shift_template" */
export type Shift_Template_Stddev_Order_By = {
  /** Default break duration in minutes */
  break_duration_minutes?: InputMaybe<Order_By>;
  /** Default refuel duration in minutes */
  refuel_duration_minutes?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Shift_Template_Stddev_Pop_Fields = {
  __typename?: 'shift_template_stddev_pop_fields';
  /** Default break duration in minutes */
  break_duration_minutes?: Maybe<Scalars['Float']['output']>;
  /** Default refuel duration in minutes */
  refuel_duration_minutes?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "shift_template" */
export type Shift_Template_Stddev_Pop_Order_By = {
  /** Default break duration in minutes */
  break_duration_minutes?: InputMaybe<Order_By>;
  /** Default refuel duration in minutes */
  refuel_duration_minutes?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Shift_Template_Stddev_Samp_Fields = {
  __typename?: 'shift_template_stddev_samp_fields';
  /** Default break duration in minutes */
  break_duration_minutes?: Maybe<Scalars['Float']['output']>;
  /** Default refuel duration in minutes */
  refuel_duration_minutes?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "shift_template" */
export type Shift_Template_Stddev_Samp_Order_By = {
  /** Default break duration in minutes */
  break_duration_minutes?: InputMaybe<Order_By>;
  /** Default refuel duration in minutes */
  refuel_duration_minutes?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "shift_template" */
export type Shift_Template_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Shift_Template_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Shift_Template_Stream_Cursor_Value_Input = {
  /** Default break duration in minutes */
  break_duration_minutes?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  /** Days of the week this template applies to. Array of integers: 0=Sun, 1=Mon, ..., 6=Sat. Matches master_slot convention. */
  days_of_week?: InputMaybe<Scalars['jsonb']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  end_time?: InputMaybe<Scalars['time']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  /** True if shift crosses midnight (e.g., 14:00-02:00) */
  is_overnight?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Default refuel duration in minutes */
  refuel_duration_minutes?: InputMaybe<Scalars['Int']['input']>;
  start_time?: InputMaybe<Scalars['time']['input']>;
};

/** aggregate sum on columns */
export type Shift_Template_Sum_Fields = {
  __typename?: 'shift_template_sum_fields';
  /** Default break duration in minutes */
  break_duration_minutes?: Maybe<Scalars['Int']['output']>;
  /** Default refuel duration in minutes */
  refuel_duration_minutes?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "shift_template" */
export type Shift_Template_Sum_Order_By = {
  /** Default break duration in minutes */
  break_duration_minutes?: InputMaybe<Order_By>;
  /** Default refuel duration in minutes */
  refuel_duration_minutes?: InputMaybe<Order_By>;
};

/** update columns of table "shift_template" */
export enum Shift_Template_Update_Column {
  /** column name */
  BreakDurationMinutes = 'break_duration_minutes',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DaysOfWeek = 'days_of_week',
  /** column name */
  Description = 'description',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsOvernight = 'is_overnight',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  RefuelDurationMinutes = 'refuel_duration_minutes',
  /** column name */
  StartTime = 'start_time'
}

export type Shift_Template_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Shift_Template_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Shift_Template_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Shift_Template_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Shift_Template_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Shift_Template_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Shift_Template_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Shift_Template_Set_Input>;
  /** filter the rows which have to be updated */
  where: Shift_Template_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Shift_Template_Var_Pop_Fields = {
  __typename?: 'shift_template_var_pop_fields';
  /** Default break duration in minutes */
  break_duration_minutes?: Maybe<Scalars['Float']['output']>;
  /** Default refuel duration in minutes */
  refuel_duration_minutes?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "shift_template" */
export type Shift_Template_Var_Pop_Order_By = {
  /** Default break duration in minutes */
  break_duration_minutes?: InputMaybe<Order_By>;
  /** Default refuel duration in minutes */
  refuel_duration_minutes?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Shift_Template_Var_Samp_Fields = {
  __typename?: 'shift_template_var_samp_fields';
  /** Default break duration in minutes */
  break_duration_minutes?: Maybe<Scalars['Float']['output']>;
  /** Default refuel duration in minutes */
  refuel_duration_minutes?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "shift_template" */
export type Shift_Template_Var_Samp_Order_By = {
  /** Default break duration in minutes */
  break_duration_minutes?: InputMaybe<Order_By>;
  /** Default refuel duration in minutes */
  refuel_duration_minutes?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Shift_Template_Variance_Fields = {
  __typename?: 'shift_template_variance_fields';
  /** Default break duration in minutes */
  break_duration_minutes?: Maybe<Scalars['Float']['output']>;
  /** Default refuel duration in minutes */
  refuel_duration_minutes?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "shift_template" */
export type Shift_Template_Variance_Order_By = {
  /** Default break duration in minutes */
  break_duration_minutes?: InputMaybe<Order_By>;
  /** Default refuel duration in minutes */
  refuel_duration_minutes?: InputMaybe<Order_By>;
};

/** columns and relationships of "slab_type" */
export type Slab_Type = {
  __typename?: 'slab_type';
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  user_ledgers: Array<User_Ledger>;
  /** An aggregate relationship */
  user_ledgers_aggregate: User_Ledger_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "slab_type" */
export type Slab_TypeUser_LedgersArgs = {
  distinct_on?: InputMaybe<Array<User_Ledger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Ledger_Order_By>>;
  where?: InputMaybe<User_Ledger_Bool_Exp>;
};


/** columns and relationships of "slab_type" */
export type Slab_TypeUser_Ledgers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Ledger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Ledger_Order_By>>;
  where?: InputMaybe<User_Ledger_Bool_Exp>;
};

/** aggregated selection of "slab_type" */
export type Slab_Type_Aggregate = {
  __typename?: 'slab_type_aggregate';
  aggregate?: Maybe<Slab_Type_Aggregate_Fields>;
  nodes: Array<Slab_Type>;
};

/** aggregate fields of "slab_type" */
export type Slab_Type_Aggregate_Fields = {
  __typename?: 'slab_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Slab_Type_Max_Fields>;
  min?: Maybe<Slab_Type_Min_Fields>;
};


/** aggregate fields of "slab_type" */
export type Slab_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Slab_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "slab_type". All fields are combined with a logical 'AND'. */
export type Slab_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Slab_Type_Bool_Exp>>;
  _not?: InputMaybe<Slab_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Slab_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  user_ledgers?: InputMaybe<User_Ledger_Bool_Exp>;
  user_ledgers_aggregate?: InputMaybe<User_Ledger_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "slab_type" */
export enum Slab_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  SlabTypePkey = 'slab_type_pkey'
}

export enum Slab_Type_Enum {
  /** FLAT */
  Flat = 'FLAT',
  /** PERCENTAGE */
  Percentage = 'PERCENTAGE',
  /** PER_CUSTOMER */
  PerCustomer = 'PER_CUSTOMER',
  /** PER_LITER */
  PerLiter = 'PER_LITER'
}

/** Boolean expression to compare columns of type "slab_type_enum". All fields are combined with logical 'AND'. */
export type Slab_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Slab_Type_Enum>;
  _in?: InputMaybe<Array<Slab_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Slab_Type_Enum>;
  _nin?: InputMaybe<Array<Slab_Type_Enum>>;
};

/** input type for inserting data into table "slab_type" */
export type Slab_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  user_ledgers?: InputMaybe<User_Ledger_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Slab_Type_Max_Fields = {
  __typename?: 'slab_type_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Slab_Type_Min_Fields = {
  __typename?: 'slab_type_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "slab_type" */
export type Slab_Type_Mutation_Response = {
  __typename?: 'slab_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Slab_Type>;
};

/** input type for inserting object relation for remote table "slab_type" */
export type Slab_Type_Obj_Rel_Insert_Input = {
  data: Slab_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Slab_Type_On_Conflict>;
};

/** on_conflict condition type for table "slab_type" */
export type Slab_Type_On_Conflict = {
  constraint: Slab_Type_Constraint;
  update_columns?: Array<Slab_Type_Update_Column>;
  where?: InputMaybe<Slab_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "slab_type". */
export type Slab_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  user_ledgers_aggregate?: InputMaybe<User_Ledger_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: slab_type */
export type Slab_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "slab_type" */
export enum Slab_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "slab_type" */
export type Slab_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "slab_type" */
export type Slab_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Slab_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Slab_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "slab_type" */
export enum Slab_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Slab_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Slab_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Slab_Type_Bool_Exp;
};

export type SlotsInput = {
  day_date: Scalars['date']['input'];
  driver_vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  end_time: Scalars['timetz']['input'];
  /**
   * This delivery's own quantity. Optional: without it the caller's
   * total_monthly_qty is still split evenly across the slots, so existing
   * callers are unchanged. With it, one call can carry deliveries of
   * different sizes -- the even split made a 1,000 L and a 5,000 L delivery
   * sent together both come out at 3,000 L, which is why plan approval had
   * to issue a separate call per delivery.
   */
  qty?: InputMaybe<Scalars['numeric']['input']>;
  shift_schedule_id?: InputMaybe<Scalars['uuid']['input']>;
  start_time: Scalars['timetz']['input'];
};

/** columns and relationships of "source_type" */
export type Source_Type = {
  __typename?: 'source_type';
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  support_tickets: Array<Support_Tickets>;
  /** An aggregate relationship */
  support_tickets_aggregate: Support_Tickets_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "source_type" */
export type Source_TypeSupport_TicketsArgs = {
  distinct_on?: InputMaybe<Array<Support_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Support_Tickets_Order_By>>;
  where?: InputMaybe<Support_Tickets_Bool_Exp>;
};


/** columns and relationships of "source_type" */
export type Source_TypeSupport_Tickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Support_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Support_Tickets_Order_By>>;
  where?: InputMaybe<Support_Tickets_Bool_Exp>;
};

/** aggregated selection of "source_type" */
export type Source_Type_Aggregate = {
  __typename?: 'source_type_aggregate';
  aggregate?: Maybe<Source_Type_Aggregate_Fields>;
  nodes: Array<Source_Type>;
};

/** aggregate fields of "source_type" */
export type Source_Type_Aggregate_Fields = {
  __typename?: 'source_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Source_Type_Max_Fields>;
  min?: Maybe<Source_Type_Min_Fields>;
};


/** aggregate fields of "source_type" */
export type Source_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Source_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "source_type". All fields are combined with a logical 'AND'. */
export type Source_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Source_Type_Bool_Exp>>;
  _not?: InputMaybe<Source_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Source_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  support_tickets?: InputMaybe<Support_Tickets_Bool_Exp>;
  support_tickets_aggregate?: InputMaybe<Support_Tickets_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "source_type" */
export enum Source_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  SourceTypePkey = 'source_type_pkey'
}

export enum Source_Type_Enum {
  /** ADMIN */
  Admin = 'ADMIN',
  /** CUSTOMER */
  Customer = 'CUSTOMER',
  /** DRIVER */
  Driver = 'DRIVER',
  /** FRANCHISE */
  Franchise = 'FRANCHISE',
  /** FRIDAY */
  Friday = 'FRIDAY',
  /** SELLER */
  Seller = 'SELLER',
  /** VENDOR */
  Vendor = 'VENDOR'
}

/** Boolean expression to compare columns of type "source_type_enum". All fields are combined with logical 'AND'. */
export type Source_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Source_Type_Enum>;
  _in?: InputMaybe<Array<Source_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Source_Type_Enum>;
  _nin?: InputMaybe<Array<Source_Type_Enum>>;
};

/** input type for inserting data into table "source_type" */
export type Source_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  support_tickets?: InputMaybe<Support_Tickets_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Source_Type_Max_Fields = {
  __typename?: 'source_type_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Source_Type_Min_Fields = {
  __typename?: 'source_type_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "source_type" */
export type Source_Type_Mutation_Response = {
  __typename?: 'source_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Source_Type>;
};

/** input type for inserting object relation for remote table "source_type" */
export type Source_Type_Obj_Rel_Insert_Input = {
  data: Source_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Source_Type_On_Conflict>;
};

/** on_conflict condition type for table "source_type" */
export type Source_Type_On_Conflict = {
  constraint: Source_Type_Constraint;
  update_columns?: Array<Source_Type_Update_Column>;
  where?: InputMaybe<Source_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "source_type". */
export type Source_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  support_tickets_aggregate?: InputMaybe<Support_Tickets_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: source_type */
export type Source_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "source_type" */
export enum Source_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "source_type" */
export type Source_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "source_type" */
export type Source_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Source_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Source_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "source_type" */
export enum Source_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Source_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Source_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Source_Type_Bool_Exp;
};

/** columns and relationships of "spatial_ref_sys" */
export type Spatial_Ref_Sys = {
  __typename?: 'spatial_ref_sys';
  auth_name?: Maybe<Scalars['String']['output']>;
  auth_srid?: Maybe<Scalars['Int']['output']>;
  proj4text?: Maybe<Scalars['String']['output']>;
  srid: Scalars['Int']['output'];
  srtext?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "spatial_ref_sys" */
export type Spatial_Ref_Sys_Aggregate = {
  __typename?: 'spatial_ref_sys_aggregate';
  aggregate?: Maybe<Spatial_Ref_Sys_Aggregate_Fields>;
  nodes: Array<Spatial_Ref_Sys>;
};

/** aggregate fields of "spatial_ref_sys" */
export type Spatial_Ref_Sys_Aggregate_Fields = {
  __typename?: 'spatial_ref_sys_aggregate_fields';
  avg?: Maybe<Spatial_Ref_Sys_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Spatial_Ref_Sys_Max_Fields>;
  min?: Maybe<Spatial_Ref_Sys_Min_Fields>;
  stddev?: Maybe<Spatial_Ref_Sys_Stddev_Fields>;
  stddev_pop?: Maybe<Spatial_Ref_Sys_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Spatial_Ref_Sys_Stddev_Samp_Fields>;
  sum?: Maybe<Spatial_Ref_Sys_Sum_Fields>;
  var_pop?: Maybe<Spatial_Ref_Sys_Var_Pop_Fields>;
  var_samp?: Maybe<Spatial_Ref_Sys_Var_Samp_Fields>;
  variance?: Maybe<Spatial_Ref_Sys_Variance_Fields>;
};


/** aggregate fields of "spatial_ref_sys" */
export type Spatial_Ref_Sys_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Spatial_Ref_Sys_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Spatial_Ref_Sys_Avg_Fields = {
  __typename?: 'spatial_ref_sys_avg_fields';
  auth_srid?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "spatial_ref_sys". All fields are combined with a logical 'AND'. */
export type Spatial_Ref_Sys_Bool_Exp = {
  _and?: InputMaybe<Array<Spatial_Ref_Sys_Bool_Exp>>;
  _not?: InputMaybe<Spatial_Ref_Sys_Bool_Exp>;
  _or?: InputMaybe<Array<Spatial_Ref_Sys_Bool_Exp>>;
  auth_name?: InputMaybe<String_Comparison_Exp>;
  auth_srid?: InputMaybe<Int_Comparison_Exp>;
  proj4text?: InputMaybe<String_Comparison_Exp>;
  srid?: InputMaybe<Int_Comparison_Exp>;
  srtext?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "spatial_ref_sys" */
export enum Spatial_Ref_Sys_Constraint {
  /** unique or primary key constraint on columns "srid" */
  SpatialRefSysPkey = 'spatial_ref_sys_pkey'
}

/** input type for incrementing numeric columns in table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Inc_Input = {
  auth_srid?: InputMaybe<Scalars['Int']['input']>;
  srid?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Insert_Input = {
  auth_name?: InputMaybe<Scalars['String']['input']>;
  auth_srid?: InputMaybe<Scalars['Int']['input']>;
  proj4text?: InputMaybe<Scalars['String']['input']>;
  srid?: InputMaybe<Scalars['Int']['input']>;
  srtext?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Spatial_Ref_Sys_Max_Fields = {
  __typename?: 'spatial_ref_sys_max_fields';
  auth_name?: Maybe<Scalars['String']['output']>;
  auth_srid?: Maybe<Scalars['Int']['output']>;
  proj4text?: Maybe<Scalars['String']['output']>;
  srid?: Maybe<Scalars['Int']['output']>;
  srtext?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Spatial_Ref_Sys_Min_Fields = {
  __typename?: 'spatial_ref_sys_min_fields';
  auth_name?: Maybe<Scalars['String']['output']>;
  auth_srid?: Maybe<Scalars['Int']['output']>;
  proj4text?: Maybe<Scalars['String']['output']>;
  srid?: Maybe<Scalars['Int']['output']>;
  srtext?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Mutation_Response = {
  __typename?: 'spatial_ref_sys_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Spatial_Ref_Sys>;
};

/** on_conflict condition type for table "spatial_ref_sys" */
export type Spatial_Ref_Sys_On_Conflict = {
  constraint: Spatial_Ref_Sys_Constraint;
  update_columns?: Array<Spatial_Ref_Sys_Update_Column>;
  where?: InputMaybe<Spatial_Ref_Sys_Bool_Exp>;
};

/** Ordering options when selecting data from "spatial_ref_sys". */
export type Spatial_Ref_Sys_Order_By = {
  auth_name?: InputMaybe<Order_By>;
  auth_srid?: InputMaybe<Order_By>;
  proj4text?: InputMaybe<Order_By>;
  srid?: InputMaybe<Order_By>;
  srtext?: InputMaybe<Order_By>;
};

/** primary key columns input for table: spatial_ref_sys */
export type Spatial_Ref_Sys_Pk_Columns_Input = {
  srid: Scalars['Int']['input'];
};

/** select columns of table "spatial_ref_sys" */
export enum Spatial_Ref_Sys_Select_Column {
  /** column name */
  AuthName = 'auth_name',
  /** column name */
  AuthSrid = 'auth_srid',
  /** column name */
  Proj4text = 'proj4text',
  /** column name */
  Srid = 'srid',
  /** column name */
  Srtext = 'srtext'
}

/** input type for updating data in table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Set_Input = {
  auth_name?: InputMaybe<Scalars['String']['input']>;
  auth_srid?: InputMaybe<Scalars['Int']['input']>;
  proj4text?: InputMaybe<Scalars['String']['input']>;
  srid?: InputMaybe<Scalars['Int']['input']>;
  srtext?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Spatial_Ref_Sys_Stddev_Fields = {
  __typename?: 'spatial_ref_sys_stddev_fields';
  auth_srid?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Spatial_Ref_Sys_Stddev_Pop_Fields = {
  __typename?: 'spatial_ref_sys_stddev_pop_fields';
  auth_srid?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Spatial_Ref_Sys_Stddev_Samp_Fields = {
  __typename?: 'spatial_ref_sys_stddev_samp_fields';
  auth_srid?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Spatial_Ref_Sys_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Spatial_Ref_Sys_Stream_Cursor_Value_Input = {
  auth_name?: InputMaybe<Scalars['String']['input']>;
  auth_srid?: InputMaybe<Scalars['Int']['input']>;
  proj4text?: InputMaybe<Scalars['String']['input']>;
  srid?: InputMaybe<Scalars['Int']['input']>;
  srtext?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Spatial_Ref_Sys_Sum_Fields = {
  __typename?: 'spatial_ref_sys_sum_fields';
  auth_srid?: Maybe<Scalars['Int']['output']>;
  srid?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "spatial_ref_sys" */
export enum Spatial_Ref_Sys_Update_Column {
  /** column name */
  AuthName = 'auth_name',
  /** column name */
  AuthSrid = 'auth_srid',
  /** column name */
  Proj4text = 'proj4text',
  /** column name */
  Srid = 'srid',
  /** column name */
  Srtext = 'srtext'
}

export type Spatial_Ref_Sys_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Spatial_Ref_Sys_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Spatial_Ref_Sys_Set_Input>;
  /** filter the rows which have to be updated */
  where: Spatial_Ref_Sys_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Spatial_Ref_Sys_Var_Pop_Fields = {
  __typename?: 'spatial_ref_sys_var_pop_fields';
  auth_srid?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Spatial_Ref_Sys_Var_Samp_Fields = {
  __typename?: 'spatial_ref_sys_var_samp_fields';
  auth_srid?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Spatial_Ref_Sys_Variance_Fields = {
  __typename?: 'spatial_ref_sys_variance_fields';
  auth_srid?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

export type St_D_Within_Geography_Input = {
  distance: Scalars['Float']['input'];
  from: Scalars['geography']['input'];
  use_spheroid?: InputMaybe<Scalars['Boolean']['input']>;
};

export type St_D_Within_Input = {
  distance: Scalars['Float']['input'];
  from: Scalars['geometry']['input'];
};

/** columns and relationships of "state" */
export type State = {
  __typename?: 'state';
  /** An array relationship */
  cities: Array<City>;
  /** An aggregate relationship */
  cities_aggregate: City_Aggregate;
  code?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  country: Country;
  country_id: Scalars['uuid']['output'];
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  customer_assets: Array<Customer_Asset>;
  /** An aggregate relationship */
  customer_assets_aggregate: Customer_Asset_Aggregate;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numeric_code_id?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  organization_addresses: Array<Organization_Address>;
  /** An aggregate relationship */
  organization_addresses_aggregate: Organization_Address_Aggregate;
  vehicle_code?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  vehicles: Array<Vehicle>;
  /** An aggregate relationship */
  vehicles_aggregate: Vehicle_Aggregate;
};


/** columns and relationships of "state" */
export type StateCitiesArgs = {
  distinct_on?: InputMaybe<Array<City_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<City_Order_By>>;
  where?: InputMaybe<City_Bool_Exp>;
};


/** columns and relationships of "state" */
export type StateCities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<City_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<City_Order_By>>;
  where?: InputMaybe<City_Bool_Exp>;
};


/** columns and relationships of "state" */
export type StateCustomer_AssetsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Order_By>>;
  where?: InputMaybe<Customer_Asset_Bool_Exp>;
};


/** columns and relationships of "state" */
export type StateCustomer_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Order_By>>;
  where?: InputMaybe<Customer_Asset_Bool_Exp>;
};


/** columns and relationships of "state" */
export type StateOrganization_AddressesArgs = {
  distinct_on?: InputMaybe<Array<Organization_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Address_Order_By>>;
  where?: InputMaybe<Organization_Address_Bool_Exp>;
};


/** columns and relationships of "state" */
export type StateOrganization_Addresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Address_Order_By>>;
  where?: InputMaybe<Organization_Address_Bool_Exp>;
};


/** columns and relationships of "state" */
export type StateVehiclesArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Order_By>>;
  where?: InputMaybe<Vehicle_Bool_Exp>;
};


/** columns and relationships of "state" */
export type StateVehicles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Order_By>>;
  where?: InputMaybe<Vehicle_Bool_Exp>;
};

/** aggregated selection of "state" */
export type State_Aggregate = {
  __typename?: 'state_aggregate';
  aggregate?: Maybe<State_Aggregate_Fields>;
  nodes: Array<State>;
};

export type State_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<State_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<State_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<State_Aggregate_Bool_Exp_Count>;
};

export type State_Aggregate_Bool_Exp_Bool_And = {
  arguments: State_Select_Column_State_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<State_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type State_Aggregate_Bool_Exp_Bool_Or = {
  arguments: State_Select_Column_State_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<State_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type State_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<State_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<State_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "state" */
export type State_Aggregate_Fields = {
  __typename?: 'state_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<State_Max_Fields>;
  min?: Maybe<State_Min_Fields>;
};


/** aggregate fields of "state" */
export type State_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<State_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "state" */
export type State_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<State_Max_Order_By>;
  min?: InputMaybe<State_Min_Order_By>;
};

/** input type for inserting array relation for remote table "state" */
export type State_Arr_Rel_Insert_Input = {
  data: Array<State_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<State_On_Conflict>;
};

/** Boolean expression to filter rows from the table "state". All fields are combined with a logical 'AND'. */
export type State_Bool_Exp = {
  _and?: InputMaybe<Array<State_Bool_Exp>>;
  _not?: InputMaybe<State_Bool_Exp>;
  _or?: InputMaybe<Array<State_Bool_Exp>>;
  cities?: InputMaybe<City_Bool_Exp>;
  cities_aggregate?: InputMaybe<City_Aggregate_Bool_Exp>;
  code?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<Country_Bool_Exp>;
  country_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_assets?: InputMaybe<Customer_Asset_Bool_Exp>;
  customer_assets_aggregate?: InputMaybe<Customer_Asset_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  numeric_code_id?: InputMaybe<String_Comparison_Exp>;
  organization_addresses?: InputMaybe<Organization_Address_Bool_Exp>;
  organization_addresses_aggregate?: InputMaybe<Organization_Address_Aggregate_Bool_Exp>;
  vehicle_code?: InputMaybe<String_Comparison_Exp>;
  vehicles?: InputMaybe<Vehicle_Bool_Exp>;
  vehicles_aggregate?: InputMaybe<Vehicle_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "state" */
export enum State_Constraint {
  /** unique or primary key constraint on columns "id" */
  StatePkey = 'state_pkey'
}

/** input type for inserting data into table "state" */
export type State_Insert_Input = {
  cities?: InputMaybe<City_Arr_Rel_Insert_Input>;
  code?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Country_Obj_Rel_Insert_Input>;
  country_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_assets?: InputMaybe<Customer_Asset_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  numeric_code_id?: InputMaybe<Scalars['String']['input']>;
  organization_addresses?: InputMaybe<Organization_Address_Arr_Rel_Insert_Input>;
  vehicle_code?: InputMaybe<Scalars['String']['input']>;
  vehicles?: InputMaybe<Vehicle_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type State_Max_Fields = {
  __typename?: 'state_max_fields';
  code?: Maybe<Scalars['String']['output']>;
  country_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numeric_code_id?: Maybe<Scalars['String']['output']>;
  vehicle_code?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "state" */
export type State_Max_Order_By = {
  code?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  numeric_code_id?: InputMaybe<Order_By>;
  vehicle_code?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type State_Min_Fields = {
  __typename?: 'state_min_fields';
  code?: Maybe<Scalars['String']['output']>;
  country_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numeric_code_id?: Maybe<Scalars['String']['output']>;
  vehicle_code?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "state" */
export type State_Min_Order_By = {
  code?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  numeric_code_id?: InputMaybe<Order_By>;
  vehicle_code?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "state" */
export type State_Mutation_Response = {
  __typename?: 'state_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<State>;
};

/** input type for inserting object relation for remote table "state" */
export type State_Obj_Rel_Insert_Input = {
  data: State_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<State_On_Conflict>;
};

/** on_conflict condition type for table "state" */
export type State_On_Conflict = {
  constraint: State_Constraint;
  update_columns?: Array<State_Update_Column>;
  where?: InputMaybe<State_Bool_Exp>;
};

/** Ordering options when selecting data from "state". */
export type State_Order_By = {
  cities_aggregate?: InputMaybe<City_Aggregate_Order_By>;
  code?: InputMaybe<Order_By>;
  country?: InputMaybe<Country_Order_By>;
  country_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_assets_aggregate?: InputMaybe<Customer_Asset_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  numeric_code_id?: InputMaybe<Order_By>;
  organization_addresses_aggregate?: InputMaybe<Organization_Address_Aggregate_Order_By>;
  vehicle_code?: InputMaybe<Order_By>;
  vehicles_aggregate?: InputMaybe<Vehicle_Aggregate_Order_By>;
};

/** primary key columns input for table: state */
export type State_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "state" */
export enum State_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CountryId = 'country_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  NumericCodeId = 'numeric_code_id',
  /** column name */
  VehicleCode = 'vehicle_code'
}

/** select "state_aggregate_bool_exp_bool_and_arguments_columns" columns of table "state" */
export enum State_Select_Column_State_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "state_aggregate_bool_exp_bool_or_arguments_columns" columns of table "state" */
export enum State_Select_Column_State_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "state" */
export type State_Set_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  country_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  numeric_code_id?: InputMaybe<Scalars['String']['input']>;
  vehicle_code?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "state" */
export type State_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: State_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type State_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  country_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  numeric_code_id?: InputMaybe<Scalars['String']['input']>;
  vehicle_code?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "state" */
export enum State_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CountryId = 'country_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  NumericCodeId = 'numeric_code_id',
  /** column name */
  VehicleCode = 'vehicle_code'
}

export type State_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<State_Set_Input>;
  /** filter the rows which have to be updated */
  where: State_Bool_Exp;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "SmartRefueler.dispencerLocation" */
  SmartRefueler_dispencerLocation: Array<SmartRefueler_DispencerLocation>;
  /** fetch aggregated fields from the table: "SmartRefueler.dispencerLocation" */
  SmartRefueler_dispencerLocation_aggregate: SmartRefueler_DispencerLocation_Aggregate;
  /** fetch data from the table: "address_subsidiary" */
  address_subsidiary: Array<Address_Subsidiary>;
  /** fetch aggregated fields from the table: "address_subsidiary" */
  address_subsidiary_aggregate: Address_Subsidiary_Aggregate;
  /** An array relationship */
  address_subsidiary_audit_logs: Array<Address_Subsidiary_Audit_Logs>;
  /** An aggregate relationship */
  address_subsidiary_audit_logs_aggregate: Address_Subsidiary_Audit_Logs_Aggregate;
  /** fetch data from the table: "address_subsidiary_audit_logs" using primary key columns */
  address_subsidiary_audit_logs_by_pk?: Maybe<Address_Subsidiary_Audit_Logs>;
  /** fetch data from the table in a streaming manner: "address_subsidiary_audit_logs" */
  address_subsidiary_audit_logs_stream: Array<Address_Subsidiary_Audit_Logs>;
  /** fetch data from the table: "address_subsidiary" using primary key columns */
  address_subsidiary_by_pk?: Maybe<Address_Subsidiary>;
  /** fetch data from the table in a streaming manner: "address_subsidiary" */
  address_subsidiary_stream: Array<Address_Subsidiary>;
  /** fetch data from the table: "address_type" */
  address_type: Array<Address_Type>;
  /** fetch aggregated fields from the table: "address_type" */
  address_type_aggregate: Address_Type_Aggregate;
  /** fetch data from the table: "address_type" using primary key columns */
  address_type_by_pk?: Maybe<Address_Type>;
  /** fetch data from the table in a streaming manner: "address_type" */
  address_type_stream: Array<Address_Type>;
  /** fetch data from the table: "asset_grouping" */
  asset_grouping: Array<Asset_Grouping>;
  /** fetch aggregated fields from the table: "asset_grouping" */
  asset_grouping_aggregate: Asset_Grouping_Aggregate;
  /** fetch data from the table: "asset_grouping" using primary key columns */
  asset_grouping_by_pk?: Maybe<Asset_Grouping>;
  /** fetch data from the table: "asset_grouping_customer_asset" */
  asset_grouping_customer_asset: Array<Asset_Grouping_Customer_Asset>;
  /** fetch aggregated fields from the table: "asset_grouping_customer_asset" */
  asset_grouping_customer_asset_aggregate: Asset_Grouping_Customer_Asset_Aggregate;
  /** fetch data from the table: "asset_grouping_customer_asset" using primary key columns */
  asset_grouping_customer_asset_by_pk?: Maybe<Asset_Grouping_Customer_Asset>;
  /** fetch data from the table in a streaming manner: "asset_grouping_customer_asset" */
  asset_grouping_customer_asset_stream: Array<Asset_Grouping_Customer_Asset>;
  /** fetch data from the table in a streaming manner: "asset_grouping" */
  asset_grouping_stream: Array<Asset_Grouping>;
  /** fetch data from the table: "asset_subsidiary" */
  asset_subsidiary: Array<Asset_Subsidiary>;
  /** fetch aggregated fields from the table: "asset_subsidiary" */
  asset_subsidiary_aggregate: Asset_Subsidiary_Aggregate;
  /** An array relationship */
  asset_subsidiary_audit_logs: Array<Asset_Subsidiary_Audit_Logs>;
  /** An aggregate relationship */
  asset_subsidiary_audit_logs_aggregate: Asset_Subsidiary_Audit_Logs_Aggregate;
  /** fetch data from the table: "asset_subsidiary_audit_logs" using primary key columns */
  asset_subsidiary_audit_logs_by_pk?: Maybe<Asset_Subsidiary_Audit_Logs>;
  /** fetch data from the table in a streaming manner: "asset_subsidiary_audit_logs" */
  asset_subsidiary_audit_logs_stream: Array<Asset_Subsidiary_Audit_Logs>;
  /** fetch data from the table: "asset_subsidiary" using primary key columns */
  asset_subsidiary_by_pk?: Maybe<Asset_Subsidiary>;
  /** fetch data from the table in a streaming manner: "asset_subsidiary" */
  asset_subsidiary_stream: Array<Asset_Subsidiary>;
  /** fetch data from the table: "asset_type" */
  asset_type: Array<Asset_Type>;
  /** fetch aggregated fields from the table: "asset_type" */
  asset_type_aggregate: Asset_Type_Aggregate;
  /** fetch data from the table: "asset_type" using primary key columns */
  asset_type_by_pk?: Maybe<Asset_Type>;
  /** fetch data from the table: "asset_type_category" */
  asset_type_category: Array<Asset_Type_Category>;
  /** fetch aggregated fields from the table: "asset_type_category" */
  asset_type_category_aggregate: Asset_Type_Category_Aggregate;
  /** fetch data from the table: "asset_type_category" using primary key columns */
  asset_type_category_by_pk?: Maybe<Asset_Type_Category>;
  /** fetch data from the table in a streaming manner: "asset_type_category" */
  asset_type_category_stream: Array<Asset_Type_Category>;
  /** fetch data from the table in a streaming manner: "asset_type" */
  asset_type_stream: Array<Asset_Type>;
  /** fetch data from the table: "associated_type" */
  associated_type: Array<Associated_Type>;
  /** fetch aggregated fields from the table: "associated_type" */
  associated_type_aggregate: Associated_Type_Aggregate;
  /** fetch data from the table: "associated_type" using primary key columns */
  associated_type_by_pk?: Maybe<Associated_Type>;
  /** fetch data from the table in a streaming manner: "associated_type" */
  associated_type_stream: Array<Associated_Type>;
  /** fetch data from the table: "audit_log_action" */
  audit_log_action: Array<Audit_Log_Action>;
  /** fetch aggregated fields from the table: "audit_log_action" */
  audit_log_action_aggregate: Audit_Log_Action_Aggregate;
  /** fetch data from the table: "audit_log_action" using primary key columns */
  audit_log_action_by_pk?: Maybe<Audit_Log_Action>;
  /** fetch data from the table in a streaming manner: "audit_log_action" */
  audit_log_action_stream: Array<Audit_Log_Action>;
  /** An array relationship */
  cancellation_reasons: Array<Cancellation_Reasons>;
  /** An aggregate relationship */
  cancellation_reasons_aggregate: Cancellation_Reasons_Aggregate;
  /** fetch data from the table: "cancellation_reasons" using primary key columns */
  cancellation_reasons_by_pk?: Maybe<Cancellation_Reasons>;
  /** fetch data from the table in a streaming manner: "cancellation_reasons" */
  cancellation_reasons_stream: Array<Cancellation_Reasons>;
  /** fetch data from the table: "category" */
  category: Array<Category>;
  /** fetch aggregated fields from the table: "category" */
  category_aggregate: Category_Aggregate;
  /** fetch data from the table: "category" using primary key columns */
  category_by_pk?: Maybe<Category>;
  /** fetch data from the table in a streaming manner: "category" */
  category_stream: Array<Category>;
  /** fetch data from the table: "city" */
  city: Array<City>;
  /** fetch aggregated fields from the table: "city" */
  city_aggregate: City_Aggregate;
  /** fetch data from the table: "city" using primary key columns */
  city_by_pk?: Maybe<City>;
  /** fetch data from the table in a streaming manner: "city" */
  city_stream: Array<City>;
  /** fetch data from the table: "country" */
  country: Array<Country>;
  /** fetch aggregated fields from the table: "country" */
  country_aggregate: Country_Aggregate;
  /** fetch data from the table: "country" using primary key columns */
  country_by_pk?: Maybe<Country>;
  /** fetch data from the table in a streaming manner: "country" */
  country_stream: Array<Country>;
  /** fetch data from the table: "credit_breach" */
  credit_breach: Array<Credit_Breach>;
  /** fetch aggregated fields from the table: "credit_breach" */
  credit_breach_aggregate: Credit_Breach_Aggregate;
  /** fetch data from the table: "credit_breach" using primary key columns */
  credit_breach_by_pk?: Maybe<Credit_Breach>;
  /** fetch data from the table in a streaming manner: "credit_breach" */
  credit_breach_stream: Array<Credit_Breach>;
  /** fetch data from the table: "currency" */
  currency: Array<Currency>;
  /** fetch aggregated fields from the table: "currency" */
  currency_aggregate: Currency_Aggregate;
  /** fetch data from the table: "currency" using primary key columns */
  currency_by_pk?: Maybe<Currency>;
  /** fetch data from the table: "currency_conversion" */
  currency_conversion: Array<Currency_Conversion>;
  /** fetch aggregated fields from the table: "currency_conversion" */
  currency_conversion_aggregate: Currency_Conversion_Aggregate;
  /** fetch data from the table: "currency_conversion" using primary key columns */
  currency_conversion_by_pk?: Maybe<Currency_Conversion>;
  /** fetch data from the table in a streaming manner: "currency_conversion" */
  currency_conversion_stream: Array<Currency_Conversion>;
  /** fetch data from the table in a streaming manner: "currency" */
  currency_stream: Array<Currency>;
  /** fetch data from the table: "customer_asset" */
  customer_asset: Array<Customer_Asset>;
  /** fetch aggregated fields from the table: "customer_asset" */
  customer_asset_aggregate: Customer_Asset_Aggregate;
  /** fetch data from the table: "customer_asset_audit_log" */
  customer_asset_audit_log: Array<Customer_Asset_Audit_Log>;
  /** fetch aggregated fields from the table: "customer_asset_audit_log" */
  customer_asset_audit_log_aggregate: Customer_Asset_Audit_Log_Aggregate;
  /** fetch data from the table: "customer_asset_audit_log" using primary key columns */
  customer_asset_audit_log_by_pk?: Maybe<Customer_Asset_Audit_Log>;
  /** fetch data from the table in a streaming manner: "customer_asset_audit_log" */
  customer_asset_audit_log_stream: Array<Customer_Asset_Audit_Log>;
  /** fetch data from the table: "customer_asset" using primary key columns */
  customer_asset_by_pk?: Maybe<Customer_Asset>;
  /** fetch data from the table: "customer_asset_device" */
  customer_asset_device: Array<Customer_Asset_Device>;
  /** fetch aggregated fields from the table: "customer_asset_device" */
  customer_asset_device_aggregate: Customer_Asset_Device_Aggregate;
  /** fetch data from the table: "customer_asset_device" using primary key columns */
  customer_asset_device_by_pk?: Maybe<Customer_Asset_Device>;
  /** fetch data from the table: "customer_asset_device_calibration" */
  customer_asset_device_calibration: Array<Customer_Asset_Device_Calibration>;
  /** fetch aggregated fields from the table: "customer_asset_device_calibration" */
  customer_asset_device_calibration_aggregate: Customer_Asset_Device_Calibration_Aggregate;
  /** fetch data from the table: "customer_asset_device_calibration" using primary key columns */
  customer_asset_device_calibration_by_pk?: Maybe<Customer_Asset_Device_Calibration>;
  /** fetch data from the table in a streaming manner: "customer_asset_device_calibration" */
  customer_asset_device_calibration_stream: Array<Customer_Asset_Device_Calibration>;
  /** fetch data from the table in a streaming manner: "customer_asset_device" */
  customer_asset_device_stream: Array<Customer_Asset_Device>;
  /** An array relationship */
  customer_asset_dispensing_rules: Array<Customer_Asset_Dispensing_Rules>;
  /** An aggregate relationship */
  customer_asset_dispensing_rules_aggregate: Customer_Asset_Dispensing_Rules_Aggregate;
  /** fetch data from the table: "customer_asset_dispensing_rules" using primary key columns */
  customer_asset_dispensing_rules_by_pk?: Maybe<Customer_Asset_Dispensing_Rules>;
  /** fetch data from the table in a streaming manner: "customer_asset_dispensing_rules" */
  customer_asset_dispensing_rules_stream: Array<Customer_Asset_Dispensing_Rules>;
  /** fetch data from the table: "customer_asset_limit" */
  customer_asset_limit: Array<Customer_Asset_Limit>;
  /** fetch aggregated fields from the table: "customer_asset_limit" */
  customer_asset_limit_aggregate: Customer_Asset_Limit_Aggregate;
  /** fetch data from the table: "customer_asset_limit" using primary key columns */
  customer_asset_limit_by_pk?: Maybe<Customer_Asset_Limit>;
  /** fetch data from the table in a streaming manner: "customer_asset_limit" */
  customer_asset_limit_stream: Array<Customer_Asset_Limit>;
  /** fetch data from the table in a streaming manner: "customer_asset" */
  customer_asset_stream: Array<Customer_Asset>;
  /** fetch data from the table: "customer_asset_tag" */
  customer_asset_tag: Array<Customer_Asset_Tag>;
  /** fetch aggregated fields from the table: "customer_asset_tag" */
  customer_asset_tag_aggregate: Customer_Asset_Tag_Aggregate;
  /** fetch data from the table: "customer_asset_tag" using primary key columns */
  customer_asset_tag_by_pk?: Maybe<Customer_Asset_Tag>;
  /** fetch data from the table in a streaming manner: "customer_asset_tag" */
  customer_asset_tag_stream: Array<Customer_Asset_Tag>;
  /** fetch data from the table: "customer_order" */
  customer_order: Array<Customer_Order>;
  /** fetch aggregated fields from the table: "customer_order" */
  customer_order_aggregate: Customer_Order_Aggregate;
  /** fetch data from the table: "customer_order" using primary key columns */
  customer_order_by_pk?: Maybe<Customer_Order>;
  /** An array relationship */
  customer_order_cancellation_reasons: Array<Customer_Order_Cancellation_Reasons>;
  /** An aggregate relationship */
  customer_order_cancellation_reasons_aggregate: Customer_Order_Cancellation_Reasons_Aggregate;
  /** fetch data from the table: "customer_order_cancellation_reasons" using primary key columns */
  customer_order_cancellation_reasons_by_pk?: Maybe<Customer_Order_Cancellation_Reasons>;
  /** fetch data from the table in a streaming manner: "customer_order_cancellation_reasons" */
  customer_order_cancellation_reasons_stream: Array<Customer_Order_Cancellation_Reasons>;
  /** fetch data from the table: "customer_order_customer_asset" */
  customer_order_customer_asset: Array<Customer_Order_Customer_Asset>;
  /** fetch aggregated fields from the table: "customer_order_customer_asset" */
  customer_order_customer_asset_aggregate: Customer_Order_Customer_Asset_Aggregate;
  /** fetch data from the table: "customer_order_customer_asset" using primary key columns */
  customer_order_customer_asset_by_pk?: Maybe<Customer_Order_Customer_Asset>;
  /** fetch data from the table in a streaming manner: "customer_order_customer_asset" */
  customer_order_customer_asset_stream: Array<Customer_Order_Customer_Asset>;
  /** fetch data from the table: "customer_order_detail_view" */
  customer_order_detail_view: Array<Customer_Order_Detail_View>;
  /** fetch aggregated fields from the table: "customer_order_detail_view" */
  customer_order_detail_view_aggregate: Customer_Order_Detail_View_Aggregate;
  /** fetch data from the table in a streaming manner: "customer_order_detail_view" */
  customer_order_detail_view_stream: Array<Customer_Order_Detail_View>;
  /** fetch data from the table: "customer_order_item" */
  customer_order_item: Array<Customer_Order_Item>;
  /** fetch aggregated fields from the table: "customer_order_item" */
  customer_order_item_aggregate: Customer_Order_Item_Aggregate;
  /** fetch data from the table: "customer_order_item" using primary key columns */
  customer_order_item_by_pk?: Maybe<Customer_Order_Item>;
  /** An array relationship */
  customer_order_item_cancellation_reasons: Array<Customer_Order_Item_Cancellation_Reasons>;
  /** An aggregate relationship */
  customer_order_item_cancellation_reasons_aggregate: Customer_Order_Item_Cancellation_Reasons_Aggregate;
  /** fetch data from the table: "customer_order_item_cancellation_reasons" using primary key columns */
  customer_order_item_cancellation_reasons_by_pk?: Maybe<Customer_Order_Item_Cancellation_Reasons>;
  /** fetch data from the table in a streaming manner: "customer_order_item_cancellation_reasons" */
  customer_order_item_cancellation_reasons_stream: Array<Customer_Order_Item_Cancellation_Reasons>;
  /** An array relationship */
  customer_order_item_comments: Array<Customer_Order_Item_Comments>;
  /** An aggregate relationship */
  customer_order_item_comments_aggregate: Customer_Order_Item_Comments_Aggregate;
  /** fetch data from the table: "customer_order_item_comments" using primary key columns */
  customer_order_item_comments_by_pk?: Maybe<Customer_Order_Item_Comments>;
  /** fetch data from the table in a streaming manner: "customer_order_item_comments" */
  customer_order_item_comments_stream: Array<Customer_Order_Item_Comments>;
  /** fetch data from the table: "customer_order_item_commission" */
  customer_order_item_commission: Array<Customer_Order_Item_Commission>;
  /** fetch aggregated fields from the table: "customer_order_item_commission" */
  customer_order_item_commission_aggregate: Customer_Order_Item_Commission_Aggregate;
  /** fetch data from the table: "customer_order_item_commission" using primary key columns */
  customer_order_item_commission_by_pk?: Maybe<Customer_Order_Item_Commission>;
  /** fetch data from the table in a streaming manner: "customer_order_item_commission" */
  customer_order_item_commission_stream: Array<Customer_Order_Item_Commission>;
  /** An array relationship */
  customer_order_item_etd_transactional_logs: Array<Customer_Order_Item_Etd_Transactional_Logs>;
  /** An aggregate relationship */
  customer_order_item_etd_transactional_logs_aggregate: Customer_Order_Item_Etd_Transactional_Logs_Aggregate;
  /** fetch data from the table: "customer_order_item_etd_transactional_logs" using primary key columns */
  customer_order_item_etd_transactional_logs_by_pk?: Maybe<Customer_Order_Item_Etd_Transactional_Logs>;
  /** fetch data from the table in a streaming manner: "customer_order_item_etd_transactional_logs" */
  customer_order_item_etd_transactional_logs_stream: Array<Customer_Order_Item_Etd_Transactional_Logs>;
  /** fetch data from the table: "customer_order_item_partner" */
  customer_order_item_partner: Array<Customer_Order_Item_Partner>;
  /** fetch aggregated fields from the table: "customer_order_item_partner" */
  customer_order_item_partner_aggregate: Customer_Order_Item_Partner_Aggregate;
  /** fetch data from the table: "customer_order_item_partner" using primary key columns */
  customer_order_item_partner_by_pk?: Maybe<Customer_Order_Item_Partner>;
  /** fetch data from the table in a streaming manner: "customer_order_item_partner" */
  customer_order_item_partner_stream: Array<Customer_Order_Item_Partner>;
  /** An array relationship */
  customer_order_item_safety_checklist_results: Array<Customer_Order_Item_Safety_Checklist_Results>;
  /** An aggregate relationship */
  customer_order_item_safety_checklist_results_aggregate: Customer_Order_Item_Safety_Checklist_Results_Aggregate;
  /** fetch data from the table: "customer_order_item_safety_checklist_results" using primary key columns */
  customer_order_item_safety_checklist_results_by_pk?: Maybe<Customer_Order_Item_Safety_Checklist_Results>;
  /** fetch data from the table in a streaming manner: "customer_order_item_safety_checklist_results" */
  customer_order_item_safety_checklist_results_stream: Array<Customer_Order_Item_Safety_Checklist_Results>;
  /** fetch data from the table: "customer_order_item_state" */
  customer_order_item_state: Array<Customer_Order_Item_State>;
  /** fetch aggregated fields from the table: "customer_order_item_state" */
  customer_order_item_state_aggregate: Customer_Order_Item_State_Aggregate;
  /** fetch data from the table: "customer_order_item_state" using primary key columns */
  customer_order_item_state_by_pk?: Maybe<Customer_Order_Item_State>;
  /** fetch data from the table in a streaming manner: "customer_order_item_state" */
  customer_order_item_state_stream: Array<Customer_Order_Item_State>;
  /** fetch data from the table: "customer_order_item_stateflow" */
  customer_order_item_stateflow: Array<Customer_Order_Item_Stateflow>;
  /** fetch aggregated fields from the table: "customer_order_item_stateflow" */
  customer_order_item_stateflow_aggregate: Customer_Order_Item_Stateflow_Aggregate;
  /** fetch data from the table: "customer_order_item_stateflow" using primary key columns */
  customer_order_item_stateflow_by_pk?: Maybe<Customer_Order_Item_Stateflow>;
  /** fetch data from the table in a streaming manner: "customer_order_item_stateflow" */
  customer_order_item_stateflow_stream: Array<Customer_Order_Item_Stateflow>;
  /** fetch data from the table in a streaming manner: "customer_order_item" */
  customer_order_item_stream: Array<Customer_Order_Item>;
  /** fetch data from the table: "customer_order_item_test_category" */
  customer_order_item_test_category: Array<Customer_Order_Item_Test_Category>;
  /** fetch aggregated fields from the table: "customer_order_item_test_category" */
  customer_order_item_test_category_aggregate: Customer_Order_Item_Test_Category_Aggregate;
  /** fetch data from the table: "customer_order_item_test_category" using primary key columns */
  customer_order_item_test_category_by_pk?: Maybe<Customer_Order_Item_Test_Category>;
  /** fetch data from the table in a streaming manner: "customer_order_item_test_category" */
  customer_order_item_test_category_stream: Array<Customer_Order_Item_Test_Category>;
  /** An array relationship */
  customer_order_item_test_results: Array<Customer_Order_Item_Test_Results>;
  /** An aggregate relationship */
  customer_order_item_test_results_aggregate: Customer_Order_Item_Test_Results_Aggregate;
  /** fetch data from the table: "customer_order_item_test_results" using primary key columns */
  customer_order_item_test_results_by_pk?: Maybe<Customer_Order_Item_Test_Results>;
  /** An array relationship */
  customer_order_item_test_results_photos: Array<Customer_Order_Item_Test_Results_Photos>;
  /** An aggregate relationship */
  customer_order_item_test_results_photos_aggregate: Customer_Order_Item_Test_Results_Photos_Aggregate;
  /** fetch data from the table: "customer_order_item_test_results_photos" using primary key columns */
  customer_order_item_test_results_photos_by_pk?: Maybe<Customer_Order_Item_Test_Results_Photos>;
  /** fetch data from the table in a streaming manner: "customer_order_item_test_results_photos" */
  customer_order_item_test_results_photos_stream: Array<Customer_Order_Item_Test_Results_Photos>;
  /** fetch data from the table in a streaming manner: "customer_order_item_test_results" */
  customer_order_item_test_results_stream: Array<Customer_Order_Item_Test_Results>;
  /** fetch data from the table: "customer_order_organization_user_document" */
  customer_order_organization_user_document: Array<Customer_Order_Organization_User_Document>;
  /** fetch aggregated fields from the table: "customer_order_organization_user_document" */
  customer_order_organization_user_document_aggregate: Customer_Order_Organization_User_Document_Aggregate;
  /** fetch data from the table: "customer_order_organization_user_document" using primary key columns */
  customer_order_organization_user_document_by_pk?: Maybe<Customer_Order_Organization_User_Document>;
  /** fetch data from the table in a streaming manner: "customer_order_organization_user_document" */
  customer_order_organization_user_document_stream: Array<Customer_Order_Organization_User_Document>;
  /** fetch data from the table: "customer_order_partner_order" */
  customer_order_partner_order: Array<Customer_Order_Partner_Order>;
  /** fetch aggregated fields from the table: "customer_order_partner_order" */
  customer_order_partner_order_aggregate: Customer_Order_Partner_Order_Aggregate;
  /** fetch data from the table: "customer_order_partner_order" using primary key columns */
  customer_order_partner_order_by_pk?: Maybe<Customer_Order_Partner_Order>;
  /** fetch data from the table in a streaming manner: "customer_order_partner_order" */
  customer_order_partner_order_stream: Array<Customer_Order_Partner_Order>;
  /** An array relationship */
  customer_order_slots: Array<Customer_Order_Slots>;
  /** An aggregate relationship */
  customer_order_slots_aggregate: Customer_Order_Slots_Aggregate;
  /** fetch data from the table: "customer_order_slots" using primary key columns */
  customer_order_slots_by_pk?: Maybe<Customer_Order_Slots>;
  /** fetch data from the table in a streaming manner: "customer_order_slots" */
  customer_order_slots_stream: Array<Customer_Order_Slots>;
  /** fetch data from the table: "customer_order_state" */
  customer_order_state: Array<Customer_Order_State>;
  /** fetch aggregated fields from the table: "customer_order_state" */
  customer_order_state_aggregate: Customer_Order_State_Aggregate;
  /** fetch data from the table: "customer_order_state" using primary key columns */
  customer_order_state_by_pk?: Maybe<Customer_Order_State>;
  /** fetch data from the table in a streaming manner: "customer_order_state" */
  customer_order_state_stream: Array<Customer_Order_State>;
  /** fetch data from the table: "customer_order_stateflow" */
  customer_order_stateflow: Array<Customer_Order_Stateflow>;
  /** fetch aggregated fields from the table: "customer_order_stateflow" */
  customer_order_stateflow_aggregate: Customer_Order_Stateflow_Aggregate;
  /** fetch data from the table: "customer_order_stateflow" using primary key columns */
  customer_order_stateflow_by_pk?: Maybe<Customer_Order_Stateflow>;
  /** fetch data from the table in a streaming manner: "customer_order_stateflow" */
  customer_order_stateflow_stream: Array<Customer_Order_Stateflow>;
  /** fetch data from the table in a streaming manner: "customer_order" */
  customer_order_stream: Array<Customer_Order>;
  /** fetch data from the table: "customer_payment" */
  customer_payment: Array<Customer_Payment>;
  /** fetch aggregated fields from the table: "customer_payment" */
  customer_payment_aggregate: Customer_Payment_Aggregate;
  /** fetch data from the table: "customer_payment" using primary key columns */
  customer_payment_by_pk?: Maybe<Customer_Payment>;
  /** fetch data from the table: "customer_payment_status" */
  customer_payment_status: Array<Customer_Payment_Status>;
  /** fetch aggregated fields from the table: "customer_payment_status" */
  customer_payment_status_aggregate: Customer_Payment_Status_Aggregate;
  /** fetch data from the table: "customer_payment_status" using primary key columns */
  customer_payment_status_by_pk?: Maybe<Customer_Payment_Status>;
  /** fetch data from the table in a streaming manner: "customer_payment_status" */
  customer_payment_status_stream: Array<Customer_Payment_Status>;
  /** fetch data from the table in a streaming manner: "customer_payment" */
  customer_payment_stream: Array<Customer_Payment>;
  /** fetch data from the table: "customer_segmentation" */
  customer_segmentation: Array<Customer_Segmentation>;
  /** fetch aggregated fields from the table: "customer_segmentation" */
  customer_segmentation_aggregate: Customer_Segmentation_Aggregate;
  /** fetch data from the table: "customer_segmentation" using primary key columns */
  customer_segmentation_by_pk?: Maybe<Customer_Segmentation>;
  /** fetch data from the table in a streaming manner: "customer_segmentation" */
  customer_segmentation_stream: Array<Customer_Segmentation>;
  /** fetch data from the table: "day_type" */
  day_type: Array<Day_Type>;
  /** fetch aggregated fields from the table: "day_type" */
  day_type_aggregate: Day_Type_Aggregate;
  /** fetch data from the table: "day_type" using primary key columns */
  day_type_by_pk?: Maybe<Day_Type>;
  /** fetch data from the table in a streaming manner: "day_type" */
  day_type_stream: Array<Day_Type>;
  /** fetch data from the table: "delayed_orders" */
  delayed_orders: Array<Delayed_Orders>;
  /** fetch aggregated fields from the table: "delayed_orders" */
  delayed_orders_aggregate: Delayed_Orders_Aggregate;
  /** fetch data from the table in a streaming manner: "delayed_orders" */
  delayed_orders_stream: Array<Delayed_Orders>;
  /** fetch data from the table: "delivery_preferences" */
  delivery_preferences: Array<Delivery_Preferences>;
  /** fetch aggregated fields from the table: "delivery_preferences" */
  delivery_preferences_aggregate: Delivery_Preferences_Aggregate;
  /** fetch data from the table: "delivery_preferences" using primary key columns */
  delivery_preferences_by_pk?: Maybe<Delivery_Preferences>;
  /** fetch data from the table in a streaming manner: "delivery_preferences" */
  delivery_preferences_stream: Array<Delivery_Preferences>;
  /** fetch data from the table: "delivery_scheduler" */
  delivery_scheduler: Array<Delivery_Scheduler>;
  /** fetch aggregated fields from the table: "delivery_scheduler" */
  delivery_scheduler_aggregate: Delivery_Scheduler_Aggregate;
  /** fetch data from the table: "delivery_scheduler" using primary key columns */
  delivery_scheduler_by_pk?: Maybe<Delivery_Scheduler>;
  /** fetch data from the table: "delivery_scheduler_product_item" */
  delivery_scheduler_product_item: Array<Delivery_Scheduler_Product_Item>;
  /** fetch aggregated fields from the table: "delivery_scheduler_product_item" */
  delivery_scheduler_product_item_aggregate: Delivery_Scheduler_Product_Item_Aggregate;
  /** fetch data from the table: "delivery_scheduler_product_item" using primary key columns */
  delivery_scheduler_product_item_by_pk?: Maybe<Delivery_Scheduler_Product_Item>;
  /** fetch data from the table in a streaming manner: "delivery_scheduler_product_item" */
  delivery_scheduler_product_item_stream: Array<Delivery_Scheduler_Product_Item>;
  /** fetch data from the table in a streaming manner: "delivery_scheduler" */
  delivery_scheduler_stream: Array<Delivery_Scheduler>;
  /** fetch data from the table: "department_retag_request" */
  department_retag_request: Array<Department_Retag_Request>;
  /** fetch aggregated fields from the table: "department_retag_request" */
  department_retag_request_aggregate: Department_Retag_Request_Aggregate;
  /** fetch data from the table: "department_retag_request" using primary key columns */
  department_retag_request_by_pk?: Maybe<Department_Retag_Request>;
  /** fetch data from the table in a streaming manner: "department_retag_request" */
  department_retag_request_stream: Array<Department_Retag_Request>;
  /** fetch data from the table: "device_devicetype_paramerter_definition" */
  device_devicetype_paramerter_definition: Array<Device_Devicetype_Paramerter_Definition>;
  /** fetch aggregated fields from the table: "device_devicetype_paramerter_definition" */
  device_devicetype_paramerter_definition_aggregate: Device_Devicetype_Paramerter_Definition_Aggregate;
  /** fetch data from the table: "device_devicetype_paramerter_definition" using primary key columns */
  device_devicetype_paramerter_definition_by_pk?: Maybe<Device_Devicetype_Paramerter_Definition>;
  /** fetch data from the table in a streaming manner: "device_devicetype_paramerter_definition" */
  device_devicetype_paramerter_definition_stream: Array<Device_Devicetype_Paramerter_Definition>;
  /** fetch data from the table: "devicetype" */
  devicetype: Array<Devicetype>;
  /** fetch aggregated fields from the table: "devicetype" */
  devicetype_aggregate: Devicetype_Aggregate;
  /** fetch data from the table: "devicetype" using primary key columns */
  devicetype_by_pk?: Maybe<Devicetype>;
  /** fetch data from the table: "devicetype_paramerter_definition" */
  devicetype_paramerter_definition: Array<Devicetype_Paramerter_Definition>;
  /** fetch aggregated fields from the table: "devicetype_paramerter_definition" */
  devicetype_paramerter_definition_aggregate: Devicetype_Paramerter_Definition_Aggregate;
  /** fetch data from the table: "devicetype_paramerter_definition" using primary key columns */
  devicetype_paramerter_definition_by_pk?: Maybe<Devicetype_Paramerter_Definition>;
  /** fetch data from the table in a streaming manner: "devicetype_paramerter_definition" */
  devicetype_paramerter_definition_stream: Array<Devicetype_Paramerter_Definition>;
  /** fetch data from the table: "devicetype_parameter_group" */
  devicetype_parameter_group: Array<Devicetype_Parameter_Group>;
  /** fetch aggregated fields from the table: "devicetype_parameter_group" */
  devicetype_parameter_group_aggregate: Devicetype_Parameter_Group_Aggregate;
  /** fetch data from the table: "devicetype_parameter_group" using primary key columns */
  devicetype_parameter_group_by_pk?: Maybe<Devicetype_Parameter_Group>;
  /** fetch data from the table in a streaming manner: "devicetype_parameter_group" */
  devicetype_parameter_group_stream: Array<Devicetype_Parameter_Group>;
  /** fetch data from the table in a streaming manner: "devicetype" */
  devicetype_stream: Array<Devicetype>;
  /** fetch data from the table: "discount_type" */
  discount_type: Array<Discount_Type>;
  /** fetch aggregated fields from the table: "discount_type" */
  discount_type_aggregate: Discount_Type_Aggregate;
  /** fetch data from the table: "discount_type" using primary key columns */
  discount_type_by_pk?: Maybe<Discount_Type>;
  /** fetch data from the table in a streaming manner: "discount_type" */
  discount_type_stream: Array<Discount_Type>;
  /** fetch data from the table: "dispenser" */
  dispenser: Array<Dispenser>;
  /** fetch aggregated fields from the table: "dispenser" */
  dispenser_aggregate: Dispenser_Aggregate;
  /** fetch data from the table: "dispenser" using primary key columns */
  dispenser_by_pk?: Maybe<Dispenser>;
  /** fetch data from the table: "dispenser_configuration" */
  dispenser_configuration: Array<Dispenser_Configuration>;
  /** fetch aggregated fields from the table: "dispenser_configuration" */
  dispenser_configuration_aggregate: Dispenser_Configuration_Aggregate;
  /** fetch data from the table: "dispenser_configuration" using primary key columns */
  dispenser_configuration_by_pk?: Maybe<Dispenser_Configuration>;
  /** fetch data from the table in a streaming manner: "dispenser_configuration" */
  dispenser_configuration_stream: Array<Dispenser_Configuration>;
  /** fetch data from the table in a streaming manner: "dispenser" */
  dispenser_stream: Array<Dispenser>;
  /** fetch data from the table: "dispenser_type" */
  dispenser_type: Array<Dispenser_Type>;
  /** fetch aggregated fields from the table: "dispenser_type" */
  dispenser_type_aggregate: Dispenser_Type_Aggregate;
  /** fetch data from the table: "dispenser_type" using primary key columns */
  dispenser_type_by_pk?: Maybe<Dispenser_Type>;
  /** fetch data from the table in a streaming manner: "dispenser_type" */
  dispenser_type_stream: Array<Dispenser_Type>;
  /** An array relationship */
  dispensing_rules: Array<Dispensing_Rules>;
  /** An aggregate relationship */
  dispensing_rules_aggregate: Dispensing_Rules_Aggregate;
  /** fetch data from the table: "dispensing_rules" using primary key columns */
  dispensing_rules_by_pk?: Maybe<Dispensing_Rules>;
  /** fetch data from the table in a streaming manner: "dispensing_rules" */
  dispensing_rules_stream: Array<Dispensing_Rules>;
  /** fetch data from the table: "document_type" */
  document_type: Array<Document_Type>;
  /** fetch aggregated fields from the table: "document_type" */
  document_type_aggregate: Document_Type_Aggregate;
  /** fetch data from the table: "document_type" using primary key columns */
  document_type_by_pk?: Maybe<Document_Type>;
  /** fetch data from the table: "document_type_category" */
  document_type_category: Array<Document_Type_Category>;
  /** fetch aggregated fields from the table: "document_type_category" */
  document_type_category_aggregate: Document_Type_Category_Aggregate;
  /** fetch data from the table: "document_type_category" using primary key columns */
  document_type_category_by_pk?: Maybe<Document_Type_Category>;
  /** fetch data from the table in a streaming manner: "document_type_category" */
  document_type_category_stream: Array<Document_Type_Category>;
  /** fetch data from the table in a streaming manner: "document_type" */
  document_type_stream: Array<Document_Type>;
  /** fetch data from the table: "documents" */
  documents: Array<Documents>;
  /** fetch aggregated fields from the table: "documents" */
  documents_aggregate: Documents_Aggregate;
  /** fetch data from the table: "documents" using primary key columns */
  documents_by_pk?: Maybe<Documents>;
  /** fetch data from the table in a streaming manner: "documents" */
  documents_stream: Array<Documents>;
  /** fetch data from the table: "driver_duty_log" */
  driver_duty_log: Array<Driver_Duty_Log>;
  /** fetch aggregated fields from the table: "driver_duty_log" */
  driver_duty_log_aggregate: Driver_Duty_Log_Aggregate;
  /** fetch data from the table: "driver_duty_log" using primary key columns */
  driver_duty_log_by_pk?: Maybe<Driver_Duty_Log>;
  /** fetch data from the table in a streaming manner: "driver_duty_log" */
  driver_duty_log_stream: Array<Driver_Duty_Log>;
  /** An array relationship */
  driver_duty_photos: Array<Driver_Duty_Photos>;
  /** An aggregate relationship */
  driver_duty_photos_aggregate: Driver_Duty_Photos_Aggregate;
  /** fetch data from the table: "driver_duty_photos" using primary key columns */
  driver_duty_photos_by_pk?: Maybe<Driver_Duty_Photos>;
  /** fetch data from the table in a streaming manner: "driver_duty_photos" */
  driver_duty_photos_stream: Array<Driver_Duty_Photos>;
  /** fetch data from the table: "driver_permit" */
  driver_permit: Array<Driver_Permit>;
  /** fetch aggregated fields from the table: "driver_permit" */
  driver_permit_aggregate: Driver_Permit_Aggregate;
  /** fetch data from the table: "driver_permit" using primary key columns */
  driver_permit_by_pk?: Maybe<Driver_Permit>;
  /** fetch data from the table in a streaming manner: "driver_permit" */
  driver_permit_stream: Array<Driver_Permit>;
  /** fetch data from the table: "driver_vehicle" */
  driver_vehicle: Array<Driver_Vehicle>;
  /** fetch aggregated fields from the table: "driver_vehicle" */
  driver_vehicle_aggregate: Driver_Vehicle_Aggregate;
  /** fetch data from the table: "driver_vehicle" using primary key columns */
  driver_vehicle_by_pk?: Maybe<Driver_Vehicle>;
  /** fetch data from the table: "driver_vehicle_issue" */
  driver_vehicle_issue: Array<Driver_Vehicle_Issue>;
  /** fetch aggregated fields from the table: "driver_vehicle_issue" */
  driver_vehicle_issue_aggregate: Driver_Vehicle_Issue_Aggregate;
  /** fetch data from the table: "driver_vehicle_issue" using primary key columns */
  driver_vehicle_issue_by_pk?: Maybe<Driver_Vehicle_Issue>;
  /** fetch data from the table in a streaming manner: "driver_vehicle_issue" */
  driver_vehicle_issue_stream: Array<Driver_Vehicle_Issue>;
  /** fetch data from the table: "driver_vehicle_location" */
  driver_vehicle_location: Array<Driver_Vehicle_Location>;
  /** fetch aggregated fields from the table: "driver_vehicle_location" */
  driver_vehicle_location_aggregate: Driver_Vehicle_Location_Aggregate;
  /** fetch data from the table: "driver_vehicle_location" using primary key columns */
  driver_vehicle_location_by_pk?: Maybe<Driver_Vehicle_Location>;
  /** fetch data from the table in a streaming manner: "driver_vehicle_location" */
  driver_vehicle_location_stream: Array<Driver_Vehicle_Location>;
  /** fetch data from the table in a streaming manner: "driver_vehicle" */
  driver_vehicle_stream: Array<Driver_Vehicle>;
  /** fetch data from the table: "erp_sync_status" */
  erp_sync_status: Array<Erp_Sync_Status>;
  /** fetch aggregated fields from the table: "erp_sync_status" */
  erp_sync_status_aggregate: Erp_Sync_Status_Aggregate;
  /** fetch data from the table: "erp_sync_status" using primary key columns */
  erp_sync_status_by_pk?: Maybe<Erp_Sync_Status>;
  /** fetch data from the table in a streaming manner: "erp_sync_status" */
  erp_sync_status_stream: Array<Erp_Sync_Status>;
  /** fetch data from the table: "fillup_request" */
  fillup_request: Array<Fillup_Request>;
  /** fetch aggregated fields from the table: "fillup_request" */
  fillup_request_aggregate: Fillup_Request_Aggregate;
  /** fetch data from the table: "fillup_request" using primary key columns */
  fillup_request_by_pk?: Maybe<Fillup_Request>;
  /** fetch data from the table: "fillup_request_status" */
  fillup_request_status: Array<Fillup_Request_Status>;
  /** fetch aggregated fields from the table: "fillup_request_status" */
  fillup_request_status_aggregate: Fillup_Request_Status_Aggregate;
  /** fetch data from the table: "fillup_request_status" using primary key columns */
  fillup_request_status_by_pk?: Maybe<Fillup_Request_Status>;
  /** fetch data from the table in a streaming manner: "fillup_request_status" */
  fillup_request_status_stream: Array<Fillup_Request_Status>;
  /** fetch data from the table in a streaming manner: "fillup_request" */
  fillup_request_stream: Array<Fillup_Request>;
  /** fetch data from the table: "fuel_request_type" */
  fuel_request_type: Array<Fuel_Request_Type>;
  /** fetch aggregated fields from the table: "fuel_request_type" */
  fuel_request_type_aggregate: Fuel_Request_Type_Aggregate;
  /** fetch data from the table: "fuel_request_type" using primary key columns */
  fuel_request_type_by_pk?: Maybe<Fuel_Request_Type>;
  /** fetch data from the table in a streaming manner: "fuel_request_type" */
  fuel_request_type_stream: Array<Fuel_Request_Type>;
  /** fetch data from the table: "fueltrans_transaction_logs" */
  fueltrans_transaction_logs: Array<Fueltrans_Transaction_Logs>;
  /** fetch aggregated fields from the table: "fueltrans_transaction_logs" */
  fueltrans_transaction_logs_aggregate: Fueltrans_Transaction_Logs_Aggregate;
  /** fetch data from the table: "fueltrans_transaction_logs" using primary key columns */
  fueltrans_transaction_logs_by_pk?: Maybe<Fueltrans_Transaction_Logs>;
  /** fetch data from the table in a streaming manner: "fueltrans_transaction_logs" */
  fueltrans_transaction_logs_stream: Array<Fueltrans_Transaction_Logs>;
  /** fetch data from the table: "geography_columns" */
  geography_columns: Array<Geography_Columns>;
  /** fetch aggregated fields from the table: "geography_columns" */
  geography_columns_aggregate: Geography_Columns_Aggregate;
  /** fetch data from the table in a streaming manner: "geography_columns" */
  geography_columns_stream: Array<Geography_Columns>;
  /** fetch data from the table: "geometry_columns" */
  geometry_columns: Array<Geometry_Columns>;
  /** fetch aggregated fields from the table: "geometry_columns" */
  geometry_columns_aggregate: Geometry_Columns_Aggregate;
  /** fetch data from the table in a streaming manner: "geometry_columns" */
  geometry_columns_stream: Array<Geometry_Columns>;
  /** fetch data from the table: "inventory" */
  inventory: Array<Inventory>;
  /** fetch aggregated fields from the table: "inventory" */
  inventory_aggregate: Inventory_Aggregate;
  /** fetch data from the table: "inventory" using primary key columns */
  inventory_by_pk?: Maybe<Inventory>;
  /** fetch data from the table in a streaming manner: "inventory" */
  inventory_stream: Array<Inventory>;
  /** An array relationship */
  inventory_workflow_logs: Array<Inventory_Workflow_Logs>;
  /** An aggregate relationship */
  inventory_workflow_logs_aggregate: Inventory_Workflow_Logs_Aggregate;
  /** fetch data from the table: "inventory_workflow_logs" using primary key columns */
  inventory_workflow_logs_by_pk?: Maybe<Inventory_Workflow_Logs>;
  /** fetch data from the table in a streaming manner: "inventory_workflow_logs" */
  inventory_workflow_logs_stream: Array<Inventory_Workflow_Logs>;
  /** fetch data from the table: "invitation" */
  invitation: Array<Invitation>;
  /** fetch aggregated fields from the table: "invitation" */
  invitation_aggregate: Invitation_Aggregate;
  /** fetch data from the table: "invitation" using primary key columns */
  invitation_by_pk?: Maybe<Invitation>;
  /** fetch data from the table: "invitation_status" */
  invitation_status: Array<Invitation_Status>;
  /** fetch aggregated fields from the table: "invitation_status" */
  invitation_status_aggregate: Invitation_Status_Aggregate;
  /** fetch data from the table: "invitation_status" using primary key columns */
  invitation_status_by_pk?: Maybe<Invitation_Status>;
  /** fetch data from the table in a streaming manner: "invitation_status" */
  invitation_status_stream: Array<Invitation_Status>;
  /** fetch data from the table in a streaming manner: "invitation" */
  invitation_stream: Array<Invitation>;
  /** fetch data from the table: "invoice" */
  invoice: Array<Invoice>;
  /** fetch aggregated fields from the table: "invoice" */
  invoice_aggregate: Invoice_Aggregate;
  /** fetch data from the table: "invoice" using primary key columns */
  invoice_by_pk?: Maybe<Invoice>;
  /** fetch data from the table in a streaming manner: "invoice" */
  invoice_stream: Array<Invoice>;
  /** fetch data from the table: "invoiced_item" */
  invoiced_item: Array<Invoiced_Item>;
  /** fetch aggregated fields from the table: "invoiced_item" */
  invoiced_item_aggregate: Invoiced_Item_Aggregate;
  /** fetch data from the table: "invoiced_item" using primary key columns */
  invoiced_item_by_pk?: Maybe<Invoiced_Item>;
  /** fetch data from the table: "invoiced_item_cancellation_ticket_states" */
  invoiced_item_cancellation_ticket_states: Array<Invoiced_Item_Cancellation_Ticket_States>;
  /** fetch aggregated fields from the table: "invoiced_item_cancellation_ticket_states" */
  invoiced_item_cancellation_ticket_states_aggregate: Invoiced_Item_Cancellation_Ticket_States_Aggregate;
  /** fetch data from the table: "invoiced_item_cancellation_ticket_states" using primary key columns */
  invoiced_item_cancellation_ticket_states_by_pk?: Maybe<Invoiced_Item_Cancellation_Ticket_States>;
  /** fetch data from the table in a streaming manner: "invoiced_item_cancellation_ticket_states" */
  invoiced_item_cancellation_ticket_states_stream: Array<Invoiced_Item_Cancellation_Ticket_States>;
  /** An array relationship */
  invoiced_item_cancellation_tickets: Array<Invoiced_Item_Cancellation_Tickets>;
  /** An aggregate relationship */
  invoiced_item_cancellation_tickets_aggregate: Invoiced_Item_Cancellation_Tickets_Aggregate;
  /** fetch data from the table: "invoiced_item_cancellation_tickets" using primary key columns */
  invoiced_item_cancellation_tickets_by_pk?: Maybe<Invoiced_Item_Cancellation_Tickets>;
  /** fetch data from the table in a streaming manner: "invoiced_item_cancellation_tickets" */
  invoiced_item_cancellation_tickets_stream: Array<Invoiced_Item_Cancellation_Tickets>;
  /** fetch data from the table in a streaming manner: "invoiced_item" */
  invoiced_item_stream: Array<Invoiced_Item>;
  /** fetch data from the table: "issue" */
  issue: Array<Issue>;
  /** fetch aggregated fields from the table: "issue" */
  issue_aggregate: Issue_Aggregate;
  /** fetch data from the table: "issue" using primary key columns */
  issue_by_pk?: Maybe<Issue>;
  /** fetch data from the table in a streaming manner: "issue" */
  issue_stream: Array<Issue>;
  /** fetch data from the table: "job_state" */
  job_state: Array<Job_State>;
  /** fetch aggregated fields from the table: "job_state" */
  job_state_aggregate: Job_State_Aggregate;
  /** fetch data from the table: "job_state" using primary key columns */
  job_state_by_pk?: Maybe<Job_State>;
  /** fetch data from the table in a streaming manner: "job_state" */
  job_state_stream: Array<Job_State>;
  /** fetch data from the table: "job_type" */
  job_type: Array<Job_Type>;
  /** fetch aggregated fields from the table: "job_type" */
  job_type_aggregate: Job_Type_Aggregate;
  /** fetch data from the table: "job_type" using primary key columns */
  job_type_by_pk?: Maybe<Job_Type>;
  /** fetch data from the table in a streaming manner: "job_type" */
  job_type_stream: Array<Job_Type>;
  /** fetch data from the table: "job_type_template" */
  job_type_template: Array<Job_Type_Template>;
  /** fetch aggregated fields from the table: "job_type_template" */
  job_type_template_aggregate: Job_Type_Template_Aggregate;
  /** fetch data from the table: "job_type_template" using primary key columns */
  job_type_template_by_pk?: Maybe<Job_Type_Template>;
  /** fetch data from the table in a streaming manner: "job_type_template" */
  job_type_template_stream: Array<Job_Type_Template>;
  /** An array relationship */
  jobs: Array<Jobs>;
  /** An aggregate relationship */
  jobs_aggregate: Jobs_Aggregate;
  /** fetch data from the table: "jobs" using primary key columns */
  jobs_by_pk?: Maybe<Jobs>;
  /** fetch data from the table: "jobs_state_flow" */
  jobs_state_flow: Array<Jobs_State_Flow>;
  /** fetch aggregated fields from the table: "jobs_state_flow" */
  jobs_state_flow_aggregate: Jobs_State_Flow_Aggregate;
  /** fetch data from the table: "jobs_state_flow" using primary key columns */
  jobs_state_flow_by_pk?: Maybe<Jobs_State_Flow>;
  /** fetch data from the table in a streaming manner: "jobs_state_flow" */
  jobs_state_flow_stream: Array<Jobs_State_Flow>;
  /** fetch data from the table in a streaming manner: "jobs" */
  jobs_stream: Array<Jobs>;
  /** fetch data from the table: "limit_purchase_order" */
  limit_purchase_order: Array<Limit_Purchase_Order>;
  /** fetch aggregated fields from the table: "limit_purchase_order" */
  limit_purchase_order_aggregate: Limit_Purchase_Order_Aggregate;
  /** fetch data from the table: "limit_purchase_order" using primary key columns */
  limit_purchase_order_by_pk?: Maybe<Limit_Purchase_Order>;
  /** An array relationship */
  limit_purchase_order_logs: Array<Limit_Purchase_Order_Logs>;
  /** An aggregate relationship */
  limit_purchase_order_logs_aggregate: Limit_Purchase_Order_Logs_Aggregate;
  /** fetch data from the table: "limit_purchase_order_logs" using primary key columns */
  limit_purchase_order_logs_by_pk?: Maybe<Limit_Purchase_Order_Logs>;
  /** fetch data from the table in a streaming manner: "limit_purchase_order_logs" */
  limit_purchase_order_logs_stream: Array<Limit_Purchase_Order_Logs>;
  /** fetch data from the table in a streaming manner: "limit_purchase_order" */
  limit_purchase_order_stream: Array<Limit_Purchase_Order>;
  /** fetch data from the table: "localities" */
  localities: Array<Localities>;
  /** fetch aggregated fields from the table: "localities" */
  localities_aggregate: Localities_Aggregate;
  /** fetch data from the table: "localities" using primary key columns */
  localities_by_pk?: Maybe<Localities>;
  /** fetch data from the table in a streaming manner: "localities" */
  localities_stream: Array<Localities>;
  /** fetch data from the table: "login_type" */
  login_type: Array<Login_Type>;
  /** fetch aggregated fields from the table: "login_type" */
  login_type_aggregate: Login_Type_Aggregate;
  /** fetch data from the table: "login_type" using primary key columns */
  login_type_by_pk?: Maybe<Login_Type>;
  /** fetch data from the table in a streaming manner: "login_type" */
  login_type_stream: Array<Login_Type>;
  /** fetch data from the table: "lpo_exception" */
  lpo_exception: Array<Lpo_Exception>;
  /** fetch aggregated fields from the table: "lpo_exception" */
  lpo_exception_aggregate: Lpo_Exception_Aggregate;
  /** fetch data from the table: "lpo_exception" using primary key columns */
  lpo_exception_by_pk?: Maybe<Lpo_Exception>;
  /** fetch data from the table in a streaming manner: "lpo_exception" */
  lpo_exception_stream: Array<Lpo_Exception>;
  /** fetch data from the table: "master_slot" */
  master_slot: Array<Master_Slot>;
  /** fetch aggregated fields from the table: "master_slot" */
  master_slot_aggregate: Master_Slot_Aggregate;
  /** fetch data from the table: "master_slot" using primary key columns */
  master_slot_by_pk?: Maybe<Master_Slot>;
  /** fetch data from the table: "master_slot_pause" */
  master_slot_pause: Array<Master_Slot_Pause>;
  /** fetch aggregated fields from the table: "master_slot_pause" */
  master_slot_pause_aggregate: Master_Slot_Pause_Aggregate;
  /** fetch data from the table: "master_slot_pause" using primary key columns */
  master_slot_pause_by_pk?: Maybe<Master_Slot_Pause>;
  /** fetch data from the table in a streaming manner: "master_slot_pause" */
  master_slot_pause_stream: Array<Master_Slot_Pause>;
  /** fetch data from the table in a streaming manner: "master_slot" */
  master_slot_stream: Array<Master_Slot>;
  /** fetch data from the table: "omc_type" */
  omc_type: Array<Omc_Type>;
  /** fetch aggregated fields from the table: "omc_type" */
  omc_type_aggregate: Omc_Type_Aggregate;
  /** fetch data from the table: "omc_type" using primary key columns */
  omc_type_by_pk?: Maybe<Omc_Type>;
  /** fetch data from the table in a streaming manner: "omc_type" */
  omc_type_stream: Array<Omc_Type>;
  /** An array relationship */
  order_photos: Array<Order_Photos>;
  /** An aggregate relationship */
  order_photos_aggregate: Order_Photos_Aggregate;
  /** fetch data from the table: "order_photos" using primary key columns */
  order_photos_by_pk?: Maybe<Order_Photos>;
  /** fetch data from the table in a streaming manner: "order_photos" */
  order_photos_stream: Array<Order_Photos>;
  /** fetch data from the table: "order_scheduler" */
  order_scheduler: Array<Order_Scheduler>;
  /** fetch aggregated fields from the table: "order_scheduler" */
  order_scheduler_aggregate: Order_Scheduler_Aggregate;
  /** fetch data from the table: "order_scheduler" using primary key columns */
  order_scheduler_by_pk?: Maybe<Order_Scheduler>;
  /** fetch data from the table: "order_scheduler_customer_asset" */
  order_scheduler_customer_asset: Array<Order_Scheduler_Customer_Asset>;
  /** fetch aggregated fields from the table: "order_scheduler_customer_asset" */
  order_scheduler_customer_asset_aggregate: Order_Scheduler_Customer_Asset_Aggregate;
  /** fetch data from the table: "order_scheduler_customer_asset" using primary key columns */
  order_scheduler_customer_asset_by_pk?: Maybe<Order_Scheduler_Customer_Asset>;
  /** fetch data from the table in a streaming manner: "order_scheduler_customer_asset" */
  order_scheduler_customer_asset_stream: Array<Order_Scheduler_Customer_Asset>;
  /** fetch data from the table: "order_scheduler_daily_frequency" */
  order_scheduler_daily_frequency: Array<Order_Scheduler_Daily_Frequency>;
  /** fetch aggregated fields from the table: "order_scheduler_daily_frequency" */
  order_scheduler_daily_frequency_aggregate: Order_Scheduler_Daily_Frequency_Aggregate;
  /** fetch data from the table: "order_scheduler_daily_frequency" using primary key columns */
  order_scheduler_daily_frequency_by_pk?: Maybe<Order_Scheduler_Daily_Frequency>;
  /** fetch data from the table in a streaming manner: "order_scheduler_daily_frequency" */
  order_scheduler_daily_frequency_stream: Array<Order_Scheduler_Daily_Frequency>;
  /** fetch data from the table in a streaming manner: "order_scheduler" */
  order_scheduler_stream: Array<Order_Scheduler>;
  /** fetch data from the table: "order_type" */
  order_type: Array<Order_Type>;
  /** fetch aggregated fields from the table: "order_type" */
  order_type_aggregate: Order_Type_Aggregate;
  /** fetch data from the table: "order_type" using primary key columns */
  order_type_by_pk?: Maybe<Order_Type>;
  /** fetch data from the table in a streaming manner: "order_type" */
  order_type_stream: Array<Order_Type>;
  /** fetch data from the table: "organization" */
  organization: Array<Organization>;
  /** fetch data from the table: "organization_address" */
  organization_address: Array<Organization_Address>;
  /** fetch aggregated fields from the table: "organization_address" */
  organization_address_aggregate: Organization_Address_Aggregate;
  /** fetch data from the table: "organization_address" using primary key columns */
  organization_address_by_pk?: Maybe<Organization_Address>;
  /** fetch data from the table in a streaming manner: "organization_address" */
  organization_address_stream: Array<Organization_Address>;
  /** fetch aggregated fields from the table: "organization" */
  organization_aggregate: Organization_Aggregate;
  /** fetch data from the table: "organization_audit_log" */
  organization_audit_log: Array<Organization_Audit_Log>;
  /** fetch aggregated fields from the table: "organization_audit_log" */
  organization_audit_log_aggregate: Organization_Audit_Log_Aggregate;
  /** fetch data from the table: "organization_audit_log" using primary key columns */
  organization_audit_log_by_pk?: Maybe<Organization_Audit_Log>;
  /** fetch data from the table in a streaming manner: "organization_audit_log" */
  organization_audit_log_stream: Array<Organization_Audit_Log>;
  /** fetch data from the table: "organization" using primary key columns */
  organization_by_pk?: Maybe<Organization>;
  /** fetch data from the table: "organization_commission_product_variation_type" */
  organization_commission_product_variation_type: Array<Organization_Commission_Product_Variation_Type>;
  /** fetch aggregated fields from the table: "organization_commission_product_variation_type" */
  organization_commission_product_variation_type_aggregate: Organization_Commission_Product_Variation_Type_Aggregate;
  /** fetch data from the table: "organization_commission_product_variation_type" using primary key columns */
  organization_commission_product_variation_type_by_pk?: Maybe<Organization_Commission_Product_Variation_Type>;
  /** fetch data from the table in a streaming manner: "organization_commission_product_variation_type" */
  organization_commission_product_variation_type_stream: Array<Organization_Commission_Product_Variation_Type>;
  /** fetch data from the table: "organization_configuration" */
  organization_configuration: Array<Organization_Configuration>;
  /** fetch aggregated fields from the table: "organization_configuration" */
  organization_configuration_aggregate: Organization_Configuration_Aggregate;
  /** fetch data from the table: "organization_configuration" using primary key columns */
  organization_configuration_by_pk?: Maybe<Organization_Configuration>;
  /** fetch data from the table in a streaming manner: "organization_configuration" */
  organization_configuration_stream: Array<Organization_Configuration>;
  /** fetch data from the table: "organization_product_variation_discount" */
  organization_product_variation_discount: Array<Organization_Product_Variation_Discount>;
  /** fetch aggregated fields from the table: "organization_product_variation_discount" */
  organization_product_variation_discount_aggregate: Organization_Product_Variation_Discount_Aggregate;
  /** fetch data from the table: "organization_product_variation_discount" using primary key columns */
  organization_product_variation_discount_by_pk?: Maybe<Organization_Product_Variation_Discount>;
  /** fetch data from the table: "organization_product_variation_discount_history" */
  organization_product_variation_discount_history: Array<Organization_Product_Variation_Discount_History>;
  /** fetch aggregated fields from the table: "organization_product_variation_discount_history" */
  organization_product_variation_discount_history_aggregate: Organization_Product_Variation_Discount_History_Aggregate;
  /** fetch data from the table: "organization_product_variation_discount_history" using primary key columns */
  organization_product_variation_discount_history_by_pk?: Maybe<Organization_Product_Variation_Discount_History>;
  /** fetch data from the table in a streaming manner: "organization_product_variation_discount_history" */
  organization_product_variation_discount_history_stream: Array<Organization_Product_Variation_Discount_History>;
  /** fetch data from the table in a streaming manner: "organization_product_variation_discount" */
  organization_product_variation_discount_stream: Array<Organization_Product_Variation_Discount>;
  /** fetch data from the table: "organization_sales_projection" */
  organization_sales_projection: Array<Organization_Sales_Projection>;
  /** fetch aggregated fields from the table: "organization_sales_projection" */
  organization_sales_projection_aggregate: Organization_Sales_Projection_Aggregate;
  /** fetch data from the table: "organization_sales_projection" using primary key columns */
  organization_sales_projection_by_pk?: Maybe<Organization_Sales_Projection>;
  /** fetch data from the table in a streaming manner: "organization_sales_projection" */
  organization_sales_projection_stream: Array<Organization_Sales_Projection>;
  /** fetch data from the table in a streaming manner: "organization" */
  organization_stream: Array<Organization>;
  /** fetch data from the table: "organization_timing" */
  organization_timing: Array<Organization_Timing>;
  /** fetch aggregated fields from the table: "organization_timing" */
  organization_timing_aggregate: Organization_Timing_Aggregate;
  /** fetch data from the table: "organization_timing" using primary key columns */
  organization_timing_by_pk?: Maybe<Organization_Timing>;
  /** fetch data from the table in a streaming manner: "organization_timing" */
  organization_timing_stream: Array<Organization_Timing>;
  /** fetch data from the table: "organization_type" */
  organization_type: Array<Organization_Type>;
  /** fetch aggregated fields from the table: "organization_type" */
  organization_type_aggregate: Organization_Type_Aggregate;
  /** fetch data from the table: "organization_type" using primary key columns */
  organization_type_by_pk?: Maybe<Organization_Type>;
  /** fetch data from the table in a streaming manner: "organization_type" */
  organization_type_stream: Array<Organization_Type>;
  /** fetch data from the table: "organization_user" */
  organization_user: Array<Organization_User>;
  /** fetch aggregated fields from the table: "organization_user" */
  organization_user_aggregate: Organization_User_Aggregate;
  /** fetch data from the table: "organization_user" using primary key columns */
  organization_user_by_pk?: Maybe<Organization_User>;
  /** fetch data from the table: "organization_user_commission" */
  organization_user_commission: Array<Organization_User_Commission>;
  /** fetch aggregated fields from the table: "organization_user_commission" */
  organization_user_commission_aggregate: Organization_User_Commission_Aggregate;
  /** fetch data from the table: "organization_user_commission" using primary key columns */
  organization_user_commission_by_pk?: Maybe<Organization_User_Commission>;
  /** fetch data from the table in a streaming manner: "organization_user_commission" */
  organization_user_commission_stream: Array<Organization_User_Commission>;
  /** fetch data from the table: "organization_user_document" */
  organization_user_document: Array<Organization_User_Document>;
  /** fetch aggregated fields from the table: "organization_user_document" */
  organization_user_document_aggregate: Organization_User_Document_Aggregate;
  /** fetch data from the table: "organization_user_document" using primary key columns */
  organization_user_document_by_pk?: Maybe<Organization_User_Document>;
  /** fetch data from the table in a streaming manner: "organization_user_document" */
  organization_user_document_stream: Array<Organization_User_Document>;
  /** fetch data from the table: "organization_user_permission" */
  organization_user_permission: Array<Organization_User_Permission>;
  /** fetch aggregated fields from the table: "organization_user_permission" */
  organization_user_permission_aggregate: Organization_User_Permission_Aggregate;
  /** fetch data from the table: "organization_user_permission" using primary key columns */
  organization_user_permission_by_pk?: Maybe<Organization_User_Permission>;
  /** fetch data from the table in a streaming manner: "organization_user_permission" */
  organization_user_permission_stream: Array<Organization_User_Permission>;
  /** fetch data from the table in a streaming manner: "organization_user" */
  organization_user_stream: Array<Organization_User>;
  /** fetch data from the table: "organization_user_subsidiary" */
  organization_user_subsidiary: Array<Organization_User_Subsidiary>;
  /** fetch aggregated fields from the table: "organization_user_subsidiary" */
  organization_user_subsidiary_aggregate: Organization_User_Subsidiary_Aggregate;
  /** fetch data from the table: "organization_user_subsidiary" using primary key columns */
  organization_user_subsidiary_by_pk?: Maybe<Organization_User_Subsidiary>;
  /** fetch data from the table in a streaming manner: "organization_user_subsidiary" */
  organization_user_subsidiary_stream: Array<Organization_User_Subsidiary>;
  /** fetch data from the table: "organization_user_type" */
  organization_user_type: Array<Organization_User_Type>;
  /** fetch aggregated fields from the table: "organization_user_type" */
  organization_user_type_aggregate: Organization_User_Type_Aggregate;
  /** fetch data from the table: "organization_user_type" using primary key columns */
  organization_user_type_by_pk?: Maybe<Organization_User_Type>;
  /** fetch data from the table in a streaming manner: "organization_user_type" */
  organization_user_type_stream: Array<Organization_User_Type>;
  /** fetch data from the table: "ownership_type" */
  ownership_type: Array<Ownership_Type>;
  /** fetch aggregated fields from the table: "ownership_type" */
  ownership_type_aggregate: Ownership_Type_Aggregate;
  /** fetch data from the table: "ownership_type" using primary key columns */
  ownership_type_by_pk?: Maybe<Ownership_Type>;
  /** fetch data from the table in a streaming manner: "ownership_type" */
  ownership_type_stream: Array<Ownership_Type>;
  /** fetch data from the table: "partner" */
  partner: Array<Partner>;
  /** fetch data from the table: "partner_address" */
  partner_address: Array<Partner_Address>;
  /** fetch aggregated fields from the table: "partner_address" */
  partner_address_aggregate: Partner_Address_Aggregate;
  /** fetch data from the table: "partner_address" using primary key columns */
  partner_address_by_pk?: Maybe<Partner_Address>;
  /** fetch data from the table in a streaming manner: "partner_address" */
  partner_address_stream: Array<Partner_Address>;
  /** fetch aggregated fields from the table: "partner" */
  partner_aggregate: Partner_Aggregate;
  /** An array relationship */
  partner_bank_details: Array<Partner_Bank_Details>;
  /** An aggregate relationship */
  partner_bank_details_aggregate: Partner_Bank_Details_Aggregate;
  /** fetch data from the table: "partner_bank_details" using primary key columns */
  partner_bank_details_by_pk?: Maybe<Partner_Bank_Details>;
  /** fetch data from the table in a streaming manner: "partner_bank_details" */
  partner_bank_details_stream: Array<Partner_Bank_Details>;
  /** fetch data from the table: "partner" using primary key columns */
  partner_by_pk?: Maybe<Partner>;
  /** fetch data from the table: "partner_commission" */
  partner_commission: Array<Partner_Commission>;
  /** fetch aggregated fields from the table: "partner_commission" */
  partner_commission_aggregate: Partner_Commission_Aggregate;
  /** fetch data from the table: "partner_commission" using primary key columns */
  partner_commission_by_pk?: Maybe<Partner_Commission>;
  /** fetch data from the table: "partner_commission_product_variation_type" */
  partner_commission_product_variation_type: Array<Partner_Commission_Product_Variation_Type>;
  /** fetch aggregated fields from the table: "partner_commission_product_variation_type" */
  partner_commission_product_variation_type_aggregate: Partner_Commission_Product_Variation_Type_Aggregate;
  /** fetch data from the table: "partner_commission_product_variation_type" using primary key columns */
  partner_commission_product_variation_type_by_pk?: Maybe<Partner_Commission_Product_Variation_Type>;
  /** fetch data from the table in a streaming manner: "partner_commission_product_variation_type" */
  partner_commission_product_variation_type_stream: Array<Partner_Commission_Product_Variation_Type>;
  /** fetch data from the table in a streaming manner: "partner_commission" */
  partner_commission_stream: Array<Partner_Commission>;
  /** fetch data from the table: "partner_contact_type" */
  partner_contact_type: Array<Partner_Contact_Type>;
  /** fetch aggregated fields from the table: "partner_contact_type" */
  partner_contact_type_aggregate: Partner_Contact_Type_Aggregate;
  /** fetch data from the table: "partner_contact_type" using primary key columns */
  partner_contact_type_by_pk?: Maybe<Partner_Contact_Type>;
  /** fetch data from the table in a streaming manner: "partner_contact_type" */
  partner_contact_type_stream: Array<Partner_Contact_Type>;
  /** An array relationship */
  partner_localities: Array<Partner_Localities>;
  /** An aggregate relationship */
  partner_localities_aggregate: Partner_Localities_Aggregate;
  /** fetch data from the table: "partner_localities" using primary key columns */
  partner_localities_by_pk?: Maybe<Partner_Localities>;
  /** An array relationship */
  partner_localities_slots: Array<Partner_Localities_Slots>;
  /** An aggregate relationship */
  partner_localities_slots_aggregate: Partner_Localities_Slots_Aggregate;
  /** fetch data from the table: "partner_localities_slots" using primary key columns */
  partner_localities_slots_by_pk?: Maybe<Partner_Localities_Slots>;
  /** fetch data from the table in a streaming manner: "partner_localities_slots" */
  partner_localities_slots_stream: Array<Partner_Localities_Slots>;
  /** fetch data from the table in a streaming manner: "partner_localities" */
  partner_localities_stream: Array<Partner_Localities>;
  /** fetch data from the table: "partner_order" */
  partner_order: Array<Partner_Order>;
  /** fetch aggregated fields from the table: "partner_order" */
  partner_order_aggregate: Partner_Order_Aggregate;
  /** fetch data from the table: "partner_order" using primary key columns */
  partner_order_by_pk?: Maybe<Partner_Order>;
  /** fetch data from the table: "partner_order_customer_asset" */
  partner_order_customer_asset: Array<Partner_Order_Customer_Asset>;
  /** fetch aggregated fields from the table: "partner_order_customer_asset" */
  partner_order_customer_asset_aggregate: Partner_Order_Customer_Asset_Aggregate;
  /** fetch data from the table: "partner_order_customer_asset" using primary key columns */
  partner_order_customer_asset_by_pk?: Maybe<Partner_Order_Customer_Asset>;
  /** fetch data from the table in a streaming manner: "partner_order_customer_asset" */
  partner_order_customer_asset_stream: Array<Partner_Order_Customer_Asset>;
  /** fetch data from the table: "partner_order_item" */
  partner_order_item: Array<Partner_Order_Item>;
  /** fetch aggregated fields from the table: "partner_order_item" */
  partner_order_item_aggregate: Partner_Order_Item_Aggregate;
  /** fetch data from the table: "partner_order_item" using primary key columns */
  partner_order_item_by_pk?: Maybe<Partner_Order_Item>;
  /** fetch data from the table: "partner_order_item_commission" */
  partner_order_item_commission: Array<Partner_Order_Item_Commission>;
  /** fetch aggregated fields from the table: "partner_order_item_commission" */
  partner_order_item_commission_aggregate: Partner_Order_Item_Commission_Aggregate;
  /** fetch data from the table: "partner_order_item_commission" using primary key columns */
  partner_order_item_commission_by_pk?: Maybe<Partner_Order_Item_Commission>;
  /** fetch data from the table in a streaming manner: "partner_order_item_commission" */
  partner_order_item_commission_stream: Array<Partner_Order_Item_Commission>;
  /** fetch data from the table: "partner_order_item_state" */
  partner_order_item_state: Array<Partner_Order_Item_State>;
  /** fetch aggregated fields from the table: "partner_order_item_state" */
  partner_order_item_state_aggregate: Partner_Order_Item_State_Aggregate;
  /** fetch data from the table: "partner_order_item_state" using primary key columns */
  partner_order_item_state_by_pk?: Maybe<Partner_Order_Item_State>;
  /** fetch data from the table in a streaming manner: "partner_order_item_state" */
  partner_order_item_state_stream: Array<Partner_Order_Item_State>;
  /** fetch data from the table: "partner_order_item_stateflow" */
  partner_order_item_stateflow: Array<Partner_Order_Item_Stateflow>;
  /** fetch aggregated fields from the table: "partner_order_item_stateflow" */
  partner_order_item_stateflow_aggregate: Partner_Order_Item_Stateflow_Aggregate;
  /** fetch data from the table: "partner_order_item_stateflow" using primary key columns */
  partner_order_item_stateflow_by_pk?: Maybe<Partner_Order_Item_Stateflow>;
  /** fetch data from the table in a streaming manner: "partner_order_item_stateflow" */
  partner_order_item_stateflow_stream: Array<Partner_Order_Item_Stateflow>;
  /** fetch data from the table in a streaming manner: "partner_order_item" */
  partner_order_item_stream: Array<Partner_Order_Item>;
  /** fetch data from the table: "partner_order_item_test_category" */
  partner_order_item_test_category: Array<Partner_Order_Item_Test_Category>;
  /** fetch aggregated fields from the table: "partner_order_item_test_category" */
  partner_order_item_test_category_aggregate: Partner_Order_Item_Test_Category_Aggregate;
  /** fetch data from the table: "partner_order_item_test_category" using primary key columns */
  partner_order_item_test_category_by_pk?: Maybe<Partner_Order_Item_Test_Category>;
  /** fetch data from the table in a streaming manner: "partner_order_item_test_category" */
  partner_order_item_test_category_stream: Array<Partner_Order_Item_Test_Category>;
  /** An array relationship */
  partner_order_item_test_results: Array<Partner_Order_Item_Test_Results>;
  /** An aggregate relationship */
  partner_order_item_test_results_aggregate: Partner_Order_Item_Test_Results_Aggregate;
  /** fetch data from the table: "partner_order_item_test_results" using primary key columns */
  partner_order_item_test_results_by_pk?: Maybe<Partner_Order_Item_Test_Results>;
  /** An array relationship */
  partner_order_item_test_results_photos: Array<Partner_Order_Item_Test_Results_Photos>;
  /** An aggregate relationship */
  partner_order_item_test_results_photos_aggregate: Partner_Order_Item_Test_Results_Photos_Aggregate;
  /** fetch data from the table: "partner_order_item_test_results_photos" using primary key columns */
  partner_order_item_test_results_photos_by_pk?: Maybe<Partner_Order_Item_Test_Results_Photos>;
  /** fetch data from the table in a streaming manner: "partner_order_item_test_results_photos" */
  partner_order_item_test_results_photos_stream: Array<Partner_Order_Item_Test_Results_Photos>;
  /** fetch data from the table in a streaming manner: "partner_order_item_test_results" */
  partner_order_item_test_results_stream: Array<Partner_Order_Item_Test_Results>;
  /** fetch data from the table: "partner_order_item_value" */
  partner_order_item_value: Array<Partner_Order_Item_Value>;
  /** fetch aggregated fields from the table: "partner_order_item_value" */
  partner_order_item_value_aggregate: Partner_Order_Item_Value_Aggregate;
  /** fetch data from the table: "partner_order_item_value" using primary key columns */
  partner_order_item_value_by_pk?: Maybe<Partner_Order_Item_Value>;
  /** fetch data from the table in a streaming manner: "partner_order_item_value" */
  partner_order_item_value_stream: Array<Partner_Order_Item_Value>;
  /** fetch data from the table: "partner_order_partner_user_document" */
  partner_order_partner_user_document: Array<Partner_Order_Partner_User_Document>;
  /** fetch aggregated fields from the table: "partner_order_partner_user_document" */
  partner_order_partner_user_document_aggregate: Partner_Order_Partner_User_Document_Aggregate;
  /** fetch data from the table: "partner_order_partner_user_document" using primary key columns */
  partner_order_partner_user_document_by_pk?: Maybe<Partner_Order_Partner_User_Document>;
  /** fetch data from the table in a streaming manner: "partner_order_partner_user_document" */
  partner_order_partner_user_document_stream: Array<Partner_Order_Partner_User_Document>;
  /** fetch data from the table: "partner_order_state" */
  partner_order_state: Array<Partner_Order_State>;
  /** fetch aggregated fields from the table: "partner_order_state" */
  partner_order_state_aggregate: Partner_Order_State_Aggregate;
  /** fetch data from the table: "partner_order_state" using primary key columns */
  partner_order_state_by_pk?: Maybe<Partner_Order_State>;
  /** fetch data from the table in a streaming manner: "partner_order_state" */
  partner_order_state_stream: Array<Partner_Order_State>;
  /** fetch data from the table: "partner_order_stateflow" */
  partner_order_stateflow: Array<Partner_Order_Stateflow>;
  /** fetch aggregated fields from the table: "partner_order_stateflow" */
  partner_order_stateflow_aggregate: Partner_Order_Stateflow_Aggregate;
  /** fetch data from the table: "partner_order_stateflow" using primary key columns */
  partner_order_stateflow_by_pk?: Maybe<Partner_Order_Stateflow>;
  /** fetch data from the table in a streaming manner: "partner_order_stateflow" */
  partner_order_stateflow_stream: Array<Partner_Order_Stateflow>;
  /** fetch data from the table in a streaming manner: "partner_order" */
  partner_order_stream: Array<Partner_Order>;
  /** fetch data from the table: "partner_payment" */
  partner_payment: Array<Partner_Payment>;
  /** fetch aggregated fields from the table: "partner_payment" */
  partner_payment_aggregate: Partner_Payment_Aggregate;
  /** fetch data from the table: "partner_payment" using primary key columns */
  partner_payment_by_pk?: Maybe<Partner_Payment>;
  /** fetch data from the table in a streaming manner: "partner_payment" */
  partner_payment_stream: Array<Partner_Payment>;
  /** fetch data from the table: "partner_product" */
  partner_product: Array<Partner_Product>;
  /** fetch aggregated fields from the table: "partner_product" */
  partner_product_aggregate: Partner_Product_Aggregate;
  /** fetch data from the table: "partner_product" using primary key columns */
  partner_product_by_pk?: Maybe<Partner_Product>;
  /** fetch data from the table in a streaming manner: "partner_product" */
  partner_product_stream: Array<Partner_Product>;
  /** fetch data from the table: "partner_relationship" */
  partner_relationship: Array<Partner_Relationship>;
  /** fetch aggregated fields from the table: "partner_relationship" */
  partner_relationship_aggregate: Partner_Relationship_Aggregate;
  /** fetch data from the table: "partner_relationship" using primary key columns */
  partner_relationship_by_pk?: Maybe<Partner_Relationship>;
  /** fetch data from the table in a streaming manner: "partner_relationship" */
  partner_relationship_stream: Array<Partner_Relationship>;
  /** fetch data from the table: "partner_seller" */
  partner_seller: Array<Partner_Seller>;
  /** fetch aggregated fields from the table: "partner_seller" */
  partner_seller_aggregate: Partner_Seller_Aggregate;
  /** fetch data from the table: "partner_seller" using primary key columns */
  partner_seller_by_pk?: Maybe<Partner_Seller>;
  /** fetch data from the table in a streaming manner: "partner_seller" */
  partner_seller_stream: Array<Partner_Seller>;
  /** fetch data from the table: "partner_seller_type" */
  partner_seller_type: Array<Partner_Seller_Type>;
  /** fetch aggregated fields from the table: "partner_seller_type" */
  partner_seller_type_aggregate: Partner_Seller_Type_Aggregate;
  /** fetch data from the table: "partner_seller_type" using primary key columns */
  partner_seller_type_by_pk?: Maybe<Partner_Seller_Type>;
  /** fetch data from the table in a streaming manner: "partner_seller_type" */
  partner_seller_type_stream: Array<Partner_Seller_Type>;
  /** fetch data from the table: "partner_signing_authority" */
  partner_signing_authority: Array<Partner_Signing_Authority>;
  /** fetch aggregated fields from the table: "partner_signing_authority" */
  partner_signing_authority_aggregate: Partner_Signing_Authority_Aggregate;
  /** fetch data from the table: "partner_signing_authority" using primary key columns */
  partner_signing_authority_by_pk?: Maybe<Partner_Signing_Authority>;
  /** fetch data from the table in a streaming manner: "partner_signing_authority" */
  partner_signing_authority_stream: Array<Partner_Signing_Authority>;
  /** fetch data from the table in a streaming manner: "partner" */
  partner_stream: Array<Partner>;
  /** fetch data from the table: "partner_timing" */
  partner_timing: Array<Partner_Timing>;
  /** fetch aggregated fields from the table: "partner_timing" */
  partner_timing_aggregate: Partner_Timing_Aggregate;
  /** fetch data from the table: "partner_timing" using primary key columns */
  partner_timing_by_pk?: Maybe<Partner_Timing>;
  /** fetch data from the table in a streaming manner: "partner_timing" */
  partner_timing_stream: Array<Partner_Timing>;
  /** fetch data from the table: "partner_type" */
  partner_type: Array<Partner_Type>;
  /** fetch aggregated fields from the table: "partner_type" */
  partner_type_aggregate: Partner_Type_Aggregate;
  /** fetch data from the table: "partner_type" using primary key columns */
  partner_type_by_pk?: Maybe<Partner_Type>;
  /** fetch data from the table in a streaming manner: "partner_type" */
  partner_type_stream: Array<Partner_Type>;
  /** fetch data from the table: "partner_user" */
  partner_user: Array<Partner_User>;
  /** fetch aggregated fields from the table: "partner_user" */
  partner_user_aggregate: Partner_User_Aggregate;
  /** fetch data from the table: "partner_user" using primary key columns */
  partner_user_by_pk?: Maybe<Partner_User>;
  /** fetch data from the table: "partner_user_document" */
  partner_user_document: Array<Partner_User_Document>;
  /** fetch aggregated fields from the table: "partner_user_document" */
  partner_user_document_aggregate: Partner_User_Document_Aggregate;
  /** fetch data from the table: "partner_user_document" using primary key columns */
  partner_user_document_by_pk?: Maybe<Partner_User_Document>;
  /** fetch data from the table in a streaming manner: "partner_user_document" */
  partner_user_document_stream: Array<Partner_User_Document>;
  /** fetch data from the table: "partner_user_permission" */
  partner_user_permission: Array<Partner_User_Permission>;
  /** fetch aggregated fields from the table: "partner_user_permission" */
  partner_user_permission_aggregate: Partner_User_Permission_Aggregate;
  /** fetch data from the table: "partner_user_permission" using primary key columns */
  partner_user_permission_by_pk?: Maybe<Partner_User_Permission>;
  /** fetch data from the table in a streaming manner: "partner_user_permission" */
  partner_user_permission_stream: Array<Partner_User_Permission>;
  /** fetch data from the table in a streaming manner: "partner_user" */
  partner_user_stream: Array<Partner_User>;
  /** fetch data from the table: "partner_vehicle" */
  partner_vehicle: Array<Partner_Vehicle>;
  /** fetch aggregated fields from the table: "partner_vehicle" */
  partner_vehicle_aggregate: Partner_Vehicle_Aggregate;
  /** fetch data from the table: "partner_vehicle" using primary key columns */
  partner_vehicle_by_pk?: Maybe<Partner_Vehicle>;
  /** fetch data from the table: "partner_vehicle_state" */
  partner_vehicle_state: Array<Partner_Vehicle_State>;
  /** fetch aggregated fields from the table: "partner_vehicle_state" */
  partner_vehicle_state_aggregate: Partner_Vehicle_State_Aggregate;
  /** fetch data from the table: "partner_vehicle_state" using primary key columns */
  partner_vehicle_state_by_pk?: Maybe<Partner_Vehicle_State>;
  /** fetch data from the table in a streaming manner: "partner_vehicle_state" */
  partner_vehicle_state_stream: Array<Partner_Vehicle_State>;
  /** fetch data from the table in a streaming manner: "partner_vehicle" */
  partner_vehicle_stream: Array<Partner_Vehicle>;
  /** fetch data from the table: "payment_type" */
  payment_type: Array<Payment_Type>;
  /** fetch aggregated fields from the table: "payment_type" */
  payment_type_aggregate: Payment_Type_Aggregate;
  /** fetch data from the table: "payment_type" using primary key columns */
  payment_type_by_pk?: Maybe<Payment_Type>;
  /** fetch data from the table in a streaming manner: "payment_type" */
  payment_type_stream: Array<Payment_Type>;
  /** fetch data from the table: "period_frequency" */
  period_frequency: Array<Period_Frequency>;
  /** fetch aggregated fields from the table: "period_frequency" */
  period_frequency_aggregate: Period_Frequency_Aggregate;
  /** fetch data from the table: "period_frequency" using primary key columns */
  period_frequency_by_pk?: Maybe<Period_Frequency>;
  /** fetch data from the table in a streaming manner: "period_frequency" */
  period_frequency_stream: Array<Period_Frequency>;
  /** fetch data from the table: "permission" */
  permission: Array<Permission>;
  /** fetch aggregated fields from the table: "permission" */
  permission_aggregate: Permission_Aggregate;
  /** fetch data from the table: "permission" using primary key columns */
  permission_by_pk?: Maybe<Permission>;
  /** fetch data from the table in a streaming manner: "permission" */
  permission_stream: Array<Permission>;
  /** fetch data from the table: "permit" */
  permit: Array<Permit>;
  /** fetch aggregated fields from the table: "permit" */
  permit_aggregate: Permit_Aggregate;
  /** fetch data from the table: "permit" using primary key columns */
  permit_by_pk?: Maybe<Permit>;
  /** fetch data from the table in a streaming manner: "permit" */
  permit_stream: Array<Permit>;
  /** fetch data from the table: "photo_type" */
  photo_type: Array<Photo_Type>;
  /** fetch aggregated fields from the table: "photo_type" */
  photo_type_aggregate: Photo_Type_Aggregate;
  /** fetch data from the table: "photo_type" using primary key columns */
  photo_type_by_pk?: Maybe<Photo_Type>;
  /** fetch data from the table in a streaming manner: "photo_type" */
  photo_type_stream: Array<Photo_Type>;
  /** fetch data from the table: "planning_audit_log" */
  planning_audit_log: Array<Planning_Audit_Log>;
  /** fetch aggregated fields from the table: "planning_audit_log" */
  planning_audit_log_aggregate: Planning_Audit_Log_Aggregate;
  /** fetch data from the table: "planning_audit_log" using primary key columns */
  planning_audit_log_by_pk?: Maybe<Planning_Audit_Log>;
  /** fetch data from the table in a streaming manner: "planning_audit_log" */
  planning_audit_log_stream: Array<Planning_Audit_Log>;
  /** fetch data from the table: "planning_period" */
  planning_period: Array<Planning_Period>;
  /** fetch aggregated fields from the table: "planning_period" */
  planning_period_aggregate: Planning_Period_Aggregate;
  /** fetch data from the table: "planning_period" using primary key columns */
  planning_period_by_pk?: Maybe<Planning_Period>;
  /** fetch data from the table in a streaming manner: "planning_period" */
  planning_period_stream: Array<Planning_Period>;
  /** fetch data from the table: "product" */
  product: Array<Product>;
  /** fetch aggregated fields from the table: "product" */
  product_aggregate: Product_Aggregate;
  /** fetch data from the table: "product" using primary key columns */
  product_by_pk?: Maybe<Product>;
  /** fetch data from the table: "product_commission" */
  product_commission: Array<Product_Commission>;
  /** fetch aggregated fields from the table: "product_commission" */
  product_commission_aggregate: Product_Commission_Aggregate;
  /** fetch data from the table: "product_commission" using primary key columns */
  product_commission_by_pk?: Maybe<Product_Commission>;
  /** fetch data from the table in a streaming manner: "product_commission" */
  product_commission_stream: Array<Product_Commission>;
  /** fetch data from the table: "product_document" */
  product_document: Array<Product_Document>;
  /** fetch aggregated fields from the table: "product_document" */
  product_document_aggregate: Product_Document_Aggregate;
  /** fetch data from the table: "product_document" using primary key columns */
  product_document_by_pk?: Maybe<Product_Document>;
  /** fetch data from the table in a streaming manner: "product_document" */
  product_document_stream: Array<Product_Document>;
  /** fetch data from the table: "product_partner_localities_price" */
  product_partner_localities_price: Array<Product_Partner_Localities_Price>;
  /** fetch aggregated fields from the table: "product_partner_localities_price" */
  product_partner_localities_price_aggregate: Product_Partner_Localities_Price_Aggregate;
  /** fetch data from the table: "product_partner_localities_price" using primary key columns */
  product_partner_localities_price_by_pk?: Maybe<Product_Partner_Localities_Price>;
  /** fetch data from the table: "product_partner_localities_price_history" */
  product_partner_localities_price_history: Array<Product_Partner_Localities_Price_History>;
  /** fetch aggregated fields from the table: "product_partner_localities_price_history" */
  product_partner_localities_price_history_aggregate: Product_Partner_Localities_Price_History_Aggregate;
  /** fetch data from the table: "product_partner_localities_price_history" using primary key columns */
  product_partner_localities_price_history_by_pk?: Maybe<Product_Partner_Localities_Price_History>;
  /** fetch data from the table in a streaming manner: "product_partner_localities_price_history" */
  product_partner_localities_price_history_stream: Array<Product_Partner_Localities_Price_History>;
  /** fetch data from the table in a streaming manner: "product_partner_localities_price" */
  product_partner_localities_price_stream: Array<Product_Partner_Localities_Price>;
  /** An array relationship */
  product_photos: Array<Product_Photos>;
  /** An aggregate relationship */
  product_photos_aggregate: Product_Photos_Aggregate;
  /** fetch data from the table: "product_photos" using primary key columns */
  product_photos_by_pk?: Maybe<Product_Photos>;
  /** fetch data from the table in a streaming manner: "product_photos" */
  product_photos_stream: Array<Product_Photos>;
  /** fetch data from the table in a streaming manner: "product" */
  product_stream: Array<Product>;
  /** fetch data from the table: "product_type" */
  product_type: Array<Product_Type>;
  /** fetch aggregated fields from the table: "product_type" */
  product_type_aggregate: Product_Type_Aggregate;
  /** fetch data from the table: "product_type" using primary key columns */
  product_type_by_pk?: Maybe<Product_Type>;
  /** fetch data from the table in a streaming manner: "product_type" */
  product_type_stream: Array<Product_Type>;
  /** fetch data from the table: "product_variation" */
  product_variation: Array<Product_Variation>;
  /** fetch aggregated fields from the table: "product_variation" */
  product_variation_aggregate: Product_Variation_Aggregate;
  /** fetch data from the table: "product_variation" using primary key columns */
  product_variation_by_pk?: Maybe<Product_Variation>;
  /** An array relationship */
  product_variation_partner_localities_slots: Array<Product_Variation_Partner_Localities_Slots>;
  /** An aggregate relationship */
  product_variation_partner_localities_slots_aggregate: Product_Variation_Partner_Localities_Slots_Aggregate;
  /** fetch data from the table: "product_variation_partner_localities_slots" using primary key columns */
  product_variation_partner_localities_slots_by_pk?: Maybe<Product_Variation_Partner_Localities_Slots>;
  /** fetch data from the table in a streaming manner: "product_variation_partner_localities_slots" */
  product_variation_partner_localities_slots_stream: Array<Product_Variation_Partner_Localities_Slots>;
  /** An array relationship */
  product_variation_photos: Array<Product_Variation_Photos>;
  /** An aggregate relationship */
  product_variation_photos_aggregate: Product_Variation_Photos_Aggregate;
  /** fetch data from the table: "product_variation_photos" using primary key columns */
  product_variation_photos_by_pk?: Maybe<Product_Variation_Photos>;
  /** fetch data from the table in a streaming manner: "product_variation_photos" */
  product_variation_photos_stream: Array<Product_Variation_Photos>;
  /** fetch data from the table: "product_variation_safety_checklist_category" */
  product_variation_safety_checklist_category: Array<Product_Variation_Safety_Checklist_Category>;
  /** fetch aggregated fields from the table: "product_variation_safety_checklist_category" */
  product_variation_safety_checklist_category_aggregate: Product_Variation_Safety_Checklist_Category_Aggregate;
  /** fetch data from the table: "product_variation_safety_checklist_category" using primary key columns */
  product_variation_safety_checklist_category_by_pk?: Maybe<Product_Variation_Safety_Checklist_Category>;
  /** fetch data from the table in a streaming manner: "product_variation_safety_checklist_category" */
  product_variation_safety_checklist_category_stream: Array<Product_Variation_Safety_Checklist_Category>;
  /** fetch data from the table in a streaming manner: "product_variation" */
  product_variation_stream: Array<Product_Variation>;
  /** fetch data from the table: "product_variation_test_category" */
  product_variation_test_category: Array<Product_Variation_Test_Category>;
  /** fetch aggregated fields from the table: "product_variation_test_category" */
  product_variation_test_category_aggregate: Product_Variation_Test_Category_Aggregate;
  /** fetch data from the table: "product_variation_test_category" using primary key columns */
  product_variation_test_category_by_pk?: Maybe<Product_Variation_Test_Category>;
  /** fetch data from the table in a streaming manner: "product_variation_test_category" */
  product_variation_test_category_stream: Array<Product_Variation_Test_Category>;
  /** fetch data from the table: "purchase_order" */
  purchase_order: Array<Purchase_Order>;
  /** fetch aggregated fields from the table: "purchase_order" */
  purchase_order_aggregate: Purchase_Order_Aggregate;
  /** fetch data from the table: "purchase_order" using primary key columns */
  purchase_order_by_pk?: Maybe<Purchase_Order>;
  /** An array relationship */
  purchase_order_items: Array<Purchase_Order_Items>;
  /** An aggregate relationship */
  purchase_order_items_aggregate: Purchase_Order_Items_Aggregate;
  /** fetch data from the table: "purchase_order_items" using primary key columns */
  purchase_order_items_by_pk?: Maybe<Purchase_Order_Items>;
  /** fetch data from the table in a streaming manner: "purchase_order_items" */
  purchase_order_items_stream: Array<Purchase_Order_Items>;
  /** fetch data from the table in a streaming manner: "purchase_order" */
  purchase_order_stream: Array<Purchase_Order>;
  /** fetch data from the table: "quantity_correction_ticket_states" */
  quantity_correction_ticket_states: Array<Quantity_Correction_Ticket_States>;
  /** fetch aggregated fields from the table: "quantity_correction_ticket_states" */
  quantity_correction_ticket_states_aggregate: Quantity_Correction_Ticket_States_Aggregate;
  /** fetch data from the table: "quantity_correction_ticket_states" using primary key columns */
  quantity_correction_ticket_states_by_pk?: Maybe<Quantity_Correction_Ticket_States>;
  /** fetch data from the table in a streaming manner: "quantity_correction_ticket_states" */
  quantity_correction_ticket_states_stream: Array<Quantity_Correction_Ticket_States>;
  /** An array relationship */
  quantity_correction_tickets: Array<Quantity_Correction_Tickets>;
  /** An aggregate relationship */
  quantity_correction_tickets_aggregate: Quantity_Correction_Tickets_Aggregate;
  /** fetch data from the table: "quantity_correction_tickets" using primary key columns */
  quantity_correction_tickets_by_pk?: Maybe<Quantity_Correction_Tickets>;
  /** fetch data from the table in a streaming manner: "quantity_correction_tickets" */
  quantity_correction_tickets_stream: Array<Quantity_Correction_Tickets>;
  /** fetch data from the table: "reason_type" */
  reason_type: Array<Reason_Type>;
  /** fetch aggregated fields from the table: "reason_type" */
  reason_type_aggregate: Reason_Type_Aggregate;
  /** fetch data from the table: "reason_type" using primary key columns */
  reason_type_by_pk?: Maybe<Reason_Type>;
  /** fetch data from the table in a streaming manner: "reason_type" */
  reason_type_stream: Array<Reason_Type>;
  /** An array relationship */
  reasons: Array<Reasons>;
  /** An aggregate relationship */
  reasons_aggregate: Reasons_Aggregate;
  /** fetch data from the table: "reasons" using primary key columns */
  reasons_by_pk?: Maybe<Reasons>;
  /** fetch data from the table in a streaming manner: "reasons" */
  reasons_stream: Array<Reasons>;
  /** fetch data from the table: "role" */
  role: Array<Role>;
  /** fetch aggregated fields from the table: "role" */
  role_aggregate: Role_Aggregate;
  /** fetch data from the table: "role" using primary key columns */
  role_by_pk?: Maybe<Role>;
  /** fetch data from the table: "role_document" */
  role_document: Array<Role_Document>;
  /** fetch aggregated fields from the table: "role_document" */
  role_document_aggregate: Role_Document_Aggregate;
  /** fetch data from the table: "role_document" using primary key columns */
  role_document_by_pk?: Maybe<Role_Document>;
  /** fetch data from the table in a streaming manner: "role_document" */
  role_document_stream: Array<Role_Document>;
  /** fetch data from the table in a streaming manner: "role" */
  role_stream: Array<Role>;
  /** fetch data from the table: "safety_checklist" */
  safety_checklist: Array<Safety_Checklist>;
  /** fetch aggregated fields from the table: "safety_checklist" */
  safety_checklist_aggregate: Safety_Checklist_Aggregate;
  /** fetch data from the table: "safety_checklist" using primary key columns */
  safety_checklist_by_pk?: Maybe<Safety_Checklist>;
  /** fetch data from the table: "safety_checklist_category" */
  safety_checklist_category: Array<Safety_Checklist_Category>;
  /** fetch aggregated fields from the table: "safety_checklist_category" */
  safety_checklist_category_aggregate: Safety_Checklist_Category_Aggregate;
  /** fetch data from the table: "safety_checklist_category" using primary key columns */
  safety_checklist_category_by_pk?: Maybe<Safety_Checklist_Category>;
  /** fetch data from the table in a streaming manner: "safety_checklist_category" */
  safety_checklist_category_stream: Array<Safety_Checklist_Category>;
  /** fetch data from the table in a streaming manner: "safety_checklist" */
  safety_checklist_stream: Array<Safety_Checklist>;
  /** fetch data from the table: "script_type" */
  script_type: Array<Script_Type>;
  /** fetch aggregated fields from the table: "script_type" */
  script_type_aggregate: Script_Type_Aggregate;
  /** fetch data from the table: "script_type" using primary key columns */
  script_type_by_pk?: Maybe<Script_Type>;
  /** fetch data from the table in a streaming manner: "script_type" */
  script_type_stream: Array<Script_Type>;
  /** An array relationship */
  scripts: Array<Scripts>;
  /** An aggregate relationship */
  scripts_aggregate: Scripts_Aggregate;
  /** fetch data from the table: "scripts" using primary key columns */
  scripts_by_pk?: Maybe<Scripts>;
  /** fetch data from the table in a streaming manner: "scripts" */
  scripts_stream: Array<Scripts>;
  /** fetch data from the table: "services" */
  services: Array<Services>;
  /** fetch aggregated fields from the table: "services" */
  services_aggregate: Services_Aggregate;
  /** fetch data from the table: "services" using primary key columns */
  services_by_pk?: Maybe<Services>;
  /** fetch data from the table: "services_category" */
  services_category: Array<Services_Category>;
  /** fetch aggregated fields from the table: "services_category" */
  services_category_aggregate: Services_Category_Aggregate;
  /** fetch data from the table: "services_category" using primary key columns */
  services_category_by_pk?: Maybe<Services_Category>;
  /** fetch data from the table in a streaming manner: "services_category" */
  services_category_stream: Array<Services_Category>;
  /** fetch data from the table in a streaming manner: "services" */
  services_stream: Array<Services>;
  /** fetch data from the table: "shift_schedule" */
  shift_schedule: Array<Shift_Schedule>;
  /** fetch aggregated fields from the table: "shift_schedule" */
  shift_schedule_aggregate: Shift_Schedule_Aggregate;
  /** fetch data from the table: "shift_schedule" using primary key columns */
  shift_schedule_by_pk?: Maybe<Shift_Schedule>;
  /** fetch data from the table: "shift_schedule_dispenser" */
  shift_schedule_dispenser: Array<Shift_Schedule_Dispenser>;
  /** fetch aggregated fields from the table: "shift_schedule_dispenser" */
  shift_schedule_dispenser_aggregate: Shift_Schedule_Dispenser_Aggregate;
  /** fetch data from the table: "shift_schedule_dispenser" using primary key columns */
  shift_schedule_dispenser_by_pk?: Maybe<Shift_Schedule_Dispenser>;
  /** fetch data from the table in a streaming manner: "shift_schedule_dispenser" */
  shift_schedule_dispenser_stream: Array<Shift_Schedule_Dispenser>;
  /** fetch data from the table in a streaming manner: "shift_schedule" */
  shift_schedule_stream: Array<Shift_Schedule>;
  /** fetch data from the table: "shift_template" */
  shift_template: Array<Shift_Template>;
  /** fetch aggregated fields from the table: "shift_template" */
  shift_template_aggregate: Shift_Template_Aggregate;
  /** fetch data from the table: "shift_template" using primary key columns */
  shift_template_by_pk?: Maybe<Shift_Template>;
  /** fetch data from the table in a streaming manner: "shift_template" */
  shift_template_stream: Array<Shift_Template>;
  /** fetch data from the table: "slab_type" */
  slab_type: Array<Slab_Type>;
  /** fetch aggregated fields from the table: "slab_type" */
  slab_type_aggregate: Slab_Type_Aggregate;
  /** fetch data from the table: "slab_type" using primary key columns */
  slab_type_by_pk?: Maybe<Slab_Type>;
  /** fetch data from the table in a streaming manner: "slab_type" */
  slab_type_stream: Array<Slab_Type>;
  /** fetch data from the table: "source_type" */
  source_type: Array<Source_Type>;
  /** fetch aggregated fields from the table: "source_type" */
  source_type_aggregate: Source_Type_Aggregate;
  /** fetch data from the table: "source_type" using primary key columns */
  source_type_by_pk?: Maybe<Source_Type>;
  /** fetch data from the table in a streaming manner: "source_type" */
  source_type_stream: Array<Source_Type>;
  /** fetch data from the table: "spatial_ref_sys" */
  spatial_ref_sys: Array<Spatial_Ref_Sys>;
  /** fetch aggregated fields from the table: "spatial_ref_sys" */
  spatial_ref_sys_aggregate: Spatial_Ref_Sys_Aggregate;
  /** fetch data from the table: "spatial_ref_sys" using primary key columns */
  spatial_ref_sys_by_pk?: Maybe<Spatial_Ref_Sys>;
  /** fetch data from the table in a streaming manner: "spatial_ref_sys" */
  spatial_ref_sys_stream: Array<Spatial_Ref_Sys>;
  /** fetch data from the table: "state" */
  state: Array<State>;
  /** fetch aggregated fields from the table: "state" */
  state_aggregate: State_Aggregate;
  /** fetch data from the table: "state" using primary key columns */
  state_by_pk?: Maybe<State>;
  /** fetch data from the table in a streaming manner: "state" */
  state_stream: Array<State>;
  /** fetch data from the table: "subsidiary" */
  subsidiary: Array<Subsidiary>;
  /** fetch aggregated fields from the table: "subsidiary" */
  subsidiary_aggregate: Subsidiary_Aggregate;
  /** fetch data from the table: "subsidiary" using primary key columns */
  subsidiary_by_pk?: Maybe<Subsidiary>;
  /** fetch data from the table in a streaming manner: "subsidiary" */
  subsidiary_stream: Array<Subsidiary>;
  /** An array relationship */
  support_tickets: Array<Support_Tickets>;
  /** An aggregate relationship */
  support_tickets_aggregate: Support_Tickets_Aggregate;
  /** fetch data from the table: "support_tickets" using primary key columns */
  support_tickets_by_pk?: Maybe<Support_Tickets>;
  /** fetch data from the table: "support_tickets_category" */
  support_tickets_category: Array<Support_Tickets_Category>;
  /** fetch aggregated fields from the table: "support_tickets_category" */
  support_tickets_category_aggregate: Support_Tickets_Category_Aggregate;
  /** fetch data from the table: "support_tickets_category" using primary key columns */
  support_tickets_category_by_pk?: Maybe<Support_Tickets_Category>;
  /** fetch data from the table in a streaming manner: "support_tickets_category" */
  support_tickets_category_stream: Array<Support_Tickets_Category>;
  /** An array relationship */
  support_tickets_photos: Array<Support_Tickets_Photos>;
  /** An aggregate relationship */
  support_tickets_photos_aggregate: Support_Tickets_Photos_Aggregate;
  /** fetch data from the table: "support_tickets_photos" using primary key columns */
  support_tickets_photos_by_pk?: Maybe<Support_Tickets_Photos>;
  /** fetch data from the table in a streaming manner: "support_tickets_photos" */
  support_tickets_photos_stream: Array<Support_Tickets_Photos>;
  /** fetch data from the table in a streaming manner: "support_tickets" */
  support_tickets_stream: Array<Support_Tickets>;
  /** fetch data from the table: "tag" */
  tag: Array<Tag>;
  /** fetch aggregated fields from the table: "tag" */
  tag_aggregate: Tag_Aggregate;
  /** fetch data from the table: "tag" using primary key columns */
  tag_by_pk?: Maybe<Tag>;
  /** fetch data from the table in a streaming manner: "tag" */
  tag_stream: Array<Tag>;
  /** fetch data from the table: "tank_type" */
  tank_type: Array<Tank_Type>;
  /** fetch aggregated fields from the table: "tank_type" */
  tank_type_aggregate: Tank_Type_Aggregate;
  /** fetch data from the table: "tank_type" using primary key columns */
  tank_type_by_pk?: Maybe<Tank_Type>;
  /** fetch data from the table in a streaming manner: "tank_type" */
  tank_type_stream: Array<Tank_Type>;
  /** fetch data from the table: "task" */
  task: Array<Task>;
  /** fetch data from the table: "task_action_instruction" */
  task_action_instruction: Array<Task_Action_Instruction>;
  /** fetch aggregated fields from the table: "task_action_instruction" */
  task_action_instruction_aggregate: Task_Action_Instruction_Aggregate;
  /** fetch data from the table: "task_action_instruction" using primary key columns */
  task_action_instruction_by_pk?: Maybe<Task_Action_Instruction>;
  /** fetch data from the table in a streaming manner: "task_action_instruction" */
  task_action_instruction_stream: Array<Task_Action_Instruction>;
  /** fetch data from the table: "task_action_type" */
  task_action_type: Array<Task_Action_Type>;
  /** fetch aggregated fields from the table: "task_action_type" */
  task_action_type_aggregate: Task_Action_Type_Aggregate;
  /** fetch data from the table: "task_action_type" using primary key columns */
  task_action_type_by_pk?: Maybe<Task_Action_Type>;
  /** fetch data from the table in a streaming manner: "task_action_type" */
  task_action_type_stream: Array<Task_Action_Type>;
  /** fetch aggregated fields from the table: "task" */
  task_aggregate: Task_Aggregate;
  /** fetch data from the table: "task" using primary key columns */
  task_by_pk?: Maybe<Task>;
  /** An array relationship */
  task_cancellation_reasons: Array<Task_Cancellation_Reasons>;
  /** An aggregate relationship */
  task_cancellation_reasons_aggregate: Task_Cancellation_Reasons_Aggregate;
  /** fetch data from the table: "task_cancellation_reasons" using primary key columns */
  task_cancellation_reasons_by_pk?: Maybe<Task_Cancellation_Reasons>;
  /** fetch data from the table in a streaming manner: "task_cancellation_reasons" */
  task_cancellation_reasons_stream: Array<Task_Cancellation_Reasons>;
  /** fetch data from the table: "task_state" */
  task_state: Array<Task_State>;
  /** fetch aggregated fields from the table: "task_state" */
  task_state_aggregate: Task_State_Aggregate;
  /** fetch data from the table: "task_state" using primary key columns */
  task_state_by_pk?: Maybe<Task_State>;
  /** fetch data from the table in a streaming manner: "task_state" */
  task_state_stream: Array<Task_State>;
  /** fetch data from the table: "task_states_flow" */
  task_states_flow: Array<Task_States_Flow>;
  /** fetch aggregated fields from the table: "task_states_flow" */
  task_states_flow_aggregate: Task_States_Flow_Aggregate;
  /** fetch data from the table: "task_states_flow" using primary key columns */
  task_states_flow_by_pk?: Maybe<Task_States_Flow>;
  /** fetch data from the table in a streaming manner: "task_states_flow" */
  task_states_flow_stream: Array<Task_States_Flow>;
  /** fetch data from the table in a streaming manner: "task" */
  task_stream: Array<Task>;
  /** fetch data from the table: "task_type" */
  task_type: Array<Task_Type>;
  /** fetch aggregated fields from the table: "task_type" */
  task_type_aggregate: Task_Type_Aggregate;
  /** fetch data from the table: "task_type" using primary key columns */
  task_type_by_pk?: Maybe<Task_Type>;
  /** fetch data from the table in a streaming manner: "task_type" */
  task_type_stream: Array<Task_Type>;
  /** fetch data from the table: "task_value" */
  task_value: Array<Task_Value>;
  /** fetch aggregated fields from the table: "task_value" */
  task_value_aggregate: Task_Value_Aggregate;
  /** fetch data from the table: "task_value" using primary key columns */
  task_value_by_pk?: Maybe<Task_Value>;
  /** fetch data from the table in a streaming manner: "task_value" */
  task_value_stream: Array<Task_Value>;
  /** fetch data from the table: "test" */
  test: Array<Test>;
  /** fetch aggregated fields from the table: "test" */
  test_aggregate: Test_Aggregate;
  /** fetch data from the table: "test" using primary key columns */
  test_by_pk?: Maybe<Test>;
  /** fetch data from the table: "test_category" */
  test_category: Array<Test_Category>;
  /** fetch aggregated fields from the table: "test_category" */
  test_category_aggregate: Test_Category_Aggregate;
  /** fetch data from the table: "test_category" using primary key columns */
  test_category_by_pk?: Maybe<Test_Category>;
  /** fetch data from the table in a streaming manner: "test_category" */
  test_category_stream: Array<Test_Category>;
  /** fetch data from the table in a streaming manner: "test" */
  test_stream: Array<Test>;
  /** fetch data from the table: "ticket_state" */
  ticket_state: Array<Ticket_State>;
  /** fetch aggregated fields from the table: "ticket_state" */
  ticket_state_aggregate: Ticket_State_Aggregate;
  /** fetch data from the table: "ticket_state" using primary key columns */
  ticket_state_by_pk?: Maybe<Ticket_State>;
  /** fetch data from the table in a streaming manner: "ticket_state" */
  ticket_state_stream: Array<Ticket_State>;
  /** fetch data from the table: "ticket_type" */
  ticket_type: Array<Ticket_Type>;
  /** fetch aggregated fields from the table: "ticket_type" */
  ticket_type_aggregate: Ticket_Type_Aggregate;
  /** fetch data from the table: "ticket_type" using primary key columns */
  ticket_type_by_pk?: Maybe<Ticket_Type>;
  /** fetch data from the table in a streaming manner: "ticket_type" */
  ticket_type_stream: Array<Ticket_Type>;
  /** An array relationship */
  tickets: Array<Tickets>;
  /** An aggregate relationship */
  tickets_aggregate: Tickets_Aggregate;
  /** fetch data from the table: "tickets" using primary key columns */
  tickets_by_pk?: Maybe<Tickets>;
  /** fetch data from the table in a streaming manner: "tickets" */
  tickets_stream: Array<Tickets>;
  /** fetch data from the table: "totalizer_correction_ticket_states" */
  totalizer_correction_ticket_states: Array<Totalizer_Correction_Ticket_States>;
  /** fetch aggregated fields from the table: "totalizer_correction_ticket_states" */
  totalizer_correction_ticket_states_aggregate: Totalizer_Correction_Ticket_States_Aggregate;
  /** fetch data from the table: "totalizer_correction_ticket_states" using primary key columns */
  totalizer_correction_ticket_states_by_pk?: Maybe<Totalizer_Correction_Ticket_States>;
  /** fetch data from the table in a streaming manner: "totalizer_correction_ticket_states" */
  totalizer_correction_ticket_states_stream: Array<Totalizer_Correction_Ticket_States>;
  /** An array relationship */
  totalizer_correction_tickets: Array<Totalizer_Correction_Tickets>;
  /** An aggregate relationship */
  totalizer_correction_tickets_aggregate: Totalizer_Correction_Tickets_Aggregate;
  /** fetch data from the table: "totalizer_correction_tickets" using primary key columns */
  totalizer_correction_tickets_by_pk?: Maybe<Totalizer_Correction_Tickets>;
  /** fetch data from the table in a streaming manner: "totalizer_correction_tickets" */
  totalizer_correction_tickets_stream: Array<Totalizer_Correction_Tickets>;
  /** fetch data from the table: "transaction_type" */
  transaction_type: Array<Transaction_Type>;
  /** fetch aggregated fields from the table: "transaction_type" */
  transaction_type_aggregate: Transaction_Type_Aggregate;
  /** fetch data from the table: "transaction_type" using primary key columns */
  transaction_type_by_pk?: Maybe<Transaction_Type>;
  /** fetch data from the table in a streaming manner: "transaction_type" */
  transaction_type_stream: Array<Transaction_Type>;
  /** fetch data from the table: "trip" */
  trip: Array<Trip>;
  /** fetch aggregated fields from the table: "trip" */
  trip_aggregate: Trip_Aggregate;
  /** fetch data from the table: "trip" using primary key columns */
  trip_by_pk?: Maybe<Trip>;
  /** fetch data from the table: "trip_location" */
  trip_location: Array<Trip_Location>;
  /** fetch aggregated fields from the table: "trip_location" */
  trip_location_aggregate: Trip_Location_Aggregate;
  /** fetch data from the table: "trip_location" using primary key columns */
  trip_location_by_pk?: Maybe<Trip_Location>;
  /** fetch data from the table in a streaming manner: "trip_location" */
  trip_location_stream: Array<Trip_Location>;
  /** fetch data from the table: "trip_plan" */
  trip_plan: Array<Trip_Plan>;
  /** fetch aggregated fields from the table: "trip_plan" */
  trip_plan_aggregate: Trip_Plan_Aggregate;
  /** fetch data from the table: "trip_plan" using primary key columns */
  trip_plan_by_pk?: Maybe<Trip_Plan>;
  /** fetch data from the table in a streaming manner: "trip_plan" */
  trip_plan_stream: Array<Trip_Plan>;
  /** fetch data from the table in a streaming manner: "trip" */
  trip_stream: Array<Trip>;
  /** fetch data from the table: "unit_of_measure" */
  unit_of_measure: Array<Unit_Of_Measure>;
  /** fetch aggregated fields from the table: "unit_of_measure" */
  unit_of_measure_aggregate: Unit_Of_Measure_Aggregate;
  /** fetch data from the table: "unit_of_measure" using primary key columns */
  unit_of_measure_by_pk?: Maybe<Unit_Of_Measure>;
  /** fetch data from the table: "unit_of_measure_meta" */
  unit_of_measure_meta: Array<Unit_Of_Measure_Meta>;
  /** fetch aggregated fields from the table: "unit_of_measure_meta" */
  unit_of_measure_meta_aggregate: Unit_Of_Measure_Meta_Aggregate;
  /** fetch data from the table: "unit_of_measure_meta" using primary key columns */
  unit_of_measure_meta_by_pk?: Maybe<Unit_Of_Measure_Meta>;
  /** fetch data from the table in a streaming manner: "unit_of_measure_meta" */
  unit_of_measure_meta_stream: Array<Unit_Of_Measure_Meta>;
  /** fetch data from the table in a streaming manner: "unit_of_measure" */
  unit_of_measure_stream: Array<Unit_Of_Measure>;
  /** fetch data from the table: "uom_conversion" */
  uom_conversion: Array<Uom_Conversion>;
  /** fetch aggregated fields from the table: "uom_conversion" */
  uom_conversion_aggregate: Uom_Conversion_Aggregate;
  /** fetch data from the table: "uom_conversion" using primary key columns */
  uom_conversion_by_pk?: Maybe<Uom_Conversion>;
  /** fetch data from the table in a streaming manner: "uom_conversion" */
  uom_conversion_stream: Array<Uom_Conversion>;
  /** fetch data from the table: "user" */
  user: Array<User>;
  /** fetch data from the table: "user_access_audit_log" */
  user_access_audit_log: Array<User_Access_Audit_Log>;
  /** fetch aggregated fields from the table: "user_access_audit_log" */
  user_access_audit_log_aggregate: User_Access_Audit_Log_Aggregate;
  /** fetch data from the table: "user_access_audit_log" using primary key columns */
  user_access_audit_log_by_pk?: Maybe<User_Access_Audit_Log>;
  /** fetch data from the table in a streaming manner: "user_access_audit_log" */
  user_access_audit_log_stream: Array<User_Access_Audit_Log>;
  /** fetch aggregated fields from the table: "user" */
  user_aggregate: User_Aggregate;
  /** fetch data from the table: "user" using primary key columns */
  user_by_pk?: Maybe<User>;
  /** fetch data from the table: "user_ledger" */
  user_ledger: Array<User_Ledger>;
  /** fetch aggregated fields from the table: "user_ledger" */
  user_ledger_aggregate: User_Ledger_Aggregate;
  /** fetch data from the table: "user_ledger" using primary key columns */
  user_ledger_by_pk?: Maybe<User_Ledger>;
  /** fetch data from the table in a streaming manner: "user_ledger" */
  user_ledger_stream: Array<User_Ledger>;
  /** fetch data from the table: "user_partner_type" */
  user_partner_type: Array<User_Partner_Type>;
  /** fetch aggregated fields from the table: "user_partner_type" */
  user_partner_type_aggregate: User_Partner_Type_Aggregate;
  /** fetch data from the table: "user_partner_type" using primary key columns */
  user_partner_type_by_pk?: Maybe<User_Partner_Type>;
  /** fetch data from the table in a streaming manner: "user_partner_type" */
  user_partner_type_stream: Array<User_Partner_Type>;
  /** fetch data from the table: "user_referral" */
  user_referral: Array<User_Referral>;
  /** fetch aggregated fields from the table: "user_referral" */
  user_referral_aggregate: User_Referral_Aggregate;
  /** fetch data from the table: "user_referral" using primary key columns */
  user_referral_by_pk?: Maybe<User_Referral>;
  /** fetch data from the table in a streaming manner: "user_referral" */
  user_referral_stream: Array<User_Referral>;
  /** fetch data from the table: "user_role" */
  user_role: Array<User_Role>;
  /** fetch aggregated fields from the table: "user_role" */
  user_role_aggregate: User_Role_Aggregate;
  /** fetch data from the table: "user_role" using primary key columns */
  user_role_by_pk?: Maybe<User_Role>;
  /** fetch data from the table in a streaming manner: "user_role" */
  user_role_stream: Array<User_Role>;
  /** fetch data from the table in a streaming manner: "user" */
  user_stream: Array<User>;
  /** An array relationship */
  validation_workflows: Array<Validation_Workflows>;
  /** An aggregate relationship */
  validation_workflows_aggregate: Validation_Workflows_Aggregate;
  /** fetch data from the table: "validation_workflows" using primary key columns */
  validation_workflows_by_pk?: Maybe<Validation_Workflows>;
  /** fetch data from the table in a streaming manner: "validation_workflows" */
  validation_workflows_stream: Array<Validation_Workflows>;
  /** fetch data from the table: "variation" */
  variation: Array<Variation>;
  /** fetch aggregated fields from the table: "variation" */
  variation_aggregate: Variation_Aggregate;
  /** fetch data from the table: "variation" using primary key columns */
  variation_by_pk?: Maybe<Variation>;
  /** fetch data from the table in a streaming manner: "variation" */
  variation_stream: Array<Variation>;
  /** fetch data from the table: "variation_type" */
  variation_type: Array<Variation_Type>;
  /** fetch aggregated fields from the table: "variation_type" */
  variation_type_aggregate: Variation_Type_Aggregate;
  /** fetch data from the table: "variation_type" using primary key columns */
  variation_type_by_pk?: Maybe<Variation_Type>;
  /** fetch data from the table in a streaming manner: "variation_type" */
  variation_type_stream: Array<Variation_Type>;
  /** fetch data from the table: "vehicle" */
  vehicle: Array<Vehicle>;
  /** fetch aggregated fields from the table: "vehicle" */
  vehicle_aggregate: Vehicle_Aggregate;
  /** fetch data from the table: "vehicle" using primary key columns */
  vehicle_by_pk?: Maybe<Vehicle>;
  /** fetch data from the table: "vehicle_configuration" */
  vehicle_configuration: Array<Vehicle_Configuration>;
  /** fetch aggregated fields from the table: "vehicle_configuration" */
  vehicle_configuration_aggregate: Vehicle_Configuration_Aggregate;
  /** fetch data from the table: "vehicle_configuration" using primary key columns */
  vehicle_configuration_by_pk?: Maybe<Vehicle_Configuration>;
  /** fetch data from the table in a streaming manner: "vehicle_configuration" */
  vehicle_configuration_stream: Array<Vehicle_Configuration>;
  /** fetch data from the table: "vehicle_device" */
  vehicle_device: Array<Vehicle_Device>;
  /** fetch aggregated fields from the table: "vehicle_device" */
  vehicle_device_aggregate: Vehicle_Device_Aggregate;
  /** fetch data from the table: "vehicle_device" using primary key columns */
  vehicle_device_by_pk?: Maybe<Vehicle_Device>;
  /** fetch data from the table: "vehicle_device_calibration" */
  vehicle_device_calibration: Array<Vehicle_Device_Calibration>;
  /** fetch aggregated fields from the table: "vehicle_device_calibration" */
  vehicle_device_calibration_aggregate: Vehicle_Device_Calibration_Aggregate;
  /** fetch data from the table: "vehicle_device_calibration" using primary key columns */
  vehicle_device_calibration_by_pk?: Maybe<Vehicle_Device_Calibration>;
  /** fetch data from the table in a streaming manner: "vehicle_device_calibration" */
  vehicle_device_calibration_stream: Array<Vehicle_Device_Calibration>;
  /** fetch data from the table in a streaming manner: "vehicle_device" */
  vehicle_device_stream: Array<Vehicle_Device>;
  /** An array relationship */
  vehicle_inventory_transaction_logs: Array<Vehicle_Inventory_Transaction_Logs>;
  /** An aggregate relationship */
  vehicle_inventory_transaction_logs_aggregate: Vehicle_Inventory_Transaction_Logs_Aggregate;
  /** fetch data from the table: "vehicle_inventory_transaction_logs" using primary key columns */
  vehicle_inventory_transaction_logs_by_pk?: Maybe<Vehicle_Inventory_Transaction_Logs>;
  /** fetch data from the table in a streaming manner: "vehicle_inventory_transaction_logs" */
  vehicle_inventory_transaction_logs_stream: Array<Vehicle_Inventory_Transaction_Logs>;
  /** An array relationship */
  vehicle_localities: Array<Vehicle_Localities>;
  /** An aggregate relationship */
  vehicle_localities_aggregate: Vehicle_Localities_Aggregate;
  /** fetch data from the table: "vehicle_localities" using primary key columns */
  vehicle_localities_by_pk?: Maybe<Vehicle_Localities>;
  /** fetch data from the table in a streaming manner: "vehicle_localities" */
  vehicle_localities_stream: Array<Vehicle_Localities>;
  /** fetch data from the table: "vehicle_permit" */
  vehicle_permit: Array<Vehicle_Permit>;
  /** fetch aggregated fields from the table: "vehicle_permit" */
  vehicle_permit_aggregate: Vehicle_Permit_Aggregate;
  /** fetch data from the table: "vehicle_permit" using primary key columns */
  vehicle_permit_by_pk?: Maybe<Vehicle_Permit>;
  /** fetch data from the table in a streaming manner: "vehicle_permit" */
  vehicle_permit_stream: Array<Vehicle_Permit>;
  /** fetch data from the table: "vehicle_shift_template" */
  vehicle_shift_template: Array<Vehicle_Shift_Template>;
  /** fetch aggregated fields from the table: "vehicle_shift_template" */
  vehicle_shift_template_aggregate: Vehicle_Shift_Template_Aggregate;
  /** fetch data from the table: "vehicle_shift_template" using primary key columns */
  vehicle_shift_template_by_pk?: Maybe<Vehicle_Shift_Template>;
  /** fetch data from the table in a streaming manner: "vehicle_shift_template" */
  vehicle_shift_template_stream: Array<Vehicle_Shift_Template>;
  /** fetch data from the table: "vehicle_status" */
  vehicle_status: Array<Vehicle_Status>;
  /** fetch aggregated fields from the table: "vehicle_status" */
  vehicle_status_aggregate: Vehicle_Status_Aggregate;
  /** fetch data from the table: "vehicle_status" using primary key columns */
  vehicle_status_by_pk?: Maybe<Vehicle_Status>;
  /** An array relationship */
  vehicle_status_logs: Array<Vehicle_Status_Logs>;
  /** An aggregate relationship */
  vehicle_status_logs_aggregate: Vehicle_Status_Logs_Aggregate;
  /** fetch data from the table: "vehicle_status_logs" using primary key columns */
  vehicle_status_logs_by_pk?: Maybe<Vehicle_Status_Logs>;
  /** fetch data from the table in a streaming manner: "vehicle_status_logs" */
  vehicle_status_logs_stream: Array<Vehicle_Status_Logs>;
  /** fetch data from the table in a streaming manner: "vehicle_status" */
  vehicle_status_stream: Array<Vehicle_Status>;
  /** fetch data from the table in a streaming manner: "vehicle" */
  vehicle_stream: Array<Vehicle>;
  /** fetch data from the table: "vehicle_tank_type" */
  vehicle_tank_type: Array<Vehicle_Tank_Type>;
  /** fetch aggregated fields from the table: "vehicle_tank_type" */
  vehicle_tank_type_aggregate: Vehicle_Tank_Type_Aggregate;
  /** fetch data from the table: "vehicle_tank_type" using primary key columns */
  vehicle_tank_type_by_pk?: Maybe<Vehicle_Tank_Type>;
  /** fetch data from the table: "vehicle_tank_type_product_variation" */
  vehicle_tank_type_product_variation: Array<Vehicle_Tank_Type_Product_Variation>;
  /** fetch aggregated fields from the table: "vehicle_tank_type_product_variation" */
  vehicle_tank_type_product_variation_aggregate: Vehicle_Tank_Type_Product_Variation_Aggregate;
  /** fetch data from the table: "vehicle_tank_type_product_variation" using primary key columns */
  vehicle_tank_type_product_variation_by_pk?: Maybe<Vehicle_Tank_Type_Product_Variation>;
  /** fetch data from the table in a streaming manner: "vehicle_tank_type_product_variation" */
  vehicle_tank_type_product_variation_stream: Array<Vehicle_Tank_Type_Product_Variation>;
  /** fetch data from the table in a streaming manner: "vehicle_tank_type" */
  vehicle_tank_type_stream: Array<Vehicle_Tank_Type>;
  /** fetch data from the table: "vehicle_type" */
  vehicle_type: Array<Vehicle_Type>;
  /** fetch aggregated fields from the table: "vehicle_type" */
  vehicle_type_aggregate: Vehicle_Type_Aggregate;
  /** fetch data from the table: "vehicle_type" using primary key columns */
  vehicle_type_by_pk?: Maybe<Vehicle_Type>;
  /** fetch data from the table in a streaming manner: "vehicle_type" */
  vehicle_type_stream: Array<Vehicle_Type>;
  /** An array relationship */
  vendor_order_logs: Array<Vendor_Order_Logs>;
  /** An aggregate relationship */
  vendor_order_logs_aggregate: Vendor_Order_Logs_Aggregate;
  /** fetch data from the table: "vendor_order_logs" using primary key columns */
  vendor_order_logs_by_pk?: Maybe<Vendor_Order_Logs>;
  /** fetch data from the table in a streaming manner: "vendor_order_logs" */
  vendor_order_logs_stream: Array<Vendor_Order_Logs>;
  /** fetch data from the table: "vendor_sync_status" */
  vendor_sync_status: Array<Vendor_Sync_Status>;
  /** fetch aggregated fields from the table: "vendor_sync_status" */
  vendor_sync_status_aggregate: Vendor_Sync_Status_Aggregate;
  /** fetch data from the table: "vendor_sync_status" using primary key columns */
  vendor_sync_status_by_pk?: Maybe<Vendor_Sync_Status>;
  /** fetch data from the table in a streaming manner: "vendor_sync_status" */
  vendor_sync_status_stream: Array<Vendor_Sync_Status>;
  /** An array relationship */
  view_daily_asset_limit: Array<View_Daily_Asset_Limit>;
  /** An aggregate relationship */
  view_daily_asset_limit_aggregate: View_Daily_Asset_Limit_Aggregate;
  /** fetch data from the table in a streaming manner: "view_daily_asset_limit" */
  view_daily_asset_limit_stream: Array<View_Daily_Asset_Limit>;
  /** An array relationship */
  view_monthly_asset_limit: Array<View_Monthly_Asset_Limit>;
  /** An aggregate relationship */
  view_monthly_asset_limit_aggregate: View_Monthly_Asset_Limit_Aggregate;
  /** fetch data from the table in a streaming manner: "view_monthly_asset_limit" */
  view_monthly_asset_limit_stream: Array<View_Monthly_Asset_Limit>;
  /** fetch data from the table: "view_unlinked_customer_assets" */
  view_unlinked_customer_assets: Array<View_Unlinked_Customer_Assets>;
  /** fetch aggregated fields from the table: "view_unlinked_customer_assets" */
  view_unlinked_customer_assets_aggregate: View_Unlinked_Customer_Assets_Aggregate;
  /** fetch data from the table in a streaming manner: "view_unlinked_customer_assets" */
  view_unlinked_customer_assets_stream: Array<View_Unlinked_Customer_Assets>;
  /** An array relationship */
  view_weekly_asset_limit: Array<View_Weekly_Asset_Limit>;
  /** An aggregate relationship */
  view_weekly_asset_limit_aggregate: View_Weekly_Asset_Limit_Aggregate;
  /** fetch data from the table in a streaming manner: "view_weekly_asset_limit" */
  view_weekly_asset_limit_stream: Array<View_Weekly_Asset_Limit>;
  /** fetch data from the table: "voucher" */
  voucher: Array<Voucher>;
  /** fetch aggregated fields from the table: "voucher" */
  voucher_aggregate: Voucher_Aggregate;
  /** fetch data from the table: "voucher" using primary key columns */
  voucher_by_pk?: Maybe<Voucher>;
  /** fetch data from the table in a streaming manner: "voucher" */
  voucher_stream: Array<Voucher>;
  /** fetch data from the table: "wallet" */
  wallet: Array<Wallet>;
  /** fetch aggregated fields from the table: "wallet" */
  wallet_aggregate: Wallet_Aggregate;
  /** fetch data from the table: "wallet" using primary key columns */
  wallet_by_pk?: Maybe<Wallet>;
  /** fetch data from the table: "wallet_exception" */
  wallet_exception: Array<Wallet_Exception>;
  /** fetch aggregated fields from the table: "wallet_exception" */
  wallet_exception_aggregate: Wallet_Exception_Aggregate;
  /** fetch data from the table: "wallet_exception" using primary key columns */
  wallet_exception_by_pk?: Maybe<Wallet_Exception>;
  /** fetch data from the table in a streaming manner: "wallet_exception" */
  wallet_exception_stream: Array<Wallet_Exception>;
  /** fetch data from the table: "wallet_ledger" */
  wallet_ledger: Array<Wallet_Ledger>;
  /** fetch aggregated fields from the table: "wallet_ledger" */
  wallet_ledger_aggregate: Wallet_Ledger_Aggregate;
  /** fetch data from the table: "wallet_ledger" using primary key columns */
  wallet_ledger_by_pk?: Maybe<Wallet_Ledger>;
  /** fetch data from the table in a streaming manner: "wallet_ledger" */
  wallet_ledger_stream: Array<Wallet_Ledger>;
  /** fetch data from the table: "wallet_state" */
  wallet_state: Array<Wallet_State>;
  /** fetch aggregated fields from the table: "wallet_state" */
  wallet_state_aggregate: Wallet_State_Aggregate;
  /** fetch data from the table: "wallet_state" using primary key columns */
  wallet_state_by_pk?: Maybe<Wallet_State>;
  /** fetch data from the table in a streaming manner: "wallet_state" */
  wallet_state_stream: Array<Wallet_State>;
  /** fetch data from the table in a streaming manner: "wallet" */
  wallet_stream: Array<Wallet>;
  /** An array relationship */
  wallet_transactions: Array<Wallet_Transactions>;
  /** An aggregate relationship */
  wallet_transactions_aggregate: Wallet_Transactions_Aggregate;
  /** fetch data from the table: "wallet_transactions" using primary key columns */
  wallet_transactions_by_pk?: Maybe<Wallet_Transactions>;
  /** fetch data from the table in a streaming manner: "wallet_transactions" */
  wallet_transactions_stream: Array<Wallet_Transactions>;
};


export type Subscription_RootSmartRefueler_DispencerLocationArgs = {
  distinct_on?: InputMaybe<Array<SmartRefueler_DispencerLocation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SmartRefueler_DispencerLocation_Order_By>>;
  where?: InputMaybe<SmartRefueler_DispencerLocation_Bool_Exp>;
};


export type Subscription_RootSmartRefueler_DispencerLocation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SmartRefueler_DispencerLocation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SmartRefueler_DispencerLocation_Order_By>>;
  where?: InputMaybe<SmartRefueler_DispencerLocation_Bool_Exp>;
};


export type Subscription_RootAddress_SubsidiaryArgs = {
  distinct_on?: InputMaybe<Array<Address_Subsidiary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Address_Subsidiary_Order_By>>;
  where?: InputMaybe<Address_Subsidiary_Bool_Exp>;
};


export type Subscription_RootAddress_Subsidiary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Subsidiary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Address_Subsidiary_Order_By>>;
  where?: InputMaybe<Address_Subsidiary_Bool_Exp>;
};


export type Subscription_RootAddress_Subsidiary_Audit_LogsArgs = {
  distinct_on?: InputMaybe<Array<Address_Subsidiary_Audit_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Address_Subsidiary_Audit_Logs_Order_By>>;
  where?: InputMaybe<Address_Subsidiary_Audit_Logs_Bool_Exp>;
};


export type Subscription_RootAddress_Subsidiary_Audit_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Subsidiary_Audit_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Address_Subsidiary_Audit_Logs_Order_By>>;
  where?: InputMaybe<Address_Subsidiary_Audit_Logs_Bool_Exp>;
};


export type Subscription_RootAddress_Subsidiary_Audit_Logs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAddress_Subsidiary_Audit_Logs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Address_Subsidiary_Audit_Logs_Stream_Cursor_Input>>;
  where?: InputMaybe<Address_Subsidiary_Audit_Logs_Bool_Exp>;
};


export type Subscription_RootAddress_Subsidiary_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAddress_Subsidiary_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Address_Subsidiary_Stream_Cursor_Input>>;
  where?: InputMaybe<Address_Subsidiary_Bool_Exp>;
};


export type Subscription_RootAddress_TypeArgs = {
  distinct_on?: InputMaybe<Array<Address_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Address_Type_Order_By>>;
  where?: InputMaybe<Address_Type_Bool_Exp>;
};


export type Subscription_RootAddress_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Address_Type_Order_By>>;
  where?: InputMaybe<Address_Type_Bool_Exp>;
};


export type Subscription_RootAddress_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootAddress_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Address_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Address_Type_Bool_Exp>;
};


export type Subscription_RootAsset_GroupingArgs = {
  distinct_on?: InputMaybe<Array<Asset_Grouping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Grouping_Order_By>>;
  where?: InputMaybe<Asset_Grouping_Bool_Exp>;
};


export type Subscription_RootAsset_Grouping_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Grouping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Grouping_Order_By>>;
  where?: InputMaybe<Asset_Grouping_Bool_Exp>;
};


export type Subscription_RootAsset_Grouping_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAsset_Grouping_Customer_AssetArgs = {
  distinct_on?: InputMaybe<Array<Asset_Grouping_Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Grouping_Customer_Asset_Order_By>>;
  where?: InputMaybe<Asset_Grouping_Customer_Asset_Bool_Exp>;
};


export type Subscription_RootAsset_Grouping_Customer_Asset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Grouping_Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Grouping_Customer_Asset_Order_By>>;
  where?: InputMaybe<Asset_Grouping_Customer_Asset_Bool_Exp>;
};


export type Subscription_RootAsset_Grouping_Customer_Asset_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAsset_Grouping_Customer_Asset_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Asset_Grouping_Customer_Asset_Stream_Cursor_Input>>;
  where?: InputMaybe<Asset_Grouping_Customer_Asset_Bool_Exp>;
};


export type Subscription_RootAsset_Grouping_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Asset_Grouping_Stream_Cursor_Input>>;
  where?: InputMaybe<Asset_Grouping_Bool_Exp>;
};


export type Subscription_RootAsset_SubsidiaryArgs = {
  distinct_on?: InputMaybe<Array<Asset_Subsidiary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Subsidiary_Order_By>>;
  where?: InputMaybe<Asset_Subsidiary_Bool_Exp>;
};


export type Subscription_RootAsset_Subsidiary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Subsidiary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Subsidiary_Order_By>>;
  where?: InputMaybe<Asset_Subsidiary_Bool_Exp>;
};


export type Subscription_RootAsset_Subsidiary_Audit_LogsArgs = {
  distinct_on?: InputMaybe<Array<Asset_Subsidiary_Audit_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Subsidiary_Audit_Logs_Order_By>>;
  where?: InputMaybe<Asset_Subsidiary_Audit_Logs_Bool_Exp>;
};


export type Subscription_RootAsset_Subsidiary_Audit_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Subsidiary_Audit_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Subsidiary_Audit_Logs_Order_By>>;
  where?: InputMaybe<Asset_Subsidiary_Audit_Logs_Bool_Exp>;
};


export type Subscription_RootAsset_Subsidiary_Audit_Logs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAsset_Subsidiary_Audit_Logs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Asset_Subsidiary_Audit_Logs_Stream_Cursor_Input>>;
  where?: InputMaybe<Asset_Subsidiary_Audit_Logs_Bool_Exp>;
};


export type Subscription_RootAsset_Subsidiary_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAsset_Subsidiary_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Asset_Subsidiary_Stream_Cursor_Input>>;
  where?: InputMaybe<Asset_Subsidiary_Bool_Exp>;
};


export type Subscription_RootAsset_TypeArgs = {
  distinct_on?: InputMaybe<Array<Asset_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Type_Order_By>>;
  where?: InputMaybe<Asset_Type_Bool_Exp>;
};


export type Subscription_RootAsset_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Type_Order_By>>;
  where?: InputMaybe<Asset_Type_Bool_Exp>;
};


export type Subscription_RootAsset_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAsset_Type_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Asset_Type_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Type_Category_Order_By>>;
  where?: InputMaybe<Asset_Type_Category_Bool_Exp>;
};


export type Subscription_RootAsset_Type_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Type_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Type_Category_Order_By>>;
  where?: InputMaybe<Asset_Type_Category_Bool_Exp>;
};


export type Subscription_RootAsset_Type_Category_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootAsset_Type_Category_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Asset_Type_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Asset_Type_Category_Bool_Exp>;
};


export type Subscription_RootAsset_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Asset_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Asset_Type_Bool_Exp>;
};


export type Subscription_RootAssociated_TypeArgs = {
  distinct_on?: InputMaybe<Array<Associated_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Associated_Type_Order_By>>;
  where?: InputMaybe<Associated_Type_Bool_Exp>;
};


export type Subscription_RootAssociated_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Associated_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Associated_Type_Order_By>>;
  where?: InputMaybe<Associated_Type_Bool_Exp>;
};


export type Subscription_RootAssociated_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootAssociated_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Associated_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Associated_Type_Bool_Exp>;
};


export type Subscription_RootAudit_Log_ActionArgs = {
  distinct_on?: InputMaybe<Array<Audit_Log_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audit_Log_Action_Order_By>>;
  where?: InputMaybe<Audit_Log_Action_Bool_Exp>;
};


export type Subscription_RootAudit_Log_Action_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Audit_Log_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audit_Log_Action_Order_By>>;
  where?: InputMaybe<Audit_Log_Action_Bool_Exp>;
};


export type Subscription_RootAudit_Log_Action_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootAudit_Log_Action_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Audit_Log_Action_Stream_Cursor_Input>>;
  where?: InputMaybe<Audit_Log_Action_Bool_Exp>;
};


export type Subscription_RootCancellation_ReasonsArgs = {
  distinct_on?: InputMaybe<Array<Cancellation_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cancellation_Reasons_Order_By>>;
  where?: InputMaybe<Cancellation_Reasons_Bool_Exp>;
};


export type Subscription_RootCancellation_Reasons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cancellation_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cancellation_Reasons_Order_By>>;
  where?: InputMaybe<Cancellation_Reasons_Bool_Exp>;
};


export type Subscription_RootCancellation_Reasons_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCancellation_Reasons_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Cancellation_Reasons_Stream_Cursor_Input>>;
  where?: InputMaybe<Cancellation_Reasons_Bool_Exp>;
};


export type Subscription_RootCategoryArgs = {
  distinct_on?: InputMaybe<Array<Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Category_Order_By>>;
  where?: InputMaybe<Category_Bool_Exp>;
};


export type Subscription_RootCategory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Category_Order_By>>;
  where?: InputMaybe<Category_Bool_Exp>;
};


export type Subscription_RootCategory_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCategory_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Category_Bool_Exp>;
};


export type Subscription_RootCityArgs = {
  distinct_on?: InputMaybe<Array<City_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<City_Order_By>>;
  where?: InputMaybe<City_Bool_Exp>;
};


export type Subscription_RootCity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<City_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<City_Order_By>>;
  where?: InputMaybe<City_Bool_Exp>;
};


export type Subscription_RootCity_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCity_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<City_Stream_Cursor_Input>>;
  where?: InputMaybe<City_Bool_Exp>;
};


export type Subscription_RootCountryArgs = {
  distinct_on?: InputMaybe<Array<Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Country_Order_By>>;
  where?: InputMaybe<Country_Bool_Exp>;
};


export type Subscription_RootCountry_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Country_Order_By>>;
  where?: InputMaybe<Country_Bool_Exp>;
};


export type Subscription_RootCountry_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCountry_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Country_Stream_Cursor_Input>>;
  where?: InputMaybe<Country_Bool_Exp>;
};


export type Subscription_RootCredit_BreachArgs = {
  distinct_on?: InputMaybe<Array<Credit_Breach_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Breach_Order_By>>;
  where?: InputMaybe<Credit_Breach_Bool_Exp>;
};


export type Subscription_RootCredit_Breach_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Breach_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Breach_Order_By>>;
  where?: InputMaybe<Credit_Breach_Bool_Exp>;
};


export type Subscription_RootCredit_Breach_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCredit_Breach_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Credit_Breach_Stream_Cursor_Input>>;
  where?: InputMaybe<Credit_Breach_Bool_Exp>;
};


export type Subscription_RootCurrencyArgs = {
  distinct_on?: InputMaybe<Array<Currency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Currency_Order_By>>;
  where?: InputMaybe<Currency_Bool_Exp>;
};


export type Subscription_RootCurrency_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Currency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Currency_Order_By>>;
  where?: InputMaybe<Currency_Bool_Exp>;
};


export type Subscription_RootCurrency_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCurrency_ConversionArgs = {
  distinct_on?: InputMaybe<Array<Currency_Conversion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Currency_Conversion_Order_By>>;
  where?: InputMaybe<Currency_Conversion_Bool_Exp>;
};


export type Subscription_RootCurrency_Conversion_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Currency_Conversion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Currency_Conversion_Order_By>>;
  where?: InputMaybe<Currency_Conversion_Bool_Exp>;
};


export type Subscription_RootCurrency_Conversion_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCurrency_Conversion_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Currency_Conversion_Stream_Cursor_Input>>;
  where?: InputMaybe<Currency_Conversion_Bool_Exp>;
};


export type Subscription_RootCurrency_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Currency_Stream_Cursor_Input>>;
  where?: InputMaybe<Currency_Bool_Exp>;
};


export type Subscription_RootCustomer_AssetArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Order_By>>;
  where?: InputMaybe<Customer_Asset_Bool_Exp>;
};


export type Subscription_RootCustomer_Asset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Order_By>>;
  where?: InputMaybe<Customer_Asset_Bool_Exp>;
};


export type Subscription_RootCustomer_Asset_Audit_LogArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Audit_Log_Order_By>>;
  where?: InputMaybe<Customer_Asset_Audit_Log_Bool_Exp>;
};


export type Subscription_RootCustomer_Asset_Audit_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Audit_Log_Order_By>>;
  where?: InputMaybe<Customer_Asset_Audit_Log_Bool_Exp>;
};


export type Subscription_RootCustomer_Asset_Audit_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCustomer_Asset_Audit_Log_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Customer_Asset_Audit_Log_Stream_Cursor_Input>>;
  where?: InputMaybe<Customer_Asset_Audit_Log_Bool_Exp>;
};


export type Subscription_RootCustomer_Asset_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCustomer_Asset_DeviceArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Device_Order_By>>;
  where?: InputMaybe<Customer_Asset_Device_Bool_Exp>;
};


export type Subscription_RootCustomer_Asset_Device_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Device_Order_By>>;
  where?: InputMaybe<Customer_Asset_Device_Bool_Exp>;
};


export type Subscription_RootCustomer_Asset_Device_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCustomer_Asset_Device_CalibrationArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Device_Calibration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Device_Calibration_Order_By>>;
  where?: InputMaybe<Customer_Asset_Device_Calibration_Bool_Exp>;
};


export type Subscription_RootCustomer_Asset_Device_Calibration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Device_Calibration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Device_Calibration_Order_By>>;
  where?: InputMaybe<Customer_Asset_Device_Calibration_Bool_Exp>;
};


export type Subscription_RootCustomer_Asset_Device_Calibration_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCustomer_Asset_Device_Calibration_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Customer_Asset_Device_Calibration_Stream_Cursor_Input>>;
  where?: InputMaybe<Customer_Asset_Device_Calibration_Bool_Exp>;
};


export type Subscription_RootCustomer_Asset_Device_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Customer_Asset_Device_Stream_Cursor_Input>>;
  where?: InputMaybe<Customer_Asset_Device_Bool_Exp>;
};


export type Subscription_RootCustomer_Asset_Dispensing_RulesArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Dispensing_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Dispensing_Rules_Order_By>>;
  where?: InputMaybe<Customer_Asset_Dispensing_Rules_Bool_Exp>;
};


export type Subscription_RootCustomer_Asset_Dispensing_Rules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Dispensing_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Dispensing_Rules_Order_By>>;
  where?: InputMaybe<Customer_Asset_Dispensing_Rules_Bool_Exp>;
};


export type Subscription_RootCustomer_Asset_Dispensing_Rules_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCustomer_Asset_Dispensing_Rules_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Customer_Asset_Dispensing_Rules_Stream_Cursor_Input>>;
  where?: InputMaybe<Customer_Asset_Dispensing_Rules_Bool_Exp>;
};


export type Subscription_RootCustomer_Asset_LimitArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Limit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Limit_Order_By>>;
  where?: InputMaybe<Customer_Asset_Limit_Bool_Exp>;
};


export type Subscription_RootCustomer_Asset_Limit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Limit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Limit_Order_By>>;
  where?: InputMaybe<Customer_Asset_Limit_Bool_Exp>;
};


export type Subscription_RootCustomer_Asset_Limit_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCustomer_Asset_Limit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Customer_Asset_Limit_Stream_Cursor_Input>>;
  where?: InputMaybe<Customer_Asset_Limit_Bool_Exp>;
};


export type Subscription_RootCustomer_Asset_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Customer_Asset_Stream_Cursor_Input>>;
  where?: InputMaybe<Customer_Asset_Bool_Exp>;
};


export type Subscription_RootCustomer_Asset_TagArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Tag_Order_By>>;
  where?: InputMaybe<Customer_Asset_Tag_Bool_Exp>;
};


export type Subscription_RootCustomer_Asset_Tag_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Tag_Order_By>>;
  where?: InputMaybe<Customer_Asset_Tag_Bool_Exp>;
};


export type Subscription_RootCustomer_Asset_Tag_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCustomer_Asset_Tag_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Customer_Asset_Tag_Stream_Cursor_Input>>;
  where?: InputMaybe<Customer_Asset_Tag_Bool_Exp>;
};


export type Subscription_RootCustomer_OrderArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Order_By>>;
  where?: InputMaybe<Customer_Order_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Order_By>>;
  where?: InputMaybe<Customer_Order_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCustomer_Order_Cancellation_ReasonsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Cancellation_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Cancellation_Reasons_Order_By>>;
  where?: InputMaybe<Customer_Order_Cancellation_Reasons_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Cancellation_Reasons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Cancellation_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Cancellation_Reasons_Order_By>>;
  where?: InputMaybe<Customer_Order_Cancellation_Reasons_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Cancellation_Reasons_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCustomer_Order_Cancellation_Reasons_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Customer_Order_Cancellation_Reasons_Stream_Cursor_Input>>;
  where?: InputMaybe<Customer_Order_Cancellation_Reasons_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Customer_AssetArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Customer_Asset_Order_By>>;
  where?: InputMaybe<Customer_Order_Customer_Asset_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Customer_Asset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Customer_Asset_Order_By>>;
  where?: InputMaybe<Customer_Order_Customer_Asset_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Customer_Asset_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCustomer_Order_Customer_Asset_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Customer_Order_Customer_Asset_Stream_Cursor_Input>>;
  where?: InputMaybe<Customer_Order_Customer_Asset_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Detail_ViewArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Detail_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Detail_View_Order_By>>;
  where?: InputMaybe<Customer_Order_Detail_View_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Detail_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Detail_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Detail_View_Order_By>>;
  where?: InputMaybe<Customer_Order_Detail_View_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Detail_View_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Customer_Order_Detail_View_Stream_Cursor_Input>>;
  where?: InputMaybe<Customer_Order_Detail_View_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_ItemArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Item_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Item_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCustomer_Order_Item_Cancellation_ReasonsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Cancellation_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Cancellation_Reasons_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Cancellation_Reasons_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Item_Cancellation_Reasons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Cancellation_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Cancellation_Reasons_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Cancellation_Reasons_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Item_Cancellation_Reasons_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCustomer_Order_Item_Cancellation_Reasons_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Customer_Order_Item_Cancellation_Reasons_Stream_Cursor_Input>>;
  where?: InputMaybe<Customer_Order_Item_Cancellation_Reasons_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Item_CommentsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Comments_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Comments_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Item_Comments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Comments_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Comments_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Item_Comments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCustomer_Order_Item_Comments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Customer_Order_Item_Comments_Stream_Cursor_Input>>;
  where?: InputMaybe<Customer_Order_Item_Comments_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Item_CommissionArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Commission_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Commission_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Item_Commission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Commission_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Commission_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Item_Commission_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCustomer_Order_Item_Commission_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Customer_Order_Item_Commission_Stream_Cursor_Input>>;
  where?: InputMaybe<Customer_Order_Item_Commission_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Item_Etd_Transactional_LogsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Etd_Transactional_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Etd_Transactional_Logs_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Etd_Transactional_Logs_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Item_Etd_Transactional_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Etd_Transactional_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Etd_Transactional_Logs_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Etd_Transactional_Logs_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Item_Etd_Transactional_Logs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCustomer_Order_Item_Etd_Transactional_Logs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Customer_Order_Item_Etd_Transactional_Logs_Stream_Cursor_Input>>;
  where?: InputMaybe<Customer_Order_Item_Etd_Transactional_Logs_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Item_PartnerArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Partner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Partner_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Partner_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Item_Partner_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Partner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Partner_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Partner_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Item_Partner_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCustomer_Order_Item_Partner_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Customer_Order_Item_Partner_Stream_Cursor_Input>>;
  where?: InputMaybe<Customer_Order_Item_Partner_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Item_Safety_Checklist_ResultsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Safety_Checklist_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Safety_Checklist_Results_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Safety_Checklist_Results_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Item_Safety_Checklist_Results_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Safety_Checklist_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Safety_Checklist_Results_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Safety_Checklist_Results_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Item_Safety_Checklist_Results_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCustomer_Order_Item_Safety_Checklist_Results_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Customer_Order_Item_Safety_Checklist_Results_Stream_Cursor_Input>>;
  where?: InputMaybe<Customer_Order_Item_Safety_Checklist_Results_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Item_StateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_State_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_State_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Item_State_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_State_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_State_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Item_State_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootCustomer_Order_Item_State_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Customer_Order_Item_State_Stream_Cursor_Input>>;
  where?: InputMaybe<Customer_Order_Item_State_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Item_StateflowArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Stateflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Stateflow_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Stateflow_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Item_Stateflow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Stateflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Stateflow_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Stateflow_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Item_Stateflow_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCustomer_Order_Item_Stateflow_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Customer_Order_Item_Stateflow_Stream_Cursor_Input>>;
  where?: InputMaybe<Customer_Order_Item_Stateflow_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Item_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Customer_Order_Item_Stream_Cursor_Input>>;
  where?: InputMaybe<Customer_Order_Item_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Item_Test_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Test_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Test_Category_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Test_Category_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Item_Test_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Test_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Test_Category_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Test_Category_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Item_Test_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCustomer_Order_Item_Test_Category_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Customer_Order_Item_Test_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Customer_Order_Item_Test_Category_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Item_Test_ResultsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Test_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Test_Results_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Test_Results_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Item_Test_Results_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Test_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Test_Results_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Test_Results_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Item_Test_Results_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCustomer_Order_Item_Test_Results_PhotosArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Test_Results_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Test_Results_Photos_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Test_Results_Photos_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Item_Test_Results_Photos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Test_Results_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Test_Results_Photos_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Test_Results_Photos_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Item_Test_Results_Photos_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCustomer_Order_Item_Test_Results_Photos_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Customer_Order_Item_Test_Results_Photos_Stream_Cursor_Input>>;
  where?: InputMaybe<Customer_Order_Item_Test_Results_Photos_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Item_Test_Results_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Customer_Order_Item_Test_Results_Stream_Cursor_Input>>;
  where?: InputMaybe<Customer_Order_Item_Test_Results_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Organization_User_DocumentArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Organization_User_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Organization_User_Document_Order_By>>;
  where?: InputMaybe<Customer_Order_Organization_User_Document_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Organization_User_Document_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Organization_User_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Organization_User_Document_Order_By>>;
  where?: InputMaybe<Customer_Order_Organization_User_Document_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Organization_User_Document_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCustomer_Order_Organization_User_Document_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Customer_Order_Organization_User_Document_Stream_Cursor_Input>>;
  where?: InputMaybe<Customer_Order_Organization_User_Document_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Partner_OrderArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Partner_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Partner_Order_Order_By>>;
  where?: InputMaybe<Customer_Order_Partner_Order_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Partner_Order_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Partner_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Partner_Order_Order_By>>;
  where?: InputMaybe<Customer_Order_Partner_Order_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Partner_Order_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCustomer_Order_Partner_Order_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Customer_Order_Partner_Order_Stream_Cursor_Input>>;
  where?: InputMaybe<Customer_Order_Partner_Order_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_SlotsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Slots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Slots_Order_By>>;
  where?: InputMaybe<Customer_Order_Slots_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Slots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Slots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Slots_Order_By>>;
  where?: InputMaybe<Customer_Order_Slots_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Slots_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCustomer_Order_Slots_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Customer_Order_Slots_Stream_Cursor_Input>>;
  where?: InputMaybe<Customer_Order_Slots_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_StateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_State_Order_By>>;
  where?: InputMaybe<Customer_Order_State_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_State_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_State_Order_By>>;
  where?: InputMaybe<Customer_Order_State_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_State_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootCustomer_Order_State_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Customer_Order_State_Stream_Cursor_Input>>;
  where?: InputMaybe<Customer_Order_State_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_StateflowArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Stateflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Stateflow_Order_By>>;
  where?: InputMaybe<Customer_Order_Stateflow_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Stateflow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Stateflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Stateflow_Order_By>>;
  where?: InputMaybe<Customer_Order_Stateflow_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_Stateflow_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCustomer_Order_Stateflow_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Customer_Order_Stateflow_Stream_Cursor_Input>>;
  where?: InputMaybe<Customer_Order_Stateflow_Bool_Exp>;
};


export type Subscription_RootCustomer_Order_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Customer_Order_Stream_Cursor_Input>>;
  where?: InputMaybe<Customer_Order_Bool_Exp>;
};


export type Subscription_RootCustomer_PaymentArgs = {
  distinct_on?: InputMaybe<Array<Customer_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Payment_Order_By>>;
  where?: InputMaybe<Customer_Payment_Bool_Exp>;
};


export type Subscription_RootCustomer_Payment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Payment_Order_By>>;
  where?: InputMaybe<Customer_Payment_Bool_Exp>;
};


export type Subscription_RootCustomer_Payment_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCustomer_Payment_StatusArgs = {
  distinct_on?: InputMaybe<Array<Customer_Payment_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Payment_Status_Order_By>>;
  where?: InputMaybe<Customer_Payment_Status_Bool_Exp>;
};


export type Subscription_RootCustomer_Payment_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Payment_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Payment_Status_Order_By>>;
  where?: InputMaybe<Customer_Payment_Status_Bool_Exp>;
};


export type Subscription_RootCustomer_Payment_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootCustomer_Payment_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Customer_Payment_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Customer_Payment_Status_Bool_Exp>;
};


export type Subscription_RootCustomer_Payment_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Customer_Payment_Stream_Cursor_Input>>;
  where?: InputMaybe<Customer_Payment_Bool_Exp>;
};


export type Subscription_RootCustomer_SegmentationArgs = {
  distinct_on?: InputMaybe<Array<Customer_Segmentation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Segmentation_Order_By>>;
  where?: InputMaybe<Customer_Segmentation_Bool_Exp>;
};


export type Subscription_RootCustomer_Segmentation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Segmentation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Segmentation_Order_By>>;
  where?: InputMaybe<Customer_Segmentation_Bool_Exp>;
};


export type Subscription_RootCustomer_Segmentation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCustomer_Segmentation_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Customer_Segmentation_Stream_Cursor_Input>>;
  where?: InputMaybe<Customer_Segmentation_Bool_Exp>;
};


export type Subscription_RootDay_TypeArgs = {
  distinct_on?: InputMaybe<Array<Day_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Day_Type_Order_By>>;
  where?: InputMaybe<Day_Type_Bool_Exp>;
};


export type Subscription_RootDay_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Day_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Day_Type_Order_By>>;
  where?: InputMaybe<Day_Type_Bool_Exp>;
};


export type Subscription_RootDay_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootDay_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Day_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Day_Type_Bool_Exp>;
};


export type Subscription_RootDelayed_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Delayed_Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delayed_Orders_Order_By>>;
  where?: InputMaybe<Delayed_Orders_Bool_Exp>;
};


export type Subscription_RootDelayed_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Delayed_Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delayed_Orders_Order_By>>;
  where?: InputMaybe<Delayed_Orders_Bool_Exp>;
};


export type Subscription_RootDelayed_Orders_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Delayed_Orders_Stream_Cursor_Input>>;
  where?: InputMaybe<Delayed_Orders_Bool_Exp>;
};


export type Subscription_RootDelivery_PreferencesArgs = {
  distinct_on?: InputMaybe<Array<Delivery_Preferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delivery_Preferences_Order_By>>;
  where?: InputMaybe<Delivery_Preferences_Bool_Exp>;
};


export type Subscription_RootDelivery_Preferences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Delivery_Preferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delivery_Preferences_Order_By>>;
  where?: InputMaybe<Delivery_Preferences_Bool_Exp>;
};


export type Subscription_RootDelivery_Preferences_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootDelivery_Preferences_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Delivery_Preferences_Stream_Cursor_Input>>;
  where?: InputMaybe<Delivery_Preferences_Bool_Exp>;
};


export type Subscription_RootDelivery_SchedulerArgs = {
  distinct_on?: InputMaybe<Array<Delivery_Scheduler_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delivery_Scheduler_Order_By>>;
  where?: InputMaybe<Delivery_Scheduler_Bool_Exp>;
};


export type Subscription_RootDelivery_Scheduler_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Delivery_Scheduler_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delivery_Scheduler_Order_By>>;
  where?: InputMaybe<Delivery_Scheduler_Bool_Exp>;
};


export type Subscription_RootDelivery_Scheduler_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDelivery_Scheduler_Product_ItemArgs = {
  distinct_on?: InputMaybe<Array<Delivery_Scheduler_Product_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delivery_Scheduler_Product_Item_Order_By>>;
  where?: InputMaybe<Delivery_Scheduler_Product_Item_Bool_Exp>;
};


export type Subscription_RootDelivery_Scheduler_Product_Item_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Delivery_Scheduler_Product_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delivery_Scheduler_Product_Item_Order_By>>;
  where?: InputMaybe<Delivery_Scheduler_Product_Item_Bool_Exp>;
};


export type Subscription_RootDelivery_Scheduler_Product_Item_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDelivery_Scheduler_Product_Item_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Delivery_Scheduler_Product_Item_Stream_Cursor_Input>>;
  where?: InputMaybe<Delivery_Scheduler_Product_Item_Bool_Exp>;
};


export type Subscription_RootDelivery_Scheduler_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Delivery_Scheduler_Stream_Cursor_Input>>;
  where?: InputMaybe<Delivery_Scheduler_Bool_Exp>;
};


export type Subscription_RootDepartment_Retag_RequestArgs = {
  distinct_on?: InputMaybe<Array<Department_Retag_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Department_Retag_Request_Order_By>>;
  where?: InputMaybe<Department_Retag_Request_Bool_Exp>;
};


export type Subscription_RootDepartment_Retag_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Department_Retag_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Department_Retag_Request_Order_By>>;
  where?: InputMaybe<Department_Retag_Request_Bool_Exp>;
};


export type Subscription_RootDepartment_Retag_Request_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDepartment_Retag_Request_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Department_Retag_Request_Stream_Cursor_Input>>;
  where?: InputMaybe<Department_Retag_Request_Bool_Exp>;
};


export type Subscription_RootDevice_Devicetype_Paramerter_DefinitionArgs = {
  distinct_on?: InputMaybe<Array<Device_Devicetype_Paramerter_Definition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Device_Devicetype_Paramerter_Definition_Order_By>>;
  where?: InputMaybe<Device_Devicetype_Paramerter_Definition_Bool_Exp>;
};


export type Subscription_RootDevice_Devicetype_Paramerter_Definition_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Device_Devicetype_Paramerter_Definition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Device_Devicetype_Paramerter_Definition_Order_By>>;
  where?: InputMaybe<Device_Devicetype_Paramerter_Definition_Bool_Exp>;
};


export type Subscription_RootDevice_Devicetype_Paramerter_Definition_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDevice_Devicetype_Paramerter_Definition_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Device_Devicetype_Paramerter_Definition_Stream_Cursor_Input>>;
  where?: InputMaybe<Device_Devicetype_Paramerter_Definition_Bool_Exp>;
};


export type Subscription_RootDevicetypeArgs = {
  distinct_on?: InputMaybe<Array<Devicetype_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Devicetype_Order_By>>;
  where?: InputMaybe<Devicetype_Bool_Exp>;
};


export type Subscription_RootDevicetype_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Devicetype_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Devicetype_Order_By>>;
  where?: InputMaybe<Devicetype_Bool_Exp>;
};


export type Subscription_RootDevicetype_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDevicetype_Paramerter_DefinitionArgs = {
  distinct_on?: InputMaybe<Array<Devicetype_Paramerter_Definition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Devicetype_Paramerter_Definition_Order_By>>;
  where?: InputMaybe<Devicetype_Paramerter_Definition_Bool_Exp>;
};


export type Subscription_RootDevicetype_Paramerter_Definition_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Devicetype_Paramerter_Definition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Devicetype_Paramerter_Definition_Order_By>>;
  where?: InputMaybe<Devicetype_Paramerter_Definition_Bool_Exp>;
};


export type Subscription_RootDevicetype_Paramerter_Definition_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDevicetype_Paramerter_Definition_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Devicetype_Paramerter_Definition_Stream_Cursor_Input>>;
  where?: InputMaybe<Devicetype_Paramerter_Definition_Bool_Exp>;
};


export type Subscription_RootDevicetype_Parameter_GroupArgs = {
  distinct_on?: InputMaybe<Array<Devicetype_Parameter_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Devicetype_Parameter_Group_Order_By>>;
  where?: InputMaybe<Devicetype_Parameter_Group_Bool_Exp>;
};


export type Subscription_RootDevicetype_Parameter_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Devicetype_Parameter_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Devicetype_Parameter_Group_Order_By>>;
  where?: InputMaybe<Devicetype_Parameter_Group_Bool_Exp>;
};


export type Subscription_RootDevicetype_Parameter_Group_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDevicetype_Parameter_Group_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Devicetype_Parameter_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Devicetype_Parameter_Group_Bool_Exp>;
};


export type Subscription_RootDevicetype_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Devicetype_Stream_Cursor_Input>>;
  where?: InputMaybe<Devicetype_Bool_Exp>;
};


export type Subscription_RootDiscount_TypeArgs = {
  distinct_on?: InputMaybe<Array<Discount_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Discount_Type_Order_By>>;
  where?: InputMaybe<Discount_Type_Bool_Exp>;
};


export type Subscription_RootDiscount_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Discount_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Discount_Type_Order_By>>;
  where?: InputMaybe<Discount_Type_Bool_Exp>;
};


export type Subscription_RootDiscount_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootDiscount_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Discount_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Discount_Type_Bool_Exp>;
};


export type Subscription_RootDispenserArgs = {
  distinct_on?: InputMaybe<Array<Dispenser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dispenser_Order_By>>;
  where?: InputMaybe<Dispenser_Bool_Exp>;
};


export type Subscription_RootDispenser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dispenser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dispenser_Order_By>>;
  where?: InputMaybe<Dispenser_Bool_Exp>;
};


export type Subscription_RootDispenser_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDispenser_ConfigurationArgs = {
  distinct_on?: InputMaybe<Array<Dispenser_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dispenser_Configuration_Order_By>>;
  where?: InputMaybe<Dispenser_Configuration_Bool_Exp>;
};


export type Subscription_RootDispenser_Configuration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dispenser_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dispenser_Configuration_Order_By>>;
  where?: InputMaybe<Dispenser_Configuration_Bool_Exp>;
};


export type Subscription_RootDispenser_Configuration_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDispenser_Configuration_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Dispenser_Configuration_Stream_Cursor_Input>>;
  where?: InputMaybe<Dispenser_Configuration_Bool_Exp>;
};


export type Subscription_RootDispenser_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Dispenser_Stream_Cursor_Input>>;
  where?: InputMaybe<Dispenser_Bool_Exp>;
};


export type Subscription_RootDispenser_TypeArgs = {
  distinct_on?: InputMaybe<Array<Dispenser_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dispenser_Type_Order_By>>;
  where?: InputMaybe<Dispenser_Type_Bool_Exp>;
};


export type Subscription_RootDispenser_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dispenser_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dispenser_Type_Order_By>>;
  where?: InputMaybe<Dispenser_Type_Bool_Exp>;
};


export type Subscription_RootDispenser_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootDispenser_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Dispenser_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Dispenser_Type_Bool_Exp>;
};


export type Subscription_RootDispensing_RulesArgs = {
  distinct_on?: InputMaybe<Array<Dispensing_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dispensing_Rules_Order_By>>;
  where?: InputMaybe<Dispensing_Rules_Bool_Exp>;
};


export type Subscription_RootDispensing_Rules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dispensing_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dispensing_Rules_Order_By>>;
  where?: InputMaybe<Dispensing_Rules_Bool_Exp>;
};


export type Subscription_RootDispensing_Rules_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDispensing_Rules_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Dispensing_Rules_Stream_Cursor_Input>>;
  where?: InputMaybe<Dispensing_Rules_Bool_Exp>;
};


export type Subscription_RootDocument_TypeArgs = {
  distinct_on?: InputMaybe<Array<Document_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Type_Order_By>>;
  where?: InputMaybe<Document_Type_Bool_Exp>;
};


export type Subscription_RootDocument_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Type_Order_By>>;
  where?: InputMaybe<Document_Type_Bool_Exp>;
};


export type Subscription_RootDocument_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDocument_Type_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Document_Type_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Type_Category_Order_By>>;
  where?: InputMaybe<Document_Type_Category_Bool_Exp>;
};


export type Subscription_RootDocument_Type_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Type_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Type_Category_Order_By>>;
  where?: InputMaybe<Document_Type_Category_Bool_Exp>;
};


export type Subscription_RootDocument_Type_Category_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootDocument_Type_Category_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Document_Type_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Type_Category_Bool_Exp>;
};


export type Subscription_RootDocument_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Document_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Type_Bool_Exp>;
};


export type Subscription_RootDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Documents_Order_By>>;
  where?: InputMaybe<Documents_Bool_Exp>;
};


export type Subscription_RootDocuments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Documents_Order_By>>;
  where?: InputMaybe<Documents_Bool_Exp>;
};


export type Subscription_RootDocuments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDocuments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Documents_Stream_Cursor_Input>>;
  where?: InputMaybe<Documents_Bool_Exp>;
};


export type Subscription_RootDriver_Duty_LogArgs = {
  distinct_on?: InputMaybe<Array<Driver_Duty_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Duty_Log_Order_By>>;
  where?: InputMaybe<Driver_Duty_Log_Bool_Exp>;
};


export type Subscription_RootDriver_Duty_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Driver_Duty_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Duty_Log_Order_By>>;
  where?: InputMaybe<Driver_Duty_Log_Bool_Exp>;
};


export type Subscription_RootDriver_Duty_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDriver_Duty_Log_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Driver_Duty_Log_Stream_Cursor_Input>>;
  where?: InputMaybe<Driver_Duty_Log_Bool_Exp>;
};


export type Subscription_RootDriver_Duty_PhotosArgs = {
  distinct_on?: InputMaybe<Array<Driver_Duty_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Duty_Photos_Order_By>>;
  where?: InputMaybe<Driver_Duty_Photos_Bool_Exp>;
};


export type Subscription_RootDriver_Duty_Photos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Driver_Duty_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Duty_Photos_Order_By>>;
  where?: InputMaybe<Driver_Duty_Photos_Bool_Exp>;
};


export type Subscription_RootDriver_Duty_Photos_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDriver_Duty_Photos_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Driver_Duty_Photos_Stream_Cursor_Input>>;
  where?: InputMaybe<Driver_Duty_Photos_Bool_Exp>;
};


export type Subscription_RootDriver_PermitArgs = {
  distinct_on?: InputMaybe<Array<Driver_Permit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Permit_Order_By>>;
  where?: InputMaybe<Driver_Permit_Bool_Exp>;
};


export type Subscription_RootDriver_Permit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Driver_Permit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Permit_Order_By>>;
  where?: InputMaybe<Driver_Permit_Bool_Exp>;
};


export type Subscription_RootDriver_Permit_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDriver_Permit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Driver_Permit_Stream_Cursor_Input>>;
  where?: InputMaybe<Driver_Permit_Bool_Exp>;
};


export type Subscription_RootDriver_VehicleArgs = {
  distinct_on?: InputMaybe<Array<Driver_Vehicle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Vehicle_Order_By>>;
  where?: InputMaybe<Driver_Vehicle_Bool_Exp>;
};


export type Subscription_RootDriver_Vehicle_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Driver_Vehicle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Vehicle_Order_By>>;
  where?: InputMaybe<Driver_Vehicle_Bool_Exp>;
};


export type Subscription_RootDriver_Vehicle_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDriver_Vehicle_IssueArgs = {
  distinct_on?: InputMaybe<Array<Driver_Vehicle_Issue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Vehicle_Issue_Order_By>>;
  where?: InputMaybe<Driver_Vehicle_Issue_Bool_Exp>;
};


export type Subscription_RootDriver_Vehicle_Issue_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Driver_Vehicle_Issue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Vehicle_Issue_Order_By>>;
  where?: InputMaybe<Driver_Vehicle_Issue_Bool_Exp>;
};


export type Subscription_RootDriver_Vehicle_Issue_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDriver_Vehicle_Issue_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Driver_Vehicle_Issue_Stream_Cursor_Input>>;
  where?: InputMaybe<Driver_Vehicle_Issue_Bool_Exp>;
};


export type Subscription_RootDriver_Vehicle_LocationArgs = {
  distinct_on?: InputMaybe<Array<Driver_Vehicle_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Vehicle_Location_Order_By>>;
  where?: InputMaybe<Driver_Vehicle_Location_Bool_Exp>;
};


export type Subscription_RootDriver_Vehicle_Location_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Driver_Vehicle_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Vehicle_Location_Order_By>>;
  where?: InputMaybe<Driver_Vehicle_Location_Bool_Exp>;
};


export type Subscription_RootDriver_Vehicle_Location_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDriver_Vehicle_Location_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Driver_Vehicle_Location_Stream_Cursor_Input>>;
  where?: InputMaybe<Driver_Vehicle_Location_Bool_Exp>;
};


export type Subscription_RootDriver_Vehicle_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Driver_Vehicle_Stream_Cursor_Input>>;
  where?: InputMaybe<Driver_Vehicle_Bool_Exp>;
};


export type Subscription_RootErp_Sync_StatusArgs = {
  distinct_on?: InputMaybe<Array<Erp_Sync_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Erp_Sync_Status_Order_By>>;
  where?: InputMaybe<Erp_Sync_Status_Bool_Exp>;
};


export type Subscription_RootErp_Sync_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Erp_Sync_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Erp_Sync_Status_Order_By>>;
  where?: InputMaybe<Erp_Sync_Status_Bool_Exp>;
};


export type Subscription_RootErp_Sync_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootErp_Sync_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Erp_Sync_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Erp_Sync_Status_Bool_Exp>;
};


export type Subscription_RootFillup_RequestArgs = {
  distinct_on?: InputMaybe<Array<Fillup_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fillup_Request_Order_By>>;
  where?: InputMaybe<Fillup_Request_Bool_Exp>;
};


export type Subscription_RootFillup_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fillup_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fillup_Request_Order_By>>;
  where?: InputMaybe<Fillup_Request_Bool_Exp>;
};


export type Subscription_RootFillup_Request_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFillup_Request_StatusArgs = {
  distinct_on?: InputMaybe<Array<Fillup_Request_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fillup_Request_Status_Order_By>>;
  where?: InputMaybe<Fillup_Request_Status_Bool_Exp>;
};


export type Subscription_RootFillup_Request_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fillup_Request_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fillup_Request_Status_Order_By>>;
  where?: InputMaybe<Fillup_Request_Status_Bool_Exp>;
};


export type Subscription_RootFillup_Request_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootFillup_Request_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Fillup_Request_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Fillup_Request_Status_Bool_Exp>;
};


export type Subscription_RootFillup_Request_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Fillup_Request_Stream_Cursor_Input>>;
  where?: InputMaybe<Fillup_Request_Bool_Exp>;
};


export type Subscription_RootFuel_Request_TypeArgs = {
  distinct_on?: InputMaybe<Array<Fuel_Request_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fuel_Request_Type_Order_By>>;
  where?: InputMaybe<Fuel_Request_Type_Bool_Exp>;
};


export type Subscription_RootFuel_Request_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fuel_Request_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fuel_Request_Type_Order_By>>;
  where?: InputMaybe<Fuel_Request_Type_Bool_Exp>;
};


export type Subscription_RootFuel_Request_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootFuel_Request_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Fuel_Request_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Fuel_Request_Type_Bool_Exp>;
};


export type Subscription_RootFueltrans_Transaction_LogsArgs = {
  distinct_on?: InputMaybe<Array<Fueltrans_Transaction_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fueltrans_Transaction_Logs_Order_By>>;
  where?: InputMaybe<Fueltrans_Transaction_Logs_Bool_Exp>;
};


export type Subscription_RootFueltrans_Transaction_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fueltrans_Transaction_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fueltrans_Transaction_Logs_Order_By>>;
  where?: InputMaybe<Fueltrans_Transaction_Logs_Bool_Exp>;
};


export type Subscription_RootFueltrans_Transaction_Logs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFueltrans_Transaction_Logs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Fueltrans_Transaction_Logs_Stream_Cursor_Input>>;
  where?: InputMaybe<Fueltrans_Transaction_Logs_Bool_Exp>;
};


export type Subscription_RootGeography_ColumnsArgs = {
  distinct_on?: InputMaybe<Array<Geography_Columns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Geography_Columns_Order_By>>;
  where?: InputMaybe<Geography_Columns_Bool_Exp>;
};


export type Subscription_RootGeography_Columns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Geography_Columns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Geography_Columns_Order_By>>;
  where?: InputMaybe<Geography_Columns_Bool_Exp>;
};


export type Subscription_RootGeography_Columns_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Geography_Columns_Stream_Cursor_Input>>;
  where?: InputMaybe<Geography_Columns_Bool_Exp>;
};


export type Subscription_RootGeometry_ColumnsArgs = {
  distinct_on?: InputMaybe<Array<Geometry_Columns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Geometry_Columns_Order_By>>;
  where?: InputMaybe<Geometry_Columns_Bool_Exp>;
};


export type Subscription_RootGeometry_Columns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Geometry_Columns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Geometry_Columns_Order_By>>;
  where?: InputMaybe<Geometry_Columns_Bool_Exp>;
};


export type Subscription_RootGeometry_Columns_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Geometry_Columns_Stream_Cursor_Input>>;
  where?: InputMaybe<Geometry_Columns_Bool_Exp>;
};


export type Subscription_RootInventoryArgs = {
  distinct_on?: InputMaybe<Array<Inventory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Inventory_Order_By>>;
  where?: InputMaybe<Inventory_Bool_Exp>;
};


export type Subscription_RootInventory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Inventory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Inventory_Order_By>>;
  where?: InputMaybe<Inventory_Bool_Exp>;
};


export type Subscription_RootInventory_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootInventory_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Inventory_Stream_Cursor_Input>>;
  where?: InputMaybe<Inventory_Bool_Exp>;
};


export type Subscription_RootInventory_Workflow_LogsArgs = {
  distinct_on?: InputMaybe<Array<Inventory_Workflow_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Inventory_Workflow_Logs_Order_By>>;
  where?: InputMaybe<Inventory_Workflow_Logs_Bool_Exp>;
};


export type Subscription_RootInventory_Workflow_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Inventory_Workflow_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Inventory_Workflow_Logs_Order_By>>;
  where?: InputMaybe<Inventory_Workflow_Logs_Bool_Exp>;
};


export type Subscription_RootInventory_Workflow_Logs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootInventory_Workflow_Logs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Inventory_Workflow_Logs_Stream_Cursor_Input>>;
  where?: InputMaybe<Inventory_Workflow_Logs_Bool_Exp>;
};


export type Subscription_RootInvitationArgs = {
  distinct_on?: InputMaybe<Array<Invitation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invitation_Order_By>>;
  where?: InputMaybe<Invitation_Bool_Exp>;
};


export type Subscription_RootInvitation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invitation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invitation_Order_By>>;
  where?: InputMaybe<Invitation_Bool_Exp>;
};


export type Subscription_RootInvitation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootInvitation_StatusArgs = {
  distinct_on?: InputMaybe<Array<Invitation_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invitation_Status_Order_By>>;
  where?: InputMaybe<Invitation_Status_Bool_Exp>;
};


export type Subscription_RootInvitation_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invitation_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invitation_Status_Order_By>>;
  where?: InputMaybe<Invitation_Status_Bool_Exp>;
};


export type Subscription_RootInvitation_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootInvitation_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Invitation_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Invitation_Status_Bool_Exp>;
};


export type Subscription_RootInvitation_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Invitation_Stream_Cursor_Input>>;
  where?: InputMaybe<Invitation_Bool_Exp>;
};


export type Subscription_RootInvoiceArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


export type Subscription_RootInvoice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


export type Subscription_RootInvoice_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootInvoice_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Invoice_Stream_Cursor_Input>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


export type Subscription_RootInvoiced_ItemArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Bool_Exp>;
};


export type Subscription_RootInvoiced_Item_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Bool_Exp>;
};


export type Subscription_RootInvoiced_Item_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootInvoiced_Item_Cancellation_Ticket_StatesArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Cancellation_Ticket_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Cancellation_Ticket_States_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Cancellation_Ticket_States_Bool_Exp>;
};


export type Subscription_RootInvoiced_Item_Cancellation_Ticket_States_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Cancellation_Ticket_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Cancellation_Ticket_States_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Cancellation_Ticket_States_Bool_Exp>;
};


export type Subscription_RootInvoiced_Item_Cancellation_Ticket_States_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootInvoiced_Item_Cancellation_Ticket_States_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Invoiced_Item_Cancellation_Ticket_States_Stream_Cursor_Input>>;
  where?: InputMaybe<Invoiced_Item_Cancellation_Ticket_States_Bool_Exp>;
};


export type Subscription_RootInvoiced_Item_Cancellation_TicketsArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Cancellation_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Cancellation_Tickets_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Bool_Exp>;
};


export type Subscription_RootInvoiced_Item_Cancellation_Tickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Cancellation_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Cancellation_Tickets_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Bool_Exp>;
};


export type Subscription_RootInvoiced_Item_Cancellation_Tickets_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootInvoiced_Item_Cancellation_Tickets_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Invoiced_Item_Cancellation_Tickets_Stream_Cursor_Input>>;
  where?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Bool_Exp>;
};


export type Subscription_RootInvoiced_Item_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Invoiced_Item_Stream_Cursor_Input>>;
  where?: InputMaybe<Invoiced_Item_Bool_Exp>;
};


export type Subscription_RootIssueArgs = {
  distinct_on?: InputMaybe<Array<Issue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Order_By>>;
  where?: InputMaybe<Issue_Bool_Exp>;
};


export type Subscription_RootIssue_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Issue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Order_By>>;
  where?: InputMaybe<Issue_Bool_Exp>;
};


export type Subscription_RootIssue_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootIssue_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Issue_Stream_Cursor_Input>>;
  where?: InputMaybe<Issue_Bool_Exp>;
};


export type Subscription_RootJob_StateArgs = {
  distinct_on?: InputMaybe<Array<Job_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Job_State_Order_By>>;
  where?: InputMaybe<Job_State_Bool_Exp>;
};


export type Subscription_RootJob_State_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Job_State_Order_By>>;
  where?: InputMaybe<Job_State_Bool_Exp>;
};


export type Subscription_RootJob_State_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootJob_State_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Job_State_Stream_Cursor_Input>>;
  where?: InputMaybe<Job_State_Bool_Exp>;
};


export type Subscription_RootJob_TypeArgs = {
  distinct_on?: InputMaybe<Array<Job_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Job_Type_Order_By>>;
  where?: InputMaybe<Job_Type_Bool_Exp>;
};


export type Subscription_RootJob_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Job_Type_Order_By>>;
  where?: InputMaybe<Job_Type_Bool_Exp>;
};


export type Subscription_RootJob_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootJob_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Job_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Job_Type_Bool_Exp>;
};


export type Subscription_RootJob_Type_TemplateArgs = {
  distinct_on?: InputMaybe<Array<Job_Type_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Job_Type_Template_Order_By>>;
  where?: InputMaybe<Job_Type_Template_Bool_Exp>;
};


export type Subscription_RootJob_Type_Template_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Type_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Job_Type_Template_Order_By>>;
  where?: InputMaybe<Job_Type_Template_Bool_Exp>;
};


export type Subscription_RootJob_Type_Template_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootJob_Type_Template_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Job_Type_Template_Stream_Cursor_Input>>;
  where?: InputMaybe<Job_Type_Template_Bool_Exp>;
};


export type Subscription_RootJobsArgs = {
  distinct_on?: InputMaybe<Array<Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Jobs_Order_By>>;
  where?: InputMaybe<Jobs_Bool_Exp>;
};


export type Subscription_RootJobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Jobs_Order_By>>;
  where?: InputMaybe<Jobs_Bool_Exp>;
};


export type Subscription_RootJobs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootJobs_State_FlowArgs = {
  distinct_on?: InputMaybe<Array<Jobs_State_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Jobs_State_Flow_Order_By>>;
  where?: InputMaybe<Jobs_State_Flow_Bool_Exp>;
};


export type Subscription_RootJobs_State_Flow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Jobs_State_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Jobs_State_Flow_Order_By>>;
  where?: InputMaybe<Jobs_State_Flow_Bool_Exp>;
};


export type Subscription_RootJobs_State_Flow_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootJobs_State_Flow_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Jobs_State_Flow_Stream_Cursor_Input>>;
  where?: InputMaybe<Jobs_State_Flow_Bool_Exp>;
};


export type Subscription_RootJobs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Jobs_Stream_Cursor_Input>>;
  where?: InputMaybe<Jobs_Bool_Exp>;
};


export type Subscription_RootLimit_Purchase_OrderArgs = {
  distinct_on?: InputMaybe<Array<Limit_Purchase_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Limit_Purchase_Order_Order_By>>;
  where?: InputMaybe<Limit_Purchase_Order_Bool_Exp>;
};


export type Subscription_RootLimit_Purchase_Order_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Limit_Purchase_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Limit_Purchase_Order_Order_By>>;
  where?: InputMaybe<Limit_Purchase_Order_Bool_Exp>;
};


export type Subscription_RootLimit_Purchase_Order_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootLimit_Purchase_Order_LogsArgs = {
  distinct_on?: InputMaybe<Array<Limit_Purchase_Order_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Limit_Purchase_Order_Logs_Order_By>>;
  where?: InputMaybe<Limit_Purchase_Order_Logs_Bool_Exp>;
};


export type Subscription_RootLimit_Purchase_Order_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Limit_Purchase_Order_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Limit_Purchase_Order_Logs_Order_By>>;
  where?: InputMaybe<Limit_Purchase_Order_Logs_Bool_Exp>;
};


export type Subscription_RootLimit_Purchase_Order_Logs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootLimit_Purchase_Order_Logs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Limit_Purchase_Order_Logs_Stream_Cursor_Input>>;
  where?: InputMaybe<Limit_Purchase_Order_Logs_Bool_Exp>;
};


export type Subscription_RootLimit_Purchase_Order_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Limit_Purchase_Order_Stream_Cursor_Input>>;
  where?: InputMaybe<Limit_Purchase_Order_Bool_Exp>;
};


export type Subscription_RootLocalitiesArgs = {
  distinct_on?: InputMaybe<Array<Localities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Localities_Order_By>>;
  where?: InputMaybe<Localities_Bool_Exp>;
};


export type Subscription_RootLocalities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Localities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Localities_Order_By>>;
  where?: InputMaybe<Localities_Bool_Exp>;
};


export type Subscription_RootLocalities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootLocalities_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Localities_Stream_Cursor_Input>>;
  where?: InputMaybe<Localities_Bool_Exp>;
};


export type Subscription_RootLogin_TypeArgs = {
  distinct_on?: InputMaybe<Array<Login_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Login_Type_Order_By>>;
  where?: InputMaybe<Login_Type_Bool_Exp>;
};


export type Subscription_RootLogin_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Login_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Login_Type_Order_By>>;
  where?: InputMaybe<Login_Type_Bool_Exp>;
};


export type Subscription_RootLogin_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootLogin_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Login_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Login_Type_Bool_Exp>;
};


export type Subscription_RootLpo_ExceptionArgs = {
  distinct_on?: InputMaybe<Array<Lpo_Exception_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lpo_Exception_Order_By>>;
  where?: InputMaybe<Lpo_Exception_Bool_Exp>;
};


export type Subscription_RootLpo_Exception_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lpo_Exception_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lpo_Exception_Order_By>>;
  where?: InputMaybe<Lpo_Exception_Bool_Exp>;
};


export type Subscription_RootLpo_Exception_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootLpo_Exception_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lpo_Exception_Stream_Cursor_Input>>;
  where?: InputMaybe<Lpo_Exception_Bool_Exp>;
};


export type Subscription_RootMaster_SlotArgs = {
  distinct_on?: InputMaybe<Array<Master_Slot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Slot_Order_By>>;
  where?: InputMaybe<Master_Slot_Bool_Exp>;
};


export type Subscription_RootMaster_Slot_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Master_Slot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Slot_Order_By>>;
  where?: InputMaybe<Master_Slot_Bool_Exp>;
};


export type Subscription_RootMaster_Slot_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootMaster_Slot_PauseArgs = {
  distinct_on?: InputMaybe<Array<Master_Slot_Pause_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Slot_Pause_Order_By>>;
  where?: InputMaybe<Master_Slot_Pause_Bool_Exp>;
};


export type Subscription_RootMaster_Slot_Pause_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Master_Slot_Pause_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Slot_Pause_Order_By>>;
  where?: InputMaybe<Master_Slot_Pause_Bool_Exp>;
};


export type Subscription_RootMaster_Slot_Pause_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootMaster_Slot_Pause_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Master_Slot_Pause_Stream_Cursor_Input>>;
  where?: InputMaybe<Master_Slot_Pause_Bool_Exp>;
};


export type Subscription_RootMaster_Slot_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Master_Slot_Stream_Cursor_Input>>;
  where?: InputMaybe<Master_Slot_Bool_Exp>;
};


export type Subscription_RootOmc_TypeArgs = {
  distinct_on?: InputMaybe<Array<Omc_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Omc_Type_Order_By>>;
  where?: InputMaybe<Omc_Type_Bool_Exp>;
};


export type Subscription_RootOmc_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Omc_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Omc_Type_Order_By>>;
  where?: InputMaybe<Omc_Type_Bool_Exp>;
};


export type Subscription_RootOmc_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootOmc_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Omc_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Omc_Type_Bool_Exp>;
};


export type Subscription_RootOrder_PhotosArgs = {
  distinct_on?: InputMaybe<Array<Order_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Photos_Order_By>>;
  where?: InputMaybe<Order_Photos_Bool_Exp>;
};


export type Subscription_RootOrder_Photos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Photos_Order_By>>;
  where?: InputMaybe<Order_Photos_Bool_Exp>;
};


export type Subscription_RootOrder_Photos_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrder_Photos_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Order_Photos_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_Photos_Bool_Exp>;
};


export type Subscription_RootOrder_SchedulerArgs = {
  distinct_on?: InputMaybe<Array<Order_Scheduler_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Scheduler_Order_By>>;
  where?: InputMaybe<Order_Scheduler_Bool_Exp>;
};


export type Subscription_RootOrder_Scheduler_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Scheduler_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Scheduler_Order_By>>;
  where?: InputMaybe<Order_Scheduler_Bool_Exp>;
};


export type Subscription_RootOrder_Scheduler_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrder_Scheduler_Customer_AssetArgs = {
  distinct_on?: InputMaybe<Array<Order_Scheduler_Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Scheduler_Customer_Asset_Order_By>>;
  where?: InputMaybe<Order_Scheduler_Customer_Asset_Bool_Exp>;
};


export type Subscription_RootOrder_Scheduler_Customer_Asset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Scheduler_Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Scheduler_Customer_Asset_Order_By>>;
  where?: InputMaybe<Order_Scheduler_Customer_Asset_Bool_Exp>;
};


export type Subscription_RootOrder_Scheduler_Customer_Asset_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrder_Scheduler_Customer_Asset_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Order_Scheduler_Customer_Asset_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_Scheduler_Customer_Asset_Bool_Exp>;
};


export type Subscription_RootOrder_Scheduler_Daily_FrequencyArgs = {
  distinct_on?: InputMaybe<Array<Order_Scheduler_Daily_Frequency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Scheduler_Daily_Frequency_Order_By>>;
  where?: InputMaybe<Order_Scheduler_Daily_Frequency_Bool_Exp>;
};


export type Subscription_RootOrder_Scheduler_Daily_Frequency_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Scheduler_Daily_Frequency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Scheduler_Daily_Frequency_Order_By>>;
  where?: InputMaybe<Order_Scheduler_Daily_Frequency_Bool_Exp>;
};


export type Subscription_RootOrder_Scheduler_Daily_Frequency_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrder_Scheduler_Daily_Frequency_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Order_Scheduler_Daily_Frequency_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_Scheduler_Daily_Frequency_Bool_Exp>;
};


export type Subscription_RootOrder_Scheduler_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Order_Scheduler_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_Scheduler_Bool_Exp>;
};


export type Subscription_RootOrder_TypeArgs = {
  distinct_on?: InputMaybe<Array<Order_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Type_Order_By>>;
  where?: InputMaybe<Order_Type_Bool_Exp>;
};


export type Subscription_RootOrder_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Type_Order_By>>;
  where?: InputMaybe<Order_Type_Bool_Exp>;
};


export type Subscription_RootOrder_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootOrder_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Order_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_Type_Bool_Exp>;
};


export type Subscription_RootOrganizationArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Subscription_RootOrganization_AddressArgs = {
  distinct_on?: InputMaybe<Array<Organization_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Address_Order_By>>;
  where?: InputMaybe<Organization_Address_Bool_Exp>;
};


export type Subscription_RootOrganization_Address_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Address_Order_By>>;
  where?: InputMaybe<Organization_Address_Bool_Exp>;
};


export type Subscription_RootOrganization_Address_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganization_Address_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Address_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Address_Bool_Exp>;
};


export type Subscription_RootOrganization_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Subscription_RootOrganization_Audit_LogArgs = {
  distinct_on?: InputMaybe<Array<Organization_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Audit_Log_Order_By>>;
  where?: InputMaybe<Organization_Audit_Log_Bool_Exp>;
};


export type Subscription_RootOrganization_Audit_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Audit_Log_Order_By>>;
  where?: InputMaybe<Organization_Audit_Log_Bool_Exp>;
};


export type Subscription_RootOrganization_Audit_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganization_Audit_Log_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Audit_Log_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Audit_Log_Bool_Exp>;
};


export type Subscription_RootOrganization_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganization_Commission_Product_Variation_TypeArgs = {
  distinct_on?: InputMaybe<Array<Organization_Commission_Product_Variation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Commission_Product_Variation_Type_Order_By>>;
  where?: InputMaybe<Organization_Commission_Product_Variation_Type_Bool_Exp>;
};


export type Subscription_RootOrganization_Commission_Product_Variation_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Commission_Product_Variation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Commission_Product_Variation_Type_Order_By>>;
  where?: InputMaybe<Organization_Commission_Product_Variation_Type_Bool_Exp>;
};


export type Subscription_RootOrganization_Commission_Product_Variation_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganization_Commission_Product_Variation_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Commission_Product_Variation_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Commission_Product_Variation_Type_Bool_Exp>;
};


export type Subscription_RootOrganization_ConfigurationArgs = {
  distinct_on?: InputMaybe<Array<Organization_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Configuration_Order_By>>;
  where?: InputMaybe<Organization_Configuration_Bool_Exp>;
};


export type Subscription_RootOrganization_Configuration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Configuration_Order_By>>;
  where?: InputMaybe<Organization_Configuration_Bool_Exp>;
};


export type Subscription_RootOrganization_Configuration_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganization_Configuration_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Configuration_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Configuration_Bool_Exp>;
};


export type Subscription_RootOrganization_Product_Variation_DiscountArgs = {
  distinct_on?: InputMaybe<Array<Organization_Product_Variation_Discount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Product_Variation_Discount_Order_By>>;
  where?: InputMaybe<Organization_Product_Variation_Discount_Bool_Exp>;
};


export type Subscription_RootOrganization_Product_Variation_Discount_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Product_Variation_Discount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Product_Variation_Discount_Order_By>>;
  where?: InputMaybe<Organization_Product_Variation_Discount_Bool_Exp>;
};


export type Subscription_RootOrganization_Product_Variation_Discount_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganization_Product_Variation_Discount_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Organization_Product_Variation_Discount_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Product_Variation_Discount_History_Order_By>>;
  where?: InputMaybe<Organization_Product_Variation_Discount_History_Bool_Exp>;
};


export type Subscription_RootOrganization_Product_Variation_Discount_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Product_Variation_Discount_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Product_Variation_Discount_History_Order_By>>;
  where?: InputMaybe<Organization_Product_Variation_Discount_History_Bool_Exp>;
};


export type Subscription_RootOrganization_Product_Variation_Discount_History_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganization_Product_Variation_Discount_History_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Product_Variation_Discount_History_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Product_Variation_Discount_History_Bool_Exp>;
};


export type Subscription_RootOrganization_Product_Variation_Discount_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Product_Variation_Discount_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Product_Variation_Discount_Bool_Exp>;
};


export type Subscription_RootOrganization_Sales_ProjectionArgs = {
  distinct_on?: InputMaybe<Array<Organization_Sales_Projection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Sales_Projection_Order_By>>;
  where?: InputMaybe<Organization_Sales_Projection_Bool_Exp>;
};


export type Subscription_RootOrganization_Sales_Projection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Sales_Projection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Sales_Projection_Order_By>>;
  where?: InputMaybe<Organization_Sales_Projection_Bool_Exp>;
};


export type Subscription_RootOrganization_Sales_Projection_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganization_Sales_Projection_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Sales_Projection_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Sales_Projection_Bool_Exp>;
};


export type Subscription_RootOrganization_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Subscription_RootOrganization_TimingArgs = {
  distinct_on?: InputMaybe<Array<Organization_Timing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Timing_Order_By>>;
  where?: InputMaybe<Organization_Timing_Bool_Exp>;
};


export type Subscription_RootOrganization_Timing_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Timing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Timing_Order_By>>;
  where?: InputMaybe<Organization_Timing_Bool_Exp>;
};


export type Subscription_RootOrganization_Timing_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganization_Timing_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Timing_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Timing_Bool_Exp>;
};


export type Subscription_RootOrganization_TypeArgs = {
  distinct_on?: InputMaybe<Array<Organization_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Type_Order_By>>;
  where?: InputMaybe<Organization_Type_Bool_Exp>;
};


export type Subscription_RootOrganization_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Type_Order_By>>;
  where?: InputMaybe<Organization_Type_Bool_Exp>;
};


export type Subscription_RootOrganization_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootOrganization_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Type_Bool_Exp>;
};


export type Subscription_RootOrganization_UserArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Order_By>>;
  where?: InputMaybe<Organization_User_Bool_Exp>;
};


export type Subscription_RootOrganization_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Order_By>>;
  where?: InputMaybe<Organization_User_Bool_Exp>;
};


export type Subscription_RootOrganization_User_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganization_User_CommissionArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Commission_Order_By>>;
  where?: InputMaybe<Organization_User_Commission_Bool_Exp>;
};


export type Subscription_RootOrganization_User_Commission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Commission_Order_By>>;
  where?: InputMaybe<Organization_User_Commission_Bool_Exp>;
};


export type Subscription_RootOrganization_User_Commission_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganization_User_Commission_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_User_Commission_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_User_Commission_Bool_Exp>;
};


export type Subscription_RootOrganization_User_DocumentArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Document_Order_By>>;
  where?: InputMaybe<Organization_User_Document_Bool_Exp>;
};


export type Subscription_RootOrganization_User_Document_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Document_Order_By>>;
  where?: InputMaybe<Organization_User_Document_Bool_Exp>;
};


export type Subscription_RootOrganization_User_Document_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganization_User_Document_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_User_Document_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_User_Document_Bool_Exp>;
};


export type Subscription_RootOrganization_User_PermissionArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Permission_Order_By>>;
  where?: InputMaybe<Organization_User_Permission_Bool_Exp>;
};


export type Subscription_RootOrganization_User_Permission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Permission_Order_By>>;
  where?: InputMaybe<Organization_User_Permission_Bool_Exp>;
};


export type Subscription_RootOrganization_User_Permission_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganization_User_Permission_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_User_Permission_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_User_Permission_Bool_Exp>;
};


export type Subscription_RootOrganization_User_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_User_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_User_Bool_Exp>;
};


export type Subscription_RootOrganization_User_SubsidiaryArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Subsidiary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Subsidiary_Order_By>>;
  where?: InputMaybe<Organization_User_Subsidiary_Bool_Exp>;
};


export type Subscription_RootOrganization_User_Subsidiary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Subsidiary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Subsidiary_Order_By>>;
  where?: InputMaybe<Organization_User_Subsidiary_Bool_Exp>;
};


export type Subscription_RootOrganization_User_Subsidiary_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganization_User_Subsidiary_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_User_Subsidiary_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_User_Subsidiary_Bool_Exp>;
};


export type Subscription_RootOrganization_User_TypeArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Type_Order_By>>;
  where?: InputMaybe<Organization_User_Type_Bool_Exp>;
};


export type Subscription_RootOrganization_User_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Type_Order_By>>;
  where?: InputMaybe<Organization_User_Type_Bool_Exp>;
};


export type Subscription_RootOrganization_User_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootOrganization_User_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_User_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_User_Type_Bool_Exp>;
};


export type Subscription_RootOwnership_TypeArgs = {
  distinct_on?: InputMaybe<Array<Ownership_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ownership_Type_Order_By>>;
  where?: InputMaybe<Ownership_Type_Bool_Exp>;
};


export type Subscription_RootOwnership_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ownership_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ownership_Type_Order_By>>;
  where?: InputMaybe<Ownership_Type_Bool_Exp>;
};


export type Subscription_RootOwnership_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootOwnership_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ownership_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Ownership_Type_Bool_Exp>;
};


export type Subscription_RootPartnerArgs = {
  distinct_on?: InputMaybe<Array<Partner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_By>>;
  where?: InputMaybe<Partner_Bool_Exp>;
};


export type Subscription_RootPartner_AddressArgs = {
  distinct_on?: InputMaybe<Array<Partner_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Address_Order_By>>;
  where?: InputMaybe<Partner_Address_Bool_Exp>;
};


export type Subscription_RootPartner_Address_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Address_Order_By>>;
  where?: InputMaybe<Partner_Address_Bool_Exp>;
};


export type Subscription_RootPartner_Address_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPartner_Address_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Partner_Address_Stream_Cursor_Input>>;
  where?: InputMaybe<Partner_Address_Bool_Exp>;
};


export type Subscription_RootPartner_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_By>>;
  where?: InputMaybe<Partner_Bool_Exp>;
};


export type Subscription_RootPartner_Bank_DetailsArgs = {
  distinct_on?: InputMaybe<Array<Partner_Bank_Details_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Bank_Details_Order_By>>;
  where?: InputMaybe<Partner_Bank_Details_Bool_Exp>;
};


export type Subscription_RootPartner_Bank_Details_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Bank_Details_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Bank_Details_Order_By>>;
  where?: InputMaybe<Partner_Bank_Details_Bool_Exp>;
};


export type Subscription_RootPartner_Bank_Details_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPartner_Bank_Details_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Partner_Bank_Details_Stream_Cursor_Input>>;
  where?: InputMaybe<Partner_Bank_Details_Bool_Exp>;
};


export type Subscription_RootPartner_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPartner_CommissionArgs = {
  distinct_on?: InputMaybe<Array<Partner_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Commission_Order_By>>;
  where?: InputMaybe<Partner_Commission_Bool_Exp>;
};


export type Subscription_RootPartner_Commission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Commission_Order_By>>;
  where?: InputMaybe<Partner_Commission_Bool_Exp>;
};


export type Subscription_RootPartner_Commission_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPartner_Commission_Product_Variation_TypeArgs = {
  distinct_on?: InputMaybe<Array<Partner_Commission_Product_Variation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Commission_Product_Variation_Type_Order_By>>;
  where?: InputMaybe<Partner_Commission_Product_Variation_Type_Bool_Exp>;
};


export type Subscription_RootPartner_Commission_Product_Variation_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Commission_Product_Variation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Commission_Product_Variation_Type_Order_By>>;
  where?: InputMaybe<Partner_Commission_Product_Variation_Type_Bool_Exp>;
};


export type Subscription_RootPartner_Commission_Product_Variation_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPartner_Commission_Product_Variation_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Partner_Commission_Product_Variation_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Partner_Commission_Product_Variation_Type_Bool_Exp>;
};


export type Subscription_RootPartner_Commission_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Partner_Commission_Stream_Cursor_Input>>;
  where?: InputMaybe<Partner_Commission_Bool_Exp>;
};


export type Subscription_RootPartner_Contact_TypeArgs = {
  distinct_on?: InputMaybe<Array<Partner_Contact_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Contact_Type_Order_By>>;
  where?: InputMaybe<Partner_Contact_Type_Bool_Exp>;
};


export type Subscription_RootPartner_Contact_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Contact_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Contact_Type_Order_By>>;
  where?: InputMaybe<Partner_Contact_Type_Bool_Exp>;
};


export type Subscription_RootPartner_Contact_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootPartner_Contact_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Partner_Contact_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Partner_Contact_Type_Bool_Exp>;
};


export type Subscription_RootPartner_LocalitiesArgs = {
  distinct_on?: InputMaybe<Array<Partner_Localities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Localities_Order_By>>;
  where?: InputMaybe<Partner_Localities_Bool_Exp>;
};


export type Subscription_RootPartner_Localities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Localities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Localities_Order_By>>;
  where?: InputMaybe<Partner_Localities_Bool_Exp>;
};


export type Subscription_RootPartner_Localities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPartner_Localities_SlotsArgs = {
  distinct_on?: InputMaybe<Array<Partner_Localities_Slots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Localities_Slots_Order_By>>;
  where?: InputMaybe<Partner_Localities_Slots_Bool_Exp>;
};


export type Subscription_RootPartner_Localities_Slots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Localities_Slots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Localities_Slots_Order_By>>;
  where?: InputMaybe<Partner_Localities_Slots_Bool_Exp>;
};


export type Subscription_RootPartner_Localities_Slots_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPartner_Localities_Slots_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Partner_Localities_Slots_Stream_Cursor_Input>>;
  where?: InputMaybe<Partner_Localities_Slots_Bool_Exp>;
};


export type Subscription_RootPartner_Localities_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Partner_Localities_Stream_Cursor_Input>>;
  where?: InputMaybe<Partner_Localities_Bool_Exp>;
};


export type Subscription_RootPartner_OrderArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Order_By>>;
  where?: InputMaybe<Partner_Order_Bool_Exp>;
};


export type Subscription_RootPartner_Order_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Order_By>>;
  where?: InputMaybe<Partner_Order_Bool_Exp>;
};


export type Subscription_RootPartner_Order_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPartner_Order_Customer_AssetArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Customer_Asset_Order_By>>;
  where?: InputMaybe<Partner_Order_Customer_Asset_Bool_Exp>;
};


export type Subscription_RootPartner_Order_Customer_Asset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Customer_Asset_Order_By>>;
  where?: InputMaybe<Partner_Order_Customer_Asset_Bool_Exp>;
};


export type Subscription_RootPartner_Order_Customer_Asset_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPartner_Order_Customer_Asset_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Partner_Order_Customer_Asset_Stream_Cursor_Input>>;
  where?: InputMaybe<Partner_Order_Customer_Asset_Bool_Exp>;
};


export type Subscription_RootPartner_Order_ItemArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Bool_Exp>;
};


export type Subscription_RootPartner_Order_Item_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Bool_Exp>;
};


export type Subscription_RootPartner_Order_Item_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPartner_Order_Item_CommissionArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Commission_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Commission_Bool_Exp>;
};


export type Subscription_RootPartner_Order_Item_Commission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Commission_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Commission_Bool_Exp>;
};


export type Subscription_RootPartner_Order_Item_Commission_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPartner_Order_Item_Commission_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Partner_Order_Item_Commission_Stream_Cursor_Input>>;
  where?: InputMaybe<Partner_Order_Item_Commission_Bool_Exp>;
};


export type Subscription_RootPartner_Order_Item_StateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_State_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_State_Bool_Exp>;
};


export type Subscription_RootPartner_Order_Item_State_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_State_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_State_Bool_Exp>;
};


export type Subscription_RootPartner_Order_Item_State_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootPartner_Order_Item_State_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Partner_Order_Item_State_Stream_Cursor_Input>>;
  where?: InputMaybe<Partner_Order_Item_State_Bool_Exp>;
};


export type Subscription_RootPartner_Order_Item_StateflowArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Stateflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Stateflow_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Stateflow_Bool_Exp>;
};


export type Subscription_RootPartner_Order_Item_Stateflow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Stateflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Stateflow_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Stateflow_Bool_Exp>;
};


export type Subscription_RootPartner_Order_Item_Stateflow_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPartner_Order_Item_Stateflow_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Partner_Order_Item_Stateflow_Stream_Cursor_Input>>;
  where?: InputMaybe<Partner_Order_Item_Stateflow_Bool_Exp>;
};


export type Subscription_RootPartner_Order_Item_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Partner_Order_Item_Stream_Cursor_Input>>;
  where?: InputMaybe<Partner_Order_Item_Bool_Exp>;
};


export type Subscription_RootPartner_Order_Item_Test_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Test_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Test_Category_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Test_Category_Bool_Exp>;
};


export type Subscription_RootPartner_Order_Item_Test_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Test_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Test_Category_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Test_Category_Bool_Exp>;
};


export type Subscription_RootPartner_Order_Item_Test_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPartner_Order_Item_Test_Category_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Partner_Order_Item_Test_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Partner_Order_Item_Test_Category_Bool_Exp>;
};


export type Subscription_RootPartner_Order_Item_Test_ResultsArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Test_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Test_Results_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Test_Results_Bool_Exp>;
};


export type Subscription_RootPartner_Order_Item_Test_Results_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Test_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Test_Results_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Test_Results_Bool_Exp>;
};


export type Subscription_RootPartner_Order_Item_Test_Results_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPartner_Order_Item_Test_Results_PhotosArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Test_Results_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Test_Results_Photos_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Test_Results_Photos_Bool_Exp>;
};


export type Subscription_RootPartner_Order_Item_Test_Results_Photos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Test_Results_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Test_Results_Photos_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Test_Results_Photos_Bool_Exp>;
};


export type Subscription_RootPartner_Order_Item_Test_Results_Photos_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPartner_Order_Item_Test_Results_Photos_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Partner_Order_Item_Test_Results_Photos_Stream_Cursor_Input>>;
  where?: InputMaybe<Partner_Order_Item_Test_Results_Photos_Bool_Exp>;
};


export type Subscription_RootPartner_Order_Item_Test_Results_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Partner_Order_Item_Test_Results_Stream_Cursor_Input>>;
  where?: InputMaybe<Partner_Order_Item_Test_Results_Bool_Exp>;
};


export type Subscription_RootPartner_Order_Item_ValueArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Value_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Value_Bool_Exp>;
};


export type Subscription_RootPartner_Order_Item_Value_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Value_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Value_Bool_Exp>;
};


export type Subscription_RootPartner_Order_Item_Value_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPartner_Order_Item_Value_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Partner_Order_Item_Value_Stream_Cursor_Input>>;
  where?: InputMaybe<Partner_Order_Item_Value_Bool_Exp>;
};


export type Subscription_RootPartner_Order_Partner_User_DocumentArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Partner_User_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Partner_User_Document_Order_By>>;
  where?: InputMaybe<Partner_Order_Partner_User_Document_Bool_Exp>;
};


export type Subscription_RootPartner_Order_Partner_User_Document_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Partner_User_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Partner_User_Document_Order_By>>;
  where?: InputMaybe<Partner_Order_Partner_User_Document_Bool_Exp>;
};


export type Subscription_RootPartner_Order_Partner_User_Document_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPartner_Order_Partner_User_Document_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Partner_Order_Partner_User_Document_Stream_Cursor_Input>>;
  where?: InputMaybe<Partner_Order_Partner_User_Document_Bool_Exp>;
};


export type Subscription_RootPartner_Order_StateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_State_Order_By>>;
  where?: InputMaybe<Partner_Order_State_Bool_Exp>;
};


export type Subscription_RootPartner_Order_State_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_State_Order_By>>;
  where?: InputMaybe<Partner_Order_State_Bool_Exp>;
};


export type Subscription_RootPartner_Order_State_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootPartner_Order_State_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Partner_Order_State_Stream_Cursor_Input>>;
  where?: InputMaybe<Partner_Order_State_Bool_Exp>;
};


export type Subscription_RootPartner_Order_StateflowArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Stateflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Stateflow_Order_By>>;
  where?: InputMaybe<Partner_Order_Stateflow_Bool_Exp>;
};


export type Subscription_RootPartner_Order_Stateflow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Stateflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Stateflow_Order_By>>;
  where?: InputMaybe<Partner_Order_Stateflow_Bool_Exp>;
};


export type Subscription_RootPartner_Order_Stateflow_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPartner_Order_Stateflow_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Partner_Order_Stateflow_Stream_Cursor_Input>>;
  where?: InputMaybe<Partner_Order_Stateflow_Bool_Exp>;
};


export type Subscription_RootPartner_Order_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Partner_Order_Stream_Cursor_Input>>;
  where?: InputMaybe<Partner_Order_Bool_Exp>;
};


export type Subscription_RootPartner_PaymentArgs = {
  distinct_on?: InputMaybe<Array<Partner_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Payment_Order_By>>;
  where?: InputMaybe<Partner_Payment_Bool_Exp>;
};


export type Subscription_RootPartner_Payment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Payment_Order_By>>;
  where?: InputMaybe<Partner_Payment_Bool_Exp>;
};


export type Subscription_RootPartner_Payment_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPartner_Payment_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Partner_Payment_Stream_Cursor_Input>>;
  where?: InputMaybe<Partner_Payment_Bool_Exp>;
};


export type Subscription_RootPartner_ProductArgs = {
  distinct_on?: InputMaybe<Array<Partner_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Product_Order_By>>;
  where?: InputMaybe<Partner_Product_Bool_Exp>;
};


export type Subscription_RootPartner_Product_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Product_Order_By>>;
  where?: InputMaybe<Partner_Product_Bool_Exp>;
};


export type Subscription_RootPartner_Product_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPartner_Product_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Partner_Product_Stream_Cursor_Input>>;
  where?: InputMaybe<Partner_Product_Bool_Exp>;
};


export type Subscription_RootPartner_RelationshipArgs = {
  distinct_on?: InputMaybe<Array<Partner_Relationship_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Relationship_Order_By>>;
  where?: InputMaybe<Partner_Relationship_Bool_Exp>;
};


export type Subscription_RootPartner_Relationship_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Relationship_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Relationship_Order_By>>;
  where?: InputMaybe<Partner_Relationship_Bool_Exp>;
};


export type Subscription_RootPartner_Relationship_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPartner_Relationship_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Partner_Relationship_Stream_Cursor_Input>>;
  where?: InputMaybe<Partner_Relationship_Bool_Exp>;
};


export type Subscription_RootPartner_SellerArgs = {
  distinct_on?: InputMaybe<Array<Partner_Seller_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Seller_Order_By>>;
  where?: InputMaybe<Partner_Seller_Bool_Exp>;
};


export type Subscription_RootPartner_Seller_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Seller_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Seller_Order_By>>;
  where?: InputMaybe<Partner_Seller_Bool_Exp>;
};


export type Subscription_RootPartner_Seller_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPartner_Seller_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Partner_Seller_Stream_Cursor_Input>>;
  where?: InputMaybe<Partner_Seller_Bool_Exp>;
};


export type Subscription_RootPartner_Seller_TypeArgs = {
  distinct_on?: InputMaybe<Array<Partner_Seller_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Seller_Type_Order_By>>;
  where?: InputMaybe<Partner_Seller_Type_Bool_Exp>;
};


export type Subscription_RootPartner_Seller_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Seller_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Seller_Type_Order_By>>;
  where?: InputMaybe<Partner_Seller_Type_Bool_Exp>;
};


export type Subscription_RootPartner_Seller_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPartner_Seller_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Partner_Seller_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Partner_Seller_Type_Bool_Exp>;
};


export type Subscription_RootPartner_Signing_AuthorityArgs = {
  distinct_on?: InputMaybe<Array<Partner_Signing_Authority_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Signing_Authority_Order_By>>;
  where?: InputMaybe<Partner_Signing_Authority_Bool_Exp>;
};


export type Subscription_RootPartner_Signing_Authority_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Signing_Authority_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Signing_Authority_Order_By>>;
  where?: InputMaybe<Partner_Signing_Authority_Bool_Exp>;
};


export type Subscription_RootPartner_Signing_Authority_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPartner_Signing_Authority_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Partner_Signing_Authority_Stream_Cursor_Input>>;
  where?: InputMaybe<Partner_Signing_Authority_Bool_Exp>;
};


export type Subscription_RootPartner_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Partner_Stream_Cursor_Input>>;
  where?: InputMaybe<Partner_Bool_Exp>;
};


export type Subscription_RootPartner_TimingArgs = {
  distinct_on?: InputMaybe<Array<Partner_Timing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Timing_Order_By>>;
  where?: InputMaybe<Partner_Timing_Bool_Exp>;
};


export type Subscription_RootPartner_Timing_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Timing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Timing_Order_By>>;
  where?: InputMaybe<Partner_Timing_Bool_Exp>;
};


export type Subscription_RootPartner_Timing_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPartner_Timing_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Partner_Timing_Stream_Cursor_Input>>;
  where?: InputMaybe<Partner_Timing_Bool_Exp>;
};


export type Subscription_RootPartner_TypeArgs = {
  distinct_on?: InputMaybe<Array<Partner_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Type_Order_By>>;
  where?: InputMaybe<Partner_Type_Bool_Exp>;
};


export type Subscription_RootPartner_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Type_Order_By>>;
  where?: InputMaybe<Partner_Type_Bool_Exp>;
};


export type Subscription_RootPartner_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootPartner_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Partner_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Partner_Type_Bool_Exp>;
};


export type Subscription_RootPartner_UserArgs = {
  distinct_on?: InputMaybe<Array<Partner_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_User_Order_By>>;
  where?: InputMaybe<Partner_User_Bool_Exp>;
};


export type Subscription_RootPartner_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_User_Order_By>>;
  where?: InputMaybe<Partner_User_Bool_Exp>;
};


export type Subscription_RootPartner_User_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPartner_User_DocumentArgs = {
  distinct_on?: InputMaybe<Array<Partner_User_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_User_Document_Order_By>>;
  where?: InputMaybe<Partner_User_Document_Bool_Exp>;
};


export type Subscription_RootPartner_User_Document_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_User_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_User_Document_Order_By>>;
  where?: InputMaybe<Partner_User_Document_Bool_Exp>;
};


export type Subscription_RootPartner_User_Document_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPartner_User_Document_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Partner_User_Document_Stream_Cursor_Input>>;
  where?: InputMaybe<Partner_User_Document_Bool_Exp>;
};


export type Subscription_RootPartner_User_PermissionArgs = {
  distinct_on?: InputMaybe<Array<Partner_User_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_User_Permission_Order_By>>;
  where?: InputMaybe<Partner_User_Permission_Bool_Exp>;
};


export type Subscription_RootPartner_User_Permission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_User_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_User_Permission_Order_By>>;
  where?: InputMaybe<Partner_User_Permission_Bool_Exp>;
};


export type Subscription_RootPartner_User_Permission_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPartner_User_Permission_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Partner_User_Permission_Stream_Cursor_Input>>;
  where?: InputMaybe<Partner_User_Permission_Bool_Exp>;
};


export type Subscription_RootPartner_User_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Partner_User_Stream_Cursor_Input>>;
  where?: InputMaybe<Partner_User_Bool_Exp>;
};


export type Subscription_RootPartner_VehicleArgs = {
  distinct_on?: InputMaybe<Array<Partner_Vehicle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Vehicle_Order_By>>;
  where?: InputMaybe<Partner_Vehicle_Bool_Exp>;
};


export type Subscription_RootPartner_Vehicle_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Vehicle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Vehicle_Order_By>>;
  where?: InputMaybe<Partner_Vehicle_Bool_Exp>;
};


export type Subscription_RootPartner_Vehicle_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPartner_Vehicle_StateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Vehicle_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Vehicle_State_Order_By>>;
  where?: InputMaybe<Partner_Vehicle_State_Bool_Exp>;
};


export type Subscription_RootPartner_Vehicle_State_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Vehicle_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Vehicle_State_Order_By>>;
  where?: InputMaybe<Partner_Vehicle_State_Bool_Exp>;
};


export type Subscription_RootPartner_Vehicle_State_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootPartner_Vehicle_State_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Partner_Vehicle_State_Stream_Cursor_Input>>;
  where?: InputMaybe<Partner_Vehicle_State_Bool_Exp>;
};


export type Subscription_RootPartner_Vehicle_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Partner_Vehicle_Stream_Cursor_Input>>;
  where?: InputMaybe<Partner_Vehicle_Bool_Exp>;
};


export type Subscription_RootPayment_TypeArgs = {
  distinct_on?: InputMaybe<Array<Payment_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Type_Order_By>>;
  where?: InputMaybe<Payment_Type_Bool_Exp>;
};


export type Subscription_RootPayment_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Type_Order_By>>;
  where?: InputMaybe<Payment_Type_Bool_Exp>;
};


export type Subscription_RootPayment_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootPayment_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Payment_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Payment_Type_Bool_Exp>;
};


export type Subscription_RootPeriod_FrequencyArgs = {
  distinct_on?: InputMaybe<Array<Period_Frequency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Period_Frequency_Order_By>>;
  where?: InputMaybe<Period_Frequency_Bool_Exp>;
};


export type Subscription_RootPeriod_Frequency_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Period_Frequency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Period_Frequency_Order_By>>;
  where?: InputMaybe<Period_Frequency_Bool_Exp>;
};


export type Subscription_RootPeriod_Frequency_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootPeriod_Frequency_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Period_Frequency_Stream_Cursor_Input>>;
  where?: InputMaybe<Period_Frequency_Bool_Exp>;
};


export type Subscription_RootPermissionArgs = {
  distinct_on?: InputMaybe<Array<Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permission_Order_By>>;
  where?: InputMaybe<Permission_Bool_Exp>;
};


export type Subscription_RootPermission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permission_Order_By>>;
  where?: InputMaybe<Permission_Bool_Exp>;
};


export type Subscription_RootPermission_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPermission_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Permission_Stream_Cursor_Input>>;
  where?: InputMaybe<Permission_Bool_Exp>;
};


export type Subscription_RootPermitArgs = {
  distinct_on?: InputMaybe<Array<Permit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permit_Order_By>>;
  where?: InputMaybe<Permit_Bool_Exp>;
};


export type Subscription_RootPermit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Permit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permit_Order_By>>;
  where?: InputMaybe<Permit_Bool_Exp>;
};


export type Subscription_RootPermit_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPermit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Permit_Stream_Cursor_Input>>;
  where?: InputMaybe<Permit_Bool_Exp>;
};


export type Subscription_RootPhoto_TypeArgs = {
  distinct_on?: InputMaybe<Array<Photo_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Photo_Type_Order_By>>;
  where?: InputMaybe<Photo_Type_Bool_Exp>;
};


export type Subscription_RootPhoto_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Photo_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Photo_Type_Order_By>>;
  where?: InputMaybe<Photo_Type_Bool_Exp>;
};


export type Subscription_RootPhoto_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootPhoto_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Photo_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Photo_Type_Bool_Exp>;
};


export type Subscription_RootPlanning_Audit_LogArgs = {
  distinct_on?: InputMaybe<Array<Planning_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Planning_Audit_Log_Order_By>>;
  where?: InputMaybe<Planning_Audit_Log_Bool_Exp>;
};


export type Subscription_RootPlanning_Audit_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Planning_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Planning_Audit_Log_Order_By>>;
  where?: InputMaybe<Planning_Audit_Log_Bool_Exp>;
};


export type Subscription_RootPlanning_Audit_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPlanning_Audit_Log_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Planning_Audit_Log_Stream_Cursor_Input>>;
  where?: InputMaybe<Planning_Audit_Log_Bool_Exp>;
};


export type Subscription_RootPlanning_PeriodArgs = {
  distinct_on?: InputMaybe<Array<Planning_Period_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Planning_Period_Order_By>>;
  where?: InputMaybe<Planning_Period_Bool_Exp>;
};


export type Subscription_RootPlanning_Period_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Planning_Period_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Planning_Period_Order_By>>;
  where?: InputMaybe<Planning_Period_Bool_Exp>;
};


export type Subscription_RootPlanning_Period_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPlanning_Period_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Planning_Period_Stream_Cursor_Input>>;
  where?: InputMaybe<Planning_Period_Bool_Exp>;
};


export type Subscription_RootProductArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Subscription_RootProduct_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Subscription_RootProduct_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProduct_CommissionArgs = {
  distinct_on?: InputMaybe<Array<Product_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Commission_Order_By>>;
  where?: InputMaybe<Product_Commission_Bool_Exp>;
};


export type Subscription_RootProduct_Commission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Commission_Order_By>>;
  where?: InputMaybe<Product_Commission_Bool_Exp>;
};


export type Subscription_RootProduct_Commission_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProduct_Commission_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Product_Commission_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Commission_Bool_Exp>;
};


export type Subscription_RootProduct_DocumentArgs = {
  distinct_on?: InputMaybe<Array<Product_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Document_Order_By>>;
  where?: InputMaybe<Product_Document_Bool_Exp>;
};


export type Subscription_RootProduct_Document_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Document_Order_By>>;
  where?: InputMaybe<Product_Document_Bool_Exp>;
};


export type Subscription_RootProduct_Document_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProduct_Document_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Product_Document_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Document_Bool_Exp>;
};


export type Subscription_RootProduct_Partner_Localities_PriceArgs = {
  distinct_on?: InputMaybe<Array<Product_Partner_Localities_Price_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Partner_Localities_Price_Order_By>>;
  where?: InputMaybe<Product_Partner_Localities_Price_Bool_Exp>;
};


export type Subscription_RootProduct_Partner_Localities_Price_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Partner_Localities_Price_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Partner_Localities_Price_Order_By>>;
  where?: InputMaybe<Product_Partner_Localities_Price_Bool_Exp>;
};


export type Subscription_RootProduct_Partner_Localities_Price_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProduct_Partner_Localities_Price_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Product_Partner_Localities_Price_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Partner_Localities_Price_History_Order_By>>;
  where?: InputMaybe<Product_Partner_Localities_Price_History_Bool_Exp>;
};


export type Subscription_RootProduct_Partner_Localities_Price_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Partner_Localities_Price_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Partner_Localities_Price_History_Order_By>>;
  where?: InputMaybe<Product_Partner_Localities_Price_History_Bool_Exp>;
};


export type Subscription_RootProduct_Partner_Localities_Price_History_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProduct_Partner_Localities_Price_History_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Product_Partner_Localities_Price_History_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Partner_Localities_Price_History_Bool_Exp>;
};


export type Subscription_RootProduct_Partner_Localities_Price_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Product_Partner_Localities_Price_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Partner_Localities_Price_Bool_Exp>;
};


export type Subscription_RootProduct_PhotosArgs = {
  distinct_on?: InputMaybe<Array<Product_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Photos_Order_By>>;
  where?: InputMaybe<Product_Photos_Bool_Exp>;
};


export type Subscription_RootProduct_Photos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Photos_Order_By>>;
  where?: InputMaybe<Product_Photos_Bool_Exp>;
};


export type Subscription_RootProduct_Photos_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProduct_Photos_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Product_Photos_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Photos_Bool_Exp>;
};


export type Subscription_RootProduct_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Product_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Subscription_RootProduct_TypeArgs = {
  distinct_on?: InputMaybe<Array<Product_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Type_Order_By>>;
  where?: InputMaybe<Product_Type_Bool_Exp>;
};


export type Subscription_RootProduct_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Type_Order_By>>;
  where?: InputMaybe<Product_Type_Bool_Exp>;
};


export type Subscription_RootProduct_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootProduct_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Product_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Type_Bool_Exp>;
};


export type Subscription_RootProduct_VariationArgs = {
  distinct_on?: InputMaybe<Array<Product_Variation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Variation_Order_By>>;
  where?: InputMaybe<Product_Variation_Bool_Exp>;
};


export type Subscription_RootProduct_Variation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Variation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Variation_Order_By>>;
  where?: InputMaybe<Product_Variation_Bool_Exp>;
};


export type Subscription_RootProduct_Variation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProduct_Variation_Partner_Localities_SlotsArgs = {
  distinct_on?: InputMaybe<Array<Product_Variation_Partner_Localities_Slots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Variation_Partner_Localities_Slots_Order_By>>;
  where?: InputMaybe<Product_Variation_Partner_Localities_Slots_Bool_Exp>;
};


export type Subscription_RootProduct_Variation_Partner_Localities_Slots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Variation_Partner_Localities_Slots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Variation_Partner_Localities_Slots_Order_By>>;
  where?: InputMaybe<Product_Variation_Partner_Localities_Slots_Bool_Exp>;
};


export type Subscription_RootProduct_Variation_Partner_Localities_Slots_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProduct_Variation_Partner_Localities_Slots_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Product_Variation_Partner_Localities_Slots_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Variation_Partner_Localities_Slots_Bool_Exp>;
};


export type Subscription_RootProduct_Variation_PhotosArgs = {
  distinct_on?: InputMaybe<Array<Product_Variation_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Variation_Photos_Order_By>>;
  where?: InputMaybe<Product_Variation_Photos_Bool_Exp>;
};


export type Subscription_RootProduct_Variation_Photos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Variation_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Variation_Photos_Order_By>>;
  where?: InputMaybe<Product_Variation_Photos_Bool_Exp>;
};


export type Subscription_RootProduct_Variation_Photos_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProduct_Variation_Photos_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Product_Variation_Photos_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Variation_Photos_Bool_Exp>;
};


export type Subscription_RootProduct_Variation_Safety_Checklist_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Product_Variation_Safety_Checklist_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Variation_Safety_Checklist_Category_Order_By>>;
  where?: InputMaybe<Product_Variation_Safety_Checklist_Category_Bool_Exp>;
};


export type Subscription_RootProduct_Variation_Safety_Checklist_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Variation_Safety_Checklist_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Variation_Safety_Checklist_Category_Order_By>>;
  where?: InputMaybe<Product_Variation_Safety_Checklist_Category_Bool_Exp>;
};


export type Subscription_RootProduct_Variation_Safety_Checklist_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProduct_Variation_Safety_Checklist_Category_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Product_Variation_Safety_Checklist_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Variation_Safety_Checklist_Category_Bool_Exp>;
};


export type Subscription_RootProduct_Variation_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Product_Variation_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Variation_Bool_Exp>;
};


export type Subscription_RootProduct_Variation_Test_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Product_Variation_Test_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Variation_Test_Category_Order_By>>;
  where?: InputMaybe<Product_Variation_Test_Category_Bool_Exp>;
};


export type Subscription_RootProduct_Variation_Test_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Variation_Test_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Variation_Test_Category_Order_By>>;
  where?: InputMaybe<Product_Variation_Test_Category_Bool_Exp>;
};


export type Subscription_RootProduct_Variation_Test_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProduct_Variation_Test_Category_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Product_Variation_Test_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Variation_Test_Category_Bool_Exp>;
};


export type Subscription_RootPurchase_OrderArgs = {
  distinct_on?: InputMaybe<Array<Purchase_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Purchase_Order_Order_By>>;
  where?: InputMaybe<Purchase_Order_Bool_Exp>;
};


export type Subscription_RootPurchase_Order_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Purchase_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Purchase_Order_Order_By>>;
  where?: InputMaybe<Purchase_Order_Bool_Exp>;
};


export type Subscription_RootPurchase_Order_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPurchase_Order_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Purchase_Order_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Purchase_Order_Items_Order_By>>;
  where?: InputMaybe<Purchase_Order_Items_Bool_Exp>;
};


export type Subscription_RootPurchase_Order_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Purchase_Order_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Purchase_Order_Items_Order_By>>;
  where?: InputMaybe<Purchase_Order_Items_Bool_Exp>;
};


export type Subscription_RootPurchase_Order_Items_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPurchase_Order_Items_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Purchase_Order_Items_Stream_Cursor_Input>>;
  where?: InputMaybe<Purchase_Order_Items_Bool_Exp>;
};


export type Subscription_RootPurchase_Order_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Purchase_Order_Stream_Cursor_Input>>;
  where?: InputMaybe<Purchase_Order_Bool_Exp>;
};


export type Subscription_RootQuantity_Correction_Ticket_StatesArgs = {
  distinct_on?: InputMaybe<Array<Quantity_Correction_Ticket_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quantity_Correction_Ticket_States_Order_By>>;
  where?: InputMaybe<Quantity_Correction_Ticket_States_Bool_Exp>;
};


export type Subscription_RootQuantity_Correction_Ticket_States_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quantity_Correction_Ticket_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quantity_Correction_Ticket_States_Order_By>>;
  where?: InputMaybe<Quantity_Correction_Ticket_States_Bool_Exp>;
};


export type Subscription_RootQuantity_Correction_Ticket_States_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootQuantity_Correction_Ticket_States_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quantity_Correction_Ticket_States_Stream_Cursor_Input>>;
  where?: InputMaybe<Quantity_Correction_Ticket_States_Bool_Exp>;
};


export type Subscription_RootQuantity_Correction_TicketsArgs = {
  distinct_on?: InputMaybe<Array<Quantity_Correction_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quantity_Correction_Tickets_Order_By>>;
  where?: InputMaybe<Quantity_Correction_Tickets_Bool_Exp>;
};


export type Subscription_RootQuantity_Correction_Tickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quantity_Correction_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quantity_Correction_Tickets_Order_By>>;
  where?: InputMaybe<Quantity_Correction_Tickets_Bool_Exp>;
};


export type Subscription_RootQuantity_Correction_Tickets_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQuantity_Correction_Tickets_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quantity_Correction_Tickets_Stream_Cursor_Input>>;
  where?: InputMaybe<Quantity_Correction_Tickets_Bool_Exp>;
};


export type Subscription_RootReason_TypeArgs = {
  distinct_on?: InputMaybe<Array<Reason_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reason_Type_Order_By>>;
  where?: InputMaybe<Reason_Type_Bool_Exp>;
};


export type Subscription_RootReason_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reason_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reason_Type_Order_By>>;
  where?: InputMaybe<Reason_Type_Bool_Exp>;
};


export type Subscription_RootReason_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootReason_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Reason_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Reason_Type_Bool_Exp>;
};


export type Subscription_RootReasonsArgs = {
  distinct_on?: InputMaybe<Array<Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reasons_Order_By>>;
  where?: InputMaybe<Reasons_Bool_Exp>;
};


export type Subscription_RootReasons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reasons_Order_By>>;
  where?: InputMaybe<Reasons_Bool_Exp>;
};


export type Subscription_RootReasons_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootReasons_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Reasons_Stream_Cursor_Input>>;
  where?: InputMaybe<Reasons_Bool_Exp>;
};


export type Subscription_RootRoleArgs = {
  distinct_on?: InputMaybe<Array<Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Role_Order_By>>;
  where?: InputMaybe<Role_Bool_Exp>;
};


export type Subscription_RootRole_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Role_Order_By>>;
  where?: InputMaybe<Role_Bool_Exp>;
};


export type Subscription_RootRole_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRole_DocumentArgs = {
  distinct_on?: InputMaybe<Array<Role_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Role_Document_Order_By>>;
  where?: InputMaybe<Role_Document_Bool_Exp>;
};


export type Subscription_RootRole_Document_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Role_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Role_Document_Order_By>>;
  where?: InputMaybe<Role_Document_Bool_Exp>;
};


export type Subscription_RootRole_Document_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRole_Document_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Role_Document_Stream_Cursor_Input>>;
  where?: InputMaybe<Role_Document_Bool_Exp>;
};


export type Subscription_RootRole_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Role_Stream_Cursor_Input>>;
  where?: InputMaybe<Role_Bool_Exp>;
};


export type Subscription_RootSafety_ChecklistArgs = {
  distinct_on?: InputMaybe<Array<Safety_Checklist_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Checklist_Order_By>>;
  where?: InputMaybe<Safety_Checklist_Bool_Exp>;
};


export type Subscription_RootSafety_Checklist_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Safety_Checklist_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Checklist_Order_By>>;
  where?: InputMaybe<Safety_Checklist_Bool_Exp>;
};


export type Subscription_RootSafety_Checklist_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSafety_Checklist_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Safety_Checklist_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Checklist_Category_Order_By>>;
  where?: InputMaybe<Safety_Checklist_Category_Bool_Exp>;
};


export type Subscription_RootSafety_Checklist_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Safety_Checklist_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Checklist_Category_Order_By>>;
  where?: InputMaybe<Safety_Checklist_Category_Bool_Exp>;
};


export type Subscription_RootSafety_Checklist_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSafety_Checklist_Category_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Safety_Checklist_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Safety_Checklist_Category_Bool_Exp>;
};


export type Subscription_RootSafety_Checklist_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Safety_Checklist_Stream_Cursor_Input>>;
  where?: InputMaybe<Safety_Checklist_Bool_Exp>;
};


export type Subscription_RootScript_TypeArgs = {
  distinct_on?: InputMaybe<Array<Script_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Script_Type_Order_By>>;
  where?: InputMaybe<Script_Type_Bool_Exp>;
};


export type Subscription_RootScript_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Script_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Script_Type_Order_By>>;
  where?: InputMaybe<Script_Type_Bool_Exp>;
};


export type Subscription_RootScript_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootScript_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Script_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Script_Type_Bool_Exp>;
};


export type Subscription_RootScriptsArgs = {
  distinct_on?: InputMaybe<Array<Scripts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scripts_Order_By>>;
  where?: InputMaybe<Scripts_Bool_Exp>;
};


export type Subscription_RootScripts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scripts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scripts_Order_By>>;
  where?: InputMaybe<Scripts_Bool_Exp>;
};


export type Subscription_RootScripts_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootScripts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Scripts_Stream_Cursor_Input>>;
  where?: InputMaybe<Scripts_Bool_Exp>;
};


export type Subscription_RootServicesArgs = {
  distinct_on?: InputMaybe<Array<Services_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Services_Order_By>>;
  where?: InputMaybe<Services_Bool_Exp>;
};


export type Subscription_RootServices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Services_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Services_Order_By>>;
  where?: InputMaybe<Services_Bool_Exp>;
};


export type Subscription_RootServices_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootServices_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Services_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Services_Category_Order_By>>;
  where?: InputMaybe<Services_Category_Bool_Exp>;
};


export type Subscription_RootServices_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Services_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Services_Category_Order_By>>;
  where?: InputMaybe<Services_Category_Bool_Exp>;
};


export type Subscription_RootServices_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootServices_Category_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Services_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Services_Category_Bool_Exp>;
};


export type Subscription_RootServices_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Services_Stream_Cursor_Input>>;
  where?: InputMaybe<Services_Bool_Exp>;
};


export type Subscription_RootShift_ScheduleArgs = {
  distinct_on?: InputMaybe<Array<Shift_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shift_Schedule_Order_By>>;
  where?: InputMaybe<Shift_Schedule_Bool_Exp>;
};


export type Subscription_RootShift_Schedule_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shift_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shift_Schedule_Order_By>>;
  where?: InputMaybe<Shift_Schedule_Bool_Exp>;
};


export type Subscription_RootShift_Schedule_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootShift_Schedule_DispenserArgs = {
  distinct_on?: InputMaybe<Array<Shift_Schedule_Dispenser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shift_Schedule_Dispenser_Order_By>>;
  where?: InputMaybe<Shift_Schedule_Dispenser_Bool_Exp>;
};


export type Subscription_RootShift_Schedule_Dispenser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shift_Schedule_Dispenser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shift_Schedule_Dispenser_Order_By>>;
  where?: InputMaybe<Shift_Schedule_Dispenser_Bool_Exp>;
};


export type Subscription_RootShift_Schedule_Dispenser_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootShift_Schedule_Dispenser_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Shift_Schedule_Dispenser_Stream_Cursor_Input>>;
  where?: InputMaybe<Shift_Schedule_Dispenser_Bool_Exp>;
};


export type Subscription_RootShift_Schedule_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Shift_Schedule_Stream_Cursor_Input>>;
  where?: InputMaybe<Shift_Schedule_Bool_Exp>;
};


export type Subscription_RootShift_TemplateArgs = {
  distinct_on?: InputMaybe<Array<Shift_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shift_Template_Order_By>>;
  where?: InputMaybe<Shift_Template_Bool_Exp>;
};


export type Subscription_RootShift_Template_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shift_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shift_Template_Order_By>>;
  where?: InputMaybe<Shift_Template_Bool_Exp>;
};


export type Subscription_RootShift_Template_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootShift_Template_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Shift_Template_Stream_Cursor_Input>>;
  where?: InputMaybe<Shift_Template_Bool_Exp>;
};


export type Subscription_RootSlab_TypeArgs = {
  distinct_on?: InputMaybe<Array<Slab_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Slab_Type_Order_By>>;
  where?: InputMaybe<Slab_Type_Bool_Exp>;
};


export type Subscription_RootSlab_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Slab_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Slab_Type_Order_By>>;
  where?: InputMaybe<Slab_Type_Bool_Exp>;
};


export type Subscription_RootSlab_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootSlab_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Slab_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Slab_Type_Bool_Exp>;
};


export type Subscription_RootSource_TypeArgs = {
  distinct_on?: InputMaybe<Array<Source_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Source_Type_Order_By>>;
  where?: InputMaybe<Source_Type_Bool_Exp>;
};


export type Subscription_RootSource_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Source_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Source_Type_Order_By>>;
  where?: InputMaybe<Source_Type_Bool_Exp>;
};


export type Subscription_RootSource_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootSource_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Source_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Source_Type_Bool_Exp>;
};


export type Subscription_RootSpatial_Ref_SysArgs = {
  distinct_on?: InputMaybe<Array<Spatial_Ref_Sys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spatial_Ref_Sys_Order_By>>;
  where?: InputMaybe<Spatial_Ref_Sys_Bool_Exp>;
};


export type Subscription_RootSpatial_Ref_Sys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spatial_Ref_Sys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Spatial_Ref_Sys_Order_By>>;
  where?: InputMaybe<Spatial_Ref_Sys_Bool_Exp>;
};


export type Subscription_RootSpatial_Ref_Sys_By_PkArgs = {
  srid: Scalars['Int']['input'];
};


export type Subscription_RootSpatial_Ref_Sys_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Spatial_Ref_Sys_Stream_Cursor_Input>>;
  where?: InputMaybe<Spatial_Ref_Sys_Bool_Exp>;
};


export type Subscription_RootStateArgs = {
  distinct_on?: InputMaybe<Array<State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<State_Order_By>>;
  where?: InputMaybe<State_Bool_Exp>;
};


export type Subscription_RootState_AggregateArgs = {
  distinct_on?: InputMaybe<Array<State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<State_Order_By>>;
  where?: InputMaybe<State_Bool_Exp>;
};


export type Subscription_RootState_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootState_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<State_Stream_Cursor_Input>>;
  where?: InputMaybe<State_Bool_Exp>;
};


export type Subscription_RootSubsidiaryArgs = {
  distinct_on?: InputMaybe<Array<Subsidiary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subsidiary_Order_By>>;
  where?: InputMaybe<Subsidiary_Bool_Exp>;
};


export type Subscription_RootSubsidiary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subsidiary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subsidiary_Order_By>>;
  where?: InputMaybe<Subsidiary_Bool_Exp>;
};


export type Subscription_RootSubsidiary_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSubsidiary_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Subsidiary_Stream_Cursor_Input>>;
  where?: InputMaybe<Subsidiary_Bool_Exp>;
};


export type Subscription_RootSupport_TicketsArgs = {
  distinct_on?: InputMaybe<Array<Support_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Support_Tickets_Order_By>>;
  where?: InputMaybe<Support_Tickets_Bool_Exp>;
};


export type Subscription_RootSupport_Tickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Support_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Support_Tickets_Order_By>>;
  where?: InputMaybe<Support_Tickets_Bool_Exp>;
};


export type Subscription_RootSupport_Tickets_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSupport_Tickets_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Support_Tickets_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Support_Tickets_Category_Order_By>>;
  where?: InputMaybe<Support_Tickets_Category_Bool_Exp>;
};


export type Subscription_RootSupport_Tickets_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Support_Tickets_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Support_Tickets_Category_Order_By>>;
  where?: InputMaybe<Support_Tickets_Category_Bool_Exp>;
};


export type Subscription_RootSupport_Tickets_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSupport_Tickets_Category_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Support_Tickets_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Support_Tickets_Category_Bool_Exp>;
};


export type Subscription_RootSupport_Tickets_PhotosArgs = {
  distinct_on?: InputMaybe<Array<Support_Tickets_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Support_Tickets_Photos_Order_By>>;
  where?: InputMaybe<Support_Tickets_Photos_Bool_Exp>;
};


export type Subscription_RootSupport_Tickets_Photos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Support_Tickets_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Support_Tickets_Photos_Order_By>>;
  where?: InputMaybe<Support_Tickets_Photos_Bool_Exp>;
};


export type Subscription_RootSupport_Tickets_Photos_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSupport_Tickets_Photos_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Support_Tickets_Photos_Stream_Cursor_Input>>;
  where?: InputMaybe<Support_Tickets_Photos_Bool_Exp>;
};


export type Subscription_RootSupport_Tickets_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Support_Tickets_Stream_Cursor_Input>>;
  where?: InputMaybe<Support_Tickets_Bool_Exp>;
};


export type Subscription_RootTagArgs = {
  distinct_on?: InputMaybe<Array<Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Order_By>>;
  where?: InputMaybe<Tag_Bool_Exp>;
};


export type Subscription_RootTag_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Order_By>>;
  where?: InputMaybe<Tag_Bool_Exp>;
};


export type Subscription_RootTag_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTag_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tag_Stream_Cursor_Input>>;
  where?: InputMaybe<Tag_Bool_Exp>;
};


export type Subscription_RootTank_TypeArgs = {
  distinct_on?: InputMaybe<Array<Tank_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tank_Type_Order_By>>;
  where?: InputMaybe<Tank_Type_Bool_Exp>;
};


export type Subscription_RootTank_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tank_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tank_Type_Order_By>>;
  where?: InputMaybe<Tank_Type_Bool_Exp>;
};


export type Subscription_RootTank_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTank_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tank_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Tank_Type_Bool_Exp>;
};


export type Subscription_RootTaskArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


export type Subscription_RootTask_Action_InstructionArgs = {
  distinct_on?: InputMaybe<Array<Task_Action_Instruction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Action_Instruction_Order_By>>;
  where?: InputMaybe<Task_Action_Instruction_Bool_Exp>;
};


export type Subscription_RootTask_Action_Instruction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Action_Instruction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Action_Instruction_Order_By>>;
  where?: InputMaybe<Task_Action_Instruction_Bool_Exp>;
};


export type Subscription_RootTask_Action_Instruction_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTask_Action_Instruction_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Task_Action_Instruction_Stream_Cursor_Input>>;
  where?: InputMaybe<Task_Action_Instruction_Bool_Exp>;
};


export type Subscription_RootTask_Action_TypeArgs = {
  distinct_on?: InputMaybe<Array<Task_Action_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Action_Type_Order_By>>;
  where?: InputMaybe<Task_Action_Type_Bool_Exp>;
};


export type Subscription_RootTask_Action_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Action_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Action_Type_Order_By>>;
  where?: InputMaybe<Task_Action_Type_Bool_Exp>;
};


export type Subscription_RootTask_Action_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTask_Action_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Task_Action_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Task_Action_Type_Bool_Exp>;
};


export type Subscription_RootTask_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


export type Subscription_RootTask_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTask_Cancellation_ReasonsArgs = {
  distinct_on?: InputMaybe<Array<Task_Cancellation_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Cancellation_Reasons_Order_By>>;
  where?: InputMaybe<Task_Cancellation_Reasons_Bool_Exp>;
};


export type Subscription_RootTask_Cancellation_Reasons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Cancellation_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Cancellation_Reasons_Order_By>>;
  where?: InputMaybe<Task_Cancellation_Reasons_Bool_Exp>;
};


export type Subscription_RootTask_Cancellation_Reasons_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTask_Cancellation_Reasons_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Task_Cancellation_Reasons_Stream_Cursor_Input>>;
  where?: InputMaybe<Task_Cancellation_Reasons_Bool_Exp>;
};


export type Subscription_RootTask_StateArgs = {
  distinct_on?: InputMaybe<Array<Task_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_State_Order_By>>;
  where?: InputMaybe<Task_State_Bool_Exp>;
};


export type Subscription_RootTask_State_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_State_Order_By>>;
  where?: InputMaybe<Task_State_Bool_Exp>;
};


export type Subscription_RootTask_State_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootTask_State_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Task_State_Stream_Cursor_Input>>;
  where?: InputMaybe<Task_State_Bool_Exp>;
};


export type Subscription_RootTask_States_FlowArgs = {
  distinct_on?: InputMaybe<Array<Task_States_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_States_Flow_Order_By>>;
  where?: InputMaybe<Task_States_Flow_Bool_Exp>;
};


export type Subscription_RootTask_States_Flow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_States_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_States_Flow_Order_By>>;
  where?: InputMaybe<Task_States_Flow_Bool_Exp>;
};


export type Subscription_RootTask_States_Flow_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTask_States_Flow_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Task_States_Flow_Stream_Cursor_Input>>;
  where?: InputMaybe<Task_States_Flow_Bool_Exp>;
};


export type Subscription_RootTask_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Task_Stream_Cursor_Input>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


export type Subscription_RootTask_TypeArgs = {
  distinct_on?: InputMaybe<Array<Task_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Type_Order_By>>;
  where?: InputMaybe<Task_Type_Bool_Exp>;
};


export type Subscription_RootTask_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Type_Order_By>>;
  where?: InputMaybe<Task_Type_Bool_Exp>;
};


export type Subscription_RootTask_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootTask_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Task_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Task_Type_Bool_Exp>;
};


export type Subscription_RootTask_ValueArgs = {
  distinct_on?: InputMaybe<Array<Task_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Value_Order_By>>;
  where?: InputMaybe<Task_Value_Bool_Exp>;
};


export type Subscription_RootTask_Value_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Value_Order_By>>;
  where?: InputMaybe<Task_Value_Bool_Exp>;
};


export type Subscription_RootTask_Value_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTask_Value_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Task_Value_Stream_Cursor_Input>>;
  where?: InputMaybe<Task_Value_Bool_Exp>;
};


export type Subscription_RootTestArgs = {
  distinct_on?: InputMaybe<Array<Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Test_Order_By>>;
  where?: InputMaybe<Test_Bool_Exp>;
};


export type Subscription_RootTest_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Test_Order_By>>;
  where?: InputMaybe<Test_Bool_Exp>;
};


export type Subscription_RootTest_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTest_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Test_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Test_Category_Order_By>>;
  where?: InputMaybe<Test_Category_Bool_Exp>;
};


export type Subscription_RootTest_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Test_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Test_Category_Order_By>>;
  where?: InputMaybe<Test_Category_Bool_Exp>;
};


export type Subscription_RootTest_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTest_Category_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Test_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Test_Category_Bool_Exp>;
};


export type Subscription_RootTest_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Test_Stream_Cursor_Input>>;
  where?: InputMaybe<Test_Bool_Exp>;
};


export type Subscription_RootTicket_StateArgs = {
  distinct_on?: InputMaybe<Array<Ticket_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ticket_State_Order_By>>;
  where?: InputMaybe<Ticket_State_Bool_Exp>;
};


export type Subscription_RootTicket_State_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ticket_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ticket_State_Order_By>>;
  where?: InputMaybe<Ticket_State_Bool_Exp>;
};


export type Subscription_RootTicket_State_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootTicket_State_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ticket_State_Stream_Cursor_Input>>;
  where?: InputMaybe<Ticket_State_Bool_Exp>;
};


export type Subscription_RootTicket_TypeArgs = {
  distinct_on?: InputMaybe<Array<Ticket_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ticket_Type_Order_By>>;
  where?: InputMaybe<Ticket_Type_Bool_Exp>;
};


export type Subscription_RootTicket_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ticket_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ticket_Type_Order_By>>;
  where?: InputMaybe<Ticket_Type_Bool_Exp>;
};


export type Subscription_RootTicket_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootTicket_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ticket_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Ticket_Type_Bool_Exp>;
};


export type Subscription_RootTicketsArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tickets_Order_By>>;
  where?: InputMaybe<Tickets_Bool_Exp>;
};


export type Subscription_RootTickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tickets_Order_By>>;
  where?: InputMaybe<Tickets_Bool_Exp>;
};


export type Subscription_RootTickets_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTickets_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tickets_Stream_Cursor_Input>>;
  where?: InputMaybe<Tickets_Bool_Exp>;
};


export type Subscription_RootTotalizer_Correction_Ticket_StatesArgs = {
  distinct_on?: InputMaybe<Array<Totalizer_Correction_Ticket_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Totalizer_Correction_Ticket_States_Order_By>>;
  where?: InputMaybe<Totalizer_Correction_Ticket_States_Bool_Exp>;
};


export type Subscription_RootTotalizer_Correction_Ticket_States_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Totalizer_Correction_Ticket_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Totalizer_Correction_Ticket_States_Order_By>>;
  where?: InputMaybe<Totalizer_Correction_Ticket_States_Bool_Exp>;
};


export type Subscription_RootTotalizer_Correction_Ticket_States_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootTotalizer_Correction_Ticket_States_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Totalizer_Correction_Ticket_States_Stream_Cursor_Input>>;
  where?: InputMaybe<Totalizer_Correction_Ticket_States_Bool_Exp>;
};


export type Subscription_RootTotalizer_Correction_TicketsArgs = {
  distinct_on?: InputMaybe<Array<Totalizer_Correction_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Totalizer_Correction_Tickets_Order_By>>;
  where?: InputMaybe<Totalizer_Correction_Tickets_Bool_Exp>;
};


export type Subscription_RootTotalizer_Correction_Tickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Totalizer_Correction_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Totalizer_Correction_Tickets_Order_By>>;
  where?: InputMaybe<Totalizer_Correction_Tickets_Bool_Exp>;
};


export type Subscription_RootTotalizer_Correction_Tickets_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTotalizer_Correction_Tickets_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Totalizer_Correction_Tickets_Stream_Cursor_Input>>;
  where?: InputMaybe<Totalizer_Correction_Tickets_Bool_Exp>;
};


export type Subscription_RootTransaction_TypeArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transaction_Type_Order_By>>;
  where?: InputMaybe<Transaction_Type_Bool_Exp>;
};


export type Subscription_RootTransaction_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transaction_Type_Order_By>>;
  where?: InputMaybe<Transaction_Type_Bool_Exp>;
};


export type Subscription_RootTransaction_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootTransaction_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Transaction_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Transaction_Type_Bool_Exp>;
};


export type Subscription_RootTripArgs = {
  distinct_on?: InputMaybe<Array<Trip_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trip_Order_By>>;
  where?: InputMaybe<Trip_Bool_Exp>;
};


export type Subscription_RootTrip_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trip_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trip_Order_By>>;
  where?: InputMaybe<Trip_Bool_Exp>;
};


export type Subscription_RootTrip_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTrip_LocationArgs = {
  distinct_on?: InputMaybe<Array<Trip_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trip_Location_Order_By>>;
  where?: InputMaybe<Trip_Location_Bool_Exp>;
};


export type Subscription_RootTrip_Location_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trip_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trip_Location_Order_By>>;
  where?: InputMaybe<Trip_Location_Bool_Exp>;
};


export type Subscription_RootTrip_Location_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTrip_Location_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Trip_Location_Stream_Cursor_Input>>;
  where?: InputMaybe<Trip_Location_Bool_Exp>;
};


export type Subscription_RootTrip_PlanArgs = {
  distinct_on?: InputMaybe<Array<Trip_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trip_Plan_Order_By>>;
  where?: InputMaybe<Trip_Plan_Bool_Exp>;
};


export type Subscription_RootTrip_Plan_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trip_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trip_Plan_Order_By>>;
  where?: InputMaybe<Trip_Plan_Bool_Exp>;
};


export type Subscription_RootTrip_Plan_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTrip_Plan_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Trip_Plan_Stream_Cursor_Input>>;
  where?: InputMaybe<Trip_Plan_Bool_Exp>;
};


export type Subscription_RootTrip_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Trip_Stream_Cursor_Input>>;
  where?: InputMaybe<Trip_Bool_Exp>;
};


export type Subscription_RootUnit_Of_MeasureArgs = {
  distinct_on?: InputMaybe<Array<Unit_Of_Measure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unit_Of_Measure_Order_By>>;
  where?: InputMaybe<Unit_Of_Measure_Bool_Exp>;
};


export type Subscription_RootUnit_Of_Measure_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unit_Of_Measure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unit_Of_Measure_Order_By>>;
  where?: InputMaybe<Unit_Of_Measure_Bool_Exp>;
};


export type Subscription_RootUnit_Of_Measure_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootUnit_Of_Measure_MetaArgs = {
  distinct_on?: InputMaybe<Array<Unit_Of_Measure_Meta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unit_Of_Measure_Meta_Order_By>>;
  where?: InputMaybe<Unit_Of_Measure_Meta_Bool_Exp>;
};


export type Subscription_RootUnit_Of_Measure_Meta_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unit_Of_Measure_Meta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unit_Of_Measure_Meta_Order_By>>;
  where?: InputMaybe<Unit_Of_Measure_Meta_Bool_Exp>;
};


export type Subscription_RootUnit_Of_Measure_Meta_By_PkArgs = {
  value: Unit_Of_Measure_Enum;
};


export type Subscription_RootUnit_Of_Measure_Meta_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Unit_Of_Measure_Meta_Stream_Cursor_Input>>;
  where?: InputMaybe<Unit_Of_Measure_Meta_Bool_Exp>;
};


export type Subscription_RootUnit_Of_Measure_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Unit_Of_Measure_Stream_Cursor_Input>>;
  where?: InputMaybe<Unit_Of_Measure_Bool_Exp>;
};


export type Subscription_RootUom_ConversionArgs = {
  distinct_on?: InputMaybe<Array<Uom_Conversion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uom_Conversion_Order_By>>;
  where?: InputMaybe<Uom_Conversion_Bool_Exp>;
};


export type Subscription_RootUom_Conversion_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uom_Conversion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uom_Conversion_Order_By>>;
  where?: InputMaybe<Uom_Conversion_Bool_Exp>;
};


export type Subscription_RootUom_Conversion_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUom_Conversion_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uom_Conversion_Stream_Cursor_Input>>;
  where?: InputMaybe<Uom_Conversion_Bool_Exp>;
};


export type Subscription_RootUserArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootUser_Access_Audit_LogArgs = {
  distinct_on?: InputMaybe<Array<User_Access_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Access_Audit_Log_Order_By>>;
  where?: InputMaybe<User_Access_Audit_Log_Bool_Exp>;
};


export type Subscription_RootUser_Access_Audit_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Access_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Access_Audit_Log_Order_By>>;
  where?: InputMaybe<User_Access_Audit_Log_Bool_Exp>;
};


export type Subscription_RootUser_Access_Audit_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_Access_Audit_Log_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Access_Audit_Log_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Access_Audit_Log_Bool_Exp>;
};


export type Subscription_RootUser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootUser_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_LedgerArgs = {
  distinct_on?: InputMaybe<Array<User_Ledger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Ledger_Order_By>>;
  where?: InputMaybe<User_Ledger_Bool_Exp>;
};


export type Subscription_RootUser_Ledger_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Ledger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Ledger_Order_By>>;
  where?: InputMaybe<User_Ledger_Bool_Exp>;
};


export type Subscription_RootUser_Ledger_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_Ledger_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Ledger_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Ledger_Bool_Exp>;
};


export type Subscription_RootUser_Partner_TypeArgs = {
  distinct_on?: InputMaybe<Array<User_Partner_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Partner_Type_Order_By>>;
  where?: InputMaybe<User_Partner_Type_Bool_Exp>;
};


export type Subscription_RootUser_Partner_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Partner_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Partner_Type_Order_By>>;
  where?: InputMaybe<User_Partner_Type_Bool_Exp>;
};


export type Subscription_RootUser_Partner_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootUser_Partner_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Partner_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Partner_Type_Bool_Exp>;
};


export type Subscription_RootUser_ReferralArgs = {
  distinct_on?: InputMaybe<Array<User_Referral_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Referral_Order_By>>;
  where?: InputMaybe<User_Referral_Bool_Exp>;
};


export type Subscription_RootUser_Referral_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Referral_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Referral_Order_By>>;
  where?: InputMaybe<User_Referral_Bool_Exp>;
};


export type Subscription_RootUser_Referral_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_Referral_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Referral_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Referral_Bool_Exp>;
};


export type Subscription_RootUser_RoleArgs = {
  distinct_on?: InputMaybe<Array<User_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Role_Order_By>>;
  where?: InputMaybe<User_Role_Bool_Exp>;
};


export type Subscription_RootUser_Role_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Role_Order_By>>;
  where?: InputMaybe<User_Role_Bool_Exp>;
};


export type Subscription_RootUser_Role_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_Role_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Role_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Role_Bool_Exp>;
};


export type Subscription_RootUser_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootValidation_WorkflowsArgs = {
  distinct_on?: InputMaybe<Array<Validation_Workflows_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Validation_Workflows_Order_By>>;
  where?: InputMaybe<Validation_Workflows_Bool_Exp>;
};


export type Subscription_RootValidation_Workflows_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Validation_Workflows_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Validation_Workflows_Order_By>>;
  where?: InputMaybe<Validation_Workflows_Bool_Exp>;
};


export type Subscription_RootValidation_Workflows_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootValidation_Workflows_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Validation_Workflows_Stream_Cursor_Input>>;
  where?: InputMaybe<Validation_Workflows_Bool_Exp>;
};


export type Subscription_RootVariationArgs = {
  distinct_on?: InputMaybe<Array<Variation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variation_Order_By>>;
  where?: InputMaybe<Variation_Bool_Exp>;
};


export type Subscription_RootVariation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variation_Order_By>>;
  where?: InputMaybe<Variation_Bool_Exp>;
};


export type Subscription_RootVariation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootVariation_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Variation_Stream_Cursor_Input>>;
  where?: InputMaybe<Variation_Bool_Exp>;
};


export type Subscription_RootVariation_TypeArgs = {
  distinct_on?: InputMaybe<Array<Variation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variation_Type_Order_By>>;
  where?: InputMaybe<Variation_Type_Bool_Exp>;
};


export type Subscription_RootVariation_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variation_Type_Order_By>>;
  where?: InputMaybe<Variation_Type_Bool_Exp>;
};


export type Subscription_RootVariation_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootVariation_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Variation_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Variation_Type_Bool_Exp>;
};


export type Subscription_RootVehicleArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Order_By>>;
  where?: InputMaybe<Vehicle_Bool_Exp>;
};


export type Subscription_RootVehicle_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Order_By>>;
  where?: InputMaybe<Vehicle_Bool_Exp>;
};


export type Subscription_RootVehicle_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootVehicle_ConfigurationArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Configuration_Order_By>>;
  where?: InputMaybe<Vehicle_Configuration_Bool_Exp>;
};


export type Subscription_RootVehicle_Configuration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Configuration_Order_By>>;
  where?: InputMaybe<Vehicle_Configuration_Bool_Exp>;
};


export type Subscription_RootVehicle_Configuration_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootVehicle_Configuration_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vehicle_Configuration_Stream_Cursor_Input>>;
  where?: InputMaybe<Vehicle_Configuration_Bool_Exp>;
};


export type Subscription_RootVehicle_DeviceArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Device_Order_By>>;
  where?: InputMaybe<Vehicle_Device_Bool_Exp>;
};


export type Subscription_RootVehicle_Device_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Device_Order_By>>;
  where?: InputMaybe<Vehicle_Device_Bool_Exp>;
};


export type Subscription_RootVehicle_Device_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootVehicle_Device_CalibrationArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Device_Calibration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Device_Calibration_Order_By>>;
  where?: InputMaybe<Vehicle_Device_Calibration_Bool_Exp>;
};


export type Subscription_RootVehicle_Device_Calibration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Device_Calibration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Device_Calibration_Order_By>>;
  where?: InputMaybe<Vehicle_Device_Calibration_Bool_Exp>;
};


export type Subscription_RootVehicle_Device_Calibration_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootVehicle_Device_Calibration_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vehicle_Device_Calibration_Stream_Cursor_Input>>;
  where?: InputMaybe<Vehicle_Device_Calibration_Bool_Exp>;
};


export type Subscription_RootVehicle_Device_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vehicle_Device_Stream_Cursor_Input>>;
  where?: InputMaybe<Vehicle_Device_Bool_Exp>;
};


export type Subscription_RootVehicle_Inventory_Transaction_LogsArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Inventory_Transaction_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Inventory_Transaction_Logs_Order_By>>;
  where?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Bool_Exp>;
};


export type Subscription_RootVehicle_Inventory_Transaction_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Inventory_Transaction_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Inventory_Transaction_Logs_Order_By>>;
  where?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Bool_Exp>;
};


export type Subscription_RootVehicle_Inventory_Transaction_Logs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootVehicle_Inventory_Transaction_Logs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vehicle_Inventory_Transaction_Logs_Stream_Cursor_Input>>;
  where?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Bool_Exp>;
};


export type Subscription_RootVehicle_LocalitiesArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Localities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Localities_Order_By>>;
  where?: InputMaybe<Vehicle_Localities_Bool_Exp>;
};


export type Subscription_RootVehicle_Localities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Localities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Localities_Order_By>>;
  where?: InputMaybe<Vehicle_Localities_Bool_Exp>;
};


export type Subscription_RootVehicle_Localities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootVehicle_Localities_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vehicle_Localities_Stream_Cursor_Input>>;
  where?: InputMaybe<Vehicle_Localities_Bool_Exp>;
};


export type Subscription_RootVehicle_PermitArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Permit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Permit_Order_By>>;
  where?: InputMaybe<Vehicle_Permit_Bool_Exp>;
};


export type Subscription_RootVehicle_Permit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Permit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Permit_Order_By>>;
  where?: InputMaybe<Vehicle_Permit_Bool_Exp>;
};


export type Subscription_RootVehicle_Permit_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootVehicle_Permit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vehicle_Permit_Stream_Cursor_Input>>;
  where?: InputMaybe<Vehicle_Permit_Bool_Exp>;
};


export type Subscription_RootVehicle_Shift_TemplateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Shift_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Shift_Template_Order_By>>;
  where?: InputMaybe<Vehicle_Shift_Template_Bool_Exp>;
};


export type Subscription_RootVehicle_Shift_Template_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Shift_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Shift_Template_Order_By>>;
  where?: InputMaybe<Vehicle_Shift_Template_Bool_Exp>;
};


export type Subscription_RootVehicle_Shift_Template_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootVehicle_Shift_Template_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vehicle_Shift_Template_Stream_Cursor_Input>>;
  where?: InputMaybe<Vehicle_Shift_Template_Bool_Exp>;
};


export type Subscription_RootVehicle_StatusArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Status_Order_By>>;
  where?: InputMaybe<Vehicle_Status_Bool_Exp>;
};


export type Subscription_RootVehicle_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Status_Order_By>>;
  where?: InputMaybe<Vehicle_Status_Bool_Exp>;
};


export type Subscription_RootVehicle_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootVehicle_Status_LogsArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Status_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Status_Logs_Order_By>>;
  where?: InputMaybe<Vehicle_Status_Logs_Bool_Exp>;
};


export type Subscription_RootVehicle_Status_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Status_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Status_Logs_Order_By>>;
  where?: InputMaybe<Vehicle_Status_Logs_Bool_Exp>;
};


export type Subscription_RootVehicle_Status_Logs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootVehicle_Status_Logs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vehicle_Status_Logs_Stream_Cursor_Input>>;
  where?: InputMaybe<Vehicle_Status_Logs_Bool_Exp>;
};


export type Subscription_RootVehicle_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vehicle_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Vehicle_Status_Bool_Exp>;
};


export type Subscription_RootVehicle_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vehicle_Stream_Cursor_Input>>;
  where?: InputMaybe<Vehicle_Bool_Exp>;
};


export type Subscription_RootVehicle_Tank_TypeArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Tank_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Tank_Type_Order_By>>;
  where?: InputMaybe<Vehicle_Tank_Type_Bool_Exp>;
};


export type Subscription_RootVehicle_Tank_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Tank_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Tank_Type_Order_By>>;
  where?: InputMaybe<Vehicle_Tank_Type_Bool_Exp>;
};


export type Subscription_RootVehicle_Tank_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootVehicle_Tank_Type_Product_VariationArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Tank_Type_Product_Variation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Tank_Type_Product_Variation_Order_By>>;
  where?: InputMaybe<Vehicle_Tank_Type_Product_Variation_Bool_Exp>;
};


export type Subscription_RootVehicle_Tank_Type_Product_Variation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Tank_Type_Product_Variation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Tank_Type_Product_Variation_Order_By>>;
  where?: InputMaybe<Vehicle_Tank_Type_Product_Variation_Bool_Exp>;
};


export type Subscription_RootVehicle_Tank_Type_Product_Variation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootVehicle_Tank_Type_Product_Variation_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vehicle_Tank_Type_Product_Variation_Stream_Cursor_Input>>;
  where?: InputMaybe<Vehicle_Tank_Type_Product_Variation_Bool_Exp>;
};


export type Subscription_RootVehicle_Tank_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vehicle_Tank_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Vehicle_Tank_Type_Bool_Exp>;
};


export type Subscription_RootVehicle_TypeArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Type_Order_By>>;
  where?: InputMaybe<Vehicle_Type_Bool_Exp>;
};


export type Subscription_RootVehicle_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Type_Order_By>>;
  where?: InputMaybe<Vehicle_Type_Bool_Exp>;
};


export type Subscription_RootVehicle_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootVehicle_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vehicle_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Vehicle_Type_Bool_Exp>;
};


export type Subscription_RootVendor_Order_LogsArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Order_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Order_Logs_Order_By>>;
  where?: InputMaybe<Vendor_Order_Logs_Bool_Exp>;
};


export type Subscription_RootVendor_Order_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Order_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Order_Logs_Order_By>>;
  where?: InputMaybe<Vendor_Order_Logs_Bool_Exp>;
};


export type Subscription_RootVendor_Order_Logs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootVendor_Order_Logs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vendor_Order_Logs_Stream_Cursor_Input>>;
  where?: InputMaybe<Vendor_Order_Logs_Bool_Exp>;
};


export type Subscription_RootVendor_Sync_StatusArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Sync_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Sync_Status_Order_By>>;
  where?: InputMaybe<Vendor_Sync_Status_Bool_Exp>;
};


export type Subscription_RootVendor_Sync_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Sync_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Sync_Status_Order_By>>;
  where?: InputMaybe<Vendor_Sync_Status_Bool_Exp>;
};


export type Subscription_RootVendor_Sync_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootVendor_Sync_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vendor_Sync_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Vendor_Sync_Status_Bool_Exp>;
};


export type Subscription_RootView_Daily_Asset_LimitArgs = {
  distinct_on?: InputMaybe<Array<View_Daily_Asset_Limit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_Daily_Asset_Limit_Order_By>>;
  where?: InputMaybe<View_Daily_Asset_Limit_Bool_Exp>;
};


export type Subscription_RootView_Daily_Asset_Limit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<View_Daily_Asset_Limit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_Daily_Asset_Limit_Order_By>>;
  where?: InputMaybe<View_Daily_Asset_Limit_Bool_Exp>;
};


export type Subscription_RootView_Daily_Asset_Limit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<View_Daily_Asset_Limit_Stream_Cursor_Input>>;
  where?: InputMaybe<View_Daily_Asset_Limit_Bool_Exp>;
};


export type Subscription_RootView_Monthly_Asset_LimitArgs = {
  distinct_on?: InputMaybe<Array<View_Monthly_Asset_Limit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_Monthly_Asset_Limit_Order_By>>;
  where?: InputMaybe<View_Monthly_Asset_Limit_Bool_Exp>;
};


export type Subscription_RootView_Monthly_Asset_Limit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<View_Monthly_Asset_Limit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_Monthly_Asset_Limit_Order_By>>;
  where?: InputMaybe<View_Monthly_Asset_Limit_Bool_Exp>;
};


export type Subscription_RootView_Monthly_Asset_Limit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<View_Monthly_Asset_Limit_Stream_Cursor_Input>>;
  where?: InputMaybe<View_Monthly_Asset_Limit_Bool_Exp>;
};


export type Subscription_RootView_Unlinked_Customer_AssetsArgs = {
  distinct_on?: InputMaybe<Array<View_Unlinked_Customer_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_Unlinked_Customer_Assets_Order_By>>;
  where?: InputMaybe<View_Unlinked_Customer_Assets_Bool_Exp>;
};


export type Subscription_RootView_Unlinked_Customer_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<View_Unlinked_Customer_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_Unlinked_Customer_Assets_Order_By>>;
  where?: InputMaybe<View_Unlinked_Customer_Assets_Bool_Exp>;
};


export type Subscription_RootView_Unlinked_Customer_Assets_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<View_Unlinked_Customer_Assets_Stream_Cursor_Input>>;
  where?: InputMaybe<View_Unlinked_Customer_Assets_Bool_Exp>;
};


export type Subscription_RootView_Weekly_Asset_LimitArgs = {
  distinct_on?: InputMaybe<Array<View_Weekly_Asset_Limit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_Weekly_Asset_Limit_Order_By>>;
  where?: InputMaybe<View_Weekly_Asset_Limit_Bool_Exp>;
};


export type Subscription_RootView_Weekly_Asset_Limit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<View_Weekly_Asset_Limit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<View_Weekly_Asset_Limit_Order_By>>;
  where?: InputMaybe<View_Weekly_Asset_Limit_Bool_Exp>;
};


export type Subscription_RootView_Weekly_Asset_Limit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<View_Weekly_Asset_Limit_Stream_Cursor_Input>>;
  where?: InputMaybe<View_Weekly_Asset_Limit_Bool_Exp>;
};


export type Subscription_RootVoucherArgs = {
  distinct_on?: InputMaybe<Array<Voucher_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Voucher_Order_By>>;
  where?: InputMaybe<Voucher_Bool_Exp>;
};


export type Subscription_RootVoucher_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Voucher_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Voucher_Order_By>>;
  where?: InputMaybe<Voucher_Bool_Exp>;
};


export type Subscription_RootVoucher_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootVoucher_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Voucher_Stream_Cursor_Input>>;
  where?: InputMaybe<Voucher_Bool_Exp>;
};


export type Subscription_RootWalletArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Order_By>>;
  where?: InputMaybe<Wallet_Bool_Exp>;
};


export type Subscription_RootWallet_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Order_By>>;
  where?: InputMaybe<Wallet_Bool_Exp>;
};


export type Subscription_RootWallet_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootWallet_ExceptionArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Exception_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Exception_Order_By>>;
  where?: InputMaybe<Wallet_Exception_Bool_Exp>;
};


export type Subscription_RootWallet_Exception_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Exception_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Exception_Order_By>>;
  where?: InputMaybe<Wallet_Exception_Bool_Exp>;
};


export type Subscription_RootWallet_Exception_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootWallet_Exception_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Wallet_Exception_Stream_Cursor_Input>>;
  where?: InputMaybe<Wallet_Exception_Bool_Exp>;
};


export type Subscription_RootWallet_LedgerArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Ledger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Ledger_Order_By>>;
  where?: InputMaybe<Wallet_Ledger_Bool_Exp>;
};


export type Subscription_RootWallet_Ledger_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Ledger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Ledger_Order_By>>;
  where?: InputMaybe<Wallet_Ledger_Bool_Exp>;
};


export type Subscription_RootWallet_Ledger_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootWallet_Ledger_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Wallet_Ledger_Stream_Cursor_Input>>;
  where?: InputMaybe<Wallet_Ledger_Bool_Exp>;
};


export type Subscription_RootWallet_StateArgs = {
  distinct_on?: InputMaybe<Array<Wallet_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_State_Order_By>>;
  where?: InputMaybe<Wallet_State_Bool_Exp>;
};


export type Subscription_RootWallet_State_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wallet_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_State_Order_By>>;
  where?: InputMaybe<Wallet_State_Bool_Exp>;
};


export type Subscription_RootWallet_State_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootWallet_State_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Wallet_State_Stream_Cursor_Input>>;
  where?: InputMaybe<Wallet_State_Bool_Exp>;
};


export type Subscription_RootWallet_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Wallet_Stream_Cursor_Input>>;
  where?: InputMaybe<Wallet_Bool_Exp>;
};


export type Subscription_RootWallet_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Transactions_Order_By>>;
  where?: InputMaybe<Wallet_Transactions_Bool_Exp>;
};


export type Subscription_RootWallet_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Transactions_Order_By>>;
  where?: InputMaybe<Wallet_Transactions_Bool_Exp>;
};


export type Subscription_RootWallet_Transactions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootWallet_Transactions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Wallet_Transactions_Stream_Cursor_Input>>;
  where?: InputMaybe<Wallet_Transactions_Bool_Exp>;
};

/** columns and relationships of "subsidiary" */
export type Subsidiary = {
  __typename?: 'subsidiary';
  /** An array relationship */
  address_subsidiaries: Array<Address_Subsidiary>;
  /** An aggregate relationship */
  address_subsidiaries_aggregate: Address_Subsidiary_Aggregate;
  /** An array relationship */
  address_subsidiary_audit_logs: Array<Address_Subsidiary_Audit_Logs>;
  /** An aggregate relationship */
  address_subsidiary_audit_logs_aggregate: Address_Subsidiary_Audit_Logs_Aggregate;
  /** An array relationship */
  asset_subsidiaries: Array<Asset_Subsidiary>;
  /** An aggregate relationship */
  asset_subsidiaries_aggregate: Asset_Subsidiary_Aggregate;
  /** An array relationship */
  asset_subsidiary_audit_logs: Array<Asset_Subsidiary_Audit_Logs>;
  /** An aggregate relationship */
  asset_subsidiary_audit_logs_aggregate: Asset_Subsidiary_Audit_Logs_Aggregate;
  created_at: Scalars['timestamp']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  department_retag_requests: Array<Department_Retag_Request>;
  /** An aggregate relationship */
  department_retag_requests_aggregate: Department_Retag_Request_Aggregate;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified: Scalars['timestamp']['output'];
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name: Scalars['String']['output'];
  /** An object relationship */
  organization: Organization;
  organization_id: Scalars['uuid']['output'];
  /** An array relationship */
  organization_user_subsidiaries: Array<Organization_User_Subsidiary>;
  /** An aggregate relationship */
  organization_user_subsidiaries_aggregate: Organization_User_Subsidiary_Aggregate;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  subsidiaries: Array<Subsidiary>;
  /** An aggregate relationship */
  subsidiaries_aggregate: Subsidiary_Aggregate;
  /** An object relationship */
  subsidiary?: Maybe<Subsidiary>;
};


/** columns and relationships of "subsidiary" */
export type SubsidiaryAddress_SubsidiariesArgs = {
  distinct_on?: InputMaybe<Array<Address_Subsidiary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Address_Subsidiary_Order_By>>;
  where?: InputMaybe<Address_Subsidiary_Bool_Exp>;
};


/** columns and relationships of "subsidiary" */
export type SubsidiaryAddress_Subsidiaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Subsidiary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Address_Subsidiary_Order_By>>;
  where?: InputMaybe<Address_Subsidiary_Bool_Exp>;
};


/** columns and relationships of "subsidiary" */
export type SubsidiaryAddress_Subsidiary_Audit_LogsArgs = {
  distinct_on?: InputMaybe<Array<Address_Subsidiary_Audit_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Address_Subsidiary_Audit_Logs_Order_By>>;
  where?: InputMaybe<Address_Subsidiary_Audit_Logs_Bool_Exp>;
};


/** columns and relationships of "subsidiary" */
export type SubsidiaryAddress_Subsidiary_Audit_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Subsidiary_Audit_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Address_Subsidiary_Audit_Logs_Order_By>>;
  where?: InputMaybe<Address_Subsidiary_Audit_Logs_Bool_Exp>;
};


/** columns and relationships of "subsidiary" */
export type SubsidiaryAsset_SubsidiariesArgs = {
  distinct_on?: InputMaybe<Array<Asset_Subsidiary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Subsidiary_Order_By>>;
  where?: InputMaybe<Asset_Subsidiary_Bool_Exp>;
};


/** columns and relationships of "subsidiary" */
export type SubsidiaryAsset_Subsidiaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Subsidiary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Subsidiary_Order_By>>;
  where?: InputMaybe<Asset_Subsidiary_Bool_Exp>;
};


/** columns and relationships of "subsidiary" */
export type SubsidiaryAsset_Subsidiary_Audit_LogsArgs = {
  distinct_on?: InputMaybe<Array<Asset_Subsidiary_Audit_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Subsidiary_Audit_Logs_Order_By>>;
  where?: InputMaybe<Asset_Subsidiary_Audit_Logs_Bool_Exp>;
};


/** columns and relationships of "subsidiary" */
export type SubsidiaryAsset_Subsidiary_Audit_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Subsidiary_Audit_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Subsidiary_Audit_Logs_Order_By>>;
  where?: InputMaybe<Asset_Subsidiary_Audit_Logs_Bool_Exp>;
};


/** columns and relationships of "subsidiary" */
export type SubsidiaryDepartment_Retag_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Department_Retag_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Department_Retag_Request_Order_By>>;
  where?: InputMaybe<Department_Retag_Request_Bool_Exp>;
};


/** columns and relationships of "subsidiary" */
export type SubsidiaryDepartment_Retag_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Department_Retag_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Department_Retag_Request_Order_By>>;
  where?: InputMaybe<Department_Retag_Request_Bool_Exp>;
};


/** columns and relationships of "subsidiary" */
export type SubsidiaryOrganization_User_SubsidiariesArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Subsidiary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Subsidiary_Order_By>>;
  where?: InputMaybe<Organization_User_Subsidiary_Bool_Exp>;
};


/** columns and relationships of "subsidiary" */
export type SubsidiaryOrganization_User_Subsidiaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Subsidiary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Subsidiary_Order_By>>;
  where?: InputMaybe<Organization_User_Subsidiary_Bool_Exp>;
};


/** columns and relationships of "subsidiary" */
export type SubsidiarySubsidiariesArgs = {
  distinct_on?: InputMaybe<Array<Subsidiary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subsidiary_Order_By>>;
  where?: InputMaybe<Subsidiary_Bool_Exp>;
};


/** columns and relationships of "subsidiary" */
export type SubsidiarySubsidiaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subsidiary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subsidiary_Order_By>>;
  where?: InputMaybe<Subsidiary_Bool_Exp>;
};

/** aggregated selection of "subsidiary" */
export type Subsidiary_Aggregate = {
  __typename?: 'subsidiary_aggregate';
  aggregate?: Maybe<Subsidiary_Aggregate_Fields>;
  nodes: Array<Subsidiary>;
};

export type Subsidiary_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Subsidiary_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Subsidiary_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Subsidiary_Aggregate_Bool_Exp_Count>;
};

export type Subsidiary_Aggregate_Bool_Exp_Bool_And = {
  arguments: Subsidiary_Select_Column_Subsidiary_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Subsidiary_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Subsidiary_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Subsidiary_Select_Column_Subsidiary_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Subsidiary_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Subsidiary_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Subsidiary_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Subsidiary_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "subsidiary" */
export type Subsidiary_Aggregate_Fields = {
  __typename?: 'subsidiary_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Subsidiary_Max_Fields>;
  min?: Maybe<Subsidiary_Min_Fields>;
};


/** aggregate fields of "subsidiary" */
export type Subsidiary_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Subsidiary_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "subsidiary" */
export type Subsidiary_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Subsidiary_Max_Order_By>;
  min?: InputMaybe<Subsidiary_Min_Order_By>;
};

/** input type for inserting array relation for remote table "subsidiary" */
export type Subsidiary_Arr_Rel_Insert_Input = {
  data: Array<Subsidiary_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Subsidiary_On_Conflict>;
};

/** Boolean expression to filter rows from the table "subsidiary". All fields are combined with a logical 'AND'. */
export type Subsidiary_Bool_Exp = {
  _and?: InputMaybe<Array<Subsidiary_Bool_Exp>>;
  _not?: InputMaybe<Subsidiary_Bool_Exp>;
  _or?: InputMaybe<Array<Subsidiary_Bool_Exp>>;
  address_subsidiaries?: InputMaybe<Address_Subsidiary_Bool_Exp>;
  address_subsidiaries_aggregate?: InputMaybe<Address_Subsidiary_Aggregate_Bool_Exp>;
  address_subsidiary_audit_logs?: InputMaybe<Address_Subsidiary_Audit_Logs_Bool_Exp>;
  address_subsidiary_audit_logs_aggregate?: InputMaybe<Address_Subsidiary_Audit_Logs_Aggregate_Bool_Exp>;
  asset_subsidiaries?: InputMaybe<Asset_Subsidiary_Bool_Exp>;
  asset_subsidiaries_aggregate?: InputMaybe<Asset_Subsidiary_Aggregate_Bool_Exp>;
  asset_subsidiary_audit_logs?: InputMaybe<Asset_Subsidiary_Audit_Logs_Bool_Exp>;
  asset_subsidiary_audit_logs_aggregate?: InputMaybe<Asset_Subsidiary_Audit_Logs_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  department_retag_requests?: InputMaybe<Department_Retag_Request_Bool_Exp>;
  department_retag_requests_aggregate?: InputMaybe<Department_Retag_Request_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  organization_user_subsidiaries?: InputMaybe<Organization_User_Subsidiary_Bool_Exp>;
  organization_user_subsidiaries_aggregate?: InputMaybe<Organization_User_Subsidiary_Aggregate_Bool_Exp>;
  parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  subsidiaries?: InputMaybe<Subsidiary_Bool_Exp>;
  subsidiaries_aggregate?: InputMaybe<Subsidiary_Aggregate_Bool_Exp>;
  subsidiary?: InputMaybe<Subsidiary_Bool_Exp>;
};

/** unique or primary key constraints on table "subsidiary" */
export enum Subsidiary_Constraint {
  /** unique or primary key constraint on columns "id" */
  SubsidiaryPkey = 'subsidiary_pkey',
  /** unique or primary key constraint on columns "organization_id" */
  SubsidiaryUniqueActiveNamePerOrgIdx = 'subsidiary_unique_active_name_per_org_idx'
}

/** input type for inserting data into table "subsidiary" */
export type Subsidiary_Insert_Input = {
  address_subsidiaries?: InputMaybe<Address_Subsidiary_Arr_Rel_Insert_Input>;
  address_subsidiary_audit_logs?: InputMaybe<Address_Subsidiary_Audit_Logs_Arr_Rel_Insert_Input>;
  asset_subsidiaries?: InputMaybe<Asset_Subsidiary_Arr_Rel_Insert_Input>;
  asset_subsidiary_audit_logs?: InputMaybe<Asset_Subsidiary_Audit_Logs_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  department_retag_requests?: InputMaybe<Department_Retag_Request_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  organization_user_subsidiaries?: InputMaybe<Organization_User_Subsidiary_Arr_Rel_Insert_Input>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  subsidiaries?: InputMaybe<Subsidiary_Arr_Rel_Insert_Input>;
  subsidiary?: InputMaybe<Subsidiary_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Subsidiary_Max_Fields = {
  __typename?: 'subsidiary_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "subsidiary" */
export type Subsidiary_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Subsidiary_Min_Fields = {
  __typename?: 'subsidiary_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "subsidiary" */
export type Subsidiary_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "subsidiary" */
export type Subsidiary_Mutation_Response = {
  __typename?: 'subsidiary_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Subsidiary>;
};

/** input type for inserting object relation for remote table "subsidiary" */
export type Subsidiary_Obj_Rel_Insert_Input = {
  data: Subsidiary_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Subsidiary_On_Conflict>;
};

/** on_conflict condition type for table "subsidiary" */
export type Subsidiary_On_Conflict = {
  constraint: Subsidiary_Constraint;
  update_columns?: Array<Subsidiary_Update_Column>;
  where?: InputMaybe<Subsidiary_Bool_Exp>;
};

/** Ordering options when selecting data from "subsidiary". */
export type Subsidiary_Order_By = {
  address_subsidiaries_aggregate?: InputMaybe<Address_Subsidiary_Aggregate_Order_By>;
  address_subsidiary_audit_logs_aggregate?: InputMaybe<Address_Subsidiary_Audit_Logs_Aggregate_Order_By>;
  asset_subsidiaries_aggregate?: InputMaybe<Asset_Subsidiary_Aggregate_Order_By>;
  asset_subsidiary_audit_logs_aggregate?: InputMaybe<Asset_Subsidiary_Audit_Logs_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  department_retag_requests_aggregate?: InputMaybe<Department_Retag_Request_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  organization_user_subsidiaries_aggregate?: InputMaybe<Organization_User_Subsidiary_Aggregate_Order_By>;
  parent_id?: InputMaybe<Order_By>;
  subsidiaries_aggregate?: InputMaybe<Subsidiary_Aggregate_Order_By>;
  subsidiary?: InputMaybe<Subsidiary_Order_By>;
};

/** primary key columns input for table: subsidiary */
export type Subsidiary_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "subsidiary" */
export enum Subsidiary_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  ParentId = 'parent_id'
}

/** select "subsidiary_aggregate_bool_exp_bool_and_arguments_columns" columns of table "subsidiary" */
export enum Subsidiary_Select_Column_Subsidiary_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "subsidiary_aggregate_bool_exp_bool_or_arguments_columns" columns of table "subsidiary" */
export enum Subsidiary_Select_Column_Subsidiary_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "subsidiary" */
export type Subsidiary_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "subsidiary" */
export type Subsidiary_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Subsidiary_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Subsidiary_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "subsidiary" */
export enum Subsidiary_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  ParentId = 'parent_id'
}

export type Subsidiary_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Subsidiary_Set_Input>;
  /** filter the rows which have to be updated */
  where: Subsidiary_Bool_Exp;
};

/** columns and relationships of "support_tickets" */
export type Support_Tickets = {
  __typename?: 'support_tickets';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  message: Scalars['String']['output'];
  source: Source_Type_Enum;
  /** An object relationship */
  source_type: Source_Type;
  subject: Scalars['String']['output'];
  /** An array relationship */
  support_tickets_photos: Array<Support_Tickets_Photos>;
  /** An aggregate relationship */
  support_tickets_photos_aggregate: Support_Tickets_Photos_Aggregate;
};


/** columns and relationships of "support_tickets" */
export type Support_TicketsSupport_Tickets_PhotosArgs = {
  distinct_on?: InputMaybe<Array<Support_Tickets_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Support_Tickets_Photos_Order_By>>;
  where?: InputMaybe<Support_Tickets_Photos_Bool_Exp>;
};


/** columns and relationships of "support_tickets" */
export type Support_TicketsSupport_Tickets_Photos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Support_Tickets_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Support_Tickets_Photos_Order_By>>;
  where?: InputMaybe<Support_Tickets_Photos_Bool_Exp>;
};

/** aggregated selection of "support_tickets" */
export type Support_Tickets_Aggregate = {
  __typename?: 'support_tickets_aggregate';
  aggregate?: Maybe<Support_Tickets_Aggregate_Fields>;
  nodes: Array<Support_Tickets>;
};

export type Support_Tickets_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Support_Tickets_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Support_Tickets_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Support_Tickets_Aggregate_Bool_Exp_Count>;
};

export type Support_Tickets_Aggregate_Bool_Exp_Bool_And = {
  arguments: Support_Tickets_Select_Column_Support_Tickets_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Support_Tickets_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Support_Tickets_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Support_Tickets_Select_Column_Support_Tickets_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Support_Tickets_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Support_Tickets_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Support_Tickets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Support_Tickets_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "support_tickets" */
export type Support_Tickets_Aggregate_Fields = {
  __typename?: 'support_tickets_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Support_Tickets_Max_Fields>;
  min?: Maybe<Support_Tickets_Min_Fields>;
};


/** aggregate fields of "support_tickets" */
export type Support_Tickets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Support_Tickets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "support_tickets" */
export type Support_Tickets_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Support_Tickets_Max_Order_By>;
  min?: InputMaybe<Support_Tickets_Min_Order_By>;
};

/** input type for inserting array relation for remote table "support_tickets" */
export type Support_Tickets_Arr_Rel_Insert_Input = {
  data: Array<Support_Tickets_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Support_Tickets_On_Conflict>;
};

/** Boolean expression to filter rows from the table "support_tickets". All fields are combined with a logical 'AND'. */
export type Support_Tickets_Bool_Exp = {
  _and?: InputMaybe<Array<Support_Tickets_Bool_Exp>>;
  _not?: InputMaybe<Support_Tickets_Bool_Exp>;
  _or?: InputMaybe<Array<Support_Tickets_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  source?: InputMaybe<Source_Type_Enum_Comparison_Exp>;
  source_type?: InputMaybe<Source_Type_Bool_Exp>;
  subject?: InputMaybe<String_Comparison_Exp>;
  support_tickets_photos?: InputMaybe<Support_Tickets_Photos_Bool_Exp>;
  support_tickets_photos_aggregate?: InputMaybe<Support_Tickets_Photos_Aggregate_Bool_Exp>;
};

/** columns and relationships of "support_tickets_category" */
export type Support_Tickets_Category = {
  __typename?: 'support_tickets_category';
  category: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
};

/** aggregated selection of "support_tickets_category" */
export type Support_Tickets_Category_Aggregate = {
  __typename?: 'support_tickets_category_aggregate';
  aggregate?: Maybe<Support_Tickets_Category_Aggregate_Fields>;
  nodes: Array<Support_Tickets_Category>;
};

/** aggregate fields of "support_tickets_category" */
export type Support_Tickets_Category_Aggregate_Fields = {
  __typename?: 'support_tickets_category_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Support_Tickets_Category_Max_Fields>;
  min?: Maybe<Support_Tickets_Category_Min_Fields>;
};


/** aggregate fields of "support_tickets_category" */
export type Support_Tickets_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Support_Tickets_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "support_tickets_category". All fields are combined with a logical 'AND'. */
export type Support_Tickets_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Support_Tickets_Category_Bool_Exp>>;
  _not?: InputMaybe<Support_Tickets_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Support_Tickets_Category_Bool_Exp>>;
  category?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "support_tickets_category" */
export enum Support_Tickets_Category_Constraint {
  /** unique or primary key constraint on columns "id" */
  SupportTicketsCategoryPkey = 'support_tickets_category_pkey'
}

/** input type for inserting data into table "support_tickets_category" */
export type Support_Tickets_Category_Insert_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Support_Tickets_Category_Max_Fields = {
  __typename?: 'support_tickets_category_max_fields';
  category?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Support_Tickets_Category_Min_Fields = {
  __typename?: 'support_tickets_category_min_fields';
  category?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "support_tickets_category" */
export type Support_Tickets_Category_Mutation_Response = {
  __typename?: 'support_tickets_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Support_Tickets_Category>;
};

/** on_conflict condition type for table "support_tickets_category" */
export type Support_Tickets_Category_On_Conflict = {
  constraint: Support_Tickets_Category_Constraint;
  update_columns?: Array<Support_Tickets_Category_Update_Column>;
  where?: InputMaybe<Support_Tickets_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "support_tickets_category". */
export type Support_Tickets_Category_Order_By = {
  category?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: support_tickets_category */
export type Support_Tickets_Category_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "support_tickets_category" */
export enum Support_Tickets_Category_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "support_tickets_category" */
export type Support_Tickets_Category_Set_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "support_tickets_category" */
export type Support_Tickets_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Support_Tickets_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Support_Tickets_Category_Stream_Cursor_Value_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "support_tickets_category" */
export enum Support_Tickets_Category_Update_Column {
  /** column name */
  Category = 'category',
  /** column name */
  Id = 'id'
}

export type Support_Tickets_Category_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Support_Tickets_Category_Set_Input>;
  /** filter the rows which have to be updated */
  where: Support_Tickets_Category_Bool_Exp;
};

/** unique or primary key constraints on table "support_tickets" */
export enum Support_Tickets_Constraint {
  /** unique or primary key constraint on columns "id" */
  SupportTicketsPkey = 'support_tickets_pkey'
}

/** input type for inserting data into table "support_tickets" */
export type Support_Tickets_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Source_Type_Enum>;
  source_type?: InputMaybe<Source_Type_Obj_Rel_Insert_Input>;
  subject?: InputMaybe<Scalars['String']['input']>;
  support_tickets_photos?: InputMaybe<Support_Tickets_Photos_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Support_Tickets_Max_Fields = {
  __typename?: 'support_tickets_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "support_tickets" */
export type Support_Tickets_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Support_Tickets_Min_Fields = {
  __typename?: 'support_tickets_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "support_tickets" */
export type Support_Tickets_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "support_tickets" */
export type Support_Tickets_Mutation_Response = {
  __typename?: 'support_tickets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Support_Tickets>;
};

/** input type for inserting object relation for remote table "support_tickets" */
export type Support_Tickets_Obj_Rel_Insert_Input = {
  data: Support_Tickets_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Support_Tickets_On_Conflict>;
};

/** on_conflict condition type for table "support_tickets" */
export type Support_Tickets_On_Conflict = {
  constraint: Support_Tickets_Constraint;
  update_columns?: Array<Support_Tickets_Update_Column>;
  where?: InputMaybe<Support_Tickets_Bool_Exp>;
};

/** Ordering options when selecting data from "support_tickets". */
export type Support_Tickets_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  source_type?: InputMaybe<Source_Type_Order_By>;
  subject?: InputMaybe<Order_By>;
  support_tickets_photos_aggregate?: InputMaybe<Support_Tickets_Photos_Aggregate_Order_By>;
};

/** columns and relationships of "support_tickets_photos" */
export type Support_Tickets_Photos = {
  __typename?: 'support_tickets_photos';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  support_ticket: Support_Tickets;
  support_ticket_id: Scalars['uuid']['output'];
  url: Scalars['String']['output'];
};

/** aggregated selection of "support_tickets_photos" */
export type Support_Tickets_Photos_Aggregate = {
  __typename?: 'support_tickets_photos_aggregate';
  aggregate?: Maybe<Support_Tickets_Photos_Aggregate_Fields>;
  nodes: Array<Support_Tickets_Photos>;
};

export type Support_Tickets_Photos_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Support_Tickets_Photos_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Support_Tickets_Photos_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Support_Tickets_Photos_Aggregate_Bool_Exp_Count>;
};

export type Support_Tickets_Photos_Aggregate_Bool_Exp_Bool_And = {
  arguments: Support_Tickets_Photos_Select_Column_Support_Tickets_Photos_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Support_Tickets_Photos_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Support_Tickets_Photos_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Support_Tickets_Photos_Select_Column_Support_Tickets_Photos_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Support_Tickets_Photos_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Support_Tickets_Photos_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Support_Tickets_Photos_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Support_Tickets_Photos_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "support_tickets_photos" */
export type Support_Tickets_Photos_Aggregate_Fields = {
  __typename?: 'support_tickets_photos_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Support_Tickets_Photos_Max_Fields>;
  min?: Maybe<Support_Tickets_Photos_Min_Fields>;
};


/** aggregate fields of "support_tickets_photos" */
export type Support_Tickets_Photos_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Support_Tickets_Photos_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "support_tickets_photos" */
export type Support_Tickets_Photos_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Support_Tickets_Photos_Max_Order_By>;
  min?: InputMaybe<Support_Tickets_Photos_Min_Order_By>;
};

/** input type for inserting array relation for remote table "support_tickets_photos" */
export type Support_Tickets_Photos_Arr_Rel_Insert_Input = {
  data: Array<Support_Tickets_Photos_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Support_Tickets_Photos_On_Conflict>;
};

/** Boolean expression to filter rows from the table "support_tickets_photos". All fields are combined with a logical 'AND'. */
export type Support_Tickets_Photos_Bool_Exp = {
  _and?: InputMaybe<Array<Support_Tickets_Photos_Bool_Exp>>;
  _not?: InputMaybe<Support_Tickets_Photos_Bool_Exp>;
  _or?: InputMaybe<Array<Support_Tickets_Photos_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  support_ticket?: InputMaybe<Support_Tickets_Bool_Exp>;
  support_ticket_id?: InputMaybe<Uuid_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "support_tickets_photos" */
export enum Support_Tickets_Photos_Constraint {
  /** unique or primary key constraint on columns "id" */
  SupportTicketsPhotosPkey = 'support_tickets_photos_pkey'
}

/** input type for inserting data into table "support_tickets_photos" */
export type Support_Tickets_Photos_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  support_ticket?: InputMaybe<Support_Tickets_Obj_Rel_Insert_Input>;
  support_ticket_id?: InputMaybe<Scalars['uuid']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Support_Tickets_Photos_Max_Fields = {
  __typename?: 'support_tickets_photos_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  support_ticket_id?: Maybe<Scalars['uuid']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "support_tickets_photos" */
export type Support_Tickets_Photos_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  support_ticket_id?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Support_Tickets_Photos_Min_Fields = {
  __typename?: 'support_tickets_photos_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  support_ticket_id?: Maybe<Scalars['uuid']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "support_tickets_photos" */
export type Support_Tickets_Photos_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  support_ticket_id?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "support_tickets_photos" */
export type Support_Tickets_Photos_Mutation_Response = {
  __typename?: 'support_tickets_photos_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Support_Tickets_Photos>;
};

/** on_conflict condition type for table "support_tickets_photos" */
export type Support_Tickets_Photos_On_Conflict = {
  constraint: Support_Tickets_Photos_Constraint;
  update_columns?: Array<Support_Tickets_Photos_Update_Column>;
  where?: InputMaybe<Support_Tickets_Photos_Bool_Exp>;
};

/** Ordering options when selecting data from "support_tickets_photos". */
export type Support_Tickets_Photos_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  support_ticket?: InputMaybe<Support_Tickets_Order_By>;
  support_ticket_id?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: support_tickets_photos */
export type Support_Tickets_Photos_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "support_tickets_photos" */
export enum Support_Tickets_Photos_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  SupportTicketId = 'support_ticket_id',
  /** column name */
  Url = 'url'
}

/** select "support_tickets_photos_aggregate_bool_exp_bool_and_arguments_columns" columns of table "support_tickets_photos" */
export enum Support_Tickets_Photos_Select_Column_Support_Tickets_Photos_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "support_tickets_photos_aggregate_bool_exp_bool_or_arguments_columns" columns of table "support_tickets_photos" */
export enum Support_Tickets_Photos_Select_Column_Support_Tickets_Photos_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "support_tickets_photos" */
export type Support_Tickets_Photos_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  support_ticket_id?: InputMaybe<Scalars['uuid']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "support_tickets_photos" */
export type Support_Tickets_Photos_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Support_Tickets_Photos_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Support_Tickets_Photos_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  support_ticket_id?: InputMaybe<Scalars['uuid']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "support_tickets_photos" */
export enum Support_Tickets_Photos_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  SupportTicketId = 'support_ticket_id',
  /** column name */
  Url = 'url'
}

export type Support_Tickets_Photos_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Support_Tickets_Photos_Set_Input>;
  /** filter the rows which have to be updated */
  where: Support_Tickets_Photos_Bool_Exp;
};

/** primary key columns input for table: support_tickets */
export type Support_Tickets_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "support_tickets" */
export enum Support_Tickets_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Message = 'message',
  /** column name */
  Source = 'source',
  /** column name */
  Subject = 'subject'
}

/** select "support_tickets_aggregate_bool_exp_bool_and_arguments_columns" columns of table "support_tickets" */
export enum Support_Tickets_Select_Column_Support_Tickets_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "support_tickets_aggregate_bool_exp_bool_or_arguments_columns" columns of table "support_tickets" */
export enum Support_Tickets_Select_Column_Support_Tickets_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "support_tickets" */
export type Support_Tickets_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Source_Type_Enum>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "support_tickets" */
export type Support_Tickets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Support_Tickets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Support_Tickets_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Source_Type_Enum>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "support_tickets" */
export enum Support_Tickets_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Message = 'message',
  /** column name */
  Source = 'source',
  /** column name */
  Subject = 'subject'
}

export type Support_Tickets_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Support_Tickets_Set_Input>;
  /** filter the rows which have to be updated */
  where: Support_Tickets_Bool_Exp;
};

/** columns and relationships of "tag" */
export type Tag = {
  __typename?: 'tag';
  created_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  customer_asset_tags: Array<Customer_Asset_Tag>;
  /** An aggregate relationship */
  customer_asset_tags_aggregate: Customer_Asset_Tag_Aggregate;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified: Scalars['timestamptz']['output'];
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name: Scalars['String']['output'];
  sku?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "tag" */
export type TagCustomer_Asset_TagsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Tag_Order_By>>;
  where?: InputMaybe<Customer_Asset_Tag_Bool_Exp>;
};


/** columns and relationships of "tag" */
export type TagCustomer_Asset_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Tag_Order_By>>;
  where?: InputMaybe<Customer_Asset_Tag_Bool_Exp>;
};

/** aggregated selection of "tag" */
export type Tag_Aggregate = {
  __typename?: 'tag_aggregate';
  aggregate?: Maybe<Tag_Aggregate_Fields>;
  nodes: Array<Tag>;
};

/** aggregate fields of "tag" */
export type Tag_Aggregate_Fields = {
  __typename?: 'tag_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tag_Max_Fields>;
  min?: Maybe<Tag_Min_Fields>;
};


/** aggregate fields of "tag" */
export type Tag_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tag_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "tag". All fields are combined with a logical 'AND'. */
export type Tag_Bool_Exp = {
  _and?: InputMaybe<Array<Tag_Bool_Exp>>;
  _not?: InputMaybe<Tag_Bool_Exp>;
  _or?: InputMaybe<Array<Tag_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  customer_asset_tags?: InputMaybe<Customer_Asset_Tag_Bool_Exp>;
  customer_asset_tags_aggregate?: InputMaybe<Customer_Asset_Tag_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  sku?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "tag" */
export enum Tag_Constraint {
  /** unique or primary key constraint on columns "id" */
  TagPkey = 'tag_pkey',
  /** unique or primary key constraint on columns "sku" */
  TagSkuKey = 'tag_sku_key'
}

/** input type for inserting data into table "tag" */
export type Tag_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  customer_asset_tags?: InputMaybe<Customer_Asset_Tag_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Tag_Max_Fields = {
  __typename?: 'tag_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Tag_Min_Fields = {
  __typename?: 'tag_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "tag" */
export type Tag_Mutation_Response = {
  __typename?: 'tag_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tag>;
};

/** input type for inserting object relation for remote table "tag" */
export type Tag_Obj_Rel_Insert_Input = {
  data: Tag_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tag_On_Conflict>;
};

/** on_conflict condition type for table "tag" */
export type Tag_On_Conflict = {
  constraint: Tag_Constraint;
  update_columns?: Array<Tag_Update_Column>;
  where?: InputMaybe<Tag_Bool_Exp>;
};

/** Ordering options when selecting data from "tag". */
export type Tag_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_asset_tags_aggregate?: InputMaybe<Customer_Asset_Tag_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  sku?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tag */
export type Tag_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "tag" */
export enum Tag_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  Sku = 'sku'
}

/** input type for updating data in table "tag" */
export type Tag_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tag" */
export type Tag_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tag_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tag_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tag" */
export enum Tag_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  Sku = 'sku'
}

export type Tag_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tag_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tag_Bool_Exp;
};

/** columns and relationships of "tank_type" */
export type Tank_Type = {
  __typename?: 'tank_type';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  vehicle_tank_types: Array<Vehicle_Tank_Type>;
  /** An aggregate relationship */
  vehicle_tank_types_aggregate: Vehicle_Tank_Type_Aggregate;
};


/** columns and relationships of "tank_type" */
export type Tank_TypeVehicle_Tank_TypesArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Tank_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Tank_Type_Order_By>>;
  where?: InputMaybe<Vehicle_Tank_Type_Bool_Exp>;
};


/** columns and relationships of "tank_type" */
export type Tank_TypeVehicle_Tank_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Tank_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Tank_Type_Order_By>>;
  where?: InputMaybe<Vehicle_Tank_Type_Bool_Exp>;
};

/** aggregated selection of "tank_type" */
export type Tank_Type_Aggregate = {
  __typename?: 'tank_type_aggregate';
  aggregate?: Maybe<Tank_Type_Aggregate_Fields>;
  nodes: Array<Tank_Type>;
};

/** aggregate fields of "tank_type" */
export type Tank_Type_Aggregate_Fields = {
  __typename?: 'tank_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tank_Type_Max_Fields>;
  min?: Maybe<Tank_Type_Min_Fields>;
};


/** aggregate fields of "tank_type" */
export type Tank_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tank_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "tank_type". All fields are combined with a logical 'AND'. */
export type Tank_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Tank_Type_Bool_Exp>>;
  _not?: InputMaybe<Tank_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Tank_Type_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  vehicle_tank_types?: InputMaybe<Vehicle_Tank_Type_Bool_Exp>;
  vehicle_tank_types_aggregate?: InputMaybe<Vehicle_Tank_Type_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "tank_type" */
export enum Tank_Type_Constraint {
  /** unique or primary key constraint on columns "id" */
  TankTypePkey = 'tank_type_pkey'
}

/** input type for inserting data into table "tank_type" */
export type Tank_Type_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  vehicle_tank_types?: InputMaybe<Vehicle_Tank_Type_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Tank_Type_Max_Fields = {
  __typename?: 'tank_type_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Tank_Type_Min_Fields = {
  __typename?: 'tank_type_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "tank_type" */
export type Tank_Type_Mutation_Response = {
  __typename?: 'tank_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tank_Type>;
};

/** input type for inserting object relation for remote table "tank_type" */
export type Tank_Type_Obj_Rel_Insert_Input = {
  data: Tank_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tank_Type_On_Conflict>;
};

/** on_conflict condition type for table "tank_type" */
export type Tank_Type_On_Conflict = {
  constraint: Tank_Type_Constraint;
  update_columns?: Array<Tank_Type_Update_Column>;
  where?: InputMaybe<Tank_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "tank_type". */
export type Tank_Type_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  vehicle_tank_types_aggregate?: InputMaybe<Vehicle_Tank_Type_Aggregate_Order_By>;
};

/** primary key columns input for table: tank_type */
export type Tank_Type_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "tank_type" */
export enum Tank_Type_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  Name = 'name',
  /** column name */
  Slug = 'slug'
}

/** input type for updating data in table "tank_type" */
export type Tank_Type_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tank_type" */
export type Tank_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tank_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tank_Type_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tank_type" */
export enum Tank_Type_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  Name = 'name',
  /** column name */
  Slug = 'slug'
}

export type Tank_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tank_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tank_Type_Bool_Exp;
};

/** columns and relationships of "task" */
export type Task = {
  __typename?: 'task';
  category: Task_Type_Enum;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  customer_order?: Maybe<Customer_Order>;
  customer_order_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  customer_order_item?: Maybe<Customer_Order_Item>;
  customer_order_item_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  customer_order_items: Array<Customer_Order_Item>;
  /** An aggregate relationship */
  customer_order_items_aggregate: Customer_Order_Item_Aggregate;
  /** An object relationship */
  customer_order_slot?: Maybe<Customer_Order_Slots>;
  customer_order_slots_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  driver?: Maybe<User>;
  driver_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  driver_vehicle?: Maybe<Driver_Vehicle>;
  driver_vehicle_id?: Maybe<Scalars['uuid']['output']>;
  estimate_delivery_date?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  fillup_requests: Array<Fillup_Request>;
  /** An aggregate relationship */
  fillup_requests_aggregate: Fillup_Request_Aggregate;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  is_done_locally?: Maybe<Scalars['Boolean']['output']>;
  is_enable_rfid_flow: Scalars['Boolean']['output'];
  /** An object relationship */
  job?: Maybe<Jobs>;
  job_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  job_type_template?: Maybe<Job_Type_Template>;
  job_type_template_id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  organization_address?: Maybe<Organization_Address>;
  /** An object relationship */
  partner_address?: Maybe<Partner_Address>;
  partner_address_id?: Maybe<Scalars['uuid']['output']>;
  rank_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  shift_schedule_dispenser?: Maybe<Shift_Schedule_Dispenser>;
  shift_schedule_dispenser_id?: Maybe<Scalars['uuid']['output']>;
  shipping_address_id?: Maybe<Scalars['uuid']['output']>;
  state?: Maybe<Task_State_Enum>;
  /** An array relationship */
  task_cancellation_reasons: Array<Task_Cancellation_Reasons>;
  /** An aggregate relationship */
  task_cancellation_reasons_aggregate: Task_Cancellation_Reasons_Aggregate;
  /** An object relationship */
  task_state?: Maybe<Task_State>;
  /** An array relationship */
  task_states_flows: Array<Task_States_Flow>;
  /** An aggregate relationship */
  task_states_flows_aggregate: Task_States_Flow_Aggregate;
  /** An object relationship */
  task_type: Task_Type;
  /** An array relationship */
  task_values: Array<Task_Value>;
  /** An aggregate relationship */
  task_values_aggregate: Task_Value_Aggregate;
  /** An array relationship */
  tickets: Array<Tickets>;
  /** An aggregate relationship */
  tickets_aggregate: Tickets_Aggregate;
  /** An object relationship */
  user?: Maybe<User>;
  /** An array relationship */
  validation_workflows: Array<Validation_Workflows>;
  /** An aggregate relationship */
  validation_workflows_aggregate: Validation_Workflows_Aggregate;
  /** An object relationship */
  vehicle?: Maybe<Vehicle>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "task" */
export type TaskCustomer_Order_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Bool_Exp>;
};


/** columns and relationships of "task" */
export type TaskCustomer_Order_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Bool_Exp>;
};


/** columns and relationships of "task" */
export type TaskFillup_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Fillup_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fillup_Request_Order_By>>;
  where?: InputMaybe<Fillup_Request_Bool_Exp>;
};


/** columns and relationships of "task" */
export type TaskFillup_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fillup_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fillup_Request_Order_By>>;
  where?: InputMaybe<Fillup_Request_Bool_Exp>;
};


/** columns and relationships of "task" */
export type TaskTask_Cancellation_ReasonsArgs = {
  distinct_on?: InputMaybe<Array<Task_Cancellation_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Cancellation_Reasons_Order_By>>;
  where?: InputMaybe<Task_Cancellation_Reasons_Bool_Exp>;
};


/** columns and relationships of "task" */
export type TaskTask_Cancellation_Reasons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Cancellation_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Cancellation_Reasons_Order_By>>;
  where?: InputMaybe<Task_Cancellation_Reasons_Bool_Exp>;
};


/** columns and relationships of "task" */
export type TaskTask_States_FlowsArgs = {
  distinct_on?: InputMaybe<Array<Task_States_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_States_Flow_Order_By>>;
  where?: InputMaybe<Task_States_Flow_Bool_Exp>;
};


/** columns and relationships of "task" */
export type TaskTask_States_Flows_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_States_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_States_Flow_Order_By>>;
  where?: InputMaybe<Task_States_Flow_Bool_Exp>;
};


/** columns and relationships of "task" */
export type TaskTask_ValuesArgs = {
  distinct_on?: InputMaybe<Array<Task_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Value_Order_By>>;
  where?: InputMaybe<Task_Value_Bool_Exp>;
};


/** columns and relationships of "task" */
export type TaskTask_Values_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Value_Order_By>>;
  where?: InputMaybe<Task_Value_Bool_Exp>;
};


/** columns and relationships of "task" */
export type TaskTicketsArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tickets_Order_By>>;
  where?: InputMaybe<Tickets_Bool_Exp>;
};


/** columns and relationships of "task" */
export type TaskTickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tickets_Order_By>>;
  where?: InputMaybe<Tickets_Bool_Exp>;
};


/** columns and relationships of "task" */
export type TaskValidation_WorkflowsArgs = {
  distinct_on?: InputMaybe<Array<Validation_Workflows_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Validation_Workflows_Order_By>>;
  where?: InputMaybe<Validation_Workflows_Bool_Exp>;
};


/** columns and relationships of "task" */
export type TaskValidation_Workflows_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Validation_Workflows_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Validation_Workflows_Order_By>>;
  where?: InputMaybe<Validation_Workflows_Bool_Exp>;
};

/** columns and relationships of "task_action_instruction" */
export type Task_Action_Instruction = {
  __typename?: 'task_action_instruction';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name: Scalars['String']['output'];
  rank_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  task_action_type: Task_Action_Type;
  task_action_type_id: Scalars['uuid']['output'];
};

/** aggregated selection of "task_action_instruction" */
export type Task_Action_Instruction_Aggregate = {
  __typename?: 'task_action_instruction_aggregate';
  aggregate?: Maybe<Task_Action_Instruction_Aggregate_Fields>;
  nodes: Array<Task_Action_Instruction>;
};

export type Task_Action_Instruction_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Task_Action_Instruction_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Task_Action_Instruction_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Task_Action_Instruction_Aggregate_Bool_Exp_Count>;
};

export type Task_Action_Instruction_Aggregate_Bool_Exp_Bool_And = {
  arguments: Task_Action_Instruction_Select_Column_Task_Action_Instruction_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Task_Action_Instruction_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Task_Action_Instruction_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Task_Action_Instruction_Select_Column_Task_Action_Instruction_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Task_Action_Instruction_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Task_Action_Instruction_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Task_Action_Instruction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Task_Action_Instruction_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "task_action_instruction" */
export type Task_Action_Instruction_Aggregate_Fields = {
  __typename?: 'task_action_instruction_aggregate_fields';
  avg?: Maybe<Task_Action_Instruction_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Task_Action_Instruction_Max_Fields>;
  min?: Maybe<Task_Action_Instruction_Min_Fields>;
  stddev?: Maybe<Task_Action_Instruction_Stddev_Fields>;
  stddev_pop?: Maybe<Task_Action_Instruction_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Task_Action_Instruction_Stddev_Samp_Fields>;
  sum?: Maybe<Task_Action_Instruction_Sum_Fields>;
  var_pop?: Maybe<Task_Action_Instruction_Var_Pop_Fields>;
  var_samp?: Maybe<Task_Action_Instruction_Var_Samp_Fields>;
  variance?: Maybe<Task_Action_Instruction_Variance_Fields>;
};


/** aggregate fields of "task_action_instruction" */
export type Task_Action_Instruction_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Task_Action_Instruction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "task_action_instruction" */
export type Task_Action_Instruction_Aggregate_Order_By = {
  avg?: InputMaybe<Task_Action_Instruction_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Task_Action_Instruction_Max_Order_By>;
  min?: InputMaybe<Task_Action_Instruction_Min_Order_By>;
  stddev?: InputMaybe<Task_Action_Instruction_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Task_Action_Instruction_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Task_Action_Instruction_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Task_Action_Instruction_Sum_Order_By>;
  var_pop?: InputMaybe<Task_Action_Instruction_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Task_Action_Instruction_Var_Samp_Order_By>;
  variance?: InputMaybe<Task_Action_Instruction_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "task_action_instruction" */
export type Task_Action_Instruction_Arr_Rel_Insert_Input = {
  data: Array<Task_Action_Instruction_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Task_Action_Instruction_On_Conflict>;
};

/** aggregate avg on columns */
export type Task_Action_Instruction_Avg_Fields = {
  __typename?: 'task_action_instruction_avg_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "task_action_instruction" */
export type Task_Action_Instruction_Avg_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "task_action_instruction". All fields are combined with a logical 'AND'. */
export type Task_Action_Instruction_Bool_Exp = {
  _and?: InputMaybe<Array<Task_Action_Instruction_Bool_Exp>>;
  _not?: InputMaybe<Task_Action_Instruction_Bool_Exp>;
  _or?: InputMaybe<Array<Task_Action_Instruction_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  rank_id?: InputMaybe<Int_Comparison_Exp>;
  task_action_type?: InputMaybe<Task_Action_Type_Bool_Exp>;
  task_action_type_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "task_action_instruction" */
export enum Task_Action_Instruction_Constraint {
  /** unique or primary key constraint on columns "id" */
  TaskActionInstructionPkey = 'task_action_instruction_pkey'
}

/** input type for incrementing numeric columns in table "task_action_instruction" */
export type Task_Action_Instruction_Inc_Input = {
  rank_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "task_action_instruction" */
export type Task_Action_Instruction_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rank_id?: InputMaybe<Scalars['Int']['input']>;
  task_action_type?: InputMaybe<Task_Action_Type_Obj_Rel_Insert_Input>;
  task_action_type_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Task_Action_Instruction_Max_Fields = {
  __typename?: 'task_action_instruction_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rank_id?: Maybe<Scalars['Int']['output']>;
  task_action_type_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "task_action_instruction" */
export type Task_Action_Instruction_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  rank_id?: InputMaybe<Order_By>;
  task_action_type_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Task_Action_Instruction_Min_Fields = {
  __typename?: 'task_action_instruction_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rank_id?: Maybe<Scalars['Int']['output']>;
  task_action_type_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "task_action_instruction" */
export type Task_Action_Instruction_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  rank_id?: InputMaybe<Order_By>;
  task_action_type_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "task_action_instruction" */
export type Task_Action_Instruction_Mutation_Response = {
  __typename?: 'task_action_instruction_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Task_Action_Instruction>;
};

/** on_conflict condition type for table "task_action_instruction" */
export type Task_Action_Instruction_On_Conflict = {
  constraint: Task_Action_Instruction_Constraint;
  update_columns?: Array<Task_Action_Instruction_Update_Column>;
  where?: InputMaybe<Task_Action_Instruction_Bool_Exp>;
};

/** Ordering options when selecting data from "task_action_instruction". */
export type Task_Action_Instruction_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  rank_id?: InputMaybe<Order_By>;
  task_action_type?: InputMaybe<Task_Action_Type_Order_By>;
  task_action_type_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: task_action_instruction */
export type Task_Action_Instruction_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "task_action_instruction" */
export enum Task_Action_Instruction_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  RankId = 'rank_id',
  /** column name */
  TaskActionTypeId = 'task_action_type_id'
}

/** select "task_action_instruction_aggregate_bool_exp_bool_and_arguments_columns" columns of table "task_action_instruction" */
export enum Task_Action_Instruction_Select_Column_Task_Action_Instruction_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "task_action_instruction_aggregate_bool_exp_bool_or_arguments_columns" columns of table "task_action_instruction" */
export enum Task_Action_Instruction_Select_Column_Task_Action_Instruction_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "task_action_instruction" */
export type Task_Action_Instruction_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rank_id?: InputMaybe<Scalars['Int']['input']>;
  task_action_type_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Task_Action_Instruction_Stddev_Fields = {
  __typename?: 'task_action_instruction_stddev_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "task_action_instruction" */
export type Task_Action_Instruction_Stddev_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Task_Action_Instruction_Stddev_Pop_Fields = {
  __typename?: 'task_action_instruction_stddev_pop_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "task_action_instruction" */
export type Task_Action_Instruction_Stddev_Pop_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Task_Action_Instruction_Stddev_Samp_Fields = {
  __typename?: 'task_action_instruction_stddev_samp_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "task_action_instruction" */
export type Task_Action_Instruction_Stddev_Samp_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "task_action_instruction" */
export type Task_Action_Instruction_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Task_Action_Instruction_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Task_Action_Instruction_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rank_id?: InputMaybe<Scalars['Int']['input']>;
  task_action_type_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Task_Action_Instruction_Sum_Fields = {
  __typename?: 'task_action_instruction_sum_fields';
  rank_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "task_action_instruction" */
export type Task_Action_Instruction_Sum_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** update columns of table "task_action_instruction" */
export enum Task_Action_Instruction_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  RankId = 'rank_id',
  /** column name */
  TaskActionTypeId = 'task_action_type_id'
}

export type Task_Action_Instruction_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Task_Action_Instruction_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Task_Action_Instruction_Set_Input>;
  /** filter the rows which have to be updated */
  where: Task_Action_Instruction_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Task_Action_Instruction_Var_Pop_Fields = {
  __typename?: 'task_action_instruction_var_pop_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "task_action_instruction" */
export type Task_Action_Instruction_Var_Pop_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Task_Action_Instruction_Var_Samp_Fields = {
  __typename?: 'task_action_instruction_var_samp_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "task_action_instruction" */
export type Task_Action_Instruction_Var_Samp_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Task_Action_Instruction_Variance_Fields = {
  __typename?: 'task_action_instruction_variance_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "task_action_instruction" */
export type Task_Action_Instruction_Variance_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "task_action_type" */
export type Task_Action_Type = {
  __typename?: 'task_action_type';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  task_action_instructions: Array<Task_Action_Instruction>;
  /** An aggregate relationship */
  task_action_instructions_aggregate: Task_Action_Instruction_Aggregate;
};


/** columns and relationships of "task_action_type" */
export type Task_Action_TypeTask_Action_InstructionsArgs = {
  distinct_on?: InputMaybe<Array<Task_Action_Instruction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Action_Instruction_Order_By>>;
  where?: InputMaybe<Task_Action_Instruction_Bool_Exp>;
};


/** columns and relationships of "task_action_type" */
export type Task_Action_TypeTask_Action_Instructions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Action_Instruction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Action_Instruction_Order_By>>;
  where?: InputMaybe<Task_Action_Instruction_Bool_Exp>;
};

/** aggregated selection of "task_action_type" */
export type Task_Action_Type_Aggregate = {
  __typename?: 'task_action_type_aggregate';
  aggregate?: Maybe<Task_Action_Type_Aggregate_Fields>;
  nodes: Array<Task_Action_Type>;
};

/** aggregate fields of "task_action_type" */
export type Task_Action_Type_Aggregate_Fields = {
  __typename?: 'task_action_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Task_Action_Type_Max_Fields>;
  min?: Maybe<Task_Action_Type_Min_Fields>;
};


/** aggregate fields of "task_action_type" */
export type Task_Action_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Task_Action_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "task_action_type". All fields are combined with a logical 'AND'. */
export type Task_Action_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Task_Action_Type_Bool_Exp>>;
  _not?: InputMaybe<Task_Action_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Task_Action_Type_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  task_action_instructions?: InputMaybe<Task_Action_Instruction_Bool_Exp>;
  task_action_instructions_aggregate?: InputMaybe<Task_Action_Instruction_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "task_action_type" */
export enum Task_Action_Type_Constraint {
  /** unique or primary key constraint on columns "id" */
  TaskActionTypePkey = 'task_action_type_pkey'
}

/** input type for inserting data into table "task_action_type" */
export type Task_Action_Type_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  task_action_instructions?: InputMaybe<Task_Action_Instruction_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Task_Action_Type_Max_Fields = {
  __typename?: 'task_action_type_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Task_Action_Type_Min_Fields = {
  __typename?: 'task_action_type_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "task_action_type" */
export type Task_Action_Type_Mutation_Response = {
  __typename?: 'task_action_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Task_Action_Type>;
};

/** input type for inserting object relation for remote table "task_action_type" */
export type Task_Action_Type_Obj_Rel_Insert_Input = {
  data: Task_Action_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Task_Action_Type_On_Conflict>;
};

/** on_conflict condition type for table "task_action_type" */
export type Task_Action_Type_On_Conflict = {
  constraint: Task_Action_Type_Constraint;
  update_columns?: Array<Task_Action_Type_Update_Column>;
  where?: InputMaybe<Task_Action_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "task_action_type". */
export type Task_Action_Type_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  task_action_instructions_aggregate?: InputMaybe<Task_Action_Instruction_Aggregate_Order_By>;
};

/** primary key columns input for table: task_action_type */
export type Task_Action_Type_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "task_action_type" */
export enum Task_Action_Type_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  Slug = 'slug'
}

/** input type for updating data in table "task_action_type" */
export type Task_Action_Type_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "task_action_type" */
export type Task_Action_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Task_Action_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Task_Action_Type_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "task_action_type" */
export enum Task_Action_Type_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  Slug = 'slug'
}

export type Task_Action_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Task_Action_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Task_Action_Type_Bool_Exp;
};

/** aggregated selection of "task" */
export type Task_Aggregate = {
  __typename?: 'task_aggregate';
  aggregate?: Maybe<Task_Aggregate_Fields>;
  nodes: Array<Task>;
};

export type Task_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Task_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Task_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Task_Aggregate_Bool_Exp_Count>;
};

export type Task_Aggregate_Bool_Exp_Bool_And = {
  arguments: Task_Select_Column_Task_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Task_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Task_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Task_Select_Column_Task_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Task_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Task_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Task_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Task_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "task" */
export type Task_Aggregate_Fields = {
  __typename?: 'task_aggregate_fields';
  avg?: Maybe<Task_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Task_Max_Fields>;
  min?: Maybe<Task_Min_Fields>;
  stddev?: Maybe<Task_Stddev_Fields>;
  stddev_pop?: Maybe<Task_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Task_Stddev_Samp_Fields>;
  sum?: Maybe<Task_Sum_Fields>;
  var_pop?: Maybe<Task_Var_Pop_Fields>;
  var_samp?: Maybe<Task_Var_Samp_Fields>;
  variance?: Maybe<Task_Variance_Fields>;
};


/** aggregate fields of "task" */
export type Task_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Task_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "task" */
export type Task_Aggregate_Order_By = {
  avg?: InputMaybe<Task_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Task_Max_Order_By>;
  min?: InputMaybe<Task_Min_Order_By>;
  stddev?: InputMaybe<Task_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Task_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Task_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Task_Sum_Order_By>;
  var_pop?: InputMaybe<Task_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Task_Var_Samp_Order_By>;
  variance?: InputMaybe<Task_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "task" */
export type Task_Arr_Rel_Insert_Input = {
  data: Array<Task_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Task_On_Conflict>;
};

/** aggregate avg on columns */
export type Task_Avg_Fields = {
  __typename?: 'task_avg_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "task" */
export type Task_Avg_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "task". All fields are combined with a logical 'AND'. */
export type Task_Bool_Exp = {
  _and?: InputMaybe<Array<Task_Bool_Exp>>;
  _not?: InputMaybe<Task_Bool_Exp>;
  _or?: InputMaybe<Array<Task_Bool_Exp>>;
  category?: InputMaybe<Task_Type_Enum_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  customer_order?: InputMaybe<Customer_Order_Bool_Exp>;
  customer_order_id?: InputMaybe<Uuid_Comparison_Exp>;
  customer_order_item?: InputMaybe<Customer_Order_Item_Bool_Exp>;
  customer_order_item_id?: InputMaybe<Uuid_Comparison_Exp>;
  customer_order_items?: InputMaybe<Customer_Order_Item_Bool_Exp>;
  customer_order_items_aggregate?: InputMaybe<Customer_Order_Item_Aggregate_Bool_Exp>;
  customer_order_slot?: InputMaybe<Customer_Order_Slots_Bool_Exp>;
  customer_order_slots_id?: InputMaybe<Uuid_Comparison_Exp>;
  driver?: InputMaybe<User_Bool_Exp>;
  driver_id?: InputMaybe<Uuid_Comparison_Exp>;
  driver_vehicle?: InputMaybe<Driver_Vehicle_Bool_Exp>;
  driver_vehicle_id?: InputMaybe<Uuid_Comparison_Exp>;
  estimate_delivery_date?: InputMaybe<Timestamp_Comparison_Exp>;
  fillup_requests?: InputMaybe<Fillup_Request_Bool_Exp>;
  fillup_requests_aggregate?: InputMaybe<Fillup_Request_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_done_locally?: InputMaybe<Boolean_Comparison_Exp>;
  is_enable_rfid_flow?: InputMaybe<Boolean_Comparison_Exp>;
  job?: InputMaybe<Jobs_Bool_Exp>;
  job_id?: InputMaybe<Uuid_Comparison_Exp>;
  job_type_template?: InputMaybe<Job_Type_Template_Bool_Exp>;
  job_type_template_id?: InputMaybe<Uuid_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  organization_address?: InputMaybe<Organization_Address_Bool_Exp>;
  partner_address?: InputMaybe<Partner_Address_Bool_Exp>;
  partner_address_id?: InputMaybe<Uuid_Comparison_Exp>;
  rank_id?: InputMaybe<Int_Comparison_Exp>;
  shift_schedule_dispenser?: InputMaybe<Shift_Schedule_Dispenser_Bool_Exp>;
  shift_schedule_dispenser_id?: InputMaybe<Uuid_Comparison_Exp>;
  shipping_address_id?: InputMaybe<Uuid_Comparison_Exp>;
  state?: InputMaybe<Task_State_Enum_Comparison_Exp>;
  task_cancellation_reasons?: InputMaybe<Task_Cancellation_Reasons_Bool_Exp>;
  task_cancellation_reasons_aggregate?: InputMaybe<Task_Cancellation_Reasons_Aggregate_Bool_Exp>;
  task_state?: InputMaybe<Task_State_Bool_Exp>;
  task_states_flows?: InputMaybe<Task_States_Flow_Bool_Exp>;
  task_states_flows_aggregate?: InputMaybe<Task_States_Flow_Aggregate_Bool_Exp>;
  task_type?: InputMaybe<Task_Type_Bool_Exp>;
  task_values?: InputMaybe<Task_Value_Bool_Exp>;
  task_values_aggregate?: InputMaybe<Task_Value_Aggregate_Bool_Exp>;
  tickets?: InputMaybe<Tickets_Bool_Exp>;
  tickets_aggregate?: InputMaybe<Tickets_Aggregate_Bool_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  validation_workflows?: InputMaybe<Validation_Workflows_Bool_Exp>;
  validation_workflows_aggregate?: InputMaybe<Validation_Workflows_Aggregate_Bool_Exp>;
  vehicle?: InputMaybe<Vehicle_Bool_Exp>;
  vehicle_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** columns and relationships of "task_cancellation_reasons" */
export type Task_Cancellation_Reasons = {
  __typename?: 'task_cancellation_reasons';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  task: Task;
  task_id: Scalars['uuid']['output'];
};

/** aggregated selection of "task_cancellation_reasons" */
export type Task_Cancellation_Reasons_Aggregate = {
  __typename?: 'task_cancellation_reasons_aggregate';
  aggregate?: Maybe<Task_Cancellation_Reasons_Aggregate_Fields>;
  nodes: Array<Task_Cancellation_Reasons>;
};

export type Task_Cancellation_Reasons_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Task_Cancellation_Reasons_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Task_Cancellation_Reasons_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Task_Cancellation_Reasons_Aggregate_Bool_Exp_Count>;
};

export type Task_Cancellation_Reasons_Aggregate_Bool_Exp_Bool_And = {
  arguments: Task_Cancellation_Reasons_Select_Column_Task_Cancellation_Reasons_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Task_Cancellation_Reasons_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Task_Cancellation_Reasons_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Task_Cancellation_Reasons_Select_Column_Task_Cancellation_Reasons_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Task_Cancellation_Reasons_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Task_Cancellation_Reasons_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Task_Cancellation_Reasons_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Task_Cancellation_Reasons_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "task_cancellation_reasons" */
export type Task_Cancellation_Reasons_Aggregate_Fields = {
  __typename?: 'task_cancellation_reasons_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Task_Cancellation_Reasons_Max_Fields>;
  min?: Maybe<Task_Cancellation_Reasons_Min_Fields>;
};


/** aggregate fields of "task_cancellation_reasons" */
export type Task_Cancellation_Reasons_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Task_Cancellation_Reasons_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "task_cancellation_reasons" */
export type Task_Cancellation_Reasons_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Task_Cancellation_Reasons_Max_Order_By>;
  min?: InputMaybe<Task_Cancellation_Reasons_Min_Order_By>;
};

/** input type for inserting array relation for remote table "task_cancellation_reasons" */
export type Task_Cancellation_Reasons_Arr_Rel_Insert_Input = {
  data: Array<Task_Cancellation_Reasons_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Task_Cancellation_Reasons_On_Conflict>;
};

/** Boolean expression to filter rows from the table "task_cancellation_reasons". All fields are combined with a logical 'AND'. */
export type Task_Cancellation_Reasons_Bool_Exp = {
  _and?: InputMaybe<Array<Task_Cancellation_Reasons_Bool_Exp>>;
  _not?: InputMaybe<Task_Cancellation_Reasons_Bool_Exp>;
  _or?: InputMaybe<Array<Task_Cancellation_Reasons_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  reason?: InputMaybe<String_Comparison_Exp>;
  task?: InputMaybe<Task_Bool_Exp>;
  task_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "task_cancellation_reasons" */
export enum Task_Cancellation_Reasons_Constraint {
  /** unique or primary key constraint on columns "id" */
  TaskCancellationReasonsPkey = 'task_cancellation_reasons_pkey'
}

/** input type for inserting data into table "task_cancellation_reasons" */
export type Task_Cancellation_Reasons_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  task?: InputMaybe<Task_Obj_Rel_Insert_Input>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Task_Cancellation_Reasons_Max_Fields = {
  __typename?: 'task_cancellation_reasons_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  task_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "task_cancellation_reasons" */
export type Task_Cancellation_Reasons_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Task_Cancellation_Reasons_Min_Fields = {
  __typename?: 'task_cancellation_reasons_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  task_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "task_cancellation_reasons" */
export type Task_Cancellation_Reasons_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "task_cancellation_reasons" */
export type Task_Cancellation_Reasons_Mutation_Response = {
  __typename?: 'task_cancellation_reasons_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Task_Cancellation_Reasons>;
};

/** on_conflict condition type for table "task_cancellation_reasons" */
export type Task_Cancellation_Reasons_On_Conflict = {
  constraint: Task_Cancellation_Reasons_Constraint;
  update_columns?: Array<Task_Cancellation_Reasons_Update_Column>;
  where?: InputMaybe<Task_Cancellation_Reasons_Bool_Exp>;
};

/** Ordering options when selecting data from "task_cancellation_reasons". */
export type Task_Cancellation_Reasons_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  task?: InputMaybe<Task_Order_By>;
  task_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: task_cancellation_reasons */
export type Task_Cancellation_Reasons_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "task_cancellation_reasons" */
export enum Task_Cancellation_Reasons_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Reason = 'reason',
  /** column name */
  TaskId = 'task_id'
}

/** select "task_cancellation_reasons_aggregate_bool_exp_bool_and_arguments_columns" columns of table "task_cancellation_reasons" */
export enum Task_Cancellation_Reasons_Select_Column_Task_Cancellation_Reasons_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "task_cancellation_reasons_aggregate_bool_exp_bool_or_arguments_columns" columns of table "task_cancellation_reasons" */
export enum Task_Cancellation_Reasons_Select_Column_Task_Cancellation_Reasons_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "task_cancellation_reasons" */
export type Task_Cancellation_Reasons_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "task_cancellation_reasons" */
export type Task_Cancellation_Reasons_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Task_Cancellation_Reasons_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Task_Cancellation_Reasons_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "task_cancellation_reasons" */
export enum Task_Cancellation_Reasons_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Reason = 'reason',
  /** column name */
  TaskId = 'task_id'
}

export type Task_Cancellation_Reasons_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Task_Cancellation_Reasons_Set_Input>;
  /** filter the rows which have to be updated */
  where: Task_Cancellation_Reasons_Bool_Exp;
};

/** unique or primary key constraints on table "task" */
export enum Task_Constraint {
  /** unique or primary key constraint on columns "id" */
  TaskPkey = 'task_pkey'
}

/** input type for incrementing numeric columns in table "task" */
export type Task_Inc_Input = {
  rank_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "task" */
export type Task_Insert_Input = {
  category?: InputMaybe<Task_Type_Enum>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  customer_order?: InputMaybe<Customer_Order_Obj_Rel_Insert_Input>;
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
  customer_order_item?: InputMaybe<Customer_Order_Item_Obj_Rel_Insert_Input>;
  customer_order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  customer_order_items?: InputMaybe<Customer_Order_Item_Arr_Rel_Insert_Input>;
  customer_order_slot?: InputMaybe<Customer_Order_Slots_Obj_Rel_Insert_Input>;
  customer_order_slots_id?: InputMaybe<Scalars['uuid']['input']>;
  driver?: InputMaybe<User_Obj_Rel_Insert_Input>;
  driver_id?: InputMaybe<Scalars['uuid']['input']>;
  driver_vehicle?: InputMaybe<Driver_Vehicle_Obj_Rel_Insert_Input>;
  driver_vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  estimate_delivery_date?: InputMaybe<Scalars['timestamp']['input']>;
  fillup_requests?: InputMaybe<Fillup_Request_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_done_locally?: InputMaybe<Scalars['Boolean']['input']>;
  is_enable_rfid_flow?: InputMaybe<Scalars['Boolean']['input']>;
  job?: InputMaybe<Jobs_Obj_Rel_Insert_Input>;
  job_id?: InputMaybe<Scalars['uuid']['input']>;
  job_type_template?: InputMaybe<Job_Type_Template_Obj_Rel_Insert_Input>;
  job_type_template_id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_address?: InputMaybe<Organization_Address_Obj_Rel_Insert_Input>;
  partner_address?: InputMaybe<Partner_Address_Obj_Rel_Insert_Input>;
  partner_address_id?: InputMaybe<Scalars['uuid']['input']>;
  rank_id?: InputMaybe<Scalars['Int']['input']>;
  shift_schedule_dispenser?: InputMaybe<Shift_Schedule_Dispenser_Obj_Rel_Insert_Input>;
  shift_schedule_dispenser_id?: InputMaybe<Scalars['uuid']['input']>;
  shipping_address_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Task_State_Enum>;
  task_cancellation_reasons?: InputMaybe<Task_Cancellation_Reasons_Arr_Rel_Insert_Input>;
  task_state?: InputMaybe<Task_State_Obj_Rel_Insert_Input>;
  task_states_flows?: InputMaybe<Task_States_Flow_Arr_Rel_Insert_Input>;
  task_type?: InputMaybe<Task_Type_Obj_Rel_Insert_Input>;
  task_values?: InputMaybe<Task_Value_Arr_Rel_Insert_Input>;
  tickets?: InputMaybe<Tickets_Arr_Rel_Insert_Input>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  validation_workflows?: InputMaybe<Validation_Workflows_Arr_Rel_Insert_Input>;
  vehicle?: InputMaybe<Vehicle_Obj_Rel_Insert_Input>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Task_Max_Fields = {
  __typename?: 'task_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  customer_order_id?: Maybe<Scalars['uuid']['output']>;
  customer_order_item_id?: Maybe<Scalars['uuid']['output']>;
  customer_order_slots_id?: Maybe<Scalars['uuid']['output']>;
  driver_id?: Maybe<Scalars['uuid']['output']>;
  driver_vehicle_id?: Maybe<Scalars['uuid']['output']>;
  estimate_delivery_date?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  job_id?: Maybe<Scalars['uuid']['output']>;
  job_type_template_id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_address_id?: Maybe<Scalars['uuid']['output']>;
  rank_id?: Maybe<Scalars['Int']['output']>;
  shift_schedule_dispenser_id?: Maybe<Scalars['uuid']['output']>;
  shipping_address_id?: Maybe<Scalars['uuid']['output']>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "task" */
export type Task_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  customer_order_id?: InputMaybe<Order_By>;
  customer_order_item_id?: InputMaybe<Order_By>;
  customer_order_slots_id?: InputMaybe<Order_By>;
  driver_id?: InputMaybe<Order_By>;
  driver_vehicle_id?: InputMaybe<Order_By>;
  estimate_delivery_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  job_id?: InputMaybe<Order_By>;
  job_type_template_id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_address_id?: InputMaybe<Order_By>;
  rank_id?: InputMaybe<Order_By>;
  shift_schedule_dispenser_id?: InputMaybe<Order_By>;
  shipping_address_id?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Task_Min_Fields = {
  __typename?: 'task_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  customer_order_id?: Maybe<Scalars['uuid']['output']>;
  customer_order_item_id?: Maybe<Scalars['uuid']['output']>;
  customer_order_slots_id?: Maybe<Scalars['uuid']['output']>;
  driver_id?: Maybe<Scalars['uuid']['output']>;
  driver_vehicle_id?: Maybe<Scalars['uuid']['output']>;
  estimate_delivery_date?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  job_id?: Maybe<Scalars['uuid']['output']>;
  job_type_template_id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_address_id?: Maybe<Scalars['uuid']['output']>;
  rank_id?: Maybe<Scalars['Int']['output']>;
  shift_schedule_dispenser_id?: Maybe<Scalars['uuid']['output']>;
  shipping_address_id?: Maybe<Scalars['uuid']['output']>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "task" */
export type Task_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  customer_order_id?: InputMaybe<Order_By>;
  customer_order_item_id?: InputMaybe<Order_By>;
  customer_order_slots_id?: InputMaybe<Order_By>;
  driver_id?: InputMaybe<Order_By>;
  driver_vehicle_id?: InputMaybe<Order_By>;
  estimate_delivery_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  job_id?: InputMaybe<Order_By>;
  job_type_template_id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_address_id?: InputMaybe<Order_By>;
  rank_id?: InputMaybe<Order_By>;
  shift_schedule_dispenser_id?: InputMaybe<Order_By>;
  shipping_address_id?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "task" */
export type Task_Mutation_Response = {
  __typename?: 'task_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Task>;
};

/** input type for inserting object relation for remote table "task" */
export type Task_Obj_Rel_Insert_Input = {
  data: Task_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Task_On_Conflict>;
};

/** on_conflict condition type for table "task" */
export type Task_On_Conflict = {
  constraint: Task_Constraint;
  update_columns?: Array<Task_Update_Column>;
  where?: InputMaybe<Task_Bool_Exp>;
};

/** Ordering options when selecting data from "task". */
export type Task_Order_By = {
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  customer_order?: InputMaybe<Customer_Order_Order_By>;
  customer_order_id?: InputMaybe<Order_By>;
  customer_order_item?: InputMaybe<Customer_Order_Item_Order_By>;
  customer_order_item_id?: InputMaybe<Order_By>;
  customer_order_items_aggregate?: InputMaybe<Customer_Order_Item_Aggregate_Order_By>;
  customer_order_slot?: InputMaybe<Customer_Order_Slots_Order_By>;
  customer_order_slots_id?: InputMaybe<Order_By>;
  driver?: InputMaybe<User_Order_By>;
  driver_id?: InputMaybe<Order_By>;
  driver_vehicle?: InputMaybe<Driver_Vehicle_Order_By>;
  driver_vehicle_id?: InputMaybe<Order_By>;
  estimate_delivery_date?: InputMaybe<Order_By>;
  fillup_requests_aggregate?: InputMaybe<Fillup_Request_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_done_locally?: InputMaybe<Order_By>;
  is_enable_rfid_flow?: InputMaybe<Order_By>;
  job?: InputMaybe<Jobs_Order_By>;
  job_id?: InputMaybe<Order_By>;
  job_type_template?: InputMaybe<Job_Type_Template_Order_By>;
  job_type_template_id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_address?: InputMaybe<Organization_Address_Order_By>;
  partner_address?: InputMaybe<Partner_Address_Order_By>;
  partner_address_id?: InputMaybe<Order_By>;
  rank_id?: InputMaybe<Order_By>;
  shift_schedule_dispenser?: InputMaybe<Shift_Schedule_Dispenser_Order_By>;
  shift_schedule_dispenser_id?: InputMaybe<Order_By>;
  shipping_address_id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  task_cancellation_reasons_aggregate?: InputMaybe<Task_Cancellation_Reasons_Aggregate_Order_By>;
  task_state?: InputMaybe<Task_State_Order_By>;
  task_states_flows_aggregate?: InputMaybe<Task_States_Flow_Aggregate_Order_By>;
  task_type?: InputMaybe<Task_Type_Order_By>;
  task_values_aggregate?: InputMaybe<Task_Value_Aggregate_Order_By>;
  tickets_aggregate?: InputMaybe<Tickets_Aggregate_Order_By>;
  user?: InputMaybe<User_Order_By>;
  validation_workflows_aggregate?: InputMaybe<Validation_Workflows_Aggregate_Order_By>;
  vehicle?: InputMaybe<Vehicle_Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: task */
export type Task_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "task" */
export enum Task_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CustomerOrderId = 'customer_order_id',
  /** column name */
  CustomerOrderItemId = 'customer_order_item_id',
  /** column name */
  CustomerOrderSlotsId = 'customer_order_slots_id',
  /** column name */
  DriverId = 'driver_id',
  /** column name */
  DriverVehicleId = 'driver_vehicle_id',
  /** column name */
  EstimateDeliveryDate = 'estimate_delivery_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsDoneLocally = 'is_done_locally',
  /** column name */
  IsEnableRfidFlow = 'is_enable_rfid_flow',
  /** column name */
  JobId = 'job_id',
  /** column name */
  JobTypeTemplateId = 'job_type_template_id',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerAddressId = 'partner_address_id',
  /** column name */
  RankId = 'rank_id',
  /** column name */
  ShiftScheduleDispenserId = 'shift_schedule_dispenser_id',
  /** column name */
  ShippingAddressId = 'shipping_address_id',
  /** column name */
  State = 'state',
  /** column name */
  VehicleId = 'vehicle_id'
}

/** select "task_aggregate_bool_exp_bool_and_arguments_columns" columns of table "task" */
export enum Task_Select_Column_Task_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsDoneLocally = 'is_done_locally',
  /** column name */
  IsEnableRfidFlow = 'is_enable_rfid_flow'
}

/** select "task_aggregate_bool_exp_bool_or_arguments_columns" columns of table "task" */
export enum Task_Select_Column_Task_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsDoneLocally = 'is_done_locally',
  /** column name */
  IsEnableRfidFlow = 'is_enable_rfid_flow'
}

/** input type for updating data in table "task" */
export type Task_Set_Input = {
  category?: InputMaybe<Task_Type_Enum>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
  customer_order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  customer_order_slots_id?: InputMaybe<Scalars['uuid']['input']>;
  driver_id?: InputMaybe<Scalars['uuid']['input']>;
  driver_vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  estimate_delivery_date?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_done_locally?: InputMaybe<Scalars['Boolean']['input']>;
  is_enable_rfid_flow?: InputMaybe<Scalars['Boolean']['input']>;
  job_id?: InputMaybe<Scalars['uuid']['input']>;
  job_type_template_id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_address_id?: InputMaybe<Scalars['uuid']['input']>;
  rank_id?: InputMaybe<Scalars['Int']['input']>;
  shift_schedule_dispenser_id?: InputMaybe<Scalars['uuid']['input']>;
  shipping_address_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Task_State_Enum>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "task_state" */
export type Task_State = {
  __typename?: 'task_state';
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  task_states_flows: Array<Task_States_Flow>;
  /** An aggregate relationship */
  task_states_flows_aggregate: Task_States_Flow_Aggregate;
  /** An array relationship */
  tasks: Array<Task>;
  /** An aggregate relationship */
  tasks_aggregate: Task_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "task_state" */
export type Task_StateTask_States_FlowsArgs = {
  distinct_on?: InputMaybe<Array<Task_States_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_States_Flow_Order_By>>;
  where?: InputMaybe<Task_States_Flow_Bool_Exp>;
};


/** columns and relationships of "task_state" */
export type Task_StateTask_States_Flows_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_States_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_States_Flow_Order_By>>;
  where?: InputMaybe<Task_States_Flow_Bool_Exp>;
};


/** columns and relationships of "task_state" */
export type Task_StateTasksArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


/** columns and relationships of "task_state" */
export type Task_StateTasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};

/** aggregated selection of "task_state" */
export type Task_State_Aggregate = {
  __typename?: 'task_state_aggregate';
  aggregate?: Maybe<Task_State_Aggregate_Fields>;
  nodes: Array<Task_State>;
};

/** aggregate fields of "task_state" */
export type Task_State_Aggregate_Fields = {
  __typename?: 'task_state_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Task_State_Max_Fields>;
  min?: Maybe<Task_State_Min_Fields>;
};


/** aggregate fields of "task_state" */
export type Task_State_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Task_State_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "task_state". All fields are combined with a logical 'AND'. */
export type Task_State_Bool_Exp = {
  _and?: InputMaybe<Array<Task_State_Bool_Exp>>;
  _not?: InputMaybe<Task_State_Bool_Exp>;
  _or?: InputMaybe<Array<Task_State_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  task_states_flows?: InputMaybe<Task_States_Flow_Bool_Exp>;
  task_states_flows_aggregate?: InputMaybe<Task_States_Flow_Aggregate_Bool_Exp>;
  tasks?: InputMaybe<Task_Bool_Exp>;
  tasks_aggregate?: InputMaybe<Task_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "task_state" */
export enum Task_State_Constraint {
  /** unique or primary key constraint on columns "value" */
  TaskStatePkey = 'task_state_pkey'
}

export enum Task_State_Enum {
  /** when task is accepted by driver vehicle */
  Accepted = 'ACCEPTED',
  /** when driver vehicle reached to location */
  Arrived = 'ARRIVED',
  /** when task is assigned to driver vehicle */
  Assigned = 'ASSIGNED',
  /** when driver vehicle ask to cancel trip */
  CancellationRequested = 'CANCELLATION_REQUESTED',
  /** when task is cancelled */
  Cancelled = 'CANCELLED',
  /** when driver vehicle delivered  fuel or consumable items */
  Delivered = 'DELIVERED',
  /** when driver vehicle start to dispense fuel or consumable items */
  Dispensing = 'DISPENSING',
  /** when driver vehicle travel to location */
  InTransit = 'IN_TRANSIT',
  /** when task is not assigned to driver vehicle */
  Open = 'OPEN',
  /** when driver vehicle reject task */
  Rejected = 'REJECTED',
  /** when task is rescheduled */
  Rescheduled = 'RESCHEDULED',
  /** when driver vehicle schedule trip */
  Schedule = 'SCHEDULE',
  /** when driver vehicle start trip */
  Started = 'STARTED'
}

/** Boolean expression to compare columns of type "task_state_enum". All fields are combined with logical 'AND'. */
export type Task_State_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Task_State_Enum>;
  _in?: InputMaybe<Array<Task_State_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Task_State_Enum>;
  _nin?: InputMaybe<Array<Task_State_Enum>>;
};

/** input type for inserting data into table "task_state" */
export type Task_State_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  task_states_flows?: InputMaybe<Task_States_Flow_Arr_Rel_Insert_Input>;
  tasks?: InputMaybe<Task_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Task_State_Max_Fields = {
  __typename?: 'task_state_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Task_State_Min_Fields = {
  __typename?: 'task_state_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "task_state" */
export type Task_State_Mutation_Response = {
  __typename?: 'task_state_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Task_State>;
};

/** input type for inserting object relation for remote table "task_state" */
export type Task_State_Obj_Rel_Insert_Input = {
  data: Task_State_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Task_State_On_Conflict>;
};

/** on_conflict condition type for table "task_state" */
export type Task_State_On_Conflict = {
  constraint: Task_State_Constraint;
  update_columns?: Array<Task_State_Update_Column>;
  where?: InputMaybe<Task_State_Bool_Exp>;
};

/** Ordering options when selecting data from "task_state". */
export type Task_State_Order_By = {
  comment?: InputMaybe<Order_By>;
  task_states_flows_aggregate?: InputMaybe<Task_States_Flow_Aggregate_Order_By>;
  tasks_aggregate?: InputMaybe<Task_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: task_state */
export type Task_State_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "task_state" */
export enum Task_State_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "task_state" */
export type Task_State_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "task_state" */
export type Task_State_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Task_State_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Task_State_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "task_state" */
export enum Task_State_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Task_State_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Task_State_Set_Input>;
  /** filter the rows which have to be updated */
  where: Task_State_Bool_Exp;
};

/** columns and relationships of "task_states_flow" */
export type Task_States_Flow = {
  __typename?: 'task_states_flow';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  previousDriver?: Maybe<User>;
  /** An object relationship */
  previousVehicle?: Maybe<Vehicle>;
  previous_driver_id?: Maybe<Scalars['uuid']['output']>;
  previous_driver_vehicle_id?: Maybe<Scalars['uuid']['output']>;
  previous_vehicle_id?: Maybe<Scalars['uuid']['output']>;
  state: Task_State_Enum;
  /** An object relationship */
  task: Task;
  task_id: Scalars['uuid']['output'];
  /** An object relationship */
  task_state: Task_State;
};

/** aggregated selection of "task_states_flow" */
export type Task_States_Flow_Aggregate = {
  __typename?: 'task_states_flow_aggregate';
  aggregate?: Maybe<Task_States_Flow_Aggregate_Fields>;
  nodes: Array<Task_States_Flow>;
};

export type Task_States_Flow_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Task_States_Flow_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Task_States_Flow_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Task_States_Flow_Aggregate_Bool_Exp_Count>;
};

export type Task_States_Flow_Aggregate_Bool_Exp_Bool_And = {
  arguments: Task_States_Flow_Select_Column_Task_States_Flow_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Task_States_Flow_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Task_States_Flow_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Task_States_Flow_Select_Column_Task_States_Flow_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Task_States_Flow_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Task_States_Flow_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Task_States_Flow_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Task_States_Flow_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "task_states_flow" */
export type Task_States_Flow_Aggregate_Fields = {
  __typename?: 'task_states_flow_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Task_States_Flow_Max_Fields>;
  min?: Maybe<Task_States_Flow_Min_Fields>;
};


/** aggregate fields of "task_states_flow" */
export type Task_States_Flow_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Task_States_Flow_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "task_states_flow" */
export type Task_States_Flow_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Task_States_Flow_Max_Order_By>;
  min?: InputMaybe<Task_States_Flow_Min_Order_By>;
};

/** input type for inserting array relation for remote table "task_states_flow" */
export type Task_States_Flow_Arr_Rel_Insert_Input = {
  data: Array<Task_States_Flow_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Task_States_Flow_On_Conflict>;
};

/** Boolean expression to filter rows from the table "task_states_flow". All fields are combined with a logical 'AND'. */
export type Task_States_Flow_Bool_Exp = {
  _and?: InputMaybe<Array<Task_States_Flow_Bool_Exp>>;
  _not?: InputMaybe<Task_States_Flow_Bool_Exp>;
  _or?: InputMaybe<Array<Task_States_Flow_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  previousDriver?: InputMaybe<User_Bool_Exp>;
  previousVehicle?: InputMaybe<Vehicle_Bool_Exp>;
  previous_driver_id?: InputMaybe<Uuid_Comparison_Exp>;
  previous_driver_vehicle_id?: InputMaybe<Uuid_Comparison_Exp>;
  previous_vehicle_id?: InputMaybe<Uuid_Comparison_Exp>;
  state?: InputMaybe<Task_State_Enum_Comparison_Exp>;
  task?: InputMaybe<Task_Bool_Exp>;
  task_id?: InputMaybe<Uuid_Comparison_Exp>;
  task_state?: InputMaybe<Task_State_Bool_Exp>;
};

/** unique or primary key constraints on table "task_states_flow" */
export enum Task_States_Flow_Constraint {
  /** unique or primary key constraint on columns "id" */
  TaskStatesFlowPkey = 'task_states_flow_pkey'
}

/** input type for inserting data into table "task_states_flow" */
export type Task_States_Flow_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  previousDriver?: InputMaybe<User_Obj_Rel_Insert_Input>;
  previousVehicle?: InputMaybe<Vehicle_Obj_Rel_Insert_Input>;
  previous_driver_id?: InputMaybe<Scalars['uuid']['input']>;
  previous_driver_vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  previous_vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Task_State_Enum>;
  task?: InputMaybe<Task_Obj_Rel_Insert_Input>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
  task_state?: InputMaybe<Task_State_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Task_States_Flow_Max_Fields = {
  __typename?: 'task_states_flow_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  previous_driver_id?: Maybe<Scalars['uuid']['output']>;
  previous_driver_vehicle_id?: Maybe<Scalars['uuid']['output']>;
  previous_vehicle_id?: Maybe<Scalars['uuid']['output']>;
  task_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "task_states_flow" */
export type Task_States_Flow_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  previous_driver_id?: InputMaybe<Order_By>;
  previous_driver_vehicle_id?: InputMaybe<Order_By>;
  previous_vehicle_id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Task_States_Flow_Min_Fields = {
  __typename?: 'task_states_flow_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  previous_driver_id?: Maybe<Scalars['uuid']['output']>;
  previous_driver_vehicle_id?: Maybe<Scalars['uuid']['output']>;
  previous_vehicle_id?: Maybe<Scalars['uuid']['output']>;
  task_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "task_states_flow" */
export type Task_States_Flow_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  previous_driver_id?: InputMaybe<Order_By>;
  previous_driver_vehicle_id?: InputMaybe<Order_By>;
  previous_vehicle_id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "task_states_flow" */
export type Task_States_Flow_Mutation_Response = {
  __typename?: 'task_states_flow_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Task_States_Flow>;
};

/** on_conflict condition type for table "task_states_flow" */
export type Task_States_Flow_On_Conflict = {
  constraint: Task_States_Flow_Constraint;
  update_columns?: Array<Task_States_Flow_Update_Column>;
  where?: InputMaybe<Task_States_Flow_Bool_Exp>;
};

/** Ordering options when selecting data from "task_states_flow". */
export type Task_States_Flow_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  previousDriver?: InputMaybe<User_Order_By>;
  previousVehicle?: InputMaybe<Vehicle_Order_By>;
  previous_driver_id?: InputMaybe<Order_By>;
  previous_driver_vehicle_id?: InputMaybe<Order_By>;
  previous_vehicle_id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  task?: InputMaybe<Task_Order_By>;
  task_id?: InputMaybe<Order_By>;
  task_state?: InputMaybe<Task_State_Order_By>;
};

/** primary key columns input for table: task_states_flow */
export type Task_States_Flow_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "task_states_flow" */
export enum Task_States_Flow_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PreviousDriverId = 'previous_driver_id',
  /** column name */
  PreviousDriverVehicleId = 'previous_driver_vehicle_id',
  /** column name */
  PreviousVehicleId = 'previous_vehicle_id',
  /** column name */
  State = 'state',
  /** column name */
  TaskId = 'task_id'
}

/** select "task_states_flow_aggregate_bool_exp_bool_and_arguments_columns" columns of table "task_states_flow" */
export enum Task_States_Flow_Select_Column_Task_States_Flow_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "task_states_flow_aggregate_bool_exp_bool_or_arguments_columns" columns of table "task_states_flow" */
export enum Task_States_Flow_Select_Column_Task_States_Flow_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "task_states_flow" */
export type Task_States_Flow_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  previous_driver_id?: InputMaybe<Scalars['uuid']['input']>;
  previous_driver_vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  previous_vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Task_State_Enum>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "task_states_flow" */
export type Task_States_Flow_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Task_States_Flow_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Task_States_Flow_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  previous_driver_id?: InputMaybe<Scalars['uuid']['input']>;
  previous_driver_vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  previous_vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Task_State_Enum>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "task_states_flow" */
export enum Task_States_Flow_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PreviousDriverId = 'previous_driver_id',
  /** column name */
  PreviousDriverVehicleId = 'previous_driver_vehicle_id',
  /** column name */
  PreviousVehicleId = 'previous_vehicle_id',
  /** column name */
  State = 'state',
  /** column name */
  TaskId = 'task_id'
}

export type Task_States_Flow_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Task_States_Flow_Set_Input>;
  /** filter the rows which have to be updated */
  where: Task_States_Flow_Bool_Exp;
};

/** aggregate stddev on columns */
export type Task_Stddev_Fields = {
  __typename?: 'task_stddev_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "task" */
export type Task_Stddev_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Task_Stddev_Pop_Fields = {
  __typename?: 'task_stddev_pop_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "task" */
export type Task_Stddev_Pop_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Task_Stddev_Samp_Fields = {
  __typename?: 'task_stddev_samp_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "task" */
export type Task_Stddev_Samp_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "task" */
export type Task_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Task_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Task_Stream_Cursor_Value_Input = {
  category?: InputMaybe<Task_Type_Enum>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
  customer_order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  customer_order_slots_id?: InputMaybe<Scalars['uuid']['input']>;
  driver_id?: InputMaybe<Scalars['uuid']['input']>;
  driver_vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  estimate_delivery_date?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_done_locally?: InputMaybe<Scalars['Boolean']['input']>;
  is_enable_rfid_flow?: InputMaybe<Scalars['Boolean']['input']>;
  job_id?: InputMaybe<Scalars['uuid']['input']>;
  job_type_template_id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  partner_address_id?: InputMaybe<Scalars['uuid']['input']>;
  rank_id?: InputMaybe<Scalars['Int']['input']>;
  shift_schedule_dispenser_id?: InputMaybe<Scalars['uuid']['input']>;
  shipping_address_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Task_State_Enum>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Task_Sum_Fields = {
  __typename?: 'task_sum_fields';
  rank_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "task" */
export type Task_Sum_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "task_type" */
export type Task_Type = {
  __typename?: 'task_type';
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  tasks: Array<Task>;
  /** An aggregate relationship */
  tasks_aggregate: Task_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "task_type" */
export type Task_TypeTasksArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


/** columns and relationships of "task_type" */
export type Task_TypeTasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};

/** aggregated selection of "task_type" */
export type Task_Type_Aggregate = {
  __typename?: 'task_type_aggregate';
  aggregate?: Maybe<Task_Type_Aggregate_Fields>;
  nodes: Array<Task_Type>;
};

/** aggregate fields of "task_type" */
export type Task_Type_Aggregate_Fields = {
  __typename?: 'task_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Task_Type_Max_Fields>;
  min?: Maybe<Task_Type_Min_Fields>;
};


/** aggregate fields of "task_type" */
export type Task_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Task_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "task_type". All fields are combined with a logical 'AND'. */
export type Task_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Task_Type_Bool_Exp>>;
  _not?: InputMaybe<Task_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Task_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  tasks?: InputMaybe<Task_Bool_Exp>;
  tasks_aggregate?: InputMaybe<Task_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "task_type" */
export enum Task_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  TaskTypePkey = 'task_type_pkey'
}

export enum Task_Type_Enum {
  /** DELIVERY */
  Delivery = 'DELIVERY',
  /** FILL_UP */
  FillUp = 'FILL_UP',
  /** PICK_UP */
  PickUp = 'PICK_UP'
}

/** Boolean expression to compare columns of type "task_type_enum". All fields are combined with logical 'AND'. */
export type Task_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Task_Type_Enum>;
  _in?: InputMaybe<Array<Task_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Task_Type_Enum>;
  _nin?: InputMaybe<Array<Task_Type_Enum>>;
};

/** input type for inserting data into table "task_type" */
export type Task_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  tasks?: InputMaybe<Task_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Task_Type_Max_Fields = {
  __typename?: 'task_type_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Task_Type_Min_Fields = {
  __typename?: 'task_type_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "task_type" */
export type Task_Type_Mutation_Response = {
  __typename?: 'task_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Task_Type>;
};

/** input type for inserting object relation for remote table "task_type" */
export type Task_Type_Obj_Rel_Insert_Input = {
  data: Task_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Task_Type_On_Conflict>;
};

/** on_conflict condition type for table "task_type" */
export type Task_Type_On_Conflict = {
  constraint: Task_Type_Constraint;
  update_columns?: Array<Task_Type_Update_Column>;
  where?: InputMaybe<Task_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "task_type". */
export type Task_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  tasks_aggregate?: InputMaybe<Task_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: task_type */
export type Task_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "task_type" */
export enum Task_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "task_type" */
export type Task_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "task_type" */
export type Task_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Task_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Task_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "task_type" */
export enum Task_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Task_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Task_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Task_Type_Bool_Exp;
};

/** update columns of table "task" */
export enum Task_Update_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CustomerOrderId = 'customer_order_id',
  /** column name */
  CustomerOrderItemId = 'customer_order_item_id',
  /** column name */
  CustomerOrderSlotsId = 'customer_order_slots_id',
  /** column name */
  DriverId = 'driver_id',
  /** column name */
  DriverVehicleId = 'driver_vehicle_id',
  /** column name */
  EstimateDeliveryDate = 'estimate_delivery_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsDoneLocally = 'is_done_locally',
  /** column name */
  IsEnableRfidFlow = 'is_enable_rfid_flow',
  /** column name */
  JobId = 'job_id',
  /** column name */
  JobTypeTemplateId = 'job_type_template_id',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PartnerAddressId = 'partner_address_id',
  /** column name */
  RankId = 'rank_id',
  /** column name */
  ShiftScheduleDispenserId = 'shift_schedule_dispenser_id',
  /** column name */
  ShippingAddressId = 'shipping_address_id',
  /** column name */
  State = 'state',
  /** column name */
  VehicleId = 'vehicle_id'
}

export type Task_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Task_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Task_Set_Input>;
  /** filter the rows which have to be updated */
  where: Task_Bool_Exp;
};

/** columns and relationships of "task_value" */
export type Task_Value = {
  __typename?: 'task_value';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  customer_asset?: Maybe<Customer_Asset>;
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  is_reconciled?: Maybe<Scalars['Boolean']['output']>;
  key: Scalars['String']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  location?: Maybe<Scalars['point']['output']>;
  /** An object relationship */
  quantity_correction_ticket?: Maybe<Quantity_Correction_Tickets>;
  quantity_dispensed?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  reason?: Maybe<Reasons>;
  reason_id?: Maybe<Scalars['uuid']['output']>;
  revised_quantity_dispensed?: Maybe<Scalars['numeric']['output']>;
  revised_value?: Maybe<Scalars['String']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  task: Task;
  task_id: Scalars['uuid']['output'];
  /** An array relationship */
  tickets: Array<Tickets>;
  /** An aggregate relationship */
  tickets_aggregate: Tickets_Aggregate;
  /** An array relationship */
  totalizer_correction_tickets: Array<Totalizer_Correction_Tickets>;
  /** An aggregate relationship */
  totalizer_correction_tickets_aggregate: Totalizer_Correction_Tickets_Aggregate;
  /** Unit of the value, where one applies. NULL is correct for the 9 of 16 keys that are not measurements (AUTHORIZATION, BATCH_CODE, CHALLAN, DISPENSE_TYPE and similar). Volume keys: TOTALIZER_BEFORE_READING, TOTALIZER_AFTER_READING, PRESET_QTY, TOTALIZER_BEFORE_MANUAL, CHALLAN_READING. ODOMETER_READING is LENGTH or TIME and awaits those dimensions. AVERAGE_FLOW_RATE is a compound unit and has no single unit_of_measure row. Never add NOT NULL to this column. */
  unit?: Maybe<Unit_Of_Measure_Enum>;
  /** An object relationship */
  unit_of_measure?: Maybe<Unit_Of_Measure>;
  url?: Maybe<Scalars['String']['output']>;
  validation_status?: Maybe<Scalars['String']['output']>;
  validation_workflow_id?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "task_value" */
export type Task_ValueTicketsArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tickets_Order_By>>;
  where?: InputMaybe<Tickets_Bool_Exp>;
};


/** columns and relationships of "task_value" */
export type Task_ValueTickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tickets_Order_By>>;
  where?: InputMaybe<Tickets_Bool_Exp>;
};


/** columns and relationships of "task_value" */
export type Task_ValueTotalizer_Correction_TicketsArgs = {
  distinct_on?: InputMaybe<Array<Totalizer_Correction_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Totalizer_Correction_Tickets_Order_By>>;
  where?: InputMaybe<Totalizer_Correction_Tickets_Bool_Exp>;
};


/** columns and relationships of "task_value" */
export type Task_ValueTotalizer_Correction_Tickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Totalizer_Correction_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Totalizer_Correction_Tickets_Order_By>>;
  where?: InputMaybe<Totalizer_Correction_Tickets_Bool_Exp>;
};

/** aggregated selection of "task_value" */
export type Task_Value_Aggregate = {
  __typename?: 'task_value_aggregate';
  aggregate?: Maybe<Task_Value_Aggregate_Fields>;
  nodes: Array<Task_Value>;
};

export type Task_Value_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Task_Value_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Task_Value_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Task_Value_Aggregate_Bool_Exp_Count>;
};

export type Task_Value_Aggregate_Bool_Exp_Bool_And = {
  arguments: Task_Value_Select_Column_Task_Value_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Task_Value_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Task_Value_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Task_Value_Select_Column_Task_Value_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Task_Value_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Task_Value_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Task_Value_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Task_Value_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "task_value" */
export type Task_Value_Aggregate_Fields = {
  __typename?: 'task_value_aggregate_fields';
  avg?: Maybe<Task_Value_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Task_Value_Max_Fields>;
  min?: Maybe<Task_Value_Min_Fields>;
  stddev?: Maybe<Task_Value_Stddev_Fields>;
  stddev_pop?: Maybe<Task_Value_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Task_Value_Stddev_Samp_Fields>;
  sum?: Maybe<Task_Value_Sum_Fields>;
  var_pop?: Maybe<Task_Value_Var_Pop_Fields>;
  var_samp?: Maybe<Task_Value_Var_Samp_Fields>;
  variance?: Maybe<Task_Value_Variance_Fields>;
};


/** aggregate fields of "task_value" */
export type Task_Value_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Task_Value_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "task_value" */
export type Task_Value_Aggregate_Order_By = {
  avg?: InputMaybe<Task_Value_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Task_Value_Max_Order_By>;
  min?: InputMaybe<Task_Value_Min_Order_By>;
  stddev?: InputMaybe<Task_Value_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Task_Value_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Task_Value_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Task_Value_Sum_Order_By>;
  var_pop?: InputMaybe<Task_Value_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Task_Value_Var_Samp_Order_By>;
  variance?: InputMaybe<Task_Value_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "task_value" */
export type Task_Value_Arr_Rel_Insert_Input = {
  data: Array<Task_Value_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Task_Value_On_Conflict>;
};

/** aggregate avg on columns */
export type Task_Value_Avg_Fields = {
  __typename?: 'task_value_avg_fields';
  quantity_dispensed?: Maybe<Scalars['Float']['output']>;
  revised_quantity_dispensed?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "task_value" */
export type Task_Value_Avg_Order_By = {
  quantity_dispensed?: InputMaybe<Order_By>;
  revised_quantity_dispensed?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "task_value". All fields are combined with a logical 'AND'. */
export type Task_Value_Bool_Exp = {
  _and?: InputMaybe<Array<Task_Value_Bool_Exp>>;
  _not?: InputMaybe<Task_Value_Bool_Exp>;
  _or?: InputMaybe<Array<Task_Value_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_asset?: InputMaybe<Customer_Asset_Bool_Exp>;
  customer_asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_reconciled?: InputMaybe<Boolean_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<Point_Comparison_Exp>;
  quantity_correction_ticket?: InputMaybe<Quantity_Correction_Tickets_Bool_Exp>;
  quantity_dispensed?: InputMaybe<Numeric_Comparison_Exp>;
  reason?: InputMaybe<Reasons_Bool_Exp>;
  reason_id?: InputMaybe<Uuid_Comparison_Exp>;
  revised_quantity_dispensed?: InputMaybe<Numeric_Comparison_Exp>;
  revised_value?: InputMaybe<String_Comparison_Exp>;
  session_id?: InputMaybe<String_Comparison_Exp>;
  task?: InputMaybe<Task_Bool_Exp>;
  task_id?: InputMaybe<Uuid_Comparison_Exp>;
  tickets?: InputMaybe<Tickets_Bool_Exp>;
  tickets_aggregate?: InputMaybe<Tickets_Aggregate_Bool_Exp>;
  totalizer_correction_tickets?: InputMaybe<Totalizer_Correction_Tickets_Bool_Exp>;
  totalizer_correction_tickets_aggregate?: InputMaybe<Totalizer_Correction_Tickets_Aggregate_Bool_Exp>;
  unit?: InputMaybe<Unit_Of_Measure_Enum_Comparison_Exp>;
  unit_of_measure?: InputMaybe<Unit_Of_Measure_Bool_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  validation_status?: InputMaybe<String_Comparison_Exp>;
  validation_workflow_id?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
  vehicle_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "task_value" */
export enum Task_Value_Constraint {
  /** unique or primary key constraint on columns "key", "session_id", "customer_asset_id", "is_active" */
  TaskValueKeyCustomerAssetIdIsActiveSessionIdKey = 'task_value_key_customer_asset_id_is_active_session_id_key',
  /** unique or primary key constraint on columns "id" */
  TaskValuePkey = 'task_value_pkey',
  /** unique or primary key constraint on columns "key", "session_id", "customer_asset_id", "is_active" */
  TaskValueSessionIdIsActiveKeyCustomerAssetIdKey = 'task_value_session_id_is_active_key_customer_asset_id_key'
}

/** input type for incrementing numeric columns in table "task_value" */
export type Task_Value_Inc_Input = {
  quantity_dispensed?: InputMaybe<Scalars['numeric']['input']>;
  revised_quantity_dispensed?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "task_value" */
export type Task_Value_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_asset?: InputMaybe<Customer_Asset_Obj_Rel_Insert_Input>;
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_reconciled?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['point']['input']>;
  quantity_correction_ticket?: InputMaybe<Quantity_Correction_Tickets_Obj_Rel_Insert_Input>;
  quantity_dispensed?: InputMaybe<Scalars['numeric']['input']>;
  reason?: InputMaybe<Reasons_Obj_Rel_Insert_Input>;
  reason_id?: InputMaybe<Scalars['uuid']['input']>;
  revised_quantity_dispensed?: InputMaybe<Scalars['numeric']['input']>;
  revised_value?: InputMaybe<Scalars['String']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  task?: InputMaybe<Task_Obj_Rel_Insert_Input>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
  tickets?: InputMaybe<Tickets_Arr_Rel_Insert_Input>;
  totalizer_correction_tickets?: InputMaybe<Totalizer_Correction_Tickets_Arr_Rel_Insert_Input>;
  /** Unit of the value, where one applies. NULL is correct for the 9 of 16 keys that are not measurements (AUTHORIZATION, BATCH_CODE, CHALLAN, DISPENSE_TYPE and similar). Volume keys: TOTALIZER_BEFORE_READING, TOTALIZER_AFTER_READING, PRESET_QTY, TOTALIZER_BEFORE_MANUAL, CHALLAN_READING. ODOMETER_READING is LENGTH or TIME and awaits those dimensions. AVERAGE_FLOW_RATE is a compound unit and has no single unit_of_measure row. Never add NOT NULL to this column. */
  unit?: InputMaybe<Unit_Of_Measure_Enum>;
  unit_of_measure?: InputMaybe<Unit_Of_Measure_Obj_Rel_Insert_Input>;
  url?: InputMaybe<Scalars['String']['input']>;
  validation_status?: InputMaybe<Scalars['String']['input']>;
  validation_workflow_id?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Task_Value_Max_Fields = {
  __typename?: 'task_value_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  quantity_dispensed?: Maybe<Scalars['numeric']['output']>;
  reason_id?: Maybe<Scalars['uuid']['output']>;
  revised_quantity_dispensed?: Maybe<Scalars['numeric']['output']>;
  revised_value?: Maybe<Scalars['String']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  task_id?: Maybe<Scalars['uuid']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  validation_status?: Maybe<Scalars['String']['output']>;
  validation_workflow_id?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "task_value" */
export type Task_Value_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  quantity_dispensed?: InputMaybe<Order_By>;
  reason_id?: InputMaybe<Order_By>;
  revised_quantity_dispensed?: InputMaybe<Order_By>;
  revised_value?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  validation_status?: InputMaybe<Order_By>;
  validation_workflow_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Task_Value_Min_Fields = {
  __typename?: 'task_value_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  quantity_dispensed?: Maybe<Scalars['numeric']['output']>;
  reason_id?: Maybe<Scalars['uuid']['output']>;
  revised_quantity_dispensed?: Maybe<Scalars['numeric']['output']>;
  revised_value?: Maybe<Scalars['String']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  task_id?: Maybe<Scalars['uuid']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  validation_status?: Maybe<Scalars['String']['output']>;
  validation_workflow_id?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "task_value" */
export type Task_Value_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  quantity_dispensed?: InputMaybe<Order_By>;
  reason_id?: InputMaybe<Order_By>;
  revised_quantity_dispensed?: InputMaybe<Order_By>;
  revised_value?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  validation_status?: InputMaybe<Order_By>;
  validation_workflow_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "task_value" */
export type Task_Value_Mutation_Response = {
  __typename?: 'task_value_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Task_Value>;
};

/** input type for inserting object relation for remote table "task_value" */
export type Task_Value_Obj_Rel_Insert_Input = {
  data: Task_Value_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Task_Value_On_Conflict>;
};

/** on_conflict condition type for table "task_value" */
export type Task_Value_On_Conflict = {
  constraint: Task_Value_Constraint;
  update_columns?: Array<Task_Value_Update_Column>;
  where?: InputMaybe<Task_Value_Bool_Exp>;
};

/** Ordering options when selecting data from "task_value". */
export type Task_Value_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_asset?: InputMaybe<Customer_Asset_Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_reconciled?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  quantity_correction_ticket?: InputMaybe<Quantity_Correction_Tickets_Order_By>;
  quantity_dispensed?: InputMaybe<Order_By>;
  reason?: InputMaybe<Reasons_Order_By>;
  reason_id?: InputMaybe<Order_By>;
  revised_quantity_dispensed?: InputMaybe<Order_By>;
  revised_value?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  task?: InputMaybe<Task_Order_By>;
  task_id?: InputMaybe<Order_By>;
  tickets_aggregate?: InputMaybe<Tickets_Aggregate_Order_By>;
  totalizer_correction_tickets_aggregate?: InputMaybe<Totalizer_Correction_Tickets_Aggregate_Order_By>;
  unit?: InputMaybe<Order_By>;
  unit_of_measure?: InputMaybe<Unit_Of_Measure_Order_By>;
  url?: InputMaybe<Order_By>;
  validation_status?: InputMaybe<Order_By>;
  validation_workflow_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: task_value */
export type Task_Value_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "task_value" */
export enum Task_Value_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerAssetId = 'customer_asset_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsReconciled = 'is_reconciled',
  /** column name */
  Key = 'key',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Location = 'location',
  /** column name */
  QuantityDispensed = 'quantity_dispensed',
  /** column name */
  ReasonId = 'reason_id',
  /** column name */
  RevisedQuantityDispensed = 'revised_quantity_dispensed',
  /** column name */
  RevisedValue = 'revised_value',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  TaskId = 'task_id',
  /** column name */
  Unit = 'unit',
  /** column name */
  Url = 'url',
  /** column name */
  ValidationStatus = 'validation_status',
  /** column name */
  ValidationWorkflowId = 'validation_workflow_id',
  /** column name */
  Value = 'value',
  /** column name */
  VehicleId = 'vehicle_id'
}

/** select "task_value_aggregate_bool_exp_bool_and_arguments_columns" columns of table "task_value" */
export enum Task_Value_Select_Column_Task_Value_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsReconciled = 'is_reconciled'
}

/** select "task_value_aggregate_bool_exp_bool_or_arguments_columns" columns of table "task_value" */
export enum Task_Value_Select_Column_Task_Value_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsReconciled = 'is_reconciled'
}

/** input type for updating data in table "task_value" */
export type Task_Value_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_reconciled?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['point']['input']>;
  quantity_dispensed?: InputMaybe<Scalars['numeric']['input']>;
  reason_id?: InputMaybe<Scalars['uuid']['input']>;
  revised_quantity_dispensed?: InputMaybe<Scalars['numeric']['input']>;
  revised_value?: InputMaybe<Scalars['String']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Unit of the value, where one applies. NULL is correct for the 9 of 16 keys that are not measurements (AUTHORIZATION, BATCH_CODE, CHALLAN, DISPENSE_TYPE and similar). Volume keys: TOTALIZER_BEFORE_READING, TOTALIZER_AFTER_READING, PRESET_QTY, TOTALIZER_BEFORE_MANUAL, CHALLAN_READING. ODOMETER_READING is LENGTH or TIME and awaits those dimensions. AVERAGE_FLOW_RATE is a compound unit and has no single unit_of_measure row. Never add NOT NULL to this column. */
  unit?: InputMaybe<Unit_Of_Measure_Enum>;
  url?: InputMaybe<Scalars['String']['input']>;
  validation_status?: InputMaybe<Scalars['String']['input']>;
  validation_workflow_id?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Task_Value_Stddev_Fields = {
  __typename?: 'task_value_stddev_fields';
  quantity_dispensed?: Maybe<Scalars['Float']['output']>;
  revised_quantity_dispensed?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "task_value" */
export type Task_Value_Stddev_Order_By = {
  quantity_dispensed?: InputMaybe<Order_By>;
  revised_quantity_dispensed?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Task_Value_Stddev_Pop_Fields = {
  __typename?: 'task_value_stddev_pop_fields';
  quantity_dispensed?: Maybe<Scalars['Float']['output']>;
  revised_quantity_dispensed?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "task_value" */
export type Task_Value_Stddev_Pop_Order_By = {
  quantity_dispensed?: InputMaybe<Order_By>;
  revised_quantity_dispensed?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Task_Value_Stddev_Samp_Fields = {
  __typename?: 'task_value_stddev_samp_fields';
  quantity_dispensed?: Maybe<Scalars['Float']['output']>;
  revised_quantity_dispensed?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "task_value" */
export type Task_Value_Stddev_Samp_Order_By = {
  quantity_dispensed?: InputMaybe<Order_By>;
  revised_quantity_dispensed?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "task_value" */
export type Task_Value_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Task_Value_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Task_Value_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_reconciled?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['point']['input']>;
  quantity_dispensed?: InputMaybe<Scalars['numeric']['input']>;
  reason_id?: InputMaybe<Scalars['uuid']['input']>;
  revised_quantity_dispensed?: InputMaybe<Scalars['numeric']['input']>;
  revised_value?: InputMaybe<Scalars['String']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Unit of the value, where one applies. NULL is correct for the 9 of 16 keys that are not measurements (AUTHORIZATION, BATCH_CODE, CHALLAN, DISPENSE_TYPE and similar). Volume keys: TOTALIZER_BEFORE_READING, TOTALIZER_AFTER_READING, PRESET_QTY, TOTALIZER_BEFORE_MANUAL, CHALLAN_READING. ODOMETER_READING is LENGTH or TIME and awaits those dimensions. AVERAGE_FLOW_RATE is a compound unit and has no single unit_of_measure row. Never add NOT NULL to this column. */
  unit?: InputMaybe<Unit_Of_Measure_Enum>;
  url?: InputMaybe<Scalars['String']['input']>;
  validation_status?: InputMaybe<Scalars['String']['input']>;
  validation_workflow_id?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Task_Value_Sum_Fields = {
  __typename?: 'task_value_sum_fields';
  quantity_dispensed?: Maybe<Scalars['numeric']['output']>;
  revised_quantity_dispensed?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "task_value" */
export type Task_Value_Sum_Order_By = {
  quantity_dispensed?: InputMaybe<Order_By>;
  revised_quantity_dispensed?: InputMaybe<Order_By>;
};

/** update columns of table "task_value" */
export enum Task_Value_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerAssetId = 'customer_asset_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsReconciled = 'is_reconciled',
  /** column name */
  Key = 'key',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Location = 'location',
  /** column name */
  QuantityDispensed = 'quantity_dispensed',
  /** column name */
  ReasonId = 'reason_id',
  /** column name */
  RevisedQuantityDispensed = 'revised_quantity_dispensed',
  /** column name */
  RevisedValue = 'revised_value',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  TaskId = 'task_id',
  /** column name */
  Unit = 'unit',
  /** column name */
  Url = 'url',
  /** column name */
  ValidationStatus = 'validation_status',
  /** column name */
  ValidationWorkflowId = 'validation_workflow_id',
  /** column name */
  Value = 'value',
  /** column name */
  VehicleId = 'vehicle_id'
}

export type Task_Value_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Task_Value_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Task_Value_Set_Input>;
  /** filter the rows which have to be updated */
  where: Task_Value_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Task_Value_Var_Pop_Fields = {
  __typename?: 'task_value_var_pop_fields';
  quantity_dispensed?: Maybe<Scalars['Float']['output']>;
  revised_quantity_dispensed?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "task_value" */
export type Task_Value_Var_Pop_Order_By = {
  quantity_dispensed?: InputMaybe<Order_By>;
  revised_quantity_dispensed?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Task_Value_Var_Samp_Fields = {
  __typename?: 'task_value_var_samp_fields';
  quantity_dispensed?: Maybe<Scalars['Float']['output']>;
  revised_quantity_dispensed?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "task_value" */
export type Task_Value_Var_Samp_Order_By = {
  quantity_dispensed?: InputMaybe<Order_By>;
  revised_quantity_dispensed?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Task_Value_Variance_Fields = {
  __typename?: 'task_value_variance_fields';
  quantity_dispensed?: Maybe<Scalars['Float']['output']>;
  revised_quantity_dispensed?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "task_value" */
export type Task_Value_Variance_Order_By = {
  quantity_dispensed?: InputMaybe<Order_By>;
  revised_quantity_dispensed?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Task_Var_Pop_Fields = {
  __typename?: 'task_var_pop_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "task" */
export type Task_Var_Pop_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Task_Var_Samp_Fields = {
  __typename?: 'task_var_samp_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "task" */
export type Task_Var_Samp_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Task_Variance_Fields = {
  __typename?: 'task_variance_fields';
  rank_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "task" */
export type Task_Variance_Order_By = {
  rank_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "test" */
export type Test = {
  __typename?: 'test';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  customer_order_item_test_results: Array<Customer_Order_Item_Test_Results>;
  /** An aggregate relationship */
  customer_order_item_test_results_aggregate: Customer_Order_Item_Test_Results_Aggregate;
  description: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name: Scalars['String']['output'];
  /** An array relationship */
  partner_order_item_test_results: Array<Partner_Order_Item_Test_Results>;
  /** An aggregate relationship */
  partner_order_item_test_results_aggregate: Partner_Order_Item_Test_Results_Aggregate;
  sequence?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  test_category: Test_Category;
  test_category_id: Scalars['uuid']['output'];
};


/** columns and relationships of "test" */
export type TestCustomer_Order_Item_Test_ResultsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Test_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Test_Results_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Test_Results_Bool_Exp>;
};


/** columns and relationships of "test" */
export type TestCustomer_Order_Item_Test_Results_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Test_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Test_Results_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Test_Results_Bool_Exp>;
};


/** columns and relationships of "test" */
export type TestPartner_Order_Item_Test_ResultsArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Test_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Test_Results_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Test_Results_Bool_Exp>;
};


/** columns and relationships of "test" */
export type TestPartner_Order_Item_Test_Results_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Test_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Test_Results_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Test_Results_Bool_Exp>;
};

/** aggregated selection of "test" */
export type Test_Aggregate = {
  __typename?: 'test_aggregate';
  aggregate?: Maybe<Test_Aggregate_Fields>;
  nodes: Array<Test>;
};

export type Test_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Test_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Test_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Test_Aggregate_Bool_Exp_Count>;
};

export type Test_Aggregate_Bool_Exp_Bool_And = {
  arguments: Test_Select_Column_Test_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Test_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Test_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Test_Select_Column_Test_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Test_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Test_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Test_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Test_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "test" */
export type Test_Aggregate_Fields = {
  __typename?: 'test_aggregate_fields';
  avg?: Maybe<Test_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Test_Max_Fields>;
  min?: Maybe<Test_Min_Fields>;
  stddev?: Maybe<Test_Stddev_Fields>;
  stddev_pop?: Maybe<Test_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Test_Stddev_Samp_Fields>;
  sum?: Maybe<Test_Sum_Fields>;
  var_pop?: Maybe<Test_Var_Pop_Fields>;
  var_samp?: Maybe<Test_Var_Samp_Fields>;
  variance?: Maybe<Test_Variance_Fields>;
};


/** aggregate fields of "test" */
export type Test_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Test_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "test" */
export type Test_Aggregate_Order_By = {
  avg?: InputMaybe<Test_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Test_Max_Order_By>;
  min?: InputMaybe<Test_Min_Order_By>;
  stddev?: InputMaybe<Test_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Test_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Test_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Test_Sum_Order_By>;
  var_pop?: InputMaybe<Test_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Test_Var_Samp_Order_By>;
  variance?: InputMaybe<Test_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "test" */
export type Test_Arr_Rel_Insert_Input = {
  data: Array<Test_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Test_On_Conflict>;
};

/** aggregate avg on columns */
export type Test_Avg_Fields = {
  __typename?: 'test_avg_fields';
  sequence?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "test" */
export type Test_Avg_Order_By = {
  sequence?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "test". All fields are combined with a logical 'AND'. */
export type Test_Bool_Exp = {
  _and?: InputMaybe<Array<Test_Bool_Exp>>;
  _not?: InputMaybe<Test_Bool_Exp>;
  _or?: InputMaybe<Array<Test_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_order_item_test_results?: InputMaybe<Customer_Order_Item_Test_Results_Bool_Exp>;
  customer_order_item_test_results_aggregate?: InputMaybe<Customer_Order_Item_Test_Results_Aggregate_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  partner_order_item_test_results?: InputMaybe<Partner_Order_Item_Test_Results_Bool_Exp>;
  partner_order_item_test_results_aggregate?: InputMaybe<Partner_Order_Item_Test_Results_Aggregate_Bool_Exp>;
  sequence?: InputMaybe<Int_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  test_category?: InputMaybe<Test_Category_Bool_Exp>;
  test_category_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** columns and relationships of "test_category" */
export type Test_Category = {
  __typename?: 'test_category';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  customer_order_item_test_categories: Array<Customer_Order_Item_Test_Category>;
  /** An aggregate relationship */
  customer_order_item_test_categories_aggregate: Customer_Order_Item_Test_Category_Aggregate;
  description: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name: Scalars['String']['output'];
  /** An array relationship */
  partner_order_item_test_categories: Array<Partner_Order_Item_Test_Category>;
  /** An aggregate relationship */
  partner_order_item_test_categories_aggregate: Partner_Order_Item_Test_Category_Aggregate;
  /** An array relationship */
  product_variation_test_categories: Array<Product_Variation_Test_Category>;
  /** An aggregate relationship */
  product_variation_test_categories_aggregate: Product_Variation_Test_Category_Aggregate;
  slug?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  tests: Array<Test>;
  /** An aggregate relationship */
  tests_aggregate: Test_Aggregate;
};


/** columns and relationships of "test_category" */
export type Test_CategoryCustomer_Order_Item_Test_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Test_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Test_Category_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Test_Category_Bool_Exp>;
};


/** columns and relationships of "test_category" */
export type Test_CategoryCustomer_Order_Item_Test_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Test_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Test_Category_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Test_Category_Bool_Exp>;
};


/** columns and relationships of "test_category" */
export type Test_CategoryPartner_Order_Item_Test_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Test_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Test_Category_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Test_Category_Bool_Exp>;
};


/** columns and relationships of "test_category" */
export type Test_CategoryPartner_Order_Item_Test_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Item_Test_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Item_Test_Category_Order_By>>;
  where?: InputMaybe<Partner_Order_Item_Test_Category_Bool_Exp>;
};


/** columns and relationships of "test_category" */
export type Test_CategoryProduct_Variation_Test_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Product_Variation_Test_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Variation_Test_Category_Order_By>>;
  where?: InputMaybe<Product_Variation_Test_Category_Bool_Exp>;
};


/** columns and relationships of "test_category" */
export type Test_CategoryProduct_Variation_Test_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Variation_Test_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Variation_Test_Category_Order_By>>;
  where?: InputMaybe<Product_Variation_Test_Category_Bool_Exp>;
};


/** columns and relationships of "test_category" */
export type Test_CategoryTestsArgs = {
  distinct_on?: InputMaybe<Array<Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Test_Order_By>>;
  where?: InputMaybe<Test_Bool_Exp>;
};


/** columns and relationships of "test_category" */
export type Test_CategoryTests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Test_Order_By>>;
  where?: InputMaybe<Test_Bool_Exp>;
};

/** aggregated selection of "test_category" */
export type Test_Category_Aggregate = {
  __typename?: 'test_category_aggregate';
  aggregate?: Maybe<Test_Category_Aggregate_Fields>;
  nodes: Array<Test_Category>;
};

/** aggregate fields of "test_category" */
export type Test_Category_Aggregate_Fields = {
  __typename?: 'test_category_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Test_Category_Max_Fields>;
  min?: Maybe<Test_Category_Min_Fields>;
};


/** aggregate fields of "test_category" */
export type Test_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Test_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "test_category". All fields are combined with a logical 'AND'. */
export type Test_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Test_Category_Bool_Exp>>;
  _not?: InputMaybe<Test_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Test_Category_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_order_item_test_categories?: InputMaybe<Customer_Order_Item_Test_Category_Bool_Exp>;
  customer_order_item_test_categories_aggregate?: InputMaybe<Customer_Order_Item_Test_Category_Aggregate_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  partner_order_item_test_categories?: InputMaybe<Partner_Order_Item_Test_Category_Bool_Exp>;
  partner_order_item_test_categories_aggregate?: InputMaybe<Partner_Order_Item_Test_Category_Aggregate_Bool_Exp>;
  product_variation_test_categories?: InputMaybe<Product_Variation_Test_Category_Bool_Exp>;
  product_variation_test_categories_aggregate?: InputMaybe<Product_Variation_Test_Category_Aggregate_Bool_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  tests?: InputMaybe<Test_Bool_Exp>;
  tests_aggregate?: InputMaybe<Test_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "test_category" */
export enum Test_Category_Constraint {
  /** unique or primary key constraint on columns "id" */
  TestCategoryPkey = 'test_category_pkey'
}

/** input type for inserting data into table "test_category" */
export type Test_Category_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_item_test_categories?: InputMaybe<Customer_Order_Item_Test_Category_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partner_order_item_test_categories?: InputMaybe<Partner_Order_Item_Test_Category_Arr_Rel_Insert_Input>;
  product_variation_test_categories?: InputMaybe<Product_Variation_Test_Category_Arr_Rel_Insert_Input>;
  slug?: InputMaybe<Scalars['String']['input']>;
  tests?: InputMaybe<Test_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Test_Category_Max_Fields = {
  __typename?: 'test_category_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Test_Category_Min_Fields = {
  __typename?: 'test_category_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "test_category" */
export type Test_Category_Mutation_Response = {
  __typename?: 'test_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Test_Category>;
};

/** input type for inserting object relation for remote table "test_category" */
export type Test_Category_Obj_Rel_Insert_Input = {
  data: Test_Category_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Test_Category_On_Conflict>;
};

/** on_conflict condition type for table "test_category" */
export type Test_Category_On_Conflict = {
  constraint: Test_Category_Constraint;
  update_columns?: Array<Test_Category_Update_Column>;
  where?: InputMaybe<Test_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "test_category". */
export type Test_Category_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_order_item_test_categories_aggregate?: InputMaybe<Customer_Order_Item_Test_Category_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  partner_order_item_test_categories_aggregate?: InputMaybe<Partner_Order_Item_Test_Category_Aggregate_Order_By>;
  product_variation_test_categories_aggregate?: InputMaybe<Product_Variation_Test_Category_Aggregate_Order_By>;
  slug?: InputMaybe<Order_By>;
  tests_aggregate?: InputMaybe<Test_Aggregate_Order_By>;
};

/** primary key columns input for table: test_category */
export type Test_Category_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "test_category" */
export enum Test_Category_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  Slug = 'slug'
}

/** input type for updating data in table "test_category" */
export type Test_Category_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "test_category" */
export type Test_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Test_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Test_Category_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "test_category" */
export enum Test_Category_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  Slug = 'slug'
}

export type Test_Category_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Test_Category_Set_Input>;
  /** filter the rows which have to be updated */
  where: Test_Category_Bool_Exp;
};

/** unique or primary key constraints on table "test" */
export enum Test_Constraint {
  /** unique or primary key constraint on columns "id" */
  TestPkey = 'test_pkey'
}

/** input type for incrementing numeric columns in table "test" */
export type Test_Inc_Input = {
  sequence?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "test" */
export type Test_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_order_item_test_results?: InputMaybe<Customer_Order_Item_Test_Results_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partner_order_item_test_results?: InputMaybe<Partner_Order_Item_Test_Results_Arr_Rel_Insert_Input>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  test_category?: InputMaybe<Test_Category_Obj_Rel_Insert_Input>;
  test_category_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Test_Max_Fields = {
  __typename?: 'test_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sequence?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  test_category_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "test" */
export type Test_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  test_category_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Test_Min_Fields = {
  __typename?: 'test_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sequence?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  test_category_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "test" */
export type Test_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  test_category_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "test" */
export type Test_Mutation_Response = {
  __typename?: 'test_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Test>;
};

/** input type for inserting object relation for remote table "test" */
export type Test_Obj_Rel_Insert_Input = {
  data: Test_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Test_On_Conflict>;
};

/** on_conflict condition type for table "test" */
export type Test_On_Conflict = {
  constraint: Test_Constraint;
  update_columns?: Array<Test_Update_Column>;
  where?: InputMaybe<Test_Bool_Exp>;
};

/** Ordering options when selecting data from "test". */
export type Test_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_order_item_test_results_aggregate?: InputMaybe<Customer_Order_Item_Test_Results_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  partner_order_item_test_results_aggregate?: InputMaybe<Partner_Order_Item_Test_Results_Aggregate_Order_By>;
  sequence?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  test_category?: InputMaybe<Test_Category_Order_By>;
  test_category_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: test */
export type Test_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "test" */
export enum Test_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  Sequence = 'sequence',
  /** column name */
  Slug = 'slug',
  /** column name */
  TestCategoryId = 'test_category_id'
}

/** select "test_aggregate_bool_exp_bool_and_arguments_columns" columns of table "test" */
export enum Test_Select_Column_Test_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "test_aggregate_bool_exp_bool_or_arguments_columns" columns of table "test" */
export enum Test_Select_Column_Test_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "test" */
export type Test_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  test_category_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Test_Stddev_Fields = {
  __typename?: 'test_stddev_fields';
  sequence?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "test" */
export type Test_Stddev_Order_By = {
  sequence?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Test_Stddev_Pop_Fields = {
  __typename?: 'test_stddev_pop_fields';
  sequence?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "test" */
export type Test_Stddev_Pop_Order_By = {
  sequence?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Test_Stddev_Samp_Fields = {
  __typename?: 'test_stddev_samp_fields';
  sequence?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "test" */
export type Test_Stddev_Samp_Order_By = {
  sequence?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "test" */
export type Test_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Test_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Test_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  test_category_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Test_Sum_Fields = {
  __typename?: 'test_sum_fields';
  sequence?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "test" */
export type Test_Sum_Order_By = {
  sequence?: InputMaybe<Order_By>;
};

/** update columns of table "test" */
export enum Test_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Name = 'name',
  /** column name */
  Sequence = 'sequence',
  /** column name */
  Slug = 'slug',
  /** column name */
  TestCategoryId = 'test_category_id'
}

export type Test_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Test_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Test_Set_Input>;
  /** filter the rows which have to be updated */
  where: Test_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Test_Var_Pop_Fields = {
  __typename?: 'test_var_pop_fields';
  sequence?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "test" */
export type Test_Var_Pop_Order_By = {
  sequence?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Test_Var_Samp_Fields = {
  __typename?: 'test_var_samp_fields';
  sequence?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "test" */
export type Test_Var_Samp_Order_By = {
  sequence?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Test_Variance_Fields = {
  __typename?: 'test_variance_fields';
  sequence?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "test" */
export type Test_Variance_Order_By = {
  sequence?: InputMaybe<Order_By>;
};

/** columns and relationships of "ticket_state" */
export type Ticket_State = {
  __typename?: 'ticket_state';
  comment: Scalars['String']['output'];
  /** An array relationship */
  tickets: Array<Tickets>;
  /** An aggregate relationship */
  tickets_aggregate: Tickets_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "ticket_state" */
export type Ticket_StateTicketsArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tickets_Order_By>>;
  where?: InputMaybe<Tickets_Bool_Exp>;
};


/** columns and relationships of "ticket_state" */
export type Ticket_StateTickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tickets_Order_By>>;
  where?: InputMaybe<Tickets_Bool_Exp>;
};

/** aggregated selection of "ticket_state" */
export type Ticket_State_Aggregate = {
  __typename?: 'ticket_state_aggregate';
  aggregate?: Maybe<Ticket_State_Aggregate_Fields>;
  nodes: Array<Ticket_State>;
};

/** aggregate fields of "ticket_state" */
export type Ticket_State_Aggregate_Fields = {
  __typename?: 'ticket_state_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Ticket_State_Max_Fields>;
  min?: Maybe<Ticket_State_Min_Fields>;
};


/** aggregate fields of "ticket_state" */
export type Ticket_State_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ticket_State_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "ticket_state". All fields are combined with a logical 'AND'. */
export type Ticket_State_Bool_Exp = {
  _and?: InputMaybe<Array<Ticket_State_Bool_Exp>>;
  _not?: InputMaybe<Ticket_State_Bool_Exp>;
  _or?: InputMaybe<Array<Ticket_State_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  tickets?: InputMaybe<Tickets_Bool_Exp>;
  tickets_aggregate?: InputMaybe<Tickets_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ticket_state" */
export enum Ticket_State_Constraint {
  /** unique or primary key constraint on columns "value" */
  TicketStatePkey = 'ticket_state_pkey'
}

export enum Ticket_State_Enum {
  /** APPROVED */
  Approved = 'APPROVED',
  /** PENDING */
  Pending = 'PENDING',
  /** REJECTED */
  Rejected = 'REJECTED'
}

/** Boolean expression to compare columns of type "ticket_state_enum". All fields are combined with logical 'AND'. */
export type Ticket_State_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Ticket_State_Enum>;
  _in?: InputMaybe<Array<Ticket_State_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Ticket_State_Enum>;
  _nin?: InputMaybe<Array<Ticket_State_Enum>>;
};

/** input type for inserting data into table "ticket_state" */
export type Ticket_State_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  tickets?: InputMaybe<Tickets_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Ticket_State_Max_Fields = {
  __typename?: 'ticket_state_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Ticket_State_Min_Fields = {
  __typename?: 'ticket_state_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "ticket_state" */
export type Ticket_State_Mutation_Response = {
  __typename?: 'ticket_state_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ticket_State>;
};

/** input type for inserting object relation for remote table "ticket_state" */
export type Ticket_State_Obj_Rel_Insert_Input = {
  data: Ticket_State_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ticket_State_On_Conflict>;
};

/** on_conflict condition type for table "ticket_state" */
export type Ticket_State_On_Conflict = {
  constraint: Ticket_State_Constraint;
  update_columns?: Array<Ticket_State_Update_Column>;
  where?: InputMaybe<Ticket_State_Bool_Exp>;
};

/** Ordering options when selecting data from "ticket_state". */
export type Ticket_State_Order_By = {
  comment?: InputMaybe<Order_By>;
  tickets_aggregate?: InputMaybe<Tickets_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ticket_state */
export type Ticket_State_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "ticket_state" */
export enum Ticket_State_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "ticket_state" */
export type Ticket_State_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "ticket_state" */
export type Ticket_State_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ticket_State_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ticket_State_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "ticket_state" */
export enum Ticket_State_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Ticket_State_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ticket_State_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ticket_State_Bool_Exp;
};

/** columns and relationships of "ticket_type" */
export type Ticket_Type = {
  __typename?: 'ticket_type';
  comment: Scalars['String']['output'];
  /** An array relationship */
  tickets: Array<Tickets>;
  /** An aggregate relationship */
  tickets_aggregate: Tickets_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "ticket_type" */
export type Ticket_TypeTicketsArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tickets_Order_By>>;
  where?: InputMaybe<Tickets_Bool_Exp>;
};


/** columns and relationships of "ticket_type" */
export type Ticket_TypeTickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tickets_Order_By>>;
  where?: InputMaybe<Tickets_Bool_Exp>;
};

/** aggregated selection of "ticket_type" */
export type Ticket_Type_Aggregate = {
  __typename?: 'ticket_type_aggregate';
  aggregate?: Maybe<Ticket_Type_Aggregate_Fields>;
  nodes: Array<Ticket_Type>;
};

/** aggregate fields of "ticket_type" */
export type Ticket_Type_Aggregate_Fields = {
  __typename?: 'ticket_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Ticket_Type_Max_Fields>;
  min?: Maybe<Ticket_Type_Min_Fields>;
};


/** aggregate fields of "ticket_type" */
export type Ticket_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ticket_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "ticket_type". All fields are combined with a logical 'AND'. */
export type Ticket_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Ticket_Type_Bool_Exp>>;
  _not?: InputMaybe<Ticket_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Ticket_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  tickets?: InputMaybe<Tickets_Bool_Exp>;
  tickets_aggregate?: InputMaybe<Tickets_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ticket_type" */
export enum Ticket_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  TicketTypePkey = 'ticket_type_pkey'
}

export enum Ticket_Type_Enum {
  /** ADDRESS_CORRECTION */
  AddressCorrection = 'ADDRESS_CORRECTION',
  /** ASSET_CHANGE */
  AssetChange = 'ASSET_CHANGE',
  /** INVOICE_DATE_CORRECTION */
  InvoiceDateCorrection = 'INVOICE_DATE_CORRECTION',
  /** ODOMETER_CORRECTION */
  OdometerCorrection = 'ODOMETER_CORRECTION',
  /** ODOMETER_MISSING */
  OdometerMissing = 'ODOMETER_MISSING',
  /** ORDER_CANCELLATION */
  OrderCancellation = 'ORDER_CANCELLATION'
}

/** Boolean expression to compare columns of type "ticket_type_enum". All fields are combined with logical 'AND'. */
export type Ticket_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Ticket_Type_Enum>;
  _in?: InputMaybe<Array<Ticket_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Ticket_Type_Enum>;
  _nin?: InputMaybe<Array<Ticket_Type_Enum>>;
};

/** input type for inserting data into table "ticket_type" */
export type Ticket_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  tickets?: InputMaybe<Tickets_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Ticket_Type_Max_Fields = {
  __typename?: 'ticket_type_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Ticket_Type_Min_Fields = {
  __typename?: 'ticket_type_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "ticket_type" */
export type Ticket_Type_Mutation_Response = {
  __typename?: 'ticket_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ticket_Type>;
};

/** input type for inserting object relation for remote table "ticket_type" */
export type Ticket_Type_Obj_Rel_Insert_Input = {
  data: Ticket_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ticket_Type_On_Conflict>;
};

/** on_conflict condition type for table "ticket_type" */
export type Ticket_Type_On_Conflict = {
  constraint: Ticket_Type_Constraint;
  update_columns?: Array<Ticket_Type_Update_Column>;
  where?: InputMaybe<Ticket_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "ticket_type". */
export type Ticket_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  tickets_aggregate?: InputMaybe<Tickets_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ticket_type */
export type Ticket_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "ticket_type" */
export enum Ticket_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "ticket_type" */
export type Ticket_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "ticket_type" */
export type Ticket_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ticket_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ticket_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "ticket_type" */
export enum Ticket_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Ticket_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ticket_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ticket_Type_Bool_Exp;
};

/** columns and relationships of "tickets" */
export type Tickets = {
  __typename?: 'tickets';
  approved_by?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamp']['output'];
  created_by: Scalars['uuid']['output'];
  /** An object relationship */
  customer_asset?: Maybe<Customer_Asset>;
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  customer_order?: Maybe<Customer_Order>;
  customer_order_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  image_url?: Maybe<Scalars['String']['output']>;
  is_active: Scalars['Boolean']['output'];
  last_modified: Scalars['timestamp']['output'];
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  new_date?: Maybe<Scalars['timestamp']['output']>;
  old_value?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  reason?: Maybe<Reasons>;
  reason_id?: Maybe<Scalars['uuid']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  state: Ticket_State_Enum;
  /** An object relationship */
  task?: Maybe<Task>;
  task_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  task_value?: Maybe<Task_Value>;
  task_value_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  ticketTypeByTicketType?: Maybe<Ticket_Type>;
  /** An object relationship */
  ticket_state: Ticket_State;
  ticket_type?: Maybe<Ticket_Type_Enum>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "tickets" */
export type Tickets_Aggregate = {
  __typename?: 'tickets_aggregate';
  aggregate?: Maybe<Tickets_Aggregate_Fields>;
  nodes: Array<Tickets>;
};

export type Tickets_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Tickets_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Tickets_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Tickets_Aggregate_Bool_Exp_Count>;
};

export type Tickets_Aggregate_Bool_Exp_Bool_And = {
  arguments: Tickets_Select_Column_Tickets_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tickets_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tickets_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Tickets_Select_Column_Tickets_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tickets_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tickets_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tickets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tickets_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tickets" */
export type Tickets_Aggregate_Fields = {
  __typename?: 'tickets_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tickets_Max_Fields>;
  min?: Maybe<Tickets_Min_Fields>;
};


/** aggregate fields of "tickets" */
export type Tickets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tickets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tickets" */
export type Tickets_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tickets_Max_Order_By>;
  min?: InputMaybe<Tickets_Min_Order_By>;
};

/** input type for inserting array relation for remote table "tickets" */
export type Tickets_Arr_Rel_Insert_Input = {
  data: Array<Tickets_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tickets_On_Conflict>;
};

/** Boolean expression to filter rows from the table "tickets". All fields are combined with a logical 'AND'. */
export type Tickets_Bool_Exp = {
  _and?: InputMaybe<Array<Tickets_Bool_Exp>>;
  _not?: InputMaybe<Tickets_Bool_Exp>;
  _or?: InputMaybe<Array<Tickets_Bool_Exp>>;
  approved_by?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  customer_asset?: InputMaybe<Customer_Asset_Bool_Exp>;
  customer_asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  customer_order?: InputMaybe<Customer_Order_Bool_Exp>;
  customer_order_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  new_date?: InputMaybe<Timestamp_Comparison_Exp>;
  old_value?: InputMaybe<String_Comparison_Exp>;
  reason?: InputMaybe<Reasons_Bool_Exp>;
  reason_id?: InputMaybe<Uuid_Comparison_Exp>;
  session_id?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<Ticket_State_Enum_Comparison_Exp>;
  task?: InputMaybe<Task_Bool_Exp>;
  task_id?: InputMaybe<Uuid_Comparison_Exp>;
  task_value?: InputMaybe<Task_Value_Bool_Exp>;
  task_value_id?: InputMaybe<Uuid_Comparison_Exp>;
  ticketTypeByTicketType?: InputMaybe<Ticket_Type_Bool_Exp>;
  ticket_state?: InputMaybe<Ticket_State_Bool_Exp>;
  ticket_type?: InputMaybe<Ticket_Type_Enum_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "tickets" */
export enum Tickets_Constraint {
  /** unique or primary key constraint on columns "id" */
  TicketsPkey = 'tickets_pkey'
}

/** input type for inserting data into table "tickets" */
export type Tickets_Insert_Input = {
  approved_by?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  customer_asset?: InputMaybe<Customer_Asset_Obj_Rel_Insert_Input>;
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  customer_order?: InputMaybe<Customer_Order_Obj_Rel_Insert_Input>;
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image_url?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  new_date?: InputMaybe<Scalars['timestamp']['input']>;
  old_value?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Reasons_Obj_Rel_Insert_Input>;
  reason_id?: InputMaybe<Scalars['uuid']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Ticket_State_Enum>;
  task?: InputMaybe<Task_Obj_Rel_Insert_Input>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
  task_value?: InputMaybe<Task_Value_Obj_Rel_Insert_Input>;
  task_value_id?: InputMaybe<Scalars['uuid']['input']>;
  ticketTypeByTicketType?: InputMaybe<Ticket_Type_Obj_Rel_Insert_Input>;
  ticket_state?: InputMaybe<Ticket_State_Obj_Rel_Insert_Input>;
  ticket_type?: InputMaybe<Ticket_Type_Enum>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Tickets_Max_Fields = {
  __typename?: 'tickets_max_fields';
  approved_by?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  customer_order_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_url?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  new_date?: Maybe<Scalars['timestamp']['output']>;
  old_value?: Maybe<Scalars['String']['output']>;
  reason_id?: Maybe<Scalars['uuid']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  task_id?: Maybe<Scalars['uuid']['output']>;
  task_value_id?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "tickets" */
export type Tickets_Max_Order_By = {
  approved_by?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  customer_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  new_date?: InputMaybe<Order_By>;
  old_value?: InputMaybe<Order_By>;
  reason_id?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  task_value_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tickets_Min_Fields = {
  __typename?: 'tickets_min_fields';
  approved_by?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  customer_order_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_url?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  new_date?: Maybe<Scalars['timestamp']['output']>;
  old_value?: Maybe<Scalars['String']['output']>;
  reason_id?: Maybe<Scalars['uuid']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  task_id?: Maybe<Scalars['uuid']['output']>;
  task_value_id?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "tickets" */
export type Tickets_Min_Order_By = {
  approved_by?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  customer_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  new_date?: InputMaybe<Order_By>;
  old_value?: InputMaybe<Order_By>;
  reason_id?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  task_value_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tickets" */
export type Tickets_Mutation_Response = {
  __typename?: 'tickets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tickets>;
};

/** on_conflict condition type for table "tickets" */
export type Tickets_On_Conflict = {
  constraint: Tickets_Constraint;
  update_columns?: Array<Tickets_Update_Column>;
  where?: InputMaybe<Tickets_Bool_Exp>;
};

/** Ordering options when selecting data from "tickets". */
export type Tickets_Order_By = {
  approved_by?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  customer_asset?: InputMaybe<Customer_Asset_Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  customer_order?: InputMaybe<Customer_Order_Order_By>;
  customer_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  new_date?: InputMaybe<Order_By>;
  old_value?: InputMaybe<Order_By>;
  reason?: InputMaybe<Reasons_Order_By>;
  reason_id?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  task?: InputMaybe<Task_Order_By>;
  task_id?: InputMaybe<Order_By>;
  task_value?: InputMaybe<Task_Value_Order_By>;
  task_value_id?: InputMaybe<Order_By>;
  ticketTypeByTicketType?: InputMaybe<Ticket_Type_Order_By>;
  ticket_state?: InputMaybe<Ticket_State_Order_By>;
  ticket_type?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tickets */
export type Tickets_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "tickets" */
export enum Tickets_Select_Column {
  /** column name */
  ApprovedBy = 'approved_by',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CustomerAssetId = 'customer_asset_id',
  /** column name */
  CustomerOrderId = 'customer_order_id',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  NewDate = 'new_date',
  /** column name */
  OldValue = 'old_value',
  /** column name */
  ReasonId = 'reason_id',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  State = 'state',
  /** column name */
  TaskId = 'task_id',
  /** column name */
  TaskValueId = 'task_value_id',
  /** column name */
  TicketType = 'ticket_type',
  /** column name */
  Value = 'value'
}

/** select "tickets_aggregate_bool_exp_bool_and_arguments_columns" columns of table "tickets" */
export enum Tickets_Select_Column_Tickets_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "tickets_aggregate_bool_exp_bool_or_arguments_columns" columns of table "tickets" */
export enum Tickets_Select_Column_Tickets_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "tickets" */
export type Tickets_Set_Input = {
  approved_by?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image_url?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  new_date?: InputMaybe<Scalars['timestamp']['input']>;
  old_value?: InputMaybe<Scalars['String']['input']>;
  reason_id?: InputMaybe<Scalars['uuid']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Ticket_State_Enum>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
  task_value_id?: InputMaybe<Scalars['uuid']['input']>;
  ticket_type?: InputMaybe<Ticket_Type_Enum>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tickets" */
export type Tickets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tickets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tickets_Stream_Cursor_Value_Input = {
  approved_by?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image_url?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  new_date?: InputMaybe<Scalars['timestamp']['input']>;
  old_value?: InputMaybe<Scalars['String']['input']>;
  reason_id?: InputMaybe<Scalars['uuid']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Ticket_State_Enum>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
  task_value_id?: InputMaybe<Scalars['uuid']['input']>;
  ticket_type?: InputMaybe<Ticket_Type_Enum>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tickets" */
export enum Tickets_Update_Column {
  /** column name */
  ApprovedBy = 'approved_by',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CustomerAssetId = 'customer_asset_id',
  /** column name */
  CustomerOrderId = 'customer_order_id',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  NewDate = 'new_date',
  /** column name */
  OldValue = 'old_value',
  /** column name */
  ReasonId = 'reason_id',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  State = 'state',
  /** column name */
  TaskId = 'task_id',
  /** column name */
  TaskValueId = 'task_value_id',
  /** column name */
  TicketType = 'ticket_type',
  /** column name */
  Value = 'value'
}

export type Tickets_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tickets_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tickets_Bool_Exp;
};

/** Boolean expression to compare columns of type "time". All fields are combined with logical 'AND'. */
export type Time_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['time']['input']>;
  _gt?: InputMaybe<Scalars['time']['input']>;
  _gte?: InputMaybe<Scalars['time']['input']>;
  _in?: InputMaybe<Array<Scalars['time']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['time']['input']>;
  _lte?: InputMaybe<Scalars['time']['input']>;
  _neq?: InputMaybe<Scalars['time']['input']>;
  _nin?: InputMaybe<Array<Scalars['time']['input']>>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']['input']>;
  _gt?: InputMaybe<Scalars['timestamp']['input']>;
  _gte?: InputMaybe<Scalars['timestamp']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamp']['input']>;
  _lte?: InputMaybe<Scalars['timestamp']['input']>;
  _neq?: InputMaybe<Scalars['timestamp']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** Boolean expression to compare columns of type "timetz". All fields are combined with logical 'AND'. */
export type Timetz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timetz']['input']>;
  _gt?: InputMaybe<Scalars['timetz']['input']>;
  _gte?: InputMaybe<Scalars['timetz']['input']>;
  _in?: InputMaybe<Array<Scalars['timetz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timetz']['input']>;
  _lte?: InputMaybe<Scalars['timetz']['input']>;
  _neq?: InputMaybe<Scalars['timetz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timetz']['input']>>;
};

/** Enum table for totalizer correction ticket states */
export type Totalizer_Correction_Ticket_States = {
  __typename?: 'totalizer_correction_ticket_states';
  comment: Scalars['String']['output'];
  /** An array relationship */
  totalizer_correction_tickets: Array<Totalizer_Correction_Tickets>;
  /** An aggregate relationship */
  totalizer_correction_tickets_aggregate: Totalizer_Correction_Tickets_Aggregate;
  value: Scalars['String']['output'];
};


/** Enum table for totalizer correction ticket states */
export type Totalizer_Correction_Ticket_StatesTotalizer_Correction_TicketsArgs = {
  distinct_on?: InputMaybe<Array<Totalizer_Correction_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Totalizer_Correction_Tickets_Order_By>>;
  where?: InputMaybe<Totalizer_Correction_Tickets_Bool_Exp>;
};


/** Enum table for totalizer correction ticket states */
export type Totalizer_Correction_Ticket_StatesTotalizer_Correction_Tickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Totalizer_Correction_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Totalizer_Correction_Tickets_Order_By>>;
  where?: InputMaybe<Totalizer_Correction_Tickets_Bool_Exp>;
};

/** aggregated selection of "totalizer_correction_ticket_states" */
export type Totalizer_Correction_Ticket_States_Aggregate = {
  __typename?: 'totalizer_correction_ticket_states_aggregate';
  aggregate?: Maybe<Totalizer_Correction_Ticket_States_Aggregate_Fields>;
  nodes: Array<Totalizer_Correction_Ticket_States>;
};

/** aggregate fields of "totalizer_correction_ticket_states" */
export type Totalizer_Correction_Ticket_States_Aggregate_Fields = {
  __typename?: 'totalizer_correction_ticket_states_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Totalizer_Correction_Ticket_States_Max_Fields>;
  min?: Maybe<Totalizer_Correction_Ticket_States_Min_Fields>;
};


/** aggregate fields of "totalizer_correction_ticket_states" */
export type Totalizer_Correction_Ticket_States_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Totalizer_Correction_Ticket_States_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "totalizer_correction_ticket_states". All fields are combined with a logical 'AND'. */
export type Totalizer_Correction_Ticket_States_Bool_Exp = {
  _and?: InputMaybe<Array<Totalizer_Correction_Ticket_States_Bool_Exp>>;
  _not?: InputMaybe<Totalizer_Correction_Ticket_States_Bool_Exp>;
  _or?: InputMaybe<Array<Totalizer_Correction_Ticket_States_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  totalizer_correction_tickets?: InputMaybe<Totalizer_Correction_Tickets_Bool_Exp>;
  totalizer_correction_tickets_aggregate?: InputMaybe<Totalizer_Correction_Tickets_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "totalizer_correction_ticket_states" */
export enum Totalizer_Correction_Ticket_States_Constraint {
  /** unique or primary key constraint on columns "value" */
  TotalizerCorrectionTicketStatesPkey = 'totalizer_correction_ticket_states_pkey'
}

export enum Totalizer_Correction_Ticket_States_Enum {
  /** Correction approved and applied */
  Approved = 'APPROVED',
  /** Ticket awaiting review */
  Pending = 'PENDING',
  /** Correction rejected */
  Rejected = 'REJECTED'
}

/** Boolean expression to compare columns of type "totalizer_correction_ticket_states_enum". All fields are combined with logical 'AND'. */
export type Totalizer_Correction_Ticket_States_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Totalizer_Correction_Ticket_States_Enum>;
  _in?: InputMaybe<Array<Totalizer_Correction_Ticket_States_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Totalizer_Correction_Ticket_States_Enum>;
  _nin?: InputMaybe<Array<Totalizer_Correction_Ticket_States_Enum>>;
};

/** input type for inserting data into table "totalizer_correction_ticket_states" */
export type Totalizer_Correction_Ticket_States_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  totalizer_correction_tickets?: InputMaybe<Totalizer_Correction_Tickets_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Totalizer_Correction_Ticket_States_Max_Fields = {
  __typename?: 'totalizer_correction_ticket_states_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Totalizer_Correction_Ticket_States_Min_Fields = {
  __typename?: 'totalizer_correction_ticket_states_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "totalizer_correction_ticket_states" */
export type Totalizer_Correction_Ticket_States_Mutation_Response = {
  __typename?: 'totalizer_correction_ticket_states_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Totalizer_Correction_Ticket_States>;
};

/** input type for inserting object relation for remote table "totalizer_correction_ticket_states" */
export type Totalizer_Correction_Ticket_States_Obj_Rel_Insert_Input = {
  data: Totalizer_Correction_Ticket_States_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Totalizer_Correction_Ticket_States_On_Conflict>;
};

/** on_conflict condition type for table "totalizer_correction_ticket_states" */
export type Totalizer_Correction_Ticket_States_On_Conflict = {
  constraint: Totalizer_Correction_Ticket_States_Constraint;
  update_columns?: Array<Totalizer_Correction_Ticket_States_Update_Column>;
  where?: InputMaybe<Totalizer_Correction_Ticket_States_Bool_Exp>;
};

/** Ordering options when selecting data from "totalizer_correction_ticket_states". */
export type Totalizer_Correction_Ticket_States_Order_By = {
  comment?: InputMaybe<Order_By>;
  totalizer_correction_tickets_aggregate?: InputMaybe<Totalizer_Correction_Tickets_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: totalizer_correction_ticket_states */
export type Totalizer_Correction_Ticket_States_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "totalizer_correction_ticket_states" */
export enum Totalizer_Correction_Ticket_States_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "totalizer_correction_ticket_states" */
export type Totalizer_Correction_Ticket_States_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "totalizer_correction_ticket_states" */
export type Totalizer_Correction_Ticket_States_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Totalizer_Correction_Ticket_States_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Totalizer_Correction_Ticket_States_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "totalizer_correction_ticket_states" */
export enum Totalizer_Correction_Ticket_States_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Totalizer_Correction_Ticket_States_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Totalizer_Correction_Ticket_States_Set_Input>;
  /** filter the rows which have to be updated */
  where: Totalizer_Correction_Ticket_States_Bool_Exp;
};

/** Correction requests for totalizer readings (before/after). Tech Support creates, workflow processes. */
export type Totalizer_Correction_Tickets = {
  __typename?: 'totalizer_correction_tickets';
  approved_by?: Maybe<Scalars['uuid']['output']>;
  corrected_reading: Scalars['numeric']['output'];
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  image_url?: Maybe<Scalars['String']['output']>;
  is_active: Scalars['Boolean']['output'];
  last_modified: Scalars['timestamptz']['output'];
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  original_reading: Scalars['numeric']['output'];
  reading_type: Scalars['String']['output'];
  /** An object relationship */
  reason: Reasons;
  reason_id: Scalars['uuid']['output'];
  state: Totalizer_Correction_Ticket_States_Enum;
  /** An object relationship */
  task_value: Task_Value;
  task_value_id: Scalars['uuid']['output'];
  /** An object relationship */
  totalizer_correction_ticket_state: Totalizer_Correction_Ticket_States;
  /** An object relationship */
  user?: Maybe<User>;
  /** An object relationship */
  userByCreatedBy?: Maybe<User>;
  /** An object relationship */
  userByLastModifiedBy?: Maybe<User>;
};

/** aggregated selection of "totalizer_correction_tickets" */
export type Totalizer_Correction_Tickets_Aggregate = {
  __typename?: 'totalizer_correction_tickets_aggregate';
  aggregate?: Maybe<Totalizer_Correction_Tickets_Aggregate_Fields>;
  nodes: Array<Totalizer_Correction_Tickets>;
};

export type Totalizer_Correction_Tickets_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Totalizer_Correction_Tickets_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Totalizer_Correction_Tickets_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Totalizer_Correction_Tickets_Aggregate_Bool_Exp_Count>;
};

export type Totalizer_Correction_Tickets_Aggregate_Bool_Exp_Bool_And = {
  arguments: Totalizer_Correction_Tickets_Select_Column_Totalizer_Correction_Tickets_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Totalizer_Correction_Tickets_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Totalizer_Correction_Tickets_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Totalizer_Correction_Tickets_Select_Column_Totalizer_Correction_Tickets_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Totalizer_Correction_Tickets_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Totalizer_Correction_Tickets_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Totalizer_Correction_Tickets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Totalizer_Correction_Tickets_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "totalizer_correction_tickets" */
export type Totalizer_Correction_Tickets_Aggregate_Fields = {
  __typename?: 'totalizer_correction_tickets_aggregate_fields';
  avg?: Maybe<Totalizer_Correction_Tickets_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Totalizer_Correction_Tickets_Max_Fields>;
  min?: Maybe<Totalizer_Correction_Tickets_Min_Fields>;
  stddev?: Maybe<Totalizer_Correction_Tickets_Stddev_Fields>;
  stddev_pop?: Maybe<Totalizer_Correction_Tickets_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Totalizer_Correction_Tickets_Stddev_Samp_Fields>;
  sum?: Maybe<Totalizer_Correction_Tickets_Sum_Fields>;
  var_pop?: Maybe<Totalizer_Correction_Tickets_Var_Pop_Fields>;
  var_samp?: Maybe<Totalizer_Correction_Tickets_Var_Samp_Fields>;
  variance?: Maybe<Totalizer_Correction_Tickets_Variance_Fields>;
};


/** aggregate fields of "totalizer_correction_tickets" */
export type Totalizer_Correction_Tickets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Totalizer_Correction_Tickets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "totalizer_correction_tickets" */
export type Totalizer_Correction_Tickets_Aggregate_Order_By = {
  avg?: InputMaybe<Totalizer_Correction_Tickets_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Totalizer_Correction_Tickets_Max_Order_By>;
  min?: InputMaybe<Totalizer_Correction_Tickets_Min_Order_By>;
  stddev?: InputMaybe<Totalizer_Correction_Tickets_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Totalizer_Correction_Tickets_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Totalizer_Correction_Tickets_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Totalizer_Correction_Tickets_Sum_Order_By>;
  var_pop?: InputMaybe<Totalizer_Correction_Tickets_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Totalizer_Correction_Tickets_Var_Samp_Order_By>;
  variance?: InputMaybe<Totalizer_Correction_Tickets_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "totalizer_correction_tickets" */
export type Totalizer_Correction_Tickets_Arr_Rel_Insert_Input = {
  data: Array<Totalizer_Correction_Tickets_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Totalizer_Correction_Tickets_On_Conflict>;
};

/** aggregate avg on columns */
export type Totalizer_Correction_Tickets_Avg_Fields = {
  __typename?: 'totalizer_correction_tickets_avg_fields';
  corrected_reading?: Maybe<Scalars['Float']['output']>;
  original_reading?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "totalizer_correction_tickets" */
export type Totalizer_Correction_Tickets_Avg_Order_By = {
  corrected_reading?: InputMaybe<Order_By>;
  original_reading?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "totalizer_correction_tickets". All fields are combined with a logical 'AND'. */
export type Totalizer_Correction_Tickets_Bool_Exp = {
  _and?: InputMaybe<Array<Totalizer_Correction_Tickets_Bool_Exp>>;
  _not?: InputMaybe<Totalizer_Correction_Tickets_Bool_Exp>;
  _or?: InputMaybe<Array<Totalizer_Correction_Tickets_Bool_Exp>>;
  approved_by?: InputMaybe<Uuid_Comparison_Exp>;
  corrected_reading?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  original_reading?: InputMaybe<Numeric_Comparison_Exp>;
  reading_type?: InputMaybe<String_Comparison_Exp>;
  reason?: InputMaybe<Reasons_Bool_Exp>;
  reason_id?: InputMaybe<Uuid_Comparison_Exp>;
  state?: InputMaybe<Totalizer_Correction_Ticket_States_Enum_Comparison_Exp>;
  task_value?: InputMaybe<Task_Value_Bool_Exp>;
  task_value_id?: InputMaybe<Uuid_Comparison_Exp>;
  totalizer_correction_ticket_state?: InputMaybe<Totalizer_Correction_Ticket_States_Bool_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userByCreatedBy?: InputMaybe<User_Bool_Exp>;
  userByLastModifiedBy?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "totalizer_correction_tickets" */
export enum Totalizer_Correction_Tickets_Constraint {
  /** unique or primary key constraint on columns "id" */
  TotalizerCorrectionTicketsPkey = 'totalizer_correction_tickets_pkey'
}

/** input type for incrementing numeric columns in table "totalizer_correction_tickets" */
export type Totalizer_Correction_Tickets_Inc_Input = {
  corrected_reading?: InputMaybe<Scalars['numeric']['input']>;
  original_reading?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "totalizer_correction_tickets" */
export type Totalizer_Correction_Tickets_Insert_Input = {
  approved_by?: InputMaybe<Scalars['uuid']['input']>;
  corrected_reading?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image_url?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  original_reading?: InputMaybe<Scalars['numeric']['input']>;
  reading_type?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Reasons_Obj_Rel_Insert_Input>;
  reason_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Totalizer_Correction_Ticket_States_Enum>;
  task_value?: InputMaybe<Task_Value_Obj_Rel_Insert_Input>;
  task_value_id?: InputMaybe<Scalars['uuid']['input']>;
  totalizer_correction_ticket_state?: InputMaybe<Totalizer_Correction_Ticket_States_Obj_Rel_Insert_Input>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userByCreatedBy?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userByLastModifiedBy?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Totalizer_Correction_Tickets_Max_Fields = {
  __typename?: 'totalizer_correction_tickets_max_fields';
  approved_by?: Maybe<Scalars['uuid']['output']>;
  corrected_reading?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_url?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  original_reading?: Maybe<Scalars['numeric']['output']>;
  reading_type?: Maybe<Scalars['String']['output']>;
  reason_id?: Maybe<Scalars['uuid']['output']>;
  task_value_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "totalizer_correction_tickets" */
export type Totalizer_Correction_Tickets_Max_Order_By = {
  approved_by?: InputMaybe<Order_By>;
  corrected_reading?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  original_reading?: InputMaybe<Order_By>;
  reading_type?: InputMaybe<Order_By>;
  reason_id?: InputMaybe<Order_By>;
  task_value_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Totalizer_Correction_Tickets_Min_Fields = {
  __typename?: 'totalizer_correction_tickets_min_fields';
  approved_by?: Maybe<Scalars['uuid']['output']>;
  corrected_reading?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_url?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  original_reading?: Maybe<Scalars['numeric']['output']>;
  reading_type?: Maybe<Scalars['String']['output']>;
  reason_id?: Maybe<Scalars['uuid']['output']>;
  task_value_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "totalizer_correction_tickets" */
export type Totalizer_Correction_Tickets_Min_Order_By = {
  approved_by?: InputMaybe<Order_By>;
  corrected_reading?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  original_reading?: InputMaybe<Order_By>;
  reading_type?: InputMaybe<Order_By>;
  reason_id?: InputMaybe<Order_By>;
  task_value_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "totalizer_correction_tickets" */
export type Totalizer_Correction_Tickets_Mutation_Response = {
  __typename?: 'totalizer_correction_tickets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Totalizer_Correction_Tickets>;
};

/** on_conflict condition type for table "totalizer_correction_tickets" */
export type Totalizer_Correction_Tickets_On_Conflict = {
  constraint: Totalizer_Correction_Tickets_Constraint;
  update_columns?: Array<Totalizer_Correction_Tickets_Update_Column>;
  where?: InputMaybe<Totalizer_Correction_Tickets_Bool_Exp>;
};

/** Ordering options when selecting data from "totalizer_correction_tickets". */
export type Totalizer_Correction_Tickets_Order_By = {
  approved_by?: InputMaybe<Order_By>;
  corrected_reading?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  original_reading?: InputMaybe<Order_By>;
  reading_type?: InputMaybe<Order_By>;
  reason?: InputMaybe<Reasons_Order_By>;
  reason_id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  task_value?: InputMaybe<Task_Value_Order_By>;
  task_value_id?: InputMaybe<Order_By>;
  totalizer_correction_ticket_state?: InputMaybe<Totalizer_Correction_Ticket_States_Order_By>;
  user?: InputMaybe<User_Order_By>;
  userByCreatedBy?: InputMaybe<User_Order_By>;
  userByLastModifiedBy?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: totalizer_correction_tickets */
export type Totalizer_Correction_Tickets_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "totalizer_correction_tickets" */
export enum Totalizer_Correction_Tickets_Select_Column {
  /** column name */
  ApprovedBy = 'approved_by',
  /** column name */
  CorrectedReading = 'corrected_reading',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Message = 'message',
  /** column name */
  OriginalReading = 'original_reading',
  /** column name */
  ReadingType = 'reading_type',
  /** column name */
  ReasonId = 'reason_id',
  /** column name */
  State = 'state',
  /** column name */
  TaskValueId = 'task_value_id'
}

/** select "totalizer_correction_tickets_aggregate_bool_exp_bool_and_arguments_columns" columns of table "totalizer_correction_tickets" */
export enum Totalizer_Correction_Tickets_Select_Column_Totalizer_Correction_Tickets_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "totalizer_correction_tickets_aggregate_bool_exp_bool_or_arguments_columns" columns of table "totalizer_correction_tickets" */
export enum Totalizer_Correction_Tickets_Select_Column_Totalizer_Correction_Tickets_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "totalizer_correction_tickets" */
export type Totalizer_Correction_Tickets_Set_Input = {
  approved_by?: InputMaybe<Scalars['uuid']['input']>;
  corrected_reading?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image_url?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  original_reading?: InputMaybe<Scalars['numeric']['input']>;
  reading_type?: InputMaybe<Scalars['String']['input']>;
  reason_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Totalizer_Correction_Ticket_States_Enum>;
  task_value_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Totalizer_Correction_Tickets_Stddev_Fields = {
  __typename?: 'totalizer_correction_tickets_stddev_fields';
  corrected_reading?: Maybe<Scalars['Float']['output']>;
  original_reading?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "totalizer_correction_tickets" */
export type Totalizer_Correction_Tickets_Stddev_Order_By = {
  corrected_reading?: InputMaybe<Order_By>;
  original_reading?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Totalizer_Correction_Tickets_Stddev_Pop_Fields = {
  __typename?: 'totalizer_correction_tickets_stddev_pop_fields';
  corrected_reading?: Maybe<Scalars['Float']['output']>;
  original_reading?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "totalizer_correction_tickets" */
export type Totalizer_Correction_Tickets_Stddev_Pop_Order_By = {
  corrected_reading?: InputMaybe<Order_By>;
  original_reading?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Totalizer_Correction_Tickets_Stddev_Samp_Fields = {
  __typename?: 'totalizer_correction_tickets_stddev_samp_fields';
  corrected_reading?: Maybe<Scalars['Float']['output']>;
  original_reading?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "totalizer_correction_tickets" */
export type Totalizer_Correction_Tickets_Stddev_Samp_Order_By = {
  corrected_reading?: InputMaybe<Order_By>;
  original_reading?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "totalizer_correction_tickets" */
export type Totalizer_Correction_Tickets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Totalizer_Correction_Tickets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Totalizer_Correction_Tickets_Stream_Cursor_Value_Input = {
  approved_by?: InputMaybe<Scalars['uuid']['input']>;
  corrected_reading?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image_url?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  original_reading?: InputMaybe<Scalars['numeric']['input']>;
  reading_type?: InputMaybe<Scalars['String']['input']>;
  reason_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Totalizer_Correction_Ticket_States_Enum>;
  task_value_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Totalizer_Correction_Tickets_Sum_Fields = {
  __typename?: 'totalizer_correction_tickets_sum_fields';
  corrected_reading?: Maybe<Scalars['numeric']['output']>;
  original_reading?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "totalizer_correction_tickets" */
export type Totalizer_Correction_Tickets_Sum_Order_By = {
  corrected_reading?: InputMaybe<Order_By>;
  original_reading?: InputMaybe<Order_By>;
};

/** update columns of table "totalizer_correction_tickets" */
export enum Totalizer_Correction_Tickets_Update_Column {
  /** column name */
  ApprovedBy = 'approved_by',
  /** column name */
  CorrectedReading = 'corrected_reading',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Message = 'message',
  /** column name */
  OriginalReading = 'original_reading',
  /** column name */
  ReadingType = 'reading_type',
  /** column name */
  ReasonId = 'reason_id',
  /** column name */
  State = 'state',
  /** column name */
  TaskValueId = 'task_value_id'
}

export type Totalizer_Correction_Tickets_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Totalizer_Correction_Tickets_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Totalizer_Correction_Tickets_Set_Input>;
  /** filter the rows which have to be updated */
  where: Totalizer_Correction_Tickets_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Totalizer_Correction_Tickets_Var_Pop_Fields = {
  __typename?: 'totalizer_correction_tickets_var_pop_fields';
  corrected_reading?: Maybe<Scalars['Float']['output']>;
  original_reading?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "totalizer_correction_tickets" */
export type Totalizer_Correction_Tickets_Var_Pop_Order_By = {
  corrected_reading?: InputMaybe<Order_By>;
  original_reading?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Totalizer_Correction_Tickets_Var_Samp_Fields = {
  __typename?: 'totalizer_correction_tickets_var_samp_fields';
  corrected_reading?: Maybe<Scalars['Float']['output']>;
  original_reading?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "totalizer_correction_tickets" */
export type Totalizer_Correction_Tickets_Var_Samp_Order_By = {
  corrected_reading?: InputMaybe<Order_By>;
  original_reading?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Totalizer_Correction_Tickets_Variance_Fields = {
  __typename?: 'totalizer_correction_tickets_variance_fields';
  corrected_reading?: Maybe<Scalars['Float']['output']>;
  original_reading?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "totalizer_correction_tickets" */
export type Totalizer_Correction_Tickets_Variance_Order_By = {
  corrected_reading?: InputMaybe<Order_By>;
  original_reading?: InputMaybe<Order_By>;
};

/** columns and relationships of "transaction_type" */
export type Transaction_Type = {
  __typename?: 'transaction_type';
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  limit_purchase_order_logs: Array<Limit_Purchase_Order_Logs>;
  /** An aggregate relationship */
  limit_purchase_order_logs_aggregate: Limit_Purchase_Order_Logs_Aggregate;
  value: Scalars['String']['output'];
  /** An array relationship */
  vehicle_inventory_transaction_logs: Array<Vehicle_Inventory_Transaction_Logs>;
  /** An aggregate relationship */
  vehicle_inventory_transaction_logs_aggregate: Vehicle_Inventory_Transaction_Logs_Aggregate;
};


/** columns and relationships of "transaction_type" */
export type Transaction_TypeLimit_Purchase_Order_LogsArgs = {
  distinct_on?: InputMaybe<Array<Limit_Purchase_Order_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Limit_Purchase_Order_Logs_Order_By>>;
  where?: InputMaybe<Limit_Purchase_Order_Logs_Bool_Exp>;
};


/** columns and relationships of "transaction_type" */
export type Transaction_TypeLimit_Purchase_Order_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Limit_Purchase_Order_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Limit_Purchase_Order_Logs_Order_By>>;
  where?: InputMaybe<Limit_Purchase_Order_Logs_Bool_Exp>;
};


/** columns and relationships of "transaction_type" */
export type Transaction_TypeVehicle_Inventory_Transaction_LogsArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Inventory_Transaction_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Inventory_Transaction_Logs_Order_By>>;
  where?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Bool_Exp>;
};


/** columns and relationships of "transaction_type" */
export type Transaction_TypeVehicle_Inventory_Transaction_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Inventory_Transaction_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Inventory_Transaction_Logs_Order_By>>;
  where?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Bool_Exp>;
};

/** aggregated selection of "transaction_type" */
export type Transaction_Type_Aggregate = {
  __typename?: 'transaction_type_aggregate';
  aggregate?: Maybe<Transaction_Type_Aggregate_Fields>;
  nodes: Array<Transaction_Type>;
};

/** aggregate fields of "transaction_type" */
export type Transaction_Type_Aggregate_Fields = {
  __typename?: 'transaction_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Transaction_Type_Max_Fields>;
  min?: Maybe<Transaction_Type_Min_Fields>;
};


/** aggregate fields of "transaction_type" */
export type Transaction_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Transaction_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "transaction_type". All fields are combined with a logical 'AND'. */
export type Transaction_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Transaction_Type_Bool_Exp>>;
  _not?: InputMaybe<Transaction_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Transaction_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  limit_purchase_order_logs?: InputMaybe<Limit_Purchase_Order_Logs_Bool_Exp>;
  limit_purchase_order_logs_aggregate?: InputMaybe<Limit_Purchase_Order_Logs_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
  vehicle_inventory_transaction_logs?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Bool_Exp>;
  vehicle_inventory_transaction_logs_aggregate?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "transaction_type" */
export enum Transaction_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  TransactionTypePkey = 'transaction_type_pkey'
}

/** input type for inserting data into table "transaction_type" */
export type Transaction_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  limit_purchase_order_logs?: InputMaybe<Limit_Purchase_Order_Logs_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
  vehicle_inventory_transaction_logs?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Transaction_Type_Max_Fields = {
  __typename?: 'transaction_type_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Transaction_Type_Min_Fields = {
  __typename?: 'transaction_type_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "transaction_type" */
export type Transaction_Type_Mutation_Response = {
  __typename?: 'transaction_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Transaction_Type>;
};

/** input type for inserting object relation for remote table "transaction_type" */
export type Transaction_Type_Obj_Rel_Insert_Input = {
  data: Transaction_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Transaction_Type_On_Conflict>;
};

/** on_conflict condition type for table "transaction_type" */
export type Transaction_Type_On_Conflict = {
  constraint: Transaction_Type_Constraint;
  update_columns?: Array<Transaction_Type_Update_Column>;
  where?: InputMaybe<Transaction_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "transaction_type". */
export type Transaction_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  limit_purchase_order_logs_aggregate?: InputMaybe<Limit_Purchase_Order_Logs_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
  vehicle_inventory_transaction_logs_aggregate?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Aggregate_Order_By>;
};

/** primary key columns input for table: transaction_type */
export type Transaction_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "transaction_type" */
export enum Transaction_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "transaction_type" */
export type Transaction_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "transaction_type" */
export type Transaction_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Transaction_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Transaction_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "transaction_type" */
export enum Transaction_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Transaction_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Transaction_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Transaction_Type_Bool_Exp;
};

export type TriggerDeliveryNoteInput = {
  invoiced_item_ids: Array<Scalars['uuid']['input']>;
};

export type TriggerDeliveryNoteOutput = {
  __typename?: 'triggerDeliveryNoteOutput';
  affected_rows?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Scalars['jsonb']['output']>;
  message: Scalars['String']['output'];
};

/** columns and relationships of "trip" */
export type Trip = {
  __typename?: 'trip';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  location: Scalars['geometry']['output'];
  /** An object relationship */
  partner: Partner;
  partner_id: Scalars['uuid']['output'];
  /** An object relationship */
  trip_plan: Trip_Plan;
  trip_plan_id: Scalars['uuid']['output'];
};

/** aggregated selection of "trip" */
export type Trip_Aggregate = {
  __typename?: 'trip_aggregate';
  aggregate?: Maybe<Trip_Aggregate_Fields>;
  nodes: Array<Trip>;
};

export type Trip_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Trip_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Trip_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Trip_Aggregate_Bool_Exp_Count>;
};

export type Trip_Aggregate_Bool_Exp_Bool_And = {
  arguments: Trip_Select_Column_Trip_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Trip_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Trip_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Trip_Select_Column_Trip_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Trip_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Trip_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Trip_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Trip_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "trip" */
export type Trip_Aggregate_Fields = {
  __typename?: 'trip_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Trip_Max_Fields>;
  min?: Maybe<Trip_Min_Fields>;
};


/** aggregate fields of "trip" */
export type Trip_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trip_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "trip" */
export type Trip_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trip_Max_Order_By>;
  min?: InputMaybe<Trip_Min_Order_By>;
};

/** input type for inserting array relation for remote table "trip" */
export type Trip_Arr_Rel_Insert_Input = {
  data: Array<Trip_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Trip_On_Conflict>;
};

/** Boolean expression to filter rows from the table "trip". All fields are combined with a logical 'AND'. */
export type Trip_Bool_Exp = {
  _and?: InputMaybe<Array<Trip_Bool_Exp>>;
  _not?: InputMaybe<Trip_Bool_Exp>;
  _or?: InputMaybe<Array<Trip_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<Geometry_Comparison_Exp>;
  partner?: InputMaybe<Partner_Bool_Exp>;
  partner_id?: InputMaybe<Uuid_Comparison_Exp>;
  trip_plan?: InputMaybe<Trip_Plan_Bool_Exp>;
  trip_plan_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "trip" */
export enum Trip_Constraint {
  /** unique or primary key constraint on columns "id" */
  TripPkey = 'trip_pkey'
}

/** input type for inserting data into table "trip" */
export type Trip_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['geometry']['input']>;
  partner?: InputMaybe<Partner_Obj_Rel_Insert_Input>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  trip_plan?: InputMaybe<Trip_Plan_Obj_Rel_Insert_Input>;
  trip_plan_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "trip_location" */
export type Trip_Location = {
  __typename?: 'trip_location';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  location: Scalars['geometry']['output'];
  /** An object relationship */
  trip_plan: Trip_Plan;
  trip_plan_id: Scalars['uuid']['output'];
};

/** aggregated selection of "trip_location" */
export type Trip_Location_Aggregate = {
  __typename?: 'trip_location_aggregate';
  aggregate?: Maybe<Trip_Location_Aggregate_Fields>;
  nodes: Array<Trip_Location>;
};

export type Trip_Location_Aggregate_Bool_Exp = {
  count?: InputMaybe<Trip_Location_Aggregate_Bool_Exp_Count>;
};

export type Trip_Location_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Trip_Location_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Trip_Location_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "trip_location" */
export type Trip_Location_Aggregate_Fields = {
  __typename?: 'trip_location_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Trip_Location_Max_Fields>;
  min?: Maybe<Trip_Location_Min_Fields>;
};


/** aggregate fields of "trip_location" */
export type Trip_Location_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trip_Location_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "trip_location" */
export type Trip_Location_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trip_Location_Max_Order_By>;
  min?: InputMaybe<Trip_Location_Min_Order_By>;
};

/** input type for inserting array relation for remote table "trip_location" */
export type Trip_Location_Arr_Rel_Insert_Input = {
  data: Array<Trip_Location_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Trip_Location_On_Conflict>;
};

/** Boolean expression to filter rows from the table "trip_location". All fields are combined with a logical 'AND'. */
export type Trip_Location_Bool_Exp = {
  _and?: InputMaybe<Array<Trip_Location_Bool_Exp>>;
  _not?: InputMaybe<Trip_Location_Bool_Exp>;
  _or?: InputMaybe<Array<Trip_Location_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<Geometry_Comparison_Exp>;
  trip_plan?: InputMaybe<Trip_Plan_Bool_Exp>;
  trip_plan_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "trip_location" */
export enum Trip_Location_Constraint {
  /** unique or primary key constraint on columns "id" */
  TripLocationPkey = 'trip_location_pkey'
}

/** input type for inserting data into table "trip_location" */
export type Trip_Location_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['geometry']['input']>;
  trip_plan?: InputMaybe<Trip_Plan_Obj_Rel_Insert_Input>;
  trip_plan_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Trip_Location_Max_Fields = {
  __typename?: 'trip_location_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  trip_plan_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "trip_location" */
export type Trip_Location_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  trip_plan_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Trip_Location_Min_Fields = {
  __typename?: 'trip_location_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  trip_plan_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "trip_location" */
export type Trip_Location_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  trip_plan_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "trip_location" */
export type Trip_Location_Mutation_Response = {
  __typename?: 'trip_location_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Trip_Location>;
};

/** on_conflict condition type for table "trip_location" */
export type Trip_Location_On_Conflict = {
  constraint: Trip_Location_Constraint;
  update_columns?: Array<Trip_Location_Update_Column>;
  where?: InputMaybe<Trip_Location_Bool_Exp>;
};

/** Ordering options when selecting data from "trip_location". */
export type Trip_Location_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  trip_plan?: InputMaybe<Trip_Plan_Order_By>;
  trip_plan_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: trip_location */
export type Trip_Location_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "trip_location" */
export enum Trip_Location_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Location = 'location',
  /** column name */
  TripPlanId = 'trip_plan_id'
}

/** input type for updating data in table "trip_location" */
export type Trip_Location_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['geometry']['input']>;
  trip_plan_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "trip_location" */
export type Trip_Location_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trip_Location_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trip_Location_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['geometry']['input']>;
  trip_plan_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "trip_location" */
export enum Trip_Location_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Location = 'location',
  /** column name */
  TripPlanId = 'trip_plan_id'
}

export type Trip_Location_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Trip_Location_Set_Input>;
  /** filter the rows which have to be updated */
  where: Trip_Location_Bool_Exp;
};

/** aggregate max on columns */
export type Trip_Max_Fields = {
  __typename?: 'trip_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  trip_plan_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "trip" */
export type Trip_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  trip_plan_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Trip_Min_Fields = {
  __typename?: 'trip_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  trip_plan_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "trip" */
export type Trip_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  trip_plan_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "trip" */
export type Trip_Mutation_Response = {
  __typename?: 'trip_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Trip>;
};

/** on_conflict condition type for table "trip" */
export type Trip_On_Conflict = {
  constraint: Trip_Constraint;
  update_columns?: Array<Trip_Update_Column>;
  where?: InputMaybe<Trip_Bool_Exp>;
};

/** Ordering options when selecting data from "trip". */
export type Trip_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  partner?: InputMaybe<Partner_Order_By>;
  partner_id?: InputMaybe<Order_By>;
  trip_plan?: InputMaybe<Trip_Plan_Order_By>;
  trip_plan_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: trip */
export type Trip_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "trip_plan" */
export type Trip_Plan = {
  __typename?: 'trip_plan';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  customer_asset: Customer_Asset;
  customer_asset_id: Scalars['uuid']['output'];
  driver_id: Scalars['uuid']['output'];
  end_date?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  max_qty?: Maybe<Scalars['numeric']['output']>;
  start_date?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  trip_locations: Array<Trip_Location>;
  /** An aggregate relationship */
  trip_locations_aggregate: Trip_Location_Aggregate;
  /** An array relationship */
  trips: Array<Trip>;
  /** An aggregate relationship */
  trips_aggregate: Trip_Aggregate;
  /** An object relationship */
  user: User;
  /** An object relationship */
  vehicle: Vehicle;
  vehicle_id: Scalars['uuid']['output'];
};


/** columns and relationships of "trip_plan" */
export type Trip_PlanTrip_LocationsArgs = {
  distinct_on?: InputMaybe<Array<Trip_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trip_Location_Order_By>>;
  where?: InputMaybe<Trip_Location_Bool_Exp>;
};


/** columns and relationships of "trip_plan" */
export type Trip_PlanTrip_Locations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trip_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trip_Location_Order_By>>;
  where?: InputMaybe<Trip_Location_Bool_Exp>;
};


/** columns and relationships of "trip_plan" */
export type Trip_PlanTripsArgs = {
  distinct_on?: InputMaybe<Array<Trip_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trip_Order_By>>;
  where?: InputMaybe<Trip_Bool_Exp>;
};


/** columns and relationships of "trip_plan" */
export type Trip_PlanTrips_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trip_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trip_Order_By>>;
  where?: InputMaybe<Trip_Bool_Exp>;
};

/** aggregated selection of "trip_plan" */
export type Trip_Plan_Aggregate = {
  __typename?: 'trip_plan_aggregate';
  aggregate?: Maybe<Trip_Plan_Aggregate_Fields>;
  nodes: Array<Trip_Plan>;
};

export type Trip_Plan_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Trip_Plan_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Trip_Plan_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Trip_Plan_Aggregate_Bool_Exp_Count>;
};

export type Trip_Plan_Aggregate_Bool_Exp_Bool_And = {
  arguments: Trip_Plan_Select_Column_Trip_Plan_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Trip_Plan_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Trip_Plan_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Trip_Plan_Select_Column_Trip_Plan_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Trip_Plan_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Trip_Plan_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Trip_Plan_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Trip_Plan_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "trip_plan" */
export type Trip_Plan_Aggregate_Fields = {
  __typename?: 'trip_plan_aggregate_fields';
  avg?: Maybe<Trip_Plan_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Trip_Plan_Max_Fields>;
  min?: Maybe<Trip_Plan_Min_Fields>;
  stddev?: Maybe<Trip_Plan_Stddev_Fields>;
  stddev_pop?: Maybe<Trip_Plan_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Trip_Plan_Stddev_Samp_Fields>;
  sum?: Maybe<Trip_Plan_Sum_Fields>;
  var_pop?: Maybe<Trip_Plan_Var_Pop_Fields>;
  var_samp?: Maybe<Trip_Plan_Var_Samp_Fields>;
  variance?: Maybe<Trip_Plan_Variance_Fields>;
};


/** aggregate fields of "trip_plan" */
export type Trip_Plan_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trip_Plan_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "trip_plan" */
export type Trip_Plan_Aggregate_Order_By = {
  avg?: InputMaybe<Trip_Plan_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trip_Plan_Max_Order_By>;
  min?: InputMaybe<Trip_Plan_Min_Order_By>;
  stddev?: InputMaybe<Trip_Plan_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Trip_Plan_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Trip_Plan_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Trip_Plan_Sum_Order_By>;
  var_pop?: InputMaybe<Trip_Plan_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Trip_Plan_Var_Samp_Order_By>;
  variance?: InputMaybe<Trip_Plan_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "trip_plan" */
export type Trip_Plan_Arr_Rel_Insert_Input = {
  data: Array<Trip_Plan_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Trip_Plan_On_Conflict>;
};

/** aggregate avg on columns */
export type Trip_Plan_Avg_Fields = {
  __typename?: 'trip_plan_avg_fields';
  max_qty?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "trip_plan" */
export type Trip_Plan_Avg_Order_By = {
  max_qty?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "trip_plan". All fields are combined with a logical 'AND'. */
export type Trip_Plan_Bool_Exp = {
  _and?: InputMaybe<Array<Trip_Plan_Bool_Exp>>;
  _not?: InputMaybe<Trip_Plan_Bool_Exp>;
  _or?: InputMaybe<Array<Trip_Plan_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_asset?: InputMaybe<Customer_Asset_Bool_Exp>;
  customer_asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  driver_id?: InputMaybe<Uuid_Comparison_Exp>;
  end_date?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  max_qty?: InputMaybe<Numeric_Comparison_Exp>;
  start_date?: InputMaybe<Timestamp_Comparison_Exp>;
  trip_locations?: InputMaybe<Trip_Location_Bool_Exp>;
  trip_locations_aggregate?: InputMaybe<Trip_Location_Aggregate_Bool_Exp>;
  trips?: InputMaybe<Trip_Bool_Exp>;
  trips_aggregate?: InputMaybe<Trip_Aggregate_Bool_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  vehicle?: InputMaybe<Vehicle_Bool_Exp>;
  vehicle_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "trip_plan" */
export enum Trip_Plan_Constraint {
  /** unique or primary key constraint on columns "id" */
  TripPlanPkey = 'trip_plan_pkey'
}

/** input type for incrementing numeric columns in table "trip_plan" */
export type Trip_Plan_Inc_Input = {
  max_qty?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "trip_plan" */
export type Trip_Plan_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_asset?: InputMaybe<Customer_Asset_Obj_Rel_Insert_Input>;
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  driver_id?: InputMaybe<Scalars['uuid']['input']>;
  end_date?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  max_qty?: InputMaybe<Scalars['numeric']['input']>;
  start_date?: InputMaybe<Scalars['timestamp']['input']>;
  trip_locations?: InputMaybe<Trip_Location_Arr_Rel_Insert_Input>;
  trips?: InputMaybe<Trip_Arr_Rel_Insert_Input>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  vehicle?: InputMaybe<Vehicle_Obj_Rel_Insert_Input>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Trip_Plan_Max_Fields = {
  __typename?: 'trip_plan_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  driver_id?: Maybe<Scalars['uuid']['output']>;
  end_date?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  max_qty?: Maybe<Scalars['numeric']['output']>;
  start_date?: Maybe<Scalars['timestamp']['output']>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "trip_plan" */
export type Trip_Plan_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  driver_id?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  max_qty?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Trip_Plan_Min_Fields = {
  __typename?: 'trip_plan_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  driver_id?: Maybe<Scalars['uuid']['output']>;
  end_date?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  max_qty?: Maybe<Scalars['numeric']['output']>;
  start_date?: Maybe<Scalars['timestamp']['output']>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "trip_plan" */
export type Trip_Plan_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  driver_id?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  max_qty?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "trip_plan" */
export type Trip_Plan_Mutation_Response = {
  __typename?: 'trip_plan_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Trip_Plan>;
};

/** input type for inserting object relation for remote table "trip_plan" */
export type Trip_Plan_Obj_Rel_Insert_Input = {
  data: Trip_Plan_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Trip_Plan_On_Conflict>;
};

/** on_conflict condition type for table "trip_plan" */
export type Trip_Plan_On_Conflict = {
  constraint: Trip_Plan_Constraint;
  update_columns?: Array<Trip_Plan_Update_Column>;
  where?: InputMaybe<Trip_Plan_Bool_Exp>;
};

/** Ordering options when selecting data from "trip_plan". */
export type Trip_Plan_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_asset?: InputMaybe<Customer_Asset_Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  driver_id?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  max_qty?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  trip_locations_aggregate?: InputMaybe<Trip_Location_Aggregate_Order_By>;
  trips_aggregate?: InputMaybe<Trip_Aggregate_Order_By>;
  user?: InputMaybe<User_Order_By>;
  vehicle?: InputMaybe<Vehicle_Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: trip_plan */
export type Trip_Plan_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "trip_plan" */
export enum Trip_Plan_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerAssetId = 'customer_asset_id',
  /** column name */
  DriverId = 'driver_id',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  MaxQty = 'max_qty',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  VehicleId = 'vehicle_id'
}

/** select "trip_plan_aggregate_bool_exp_bool_and_arguments_columns" columns of table "trip_plan" */
export enum Trip_Plan_Select_Column_Trip_Plan_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "trip_plan_aggregate_bool_exp_bool_or_arguments_columns" columns of table "trip_plan" */
export enum Trip_Plan_Select_Column_Trip_Plan_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "trip_plan" */
export type Trip_Plan_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  driver_id?: InputMaybe<Scalars['uuid']['input']>;
  end_date?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  max_qty?: InputMaybe<Scalars['numeric']['input']>;
  start_date?: InputMaybe<Scalars['timestamp']['input']>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Trip_Plan_Stddev_Fields = {
  __typename?: 'trip_plan_stddev_fields';
  max_qty?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "trip_plan" */
export type Trip_Plan_Stddev_Order_By = {
  max_qty?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Trip_Plan_Stddev_Pop_Fields = {
  __typename?: 'trip_plan_stddev_pop_fields';
  max_qty?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "trip_plan" */
export type Trip_Plan_Stddev_Pop_Order_By = {
  max_qty?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Trip_Plan_Stddev_Samp_Fields = {
  __typename?: 'trip_plan_stddev_samp_fields';
  max_qty?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "trip_plan" */
export type Trip_Plan_Stddev_Samp_Order_By = {
  max_qty?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "trip_plan" */
export type Trip_Plan_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trip_Plan_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trip_Plan_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  driver_id?: InputMaybe<Scalars['uuid']['input']>;
  end_date?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  max_qty?: InputMaybe<Scalars['numeric']['input']>;
  start_date?: InputMaybe<Scalars['timestamp']['input']>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Trip_Plan_Sum_Fields = {
  __typename?: 'trip_plan_sum_fields';
  max_qty?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "trip_plan" */
export type Trip_Plan_Sum_Order_By = {
  max_qty?: InputMaybe<Order_By>;
};

/** update columns of table "trip_plan" */
export enum Trip_Plan_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerAssetId = 'customer_asset_id',
  /** column name */
  DriverId = 'driver_id',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  MaxQty = 'max_qty',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  VehicleId = 'vehicle_id'
}

export type Trip_Plan_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Trip_Plan_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Trip_Plan_Set_Input>;
  /** filter the rows which have to be updated */
  where: Trip_Plan_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Trip_Plan_Var_Pop_Fields = {
  __typename?: 'trip_plan_var_pop_fields';
  max_qty?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "trip_plan" */
export type Trip_Plan_Var_Pop_Order_By = {
  max_qty?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Trip_Plan_Var_Samp_Fields = {
  __typename?: 'trip_plan_var_samp_fields';
  max_qty?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "trip_plan" */
export type Trip_Plan_Var_Samp_Order_By = {
  max_qty?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Trip_Plan_Variance_Fields = {
  __typename?: 'trip_plan_variance_fields';
  max_qty?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "trip_plan" */
export type Trip_Plan_Variance_Order_By = {
  max_qty?: InputMaybe<Order_By>;
};

/** select columns of table "trip" */
export enum Trip_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Location = 'location',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  TripPlanId = 'trip_plan_id'
}

/** select "trip_aggregate_bool_exp_bool_and_arguments_columns" columns of table "trip" */
export enum Trip_Select_Column_Trip_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "trip_aggregate_bool_exp_bool_or_arguments_columns" columns of table "trip" */
export enum Trip_Select_Column_Trip_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "trip" */
export type Trip_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['geometry']['input']>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  trip_plan_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "trip" */
export type Trip_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trip_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trip_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['geometry']['input']>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  trip_plan_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "trip" */
export enum Trip_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Location = 'location',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  TripPlanId = 'trip_plan_id'
}

export type Trip_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Trip_Set_Input>;
  /** filter the rows which have to be updated */
  where: Trip_Bool_Exp;
};

export type Unblock_Wallet_Amount_Args = {
  p_amount?: InputMaybe<Scalars['numeric']['input']>;
  p_org_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "unit_of_measure" */
export type Unit_Of_Measure = {
  __typename?: 'unit_of_measure';
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  customer_order_customer_assets: Array<Customer_Order_Customer_Asset>;
  /** An aggregate relationship */
  customer_order_customer_assets_aggregate: Customer_Order_Customer_Asset_Aggregate;
  /** An array relationship */
  customer_order_items: Array<Customer_Order_Item>;
  /** An aggregate relationship */
  customer_order_items_aggregate: Customer_Order_Item_Aggregate;
  /** An array relationship */
  fillupRequestsByNormalizedUnit: Array<Fillup_Request>;
  /** An aggregate relationship */
  fillupRequestsByNormalizedUnit_aggregate: Fillup_Request_Aggregate;
  /** An array relationship */
  fillup_requests: Array<Fillup_Request>;
  /** An aggregate relationship */
  fillup_requests_aggregate: Fillup_Request_Aggregate;
  /** An array relationship */
  invoiced_items: Array<Invoiced_Item>;
  /** An aggregate relationship */
  invoiced_items_aggregate: Invoiced_Item_Aggregate;
  /** An object relationship */
  meta?: Maybe<Unit_Of_Measure_Meta>;
  /** An array relationship */
  products: Array<Product>;
  /** An aggregate relationship */
  products_aggregate: Product_Aggregate;
  /** An array relationship */
  task_values: Array<Task_Value>;
  /** An aggregate relationship */
  task_values_aggregate: Task_Value_Aggregate;
  /** An array relationship */
  uomConversionsByToUom: Array<Uom_Conversion>;
  /** An aggregate relationship */
  uomConversionsByToUom_aggregate: Uom_Conversion_Aggregate;
  /** An array relationship */
  uom_conversions: Array<Uom_Conversion>;
  /** An aggregate relationship */
  uom_conversions_aggregate: Uom_Conversion_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "unit_of_measure" */
export type Unit_Of_MeasureCustomer_Order_Customer_AssetsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Customer_Asset_Order_By>>;
  where?: InputMaybe<Customer_Order_Customer_Asset_Bool_Exp>;
};


/** columns and relationships of "unit_of_measure" */
export type Unit_Of_MeasureCustomer_Order_Customer_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Customer_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Customer_Asset_Order_By>>;
  where?: InputMaybe<Customer_Order_Customer_Asset_Bool_Exp>;
};


/** columns and relationships of "unit_of_measure" */
export type Unit_Of_MeasureCustomer_Order_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Bool_Exp>;
};


/** columns and relationships of "unit_of_measure" */
export type Unit_Of_MeasureCustomer_Order_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Item_Order_By>>;
  where?: InputMaybe<Customer_Order_Item_Bool_Exp>;
};


/** columns and relationships of "unit_of_measure" */
export type Unit_Of_MeasureFillupRequestsByNormalizedUnitArgs = {
  distinct_on?: InputMaybe<Array<Fillup_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fillup_Request_Order_By>>;
  where?: InputMaybe<Fillup_Request_Bool_Exp>;
};


/** columns and relationships of "unit_of_measure" */
export type Unit_Of_MeasureFillupRequestsByNormalizedUnit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fillup_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fillup_Request_Order_By>>;
  where?: InputMaybe<Fillup_Request_Bool_Exp>;
};


/** columns and relationships of "unit_of_measure" */
export type Unit_Of_MeasureFillup_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Fillup_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fillup_Request_Order_By>>;
  where?: InputMaybe<Fillup_Request_Bool_Exp>;
};


/** columns and relationships of "unit_of_measure" */
export type Unit_Of_MeasureFillup_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fillup_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fillup_Request_Order_By>>;
  where?: InputMaybe<Fillup_Request_Bool_Exp>;
};


/** columns and relationships of "unit_of_measure" */
export type Unit_Of_MeasureInvoiced_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Bool_Exp>;
};


/** columns and relationships of "unit_of_measure" */
export type Unit_Of_MeasureInvoiced_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Bool_Exp>;
};


/** columns and relationships of "unit_of_measure" */
export type Unit_Of_MeasureProductsArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


/** columns and relationships of "unit_of_measure" */
export type Unit_Of_MeasureProducts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


/** columns and relationships of "unit_of_measure" */
export type Unit_Of_MeasureTask_ValuesArgs = {
  distinct_on?: InputMaybe<Array<Task_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Value_Order_By>>;
  where?: InputMaybe<Task_Value_Bool_Exp>;
};


/** columns and relationships of "unit_of_measure" */
export type Unit_Of_MeasureTask_Values_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Value_Order_By>>;
  where?: InputMaybe<Task_Value_Bool_Exp>;
};


/** columns and relationships of "unit_of_measure" */
export type Unit_Of_MeasureUomConversionsByToUomArgs = {
  distinct_on?: InputMaybe<Array<Uom_Conversion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uom_Conversion_Order_By>>;
  where?: InputMaybe<Uom_Conversion_Bool_Exp>;
};


/** columns and relationships of "unit_of_measure" */
export type Unit_Of_MeasureUomConversionsByToUom_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uom_Conversion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uom_Conversion_Order_By>>;
  where?: InputMaybe<Uom_Conversion_Bool_Exp>;
};


/** columns and relationships of "unit_of_measure" */
export type Unit_Of_MeasureUom_ConversionsArgs = {
  distinct_on?: InputMaybe<Array<Uom_Conversion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uom_Conversion_Order_By>>;
  where?: InputMaybe<Uom_Conversion_Bool_Exp>;
};


/** columns and relationships of "unit_of_measure" */
export type Unit_Of_MeasureUom_Conversions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uom_Conversion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uom_Conversion_Order_By>>;
  where?: InputMaybe<Uom_Conversion_Bool_Exp>;
};

/** aggregated selection of "unit_of_measure" */
export type Unit_Of_Measure_Aggregate = {
  __typename?: 'unit_of_measure_aggregate';
  aggregate?: Maybe<Unit_Of_Measure_Aggregate_Fields>;
  nodes: Array<Unit_Of_Measure>;
};

/** aggregate fields of "unit_of_measure" */
export type Unit_Of_Measure_Aggregate_Fields = {
  __typename?: 'unit_of_measure_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Unit_Of_Measure_Max_Fields>;
  min?: Maybe<Unit_Of_Measure_Min_Fields>;
};


/** aggregate fields of "unit_of_measure" */
export type Unit_Of_Measure_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Unit_Of_Measure_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "unit_of_measure". All fields are combined with a logical 'AND'. */
export type Unit_Of_Measure_Bool_Exp = {
  _and?: InputMaybe<Array<Unit_Of_Measure_Bool_Exp>>;
  _not?: InputMaybe<Unit_Of_Measure_Bool_Exp>;
  _or?: InputMaybe<Array<Unit_Of_Measure_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  customer_order_customer_assets?: InputMaybe<Customer_Order_Customer_Asset_Bool_Exp>;
  customer_order_customer_assets_aggregate?: InputMaybe<Customer_Order_Customer_Asset_Aggregate_Bool_Exp>;
  customer_order_items?: InputMaybe<Customer_Order_Item_Bool_Exp>;
  customer_order_items_aggregate?: InputMaybe<Customer_Order_Item_Aggregate_Bool_Exp>;
  fillupRequestsByNormalizedUnit?: InputMaybe<Fillup_Request_Bool_Exp>;
  fillupRequestsByNormalizedUnit_aggregate?: InputMaybe<Fillup_Request_Aggregate_Bool_Exp>;
  fillup_requests?: InputMaybe<Fillup_Request_Bool_Exp>;
  fillup_requests_aggregate?: InputMaybe<Fillup_Request_Aggregate_Bool_Exp>;
  invoiced_items?: InputMaybe<Invoiced_Item_Bool_Exp>;
  invoiced_items_aggregate?: InputMaybe<Invoiced_Item_Aggregate_Bool_Exp>;
  meta?: InputMaybe<Unit_Of_Measure_Meta_Bool_Exp>;
  products?: InputMaybe<Product_Bool_Exp>;
  products_aggregate?: InputMaybe<Product_Aggregate_Bool_Exp>;
  task_values?: InputMaybe<Task_Value_Bool_Exp>;
  task_values_aggregate?: InputMaybe<Task_Value_Aggregate_Bool_Exp>;
  uomConversionsByToUom?: InputMaybe<Uom_Conversion_Bool_Exp>;
  uomConversionsByToUom_aggregate?: InputMaybe<Uom_Conversion_Aggregate_Bool_Exp>;
  uom_conversions?: InputMaybe<Uom_Conversion_Bool_Exp>;
  uom_conversions_aggregate?: InputMaybe<Uom_Conversion_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "unit_of_measure" */
export enum Unit_Of_Measure_Constraint {
  /** unique or primary key constraint on columns "value" */
  UnitOfMeasurePkey = 'unit_of_measure_pkey'
}

export enum Unit_Of_Measure_Enum {
  /** Imperial gallon - 4.54609 litres */
  ImperialGallon = 'IMPERIAL_GALLON',
  /** Base volumetric unit */
  Litre = 'LITRE',
  /** Standard cubic foot - 1 SCM = 35.3147 SCF */
  Scf = 'SCF',
  /** Standard cubic metre - base gas volume unit */
  Scm = 'SCM'
}

/** Boolean expression to compare columns of type "unit_of_measure_enum". All fields are combined with logical 'AND'. */
export type Unit_Of_Measure_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Unit_Of_Measure_Enum>;
  _in?: InputMaybe<Array<Unit_Of_Measure_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Unit_Of_Measure_Enum>;
  _nin?: InputMaybe<Array<Unit_Of_Measure_Enum>>;
};

/** input type for inserting data into table "unit_of_measure" */
export type Unit_Of_Measure_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  customer_order_customer_assets?: InputMaybe<Customer_Order_Customer_Asset_Arr_Rel_Insert_Input>;
  customer_order_items?: InputMaybe<Customer_Order_Item_Arr_Rel_Insert_Input>;
  fillupRequestsByNormalizedUnit?: InputMaybe<Fillup_Request_Arr_Rel_Insert_Input>;
  fillup_requests?: InputMaybe<Fillup_Request_Arr_Rel_Insert_Input>;
  invoiced_items?: InputMaybe<Invoiced_Item_Arr_Rel_Insert_Input>;
  meta?: InputMaybe<Unit_Of_Measure_Meta_Obj_Rel_Insert_Input>;
  products?: InputMaybe<Product_Arr_Rel_Insert_Input>;
  task_values?: InputMaybe<Task_Value_Arr_Rel_Insert_Input>;
  uomConversionsByToUom?: InputMaybe<Uom_Conversion_Arr_Rel_Insert_Input>;
  uom_conversions?: InputMaybe<Uom_Conversion_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Unit_Of_Measure_Max_Fields = {
  __typename?: 'unit_of_measure_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** Per-unit metadata held OUT of unit_of_measure so that table can remain a Hasura enum (is_enum requires exactly one PK plus at most one comment column). 1:1 on value. Rows are applied by ops, not seeded by a migration. */
export type Unit_Of_Measure_Meta = {
  __typename?: 'unit_of_measure_meta';
  created_at: Scalars['timestamptz']['output'];
  /** Physical dimension. Conversion is permitted only WITHIN a dimension. LIQUID_VOLUME (litre, imperial gallon) and GAS_VOLUME (SCM, SCF) are not interconvertible by a scalar factor - SCM/SCF are gas volumes at standard temperature and pressure. Future: TIME (machinery hour meters), LENGTH (odometer km). */
  dimension: Scalars['String']['output'];
  /** Soft-delete flag. Retire a unit by setting this false - never DELETE from unit_of_measure. A hard delete would force Postgres to scan every referencing table (169M rows on customer_order_customer_asset) checking foreign keys. */
  is_active: Scalars['Boolean']['output'];
  /** Exactly one unit per dimension is the base. normalized_quantity is expressed in it. */
  is_base: Scalars['Boolean']['output'];
  last_modified: Scalars['timestamptz']['output'];
  /** The user who last wrote this row, from the session via a Hasura column preset. NULL for rows seeded by ops SQL, which has no session user. */
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  unit: Unit_Of_Measure;
  /** An array relationship */
  uomConversionsByDimensionToUom: Array<Uom_Conversion>;
  /** An aggregate relationship */
  uomConversionsByDimensionToUom_aggregate: Uom_Conversion_Aggregate;
  /** An array relationship */
  uom_conversions: Array<Uom_Conversion>;
  /** An aggregate relationship */
  uom_conversions_aggregate: Uom_Conversion_Aggregate;
  value: Unit_Of_Measure_Enum;
};


/** Per-unit metadata held OUT of unit_of_measure so that table can remain a Hasura enum (is_enum requires exactly one PK plus at most one comment column). 1:1 on value. Rows are applied by ops, not seeded by a migration. */
export type Unit_Of_Measure_MetaUomConversionsByDimensionToUomArgs = {
  distinct_on?: InputMaybe<Array<Uom_Conversion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uom_Conversion_Order_By>>;
  where?: InputMaybe<Uom_Conversion_Bool_Exp>;
};


/** Per-unit metadata held OUT of unit_of_measure so that table can remain a Hasura enum (is_enum requires exactly one PK plus at most one comment column). 1:1 on value. Rows are applied by ops, not seeded by a migration. */
export type Unit_Of_Measure_MetaUomConversionsByDimensionToUom_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uom_Conversion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uom_Conversion_Order_By>>;
  where?: InputMaybe<Uom_Conversion_Bool_Exp>;
};


/** Per-unit metadata held OUT of unit_of_measure so that table can remain a Hasura enum (is_enum requires exactly one PK plus at most one comment column). 1:1 on value. Rows are applied by ops, not seeded by a migration. */
export type Unit_Of_Measure_MetaUom_ConversionsArgs = {
  distinct_on?: InputMaybe<Array<Uom_Conversion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uom_Conversion_Order_By>>;
  where?: InputMaybe<Uom_Conversion_Bool_Exp>;
};


/** Per-unit metadata held OUT of unit_of_measure so that table can remain a Hasura enum (is_enum requires exactly one PK plus at most one comment column). 1:1 on value. Rows are applied by ops, not seeded by a migration. */
export type Unit_Of_Measure_MetaUom_Conversions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uom_Conversion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uom_Conversion_Order_By>>;
  where?: InputMaybe<Uom_Conversion_Bool_Exp>;
};

/** aggregated selection of "unit_of_measure_meta" */
export type Unit_Of_Measure_Meta_Aggregate = {
  __typename?: 'unit_of_measure_meta_aggregate';
  aggregate?: Maybe<Unit_Of_Measure_Meta_Aggregate_Fields>;
  nodes: Array<Unit_Of_Measure_Meta>;
};

/** aggregate fields of "unit_of_measure_meta" */
export type Unit_Of_Measure_Meta_Aggregate_Fields = {
  __typename?: 'unit_of_measure_meta_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Unit_Of_Measure_Meta_Max_Fields>;
  min?: Maybe<Unit_Of_Measure_Meta_Min_Fields>;
};


/** aggregate fields of "unit_of_measure_meta" */
export type Unit_Of_Measure_Meta_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Unit_Of_Measure_Meta_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "unit_of_measure_meta". All fields are combined with a logical 'AND'. */
export type Unit_Of_Measure_Meta_Bool_Exp = {
  _and?: InputMaybe<Array<Unit_Of_Measure_Meta_Bool_Exp>>;
  _not?: InputMaybe<Unit_Of_Measure_Meta_Bool_Exp>;
  _or?: InputMaybe<Array<Unit_Of_Measure_Meta_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  dimension?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_base?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  unit?: InputMaybe<Unit_Of_Measure_Bool_Exp>;
  uomConversionsByDimensionToUom?: InputMaybe<Uom_Conversion_Bool_Exp>;
  uomConversionsByDimensionToUom_aggregate?: InputMaybe<Uom_Conversion_Aggregate_Bool_Exp>;
  uom_conversions?: InputMaybe<Uom_Conversion_Bool_Exp>;
  uom_conversions_aggregate?: InputMaybe<Uom_Conversion_Aggregate_Bool_Exp>;
  value?: InputMaybe<Unit_Of_Measure_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "unit_of_measure_meta" */
export enum Unit_Of_Measure_Meta_Constraint {
  /** unique or primary key constraint on columns "value" */
  UnitOfMeasureMetaPkey = 'unit_of_measure_meta_pkey',
  /** unique or primary key constraint on columns "dimension", "value" */
  UnitOfMeasureMetaValueDimensionKey = 'unit_of_measure_meta_value_dimension_key',
  /** unique or primary key constraint on columns "dimension" */
  UomMetaOneBasePerDimension = 'uom_meta_one_base_per_dimension'
}

/** input type for inserting data into table "unit_of_measure_meta" */
export type Unit_Of_Measure_Meta_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Physical dimension. Conversion is permitted only WITHIN a dimension. LIQUID_VOLUME (litre, imperial gallon) and GAS_VOLUME (SCM, SCF) are not interconvertible by a scalar factor - SCM/SCF are gas volumes at standard temperature and pressure. Future: TIME (machinery hour meters), LENGTH (odometer km). */
  dimension?: InputMaybe<Scalars['String']['input']>;
  /** Soft-delete flag. Retire a unit by setting this false - never DELETE from unit_of_measure. A hard delete would force Postgres to scan every referencing table (169M rows on customer_order_customer_asset) checking foreign keys. */
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Exactly one unit per dimension is the base. normalized_quantity is expressed in it. */
  is_base?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  /** The user who last wrote this row, from the session via a Hasura column preset. NULL for rows seeded by ops SQL, which has no session user. */
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  unit?: InputMaybe<Unit_Of_Measure_Obj_Rel_Insert_Input>;
  uomConversionsByDimensionToUom?: InputMaybe<Uom_Conversion_Arr_Rel_Insert_Input>;
  uom_conversions?: InputMaybe<Uom_Conversion_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Unit_Of_Measure_Enum>;
};

/** aggregate max on columns */
export type Unit_Of_Measure_Meta_Max_Fields = {
  __typename?: 'unit_of_measure_meta_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Physical dimension. Conversion is permitted only WITHIN a dimension. LIQUID_VOLUME (litre, imperial gallon) and GAS_VOLUME (SCM, SCF) are not interconvertible by a scalar factor - SCM/SCF are gas volumes at standard temperature and pressure. Future: TIME (machinery hour meters), LENGTH (odometer km). */
  dimension?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  /** The user who last wrote this row, from the session via a Hasura column preset. NULL for rows seeded by ops SQL, which has no session user. */
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Unit_Of_Measure_Meta_Min_Fields = {
  __typename?: 'unit_of_measure_meta_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Physical dimension. Conversion is permitted only WITHIN a dimension. LIQUID_VOLUME (litre, imperial gallon) and GAS_VOLUME (SCM, SCF) are not interconvertible by a scalar factor - SCM/SCF are gas volumes at standard temperature and pressure. Future: TIME (machinery hour meters), LENGTH (odometer km). */
  dimension?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  /** The user who last wrote this row, from the session via a Hasura column preset. NULL for rows seeded by ops SQL, which has no session user. */
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "unit_of_measure_meta" */
export type Unit_Of_Measure_Meta_Mutation_Response = {
  __typename?: 'unit_of_measure_meta_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Unit_Of_Measure_Meta>;
};

/** input type for inserting object relation for remote table "unit_of_measure_meta" */
export type Unit_Of_Measure_Meta_Obj_Rel_Insert_Input = {
  data: Unit_Of_Measure_Meta_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Unit_Of_Measure_Meta_On_Conflict>;
};

/** on_conflict condition type for table "unit_of_measure_meta" */
export type Unit_Of_Measure_Meta_On_Conflict = {
  constraint: Unit_Of_Measure_Meta_Constraint;
  update_columns?: Array<Unit_Of_Measure_Meta_Update_Column>;
  where?: InputMaybe<Unit_Of_Measure_Meta_Bool_Exp>;
};

/** Ordering options when selecting data from "unit_of_measure_meta". */
export type Unit_Of_Measure_Meta_Order_By = {
  created_at?: InputMaybe<Order_By>;
  dimension?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_base?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  unit?: InputMaybe<Unit_Of_Measure_Order_By>;
  uomConversionsByDimensionToUom_aggregate?: InputMaybe<Uom_Conversion_Aggregate_Order_By>;
  uom_conversions_aggregate?: InputMaybe<Uom_Conversion_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: unit_of_measure_meta */
export type Unit_Of_Measure_Meta_Pk_Columns_Input = {
  value: Unit_Of_Measure_Enum;
};

/** select columns of table "unit_of_measure_meta" */
export enum Unit_Of_Measure_Meta_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Dimension = 'dimension',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsBase = 'is_base',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "unit_of_measure_meta" */
export type Unit_Of_Measure_Meta_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Physical dimension. Conversion is permitted only WITHIN a dimension. LIQUID_VOLUME (litre, imperial gallon) and GAS_VOLUME (SCM, SCF) are not interconvertible by a scalar factor - SCM/SCF are gas volumes at standard temperature and pressure. Future: TIME (machinery hour meters), LENGTH (odometer km). */
  dimension?: InputMaybe<Scalars['String']['input']>;
  /** Soft-delete flag. Retire a unit by setting this false - never DELETE from unit_of_measure. A hard delete would force Postgres to scan every referencing table (169M rows on customer_order_customer_asset) checking foreign keys. */
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Exactly one unit per dimension is the base. normalized_quantity is expressed in it. */
  is_base?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  /** The user who last wrote this row, from the session via a Hasura column preset. NULL for rows seeded by ops SQL, which has no session user. */
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Unit_Of_Measure_Enum>;
};

/** Streaming cursor of the table "unit_of_measure_meta" */
export type Unit_Of_Measure_Meta_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Unit_Of_Measure_Meta_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Unit_Of_Measure_Meta_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Physical dimension. Conversion is permitted only WITHIN a dimension. LIQUID_VOLUME (litre, imperial gallon) and GAS_VOLUME (SCM, SCF) are not interconvertible by a scalar factor - SCM/SCF are gas volumes at standard temperature and pressure. Future: TIME (machinery hour meters), LENGTH (odometer km). */
  dimension?: InputMaybe<Scalars['String']['input']>;
  /** Soft-delete flag. Retire a unit by setting this false - never DELETE from unit_of_measure. A hard delete would force Postgres to scan every referencing table (169M rows on customer_order_customer_asset) checking foreign keys. */
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Exactly one unit per dimension is the base. normalized_quantity is expressed in it. */
  is_base?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  /** The user who last wrote this row, from the session via a Hasura column preset. NULL for rows seeded by ops SQL, which has no session user. */
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Unit_Of_Measure_Enum>;
};

/** update columns of table "unit_of_measure_meta" */
export enum Unit_Of_Measure_Meta_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Dimension = 'dimension',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsBase = 'is_base',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Value = 'value'
}

export type Unit_Of_Measure_Meta_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Unit_Of_Measure_Meta_Set_Input>;
  /** filter the rows which have to be updated */
  where: Unit_Of_Measure_Meta_Bool_Exp;
};

/** aggregate min on columns */
export type Unit_Of_Measure_Min_Fields = {
  __typename?: 'unit_of_measure_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "unit_of_measure" */
export type Unit_Of_Measure_Mutation_Response = {
  __typename?: 'unit_of_measure_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Unit_Of_Measure>;
};

/** input type for inserting object relation for remote table "unit_of_measure" */
export type Unit_Of_Measure_Obj_Rel_Insert_Input = {
  data: Unit_Of_Measure_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Unit_Of_Measure_On_Conflict>;
};

/** on_conflict condition type for table "unit_of_measure" */
export type Unit_Of_Measure_On_Conflict = {
  constraint: Unit_Of_Measure_Constraint;
  update_columns?: Array<Unit_Of_Measure_Update_Column>;
  where?: InputMaybe<Unit_Of_Measure_Bool_Exp>;
};

/** Ordering options when selecting data from "unit_of_measure". */
export type Unit_Of_Measure_Order_By = {
  comment?: InputMaybe<Order_By>;
  customer_order_customer_assets_aggregate?: InputMaybe<Customer_Order_Customer_Asset_Aggregate_Order_By>;
  customer_order_items_aggregate?: InputMaybe<Customer_Order_Item_Aggregate_Order_By>;
  fillupRequestsByNormalizedUnit_aggregate?: InputMaybe<Fillup_Request_Aggregate_Order_By>;
  fillup_requests_aggregate?: InputMaybe<Fillup_Request_Aggregate_Order_By>;
  invoiced_items_aggregate?: InputMaybe<Invoiced_Item_Aggregate_Order_By>;
  meta?: InputMaybe<Unit_Of_Measure_Meta_Order_By>;
  products_aggregate?: InputMaybe<Product_Aggregate_Order_By>;
  task_values_aggregate?: InputMaybe<Task_Value_Aggregate_Order_By>;
  uomConversionsByToUom_aggregate?: InputMaybe<Uom_Conversion_Aggregate_Order_By>;
  uom_conversions_aggregate?: InputMaybe<Uom_Conversion_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: unit_of_measure */
export type Unit_Of_Measure_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "unit_of_measure" */
export enum Unit_Of_Measure_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "unit_of_measure" */
export type Unit_Of_Measure_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "unit_of_measure" */
export type Unit_Of_Measure_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Unit_Of_Measure_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Unit_Of_Measure_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "unit_of_measure" */
export enum Unit_Of_Measure_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Unit_Of_Measure_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Unit_Of_Measure_Set_Input>;
  /** filter the rows which have to be updated */
  where: Unit_Of_Measure_Bool_Exp;
};

/** columns and relationships of "uom_conversion" */
export type Uom_Conversion = {
  __typename?: 'uom_conversion';
  conversion_factor: Scalars['numeric']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** Denormalised from unit_of_measure_meta so composite FKs can force both sides of a conversion into the same dimension. This is the gas-vs-liquid guard. */
  dimension: Scalars['String']['output'];
  /** An object relationship */
  fromUom?: Maybe<Unit_Of_Measure>;
  from_uom: Unit_Of_Measure_Enum;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified: Scalars['timestamptz']['output'];
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  toUom?: Maybe<Unit_Of_Measure>;
  to_uom: Unit_Of_Measure_Enum;
  /** An object relationship */
  unitOfMeasureMetumByDimensionToUom?: Maybe<Unit_Of_Measure_Meta>;
  /** An object relationship */
  unit_of_measure_metum?: Maybe<Unit_Of_Measure_Meta>;
};

/** aggregated selection of "uom_conversion" */
export type Uom_Conversion_Aggregate = {
  __typename?: 'uom_conversion_aggregate';
  aggregate?: Maybe<Uom_Conversion_Aggregate_Fields>;
  nodes: Array<Uom_Conversion>;
};

export type Uom_Conversion_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Uom_Conversion_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Uom_Conversion_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Uom_Conversion_Aggregate_Bool_Exp_Count>;
};

export type Uom_Conversion_Aggregate_Bool_Exp_Bool_And = {
  arguments: Uom_Conversion_Select_Column_Uom_Conversion_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Uom_Conversion_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Uom_Conversion_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Uom_Conversion_Select_Column_Uom_Conversion_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Uom_Conversion_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Uom_Conversion_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Uom_Conversion_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Uom_Conversion_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "uom_conversion" */
export type Uom_Conversion_Aggregate_Fields = {
  __typename?: 'uom_conversion_aggregate_fields';
  avg?: Maybe<Uom_Conversion_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uom_Conversion_Max_Fields>;
  min?: Maybe<Uom_Conversion_Min_Fields>;
  stddev?: Maybe<Uom_Conversion_Stddev_Fields>;
  stddev_pop?: Maybe<Uom_Conversion_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uom_Conversion_Stddev_Samp_Fields>;
  sum?: Maybe<Uom_Conversion_Sum_Fields>;
  var_pop?: Maybe<Uom_Conversion_Var_Pop_Fields>;
  var_samp?: Maybe<Uom_Conversion_Var_Samp_Fields>;
  variance?: Maybe<Uom_Conversion_Variance_Fields>;
};


/** aggregate fields of "uom_conversion" */
export type Uom_Conversion_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uom_Conversion_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "uom_conversion" */
export type Uom_Conversion_Aggregate_Order_By = {
  avg?: InputMaybe<Uom_Conversion_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Uom_Conversion_Max_Order_By>;
  min?: InputMaybe<Uom_Conversion_Min_Order_By>;
  stddev?: InputMaybe<Uom_Conversion_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Uom_Conversion_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Uom_Conversion_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Uom_Conversion_Sum_Order_By>;
  var_pop?: InputMaybe<Uom_Conversion_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Uom_Conversion_Var_Samp_Order_By>;
  variance?: InputMaybe<Uom_Conversion_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "uom_conversion" */
export type Uom_Conversion_Arr_Rel_Insert_Input = {
  data: Array<Uom_Conversion_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Uom_Conversion_On_Conflict>;
};

/** aggregate avg on columns */
export type Uom_Conversion_Avg_Fields = {
  __typename?: 'uom_conversion_avg_fields';
  conversion_factor?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "uom_conversion" */
export type Uom_Conversion_Avg_Order_By = {
  conversion_factor?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "uom_conversion". All fields are combined with a logical 'AND'. */
export type Uom_Conversion_Bool_Exp = {
  _and?: InputMaybe<Array<Uom_Conversion_Bool_Exp>>;
  _not?: InputMaybe<Uom_Conversion_Bool_Exp>;
  _or?: InputMaybe<Array<Uom_Conversion_Bool_Exp>>;
  conversion_factor?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  dimension?: InputMaybe<String_Comparison_Exp>;
  fromUom?: InputMaybe<Unit_Of_Measure_Bool_Exp>;
  from_uom?: InputMaybe<Unit_Of_Measure_Enum_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  toUom?: InputMaybe<Unit_Of_Measure_Bool_Exp>;
  to_uom?: InputMaybe<Unit_Of_Measure_Enum_Comparison_Exp>;
  unitOfMeasureMetumByDimensionToUom?: InputMaybe<Unit_Of_Measure_Meta_Bool_Exp>;
  unit_of_measure_metum?: InputMaybe<Unit_Of_Measure_Meta_Bool_Exp>;
};

/** unique or primary key constraints on table "uom_conversion" */
export enum Uom_Conversion_Constraint {
  /** unique or primary key constraint on columns "to_uom", "from_uom" */
  UomConversionFromToKey = 'uom_conversion_from_to_key',
  /** unique or primary key constraint on columns "id" */
  UomConversionPkey = 'uom_conversion_pkey'
}

/** input type for incrementing numeric columns in table "uom_conversion" */
export type Uom_Conversion_Inc_Input = {
  conversion_factor?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "uom_conversion" */
export type Uom_Conversion_Insert_Input = {
  conversion_factor?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Denormalised from unit_of_measure_meta so composite FKs can force both sides of a conversion into the same dimension. This is the gas-vs-liquid guard. */
  dimension?: InputMaybe<Scalars['String']['input']>;
  fromUom?: InputMaybe<Unit_Of_Measure_Obj_Rel_Insert_Input>;
  from_uom?: InputMaybe<Unit_Of_Measure_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  toUom?: InputMaybe<Unit_Of_Measure_Obj_Rel_Insert_Input>;
  to_uom?: InputMaybe<Unit_Of_Measure_Enum>;
  unitOfMeasureMetumByDimensionToUom?: InputMaybe<Unit_Of_Measure_Meta_Obj_Rel_Insert_Input>;
  unit_of_measure_metum?: InputMaybe<Unit_Of_Measure_Meta_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Uom_Conversion_Max_Fields = {
  __typename?: 'uom_conversion_max_fields';
  conversion_factor?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Denormalised from unit_of_measure_meta so composite FKs can force both sides of a conversion into the same dimension. This is the gas-vs-liquid guard. */
  dimension?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "uom_conversion" */
export type Uom_Conversion_Max_Order_By = {
  conversion_factor?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  /** Denormalised from unit_of_measure_meta so composite FKs can force both sides of a conversion into the same dimension. This is the gas-vs-liquid guard. */
  dimension?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Uom_Conversion_Min_Fields = {
  __typename?: 'uom_conversion_min_fields';
  conversion_factor?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Denormalised from unit_of_measure_meta so composite FKs can force both sides of a conversion into the same dimension. This is the gas-vs-liquid guard. */
  dimension?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "uom_conversion" */
export type Uom_Conversion_Min_Order_By = {
  conversion_factor?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  /** Denormalised from unit_of_measure_meta so composite FKs can force both sides of a conversion into the same dimension. This is the gas-vs-liquid guard. */
  dimension?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "uom_conversion" */
export type Uom_Conversion_Mutation_Response = {
  __typename?: 'uom_conversion_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uom_Conversion>;
};

/** on_conflict condition type for table "uom_conversion" */
export type Uom_Conversion_On_Conflict = {
  constraint: Uom_Conversion_Constraint;
  update_columns?: Array<Uom_Conversion_Update_Column>;
  where?: InputMaybe<Uom_Conversion_Bool_Exp>;
};

/** Ordering options when selecting data from "uom_conversion". */
export type Uom_Conversion_Order_By = {
  conversion_factor?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dimension?: InputMaybe<Order_By>;
  fromUom?: InputMaybe<Unit_Of_Measure_Order_By>;
  from_uom?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  toUom?: InputMaybe<Unit_Of_Measure_Order_By>;
  to_uom?: InputMaybe<Order_By>;
  unitOfMeasureMetumByDimensionToUom?: InputMaybe<Unit_Of_Measure_Meta_Order_By>;
  unit_of_measure_metum?: InputMaybe<Unit_Of_Measure_Meta_Order_By>;
};

/** primary key columns input for table: uom_conversion */
export type Uom_Conversion_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "uom_conversion" */
export enum Uom_Conversion_Select_Column {
  /** column name */
  ConversionFactor = 'conversion_factor',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Dimension = 'dimension',
  /** column name */
  FromUom = 'from_uom',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  ToUom = 'to_uom'
}

/** select "uom_conversion_aggregate_bool_exp_bool_and_arguments_columns" columns of table "uom_conversion" */
export enum Uom_Conversion_Select_Column_Uom_Conversion_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "uom_conversion_aggregate_bool_exp_bool_or_arguments_columns" columns of table "uom_conversion" */
export enum Uom_Conversion_Select_Column_Uom_Conversion_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "uom_conversion" */
export type Uom_Conversion_Set_Input = {
  conversion_factor?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Denormalised from unit_of_measure_meta so composite FKs can force both sides of a conversion into the same dimension. This is the gas-vs-liquid guard. */
  dimension?: InputMaybe<Scalars['String']['input']>;
  from_uom?: InputMaybe<Unit_Of_Measure_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  to_uom?: InputMaybe<Unit_Of_Measure_Enum>;
};

/** aggregate stddev on columns */
export type Uom_Conversion_Stddev_Fields = {
  __typename?: 'uom_conversion_stddev_fields';
  conversion_factor?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "uom_conversion" */
export type Uom_Conversion_Stddev_Order_By = {
  conversion_factor?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Uom_Conversion_Stddev_Pop_Fields = {
  __typename?: 'uom_conversion_stddev_pop_fields';
  conversion_factor?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "uom_conversion" */
export type Uom_Conversion_Stddev_Pop_Order_By = {
  conversion_factor?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Uom_Conversion_Stddev_Samp_Fields = {
  __typename?: 'uom_conversion_stddev_samp_fields';
  conversion_factor?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "uom_conversion" */
export type Uom_Conversion_Stddev_Samp_Order_By = {
  conversion_factor?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "uom_conversion" */
export type Uom_Conversion_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uom_Conversion_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uom_Conversion_Stream_Cursor_Value_Input = {
  conversion_factor?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Denormalised from unit_of_measure_meta so composite FKs can force both sides of a conversion into the same dimension. This is the gas-vs-liquid guard. */
  dimension?: InputMaybe<Scalars['String']['input']>;
  from_uom?: InputMaybe<Unit_Of_Measure_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  to_uom?: InputMaybe<Unit_Of_Measure_Enum>;
};

/** aggregate sum on columns */
export type Uom_Conversion_Sum_Fields = {
  __typename?: 'uom_conversion_sum_fields';
  conversion_factor?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "uom_conversion" */
export type Uom_Conversion_Sum_Order_By = {
  conversion_factor?: InputMaybe<Order_By>;
};

/** update columns of table "uom_conversion" */
export enum Uom_Conversion_Update_Column {
  /** column name */
  ConversionFactor = 'conversion_factor',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Dimension = 'dimension',
  /** column name */
  FromUom = 'from_uom',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  ToUom = 'to_uom'
}

export type Uom_Conversion_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uom_Conversion_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uom_Conversion_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uom_Conversion_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uom_Conversion_Var_Pop_Fields = {
  __typename?: 'uom_conversion_var_pop_fields';
  conversion_factor?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "uom_conversion" */
export type Uom_Conversion_Var_Pop_Order_By = {
  conversion_factor?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Uom_Conversion_Var_Samp_Fields = {
  __typename?: 'uom_conversion_var_samp_fields';
  conversion_factor?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "uom_conversion" */
export type Uom_Conversion_Var_Samp_Order_By = {
  conversion_factor?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Uom_Conversion_Variance_Fields = {
  __typename?: 'uom_conversion_variance_fields';
  conversion_factor?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "uom_conversion" */
export type Uom_Conversion_Variance_Order_By = {
  conversion_factor?: InputMaybe<Order_By>;
};

export type UpdateCustomerOrderItemInput = {
  customer_order_item_id: Scalars['uuid']['input'];
};

export type UpdateCustomerOrderItemOutput = {
  __typename?: 'updateCustomerOrderItemOutput';
  data?: Maybe<Scalars['jsonb']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type UpdateDispensedQtyInput = {
  quantity: Scalars['numeric']['input'];
  reason_id: Scalars['uuid']['input'];
  task_value_id: Scalars['uuid']['input'];
};

export type UpdateDispensedQtyOutput = {
  __typename?: 'updateDispensedQtyOutput';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type UpdateDispensingDateInput = {
  end_date?: InputMaybe<Scalars['date']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
};

export type UpdateDispensingDateOutput = {
  __typename?: 'updateDispensingDateOutput';
  error?: Maybe<Scalars['String']['output']>;
  failed?: Maybe<Scalars['jsonb']['output']>;
  failed_count?: Maybe<Scalars['numeric']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success_count?: Maybe<Scalars['numeric']['output']>;
};

export type UpdateInvoiceInput = {
  inovice_item_id?: InputMaybe<Scalars['uuid']['input']>;
  invoice_id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateInvoiceOutput = {
  __typename?: 'updateInvoiceOutput';
  data?: Maybe<Scalars['jsonb']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type UpdateOdometerReadingInput = {
  task_value_id: Scalars['uuid']['input'];
  value: Scalars['String']['input'];
};

export type UpdateOdometerReadingOutput = {
  __typename?: 'updateOdometerReadingOutput';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type UpdateOrderDateByOrderCodeInput = {
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  invoice_date?: InputMaybe<Scalars['timestamptz']['input']>;
  order_code?: InputMaybe<Scalars['bigint']['input']>;
  order_date_slot?: InputMaybe<Scalars['date']['input']>;
  selected_date?: InputMaybe<Scalars['timestamp']['input']>;
};

export type UpdateOrderDateByOrderCodeOutput = {
  __typename?: 'updateOrderDateByOrderCodeOutput';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type UpdateOrderItemToAcceptedInput = {
  orderItemId?: InputMaybe<Scalars['uuid']['input']>;
  partnerId?: InputMaybe<Scalars['uuid']['input']>;
};

export type UpdateOrderItemToAcceptedOutput = {
  __typename?: 'updateOrderItemToAcceptedOutput';
  orderItemId?: Maybe<Scalars['uuid']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type UpdateOrderStateByOrderCodeInput = {
  order_code?: InputMaybe<Scalars['bigint']['input']>;
};

export type UpdateOrderStateByOrderCodeOutput = {
  __typename?: 'updateOrderStateByOrderCodeOutput';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type UpdateProductPartnerLocalitiesPriceInput = {
  buy_price?: InputMaybe<Scalars['numeric']['input']>;
  created_by: Scalars['uuid']['input'];
  product_partner_localities_price_ids?: InputMaybe<Array<Scalars['uuid']['input']>>;
  sale_price: Scalars['numeric']['input'];
  valid_from: Scalars['timestamp']['input'];
  valid_to: Scalars['timestamp']['input'];
};

export type UpdateProductPartnerLocalitiesPriceOutput = {
  __typename?: 'updateProductPartnerLocalitiesPriceOutput';
  data?: Maybe<Scalars['jsonb']['output']>;
};

export type UpdateTaskInput = {
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
  task_value_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type UpdateTaskOutput = {
  __typename?: 'updateTaskOutput';
  data?: Maybe<Scalars['jsonb']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type UpdateWalletAmountInput = {
  amount: Scalars['numeric']['input'];
  approved_by?: InputMaybe<Scalars['uuid']['input']>;
  currency_id?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organization_id: Scalars['uuid']['input'];
  posting_date?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWalletAmountOutput = {
  __typename?: 'updateWalletAmountOutput';
  amount?: Maybe<Scalars['numeric']['output']>;
  currency_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  wallet_ledger_id?: Maybe<Scalars['uuid']['output']>;
};

export type UploadFuelTransTxnLogsExcelInput = {
  customer_order_id: Scalars['uuid']['input'];
  dispensing_logs: Array<InputMaybe<FuelTransLog>>;
};

export type UploadFuelTransTxnLogsExcelOutput = {
  __typename?: 'uploadFuelTransTxnLogsExcelOutput';
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type UpsertCustomerAssetEtInput = {
  capacity?: InputMaybe<Scalars['Int']['input']>;
  card_number?: InputMaybe<Scalars['String']['input']>;
  chassis_number?: InputMaybe<Scalars['String']['input']>;
  department_name?: InputMaybe<Scalars['String']['input']>;
  emirate?: InputMaybe<Scalars['String']['input']>;
  et_internal_number?: InputMaybe<Scalars['String']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  plate_code?: InputMaybe<Scalars['String']['input']>;
  plate_number?: InputMaybe<Scalars['String']['input']>;
  request_type?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertCustomerAssetEtOutput = {
  __typename?: 'upsertCustomerAssetETOutput';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['jsonb']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

/** columns and relationships of "user" */
export type User = {
  __typename?: 'user';
  code?: Maybe<Scalars['bigint']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  customer_asset_audit_logs: Array<Customer_Asset_Audit_Log>;
  /** An aggregate relationship */
  customer_asset_audit_logs_aggregate: Customer_Asset_Audit_Log_Aggregate;
  customer_code: Scalars['bigint']['output'];
  /** An object relationship */
  customer_segmentation?: Maybe<Customer_Segmentation>;
  customer_segmentation_id?: Maybe<Scalars['uuid']['output']>;
  delivery_otp: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  driver_code?: Maybe<Scalars['bigint']['output']>;
  /** An array relationship */
  driver_permits: Array<Driver_Permit>;
  /** An aggregate relationship */
  driver_permits_aggregate: Driver_Permit_Aggregate;
  /** An array relationship */
  driver_vehicles: Array<Driver_Vehicle>;
  /** An aggregate relationship */
  driver_vehicles_aggregate: Driver_Vehicle_Aggregate;
  email?: Maybe<Scalars['String']['output']>;
  erp_code?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  fillupRequestsByDriverId: Array<Fillup_Request>;
  /** An aggregate relationship */
  fillupRequestsByDriverId_aggregate: Fillup_Request_Aggregate;
  /** An array relationship */
  fillup_requests: Array<Fillup_Request>;
  /** An aggregate relationship */
  fillup_requests_aggregate: Fillup_Request_Aggregate;
  first_name?: Maybe<Scalars['String']['output']>;
  google_firebase_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  invoicedItemCancellationTicketsByCreatedBy: Array<Invoiced_Item_Cancellation_Tickets>;
  /** An aggregate relationship */
  invoicedItemCancellationTicketsByCreatedBy_aggregate: Invoiced_Item_Cancellation_Tickets_Aggregate;
  /** An array relationship */
  invoicedItemCancellationTicketsByLastModifiedBy: Array<Invoiced_Item_Cancellation_Tickets>;
  /** An aggregate relationship */
  invoicedItemCancellationTicketsByLastModifiedBy_aggregate: Invoiced_Item_Cancellation_Tickets_Aggregate;
  /** An array relationship */
  invoiced_item_cancellation_tickets: Array<Invoiced_Item_Cancellation_Tickets>;
  /** An aggregate relationship */
  invoiced_item_cancellation_tickets_aggregate: Invoiced_Item_Cancellation_Tickets_Aggregate;
  is_active: Scalars['Boolean']['output'];
  is_test?: Maybe<Scalars['Boolean']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  license_number?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  lpoExceptionsByLastModifiedBy: Array<Lpo_Exception>;
  /** An aggregate relationship */
  lpoExceptionsByLastModifiedBy_aggregate: Lpo_Exception_Aggregate;
  /** An array relationship */
  lpo_exceptions: Array<Lpo_Exception>;
  /** An aggregate relationship */
  lpo_exceptions_aggregate: Lpo_Exception_Aggregate;
  /** An array relationship */
  masterSlotPausesByLastModifiedBy: Array<Master_Slot_Pause>;
  /** An aggregate relationship */
  masterSlotPausesByLastModifiedBy_aggregate: Master_Slot_Pause_Aggregate;
  /** An array relationship */
  masterSlotsByLastModifiedBy: Array<Master_Slot>;
  /** An aggregate relationship */
  masterSlotsByLastModifiedBy_aggregate: Master_Slot_Aggregate;
  /** An array relationship */
  masterSlotsByReviewedBy: Array<Master_Slot>;
  /** An aggregate relationship */
  masterSlotsByReviewedBy_aggregate: Master_Slot_Aggregate;
  /** An array relationship */
  master_slot_pauses: Array<Master_Slot_Pause>;
  /** An aggregate relationship */
  master_slot_pauses_aggregate: Master_Slot_Pause_Aggregate;
  /** An array relationship */
  master_slots: Array<Master_Slot>;
  /** An aggregate relationship */
  master_slots_aggregate: Master_Slot_Aggregate;
  middle_name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  organization_audit_logs: Array<Organization_Audit_Log>;
  /** An aggregate relationship */
  organization_audit_logs_aggregate: Organization_Audit_Log_Aggregate;
  /** An array relationship */
  organization_user_commissions: Array<Organization_User_Commission>;
  /** An aggregate relationship */
  organization_user_commissions_aggregate: Organization_User_Commission_Aggregate;
  /** An array relationship */
  organization_users: Array<Organization_User>;
  /** An aggregate relationship */
  organization_users_aggregate: Organization_User_Aggregate;
  pan_number?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  partnerOrdersByCreatedBy: Array<Partner_Order>;
  /** An aggregate relationship */
  partnerOrdersByCreatedBy_aggregate: Partner_Order_Aggregate;
  /** An array relationship */
  partner_addresses: Array<Partner_Address>;
  /** An aggregate relationship */
  partner_addresses_aggregate: Partner_Address_Aggregate;
  /** An array relationship */
  partner_commissions: Array<Partner_Commission>;
  /** An aggregate relationship */
  partner_commissions_aggregate: Partner_Commission_Aggregate;
  /** An array relationship */
  partner_orders: Array<Partner_Order>;
  /** An aggregate relationship */
  partner_orders_aggregate: Partner_Order_Aggregate;
  /** An array relationship */
  partner_users: Array<Partner_User>;
  /** An aggregate relationship */
  partner_users_aggregate: Partner_User_Aggregate;
  phone_number?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  planningPeriodsByCreatedBy: Array<Planning_Period>;
  /** An aggregate relationship */
  planningPeriodsByCreatedBy_aggregate: Planning_Period_Aggregate;
  /** An array relationship */
  planning_audit_logs: Array<Planning_Audit_Log>;
  /** An aggregate relationship */
  planning_audit_logs_aggregate: Planning_Audit_Log_Aggregate;
  /** An array relationship */
  planning_periods: Array<Planning_Period>;
  /** An aggregate relationship */
  planning_periods_aggregate: Planning_Period_Aggregate;
  profile_pic?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  quantity_correction_tickets: Array<Quantity_Correction_Tickets>;
  /** An aggregate relationship */
  quantity_correction_tickets_aggregate: Quantity_Correction_Tickets_Aggregate;
  referral_code?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  shiftScheduleDispensersByCreatedBy: Array<Shift_Schedule_Dispenser>;
  /** An aggregate relationship */
  shiftScheduleDispensersByCreatedBy_aggregate: Shift_Schedule_Dispenser_Aggregate;
  /** An array relationship */
  shiftSchedulesByApprovedBy: Array<Shift_Schedule>;
  /** An aggregate relationship */
  shiftSchedulesByApprovedBy_aggregate: Shift_Schedule_Aggregate;
  /** An array relationship */
  shiftTemplatesByLastModifiedBy: Array<Shift_Template>;
  /** An aggregate relationship */
  shiftTemplatesByLastModifiedBy_aggregate: Shift_Template_Aggregate;
  /** An array relationship */
  shift_schedule_dispensers: Array<Shift_Schedule_Dispenser>;
  /** An aggregate relationship */
  shift_schedule_dispensers_aggregate: Shift_Schedule_Dispenser_Aggregate;
  /** An array relationship */
  shift_schedules: Array<Shift_Schedule>;
  /** An aggregate relationship */
  shift_schedules_aggregate: Shift_Schedule_Aggregate;
  /** An array relationship */
  shift_templates: Array<Shift_Template>;
  /** An aggregate relationship */
  shift_templates_aggregate: Shift_Template_Aggregate;
  /** An array relationship */
  taskStatesFlowsByPreviousDriverId: Array<Task_States_Flow>;
  /** An aggregate relationship */
  taskStatesFlowsByPreviousDriverId_aggregate: Task_States_Flow_Aggregate;
  /** An array relationship */
  tasks: Array<Task>;
  /** An array relationship */
  tasksByDriverId: Array<Task>;
  /** An aggregate relationship */
  tasksByDriverId_aggregate: Task_Aggregate;
  /** An aggregate relationship */
  tasks_aggregate: Task_Aggregate;
  time_zone?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  totalizerCorrectionTicketsByCreatedBy: Array<Totalizer_Correction_Tickets>;
  /** An aggregate relationship */
  totalizerCorrectionTicketsByCreatedBy_aggregate: Totalizer_Correction_Tickets_Aggregate;
  /** An array relationship */
  totalizerCorrectionTicketsByLastModifiedBy: Array<Totalizer_Correction_Tickets>;
  /** An aggregate relationship */
  totalizerCorrectionTicketsByLastModifiedBy_aggregate: Totalizer_Correction_Tickets_Aggregate;
  /** An array relationship */
  totalizer_correction_tickets: Array<Totalizer_Correction_Tickets>;
  /** An aggregate relationship */
  totalizer_correction_tickets_aggregate: Totalizer_Correction_Tickets_Aggregate;
  /** An array relationship */
  trip_plans: Array<Trip_Plan>;
  /** An aggregate relationship */
  trip_plans_aggregate: Trip_Plan_Aggregate;
  /** An array relationship */
  userAccessAuditLogsByUserId: Array<User_Access_Audit_Log>;
  /** An aggregate relationship */
  userAccessAuditLogsByUserId_aggregate: User_Access_Audit_Log_Aggregate;
  /** An array relationship */
  userReferralsByUserId: Array<User_Referral>;
  /** An aggregate relationship */
  userReferralsByUserId_aggregate: User_Referral_Aggregate;
  /** An array relationship */
  user_access_audit_logs: Array<User_Access_Audit_Log>;
  /** An aggregate relationship */
  user_access_audit_logs_aggregate: User_Access_Audit_Log_Aggregate;
  /** An array relationship */
  user_referrals: Array<User_Referral>;
  /** An aggregate relationship */
  user_referrals_aggregate: User_Referral_Aggregate;
  /** An array relationship */
  user_roles: Array<User_Role>;
  /** An aggregate relationship */
  user_roles_aggregate: User_Role_Aggregate;
  /** An array relationship */
  vehicleShiftTemplatesByCreatedBy: Array<Vehicle_Shift_Template>;
  /** An aggregate relationship */
  vehicleShiftTemplatesByCreatedBy_aggregate: Vehicle_Shift_Template_Aggregate;
  /** An array relationship */
  vendorOrderLogsByDriverId: Array<Vendor_Order_Logs>;
  /** An aggregate relationship */
  vendorOrderLogsByDriverId_aggregate: Vendor_Order_Logs_Aggregate;
  /** An array relationship */
  vendorOrderLogsByLastModifiedBy: Array<Vendor_Order_Logs>;
  /** An aggregate relationship */
  vendorOrderLogsByLastModifiedBy_aggregate: Vendor_Order_Logs_Aggregate;
  /** An array relationship */
  vendor_order_logs: Array<Vendor_Order_Logs>;
  /** An aggregate relationship */
  vendor_order_logs_aggregate: Vendor_Order_Logs_Aggregate;
  verified_at?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  wallet_exceptions: Array<Wallet_Exception>;
  /** An aggregate relationship */
  wallet_exceptions_aggregate: Wallet_Exception_Aggregate;
  /** An array relationship */
  wallet_ledgers: Array<Wallet_Ledger>;
  /** An aggregate relationship */
  wallet_ledgers_aggregate: Wallet_Ledger_Aggregate;
};


/** columns and relationships of "user" */
export type UserCustomer_Asset_Audit_LogsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Audit_Log_Order_By>>;
  where?: InputMaybe<Customer_Asset_Audit_Log_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserCustomer_Asset_Audit_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Asset_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Asset_Audit_Log_Order_By>>;
  where?: InputMaybe<Customer_Asset_Audit_Log_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserDriver_PermitsArgs = {
  distinct_on?: InputMaybe<Array<Driver_Permit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Permit_Order_By>>;
  where?: InputMaybe<Driver_Permit_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserDriver_Permits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Driver_Permit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Permit_Order_By>>;
  where?: InputMaybe<Driver_Permit_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserDriver_VehiclesArgs = {
  distinct_on?: InputMaybe<Array<Driver_Vehicle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Vehicle_Order_By>>;
  where?: InputMaybe<Driver_Vehicle_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserDriver_Vehicles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Driver_Vehicle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Vehicle_Order_By>>;
  where?: InputMaybe<Driver_Vehicle_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserFillupRequestsByDriverIdArgs = {
  distinct_on?: InputMaybe<Array<Fillup_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fillup_Request_Order_By>>;
  where?: InputMaybe<Fillup_Request_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserFillupRequestsByDriverId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fillup_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fillup_Request_Order_By>>;
  where?: InputMaybe<Fillup_Request_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserFillup_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Fillup_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fillup_Request_Order_By>>;
  where?: InputMaybe<Fillup_Request_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserFillup_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fillup_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fillup_Request_Order_By>>;
  where?: InputMaybe<Fillup_Request_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserInvoicedItemCancellationTicketsByCreatedByArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Cancellation_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Cancellation_Tickets_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserInvoicedItemCancellationTicketsByCreatedBy_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Cancellation_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Cancellation_Tickets_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserInvoicedItemCancellationTicketsByLastModifiedByArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Cancellation_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Cancellation_Tickets_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserInvoicedItemCancellationTicketsByLastModifiedBy_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Cancellation_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Cancellation_Tickets_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserInvoiced_Item_Cancellation_TicketsArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Cancellation_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Cancellation_Tickets_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserInvoiced_Item_Cancellation_Tickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Cancellation_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Cancellation_Tickets_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserLpoExceptionsByLastModifiedByArgs = {
  distinct_on?: InputMaybe<Array<Lpo_Exception_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lpo_Exception_Order_By>>;
  where?: InputMaybe<Lpo_Exception_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserLpoExceptionsByLastModifiedBy_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lpo_Exception_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lpo_Exception_Order_By>>;
  where?: InputMaybe<Lpo_Exception_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserLpo_ExceptionsArgs = {
  distinct_on?: InputMaybe<Array<Lpo_Exception_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lpo_Exception_Order_By>>;
  where?: InputMaybe<Lpo_Exception_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserLpo_Exceptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lpo_Exception_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lpo_Exception_Order_By>>;
  where?: InputMaybe<Lpo_Exception_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserMasterSlotPausesByLastModifiedByArgs = {
  distinct_on?: InputMaybe<Array<Master_Slot_Pause_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Slot_Pause_Order_By>>;
  where?: InputMaybe<Master_Slot_Pause_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserMasterSlotPausesByLastModifiedBy_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Master_Slot_Pause_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Slot_Pause_Order_By>>;
  where?: InputMaybe<Master_Slot_Pause_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserMasterSlotsByLastModifiedByArgs = {
  distinct_on?: InputMaybe<Array<Master_Slot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Slot_Order_By>>;
  where?: InputMaybe<Master_Slot_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserMasterSlotsByLastModifiedBy_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Master_Slot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Slot_Order_By>>;
  where?: InputMaybe<Master_Slot_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserMasterSlotsByReviewedByArgs = {
  distinct_on?: InputMaybe<Array<Master_Slot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Slot_Order_By>>;
  where?: InputMaybe<Master_Slot_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserMasterSlotsByReviewedBy_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Master_Slot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Slot_Order_By>>;
  where?: InputMaybe<Master_Slot_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserMaster_Slot_PausesArgs = {
  distinct_on?: InputMaybe<Array<Master_Slot_Pause_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Slot_Pause_Order_By>>;
  where?: InputMaybe<Master_Slot_Pause_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserMaster_Slot_Pauses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Master_Slot_Pause_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Slot_Pause_Order_By>>;
  where?: InputMaybe<Master_Slot_Pause_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserMaster_SlotsArgs = {
  distinct_on?: InputMaybe<Array<Master_Slot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Slot_Order_By>>;
  where?: InputMaybe<Master_Slot_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserMaster_Slots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Master_Slot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Slot_Order_By>>;
  where?: InputMaybe<Master_Slot_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserOrganization_Audit_LogsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Audit_Log_Order_By>>;
  where?: InputMaybe<Organization_Audit_Log_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserOrganization_Audit_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Audit_Log_Order_By>>;
  where?: InputMaybe<Organization_Audit_Log_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserOrganization_User_CommissionsArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Commission_Order_By>>;
  where?: InputMaybe<Organization_User_Commission_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserOrganization_User_Commissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Commission_Order_By>>;
  where?: InputMaybe<Organization_User_Commission_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserOrganization_UsersArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Order_By>>;
  where?: InputMaybe<Organization_User_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserOrganization_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_User_Order_By>>;
  where?: InputMaybe<Organization_User_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserPartnerOrdersByCreatedByArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Order_By>>;
  where?: InputMaybe<Partner_Order_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserPartnerOrdersByCreatedBy_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Order_By>>;
  where?: InputMaybe<Partner_Order_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserPartner_AddressesArgs = {
  distinct_on?: InputMaybe<Array<Partner_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Address_Order_By>>;
  where?: InputMaybe<Partner_Address_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserPartner_Addresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Address_Order_By>>;
  where?: InputMaybe<Partner_Address_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserPartner_CommissionsArgs = {
  distinct_on?: InputMaybe<Array<Partner_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Commission_Order_By>>;
  where?: InputMaybe<Partner_Commission_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserPartner_Commissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Commission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Commission_Order_By>>;
  where?: InputMaybe<Partner_Commission_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserPartner_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Order_By>>;
  where?: InputMaybe<Partner_Order_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserPartner_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Order_By>>;
  where?: InputMaybe<Partner_Order_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserPartner_UsersArgs = {
  distinct_on?: InputMaybe<Array<Partner_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_User_Order_By>>;
  where?: InputMaybe<Partner_User_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserPartner_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_User_Order_By>>;
  where?: InputMaybe<Partner_User_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserPlanningPeriodsByCreatedByArgs = {
  distinct_on?: InputMaybe<Array<Planning_Period_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Planning_Period_Order_By>>;
  where?: InputMaybe<Planning_Period_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserPlanningPeriodsByCreatedBy_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Planning_Period_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Planning_Period_Order_By>>;
  where?: InputMaybe<Planning_Period_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserPlanning_Audit_LogsArgs = {
  distinct_on?: InputMaybe<Array<Planning_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Planning_Audit_Log_Order_By>>;
  where?: InputMaybe<Planning_Audit_Log_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserPlanning_Audit_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Planning_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Planning_Audit_Log_Order_By>>;
  where?: InputMaybe<Planning_Audit_Log_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserPlanning_PeriodsArgs = {
  distinct_on?: InputMaybe<Array<Planning_Period_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Planning_Period_Order_By>>;
  where?: InputMaybe<Planning_Period_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserPlanning_Periods_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Planning_Period_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Planning_Period_Order_By>>;
  where?: InputMaybe<Planning_Period_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserQuantity_Correction_TicketsArgs = {
  distinct_on?: InputMaybe<Array<Quantity_Correction_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quantity_Correction_Tickets_Order_By>>;
  where?: InputMaybe<Quantity_Correction_Tickets_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserQuantity_Correction_Tickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quantity_Correction_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quantity_Correction_Tickets_Order_By>>;
  where?: InputMaybe<Quantity_Correction_Tickets_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserShiftScheduleDispensersByCreatedByArgs = {
  distinct_on?: InputMaybe<Array<Shift_Schedule_Dispenser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shift_Schedule_Dispenser_Order_By>>;
  where?: InputMaybe<Shift_Schedule_Dispenser_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserShiftScheduleDispensersByCreatedBy_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shift_Schedule_Dispenser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shift_Schedule_Dispenser_Order_By>>;
  where?: InputMaybe<Shift_Schedule_Dispenser_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserShiftSchedulesByApprovedByArgs = {
  distinct_on?: InputMaybe<Array<Shift_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shift_Schedule_Order_By>>;
  where?: InputMaybe<Shift_Schedule_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserShiftSchedulesByApprovedBy_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shift_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shift_Schedule_Order_By>>;
  where?: InputMaybe<Shift_Schedule_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserShiftTemplatesByLastModifiedByArgs = {
  distinct_on?: InputMaybe<Array<Shift_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shift_Template_Order_By>>;
  where?: InputMaybe<Shift_Template_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserShiftTemplatesByLastModifiedBy_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shift_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shift_Template_Order_By>>;
  where?: InputMaybe<Shift_Template_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserShift_Schedule_DispensersArgs = {
  distinct_on?: InputMaybe<Array<Shift_Schedule_Dispenser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shift_Schedule_Dispenser_Order_By>>;
  where?: InputMaybe<Shift_Schedule_Dispenser_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserShift_Schedule_Dispensers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shift_Schedule_Dispenser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shift_Schedule_Dispenser_Order_By>>;
  where?: InputMaybe<Shift_Schedule_Dispenser_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserShift_SchedulesArgs = {
  distinct_on?: InputMaybe<Array<Shift_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shift_Schedule_Order_By>>;
  where?: InputMaybe<Shift_Schedule_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserShift_Schedules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shift_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shift_Schedule_Order_By>>;
  where?: InputMaybe<Shift_Schedule_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserShift_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Shift_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shift_Template_Order_By>>;
  where?: InputMaybe<Shift_Template_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserShift_Templates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shift_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shift_Template_Order_By>>;
  where?: InputMaybe<Shift_Template_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserTaskStatesFlowsByPreviousDriverIdArgs = {
  distinct_on?: InputMaybe<Array<Task_States_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_States_Flow_Order_By>>;
  where?: InputMaybe<Task_States_Flow_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserTaskStatesFlowsByPreviousDriverId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_States_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_States_Flow_Order_By>>;
  where?: InputMaybe<Task_States_Flow_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserTasksArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserTasksByDriverIdArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserTasksByDriverId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserTasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserTotalizerCorrectionTicketsByCreatedByArgs = {
  distinct_on?: InputMaybe<Array<Totalizer_Correction_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Totalizer_Correction_Tickets_Order_By>>;
  where?: InputMaybe<Totalizer_Correction_Tickets_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserTotalizerCorrectionTicketsByCreatedBy_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Totalizer_Correction_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Totalizer_Correction_Tickets_Order_By>>;
  where?: InputMaybe<Totalizer_Correction_Tickets_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserTotalizerCorrectionTicketsByLastModifiedByArgs = {
  distinct_on?: InputMaybe<Array<Totalizer_Correction_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Totalizer_Correction_Tickets_Order_By>>;
  where?: InputMaybe<Totalizer_Correction_Tickets_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserTotalizerCorrectionTicketsByLastModifiedBy_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Totalizer_Correction_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Totalizer_Correction_Tickets_Order_By>>;
  where?: InputMaybe<Totalizer_Correction_Tickets_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserTotalizer_Correction_TicketsArgs = {
  distinct_on?: InputMaybe<Array<Totalizer_Correction_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Totalizer_Correction_Tickets_Order_By>>;
  where?: InputMaybe<Totalizer_Correction_Tickets_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserTotalizer_Correction_Tickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Totalizer_Correction_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Totalizer_Correction_Tickets_Order_By>>;
  where?: InputMaybe<Totalizer_Correction_Tickets_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserTrip_PlansArgs = {
  distinct_on?: InputMaybe<Array<Trip_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trip_Plan_Order_By>>;
  where?: InputMaybe<Trip_Plan_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserTrip_Plans_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trip_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trip_Plan_Order_By>>;
  where?: InputMaybe<Trip_Plan_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUserAccessAuditLogsByUserIdArgs = {
  distinct_on?: InputMaybe<Array<User_Access_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Access_Audit_Log_Order_By>>;
  where?: InputMaybe<User_Access_Audit_Log_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUserAccessAuditLogsByUserId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Access_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Access_Audit_Log_Order_By>>;
  where?: InputMaybe<User_Access_Audit_Log_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUserReferralsByUserIdArgs = {
  distinct_on?: InputMaybe<Array<User_Referral_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Referral_Order_By>>;
  where?: InputMaybe<User_Referral_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUserReferralsByUserId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Referral_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Referral_Order_By>>;
  where?: InputMaybe<User_Referral_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_Access_Audit_LogsArgs = {
  distinct_on?: InputMaybe<Array<User_Access_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Access_Audit_Log_Order_By>>;
  where?: InputMaybe<User_Access_Audit_Log_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_Access_Audit_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Access_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Access_Audit_Log_Order_By>>;
  where?: InputMaybe<User_Access_Audit_Log_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_ReferralsArgs = {
  distinct_on?: InputMaybe<Array<User_Referral_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Referral_Order_By>>;
  where?: InputMaybe<User_Referral_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_Referrals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Referral_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Referral_Order_By>>;
  where?: InputMaybe<User_Referral_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_RolesArgs = {
  distinct_on?: InputMaybe<Array<User_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Role_Order_By>>;
  where?: InputMaybe<User_Role_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Role_Order_By>>;
  where?: InputMaybe<User_Role_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserVehicleShiftTemplatesByCreatedByArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Shift_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Shift_Template_Order_By>>;
  where?: InputMaybe<Vehicle_Shift_Template_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserVehicleShiftTemplatesByCreatedBy_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Shift_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Shift_Template_Order_By>>;
  where?: InputMaybe<Vehicle_Shift_Template_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserVendorOrderLogsByDriverIdArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Order_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Order_Logs_Order_By>>;
  where?: InputMaybe<Vendor_Order_Logs_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserVendorOrderLogsByDriverId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Order_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Order_Logs_Order_By>>;
  where?: InputMaybe<Vendor_Order_Logs_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserVendorOrderLogsByLastModifiedByArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Order_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Order_Logs_Order_By>>;
  where?: InputMaybe<Vendor_Order_Logs_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserVendorOrderLogsByLastModifiedBy_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Order_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Order_Logs_Order_By>>;
  where?: InputMaybe<Vendor_Order_Logs_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserVendor_Order_LogsArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Order_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Order_Logs_Order_By>>;
  where?: InputMaybe<Vendor_Order_Logs_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserVendor_Order_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Order_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Order_Logs_Order_By>>;
  where?: InputMaybe<Vendor_Order_Logs_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserWallet_ExceptionsArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Exception_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Exception_Order_By>>;
  where?: InputMaybe<Wallet_Exception_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserWallet_Exceptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Exception_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Exception_Order_By>>;
  where?: InputMaybe<Wallet_Exception_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserWallet_LedgersArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Ledger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Ledger_Order_By>>;
  where?: InputMaybe<Wallet_Ledger_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserWallet_Ledgers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Ledger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Ledger_Order_By>>;
  where?: InputMaybe<Wallet_Ledger_Bool_Exp>;
};

/** columns and relationships of "user_access_audit_log" */
export type User_Access_Audit_Log = {
  __typename?: 'user_access_audit_log';
  action: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  new_status: Scalars['Boolean']['output'];
  performed_by: Scalars['uuid']['output'];
  /** An object relationship */
  performer?: Maybe<User>;
  previous_status: Scalars['Boolean']['output'];
  reason: Scalars['String']['output'];
  /** An object relationship */
  user: User;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "user_access_audit_log" */
export type User_Access_Audit_Log_Aggregate = {
  __typename?: 'user_access_audit_log_aggregate';
  aggregate?: Maybe<User_Access_Audit_Log_Aggregate_Fields>;
  nodes: Array<User_Access_Audit_Log>;
};

export type User_Access_Audit_Log_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<User_Access_Audit_Log_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Access_Audit_Log_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<User_Access_Audit_Log_Aggregate_Bool_Exp_Count>;
};

export type User_Access_Audit_Log_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Access_Audit_Log_Select_Column_User_Access_Audit_Log_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Access_Audit_Log_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Access_Audit_Log_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Access_Audit_Log_Select_Column_User_Access_Audit_Log_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Access_Audit_Log_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Access_Audit_Log_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Access_Audit_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Access_Audit_Log_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_access_audit_log" */
export type User_Access_Audit_Log_Aggregate_Fields = {
  __typename?: 'user_access_audit_log_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_Access_Audit_Log_Max_Fields>;
  min?: Maybe<User_Access_Audit_Log_Min_Fields>;
};


/** aggregate fields of "user_access_audit_log" */
export type User_Access_Audit_Log_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Access_Audit_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_access_audit_log" */
export type User_Access_Audit_Log_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Access_Audit_Log_Max_Order_By>;
  min?: InputMaybe<User_Access_Audit_Log_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_access_audit_log" */
export type User_Access_Audit_Log_Arr_Rel_Insert_Input = {
  data: Array<User_Access_Audit_Log_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Access_Audit_Log_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user_access_audit_log". All fields are combined with a logical 'AND'. */
export type User_Access_Audit_Log_Bool_Exp = {
  _and?: InputMaybe<Array<User_Access_Audit_Log_Bool_Exp>>;
  _not?: InputMaybe<User_Access_Audit_Log_Bool_Exp>;
  _or?: InputMaybe<Array<User_Access_Audit_Log_Bool_Exp>>;
  action?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  new_status?: InputMaybe<Boolean_Comparison_Exp>;
  performed_by?: InputMaybe<Uuid_Comparison_Exp>;
  performer?: InputMaybe<User_Bool_Exp>;
  previous_status?: InputMaybe<Boolean_Comparison_Exp>;
  reason?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_access_audit_log" */
export enum User_Access_Audit_Log_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserAccessAuditLogPkey = 'user_access_audit_log_pkey'
}

/** input type for inserting data into table "user_access_audit_log" */
export type User_Access_Audit_Log_Insert_Input = {
  action?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  new_status?: InputMaybe<Scalars['Boolean']['input']>;
  performed_by?: InputMaybe<Scalars['uuid']['input']>;
  performer?: InputMaybe<User_Obj_Rel_Insert_Input>;
  previous_status?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type User_Access_Audit_Log_Max_Fields = {
  __typename?: 'user_access_audit_log_max_fields';
  action?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  performed_by?: Maybe<Scalars['uuid']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "user_access_audit_log" */
export type User_Access_Audit_Log_Max_Order_By = {
  action?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  performed_by?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Access_Audit_Log_Min_Fields = {
  __typename?: 'user_access_audit_log_min_fields';
  action?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  performed_by?: Maybe<Scalars['uuid']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "user_access_audit_log" */
export type User_Access_Audit_Log_Min_Order_By = {
  action?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  performed_by?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_access_audit_log" */
export type User_Access_Audit_Log_Mutation_Response = {
  __typename?: 'user_access_audit_log_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Access_Audit_Log>;
};

/** on_conflict condition type for table "user_access_audit_log" */
export type User_Access_Audit_Log_On_Conflict = {
  constraint: User_Access_Audit_Log_Constraint;
  update_columns?: Array<User_Access_Audit_Log_Update_Column>;
  where?: InputMaybe<User_Access_Audit_Log_Bool_Exp>;
};

/** Ordering options when selecting data from "user_access_audit_log". */
export type User_Access_Audit_Log_Order_By = {
  action?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  new_status?: InputMaybe<Order_By>;
  performed_by?: InputMaybe<Order_By>;
  performer?: InputMaybe<User_Order_By>;
  previous_status?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_access_audit_log */
export type User_Access_Audit_Log_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_access_audit_log" */
export enum User_Access_Audit_Log_Select_Column {
  /** column name */
  Action = 'action',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  NewStatus = 'new_status',
  /** column name */
  PerformedBy = 'performed_by',
  /** column name */
  PreviousStatus = 'previous_status',
  /** column name */
  Reason = 'reason',
  /** column name */
  UserId = 'user_id'
}

/** select "user_access_audit_log_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_access_audit_log" */
export enum User_Access_Audit_Log_Select_Column_User_Access_Audit_Log_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  NewStatus = 'new_status',
  /** column name */
  PreviousStatus = 'previous_status'
}

/** select "user_access_audit_log_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_access_audit_log" */
export enum User_Access_Audit_Log_Select_Column_User_Access_Audit_Log_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  NewStatus = 'new_status',
  /** column name */
  PreviousStatus = 'previous_status'
}

/** input type for updating data in table "user_access_audit_log" */
export type User_Access_Audit_Log_Set_Input = {
  action?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  new_status?: InputMaybe<Scalars['Boolean']['input']>;
  performed_by?: InputMaybe<Scalars['uuid']['input']>;
  previous_status?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "user_access_audit_log" */
export type User_Access_Audit_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Access_Audit_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Access_Audit_Log_Stream_Cursor_Value_Input = {
  action?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  new_status?: InputMaybe<Scalars['Boolean']['input']>;
  performed_by?: InputMaybe<Scalars['uuid']['input']>;
  previous_status?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "user_access_audit_log" */
export enum User_Access_Audit_Log_Update_Column {
  /** column name */
  Action = 'action',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  NewStatus = 'new_status',
  /** column name */
  PerformedBy = 'performed_by',
  /** column name */
  PreviousStatus = 'previous_status',
  /** column name */
  Reason = 'reason',
  /** column name */
  UserId = 'user_id'
}

export type User_Access_Audit_Log_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Access_Audit_Log_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Access_Audit_Log_Bool_Exp;
};

/** aggregated selection of "user" */
export type User_Aggregate = {
  __typename?: 'user_aggregate';
  aggregate?: Maybe<User_Aggregate_Fields>;
  nodes: Array<User>;
};

export type User_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<User_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<User_Aggregate_Bool_Exp_Count>;
};

export type User_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Select_Column_User_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Select_Column_User_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user" */
export type User_Aggregate_Fields = {
  __typename?: 'user_aggregate_fields';
  avg?: Maybe<User_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Max_Fields>;
  min?: Maybe<User_Min_Fields>;
  stddev?: Maybe<User_Stddev_Fields>;
  stddev_pop?: Maybe<User_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Stddev_Samp_Fields>;
  sum?: Maybe<User_Sum_Fields>;
  var_pop?: Maybe<User_Var_Pop_Fields>;
  var_samp?: Maybe<User_Var_Samp_Fields>;
  variance?: Maybe<User_Variance_Fields>;
};


/** aggregate fields of "user" */
export type User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user" */
export type User_Aggregate_Order_By = {
  avg?: InputMaybe<User_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Max_Order_By>;
  min?: InputMaybe<User_Min_Order_By>;
  stddev?: InputMaybe<User_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Sum_Order_By>;
  var_pop?: InputMaybe<User_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user" */
export type User_Arr_Rel_Insert_Input = {
  data: Array<User_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Avg_Fields = {
  __typename?: 'user_avg_fields';
  code?: Maybe<Scalars['Float']['output']>;
  customer_code?: Maybe<Scalars['Float']['output']>;
  driver_code?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "user" */
export type User_Avg_Order_By = {
  code?: InputMaybe<Order_By>;
  customer_code?: InputMaybe<Order_By>;
  driver_code?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user". All fields are combined with a logical 'AND'. */
export type User_Bool_Exp = {
  _and?: InputMaybe<Array<User_Bool_Exp>>;
  _not?: InputMaybe<User_Bool_Exp>;
  _or?: InputMaybe<Array<User_Bool_Exp>>;
  code?: InputMaybe<Bigint_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_asset_audit_logs?: InputMaybe<Customer_Asset_Audit_Log_Bool_Exp>;
  customer_asset_audit_logs_aggregate?: InputMaybe<Customer_Asset_Audit_Log_Aggregate_Bool_Exp>;
  customer_code?: InputMaybe<Bigint_Comparison_Exp>;
  customer_segmentation?: InputMaybe<Customer_Segmentation_Bool_Exp>;
  customer_segmentation_id?: InputMaybe<Uuid_Comparison_Exp>;
  delivery_otp?: InputMaybe<Boolean_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  driver_code?: InputMaybe<Bigint_Comparison_Exp>;
  driver_permits?: InputMaybe<Driver_Permit_Bool_Exp>;
  driver_permits_aggregate?: InputMaybe<Driver_Permit_Aggregate_Bool_Exp>;
  driver_vehicles?: InputMaybe<Driver_Vehicle_Bool_Exp>;
  driver_vehicles_aggregate?: InputMaybe<Driver_Vehicle_Aggregate_Bool_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  erp_code?: InputMaybe<String_Comparison_Exp>;
  fillupRequestsByDriverId?: InputMaybe<Fillup_Request_Bool_Exp>;
  fillupRequestsByDriverId_aggregate?: InputMaybe<Fillup_Request_Aggregate_Bool_Exp>;
  fillup_requests?: InputMaybe<Fillup_Request_Bool_Exp>;
  fillup_requests_aggregate?: InputMaybe<Fillup_Request_Aggregate_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  google_firebase_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invoicedItemCancellationTicketsByCreatedBy?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Bool_Exp>;
  invoicedItemCancellationTicketsByCreatedBy_aggregate?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Aggregate_Bool_Exp>;
  invoicedItemCancellationTicketsByLastModifiedBy?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Bool_Exp>;
  invoicedItemCancellationTicketsByLastModifiedBy_aggregate?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Aggregate_Bool_Exp>;
  invoiced_item_cancellation_tickets?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Bool_Exp>;
  invoiced_item_cancellation_tickets_aggregate?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Aggregate_Bool_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_test?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  license_number?: InputMaybe<String_Comparison_Exp>;
  lpoExceptionsByLastModifiedBy?: InputMaybe<Lpo_Exception_Bool_Exp>;
  lpoExceptionsByLastModifiedBy_aggregate?: InputMaybe<Lpo_Exception_Aggregate_Bool_Exp>;
  lpo_exceptions?: InputMaybe<Lpo_Exception_Bool_Exp>;
  lpo_exceptions_aggregate?: InputMaybe<Lpo_Exception_Aggregate_Bool_Exp>;
  masterSlotPausesByLastModifiedBy?: InputMaybe<Master_Slot_Pause_Bool_Exp>;
  masterSlotPausesByLastModifiedBy_aggregate?: InputMaybe<Master_Slot_Pause_Aggregate_Bool_Exp>;
  masterSlotsByLastModifiedBy?: InputMaybe<Master_Slot_Bool_Exp>;
  masterSlotsByLastModifiedBy_aggregate?: InputMaybe<Master_Slot_Aggregate_Bool_Exp>;
  masterSlotsByReviewedBy?: InputMaybe<Master_Slot_Bool_Exp>;
  masterSlotsByReviewedBy_aggregate?: InputMaybe<Master_Slot_Aggregate_Bool_Exp>;
  master_slot_pauses?: InputMaybe<Master_Slot_Pause_Bool_Exp>;
  master_slot_pauses_aggregate?: InputMaybe<Master_Slot_Pause_Aggregate_Bool_Exp>;
  master_slots?: InputMaybe<Master_Slot_Bool_Exp>;
  master_slots_aggregate?: InputMaybe<Master_Slot_Aggregate_Bool_Exp>;
  middle_name?: InputMaybe<String_Comparison_Exp>;
  organization_audit_logs?: InputMaybe<Organization_Audit_Log_Bool_Exp>;
  organization_audit_logs_aggregate?: InputMaybe<Organization_Audit_Log_Aggregate_Bool_Exp>;
  organization_user_commissions?: InputMaybe<Organization_User_Commission_Bool_Exp>;
  organization_user_commissions_aggregate?: InputMaybe<Organization_User_Commission_Aggregate_Bool_Exp>;
  organization_users?: InputMaybe<Organization_User_Bool_Exp>;
  organization_users_aggregate?: InputMaybe<Organization_User_Aggregate_Bool_Exp>;
  pan_number?: InputMaybe<String_Comparison_Exp>;
  partnerOrdersByCreatedBy?: InputMaybe<Partner_Order_Bool_Exp>;
  partnerOrdersByCreatedBy_aggregate?: InputMaybe<Partner_Order_Aggregate_Bool_Exp>;
  partner_addresses?: InputMaybe<Partner_Address_Bool_Exp>;
  partner_addresses_aggregate?: InputMaybe<Partner_Address_Aggregate_Bool_Exp>;
  partner_commissions?: InputMaybe<Partner_Commission_Bool_Exp>;
  partner_commissions_aggregate?: InputMaybe<Partner_Commission_Aggregate_Bool_Exp>;
  partner_orders?: InputMaybe<Partner_Order_Bool_Exp>;
  partner_orders_aggregate?: InputMaybe<Partner_Order_Aggregate_Bool_Exp>;
  partner_users?: InputMaybe<Partner_User_Bool_Exp>;
  partner_users_aggregate?: InputMaybe<Partner_User_Aggregate_Bool_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  planningPeriodsByCreatedBy?: InputMaybe<Planning_Period_Bool_Exp>;
  planningPeriodsByCreatedBy_aggregate?: InputMaybe<Planning_Period_Aggregate_Bool_Exp>;
  planning_audit_logs?: InputMaybe<Planning_Audit_Log_Bool_Exp>;
  planning_audit_logs_aggregate?: InputMaybe<Planning_Audit_Log_Aggregate_Bool_Exp>;
  planning_periods?: InputMaybe<Planning_Period_Bool_Exp>;
  planning_periods_aggregate?: InputMaybe<Planning_Period_Aggregate_Bool_Exp>;
  profile_pic?: InputMaybe<String_Comparison_Exp>;
  quantity_correction_tickets?: InputMaybe<Quantity_Correction_Tickets_Bool_Exp>;
  quantity_correction_tickets_aggregate?: InputMaybe<Quantity_Correction_Tickets_Aggregate_Bool_Exp>;
  referral_code?: InputMaybe<String_Comparison_Exp>;
  shiftScheduleDispensersByCreatedBy?: InputMaybe<Shift_Schedule_Dispenser_Bool_Exp>;
  shiftScheduleDispensersByCreatedBy_aggregate?: InputMaybe<Shift_Schedule_Dispenser_Aggregate_Bool_Exp>;
  shiftSchedulesByApprovedBy?: InputMaybe<Shift_Schedule_Bool_Exp>;
  shiftSchedulesByApprovedBy_aggregate?: InputMaybe<Shift_Schedule_Aggregate_Bool_Exp>;
  shiftTemplatesByLastModifiedBy?: InputMaybe<Shift_Template_Bool_Exp>;
  shiftTemplatesByLastModifiedBy_aggregate?: InputMaybe<Shift_Template_Aggregate_Bool_Exp>;
  shift_schedule_dispensers?: InputMaybe<Shift_Schedule_Dispenser_Bool_Exp>;
  shift_schedule_dispensers_aggregate?: InputMaybe<Shift_Schedule_Dispenser_Aggregate_Bool_Exp>;
  shift_schedules?: InputMaybe<Shift_Schedule_Bool_Exp>;
  shift_schedules_aggregate?: InputMaybe<Shift_Schedule_Aggregate_Bool_Exp>;
  shift_templates?: InputMaybe<Shift_Template_Bool_Exp>;
  shift_templates_aggregate?: InputMaybe<Shift_Template_Aggregate_Bool_Exp>;
  taskStatesFlowsByPreviousDriverId?: InputMaybe<Task_States_Flow_Bool_Exp>;
  taskStatesFlowsByPreviousDriverId_aggregate?: InputMaybe<Task_States_Flow_Aggregate_Bool_Exp>;
  tasks?: InputMaybe<Task_Bool_Exp>;
  tasksByDriverId?: InputMaybe<Task_Bool_Exp>;
  tasksByDriverId_aggregate?: InputMaybe<Task_Aggregate_Bool_Exp>;
  tasks_aggregate?: InputMaybe<Task_Aggregate_Bool_Exp>;
  time_zone?: InputMaybe<String_Comparison_Exp>;
  totalizerCorrectionTicketsByCreatedBy?: InputMaybe<Totalizer_Correction_Tickets_Bool_Exp>;
  totalizerCorrectionTicketsByCreatedBy_aggregate?: InputMaybe<Totalizer_Correction_Tickets_Aggregate_Bool_Exp>;
  totalizerCorrectionTicketsByLastModifiedBy?: InputMaybe<Totalizer_Correction_Tickets_Bool_Exp>;
  totalizerCorrectionTicketsByLastModifiedBy_aggregate?: InputMaybe<Totalizer_Correction_Tickets_Aggregate_Bool_Exp>;
  totalizer_correction_tickets?: InputMaybe<Totalizer_Correction_Tickets_Bool_Exp>;
  totalizer_correction_tickets_aggregate?: InputMaybe<Totalizer_Correction_Tickets_Aggregate_Bool_Exp>;
  trip_plans?: InputMaybe<Trip_Plan_Bool_Exp>;
  trip_plans_aggregate?: InputMaybe<Trip_Plan_Aggregate_Bool_Exp>;
  userAccessAuditLogsByUserId?: InputMaybe<User_Access_Audit_Log_Bool_Exp>;
  userAccessAuditLogsByUserId_aggregate?: InputMaybe<User_Access_Audit_Log_Aggregate_Bool_Exp>;
  userReferralsByUserId?: InputMaybe<User_Referral_Bool_Exp>;
  userReferralsByUserId_aggregate?: InputMaybe<User_Referral_Aggregate_Bool_Exp>;
  user_access_audit_logs?: InputMaybe<User_Access_Audit_Log_Bool_Exp>;
  user_access_audit_logs_aggregate?: InputMaybe<User_Access_Audit_Log_Aggregate_Bool_Exp>;
  user_referrals?: InputMaybe<User_Referral_Bool_Exp>;
  user_referrals_aggregate?: InputMaybe<User_Referral_Aggregate_Bool_Exp>;
  user_roles?: InputMaybe<User_Role_Bool_Exp>;
  user_roles_aggregate?: InputMaybe<User_Role_Aggregate_Bool_Exp>;
  vehicleShiftTemplatesByCreatedBy?: InputMaybe<Vehicle_Shift_Template_Bool_Exp>;
  vehicleShiftTemplatesByCreatedBy_aggregate?: InputMaybe<Vehicle_Shift_Template_Aggregate_Bool_Exp>;
  vendorOrderLogsByDriverId?: InputMaybe<Vendor_Order_Logs_Bool_Exp>;
  vendorOrderLogsByDriverId_aggregate?: InputMaybe<Vendor_Order_Logs_Aggregate_Bool_Exp>;
  vendorOrderLogsByLastModifiedBy?: InputMaybe<Vendor_Order_Logs_Bool_Exp>;
  vendorOrderLogsByLastModifiedBy_aggregate?: InputMaybe<Vendor_Order_Logs_Aggregate_Bool_Exp>;
  vendor_order_logs?: InputMaybe<Vendor_Order_Logs_Bool_Exp>;
  vendor_order_logs_aggregate?: InputMaybe<Vendor_Order_Logs_Aggregate_Bool_Exp>;
  verified_at?: InputMaybe<Timestamp_Comparison_Exp>;
  wallet_exceptions?: InputMaybe<Wallet_Exception_Bool_Exp>;
  wallet_exceptions_aggregate?: InputMaybe<Wallet_Exception_Aggregate_Bool_Exp>;
  wallet_ledgers?: InputMaybe<Wallet_Ledger_Bool_Exp>;
  wallet_ledgers_aggregate?: InputMaybe<Wallet_Ledger_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "user" */
export enum User_Constraint {
  /** unique or primary key constraint on columns "code" */
  UserCodeKey = 'user_code_key',
  /** unique or primary key constraint on columns "driver_code" */
  UserDriverCodeKey = 'user_driver_code_key',
  /** unique or primary key constraint on columns "email" */
  UserEmailKey = 'user_email_key',
  /** unique or primary key constraint on columns "phone_number" */
  UserPhoneNumberKey = 'user_phone_number_key',
  /** unique or primary key constraint on columns "id" */
  UserPkey = 'user_pkey'
}

/** input type for incrementing numeric columns in table "user" */
export type User_Inc_Input = {
  code?: InputMaybe<Scalars['bigint']['input']>;
  customer_code?: InputMaybe<Scalars['bigint']['input']>;
  driver_code?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "user" */
export type User_Insert_Input = {
  code?: InputMaybe<Scalars['bigint']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_asset_audit_logs?: InputMaybe<Customer_Asset_Audit_Log_Arr_Rel_Insert_Input>;
  customer_code?: InputMaybe<Scalars['bigint']['input']>;
  customer_segmentation?: InputMaybe<Customer_Segmentation_Obj_Rel_Insert_Input>;
  customer_segmentation_id?: InputMaybe<Scalars['uuid']['input']>;
  delivery_otp?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  driver_code?: InputMaybe<Scalars['bigint']['input']>;
  driver_permits?: InputMaybe<Driver_Permit_Arr_Rel_Insert_Input>;
  driver_vehicles?: InputMaybe<Driver_Vehicle_Arr_Rel_Insert_Input>;
  email?: InputMaybe<Scalars['String']['input']>;
  erp_code?: InputMaybe<Scalars['String']['input']>;
  fillupRequestsByDriverId?: InputMaybe<Fillup_Request_Arr_Rel_Insert_Input>;
  fillup_requests?: InputMaybe<Fillup_Request_Arr_Rel_Insert_Input>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  google_firebase_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invoicedItemCancellationTicketsByCreatedBy?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Arr_Rel_Insert_Input>;
  invoicedItemCancellationTicketsByLastModifiedBy?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Arr_Rel_Insert_Input>;
  invoiced_item_cancellation_tickets?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Arr_Rel_Insert_Input>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_test?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  license_number?: InputMaybe<Scalars['String']['input']>;
  lpoExceptionsByLastModifiedBy?: InputMaybe<Lpo_Exception_Arr_Rel_Insert_Input>;
  lpo_exceptions?: InputMaybe<Lpo_Exception_Arr_Rel_Insert_Input>;
  masterSlotPausesByLastModifiedBy?: InputMaybe<Master_Slot_Pause_Arr_Rel_Insert_Input>;
  masterSlotsByLastModifiedBy?: InputMaybe<Master_Slot_Arr_Rel_Insert_Input>;
  masterSlotsByReviewedBy?: InputMaybe<Master_Slot_Arr_Rel_Insert_Input>;
  master_slot_pauses?: InputMaybe<Master_Slot_Pause_Arr_Rel_Insert_Input>;
  master_slots?: InputMaybe<Master_Slot_Arr_Rel_Insert_Input>;
  middle_name?: InputMaybe<Scalars['String']['input']>;
  organization_audit_logs?: InputMaybe<Organization_Audit_Log_Arr_Rel_Insert_Input>;
  organization_user_commissions?: InputMaybe<Organization_User_Commission_Arr_Rel_Insert_Input>;
  organization_users?: InputMaybe<Organization_User_Arr_Rel_Insert_Input>;
  pan_number?: InputMaybe<Scalars['String']['input']>;
  partnerOrdersByCreatedBy?: InputMaybe<Partner_Order_Arr_Rel_Insert_Input>;
  partner_addresses?: InputMaybe<Partner_Address_Arr_Rel_Insert_Input>;
  partner_commissions?: InputMaybe<Partner_Commission_Arr_Rel_Insert_Input>;
  partner_orders?: InputMaybe<Partner_Order_Arr_Rel_Insert_Input>;
  partner_users?: InputMaybe<Partner_User_Arr_Rel_Insert_Input>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  planningPeriodsByCreatedBy?: InputMaybe<Planning_Period_Arr_Rel_Insert_Input>;
  planning_audit_logs?: InputMaybe<Planning_Audit_Log_Arr_Rel_Insert_Input>;
  planning_periods?: InputMaybe<Planning_Period_Arr_Rel_Insert_Input>;
  profile_pic?: InputMaybe<Scalars['String']['input']>;
  quantity_correction_tickets?: InputMaybe<Quantity_Correction_Tickets_Arr_Rel_Insert_Input>;
  referral_code?: InputMaybe<Scalars['String']['input']>;
  shiftScheduleDispensersByCreatedBy?: InputMaybe<Shift_Schedule_Dispenser_Arr_Rel_Insert_Input>;
  shiftSchedulesByApprovedBy?: InputMaybe<Shift_Schedule_Arr_Rel_Insert_Input>;
  shiftTemplatesByLastModifiedBy?: InputMaybe<Shift_Template_Arr_Rel_Insert_Input>;
  shift_schedule_dispensers?: InputMaybe<Shift_Schedule_Dispenser_Arr_Rel_Insert_Input>;
  shift_schedules?: InputMaybe<Shift_Schedule_Arr_Rel_Insert_Input>;
  shift_templates?: InputMaybe<Shift_Template_Arr_Rel_Insert_Input>;
  taskStatesFlowsByPreviousDriverId?: InputMaybe<Task_States_Flow_Arr_Rel_Insert_Input>;
  tasks?: InputMaybe<Task_Arr_Rel_Insert_Input>;
  tasksByDriverId?: InputMaybe<Task_Arr_Rel_Insert_Input>;
  time_zone?: InputMaybe<Scalars['String']['input']>;
  totalizerCorrectionTicketsByCreatedBy?: InputMaybe<Totalizer_Correction_Tickets_Arr_Rel_Insert_Input>;
  totalizerCorrectionTicketsByLastModifiedBy?: InputMaybe<Totalizer_Correction_Tickets_Arr_Rel_Insert_Input>;
  totalizer_correction_tickets?: InputMaybe<Totalizer_Correction_Tickets_Arr_Rel_Insert_Input>;
  trip_plans?: InputMaybe<Trip_Plan_Arr_Rel_Insert_Input>;
  userAccessAuditLogsByUserId?: InputMaybe<User_Access_Audit_Log_Arr_Rel_Insert_Input>;
  userReferralsByUserId?: InputMaybe<User_Referral_Arr_Rel_Insert_Input>;
  user_access_audit_logs?: InputMaybe<User_Access_Audit_Log_Arr_Rel_Insert_Input>;
  user_referrals?: InputMaybe<User_Referral_Arr_Rel_Insert_Input>;
  user_roles?: InputMaybe<User_Role_Arr_Rel_Insert_Input>;
  vehicleShiftTemplatesByCreatedBy?: InputMaybe<Vehicle_Shift_Template_Arr_Rel_Insert_Input>;
  vendorOrderLogsByDriverId?: InputMaybe<Vendor_Order_Logs_Arr_Rel_Insert_Input>;
  vendorOrderLogsByLastModifiedBy?: InputMaybe<Vendor_Order_Logs_Arr_Rel_Insert_Input>;
  vendor_order_logs?: InputMaybe<Vendor_Order_Logs_Arr_Rel_Insert_Input>;
  verified_at?: InputMaybe<Scalars['timestamp']['input']>;
  wallet_exceptions?: InputMaybe<Wallet_Exception_Arr_Rel_Insert_Input>;
  wallet_ledgers?: InputMaybe<Wallet_Ledger_Arr_Rel_Insert_Input>;
};

/** columns and relationships of "user_ledger" */
export type User_Ledger = {
  __typename?: 'user_ledger';
  amount?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  currency: Currency;
  currency_id: Scalars['uuid']['output'];
  /** An object relationship */
  customer_payment?: Maybe<Customer_Payment>;
  customer_payment_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  organization_user?: Maybe<Organization_User>;
  organization_user_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  partner_payment?: Maybe<Partner_Payment>;
  partner_payment_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  paymentTypeByPaymentType?: Maybe<Payment_Type>;
  payment_type?: Maybe<Payment_Type_Enum>;
  slab?: Maybe<Slab_Type_Enum>;
  /** An object relationship */
  slab_type?: Maybe<Slab_Type>;
  transaction_details: Scalars['String']['output'];
  /** An object relationship */
  wallet?: Maybe<Wallet>;
  wallet_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  wallet_transaction?: Maybe<Wallet_Transactions>;
  wallet_transaction_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "user_ledger" */
export type User_Ledger_Aggregate = {
  __typename?: 'user_ledger_aggregate';
  aggregate?: Maybe<User_Ledger_Aggregate_Fields>;
  nodes: Array<User_Ledger>;
};

export type User_Ledger_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Ledger_Aggregate_Bool_Exp_Count>;
};

export type User_Ledger_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Ledger_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Ledger_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_ledger" */
export type User_Ledger_Aggregate_Fields = {
  __typename?: 'user_ledger_aggregate_fields';
  avg?: Maybe<User_Ledger_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Ledger_Max_Fields>;
  min?: Maybe<User_Ledger_Min_Fields>;
  stddev?: Maybe<User_Ledger_Stddev_Fields>;
  stddev_pop?: Maybe<User_Ledger_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Ledger_Stddev_Samp_Fields>;
  sum?: Maybe<User_Ledger_Sum_Fields>;
  var_pop?: Maybe<User_Ledger_Var_Pop_Fields>;
  var_samp?: Maybe<User_Ledger_Var_Samp_Fields>;
  variance?: Maybe<User_Ledger_Variance_Fields>;
};


/** aggregate fields of "user_ledger" */
export type User_Ledger_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Ledger_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_ledger" */
export type User_Ledger_Aggregate_Order_By = {
  avg?: InputMaybe<User_Ledger_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Ledger_Max_Order_By>;
  min?: InputMaybe<User_Ledger_Min_Order_By>;
  stddev?: InputMaybe<User_Ledger_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Ledger_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Ledger_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Ledger_Sum_Order_By>;
  var_pop?: InputMaybe<User_Ledger_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Ledger_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Ledger_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_ledger" */
export type User_Ledger_Arr_Rel_Insert_Input = {
  data: Array<User_Ledger_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Ledger_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Ledger_Avg_Fields = {
  __typename?: 'user_ledger_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "user_ledger" */
export type User_Ledger_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_ledger". All fields are combined with a logical 'AND'. */
export type User_Ledger_Bool_Exp = {
  _and?: InputMaybe<Array<User_Ledger_Bool_Exp>>;
  _not?: InputMaybe<User_Ledger_Bool_Exp>;
  _or?: InputMaybe<Array<User_Ledger_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  currency?: InputMaybe<Currency_Bool_Exp>;
  currency_id?: InputMaybe<Uuid_Comparison_Exp>;
  customer_payment?: InputMaybe<Customer_Payment_Bool_Exp>;
  customer_payment_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  organization_user?: InputMaybe<Organization_User_Bool_Exp>;
  organization_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner_payment?: InputMaybe<Partner_Payment_Bool_Exp>;
  partner_payment_id?: InputMaybe<Uuid_Comparison_Exp>;
  paymentTypeByPaymentType?: InputMaybe<Payment_Type_Bool_Exp>;
  payment_type?: InputMaybe<Payment_Type_Enum_Comparison_Exp>;
  slab?: InputMaybe<Slab_Type_Enum_Comparison_Exp>;
  slab_type?: InputMaybe<Slab_Type_Bool_Exp>;
  transaction_details?: InputMaybe<String_Comparison_Exp>;
  wallet?: InputMaybe<Wallet_Bool_Exp>;
  wallet_id?: InputMaybe<Uuid_Comparison_Exp>;
  wallet_transaction?: InputMaybe<Wallet_Transactions_Bool_Exp>;
  wallet_transaction_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_ledger" */
export enum User_Ledger_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserLedgerPkey = 'user_ledger_pkey'
}

/** input type for incrementing numeric columns in table "user_ledger" */
export type User_Ledger_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "user_ledger" */
export type User_Ledger_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  currency?: InputMaybe<Currency_Obj_Rel_Insert_Input>;
  currency_id?: InputMaybe<Scalars['uuid']['input']>;
  customer_payment?: InputMaybe<Customer_Payment_Obj_Rel_Insert_Input>;
  customer_payment_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_user?: InputMaybe<Organization_User_Obj_Rel_Insert_Input>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_payment?: InputMaybe<Partner_Payment_Obj_Rel_Insert_Input>;
  partner_payment_id?: InputMaybe<Scalars['uuid']['input']>;
  paymentTypeByPaymentType?: InputMaybe<Payment_Type_Obj_Rel_Insert_Input>;
  payment_type?: InputMaybe<Payment_Type_Enum>;
  slab?: InputMaybe<Slab_Type_Enum>;
  slab_type?: InputMaybe<Slab_Type_Obj_Rel_Insert_Input>;
  transaction_details?: InputMaybe<Scalars['String']['input']>;
  wallet?: InputMaybe<Wallet_Obj_Rel_Insert_Input>;
  wallet_id?: InputMaybe<Scalars['uuid']['input']>;
  wallet_transaction?: InputMaybe<Wallet_Transactions_Obj_Rel_Insert_Input>;
  wallet_transaction_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type User_Ledger_Max_Fields = {
  __typename?: 'user_ledger_max_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  currency_id?: Maybe<Scalars['uuid']['output']>;
  customer_payment_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  organization_user_id?: Maybe<Scalars['uuid']['output']>;
  partner_payment_id?: Maybe<Scalars['uuid']['output']>;
  transaction_details?: Maybe<Scalars['String']['output']>;
  wallet_id?: Maybe<Scalars['uuid']['output']>;
  wallet_transaction_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "user_ledger" */
export type User_Ledger_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency_id?: InputMaybe<Order_By>;
  customer_payment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
  partner_payment_id?: InputMaybe<Order_By>;
  transaction_details?: InputMaybe<Order_By>;
  wallet_id?: InputMaybe<Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Ledger_Min_Fields = {
  __typename?: 'user_ledger_min_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  currency_id?: Maybe<Scalars['uuid']['output']>;
  customer_payment_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  organization_user_id?: Maybe<Scalars['uuid']['output']>;
  partner_payment_id?: Maybe<Scalars['uuid']['output']>;
  transaction_details?: Maybe<Scalars['String']['output']>;
  wallet_id?: Maybe<Scalars['uuid']['output']>;
  wallet_transaction_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "user_ledger" */
export type User_Ledger_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency_id?: InputMaybe<Order_By>;
  customer_payment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
  partner_payment_id?: InputMaybe<Order_By>;
  transaction_details?: InputMaybe<Order_By>;
  wallet_id?: InputMaybe<Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_ledger" */
export type User_Ledger_Mutation_Response = {
  __typename?: 'user_ledger_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Ledger>;
};

/** on_conflict condition type for table "user_ledger" */
export type User_Ledger_On_Conflict = {
  constraint: User_Ledger_Constraint;
  update_columns?: Array<User_Ledger_Update_Column>;
  where?: InputMaybe<User_Ledger_Bool_Exp>;
};

/** Ordering options when selecting data from "user_ledger". */
export type User_Ledger_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Currency_Order_By>;
  currency_id?: InputMaybe<Order_By>;
  customer_payment?: InputMaybe<Customer_Payment_Order_By>;
  customer_payment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_user?: InputMaybe<Organization_User_Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
  partner_payment?: InputMaybe<Partner_Payment_Order_By>;
  partner_payment_id?: InputMaybe<Order_By>;
  paymentTypeByPaymentType?: InputMaybe<Payment_Type_Order_By>;
  payment_type?: InputMaybe<Order_By>;
  slab?: InputMaybe<Order_By>;
  slab_type?: InputMaybe<Slab_Type_Order_By>;
  transaction_details?: InputMaybe<Order_By>;
  wallet?: InputMaybe<Wallet_Order_By>;
  wallet_id?: InputMaybe<Order_By>;
  wallet_transaction?: InputMaybe<Wallet_Transactions_Order_By>;
  wallet_transaction_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_ledger */
export type User_Ledger_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_ledger" */
export enum User_Ledger_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  CustomerPaymentId = 'customer_payment_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrganizationUserId = 'organization_user_id',
  /** column name */
  PartnerPaymentId = 'partner_payment_id',
  /** column name */
  PaymentType = 'payment_type',
  /** column name */
  Slab = 'slab',
  /** column name */
  TransactionDetails = 'transaction_details',
  /** column name */
  WalletId = 'wallet_id',
  /** column name */
  WalletTransactionId = 'wallet_transaction_id'
}

/** input type for updating data in table "user_ledger" */
export type User_Ledger_Set_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  currency_id?: InputMaybe<Scalars['uuid']['input']>;
  customer_payment_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_payment_id?: InputMaybe<Scalars['uuid']['input']>;
  payment_type?: InputMaybe<Payment_Type_Enum>;
  slab?: InputMaybe<Slab_Type_Enum>;
  transaction_details?: InputMaybe<Scalars['String']['input']>;
  wallet_id?: InputMaybe<Scalars['uuid']['input']>;
  wallet_transaction_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type User_Ledger_Stddev_Fields = {
  __typename?: 'user_ledger_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "user_ledger" */
export type User_Ledger_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Ledger_Stddev_Pop_Fields = {
  __typename?: 'user_ledger_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "user_ledger" */
export type User_Ledger_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Ledger_Stddev_Samp_Fields = {
  __typename?: 'user_ledger_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "user_ledger" */
export type User_Ledger_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_ledger" */
export type User_Ledger_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Ledger_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Ledger_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  currency_id?: InputMaybe<Scalars['uuid']['input']>;
  customer_payment_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_payment_id?: InputMaybe<Scalars['uuid']['input']>;
  payment_type?: InputMaybe<Payment_Type_Enum>;
  slab?: InputMaybe<Slab_Type_Enum>;
  transaction_details?: InputMaybe<Scalars['String']['input']>;
  wallet_id?: InputMaybe<Scalars['uuid']['input']>;
  wallet_transaction_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type User_Ledger_Sum_Fields = {
  __typename?: 'user_ledger_sum_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "user_ledger" */
export type User_Ledger_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** update columns of table "user_ledger" */
export enum User_Ledger_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  CustomerPaymentId = 'customer_payment_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrganizationUserId = 'organization_user_id',
  /** column name */
  PartnerPaymentId = 'partner_payment_id',
  /** column name */
  PaymentType = 'payment_type',
  /** column name */
  Slab = 'slab',
  /** column name */
  TransactionDetails = 'transaction_details',
  /** column name */
  WalletId = 'wallet_id',
  /** column name */
  WalletTransactionId = 'wallet_transaction_id'
}

export type User_Ledger_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Ledger_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Ledger_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Ledger_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Ledger_Var_Pop_Fields = {
  __typename?: 'user_ledger_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "user_ledger" */
export type User_Ledger_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Ledger_Var_Samp_Fields = {
  __typename?: 'user_ledger_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "user_ledger" */
export type User_Ledger_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Ledger_Variance_Fields = {
  __typename?: 'user_ledger_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "user_ledger" */
export type User_Ledger_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type User_Max_Fields = {
  __typename?: 'user_max_fields';
  code?: Maybe<Scalars['bigint']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_code?: Maybe<Scalars['bigint']['output']>;
  customer_segmentation_id?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  driver_code?: Maybe<Scalars['bigint']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  erp_code?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  google_firebase_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  license_number?: Maybe<Scalars['String']['output']>;
  middle_name?: Maybe<Scalars['String']['output']>;
  pan_number?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  profile_pic?: Maybe<Scalars['String']['output']>;
  referral_code?: Maybe<Scalars['String']['output']>;
  time_zone?: Maybe<Scalars['String']['output']>;
  verified_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "user" */
export type User_Max_Order_By = {
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_code?: InputMaybe<Order_By>;
  customer_segmentation_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  driver_code?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  erp_code?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  google_firebase_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  license_number?: InputMaybe<Order_By>;
  middle_name?: InputMaybe<Order_By>;
  pan_number?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  profile_pic?: InputMaybe<Order_By>;
  referral_code?: InputMaybe<Order_By>;
  time_zone?: InputMaybe<Order_By>;
  verified_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Min_Fields = {
  __typename?: 'user_min_fields';
  code?: Maybe<Scalars['bigint']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_code?: Maybe<Scalars['bigint']['output']>;
  customer_segmentation_id?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  driver_code?: Maybe<Scalars['bigint']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  erp_code?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  google_firebase_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  license_number?: Maybe<Scalars['String']['output']>;
  middle_name?: Maybe<Scalars['String']['output']>;
  pan_number?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  profile_pic?: Maybe<Scalars['String']['output']>;
  referral_code?: Maybe<Scalars['String']['output']>;
  time_zone?: Maybe<Scalars['String']['output']>;
  verified_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "user" */
export type User_Min_Order_By = {
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_code?: InputMaybe<Order_By>;
  customer_segmentation_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  driver_code?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  erp_code?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  google_firebase_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  license_number?: InputMaybe<Order_By>;
  middle_name?: InputMaybe<Order_By>;
  pan_number?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  profile_pic?: InputMaybe<Order_By>;
  referral_code?: InputMaybe<Order_By>;
  time_zone?: InputMaybe<Order_By>;
  verified_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user" */
export type User_Mutation_Response = {
  __typename?: 'user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User>;
};

/** input type for inserting object relation for remote table "user" */
export type User_Obj_Rel_Insert_Input = {
  data: User_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_On_Conflict>;
};

/** on_conflict condition type for table "user" */
export type User_On_Conflict = {
  constraint: User_Constraint;
  update_columns?: Array<User_Update_Column>;
  where?: InputMaybe<User_Bool_Exp>;
};

/** Ordering options when selecting data from "user". */
export type User_Order_By = {
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_asset_audit_logs_aggregate?: InputMaybe<Customer_Asset_Audit_Log_Aggregate_Order_By>;
  customer_code?: InputMaybe<Order_By>;
  customer_segmentation?: InputMaybe<Customer_Segmentation_Order_By>;
  customer_segmentation_id?: InputMaybe<Order_By>;
  delivery_otp?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  driver_code?: InputMaybe<Order_By>;
  driver_permits_aggregate?: InputMaybe<Driver_Permit_Aggregate_Order_By>;
  driver_vehicles_aggregate?: InputMaybe<Driver_Vehicle_Aggregate_Order_By>;
  email?: InputMaybe<Order_By>;
  erp_code?: InputMaybe<Order_By>;
  fillupRequestsByDriverId_aggregate?: InputMaybe<Fillup_Request_Aggregate_Order_By>;
  fillup_requests_aggregate?: InputMaybe<Fillup_Request_Aggregate_Order_By>;
  first_name?: InputMaybe<Order_By>;
  google_firebase_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoicedItemCancellationTicketsByCreatedBy_aggregate?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Aggregate_Order_By>;
  invoicedItemCancellationTicketsByLastModifiedBy_aggregate?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Aggregate_Order_By>;
  invoiced_item_cancellation_tickets_aggregate?: InputMaybe<Invoiced_Item_Cancellation_Tickets_Aggregate_Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_test?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  license_number?: InputMaybe<Order_By>;
  lpoExceptionsByLastModifiedBy_aggregate?: InputMaybe<Lpo_Exception_Aggregate_Order_By>;
  lpo_exceptions_aggregate?: InputMaybe<Lpo_Exception_Aggregate_Order_By>;
  masterSlotPausesByLastModifiedBy_aggregate?: InputMaybe<Master_Slot_Pause_Aggregate_Order_By>;
  masterSlotsByLastModifiedBy_aggregate?: InputMaybe<Master_Slot_Aggregate_Order_By>;
  masterSlotsByReviewedBy_aggregate?: InputMaybe<Master_Slot_Aggregate_Order_By>;
  master_slot_pauses_aggregate?: InputMaybe<Master_Slot_Pause_Aggregate_Order_By>;
  master_slots_aggregate?: InputMaybe<Master_Slot_Aggregate_Order_By>;
  middle_name?: InputMaybe<Order_By>;
  organization_audit_logs_aggregate?: InputMaybe<Organization_Audit_Log_Aggregate_Order_By>;
  organization_user_commissions_aggregate?: InputMaybe<Organization_User_Commission_Aggregate_Order_By>;
  organization_users_aggregate?: InputMaybe<Organization_User_Aggregate_Order_By>;
  pan_number?: InputMaybe<Order_By>;
  partnerOrdersByCreatedBy_aggregate?: InputMaybe<Partner_Order_Aggregate_Order_By>;
  partner_addresses_aggregate?: InputMaybe<Partner_Address_Aggregate_Order_By>;
  partner_commissions_aggregate?: InputMaybe<Partner_Commission_Aggregate_Order_By>;
  partner_orders_aggregate?: InputMaybe<Partner_Order_Aggregate_Order_By>;
  partner_users_aggregate?: InputMaybe<Partner_User_Aggregate_Order_By>;
  phone_number?: InputMaybe<Order_By>;
  planningPeriodsByCreatedBy_aggregate?: InputMaybe<Planning_Period_Aggregate_Order_By>;
  planning_audit_logs_aggregate?: InputMaybe<Planning_Audit_Log_Aggregate_Order_By>;
  planning_periods_aggregate?: InputMaybe<Planning_Period_Aggregate_Order_By>;
  profile_pic?: InputMaybe<Order_By>;
  quantity_correction_tickets_aggregate?: InputMaybe<Quantity_Correction_Tickets_Aggregate_Order_By>;
  referral_code?: InputMaybe<Order_By>;
  shiftScheduleDispensersByCreatedBy_aggregate?: InputMaybe<Shift_Schedule_Dispenser_Aggregate_Order_By>;
  shiftSchedulesByApprovedBy_aggregate?: InputMaybe<Shift_Schedule_Aggregate_Order_By>;
  shiftTemplatesByLastModifiedBy_aggregate?: InputMaybe<Shift_Template_Aggregate_Order_By>;
  shift_schedule_dispensers_aggregate?: InputMaybe<Shift_Schedule_Dispenser_Aggregate_Order_By>;
  shift_schedules_aggregate?: InputMaybe<Shift_Schedule_Aggregate_Order_By>;
  shift_templates_aggregate?: InputMaybe<Shift_Template_Aggregate_Order_By>;
  taskStatesFlowsByPreviousDriverId_aggregate?: InputMaybe<Task_States_Flow_Aggregate_Order_By>;
  tasksByDriverId_aggregate?: InputMaybe<Task_Aggregate_Order_By>;
  tasks_aggregate?: InputMaybe<Task_Aggregate_Order_By>;
  time_zone?: InputMaybe<Order_By>;
  totalizerCorrectionTicketsByCreatedBy_aggregate?: InputMaybe<Totalizer_Correction_Tickets_Aggregate_Order_By>;
  totalizerCorrectionTicketsByLastModifiedBy_aggregate?: InputMaybe<Totalizer_Correction_Tickets_Aggregate_Order_By>;
  totalizer_correction_tickets_aggregate?: InputMaybe<Totalizer_Correction_Tickets_Aggregate_Order_By>;
  trip_plans_aggregate?: InputMaybe<Trip_Plan_Aggregate_Order_By>;
  userAccessAuditLogsByUserId_aggregate?: InputMaybe<User_Access_Audit_Log_Aggregate_Order_By>;
  userReferralsByUserId_aggregate?: InputMaybe<User_Referral_Aggregate_Order_By>;
  user_access_audit_logs_aggregate?: InputMaybe<User_Access_Audit_Log_Aggregate_Order_By>;
  user_referrals_aggregate?: InputMaybe<User_Referral_Aggregate_Order_By>;
  user_roles_aggregate?: InputMaybe<User_Role_Aggregate_Order_By>;
  vehicleShiftTemplatesByCreatedBy_aggregate?: InputMaybe<Vehicle_Shift_Template_Aggregate_Order_By>;
  vendorOrderLogsByDriverId_aggregate?: InputMaybe<Vendor_Order_Logs_Aggregate_Order_By>;
  vendorOrderLogsByLastModifiedBy_aggregate?: InputMaybe<Vendor_Order_Logs_Aggregate_Order_By>;
  vendor_order_logs_aggregate?: InputMaybe<Vendor_Order_Logs_Aggregate_Order_By>;
  verified_at?: InputMaybe<Order_By>;
  wallet_exceptions_aggregate?: InputMaybe<Wallet_Exception_Aggregate_Order_By>;
  wallet_ledgers_aggregate?: InputMaybe<Wallet_Ledger_Aggregate_Order_By>;
};

/** columns and relationships of "user_partner_type" */
export type User_Partner_Type = {
  __typename?: 'user_partner_type';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "user_partner_type" */
export type User_Partner_Type_Aggregate = {
  __typename?: 'user_partner_type_aggregate';
  aggregate?: Maybe<User_Partner_Type_Aggregate_Fields>;
  nodes: Array<User_Partner_Type>;
};

/** aggregate fields of "user_partner_type" */
export type User_Partner_Type_Aggregate_Fields = {
  __typename?: 'user_partner_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_Partner_Type_Max_Fields>;
  min?: Maybe<User_Partner_Type_Min_Fields>;
};


/** aggregate fields of "user_partner_type" */
export type User_Partner_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Partner_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "user_partner_type". All fields are combined with a logical 'AND'. */
export type User_Partner_Type_Bool_Exp = {
  _and?: InputMaybe<Array<User_Partner_Type_Bool_Exp>>;
  _not?: InputMaybe<User_Partner_Type_Bool_Exp>;
  _or?: InputMaybe<Array<User_Partner_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_partner_type" */
export enum User_Partner_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  UserPartnerTypePkey = 'user_partner_type_pkey'
}

/** input type for inserting data into table "user_partner_type" */
export type User_Partner_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type User_Partner_Type_Max_Fields = {
  __typename?: 'user_partner_type_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type User_Partner_Type_Min_Fields = {
  __typename?: 'user_partner_type_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "user_partner_type" */
export type User_Partner_Type_Mutation_Response = {
  __typename?: 'user_partner_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Partner_Type>;
};

/** on_conflict condition type for table "user_partner_type" */
export type User_Partner_Type_On_Conflict = {
  constraint: User_Partner_Type_Constraint;
  update_columns?: Array<User_Partner_Type_Update_Column>;
  where?: InputMaybe<User_Partner_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "user_partner_type". */
export type User_Partner_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_partner_type */
export type User_Partner_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "user_partner_type" */
export enum User_Partner_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "user_partner_type" */
export type User_Partner_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "user_partner_type" */
export type User_Partner_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Partner_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Partner_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "user_partner_type" */
export enum User_Partner_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type User_Partner_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Partner_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Partner_Type_Bool_Exp;
};

/** primary key columns input for table: user */
export type User_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "user_referral" */
export type User_Referral = {
  __typename?: 'user_referral';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  referral_id: Scalars['uuid']['output'];
  /** An object relationship */
  user: User;
  /** An object relationship */
  userByUserId: User;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "user_referral" */
export type User_Referral_Aggregate = {
  __typename?: 'user_referral_aggregate';
  aggregate?: Maybe<User_Referral_Aggregate_Fields>;
  nodes: Array<User_Referral>;
};

export type User_Referral_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<User_Referral_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Referral_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<User_Referral_Aggregate_Bool_Exp_Count>;
};

export type User_Referral_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Referral_Select_Column_User_Referral_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Referral_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Referral_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Referral_Select_Column_User_Referral_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Referral_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Referral_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Referral_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Referral_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_referral" */
export type User_Referral_Aggregate_Fields = {
  __typename?: 'user_referral_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_Referral_Max_Fields>;
  min?: Maybe<User_Referral_Min_Fields>;
};


/** aggregate fields of "user_referral" */
export type User_Referral_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Referral_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_referral" */
export type User_Referral_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Referral_Max_Order_By>;
  min?: InputMaybe<User_Referral_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_referral" */
export type User_Referral_Arr_Rel_Insert_Input = {
  data: Array<User_Referral_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Referral_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user_referral". All fields are combined with a logical 'AND'. */
export type User_Referral_Bool_Exp = {
  _and?: InputMaybe<Array<User_Referral_Bool_Exp>>;
  _not?: InputMaybe<User_Referral_Bool_Exp>;
  _or?: InputMaybe<Array<User_Referral_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  referral_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userByUserId?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_referral" */
export enum User_Referral_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserReferralPkey = 'user_referral_pkey'
}

/** input type for inserting data into table "user_referral" */
export type User_Referral_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  referral_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userByUserId?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type User_Referral_Max_Fields = {
  __typename?: 'user_referral_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  referral_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "user_referral" */
export type User_Referral_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  referral_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Referral_Min_Fields = {
  __typename?: 'user_referral_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  referral_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "user_referral" */
export type User_Referral_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  referral_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_referral" */
export type User_Referral_Mutation_Response = {
  __typename?: 'user_referral_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Referral>;
};

/** on_conflict condition type for table "user_referral" */
export type User_Referral_On_Conflict = {
  constraint: User_Referral_Constraint;
  update_columns?: Array<User_Referral_Update_Column>;
  where?: InputMaybe<User_Referral_Bool_Exp>;
};

/** Ordering options when selecting data from "user_referral". */
export type User_Referral_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  referral_id?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userByUserId?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_referral */
export type User_Referral_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_referral" */
export enum User_Referral_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  ReferralId = 'referral_id',
  /** column name */
  UserId = 'user_id'
}

/** select "user_referral_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_referral" */
export enum User_Referral_Select_Column_User_Referral_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "user_referral_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_referral" */
export enum User_Referral_Select_Column_User_Referral_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "user_referral" */
export type User_Referral_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  referral_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "user_referral" */
export type User_Referral_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Referral_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Referral_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  referral_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "user_referral" */
export enum User_Referral_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  ReferralId = 'referral_id',
  /** column name */
  UserId = 'user_id'
}

export type User_Referral_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Referral_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Referral_Bool_Exp;
};

/** columns and relationships of "user_role" */
export type User_Role = {
  __typename?: 'user_role';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  role: Role;
  role_id: Scalars['uuid']['output'];
  /** An object relationship */
  user: User;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "user_role" */
export type User_Role_Aggregate = {
  __typename?: 'user_role_aggregate';
  aggregate?: Maybe<User_Role_Aggregate_Fields>;
  nodes: Array<User_Role>;
};

export type User_Role_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<User_Role_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Role_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<User_Role_Aggregate_Bool_Exp_Count>;
};

export type User_Role_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Role_Select_Column_User_Role_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Role_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Role_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Role_Select_Column_User_Role_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Role_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Role_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Role_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Role_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_role" */
export type User_Role_Aggregate_Fields = {
  __typename?: 'user_role_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_Role_Max_Fields>;
  min?: Maybe<User_Role_Min_Fields>;
};


/** aggregate fields of "user_role" */
export type User_Role_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Role_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_role" */
export type User_Role_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Role_Max_Order_By>;
  min?: InputMaybe<User_Role_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_role" */
export type User_Role_Arr_Rel_Insert_Input = {
  data: Array<User_Role_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Role_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user_role". All fields are combined with a logical 'AND'. */
export type User_Role_Bool_Exp = {
  _and?: InputMaybe<Array<User_Role_Bool_Exp>>;
  _not?: InputMaybe<User_Role_Bool_Exp>;
  _or?: InputMaybe<Array<User_Role_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  role?: InputMaybe<Role_Bool_Exp>;
  role_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_role" */
export enum User_Role_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserRolePkey = 'user_role_pkey'
}

/** input type for inserting data into table "user_role" */
export type User_Role_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Role_Obj_Rel_Insert_Input>;
  role_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type User_Role_Max_Fields = {
  __typename?: 'user_role_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  role_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "user_role" */
export type User_Role_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Role_Min_Fields = {
  __typename?: 'user_role_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  role_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "user_role" */
export type User_Role_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_role" */
export type User_Role_Mutation_Response = {
  __typename?: 'user_role_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Role>;
};

/** on_conflict condition type for table "user_role" */
export type User_Role_On_Conflict = {
  constraint: User_Role_Constraint;
  update_columns?: Array<User_Role_Update_Column>;
  where?: InputMaybe<User_Role_Bool_Exp>;
};

/** Ordering options when selecting data from "user_role". */
export type User_Role_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  role?: InputMaybe<Role_Order_By>;
  role_id?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_role */
export type User_Role_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_role" */
export enum User_Role_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  UserId = 'user_id'
}

/** select "user_role_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_role" */
export enum User_Role_Select_Column_User_Role_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "user_role_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_role" */
export enum User_Role_Select_Column_User_Role_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "user_role" */
export type User_Role_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  role_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "user_role" */
export type User_Role_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Role_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Role_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  role_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "user_role" */
export enum User_Role_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  UserId = 'user_id'
}

export type User_Role_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Role_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Role_Bool_Exp;
};

/** select columns of table "user" */
export enum User_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerCode = 'customer_code',
  /** column name */
  CustomerSegmentationId = 'customer_segmentation_id',
  /** column name */
  DeliveryOtp = 'delivery_otp',
  /** column name */
  Description = 'description',
  /** column name */
  DriverCode = 'driver_code',
  /** column name */
  Email = 'email',
  /** column name */
  ErpCode = 'erp_code',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  GoogleFirebaseId = 'google_firebase_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsTest = 'is_test',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LicenseNumber = 'license_number',
  /** column name */
  MiddleName = 'middle_name',
  /** column name */
  PanNumber = 'pan_number',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  ProfilePic = 'profile_pic',
  /** column name */
  ReferralCode = 'referral_code',
  /** column name */
  TimeZone = 'time_zone',
  /** column name */
  VerifiedAt = 'verified_at'
}

/** select "user_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user" */
export enum User_Select_Column_User_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  DeliveryOtp = 'delivery_otp',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsTest = 'is_test'
}

/** select "user_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user" */
export enum User_Select_Column_User_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  DeliveryOtp = 'delivery_otp',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsTest = 'is_test'
}

/** input type for updating data in table "user" */
export type User_Set_Input = {
  code?: InputMaybe<Scalars['bigint']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_code?: InputMaybe<Scalars['bigint']['input']>;
  customer_segmentation_id?: InputMaybe<Scalars['uuid']['input']>;
  delivery_otp?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  driver_code?: InputMaybe<Scalars['bigint']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  erp_code?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  google_firebase_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_test?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  license_number?: InputMaybe<Scalars['String']['input']>;
  middle_name?: InputMaybe<Scalars['String']['input']>;
  pan_number?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  profile_pic?: InputMaybe<Scalars['String']['input']>;
  referral_code?: InputMaybe<Scalars['String']['input']>;
  time_zone?: InputMaybe<Scalars['String']['input']>;
  verified_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type User_Stddev_Fields = {
  __typename?: 'user_stddev_fields';
  code?: Maybe<Scalars['Float']['output']>;
  customer_code?: Maybe<Scalars['Float']['output']>;
  driver_code?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "user" */
export type User_Stddev_Order_By = {
  code?: InputMaybe<Order_By>;
  customer_code?: InputMaybe<Order_By>;
  driver_code?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Stddev_Pop_Fields = {
  __typename?: 'user_stddev_pop_fields';
  code?: Maybe<Scalars['Float']['output']>;
  customer_code?: Maybe<Scalars['Float']['output']>;
  driver_code?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "user" */
export type User_Stddev_Pop_Order_By = {
  code?: InputMaybe<Order_By>;
  customer_code?: InputMaybe<Order_By>;
  driver_code?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Stddev_Samp_Fields = {
  __typename?: 'user_stddev_samp_fields';
  code?: Maybe<Scalars['Float']['output']>;
  customer_code?: Maybe<Scalars['Float']['output']>;
  driver_code?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "user" */
export type User_Stddev_Samp_Order_By = {
  code?: InputMaybe<Order_By>;
  customer_code?: InputMaybe<Order_By>;
  driver_code?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user" */
export type User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['bigint']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_code?: InputMaybe<Scalars['bigint']['input']>;
  customer_segmentation_id?: InputMaybe<Scalars['uuid']['input']>;
  delivery_otp?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  driver_code?: InputMaybe<Scalars['bigint']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  erp_code?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  google_firebase_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_test?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  license_number?: InputMaybe<Scalars['String']['input']>;
  middle_name?: InputMaybe<Scalars['String']['input']>;
  pan_number?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  profile_pic?: InputMaybe<Scalars['String']['input']>;
  referral_code?: InputMaybe<Scalars['String']['input']>;
  time_zone?: InputMaybe<Scalars['String']['input']>;
  verified_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type User_Sum_Fields = {
  __typename?: 'user_sum_fields';
  code?: Maybe<Scalars['bigint']['output']>;
  customer_code?: Maybe<Scalars['bigint']['output']>;
  driver_code?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "user" */
export type User_Sum_Order_By = {
  code?: InputMaybe<Order_By>;
  customer_code?: InputMaybe<Order_By>;
  driver_code?: InputMaybe<Order_By>;
};

/** update columns of table "user" */
export enum User_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerCode = 'customer_code',
  /** column name */
  CustomerSegmentationId = 'customer_segmentation_id',
  /** column name */
  DeliveryOtp = 'delivery_otp',
  /** column name */
  Description = 'description',
  /** column name */
  DriverCode = 'driver_code',
  /** column name */
  Email = 'email',
  /** column name */
  ErpCode = 'erp_code',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  GoogleFirebaseId = 'google_firebase_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsTest = 'is_test',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LicenseNumber = 'license_number',
  /** column name */
  MiddleName = 'middle_name',
  /** column name */
  PanNumber = 'pan_number',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  ProfilePic = 'profile_pic',
  /** column name */
  ReferralCode = 'referral_code',
  /** column name */
  TimeZone = 'time_zone',
  /** column name */
  VerifiedAt = 'verified_at'
}

export type User_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Var_Pop_Fields = {
  __typename?: 'user_var_pop_fields';
  code?: Maybe<Scalars['Float']['output']>;
  customer_code?: Maybe<Scalars['Float']['output']>;
  driver_code?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "user" */
export type User_Var_Pop_Order_By = {
  code?: InputMaybe<Order_By>;
  customer_code?: InputMaybe<Order_By>;
  driver_code?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Var_Samp_Fields = {
  __typename?: 'user_var_samp_fields';
  code?: Maybe<Scalars['Float']['output']>;
  customer_code?: Maybe<Scalars['Float']['output']>;
  driver_code?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "user" */
export type User_Var_Samp_Order_By = {
  code?: InputMaybe<Order_By>;
  customer_code?: InputMaybe<Order_By>;
  driver_code?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Variance_Fields = {
  __typename?: 'user_variance_fields';
  code?: Maybe<Scalars['Float']['output']>;
  customer_code?: Maybe<Scalars['Float']['output']>;
  driver_code?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "user" */
export type User_Variance_Order_By = {
  code?: InputMaybe<Order_By>;
  customer_code?: InputMaybe<Order_By>;
  driver_code?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/** Boolean expression to compare columns of type "validation_workflow_status". All fields are combined with logical 'AND'. */
export type Validation_Workflow_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['validation_workflow_status']['input']>;
  _gt?: InputMaybe<Scalars['validation_workflow_status']['input']>;
  _gte?: InputMaybe<Scalars['validation_workflow_status']['input']>;
  _in?: InputMaybe<Array<Scalars['validation_workflow_status']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['validation_workflow_status']['input']>;
  _lte?: InputMaybe<Scalars['validation_workflow_status']['input']>;
  _neq?: InputMaybe<Scalars['validation_workflow_status']['input']>;
  _nin?: InputMaybe<Array<Scalars['validation_workflow_status']['input']>>;
};

/** columns and relationships of "validation_workflows" */
export type Validation_Workflows = {
  __typename?: 'validation_workflows';
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  ruleset_version: Scalars['String']['output'];
  status: Scalars['validation_workflow_status']['output'];
  /** An object relationship */
  task: Task;
  task_id: Scalars['uuid']['output'];
  validation_result?: Maybe<Scalars['jsonb']['output']>;
  workflow_id: Scalars['String']['output'];
  workflow_run_id: Scalars['String']['output'];
  workflow_version: Scalars['String']['output'];
};


/** columns and relationships of "validation_workflows" */
export type Validation_WorkflowsValidation_ResultArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "validation_workflows" */
export type Validation_Workflows_Aggregate = {
  __typename?: 'validation_workflows_aggregate';
  aggregate?: Maybe<Validation_Workflows_Aggregate_Fields>;
  nodes: Array<Validation_Workflows>;
};

export type Validation_Workflows_Aggregate_Bool_Exp = {
  count?: InputMaybe<Validation_Workflows_Aggregate_Bool_Exp_Count>;
};

export type Validation_Workflows_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Validation_Workflows_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Validation_Workflows_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "validation_workflows" */
export type Validation_Workflows_Aggregate_Fields = {
  __typename?: 'validation_workflows_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Validation_Workflows_Max_Fields>;
  min?: Maybe<Validation_Workflows_Min_Fields>;
};


/** aggregate fields of "validation_workflows" */
export type Validation_Workflows_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Validation_Workflows_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "validation_workflows" */
export type Validation_Workflows_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Validation_Workflows_Max_Order_By>;
  min?: InputMaybe<Validation_Workflows_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Validation_Workflows_Append_Input = {
  validation_result?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "validation_workflows" */
export type Validation_Workflows_Arr_Rel_Insert_Input = {
  data: Array<Validation_Workflows_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Validation_Workflows_On_Conflict>;
};

/** Boolean expression to filter rows from the table "validation_workflows". All fields are combined with a logical 'AND'. */
export type Validation_Workflows_Bool_Exp = {
  _and?: InputMaybe<Array<Validation_Workflows_Bool_Exp>>;
  _not?: InputMaybe<Validation_Workflows_Bool_Exp>;
  _or?: InputMaybe<Array<Validation_Workflows_Bool_Exp>>;
  completed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ruleset_version?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Validation_Workflow_Status_Comparison_Exp>;
  task?: InputMaybe<Task_Bool_Exp>;
  task_id?: InputMaybe<Uuid_Comparison_Exp>;
  validation_result?: InputMaybe<Jsonb_Comparison_Exp>;
  workflow_id?: InputMaybe<String_Comparison_Exp>;
  workflow_run_id?: InputMaybe<String_Comparison_Exp>;
  workflow_version?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "validation_workflows" */
export enum Validation_Workflows_Constraint {
  /** unique or primary key constraint on columns "id" */
  ValidationWorkflowsPkey = 'validation_workflows_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Validation_Workflows_Delete_At_Path_Input = {
  validation_result?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Validation_Workflows_Delete_Elem_Input = {
  validation_result?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Validation_Workflows_Delete_Key_Input = {
  validation_result?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "validation_workflows" */
export type Validation_Workflows_Insert_Input = {
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ruleset_version?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['validation_workflow_status']['input']>;
  task?: InputMaybe<Task_Obj_Rel_Insert_Input>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
  validation_result?: InputMaybe<Scalars['jsonb']['input']>;
  workflow_id?: InputMaybe<Scalars['String']['input']>;
  workflow_run_id?: InputMaybe<Scalars['String']['input']>;
  workflow_version?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Validation_Workflows_Max_Fields = {
  __typename?: 'validation_workflows_max_fields';
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ruleset_version?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['validation_workflow_status']['output']>;
  task_id?: Maybe<Scalars['uuid']['output']>;
  workflow_id?: Maybe<Scalars['String']['output']>;
  workflow_run_id?: Maybe<Scalars['String']['output']>;
  workflow_version?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "validation_workflows" */
export type Validation_Workflows_Max_Order_By = {
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ruleset_version?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
  workflow_run_id?: InputMaybe<Order_By>;
  workflow_version?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Validation_Workflows_Min_Fields = {
  __typename?: 'validation_workflows_min_fields';
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ruleset_version?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['validation_workflow_status']['output']>;
  task_id?: Maybe<Scalars['uuid']['output']>;
  workflow_id?: Maybe<Scalars['String']['output']>;
  workflow_run_id?: Maybe<Scalars['String']['output']>;
  workflow_version?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "validation_workflows" */
export type Validation_Workflows_Min_Order_By = {
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ruleset_version?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
  workflow_run_id?: InputMaybe<Order_By>;
  workflow_version?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "validation_workflows" */
export type Validation_Workflows_Mutation_Response = {
  __typename?: 'validation_workflows_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Validation_Workflows>;
};

/** on_conflict condition type for table "validation_workflows" */
export type Validation_Workflows_On_Conflict = {
  constraint: Validation_Workflows_Constraint;
  update_columns?: Array<Validation_Workflows_Update_Column>;
  where?: InputMaybe<Validation_Workflows_Bool_Exp>;
};

/** Ordering options when selecting data from "validation_workflows". */
export type Validation_Workflows_Order_By = {
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ruleset_version?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  task?: InputMaybe<Task_Order_By>;
  task_id?: InputMaybe<Order_By>;
  validation_result?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
  workflow_run_id?: InputMaybe<Order_By>;
  workflow_version?: InputMaybe<Order_By>;
};

/** primary key columns input for table: validation_workflows */
export type Validation_Workflows_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Validation_Workflows_Prepend_Input = {
  validation_result?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "validation_workflows" */
export enum Validation_Workflows_Select_Column {
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  RulesetVersion = 'ruleset_version',
  /** column name */
  Status = 'status',
  /** column name */
  TaskId = 'task_id',
  /** column name */
  ValidationResult = 'validation_result',
  /** column name */
  WorkflowId = 'workflow_id',
  /** column name */
  WorkflowRunId = 'workflow_run_id',
  /** column name */
  WorkflowVersion = 'workflow_version'
}

/** input type for updating data in table "validation_workflows" */
export type Validation_Workflows_Set_Input = {
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ruleset_version?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['validation_workflow_status']['input']>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
  validation_result?: InputMaybe<Scalars['jsonb']['input']>;
  workflow_id?: InputMaybe<Scalars['String']['input']>;
  workflow_run_id?: InputMaybe<Scalars['String']['input']>;
  workflow_version?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "validation_workflows" */
export type Validation_Workflows_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Validation_Workflows_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Validation_Workflows_Stream_Cursor_Value_Input = {
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ruleset_version?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['validation_workflow_status']['input']>;
  task_id?: InputMaybe<Scalars['uuid']['input']>;
  validation_result?: InputMaybe<Scalars['jsonb']['input']>;
  workflow_id?: InputMaybe<Scalars['String']['input']>;
  workflow_run_id?: InputMaybe<Scalars['String']['input']>;
  workflow_version?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "validation_workflows" */
export enum Validation_Workflows_Update_Column {
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  RulesetVersion = 'ruleset_version',
  /** column name */
  Status = 'status',
  /** column name */
  TaskId = 'task_id',
  /** column name */
  ValidationResult = 'validation_result',
  /** column name */
  WorkflowId = 'workflow_id',
  /** column name */
  WorkflowRunId = 'workflow_run_id',
  /** column name */
  WorkflowVersion = 'workflow_version'
}

export type Validation_Workflows_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Validation_Workflows_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Validation_Workflows_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Validation_Workflows_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Validation_Workflows_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Validation_Workflows_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Validation_Workflows_Set_Input>;
  /** filter the rows which have to be updated */
  where: Validation_Workflows_Bool_Exp;
};

/** columns and relationships of "variation" */
export type Variation = {
  __typename?: 'variation';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  pack_size: Scalars['String']['output'];
  /** An array relationship */
  product_variations: Array<Product_Variation>;
  /** An aggregate relationship */
  product_variations_aggregate: Product_Variation_Aggregate;
  slug: Scalars['String']['output'];
  /** An object relationship */
  variationTypeByVariationType: Variation_Type;
  variation_name?: Maybe<Scalars['String']['output']>;
  variation_type: Variation_Type_Enum;
};


/** columns and relationships of "variation" */
export type VariationProduct_VariationsArgs = {
  distinct_on?: InputMaybe<Array<Product_Variation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Variation_Order_By>>;
  where?: InputMaybe<Product_Variation_Bool_Exp>;
};


/** columns and relationships of "variation" */
export type VariationProduct_Variations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Variation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Variation_Order_By>>;
  where?: InputMaybe<Product_Variation_Bool_Exp>;
};

/** aggregated selection of "variation" */
export type Variation_Aggregate = {
  __typename?: 'variation_aggregate';
  aggregate?: Maybe<Variation_Aggregate_Fields>;
  nodes: Array<Variation>;
};

export type Variation_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Variation_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Variation_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Variation_Aggregate_Bool_Exp_Count>;
};

export type Variation_Aggregate_Bool_Exp_Bool_And = {
  arguments: Variation_Select_Column_Variation_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Variation_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Variation_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Variation_Select_Column_Variation_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Variation_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Variation_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Variation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Variation_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "variation" */
export type Variation_Aggregate_Fields = {
  __typename?: 'variation_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Variation_Max_Fields>;
  min?: Maybe<Variation_Min_Fields>;
};


/** aggregate fields of "variation" */
export type Variation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Variation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "variation" */
export type Variation_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Variation_Max_Order_By>;
  min?: InputMaybe<Variation_Min_Order_By>;
};

/** input type for inserting array relation for remote table "variation" */
export type Variation_Arr_Rel_Insert_Input = {
  data: Array<Variation_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Variation_On_Conflict>;
};

/** Boolean expression to filter rows from the table "variation". All fields are combined with a logical 'AND'. */
export type Variation_Bool_Exp = {
  _and?: InputMaybe<Array<Variation_Bool_Exp>>;
  _not?: InputMaybe<Variation_Bool_Exp>;
  _or?: InputMaybe<Array<Variation_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  pack_size?: InputMaybe<String_Comparison_Exp>;
  product_variations?: InputMaybe<Product_Variation_Bool_Exp>;
  product_variations_aggregate?: InputMaybe<Product_Variation_Aggregate_Bool_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  variationTypeByVariationType?: InputMaybe<Variation_Type_Bool_Exp>;
  variation_name?: InputMaybe<String_Comparison_Exp>;
  variation_type?: InputMaybe<Variation_Type_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "variation" */
export enum Variation_Constraint {
  /** unique or primary key constraint on columns "id" */
  VariationPkey = 'variation_pkey'
}

/** input type for inserting data into table "variation" */
export type Variation_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  pack_size?: InputMaybe<Scalars['String']['input']>;
  product_variations?: InputMaybe<Product_Variation_Arr_Rel_Insert_Input>;
  slug?: InputMaybe<Scalars['String']['input']>;
  variationTypeByVariationType?: InputMaybe<Variation_Type_Obj_Rel_Insert_Input>;
  variation_name?: InputMaybe<Scalars['String']['input']>;
  variation_type?: InputMaybe<Variation_Type_Enum>;
};

/** aggregate max on columns */
export type Variation_Max_Fields = {
  __typename?: 'variation_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  pack_size?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  variation_name?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "variation" */
export type Variation_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  pack_size?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  variation_name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Variation_Min_Fields = {
  __typename?: 'variation_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  pack_size?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  variation_name?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "variation" */
export type Variation_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  pack_size?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  variation_name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "variation" */
export type Variation_Mutation_Response = {
  __typename?: 'variation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Variation>;
};

/** input type for inserting object relation for remote table "variation" */
export type Variation_Obj_Rel_Insert_Input = {
  data: Variation_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Variation_On_Conflict>;
};

/** on_conflict condition type for table "variation" */
export type Variation_On_Conflict = {
  constraint: Variation_Constraint;
  update_columns?: Array<Variation_Update_Column>;
  where?: InputMaybe<Variation_Bool_Exp>;
};

/** Ordering options when selecting data from "variation". */
export type Variation_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  pack_size?: InputMaybe<Order_By>;
  product_variations_aggregate?: InputMaybe<Product_Variation_Aggregate_Order_By>;
  slug?: InputMaybe<Order_By>;
  variationTypeByVariationType?: InputMaybe<Variation_Type_Order_By>;
  variation_name?: InputMaybe<Order_By>;
  variation_type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: variation */
export type Variation_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "variation" */
export enum Variation_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PackSize = 'pack_size',
  /** column name */
  Slug = 'slug',
  /** column name */
  VariationName = 'variation_name',
  /** column name */
  VariationType = 'variation_type'
}

/** select "variation_aggregate_bool_exp_bool_and_arguments_columns" columns of table "variation" */
export enum Variation_Select_Column_Variation_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "variation_aggregate_bool_exp_bool_or_arguments_columns" columns of table "variation" */
export enum Variation_Select_Column_Variation_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "variation" */
export type Variation_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  pack_size?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  variation_name?: InputMaybe<Scalars['String']['input']>;
  variation_type?: InputMaybe<Variation_Type_Enum>;
};

/** Streaming cursor of the table "variation" */
export type Variation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Variation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Variation_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  pack_size?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  variation_name?: InputMaybe<Scalars['String']['input']>;
  variation_type?: InputMaybe<Variation_Type_Enum>;
};

/** columns and relationships of "variation_type" */
export type Variation_Type = {
  __typename?: 'variation_type';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
  /** An array relationship */
  variations: Array<Variation>;
  /** An aggregate relationship */
  variations_aggregate: Variation_Aggregate;
};


/** columns and relationships of "variation_type" */
export type Variation_TypeVariationsArgs = {
  distinct_on?: InputMaybe<Array<Variation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variation_Order_By>>;
  where?: InputMaybe<Variation_Bool_Exp>;
};


/** columns and relationships of "variation_type" */
export type Variation_TypeVariations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variation_Order_By>>;
  where?: InputMaybe<Variation_Bool_Exp>;
};

/** aggregated selection of "variation_type" */
export type Variation_Type_Aggregate = {
  __typename?: 'variation_type_aggregate';
  aggregate?: Maybe<Variation_Type_Aggregate_Fields>;
  nodes: Array<Variation_Type>;
};

/** aggregate fields of "variation_type" */
export type Variation_Type_Aggregate_Fields = {
  __typename?: 'variation_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Variation_Type_Max_Fields>;
  min?: Maybe<Variation_Type_Min_Fields>;
};


/** aggregate fields of "variation_type" */
export type Variation_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Variation_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "variation_type". All fields are combined with a logical 'AND'. */
export type Variation_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Variation_Type_Bool_Exp>>;
  _not?: InputMaybe<Variation_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Variation_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
  variations?: InputMaybe<Variation_Bool_Exp>;
  variations_aggregate?: InputMaybe<Variation_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "variation_type" */
export enum Variation_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  VariationTypePkey = 'variation_type_pkey'
}

export enum Variation_Type_Enum {
  /** ADD_ON */
  AddOn = 'ADD_ON',
  /** FINISH_GOOD */
  FinishGood = 'FINISH_GOOD'
}

/** Boolean expression to compare columns of type "variation_type_enum". All fields are combined with logical 'AND'. */
export type Variation_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Variation_Type_Enum>;
  _in?: InputMaybe<Array<Variation_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Variation_Type_Enum>;
  _nin?: InputMaybe<Array<Variation_Type_Enum>>;
};

/** input type for inserting data into table "variation_type" */
export type Variation_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  variations?: InputMaybe<Variation_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Variation_Type_Max_Fields = {
  __typename?: 'variation_type_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Variation_Type_Min_Fields = {
  __typename?: 'variation_type_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "variation_type" */
export type Variation_Type_Mutation_Response = {
  __typename?: 'variation_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Variation_Type>;
};

/** input type for inserting object relation for remote table "variation_type" */
export type Variation_Type_Obj_Rel_Insert_Input = {
  data: Variation_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Variation_Type_On_Conflict>;
};

/** on_conflict condition type for table "variation_type" */
export type Variation_Type_On_Conflict = {
  constraint: Variation_Type_Constraint;
  update_columns?: Array<Variation_Type_Update_Column>;
  where?: InputMaybe<Variation_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "variation_type". */
export type Variation_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  variations_aggregate?: InputMaybe<Variation_Aggregate_Order_By>;
};

/** primary key columns input for table: variation_type */
export type Variation_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "variation_type" */
export enum Variation_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "variation_type" */
export type Variation_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "variation_type" */
export type Variation_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Variation_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Variation_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "variation_type" */
export enum Variation_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Variation_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Variation_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Variation_Type_Bool_Exp;
};

/** update columns of table "variation" */
export enum Variation_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PackSize = 'pack_size',
  /** column name */
  Slug = 'slug',
  /** column name */
  VariationName = 'variation_name',
  /** column name */
  VariationType = 'variation_type'
}

export type Variation_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Variation_Set_Input>;
  /** filter the rows which have to be updated */
  where: Variation_Bool_Exp;
};

/** columns and relationships of "vehicle" */
export type Vehicle = {
  __typename?: 'vehicle';
  category?: Maybe<Scalars['String']['output']>;
  chassis_number?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  delivery_schedulers: Array<Delivery_Scheduler>;
  /** An aggregate relationship */
  delivery_schedulers_aggregate: Delivery_Scheduler_Aggregate;
  description?: Maybe<Scalars['String']['output']>;
  device_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  dispensers: Array<Dispenser>;
  /** An aggregate relationship */
  dispensers_aggregate: Dispenser_Aggregate;
  /** An array relationship */
  driver_vehicles: Array<Driver_Vehicle>;
  /** An aggregate relationship */
  driver_vehicles_aggregate: Driver_Vehicle_Aggregate;
  erp_code?: Maybe<Scalars['String']['output']>;
  fuel_tank_capacity?: Maybe<Scalars['Int']['output']>;
  fueltrans_enabled: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  insurance_expire_date?: Maybe<Scalars['date']['output']>;
  is_active: Scalars['Boolean']['output'];
  is_mothership: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  location?: Maybe<Scalars['point']['output']>;
  make?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  master_slots: Array<Master_Slot>;
  /** An aggregate relationship */
  master_slots_aggregate: Master_Slot_Aggregate;
  model?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** An object relationship */
  partner_address?: Maybe<Partner_Address>;
  partner_address_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  partner_vehicles: Array<Partner_Vehicle>;
  /** An aggregate relationship */
  partner_vehicles_aggregate: Partner_Vehicle_Aggregate;
  plate_code?: Maybe<Scalars['String']['output']>;
  plate_number?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
  rated_capacity?: Maybe<Scalars['Int']['output']>;
  rc_expire_date?: Maybe<Scalars['date']['output']>;
  registration_number?: Maybe<Scalars['String']['output']>;
  rfid?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  shift_schedules: Array<Shift_Schedule>;
  /** An aggregate relationship */
  shift_schedules_aggregate: Shift_Schedule_Aggregate;
  /** An object relationship */
  state?: Maybe<State>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Vehicle_Status_Enum>;
  tanker_capacity?: Maybe<Scalars['Int']['output']>;
  tanker_compartment_number?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  taskStatesFlowsByPreviousVehicleId: Array<Task_States_Flow>;
  /** An aggregate relationship */
  taskStatesFlowsByPreviousVehicleId_aggregate: Task_States_Flow_Aggregate;
  /** An array relationship */
  tasks: Array<Task>;
  /** An aggregate relationship */
  tasks_aggregate: Task_Aggregate;
  /** An array relationship */
  trip_plans: Array<Trip_Plan>;
  /** An aggregate relationship */
  trip_plans_aggregate: Trip_Plan_Aggregate;
  /** An object relationship */
  vehicleStatusByStatus?: Maybe<Vehicle_Status>;
  /** An object relationship */
  vehicleTypeByVehicleType?: Maybe<Vehicle_Type>;
  /** An array relationship */
  vehicle_configurations: Array<Vehicle_Configuration>;
  /** An aggregate relationship */
  vehicle_configurations_aggregate: Vehicle_Configuration_Aggregate;
  /** An array relationship */
  vehicle_devices: Array<Vehicle_Device>;
  /** An aggregate relationship */
  vehicle_devices_aggregate: Vehicle_Device_Aggregate;
  /** An array relationship */
  vehicle_inventory_transaction_logs: Array<Vehicle_Inventory_Transaction_Logs>;
  /** An aggregate relationship */
  vehicle_inventory_transaction_logs_aggregate: Vehicle_Inventory_Transaction_Logs_Aggregate;
  /** An array relationship */
  vehicle_localities: Array<Vehicle_Localities>;
  /** An aggregate relationship */
  vehicle_localities_aggregate: Vehicle_Localities_Aggregate;
  /** An array relationship */
  vehicle_permits: Array<Vehicle_Permit>;
  /** An aggregate relationship */
  vehicle_permits_aggregate: Vehicle_Permit_Aggregate;
  /** An array relationship */
  vehicle_shift_templates: Array<Vehicle_Shift_Template>;
  /** An aggregate relationship */
  vehicle_shift_templates_aggregate: Vehicle_Shift_Template_Aggregate;
  /** An array relationship */
  vehicle_status_logs: Array<Vehicle_Status_Logs>;
  /** An aggregate relationship */
  vehicle_status_logs_aggregate: Vehicle_Status_Logs_Aggregate;
  /** An array relationship */
  vehicle_tank_types: Array<Vehicle_Tank_Type>;
  /** An aggregate relationship */
  vehicle_tank_types_aggregate: Vehicle_Tank_Type_Aggregate;
  vehicle_type?: Maybe<Vehicle_Type_Enum>;
  /** An array relationship */
  vendor_order_logs: Array<Vendor_Order_Logs>;
  /** An aggregate relationship */
  vendor_order_logs_aggregate: Vendor_Order_Logs_Aggregate;
  year?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "vehicle" */
export type VehicleDelivery_SchedulersArgs = {
  distinct_on?: InputMaybe<Array<Delivery_Scheduler_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delivery_Scheduler_Order_By>>;
  where?: InputMaybe<Delivery_Scheduler_Bool_Exp>;
};


/** columns and relationships of "vehicle" */
export type VehicleDelivery_Schedulers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Delivery_Scheduler_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delivery_Scheduler_Order_By>>;
  where?: InputMaybe<Delivery_Scheduler_Bool_Exp>;
};


/** columns and relationships of "vehicle" */
export type VehicleDispensersArgs = {
  distinct_on?: InputMaybe<Array<Dispenser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dispenser_Order_By>>;
  where?: InputMaybe<Dispenser_Bool_Exp>;
};


/** columns and relationships of "vehicle" */
export type VehicleDispensers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dispenser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dispenser_Order_By>>;
  where?: InputMaybe<Dispenser_Bool_Exp>;
};


/** columns and relationships of "vehicle" */
export type VehicleDriver_VehiclesArgs = {
  distinct_on?: InputMaybe<Array<Driver_Vehicle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Vehicle_Order_By>>;
  where?: InputMaybe<Driver_Vehicle_Bool_Exp>;
};


/** columns and relationships of "vehicle" */
export type VehicleDriver_Vehicles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Driver_Vehicle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Vehicle_Order_By>>;
  where?: InputMaybe<Driver_Vehicle_Bool_Exp>;
};


/** columns and relationships of "vehicle" */
export type VehicleMaster_SlotsArgs = {
  distinct_on?: InputMaybe<Array<Master_Slot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Slot_Order_By>>;
  where?: InputMaybe<Master_Slot_Bool_Exp>;
};


/** columns and relationships of "vehicle" */
export type VehicleMaster_Slots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Master_Slot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Master_Slot_Order_By>>;
  where?: InputMaybe<Master_Slot_Bool_Exp>;
};


/** columns and relationships of "vehicle" */
export type VehiclePartner_VehiclesArgs = {
  distinct_on?: InputMaybe<Array<Partner_Vehicle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Vehicle_Order_By>>;
  where?: InputMaybe<Partner_Vehicle_Bool_Exp>;
};


/** columns and relationships of "vehicle" */
export type VehiclePartner_Vehicles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Vehicle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Vehicle_Order_By>>;
  where?: InputMaybe<Partner_Vehicle_Bool_Exp>;
};


/** columns and relationships of "vehicle" */
export type VehicleShift_SchedulesArgs = {
  distinct_on?: InputMaybe<Array<Shift_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shift_Schedule_Order_By>>;
  where?: InputMaybe<Shift_Schedule_Bool_Exp>;
};


/** columns and relationships of "vehicle" */
export type VehicleShift_Schedules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shift_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shift_Schedule_Order_By>>;
  where?: InputMaybe<Shift_Schedule_Bool_Exp>;
};


/** columns and relationships of "vehicle" */
export type VehicleTaskStatesFlowsByPreviousVehicleIdArgs = {
  distinct_on?: InputMaybe<Array<Task_States_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_States_Flow_Order_By>>;
  where?: InputMaybe<Task_States_Flow_Bool_Exp>;
};


/** columns and relationships of "vehicle" */
export type VehicleTaskStatesFlowsByPreviousVehicleId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_States_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_States_Flow_Order_By>>;
  where?: InputMaybe<Task_States_Flow_Bool_Exp>;
};


/** columns and relationships of "vehicle" */
export type VehicleTasksArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


/** columns and relationships of "vehicle" */
export type VehicleTasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


/** columns and relationships of "vehicle" */
export type VehicleTrip_PlansArgs = {
  distinct_on?: InputMaybe<Array<Trip_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trip_Plan_Order_By>>;
  where?: InputMaybe<Trip_Plan_Bool_Exp>;
};


/** columns and relationships of "vehicle" */
export type VehicleTrip_Plans_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trip_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trip_Plan_Order_By>>;
  where?: InputMaybe<Trip_Plan_Bool_Exp>;
};


/** columns and relationships of "vehicle" */
export type VehicleVehicle_ConfigurationsArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Configuration_Order_By>>;
  where?: InputMaybe<Vehicle_Configuration_Bool_Exp>;
};


/** columns and relationships of "vehicle" */
export type VehicleVehicle_Configurations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Configuration_Order_By>>;
  where?: InputMaybe<Vehicle_Configuration_Bool_Exp>;
};


/** columns and relationships of "vehicle" */
export type VehicleVehicle_DevicesArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Device_Order_By>>;
  where?: InputMaybe<Vehicle_Device_Bool_Exp>;
};


/** columns and relationships of "vehicle" */
export type VehicleVehicle_Devices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Device_Order_By>>;
  where?: InputMaybe<Vehicle_Device_Bool_Exp>;
};


/** columns and relationships of "vehicle" */
export type VehicleVehicle_Inventory_Transaction_LogsArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Inventory_Transaction_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Inventory_Transaction_Logs_Order_By>>;
  where?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Bool_Exp>;
};


/** columns and relationships of "vehicle" */
export type VehicleVehicle_Inventory_Transaction_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Inventory_Transaction_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Inventory_Transaction_Logs_Order_By>>;
  where?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Bool_Exp>;
};


/** columns and relationships of "vehicle" */
export type VehicleVehicle_LocalitiesArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Localities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Localities_Order_By>>;
  where?: InputMaybe<Vehicle_Localities_Bool_Exp>;
};


/** columns and relationships of "vehicle" */
export type VehicleVehicle_Localities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Localities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Localities_Order_By>>;
  where?: InputMaybe<Vehicle_Localities_Bool_Exp>;
};


/** columns and relationships of "vehicle" */
export type VehicleVehicle_PermitsArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Permit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Permit_Order_By>>;
  where?: InputMaybe<Vehicle_Permit_Bool_Exp>;
};


/** columns and relationships of "vehicle" */
export type VehicleVehicle_Permits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Permit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Permit_Order_By>>;
  where?: InputMaybe<Vehicle_Permit_Bool_Exp>;
};


/** columns and relationships of "vehicle" */
export type VehicleVehicle_Shift_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Shift_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Shift_Template_Order_By>>;
  where?: InputMaybe<Vehicle_Shift_Template_Bool_Exp>;
};


/** columns and relationships of "vehicle" */
export type VehicleVehicle_Shift_Templates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Shift_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Shift_Template_Order_By>>;
  where?: InputMaybe<Vehicle_Shift_Template_Bool_Exp>;
};


/** columns and relationships of "vehicle" */
export type VehicleVehicle_Status_LogsArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Status_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Status_Logs_Order_By>>;
  where?: InputMaybe<Vehicle_Status_Logs_Bool_Exp>;
};


/** columns and relationships of "vehicle" */
export type VehicleVehicle_Status_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Status_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Status_Logs_Order_By>>;
  where?: InputMaybe<Vehicle_Status_Logs_Bool_Exp>;
};


/** columns and relationships of "vehicle" */
export type VehicleVehicle_Tank_TypesArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Tank_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Tank_Type_Order_By>>;
  where?: InputMaybe<Vehicle_Tank_Type_Bool_Exp>;
};


/** columns and relationships of "vehicle" */
export type VehicleVehicle_Tank_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Tank_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Tank_Type_Order_By>>;
  where?: InputMaybe<Vehicle_Tank_Type_Bool_Exp>;
};


/** columns and relationships of "vehicle" */
export type VehicleVendor_Order_LogsArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Order_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Order_Logs_Order_By>>;
  where?: InputMaybe<Vendor_Order_Logs_Bool_Exp>;
};


/** columns and relationships of "vehicle" */
export type VehicleVendor_Order_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Order_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vendor_Order_Logs_Order_By>>;
  where?: InputMaybe<Vendor_Order_Logs_Bool_Exp>;
};

export type VehicleInventoryTransactionLogsInput = {
  end_date: Scalars['timestamp']['input'];
  partner_id: Scalars['uuid']['input'];
  registration_number?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  start_date: Scalars['timestamp']['input'];
};

export type VehicleInventoryTransactionLogsOutput = {
  __typename?: 'vehicleInventoryTransactionLogsOutput';
  vehicle_inventory_transaction_logs?: Maybe<Scalars['jsonb']['output']>;
};

export type VehicleLiveDataInput = {
  end_date: Scalars['timestamp']['input'];
  partner_id: Scalars['uuid']['input'];
  registration_number?: InputMaybe<Array<Scalars['String']['input']>>;
  start_date: Scalars['timestamp']['input'];
};

export type VehicleLiveDataOutput = {
  __typename?: 'vehicleLiveDataOutput';
  data?: Maybe<Scalars['jsonb']['output']>;
};

/** aggregated selection of "vehicle" */
export type Vehicle_Aggregate = {
  __typename?: 'vehicle_aggregate';
  aggregate?: Maybe<Vehicle_Aggregate_Fields>;
  nodes: Array<Vehicle>;
};

export type Vehicle_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Vehicle_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Vehicle_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Vehicle_Aggregate_Bool_Exp_Count>;
};

export type Vehicle_Aggregate_Bool_Exp_Bool_And = {
  arguments: Vehicle_Select_Column_Vehicle_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vehicle_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Vehicle_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Vehicle_Select_Column_Vehicle_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vehicle_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Vehicle_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Vehicle_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vehicle_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "vehicle" */
export type Vehicle_Aggregate_Fields = {
  __typename?: 'vehicle_aggregate_fields';
  avg?: Maybe<Vehicle_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Vehicle_Max_Fields>;
  min?: Maybe<Vehicle_Min_Fields>;
  stddev?: Maybe<Vehicle_Stddev_Fields>;
  stddev_pop?: Maybe<Vehicle_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vehicle_Stddev_Samp_Fields>;
  sum?: Maybe<Vehicle_Sum_Fields>;
  var_pop?: Maybe<Vehicle_Var_Pop_Fields>;
  var_samp?: Maybe<Vehicle_Var_Samp_Fields>;
  variance?: Maybe<Vehicle_Variance_Fields>;
};


/** aggregate fields of "vehicle" */
export type Vehicle_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vehicle_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "vehicle" */
export type Vehicle_Aggregate_Order_By = {
  avg?: InputMaybe<Vehicle_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vehicle_Max_Order_By>;
  min?: InputMaybe<Vehicle_Min_Order_By>;
  stddev?: InputMaybe<Vehicle_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Vehicle_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Vehicle_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Vehicle_Sum_Order_By>;
  var_pop?: InputMaybe<Vehicle_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Vehicle_Var_Samp_Order_By>;
  variance?: InputMaybe<Vehicle_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "vehicle" */
export type Vehicle_Arr_Rel_Insert_Input = {
  data: Array<Vehicle_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Vehicle_On_Conflict>;
};

/** aggregate avg on columns */
export type Vehicle_Avg_Fields = {
  __typename?: 'vehicle_avg_fields';
  fuel_tank_capacity?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  rated_capacity?: Maybe<Scalars['Float']['output']>;
  tanker_capacity?: Maybe<Scalars['Float']['output']>;
  tanker_compartment_number?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "vehicle" */
export type Vehicle_Avg_Order_By = {
  fuel_tank_capacity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rated_capacity?: InputMaybe<Order_By>;
  tanker_capacity?: InputMaybe<Order_By>;
  tanker_compartment_number?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vehicle". All fields are combined with a logical 'AND'. */
export type Vehicle_Bool_Exp = {
  _and?: InputMaybe<Array<Vehicle_Bool_Exp>>;
  _not?: InputMaybe<Vehicle_Bool_Exp>;
  _or?: InputMaybe<Array<Vehicle_Bool_Exp>>;
  category?: InputMaybe<String_Comparison_Exp>;
  chassis_number?: InputMaybe<String_Comparison_Exp>;
  color?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  delivery_schedulers?: InputMaybe<Delivery_Scheduler_Bool_Exp>;
  delivery_schedulers_aggregate?: InputMaybe<Delivery_Scheduler_Aggregate_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  device_id?: InputMaybe<Uuid_Comparison_Exp>;
  dispensers?: InputMaybe<Dispenser_Bool_Exp>;
  dispensers_aggregate?: InputMaybe<Dispenser_Aggregate_Bool_Exp>;
  driver_vehicles?: InputMaybe<Driver_Vehicle_Bool_Exp>;
  driver_vehicles_aggregate?: InputMaybe<Driver_Vehicle_Aggregate_Bool_Exp>;
  erp_code?: InputMaybe<String_Comparison_Exp>;
  fuel_tank_capacity?: InputMaybe<Int_Comparison_Exp>;
  fueltrans_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  insurance_expire_date?: InputMaybe<Date_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_mothership?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<Point_Comparison_Exp>;
  make?: InputMaybe<String_Comparison_Exp>;
  master_slots?: InputMaybe<Master_Slot_Bool_Exp>;
  master_slots_aggregate?: InputMaybe<Master_Slot_Aggregate_Bool_Exp>;
  model?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  partner_address?: InputMaybe<Partner_Address_Bool_Exp>;
  partner_address_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner_vehicles?: InputMaybe<Partner_Vehicle_Bool_Exp>;
  partner_vehicles_aggregate?: InputMaybe<Partner_Vehicle_Aggregate_Bool_Exp>;
  plate_code?: InputMaybe<String_Comparison_Exp>;
  plate_number?: InputMaybe<String_Comparison_Exp>;
  quantity?: InputMaybe<Numeric_Comparison_Exp>;
  rated_capacity?: InputMaybe<Int_Comparison_Exp>;
  rc_expire_date?: InputMaybe<Date_Comparison_Exp>;
  registration_number?: InputMaybe<String_Comparison_Exp>;
  rfid?: InputMaybe<String_Comparison_Exp>;
  shift_schedules?: InputMaybe<Shift_Schedule_Bool_Exp>;
  shift_schedules_aggregate?: InputMaybe<Shift_Schedule_Aggregate_Bool_Exp>;
  state?: InputMaybe<State_Bool_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Vehicle_Status_Enum_Comparison_Exp>;
  tanker_capacity?: InputMaybe<Int_Comparison_Exp>;
  tanker_compartment_number?: InputMaybe<Int_Comparison_Exp>;
  taskStatesFlowsByPreviousVehicleId?: InputMaybe<Task_States_Flow_Bool_Exp>;
  taskStatesFlowsByPreviousVehicleId_aggregate?: InputMaybe<Task_States_Flow_Aggregate_Bool_Exp>;
  tasks?: InputMaybe<Task_Bool_Exp>;
  tasks_aggregate?: InputMaybe<Task_Aggregate_Bool_Exp>;
  trip_plans?: InputMaybe<Trip_Plan_Bool_Exp>;
  trip_plans_aggregate?: InputMaybe<Trip_Plan_Aggregate_Bool_Exp>;
  vehicleStatusByStatus?: InputMaybe<Vehicle_Status_Bool_Exp>;
  vehicleTypeByVehicleType?: InputMaybe<Vehicle_Type_Bool_Exp>;
  vehicle_configurations?: InputMaybe<Vehicle_Configuration_Bool_Exp>;
  vehicle_configurations_aggregate?: InputMaybe<Vehicle_Configuration_Aggregate_Bool_Exp>;
  vehicle_devices?: InputMaybe<Vehicle_Device_Bool_Exp>;
  vehicle_devices_aggregate?: InputMaybe<Vehicle_Device_Aggregate_Bool_Exp>;
  vehicle_inventory_transaction_logs?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Bool_Exp>;
  vehicle_inventory_transaction_logs_aggregate?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Aggregate_Bool_Exp>;
  vehicle_localities?: InputMaybe<Vehicle_Localities_Bool_Exp>;
  vehicle_localities_aggregate?: InputMaybe<Vehicle_Localities_Aggregate_Bool_Exp>;
  vehicle_permits?: InputMaybe<Vehicle_Permit_Bool_Exp>;
  vehicle_permits_aggregate?: InputMaybe<Vehicle_Permit_Aggregate_Bool_Exp>;
  vehicle_shift_templates?: InputMaybe<Vehicle_Shift_Template_Bool_Exp>;
  vehicle_shift_templates_aggregate?: InputMaybe<Vehicle_Shift_Template_Aggregate_Bool_Exp>;
  vehicle_status_logs?: InputMaybe<Vehicle_Status_Logs_Bool_Exp>;
  vehicle_status_logs_aggregate?: InputMaybe<Vehicle_Status_Logs_Aggregate_Bool_Exp>;
  vehicle_tank_types?: InputMaybe<Vehicle_Tank_Type_Bool_Exp>;
  vehicle_tank_types_aggregate?: InputMaybe<Vehicle_Tank_Type_Aggregate_Bool_Exp>;
  vehicle_type?: InputMaybe<Vehicle_Type_Enum_Comparison_Exp>;
  vendor_order_logs?: InputMaybe<Vendor_Order_Logs_Bool_Exp>;
  vendor_order_logs_aggregate?: InputMaybe<Vendor_Order_Logs_Aggregate_Bool_Exp>;
  year?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "vehicle_configuration" */
export type Vehicle_Configuration = {
  __typename?: 'vehicle_configuration';
  created_at: Scalars['timestamp']['output'];
  id: Scalars['uuid']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamp']['output'];
  value?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  vehicle: Vehicle;
  vehicle_id: Scalars['uuid']['output'];
};

/** aggregated selection of "vehicle_configuration" */
export type Vehicle_Configuration_Aggregate = {
  __typename?: 'vehicle_configuration_aggregate';
  aggregate?: Maybe<Vehicle_Configuration_Aggregate_Fields>;
  nodes: Array<Vehicle_Configuration>;
};

export type Vehicle_Configuration_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Vehicle_Configuration_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Vehicle_Configuration_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Vehicle_Configuration_Aggregate_Bool_Exp_Count>;
};

export type Vehicle_Configuration_Aggregate_Bool_Exp_Bool_And = {
  arguments: Vehicle_Configuration_Select_Column_Vehicle_Configuration_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vehicle_Configuration_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Vehicle_Configuration_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Vehicle_Configuration_Select_Column_Vehicle_Configuration_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vehicle_Configuration_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Vehicle_Configuration_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Vehicle_Configuration_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vehicle_Configuration_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "vehicle_configuration" */
export type Vehicle_Configuration_Aggregate_Fields = {
  __typename?: 'vehicle_configuration_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Vehicle_Configuration_Max_Fields>;
  min?: Maybe<Vehicle_Configuration_Min_Fields>;
};


/** aggregate fields of "vehicle_configuration" */
export type Vehicle_Configuration_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vehicle_Configuration_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "vehicle_configuration" */
export type Vehicle_Configuration_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vehicle_Configuration_Max_Order_By>;
  min?: InputMaybe<Vehicle_Configuration_Min_Order_By>;
};

/** input type for inserting array relation for remote table "vehicle_configuration" */
export type Vehicle_Configuration_Arr_Rel_Insert_Input = {
  data: Array<Vehicle_Configuration_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Vehicle_Configuration_On_Conflict>;
};

/** Boolean expression to filter rows from the table "vehicle_configuration". All fields are combined with a logical 'AND'. */
export type Vehicle_Configuration_Bool_Exp = {
  _and?: InputMaybe<Array<Vehicle_Configuration_Bool_Exp>>;
  _not?: InputMaybe<Vehicle_Configuration_Bool_Exp>;
  _or?: InputMaybe<Array<Vehicle_Configuration_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
  vehicle?: InputMaybe<Vehicle_Bool_Exp>;
  vehicle_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "vehicle_configuration" */
export enum Vehicle_Configuration_Constraint {
  /** unique or primary key constraint on columns "id" */
  VehicleConfigurationPkey = 'vehicle_configuration_pkey'
}

/** input type for inserting data into table "vehicle_configuration" */
export type Vehicle_Configuration_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  vehicle?: InputMaybe<Vehicle_Obj_Rel_Insert_Input>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Vehicle_Configuration_Max_Fields = {
  __typename?: 'vehicle_configuration_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "vehicle_configuration" */
export type Vehicle_Configuration_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Vehicle_Configuration_Min_Fields = {
  __typename?: 'vehicle_configuration_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "vehicle_configuration" */
export type Vehicle_Configuration_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "vehicle_configuration" */
export type Vehicle_Configuration_Mutation_Response = {
  __typename?: 'vehicle_configuration_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Vehicle_Configuration>;
};

/** on_conflict condition type for table "vehicle_configuration" */
export type Vehicle_Configuration_On_Conflict = {
  constraint: Vehicle_Configuration_Constraint;
  update_columns?: Array<Vehicle_Configuration_Update_Column>;
  where?: InputMaybe<Vehicle_Configuration_Bool_Exp>;
};

/** Ordering options when selecting data from "vehicle_configuration". */
export type Vehicle_Configuration_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  vehicle?: InputMaybe<Vehicle_Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vehicle_configuration */
export type Vehicle_Configuration_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "vehicle_configuration" */
export enum Vehicle_Configuration_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Key = 'key',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value',
  /** column name */
  VehicleId = 'vehicle_id'
}

/** select "vehicle_configuration_aggregate_bool_exp_bool_and_arguments_columns" columns of table "vehicle_configuration" */
export enum Vehicle_Configuration_Select_Column_Vehicle_Configuration_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "vehicle_configuration_aggregate_bool_exp_bool_or_arguments_columns" columns of table "vehicle_configuration" */
export enum Vehicle_Configuration_Select_Column_Vehicle_Configuration_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "vehicle_configuration" */
export type Vehicle_Configuration_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "vehicle_configuration" */
export type Vehicle_Configuration_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vehicle_Configuration_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vehicle_Configuration_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "vehicle_configuration" */
export enum Vehicle_Configuration_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Key = 'key',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value',
  /** column name */
  VehicleId = 'vehicle_id'
}

export type Vehicle_Configuration_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Vehicle_Configuration_Set_Input>;
  /** filter the rows which have to be updated */
  where: Vehicle_Configuration_Bool_Exp;
};

/** unique or primary key constraints on table "vehicle" */
export enum Vehicle_Constraint {
  /** unique or primary key constraint on columns "id" */
  VehiclePkey = 'vehicle_pkey'
}

/** columns and relationships of "vehicle_device" */
export type Vehicle_Device = {
  __typename?: 'vehicle_device';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  device_configuration_url?: Maybe<Scalars['String']['output']>;
  device_id: Scalars['numeric']['output'];
  device_type_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  devicetype?: Maybe<Devicetype>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  vehicle: Vehicle;
  /** An object relationship */
  vehicle_device_calibrations?: Maybe<Vehicle_Device_Calibration>;
  vehicle_id: Scalars['uuid']['output'];
};

/** aggregated selection of "vehicle_device" */
export type Vehicle_Device_Aggregate = {
  __typename?: 'vehicle_device_aggregate';
  aggregate?: Maybe<Vehicle_Device_Aggregate_Fields>;
  nodes: Array<Vehicle_Device>;
};

export type Vehicle_Device_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Vehicle_Device_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Vehicle_Device_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Vehicle_Device_Aggregate_Bool_Exp_Count>;
};

export type Vehicle_Device_Aggregate_Bool_Exp_Bool_And = {
  arguments: Vehicle_Device_Select_Column_Vehicle_Device_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vehicle_Device_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Vehicle_Device_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Vehicle_Device_Select_Column_Vehicle_Device_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vehicle_Device_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Vehicle_Device_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Vehicle_Device_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vehicle_Device_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "vehicle_device" */
export type Vehicle_Device_Aggregate_Fields = {
  __typename?: 'vehicle_device_aggregate_fields';
  avg?: Maybe<Vehicle_Device_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Vehicle_Device_Max_Fields>;
  min?: Maybe<Vehicle_Device_Min_Fields>;
  stddev?: Maybe<Vehicle_Device_Stddev_Fields>;
  stddev_pop?: Maybe<Vehicle_Device_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vehicle_Device_Stddev_Samp_Fields>;
  sum?: Maybe<Vehicle_Device_Sum_Fields>;
  var_pop?: Maybe<Vehicle_Device_Var_Pop_Fields>;
  var_samp?: Maybe<Vehicle_Device_Var_Samp_Fields>;
  variance?: Maybe<Vehicle_Device_Variance_Fields>;
};


/** aggregate fields of "vehicle_device" */
export type Vehicle_Device_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vehicle_Device_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "vehicle_device" */
export type Vehicle_Device_Aggregate_Order_By = {
  avg?: InputMaybe<Vehicle_Device_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vehicle_Device_Max_Order_By>;
  min?: InputMaybe<Vehicle_Device_Min_Order_By>;
  stddev?: InputMaybe<Vehicle_Device_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Vehicle_Device_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Vehicle_Device_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Vehicle_Device_Sum_Order_By>;
  var_pop?: InputMaybe<Vehicle_Device_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Vehicle_Device_Var_Samp_Order_By>;
  variance?: InputMaybe<Vehicle_Device_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "vehicle_device" */
export type Vehicle_Device_Arr_Rel_Insert_Input = {
  data: Array<Vehicle_Device_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Vehicle_Device_On_Conflict>;
};

/** aggregate avg on columns */
export type Vehicle_Device_Avg_Fields = {
  __typename?: 'vehicle_device_avg_fields';
  device_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "vehicle_device" */
export type Vehicle_Device_Avg_Order_By = {
  device_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vehicle_device". All fields are combined with a logical 'AND'. */
export type Vehicle_Device_Bool_Exp = {
  _and?: InputMaybe<Array<Vehicle_Device_Bool_Exp>>;
  _not?: InputMaybe<Vehicle_Device_Bool_Exp>;
  _or?: InputMaybe<Array<Vehicle_Device_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  device_configuration_url?: InputMaybe<String_Comparison_Exp>;
  device_id?: InputMaybe<Numeric_Comparison_Exp>;
  device_type_id?: InputMaybe<Uuid_Comparison_Exp>;
  devicetype?: InputMaybe<Devicetype_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  vehicle?: InputMaybe<Vehicle_Bool_Exp>;
  vehicle_device_calibrations?: InputMaybe<Vehicle_Device_Calibration_Bool_Exp>;
  vehicle_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** columns and relationships of "vehicle_device_calibration" */
export type Vehicle_Device_Calibration = {
  __typename?: 'vehicle_device_calibration';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  devicetypeParamerterDefinitionByTargetDevicetypeParamerterDefinitionId?: Maybe<Devicetype_Paramerter_Definition>;
  /** An object relationship */
  devicetype_paramerter_definition: Devicetype_Paramerter_Definition;
  devicetype_paramerter_definition_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  target_devicetype_paramerter_definition_id?: Maybe<Scalars['uuid']['output']>;
  value: Scalars['String']['output'];
  /** An object relationship */
  vehicle_device?: Maybe<Vehicle_Device>;
  vehicle_device_id: Scalars['uuid']['output'];
};

/** aggregated selection of "vehicle_device_calibration" */
export type Vehicle_Device_Calibration_Aggregate = {
  __typename?: 'vehicle_device_calibration_aggregate';
  aggregate?: Maybe<Vehicle_Device_Calibration_Aggregate_Fields>;
  nodes: Array<Vehicle_Device_Calibration>;
};

export type Vehicle_Device_Calibration_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Vehicle_Device_Calibration_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Vehicle_Device_Calibration_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Vehicle_Device_Calibration_Aggregate_Bool_Exp_Count>;
};

export type Vehicle_Device_Calibration_Aggregate_Bool_Exp_Bool_And = {
  arguments: Vehicle_Device_Calibration_Select_Column_Vehicle_Device_Calibration_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vehicle_Device_Calibration_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Vehicle_Device_Calibration_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Vehicle_Device_Calibration_Select_Column_Vehicle_Device_Calibration_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vehicle_Device_Calibration_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Vehicle_Device_Calibration_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Vehicle_Device_Calibration_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vehicle_Device_Calibration_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "vehicle_device_calibration" */
export type Vehicle_Device_Calibration_Aggregate_Fields = {
  __typename?: 'vehicle_device_calibration_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Vehicle_Device_Calibration_Max_Fields>;
  min?: Maybe<Vehicle_Device_Calibration_Min_Fields>;
};


/** aggregate fields of "vehicle_device_calibration" */
export type Vehicle_Device_Calibration_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vehicle_Device_Calibration_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "vehicle_device_calibration" */
export type Vehicle_Device_Calibration_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vehicle_Device_Calibration_Max_Order_By>;
  min?: InputMaybe<Vehicle_Device_Calibration_Min_Order_By>;
};

/** input type for inserting array relation for remote table "vehicle_device_calibration" */
export type Vehicle_Device_Calibration_Arr_Rel_Insert_Input = {
  data: Array<Vehicle_Device_Calibration_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Vehicle_Device_Calibration_On_Conflict>;
};

/** Boolean expression to filter rows from the table "vehicle_device_calibration". All fields are combined with a logical 'AND'. */
export type Vehicle_Device_Calibration_Bool_Exp = {
  _and?: InputMaybe<Array<Vehicle_Device_Calibration_Bool_Exp>>;
  _not?: InputMaybe<Vehicle_Device_Calibration_Bool_Exp>;
  _or?: InputMaybe<Array<Vehicle_Device_Calibration_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  devicetypeParamerterDefinitionByTargetDevicetypeParamerterDefinitionId?: InputMaybe<Devicetype_Paramerter_Definition_Bool_Exp>;
  devicetype_paramerter_definition?: InputMaybe<Devicetype_Paramerter_Definition_Bool_Exp>;
  devicetype_paramerter_definition_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  target_devicetype_paramerter_definition_id?: InputMaybe<Uuid_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
  vehicle_device?: InputMaybe<Vehicle_Device_Bool_Exp>;
  vehicle_device_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "vehicle_device_calibration" */
export enum Vehicle_Device_Calibration_Constraint {
  /** unique or primary key constraint on columns "id" */
  VehicleDeviceCalibrationPkey = 'vehicle_device_calibration_pkey'
}

/** input type for inserting data into table "vehicle_device_calibration" */
export type Vehicle_Device_Calibration_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  devicetypeParamerterDefinitionByTargetDevicetypeParamerterDefinitionId?: InputMaybe<Devicetype_Paramerter_Definition_Obj_Rel_Insert_Input>;
  devicetype_paramerter_definition?: InputMaybe<Devicetype_Paramerter_Definition_Obj_Rel_Insert_Input>;
  devicetype_paramerter_definition_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  target_devicetype_paramerter_definition_id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  vehicle_device?: InputMaybe<Vehicle_Device_Obj_Rel_Insert_Input>;
  vehicle_device_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Vehicle_Device_Calibration_Max_Fields = {
  __typename?: 'vehicle_device_calibration_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  devicetype_paramerter_definition_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  target_devicetype_paramerter_definition_id?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  vehicle_device_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "vehicle_device_calibration" */
export type Vehicle_Device_Calibration_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  devicetype_paramerter_definition_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  target_devicetype_paramerter_definition_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  vehicle_device_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Vehicle_Device_Calibration_Min_Fields = {
  __typename?: 'vehicle_device_calibration_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  devicetype_paramerter_definition_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  target_devicetype_paramerter_definition_id?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  vehicle_device_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "vehicle_device_calibration" */
export type Vehicle_Device_Calibration_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  devicetype_paramerter_definition_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  target_devicetype_paramerter_definition_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  vehicle_device_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "vehicle_device_calibration" */
export type Vehicle_Device_Calibration_Mutation_Response = {
  __typename?: 'vehicle_device_calibration_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Vehicle_Device_Calibration>;
};

/** input type for inserting object relation for remote table "vehicle_device_calibration" */
export type Vehicle_Device_Calibration_Obj_Rel_Insert_Input = {
  data: Vehicle_Device_Calibration_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Vehicle_Device_Calibration_On_Conflict>;
};

/** on_conflict condition type for table "vehicle_device_calibration" */
export type Vehicle_Device_Calibration_On_Conflict = {
  constraint: Vehicle_Device_Calibration_Constraint;
  update_columns?: Array<Vehicle_Device_Calibration_Update_Column>;
  where?: InputMaybe<Vehicle_Device_Calibration_Bool_Exp>;
};

/** Ordering options when selecting data from "vehicle_device_calibration". */
export type Vehicle_Device_Calibration_Order_By = {
  created_at?: InputMaybe<Order_By>;
  devicetypeParamerterDefinitionByTargetDevicetypeParamerterDefinitionId?: InputMaybe<Devicetype_Paramerter_Definition_Order_By>;
  devicetype_paramerter_definition?: InputMaybe<Devicetype_Paramerter_Definition_Order_By>;
  devicetype_paramerter_definition_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  target_devicetype_paramerter_definition_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  vehicle_device?: InputMaybe<Vehicle_Device_Order_By>;
  vehicle_device_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vehicle_device_calibration */
export type Vehicle_Device_Calibration_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "vehicle_device_calibration" */
export enum Vehicle_Device_Calibration_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DevicetypeParamerterDefinitionId = 'devicetype_paramerter_definition_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Key = 'key',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  TargetDevicetypeParamerterDefinitionId = 'target_devicetype_paramerter_definition_id',
  /** column name */
  Value = 'value',
  /** column name */
  VehicleDeviceId = 'vehicle_device_id'
}

/** select "vehicle_device_calibration_aggregate_bool_exp_bool_and_arguments_columns" columns of table "vehicle_device_calibration" */
export enum Vehicle_Device_Calibration_Select_Column_Vehicle_Device_Calibration_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "vehicle_device_calibration_aggregate_bool_exp_bool_or_arguments_columns" columns of table "vehicle_device_calibration" */
export enum Vehicle_Device_Calibration_Select_Column_Vehicle_Device_Calibration_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "vehicle_device_calibration" */
export type Vehicle_Device_Calibration_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  devicetype_paramerter_definition_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  target_devicetype_paramerter_definition_id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  vehicle_device_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "vehicle_device_calibration" */
export type Vehicle_Device_Calibration_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vehicle_Device_Calibration_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vehicle_Device_Calibration_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  devicetype_paramerter_definition_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  target_devicetype_paramerter_definition_id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  vehicle_device_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "vehicle_device_calibration" */
export enum Vehicle_Device_Calibration_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DevicetypeParamerterDefinitionId = 'devicetype_paramerter_definition_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Key = 'key',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  TargetDevicetypeParamerterDefinitionId = 'target_devicetype_paramerter_definition_id',
  /** column name */
  Value = 'value',
  /** column name */
  VehicleDeviceId = 'vehicle_device_id'
}

export type Vehicle_Device_Calibration_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Vehicle_Device_Calibration_Set_Input>;
  /** filter the rows which have to be updated */
  where: Vehicle_Device_Calibration_Bool_Exp;
};

/** unique or primary key constraints on table "vehicle_device" */
export enum Vehicle_Device_Constraint {
  /** unique or primary key constraint on columns "id" */
  VehicleDevicePkey = 'vehicle_device_pkey'
}

/** input type for incrementing numeric columns in table "vehicle_device" */
export type Vehicle_Device_Inc_Input = {
  device_id?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "vehicle_device" */
export type Vehicle_Device_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  device_configuration_url?: InputMaybe<Scalars['String']['input']>;
  device_id?: InputMaybe<Scalars['numeric']['input']>;
  device_type_id?: InputMaybe<Scalars['uuid']['input']>;
  devicetype?: InputMaybe<Devicetype_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  vehicle?: InputMaybe<Vehicle_Obj_Rel_Insert_Input>;
  vehicle_device_calibrations?: InputMaybe<Vehicle_Device_Calibration_Obj_Rel_Insert_Input>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Vehicle_Device_Max_Fields = {
  __typename?: 'vehicle_device_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  device_configuration_url?: Maybe<Scalars['String']['output']>;
  device_id?: Maybe<Scalars['numeric']['output']>;
  device_type_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "vehicle_device" */
export type Vehicle_Device_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  device_configuration_url?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  device_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Vehicle_Device_Min_Fields = {
  __typename?: 'vehicle_device_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  device_configuration_url?: Maybe<Scalars['String']['output']>;
  device_id?: Maybe<Scalars['numeric']['output']>;
  device_type_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "vehicle_device" */
export type Vehicle_Device_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  device_configuration_url?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  device_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "vehicle_device" */
export type Vehicle_Device_Mutation_Response = {
  __typename?: 'vehicle_device_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Vehicle_Device>;
};

/** input type for inserting object relation for remote table "vehicle_device" */
export type Vehicle_Device_Obj_Rel_Insert_Input = {
  data: Vehicle_Device_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Vehicle_Device_On_Conflict>;
};

/** on_conflict condition type for table "vehicle_device" */
export type Vehicle_Device_On_Conflict = {
  constraint: Vehicle_Device_Constraint;
  update_columns?: Array<Vehicle_Device_Update_Column>;
  where?: InputMaybe<Vehicle_Device_Bool_Exp>;
};

/** Ordering options when selecting data from "vehicle_device". */
export type Vehicle_Device_Order_By = {
  created_at?: InputMaybe<Order_By>;
  device_configuration_url?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  device_type_id?: InputMaybe<Order_By>;
  devicetype?: InputMaybe<Devicetype_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  vehicle?: InputMaybe<Vehicle_Order_By>;
  vehicle_device_calibrations?: InputMaybe<Vehicle_Device_Calibration_Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vehicle_device */
export type Vehicle_Device_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "vehicle_device" */
export enum Vehicle_Device_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeviceConfigurationUrl = 'device_configuration_url',
  /** column name */
  DeviceId = 'device_id',
  /** column name */
  DeviceTypeId = 'device_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  VehicleId = 'vehicle_id'
}

/** select "vehicle_device_aggregate_bool_exp_bool_and_arguments_columns" columns of table "vehicle_device" */
export enum Vehicle_Device_Select_Column_Vehicle_Device_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "vehicle_device_aggregate_bool_exp_bool_or_arguments_columns" columns of table "vehicle_device" */
export enum Vehicle_Device_Select_Column_Vehicle_Device_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "vehicle_device" */
export type Vehicle_Device_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  device_configuration_url?: InputMaybe<Scalars['String']['input']>;
  device_id?: InputMaybe<Scalars['numeric']['input']>;
  device_type_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Vehicle_Device_Stddev_Fields = {
  __typename?: 'vehicle_device_stddev_fields';
  device_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "vehicle_device" */
export type Vehicle_Device_Stddev_Order_By = {
  device_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Vehicle_Device_Stddev_Pop_Fields = {
  __typename?: 'vehicle_device_stddev_pop_fields';
  device_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "vehicle_device" */
export type Vehicle_Device_Stddev_Pop_Order_By = {
  device_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Vehicle_Device_Stddev_Samp_Fields = {
  __typename?: 'vehicle_device_stddev_samp_fields';
  device_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "vehicle_device" */
export type Vehicle_Device_Stddev_Samp_Order_By = {
  device_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "vehicle_device" */
export type Vehicle_Device_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vehicle_Device_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vehicle_Device_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  device_configuration_url?: InputMaybe<Scalars['String']['input']>;
  device_id?: InputMaybe<Scalars['numeric']['input']>;
  device_type_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Vehicle_Device_Sum_Fields = {
  __typename?: 'vehicle_device_sum_fields';
  device_id?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "vehicle_device" */
export type Vehicle_Device_Sum_Order_By = {
  device_id?: InputMaybe<Order_By>;
};

/** update columns of table "vehicle_device" */
export enum Vehicle_Device_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeviceConfigurationUrl = 'device_configuration_url',
  /** column name */
  DeviceId = 'device_id',
  /** column name */
  DeviceTypeId = 'device_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  VehicleId = 'vehicle_id'
}

export type Vehicle_Device_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Vehicle_Device_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Vehicle_Device_Set_Input>;
  /** filter the rows which have to be updated */
  where: Vehicle_Device_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Vehicle_Device_Var_Pop_Fields = {
  __typename?: 'vehicle_device_var_pop_fields';
  device_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "vehicle_device" */
export type Vehicle_Device_Var_Pop_Order_By = {
  device_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Vehicle_Device_Var_Samp_Fields = {
  __typename?: 'vehicle_device_var_samp_fields';
  device_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "vehicle_device" */
export type Vehicle_Device_Var_Samp_Order_By = {
  device_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Vehicle_Device_Variance_Fields = {
  __typename?: 'vehicle_device_variance_fields';
  device_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "vehicle_device" */
export type Vehicle_Device_Variance_Order_By = {
  device_id?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "vehicle" */
export type Vehicle_Inc_Input = {
  fuel_tank_capacity?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  rated_capacity?: InputMaybe<Scalars['Int']['input']>;
  tanker_capacity?: InputMaybe<Scalars['Int']['input']>;
  tanker_compartment_number?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "vehicle" */
export type Vehicle_Insert_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  chassis_number?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  delivery_schedulers?: InputMaybe<Delivery_Scheduler_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']['input']>;
  device_id?: InputMaybe<Scalars['uuid']['input']>;
  dispensers?: InputMaybe<Dispenser_Arr_Rel_Insert_Input>;
  driver_vehicles?: InputMaybe<Driver_Vehicle_Arr_Rel_Insert_Input>;
  erp_code?: InputMaybe<Scalars['String']['input']>;
  fuel_tank_capacity?: InputMaybe<Scalars['Int']['input']>;
  fueltrans_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  insurance_expire_date?: InputMaybe<Scalars['date']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_mothership?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['point']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  master_slots?: InputMaybe<Master_Slot_Arr_Rel_Insert_Input>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partner_address?: InputMaybe<Partner_Address_Obj_Rel_Insert_Input>;
  partner_address_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_vehicles?: InputMaybe<Partner_Vehicle_Arr_Rel_Insert_Input>;
  plate_code?: InputMaybe<Scalars['String']['input']>;
  plate_number?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  rated_capacity?: InputMaybe<Scalars['Int']['input']>;
  rc_expire_date?: InputMaybe<Scalars['date']['input']>;
  registration_number?: InputMaybe<Scalars['String']['input']>;
  rfid?: InputMaybe<Scalars['String']['input']>;
  shift_schedules?: InputMaybe<Shift_Schedule_Arr_Rel_Insert_Input>;
  state?: InputMaybe<State_Obj_Rel_Insert_Input>;
  state_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Vehicle_Status_Enum>;
  tanker_capacity?: InputMaybe<Scalars['Int']['input']>;
  tanker_compartment_number?: InputMaybe<Scalars['Int']['input']>;
  taskStatesFlowsByPreviousVehicleId?: InputMaybe<Task_States_Flow_Arr_Rel_Insert_Input>;
  tasks?: InputMaybe<Task_Arr_Rel_Insert_Input>;
  trip_plans?: InputMaybe<Trip_Plan_Arr_Rel_Insert_Input>;
  vehicleStatusByStatus?: InputMaybe<Vehicle_Status_Obj_Rel_Insert_Input>;
  vehicleTypeByVehicleType?: InputMaybe<Vehicle_Type_Obj_Rel_Insert_Input>;
  vehicle_configurations?: InputMaybe<Vehicle_Configuration_Arr_Rel_Insert_Input>;
  vehicle_devices?: InputMaybe<Vehicle_Device_Arr_Rel_Insert_Input>;
  vehicle_inventory_transaction_logs?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Arr_Rel_Insert_Input>;
  vehicle_localities?: InputMaybe<Vehicle_Localities_Arr_Rel_Insert_Input>;
  vehicle_permits?: InputMaybe<Vehicle_Permit_Arr_Rel_Insert_Input>;
  vehicle_shift_templates?: InputMaybe<Vehicle_Shift_Template_Arr_Rel_Insert_Input>;
  vehicle_status_logs?: InputMaybe<Vehicle_Status_Logs_Arr_Rel_Insert_Input>;
  vehicle_tank_types?: InputMaybe<Vehicle_Tank_Type_Arr_Rel_Insert_Input>;
  vehicle_type?: InputMaybe<Vehicle_Type_Enum>;
  vendor_order_logs?: InputMaybe<Vendor_Order_Logs_Arr_Rel_Insert_Input>;
  year?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "vehicle_inventory_transaction_logs" */
export type Vehicle_Inventory_Transaction_Logs = {
  __typename?: 'vehicle_inventory_transaction_logs';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  current_available_quantity?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  customer_order?: Maybe<Customer_Order>;
  customer_order_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  erpSyncStatusByErpSyncStatus?: Maybe<Erp_Sync_Status>;
  /** ERP document name after sync */
  erp_code?: Maybe<Scalars['String']['output']>;
  /** ERP document type (Purchase Receipt, Stock Entry) */
  erp_doctype?: Maybe<Scalars['String']['output']>;
  /** ERP sync tracking (PENDING, COMPLETED, FAILED) */
  erp_sync_status?: Maybe<Erp_Sync_Status_Enum>;
  /** An object relationship */
  fillup_request?: Maybe<Fillup_Request>;
  fillup_request_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** Additional context (images, GPS, etc.) */
  metadata?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  product_variation: Product_Variation;
  product_variation_id: Scalars['uuid']['output'];
  quantity?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  transactionTypeByTransactionType?: Maybe<Transaction_Type>;
  transaction_type?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  vehicle: Vehicle;
  vehicle_id: Scalars['uuid']['output'];
  /** An object relationship */
  vehicle_tank_type?: Maybe<Vehicle_Tank_Type>;
  vehicle_tank_type_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "vehicle_inventory_transaction_logs" */
export type Vehicle_Inventory_Transaction_LogsMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "vehicle_inventory_transaction_logs" */
export type Vehicle_Inventory_Transaction_Logs_Aggregate = {
  __typename?: 'vehicle_inventory_transaction_logs_aggregate';
  aggregate?: Maybe<Vehicle_Inventory_Transaction_Logs_Aggregate_Fields>;
  nodes: Array<Vehicle_Inventory_Transaction_Logs>;
};

export type Vehicle_Inventory_Transaction_Logs_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Aggregate_Bool_Exp_Count>;
};

export type Vehicle_Inventory_Transaction_Logs_Aggregate_Bool_Exp_Bool_And = {
  arguments: Vehicle_Inventory_Transaction_Logs_Select_Column_Vehicle_Inventory_Transaction_Logs_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Vehicle_Inventory_Transaction_Logs_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Vehicle_Inventory_Transaction_Logs_Select_Column_Vehicle_Inventory_Transaction_Logs_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Vehicle_Inventory_Transaction_Logs_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Vehicle_Inventory_Transaction_Logs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "vehicle_inventory_transaction_logs" */
export type Vehicle_Inventory_Transaction_Logs_Aggregate_Fields = {
  __typename?: 'vehicle_inventory_transaction_logs_aggregate_fields';
  avg?: Maybe<Vehicle_Inventory_Transaction_Logs_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Vehicle_Inventory_Transaction_Logs_Max_Fields>;
  min?: Maybe<Vehicle_Inventory_Transaction_Logs_Min_Fields>;
  stddev?: Maybe<Vehicle_Inventory_Transaction_Logs_Stddev_Fields>;
  stddev_pop?: Maybe<Vehicle_Inventory_Transaction_Logs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vehicle_Inventory_Transaction_Logs_Stddev_Samp_Fields>;
  sum?: Maybe<Vehicle_Inventory_Transaction_Logs_Sum_Fields>;
  var_pop?: Maybe<Vehicle_Inventory_Transaction_Logs_Var_Pop_Fields>;
  var_samp?: Maybe<Vehicle_Inventory_Transaction_Logs_Var_Samp_Fields>;
  variance?: Maybe<Vehicle_Inventory_Transaction_Logs_Variance_Fields>;
};


/** aggregate fields of "vehicle_inventory_transaction_logs" */
export type Vehicle_Inventory_Transaction_Logs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vehicle_Inventory_Transaction_Logs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "vehicle_inventory_transaction_logs" */
export type Vehicle_Inventory_Transaction_Logs_Aggregate_Order_By = {
  avg?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Max_Order_By>;
  min?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Min_Order_By>;
  stddev?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Sum_Order_By>;
  var_pop?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Var_Samp_Order_By>;
  variance?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Vehicle_Inventory_Transaction_Logs_Append_Input = {
  /** Additional context (images, GPS, etc.) */
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "vehicle_inventory_transaction_logs" */
export type Vehicle_Inventory_Transaction_Logs_Arr_Rel_Insert_Input = {
  data: Array<Vehicle_Inventory_Transaction_Logs_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Vehicle_Inventory_Transaction_Logs_On_Conflict>;
};

/** aggregate avg on columns */
export type Vehicle_Inventory_Transaction_Logs_Avg_Fields = {
  __typename?: 'vehicle_inventory_transaction_logs_avg_fields';
  current_available_quantity?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "vehicle_inventory_transaction_logs" */
export type Vehicle_Inventory_Transaction_Logs_Avg_Order_By = {
  current_available_quantity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vehicle_inventory_transaction_logs". All fields are combined with a logical 'AND'. */
export type Vehicle_Inventory_Transaction_Logs_Bool_Exp = {
  _and?: InputMaybe<Array<Vehicle_Inventory_Transaction_Logs_Bool_Exp>>;
  _not?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Bool_Exp>;
  _or?: InputMaybe<Array<Vehicle_Inventory_Transaction_Logs_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  current_available_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  customer_order?: InputMaybe<Customer_Order_Bool_Exp>;
  customer_order_id?: InputMaybe<Uuid_Comparison_Exp>;
  erpSyncStatusByErpSyncStatus?: InputMaybe<Erp_Sync_Status_Bool_Exp>;
  erp_code?: InputMaybe<String_Comparison_Exp>;
  erp_doctype?: InputMaybe<String_Comparison_Exp>;
  erp_sync_status?: InputMaybe<Erp_Sync_Status_Enum_Comparison_Exp>;
  fillup_request?: InputMaybe<Fillup_Request_Bool_Exp>;
  fillup_request_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  product_variation?: InputMaybe<Product_Variation_Bool_Exp>;
  product_variation_id?: InputMaybe<Uuid_Comparison_Exp>;
  quantity?: InputMaybe<Numeric_Comparison_Exp>;
  transactionTypeByTransactionType?: InputMaybe<Transaction_Type_Bool_Exp>;
  transaction_type?: InputMaybe<String_Comparison_Exp>;
  unit?: InputMaybe<String_Comparison_Exp>;
  vehicle?: InputMaybe<Vehicle_Bool_Exp>;
  vehicle_id?: InputMaybe<Uuid_Comparison_Exp>;
  vehicle_tank_type?: InputMaybe<Vehicle_Tank_Type_Bool_Exp>;
  vehicle_tank_type_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "vehicle_inventory_transaction_logs" */
export enum Vehicle_Inventory_Transaction_Logs_Constraint {
  /** unique or primary key constraint on columns "fillup_request_id", "transaction_type" */
  VehicleInventoryTransactionLogsFillupRequestTypeKey = 'vehicle_inventory_transaction_logs_fillup_request_type_key',
  /** unique or primary key constraint on columns "id" */
  VehicleInventoryTransactionLogsPkey = 'vehicle_inventory_transaction_logs_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Vehicle_Inventory_Transaction_Logs_Delete_At_Path_Input = {
  /** Additional context (images, GPS, etc.) */
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Vehicle_Inventory_Transaction_Logs_Delete_Elem_Input = {
  /** Additional context (images, GPS, etc.) */
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Vehicle_Inventory_Transaction_Logs_Delete_Key_Input = {
  /** Additional context (images, GPS, etc.) */
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "vehicle_inventory_transaction_logs" */
export type Vehicle_Inventory_Transaction_Logs_Inc_Input = {
  current_available_quantity?: InputMaybe<Scalars['numeric']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "vehicle_inventory_transaction_logs" */
export type Vehicle_Inventory_Transaction_Logs_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  current_available_quantity?: InputMaybe<Scalars['numeric']['input']>;
  customer_order?: InputMaybe<Customer_Order_Obj_Rel_Insert_Input>;
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
  erpSyncStatusByErpSyncStatus?: InputMaybe<Erp_Sync_Status_Obj_Rel_Insert_Input>;
  /** ERP document name after sync */
  erp_code?: InputMaybe<Scalars['String']['input']>;
  /** ERP document type (Purchase Receipt, Stock Entry) */
  erp_doctype?: InputMaybe<Scalars['String']['input']>;
  /** ERP sync tracking (PENDING, COMPLETED, FAILED) */
  erp_sync_status?: InputMaybe<Erp_Sync_Status_Enum>;
  fillup_request?: InputMaybe<Fillup_Request_Obj_Rel_Insert_Input>;
  fillup_request_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  /** Additional context (images, GPS, etc.) */
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  product_variation?: InputMaybe<Product_Variation_Obj_Rel_Insert_Input>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  transactionTypeByTransactionType?: InputMaybe<Transaction_Type_Obj_Rel_Insert_Input>;
  transaction_type?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  vehicle?: InputMaybe<Vehicle_Obj_Rel_Insert_Input>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  vehicle_tank_type?: InputMaybe<Vehicle_Tank_Type_Obj_Rel_Insert_Input>;
  vehicle_tank_type_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Vehicle_Inventory_Transaction_Logs_Max_Fields = {
  __typename?: 'vehicle_inventory_transaction_logs_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  current_available_quantity?: Maybe<Scalars['numeric']['output']>;
  customer_order_id?: Maybe<Scalars['uuid']['output']>;
  /** ERP document name after sync */
  erp_code?: Maybe<Scalars['String']['output']>;
  /** ERP document type (Purchase Receipt, Stock Entry) */
  erp_doctype?: Maybe<Scalars['String']['output']>;
  fillup_request_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
  transaction_type?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
  vehicle_tank_type_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "vehicle_inventory_transaction_logs" */
export type Vehicle_Inventory_Transaction_Logs_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  current_available_quantity?: InputMaybe<Order_By>;
  customer_order_id?: InputMaybe<Order_By>;
  /** ERP document name after sync */
  erp_code?: InputMaybe<Order_By>;
  /** ERP document type (Purchase Receipt, Stock Entry) */
  erp_doctype?: InputMaybe<Order_By>;
  fillup_request_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  transaction_type?: InputMaybe<Order_By>;
  unit?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
  vehicle_tank_type_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Vehicle_Inventory_Transaction_Logs_Min_Fields = {
  __typename?: 'vehicle_inventory_transaction_logs_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  current_available_quantity?: Maybe<Scalars['numeric']['output']>;
  customer_order_id?: Maybe<Scalars['uuid']['output']>;
  /** ERP document name after sync */
  erp_code?: Maybe<Scalars['String']['output']>;
  /** ERP document type (Purchase Receipt, Stock Entry) */
  erp_doctype?: Maybe<Scalars['String']['output']>;
  fillup_request_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
  transaction_type?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
  vehicle_tank_type_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "vehicle_inventory_transaction_logs" */
export type Vehicle_Inventory_Transaction_Logs_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  current_available_quantity?: InputMaybe<Order_By>;
  customer_order_id?: InputMaybe<Order_By>;
  /** ERP document name after sync */
  erp_code?: InputMaybe<Order_By>;
  /** ERP document type (Purchase Receipt, Stock Entry) */
  erp_doctype?: InputMaybe<Order_By>;
  fillup_request_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  transaction_type?: InputMaybe<Order_By>;
  unit?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
  vehicle_tank_type_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "vehicle_inventory_transaction_logs" */
export type Vehicle_Inventory_Transaction_Logs_Mutation_Response = {
  __typename?: 'vehicle_inventory_transaction_logs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Vehicle_Inventory_Transaction_Logs>;
};

/** on_conflict condition type for table "vehicle_inventory_transaction_logs" */
export type Vehicle_Inventory_Transaction_Logs_On_Conflict = {
  constraint: Vehicle_Inventory_Transaction_Logs_Constraint;
  update_columns?: Array<Vehicle_Inventory_Transaction_Logs_Update_Column>;
  where?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Bool_Exp>;
};

/** Ordering options when selecting data from "vehicle_inventory_transaction_logs". */
export type Vehicle_Inventory_Transaction_Logs_Order_By = {
  created_at?: InputMaybe<Order_By>;
  current_available_quantity?: InputMaybe<Order_By>;
  customer_order?: InputMaybe<Customer_Order_Order_By>;
  customer_order_id?: InputMaybe<Order_By>;
  erpSyncStatusByErpSyncStatus?: InputMaybe<Erp_Sync_Status_Order_By>;
  erp_code?: InputMaybe<Order_By>;
  erp_doctype?: InputMaybe<Order_By>;
  erp_sync_status?: InputMaybe<Order_By>;
  fillup_request?: InputMaybe<Fillup_Request_Order_By>;
  fillup_request_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  product_variation?: InputMaybe<Product_Variation_Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  transactionTypeByTransactionType?: InputMaybe<Transaction_Type_Order_By>;
  transaction_type?: InputMaybe<Order_By>;
  unit?: InputMaybe<Order_By>;
  vehicle?: InputMaybe<Vehicle_Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
  vehicle_tank_type?: InputMaybe<Vehicle_Tank_Type_Order_By>;
  vehicle_tank_type_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vehicle_inventory_transaction_logs */
export type Vehicle_Inventory_Transaction_Logs_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Vehicle_Inventory_Transaction_Logs_Prepend_Input = {
  /** Additional context (images, GPS, etc.) */
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "vehicle_inventory_transaction_logs" */
export enum Vehicle_Inventory_Transaction_Logs_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentAvailableQuantity = 'current_available_quantity',
  /** column name */
  CustomerOrderId = 'customer_order_id',
  /** column name */
  ErpCode = 'erp_code',
  /** column name */
  ErpDoctype = 'erp_doctype',
  /** column name */
  ErpSyncStatus = 'erp_sync_status',
  /** column name */
  FillupRequestId = 'fillup_request_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  ProductVariationId = 'product_variation_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  TransactionType = 'transaction_type',
  /** column name */
  Unit = 'unit',
  /** column name */
  VehicleId = 'vehicle_id',
  /** column name */
  VehicleTankTypeId = 'vehicle_tank_type_id'
}

/** select "vehicle_inventory_transaction_logs_aggregate_bool_exp_bool_and_arguments_columns" columns of table "vehicle_inventory_transaction_logs" */
export enum Vehicle_Inventory_Transaction_Logs_Select_Column_Vehicle_Inventory_Transaction_Logs_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "vehicle_inventory_transaction_logs_aggregate_bool_exp_bool_or_arguments_columns" columns of table "vehicle_inventory_transaction_logs" */
export enum Vehicle_Inventory_Transaction_Logs_Select_Column_Vehicle_Inventory_Transaction_Logs_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "vehicle_inventory_transaction_logs" */
export type Vehicle_Inventory_Transaction_Logs_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  current_available_quantity?: InputMaybe<Scalars['numeric']['input']>;
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
  /** ERP document name after sync */
  erp_code?: InputMaybe<Scalars['String']['input']>;
  /** ERP document type (Purchase Receipt, Stock Entry) */
  erp_doctype?: InputMaybe<Scalars['String']['input']>;
  /** ERP sync tracking (PENDING, COMPLETED, FAILED) */
  erp_sync_status?: InputMaybe<Erp_Sync_Status_Enum>;
  fillup_request_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  /** Additional context (images, GPS, etc.) */
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  transaction_type?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  vehicle_tank_type_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Vehicle_Inventory_Transaction_Logs_Stddev_Fields = {
  __typename?: 'vehicle_inventory_transaction_logs_stddev_fields';
  current_available_quantity?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "vehicle_inventory_transaction_logs" */
export type Vehicle_Inventory_Transaction_Logs_Stddev_Order_By = {
  current_available_quantity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Vehicle_Inventory_Transaction_Logs_Stddev_Pop_Fields = {
  __typename?: 'vehicle_inventory_transaction_logs_stddev_pop_fields';
  current_available_quantity?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "vehicle_inventory_transaction_logs" */
export type Vehicle_Inventory_Transaction_Logs_Stddev_Pop_Order_By = {
  current_available_quantity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Vehicle_Inventory_Transaction_Logs_Stddev_Samp_Fields = {
  __typename?: 'vehicle_inventory_transaction_logs_stddev_samp_fields';
  current_available_quantity?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "vehicle_inventory_transaction_logs" */
export type Vehicle_Inventory_Transaction_Logs_Stddev_Samp_Order_By = {
  current_available_quantity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "vehicle_inventory_transaction_logs" */
export type Vehicle_Inventory_Transaction_Logs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vehicle_Inventory_Transaction_Logs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vehicle_Inventory_Transaction_Logs_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  current_available_quantity?: InputMaybe<Scalars['numeric']['input']>;
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
  /** ERP document name after sync */
  erp_code?: InputMaybe<Scalars['String']['input']>;
  /** ERP document type (Purchase Receipt, Stock Entry) */
  erp_doctype?: InputMaybe<Scalars['String']['input']>;
  /** ERP sync tracking (PENDING, COMPLETED, FAILED) */
  erp_sync_status?: InputMaybe<Erp_Sync_Status_Enum>;
  fillup_request_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  /** Additional context (images, GPS, etc.) */
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  transaction_type?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  vehicle_tank_type_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Vehicle_Inventory_Transaction_Logs_Sum_Fields = {
  __typename?: 'vehicle_inventory_transaction_logs_sum_fields';
  current_available_quantity?: Maybe<Scalars['numeric']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "vehicle_inventory_transaction_logs" */
export type Vehicle_Inventory_Transaction_Logs_Sum_Order_By = {
  current_available_quantity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** update columns of table "vehicle_inventory_transaction_logs" */
export enum Vehicle_Inventory_Transaction_Logs_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentAvailableQuantity = 'current_available_quantity',
  /** column name */
  CustomerOrderId = 'customer_order_id',
  /** column name */
  ErpCode = 'erp_code',
  /** column name */
  ErpDoctype = 'erp_doctype',
  /** column name */
  ErpSyncStatus = 'erp_sync_status',
  /** column name */
  FillupRequestId = 'fillup_request_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  ProductVariationId = 'product_variation_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  TransactionType = 'transaction_type',
  /** column name */
  Unit = 'unit',
  /** column name */
  VehicleId = 'vehicle_id',
  /** column name */
  VehicleTankTypeId = 'vehicle_tank_type_id'
}

export type Vehicle_Inventory_Transaction_Logs_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Vehicle_Inventory_Transaction_Logs_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Vehicle_Inventory_Transaction_Logs_Var_Pop_Fields = {
  __typename?: 'vehicle_inventory_transaction_logs_var_pop_fields';
  current_available_quantity?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "vehicle_inventory_transaction_logs" */
export type Vehicle_Inventory_Transaction_Logs_Var_Pop_Order_By = {
  current_available_quantity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Vehicle_Inventory_Transaction_Logs_Var_Samp_Fields = {
  __typename?: 'vehicle_inventory_transaction_logs_var_samp_fields';
  current_available_quantity?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "vehicle_inventory_transaction_logs" */
export type Vehicle_Inventory_Transaction_Logs_Var_Samp_Order_By = {
  current_available_quantity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Vehicle_Inventory_Transaction_Logs_Variance_Fields = {
  __typename?: 'vehicle_inventory_transaction_logs_variance_fields';
  current_available_quantity?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "vehicle_inventory_transaction_logs" */
export type Vehicle_Inventory_Transaction_Logs_Variance_Order_By = {
  current_available_quantity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** columns and relationships of "vehicle_localities" */
export type Vehicle_Localities = {
  __typename?: 'vehicle_localities';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified: Scalars['timestamptz']['output'];
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  localities_id: Scalars['uuid']['output'];
  /** An object relationship */
  locality: Localities;
  /** An object relationship */
  vehicle: Vehicle;
  vehicle_id: Scalars['uuid']['output'];
};

/** aggregated selection of "vehicle_localities" */
export type Vehicle_Localities_Aggregate = {
  __typename?: 'vehicle_localities_aggregate';
  aggregate?: Maybe<Vehicle_Localities_Aggregate_Fields>;
  nodes: Array<Vehicle_Localities>;
};

export type Vehicle_Localities_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Vehicle_Localities_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Vehicle_Localities_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Vehicle_Localities_Aggregate_Bool_Exp_Count>;
};

export type Vehicle_Localities_Aggregate_Bool_Exp_Bool_And = {
  arguments: Vehicle_Localities_Select_Column_Vehicle_Localities_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vehicle_Localities_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Vehicle_Localities_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Vehicle_Localities_Select_Column_Vehicle_Localities_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vehicle_Localities_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Vehicle_Localities_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Vehicle_Localities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vehicle_Localities_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "vehicle_localities" */
export type Vehicle_Localities_Aggregate_Fields = {
  __typename?: 'vehicle_localities_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Vehicle_Localities_Max_Fields>;
  min?: Maybe<Vehicle_Localities_Min_Fields>;
};


/** aggregate fields of "vehicle_localities" */
export type Vehicle_Localities_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vehicle_Localities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "vehicle_localities" */
export type Vehicle_Localities_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vehicle_Localities_Max_Order_By>;
  min?: InputMaybe<Vehicle_Localities_Min_Order_By>;
};

/** input type for inserting array relation for remote table "vehicle_localities" */
export type Vehicle_Localities_Arr_Rel_Insert_Input = {
  data: Array<Vehicle_Localities_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Vehicle_Localities_On_Conflict>;
};

/** Boolean expression to filter rows from the table "vehicle_localities". All fields are combined with a logical 'AND'. */
export type Vehicle_Localities_Bool_Exp = {
  _and?: InputMaybe<Array<Vehicle_Localities_Bool_Exp>>;
  _not?: InputMaybe<Vehicle_Localities_Bool_Exp>;
  _or?: InputMaybe<Array<Vehicle_Localities_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  localities_id?: InputMaybe<Uuid_Comparison_Exp>;
  locality?: InputMaybe<Localities_Bool_Exp>;
  vehicle?: InputMaybe<Vehicle_Bool_Exp>;
  vehicle_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "vehicle_localities" */
export enum Vehicle_Localities_Constraint {
  /** unique or primary key constraint on columns "id" */
  VehicleLocalitiesPkey = 'vehicle_localities_pkey',
  /** unique or primary key constraint on columns "vehicle_id", "localities_id" */
  VehicleLocalitiesVehicleIdLocalitiesIdKey = 'vehicle_localities_vehicle_id_localities_id_key'
}

/** input type for inserting data into table "vehicle_localities" */
export type Vehicle_Localities_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  localities_id?: InputMaybe<Scalars['uuid']['input']>;
  locality?: InputMaybe<Localities_Obj_Rel_Insert_Input>;
  vehicle?: InputMaybe<Vehicle_Obj_Rel_Insert_Input>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Vehicle_Localities_Max_Fields = {
  __typename?: 'vehicle_localities_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  localities_id?: Maybe<Scalars['uuid']['output']>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "vehicle_localities" */
export type Vehicle_Localities_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  localities_id?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Vehicle_Localities_Min_Fields = {
  __typename?: 'vehicle_localities_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  localities_id?: Maybe<Scalars['uuid']['output']>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "vehicle_localities" */
export type Vehicle_Localities_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  localities_id?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "vehicle_localities" */
export type Vehicle_Localities_Mutation_Response = {
  __typename?: 'vehicle_localities_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Vehicle_Localities>;
};

/** on_conflict condition type for table "vehicle_localities" */
export type Vehicle_Localities_On_Conflict = {
  constraint: Vehicle_Localities_Constraint;
  update_columns?: Array<Vehicle_Localities_Update_Column>;
  where?: InputMaybe<Vehicle_Localities_Bool_Exp>;
};

/** Ordering options when selecting data from "vehicle_localities". */
export type Vehicle_Localities_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  localities_id?: InputMaybe<Order_By>;
  locality?: InputMaybe<Localities_Order_By>;
  vehicle?: InputMaybe<Vehicle_Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vehicle_localities */
export type Vehicle_Localities_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "vehicle_localities" */
export enum Vehicle_Localities_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  LocalitiesId = 'localities_id',
  /** column name */
  VehicleId = 'vehicle_id'
}

/** select "vehicle_localities_aggregate_bool_exp_bool_and_arguments_columns" columns of table "vehicle_localities" */
export enum Vehicle_Localities_Select_Column_Vehicle_Localities_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "vehicle_localities_aggregate_bool_exp_bool_or_arguments_columns" columns of table "vehicle_localities" */
export enum Vehicle_Localities_Select_Column_Vehicle_Localities_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "vehicle_localities" */
export type Vehicle_Localities_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  localities_id?: InputMaybe<Scalars['uuid']['input']>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "vehicle_localities" */
export type Vehicle_Localities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vehicle_Localities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vehicle_Localities_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  localities_id?: InputMaybe<Scalars['uuid']['input']>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "vehicle_localities" */
export enum Vehicle_Localities_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  LocalitiesId = 'localities_id',
  /** column name */
  VehicleId = 'vehicle_id'
}

export type Vehicle_Localities_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Vehicle_Localities_Set_Input>;
  /** filter the rows which have to be updated */
  where: Vehicle_Localities_Bool_Exp;
};

/** aggregate max on columns */
export type Vehicle_Max_Fields = {
  __typename?: 'vehicle_max_fields';
  category?: Maybe<Scalars['String']['output']>;
  chassis_number?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  device_id?: Maybe<Scalars['uuid']['output']>;
  erp_code?: Maybe<Scalars['String']['output']>;
  fuel_tank_capacity?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  insurance_expire_date?: Maybe<Scalars['date']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  make?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  partner_address_id?: Maybe<Scalars['uuid']['output']>;
  plate_code?: Maybe<Scalars['String']['output']>;
  plate_number?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
  rated_capacity?: Maybe<Scalars['Int']['output']>;
  rc_expire_date?: Maybe<Scalars['date']['output']>;
  registration_number?: Maybe<Scalars['String']['output']>;
  rfid?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  tanker_capacity?: Maybe<Scalars['Int']['output']>;
  tanker_compartment_number?: Maybe<Scalars['Int']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "vehicle" */
export type Vehicle_Max_Order_By = {
  category?: InputMaybe<Order_By>;
  chassis_number?: InputMaybe<Order_By>;
  color?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  erp_code?: InputMaybe<Order_By>;
  fuel_tank_capacity?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insurance_expire_date?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  make?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  partner_address_id?: InputMaybe<Order_By>;
  plate_code?: InputMaybe<Order_By>;
  plate_number?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rated_capacity?: InputMaybe<Order_By>;
  rc_expire_date?: InputMaybe<Order_By>;
  registration_number?: InputMaybe<Order_By>;
  rfid?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  tanker_capacity?: InputMaybe<Order_By>;
  tanker_compartment_number?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Vehicle_Min_Fields = {
  __typename?: 'vehicle_min_fields';
  category?: Maybe<Scalars['String']['output']>;
  chassis_number?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  device_id?: Maybe<Scalars['uuid']['output']>;
  erp_code?: Maybe<Scalars['String']['output']>;
  fuel_tank_capacity?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  insurance_expire_date?: Maybe<Scalars['date']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  make?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  partner_address_id?: Maybe<Scalars['uuid']['output']>;
  plate_code?: Maybe<Scalars['String']['output']>;
  plate_number?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
  rated_capacity?: Maybe<Scalars['Int']['output']>;
  rc_expire_date?: Maybe<Scalars['date']['output']>;
  registration_number?: Maybe<Scalars['String']['output']>;
  rfid?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  tanker_capacity?: Maybe<Scalars['Int']['output']>;
  tanker_compartment_number?: Maybe<Scalars['Int']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "vehicle" */
export type Vehicle_Min_Order_By = {
  category?: InputMaybe<Order_By>;
  chassis_number?: InputMaybe<Order_By>;
  color?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  erp_code?: InputMaybe<Order_By>;
  fuel_tank_capacity?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insurance_expire_date?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  make?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  partner_address_id?: InputMaybe<Order_By>;
  plate_code?: InputMaybe<Order_By>;
  plate_number?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rated_capacity?: InputMaybe<Order_By>;
  rc_expire_date?: InputMaybe<Order_By>;
  registration_number?: InputMaybe<Order_By>;
  rfid?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  tanker_capacity?: InputMaybe<Order_By>;
  tanker_compartment_number?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "vehicle" */
export type Vehicle_Mutation_Response = {
  __typename?: 'vehicle_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Vehicle>;
};

/** input type for inserting object relation for remote table "vehicle" */
export type Vehicle_Obj_Rel_Insert_Input = {
  data: Vehicle_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Vehicle_On_Conflict>;
};

/** on_conflict condition type for table "vehicle" */
export type Vehicle_On_Conflict = {
  constraint: Vehicle_Constraint;
  update_columns?: Array<Vehicle_Update_Column>;
  where?: InputMaybe<Vehicle_Bool_Exp>;
};

/** Ordering options when selecting data from "vehicle". */
export type Vehicle_Order_By = {
  category?: InputMaybe<Order_By>;
  chassis_number?: InputMaybe<Order_By>;
  color?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  delivery_schedulers_aggregate?: InputMaybe<Delivery_Scheduler_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  dispensers_aggregate?: InputMaybe<Dispenser_Aggregate_Order_By>;
  driver_vehicles_aggregate?: InputMaybe<Driver_Vehicle_Aggregate_Order_By>;
  erp_code?: InputMaybe<Order_By>;
  fuel_tank_capacity?: InputMaybe<Order_By>;
  fueltrans_enabled?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insurance_expire_date?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_mothership?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  make?: InputMaybe<Order_By>;
  master_slots_aggregate?: InputMaybe<Master_Slot_Aggregate_Order_By>;
  model?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  partner_address?: InputMaybe<Partner_Address_Order_By>;
  partner_address_id?: InputMaybe<Order_By>;
  partner_vehicles_aggregate?: InputMaybe<Partner_Vehicle_Aggregate_Order_By>;
  plate_code?: InputMaybe<Order_By>;
  plate_number?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rated_capacity?: InputMaybe<Order_By>;
  rc_expire_date?: InputMaybe<Order_By>;
  registration_number?: InputMaybe<Order_By>;
  rfid?: InputMaybe<Order_By>;
  shift_schedules_aggregate?: InputMaybe<Shift_Schedule_Aggregate_Order_By>;
  state?: InputMaybe<State_Order_By>;
  state_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tanker_capacity?: InputMaybe<Order_By>;
  tanker_compartment_number?: InputMaybe<Order_By>;
  taskStatesFlowsByPreviousVehicleId_aggregate?: InputMaybe<Task_States_Flow_Aggregate_Order_By>;
  tasks_aggregate?: InputMaybe<Task_Aggregate_Order_By>;
  trip_plans_aggregate?: InputMaybe<Trip_Plan_Aggregate_Order_By>;
  vehicleStatusByStatus?: InputMaybe<Vehicle_Status_Order_By>;
  vehicleTypeByVehicleType?: InputMaybe<Vehicle_Type_Order_By>;
  vehicle_configurations_aggregate?: InputMaybe<Vehicle_Configuration_Aggregate_Order_By>;
  vehicle_devices_aggregate?: InputMaybe<Vehicle_Device_Aggregate_Order_By>;
  vehicle_inventory_transaction_logs_aggregate?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Aggregate_Order_By>;
  vehicle_localities_aggregate?: InputMaybe<Vehicle_Localities_Aggregate_Order_By>;
  vehicle_permits_aggregate?: InputMaybe<Vehicle_Permit_Aggregate_Order_By>;
  vehicle_shift_templates_aggregate?: InputMaybe<Vehicle_Shift_Template_Aggregate_Order_By>;
  vehicle_status_logs_aggregate?: InputMaybe<Vehicle_Status_Logs_Aggregate_Order_By>;
  vehicle_tank_types_aggregate?: InputMaybe<Vehicle_Tank_Type_Aggregate_Order_By>;
  vehicle_type?: InputMaybe<Order_By>;
  vendor_order_logs_aggregate?: InputMaybe<Vendor_Order_Logs_Aggregate_Order_By>;
  year?: InputMaybe<Order_By>;
};

/** columns and relationships of "vehicle_permit" */
export type Vehicle_Permit = {
  __typename?: 'vehicle_permit';
  created_at: Scalars['timestamptz']['output'];
  expiry_date?: Maybe<Scalars['date']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified: Scalars['timestamptz']['output'];
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  permit: Permit;
  permit_id: Scalars['uuid']['output'];
  /** An object relationship */
  vehicle: Vehicle;
  vehicle_id: Scalars['uuid']['output'];
};

/** aggregated selection of "vehicle_permit" */
export type Vehicle_Permit_Aggregate = {
  __typename?: 'vehicle_permit_aggregate';
  aggregate?: Maybe<Vehicle_Permit_Aggregate_Fields>;
  nodes: Array<Vehicle_Permit>;
};

export type Vehicle_Permit_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Vehicle_Permit_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Vehicle_Permit_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Vehicle_Permit_Aggregate_Bool_Exp_Count>;
};

export type Vehicle_Permit_Aggregate_Bool_Exp_Bool_And = {
  arguments: Vehicle_Permit_Select_Column_Vehicle_Permit_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vehicle_Permit_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Vehicle_Permit_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Vehicle_Permit_Select_Column_Vehicle_Permit_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vehicle_Permit_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Vehicle_Permit_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Vehicle_Permit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vehicle_Permit_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "vehicle_permit" */
export type Vehicle_Permit_Aggregate_Fields = {
  __typename?: 'vehicle_permit_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Vehicle_Permit_Max_Fields>;
  min?: Maybe<Vehicle_Permit_Min_Fields>;
};


/** aggregate fields of "vehicle_permit" */
export type Vehicle_Permit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vehicle_Permit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "vehicle_permit" */
export type Vehicle_Permit_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vehicle_Permit_Max_Order_By>;
  min?: InputMaybe<Vehicle_Permit_Min_Order_By>;
};

/** input type for inserting array relation for remote table "vehicle_permit" */
export type Vehicle_Permit_Arr_Rel_Insert_Input = {
  data: Array<Vehicle_Permit_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Vehicle_Permit_On_Conflict>;
};

/** Boolean expression to filter rows from the table "vehicle_permit". All fields are combined with a logical 'AND'. */
export type Vehicle_Permit_Bool_Exp = {
  _and?: InputMaybe<Array<Vehicle_Permit_Bool_Exp>>;
  _not?: InputMaybe<Vehicle_Permit_Bool_Exp>;
  _or?: InputMaybe<Array<Vehicle_Permit_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  expiry_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  permit?: InputMaybe<Permit_Bool_Exp>;
  permit_id?: InputMaybe<Uuid_Comparison_Exp>;
  vehicle?: InputMaybe<Vehicle_Bool_Exp>;
  vehicle_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "vehicle_permit" */
export enum Vehicle_Permit_Constraint {
  /** unique or primary key constraint on columns "id" */
  VehiclePermitPkey = 'vehicle_permit_pkey',
  /** unique or primary key constraint on columns "permit_id", "vehicle_id" */
  VehiclePermitVehicleIdPermitIdKey = 'vehicle_permit_vehicle_id_permit_id_key'
}

/** input type for inserting data into table "vehicle_permit" */
export type Vehicle_Permit_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  expiry_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  permit?: InputMaybe<Permit_Obj_Rel_Insert_Input>;
  permit_id?: InputMaybe<Scalars['uuid']['input']>;
  vehicle?: InputMaybe<Vehicle_Obj_Rel_Insert_Input>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Vehicle_Permit_Max_Fields = {
  __typename?: 'vehicle_permit_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  expiry_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  permit_id?: Maybe<Scalars['uuid']['output']>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "vehicle_permit" */
export type Vehicle_Permit_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  expiry_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  permit_id?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Vehicle_Permit_Min_Fields = {
  __typename?: 'vehicle_permit_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  expiry_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  permit_id?: Maybe<Scalars['uuid']['output']>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "vehicle_permit" */
export type Vehicle_Permit_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  expiry_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  permit_id?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "vehicle_permit" */
export type Vehicle_Permit_Mutation_Response = {
  __typename?: 'vehicle_permit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Vehicle_Permit>;
};

/** on_conflict condition type for table "vehicle_permit" */
export type Vehicle_Permit_On_Conflict = {
  constraint: Vehicle_Permit_Constraint;
  update_columns?: Array<Vehicle_Permit_Update_Column>;
  where?: InputMaybe<Vehicle_Permit_Bool_Exp>;
};

/** Ordering options when selecting data from "vehicle_permit". */
export type Vehicle_Permit_Order_By = {
  created_at?: InputMaybe<Order_By>;
  expiry_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  permit?: InputMaybe<Permit_Order_By>;
  permit_id?: InputMaybe<Order_By>;
  vehicle?: InputMaybe<Vehicle_Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vehicle_permit */
export type Vehicle_Permit_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "vehicle_permit" */
export enum Vehicle_Permit_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiryDate = 'expiry_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PermitId = 'permit_id',
  /** column name */
  VehicleId = 'vehicle_id'
}

/** select "vehicle_permit_aggregate_bool_exp_bool_and_arguments_columns" columns of table "vehicle_permit" */
export enum Vehicle_Permit_Select_Column_Vehicle_Permit_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "vehicle_permit_aggregate_bool_exp_bool_or_arguments_columns" columns of table "vehicle_permit" */
export enum Vehicle_Permit_Select_Column_Vehicle_Permit_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "vehicle_permit" */
export type Vehicle_Permit_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  expiry_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  permit_id?: InputMaybe<Scalars['uuid']['input']>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "vehicle_permit" */
export type Vehicle_Permit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vehicle_Permit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vehicle_Permit_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  expiry_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  permit_id?: InputMaybe<Scalars['uuid']['input']>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "vehicle_permit" */
export enum Vehicle_Permit_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiryDate = 'expiry_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  PermitId = 'permit_id',
  /** column name */
  VehicleId = 'vehicle_id'
}

export type Vehicle_Permit_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Vehicle_Permit_Set_Input>;
  /** filter the rows which have to be updated */
  where: Vehicle_Permit_Bool_Exp;
};

/** primary key columns input for table: vehicle */
export type Vehicle_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "vehicle" */
export enum Vehicle_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  ChassisNumber = 'chassis_number',
  /** column name */
  Color = 'color',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  DeviceId = 'device_id',
  /** column name */
  ErpCode = 'erp_code',
  /** column name */
  FuelTankCapacity = 'fuel_tank_capacity',
  /** column name */
  FueltransEnabled = 'fueltrans_enabled',
  /** column name */
  Id = 'id',
  /** column name */
  InsuranceExpireDate = 'insurance_expire_date',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsMothership = 'is_mothership',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Location = 'location',
  /** column name */
  Make = 'make',
  /** column name */
  Model = 'model',
  /** column name */
  Name = 'name',
  /** column name */
  PartnerAddressId = 'partner_address_id',
  /** column name */
  PlateCode = 'plate_code',
  /** column name */
  PlateNumber = 'plate_number',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  RatedCapacity = 'rated_capacity',
  /** column name */
  RcExpireDate = 'rc_expire_date',
  /** column name */
  RegistrationNumber = 'registration_number',
  /** column name */
  Rfid = 'rfid',
  /** column name */
  StateId = 'state_id',
  /** column name */
  Status = 'status',
  /** column name */
  TankerCapacity = 'tanker_capacity',
  /** column name */
  TankerCompartmentNumber = 'tanker_compartment_number',
  /** column name */
  VehicleType = 'vehicle_type',
  /** column name */
  Year = 'year'
}

/** select "vehicle_aggregate_bool_exp_bool_and_arguments_columns" columns of table "vehicle" */
export enum Vehicle_Select_Column_Vehicle_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  FueltransEnabled = 'fueltrans_enabled',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsMothership = 'is_mothership'
}

/** select "vehicle_aggregate_bool_exp_bool_or_arguments_columns" columns of table "vehicle" */
export enum Vehicle_Select_Column_Vehicle_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  FueltransEnabled = 'fueltrans_enabled',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsMothership = 'is_mothership'
}

/** input type for updating data in table "vehicle" */
export type Vehicle_Set_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  chassis_number?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  device_id?: InputMaybe<Scalars['uuid']['input']>;
  erp_code?: InputMaybe<Scalars['String']['input']>;
  fuel_tank_capacity?: InputMaybe<Scalars['Int']['input']>;
  fueltrans_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  insurance_expire_date?: InputMaybe<Scalars['date']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_mothership?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['point']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partner_address_id?: InputMaybe<Scalars['uuid']['input']>;
  plate_code?: InputMaybe<Scalars['String']['input']>;
  plate_number?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  rated_capacity?: InputMaybe<Scalars['Int']['input']>;
  rc_expire_date?: InputMaybe<Scalars['date']['input']>;
  registration_number?: InputMaybe<Scalars['String']['input']>;
  rfid?: InputMaybe<Scalars['String']['input']>;
  state_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Vehicle_Status_Enum>;
  tanker_capacity?: InputMaybe<Scalars['Int']['input']>;
  tanker_compartment_number?: InputMaybe<Scalars['Int']['input']>;
  vehicle_type?: InputMaybe<Vehicle_Type_Enum>;
  year?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "vehicle_shift_template" */
export type Vehicle_Shift_Template = {
  __typename?: 'vehicle_shift_template';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  created_by_user?: Maybe<User>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  /** An object relationship */
  shift_schedule?: Maybe<Shift_Schedule>;
  shift_schedule_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  shift_template: Shift_Template;
  shift_template_id: Scalars['uuid']['output'];
  /** An object relationship */
  vehicle: Vehicle;
  vehicle_id: Scalars['uuid']['output'];
};

/** aggregated selection of "vehicle_shift_template" */
export type Vehicle_Shift_Template_Aggregate = {
  __typename?: 'vehicle_shift_template_aggregate';
  aggregate?: Maybe<Vehicle_Shift_Template_Aggregate_Fields>;
  nodes: Array<Vehicle_Shift_Template>;
};

export type Vehicle_Shift_Template_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Vehicle_Shift_Template_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Vehicle_Shift_Template_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Vehicle_Shift_Template_Aggregate_Bool_Exp_Count>;
};

export type Vehicle_Shift_Template_Aggregate_Bool_Exp_Bool_And = {
  arguments: Vehicle_Shift_Template_Select_Column_Vehicle_Shift_Template_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vehicle_Shift_Template_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Vehicle_Shift_Template_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Vehicle_Shift_Template_Select_Column_Vehicle_Shift_Template_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vehicle_Shift_Template_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Vehicle_Shift_Template_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Vehicle_Shift_Template_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vehicle_Shift_Template_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "vehicle_shift_template" */
export type Vehicle_Shift_Template_Aggregate_Fields = {
  __typename?: 'vehicle_shift_template_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Vehicle_Shift_Template_Max_Fields>;
  min?: Maybe<Vehicle_Shift_Template_Min_Fields>;
};


/** aggregate fields of "vehicle_shift_template" */
export type Vehicle_Shift_Template_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vehicle_Shift_Template_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "vehicle_shift_template" */
export type Vehicle_Shift_Template_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vehicle_Shift_Template_Max_Order_By>;
  min?: InputMaybe<Vehicle_Shift_Template_Min_Order_By>;
};

/** input type for inserting array relation for remote table "vehicle_shift_template" */
export type Vehicle_Shift_Template_Arr_Rel_Insert_Input = {
  data: Array<Vehicle_Shift_Template_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Vehicle_Shift_Template_On_Conflict>;
};

/** Boolean expression to filter rows from the table "vehicle_shift_template". All fields are combined with a logical 'AND'. */
export type Vehicle_Shift_Template_Bool_Exp = {
  _and?: InputMaybe<Array<Vehicle_Shift_Template_Bool_Exp>>;
  _not?: InputMaybe<Vehicle_Shift_Template_Bool_Exp>;
  _or?: InputMaybe<Array<Vehicle_Shift_Template_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  created_by_user?: InputMaybe<User_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  shift_schedule?: InputMaybe<Shift_Schedule_Bool_Exp>;
  shift_schedule_id?: InputMaybe<Uuid_Comparison_Exp>;
  shift_template?: InputMaybe<Shift_Template_Bool_Exp>;
  shift_template_id?: InputMaybe<Uuid_Comparison_Exp>;
  vehicle?: InputMaybe<Vehicle_Bool_Exp>;
  vehicle_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "vehicle_shift_template" */
export enum Vehicle_Shift_Template_Constraint {
  /** unique or primary key constraint on columns "id" */
  VehicleShiftTemplatePkey = 'vehicle_shift_template_pkey',
  /** unique or primary key constraint on columns "shift_template_id", "vehicle_id" */
  VehicleShiftTemplateUnique = 'vehicle_shift_template_unique'
}

/** input type for inserting data into table "vehicle_shift_template" */
export type Vehicle_Shift_Template_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  created_by_user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  shift_schedule?: InputMaybe<Shift_Schedule_Obj_Rel_Insert_Input>;
  shift_schedule_id?: InputMaybe<Scalars['uuid']['input']>;
  shift_template?: InputMaybe<Shift_Template_Obj_Rel_Insert_Input>;
  shift_template_id?: InputMaybe<Scalars['uuid']['input']>;
  vehicle?: InputMaybe<Vehicle_Obj_Rel_Insert_Input>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Vehicle_Shift_Template_Max_Fields = {
  __typename?: 'vehicle_shift_template_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  shift_schedule_id?: Maybe<Scalars['uuid']['output']>;
  shift_template_id?: Maybe<Scalars['uuid']['output']>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "vehicle_shift_template" */
export type Vehicle_Shift_Template_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shift_schedule_id?: InputMaybe<Order_By>;
  shift_template_id?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Vehicle_Shift_Template_Min_Fields = {
  __typename?: 'vehicle_shift_template_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  shift_schedule_id?: Maybe<Scalars['uuid']['output']>;
  shift_template_id?: Maybe<Scalars['uuid']['output']>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "vehicle_shift_template" */
export type Vehicle_Shift_Template_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shift_schedule_id?: InputMaybe<Order_By>;
  shift_template_id?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "vehicle_shift_template" */
export type Vehicle_Shift_Template_Mutation_Response = {
  __typename?: 'vehicle_shift_template_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Vehicle_Shift_Template>;
};

/** on_conflict condition type for table "vehicle_shift_template" */
export type Vehicle_Shift_Template_On_Conflict = {
  constraint: Vehicle_Shift_Template_Constraint;
  update_columns?: Array<Vehicle_Shift_Template_Update_Column>;
  where?: InputMaybe<Vehicle_Shift_Template_Bool_Exp>;
};

/** Ordering options when selecting data from "vehicle_shift_template". */
export type Vehicle_Shift_Template_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<User_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  shift_schedule?: InputMaybe<Shift_Schedule_Order_By>;
  shift_schedule_id?: InputMaybe<Order_By>;
  shift_template?: InputMaybe<Shift_Template_Order_By>;
  shift_template_id?: InputMaybe<Order_By>;
  vehicle?: InputMaybe<Vehicle_Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vehicle_shift_template */
export type Vehicle_Shift_Template_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "vehicle_shift_template" */
export enum Vehicle_Shift_Template_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  ShiftScheduleId = 'shift_schedule_id',
  /** column name */
  ShiftTemplateId = 'shift_template_id',
  /** column name */
  VehicleId = 'vehicle_id'
}

/** select "vehicle_shift_template_aggregate_bool_exp_bool_and_arguments_columns" columns of table "vehicle_shift_template" */
export enum Vehicle_Shift_Template_Select_Column_Vehicle_Shift_Template_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "vehicle_shift_template_aggregate_bool_exp_bool_or_arguments_columns" columns of table "vehicle_shift_template" */
export enum Vehicle_Shift_Template_Select_Column_Vehicle_Shift_Template_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "vehicle_shift_template" */
export type Vehicle_Shift_Template_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  shift_schedule_id?: InputMaybe<Scalars['uuid']['input']>;
  shift_template_id?: InputMaybe<Scalars['uuid']['input']>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "vehicle_shift_template" */
export type Vehicle_Shift_Template_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vehicle_Shift_Template_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vehicle_Shift_Template_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  shift_schedule_id?: InputMaybe<Scalars['uuid']['input']>;
  shift_template_id?: InputMaybe<Scalars['uuid']['input']>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "vehicle_shift_template" */
export enum Vehicle_Shift_Template_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  ShiftScheduleId = 'shift_schedule_id',
  /** column name */
  ShiftTemplateId = 'shift_template_id',
  /** column name */
  VehicleId = 'vehicle_id'
}

export type Vehicle_Shift_Template_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Vehicle_Shift_Template_Set_Input>;
  /** filter the rows which have to be updated */
  where: Vehicle_Shift_Template_Bool_Exp;
};

/** columns and relationships of "vehicle_status" */
export type Vehicle_Status = {
  __typename?: 'vehicle_status';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
  /** An array relationship */
  vehicles: Array<Vehicle>;
  /** An aggregate relationship */
  vehicles_aggregate: Vehicle_Aggregate;
};


/** columns and relationships of "vehicle_status" */
export type Vehicle_StatusVehiclesArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Order_By>>;
  where?: InputMaybe<Vehicle_Bool_Exp>;
};


/** columns and relationships of "vehicle_status" */
export type Vehicle_StatusVehicles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Order_By>>;
  where?: InputMaybe<Vehicle_Bool_Exp>;
};

/** aggregated selection of "vehicle_status" */
export type Vehicle_Status_Aggregate = {
  __typename?: 'vehicle_status_aggregate';
  aggregate?: Maybe<Vehicle_Status_Aggregate_Fields>;
  nodes: Array<Vehicle_Status>;
};

/** aggregate fields of "vehicle_status" */
export type Vehicle_Status_Aggregate_Fields = {
  __typename?: 'vehicle_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Vehicle_Status_Max_Fields>;
  min?: Maybe<Vehicle_Status_Min_Fields>;
};


/** aggregate fields of "vehicle_status" */
export type Vehicle_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vehicle_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "vehicle_status". All fields are combined with a logical 'AND'. */
export type Vehicle_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Vehicle_Status_Bool_Exp>>;
  _not?: InputMaybe<Vehicle_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Vehicle_Status_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
  vehicles?: InputMaybe<Vehicle_Bool_Exp>;
  vehicles_aggregate?: InputMaybe<Vehicle_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "vehicle_status" */
export enum Vehicle_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  VehicleStatusPkey = 'vehicle_status_pkey'
}

export enum Vehicle_Status_Enum {
  /** Automation Installation */
  AutomationInstallation = 'AUTOMATION_INSTALLATION',
  /** Blocked - Repairs */
  BlockedRepairs = 'BLOCKED_REPAIRS',
  /** Blocked - Service */
  BlockedService = 'BLOCKED_SERVICE',
  /** Blocked - Tech */
  BlockedTech = 'BLOCKED_TECH',
  /** Breakdown - Mech */
  BreakdownMech = 'BREAKDOWN_MECH',
  /** Breakdown - Tech */
  BreakdownTech = 'BREAKDOWN_TECH',
  /** In Fleet - Automation */
  InFleetAutomation = 'IN_FLEET_AUTOMATION',
  /** In Fleet - Manual */
  InFleetManual = 'IN_FLEET_MANUAL',
  /** In Testing */
  InTesting = 'IN_TESTING',
  /** Partial Breakdown */
  PartialBreakdown = 'PARTIAL_BREAKDOWN',
  /** Truck Discontinued */
  TruckDiscontinued = 'TRUCK_DISCONTINUED'
}

/** Boolean expression to compare columns of type "vehicle_status_enum". All fields are combined with logical 'AND'. */
export type Vehicle_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Vehicle_Status_Enum>;
  _in?: InputMaybe<Array<Vehicle_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Vehicle_Status_Enum>;
  _nin?: InputMaybe<Array<Vehicle_Status_Enum>>;
};

/** input type for inserting data into table "vehicle_status" */
export type Vehicle_Status_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  vehicles?: InputMaybe<Vehicle_Arr_Rel_Insert_Input>;
};

/** columns and relationships of "vehicle_status_logs" */
export type Vehicle_Status_Logs = {
  __typename?: 'vehicle_status_logs';
  changed_by?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  current_status: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  previous_status: Scalars['Boolean']['output'];
  /** An object relationship */
  vehicle: Vehicle;
  vehicle_id: Scalars['uuid']['output'];
};

/** aggregated selection of "vehicle_status_logs" */
export type Vehicle_Status_Logs_Aggregate = {
  __typename?: 'vehicle_status_logs_aggregate';
  aggregate?: Maybe<Vehicle_Status_Logs_Aggregate_Fields>;
  nodes: Array<Vehicle_Status_Logs>;
};

export type Vehicle_Status_Logs_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Vehicle_Status_Logs_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Vehicle_Status_Logs_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Vehicle_Status_Logs_Aggregate_Bool_Exp_Count>;
};

export type Vehicle_Status_Logs_Aggregate_Bool_Exp_Bool_And = {
  arguments: Vehicle_Status_Logs_Select_Column_Vehicle_Status_Logs_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vehicle_Status_Logs_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Vehicle_Status_Logs_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Vehicle_Status_Logs_Select_Column_Vehicle_Status_Logs_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vehicle_Status_Logs_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Vehicle_Status_Logs_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Vehicle_Status_Logs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vehicle_Status_Logs_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "vehicle_status_logs" */
export type Vehicle_Status_Logs_Aggregate_Fields = {
  __typename?: 'vehicle_status_logs_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Vehicle_Status_Logs_Max_Fields>;
  min?: Maybe<Vehicle_Status_Logs_Min_Fields>;
};


/** aggregate fields of "vehicle_status_logs" */
export type Vehicle_Status_Logs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vehicle_Status_Logs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "vehicle_status_logs" */
export type Vehicle_Status_Logs_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vehicle_Status_Logs_Max_Order_By>;
  min?: InputMaybe<Vehicle_Status_Logs_Min_Order_By>;
};

/** input type for inserting array relation for remote table "vehicle_status_logs" */
export type Vehicle_Status_Logs_Arr_Rel_Insert_Input = {
  data: Array<Vehicle_Status_Logs_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Vehicle_Status_Logs_On_Conflict>;
};

/** Boolean expression to filter rows from the table "vehicle_status_logs". All fields are combined with a logical 'AND'. */
export type Vehicle_Status_Logs_Bool_Exp = {
  _and?: InputMaybe<Array<Vehicle_Status_Logs_Bool_Exp>>;
  _not?: InputMaybe<Vehicle_Status_Logs_Bool_Exp>;
  _or?: InputMaybe<Array<Vehicle_Status_Logs_Bool_Exp>>;
  changed_by?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  current_status?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  previous_status?: InputMaybe<Boolean_Comparison_Exp>;
  vehicle?: InputMaybe<Vehicle_Bool_Exp>;
  vehicle_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "vehicle_status_logs" */
export enum Vehicle_Status_Logs_Constraint {
  /** unique or primary key constraint on columns "id" */
  VehicleStatusLogsPkey = 'vehicle_status_logs_pkey'
}

/** input type for inserting data into table "vehicle_status_logs" */
export type Vehicle_Status_Logs_Insert_Input = {
  changed_by?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  current_status?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  previous_status?: InputMaybe<Scalars['Boolean']['input']>;
  vehicle?: InputMaybe<Vehicle_Obj_Rel_Insert_Input>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Vehicle_Status_Logs_Max_Fields = {
  __typename?: 'vehicle_status_logs_max_fields';
  changed_by?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "vehicle_status_logs" */
export type Vehicle_Status_Logs_Max_Order_By = {
  changed_by?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Vehicle_Status_Logs_Min_Fields = {
  __typename?: 'vehicle_status_logs_min_fields';
  changed_by?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "vehicle_status_logs" */
export type Vehicle_Status_Logs_Min_Order_By = {
  changed_by?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "vehicle_status_logs" */
export type Vehicle_Status_Logs_Mutation_Response = {
  __typename?: 'vehicle_status_logs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Vehicle_Status_Logs>;
};

/** on_conflict condition type for table "vehicle_status_logs" */
export type Vehicle_Status_Logs_On_Conflict = {
  constraint: Vehicle_Status_Logs_Constraint;
  update_columns?: Array<Vehicle_Status_Logs_Update_Column>;
  where?: InputMaybe<Vehicle_Status_Logs_Bool_Exp>;
};

/** Ordering options when selecting data from "vehicle_status_logs". */
export type Vehicle_Status_Logs_Order_By = {
  changed_by?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  current_status?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  previous_status?: InputMaybe<Order_By>;
  vehicle?: InputMaybe<Vehicle_Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vehicle_status_logs */
export type Vehicle_Status_Logs_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "vehicle_status_logs" */
export enum Vehicle_Status_Logs_Select_Column {
  /** column name */
  ChangedBy = 'changed_by',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentStatus = 'current_status',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  PreviousStatus = 'previous_status',
  /** column name */
  VehicleId = 'vehicle_id'
}

/** select "vehicle_status_logs_aggregate_bool_exp_bool_and_arguments_columns" columns of table "vehicle_status_logs" */
export enum Vehicle_Status_Logs_Select_Column_Vehicle_Status_Logs_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  CurrentStatus = 'current_status',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  PreviousStatus = 'previous_status'
}

/** select "vehicle_status_logs_aggregate_bool_exp_bool_or_arguments_columns" columns of table "vehicle_status_logs" */
export enum Vehicle_Status_Logs_Select_Column_Vehicle_Status_Logs_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  CurrentStatus = 'current_status',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  PreviousStatus = 'previous_status'
}

/** input type for updating data in table "vehicle_status_logs" */
export type Vehicle_Status_Logs_Set_Input = {
  changed_by?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  current_status?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  previous_status?: InputMaybe<Scalars['Boolean']['input']>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "vehicle_status_logs" */
export type Vehicle_Status_Logs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vehicle_Status_Logs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vehicle_Status_Logs_Stream_Cursor_Value_Input = {
  changed_by?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  current_status?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  previous_status?: InputMaybe<Scalars['Boolean']['input']>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "vehicle_status_logs" */
export enum Vehicle_Status_Logs_Update_Column {
  /** column name */
  ChangedBy = 'changed_by',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentStatus = 'current_status',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  PreviousStatus = 'previous_status',
  /** column name */
  VehicleId = 'vehicle_id'
}

export type Vehicle_Status_Logs_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Vehicle_Status_Logs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Vehicle_Status_Logs_Bool_Exp;
};

/** aggregate max on columns */
export type Vehicle_Status_Max_Fields = {
  __typename?: 'vehicle_status_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Vehicle_Status_Min_Fields = {
  __typename?: 'vehicle_status_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "vehicle_status" */
export type Vehicle_Status_Mutation_Response = {
  __typename?: 'vehicle_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Vehicle_Status>;
};

/** input type for inserting object relation for remote table "vehicle_status" */
export type Vehicle_Status_Obj_Rel_Insert_Input = {
  data: Vehicle_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Vehicle_Status_On_Conflict>;
};

/** on_conflict condition type for table "vehicle_status" */
export type Vehicle_Status_On_Conflict = {
  constraint: Vehicle_Status_Constraint;
  update_columns?: Array<Vehicle_Status_Update_Column>;
  where?: InputMaybe<Vehicle_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "vehicle_status". */
export type Vehicle_Status_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  vehicles_aggregate?: InputMaybe<Vehicle_Aggregate_Order_By>;
};

/** primary key columns input for table: vehicle_status */
export type Vehicle_Status_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "vehicle_status" */
export enum Vehicle_Status_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "vehicle_status" */
export type Vehicle_Status_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "vehicle_status" */
export type Vehicle_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vehicle_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vehicle_Status_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "vehicle_status" */
export enum Vehicle_Status_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Vehicle_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Vehicle_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Vehicle_Status_Bool_Exp;
};

/** aggregate stddev on columns */
export type Vehicle_Stddev_Fields = {
  __typename?: 'vehicle_stddev_fields';
  fuel_tank_capacity?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  rated_capacity?: Maybe<Scalars['Float']['output']>;
  tanker_capacity?: Maybe<Scalars['Float']['output']>;
  tanker_compartment_number?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "vehicle" */
export type Vehicle_Stddev_Order_By = {
  fuel_tank_capacity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rated_capacity?: InputMaybe<Order_By>;
  tanker_capacity?: InputMaybe<Order_By>;
  tanker_compartment_number?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Vehicle_Stddev_Pop_Fields = {
  __typename?: 'vehicle_stddev_pop_fields';
  fuel_tank_capacity?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  rated_capacity?: Maybe<Scalars['Float']['output']>;
  tanker_capacity?: Maybe<Scalars['Float']['output']>;
  tanker_compartment_number?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "vehicle" */
export type Vehicle_Stddev_Pop_Order_By = {
  fuel_tank_capacity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rated_capacity?: InputMaybe<Order_By>;
  tanker_capacity?: InputMaybe<Order_By>;
  tanker_compartment_number?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Vehicle_Stddev_Samp_Fields = {
  __typename?: 'vehicle_stddev_samp_fields';
  fuel_tank_capacity?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  rated_capacity?: Maybe<Scalars['Float']['output']>;
  tanker_capacity?: Maybe<Scalars['Float']['output']>;
  tanker_compartment_number?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "vehicle" */
export type Vehicle_Stddev_Samp_Order_By = {
  fuel_tank_capacity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rated_capacity?: InputMaybe<Order_By>;
  tanker_capacity?: InputMaybe<Order_By>;
  tanker_compartment_number?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "vehicle" */
export type Vehicle_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vehicle_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vehicle_Stream_Cursor_Value_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  chassis_number?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  device_id?: InputMaybe<Scalars['uuid']['input']>;
  erp_code?: InputMaybe<Scalars['String']['input']>;
  fuel_tank_capacity?: InputMaybe<Scalars['Int']['input']>;
  fueltrans_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  insurance_expire_date?: InputMaybe<Scalars['date']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_mothership?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['point']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partner_address_id?: InputMaybe<Scalars['uuid']['input']>;
  plate_code?: InputMaybe<Scalars['String']['input']>;
  plate_number?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  rated_capacity?: InputMaybe<Scalars['Int']['input']>;
  rc_expire_date?: InputMaybe<Scalars['date']['input']>;
  registration_number?: InputMaybe<Scalars['String']['input']>;
  rfid?: InputMaybe<Scalars['String']['input']>;
  state_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Vehicle_Status_Enum>;
  tanker_capacity?: InputMaybe<Scalars['Int']['input']>;
  tanker_compartment_number?: InputMaybe<Scalars['Int']['input']>;
  vehicle_type?: InputMaybe<Vehicle_Type_Enum>;
  year?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Vehicle_Sum_Fields = {
  __typename?: 'vehicle_sum_fields';
  fuel_tank_capacity?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
  rated_capacity?: Maybe<Scalars['Int']['output']>;
  tanker_capacity?: Maybe<Scalars['Int']['output']>;
  tanker_compartment_number?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "vehicle" */
export type Vehicle_Sum_Order_By = {
  fuel_tank_capacity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rated_capacity?: InputMaybe<Order_By>;
  tanker_capacity?: InputMaybe<Order_By>;
  tanker_compartment_number?: InputMaybe<Order_By>;
};

/** columns and relationships of "vehicle_tank_type" */
export type Vehicle_Tank_Type = {
  __typename?: 'vehicle_tank_type';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  dispenser_product_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  tank_capacity?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  tank_type: Tank_Type;
  tank_type_id: Scalars['uuid']['output'];
  /** An object relationship */
  vehicle: Vehicle;
  vehicle_id: Scalars['uuid']['output'];
  /** An array relationship */
  vehicle_inventory_transaction_logs: Array<Vehicle_Inventory_Transaction_Logs>;
  /** An aggregate relationship */
  vehicle_inventory_transaction_logs_aggregate: Vehicle_Inventory_Transaction_Logs_Aggregate;
  /** An array relationship */
  vehicle_tank_type_product_variations: Array<Vehicle_Tank_Type_Product_Variation>;
  /** An aggregate relationship */
  vehicle_tank_type_product_variations_aggregate: Vehicle_Tank_Type_Product_Variation_Aggregate;
};


/** columns and relationships of "vehicle_tank_type" */
export type Vehicle_Tank_TypeVehicle_Inventory_Transaction_LogsArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Inventory_Transaction_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Inventory_Transaction_Logs_Order_By>>;
  where?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Bool_Exp>;
};


/** columns and relationships of "vehicle_tank_type" */
export type Vehicle_Tank_TypeVehicle_Inventory_Transaction_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Inventory_Transaction_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Inventory_Transaction_Logs_Order_By>>;
  where?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Bool_Exp>;
};


/** columns and relationships of "vehicle_tank_type" */
export type Vehicle_Tank_TypeVehicle_Tank_Type_Product_VariationsArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Tank_Type_Product_Variation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Tank_Type_Product_Variation_Order_By>>;
  where?: InputMaybe<Vehicle_Tank_Type_Product_Variation_Bool_Exp>;
};


/** columns and relationships of "vehicle_tank_type" */
export type Vehicle_Tank_TypeVehicle_Tank_Type_Product_Variations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Tank_Type_Product_Variation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Tank_Type_Product_Variation_Order_By>>;
  where?: InputMaybe<Vehicle_Tank_Type_Product_Variation_Bool_Exp>;
};

/** aggregated selection of "vehicle_tank_type" */
export type Vehicle_Tank_Type_Aggregate = {
  __typename?: 'vehicle_tank_type_aggregate';
  aggregate?: Maybe<Vehicle_Tank_Type_Aggregate_Fields>;
  nodes: Array<Vehicle_Tank_Type>;
};

export type Vehicle_Tank_Type_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Vehicle_Tank_Type_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Vehicle_Tank_Type_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Vehicle_Tank_Type_Aggregate_Bool_Exp_Count>;
};

export type Vehicle_Tank_Type_Aggregate_Bool_Exp_Bool_And = {
  arguments: Vehicle_Tank_Type_Select_Column_Vehicle_Tank_Type_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vehicle_Tank_Type_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Vehicle_Tank_Type_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Vehicle_Tank_Type_Select_Column_Vehicle_Tank_Type_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vehicle_Tank_Type_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Vehicle_Tank_Type_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Vehicle_Tank_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vehicle_Tank_Type_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "vehicle_tank_type" */
export type Vehicle_Tank_Type_Aggregate_Fields = {
  __typename?: 'vehicle_tank_type_aggregate_fields';
  avg?: Maybe<Vehicle_Tank_Type_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Vehicle_Tank_Type_Max_Fields>;
  min?: Maybe<Vehicle_Tank_Type_Min_Fields>;
  stddev?: Maybe<Vehicle_Tank_Type_Stddev_Fields>;
  stddev_pop?: Maybe<Vehicle_Tank_Type_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vehicle_Tank_Type_Stddev_Samp_Fields>;
  sum?: Maybe<Vehicle_Tank_Type_Sum_Fields>;
  var_pop?: Maybe<Vehicle_Tank_Type_Var_Pop_Fields>;
  var_samp?: Maybe<Vehicle_Tank_Type_Var_Samp_Fields>;
  variance?: Maybe<Vehicle_Tank_Type_Variance_Fields>;
};


/** aggregate fields of "vehicle_tank_type" */
export type Vehicle_Tank_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vehicle_Tank_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "vehicle_tank_type" */
export type Vehicle_Tank_Type_Aggregate_Order_By = {
  avg?: InputMaybe<Vehicle_Tank_Type_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vehicle_Tank_Type_Max_Order_By>;
  min?: InputMaybe<Vehicle_Tank_Type_Min_Order_By>;
  stddev?: InputMaybe<Vehicle_Tank_Type_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Vehicle_Tank_Type_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Vehicle_Tank_Type_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Vehicle_Tank_Type_Sum_Order_By>;
  var_pop?: InputMaybe<Vehicle_Tank_Type_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Vehicle_Tank_Type_Var_Samp_Order_By>;
  variance?: InputMaybe<Vehicle_Tank_Type_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "vehicle_tank_type" */
export type Vehicle_Tank_Type_Arr_Rel_Insert_Input = {
  data: Array<Vehicle_Tank_Type_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Vehicle_Tank_Type_On_Conflict>;
};

/** aggregate avg on columns */
export type Vehicle_Tank_Type_Avg_Fields = {
  __typename?: 'vehicle_tank_type_avg_fields';
  tank_capacity?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "vehicle_tank_type" */
export type Vehicle_Tank_Type_Avg_Order_By = {
  tank_capacity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vehicle_tank_type". All fields are combined with a logical 'AND'. */
export type Vehicle_Tank_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Vehicle_Tank_Type_Bool_Exp>>;
  _not?: InputMaybe<Vehicle_Tank_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Vehicle_Tank_Type_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  dispenser_product_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  tank_capacity?: InputMaybe<Numeric_Comparison_Exp>;
  tank_type?: InputMaybe<Tank_Type_Bool_Exp>;
  tank_type_id?: InputMaybe<Uuid_Comparison_Exp>;
  vehicle?: InputMaybe<Vehicle_Bool_Exp>;
  vehicle_id?: InputMaybe<Uuid_Comparison_Exp>;
  vehicle_inventory_transaction_logs?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Bool_Exp>;
  vehicle_inventory_transaction_logs_aggregate?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Aggregate_Bool_Exp>;
  vehicle_tank_type_product_variations?: InputMaybe<Vehicle_Tank_Type_Product_Variation_Bool_Exp>;
  vehicle_tank_type_product_variations_aggregate?: InputMaybe<Vehicle_Tank_Type_Product_Variation_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "vehicle_tank_type" */
export enum Vehicle_Tank_Type_Constraint {
  /** unique or primary key constraint on columns "id" */
  VehicleTankTypePkey = 'vehicle_tank_type_pkey'
}

/** input type for incrementing numeric columns in table "vehicle_tank_type" */
export type Vehicle_Tank_Type_Inc_Input = {
  tank_capacity?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "vehicle_tank_type" */
export type Vehicle_Tank_Type_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  dispenser_product_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  tank_capacity?: InputMaybe<Scalars['numeric']['input']>;
  tank_type?: InputMaybe<Tank_Type_Obj_Rel_Insert_Input>;
  tank_type_id?: InputMaybe<Scalars['uuid']['input']>;
  vehicle?: InputMaybe<Vehicle_Obj_Rel_Insert_Input>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  vehicle_inventory_transaction_logs?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Arr_Rel_Insert_Input>;
  vehicle_tank_type_product_variations?: InputMaybe<Vehicle_Tank_Type_Product_Variation_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Vehicle_Tank_Type_Max_Fields = {
  __typename?: 'vehicle_tank_type_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  dispenser_product_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  tank_capacity?: Maybe<Scalars['numeric']['output']>;
  tank_type_id?: Maybe<Scalars['uuid']['output']>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "vehicle_tank_type" */
export type Vehicle_Tank_Type_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  dispenser_product_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  tank_capacity?: InputMaybe<Order_By>;
  tank_type_id?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Vehicle_Tank_Type_Min_Fields = {
  __typename?: 'vehicle_tank_type_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  dispenser_product_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  tank_capacity?: Maybe<Scalars['numeric']['output']>;
  tank_type_id?: Maybe<Scalars['uuid']['output']>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "vehicle_tank_type" */
export type Vehicle_Tank_Type_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  dispenser_product_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  tank_capacity?: InputMaybe<Order_By>;
  tank_type_id?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "vehicle_tank_type" */
export type Vehicle_Tank_Type_Mutation_Response = {
  __typename?: 'vehicle_tank_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Vehicle_Tank_Type>;
};

/** input type for inserting object relation for remote table "vehicle_tank_type" */
export type Vehicle_Tank_Type_Obj_Rel_Insert_Input = {
  data: Vehicle_Tank_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Vehicle_Tank_Type_On_Conflict>;
};

/** on_conflict condition type for table "vehicle_tank_type" */
export type Vehicle_Tank_Type_On_Conflict = {
  constraint: Vehicle_Tank_Type_Constraint;
  update_columns?: Array<Vehicle_Tank_Type_Update_Column>;
  where?: InputMaybe<Vehicle_Tank_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "vehicle_tank_type". */
export type Vehicle_Tank_Type_Order_By = {
  created_at?: InputMaybe<Order_By>;
  dispenser_product_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  tank_capacity?: InputMaybe<Order_By>;
  tank_type?: InputMaybe<Tank_Type_Order_By>;
  tank_type_id?: InputMaybe<Order_By>;
  vehicle?: InputMaybe<Vehicle_Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
  vehicle_inventory_transaction_logs_aggregate?: InputMaybe<Vehicle_Inventory_Transaction_Logs_Aggregate_Order_By>;
  vehicle_tank_type_product_variations_aggregate?: InputMaybe<Vehicle_Tank_Type_Product_Variation_Aggregate_Order_By>;
};

/** primary key columns input for table: vehicle_tank_type */
export type Vehicle_Tank_Type_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "vehicle_tank_type_product_variation" */
export type Vehicle_Tank_Type_Product_Variation = {
  __typename?: 'vehicle_tank_type_product_variation';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  fillup_requests: Array<Fillup_Request>;
  /** An aggregate relationship */
  fillup_requests_aggregate: Fillup_Request_Aggregate;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  product_variation: Product_Variation;
  product_variation_id: Scalars['uuid']['output'];
  /** An object relationship */
  vehicle_tank_type: Vehicle_Tank_Type;
  vehicle_tank_type_id: Scalars['uuid']['output'];
};


/** columns and relationships of "vehicle_tank_type_product_variation" */
export type Vehicle_Tank_Type_Product_VariationFillup_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Fillup_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fillup_Request_Order_By>>;
  where?: InputMaybe<Fillup_Request_Bool_Exp>;
};


/** columns and relationships of "vehicle_tank_type_product_variation" */
export type Vehicle_Tank_Type_Product_VariationFillup_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fillup_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fillup_Request_Order_By>>;
  where?: InputMaybe<Fillup_Request_Bool_Exp>;
};

/** aggregated selection of "vehicle_tank_type_product_variation" */
export type Vehicle_Tank_Type_Product_Variation_Aggregate = {
  __typename?: 'vehicle_tank_type_product_variation_aggregate';
  aggregate?: Maybe<Vehicle_Tank_Type_Product_Variation_Aggregate_Fields>;
  nodes: Array<Vehicle_Tank_Type_Product_Variation>;
};

export type Vehicle_Tank_Type_Product_Variation_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Vehicle_Tank_Type_Product_Variation_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Vehicle_Tank_Type_Product_Variation_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Vehicle_Tank_Type_Product_Variation_Aggregate_Bool_Exp_Count>;
};

export type Vehicle_Tank_Type_Product_Variation_Aggregate_Bool_Exp_Bool_And = {
  arguments: Vehicle_Tank_Type_Product_Variation_Select_Column_Vehicle_Tank_Type_Product_Variation_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vehicle_Tank_Type_Product_Variation_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Vehicle_Tank_Type_Product_Variation_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Vehicle_Tank_Type_Product_Variation_Select_Column_Vehicle_Tank_Type_Product_Variation_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vehicle_Tank_Type_Product_Variation_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Vehicle_Tank_Type_Product_Variation_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Vehicle_Tank_Type_Product_Variation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vehicle_Tank_Type_Product_Variation_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "vehicle_tank_type_product_variation" */
export type Vehicle_Tank_Type_Product_Variation_Aggregate_Fields = {
  __typename?: 'vehicle_tank_type_product_variation_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Vehicle_Tank_Type_Product_Variation_Max_Fields>;
  min?: Maybe<Vehicle_Tank_Type_Product_Variation_Min_Fields>;
};


/** aggregate fields of "vehicle_tank_type_product_variation" */
export type Vehicle_Tank_Type_Product_Variation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vehicle_Tank_Type_Product_Variation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "vehicle_tank_type_product_variation" */
export type Vehicle_Tank_Type_Product_Variation_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vehicle_Tank_Type_Product_Variation_Max_Order_By>;
  min?: InputMaybe<Vehicle_Tank_Type_Product_Variation_Min_Order_By>;
};

/** input type for inserting array relation for remote table "vehicle_tank_type_product_variation" */
export type Vehicle_Tank_Type_Product_Variation_Arr_Rel_Insert_Input = {
  data: Array<Vehicle_Tank_Type_Product_Variation_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Vehicle_Tank_Type_Product_Variation_On_Conflict>;
};

/** Boolean expression to filter rows from the table "vehicle_tank_type_product_variation". All fields are combined with a logical 'AND'. */
export type Vehicle_Tank_Type_Product_Variation_Bool_Exp = {
  _and?: InputMaybe<Array<Vehicle_Tank_Type_Product_Variation_Bool_Exp>>;
  _not?: InputMaybe<Vehicle_Tank_Type_Product_Variation_Bool_Exp>;
  _or?: InputMaybe<Array<Vehicle_Tank_Type_Product_Variation_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  fillup_requests?: InputMaybe<Fillup_Request_Bool_Exp>;
  fillup_requests_aggregate?: InputMaybe<Fillup_Request_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  product_variation?: InputMaybe<Product_Variation_Bool_Exp>;
  product_variation_id?: InputMaybe<Uuid_Comparison_Exp>;
  vehicle_tank_type?: InputMaybe<Vehicle_Tank_Type_Bool_Exp>;
  vehicle_tank_type_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "vehicle_tank_type_product_variation" */
export enum Vehicle_Tank_Type_Product_Variation_Constraint {
  /** unique or primary key constraint on columns "id" */
  VehicleTankTypeProductVariationPkey = 'vehicle_tank_type_product_variation_pkey'
}

/** input type for inserting data into table "vehicle_tank_type_product_variation" */
export type Vehicle_Tank_Type_Product_Variation_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  fillup_requests?: InputMaybe<Fillup_Request_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  product_variation?: InputMaybe<Product_Variation_Obj_Rel_Insert_Input>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  vehicle_tank_type?: InputMaybe<Vehicle_Tank_Type_Obj_Rel_Insert_Input>;
  vehicle_tank_type_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Vehicle_Tank_Type_Product_Variation_Max_Fields = {
  __typename?: 'vehicle_tank_type_product_variation_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
  vehicle_tank_type_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "vehicle_tank_type_product_variation" */
export type Vehicle_Tank_Type_Product_Variation_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  vehicle_tank_type_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Vehicle_Tank_Type_Product_Variation_Min_Fields = {
  __typename?: 'vehicle_tank_type_product_variation_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
  vehicle_tank_type_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "vehicle_tank_type_product_variation" */
export type Vehicle_Tank_Type_Product_Variation_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  vehicle_tank_type_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "vehicle_tank_type_product_variation" */
export type Vehicle_Tank_Type_Product_Variation_Mutation_Response = {
  __typename?: 'vehicle_tank_type_product_variation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Vehicle_Tank_Type_Product_Variation>;
};

/** input type for inserting object relation for remote table "vehicle_tank_type_product_variation" */
export type Vehicle_Tank_Type_Product_Variation_Obj_Rel_Insert_Input = {
  data: Vehicle_Tank_Type_Product_Variation_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Vehicle_Tank_Type_Product_Variation_On_Conflict>;
};

/** on_conflict condition type for table "vehicle_tank_type_product_variation" */
export type Vehicle_Tank_Type_Product_Variation_On_Conflict = {
  constraint: Vehicle_Tank_Type_Product_Variation_Constraint;
  update_columns?: Array<Vehicle_Tank_Type_Product_Variation_Update_Column>;
  where?: InputMaybe<Vehicle_Tank_Type_Product_Variation_Bool_Exp>;
};

/** Ordering options when selecting data from "vehicle_tank_type_product_variation". */
export type Vehicle_Tank_Type_Product_Variation_Order_By = {
  created_at?: InputMaybe<Order_By>;
  fillup_requests_aggregate?: InputMaybe<Fillup_Request_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  product_variation?: InputMaybe<Product_Variation_Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  vehicle_tank_type?: InputMaybe<Vehicle_Tank_Type_Order_By>;
  vehicle_tank_type_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vehicle_tank_type_product_variation */
export type Vehicle_Tank_Type_Product_Variation_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "vehicle_tank_type_product_variation" */
export enum Vehicle_Tank_Type_Product_Variation_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  ProductVariationId = 'product_variation_id',
  /** column name */
  VehicleTankTypeId = 'vehicle_tank_type_id'
}

/** select "vehicle_tank_type_product_variation_aggregate_bool_exp_bool_and_arguments_columns" columns of table "vehicle_tank_type_product_variation" */
export enum Vehicle_Tank_Type_Product_Variation_Select_Column_Vehicle_Tank_Type_Product_Variation_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "vehicle_tank_type_product_variation_aggregate_bool_exp_bool_or_arguments_columns" columns of table "vehicle_tank_type_product_variation" */
export enum Vehicle_Tank_Type_Product_Variation_Select_Column_Vehicle_Tank_Type_Product_Variation_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "vehicle_tank_type_product_variation" */
export type Vehicle_Tank_Type_Product_Variation_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  vehicle_tank_type_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "vehicle_tank_type_product_variation" */
export type Vehicle_Tank_Type_Product_Variation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vehicle_Tank_Type_Product_Variation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vehicle_Tank_Type_Product_Variation_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  vehicle_tank_type_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "vehicle_tank_type_product_variation" */
export enum Vehicle_Tank_Type_Product_Variation_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  ProductVariationId = 'product_variation_id',
  /** column name */
  VehicleTankTypeId = 'vehicle_tank_type_id'
}

export type Vehicle_Tank_Type_Product_Variation_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Vehicle_Tank_Type_Product_Variation_Set_Input>;
  /** filter the rows which have to be updated */
  where: Vehicle_Tank_Type_Product_Variation_Bool_Exp;
};

/** select columns of table "vehicle_tank_type" */
export enum Vehicle_Tank_Type_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DispenserProductId = 'dispenser_product_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  TankCapacity = 'tank_capacity',
  /** column name */
  TankTypeId = 'tank_type_id',
  /** column name */
  VehicleId = 'vehicle_id'
}

/** select "vehicle_tank_type_aggregate_bool_exp_bool_and_arguments_columns" columns of table "vehicle_tank_type" */
export enum Vehicle_Tank_Type_Select_Column_Vehicle_Tank_Type_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "vehicle_tank_type_aggregate_bool_exp_bool_or_arguments_columns" columns of table "vehicle_tank_type" */
export enum Vehicle_Tank_Type_Select_Column_Vehicle_Tank_Type_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "vehicle_tank_type" */
export type Vehicle_Tank_Type_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  dispenser_product_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  tank_capacity?: InputMaybe<Scalars['numeric']['input']>;
  tank_type_id?: InputMaybe<Scalars['uuid']['input']>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Vehicle_Tank_Type_Stddev_Fields = {
  __typename?: 'vehicle_tank_type_stddev_fields';
  tank_capacity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "vehicle_tank_type" */
export type Vehicle_Tank_Type_Stddev_Order_By = {
  tank_capacity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Vehicle_Tank_Type_Stddev_Pop_Fields = {
  __typename?: 'vehicle_tank_type_stddev_pop_fields';
  tank_capacity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "vehicle_tank_type" */
export type Vehicle_Tank_Type_Stddev_Pop_Order_By = {
  tank_capacity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Vehicle_Tank_Type_Stddev_Samp_Fields = {
  __typename?: 'vehicle_tank_type_stddev_samp_fields';
  tank_capacity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "vehicle_tank_type" */
export type Vehicle_Tank_Type_Stddev_Samp_Order_By = {
  tank_capacity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "vehicle_tank_type" */
export type Vehicle_Tank_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vehicle_Tank_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vehicle_Tank_Type_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  dispenser_product_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  tank_capacity?: InputMaybe<Scalars['numeric']['input']>;
  tank_type_id?: InputMaybe<Scalars['uuid']['input']>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Vehicle_Tank_Type_Sum_Fields = {
  __typename?: 'vehicle_tank_type_sum_fields';
  tank_capacity?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "vehicle_tank_type" */
export type Vehicle_Tank_Type_Sum_Order_By = {
  tank_capacity?: InputMaybe<Order_By>;
};

/** update columns of table "vehicle_tank_type" */
export enum Vehicle_Tank_Type_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DispenserProductId = 'dispenser_product_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  TankCapacity = 'tank_capacity',
  /** column name */
  TankTypeId = 'tank_type_id',
  /** column name */
  VehicleId = 'vehicle_id'
}

export type Vehicle_Tank_Type_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Vehicle_Tank_Type_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Vehicle_Tank_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Vehicle_Tank_Type_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Vehicle_Tank_Type_Var_Pop_Fields = {
  __typename?: 'vehicle_tank_type_var_pop_fields';
  tank_capacity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "vehicle_tank_type" */
export type Vehicle_Tank_Type_Var_Pop_Order_By = {
  tank_capacity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Vehicle_Tank_Type_Var_Samp_Fields = {
  __typename?: 'vehicle_tank_type_var_samp_fields';
  tank_capacity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "vehicle_tank_type" */
export type Vehicle_Tank_Type_Var_Samp_Order_By = {
  tank_capacity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Vehicle_Tank_Type_Variance_Fields = {
  __typename?: 'vehicle_tank_type_variance_fields';
  tank_capacity?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "vehicle_tank_type" */
export type Vehicle_Tank_Type_Variance_Order_By = {
  tank_capacity?: InputMaybe<Order_By>;
};

/** columns and relationships of "vehicle_type" */
export type Vehicle_Type = {
  __typename?: 'vehicle_type';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
  /** An array relationship */
  vehicles: Array<Vehicle>;
  /** An aggregate relationship */
  vehicles_aggregate: Vehicle_Aggregate;
};


/** columns and relationships of "vehicle_type" */
export type Vehicle_TypeVehiclesArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Order_By>>;
  where?: InputMaybe<Vehicle_Bool_Exp>;
};


/** columns and relationships of "vehicle_type" */
export type Vehicle_TypeVehicles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vehicle_Order_By>>;
  where?: InputMaybe<Vehicle_Bool_Exp>;
};

/** aggregated selection of "vehicle_type" */
export type Vehicle_Type_Aggregate = {
  __typename?: 'vehicle_type_aggregate';
  aggregate?: Maybe<Vehicle_Type_Aggregate_Fields>;
  nodes: Array<Vehicle_Type>;
};

/** aggregate fields of "vehicle_type" */
export type Vehicle_Type_Aggregate_Fields = {
  __typename?: 'vehicle_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Vehicle_Type_Max_Fields>;
  min?: Maybe<Vehicle_Type_Min_Fields>;
};


/** aggregate fields of "vehicle_type" */
export type Vehicle_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vehicle_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "vehicle_type". All fields are combined with a logical 'AND'. */
export type Vehicle_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Vehicle_Type_Bool_Exp>>;
  _not?: InputMaybe<Vehicle_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Vehicle_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
  vehicles?: InputMaybe<Vehicle_Bool_Exp>;
  vehicles_aggregate?: InputMaybe<Vehicle_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "vehicle_type" */
export enum Vehicle_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  VehicleTypePkey = 'vehicle_type_pkey'
}

export enum Vehicle_Type_Enum {
  /** BOWSER */
  Bowser = 'BOWSER',
  /** CONTAINER */
  Container = 'CONTAINER',
  /** Third Party Tankers */
  TptTank = 'TPT_TANK'
}

/** Boolean expression to compare columns of type "vehicle_type_enum". All fields are combined with logical 'AND'. */
export type Vehicle_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Vehicle_Type_Enum>;
  _in?: InputMaybe<Array<Vehicle_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Vehicle_Type_Enum>;
  _nin?: InputMaybe<Array<Vehicle_Type_Enum>>;
};

/** input type for inserting data into table "vehicle_type" */
export type Vehicle_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  vehicles?: InputMaybe<Vehicle_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Vehicle_Type_Max_Fields = {
  __typename?: 'vehicle_type_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Vehicle_Type_Min_Fields = {
  __typename?: 'vehicle_type_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "vehicle_type" */
export type Vehicle_Type_Mutation_Response = {
  __typename?: 'vehicle_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Vehicle_Type>;
};

/** input type for inserting object relation for remote table "vehicle_type" */
export type Vehicle_Type_Obj_Rel_Insert_Input = {
  data: Vehicle_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Vehicle_Type_On_Conflict>;
};

/** on_conflict condition type for table "vehicle_type" */
export type Vehicle_Type_On_Conflict = {
  constraint: Vehicle_Type_Constraint;
  update_columns?: Array<Vehicle_Type_Update_Column>;
  where?: InputMaybe<Vehicle_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "vehicle_type". */
export type Vehicle_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  vehicles_aggregate?: InputMaybe<Vehicle_Aggregate_Order_By>;
};

/** primary key columns input for table: vehicle_type */
export type Vehicle_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "vehicle_type" */
export enum Vehicle_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "vehicle_type" */
export type Vehicle_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "vehicle_type" */
export type Vehicle_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vehicle_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vehicle_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "vehicle_type" */
export enum Vehicle_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Vehicle_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Vehicle_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Vehicle_Type_Bool_Exp;
};

/** update columns of table "vehicle" */
export enum Vehicle_Update_Column {
  /** column name */
  Category = 'category',
  /** column name */
  ChassisNumber = 'chassis_number',
  /** column name */
  Color = 'color',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  DeviceId = 'device_id',
  /** column name */
  ErpCode = 'erp_code',
  /** column name */
  FuelTankCapacity = 'fuel_tank_capacity',
  /** column name */
  FueltransEnabled = 'fueltrans_enabled',
  /** column name */
  Id = 'id',
  /** column name */
  InsuranceExpireDate = 'insurance_expire_date',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsMothership = 'is_mothership',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Location = 'location',
  /** column name */
  Make = 'make',
  /** column name */
  Model = 'model',
  /** column name */
  Name = 'name',
  /** column name */
  PartnerAddressId = 'partner_address_id',
  /** column name */
  PlateCode = 'plate_code',
  /** column name */
  PlateNumber = 'plate_number',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  RatedCapacity = 'rated_capacity',
  /** column name */
  RcExpireDate = 'rc_expire_date',
  /** column name */
  RegistrationNumber = 'registration_number',
  /** column name */
  Rfid = 'rfid',
  /** column name */
  StateId = 'state_id',
  /** column name */
  Status = 'status',
  /** column name */
  TankerCapacity = 'tanker_capacity',
  /** column name */
  TankerCompartmentNumber = 'tanker_compartment_number',
  /** column name */
  VehicleType = 'vehicle_type',
  /** column name */
  Year = 'year'
}

export type Vehicle_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Vehicle_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Vehicle_Set_Input>;
  /** filter the rows which have to be updated */
  where: Vehicle_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Vehicle_Var_Pop_Fields = {
  __typename?: 'vehicle_var_pop_fields';
  fuel_tank_capacity?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  rated_capacity?: Maybe<Scalars['Float']['output']>;
  tanker_capacity?: Maybe<Scalars['Float']['output']>;
  tanker_compartment_number?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "vehicle" */
export type Vehicle_Var_Pop_Order_By = {
  fuel_tank_capacity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rated_capacity?: InputMaybe<Order_By>;
  tanker_capacity?: InputMaybe<Order_By>;
  tanker_compartment_number?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Vehicle_Var_Samp_Fields = {
  __typename?: 'vehicle_var_samp_fields';
  fuel_tank_capacity?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  rated_capacity?: Maybe<Scalars['Float']['output']>;
  tanker_capacity?: Maybe<Scalars['Float']['output']>;
  tanker_compartment_number?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "vehicle" */
export type Vehicle_Var_Samp_Order_By = {
  fuel_tank_capacity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rated_capacity?: InputMaybe<Order_By>;
  tanker_capacity?: InputMaybe<Order_By>;
  tanker_compartment_number?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Vehicle_Variance_Fields = {
  __typename?: 'vehicle_variance_fields';
  fuel_tank_capacity?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  rated_capacity?: Maybe<Scalars['Float']['output']>;
  tanker_capacity?: Maybe<Scalars['Float']['output']>;
  tanker_compartment_number?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "vehicle" */
export type Vehicle_Variance_Order_By = {
  fuel_tank_capacity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rated_capacity?: InputMaybe<Order_By>;
  tanker_capacity?: InputMaybe<Order_By>;
  tanker_compartment_number?: InputMaybe<Order_By>;
};

/** columns and relationships of "vendor_order_logs" */
export type Vendor_Order_Logs = {
  __typename?: 'vendor_order_logs';
  address_id: Scalars['uuid']['output'];
  asset_logs: Scalars['json']['output'];
  batch_id: Scalars['uuid']['output'];
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_code: Scalars['uuid']['output'];
  /** An object relationship */
  driver?: Maybe<User>;
  driver_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  driver_vehicle?: Maybe<Driver_Vehicle>;
  driver_vehicle_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  order_date: Scalars['timestamp']['output'];
  /** An object relationship */
  organization_address: Organization_Address;
  /** An object relationship */
  partner: Partner;
  partner_id: Scalars['uuid']['output'];
  partner_localities_id: Scalars['uuid']['output'];
  /** An object relationship */
  partner_locality: Partner_Localities;
  /** An object relationship */
  product_variation: Product_Variation;
  product_variation_id: Scalars['uuid']['output'];
  /** An object relationship */
  user: User;
  /** An object relationship */
  userByLastModifiedBy?: Maybe<User>;
  /** An object relationship */
  vehicle?: Maybe<Vehicle>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "vendor_order_logs" */
export type Vendor_Order_LogsAsset_LogsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "vendor_order_logs" */
export type Vendor_Order_Logs_Aggregate = {
  __typename?: 'vendor_order_logs_aggregate';
  aggregate?: Maybe<Vendor_Order_Logs_Aggregate_Fields>;
  nodes: Array<Vendor_Order_Logs>;
};

export type Vendor_Order_Logs_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Vendor_Order_Logs_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Vendor_Order_Logs_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Vendor_Order_Logs_Aggregate_Bool_Exp_Count>;
};

export type Vendor_Order_Logs_Aggregate_Bool_Exp_Bool_And = {
  arguments: Vendor_Order_Logs_Select_Column_Vendor_Order_Logs_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vendor_Order_Logs_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Vendor_Order_Logs_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Vendor_Order_Logs_Select_Column_Vendor_Order_Logs_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vendor_Order_Logs_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Vendor_Order_Logs_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Vendor_Order_Logs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vendor_Order_Logs_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "vendor_order_logs" */
export type Vendor_Order_Logs_Aggregate_Fields = {
  __typename?: 'vendor_order_logs_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Vendor_Order_Logs_Max_Fields>;
  min?: Maybe<Vendor_Order_Logs_Min_Fields>;
};


/** aggregate fields of "vendor_order_logs" */
export type Vendor_Order_Logs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vendor_Order_Logs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "vendor_order_logs" */
export type Vendor_Order_Logs_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vendor_Order_Logs_Max_Order_By>;
  min?: InputMaybe<Vendor_Order_Logs_Min_Order_By>;
};

/** input type for inserting array relation for remote table "vendor_order_logs" */
export type Vendor_Order_Logs_Arr_Rel_Insert_Input = {
  data: Array<Vendor_Order_Logs_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Vendor_Order_Logs_On_Conflict>;
};

/** Boolean expression to filter rows from the table "vendor_order_logs". All fields are combined with a logical 'AND'. */
export type Vendor_Order_Logs_Bool_Exp = {
  _and?: InputMaybe<Array<Vendor_Order_Logs_Bool_Exp>>;
  _not?: InputMaybe<Vendor_Order_Logs_Bool_Exp>;
  _or?: InputMaybe<Array<Vendor_Order_Logs_Bool_Exp>>;
  address_id?: InputMaybe<Uuid_Comparison_Exp>;
  asset_logs?: InputMaybe<Json_Comparison_Exp>;
  batch_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_code?: InputMaybe<Uuid_Comparison_Exp>;
  driver?: InputMaybe<User_Bool_Exp>;
  driver_id?: InputMaybe<Uuid_Comparison_Exp>;
  driver_vehicle?: InputMaybe<Driver_Vehicle_Bool_Exp>;
  driver_vehicle_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  order_date?: InputMaybe<Timestamp_Comparison_Exp>;
  organization_address?: InputMaybe<Organization_Address_Bool_Exp>;
  partner?: InputMaybe<Partner_Bool_Exp>;
  partner_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner_localities_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner_locality?: InputMaybe<Partner_Localities_Bool_Exp>;
  product_variation?: InputMaybe<Product_Variation_Bool_Exp>;
  product_variation_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userByLastModifiedBy?: InputMaybe<User_Bool_Exp>;
  vehicle?: InputMaybe<Vehicle_Bool_Exp>;
  vehicle_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "vendor_order_logs" */
export enum Vendor_Order_Logs_Constraint {
  /** unique or primary key constraint on columns "address_id", "order_date", "batch_id", "customer_code" */
  VendorOrderLogsBatchDedupKey = 'vendor_order_logs_batch_dedup_key',
  /** unique or primary key constraint on columns "id" */
  VendorOrderLogsPkey = 'vendor_order_logs_pkey'
}

/** input type for inserting data into table "vendor_order_logs" */
export type Vendor_Order_Logs_Insert_Input = {
  address_id?: InputMaybe<Scalars['uuid']['input']>;
  asset_logs?: InputMaybe<Scalars['json']['input']>;
  batch_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_code?: InputMaybe<Scalars['uuid']['input']>;
  driver?: InputMaybe<User_Obj_Rel_Insert_Input>;
  driver_id?: InputMaybe<Scalars['uuid']['input']>;
  driver_vehicle?: InputMaybe<Driver_Vehicle_Obj_Rel_Insert_Input>;
  driver_vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  order_date?: InputMaybe<Scalars['timestamp']['input']>;
  organization_address?: InputMaybe<Organization_Address_Obj_Rel_Insert_Input>;
  partner?: InputMaybe<Partner_Obj_Rel_Insert_Input>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_localities_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_locality?: InputMaybe<Partner_Localities_Obj_Rel_Insert_Input>;
  product_variation?: InputMaybe<Product_Variation_Obj_Rel_Insert_Input>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userByLastModifiedBy?: InputMaybe<User_Obj_Rel_Insert_Input>;
  vehicle?: InputMaybe<Vehicle_Obj_Rel_Insert_Input>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Vendor_Order_Logs_Max_Fields = {
  __typename?: 'vendor_order_logs_max_fields';
  address_id?: Maybe<Scalars['uuid']['output']>;
  batch_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_code?: Maybe<Scalars['uuid']['output']>;
  driver_id?: Maybe<Scalars['uuid']['output']>;
  driver_vehicle_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  order_date?: Maybe<Scalars['timestamp']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  partner_localities_id?: Maybe<Scalars['uuid']['output']>;
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "vendor_order_logs" */
export type Vendor_Order_Logs_Max_Order_By = {
  address_id?: InputMaybe<Order_By>;
  batch_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_code?: InputMaybe<Order_By>;
  driver_id?: InputMaybe<Order_By>;
  driver_vehicle_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  order_date?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  partner_localities_id?: InputMaybe<Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Vendor_Order_Logs_Min_Fields = {
  __typename?: 'vendor_order_logs_min_fields';
  address_id?: Maybe<Scalars['uuid']['output']>;
  batch_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  customer_code?: Maybe<Scalars['uuid']['output']>;
  driver_id?: Maybe<Scalars['uuid']['output']>;
  driver_vehicle_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  order_date?: Maybe<Scalars['timestamp']['output']>;
  partner_id?: Maybe<Scalars['uuid']['output']>;
  partner_localities_id?: Maybe<Scalars['uuid']['output']>;
  product_variation_id?: Maybe<Scalars['uuid']['output']>;
  vehicle_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "vendor_order_logs" */
export type Vendor_Order_Logs_Min_Order_By = {
  address_id?: InputMaybe<Order_By>;
  batch_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_code?: InputMaybe<Order_By>;
  driver_id?: InputMaybe<Order_By>;
  driver_vehicle_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  order_date?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  partner_localities_id?: InputMaybe<Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "vendor_order_logs" */
export type Vendor_Order_Logs_Mutation_Response = {
  __typename?: 'vendor_order_logs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Vendor_Order_Logs>;
};

/** on_conflict condition type for table "vendor_order_logs" */
export type Vendor_Order_Logs_On_Conflict = {
  constraint: Vendor_Order_Logs_Constraint;
  update_columns?: Array<Vendor_Order_Logs_Update_Column>;
  where?: InputMaybe<Vendor_Order_Logs_Bool_Exp>;
};

/** Ordering options when selecting data from "vendor_order_logs". */
export type Vendor_Order_Logs_Order_By = {
  address_id?: InputMaybe<Order_By>;
  asset_logs?: InputMaybe<Order_By>;
  batch_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_code?: InputMaybe<Order_By>;
  driver?: InputMaybe<User_Order_By>;
  driver_id?: InputMaybe<Order_By>;
  driver_vehicle?: InputMaybe<Driver_Vehicle_Order_By>;
  driver_vehicle_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  order_date?: InputMaybe<Order_By>;
  organization_address?: InputMaybe<Organization_Address_Order_By>;
  partner?: InputMaybe<Partner_Order_By>;
  partner_id?: InputMaybe<Order_By>;
  partner_localities_id?: InputMaybe<Order_By>;
  partner_locality?: InputMaybe<Partner_Localities_Order_By>;
  product_variation?: InputMaybe<Product_Variation_Order_By>;
  product_variation_id?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userByLastModifiedBy?: InputMaybe<User_Order_By>;
  vehicle?: InputMaybe<Vehicle_Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vendor_order_logs */
export type Vendor_Order_Logs_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "vendor_order_logs" */
export enum Vendor_Order_Logs_Select_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  AssetLogs = 'asset_logs',
  /** column name */
  BatchId = 'batch_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerCode = 'customer_code',
  /** column name */
  DriverId = 'driver_id',
  /** column name */
  DriverVehicleId = 'driver_vehicle_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrderDate = 'order_date',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  PartnerLocalitiesId = 'partner_localities_id',
  /** column name */
  ProductVariationId = 'product_variation_id',
  /** column name */
  VehicleId = 'vehicle_id'
}

/** select "vendor_order_logs_aggregate_bool_exp_bool_and_arguments_columns" columns of table "vendor_order_logs" */
export enum Vendor_Order_Logs_Select_Column_Vendor_Order_Logs_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "vendor_order_logs_aggregate_bool_exp_bool_or_arguments_columns" columns of table "vendor_order_logs" */
export enum Vendor_Order_Logs_Select_Column_Vendor_Order_Logs_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "vendor_order_logs" */
export type Vendor_Order_Logs_Set_Input = {
  address_id?: InputMaybe<Scalars['uuid']['input']>;
  asset_logs?: InputMaybe<Scalars['json']['input']>;
  batch_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_code?: InputMaybe<Scalars['uuid']['input']>;
  driver_id?: InputMaybe<Scalars['uuid']['input']>;
  driver_vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  order_date?: InputMaybe<Scalars['timestamp']['input']>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_localities_id?: InputMaybe<Scalars['uuid']['input']>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "vendor_order_logs" */
export type Vendor_Order_Logs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vendor_Order_Logs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vendor_Order_Logs_Stream_Cursor_Value_Input = {
  address_id?: InputMaybe<Scalars['uuid']['input']>;
  asset_logs?: InputMaybe<Scalars['json']['input']>;
  batch_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_code?: InputMaybe<Scalars['uuid']['input']>;
  driver_id?: InputMaybe<Scalars['uuid']['input']>;
  driver_vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  order_date?: InputMaybe<Scalars['timestamp']['input']>;
  partner_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_localities_id?: InputMaybe<Scalars['uuid']['input']>;
  product_variation_id?: InputMaybe<Scalars['uuid']['input']>;
  vehicle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "vendor_order_logs" */
export enum Vendor_Order_Logs_Update_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  AssetLogs = 'asset_logs',
  /** column name */
  BatchId = 'batch_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerCode = 'customer_code',
  /** column name */
  DriverId = 'driver_id',
  /** column name */
  DriverVehicleId = 'driver_vehicle_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrderDate = 'order_date',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  PartnerLocalitiesId = 'partner_localities_id',
  /** column name */
  ProductVariationId = 'product_variation_id',
  /** column name */
  VehicleId = 'vehicle_id'
}

export type Vendor_Order_Logs_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Vendor_Order_Logs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Vendor_Order_Logs_Bool_Exp;
};

/** columns and relationships of "vendor_sync_status" */
export type Vendor_Sync_Status = {
  __typename?: 'vendor_sync_status';
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  invoicedItemsByErpSyncStatus: Array<Invoiced_Item>;
  /** An aggregate relationship */
  invoicedItemsByErpSyncStatus_aggregate: Invoiced_Item_Aggregate;
  /** An array relationship */
  invoiced_items: Array<Invoiced_Item>;
  /** An aggregate relationship */
  invoiced_items_aggregate: Invoiced_Item_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "vendor_sync_status" */
export type Vendor_Sync_StatusInvoicedItemsByErpSyncStatusArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Bool_Exp>;
};


/** columns and relationships of "vendor_sync_status" */
export type Vendor_Sync_StatusInvoicedItemsByErpSyncStatus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Bool_Exp>;
};


/** columns and relationships of "vendor_sync_status" */
export type Vendor_Sync_StatusInvoiced_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Bool_Exp>;
};


/** columns and relationships of "vendor_sync_status" */
export type Vendor_Sync_StatusInvoiced_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoiced_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoiced_Item_Order_By>>;
  where?: InputMaybe<Invoiced_Item_Bool_Exp>;
};

/** aggregated selection of "vendor_sync_status" */
export type Vendor_Sync_Status_Aggregate = {
  __typename?: 'vendor_sync_status_aggregate';
  aggregate?: Maybe<Vendor_Sync_Status_Aggregate_Fields>;
  nodes: Array<Vendor_Sync_Status>;
};

/** aggregate fields of "vendor_sync_status" */
export type Vendor_Sync_Status_Aggregate_Fields = {
  __typename?: 'vendor_sync_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Vendor_Sync_Status_Max_Fields>;
  min?: Maybe<Vendor_Sync_Status_Min_Fields>;
};


/** aggregate fields of "vendor_sync_status" */
export type Vendor_Sync_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vendor_Sync_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "vendor_sync_status". All fields are combined with a logical 'AND'. */
export type Vendor_Sync_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Vendor_Sync_Status_Bool_Exp>>;
  _not?: InputMaybe<Vendor_Sync_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Vendor_Sync_Status_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  invoicedItemsByErpSyncStatus?: InputMaybe<Invoiced_Item_Bool_Exp>;
  invoicedItemsByErpSyncStatus_aggregate?: InputMaybe<Invoiced_Item_Aggregate_Bool_Exp>;
  invoiced_items?: InputMaybe<Invoiced_Item_Bool_Exp>;
  invoiced_items_aggregate?: InputMaybe<Invoiced_Item_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "vendor_sync_status" */
export enum Vendor_Sync_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  VendorSyncStatusPkey = 'vendor_sync_status_pkey'
}

export enum Vendor_Sync_Status_Enum {
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** FAILED */
  Failed = 'FAILED',
  /** INVOICED */
  Invoiced = 'INVOICED',
  /** IN_PROGRESS */
  InProgress = 'IN_PROGRESS',
  /** PENDING */
  Pending = 'PENDING'
}

/** Boolean expression to compare columns of type "vendor_sync_status_enum". All fields are combined with logical 'AND'. */
export type Vendor_Sync_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Vendor_Sync_Status_Enum>;
  _in?: InputMaybe<Array<Vendor_Sync_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Vendor_Sync_Status_Enum>;
  _nin?: InputMaybe<Array<Vendor_Sync_Status_Enum>>;
};

/** input type for inserting data into table "vendor_sync_status" */
export type Vendor_Sync_Status_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  invoicedItemsByErpSyncStatus?: InputMaybe<Invoiced_Item_Arr_Rel_Insert_Input>;
  invoiced_items?: InputMaybe<Invoiced_Item_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Vendor_Sync_Status_Max_Fields = {
  __typename?: 'vendor_sync_status_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Vendor_Sync_Status_Min_Fields = {
  __typename?: 'vendor_sync_status_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "vendor_sync_status" */
export type Vendor_Sync_Status_Mutation_Response = {
  __typename?: 'vendor_sync_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Vendor_Sync_Status>;
};

/** input type for inserting object relation for remote table "vendor_sync_status" */
export type Vendor_Sync_Status_Obj_Rel_Insert_Input = {
  data: Vendor_Sync_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Vendor_Sync_Status_On_Conflict>;
};

/** on_conflict condition type for table "vendor_sync_status" */
export type Vendor_Sync_Status_On_Conflict = {
  constraint: Vendor_Sync_Status_Constraint;
  update_columns?: Array<Vendor_Sync_Status_Update_Column>;
  where?: InputMaybe<Vendor_Sync_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "vendor_sync_status". */
export type Vendor_Sync_Status_Order_By = {
  comment?: InputMaybe<Order_By>;
  invoicedItemsByErpSyncStatus_aggregate?: InputMaybe<Invoiced_Item_Aggregate_Order_By>;
  invoiced_items_aggregate?: InputMaybe<Invoiced_Item_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vendor_sync_status */
export type Vendor_Sync_Status_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "vendor_sync_status" */
export enum Vendor_Sync_Status_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "vendor_sync_status" */
export type Vendor_Sync_Status_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "vendor_sync_status" */
export type Vendor_Sync_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vendor_Sync_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vendor_Sync_Status_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "vendor_sync_status" */
export enum Vendor_Sync_Status_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Vendor_Sync_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Vendor_Sync_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Vendor_Sync_Status_Bool_Exp;
};

export type VerifyEasebuzzPaymentStatusInput = {
  order_id: Scalars['uuid']['input'];
  payment_id: Scalars['uuid']['input'];
};

export type VerifyEasebuzzPaymentStatusOutPut = {
  __typename?: 'verifyEasebuzzPaymentStatusOutPut';
  order_id: Scalars['uuid']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type VerifyPaymentStatusInput = {
  order_id: Scalars['uuid']['input'];
  payment_id: Scalars['uuid']['input'];
};

export type VerifyPaymentStatusOutPut = {
  __typename?: 'verifyPaymentStatusOutPut';
  order_id: Scalars['uuid']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

/** columns and relationships of "view_daily_asset_limit" */
export type View_Daily_Asset_Limit = {
  __typename?: 'view_daily_asset_limit';
  /** An object relationship */
  customer_asset?: Maybe<Customer_Asset>;
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  dispensing_rule?: Maybe<Dispensing_Rules>;
  dispensing_rule_id?: Maybe<Scalars['uuid']['output']>;
  remaining_count?: Maybe<Scalars['numeric']['output']>;
  remaining_qty?: Maybe<Scalars['numeric']['output']>;
  remaining_value?: Maybe<Scalars['numeric']['output']>;
};

/** aggregated selection of "view_daily_asset_limit" */
export type View_Daily_Asset_Limit_Aggregate = {
  __typename?: 'view_daily_asset_limit_aggregate';
  aggregate?: Maybe<View_Daily_Asset_Limit_Aggregate_Fields>;
  nodes: Array<View_Daily_Asset_Limit>;
};

export type View_Daily_Asset_Limit_Aggregate_Bool_Exp = {
  count?: InputMaybe<View_Daily_Asset_Limit_Aggregate_Bool_Exp_Count>;
};

export type View_Daily_Asset_Limit_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<View_Daily_Asset_Limit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<View_Daily_Asset_Limit_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "view_daily_asset_limit" */
export type View_Daily_Asset_Limit_Aggregate_Fields = {
  __typename?: 'view_daily_asset_limit_aggregate_fields';
  avg?: Maybe<View_Daily_Asset_Limit_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<View_Daily_Asset_Limit_Max_Fields>;
  min?: Maybe<View_Daily_Asset_Limit_Min_Fields>;
  stddev?: Maybe<View_Daily_Asset_Limit_Stddev_Fields>;
  stddev_pop?: Maybe<View_Daily_Asset_Limit_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<View_Daily_Asset_Limit_Stddev_Samp_Fields>;
  sum?: Maybe<View_Daily_Asset_Limit_Sum_Fields>;
  var_pop?: Maybe<View_Daily_Asset_Limit_Var_Pop_Fields>;
  var_samp?: Maybe<View_Daily_Asset_Limit_Var_Samp_Fields>;
  variance?: Maybe<View_Daily_Asset_Limit_Variance_Fields>;
};


/** aggregate fields of "view_daily_asset_limit" */
export type View_Daily_Asset_Limit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<View_Daily_Asset_Limit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "view_daily_asset_limit" */
export type View_Daily_Asset_Limit_Aggregate_Order_By = {
  avg?: InputMaybe<View_Daily_Asset_Limit_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<View_Daily_Asset_Limit_Max_Order_By>;
  min?: InputMaybe<View_Daily_Asset_Limit_Min_Order_By>;
  stddev?: InputMaybe<View_Daily_Asset_Limit_Stddev_Order_By>;
  stddev_pop?: InputMaybe<View_Daily_Asset_Limit_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<View_Daily_Asset_Limit_Stddev_Samp_Order_By>;
  sum?: InputMaybe<View_Daily_Asset_Limit_Sum_Order_By>;
  var_pop?: InputMaybe<View_Daily_Asset_Limit_Var_Pop_Order_By>;
  var_samp?: InputMaybe<View_Daily_Asset_Limit_Var_Samp_Order_By>;
  variance?: InputMaybe<View_Daily_Asset_Limit_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "view_daily_asset_limit" */
export type View_Daily_Asset_Limit_Arr_Rel_Insert_Input = {
  data: Array<View_Daily_Asset_Limit_Insert_Input>;
};

/** aggregate avg on columns */
export type View_Daily_Asset_Limit_Avg_Fields = {
  __typename?: 'view_daily_asset_limit_avg_fields';
  remaining_count?: Maybe<Scalars['Float']['output']>;
  remaining_qty?: Maybe<Scalars['Float']['output']>;
  remaining_value?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "view_daily_asset_limit" */
export type View_Daily_Asset_Limit_Avg_Order_By = {
  remaining_count?: InputMaybe<Order_By>;
  remaining_qty?: InputMaybe<Order_By>;
  remaining_value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "view_daily_asset_limit". All fields are combined with a logical 'AND'. */
export type View_Daily_Asset_Limit_Bool_Exp = {
  _and?: InputMaybe<Array<View_Daily_Asset_Limit_Bool_Exp>>;
  _not?: InputMaybe<View_Daily_Asset_Limit_Bool_Exp>;
  _or?: InputMaybe<Array<View_Daily_Asset_Limit_Bool_Exp>>;
  customer_asset?: InputMaybe<Customer_Asset_Bool_Exp>;
  customer_asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  dispensing_rule?: InputMaybe<Dispensing_Rules_Bool_Exp>;
  dispensing_rule_id?: InputMaybe<Uuid_Comparison_Exp>;
  remaining_count?: InputMaybe<Numeric_Comparison_Exp>;
  remaining_qty?: InputMaybe<Numeric_Comparison_Exp>;
  remaining_value?: InputMaybe<Numeric_Comparison_Exp>;
};

/** input type for inserting data into table "view_daily_asset_limit" */
export type View_Daily_Asset_Limit_Insert_Input = {
  customer_asset?: InputMaybe<Customer_Asset_Obj_Rel_Insert_Input>;
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  dispensing_rule?: InputMaybe<Dispensing_Rules_Obj_Rel_Insert_Input>;
  dispensing_rule_id?: InputMaybe<Scalars['uuid']['input']>;
  remaining_count?: InputMaybe<Scalars['numeric']['input']>;
  remaining_qty?: InputMaybe<Scalars['numeric']['input']>;
  remaining_value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type View_Daily_Asset_Limit_Max_Fields = {
  __typename?: 'view_daily_asset_limit_max_fields';
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  dispensing_rule_id?: Maybe<Scalars['uuid']['output']>;
  remaining_count?: Maybe<Scalars['numeric']['output']>;
  remaining_qty?: Maybe<Scalars['numeric']['output']>;
  remaining_value?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "view_daily_asset_limit" */
export type View_Daily_Asset_Limit_Max_Order_By = {
  customer_asset_id?: InputMaybe<Order_By>;
  dispensing_rule_id?: InputMaybe<Order_By>;
  remaining_count?: InputMaybe<Order_By>;
  remaining_qty?: InputMaybe<Order_By>;
  remaining_value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type View_Daily_Asset_Limit_Min_Fields = {
  __typename?: 'view_daily_asset_limit_min_fields';
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  dispensing_rule_id?: Maybe<Scalars['uuid']['output']>;
  remaining_count?: Maybe<Scalars['numeric']['output']>;
  remaining_qty?: Maybe<Scalars['numeric']['output']>;
  remaining_value?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "view_daily_asset_limit" */
export type View_Daily_Asset_Limit_Min_Order_By = {
  customer_asset_id?: InputMaybe<Order_By>;
  dispensing_rule_id?: InputMaybe<Order_By>;
  remaining_count?: InputMaybe<Order_By>;
  remaining_qty?: InputMaybe<Order_By>;
  remaining_value?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "view_daily_asset_limit". */
export type View_Daily_Asset_Limit_Order_By = {
  customer_asset?: InputMaybe<Customer_Asset_Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  dispensing_rule?: InputMaybe<Dispensing_Rules_Order_By>;
  dispensing_rule_id?: InputMaybe<Order_By>;
  remaining_count?: InputMaybe<Order_By>;
  remaining_qty?: InputMaybe<Order_By>;
  remaining_value?: InputMaybe<Order_By>;
};

/** select columns of table "view_daily_asset_limit" */
export enum View_Daily_Asset_Limit_Select_Column {
  /** column name */
  CustomerAssetId = 'customer_asset_id',
  /** column name */
  DispensingRuleId = 'dispensing_rule_id',
  /** column name */
  RemainingCount = 'remaining_count',
  /** column name */
  RemainingQty = 'remaining_qty',
  /** column name */
  RemainingValue = 'remaining_value'
}

/** aggregate stddev on columns */
export type View_Daily_Asset_Limit_Stddev_Fields = {
  __typename?: 'view_daily_asset_limit_stddev_fields';
  remaining_count?: Maybe<Scalars['Float']['output']>;
  remaining_qty?: Maybe<Scalars['Float']['output']>;
  remaining_value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "view_daily_asset_limit" */
export type View_Daily_Asset_Limit_Stddev_Order_By = {
  remaining_count?: InputMaybe<Order_By>;
  remaining_qty?: InputMaybe<Order_By>;
  remaining_value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type View_Daily_Asset_Limit_Stddev_Pop_Fields = {
  __typename?: 'view_daily_asset_limit_stddev_pop_fields';
  remaining_count?: Maybe<Scalars['Float']['output']>;
  remaining_qty?: Maybe<Scalars['Float']['output']>;
  remaining_value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "view_daily_asset_limit" */
export type View_Daily_Asset_Limit_Stddev_Pop_Order_By = {
  remaining_count?: InputMaybe<Order_By>;
  remaining_qty?: InputMaybe<Order_By>;
  remaining_value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type View_Daily_Asset_Limit_Stddev_Samp_Fields = {
  __typename?: 'view_daily_asset_limit_stddev_samp_fields';
  remaining_count?: Maybe<Scalars['Float']['output']>;
  remaining_qty?: Maybe<Scalars['Float']['output']>;
  remaining_value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "view_daily_asset_limit" */
export type View_Daily_Asset_Limit_Stddev_Samp_Order_By = {
  remaining_count?: InputMaybe<Order_By>;
  remaining_qty?: InputMaybe<Order_By>;
  remaining_value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "view_daily_asset_limit" */
export type View_Daily_Asset_Limit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: View_Daily_Asset_Limit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type View_Daily_Asset_Limit_Stream_Cursor_Value_Input = {
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  dispensing_rule_id?: InputMaybe<Scalars['uuid']['input']>;
  remaining_count?: InputMaybe<Scalars['numeric']['input']>;
  remaining_qty?: InputMaybe<Scalars['numeric']['input']>;
  remaining_value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type View_Daily_Asset_Limit_Sum_Fields = {
  __typename?: 'view_daily_asset_limit_sum_fields';
  remaining_count?: Maybe<Scalars['numeric']['output']>;
  remaining_qty?: Maybe<Scalars['numeric']['output']>;
  remaining_value?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "view_daily_asset_limit" */
export type View_Daily_Asset_Limit_Sum_Order_By = {
  remaining_count?: InputMaybe<Order_By>;
  remaining_qty?: InputMaybe<Order_By>;
  remaining_value?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type View_Daily_Asset_Limit_Var_Pop_Fields = {
  __typename?: 'view_daily_asset_limit_var_pop_fields';
  remaining_count?: Maybe<Scalars['Float']['output']>;
  remaining_qty?: Maybe<Scalars['Float']['output']>;
  remaining_value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "view_daily_asset_limit" */
export type View_Daily_Asset_Limit_Var_Pop_Order_By = {
  remaining_count?: InputMaybe<Order_By>;
  remaining_qty?: InputMaybe<Order_By>;
  remaining_value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type View_Daily_Asset_Limit_Var_Samp_Fields = {
  __typename?: 'view_daily_asset_limit_var_samp_fields';
  remaining_count?: Maybe<Scalars['Float']['output']>;
  remaining_qty?: Maybe<Scalars['Float']['output']>;
  remaining_value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "view_daily_asset_limit" */
export type View_Daily_Asset_Limit_Var_Samp_Order_By = {
  remaining_count?: InputMaybe<Order_By>;
  remaining_qty?: InputMaybe<Order_By>;
  remaining_value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type View_Daily_Asset_Limit_Variance_Fields = {
  __typename?: 'view_daily_asset_limit_variance_fields';
  remaining_count?: Maybe<Scalars['Float']['output']>;
  remaining_qty?: Maybe<Scalars['Float']['output']>;
  remaining_value?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "view_daily_asset_limit" */
export type View_Daily_Asset_Limit_Variance_Order_By = {
  remaining_count?: InputMaybe<Order_By>;
  remaining_qty?: InputMaybe<Order_By>;
  remaining_value?: InputMaybe<Order_By>;
};

/** columns and relationships of "view_monthly_asset_limit" */
export type View_Monthly_Asset_Limit = {
  __typename?: 'view_monthly_asset_limit';
  /** An object relationship */
  customer_asset?: Maybe<Customer_Asset>;
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  dispensing_rule?: Maybe<Dispensing_Rules>;
  dispensing_rule_id?: Maybe<Scalars['uuid']['output']>;
  remaining_count?: Maybe<Scalars['numeric']['output']>;
  remaining_qty?: Maybe<Scalars['numeric']['output']>;
  remaining_value?: Maybe<Scalars['numeric']['output']>;
};

/** aggregated selection of "view_monthly_asset_limit" */
export type View_Monthly_Asset_Limit_Aggregate = {
  __typename?: 'view_monthly_asset_limit_aggregate';
  aggregate?: Maybe<View_Monthly_Asset_Limit_Aggregate_Fields>;
  nodes: Array<View_Monthly_Asset_Limit>;
};

export type View_Monthly_Asset_Limit_Aggregate_Bool_Exp = {
  count?: InputMaybe<View_Monthly_Asset_Limit_Aggregate_Bool_Exp_Count>;
};

export type View_Monthly_Asset_Limit_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<View_Monthly_Asset_Limit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<View_Monthly_Asset_Limit_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "view_monthly_asset_limit" */
export type View_Monthly_Asset_Limit_Aggregate_Fields = {
  __typename?: 'view_monthly_asset_limit_aggregate_fields';
  avg?: Maybe<View_Monthly_Asset_Limit_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<View_Monthly_Asset_Limit_Max_Fields>;
  min?: Maybe<View_Monthly_Asset_Limit_Min_Fields>;
  stddev?: Maybe<View_Monthly_Asset_Limit_Stddev_Fields>;
  stddev_pop?: Maybe<View_Monthly_Asset_Limit_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<View_Monthly_Asset_Limit_Stddev_Samp_Fields>;
  sum?: Maybe<View_Monthly_Asset_Limit_Sum_Fields>;
  var_pop?: Maybe<View_Monthly_Asset_Limit_Var_Pop_Fields>;
  var_samp?: Maybe<View_Monthly_Asset_Limit_Var_Samp_Fields>;
  variance?: Maybe<View_Monthly_Asset_Limit_Variance_Fields>;
};


/** aggregate fields of "view_monthly_asset_limit" */
export type View_Monthly_Asset_Limit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<View_Monthly_Asset_Limit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "view_monthly_asset_limit" */
export type View_Monthly_Asset_Limit_Aggregate_Order_By = {
  avg?: InputMaybe<View_Monthly_Asset_Limit_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<View_Monthly_Asset_Limit_Max_Order_By>;
  min?: InputMaybe<View_Monthly_Asset_Limit_Min_Order_By>;
  stddev?: InputMaybe<View_Monthly_Asset_Limit_Stddev_Order_By>;
  stddev_pop?: InputMaybe<View_Monthly_Asset_Limit_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<View_Monthly_Asset_Limit_Stddev_Samp_Order_By>;
  sum?: InputMaybe<View_Monthly_Asset_Limit_Sum_Order_By>;
  var_pop?: InputMaybe<View_Monthly_Asset_Limit_Var_Pop_Order_By>;
  var_samp?: InputMaybe<View_Monthly_Asset_Limit_Var_Samp_Order_By>;
  variance?: InputMaybe<View_Monthly_Asset_Limit_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "view_monthly_asset_limit" */
export type View_Monthly_Asset_Limit_Arr_Rel_Insert_Input = {
  data: Array<View_Monthly_Asset_Limit_Insert_Input>;
};

/** aggregate avg on columns */
export type View_Monthly_Asset_Limit_Avg_Fields = {
  __typename?: 'view_monthly_asset_limit_avg_fields';
  remaining_count?: Maybe<Scalars['Float']['output']>;
  remaining_qty?: Maybe<Scalars['Float']['output']>;
  remaining_value?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "view_monthly_asset_limit" */
export type View_Monthly_Asset_Limit_Avg_Order_By = {
  remaining_count?: InputMaybe<Order_By>;
  remaining_qty?: InputMaybe<Order_By>;
  remaining_value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "view_monthly_asset_limit". All fields are combined with a logical 'AND'. */
export type View_Monthly_Asset_Limit_Bool_Exp = {
  _and?: InputMaybe<Array<View_Monthly_Asset_Limit_Bool_Exp>>;
  _not?: InputMaybe<View_Monthly_Asset_Limit_Bool_Exp>;
  _or?: InputMaybe<Array<View_Monthly_Asset_Limit_Bool_Exp>>;
  customer_asset?: InputMaybe<Customer_Asset_Bool_Exp>;
  customer_asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  dispensing_rule?: InputMaybe<Dispensing_Rules_Bool_Exp>;
  dispensing_rule_id?: InputMaybe<Uuid_Comparison_Exp>;
  remaining_count?: InputMaybe<Numeric_Comparison_Exp>;
  remaining_qty?: InputMaybe<Numeric_Comparison_Exp>;
  remaining_value?: InputMaybe<Numeric_Comparison_Exp>;
};

/** input type for inserting data into table "view_monthly_asset_limit" */
export type View_Monthly_Asset_Limit_Insert_Input = {
  customer_asset?: InputMaybe<Customer_Asset_Obj_Rel_Insert_Input>;
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  dispensing_rule?: InputMaybe<Dispensing_Rules_Obj_Rel_Insert_Input>;
  dispensing_rule_id?: InputMaybe<Scalars['uuid']['input']>;
  remaining_count?: InputMaybe<Scalars['numeric']['input']>;
  remaining_qty?: InputMaybe<Scalars['numeric']['input']>;
  remaining_value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type View_Monthly_Asset_Limit_Max_Fields = {
  __typename?: 'view_monthly_asset_limit_max_fields';
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  dispensing_rule_id?: Maybe<Scalars['uuid']['output']>;
  remaining_count?: Maybe<Scalars['numeric']['output']>;
  remaining_qty?: Maybe<Scalars['numeric']['output']>;
  remaining_value?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "view_monthly_asset_limit" */
export type View_Monthly_Asset_Limit_Max_Order_By = {
  customer_asset_id?: InputMaybe<Order_By>;
  dispensing_rule_id?: InputMaybe<Order_By>;
  remaining_count?: InputMaybe<Order_By>;
  remaining_qty?: InputMaybe<Order_By>;
  remaining_value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type View_Monthly_Asset_Limit_Min_Fields = {
  __typename?: 'view_monthly_asset_limit_min_fields';
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  dispensing_rule_id?: Maybe<Scalars['uuid']['output']>;
  remaining_count?: Maybe<Scalars['numeric']['output']>;
  remaining_qty?: Maybe<Scalars['numeric']['output']>;
  remaining_value?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "view_monthly_asset_limit" */
export type View_Monthly_Asset_Limit_Min_Order_By = {
  customer_asset_id?: InputMaybe<Order_By>;
  dispensing_rule_id?: InputMaybe<Order_By>;
  remaining_count?: InputMaybe<Order_By>;
  remaining_qty?: InputMaybe<Order_By>;
  remaining_value?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "view_monthly_asset_limit". */
export type View_Monthly_Asset_Limit_Order_By = {
  customer_asset?: InputMaybe<Customer_Asset_Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  dispensing_rule?: InputMaybe<Dispensing_Rules_Order_By>;
  dispensing_rule_id?: InputMaybe<Order_By>;
  remaining_count?: InputMaybe<Order_By>;
  remaining_qty?: InputMaybe<Order_By>;
  remaining_value?: InputMaybe<Order_By>;
};

/** select columns of table "view_monthly_asset_limit" */
export enum View_Monthly_Asset_Limit_Select_Column {
  /** column name */
  CustomerAssetId = 'customer_asset_id',
  /** column name */
  DispensingRuleId = 'dispensing_rule_id',
  /** column name */
  RemainingCount = 'remaining_count',
  /** column name */
  RemainingQty = 'remaining_qty',
  /** column name */
  RemainingValue = 'remaining_value'
}

/** aggregate stddev on columns */
export type View_Monthly_Asset_Limit_Stddev_Fields = {
  __typename?: 'view_monthly_asset_limit_stddev_fields';
  remaining_count?: Maybe<Scalars['Float']['output']>;
  remaining_qty?: Maybe<Scalars['Float']['output']>;
  remaining_value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "view_monthly_asset_limit" */
export type View_Monthly_Asset_Limit_Stddev_Order_By = {
  remaining_count?: InputMaybe<Order_By>;
  remaining_qty?: InputMaybe<Order_By>;
  remaining_value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type View_Monthly_Asset_Limit_Stddev_Pop_Fields = {
  __typename?: 'view_monthly_asset_limit_stddev_pop_fields';
  remaining_count?: Maybe<Scalars['Float']['output']>;
  remaining_qty?: Maybe<Scalars['Float']['output']>;
  remaining_value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "view_monthly_asset_limit" */
export type View_Monthly_Asset_Limit_Stddev_Pop_Order_By = {
  remaining_count?: InputMaybe<Order_By>;
  remaining_qty?: InputMaybe<Order_By>;
  remaining_value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type View_Monthly_Asset_Limit_Stddev_Samp_Fields = {
  __typename?: 'view_monthly_asset_limit_stddev_samp_fields';
  remaining_count?: Maybe<Scalars['Float']['output']>;
  remaining_qty?: Maybe<Scalars['Float']['output']>;
  remaining_value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "view_monthly_asset_limit" */
export type View_Monthly_Asset_Limit_Stddev_Samp_Order_By = {
  remaining_count?: InputMaybe<Order_By>;
  remaining_qty?: InputMaybe<Order_By>;
  remaining_value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "view_monthly_asset_limit" */
export type View_Monthly_Asset_Limit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: View_Monthly_Asset_Limit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type View_Monthly_Asset_Limit_Stream_Cursor_Value_Input = {
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  dispensing_rule_id?: InputMaybe<Scalars['uuid']['input']>;
  remaining_count?: InputMaybe<Scalars['numeric']['input']>;
  remaining_qty?: InputMaybe<Scalars['numeric']['input']>;
  remaining_value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type View_Monthly_Asset_Limit_Sum_Fields = {
  __typename?: 'view_monthly_asset_limit_sum_fields';
  remaining_count?: Maybe<Scalars['numeric']['output']>;
  remaining_qty?: Maybe<Scalars['numeric']['output']>;
  remaining_value?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "view_monthly_asset_limit" */
export type View_Monthly_Asset_Limit_Sum_Order_By = {
  remaining_count?: InputMaybe<Order_By>;
  remaining_qty?: InputMaybe<Order_By>;
  remaining_value?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type View_Monthly_Asset_Limit_Var_Pop_Fields = {
  __typename?: 'view_monthly_asset_limit_var_pop_fields';
  remaining_count?: Maybe<Scalars['Float']['output']>;
  remaining_qty?: Maybe<Scalars['Float']['output']>;
  remaining_value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "view_monthly_asset_limit" */
export type View_Monthly_Asset_Limit_Var_Pop_Order_By = {
  remaining_count?: InputMaybe<Order_By>;
  remaining_qty?: InputMaybe<Order_By>;
  remaining_value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type View_Monthly_Asset_Limit_Var_Samp_Fields = {
  __typename?: 'view_monthly_asset_limit_var_samp_fields';
  remaining_count?: Maybe<Scalars['Float']['output']>;
  remaining_qty?: Maybe<Scalars['Float']['output']>;
  remaining_value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "view_monthly_asset_limit" */
export type View_Monthly_Asset_Limit_Var_Samp_Order_By = {
  remaining_count?: InputMaybe<Order_By>;
  remaining_qty?: InputMaybe<Order_By>;
  remaining_value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type View_Monthly_Asset_Limit_Variance_Fields = {
  __typename?: 'view_monthly_asset_limit_variance_fields';
  remaining_count?: Maybe<Scalars['Float']['output']>;
  remaining_qty?: Maybe<Scalars['Float']['output']>;
  remaining_value?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "view_monthly_asset_limit" */
export type View_Monthly_Asset_Limit_Variance_Order_By = {
  remaining_count?: InputMaybe<Order_By>;
  remaining_qty?: InputMaybe<Order_By>;
  remaining_value?: InputMaybe<Order_By>;
};

/** columns and relationships of "view_unlinked_customer_assets" */
export type View_Unlinked_Customer_Assets = {
  __typename?: 'view_unlinked_customer_assets';
  /** An object relationship */
  customer_asset?: Maybe<Customer_Asset>;
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  customer_order?: Maybe<Customer_Order>;
  customer_order_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "view_unlinked_customer_assets" */
export type View_Unlinked_Customer_Assets_Aggregate = {
  __typename?: 'view_unlinked_customer_assets_aggregate';
  aggregate?: Maybe<View_Unlinked_Customer_Assets_Aggregate_Fields>;
  nodes: Array<View_Unlinked_Customer_Assets>;
};

/** aggregate fields of "view_unlinked_customer_assets" */
export type View_Unlinked_Customer_Assets_Aggregate_Fields = {
  __typename?: 'view_unlinked_customer_assets_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<View_Unlinked_Customer_Assets_Max_Fields>;
  min?: Maybe<View_Unlinked_Customer_Assets_Min_Fields>;
};


/** aggregate fields of "view_unlinked_customer_assets" */
export type View_Unlinked_Customer_Assets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<View_Unlinked_Customer_Assets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "view_unlinked_customer_assets". All fields are combined with a logical 'AND'. */
export type View_Unlinked_Customer_Assets_Bool_Exp = {
  _and?: InputMaybe<Array<View_Unlinked_Customer_Assets_Bool_Exp>>;
  _not?: InputMaybe<View_Unlinked_Customer_Assets_Bool_Exp>;
  _or?: InputMaybe<Array<View_Unlinked_Customer_Assets_Bool_Exp>>;
  customer_asset?: InputMaybe<Customer_Asset_Bool_Exp>;
  customer_asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  customer_order?: InputMaybe<Customer_Order_Bool_Exp>;
  customer_order_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type View_Unlinked_Customer_Assets_Max_Fields = {
  __typename?: 'view_unlinked_customer_assets_max_fields';
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  customer_order_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type View_Unlinked_Customer_Assets_Min_Fields = {
  __typename?: 'view_unlinked_customer_assets_min_fields';
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  customer_order_id?: Maybe<Scalars['uuid']['output']>;
};

/** Ordering options when selecting data from "view_unlinked_customer_assets". */
export type View_Unlinked_Customer_Assets_Order_By = {
  customer_asset?: InputMaybe<Customer_Asset_Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  customer_order?: InputMaybe<Customer_Order_Order_By>;
  customer_order_id?: InputMaybe<Order_By>;
};

/** select columns of table "view_unlinked_customer_assets" */
export enum View_Unlinked_Customer_Assets_Select_Column {
  /** column name */
  CustomerAssetId = 'customer_asset_id',
  /** column name */
  CustomerOrderId = 'customer_order_id'
}

/** Streaming cursor of the table "view_unlinked_customer_assets" */
export type View_Unlinked_Customer_Assets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: View_Unlinked_Customer_Assets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type View_Unlinked_Customer_Assets_Stream_Cursor_Value_Input = {
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "view_weekly_asset_limit" */
export type View_Weekly_Asset_Limit = {
  __typename?: 'view_weekly_asset_limit';
  /** An object relationship */
  customer_asset?: Maybe<Customer_Asset>;
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  dispensing_rule?: Maybe<Dispensing_Rules>;
  dispensing_rule_id?: Maybe<Scalars['uuid']['output']>;
  remaining_count?: Maybe<Scalars['numeric']['output']>;
  remaining_qty?: Maybe<Scalars['numeric']['output']>;
  remaining_value?: Maybe<Scalars['numeric']['output']>;
};

/** aggregated selection of "view_weekly_asset_limit" */
export type View_Weekly_Asset_Limit_Aggregate = {
  __typename?: 'view_weekly_asset_limit_aggregate';
  aggregate?: Maybe<View_Weekly_Asset_Limit_Aggregate_Fields>;
  nodes: Array<View_Weekly_Asset_Limit>;
};

export type View_Weekly_Asset_Limit_Aggregate_Bool_Exp = {
  count?: InputMaybe<View_Weekly_Asset_Limit_Aggregate_Bool_Exp_Count>;
};

export type View_Weekly_Asset_Limit_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<View_Weekly_Asset_Limit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<View_Weekly_Asset_Limit_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "view_weekly_asset_limit" */
export type View_Weekly_Asset_Limit_Aggregate_Fields = {
  __typename?: 'view_weekly_asset_limit_aggregate_fields';
  avg?: Maybe<View_Weekly_Asset_Limit_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<View_Weekly_Asset_Limit_Max_Fields>;
  min?: Maybe<View_Weekly_Asset_Limit_Min_Fields>;
  stddev?: Maybe<View_Weekly_Asset_Limit_Stddev_Fields>;
  stddev_pop?: Maybe<View_Weekly_Asset_Limit_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<View_Weekly_Asset_Limit_Stddev_Samp_Fields>;
  sum?: Maybe<View_Weekly_Asset_Limit_Sum_Fields>;
  var_pop?: Maybe<View_Weekly_Asset_Limit_Var_Pop_Fields>;
  var_samp?: Maybe<View_Weekly_Asset_Limit_Var_Samp_Fields>;
  variance?: Maybe<View_Weekly_Asset_Limit_Variance_Fields>;
};


/** aggregate fields of "view_weekly_asset_limit" */
export type View_Weekly_Asset_Limit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<View_Weekly_Asset_Limit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "view_weekly_asset_limit" */
export type View_Weekly_Asset_Limit_Aggregate_Order_By = {
  avg?: InputMaybe<View_Weekly_Asset_Limit_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<View_Weekly_Asset_Limit_Max_Order_By>;
  min?: InputMaybe<View_Weekly_Asset_Limit_Min_Order_By>;
  stddev?: InputMaybe<View_Weekly_Asset_Limit_Stddev_Order_By>;
  stddev_pop?: InputMaybe<View_Weekly_Asset_Limit_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<View_Weekly_Asset_Limit_Stddev_Samp_Order_By>;
  sum?: InputMaybe<View_Weekly_Asset_Limit_Sum_Order_By>;
  var_pop?: InputMaybe<View_Weekly_Asset_Limit_Var_Pop_Order_By>;
  var_samp?: InputMaybe<View_Weekly_Asset_Limit_Var_Samp_Order_By>;
  variance?: InputMaybe<View_Weekly_Asset_Limit_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "view_weekly_asset_limit" */
export type View_Weekly_Asset_Limit_Arr_Rel_Insert_Input = {
  data: Array<View_Weekly_Asset_Limit_Insert_Input>;
};

/** aggregate avg on columns */
export type View_Weekly_Asset_Limit_Avg_Fields = {
  __typename?: 'view_weekly_asset_limit_avg_fields';
  remaining_count?: Maybe<Scalars['Float']['output']>;
  remaining_qty?: Maybe<Scalars['Float']['output']>;
  remaining_value?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "view_weekly_asset_limit" */
export type View_Weekly_Asset_Limit_Avg_Order_By = {
  remaining_count?: InputMaybe<Order_By>;
  remaining_qty?: InputMaybe<Order_By>;
  remaining_value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "view_weekly_asset_limit". All fields are combined with a logical 'AND'. */
export type View_Weekly_Asset_Limit_Bool_Exp = {
  _and?: InputMaybe<Array<View_Weekly_Asset_Limit_Bool_Exp>>;
  _not?: InputMaybe<View_Weekly_Asset_Limit_Bool_Exp>;
  _or?: InputMaybe<Array<View_Weekly_Asset_Limit_Bool_Exp>>;
  customer_asset?: InputMaybe<Customer_Asset_Bool_Exp>;
  customer_asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  dispensing_rule?: InputMaybe<Dispensing_Rules_Bool_Exp>;
  dispensing_rule_id?: InputMaybe<Uuid_Comparison_Exp>;
  remaining_count?: InputMaybe<Numeric_Comparison_Exp>;
  remaining_qty?: InputMaybe<Numeric_Comparison_Exp>;
  remaining_value?: InputMaybe<Numeric_Comparison_Exp>;
};

/** input type for inserting data into table "view_weekly_asset_limit" */
export type View_Weekly_Asset_Limit_Insert_Input = {
  customer_asset?: InputMaybe<Customer_Asset_Obj_Rel_Insert_Input>;
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  dispensing_rule?: InputMaybe<Dispensing_Rules_Obj_Rel_Insert_Input>;
  dispensing_rule_id?: InputMaybe<Scalars['uuid']['input']>;
  remaining_count?: InputMaybe<Scalars['numeric']['input']>;
  remaining_qty?: InputMaybe<Scalars['numeric']['input']>;
  remaining_value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type View_Weekly_Asset_Limit_Max_Fields = {
  __typename?: 'view_weekly_asset_limit_max_fields';
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  dispensing_rule_id?: Maybe<Scalars['uuid']['output']>;
  remaining_count?: Maybe<Scalars['numeric']['output']>;
  remaining_qty?: Maybe<Scalars['numeric']['output']>;
  remaining_value?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "view_weekly_asset_limit" */
export type View_Weekly_Asset_Limit_Max_Order_By = {
  customer_asset_id?: InputMaybe<Order_By>;
  dispensing_rule_id?: InputMaybe<Order_By>;
  remaining_count?: InputMaybe<Order_By>;
  remaining_qty?: InputMaybe<Order_By>;
  remaining_value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type View_Weekly_Asset_Limit_Min_Fields = {
  __typename?: 'view_weekly_asset_limit_min_fields';
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  dispensing_rule_id?: Maybe<Scalars['uuid']['output']>;
  remaining_count?: Maybe<Scalars['numeric']['output']>;
  remaining_qty?: Maybe<Scalars['numeric']['output']>;
  remaining_value?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "view_weekly_asset_limit" */
export type View_Weekly_Asset_Limit_Min_Order_By = {
  customer_asset_id?: InputMaybe<Order_By>;
  dispensing_rule_id?: InputMaybe<Order_By>;
  remaining_count?: InputMaybe<Order_By>;
  remaining_qty?: InputMaybe<Order_By>;
  remaining_value?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "view_weekly_asset_limit". */
export type View_Weekly_Asset_Limit_Order_By = {
  customer_asset?: InputMaybe<Customer_Asset_Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  dispensing_rule?: InputMaybe<Dispensing_Rules_Order_By>;
  dispensing_rule_id?: InputMaybe<Order_By>;
  remaining_count?: InputMaybe<Order_By>;
  remaining_qty?: InputMaybe<Order_By>;
  remaining_value?: InputMaybe<Order_By>;
};

/** select columns of table "view_weekly_asset_limit" */
export enum View_Weekly_Asset_Limit_Select_Column {
  /** column name */
  CustomerAssetId = 'customer_asset_id',
  /** column name */
  DispensingRuleId = 'dispensing_rule_id',
  /** column name */
  RemainingCount = 'remaining_count',
  /** column name */
  RemainingQty = 'remaining_qty',
  /** column name */
  RemainingValue = 'remaining_value'
}

/** aggregate stddev on columns */
export type View_Weekly_Asset_Limit_Stddev_Fields = {
  __typename?: 'view_weekly_asset_limit_stddev_fields';
  remaining_count?: Maybe<Scalars['Float']['output']>;
  remaining_qty?: Maybe<Scalars['Float']['output']>;
  remaining_value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "view_weekly_asset_limit" */
export type View_Weekly_Asset_Limit_Stddev_Order_By = {
  remaining_count?: InputMaybe<Order_By>;
  remaining_qty?: InputMaybe<Order_By>;
  remaining_value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type View_Weekly_Asset_Limit_Stddev_Pop_Fields = {
  __typename?: 'view_weekly_asset_limit_stddev_pop_fields';
  remaining_count?: Maybe<Scalars['Float']['output']>;
  remaining_qty?: Maybe<Scalars['Float']['output']>;
  remaining_value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "view_weekly_asset_limit" */
export type View_Weekly_Asset_Limit_Stddev_Pop_Order_By = {
  remaining_count?: InputMaybe<Order_By>;
  remaining_qty?: InputMaybe<Order_By>;
  remaining_value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type View_Weekly_Asset_Limit_Stddev_Samp_Fields = {
  __typename?: 'view_weekly_asset_limit_stddev_samp_fields';
  remaining_count?: Maybe<Scalars['Float']['output']>;
  remaining_qty?: Maybe<Scalars['Float']['output']>;
  remaining_value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "view_weekly_asset_limit" */
export type View_Weekly_Asset_Limit_Stddev_Samp_Order_By = {
  remaining_count?: InputMaybe<Order_By>;
  remaining_qty?: InputMaybe<Order_By>;
  remaining_value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "view_weekly_asset_limit" */
export type View_Weekly_Asset_Limit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: View_Weekly_Asset_Limit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type View_Weekly_Asset_Limit_Stream_Cursor_Value_Input = {
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  dispensing_rule_id?: InputMaybe<Scalars['uuid']['input']>;
  remaining_count?: InputMaybe<Scalars['numeric']['input']>;
  remaining_qty?: InputMaybe<Scalars['numeric']['input']>;
  remaining_value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type View_Weekly_Asset_Limit_Sum_Fields = {
  __typename?: 'view_weekly_asset_limit_sum_fields';
  remaining_count?: Maybe<Scalars['numeric']['output']>;
  remaining_qty?: Maybe<Scalars['numeric']['output']>;
  remaining_value?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "view_weekly_asset_limit" */
export type View_Weekly_Asset_Limit_Sum_Order_By = {
  remaining_count?: InputMaybe<Order_By>;
  remaining_qty?: InputMaybe<Order_By>;
  remaining_value?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type View_Weekly_Asset_Limit_Var_Pop_Fields = {
  __typename?: 'view_weekly_asset_limit_var_pop_fields';
  remaining_count?: Maybe<Scalars['Float']['output']>;
  remaining_qty?: Maybe<Scalars['Float']['output']>;
  remaining_value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "view_weekly_asset_limit" */
export type View_Weekly_Asset_Limit_Var_Pop_Order_By = {
  remaining_count?: InputMaybe<Order_By>;
  remaining_qty?: InputMaybe<Order_By>;
  remaining_value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type View_Weekly_Asset_Limit_Var_Samp_Fields = {
  __typename?: 'view_weekly_asset_limit_var_samp_fields';
  remaining_count?: Maybe<Scalars['Float']['output']>;
  remaining_qty?: Maybe<Scalars['Float']['output']>;
  remaining_value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "view_weekly_asset_limit" */
export type View_Weekly_Asset_Limit_Var_Samp_Order_By = {
  remaining_count?: InputMaybe<Order_By>;
  remaining_qty?: InputMaybe<Order_By>;
  remaining_value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type View_Weekly_Asset_Limit_Variance_Fields = {
  __typename?: 'view_weekly_asset_limit_variance_fields';
  remaining_count?: Maybe<Scalars['Float']['output']>;
  remaining_qty?: Maybe<Scalars['Float']['output']>;
  remaining_value?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "view_weekly_asset_limit" */
export type View_Weekly_Asset_Limit_Variance_Order_By = {
  remaining_count?: InputMaybe<Order_By>;
  remaining_qty?: InputMaybe<Order_By>;
  remaining_value?: InputMaybe<Order_By>;
};

/** columns and relationships of "voucher" */
export type Voucher = {
  __typename?: 'voucher';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  customer_orders: Array<Customer_Order>;
  /** An aggregate relationship */
  customer_orders_aggregate: Customer_Order_Aggregate;
  description?: Maybe<Scalars['String']['output']>;
  expiry_date?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organization_user: Organization_User;
  organization_user_id: Scalars['uuid']['output'];
  /** An array relationship */
  partner_orders: Array<Partner_Order>;
  /** An aggregate relationship */
  partner_orders_aggregate: Partner_Order_Aggregate;
  /** An object relationship */
  script: Scripts;
  scripts_id: Scalars['uuid']['output'];
};


/** columns and relationships of "voucher" */
export type VoucherCustomer_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Order_By>>;
  where?: InputMaybe<Customer_Order_Bool_Exp>;
};


/** columns and relationships of "voucher" */
export type VoucherCustomer_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_Order_By>>;
  where?: InputMaybe<Customer_Order_Bool_Exp>;
};


/** columns and relationships of "voucher" */
export type VoucherPartner_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Order_By>>;
  where?: InputMaybe<Partner_Order_Bool_Exp>;
};


/** columns and relationships of "voucher" */
export type VoucherPartner_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Order_Order_By>>;
  where?: InputMaybe<Partner_Order_Bool_Exp>;
};

/** aggregated selection of "voucher" */
export type Voucher_Aggregate = {
  __typename?: 'voucher_aggregate';
  aggregate?: Maybe<Voucher_Aggregate_Fields>;
  nodes: Array<Voucher>;
};

export type Voucher_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Voucher_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Voucher_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Voucher_Aggregate_Bool_Exp_Count>;
};

export type Voucher_Aggregate_Bool_Exp_Bool_And = {
  arguments: Voucher_Select_Column_Voucher_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Voucher_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Voucher_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Voucher_Select_Column_Voucher_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Voucher_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Voucher_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Voucher_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Voucher_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "voucher" */
export type Voucher_Aggregate_Fields = {
  __typename?: 'voucher_aggregate_fields';
  avg?: Maybe<Voucher_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Voucher_Max_Fields>;
  min?: Maybe<Voucher_Min_Fields>;
  stddev?: Maybe<Voucher_Stddev_Fields>;
  stddev_pop?: Maybe<Voucher_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Voucher_Stddev_Samp_Fields>;
  sum?: Maybe<Voucher_Sum_Fields>;
  var_pop?: Maybe<Voucher_Var_Pop_Fields>;
  var_samp?: Maybe<Voucher_Var_Samp_Fields>;
  variance?: Maybe<Voucher_Variance_Fields>;
};


/** aggregate fields of "voucher" */
export type Voucher_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Voucher_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "voucher" */
export type Voucher_Aggregate_Order_By = {
  avg?: InputMaybe<Voucher_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Voucher_Max_Order_By>;
  min?: InputMaybe<Voucher_Min_Order_By>;
  stddev?: InputMaybe<Voucher_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Voucher_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Voucher_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Voucher_Sum_Order_By>;
  var_pop?: InputMaybe<Voucher_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Voucher_Var_Samp_Order_By>;
  variance?: InputMaybe<Voucher_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "voucher" */
export type Voucher_Arr_Rel_Insert_Input = {
  data: Array<Voucher_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Voucher_On_Conflict>;
};

/** aggregate avg on columns */
export type Voucher_Avg_Fields = {
  __typename?: 'voucher_avg_fields';
  limit?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "voucher" */
export type Voucher_Avg_Order_By = {
  limit?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "voucher". All fields are combined with a logical 'AND'. */
export type Voucher_Bool_Exp = {
  _and?: InputMaybe<Array<Voucher_Bool_Exp>>;
  _not?: InputMaybe<Voucher_Bool_Exp>;
  _or?: InputMaybe<Array<Voucher_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_orders?: InputMaybe<Customer_Order_Bool_Exp>;
  customer_orders_aggregate?: InputMaybe<Customer_Order_Aggregate_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  expiry_date?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  limit?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization_user?: InputMaybe<Organization_User_Bool_Exp>;
  organization_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner_orders?: InputMaybe<Partner_Order_Bool_Exp>;
  partner_orders_aggregate?: InputMaybe<Partner_Order_Aggregate_Bool_Exp>;
  script?: InputMaybe<Scripts_Bool_Exp>;
  scripts_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "voucher" */
export enum Voucher_Constraint {
  /** unique or primary key constraint on columns "id" */
  VoucherPkey = 'voucher_pkey'
}

/** input type for incrementing numeric columns in table "voucher" */
export type Voucher_Inc_Input = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "voucher" */
export type Voucher_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  customer_orders?: InputMaybe<Customer_Order_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']['input']>;
  expiry_date?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_user?: InputMaybe<Organization_User_Obj_Rel_Insert_Input>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_orders?: InputMaybe<Partner_Order_Arr_Rel_Insert_Input>;
  script?: InputMaybe<Scripts_Obj_Rel_Insert_Input>;
  scripts_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Voucher_Max_Fields = {
  __typename?: 'voucher_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expiry_date?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization_user_id?: Maybe<Scalars['uuid']['output']>;
  scripts_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "voucher" */
export type Voucher_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  expiry_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  limit?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
  scripts_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Voucher_Min_Fields = {
  __typename?: 'voucher_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expiry_date?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization_user_id?: Maybe<Scalars['uuid']['output']>;
  scripts_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "voucher" */
export type Voucher_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  expiry_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  limit?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
  scripts_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "voucher" */
export type Voucher_Mutation_Response = {
  __typename?: 'voucher_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Voucher>;
};

/** input type for inserting object relation for remote table "voucher" */
export type Voucher_Obj_Rel_Insert_Input = {
  data: Voucher_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Voucher_On_Conflict>;
};

/** on_conflict condition type for table "voucher" */
export type Voucher_On_Conflict = {
  constraint: Voucher_Constraint;
  update_columns?: Array<Voucher_Update_Column>;
  where?: InputMaybe<Voucher_Bool_Exp>;
};

/** Ordering options when selecting data from "voucher". */
export type Voucher_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_orders_aggregate?: InputMaybe<Customer_Order_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  expiry_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  limit?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_user?: InputMaybe<Organization_User_Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
  partner_orders_aggregate?: InputMaybe<Partner_Order_Aggregate_Order_By>;
  script?: InputMaybe<Scripts_Order_By>;
  scripts_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: voucher */
export type Voucher_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "voucher" */
export enum Voucher_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  ExpiryDate = 'expiry_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Limit = 'limit',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationUserId = 'organization_user_id',
  /** column name */
  ScriptsId = 'scripts_id'
}

/** select "voucher_aggregate_bool_exp_bool_and_arguments_columns" columns of table "voucher" */
export enum Voucher_Select_Column_Voucher_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "voucher_aggregate_bool_exp_bool_or_arguments_columns" columns of table "voucher" */
export enum Voucher_Select_Column_Voucher_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "voucher" */
export type Voucher_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expiry_date?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  scripts_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Voucher_Stddev_Fields = {
  __typename?: 'voucher_stddev_fields';
  limit?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "voucher" */
export type Voucher_Stddev_Order_By = {
  limit?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Voucher_Stddev_Pop_Fields = {
  __typename?: 'voucher_stddev_pop_fields';
  limit?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "voucher" */
export type Voucher_Stddev_Pop_Order_By = {
  limit?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Voucher_Stddev_Samp_Fields = {
  __typename?: 'voucher_stddev_samp_fields';
  limit?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "voucher" */
export type Voucher_Stddev_Samp_Order_By = {
  limit?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "voucher" */
export type Voucher_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Voucher_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Voucher_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expiry_date?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  scripts_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Voucher_Sum_Fields = {
  __typename?: 'voucher_sum_fields';
  limit?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "voucher" */
export type Voucher_Sum_Order_By = {
  limit?: InputMaybe<Order_By>;
};

/** update columns of table "voucher" */
export enum Voucher_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  ExpiryDate = 'expiry_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Limit = 'limit',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationUserId = 'organization_user_id',
  /** column name */
  ScriptsId = 'scripts_id'
}

export type Voucher_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Voucher_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Voucher_Set_Input>;
  /** filter the rows which have to be updated */
  where: Voucher_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Voucher_Var_Pop_Fields = {
  __typename?: 'voucher_var_pop_fields';
  limit?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "voucher" */
export type Voucher_Var_Pop_Order_By = {
  limit?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Voucher_Var_Samp_Fields = {
  __typename?: 'voucher_var_samp_fields';
  limit?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "voucher" */
export type Voucher_Var_Samp_Order_By = {
  limit?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Voucher_Variance_Fields = {
  __typename?: 'voucher_variance_fields';
  limit?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "voucher" */
export type Voucher_Variance_Order_By = {
  limit?: InputMaybe<Order_By>;
};

/** columns and relationships of "wallet" */
export type Wallet = {
  __typename?: 'wallet';
  amount?: Maybe<Scalars['numeric']['output']>;
  blocked_amount?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  currency: Currency;
  currency_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  organization?: Maybe<Organization>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  user_ledgers: Array<User_Ledger>;
  /** An aggregate relationship */
  user_ledgers_aggregate: User_Ledger_Aggregate;
  /** An array relationship */
  wallet_exceptions: Array<Wallet_Exception>;
  /** An aggregate relationship */
  wallet_exceptions_aggregate: Wallet_Exception_Aggregate;
  /** An array relationship */
  wallet_ledgers: Array<Wallet_Ledger>;
  /** An aggregate relationship */
  wallet_ledgers_aggregate: Wallet_Ledger_Aggregate;
  /** An array relationship */
  wallet_transactions: Array<Wallet_Transactions>;
  /** An aggregate relationship */
  wallet_transactions_aggregate: Wallet_Transactions_Aggregate;
};


/** columns and relationships of "wallet" */
export type WalletUser_LedgersArgs = {
  distinct_on?: InputMaybe<Array<User_Ledger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Ledger_Order_By>>;
  where?: InputMaybe<User_Ledger_Bool_Exp>;
};


/** columns and relationships of "wallet" */
export type WalletUser_Ledgers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Ledger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Ledger_Order_By>>;
  where?: InputMaybe<User_Ledger_Bool_Exp>;
};


/** columns and relationships of "wallet" */
export type WalletWallet_ExceptionsArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Exception_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Exception_Order_By>>;
  where?: InputMaybe<Wallet_Exception_Bool_Exp>;
};


/** columns and relationships of "wallet" */
export type WalletWallet_Exceptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Exception_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Exception_Order_By>>;
  where?: InputMaybe<Wallet_Exception_Bool_Exp>;
};


/** columns and relationships of "wallet" */
export type WalletWallet_LedgersArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Ledger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Ledger_Order_By>>;
  where?: InputMaybe<Wallet_Ledger_Bool_Exp>;
};


/** columns and relationships of "wallet" */
export type WalletWallet_Ledgers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Ledger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Ledger_Order_By>>;
  where?: InputMaybe<Wallet_Ledger_Bool_Exp>;
};


/** columns and relationships of "wallet" */
export type WalletWallet_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Transactions_Order_By>>;
  where?: InputMaybe<Wallet_Transactions_Bool_Exp>;
};


/** columns and relationships of "wallet" */
export type WalletWallet_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Transactions_Order_By>>;
  where?: InputMaybe<Wallet_Transactions_Bool_Exp>;
};

/** aggregated selection of "wallet" */
export type Wallet_Aggregate = {
  __typename?: 'wallet_aggregate';
  aggregate?: Maybe<Wallet_Aggregate_Fields>;
  nodes: Array<Wallet>;
};

export type Wallet_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Wallet_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Wallet_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Wallet_Aggregate_Bool_Exp_Count>;
};

export type Wallet_Aggregate_Bool_Exp_Bool_And = {
  arguments: Wallet_Select_Column_Wallet_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Wallet_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Wallet_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Wallet_Select_Column_Wallet_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Wallet_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Wallet_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Wallet_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Wallet_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "wallet" */
export type Wallet_Aggregate_Fields = {
  __typename?: 'wallet_aggregate_fields';
  avg?: Maybe<Wallet_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Wallet_Max_Fields>;
  min?: Maybe<Wallet_Min_Fields>;
  stddev?: Maybe<Wallet_Stddev_Fields>;
  stddev_pop?: Maybe<Wallet_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Wallet_Stddev_Samp_Fields>;
  sum?: Maybe<Wallet_Sum_Fields>;
  var_pop?: Maybe<Wallet_Var_Pop_Fields>;
  var_samp?: Maybe<Wallet_Var_Samp_Fields>;
  variance?: Maybe<Wallet_Variance_Fields>;
};


/** aggregate fields of "wallet" */
export type Wallet_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Wallet_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "wallet" */
export type Wallet_Aggregate_Order_By = {
  avg?: InputMaybe<Wallet_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Wallet_Max_Order_By>;
  min?: InputMaybe<Wallet_Min_Order_By>;
  stddev?: InputMaybe<Wallet_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Wallet_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Wallet_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Wallet_Sum_Order_By>;
  var_pop?: InputMaybe<Wallet_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Wallet_Var_Samp_Order_By>;
  variance?: InputMaybe<Wallet_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "wallet" */
export type Wallet_Arr_Rel_Insert_Input = {
  data: Array<Wallet_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Wallet_On_Conflict>;
};

/** aggregate avg on columns */
export type Wallet_Avg_Fields = {
  __typename?: 'wallet_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  blocked_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "wallet" */
export type Wallet_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  blocked_amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "wallet". All fields are combined with a logical 'AND'. */
export type Wallet_Bool_Exp = {
  _and?: InputMaybe<Array<Wallet_Bool_Exp>>;
  _not?: InputMaybe<Wallet_Bool_Exp>;
  _or?: InputMaybe<Array<Wallet_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  blocked_amount?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  currency?: InputMaybe<Currency_Bool_Exp>;
  currency_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  user_ledgers?: InputMaybe<User_Ledger_Bool_Exp>;
  user_ledgers_aggregate?: InputMaybe<User_Ledger_Aggregate_Bool_Exp>;
  wallet_exceptions?: InputMaybe<Wallet_Exception_Bool_Exp>;
  wallet_exceptions_aggregate?: InputMaybe<Wallet_Exception_Aggregate_Bool_Exp>;
  wallet_ledgers?: InputMaybe<Wallet_Ledger_Bool_Exp>;
  wallet_ledgers_aggregate?: InputMaybe<Wallet_Ledger_Aggregate_Bool_Exp>;
  wallet_transactions?: InputMaybe<Wallet_Transactions_Bool_Exp>;
  wallet_transactions_aggregate?: InputMaybe<Wallet_Transactions_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "wallet" */
export enum Wallet_Constraint {
  /** unique or primary key constraint on columns "organization_id" */
  WalletOrganizationUnique = 'wallet_organization_unique',
  /** unique or primary key constraint on columns "id" */
  WalletPkey = 'wallet_pkey'
}

/** Tracks temporary wallet exception approvals that allow deliveries when the wallet is exhausted. Each exception is a fixed 12-hour window with an AED amount cap. Mirrors lpo_exception (IDEV-2738). */
export type Wallet_Exception = {
  __typename?: 'wallet_exception';
  approved_by: Scalars['uuid']['output'];
  /** An object relationship */
  approved_by_user: User;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  exception_amount?: Maybe<Scalars['numeric']['output']>;
  expires_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified: Scalars['timestamptz']['output'];
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organization: Organization;
  organization_id: Scalars['uuid']['output'];
  state: Scalars['String']['output'];
  /** An object relationship */
  wallet: Wallet;
  wallet_id: Scalars['uuid']['output'];
  workflow_id?: Maybe<Scalars['String']['output']>;
  workflow_run_id?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "wallet_exception" */
export type Wallet_Exception_Aggregate = {
  __typename?: 'wallet_exception_aggregate';
  aggregate?: Maybe<Wallet_Exception_Aggregate_Fields>;
  nodes: Array<Wallet_Exception>;
};

export type Wallet_Exception_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Wallet_Exception_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Wallet_Exception_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Wallet_Exception_Aggregate_Bool_Exp_Count>;
};

export type Wallet_Exception_Aggregate_Bool_Exp_Bool_And = {
  arguments: Wallet_Exception_Select_Column_Wallet_Exception_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Wallet_Exception_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Wallet_Exception_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Wallet_Exception_Select_Column_Wallet_Exception_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Wallet_Exception_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Wallet_Exception_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Wallet_Exception_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Wallet_Exception_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "wallet_exception" */
export type Wallet_Exception_Aggregate_Fields = {
  __typename?: 'wallet_exception_aggregate_fields';
  avg?: Maybe<Wallet_Exception_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Wallet_Exception_Max_Fields>;
  min?: Maybe<Wallet_Exception_Min_Fields>;
  stddev?: Maybe<Wallet_Exception_Stddev_Fields>;
  stddev_pop?: Maybe<Wallet_Exception_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Wallet_Exception_Stddev_Samp_Fields>;
  sum?: Maybe<Wallet_Exception_Sum_Fields>;
  var_pop?: Maybe<Wallet_Exception_Var_Pop_Fields>;
  var_samp?: Maybe<Wallet_Exception_Var_Samp_Fields>;
  variance?: Maybe<Wallet_Exception_Variance_Fields>;
};


/** aggregate fields of "wallet_exception" */
export type Wallet_Exception_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Wallet_Exception_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "wallet_exception" */
export type Wallet_Exception_Aggregate_Order_By = {
  avg?: InputMaybe<Wallet_Exception_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Wallet_Exception_Max_Order_By>;
  min?: InputMaybe<Wallet_Exception_Min_Order_By>;
  stddev?: InputMaybe<Wallet_Exception_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Wallet_Exception_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Wallet_Exception_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Wallet_Exception_Sum_Order_By>;
  var_pop?: InputMaybe<Wallet_Exception_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Wallet_Exception_Var_Samp_Order_By>;
  variance?: InputMaybe<Wallet_Exception_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "wallet_exception" */
export type Wallet_Exception_Arr_Rel_Insert_Input = {
  data: Array<Wallet_Exception_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Wallet_Exception_On_Conflict>;
};

/** aggregate avg on columns */
export type Wallet_Exception_Avg_Fields = {
  __typename?: 'wallet_exception_avg_fields';
  exception_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "wallet_exception" */
export type Wallet_Exception_Avg_Order_By = {
  exception_amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "wallet_exception". All fields are combined with a logical 'AND'. */
export type Wallet_Exception_Bool_Exp = {
  _and?: InputMaybe<Array<Wallet_Exception_Bool_Exp>>;
  _not?: InputMaybe<Wallet_Exception_Bool_Exp>;
  _or?: InputMaybe<Array<Wallet_Exception_Bool_Exp>>;
  approved_by?: InputMaybe<Uuid_Comparison_Exp>;
  approved_by_user?: InputMaybe<User_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  exception_amount?: InputMaybe<Numeric_Comparison_Exp>;
  expires_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  wallet?: InputMaybe<Wallet_Bool_Exp>;
  wallet_id?: InputMaybe<Uuid_Comparison_Exp>;
  workflow_id?: InputMaybe<String_Comparison_Exp>;
  workflow_run_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "wallet_exception" */
export enum Wallet_Exception_Constraint {
  /** unique or primary key constraint on columns "wallet_id" */
  WalletExceptionActiveUnique = 'wallet_exception_active_unique',
  /** unique or primary key constraint on columns "id" */
  WalletExceptionPkey = 'wallet_exception_pkey'
}

/** input type for incrementing numeric columns in table "wallet_exception" */
export type Wallet_Exception_Inc_Input = {
  exception_amount?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "wallet_exception" */
export type Wallet_Exception_Insert_Input = {
  approved_by?: InputMaybe<Scalars['uuid']['input']>;
  approved_by_user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  exception_amount?: InputMaybe<Scalars['numeric']['input']>;
  expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  wallet?: InputMaybe<Wallet_Obj_Rel_Insert_Input>;
  wallet_id?: InputMaybe<Scalars['uuid']['input']>;
  workflow_id?: InputMaybe<Scalars['String']['input']>;
  workflow_run_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Wallet_Exception_Max_Fields = {
  __typename?: 'wallet_exception_max_fields';
  approved_by?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  exception_amount?: Maybe<Scalars['numeric']['output']>;
  expires_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  wallet_id?: Maybe<Scalars['uuid']['output']>;
  workflow_id?: Maybe<Scalars['String']['output']>;
  workflow_run_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "wallet_exception" */
export type Wallet_Exception_Max_Order_By = {
  approved_by?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  exception_amount?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  wallet_id?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
  workflow_run_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Wallet_Exception_Min_Fields = {
  __typename?: 'wallet_exception_min_fields';
  approved_by?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  exception_amount?: Maybe<Scalars['numeric']['output']>;
  expires_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamptz']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  wallet_id?: Maybe<Scalars['uuid']['output']>;
  workflow_id?: Maybe<Scalars['String']['output']>;
  workflow_run_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "wallet_exception" */
export type Wallet_Exception_Min_Order_By = {
  approved_by?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  exception_amount?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  wallet_id?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
  workflow_run_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "wallet_exception" */
export type Wallet_Exception_Mutation_Response = {
  __typename?: 'wallet_exception_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Wallet_Exception>;
};

/** on_conflict condition type for table "wallet_exception" */
export type Wallet_Exception_On_Conflict = {
  constraint: Wallet_Exception_Constraint;
  update_columns?: Array<Wallet_Exception_Update_Column>;
  where?: InputMaybe<Wallet_Exception_Bool_Exp>;
};

/** Ordering options when selecting data from "wallet_exception". */
export type Wallet_Exception_Order_By = {
  approved_by?: InputMaybe<Order_By>;
  approved_by_user?: InputMaybe<User_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  exception_amount?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  wallet?: InputMaybe<Wallet_Order_By>;
  wallet_id?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
  workflow_run_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: wallet_exception */
export type Wallet_Exception_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "wallet_exception" */
export enum Wallet_Exception_Select_Column {
  /** column name */
  ApprovedBy = 'approved_by',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  ExceptionAmount = 'exception_amount',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Notes = 'notes',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  State = 'state',
  /** column name */
  WalletId = 'wallet_id',
  /** column name */
  WorkflowId = 'workflow_id',
  /** column name */
  WorkflowRunId = 'workflow_run_id'
}

/** select "wallet_exception_aggregate_bool_exp_bool_and_arguments_columns" columns of table "wallet_exception" */
export enum Wallet_Exception_Select_Column_Wallet_Exception_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "wallet_exception_aggregate_bool_exp_bool_or_arguments_columns" columns of table "wallet_exception" */
export enum Wallet_Exception_Select_Column_Wallet_Exception_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "wallet_exception" */
export type Wallet_Exception_Set_Input = {
  approved_by?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  exception_amount?: InputMaybe<Scalars['numeric']['input']>;
  expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  wallet_id?: InputMaybe<Scalars['uuid']['input']>;
  workflow_id?: InputMaybe<Scalars['String']['input']>;
  workflow_run_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Wallet_Exception_Stddev_Fields = {
  __typename?: 'wallet_exception_stddev_fields';
  exception_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "wallet_exception" */
export type Wallet_Exception_Stddev_Order_By = {
  exception_amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Wallet_Exception_Stddev_Pop_Fields = {
  __typename?: 'wallet_exception_stddev_pop_fields';
  exception_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "wallet_exception" */
export type Wallet_Exception_Stddev_Pop_Order_By = {
  exception_amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Wallet_Exception_Stddev_Samp_Fields = {
  __typename?: 'wallet_exception_stddev_samp_fields';
  exception_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "wallet_exception" */
export type Wallet_Exception_Stddev_Samp_Order_By = {
  exception_amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "wallet_exception" */
export type Wallet_Exception_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Wallet_Exception_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Wallet_Exception_Stream_Cursor_Value_Input = {
  approved_by?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  exception_amount?: InputMaybe<Scalars['numeric']['input']>;
  expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamptz']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  wallet_id?: InputMaybe<Scalars['uuid']['input']>;
  workflow_id?: InputMaybe<Scalars['String']['input']>;
  workflow_run_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Wallet_Exception_Sum_Fields = {
  __typename?: 'wallet_exception_sum_fields';
  exception_amount?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "wallet_exception" */
export type Wallet_Exception_Sum_Order_By = {
  exception_amount?: InputMaybe<Order_By>;
};

/** update columns of table "wallet_exception" */
export enum Wallet_Exception_Update_Column {
  /** column name */
  ApprovedBy = 'approved_by',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  ExceptionAmount = 'exception_amount',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  Notes = 'notes',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  State = 'state',
  /** column name */
  WalletId = 'wallet_id',
  /** column name */
  WorkflowId = 'workflow_id',
  /** column name */
  WorkflowRunId = 'workflow_run_id'
}

export type Wallet_Exception_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Wallet_Exception_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Wallet_Exception_Set_Input>;
  /** filter the rows which have to be updated */
  where: Wallet_Exception_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Wallet_Exception_Var_Pop_Fields = {
  __typename?: 'wallet_exception_var_pop_fields';
  exception_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "wallet_exception" */
export type Wallet_Exception_Var_Pop_Order_By = {
  exception_amount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Wallet_Exception_Var_Samp_Fields = {
  __typename?: 'wallet_exception_var_samp_fields';
  exception_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "wallet_exception" */
export type Wallet_Exception_Var_Samp_Order_By = {
  exception_amount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Wallet_Exception_Variance_Fields = {
  __typename?: 'wallet_exception_variance_fields';
  exception_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "wallet_exception" */
export type Wallet_Exception_Variance_Order_By = {
  exception_amount?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "wallet" */
export type Wallet_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  blocked_amount?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "wallet" */
export type Wallet_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  blocked_amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  currency?: InputMaybe<Currency_Obj_Rel_Insert_Input>;
  currency_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  user_ledgers?: InputMaybe<User_Ledger_Arr_Rel_Insert_Input>;
  wallet_exceptions?: InputMaybe<Wallet_Exception_Arr_Rel_Insert_Input>;
  wallet_ledgers?: InputMaybe<Wallet_Ledger_Arr_Rel_Insert_Input>;
  wallet_transactions?: InputMaybe<Wallet_Transactions_Arr_Rel_Insert_Input>;
};

/** columns and relationships of "wallet_ledger" */
export type Wallet_Ledger = {
  __typename?: 'wallet_ledger';
  amount: Scalars['numeric']['output'];
  approved_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  approved_by_user?: Maybe<User>;
  created_at: Scalars['timestamp']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  currency: Currency;
  currency_id: Scalars['uuid']['output'];
  /** An object relationship */
  customer_asset?: Maybe<Customer_Asset>;
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified: Scalars['timestamp']['output'];
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  line_item_type: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  payment_type: Scalars['String']['output'];
  posting_date?: Maybe<Scalars['timestamp']['output']>;
  reference_id?: Maybe<Scalars['uuid']['output']>;
  reference_type?: Maybe<Scalars['String']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  wallet: Wallet;
  wallet_id: Scalars['uuid']['output'];
};

/** aggregated selection of "wallet_ledger" */
export type Wallet_Ledger_Aggregate = {
  __typename?: 'wallet_ledger_aggregate';
  aggregate?: Maybe<Wallet_Ledger_Aggregate_Fields>;
  nodes: Array<Wallet_Ledger>;
};

export type Wallet_Ledger_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Wallet_Ledger_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Wallet_Ledger_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Wallet_Ledger_Aggregate_Bool_Exp_Count>;
};

export type Wallet_Ledger_Aggregate_Bool_Exp_Bool_And = {
  arguments: Wallet_Ledger_Select_Column_Wallet_Ledger_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Wallet_Ledger_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Wallet_Ledger_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Wallet_Ledger_Select_Column_Wallet_Ledger_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Wallet_Ledger_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Wallet_Ledger_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Wallet_Ledger_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Wallet_Ledger_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "wallet_ledger" */
export type Wallet_Ledger_Aggregate_Fields = {
  __typename?: 'wallet_ledger_aggregate_fields';
  avg?: Maybe<Wallet_Ledger_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Wallet_Ledger_Max_Fields>;
  min?: Maybe<Wallet_Ledger_Min_Fields>;
  stddev?: Maybe<Wallet_Ledger_Stddev_Fields>;
  stddev_pop?: Maybe<Wallet_Ledger_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Wallet_Ledger_Stddev_Samp_Fields>;
  sum?: Maybe<Wallet_Ledger_Sum_Fields>;
  var_pop?: Maybe<Wallet_Ledger_Var_Pop_Fields>;
  var_samp?: Maybe<Wallet_Ledger_Var_Samp_Fields>;
  variance?: Maybe<Wallet_Ledger_Variance_Fields>;
};


/** aggregate fields of "wallet_ledger" */
export type Wallet_Ledger_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Wallet_Ledger_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "wallet_ledger" */
export type Wallet_Ledger_Aggregate_Order_By = {
  avg?: InputMaybe<Wallet_Ledger_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Wallet_Ledger_Max_Order_By>;
  min?: InputMaybe<Wallet_Ledger_Min_Order_By>;
  stddev?: InputMaybe<Wallet_Ledger_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Wallet_Ledger_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Wallet_Ledger_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Wallet_Ledger_Sum_Order_By>;
  var_pop?: InputMaybe<Wallet_Ledger_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Wallet_Ledger_Var_Samp_Order_By>;
  variance?: InputMaybe<Wallet_Ledger_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "wallet_ledger" */
export type Wallet_Ledger_Arr_Rel_Insert_Input = {
  data: Array<Wallet_Ledger_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Wallet_Ledger_On_Conflict>;
};

/** aggregate avg on columns */
export type Wallet_Ledger_Avg_Fields = {
  __typename?: 'wallet_ledger_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "wallet_ledger" */
export type Wallet_Ledger_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "wallet_ledger". All fields are combined with a logical 'AND'. */
export type Wallet_Ledger_Bool_Exp = {
  _and?: InputMaybe<Array<Wallet_Ledger_Bool_Exp>>;
  _not?: InputMaybe<Wallet_Ledger_Bool_Exp>;
  _or?: InputMaybe<Array<Wallet_Ledger_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  approved_by?: InputMaybe<Uuid_Comparison_Exp>;
  approved_by_user?: InputMaybe<User_Bool_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  currency?: InputMaybe<Currency_Bool_Exp>;
  currency_id?: InputMaybe<Uuid_Comparison_Exp>;
  customer_asset?: InputMaybe<Customer_Asset_Bool_Exp>;
  customer_asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  line_item_type?: InputMaybe<String_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  payment_type?: InputMaybe<String_Comparison_Exp>;
  posting_date?: InputMaybe<Timestamp_Comparison_Exp>;
  reference_id?: InputMaybe<Uuid_Comparison_Exp>;
  reference_type?: InputMaybe<String_Comparison_Exp>;
  session_id?: InputMaybe<String_Comparison_Exp>;
  wallet?: InputMaybe<Wallet_Bool_Exp>;
  wallet_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "wallet_ledger" */
export enum Wallet_Ledger_Constraint {
  /** unique or primary key constraint on columns "reference_id", "customer_asset_id" */
  WalletLedgerBlockTaskAssetSessionUnique = 'wallet_ledger_block_task_asset_session_unique',
  /** unique or primary key constraint on columns "reference_id" */
  WalletLedgerInvoicedItemUnique = 'wallet_ledger_invoiced_item_unique',
  /** unique or primary key constraint on columns "id" */
  WalletLedgerPkey = 'wallet_ledger_pkey'
}

/** input type for incrementing numeric columns in table "wallet_ledger" */
export type Wallet_Ledger_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "wallet_ledger" */
export type Wallet_Ledger_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  approved_by?: InputMaybe<Scalars['uuid']['input']>;
  approved_by_user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  currency?: InputMaybe<Currency_Obj_Rel_Insert_Input>;
  currency_id?: InputMaybe<Scalars['uuid']['input']>;
  customer_asset?: InputMaybe<Customer_Asset_Obj_Rel_Insert_Input>;
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  line_item_type?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  payment_type?: InputMaybe<Scalars['String']['input']>;
  posting_date?: InputMaybe<Scalars['timestamp']['input']>;
  reference_id?: InputMaybe<Scalars['uuid']['input']>;
  reference_type?: InputMaybe<Scalars['String']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  wallet?: InputMaybe<Wallet_Obj_Rel_Insert_Input>;
  wallet_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Wallet_Ledger_Max_Fields = {
  __typename?: 'wallet_ledger_max_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  approved_by?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  currency_id?: Maybe<Scalars['uuid']['output']>;
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  line_item_type?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  payment_type?: Maybe<Scalars['String']['output']>;
  posting_date?: Maybe<Scalars['timestamp']['output']>;
  reference_id?: Maybe<Scalars['uuid']['output']>;
  reference_type?: Maybe<Scalars['String']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  wallet_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "wallet_ledger" */
export type Wallet_Ledger_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  approved_by?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  currency_id?: InputMaybe<Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  line_item_type?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  payment_type?: InputMaybe<Order_By>;
  posting_date?: InputMaybe<Order_By>;
  reference_id?: InputMaybe<Order_By>;
  reference_type?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  wallet_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Wallet_Ledger_Min_Fields = {
  __typename?: 'wallet_ledger_min_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  approved_by?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  currency_id?: Maybe<Scalars['uuid']['output']>;
  customer_asset_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  line_item_type?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  payment_type?: Maybe<Scalars['String']['output']>;
  posting_date?: Maybe<Scalars['timestamp']['output']>;
  reference_id?: Maybe<Scalars['uuid']['output']>;
  reference_type?: Maybe<Scalars['String']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  wallet_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "wallet_ledger" */
export type Wallet_Ledger_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  approved_by?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  currency_id?: InputMaybe<Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  line_item_type?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  payment_type?: InputMaybe<Order_By>;
  posting_date?: InputMaybe<Order_By>;
  reference_id?: InputMaybe<Order_By>;
  reference_type?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  wallet_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "wallet_ledger" */
export type Wallet_Ledger_Mutation_Response = {
  __typename?: 'wallet_ledger_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Wallet_Ledger>;
};

/** on_conflict condition type for table "wallet_ledger" */
export type Wallet_Ledger_On_Conflict = {
  constraint: Wallet_Ledger_Constraint;
  update_columns?: Array<Wallet_Ledger_Update_Column>;
  where?: InputMaybe<Wallet_Ledger_Bool_Exp>;
};

/** Ordering options when selecting data from "wallet_ledger". */
export type Wallet_Ledger_Order_By = {
  amount?: InputMaybe<Order_By>;
  approved_by?: InputMaybe<Order_By>;
  approved_by_user?: InputMaybe<User_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  currency?: InputMaybe<Currency_Order_By>;
  currency_id?: InputMaybe<Order_By>;
  customer_asset?: InputMaybe<Customer_Asset_Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  line_item_type?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  payment_type?: InputMaybe<Order_By>;
  posting_date?: InputMaybe<Order_By>;
  reference_id?: InputMaybe<Order_By>;
  reference_type?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  wallet?: InputMaybe<Wallet_Order_By>;
  wallet_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: wallet_ledger */
export type Wallet_Ledger_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "wallet_ledger" */
export enum Wallet_Ledger_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  ApprovedBy = 'approved_by',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  CustomerAssetId = 'customer_asset_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  LineItemType = 'line_item_type',
  /** column name */
  Notes = 'notes',
  /** column name */
  PaymentType = 'payment_type',
  /** column name */
  PostingDate = 'posting_date',
  /** column name */
  ReferenceId = 'reference_id',
  /** column name */
  ReferenceType = 'reference_type',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  WalletId = 'wallet_id'
}

/** select "wallet_ledger_aggregate_bool_exp_bool_and_arguments_columns" columns of table "wallet_ledger" */
export enum Wallet_Ledger_Select_Column_Wallet_Ledger_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "wallet_ledger_aggregate_bool_exp_bool_or_arguments_columns" columns of table "wallet_ledger" */
export enum Wallet_Ledger_Select_Column_Wallet_Ledger_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "wallet_ledger" */
export type Wallet_Ledger_Set_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  approved_by?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  currency_id?: InputMaybe<Scalars['uuid']['input']>;
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  line_item_type?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  payment_type?: InputMaybe<Scalars['String']['input']>;
  posting_date?: InputMaybe<Scalars['timestamp']['input']>;
  reference_id?: InputMaybe<Scalars['uuid']['input']>;
  reference_type?: InputMaybe<Scalars['String']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  wallet_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Wallet_Ledger_Stddev_Fields = {
  __typename?: 'wallet_ledger_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "wallet_ledger" */
export type Wallet_Ledger_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Wallet_Ledger_Stddev_Pop_Fields = {
  __typename?: 'wallet_ledger_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "wallet_ledger" */
export type Wallet_Ledger_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Wallet_Ledger_Stddev_Samp_Fields = {
  __typename?: 'wallet_ledger_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "wallet_ledger" */
export type Wallet_Ledger_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "wallet_ledger" */
export type Wallet_Ledger_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Wallet_Ledger_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Wallet_Ledger_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  approved_by?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  currency_id?: InputMaybe<Scalars['uuid']['input']>;
  customer_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  line_item_type?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  payment_type?: InputMaybe<Scalars['String']['input']>;
  posting_date?: InputMaybe<Scalars['timestamp']['input']>;
  reference_id?: InputMaybe<Scalars['uuid']['input']>;
  reference_type?: InputMaybe<Scalars['String']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  wallet_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Wallet_Ledger_Sum_Fields = {
  __typename?: 'wallet_ledger_sum_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "wallet_ledger" */
export type Wallet_Ledger_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** update columns of table "wallet_ledger" */
export enum Wallet_Ledger_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  ApprovedBy = 'approved_by',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  CustomerAssetId = 'customer_asset_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  LineItemType = 'line_item_type',
  /** column name */
  Notes = 'notes',
  /** column name */
  PaymentType = 'payment_type',
  /** column name */
  PostingDate = 'posting_date',
  /** column name */
  ReferenceId = 'reference_id',
  /** column name */
  ReferenceType = 'reference_type',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  WalletId = 'wallet_id'
}

export type Wallet_Ledger_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Wallet_Ledger_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Wallet_Ledger_Set_Input>;
  /** filter the rows which have to be updated */
  where: Wallet_Ledger_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Wallet_Ledger_Var_Pop_Fields = {
  __typename?: 'wallet_ledger_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "wallet_ledger" */
export type Wallet_Ledger_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Wallet_Ledger_Var_Samp_Fields = {
  __typename?: 'wallet_ledger_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "wallet_ledger" */
export type Wallet_Ledger_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Wallet_Ledger_Variance_Fields = {
  __typename?: 'wallet_ledger_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "wallet_ledger" */
export type Wallet_Ledger_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Wallet_Max_Fields = {
  __typename?: 'wallet_max_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  blocked_amount?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  currency_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "wallet" */
export type Wallet_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  blocked_amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Wallet_Min_Fields = {
  __typename?: 'wallet_min_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  blocked_amount?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  currency_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  organization_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "wallet" */
export type Wallet_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  blocked_amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "wallet" */
export type Wallet_Mutation_Response = {
  __typename?: 'wallet_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Wallet>;
};

/** input type for inserting object relation for remote table "wallet" */
export type Wallet_Obj_Rel_Insert_Input = {
  data: Wallet_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Wallet_On_Conflict>;
};

/** on_conflict condition type for table "wallet" */
export type Wallet_On_Conflict = {
  constraint: Wallet_Constraint;
  update_columns?: Array<Wallet_Update_Column>;
  where?: InputMaybe<Wallet_Bool_Exp>;
};

/** Ordering options when selecting data from "wallet". */
export type Wallet_Order_By = {
  amount?: InputMaybe<Order_By>;
  blocked_amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Currency_Order_By>;
  currency_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  user_ledgers_aggregate?: InputMaybe<User_Ledger_Aggregate_Order_By>;
  wallet_exceptions_aggregate?: InputMaybe<Wallet_Exception_Aggregate_Order_By>;
  wallet_ledgers_aggregate?: InputMaybe<Wallet_Ledger_Aggregate_Order_By>;
  wallet_transactions_aggregate?: InputMaybe<Wallet_Transactions_Aggregate_Order_By>;
};

/** primary key columns input for table: wallet */
export type Wallet_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "wallet" */
export enum Wallet_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  BlockedAmount = 'blocked_amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrganizationId = 'organization_id'
}

/** select "wallet_aggregate_bool_exp_bool_and_arguments_columns" columns of table "wallet" */
export enum Wallet_Select_Column_Wallet_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "wallet_aggregate_bool_exp_bool_or_arguments_columns" columns of table "wallet" */
export enum Wallet_Select_Column_Wallet_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "wallet" */
export type Wallet_Set_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  blocked_amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  currency_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "wallet_state" */
export type Wallet_State = {
  __typename?: 'wallet_state';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
  /** An array relationship */
  wallet_transactions: Array<Wallet_Transactions>;
  /** An aggregate relationship */
  wallet_transactions_aggregate: Wallet_Transactions_Aggregate;
};


/** columns and relationships of "wallet_state" */
export type Wallet_StateWallet_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Transactions_Order_By>>;
  where?: InputMaybe<Wallet_Transactions_Bool_Exp>;
};


/** columns and relationships of "wallet_state" */
export type Wallet_StateWallet_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wallet_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wallet_Transactions_Order_By>>;
  where?: InputMaybe<Wallet_Transactions_Bool_Exp>;
};

/** aggregated selection of "wallet_state" */
export type Wallet_State_Aggregate = {
  __typename?: 'wallet_state_aggregate';
  aggregate?: Maybe<Wallet_State_Aggregate_Fields>;
  nodes: Array<Wallet_State>;
};

/** aggregate fields of "wallet_state" */
export type Wallet_State_Aggregate_Fields = {
  __typename?: 'wallet_state_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Wallet_State_Max_Fields>;
  min?: Maybe<Wallet_State_Min_Fields>;
};


/** aggregate fields of "wallet_state" */
export type Wallet_State_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Wallet_State_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "wallet_state". All fields are combined with a logical 'AND'. */
export type Wallet_State_Bool_Exp = {
  _and?: InputMaybe<Array<Wallet_State_Bool_Exp>>;
  _not?: InputMaybe<Wallet_State_Bool_Exp>;
  _or?: InputMaybe<Array<Wallet_State_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
  wallet_transactions?: InputMaybe<Wallet_Transactions_Bool_Exp>;
  wallet_transactions_aggregate?: InputMaybe<Wallet_Transactions_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "wallet_state" */
export enum Wallet_State_Constraint {
  /** unique or primary key constraint on columns "value" */
  WalletStatePkey = 'wallet_state_pkey'
}

export enum Wallet_State_Enum {
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** PAID */
  Paid = 'PAID',
  /** PENDING */
  Pending = 'PENDING'
}

/** Boolean expression to compare columns of type "wallet_state_enum". All fields are combined with logical 'AND'. */
export type Wallet_State_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Wallet_State_Enum>;
  _in?: InputMaybe<Array<Wallet_State_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Wallet_State_Enum>;
  _nin?: InputMaybe<Array<Wallet_State_Enum>>;
};

/** input type for inserting data into table "wallet_state" */
export type Wallet_State_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  wallet_transactions?: InputMaybe<Wallet_Transactions_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Wallet_State_Max_Fields = {
  __typename?: 'wallet_state_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Wallet_State_Min_Fields = {
  __typename?: 'wallet_state_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "wallet_state" */
export type Wallet_State_Mutation_Response = {
  __typename?: 'wallet_state_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Wallet_State>;
};

/** input type for inserting object relation for remote table "wallet_state" */
export type Wallet_State_Obj_Rel_Insert_Input = {
  data: Wallet_State_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Wallet_State_On_Conflict>;
};

/** on_conflict condition type for table "wallet_state" */
export type Wallet_State_On_Conflict = {
  constraint: Wallet_State_Constraint;
  update_columns?: Array<Wallet_State_Update_Column>;
  where?: InputMaybe<Wallet_State_Bool_Exp>;
};

/** Ordering options when selecting data from "wallet_state". */
export type Wallet_State_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  wallet_transactions_aggregate?: InputMaybe<Wallet_Transactions_Aggregate_Order_By>;
};

/** primary key columns input for table: wallet_state */
export type Wallet_State_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "wallet_state" */
export enum Wallet_State_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "wallet_state" */
export type Wallet_State_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "wallet_state" */
export type Wallet_State_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Wallet_State_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Wallet_State_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "wallet_state" */
export enum Wallet_State_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Wallet_State_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Wallet_State_Set_Input>;
  /** filter the rows which have to be updated */
  where: Wallet_State_Bool_Exp;
};

/** aggregate stddev on columns */
export type Wallet_Stddev_Fields = {
  __typename?: 'wallet_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  blocked_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "wallet" */
export type Wallet_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  blocked_amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Wallet_Stddev_Pop_Fields = {
  __typename?: 'wallet_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  blocked_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "wallet" */
export type Wallet_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  blocked_amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Wallet_Stddev_Samp_Fields = {
  __typename?: 'wallet_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  blocked_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "wallet" */
export type Wallet_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  blocked_amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "wallet" */
export type Wallet_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Wallet_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Wallet_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  blocked_amount?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  currency_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Wallet_Sum_Fields = {
  __typename?: 'wallet_sum_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  blocked_amount?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "wallet" */
export type Wallet_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  blocked_amount?: InputMaybe<Order_By>;
};

/** columns and relationships of "wallet_transactions" */
export type Wallet_Transactions = {
  __typename?: 'wallet_transactions';
  amount?: Maybe<Scalars['numeric']['output']>;
  client_secret?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  currency?: Maybe<Currency>;
  currency_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  organization_user: Organization_User;
  organization_user_id: Scalars['uuid']['output'];
  state: Wallet_State_Enum;
  transaction_id?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  user_ledgers: Array<User_Ledger>;
  /** An aggregate relationship */
  user_ledgers_aggregate: User_Ledger_Aggregate;
  /** An object relationship */
  wallet: Wallet;
  wallet_id: Scalars['uuid']['output'];
  /** An object relationship */
  wallet_state: Wallet_State;
};


/** columns and relationships of "wallet_transactions" */
export type Wallet_TransactionsUser_LedgersArgs = {
  distinct_on?: InputMaybe<Array<User_Ledger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Ledger_Order_By>>;
  where?: InputMaybe<User_Ledger_Bool_Exp>;
};


/** columns and relationships of "wallet_transactions" */
export type Wallet_TransactionsUser_Ledgers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Ledger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Ledger_Order_By>>;
  where?: InputMaybe<User_Ledger_Bool_Exp>;
};

/** aggregated selection of "wallet_transactions" */
export type Wallet_Transactions_Aggregate = {
  __typename?: 'wallet_transactions_aggregate';
  aggregate?: Maybe<Wallet_Transactions_Aggregate_Fields>;
  nodes: Array<Wallet_Transactions>;
};

export type Wallet_Transactions_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Wallet_Transactions_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Wallet_Transactions_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Wallet_Transactions_Aggregate_Bool_Exp_Count>;
};

export type Wallet_Transactions_Aggregate_Bool_Exp_Bool_And = {
  arguments: Wallet_Transactions_Select_Column_Wallet_Transactions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Wallet_Transactions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Wallet_Transactions_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Wallet_Transactions_Select_Column_Wallet_Transactions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Wallet_Transactions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Wallet_Transactions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Wallet_Transactions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Wallet_Transactions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "wallet_transactions" */
export type Wallet_Transactions_Aggregate_Fields = {
  __typename?: 'wallet_transactions_aggregate_fields';
  avg?: Maybe<Wallet_Transactions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Wallet_Transactions_Max_Fields>;
  min?: Maybe<Wallet_Transactions_Min_Fields>;
  stddev?: Maybe<Wallet_Transactions_Stddev_Fields>;
  stddev_pop?: Maybe<Wallet_Transactions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Wallet_Transactions_Stddev_Samp_Fields>;
  sum?: Maybe<Wallet_Transactions_Sum_Fields>;
  var_pop?: Maybe<Wallet_Transactions_Var_Pop_Fields>;
  var_samp?: Maybe<Wallet_Transactions_Var_Samp_Fields>;
  variance?: Maybe<Wallet_Transactions_Variance_Fields>;
};


/** aggregate fields of "wallet_transactions" */
export type Wallet_Transactions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Wallet_Transactions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "wallet_transactions" */
export type Wallet_Transactions_Aggregate_Order_By = {
  avg?: InputMaybe<Wallet_Transactions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Wallet_Transactions_Max_Order_By>;
  min?: InputMaybe<Wallet_Transactions_Min_Order_By>;
  stddev?: InputMaybe<Wallet_Transactions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Wallet_Transactions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Wallet_Transactions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Wallet_Transactions_Sum_Order_By>;
  var_pop?: InputMaybe<Wallet_Transactions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Wallet_Transactions_Var_Samp_Order_By>;
  variance?: InputMaybe<Wallet_Transactions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "wallet_transactions" */
export type Wallet_Transactions_Arr_Rel_Insert_Input = {
  data: Array<Wallet_Transactions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Wallet_Transactions_On_Conflict>;
};

/** aggregate avg on columns */
export type Wallet_Transactions_Avg_Fields = {
  __typename?: 'wallet_transactions_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "wallet_transactions" */
export type Wallet_Transactions_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "wallet_transactions". All fields are combined with a logical 'AND'. */
export type Wallet_Transactions_Bool_Exp = {
  _and?: InputMaybe<Array<Wallet_Transactions_Bool_Exp>>;
  _not?: InputMaybe<Wallet_Transactions_Bool_Exp>;
  _or?: InputMaybe<Array<Wallet_Transactions_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  client_secret?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  currency?: InputMaybe<Currency_Bool_Exp>;
  currency_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  last_modified_by?: InputMaybe<Uuid_Comparison_Exp>;
  organization_user?: InputMaybe<Organization_User_Bool_Exp>;
  organization_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  state?: InputMaybe<Wallet_State_Enum_Comparison_Exp>;
  transaction_id?: InputMaybe<String_Comparison_Exp>;
  user_ledgers?: InputMaybe<User_Ledger_Bool_Exp>;
  user_ledgers_aggregate?: InputMaybe<User_Ledger_Aggregate_Bool_Exp>;
  wallet?: InputMaybe<Wallet_Bool_Exp>;
  wallet_id?: InputMaybe<Uuid_Comparison_Exp>;
  wallet_state?: InputMaybe<Wallet_State_Bool_Exp>;
};

/** unique or primary key constraints on table "wallet_transactions" */
export enum Wallet_Transactions_Constraint {
  /** unique or primary key constraint on columns "id" */
  WalletTransactionsPkey = 'wallet_transactions_pkey'
}

/** input type for incrementing numeric columns in table "wallet_transactions" */
export type Wallet_Transactions_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "wallet_transactions" */
export type Wallet_Transactions_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  client_secret?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  currency?: InputMaybe<Currency_Obj_Rel_Insert_Input>;
  currency_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_user?: InputMaybe<Organization_User_Obj_Rel_Insert_Input>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Wallet_State_Enum>;
  transaction_id?: InputMaybe<Scalars['String']['input']>;
  user_ledgers?: InputMaybe<User_Ledger_Arr_Rel_Insert_Input>;
  wallet?: InputMaybe<Wallet_Obj_Rel_Insert_Input>;
  wallet_id?: InputMaybe<Scalars['uuid']['input']>;
  wallet_state?: InputMaybe<Wallet_State_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Wallet_Transactions_Max_Fields = {
  __typename?: 'wallet_transactions_max_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  client_secret?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  currency_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  organization_user_id?: Maybe<Scalars['uuid']['output']>;
  transaction_id?: Maybe<Scalars['String']['output']>;
  wallet_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "wallet_transactions" */
export type Wallet_Transactions_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  client_secret?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  wallet_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Wallet_Transactions_Min_Fields = {
  __typename?: 'wallet_transactions_min_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  client_secret?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  currency_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_modified?: Maybe<Scalars['timestamp']['output']>;
  last_modified_by?: Maybe<Scalars['uuid']['output']>;
  organization_user_id?: Maybe<Scalars['uuid']['output']>;
  transaction_id?: Maybe<Scalars['String']['output']>;
  wallet_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "wallet_transactions" */
export type Wallet_Transactions_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  client_secret?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  wallet_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "wallet_transactions" */
export type Wallet_Transactions_Mutation_Response = {
  __typename?: 'wallet_transactions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Wallet_Transactions>;
};

/** input type for inserting object relation for remote table "wallet_transactions" */
export type Wallet_Transactions_Obj_Rel_Insert_Input = {
  data: Wallet_Transactions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Wallet_Transactions_On_Conflict>;
};

/** on_conflict condition type for table "wallet_transactions" */
export type Wallet_Transactions_On_Conflict = {
  constraint: Wallet_Transactions_Constraint;
  update_columns?: Array<Wallet_Transactions_Update_Column>;
  where?: InputMaybe<Wallet_Transactions_Bool_Exp>;
};

/** Ordering options when selecting data from "wallet_transactions". */
export type Wallet_Transactions_Order_By = {
  amount?: InputMaybe<Order_By>;
  client_secret?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Currency_Order_By>;
  currency_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  last_modified_by?: InputMaybe<Order_By>;
  organization_user?: InputMaybe<Organization_User_Order_By>;
  organization_user_id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  user_ledgers_aggregate?: InputMaybe<User_Ledger_Aggregate_Order_By>;
  wallet?: InputMaybe<Wallet_Order_By>;
  wallet_id?: InputMaybe<Order_By>;
  wallet_state?: InputMaybe<Wallet_State_Order_By>;
};

/** primary key columns input for table: wallet_transactions */
export type Wallet_Transactions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "wallet_transactions" */
export enum Wallet_Transactions_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  ClientSecret = 'client_secret',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrganizationUserId = 'organization_user_id',
  /** column name */
  State = 'state',
  /** column name */
  TransactionId = 'transaction_id',
  /** column name */
  WalletId = 'wallet_id'
}

/** select "wallet_transactions_aggregate_bool_exp_bool_and_arguments_columns" columns of table "wallet_transactions" */
export enum Wallet_Transactions_Select_Column_Wallet_Transactions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "wallet_transactions_aggregate_bool_exp_bool_or_arguments_columns" columns of table "wallet_transactions" */
export enum Wallet_Transactions_Select_Column_Wallet_Transactions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "wallet_transactions" */
export type Wallet_Transactions_Set_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  client_secret?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  currency_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Wallet_State_Enum>;
  transaction_id?: InputMaybe<Scalars['String']['input']>;
  wallet_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Wallet_Transactions_Stddev_Fields = {
  __typename?: 'wallet_transactions_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "wallet_transactions" */
export type Wallet_Transactions_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Wallet_Transactions_Stddev_Pop_Fields = {
  __typename?: 'wallet_transactions_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "wallet_transactions" */
export type Wallet_Transactions_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Wallet_Transactions_Stddev_Samp_Fields = {
  __typename?: 'wallet_transactions_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "wallet_transactions" */
export type Wallet_Transactions_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "wallet_transactions" */
export type Wallet_Transactions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Wallet_Transactions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Wallet_Transactions_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  client_secret?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  currency_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['timestamp']['input']>;
  last_modified_by?: InputMaybe<Scalars['uuid']['input']>;
  organization_user_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Wallet_State_Enum>;
  transaction_id?: InputMaybe<Scalars['String']['input']>;
  wallet_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Wallet_Transactions_Sum_Fields = {
  __typename?: 'wallet_transactions_sum_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "wallet_transactions" */
export type Wallet_Transactions_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** update columns of table "wallet_transactions" */
export enum Wallet_Transactions_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  ClientSecret = 'client_secret',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrganizationUserId = 'organization_user_id',
  /** column name */
  State = 'state',
  /** column name */
  TransactionId = 'transaction_id',
  /** column name */
  WalletId = 'wallet_id'
}

export type Wallet_Transactions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Wallet_Transactions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Wallet_Transactions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Wallet_Transactions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Wallet_Transactions_Var_Pop_Fields = {
  __typename?: 'wallet_transactions_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "wallet_transactions" */
export type Wallet_Transactions_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Wallet_Transactions_Var_Samp_Fields = {
  __typename?: 'wallet_transactions_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "wallet_transactions" */
export type Wallet_Transactions_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Wallet_Transactions_Variance_Fields = {
  __typename?: 'wallet_transactions_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "wallet_transactions" */
export type Wallet_Transactions_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** update columns of table "wallet" */
export enum Wallet_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  BlockedAmount = 'blocked_amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LastModifiedBy = 'last_modified_by',
  /** column name */
  OrganizationId = 'organization_id'
}

export type Wallet_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Wallet_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Wallet_Set_Input>;
  /** filter the rows which have to be updated */
  where: Wallet_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Wallet_Var_Pop_Fields = {
  __typename?: 'wallet_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  blocked_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "wallet" */
export type Wallet_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  blocked_amount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Wallet_Var_Samp_Fields = {
  __typename?: 'wallet_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  blocked_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "wallet" */
export type Wallet_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  blocked_amount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Wallet_Variance_Fields = {
  __typename?: 'wallet_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  blocked_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "wallet" */
export type Wallet_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  blocked_amount?: InputMaybe<Order_By>;
};

export type AddCustomerItemSaftyCheckListResultsMutationVariables = Exact<{
  objects: Array<Customer_Order_Item_Safety_Checklist_Results_Insert_Input> | Customer_Order_Item_Safety_Checklist_Results_Insert_Input;
}>;


export type AddCustomerItemSaftyCheckListResultsMutation = { __typename?: 'mutation_root', insert_customer_order_item_safety_checklist_results?: { __typename?: 'customer_order_item_safety_checklist_results_mutation_response', returning: Array<{ __typename?: 'customer_order_item_safety_checklist_results', customer_order_item_id: any, id: any, is_active: boolean, key?: string | null, safety_checklist_id: any, value?: string | null }> } | null };

export type AddMissingCustomerOrderCustomerAssetMutationVariables = Exact<{
  object?: InputMaybe<AddMissingCustomerOrderCustomerAssetInput>;
}>;


export type AddMissingCustomerOrderCustomerAssetMutation = { __typename?: 'mutation_root', addMissingCustomerOrderCustomerAsset?: { __typename?: 'addMissingCustomerOrderCustomerAssetOutput', error?: string | null, message?: string | null } | null };

export type AddTaskCancellationReasonMutationVariables = Exact<{
  object: Task_Cancellation_Reasons_Insert_Input;
}>;


export type AddTaskCancellationReasonMutation = { __typename?: 'mutation_root', insert_task_cancellation_reasons_one?: { __typename?: 'task_cancellation_reasons', id: any, is_active: boolean, task_id: any, reason?: string | null } | null };

export type CreateDeliveryInvoiceMutationVariables = Exact<{
  object: CreateDeliveryInvoiceInput;
}>;


export type CreateDeliveryInvoiceMutation = { __typename?: 'mutation_root', createDeliveryInvoice?: { __typename?: 'createDeliveryInvoiceOutput', code?: string | null, data?: any | null, error?: string | null, message?: string | null } | null };

export type CreateInvoicedItemForAssetMutationVariables = Exact<{
  object: CreateInvoicedItemForAssetInput;
}>;


export type CreateInvoicedItemForAssetMutation = { __typename?: 'mutation_root', createInvoicedItemForAsset?: { __typename?: 'CreateInvoicedItemForAssetOutput', code?: number | null, message?: string | null, error?: string | null } | null };

export type CreateTaskValueMutationVariables = Exact<{
  object: CreateTaskValueInput;
}>;


export type CreateTaskValueMutation = { __typename?: 'mutation_root', createTaskValue?: { __typename?: 'createTaskValueOuput', data?: any | null, code?: string | null, error?: string | null, message?: string | null } | null };

export type DisableTaskValuesByAssetIdMutationVariables = Exact<{
  task_id: Scalars['uuid']['input'];
  customer_asset_id: Scalars['uuid']['input'];
}>;


export type DisableTaskValuesByAssetIdMutation = { __typename?: 'mutation_root', update_task_value?: { __typename?: 'task_value_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'task_value', id: any }> } | null };

export type DriverCheckInMutationVariables = Exact<{
  object: Driver_Duty_Log_Insert_Input;
}>;


export type DriverCheckInMutation = { __typename?: 'mutation_root', insert_driver_duty_log_one?: { __typename?: 'driver_duty_log', id: any, is_active: boolean, location?: any | null, loginTime?: any | null, name: string, odometer: string, category: Login_Type_Enum, totallizer: string, driver_vehicle_id?: any | null, driver_duty_photos: Array<{ __typename?: 'driver_duty_photos', id: any, is_active: boolean, driver_duty_log_id: any, category: Photo_Type_Enum, url: string }> } | null };

export type GetLatestTaskValueMutationVariables = Exact<{
  task_id: Scalars['uuid']['input'];
  asset_id: Scalars['uuid']['input'];
}>;


export type GetLatestTaskValueMutation = { __typename?: 'mutation_root', getLatestTaskValue?: { __typename?: 'getLatestTaskValueOutput', message?: string | null, error?: string | null, data?: any | null } | null };

export type InsertTicketMutationVariables = Exact<{
  object: Tickets_Insert_Input;
}>;


export type InsertTicketMutation = { __typename?: 'mutation_root', insert_tickets_one?: { __typename?: 'tickets', id: any, customer_order_id?: any | null, state: Ticket_State_Enum, is_active: boolean, created_by: any } | null };

export type UpdateDriverVehicleStateByIdMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  state?: InputMaybe<Login_Type_Enum>;
  status?: InputMaybe<Partner_Vehicle_State_Enum>;
}>;


export type UpdateDriverVehicleStateByIdMutation = { __typename?: 'mutation_root', update_driver_vehicle_by_pk?: { __typename?: 'driver_vehicle', status?: Partner_Vehicle_State_Enum | null, id: any, driver_id: any, state?: Login_Type_Enum | null, vehicle_id: any } | null };

export type UpdateTaskStateMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  state?: InputMaybe<Task_State_Enum>;
}>;


export type UpdateTaskStateMutation = { __typename?: 'mutation_root', update_task_by_pk?: { __typename?: 'task', id: any } | null };

export type FetchFileUrlFromServerQueryVariables = Exact<{
  file: FileInput;
}>;


export type FetchFileUrlFromServerQuery = { __typename?: 'query_root', fetchFile?: { __typename?: 'FileOutput', url: string } | null };

export type UploadFileToBucketMutationVariables = Exact<{
  file: StorageInput;
}>;


export type UploadFileToBucketMutation = { __typename?: 'mutation_root', uploadFile?: { __typename?: 'StorageOutput', contentType?: string | null, signedUrl?: string | null, storeUrl?: string | null } | null };

export type GetCustomerAssetsByOrderIdQueryVariables = Exact<{
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
  searchKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCustomerAssetsByOrderIdQuery = { __typename?: 'query_root', customer_order_customer_asset: Array<{ __typename?: 'customer_order_customer_asset', quantity_dispensed?: any | null, is_active: boolean, quantity_requested?: any | null, customer_asset: { __typename?: 'customer_asset', is_collect_odometer_reading: boolean, tag_id?: string | null, capacity?: string | null, color?: string | null, id: any, description?: string | null, name: string, registration_number?: string | null, make?: string | null, modal?: string | null, organization_user_id?: any | null, asset_type: { __typename?: 'asset_type', name?: string | null } } }> };

export type GetCustomerOrganizationConfigurationQueryVariables = Exact<{
  organization_id: Scalars['uuid']['input'];
}>;


export type GetCustomerOrganizationConfigurationQuery = { __typename?: 'query_root', organization_configuration: Array<{ __typename?: 'organization_configuration', key: string, value?: string | null }> };

export type GetDispensingOrderByAssetIdQueryVariables = Exact<{
  assetId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetDispensingOrderByAssetIdQuery = { __typename?: 'query_root', task: Array<{ __typename?: 'task', id: any, customer_order?: { __typename?: 'customer_order', id: any, organization_user?: { __typename?: 'organization_user', customer_assets: Array<{ __typename?: 'customer_asset', id: any }> } | null } | null }> };

export type GetOdometerMissReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOdometerMissReasonsQuery = { __typename?: 'query_root', reasons: Array<{ __typename?: 'reasons', id: any, reason?: string | null }> };

export type GetSafetyChecklistQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSafetyChecklistQuery = { __typename?: 'query_root', safety_checklist: Array<{ __typename?: 'safety_checklist', id: any, slug?: string | null, name: string, is_active: boolean }> };

export type GetShiftScheduleQueryVariables = Exact<{
  dateTime?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type GetShiftScheduleQuery = { __typename?: 'query_root', shift_schedule: Array<{ __typename?: 'shift_schedule', driver_vehicle_id?: any | null, vehicle_id?: any | null, end_time: any, id: any, start_time: any, vehicle?: { __typename?: 'vehicle', id: any, registration_number?: string | null, description?: string | null, vehicle_configurations: Array<{ __typename?: 'vehicle_configuration', id: any, key?: string | null, value?: string | null, is_active?: boolean | null }> } | null, driver_vehicle?: { __typename?: 'driver_vehicle', id: any, status?: Partner_Vehicle_State_Enum | null, state?: Login_Type_Enum | null, user: { __typename?: 'user', id: any, first_name?: string | null, middle_name?: string | null, last_name?: string | null, code?: any | null }, vehicle: { __typename?: 'vehicle', id: any, registration_number?: string | null, description?: string | null, vehicle_configurations: Array<{ __typename?: 'vehicle_configuration', id: any, key?: string | null, value?: string | null, is_active?: boolean | null }> } } | null }> };

export type GetTasksQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Task_Bool_Exp>;
}>;


export type GetTasksQuery = { __typename?: 'query_root', task: Array<{ __typename?: 'task', state?: Task_State_Enum | null, category: Task_Type_Enum, driver_vehicle_id?: any | null, driver_id?: any | null, vehicle_id?: any | null, is_done_locally?: boolean | null, is_enable_rfid_flow: boolean, id: any, customer_order?: { __typename?: 'customer_order', is_receipt_required: boolean, order_code: any, is_otp_required: boolean, instruction?: string | null, delivery_fee?: any | null, delivery_preference?: Delivery_Preferences_Enum | null, id: any, order_date?: any | null, name: string, is_prepaid: boolean, is_active: boolean, organization_user_id?: any | null, organization_user?: { __typename?: 'organization_user', id: any, organization_id: any, user: { __typename?: 'user', id: any, middle_name?: string | null, first_name?: string | null, last_name?: string | null } } | null, customer_order_items: Array<{ __typename?: 'customer_order_item', actual_delivery_date?: any | null, actual_qty: any, id: any, estimate_delivery_date?: any | null, qty: any, state?: Customer_Order_Item_State_Enum | null, product_variation_id: any, discount_rate?: any | null, discount_type?: Discount_Type_Enum | null, product_variation_partner_localities_slot_id?: any | null, product_variation: { __typename?: 'product_variation', id: any, is_active: boolean, product: { __typename?: 'product', id: any, is_active: boolean, name: string } }, customer_order_item_safety_checklist_results: Array<{ __typename?: 'customer_order_item_safety_checklist_results', id: any }> }>, product_variation_partner_localities_slot?: { __typename?: 'product_variation_partner_localities_slots', start_time: any, end_time: any, day_date: any } | null, customer_order_slot?: { __typename?: 'customer_order_slots', start_time: any, end_time: any } | null } | null, organization_address?: { __typename?: 'organization_address', name: string, instruction?: string | null, location?: any | null, area?: any | null, address_line1?: string | null, address_line2?: string | null, pincode?: string | null, city_id?: any | null, state?: { __typename?: 'state', name?: string | null } | null, country?: { __typename?: 'country', id: any, name?: string | null, numeric_code_id?: number | null, official_state?: string | null } | null } | null, task_values: Array<{ __typename?: 'task_value', customer_asset_id?: any | null, id: any, key: string, quantity_dispensed?: any | null, value: string, url?: string | null, session_id?: string | null }> }> };

export type GetUserQueryVariables = Exact<{
  firebaseID?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUserQuery = { __typename?: 'query_root', user: Array<{ __typename?: 'user', id: any, first_name?: string | null, last_name?: string | null, email?: string | null, erp_code?: string | null, profile_pic?: string | null }> };

export type SearchCustomerAssetByIdQueryVariables = Exact<{
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
  asset_id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type SearchCustomerAssetByIdQuery = { __typename?: 'query_root', customer_order_customer_asset: Array<{ __typename?: 'customer_order_customer_asset', quantity_dispensed?: any | null, is_active: boolean, quantity_requested?: any | null, customer_asset: { __typename?: 'customer_asset', is_collect_odometer_reading: boolean, tag_id?: string | null, capacity?: string | null, color?: string | null, id: any, description?: string | null, name: string, registration_number?: string | null, make?: string | null, modal?: string | null, organization_user_id?: any | null, asset_type: { __typename?: 'asset_type', name?: string | null } } }> };

export type SearchCustomerAssetsPaginatedQueryVariables = Exact<{
  customer_order_id: Scalars['uuid']['input'];
  searchKey: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchCustomerAssetsPaginatedQuery = { __typename?: 'query_root', customer_order_customer_asset_aggregate: { __typename?: 'customer_order_customer_asset_aggregate', aggregate?: { __typename?: 'customer_order_customer_asset_aggregate_fields', count: number } | null }, customer_order_customer_asset: Array<{ __typename?: 'customer_order_customer_asset', quantity_dispensed?: any | null, is_active: boolean, quantity_requested?: any | null, customer_asset: { __typename?: 'customer_asset', is_collect_odometer_reading: boolean, tag_id?: string | null, capacity?: string | null, color?: string | null, id: any, description?: string | null, name: string, registration_number?: string | null, make?: string | null, modal?: string | null, organization_user_id?: any | null, asset_type: { __typename?: 'asset_type', name?: string | null } } }> };


export const AddCustomerItemSaftyCheckListResultsDocument = gql`
    mutation addCustomerItemSaftyCheckListResults($objects: [customer_order_item_safety_checklist_results_insert_input!]!) {
  insert_customer_order_item_safety_checklist_results(objects: $objects) {
    returning {
      customer_order_item_id
      id
      is_active
      key
      safety_checklist_id
      value
    }
  }
}
    `;
export const AddMissingCustomerOrderCustomerAssetDocument = gql`
    mutation addMissingCustomerOrderCustomerAsset($object: addMissingCustomerOrderCustomerAssetInput = {customer_order_id: ""}) {
  addMissingCustomerOrderCustomerAsset(object: $object) {
    error
    message
  }
}
    `;
export const AddTaskCancellationReasonDocument = gql`
    mutation addTaskCancellationReason($object: task_cancellation_reasons_insert_input!) {
  insert_task_cancellation_reasons_one(object: $object) {
    id
    is_active
    task_id
    reason
  }
}
    `;
export const CreateDeliveryInvoiceDocument = gql`
    mutation createDeliveryInvoice($object: createDeliveryInvoiceInput!) {
  createDeliveryInvoice(object: $object) {
    code
    data
    error
    message
  }
}
    `;
export const CreateInvoicedItemForAssetDocument = gql`
    mutation createInvoicedItemForAsset($object: CreateInvoicedItemForAssetInput!) {
  createInvoicedItemForAsset(object: $object) {
    code
    message
    error
  }
}
    `;
export const CreateTaskValueDocument = gql`
    mutation createTaskValue($object: createTaskValueInput!) {
  createTaskValue(object: $object) {
    data
    code
    error
    message
  }
}
    `;
export const DisableTaskValuesByAssetIdDocument = gql`
    mutation disableTaskValuesByAssetId($task_id: uuid!, $customer_asset_id: uuid!) {
  update_task_value(
    where: {task_id: {_eq: $task_id}, customer_asset_id: {_eq: $customer_asset_id}}
    _set: {is_active: false}
  ) {
    affected_rows
    returning {
      id
    }
  }
}
    `;
export const DriverCheckInDocument = gql`
    mutation driverCheckIn($object: driver_duty_log_insert_input!) {
  insert_driver_duty_log_one(object: $object) {
    driver_duty_photos {
      id
      is_active
      driver_duty_log_id
      category
      url
    }
    id
    is_active
    location
    loginTime
    name
    odometer
    category
    totallizer
    driver_vehicle_id
  }
}
    `;
export const GetLatestTaskValueDocument = gql`
    mutation getLatestTaskValue($task_id: uuid!, $asset_id: uuid!) {
  getLatestTaskValue(object: {task_id: $task_id, asset_id: $asset_id}) {
    message
    error
    data
  }
}
    `;
export const InsertTicketDocument = gql`
    mutation insertTicket($object: tickets_insert_input!) {
  insert_tickets_one(object: $object) {
    id
    customer_order_id
    state
    is_active
    created_by
  }
}
    `;
export const UpdateDriverVehicleStateByIdDocument = gql`
    mutation updateDriverVehicleStateById($id: uuid!, $state: login_type_enum, $status: partner_vehicle_state_enum) {
  update_driver_vehicle_by_pk(
    pk_columns: {id: $id}
    _set: {state: $state, status: $status}
  ) {
    status
    id
    driver_id
    state
    vehicle_id
  }
}
    `;
export const UpdateTaskStateDocument = gql`
    mutation updateTaskState($id: uuid!, $state: task_state_enum) {
  update_task_by_pk(pk_columns: {id: $id}, _set: {state: $state}) {
    id
  }
}
    `;
export const FetchFileUrlFromServerDocument = gql`
    query fetchFileUrlFromServer($file: FileInput!) {
  fetchFile(file: $file) {
    url
  }
}
    `;
export const UploadFileToBucketDocument = gql`
    mutation uploadFileToBucket($file: StorageInput!) {
  uploadFile(object: $file) {
    contentType
    signedUrl
    storeUrl
  }
}
    `;
export const GetCustomerAssetsByOrderIdDocument = gql`
    query getCustomerAssetsByOrderID($customer_order_id: uuid, $searchKey: String) {
  customer_order_customer_asset(
    where: {customer_order_id: {_eq: $customer_order_id}, is_active: {_eq: true}, customer_asset: {is_active: {_eq: true}}}
  ) {
    customer_asset {
      is_collect_odometer_reading
      tag_id
      capacity
      color
      id
      description
      name
      registration_number
      asset_type {
        name
      }
      make
      modal
      organization_user_id
    }
    quantity_dispensed
    is_active
    quantity_requested
  }
}
    `;
export const GetCustomerOrganizationConfigurationDocument = gql`
    query getCustomerOrganizationConfiguration($organization_id: uuid!) {
  organization_configuration(where: {organization_id: {_eq: $organization_id}}) {
    key
    value
  }
}
    `;
export const GetDispensingOrderByAssetIdDocument = gql`
    query getDispensingOrderByAssetID($assetId: uuid, $userId: uuid) {
  task(
    where: {state: {_in: [DISPENSING]}, _or: [{driver_id: {_eq: $userId}}, {driver_vehicle: {user: {id: {_eq: $userId}}}}], customer_order: {organization_user: {customer_assets: {id: {_eq: $assetId}}}}}
    order_by: {estimate_delivery_date: asc_nulls_last}
  ) {
    id
    customer_order {
      id
      organization_user {
        customer_assets(where: {id: {_eq: $assetId}}) {
          id
        }
      }
    }
  }
}
    `;
export const GetOdometerMissReasonsDocument = gql`
    query getOdometerMissReasons {
  reasons(
    where: {reason_type: {_eq: ODOMETER_MISS_REASON}, is_active: {_eq: true}}
    order_by: {rank_id: asc}
  ) {
    id
    reason
  }
}
    `;
export const GetSafetyChecklistDocument = gql`
    query getSafetyChecklist {
  safety_checklist(where: {safety_checklist_category: {name: {_eq: "DRIVER"}}}) {
    id
    slug
    name
    is_active
  }
}
    `;
export const GetShiftScheduleDocument = gql`
    query getShiftSchedule($dateTime: timestamptz) {
  shift_schedule(
    where: {is_active: {_eq: true}, status: {_nin: ["CANCELLED"]}, end_time: {_gte: $dateTime}, start_time: {_lte: $dateTime}}
    limit: 1
    offset: 0
  ) {
    driver_vehicle_id
    vehicle_id
    end_time
    id
    start_time
    vehicle {
      id
      registration_number
      description
      vehicle_configurations {
        id
        key
        value
        is_active
      }
    }
    driver_vehicle {
      user {
        id
        first_name
        middle_name
        last_name
        code
      }
      vehicle {
        id
        registration_number
        description
        vehicle_configurations {
          id
          key
          value
          is_active
        }
      }
      id
      status
      state
    }
  }
}
    `;
export const GetTasksDocument = gql`
    query getTasks($limit: Int, $offset: Int, $where: task_bool_exp) {
  task(
    where: $where
    limit: $limit
    offset: $offset
    order_by: {estimate_delivery_date: asc_nulls_last}
  ) {
    state
    category
    driver_vehicle_id
    driver_id
    vehicle_id
    customer_order {
      is_receipt_required
      order_code
      is_otp_required
      instruction
      organization_user {
        id
        organization_id
        user {
          id
          middle_name
          first_name
          last_name
        }
      }
      customer_order_items {
        actual_delivery_date
        actual_qty
        id
        estimate_delivery_date
        qty
        state
        product_variation_id
        discount_rate
        discount_type
        product_variation {
          id
          is_active
          product {
            id
            is_active
            name
          }
        }
        product_variation_partner_localities_slot_id
        customer_order_item_safety_checklist_results {
          id
        }
      }
      delivery_fee
      delivery_preference
      order_code
      id
      order_date
      name
      is_prepaid
      is_active
      product_variation_partner_localities_slot {
        start_time
        end_time
        day_date
      }
      customer_order_slot {
        start_time
        end_time
      }
      organization_user_id
    }
    is_done_locally
    is_enable_rfid_flow
    id
    organization_address {
      name
      instruction
      location
      area
      address_line1
      address_line2
      pincode
      city_id
      state {
        name
      }
      country {
        id
        name
        numeric_code_id
        official_state
      }
    }
    task_values {
      customer_asset_id
      id
      key
      quantity_dispensed
      value
      url
      session_id
    }
  }
}
    `;
export const GetUserDocument = gql`
    query getUser($firebaseID: String = "") {
  user(where: {google_firebase_id: {_eq: $firebaseID}}) {
    id
    first_name
    last_name
    email
    erp_code
    profile_pic
  }
}
    `;
export const SearchCustomerAssetByIdDocument = gql`
    query searchCustomerAssetById($customer_order_id: uuid, $asset_id: uuid) {
  customer_order_customer_asset(
    where: {customer_order_id: {_eq: $customer_order_id}, customer_asset_id: {_eq: $asset_id}, is_active: {_eq: true}, customer_asset: {is_active: {_eq: true}}}
  ) {
    customer_asset {
      is_collect_odometer_reading
      tag_id
      capacity
      color
      id
      description
      name
      registration_number
      asset_type {
        name
      }
      make
      modal
      organization_user_id
    }
    quantity_dispensed
    is_active
    quantity_requested
  }
}
    `;
export const SearchCustomerAssetsPaginatedDocument = gql`
    query searchCustomerAssetsPaginated($customer_order_id: uuid!, $searchKey: String!, $limit: Int = 10, $offset: Int = 0) {
  customer_order_customer_asset_aggregate(
    where: {customer_order_id: {_eq: $customer_order_id}, is_active: {_eq: true}, customer_asset: {is_active: {_eq: true}, _or: [{description: {_ilike: $searchKey}}, {registration_number: {_ilike: $searchKey}}]}}
  ) {
    aggregate {
      count
    }
  }
  customer_order_customer_asset(
    where: {customer_order_id: {_eq: $customer_order_id}, is_active: {_eq: true}, customer_asset: {is_active: {_eq: true}, _or: [{description: {_ilike: $searchKey}}, {registration_number: {_ilike: $searchKey}}]}}
    limit: $limit
    offset: $offset
    order_by: {customer_asset: {description: asc}}
  ) {
    customer_asset {
      is_collect_odometer_reading
      tag_id
      capacity
      color
      id
      description
      name
      registration_number
      asset_type {
        name
      }
      make
      modal
      organization_user_id
    }
    quantity_dispensed
    is_active
    quantity_requested
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    addCustomerItemSaftyCheckListResults(variables: AddCustomerItemSaftyCheckListResultsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddCustomerItemSaftyCheckListResultsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddCustomerItemSaftyCheckListResultsMutation>(AddCustomerItemSaftyCheckListResultsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addCustomerItemSaftyCheckListResults', 'mutation', variables);
    },
    addMissingCustomerOrderCustomerAsset(variables?: AddMissingCustomerOrderCustomerAssetMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddMissingCustomerOrderCustomerAssetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddMissingCustomerOrderCustomerAssetMutation>(AddMissingCustomerOrderCustomerAssetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addMissingCustomerOrderCustomerAsset', 'mutation', variables);
    },
    addTaskCancellationReason(variables: AddTaskCancellationReasonMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddTaskCancellationReasonMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddTaskCancellationReasonMutation>(AddTaskCancellationReasonDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addTaskCancellationReason', 'mutation', variables);
    },
    createDeliveryInvoice(variables: CreateDeliveryInvoiceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateDeliveryInvoiceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateDeliveryInvoiceMutation>(CreateDeliveryInvoiceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createDeliveryInvoice', 'mutation', variables);
    },
    createInvoicedItemForAsset(variables: CreateInvoicedItemForAssetMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateInvoicedItemForAssetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateInvoicedItemForAssetMutation>(CreateInvoicedItemForAssetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createInvoicedItemForAsset', 'mutation', variables);
    },
    createTaskValue(variables: CreateTaskValueMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateTaskValueMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateTaskValueMutation>(CreateTaskValueDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createTaskValue', 'mutation', variables);
    },
    disableTaskValuesByAssetId(variables: DisableTaskValuesByAssetIdMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DisableTaskValuesByAssetIdMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DisableTaskValuesByAssetIdMutation>(DisableTaskValuesByAssetIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'disableTaskValuesByAssetId', 'mutation', variables);
    },
    driverCheckIn(variables: DriverCheckInMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriverCheckInMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriverCheckInMutation>(DriverCheckInDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'driverCheckIn', 'mutation', variables);
    },
    getLatestTaskValue(variables: GetLatestTaskValueMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetLatestTaskValueMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetLatestTaskValueMutation>(GetLatestTaskValueDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getLatestTaskValue', 'mutation', variables);
    },
    insertTicket(variables: InsertTicketMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InsertTicketMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<InsertTicketMutation>(InsertTicketDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'insertTicket', 'mutation', variables);
    },
    updateDriverVehicleStateById(variables: UpdateDriverVehicleStateByIdMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateDriverVehicleStateByIdMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateDriverVehicleStateByIdMutation>(UpdateDriverVehicleStateByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateDriverVehicleStateById', 'mutation', variables);
    },
    updateTaskState(variables: UpdateTaskStateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateTaskStateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateTaskStateMutation>(UpdateTaskStateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateTaskState', 'mutation', variables);
    },
    fetchFileUrlFromServer(variables: FetchFileUrlFromServerQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FetchFileUrlFromServerQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchFileUrlFromServerQuery>(FetchFileUrlFromServerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchFileUrlFromServer', 'query', variables);
    },
    uploadFileToBucket(variables: UploadFileToBucketMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UploadFileToBucketMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UploadFileToBucketMutation>(UploadFileToBucketDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'uploadFileToBucket', 'mutation', variables);
    },
    getCustomerAssetsByOrderID(variables?: GetCustomerAssetsByOrderIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCustomerAssetsByOrderIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCustomerAssetsByOrderIdQuery>(GetCustomerAssetsByOrderIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCustomerAssetsByOrderID', 'query', variables);
    },
    getCustomerOrganizationConfiguration(variables: GetCustomerOrganizationConfigurationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCustomerOrganizationConfigurationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCustomerOrganizationConfigurationQuery>(GetCustomerOrganizationConfigurationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCustomerOrganizationConfiguration', 'query', variables);
    },
    getDispensingOrderByAssetID(variables?: GetDispensingOrderByAssetIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetDispensingOrderByAssetIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetDispensingOrderByAssetIdQuery>(GetDispensingOrderByAssetIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getDispensingOrderByAssetID', 'query', variables);
    },
    getOdometerMissReasons(variables?: GetOdometerMissReasonsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetOdometerMissReasonsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOdometerMissReasonsQuery>(GetOdometerMissReasonsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOdometerMissReasons', 'query', variables);
    },
    getSafetyChecklist(variables?: GetSafetyChecklistQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetSafetyChecklistQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSafetyChecklistQuery>(GetSafetyChecklistDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSafetyChecklist', 'query', variables);
    },
    getShiftSchedule(variables?: GetShiftScheduleQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetShiftScheduleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetShiftScheduleQuery>(GetShiftScheduleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getShiftSchedule', 'query', variables);
    },
    getTasks(variables?: GetTasksQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetTasksQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetTasksQuery>(GetTasksDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getTasks', 'query', variables);
    },
    getUser(variables?: GetUserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUserQuery>(GetUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getUser', 'query', variables);
    },
    searchCustomerAssetById(variables?: SearchCustomerAssetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SearchCustomerAssetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SearchCustomerAssetByIdQuery>(SearchCustomerAssetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'searchCustomerAssetById', 'query', variables);
    },
    searchCustomerAssetsPaginated(variables: SearchCustomerAssetsPaginatedQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SearchCustomerAssetsPaginatedQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SearchCustomerAssetsPaginatedQuery>(SearchCustomerAssetsPaginatedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'searchCustomerAssetsPaginated', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;